
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec720"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec720"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "HashRouter", () => $040dbb9c344a508d$export$7221d69dcfc8e36b);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2vsP7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $1d34d5c4a288b213$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $7939e29d663dd3ed$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $7939e29d663dd3ed$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, (0, $2vsP7.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("ZD2ym", function(module, exports) {

$parcel$export(module.exports, "ActiveFBOContainer", () => $4a13aeac4e44e8c4$export$efc5bc1c8a24c051);
$parcel$export(module.exports, "useActiveFBOs", () => $4a13aeac4e44e8c4$export$647f18d254967de3);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1bIpT = parcelRequire("1bIpT");
var $4yCYl = parcelRequire("4yCYl");

var $lNEp2 = parcelRequire("lNEp2");

var $7R9OT = parcelRequire("7R9OT");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $ay9Yf = parcelRequire("ay9Yf");
const $4a13aeac4e44e8c4$var$useActiveFBOContainerState = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const [fbos, setFbos] = $acw62.useState();
    const [isLoading, setIsLoading] = $acw62.useState(true);
    const [activeFBOId, setActiveFBOId] = (0, $1bIpT.default)(`airplx/${(0, $lNEp2.envName)()}/activeFBOId`, "");
    const previousFbos = (0, $4yCYl.default)(fbos);
    $acw62.useEffect(()=>{
        (async ()=>{
            if (!airplxIdentity.userid) {
                // No userid in JWT - this shouldn't happen with updated make_identity_token
                console.warn("No userid in airplxIdentity:", airplxIdentity);
                console.warn("This indicates make_identity_token needs to be updated to include userid");
                // Set empty FBOs and mark as loaded
                setFbos([]);
                setIsLoading(false);
                return;
            }
            const fbos = await postgrest.from("fbo").select().select("*,fbo_employees(_role)").eq("fbo_employees.user_id", airplxIdentity.userid).order("name", {
                ascending: true
            }).then((r)=>{
                return (r.body || []).map(({ fbo_employees: fbo_employees, ...row })=>({
                        ...row,
                        user_role: fbo_employees?.[0]?._role ?? "operator"
                    }));
            }).then((data)=>data);
            setFbos(fbos);
            if (!activeFBOId && fbos.length) setActiveFBOId(fbos[0].id);
            setIsLoading(false);
        })();
    }, [
        airplxIdentity
    ]);
    $acw62.useEffect(()=>{
        (async ()=>{
            if (!fbos || !previousFbos) return;
            for (const fbo of fbos){
                const previousFbo = previousFbos.find((prev)=>prev.id === fbo.id);
                if (previousFbo && JSON.stringify(previousFbo) !== JSON.stringify(fbo)) {
                    const { id: _id, user_role: _user_role, ...otherFboData } = fbo;
                    await postgrest.from("fbo").update({
                        ...otherFboData
                    }).eq("id", fbo.id);
                }
            }
        })();
    }, [
        fbos
    ]);
    const activeFBO = fbos?.find((fbo)=>Boolean(activeFBOId) ? fbo.id === activeFBOId : true);
    const setFBO = $acw62.useCallback((fbo)=>{
        setFbos(fbos.map((f)=>f.id === fbo.id ? fbo : f));
    }, [
        fbos
    ]);
    $acw62.useEffect(()=>{
        if (activeFBO) (0, $7R9OT.default).register({
            fbo: activeFBO.name
        });
    }, [
        activeFBO
    ]);
    return {
        ready: !isLoading,
        activeFBO: activeFBO,
        setActiveFBOId: setActiveFBOId,
        fbos: fbos ?? [],
        setFbos: setFbos,
        setFBO: setFBO
    };
};
const $4a13aeac4e44e8c4$var$ActiveFBOContainerState = (0, $ay9Yf.createContainer)($4a13aeac4e44e8c4$var$useActiveFBOContainerState);
const $4a13aeac4e44e8c4$export$efc5bc1c8a24c051 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4a13aeac4e44e8c4$var$ActiveFBOContainerState.Provider, {
        children: children
    });
};
const $4a13aeac4e44e8c4$export$647f18d254967de3 = $4a13aeac4e44e8c4$var$ActiveFBOContainerState.useContainer;

});
parcelRegister("1bIpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dd945c2ad445b2d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $iG64q = parcelRequire("iG64q");
var $0dd945c2ad445b2d$var$useLocalStorage = function(key, initialValue, options) {
    if (!(0, $iG64q.isBrowser)) return [
        initialValue,
        (0, $iG64q.noop),
        (0, $iG64q.noop)
    ];
    if (!key) throw new Error('useLocalStorage key may not be falsy');
    var deserializer = options ? options.raw ? function(value) {
        return value;
    } : options.deserializer : JSON.parse;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var initializer = (0, $acw62.useRef)(function(key) {
        try {
            var serializer = options ? options.raw ? String : options.serializer : JSON.stringify;
            var localStorageValue = localStorage.getItem(key);
            if (localStorageValue !== null) return deserializer(localStorageValue);
            else {
                initialValue && localStorage.setItem(key, serializer(initialValue));
                return initialValue;
            }
        } catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0, $acw62.useState)(function() {
        return initializer.current(key);
    }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useLayoutEffect)(function() {
        return setState(initializer.current(key));
    }, [
        key
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var set = (0, $acw62.useCallback)(function(valOrFunc) {
        try {
            var newState = typeof valOrFunc === 'function' ? valOrFunc(state) : valOrFunc;
            if (typeof newState === 'undefined') return;
            var value = void 0;
            if (options) {
                if (options.raw) {
                    if (typeof newState === 'string') value = newState;
                    else value = JSON.stringify(newState);
                } else if (options.serializer) value = options.serializer(newState);
                else value = JSON.stringify(newState);
            } else value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [
        key,
        setState
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var remove = (0, $acw62.useCallback)(function() {
        try {
            localStorage.removeItem(key);
            setState(undefined);
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw.
        }
    }, [
        key,
        setState
    ]);
    return [
        state,
        set,
        remove
    ];
};
var $0dd945c2ad445b2d$export$2e2bcd8739ae039 = $0dd945c2ad445b2d$var$useLocalStorage;

});
parcelRegister("iG64q", function(module, exports) {

$parcel$export(module.exports, "noop", () => $d990dbaa8d958b74$export$8793edee2d425525);
$parcel$export(module.exports, "on", () => $d990dbaa8d958b74$export$af631764ddc44097);
$parcel$export(module.exports, "off", () => $d990dbaa8d958b74$export$8c8705df4a2dcec9);
$parcel$export(module.exports, "isBrowser", () => $d990dbaa8d958b74$export$4e09c449d6c407f7);
var $d990dbaa8d958b74$export$8793edee2d425525 = function() {};
function $d990dbaa8d958b74$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $d990dbaa8d958b74$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $d990dbaa8d958b74$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $d990dbaa8d958b74$export$42e7ac6120dd324e = typeof navigator !== 'undefined';

});


parcelRegister("4yCYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3518917de5f4e958$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $3518917de5f4e958$export$2e2bcd8739ae039(state) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = state;
    });
    return ref.current;
}

});

parcelRegister("lNEp2", function(module, exports) {

$parcel$export(module.exports, "convertAircraftPreferencesToAlgorithmPreferences", () => $a2299f428347f042$export$e6e8a1c08fed8885);
$parcel$export(module.exports, "defaultPreferenceForAircraft", () => $a2299f428347f042$export$a779ab8d3c9daae6);
$parcel$export(module.exports, "uuidv4", () => $a2299f428347f042$export$abe4376e1bf796d6);
$parcel$export(module.exports, "consistentId", () => $a2299f428347f042$export$e4d8f5ca9f8d1d7d);
$parcel$export(module.exports, "calcStackUtilization", () => $a2299f428347f042$export$37f1461f1ffb4c4a);
$parcel$export(module.exports, "sortLayoutOptions", () => $a2299f428347f042$export$c6bc520d47c63fd1);
$parcel$export(module.exports, "getTokenMakerUrl", () => $a2299f428347f042$export$13fa5c928776c97b);
$parcel$export(module.exports, "getPostgrestUrl", () => $a2299f428347f042$export$1fc1f807505212b2);
$parcel$export(module.exports, "envName", () => $a2299f428347f042$export$e649b0450495b7de);
$parcel$export(module.exports, "formatNumber", () => $a2299f428347f042$export$f5dd818bff069720);
$parcel$export(module.exports, "formatCurrency", () => $a2299f428347f042$export$3dc27271f5d5c629);
$parcel$export(module.exports, "formatPercentage", () => $a2299f428347f042$export$3e1eee59f5dc52be);
$parcel$export(module.exports, "scrollSx", () => $a2299f428347f042$export$785c946831d4eaed);
$parcel$export(module.exports, "formatUnit", () => $a2299f428347f042$export$fab59da06805c4ec);
$parcel$export(module.exports, "parsePreciseNumber", () => $a2299f428347f042$export$dabe8b933ac6049);

var $lLxKB = parcelRequire("lLxKB");

var $5sKyw = parcelRequire("5sKyw");

var $keHtM = parcelRequire("keHtM");

var $cLNZr = parcelRequire("cLNZr");

var $d7VTV = parcelRequire("d7VTV");
const $a2299f428347f042$export$e6e8a1c08fed8885 = (preferences = [])=>{
    return preferences.map((pref)=>{
        if (pref === (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN) return (0, $keHtM.Preference).TAIL_IN;
        if (pref === (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN) return (0, $keHtM.Preference).NOSE_IN;
        return pref;
    });
};
const $a2299f428347f042$export$341e74035a9e0c7f = (md5Hash)=>{
    return (md5Hash.substring(0, 8) + "-" + md5Hash.substring(8, 12) + "-" + md5Hash.substring(12, 16) + "-" + md5Hash.substring(16, 20) + "-" + md5Hash.substring(20)).toLowerCase();
};
const $a2299f428347f042$export$a779ab8d3c9daae6 = (aircraft, fbo)=>{
    if (!aircraft) return [
        (0, $keHtM.Preference).TAIL_IN
    ];
    if (aircraft.tail_wheel === true) return [
        (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN
    ];
    if (aircraft.tail_bottom > fbo.sop_orientation_nose_in_threshold) return [
        (0, $keHtM.Preference).NOSE_IN
    ];
    if (aircraft.tail_top < fbo.sop_orientation_tail_in_threshold) return [
        (0, $keHtM.Preference).TAIL_IN
    ];
    return [];
};
const $a2299f428347f042$export$abe4376e1bf796d6 = ()=>(0, $5sKyw.default)();
const $a2299f428347f042$export$e4d8f5ca9f8d1d7d = (...args)=>{
    return $a2299f428347f042$export$341e74035a9e0c7f((0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(args.map((arg)=>arg.toString()).join("")));
};
const $a2299f428347f042$export$7098daa97eff84b5 = (hangar, limitToPlaced = false)=>{
    const total = (0, $cLNZr.sum)(hangar.stack.tenants.filter((t)=>limitToPlaced ? t.position.x != null : true).map(({ aircraft: aircraft })=>aircraft.wingspan * aircraft.length));
    const area = hangar.depth * hangar.width;
    return (0, $cLNZr.round)(100 * total / area, 0);
};
const $a2299f428347f042$export$37f1461f1ffb4c4a = (hangar, stack)=>{
    const total = (0, $cLNZr.sum)(stack.tenants.filter((t)=>t.position.x != null).map(({ aircraft: aircraft })=>aircraft.wingspan * aircraft.length));
    const area = hangar.depth * hangar.width;
    return (0, $cLNZr.round)(100 * total / area, 0);
};
const $a2299f428347f042$export$b88f83c32047fa92 = (aircrafts)=>{
    const total = (0, $cLNZr.sum)(aircrafts.filter((a)=>a.id).map((aircraft)=>aircraft.wingspan * aircraft.length));
    return total;
};
const $a2299f428347f042$export$1a8caff98adffd53 = (placements)=>{
    return (0, $cLNZr.sum)(placements.map(({ error: error })=>error));
};
const $a2299f428347f042$export$373a0213e74556b5 = (a, b)=>{
    if (!b.stackMembers) return -1;
    if (!a.stackMembers) return 1;
    const utilizationDiff = (0, $cLNZr.sum)(b.stackMembers.map(({ area: area })=>area)) - (0, $cLNZr.sum)(a.stackMembers.map(({ area: area })=>area));
    // if b utilization > autilization
    if (utilizationDiff > 0) return 1;
    if (utilizationDiff < 0) return -1;
    return Math.sign($a2299f428347f042$export$1a8caff98adffd53(a.stackMembers) - $a2299f428347f042$export$1a8caff98adffd53(b.stackMembers));
};
const $a2299f428347f042$export$72d1f6142b5c38f0 = (a, b)=>{
    if (!b.stackMembers) return 1;
    if (!a.stackMembers) return -1;
    const utilizationDiff = (0, $cLNZr.sum)(b.stackMembers.map(({ area: area })=>area)) - (0, $cLNZr.sum)(a.stackMembers.map(({ area: area })=>area));
    if (utilizationDiff !== 0) return utilizationDiff;
    const spacingDiff = Math.sign(b.paramSet.options.horizontal_spacing - a.paramSet.options.horizontal_spacing);
    if (spacingDiff !== 0) return spacingDiff;
    return $a2299f428347f042$export$1a8caff98adffd53(a.stackMembers) - $a2299f428347f042$export$1a8caff98adffd53(b.stackMembers);
};
const $a2299f428347f042$export$c6bc520d47c63fd1 = (_hangar, layoutOptions, _overlap)=>{
    if (!layoutOptions.length) return [];
    const layoutOptionsWithScore = layoutOptions.map((stack)=>({
            stack: stack,
            score: (0, $cLNZr.sum)(stack.stackMembers.filter((m)=>Boolean(m.x) && Boolean(m.area)).map(({ area: area })=>area))
        }));
    const layoutOptionsByScore = (0, $cLNZr.orderBy)(layoutOptionsWithScore, [
        "score"
    ], [
        "desc"
    ]);
    return layoutOptionsByScore;
};
const $a2299f428347f042$export$40edfb7eeb78c4e8 = ()=>{
    return window.location.origin.indexOf("localhost") > -1;
};
const $a2299f428347f042$export$23da1d24a38b0bde = ()=>{
    return window.location.origin.indexOf("staging.airplx.com") > -1;
};
const $a2299f428347f042$export$1cfdf9a01e3f7773 = ()=>{
    return window.location.origin.indexOf("app.airplx.com") > -1;
};
const $a2299f428347f042$var$ENVS = {
    production: {
        tokenmaker: "https://tm.airplx.com",
        postgrest: "https://dbrst.airplx.com"
    },
    staging: {
        tokenmaker: "https://ts.airplx.com",
        postgrest: "https://apis.airplx.com"
    },
    dev: {
        tokenmaker: "http://localhost:9009",
        postgrest: "http://localhost:3456"
    }
};
const $a2299f428347f042$export$13fa5c928776c97b = ()=>{
    if ($a2299f428347f042$export$40edfb7eeb78c4e8()) return $a2299f428347f042$var$ENVS.dev.tokenmaker;
    if ($a2299f428347f042$export$23da1d24a38b0bde()) return $a2299f428347f042$var$ENVS.staging.tokenmaker;
    return $a2299f428347f042$var$ENVS.production.tokenmaker;
};
const $a2299f428347f042$export$1fc1f807505212b2 = ()=>{
    if ($a2299f428347f042$export$40edfb7eeb78c4e8()) return $a2299f428347f042$var$ENVS.dev.postgrest;
    if ($a2299f428347f042$export$23da1d24a38b0bde()) return $a2299f428347f042$var$ENVS.staging.postgrest;
    return $a2299f428347f042$var$ENVS.production.postgrest;
};
const $a2299f428347f042$export$e649b0450495b7de = ()=>{
    if ($a2299f428347f042$export$40edfb7eeb78c4e8()) return "dev";
    if ($a2299f428347f042$export$23da1d24a38b0bde()) return "staging";
    if ($a2299f428347f042$export$1cfdf9a01e3f7773()) return "production";
    return "prod";
};
const $a2299f428347f042$export$f5dd818bff069720 = (value, decimalPlaces = 2, locale = null)=>{
    const userLocale = locale || navigator.languages?.[0] || navigator.language || "en-US";
    return new Intl.NumberFormat(userLocale, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }).format(value);
};
const $a2299f428347f042$export$3dc27271f5d5c629 = (value, decimalPlaces = 2, currency = "USD", locale = null)=>{
    const userLocale = locale || navigator.languages?.[0] || navigator.language || "en-US";
    return new Intl.NumberFormat(userLocale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }).format(value);
};
const $a2299f428347f042$export$3e1eee59f5dc52be = (value, decimalPlaces = 1, locale = null)=>{
    const userLocale = locale || navigator.languages?.[0] || navigator.language || "en-US";
    return new Intl.NumberFormat(userLocale, {
        style: "percent",
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }).format(value);
};
const $a2299f428347f042$export$785c946831d4eaed = {
    scrollbarGutter: "stable",
    "&::-webkit-scrollbar": {
        width: `10px !important`,
        height: `10px !important`
    },
    "&::-webkit-scrollbar-thumb": {
        background: "#00000080 !important"
    }
};
const $a2299f428347f042$export$fab59da06805c4ec = (value, squared, useMetric = false)=>{
    if (useMetric) {
        if (squared) return `${$a2299f428347f042$export$f5dd818bff069720((0, $d7VTV.squareFeetToSquareMeters)(value), 2)} m\xb2`;
        return $a2299f428347f042$export$f5dd818bff069720((0, $d7VTV.feetToMeters)(value), 2);
    }
    if (squared) return `${$a2299f428347f042$export$f5dd818bff069720(value, 0)} ft\xb2`;
    return $a2299f428347f042$export$f5dd818bff069720(value, 0);
};
const $a2299f428347f042$export$dabe8b933ac6049 = (value, maxDecimals = 3)=>{
    if (typeof value === "number") return Number(value.toFixed(maxDecimals));
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return 0;
    // Round to specified decimal places to avoid floating point precision issues
    return Number(numValue.toFixed(maxDecimals));
};

});
parcelRegister("lLxKB", function(module, exports) {




(function() {
    var crypt = (parcelRequire("12eZZ")), utf8 = (parcelRequire("a74v9")).utf8, isBuffer = (parcelRequire("7B5Ea")), bin = (parcelRequire("a74v9")).bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === 'binary') message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    module.exports = function(message, options) {
        if (message === undefined || message === null) throw new Error('Illegal argument ' + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();

});
parcelRegister("12eZZ", function(module, exports) {
(function() {
    var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join('');
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push('=');
            }
            return base64.join('');
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("a74v9", function(module, exports) {
var $75ce0cb6501c8271$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $75ce0cb6501c8271$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($75ce0cb6501c8271$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join('');
        }
    }
};
module.exports = $75ce0cb6501c8271$var$charenc;

});

parcelRegister("7B5Ea", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($58805e71bbbc0b37$var$isBuffer(obj) || $58805e71bbbc0b37$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $58805e71bbbc0b37$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $58805e71bbbc0b37$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && $58805e71bbbc0b37$var$isBuffer(obj.slice(0, 0));
}

});


parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.default)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0137947e8554ce$export$2e2bcd8739ae039);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).substr(1));
function $1d0137947e8554ce$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("keHtM", function(module, exports) {

$parcel$export(module.exports, "Preference", () => $cb0ac62ea843e2f3$export$797e66270d412019);
$parcel$export(module.exports, "TenantType", () => $cb0ac62ea843e2f3$export$92a757ac1398962f);
$parcel$export(module.exports, "MarkingType", () => $cb0ac62ea843e2f3$export$4d2290bf238dc21f);
$parcel$export(module.exports, "ObstacleType", () => $cb0ac62ea843e2f3$export$dcbc400a7ff5fac3);
$parcel$export(module.exports, "CornerStrategy", () => $cb0ac62ea843e2f3$export$6a57945abbc885c3);
$parcel$export(module.exports, "CornerStrategies", () => $cb0ac62ea843e2f3$export$5d7b48f437ada5f7);
var $cb0ac62ea843e2f3$export$797e66270d412019 = /*#__PURE__*/ function(Preference) {
    Preference["PREFER_FRONT_ROW"] = "PREFER_FRONT_ROW";
    Preference["PREFER_BACK_ROW"] = "PREFER_BACK_ROW";
    Preference["PREFER_LEFT"] = "PREFER_LEFT";
    Preference["PREFER_RIGHT"] = "PREFER_RIGHT";
    Preference["PREFER_FRONT"] = "PREFER_FRONT";
    Preference["PREFER_BACK"] = "PREFER_BACK";
    // split hangar into thirds
    Preference["PREFER_LEFT_THIRD"] = "PREFER_LEFT_THIRD";
    Preference["PREFER_MIDDLE_THIRD"] = "PREFER_MIDDLE_THIRD";
    Preference["PREFER_RIGHT_THIRD"] = "PREFER_RIGHT_THIRD";
    Preference["NOSE_IN"] = "NOSE_IN";
    Preference["TAIL_IN"] = "TAIL_IN";
    // tail wheel is reversed b/c the image is upside down
    Preference["TAIL_WHEEL_NOSE_IN"] = "TAIL_WHEEL_TAIL_IN";
    Preference["TAIL_WHEEL_TAIL_IN"] = "TAIL_WHEEL_NOSE_IN";
    Preference["OK_TO_LEAVE_OUT"] = "OK_TO_LEAVE_OUT";
    Preference["LOCKED"] = "LOCKED";
    return Preference;
}({});
var $cb0ac62ea843e2f3$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["BASE"] = "base";
    TenantType["TRANSIENT"] = "transient";
    return TenantType;
}({});
var $cb0ac62ea843e2f3$export$4d2290bf238dc21f = /*#__PURE__*/ function(MarkingType) {
    MarkingType["OUTLINE"] = "Outline";
    MarkingType["REFERENCE_DISTANCE"] = "Reference Distance";
    MarkingType["RED_SOLID"] = "Red Solid";
    MarkingType["GREY"] = "Grey";
    MarkingType["WHITE_SOLID"] = "White Solid";
    MarkingType["WHITE_DASHED"] = "White Dashed";
    MarkingType["YELLOW_SOLID"] = "Yellow Solid";
    MarkingType["YELLOW_DASHED"] = "Yellow Dashed";
    MarkingType["YELLOW_SOLID_CURVED"] = "Yellow Solid Curved";
    return MarkingType;
}({});
var $cb0ac62ea843e2f3$export$dcbc400a7ff5fac3 = /*#__PURE__*/ function(ObstacleType) {
    ObstacleType["OBSTRUCTION"] = "OBSTRUCTION";
    ObstacleType["NO_TOW_AREA"] = "NO_TOW_AREA";
    ObstacleType["UNOBSTRUCTIVE"] = "UNOBSTRUCTIVE";
    ObstacleType["CAUTION"] = "CAUTION";
    return ObstacleType;
}({});
var $cb0ac62ea843e2f3$export$6a57945abbc885c3 = /*#__PURE__*/ function(CornerStrategy) {
    CornerStrategy["ANGLE_SHALLOW"] = "S";
    CornerStrategy["ANGLE_45"] = "45";
    return CornerStrategy;
}({});
const $cb0ac62ea843e2f3$export$5d7b48f437ada5f7 = [
    [
        "45",
        "45"
    ],
    [
        "45",
        "S"
    ],
    [
        "S",
        "45"
    ],
    [
        "S",
        "S"
    ]
];

});

parcelRegister("cLNZr", function(module, exports) {

$parcel$export(module.exports, "round", () => $0f3c5702155b7cf0$export$2077e0241d6afd3c);
$parcel$export(module.exports, "sum", () => $0f3c5702155b7cf0$export$8a63f25cc62965f1);
$parcel$export(module.exports, "orderBy", () => $0f3c5702155b7cf0$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "uniqBy", () => $0f3c5702155b7cf0$export$da805ba9431c7107);
$parcel$export(module.exports, "uniq", () => $0f3c5702155b7cf0$export$f70730c3d1fc524e);
$parcel$export(module.exports, "range", () => $0f3c5702155b7cf0$export$d02631cccf789723);
$parcel$export(module.exports, "pick", () => $0f3c5702155b7cf0$export$357523c63a2253b9);
$parcel$export(module.exports, "mean", () => $0f3c5702155b7cf0$export$1ce691f85baaa52);
$parcel$export(module.exports, "defaultTo", () => $0f3c5702155b7cf0$export$cd893f1e9a9d7dd5);
$parcel$export(module.exports, "debounce", () => $0f3c5702155b7cf0$export$61fc7d43ac8f84b0);
/**
 * Native JavaScript replacements for lodash functions
 * These implementations provide the same functionality without the bundle size overhead
 */ /**
 * Rounds a number to the specified precision
 * @param value The number to round
 * @param precision The number of decimal places (default 0)
 */ function $0f3c5702155b7cf0$export$2077e0241d6afd3c(value, precision = 0) {
    const factor = Math.pow(10, precision);
    return Math.round(value * factor) / factor;
}
function $0f3c5702155b7cf0$export$8a63f25cc62965f1(array) {
    if (!array || array.length === 0) return 0;
    return array.reduce((acc, val)=>acc + val, 0);
}
function $0f3c5702155b7cf0$export$f18af21d6f4dafd8(collection, iteratees, orders = []) {
    if (!collection || collection.length === 0) return [];
    const sorted = [
        ...collection
    ];
    sorted.sort((a, b)=>{
        for(let i = 0; i < iteratees.length; i++){
            const iteratee = iteratees[i];
            const order = orders[i] || 'asc';
            let aVal;
            let bVal;
            if (typeof iteratee === 'function') {
                aVal = iteratee(a);
                bVal = iteratee(b);
            } else {
                aVal = a[iteratee];
                bVal = b[iteratee];
            }
            // Handle null/undefined
            if (aVal == null && bVal == null) continue;
            if (aVal == null) return order === 'asc' ? 1 : -1;
            if (bVal == null) return order === 'asc' ? -1 : 1;
            // Compare values
            if (aVal < bVal) return order === 'asc' ? -1 : 1;
            if (aVal > bVal) return order === 'asc' ? 1 : -1;
        }
        return 0;
    });
    return sorted;
}
function $0f3c5702155b7cf0$export$da805ba9431c7107(array, iteratee) {
    if (!array || array.length === 0) return [];
    const seen = new Set();
    const result = [];
    for (const item of array){
        const key = typeof iteratee === 'function' ? iteratee(item) : item[iteratee];
        if (!seen.has(key)) {
            seen.add(key);
            result.push(item);
        }
    }
    return result;
}
function $0f3c5702155b7cf0$export$f70730c3d1fc524e(array) {
    return [
        ...new Set(array)
    ];
}
function $0f3c5702155b7cf0$export$d02631cccf789723(start, end, step = 1) {
    if (end === undefined) {
        end = start;
        start = 0;
    }
    const length = Math.max(Math.ceil((end - start) / step), 0);
    const result = new Array(length);
    for(let i = 0; i < length; i++)result[i] = start + i * step;
    return result;
}
function $0f3c5702155b7cf0$export$4812e460280c6ef2(array) {
    if (!array || array.length === 0) return undefined;
    return array[Math.floor(Math.random() * array.length)];
}
function $0f3c5702155b7cf0$export$357523c63a2253b9(object, keys) {
    const result = {};
    for (const key of keys)if (key in object) result[key] = object[key];
    return result;
}
function $0f3c5702155b7cf0$export$1ce691f85baaa52(array) {
    if (!array || array.length === 0) return 0;
    return $0f3c5702155b7cf0$export$8a63f25cc62965f1(array) / array.length;
}
function $0f3c5702155b7cf0$export$cd893f1e9a9d7dd5(value, defaultValue) {
    return value == null ? defaultValue : value;
}
function $0f3c5702155b7cf0$export$61fc7d43ac8f84b0(func, wait = 0, options) {
    let timerId;
    let lastArgs;
    let lastThis;
    let lastCallTime;
    let lastInvokeTime = 0;
    const leading = options?.leading ?? false;
    const trailing = options?.trailing ?? true;
    const maxWait = options?.maxWait;
    function invokeFunc(time) {
        const args = lastArgs;
        const thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        return func.apply(thisArg, args);
    }
    function shouldInvoke(time) {
        const timeSinceLastCall = lastCallTime === undefined ? 0 : time - lastCallTime;
        const timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, or enough time has elapsed
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxWait !== undefined && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        const time = Date.now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart timer
        const timeSinceLastCall = lastCallTime === undefined ? 0 : time - lastCallTime;
        const timeSinceLastInvoke = time - lastInvokeTime;
        const timeWaiting = wait - timeSinceLastCall;
        const remainingWait = maxWait !== undefined ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        timerId = setTimeout(timerExpired, remainingWait);
    }
    function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : undefined;
    }
    function trailingEdge(time) {
        timerId = undefined;
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return undefined;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastThis = lastCallTime = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? undefined : trailingEdge(Date.now());
    }
    function debounced(...args) {
        const time = Date.now();
        const isInvoking = shouldInvoke(time);
        lastArgs = args;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxWait !== undefined) {
                // Handle invocations in a tight loop
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var // For backward compatibility with lodash import style
$0f3c5702155b7cf0$export$2e2bcd8739ae039 = {
    round: $0f3c5702155b7cf0$export$2077e0241d6afd3c,
    sum: $0f3c5702155b7cf0$export$8a63f25cc62965f1,
    orderBy: $0f3c5702155b7cf0$export$f18af21d6f4dafd8,
    uniqBy: $0f3c5702155b7cf0$export$da805ba9431c7107,
    uniq: $0f3c5702155b7cf0$export$f70730c3d1fc524e,
    range: $0f3c5702155b7cf0$export$d02631cccf789723,
    sample: $0f3c5702155b7cf0$export$4812e460280c6ef2,
    pick: $0f3c5702155b7cf0$export$357523c63a2253b9,
    mean: $0f3c5702155b7cf0$export$1ce691f85baaa52,
    defaultTo: $0f3c5702155b7cf0$export$cd893f1e9a9d7dd5,
    debounce: $0f3c5702155b7cf0$export$61fc7d43ac8f84b0
};

});

parcelRegister("d7VTV", function(module, exports) {

$parcel$export(module.exports, "metersToFeet", () => $96fee590aab2642b$export$d284c26147b5ca34);
$parcel$export(module.exports, "feetToMeters", () => $96fee590aab2642b$export$76afc266724c5901);
$parcel$export(module.exports, "squareFeetToSquareMeters", () => $96fee590aab2642b$export$200d1f40f84fab5c);
$parcel$export(module.exports, "getHypotenuse", () => $96fee590aab2642b$export$4373f688011b89a3);
$parcel$export(module.exports, "convertDegreesToRadians", () => $96fee590aab2642b$export$c29e4604bcc6f4d3);
$parcel$export(module.exports, "convertRadiansToDegress", () => $96fee590aab2642b$export$e6f1e0795aba3e4f);
$parcel$export(module.exports, "roundTo3sf", () => $96fee590aab2642b$export$da4605f54a8410b);
$parcel$export(module.exports, "getDifferenceBetweenAngles", () => $96fee590aab2642b$export$a9a390b934478987);
const $96fee590aab2642b$export$d284c26147b5ca34 = (meters)=>{
    return meters * 3.28084;
};
const $96fee590aab2642b$export$76afc266724c5901 = (feet)=>{
    return feet * 0.3048;
};
const $96fee590aab2642b$export$200d1f40f84fab5c = (squareFeet)=>{
    return squareFeet * 0.092903;
};
const $96fee590aab2642b$export$4373f688011b89a3 = function(length, width) {
    return Math.sqrt(Math.pow(length, 2) + Math.pow(width, 2));
};
const $96fee590aab2642b$export$c29e4604bcc6f4d3 = function(degrees) {
    return degrees * (Math.PI / 180);
};
const $96fee590aab2642b$export$e6f1e0795aba3e4f = function(radians) {
    return radians / (Math.PI / 180);
};
const $96fee590aab2642b$export$da4605f54a8410b = function(num) {
    return Math.round(num * 1000) / 1000;
};
const $96fee590aab2642b$export$a9a390b934478987 = function(degA, degB) {
    var temp = (degA + 360) % 360 - (degB + 360) % 360;
    if (temp < 0) temp = temp * -1;
    return temp;
};

});


parcelRegister("7R9OT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6f96c4a5e0fd184$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setupSessionTracking", () => (parcelRequire("gKzpB")).setupSessionTracking);
$parcel$export(module.exports, "endAllSessions", () => (parcelRequire("gKzpB")).endAllSessions);
/**
 * Synchronous wrapper for lazy-loaded Mixpanel
 * This maintains backward compatibility while using the lazy-loaded implementation
 */ 
var $gKzpB = parcelRequire("gKzpB");
// Create a synchronous proxy that queues calls until mixpanel is loaded
const $e6f96c4a5e0fd184$var$createSyncProxy = ()=>{
    let resolvedMixpanel = null;
    const pendingCalls = [];
    // Load mixpanel asynchronously
    (0, $gKzpB.mixpanelInstance).then((mp)=>{
        resolvedMixpanel = mp;
        // Execute all pending calls
        pendingCalls.forEach((call)=>call());
        pendingCalls.length = 0;
    });
    return new Proxy({}, {
        get (target, prop) {
            // If mixpanel is loaded, use it directly
            if (resolvedMixpanel) return resolvedMixpanel[prop];
            // Special handling for nested objects like 'people'
            if (prop === 'people') return new Proxy({}, {
                get (target, subProp) {
                    return (...args)=>{
                        if (resolvedMixpanel) return resolvedMixpanel.people[subProp](...args);
                        pendingCalls.push(()=>{
                            if (resolvedMixpanel && resolvedMixpanel.people && resolvedMixpanel.people[subProp]) resolvedMixpanel.people[subProp](...args);
                        });
                    };
                }
            });
            // Return a function that queues the call
            return (...args)=>{
                if (resolvedMixpanel) {
                    const method = resolvedMixpanel[prop];
                    if (typeof method === 'function') return method(...args);
                    return method;
                }
                // Queue the call for when mixpanel loads
                pendingCalls.push(()=>{
                    const method = resolvedMixpanel[prop];
                    if (typeof method === 'function') method(...args);
                });
            };
        }
    });
};
// Create the synchronous wrapper
const $e6f96c4a5e0fd184$var$mixpanel = $e6f96c4a5e0fd184$var$createSyncProxy();
var // Export the sync wrapper as default
$e6f96c4a5e0fd184$export$2e2bcd8739ae039 = $e6f96c4a5e0fd184$var$mixpanel;

});
parcelRegister("gKzpB", function(module, exports) {

$parcel$export(module.exports, "mixpanelInstance", () => $34d7554d4790f14f$export$2bbd0037bb55521);
$parcel$export(module.exports, "setupSessionTracking", () => $34d7554d4790f14f$export$34fccc54576f92c7);
$parcel$export(module.exports, "endAllSessions", () => $34d7554d4790f14f$export$a2f7d04251381c9a);
/**
 * Lazy-loaded Mixpanel implementation that defers 306KB library loading
 * until it's actually needed (production environment only)
 * This reduces initial bundle size by ~306KB for non-production builds
 */ const $34d7554d4790f14f$var$SESSION_TIMEOUT = 1800000; // 30 minutes in milliseconds
const $34d7554d4790f14f$var$sessionState = {
    sessionId: null,
    lastActivity: 0,
    fboId: null
};
// Lazy loader for Mixpanel
let $34d7554d4790f14f$var$mixpanelPromise = null;
let $34d7554d4790f14f$var$loadedMixpanel = null;

const $34d7554d4790f14f$var$loadMixpanel = async ()=>{
    if (!$34d7554d4790f14f$var$mixpanelPromise) $34d7554d4790f14f$var$mixpanelPromise = (parcelRequire("hngvo")).then((module)=>module.default);
    if (!$34d7554d4790f14f$var$loadedMixpanel) {
        const mixpanel = await $34d7554d4790f14f$var$mixpanelPromise;
        // Initialize Mixpanel for production
        mixpanel.init("62aa25aa93870b1f6f43b1e11def428b", {
            debug: false,
            record_sessions_percent: 100,
            record_mask_text_selector: "#noop"
        });
        $34d7554d4790f14f$var$loadedMixpanel = mixpanel;
    }
    return $34d7554d4790f14f$var$loadedMixpanel;
};
// Sanitize error messages to remove sensitive information
function $34d7554d4790f14f$var$sanitizeError(error) {
    if (!error) return "Unknown error";
    // Convert error to string
    const errorString = error instanceof Error ? error.message : String(error);
    // Remove potential sensitive patterns
    return errorString.replace(/session_id:\s*[\w-]+/gi, "session_id: [REDACTED]").replace(/"p_session_id":\s*"[^"]+"/gi, '"p_session_id": "[REDACTED]"').replace(/token:\s*[\w.-]+/gi, "token: [REDACTED]").replace(/Bearer\s+[\w.-]+/gi, "Bearer [REDACTED]").replace(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g, "[EMAIL]").replace(/\b\d{4}[\s-]?\d{4}[\s-]?\d{4}[\s-]?\d{4}\b/g, "[CARD]");
}
// Dummy implementation for development
const $34d7554d4790f14f$var$dummy = new Proxy({}, {
    get (target, propKey) {
        if (propKey.toString() === "people") return $34d7554d4790f14f$var$dummy;
        if (propKey.toString() === "identify") return (userId)=>{
            console.info(`Mixpanel Dev: identify => ${JSON.stringify(userId)}`);
        };
        if (propKey.toString() === "register") return (properties)=>{
            console.info(`Mixpanel Dev: register => ${JSON.stringify(properties)}`);
        };
        if (propKey.toString() === "reset") return ()=>{
            console.info(`Mixpanel Dev: reset`);
        };
        if (propKey.toString() === "alias") return (alias, original)=>{
            console.info(`Mixpanel Dev: alias => ${JSON.stringify({
                alias: alias,
                original: original
            })}`);
        };
        if (propKey.toString() === "get_distinct_id") return ()=>{
            const mockId = "dev-user-123";
            console.info(`Mixpanel Dev: get_distinct_id => ${mockId}`);
            return mockId;
        };
        if (propKey.toString() === "opt_out_tracking" || propKey.toString() === "opt_in_tracking") return ()=>{
            console.info(`Mixpanel Dev: ${propKey.toString()}`);
        };
        return (...args)=>{
            // Format the output to match the expected format (single arg without array brackets)
            const formattedArgs = args.length === 1 ? JSON.stringify(args[0]) : JSON.stringify(args);
            console.info(`Mixpanel Dev: called with ${propKey.toString()} => ${formattedArgs}`);
        };
    }
});
// Session tracking functions
async function $34d7554d4790f14f$var$recordSession(postgrest, fboId) {
    try {
        const { data: data, error: error } = await postgrest.rpc("record_session", {
            p_fbo_id: fboId
        });
        if (error) return null;
        return data?.[0] || null;
    } catch (error) {
        return null;
    }
}
async function $34d7554d4790f14f$var$checkAndRecordSession(postgrest, userId, fboId, mixpanelTracker) {
    const now = Date.now();
    // Check if we need to create a new session
    const needsNewSession = !$34d7554d4790f14f$var$sessionState.sessionId || $34d7554d4790f14f$var$sessionState.fboId !== fboId || now - $34d7554d4790f14f$var$sessionState.lastActivity > $34d7554d4790f14f$var$SESSION_TIMEOUT;
    if (needsNewSession) {
        const sessionId = await $34d7554d4790f14f$var$recordSession(postgrest, fboId);
        if (sessionId) {
            $34d7554d4790f14f$var$sessionState.sessionId = sessionId;
            $34d7554d4790f14f$var$sessionState.fboId = fboId;
            $34d7554d4790f14f$var$sessionState.lastActivity = now;
            // Track session start in Mixpanel
            mixpanelTracker.track("Session Started", {
                session_id: sessionId,
                user_id: userId,
                fbo_id: fboId
            });
        }
    } else // Update last activity time
    $34d7554d4790f14f$var$sessionState.lastActivity = now;
}
// Create mixpanel wrapper that lazy-loads only for production
const $34d7554d4790f14f$var$createMixpanelWrapper = ()=>{
    const isProduction = window.location.hostname === "app.airplx.com";
    if (!isProduction) // Return dummy immediately for non-production
    return Promise.resolve($34d7554d4790f14f$var$dummy);
    // For production, return a promise that resolves to the lazy-loaded instance
    return $34d7554d4790f14f$var$loadMixpanel().then((mixpanel)=>{
        return {
            ...mixpanel,
            _track: mixpanel.track,
            track: async (eventName, properties)=>{
                // Call original track function
                mixpanel.track(eventName, properties);
                // Get session data from the app context
                const sessionData = window.__airplxSessionData;
                if (sessionData && sessionData.userId && sessionData.fboId) // Fire and forget - don't block UI
                $34d7554d4790f14f$var$checkAndRecordSession(sessionData.postgrest, sessionData.userId, sessionData.fboId, mixpanel).catch((err)=>{});
            },
            identify: mixpanel.identify.bind(mixpanel),
            register: mixpanel.register.bind(mixpanel),
            reset: mixpanel.reset ? mixpanel.reset.bind(mixpanel) : ()=>{},
            alias: mixpanel.alias ? mixpanel.alias.bind(mixpanel) : ()=>{},
            get_distinct_id: mixpanel.get_distinct_id ? mixpanel.get_distinct_id.bind(mixpanel) : ()=>"unknown",
            opt_out_tracking: mixpanel.opt_out_tracking ? mixpanel.opt_out_tracking.bind(mixpanel) : ()=>{},
            opt_in_tracking: mixpanel.opt_in_tracking ? mixpanel.opt_in_tracking.bind(mixpanel) : ()=>{},
            people: mixpanel.people,
            getSessionState: ()=>({
                    ...$34d7554d4790f14f$var$sessionState
                })
        };
    });
};
// Create the promise-based mixpanel instance
const $34d7554d4790f14f$export$2bbd0037bb55521 = $34d7554d4790f14f$var$createMixpanelWrapper();
async function $34d7554d4790f14f$export$34fccc54576f92c7(postgrest, userId, fboId) {
    window.__airplxSessionData = {
        postgrest: postgrest,
        userId: userId,
        fboId: fboId
    };
    // Start session heartbeat to keep sessions active
    $34d7554d4790f14f$var$startSessionHeartbeat();
}
function $34d7554d4790f14f$export$beb665830535e8a2() {
    $34d7554d4790f14f$var$stopSessionHeartbeat();
    // Clear global session data
    if (typeof window !== "undefined") window.__airplxSessionData = null;
}
async function $34d7554d4790f14f$export$7bc0b2215dc226de(postgrest, userId, fboId) {
    const mixpanel = await $34d7554d4790f14f$export$2bbd0037bb55521;
    await $34d7554d4790f14f$var$checkAndRecordSession(postgrest, userId, fboId, mixpanel);
}
async function $34d7554d4790f14f$export$a2f7d04251381c9a(postgrest) {
    try {
        await postgrest.rpc("end_session", {});
        // Clear session state
        $34d7554d4790f14f$var$sessionState.sessionId = null;
        $34d7554d4790f14f$var$sessionState.lastActivity = 0;
        $34d7554d4790f14f$var$sessionState.fboId = null;
        // Stop session heartbeat
        $34d7554d4790f14f$var$stopSessionHeartbeat();
        // Clear global session data
        if (typeof window !== "undefined") window.__airplxSessionData = null;
    } catch (error) {}
}
// Session heartbeat management
let $34d7554d4790f14f$var$heartbeatInterval = null;
function $34d7554d4790f14f$var$startSessionHeartbeat() {
    if ($34d7554d4790f14f$var$heartbeatInterval) clearInterval($34d7554d4790f14f$var$heartbeatInterval);
    $34d7554d4790f14f$var$heartbeatInterval = setInterval(async ()=>{
        const sessionData = window.__airplxSessionData;
        if (sessionData && sessionData.userId && sessionData.fboId && $34d7554d4790f14f$var$sessionState.sessionId) {
            const now = Date.now();
            const timeSinceLastActivity = now - $34d7554d4790f14f$var$sessionState.lastActivity;
            // Only send heartbeat if there's been recent activity (within 10 minutes)
            if (timeSinceLastActivity < 600000) {
                const mixpanel = await $34d7554d4790f14f$export$2bbd0037bb55521;
                await $34d7554d4790f14f$var$checkAndRecordSession(sessionData.postgrest, sessionData.userId, sessionData.fboId, mixpanel);
            }
        }
    }, 300000); // Check every 5 minutes
}
function $34d7554d4790f14f$var$stopSessionHeartbeat() {
    if ($34d7554d4790f14f$var$heartbeatInterval) {
        clearInterval($34d7554d4790f14f$var$heartbeatInterval);
        $34d7554d4790f14f$var$heartbeatInterval = null;
    }
}
// Browser event listeners
if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", async ()=>{
        const sessionData = window.__airplxSessionData;
        if (sessionData && sessionData.postgrest && $34d7554d4790f14f$var$sessionState.sessionId) try {
            $34d7554d4790f14f$var$stopSessionHeartbeat();
            await sessionData.postgrest.rpc("end_session", {
                p_session_id: $34d7554d4790f14f$var$sessionState.sessionId
            });
        } catch (error) {}
    });
    document.addEventListener("visibilitychange", async ()=>{
        if (document.visibilityState === "visible") {
            const sessionData = window.__airplxSessionData;
            if (sessionData && sessionData.userId && sessionData.fboId) {
                $34d7554d4790f14f$var$startSessionHeartbeat();
                const mixpanel = await $34d7554d4790f14f$export$2bbd0037bb55521;
                await $34d7554d4790f14f$var$checkAndRecordSession(sessionData.postgrest, sessionData.userId, sessionData.fboId, mixpanel);
            }
        } else $34d7554d4790f14f$var$stopSessionHeartbeat();
    });
}
var // Default export for backwards compatibility
$34d7554d4790f14f$export$2e2bcd8739ae039 = $34d7554d4790f14f$export$2bbd0037bb55521;

});
parcelRegister("hngvo", function(module, exports) {
module.exports = import("4yT10").then(()=>parcelRequire('9AHSP'));

});



parcelRegister("2LXej", function(module, exports) {

$parcel$export(module.exports, "ApiContainer", () => $66f2fe8092790e8d$export$a238225dd6c01602);
$parcel$export(module.exports, "useApi", () => $66f2fe8092790e8d$export$eb2799109db70ffd);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("hLOAf");
var $bjuzH = parcelRequire("bjuzH");

var $acw62 = parcelRequire("acw62");

var $1bIpT = parcelRequire("1bIpT");

var $gmmcf = parcelRequire("gmmcf");

var $lNEp2 = parcelRequire("lNEp2");

var $gqehT = parcelRequire("gqehT");

var $ay9Yf = parcelRequire("ay9Yf");
/**
 */ const $66f2fe8092790e8d$var$useApiContainerState = ()=>{
    const { airplxToken: airplxToken } = (0, $gqehT.useIdentity)();
    const [token] = (0, $1bIpT.default)((0, $gqehT.AIRPLX_TOKEN), "", {
        raw: true
    });
    const queue = (0, $gmmcf.useFunctionQueue)();
    const postgrest = $acw62.useMemo(()=>{
        const tokenToUse = token || airplxToken;
        const cli = new (0, $bjuzH.default)((0, $lNEp2.getPostgrestUrl)());
        cli.auth(tokenToUse);
        return cli;
    }, [
        token,
        airplxToken
    ]);
    // TODO
    return {
        postgrest: postgrest,
        queue: queue,
        helpers: {
            deleteTenant: async (tenantId)=>{
                return postgrest.from("tenant").delete().eq("id", tenantId);
            }
        }
    };
};
const $66f2fe8092790e8d$var$ApiContainerState = (0, $ay9Yf.createContainer)($66f2fe8092790e8d$var$useApiContainerState);
const $66f2fe8092790e8d$export$a238225dd6c01602 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($66f2fe8092790e8d$var$ApiContainerState.Provider, {
        children: children
    });
};
const $66f2fe8092790e8d$export$eb2799109db70ffd = $66f2fe8092790e8d$var$ApiContainerState.useContainer;

});
parcelRegister("hLOAf", function(module, exports) {

$parcel$export(module.exports, "PostgrestClient", () => (parcelRequire("bjuzH")).default);

var $bjuzH = parcelRequire("bjuzH");

var $9Keqh = parcelRequire("9Keqh");

var $gyrjK = parcelRequire("gyrjK");

var $52nwS = parcelRequire("52nwS");

});
parcelRegister("bjuzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c92f94715fb663$export$2e2bcd8739ae039);

var $gyrjK = parcelRequire("gyrjK");

var $cyvtK = parcelRequire("cyvtK");

var $4ixvA = parcelRequire("4ixvA");
class $83c92f94715fb663$export$2e2bcd8739ae039 {
    /**
     * Creates a PostgREST client.
     *
     * @param url  URL of the PostgREST endpoint.
     * @param headers  Custom headers.
     * @param schema  Postgres schema to switch to.
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch, throwOnError: throwOnError } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $4ixvA.DEFAULT_HEADERS)), headers);
        this.schema = schema;
        this.fetch = fetch;
        this.shouldThrowOnError = throwOnError;
    }
    /**
     * Authenticates the request with JWT.
     *
     * @param token  The JWT token to use.
     */ auth(token) {
        this.headers['Authorization'] = `Bearer ${token}`;
        return this;
    }
    /**
     * Perform a table operation.
     *
     * @param table  The table name to operate on.
     */ from(table) {
        const url = `${this.url}/${table}`;
        return new (0, $gyrjK.default)(url, {
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            shouldThrowOnError: this.shouldThrowOnError
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn  The function name to call.
     * @param params  The parameters to pass to the function call.
     * @param head  When set to true, no data will be returned.
     * @param count  Count algorithm to use to count rows in a table.
     */ rpc(fn, params, { head: head = false, count: count = null } = {}) {
        const url = `${this.url}/rpc/${fn}`;
        return new (0, $cyvtK.default)(url, {
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            shouldThrowOnError: this.shouldThrowOnError
        }).rpc(params, {
            head: head,
            count: count
        });
    }
}

});
parcelRegister("gyrjK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d502ff80704788$export$2e2bcd8739ae039);

var $52nwS = parcelRequire("52nwS");

var $9Keqh = parcelRequire("9Keqh");
class $c0d502ff80704788$export$2e2bcd8739ae039 extends (0, $52nwS.PostgrestBuilder) {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch, shouldThrowOnError: shouldThrowOnError } = {}){
        super({
            fetch: fetch,
            shouldThrowOnError: shouldThrowOnError
        });
        this.url = new URL(url);
        this.headers = Object.assign({}, headers);
        this.schema = schema;
    }
    /**
     * Performs vertical filtering with SELECT.
     *
     * @param columns  The columns to retrieve, separated by commas.
     * @param head  When set to true, select will void data.
     * @param count  Count algorithm to use to count rows in a table.
     */ select(columns = '*', { head: head = false, count: count = null } = {}) {
        this.method = 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = columns.split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        if (head) this.method = 'HEAD';
        return new (0, $9Keqh.default)(this);
    }
    insert(values, { upsert: upsert = false, onConflict: onConflict, returning: returning = 'representation', count: count = null } = {}) {
        this.method = 'POST';
        const prefersHeaders = [
            `return=${returning}`
        ];
        if (upsert) prefersHeaders.push('resolution=merge-duplicates');
        if (upsert && onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        this.body = values;
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new (0, $9Keqh.default)(this);
    }
    /**
     * Performs an UPSERT into the table.
     *
     * @param values  The values to insert.
     * @param onConflict  By specifying the `on_conflict` query parameter, you can make UPSERT work on a column(s) that has a UNIQUE constraint.
     * @param returning  By default the new record is returned. Set this to 'minimal' if you don't need this value.
     * @param count  Count algorithm to use to count rows in a table.
     * @param ignoreDuplicates  Specifies if duplicate rows should be ignored and not inserted.
     */ upsert(values, { onConflict: onConflict, returning: returning = 'representation', count: count = null, ignoreDuplicates: ignoreDuplicates = false } = {}) {
        this.method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`,
            `return=${returning}`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        this.body = values;
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new (0, $9Keqh.default)(this);
    }
    /**
     * Performs an UPDATE on the table.
     *
     * @param values  The values to update.
     * @param returning  By default the updated record is returned. Set this to 'minimal' if you don't need this value.
     * @param count  Count algorithm to use to count rows in a table.
     */ update(values, { returning: returning = 'representation', count: count = null } = {}) {
        this.method = 'PATCH';
        const prefersHeaders = [
            `return=${returning}`
        ];
        this.body = values;
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new (0, $9Keqh.default)(this);
    }
    /**
     * Performs a DELETE on the table.
     *
     * @param returning  If `true`, return the deleted row(s) in the response.
     * @param count  Count algorithm to use to count rows in a table.
     */ delete({ returning: returning = 'representation', count: count = null } = {}) {
        this.method = 'DELETE';
        const prefersHeaders = [
            `return=${returning}`
        ];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new (0, $9Keqh.default)(this);
    }
}

});
parcelRegister("52nwS", function(module, exports) {

$parcel$export(module.exports, "PostgrestBuilder", () => $3aaf6419364c17d6$export$3106e21688a06353);
var $3aaf6419364c17d6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

class $3aaf6419364c17d6$export$3106e21688a06353 {
    constructor(builder){
        Object.assign(this, builder);
        let _fetch;
        if (builder.fetch) _fetch = builder.fetch;
        else if (typeof fetch === 'undefined') _fetch = (...args)=>$3aaf6419364c17d6$var$__awaiter(this, void 0, void 0, function*() {
                return yield (yield (parcelRequire("hOnb9"))).fetch(...args);
            });
        else _fetch = fetch;
        this.fetch = (...args)=>_fetch(...args);
        this.shouldThrowOnError = builder.shouldThrowOnError || false;
        this.allowEmpty = builder.allowEmpty || false;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError(throwOnError) {
        if (throwOnError === null || throwOnError === undefined) throwOnError = true;
        this.shouldThrowOnError = throwOnError;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (typeof this.schema === 'undefined') ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        let res = this.fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then((res)=>$3aaf6419364c17d6$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c, _d;
                let error = null;
                let data = null;
                let count = null;
                let status = res.status;
                let statusText = res.statusText;
                if (res.ok) {
                    const isReturnMinimal = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.split(',').includes('return=minimal');
                    if (this.method !== 'HEAD' && !isReturnMinimal) {
                        const text = yield res.text();
                        if (!text) ;
                        else if (this.headers['Accept'] === 'text/csv') data = text;
                        else data = JSON.parse(text);
                    }
                    const countHeader = (_b = this.headers['Prefer']) === null || _b === void 0 ? void 0 : _b.match(/count=(exact|planned|estimated)/);
                    const contentRange = (_c = res.headers.get('content-range')) === null || _c === void 0 ? void 0 : _c.split('/');
                    if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                } else {
                    const body = yield res.text();
                    try {
                        error = JSON.parse(body);
                    } catch (_e) {
                        error = {
                            message: body
                        };
                    }
                    if (error && this.allowEmpty && ((_d = error === null || error === void 0 ? void 0 : error.details) === null || _d === void 0 ? void 0 : _d.includes('Results contain 0 rows'))) {
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                    if (error && this.shouldThrowOnError) throw error;
                }
                const postgrestResponse = {
                    error: error,
                    data: data,
                    count: count,
                    status: status,
                    statusText: statusText,
                    body: data
                };
                return postgrestResponse;
            }));
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>({
                error: {
                    message: `FetchError: ${fetchError.message}`,
                    details: '',
                    hint: '',
                    code: fetchError.code || ''
                },
                data: null,
                body: null,
                count: null,
                status: 400,
                statusText: 'Bad Request'
            }));
        return res.then(onfulfilled, onrejected);
    }
}

});
parcelRegister("hOnb9", function(module, exports) {
module.exports = import("gWSs8").then(()=>parcelRequire('R5nvG'));

});


parcelRegister("9Keqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7183990437551054$export$2e2bcd8739ae039);

var $dRFh6 = parcelRequire("dRFh6");
class $7183990437551054$export$2e2bcd8739ae039 extends (0, $dRFh6.default) {
    constructor(){
        super(...arguments);
        /** @deprecated Use `contains()` instead. */ this.cs = this.contains;
        /** @deprecated Use `containedBy()` instead. */ this.cd = this.containedBy;
        /** @deprecated Use `rangeLt()` instead. */ this.sl = this.rangeLt;
        /** @deprecated Use `rangeGt()` instead. */ this.sr = this.rangeGt;
        /** @deprecated Use `rangeGte()` instead. */ this.nxl = this.rangeGte;
        /** @deprecated Use `rangeLte()` instead. */ this.nxr = this.rangeLte;
        /** @deprecated Use `rangeAdjacent()` instead. */ this.adj = this.rangeAdjacent;
        /** @deprecated Use `overlaps()` instead. */ this.ov = this.overlaps;
    }
    /**
     * Finds all rows which doesn't satisfy the filter.
     *
     * @param column  The column to filter on.
     * @param operator  The operator to filter with.
     * @param value  The value to filter with.
     */ not(column, operator, value) {
        this.url.searchParams.append(`${column}`, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Finds all rows satisfying at least one of the filters.
     *
     * @param filters  The filters to use, separated by commas.
     * @param foreignTable  The foreign table to use (if `column` is a foreign column).
     */ or(filters, { foreignTable: foreignTable } = {}) {
        const key = typeof foreignTable === 'undefined' ? 'or' : `${foreignTable}.or`;
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Finds all rows whose value on the stated `column` exactly matches the
     * specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ eq(column, value) {
        this.url.searchParams.append(`${column}`, `eq.${value}`);
        return this;
    }
    /**
     * Finds all rows whose value on the stated `column` doesn't match the
     * specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ neq(column, value) {
        this.url.searchParams.append(`${column}`, `neq.${value}`);
        return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is greater than the
     * specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ gt(column, value) {
        this.url.searchParams.append(`${column}`, `gt.${value}`);
        return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is greater than or
     * equal to the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ gte(column, value) {
        this.url.searchParams.append(`${column}`, `gte.${value}`);
        return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is less than the
     * specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ lt(column, value) {
        this.url.searchParams.append(`${column}`, `lt.${value}`);
        return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is less than or equal
     * to the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ lte(column, value) {
        this.url.searchParams.append(`${column}`, `lte.${value}`);
        return this;
    }
    /**
     * Finds all rows whose value in the stated `column` matches the supplied
     * `pattern` (case sensitive).
     *
     * @param column  The column to filter on.
     * @param pattern  The pattern to filter with.
     */ like(column, pattern) {
        this.url.searchParams.append(`${column}`, `like.${pattern}`);
        return this;
    }
    /**
     * Finds all rows whose value in the stated `column` matches the supplied
     * `pattern` (case insensitive).
     *
     * @param column  The column to filter on.
     * @param pattern  The pattern to filter with.
     */ ilike(column, pattern) {
        this.url.searchParams.append(`${column}`, `ilike.${pattern}`);
        return this;
    }
    /**
     * A check for exact equality (null, true, false), finds all rows whose
     * value on the stated `column` exactly match the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ is(column, value) {
        this.url.searchParams.append(`${column}`, `is.${value}`);
        return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is found on the
     * specified `values`.
     *
     * @param column  The column to filter on.
     * @param values  The values to filter with.
     */ in(column, values) {
        const cleanedValues = values.map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(`${column}`, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Finds all rows whose json, array, or range value on the stated `column`
     * contains the values specified in `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(`${column}`, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(`${column}`, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(`${column}`, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Finds all rows whose json, array, or range value on the stated `column` is
     * contained by the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(`${column}`, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(`${column}`, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(`${column}`, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` is strictly to the
     * left of the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */ rangeLt(column, range) {
        this.url.searchParams.append(`${column}`, `sl.${range}`);
        return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` is strictly to
     * the right of the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */ rangeGt(column, range) {
        this.url.searchParams.append(`${column}`, `sr.${range}`);
        return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` does not extend
     * to the left of the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */ rangeGte(column, range) {
        this.url.searchParams.append(`${column}`, `nxl.${range}`);
        return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` does not extend
     * to the right of the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */ rangeLte(column, range) {
        this.url.searchParams.append(`${column}`, `nxr.${range}`);
        return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` is adjacent to
     * the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(`${column}`, `adj.${range}`);
        return this;
    }
    /**
     * Finds all rows whose array or range value on the stated `column` overlaps
     * (has a value in common) with the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(`${column}`, `ov.${value}`);
        else // array
        this.url.searchParams.append(`${column}`, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Finds all rows whose text or tsvector value on the stated `column` matches
     * the tsquery in `query`.
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     * @param type  The type of tsquery conversion to use on `query`.
     */ textSearch(column, query, { config: config, type: type = null } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(`${column}`, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Finds all rows whose tsvector value on the stated `column` matches
     * to_tsquery(`query`).
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     *
     * @deprecated Use `textSearch()` instead.
     */ fts(column, query, { config: config } = {}) {
        const configPart = typeof config === 'undefined' ? '' : `(${config})`;
        this.url.searchParams.append(`${column}`, `fts${configPart}.${query}`);
        return this;
    }
    /**
     * Finds all rows whose tsvector value on the stated `column` matches
     * plainto_tsquery(`query`).
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     *
     * @deprecated Use `textSearch()` with `type: 'plain'` instead.
     */ plfts(column, query, { config: config } = {}) {
        const configPart = typeof config === 'undefined' ? '' : `(${config})`;
        this.url.searchParams.append(`${column}`, `plfts${configPart}.${query}`);
        return this;
    }
    /**
     * Finds all rows whose tsvector value on the stated `column` matches
     * phraseto_tsquery(`query`).
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     *
     * @deprecated Use `textSearch()` with `type: 'phrase'` instead.
     */ phfts(column, query, { config: config } = {}) {
        const configPart = typeof config === 'undefined' ? '' : `(${config})`;
        this.url.searchParams.append(`${column}`, `phfts${configPart}.${query}`);
        return this;
    }
    /**
     * Finds all rows whose tsvector value on the stated `column` matches
     * websearch_to_tsquery(`query`).
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     *
     * @deprecated Use `textSearch()` with `type: 'websearch'` instead.
     */ wfts(column, query, { config: config } = {}) {
        const configPart = typeof config === 'undefined' ? '' : `(${config})`;
        this.url.searchParams.append(`${column}`, `wfts${configPart}.${query}`);
        return this;
    }
    /**
     * Finds all rows whose `column` satisfies the filter.
     *
     * @param column  The column to filter on.
     * @param operator  The operator to filter with.
     * @param value  The value to filter with.
     */ filter(column, operator, value) {
        this.url.searchParams.append(`${column}`, `${operator}.${value}`);
        return this;
    }
    /**
     * Finds all rows whose columns match the specified `query` object.
     *
     * @param query  The object to filter with, with column names as keys mapped
     *               to their filter values.
     */ match(query) {
        Object.keys(query).forEach((key)=>{
            this.url.searchParams.append(`${key}`, `eq.${query[key]}`);
        });
        return this;
    }
}

});
parcelRegister("dRFh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1803de8df26892f$export$2e2bcd8739ae039);

var $52nwS = parcelRequire("52nwS");
class $a1803de8df26892f$export$2e2bcd8739ae039 extends (0, $52nwS.PostgrestBuilder) {
    /**
     * Performs vertical filtering with SELECT.
     *
     * @param columns  The columns to retrieve, separated by commas.
     */ select(columns = '*') {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = columns.split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        return this;
    }
    /**
     * Orders the result with the specified `column`.
     *
     * @param column  The column to order on.
     * @param ascending  If `true`, the result will be in ascending order.
     * @param nullsFirst  If `true`, `null`s appear first.
     * @param foreignTable  The foreign table to use (if `column` is a foreign column).
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst = false, foreignTable: foreignTable } = {}) {
        const key = typeof foreignTable === 'undefined' ? 'order' : `${foreignTable}.order`;
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}.${nullsFirst ? 'nullsfirst' : 'nullslast'}`);
        return this;
    }
    /**
     * Limits the result with the specified `count`.
     *
     * @param count  The maximum no. of rows to limit to.
     * @param foreignTable  The foreign table to use (for foreign columns).
     */ limit(count, { foreignTable: foreignTable } = {}) {
        const key = typeof foreignTable === 'undefined' ? 'limit' : `${foreignTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limits the result to rows within the specified range, inclusive.
     *
     * @param from  The starting index from which to limit the result, inclusive.
     * @param to  The last index to which to limit the result, inclusive.
     * @param foreignTable  The foreign table to use (for foreign columns).
     */ range(from, to, { foreignTable: foreignTable } = {}) {
        const keyOffset = typeof foreignTable === 'undefined' ? 'offset' : `${foreignTable}.offset`;
        const keyLimit = typeof foreignTable === 'undefined' ? 'limit' : `${foreignTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Sets the AbortSignal for the fetch request.
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Retrieves only one row from the result. Result must be one row (e.g. using
     * `limit`), otherwise this will result in an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Retrieves at most one row from the result. Result must be at most one row
     * (e.g. using `eq` on a UNIQUE column), otherwise this will result in an
     * error.
     */ maybeSingle() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.allowEmpty = true;
        return this;
    }
    /**
     * Set the response type to CSV.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
}

});



parcelRegister("cyvtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $025be36b8ad4e2ba$export$2e2bcd8739ae039);

var $52nwS = parcelRequire("52nwS");

var $9Keqh = parcelRequire("9Keqh");
class $025be36b8ad4e2ba$export$2e2bcd8739ae039 extends (0, $52nwS.PostgrestBuilder) {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch, shouldThrowOnError: shouldThrowOnError } = {}){
        super({
            fetch: fetch,
            shouldThrowOnError: shouldThrowOnError
        });
        this.url = new URL(url);
        this.headers = Object.assign({}, headers);
        this.schema = schema;
    }
    /**
     * Perform a function call.
     */ rpc(params, { head: head = false, count: count = null } = {}) {
        if (head) {
            this.method = 'HEAD';
            if (params) Object.entries(params).forEach(([name, value])=>{
                this.url.searchParams.append(name, value);
            });
        } else {
            this.method = 'POST';
            this.body = params;
        }
        if (count) {
            if (this.headers['Prefer'] !== undefined) this.headers['Prefer'] += `,count=${count}`;
            else this.headers['Prefer'] = `count=${count}`;
        }
        return new (0, $9Keqh.default)(this);
    }
}

});

parcelRegister("4ixvA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_HEADERS", () => $3212d5f3017e8dc3$export$88a84136db6a4b64);

var $fEBmJ = parcelRequire("fEBmJ");
const $3212d5f3017e8dc3$export$88a84136db6a4b64 = {
    'X-Client-Info': `postgrest-js/${(0, $fEBmJ.version)}`
};

});
parcelRegister("fEBmJ", function(module, exports) {

$parcel$export(module.exports, "version", () => $b657937ef2c3fe71$export$83d89fbfd8236492);
// generated by genversion
const $b657937ef2c3fe71$export$83d89fbfd8236492 = '0.37.4';

});




parcelRegister("gmmcf", function(module, exports) {

$parcel$export(module.exports, "useFunctionQueue", () => $d2beb79d4a44608c$export$1e3598ac2ef5f634);

var $acw62 = parcelRequire("acw62");
const $d2beb79d4a44608c$export$1e3598ac2ef5f634 = ()=>{
    const [currentIndex, setCurrentIndex] = $acw62.useState(0);
    const [functions, setFunctions] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        async function callFunctions() {
            const functionsToCall = functions.slice(currentIndex);
            // Execute sequentially to prevent foreign key constraint violations
            for (const fn of functionsToCall)try {
                await fn();
            } catch (error) {
                console.error("Error executing queued function:", error);
            // Continue with other functions even if one fails
            }
            setCurrentIndex(functions.length);
        }
        callFunctions();
    }, [
        currentIndex,
        functions
    ]);
    function addFunctions(newFunctions) {
        setFunctions((prevFunctions)=>[
                ...prevFunctions,
                ...newFunctions
            ]);
    }
    function addFunction(newFunction) {
        setFunctions((prevFunctions)=>[
                ...prevFunctions,
                newFunction
            ]);
    }
    function next() {
        setCurrentIndex((prevIndex)=>prevIndex + 1);
    }
    return {
        addFunctions: addFunctions,
        addFunction: addFunction,
        next: next
    };
};

});

parcelRegister("gqehT", function(module, exports) {

$parcel$export(module.exports, "AIRPLX_TOKEN", () => $4cc785a23330ba2c$export$702c4c0144b25af6);
$parcel$export(module.exports, "IdentityContainer", () => $4cc785a23330ba2c$export$1852624fe14d261f);
$parcel$export(module.exports, "useIdentity", () => $4cc785a23330ba2c$export$a2347e5c24cde9c8);

var $ayMG0 = parcelRequire("ayMG0");

var $hY1XM = parcelRequire("hY1XM");

var $2Eznr = parcelRequire("2Eznr");

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $3kyM0 = parcelRequire("3kyM0");

var $lNEp2 = parcelRequire("lNEp2");

var $l5ED9 = parcelRequire("l5ED9");

var $7R9OT = parcelRequire("7R9OT");

var $6fDLr = parcelRequire("6fDLr");

var $ay9Yf = parcelRequire("ay9Yf");
/**
 * Lazy-load Azure MSAL only when Microsoft login is used
 */ let $4cc785a23330ba2c$var$msalInstance = null;

const $4cc785a23330ba2c$var$getMsalInstance = async ()=>{
    if (!$4cc785a23330ba2c$var$msalInstance) {
        const { PublicClientApplication: PublicClientApplication } = await (parcelRequire("1sLyH"));
        $4cc785a23330ba2c$var$msalInstance = new PublicClientApplication({
            auth: {
                clientId: "0ba12eac-fc85-4b51-8089-2c741d94f404",
                // Application (client) ID
                authority: "https://login.microsoftonline.com/common/",
                /**
         * http://localhost:1234
         * https://staging.airplx.com
         * https://app.airplx.com
         */ redirectUri: window.location.origin
            },
            cache: {
                cacheLocation: "sessionStorage",
                // This configures where your cache will be stored
                storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
            }
        });
    }
    return $4cc785a23330ba2c$var$msalInstance;
};
const $4cc785a23330ba2c$export$aedae4bd4e8762c2 = (jwt)=>{
    const decoded = (0, $2Eznr.default)(jwt);
    return {
        ...decoded,
        jwt: jwt
    };
};
const $4cc785a23330ba2c$export$d8474cff104280f3 = `airplx/${(0, $lNEp2.envName)()}/2023-02-02/identity`;
const $4cc785a23330ba2c$export$702c4c0144b25af6 = `airplx/${(0, $lNEp2.envName)()}/2023-02-02/token`;

/**
 * Create an identity container that can run the SSO login sequences with
 * online identity providers.
 *
 * Credentials are cached in local storage.
 *
 * An identity can be force set through props for testing or impersonation.
 */ const $4cc785a23330ba2c$var$useIdentityContainerState = (props)=>{
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { verifyJWT: verifyJWT, getIdentityToken: getIdentityToken, exchangeToken: exchangeToken } = (0, $3kyM0.useTokenMaker)();
    // Create unauthenticated postgrest client for public auth endpoints
    // (can't use authenticated client from ApiContainer due to circular dependency)
    const unauthenticatedPostgrest = $acw62.useMemo(()=>{
        return (0, $l5ED9.createUnauthenticatedPostgrest)();
    }, []);
    const [identity, setIdentity] = $acw62.useState(props.forceSetIdentity ?? JSON.parse(localStorage.getItem($4cc785a23330ba2c$export$d8474cff104280f3) || "{}"));
    const [airplxToken, setAirplxToken] = $acw62.useState(localStorage.getItem($4cc785a23330ba2c$export$702c4c0144b25af6));
    const airplxIdentity = Boolean(airplxToken) && airplxToken ? (0, $2Eznr.default)(airplxToken) : {};
    const refreshAirplxToken = async (jwt)=>{
        const token = await verifyJWT(jwt ?? identity.jwt, 1);
        if (!token) {
            // usually when this happens, the user has a really old token. we're just going
            // to log them out and make them re-authenticate.
            setIdentity(null);
            // nuke everything in local storage
            localStorage.clear();
            snackbar.notify({
                text: "We need to validate your account credentials. Please login with your SSO provider.",
                severity: "error"
            });
            window.location.href = "/#/login";
            return;
        }
        setAirplxToken(token);
        localStorage.setItem($4cc785a23330ba2c$export$702c4c0144b25af6, token ? token : "");
        if (!token) snackbar.notify({
            text: "You attemped to login with an unauthorized account. Please try another account.",
            severity: "error"
        });
    };
    /**
   * When your identity changes -- cache it in local storage.
   */ (0, $2NPdf.default)(async ()=>{
        // check for expired tokens
        if (identity.exp < Date.now() / 1000) {
            setIdentity(undefined);
            return;
        }
        if (airplxIdentity.exp < Date.now() / 1000) await refreshAirplxToken();
        if (identity && identity.jwt) {
            (0, $7R9OT.default).people.set({
                msftIdentity: identity
            });
            localStorage.setItem($4cc785a23330ba2c$export$d8474cff104280f3, JSON.stringify(identity));
            if (!airplxToken) await refreshAirplxToken();
        } else localStorage.removeItem($4cc785a23330ba2c$export$d8474cff104280f3);
    }, [
        identity
    ]);
    /**
   * MixPanel user tracking
   */ $acw62.useEffect(()=>{
        if (!airplxIdentity || !airplxIdentity.userid) return;
        (0, $7R9OT.default).identify(airplxIdentity.userid);
        (0, $7R9OT.default).people.set({
            $email: airplxIdentity.email
        });
        (0, $7R9OT.default).people.set({
            $name: identity?.account?.name
        });
    }, [
        airplxToken
    ]);
    // if their airPlx token is expired, we need to refresh it
    $acw62.useEffect(()=>{
        if (airplxIdentity.exp < Date.now() / 1000) setAirplxToken(null);
    }, [
        airplxIdentity
    ]);
    /**
   * Ask Microsoft to get us an identity token.
   */ const loginWithMicrosoft = async ()=>{
        localStorage.removeItem($4cc785a23330ba2c$export$d8474cff104280f3);
        localStorage.removeItem($4cc785a23330ba2c$export$702c4c0144b25af6);
        const msal = await $4cc785a23330ba2c$var$getMsalInstance();
        return msal.loginPopup({
            scopes: [
                "openid",
                "email",
                "profile"
            ]
        }).then(async (data)=>{
            const identity = {
                ...data,
                jwt: data.idToken
            };
            await refreshAirplxToken(data.idToken);
            setIdentity(identity);
        });
    };
    /**
   * Ask Google to get us an identity token.
   */ const loginWithGoogle = async (token, identity)=>{
        localStorage.removeItem($4cc785a23330ba2c$export$d8474cff104280f3);
        localStorage.removeItem($4cc785a23330ba2c$export$702c4c0144b25af6);
        await exchangeToken(token);
        setIdentity({
            ...identity,
            jwt: token
        });
    };
    /**
   * Login with a magic link token.
   */ const loginWithMagicLink = async (code)=>{
        localStorage.removeItem($4cc785a23330ba2c$export$d8474cff104280f3);
        localStorage.removeItem($4cc785a23330ba2c$export$702c4c0144b25af6);
        const token = await getIdentityToken(code);
        await refreshAirplxToken(token);
        setIdentity({
            ...identity,
            jwt: token
        });
    };
    /**
   * Check if an email has a password set (for email-first login flow).
   */ const hasPassword = async (email)=>{
        try {
            const { data: data } = await unauthenticatedPostgrest.rpc("has_password", {
                p_email: email
            });
            return data;
        } catch (error) {
            console.error("Error checking if email has password:", error);
            return false;
        }
    };
    /**
   * Login with email and password.
   */ const loginWithPassword = async (email, password)=>{
        try {
            localStorage.removeItem($4cc785a23330ba2c$export$d8474cff104280f3);
            localStorage.removeItem($4cc785a23330ba2c$export$702c4c0144b25af6);
            const { data: token } = await unauthenticatedPostgrest.rpc("authenticate_with_password", {
                p_email: email,
                p_password: password
            });
            if (!token) return false;
            const tokenString = token;
            setAirplxToken(tokenString);
            localStorage.setItem($4cc785a23330ba2c$export$702c4c0144b25af6, tokenString);
            setIdentity({
                ...identity,
                jwt: tokenString
            });
            return true;
        } catch (error) {
            console.error("Error logging in with password:", error);
            return false;
        }
    };
    /**
   * Clear out identity.
   */ const logout = async ()=>{
        // End all active sessions before logout
        try {
            // Import here to avoid circular dependencies
            const { endAllSessions: endAllSessions } = await Promise.resolve((parcelRequire("7R9OT")));
            await endAllSessions(unauthenticatedPostgrest);
        } catch (error) {
            console.error("Error ending sessions during logout:", error);
        }
        setIdentity(undefined);
        setAirplxToken(null);
        localStorage.removeItem($4cc785a23330ba2c$export$d8474cff104280f3);
        localStorage.removeItem($4cc785a23330ba2c$export$702c4c0144b25af6);
        window.location.reload();
    };
    return {
        isLoggedIn: Boolean(airplxToken),
        identity: identity,
        airplxIdentity: airplxIdentity,
        airplxToken: airplxToken,
        loginWithMicrosoft: loginWithMicrosoft,
        loginWithGoogle: loginWithGoogle,
        loginWithMagicLink: loginWithMagicLink,
        loginWithPassword: loginWithPassword,
        hasPassword: hasPassword,
        refreshAirplxToken: refreshAirplxToken,
        logout: logout
    };
};
const $4cc785a23330ba2c$var$IdentityContainerState = (0, $ay9Yf.createContainer)($4cc785a23330ba2c$var$useIdentityContainerState);
const $4cc785a23330ba2c$export$1852624fe14d261f = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4cc785a23330ba2c$var$IdentityContainerState.Provider, {
        initialState: props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hY1XM.GoogleOAuthProvider), {
            clientId: "766877242042-4klesl9nm4aro0glc74tp588qc1fqtcq.apps.googleusercontent.com",
            children: children
        })
    });
};
const $4cc785a23330ba2c$export$a2347e5c24cde9c8 = $4cc785a23330ba2c$var$IdentityContainerState.useContainer;

});
parcelRegister("hY1XM", function(module, exports) {

$parcel$export(module.exports, "GoogleOAuthProvider", () => $d149901aa2a09db4$export$a325976a38f291f5);
$parcel$export(module.exports, "GoogleLogin", () => $d149901aa2a09db4$export$a795a627e512102a);

var $acw62 = parcelRequire("acw62");
function $d149901aa2a09db4$var$useLoadGsiScript(options = {}) {
    const { nonce: nonce, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0, $acw62.useState)(false);
    const onScriptLoadSuccessRef = (0, $acw62.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0, $acw62.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0, $acw62.useEffect)(()=>{
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.nonce = nonce;
        scriptTag.onload = ()=>{
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 || _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = ()=>{
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 || _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return ()=>{
            document.body.removeChild(scriptTag);
        };
    }, [
        nonce
    ]);
    return scriptLoadedSuccessfully;
}
const $d149901aa2a09db4$var$GoogleOAuthContext = (0, $acw62.createContext)(null);
function $d149901aa2a09db4$export$a325976a38f291f5({ clientId: clientId, nonce: nonce, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError, children: children }) {
    const scriptLoadedSuccessfully = $d149901aa2a09db4$var$useLoadGsiScript({
        nonce: nonce,
        onScriptLoadSuccess: onScriptLoadSuccess,
        onScriptLoadError: onScriptLoadError
    });
    const contextValue = (0, $acw62.useMemo)(()=>({
            clientId: clientId,
            scriptLoadedSuccessfully: scriptLoadedSuccessfully
        }), [
        clientId,
        scriptLoadedSuccessfully
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d149901aa2a09db4$var$GoogleOAuthContext.Provider, {
        value: contextValue
    }, children);
}
function $d149901aa2a09db4$var$useGoogleOAuth() {
    const context = (0, $acw62.useContext)($d149901aa2a09db4$var$GoogleOAuthContext);
    if (!context) throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
    return context;
}
function $d149901aa2a09db4$var$extractClientId(credentialResponse) {
    var _a;
    const clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
    return clientId;
}
const $d149901aa2a09db4$var$containerHeightMap = {
    large: 40,
    medium: 32,
    small: 20
};
function $d149901aa2a09db4$export$a795a627e512102a({ onSuccess: onSuccess, onError: onError, useOneTap: useOneTap, promptMomentNotification: promptMomentNotification, type: type = 'standard', theme: theme = 'outline', size: size = 'large', text: text, shape: shape, logo_alignment: logo_alignment, width: width, locale: locale, click_listener: click_listener, containerProps: containerProps, ...props }) {
    const btnContainerRef = (0, $acw62.useRef)(null);
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $d149901aa2a09db4$var$useGoogleOAuth();
    const onSuccessRef = (0, $acw62.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $acw62.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $acw62.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully) return;
        (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $d149901aa2a09db4$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            ...props
        });
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 || _f.renderButton(btnContainerRef.current, {
            type: type,
            theme: theme,
            size: size,
            text: text,
            shape: shape,
            logo_alignment: logo_alignment,
            width: width,
            locale: locale,
            click_listener: click_listener
        });
        if (useOneTap) (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 || _j.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a, _b, _c;
            if (useOneTap) (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...containerProps,
        ref: btnContainerRef,
        style: {
            height: $d149901aa2a09db4$var$containerHeightMap[size],
            ...containerProps === null || containerProps === void 0 ? void 0 : containerProps.style
        }
    });
}
function $d149901aa2a09db4$export$64c51800d55c1202() {
    var _a, _b, _c;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.disableAutoSelect();
}
/* eslint-disable import/export */ function $d149901aa2a09db4$export$6ca4c5d94f9e170b({ flow: flow = 'implicit', scope: scope = '', onSuccess: onSuccess, onError: onError, onNonOAuthError: onNonOAuthError, overrideScope: overrideScope, state: state, ...props }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $d149901aa2a09db4$var$useGoogleOAuth();
    const clientRef = (0, $acw62.useRef)();
    const onSuccessRef = (0, $acw62.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $acw62.useRef)(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = (0, $acw62.useRef)(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (!scriptLoadedSuccessfully) return;
        const clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
        const client = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response)=>{
                var _a, _b;
                if (response.error) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 || _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError)=>{
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 || _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            state: state,
            ...props
        });
        clientRef.current = client;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        flow,
        scope,
        state
    ]);
    const loginImplicitFlow = (0, $acw62.useCallback)((overrideConfig)=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig);
    }, []);
    const loginAuthCodeFlow = (0, $acw62.useCallback)(()=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode();
    }, []);
    return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}
function $d149901aa2a09db4$export$7ab2d3f76b55c251({ onSuccess: onSuccess, onError: onError, promptMomentNotification: promptMomentNotification, cancel_on_tap_outside: cancel_on_tap_outside, prompt_parent_id: prompt_parent_id, state_cookie_domain: state_cookie_domain, hosted_domain: hosted_domain, disabled: disabled }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $d149901aa2a09db4$var$useGoogleOAuth();
    const onSuccessRef = (0, $acw62.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $acw62.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $acw62.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully) return;
        if (disabled) {
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
            return;
        }
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 || _f.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $d149901aa2a09db4$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            hosted_domain: hosted_domain,
            cancel_on_tap_outside: cancel_on_tap_outside,
            prompt_parent_id: prompt_parent_id,
            state_cookie_domain: state_cookie_domain
        });
        (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 || _j.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a, _b, _c;
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        cancel_on_tap_outside,
        prompt_parent_id,
        state_cookie_domain,
        hosted_domain,
        disabled
    ]);
}
/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */ function $d149901aa2a09db4$export$dfe7cd07eac17bc5(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google)) return false;
    return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAllScopes(tokenResponse, firstScope, ...restScopes)) || false;
}
/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */ function $d149901aa2a09db4$export$3413c85423c3f1d0(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google)) return false;
    return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAnyScope(tokenResponse, firstScope, ...restScopes)) || false;
}

});

parcelRegister("2Eznr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eeac253570f845a$export$2e2bcd8739ae039);
function $1eeac253570f845a$var$e(e) {
    this.message = e;
}
$1eeac253570f845a$var$e.prototype = new Error, $1eeac253570f845a$var$e.prototype.name = "InvalidCharacterError";
var $1eeac253570f845a$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $1eeac253570f845a$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $1eeac253570f845a$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($1eeac253570f845a$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $1eeac253570f845a$var$r(t);
    }
}
function $1eeac253570f845a$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $1eeac253570f845a$var$o(e, r) {
    if ("string" != typeof e) throw new $1eeac253570f845a$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($1eeac253570f845a$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $1eeac253570f845a$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$1eeac253570f845a$export$b9721ef022f71a68.prototype = new Error, $1eeac253570f845a$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $1eeac253570f845a$export$2e2bcd8739ae039 = $1eeac253570f845a$var$o;

});

parcelRegister("2NPdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a7e22880d53ca2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4ujy9 = parcelRequire("4ujy9");
function $20a7e22880d53ca2$export$2e2bcd8739ae039(fn, deps) {
    if (deps === void 0) deps = [];
    var _a = (0, $4ujy9.default)(fn, deps, {
        loading: true
    }), state = _a[0], callback = _a[1];
    (0, $acw62.useEffect)(function() {
        callback();
    }, [
        callback
    ]);
    return state;
}

});
parcelRegister("4ujy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $344920ee39427eae$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $60Fw0 = parcelRequire("60Fw0");
function $344920ee39427eae$export$2e2bcd8739ae039(fn, deps, initialState) {
    if (deps === void 0) deps = [];
    if (initialState === void 0) initialState = {
        loading: false
    };
    var lastCallId = (0, $acw62.useRef)(0);
    var isMounted = (0, $60Fw0.default)();
    var _a = (0, $acw62.useState)(initialState), state = _a[0], set = _a[1];
    var callback = (0, $acw62.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var callId = ++lastCallId.current;
        if (!state.loading) set(function(prevState) {
            return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, prevState), {
                loading: true
            });
        });
        return fn.apply(void 0, args).then(function(value) {
            isMounted() && callId === lastCallId.current && set({
                value: value,
                loading: false
            });
            return value;
        }, function(error) {
            isMounted() && callId === lastCallId.current && set({
                error: error,
                loading: false
            });
            return error;
        });
    }, deps);
    return [
        state,
        callback
    ];
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("60Fw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4602f23e571d1865$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $4602f23e571d1865$export$2e2bcd8739ae039() {
    var mountedRef = (0, $acw62.useRef)(false);
    var get = (0, $acw62.useCallback)(function() {
        return mountedRef.current;
    }, []);
    (0, $acw62.useEffect)(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    }, []);
    return get;
}

});



parcelRegister("3kyM0", function(module, exports) {

$parcel$export(module.exports, "usePostgrest", () => $ae56d1ae1a6d6b98$export$539142e17c2501f);
$parcel$export(module.exports, "useTokenMaker", () => $ae56d1ae1a6d6b98$export$ebe80882cfef39c1);
parcelRequire("hLOAf");
var $bjuzH = parcelRequire("bjuzH");

var $acw62 = parcelRequire("acw62");

var $lNEp2 = parcelRequire("lNEp2");
const $ae56d1ae1a6d6b98$export$539142e17c2501f = ()=>{
    const [token] = $acw62.useState("");
    const postgrest = new (0, $bjuzH.default)((0, $lNEp2.getPostgrestUrl)());
    if (token) postgrest.auth(token);
    return postgrest;
};
const $ae56d1ae1a6d6b98$export$ebe80882cfef39c1 = ()=>{
    const url = (0, $lNEp2.getTokenMakerUrl)();
    const getIdentityToken = async (code)=>{
        const result = await fetch(`${url}/identity/${code}`).then((res)=>res.json());
        return result.token;
    };
    const verifyJWT = async (jwt, noValidate = 0)=>{
        const verifyURL = noValidate ? `${url}/?token=${jwt}&noValidate=${noValidate}` : `${url}/?token=${jwt}`;
        const result = await fetch(verifyURL).then((res)=>res.json());
        return result.token;
    };
    const exchangeToken = async (jwt)=>{
        const result = await fetch(`${url}?token=${jwt}&noValidate=1`).then((res)=>res.json());
        return result.token;
    };
    return {
        url: url,
        verifyJWT: verifyJWT,
        getIdentityToken: getIdentityToken,
        exchangeToken: exchangeToken
    };
};

});

parcelRegister("l5ED9", function(module, exports) {

$parcel$export(module.exports, "createUnauthenticatedPostgrest", () => $6bcce367c60eb055$export$fadfae840eaaa711);
parcelRequire("hLOAf");
var $bjuzH = parcelRequire("bjuzH");

var $lNEp2 = parcelRequire("lNEp2");
const $6bcce367c60eb055$export$fadfae840eaaa711 = ()=>{
    return new (0, $bjuzH.default)((0, $lNEp2.getPostgrestUrl)());
};

});

parcelRegister("6fDLr", function(module, exports) {

$parcel$export(module.exports, "SnackbarContainer", () => $5f7e0e140185757d$export$fe8275a9a0b320df);
$parcel$export(module.exports, "useSnackbar", () => $5f7e0e140185757d$export$1c97ac2c9a6e7c09);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lNEp2 = parcelRequire("lNEp2");

var $ay9Yf = parcelRequire("ay9Yf");
const $5f7e0e140185757d$var$useSnackbarContainerState = ()=>{
    const [notifications, setNotifications] = $acw62.useState([]);
    return {
        notify: (notification)=>{
            setNotifications((notifications)=>[
                    ...notifications,
                    {
                        ...notification,
                        id: (0, $lNEp2.uuidv4)(),
                        severity: notification.severity ?? "error",
                        open: true
                    }
                ]);
        },
        notifications: notifications,
        setNotifications: setNotifications
    };
};
const $5f7e0e140185757d$var$SnackbarContainerState = (0, $ay9Yf.createContainer)($5f7e0e140185757d$var$useSnackbarContainerState);
const $5f7e0e140185757d$export$fe8275a9a0b320df = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5f7e0e140185757d$var$SnackbarContainerState.Provider, {
        ...props,
        children: children
    });
};
const $5f7e0e140185757d$export$1c97ac2c9a6e7c09 = $5f7e0e140185757d$var$SnackbarContainerState.useContainer;

});
parcelRegister("ay9Yf", function(module, exports) {

$parcel$export(module.exports, "createContainer", () => $5114323cba7f9408$export$26ae5ca175b4ec5a);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $5114323cba7f9408$export$26ae5ca175b4ec5a = (useHook)=>{
    // use react context for the actual state
    const Context = /*#__PURE__*/ $acw62.createContext({});
    const Provider = (props)=>{
        const value = useHook(props.initialState) || {};
        return /*#__PURE__*/ (0, $ayMG0.jsx)(Context.Provider, {
            value: value,
            children: props.children
        });
    };
    /**
   * Use the container in a component down the react tree.
   *
   * This can come back with an empty context if no provider
   * is above to avoid errors from destructuring undefined -- instead
   * flow through with a un-contextualized invocation of the state hook.
   *
   * This should 'forgive' a bit of not having a container and in effect
   * devolve to hook use inside the calling component, which will work just
   * like useState -- it's just that lower components on the tree won't be able
   * to see!
   */ const useContainer = ()=>{
        const value = $acw62.useContext(Context) || useHook() || {};
        return value || {};
    };
    return {
        Provider: Provider,
        useContainer: useContainer
    };
};

});


parcelRegister("1sLyH", function(module, exports) {
module.exports = import("11o6q").then(()=>parcelRequire('8zQx8'));

});




parcelRegister("03mUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a20d475386f68c$export$2e2bcd8739ae039);

var $8Djtb = parcelRequire("8Djtb");


var $bnost = parcelRequire("bnost");

var $ijOKP = parcelRequire("ijOKP");

var $4jPsi = parcelRequire("4jPsi");

var $hOwN9 = parcelRequire("hOwN9");
'use client';
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $8Djtb.default)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: (0, $hOwN9.default).root,
    generateClassName: (0, $bnost.default).generate
});
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;

});
parcelRegister("8Djtb", function(module, exports) {

$parcel$export(module.exports, "default", () => $649111849f89bb90$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $5C8IU = parcelRequire("5C8IU");

var $g91qR = parcelRequire("g91qR");
var $6hiu6 = parcelRequire("6hiu6");

var $iPcdL = parcelRequire("iPcdL");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $649111849f89bb90$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5C8IU.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $g91qR.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $iPcdL.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $6hiu6.default)(inProps);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});
parcelRegister("9QePP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("5C8IU", function(module, exports) {

$parcel$export(module.exports, "default", () => $416744a0a1673bb3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_mutateStyles", () => $416744a0a1673bb3$export$592c7226e4cb0171);
$parcel$export(module.exports, "internal_serializeStyles", () => $416744a0a1673bb3$export$13a2d3ef13012b32);
/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $5rflj = parcelRequire("5rflj");

var $8rteH = parcelRequire("8rteH");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");


var $aVZKi = parcelRequire("aVZKi");
function $416744a0a1673bb3$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $416744a0a1673bb3$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $416744a0a1673bb3$var$wrapper = [];
function $416744a0a1673bb3$export$13a2d3ef13012b32(styles) {
    $416744a0a1673bb3$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($416744a0a1673bb3$var$wrapper);
}

});
parcelRegister("5rflj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("aVZKi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f5f1fa669ccc202$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $7f5f1fa669ccc202$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $7f5f1fa669ccc202$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($7f5f1fa669ccc202$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jjlaj.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("g91qR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0e990868bc4709$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $4hxOJ = parcelRequire("4hxOJ");

var $85acy = parcelRequire("85acy");

var $fkf5V = parcelRequire("fkf5V");

var $jWad3 = parcelRequire("jWad3");

var $5iHq4 = parcelRequire("5iHq4");
function $bc0e990868bc4709$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $bc0e990868bc4709$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $bc0e990868bc4709$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $85acy.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $85acy.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $85acy.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $fkf5V.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $5iHq4.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $fkf5V.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $bc0e990868bc4709$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $4hxOJ.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $fkf5V.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($bc0e990868bc4709$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $4hxOJ.default)(css, breakpointsValues);
                        }
                    } else css = (0, $4hxOJ.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $jWad3.sortContainerQueries)(theme, (0, $fkf5V.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $jWad3.sortContainerQueries)(theme, (0, $fkf5V.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $bc0e990868bc4709$var$styleFunctionSx = $bc0e990868bc4709$export$7d53d8bf2911e013();
$bc0e990868bc4709$var$styleFunctionSx.filterProps = [
    'sx'
];
var $bc0e990868bc4709$export$2e2bcd8739ae039 = $bc0e990868bc4709$var$styleFunctionSx;

});
parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");
function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $cpmCj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("4hxOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e2fb5dec95c3d0$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $31e2fb5dec95c3d0$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $31e2fb5dec95c3d0$export$2e2bcd8739ae039 = $31e2fb5dec95c3d0$var$merge;

});
parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $19Aa2 = parcelRequire("19Aa2");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || (0, $19Aa2.isValidElementType)(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key]) || (0, $19Aa2.isValidElementType)(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("19Aa2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gijsP"));

});
parcelRegister("gijsP", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $bdcd6ced2cdccd72$export$a7c73072b1a182ae, (v) => $bdcd6ced2cdccd72$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $bdcd6ced2cdccd72$export$9f27bc3417b4524d, (v) => $bdcd6ced2cdccd72$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $bdcd6ced2cdccd72$export$db77ccec0bb4ccac, (v) => $bdcd6ced2cdccd72$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35, (v) => $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $bdcd6ced2cdccd72$export$ffb0004e005737fa, (v) => $bdcd6ced2cdccd72$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $bdcd6ced2cdccd72$export$b624eff549462981, (v) => $bdcd6ced2cdccd72$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $bdcd6ced2cdccd72$export$7897aa7841a5380c, (v) => $bdcd6ced2cdccd72$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $bdcd6ced2cdccd72$export$602eac185826482c, (v) => $bdcd6ced2cdccd72$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $bdcd6ced2cdccd72$export$e2c29f18771995cb, (v) => $bdcd6ced2cdccd72$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $bdcd6ced2cdccd72$export$5f8d39834fd61797, (v) => $bdcd6ced2cdccd72$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bdcd6ced2cdccd72$export$74bf444e3cd11ea5, (v) => $bdcd6ced2cdccd72$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $bdcd6ced2cdccd72$export$998bcd577473dd93, (v) => $bdcd6ced2cdccd72$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $bdcd6ced2cdccd72$export$b706b080d889d2c9, (v) => $bdcd6ced2cdccd72$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $bdcd6ced2cdccd72$export$5be5a87408f70ddc, (v) => $bdcd6ced2cdccd72$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d, (v) => $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $bdcd6ced2cdccd72$export$455c2e768291efa6, (v) => $bdcd6ced2cdccd72$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $bdcd6ced2cdccd72$export$9522e17588c12572, (v) => $bdcd6ced2cdccd72$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $bdcd6ced2cdccd72$export$2110ac352bb060b9, (v) => $bdcd6ced2cdccd72$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $bdcd6ced2cdccd72$export$56885ab8b9c456ab, (v) => $bdcd6ced2cdccd72$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $bdcd6ced2cdccd72$export$d927fcb6adf8f9de, (v) => $bdcd6ced2cdccd72$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $bdcd6ced2cdccd72$export$b82d16f27459e05a, (v) => $bdcd6ced2cdccd72$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $bdcd6ced2cdccd72$export$522c17b4f5e123e8, (v) => $bdcd6ced2cdccd72$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6, (v) => $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $bdcd6ced2cdccd72$export$3d6c20d97e46b957, (v) => $bdcd6ced2cdccd72$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $bdcd6ced2cdccd72$export$9b621391a187a31a, (v) => $bdcd6ced2cdccd72$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $bdcd6ced2cdccd72$export$f5bbd400c2f4426f, (v) => $bdcd6ced2cdccd72$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bdcd6ced2cdccd72$export$a7c73072b1a182ae;
var $bdcd6ced2cdccd72$export$9f27bc3417b4524d;
var $bdcd6ced2cdccd72$export$db77ccec0bb4ccac;
var $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35;
var $bdcd6ced2cdccd72$export$ffb0004e005737fa;
var $bdcd6ced2cdccd72$export$b624eff549462981;
var $bdcd6ced2cdccd72$export$7897aa7841a5380c;
var $bdcd6ced2cdccd72$export$602eac185826482c;
var $bdcd6ced2cdccd72$export$e2c29f18771995cb;
var $bdcd6ced2cdccd72$export$5f8d39834fd61797;
var $bdcd6ced2cdccd72$export$74bf444e3cd11ea5;
var $bdcd6ced2cdccd72$export$998bcd577473dd93;
var $bdcd6ced2cdccd72$export$b706b080d889d2c9;
var $bdcd6ced2cdccd72$export$5be5a87408f70ddc;
var $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d;
var $bdcd6ced2cdccd72$export$455c2e768291efa6;
var $bdcd6ced2cdccd72$export$9522e17588c12572;
var $bdcd6ced2cdccd72$export$2110ac352bb060b9;
var $bdcd6ced2cdccd72$export$56885ab8b9c456ab;
var $bdcd6ced2cdccd72$export$d927fcb6adf8f9de;
var $bdcd6ced2cdccd72$export$b82d16f27459e05a;
var $bdcd6ced2cdccd72$export$522c17b4f5e123e8;
var $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6;
var $bdcd6ced2cdccd72$export$3d6c20d97e46b957;
var $bdcd6ced2cdccd72$export$9b621391a187a31a;
var $bdcd6ced2cdccd72$export$f5bbd400c2f4426f;
"use strict";
var $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bdcd6ced2cdccd72$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $bdcd6ced2cdccd72$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $bdcd6ced2cdccd72$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE:
                                return object;
                            case $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$bdcd6ced2cdccd72$export$a7c73072b1a182ae = $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE;
$bdcd6ced2cdccd72$export$9f27bc3417b4524d = $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE;
$bdcd6ced2cdccd72$export$db77ccec0bb4ccac = $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE;
$bdcd6ced2cdccd72$export$8392c0c9d3dcbd35 = $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE;
$bdcd6ced2cdccd72$export$ffb0004e005737fa = $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE;
$bdcd6ced2cdccd72$export$b624eff549462981 = $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE;
$bdcd6ced2cdccd72$export$7897aa7841a5380c = $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE;
$bdcd6ced2cdccd72$export$602eac185826482c = $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE;
$bdcd6ced2cdccd72$export$e2c29f18771995cb = $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE;
$bdcd6ced2cdccd72$export$5f8d39834fd61797 = $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE;
$bdcd6ced2cdccd72$export$74bf444e3cd11ea5 = $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE;
$bdcd6ced2cdccd72$export$998bcd577473dd93 = $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE;
$bdcd6ced2cdccd72$export$b706b080d889d2c9 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE;
};
$bdcd6ced2cdccd72$export$5be5a87408f70ddc = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE;
};
$bdcd6ced2cdccd72$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE;
};
$bdcd6ced2cdccd72$export$455c2e768291efa6 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE;
};
$bdcd6ced2cdccd72$export$9522e17588c12572 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE;
};
$bdcd6ced2cdccd72$export$2110ac352bb060b9 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE;
};
$bdcd6ced2cdccd72$export$56885ab8b9c456ab = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE;
};
$bdcd6ced2cdccd72$export$d927fcb6adf8f9de = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE;
};
$bdcd6ced2cdccd72$export$b82d16f27459e05a = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE;
};
$bdcd6ced2cdccd72$export$522c17b4f5e123e8 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE;
};
$bdcd6ced2cdccd72$export$1aabd8a0274ecfd6 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE;
};
$bdcd6ced2cdccd72$export$3d6c20d97e46b957 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE;
};
$bdcd6ced2cdccd72$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE || type === $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE || type === $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE || type === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE || type === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$bdcd6ced2cdccd72$export$f5bbd400c2f4426f = $bdcd6ced2cdccd72$var$typeOf;

});




parcelRegister("85acy", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $5e26b42cd60d872d$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $5e26b42cd60d872d$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $5e26b42cd60d872d$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");


var $fkf5V = parcelRequire("fkf5V");
function $5e26b42cd60d872d$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $5e26b42cd60d872d$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $5e26b42cd60d872d$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $5e26b42cd60d872d$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $5e26b42cd60d872d$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $5e26b42cd60d872d$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $5e26b42cd60d872d$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $fkf5V.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $5e26b42cd60d872d$export$2e2bcd8739ae039 = $5e26b42cd60d872d$var$style;

});
parcelRegister("fkf5V", function(module, exports) {

$parcel$export(module.exports, "values", () => $b2846ebbb0334250$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $b2846ebbb0334250$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $b2846ebbb0334250$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $b2846ebbb0334250$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $b2846ebbb0334250$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $b2846ebbb0334250$export$980e6a259d807490);


var $3z1Ay = parcelRequire("3z1Ay");

var $4hxOJ = parcelRequire("4hxOJ");

var $jWad3 = parcelRequire("jWad3");
const $b2846ebbb0334250$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $b2846ebbb0334250$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$b2846ebbb0334250$export$68c286be0e7e55b7[key]}px)`
};
const $b2846ebbb0334250$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $b2846ebbb0334250$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $b2846ebbb0334250$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $b2846ebbb0334250$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $b2846ebbb0334250$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $jWad3.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $jWad3.getContainerQuery)(theme.containerQueries ? theme : $b2846ebbb0334250$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $b2846ebbb0334250$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $b2846ebbb0334250$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $b2846ebbb0334250$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $4hxOJ.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $b2846ebbb0334250$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $b2846ebbb0334250$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $b2846ebbb0334250$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $b2846ebbb0334250$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $b2846ebbb0334250$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $b2846ebbb0334250$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $b2846ebbb0334250$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $b2846ebbb0334250$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $b2846ebbb0334250$export$2e2bcd8739ae039 = $b2846ebbb0334250$var$breakpoints;

});
parcelRegister("jWad3", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", () => $e83b5a82a226ed9e$export$456f6c1142f990db);
$parcel$export(module.exports, "isCqShorthand", () => $e83b5a82a226ed9e$export$77c7c3e357f440e7);
$parcel$export(module.exports, "getContainerQuery", () => $e83b5a82a226ed9e$export$10a9745dfa00d15);
$parcel$export(module.exports, "default", () => $e83b5a82a226ed9e$export$2e2bcd8739ae039);

function $e83b5a82a226ed9e$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $e83b5a82a226ed9e$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $e83b5a82a226ed9e$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $e83b5a82a226ed9e$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});



parcelRegister("5iHq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc050675c3a4812$export$2e2bcd8739ae039);

var $FuSTe = parcelRequire("FuSTe");

var $jYFzm = parcelRequire("jYFzm");

var $1f8h4 = parcelRequire("1f8h4");

var $5mUnW = parcelRequire("5mUnW");

var $dWKxE = parcelRequire("dWKxE");
const $3dc050675c3a4812$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $jYFzm.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $jYFzm.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $jYFzm.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $jYFzm.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $jYFzm.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $jYFzm.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $jYFzm.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $5mUnW.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $5mUnW.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $5mUnW.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $FuSTe.padding)
    },
    pt: {
        style: (0, $FuSTe.padding)
    },
    pr: {
        style: (0, $FuSTe.padding)
    },
    pb: {
        style: (0, $FuSTe.padding)
    },
    pl: {
        style: (0, $FuSTe.padding)
    },
    px: {
        style: (0, $FuSTe.padding)
    },
    py: {
        style: (0, $FuSTe.padding)
    },
    padding: {
        style: (0, $FuSTe.padding)
    },
    paddingTop: {
        style: (0, $FuSTe.padding)
    },
    paddingRight: {
        style: (0, $FuSTe.padding)
    },
    paddingBottom: {
        style: (0, $FuSTe.padding)
    },
    paddingLeft: {
        style: (0, $FuSTe.padding)
    },
    paddingX: {
        style: (0, $FuSTe.padding)
    },
    paddingY: {
        style: (0, $FuSTe.padding)
    },
    paddingInline: {
        style: (0, $FuSTe.padding)
    },
    paddingInlineStart: {
        style: (0, $FuSTe.padding)
    },
    paddingInlineEnd: {
        style: (0, $FuSTe.padding)
    },
    paddingBlock: {
        style: (0, $FuSTe.padding)
    },
    paddingBlockStart: {
        style: (0, $FuSTe.padding)
    },
    paddingBlockEnd: {
        style: (0, $FuSTe.padding)
    },
    m: {
        style: (0, $FuSTe.margin)
    },
    mt: {
        style: (0, $FuSTe.margin)
    },
    mr: {
        style: (0, $FuSTe.margin)
    },
    mb: {
        style: (0, $FuSTe.margin)
    },
    ml: {
        style: (0, $FuSTe.margin)
    },
    mx: {
        style: (0, $FuSTe.margin)
    },
    my: {
        style: (0, $FuSTe.margin)
    },
    margin: {
        style: (0, $FuSTe.margin)
    },
    marginTop: {
        style: (0, $FuSTe.margin)
    },
    marginRight: {
        style: (0, $FuSTe.margin)
    },
    marginBottom: {
        style: (0, $FuSTe.margin)
    },
    marginLeft: {
        style: (0, $FuSTe.margin)
    },
    marginX: {
        style: (0, $FuSTe.margin)
    },
    marginY: {
        style: (0, $FuSTe.margin)
    },
    marginInline: {
        style: (0, $FuSTe.margin)
    },
    marginInlineStart: {
        style: (0, $FuSTe.margin)
    },
    marginInlineEnd: {
        style: (0, $FuSTe.margin)
    },
    marginBlock: {
        style: (0, $FuSTe.margin)
    },
    marginBlockStart: {
        style: (0, $FuSTe.margin)
    },
    marginBlockEnd: {
        style: (0, $FuSTe.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $1f8h4.gap)
    },
    rowGap: {
        style: (0, $1f8h4.rowGap)
    },
    columnGap: {
        style: (0, $1f8h4.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $dWKxE.sizingTransform)
    },
    maxWidth: {
        style: (0, $dWKxE.maxWidth)
    },
    minWidth: {
        transform: (0, $dWKxE.sizingTransform)
    },
    height: {
        transform: (0, $dWKxE.sizingTransform)
    },
    maxHeight: {
        transform: (0, $dWKxE.sizingTransform)
    },
    minHeight: {
        transform: (0, $dWKxE.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $3dc050675c3a4812$export$2e2bcd8739ae039 = $3dc050675c3a4812$var$defaultSxConfig;

});
parcelRegister("FuSTe", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $07cbc96ed1980a10$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $07cbc96ed1980a10$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $07cbc96ed1980a10$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $07cbc96ed1980a10$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $07cbc96ed1980a10$export$6f98e8eaf0be1996);


var $fkf5V = parcelRequire("fkf5V");

var $85acy = parcelRequire("85acy");

var $4hxOJ = parcelRequire("4hxOJ");

var $6F7wE = parcelRequire("6F7wE");
const $07cbc96ed1980a10$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $07cbc96ed1980a10$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $07cbc96ed1980a10$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $07cbc96ed1980a10$var$getCssProperties = (0, $6F7wE.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($07cbc96ed1980a10$var$aliases[prop]) prop = $07cbc96ed1980a10$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $07cbc96ed1980a10$var$properties[a];
    const direction = $07cbc96ed1980a10$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $07cbc96ed1980a10$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $07cbc96ed1980a10$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $07cbc96ed1980a10$var$spacingKeys = [
    ...$07cbc96ed1980a10$export$aab52a0dde05ad8a,
    ...$07cbc96ed1980a10$export$f8397d44f03ab6ad
];
function $07cbc96ed1980a10$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $85acy.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $07cbc96ed1980a10$export$1def6f833384e3d1(theme) {
    return $07cbc96ed1980a10$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $07cbc96ed1980a10$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $07cbc96ed1980a10$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $07cbc96ed1980a10$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $07cbc96ed1980a10$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $07cbc96ed1980a10$var$getCssProperties(prop);
    const styleFromPropValue = $07cbc96ed1980a10$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $fkf5V.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $07cbc96ed1980a10$var$style(props, keys) {
    const transformer = $07cbc96ed1980a10$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$07cbc96ed1980a10$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $4hxOJ.default), {});
}
function $07cbc96ed1980a10$export$7ede87f9b603dd3c(props) {
    return $07cbc96ed1980a10$var$style(props, $07cbc96ed1980a10$export$aab52a0dde05ad8a);
}
$07cbc96ed1980a10$export$7ede87f9b603dd3c.propTypes = {};
$07cbc96ed1980a10$export$7ede87f9b603dd3c.filterProps = $07cbc96ed1980a10$export$aab52a0dde05ad8a;
function $07cbc96ed1980a10$export$6f98e8eaf0be1996(props) {
    return $07cbc96ed1980a10$var$style(props, $07cbc96ed1980a10$export$f8397d44f03ab6ad);
}
$07cbc96ed1980a10$export$6f98e8eaf0be1996.propTypes = {};
$07cbc96ed1980a10$export$6f98e8eaf0be1996.filterProps = $07cbc96ed1980a10$export$f8397d44f03ab6ad;
function $07cbc96ed1980a10$var$spacing(props) {
    return $07cbc96ed1980a10$var$style(props, $07cbc96ed1980a10$var$spacingKeys);
}
$07cbc96ed1980a10$var$spacing.propTypes = {};
$07cbc96ed1980a10$var$spacing.filterProps = $07cbc96ed1980a10$var$spacingKeys;
var $07cbc96ed1980a10$export$2e2bcd8739ae039 = $07cbc96ed1980a10$var$spacing;

});
parcelRegister("6F7wE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9c68d21bd1e003$export$2e2bcd8739ae039);
function $4d9c68d21bd1e003$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jYFzm", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $e8b3ddb65b96dec9$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $e8b3ddb65b96dec9$export$7a57f79000377ca2);


var $85acy = parcelRequire("85acy");

var $g5Uqy = parcelRequire("g5Uqy");

var $FuSTe = parcelRequire("FuSTe");

var $fkf5V = parcelRequire("fkf5V");
function $e8b3ddb65b96dec9$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $e8b3ddb65b96dec9$var$createBorderStyle(prop, transform) {
    return (0, $85acy.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $e8b3ddb65b96dec9$export$1edee58a52776cd9 = $e8b3ddb65b96dec9$var$createBorderStyle('border', $e8b3ddb65b96dec9$export$34e2febe53ae29cc);
const $e8b3ddb65b96dec9$export$f9a7b6bd24892946 = $e8b3ddb65b96dec9$var$createBorderStyle('borderTop', $e8b3ddb65b96dec9$export$34e2febe53ae29cc);
const $e8b3ddb65b96dec9$export$5abca33e6be905d2 = $e8b3ddb65b96dec9$var$createBorderStyle('borderRight', $e8b3ddb65b96dec9$export$34e2febe53ae29cc);
const $e8b3ddb65b96dec9$export$e2ce9f12a980a822 = $e8b3ddb65b96dec9$var$createBorderStyle('borderBottom', $e8b3ddb65b96dec9$export$34e2febe53ae29cc);
const $e8b3ddb65b96dec9$export$47658cca1a909427 = $e8b3ddb65b96dec9$var$createBorderStyle('borderLeft', $e8b3ddb65b96dec9$export$34e2febe53ae29cc);
const $e8b3ddb65b96dec9$export$e7fb0694ba2404fc = $e8b3ddb65b96dec9$var$createBorderStyle('borderColor');
const $e8b3ddb65b96dec9$export$126a92c968acdb85 = $e8b3ddb65b96dec9$var$createBorderStyle('borderTopColor');
const $e8b3ddb65b96dec9$export$85cc51cb8fbb8c0e = $e8b3ddb65b96dec9$var$createBorderStyle('borderRightColor');
const $e8b3ddb65b96dec9$export$340b0327727f6d1a = $e8b3ddb65b96dec9$var$createBorderStyle('borderBottomColor');
const $e8b3ddb65b96dec9$export$60beef91a985b4bf = $e8b3ddb65b96dec9$var$createBorderStyle('borderLeftColor');
const $e8b3ddb65b96dec9$export$f9258c55612cbed7 = $e8b3ddb65b96dec9$var$createBorderStyle('outline', $e8b3ddb65b96dec9$export$34e2febe53ae29cc);
const $e8b3ddb65b96dec9$export$621fe586efeb64b9 = $e8b3ddb65b96dec9$var$createBorderStyle('outlineColor');
const $e8b3ddb65b96dec9$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $FuSTe.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $FuSTe.getValue)(transformer, propValue)
            });
        return (0, $fkf5V.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e8b3ddb65b96dec9$export$7a57f79000377ca2.propTypes = {};
$e8b3ddb65b96dec9$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $e8b3ddb65b96dec9$var$borders = (0, $g5Uqy.default)($e8b3ddb65b96dec9$export$1edee58a52776cd9, $e8b3ddb65b96dec9$export$f9a7b6bd24892946, $e8b3ddb65b96dec9$export$5abca33e6be905d2, $e8b3ddb65b96dec9$export$e2ce9f12a980a822, $e8b3ddb65b96dec9$export$47658cca1a909427, $e8b3ddb65b96dec9$export$e7fb0694ba2404fc, $e8b3ddb65b96dec9$export$126a92c968acdb85, $e8b3ddb65b96dec9$export$85cc51cb8fbb8c0e, $e8b3ddb65b96dec9$export$340b0327727f6d1a, $e8b3ddb65b96dec9$export$60beef91a985b4bf, $e8b3ddb65b96dec9$export$7a57f79000377ca2, $e8b3ddb65b96dec9$export$f9258c55612cbed7, $e8b3ddb65b96dec9$export$621fe586efeb64b9);
var $e8b3ddb65b96dec9$export$2e2bcd8739ae039 = $e8b3ddb65b96dec9$var$borders;

});
parcelRegister("g5Uqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb78e23ea903cd27$export$2e2bcd8739ae039);

var $4hxOJ = parcelRequire("4hxOJ");
function $bb78e23ea903cd27$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $4hxOJ.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $bb78e23ea903cd27$export$2e2bcd8739ae039 = $bb78e23ea903cd27$var$compose;

});


parcelRegister("1f8h4", function(module, exports) {

$parcel$export(module.exports, "gap", () => $0e7d9c3eaddc35f5$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $0e7d9c3eaddc35f5$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $0e7d9c3eaddc35f5$export$8a833ffa5f5dbeda);

var $85acy = parcelRequire("85acy");

var $g5Uqy = parcelRequire("g5Uqy");

var $FuSTe = parcelRequire("FuSTe");

var $fkf5V = parcelRequire("fkf5V");

const $0e7d9c3eaddc35f5$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $FuSTe.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $FuSTe.getValue)(transformer, propValue)
            });
        return (0, $fkf5V.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0e7d9c3eaddc35f5$export$5df9adcb0db95e1e.propTypes = {};
$0e7d9c3eaddc35f5$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $0e7d9c3eaddc35f5$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $FuSTe.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $FuSTe.getValue)(transformer, propValue)
            });
        return (0, $fkf5V.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0e7d9c3eaddc35f5$export$ec60d70ff941a580.propTypes = {};
$0e7d9c3eaddc35f5$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $0e7d9c3eaddc35f5$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $FuSTe.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $FuSTe.getValue)(transformer, propValue)
            });
        return (0, $fkf5V.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0e7d9c3eaddc35f5$export$8a833ffa5f5dbeda.propTypes = {};
$0e7d9c3eaddc35f5$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $0e7d9c3eaddc35f5$export$baf44164ca3a34e8 = (0, $85acy.default)({
    prop: 'gridColumn'
});
const $0e7d9c3eaddc35f5$export$8f7213a1cd01e832 = (0, $85acy.default)({
    prop: 'gridRow'
});
const $0e7d9c3eaddc35f5$export$b0e0abbc49ba668 = (0, $85acy.default)({
    prop: 'gridAutoFlow'
});
const $0e7d9c3eaddc35f5$export$bcd8b929d4b4142 = (0, $85acy.default)({
    prop: 'gridAutoColumns'
});
const $0e7d9c3eaddc35f5$export$e5039a674e14c828 = (0, $85acy.default)({
    prop: 'gridAutoRows'
});
const $0e7d9c3eaddc35f5$export$42bd9088661ffb03 = (0, $85acy.default)({
    prop: 'gridTemplateColumns'
});
const $0e7d9c3eaddc35f5$export$920682ae05b999bc = (0, $85acy.default)({
    prop: 'gridTemplateRows'
});
const $0e7d9c3eaddc35f5$export$1b88fbdd482fd33a = (0, $85acy.default)({
    prop: 'gridTemplateAreas'
});
const $0e7d9c3eaddc35f5$export$bdb486e40d52d26f = (0, $85acy.default)({
    prop: 'gridArea'
});
const $0e7d9c3eaddc35f5$var$grid = (0, $g5Uqy.default)($0e7d9c3eaddc35f5$export$5df9adcb0db95e1e, $0e7d9c3eaddc35f5$export$ec60d70ff941a580, $0e7d9c3eaddc35f5$export$8a833ffa5f5dbeda, $0e7d9c3eaddc35f5$export$baf44164ca3a34e8, $0e7d9c3eaddc35f5$export$8f7213a1cd01e832, $0e7d9c3eaddc35f5$export$b0e0abbc49ba668, $0e7d9c3eaddc35f5$export$bcd8b929d4b4142, $0e7d9c3eaddc35f5$export$e5039a674e14c828, $0e7d9c3eaddc35f5$export$42bd9088661ffb03, $0e7d9c3eaddc35f5$export$920682ae05b999bc, $0e7d9c3eaddc35f5$export$1b88fbdd482fd33a, $0e7d9c3eaddc35f5$export$bdb486e40d52d26f);
var $0e7d9c3eaddc35f5$export$2e2bcd8739ae039 = $0e7d9c3eaddc35f5$var$grid;

});

parcelRegister("5mUnW", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $3e8abebccc227ef9$export$dbaffd4420ea0ac6);

var $85acy = parcelRequire("85acy");

var $g5Uqy = parcelRequire("g5Uqy");
function $3e8abebccc227ef9$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $3e8abebccc227ef9$export$35e9368ef982300f = (0, $85acy.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $3e8abebccc227ef9$export$dbaffd4420ea0ac6
});
const $3e8abebccc227ef9$export$2506f56c10355b33 = (0, $85acy.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $3e8abebccc227ef9$export$dbaffd4420ea0ac6
});
const $3e8abebccc227ef9$export$8c5a050822fd698c = (0, $85acy.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $3e8abebccc227ef9$export$dbaffd4420ea0ac6
});
const $3e8abebccc227ef9$var$palette = (0, $g5Uqy.default)($3e8abebccc227ef9$export$35e9368ef982300f, $3e8abebccc227ef9$export$2506f56c10355b33, $3e8abebccc227ef9$export$8c5a050822fd698c);
var $3e8abebccc227ef9$export$2e2bcd8739ae039 = $3e8abebccc227ef9$var$palette;

});

parcelRegister("dWKxE", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $a274cb5f8267fec4$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $a274cb5f8267fec4$export$488fda99655ff65a);

var $85acy = parcelRequire("85acy");

var $g5Uqy = parcelRequire("g5Uqy");

var $fkf5V = parcelRequire("fkf5V");
function $a274cb5f8267fec4$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $a274cb5f8267fec4$export$7e3df82ee760448c = (0, $85acy.default)({
    prop: 'width',
    transform: $a274cb5f8267fec4$export$8afece71750ec241
});
const $a274cb5f8267fec4$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $fkf5V.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $a274cb5f8267fec4$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $fkf5V.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$a274cb5f8267fec4$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $a274cb5f8267fec4$export$ee148fbbe8357dd2 = (0, $85acy.default)({
    prop: 'minWidth',
    transform: $a274cb5f8267fec4$export$8afece71750ec241
});
const $a274cb5f8267fec4$export$ac607276a8fe9f0a = (0, $85acy.default)({
    prop: 'height',
    transform: $a274cb5f8267fec4$export$8afece71750ec241
});
const $a274cb5f8267fec4$export$dc0d8bd0b94f8570 = (0, $85acy.default)({
    prop: 'maxHeight',
    transform: $a274cb5f8267fec4$export$8afece71750ec241
});
const $a274cb5f8267fec4$export$a43cf604e12f3b17 = (0, $85acy.default)({
    prop: 'minHeight',
    transform: $a274cb5f8267fec4$export$8afece71750ec241
});
const $a274cb5f8267fec4$export$ffed9f14fb65e276 = (0, $85acy.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $a274cb5f8267fec4$export$8afece71750ec241
});
const $a274cb5f8267fec4$export$905076ed6620e671 = (0, $85acy.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $a274cb5f8267fec4$export$8afece71750ec241
});
const $a274cb5f8267fec4$export$6ccc93f785106a58 = (0, $85acy.default)({
    prop: 'boxSizing'
});
const $a274cb5f8267fec4$var$sizing = (0, $g5Uqy.default)($a274cb5f8267fec4$export$7e3df82ee760448c, $a274cb5f8267fec4$export$488fda99655ff65a, $a274cb5f8267fec4$export$ee148fbbe8357dd2, $a274cb5f8267fec4$export$ac607276a8fe9f0a, $a274cb5f8267fec4$export$dc0d8bd0b94f8570, $a274cb5f8267fec4$export$a43cf604e12f3b17, $a274cb5f8267fec4$export$6ccc93f785106a58);
var $a274cb5f8267fec4$export$2e2bcd8739ae039 = $a274cb5f8267fec4$var$sizing;

});



parcelRegister("6hiu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4922ab3f1f5ee220$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $5iHq4 = parcelRequire("5iHq4");
const $4922ab3f1f5ee220$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $5iHq4.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $4922ab3f1f5ee220$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $4922ab3f1f5ee220$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});

parcelRegister("iPcdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $db467842321a5ec0$export$2e2bcd8739ae039);

var $8NnpI = parcelRequire("8NnpI");

var $29cO3 = parcelRequire("29cO3");
'use client';
const $db467842321a5ec0$export$35e57303dbd8a66 = (0, $8NnpI.default)();
function $db467842321a5ec0$var$useTheme(defaultTheme = $db467842321a5ec0$export$35e57303dbd8a66) {
    return (0, $29cO3.default)(defaultTheme);
}
var $db467842321a5ec0$export$2e2bcd8739ae039 = $db467842321a5ec0$var$useTheme;

});
parcelRegister("8NnpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $66750fd06db62b1c$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $b5cOT = parcelRequire("b5cOT");

var $jWad3 = parcelRequire("jWad3");

var $jrZOE = parcelRequire("jrZOE");

var $2YDV9 = parcelRequire("2YDV9");

var $g91qR = parcelRequire("g91qR");

var $5iHq4 = parcelRequire("5iHq4");

var $2PWu5 = parcelRequire("2PWu5");
function $66750fd06db62b1c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $b5cOT.default)(breakpointsInput);
    const spacing = (0, $2YDV9.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $jrZOE.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $jWad3.default)(muiTheme);
    muiTheme.applyStyles = (0, $2PWu5.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $5iHq4.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $g91qR.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $66750fd06db62b1c$export$2e2bcd8739ae039 = $66750fd06db62b1c$var$createTheme;

});
parcelRegister("b5cOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $811a1b1a18519764$export$2e2bcd8739ae039);
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $811a1b1a18519764$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $811a1b1a18519764$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $811a1b1a18519764$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $811a1b1a18519764$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("jrZOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2907d4f90ca619b$export$2e2bcd8739ae039);
const $e2907d4f90ca619b$var$shape = {
    borderRadius: 4
};
var $e2907d4f90ca619b$export$2e2bcd8739ae039 = $e2907d4f90ca619b$var$shape;

});

parcelRegister("2YDV9", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b026ca2499c378$export$2e2bcd8739ae039);

var $FuSTe = parcelRequire("FuSTe");
function $22b026ca2499c378$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $FuSTe.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("2PWu5", function(module, exports) {

$parcel$export(module.exports, "default", () => $210db5f09ad53fd7$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $210db5f09ad53fd7$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("29cO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $19065b157e93c369$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
'use client';
function $19065b157e93c369$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $19065b157e93c369$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $eP9YU.T));
    return !contextTheme || $19065b157e93c369$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $19065b157e93c369$export$2e2bcd8739ae039 = $19065b157e93c369$var$useTheme;

});



parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});

parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $4Gk6P = parcelRequire("4Gk6P");

var $eLI0w = parcelRequire("eLI0w");

var $8v3fy = parcelRequire("8v3fy");
// eslint-disable-next-line consistent-return
function $d5615f18e5cd04fc$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $4Gk6P.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $d5615f18e5cd04fc$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $8v3fy.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $8v3fy.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $eLI0w.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $8gMkr = parcelRequire("8gMkr");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
function $368aaef25f6a2997$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $dzxhF.default).white,
            default: (0, $dzxhF.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $368aaef25f6a2997$export$a43af521ac8c3202 = $368aaef25f6a2997$var$getLight();
function $368aaef25f6a2997$var$getDark() {
    return {
        text: {
            primary: (0, $dzxhF.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $dzxhF.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $368aaef25f6a2997$export$55ce6f3a06c59543 = $368aaef25f6a2997$var$getDark();
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $8gMkr.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $8gMkr.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $8gMkr.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $cpmCj.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $cpmCj.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $368aaef25f6a2997$var$getLight();
    else if (mode === 'dark') modeHydrated = $368aaef25f6a2997$var$getDark();
    const paletteOutput = (0, $3z1Ay.default)({
        // A collection of common colors.
        common: {
            ...(0, $dzxhF.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("8gMkr", function(module, exports) {

$parcel$export(module.exports, "decomposeColor", () => $60554e727ad47a99$export$677b39864803984e);
$parcel$export(module.exports, "private_safeColorChannel", () => $60554e727ad47a99$export$427365fc3db6fc5e);
$parcel$export(module.exports, "recomposeColor", () => $60554e727ad47a99$export$211a73f2b8c10ce4);
$parcel$export(module.exports, "hslToRgb", () => $60554e727ad47a99$export$29fb7152bd3f781a);
$parcel$export(module.exports, "getContrastRatio", () => $60554e727ad47a99$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $60554e727ad47a99$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "private_safeAlpha", () => $60554e727ad47a99$export$34109543fc7f43f8);
$parcel$export(module.exports, "darken", () => $60554e727ad47a99$export$4b073707ff63303);
$parcel$export(module.exports, "private_safeDarken", () => $60554e727ad47a99$export$eaaef2dca3e9e512);
$parcel$export(module.exports, "lighten", () => $60554e727ad47a99$export$c0816ed86df316af);
$parcel$export(module.exports, "private_safeLighten", () => $60554e727ad47a99$export$aeeda94ef1d01275);
$parcel$export(module.exports, "emphasize", () => $60554e727ad47a99$export$e665714f76e581fd);
$parcel$export(module.exports, "private_safeEmphasize", () => $60554e727ad47a99$export$11bb74ba10c85505);

var $cpmCj = parcelRequire("cpmCj");

var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $60554e727ad47a99$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1jJMI.default)(value, min, max);
}
function $60554e727ad47a99$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $60554e727ad47a99$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $60554e727ad47a99$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $60554e727ad47a99$export$677b39864803984e($60554e727ad47a99$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $cpmCj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $cpmCj.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $60554e727ad47a99$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $60554e727ad47a99$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $60554e727ad47a99$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $60554e727ad47a99$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $60554e727ad47a99$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $60554e727ad47a99$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $60554e727ad47a99$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$60554e727ad47a99$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $60554e727ad47a99$export$29fb7152bd3f781a(color) {
    color = $60554e727ad47a99$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $60554e727ad47a99$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $60554e727ad47a99$export$c852d90bf7403b62(color) {
    color = $60554e727ad47a99$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $60554e727ad47a99$export$677b39864803984e($60554e727ad47a99$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $60554e727ad47a99$export$d061e26956a60b0a(foreground, background) {
    const lumA = $60554e727ad47a99$export$c852d90bf7403b62(foreground);
    const lumB = $60554e727ad47a99$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $60554e727ad47a99$export$58f0f39f63f3cf42(color, value) {
    color = $60554e727ad47a99$export$677b39864803984e(color);
    value = $60554e727ad47a99$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $60554e727ad47a99$export$211a73f2b8c10ce4(color);
}
function $60554e727ad47a99$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $60554e727ad47a99$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $60554e727ad47a99$export$4b073707ff63303(color, coefficient) {
    color = $60554e727ad47a99$export$677b39864803984e(color);
    coefficient = $60554e727ad47a99$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $60554e727ad47a99$export$211a73f2b8c10ce4(color);
}
function $60554e727ad47a99$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $60554e727ad47a99$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $60554e727ad47a99$export$c0816ed86df316af(color, coefficient) {
    color = $60554e727ad47a99$export$677b39864803984e(color);
    coefficient = $60554e727ad47a99$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $60554e727ad47a99$export$211a73f2b8c10ce4(color);
}
function $60554e727ad47a99$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $60554e727ad47a99$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $60554e727ad47a99$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $60554e727ad47a99$export$c852d90bf7403b62(color) > 0.5 ? $60554e727ad47a99$export$4b073707ff63303(color, coefficient) : $60554e727ad47a99$export$c0816ed86df316af(color, coefficient);
}
function $60554e727ad47a99$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $60554e727ad47a99$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $60554e727ad47a99$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $60554e727ad47a99$export$677b39864803984e(background);
    const overlayColor = $60554e727ad47a99$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $60554e727ad47a99$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});


parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("eLI0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07976fc01fdfa9$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $2YDV9 = parcelRequire("2YDV9");
var $bzpew = parcelRequire("bzpew");

var $FuSTe = parcelRequire("FuSTe");

var $4kNxA = parcelRequire("4kNxA");
var $lLgYq = parcelRequire("lLgYq");
var $dDX8s = parcelRequire("dDX8s");

var $g91qR = parcelRequire("g91qR");
var $5iHq4 = parcelRequire("5iHq4");

var $8gMkr = parcelRequire("8gMkr");

var $8v3fy = parcelRequire("8v3fy");

var $2JzIB = parcelRequire("2JzIB");

var $fPRn6 = parcelRequire("fPRn6");

var $9yYvT = parcelRequire("9yYvT");

var $2ICMq = parcelRequire("2ICMq");
function $ac07976fc01fdfa9$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $ac07976fc01fdfa9$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $ac07976fc01fdfa9$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $8gMkr.hslToRgb)(color);
}
function $ac07976fc01fdfa9$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $8gMkr.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $ac07976fc01fdfa9$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $ac07976fc01fdfa9$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $ac07976fc01fdfa9$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $bzpew.default)(cssVarPrefix);
function $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $2JzIB.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $8v3fy.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $2JzIB.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $2JzIB.getOverlays)(mode)
    };
    return muiTheme;
}
function $ac07976fc01fdfa9$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $fPRn6.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $ac07976fc01fdfa9$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $cpmCj.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $dDX8s.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $ac07976fc01fdfa9$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#fff');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#000');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $ac07976fc01fdfa9$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', (0, $8gMkr.private_safeDarken)(palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', (0, $8gMkr.private_safeDarken)(palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', (0, $8gMkr.private_safeDarken)(palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', (0, $8gMkr.private_safeDarken)(palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', (0, $8gMkr.private_safeLighten)(palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', (0, $8gMkr.private_safeLighten)(palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', (0, $8gMkr.private_safeLighten)(palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', (0, $8gMkr.private_safeLighten)(palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', (0, $8gMkr.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $8gMkr.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', (0, $8gMkr.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', (0, $8gMkr.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', (0, $8gMkr.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', (0, $8gMkr.private_safeLighten)(palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', (0, $8gMkr.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', (0, $8gMkr.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', (0, $8gMkr.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', (0, $8gMkr.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', (0, $8gMkr.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', (0, $8gMkr.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $8gMkr.private_safeEmphasize)(palette.background.default, 0.8);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $8gMkr.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $8gMkr.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $8gMkr.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', (0, $8gMkr.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', (0, $8gMkr.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', (0, $8gMkr.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', (0, $8gMkr.private_safeLighten)(palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', (0, $8gMkr.private_safeLighten)((0, $8gMkr.private_safeAlpha)(palette.divider, 1), 0.88));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', (0, $8gMkr.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', (0, $8gMkr.private_safeLighten)(palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', (0, $8gMkr.private_safeLighten)(palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', (0, $8gMkr.private_safeLighten)(palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', (0, $8gMkr.private_safeLighten)(palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', (0, $8gMkr.private_safeDarken)(palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', (0, $8gMkr.private_safeDarken)(palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', (0, $8gMkr.private_safeDarken)(palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', (0, $8gMkr.private_safeDarken)(palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', (0, $8gMkr.private_safeDarken)(palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $8gMkr.private_safeDarken)(palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', (0, $8gMkr.private_safeDarken)(palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', (0, $8gMkr.private_safeDarken)(palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', (0, $8gMkr.private_safeDarken)(palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', (0, $8gMkr.private_safeDarken)(palette.warning.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', (0, $8gMkr.private_safeDarken)(palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', (0, $8gMkr.private_safeDarken)(palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', (0, $8gMkr.private_safeDarken)(palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', (0, $8gMkr.private_safeDarken)(palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', (0, $8gMkr.private_safeDarken)(palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', (0, $8gMkr.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $8gMkr.private_safeEmphasize)(palette.background.default, 0.98);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $8gMkr.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $8gMkr.private_safeDarken)(palette.primary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $8gMkr.private_safeDarken)(palette.secondary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', (0, $8gMkr.private_safeDarken)(palette.error.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', (0, $8gMkr.private_safeDarken)(palette.info.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', (0, $8gMkr.private_safeDarken)(palette.success.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', (0, $8gMkr.private_safeDarken)(palette.warning.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', (0, $8gMkr.private_safeDarken)((0, $8gMkr.private_safeAlpha)(palette.divider, 1), 0.68));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', (0, $8gMkr.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'paper');
        $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'background');
        $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'onBackground');
        $ac07976fc01fdfa9$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $ac07976fc01fdfa9$var$setColor(palette[color], 'mainChannel', (0, $8gMkr.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.main)));
                if (colors.light) $ac07976fc01fdfa9$var$setColor(palette[color], 'lightChannel', (0, $8gMkr.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.light)));
                if (colors.dark) $ac07976fc01fdfa9$var$setColor(palette[color], 'darkChannel', (0, $8gMkr.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.dark)));
                if (colors.contrastText) $ac07976fc01fdfa9$var$setColor(palette[color], 'contrastTextChannel', (0, $8gMkr.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'primary');
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $9yYvT.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $lLgYq.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $2YDV9.default)(input.spacing, (0, $FuSTe.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $4kNxA.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $5iHq4.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $g91qR.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $2ICMq.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("bzpew", function(module, exports) {

$parcel$export(module.exports, "default", () => $86c68965abccb6a9$export$2e2bcd8739ae039);
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $86c68965abccb6a9$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("4kNxA", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", () => $327f75756f04f3b6$export$858538ff6c0d421d);
/* eslint-disable import/prefer-default-export */ function $327f75756f04f3b6$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("lLgYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd7b2759a3ac0441$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $evrHn = parcelRequire("evrHn");
function $fd7b2759a3ac0441$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $evrHn.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $evrHn.default)(scheme, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $evrHn.default)(defaultScheme, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3z1Ay.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $fd7b2759a3ac0441$export$2e2bcd8739ae039 = $fd7b2759a3ac0441$var$prepareCssVars;

});
parcelRegister("evrHn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8f9724956a5e42a$export$2e2bcd8739ae039);
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $a8f9724956a5e42a$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $a8f9724956a5e42a$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $a8f9724956a5e42a$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $a8f9724956a5e42a$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $a8f9724956a5e42a$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $a8f9724956a5e42a$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $a8f9724956a5e42a$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $a8f9724956a5e42a$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("dDX8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eecc9ee752db50d$export$2e2bcd8739ae039);
function $9eecc9ee752db50d$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("8v3fy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6303bd594dbbe1c5$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $g91qR = parcelRequire("g91qR");
var $5iHq4 = parcelRequire("5iHq4");

var $8NnpI = parcelRequire("8NnpI");


var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");

var $2ICMq = parcelRequire("2ICMq");
function $6303bd594dbbe1c5$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $cpmCj.default)(20));
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $8NnpI.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: {
            ...(0, $lhXgK.default)
        }
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $5iHq4.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $g91qR.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $2ICMq.stringifyTheme); // for Pigment CSS integration
    return muiTheme;
}
let $6303bd594dbbe1c5$var$warnedOnce = false;
function $6303bd594dbbe1c5$export$c469355549431d9b(...args) {
    return $6303bd594dbbe1c5$var$createThemeNoVars(...args);
}
var $6303bd594dbbe1c5$export$2e2bcd8739ae039 = $6303bd594dbbe1c5$var$createThemeNoVars;

});
parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
                letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3z1Ay.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "duration", () => $845514f3678d3888$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$845514f3678d3888$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$845514f3678d3888$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});

parcelRegister("2ICMq", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", () => $1fadc5be6a14f8c8$export$32c2afa5f91892aa);
/* eslint-disable import/prefer-default-export */ 
var $3z1Ay = parcelRequire("3z1Ay");
function $1fadc5be6a14f8c8$var$isSerializable(val) {
    return (0, $3z1Ay.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $1fadc5be6a14f8c8$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$1fadc5be6a14f8c8$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $3z1Ay.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("2JzIB", function(module, exports) {

$parcel$export(module.exports, "getOpacity", () => $1fdb7dab8864519b$export$c85e0347fceb69ba);
$parcel$export(module.exports, "getOverlays", () => $1fdb7dab8864519b$export$dd191566510330d3);
$parcel$export(module.exports, "default", () => $1fdb7dab8864519b$export$2e2bcd8739ae039);

var $4Gk6P = parcelRequire("4Gk6P");

var $35vyj = parcelRequire("35vyj");
const $1fdb7dab8864519b$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $35vyj.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $1fdb7dab8864519b$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $1fdb7dab8864519b$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $1fdb7dab8864519b$var$defaultDarkOverlays : [];
}
function $1fdb7dab8864519b$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $4Gk6P.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$1fdb7dab8864519b$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $1fdb7dab8864519b$export$dd191566510330d3(palette.mode),
        ...rest
    };
}

});
parcelRegister("35vyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $23fa506264c010ed$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $23fa506264c010ed$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("fPRn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b87504e8f71bd950$export$2e2bcd8739ae039);
function $b87504e8f71bd950$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("9yYvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f663abbabfb57a0$export$2e2bcd8739ae039);

var $kKEhy = parcelRequire("kKEhy");
var $6f663abbabfb57a0$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $kKEhy.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("kKEhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1b759b2363a287f$export$2e2bcd8739ae039);
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $f1b759b2363a287f$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $f1b759b2363a287f$export$2e2bcd8739ae039 = $f1b759b2363a287f$var$excludeVariablesFromRoot;

});




parcelRegister("4jPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3250d9bb994a2d02$export$2e2bcd8739ae039);
var $3250d9bb994a2d02$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("hOwN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf808af3a1d339c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");
const $cf808af3a1d339c9$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$export$2e2bcd8739ae039 = $cf808af3a1d339c9$var$boxClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});




parcelRegister("6lXkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a02bab8c70a697b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $5A6d3 = parcelRequire("5A6d3");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $2cPwN = parcelRequire("2cPwN");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $1xAC3 = parcelRequire("1xAC3");

var $bwtSM = parcelRequire("bwtSM");

var $3eDio = parcelRequire("3eDio");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $jTnBY.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $1xAC3.getButtonUtilityClass), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $4a02bab8c70a697b$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $1xAC3.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $1xAC3.default).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $1xAC3.default).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $1xAC3.default).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $8gMkr.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1xAC3.default).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1xAC3.default).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $1xAC3.default).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$4a02bab8c70a697b$var$commonIconStyles
        ]
    }));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$4a02bab8c70a697b$var$commonIconStyles
        ]
    }));
const $4a02bab8c70a697b$var$ButtonLoadingIndicator = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder',
    overridesResolver: (props, styles)=>styles.loadingIconPlaceholder
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $bwtSM.default));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $3eDio.default));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $5A6d3.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ayMG0.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;

});
parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});

parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("5A6d3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4105219ee6538ed1$export$2e2bcd8739ae039);

var $auC0X = parcelRequire("auC0X");
'use client';
var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $auC0X.default);

});
parcelRegister("auC0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3a319e7e555608$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $7a3a319e7e555608$var$safeReact = {
    ...$acw62
};
const $7a3a319e7e555608$var$maybeReactUseId = $7a3a319e7e555608$var$safeReact.useId;
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}

});


parcelRegister("8Uq77", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7cf568a060c3d$export$2e2bcd8739ae039);

var $PJRTc = parcelRequire("PJRTc");
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$export$2e2bcd8739ae039 = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b8580029d7f562$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$export$2e2bcd8739ae039 = $09b8580029d7f562$var$slotShouldForwardProp;

});


parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);

var $6LgWo = parcelRequire("6LgWo");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $8Uq77 = parcelRequire("8Uq77");

'use client';
const $0277c5e26ff0d56c$var$styled = (0, $6LgWo.default)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $8Uq77.default
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("6LgWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec445f14e3546d2$export$2e2bcd8739ae039);

var $5C8IU = parcelRequire("5C8IU");

var $3z1Ay = parcelRequire("3z1Ay");

var $gxvzd = parcelRequire("gxvzd");

var $eWm0o = parcelRequire("eWm0o");

var $8NnpI = parcelRequire("8NnpI");

var $g91qR = parcelRequire("g91qR");

var $cy0UO = parcelRequire("cy0UO");
const $4ec445f14e3546d2$export$35e57303dbd8a66 = (0, $8NnpI.default)();
function $4ec445f14e3546d2$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $4ec445f14e3546d2$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $4ec445f14e3546d2$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $4ec445f14e3546d2$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $4ec445f14e3546d2$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $4ec445f14e3546d2$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$4ec445f14e3546d2$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $4ec445f14e3546d2$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $4ec445f14e3546d2$var$shallowLayer((0, $5C8IU.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $4ec445f14e3546d2$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $4ec445f14e3546d2$var$shallowLayer((0, $5C8IU.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $4ec445f14e3546d2$var$shallowLayer((0, $5C8IU.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $4ec445f14e3546d2$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $4ec445f14e3546d2$var$shallowLayer((0, $5C8IU.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $4ec445f14e3546d2$var$shallowLayer((0, $5C8IU.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $4ec445f14e3546d2$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $4ec445f14e3546d2$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $4ec445f14e3546d2$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $4ec445f14e3546d2$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $4ec445f14e3546d2$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $5C8IU.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $g91qR.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $4ec445f14e3546d2$var$defaultOverridesResolver($4ec445f14e3546d2$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $4ec445f14e3546d2$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($4ec445f14e3546d2$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5C8IU.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $4ec445f14e3546d2$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $4ec445f14e3546d2$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $3z1Ay.isPlainObject)(style)) {
                const serialized = (0, $cy0UO.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $4ec445f14e3546d2$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $4ec445f14e3546d2$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $4ec445f14e3546d2$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $4ec445f14e3546d2$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $g91qR.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $4ec445f14e3546d2$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $gxvzd.default)(componentSlot || '')}`;
    return `Styled(${(0, $eWm0o.default)(tag)})`;
}
function $4ec445f14e3546d2$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $4ec445f14e3546d2$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $4ec445f14e3546d2$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $4ec445f14e3546d2$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("eWm0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $19Aa2 = parcelRequire("19Aa2");
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $19Aa2.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $19Aa2.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("cy0UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $92295ec3af72de9b$export$2e2bcd8739ae039);

var $5C8IU = parcelRequire("5C8IU");
function $92295ec3af72de9b$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $5C8IU.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $5C8IU.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
'use client';
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});


parcelRegister("aeD7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $77398f38c6229912$export$2e2bcd8739ae039);

var $ejHnT = parcelRequire("ejHnT");
const $77398f38c6229912$var$memoTheme = (0, $ejHnT.default);
var $77398f38c6229912$export$2e2bcd8739ae039 = $77398f38c6229912$var$memoTheme;

});
parcelRegister("ejHnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6c47e4953832cbf$export$2e2bcd8739ae039);

var $cy0UO = parcelRequire("cy0UO");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $a6c47e4953832cbf$var$arg = {
    theme: undefined
};
function $a6c47e4953832cbf$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $a6c47e4953832cbf$var$arg.theme = props.theme;
            value = (0, $cy0UO.default)(styleFn($a6c47e4953832cbf$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("1iOpW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f2e94b8fca67639$export$2440da353cedad43);
parcelRequire("acw62");


var $3vMLS = parcelRequire("3vMLS");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3vMLS.default), {
        ...props
    });
}
var $0f2e94b8fca67639$export$2e2bcd8739ae039 = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$export$2440da353cedad43(params) {
    return (0, $3vMLS.useDefaultProps)(params);
}

});
parcelRegister("3vMLS", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $28ea194fe257804a$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $28ea194fe257804a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $28ea194fe257804a$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $28ea194fe257804a$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28ea194fe257804a$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $28ea194fe257804a$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props);
    return props;
}
function $28ea194fe257804a$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($28ea194fe257804a$var$PropsContext);
    return $28ea194fe257804a$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $28ea194fe257804a$export$2e2bcd8739ae039 = $28ea194fe257804a$var$DefaultPropsProvider;

});


parcelRegister("6n0Ko", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a35786d89db9dda$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $52FI1 = parcelRequire("52FI1");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $9Rgf1 = parcelRequire("9Rgf1");

var $4o7uD = parcelRequire("4o7uD");

var $ju2Oo = parcelRequire("ju2Oo");

var $brF9L = parcelRequire("brF9L");

var $5JO1P = parcelRequire("5JO1P");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5JO1P.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $5JO1P.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $acw62.useRef(null);
    const ripple = (0, $ju2Oo.default)();
    const handleRippleRef = (0, $9Rgf1.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $4a35786d89db9dda$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $4a35786d89db9dda$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $52FI1.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4o7uD.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $52FI1.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $4o7uD.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $4o7uD.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $9Rgf1.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brF9L.default), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $4a35786d89db9dda$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $4o7uD.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;

});
parcelRegister("52FI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3abd7e3358fc5f35$export$2e2bcd8739ae039);
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $3abd7e3358fc5f35$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("9Rgf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d5a979b2ad8bc9$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");
'use client';
var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $3qSdM.default);

});
parcelRegister("3qSdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $27fddc0219860a83$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $acw62.useRef(undefined);
    const refEffect = $acw62.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("4o7uD", function(module, exports) {

$parcel$export(module.exports, "default", () => $331f3746e6346411$export$2e2bcd8739ae039);

var $13KXh = parcelRequire("13KXh");
'use client';
var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $13KXh.default);

});
parcelRegister("13KXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5a7e8ccbc07697$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $eEJPp.default)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;

});
parcelRegister("eEJPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab859a020ad749e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;

});



parcelRegister("ju2Oo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2f30007e7be7ff3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $iYIN2 = parcelRequire("iYIN2");
'use client';
class $e2f30007e7be7ff3$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $e2f30007e7be7ff3$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $iYIN2.default)($e2f30007e7be7ff3$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $acw62.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $acw62.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $e2f30007e7be7ff3$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $e2f30007e7be7ff3$export$2e2bcd8739ae039() {
    return $e2f30007e7be7ff3$export$f5de0641c7db4154.use();
}
function $e2f30007e7be7ff3$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("iYIN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1092ee97d527c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("brF9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $855224273a002a0f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $jEvxL = parcelRequire("jEvxL");

var $9QePP = parcelRequire("9QePP");

var $lHOu3 = parcelRequire("lHOu3");

var $jjlaj = parcelRequire("jjlaj");
var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $hruNq = parcelRequire("hruNq");

var $a4Mf7 = parcelRequire("a4Mf7");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $jjlaj.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $855224273a002a0f$var$exitKeyframe = (0, $jjlaj.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $855224273a002a0f$var$pulsateKeyframe = (0, $jjlaj.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $hruNq.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $a4Mf7.default).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$855224273a002a0f$var$enterKeyframe};
    animation-duration: ${$855224273a002a0f$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $a4Mf7.default).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $a4Mf7.default).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $a4Mf7.default).childLeaving} {
    opacity: 0;
    animation-name: ${$855224273a002a0f$var$exitKeyframe};
    animation-duration: ${$855224273a002a0f$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $a4Mf7.default).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$855224273a002a0f$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $lHOu3.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $a4Mf7.default).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $a4Mf7.default).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $a4Mf7.default).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $a4Mf7.default).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $a4Mf7.default).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $a4Mf7.default).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, {
        className: (0, $9QePP.default)((0, $a4Mf7.default).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEvxL.default), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;

});
parcelRegister("jEvxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ea38a8b431e8fc$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $6xlZQ = parcelRequire("6xlZQ");

var $n2pn1 = parcelRequire("n2pn1");
var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hDpcU.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $n2pn1.getInitialChildMapping)(nextProps, handleExited) : (0, $n2pn1.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $n2pn1.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("n2pn1", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $04540450bf60efa1$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $04540450bf60efa1$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $04540450bf60efa1$export$36fd1af28d383ec0);

var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("lHOu3", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $fcd4c6205d65c7df$export$786b4da70f00938b);
$parcel$export(module.exports, "default", () => $fcd4c6205d65c7df$export$2e2bcd8739ae039);

var $iYIN2 = parcelRequire("iYIN2");

var $dOphX = parcelRequire("dOphX");
'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $iYIN2.default)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $dOphX.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("dOphX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e38fa988f617e0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("hruNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2cd8c78d72bd92$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;

});

parcelRegister("a4Mf7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getTouchRippleUtilityClass", () => $755fb323846f60d4$export$b464606f735ab902);
$parcel$export(module.exports, "default", () => $755fb323846f60d4$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $beCSm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;

});


parcelRegister("5JO1P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getButtonBaseUtilityClass", () => $42d7f65840078ec1$export$fccb0498dcd99783);
$parcel$export(module.exports, "default", () => $42d7f65840078ec1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $beCSm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;

});


parcelRegister("2cPwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b4ac261663afa8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $fPJfA = parcelRequire("fPJfA");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $jjlaj.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $jjlaj.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $19b4ac261663afa8$var$rotateAnimation = typeof $19b4ac261663afa8$var$circularRotateKeyframe !== 'string' ? (0, $jjlaj.css)`
        animation: ${$19b4ac261663afa8$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $19b4ac261663afa8$var$dashAnimation = typeof $19b4ac261663afa8$var$circularDashKeyframe !== 'string' ? (0, $jjlaj.css)`
        animation: ${$19b4ac261663afa8$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fPJfA.getCircularProgressUtilityClass), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $19b4ac261663afa8$var$rotateAnimation || {
                    animation: `${$19b4ac261663afa8$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $19b4ac261663afa8$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$19b4ac261663afa8$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;

});
parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("1Anyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $127b6c47a683862d$export$2e2bcd8739ae039);
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $127b6c47a683862d$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $127b6c47a683862d$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$127b6c47a683862d$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $127b6c47a683862d$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $127b6c47a683862d$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("fPJfA", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", () => $b86eb8364bb4993c$export$29cad1383b3f235d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $beCSm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;

});


parcelRegister("1xAC3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getButtonUtilityClass", () => $11f546081ba06ace$export$5a6f9035944c8119);
$parcel$export(module.exports, "default", () => $11f546081ba06ace$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $beCSm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;

});

parcelRegister("bwtSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8639dcef822d5d4c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;

});

parcelRegister("3eDio", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b1293270900846$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $25b1293270900846$export$2e2bcd8739ae039 = $25b1293270900846$var$ButtonGroupButtonContext;

});


parcelRegister("6MV2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f13784bd714c44e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");

var $jTnBY = parcelRequire("jTnBY");

var $118QM = parcelRequire("118QM");

var $86f4a = parcelRequire("86f4a");

var $7Frhn = parcelRequire("7Frhn");

var $gX5bM = parcelRequire("gX5bM");

var $8W68d = parcelRequire("8W68d");

var $6cr7d = parcelRequire("6cr7d");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4f13784bd714c44e$var$DialogBackdrop = (0, $d8seH.default)((0, $6cr7d.default), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $jTnBY.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $jTnBY.default)(scroll)}`,
            `paperWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $gX5bM.getDialogUtilityClass), classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $d8seH.default)((0, $118QM.default), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $d8seH.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $jTnBY.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $4f13784bd714c44e$var$DialogPaper = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $jTnBY.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $14H9o.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $7Frhn.default), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $86f4a.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $auC0X.default)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        elementType: $4f13784bd714c44e$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $6lpak.default)('backdrop', {
        elementType: $4f13784bd714c44e$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $6lpak.default)('paper', {
        elementType: $4f13784bd714c44e$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $6lpak.default)('container', {
        elementType: $4f13784bd714c44e$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.container)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $86f4a.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8W68d.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $4f13784bd714c44e$export$2e2bcd8739ae039 = $4f13784bd714c44e$var$Dialog;

});
parcelRegister("118QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdcbfecdf3275a2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kRwxQ = parcelRequire("kRwxQ");

var $2Q995 = parcelRequire("2Q995");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6cr7d = parcelRequire("6cr7d");

var $lkowv = parcelRequire("lkowv");

var $16KGQ = parcelRequire("16KGQ");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $16KGQ.getModalUtilityClass), classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $6cr7d.default), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $lkowv.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $0bdcbfecdf3275a2$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $6lpak.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $9QePP.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q995.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kRwxQ.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;

});
parcelRegister("kRwxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f30200a1e85b3f20$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $2xc7G = parcelRequire("2xc7G");
var $6zeBo = parcelRequire("6zeBo");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)((0, $2xc7G.default)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $f30200a1e85b3f20$export$2e2bcd8739ae039 = $f30200a1e85b3f20$var$FocusTrap;

});
parcelRegister("2xc7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d88113360503233$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});

parcelRegister("6zeBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8156a231c9130b$export$2e2bcd8739ae039);
function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});


parcelRegister("2Q995", function(module, exports) {

$parcel$export(module.exports, "default", () => $2117883cc21a32b2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $2xc7G = parcelRequire("2xc7G");
var $hervl = parcelRequire("hervl");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");
'use client';
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v6.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v6.mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $3qSdM.default)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $2xc7G.default)(children) : null, forwardedRef);
    (0, $eEJPp.default)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $eEJPp.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $hervl.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $hervl.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $1u0KT.createPortal(children, mountNode) : mountNode;
});
var $2117883cc21a32b2$export$2e2bcd8739ae039 = $2117883cc21a32b2$var$Portal;

});
parcelRegister("hervl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b9145416f64bb2$export$2e2bcd8739ae039);
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("6cr7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $4838e5a14e330013$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6lpak = parcelRequire("6lpak");

var $86f4a = parcelRequire("86f4a");

var $7ViEK = parcelRequire("7ViEK");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7ViEK.getBackdropUtilityClass), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $4838e5a14e330013$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $86f4a.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;

});
parcelRegister("6lpak", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e8399bd2388464$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $8bslU = parcelRequire("8bslU");

var $1ESci = parcelRequire("1ESci");
'use client';
function $49e8399bd2388464$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $8bslU.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $1ESci.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $gEUd4.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("gEUd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20bfbd9e98e2eff$export$2e2bcd8739ae039);

var $awhpc = parcelRequire("awhpc");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $awhpc.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;

});
parcelRegister("awhpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8a64e8a5211ee5$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;

});


parcelRegister("8bslU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5557fdc8e8d8fa$export$2e2bcd8739ae039);
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;

});

parcelRegister("1ESci", function(module, exports) {

$parcel$export(module.exports, "default", () => $135391549c807611$export$2e2bcd8739ae039);

var $9QePP = parcelRequire("9QePP");

var $f56pe = parcelRequire("f56pe");

var $5nUQA = parcelRequire("5nUQA");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $9QePP.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f56pe.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $5nUQA.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $5nUQA.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $9QePP.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;

});
parcelRegister("f56pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $afac4abdaa8d83ea$export$2e2bcd8739ae039);
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;

});

parcelRegister("5nUQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebb326a10a78a15$export$2e2bcd8739ae039);
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;

});



parcelRegister("86f4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5a92158e7d9bd4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $1mPeS = parcelRequire("1mPeS");


var $2xc7G = parcelRequire("2xc7G");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $14H9o.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(nodeRef, (0, $2xc7G.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$5e5a92158e7d9bd4$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;

});
parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");


var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("14H9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c87a2f38cd49c7a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $iPcdL = parcelRequire("iPcdL");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $iPcdL.default)((0, $jR9F1.default));
    return theme[0, $4jPsi.default] || theme;
}

});

parcelRegister("hweuE", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $cc10aae84e3e4b9c$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $cc10aae84e3e4b9c$export$8cb1e9b404609ae9);
const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});


parcelRegister("7ViEK", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", () => $5c4c540114ae85ab$export$9927a91fd93152bd);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $beCSm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;

});


parcelRegister("lkowv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86e7d122c1fa324$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hPGQj = parcelRequire("hPGQj");
var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $f56pe = parcelRequire("f56pe");

var $75CP6 = parcelRequire("75CP6");
'use client';
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $f86e7d122c1fa324$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$manager = new (0, $75CP6.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $6zeBo.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $f86e7d122c1fa324$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $13KXh.default)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        $f86e7d122c1fa324$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$f86e7d122c1fa324$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $13KXh.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $75CP6.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        $f86e7d122c1fa324$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f56pe.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $hPGQj.default)(handleEnter, children?.props.onEnter ?? $f86e7d122c1fa324$var$noop),
            onExited: (0, $hPGQj.default)(handleExited, children?.props.onExited ?? $f86e7d122c1fa324$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$export$2e2bcd8739ae039 = $f86e7d122c1fa324$var$useModal;

});
parcelRegister("hPGQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb86ebe4ea00eb7$export$2e2bcd8739ae039);
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("75CP6", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $52971d86e2bcd483$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "ModalManager", () => $52971d86e2bcd483$export$ce11c4ecd08cea67);

var $aF4kJ = parcelRequire("aF4kJ");
var $6zeBo = parcelRequire("6zeBo");
var $9KvVX = parcelRequire("9KvVX");
// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $6zeBo.default)(container);
    if (doc.body === container) return (0, $9KvVX.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseInt((0, $9KvVX.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$export$e1bd0c6150f13d96(element, hide);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $aF4kJ.default)((0, $9KvVX.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $6zeBo.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $6zeBo.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $9KvVX.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $52971d86e2bcd483$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});
parcelRegister("aF4kJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0200cab69b9251c8$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});

parcelRegister("9KvVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $71912e551e227707$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $6zeBo.default)(node);
    return doc.defaultView || window;
}

});



parcelRegister("16KGQ", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", () => $0cea91a79e26c98a$export$67960e22b12a638d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0cea91a79e26c98a$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $beCSm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$export$2e2bcd8739ae039 = $0cea91a79e26c98a$var$modalClasses;

});


parcelRegister("7Frhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $595185d0d7275c3b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $35vyj = parcelRequire("35vyj");

var $6LfkK = parcelRequire("6LfkK");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6LfkK.getPaperUtilityClass), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $14H9o.default)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $8gMkr.alpha)('#fff', (0, $35vyj.default)(elevation))}, ${(0, $8gMkr.alpha)('#fff', (0, $35vyj.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;

});
parcelRegister("6LfkK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getPaperUtilityClass", () => $4ec306d48089c2c9$export$29cdb466b9b6f20b);
$parcel$export(module.exports, "default", () => $4ec306d48089c2c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $beCSm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;

});


parcelRegister("gX5bM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getDialogUtilityClass", () => $c5762e789acf7dcc$export$2177af0aa15c34c2);
$parcel$export(module.exports, "default", () => $c5762e789acf7dcc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c5762e789acf7dcc$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)('MuiDialog', slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $beCSm.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $c5762e789acf7dcc$export$2e2bcd8739ae039 = $c5762e789acf7dcc$var$dialogClasses;

});

parcelRegister("8W68d", function(module, exports) {

$parcel$export(module.exports, "default", () => $68187f174395cd28$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $68187f174395cd28$export$2e2bcd8739ae039 = $68187f174395cd28$var$DialogContext;

});


parcelRegister("2MUlQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $207bc6ab7c60f4b2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $4ZLz5 = parcelRequire("4ZLz5");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4ZLz5.getDialogActionsUtilityClass), classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $207bc6ab7c60f4b2$export$2e2bcd8739ae039 = $207bc6ab7c60f4b2$var$DialogActions;

});
parcelRegister("4ZLz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getDialogActionsUtilityClass", () => $3a31c1516a2c01e5$export$5e57a444791c63be);
$parcel$export(module.exports, "default", () => $3a31c1516a2c01e5$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3a31c1516a2c01e5$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)('MuiDialogActions', slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $beCSm.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3a31c1516a2c01e5$export$2e2bcd8739ae039 = $3a31c1516a2c01e5$var$dialogActionsClasses;

});


parcelRegister("6Q1H5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa8e9c420cdee0a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $hd5xz = parcelRequire("hd5xz");

var $kQXVi = parcelRequire("kQXVi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hd5xz.getDialogContentUtilityClass), classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $kQXVi.default).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $4fa8e9c420cdee0a$export$2e2bcd8739ae039 = $4fa8e9c420cdee0a$var$DialogContent;

});
parcelRegister("hd5xz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getDialogContentUtilityClass", () => $c877f2cebcabf5cb$export$61b0ee1f05fb344e);
$parcel$export(module.exports, "default", () => $c877f2cebcabf5cb$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c877f2cebcabf5cb$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)('MuiDialogContent', slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $beCSm.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c877f2cebcabf5cb$export$2e2bcd8739ae039 = $c877f2cebcabf5cb$var$dialogContentClasses;

});

parcelRegister("kQXVi", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", () => $f2e7257b2514744a$export$f5d2ec7e4c47e088);
$parcel$export(module.exports, "default", () => $f2e7257b2514744a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f2e7257b2514744a$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)('MuiDialogTitle', slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $beCSm.default)('MuiDialogTitle', [
    'root'
]);
var $f2e7257b2514744a$export$2e2bcd8739ae039 = $f2e7257b2514744a$var$dialogTitleClasses;

});


parcelRegister("ejcfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6ac58aca374c76c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $kQXVi = parcelRequire("kQXVi");

var $8W68d = parcelRequire("8W68d");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a6ac58aca374c76c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kQXVi.getDialogTitleUtilityClass), classes);
};
const $a6ac58aca374c76c$var$DialogTitleRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $a6ac58aca374c76c$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $a6ac58aca374c76c$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $acw62.useContext((0, $8W68d.default));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6ac58aca374c76c$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $a6ac58aca374c76c$export$2e2bcd8739ae039 = $a6ac58aca374c76c$var$DialogTitle;

});
parcelRegister("3bYfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2531239e3a525689$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aAbgT = parcelRequire("aAbgT");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $bhKtZ = parcelRequire("bhKtZ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2531239e3a525689$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $2531239e3a525689$var$extendSxProp = (0, $aAbgT.internal_createExtendSxProp)();
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bhKtZ.getTypographyUtilityClass), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $jTnBY.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$2531239e3a525689$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $2531239e3a525689$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;

});
parcelRegister("aAbgT", function(module, exports) {

$parcel$export(module.exports, "globalCss", () => $7b460279bb5c09c1$export$db53682eef82cc11);
$parcel$export(module.exports, "internal_createExtendSxProp", () => $7b460279bb5c09c1$export$7e7f5719ff4debb1);
parcelRequire("acw62");

var $6hiu6 = parcelRequire("6hiu6");

var $14H9o = parcelRequire("14H9o");

var $ldx2z = parcelRequire("ldx2z");

var $ayMG0 = parcelRequire("ayMG0");

var $jjlaj = parcelRequire("jjlaj");

var $d8seH = parcelRequire("d8seH");
function $7b460279bb5c09c1$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ayMG0.jsx)((0, $ldx2z.default), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $7b460279bb5c09c1$export$7e7f5719ff4debb1() {
    return 0, $6hiu6.default;
}

});
parcelRegister("ldx2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $03fc756f7adfd498$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $945hh = parcelRequire("945hh");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $945hh.default), {
        ...props,
        defaultTheme: (0, $jR9F1.default),
        themeId: (0, $4jPsi.default)
    });
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;

});
parcelRegister("945hh", function(module, exports) {

$parcel$export(module.exports, "default", () => $699894d3e78e9c81$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $aVZKi = parcelRequire("aVZKi");
var $5C8IU = parcelRequire("5C8IU");

var $iPcdL = parcelRequire("iPcdL");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $699894d3e78e9c81$var$wrapGlobalLayer(styles) {
    const serialized = (0, $5C8IU.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $699894d3e78e9c81$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $iPcdL.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $699894d3e78e9c81$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $699894d3e78e9c81$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $699894d3e78e9c81$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVZKi.default), {
        styles: globalStyles
    });
}
var $699894d3e78e9c81$export$2e2bcd8739ae039 = $699894d3e78e9c81$var$GlobalStyles;

});



parcelRegister("bhKtZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getTypographyUtilityClass", () => $837556bdf75d281f$export$24c1f8f60cbac79e);
$parcel$export(module.exports, "default", () => $837556bdf75d281f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $beCSm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;

});



parcelRegister("lkxXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f875d00b2138afe4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $cbVYE = parcelRequire("cbVYE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cbVYE.getDividerUtilityClass), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $8gMkr.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($f875d00b2138afe4$var$Divider) $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;

});
parcelRegister("cbVYE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getDividerUtilityClass", () => $024a60f892d3fa61$export$46f01d01378ec5a2);
$parcel$export(module.exports, "default", () => $024a60f892d3fa61$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $beCSm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;

});


parcelRegister("30UGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $231d58234d437bc0$export$2e2bcd8739ae039);


var $28s05 = parcelRequire("28s05");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $231d58234d437bc0$var$Stack = (0, $28s05.default)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $231d58234d437bc0$export$2e2bcd8739ae039 = $231d58234d437bc0$var$Stack;

});
parcelRegister("28s05", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e20c6a989db8b9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $bPDWy = parcelRequire("bPDWy");

var $7qEX0 = parcelRequire("7qEX0");

var $6hiu6 = parcelRequire("6hiu6");

var $8NnpI = parcelRequire("8NnpI");

var $fkf5V = parcelRequire("fkf5V");

var $FuSTe = parcelRequire("FuSTe");

var $ayMG0 = parcelRequire("ayMG0");
const $18e20c6a989db8b9$var$defaultTheme = (0, $8NnpI.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $18e20c6a989db8b9$var$defaultCreateStyledComponent = (0, $bPDWy.default)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $18e20c6a989db8b9$var$useThemePropsDefault(props) {
    return (0, $7qEX0.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $18e20c6a989db8b9$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $18e20c6a989db8b9$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $18e20c6a989db8b9$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $18e20c6a989db8b9$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $fkf5V.handleBreakpoints)({
            theme: theme
        }, (0, $fkf5V.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $FuSTe.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $fkf5V.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $fkf5V.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $FuSTe.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$18e20c6a989db8b9$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $FuSTe.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $fkf5V.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $fkf5V.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $18e20c6a989db8b9$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $18e20c6a989db8b9$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $18e20c6a989db8b9$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($18e20c6a989db8b9$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $6hiu6.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            children: divider ? $18e20c6a989db8b9$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});
parcelRegister("bPDWy", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d3711065c3823f$export$2e2bcd8739ae039);

var $6LgWo = parcelRequire("6LgWo");
const $89d3711065c3823f$var$styled = (0, $6LgWo.default)();
var $89d3711065c3823f$export$2e2bcd8739ae039 = $89d3711065c3823f$var$styled;

});

parcelRegister("7qEX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $568aba12ccdf91ea$export$2e2bcd8739ae039);

var $5BtxM = parcelRequire("5BtxM");

var $iPcdL = parcelRequire("iPcdL");
'use client';
function $568aba12ccdf91ea$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $iPcdL.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $5BtxM.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("5BtxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $414753394dff993c$export$2e2bcd8739ae039);

var $4FZD0 = parcelRequire("4FZD0");
function $414753394dff993c$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}

});




parcelRegister("g5N8Q", function(module, exports) {

$parcel$export(module.exports, "BLURPLE", () => $414e0eb9db3901b6$export$33221d931a21476f);
$parcel$export(module.exports, "ThemeContainer", () => $414e0eb9db3901b6$export$11eb671888ed6e7d);

var $ayMG0 = parcelRequire("ayMG0");

var $ijOKP = parcelRequire("ijOKP");
var $gODrq = parcelRequire("gODrq");
var $gRp5N = parcelRequire("gRp5N");

var $acw62 = parcelRequire("acw62");

var $kfwWK = parcelRequire("kfwWK");

var $fC0pb = parcelRequire("fC0pb");
const $414e0eb9db3901b6$export$33221d931a21476f = {
    main: "#635bff",
    light: "#e8e5ff",
    hover: "#d5d0ff",
    dark: "#4f3bff",
    contrastText: "#ffffff"
};
// Create theme based on mode (light/dark)
const $414e0eb9db3901b6$var$createAppTheme = (mode)=>(0, $ijOKP.default)({
        palette: {
            mode: mode,
            primary: {
                main: mode === 'dark' ? "#FFFFFF" : "#000000"
            },
            secondary: {
                main: "#23967F"
            },
            info: {
                main: "#d7d7d7"
            },
            success: {
                main: "#3c6ce9"
            },
            warning: {
                main: "#f5c25c"
            },
            background: mode === 'dark' ? {
                default: "#121212",
                paper: "#1e1e1e"
            } : {
                paper: "#ffffff",
                default: "#00000004"
            }
        },
        zIndex: {
            mobileStepper: 9000,
            fab: 9050,
            appBar: 9100,
            drawer: 9249,
            modal: 9250,
            snackbar: 9400,
            tooltip: 17999
        },
        components: {
            // @ts-expect-error - MuiDataGrid is from @mui/x-data-grid and not included in core MUI types
            MuiDataGrid: {
                styleOverrides: {
                    root: {
                        "--DataGrid-containerBackground": mode === 'dark' ? "#1e1e1e" : "#fbfbfb"
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: 700,
                        borderRadius: 24,
                        boxShadow: "none"
                    }
                }
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        borderRadius: 0
                    }
                }
            },
            // Filter variant: Clean, minimal styling for filters and form controls
            // Based on FilterDropdown and OpsCenter filter components
            // Usage: <TextField size="small" /> or <Select size="small" />
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: "transparent",
                        "&.MuiInputBase-sizeSmall:not(.MuiInputBase-multiline)": {
                            height: 40,
                            borderRadius: "8px",
                            fontSize: "0.875rem",
                            // 14px
                            fontWeight: 500,
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "grey.200",
                                borderWidth: "1px"
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "grey.300"
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "grey.400",
                                borderWidth: "1px" // No thickening on focus
                            },
                            "& input, & .MuiSelect-select": {
                                paddingLeft: "12px",
                                paddingRight: "12px",
                                paddingTop: 0,
                                paddingBottom: 0,
                                height: "100%",
                                display: "flex",
                                alignItems: "center"
                            }
                        }
                    }
                }
            },
            MuiSelect: {
                defaultProps: {
                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($kfwWK)))
                },
                styleOverrides: {
                    icon: {
                        color: "grey.600",
                        fontSize: 20
                    }
                }
            },
            MuiMenu: {
                styleOverrides: {
                    paper: {
                        marginTop: "4px",
                        borderRadius: "12px",
                        border: "1px solid",
                        borderColor: "grey.200",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)"
                    }
                }
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "8px",
                        paddingBottom: "8px",
                        fontSize: "0.875rem",
                        "&:hover": {
                            backgroundColor: "grey.50"
                        },
                        "&.Mui-selected": {
                            backgroundColor: "transparent",
                            "&:hover": {
                                backgroundColor: "grey.50"
                            }
                        }
                    }
                }
            }
        },
        typography: {
            button: {
                textTransform: "none"
            },
            // @ts-expect-error - custom typography variant not in default MUI types
            tabs: {
                textTransform: "none"
            },
            fontFamily: [
                "Lexend Deca",
                "Inter",
                "-apple-system",
                "BlinkMacSystemFont",
                '"Segoe UI"',
                "Roboto",
                '"Helvetica Neue"',
                "Arial",
                "sans-serif",
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"'
            ].join(",")
        }
    });
const $414e0eb9db3901b6$export$11eb671888ed6e7d = ({ children: children })=>{
    const { preferences: preferences, loading: loading } = (0, $fC0pb.useUserPreferences)();
    // Use explicit user preference, default to light mode
    // Note: OS color scheme detection was removed to prevent toggle/theme mismatch
    const theme = $acw62.useMemo(()=>$414e0eb9db3901b6$var$createAppTheme(preferences?.theme ?? 'light'), [
        preferences?.theme
    ]);
    // Show nothing while loading to prevent flash of wrong theme
    if (loading) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gRp5N.default), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gODrq.default), {}),
            children
        ]
    });
};

});
parcelRegister("gODrq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3dfe91526ac04a1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $aAbgT = parcelRequire("aAbgT");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c3dfe91526ac04a1$var$isDynamicSupport = typeof (0, $aAbgT.globalCss)({}) === 'function';
const $c3dfe91526ac04a1$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $c3dfe91526ac04a1$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $c3dfe91526ac04a1$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $c3dfe91526ac04a1$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$c3dfe91526ac04a1$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $c3dfe91526ac04a1$var$SELECTOR = 'mui-ecs';
const $c3dfe91526ac04a1$var$staticStyles = (theme)=>{
    const result = $c3dfe91526ac04a1$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$c3dfe91526ac04a1$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $c3dfe91526ac04a1$var$GlobalStyles = (0, $aAbgT.globalCss)($c3dfe91526ac04a1$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$c3dfe91526ac04a1$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$c3dfe91526ac04a1$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $c3dfe91526ac04a1$var$CssBaseline(inProps) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            $c3dfe91526ac04a1$var$isDynamicSupport && /*#__PURE__*/ (0, $ayMG0.jsx)($c3dfe91526ac04a1$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$c3dfe91526ac04a1$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: $c3dfe91526ac04a1$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $c3dfe91526ac04a1$export$2e2bcd8739ae039 = $c3dfe91526ac04a1$var$CssBaseline;

});

parcelRegister("gRp5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4650f6dac4940cb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6osfi = parcelRequire("6osfi");

var $b0NgK = parcelRequire("b0NgK");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $c4650f6dac4940cb$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $acw62.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $4jPsi.default) in theme ? theme[0, $4jPsi.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6osfi.default), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0NgK.CssVarsProvider), {
        theme: theme,
        ...props
    });
}

});
parcelRegister("6osfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7ae4f41d656e46$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $1zd7t = parcelRequire("1zd7t");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $4a7ae4f41d656e46$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $4jPsi.default) in themeInput ? themeInput[0, $4jPsi.default] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1zd7t.default), {
        ...props,
        themeId: scopedTheme ? (0, $4jPsi.default) : undefined,
        theme: scopedTheme || themeInput
    });
}

});
parcelRegister("1zd7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $12433c9be3a4ac8d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $lXlp1 = parcelRequire("lXlp1");
var $5IBl4 = parcelRequire("5IBl4");

parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $29cO3 = parcelRequire("29cO3");

var $bJeVA = parcelRequire("bJeVA");

var $3vMLS = parcelRequire("3vMLS");

var $laEGc = parcelRequire("laEGc");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $12433c9be3a4ac8d$var$EMPTY_THEME = {};
function $12433c9be3a4ac8d$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $12433c9be3a4ac8d$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $29cO3.default)($12433c9be3a4ac8d$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $5IBl4.default)() || $12433c9be3a4ac8d$var$EMPTY_THEME;
    const engineTheme = $12433c9be3a4ac8d$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $12433c9be3a4ac8d$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $laEGc.default)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lXlp1.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bJeVA.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3vMLS.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $12433c9be3a4ac8d$export$2e2bcd8739ae039 = $12433c9be3a4ac8d$var$ThemeProvider;

});
parcelRegister("lXlp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffbfb5c53e53b721$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $hxthG = parcelRequire("hxthG");

var $5IBl4 = parcelRequire("5IBl4");

var $7K1Px = parcelRequire("7K1Px");

var $ayMG0 = parcelRequire("ayMG0");
function $ffbfb5c53e53b721$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $ffbfb5c53e53b721$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $5IBl4.default)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $ffbfb5c53e53b721$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $7K1Px.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hxthG.default).Provider, {
        value: theme,
        children: children
    });
}
var $ffbfb5c53e53b721$export$2e2bcd8739ae039 = $ffbfb5c53e53b721$var$ThemeProvider;

});
parcelRegister("hxthG", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc4c3bfd454df484$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $cc4c3bfd454df484$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $cc4c3bfd454df484$export$2e2bcd8739ae039 = $cc4c3bfd454df484$var$ThemeContext;

});

parcelRegister("5IBl4", function(module, exports) {

$parcel$export(module.exports, "default", () => $429e068ad0a4eb17$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hxthG = parcelRequire("hxthG");
function $429e068ad0a4eb17$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $hxthG.default));
    return theme;
}

});

parcelRegister("7K1Px", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2e3fc1bffefb95$export$2e2bcd8739ae039);
const $5a2e3fc1bffefb95$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $5a2e3fc1bffefb95$export$2e2bcd8739ae039 = $5a2e3fc1bffefb95$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("bJeVA", function(module, exports) {

$parcel$export(module.exports, "useRtl", () => $889f7a05097f3e52$export$b2dd014b6c321cb);
$parcel$export(module.exports, "default", () => $889f7a05097f3e52$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $889f7a05097f3e52$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $889f7a05097f3e52$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($889f7a05097f3e52$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $889f7a05097f3e52$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($889f7a05097f3e52$var$RtlContext);
    return value ?? false;
};
var $889f7a05097f3e52$export$2e2bcd8739ae039 = $889f7a05097f3e52$var$RtlProvider;

});

parcelRegister("laEGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f69a16462c10cca0$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $auC0X = parcelRequire("auC0X");

var $945hh = parcelRequire("945hh");

var $29cO3 = parcelRequire("29cO3");

var $ayMG0 = parcelRequire("ayMG0");
function $f69a16462c10cca0$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $29cO3.default)();
    const id = (0, $auC0X.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $eEJPp.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $945hh.default), {
        styles: layerOrder
    });
}

});



parcelRegister("b0NgK", function(module, exports) {

$parcel$export(module.exports, "CssVarsProvider", () => $8045e99d413e4782$export$50ec01b133c61652);
parcelRequire("acw62");

var $g91qR = parcelRequire("g91qR");

var $caUMh = parcelRequire("caUMh");

var $ijOKP = parcelRequire("ijOKP");

var $d6q8u = parcelRequire("d6q8u");

var $4jPsi = parcelRequire("4jPsi");

var $3K3i6 = parcelRequire("3K3i6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const { CssVarsProvider: $8045e99d413e4782$var$InternalCssVarsProvider, useColorScheme: $8045e99d413e4782$export$6343629ee1b29116, getInitColorSchemeScript: $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript } = (0, $caUMh.default)({
    themeId: (0, $4jPsi.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $ijOKP.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $3K3i6.defaultConfig).colorSchemeStorageKey,
    modeStorageKey: (0, $3K3i6.defaultConfig).modeStorageKey,
    defaultColorScheme: {
        light: (0, $3K3i6.defaultConfig).defaultLightColorScheme,
        dark: (0, $3K3i6.defaultConfig).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $d6q8u.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $g91qR.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $8045e99d413e4782$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $8045e99d413e4782$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8045e99d413e4782$var$InternalCssVarsProvider, {
        ...props
    });
}
let $8045e99d413e4782$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $8045e99d413e4782$export$f9a57b4a2abf8ed = (params)=>{
    if (!$8045e99d413e4782$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $8045e99d413e4782$var$warnedInitScriptOnce = true;
    }
    return $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript(params);
};
const $8045e99d413e4782$export$50ec01b133c61652 = $8045e99d413e4782$var$InternalCssVarsProvider;

});
parcelRegister("caUMh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dd27611b958afb6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $aVZKi = parcelRequire("aVZKi");

var $5IBl4 = parcelRequire("5IBl4");

var $eEJPp = parcelRequire("eEJPp");

var $1zd7t = parcelRequire("1zd7t");

var $fosqA = parcelRequire("fosqA");

var $aCkrv = parcelRequire("aCkrv");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $8dd27611b958afb6$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8dd27611b958afb6$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $fosqA.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $fosqA.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $acw62.createContext(undefined);
    const useColorScheme = ()=>$acw62.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', noSsr: noSsr } = props;
        const hasMounted = $acw62.useRef(false);
        const upperTheme = (0, $5IBl4.default)();
        const ctx = $acw62.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $acw62.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $acw62.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $aCkrv.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const memoTheme = $acw62.useMemo(()=>{
            // `colorScheme` is undefined on the server and hydration phase
            const calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            colorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $eEJPp.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $acw62.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8dd27611b958afb6$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $acw62.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $acw62.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1zd7t.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVZKi.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $fosqA.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("fosqA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE_STORAGE_KEY", () => $b34f26174ff1ab13$export$ff0fa3047d11164c);
$parcel$export(module.exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", () => $b34f26174ff1ab13$export$665054ea9d94dab9);
$parcel$export(module.exports, "default", () => $b34f26174ff1ab13$export$2e2bcd8739ae039);
/**
 * Split this component for RSC import
 */ parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $b34f26174ff1ab13$export$ff0fa3047d11164c = 'mode';
const $b34f26174ff1ab13$export$665054ea9d94dab9 = 'color-scheme';
const $b34f26174ff1ab13$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $b34f26174ff1ab13$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $b34f26174ff1ab13$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $b34f26174ff1ab13$export$665054ea9d94dab9, attribute: initialAttribute = $b34f26174ff1ab13$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("aCkrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bad4f7c7265e4f5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fosqA = parcelRequire("fosqA");

var $bb4Gq = parcelRequire("bb4Gq");
'use client';
function $7bad4f7c7265e4f5$var$noop() {}
function $7bad4f7c7265e4f5$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $7bad4f7c7265e4f5$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $7bad4f7c7265e4f5$export$3caa7590cc1987bd(state) {
    return $7bad4f7c7265e4f5$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $7bad4f7c7265e4f5$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $fosqA.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: colorSchemeStorageKey = (0, $fosqA.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $bb4Gq.default), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $acw62.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $acw62.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $7bad4f7c7265e4f5$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $acw62.useState(noSsr || !isMultiSchemes);
    $acw62.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $7bad4f7c7265e4f5$export$3caa7590cc1987bd(state);
    const setMode = $acw62.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $7bad4f7c7265e4f5$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $acw62.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $7bad4f7c7265e4f5$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $acw62.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $acw62.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $acw62.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $acw62.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $7bad4f7c7265e4f5$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $7bad4f7c7265e4f5$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $7bad4f7c7265e4f5$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("bb4Gq", function(module, exports) {

$parcel$export(module.exports, "default", () => $82345ac8b633844d$export$2e2bcd8739ae039);
function $82345ac8b633844d$var$noop() {}
const $82345ac8b633844d$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $82345ac8b633844d$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $82345ac8b633844d$export$2e2bcd8739ae039 = $82345ac8b633844d$var$localStorageManager;

});



parcelRegister("3K3i6", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", () => $2b983880bbf899cb$export$f84bd70098573c5c);
parcelRequire("acw62");

var $fosqA = parcelRequire("fosqA");

var $ayMG0 = parcelRequire("ayMG0");
const $2b983880bbf899cb$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $2b983880bbf899cb$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fosqA.default), {
        ...$2b983880bbf899cb$export$f84bd70098573c5c,
        ...props
    });
};

});



parcelRegister("kfwWK", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ebdec3d621c029d6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebdec3d621c029d6$var$_createSvgIcon = $ebdec3d621c029d6$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ebdec3d621c029d6$var$_default = module.exports.default = (0, $ebdec3d621c029d6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("aiIP4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $beCSm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});





parcelRegister("fC0pb", function(module, exports) {

$parcel$export(module.exports, "UserPreferencesContainer", () => $0acee997b59a92fa$export$aa278641ded1adf);
$parcel$export(module.exports, "useUserPreferences", () => $0acee997b59a92fa$export$b6472e0d8983f5f5);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aJsjr = parcelRequire("aJsjr");
// const UserPreferencesContainerState = createContainer(useUserPreferencesContainerState);
const $0acee997b59a92fa$var$UserPreferencesContainerState = /*#__PURE__*/ $acw62.createContext({
    loading: false,
    userPreferences: null,
    setUserPreferences: function() {},
    preferences: {},
    setPreferences: function() {}
});
const $0acee997b59a92fa$export$aa278641ded1adf = ({ children: children })=>{
    const data = (0, $aJsjr.useUserPreferences)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0acee997b59a92fa$var$UserPreferencesContainerState.Provider, {
        value: data,
        children: children
    });
};
const $0acee997b59a92fa$export$b6472e0d8983f5f5 = ()=>$acw62.useContext($0acee997b59a92fa$var$UserPreferencesContainerState);

});
parcelRegister("aJsjr", function(module, exports) {

$parcel$export(module.exports, "useUserPreferences", () => $0baf8a188ace6b18$export$b6472e0d8983f5f5);

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $4yCYl = parcelRequire("4yCYl");

var $5sKyw = parcelRequire("5sKyw");
const $0baf8a188ace6b18$export$b6472e0d8983f5f5 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const [loading, setLoading] = $acw62.useState(true);
    const [userPreferences, setUserPreferences] = $acw62.useState();
    const previousUserPreferences = (0, $4yCYl.default)(userPreferences);
    $acw62.useEffect(()=>{
        (async ()=>{
            if (!airplxIdentity?.userid) {
                setLoading(false);
                return;
            }
            const { data: data } = await postgrest.from("user_preferences").select().single();
            setUserPreferences({
                ...data,
                id: data?.id ?? (0, $5sKyw.default)(),
                user_id: data?.user_id ?? airplxIdentity?.userid,
                preferences: data?.preferences ?? {}
            });
            setLoading(false);
        })();
    }, []);
    $acw62.useEffect(()=>{
        if (!userPreferences || !previousUserPreferences) return;
        (async ()=>{
            await postgrest.from("user_preferences").upsert({
                ...userPreferences
            });
        })();
    }, [
        userPreferences
    ]);
    const setPreferences = $acw62.useCallback((preferences)=>{
        setUserPreferences((current)=>{
            const newPreferences = typeof preferences === 'function' ? preferences(current?.preferences ?? {}) : preferences;
            if (!current) // If current is undefined, create a new UserPreferences with temporary values
            // These will be replaced when the actual data loads from the database
            return {
                id: '',
                user_id: '',
                preferences: newPreferences
            };
            return {
                ...current,
                preferences: newPreferences
            };
        });
    }, []);
    return {
        loading: loading,
        userPreferences: userPreferences,
        setUserPreferences: setUserPreferences,
        preferences: userPreferences?.preferences ?? {},
        setPreferences: setPreferences
    };
};

});



parcelRegister("5RIww", function(module, exports) {

$parcel$export(module.exports, "default", () => $445470756a9ff70a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");
var $18jQK = parcelRequire("18jQK");

var $jjlaj = parcelRequire("jjlaj");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $bWvDT = parcelRequire("bWvDT");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $445470756a9ff70a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bWvDT.getSkeletonUtilityClass), classes);
};
const $445470756a9ff70a$var$pulseKeyframe = (0, $jjlaj.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $445470756a9ff70a$var$waveKeyframe = (0, $jjlaj.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $445470756a9ff70a$var$pulseAnimation = typeof $445470756a9ff70a$var$pulseKeyframe !== 'string' ? (0, $jjlaj.css)`
        animation: ${$445470756a9ff70a$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $445470756a9ff70a$var$waveAnimation = typeof $445470756a9ff70a$var$waveKeyframe !== 'string' ? (0, $jjlaj.css)`
        &::after {
          animation: ${$445470756a9ff70a$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $445470756a9ff70a$var$SkeletonRoot = (0, $d8seH.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const radiusUnit = (0, $18jQK.getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $18jQK.toUnitless)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $8gMkr.alpha)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $445470756a9ff70a$var$pulseAnimation || {
                    animation: `${$445470756a9ff70a$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $445470756a9ff70a$var$waveAnimation || {
                    '&::after': {
                        animation: `${$445470756a9ff70a$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $445470756a9ff70a$var$Skeleton = /*#__PURE__*/ $acw62.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $445470756a9ff70a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($445470756a9ff70a$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $445470756a9ff70a$export$2e2bcd8739ae039 = $445470756a9ff70a$var$Skeleton;

});
parcelRegister("18jQK", function(module, exports) {

$parcel$export(module.exports, "getUnit", () => $0d35ef8a52a98e99$export$65f2564e9a9b9222);
$parcel$export(module.exports, "toUnitless", () => $0d35ef8a52a98e99$export$8af1d214c6c2f0f1);
function $0d35ef8a52a98e99$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $0d35ef8a52a98e99$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $0d35ef8a52a98e99$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $0d35ef8a52a98e99$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $0d35ef8a52a98e99$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRegister("bWvDT", function(module, exports) {

$parcel$export(module.exports, "getSkeletonUtilityClass", () => $8b1da808c4852549$export$c987db9fc844f86);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8b1da808c4852549$export$c987db9fc844f86(slot) {
    return (0, $4Cod0.default)('MuiSkeleton', slot);
}
const $8b1da808c4852549$var$skeletonClasses = (0, $beCSm.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $8b1da808c4852549$export$2e2bcd8739ae039 = $8b1da808c4852549$var$skeletonClasses;

});


parcelRegister("30hyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $22fefd5f207422b3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jWrFr = parcelRequire("jWrFr");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $5kXxI = parcelRequire("5kXxI");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5kXxI.getTableUtilityClass), classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $d8seH.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $22fefd5f207422b3$var$defaultComponent = 'table';
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jWrFr.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, {
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var $22fefd5f207422b3$export$2e2bcd8739ae039 = $22fefd5f207422b3$var$Table;

});
parcelRegister("jWrFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e848e543ed3bf349$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;

});

parcelRegister("5kXxI", function(module, exports) {

$parcel$export(module.exports, "getTableUtilityClass", () => $3e2d01fd3f88b8c8$export$315cb19215f77ce0);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3e2d01fd3f88b8c8$export$315cb19215f77ce0(slot) {
    return (0, $4Cod0.default)('MuiTable', slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $beCSm.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $3e2d01fd3f88b8c8$export$2e2bcd8739ae039 = $3e2d01fd3f88b8c8$var$tableClasses;

});


parcelRegister("QpuKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $09d8a23708c3ccc9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $RbMj7 = parcelRequire("RbMj7");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $dfSTK = parcelRequire("dfSTK");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dfSTK.getTableBodyUtilityClass), classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $d8seH.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: 'body'
};
const $09d8a23708c3ccc9$var$defaultComponent = 'tbody';
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RbMj7.default).Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, {
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $09d8a23708c3ccc9$export$2e2bcd8739ae039 = $09d8a23708c3ccc9$var$TableBody;

});
parcelRegister("RbMj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $09fe163f52c859c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;

});

parcelRegister("dfSTK", function(module, exports) {

$parcel$export(module.exports, "getTableBodyUtilityClass", () => $9a6742b7048414d1$export$98bd2a9b566ec665);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a6742b7048414d1$export$98bd2a9b566ec665(slot) {
    return (0, $4Cod0.default)('MuiTableBody', slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $beCSm.default)('MuiTableBody', [
    'root'
]);
var $9a6742b7048414d1$export$2e2bcd8739ae039 = $9a6742b7048414d1$var$tableBodyClasses;

});


parcelRegister("elyLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71dfe9e22152ea2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $jTnBY = parcelRequire("jTnBY");

var $jWrFr = parcelRequire("jWrFr");

var $RbMj7 = parcelRequire("RbMj7");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $ev9nI = parcelRequire("ev9nI");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            padding !== 'normal' && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ev9nI.getTableCellUtilityClass), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $8gMkr.lighten)((0, $8gMkr.alpha)(theme.palette.divider, 1), 0.88) : (0, $8gMkr.darken)((0, $8gMkr.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${(0, $ev9nI.default).paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $acw62.useContext((0, $jWrFr.default));
    const tablelvl2 = $acw62.useContext((0, $RbMj7.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;

});
parcelRegister("ev9nI", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", () => $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b);
$parcel$export(module.exports, "default", () => $a8eb3ce62ab46dc7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $beCSm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;

});


parcelRegister("hjXJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c28a8e795911dc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $RbMj7 = parcelRequire("RbMj7");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $hMbPk = parcelRequire("hMbPk");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hMbPk.getTableHeadUtilityClass), classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $d8seH.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: 'head'
};
const $c9c28a8e795911dc$var$defaultComponent = 'thead';
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RbMj7.default).Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, {
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $c9c28a8e795911dc$export$2e2bcd8739ae039 = $c9c28a8e795911dc$var$TableHead;

});
parcelRegister("hMbPk", function(module, exports) {

$parcel$export(module.exports, "getTableHeadUtilityClass", () => $cf1017f12785ebe4$export$2e731cea2d1c2392);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $cf1017f12785ebe4$export$2e731cea2d1c2392(slot) {
    return (0, $4Cod0.default)('MuiTableHead', slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $beCSm.default)('MuiTableHead', [
    'root'
]);
var $cf1017f12785ebe4$export$2e2bcd8739ae039 = $cf1017f12785ebe4$var$tableHeadClasses;

});


parcelRegister("2XjE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22705465ad6920f8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $RbMj7 = parcelRequire("RbMj7");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $4iLi6 = parcelRequire("4iLi6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4iLi6.getTableRowUtilityClass), classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $d8seH.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $4iLi6.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $4iLi6.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    })));
const $22705465ad6920f8$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $acw62.useContext((0, $RbMj7.default));
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var $22705465ad6920f8$export$2e2bcd8739ae039 = $22705465ad6920f8$var$TableRow;

});
parcelRegister("4iLi6", function(module, exports) {

$parcel$export(module.exports, "getTableRowUtilityClass", () => $321d86e199abda5b$export$ba0a6d6c28940107);
$parcel$export(module.exports, "default", () => $321d86e199abda5b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $321d86e199abda5b$export$ba0a6d6c28940107(slot) {
    return (0, $4Cod0.default)('MuiTableRow', slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $beCSm.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $321d86e199abda5b$export$2e2bcd8739ae039 = $321d86e199abda5b$var$tableRowClasses;

});


parcelRegister("eScwB", function(module, exports) {

$parcel$export(module.exports, "FormLabel", () => $57a92d8b0bb025c8$export$842aba50ed0ce9d7);
$parcel$export(module.exports, "FeeCalculator2Presenter", () => $57a92d8b0bb025c8$export$71b6e9decd315b7);

var $ayMG0 = parcelRequire("ayMG0");

var $ex6lH = parcelRequire("ex6lH");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $hViLc = parcelRequire("hViLc");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $jNGAr = parcelRequire("jNGAr");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $aDtBU = parcelRequire("aDtBU");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $5KGQl = parcelRequire("5KGQl");

var $lNEp2 = parcelRequire("lNEp2");

var $85p2A = parcelRequire("85p2A");

var $kzQHY = parcelRequire("kzQHY");

var $gQSh1 = parcelRequire("gQSh1");

var $hTRQz = parcelRequire("hTRQz");

var $bdiEl = parcelRequire("bdiEl");
const $57a92d8b0bb025c8$export$842aba50ed0ce9d7 = ({ title: title, subtitle: subtitle })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "subtitle2",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: subtitle,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                    fontSize: "small",
                    sx: {
                        color: "info.dark"
                    }
                })
            })
        ]
    });
const $57a92d8b0bb025c8$export$71b6e9decd315b7 = ({ aircraft: aircraft, buffer: buffer, setBuffer: setBuffer, setAircaft: setAircaft, aircraftSqft: aircraftSqft, aircraftSqftWithBuffer: aircraftSqftWithBuffer, monthlyTenantValue: monthlyTenantValue, monthlyTenantValueWithCAM: monthlyTenantValueWithCAM, monthlyTenantDisplayValue: monthlyTenantDisplayValue, monthlyTenantDisplayValueWithCAM: monthlyTenantDisplayValueWithCAM, dailyTenantDisplayValue: dailyTenantDisplayValue, monthlyCamFees: monthlyCamFees, activeFBO: activeFBO, monthlyRate: monthlyRate, nightlyRate: nightlyRate, cam: cam, camPerSqft: camPerSqft, setCam: setCam, setCamPerSqft: setCamPerSqft, dailyRate: dailyRate, setDailyRate: setDailyRate, setMonthlyRate: setMonthlyRate, availableRates: availableRates })=>{
    const [activeTab, setActiveTab] = $acw62.useState("Tenant & Transient Fees");
    const [selectedRate, setSelectedRate] = $acw62.useState("Default");
    const unit = activeFBO?.settings?.useMetricSystem ? "m" : "ft";
    // if the user has picked a selectedRate and then modified one of those rates,
    // we want to reset the selectedRate to Default
    $acw62.useEffect(()=>{
        const activeRate = availableRates.find((rate)=>rate.label === selectedRate);
        const wereRatesModified = activeRate && (activeRate.monthly_rate !== monthlyRate || activeRate.nightly_rate !== nightlyRate);
        if (activeRate?.label !== "Default" && wereRatesModified) setSelectedRate("Default");
    }, [
        monthlyRate,
        nightlyRate
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        justifyContent: "space-around",
        alignItems: "flex-start",
        maxWidth: "100%",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                p: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: "Inputs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        width: 600,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($57a92d8b0bb025c8$export$842aba50ed0ce9d7, {
                                            title: "Aircraft",
                                            subtitle: "Aircraft you would like to calculate fees for. We'll use the wingspan and length to calculate the area to use in calculations."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            spacing: 1,
                                            width: "100%",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                    width: 375,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                                                        label: "Make/Model",
                                                        onSelect: setAircaft,
                                                        defaultSelected: aircraft
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "column",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "subtitle2",
                                                            children: "Dimensions"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            spacing: 1,
                                                            alignItems: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body1",
                                                                    children: aircraftSqft
                                                                }),
                                                                aircraft ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85p2A.AircraftSpecsTooltip), {
                                                                    aircraft: aircraft
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($57a92d8b0bb025c8$export$842aba50ed0ce9d7, {
                                            title: "Buffer",
                                            subtitle: `A buffer is added to each end of the dimensions. Eg: a 2${unit} buffer adds a total of 4${unit} to the length and 4${unit} to the wingspan.`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                            type: "number",
                                            unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                            inputProps: {
                                                min: 0.0,
                                                max: 5,
                                                step: activeFBO?.settings?.useMetricSystem ? 0.1 : 0.5,
                                                inputMode: "decimal"
                                            },
                                            size: "small",
                                            InputProps: {
                                                endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                                    position: "end",
                                                    children: unit
                                                })
                                            },
                                            onChange: (value)=>setBuffer(Number(value)),
                                            value: buffer,
                                            sx: {
                                                width: 125
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "flex-end",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "column",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($57a92d8b0bb025c8$export$842aba50ed0ce9d7, {
                                                            title: "Base Tenant Rate",
                                                            subtitle: "Rate to use for calculating monthly tenant pricing."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                            label: `$ / sq${unit} / month`,
                                                            variant: "outlined",
                                                            type: "number",
                                                            size: "small",
                                                            inputProps: {
                                                                step: 0.001,
                                                                min: 0.01,
                                                                max: 100,
                                                                inputMode: "decimal"
                                                            },
                                                            sx: {
                                                                width: 200
                                                            },
                                                            onChange: (evt)=>setMonthlyRate((0, $lNEp2.parsePreciseNumber)(evt.target.value)),
                                                            value: monthlyRate
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "column",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($57a92d8b0bb025c8$export$842aba50ed0ce9d7, {
                                                            title: "Transient Rate",
                                                            subtitle: "Rate to use for calculating nightly transient pricing."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                            label: `$ / sq${unit} / day`,
                                                            variant: "outlined",
                                                            type: "number",
                                                            size: "small",
                                                            inputProps: {
                                                                step: 0.001,
                                                                min: 0.01,
                                                                max: 100,
                                                                inputMode: "decimal"
                                                            },
                                                            sx: {
                                                                width: 200
                                                            },
                                                            onChange: (evt)=>setDailyRate((0, $lNEp2.parsePreciseNumber)(evt.target.value)),
                                                            value: dailyRate
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "column",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($57a92d8b0bb025c8$export$842aba50ed0ce9d7, {
                                                            title: "Presets",
                                                            subtitle: "You can add/edit preset rates in Settings > Estimation."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                            select: true,
                                                            label: "Rates",
                                                            size: "small",
                                                            sx: {
                                                                width: 225
                                                            },
                                                            onChange: (evt)=>{
                                                                const label = evt.target.value;
                                                                const rate = availableRates.find((rate)=>rate.label === label);
                                                                setMonthlyRate(rate.monthly_rate);
                                                                setDailyRate(rate.nightly_rate);
                                                                setSelectedRate(label);
                                                            },
                                                            value: selectedRate,
                                                            children: availableRates.map((rate)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                    value: rate.label,
                                                                    children: rate.label
                                                                }, rate.id))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($57a92d8b0bb025c8$export$842aba50ed0ce9d7, {
                                            title: "Common Area Maitenance Fees",
                                            subtitle: `Common Area Maintenance Fees added to monthly tenant rate. You can specify a percentage fee or a ${unit}\xb2 fee.`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            spacing: 2,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                    type: "number",
                                                    inputProps: {
                                                        min: 0.0,
                                                        max: 100,
                                                        step: 1,
                                                        inputMode: "numeric"
                                                    },
                                                    InputProps: {
                                                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                                            position: "end",
                                                            children: "%"
                                                        })
                                                    },
                                                    size: "small",
                                                    onChange: (evt)=>{
                                                        // Parse the value without the percentage sign
                                                        const value = (0, $lNEp2.parsePreciseNumber)(evt.target.value);
                                                        setCam(value || 0);
                                                        setCamPerSqft(0);
                                                    },
                                                    value: cam,
                                                    sx: {
                                                        width: 120
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    children: "OR"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                                    decimals: 2,
                                                    type: "number",
                                                    InputProps: {
                                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                                            position: "start",
                                                            children: "$"
                                                        }),
                                                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hViLc.default), {
                                                            position: "end",
                                                            children: [
                                                                "/ ",
                                                                unit,
                                                                "\xb2"
                                                            ]
                                                        })
                                                    },
                                                    size: "small",
                                                    onChange: (value)=>{
                                                        setCamPerSqft(value || 0);
                                                        setCam(0);
                                                    },
                                                    value: camPerSqft,
                                                    sx: {
                                                        width: 140
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                orientation: "vertical",
                flexItem: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                width: 600,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 1,
                    p: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: "Calculations"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                            value: activeTab,
                            onChange: (_, newValue)=>setActiveTab(newValue),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                    value: "Tenant & Transient Fees",
                                    label: "Tenant & Transient Fees"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                    value: "Annual Fees",
                                    label: "Annual Fees"
                                })
                            ]
                        }),
                        activeTab === "Tenant & Transient Fees" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($57a92d8b0bb025c8$export$842aba50ed0ce9d7, {
                                                            title: `Aircraft Square ${unit === "m" ? "Meters" : "Feet"}`,
                                                            subtitle: "Area taken up by the aircraft. Mesaured as wingspan x length."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($57a92d8b0bb025c8$export$842aba50ed0ce9d7, {
                                                            title: `Total Square ${unit === "m" ? "Meters" : "Feet"}`,
                                                            subtitle: "Area taken up by the aircraft aircraft + buffer (if provided)."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        children: aircraftSqft
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                            bidirectional: true,
                                                            text: aircraftSqftWithBuffer,
                                                            value: (0, $5KGQl.removeNonNumericAndParse)(aircraftSqftWithBuffer)
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        children: "Aircraft Fee"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        children: "CAM Fees"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "inherit",
                                                            align: "center",
                                                            sx: {
                                                                borderBottomColor: "success.main",
                                                                borderBottomWidth: 2,
                                                                borderBottomStyle: "solid"
                                                            },
                                                            children: "Total Fee"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $QpuKB.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: "Tenant (monthly)"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: monthlyTenantDisplayValue
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: monthlyCamFees ? (0, $lNEp2.formatCurrency)(monthlyCamFees, 2) : "---"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                                bidirectional: true,
                                                                value: (0, $5KGQl.removeNonNumericAndParse)(monthlyTenantDisplayValueWithCAM),
                                                                text: monthlyTenantDisplayValueWithCAM
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: "Transient (daily)"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: dailyTenantDisplayValue
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: "---"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                                bidirectional: true,
                                                                value: (0, $5KGQl.removeNonNumericAndParse)(dailyTenantDisplayValue),
                                                                text: dailyTenantDisplayValue
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === "Annual Fees" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdiEl.AnnualTenantTable), {
                            aircraftFee: monthlyTenantValue,
                            camFees: monthlyCamFees,
                            totalFee: monthlyTenantValueWithCAM
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("ex6lH", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a949128807fcb708$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a949128807fcb708$var$_createSvgIcon = $a949128807fcb708$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a949128807fcb708$var$_default = module.exports.default = (0, $a949128807fcb708$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), 'Info');

});

parcelRegister("hViLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c64ff513a9933f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $3bYfT = parcelRequire("3bYfT");

var $blr6C = parcelRequire("blr6C");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $kWfSh = parcelRequire("kWfSh");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kWfSh.getInputAdornmentUtilityClass), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $kWfSh.default).positionStart}&:not(.${(0, $kWfSh.default).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;

});
parcelRegister("blr6C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8426ae8303951a73$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;

});

parcelRegister("cJQfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $946238fa82894619$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $blr6C = parcelRequire("blr6C");
'use client';
function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $blr6C.default));
}

});

parcelRegister("kWfSh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getInputAdornmentUtilityClass", () => $f3e589c60baacdec$export$4b135a4b3a6c4550);
$parcel$export(module.exports, "default", () => $f3e589c60baacdec$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $beCSm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;

});


parcelRegister("2iAqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ac984bce84b2164$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $6n0Ko = parcelRequire("6n0Ko");

var $khjmj = parcelRequire("khjmj");

var $9Rgf1 = parcelRequire("9Rgf1");

var $cbVYE = parcelRequire("cbVYE");

var $doXfV = parcelRequire("doXfV");

var $guz4p = parcelRequire("guz4p");

var $eWb0W = parcelRequire("eWb0W");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $eWb0W.getMenuItemUtilityClass), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $eWb0W.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $eWb0W.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $eWb0W.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $eWb0W.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $eWb0W.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $cbVYE.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $cbVYE.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $guz4p.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $guz4p.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $doXfV.default).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $doXfV.default).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $khjmj.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $9Rgf1.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;

});
parcelRegister("3W6ht", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddba918a398c481$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;

});

parcelRegister("khjmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec346974df496fc5$export$2e2bcd8739ae039);

var $eEJPp = parcelRequire("eEJPp");
'use client';
var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $eEJPp.default);

});

parcelRegister("doXfV", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", () => $9c1b7b40cd19f5fe$export$81478e24460c57f2);
$parcel$export(module.exports, "default", () => $9c1b7b40cd19f5fe$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $beCSm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;

});

parcelRegister("guz4p", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", () => $c01aa6ddbe5e68bd$export$1061006a0db3aeb5);
$parcel$export(module.exports, "default", () => $c01aa6ddbe5e68bd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $beCSm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;

});

parcelRegister("eWb0W", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getMenuItemUtilityClass", () => $adff06ac3b11e066$export$515f8c67b5305377);
$parcel$export(module.exports, "default", () => $adff06ac3b11e066$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $beCSm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;

});


parcelRegister("jNGAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6a3a0c577f6eee9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");


var $jHfLJ = parcelRequire("jHfLJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $jTnBY.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jHfLJ.getTabUtilityClass), classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $jTnBY.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $jHfLJ.default).iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${(0, $jHfLJ.default).icon}`]: styles.icon
            }
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${(0, $jHfLJ.default).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${(0, $jHfLJ.default).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${(0, $jHfLJ.default).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${(0, $jHfLJ.default).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $jHfLJ.default).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $jHfLJ.default).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $jHfLJ.default).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $jHfLJ.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $jHfLJ.default).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $jHfLJ.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $e6a3a0c577f6eee9$export$2e2bcd8739ae039 = $e6a3a0c577f6eee9$var$Tab;

});
parcelRegister("jHfLJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getTabUtilityClass", () => $e56e43dd06ac0faa$export$72aef224d6115253);
$parcel$export(module.exports, "default", () => $e56e43dd06ac0faa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e56e43dd06ac0faa$export$72aef224d6115253(slot) {
    return (0, $4Cod0.default)('MuiTab', slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $beCSm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $e56e43dd06ac0faa$export$2e2bcd8739ae039 = $e56e43dd06ac0faa$var$tabClasses;

});


parcelRegister("aDtBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be483edbed3b474$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $bJeVA = parcelRequire("bJeVA");

var $eD6Co = parcelRequire("eD6Co");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $1iGrQ = parcelRequire("1iGrQ");

var $kRsYK = parcelRequire("kRsYK");

var $l0ZbI = parcelRequire("l0ZbI");

var $dz5QO = parcelRequire("dz5QO");

var $4o7uD = parcelRequire("4o7uD");

var $bTm2Q = parcelRequire("bTm2Q");

var $gzyUk = parcelRequire("gzyUk");

var $9Evvr = parcelRequire("9Evvr");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bTm2Q.getTabsUtilityClass), classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $bTm2Q.default).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $bTm2Q.default).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $bTm2Q.default).scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $7be483edbed3b474$var$TabsScroller = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $7be483edbed3b474$var$List = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $7be483edbed3b474$var$TabsIndicator = (0, $d8seH.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $d8seH.default)((0, $l0ZbI.default))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $bJeVA.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $4o7uD.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $kRsYK.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $6lpak.default)('scrollbar', {
        className: (0, $9QePP.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: $7be483edbed3b474$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $6lpak.default)('scrollButtons', {
        className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: (0, $dz5QO.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $4o7uD.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $4o7uD.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $1iGrQ.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $9Evvr.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $6lpak.default)('indicator', {
        className: (0, $9QePP.default)(classes.indicator, TabIndicatorProps.className),
        elementType: $7be483edbed3b474$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $gzyUk.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $7be483edbed3b474$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $6lpak.default)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $7be483edbed3b474$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $6lpak.default)('list', {
        ref: tabListRef,
        className: (0, $9QePP.default)(classes.list, classes.flexContainer),
        elementType: $7be483edbed3b474$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $7be483edbed3b474$export$2e2bcd8739ae039 = $7be483edbed3b474$var$Tabs;

});
parcelRegister("eD6Co", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa69d7725f45330b$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $1ESci = parcelRequire("1ESci");

var $8bslU = parcelRequire("8bslU");
'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $8bslU.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $1ESci.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $gEUd4.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;

});

parcelRegister("1iGrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2866359d6621f3$export$2e2bcd8739ae039);

var $aJ8G8 = parcelRequire("aJ8G8");
var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $aJ8G8.default);

});
parcelRegister("aJ8G8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf4d6c2077a48de$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("kRsYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ff3c73ed46b37c$export$2e2bcd8739ae039);
function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("l0ZbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c90fbbf54d23af$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $1iGrQ = parcelRequire("1iGrQ");

var $9Evvr = parcelRequire("9Evvr");
var $khjmj = parcelRequire("khjmj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $f4c90fbbf54d23af$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $khjmj.default)(()=>{
        const handleResize = (0, $1iGrQ.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $9Evvr.default)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $f4c90fbbf54d23af$var$styles,
        ...other,
        ref: nodeRef
    });
}

});
parcelRegister("9Evvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $707049eb9639aeac$export$2e2bcd8739ae039);

var $9KvVX = parcelRequire("9KvVX");
var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $9KvVX.default);

});


parcelRegister("dz5QO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e031514df70ea8e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $bJeVA = parcelRequire("bJeVA");

var $eD6Co = parcelRequire("eD6Co");

var $frMNQ = parcelRequire("frMNQ");

var $f46un = parcelRequire("f46un");

var $6n0Ko = parcelRequire("6n0Ko");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $4CguH = parcelRequire("4CguH");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4CguH.getTabScrollButtonUtilityClass), classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $4CguH.default).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $bJeVA.useRtl)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? (0, $frMNQ.default);
    const EndButtonIcon = slots.EndScrollButtonIcon ?? (0, $f46un.default);
    const startButtonIconProps = (0, $eD6Co.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $eD6Co.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $9e031514df70ea8e$export$2e2bcd8739ae039 = $9e031514df70ea8e$var$TabScrollButton;

});
parcelRegister("frMNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ef3be5c947a70a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $b3ef3be5c947a70a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("f46un", function(module, exports) {

$parcel$export(module.exports, "default", () => $02d495bb1a743bb2$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $02d495bb1a743bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});

parcelRegister("4CguH", function(module, exports) {

$parcel$export(module.exports, "getTabScrollButtonUtilityClass", () => $35c7816ebadb07c9$export$34861783d3c2eef8);
$parcel$export(module.exports, "default", () => $35c7816ebadb07c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $35c7816ebadb07c9$export$34861783d3c2eef8(slot) {
    return (0, $4Cod0.default)('MuiTabScrollButton', slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $beCSm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $35c7816ebadb07c9$export$2e2bcd8739ae039 = $35c7816ebadb07c9$var$tabScrollButtonClasses;

});


parcelRegister("bTm2Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getTabsUtilityClass", () => $8a85ee70c626268d$export$cdd93bd054dec359);
$parcel$export(module.exports, "default", () => $8a85ee70c626268d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8a85ee70c626268d$export$cdd93bd054dec359(slot) {
    return (0, $4Cod0.default)('MuiTabs', slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $beCSm.default)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8a85ee70c626268d$export$2e2bcd8739ae039 = $8a85ee70c626268d$var$tabsClasses;

});

parcelRegister("gzyUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10afe25107351d9$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $6zeBo.default);

});


parcelRegister("iAtns", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8826083c5af4ea7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ab7Se = parcelRequire("ab7Se");

var $g4sO2 = parcelRequire("g4sO2");

var $imehR = parcelRequire("imehR");

var $OEVqP = parcelRequire("OEVqP");

var $gd5y7 = parcelRequire("gd5y7");

var $i32L9 = parcelRequire("i32L9");

var $cX7V2 = parcelRequire("cX7V2");

var $3epOE = parcelRequire("3epOE");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $ab7Se.default),
    filled: (0, $g4sO2.default),
    outlined: (0, $imehR.default)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3epOE.getTextFieldUtilityClass), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $gd5y7.default), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const id = (0, $auC0X.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $d8826083c5af4ea7$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $6lpak.default)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $6lpak.default)('inputLabel', {
        elementType: (0, $OEVqP.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $6lpak.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $6lpak.default)('formHelperText', {
        elementType: (0, $i32L9.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $6lpak.default)('select', {
        elementType: (0, $cX7V2.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;

});
parcelRegister("ab7Se", function(module, exports) {

$parcel$export(module.exports, "default", () => $76910a07fd4ac4fe$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");


var $95gUw = parcelRequire("95gUw");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $b3ugU = parcelRequire("b3ugU");

var $95gUw = parcelRequire("95gUw");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $b3ugU.getInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $b3ugU.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $b3ugU.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $b3ugU.default).disabled}, .${(0, $b3ugU.default).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $b3ugU.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $95gUw.InputBaseInput), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $3z1Ay.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;

});
parcelRegister("95gUw", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", () => $69d1b2c99a8dc649$export$965edad20a84fa75);
$parcel$export(module.exports, "inputOverridesResolver", () => $69d1b2c99a8dc649$export$cf507b112810e72d);
$parcel$export(module.exports, "InputBaseRoot", () => $69d1b2c99a8dc649$export$298a043133d72a38);
$parcel$export(module.exports, "InputBaseInput", () => $69d1b2c99a8dc649$export$ee10465db6ff6017);
$parcel$export(module.exports, "default", () => $69d1b2c99a8dc649$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $gSRTE = parcelRequire("gSRTE");

var $c1jOg = parcelRequire("c1jOg");

var $aaphR = parcelRequire("aaphR");

var $blr6C = parcelRequire("blr6C");

var $cJQfW = parcelRequire("cJQfW");

var $aAbgT = parcelRequire("aAbgT");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $9Rgf1 = parcelRequire("9Rgf1");

var $khjmj = parcelRequire("khjmj");

var $2BbKU = parcelRequire("2BbKU");

var $dmljZ = parcelRequire("dmljZ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $69d1b2c99a8dc649$var$_InputGlobalStyles;
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $jTnBY.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dmljZ.getInputBaseUtilityClass), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $dmljZ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $69d1b2c99a8dc649$export$ee10465db6ff6017 = (0, $d8seH.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})((0, $aeD7H.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $dmljZ.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $dmljZ.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $69d1b2c99a8dc649$var$InputGlobalStyles = (0, $aAbgT.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $9Rgf1.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $2BbKU.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $khjmj.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cpmCj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $gSRTE.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $69d1b2c99a8dc649$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($69d1b2c99a8dc649$var$_InputGlobalStyles || ($69d1b2c99a8dc649$var$_InputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)($69d1b2c99a8dc649$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $c1jOg.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $c1jOg.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;

});
parcelRegister("gSRTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $032c0e7078a9cb7d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $aJ8G8 = parcelRequire("aJ8G8");
var $9KvVX = parcelRequire("9KvVX");
var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return $032c0e7078a9cb7d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://v6.mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://v6.mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $acw62.useRef(value != null);
    const textareaRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(forwardedRef, textareaRef);
    const heightRef = $acw62.useRef(null);
    const hiddenTextareaRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $9KvVX.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $13KXh.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $acw62.useRef(-1);
    (0, $eEJPp.default)(()=>{
        const debouncedHandleResize = (0, $aJ8G8.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $9KvVX.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $eEJPp.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$032c0e7078a9cb7d$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $032c0e7078a9cb7d$export$2e2bcd8739ae039 = $032c0e7078a9cb7d$var$TextareaAutosize;

});

parcelRegister("c1jOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c04f1d112fc50bc$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $8c04f1d112fc50bc$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $8c04f1d112fc50bc$export$2e2bcd8739ae039 = $8c04f1d112fc50bc$var$isHostComponent;

});

parcelRegister("aaphR", function(module, exports) {

$parcel$export(module.exports, "default", () => $766e740713576b8d$export$2e2bcd8739ae039);
function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("2BbKU", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $1e4827e2a850b1f0$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $1e4827e2a850b1f0$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("dmljZ", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", () => $9b9dde6aa920e08c$export$ef57d5c8ca2278f6);
$parcel$export(module.exports, "default", () => $9b9dde6aa920e08c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $beCSm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;

});


parcelRegister("b3ugU", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", () => $80c774dd7f29b734$export$cdb270390122322b);
$parcel$export(module.exports, "default", () => $80c774dd7f29b734$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = {
    ...(0, $dmljZ.default),
    ...(0, $beCSm.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;

});


parcelRegister("g4sO2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb335d5457c07f5b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");



var $8Indx = parcelRequire("8Indx");

var $95gUw = parcelRequire("95gUw");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $faAxf = parcelRequire("faAxf");

var $95gUw = parcelRequire("95gUw");

var $jTnBY = parcelRequire("jTnBY");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $jTnBY.default)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $faAxf.getFilledInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $faAxf.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $faAxf.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $faAxf.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $faAxf.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $faAxf.default).disabled}, .${(0, $faAxf.default).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $faAxf.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $95gUw.InputBaseInput), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})((0, $aeD7H.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;

});
parcelRegister("faAxf", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", () => $b0b42157daacd8b1$export$3331e419f1a48437);
$parcel$export(module.exports, "default", () => $b0b42157daacd8b1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = {
    ...(0, $dmljZ.default),
    ...(0, $beCSm.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;

});


parcelRegister("imehR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d55d2dd82639e9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $9ZwEw = parcelRequire("9ZwEw");

var $cJQfW = parcelRequire("cJQfW");

var $aaphR = parcelRequire("aaphR");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $96QZi = parcelRequire("96QZi");

var $95gUw = parcelRequire("95gUw");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $96QZi.getOutlinedInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $95gUw.rootOverridesResolver)
})((0, $aeD7H.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $96QZi.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $96QZi.default).focused} .${(0, $96QZi.default).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $96QZi.default).focused} .${(0, $96QZi.default).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $96QZi.default).error} .${(0, $96QZi.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $96QZi.default).disabled} .${(0, $96QZi.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $9ZwEw.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $aeD7H.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $95gUw.InputBaseInput), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})((0, $aeD7H.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $d5d55d2dd82639e9$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $6lpak.default)('notchedOutline', {
        elementType: $d5d55d2dd82639e9$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;

});
parcelRegister("9ZwEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $746323a953600e78$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $746323a953600e78$var$_span;
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $8Uq77.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $8Uq77.default)
})((0, $aeD7H.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

});

parcelRegister("96QZi", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", () => $6a1dc6d1d7e1816a$export$89922944c7227687);
$parcel$export(module.exports, "default", () => $6a1dc6d1d7e1816a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = {
    ...(0, $dmljZ.default),
    ...(0, $beCSm.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;

});


parcelRegister("OEVqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $09846a8ab0aba36e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $djhCy = parcelRequire("djhCy");
var $h2sOW = parcelRequire("h2sOW");

var $jTnBY = parcelRequire("jTnBY");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $cCThE = parcelRequire("cCThE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $jTnBY.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $cCThE.getInputLabelUtilityClasses), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $djhCy.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $h2sOW.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;

});
parcelRegister("djhCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b0ab7de0d37835d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $h2sOW = parcelRequire("h2sOW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $h2sOW.getFormLabelUtilityClasses), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $h2sOW.default).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $h2sOW.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $h2sOW.default).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $aeD7H.default)(({ theme: theme })=>({
        [`&.${(0, $h2sOW.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;

});
parcelRegister("h2sOW", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", () => $c678fac155df4fc3$export$f7d501e40371cd17);
$parcel$export(module.exports, "default", () => $c678fac155df4fc3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $beCSm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;

});


parcelRegister("cCThE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getInputLabelUtilityClasses", () => $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f);
$parcel$export(module.exports, "default", () => $9313ead0c5e2e8ca$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $beCSm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;

});


parcelRegister("gd5y7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd22a386c6068c0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $2BbKU = parcelRequire("2BbKU");

var $jTnBY = parcelRequire("jTnBY");

var $cpXNi = parcelRequire("cpXNi");

var $blr6C = parcelRequire("blr6C");

var $hGBKj = parcelRequire("hGBKj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hGBKj.getFormControlUtilityClasses), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $cpXNi.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $cpXNi.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $2BbKU.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $cpXNi.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $2BbKU.isFilled)(child.props, true) || (0, $2BbKU.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $acw62.useRef(false);
    const onFilled = $acw62.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $acw62.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;

});
parcelRegister("cpXNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a633ad7a979daa$export$2e2bcd8739ae039);

var $4NpFa = parcelRequire("4NpFa");
var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $4NpFa.default);

});
parcelRegister("4NpFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $37dfa52af4926933$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("hGBKj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFormControlUtilityClasses", () => $ce03a37a8cfb980d$export$149c8b8bab2289d1);
$parcel$export(module.exports, "default", () => $ce03a37a8cfb980d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $beCSm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;

});


parcelRegister("i32L9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23aa5c3ca6913fb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $e7ceb = parcelRequire("e7ceb");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e7ceb.getFormHelperTextUtilityClasses), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $e7ceb.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $e7ceb.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;

});
parcelRegister("e7ceb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", () => $a46b344d341d82c0$export$a394fa61b1d583a9);
$parcel$export(module.exports, "default", () => $a46b344d341d82c0$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $beCSm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;

});


parcelRegister("cX7V2", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e1233e8d06bb2d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $8Indx = parcelRequire("8Indx");

var $2xc7G = parcelRequire("2xc7G");

var $c0lH6 = parcelRequire("c0lH6");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $7LRfY = parcelRequire("7LRfY");

var $ab7Se = parcelRequire("ab7Se");

var $iOErJ = parcelRequire("iOErJ");

var $g4sO2 = parcelRequire("g4sO2");

var $imehR = parcelRequire("imehR");

var $1iOpW = parcelRequire("1iOpW");

var $9Rgf1 = parcelRequire("9Rgf1");

var $d8seH = parcelRequire("d8seH");

var $8Uq77 = parcelRequire("8Uq77");

var $bmfPX = parcelRequire("bmfPX");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $bmfPX.getSelectUtilityClasses), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $ab7Se.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $imehR.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $g4sO2.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7LRfY.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $iOErJ.default) : (0, $c0lH6.default);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $9Rgf1.default)(ref, (0, $2xc7G.default)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;

});
parcelRegister("c0lH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd650259be885cb$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");


var $gzyUk = parcelRequire("gzyUk");

var $jTnBY = parcelRequire("jTnBY");

var $4F5tJ = parcelRequire("4F5tJ");

var $iOErJ = parcelRequire("iOErJ");

var $2BbKU = parcelRequire("2BbKU");

var $d8seH = parcelRequire("d8seH");

var $PJRTc = parcelRequire("PJRTc");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3yddg = parcelRequire("3yddg");

var $bmfPX = parcelRequire("bmfPX");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)((0, $iOErJ.StyledSelectSelect), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $bmfPX.default).select}`]: styles.select
            },
            {
                [`&.${(0, $bmfPX.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $bmfPX.default).error}`]: styles.error
            },
            {
                [`&.${(0, $bmfPX.default).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $bmfPX.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)((0, $iOErJ.StyledSelectIcon), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bmfPX.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $3yddg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3yddg.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $9Rgf1.default)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $gzyUk.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $2BbKU.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cpmCj.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, $auC0X.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;

});
parcelRegister("4F5tJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $364f3db28d8d2e79$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $bJeVA = parcelRequire("bJeVA");

var $eD6Co = parcelRequire("eD6Co");

var $lBOb7 = parcelRequire("lBOb7");

var $6el2W = parcelRequire("6el2W");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $lyHsQ = parcelRequire("lyHsQ");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lyHsQ.getMenuUtilityClass), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $6el2W.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$export$4f7c51a5920c9f33 = (0, $d8seH.default)((0, $6el2W.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $lBOb7.default), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $bJeVA.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $eD6Co.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $6lpak.default)('paper', {
        className: classes.paper,
        elementType: $364f3db28d8d2e79$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $6lpak.default)('list', {
        className: (0, $9QePP.default)(classes.list, MenuListProps.className),
        elementType: $364f3db28d8d2e79$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;

});
parcelRegister("lBOb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb3fa0cdc277971$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $gzyUk = parcelRequire("gzyUk");

var $8AyZl = parcelRequire("8AyZl");

var $19SuQ = parcelRequire("19SuQ");

var $9Rgf1 = parcelRequire("9Rgf1");

var $khjmj = parcelRequire("khjmj");

var $9Evvr = parcelRequire("9Evvr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $khjmj.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $19SuQ.default)((0, $9Evvr.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $gzyUk.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $9Rgf1.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;

});
parcelRegister("8AyZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $640cd381f5e8b3ea$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $eUMjp = parcelRequire("eUMjp");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eUMjp.getListUtilityClass), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, {
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;

});
parcelRegister("eUMjp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getListUtilityClass", () => $adbbc5717e0d0350$export$c6bd6795ed6e3203);
$parcel$export(module.exports, "default", () => $adbbc5717e0d0350$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $beCSm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;

});


parcelRegister("19SuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d80e79907b6bdbc$export$2e2bcd8739ae039);

var $aF4kJ = parcelRequire("aF4kJ");
var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $aF4kJ.default);

});


parcelRegister("6el2W", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", () => $012baef8dc9ae9d0$export$821346c38a2d9390);
$parcel$export(module.exports, "default", () => $012baef8dc9ae9d0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");






var $c1jOg = parcelRequire("c1jOg");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1iGrQ = parcelRequire("1iGrQ");

var $gzyUk = parcelRequire("gzyUk");

var $9Evvr = parcelRequire("9Evvr");

var $iscuz = parcelRequire("iscuz");

var $118QM = parcelRequire("118QM");

var $7Frhn = parcelRequire("7Frhn");

var $k6uEG = parcelRequire("k6uEG");

var $6lpak = parcelRequire("6lpak");

var $f8X1n = parcelRequire("f8X1n");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $k6uEG.getPopoverUtilityClass), classes);
};
const $012baef8dc9ae9d0$export$bcce13685275fc99 = (0, $d8seH.default)((0, $118QM.default), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$export$821346c38a2d9390 = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $acw62.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $gzyUk.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $9Evvr.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $1iGrQ.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $9Evvr.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $iscuz.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $gzyUk.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $012baef8dc9ae9d0$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $f8X1n.default)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $6lpak.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $012baef8dc9ae9d0$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $c1jOg.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;

});
parcelRegister("iscuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f4882a3b1c59f2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $lHOu3 = parcelRequire("lHOu3");


var $2xc7G = parcelRequire("2xc7G");

var $1mPeS = parcelRequire("1mPeS");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const timer = (0, $lHOu3.default)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $14H9o.default)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(nodeRef, (0, $2xc7G.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$d6f4882a3b1c59f2$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($d6f4882a3b1c59f2$var$Grow) $d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;

});

parcelRegister("k6uEG", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", () => $ea2c25a800e729b1$export$88f455dd56c95edb);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $beCSm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;

});

parcelRegister("f8X1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $b06562c0a3ca8f02$export$2e2bcd8739ae039);

var $9QePP = parcelRequire("9QePP");
function $b06562c0a3ca8f02$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $9QePP.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $9QePP.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});


parcelRegister("lyHsQ", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", () => $fb1e7d0ac8fac824$export$2cf86a63a84fe23d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $beCSm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;

});


parcelRegister("iOErJ", function(module, exports) {

$parcel$export(module.exports, "StyledSelectSelect", () => $db2c454fb2e8bc3c$export$50b3545a8ccd87af);
$parcel$export(module.exports, "StyledSelectIcon", () => $db2c454fb2e8bc3c$export$7dd4d92f143902e3);
$parcel$export(module.exports, "default", () => $db2c454fb2e8bc3c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $6jVRo = parcelRequire("6jVRo");

var $d8seH = parcelRequire("d8seH");

var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6jVRo.getNativeSelectUtilityClasses), classes);
};
const $db2c454fb2e8bc3c$export$50b3545a8ccd87af = (0, $d8seH.default)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $6jVRo.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)($db2c454fb2e8bc3c$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8Uq77.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $6jVRo.default).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $db2c454fb2e8bc3c$export$7dd4d92f143902e3 = (0, $d8seH.default)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $6jVRo.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)($db2c454fb2e8bc3c$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;

});
parcelRegister("6jVRo", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", () => $49a1663d7631a8fa$export$1ee13051fd9e2ab5);
$parcel$export(module.exports, "default", () => $49a1663d7631a8fa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $beCSm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;

});


parcelRegister("3yddg", function(module, exports) {

$parcel$export(module.exports, "default", () => $295ecbe78b5bad73$export$2e2bcd8739ae039);

var $agZ85 = parcelRequire("agZ85");
'use client';
var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $agZ85.default);

});
parcelRegister("agZ85", function(module, exports) {

$parcel$export(module.exports, "default", () => $77aad105771eb889$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("bmfPX", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", () => $844e08aea9053c4b$export$2c0c1ee5a3392e);
$parcel$export(module.exports, "default", () => $844e08aea9053c4b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $beCSm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;

});


parcelRegister("7LRfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a863bd9b12ca76b$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});


parcelRegister("3epOE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getTextFieldUtilityClass", () => $25a6b464d3ca38da$export$c1bdcbaf0596aeda);
$parcel$export(module.exports, "default", () => $25a6b464d3ca38da$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $beCSm.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;

});


parcelRegister("cVXaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a8b4f445fd9172$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $lHOu3 = parcelRequire("lHOu3");


var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $bJeVA = parcelRequire("bJeVA");

var $52FI1 = parcelRequire("52FI1");

var $2xc7G = parcelRequire("2xc7G");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $iscuz = parcelRequire("iscuz");

var $e76iu = parcelRequire("e76iu");

var $4o7uD = parcelRequire("4o7uD");

var $9Rgf1 = parcelRequire("9Rgf1");

var $5A6d3 = parcelRequire("5A6d3");

var $3yddg = parcelRequire("3yddg");

var $6lpak = parcelRequire("6lpak");

var $eVjpW = parcelRequire("eVjpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $jTnBY.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eVjpW.getTooltipUtilityClass), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $eVjpW.default).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $eVjpW.default).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $eVjpW.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $eVjpW.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $eVjpW.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $eVjpW.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $eVjpW.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $eVjpW.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $8gMkr.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})((0, $aeD7H.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $8gMkr.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new (0, $lHOu3.Timeout)();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $bJeVA.useRtl)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $lHOu3.default)();
    const enterTimer = (0, $lHOu3.default)();
    const leaveTimer = (0, $lHOu3.default)();
    const touchTimer = (0, $lHOu3.default)();
    const [openState, setOpenState] = (0, $3yddg.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $5A6d3.default)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $4o7uD.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $4o7uD.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $52FI1.default)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $52FI1.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $9Rgf1.default)((0, $2xc7G.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $9QePP.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $acw62.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $6lpak.default)('popper', {
        elementType: $96a8b4f445fd9172$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $iscuz.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $6lpak.default)('tooltip', {
        elementType: $96a8b4f445fd9172$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $6lpak.default)('arrow', {
        elementType: $96a8b4f445fd9172$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $e76iu.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;

});
parcelRegister("e76iu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4669aa090d445bd$export$2e2bcd8739ae039);

var $bJeVA = parcelRequire("bJeVA");




var $acw62 = parcelRequire("acw62");

var $7JHF2 = parcelRequire("7JHF2");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $7JHF2.default), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://v6.mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 * - [Popper](https://v6.mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://v6.mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $bJeVA.useRtl)();
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;

});
parcelRegister("7JHF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a1e9a841ed0d0fc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");

var $3tUi5 = parcelRequire("3tUi5");


var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $2Q995 = parcelRequire("2Q995");

var $g3XLf = parcelRequire("g3XLf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $g3XLf.getPopperUtilityClass), classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $3qSdM.default)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $3qSdM.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $eEJPp.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $eEJPp.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $3tUi5.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $eD6Co.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $6zeBo.default)(resolvedAnchorEl).body : (0, $6zeBo.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q995.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $5a1e9a841ed0d0fc$export$2e2bcd8739ae039 = $5a1e9a841ed0d0fc$var$Popper;

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === 'html' || (0, $oKPBf.default)(offsetParent) === 'body' && (0, $huVQQ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === 'rtl') x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === 'x' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("g3XLf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getPopperUtilityClass", () => $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1);
$parcel$export(module.exports, "default", () => $bb1b487b0ea8f7b1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $beCSm.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$export$2e2bcd8739ae039 = $bb1b487b0ea8f7b1$var$popperClasses;

});



parcelRegister("eVjpW", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", () => $add5737403c6a16a$export$837848f5f6cee923);
$parcel$export(module.exports, "default", () => $add5737403c6a16a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $beCSm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;

});


parcelRegister("5KGQl", function(module, exports) {

$parcel$export(module.exports, "getStackPolygons", () => $6476a66b8c9351e2$export$e746cd55cae4263);
$parcel$export(module.exports, "arraysEqual", () => $6476a66b8c9351e2$export$234180f8206db11b);
$parcel$export(module.exports, "objectsEqual", () => $6476a66b8c9351e2$export$4101b1f9eee93414);
$parcel$export(module.exports, "anglediff", () => $6476a66b8c9351e2$export$c95a67291b850b07);
$parcel$export(module.exports, "removeNonNumericAndParse", () => $6476a66b8c9351e2$export$242b4f59ae4c5515);
$parcel$export(module.exports, "levenshtein", () => $6476a66b8c9351e2$export$bf89e973afcb2927);
parcelRequire("9vNAe");
var $doyzN = parcelRequire("doyzN");
var $3UnUr = parcelRequire("3UnUr");

var $g7var = parcelRequire("g7var");

var $1NUjF = parcelRequire("1NUjF");
const $6476a66b8c9351e2$export$b3375bf63d3f8a0f = (geomz, position)=>{
    const updatedCoordinates = geomz.coordinates.map((coords)=>{
        return coords.map((c)=>c.map((p)=>[
                    p[0] + position.x,
                    p[1] + position.y,
                    p[2],
                    // z
                    p[3] // m
                ]));
    });
    return {
        ...geomz,
        coordinates: updatedCoordinates
    };
};
const $6476a66b8c9351e2$export$65c1164b6801a0b2 = (geomz, pivotPoint, position)=>{
    const updatedCoordinates = geomz.coordinates.map((coords)=>{
        return coords.map((subpolygon)=>$3UnUr.polygonRotate(subpolygon.map((c)=>[
                    c[0],
                    c[1]
                ]), // geometric rotates the other way, so negate the angle
            -position.angle, pivotPoint).map((c)=>[
                    c[0],
                    c[1],
                    subpolygon[0][2],
                    subpolygon[0][3]
                ]));
    });
    return {
        ...geomz,
        coordinates: updatedCoordinates
    };
};
const $6476a66b8c9351e2$export$e746cd55cae4263 = (stack, layoutWidth, feetToPixels, isMultiHangar = false, isHoldingArea = false)=>{
    if (!stack) return [];
    const tenantPolygons = (0, $g7var.wrapUnplacedAirplanes)(stack.tenants, layoutWidth, feetToPixels, isMultiHangar, isHoldingArea).map(({ entity_id: entity_id, position: position, aircraft: aircraft, tail_number: tail_number })=>{
        /**
     * take the scaled polygon, get it into position, then rotate it on the correct pivot
     * point. the result should be a polygon that matches the outline of each aircraft.
     * we can use this to detect things like collisions
     */ // Defensive check for missing aircraft geometry
        if (!aircraft.scaled_geom_full?.coordinates?.[0] || !aircraft.pivot_point?.coordinates) {
            console.warn('Skipping tenant with missing aircraft geometry:', {
                entity_id: entity_id,
                tail_number: tail_number || 'unknown',
                aircraft_id: aircraft.id || 'null',
                has_scaled_geom_full: !!aircraft.scaled_geom_full,
                has_pivot_point: !!aircraft.pivot_point,
                aircraft_object_keys: Object.keys(aircraft),
                // See what properties exist
                is_empty_object: Object.keys(aircraft).length === 0 // Detect {} fallback
            });
            return null;
        }
        const basePolygon = aircraft.scaled_geom_full.coordinates[0].map(([x, y])=>[
                x + position.x,
                y + position.y
            ]);
        const pivotPoint = [
            aircraft.pivot_point.coordinates[0] + position.x,
            aircraft.pivot_point.coordinates[1] + position.y
        ];
        const polygon = $3UnUr.polygonRotate(basePolygon, // geometric rotates the other way, so negate the angle
        -position.angle, pivotPoint);
        return {
            entity_id: entity_id,
            polygon: {
                type: "Polygon",
                coordinates: [
                    polygon
                ]
            },
            bounds: $doyzN.polygonBounds(polygon)
        };
    }).filter(Boolean); // Remove null entries from tenants with missing aircraft data
    const movableObstaclePolygons = stack.movableObstacles.map(({ entity_id: entity_id, position: position, obstacle: obstacle })=>{
        const basePolygon = obstacle.geom.coordinates[0].map(([x, y])=>[
                x + position.x,
                y + position.y
            ]);
        const center = Math.max(obstacle.width, obstacle.length) / 2;
        const pivotPoint = [
            center + position.x,
            center + position.y
        ];
        const polygon = $3UnUr.polygonRotate(basePolygon, // geometric rotates the other way, so negate the angle
        -position.angle, pivotPoint);
        return {
            entity_id: entity_id,
            polygon: {
                type: "Polygon",
                coordinates: [
                    polygon
                ]
            },
            bounds: $doyzN.polygonBounds(polygon)
        };
    }).filter(Boolean);
    return [
        ...tenantPolygons,
        ...movableObstaclePolygons
    ];
};
function $6476a66b8c9351e2$export$234180f8206db11b(array1, array2) {
    if (array1.length !== array2.length) return false;
    for(let i = 0; i < array1.length; i++){
        const item1 = array1[i];
        const item2 = array2[i];
        if (typeof item1 !== typeof item2) return false;
        if (Array.isArray(item1) && Array.isArray(item2)) {
            if (!$6476a66b8c9351e2$export$234180f8206db11b(item1, item2)) return false;
        } else if (typeof item1 === "object" && typeof item2 === "object") {
            if (!$6476a66b8c9351e2$export$4101b1f9eee93414(item1, item2)) return false;
        } else if (item1 !== item2) return false;
    }
    return true;
}
function $6476a66b8c9351e2$export$4101b1f9eee93414(object1, object2) {
    const keys1 = Object.keys(object1 ?? {});
    const keys2 = Object.keys(object2 ?? {});
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const value1 = object1[key];
        const value2 = object2[key];
        if (typeof value1 !== typeof value2) return false;
        if (Array.isArray(value1) && Array.isArray(value2)) {
            if (!$6476a66b8c9351e2$export$234180f8206db11b(value1, value2)) return false;
        } else if (typeof value1 === "object" && typeof value2 === "object") {
            if (!$6476a66b8c9351e2$export$4101b1f9eee93414(value1, value2)) return false;
        } else if (value1 !== value2) return false;
    }
    return true;
}
const $6476a66b8c9351e2$export$c95a67291b850b07 = (a, b)=>{
    return Math.abs((a - b + 180) % 360 - 180);
};
const $6476a66b8c9351e2$export$242b4f59ae4c5515 = (value)=>{
    // Remove all non-numeric characters and "." from the string
    const cleanedValue = value.replace(/[^0-9.]/g, "");
    // Attempt to parse the cleaned value to a number
    const parsedNumber = Number(cleanedValue);
    // Return the parsed number if it's not NaN, otherwise return null
    return isNaN(parsedNumber) ? null : parsedNumber;
};
const $6476a66b8c9351e2$export$fbfc9ab1d8e6793b = (wkt)=>{
    // Remove 'MULTIPOLYGON ZM' prefix and surrounding parentheses
    const cleanedWkt = wkt.replace("MULTIPOLYGON ZM ", "").trim().slice(1, -1);
    // Split into individual polygons
    const polygons = cleanedWkt.split(")),((");
    // Process each polygon
    const coordinates = polygons.map((polygon)=>{
        // Remove outer parentheses if present
        const cleanedPolygon = polygon.replace(/\(|\)/g, "");
        // Split the polygon into rings
        const rings = cleanedPolygon.split("),(");
        // Process each ring
        return rings.map((ring)=>{
            // Split the ring into points
            const points = ring.split(",");
            // Process each point
            return points.map((point)=>{
                // Split the point into coordinates and convert to numbers
                const [x, y, z, m] = point.trim().split(/\s+/).map(Number);
                return [
                    x,
                    y,
                    z,
                    m
                ];
            });
        });
    });
    // Construct GeoJSON MultiPolygon
    const geojson = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return geojson;
};
function $6476a66b8c9351e2$export$bf89e973afcb2927(a, b) {
    const an = a ? a.length : 0;
    const bn = b ? b.length : 0;
    if (an === 0) return bn;
    if (bn === 0) return an;
    const matrix = new Array(bn + 1);
    for(let i = 0; i <= bn; ++i){
        let row = matrix[i] = new Array(an + 1);
        row[0] = i;
    }
    const firstRow = matrix[0];
    for(let j = 1; j <= an; ++j)firstRow[j] = j;
    for(let i = 1; i <= bn; ++i){
        for(let j = 1; j <= an; ++j)if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
        else matrix[i][j] = Math.min(matrix[i - 1][j - 1], // substitution
        matrix[i][j - 1], // insertion
        matrix[i - 1][j] // deletion
        ) + 1;
    }
    return matrix[bn][an];
}

});
parcelRegister("9vNAe", function(module, exports) {

$parcel$export(module.exports, "polygonBounds", () => (parcelRequire("doyzN")).polygonBounds);
$parcel$export(module.exports, "polygonInterpolate", () => (parcelRequire("jlYvG")).polygonInterpolate);
$parcel$export(module.exports, "polygonRotate", () => (parcelRequire("3UnUr")).polygonRotate);
$parcel$export(module.exports, "pointInPolygon", () => (parcelRequire("g2BFU")).pointInPolygon);
$parcel$export(module.exports, "polygonInPolygon", () => (parcelRequire("dfdxy")).polygonInPolygon);
$parcel$export(module.exports, "polygonIntersectsPolygon", () => (parcelRequire("d2xzW")).polygonIntersectsPolygon);

var $SyezW = parcelRequire("SyezW");

var $lUUlY = parcelRequire("lUUlY");

var $83wtC = parcelRequire("83wtC");

var $5gI5I = parcelRequire("5gI5I");

var $a8lHJ = parcelRequire("a8lHJ");

var $lXWSD = parcelRequire("lXWSD");

var $j3rAi = parcelRequire("j3rAi");

var $51Pd3 = parcelRequire("51Pd3");

var $2W9st = parcelRequire("2W9st");

var $doyzN = parcelRequire("doyzN");

var $k5GZm = parcelRequire("k5GZm");

var $1dxEb = parcelRequire("1dxEb");

var $jlYvG = parcelRequire("jlYvG");

var $8k1hj = parcelRequire("8k1hj");

var $dG4Ei = parcelRequire("dG4Ei");

var $kmsRN = parcelRequire("kmsRN");

var $9y5pj = parcelRequire("9y5pj");

var $cMcGI = parcelRequire("cMcGI");

var $ghaI4 = parcelRequire("ghaI4");

var $3UnUr = parcelRequire("3UnUr");

var $9JapF = parcelRequire("9JapF");

var $hRmkR = parcelRequire("hRmkR");

var $aRnSx = parcelRequire("aRnSx");

var $dij7m = parcelRequire("dij7m");

var $1GKWW = parcelRequire("1GKWW");

var $8DPYo = parcelRequire("8DPYo");

var $cBkDd = parcelRequire("cBkDd");

var $3sxIR = parcelRequire("3sxIR");

var $g2BFU = parcelRequire("g2BFU");

var $ltlmp = parcelRequire("ltlmp");

var $2epWj = parcelRequire("2epWj");

var $dfdxy = parcelRequire("dfdxy");

var $d2xzW = parcelRequire("d2xzW");

var $3Dma2 = parcelRequire("3Dma2");

var $hCTp7 = parcelRequire("hCTp7");

var $9MYRn = parcelRequire("9MYRn");

});
parcelRegister("SyezW", function(module, exports) {

$parcel$export(module.exports, "lineAngle", () => $0a3f99728f640dd4$export$281f0d295859ab5b);

var $hCTp7 = parcelRequire("hCTp7");
function $0a3f99728f640dd4$export$281f0d295859ab5b(line) {
    return (0, $hCTp7.angleToDegrees)(Math.atan2(line[1][1] - line[0][1], line[1][0] - line[0][0]));
}

});
parcelRegister("hCTp7", function(module, exports) {

$parcel$export(module.exports, "angleToDegrees", () => $cd50f66377dcf8b5$export$e91ed213606fb780);
// Converts radians to degrees.
function $cd50f66377dcf8b5$export$e91ed213606fb780(angle) {
    return angle * 180 / Math.PI;
}

});


parcelRegister("lUUlY", function(module, exports) {

$parcel$export(module.exports, "lineInterpolate", () => $ff4a8a90d6bbe246$export$4f3baf4a0ceb52d2);
// Returns an interpolator function given a line [a, b].
// The returned interpolator function takes a single argument t, where t is a number ranging from 0 to 1;
// a value of 0 returns a, while a value of 1 returns b.
// Intermediate values interpolate from start to end along the line segment.
// By default, the returned interpolator will output points outside of the line segment if t is less than 0 or greater than 1.
// You can pass an optional boolean indicating whether to the returned point to inside of the line segment,
// even if t is greater than 1 or less then 0.
function $ff4a8a90d6bbe246$export$4f3baf4a0ceb52d2(line, clamp = false) {
    const [[x1, y1], [x2, y2]] = line;
    const x = (v)=>(x2 - x1) * v + x1;
    const y = (v)=>(y2 - y1) * v + y1;
    return (t)=>{
        const t0 = clamp ? t < 0 ? 0 : t > 1 ? 1 : t : t;
        return [
            x(t0),
            y(t0)
        ];
    };
}

});

parcelRegister("83wtC", function(module, exports) {

$parcel$export(module.exports, "lineLength", () => $5dd7cbbe8706ed86$export$28022775658f8740);
// Calculates the distance between the endpoints of a line segment.
function $5dd7cbbe8706ed86$export$28022775658f8740(line) {
    return Math.sqrt(Math.pow(line[1][0] - line[0][0], 2) + Math.pow(line[1][1] - line[0][1], 2));
}

});

parcelRegister("5gI5I", function(module, exports) {

$parcel$export(module.exports, "lineMidpoint", () => $3d60a5f22cf0ac2d$export$81616d6c91c1ae80);
// Calculates the midpoint of a line segment.
function $3d60a5f22cf0ac2d$export$81616d6c91c1ae80(line) {
    return [
        (line[0][0] + line[1][0]) / 2,
        (line[0][1] + line[1][1]) / 2
    ];
}

});

parcelRegister("a8lHJ", function(module, exports) {

var $5gI5I = parcelRequire("5gI5I");

var $j3rAi = parcelRequire("j3rAi");
function $760b7cbecabe7730$export$66d726d0639c287b(line, angle, origin) {
    return line.map((point)=>(0, $j3rAi.pointRotate)(point, angle, origin || (0, $5gI5I.lineMidpoint)(line)));
}

});
parcelRegister("j3rAi", function(module, exports) {

$parcel$export(module.exports, "pointRotate", () => $ddf3b1d3837f9fc1$export$23aca863471c3fa8);

var $9MYRn = parcelRequire("9MYRn");
function $ddf3b1d3837f9fc1$export$23aca863471c3fa8(point, angle, origin) {
    const r = (0, $9MYRn.angleToRadians)(angle || 0);
    if (!origin || origin[0] === 0 && origin[1] === 0) return $ddf3b1d3837f9fc1$var$rotate(point, r);
    else {
        // See: https://math.stackexchange.com/questions/1964905/rotation-around-non-zero-point
        const p0 = point.map((c, i)=>c - origin[i]);
        const rotated = $ddf3b1d3837f9fc1$var$rotate(p0, r);
        return rotated.map((c, i)=>c + origin[i]);
    }
}
function $ddf3b1d3837f9fc1$var$rotate(point, angle) {
    // See: https://en.wikipedia.org/wiki/Cartesian_coordinate_system#Rotation
    return [
        point[0] * Math.cos(angle) - point[1] * Math.sin(angle),
        point[0] * Math.sin(angle) + point[1] * Math.cos(angle)
    ];
}

});
parcelRegister("9MYRn", function(module, exports) {

$parcel$export(module.exports, "angleToRadians", () => $7207ce476db2e289$export$813f0643d0f0294c);
// Converts degrees to radians.
function $7207ce476db2e289$export$813f0643d0f0294c(angle) {
    return angle / 180 * Math.PI;
}

});



parcelRegister("lXWSD", function(module, exports) {

var $51Pd3 = parcelRequire("51Pd3");
function $ffdcc8114fd2f42c$export$9b46fa45bac13e22(line, angle, distance) {
    return line.map((point)=>(0, $51Pd3.pointTranslate)(point, angle, distance));
}

});
parcelRegister("51Pd3", function(module, exports) {

$parcel$export(module.exports, "pointTranslate", () => $3a94c4e047bb438f$export$1499637292302e66);

var $9MYRn = parcelRequire("9MYRn");
function $3a94c4e047bb438f$export$1499637292302e66(point, angle = 0, distance = 0) {
    const r = (0, $9MYRn.angleToRadians)(angle);
    return [
        point[0] + distance * Math.cos(r),
        point[1] + distance * Math.sin(r)
    ];
}

});


parcelRegister("2W9st", function(module, exports) {

$parcel$export(module.exports, "polygonArea", () => $223855bf6a21e154$export$7c04771a442b0848);
// Calculates the area of a polygon.
function $223855bf6a21e154$export$7c04771a442b0848(vertices, signed = false) {
    let a = 0;
    for(let i = 0, l = vertices.length; i < l; i++){
        const v0 = vertices[i], v1 = vertices[i === l - 1 ? 0 : i + 1];
        a += v0[0] * v1[1];
        a -= v1[0] * v0[1];
    }
    return signed ? a / 2 : Math.abs(a / 2);
}

});

parcelRegister("doyzN", function(module, exports) {

$parcel$export(module.exports, "polygonBounds", () => $9c085666c5699ea1$export$f0b1656162320e06);
// Calculates the bounds of a polygon.
function $9c085666c5699ea1$export$f0b1656162320e06(polygon) {
    if (polygon.length < 3) return null;
    let xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, found = false;
    for(let i = 0, l = polygon.length; i < l; i++){
        const p = polygon[i], x = p[0], y = p[1];
        if (x != null && isFinite(x) && y != null && isFinite(y)) {
            found = true;
            if (x < xMin) xMin = x;
            if (x > xMax) xMax = x;
            if (y < yMin) yMin = y;
            if (y > yMax) yMax = y;
        }
    }
    return found ? [
        [
            xMin,
            yMin
        ],
        [
            xMax,
            yMax
        ]
    ] : null;
}

});

parcelRegister("k5GZm", function(module, exports) {

$parcel$export(module.exports, "polygonCentroid", () => $ea059ef29e550516$export$31875faf3fe0de4d);
// Calculates the weighted centroid a polygon.
function $ea059ef29e550516$export$31875faf3fe0de4d(vertices) {
    let a = 0, x = 0, y = 0, l = vertices.length;
    for(let i = 0; i < l; i++){
        const s = i === l - 1 ? 0 : i + 1, v0 = vertices[i], v1 = vertices[s], f = v0[0] * v1[1] - v1[0] * v0[1];
        a += f;
        x += (v0[0] + v1[0]) * f;
        y += (v0[1] + v1[1]) * f;
    }
    const d = a * 3;
    return [
        x / d,
        y / d
    ];
}

});

parcelRegister("1dxEb", function(module, exports) {

var $3wSWn = parcelRequire("3wSWn");
function $0e311aef9e606487$export$9869f4451dcfc1f(points) {
    if (points.length < 3) return null;
    const pointsCopy = points.slice().sort((a, b)=>a[0] === b[0] ? a[1] - b[1] : a[0] - b[0]);
    let lower = [];
    for(let i = 0; i < pointsCopy.length; i++){
        while(lower.length >= 2 && (0, $3wSWn.cross)(lower[lower.length - 2], lower[lower.length - 1], pointsCopy[i]) <= 0)lower.pop();
        lower.push(pointsCopy[i]);
    }
    let upper = [];
    for(let i = pointsCopy.length - 1; i >= 0; i--){
        while(upper.length >= 2 && (0, $3wSWn.cross)(upper[upper.length - 2], upper[upper.length - 1], pointsCopy[i]) <= 0)upper.pop();
        upper.push(pointsCopy[i]);
    }
    upper.pop();
    lower.pop();
    return lower.concat(upper);
}

});
parcelRegister("3wSWn", function(module, exports) {

$parcel$export(module.exports, "cross", () => $291efa4ab13b0b7e$export$bb646b20bb93d339);
// See https://en.wikibooks.org/wiki/Algorithm_Implementation/Geometry/Convex_hull/Monotone_chain#JavaScript
// and https://math.stackexchange.com/questions/274712/calculate-on-which-side-of-a-straight-line-is-a-given-point-located
function $291efa4ab13b0b7e$export$bb646b20bb93d339(a, b, o) {
    return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
}

});


parcelRegister("jlYvG", function(module, exports) {

$parcel$export(module.exports, "polygonInterpolate", () => $e16eea89f6f5ecc5$export$c886d085c7b0d9b0);

var $lYolD = parcelRequire("lYolD");

var $SyezW = parcelRequire("SyezW");

var $83wtC = parcelRequire("83wtC");

var $51Pd3 = parcelRequire("51Pd3");

var $8k1hj = parcelRequire("8k1hj");
function $e16eea89f6f5ecc5$export$c886d085c7b0d9b0(polygon) {
    return (t)=>{
        if (t <= 0) return polygon[0];
        const closed = (0, $lYolD.close)(polygon);
        if (t >= 1) return closed[closed.length - 1];
        const target = (0, $8k1hj.polygonLength)(closed) * t;
        let point = [], track = 0;
        for(let i = 0; i < closed.length - 1; i++){
            const side = [
                closed[i],
                closed[i + 1]
            ], length = (0, $83wtC.lineLength)(side), angle = (0, $SyezW.lineAngle)(side), delta = target - (track += length);
            if (delta < 0) {
                point = (0, $51Pd3.pointTranslate)(side[0], angle, length + delta);
                break;
            } else if (i === polygon.length - 2) point = (0, $51Pd3.pointTranslate)(side[0], angle, delta);
        }
        return point;
    };
}

});
parcelRegister("lYolD", function(module, exports) {

$parcel$export(module.exports, "close", () => $fff21691e7345ecf$export$8360e631d277ea4d);
// Closes a polygon if it's not closed already. Does not modify input polygon.
function $fff21691e7345ecf$export$8360e631d277ea4d(polygon) {
    return $fff21691e7345ecf$export$4210f5ea57fbae57(polygon) ? polygon : [
        ...polygon,
        polygon[0]
    ];
}
function $fff21691e7345ecf$export$4210f5ea57fbae57(polygon) {
    const first = polygon[0], last = polygon[polygon.length - 1];
    return first[0] === last[0] && first[1] === last[1];
}

});

parcelRegister("8k1hj", function(module, exports) {

$parcel$export(module.exports, "polygonLength", () => $60f12ecd50511c1a$export$9236f1a6c551ea06);
// Calculates the length of a polygon's perimeter. See https://github.com/d3/d3-polygon/blob/master/src/length.js
function $60f12ecd50511c1a$export$9236f1a6c551ea06(vertices) {
    if (vertices.length === 0) return 0;
    let i = -1, n = vertices.length, b = vertices[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = vertices[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.sqrt(xa * xa + ya * ya);
    }
    return perimeter;
}

});


parcelRegister("dG4Ei", function(module, exports) {
// Calculates the arithmetic mean of a polygon's vertices.
function $9f52cdc51ac78557$export$e4bdabf9284ca3bf(vertices) {
    let x = 0, y = 0, l = vertices.length;
    for(let i = 0; i < l; i++){
        const v = vertices[i];
        x += v[0];
        y += v[1];
    }
    return [
        x / l,
        y / l
    ];
}

});

parcelRegister("kmsRN", function(module, exports) {
parcelRequire("lYolD");

var $SyezW = parcelRequire("SyezW");

var $83wtC = parcelRequire("83wtC");

var $2W9st = parcelRequire("2W9st");

var $k5GZm = parcelRequire("k5GZm");

var $hRmkR = parcelRequire("hRmkR");

var $1GKWW = parcelRequire("1GKWW");
function $ed2c41070da0520e$export$eab59b6e2893da88(sides = 3, area = 100, centroid = [
    0,
    0
]) {
    const r = Math.sqrt(area / Math.PI), xs = Array.from({
        length: sides
    }, ()=>2 * r * Math.random()), ys = Array.from({
        length: sides
    }, ()=>2 * r * Math.random());
    xs.sort((a, b)=>a - b);
    ys.sort((a, b)=>a - b);
    const vecXS = $ed2c41070da0520e$var$chain(xs, xs[0], xs[xs.length - 1]), vecYS = $ed2c41070da0520e$var$chain(ys, ys[0], ys[ys.length - 1]);
    $ed2c41070da0520e$var$shuffle(vecYS);
    //Make polygon coordinates from the vecs by laying them out end to end
    let polygon = [], x = 0, y = 0;
    // Zip the vector arrays together
    // Then, sort the vectors by angle, in a counter clockwise fashion. 
    // a and b are tuples representing vectors. Compute angle for each vector and compare them.
    const vecs = vecXS.map((d, i)=>[
            d,
            vecYS[i]
        ]).sort((a, b)=>Math.atan2(b[1], b[0]) - Math.atan2(a[1], a[0])).forEach((vec)=>{
        x += vec[0] * 1;
        y += vec[1] * 1;
        polygon.push([
            x,
            y
        ]);
    });
    // Scale and translate
    const c = (0, $k5GZm.polygonCentroid)(polygon);
    return (0, $1GKWW.polygonTranslate)((0, $hRmkR.polygonScaleArea)(polygon, area / (0, $2W9st.polygonArea)(polygon)), (0, $SyezW.lineAngle)([
        c,
        centroid
    ]), (0, $83wtC.lineLength)([
        c,
        centroid
    ]));
}
function $ed2c41070da0520e$var$chain(values, min, max) {
    let lastMin = min, lastMax = min;
    const output = [];
    for(let i = 1; i < values.length - 1; i++){
        const val = values[i];
        if (Math.random() > 0.5) {
            output.push(val - lastMin);
            lastMin = val;
        } else {
            output.push(lastMax - val);
            lastMax = val;
        }
    }
    output.push(max - lastMin);
    output.push(lastMax - max);
    return output;
}
function $ed2c41070da0520e$var$shuffle(array) {
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
}

});
parcelRegister("hRmkR", function(module, exports) {

$parcel$export(module.exports, "polygonScaleArea", () => $d008b63d72af91c4$export$7faa2d0192638a98);

var $SyezW = parcelRequire("SyezW");

var $83wtC = parcelRequire("83wtC");

var $51Pd3 = parcelRequire("51Pd3");

var $k5GZm = parcelRequire("k5GZm");
function $d008b63d72af91c4$export$7faa2d0192638a98(polygon, scale, origin) {
    if (!origin) origin = (0, $k5GZm.polygonCentroid)(polygon);
    let p = [];
    for(let i = 0, l = polygon.length; i < l; i++){
        const v = polygon[i], d = (0, $83wtC.lineLength)([
            origin,
            v
        ]), a = (0, $SyezW.lineAngle)([
            origin,
            v
        ]);
        p[i] = (0, $51Pd3.pointTranslate)(origin, a, d * Math.sqrt(scale));
    }
    return p;
}

});

parcelRegister("1GKWW", function(module, exports) {

$parcel$export(module.exports, "polygonTranslate", () => $13ae21ebdd842f44$export$9e8bf6bd83076c93);

var $51Pd3 = parcelRequire("51Pd3");
function $13ae21ebdd842f44$export$9e8bf6bd83076c93(polygon, angle, distance) {
    let p = [];
    for(let i = 0, l = polygon.length; i < l; i++)p[i] = (0, $51Pd3.pointTranslate)(polygon[i], angle, distance);
    return p;
}

});


parcelRegister("9y5pj", function(module, exports) {

var $lUUlY = parcelRequire("lUUlY");

var $doyzN = parcelRequire("doyzN");
function $6f3b7bcf0d2d12c0$export$f1359e6cf7d9a783(polygon, reflectFactor = 1) {
    const [[min, _], [max, __]] = (0, $doyzN.polygonBounds)(polygon);
    const p = [];
    for(let i = 0, l = polygon.length; i < l; i++){
        const [x, y] = polygon[i];
        const r = [
            min + max - x,
            y
        ];
        if (reflectFactor === 0) p[i] = [
            x,
            y
        ];
        else if (reflectFactor === 1) p[i] = r;
        else {
            const t = (0, $lUUlY.lineInterpolate)([
                [
                    x,
                    y
                ],
                r
            ]);
            p[i] = t(Math.max(Math.min(reflectFactor, 1), 0));
        }
    }
    return p;
}

});

parcelRegister("cMcGI", function(module, exports) {

var $lUUlY = parcelRequire("lUUlY");

var $doyzN = parcelRequire("doyzN");
function $94d3cf513541b236$export$af7d10374c720277(polygon, reflectFactor = 1) {
    const [[_, min], [__, max]] = (0, $doyzN.polygonBounds)(polygon);
    const p = [];
    for(let i = 0, l = polygon.length; i < l; i++){
        const [x, y] = polygon[i];
        const r = [
            x,
            min + max - y
        ];
        if (reflectFactor === 0) p[i] = [
            x,
            y
        ];
        else if (reflectFactor === 1) p[i] = r;
        else {
            const t = (0, $lUUlY.lineInterpolate)([
                [
                    x,
                    y
                ],
                r
            ]);
            p[i] = t(Math.max(Math.min(reflectFactor, 1), 0));
        }
    }
    return p;
}

});

parcelRegister("ghaI4", function(module, exports) {

var $SyezW = parcelRequire("SyezW");

var $83wtC = parcelRequire("83wtC");

var $51Pd3 = parcelRequire("51Pd3");

var $1GKWW = parcelRequire("1GKWW");
function $bd968a9f87e818fb$export$f16b442704bd025f(sides = 3, area = 100, center) {
    let polygon = [], point = [
        0,
        0
    ], sum = [
        0,
        0
    ], angle = 0;
    for(let i = 0; i < sides; i++){
        polygon[i] = point;
        sum[0] += point[0];
        sum[1] += point[1];
        point = (0, $51Pd3.pointTranslate)(point, angle, Math.sqrt(4 * area * Math.tan(Math.PI / sides) / sides)); // https://web.archive.org/web/20180404142713/http://keisan.casio.com/exec/system/1355985985
        angle -= 360 / sides;
    }
    if (center) {
        const line = [
            [
                sum[0] / sides,
                sum[1] / sides
            ],
            center
        ];
        polygon = (0, $1GKWW.polygonTranslate)(polygon, (0, $SyezW.lineAngle)(line), (0, $83wtC.lineLength)(line));
    }
    return polygon;
}

});

parcelRegister("3UnUr", function(module, exports) {

$parcel$export(module.exports, "polygonRotate", () => $2d8925f15bfea9a6$export$c126d2a8eee83daa);

var $j3rAi = parcelRequire("j3rAi");
function $2d8925f15bfea9a6$export$c126d2a8eee83daa(polygon, angle, origin) {
    let p = [];
    for(let i = 0, l = polygon.length; i < l; i++)p[i] = (0, $j3rAi.pointRotate)(polygon[i], angle, origin);
    return p;
}

});

parcelRegister("9JapF", function(module, exports) {

var $SyezW = parcelRequire("SyezW");

var $83wtC = parcelRequire("83wtC");

var $51Pd3 = parcelRequire("51Pd3");

var $k5GZm = parcelRequire("k5GZm");
function $715064cfe8848db6$export$4555429da653477f(polygon, scale, origin) {
    if (!origin) origin = (0, $k5GZm.polygonCentroid)(polygon);
    let p = [];
    for(let i = 0, l = polygon.length; i < l; i++){
        const v = polygon[i], d = (0, $83wtC.lineLength)([
            origin,
            v
        ]), a = (0, $SyezW.lineAngle)([
            origin,
            v
        ]);
        p[i] = (0, $51Pd3.pointTranslate)(origin, a, d * scale);
    }
    return p;
}

});

parcelRegister("aRnSx", function(module, exports) {

var $SyezW = parcelRequire("SyezW");

var $83wtC = parcelRequire("83wtC");

var $51Pd3 = parcelRequire("51Pd3");

var $k5GZm = parcelRequire("k5GZm");
function $7e81606c1b122066$export$9bb2634377a3190f(polygon, scale, origin) {
    if (!origin) origin = (0, $k5GZm.polygonCentroid)(polygon);
    let p = [];
    for(let i = 0, l = polygon.length; i < l; i++){
        const v = polygon[i], d = (0, $83wtC.lineLength)([
            origin,
            v
        ]), a = (0, $SyezW.lineAngle)([
            origin,
            v
        ]), t = (0, $51Pd3.pointTranslate)(origin, a, d * scale);
        p[i] = [
            t[0],
            v[1]
        ];
    }
    return p;
}

});

parcelRegister("dij7m", function(module, exports) {

var $SyezW = parcelRequire("SyezW");

var $83wtC = parcelRequire("83wtC");

var $51Pd3 = parcelRequire("51Pd3");

var $k5GZm = parcelRequire("k5GZm");
function $9adbc92a0fdba118$export$b47183576eb195eb(polygon, scale, origin) {
    if (!origin) origin = (0, $k5GZm.polygonCentroid)(polygon);
    let p = [];
    for(let i = 0, l = polygon.length; i < l; i++){
        const v = polygon[i], d = (0, $83wtC.lineLength)([
            origin,
            v
        ]), a = (0, $SyezW.lineAngle)([
            origin,
            v
        ]), t = (0, $51Pd3.pointTranslate)(origin, a, d * scale);
        p[i] = [
            v[0],
            t[1]
        ];
    }
    return p;
}

});

parcelRegister("8DPYo", function(module, exports) {

var $2W9st = parcelRequire("2W9st");
function $64aa47fe9e42401c$export$a3421a8fa278e614(polygon, order = "ccw") {
    if (polygon.length < 3) return null;
    const reversed = polygon.slice().reverse();
    const isClockwise = (0, $2W9st.polygonArea)(polygon, true) > 0;
    if (order === "cw" || order === "clockwise") return isClockwise ? polygon : reversed;
    else return isClockwise ? reversed : polygon;
}

});

parcelRegister("cBkDd", function(module, exports) {

$parcel$export(module.exports, "lineIntersectsLine", () => $92c8f1bf9b6b0556$export$55027e237fd1a71);

var $2epWj = parcelRequire("2epWj");
function $92c8f1bf9b6b0556$export$55027e237fd1a71(lineA, lineB) {
    const [[a0x, a0y], [a1x, a1y]] = lineA, [[b0x, b0y], [b1x, b1y]] = lineB;
    // Test for shared points
    if (a0x === b0x && a0y === b0y) return true;
    if (a1x === b1x && a1y === b1y) return true;
    // Test for point on line
    if ((0, $2epWj.pointOnLine)(lineA[0], lineB) || (0, $2epWj.pointOnLine)(lineA[1], lineB)) return true;
    if ((0, $2epWj.pointOnLine)(lineB[0], lineA) || (0, $2epWj.pointOnLine)(lineB[1], lineA)) return true;
    const denom = (b1y - b0y) * (a1x - a0x) - (b1x - b0x) * (a1y - a0y);
    if (denom === 0) return false;
    const deltaY = a0y - b0y, deltaX = a0x - b0x, numer0 = (b1x - b0x) * deltaY - (b1y - b0y) * deltaX, numer1 = (a1x - a0x) * deltaY - (a1y - a0y) * deltaX, quotA = numer0 / denom, quotB = numer1 / denom;
    return quotA > 0 && quotA < 1 && quotB > 0 && quotB < 1;
}

});
parcelRegister("2epWj", function(module, exports) {

$parcel$export(module.exports, "pointOnLine", () => $1a0102a2be5b5a6f$export$453c0a9afb4a69bb);

var $83wtC = parcelRequire("83wtC");

var $3wSWn = parcelRequire("3wSWn");
// See https://math.stackexchange.com/questions/274712/calculate-on-which-side-of-a-straight-line-is-a-given-point-located
function $1a0102a2be5b5a6f$var$topPointFirst(line) {
    return line[1][1] > line[0][1] ? line : [
        line[1],
        line[0]
    ];
}
function $1a0102a2be5b5a6f$export$f412b1c395da4845(point, line) {
    const t = $1a0102a2be5b5a6f$var$topPointFirst(line);
    return (0, $3wSWn.cross)(point, t[1], t[0]) < 0;
}
function $1a0102a2be5b5a6f$export$c0fea1e8176f44b4(point, line) {
    const t = $1a0102a2be5b5a6f$var$topPointFirst(line);
    return (0, $3wSWn.cross)(point, t[1], t[0]) > 0;
}
function $1a0102a2be5b5a6f$export$453c0a9afb4a69bb(point, line, epsilon = 0) {
    const l = (0, $83wtC.lineLength)(line);
    return $1a0102a2be5b5a6f$export$39f564e56833304e(point, line, epsilon) && (0, $83wtC.lineLength)([
        line[0],
        point
    ]) <= l && (0, $83wtC.lineLength)([
        line[1],
        point
    ]) <= l;
}
function $1a0102a2be5b5a6f$export$39f564e56833304e(point, line, epsilon = 0) {
    return Math.abs((0, $3wSWn.cross)(point, line[0], line[1])) <= epsilon;
}

});


parcelRegister("3sxIR", function(module, exports) {

$parcel$export(module.exports, "lineIntersectsPolygon", () => $284e253f14caa39d$export$ba698bd5aeb7cb3d);

var $lYolD = parcelRequire("lYolD");

var $cBkDd = parcelRequire("cBkDd");

var $2epWj = parcelRequire("2epWj");
function $284e253f14caa39d$export$ba698bd5aeb7cb3d(line, polygon) {
    let intersects = false;
    const closed = (0, $lYolD.close)(polygon);
    for(let i = 0, l = closed.length - 1; i < l; i++){
        const v0 = closed[i], v1 = closed[i + 1];
        if ((0, $cBkDd.lineIntersectsLine)(line, [
            v0,
            v1
        ]) || (0, $2epWj.pointOnLine)(v0, line) && (0, $2epWj.pointOnLine)(v1, line)) {
            intersects = true;
            break;
        }
    }
    return intersects;
}

});

parcelRegister("g2BFU", function(module, exports) {

$parcel$export(module.exports, "pointInPolygon", () => $bada0eb50ac6a34a$export$7f6bc8d3d7d61b11);
// Determines whether a point is inside of a polygon, represented as an array of vertices.
// From https://github.com/substack/point-in-polygon/blob/master/index.js,
// based on the ray-casting algorithm from https://web.archive.org/web/20180115151705/https://wrf.ecse.rpi.edu//Research/Short_Notes/pnpoly.html
// Wikipedia: https://en.wikipedia.org/wiki/Point_in_polygon#Ray_casting_algorithm
// Returns a boolean.
function $bada0eb50ac6a34a$export$7f6bc8d3d7d61b11(point, polygon) {
    let x = point[0], y = point[1], inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i][0], yi = polygon[i][1], xj = polygon[j][0], yj = polygon[j][1];
        if (yi > y != yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) inside = !inside;
    }
    return inside;
}

});

parcelRegister("ltlmp", function(module, exports) {

$parcel$export(module.exports, "pointOnPolygon", () => $fa1ce02b98696cd0$export$8016c105f7c8a882);

var $lYolD = parcelRequire("lYolD");

var $2epWj = parcelRequire("2epWj");
function $fa1ce02b98696cd0$export$8016c105f7c8a882(point, polygon, epsilon = 0) {
    let on = false;
    const closed = (0, $lYolD.close)(polygon);
    for(let i = 0, l = closed.length - 1; i < l; i++)if ((0, $2epWj.pointOnLine)(point, [
        closed[i],
        closed[i + 1]
    ], epsilon)) {
        on = true;
        break;
    }
    return on;
}

});

parcelRegister("dfdxy", function(module, exports) {

$parcel$export(module.exports, "polygonInPolygon", () => $9a472ddc1eafcf0c$export$49c2f0814614c55a);

var $lYolD = parcelRequire("lYolD");

var $3sxIR = parcelRequire("3sxIR");

var $g2BFU = parcelRequire("g2BFU");
function $9a472ddc1eafcf0c$export$49c2f0814614c55a(polygonA, polygonB) {
    let inside = true;
    const closed = (0, $lYolD.close)(polygonA);
    for(let i = 0, l = closed.length - 1; i < l; i++){
        const v0 = closed[i];
        // Points test  
        if (!(0, $g2BFU.pointInPolygon)(v0, polygonB)) {
            inside = false;
            break;
        }
        // Lines test
        if ((0, $3sxIR.lineIntersectsPolygon)([
            v0,
            closed[i + 1]
        ], polygonB)) {
            inside = false;
            break;
        }
    }
    return inside;
}

});

parcelRegister("d2xzW", function(module, exports) {

$parcel$export(module.exports, "polygonIntersectsPolygon", () => $97e582485d792800$export$3ee21e7d14d075d9);

var $lYolD = parcelRequire("lYolD");

var $3sxIR = parcelRequire("3sxIR");

var $ltlmp = parcelRequire("ltlmp");
function $97e582485d792800$export$3ee21e7d14d075d9(polygonA, polygonB) {
    let intersects = false, onCount = 0;
    const closed = (0, $lYolD.close)(polygonA);
    for(let i = 0, l = closed.length - 1; i < l; i++){
        const v0 = closed[i], v1 = closed[i + 1];
        if ((0, $3sxIR.lineIntersectsPolygon)([
            v0,
            v1
        ], polygonB)) {
            intersects = true;
            break;
        }
        if ((0, $ltlmp.pointOnPolygon)(v0, polygonB)) ++onCount;
        if (onCount === 2) {
            intersects = true;
            break;
        }
    }
    return intersects;
}

});

parcelRegister("3Dma2", function(module, exports) {
// Returns the angle of reflection given an angle of incidence and a surface angle.
function $2a56344a5926fea6$export$8fca58526de1964c(incidenceAngle, surfaceAngle) {
    return (surfaceAngle * 2 - incidenceAngle % 360 + 360) % 360;
}

});


parcelRegister("g7var", function(module, exports) {

$parcel$export(module.exports, "getOrientation", () => $0d8c2b6f5fa626f9$export$67689507e8404821);
$parcel$export(module.exports, "wrapUnplacedAirplanes", () => $0d8c2b6f5fa626f9$export$5ff42dbda6929ab4);
$parcel$export(module.exports, "formatObstacles", () => $0d8c2b6f5fa626f9$export$3a4a6eca2f26899c);
parcelRequire("9vNAe");
var $3UnUr = parcelRequire("3UnUr");

var $5KGQl = parcelRequire("5KGQl");

var $keHtM = parcelRequire("keHtM");

var $cLNZr = parcelRequire("cLNZr");

var $aVGl3 = parcelRequire("aVGl3");
const $0d8c2b6f5fa626f9$export$67689507e8404821 = (tenant)=>{
    const angle = tenant.position.angle ?? $0d8c2b6f5fa626f9$export$8a74f02544894b10(tenant);
    const isGreaterThan90 = (0, $5KGQl.anglediff)(0, angle) > 90;
    if (tenant.aircraft.tail_wheel) return isGreaterThan90 ? (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN : (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN;
    return isGreaterThan90 ? (0, $keHtM.Preference).TAIL_IN : (0, $keHtM.Preference).NOSE_IN;
};
const $0d8c2b6f5fa626f9$export$8a74f02544894b10 = (tenant)=>{
    if (tenant.position.preferences.indexOf((0, $keHtM.Preference).TAIL_IN) > -1 || tenant.position.preferences.indexOf((0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN) > -1) return 180;
    return 0;
};
const $0d8c2b6f5fa626f9$export$5ff42dbda6929ab4 = (tenants, width, feetToPixels, singleRow = false, isHoldingArea = false)=>{
    if (isHoldingArea) return $0d8c2b6f5fa626f9$export$13768e49b06fff74(tenants, width, feetToPixels);
    /**
   * go through each tenant. if it's unplaced, then assign values
   * x and y should return after > width
   */ const tenantsToReturn = [];
    let currentX = 0;
    let rowStartingY = isHoldingArea ? -(window.innerHeight - 230) / feetToPixels : 0;
    let maxLengthForRow = 0;
    for (const tenant of tenants){
        if (tenant.position.x == null) {
            tenantsToReturn.push({
                ...tenant,
                position: {
                    ...tenant.position,
                    angle: $0d8c2b6f5fa626f9$export$8a74f02544894b10(tenant),
                    x: currentX,
                    y: -Math.max(tenant.aircraft.wingspan, tenant.aircraft.length) - rowStartingY
                }
            });
            currentX += Math.max(tenant.aircraft.wingspan, tenant.aircraft.length);
            maxLengthForRow = Math.max(maxLengthForRow, tenant.aircraft.length);
            if (currentX * feetToPixels > width) {
                currentX = 0;
                rowStartingY += singleRow && isHoldingArea === false ? 0 : maxLengthForRow;
                maxLengthForRow = 0;
            }
            continue;
        }
        tenantsToReturn.push(tenant);
    }
    return tenantsToReturn;
};
const $0d8c2b6f5fa626f9$export$c6a549327d9a766e = ()=>{
    const element = document.querySelector('div[data-location-id="holding-area"] canvas');
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    return rect.height;
};
const $0d8c2b6f5fa626f9$export$13768e49b06fff74 = (tenants, width, feetToPixels)=>{
    /**
   * go through each tenant. if it's unplaced, then assign values
   * x and y should return after > width
   */ const tenantsInSizeOrder = tenants.sort((a, b)=>{
        const sqftA = a.aircraft.length * a.aircraft.wingspan;
        const sqftB = b.aircraft.length * b.aircraft.wingspan;
        return sqftB - sqftA;
    }).filter((tenant)=>tenant.position.x == null);
    const holdingAreaHeight = $0d8c2b6f5fa626f9$export$c6a549327d9a766e() / feetToPixels;
    let currentMaxX = 0;
    let currentMaxDepth = 0;
    const tenantsToReturn = [];
    const rowHeights = [
        0
    ];
    const widthInFeet = width / feetToPixels;
    for (const tenant of tenantsInSizeOrder){
        const span = Math.max(tenant.aircraft.wingspan, tenant.aircraft.length);
        // check to see if it's going to go off the screen. if so, then move to the next line
        if (currentMaxX + span > widthInFeet) {
            rowHeights.push(currentMaxDepth);
            tenantsToReturn.push({
                ...tenant,
                position: {
                    ...tenant.position,
                    angle: $0d8c2b6f5fa626f9$export$8a74f02544894b10(tenant),
                    x: 0,
                    y: holdingAreaHeight - span - (0, $cLNZr.sum)(rowHeights)
                }
            });
            currentMaxDepth = span;
            currentMaxX = span;
        } else {
            tenantsToReturn.push({
                ...tenant,
                position: {
                    ...tenant.position,
                    angle: $0d8c2b6f5fa626f9$export$8a74f02544894b10(tenant),
                    x: currentMaxX,
                    y: holdingAreaHeight - span - (0, $cLNZr.sum)(rowHeights)
                }
            });
            currentMaxDepth = Math.max(span, currentMaxDepth);
            currentMaxX += span;
        }
    }
    return [
        ...tenants.filter((tenant)=>tenant.position.x != null),
        ...tenantsToReturn
    ];
};
const $0d8c2b6f5fa626f9$export$3a4a6eca2f26899c = (hangar)=>{
    const obstacles = [];
    for (const obstacle of hangar.obstacles){
        if (obstacle.type === (0, $keHtM.ObstacleType).UNOBSTRUCTIVE) continue;
        if (obstacle.type === (0, $keHtM.ObstacleType).CAUTION) continue;
        // need to flip the y axis for postgis
        let o = {
            height: obstacle.height,
            geom: {
                type: "Polygon",
                coordinates: [
                    obstacle.geom.coordinates.flat().map(([x, y])=>[
                            x,
                            hangar.depth - y
                        ])
                ]
            }
        };
        // it's easier to do this here instead of on the backend.
        // we're going to add in wall spacing to the obstacle if is touching the wall
        // if is it is touching the left wall and the top wall (top left corner)
        if (Math.min(...obstacle.geom.coordinates[0].map(([x])=>x)) === 0 && Math.min(...obstacle.geom.coordinates[0].map(([_, y])=>y)) === 0) {
            const geom = (0, $aVGl3.getObstacleGeometry)(obstacle, {
                right: hangar.wall_spacing_left,
                bottom: hangar.wall_spacing_back
            });
            o = {
                height: obstacle.height,
                geom: {
                    type: "Polygon",
                    coordinates: [
                        geom.coordinates.flat().map(([x, y])=>[
                                x,
                                hangar.depth - y
                            ])
                    ]
                }
            };
        // if is it is touching the right wall and the top wall (top right corner)
        } else if (Math.max(...obstacle.geom.coordinates[0].map(([x, _])=>x)) === hangar.width && Math.min(...obstacle.geom.coordinates[0].map(([_, y])=>y)) === 0) {
            const geom = (0, $aVGl3.getObstacleGeometry)(obstacle, {
                left: hangar.wall_spacing_right,
                bottom: hangar.wall_spacing_back
            });
            o = {
                height: obstacle.height,
                geom: {
                    type: "Polygon",
                    coordinates: [
                        geom.coordinates.flat().map(([x, y])=>[
                                x,
                                hangar.depth - y
                            ])
                    ]
                }
            };
        // is it touching the left wall?
        } else if (Math.min(...obstacle.geom.coordinates[0].map(([x])=>x)) === 0) {
            const geom = (0, $aVGl3.getObstacleGeometry)(obstacle, {
                right: hangar.wall_spacing_left,
                top: hangar.wall_spacing_left,
                bottom: hangar.wall_spacing_left
            });
            o = {
                height: obstacle.height,
                geom: {
                    type: "Polygon",
                    coordinates: [
                        geom.coordinates.flat().map(([x, y])=>[
                                x,
                                hangar.depth - y
                            ])
                    ]
                }
            };
        } else if (Math.min(...obstacle.geom.coordinates[0].map(([_, y])=>y)) === 0) {
            const geom = (0, $aVGl3.getObstacleGeometry)(obstacle, {
                right: hangar.wall_spacing_back,
                left: hangar.wall_spacing_back,
                bottom: hangar.wall_spacing_back
            });
            o = {
                height: obstacle.height,
                geom: {
                    type: "Polygon",
                    coordinates: [
                        geom.coordinates.flat().map(([x, y])=>[
                                x,
                                hangar.depth - y
                            ])
                    ]
                }
            };
        } else if (Math.max(...obstacle.geom.coordinates[0].map(([x])=>x)) === hangar.width) {
            const geom = (0, $aVGl3.getObstacleGeometry)(obstacle, {
                top: hangar.wall_spacing_right,
                left: hangar.wall_spacing_right,
                bottom: hangar.wall_spacing_right
            });
            o = {
                height: obstacle.height,
                geom: {
                    type: "Polygon",
                    coordinates: [
                        geom.coordinates.flat().map(([x, y])=>[
                                x,
                                hangar.depth - y
                            ])
                    ]
                }
            };
        }
        obstacles.push(o);
    }
    for (const { obstacle: obstacle, position: position } of hangar.stack.movableObstacles){
        const basePolygon = obstacle.geom.coordinates[0].map(([x, y])=>[
                x + position.x,
                y + position.y
            ]);
        const center = Math.max(obstacle.width, obstacle.length) / 2;
        const pivotPoint = [
            center + position.x,
            center + position.y
        ];
        const polygon = $3UnUr.polygonRotate(basePolygon, // geometric rotates the other way, so negate the angle
        -position.angle, pivotPoint);
        obstacles.push({
            height: obstacle.height,
            geom: {
                type: "Polygon",
                coordinates: [
                    polygon
                ]
            }
        });
    }
    return obstacles;
};

});
parcelRegister("aVGl3", function(module, exports) {

$parcel$export(module.exports, "getObstacleGeometry", () => $1961243c93f03f75$export$206d1ba9ccb788d1);
$parcel$export(module.exports, "ObstacleToolbar", () => $1961243c93f03f75$export$63a29910fdf93807);
$parcel$export(module.exports, "ObstacleCanvas", () => $1961243c93f03f75$export$5b5da4b86d48efce);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $ex6lH = parcelRequire("ex6lH");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $kzQHY = parcelRequire("kzQHY");

var $ga8GY = parcelRequire("ga8GY");

var $5g4nb = parcelRequire("5g4nb");

var $2USWk = parcelRequire("2USWk");

var $kfxZt = parcelRequire("kfxZt");
const $1961243c93f03f75$export$206d1ba9ccb788d1 = (obstacle, spacing = {})=>{
    return {
        type: "Polygon",
        coordinates: [
            [
                // top left
                [
                    obstacle.x - (spacing.left ?? 0),
                    obstacle.y - (spacing.top ?? 0)
                ],
                // top right
                [
                    obstacle.x + obstacle.width + (spacing.right ?? 0),
                    obstacle.y - (spacing.top ?? 0)
                ],
                // bottom right
                [
                    obstacle.x + obstacle.width + (spacing.right ?? 0),
                    obstacle.y + obstacle.depth + (spacing.bottom ?? 0)
                ],
                // bottom left
                [
                    obstacle.x - (spacing.left ?? 0),
                    obstacle.y + obstacle.depth + (spacing.bottom ?? 0)
                ],
                // top left
                [
                    obstacle.x - (spacing.left ?? 0),
                    obstacle.y - (spacing.top ?? 0)
                ]
            ]
        ]
    };
};
const $1961243c93f03f75$export$63a29910fdf93807 = ({ hangar: hangar, onAdd: onAdd })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [open, setOpen] = $acw62.useState(false);
    const [obstacle, setObstacle] = $acw62.useState();
    $acw62.useEffect(()=>{
        setObstacle({
            fbo_id: activeFBO.id,
            hangar_id: hangar.id,
            id: (0, $lNEp2.uuidv4)(),
            x: 0,
            y: 0,
            width: 20,
            depth: 20,
            height: null,
            geom: $1961243c93f03f75$export$206d1ba9ccb788d1({
                x: 0,
                y: 0,
                width: 20,
                depth: 20
            }),
            type: activeFBO.subscription === "standard" ? (0, $keHtM.ObstacleType).NO_TOW_AREA : (0, $keHtM.ObstacleType).OBSTRUCTION
        });
    }, [
        open
    ]);
    const handleClose = ()=>{
        setOpen(false);
    };
    if (!obstacle) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {});
    const unit = activeFBO?.settings?.useMetricSystem ? "m" : "ft";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "row",
                justifyContent: "flex-end",
                spacing: 1,
                sx: {
                    mb: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "Add Obstacle",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "info",
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                onClick: ()=>setOpen(true),
                                children: "Add Obstacle"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                    fontSize: "small"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    children: "right-click to delete an obstacle"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: ()=>setOpen(false),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Add Obstacle/No Tow Area"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                    fullWidth: true,
                                    size: "small",
                                    select: true,
                                    required: true,
                                    value: obstacle.type,
                                    onChange: (evt)=>setObstacle({
                                            ...obstacle,
                                            type: evt.target.value
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                            value: (0, $keHtM.ObstacleType).OBSTRUCTION,
                                            disabled: activeFBO.subscription === "standard",
                                            children: "obstruction"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                            value: (0, $keHtM.ObstacleType).NO_TOW_AREA,
                                            children: "no tow area"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                            value: (0, $keHtM.ObstacleType).UNOBSTRUCTIVE,
                                            children: "unobstructive"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                            value: (0, $keHtM.ObstacleType).CAUTION,
                                            children: "caution"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                    type: "number",
                                    fullWidth: true,
                                    required: true,
                                    inputProps: {
                                        min: 1,
                                        max: 1000,
                                        step: 0.1
                                    },
                                    size: "small",
                                    onChange: (value)=>setObstacle({
                                            ...obstacle,
                                            width: value
                                        }),
                                    value: obstacle.width,
                                    label: `Width (${unit})`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                    type: "number",
                                    fullWidth: true,
                                    required: true,
                                    inputProps: {
                                        min: 1,
                                        max: 1000,
                                        step: 0.1
                                    },
                                    size: "small",
                                    onChange: (value)=>setObstacle({
                                            ...obstacle,
                                            depth: value
                                        }),
                                    value: obstacle.depth,
                                    label: `Depth (${unit})`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                    type: "number",
                                    fullWidth: true,
                                    inputProps: {
                                        min: 1,
                                        max: 100,
                                        step: 0.1
                                    },
                                    size: "small",
                                    onChange: (value)=>setObstacle({
                                            ...obstacle,
                                            height: value
                                        }),
                                    value: obstacle.height,
                                    label: `Height (${unit})`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleClose,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    flex: "1 0 0"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                onClick: ()=>{
                                    onAdd({
                                        ...obstacle,
                                        geom: $1961243c93f03f75$export$206d1ba9ccb788d1(obstacle)
                                    });
                                    handleClose();
                                },
                                children: "Add"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $1961243c93f03f75$export$5b5da4b86d48efce = ({ hangar: hangar, setHangar: setHangar, referenceImage: referenceImage, bays: bays = [], hideToolbar: hideToolbar = false })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [canvasHeight, setCanvasHeight] = $acw62.useState(0);
    const div = $acw62.useCallback((node)=>{
        if (node?.offsetWidth && node?.offsetHeight) {
            const maxHeight = Math.min(node.parentNode.parentNode.parentNode.offsetHeight - 100, // 999999999,
            node?.offsetWidth * (hangar.depth / hangar.width));
            setCanvasHeight(maxHeight);
        }
    }, [
        hangar?.width
    ]);
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const canvasWidth = canvasHeight * hangar?.width / hangar?.depth;
    const feetToPixels = (feet)=>feet * canvasWidth / hangar?.width;
    if (!hangar) return null;
    const draw = $acw62.useCallback((ctx)=>{
        ctx.clearRect(-1, -1, canvasWidth, canvasHeight);
        (0, $kfxZt.drawDoors)(ctx, hangar, feetToPixels);
        (0, $kfxZt.drawSpacingBuffers)(ctx, hangar, feetToPixels, {
            showWallSpacingFill: true // Always show fill in the settings editor
        });
        // NEW: Draw bay boundaries with color-coding
        if (bays && bays.length > 0) {
            (0, $kfxZt.drawBayBoundaries)(ctx, bays, hangar, feetToPixels, {
                showLabels: true,
                showHeights: true
            });
            // Draw uncovered areas with hatching pattern
            (0, $kfxZt.drawUncoveredAreas)(ctx, bays, hangar, feetToPixels);
        }
        (0, $kfxZt.drawUnobstructiveObstacles)(ctx, hangar, feetToPixels);
        (0, $kfxZt.drawGarageDoorMarkers)(ctx, hangar, hangar.garageDoors, feetToPixels, activeFBO?.settings?.useMetricSystem ? "m" : "ft");
        (0, $kfxZt.drawDistanceMarkers)(ctx, hangar, hangar.obstacles.find((o)=>o.active), feetToPixels, activeFBO?.settings?.useMetricSystem ? "m" : "ft");
        (0, $kfxZt.clearBackgroundForObstacles)(ctx, hangar, feetToPixels);
    }, [
        hangar,
        bays,
        canvasHeight,
        feetToPixels
    ]);
    const handleMouseDown = ()=>{};
    const handleMouseMove = ()=>{};
    const handleMouseExit = ()=>{};
    const backgroundColor = Boolean(referenceImage) ? "transparent" : "#E8EBF1";
    const dashColor = "#ADBDD5";
    const dashWidth = 3;
    const gridSize = feetToPixels(10);
    const dashLength = gridSize / 10;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        sx: {
            width: "100%"
        },
        children: [
            !hideToolbar && /*#__PURE__*/ (0, $ayMG0.jsx)($1961243c93f03f75$export$63a29910fdf93807, {
                hangar: hangar,
                onAdd: (obstacle)=>setHangar({
                        ...hangar,
                        obstacles: [
                            ...hangar.obstacles,
                            obstacle
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                ref: div,
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            position: "absolute",
                            // need to account for border here
                            width: canvasWidth,
                            height: canvasHeight
                        },
                        children: [
                            hangar.obstacles.filter(()=>{
                                const activeGarageDoor = hangar.garageDoors.find((g)=>g.active);
                                return !Boolean(activeGarageDoor);
                            }).map((obstacle)=>/*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2USWk.DraggableObstacle), {
                                        hangar: hangar,
                                        setHangar: setHangar,
                                        feetToPixels: feetToPixels(1),
                                        obstacle: obstacle,
                                        onDrag: (obstacle)=>{
                                            setHangar({
                                                ...hangar,
                                                obstacles: hangar.obstacles.map((o)=>o.id === obstacle.id ? obstacle : o)
                                            });
                                        },
                                        onDelete: (obstacle)=>setHangar({
                                                ...hangar,
                                                obstacles: hangar.obstacles.filter((o)=>o.id !== obstacle.id)
                                            })
                                    })
                                }, `obstacle-${obstacle.id}`)),
                            hangar.garageDoors.filter(()=>{
                                const activeObstacle = hangar.obstacles.find((o)=>o.active);
                                return !Boolean(activeObstacle);
                            }).map((garageDoor)=>/*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5g4nb.DraggableGarageDoor), {
                                        hangar: hangar,
                                        feetToPixels: feetToPixels(1),
                                        garageDoor: garageDoor,
                                        onDrag: (garageDoor)=>{
                                            setHangar({
                                                ...hangar,
                                                garageDoors: hangar.garageDoors.map((g)=>g.id === garageDoor.id ? garageDoor : g)
                                            });
                                        },
                                        onDelete: (garageDoor)=>setHangar({
                                                ...hangar,
                                                garageDoors: hangar.garageDoors.filter((g)=>g.id !== garageDoor.id)
                                            })
                                    })
                                }, `garageDoor-${garageDoor.id}`))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            // https://s3-prod.dogtopia.com/wp-content/uploads/2019/03/0-570x380.jpg
                            backgroundImage: `url(${referenceImage})`,
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ga8GY.default), {
                            ref: canvasRef,
                            width: canvasWidth,
                            height: canvasHeight,
                            draw: draw,
                            onMouseDown: handleMouseDown,
                            onMouseMove: handleMouseMove,
                            onMouseUp: handleMouseExit,
                            onMouseLeave: handleMouseExit,
                            style: {
                                backgroundColor: backgroundColor,
                                backgroundSize: `${dashLength * 2}px ${dashLength * 2}px, ${gridSize}px ${gridSize}px`,
                                backgroundPosition: `${-dashWidth / 2}px ${-dashWidth / 2}px`,
                                backgroundImage: `linear-gradient(to bottom, transparent 5px, ${backgroundColor} 5px),
              linear-gradient(to right, ${dashColor}50 3px, transparent 3px),
              linear-gradient(to right, transparent 5px, ${backgroundColor} 5px),
              linear-gradient(to bottom, ${dashColor}50 3px, transparent 3px)
            `
                            }
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7tqxO", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $570fd50501d08ed5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $570fd50501d08ed5$var$_createSvgIcon = $570fd50501d08ed5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $570fd50501d08ed5$var$_default = module.exports.default = (0, $570fd50501d08ed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');

});

parcelRegister("kzQHY", function(module, exports) {

$parcel$export(module.exports, "MetricAwareTextField", () => $8bc2d10841345460$export$cd3f51794d7c1dc5);

var $ayMG0 = parcelRequire("ayMG0");

var $iAtns = parcelRequire("iAtns");

var $acw62 = parcelRequire("acw62");

var $cLNZr = parcelRequire("cLNZr");

var $02ITL = parcelRequire("02ITL");
const $8bc2d10841345460$export$cd3f51794d7c1dc5 = ({ value: value, decimals: decimalsProvided, unit: unit, onChange: onChange, onBlur: onBlur, ...textFieldProps })=>{
    const defaultDecimals = unit === "meters" ? 2 : 1;
    const decimals = decimalsProvided ?? defaultDecimals;
    // Conversion factors
    const METERS_TO_FEET = 3.28084;
    // Local state for tracking user input during editing
    const [inputValue, setInputValue] = $acw62.useState("");
    const [isFocused, setIsFocused] = $acw62.useState(false);
    // Compute display value from prop
    const displayValue = (0, $cLNZr.round)(unit === "meters" ? value / METERS_TO_FEET : value, decimals // Use calculated precision (meters=2, feet=1)
    );
    // Sync local input state when parent value changes externally (only when not focused)
    $acw62.useEffect(()=>{
        if (!isFocused) setInputValue(displayValue.toFixed(decimals));
    }, [
        displayValue,
        isFocused,
        decimals
    ]);
    // Handle input changes - just update local state while typing
    const handleInputChange = (event)=>{
        setInputValue(event.target.value);
    };
    // Handle focus - initialize input value for editing
    const handleFocus = (event)=>{
        setIsFocused(true);
        setInputValue(displayValue.toFixed(decimals));
        textFieldProps.onFocus?.(event);
    };
    // Handle blur - parse input and update parent
    const handleBlur = (_event)=>{
        setIsFocused(false);
        const parsedValue = (0, $02ITL.parseLocaleNumber)(inputValue);
        const conversion = unit === "meters" ? METERS_TO_FEET : 1;
        const valueInFeet = parsedValue * conversion;
        // Update parent with parsed value
        onChange(valueInFeet);
        // Call parent's onBlur if provided
        if (onBlur) onBlur(valueInFeet);
    };
    // Step size matches decimal precision
    const step = decimals === 0 ? 1 : Math.pow(10, -decimals);
    // Handle arrow key increment/decrement
    const handleKeyDown = (event)=>{
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault(); // Prevent default browser behavior
            // Calculate new display value
            const delta = event.key === 'ArrowUp' ? step : -step;
            const newDisplayValue = Math.max(0, displayValue + delta); // Don't go below 0
            // Update local input state for immediate visual feedback
            setInputValue(newDisplayValue.toFixed(decimals));
            // Convert to feet and call onChange
            const conversion = unit === "meters" ? METERS_TO_FEET : 1;
            const valueInFeet = newDisplayValue * conversion;
            onChange(valueInFeet);
        }
    };
    // Extract and convert min/max constraints from parent
    // Parent provides values in feet (internal storage unit), but HTML validation
    // needs them in display units to match displayValue
    const parentInputProps = textFieldProps.InputProps?.inputProps || {};
    const convertConstraint = (valueInFeet)=>{
        if (valueInFeet === undefined) return undefined;
        return unit === "meters" ? (0, $cLNZr.round)(valueInFeet / METERS_TO_FEET, 2) : valueInFeet;
    };
    const convertedMin = convertConstraint(parentInputProps.min) ?? 0;
    const convertedMax = convertConstraint(parentInputProps.max);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
        ...textFieldProps,
        type: "text" // Use text input for locale-aware decimal handling
        ,
        onChange: handleInputChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        value: isFocused ? inputValue : displayValue.toFixed(decimals),
        InputProps: {
            ...textFieldProps.InputProps,
            endAdornment: unit === "meters" ? "m" : "ft",
            inputProps: {
                ...parentInputProps,
                inputMode: "decimal",
                // Shows numeric keyboard on mobile
                pattern: "[0-9.,\\-]*",
                step: // Allow numbers, comma, period, and minus
                step,
                min: convertedMin,
                ...convertedMax !== undefined && {
                    max: convertedMax
                }
            }
        }
    });
};

});
parcelRegister("02ITL", function(module, exports) {

$parcel$export(module.exports, "parseLocaleNumber", () => $6e4ea5629f3a2191$export$5e0c99971929e08f);
/**
 * Locale-aware number parsing utilities for handling different decimal separators.
 *
 * HTML5 type="number" inputs only support period (.) as decimal separator,
 * which breaks for users in locales that use comma (,) as decimal separator.
 * These utilities normalize input to handle both separators correctly.
 */ /**
 * Gets the user's locale from browser settings.
 * Falls back to en-US if detection fails.
 */ function $6e4ea5629f3a2191$export$a6ea185b366483aa() {
    if (typeof navigator === 'undefined') return 'en-US';
    return navigator.languages?.[0] || navigator.language || 'en-US';
}
function $6e4ea5629f3a2191$export$4747ae6d092bd1d2(locale) {
    const userLocale = locale || $6e4ea5629f3a2191$export$a6ea185b366483aa();
    // Use Intl.NumberFormat to detect the decimal separator
    const formatter = new Intl.NumberFormat(userLocale);
    const parts = formatter.formatToParts(1.1);
    const decimalPart = parts.find((part)=>part.type === 'decimal');
    return decimalPart?.value === ',' ? ',' : '.';
}
function $6e4ea5629f3a2191$export$5e0c99971929e08f(value) {
    if (!value || typeof value !== 'string') return NaN;
    // Trim whitespace
    const trimmed = value.trim();
    if (trimmed === '') return NaN;
    // Detect which separator is being used as decimal based on position
    // The decimal separator is typically the LAST occurrence of comma or period
    const lastComma = trimmed.lastIndexOf(',');
    const lastPeriod = trimmed.lastIndexOf('.');
    let normalized;
    if (lastComma === -1 && lastPeriod === -1) // No decimal separator, just parse as integer
    normalized = trimmed;
    else if (lastComma > lastPeriod) // Comma appears after period, so comma is the decimal separator
    // Remove all periods (thousands separators) and replace comma with period
    normalized = trimmed.replace(/\./g, '').replace(',', '.');
    else // Period appears after comma (or no comma), so period is the decimal separator
    // Remove all commas (thousands separators)
    normalized = trimmed.replace(/,/g, '');
    return parseFloat(normalized);
}
function $6e4ea5629f3a2191$export$2dac130afdb37a67(value, decimals = 2, locale) {
    const userLocale = locale || $6e4ea5629f3a2191$export$a6ea185b366483aa();
    return new Intl.NumberFormat(userLocale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(value);
}

});


parcelRegister("ga8GY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b934dfc7f4d0bf10$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $b934dfc7f4d0bf10$var$useCanvas = (canvasRef, draw)=>{
    (0, $acw62.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const context = canvas.getContext("2d");
        if (!context) return;
        // Save the current transformation matrix
        context.save();
        // Apply sub-pixel offset for crisp lines
        context.translate(0.5, 0.5);
        // Call the draw function
        draw(context);
        // Restore the transformation matrix
        context.restore();
        return ()=>{};
    }, [
        canvasRef,
        draw
    ]);
    return canvasRef;
};
const $b934dfc7f4d0bf10$var$Canvas = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ draw: draw, width: width, height: height, ...rest }, ref)=>{
    const internalRef = (0, $acw62.useRef)(null);
    $b934dfc7f4d0bf10$var$useCanvas(internalRef, draw);
    (0, $acw62.useImperativeHandle)(ref, ()=>internalRef.current);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("canvas", {
        id: "canvas",
        ref: internalRef,
        width: width,
        height: height,
        ...rest
    });
});
var $b934dfc7f4d0bf10$export$2e2bcd8739ae039 = $b934dfc7f4d0bf10$var$Canvas;

});

parcelRegister("5g4nb", function(module, exports) {

$parcel$export(module.exports, "DraggableGarageDoor", () => $3aad4cf97fb3bc07$export$dd55638f1374c1af);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");

var $acw62 = parcelRequire("acw62");

var $lrh3u = parcelRequire("lrh3u");
const $3aad4cf97fb3bc07$export$ec189fad4f4cb8ed = ({ anchorEl: anchorEl, onDelete: onDelete, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        anchorOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        onClose: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
            onClick: onDelete,
            children: "Delete"
        })
    });
};
const $3aad4cf97fb3bc07$export$dd55638f1374c1af = ({ hangar: hangar, feetToPixels: feetToPixels, garageDoor: garageDoor, onDrag: onDrag, onDelete: onDelete })=>{
    const PX_WIDTH = 2;
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const x = garageDoor.wall === "back" ? feetToPixels * garageDoor.x : garageDoor.wall === "right" ? feetToPixels * (hangar.width - PX_WIDTH) : 0;
    const y = garageDoor.wall === "back" ? 0 : feetToPixels * garageDoor.y;
    const sx = {
        backgroundColor: "#FFAC1C",
        border: "#FFAC1C"
    };
    const sxHover = {
        backgroundColor: "#f59e07",
        border: "#f59e07"
    };
    const nodeRef = $acw62.useRef(null);
    if (!feetToPixels) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lrh3u))), {
                nodeRef: nodeRef,
                bounds: "parent",
                axis: garageDoor.wall === "back" ? "x" : "y",
                position: {
                    x: x,
                    y: y
                },
                onDrag: (evt, data)=>{
                    let x, y;
                    if (garageDoor.wall === "back") {
                        x = data.x / feetToPixels;
                        y = hangar.depth;
                    } else if (garageDoor.wall === "right") {
                        x = hangar.width;
                        y = data.y / feetToPixels;
                    } else if (garageDoor.wall === "left") {
                        x = 0;
                        y = data.y / feetToPixels;
                    }
                    const newGarageDoor = {
                        ...garageDoor,
                        x: x,
                        y: y
                    };
                    onDrag({
                        ...newGarageDoor,
                        active: true
                    });
                },
                onStop: ()=>{
                    onDrag({
                        ...garageDoor,
                        active: false
                    });
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    ref: nodeRef,
                    onContextMenu: (evt)=>{
                        evt.preventDefault();
                        setAnchorEl(evt.currentTarget);
                    },
                    sx: {
                        ...sx,
                        position: "absolute",
                        cursor: "grab",
                        width: garageDoor.wall === "back" ? garageDoor.width * feetToPixels : PX_WIDTH * feetToPixels,
                        height: garageDoor.wall === "back" ? PX_WIDTH * feetToPixels : garageDoor.width * feetToPixels,
                        "&:hover": {
                            ...sxHover
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($3aad4cf97fb3bc07$export$ec189fad4f4cb8ed, {
                anchorEl: anchorEl,
                onClose: ()=>setAnchorEl(null),
                onDelete: ()=>onDelete(garageDoor)
            })
        ]
    });
};

});
parcelRegister("lrh3u", function(module, exports) {
"use strict";

var $6UOTq = parcelRequire("6UOTq");
var $f9b9596425583678$require$Draggable = $6UOTq.default;
var $f9b9596425583678$require$DraggableCore = $6UOTq.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $f9b9596425583678$require$Draggable;
module.exports.default = $f9b9596425583678$require$Draggable;
module.exports.DraggableCore = $f9b9596425583678$require$DraggableCore;

});
parcelRegister("6UOTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $508f735703b01dcf$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $508f735703b01dcf$var$React = $508f735703b01dcf$var$_interopRequireWildcard((parcelRequire("acw62")));

var $508f735703b01dcf$var$_propTypes = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $508f735703b01dcf$var$_reactDom = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $9QePP = parcelRequire("9QePP");

var $hVGkP = parcelRequire("hVGkP");

var $jc5pr = parcelRequire("jc5pr");

var $7jnr7 = parcelRequire("7jnr7");

var $508f735703b01dcf$var$_DraggableCore = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("7eM6q")));

var $508f735703b01dcf$var$_log = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("ldVpK")));
function $508f735703b01dcf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $508f735703b01dcf$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($508f735703b01dcf$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $508f735703b01dcf$var$_extends() {
    return $508f735703b01dcf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $508f735703b01dcf$var$_extends.apply(null, arguments);
}
function $508f735703b01dcf$var$_defineProperty(e, r, t) {
    return (r = $508f735703b01dcf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $508f735703b01dcf$var$_toPropertyKey(t) {
    var i = $508f735703b01dcf$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $508f735703b01dcf$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $508f735703b01dcf$var$Draggable extends $508f735703b01dcf$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $508f735703b01dcf$var$_log.default)('Draggable: getDerivedStateFromProps %j', {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $508f735703b01dcf$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $508f735703b01dcf$var$_log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $jc5pr.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $508f735703b01dcf$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $508f735703b01dcf$var$_log.default)('Draggable: onDrag: %j', coreData);
            const uiData = (0, $jc5pr.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $jc5pr.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $508f735703b01dcf$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $jc5pr.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $508f735703b01dcf$var$_log.default)('Draggable: onDragStop: %j', coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        if (this.state.dragging) this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        return this.props?.nodeRef?.current ?? $508f735703b01dcf$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $jc5pr.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $jc5pr.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $hVGkP.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $hVGkP.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $9QePP.clsx)(children.props.className || '', defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $508f735703b01dcf$var$React.createElement($508f735703b01dcf$var$_DraggableCore.default, $508f735703b01dcf$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $508f735703b01dcf$var$React.cloneElement($508f735703b01dcf$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
module.exports.default = $508f735703b01dcf$var$Draggable;
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "displayName", 'Draggable');
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$508f735703b01dcf$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $508f735703b01dcf$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $508f735703b01dcf$var$_propTypes.default.oneOfType([
        $508f735703b01dcf$var$_propTypes.default.shape({
            left: $508f735703b01dcf$var$_propTypes.default.number,
            right: $508f735703b01dcf$var$_propTypes.default.number,
            top: $508f735703b01dcf$var$_propTypes.default.number,
            bottom: $508f735703b01dcf$var$_propTypes.default.number
        }),
        $508f735703b01dcf$var$_propTypes.default.string,
        $508f735703b01dcf$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $508f735703b01dcf$var$_propTypes.default.string,
    defaultClassNameDragging: $508f735703b01dcf$var$_propTypes.default.string,
    defaultClassNameDragged: $508f735703b01dcf$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.number,
        y: $508f735703b01dcf$var$_propTypes.default.number
    }),
    positionOffset: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.oneOfType([
            $508f735703b01dcf$var$_propTypes.default.number,
            $508f735703b01dcf$var$_propTypes.default.string
        ]),
        y: $508f735703b01dcf$var$_propTypes.default.oneOfType([
            $508f735703b01dcf$var$_propTypes.default.number,
            $508f735703b01dcf$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.number,
        y: $508f735703b01dcf$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $7jnr7.dontSetMe,
    style: $7jnr7.dontSetMe,
    transform: $7jnr7.dontSetMe
});
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "defaultProps", {
    ...$508f735703b01dcf$var$_DraggableCore.default.defaultProps,
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});

});
parcelRegister("hVGkP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $d0d8995f7df729b6$var$addClassName;
module.exports.addEvent = $d0d8995f7df729b6$var$addEvent;
module.exports.addUserSelectStyles = $d0d8995f7df729b6$var$addUserSelectStyles;
module.exports.createCSSTransform = $d0d8995f7df729b6$var$createCSSTransform;
module.exports.createSVGTransform = $d0d8995f7df729b6$var$createSVGTransform;
module.exports.getTouch = $d0d8995f7df729b6$var$getTouch;
module.exports.getTouchIdentifier = $d0d8995f7df729b6$var$getTouchIdentifier;
module.exports.getTranslation = $d0d8995f7df729b6$var$getTranslation;
module.exports.innerHeight = $d0d8995f7df729b6$var$innerHeight;
module.exports.innerWidth = $d0d8995f7df729b6$var$innerWidth;
module.exports.matchesSelector = $d0d8995f7df729b6$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $d0d8995f7df729b6$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $d0d8995f7df729b6$var$offsetXYFromParent;
module.exports.outerHeight = $d0d8995f7df729b6$var$outerHeight;
module.exports.outerWidth = $d0d8995f7df729b6$var$outerWidth;
module.exports.removeClassName = $d0d8995f7df729b6$var$removeClassName;
module.exports.removeEvent = $d0d8995f7df729b6$var$removeEvent;
module.exports.scheduleRemoveUserSelectStyles = $d0d8995f7df729b6$var$scheduleRemoveUserSelectStyles;

var $7jnr7 = parcelRequire("7jnr7");

var $d0d8995f7df729b6$var$_getPrefix = $d0d8995f7df729b6$var$_interopRequireWildcard((parcelRequire("jnmRN")));
function $d0d8995f7df729b6$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d0d8995f7df729b6$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $d0d8995f7df729b6$var$matchesSelectorFunc = '';
function $d0d8995f7df729b6$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$d0d8995f7df729b6$var$matchesSelectorFunc) $d0d8995f7df729b6$var$matchesSelectorFunc = (0, $7jnr7.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $7jnr7.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $7jnr7.isFunction)(el[$d0d8995f7df729b6$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$d0d8995f7df729b6$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $d0d8995f7df729b6$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($d0d8995f7df729b6$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $d0d8995f7df729b6$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function $d0d8995f7df729b6$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function $d0d8995f7df729b6$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $7jnr7.int)(computedStyle.borderTopWidth);
    height += (0, $7jnr7.int)(computedStyle.borderBottomWidth);
    return height;
}
function $d0d8995f7df729b6$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $7jnr7.int)(computedStyle.borderLeftWidth);
    width += (0, $7jnr7.int)(computedStyle.borderRightWidth);
    return width;
}
function $d0d8995f7df729b6$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $7jnr7.int)(computedStyle.paddingTop);
    height -= (0, $7jnr7.int)(computedStyle.paddingBottom);
    return height;
}
function $d0d8995f7df729b6$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $7jnr7.int)(computedStyle.paddingLeft);
    width -= (0, $7jnr7.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $d0d8995f7df729b6$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $d0d8995f7df729b6$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $d0d8995f7df729b6$var$getTranslation(controlPos, positionOffset, 'px');
    return {
        [(0, $d0d8995f7df729b6$var$_getPrefix.browserPrefixToKey)('transform', $d0d8995f7df729b6$var$_getPrefix.default)]: translation
    };
}
function $d0d8995f7df729b6$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $d0d8995f7df729b6$var$getTranslation(controlPos, positionOffset, '');
    return translation;
}
function $d0d8995f7df729b6$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
        const defaultX = `${typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix}`;
        const defaultY = `${typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix}`;
        translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
}
function $d0d8995f7df729b6$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $7jnr7.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $7jnr7.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $d0d8995f7df729b6$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $d0d8995f7df729b6$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) $d0d8995f7df729b6$var$addClassName(doc.body, 'react-draggable-transparent-selection');
}
function $d0d8995f7df729b6$var$scheduleRemoveUserSelectStyles(doc /*: ?Document*/ ) {
    // Prevent a possible "forced reflow"
    if (window.requestAnimationFrame) window.requestAnimationFrame(()=>{
        $d0d8995f7df729b6$var$removeUserSelectStyles(doc);
    });
    else $d0d8995f7df729b6$var$removeUserSelectStyles(doc);
}
function $d0d8995f7df729b6$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $d0d8995f7df729b6$var$removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $d0d8995f7df729b6$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) el.className += ` ${className}`;
}
function $d0d8995f7df729b6$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, 'g'), '');
}

});
parcelRegister("7jnr7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $552c7cc0c70bb1ed$var$dontSetMe;
module.exports.findInArray = $552c7cc0c70bb1ed$var$findInArray;
module.exports.int = $552c7cc0c70bb1ed$var$int;
module.exports.isFunction = $552c7cc0c70bb1ed$var$isFunction;
module.exports.isNum = $552c7cc0c70bb1ed$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $552c7cc0c70bb1ed$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $552c7cc0c70bb1ed$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function $552c7cc0c70bb1ed$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function $552c7cc0c70bb1ed$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $552c7cc0c70bb1ed$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
}

});

parcelRegister("jnmRN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $e1b1e7274ffc28cf$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $e1b1e7274ffc28cf$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $e1b1e7274ffc28cf$var$getPrefix;
const $e1b1e7274ffc28cf$var$prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function $e1b1e7274ffc28cf$var$getPrefix() /*: string*/ {
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = window.document?.documentElement?.style;
    if (!style) return '';
    if (prop in style) return '';
    for(let i = 0; i < $e1b1e7274ffc28cf$var$prefixes.length; i++){
        if ($e1b1e7274ffc28cf$var$browserPrefixToKey(prop, $e1b1e7274ffc28cf$var$prefixes[i]) in style) return $e1b1e7274ffc28cf$var$prefixes[i];
    }
    return '';
}
function $e1b1e7274ffc28cf$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? `${prefix}${$e1b1e7274ffc28cf$var$kebabToTitleCase(prop)}` : prop;
}
function $e1b1e7274ffc28cf$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? `-${prefix.toLowerCase()}-${prop}` : prop;
}
function $e1b1e7274ffc28cf$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = '';
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $e1b1e7274ffc28cf$var$_default = module.exports.default = $e1b1e7274ffc28cf$var$getPrefix();

});


parcelRegister("jc5pr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $df93557b6a1aa90a$var$canDragX;
module.exports.canDragY = $df93557b6a1aa90a$var$canDragY;
module.exports.createCoreData = $df93557b6a1aa90a$var$createCoreData;
module.exports.createDraggableData = $df93557b6a1aa90a$var$createDraggableData;
module.exports.getBoundPosition = $df93557b6a1aa90a$var$getBoundPosition;
module.exports.getControlPosition = $df93557b6a1aa90a$var$getControlPosition;
module.exports.snapToGrid = $df93557b6a1aa90a$var$snapToGrid;

var $7jnr7 = parcelRequire("7jnr7");

var $hVGkP = parcelRequire("hVGkP");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $df93557b6a1aa90a$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === 'string' ? bounds : $df93557b6a1aa90a$var$cloneBounds(bounds);
    const node = $df93557b6a1aa90a$var$findDOMNode(draggable);
    if (typeof bounds === 'string') {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else {
            // Flow assigns the wrong return type (Node) for getRootNode(),
            // so we cast it to one of the correct types (Element).
            // The others are Document and ShadowRoot.
            // All three implement querySelector() so it's safe to call.
            const rootNode = node.getRootNode();
            boundNode = rootNode.querySelector(bounds);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $7jnr7.int)(boundNodeStyle.paddingLeft) + (0, $7jnr7.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $7jnr7.int)(boundNodeStyle.paddingTop) + (0, $7jnr7.int)(nodeStyle.marginTop),
            right: (0, $hVGkP.innerWidth)(boundNodeEl) - (0, $hVGkP.outerWidth)(node) - node.offsetLeft + (0, $7jnr7.int)(boundNodeStyle.paddingRight) - (0, $7jnr7.int)(nodeStyle.marginRight),
            bottom: (0, $hVGkP.innerHeight)(boundNodeEl) - (0, $hVGkP.outerHeight)(node) - node.offsetTop + (0, $7jnr7.int)(boundNodeStyle.paddingBottom) - (0, $7jnr7.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $7jnr7.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $7jnr7.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $7jnr7.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $7jnr7.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $df93557b6a1aa90a$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $df93557b6a1aa90a$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function $df93557b6a1aa90a$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function $df93557b6a1aa90a$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === 'number' ? (0, $hVGkP.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    const node = $df93557b6a1aa90a$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $hVGkP.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $df93557b6a1aa90a$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $7jnr7.isNum)(draggable.lastX);
    const node = $df93557b6a1aa90a$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $df93557b6a1aa90a$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $df93557b6a1aa90a$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $df93557b6a1aa90a$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("7eM6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $544f2767f390b5ca$var$React = $544f2767f390b5ca$var$_interopRequireWildcard((parcelRequire("acw62")));

var $544f2767f390b5ca$var$_propTypes = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $544f2767f390b5ca$var$_reactDom = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $hVGkP = parcelRequire("hVGkP");

var $jc5pr = parcelRequire("jc5pr");

var $7jnr7 = parcelRequire("7jnr7");

var $544f2767f390b5ca$var$_log = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("ldVpK")));
function $544f2767f390b5ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $544f2767f390b5ca$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($544f2767f390b5ca$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $544f2767f390b5ca$var$_defineProperty(e, r, t) {
    return (r = $544f2767f390b5ca$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $544f2767f390b5ca$var$_toPropertyKey(t) {
    var i = $544f2767f390b5ca$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $544f2767f390b5ca$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $544f2767f390b5ca$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
let $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  allowMobileScroll: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $544f2767f390b5ca$var$DraggableCore extends $544f2767f390b5ca$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $544f2767f390b5ca$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $544f2767f390b5ca$var$_defineProperty(this, "lastX", NaN);
        $544f2767f390b5ca$var$_defineProperty(this, "lastY", NaN);
        $544f2767f390b5ca$var$_defineProperty(this, "touchIdentifier", null);
        $544f2767f390b5ca$var$_defineProperty(this, "mounted", false);
        $544f2767f390b5ca$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $hVGkP.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $hVGkP.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart' && !this.props.allowMobileScroll) e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $hVGkP.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $jc5pr.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            (0, $544f2767f390b5ca$var$_log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $544f2767f390b5ca$var$_log.default)('calling', this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $hVGkP.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $hVGkP.addEvent)(ownerDocument, $544f2767f390b5ca$var$dragEventFor.move, this.handleDrag);
            (0, $hVGkP.addEvent)(ownerDocument, $544f2767f390b5ca$var$dragEventFor.stop, this.handleDragStop);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $jc5pr.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $jc5pr.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            (0, $544f2767f390b5ca$var$_log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $544f2767f390b5ca$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $jc5pr.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $jc5pr.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $hVGkP.scheduleRemoveUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $544f2767f390b5ca$var$_log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $544f2767f390b5ca$var$_log.default)('DraggableCore: Removing handlers');
                (0, $hVGkP.removeEvent)(thisNode.ownerDocument, $544f2767f390b5ca$var$dragEventFor.move, this.handleDrag);
                (0, $hVGkP.removeEvent)(thisNode.ownerDocument, $544f2767f390b5ca$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onMouseDown", (e)=>{
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onMouseUp", (e)=>{
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $544f2767f390b5ca$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $hVGkP.addEvent)(thisNode, $544f2767f390b5ca$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.mouse.move, this.handleDrag);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.touch.move, this.handleDrag);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $hVGkP.removeEvent)(thisNode, $544f2767f390b5ca$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $hVGkP.scheduleRemoveUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        return this.props?.nodeRef ? this.props?.nodeRef?.current : $544f2767f390b5ca$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $544f2767f390b5ca$var$React.cloneElement($544f2767f390b5ca$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $544f2767f390b5ca$var$DraggableCore;
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "displayName", 'DraggableCore');
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $544f2767f390b5ca$var$_propTypes.default.bool,
    /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */ allowMobileScroll: $544f2767f390b5ca$var$_propTypes.default.bool,
    children: $544f2767f390b5ca$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $544f2767f390b5ca$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $544f2767f390b5ca$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $544f2767f390b5ca$var$_propTypes.default.arrayOf($544f2767f390b5ca$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $544f2767f390b5ca$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $544f2767f390b5ca$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $544f2767f390b5ca$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $544f2767f390b5ca$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $7jnr7.dontSetMe,
    style: $7jnr7.dontSetMe,
    transform: $7jnr7.dontSetMe
});
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("ldVpK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7375926498124e5$var$log;
/*eslint no-console:0*/ function $f7375926498124e5$var$log() {}

});





parcelRegister("2USWk", function(module, exports) {

$parcel$export(module.exports, "DraggableObstacle", () => $5666c51c2d39ad4f$export$fdfb92d9c73adfa7);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $lrh3u = parcelRequire("lrh3u");

var $ZD2ym = parcelRequire("ZD2ym");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");

var $aVGl3 = parcelRequire("aVGl3");
const $5666c51c2d39ad4f$export$7dadc35f8f793762 = ({ anchorEl: anchorEl, onCopy: onCopy, onDelete: onDelete, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4F5tJ.default), {
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        anchorOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                onClick: onCopy,
                children: "Copy"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                onClick: onDelete,
                children: "Delete"
            })
        ]
    });
};
const $5666c51c2d39ad4f$export$fdfb92d9c73adfa7 = ({ hangar: hangar, setHangar: setHangar, feetToPixels: feetToPixels, obstacle: obstacle, onDrag: onDrag, onDelete: onDelete })=>{
    const theme = (0, $14H9o.default)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const x = feetToPixels * obstacle.x;
    const y = feetToPixels * obstacle.y;
    let sx = {};
    let sxHover = {};
    if (obstacle.type === (0, $keHtM.ObstacleType).OBSTRUCTION) {
        sx = {
            backgroundColor: "info.main",
            outline: "none"
        };
        sxHover = {
            backgroundColor: `${theme.palette.info.dark}20`,
            outline: "none"
        };
    } else if (obstacle.type === (0, $keHtM.ObstacleType).NO_TOW_AREA) {
        sx = {
            backgroundColor: "info.error",
            outline: "2px dashed red"
        };
        sxHover = {
            backgroundColor: "#EE4B2B20",
            outline: "2px dashed #EE4B2B"
        };
    } else if (obstacle.type === (0, $keHtM.ObstacleType).UNOBSTRUCTIVE) {
        sx = {
            backgroundColor: "#3c6ce990",
            outline: "none"
        };
        sxHover = {
            backgroundColor: "#3c6ce920",
            outline: "none"
        };
    } else if (obstacle.type === (0, $keHtM.ObstacleType).CAUTION) {
        sx = {
            backgroundColor: "#ECE81A90",
            outline: "none"
        };
        sxHover = {
            backgroundColor: "#ECE81A20",
            outline: "none"
        };
    }
    const BORDER_BUFFER = 0;
    const dimensions = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(obstacle.width), 1)}m x ${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(obstacle.depth), 1)}m` : `${(0, $lNEp2.formatNumber)(obstacle.width, 2)}ft x ${(0, $lNEp2.formatNumber)(obstacle.depth, 2)}ft`;
    const nodeRef = $acw62.useRef(null);
    if (!feetToPixels) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lrh3u))), {
                nodeRef: nodeRef,
                bounds: "parent",
                position: {
                    x: x,
                    y: y
                },
                onDrag: (evt, data)=>{
                    const newObstacle = {
                        ...obstacle,
                        x: data.x / feetToPixels,
                        y: data.y / feetToPixels
                    };
                    // if outside of hangar, don't fire
                    if (newObstacle.x < -BORDER_BUFFER || newObstacle.y < -BORDER_BUFFER || newObstacle.x + newObstacle.width > hangar.width + BORDER_BUFFER || newObstacle.y + newObstacle.depth > hangar.depth + BORDER_BUFFER) {
                        evt.preventDefault();
                        return;
                    }
                    onDrag({
                        ...newObstacle,
                        active: true,
                        geom: (0, $aVGl3.getObstacleGeometry)(newObstacle)
                    });
                },
                onStop: ()=>{
                    onDrag({
                        ...obstacle,
                        active: false
                    });
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    ref: nodeRef,
                    onContextMenu: (evt)=>{
                        evt.preventDefault();
                        setAnchorEl(evt.currentTarget);
                    },
                    sx: {
                        ...sx,
                        position: "absolute",
                        cursor: "grab",
                        width: `${obstacle.width * feetToPixels}px`,
                        height: `${obstacle.depth * feetToPixels}px`,
                        "&:hover": {
                            ...sxHover
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        sx: {
                            height: "100%",
                            width: "100%",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            children: dimensions
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($5666c51c2d39ad4f$export$7dadc35f8f793762, {
                anchorEl: anchorEl,
                onCopy: ()=>{
                    const copiedObstacle = {
                        ...obstacle,
                        id: (0, $lNEp2.uuidv4)(),
                        x: obstacle.x + 5,
                        y: obstacle.y + 5
                    };
                    setHangar({
                        ...hangar,
                        obstacles: [
                            ...hangar.obstacles,
                            copiedObstacle
                        ]
                    });
                },
                onClose: ()=>setAnchorEl(null),
                onDelete: ()=>onDelete(obstacle)
            })
        ]
    });
};

});

parcelRegister("kfxZt", function(module, exports) {

$parcel$export(module.exports, "drawDoors", () => $cc253b5f0365b6f5$export$6cd1a81e24aa6179);
$parcel$export(module.exports, "drawUnobstructiveObstacles", () => $cc253b5f0365b6f5$export$8ee9f7a6e4d93c4b);
$parcel$export(module.exports, "drawSpacingBuffers", () => $cc253b5f0365b6f5$export$761a2f1cca46dab5);
$parcel$export(module.exports, "drawDistanceMarkers", () => $cc253b5f0365b6f5$export$7370504b5ff02cea);
$parcel$export(module.exports, "drawGarageDoorMarkers", () => $cc253b5f0365b6f5$export$1113f4b7bb5555c1);
$parcel$export(module.exports, "clearBackgroundForObstacles", () => $cc253b5f0365b6f5$export$6b9845ebdaaa41e6);
$parcel$export(module.exports, "drawBayBoundaries", () => $cc253b5f0365b6f5$export$9467f717b2d9a4c8);
$parcel$export(module.exports, "drawUncoveredAreas", () => $cc253b5f0365b6f5$export$daeb0cc7feb352ec);

var $keHtM = parcelRequire("keHtM");

var $cLNZr = parcelRequire("cLNZr");

var $d7VTV = parcelRequire("d7VTV");
const $cc253b5f0365b6f5$export$a12a46f2fc0693d6 = (num1, num2)=>{
    return Math.abs(num1 - num2) < 0.9;
};
const $cc253b5f0365b6f5$export$6cd1a81e24aa6179 = (ctx, hangar, feetToPixels)=>{
    ctx.beginPath();
    ctx.save();
    if (hangar.left_door) {
        ctx.setLineDash([]);
        ctx.lineWidth = 0;
        ctx.strokeStyle = "black";
        ctx.fillStyle = "black";
        ctx.moveTo(0, ctx.canvas.height);
        ctx.lineTo(feetToPixels(hangar.left_door), ctx.canvas.height);
        ctx.lineTo(feetToPixels(hangar.left_door), ctx.canvas.height - 20);
        ctx.lineTo(0, ctx.canvas.height - 20);
        ctx.fill();
    }
    if (hangar.right_door) {
        ctx.setLineDash([]);
        ctx.strokeStyle = "black";
        ctx.fillStyle = "black";
        ctx.moveTo(ctx.canvas.width - feetToPixels(hangar.right_door), ctx.canvas.height);
        ctx.lineTo(ctx.canvas.width, ctx.canvas.height);
        ctx.lineTo(ctx.canvas.width, ctx.canvas.height - 20);
        ctx.lineTo(ctx.canvas.width - feetToPixels(hangar.right_door), ctx.canvas.height - 20);
        ctx.fill();
    }
    ctx.restore();
};
const $cc253b5f0365b6f5$export$aa233fc87252342e = (ctx, garageDoors, feetToPixels)=>{
    ctx.beginPath();
    ctx.save();
    for (const garageDoor of garageDoors){
        ctx.setLineDash([]);
        ctx.lineWidth = 8;
        ctx.strokeStyle = "#FFAC1C";
        ctx.fillStyle = "#FFAC1C";
        if (garageDoor.wall === "back") {
            ctx.moveTo(feetToPixels(garageDoor.x), ctx.canvas.height - feetToPixels(garageDoor.y));
            ctx.lineTo(feetToPixels(garageDoor.x + garageDoor.width), ctx.canvas.height - feetToPixels(garageDoor.y));
        } else {
            ctx.moveTo(feetToPixels(garageDoor.x), ctx.canvas.height - feetToPixels(garageDoor.y));
            ctx.lineTo(feetToPixels(garageDoor.x), ctx.canvas.height - feetToPixels(garageDoor.y + garageDoor.width));
        }
        ctx.stroke();
        ctx.fill();
    }
    ctx.restore();
};
const $cc253b5f0365b6f5$export$8ee9f7a6e4d93c4b = (ctx, hangar, _feetToPixels, _options)=>{
    ctx.beginPath();
    ctx.save();
    for (const _obstacle of hangar.obstacles.filter((o)=>o.type === (0, $keHtM.ObstacleType).UNOBSTRUCTIVE));
    ctx.restore();
};
const $cc253b5f0365b6f5$export$761a2f1cca46dab5 = (ctx, hangar, feetToPixels, options)=>{
    ctx.beginPath();
    ctx.save();
    const lineWidth = options?.lineWidth ?? 2;
    const lineDash = options?.lineDash ?? [
        4,
        4
    ];
    const showWallSpacingFill = options?.showWallSpacingFill ?? false;
    // Draw all spacing rectangles (wall spacing + obstacle extensions) in one path
    ctx.beginPath();
    ctx.fillStyle = "rgba(255, 0, 0, 0.2)"; // #FF0000 at 20% opacity
    // Left wall spacing area - full height
    if (hangar.wall_spacing_left) ctx.rect(0, // x start
    0, // y start (full height)
    Math.round(feetToPixels(hangar.wall_spacing_left)), // width
    ctx.canvas.height // full height
    );
    // Back wall spacing area - full width
    if (hangar.wall_spacing_back) ctx.rect(0, // x start (full width)
    0, // y start
    ctx.canvas.width, // full width
    Math.round(feetToPixels(hangar.wall_spacing_back)) // height
    );
    // Right wall spacing area - full height
    if (hangar.wall_spacing_right) ctx.rect(Math.round(feetToPixels(hangar.width - hangar.wall_spacing_right)), // x start
    0, // y start (full height)
    Math.round(feetToPixels(hangar.wall_spacing_right)), // width
    ctx.canvas.height // full height
    );
    // Add spacing buffer extensions around wall-touching obstacles to the same path
    if (hangar.obstacles) for (const obstacle of hangar.obstacles){
        if (obstacle.type === (0, $keHtM.ObstacleType).UNOBSTRUCTIVE || obstacle.type === (0, $keHtM.ObstacleType).CAUTION) continue;
        const touchesWall = obstacle.y === 0 || obstacle.x === 0 || $cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width);
        if (touchesWall) {
            // Draw spacing buffer extension around the obstacle
            if (obstacle.y === 0 && obstacle.x === 0) // top left corner
            ctx.rect(Math.round(feetToPixels(0)), Math.round(feetToPixels(0)), Math.round(feetToPixels(obstacle.width + (hangar.wall_spacing_left || 0))), Math.round(feetToPixels(obstacle.depth + (hangar.wall_spacing_back || 0))));
            else if (obstacle.y === 0 && $cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width)) // top right corner
            ctx.rect(Math.round(feetToPixels(obstacle.x - (hangar.wall_spacing_right || 0))), Math.round(feetToPixels(0)), Math.round(feetToPixels(obstacle.width + (hangar.wall_spacing_right || 0) * 2)), Math.round(feetToPixels(obstacle.depth + (hangar.wall_spacing_back || 0))));
            else if (obstacle.y === 0) // back wall
            ctx.rect(Math.round(feetToPixels(obstacle.x - (hangar.wall_spacing_back || 0))), Math.round(feetToPixels(0)), Math.round(feetToPixels(obstacle.width + (hangar.wall_spacing_back || 0) * 2)), Math.round(feetToPixels(obstacle.depth + (hangar.wall_spacing_back || 0))));
            else if (obstacle.x === 0) // left wall
            ctx.rect(Math.round(feetToPixels(0)), Math.round(feetToPixels(obstacle.y - (hangar.wall_spacing_left || 0))), Math.round(feetToPixels(obstacle.width + (hangar.wall_spacing_left || 0))), Math.round(feetToPixels(obstacle.depth + (hangar.wall_spacing_left || 0) * 2)));
            else if ($cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width)) // right wall
            ctx.rect(Math.round(feetToPixels(hangar.width - obstacle.width - (hangar.wall_spacing_right || 0))), Math.round(feetToPixels(obstacle.y - (hangar.wall_spacing_right || 0))), Math.round(feetToPixels(obstacle.width + (hangar.wall_spacing_right || 0) * 2)), Math.round(feetToPixels(obstacle.depth + (hangar.wall_spacing_right || 0) * 2)));
        }
    }
    // Fill all rectangles only if showWallSpacingFill is enabled
    if (showWallSpacingFill) ctx.fill();
    // Only draw dotted boundaries when fill is disabled
    if (!showWallSpacingFill) {
        // Draw dashed boundary lines at the edges of spacing areas
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = "red";
        ctx.setLineDash(lineDash);
        ctx.beginPath();
        // Calculate boundaries to prevent corner intersections
        // Round to whole pixels to ensure crisp lines
        const leftBoundaryX = hangar.wall_spacing_left ? Math.round(feetToPixels(hangar.wall_spacing_left)) : 0;
        const rightBoundaryX = hangar.wall_spacing_right ? Math.round(feetToPixels(hangar.width - hangar.wall_spacing_right)) : ctx.canvas.width;
        const backBoundaryY = hangar.wall_spacing_back ? Math.round(feetToPixels(hangar.wall_spacing_back)) : 0;
        // Left wall spacing boundary - stop at back spacing if present
        if (hangar.wall_spacing_left) {
            ctx.moveTo(leftBoundaryX, backBoundaryY);
            ctx.lineTo(leftBoundaryX, ctx.canvas.height);
        }
        // Back wall spacing boundary - draw between left and right spacing
        if (hangar.wall_spacing_back) {
            ctx.moveTo(leftBoundaryX, backBoundaryY);
            ctx.lineTo(rightBoundaryX, backBoundaryY);
        }
        // Right wall spacing boundary - stop at back spacing if present
        if (hangar.wall_spacing_right) {
            ctx.moveTo(rightBoundaryX, backBoundaryY);
            ctx.lineTo(rightBoundaryX, ctx.canvas.height);
        }
        // Draw obstacle extension boundaries for wall-touching obstacles
        if (hangar.obstacles) for (const obstacle of hangar.obstacles){
            if (obstacle.type === (0, $keHtM.ObstacleType).UNOBSTRUCTIVE || obstacle.type === (0, $keHtM.ObstacleType).CAUTION) continue;
            const touchesWall = obstacle.y === 0 || obstacle.x === 0 || $cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width);
            if (touchesWall) {
                // Draw only the necessary perimeter boundaries
                if (obstacle.y === 0 && obstacle.x === 0) {
                    // top left corner - only draw the extensions beyond wall spacing
                    const rightEdge = Math.round(feetToPixels(obstacle.width + (hangar.wall_spacing_left || 0)));
                    const bottomEdge = Math.round(feetToPixels(obstacle.depth + (hangar.wall_spacing_back || 0)));
                    ctx.moveTo(rightEdge, 0);
                    ctx.lineTo(rightEdge, bottomEdge);
                    ctx.moveTo(0, bottomEdge);
                    ctx.lineTo(rightEdge, bottomEdge);
                } else if (obstacle.y === 0 && $cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width)) {
                    // top right corner - only draw the extensions beyond wall spacing
                    const leftEdge = Math.round(feetToPixels(obstacle.x - (hangar.wall_spacing_right || 0)));
                    const bottomEdge = Math.round(feetToPixels(obstacle.depth + (hangar.wall_spacing_back || 0)));
                    ctx.moveTo(leftEdge, 0);
                    ctx.lineTo(leftEdge, bottomEdge);
                    ctx.moveTo(leftEdge, bottomEdge);
                    ctx.lineTo(ctx.canvas.width, bottomEdge);
                } else if (obstacle.y === 0) {
                    // back wall - only draw horizontal line that outlines the filled area, skip vertical lines that are internal
                    const leftEdge = Math.round(feetToPixels(obstacle.x - (hangar.wall_spacing_back || 0)));
                    const rightEdge = Math.round(feetToPixels(obstacle.x + obstacle.width + (hangar.wall_spacing_back || 0)));
                    const bottomEdge = Math.round(feetToPixels(obstacle.depth + (hangar.wall_spacing_back || 0)));
                    // Only draw horizontal line that outlines the filled area (don't draw vertical lines when fill is enabled)
                    ctx.moveTo(Math.max(leftEdge, Math.round(feetToPixels(hangar.wall_spacing_left || 0))), bottomEdge);
                    ctx.lineTo(Math.min(rightEdge, Math.round(feetToPixels(hangar.width - (hangar.wall_spacing_right || 0)))), bottomEdge);
                } else if (obstacle.x === 0) {
                    // left wall - only draw the right vertical boundary that outlines the filled area
                    const topEdge = Math.round(feetToPixels(obstacle.y - (hangar.wall_spacing_left || 0)));
                    const bottomEdge = Math.round(feetToPixels(obstacle.y + obstacle.depth + (hangar.wall_spacing_left || 0)));
                    const rightEdge = Math.round(feetToPixels(obstacle.width + (hangar.wall_spacing_left || 0)));
                    // Only draw the right vertical line that forms the outline of the filled area
                    const leftSpacingRight = Math.round(feetToPixels(hangar.wall_spacing_left || 0));
                    const backSpacingBottom = Math.round(feetToPixels(hangar.wall_spacing_back || 0));
                    // Draw right vertical line only for the part that extends beyond filled areas
                    if (rightEdge > leftSpacingRight) {
                        ctx.moveTo(rightEdge, Math.max(topEdge, backSpacingBottom));
                        ctx.lineTo(rightEdge, bottomEdge);
                    }
                } else if ($cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width)) {
                    // right wall - draw outline boundaries of spacing extensions
                    const topEdge = Math.round(feetToPixels(obstacle.y - (hangar.wall_spacing_right || 0)));
                    const bottomEdge = Math.round(feetToPixels(obstacle.y + obstacle.depth + (hangar.wall_spacing_right || 0)));
                    const leftEdge = Math.round(feetToPixels(obstacle.x - (hangar.wall_spacing_right || 0)));
                    // Draw the left vertical boundary that outlines the spacing extension
                    ctx.moveTo(leftEdge, Math.max(topEdge, Math.round(feetToPixels(hangar.wall_spacing_back || 0))));
                    ctx.lineTo(leftEdge, bottomEdge);
                }
            }
        }
        // Draw all boundary lines at once
        ctx.stroke();
    }
    ctx.restore();
    ctx.save();
    ctx.beginPath();
    if (hangar.obstacles) for (const obstacle of hangar.obstacles){
        if (obstacle.type === (0, $keHtM.ObstacleType).UNOBSTRUCTIVE) continue;
        if (obstacle.type === (0, $keHtM.ObstacleType).CAUTION) continue;
        if (obstacle.type === (0, $keHtM.ObstacleType).NO_TOW_AREA) {
            // NO_TOW_AREA obstacles should use the same spacing buffer logic as regular obstructions
            // but clear a larger area when they touch walls to include the wall spacing
            const touchesWall = obstacle.y === 0 || obstacle.x === 0 || $cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width);
            if (touchesWall && showWallSpacingFill) continue; // Skip to next obstacle when fill is enabled and wall is touched
            else if (!touchesWall) {
                // For non-wall-touching NO_TOW_AREA, just clear the obstacle area and skip the boundary drawing
                ctx.clearRect(Math.round(feetToPixels(obstacle.x)), Math.round(feetToPixels(obstacle.y)), Math.round(feetToPixels(obstacle.width)), Math.round(feetToPixels(obstacle.depth)));
                continue; // Skip to next obstacle for non-wall-touching NO_TOW_AREA
            }
        // For wall-touching NO_TOW_AREA with fill disabled, fall through to the same boundary drawing logic as regular obstructions
        }
        // When wall spacing fill is enabled, only clear the obstacle itself (not the spacing extension)
        // to leave the red spacing buffer around the obstacle
        if (showWallSpacingFill) {
            const touchesWall = obstacle.y === 0 || obstacle.x === 0 || $cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width);
            if (touchesWall) {
                // Only clear the obstacle itself, leaving the spacing buffer filled
                ctx.clearRect(Math.round(feetToPixels(obstacle.x)), Math.round(feetToPixels(obstacle.y)), Math.round(feetToPixels(obstacle.width)), Math.round(feetToPixels(obstacle.depth)));
                continue;
            }
        }
        // Draw boundary lines for wall-touching obstacles when fill is disabled
        if (!showWallSpacingFill) {
            // top left corner
            if (obstacle.y === 0 && obstacle.x === 0) {
                ctx.clearRect(Math.round(feetToPixels(0)), Math.round(feetToPixels(0)), Math.round(feetToPixels(obstacle.width + hangar.wall_spacing_left)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                ctx.setLineDash(lineDash);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = "red";
                ctx.moveTo(Math.round(feetToPixels(hangar.wall_spacing_left)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                ctx.lineTo(Math.round(feetToPixels(obstacle.width + hangar.wall_spacing_left)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                ctx.lineTo(Math.round(feetToPixels(obstacle.width + hangar.wall_spacing_left)), Math.round(feetToPixels(hangar.wall_spacing_back)));
                ctx.stroke();
                ctx.restore();
                continue;
            }
            // top right corner
            if (obstacle.y === 0 && $cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width)) {
                ctx.clearRect(Math.round(feetToPixels(obstacle.x - hangar.wall_spacing_right)), Math.round(feetToPixels(0)), Math.round(feetToPixels(obstacle.width + hangar.wall_spacing_right * 2)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                ctx.setLineDash(lineDash);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = "red";
                ctx.moveTo(Math.round(feetToPixels(obstacle.x - hangar.wall_spacing_right)), Math.round(feetToPixels(hangar.wall_spacing_back)));
                ctx.lineTo(Math.round(feetToPixels(obstacle.x - hangar.wall_spacing_right)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                ctx.lineTo(Math.round(feetToPixels(obstacle.x + obstacle.width - hangar.wall_spacing_right)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                ctx.stroke();
                ctx.restore();
                continue;
            }
            // check to see if it is touching a wall
            if (obstacle.y === 0) {
                ctx.clearRect(Math.round(feetToPixels(obstacle.x - hangar.wall_spacing_back)), Math.round(feetToPixels(0)), Math.round(feetToPixels(obstacle.width + hangar.wall_spacing_back * 2)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                ctx.setLineDash(lineDash);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = "red";
                // if the left buffer on the obstacle is within the wall spacing
                // then we aren't going to paint the left buffer
                // top left
                if (obstacle.x - hangar.wall_spacing_back < hangar.wall_spacing_back) ctx.moveTo(Math.round(feetToPixels(hangar.wall_spacing_back)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                else ctx.moveTo(Math.round(feetToPixels(obstacle.x - hangar.wall_spacing_back)), Math.round(feetToPixels(hangar.wall_spacing_back)));
                // bottom left
                ctx.lineTo(Math.round(feetToPixels(Math.max(hangar.wall_spacing_back, obstacle.x - hangar.wall_spacing_back))), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                // bottom right
                ctx.lineTo(Math.round(feetToPixels(Math.min(hangar.width - hangar.wall_spacing_back, obstacle.x + obstacle.width + hangar.wall_spacing_back))), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_back)));
                // top right
                if (hangar.width - (obstacle.x + obstacle.width + hangar.wall_spacing_back) < hangar.wall_spacing_back) ;
                else ctx.lineTo(Math.round(feetToPixels(obstacle.x + obstacle.width + hangar.wall_spacing_back)), Math.round(feetToPixels(hangar.wall_spacing_back)));
                ctx.stroke();
            }
            if (obstacle.x === 0) {
                ctx.clearRect(Math.round(feetToPixels(0)), Math.round(feetToPixels(obstacle.y - hangar.wall_spacing_left)), Math.round(feetToPixels(obstacle.width + hangar.wall_spacing_left)), Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_left * 2)));
                ctx.setLineDash(lineDash);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = "red";
                // if the top buffer on the obstacle is within the wall spacing
                // then we aren't going to paint the top buffer
                if (obstacle.y - hangar.wall_spacing_left < hangar.wall_spacing_left) ctx.moveTo(Math.round(feetToPixels(obstacle.x + obstacle.width + hangar.wall_spacing_left)), Math.round(feetToPixels(hangar.wall_spacing_left)));
                else ctx.moveTo(Math.round(feetToPixels(obstacle.x + hangar.wall_spacing_left)), Math.round(feetToPixels(obstacle.y - hangar.wall_spacing_left)));
                ctx.lineTo(Math.round(feetToPixels(obstacle.x + obstacle.width + hangar.wall_spacing_left)), Math.round(feetToPixels(Math.max(hangar.wall_spacing_left, obstacle.y - hangar.wall_spacing_left))));
                ctx.lineTo(Math.round(feetToPixels(obstacle.x + obstacle.width + hangar.wall_spacing_left)), Math.round(feetToPixels(obstacle.y + obstacle.depth + hangar.wall_spacing_left)));
                ctx.lineTo(Math.round(feetToPixels(obstacle.x + hangar.wall_spacing_left)), Math.round(feetToPixels(obstacle.y + obstacle.depth + hangar.wall_spacing_left)));
                ctx.stroke();
            }
            if ($cc253b5f0365b6f5$export$a12a46f2fc0693d6(obstacle.x + obstacle.width, hangar.width)) {
                ctx.clearRect(Math.round(feetToPixels(hangar.width - obstacle.width - hangar.wall_spacing_right)), Math.round(feetToPixels(obstacle.y - hangar.wall_spacing_right)), Math.round(feetToPixels(obstacle.width + hangar.wall_spacing_right * 2)) + lineWidth, Math.round(feetToPixels(obstacle.depth + hangar.wall_spacing_right * 2)) + lineWidth);
                ctx.setLineDash(lineDash);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = "red";
                if (obstacle.y - hangar.wall_spacing_right < hangar.wall_spacing_right) ctx.moveTo(Math.round(feetToPixels(hangar.width - hangar.wall_spacing_right - obstacle.width)), Math.round(feetToPixels(hangar.wall_spacing_right)));
                else ctx.moveTo(Math.round(feetToPixels(hangar.width - hangar.wall_spacing_right)), Math.round(feetToPixels(obstacle.y - hangar.wall_spacing_right)));
                ctx.lineTo(Math.round(feetToPixels(hangar.width - hangar.wall_spacing_right - obstacle.width)), Math.round(feetToPixels(Math.max(hangar.wall_spacing_right, obstacle.y - hangar.wall_spacing_right))));
                ctx.lineTo(Math.round(feetToPixels(hangar.width - hangar.wall_spacing_right - obstacle.width)), Math.round(feetToPixels(obstacle.y + obstacle.depth + hangar.wall_spacing_right)));
                ctx.lineTo(Math.round(feetToPixels(hangar.width - hangar.wall_spacing_right)), Math.round(feetToPixels(obstacle.y + obstacle.depth + hangar.wall_spacing_right)));
                ctx.stroke();
            }
        } // End of showWallSpacingFill conditional
    }
    ctx.restore();
};
const $cc253b5f0365b6f5$export$7370504b5ff02cea = (ctx, hangar, obstacle, feetToPixels, unit = "ft")=>{
    if (!obstacle) return;
    const obstacleInPixels = {
        ...obstacle,
        x: feetToPixels(obstacle.x),
        y: feetToPixels(obstacle.y),
        width: feetToPixels(obstacle.width),
        depth: feetToPixels(obstacle.depth),
        height: feetToPixels(obstacle.height)
    };
    ctx.beginPath();
    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = 4;
    ctx.setLineDash([
        4
    ]);
    ctx.strokeStyle = "skyblue";
    // horizontal
    ctx.moveTo(0, obstacleInPixels.y + obstacleInPixels.depth / 2);
    ctx.lineTo(ctx.canvas.width, obstacleInPixels.y + obstacleInPixels.depth / 2);
    ctx.stroke();
    // vertical
    ctx.moveTo(obstacleInPixels.x + obstacleInPixels.width / 2, 0);
    ctx.lineTo(obstacleInPixels.x + obstacleInPixels.width / 2, ctx.canvas.height);
    ctx.stroke();
    ctx.textAlign = "center";
    ctx.font = "14px Lexend Deca";
    ctx.fillStyle = "black";
    // left
    $cc253b5f0365b6f5$export$763ff822f2e9efaa(ctx, obstacleInPixels, obstacleInPixels.x / 2, obstacleInPixels.y + obstacleInPixels.depth / 2 + 14, obstacle.x, unit);
    // top
    $cc253b5f0365b6f5$export$763ff822f2e9efaa(ctx, obstacleInPixels, (obstacleInPixels.x + (obstacleInPixels.x + obstacleInPixels.width)) / 2, obstacleInPixels.y / 2, obstacle.y, unit);
    // bottom
    $cc253b5f0365b6f5$export$763ff822f2e9efaa(ctx, obstacleInPixels, (obstacleInPixels.x + (obstacleInPixels.x + obstacleInPixels.width)) / 2, ctx.canvas.height - (ctx.canvas.height - obstacleInPixels.y - obstacleInPixels.depth) / 2, hangar.depth - obstacle.y - obstacle.depth, unit);
    // right
    $cc253b5f0365b6f5$export$763ff822f2e9efaa(ctx, obstacleInPixels, ctx.canvas.width - (ctx.canvas.width - obstacleInPixels.x - obstacleInPixels.width) / 2, obstacleInPixels.y + obstacleInPixels.depth / 2 + 14, hangar.width - obstacle.x - obstacle.width, unit);
    ctx.restore();
};
const $cc253b5f0365b6f5$export$763ff822f2e9efaa = (ctx, obstacleInPixels, x, y, size, unit = "ft")=>{
    size = unit === "m" ? (0, $d7VTV.feetToMeters)(size) : size;
    // if smushed to the back
    if (y < 20) {
        const value = Math.abs((0, $cLNZr.round)(size, 2));
        ctx.fillText(`${value} ${unit}`, x - 30 - obstacleInPixels.width / 2, y + 10);
        return;
    }
    // if smushed to the left
    if (x < 20) {
        const value = Math.abs((0, $cLNZr.round)(size, 2));
        ctx.fillText(`${value} ${unit}`, 30, y + obstacleInPixels.depth / 2);
        return;
    }
    // if smushed to the right
    if (x > ctx.canvas.width - 20) {
        const value = Math.abs((0, $cLNZr.round)(size, 2));
        ctx.fillText(`${value} ${unit}`, ctx.canvas.width - 30, y + obstacleInPixels.depth / 2);
        return;
    }
    // if smushed to the bottom
    if (y > ctx.canvas.height - 20) {
        const value = Math.abs((0, $cLNZr.round)(size, 2));
        ctx.fillText(`${value} ${unit}`, x - 30 - obstacleInPixels.width / 2, y - 10);
        return;
    }
    ctx.fillText(`${Math.abs((0, $cLNZr.round)(size, 2))} ${unit}`, x, y);
};
const $cc253b5f0365b6f5$export$1113f4b7bb5555c1 = (ctx, hangar, garageDoors, feetToPixels, unit = "ft")=>{
    if (!garageDoors) return;
    for (const garageDoor of garageDoors){
        if (!garageDoor.active) continue;
        ctx.lineWidth = 2;
        ctx.setLineDash([
            8
        ]);
        ctx.strokeStyle = "skyblue";
        ctx.textAlign = "center";
        ctx.font = "14px Lexend Deca";
        ctx.fillStyle = "black";
        if (garageDoor.wall === "back") {
            const x = feetToPixels(garageDoor.x);
            const y = feetToPixels(2);
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(ctx.canvas.width, y);
            ctx.stroke();
            const value1 = unit === "m" ? Math.abs((0, $cLNZr.round)((0, $d7VTV.feetToMeters)(garageDoor.x), 2)) : Math.abs((0, $cLNZr.round)(garageDoor.x, 2));
            ctx.fillText(`${value1} ${unit}`, Math.max(40, x / 2), y * 3);
            const value2 = unit === "m" ? Math.abs((0, $cLNZr.round)((0, $d7VTV.feetToMeters)(hangar.width - garageDoor.width - garageDoor.x), 2)) : Math.abs((0, $cLNZr.round)(hangar.width - garageDoor.width - garageDoor.x, 2));
            ctx.fillText(`${value2} ${unit}`, Math.min(ctx.canvas.width - 40, feetToPixels(garageDoor.x + garageDoor.width + (hangar.width - garageDoor.x - garageDoor.width) / 2)), y * 3);
            ctx.restore();
        } else if (garageDoor.wall === "left") {
            const x = feetToPixels(2);
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, ctx.canvas.height);
            ctx.stroke();
            const value1 = unit === "m" ? Math.abs((0, $cLNZr.round)((0, $d7VTV.feetToMeters)(garageDoor.y), 2)) : Math.abs((0, $cLNZr.round)(garageDoor.y, 2));
            ctx.fillText(`${value1} ${unit}`, x * 5, feetToPixels(Math.max(10, garageDoor.y)) / 2);
            const value2 = unit === "m" ? Math.abs((0, $cLNZr.round)((0, $d7VTV.feetToMeters)(hangar.depth - garageDoor.y - garageDoor.width), 2)) : Math.abs((0, $cLNZr.round)(hangar.depth - garageDoor.y - garageDoor.width, 2));
            ctx.fillText(`${value2} ${unit}`, x * 5, feetToPixels(Math.min(hangar.depth - 10, (hangar.depth + garageDoor.y + garageDoor.width) / 2)));
            ctx.restore();
        } else if (garageDoor.wall === "right") {
            const x = feetToPixels(hangar.width - 15);
            ctx.beginPath();
            ctx.moveTo(feetToPixels(hangar.width - 1), 0);
            ctx.lineTo(feetToPixels(hangar.width - 1), ctx.canvas.height);
            ctx.stroke();
            const value1 = unit === "m" ? Math.abs((0, $cLNZr.round)((0, $d7VTV.feetToMeters)(garageDoor.y), 2)) : Math.abs((0, $cLNZr.round)(garageDoor.y, 2));
            ctx.fillText(`${value1} ${unit}`, x, feetToPixels(Math.max(10, garageDoor.y)) / 2);
            const value2 = unit === "m" ? Math.abs((0, $cLNZr.round)((0, $d7VTV.feetToMeters)(hangar.depth - garageDoor.y - garageDoor.width), 2)) : Math.abs((0, $cLNZr.round)(hangar.depth - garageDoor.y - garageDoor.width, 2));
            ctx.fillText(`${value2} ${unit}`, x, feetToPixels(Math.min(hangar.depth - 10, (hangar.depth + garageDoor.y + garageDoor.width) / 2)));
            ctx.restore();
        }
    }
};
const $cc253b5f0365b6f5$export$6b9845ebdaaa41e6 = (ctx, hangar, feetToPixels)=>{
    // ctx.beginPath();
    for (const obstacle of hangar.obstacles){
        if (obstacle.type === (0, $keHtM.ObstacleType).UNOBSTRUCTIVE) continue;
        if (obstacle.type === (0, $keHtM.ObstacleType).CAUTION) continue;
        const obstacleInPixels = {
            ...obstacle,
            x: feetToPixels(obstacle.x),
            y: feetToPixels(obstacle.y),
            width: feetToPixels(obstacle.width),
            depth: feetToPixels(obstacle.depth),
            height: feetToPixels(obstacle.height)
        };
        ctx.clearRect(obstacleInPixels.x, obstacleInPixels.y, obstacleInPixels.width, obstacleInPixels.depth);
    }
// ctx.save();
};
const $cc253b5f0365b6f5$export$9467f717b2d9a4c8 = (ctx, bays, hangar, feetToPixels, options)=>{
    if (!bays || bays.length === 0) return;
    if (bays.length === 1) {
        // Single bay - no dividers needed, just draw labels
        $cc253b5f0365b6f5$var$drawBayLabel(ctx, bays[0], 0, hangar, feetToPixels, false, options);
        return;
    }
    ctx.save();
    // Detect orientation: longitudinal if all bays share X-range (full width)
    const isLongitudinal = $cc253b5f0365b6f5$var$detectLongitudinalOrientation(bays);
    // Draw divider lines only (not exterior edges)
    if (isLongitudinal) $cc253b5f0365b6f5$var$drawLongitudinalDividers(ctx, bays, hangar, feetToPixels);
    else $cc253b5f0365b6f5$var$drawLateralDividers(ctx, bays, feetToPixels);
    // Draw bay labels with adjusted positioning
    bays.forEach((bay, index)=>{
        $cc253b5f0365b6f5$var$drawBayLabel(ctx, bay, index, hangar, feetToPixels, isLongitudinal, options);
    });
    ctx.restore();
};
const $cc253b5f0365b6f5$export$daeb0cc7feb352ec = (ctx, bays, hangar, feetToPixels)=>{
    if (!bays || bays.length === 0) return;
    ctx.save();
    const isLongitudinal = $cc253b5f0365b6f5$var$detectLongitudinalOrientation(bays);
    if (isLongitudinal) {
        // Calculate maximum depth covered by bays
        const coveredDepth = bays.reduce((max, bay)=>{
            const coords = bay.geom.coordinates[0];
            const yValues = coords.map((c)=>c[1]);
            return Math.max(max, Math.max(...yValues));
        }, 0);
        if (coveredDepth < hangar.depth - 0.1) {
            // Draw uncovered area at back
            const uncoveredStartPx = feetToPixels(coveredDepth);
            const uncoveredHeightPx = feetToPixels(hangar.depth - coveredDepth);
            // Fill with semi-transparent red
            ctx.fillStyle = "rgba(255, 0, 0, 0.08)";
            ctx.fillRect(0, uncoveredStartPx, feetToPixels(hangar.width), uncoveredHeightPx);
            // Add diagonal hatching
            ctx.strokeStyle = "rgba(255, 0, 0, 0.3)";
            ctx.lineWidth = 1;
            ctx.setLineDash([
                5,
                5
            ]);
            for(let x = 0; x < feetToPixels(hangar.width); x += 20){
                ctx.beginPath();
                ctx.moveTo(x, uncoveredStartPx);
                ctx.lineTo(x + uncoveredHeightPx, uncoveredStartPx + uncoveredHeightPx);
                ctx.stroke();
            }
            // Label uncovered area
            ctx.setLineDash([]);
            ctx.fillStyle = "#c62828";
            ctx.font = "bold 14px Lexend Deca, sans-serif";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(`UNCOVERED: ${(hangar.depth - coveredDepth).toFixed(1)}ft`, feetToPixels(hangar.width / 2), uncoveredStartPx + uncoveredHeightPx / 2);
        }
    } else {
        // Lateral bays - calculate maximum width covered
        const coveredWidth = bays.reduce((max, bay)=>{
            const coords = bay.geom.coordinates[0];
            const xValues = coords.map((c)=>c[0]);
            return Math.max(max, Math.max(...xValues));
        }, 0);
        if (coveredWidth < hangar.width - 0.1) {
            // Draw uncovered area on right side
            const uncoveredStartPx = feetToPixels(coveredWidth);
            const uncoveredWidthPx = feetToPixels(hangar.width - coveredWidth);
            // Fill with semi-transparent red
            ctx.fillStyle = "rgba(255, 0, 0, 0.08)";
            ctx.fillRect(uncoveredStartPx, 0, uncoveredWidthPx, feetToPixels(hangar.depth));
            // Add diagonal hatching
            ctx.strokeStyle = "rgba(255, 0, 0, 0.3)";
            ctx.lineWidth = 1;
            ctx.setLineDash([
                5,
                5
            ]);
            for(let y = 0; y < feetToPixels(hangar.depth); y += 20){
                ctx.beginPath();
                ctx.moveTo(uncoveredStartPx, y);
                ctx.lineTo(uncoveredStartPx + uncoveredWidthPx, y + uncoveredWidthPx);
                ctx.stroke();
            }
            // Label uncovered area (rotated for vertical text)
            ctx.setLineDash([]);
            ctx.save();
            ctx.translate(uncoveredStartPx + uncoveredWidthPx / 2, feetToPixels(hangar.depth / 2));
            ctx.rotate(-Math.PI / 2);
            ctx.fillStyle = "#c62828";
            ctx.font = "bold 14px Lexend Deca, sans-serif";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(`UNCOVERED: ${(hangar.width - coveredWidth).toFixed(1)}ft`, 0, 0);
            ctx.restore();
        }
    }
    ctx.restore();
};
/**
 * Detect if bays are arranged longitudinally (front-to-back)
 * by checking if all bays share the same X-range (full width)
 */ function $cc253b5f0365b6f5$var$detectLongitudinalOrientation(bays) {
    if (bays.length < 2) return false;
    const getXRange = (bay)=>{
        const coords = bay.geom.coordinates[0];
        const xValues = coords.map((c)=>c[0]);
        return {
            min: Math.min(...xValues),
            max: Math.max(...xValues)
        };
    };
    const firstRange = getXRange(bays[0]);
    // Check if all other bays have the same X-range (within tolerance)
    return bays.slice(1).every((bay)=>{
        const range = getXRange(bay);
        return Math.abs(range.min - firstRange.min) < 0.5 && Math.abs(range.max - firstRange.max) < 0.5;
    });
}
/**
 * Draw horizontal divider lines for longitudinal bays
 */ function $cc253b5f0365b6f5$var$drawLongitudinalDividers(ctx, bays, hangar, feetToPixels) {
    // Find unique Y-coordinates that appear as shared edges
    const yCoordinates = new Set();
    bays.forEach((bay)=>{
        const coords = bay.geom.coordinates[0];
        const yValues = coords.map((c)=>c[1]);
        yValues.forEach((y)=>yCoordinates.add(y));
    });
    // Get min/max Y to identify exterior edges
    const allY = Array.from(yCoordinates);
    const minY = Math.min(...allY);
    const maxY = Math.max(...allY);
    // Draw horizontal lines for internal dividers only
    allY.forEach((y)=>{
        // Skip exterior edges
        if (Math.abs(y - minY) < 0.1 || Math.abs(y - maxY) < 0.1) return;
        // Get X-range from first bay (all bays span full width)
        const coords = bays[0].geom.coordinates[0];
        const xValues = coords.map((c)=>c[0]);
        const minX = Math.min(...xValues);
        const maxX = Math.max(...xValues);
        // Transform Y for canvas (bottom-up rendering)
        const canvasY = hangar.depth - y;
        ctx.beginPath();
        ctx.moveTo((0, $cLNZr.round)(feetToPixels(minX)), (0, $cLNZr.round)(feetToPixels(canvasY)));
        ctx.lineTo((0, $cLNZr.round)(feetToPixels(maxX)), (0, $cLNZr.round)(feetToPixels(canvasY)));
        ctx.strokeStyle = "#FFFFFF";
        ctx.lineWidth = 2;
        ctx.setLineDash([
            8,
            4
        ]);
        ctx.stroke();
    });
    ctx.setLineDash([]);
}
/**
 * Draw vertical divider lines for lateral bays
 */ function $cc253b5f0365b6f5$var$drawLateralDividers(ctx, bays, feetToPixels) {
    // Find unique X-coordinates that appear as shared edges
    const xCoordinates = new Set();
    bays.forEach((bay)=>{
        const coords = bay.geom.coordinates[0];
        const xValues = coords.map((c)=>c[0]);
        xValues.forEach((x)=>xCoordinates.add(x));
    });
    // Get min/max X to identify exterior edges
    const allX = Array.from(xCoordinates);
    const minX = Math.min(...allX);
    const maxX = Math.max(...allX);
    // Draw vertical lines for internal dividers only
    allX.forEach((x)=>{
        // Skip exterior edges
        if (Math.abs(x - minX) < 0.1 || Math.abs(x - maxX) < 0.1) return;
        // Get Y-range from first bay (all bays span full depth)
        const coords = bays[0].geom.coordinates[0];
        const yValues = coords.map((c)=>c[1]);
        const minY = Math.min(...yValues);
        const maxY = Math.max(...yValues);
        ctx.beginPath();
        ctx.moveTo((0, $cLNZr.round)(feetToPixels(x)), (0, $cLNZr.round)(feetToPixels(minY)));
        ctx.lineTo((0, $cLNZr.round)(feetToPixels(x)), (0, $cLNZr.round)(feetToPixels(maxY)));
        ctx.strokeStyle = "#FFFFFF";
        ctx.lineWidth = 2;
        ctx.setLineDash([
            8,
            4
        ]);
        ctx.stroke();
    });
    ctx.setLineDash([]);
}
/**
 * Draw bay label with position adjusted for orientation
 */ function $cc253b5f0365b6f5$var$drawBayLabel(ctx, bay, index, hangar, feetToPixels, isLongitudinal, options) {
    const { showLabels: showLabels = true, showHeights: showHeights = true } = options || {};
    if (!showLabels && !showHeights) return;
    const coordinates = bay.geom.coordinates[0];
    if (!coordinates || coordinates.length === 0) return;
    // Calculate center position
    const uniqueCoords = coordinates.slice(0, -1); // Remove duplicate closing point
    const centerX = uniqueCoords.reduce((sum, coord)=>sum + coord[0], 0) / uniqueCoords.length;
    // Position at 25% from top for all bays to avoid hangar name watermark
    const yValues = uniqueCoords.map((coord)=>coord[1]);
    const minY = Math.min(...yValues);
    const maxY = Math.max(...yValues);
    const geometryCenterY = minY + (maxY - minY) * 0.25;
    // Transform Y for canvas rendering (bottom-up for longitudinal)
    const centerY = isLongitudinal ? hangar.depth - geometryCenterY : geometryCenterY;
    const centerPixelX = (0, $cLNZr.round)(feetToPixels(centerX));
    const centerPixelY = (0, $cLNZr.round)(feetToPixels(centerY));
    // Watermark style: grey text
    ctx.fillStyle = "#888888";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    if (showLabels && showHeights) {
        ctx.font = "14px Lexend Deca, sans-serif";
        ctx.fillText(`Bay ${index + 1} - ${bay.clear_height}ft clear`, centerPixelX, centerPixelY);
    } else if (showLabels) {
        ctx.font = "14px Lexend Deca, sans-serif";
        ctx.fillText(`Bay ${index + 1}`, centerPixelX, centerPixelY);
    } else if (showHeights) {
        ctx.font = "14px Lexend Deca, sans-serif";
        ctx.fillText(`${bay.clear_height}ft clear`, centerPixelX, centerPixelY);
    }
}

});



parcelRegister("1NUjF", function(module, exports) {

$parcel$export(module.exports, "copyImageAndUrlToClipboard", () => $2188d0ab888ffdbc$export$6c12337ff9cda6aa);
/**
 * Clipboard utilities for copying canvas images with memory-aware optimizations
 * 
 * This file is kept dependency-free to avoid test issues with ESM modules
 */ /**
 * Copies a canvas image and URL to the clipboard as HTML
 * 
 * Features:
 * - Memory-aware canvas scaling based on device memory
 * - Progressive quality reduction for large canvases
 * - Comprehensive error handling
 * 
 * @param canvas The canvas element to copy
 * @param linkUrl The URL to include with the image
 * @param type The type of content (e.g., 'hangar', 'ramp')
 * @returns boolean indicating success or failure
 */ const $2188d0ab888ffdbc$export$6c12337ff9cda6aa = async (canvas, linkUrl, type = "hangar")=>{
    try {
        // Estimate available memory - use navigator.deviceMemory if available or default to conservative estimate
        const estimatedDeviceMemory = navigator.deviceMemory || 4; // in GB, defaults to 4GB if not available
        console.log(`Device memory detected: ${estimatedDeviceMemory}GB`);
        // Scale max canvas dimensions based on available memory
        // Less aggressive limits to prevent content cropping
        const MAX_CANVAS_DIMENSION = Math.min(4096, // absolute maximum
        estimatedDeviceMemory >= 16 ? 4096 : estimatedDeviceMemory >= 8 ? 3500 : // Increased from 3072
        estimatedDeviceMemory >= 4 ? 2500 : 2000 // Increased from 2048 and 1536
        );
        // Maximum canvas area (width * height) based on memory
        // Increased safety margin to prevent content loss
        const MAX_CANVAS_AREA = MAX_CANVAS_DIMENSION * MAX_CANVAS_DIMENSION * 0.85; // Increased from 0.75 to 0.85
        // Check if the canvas exceeds maximum dimensions
        let scaledCanvas = canvas;
        const width = canvas.width;
        const height = canvas.height;
        const area = width * height;
        // If canvas is too large by area or dimensions, create a scaled down version
        if (area > MAX_CANVAS_AREA || width > MAX_CANVAS_DIMENSION || height > MAX_CANVAS_DIMENSION) {
            console.log(`Canvas needs scaling - dimensions: ${width}x${height}, area: ${area}, MAX_DIMENSION: ${MAX_CANVAS_DIMENSION}, MAX_AREA: ${MAX_CANVAS_AREA}`);
            // Calculate scale factor to maintain aspect ratio
            let scaleFactor = 1;
            // First check area constraint with buffer for content preservation
            if (area > MAX_CANVAS_AREA) scaleFactor = Math.sqrt(MAX_CANVAS_AREA / area) * 0.95; // Add 5% buffer to prevent edge content loss
            // Then check dimension constraints with buffer
            scaleFactor = Math.min(scaleFactor, MAX_CANVAS_DIMENSION / width * 0.95, // Add 5% buffer
            MAX_CANVAS_DIMENSION / height * 0.95 // Add 5% buffer
            );
            // Ensure minimum scale factor to prevent excessive downsizing
            scaleFactor = Math.max(scaleFactor, 0.3); // Don't scale below 30% of original
            // Create a new canvas with scaled dimensions
            const scaledWidth = Math.floor(width * scaleFactor);
            const scaledHeight = Math.floor(height * scaleFactor);
            console.log(`Scaling canvas to: ${scaledWidth}x${scaledHeight} (scale factor: ${scaleFactor.toFixed(2)})`);
            scaledCanvas = document.createElement('canvas');
            scaledCanvas.width = scaledWidth;
            scaledCanvas.height = scaledHeight;
            // Draw the original canvas onto the scaled canvas
            const ctx = scaledCanvas.getContext('2d');
            // Use appropriate quality based on scale factor
            if (scaleFactor < 0.5) ctx.imageSmoothingQuality = 'high';
            else if (area > MAX_CANVAS_AREA * 0.5) ctx.imageSmoothingQuality = 'medium';
            else ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(canvas, 0, 0, width, height, 0, 0, scaledWidth, scaledHeight);
        }
        // Try to get dataURL from canvas with error handling and progressive quality reduction
        const getCanvasDataUrl = (canvas, quality = 1.0)=>{
            try {
                // Try with the specified quality
                const dataUrl = canvas.toDataURL('image/png', quality);
                // Validate that the dataURL is not empty or invalid
                if (!dataUrl || dataUrl === 'data:,' || dataUrl.length < 100) {
                    console.error(`Generated dataURL is invalid or empty with quality ${quality}`);
                    // If quality is already at minimum, return null
                    if (quality <= 0.5) return null;
                    // Try again with lower quality
                    console.log(`Error occurred, retrying with lower quality (${(quality - 0.2).toFixed(1)})`);
                    return getCanvasDataUrl(canvas, quality - 0.2);
                }
                return dataUrl;
            } catch (err) {
                console.error('Error generating canvas dataURL:', err);
                // If error occurs and quality is still high, try with lower quality
                if (quality > 0.5) {
                    console.log(`Error occurred, retrying with lower quality (${(quality - 0.2).toFixed(1)})`);
                    return getCanvasDataUrl(canvas, quality - 0.2);
                }
                return null;
            }
        };
        // Get the dataURL with progressive quality reduction
        const dataUrl = getCanvasDataUrl(scaledCanvas);
        if (!dataUrl) {
            console.error('Failed to generate canvas dataURL after multiple attempts');
            return false;
        }
        // Create HTML content for clipboard
        const html = `<div>
      <img src="${dataUrl}" />
      <p>Edit ${type} here: <a href="${linkUrl}">${linkUrl}</a></p>
    </div>`;
        // Create blob and clipboard item
        const leBlob = new Blob([
            html
        ], {
            type: "text/html"
        });
        const item = new ClipboardItem({
            "text/html": leBlob
        });
        // Write to clipboard with proper async/await handling
        try {
            await navigator.clipboard.write([
                item
            ]);
            return true;
        } catch (err) {
            console.error('Error writing to clipboard:', err);
            throw err; // Re-throw to be caught by outer try-catch
        }
    } catch (err) {
        const errorDetails = {
            message: err.message || "Unknown error",
            stack: err.stack,
            canvasWidth: canvas.width,
            canvasHeight: canvas.height,
            canvasArea: canvas.width * canvas.height,
            url: linkUrl,
            type: type,
            deviceMemory: navigator.deviceMemory || "unknown",
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
        };
        console.error('Failed to copy to clipboard - detailed error:', errorDetails);
        return false;
    }
};

});


parcelRegister("85p2A", function(module, exports) {

$parcel$export(module.exports, "AircraftSpecsTooltip", () => $e1b06929133f7014$export$f7efec3d8ca42636);

var $ayMG0 = parcelRequire("ayMG0");

var $ex6lH = parcelRequire("ex6lH");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");
parcelRequire("86FOL");
var $9UCpe = parcelRequire("9UCpe");
const $e1b06929133f7014$export$f7efec3d8ca42636 = ({ aircraft: aircraft })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const imageSize = 150;
    const pixelSpanWingspan = imageSize / Math.max(aircraft.length, aircraft.wingspan) * aircraft.wingspan;
    const pixelSpanLength = imageSize / Math.max(aircraft.length, aircraft.wingspan) * aircraft.length;
    const wingspan = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(aircraft.wingspan), 2)} m` : `${(0, $lNEp2.formatNumber)(aircraft.wingspan, 2)} ft`;
    const length = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(aircraft.length), 2)} m` : `${(0, $lNEp2.formatNumber)(aircraft.length, 2)} ft`;
    const tailHeight = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(aircraft.tail_height), 2)} m` : `${(0, $lNEp2.formatNumber)(aircraft.tail_height, 2)} ft`;
    const area = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.squareFeetToSquareMeters)(aircraft.length * aircraft.wingspan), 0)} m\xb2` : `${(0, $lNEp2.formatNumber)(aircraft.length * aircraft.wingspan, 1)} ft\xb2`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9UCpe.HtmlTooltip), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            sx: {
                width: "100%",
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        pt: 1,
                        pl: 1,
                        pr: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            spacing: 1,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                children: area
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            direction: "column",
                            alignItems: "flex-end",
                            sx: {
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                sx: {
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: length
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    backgroundImage: `url(${aircraft.image})`,
                                                    backgroundPosition: "center",
                                                    backgroundSize: "cover",
                                                    width: pixelSpanWingspan,
                                                    height: pixelSpanLength,
                                                    filter: "brightness(0) invert(1)",
                                                    transform: aircraft.tail_wheel ? `rotate(180deg)` : ``,
                                                    borderLeft: !aircraft.tail_wheel ? "4px solid blue" : "",
                                                    borderBottom: !aircraft.tail_wheel ? "4px solid blue" : "",
                                                    borderRight: aircraft.tail_wheel ? "4px solid blue" : "",
                                                    borderTop: aircraft.tail_wheel ? "4px solid blue" : ""
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                textAlign: "center",
                                                children: wingspan
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    sx: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        children: [
                            "H: ",
                            tailHeight
                        ]
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
            sx: {
                color: "info.dark",
                fontSize: 18
            }
        })
    });
};

});
parcelRegister("86FOL", function(module, exports) {
$parcel$export(module.exports, "HtmlTooltip", () => (parcelRequire("9UCpe")).HtmlTooltip);
parcelRequire("9UCpe");

});
parcelRegister("9UCpe", function(module, exports) {

$parcel$export(module.exports, "HtmlTooltip", () => $751e8259069b8eb6$export$827543797958eaa6);

var $ayMG0 = parcelRequire("ayMG0");

var $cVXaD = parcelRequire("cVXaD");
var $eVjpW = parcelRequire("eVjpW");

var $d8seH = parcelRequire("d8seH");
const $751e8259069b8eb6$export$827543797958eaa6 = (0, $d8seH.default)(({ className: className, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        ...props,
        classes: {
            popper: className
        }
    }))(({})=>({
        [`& .${(0, $eVjpW.default).tooltip}`]: {
        }
    }));

});



parcelRegister("gQSh1", function(module, exports) {

$parcel$export(module.exports, "SexyText", () => $b3a983bd7ec87aa6$export$e755452f8ff23d2e);

var $ayMG0 = parcelRequire("ayMG0");

var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");
const $b3a983bd7ec87aa6$export$e755452f8ff23d2e = ({ value: initialValue, text: text, bidirectional: bidirectional = false })=>{
    const theme = (0, $14H9o.default)();
    const [isFlashing, setIsFlashing] = $acw62.useState(false);
    const [value, setValue] = $acw62.useState(initialValue);
    const [previousValue, setPreviousValue] = $acw62.useState();
    $acw62.useEffect(()=>{
        if (initialValue === value) return;
        setPreviousValue(value);
        setValue(initialValue);
    }, [
        initialValue
    ]);
    const startFlash = ()=>{
        setIsFlashing(true);
        setTimeout(()=>{
            setIsFlashing(false);
        }, 500); // Flash for 1 second (1000 milliseconds)
    };
    $acw62.useEffect(()=>{
        if (previousValue === undefined) return;
        startFlash();
    }, [
        value
    ]);
    const isBetter = value > previousValue;
    const backgroundColor = isFlashing ? isBetter ? theme.palette.primary.main : bidirectional ? theme.palette.primary.main : "inherit" : "inherit";
    if (!isBetter && !bidirectional) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: text
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: {
            width: "100%",
            height: "100%",
            color: isFlashing ? "white" : "inherit",
            backgroundColor: backgroundColor,
            transition: "background-color 0.5s ease-in-out",
            borderRadius: 2,
            padding: 3
        },
        children: text
    });
};

});

parcelRegister("hTRQz", function(module, exports) {

$parcel$export(module.exports, "AutocompleteAircraft", () => $5f5da27b48ebc472$export$84f7aff7bfa1b520);

var $ayMG0 = parcelRequire("ayMG0");

var $focGp = parcelRequire("focGp");

var $2P5BT = parcelRequire("2P5BT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $3kyM0 = parcelRequire("3kyM0");

var $iwiZ3 = parcelRequire("iwiZ3");
var $cFBau = parcelRequire("cFBau");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $hViLc = parcelRequire("hViLc");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $bqC3r = parcelRequire("bqC3r");
// Module-level cache with better race condition handling
class $5f5da27b48ebc472$var$AircraftCacheManager {
    subscribe(callback) {
        this.subscribers.add(callback);
        return ()=>{
            this.subscribers.delete(callback);
            // Clean up cache when no subscribers remain
            if (this.subscribers.size === 0) this.clearCache();
        };
    }
    notifySubscribers() {
        this.subscribers.forEach((callback)=>callback());
    }
    clearCache() {
        this.data = null;
        this.loading = false;
        this.error = null;
        this.promise = null;
    }
    async fetchData(postgrest) {
        // Return existing promise if one is already running to prevent race conditions
        if (this.promise) return this.promise;
        // Return cached data if available
        if (this.data && !this.error) return this.data;
        this.loading = true;
        this.error = null;
        this.notifySubscribers();
        this.promise = this.performFetch(postgrest);
        try {
            const result = await this.promise;
            this.data = result;
            this.loading = false;
            this.error = null;
            this.promise = null;
            this.notifySubscribers();
            return result;
        } catch (error) {
            this.loading = false;
            this.error = error;
            this.data = null;
            this.promise = null;
            this.notifySubscribers();
            throw error;
        }
    }
    async performFetch(postgrest) {
        const result = await postgrest.from("aircraft").select("id,make,model,geom,linked_to").order("make").order("model");
        return result.body?.filter((row)=>row.geom || row.linked_to) || [];
    }
    getState() {
        return {
            loading: this.loading,
            value: this.data,
            error: this.error
        };
    }
    constructor(){
        this.data = null;
        this.loading = false;
        this.error = null;
        this.promise = null;
        this.subscribers = new Set();
    }
}
const $5f5da27b48ebc472$var$aircraftCacheManager = new $5f5da27b48ebc472$var$AircraftCacheManager();
// Custom hook to fetch and cache aircraft data
const $5f5da27b48ebc472$var$useAircraftData = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [, forceUpdate] = $acw62.useReducer((x)=>x + 1, 0);
    $acw62.useEffect(()=>{
        // Subscribe to cache updates
        const unsubscribe = $5f5da27b48ebc472$var$aircraftCacheManager.subscribe(forceUpdate);
        return unsubscribe;
    }, []);
    $acw62.useEffect(()=>{
        // Use the cache manager to fetch data
        $5f5da27b48ebc472$var$aircraftCacheManager.fetchData(postgrest).catch(()=>{
        // Error is already handled by the cache manager
        });
    }, [
        postgrest
    ]);
    return $5f5da27b48ebc472$var$aircraftCacheManager.getState();
};
const $5f5da27b48ebc472$export$deaa129e639f7d8b = ({ open: open, setOpen: setOpen })=>{
    const { url: tokenMakerURL } = (0, $3kyM0.useTokenMaker)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [success, setSuccess] = $acw62.useState(false);
    const [make, setMake] = $acw62.useState("");
    const [model, setModel] = $acw62.useState("");
    const [uniqueMods, setUniqueMods] = $acw62.useState("");
    const [timeframe, setTimeframe] = $acw62.useState("");
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const onSubmit = $acw62.useCallback(async ()=>{
        try {
            const payload = {
                fbo_name: activeFBO.name,
                user_email: airplxIdentity.email,
                make: make,
                model: model,
                uniqueMods: uniqueMods,
                timeframe: timeframe
            };
            const payloadQuerystring = new URLSearchParams(payload).toString();
            const response = await fetch(`${tokenMakerURL}/request_aircraft?${payloadQuerystring}`);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        } catch (error) {
            console.error("Failed to submit aircraft request:", error);
            throw error; // Re-throw to allow UI to handle it
        }
    }, [
        activeFBO?.name,
        airplxIdentity.email,
        make,
        model,
        uniqueMods,
        timeframe,
        tokenMakerURL
    ]);
    $acw62.useEffect(()=>{
        setMake("");
        setModel("");
        setUniqueMods("");
        setTimeframe("");
        setSuccess(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
            open: open,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                    children: success ? "Request Received" : "New Aircraft Request"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                    sx: {
                        p: 1
                    },
                    children: success ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                        action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            color: "inherit",
                            size: "small",
                            onClick: ()=>setOpen(false),
                            children: "OK"
                        }),
                        children: "Thanks! We'll start working on this as soon as we can. We might email you if we have questions about the specifics of the aircraft you'd like to add so please watch your inbox."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            p: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    size: "small",
                                    autoFocus: true,
                                    required: true,
                                    label: "Manufacturer",
                                    type: "text",
                                    fullWidth: true,
                                    onChange: (evt)=>setMake(evt.target.value),
                                    value: make,
                                    sx: {
                                        mt: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    size: "small",
                                    required: true,
                                    label: "Model",
                                    type: "text",
                                    fullWidth: true,
                                    onChange: (evt)=>setModel(evt.target.value),
                                    value: model
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    size: "small",
                                    required: true,
                                    label: "Unique Modifiers (e.g. winglets, variations)",
                                    type: "text",
                                    fullWidth: true,
                                    onChange: (evt)=>setUniqueMods(evt.target.value),
                                    value: uniqueMods
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    size: "small",
                                    label: "Timeframe",
                                    type: "text",
                                    fullWidth: true,
                                    onChange: (evt)=>setTimeframe(evt.target.value),
                                    value: timeframe
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    children: "Allow 2-4 days for upload of new aircraft models. We will notify once it is available."
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                    children: success ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                color: "error",
                                onClick: ()=>setOpen(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                disabled: !Boolean(make) || !Boolean(model),
                                color: "success",
                                variant: "contained",
                                onClick: async ()=>{
                                    await onSubmit();
                                    setSuccess(true);
                                },
                                children: "Submit"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $5f5da27b48ebc472$export$84f7aff7bfa1b520 = ({ label: label, onSelect: onSelect, defaultSelected: defaultSelected, shouldFlash: shouldFlash = false })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [submitNewAircraftOpen, setSubmitNewAircraftOpen] = $acw62.useState(false);
    const [selected, setSelected] = $acw62.useState(defaultSelected);
    const [isHighlighted, setIsHighlighted] = $acw62.useState(false);
    const isFirstRender = $acw62.useRef(true);
    const flashedAircraftId = $acw62.useRef(null);
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const state = $5f5da27b48ebc472$var$useAircraftData();
    // Update selected only when the aircraft ID actually changes (not just object reference)
    $acw62.useEffect(()=>{
        // Only update if the aircraft ID is different or if going from something to nothing/vice versa
        if (defaultSelected?.id !== selected?.id) setSelected(defaultSelected);
    }, [
        defaultSelected?.id,
        selected?.id
    ]);
    // Flash when shouldFlash is true and we have a NEW aircraft to show
    $acw62.useEffect(()=>{
        if (shouldFlash && defaultSelected?.id) // Only flash if this is a different aircraft than we've already flashed
        {
            if (flashedAircraftId.current !== defaultSelected.id) {
                flashedAircraftId.current = defaultSelected.id;
                setIsHighlighted(true);
                // Reset highlight after 1 second
                const timer = setTimeout(()=>{
                    setIsHighlighted(false);
                }, 1000);
                return ()=>clearTimeout(timer);
            }
        }
    }, [
        shouldFlash,
        defaultSelected?.id
    ]);
    // Track first render separately
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                loading: state.loading,
                options: state.value ?? [],
                filterOptions: (0, $bqC3r.filterOptions),
                ListboxProps: {
                    // Limit visible height and optimize scrolling
                    style: {
                        maxHeight: "40vh",
                        // Limit to 40% of viewport height
                        overflow: "auto"
                    }
                },
                slotProps: {
                    popper: {
                        sx: {
                            zIndex: 10000 // Higher than dialog (9600)
                        }
                    }
                },
                noOptionsText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "contained",
                    color: "success",
                    endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($focGp))), {}),
                    onClick: ()=>setSubmitNewAircraftOpen(true),
                    children: "No aircraft found \u2022\xa0Click here to request a new aircraft"
                }),
                getOptionLabel: (option)=>{
                    if (!option) return "";
                    return `${option.make || ""} ${option.model || ""}`.trim();
                },
                isOptionEqualToValue: (option, value)=>option?.id === value?.id,
                onChange: async (event, newValue)=>{
                    if (!newValue) {
                        onSelect(null);
                        setSelected(null);
                        return;
                    }
                    try {
                        const fullValue = await postgrest.from("aircraft").select().eq("id", newValue.id).single();
                        const { data: geom_scaled_buffer } = await postgrest.rpc("buffer", {
                            geom: fullValue.data.scaled_geom_full,
                            radius: activeFBO.sop_horizontal_spacing ?? 2
                        });
                        const { data: aircraftGeomZM } = await postgrest.rpc("scaled_geomz_full", {
                            aircraft_ids: [
                                newValue.id
                            ]
                        });
                        const { data: ramp_geom_scaled_buffer } = await postgrest.rpc("buffer", {
                            geom: fullValue.data.scaled_geom_full,
                            radius: activeFBO.sop_ramp_horizontal_spacing ?? 10
                        });
                        const selectedAircraft = {
                            ...fullValue.data,
                            geom_scaled_buffer: geom_scaled_buffer,
                            ramp_geom_scaled_buffer: ramp_geom_scaled_buffer,
                            scaled_geomz_full: aircraftGeomZM?.[0]?.geomzm?.geometry
                        };
                        onSelect(selectedAircraft);
                        setSelected(selectedAircraft);
                    } catch (error) {
                        console.error("Failed to load aircraft details:", error);
                        // Still call onSelect with the basic aircraft data to avoid breaking the UI
                        onSelect(newValue);
                        setSelected(newValue);
                    }
                },
                value: selected || null,
                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        ...params,
                        label: label ?? "Aircraft",
                        size: "small",
                        sx: (theme)=>({
                                "& .MuiOutlinedInput-root": isHighlighted ? {
                                    borderColor: theme.palette.success.main,
                                    borderWidth: "2px",
                                    boxShadow: `0 0 0 3px ${theme.palette.success.main}40`,
                                    animation: "highlight-pulse 1s ease-in-out 1",
                                    "@keyframes highlight-pulse": {
                                        "0%": {
                                            borderColor: theme.palette.success.main,
                                            borderWidth: "2px",
                                            boxShadow: `0 0 0 3px ${theme.palette.success.main}40`
                                        },
                                        "50%": {
                                            borderColor: theme.palette.success.light,
                                            borderWidth: "3px",
                                            boxShadow: `0 0 0 6px ${theme.palette.success.main}60`
                                        },
                                        "100%": {
                                            borderColor: theme.palette.success.main,
                                            borderWidth: "2px",
                                            boxShadow: `0 0 0 3px ${theme.palette.success.main}40`
                                        }
                                    }
                                } : {}
                            }),
                        InputProps: {
                            ...params.InputProps,
                            startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                position: "start",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                            })
                        },
                        inputProps: {
                            ...params.inputProps,
                            "data-testid": "autocomplete_aircraft"
                        }
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($5f5da27b48ebc472$export$deaa129e639f7d8b, {
                open: submitNewAircraftOpen,
                setOpen: setSubmitNewAircraftOpen
            })
        ]
    });
};

});
parcelRegister("focGp", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $b342ef7cdf5e20bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b342ef7cdf5e20bb$var$_createSvgIcon = $b342ef7cdf5e20bb$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b342ef7cdf5e20bb$var$_default = module.exports.default = (0, $b342ef7cdf5e20bb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), 'HelpOutline');

});

parcelRegister("2P5BT", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $20e4b243ccff587b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20e4b243ccff587b$var$_createSvgIcon = $20e4b243ccff587b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $20e4b243ccff587b$var$_default = module.exports.default = (0, $20e4b243ccff587b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');

});

parcelRegister("iwiZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7b9f0ef25189a24$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6lpak = parcelRequire("6lpak");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $7Frhn = parcelRequire("7Frhn");

var $2xI7c = parcelRequire("2xI7c");

var $9Lykx = parcelRequire("9Lykx");

var $1hqLn = parcelRequire("1hqLn");

var $8kXp7 = parcelRequire("8kXp7");

var $f42XJ = parcelRequire("f42XJ");

var $a8MtG = parcelRequire("a8MtG");

var $ldBGF = parcelRequire("ldBGF");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color || severity)}`,
            `${variant}${(0, $jTnBY.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $2xI7c.getAlertUtilityClass), classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $8gMkr.darken) : (0, $8gMkr.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $8gMkr.lighten) : (0, $8gMkr.darken);
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $2xI7c.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $2xI7c.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $d7b9f0ef25189a24$var$AlertIcon = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1hqLn.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8kXp7.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f42XJ.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8MtG.default), {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $d7b9f0ef25189a24$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $6lpak.default)('icon', {
        className: classes.icon,
        elementType: $d7b9f0ef25189a24$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $6lpak.default)('message', {
        className: classes.message,
        elementType: $d7b9f0ef25189a24$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $6lpak.default)('action', {
        className: classes.action,
        elementType: $d7b9f0ef25189a24$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $6lpak.default)('closeButton', {
        elementType: (0, $9Lykx.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $6lpak.default)('closeIcon', {
        elementType: (0, $ldBGF.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $d7b9f0ef25189a24$export$2e2bcd8739ae039 = $d7b9f0ef25189a24$var$Alert;

});
parcelRegister("2xI7c", function(module, exports) {

$parcel$export(module.exports, "getAlertUtilityClass", () => $1da0e229d53b4459$export$69aecd24bc2cf7e3);
$parcel$export(module.exports, "default", () => $1da0e229d53b4459$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1da0e229d53b4459$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)('MuiAlert', slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $beCSm.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $1da0e229d53b4459$export$2e2bcd8739ae039 = $1da0e229d53b4459$var$alertClasses;

});

parcelRegister("9Lykx", function(module, exports) {

$parcel$export(module.exports, "default", () => $71c322247f7fbf93$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $5A6d3 = parcelRequire("5A6d3");

var $8gMkr = parcelRequire("8gMkr");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $2cPwN = parcelRequire("2cPwN");

var $jTnBY = parcelRequire("jTnBY");

var $jzUw6 = parcelRequire("jzUw6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jzUw6.getIconButtonUtilityClass), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $aeD7H.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $jzUw6.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $jzUw6.default).loading}`]: {
            color: 'transparent'
        }
    })));
const $71c322247f7fbf93$var$IconButtonLoadingIndicator = (0, $d8seH.default)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $5A6d3.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($71c322247f7fbf93$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ayMG0.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;

});
parcelRegister("jzUw6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getIconButtonUtilityClass", () => $e40d2047b7c1e09d$export$5e8702d71474f093);
$parcel$export(module.exports, "default", () => $e40d2047b7c1e09d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $beCSm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;

});


parcelRegister("1hqLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eec239707c48bf2$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0eec239707c48bf2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

});

parcelRegister("8kXp7", function(module, exports) {

$parcel$export(module.exports, "default", () => $611e456547a52fc7$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $611e456547a52fc7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

});

parcelRegister("f42XJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $af7987087272cca1$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $af7987087272cca1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

});

parcelRegister("a8MtG", function(module, exports) {

$parcel$export(module.exports, "default", () => $76204164d2201318$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $76204164d2201318$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

});

parcelRegister("ldBGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7280bbf95507cba$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});


parcelRegister("cFBau", function(module, exports) {

$parcel$export(module.exports, "default", () => $9396253983985262$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $33DpT = parcelRequire("33DpT");

var $e76iu = parcelRequire("e76iu");

var $7djgP = parcelRequire("7djgP");

var $7Frhn = parcelRequire("7Frhn");

var $9Lykx = parcelRequire("9Lykx");

var $6ami2 = parcelRequire("6ami2");

var $b3ugU = parcelRequire("b3ugU");

var $dmljZ = parcelRequire("dmljZ");

var $96QZi = parcelRequire("96QZi");

var $faAxf = parcelRequire("faAxf");

var $ldBGF = parcelRequire("ldBGF");

var $7LRfY = parcelRequire("7LRfY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $9O25J = parcelRequire("9O25J");

var $jTnBY = parcelRequire("jTnBY");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9O25J.getAutocompleteUtilityClass), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $9O25J.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $9O25J.default).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $9O25J.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $9O25J.default).input}`]: styles.input
            },
            {
                [`& .${(0, $9O25J.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $9O25J.default).focused} .${(0, $9O25J.default).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $9O25J.default).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $9O25J.default).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $9O25J.default).inputRoot}`]: {
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $9O25J.default).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $b3ugU.default).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $b3ugU.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        [`& .${(0, $b3ugU.default).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $96QZi.default).root}`]: {
        padding: 9,
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $9O25J.default).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $9O25J.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $96QZi.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $9O25J.default).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $faAxf.default).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $faAxf.default).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $9O25J.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $faAxf.default).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $dmljZ.default).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $9O25J.default).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).hiddenLabel}.${(0, $dmljZ.default).sizeSmall}`]: {
        [`& .${(0, $9O25J.default).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $9O25J.default).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $9O25J.default).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $9O25J.default).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $9O25J.default).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $9Lykx.default), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $9Lykx.default), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9O25J.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})((0, $aeD7H.default)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $9O25J.default).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $9O25J.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $9O25J.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $9O25J.default).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $9O25J.default).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    })));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $7djgP.default), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})((0, $aeD7H.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $9O25J.default).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldBGF.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7LRfY.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $33DpT.default)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $6lpak.default)('listbox', {
        elementType: $9396253983985262$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $6lpak.default)('paper', {
        elementType: (0, $7Frhn.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $6lpak.default)('popper', {
        elementType: (0, $e76iu.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>({
                className: classes.tag,
                disabled: disabled,
                ...getTagProps(params)
            });
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const { key: key, ...customTagProps } = getCustomizedTagProps({
                index: index
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                label: getOptionLabel(option),
                size: size,
                ...customTagProps,
                ...externalForwardedProps.slotProps.chip
            }, key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $9QePP.default)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $9QePP.default)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $9QePP.default)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;

});
parcelRegister("33DpT", function(module, exports) {

$parcel$export(module.exports, "createFilterOptions", () => $23a03a376a300fc5$export$f76f94b238d946d8);
$parcel$export(module.exports, "default", () => $23a03a376a300fc5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hervl = parcelRequire("hervl");
var $agZ85 = parcelRequire("agZ85");
var $13KXh = parcelRequire("13KXh");
var $auC0X = parcelRequire("auC0X");
var $9D07P = parcelRequire("9D07P");
'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $23a03a376a300fc5$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$getInputValue(value, multiple, getOptionLabel) {
    if (multiple || value == null) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $auC0X.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $acw62.useRef($23a03a376a300fc5$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $agZ85.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $agZ85.default)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $23a03a376a300fc5$var$getInputValue(newValue, multiple, getOptionLabel);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $agZ85.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $9D07P.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $13KXh.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $13KXh.default)(({ event: event, index: index, reason: reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $13KXh.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $13KXh.default)((node)=>{
        (0, $hervl.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleTagDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$export$2e2bcd8739ae039 = $23a03a376a300fc5$var$useAutocomplete;

});
parcelRegister("9D07P", function(module, exports) {

$parcel$export(module.exports, "default", () => $7027da6f4b17de9d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $7027da6f4b17de9d$var$usePreviousProps = (value)=>{
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;

});


parcelRegister("7djgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5408b2039b9d572c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $ixwSf = parcelRequire("ixwSf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ixwSf.getListSubheaderUtilityClass), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($5408b2039b9d572c$var$ListSubheader) $5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;

});
parcelRegister("ixwSf", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", () => $d7f4cf29715b69dd$export$6816d4fc0981ec7);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $beCSm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;

});


parcelRegister("6ami2", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d4f79319086dc5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $8u0rE = parcelRequire("8u0rE");

var $9Rgf1 = parcelRequire("9Rgf1");


var $jTnBY = parcelRequire("jTnBY");

var $6n0Ko = parcelRequire("6n0Ko");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $iNSYf = parcelRequire("iNSYf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iNSYf.getChipUtilityClass), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles[`iconColor${(0, $jTnBY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $jTnBY.default)(color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $iNSYf.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $iNSYf.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $iNSYf.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $iNSYf.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $iNSYf.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $iNSYf.default).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $8gMkr.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $8gMkr.alpha)(theme.palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $iNSYf.default).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $iNSYf.default).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].contrastTextChannel} / 0.7)` : (0, $8gMkr.alpha)(theme.palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $iNSYf.default).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $iNSYf.default).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $iNSYf.default).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8gMkr.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $iNSYf.default).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8gMkr.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
                    },
                    [`&.${(0, $iNSYf.default).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8gMkr.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $iNSYf.default).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $iNSYf.default).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $iNSYf.default).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $iNSYf.default).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $iNSYf.default).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $iNSYf.default).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $iNSYf.default).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $iNSYf.default).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $iNSYf.default).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $8gMkr.alpha)(theme.palette[color].main, 0.7)}`,
                        [`&.${(0, $iNSYf.default).clickable}:hover`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        },
                        [`&.${(0, $iNSYf.default).focusVisible}`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.focusOpacity)
                        },
                        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $8gMkr.alpha)(theme.palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, // TODO v6: Rename to `focusableWhenDisabled`.
    ...other } = props;
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $6n0Ko.default) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $6n0Ko.default) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $9QePP.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8u0rE.default), {
        className: (0, $9QePP.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $9QePP.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState,
        ...moreProps,
        ...other,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $9QePP.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;

});
parcelRegister("8u0rE", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d1787512a69c15$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("iNSYf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getChipUtilityClass", () => $db0771a9e6a32b1d$export$31444911e4ee6fdd);
$parcel$export(module.exports, "default", () => $db0771a9e6a32b1d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $beCSm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;

});


parcelRegister("9O25J", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", () => $723a67e53eb4dc4c$export$8ee01529667e66d9);
$parcel$export(module.exports, "default", () => $723a67e53eb4dc4c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $beCSm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;

});


parcelRegister("bqC3r", function(module, exports) {

$parcel$export(module.exports, "filterOptions", () => $555040406bbd8a95$export$60d56ed3961c839c);

var $acw62 = parcelRequire("acw62");

var $5KGQl = parcelRequire("5KGQl");
/**
 * Escape special regex characters in a string to treat them as literals.
 * This prevents regex syntax errors when user input contains metacharacters.
 */ const $555040406bbd8a95$var$escapeRegex = (str)=>{
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
/**
 * Score a single token against a target string.
 * Lower scores indicate better matches.
 */ const $555040406bbd8a95$var$scoreToken = (token, target, isMakeField)=>{
    const lowerTarget = target.toLowerCase();
    const lowerToken = token.toLowerCase();
    // Exact match (entire field matches token)
    if (lowerTarget === lowerToken) return isMakeField ? 0 : 1; // Prefer make matches
    // Prefix match (token starts the field)
    if (lowerTarget.startsWith(lowerToken)) return isMakeField ? 10 : 11;
    // Word boundary match (token starts a word in the field)
    const wordBoundaryRegex = new RegExp(`\\b${$555040406bbd8a95$var$escapeRegex(lowerToken)}`, "i");
    if (wordBoundaryRegex.test(lowerTarget)) {
        const matchIndex = lowerTarget.search(wordBoundaryRegex);
        return isMakeField ? 20 + matchIndex : 21 + matchIndex;
    }
    // Substring match (token appears anywhere)
    const substringIndex = lowerTarget.indexOf(lowerToken);
    if (substringIndex !== -1) return isMakeField ? 30 + substringIndex : 31 + substringIndex;
    // Fuzzy match (Levenshtein distance) - only for tokens of 4+ characters
    // Short tokens should rely on exact/prefix/substring matching
    if (lowerToken.length >= 4) {
        const distance = (0, $5KGQl.levenshtein)(lowerToken, lowerTarget);
        // Use stricter threshold for shorter tokens
        const threshold = lowerToken.length <= 5 ? 2 : 4;
        if (distance <= threshold) return isMakeField ? 40 + distance : 41 + distance;
    }
    // No match
    return Infinity;
};
/**
 * Calculate the overall score for an aircraft against the search input.
 * Uses token-based scoring with partial matching support.
 */ const $555040406bbd8a95$var$scoreAircraft = (aircraft, inputTokens)=>{
    const make = aircraft.make || "";
    const model = aircraft.model || "";
    const fullName = `${make} ${model}`;
    // Score each token independently and sum them
    const tokenScores = inputTokens.map((token)=>{
        // Try matching against make, model, and full name
        const makeScore = $555040406bbd8a95$var$scoreToken(token, make, true);
        const modelScore = $555040406bbd8a95$var$scoreToken(token, model, false);
        const fullNameScore = $555040406bbd8a95$var$scoreToken(token, fullName, false);
        // Return the best (lowest) score for this token
        return Math.min(makeScore, modelScore, fullNameScore);
    });
    // Sum all token scores (allows partial matching)
    // If any token has Infinity score, the total will be Infinity
    const totalScore = tokenScores.reduce((sum, score)=>sum + score, 0);
    return totalScore;
};
const $555040406bbd8a95$export$d6edc470b926b1ee = (options, inputValue)=>{
    if (!inputValue) return options;
    // Prepare input tokens
    const input = inputValue.toLowerCase().trim();
    const inputTokens = input.split(/\s+/).filter((t)=>t.length > 0);
    if (inputTokens.length === 0) return options;
    // Calculate scores for all aircraft
    const scoredAircraft = options.map((option)=>{
        const score = $555040406bbd8a95$var$scoreAircraft(option, inputTokens);
        return {
            option: option,
            score: score
        };
    });
    // Filter out aircraft with no matches (Infinity score)
    const filteredMatches = scoredAircraft.filter((match)=>match.score !== Infinity);
    // Sort by score (ascending - lower is better)
    filteredMatches.sort((a, b)=>a.score - b.score);
    // Return just the aircraft objects in sorted order
    return filteredMatches.map((match)=>match.option);
};
const $555040406bbd8a95$export$2cfd1f4eb9a90d7e = (options, inputValue)=>{
    return (0, $acw62.useMemo)(()=>{
        return $555040406bbd8a95$export$d6edc470b926b1ee(options, inputValue);
    }, [
        options,
        inputValue
    ]);
};
const $555040406bbd8a95$export$60d56ed3961c839c = (options, { inputValue: inputValue })=>{
    return $555040406bbd8a95$export$d6edc470b926b1ee(options, inputValue);
};

});


parcelRegister("bdiEl", function(module, exports) {

$parcel$export(module.exports, "AnnualTenantTable", () => $0b10a2bf45c8a70b$export$5c02f5f34b4b70b6);

var $ayMG0 = parcelRequire("ayMG0");

var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $8pYaz = parcelRequire("8pYaz");
const $0b10a2bf45c8a70b$export$5c02f5f34b4b70b6 = ({ aircraftFee: aircraftFee, camFees: camFees, totalFee: totalFee })=>{
    const [percentageIncrease, setPercentageIncrease] = (0, $acw62.useState)(5);
    // Calculate fees for 5 years
    const fees = Array.from({
        length: 5
    }, (_, i)=>{
        if (!aircraftFee) return {
            aircraftFee: "---",
            camFees: "---",
            totalFee: "---"
        };
        return {
            aircraftFee: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(aircraftFee * Math.pow(1 + percentageIncrease / 100, i)),
            camFees: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(camFees * Math.pow(1 + percentageIncrease / 100, i)),
            totalFee: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(totalFee * Math.pow(1 + percentageIncrease / 100, i))
        };
    });
    const showBufferColumn = camFees !== undefined;
    const showBufferAndCamColumn = totalFee !== undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: "Annual % Increase"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8pYaz.PercentageInput), {
                        initialValue: percentageIncrease,
                        onChange: (value)=>setPercentageIncrease(value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Aircraft Fee"
                                }),
                                showBufferColumn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "CAM Fees"
                                }),
                                showBufferAndCamColumn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Total Fee"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                        children: fees.map((fee, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "center",
                                        children: `Year ${index + 1}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "center",
                                        children: fee.aircraftFee
                                    }),
                                    showBufferColumn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "center",
                                        children: fee.camFees
                                    }),
                                    showBufferAndCamColumn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "center",
                                        children: fee.totalFee
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("8pYaz", function(module, exports) {

$parcel$export(module.exports, "PercentageInput", () => $042ebb61a9ba6b3d$export$8a93502f8ade010f);

var $ayMG0 = parcelRequire("ayMG0");

var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $042ebb61a9ba6b3d$export$8a93502f8ade010f = ({ initialValue: initialValue, step: step = 0.01, onChange: onChange, ...props })=>{
    const [value, setValue] = (0, $acw62.useState)(initialValue);
    const handleChange = (event)=>{
        const inputValue = event.target.value;
        // Allow empty string (to clear input) or valid number
        if (inputValue === "" || !isNaN(Number(inputValue))) {
            setValue(inputValue === "" ? "" : Number(inputValue));
            onChange && onChange(Number(inputValue));
        }
    };
    const handleBlur = ()=>{
        // Round to 2 decimal places on blur
        if (value !== "" && typeof value === "number") setValue(parseFloat(value.toFixed(2)));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
        ...props,
        type: "number",
        size: "small",
        value: value,
        onChange: handleChange,
        onBlur: handleBlur,
        InputProps: {
            ...props.InputProps,
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                children: "%"
            }),
            inputProps: {
                ...props.InputProps?.inputProps,
                step: step,
                // Add step for up/down arrows
                min: 0,
                // Optional: Prevent negative percentages
                max: 100 // Optional: Limit to 100%
            }
        }
    });
};

});



parcelRegister("7FzhI", function(module, exports) {

$parcel$export(module.exports, "HangarsStateContainer", () => $ad3cff08013b66dd$export$eb911f9a5725ae6);
$parcel$export(module.exports, "useHangarsState", () => $ad3cff08013b66dd$export$9e7cf790a1fae655);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1Ttlg = parcelRequire("1Ttlg");

var $44Pku = parcelRequire("44Pku");
const $ad3cff08013b66dd$var$HangarsStateContainerState = /*#__PURE__*/ $acw62.createContext(undefined);
const $ad3cff08013b66dd$export$eb911f9a5725ae6 = ({ children: children, isReference: isReference })=>{
    const { ready: ready, hangars: hangars, setHangars: setHangars } = (0, $1Ttlg.useHangars)(isReference);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ad3cff08013b66dd$var$HangarsStateContainerState.Provider, {
        value: {
            ready: ready,
            hangars: hangars,
            setHangars: setHangars
        },
        children: ready ? children : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44Pku.HangarsSkeleton), {})
    });
};
const $ad3cff08013b66dd$export$9e7cf790a1fae655 = ()=>{
    const context = $acw62.useContext($ad3cff08013b66dd$var$HangarsStateContainerState);
    if (!context) throw new Error('useHangarsState must be used within HangarsStateContainer');
    return context;
};

});
parcelRegister("1Ttlg", function(module, exports) {

$parcel$export(module.exports, "useHangars", () => $be82616a1f9effc0$export$5805737883ede3c4);

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $97sqG = parcelRequire("97sqG");

var $8GP8k = parcelRequire("8GP8k");

var $W9FY8 = parcelRequire("W9FY8");
const $be82616a1f9effc0$export$5805737883ede3c4 = (isReference)=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [ready, setReady] = $acw62.useState(false);
    const [hangars, setHangars] = $acw62.useState(null);
    (0, $W9FY8.default)({
        thingToWatch: hangars,
        tableName: "hangar"
    });
    // grab the hangar to start
    $acw62.useEffect(()=>{
        (async ()=>{
            const zHangars = await (0, $8GP8k.fetchHangars)(postgrest, activeFBO, isReference);
            setHangars(zHangars.sort((a, b)=>(0, $97sqG.sortHangars)(a, b, activeFBO?.settings?.hangarDisplayOrder)));
            setReady(true);
        })();
    }, []);
    return {
        ready: ready,
        hangars: hangars ?? [],
        setHangars: setHangars
    };
};

});
parcelRegister("97sqG", function(module, exports) {

$parcel$export(module.exports, "sortHangars", () => $216df0feb33e8435$export$15715539b7240e9d);
$parcel$export(module.exports, "sortByNumberThenText", () => $216df0feb33e8435$export$e4d2e447d9407726);
$parcel$export(module.exports, "estimateValue", () => $216df0feb33e8435$export$356ca06baaa2d166);
$parcel$export(module.exports, "calcEstimateTowTime", () => $216df0feb33e8435$export$462d3000c904c8f6);
$parcel$export(module.exports, "HangarsPresenter", () => $216df0feb33e8435$export$ff51d0c0ecc7c11);

var $ayMG0 = parcelRequire("ayMG0");

var $ltk0t = parcelRequire("ltk0t");

var $8Ks9I = parcelRequire("8Ks9I");

var $gFNdt = parcelRequire("gFNdt");

var $2SjXn = parcelRequire("2SjXn");

var $ex6lH = parcelRequire("ex6lH");

var $hllcA = parcelRequire("hllcA");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
var $18tt9 = parcelRequire("18tt9");
var $14H9o = parcelRequire("14H9o");
parcelRequire("acw62");

var $fBVnr = parcelRequire("fBVnr");

var $ZD2ym = parcelRequire("ZD2ym");

var $7FzhI = parcelRequire("7FzhI");

var $gqehT = parcelRequire("gqehT");

var $kWYrU = parcelRequire("kWYrU");

var $5KGQl = parcelRequire("5KGQl");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $aHqXU = parcelRequire("aHqXU");

var $gtiLb = parcelRequire("gtiLb");

var $kPMZ3 = parcelRequire("kPMZ3");

var $hKDIt = parcelRequire("hKDIt");

var $XeBZd = parcelRequire("XeBZd");

var $44Pku = parcelRequire("44Pku");

var $3Zybu = parcelRequire("3Zybu");
const $216df0feb33e8435$export$831d57629967e241 = (text)=>{
    // get first integer from text via regex
    const matches = text.match(/\d+/);
    if (matches) return [
        Number(matches[0]),
        text.match(/\d+[A-Za-z]+/)?.[0]
    ];
    return [
        null,
        null
    ];
};
const $216df0feb33e8435$export$15715539b7240e9d = (a, b, hangarDisplayOrder)=>{
    if (hangarDisplayOrder) {
        const aIndex = hangarDisplayOrder.indexOf(a.id);
        const bIndex = hangarDisplayOrder.indexOf(b.id);
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        else if (aIndex !== -1) return -1;
        else if (bIndex !== -1) return 1;
    }
    return $216df0feb33e8435$export$e4d2e447d9407726(a.name, b.name);
};
const $216df0feb33e8435$export$e4d2e447d9407726 = (a, b)=>{
    const [aNumber, aAlphaNumeric] = $216df0feb33e8435$export$831d57629967e241(a);
    const [bNumber, bAlphaNumeric] = $216df0feb33e8435$export$831d57629967e241(b);
    if (aNumber !== null && bNumber !== null) {
        // If both first words are numbers, compare them numerically
        if (Number(aNumber) === Number(bNumber)) {
            if (aAlphaNumeric && bAlphaNumeric) return aAlphaNumeric.localeCompare(bAlphaNumeric);
            return a.localeCompare(b);
        }
        return Number(aNumber) - Number(bNumber);
    } else if (aNumber !== null) // If only the first word in a is a number, a comes before b
    return -1;
    else if (bNumber !== null) // If only the first word in b is a number, b comes before a
    return 1;
    else // Otherwise, compare alphabetically
    return a.localeCompare(b);
};
const $216df0feb33e8435$export$356ca06baaa2d166 = (fbo, hangar, polygons, _ignoreDeadSpaceForUtilization = false, monthly = false)=>{
    if (hangar.stack.name === "reference") {
        const tenantUtilization = (0, $kPMZ3.calculateUtilization)(hangar, polygons, false, false // ignoreDeadSpaceForUtilization
        );
        const sqftValue = fbo.nightly_base_rate ?? 0.2;
        const value = tenantUtilization / 100 * hangar.width * hangar.depth * sqftValue * (monthly ? 30.44 : 1);
        return (0, $lNEp2.formatCurrency)(10 * Math.round(Math.ceil(value) / 10), 0);
    }
    const transientUtilization = (0, $kPMZ3.calculateUtilization)({
        ...hangar,
        stack: {
            ...hangar.stack,
            tenants: hangar.stack.tenants.filter((t)=>t.type === "transient")
        }
    }, polygons, true, false // ignoreDeadSpaceForUtilization
    );
    const sqftValue = fbo.nightly_transient_rate ?? 0.2;
    const value = (monthly ? 30.44 : 1) * hangar.base_tenant_value + transientUtilization / 100 * hangar.width * hangar.depth * sqftValue * (monthly ? 30.44 : 1);
    return (0, $lNEp2.formatCurrency)(10 * Math.round(Math.ceil(value) / 10), 0);
};
const $216df0feb33e8435$var$isLocked = (t)=>{
    return t.position.preferences.find((p)=>p === (0, $keHtM.Preference).LOCKED) !== undefined;
};
const $216df0feb33e8435$export$462d3000c904c8f6 = (hangar, polygons)=>{
    const tenants = (0, $kPMZ3.findTenantsFullyInHangar)(hangar, polygons).filter((t)=>!$216df0feb33e8435$var$isLocked(t));
    const dist = (0, $cLNZr.sum)(tenants.map((t)=>Math.max(0, Math.abs(t.position.angle) > 90 ? t.position.y ?? 0 : t.aircraft.length + (t.position.y ?? 0)))) ?? 0;
    const totalMinutes = 2 * dist / 150 + 6 * tenants.length;
    if (!totalMinutes) return "\u2013\u2013\u2013";
    return `${Math.ceil(totalMinutes)} min`;
};
const $216df0feb33e8435$export$ff51d0c0ecc7c11 = ()=>{
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const theme = (0, $14H9o.default)();
    const isTablet = (0, $18tt9.default)(theme.breakpoints.down("lg")); // Hide columns on tablets and smaller
    const displayEstimatedValue = (0, $aHqXU.getRoleSetting)(activeFBO, "displayEstimatedValue", true);
    const displayEditTenants = hasPermission((0, $aHqXU.Permission).MODIFY_TENANTS);
    const { ready: ready, hangars: hangars } = (0, $7FzhI.useHangarsState)();
    const sortedHangars = [
        ...hangars
    ].sort((a, b)=>$216df0feb33e8435$export$15715539b7240e9d(a, b, activeFBO?.settings?.hangarDisplayOrder));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            ml: 2,
            mr: 2,
            height: "100%",
            minHeight: "calc(100vh - 64px)",
            pb: 4
        },
        children: !ready ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44Pku.HangarsSkeleton), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: {
                        mt: 2,
                        mb: 2.25,
                        pb: 1.5,
                        borderBottom: "1px solid",
                        borderColor: "divider"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "h6",
                            children: [
                                "Hangars \u2013 ",
                                activeFBO?.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Zybu.MultiHangarButton), {
                            hangars: hangars
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    sx: {
                        mb: 2,
                        width: "100%",
                        maxWidth: 900,
                        "& > *": {
                            flex: 1,
                            maxWidth: 420
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $XeBZd.StatCard), {
                            icon: (0, $gtiLb.HangarIcon),
                            label: "Total Hangars",
                            value: hangars.length,
                            testId: "total_hangars"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $XeBZd.StatCard), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFNdt))),
                            label: "Total Aircraft in Hangars",
                            value: (0, $cLNZr.sum)(hangars.map((h)=>h.stack.tenants.length)),
                            testId: "total_aircraft"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        flex: 1,
                        overflow: "auto",
                        minHeight: 0,
                        bgcolor: "background.paper",
                        ...(0, $lNEp2.scrollSx)
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                display: "grid",
                                gridTemplateColumns: isTablet ? "200px 160px 180px 120px 1fr" : displayEstimatedValue ? "200px 160px 180px 120px 140px 120px 1fr" : "200px 160px 180px 140px 120px 1fr",
                                alignItems: "center",
                                gap: 2,
                                px: 2.5,
                                py: 1,
                                borderBottom: "1px solid",
                                borderColor: "grey.200",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                                bgcolor: "background.paper"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: {
                                        fontWeight: 500,
                                        fontSize: "0.95rem"
                                    },
                                    children: "Hangar Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 0.5,
                                    justifyContent: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Ks9I))), {
                                            sx: {
                                                color: "text.disabled",
                                                fontSize: "0.85rem",
                                                opacity: 0.8
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                fontWeight: 500,
                                                fontSize: "0.95rem"
                                            },
                                            children: "Aircraft"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "# aircraft inside hangar / # aircraft wanted inside",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "text.disabled",
                                                    fontSize: "0.85rem",
                                                    opacity: 0.8
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 0.5,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hllcA))), {
                                            sx: {
                                                color: "text.disabled",
                                                fontSize: "0.85rem",
                                                opacity: 0.8
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                fontWeight: 500,
                                                fontSize: "0.95rem"
                                            },
                                            children: "Utilization"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    p: 0.5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        sx: {
                                                            fontWeight: 600,
                                                            mb: 1
                                                        },
                                                        children: "Utilization"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        component: "div",
                                                        sx: {
                                                            mb: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Stacked"
                                                            }),
                                                            " shows current utilization, which can exceed 100% when aircraft are parked in the negative space of other aircraft footprints."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        component: "div",
                                                        sx: {
                                                            mb: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "At full tenant load"
                                                            }),
                                                            " shows what utilization would be if every aircraft assigned to this hangar were on the ground at once."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        sx: {
                                                            mb: 1
                                                        },
                                                        children: "The gauge shows a baseline marker at 100% - blue below, green above."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        sx: {
                                                            display: "block",
                                                            opacity: 0.8
                                                        },
                                                        children: "Adjust how this is calculated in Settings \u2192 Configuration"
                                                    })
                                                ]
                                            }),
                                            arrow: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "text.disabled",
                                                    fontSize: "0.85rem",
                                                    opacity: 0.8
                                                }
                                            })
                                        })
                                    ]
                                }),
                                !isTablet && displayEstimatedValue && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 0.5,
                                    justifyContent: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                fontWeight: 500,
                                                fontSize: "0.95rem"
                                            },
                                            children: "Est. Value"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "Estimated value of the hangar per night based on aircraft fully inside the hangar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "text.disabled",
                                                    fontSize: "0.85rem",
                                                    opacity: 0.8
                                                }
                                            })
                                        })
                                    ]
                                }),
                                !isTablet && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 0.5,
                                    justifyContent: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ltk0t))), {
                                            sx: {
                                                color: "text.disabled",
                                                fontSize: "0.85rem",
                                                opacity: 0.8
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                fontWeight: 500,
                                                fontSize: "0.95rem"
                                            },
                                            children: "Est. Tow Time"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "Estimated time to tow hangar into position",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "text.disabled",
                                                    fontSize: "0.85rem",
                                                    opacity: 0.8
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 0.5,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2SjXn))), {
                                            sx: {
                                                color: "text.disabled",
                                                fontSize: "0.85rem",
                                                opacity: 0.8
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                fontWeight: 500,
                                                fontSize: "0.95rem"
                                            },
                                            children: "Last Stacked"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "flex-end",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            fontWeight: 500,
                                            fontSize: "0.95rem"
                                        },
                                        children: "Actions"
                                    })
                                })
                            ]
                        }),
                        sortedHangars.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fBVnr.EmptyState), {
                            title: "No Hangars Yet",
                            description: "Create your first hangar to start managing aircraft storage and stacking operations.",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtiLb.HangarIcon), {
                                sx: {
                                    fontSize: 64,
                                    opacity: 0.5
                                }
                            })
                        }) : sortedHangars.map((hangar)=>{
                            const polygons = (0, $5KGQl.getStackPolygons)(hangar.stack, hangar.width, 1);
                            const nTenantsFullyInHangar = (0, $kPMZ3.findTenantsFullyInHangar)(hangar, polygons).length;
                            const utilizationStacked = (0, $kPMZ3.calculateUtilization)(hangar, polygons, true, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false);
                            const totalUtilization = (0, $cLNZr.sum)(hangar.stack.tenants.map(({ aircraft: aircraft })=>aircraft.wingspan * aircraft.length));
                            const utilizationAll = Math.round(100 * totalUtilization / (0, $kPMZ3.calculateTotalArea)(hangar, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false));
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hKDIt.HangarRow), {
                                hangar: hangar,
                                aircraft: `${nTenantsFullyInHangar} / ${hangar.stack.tenants.length || 0}`,
                                aircraftInside: nTenantsFullyInHangar,
                                aircraftTotal: hangar.stack.tenants.length || 0,
                                utilization: `${utilizationStacked}% / ${utilizationAll}%`,
                                utilizationStacked: utilizationStacked,
                                utilizationAll: utilizationAll,
                                estimatedValue: displayEstimatedValue ? $216df0feb33e8435$export$356ca06baaa2d166(activeFBO, hangar, polygons, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false) : undefined,
                                estimatedTowTime: $216df0feb33e8435$export$462d3000c904c8f6(hangar, polygons),
                                lastStacked: hangar.last_stacked ? new Date(hangar.last_stacked) : null,
                                displayEditTenants: displayEditTenants,
                                enableScheduling: activeFBO?.settings?.enableScheduling ?? false,
                                isTablet: isTablet,
                                displayEstimatedValue: displayEstimatedValue
                            }, hangar.id);
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("ltk0t", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $fa1bd34af973acad$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa1bd34af973acad$var$_createSvgIcon = $fa1bd34af973acad$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $fa1bd34af973acad$var$_default = module.exports.default = (0, $fa1bd34af973acad$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }, "1")
], 'AccessTime');

});

parcelRegister("8Ks9I", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $01a4c817ca77afee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01a4c817ca77afee$var$_createSvgIcon = $01a4c817ca77afee$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $01a4c817ca77afee$var$_default = module.exports.default = (0, $01a4c817ca77afee$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5z"
}), 'AirplanemodeActive');

});

parcelRegister("gFNdt", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c236a6fdb6074505$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c236a6fdb6074505$var$_createSvgIcon = $c236a6fdb6074505$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c236a6fdb6074505$var$_default = module.exports.default = (0, $c236a6fdb6074505$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z"
}), 'Flight');

});

parcelRegister("2SjXn", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $21801ae352e01d15$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21801ae352e01d15$var$_createSvgIcon = $21801ae352e01d15$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $21801ae352e01d15$var$_default = module.exports.default = (0, $21801ae352e01d15$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), 'History');

});

parcelRegister("hllcA", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ca04d8192f0de6f2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca04d8192f0de6f2$var$_createSvgIcon = $ca04d8192f0de6f2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ca04d8192f0de6f2$var$_default = module.exports.default = (0, $ca04d8192f0de6f2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m20.38 8.57-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44zm-9.79 6.84a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83"
}), 'Speed');

});

parcelRegister("18tt9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0d3d65c0582fd03d$export$2e2bcd8739ae039);

var $14OWs = parcelRequire("14OWs");

var $4jPsi = parcelRequire("4jPsi");
const $0d3d65c0582fd03d$var$useMediaQuery = (0, $14OWs.unstable_createUseMediaQuery)({
    themeId: (0, $4jPsi.default)
});
var $0d3d65c0582fd03d$export$2e2bcd8739ae039 = $0d3d65c0582fd03d$var$useMediaQuery;

});
parcelRegister("14OWs", function(module, exports) {

$parcel$export(module.exports, "unstable_createUseMediaQuery", () => $0c8dae23e679323d$export$96d7927a982220b5);

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $5BtxM = parcelRequire("5BtxM");

var $29cO3 = parcelRequire("29cO3");
'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $0c8dae23e679323d$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $acw62.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $eEJPp.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $0c8dae23e679323d$var$safeReact = {
    ...$acw62
};
const $0c8dae23e679323d$var$maybeReactUseSyncExternalStore = $0c8dae23e679323d$var$safeReact.useSyncExternalStore;
function $0c8dae23e679323d$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $acw62.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $acw62.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $0c8dae23e679323d$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $0c8dae23e679323d$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $29cO3.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $5BtxM.default)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $0c8dae23e679323d$var$maybeReactUseSyncExternalStore !== undefined ? $0c8dae23e679323d$var$useMediaQueryNew : $0c8dae23e679323d$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $0c8dae23e679323d$var$useMediaQuery = $0c8dae23e679323d$export$96d7927a982220b5();
var $0c8dae23e679323d$export$2e2bcd8739ae039 = $0c8dae23e679323d$var$useMediaQuery;

});


parcelRegister("fBVnr", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $23eaea0ba786435d$export$fddf379e22a74b00);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $fu9Og = parcelRequire("fu9Og");
const $23eaea0ba786435d$export$fddf379e22a74b00 = ({ title: title, description: description, icon: icon, actionLabel: actionLabel, onAction: onAction, actionIcon: actionIcon, variant: variant = "default" })=>{
    const isCompact = variant === "compact";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: isCompact ? "auto" : "100%",
            minHeight: isCompact ? 200 : 400,
            p: isCompact ? 2 : 4,
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    color: "text.secondary",
                    mb: isCompact ? 1 : 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: icon || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                    name: "NoDataIcon",
                    sx: {
                        fontSize: isCompact ? 48 : 64,
                        opacity: 0.5
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: isCompact ? "h6" : "h5",
                gutterBottom: true,
                sx: {
                    fontWeight: 500,
                    color: "text.secondary"
                },
                children: title
            }),
            description && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    mb: isCompact ? 2 : 3,
                    maxWidth: 400
                },
                children: description
            }),
            actionLabel && onAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                variant: "contained",
                color: "primary",
                onClick: onAction,
                startIcon: actionIcon || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                    name: "AddIcon"
                }),
                size: isCompact ? "small" : "medium",
                children: actionLabel
            })
        ]
    });
};

});
parcelRegister("fu9Og", function(module, exports) {

$parcel$export(module.exports, "LazyIcon", () => $57c5e4a9b8fd186f$export$73059579cf355459);
$parcel$export(module.exports, "default", () => $57c5e4a9b8fd186f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $gQYsL = parcelRequire("gQYsL");
































































































































// Icon name mapping with lazy loading
const $57c5e4a9b8fd186f$var$iconMap = {
    // Core navigation and actions
    AccessTimeIcon: ()=>Promise.resolve((parcelRequire("ltk0t"))),
    AddIcon: ()=>Promise.resolve((parcelRequire("7tqxO"))),
    AddRoadIcon: ()=>Promise.resolve((parcelRequire("eBnBM"))),
    AirplanemodeActiveIcon: ()=>Promise.resolve((parcelRequire("8Ks9I"))),
    ArrowBackIcon: ()=>Promise.resolve((parcelRequire("1YLXO"))),
    ArrowDownwardIcon: ()=>(parcelRequire("fc0Ba")),
    ArrowDropDownIcon: ()=>Promise.resolve((parcelRequire("3JK9z"))),
    ArrowUpwardIcon: ()=>(parcelRequire("cyeiV")),
    BeachAccessIcon: ()=>Promise.resolve((parcelRequire("fP0Mq"))),
    BoltIcon: ()=>Promise.resolve((parcelRequire("2WBL0"))),
    CheckIcon: ()=>Promise.resolve((parcelRequire("fZSPM"))),
    ChevronRightIcon: ()=>Promise.resolve((parcelRequire("kT7QH"))),
    CleaningServicesIcon: ()=>(parcelRequire("6aHRi")),
    ClearIcon: ()=>Promise.resolve((parcelRequire("jO6ya"))),
    CloseIcon: ()=>Promise.resolve((parcelRequire("dqlTG"))),
    CloseFullscreenIcon: ()=>Promise.resolve((parcelRequire("146vq"))),
    CloudUploadIcon: ()=>Promise.resolve((parcelRequire("79E6C"))),
    CompassIcon: ()=>Promise.resolve((parcelRequire("9dUJu"))),
    UploadFileIcon: ()=>(parcelRequire("bUHej")),
    ConnectingAirportsIcon: ()=>Promise.resolve((parcelRequire("le4Y6"))),
    ContentCopyIcon: ()=>Promise.resolve((parcelRequire("jLQQD"))),
    CopyAllIcon: ()=>Promise.resolve((parcelRequire("fDKu1"))),
    DeleteIcon: ()=>Promise.resolve((parcelRequire("1MdOk"))),
    DoneIcon: ()=>Promise.resolve((parcelRequire("4VwvT"))),
    DownloadIcon: ()=>Promise.resolve((parcelRequire("7fruN"))),
    EditIcon: ()=>Promise.resolve((parcelRequire("c3r8Q"))),
    EditNoteIcon: ()=>Promise.resolve((parcelRequire("gPeoT"))),
    ExpandLessIcon: ()=>Promise.resolve((parcelRequire("e70ED"))),
    ExpandMoreIcon: ()=>Promise.resolve((parcelRequire("hbZ6O"))),
    FilledFlagIcon: ()=>Promise.resolve((parcelRequire("1BegY"))),
    FlightIcon: ()=>Promise.resolve((parcelRequire("gFNdt"))),
    FlightLandIcon: ()=>Promise.resolve((parcelRequire("iGBB4"))),
    FlightTakeoffIcon: ()=>Promise.resolve((parcelRequire("ap4xJ"))),
    GpsFixedIcon: ()=>Promise.resolve((parcelRequire("bOiZ6"))),
    GridViewIcon: ()=>Promise.resolve((parcelRequire("78dTG"))),
    GroupIcon: ()=>(parcelRequire("8Vpk2")),
    HelpIcon: ()=>Promise.resolve((parcelRequire("eGRb8"))),
    HelpCenterIcon: ()=>(parcelRequire("BEcNi")),
    HelpOutlineIcon: ()=>Promise.resolve((parcelRequire("focGp"))),
    ImageAspectRatioIcon: ()=>(parcelRequire("lclsp")),
    InfoIcon: ()=>Promise.resolve((parcelRequire("ex6lH"))),
    KeyboardDoubleArrowLeftIcon: ()=>Promise.resolve((parcelRequire("9uy2D"))),
    KeyboardDoubleArrowRightIcon: ()=>Promise.resolve((parcelRequire("6lMlz"))),
    LabelIcon: ()=>Promise.resolve((parcelRequire("lsdhg"))),
    LinearScaleIcon: ()=>Promise.resolve((parcelRequire("4WTQ1"))),
    LinkIcon: ()=>Promise.resolve((parcelRequire("8qjhV"))),
    LocalFireDepartmentIcon: ()=>Promise.resolve((parcelRequire("hBILp"))),
    LockIcon: ()=>Promise.resolve((parcelRequire("ewtCw"))),
    LockOpenIcon: ()=>Promise.resolve((parcelRequire("fpqo6"))),
    LogoutIcon: ()=>(parcelRequire("3bqFZ")),
    MailOutlineIcon: ()=>(parcelRequire("ivbmv")),
    MapIcon: ()=>(parcelRequire("cUo2w")),
    MoreHorizIcon: ()=>Promise.resolve((parcelRequire("hzsFs"))),
    MyLocationIcon: ()=>(parcelRequire("6Gn8q")),
    NextIcon: ()=>Promise.resolve((parcelRequire("huQT5"))),
    NearMeIcon: ()=>Promise.resolve((parcelRequire("1oB2K"))),
    OpenInFullIcon: ()=>Promise.resolve((parcelRequire("erdLd"))),
    OutlinedFlagIcon: ()=>Promise.resolve((parcelRequire("7mYdE"))),
    PictureInPictureIcon: ()=>Promise.resolve((parcelRequire("1QUqu"))),
    PlayIcon: ()=>Promise.resolve((parcelRequire("euRCv"))),
    PrintIcon: ()=>Promise.resolve((parcelRequire("utPXC"))),
    RadioButtonUncheckedIcon: ()=>Promise.resolve((parcelRequire("j8sxO"))),
    RefreshIcon: ()=>Promise.resolve((parcelRequire("2s2i8"))),
    RemoveIcon: ()=>Promise.resolve((parcelRequire("3zG2N"))),
    ReplayIcon: ()=>Promise.resolve((parcelRequire("5H68o"))),
    RocketLaunchIcon: ()=>Promise.resolve((parcelRequire("h23xD"))),
    SaveIcon: ()=>Promise.resolve((parcelRequire("9wvX1"))),
    ScatterPlotIcon: ()=>(parcelRequire("lLPJH")),
    SearchIcon: ()=>Promise.resolve((parcelRequire("2P5BT"))),
    SettingsIcon: ()=>Promise.resolve((parcelRequire("1KzZ6"))),
    SpeedIcon: ()=>Promise.resolve((parcelRequire("hllcA"))),
    SquareFootIcon: ()=>Promise.resolve((parcelRequire("8Sfdl"))),
    StopIcon: ()=>(parcelRequire("jZCs2")),
    StraightenIcon: ()=>Promise.resolve((parcelRequire("2jjgy"))),
    SwitchAccountIcon: ()=>Promise.resolve((parcelRequire("h0pvP"))),
    SwitchLeftIcon: ()=>(parcelRequire("jFdEB")),
    TextFieldsIcon: ()=>Promise.resolve((parcelRequire("9HeVX"))),
    TextureIcon: ()=>Promise.resolve((parcelRequire("hmGhT"))),
    ThumbUpIcon: ()=>Promise.resolve((parcelRequire("3th7A"))),
    TitleIcon: ()=>Promise.resolve((parcelRequire("3M2I5"))),
    TuneIcon: ()=>Promise.resolve((parcelRequire("2wozg"))),
    UnfoldLessIcon: ()=>(parcelRequire("6aDFm")),
    WarningIcon: ()=>Promise.resolve((parcelRequire("5y9fX"))),
    WidgetsIcon: ()=>Promise.resolve((parcelRequire("dJDFZ"))),
    CalculateIcon: ()=>(parcelRequire("f45Er")),
    MonetizationOnIcon: ()=>(parcelRequire("7nZOn")),
    SupportIcon: ()=>(parcelRequire("2HOJI")),
    SupportAgentIcon: ()=>(parcelRequire("8XLur")),
    // Additional consolidated icons
    CameraAltIcon: ()=>(parcelRequire("kWUXD")),
    ChevronLeftIcon: ()=>Promise.resolve((parcelRequire("kJUDd"))),
    ExpandCircleDownIcon: ()=>(parcelRequire("gvCPE")),
    FilterListIcon: ()=>(parcelRequire("2Ui9E")),
    GetAppIcon: ()=>(parcelRequire("1Y1Mg")),
    LaunchIcon: ()=>(parcelRequire("kP8nb")),
    MinimizeIcon: ()=>(parcelRequire("3WSxt")),
    NotificationImportantIcon: ()=>(parcelRequire("dA7T0")),
    PauseCircleIcon: ()=>(parcelRequire("c12PB")),
    PhoneIcon: ()=>(parcelRequire("8iZen")),
    PhotoCameraIcon: ()=>(parcelRequire("2rCqm")),
    PlaceIcon: ()=>Promise.resolve((parcelRequire("iQIBI"))),
    PublicIcon: ()=>(parcelRequire("7ZDOL")),
    QuestionMarkIcon: ()=>(parcelRequire("eLvuZ")),
    ScheduleIcon: ()=>Promise.resolve((parcelRequire("dTjVb"))),
    SmartToyIcon: ()=>(parcelRequire("7HZko")),
    SyncAltIcon: ()=>(parcelRequire("aIuYX")),
    TimelineIcon: ()=>(parcelRequire("6hD2z")),
    TransformIcon: ()=>(parcelRequire("3SGuh")),
    VisibilityIcon: ()=>Promise.resolve((parcelRequire("47hDK"))),
    VisibilityOffIcon: ()=>Promise.resolve((parcelRequire("fNKiI"))),
    ZoomInIcon: ()=>(parcelRequire("gC30r")),
    ZoomOutIcon: ()=>(parcelRequire("67scz")),
    MoreVertIcon: ()=>Promise.resolve((parcelRequire("4D8ul"))),
    StarIcon: ()=>(parcelRequire("3w9yg")),
    StarBorderIcon: ()=>(parcelRequire("3tQEG")),
    ViewModuleIcon: ()=>(parcelRequire("8bRjh")),
    ViewComfyIcon: ()=>(parcelRequire("57pvR")),
    AnalyticsIcon: ()=>(parcelRequire("cy9PS")),
    InsightsIcon: ()=>(parcelRequire("kI2UI")),
    PersonIcon: ()=>Promise.resolve((parcelRequire("33PpE"))),
    // Additional missing icons
    BlockIcon: ()=>Promise.resolve((parcelRequire("2KvQo"))),
    BugIcon: ()=>(parcelRequire("dErt0")),
    BuildIcon: ()=>(parcelRequire("l32Ih")),
    CalendarMonthIcon: ()=>(parcelRequire("6XkYM")),
    NavigateNextIcon: ()=>Promise.resolve((parcelRequire("huQT5"))),
    ShareIcon: ()=>(parcelRequire("cf62F")),
    TableViewIcon: ()=>(parcelRequire("i8XSp")),
    NoDataIcon: ()=>(parcelRequire("31Jy0")),
    Today: ()=>(parcelRequire("86gi2"))
};
// Lazy icon component cache for performance
const $57c5e4a9b8fd186f$var$lazyIconCache = new Map();
// Simple circle fallback icon (inline SVG to avoid imports)
const $57c5e4a9b8fd186f$var$DefaultFallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ref: ref,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "8",
            opacity: "0.3"
        })
    }));
$57c5e4a9b8fd186f$var$DefaultFallback.displayName = 'DefaultFallback';
const $57c5e4a9b8fd186f$export$73059579cf355459 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ name: name, fallback: Fallback = $57c5e4a9b8fd186f$var$DefaultFallback, ...props }, ref)=>{
    // First, check if it's a core bundled icon
    if ((0, $gQYsL.isCoreIcon)(name)) {
        const CoreIcon = (0, $gQYsL.getCoreIcon)(name);
        if (CoreIcon) return /*#__PURE__*/ (0, $ayMG0.jsx)(CoreIcon, {
            ref: ref,
            ...props
        });
    }
    // Fall back to lazy loading for non-core icons
    if (!$57c5e4a9b8fd186f$var$lazyIconCache.has(name)) {
        const iconLoader = $57c5e4a9b8fd186f$var$iconMap[name];
        if (iconLoader) $57c5e4a9b8fd186f$var$lazyIconCache.set(name, /*#__PURE__*/ (0, $acw62.lazy)(iconLoader));
    }
    const LazyIconComponent = $57c5e4a9b8fd186f$var$lazyIconCache.get(name);
    if (!LazyIconComponent) {
        // Fallback for unknown icons
        console.warn(`Icon "${name}" not found in icon map`);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(Fallback, {
            ref: ref,
            ...props
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
        fallback: /*#__PURE__*/ (0, $ayMG0.jsx)(Fallback, {
            ref: ref,
            ...props
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(LazyIconComponent, {
            ref: ref,
            ...props
        })
    });
});
$57c5e4a9b8fd186f$export$73059579cf355459.displayName = 'LazyIcon';
var $57c5e4a9b8fd186f$export$2e2bcd8739ae039 = $57c5e4a9b8fd186f$export$73059579cf355459;

});
parcelRegister("gQYsL", function(module, exports) {

$parcel$export(module.exports, "isCoreIcon", () => $5671e17790e27ea4$export$cf6891d2800bfb62);
$parcel$export(module.exports, "getCoreIcon", () => $5671e17790e27ea4$export$201abc51380246cc);
// Core icon bundle - frequently used icons bundled together
// This reduces network requests from 100+ individual icon chunks to 1 bundle
parcelRequire("acw62");

var $7tqxO = parcelRequire("7tqxO");

var $1YLXO = parcelRequire("1YLXO");

var $3JK9z = parcelRequire("3JK9z");

var $fZSPM = parcelRequire("fZSPM");

var $kJUDd = parcelRequire("kJUDd");

var $kT7QH = parcelRequire("kT7QH");

var $jO6ya = parcelRequire("jO6ya");

var $dqlTG = parcelRequire("dqlTG");

var $1MdOk = parcelRequire("1MdOk");

var $4VwvT = parcelRequire("4VwvT");

var $7fruN = parcelRequire("7fruN");

var $c3r8Q = parcelRequire("c3r8Q");

var $e70ED = parcelRequire("e70ED");

var $hbZ6O = parcelRequire("hbZ6O");

var $gFNdt = parcelRequire("gFNdt");

var $eGRb8 = parcelRequire("eGRb8");

var $ex6lH = parcelRequire("ex6lH");

var $hzsFs = parcelRequire("hzsFs");

var $4D8ul = parcelRequire("4D8ul");

var $huQT5 = parcelRequire("huQT5");

var $2s2i8 = parcelRequire("2s2i8");

var $9wvX1 = parcelRequire("9wvX1");

var $2P5BT = parcelRequire("2P5BT");

var $1KzZ6 = parcelRequire("1KzZ6");

var $47hDK = parcelRequire("47hDK");

var $fNKiI = parcelRequire("fNKiI");

var $5y9fX = parcelRequire("5y9fX");
const $5671e17790e27ea4$export$3081620a02103cb5 = {
    AddIcon: (/*@__PURE__*/$parcel$interopDefault($7tqxO)),
    ArrowBackIcon: (/*@__PURE__*/$parcel$interopDefault($1YLXO)),
    ArrowDropDownIcon: (/*@__PURE__*/$parcel$interopDefault($3JK9z)),
    CheckIcon: (/*@__PURE__*/$parcel$interopDefault($fZSPM)),
    ChevronLeftIcon: (/*@__PURE__*/$parcel$interopDefault($kJUDd)),
    ChevronRightIcon: (/*@__PURE__*/$parcel$interopDefault($kT7QH)),
    ClearIcon: (/*@__PURE__*/$parcel$interopDefault($jO6ya)),
    CloseIcon: (/*@__PURE__*/$parcel$interopDefault($dqlTG)),
    DeleteIcon: (/*@__PURE__*/$parcel$interopDefault($1MdOk)),
    DoneIcon: (/*@__PURE__*/$parcel$interopDefault($4VwvT)),
    DownloadIcon: (/*@__PURE__*/$parcel$interopDefault($7fruN)),
    EditIcon: (/*@__PURE__*/$parcel$interopDefault($c3r8Q)),
    ExpandLessIcon: (/*@__PURE__*/$parcel$interopDefault($e70ED)),
    ExpandMoreIcon: (/*@__PURE__*/$parcel$interopDefault($hbZ6O)),
    FlightIcon: (/*@__PURE__*/$parcel$interopDefault($gFNdt)),
    HelpIcon: (/*@__PURE__*/$parcel$interopDefault($eGRb8)),
    InfoIcon: (/*@__PURE__*/$parcel$interopDefault($ex6lH)),
    MoreHorizIcon: (/*@__PURE__*/$parcel$interopDefault($hzsFs)),
    MoreVertIcon: (/*@__PURE__*/$parcel$interopDefault($4D8ul)),
    NextIcon: (0, (/*@__PURE__*/$parcel$interopDefault($huQT5))),
    RefreshIcon: (/*@__PURE__*/$parcel$interopDefault($2s2i8)),
    SaveIcon: (/*@__PURE__*/$parcel$interopDefault($9wvX1)),
    SearchIcon: (/*@__PURE__*/$parcel$interopDefault($2P5BT)),
    SettingsIcon: (/*@__PURE__*/$parcel$interopDefault($1KzZ6)),
    VisibilityIcon: (/*@__PURE__*/$parcel$interopDefault($47hDK)),
    VisibilityOffIcon: (/*@__PURE__*/$parcel$interopDefault($fNKiI)),
    WarningIcon: (/*@__PURE__*/$parcel$interopDefault($5y9fX))
};
const $5671e17790e27ea4$export$cf6891d2800bfb62 = (iconName)=>{
    return iconName in $5671e17790e27ea4$export$3081620a02103cb5;
};
const $5671e17790e27ea4$export$201abc51380246cc = (iconName)=>{
    return $5671e17790e27ea4$export$3081620a02103cb5[iconName] || null;
};

});
parcelRegister("1YLXO", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1710999fd8a821f2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1710999fd8a821f2$var$_createSvgIcon = $1710999fd8a821f2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1710999fd8a821f2$var$_default = module.exports.default = (0, $1710999fd8a821f2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');

});

parcelRegister("3JK9z", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2b89602345ebb0fd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b89602345ebb0fd$var$_createSvgIcon = $2b89602345ebb0fd$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2b89602345ebb0fd$var$_default = module.exports.default = (0, $2b89602345ebb0fd$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("fZSPM", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ba571672f7b8a33c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba571672f7b8a33c$var$_createSvgIcon = $ba571672f7b8a33c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ba571672f7b8a33c$var$_default = module.exports.default = (0, $ba571672f7b8a33c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

});

parcelRegister("kJUDd", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $f193f0793ab029b2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f193f0793ab029b2$var$_createSvgIcon = $f193f0793ab029b2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $f193f0793ab029b2$var$_default = module.exports.default = (0, $f193f0793ab029b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');

});

parcelRegister("kT7QH", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $f34f085839eedc26$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f34f085839eedc26$var$_createSvgIcon = $f34f085839eedc26$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $f34f085839eedc26$var$_default = module.exports.default = (0, $f34f085839eedc26$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

});

parcelRegister("jO6ya", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e6b7c48de87835c4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6b7c48de87835c4$var$_createSvgIcon = $e6b7c48de87835c4$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e6b7c48de87835c4$var$_default = module.exports.default = (0, $e6b7c48de87835c4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

});

parcelRegister("dqlTG", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $9c5eb05f9740712a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $9c5eb05f9740712a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = module.exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("1MdOk", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $14b4fcb0e549e7b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14b4fcb0e549e7b0$var$_createSvgIcon = $14b4fcb0e549e7b0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $14b4fcb0e549e7b0$var$_default = module.exports.default = (0, $14b4fcb0e549e7b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');

});

parcelRegister("4VwvT", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $3965b4c1913a7284$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3965b4c1913a7284$var$_createSvgIcon = $3965b4c1913a7284$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $3965b4c1913a7284$var$_default = module.exports.default = (0, $3965b4c1913a7284$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), 'Done');

});

parcelRegister("7fruN", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $546f4335ad644031$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $546f4335ad644031$var$_createSvgIcon = $546f4335ad644031$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $546f4335ad644031$var$_default = module.exports.default = (0, $546f4335ad644031$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');

});

parcelRegister("c3r8Q", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8c6ad197f63b3f3e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $8c6ad197f63b3f3e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = module.exports.default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');

});

parcelRegister("e70ED", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a4623a154accf113$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4623a154accf113$var$_createSvgIcon = $a4623a154accf113$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a4623a154accf113$var$_default = module.exports.default = (0, $a4623a154accf113$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

});

parcelRegister("hbZ6O", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c842ddb70f8ccad0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842ddb70f8ccad0$var$_createSvgIcon = $c842ddb70f8ccad0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c842ddb70f8ccad0$var$_default = module.exports.default = (0, $c842ddb70f8ccad0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

});

parcelRegister("eGRb8", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ab1e3d19a10d5b36$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab1e3d19a10d5b36$var$_createSvgIcon = $ab1e3d19a10d5b36$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ab1e3d19a10d5b36$var$_default = module.exports.default = (0, $ab1e3d19a10d5b36$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 17h-2v-2h2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"
}), 'Help');

});

parcelRegister("hzsFs", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ccabf15be2d9d072$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccabf15be2d9d072$var$_createSvgIcon = $ccabf15be2d9d072$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ccabf15be2d9d072$var$_default = module.exports.default = (0, $ccabf15be2d9d072$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreHoriz');

});

parcelRegister("4D8ul", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $35f16394a96a7f2a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35f16394a96a7f2a$var$_createSvgIcon = $35f16394a96a7f2a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $35f16394a96a7f2a$var$_default = module.exports.default = (0, $35f16394a96a7f2a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVert');

});

parcelRegister("huQT5", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $cbce43614cfca6bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbce43614cfca6bb$var$_createSvgIcon = $cbce43614cfca6bb$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $cbce43614cfca6bb$var$_default = module.exports.default = (0, $cbce43614cfca6bb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

});

parcelRegister("2s2i8", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1c8ff95a3ff850ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c8ff95a3ff850ab$var$_createSvgIcon = $1c8ff95a3ff850ab$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1c8ff95a3ff850ab$var$_default = module.exports.default = (0, $1c8ff95a3ff850ab$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), 'Refresh');

});

parcelRegister("9wvX1", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $6eefe30025c8ad9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6eefe30025c8ad9a$var$_createSvgIcon = $6eefe30025c8ad9a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6eefe30025c8ad9a$var$_default = module.exports.default = (0, $6eefe30025c8ad9a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), 'Save');

});

parcelRegister("1KzZ6", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1466001c800d0f24$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1466001c800d0f24$var$_createSvgIcon = $1466001c800d0f24$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1466001c800d0f24$var$_default = module.exports.default = (0, $1466001c800d0f24$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), 'Settings');

});

parcelRegister("47hDK", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2ff57fd6d94f368c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ff57fd6d94f368c$var$_createSvgIcon = $2ff57fd6d94f368c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2ff57fd6d94f368c$var$_default = module.exports.default = (0, $2ff57fd6d94f368c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');

});

parcelRegister("fNKiI", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $b80f590192083ee3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80f590192083ee3$var$_createSvgIcon = $b80f590192083ee3$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b80f590192083ee3$var$_default = module.exports.default = (0, $b80f590192083ee3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');

});

parcelRegister("5y9fX", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $40a74ed5b01f3d24$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40a74ed5b01f3d24$var$_createSvgIcon = $40a74ed5b01f3d24$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $40a74ed5b01f3d24$var$_default = module.exports.default = (0, $40a74ed5b01f3d24$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'Warning');

});


parcelRegister("eBnBM", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $aa16d58271b21a1c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa16d58271b21a1c$var$_createSvgIcon = $aa16d58271b21a1c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $aa16d58271b21a1c$var$_default = module.exports.default = (0, $aa16d58271b21a1c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2zM18 4h2v9h-2zM4 4h2v16H4zm7 0h2v4h-2zm0 6h2v4h-2zm0 6h2v4h-2z"
}), 'AddRoad');

});

parcelRegister("fc0Ba", function(module, exports) {
module.exports = import("ctROh").then(()=>parcelRequire('2mYIR'));

});

parcelRegister("cyeiV", function(module, exports) {
module.exports = import("9AiJE").then(()=>parcelRequire('f1nIu'));

});

parcelRegister("fP0Mq", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $b84c395616767272$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b84c395616767272$var$_createSvgIcon = $b84c395616767272$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b84c395616767272$var$_default = module.exports.default = (0, $b84c395616767272$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m13.127 14.56 1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73 2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88M5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98m.02-.02-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3"
}), 'BeachAccess');

});

parcelRegister("2WBL0", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $224e49595dca9c4d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $224e49595dca9c4d$var$_createSvgIcon = $224e49595dca9c4d$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $224e49595dca9c4d$var$_default = module.exports.default = (0, $224e49595dca9c4d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66s.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21"
}), 'Bolt');

});

parcelRegister("6aHRi", function(module, exports) {
module.exports = import("fmodw").then(()=>parcelRequire('2AZTR'));

});

parcelRegister("146vq", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $0c6b3612ef19c4c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c6b3612ef19c4c5$var$_createSvgIcon = $0c6b3612ef19c4c5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $0c6b3612ef19c4c5$var$_default = module.exports.default = (0, $0c6b3612ef19c4c5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22 3.41 16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59z"
}), 'CloseFullscreen');

});

parcelRegister("79E6C", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $53587bd410475806$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53587bd410475806$var$_createSvgIcon = $53587bd410475806$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $53587bd410475806$var$_default = module.exports.default = (0, $53587bd410475806$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), 'CloudUpload');

});

parcelRegister("9dUJu", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $6b7155e2751be36d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b7155e2751be36d$var$_createSvgIcon = $6b7155e2751be36d$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6b7155e2751be36d$var$_default = module.exports.default = (0, $6b7155e2751be36d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2 4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
}), 'Navigation');

});

parcelRegister("bUHej", function(module, exports) {
module.exports = import("50SHb").then(()=>parcelRequire('79wBf'));

});

parcelRegister("le4Y6", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $f73ec26364306fa2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f73ec26364306fa2$var$_createSvgIcon = $f73ec26364306fa2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $f73ec26364306fa2$var$_default = module.exports.default = (0, $f73ec26364306fa2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m15.4 17 1.3 4.4h-1.1L13 17h-3c-.55 0-1-.45-1-1s.45-1 1-1h3l2.6-4.4h1.1L15.4 15h2.85l.75-1h1l-.6 2 .6 2h-1l-.75-1zM5.75 7 5 6H4l.6 2-.6 2h1l.75-1H8.6l-1.3 4.4h1.1L11 9h3c.55 0 1-.45 1-1s-.45-1-1-1h-3L8.4 2.6H7.3L8.6 7z"
}), 'ConnectingAirports');

});

parcelRegister("jLQQD", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e64b66a0287a27e1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e64b66a0287a27e1$var$_createSvgIcon = $e64b66a0287a27e1$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e64b66a0287a27e1$var$_default = module.exports.default = (0, $e64b66a0287a27e1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');

});

parcelRegister("fDKu1", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $b62e8e213130dab6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b62e8e213130dab6$var$_createSvgIcon = $b62e8e213130dab6$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b62e8e213130dab6$var$_default = module.exports.default = (0, $b62e8e213130dab6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H9V4h9zM3 15v-2h2v2zm0-5.5h2v2H3zM10 20h2v2h-2zm-7-1.5v-2h2v2zM5 22c-1.1 0-2-.9-2-2h2zm3.5 0h-2v-2h2zm5 0v-2h2c0 1.1-.9 2-2 2M5 6v2H3c0-1.1.9-2 2-2"
}), 'CopyAll');

});

parcelRegister("gPeoT", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c3fc946beafe6876$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc946beafe6876$var$_createSvgIcon = $c3fc946beafe6876$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c3fc946beafe6876$var$_default = module.exports.default = (0, $c3fc946beafe6876$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 10h11v2H3zm0-2h11V6H3zm0 8h7v-2H3zm15.01-3.13.71-.71c.39-.39 1.02-.39 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71zm-.71.71-5.3 5.3V21h2.12l5.3-5.3z"
}), 'EditNote');

});

parcelRegister("1BegY", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $12a4516962015a76$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a4516962015a76$var$_createSvgIcon = $12a4516962015a76$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $12a4516962015a76$var$_default = module.exports.default = (0, $12a4516962015a76$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6z"
}), 'Flag');

});

parcelRegister("iGBB4", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d9a95033183cb989$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9a95033183cb989$var$_createSvgIcon = $d9a95033183cb989$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d9a95033183cb989$var$_default = module.exports.default = (0, $d9a95033183cb989$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M2.5 19h19v2h-19zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17z"
}), 'FlightLand');

});

parcelRegister("ap4xJ", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $792fc352a65a5dae$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $792fc352a65a5dae$var$_createSvgIcon = $792fc352a65a5dae$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $792fc352a65a5dae$var$_default = module.exports.default = (0, $792fc352a65a5dae$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49s7.12-1.9 16.57-4.43c.81-.23 1.28-1.05 1.07-1.85"
}), 'FlightTakeoff');

});

parcelRegister("bOiZ6", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8993172cb7bc25ee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8993172cb7bc25ee$var$_createSvgIcon = $8993172cb7bc25ee$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8993172cb7bc25ee$var$_default = module.exports.default = (0, $8993172cb7bc25ee$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"
}), 'GpsFixed');

});

parcelRegister("78dTG", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $53140f70f5116e76$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53140f70f5116e76$var$_createSvgIcon = $53140f70f5116e76$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $53140f70f5116e76$var$_default = module.exports.default = (0, $53140f70f5116e76$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    fillRule: "evenodd",
    d: "M3 3v8h8V3zm6 6H5V5h4zm-6 4v8h8v-8zm6 6H5v-4h4zm4-16v8h8V3zm6 6h-4V5h4zm-6 4v8h8v-8zm6 6h-4v-4h4z"
}), 'GridView');

});

parcelRegister("8Vpk2", function(module, exports) {
module.exports = import("jlHXA").then(()=>parcelRequire('8fkqf'));

});

parcelRegister("BEcNi", function(module, exports) {
module.exports = import("arKV7").then(()=>parcelRequire('huApQ'));

});

parcelRegister("lclsp", function(module, exports) {
module.exports = import("6tpPT").then(()=>parcelRequire('6ftUl'));

});

parcelRegister("9uy2D", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $6e915254c6f2ff62$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e915254c6f2ff62$var$_createSvgIcon = $6e915254c6f2ff62$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6e915254c6f2ff62$var$_default = module.exports.default = (0, $6e915254c6f2ff62$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M17.59 18 19 16.59 14.42 12 19 7.41 17.59 6l-6 6z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m11 18 1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z"
    }, "1")
], 'KeyboardDoubleArrowLeft');

});

parcelRegister("6lMlz", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $49fa34f3c6d508a0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49fa34f3c6d508a0$var$_createSvgIcon = $49fa34f3c6d508a0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $49fa34f3c6d508a0$var$_default = module.exports.default = (0, $49fa34f3c6d508a0$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
    }, "1")
], 'KeyboardDoubleArrowRight');

});

parcelRegister("lsdhg", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $f9e6831fd5da342e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9e6831fd5da342e$var$_createSvgIcon = $f9e6831fd5da342e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $f9e6831fd5da342e$var$_default = module.exports.default = (0, $f9e6831fd5da342e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12z"
}), 'Label');

});

parcelRegister("4WTQ1", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $39a7e475e491879e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $39a7e475e491879e$var$_createSvgIcon = $39a7e475e491879e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $39a7e475e491879e$var$_default = module.exports.default = (0, $39a7e475e491879e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5"
}), 'LinearScale');

});

parcelRegister("8qjhV", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $621fb6a237b62b7c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $621fb6a237b62b7c$var$_createSvgIcon = $621fb6a237b62b7c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $621fb6a237b62b7c$var$_default = module.exports.default = (0, $621fb6a237b62b7c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M8 13h8v-2H8zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5"
}), 'Link');

});

parcelRegister("hBILp", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $cd189d86ab9ed525$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd189d86ab9ed525$var$_createSvgIcon = $cd189d86ab9ed525$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $cd189d86ab9ed525$var$_default = module.exports.default = (0, $cd189d86ab9ed525$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52"
    }, "1")
], 'LocalFireDepartment');

});

parcelRegister("ewtCw", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a92b07d661f9bafe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a92b07d661f9bafe$var$_createSvgIcon = $a92b07d661f9bafe$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a92b07d661f9bafe$var$_default = module.exports.default = (0, $a92b07d661f9bafe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1z"
}), 'Lock');

});

parcelRegister("fpqo6", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $b37da8e3346a63de$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b37da8e3346a63de$var$_createSvgIcon = $b37da8e3346a63de$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b37da8e3346a63de$var$_default = module.exports.default = (0, $b37da8e3346a63de$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m0 12H6V10h12z"
}), 'LockOpen');

});

parcelRegister("3bqFZ", function(module, exports) {
module.exports = import("Rt9Vu").then(()=>parcelRequire('3ytJg'));

});

parcelRegister("ivbmv", function(module, exports) {
module.exports = import("k1JeB").then(()=>parcelRequire('gMNf8'));

});

parcelRegister("cUo2w", function(module, exports) {
module.exports = import("in58A").then(()=>parcelRequire('fnZuW'));

});

parcelRegister("6Gn8q", function(module, exports) {
module.exports = import("g0Ro8").then(()=>parcelRequire('76ABf'));

});

parcelRegister("1oB2K", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1044c45c787d7613$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1044c45c787d7613$var$_createSvgIcon = $1044c45c787d7613$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1044c45c787d7613$var$_default = module.exports.default = (0, $1044c45c787d7613$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98z"
}), 'NearMe');

});

parcelRegister("erdLd", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a82e42e1e9ae6d57$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a82e42e1e9ae6d57$var$_createSvgIcon = $a82e42e1e9ae6d57$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a82e42e1e9ae6d57$var$_default = module.exports.default = (0, $a82e42e1e9ae6d57$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"
}), 'OpenInFull');

});

parcelRegister("7mYdE", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $55d94cbc4c196af8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55d94cbc4c196af8$var$_createSvgIcon = $55d94cbc4c196af8$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $55d94cbc4c196af8$var$_default = module.exports.default = (0, $55d94cbc4c196af8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m14 6-1-2H5v17h2v-7h5l1 2h7V6zm4 8h-4l-1-2H7V6h5l1 2h5z"
}), 'OutlinedFlag');

});

parcelRegister("1QUqu", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $15966adf050d49b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15966adf050d49b1$var$_createSvgIcon = $15966adf050d49b1$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $15966adf050d49b1$var$_default = module.exports.default = (0, $15966adf050d49b1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 7h-8v6h8zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2m0 16.01H3V4.98h18z"
}), 'PictureInPicture');

});

parcelRegister("euRCv", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a8dd75dbad9f9526$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8dd75dbad9f9526$var$_createSvgIcon = $a8dd75dbad9f9526$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a8dd75dbad9f9526$var$_default = module.exports.default = (0, $a8dd75dbad9f9526$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8 5v14l11-7z"
}), 'PlayArrow');

});

parcelRegister("utPXC", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $05b9f27a4600b643$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05b9f27a4600b643$var$_createSvgIcon = $05b9f27a4600b643$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $05b9f27a4600b643$var$_default = module.exports.default = (0, $05b9f27a4600b643$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3m-3 11H8v-5h8zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m-1-9H6v4h12z"
}), 'Print');

});

parcelRegister("j8sxO", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $dee4e7f7fcd4d75f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dee4e7f7fcd4d75f$var$_createSvgIcon = $dee4e7f7fcd4d75f$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $dee4e7f7fcd4d75f$var$_default = module.exports.default = (0, $dee4e7f7fcd4d75f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonUnchecked');

});

parcelRegister("3zG2N", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $29a5410bebd3849f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29a5410bebd3849f$var$_createSvgIcon = $29a5410bebd3849f$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $29a5410bebd3849f$var$_default = module.exports.default = (0, $29a5410bebd3849f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13H5v-2h14z"
}), 'Remove');

});

parcelRegister("5H68o", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $4255ba0ed329d5b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4255ba0ed329d5b4$var$_createSvgIcon = $4255ba0ed329d5b4$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4255ba0ed329d5b4$var$_default = module.exports.default = (0, $4255ba0ed329d5b4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8"
}), 'Replay');

});

parcelRegister("h23xD", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c6655ed60195f28f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6655ed60195f28f$var$_createSvgIcon = $c6655ed60195f28f$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c6655ed60195f28f$var$_default = module.exports.default = (0, $c6655ed60195f28f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9.19 6.35c-2.04 2.29-3.44 5.58-3.57 5.89L2 10.69l4.05-4.05c.47-.47 1.15-.68 1.81-.55zM11.17 17s3.74-1.55 5.89-3.7c5.4-5.4 4.5-9.62 4.21-10.57-.95-.3-5.17-1.19-10.57 4.21C8.55 9.09 7 12.83 7 12.83zm6.48-2.19c-2.29 2.04-5.58 3.44-5.89 3.57L13.31 22l4.05-4.05c.47-.47.68-1.15.55-1.81zM9 18c0 .83-.34 1.58-.88 2.12C6.94 21.3 2 22 2 22s.7-4.94 1.88-6.12C4.42 15.34 5.17 15 6 15c1.66 0 3 1.34 3 3m4-9c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2"
}), 'RocketLaunch');

});

parcelRegister("lLPJH", function(module, exports) {
module.exports = import("dULmZ").then(()=>parcelRequire('cKGzs'));

});

parcelRegister("8Sfdl", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $675f2b16dc8ab273$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $675f2b16dc8ab273$var$_createSvgIcon = $675f2b16dc8ab273$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $675f2b16dc8ab273$var$_default = module.exports.default = (0, $675f2b16dc8ab273$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m17.66 17.66-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14zM7 17v-5.76L12.76 17z"
}), 'SquareFoot');

});

parcelRegister("jZCs2", function(module, exports) {
module.exports = import("Fqupz").then(()=>parcelRequire('6qmzO'));

});

parcelRegister("2jjgy", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1aec4cecf10cc6ad$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1aec4cecf10cc6ad$var$_createSvgIcon = $1aec4cecf10cc6ad$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1aec4cecf10cc6ad$var$_default = module.exports.default = (0, $1aec4cecf10cc6ad$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2z"
}), 'Straighten');

});

parcelRegister("h0pvP", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c61639ffdbe05b80$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c61639ffdbe05b80$var$_createSvgIcon = $c61639ffdbe05b80$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c61639ffdbe05b80$var$_default = module.exports.default = (0, $c61639ffdbe05b80$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-6 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m6 12H8v-1.5c0-1.99 4-3 6-3s6 1.01 6 3z"
}), 'SwitchAccount');

});

parcelRegister("jFdEB", function(module, exports) {
module.exports = import("gj32S").then(()=>parcelRequire('gHUmr'));

});

parcelRegister("9HeVX", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $70f3b6c121fb5d84$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70f3b6c121fb5d84$var$_createSvgIcon = $70f3b6c121fb5d84$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $70f3b6c121fb5d84$var$_default = module.exports.default = (0, $70f3b6c121fb5d84$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M2.5 4v3h5v12h3V7h5V4zm19 5h-9v3h3v7h3v-7h3z"
}), 'TextFields');

});

parcelRegister("hmGhT", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ca454b2c4fe8416b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca454b2c4fe8416b$var$_createSvgIcon = $ca454b2c4fe8416b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ca454b2c4fe8416b$var$_default = module.exports.default = (0, $ca454b2c4fe8416b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.51 3.08 3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41M11.88 3 3 11.88v2.83L14.71 3zM5 3c-1.1 0-2 .9-2 2v2l4-4zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4zm-9.71 0h2.83L21 12.12V9.29z"
}), 'Texture');

});

parcelRegister("3th7A", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $28715c7f04856a37$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28715c7f04856a37$var$_createSvgIcon = $28715c7f04856a37$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $28715c7f04856a37$var$_default = module.exports.default = (0, $28715c7f04856a37$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h4V9H1zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73z"
}), 'ThumbUp');

});

parcelRegister("3M2I5", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2bf7f4faa145861b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bf7f4faa145861b$var$_createSvgIcon = $2bf7f4faa145861b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2bf7f4faa145861b$var$_default = module.exports.default = (0, $2bf7f4faa145861b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 4v3h5.5v12h3V7H19V4z"
}), 'Title');

});

parcelRegister("2wozg", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1d61a0932a865cbe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d61a0932a865cbe$var$_createSvgIcon = $1d61a0932a865cbe$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1d61a0932a865cbe$var$_default = module.exports.default = (0, $1d61a0932a865cbe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17v2h6v-2zM3 5v2h10V5zm10 16v-2h8v-2h-8v-2h-2v6zM7 9v2H3v2h4v2h2V9zm14 4v-2H11v2zm-6-4h2V7h4V5h-4V3h-2z"
}), 'Tune');

});

parcelRegister("6aDFm", function(module, exports) {
module.exports = import("33RXc").then(()=>parcelRequire('dgTwi'));

});

parcelRegister("dJDFZ", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $9ffe41356ec70584$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ffe41356ec70584$var$_createSvgIcon = $9ffe41356ec70584$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9ffe41356ec70584$var$_default = module.exports.default = (0, $9ffe41356ec70584$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 13v8h8v-8zM3 21h8v-8H3zM3 3v8h8V3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66z"
}), 'Widgets');

});

parcelRegister("f45Er", function(module, exports) {
module.exports = import("jBC9y").then(()=>parcelRequire('6uflp'));

});

parcelRegister("7nZOn", function(module, exports) {
module.exports = import("gMyfz").then(()=>parcelRequire('6BcsJ'));

});

parcelRegister("2HOJI", function(module, exports) {
module.exports = import("6rrN7").then(()=>parcelRequire('lY3UN'));

});

parcelRegister("8XLur", function(module, exports) {
module.exports = import("4vVZ7").then(()=>parcelRequire('eAdLt'));

});

parcelRegister("kWUXD", function(module, exports) {
module.exports = import("7dsHi").then(()=>parcelRequire('kt8TY'));

});

parcelRegister("gvCPE", function(module, exports) {
module.exports = import("71Ndu").then(()=>parcelRequire('8Pezc'));

});

parcelRegister("2Ui9E", function(module, exports) {
module.exports = import("6tHWk").then(()=>parcelRequire('gYrbG'));

});

parcelRegister("1Y1Mg", function(module, exports) {
module.exports = import("bcKOb").then(()=>parcelRequire('dTtI4'));

});

parcelRegister("kP8nb", function(module, exports) {
module.exports = import("ljz8y").then(()=>parcelRequire('5eHWq'));

});

parcelRegister("3WSxt", function(module, exports) {
module.exports = import("9JE1S").then(()=>parcelRequire('iP93F'));

});

parcelRegister("dA7T0", function(module, exports) {
module.exports = import("iCscs").then(()=>parcelRequire('65sjF'));

});

parcelRegister("c12PB", function(module, exports) {
module.exports = import("4tb6D").then(()=>parcelRequire('bQAQI'));

});

parcelRegister("8iZen", function(module, exports) {
module.exports = import("6NYlM").then(()=>parcelRequire('jqzlS'));

});

parcelRegister("2rCqm", function(module, exports) {
module.exports = import("ki3Kp").then(()=>parcelRequire('eEaCl'));

});

parcelRegister("iQIBI", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $db8faf6665f46ff1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db8faf6665f46ff1$var$_createSvgIcon = $db8faf6665f46ff1$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $db8faf6665f46ff1$var$_default = module.exports.default = (0, $db8faf6665f46ff1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), 'Place');

});

parcelRegister("7ZDOL", function(module, exports) {
module.exports = import("lQcGU").then(()=>parcelRequire('6qjW5'));

});

parcelRegister("eLvuZ", function(module, exports) {
module.exports = import("4M6Yl").then(()=>parcelRequire('jJZZ4'));

});

parcelRegister("dTjVb", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a1cfdd5eecb44cb2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1cfdd5eecb44cb2$var$_createSvgIcon = $a1cfdd5eecb44cb2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a1cfdd5eecb44cb2$var$_default = module.exports.default = (0, $a1cfdd5eecb44cb2$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }, "1")
], 'Schedule');

});

parcelRegister("7HZko", function(module, exports) {
module.exports = import("ijslt").then(()=>parcelRequire('2EwNo'));

});

parcelRegister("aIuYX", function(module, exports) {
module.exports = import("ic1cR").then(()=>parcelRequire('cNgef'));

});

parcelRegister("6hD2z", function(module, exports) {
module.exports = import("cNQ0X").then(()=>parcelRequire('5ILlj'));

});

parcelRegister("3SGuh", function(module, exports) {
module.exports = import("14zzL").then(()=>parcelRequire('b4R3h'));

});

parcelRegister("gC30r", function(module, exports) {
module.exports = import("dzxQB").then(()=>parcelRequire('g0L4K'));

});

parcelRegister("67scz", function(module, exports) {
module.exports = import("fzgtI").then(()=>parcelRequire('6hFme'));

});

parcelRegister("3w9yg", function(module, exports) {
module.exports = import("2n7e5").then(()=>parcelRequire('5lxnU'));

});

parcelRegister("3tQEG", function(module, exports) {
module.exports = import("a9547").then(()=>parcelRequire('dohfE'));

});

parcelRegister("8bRjh", function(module, exports) {
module.exports = import("e0cqA").then(()=>parcelRequire('bgbQv'));

});

parcelRegister("57pvR", function(module, exports) {
module.exports = import("8WwoI").then(()=>parcelRequire('bTP6l'));

});

parcelRegister("cy9PS", function(module, exports) {
module.exports = import("esRsU").then(()=>parcelRequire('ayPsx'));

});

parcelRegister("kI2UI", function(module, exports) {
module.exports = import("aOSDv").then(()=>parcelRequire('eAW1Y'));

});

parcelRegister("33PpE", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $23a98866e8b9b13c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23a98866e8b9b13c$var$_createSvgIcon = $23a98866e8b9b13c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $23a98866e8b9b13c$var$_default = module.exports.default = (0, $23a98866e8b9b13c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'Person');

});

parcelRegister("2KvQo", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $20089432e2bb2ac7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20089432e2bb2ac7$var$_createSvgIcon = $20089432e2bb2ac7$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $20089432e2bb2ac7$var$_default = module.exports.default = (0, $20089432e2bb2ac7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12m8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8"
}), 'Block');

});

parcelRegister("dErt0", function(module, exports) {
module.exports = import("h6yS0").then(()=>parcelRequire('f8PoN'));

});

parcelRegister("l32Ih", function(module, exports) {
module.exports = import("hkjqv").then(()=>parcelRequire('hO6PI'));

});

parcelRegister("6XkYM", function(module, exports) {
module.exports = import("cfjwo").then(()=>parcelRequire('alZpG'));

});

parcelRegister("cf62F", function(module, exports) {
module.exports = import("eXPBx").then(()=>parcelRequire('9srVE'));

});

parcelRegister("i8XSp", function(module, exports) {
module.exports = import("49OJ2").then(()=>parcelRequire('gyLfI'));

});

parcelRegister("31Jy0", function(module, exports) {
module.exports = import("lTA9f").then(()=>parcelRequire('3K2Vi'));

});

parcelRegister("86gi2", function(module, exports) {
module.exports = import("baaZr").then(()=>parcelRequire('jW9D0'));

});



parcelRegister("kWYrU", function(module, exports) {

$parcel$export(module.exports, "usePermissions", () => $acc2bf70c4c22d1d$export$dde803638a7db51f);

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $gqehT = parcelRequire("gqehT");

var $bfCc1 = parcelRequire("bfCc1");

var $aHqXU = parcelRequire("aHqXU");
function $acc2bf70c4c22d1d$export$dde803638a7db51f() {
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { isActive: isActive, overriddenRole: overriddenRole, fboId: fboId, stopRoleOverride: stopRoleOverride } = (0, $bfCc1.useRoleOverride)();
    // Auto-disable role override when switching FBOs
    (0, $acw62.useEffect)(()=>{
        if (isActive && fboId && activeFBO?.id && fboId !== activeFBO.id) stopRoleOverride();
    }, [
        isActive,
        fboId,
        activeFBO?.id,
        stopRoleOverride
    ]);
    const context = (0, $acw62.useMemo)(()=>{
        // Only apply role override if:
        // 1. Override is active
        // 2. User is system admin (safety check)
        // 3. There's an overridden role set
        // 4. FBO IDs match (or no FBO active)
        const shouldOverride = isActive && airplxIdentity.isadmin && overriddenRole && (!activeFBO || !fboId || fboId === activeFBO.id);
        return {
            user: {
                // IMPORTANT: Keep isAdmin true - preserves admin escape hatch
                isAdmin: airplxIdentity.isadmin,
                userid: airplxIdentity.userid
            },
            fbo: activeFBO && shouldOverride ? {
                ...activeFBO,
                // Override the user_role for permission checks
                user_role: overriddenRole
            } : activeFBO,
            // Flag to skip admin bypass during role testing
            roleOverrideActive: shouldOverride
        };
    }, [
        airplxIdentity,
        activeFBO,
        isActive,
        overriddenRole,
        fboId
    ]);
    return {
        /**
     * Check if the current user has a specific permission.
     *
     * Automatically handles:
     * - System admin bypass (always returns true for admins)
     * - View-only mode (returns false for write permissions when in view-only mode)
     * - Role-based permissions (checks user's role against FBO settings)
     */ hasPermission: (permission)=>(0, $aHqXU.hasPermission)(permission, context),
        context: /**
     * Permission context for advanced use cases.
     * Most components should use hasPermission() instead.
     */ context
    };
}

});
parcelRegister("bfCc1", function(module, exports) {

$parcel$export(module.exports, "useRoleOverride", () => $4b576ba4c1f3feb4$export$ff914bac826743ee);
/**
 * Zustand store for admin role override/testing
 *
 * Allows system administrators to temporarily test the application as different user roles
 * without logging out or affecting the database. The override is client-side only and
 * persists across page reloads via localStorage.
 *
 * Safety mechanisms:
 * - Only admins can activate (enforced in usePermissions hook)
 * - Auto-disables when switching FBOs
 * - Preserves system admin escape hatch (ACCESS_SUPER_ADMIN always true)
 *
 * @example
 * const { isActive, overriddenRole, startRoleOverride, stopRoleOverride } = useRoleOverride();
 *
 * // Start testing as operator
 * startRoleOverride('operator', activeFBO.id);
 *
 * // Exit role testing
 * stopRoleOverride();
 */ 
var $f4OIt = parcelRequire("f4OIt");

var $88tPr = parcelRequire("88tPr");
const $4b576ba4c1f3feb4$export$ff914bac826743ee = (0, $f4OIt.create)((0, $88tPr.persist)((set)=>({
        overriddenRole: null,
        isActive: false,
        fboId: null,
        startRoleOverride: (role, fboId)=>{
            set({
                overriddenRole: role,
                isActive: true,
                fboId: fboId
            });
        },
        stopRoleOverride: ()=>{
            set({
                overriddenRole: null,
                isActive: false,
                fboId: null
            });
        }
    }), {
    name: "role-override-storage"
}));

});
parcelRegister("f4OIt", function(module, exports) {
'use strict';

var $iNkrR = parcelRequire("iNkrR");

var $acw62 = parcelRequire("acw62");

var $9b0Yv = parcelRequire("9b0Yv");
var $af9e91ea6e32034a$var$useDebugValue = $acw62.useDebugValue;
var $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector = $9b0Yv.useSyncExternalStoreWithSelector;
var $af9e91ea6e32034a$var$didWarnAboutEqualityFn = false;
var $af9e91ea6e32034a$var$identity = function identity(arg) {
    return arg;
};
function $af9e91ea6e32034a$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $af9e91ea6e32034a$var$identity;
    var slice = $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $af9e91ea6e32034a$var$useDebugValue(slice);
    return slice;
}
var $af9e91ea6e32034a$var$createImpl = function createImpl(createState) {
    var api = typeof createState === 'function' ? $iNkrR.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $af9e91ea6e32034a$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $af9e91ea6e32034a$var$create = function create(createState) {
    return createState ? $af9e91ea6e32034a$var$createImpl(createState) : $af9e91ea6e32034a$var$createImpl;
};
var $af9e91ea6e32034a$var$react = function(createState) {
    return $af9e91ea6e32034a$var$create(createState);
};
module.exports.create = $af9e91ea6e32034a$var$create;
module.exports.default = $af9e91ea6e32034a$var$react;
module.exports.useStore = $af9e91ea6e32034a$var$useStore;
Object.keys($iNkrR).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $iNkrR[k];
        }
    });
});
module.exports = $af9e91ea6e32034a$var$react;
module.exports.create = $af9e91ea6e32034a$var$create;
module.exports.useStore = $af9e91ea6e32034a$var$useStore;
module.exports.createStore = $iNkrR.createStore;
module.exports.default = module.exports;

});
parcelRegister("iNkrR", function(module, exports) {
'use strict';
var $daecaa38e3584fd1$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $daecaa38e3584fd1$var$createStore = function createStore(createState) {
    return createState ? $daecaa38e3584fd1$var$createStoreImpl(createState) : $daecaa38e3584fd1$var$createStoreImpl;
};
var $daecaa38e3584fd1$var$vanilla = function(createState) {
    return $daecaa38e3584fd1$var$createStore(createState);
};
module.exports.createStore = $daecaa38e3584fd1$var$createStore;
module.exports.default = $daecaa38e3584fd1$var$vanilla;
module.exports = $daecaa38e3584fd1$var$vanilla;
module.exports.createStore = $daecaa38e3584fd1$var$createStore;
module.exports.default = module.exports;

});

parcelRegister("9b0Yv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i5mAx"));

});
parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});
parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});





parcelRegister("88tPr", function(module, exports) {

$parcel$export(module.exports, "persist", () => $5ec635760157368f$export$9a6132153fba2e0, (v) => $5ec635760157368f$export$9a6132153fba2e0 = v);
var $5ec635760157368f$export$1be1fc439b849fdf;
var $5ec635760157368f$export$95a3b7b12ab518f9;
var $5ec635760157368f$export$6922d3b3a607469e;
var $5ec635760157368f$export$9a6132153fba2e0;
var $5ec635760157368f$export$4feba8a1bc8e9afd;
var $5ec635760157368f$export$5c593627aef9f076;
'use strict';
function $5ec635760157368f$var$_extends() {
    return $5ec635760157368f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5ec635760157368f$var$_extends.apply(null, arguments);
}
function $5ec635760157368f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5ec635760157368f$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $5ec635760157368f$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $5ec635760157368f$var$redux = $5ec635760157368f$var$reduxImpl;
var $5ec635760157368f$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $5ec635760157368f$var$_excluded2 = [
    "connection"
];
var $5ec635760157368f$var$trackedConnections = new Map();
var $5ec635760157368f$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $5ec635760157368f$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $5ec635760157368f$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: 'untracked',
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $5ec635760157368f$var$trackedConnections.get(options.name);
    if (existingConnection) return $5ec635760157368f$var$_extends({
        type: 'tracked',
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5ec635760157368f$var$trackedConnections.set(options.name, newConnection);
    return $5ec635760157368f$var$_extends({
        type: 'tracked',
        store: store
    }, newConnection);
};
var $5ec635760157368f$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $5ec635760157368f$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $5ec635760157368f$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $5ec635760157368f$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $5ec635760157368f$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $5ec635760157368f$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || 'anonymous'
            } : typeof nameOrAction === 'string' ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($5ec635760157368f$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $5ec635760157368f$var$_extends({}, $5ec635760157368f$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === 'untracked') connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === 'function') {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case 'ACTION':
                    if (typeof message.payload !== 'string') {
                        console.error('[zustand devtools middleware] Unsupported action format');
                        return;
                    }
                    return $5ec635760157368f$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === '__setState') {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error("\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { \"type\": \"__setState\", \"state\": { \"abc123Store\": { \"foo\": \"bar\" } } }\n                    ");
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== 'function') return;
                        api.dispatch(action);
                    });
                case 'DISPATCH':
                    switch(message.payload.type){
                        case 'RESET':
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                        case 'COMMIT':
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                        case 'ROLLBACK':
                            return $5ec635760157368f$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                            });
                        case 'JUMP_TO_STATE':
                        case 'JUMP_TO_ACTION':
                            return $5ec635760157368f$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case 'IMPORT_STATE':
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case 'PAUSE_RECORDING':
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $5ec635760157368f$var$devtools = $5ec635760157368f$var$devtoolsImpl;
var $5ec635760157368f$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error('[zustand devtools middleware] Could not parse the received json', e);
    }
    if (parsed !== undefined) f(parsed);
};
var $5ec635760157368f$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $5ec635760157368f$var$subscribeWithSelector = $5ec635760157368f$var$subscribeWithSelectorImpl;
var $5ec635760157368f$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $5ec635760157368f$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $5ec635760157368f$var$_toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return $5ec635760157368f$var$_toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return $5ec635760157368f$var$_toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $5ec635760157368f$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $5ec635760157368f$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $5ec635760157368f$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $5ec635760157368f$var$_toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($5ec635760157368f$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $5ec635760157368f$var$_toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $5ec635760157368f$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $5ec635760157368f$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $5ec635760157368f$var$_extends({
            storage: $5ec635760157368f$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $5ec635760157368f$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($5ec635760157368f$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        api.getInitialState = function() {
            return configResult;
        };
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $5ec635760157368f$var$_toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    undefined
                ];
            }).then(function(migrationResult) {
                var _get4;
                var migrated = migrationResult[0], migratedState = migrationResult[1];
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $5ec635760157368f$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $5ec635760157368f$var$persistImpl = function persistImpl(config, baseOptions) {
    if ('getStorage' in baseOptions || 'serialize' in baseOptions || 'deserialize' in baseOptions) return $5ec635760157368f$var$oldImpl(config, baseOptions);
    return $5ec635760157368f$var$newImpl(config, baseOptions);
};
var $5ec635760157368f$var$persist = $5ec635760157368f$var$persistImpl;
$5ec635760157368f$export$1be1fc439b849fdf = $5ec635760157368f$var$combine;
$5ec635760157368f$export$95a3b7b12ab518f9 = $5ec635760157368f$var$createJSONStorage;
$5ec635760157368f$export$6922d3b3a607469e = $5ec635760157368f$var$devtools;
$5ec635760157368f$export$9a6132153fba2e0 = $5ec635760157368f$var$persist;
$5ec635760157368f$export$4feba8a1bc8e9afd = $5ec635760157368f$var$redux;
$5ec635760157368f$export$5c593627aef9f076 = $5ec635760157368f$var$subscribeWithSelector;

});


parcelRegister("aHqXU", function(module, exports) {

$parcel$export(module.exports, "ROLE_DISPLAY_NAMES", () => $0066071277105e89$export$ea4ec65d53240a8e);
$parcel$export(module.exports, "formatRoleName", () => $0066071277105e89$export$ce0df27119809c25);
$parcel$export(module.exports, "ROLE_OPTIONS", () => $0066071277105e89$export$43fbb932cb09c7d);
$parcel$export(module.exports, "Permission", () => $0066071277105e89$export$a461eaf23bef603e);
$parcel$export(module.exports, "hasPermission", () => $0066071277105e89$export$b325ec6732b039cf);
$parcel$export(module.exports, "getRoleSetting", () => $0066071277105e89$export$31e93aa94fceab88);
/**
 * Centralized permission system for AirPlx application
 *
 * This module consolidates all permission logic that was previously scattered
 * across multiple components. It provides type-safe role and permission checking
 * with a single source of truth for all authorization decisions.
 */ var $0066071277105e89$export$eb3485a690c2f0b8 = /*#__PURE__*/ function(UserRole) {
    UserRole["SYSTEM_ADMIN"] = "system_admin";
    UserRole["FBO_ADMIN"] = "fbo_admin";
    UserRole["FBO_MANAGER"] = "manager";
    UserRole["FBO_OPERATOR"] = "operator";
    UserRole["CSR"] = "csr";
    UserRole["AIRPLX_EMPLOYEE"] = "airplx_employee";
    return UserRole;
}({});
const $0066071277105e89$export$ea4ec65d53240a8e = {
    fbo_admin: "FBO Admin",
    manager: "Manager",
    operator: "Operator",
    csr: "CSR"
};
const $0066071277105e89$export$ce0df27119809c25 = (role)=>{
    return $0066071277105e89$export$ea4ec65d53240a8e[role] || role;
};
const $0066071277105e89$export$43fbb932cb09c7d = [
    {
        value: "fbo_admin",
        label: "FBO Admin"
    },
    {
        value: "manager",
        label: "Manager"
    },
    {
        value: "operator",
        label: "Operator"
    },
    {
        value: "csr",
        label: "CSR"
    }
];
var $0066071277105e89$export$a461eaf23bef603e = /*#__PURE__*/ function(Permission) {
    // System-level permissions
    Permission["ACCESS_SUPER_ADMIN"] = "access_super_admin";
    // FBO-level permissions
    Permission["MODIFY_AIRCRAFT_PREFERENCES"] = "modify_aircraft_preferences";
    Permission["MODIFY_LAYOUT"] = "modify_layout";
    Permission["MANAGE_TEAM_MEMBERS"] = "manage_team_members";
    Permission["MODIFY_TENANTS"] = "modify_tenants";
    Permission["USE_FAVORITES"] = "use_favorites";
    Permission["CREATE_TRIPS"] = "create_trips";
    Permission["DELETE_TRIPS"] = "delete_trips";
    // NEW: Backend RLS permissions
    Permission["MODIFY_RATES"] = "modify_rates";
    Permission["MODIFY_INFRASTRUCTURE"] = "modify_infrastructure";
    Permission["MODIFY_CONFIGURATION"] = "modify_configuration";
    // View permissions
    Permission["VIEW_SCHEDULE"] = "view_schedule";
    Permission["VIEW_LAYOUT"] = "view_layout";
    return Permission;
}({});
function $0066071277105e89$export$c33a4269214e2ec4(user, fbo, roleOverrideActive = false) {
    // When role override is active, use the FBO role (not admin status)
    if (!roleOverrideActive && (user.isadmin || user.isAdmin)) return "system_admin";
    if (fbo?.user_role === "fbo_admin") return "fbo_admin";
    if (fbo?.user_role === "manager") return "manager";
    if (fbo?.user_role === "csr") return "csr";
    return "operator";
}
function $0066071277105e89$export$b325ec6732b039cf(permission, context) {
    // Pass roleOverrideActive flag to getUserRole so it uses FBO role instead of admin status
    const userRole = $0066071277105e89$export$c33a4269214e2ec4(context.user, context.fbo, context.roleOverrideActive);
    // System admins have all permissions
    // EXCEPT when role override is active (for testing) - then respect the overridden role
    if (userRole === "system_admin" && !context.roleOverrideActive) return true;
    // No FBO context means no FBO permissions (except system permissions)
    if (!context.fbo) return permission === "access_super_admin" ? false : false;
    switch(permission){
        case "access_super_admin":
            // System admins already returned early (line 141), so this is always false
            return false;
        case "modify_aircraft_preferences":
            return !$0066071277105e89$var$isInViewOnlyMode(context);
        case "modify_layout":
            if (userRole === "fbo_admin") // Fallback to Manager setting if FBOAdmin setting is undefined
            return (context.fbo.settings.modifyLayoutForFBOAdmin ?? context.fbo.settings.modifyLayoutForManager ?? true) && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "manager") return context.fbo.settings.modifyLayoutForManager && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "operator") return context.fbo.settings.modifyLayoutForOperator && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "csr") return context.fbo.settings.modifyLayoutForCSR && !$0066071277105e89$var$isInViewOnlyMode(context);
            return !$0066071277105e89$var$isInViewOnlyMode(context);
        case "manage_team_members":
            if (userRole === "fbo_admin") // Fallback to Manager setting if FBOAdmin setting is undefined
            return context.fbo.settings.addTeamMembersForFBOAdmin ?? context.fbo.settings.addTeamMembersForManager ?? true;
            if (userRole === "manager") return context.fbo.settings.addTeamMembersForManager;
            if (userRole === "operator") return context.fbo.settings.addTeamMembersForOperator;
            if (userRole === "csr") return context.fbo.settings.addTeamMembersForCSR;
            return false;
        case "modify_tenants":
            if (userRole === "fbo_admin") // Fallback to Manager setting if FBOAdmin setting is undefined
            return context.fbo.settings.modifyTenantsForFBOAdmin ?? context.fbo.settings.modifyTenantsForManager ?? true;
            if (userRole === "manager") return context.fbo.settings.modifyTenantsForManager;
            if (userRole === "operator") return context.fbo.settings.modifyTenantsForOperator;
            if (userRole === "csr") return context.fbo.settings.modifyTenantsForCSR;
            return false;
        case "use_favorites":
            if (userRole === "fbo_admin") // Fallback to Manager setting if FBOAdmin setting is undefined
            return context.fbo.settings.useFavoritesForFBOAdmin ?? context.fbo.settings.useFavoritesForManager ?? true;
            if (userRole === "manager") return context.fbo.settings.useFavoritesForManager;
            if (userRole === "operator") return context.fbo.settings.useFavoritesForOperator;
            if (userRole === "csr") return context.fbo.settings.useFavoritesForCSR;
            return false;
        case "view_schedule":
            return true;
        // All authenticated users can view schedules
        case "view_layout":
            return true;
        // All authenticated users can view layouts
        case "create_trips":
            if (userRole === "fbo_admin") // Fallback to Manager setting if FBOAdmin setting is undefined
            return (context.fbo.settings.createTripsForFBOAdmin ?? context.fbo.settings.createTripsForManager ?? true) && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "manager") return context.fbo.settings.createTripsForManager && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "operator") return context.fbo.settings.createTripsForOperator && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "csr") return context.fbo.settings.createTripsForCSR && !$0066071277105e89$var$isInViewOnlyMode(context);
            return !$0066071277105e89$var$isInViewOnlyMode(context);
        case "delete_trips":
            // Note: System admins already returned early (line 141)
            if (userRole === "fbo_admin") // Fallback to Manager setting if FBOAdmin setting is undefined
            return (context.fbo.settings.deleteTripsForFBOAdmin ?? context.fbo.settings.deleteTripsForManager ?? true) && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "manager") return context.fbo.settings.deleteTripsForManager && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "operator") return context.fbo.settings.deleteTripsForOperator && !$0066071277105e89$var$isInViewOnlyMode(context);
            if (userRole === "csr") return context.fbo.settings.deleteTripsForCSR && !$0066071277105e89$var$isInViewOnlyMode(context);
            return !$0066071277105e89$var$isInViewOnlyMode(context);
        case "modify_rates":
            if (userRole === "fbo_admin") return context.fbo.settings.modifyRatesForFBOAdmin ?? context.fbo.settings.modifyRatesForManager ?? true;
            if (userRole === "manager") return context.fbo.settings.modifyRatesForManager ?? true;
            if (userRole === "operator") return context.fbo.settings.modifyRatesForOperator ?? false;
            if (userRole === "csr") return context.fbo.settings.modifyRatesForCSR ?? false;
            return false;
        case "modify_infrastructure":
            if (userRole === "fbo_admin") return context.fbo.settings.modifyInfrastructureForFBOAdmin ?? context.fbo.settings.modifyInfrastructureForManager ?? true;
            if (userRole === "manager") return context.fbo.settings.modifyInfrastructureForManager ?? true;
            if (userRole === "operator") return context.fbo.settings.modifyInfrastructureForOperator ?? false;
            if (userRole === "csr") return context.fbo.settings.modifyInfrastructureForCSR ?? false;
            return false;
        case "modify_configuration":
            if (userRole === "fbo_admin") return context.fbo.settings.modifyConfigurationForFBOAdmin ?? context.fbo.settings.modifyConfigurationForManager ?? true;
            if (userRole === "manager") return context.fbo.settings.modifyConfigurationForManager ?? true;
            if (userRole === "operator") return context.fbo.settings.modifyConfigurationForOperator ?? false;
            if (userRole === "csr") return context.fbo.settings.modifyConfigurationForCSR ?? false;
            return false;
        default:
            return false;
    }
}
/**
 * INTERNAL HELPER: Check if the user is in view-only mode based on their role and FBO settings
 *
 * This function is used internally by hasPermission() to enforce view-only mode.
 * Components should NOT call this directly - use hasPermission() instead.
 */ function $0066071277105e89$var$isInViewOnlyMode(context) {
    const userRole = $0066071277105e89$export$c33a4269214e2ec4(context.user, context.fbo);
    if (userRole === "system_admin") return false;
    if (!context.fbo) return true;
    if (userRole === "fbo_admin") return context.fbo.settings.viewOnlyForFBOAdmin ?? context.fbo.settings.viewOnlyForManager ?? false;
    if (userRole === "manager") return context.fbo.settings.viewOnlyForManager;
    if (userRole === "csr") return context.fbo.settings.viewOnlyForCSR;
    return context.fbo.settings.viewOnlyForOperator;
}
function $0066071277105e89$export$f54813e139fbec3d(fbo) {
    return fbo?.user_role === "manager" || fbo?.user_role === "fbo_admin";
}
function $0066071277105e89$export$31e93aa94fceab88(fbo, settingName, defaultValue) {
    if (!fbo?.settings) return defaultValue;
    const role = fbo.user_role;
    const settings = fbo.settings;
    // Try role-specific setting first
    if (role === "fbo_admin") return settings[`${settingName}ForFBOAdmin`] ?? settings[`${settingName}ForManager`] ?? defaultValue;
    if (role === "manager") return settings[`${settingName}ForManager`] ?? defaultValue;
    if (role === "csr") return settings[`${settingName}ForCSR`] ?? defaultValue;
    // operator or unknown role
    return settings[`${settingName}ForOperator`] ?? defaultValue;
}

});


parcelRegister("gtiLb", function(module, exports) {

$parcel$export(module.exports, "HangarIcon", () => $a48927b5049eec05$export$25633d9137088f8f);

var $ayMG0 = parcelRequire("ayMG0");

var $3ErGR = parcelRequire("3ErGR");
const $a48927b5049eec05$export$25633d9137088f8f = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), {
        ...props,
        viewBox: "0 0 50 50",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            style: {
                stroke: "none",
                fillRule: "nonzero",
                fill: "currentColor",
                fillOpacity: 1
            },
            d: "M 24.78125 12 L 7.839844 16.941406 C 7.558594 17.082031 7.351562 17.367188 7.351562 17.648438 L 7.351562 35.292969 C 7.351562 35.71875 7.632812 36 8.058594 36 L 12.292969 36 L 12.292969 24 C 12.292969 23.574219 12.574219 23.292969 13 23.292969 L 37 23.292969 C 37.425781 23.292969 37.707031 23.574219 37.707031 24 L 37.707031 36 L 41.941406 36 C 42.367188 36 42.648438 35.71875 42.648438 35.292969 L 42.648438 17.648438 C 42.648438 17.367188 42.441406 17.082031 42.160156 16.941406 L 25.21875 12 Z M 13.707031 24.707031 L 13.707031 36 L 36.292969 36 L 36.292969 24.707031 Z M 13.707031 24.707031 "
        })
    });

});

parcelRegister("kPMZ3", function(module, exports) {

$parcel$export(module.exports, "findTenantsFullyInHangar", () => $e8b29c51c66a0758$export$8c7c2b38098d83f3);
$parcel$export(module.exports, "calculateTotalArea", () => $e8b29c51c66a0758$export$a5c0213b68c9bfe);
$parcel$export(module.exports, "calculateUtilization", () => $e8b29c51c66a0758$export$cc573a7b400f64c4);
$parcel$export(module.exports, "HangarInfoCard", () => $e8b29c51c66a0758$export$b68537d96bd13153);

var $ayMG0 = parcelRequire("ayMG0");

var $ltk0t = parcelRequire("ltk0t");

var $hbZ6O = parcelRequire("hbZ6O");

var $ex6lH = parcelRequire("ex6lH");
parcelRequire("9vNAe");
var $dfdxy = parcelRequire("dfdxy");
parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $64iGd = parcelRequire("64iGd");

var $5KGQl = parcelRequire("5KGQl");

var $cLNZr = parcelRequire("cLNZr");

var $3dLiv = parcelRequire("3dLiv");

var $gQSh1 = parcelRequire("gQSh1");

var $97sqG = parcelRequire("97sqG");

var $78CAK = parcelRequire("78CAK");

var $le4Y6 = parcelRequire("le4Y6");

var $1QUqu = parcelRequire("1QUqu");

var $7UqNi = parcelRequire("7UqNi");
var $2mdyF = parcelRequire("2mdyF");
var $2gURC = parcelRequire("2gURC");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");

var $aHqXU = parcelRequire("aHqXU");

var $3JLDK = parcelRequire("3JLDK");

var $8vHzJ = parcelRequire("8vHzJ");
const $e8b29c51c66a0758$export$8c7c2b38098d83f3 = (hangar, entityPolygons)=>{
    const buffer = 2.5;
    const hangarPolygon = [
        [
            0 - buffer,
            0 - buffer
        ],
        [
            0 - buffer,
            hangar.depth + buffer
        ],
        [
            hangar.width + buffer,
            hangar.depth + buffer
        ],
        [
            hangar.width + buffer,
            0 - buffer
        ]
    ];
    const tenantIdsFullyInHangar = entityPolygons.filter(({ polygon: polygon })=>{
        return $dfdxy.polygonInPolygon(polygon.coordinates[0], hangarPolygon);
    }).map(({ entity_id: entity_id })=>entity_id);
    const tenantsInHangar = hangar.stack.tenants.filter((tenant)=>{
        return tenantIdsFullyInHangar.indexOf(tenant.entity_id) > -1;
    });
    return tenantsInHangar;
};
const $e8b29c51c66a0758$export$a5c0213b68c9bfe = (hangar, ignoreUnusableArea = false)=>{
    if (ignoreUnusableArea) {
        const unusableArea = (0, $cLNZr.sum)([
            ...hangar.obstacles.map((o)=>o.width * o.depth),
            hangar.wall_spacing_left * hangar.depth,
            hangar.wall_spacing_back * hangar.width,
            hangar.wall_spacing_right * hangar.depth,
            // these areas get double counted b/c they overlap
            -hangar.wall_spacing_left * hangar.wall_spacing_back,
            -hangar.wall_spacing_right * hangar.wall_spacing_back
        ]);
        return hangar.width * hangar.depth - unusableArea;
    }
    return hangar.width * hangar.depth;
};
const $e8b29c51c66a0758$export$cc573a7b400f64c4 = (hangar, polygons, limitToInHangar = false, ignoreUnusableArea = false, feet = false)=>{
    const totalUtilization = (0, $cLNZr.sum)((limitToInHangar ? $e8b29c51c66a0758$export$8c7c2b38098d83f3(hangar, polygons) : hangar.stack.tenants).map(({ aircraft: aircraft })=>aircraft.wingspan * aircraft.length));
    if (feet) return totalUtilization;
    const totalArea = $e8b29c51c66a0758$export$a5c0213b68c9bfe(hangar, ignoreUnusableArea);
    return Math.round(100 * totalUtilization / totalArea);
};
const $e8b29c51c66a0758$export$dc897f6ae10ab4b6 = (fbo, hangar)=>{
    const totalSqft = (0, $cLNZr.sum)(hangar.stack.tenants.filter((t)=>t.type === "transient").map((t)=>t.aircraft.wingspan * t.aircraft.length));
    const sqftValue = fbo.nightly_transient_rate ?? 0.2;
    return (0, $lNEp2.formatCurrency)(sqftValue * totalSqft, 0);
};
const $e8b29c51c66a0758$export$b68537d96bd13153 = ({ hangar: hangar, customPlacementOptions: customPlacementOptions, setCustomPlacementOptions: setCustomPlacementOptions, isAlgorithmTesting: isAlgorithmTesting = false, multiHangar: multiHangar = false, isScheduledView: isScheduledView = false, timeRange: timeRange, allPlacements: allPlacements = [] })=>{
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const padding = 2;
    /**
   * we are cheating a bit on these useMemos and useDebouncedValues. when this component is rendered,
   * the hangar itself isn't changing (dimensions, doors, etc.). so we can focus only on the geometry
   * of the hangar and the entities inside it for changes.
   */ const entityPolygons = (0, $64iGd.useDebouncedValue)(()=>(0, $5KGQl.getStackPolygons)(hangar.stack, hangar.width, 1), 50, [
        hangar.stack
    ]);
    const displayEstimatedValue = (0, $aHqXU.getRoleSetting)(activeFBO, "displayEstimatedValue", true);
    const tenantsFullyInHangar = (0, $64iGd.useDebouncedValue)(()=>{
        return $e8b29c51c66a0758$export$8c7c2b38098d83f3(hangar, entityPolygons);
    }, 100, [
        // hangar.width, hangar.depth, hangar.stack.tenants,
        entityPolygons
    ]);
    const actualUtilization = (0, $64iGd.useDebouncedValue)(()=>{
        return $e8b29c51c66a0758$export$cc573a7b400f64c4(hangar, entityPolygons, true, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false);
    }, 100, [
        // hangar,
        entityPolygons,
        activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false
    ]);
    const totalPossibleUtilization = (0, $64iGd.useDebouncedValue)(()=>{
        return $e8b29c51c66a0758$export$cc573a7b400f64c4(hangar, entityPolygons, undefined, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false);
    }, 100, [
        // hangar,
        entityPolygons,
        activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false
    ]);
    const dailyEstimatedValue = (0, $64iGd.useDebouncedValue)(()=>{
        return (0, $97sqG.estimateValue)(activeFBO, hangar, entityPolygons, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false);
    }, 100, [
        activeFBO?.nightly_base_rate,
        // hangar,
        entityPolygons
    ]);
    const monthlyEstimatedValue = (0, $64iGd.useDebouncedValue)(()=>{
        return (0, $97sqG.estimateValue)(activeFBO, hangar, entityPolygons, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false, true);
    }, 100, [
        activeFBO?.nightly_base_rate,
        // hangar,
        entityPolygons
    ]);
    const estimatedTowTime = (0, $64iGd.useDebouncedValue)(()=>{
        return (0, $97sqG.calcEstimateTowTime)(hangar, entityPolygons);
    }, 100, [
        // hangar,
        entityPolygons
    ]);
    // New metrics for scheduled view
    const currentTime = timeRange ? new Date((timeRange.start.getTime() + timeRange.end.getTime()) / 2) : new Date();
    const activeTrips = (0, $64iGd.useDebouncedValue)(()=>{
        if (!isScheduledView || !allPlacements) return 0;
        return (0, $3dLiv.calculateActiveAircraft)(allPlacements, currentTime, hangar.id, "hangar");
    }, 100, [
        isScheduledView,
        allPlacements,
        allPlacements?.length,
        currentTime,
        hangar.id
    ]);
    const futureTrips = (0, $64iGd.useDebouncedValue)(()=>{
        if (!isScheduledView || !allPlacements) return 0;
        return (0, $3dLiv.calculateAssignedAircraft)(allPlacements, currentTime, hangar.id, "hangar");
    }, 100, [
        isScheduledView,
        allPlacements,
        allPlacements?.length,
        currentTime,
        hangar.id
    ]);
    const doorSize = activeFBO?.settings?.useMetricSystem ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(hangar.width - (hangar.right_door + hangar.left_door)), 2),
            "L x ",
            (0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(hangar.height), 2),
            "H"
        ]
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $lNEp2.formatNumber)(hangar.width - (hangar.right_door + hangar.left_door), 0),
            "L x ",
            (0, $lNEp2.formatNumber)(hangar.height, 0),
            "H"
        ]
    });
    const dimensions = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(hangar.depth), 1)}L x ${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(hangar.width), 1)}W` : `${(0, $lNEp2.formatNumber)(hangar.depth, 1)}L x ${(0, $lNEp2.formatNumber)(hangar.width, 1)}W`;
    if (!isDrawerOpen) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
        width: 130,
        height: 105,
        children: [
            multiHangar && !isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "caption",
                children: hangar.name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                spacing: 1,
                sx: {
                    p: 1,
                    pt: 0,
                    maxHeight: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vHzJ.MicroMetric), {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($le4Y6))), {}),
                        value: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                    value: tenantsFullyInHangar.length,
                                    text: tenantsFullyInHangar.length
                                }),
                                " ",
                                "/ ",
                                `${hangar.stack.tenants.length}`
                            ]
                        }),
                        tooltip: "# aircraft inside hangar / # aircraft wanted inside"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vHzJ.MicroMetric), {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1QUqu))), {}),
                        value: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        color: "inherit"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                            value: actualUtilization,
                                            text: `${actualUtilization}%`
                                        }),
                                        " "
                                    ]
                                }),
                                "/ ",
                                totalPossibleUtilization,
                                "%"
                            ]
                        }),
                        tooltip: "Stacked aircraft utl. / All aircraft on screen utl. You can adjust how utilization is calculated in Settings > Configuration."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vHzJ.MicroMetric), {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ltk0t))), {}),
                        value: estimatedTowTime,
                        tooltip: "Estimated time it would take to tow every aircraft out of the hangar."
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        sx: {
            p: padding,
            maxHeight: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                children: [
                    multiHangar && !isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: hangar.name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                sx: {
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                textAlign: "center",
                                                children: "Aircraft"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                title: "# aircraft inside hangar / # aircraft wanted inside",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                    sx: {
                                                        color: "info.dark"
                                                    },
                                                    fontSize: "small"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "caption",
                                        textAlign: "center",
                                        color: "info.dark",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    color: "inherit"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                        value: tenantsFullyInHangar.length,
                                                        text: tenantsFullyInHangar.length
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            "/ ",
                                            `${hangar.stack.tenants.length}`
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                orientation: "vertical",
                                variant: "middle",
                                flexItem: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                sx: {
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                textAlign: "center",
                                                children: "Utilization"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                title: "Stacked aircraft utl. / All aircraft on screen utl. You can adjust how utilization is calculated in Settings > Configuration.",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                    sx: {
                                                        color: "info.dark"
                                                    },
                                                    fontSize: "small"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "caption",
                                        textAlign: "center",
                                        color: "info.dark",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    color: "inherit"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                        value: actualUtilization,
                                                        text: `${actualUtilization}%`
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            "/ ",
                                            totalPossibleUtilization,
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            !multiHangar && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                        orientation: "vertical",
                                        variant: "middle",
                                        flexItem: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                        direction: "column",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: isScheduledView ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            textAlign: "center",
                                                            children: "Trips"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                            title: "Active trips / Future trips assigned to this hangar",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                                sx: {
                                                                    color: "info.dark"
                                                                },
                                                                fontSize: "small"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    textAlign: "center",
                                                    color: "info.dark",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                color: "inherit"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                                    value: activeTrips,
                                                                    text: activeTrips
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        "/ ",
                                                        futureTrips
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                                    direction: "row",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    spacing: 1,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        textAlign: "center",
                                                        children: "Door Size"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    textAlign: "center",
                                                    color: "info.dark",
                                                    children: doorSize
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            isScheduledView ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    textAlign: "center",
                                                    children: "Est. Tow Time"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: "Estimated time it would take to tow every aircraft out of the hangar.",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                        sx: {
                                                            color: "info.dark"
                                                        },
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: estimatedTowTime
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    displayEstimatedValue && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        textAlign: "center",
                                                        children: "Est. Value"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: "Estimated value of your hangar. This includes all base tenants and any transients you're able to fit in the hangar.",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                            sx: {
                                                                color: "info.dark"
                                                            },
                                                            fontSize: "small"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                textAlign: "center",
                                                color: "info.dark",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                        value: (0, $5KGQl.removeNonNumericAndParse)(dailyEstimatedValue),
                                                        text: `${dailyEstimatedValue} / day`
                                                    }),
                                                    hangar.stack.name === "reference" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                                value: (0, $5KGQl.removeNonNumericAndParse)(monthlyEstimatedValue),
                                                                text: `${monthlyEstimatedValue} / mo`
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    displayEstimatedValue && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                        orientation: "vertical",
                                        variant: "middle",
                                        flexItem: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        textAlign: "center",
                                                        children: "Est. Tow Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: "Estimated time it would take to tow every aircraft out of the hangar.",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                            sx: {
                                                                color: "info.dark"
                                                            },
                                                            fontSize: "small"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                textAlign: "center",
                                                color: "info.dark",
                                                children: estimatedTowTime
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !multiHangar && !isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                        orientation: "vertical",
                                        variant: "middle",
                                        flexItem: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                textAlign: "center",
                                                children: "Dimensions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                textAlign: "center",
                                                color: "info.dark",
                                                children: dimensions
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isAlgorithmTesting && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UqNi.default), {
                disableGutters: true,
                elevation: 0,
                defaultExpanded: false,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gURC.default), {
                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {}),
                        "aria-controls": "panel1a-content",
                        id: "panel1a-header",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: "Parameters"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2mdyF.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $78CAK.CustomStackForm), {
                            minimal: true,
                            isDev: true,
                            customPlacementOptions: customPlacementOptions,
                            setCustomPlacementOptions: setCustomPlacementOptions
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("64iGd", function(module, exports) {

$parcel$export(module.exports, "useDebouncedValue", () => $328aafc36bacdd4d$export$5ab4fa7caa249e6e);

var $acw62 = parcelRequire("acw62");

var $1x7Ku = parcelRequire("1x7Ku");
const $328aafc36bacdd4d$export$5ab4fa7caa249e6e = (func, delay, deps)=>{
    const [debouncedValue, setDebouncedValue] = $acw62.useState(func());
    (0, $1x7Ku.default)(()=>{
        const value = func();
        setDebouncedValue(value);
    }, delay, deps);
    return debouncedValue;
};

});
parcelRegister("1x7Ku", function(module, exports) {

$parcel$export(module.exports, "default", () => $11dee2472380ff6c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $lHtN0 = parcelRequire("lHtN0");
function $11dee2472380ff6c$export$2e2bcd8739ae039(fn, ms, deps) {
    if (ms === void 0) ms = 0;
    if (deps === void 0) deps = [];
    var _a = (0, $lHtN0.default)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0, $acw62.useEffect)(reset, deps);
    return [
        isReady,
        cancel
    ];
}

});
parcelRegister("lHtN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0413b065fc297747$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $0413b065fc297747$export$2e2bcd8739ae039(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = (0, $acw62.useRef)(false);
    var timeout = (0, $acw62.useRef)();
    var callback = (0, $acw62.useRef)(fn);
    var isReady = (0, $acw62.useCallback)(function() {
        return ready.current;
    }, []);
    var set = (0, $acw62.useCallback)(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = (0, $acw62.useCallback)(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0, $acw62.useEffect)(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    (0, $acw62.useEffect)(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}

});



parcelRegister("3dLiv", function(module, exports) {

$parcel$export(module.exports, "calculateActiveAircraft", () => $38feff204bc17365$export$670b7054594b15ca);
$parcel$export(module.exports, "calculateAssignedAircraft", () => $38feff204bc17365$export$f78d8d6b9c7b70f9);
$parcel$export(module.exports, "detectAndLogDuplicates", () => $38feff204bc17365$export$2039f6bed923d95d);

var $gYLUy = parcelRequire("gYLUy");
function $38feff204bc17365$export$667ef6ba403b9ec9(_placements, _location, _viewMode = "scheduled") {
    // This function should not be used - it creates fake aircraft data
    throw new Error(`convertPlacementsToStack is deprecated and should not be used. ` + `It was creating fake aircraft objects with hardcoded dimensions (wingspan: 50, length: 40) which causes layout errors. ` + `Use ScheduledHangarView or ScheduledRampView instead, which properly fetch real aircraft data from the database.`);
}
const $38feff204bc17365$export$670b7054594b15ca = (placements, currentTime, locationId, locationType)=>{
    if (!placements || placements.length === 0) return 0;
    const now = currentTime.getTime();
    const locationField = locationType === "hangar" ? "hangar_id" : "ramp_id";
    // Count unique aircraft (by tail_number) currently at this location
    const activeTailNumbers = new Set(placements.filter((p)=>{
        if (!p.tail_number || p.status === "cancelled") return false;
        if (p[locationField] !== locationId) return false;
        const startTime = new Date(p.start_time).getTime();
        // Handle infinity end_time (base tenants never leave)
        const endTime = (0, $gYLUy.isInfinityDate)(p.end_time) ? Infinity : new Date(p.end_time).getTime();
        // Active means the current time is between start and end
        return startTime <= now && endTime >= now;
    }).map((p)=>p.tail_number));
    return activeTailNumbers.size;
};
const $38feff204bc17365$export$f78d8d6b9c7b70f9 = (placements, currentTime, locationId, locationType)=>{
    if (!placements || placements.length === 0) return 0;
    const now = currentTime.getTime();
    const locationField = locationType === "hangar" ? "hangar_id" : "ramp_id";
    // Count unique aircraft with any non-cancelled trips at this location
    const assignedTailNumbers = new Set(placements.filter((p)=>{
        if (!p.tail_number || p.status === "cancelled") return false;
        if (p[locationField] !== locationId) return false;
        // Handle infinity end_time (base tenants are always assigned)
        const endTime = (0, $gYLUy.isInfinityDate)(p.end_time) ? Infinity : new Date(p.end_time).getTime();
        // Assigned means not yet completed (end time is in the future or current)
        return endTime >= now;
    }).map((p)=>p.tail_number));
    return assignedTailNumbers.size;
};
function $38feff204bc17365$export$f77f06f69e03a2c9(tenantId, tripId, position, locationId, locationType) {
    return {
        trip_id: tripId,
        hangar_id: locationType === "hangar" ? locationId : undefined,
        ramp_id: locationType === "ramp" ? locationId : undefined,
        x: position.x,
        y: position.y,
        angle: position.angle
    };
}
function $38feff204bc17365$export$366ee14d473cb268(tenantId) {
    const match = tenantId.match(/^scheduled-tenant-(.+)$/);
    return match ? match[1] : null;
}
function $38feff204bc17365$export$b6170a6354305fa6(tenant) {
    return tenant.id.startsWith("scheduled-tenant-");
}
function $38feff204bc17365$export$e8cb741003f5293c(id, type) {
    return `${type}-${id}`;
}
function $38feff204bc17365$export$a7840d1960840ba5(locationId) {
    if (locationId.startsWith("hangar-")) return {
        type: "hangar",
        id: locationId.replace("hangar-", "")
    };
    else if (locationId.startsWith("ramp-")) return {
        type: "ramp",
        id: locationId.replace("ramp-", "")
    };
    return {
        type: null,
        id: null
    };
}
function $38feff204bc17365$export$17048fd8b8e0e6a4(date) {
    const d = typeof date === "string" ? new Date(date) : date;
    return d.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    });
}
function $38feff204bc17365$export$f64ae91ddb09a23e(start1, end1, start2, end2) {
    const s1 = typeof start1 === "string" ? new Date(start1).getTime() : start1.getTime();
    // Handle infinity end times (base tenants)
    const e1 = (0, $gYLUy.isInfinityDate)(end1) ? Infinity : typeof end1 === "string" ? new Date(end1).getTime() : end1.getTime();
    const s2 = typeof start2 === "string" ? new Date(start2).getTime() : start2.getTime();
    const e2 = (0, $gYLUy.isInfinityDate)(end2) ? Infinity : typeof end2 === "string" ? new Date(end2).getTime() : end2.getTime();
    return s1 < e2 && e1 > s2;
}
function $38feff204bc17365$export$fa5ce5e5cf985163(placements, tripStart, tripEnd) {
    const gaps = [];
    const tStart = typeof tripStart === "string" ? new Date(tripStart) : tripStart;
    // Handle infinity trip end (base tenants) - use far future for gap calculation
    const tEnd = (0, $gYLUy.isInfinityDate)(tripEnd) ? new Date("2099-12-31T23:59:59Z") : typeof tripEnd === "string" ? new Date(tripEnd) : tripEnd;
    // Sort placements by start time
    const sorted = [
        ...placements
    ].sort((a, b)=>new Date(a.start_time).getTime() - new Date(b.start_time).getTime());
    // Check for gap at arrival
    if (sorted.length === 0 || new Date(sorted[0].start_time) > tStart) {
        const gapEnd = sorted.length > 0 ? new Date(sorted[0].start_time) : tEnd;
        gaps.push({
            start: tStart,
            end: gapEnd,
            duration: gapEnd.getTime() - tStart.getTime()
        });
    }
    // Check for gaps between placements
    for(let i = 0; i < sorted.length - 1; i++){
        // Handle infinity end_time in placements
        if ((0, $gYLUy.isInfinityDate)(sorted[i].end_time)) break;
        const currentEnd = new Date(sorted[i].end_time);
        const nextStart = new Date(sorted[i + 1].start_time);
        if (currentEnd < nextStart) gaps.push({
            start: currentEnd,
            end: nextStart,
            duration: nextStart.getTime() - currentEnd.getTime()
        });
    }
    // Check for gap at departure
    if (sorted.length > 0) {
        const lastPlacement = sorted[sorted.length - 1];
        // If last placement has infinity end_time, no gap at departure
        if (!(0, $gYLUy.isInfinityDate)(lastPlacement.end_time)) {
            const lastEnd = new Date(lastPlacement.end_time);
            if (lastEnd < tEnd) gaps.push({
                start: lastEnd,
                end: tEnd,
                duration: tEnd.getTime() - lastEnd.getTime()
            });
        }
    }
    return gaps;
}
function $38feff204bc17365$export$2039f6bed923d95d(tenants, context) {
    // Check 1: Duplicate trip IDs (existing check)
    const tripIds = tenants.map((t)=>t.trip_id).filter(Boolean);
    const uniqueTripIds = new Set(tripIds);
    if (tripIds.length !== uniqueTripIds.size) {
        const duplicateCount = tripIds.length - uniqueTripIds.size;
        const duplicateTripIds = tripIds.filter((id, index)=>tripIds.indexOf(id) !== index);
        console.warn(`\u{1F6A8} Duplicate trip_ids detected in ${context}:`, {
            totalTenants: tenants.length,
            uniqueTrips: uniqueTripIds.size,
            duplicateCount: duplicateCount,
            duplicateTripIds: duplicateTripIds,
            timestamp: new Date().toISOString()
        });
    }
    // Check 2: Duplicate placement IDs (AutoPark bug detection)
    const placementIds = tenants.map((t)=>t.placement_id).filter(Boolean);
    const uniquePlacementIds = new Set(placementIds);
    if (placementIds.length !== uniquePlacementIds.size) {
        const duplicateCount = placementIds.length - uniquePlacementIds.size;
        const duplicatePlacementIds = placementIds.filter((id, index)=>placementIds.indexOf(id) !== index);
        // Find which tenants have duplicate placement_ids
        const duplicatePlacements = [];
        duplicatePlacementIds.forEach((placementId)=>{
            const tenantsWithThisPlacement = tenants.filter((t)=>t.placement_id === placementId);
            duplicatePlacements.push({
                placementId: placementId,
                tenants: tenantsWithThisPlacement.map((t)=>({
                        tripId: t.trip_id || "unknown",
                        tailNumber: t.tail_number || "unknown"
                    }))
            });
        });
        console.error(`\u{26A0}\u{FE0F}  DUPLICATE PLACEMENT_IDS DETECTED in ${context} (AutoPark bug):`, {
            totalTenants: tenants.length,
            uniquePlacements: uniquePlacementIds.size,
            duplicateCount: duplicateCount,
            details: duplicatePlacements,
            timestamp: new Date().toISOString()
        });
        // Log each duplicate for clarity
        duplicatePlacements.forEach((dup)=>{
            console.error(`  - placement_id="${dup.placementId}" assigned to ${dup.tenants.length} trips:`, dup.tenants.map((t)=>`${t.tailNumber} (trip: ${t.tripId})`).join(", "));
        });
    }
}

});
parcelRegister("gYLUy", function(module, exports) {

$parcel$export(module.exports, "INFINITY_DATE_STRING", () => $5589d9476399db47$export$ba53acd208fd3281);
$parcel$export(module.exports, "isInfinityDate", () => $5589d9476399db47$export$ebf780e07731fb80);
$parcel$export(module.exports, "formatDepartureDate", () => $5589d9476399db47$export$2079976cabd0d3b3);
/**
 * Date Helper Utilities for Infinity Date Handling
 *
 * Provides centralized utilities for handling PostgreSQL 'infinity' timestamps
 * in the frontend. These helpers enable consistent handling of infinite departure
 * dates for base tenant trips throughout the application.
 *
 * Key Concept: PostgreSQL's 'infinity' timestamptz value is serialized as the
 * string "infinity" in JSON responses. These utilities detect and handle this
 * special value appropriately.
 */ 
var $kfA3C = parcelRequire("kfA3C");
var $7761d = parcelRequire("7761d");
const $5589d9476399db47$export$ba53acd208fd3281 = 'infinity';
function $5589d9476399db47$export$ebf780e07731fb80(date) {
    if (!date) return false;
    if (typeof date !== 'string') return false;
    // Trim whitespace and compare case-insensitively
    return date.trim().toLowerCase() === $5589d9476399db47$export$ba53acd208fd3281;
}
function $5589d9476399db47$export$e13a7a458e9c2d25(date) {
    // Handle null/undefined
    if (!date) return null;
    // Handle infinity
    if ($5589d9476399db47$export$ebf780e07731fb80(date)) return null;
    // Handle Date objects
    if (date instanceof Date) return isNaN(date.getTime()) ? null : date;
    // Parse ISO string
    try {
        const parsed = (0, $7761d.parseISO)(date);
        return isNaN(parsed.getTime()) ? null : parsed;
    } catch  {
        return null;
    }
}
function $5589d9476399db47$export$2079976cabd0d3b3(date) {
    // Handle infinity
    if ($5589d9476399db47$export$ebf780e07731fb80(date)) return 'No scheduled departure';
    // Parse the date
    const parsed = $5589d9476399db47$export$e13a7a458e9c2d25(date);
    // Handle invalid dates
    if (!parsed) return 'Invalid date';
    // Format using date-fns
    try {
        return (0, $kfA3C.format)(parsed, 'MMM d, h:mm a');
    } catch  {
        return 'Invalid date';
    }
}
function $5589d9476399db47$export$c4c806e061935577(date1, date2) {
    const is1Infinity = $5589d9476399db47$export$ebf780e07731fb80(date1);
    const is2Infinity = $5589d9476399db47$export$ebf780e07731fb80(date2);
    // Both infinity
    if (is1Infinity && is2Infinity) return 0;
    // Only date1 is infinity (larger)
    if (is1Infinity) return 1;
    // Only date2 is infinity (smaller)
    if (is2Infinity) return -1;
    // Both are finite dates - parse and compare
    const parsed1 = $5589d9476399db47$export$e13a7a458e9c2d25(date1);
    const parsed2 = $5589d9476399db47$export$e13a7a458e9c2d25(date2);
    // Handle invalid dates - throw error instead of silently treating as equal
    if (!parsed1 && !parsed2) // Both invalid - treat as equal for sorting stability
    return 0;
    if (!parsed1) throw new Error(`Invalid date string: "${date1}"`);
    if (!parsed2) throw new Error(`Invalid date string: "${date2}"`);
    const time1 = parsed1.getTime();
    const time2 = parsed2.getTime();
    if (time1 > time2) return 1;
    if (time1 < time2) return -1;
    return 0;
}

});
parcelRegister("kfA3C", function(module, exports) {

$parcel$export(module.exports, "format", () => $4d82c4193dc87874$export$d9468344d3651243);

var $alq4V = parcelRequire("alq4V");

var $gpD2R = parcelRequire("gpD2R");

var $4jr93 = parcelRequire("4jr93");

var $1DEFJ = parcelRequire("1DEFJ");

var $72JKy = parcelRequire("72JKy");

var $02AOC = parcelRequire("02AOC");

var $9Jots = parcelRequire("9Jots");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $4d82c4193dc87874$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $4d82c4193dc87874$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $4d82c4193dc87874$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $4d82c4193dc87874$var$doubleQuoteRegExp = /''/g;
const $4d82c4193dc87874$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4d82c4193dc87874$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $gpD2R.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $alq4V.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $9Jots.toDate)(date);
    if (!(0, $02AOC.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($4d82c4193dc87874$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $1DEFJ.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4d82c4193dc87874$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $4d82c4193dc87874$var$cleanEscapedString(substring)
        };
        if ((0, $4jr93.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($4d82c4193dc87874$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $72JKy.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $72JKy.isProtectedDayOfYearToken)(token)) (0, $72JKy.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $4jr93.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $4d82c4193dc87874$var$cleanEscapedString(input) {
    const matched = input.match($4d82c4193dc87874$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4d82c4193dc87874$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$4d82c4193dc87874$export$2e2bcd8739ae039 = $4d82c4193dc87874$export$d9468344d3651243;

});
parcelRegister("alq4V", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $f45f4bcf38c4ce94$export$137380d9ce54f7f);

var $jG9GD = parcelRequire("jG9GD");

var $j5K18 = parcelRequire("j5K18");

var $5FH1U = parcelRequire("5FH1U");

var $lfAyX = parcelRequire("lfAyX");

var $2Q38v = parcelRequire("2Q38v");
const $f45f4bcf38c4ce94$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $jG9GD.formatDistance),
    formatLong: (0, $j5K18.formatLong),
    formatRelative: (0, $5FH1U.formatRelative),
    localize: (0, $lfAyX.localize),
    match: (0, $2Q38v.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$f45f4bcf38c4ce94$export$2e2bcd8739ae039 = $f45f4bcf38c4ce94$export$137380d9ce54f7f;

});
parcelRegister("jG9GD", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $e53a64e8b1fa0c80$export$2c14ff85d6318973);
const $e53a64e8b1fa0c80$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $e53a64e8b1fa0c80$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $e53a64e8b1fa0c80$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("j5K18", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $6c77c8df84810c56$export$cbf60ecb96cbb82f);

var $nFdTs = parcelRequire("nFdTs");
const $6c77c8df84810c56$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $6c77c8df84810c56$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $6c77c8df84810c56$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6c77c8df84810c56$export$cbf60ecb96cbb82f = {
    date: (0, $nFdTs.buildFormatLongFn)({
        formats: $6c77c8df84810c56$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $nFdTs.buildFormatLongFn)({
        formats: $6c77c8df84810c56$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $nFdTs.buildFormatLongFn)({
        formats: $6c77c8df84810c56$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("nFdTs", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $82aa69c14702147f$export$38e44e97ce4dbb7d);
function $82aa69c14702147f$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("5FH1U", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $1fab2cf05b8cccda$export$8fbbfd65594f46a0);
const $1fab2cf05b8cccda$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $1fab2cf05b8cccda$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$1fab2cf05b8cccda$var$formatRelativeLocale[token];

});

parcelRegister("lfAyX", function(module, exports) {

$parcel$export(module.exports, "localize", () => $54b33a47c5274498$export$b3bd0bc58e36cd63);

var $1IpIt = parcelRequire("1IpIt");
const $54b33a47c5274498$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $54b33a47c5274498$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $54b33a47c5274498$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $54b33a47c5274498$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $54b33a47c5274498$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $54b33a47c5274498$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $54b33a47c5274498$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $54b33a47c5274498$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $54b33a47c5274498$var$ordinalNumber,
    era: (0, $1IpIt.buildLocalizeFn)({
        values: $54b33a47c5274498$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $1IpIt.buildLocalizeFn)({
        values: $54b33a47c5274498$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $1IpIt.buildLocalizeFn)({
        values: $54b33a47c5274498$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $1IpIt.buildLocalizeFn)({
        values: $54b33a47c5274498$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $1IpIt.buildLocalizeFn)({
        values: $54b33a47c5274498$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $54b33a47c5274498$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("1IpIt", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $b12404f6dcad3401$export$63596d6ee8878b25);
/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $b12404f6dcad3401$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("2Q38v", function(module, exports) {

$parcel$export(module.exports, "match", () => $6a38ab3f2b32c4bb$export$4659b591c19bdf3d);

var $5ul3l = parcelRequire("5ul3l");

var $i7lbf = parcelRequire("i7lbf");
const $6a38ab3f2b32c4bb$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $6a38ab3f2b32c4bb$var$parseOrdinalNumberPattern = /\d+/i;
const $6a38ab3f2b32c4bb$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $6a38ab3f2b32c4bb$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $6a38ab3f2b32c4bb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $6a38ab3f2b32c4bb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $6a38ab3f2b32c4bb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $6a38ab3f2b32c4bb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $6a38ab3f2b32c4bb$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $i7lbf.buildMatchPatternFn)({
        matchPattern: $6a38ab3f2b32c4bb$var$matchOrdinalNumberPattern,
        parsePattern: $6a38ab3f2b32c4bb$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $5ul3l.buildMatchFn)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $5ul3l.buildMatchFn)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $5ul3l.buildMatchFn)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $5ul3l.buildMatchFn)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $5ul3l.buildMatchFn)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("5ul3l", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $89a828c41b7e1bc3$export$1430a0f35710914d);
function $89a828c41b7e1bc3$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $89a828c41b7e1bc3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $89a828c41b7e1bc3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $89a828c41b7e1bc3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $89a828c41b7e1bc3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("i7lbf", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95);
function $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("gpD2R", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $6525066f50a2904f$export$430a3269e24b912e);
let $6525066f50a2904f$var$defaultOptions = {};
function $6525066f50a2904f$export$430a3269e24b912e() {
    return $6525066f50a2904f$var$defaultOptions;
}
function $6525066f50a2904f$export$95365be1b0704abc(newOptions) {
    $6525066f50a2904f$var$defaultOptions = newOptions;
}

});

parcelRegister("4jr93", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $2733e62ab452f32f$export$fe98a034cfb96d55);

var $7ZZX2 = parcelRequire("7ZZX2");

var $evs2S = parcelRequire("evs2S");

var $f3wXN = parcelRequire("f3wXN");

var $rHu8c = parcelRequire("rHu8c");

var $d1X2c = parcelRequire("d1X2c");

var $gB1dK = parcelRequire("gB1dK");

var $321Wc = parcelRequire("321Wc");
const $2733e62ab452f32f$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $2733e62ab452f32f$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $321Wc.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $d1X2c.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $gB1dK.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $gB1dK.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $f3wXN.getISOWeekYear)(date);
        // Padding
        return (0, $gB1dK.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $gB1dK.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $gB1dK.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $gB1dK.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $321Wc.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $gB1dK.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $rHu8c.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $gB1dK.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $evs2S.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $gB1dK.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $321Wc.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $7ZZX2.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $gB1dK.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $gB1dK.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $gB1dK.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $gB1dK.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $321Wc.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $321Wc.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $gB1dK.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $gB1dK.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $321Wc.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $321Wc.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $321Wc.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $2733e62ab452f32f$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $2733e62ab452f32f$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $gB1dK.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $gB1dK.addLeadingZeros)(timestamp, token.length);
    }
};
function $2733e62ab452f32f$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $gB1dK.addLeadingZeros)(minutes, 2);
}
function $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $gB1dK.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $2733e62ab452f32f$var$formatTimezone(offset, delimiter);
}
function $2733e62ab452f32f$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $gB1dK.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $gB1dK.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("7ZZX2", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $4312ea6469709b9b$export$d3b42cd8452deec);

var $j6qpa = parcelRequire("j6qpa");

var $kwkuf = parcelRequire("kwkuf");

var $9Jots = parcelRequire("9Jots");
function $4312ea6469709b9b$export$d3b42cd8452deec(date) {
    const _date = (0, $9Jots.toDate)(date);
    const diff = (0, $j6qpa.differenceInCalendarDays)(_date, (0, $kwkuf.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$4312ea6469709b9b$export$2e2bcd8739ae039 = $4312ea6469709b9b$export$d3b42cd8452deec;

});
parcelRegister("j6qpa", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $30481ff49751e85f$export$4a02e9c37dab4871);

var $klgYS = parcelRequire("klgYS");

var $g04kv = parcelRequire("g04kv");

var $7MGTI = parcelRequire("7MGTI");
function $30481ff49751e85f$export$4a02e9c37dab4871(dateLeft, dateRight) {
    const startOfDayLeft = (0, $g04kv.startOfDay)(dateLeft);
    const startOfDayRight = (0, $g04kv.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $7MGTI.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $7MGTI.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, $klgYS.millisecondsInDay));
}
var // Fallback for modularized imports:
$30481ff49751e85f$export$2e2bcd8739ae039 = $30481ff49751e85f$export$4a02e9c37dab4871;

});
parcelRegister("klgYS", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", () => $e24aa25ccaa7cb1c$export$4fad13613e88edc8);
$parcel$export(module.exports, "millisecondsInDay", () => $e24aa25ccaa7cb1c$export$b76b1809a2898f9a);
$parcel$export(module.exports, "millisecondsInMinute", () => $e24aa25ccaa7cb1c$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $e24aa25ccaa7cb1c$export$7f72910d6dfd237a);
$parcel$export(module.exports, "minutesInMonth", () => $e24aa25ccaa7cb1c$export$ab7da2ccd1075c38);
$parcel$export(module.exports, "minutesInDay", () => $e24aa25ccaa7cb1c$export$2423174df8cd3cd2);
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $e24aa25ccaa7cb1c$export$dfd9b671c89acc8e = 7;
const $e24aa25ccaa7cb1c$export$3913210603d8e9ae = 365.2425;
const $e24aa25ccaa7cb1c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $e24aa25ccaa7cb1c$export$4dec998e48f9c246 = -$e24aa25ccaa7cb1c$export$81caae6e1cc7a622;
const $e24aa25ccaa7cb1c$export$4fad13613e88edc8 = 604800000;
const $e24aa25ccaa7cb1c$export$b76b1809a2898f9a = 86400000;
const $e24aa25ccaa7cb1c$export$91246f0b9bd9beff = 60000;
const $e24aa25ccaa7cb1c$export$7f72910d6dfd237a = 3600000;
const $e24aa25ccaa7cb1c$export$397c2d5776aa9055 = 1000;
const $e24aa25ccaa7cb1c$export$3633035e63cee86a = 525600;
const $e24aa25ccaa7cb1c$export$ab7da2ccd1075c38 = 43200;
const $e24aa25ccaa7cb1c$export$2423174df8cd3cd2 = 1440;
const $e24aa25ccaa7cb1c$export$f2f5ae5a8e2d8f9f = 60;
const $e24aa25ccaa7cb1c$export$3c58128db900d44e = 3;
const $e24aa25ccaa7cb1c$export$80d7e435f744f319 = 12;
const $e24aa25ccaa7cb1c$export$4db7641526e3241f = 4;
const $e24aa25ccaa7cb1c$export$698aec755e92c695 = 3600;
const $e24aa25ccaa7cb1c$export$a77c1a7ebebe2a5a = 60;
const $e24aa25ccaa7cb1c$export$815a9362476d2fe3 = $e24aa25ccaa7cb1c$export$698aec755e92c695 * 24;
const $e24aa25ccaa7cb1c$export$34804a017b31e2fe = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * 7;
const $e24aa25ccaa7cb1c$export$7271e9e3478110d1 = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * $e24aa25ccaa7cb1c$export$3913210603d8e9ae;
const $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb = $e24aa25ccaa7cb1c$export$7271e9e3478110d1 / 12;
const $e24aa25ccaa7cb1c$export$be1dccf2de902d31 = $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb * 3;

});

parcelRegister("g04kv", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $08eadd31071dba99$export$63fa379ae8a9ba2);

var $9Jots = parcelRequire("9Jots");
function $08eadd31071dba99$export$63fa379ae8a9ba2(date) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$08eadd31071dba99$export$2e2bcd8739ae039 = $08eadd31071dba99$export$63fa379ae8a9ba2;

});
parcelRegister("9Jots", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $77dc29417ac8d032$export$e67a095c620b86fe);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $77dc29417ac8d032$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$77dc29417ac8d032$export$2e2bcd8739ae039 = $77dc29417ac8d032$export$e67a095c620b86fe;

});


parcelRegister("7MGTI", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $39c386bf2b2d4be8$export$113002b5eff6e430);

var $9Jots = parcelRequire("9Jots");
function $39c386bf2b2d4be8$export$113002b5eff6e430(date) {
    const _date = (0, $9Jots.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("kwkuf", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $acbc1d0003a51961$export$f91e89d3d0406102);

var $9Jots = parcelRequire("9Jots");

var $bXANJ = parcelRequire("bXANJ");
function $acbc1d0003a51961$export$f91e89d3d0406102(date) {
    const cleanDate = (0, $9Jots.toDate)(date);
    const _date = (0, $bXANJ.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$acbc1d0003a51961$export$2e2bcd8739ae039 = $acbc1d0003a51961$export$f91e89d3d0406102;

});
parcelRegister("bXANJ", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $9e6f0c9ad494c17a$export$ead8a1812b171991);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $9e6f0c9ad494c17a$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$9e6f0c9ad494c17a$export$2e2bcd8739ae039 = $9e6f0c9ad494c17a$export$ead8a1812b171991;

});



parcelRegister("evs2S", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $7e3321a3fdd64965$export$7cabdc5698b63e2f);

var $klgYS = parcelRequire("klgYS");

var $kW2qG = parcelRequire("kW2qG");

var $6zOE9 = parcelRequire("6zOE9");

var $9Jots = parcelRequire("9Jots");
function $7e3321a3fdd64965$export$7cabdc5698b63e2f(date) {
    const _date = (0, $9Jots.toDate)(date);
    const diff = +(0, $kW2qG.startOfISOWeek)(_date) - +(0, $6zOE9.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $klgYS.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$7e3321a3fdd64965$export$2e2bcd8739ae039 = $7e3321a3fdd64965$export$7cabdc5698b63e2f;

});
parcelRegister("kW2qG", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $80ab7b76dc31fb87$export$6173213f95a4431e);

var $hRsar = parcelRequire("hRsar");
function $80ab7b76dc31fb87$export$6173213f95a4431e(date) {
    return (0, $hRsar.startOfWeek)(date, {
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$80ab7b76dc31fb87$export$2e2bcd8739ae039 = $80ab7b76dc31fb87$export$6173213f95a4431e;

});
parcelRegister("hRsar", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $a6b650558c0d274a$export$42c81a444fbfb5d4);

var $9Jots = parcelRequire("9Jots");

var $gpD2R = parcelRequire("gpD2R");
function $a6b650558c0d274a$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $gpD2R.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $9Jots.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$a6b650558c0d274a$export$2e2bcd8739ae039 = $a6b650558c0d274a$export$42c81a444fbfb5d4;

});


parcelRegister("6zOE9", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $00ea35cfe8164ea9$export$236bdfa374eb69a9);

var $f3wXN = parcelRequire("f3wXN");

var $kW2qG = parcelRequire("kW2qG");

var $bXANJ = parcelRequire("bXANJ");
function $00ea35cfe8164ea9$export$236bdfa374eb69a9(date) {
    const year = (0, $f3wXN.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $bXANJ.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $kW2qG.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$00ea35cfe8164ea9$export$2e2bcd8739ae039 = $00ea35cfe8164ea9$export$236bdfa374eb69a9;

});
parcelRegister("f3wXN", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc);

var $bXANJ = parcelRequire("bXANJ");

var $kW2qG = parcelRequire("kW2qG");

var $9Jots = parcelRequire("9Jots");
function $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc(date) {
    const _date = (0, $9Jots.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $bXANJ.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $kW2qG.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $bXANJ.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $kW2qG.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$a5b0ea7a35e081a3$export$2e2bcd8739ae039 = $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc;

});



parcelRegister("rHu8c", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $ea960e7aff37061d$export$efe19b760242b2fc);

var $klgYS = parcelRequire("klgYS");

var $hRsar = parcelRequire("hRsar");

var $8i5S3 = parcelRequire("8i5S3");

var $9Jots = parcelRequire("9Jots");
function $ea960e7aff37061d$export$efe19b760242b2fc(date, options) {
    const _date = (0, $9Jots.toDate)(date);
    const diff = +(0, $hRsar.startOfWeek)(_date, options) - +(0, $8i5S3.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $klgYS.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$ea960e7aff37061d$export$2e2bcd8739ae039 = $ea960e7aff37061d$export$efe19b760242b2fc;

});
parcelRegister("8i5S3", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $ef995389f8e20dbc$export$bb7b45bb8e74da0f);

var $bXANJ = parcelRequire("bXANJ");

var $d1X2c = parcelRequire("d1X2c");

var $hRsar = parcelRequire("hRsar");

var $gpD2R = parcelRequire("gpD2R");
function $ef995389f8e20dbc$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $gpD2R.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $d1X2c.getWeekYear)(date, options);
    const firstWeek = (0, $bXANJ.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $hRsar.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$ef995389f8e20dbc$export$2e2bcd8739ae039 = $ef995389f8e20dbc$export$bb7b45bb8e74da0f;

});
parcelRegister("d1X2c", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $2a4c9a3ae7bb29a5$export$12d572480ceb6e58);

var $bXANJ = parcelRequire("bXANJ");

var $hRsar = parcelRequire("hRsar");

var $9Jots = parcelRequire("9Jots");

var $gpD2R = parcelRequire("gpD2R");
function $2a4c9a3ae7bb29a5$export$12d572480ceb6e58(date, options) {
    const _date = (0, $9Jots.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $gpD2R.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $bXANJ.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $hRsar.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $bXANJ.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $hRsar.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$2a4c9a3ae7bb29a5$export$2e2bcd8739ae039 = $2a4c9a3ae7bb29a5$export$12d572480ceb6e58;

});



parcelRegister("gB1dK", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $3f6840376f7c8255$export$c8306e720e213c0f);
function $3f6840376f7c8255$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("321Wc", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $aed2876e10bb3b8a$export$b0d4b338e1516f13);

var $gB1dK = parcelRequire("gB1dK");
const $aed2876e10bb3b8a$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $gB1dK.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $gB1dK.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $gB1dK.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $gB1dK.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $gB1dK.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $gB1dK.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $gB1dK.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $gB1dK.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("1DEFJ", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $3d9918f67aabe98a$export$70cc8fd02856fd58);
const $3d9918f67aabe98a$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $3d9918f67aabe98a$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $3d9918f67aabe98a$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $3d9918f67aabe98a$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3d9918f67aabe98a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3d9918f67aabe98a$var$timeLongFormatter(timePattern, formatLong));
};
const $3d9918f67aabe98a$export$70cc8fd02856fd58 = {
    p: $3d9918f67aabe98a$var$timeLongFormatter,
    P: $3d9918f67aabe98a$var$dateTimeLongFormatter
};

});

parcelRegister("72JKy", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $8680c08594a744bc$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $8680c08594a744bc$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $8680c08594a744bc$export$f5f38f90ecaaf879);
const $8680c08594a744bc$var$dayOfYearTokenRE = /^D+$/;
const $8680c08594a744bc$var$weekYearTokenRE = /^Y+$/;
const $8680c08594a744bc$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $8680c08594a744bc$export$c6cc36aa33304772(token) {
    return $8680c08594a744bc$var$dayOfYearTokenRE.test(token);
}
function $8680c08594a744bc$export$c6b49d6dceb604a1(token) {
    return $8680c08594a744bc$var$weekYearTokenRE.test(token);
}
function $8680c08594a744bc$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $8680c08594a744bc$var$message(token, format, input);
    console.warn(_message);
    if ($8680c08594a744bc$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $8680c08594a744bc$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("02AOC", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $ae5dedc3e6bc7894$export$1ea939691cdc45b8);

var $6B4a6 = parcelRequire("6B4a6");

var $9Jots = parcelRequire("9Jots");
function $ae5dedc3e6bc7894$export$1ea939691cdc45b8(date) {
    if (!(0, $6B4a6.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $9Jots.toDate)(date);
    return !isNaN(Number(_date));
}
var // Fallback for modularized imports:
$ae5dedc3e6bc7894$export$2e2bcd8739ae039 = $ae5dedc3e6bc7894$export$1ea939691cdc45b8;

});
parcelRegister("6B4a6", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $ccbd6968dbb36c3b$export$871608497c498473);
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $ccbd6968dbb36c3b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$ccbd6968dbb36c3b$export$2e2bcd8739ae039 = $ccbd6968dbb36c3b$export$871608497c498473;

});



parcelRegister("7761d", function(module, exports) {

$parcel$export(module.exports, "parseISO", () => $b2d0c66f58a40ae9$export$4393d2ccbbedb219);

var $klgYS = parcelRequire("klgYS");
function $b2d0c66f58a40ae9$export$4393d2ccbbedb219(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $b2d0c66f58a40ae9$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $b2d0c66f58a40ae9$var$parseYear(dateStrings.date, additionalDigits);
        date = $b2d0c66f58a40ae9$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $b2d0c66f58a40ae9$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $b2d0c66f58a40ae9$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $b2d0c66f58a40ae9$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $b2d0c66f58a40ae9$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $b2d0c66f58a40ae9$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $b2d0c66f58a40ae9$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $b2d0c66f58a40ae9$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($b2d0c66f58a40ae9$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($b2d0c66f58a40ae9$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($b2d0c66f58a40ae9$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $b2d0c66f58a40ae9$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b2d0c66f58a40ae9$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $b2d0c66f58a40ae9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($b2d0c66f58a40ae9$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $b2d0c66f58a40ae9$var$parseDateUnit(captures[1]);
    const month = $b2d0c66f58a40ae9$var$parseDateUnit(captures[2]) - 1;
    const day = $b2d0c66f58a40ae9$var$parseDateUnit(captures[3]);
    const week = $b2d0c66f58a40ae9$var$parseDateUnit(captures[4]);
    const dayOfWeek = $b2d0c66f58a40ae9$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$b2d0c66f58a40ae9$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b2d0c66f58a40ae9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$b2d0c66f58a40ae9$var$validateDate(year, month, day) || !$b2d0c66f58a40ae9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $b2d0c66f58a40ae9$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $b2d0c66f58a40ae9$var$parseTime(timeString) {
    const captures = timeString.match($b2d0c66f58a40ae9$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[1]);
    const minutes = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[2]);
    const seconds = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[3]);
    if (!$b2d0c66f58a40ae9$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $klgYS.millisecondsInHour) + minutes * (0, $klgYS.millisecondsInMinute) + seconds * 1000;
}
function $b2d0c66f58a40ae9$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $b2d0c66f58a40ae9$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($b2d0c66f58a40ae9$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$b2d0c66f58a40ae9$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $klgYS.millisecondsInHour) + minutes * (0, $klgYS.millisecondsInMinute));
}
function $b2d0c66f58a40ae9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $b2d0c66f58a40ae9$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b2d0c66f58a40ae9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b2d0c66f58a40ae9$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($b2d0c66f58a40ae9$var$daysInMonths[month] || ($b2d0c66f58a40ae9$var$isLeapYearIndex(year) ? 29 : 28));
}
function $b2d0c66f58a40ae9$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($b2d0c66f58a40ae9$var$isLeapYearIndex(year) ? 366 : 365);
}
function $b2d0c66f58a40ae9$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $b2d0c66f58a40ae9$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $b2d0c66f58a40ae9$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$b2d0c66f58a40ae9$export$2e2bcd8739ae039 = $b2d0c66f58a40ae9$export$4393d2ccbbedb219;

});



parcelRegister("78CAK", function(module, exports) {

$parcel$export(module.exports, "CustomStackForm", () => $62d49c118b5a9df4$export$bfb7960e473b6027);
$parcel$export(module.exports, "CustomStackDialog", () => $62d49c118b5a9df4$export$4178db7668e29b33);
$parcel$export(module.exports, "defaultCustomPlacementOptions", () => $62d49c118b5a9df4$export$2a6844326415216a);

var $ayMG0 = parcelRequire("ayMG0");

var $ex6lH = parcelRequire("ex6lH");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $6ami2 = parcelRequire("6ami2");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $2esSG = parcelRequire("2esSG");
var $hViLc = parcelRequire("hViLc");
var $19ocJ = parcelRequire("19ocJ");
var $2iAqv = parcelRequire("2iAqv");
var $imehR = parcelRequire("imehR");
var $cX7V2 = parcelRequire("cX7V2");
var $jU0bc = parcelRequire("jU0bc");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $6AlVH = parcelRequire("6AlVH");

var $gZQV9 = parcelRequire("gZQV9");

var $keHtM = parcelRequire("keHtM");
parcelRequire("aYEL3");
var $1nUr4 = parcelRequire("1nUr4");
const $62d49c118b5a9df4$export$bfb7960e473b6027 = ({ customPlacementOptions: customPlacementOptions, setCustomPlacementOptions: setCustomPlacementOptions, minimal: minimal = false, isDev: isDev = false })=>{
    const [ignoreTowingEquipment, setIgnoreTowingEquipment] = $acw62.useState(false);
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hangar: hangar } = (0, $gZQV9.useThisHangar)();
    const { towingEquipments: allTowingEquipments } = (0, $6AlVH.useTowingEquipmentState)();
    const towingEquipments = allTowingEquipments.filter((t)=>t.in_use);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        textAlign: "center",
                        children: "Spacing SOP"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Override SOPs. These will default to the SOPs set for your FBO.",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1nUr4.BorderedBox), {
                sx: {
                    border: minimal && "none",
                    p: minimal && 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                size: "small",
                                type: "number",
                                fullWidth: true,
                                inputProps: {
                                    min: 0,
                                    max: 20
                                },
                                onChange: (evt)=>setCustomPlacementOptions({
                                        ...customPlacementOptions,
                                        horizontal_spacing: parseFloat(evt.target.value)
                                    }),
                                value: customPlacementOptions.horizontal_spacing || 0,
                                label: "Horizontal (ft)",
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            size: "small",
                                            label: `${activeFBO?.sop_horizontal_spacing} ft`
                                        })
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                size: "small",
                                type: "number",
                                fullWidth: true,
                                inputProps: {
                                    min: 0,
                                    max: 20
                                },
                                onChange: (evt)=>setCustomPlacementOptions({
                                        ...customPlacementOptions,
                                        vertical_spacing: parseFloat(evt.target.value)
                                    }),
                                value: customPlacementOptions.vertical_spacing || 0,
                                label: "Vertical (ft)",
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            size: "small",
                                            label: `${activeFBO?.sop_vertical_spacing} ft`
                                        })
                                    })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                size: "small",
                                type: "number",
                                fullWidth: true,
                                inputProps: {
                                    min: 0,
                                    max: 12
                                },
                                onChange: (evt)=>setCustomPlacementOptions({
                                        ...customPlacementOptions,
                                        wall_spacing_left: parseFloat(evt.target.value)
                                    }),
                                value: customPlacementOptions.wall_spacing_left || 0,
                                label: "Left Wall (ft)",
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            size: "small",
                                            label: `${hangar?.wall_spacing_left ?? 0} ft`
                                        })
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                size: "small",
                                type: "number",
                                fullWidth: true,
                                inputProps: {
                                    min: 0,
                                    max: 12
                                },
                                onChange: (evt)=>setCustomPlacementOptions({
                                        ...customPlacementOptions,
                                        wall_spacing_back: parseFloat(evt.target.value)
                                    }),
                                value: customPlacementOptions.wall_spacing_back || 0,
                                label: "Back Wall (ft)",
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            size: "small",
                                            label: `${hangar?.wall_spacing_back ?? 0} ft`
                                        })
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                size: "small",
                                type: "number",
                                fullWidth: true,
                                inputProps: {
                                    min: 0,
                                    max: 20
                                },
                                onChange: (evt)=>setCustomPlacementOptions({
                                        ...customPlacementOptions,
                                        wall_spacing_right: parseFloat(evt.target.value)
                                    }),
                                value: customPlacementOptions.wall_spacing_right || 0,
                                label: "Right Wall (ft)",
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            size: "small",
                                            label: `${hangar?.wall_spacing_right ?? 0} ft`
                                        })
                                    })
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                size: "small",
                                disabled: ignoreTowingEquipment,
                                select: true,
                                fullWidth: true,
                                label: "Towing Equipment For Stack",
                                value: customPlacementOptions.towing_equipment_id,
                                onChange: (evt)=>{
                                    setCustomPlacementOptions({
                                        ...customPlacementOptions,
                                        towing_equipment_id: evt.target.value
                                    });
                                },
                                children: towingEquipments?.map((towingEquipment)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        value: towingEquipment.towing_equipment_id,
                                        children: towingEquipment.name
                                    }, `towing-equipment-select-${towingEquipment.towing_equipment_id}`))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    checked: ignoreTowingEquipment
                                }),
                                onChange: ()=>{
                                    setIgnoreTowingEquipment(!ignoreTowingEquipment);
                                    setCustomPlacementOptions({
                                        ...customPlacementOptions,
                                        towing_equipment_id: null
                                    });
                                },
                                label: "Ignore?"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        textAlign: "center",
                        children: "Preferences"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Customize your stacking preferences. These will apply to every aircraft.",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1nUr4.BorderedBox), {
                        sx: {
                            border: minimal && "none",
                            p: minimal && 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            children: "Allow Overlap"
                                        }),
                                        !minimal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "info.dark",
                                            children: "Allow the algorithm to overlap planes."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    checked: customPlacementOptions.overlap,
                                    onChange: (evt)=>setCustomPlacementOptions({
                                            ...customPlacementOptions,
                                            overlap: evt.target.checked
                                        })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1nUr4.BorderedBox), {
                        sx: {
                            border: minimal && "none",
                            p: minimal && 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            children: "Ignore Nose In/Out Preferences"
                                        }),
                                        !minimal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "info.dark",
                                            children: "Allow the algorithm to use your towing orientation preferences."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    checked: customPlacementOptions.ignore_nose_in_out,
                                    onChange: (evt)=>setCustomPlacementOptions({
                                            ...customPlacementOptions,
                                            ignore_nose_in_out: evt.target.checked
                                        })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1nUr4.BorderedBox), {
                        sx: {
                            border: minimal && "none",
                            p: minimal && 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            children: "Ignore Front/Back Preferences"
                                        }),
                                        !minimal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "info.dark",
                                            children: "Allow the algorithm to use your front or back row preference."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    checked: customPlacementOptions.ignore_front_back,
                                    onChange: (evt)=>setCustomPlacementOptions({
                                            ...customPlacementOptions,
                                            ignore_front_back: evt.target.checked
                                        })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1nUr4.BorderedBox), {
                        sx: {
                            border: minimal && "none",
                            p: minimal && 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            children: "Ignore Allow Outside Hangar Preferences"
                                        }),
                                        !minimal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "info.dark",
                                            children: 'Allow the algorithm to consider your "ok to leave out" preferences.'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    checked: customPlacementOptions.ignore_outside_hangar,
                                    onChange: (evt)=>setCustomPlacementOptions({
                                            ...customPlacementOptions,
                                            ignore_outside_hangar: evt.target.checked
                                        })
                                })
                            ]
                        })
                    }),
                    isDev && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1nUr4.BorderedBox), {
                                sx: {
                                    border: minimal && "none",
                                    p: minimal && 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    children: "Use Cloud Position Prioritization"
                                                }),
                                                !minimal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    color: "info.dark",
                                                    children: 'Uses "Cloud" (ConvexHull) position prioritization to determine which positions to evaluate.'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                            checked: customPlacementOptions.cloud_position_prioritization,
                                            onChange: (evt)=>setCustomPlacementOptions({
                                                    ...customPlacementOptions,
                                                    cloud_position_prioritization: evt.target.checked
                                                })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1nUr4.BorderedBox), {
                                sx: {
                                    border: minimal && "none",
                                    p: minimal && 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            children: "Sample Size"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            size: "small",
                                            type: "number",
                                            fullWidth: true,
                                            inputProps: {
                                                min: 100,
                                                max: 1e9,
                                                step: 100
                                            },
                                            onChange: (evt)=>setCustomPlacementOptions({
                                                    ...customPlacementOptions,
                                                    sample_size: parseFloat(evt.target.value)
                                                }),
                                            value: customPlacementOptions.sample_size || 1000,
                                            label: "Sample Size"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        children: "Corner Strategy"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cX7V2.default), {
                                        multiple: true,
                                        value: customPlacementOptions.corner_strategies,
                                        onChange: (evt)=>setCustomPlacementOptions({
                                                ...customPlacementOptions,
                                                corner_strategies: evt.target.value
                                            }),
                                        input: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $imehR.default), {
                                            size: "small"
                                        }),
                                        renderValue: (selected)=>selected.map((s)=>`[${s.join(", ")}]`).join(", "),
                                        children: (0, $keHtM.CornerStrategies).map((strategy)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                                value: strategy,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                        checked: customPlacementOptions.corner_strategies.indexOf(strategy) > -1
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                                        primary: strategy.join(", ")
                                                    })
                                                ]
                                            }, JSON.stringify(strategy)))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        children: "XY Weights"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                size: "small",
                                                type: "number",
                                                inputProps: {
                                                    min: 0,
                                                    max: 3,
                                                    step: 0.1
                                                },
                                                onChange: (evt)=>setCustomPlacementOptions({
                                                        ...customPlacementOptions,
                                                        xy_weights: [
                                                            parseFloat(evt.target.value),
                                                            customPlacementOptions.xy_weights[1]
                                                        ]
                                                    }),
                                                value: customPlacementOptions.xy_weights[0] || 1,
                                                label: "X"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                size: "small",
                                                type: "number",
                                                inputProps: {
                                                    min: 0,
                                                    max: 3,
                                                    step: 0.1
                                                },
                                                onChange: (evt)=>setCustomPlacementOptions({
                                                        ...customPlacementOptions,
                                                        xy_weights: [
                                                            customPlacementOptions.xy_weights[0],
                                                            parseFloat(evt.target.value)
                                                        ]
                                                    }),
                                                value: customPlacementOptions.xy_weights[1] || 1,
                                                label: "Y"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                sx: {
                                    pl: 2,
                                    width: "80%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "caption",
                                        children: "3D Density Threshold"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jU0bc.default), {
                                        valueLabelDisplay: "auto",
                                        min: 0,
                                        max: 1,
                                        step: 0.1,
                                        valueLabelFormat: (value)=>`${value * 100}%`,
                                        marks: [
                                            {
                                                value: 0,
                                                label: "0%"
                                            },
                                            {
                                                value: 0.5,
                                                label: "50%"
                                            },
                                            {
                                                value: 1,
                                                label: "100%"
                                            }
                                        ],
                                        onChange: (_, newValue)=>setCustomPlacementOptions({
                                                ...customPlacementOptions,
                                                density_threshold: newValue
                                            }),
                                        value: customPlacementOptions.density_threshold
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $62d49c118b5a9df4$export$4178db7668e29b33 = ({ onClickRunStack: onClickRunStack, onClose: onClose, isDev: isDev = false })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [open, setOpen] = $acw62.useState(true);
    const [customPlacementOptions, setCustomPlacementOptions] = $acw62.useState($62d49c118b5a9df4$export$2a6844326415216a(activeFBO, null));
    const handleClose = ()=>{
        onClose();
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
            open: open,
            onClose: handleClose,
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                    children: "Customize your Stack"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                    sx: {
                        width: 550
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($62d49c118b5a9df4$export$bfb7960e473b6027, {
                        isDev: isDev,
                        customPlacementOptions: customPlacementOptions,
                        setCustomPlacementOptions: setCustomPlacementOptions
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: handleClose,
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                flex: "1 0 0"
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            color: "success",
                            onClick: ()=>{
                                onClickRunStack(customPlacementOptions);
                            },
                            children: "Run Stack"
                        })
                    ]
                })
            ]
        })
    });
};
const $62d49c118b5a9df4$export$2a6844326415216a = (activeFBO, hangar)=>{
    if (!activeFBO) return {
        horizontal_spacing: 2,
        vertical_spacing: 2,
        wall_spacing_left: 2,
        wall_spacing_back: 2,
        wall_spacing_right: 2,
        overlap: false,
        ignore_nose_in_out: false,
        ignore_front_back: false,
        ignore_outside_hangar: false,
        density_threshold: 0.8,
        sample_size: 1000,
        corner_strategies: (0, $keHtM.CornerStrategies),
        cloud_position_prioritization: true,
        xy_weights: [
            1,
            2
        ],
        towing_equipment_id: null
    };
    return {
        horizontal_spacing: activeFBO.sop_horizontal_spacing ?? 2,
        vertical_spacing: activeFBO.sop_vertical_spacing ?? 2,
        wall_spacing_left: hangar?.wall_spacing_left ?? 2,
        wall_spacing_back: hangar?.wall_spacing_back ?? 2,
        wall_spacing_right: hangar?.wall_spacing_right ?? 2,
        overlap: activeFBO.sop_overlap ?? false,
        ignore_nose_in_out: false,
        ignore_front_back: false,
        ignore_outside_hangar: false,
        density_threshold: 0.8,
        sample_size: 1000,
        corner_strategies: (0, $keHtM.CornerStrategies),
        cloud_position_prioritization: true,
        xy_weights: [
            1,
            2
        ],
        towing_equipment_id: null
    };
};

});
parcelRegister("1Aijw", function(module, exports) {

$parcel$export(module.exports, "default", () => $12775c00f473d955$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $kVqvD = parcelRequire("kVqvD");

var $1yHUZ = parcelRequire("1yHUZ");

var $etWmn = parcelRequire("etWmn");

var $2rW38 = parcelRequire("2rW38");

var $jTnBY = parcelRequire("jTnBY");

var $8Uq77 = parcelRequire("8Uq77");

var $9s7Sp = parcelRequire("9s7Sp");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $f8X1n = parcelRequire("f8X1n");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9s7Sp.getCheckboxUtilityClass), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $12775c00f473d955$var$CheckboxRoot = (0, $d8seH.default)((0, $kVqvD.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $9s7Sp.default).checked}, &.${(0, $9s7Sp.default).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $9s7Sp.default).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $etWmn.default), {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1yHUZ.default), {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2rW38.default), {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $12775c00f473d955$var$CheckboxRoot,
        className: (0, $9QePP.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $f8X1n.default)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $12775c00f473d955$export$2e2bcd8739ae039 = $12775c00f473d955$var$Checkbox;

});
parcelRegister("kVqvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bdb1b636c81735$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $3yddg = parcelRequire("3yddg");

var $cJQfW = parcelRequire("cJQfW");

var $6n0Ko = parcelRequire("6n0Ko");

var $bxhip = parcelRequire("bxhip");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $jTnBY.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bxhip.getSwitchBaseUtilityClass), classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $d8seH.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $8Uq77.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $3yddg.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $cJQfW.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $f3bdb1b636c81735$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $6lpak.default)('input', {
        ref: inputRef,
        elementType: $f3bdb1b636c81735$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $f3bdb1b636c81735$export$2e2bcd8739ae039 = $f3bdb1b636c81735$var$SwitchBase;

});
parcelRegister("bxhip", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", () => $86603163591f910a$export$baa0faa0c7ad8085);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $86603163591f910a$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)('PrivateSwitchBase', slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $beCSm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $86603163591f910a$export$2e2bcd8739ae039 = $86603163591f910a$var$switchBaseClasses;

});


parcelRegister("1yHUZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $122b08a8ae2faae5$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $122b08a8ae2faae5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("etWmn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b10b2b5aaa8e54$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $a8b10b2b5aaa8e54$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("2rW38", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8b21cdbf539e4f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $1c8b21cdbf539e4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("9s7Sp", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", () => $6e1cd6b997bc70d3$export$6c57c6e16b4063b);
$parcel$export(module.exports, "default", () => $6e1cd6b997bc70d3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e1cd6b997bc70d3$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $beCSm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$export$2e2bcd8739ae039 = $6e1cd6b997bc70d3$var$checkboxClasses;

});


parcelRegister("2esSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a034abd43bd8eee$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $3bYfT = parcelRequire("3bYfT");

var $jTnBY = parcelRequire("jTnBY");

var $7Z1x5 = parcelRequire("7Z1x5");

var $aaphR = parcelRequire("aaphR");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7Z1x5.getFormControlLabelUtilityClasses), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7Z1x5.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $7Z1x5.default).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $7Z1x5.default).label}`]: {
            [`&.${(0, $7Z1x5.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $aeD7H.default)(({ theme: theme })=>({
        [`&.${(0, $7Z1x5.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $6lpak.default)('typography', {
        elementType: (0, $3bYfT.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $3bYfT.default) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $9QePP.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;

});
parcelRegister("7Z1x5", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", () => $5cff6b4166fff27c$export$717666c39ec07e12);
$parcel$export(module.exports, "default", () => $5cff6b4166fff27c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $beCSm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;

});


parcelRegister("19ocJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d696835f9b43a35$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $3bYfT = parcelRequire("3bYfT");
var $bhKtZ = parcelRequire("bhKtZ");

var $3W6ht = parcelRequire("3W6ht");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $guz4p = parcelRequire("guz4p");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $guz4p.getListItemTextUtilityClass), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $guz4p.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $guz4p.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $bhKtZ.default).root}:where(& .${(0, $guz4p.default).primary})`]: {
        display: 'block'
    },
    [`.${(0, $bhKtZ.default).root}:where(& .${(0, $guz4p.default).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $acw62.useContext((0, $3W6ht.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $0d696835f9b43a35$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $6lpak.default)('primary', {
        className: classes.primary,
        elementType: (0, $3bYfT.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $6lpak.default)('secondary', {
        className: classes.secondary,
        elementType: (0, $3bYfT.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $3bYfT.default) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $3bYfT.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;

});

parcelRegister("jU0bc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d362f04a4204f3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $bJeVA = parcelRequire("bJeVA");

var $eD6Co = parcelRequire("eD6Co");

var $dBUOG = parcelRequire("dBUOG");

var $c1jOg = parcelRequire("c1jOg");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $PJRTc = parcelRequire("PJRTc");

var $lTbyd = parcelRequire("lTbyd");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $2xkal = parcelRequire("2xkal");

var $20dvU = parcelRequire("20dvU");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $e7d362f04a4204f3$var$Identity(x) {
    return x;
}
const $e7d362f04a4204f3$export$c1a21b3b4da66aa1 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $20dvU.default).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $20dvU.default).dragging}`]: {
            [`& .${(0, $20dvU.default).thumb}, & .${(0, $20dvU.default).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $e7d362f04a4204f3$export$b02fde61a3559c2 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $e7d362f04a4204f3$export$105594979f116971 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $aeD7H.default)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: (0, $8gMkr.lighten)(theme.palette[color].main, 0.62),
                            borderColor: (0, $8gMkr.lighten)(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: (0, $8gMkr.darken)(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: (0, $8gMkr.darken)(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $e7d362f04a4204f3$export$2c1b491743890dec = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $20dvU.default).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $20dvU.default).focusVisible}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 8px ${(0, $8gMkr.alpha)(theme.palette[color].main, 0.16)}`
                            },
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${(0, $20dvU.default).active}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 14px ${(0, $8gMkr.alpha)(theme.palette[color].main, 0.16)}`
                            }
                        }
                    }
                }))
        ]
    })));
const $e7d362f04a4204f3$export$6453176f504d54f0 = (0, $d8seH.default)((0, $2xkal.default), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})((0, $aeD7H.default)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $20dvU.default).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $20dvU.default).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $e7d362f04a4204f3$export$6f85f6a3c5da6f62 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $e7d362f04a4204f3$export$e6cd369965e5aa95 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $jTnBY.default)(color)}`,
            size && `size${(0, $jTnBY.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $jTnBY.default)(size)}`,
            color && `thumbColor${(0, $jTnBY.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $20dvU.getSliderUtilityClass), classes);
};
const $e7d362f04a4204f3$var$Forward = ({ children: children })=>children;
const $e7d362f04a4204f3$var$Slider = /*#__PURE__*/ $acw62.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $bJeVA.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $e7d362f04a4204f3$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $e7d362f04a4204f3$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $dBUOG.useSlider)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $e7d362f04a4204f3$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $e7d362f04a4204f3$export$c1a21b3b4da66aa1;
    const RailSlot = slots?.rail ?? components.Rail ?? $e7d362f04a4204f3$export$b02fde61a3559c2;
    const TrackSlot = slots?.track ?? components.Track ?? $e7d362f04a4204f3$export$105594979f116971;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $e7d362f04a4204f3$export$2c1b491743890dec;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $e7d362f04a4204f3$export$6453176f504d54f0;
    const MarkSlot = slots?.mark ?? components.Mark ?? $e7d362f04a4204f3$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $e7d362f04a4204f3$export$e6cd369965e5aa95;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $eD6Co.default)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $lTbyd.default)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $eD6Co.default)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $eD6Co.default)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $eD6Co.default)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $eD6Co.default)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $eD6Co.default)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $eD6Co.default)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $eD6Co.default)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $dBUOG.valueToPercent)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $c1jOg.default)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $9QePP.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $c1jOg.default)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $9QePP.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $dBUOG.valueToPercent)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $e7d362f04a4204f3$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $ayMG0.jsx)(ValueLabelComponent, {
                    ...!(0, $c1jOg.default)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $9QePP.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var $e7d362f04a4204f3$export$2e2bcd8739ae039 = $e7d362f04a4204f3$var$Slider;

});
parcelRegister("dBUOG", function(module, exports) {

$parcel$export(module.exports, "valueToPercent", () => $9e8acd9e5bad7cc4$export$83ce4bc8280540e6);
$parcel$export(module.exports, "useSlider", () => $9e8acd9e5bad7cc4$export$56b2c08e277f365);

var $acw62 = parcelRequire("acw62");

var $1jJMI = parcelRequire("1jJMI");
var $52FI1 = parcelRequire("52FI1");
var $6zeBo = parcelRequire("6zeBo");
var $agZ85 = parcelRequire("agZ85");
var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");
var $VrQIh = parcelRequire("VrQIh");

var $f56pe = parcelRequire("f56pe");

var $9r78y = parcelRequire("9r78y");
'use client';
const $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $9e8acd9e5bad7cc4$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $9e8acd9e5bad7cc4$var$asc(a, b) {
    return a - b;
}
function $9e8acd9e5bad7cc4$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $9e8acd9e5bad7cc4$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $9e8acd9e5bad7cc4$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $9e8acd9e5bad7cc4$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($9e8acd9e5bad7cc4$var$getDecimalPrecision(step)));
}
function $9e8acd9e5bad7cc4$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($9e8acd9e5bad7cc4$var$asc);
}
function $9e8acd9e5bad7cc4$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const doc = (0, $6zeBo.default)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $9e8acd9e5bad7cc4$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $9r78y.default)(newValue, oldValue);
    return false;
}
const $9e8acd9e5bad7cc4$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $9e8acd9e5bad7cc4$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
function $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone() {
    if ($9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = true;
    }
    return $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
}
function $9e8acd9e5bad7cc4$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $9e8acd9e5bad7cc4$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $acw62.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $acw62.useState(-1);
    const [open, setOpen] = $acw62.useState(-1);
    const [dragging, setDragging] = $acw62.useState(false);
    const moveCount = $acw62.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $acw62.useRef(null);
    const [valueDerived, setValueState] = (0, $agZ85.default)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($9e8acd9e5bad7cc4$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $1jJMI.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $acw62.useState(-1);
    const sliderRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $52FI1.default)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $52FI1.default)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $eEJPp.default)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $acw62.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max);
        if (step) newValue = $9e8acd9e5bad7cc4$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $9e8acd9e5bad7cc4$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $9e8acd9e5bad7cc4$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $13KXh.default)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $9e8acd9e5bad7cc4$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $13KXh.default)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $13KXh.default)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $6zeBo.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $acw62.useCallback(()=>{
        const doc = (0, $6zeBo.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $acw62.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $acw62.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $9e8acd9e5bad7cc4$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $9e8acd9e5bad7cc4$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $6zeBo.default)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...(0, $VrQIh.default),
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $9e8acd9e5bad7cc4$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}

});
parcelRegister("VrQIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0acaed42692b8720$export$2e2bcd8739ae039);
const $0acaed42692b8720$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $0acaed42692b8720$export$2e2bcd8739ae039 = $0acaed42692b8720$var$visuallyHidden;

});

parcelRegister("9r78y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dec2bf07d6d333a$export$2e2bcd8739ae039);
function $6dec2bf07d6d333a$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $6dec2bf07d6d333a$export$2e2bcd8739ae039 = $6dec2bf07d6d333a$var$areArraysEqual;

});


parcelRegister("lTbyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef7b1c426e97238$export$2e2bcd8739ae039);

var $c1jOg = parcelRequire("c1jOg");
const $fef7b1c426e97238$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $c1jOg.default)(Slot);
};
var $fef7b1c426e97238$export$2e2bcd8739ae039 = $fef7b1c426e97238$var$shouldSpreadAdditionalProps;

});

parcelRegister("2xkal", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8e4e584d12bd05$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $20dvU = parcelRequire("20dvU");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1d8e4e584d12bd05$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $9QePP.default)(open && (0, $20dvU.default).valueLabelOpen),
        circle: (0, $20dvU.default).valueLabelCircle,
        label: (0, $20dvU.default).valueLabelLabel
    };
    return utilityClasses;
};
function $1d8e4e584d12bd05$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $1d8e4e584d12bd05$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        className: (0, $9QePP.default)(children.props.className)
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}

});
parcelRegister("20dvU", function(module, exports) {

$parcel$export(module.exports, "getSliderUtilityClass", () => $175610683d4083b7$export$9f59f2622d5cbc2a);
$parcel$export(module.exports, "default", () => $175610683d4083b7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $175610683d4083b7$export$9f59f2622d5cbc2a(slot) {
    return (0, $4Cod0.default)('MuiSlider', slot);
}
const $175610683d4083b7$var$sliderClasses = (0, $beCSm.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $175610683d4083b7$export$2e2bcd8739ae039 = $175610683d4083b7$var$sliderClasses;

});



parcelRegister("7s24a", function(module, exports) {

$parcel$export(module.exports, "default", () => $56ccc0421702a0be$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $kVqvD = parcelRequire("kVqvD");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $89Onw = parcelRequire("89Onw");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $jTnBY.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $89Onw.getSwitchUtilityClass), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $89Onw.default).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $89Onw.default).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $89Onw.default).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $d8seH.default)((0, $kVqvD.default), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $89Onw.default).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $89Onw.default).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $89Onw.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $89Onw.default).checked} + .${(0, $89Onw.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $89Onw.default).disabled} + .${(0, $89Onw.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $89Onw.default).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $aeD7H.default)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $89Onw.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $89Onw.default).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $8gMkr.lighten)(theme.palette[color].main, 0.62) : (0, $8gMkr.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $89Onw.default).checked} + .${(0, $89Onw.default).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $56ccc0421702a0be$var$SwitchTrack = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $aeD7H.default)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $56ccc0421702a0be$var$SwitchThumb = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})((0, $aeD7H.default)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $56ccc0421702a0be$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $6lpak.default)('thumb', {
        className: classes.thumb,
        elementType: $56ccc0421702a0be$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $6lpak.default)('track', {
        className: classes.track,
        elementType: $56ccc0421702a0be$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var $56ccc0421702a0be$export$2e2bcd8739ae039 = $56ccc0421702a0be$var$Switch;

});
parcelRegister("89Onw", function(module, exports) {

$parcel$export(module.exports, "getSwitchUtilityClass", () => $5f063e1b0f6d278b$export$39f6debbec19b3ba);
$parcel$export(module.exports, "default", () => $5f063e1b0f6d278b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5f063e1b0f6d278b$export$39f6debbec19b3ba(slot) {
    return (0, $4Cod0.default)('MuiSwitch', slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $beCSm.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $5f063e1b0f6d278b$export$2e2bcd8739ae039 = $5f063e1b0f6d278b$var$switchClasses;

});


parcelRegister("6AlVH", function(module, exports) {

$parcel$export(module.exports, "TowingEquipmentContainer", () => $56260a2afd883aee$export$a820e29e30558cf7);
$parcel$export(module.exports, "useTowingEquipmentState", () => $56260a2afd883aee$export$bfc712186e3db9fe);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $229QL = parcelRequire("229QL");
const $56260a2afd883aee$var$TowingEquipmentContainerState = /*#__PURE__*/ $acw62.createContext({
    loading: false,
    towingEquipments: [],
    setTowingEquipments: function() {}
});
const $56260a2afd883aee$export$a820e29e30558cf7 = ({ children: children })=>{
    const data = (0, $229QL.useTowingEquipment)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($56260a2afd883aee$var$TowingEquipmentContainerState.Provider, {
        value: data,
        children: children
    });
};
const $56260a2afd883aee$export$bfc712186e3db9fe = ()=>$acw62.useContext($56260a2afd883aee$var$TowingEquipmentContainerState);

});
parcelRegister("229QL", function(module, exports) {

$parcel$export(module.exports, "useTowingEquipment", () => $d21e3013ca9663c6$export$fb991fc1174b0434);

var $acw62 = parcelRequire("acw62");

var $4yCYl = parcelRequire("4yCYl");

var $5sKyw = parcelRequire("5sKyw");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");
const $d21e3013ca9663c6$export$fb991fc1174b0434 = (limitToInUse = false)=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [loading, setLoading] = $acw62.useState(true);
    const [towingEquipments, setTowingEquipments] = $acw62.useState();
    const previousTowingEquipments = (0, $4yCYl.default)(towingEquipments);
    $acw62.useEffect(()=>{
        (async ()=>{
            const { data: allTowingEquipments } = await postgrest.from("towing_equipment").select().order("name");
            const { data: towingEquipmentsInUse } = await postgrest.from("towing_equipment_in_use").select().eq("fbo_id", activeFBO.id);
            let towingEquipmentsToDisplay = towingEquipmentsInUse.map((towingEquipmentInUse)=>{
                const towingEquipment = allTowingEquipments.find((t)=>t.id === towingEquipmentInUse.towing_equipment_id);
                return {
                    id: towingEquipmentInUse.id,
                    towing_equipment_id: towingEquipmentInUse.towing_equipment_id,
                    is_default: towingEquipmentInUse.is_default,
                    name: towingEquipment.name,
                    width: towingEquipment.width,
                    length: towingEquipment.length,
                    height: towingEquipment.height,
                    tow_bar_length: towingEquipment.tow_bar_length,
                    geom: towingEquipment.geom,
                    geomz: towingEquipment.geomz,
                    in_use: true
                };
            });
            if (!limitToInUse) towingEquipmentsToDisplay = towingEquipmentsToDisplay.concat(allTowingEquipments.filter((t)=>!towingEquipmentsInUse.find((e)=>e.towing_equipment_id === t.id)).map((towingEquipment)=>({
                    id: (0, $5sKyw.default)(),
                    towing_equipment_id: towingEquipment.id,
                    is_default: null,
                    name: towingEquipment.name,
                    width: towingEquipment.width,
                    length: towingEquipment.length,
                    height: towingEquipment.height,
                    tow_bar_length: towingEquipment.tow_bar_length,
                    geom: towingEquipment.geom,
                    geomz: towingEquipment.geomz,
                    in_use: false
                })));
            setTowingEquipments(towingEquipmentsToDisplay);
            setLoading(false);
        })();
    }, []);
    $acw62.useEffect(()=>{
        if (!towingEquipments || !previousTowingEquipments) return;
        (async ()=>{
            const towingEquipmentInUse = towingEquipments.filter((t)=>t.in_use);
            const equipmentIdsInUseSQL = `(${towingEquipmentInUse.map((t)=>t.id).join(",")})`;
            await postgrest.from("towing_equipment_in_use").delete().eq("fbo_id", activeFBO.id).not("id", "in", equipmentIdsInUseSQL);
            await postgrest.from("towing_equipment_in_use").upsert(towingEquipmentInUse.map((t)=>({
                    id: t.id,
                    fbo_id: activeFBO.id,
                    towing_equipment_id: t.towing_equipment_id,
                    is_default: t.is_default
                })));
        })();
    }, [
        towingEquipments
    ]);
    return {
        loading: loading,
        towingEquipments: towingEquipments ?? [],
        setTowingEquipments: setTowingEquipments
    };
};

});


parcelRegister("gZQV9", function(module, exports) {

$parcel$export(module.exports, "useThisHangar", () => $8f45c22630325f0e$export$8338d29746ea5279);

var $ggtZr = parcelRequire("ggtZr");

var $7p8YN = parcelRequire("7p8YN");
const $8f45c22630325f0e$export$8338d29746ea5279 = ()=>{
    const singleHangarState = (0, $ggtZr.useOptionalHangarState)();
    const multiHangarState = (0, $7p8YN.useMultiHangarState)();
    if (multiHangarState?.isMultiHangar) return multiHangarState;
    return singleHangarState || {
        hangar: undefined,
        getHangar: ()=>undefined,
        setHangar: ()=>{},
        history: undefined,
        isReference: false
    };
};

});
parcelRegister("ggtZr", function(module, exports) {

$parcel$export(module.exports, "HangarStateContainer", () => $05661d70b1b2785d$export$1d4aa4cf7c37c5f6);
$parcel$export(module.exports, "useHangarState", () => $05661d70b1b2785d$export$6dcc41944f23f4ab);
$parcel$export(module.exports, "useOptionalHangarState", () => $05661d70b1b2785d$export$7f2a9380312e8364);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kiGH8 = parcelRequire("kiGH8");

var $2sRWk = parcelRequire("2sRWk");
const $05661d70b1b2785d$var$HangarStateContainerState = /*#__PURE__*/ $acw62.createContext(undefined);
const $05661d70b1b2785d$export$1d4aa4cf7c37c5f6 = ({ children: children, initialState: initialState })=>{
    const { ready: ready, hangars: hangars, getHangar: getHangar, setHangar: setHangar, history: history } = (0, $kiGH8.useMultipleHangars)([
        initialState.hangar_id
    ], initialState.isReference);
    const hangar = hangars?.[0];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($05661d70b1b2785d$var$HangarStateContainerState.Provider, {
        value: {
            hangar: hangar,
            getHangar: getHangar,
            setHangar: setHangar,
            history: history,
            isReference: initialState.isReference
        },
        children: ready ? children : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2sRWk.HangarSkeleton), {})
    });
};
const $05661d70b1b2785d$export$6dcc41944f23f4ab = ()=>{
    const context = $acw62.useContext($05661d70b1b2785d$var$HangarStateContainerState);
    if (!context) throw new Error("useHangarState must be used within a HangarStateContainer");
    return context;
};
const $05661d70b1b2785d$export$7f2a9380312e8364 = ()=>{
    const context = $acw62.useContext($05661d70b1b2785d$var$HangarStateContainerState);
    return context;
};

});
parcelRegister("kiGH8", function(module, exports) {

$parcel$export(module.exports, "useMultipleHangars", () => $1a901aec67bdb48c$export$ebaf1cb97984ddd7);

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $5U03M = parcelRequire("5U03M");

var $dZ8EH = parcelRequire("dZ8EH");

var $8GP8k = parcelRequire("8GP8k");

var $abvRu = parcelRequire("abvRu");

var $6TVXD = parcelRequire("6TVXD");

var $W9FY8 = parcelRequire("W9FY8");
const $1a901aec67bdb48c$var$hasMeaningfulChanges = (prev, next)=>{
    if (!prev || !next) return true;
    return prev.some((p, i)=>(0, $abvRu.isLocationChangeMeaningful)(p, next[i]));
};
const $1a901aec67bdb48c$export$ebaf1cb97984ddd7 = (hangar_ids, isReference)=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [ready, setReady] = $acw62.useState(false);
    const [hangars, setHangars, undo] = (0, $6TVXD.useStateHistory)(null, $1a901aec67bdb48c$var$hasMeaningfulChanges);
    const setHangar = $acw62.useCallback((hangar)=>{
        // update the hangar that's currently being modified
        // if the hangar moved a tenant into it, then remove that
        // tenant from all other hangars
        const hangarsTenantIds = hangar.stack.tenants.map((t)=>t.id);
        const newHangars = hangars.map((h)=>{
            if (h.id === hangar.id) return hangar;
            // remove any duplicate tenants. this should not happen but has apparently happened
            // at Maven in the past
            const tenants = h.stack.tenants.filter((t)=>!hangarsTenantIds.includes(t.id)).filter((t, i, self)=>self.findIndex((s)=>s.id === t.id) === i);
            return {
                ...h,
                stack: {
                    ...h.stack,
                    tenants: tenants
                }
            };
        });
        setHangars(newHangars);
    }, [
        hangars,
        setHangars
    ]);
    const realHangars = hangars?.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID));
    const holdingArea = hangars?.find((h)=>h.id === (0, $5U03M.HOLDING_AREA_ID));
    // watches for "core" diffs on the hangar. width, depth, name, etc.
    (0, $W9FY8.default)({
        thingToWatch: realHangars,
        tableName: "hangar"
    });
    // watch for stack
    const stacks = [];
    for (const hangar of realHangars ?? []){
        for (const stack of hangar.stacks ?? [])if (stack.id === hangar.stack.id) stacks.push(hangar.stack);
        else stacks.push(stack);
    }
    (0, $W9FY8.default)({
        tableName: "stack",
        thingToWatch: Boolean(realHangars) ? stacks : null
    });
    // core info for a tenant can be modified within the holding area. so we need to include these
    // in the sync
    const tenants = [
        ...stacks?.flatMap((stack)=>stack.tenants),
        ...holdingArea?.stack.tenants || []
    ];
    (0, $W9FY8.default)({
        // pass in null until we actually have data
        thingToWatch: Boolean(realHangars) ? tenants : null,
        tableName: "tenant",
        deleteFromDatabase: async ()=>{
        // we don't actually delete tenants. they just leave the hangar. we're still
        // tracking them in this file b/c we need to be able to edit their info from
        // the hangar.
        }
    });
    const movableObstacles = [
        ...stacks?.map((s)=>[
                ...s.movableObstacles
            ])
    ].flat() ?? [];
    (0, $W9FY8.default)({
        thingToWatch: Boolean(realHangars) ? movableObstacles : null,
        tableName: "movable_obstacle",
        deleteFromDatabase: async ()=>{
        // we don't actually delete movable obstacles. they just leave the hangar. we're still
        // tracking them in this file b/c we need to be able to edit their info from
        // the hangar.
        }
    });
    const currentPositions = [];
    for (const stack of stacks ?? []){
        for (const tenant of stack.tenants ?? [])currentPositions.push(tenant.position);
        for (const movableObstacle of stack.movableObstacles ?? [])currentPositions.push(movableObstacle.position);
    }
    (0, $W9FY8.default)({
        // pass in null until we actually have data
        thingToWatch: Boolean(realHangars) ? currentPositions : null,
        tableName: "position",
        // wow this is ugly. if i put this in the hook, it will cause a circular dependency
        // so i'm just going to put it here. life soldiers on.
        onUpdate: async (rows)=>{
            const hangarsAffected = realHangars.filter((h)=>rows.some((r)=>h.stack.tenants.some((t)=>t.position.id === r.id)));
            await postgrest.from("hangar").update({
                last_stacked: new Date().toISOString()
            }).in("id", hangarsAffected.map((h)=>h.id));
        },
        // Add debounce to ensure Stacks are saved before Positions
        debounce: 200
    });
    const obstacles = Boolean(realHangars) ? [
        ...realHangars?.map((h)=>[
                ...h.obstacles ?? []
            ])
    ].flat() : [];
    (0, $W9FY8.default)({
        thingToWatch: Boolean(realHangars) ? obstacles : null,
        tableName: "obstacle"
    });
    const garageDoors = Boolean(realHangars) ? [
        ...realHangars?.map((h)=>[
                ...h.garageDoors ?? []
            ])
    ].flat() : [];
    (0, $W9FY8.default)({
        thingToWatch: Boolean(realHangars) ? garageDoors : null,
        tableName: "garage_door"
    });
    const hangarBays = Boolean(realHangars) ? [
        ...realHangars?.map((h)=>[
                ...h.bays ?? []
            ])
    ].flat() : [];
    (0, $W9FY8.default)({
        thingToWatch: Boolean(realHangars) ? hangarBays : null,
        tableName: "hangar_bay"
    });
    // ok let's grab the hangars we only do this once. changes made in memory will be
    // synced to the database via the useSyncToTable hook
    $acw62.useEffect(()=>{
        (async ()=>{
            const doit = hangar_ids.map(async (hangar_id)=>await (0, $8GP8k.fetchHangar)(postgrest, activeFBO, hangar_id, isReference));
            const zHangars = await Promise.all(doit);
            // Fetch holding area entries from database
            let holdingAreaTenants = [];
            if (activeFBO?.id) try {
                const holdingAreaService = new (0, $dZ8EH.HoldingAreaService)(postgrest);
                const entries = await holdingAreaService.getActiveEntries(activeFBO.id);
                // Extract tenants from entries
                holdingAreaTenants = entries.filter((entry)=>entry.tenant).map((entry)=>({
                        ...entry.tenant,
                        selected: false,
                        // Add missing required field
                        // Ensure position is null for holding area
                        position: {
                            ...entry.tenant.position,
                            x: null,
                            y: null,
                            angle: null,
                            preferences: entry.tenant.position?.preferences || [] // Ensure preferences array exists
                        }
                    }));
                // Enrich aircraft data with geometry buffers (geom_scaled_buffer, ramp_geom_scaled_buffer)
                // These are computed via RPC calls and not included in the basic database query
                const aircraftIds = holdingAreaTenants.map((t)=>t.aircraft_id).filter((id)=>id);
                if (aircraftIds.length > 0) {
                    const enrichedAircraft = await (0, $8GP8k.fetchAircraftWithCache)(postgrest, aircraftIds, activeFBO);
                    // Merge enriched aircraft data back into tenants
                    holdingAreaTenants = holdingAreaTenants.map((tenant)=>({
                            ...tenant,
                            aircraft: enrichedAircraft.find(({ id: id })=>tenant.aircraft_id === id) ?? tenant.aircraft
                        }));
                }
            } catch (err) {
                console.error("Failed to load holding area entries:", err);
            }
            zHangars.push({
                id: (0, $5U03M.HOLDING_AREA_ID),
                location_id: "",
                // Virtual hangar, no physical location
                fbo_id: activeFBO?.id || "",
                name: "Holding Area",
                width: 100,
                depth: 300,
                height: 50,
                left_door: 0,
                right_door: 0,
                wall_spacing_left: 0,
                wall_spacing_back: 0,
                wall_spacing_right: 0,
                stack: {
                    id: "holding-area-stack",
                    name: "current",
                    isReference: false,
                    tenants: holdingAreaTenants,
                    movableObstacles: [],
                    options: {
                        wall_spacing_left: 0,
                        wall_spacing_back: 0,
                        wall_spacing_right: 0,
                        horizontal_spacing: 0,
                        vertical_spacing: 0,
                        overlap: false,
                        tug_spacing: 0,
                        density_threshold: 0,
                        corner_strategy: [],
                        xy_weights: [],
                        towing_equipment_id: ""
                    }
                },
                stacks: [
                    {
                        id: "holding-area-stack",
                        name: "current",
                        isReference: false,
                        tenants: holdingAreaTenants,
                        movableObstacles: [],
                        options: {
                            wall_spacing_left: 0,
                            wall_spacing_back: 0,
                            wall_spacing_right: 0,
                            horizontal_spacing: 0,
                            vertical_spacing: 0,
                            overlap: false,
                            tug_spacing: 0,
                            density_threshold: 0,
                            corner_strategy: [],
                            xy_weights: [],
                            towing_equipment_id: ""
                        }
                    }
                ],
                obstacles: [],
                garageDoors: [],
                created_at: new Date().toISOString(),
                last_stacked: new Date().toISOString()
            });
            setHangars(zHangars);
            setReady(true);
        })();
    }, []);
    return {
        ready: ready && Boolean(hangars) && Boolean(hangars.length === hangar_ids.length + 1),
        getHangar: (hangar_id)=>hangars?.find((h)=>h.id === hangar_id),
        hangars: hangars ?? [],
        setHangar: setHangar,
        setHangars: setHangars,
        // setHangars: (newHangars: Hangar[]) => {
        //   // make sure there are no duplicate tenants
        //   setHangars(
        //     newHangars.map((h) => ({
        //       ...h,
        //       stack: {
        //         ...h.stack,
        //         tenants: h.stack.tenants.filter(
        //           (t, i, self) => self.findIndex((s) => s.id === t.id) === i
        //         ),
        //       },
        //     }))
        //   );
        // },
        history: {
            undo: undo
        },
        isReference: isReference
    };
};

});
parcelRegister("5U03M", function(module, exports) {

$parcel$export(module.exports, "HOLDING_AREA_ID", () => $242385e6ae0b7b8f$export$10ea36fec5d8ea6e);
$parcel$export(module.exports, "HoldingArea", () => $242385e6ae0b7b8f$export$aa258ef6d0350a54);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ZD2ym = parcelRequire("ZD2ym");

var $7p8YN = parcelRequire("7p8YN");

var $6fDLr = parcelRequire("6fDLr");

var $6rxM8 = parcelRequire("6rxM8");

var $3JLDK = parcelRequire("3JLDK");

var $kLEoe = parcelRequire("kLEoe");

var $7UdqG = parcelRequire("7UdqG");

var $he3Hz = parcelRequire("he3Hz");

var $kinWj = parcelRequire("kinWj");

var $gJrqw = parcelRequire("gJrqw");
parcelRequire("7o8I0");
var $3XtNi = parcelRequire("3XtNi");

var $74Lxs = parcelRequire("74Lxs");

var $ctu9I = parcelRequire("ctu9I");

var $2LXej = parcelRequire("2LXej");

var $bvqAP = parcelRequire("bvqAP");
const $242385e6ae0b7b8f$export$10ea36fec5d8ea6e = "holding-area";
/**
 * Helper to add tenants to holding area with null positions
 */ const $242385e6ae0b7b8f$var$addTenantsToHoldingArea = (hangars, tenants)=>{
    const tenantArray = Array.isArray(tenants) ? tenants : [
        tenants
    ];
    const tenantsWithNullPosition = tenantArray.map((t)=>({
            ...t,
            position: {
                ...t.position,
                x: null,
                y: null,
                angle: null
            }
        }));
    return hangars.map((h)=>h.id === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? {
            ...h,
            stack: {
                ...h.stack,
                tenants: [
                    ...tenantsWithNullPosition,
                    ...h.stack.tenants
                ]
            }
        } : h);
};
/**
 * Helper to move tenant from holding area to target hangar
 */ const $242385e6ae0b7b8f$var$moveTenantsFromHoldingAreaToHangar = (hangars, tenant, targetHangarId)=>{
    return hangars.map((h)=>{
        if (h.id === targetHangarId) // Add to target hangar with null position (unplaced)
        return {
            ...h,
            stack: {
                ...h.stack,
                tenants: [
                    ...h.stack.tenants,
                    {
                        ...tenant,
                        position: {
                            ...tenant.position,
                            x: null,
                            y: null,
                            angle: null,
                            stack_id: h.stack.id
                        }
                    }
                ]
            }
        };
        else if (h.id === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e) // Remove from holding area
        return {
            ...h,
            stack: {
                ...h.stack,
                tenants: h.stack.tenants.filter((t)=>t.id !== tenant.id)
            }
        };
        return h;
    });
};
const $242385e6ae0b7b8f$export$aa258ef6d0350a54 = ({ feetToPixels: feetToPixels, multiHangarLayoutHeight: multiHangarLayoutHeight })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const theme = (0, $14H9o.default)();
    const { focus: focus, activeLocationId: activeLocationId, setActiveLocationId: setActiveLocationId, hangars: hangars, setHangars: setHangars } = (0, $7p8YN.useMultiHangarState)();
    const navigate = (0, $aphAM.useNavigate)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const holdingAreaTracking = (0, $74Lxs.useHoldingArea)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const tenantService = $acw62.useMemo(()=>new (0, $bvqAP.TenantService)(postgrest), [
        postgrest
    ]);
    const holdingArea = hangars.find((h)=>h.id === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e);
    // Check if we should use the list-based UI (default: true)
    const useListView = activeFBO?.settings?.useListHoldingArea ?? true;
    // Dialog state
    const [assignDialogOpen, setAssignDialogOpen] = $acw62.useState(false);
    const [selectedTenantForAssignment, setSelectedTenantForAssignment] = $acw62.useState(null);
    const [isAssigning, setIsAssigning] = $acw62.useState(false);
    const [editDialogOpen, setEditDialogOpen] = $acw62.useState(false);
    const [selectedTenantForEdit, setSelectedTenantForEdit] = $acw62.useState(null);
    if (!holdingArea || !holdingArea.stack) return null;
    // Handler for opening assignment dialog
    const handleAssign = $acw62.useCallback((tenantId)=>{
        const tenant = holdingArea.stack.tenants.find((t)=>t.id === tenantId);
        if (tenant) {
            setSelectedTenantForAssignment(tenant);
            setAssignDialogOpen(true);
        }
    }, [
        holdingArea.stack.tenants
    ]);
    // Handler for adding aircraft
    const handleAddAircraft = $acw62.useCallback(async (tenant)=>{
        setHangars((hangars)=>$242385e6ae0b7b8f$var$addTenantsToHoldingArea(hangars, tenant));
        // Create tenant in database FIRST, then track in holding area
        try {
            const tenantArray = Array.isArray(tenant) ? tenant : [
                tenant
            ];
            for (const t of tenantArray){
                // Step 1: Upsert tenant into database (handles both new and existing)
                await tenantService.createTenant(t);
                // Step 2: Track in holding area (now tenant definitely exists in DB)
                await holdingAreaTracking.addTenant(t);
            }
        } catch (err) {
            console.error("Failed to save tenant to holding area:", err);
            snackbar.notify({
                text: "Failed to save aircraft to holding area",
                severity: "error"
            });
        }
    }, [
        setHangars,
        holdingAreaTracking,
        snackbar,
        tenantService
    ]);
    // Handler for editing aircraft
    const handleEdit = $acw62.useCallback((tenant)=>{
        setSelectedTenantForEdit(tenant);
        setEditDialogOpen(true);
    }, []);
    // Handler for removing aircraft
    const handleRemove = $acw62.useCallback(async (tenantId)=>{
        const tenant = holdingArea.stack.tenants.find((t)=>t.id === tenantId);
        setHangars((hangars)=>hangars.map((h)=>h.id === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? {
                    ...h,
                    stack: {
                        ...h.stack,
                        tenants: h.stack.tenants.filter((t)=>t.id !== tenantId)
                    }
                } : h));
        // Update tracking in database
        try {
            await holdingAreaTracking.removeTenant(tenantId);
        } catch (err) {
            console.error("Failed to update holding area tracking:", err);
            snackbar.notify({
                text: "Failed to update holding area tracking",
                severity: "warning"
            });
        }
        if (tenant) snackbar.notify({
            text: `${tenant.tail_number || tenant.aircraft.model} removed from holding area`,
            severity: "success"
        });
    }, [
        holdingArea.stack.tenants,
        setHangars,
        snackbar,
        holdingAreaTracking
    ]);
    // Handler for confirming assignment
    const handleConfirmAssignment = $acw62.useCallback(async (targetHangarId)=>{
        if (!selectedTenantForAssignment) return;
        setIsAssigning(true);
        try {
            // Find target hangar for success message
            const targetHangar = hangars.find((h)=>h.id === targetHangarId);
            // Move tenant from holding area to target hangar
            setHangars((hangars)=>$242385e6ae0b7b8f$var$moveTenantsFromHoldingAreaToHangar(hangars, selectedTenantForAssignment, targetHangarId));
            // Update tracking in database
            try {
                await holdingAreaTracking.assignTenant(selectedTenantForAssignment.id);
            } catch (err) {
                console.error("Failed to update holding area tracking:", err);
                snackbar.notify({
                    text: "Failed to update holding area tracking",
                    severity: "warning"
                });
            }
            // Show success notification
            if (targetHangar) snackbar.notify({
                text: `${selectedTenantForAssignment.tail_number || selectedTenantForAssignment.aircraft.model} assigned to ${targetHangar.name}`,
                severity: "success"
            });
            // Close dialog
            setAssignDialogOpen(false);
            setSelectedTenantForAssignment(null);
        } finally{
            setIsAssigning(false);
        }
    }, [
        selectedTenantForAssignment,
        setHangars,
        hangars,
        snackbar,
        holdingAreaTracking
    ]);
    // Get available hangars (exclude holding area)
    const availableHangars = $acw62.useMemo(()=>hangars.filter((h)=>h.id !== $242385e6ae0b7b8f$export$10ea36fec5d8ea6e), [
        hangars
    ]);
    // Render canvas-based UI (old version)
    if (!useListView) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        onClick: (_e)=>{
            // if the user is focused on one of the hangars, keep the selected hangar blue
            if (focus) return;
            setActiveLocationId($242385e6ae0b7b8f$export$10ea36fec5d8ea6e);
        },
        sx: {
            pr: 1,
            mt: "68px",
            height: "calc(100vh - 120px)",
            width: 250
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    zIndex: 1000,
                    top: 0,
                    left: 72,
                    display: activeLocationId === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? "block" : "none"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3JLDK.CollapsibleRampActionCard), {
                    hideTitle: true,
                    location: {
                        type: "hangar",
                        ...holdingArea
                    },
                    onClickBack: ()=>navigate("/hangars"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        display: "flex",
                        flex: 1,
                        spacing: 1,
                        height: "98%",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kinWj.MultiHangarInfoCard), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctu9I.HangarLeftPanelWrapper), {
                                hangarId: $242385e6ae0b7b8f$export$10ea36fec5d8ea6e,
                                width: 300,
                                viewableHangars: hangars,
                                activeHangarId: activeLocationId,
                                setActiveHangarId: setActiveLocationId,
                                // none of this actually gets used for the holding area so we just stub it out
                                stacks: [],
                                setStacks: ()=>null,
                                stackStrategy: null,
                                setStackStrategy: ()=>null,
                                customPlacementOptions: {
                                    wall_spacing_left: 0,
                                    wall_spacing_back: 0,
                                    wall_spacing_right: 0,
                                    horizontal_spacing: 0,
                                    vertical_spacing: 0,
                                    overlap: false,
                                    ignore_nose_in_out: false,
                                    ignore_front_back: false,
                                    ignore_outside_hangar: false,
                                    corner_strategies: [],
                                    cloud_position_prioritization: false,
                                    xy_weights: [],
                                    towing_equipment_id: ""
                                },
                                setCustomPlacementOptions: ()=>null
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    zIndex: 1000,
                    top: 0,
                    left: 475,
                    maxWidth: "calc(100vw - 475px)",
                    display: activeLocationId === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? "block" : "none"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $he3Hz.LayoutToolbarWrapper), {
                    hangarId: $242385e6ae0b7b8f$export$10ea36fec5d8ea6e,
                    setStacks: ()=>null
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UdqG.HoldingAreaPresenter), {
                    active: activeLocationId === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e,
                    feetToPixels: feetToPixels,
                    multiHangarDepth: (multiHangarLayoutHeight || 0) - parseFloat(theme.spacing(2)),
                    customPlacementOptions: {
                        wall_spacing_left: 0,
                        wall_spacing_back: 0,
                        wall_spacing_right: 0,
                        horizontal_spacing: 0,
                        vertical_spacing: 0,
                        overlap: false,
                        ignore_nose_in_out: false,
                        ignore_front_back: false,
                        ignore_outside_hangar: false,
                        density_threshold: 0,
                        tug_spacing: 0,
                        sample_size: 0,
                        corner_strategies: [],
                        cloud_position_prioritization: false,
                        xy_weights: [],
                        towing_equipment_id: ""
                    }
                })
            })
        ]
    });
    // Render list-based UI (new version)
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        onClick: (_e)=>{
            // if the user is focused on one of the hangars, keep the selected hangar blue
            if (focus) return;
            setActiveLocationId($242385e6ae0b7b8f$export$10ea36fec5d8ea6e);
        },
        sx: {
            pr: 1,
            mt: "68px",
            height: "calc(100vh - 120px)",
            width: 350 // 40% wider than original 250
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    zIndex: 1000,
                    top: 0,
                    left: 72,
                    display: activeLocationId === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? "block" : "none"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3JLDK.CollapsibleRampActionCard), {
                    hideTitle: true,
                    location: {
                        type: "hangar",
                        ...holdingArea
                    },
                    onClickBack: ()=>navigate("/hangars"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "column",
                        display: "flex",
                        flex: 1,
                        spacing: 1,
                        height: "98%",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kinWj.MultiHangarInfoCard), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    zIndex: 1000,
                    top: 0,
                    left: 475,
                    maxWidth: "calc(100vw - 475px)",
                    display: activeLocationId === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? "block" : "none"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $he3Hz.LayoutToolbarWrapper), {
                    hangarId: $242385e6ae0b7b8f$export$10ea36fec5d8ea6e,
                    setStacks: ()=>null
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kLEoe.HoldingAreaList), {
                tenants: holdingArea.stack.tenants,
                onAssign: handleAssign,
                onEdit: handleEdit,
                onRemove: handleRemove,
                onAdd: handleAddAircraft,
                setStack: (stack)=>{
                    setHangars((hangars)=>hangars.map((h)=>h.id === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? {
                                ...h,
                                stack: {
                                    ...h.stack,
                                    ...stack
                                }
                            } : h));
                },
                location: {
                    type: "hangar",
                    ...holdingArea
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJrqw.AssignAircraftDialog), {
                open: assignDialogOpen,
                onClose: ()=>{
                    setAssignDialogOpen(false);
                    setSelectedTenantForAssignment(null);
                },
                aircraftTail: selectedTenantForAssignment?.tail_number || "",
                aircraftModel: selectedTenantForAssignment?.aircraft?.model || "",
                aircraftWingspan: selectedTenantForAssignment?.aircraft?.wingspan,
                aircraftLength: selectedTenantForAssignment?.aircraft?.length,
                availableHangars: availableHangars,
                onAssign: handleConfirmAssignment,
                isAssigning: isAssigning
            }),
            editDialogOpen && selectedTenantForEdit && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6rxM8.LocationsContainer), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3XtNi.EditTenant), {
                    tenant: selectedTenantForEdit,
                    setTenant: (updatedTenant)=>{
                        setHangars((hangars)=>hangars.map((h)=>h.id === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? {
                                    ...h,
                                    stack: {
                                        ...h.stack,
                                        tenants: h.stack.tenants.map((t)=>t.id === updatedTenant.id ? updatedTenant : t)
                                    }
                                } : h));
                    },
                    stack: holdingArea.stack,
                    setStack: (stack)=>{
                        setHangars((hangars)=>hangars.map((h)=>h.id === $242385e6ae0b7b8f$export$10ea36fec5d8ea6e ? {
                                    ...h,
                                    stack: stack
                                } : h));
                    },
                    onClose: ()=>{
                        setEditDialogOpen(false);
                        setSelectedTenantForEdit(null);
                    }
                })
            })
        ]
    });
};

});
parcelRegister("7p8YN", function(module, exports) {

$parcel$export(module.exports, "MultiHangarStateContainer", () => $9d58b52493edea26$export$9f30d6356d90c668);
$parcel$export(module.exports, "useMultiHangarState", () => $9d58b52493edea26$export$91652b42836a2a65);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kiGH8 = parcelRequire("kiGH8");
const $9d58b52493edea26$var$EMPTY_HANGAR = {
    id: "",
    name: "",
    width: 0,
    depth: 0,
    height: 0,
    fbo_id: "",
    garageDoors: [],
    left_door: 0,
    right_door: 0,
    wall_spacing_back: 0,
    wall_spacing_right: 0,
    wall_spacing_left: 0,
    obstacles: [],
    stack: {
        id: "",
        name: "",
        tenants: [],
        movableObstacles: [],
        options: {
            wall_spacing_left: 0,
            wall_spacing_back: 0,
            wall_spacing_right: 0,
            horizontal_spacing: 0,
            vertical_spacing: 0,
            overlap: false,
            tug_spacing: 0,
            density_threshold: 0,
            corner_strategy: [],
            xy_weights: [],
            towing_equipment_id: ""
        },
        isReference: false
    },
    stacks: [],
    location_id: "",
    last_stacked: "",
    created_at: ""
};
const $9d58b52493edea26$var$MultiHangarContainer = /*#__PURE__*/ $acw62.createContext({
    ready: false,
    isMultiHangar: false,
    activeLocationId: "",
    setActiveLocationId: ()=>{},
    hangarIds: [],
    setHangarIds: ()=>{},
    zoom: 1,
    setZoom: ()=>{},
    focus: null,
    setFocus: ()=>{},
    //
    hangar: $9d58b52493edea26$var$EMPTY_HANGAR,
    hangars: [],
    getHangar: ()=>$9d58b52493edea26$var$EMPTY_HANGAR,
    setHangar: ()=>{},
    setHangars: ()=>{},
    history: {
        undo: ()=>{},
        redo: ()=>{}
    }
});
const $9d58b52493edea26$export$9f30d6356d90c668 = ({ children: children, initialState: initialState })=>{
    const [hangarIds, setHangarIds] = $acw62.useState(initialState.hangarIds ?? []);
    const { ready: ready, hangars: hangars, getHangar: getHangar, setHangar: setHangar, setHangars: setHangars, history: history } = (0, $kiGH8.useMultipleHangars)(initialState.hangarIds ?? [], false);
    const [activeLocationId, setActiveLocationId] = $acw62.useState(initialState.activeHangarId ?? "");
    const [zoom, setZoom] = $acw62.useState(1);
    const [focus, setFocus] = $acw62.useState();
    const setZoomCapped = $acw62.useCallback((zoom)=>{
        if (zoom < 0.7) setZoom(0.7);
        else if (zoom > 2) setZoom(2);
        else setZoom(zoom);
    }, [
        setZoom
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9d58b52493edea26$var$MultiHangarContainer.Provider, {
        value: {
            ready: ready,
            isMultiHangar: hangars.length > 1,
            hangarIds: hangarIds,
            setHangarIds: setHangarIds,
            activeLocationId: activeLocationId,
            setActiveLocationId: setActiveLocationId,
            zoom: zoom,
            setZoom: setZoomCapped,
            focus: focus,
            setFocus: setFocus,
            //
            hangar: hangars.find((h)=>h.id === activeLocationId) ?? hangars[0],
            hangars: hangars,
            getHangar: getHangar,
            setHangar: setHangar,
            setHangars: setHangars,
            history: history
        },
        children: children
    });
};
const $9d58b52493edea26$export$91652b42836a2a65 = ()=>$acw62.useContext($9d58b52493edea26$var$MultiHangarContainer);

});

parcelRegister("6rxM8", function(module, exports) {

$parcel$export(module.exports, "LocationsContainer", () => $1b7839e26028f05c$export$4c899c030df19b90);
$parcel$export(module.exports, "useLocationsState", () => $1b7839e26028f05c$export$38dd16bab0f24427);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bTM6K = parcelRequire("bTM6K");
const $1b7839e26028f05c$var$LocationsContainerState = /*#__PURE__*/ $acw62.createContext({});
const $1b7839e26028f05c$export$4c899c030df19b90 = ({ children: children })=>{
    const data = (0, $bTM6K.useLocations)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b7839e26028f05c$var$LocationsContainerState.Provider, {
        value: data,
        children: children
    });
};
const $1b7839e26028f05c$export$38dd16bab0f24427 = ()=>$acw62.useContext($1b7839e26028f05c$var$LocationsContainerState);

});
parcelRegister("bTM6K", function(module, exports) {

$parcel$export(module.exports, "useLocations", () => $438a06939ba7d94c$export$8535247f55db5d21);

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $lNEp2 = parcelRequire("lNEp2");
const $438a06939ba7d94c$export$8535247f55db5d21 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { hangars: hangars } = (0, $7FzhI.useHangarsState)();
    const { ramps: ramps } = (0, $3AGzj.useRampsState)();
    const [locationOverides, setLocationOverides] = $acw62.useState({});
    const locations = [
        ...hangars.map((h)=>({
                ...h,
                type: "hangar"
            })),
        ...ramps.map((r)=>({
                ...r,
                type: "ramp"
            }))
    ];
    const findTenantLocation = $acw62.useCallback((isReference, tenant)=>{
        const stackName = isReference ? "reference" : "current";
        const key = `${tenant.id}-${stackName}`;
        // check if the key exists in locationOverrides
        if (key in locationOverides) return locationOverides[key];
        for (const location of locations){
            const activeStack = location.stacks.find((stack)=>stack?.name === stackName);
            if (!activeStack) continue;
            const foundTenant = activeStack.tenants.find((t)=>t.id === tenant.id);
            if (foundTenant) return location;
        }
    }, [
        locations,
        locationOverides
    ]);
    const findTenantLocations = $acw62.useCallback((tenant)=>{
        return {
            current: findTenantLocation(false, tenant),
            assigned: findTenantLocation(true, tenant)
        };
    }, [
        findTenantLocation
    ]);
    const sendToLocation = $acw62.useCallback(async (newLocation, stackName, tenant)=>{
        if (!newLocation) {
            // we've removed the tenant from a given hangar. we need to delete all
            // references to the type of hangar that this one is in.
            await postgrest.rpc("remove_stack_positions_for_entity", {
                entity_id: tenant.entity_id,
                stack_name: stackName,
                position_id_to_keep: null
            });
            setLocationOverides((locationOverides)=>({
                    ...locationOverides,
                    [`${tenant.id}-${stackName}`]: null
                }));
            return;
        }
        const newStack = newLocation.stacks.find((s)=>s.name === stackName);
        await postgrest.from("position").upsert({
            id: (0, $lNEp2.uuidv4)(),
            stack_id: newStack.id,
            entity_id: tenant.entity_id,
            x: null,
            y: null,
            angle: null,
            preferences: tenant.position.preferences
        });
        setLocationOverides((locationOverides)=>({
                ...locationOverides,
                [`${tenant.id}-${stackName}`]: newLocation
            }));
    }, [
        postgrest,
        locationOverides,
        locations
    ]);
    return {
        locations: locations,
        locationOverides: locationOverides,
        findTenantLocation: findTenantLocation,
        findTenantLocations: findTenantLocations,
        sendToLocation: sendToLocation
    };
};

});
parcelRegister("3AGzj", function(module, exports) {

$parcel$export(module.exports, "RampsStateContainer", () => $4eb7de1fea26bcfd$export$3386fbb1b990beb1);
$parcel$export(module.exports, "useRampsState", () => $4eb7de1fea26bcfd$export$de702eb0176649af);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4jPrg = parcelRequire("4jPrg");

var $ivJiD = parcelRequire("ivJiD");
// const RampStateContainerState = createContainer(useRampStateContainerState);
const $4eb7de1fea26bcfd$var$RampsStateContainerState = /*#__PURE__*/ $acw62.createContext({
    ramps: [],
    setRamps: ()=>{},
    isReference: false,
    ready: false
});
const $4eb7de1fea26bcfd$export$3386fbb1b990beb1 = ({ children: children, isReference: isReference })=>{
    const { ready: ready, ramps: ramps, setRamps: setRamps } = (0, $4jPrg.useRamps)(isReference, false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4eb7de1fea26bcfd$var$RampsStateContainerState.Provider, {
        value: {
            ramps: ramps,
            setRamps: setRamps,
            isReference: isReference,
            ready: ready
        },
        children: ready ? children : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ivJiD.RampsSkeleton), {})
    });
};
const $4eb7de1fea26bcfd$export$de702eb0176649af = ()=>$acw62.useContext($4eb7de1fea26bcfd$var$RampsStateContainerState);

});
parcelRegister("4jPrg", function(module, exports) {

$parcel$export(module.exports, "useRamps", () => $70b515e33b1931f5$export$812ad7e5feb81f3c);

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $5HLUx = parcelRequire("5HLUx");

var $8GP8k = parcelRequire("8GP8k");

var $W9FY8 = parcelRequire("W9FY8");
const $70b515e33b1931f5$export$812ad7e5feb81f3c = (isReference, includeReferenceImage = true)=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [ready, setReady] = $acw62.useState(false);
    const [ramps, setRamps] = $acw62.useState(null);
    (0, $W9FY8.default)({
        thingToWatch: ramps,
        tableName: "ramp"
    });
    // grab the ramp to start
    $acw62.useEffect(()=>{
        (async ()=>{
            const data = await (0, $8GP8k.fetchRamps)(postgrest, activeFBO, isReference, [], includeReferenceImage);
            setRamps(data.sort((a, b)=>(0, $5HLUx.sortRamps)(a, b, activeFBO?.settings?.rampDisplayOrder)));
            setReady(true);
        })();
    }, []);
    return {
        ready: ready,
        ramps: ramps ?? [],
        setRamps: setRamps
    };
};

});
parcelRegister("5HLUx", function(module, exports) {

$parcel$export(module.exports, "sortRamps", () => $597ee5a013d663a0$export$792a1d644e87113b);
$parcel$export(module.exports, "RampsPresenter", () => $597ee5a013d663a0$export$7bedfb93fa65e6af);

var $ayMG0 = parcelRequire("ayMG0");

var $8Ks9I = parcelRequire("8Ks9I");

var $gFNdt = parcelRequire("gFNdt");

var $ex6lH = parcelRequire("ex6lH");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $fBVnr = parcelRequire("fBVnr");

var $ZD2ym = parcelRequire("ZD2ym");

var $3AGzj = parcelRequire("3AGzj");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $apzof = parcelRequire("apzof");

var $XeBZd = parcelRequire("XeBZd");

var $97sqG = parcelRequire("97sqG");

var $foCxA = parcelRequire("foCxA");

var $ivJiD = parcelRequire("ivJiD");
const $597ee5a013d663a0$export$792a1d644e87113b = (a, b, rampDisplayOrder)=>{
    if (rampDisplayOrder) {
        const aIndex = rampDisplayOrder.indexOf(a.id);
        const bIndex = rampDisplayOrder.indexOf(b.id);
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        else if (aIndex !== -1) return -1;
        else if (bIndex !== -1) return 1;
    }
    return (0, $97sqG.sortByNumberThenText)(a.name, b.name);
};
const $597ee5a013d663a0$export$7bedfb93fa65e6af = ()=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { ramps: ramps, ready: ready } = (0, $3AGzj.useRampsState)();
    const sortedRamps = [
        ...ramps
    ].sort((a, b)=>$597ee5a013d663a0$export$792a1d644e87113b(a, b, activeFBO?.settings?.rampDisplayOrder));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            ml: 2,
            mr: 2,
            height: "100%",
            minHeight: "calc(100vh - 64px)",
            pb: 4
        },
        children: !ready ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ivJiD.RampsSkeleton), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: {
                        mt: 2,
                        mb: 2.25,
                        pb: 1.5,
                        borderBottom: "1px solid rgba(0,0,0,0.05)"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "h6",
                        children: [
                            "Ramps \u2013 ",
                            activeFBO?.name
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    sx: {
                        mb: 2,
                        width: "100%",
                        maxWidth: 900,
                        "& > *": {
                            flex: 1,
                            maxWidth: 420
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $XeBZd.StatCard), {
                            icon: (0, $apzof.RampIcon),
                            label: "Total Ramps",
                            value: ramps.length,
                            testId: "total_ramps"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $XeBZd.StatCard), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFNdt))),
                            label: "Total Aircraft on Ramps",
                            value: (0, $cLNZr.sum)(ramps.map((r)=>r.stack?.tenants?.length ?? 0)),
                            testId: "total_aircraft"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        flex: 1,
                        overflow: "auto",
                        minHeight: 0,
                        bgcolor: "background.paper",
                        ...(0, $lNEp2.scrollSx)
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                display: "grid",
                                gridTemplateColumns: "200px 160px 1fr",
                                alignItems: "center",
                                gap: 2,
                                px: 2.5,
                                py: 1,
                                borderBottom: "1px solid",
                                borderColor: "grey.200",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                                bgcolor: "background.paper"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: {
                                        fontWeight: 500,
                                        fontSize: "0.95rem"
                                    },
                                    children: "Ramp Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 0.5,
                                    justifyContent: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Ks9I))), {
                                            sx: {
                                                color: "text.disabled",
                                                fontSize: "0.85rem",
                                                opacity: 0.8
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                fontWeight: 500,
                                                fontSize: "0.95rem"
                                            },
                                            children: "Current Aircraft"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "# of aircraft on the ramp",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "text.disabled",
                                                    fontSize: "0.85rem",
                                                    opacity: 0.8
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "flex-end",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            fontWeight: 500,
                                            fontSize: "0.95rem"
                                        },
                                        children: "Actions"
                                    })
                                })
                            ]
                        }),
                        sortedRamps.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fBVnr.EmptyState), {
                            title: "No Ramps Yet",
                            description: "Create your first ramp to start managing aircraft parking and scheduling.",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $apzof.RampIcon), {
                                sx: {
                                    fontSize: 64,
                                    opacity: 0.5
                                }
                            })
                        }) : sortedRamps.map((ramp)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $foCxA.RampRow), {
                                ramp: ramp,
                                aircraftCount: ramp.stack?.tenants?.length ?? 0,
                                enableScheduling: activeFBO?.settings?.enableScheduling ?? false
                            }, ramp.id))
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("apzof", function(module, exports) {

$parcel$export(module.exports, "RampIcon", () => $205fefc3dc3c646f$export$7e768057a605fe8c);

var $ayMG0 = parcelRequire("ayMG0");

var $3ErGR = parcelRequire("3ErGR");
const $205fefc3dc3c646f$export$7e768057a605fe8c = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), {
        ...props,
        viewBox: "0 0 30 30",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            style: {
                stroke: "none",
                fillRule: "nonzero",
                fill: "currentColor",
                fillOpacity: 1
            },
            d: "M 8 4 A 2 2 0 0 0 6.03125 5.6542969 L 6.0292969 5.65625 L 3.03125 23.642578 L 3.0332031 23.644531 A 2 2 0 0 0 3 24 A 2 2 0 0 0 5 26 L 14 26 L 14 21 L 16 21 L 16 26 L 25 26 A 2 2 0 0 0 27 24 A 2 2 0 0 0 26.966797 23.644531 L 26.96875 23.642578 L 23.970703 5.6601562 A 2 2 0 0 0 23.970703 5.65625 L 23.96875 5.65625 A 2 2 0 0 0 22 4 L 16 4 L 16 6 L 14 6 L 14 4 L 8 4 z M 14 8 L 16 8 L 16 11 L 14 11 L 14 8 z M 14 13 L 16 13 L 16 18 L 14 18 L 14 13 z"
        })
    });

});

parcelRegister("XeBZd", function(module, exports) {

$parcel$export(module.exports, "StatCard", () => $3dc1c159147a2bcb$export$b5cddb1a6bf990a0);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $8gMkr = parcelRequire("8gMkr");
const $3dc1c159147a2bcb$var$fadeInUp = {
    '@keyframes fadeInUp': {
        '0%': {
            opacity: 0,
            transform: 'translateY(4px)'
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)'
        }
    }
};
const $3dc1c159147a2bcb$export$b5cddb1a6bf990a0 = ({ icon: Icon, label: label, value: value, testId: testId })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5WjaY.default), {
        sx: {
            width: "100%",
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "10px",
            boxShadow: 1,
            position: "relative",
            overflow: "hidden",
            transition: "transform 0.2s ease-in-out, box-shadow 0.15s ease",
            ...$3dc1c159147a2bcb$var$fadeInUp,
            animation: 'fadeInUp 150ms ease forwards',
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "3px",
                bgcolor: "primary.main",
                borderRadius: "10px 10px 0 0",
                zIndex: 2
            },
            "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 3
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "8px",
                    background: (theme)=>`linear-gradient(to bottom, ${(0, $8gMkr.alpha)(theme.palette.primary.main, 0.14)} 0%, ${(0, $8gMkr.alpha)(theme.palette.primary.main, 0.04)} 20%, transparent 100%)`,
                    pointerEvents: "none",
                    zIndex: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                sx: {
                    px: 3.5,
                    py: 3,
                    position: "relative",
                    zIndex: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                width: 42,
                                height: 42,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                bgcolor: (theme)=>(0, $8gMkr.alpha)(theme.palette.primary.main, 0.10),
                                color: "primary.main"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                sx: {
                                    fontSize: 24,
                                    color: "inherit"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 0.5,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    sx: {
                                        fontWeight: 500,
                                        color: "text.secondary",
                                        lineHeight: 1.2
                                    },
                                    children: label
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    sx: {
                                        fontSize: "1.75rem",
                                        fontWeight: 700,
                                        lineHeight: 1.1,
                                        display: "block",
                                        color: "text.primary"
                                    },
                                    "data-testid": testId,
                                    children: value
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("5WjaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $45313e7d506ce734$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $7Frhn = parcelRequire("7Frhn");

var $bOBRq = parcelRequire("bOBRq");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bOBRq.getCardUtilityClass), classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    overflow: 'hidden'
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $45313e7d506ce734$export$2e2bcd8739ae039 = $45313e7d506ce734$var$Card;

});
parcelRegister("bOBRq", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", () => $89a1bb9709695920$export$f3b76d2cce458caa);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $89a1bb9709695920$export$f3b76d2cce458caa(slot) {
    return (0, $4Cod0.default)('MuiCard', slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $beCSm.default)('MuiCard', [
    'root'
]);
var $89a1bb9709695920$export$2e2bcd8739ae039 = $89a1bb9709695920$var$cardClasses;

});


parcelRegister("3ulHf", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a500ea92f2665f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3mVgJ = parcelRequire("3mVgJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $28a500ea92f2665f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3mVgJ.getCardContentUtilityClass), classes);
};
const $28a500ea92f2665f$var$CardContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $28a500ea92f2665f$var$CardContent = /*#__PURE__*/ $acw62.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $28a500ea92f2665f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28a500ea92f2665f$var$CardContentRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $28a500ea92f2665f$export$2e2bcd8739ae039 = $28a500ea92f2665f$var$CardContent;

});
parcelRegister("3mVgJ", function(module, exports) {

$parcel$export(module.exports, "getCardContentUtilityClass", () => $273fd99738f3adbe$export$964336739a8c7119);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $273fd99738f3adbe$export$964336739a8c7119(slot) {
    return (0, $4Cod0.default)('MuiCardContent', slot);
}
const $273fd99738f3adbe$var$cardContentClasses = (0, $beCSm.default)('MuiCardContent', [
    'root'
]);
var $273fd99738f3adbe$export$2e2bcd8739ae039 = $273fd99738f3adbe$var$cardContentClasses;

});



parcelRegister("foCxA", function(module, exports) {

$parcel$export(module.exports, "RampRow", () => $192c5321e43d4b51$export$b4f2b4214a2f8936);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $7R9OT = parcelRequire("7R9OT");
const $192c5321e43d4b51$export$b4f2b4214a2f8936 = ({ ramp: ramp, aircraftCount: aircraftCount, enableScheduling: enableScheduling })=>{
    const navigate = (0, $aphAM.useNavigate)();
    const gridColumns = "200px 160px 1fr";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            display: "grid",
            gridTemplateColumns: gridColumns,
            alignItems: "center",
            gap: 2,
            px: 2.5,
            py: 1.5,
            borderBottom: "1px solid",
            borderColor: "grey.200",
            transition: "background-color 0.15s ease",
            "&:hover": {
                bgcolor: "action.hover"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                sx: {
                    fontWeight: 600
                },
                children: ramp.name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    textAlign: "right"
                },
                children: aircraftCount
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                justifyContent: "flex-end",
                sx: {
                    flexWrap: "nowrap"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "contained",
                        color: "success",
                        onClick: ()=>{
                            (0, $7R9OT.default).track("Clicked Ramp", {
                                location_name: ramp.name,
                                location_type: "ramp"
                            });
                            navigate(`/ramps/${ramp.id}`);
                        },
                        sx: {
                            whiteSpace: "nowrap",
                            minWidth: "fit-content",
                            px: 1.5,
                            py: 0.4,
                            fontSize: "0.75rem",
                            borderRadius: "14px"
                        },
                        children: "Current Ramp"
                    }),
                    enableScheduling && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "contained",
                        color: "secondary",
                        onClick: ()=>{
                            (0, $7R9OT.default).track("Clicked Ramp Schedule", {
                                location_name: ramp.name,
                                location_type: "ramp"
                            });
                            navigate(`/ramps/${ramp.id}/schedule`);
                        },
                        sx: {
                            whiteSpace: "nowrap",
                            minWidth: "fit-content",
                            px: 1.5,
                            py: 0.4,
                            fontSize: "0.75rem",
                            borderRadius: "14px"
                        },
                        children: "Ramp Schedule"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "outlined",
                        sx: {
                            color: "text.primary",
                            borderColor: "grey.300",
                            whiteSpace: "nowrap",
                            minWidth: "fit-content",
                            px: 1.5,
                            py: 0.4,
                            fontSize: "0.75rem",
                            borderRadius: "14px",
                            "&:hover": {
                                borderColor: "grey.400",
                                bgcolor: "grey.50"
                            }
                        },
                        onClick: ()=>{
                            navigate(`/reference-ramps/${ramp.id}`);
                        },
                        children: "Edit Tie Down Tenants"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("ivJiD", function(module, exports) {

$parcel$export(module.exports, "RampsSkeleton", () => $27aa712311e078d1$export$7e0dacc180f68fb7);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
const $27aa712311e078d1$export$7e0dacc180f68fb7 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            ml: 2,
            mr: 2,
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    sx: {
                        mt: 2,
                        mb: 2
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                        variant: "text",
                        width: 300,
                        height: 40
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 2,
                    sx: {
                        mb: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                            variant: "outlined",
                            sx: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle1",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            width: 120
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            width: 40
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                            variant: "outlined",
                            sx: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle1",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            width: 180
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            width: 40
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                    variant: "rectangular",
                    height: "calc(100vh - 200px)",
                    width: "100%",
                    sx: {
                        minHeight: 400,
                        animation: "pulse 1.5s ease-in-out 0.5s infinite"
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        display: "none"
                    },
                    children: [
                        ...Array(5)
                    ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            sx: {
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 250,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 155,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 300,
                                    height: 30
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};

});


parcelRegister("8GP8k", function(module, exports) {

$parcel$export(module.exports, "resetAircraftCache", () => $49db6a2d24fa58c7$export$a352b43038246440);
$parcel$export(module.exports, "fetchAircraft", () => $49db6a2d24fa58c7$export$e7b9c13d217dcb7c);
$parcel$export(module.exports, "fetchAircraftWithCache", () => $49db6a2d24fa58c7$export$2c93ac57a2fb53cc);
$parcel$export(module.exports, "fetchHangar", () => $49db6a2d24fa58c7$export$6aabbb604cdca852);
$parcel$export(module.exports, "fetchHangars", () => $49db6a2d24fa58c7$export$ed837f001e849909);
$parcel$export(module.exports, "fetchRamp", () => $49db6a2d24fa58c7$export$856d55433da27a32);
$parcel$export(module.exports, "fetchRamps", () => $49db6a2d24fa58c7$export$7fda72a4726d478f);

var $lLxKB = parcelRequire("lLxKB");

var $d199i = parcelRequire("d199i");

var $5sKyw = parcelRequire("5sKyw");

var $f4OIt = parcelRequire("f4OIt");

var $88tPr = parcelRequire("88tPr");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");
let $49db6a2d24fa58c7$var$cache = {};
const $49db6a2d24fa58c7$export$88b9cbcd54dd7ff3 = (0, $f4OIt.create)()((0, $88tPr.persist)((set, get)=>({
        cache: {},
        getCachedResult: (key)=>get().cache[key],
        setCachedResult: (key, value)=>set((state)=>({
                    cache: {
                        ...state.cache,
                        [key]: value
                    }
                }))
    }), {
    name: `airplx/${(0, $lNEp2.envName)()}/geomBufferCache`,
    // Only persist the cache object
    partialize: (state)=>({
            cache: state.cache
        })
}));
const $49db6a2d24fa58c7$export$aa68fd26e593cc7e = (geoms, radius)=>{
    // Combine geoms and radius into a single string and hash it
    return (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify({
        geoms: geoms,
        radius: radius
    }));
};
const $49db6a2d24fa58c7$export$a352b43038246440 = ()=>{
    $49db6a2d24fa58c7$var$cache = {};
};
const $49db6a2d24fa58c7$export$753f64a47e4e80ee = async (postgrest, aircraftIds, _fbo)=>{
    const columns = [
        "id",
        "linked_to",
        "make",
        "model",
        "wingspan",
        "length",
        "tail_bottom",
        "tail_height",
        "scaled_geom",
        "scaled_geom_full",
        "geom",
        "pivot_point",
        "nose",
        "centroid",
        "midline",
        "front_wheels",
        "rear_wheels",
        "wheel_rotation_limit",
        "tail_wheel",
        "created_at"
    ].join(",");
    // split aircraftIdsToFetch into chunks of 10 to avoid PostgREST error
    const aircraftIdsToFetch = [];
    const batchsize = 10;
    for(let i = 0; i < aircraftIds.length; i += batchsize)aircraftIdsToFetch.push(aircraftIds.slice(i, i + batchsize));
    const limit = (0, (/*@__PURE__*/$parcel$interopDefault($d199i)))(5);
    // now fetch each chunk
    const newAircraftsChunksRaw = await Promise.all(aircraftIdsToFetch.map(async (chunk)=>{
        return limit(async ()=>{
            const { data: newAircraftsRawChunk } = await postgrest.from("aircraft").select(columns).in("id", chunk);
            return newAircraftsRawChunk;
        });
    }));
    return newAircraftsChunksRaw.flat();
};
const $49db6a2d24fa58c7$export$40c188ee4ecdb35a = async (postgrest, fbo)=>{
    const columns = [
        "id",
        "linked_to",
        "make",
        "model",
        "wingspan",
        "length",
        "tail_bottom",
        "tail_height",
        "scaled_geom",
        "scaled_geom_full",
        "geom",
        "pivot_point",
        "nose",
        "centroid",
        "midline",
        "front_wheels",
        "rear_wheels",
        "wheel_rotation_limit",
        "tail_wheel",
        "created_at"
    ].join(",");
    const { data: aircraft } = await postgrest.rpc("aircraft_for_fbo", {
        fbo_id: fbo.id
    }).select(columns);
    return aircraft;
};
const $49db6a2d24fa58c7$export$5135414f0c618480 = async (postgrest, aircraftIds, fbo)=>{
    if (aircraftIds.length === 0) return [];
    const columns = [
        "id",
        "linked_to",
        "make",
        "model",
        "wingspan",
        "length",
        "tail_bottom",
        "tail_height",
        "scaled_geom",
        "scaled_geom_full",
        "geom",
        "pivot_point",
        "nose",
        "centroid",
        "midline",
        "front_wheels",
        "rear_wheels",
        "wheel_rotation_limit",
        "tail_wheel",
        "created_at"
    ].join(",");
    // Use the modified aircraft_for_fbo function with specific aircraft IDs
    const { data: aircraft, error: error } = await postgrest.rpc("aircraft_for_fbo", {
        fbo_id: fbo.id,
        p_aircraft_ids: aircraftIds
    }).select(columns);
    if (error) {
        console.error("Failed to fetch aircraft by IDs:", error);
        return [];
    }
    return aircraft || [];
};
const $49db6a2d24fa58c7$export$d5073e7c38b1e59c = async (postgrest, geoms, fbo, isRamp = false)=>{
    // Calculate the radius based on FBO settings and isRamp flag
    const radius = (isRamp ? fbo.sop_ramp_horizontal_spacing : fbo.sop_horizontal_spacing) ?? 2;
    // Create a cache key from the input parameters
    // Get the cache store
    // const { getCachedResult, setCachedResult } = useGeomBufferCacheStore.getState();
    // Check if we have a cached result
    // const cachedResult = getCachedResult(cacheKey);
    // if (cachedResult) {
    //   return cachedResult;
    // }
    // If not in cache, fetch from server
    const { data: geom_scaled_buffers } = await postgrest.rpc("buffer", {
        geoms: geoms,
        radius: radius
    });
    // Store the result in cache
    // setCachedResult(cacheKey, geom_scaled_buffers);
    return geom_scaled_buffers;
};
const $49db6a2d24fa58c7$export$e7b9c13d217dcb7c = async (postgrest, aircraftId, fbo)=>{
    // Check if aircraft exists in cache
    if ($49db6a2d24fa58c7$var$cache[aircraftId]) return $49db6a2d24fa58c7$var$cache[aircraftId];
    // Fetch the single aircraft without using cache
    const columns = [
        "id",
        "linked_to",
        "make",
        "model",
        "wingspan",
        "length",
        "tail_bottom",
        "tail_height",
        "scaled_geom",
        "scaled_geom_full",
        "geom",
        "pivot_point",
        "nose",
        "centroid",
        "midline",
        "front_wheels",
        "rear_wheels",
        "wheel_rotation_limit",
        "tail_wheel",
        "created_at"
    ].join(",");
    const { data: aircraftRaw } = await postgrest.from("aircraft").select(columns).eq("id", aircraftId).limit(1);
    if (!aircraftRaw || aircraftRaw.length === 0) return null;
    // Get geom buffers for the aircraft
    const scaled_geom_full = aircraftRaw[0].scaled_geom_full;
    const geom_scaled_buffer = await $49db6a2d24fa58c7$export$d5073e7c38b1e59c(postgrest, [
        scaled_geom_full
    ], fbo, false);
    const ramp_geom_scaled_buffer = await $49db6a2d24fa58c7$export$d5073e7c38b1e59c(postgrest, [
        scaled_geom_full
    ], fbo, true);
    // Create the aircraft object with buffers
    const aircraft = {
        ...aircraftRaw[0],
        geom_scaled_buffer: geom_scaled_buffer[0],
        ramp_geom_scaled_buffer: ramp_geom_scaled_buffer[0],
        image: window.location.protocol === "http:" ? `/${aircraftRaw[0].id}.png` : `https://static.airplx.com/${aircraftRaw[0].id}.png`
    };
    // Preload the image
    const img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.src = aircraft.image;
    // Add to cache
    $49db6a2d24fa58c7$var$cache[aircraftId] = aircraft;
    return aircraft;
};
const $49db6a2d24fa58c7$export$2c93ac57a2fb53cc = async (postgrest, aircraftIds, fbo)=>{
    const aircrafts = [];
    const aircraftIdsToFetch = [];
    for (const aircraftId of aircraftIds){
        if ($49db6a2d24fa58c7$var$cache[aircraftId]) {
            aircrafts.push($49db6a2d24fa58c7$var$cache[aircraftId]);
            continue;
        }
        aircraftIdsToFetch.push(aircraftId);
    }
    if (aircraftIdsToFetch.length === 0) return aircrafts;
    // Fetch only the specific aircraft IDs that we need
    const newAircraftsRaw = await $49db6a2d24fa58c7$export$5135414f0c618480(postgrest, aircraftIdsToFetch, fbo);
    const scaled_geom_fulls = newAircraftsRaw.map(({ scaled_geom_full: scaled_geom_full })=>scaled_geom_full);
    const geom_scaled_buffers = await $49db6a2d24fa58c7$export$d5073e7c38b1e59c(postgrest, scaled_geom_fulls, fbo, false);
    const ramp_geom_scaled_buffers = await $49db6a2d24fa58c7$export$d5073e7c38b1e59c(postgrest, scaled_geom_fulls, fbo, true);
    const newAircraftsRawWithBufferedGeom = newAircraftsRaw.map((newAircraftRaw, idx)=>({
            ...newAircraftRaw,
            geom_scaled_buffer: geom_scaled_buffers[idx],
            ramp_geom_scaled_buffer: ramp_geom_scaled_buffers[idx]
        }));
    const newAircrafts = newAircraftsRawWithBufferedGeom.map((aircraftRaw)=>({
            ...aircraftRaw,
            image: window.location.protocol === "http:" ? `/${aircraftRaw.id}.png` : `https://static.airplx.com/${aircraftRaw.id}.png`
        }));
    // preload the images
    for (const aircraft of newAircrafts){
        const img = new Image();
        img.setAttribute("crossOrigin", "anonymous");
        img.src = aircraft.image;
    }
    $49db6a2d24fa58c7$var$cache = {
        ...$49db6a2d24fa58c7$var$cache,
        ...Object.fromEntries(newAircrafts.map((aircraft)=>[
                aircraft.id,
                aircraft
            ]))
    };
    return [
        ...aircrafts,
        ...newAircrafts
    ];
};
const $49db6a2d24fa58c7$export$67469de4a85fc64f = async (postgrest, obstacleIds, _fbo)=>{
    const predefinedObstacles = [];
    const predefinedObstacleIdsToFetch = [];
    for (const obstacleId of obstacleIds){
        if ($49db6a2d24fa58c7$var$cache[obstacleId]) {
            predefinedObstacles.push($49db6a2d24fa58c7$var$cache[obstacleId]);
            continue;
        }
        predefinedObstacleIdsToFetch.push(obstacleId);
    }
    if (predefinedObstacleIdsToFetch.length === 0) return predefinedObstacles;
    const { data: newPredefinedObstaclesRaw } = await postgrest.from("predefined_obstacle").select("*").in("id", predefinedObstacleIdsToFetch);
    const newPredefinedObstacles = newPredefinedObstaclesRaw.map((predefinedObstacle)=>({
            ...predefinedObstacle
        }));
    $49db6a2d24fa58c7$var$cache = {
        ...$49db6a2d24fa58c7$var$cache,
        ...Object.fromEntries(newPredefinedObstacles.map((predefinedObstacle)=>[
                predefinedObstacle.id,
                predefinedObstacle
            ]))
    };
    return [
        ...predefinedObstacles,
        ...newPredefinedObstacles
    ];
};
const $49db6a2d24fa58c7$export$6fbbfa1552411ebf = async (postgrest, hangar_location_ids)=>{
    const { data: data } = await postgrest.rpc("nightly_base_tenant_values", {
        hangar_location_ids: hangar_location_ids
    });
    return data;
};
const $49db6a2d24fa58c7$export$6aabbb604cdca852 = async (postgrest, activeFBO, hangar_id, isReference)=>{
    const hangars = await $49db6a2d24fa58c7$export$ed837f001e849909(postgrest, activeFBO, isReference, [
        hangar_id
    ]);
    return hangars.find((h)=>h.id === hangar_id);
};
const $49db6a2d24fa58c7$export$856d55433da27a32 = async (postgrest, activeFBO, ramp_id, isReference, includeReferenceImage = false)=>{
    const ramps = await $49db6a2d24fa58c7$export$7fda72a4726d478f(postgrest, activeFBO, isReference, [
        ramp_id
    ], includeReferenceImage);
    return ramps.find((r)=>r.id === ramp_id);
};
const $49db6a2d24fa58c7$export$7fda72a4726d478f = async (postgrest, activeFBO, isReference, limitToRampIds = [], includeReferenceImage = false)=>{
    let query = postgrest.rpc("ramps_for_fbo", {
        p_fbo_id: activeFBO.id,
        p_include_reference_image: includeReferenceImage
    }).select("*").order("name");
    if (limitToRampIds.length) query = query.in("id", limitToRampIds);
    const { data: __rampDataRaw } = await query;
    const rampDataRaw = __rampDataRaw.map((r)=>r.ramp);
    const aircraftIds = rampDataRaw.map(({ stacks: stacks })=>stacks.map((stack)=>stack.tenants.map((t)=>t.aircraft_id))).flat().flat().filter((x)=>x);
    const aircrafts = await $49db6a2d24fa58c7$export$2c93ac57a2fb53cc(postgrest, aircraftIds, activeFBO);
    // Validate all referenced aircraft were fetched
    const referencedAircraftIds = new Set();
    rampDataRaw.forEach((ramp)=>{
        ramp.stacks.forEach((stack)=>{
            stack.tenants.forEach((tenant)=>{
                if (tenant.aircraft_id) referencedAircraftIds.add(tenant.aircraft_id);
            });
        });
    });
    const fetchedAircraftIds = new Set(aircrafts.map((a)=>a.id));
    const missingAircraftIds = Array.from(referencedAircraftIds).filter((id)=>!fetchedAircraftIds.has(id));
    if (missingAircraftIds.length > 0) console.error('Data integrity issue: Tenants reference aircraft that were not fetched:', {
        missingCount: missingAircraftIds.length,
        missingIds: missingAircraftIds,
        possibleCauses: [
            'Aircraft deleted but tenant still references it (no FK constraint)',
            'Aircraft hidden/excluded from full_aircraft view',
            'Aircraft not loaded to web schema via web.load_aircraft()'
        ]
    });
    const predefinedObstacleIds = rampDataRaw.map(({ stacks: stacks })=>stacks.map((stack)=>stack.movable_obstacles.map((mo)=>mo.obstacle_id))).flat().flat().filter((x)=>x);
    const predefinedObstacles = await $49db6a2d24fa58c7$export$67469de4a85fc64f(postgrest, predefinedObstacleIds, activeFBO);
    const ramps = rampDataRaw.map((rampData)=>{
        const activeStack = isReference ? rampData.stacks.find((s)=>s.name === "reference") : rampData.stacks.find((s)=>s.name === "current");
        const ramp = {
            id: rampData.id,
            location_id: rampData.location_id,
            fbo_id: rampData.fbo_id,
            name: rampData.name,
            version: rampData.version,
            width: rampData.width,
            depth: rampData.depth,
            outline: rampData.outline,
            reference_image: rampData.reference_image,
            autoparking_enabled: rampData.autoparking_enabled,
            towing_equipment_id: rampData.towing_equipment_id,
            markings: rampData.markings ?? [],
            shapes: rampData.shapes ?? [],
            calibration_points: rampData.calibration_points ?? [],
            stacks: rampData.stacks.map((stack)=>({
                    id: stack.id,
                    location_id: stack.location_id,
                    name: stack.name,
                    tenants: stack.tenants.map((tenant)=>({
                            ...tenant,
                            selected: false,
                            placement_id: (0, $5sKyw.default)(),
                            // -- swap out for position.id
                            aircraft: aircrafts.find(({ id: id })=>tenant.aircraft_id === id) ?? {},
                            position: {
                                ...tenant.position,
                                preferences: tenant.position?.preferences ?? (0, $lNEp2.defaultPreferenceForAircraft)(aircrafts.find(({ id: id })=>tenant.aircraft_id === id), activeFBO)
                            }
                        })),
                    movableObstacles: stack.movable_obstacles.map((movableObstacle)=>({
                            ...movableObstacle,
                            selected: movableObstacle.selected ?? false,
                            placement_id: movableObstacle.position[0],
                            obstacle: predefinedObstacles.find((p)=>p.id === movableObstacle.obstacle_id),
                            position: {
                                ...movableObstacle.position,
                                preferences: movableObstacle.position?.preferences ?? []
                            }
                        })),
                    options: {
                        // these are the defaults
                        wall_spacing_left: 2,
                        wall_spacing_back: 2,
                        wall_spacing_right: 2,
                        horizontal_spacing: activeFBO?.sop_horizontal_spacing,
                        vertical_spacing: activeFBO?.sop_vertical_spacing,
                        overlap: activeFBO?.sop_overlap,
                        tug_spacing: 10,
                        density_threshold: 0.8,
                        towing_equipment_id: null,
                        corner_strategy: [
                            (0, $keHtM.CornerStrategy).ANGLE_45,
                            (0, $keHtM.CornerStrategy).ANGLE_45
                        ],
                        cloud_position_prioritization: true,
                        sample_size: 1000,
                        xy_weights: [
                            1,
                            2
                        ]
                    }
                })),
            // for now we'll just make a new stack each time.
            // this will be our default stack. eventually we'll pull this from the db if it exists
            stack: {
                id: activeStack.id,
                name: activeStack.name,
                location_id: rampData.location_id,
                isReference: isReference,
                tenants: activeStack.tenants.map((tenant)=>({
                        ...tenant,
                        selected: false,
                        placement_id: (0, $5sKyw.default)(),
                        // -- swap out for position.id
                        aircraft: aircrafts.find(({ id: id })=>tenant.aircraft_id === id) ?? {},
                        position: {
                            ...tenant.position,
                            preferences: tenant.position?.preferences ?? (0, $lNEp2.defaultPreferenceForAircraft)(aircrafts.find(({ id: id })=>tenant.aircraft_id === id), activeFBO)
                        }
                    })),
                movableObstacles: activeStack.movable_obstacles.map((movableObstacle)=>({
                        ...movableObstacle,
                        selected: movableObstacle.selected ?? false,
                        placement_id: movableObstacle.position[0],
                        obstacle: predefinedObstacles.find((p)=>p.id === movableObstacle.obstacle_id),
                        position: {
                            ...movableObstacle.position,
                            preferences: movableObstacle.position?.preferences ?? []
                        }
                    })),
                options: {
                    // these are the defaults
                    wall_spacing_left: 2,
                    wall_spacing_back: 2,
                    wall_spacing_right: 2,
                    horizontal_spacing: activeFBO?.sop_horizontal_spacing,
                    vertical_spacing: activeFBO?.sop_vertical_spacing,
                    overlap: activeFBO?.sop_overlap,
                    tug_spacing: 10,
                    density_threshold: 0.8,
                    towing_equipment_id: null,
                    corner_strategy: [
                        (0, $keHtM.CornerStrategy).ANGLE_45,
                        (0, $keHtM.CornerStrategy).ANGLE_45
                    ],
                    cloud_position_prioritization: true,
                    sample_size: 1000,
                    xy_weights: [
                        1,
                        2
                    ]
                }
            }
        };
        return ramp;
    });
    return ramps;
};
const $49db6a2d24fa58c7$export$ed837f001e849909 = async (postgrest, activeFBO, isReference, limitToHangarIds = [])=>{
    let query = postgrest.rpc("hangars_for_fbo", {
        p_fbo_id: activeFBO.id
    }).select("*").order("name");
    if (limitToHangarIds.length) query = query.in("id", limitToHangarIds);
    const { data: __hangarDataRaw } = await query;
    const hangarDataRaw = __hangarDataRaw.map((h)=>h.hangar);
    const aircraftIds = hangarDataRaw.map(({ stacks: stacks })=>stacks.map((stack)=>stack.tenants.map((t)=>t.aircraft_id))).flat().flat().filter((x)=>x);
    const aircrafts = await $49db6a2d24fa58c7$export$2c93ac57a2fb53cc(postgrest, aircraftIds, activeFBO);
    const predefinedObstacleIds = hangarDataRaw.map(({ stacks: stacks })=>stacks.map((stack)=>stack.movable_obstacles.map((mo)=>mo.obstacle_id))).flat().flat().filter((x)=>x);
    const predefinedObstacles = await $49db6a2d24fa58c7$export$67469de4a85fc64f(postgrest, predefinedObstacleIds, activeFBO);
    const hangars = hangarDataRaw.map((hangarData)=>{
        const activeStack = isReference ? hangarData.stacks.find((s)=>s.name === "reference") : hangarData.stacks.find((s)=>s.name === "current");
        const referenceStack = hangarData.stacks.find((s)=>s.name === "reference");
        const base_tenant_value = (0, $cLNZr.sum)(referenceStack?.tenants?.map((t)=>{
            const { wingspan: wingspan, length: length } = aircrafts.find(({ id: id })=>t.aircraft_id === id);
            return wingspan * length * activeFBO.nightly_base_rate;
        })) || 0;
        const hangar = {
            id: hangarData.id,
            location_id: hangarData.location_id,
            fbo_id: hangarData.fbo_id,
            name: hangarData.name,
            width: hangarData.width,
            depth: hangarData.depth,
            height: hangarData.height,
            left_door: hangarData.left_door,
            right_door: hangarData.right_door,
            wall_spacing_left: hangarData.wall_spacing_left,
            wall_spacing_back: hangarData.wall_spacing_back,
            wall_spacing_right: hangarData.wall_spacing_right,
            last_stacked: hangarData.last_stacked,
            base_tenant_value: base_tenant_value ?? 0,
            autostacking_enabled: hangarData.autostacking_enabled,
            towing_equipment_id: hangarData.towing_equipment_id,
            created_at: hangarData.created_at,
            obstacles: (hangarData.obstacles || []).map((obstacle)=>{
                const o = {
                    id: obstacle.id,
                    fbo_id: obstacle.fbo_id,
                    hangar_id: hangarData.id,
                    x: obstacle.x,
                    y: obstacle.y,
                    width: obstacle.width,
                    depth: obstacle.depth,
                    height: obstacle.height,
                    geom: obstacle.geom,
                    type: obstacle.type
                };
                return o;
            }),
            garageDoors: (hangarData.garage_doors || []).map((garageDoor)=>{
                const g = {
                    id: garageDoor.id,
                    fbo_id: garageDoor.fbo_id,
                    hangar_id: garageDoor.hangar_id,
                    wall: garageDoor.wall,
                    x: garageDoor.x,
                    y: garageDoor.y,
                    width: garageDoor.width
                };
                return g;
            }),
            bays: (hangarData.bays || []).map((bay)=>{
                const b = {
                    id: bay.id,
                    hangar_id: bay.hangar_id,
                    fbo_id: bay.fbo_id,
                    geom: bay.geom,
                    eave_height: bay.eave_height,
                    clear_height: bay.clear_height,
                    created_at: bay.created_at,
                    updated_at: bay.updated_at
                };
                return b;
            }),
            stacks: hangarData.stacks.map((stack)=>({
                    id: stack.id,
                    name: stack.name,
                    location_id: stack.location_id,
                    tenants: stack.tenants.map((tenant)=>({
                            ...tenant,
                            selected: false,
                            placement_id: (0, $5sKyw.default)(),
                            // -- swap out for position.id
                            aircraft: aircrafts.find(({ id: id })=>tenant.aircraft_id === id) ?? {},
                            position: {
                                ...tenant.position,
                                preferences: tenant.position?.preferences ?? (0, $lNEp2.defaultPreferenceForAircraft)(aircrafts.find(({ id: id })=>tenant.aircraft_id === id), activeFBO)
                            }
                        })),
                    movableObstacles: stack.movable_obstacles.map((movableObstacle)=>({
                            ...movableObstacle,
                            selected: movableObstacle.selected ?? false,
                            placement_id: movableObstacle.position[0],
                            obstacle: predefinedObstacles.find((p)=>p.id === movableObstacle.obstacle_id),
                            position: {
                                ...movableObstacle.position,
                                preferences: movableObstacle.position?.preferences ?? []
                            }
                        })),
                    options: {
                        // these are the defaults
                        wall_spacing_left: hangarData.wall_spacing_left ?? 2,
                        wall_spacing_back: hangarData.wall_spacing_back ?? 2,
                        wall_spacing_right: hangarData.wall_spacing_right ?? 2,
                        horizontal_spacing: activeFBO?.sop_horizontal_spacing,
                        vertical_spacing: activeFBO?.sop_vertical_spacing,
                        overlap: activeFBO?.sop_overlap,
                        tug_spacing: 10,
                        density_threshold: 0.8,
                        towing_equipment_id: null,
                        corner_strategy: [
                            (0, $keHtM.CornerStrategy).ANGLE_45,
                            (0, $keHtM.CornerStrategy).ANGLE_45
                        ],
                        cloud_position_prioritization: true,
                        sample_size: 1000,
                        xy_weights: [
                            1,
                            2
                        ]
                    }
                })),
            // for now we'll just make a new stack each time.
            // this will be our default stack. eventually we'll pull this from the db if it exists
            stack: {
                id: activeStack.id,
                name: activeStack.name,
                location_id: hangarData.location_id,
                isReference: isReference,
                tenants: activeStack.tenants.map((tenant)=>({
                        ...tenant,
                        selected: false,
                        placement_id: (0, $5sKyw.default)(),
                        // -- swap out for position.id
                        aircraft: aircrafts.find(({ id: id })=>tenant.aircraft_id === id) ?? {},
                        position: {
                            ...tenant.position,
                            preferences: tenant.position?.preferences ?? (0, $lNEp2.defaultPreferenceForAircraft)(aircrafts.find(({ id: id })=>tenant.aircraft_id === id), activeFBO)
                        }
                    })),
                movableObstacles: activeStack.movable_obstacles.map((movableObstacle)=>({
                        ...movableObstacle,
                        selected: movableObstacle.selected ?? false,
                        placement_id: movableObstacle.position[0],
                        obstacle: predefinedObstacles.find((p)=>p.id === movableObstacle.obstacle_id),
                        position: {
                            ...movableObstacle.position,
                            preferences: movableObstacle.position?.preferences ?? []
                        }
                    })),
                options: {
                    // these are the defaults
                    wall_spacing_left: hangarData.wall_spacing_left ?? 2,
                    wall_spacing_back: hangarData.wall_spacing_back ?? 2,
                    wall_spacing_right: hangarData.wall_spacing_right ?? 2,
                    horizontal_spacing: activeFBO?.sop_horizontal_spacing,
                    vertical_spacing: activeFBO?.sop_vertical_spacing,
                    overlap: activeFBO?.sop_overlap,
                    tug_spacing: 10,
                    density_threshold: 0.8,
                    towing_equipment_id: null,
                    corner_strategy: [
                        (0, $keHtM.CornerStrategy).ANGLE_45,
                        (0, $keHtM.CornerStrategy).ANGLE_45
                    ],
                    cloud_position_prioritization: true,
                    sample_size: 1000,
                    xy_weights: [
                        1,
                        2
                    ]
                }
            }
        };
        return hangar;
    });
    return hangars;
};
const $49db6a2d24fa58c7$export$44c7dd4c9ad16a27 = async (postgrest, hangar_id)=>{
    const { data: data } = await postgrest.rpc("generate_hangar_heatmap", {
        id: hangar_id
    });
    return data;
};

});
parcelRegister("d199i", function(module, exports) {
'use strict';

var $b3p1W = parcelRequire("b3p1W");
const $97a277202da6885a$var$pLimit = (concurrency)=>{
    if (!((Number.isInteger(concurrency) || concurrency === Infinity) && concurrency > 0)) throw new TypeError('Expected `concurrency` to be a number from 1 and up');
    const queue = new $b3p1W();
    let activeCount = 0;
    const next = ()=>{
        activeCount--;
        if (queue.size > 0) queue.dequeue()();
    };
    const run = async (fn, resolve, ...args)=>{
        activeCount++;
        const result = (async ()=>fn(...args))();
        resolve(result);
        try {
            await result;
        } catch  {}
        next();
    };
    const enqueue = (fn, resolve, ...args)=>{
        queue.enqueue(run.bind(null, fn, resolve, ...args));
        (async ()=>{
            // This function needs to wait until the next microtask before comparing
            // `activeCount` to `concurrency`, because `activeCount` is updated asynchronously
            // when the run function is dequeued and called. The comparison in the if-statement
            // needs to happen asynchronously as well to get an up-to-date value for `activeCount`.
            await Promise.resolve();
            if (activeCount < concurrency && queue.size > 0) queue.dequeue()();
        })();
    };
    const generator = (fn, ...args)=>new Promise((resolve)=>{
            enqueue(fn, resolve, ...args);
        });
    Object.defineProperties(generator, {
        activeCount: {
            get: ()=>activeCount
        },
        pendingCount: {
            get: ()=>queue.size
        },
        clearQueue: {
            value: ()=>{
                queue.clear();
            }
        }
    });
    return generator;
};
module.exports = $97a277202da6885a$var$pLimit;

});
parcelRegister("b3p1W", function(module, exports) {
class $80c3640207386fc4$var$Node {
    /// value;
    /// next;
    constructor(value){
        this.value = value;
        // TODO: Remove this when targeting Node.js 12.
        this.next = undefined;
    }
}
class $80c3640207386fc4$var$Queue {
    // TODO: Use private class fields when targeting Node.js 12.
    // #_head;
    // #_tail;
    // #_size;
    constructor(){
        this.clear();
    }
    enqueue(value) {
        const node = new $80c3640207386fc4$var$Node(value);
        if (this._head) {
            this._tail.next = node;
            this._tail = node;
        } else {
            this._head = node;
            this._tail = node;
        }
        this._size++;
    }
    dequeue() {
        const current = this._head;
        if (!current) return;
        this._head = this._head.next;
        this._size--;
        return current.value;
    }
    clear() {
        this._head = undefined;
        this._tail = undefined;
        this._size = 0;
    }
    get size() {
        return this._size;
    }
    *[Symbol.iterator]() {
        let current = this._head;
        while(current){
            yield current.value;
            current = current.next;
        }
    }
}
module.exports = $80c3640207386fc4$var$Queue;

});



parcelRegister("W9FY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cfabb5fb5d0efa0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1x7Ku = parcelRequire("1x7Ku");

var $2LXej = parcelRequire("2LXej");

var $js9Xf = parcelRequire("js9Xf");

var $5KGQl = parcelRequire("5KGQl");
const $7cfabb5fb5d0efa0$export$75093a47a9fa838d = (thing)=>{
    if (!thing) return [];
    if (Array.isArray(thing)) return thing;
    return [
        thing
    ];
};
const $7cfabb5fb5d0efa0$export$1a2e73cd2cfa2776 = ({ thingToWatch: thingToWatch, tableName: tableName, onUpdate: onUpdate, updateDatabase: updateDatabase, deleteFromDatabase: deleteFromDatabase, debounce: debounce = 0 })=>{
    // we're going to track arrays. so even thingToWatch is an object, we'll put it in an array.
    const arrayToWatch = Boolean(thingToWatch) ? $7cfabb5fb5d0efa0$export$75093a47a9fa838d(thingToWatch) : null;
    // we'll use this to track the array we're watching in memory. sometimes we get null data as input. we will
    // go ahead and filter that out.
    const [array, setArray] = (0, $acw62.useState)(Boolean(arrayToWatch) ? arrayToWatch.filter((x)=>x) : null);
    const { postgrest: postgrest, queue: queue } = (0, $2LXej.useApi)();
    const { schema: schema, loading: isSchemaLoading } = (0, $js9Xf.useSchema)();
    // this is our main watcher. we're going to look for changes between the
    // in memory array and the prop arrayToWatch.
    (0, $1x7Ku.default)(()=>{
        // load ze metadata!
        if (isSchemaLoading) return;
        // if thing to watch is null, we don't need to do anything yet.
        if (!thingToWatch) return;
        // the first time we see the arrayToWatch, we want to set the array. we'll consider this the initial state.
        if (!array) {
            setArray(arrayToWatch);
            return;
        }
        if (!schema) {
            console.error(`No schema found for table ${tableName}. Cannot sync to table.`);
            return;
        }
        (async ()=>{
            // we only want to be looking at the fields that are in the table we're syncing to
            // grab those fields from the objects in the array. if the field doesn't exist, set it to null.
            const extractTableFields = (obj)=>{
                return Object.fromEntries(schema[tableName].map((field)=>{
                    const value = obj[field] ?? null;
                    // Deep clone JSONB fields to ensure comparison works correctly
                    // This prevents reference equality issues with nested objects
                    if (field === 'metadata' || field === 'reference_points') return [
                        field,
                        value ? JSON.parse(JSON.stringify(value)) : null
                    ];
                    return [
                        field,
                        value
                    ];
                }));
            };
            // now grab the table fields for both the arrayToWatch and the tracked
            // array we have in memory within the hook.
            const arrayToWatchWithTableFields = arrayToWatch.map(extractTableFields);
            const arrayTopLevelWithTableFields = array.map(extractTableFields);
            // Diagnostic logging for shape table
            if (tableName === 'shape' && arrayToWatch.length > 0) console.log('[useSyncToTable] Shape sync debug:', {
                schemaColumns: schema[tableName],
                hasMetadata: schema[tableName]?.includes('metadata'),
                sampleExtracted: arrayToWatchWithTableFields[0],
                sampleOriginal: arrayToWatch[0]
            });
            // if the arrays are not equal, we need to update the database
            if (!(0, $5KGQl.arraysEqual)(arrayToWatchWithTableFields, arrayTopLevelWithTableFields)) {
                // Helper function to retry on foreign key violations
                const retryOnForeignKeyError = async (fn, retries = 3, delay = 500)=>{
                    try {
                        return await fn();
                    } catch (error) {
                        const errorMessage = error?.message || error?.toString() || "";
                        const isForeignKeyError = error?.code === "23503" || // PostgreSQL foreign key violation code
                        errorMessage.includes("foreign key constraint") || errorMessage.includes("violates foreign key");
                        if (isForeignKeyError && retries > 0) {
                            console.log(`Foreign key constraint error for ${tableName}, retrying in ${delay}ms... (${retries} retries left)`);
                            await new Promise((resolve)=>setTimeout(resolve, delay));
                            return retryOnForeignKeyError(fn, retries - 1, delay * 2);
                        }
                        throw error;
                    }
                };
                // default update will be to do a bulk upsert
                const updateDatabaseDefault = async (data)=>{
                    try {
                        await retryOnForeignKeyError(async ()=>{
                            return await postgrest?.from(tableName).upsert(data, {
                                returning: "minimal"
                            });
                        });
                    } catch (error) {
                        console.error(`Error updating ${tableName} table: ${error}`);
                    }
                };
                // default delete will be to delete by id
                const deleteFromDatabaseDefault = async (id)=>{
                    try {
                        await postgrest?.from(tableName).delete().eq("id", id);
                    } catch (error) {
                        console.error(`Error deleting ${id} from ${tableName} table: ${error}`);
                    }
                };
                // find items that have been updated
                const updatedItems = arrayToWatchWithTableFields.filter((item)=>{
                    const existingItem = arrayTopLevelWithTableFields.find(({ id: id })=>id === item.id);
                    return !existingItem || !(0, $5KGQl.objectsEqual)(existingItem, item);
                });
                // Log what's being updated
                if (tableName === 'shape' && updatedItems.length > 0) console.log('[useSyncToTable] Shapes to update:', {
                    count: updatedItems.length,
                    items: updatedItems.map((item)=>({
                            id: item.id,
                            type: item.type,
                            hasMetadata: item.metadata !== null && item.metadata !== undefined,
                            metadata: item.metadata
                        }))
                });
                // and find items that have been removed from the watch array
                const deletedItems = arrayTopLevelWithTableFields.filter((item)=>arrayToWatchWithTableFields.map(({ id: id })=>id).indexOf(item.id) === -1);
                console.log(`Updating ${tableName} table => updates: ${updatedItems.length}, deletes: ${deletedItems.length}`);
                if (updatedItems.length) // update items that have been updated in the watch array
                queue.addFunction(async ()=>{
                    if (Boolean(updateDatabase)) // Wrap custom update function with retry logic
                    await retryOnForeignKeyError(()=>updateDatabase(updatedItems));
                    else await updateDatabaseDefault(updatedItems);
                });
                // if we have an onUpdate function, call it with the updated items
                if (updatedItems.length && Boolean(onUpdate)) onUpdate(updatedItems);
                if (deletedItems.length) // delete items that have been removed from the watch array
                queue.addFunction(async ()=>await Promise.all(deletedItems.map((item)=>Boolean(deleteFromDatabase) ? deleteFromDatabase(item.id) : deleteFromDatabaseDefault(item.id))));
                setArray(arrayToWatch);
            }
        })();
    }, // optional debounce time. defaults to 0.
    debounce, [
        arrayToWatch,
        schema
    ]);
    // we'll return the array we're watching in memory, though likely won't need it.
    return array;
};
var $7cfabb5fb5d0efa0$export$2e2bcd8739ae039 = $7cfabb5fb5d0efa0$export$1a2e73cd2cfa2776;

});
parcelRegister("js9Xf", function(module, exports) {

$parcel$export(module.exports, "SchemaContainer", () => $3d02d1223485254e$export$423976b269b7be7d);
$parcel$export(module.exports, "useSchema", () => $3d02d1223485254e$export$aecd9c955413bc92);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $2LXej = parcelRequire("2LXej");

var $ay9Yf = parcelRequire("ay9Yf");
const $3d02d1223485254e$var$useSchemaContainerState = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { value: value, loading: loading } = (0, $2NPdf.default)(async ()=>{
        const { data: data } = await postgrest.rpc("columns");
        return Object.fromEntries(data.map((row)=>[
                row.table_name,
                row.column_names
            ]));
    });
    return {
        schema: value,
        loading: loading
    };
};
const $3d02d1223485254e$var$SchemaContainerState = (0, $ay9Yf.createContainer)($3d02d1223485254e$var$useSchemaContainerState);
const $3d02d1223485254e$export$423976b269b7be7d = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3d02d1223485254e$var$SchemaContainerState.Provider, {
        children: children
    });
};
const $3d02d1223485254e$export$aecd9c955413bc92 = $3d02d1223485254e$var$SchemaContainerState.useContainer;

});






parcelRegister("3JLDK", function(module, exports) {

$parcel$export(module.exports, "useLayout", () => $becb12ee64131fd4$export$f47430f7ffdcc134);
$parcel$export(module.exports, "CollapsibleRampActionCard", () => $becb12ee64131fd4$export$15b2983935563811);

var $ayMG0 = parcelRequire("ayMG0");

var $9uy2D = parcelRequire("9uy2D");

var $6lMlz = parcelRequire("6lMlz");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
parcelRequire("acw62");

var $f4OIt = parcelRequire("f4OIt");

var $88tPr = parcelRequire("88tPr");

var $gGfi1 = parcelRequire("gGfi1");

var $ZD2ym = parcelRequire("ZD2ym");
const $becb12ee64131fd4$export$f47430f7ffdcc134 = (0, $f4OIt.create)((0, $88tPr.persist)((set)=>({
        isDrawerOpen: true,
        setIsDrawerOpen: (isOpen)=>set({
                isDrawerOpen: isOpen
            })
    }), {
    name: "layout-storage" // name of the item in storage
}));
const $becb12ee64131fd4$export$15b2983935563811 = ({ location: location, children: children, onClickBack: onClickBack, hideTitle: hideTitle = false, hideNavigation: hideNavigation = false, extendBorderUp: extendBorderUp = false })=>{
    const { isDrawerOpen: isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen } = $becb12ee64131fd4$export$f47430f7ffdcc134();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const drawerWidth = 400;
    const miniDrawerWidth = 125;
    // Check if scheduling is enabled
    const isSchedulingEnabled = activeFBO?.settings?.enableScheduling ?? false;
    let namePrefix = "";
    if (location.stack.isReference) {
        if (location.type === "ramp") namePrefix = `[All Tie Down Tenants] `;
        else if (location.type === "hangar") namePrefix = `[All Tenants] `;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            width: isDrawerOpen ? drawerWidth : miniDrawerWidth,
            sx: {
                overflow: "hidden",
                transition: "width 0.3s",
                borderRight: 1,
                borderTop: extendBorderUp ? 1 : 0,
                borderLeft: 0,
                borderColor: "divider"
            },
            children: [
                !hideNavigation && isDrawerOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        p: 1
                    },
                    children: !hideTitle ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gGfi1.LocationNavigationHeader), {
                        locationName: `${namePrefix}${location.name}`,
                        locationId: location.id,
                        locationType: location.type,
                        isSchedulingEnabled: isSchedulingEnabled,
                        onBack: onClickBack,
                        rightActions: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: ()=>setIsDrawerOpen(!isDrawerOpen),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9uy2D))), {})
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "flex-end"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: ()=>setIsDrawerOpen(!isDrawerOpen),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9uy2D))), {})
                        })
                    })
                }),
                !hideNavigation && !isDrawerOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        p: 1,
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        onClick: ()=>setIsDrawerOpen(!isDrawerOpen),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6lMlz))), {})
                    })
                }),
                !hideNavigation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    display: "flex",
                    flex: 1,
                    overflow: "hidden",
                    children: children
                })
            ]
        })
    });
};

});
parcelRegister("gGfi1", function(module, exports) {

$parcel$export(module.exports, "LocationNavigationHeader", () => $f513d3e0d4771dd2$export$f3bd19701cbe57e7);

var $ayMG0 = parcelRequire("ayMG0");

var $1YLXO = parcelRequire("1YLXO");

var $03mUs = parcelRequire("03mUs");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $8VnCi = parcelRequire("8VnCi");
const $f513d3e0d4771dd2$export$f3bd19701cbe57e7 = ({ locationName: locationName, locationId: locationId, locationType: locationType, isSchedulingEnabled: isSchedulingEnabled = false, showBackButton: showBackButton = true, onBack: onBack, rightActions: rightActions })=>{
    const navigate = (0, $aphAM.useNavigate)();
    const handleBack = ()=>{
        if (onBack) onBack();
        else navigate(-1);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        spacing: 2,
        alignItems: "center",
        sx: {
            width: "100%"
        },
        children: [
            showBackButton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                onClick: handleBack,
                sx: {
                    alignSelf: "flex-start" // Align to top to match with chips
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YLXO))), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    flexGrow: 1,
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8VnCi.LocationViewSelector), {
                    locationName: locationName,
                    locationId: locationId,
                    locationType: locationType,
                    isSchedulingEnabled: isSchedulingEnabled
                })
            }),
            rightActions && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    alignSelf: "flex-start"
                },
                children: rightActions
            })
        ]
    });
};

});
parcelRegister("8VnCi", function(module, exports) {

$parcel$export(module.exports, "LocationViewSelector", () => $5ccfd647d2171d61$export$65344b458f37fab7);

var $ayMG0 = parcelRequire("ayMG0");

var $dLCr5 = parcelRequire("dLCr5");

var $aYQP7 = parcelRequire("aYQP7");

var $dTjVb = parcelRequire("dTjVb");

var $6ami2 = parcelRequire("6ami2");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");
const $5ccfd647d2171d61$export$65344b458f37fab7 = ({ locationName: locationName, locationId: locationId, locationType: locationType, isSchedulingEnabled: isSchedulingEnabled = false })=>{
    const navigate = (0, $aphAM.useNavigate)();
    const location = (0, $aphAM.useLocation)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    // Detect current view from URL using React Router
    const getCurrentView = ()=>{
        const path = location.pathname;
        if (path.includes("/schedule")) return "schedule";
        if (path.includes("/reference-")) return "tenants";
        return "current";
    };
    const currentView = getCurrentView();
    // Build navigation options - hide Schedule tab when not enabled
    const viewOptions = $acw62.useMemo(()=>{
        const baseRoute = `/${locationType}s`; // "/hangars" or "/ramps"
        const referenceRoute = `/reference-${locationType}s`; // "/reference-hangars" or "/reference-ramps"
        const options = [
            {
                label: "Current",
                value: "current",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dLCr5))), {}),
                path: `${baseRoute}/${locationId}`,
                disabled: false
            },
            // Only include Schedule tab when scheduling is enabled
            ...isSchedulingEnabled ? [
                {
                    label: "Schedule",
                    value: "schedule",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTjVb))), {}),
                    path: `${baseRoute}/${locationId}/schedule`,
                    disabled: false
                }
            ] : [],
            // Only include Tenants tab when user has permission to modify tenants
            ...hasPermission((0, $aHqXU.Permission).MODIFY_TENANTS) ? [
                {
                    label: "Tenants",
                    value: "tenants",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aYQP7))), {}),
                    path: `${referenceRoute}/${locationId}`,
                    disabled: false
                }
            ] : []
        ];
        return options;
    }, [
        locationId,
        locationType,
        isSchedulingEnabled,
        hasPermission
    ]);
    const handleNavigation = (path)=>{
        // All visible tabs are now clickable (no disabled tabs)
        navigate(path);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 0.5,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "row",
                spacing: 0.5,
                alignItems: "center",
                justifyContent: "center",
                children: viewOptions.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                        label: option.label,
                        icon: option.icon,
                        variant: currentView === option.value ? "filled" : "outlined",
                        size: "small",
                        clickable: true,
                        onClick: ()=>handleNavigation(option.path),
                        sx: {
                            fontSize: "0.75rem",
                            height: "24px",
                            borderRadius: "12px",
                            // Override global square corners for a more modern look
                            fontWeight: 500,
                            border: "1px solid",
                            transition: "all 0.2s ease-in-out",
                            "& .MuiChip-icon": {
                                fontSize: "14px",
                                marginLeft: "4px",
                                marginRight: "-2px"
                            },
                            "& .MuiChip-label": {
                                padding: "0 8px"
                            },
                            // Outlined state (inactive)
                            "&.MuiChip-outlined": {
                                borderColor: "divider",
                                backgroundColor: "transparent",
                                color: "text.secondary",
                                "&:hover": {
                                    borderColor: "primary.main",
                                    backgroundColor: "action.hover",
                                    color: "text.primary"
                                },
                                "&:focus": {
                                    borderColor: "primary.main",
                                    outline: "2px solid",
                                    outlineColor: "primary.main",
                                    outlineOffset: "1px"
                                }
                            },
                            // Filled state (active)
                            "&.MuiChip-filled": {
                                backgroundColor: "primary.main",
                                borderColor: "primary.main",
                                color: "primary.contrastText",
                                fontWeight: 600,
                                "&:hover": {
                                    backgroundColor: "primary.dark",
                                    borderColor: "primary.dark"
                                },
                                "&:focus": {
                                    outline: "2px solid",
                                    outlineColor: "primary.contrastText",
                                    outlineOffset: "1px"
                                }
                            },
                            // Ensure consistent appearance regardless of parent container
                            "&.MuiChip-root": {
                                minWidth: "fit-content",
                                "& .MuiChip-deleteIcon": {
                                    display: "none" // Hide delete icon if somehow present
                                }
                            }
                        }
                    }, option.value))
            }),
            locationName && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                sx: {
                    fontSize: {
                        xs: "1rem",
                        sm: "1.25rem"
                    },
                    fontWeight: 600
                },
                children: locationName
            })
        ]
    });
};

});
parcelRegister("dLCr5", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a05d7ab14403c256$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a05d7ab14403c256$var$_createSvgIcon = $a05d7ab14403c256$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a05d7ab14403c256$var$_default = module.exports.default = (0, $a05d7ab14403c256$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');

});

parcelRegister("aYQP7", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $7fe87b9c4aaaeeca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fe87b9c4aaaeeca$var$_createSvgIcon = $7fe87b9c4aaaeeca$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $7fe87b9c4aaaeeca$var$_default = module.exports.default = (0, $7fe87b9c4aaaeeca$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), 'People');

});




parcelRegister("kLEoe", function(module, exports) {

$parcel$export(module.exports, "HoldingAreaList", () => $e424abe747698fb5$export$9f3799a0603daa9);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $6rxM8 = parcelRequire("6rxM8");

var $8ORjT = parcelRequire("8ORjT");

var $cOIY7 = parcelRequire("cOIY7");
const $e424abe747698fb5$export$9f3799a0603daa9 = ({ tenants: tenants, onAssign: onAssign, onEdit: onEdit, onRemove: onRemove, onAdd: onAdd, setStack: setStack, location: location })=>{
    const { sendToLocation: sendToLocation } = (0, $6rxM8.useLocationsState)();
    // Sort tenants by created_at (newest first) for stable ordering
    const sortedTenants = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return [
            ...tenants
        ].sort((a, b)=>{
            // Handle missing timestamps by putting them at the end
            if (!a.created_at) return 1;
            if (!b.created_at) return -1;
            // Sort descending (newest first)
            return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        });
    }, [
        tenants
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 2,
        sx: {
            p: 2,
            height: "100%",
            width: "100%",
            overflowY: "auto",
            backgroundColor: "grey.100"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                sx: {
                    px: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        children: [
                            "Holding Area (",
                            tenants.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ORjT.AddTenantButton), {
                        sendToLocation: sendToLocation,
                        location: location,
                        stack: location.stack,
                        setStack: setStack,
                        onAdd: onAdd
                    })
                ]
            }),
            tenants.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                spacing: 1,
                children: sortedTenants.map((tenant)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cOIY7.HoldingAreaListItem), {
                        tenant: tenant,
                        onAssign: onAssign,
                        onEdit: onEdit,
                        onRemove: onRemove
                    }, tenant.id))
            }),
            tenants.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body2",
                    color: "text.secondary",
                    children: "No aircraft in holding area"
                })
            })
        ]
    });
};

});
parcelRegister("8ORjT", function(module, exports) {

$parcel$export(module.exports, "calculateInitialPosition", () => $1e193b0e406fe707$export$ad0425b978f5fcf0);
$parcel$export(module.exports, "AddTenantButton", () => $1e193b0e406fe707$export$7dca5fea1ab29e3e);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $8Ks9I = parcelRequire("8Ks9I");

var $dqlTG = parcelRequire("dqlTG");

var $iwiZ3 = parcelRequire("iwiZ3");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");
var $cVXaD = parcelRequire("cVXaD");
var $18tt9 = parcelRequire("18tt9");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $gqehT = parcelRequire("gqehT");

var $6rxM8 = parcelRequire("6rxM8");

var $6fDLr = parcelRequire("6fDLr");

var $koS2J = parcelRequire("koS2J");

var $9OZOC = parcelRequire("9OZOC");

var $5KGQl = parcelRequire("5KGQl");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $b4ldQ = parcelRequire("b4ldQ");

var $7R9OT = parcelRequire("7R9OT");

var $5kwJN = parcelRequire("5kwJN");

var $kgjm7 = parcelRequire("kgjm7");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");

var $bj2A9 = parcelRequire("bj2A9");

var $iEhC9 = parcelRequire("iEhC9");

var $7y2Rw = parcelRequire("7y2Rw");

var $iTQAE = parcelRequire("iTQAE");

var $bX2ze = parcelRequire("bX2ze");

var $jPO9z = parcelRequire("jPO9z");

var $63ZV6 = parcelRequire("63ZV6");

var $8UGfr = parcelRequire("8UGfr");

var $jxJ0r = parcelRequire("jxJ0r");
const $1e193b0e406fe707$export$ad0425b978f5fcf0 = (location, newAircraft, feetToPixels, x0, y0)=>{
    if (!location || !newAircraft) return;
    if (feetToPixels) {
        // check to see if the entire location is within the viewport
        const y = y0 > 0 ? y0 : -1 * Math.max(newAircraft.length, newAircraft.wingspan) + y0;
        // for the x position, we don't want to place the aircraft on top of another aircraft
        const polygons = (0, $5KGQl.getStackPolygons)(location.stack, 1e8, feetToPixels, null, false);
        // increment the x position until we find a spot that doesn't intersect with any other aircraft
        let x = x0 || 0;
        while(polygons.some((polygon)=>(0, $bj2A9.doBoundsIntersect)(polygon.bounds, [
                [
                    x,
                    y
                ],
                [
                    x + newAircraft.wingspan,
                    y + newAircraft.length
                ]
            ])))x += 10;
        return {
            x: x,
            y: y
        };
    }
    return {
        x: null,
        y: -1 * Math.max(newAircraft.length, newAircraft.wingspan)
    };
};
const $1e193b0e406fe707$export$7dca5fea1ab29e3e = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6rxM8.LocationsContainer), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1e193b0e406fe707$export$8e3354c4c757ebac, {
            ...props
        })
    });
const $1e193b0e406fe707$export$8e3354c4c757ebac = ({ location: location, sendToLocation: sendToLocation, stack: stack, setStack: setStack, onAdd: onAdd, hideAddMovableObstacle: hideAddMovableObstacle = false, bulk: bulk = true, disabled: disabled = false, feetToPixels: feetToPixels, iconButton: iconButton = false, isScheduledView: isScheduledView = false, onAddTrip: onAddTrip, currentTime: currentTime })=>{
    const theme = (0, $14H9o.default)();
    const isTablet = (0, $18tt9.default)(theme.breakpoints.down("lg"));
    const { initialPositionOffset: initialPositionOffset } = (0, $iEhC9.useLayoutCanvasState)();
    const { predefinedObstacles: predefinedObstacles } = (0, $koS2J.usePredefinedObstacle)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { tenants: tenants, setTenants: setTenants } = (0, $9OZOC.useTenants)();
    const [localCurrentLocation, setLocalCurrentLocation] = $acw62.useState();
    const [localAssignedLocation, setLocalAssignedLocation] = $acw62.useState();
    const [open, setOpen] = $acw62.useState(false);
    const [selectedTab, setSelectedTab] = $acw62.useState("");
    const [warnings, setWarnings] = $acw62.useState([]);
    const [tailNumber, setTailNumber] = $acw62.useState("");
    const [owner, setOwner] = $acw62.useState("");
    const [note, setNote] = $acw62.useState("");
    const [type, setType] = $acw62.useState(stack?.isReference ? "base" : "transient");
    const [bulkTenantsToAdd, setBulkTenantsToAdd] = $acw62.useState([]);
    const [newAircraft, setNewAircraft] = $acw62.useState();
    const [showConfirmation, setShowConfirmation] = $acw62.useState("");
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    // Add Trip tab ref and state
    const addTripTabRef = $acw62.useRef(null);
    const [tripFormState, setTripFormState] = $acw62.useState({
        isValid: false,
        loading: false
    });
    // Bulk Upload tab ref and state
    const bulkUploadRef = $acw62.useRef(null);
    const [bulkUploadFormState, setBulkUploadFormState] = $acw62.useState({
        isValid: false,
        loading: false
    });
    // Helper function to determine available tabs based on current props
    const getAvailableTabs = $acw62.useCallback(()=>{
        const tabs = [];
        if (!isScheduledView) {
            tabs.push("New Aircraft");
            if (Boolean(location)) tabs.push("Prior Transients", "Tenants");
            // Allow bulk add even without location (for Tenants page)
            if (bulk) tabs.push("Bulk Add");
        }
        if (isScheduledView && onAddTrip) tabs.push("Add Trip", "All Trips", "Bulk Upload");
        if (!hideAddMovableObstacle && Boolean(location)) tabs.push("Add Movable Obstacle");
        return tabs;
    }, [
        isScheduledView,
        location,
        bulk,
        onAddTrip,
        hideAddMovableObstacle
    ]);
    /**
   * not sure where to put this...
   */ const checkForWarnings = $acw62.useCallback((aircraft)=>{
        const warnings = (0, $b4ldQ.checkForAircraftWarnings)(aircraft, location);
        if (!warnings) return;
        setWarnings(warnings);
    }, [
        location
    ]);
    // Reset form state when dialog opens (but not when dependencies change while dialog is already open)
    const prevOpenRef = $acw62.useRef(open);
    $acw62.useEffect(()=>{
        // Only reset if dialog transitioned from closed to open
        if (open && !prevOpenRef.current) {
            setTailNumber("");
            setOwner("");
            setType(stack?.isReference ? "base" : "transient");
            setNote("");
            setWarnings([]);
            setNewAircraft(null);
            setLocalAssignedLocation(null);
            setLocalCurrentLocation(null);
            setBulkTenantsToAdd([]);
            setSelectedTab(""); // Reset tab selection when dialog opens
        }
        prevOpenRef.current = open;
    }, [
        open,
        stack
    ]); // Track full stack object to ensure latest value when dialog opens
    // Set default tab when dialog opens (separate effect to avoid resetting form on dependency changes)
    $acw62.useEffect(()=>{
        if (open && !selectedTab) {
            const availableTabs = getAvailableTabs();
            // Use the first available tab as default
            if (availableTabs.length > 0) {
                // Prefer "Add Trip" for scheduled view, "New Aircraft" otherwise, or first available
                if (isScheduledView && availableTabs.includes("Add Trip")) setSelectedTab("Add Trip");
                else if (!isScheduledView && availableTabs.includes("New Aircraft")) setSelectedTab("New Aircraft");
                else setSelectedTab(availableTabs[0]);
            }
        }
    }, [
        open,
        selectedTab,
        isScheduledView,
        getAvailableTabs
    ]);
    // Validate selectedTab when available tabs change
    $acw62.useEffect(()=>{
        if (open && selectedTab) {
            const availableTabs = getAvailableTabs();
            // If current tab is not available, reset to first available
            if (!availableTabs.includes(selectedTab) && availableTabs.length > 0) {
                // Prefer "Add Trip" for scheduled view, "New Aircraft" otherwise, or first available
                if (isScheduledView && availableTabs.includes("Add Trip")) setSelectedTab("Add Trip");
                else if (!isScheduledView && availableTabs.includes("New Aircraft")) setSelectedTab("New Aircraft");
                else setSelectedTab(availableTabs[0]);
            }
        }
    }, [
        open,
        selectedTab,
        getAvailableTabs,
        isScheduledView
    ]);
    $acw62.useEffect(()=>{
        checkForWarnings(newAircraft);
    }, [
        newAircraft
    ]);
    const onClickAddTenant = $acw62.useCallback(async (formData)=>{
        if (!newAircraft) return;
        if (type === "base" && (location || selectedTab !== "New Aircraft")) {
            setShowConfirmation((0, $5kwJN.addTenantConformationText)(!location || location?.type === "hangar" ? "hangar" : "ramp"));
            return;
        }
        const entity_id = (0, $lNEp2.uuidv4)();
        const tenant = {
            id: (0, $lNEp2.uuidv4)(),
            placement_id: (0, $lNEp2.uuidv4)(),
            fbo_id: activeFBO.id,
            entity_id: entity_id,
            owner_manager: formData.owner,
            tail_number: formData.tailNumber,
            note: formData.note,
            note_last_updated: new Date().toISOString(),
            note_last_updated_by: airplxIdentity?.email ?? "Unknown",
            type: stack?.isReference ? "base" : type,
            aircraft_id: newAircraft.id,
            aircraft: newAircraft,
            selected: false,
            position: {
                id: (0, $lNEp2.consistentId)(entity_id, stack?.isReference ?? false),
                stack_id: stack?.id,
                entity_id: entity_id,
                ...$1e193b0e406fe707$export$ad0425b978f5fcf0(location, newAircraft, feetToPixels, initialPositionOffset.xFeet, initialPositionOffset.yFeet),
                angle: null,
                preferences: (0, $lNEp2.defaultPreferenceForAircraft)(newAircraft, activeFBO)
            }
        };
        onAdd(tenant);
        setTenants(tenants.concat([
            tenant
        ]));
        setNewAircraft(null);
        setTailNumber("");
        setOwner("");
        setNote("");
        // setOpen(false);
        snackbar.notify({
            text: location ? `${tenant.aircraft.model} added to ${location.name}` : `${tenant.aircraft.model} added`,
            severity: "success"
        });
        // i don't like this but there isn't a great alternative. we need to wait for the tenant
        // to be created, then put it into the correct hangars
        setTimeout(async ()=>{
            if (Boolean(localCurrentLocation)) await sendToLocation(localCurrentLocation, "current", tenant);
            if (Boolean(localAssignedLocation)) await sendToLocation(localAssignedLocation, "reference", tenant);
        }, 100);
        (0, $7R9OT.default).track("New Aircraft", {
            aircraft_tenant_type: type,
            aircraft_type: newAircraft.model,
            aircraft_tail_number: formData.tailNumber
        });
    }, [
        location,
        stack,
        type,
        newAircraft,
        onAdd,
        sendToLocation,
        tenants,
        feetToPixels,
        initialPositionOffset,
        activeFBO,
        airplxIdentity,
        localCurrentLocation,
        localAssignedLocation,
        snackbar
    ]);
    const onClickBulkAdd = async ()=>{
        // bulk add
        setTenants([
            ...tenants,
            ...bulkTenantsToAdd
        ]);
        onAdd(bulkTenantsToAdd);
        // i don't like this but there isn't a great alternative. we need to wait for the tenant
        // to be created, then put it into the correct hangars
        setTimeout(async ()=>{
            if (Boolean(localCurrentLocation)) for (const tenant of bulkTenantsToAdd)await sendToLocation(localCurrentLocation, "current", tenant);
            if (Boolean(localAssignedLocation)) for (const tenant of bulkTenantsToAdd)await sendToLocation(localAssignedLocation, "reference", tenant);
        }, 100);
        setOpen(false);
    };
    const selectedTenant = $acw62.useMemo(()=>{
        return tenants?.filter((t)=>t.tail_number).find((t)=>t.tail_number.toLocaleUpperCase() === tailNumber.toLocaleUpperCase());
    }, [
        tenants,
        tailNumber
    ]);
    const onAddSelectedTenant = $acw62.useCallback(async (tenant, formData)=>{
        if (!showConfirmation && location?.stack?.isReference) {
            setShowConfirmation(!location || location?.type === "hangar" ? "We'll assign this new Base Tenant to this hangar. If you need to change default hangar assignments, you can do that by editing this specific aircraft." : "We'll assign this new Tie-Down Tenant to this ramp. If you need to change default ramp assignments, you can do that by editing this specific aircraft.");
            return;
        }
        const entity_id = tenant.entity_id ?? (0, $lNEp2.uuidv4)();
        const updatedTenant = {
            ...tenant,
            entity_id: entity_id,
            owner_manager: formData.owner || tenant.owner_manager,
            tail_number: formData.tailNumber || tenant.tail_number,
            note: formData.note,
            note_last_updated: formData.note ? new Date().toISOString() : tenant.note_last_updated,
            note_last_updated_by: formData.note ? airplxIdentity?.email ?? "Unknown" : tenant.note_last_updated_by,
            type: stack?.isReference ? "base" : tenant?.type ?? "transient",
            selected: false,
            position: {
                id: (0, $lNEp2.uuidv4)(),
                entity_id: tenant.entity_id,
                stack_id: stack?.id,
                ...$1e193b0e406fe707$export$ad0425b978f5fcf0(location, newAircraft, null, initialPositionOffset.xFeet, initialPositionOffset.yFeet),
                angle: null,
                preferences: (0, $lNEp2.defaultPreferenceForAircraft)(tenant.aircraft, activeFBO)
            }
        };
        if (sendToLocation && location && stack) await sendToLocation(location, stack.name, updatedTenant);
        onAdd({
            ...updatedTenant
        });
        (0, $7R9OT.default).track("Add Aircraft", {
            aircraft_tenant_type: type,
            aircraft_type: newAircraft?.model,
            aircraft_tail_number: formData.tailNumber
        });
        setNewAircraft(null);
        setTailNumber("");
        setOwner("");
        setType(stack?.isReference ? "base" : "transient");
        setNote("");
        setWarnings([]);
        snackbar.notify({
            text: location ? `${tenant.aircraft.model} added to ${location.name}` : `${tenant.aircraft.model} added`,
            severity: "success"
        });
    // setOpen(false);
    }, [
        location,
        stack,
        onAdd,
        type,
        newAircraft,
        initialPositionOffset
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            iconButton ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: isScheduledView ? "Add Trip" : "Add Aircraft",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    size: "small",
                    variant: "contained",
                    color: "info",
                    onClick: async ()=>setOpen(true),
                    sx: {
                        alignSelf: "center",
                        width: "80%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Ks9I))), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {})
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                disabled: disabled,
                variant: "contained",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                onClick: async ()=>setOpen(true),
                color: "info",
                children: isScheduledView ? "Add Trip" : "Add Aircraft"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: ()=>setOpen(false),
                maxWidth: "lg",
                fullScreen: isTablet,
                PaperProps: {
                    sx: {
                        ...isTablet && {
                            margin: 1,
                            width: "calc(100% - 16px)",
                            height: "calc(100% - 16px)"
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ejcfT.default), {
                        children: [
                            isScheduledView ? "Add Trip" : "Add Aircraft",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                "aria-label": "close",
                                onClick: ()=>setOpen(false),
                                sx: {
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme)=>theme.palette.grey[500]
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        sx: {
                            width: isTablet ? "100%" : 900,
                            height: isTablet ? "auto" : 600,
                            maxHeight: isTablet ? "calc(100vh - 180px)" : 600,
                            overflowY: "auto",
                            padding: isTablet ? 1.5 : 3,
                            paddingBottom: isTablet ? 12 : 3,
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            spacing: 4,
                            sx: {
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 2,
                                sx: {
                                    height: "100%"
                                },
                                children: [
                                    warnings.map((warning, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                            severity: "error",
                                            action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                size: "small",
                                                onClick: ()=>setWarnings(warnings.filter((w, i)=>i !== idx)),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                                                    fontSize: "inherit"
                                                })
                                            }),
                                            children: warning
                                        }, `warning-${idx}`)),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                                        value: selectedTab || false,
                                        onChange: (evt, newValue)=>setSelectedTab(newValue),
                                        "aria-label": "basic tabs example",
                                        children: [
                                            !isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                                value: "New Aircraft",
                                                label: "New Aircraft"
                                            }),
                                            !isScheduledView && Boolean(location) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                                value: "Prior Transients",
                                                label: "Prior Transients"
                                            }),
                                            !isScheduledView && Boolean(location) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                                value: "Tenants",
                                                label: "Tenants"
                                            }),
                                            !isScheduledView && bulk && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                                value: "Bulk Add",
                                                label: "Bulk Add"
                                            }),
                                            isScheduledView && onAddTrip && [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                                    value: "Add Trip",
                                                    label: "Add Trip"
                                                }, "add-trip"),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                                    value: "All Trips",
                                                    label: "All Trips"
                                                }, "all-trips"),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                                    value: "Bulk Upload",
                                                    label: "Bulk Upload"
                                                }, "bulk-upload")
                                            ],
                                            !hideAddMovableObstacle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                                value: "Add Movable Obstacle",
                                                label: "Add Movable Obstacle"
                                            })
                                        ]
                                    }),
                                    selectedTab === "New Aircraft" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8UGfr.NewAircraftForm), {
                                                disableAutocomplete: false,
                                                tailNumber: tailNumber,
                                                setTailNumber: setTailNumber,
                                                owner: owner,
                                                setOwner: setOwner,
                                                location: location,
                                                setShowConfirmation: setShowConfirmation,
                                                type: type,
                                                setType: setType,
                                                note: note,
                                                setNote: setNote,
                                                isReference: stack?.isReference,
                                                newAircraft: newAircraft,
                                                setNewAircraft: setNewAircraft,
                                                assignedLocation: localAssignedLocation,
                                                setAssignedLocation: setLocalAssignedLocation,
                                                currentLocation: localCurrentLocation,
                                                setCurrentLocation: setLocalCurrentLocation
                                            }),
                                            Boolean(selectedTenant) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iTQAE.AddSelectedTenant), {
                                                selectedTenant: selectedTenant,
                                                onAdd: (tenant)=>onAddSelectedTenant(tenant, {
                                                        tailNumber: tailNumber,
                                                        owner: owner,
                                                        note: note
                                                    }),
                                                isReference: stack?.isReference,
                                                location: location
                                            })
                                        ]
                                    }),
                                    selectedTab === "Prior Transients" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jxJ0r.TenantSelector), {
                                        tenantType: (0, $keHtM.TenantType).TRANSIENT,
                                        filterBy: (t)=>t.type === "transient",
                                        isReference: stack?.isReference,
                                        checkAircraftHeight: checkForWarnings,
                                        location: location,
                                        stack: stack,
                                        setStack: setStack,
                                        feetToPixels: feetToPixels
                                    }),
                                    selectedTab === "Tenants" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jxJ0r.TenantSelector), {
                                        tenantType: (0, $keHtM.TenantType).BASE,
                                        filterBy: (t)=>t.type === "base",
                                        isReference: stack?.isReference,
                                        checkAircraftHeight: checkForWarnings,
                                        stack: stack,
                                        setStack: setStack,
                                        location: location,
                                        feetToPixels: feetToPixels
                                    }),
                                    selectedTab === "Bulk Add" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63ZV6.BulkAdd), {
                                        stack: stack,
                                        bulkTenantsToAdd: bulkTenantsToAdd,
                                        setBulkTenantsToAdd: setBulkTenantsToAdd
                                    }),
                                    selectedTab === "Add Trip" && isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bX2ze.AddTripTab), {
                                        ref: addTripTabRef,
                                        location: location,
                                        currentTime: currentTime,
                                        tenants: tenants,
                                        onAddTrip: onAddTrip,
                                        onClose: ()=>setOpen(false),
                                        onStateChange: (isValid, loading)=>setTripFormState({
                                                isValid: isValid,
                                                loading: loading
                                            })
                                    }),
                                    selectedTab === "All Trips" && isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jPO9z.AllTripsTab), {
                                        locationId: location?.id,
                                        locationType: location?.type === "hangar" ? "hangar" : "ramp",
                                        currentTime: currentTime,
                                        onAssignmentComplete: ()=>{
                                            // Don't close dialog - let user see their changes
                                            // Trigger any refresh needed
                                            if (onAddTrip) // This will trigger a refresh of the scheduled view
                                            onAddTrip(null);
                                        },
                                        onCancel: ()=>setOpen(false)
                                    }),
                                    selectedTab === "Bulk Upload" && isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7y2Rw.SimpleBulkUpload), {
                                        ref: bulkUploadRef,
                                        open: true,
                                        onClose: ()=>{
                                        // Don't close the parent dialog, just clear any state if needed
                                        },
                                        onComplete: ()=>{
                                            // Trigger refresh of scheduled view
                                            if (onAddTrip) onAddTrip(null);
                                        },
                                        autoAssignLocationId: location?.id,
                                        autoAssignLocationType: location?.type === "hangar" ? "hangar" : "ramp",
                                        autoAssignLocationName: location?.name,
                                        embedded: true,
                                        onStateChange: (isValid, loading)=>setBulkUploadFormState({
                                                isValid: isValid,
                                                loading: loading
                                            })
                                    }),
                                    selectedTab === "Add Movable Obstacle" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kgjm7.MovableObstacleGrid), {
                                        location: location,
                                        movableObstacles: predefinedObstacles,
                                        stack: stack,
                                        setStack: setStack
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        sx: {
                            px: 3,
                            py: 2,
                            ...isTablet && {
                                position: "sticky",
                                bottom: 0,
                                backgroundColor: "background.paper",
                                boxShadow: 4,
                                borderTop: 1,
                                borderColor: "divider",
                                zIndex: 10
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "flex-end",
                            sx: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>setOpen(false),
                                        children: "Cancel"
                                    }),
                                    selectedTab === "New Aircraft" || selectedTab === "Bulk Add" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        disabled: selectedTab === "New Aircraft" && (Boolean(selectedTenant) || !Boolean(newAircraft)) || selectedTab === "Bulk Add" && bulkTenantsToAdd.length === 0,
                                        variant: "contained",
                                        color: "success",
                                        onClick: ()=>{
                                            if (selectedTab === "New Aircraft") onClickAddTenant({
                                                tailNumber: tailNumber,
                                                owner: owner,
                                                note: note
                                            });
                                            else // bulk add
                                            onClickBulkAdd();
                                        },
                                        children: "Add"
                                    }) : selectedTab === "Add Trip" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        disabled: !tripFormState.isValid || tripFormState.loading,
                                        variant: "contained",
                                        color: "success",
                                        onClick: ()=>addTripTabRef.current?.createTrip(),
                                        children: tripFormState.loading ? "Creating..." : "Create Trip"
                                    }) : selectedTab === "Bulk Upload" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        disabled: !bulkUploadFormState.isValid || bulkUploadFormState.loading,
                                        variant: "contained",
                                        color: "success",
                                        onClick: ()=>bulkUploadRef.current?.save(),
                                        children: bulkUploadFormState.loading ? "Saving..." : "Save Trips"
                                    }) : selectedTab === "All Trips" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "contained",
                                        color: "success",
                                        onClick: ()=>setOpen(false),
                                        children: "Done"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "contained",
                                        color: "success",
                                        onClick: ()=>setOpen(false),
                                        children: "Done"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            showConfirmation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Please Confirm",
                text: showConfirmation,
                onCancel: ()=>{
                // do nothing
                },
                onClose: ()=>{
                    setShowConfirmation("");
                },
                onOk: ()=>{
                    if (!newAircraft) {
                        setShowConfirmation("");
                        setType("base");
                        return;
                    }
                    const aircraft = selectedTenant?.aircraft ?? newAircraft;
                    const entity_id = selectedTenant?.entity_id ?? (0, $lNEp2.uuidv4)();
                    const tenant = {
                        id: selectedTenant?.id ?? (0, $lNEp2.uuidv4)(),
                        fbo_id: activeFBO?.id,
                        placement_id: (0, $lNEp2.uuidv4)(),
                        entity_id: selectedTenant?.entity_id ?? entity_id,
                        owner_manager: owner || selectedTenant?.owner_manager,
                        tail_number: selectedTenant?.tail_number ?? tailNumber,
                        type: stack?.isReference ? "base" : type,
                        aircraft_id: aircraft.id,
                        aircraft: aircraft,
                        selected: false,
                        position: {
                            id: (0, $lNEp2.consistentId)(entity_id, stack?.isReference ?? true),
                            stack_id: stack?.id,
                            entity_id: entity_id,
                            ...$1e193b0e406fe707$export$ad0425b978f5fcf0(location, newAircraft, null, initialPositionOffset.xFeet, initialPositionOffset.yFeet),
                            angle: null,
                            preferences: (0, $lNEp2.defaultPreferenceForAircraft)(aircraft, activeFBO)
                        }
                    };
                    onAdd(tenant);
                    setNewAircraft(null);
                    setTailNumber("");
                    setOwner("");
                    setNote("");
                    setShowConfirmation("");
                    setOpen(false);
                    // i don't like this but there isn't a great alternative. we need to wait for the tenant
                    // to be created, then put it into the correct hangars
                    setTimeout(async ()=>{
                        if (Boolean(localCurrentLocation)) await sendToLocation(localCurrentLocation, "current", tenant);
                        if (Boolean(localAssignedLocation)) await sendToLocation(localAssignedLocation, "reference", tenant);
                    }, 100);
                }
            })
        ]
    });
};

});
parcelRegister("koS2J", function(module, exports) {

$parcel$export(module.exports, "usePredefinedObstacle", () => $ea5037cf3ceffb97$export$7b6261ce459c373e);

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $lNEp2 = parcelRequire("lNEp2");
const $ea5037cf3ceffb97$export$7b6261ce459c373e = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [loading, setLoading] = $acw62.useState(true);
    const [error, setError] = $acw62.useState(null);
    const [predefinedObstacles, setPredefinedObstacles] = $acw62.useState([]);
    const fetchPredefinedObstacles = $acw62.useCallback(async ()=>{
        try {
            setError(null);
            const { data: data, error: fetchError } = await postgrest.from("predefined_obstacle").select().order("name");
            if (fetchError) throw fetchError;
            setPredefinedObstacles(data || []);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching predefined obstacles:", err);
            setError(err?.message || "Failed to fetch obstacles");
            setLoading(false);
        }
    }, [
        postgrest
    ]);
    $acw62.useEffect(()=>{
        fetchPredefinedObstacles();
    }, [
        fetchPredefinedObstacles
    ]);
    const upsertPredefinedObstacle = $acw62.useCallback(async (obstacle)=>{
        try {
            setError(null);
            // Call the admin upsert function
            const { data: data, error: rpcError } = await postgrest.rpc("admin_upsert_predefined_obstacle", {
                p_id: obstacle.id,
                p_name: obstacle.name,
                p_width: obstacle.width,
                p_length: obstacle.length,
                p_height: obstacle.height,
                p_image: obstacle.image
            });
            if (rpcError) throw rpcError;
            // Refresh the list
            await fetchPredefinedObstacles();
            return data;
        } catch (err) {
            console.error("Error upserting obstacle:", err);
            setError(err?.message || "Failed to save obstacle");
            throw err;
        }
    }, [
        postgrest,
        fetchPredefinedObstacles
    ]);
    const createPredefinedObstacle = $acw62.useCallback(async (obstacle)=>{
        const newObstacle = {
            ...obstacle,
            id: (0, $lNEp2.uuidv4)(),
            created_at: new Date().toISOString()
        };
        const id = await upsertPredefinedObstacle(newObstacle);
        return {
            ...newObstacle,
            id: typeof id === 'string' ? id : newObstacle.id
        };
    }, [
        upsertPredefinedObstacle
    ]);
    const deletePredefinedObstacle = $acw62.useCallback(async (id)=>{
        try {
            setError(null);
            // Call the admin delete function
            const { data: data, error: rpcError } = await postgrest.rpc("admin_delete_predefined_obstacle", {
                p_id: id
            });
            if (rpcError) throw rpcError;
            // Refresh the list
            await fetchPredefinedObstacles();
            return data;
        } catch (err) {
            console.error("Error deleting obstacle:", err);
            setError(err?.message || "Failed to delete obstacle");
            throw err;
        }
    }, [
        postgrest,
        fetchPredefinedObstacles
    ]);
    const updatePredefinedObstacle = $acw62.useCallback(async (obstacle)=>{
        return upsertPredefinedObstacle(obstacle);
    }, [
        upsertPredefinedObstacle
    ]);
    return {
        loading: loading,
        error: error,
        predefinedObstacles: predefinedObstacles,
        createPredefinedObstacle: createPredefinedObstacle,
        updatePredefinedObstacle: updatePredefinedObstacle,
        deletePredefinedObstacle: deletePredefinedObstacle,
        refreshObstacles: fetchPredefinedObstacles
    };
};

});

parcelRegister("9OZOC", function(module, exports) {

$parcel$export(module.exports, "useTenants", () => $31599d3792ac33fb$export$783bab0ce54251);

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $lNEp2 = parcelRequire("lNEp2");

var $8GP8k = parcelRequire("8GP8k");

var $W9FY8 = parcelRequire("W9FY8");
const $31599d3792ac33fb$export$783bab0ce54251 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [tenants, setTenants] = $acw62.useState();
    const [ready, setReady] = $acw62.useState(false);
    const fetchTenantsForFbo = $acw62.useCallback(async ()=>{
        if (!activeFBO?.id) {
            setTenants([]);
            setReady(true);
            return;
        }
        const { data: tenantsRaw } = await postgrest.from("tenant").select().eq("fbo_id", activeFBO.id).order("last_hangared", {
            ascending: false,
            nullsFirst: false
        });
        if (!tenantsRaw) {
            setTenants([]);
            setReady(true);
            return;
        }
        const aircraftIds = (0, $cLNZr.uniq)(tenantsRaw.map(({ aircraft_id: aircraft_id })=>aircraft_id));
        const aircrafts = await (0, $8GP8k.fetchAircraftWithCache)(postgrest, aircraftIds, activeFBO);
        const tenants = tenantsRaw.map((tenant)=>({
                ...tenant,
                id: tenant.id,
                placement_id: tenant.placement_id || (0, $lNEp2.uuidv4)(),
                // Only generate UUID if not already present
                aircraft: aircrafts.find(({ id: id })=>tenant.aircraft_id === id) ?? {},
                selected: false,
                preferences: tenant.preferences ?? (0, $lNEp2.defaultPreferenceForAircraft)(aircrafts.find(({ id: id })=>tenant.aircraft_id === id), activeFBO),
                position: {
                    x: null,
                    y: null,
                    angle: null
                }
            }));
        setTenants(tenants);
        setReady(true);
    }, [
        activeFBO,
        postgrest
    ]);
    // grab the hangar to start
    $acw62.useEffect(()=>{
        fetchTenantsForFbo();
    }, [
        fetchTenantsForFbo
    ]);
    const setTenant = $acw62.useCallback((tenant)=>{
        setTenants((prevTenants)=>{
            // if we're updating an existing tenant, then mutate the existing tenants
            if (prevTenants.find((t)=>t.id === tenant.id)) return prevTenants.map((t)=>t.id === tenant.id ? tenant : t);
            else // otherwise it's a new tenant, so add it
            return [
                tenant
            ].concat(prevTenants);
        });
    }, [] // No dependencies needed since we use the functional update pattern
    );
    (0, $W9FY8.default)({
        thingToWatch: tenants,
        tableName: "tenant"
    });
    return {
        ready: ready,
        tenants: tenants ?? [],
        setTenant: setTenant,
        setTenants: setTenants
    };
};

});

parcelRegister("b4ldQ", function(module, exports) {

$parcel$export(module.exports, "checkForAircraftWarnings", () => $2bb222593c7d961b$export$2fbaa4fbd30423e7);

var $7WcKq = parcelRequire("7WcKq");
const $2bb222593c7d961b$export$2fbaa4fbd30423e7 = (aircraft, location, position)=>{
    if (!location) return;
    // make sure we have a height to check
    if (!("height" in location)) return;
    // if it's a hangar, then run these checks...
    if (!location.height || !aircraft?.tail_height) return;
    const usableHangarWidth = location.width - (location.left_door ?? 0) - (location.right_door ?? 0);
    const newWarnings = [];
    // Use bay-aware height validation
    const heightValidation = (0, $7WcKq.validateAircraftHeight)(aircraft, location, position);
    newWarnings.push(...heightValidation.warnings);
    if (aircraft.wingspan >= usableHangarWidth) newWarnings.push(`The aircraft wingspan is ${aircraft.wingspan}ft and your hangar door is ${usableHangarWidth}ft wide. This aircraft will not fit.`);
    else if (aircraft.wingspan + 1 >= usableHangarWidth) newWarnings.push(`The aircraft wingspan is ${aircraft.wingspan}ft and your hangar door is ${usableHangarWidth}ft wide. Tow with extra caution.`);
    return newWarnings;
};

});
parcelRegister("7WcKq", function(module, exports) {

$parcel$export(module.exports, "validateAircraftHeight", () => $7046ff84f943b31b$export$359824b7d5a1983b);

var $kcAwA = parcelRequire("kcAwA");

var $ioYla = parcelRequire("ioYla");
function $7046ff84f943b31b$export$e6252c417fb992a1(x, y, bays) {
    if (!bays || bays.length === 0) return null;
    const testPoint = (0, $ioYla.point)([
        x,
        y
    ]);
    for (const bay of bays){
        if ((0, $kcAwA.default)(testPoint, bay.geom)) return bay;
    }
    return null;
}
/**
 * Validate if aircraft fits based on clear_height
 * Uses same logic as existing aircraftWarnings.ts:
 * - tail_height >= clear_height: ERROR (won't fit)
 * - tail_height + 1 >= clear_height: WARNING (tight fit)
 * - Otherwise: OK
 */ function $7046ff84f943b31b$var$checkHeightClearance(tailHeight, clearHeight) {
    if (tailHeight >= clearHeight) return {
        valid: false,
        warning: `Aircraft is ${tailHeight}ft tall but clearance is ${clearHeight}ft. This aircraft will not fit.`
    };
    else if (tailHeight + 1 >= clearHeight) return {
        valid: true,
        warning: `Aircraft is ${tailHeight}ft tall and clearance is ${clearHeight}ft. Tow with extra caution.`
    };
    return {
        valid: true
    };
}
function $7046ff84f943b31b$export$359824b7d5a1983b(aircraft, hangar, position) {
    // If hangar has no bays, use legacy validation
    if (!hangar.bays || hangar.bays.length === 0) {
        const check = $7046ff84f943b31b$var$checkHeightClearance(aircraft.tail_height, hangar.height);
        return {
            valid: check.valid,
            warnings: check.warning ? [
                check.warning
            ] : []
        };
    }
    // Hangar has bays
    if (position) {
        // Position-specific validation
        const bay = $7046ff84f943b31b$export$e6252c417fb992a1(position.x, position.y, hangar.bays);
        if (bay) {
            // Aircraft is in a bay - check bay clearance
            const check = $7046ff84f943b31b$var$checkHeightClearance(aircraft.tail_height, bay.clear_height);
            return {
                valid: check.valid,
                warnings: check.warning ? [
                    check.warning
                ] : [],
                bay: bay
            };
        } else {
            // Position is outside all bays - use hangar height as fallback
            const check = $7046ff84f943b31b$var$checkHeightClearance(aircraft.tail_height, hangar.height);
            return {
                valid: check.valid,
                warnings: check.warning ? [
                    check.warning
                ] : []
            };
        }
    } else {
        // No position specified - check if aircraft fits in ANY bay
        const fittingBayInfo = [];
        const nonFittingBayInfo = [];
        const totalBays = hangar.bays.length;
        hangar.bays.forEach((bay, index)=>{
            if (aircraft.tail_height < bay.clear_height) fittingBayInfo.push({
                index: index + 1,
                height: bay.clear_height
            });
            else nonFittingBayInfo.push({
                index: index + 1,
                height: bay.clear_height
            });
        });
        const fittingBays = fittingBayInfo.length;
        // Build descriptive message with specific bay information
        let warning = "";
        if (fittingBays === 0) {
            // Fits in no bays
            const bayList = nonFittingBayInfo.map((bay)=>`Bay ${bay.index} (${bay.height}ft)`).join(", ");
            warning = `Does not fit in any bay. ${bayList}. Aircraft is ${aircraft.tail_height}ft tall.`;
            return {
                valid: false,
                warnings: [
                    warning
                ],
                fittingBays: fittingBays,
                totalBays: totalBays
            };
        } else if (fittingBays < totalBays) {
            // Fits in some bays
            const fittingList = fittingBayInfo.map((bay)=>`Bay ${bay.index} (${bay.height}ft clear)`).join(", ");
            const nonFittingList = nonFittingBayInfo.map((bay)=>`Bay ${bay.index} (${bay.height}ft clear)`).join(", ");
            warning = `Fits in ${fittingList} but NOT in ${nonFittingList}. Aircraft is ${aircraft.tail_height}ft tall.`;
            return {
                valid: true,
                warnings: [
                    warning
                ],
                fittingBays: fittingBays,
                totalBays: totalBays
            };
        } else // Fits in all bays - no warning needed
        return {
            valid: true,
            warnings: [],
            fittingBays: fittingBays,
            totalBays: totalBays
        };
    }
}

});
parcelRegister("kcAwA", function(module, exports) {

$parcel$export(module.exports, "booleanPointInPolygon", () => $eb5142abb82d444a$export$ae7424f794b3544b);
$parcel$export(module.exports, "default", () => $eb5142abb82d444a$export$2e2bcd8739ae039);
// index.ts

var $fDA3K = parcelRequire("fDA3K");

var $9ShOK = parcelRequire("9ShOK");
function $eb5142abb82d444a$export$ae7424f794b3544b(point, polygon, options = {}) {
    if (!point) throw new Error("point is required");
    if (!polygon) throw new Error("polygon is required");
    const pt = (0, $9ShOK.getCoord)(point);
    const geom = (0, $9ShOK.getGeom)(polygon);
    const type = geom.type;
    const bbox = polygon.bbox;
    let polys = geom.coordinates;
    if (bbox && $eb5142abb82d444a$var$inBBox(pt, bbox) === false) return false;
    if (type === "Polygon") polys = [
        polys
    ];
    let result = false;
    for(var i = 0; i < polys.length; ++i){
        const polyResult = (0, $fDA3K.default)(pt, polys[i]);
        if (polyResult === 0) return options.ignoreBoundary ? false : true;
        else if (polyResult) result = true;
    }
    return result;
}
function $eb5142abb82d444a$var$inBBox(pt, bbox) {
    return bbox[0] <= pt[0] && bbox[1] <= pt[1] && bbox[2] >= pt[0] && bbox[3] >= pt[1];
}
var $eb5142abb82d444a$export$2e2bcd8739ae039 = $eb5142abb82d444a$export$ae7424f794b3544b;

});
parcelRegister("fDA3K", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6267831fe45cad0$export$2e2bcd8739ae039);
parcelRequire("8wZEW");
var $99ayO = parcelRequire("99ayO");
function $b6267831fe45cad0$export$2e2bcd8739ae039(p, polygon) {
    var i;
    var ii;
    var k = 0;
    var f;
    var u1;
    var v1;
    var u2;
    var v2;
    var currentP;
    var nextP;
    var x = p[0];
    var y = p[1];
    var numContours = polygon.length;
    for(i = 0; i < numContours; i++){
        ii = 0;
        var contour = polygon[i];
        var contourLen = contour.length - 1;
        currentP = contour[0];
        if (currentP[0] !== contour[contourLen][0] && currentP[1] !== contour[contourLen][1]) throw new Error('First and last coordinates in a ring must be the same');
        u1 = currentP[0] - x;
        v1 = currentP[1] - y;
        for(ii; ii < contourLen; ii++){
            nextP = contour[ii + 1];
            u2 = nextP[0] - x;
            v2 = nextP[1] - y;
            if (v1 === 0 && v2 === 0) {
                if (u2 <= 0 && u1 >= 0 || u1 <= 0 && u2 >= 0) return 0;
            } else if (v2 >= 0 && v1 <= 0 || v2 <= 0 && v1 >= 0) {
                f = (0, $99ayO.orient2d)(u1, u2, v1, v2, 0, 0);
                if (f === 0) return 0;
                if (f > 0 && v2 > 0 && v1 <= 0 || f < 0 && v2 <= 0 && v1 > 0) k++;
            }
            currentP = nextP;
            v1 = v2;
            u1 = u2;
        }
    }
    if (k % 2 === 0) return false;
    return true;
}

});
parcelRegister("8wZEW", function(module, exports) {

$parcel$export(module.exports, "orient2d", () => (parcelRequire("99ayO")).orient2d);

var $99ayO = parcelRequire("99ayO");

var $hrhb3 = parcelRequire("hrhb3");

var $6NnA6 = parcelRequire("6NnA6");

var $kFdHR = parcelRequire("kFdHR");

});
parcelRegister("99ayO", function(module, exports) {

$parcel$export(module.exports, "orient2d", () => $01b7f43767dc330f$export$bbb923599a46a7d8);

var $1oUYY = parcelRequire("1oUYY");
const $01b7f43767dc330f$var$ccwerrboundA = (3 + 16 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon);
const $01b7f43767dc330f$var$ccwerrboundB = (2 + 12 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon);
const $01b7f43767dc330f$var$ccwerrboundC = (9 + 64 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon) * (0, $1oUYY.epsilon);
const $01b7f43767dc330f$var$B = (0, $1oUYY.vec)(4);
const $01b7f43767dc330f$var$C1 = (0, $1oUYY.vec)(8);
const $01b7f43767dc330f$var$C2 = (0, $1oUYY.vec)(12);
const $01b7f43767dc330f$var$D = (0, $1oUYY.vec)(16);
const $01b7f43767dc330f$var$u = (0, $1oUYY.vec)(4);
function $01b7f43767dc330f$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, $1oUYY.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $1oUYY.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, $1oUYY.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $1oUYY.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $01b7f43767dc330f$var$B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $01b7f43767dc330f$var$B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $01b7f43767dc330f$var$B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $01b7f43767dc330f$var$B[3] = u3;
    let det = (0, $1oUYY.estimate)(4, $01b7f43767dc330f$var$B);
    let errbound = $01b7f43767dc330f$var$ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = $01b7f43767dc330f$var$ccwerrboundC * detsum + (0, $1oUYY.resulterrbound) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, $1oUYY.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $1oUYY.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, $1oUYY.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $1oUYY.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $01b7f43767dc330f$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $01b7f43767dc330f$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $01b7f43767dc330f$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $01b7f43767dc330f$var$u[3] = u3;
    const C1len = (0, $1oUYY.sum)(4, $01b7f43767dc330f$var$B, 4, $01b7f43767dc330f$var$u, $01b7f43767dc330f$var$C1);
    s1 = acx * bcytail;
    c = (0, $1oUYY.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $1oUYY.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, $1oUYY.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $1oUYY.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $01b7f43767dc330f$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $01b7f43767dc330f$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $01b7f43767dc330f$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $01b7f43767dc330f$var$u[3] = u3;
    const C2len = (0, $1oUYY.sum)(C1len, $01b7f43767dc330f$var$C1, 4, $01b7f43767dc330f$var$u, $01b7f43767dc330f$var$C2);
    s1 = acxtail * bcytail;
    c = (0, $1oUYY.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $1oUYY.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, $1oUYY.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $1oUYY.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $01b7f43767dc330f$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $01b7f43767dc330f$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $01b7f43767dc330f$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $01b7f43767dc330f$var$u[3] = u3;
    const Dlen = (0, $1oUYY.sum)(C2len, $01b7f43767dc330f$var$C2, 4, $01b7f43767dc330f$var$u, $01b7f43767dc330f$var$D);
    return $01b7f43767dc330f$var$D[Dlen - 1];
}
function $01b7f43767dc330f$export$bbb923599a46a7d8(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= $01b7f43767dc330f$var$ccwerrboundA * detsum) return det;
    return -$01b7f43767dc330f$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function $01b7f43767dc330f$export$c42fd1bc0c0a7484(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}

});
parcelRegister("1oUYY", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => $10543bd8b6a53b88$export$6c421550c66a327d);
$parcel$export(module.exports, "splitter", () => $10543bd8b6a53b88$export$8cfde575cbd41e40);
$parcel$export(module.exports, "resulterrbound", () => $10543bd8b6a53b88$export$a4103c3ab16b06d7);
$parcel$export(module.exports, "sum", () => $10543bd8b6a53b88$export$8a63f25cc62965f1);
$parcel$export(module.exports, "sum_three", () => $10543bd8b6a53b88$export$195a93e4bd4d876f);
$parcel$export(module.exports, "scale", () => $10543bd8b6a53b88$export$dcdf75081b88279d);
$parcel$export(module.exports, "negate", () => $10543bd8b6a53b88$export$aef51622e549b8b0);
$parcel$export(module.exports, "estimate", () => $10543bd8b6a53b88$export$9f3a0795ca2cc944);
$parcel$export(module.exports, "vec", () => $10543bd8b6a53b88$export$202e0172ed3c7be0);
const $10543bd8b6a53b88$export$6c421550c66a327d = 1.1102230246251565e-16;
const $10543bd8b6a53b88$export$8cfde575cbd41e40 = 134217729;
const $10543bd8b6a53b88$export$a4103c3ab16b06d7 = (3 + 8 * $10543bd8b6a53b88$export$6c421550c66a327d) * $10543bd8b6a53b88$export$6c421550c66a327d;
function $10543bd8b6a53b88$export$8a63f25cc62965f1(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $10543bd8b6a53b88$export$195a93e4bd4d876f(alen, a, blen, b, clen, c, tmp, out) {
    return $10543bd8b6a53b88$export$8a63f25cc62965f1($10543bd8b6a53b88$export$8a63f25cc62965f1(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function $10543bd8b6a53b88$export$dcdf75081b88279d(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = $10543bd8b6a53b88$export$8cfde575cbd41e40 * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = $10543bd8b6a53b88$export$8cfde575cbd41e40 * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = $10543bd8b6a53b88$export$8cfde575cbd41e40 * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $10543bd8b6a53b88$export$aef51622e549b8b0(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function $10543bd8b6a53b88$export$9f3a0795ca2cc944(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function $10543bd8b6a53b88$export$202e0172ed3c7be0(n) {
    return new Float64Array(n);
}

});


parcelRegister("hrhb3", function(module, exports) {

var $1oUYY = parcelRequire("1oUYY");
const $cb22485b018e4f9b$var$o3derrboundA = (7 + 56 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon);
const $cb22485b018e4f9b$var$o3derrboundB = (3 + 28 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon);
const $cb22485b018e4f9b$var$o3derrboundC = (26 + 288 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon) * (0, $1oUYY.epsilon);
const $cb22485b018e4f9b$var$bc = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$ca = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$ab = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$at_b = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$at_c = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$bt_c = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$bt_a = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$ct_a = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$ct_b = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$bct = (0, $1oUYY.vec)(8);
const $cb22485b018e4f9b$var$cat = (0, $1oUYY.vec)(8);
const $cb22485b018e4f9b$var$abt = (0, $1oUYY.vec)(8);
const $cb22485b018e4f9b$var$u = (0, $1oUYY.vec)(4);
const $cb22485b018e4f9b$var$_8 = (0, $1oUYY.vec)(8);
const $cb22485b018e4f9b$var$_8b = (0, $1oUYY.vec)(8);
const $cb22485b018e4f9b$var$_16 = (0, $1oUYY.vec)(8);
const $cb22485b018e4f9b$var$_12 = (0, $1oUYY.vec)(12);
let $cb22485b018e4f9b$var$fin = (0, $1oUYY.vec)(192);
let $cb22485b018e4f9b$var$fin2 = (0, $1oUYY.vec)(192);
function $cb22485b018e4f9b$var$finadd(finlen, alen, a) {
    finlen = (0, $1oUYY.sum)(finlen, $cb22485b018e4f9b$var$fin, alen, a, $cb22485b018e4f9b$var$fin2);
    const tmp = $cb22485b018e4f9b$var$fin;
    $cb22485b018e4f9b$var$fin = $cb22485b018e4f9b$var$fin2;
    $cb22485b018e4f9b$var$fin2 = tmp;
    return finlen;
}
function $cb22485b018e4f9b$var$tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, $1oUYY.splitter) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, $1oUYY.splitter) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, $1oUYY.splitter) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, $1oUYY.splitter) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, $1oUYY.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $1oUYY.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, $1oUYY.splitter) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, $1oUYY.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, $1oUYY.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $1oUYY.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, $1oUYY.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $1oUYY.splitter) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, $1oUYY.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $1oUYY.splitter) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, $1oUYY.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $1oUYY.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function $cb22485b018e4f9b$var$tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, $1oUYY.splitter) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, $1oUYY.splitter) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, $1oUYY.splitter) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, $1oUYY.splitter) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    $cb22485b018e4f9b$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, $1oUYY.splitter) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    $cb22485b018e4f9b$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    $cb22485b018e4f9b$var$u[2] = _k - (u3 - _j);
    $cb22485b018e4f9b$var$u[3] = u3;
    finlen = $cb22485b018e4f9b$var$finadd(finlen, 4, $cb22485b018e4f9b$var$u);
    if (z !== 0) {
        c = (0, $1oUYY.splitter) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, $1oUYY.splitter) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        $cb22485b018e4f9b$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, $1oUYY.splitter) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        $cb22485b018e4f9b$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        $cb22485b018e4f9b$var$u[2] = _k - (u3 - _j);
        $cb22485b018e4f9b$var$u[3] = u3;
        finlen = $cb22485b018e4f9b$var$finadd(finlen, 4, $cb22485b018e4f9b$var$u);
    }
    return finlen;
}
function $cb22485b018e4f9b$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, $1oUYY.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $1oUYY.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $1oUYY.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $1oUYY.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cb22485b018e4f9b$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cb22485b018e4f9b$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cb22485b018e4f9b$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cb22485b018e4f9b$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $1oUYY.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $1oUYY.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $1oUYY.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $1oUYY.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cb22485b018e4f9b$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cb22485b018e4f9b$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cb22485b018e4f9b$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cb22485b018e4f9b$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $1oUYY.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $1oUYY.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $1oUYY.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $1oUYY.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cb22485b018e4f9b$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cb22485b018e4f9b$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cb22485b018e4f9b$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cb22485b018e4f9b$var$ab[3] = u3;
    finlen = (0, $1oUYY.sum)((0, $1oUYY.sum)((0, $1oUYY.scale)(4, $cb22485b018e4f9b$var$bc, adz, $cb22485b018e4f9b$var$_8), $cb22485b018e4f9b$var$_8, (0, $1oUYY.scale)(4, $cb22485b018e4f9b$var$ca, bdz, $cb22485b018e4f9b$var$_8b), $cb22485b018e4f9b$var$_8b, $cb22485b018e4f9b$var$_16), $cb22485b018e4f9b$var$_16, (0, $1oUYY.scale)(4, $cb22485b018e4f9b$var$ab, cdz, $cb22485b018e4f9b$var$_8), $cb22485b018e4f9b$var$_8, $cb22485b018e4f9b$var$fin);
    let det = (0, $1oUYY.estimate)(finlen, $cb22485b018e4f9b$var$fin);
    let errbound = $cb22485b018e4f9b$var$o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = $cb22485b018e4f9b$var$o3derrboundC * permanent + (0, $1oUYY.resulterrbound) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = $cb22485b018e4f9b$var$tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, $cb22485b018e4f9b$var$at_b, $cb22485b018e4f9b$var$at_c);
    const bt_len = $cb22485b018e4f9b$var$tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, $cb22485b018e4f9b$var$bt_c, $cb22485b018e4f9b$var$bt_a);
    const ct_len = $cb22485b018e4f9b$var$tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, $cb22485b018e4f9b$var$ct_a, $cb22485b018e4f9b$var$ct_b);
    const bctlen = (0, $1oUYY.sum)(bt_len, $cb22485b018e4f9b$var$bt_c, ct_len, $cb22485b018e4f9b$var$ct_b, $cb22485b018e4f9b$var$bct);
    finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(bctlen, $cb22485b018e4f9b$var$bct, adz, $cb22485b018e4f9b$var$_16), $cb22485b018e4f9b$var$_16);
    const catlen = (0, $1oUYY.sum)(ct_len, $cb22485b018e4f9b$var$ct_a, at_len, $cb22485b018e4f9b$var$at_c, $cb22485b018e4f9b$var$cat);
    finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(catlen, $cb22485b018e4f9b$var$cat, bdz, $cb22485b018e4f9b$var$_16), $cb22485b018e4f9b$var$_16);
    const abtlen = (0, $1oUYY.sum)(at_len, $cb22485b018e4f9b$var$at_b, bt_len, $cb22485b018e4f9b$var$bt_a, $cb22485b018e4f9b$var$abt);
    finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(abtlen, $cb22485b018e4f9b$var$abt, cdz, $cb22485b018e4f9b$var$_16), $cb22485b018e4f9b$var$_16);
    if (adztail !== 0) {
        finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(4, $cb22485b018e4f9b$var$bc, adztail, $cb22485b018e4f9b$var$_12), $cb22485b018e4f9b$var$_12);
        finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(bctlen, $cb22485b018e4f9b$var$bct, adztail, $cb22485b018e4f9b$var$_16), $cb22485b018e4f9b$var$_16);
    }
    if (bdztail !== 0) {
        finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(4, $cb22485b018e4f9b$var$ca, bdztail, $cb22485b018e4f9b$var$_12), $cb22485b018e4f9b$var$_12);
        finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(catlen, $cb22485b018e4f9b$var$cat, bdztail, $cb22485b018e4f9b$var$_16), $cb22485b018e4f9b$var$_16);
    }
    if (cdztail !== 0) {
        finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(4, $cb22485b018e4f9b$var$ab, cdztail, $cb22485b018e4f9b$var$_12), $cb22485b018e4f9b$var$_12);
        finlen = $cb22485b018e4f9b$var$finadd(finlen, (0, $1oUYY.scale)(abtlen, $cb22485b018e4f9b$var$abt, cdztail, $cb22485b018e4f9b$var$_16), $cb22485b018e4f9b$var$_16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = $cb22485b018e4f9b$var$tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = $cb22485b018e4f9b$var$tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = $cb22485b018e4f9b$var$tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = $cb22485b018e4f9b$var$tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = $cb22485b018e4f9b$var$tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = $cb22485b018e4f9b$var$tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return $cb22485b018e4f9b$var$fin[finlen - 1];
}
function $cb22485b018e4f9b$export$248ff23af2e93e3e(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = $cb22485b018e4f9b$var$o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $cb22485b018e4f9b$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function $cb22485b018e4f9b$export$407220085d2c43a5(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}

});

parcelRegister("6NnA6", function(module, exports) {

var $1oUYY = parcelRequire("1oUYY");
const $4f299c6aa49d6133$var$iccerrboundA = (10 + 96 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon);
const $4f299c6aa49d6133$var$iccerrboundB = (4 + 48 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon);
const $4f299c6aa49d6133$var$iccerrboundC = (44 + 576 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon) * (0, $1oUYY.epsilon);
const $4f299c6aa49d6133$var$bc = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$ca = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$ab = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$aa = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$bb = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$cc = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$u = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$v = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$axtbc = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$aytbc = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$bxtca = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$bytca = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$cxtab = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$cytab = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$abt = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$bct = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$cat = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$abtt = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$bctt = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$catt = (0, $1oUYY.vec)(4);
const $4f299c6aa49d6133$var$_8 = (0, $1oUYY.vec)(8);
const $4f299c6aa49d6133$var$_16 = (0, $1oUYY.vec)(16);
const $4f299c6aa49d6133$var$_16b = (0, $1oUYY.vec)(16);
const $4f299c6aa49d6133$var$_16c = (0, $1oUYY.vec)(16);
const $4f299c6aa49d6133$var$_32 = (0, $1oUYY.vec)(32);
const $4f299c6aa49d6133$var$_32b = (0, $1oUYY.vec)(32);
const $4f299c6aa49d6133$var$_48 = (0, $1oUYY.vec)(48);
const $4f299c6aa49d6133$var$_64 = (0, $1oUYY.vec)(64);
let $4f299c6aa49d6133$var$fin = (0, $1oUYY.vec)(1152);
let $4f299c6aa49d6133$var$fin2 = (0, $1oUYY.vec)(1152);
function $4f299c6aa49d6133$var$finadd(finlen, a, alen) {
    finlen = (0, $1oUYY.sum)(finlen, $4f299c6aa49d6133$var$fin, a, alen, $4f299c6aa49d6133$var$fin2);
    const tmp = $4f299c6aa49d6133$var$fin;
    $4f299c6aa49d6133$var$fin = $4f299c6aa49d6133$var$fin2;
    $4f299c6aa49d6133$var$fin2 = tmp;
    return finlen;
}
function $4f299c6aa49d6133$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, $1oUYY.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $1oUYY.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $1oUYY.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $1oUYY.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4f299c6aa49d6133$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4f299c6aa49d6133$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4f299c6aa49d6133$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4f299c6aa49d6133$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $1oUYY.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $1oUYY.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $1oUYY.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $1oUYY.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4f299c6aa49d6133$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4f299c6aa49d6133$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4f299c6aa49d6133$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4f299c6aa49d6133$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $1oUYY.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $1oUYY.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $1oUYY.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $1oUYY.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4f299c6aa49d6133$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4f299c6aa49d6133$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4f299c6aa49d6133$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4f299c6aa49d6133$var$ab[3] = u3;
    finlen = (0, $1oUYY.sum)((0, $1oUYY.sum)((0, $1oUYY.sum)((0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bc, adx, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, adx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bc, ady, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, ady, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, (0, $1oUYY.sum)((0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$ca, bdx, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, bdx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$ca, bdy, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, bdy, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, $4f299c6aa49d6133$var$_32b), $4f299c6aa49d6133$var$_32b, $4f299c6aa49d6133$var$_64), $4f299c6aa49d6133$var$_64, (0, $1oUYY.sum)((0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$ab, cdx, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, cdx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$ab, cdy, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, cdy, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$fin);
    let det = (0, $1oUYY.estimate)(finlen, $4f299c6aa49d6133$var$fin);
    let errbound = $4f299c6aa49d6133$var$iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = $4f299c6aa49d6133$var$iccerrboundC * permanent + (0, $1oUYY.resulterrbound) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, $1oUYY.splitter) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, $1oUYY.splitter) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $4f299c6aa49d6133$var$aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $4f299c6aa49d6133$var$aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $4f299c6aa49d6133$var$aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $4f299c6aa49d6133$var$aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, $1oUYY.splitter) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, $1oUYY.splitter) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $4f299c6aa49d6133$var$bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $4f299c6aa49d6133$var$bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $4f299c6aa49d6133$var$bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $4f299c6aa49d6133$var$bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, $1oUYY.splitter) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, $1oUYY.splitter) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $4f299c6aa49d6133$var$cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $4f299c6aa49d6133$var$cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $4f299c6aa49d6133$var$cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $4f299c6aa49d6133$var$cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bc, adxtail, $4f299c6aa49d6133$var$axtbc);
        finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(axtbclen, $4f299c6aa49d6133$var$axtbc, 2 * adx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$cc, adxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, bdy, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bb, adxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, -cdy, $4f299c6aa49d6133$var$_16c), $4f299c6aa49d6133$var$_16c, $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
    }
    if (adytail !== 0) {
        aytbclen = (0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bc, adytail, $4f299c6aa49d6133$var$aytbc);
        finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(aytbclen, $4f299c6aa49d6133$var$aytbc, 2 * ady, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bb, adytail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, cdx, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$cc, adytail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, -bdx, $4f299c6aa49d6133$var$_16c), $4f299c6aa49d6133$var$_16c, $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$ca, bdxtail, $4f299c6aa49d6133$var$bxtca);
        finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(bxtcalen, $4f299c6aa49d6133$var$bxtca, 2 * bdx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$aa, bdxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, cdy, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$cc, bdxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, -ady, $4f299c6aa49d6133$var$_16c), $4f299c6aa49d6133$var$_16c, $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$ca, bdytail, $4f299c6aa49d6133$var$bytca);
        finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(bytcalen, $4f299c6aa49d6133$var$bytca, 2 * bdy, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$cc, bdytail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, adx, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$aa, bdytail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, -cdx, $4f299c6aa49d6133$var$_16c), $4f299c6aa49d6133$var$_16c, $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$ab, cdxtail, $4f299c6aa49d6133$var$cxtab);
        finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(cxtablen, $4f299c6aa49d6133$var$cxtab, 2 * cdx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bb, cdxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, ady, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$aa, cdxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, -bdy, $4f299c6aa49d6133$var$_16c), $4f299c6aa49d6133$var$_16c, $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
    }
    if (cdytail !== 0) {
        cytablen = (0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$ab, cdytail, $4f299c6aa49d6133$var$cytab);
        finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(cytablen, $4f299c6aa49d6133$var$cytab, 2 * cdy, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$aa, cdytail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, bdx, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bb, cdytail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, -adx, $4f299c6aa49d6133$var$_16c), $4f299c6aa49d6133$var$_16c, $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, $1oUYY.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $1oUYY.splitter) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, $1oUYY.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $1oUYY.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $4f299c6aa49d6133$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $4f299c6aa49d6133$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, $1oUYY.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $1oUYY.splitter) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, $1oUYY.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $1oUYY.splitter) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $4f299c6aa49d6133$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $4f299c6aa49d6133$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$v[3] = u3;
            bctlen = (0, $1oUYY.sum)(4, $4f299c6aa49d6133$var$u, 4, $4f299c6aa49d6133$var$v, $4f299c6aa49d6133$var$bct);
            s1 = bdxtail * cdytail;
            c = (0, $1oUYY.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $1oUYY.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, $1oUYY.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $1oUYY.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $4f299c6aa49d6133$var$bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $4f299c6aa49d6133$var$bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$bctt[3] = u3;
            bcttlen = 4;
        } else {
            $4f299c6aa49d6133$var$bct[0] = 0;
            bctlen = 1;
            $4f299c6aa49d6133$var$bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, $1oUYY.scale)(bctlen, $4f299c6aa49d6133$var$bct, adxtail, $4f299c6aa49d6133$var$_16c);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum)((0, $1oUYY.scale)(axtbclen, $4f299c6aa49d6133$var$axtbc, adxtail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, 2 * adx, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
            const len2 = (0, $1oUYY.scale)(bcttlen, $4f299c6aa49d6133$var$bctt, adxtail, $4f299c6aa49d6133$var$_8);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, 2 * adx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, adxtail, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, adxtail, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_32b, $4f299c6aa49d6133$var$_64), $4f299c6aa49d6133$var$_64);
            if (bdytail !== 0) finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$cc, adxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, bdytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16);
            if (cdytail !== 0) finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bb, -adxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, cdytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16);
        }
        if (adytail !== 0) {
            const len = (0, $1oUYY.scale)(bctlen, $4f299c6aa49d6133$var$bct, adytail, $4f299c6aa49d6133$var$_16c);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum)((0, $1oUYY.scale)(aytbclen, $4f299c6aa49d6133$var$aytbc, adytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, 2 * ady, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
            const len2 = (0, $1oUYY.scale)(bcttlen, $4f299c6aa49d6133$var$bctt, adytail, $4f299c6aa49d6133$var$_8);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, 2 * ady, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, adytail, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, adytail, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_32b, $4f299c6aa49d6133$var$_64), $4f299c6aa49d6133$var$_64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, $1oUYY.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $1oUYY.splitter) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, $1oUYY.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $1oUYY.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $4f299c6aa49d6133$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $4f299c6aa49d6133$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, $1oUYY.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $1oUYY.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, $1oUYY.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $1oUYY.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $4f299c6aa49d6133$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $4f299c6aa49d6133$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$v[3] = u3;
            catlen = (0, $1oUYY.sum)(4, $4f299c6aa49d6133$var$u, 4, $4f299c6aa49d6133$var$v, $4f299c6aa49d6133$var$cat);
            s1 = cdxtail * adytail;
            c = (0, $1oUYY.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $1oUYY.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, $1oUYY.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $1oUYY.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $4f299c6aa49d6133$var$catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $4f299c6aa49d6133$var$catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$catt[3] = u3;
            cattlen = 4;
        } else {
            $4f299c6aa49d6133$var$cat[0] = 0;
            catlen = 1;
            $4f299c6aa49d6133$var$catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, $1oUYY.scale)(catlen, $4f299c6aa49d6133$var$cat, bdxtail, $4f299c6aa49d6133$var$_16c);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum)((0, $1oUYY.scale)(bxtcalen, $4f299c6aa49d6133$var$bxtca, bdxtail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, 2 * bdx, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
            const len2 = (0, $1oUYY.scale)(cattlen, $4f299c6aa49d6133$var$catt, bdxtail, $4f299c6aa49d6133$var$_8);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, 2 * bdx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, bdxtail, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, bdxtail, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_32b, $4f299c6aa49d6133$var$_64), $4f299c6aa49d6133$var$_64);
            if (cdytail !== 0) finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$aa, bdxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, cdytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16);
            if (adytail !== 0) finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$cc, -bdxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, adytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16);
        }
        if (bdytail !== 0) {
            const len = (0, $1oUYY.scale)(catlen, $4f299c6aa49d6133$var$cat, bdytail, $4f299c6aa49d6133$var$_16c);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum)((0, $1oUYY.scale)(bytcalen, $4f299c6aa49d6133$var$bytca, bdytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, 2 * bdy, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
            const len2 = (0, $1oUYY.scale)(cattlen, $4f299c6aa49d6133$var$catt, bdytail, $4f299c6aa49d6133$var$_8);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, 2 * bdy, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, bdytail, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, bdytail, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_32b, $4f299c6aa49d6133$var$_64), $4f299c6aa49d6133$var$_64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, $1oUYY.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $1oUYY.splitter) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, $1oUYY.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $1oUYY.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $4f299c6aa49d6133$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $4f299c6aa49d6133$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, $1oUYY.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $1oUYY.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, $1oUYY.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $1oUYY.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $4f299c6aa49d6133$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $4f299c6aa49d6133$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$v[3] = u3;
            abtlen = (0, $1oUYY.sum)(4, $4f299c6aa49d6133$var$u, 4, $4f299c6aa49d6133$var$v, $4f299c6aa49d6133$var$abt);
            s1 = adxtail * bdytail;
            c = (0, $1oUYY.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $1oUYY.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, $1oUYY.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $1oUYY.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $4f299c6aa49d6133$var$abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $4f299c6aa49d6133$var$abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $4f299c6aa49d6133$var$abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $4f299c6aa49d6133$var$abtt[3] = u3;
            abttlen = 4;
        } else {
            $4f299c6aa49d6133$var$abt[0] = 0;
            abtlen = 1;
            $4f299c6aa49d6133$var$abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, $1oUYY.scale)(abtlen, $4f299c6aa49d6133$var$abt, cdxtail, $4f299c6aa49d6133$var$_16c);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum)((0, $1oUYY.scale)(cxtablen, $4f299c6aa49d6133$var$cxtab, cdxtail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, 2 * cdx, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
            const len2 = (0, $1oUYY.scale)(abttlen, $4f299c6aa49d6133$var$abtt, cdxtail, $4f299c6aa49d6133$var$_8);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, 2 * cdx, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, cdxtail, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, cdxtail, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_32b, $4f299c6aa49d6133$var$_64), $4f299c6aa49d6133$var$_64);
            if (adytail !== 0) finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$bb, cdxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, adytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16);
            if (bdytail !== 0) finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.scale)((0, $1oUYY.scale)(4, $4f299c6aa49d6133$var$aa, -cdxtail, $4f299c6aa49d6133$var$_8), $4f299c6aa49d6133$var$_8, bdytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16);
        }
        if (cdytail !== 0) {
            const len = (0, $1oUYY.scale)(abtlen, $4f299c6aa49d6133$var$abt, cdytail, $4f299c6aa49d6133$var$_16c);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum)((0, $1oUYY.scale)(cytablen, $4f299c6aa49d6133$var$cytab, cdytail, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, 2 * cdy, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_48), $4f299c6aa49d6133$var$_48);
            const len2 = (0, $1oUYY.scale)(abttlen, $4f299c6aa49d6133$var$abtt, cdytail, $4f299c6aa49d6133$var$_8);
            finlen = $4f299c6aa49d6133$var$finadd(finlen, (0, $1oUYY.sum_three)((0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, 2 * cdy, $4f299c6aa49d6133$var$_16), $4f299c6aa49d6133$var$_16, (0, $1oUYY.scale)(len2, $4f299c6aa49d6133$var$_8, cdytail, $4f299c6aa49d6133$var$_16b), $4f299c6aa49d6133$var$_16b, (0, $1oUYY.scale)(len, $4f299c6aa49d6133$var$_16c, cdytail, $4f299c6aa49d6133$var$_32), $4f299c6aa49d6133$var$_32, $4f299c6aa49d6133$var$_32b, $4f299c6aa49d6133$var$_64), $4f299c6aa49d6133$var$_64);
        }
    }
    return $4f299c6aa49d6133$var$fin[finlen - 1];
}
function $4f299c6aa49d6133$export$454d2cfe884d4dd6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = $4f299c6aa49d6133$var$iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $4f299c6aa49d6133$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function $4f299c6aa49d6133$export$f98e78581b4485e6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}

});

parcelRegister("kFdHR", function(module, exports) {

var $1oUYY = parcelRequire("1oUYY");
const $f0b244c83fb25a7f$var$isperrboundA = (16 + 224 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon);
const $f0b244c83fb25a7f$var$isperrboundB = (5 + 72 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon);
const $f0b244c83fb25a7f$var$isperrboundC = (71 + 1408 * (0, $1oUYY.epsilon)) * (0, $1oUYY.epsilon) * (0, $1oUYY.epsilon);
const $f0b244c83fb25a7f$var$ab = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$bc = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$cd = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$de = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$ea = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$ac = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$bd = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$ce = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$da = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$eb = (0, $1oUYY.vec)(4);
const $f0b244c83fb25a7f$var$abc = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$bcd = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$cde = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$dea = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$eab = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$abd = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$bce = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$cda = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$deb = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$eac = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$adet = (0, $1oUYY.vec)(1152);
const $f0b244c83fb25a7f$var$bdet = (0, $1oUYY.vec)(1152);
const $f0b244c83fb25a7f$var$cdet = (0, $1oUYY.vec)(1152);
const $f0b244c83fb25a7f$var$ddet = (0, $1oUYY.vec)(1152);
const $f0b244c83fb25a7f$var$edet = (0, $1oUYY.vec)(1152);
const $f0b244c83fb25a7f$var$abdet = (0, $1oUYY.vec)(2304);
const $f0b244c83fb25a7f$var$cddet = (0, $1oUYY.vec)(2304);
const $f0b244c83fb25a7f$var$cdedet = (0, $1oUYY.vec)(3456);
const $f0b244c83fb25a7f$var$deter = (0, $1oUYY.vec)(5760);
const $f0b244c83fb25a7f$var$_8 = (0, $1oUYY.vec)(8);
const $f0b244c83fb25a7f$var$_8b = (0, $1oUYY.vec)(8);
const $f0b244c83fb25a7f$var$_8c = (0, $1oUYY.vec)(8);
const $f0b244c83fb25a7f$var$_16 = (0, $1oUYY.vec)(16);
const $f0b244c83fb25a7f$var$_24 = (0, $1oUYY.vec)(24);
const $f0b244c83fb25a7f$var$_48 = (0, $1oUYY.vec)(48);
const $f0b244c83fb25a7f$var$_48b = (0, $1oUYY.vec)(48);
const $f0b244c83fb25a7f$var$_96 = (0, $1oUYY.vec)(96);
const $f0b244c83fb25a7f$var$_192 = (0, $1oUYY.vec)(192);
const $f0b244c83fb25a7f$var$_384x = (0, $1oUYY.vec)(384);
const $f0b244c83fb25a7f$var$_384y = (0, $1oUYY.vec)(384);
const $f0b244c83fb25a7f$var$_384z = (0, $1oUYY.vec)(384);
const $f0b244c83fb25a7f$var$_768 = (0, $1oUYY.vec)(768);
function $f0b244c83fb25a7f$var$sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, $1oUYY.sum_three)((0, $1oUYY.scale)(4, a, az, $f0b244c83fb25a7f$var$_8), $f0b244c83fb25a7f$var$_8, (0, $1oUYY.scale)(4, b, bz, $f0b244c83fb25a7f$var$_8b), $f0b244c83fb25a7f$var$_8b, (0, $1oUYY.scale)(4, c, cz, $f0b244c83fb25a7f$var$_8c), $f0b244c83fb25a7f$var$_8c, $f0b244c83fb25a7f$var$_16, out);
}
function $f0b244c83fb25a7f$var$liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, $1oUYY.sum)((0, $1oUYY.sum)(alen, a, blen, b, $f0b244c83fb25a7f$var$_48), $f0b244c83fb25a7f$var$_48, (0, $1oUYY.negate)((0, $1oUYY.sum)(clen, c, dlen, d, $f0b244c83fb25a7f$var$_48b), $f0b244c83fb25a7f$var$_48b), $f0b244c83fb25a7f$var$_48b, $f0b244c83fb25a7f$var$_96);
    return (0, $1oUYY.sum_three)((0, $1oUYY.scale)((0, $1oUYY.scale)(len, $f0b244c83fb25a7f$var$_96, x, $f0b244c83fb25a7f$var$_192), $f0b244c83fb25a7f$var$_192, x, $f0b244c83fb25a7f$var$_384x), $f0b244c83fb25a7f$var$_384x, (0, $1oUYY.scale)((0, $1oUYY.scale)(len, $f0b244c83fb25a7f$var$_96, y, $f0b244c83fb25a7f$var$_192), $f0b244c83fb25a7f$var$_192, y, $f0b244c83fb25a7f$var$_384y), $f0b244c83fb25a7f$var$_384y, (0, $1oUYY.scale)((0, $1oUYY.scale)(len, $f0b244c83fb25a7f$var$_96, z, $f0b244c83fb25a7f$var$_192), $f0b244c83fb25a7f$var$_192, z, $f0b244c83fb25a7f$var$_384z), $f0b244c83fb25a7f$var$_384z, $f0b244c83fb25a7f$var$_768, out);
}
function $f0b244c83fb25a7f$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, $1oUYY.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $1oUYY.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, $1oUYY.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $1oUYY.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$ab[3] = u3;
    s1 = bx * cy;
    c = (0, $1oUYY.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $1oUYY.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, $1oUYY.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $1oUYY.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$bc[3] = u3;
    s1 = cx * dy;
    c = (0, $1oUYY.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $1oUYY.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, $1oUYY.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $1oUYY.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$cd[3] = u3;
    s1 = dx * ey;
    c = (0, $1oUYY.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $1oUYY.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, $1oUYY.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $1oUYY.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$de[3] = u3;
    s1 = ex * ay;
    c = (0, $1oUYY.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $1oUYY.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, $1oUYY.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $1oUYY.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$ea[3] = u3;
    s1 = ax * cy;
    c = (0, $1oUYY.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $1oUYY.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, $1oUYY.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $1oUYY.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$ac[3] = u3;
    s1 = bx * dy;
    c = (0, $1oUYY.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $1oUYY.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, $1oUYY.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $1oUYY.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$bd[3] = u3;
    s1 = cx * ey;
    c = (0, $1oUYY.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $1oUYY.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, $1oUYY.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $1oUYY.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$ce[3] = u3;
    s1 = dx * ay;
    c = (0, $1oUYY.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $1oUYY.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, $1oUYY.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $1oUYY.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$da[3] = u3;
    s1 = ex * by;
    c = (0, $1oUYY.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $1oUYY.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, $1oUYY.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $1oUYY.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $f0b244c83fb25a7f$var$eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$eb[3] = u3;
    const abclen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$ab, $f0b244c83fb25a7f$var$bc, $f0b244c83fb25a7f$var$ac, cz, az, -bz, $f0b244c83fb25a7f$var$abc);
    const bcdlen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$bc, $f0b244c83fb25a7f$var$cd, $f0b244c83fb25a7f$var$bd, dz, bz, -cz, $f0b244c83fb25a7f$var$bcd);
    const cdelen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$cd, $f0b244c83fb25a7f$var$de, $f0b244c83fb25a7f$var$ce, ez, cz, -dz, $f0b244c83fb25a7f$var$cde);
    const dealen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$de, $f0b244c83fb25a7f$var$ea, $f0b244c83fb25a7f$var$da, az, dz, -ez, $f0b244c83fb25a7f$var$dea);
    const eablen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$ea, $f0b244c83fb25a7f$var$ab, $f0b244c83fb25a7f$var$eb, bz, ez, -az, $f0b244c83fb25a7f$var$eab);
    const abdlen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$ab, $f0b244c83fb25a7f$var$bd, $f0b244c83fb25a7f$var$da, dz, az, bz, $f0b244c83fb25a7f$var$abd);
    const bcelen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$bc, $f0b244c83fb25a7f$var$ce, $f0b244c83fb25a7f$var$eb, ez, bz, cz, $f0b244c83fb25a7f$var$bce);
    const cdalen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$cd, $f0b244c83fb25a7f$var$da, $f0b244c83fb25a7f$var$ac, az, cz, dz, $f0b244c83fb25a7f$var$cda);
    const deblen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$de, $f0b244c83fb25a7f$var$eb, $f0b244c83fb25a7f$var$bd, bz, dz, ez, $f0b244c83fb25a7f$var$deb);
    const eaclen = $f0b244c83fb25a7f$var$sum_three_scale($f0b244c83fb25a7f$var$ea, $f0b244c83fb25a7f$var$ac, $f0b244c83fb25a7f$var$ce, cz, ez, az, $f0b244c83fb25a7f$var$eac);
    const deterlen = (0, $1oUYY.sum_three)($f0b244c83fb25a7f$var$liftexact(cdelen, $f0b244c83fb25a7f$var$cde, bcelen, $f0b244c83fb25a7f$var$bce, deblen, $f0b244c83fb25a7f$var$deb, bcdlen, $f0b244c83fb25a7f$var$bcd, ax, ay, az, $f0b244c83fb25a7f$var$adet), $f0b244c83fb25a7f$var$adet, $f0b244c83fb25a7f$var$liftexact(dealen, $f0b244c83fb25a7f$var$dea, cdalen, $f0b244c83fb25a7f$var$cda, eaclen, $f0b244c83fb25a7f$var$eac, cdelen, $f0b244c83fb25a7f$var$cde, bx, by, bz, $f0b244c83fb25a7f$var$bdet), $f0b244c83fb25a7f$var$bdet, (0, $1oUYY.sum_three)($f0b244c83fb25a7f$var$liftexact(eablen, $f0b244c83fb25a7f$var$eab, deblen, $f0b244c83fb25a7f$var$deb, abdlen, $f0b244c83fb25a7f$var$abd, dealen, $f0b244c83fb25a7f$var$dea, cx, cy, cz, $f0b244c83fb25a7f$var$cdet), $f0b244c83fb25a7f$var$cdet, $f0b244c83fb25a7f$var$liftexact(abclen, $f0b244c83fb25a7f$var$abc, eaclen, $f0b244c83fb25a7f$var$eac, bcelen, $f0b244c83fb25a7f$var$bce, eablen, $f0b244c83fb25a7f$var$eab, dx, dy, dz, $f0b244c83fb25a7f$var$ddet), $f0b244c83fb25a7f$var$ddet, $f0b244c83fb25a7f$var$liftexact(bcdlen, $f0b244c83fb25a7f$var$bcd, abdlen, $f0b244c83fb25a7f$var$abd, cdalen, $f0b244c83fb25a7f$var$cda, abclen, $f0b244c83fb25a7f$var$abc, ex, ey, ez, $f0b244c83fb25a7f$var$edet), $f0b244c83fb25a7f$var$edet, $f0b244c83fb25a7f$var$cddet, $f0b244c83fb25a7f$var$cdedet), $f0b244c83fb25a7f$var$cdedet, $f0b244c83fb25a7f$var$abdet, $f0b244c83fb25a7f$var$deter);
    return $f0b244c83fb25a7f$var$deter[deterlen - 1];
}
const $f0b244c83fb25a7f$var$xdet = (0, $1oUYY.vec)(96);
const $f0b244c83fb25a7f$var$ydet = (0, $1oUYY.vec)(96);
const $f0b244c83fb25a7f$var$zdet = (0, $1oUYY.vec)(96);
const $f0b244c83fb25a7f$var$fin = (0, $1oUYY.vec)(1152);
function $f0b244c83fb25a7f$var$liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = $f0b244c83fb25a7f$var$sum_three_scale(a, b, c, az, bz, cz, $f0b244c83fb25a7f$var$_24);
    return (0, $1oUYY.sum_three)((0, $1oUYY.scale)((0, $1oUYY.scale)(len, $f0b244c83fb25a7f$var$_24, x, $f0b244c83fb25a7f$var$_48), $f0b244c83fb25a7f$var$_48, x, $f0b244c83fb25a7f$var$xdet), $f0b244c83fb25a7f$var$xdet, (0, $1oUYY.scale)((0, $1oUYY.scale)(len, $f0b244c83fb25a7f$var$_24, y, $f0b244c83fb25a7f$var$_48), $f0b244c83fb25a7f$var$_48, y, $f0b244c83fb25a7f$var$ydet), $f0b244c83fb25a7f$var$ydet, (0, $1oUYY.scale)((0, $1oUYY.scale)(len, $f0b244c83fb25a7f$var$_24, z, $f0b244c83fb25a7f$var$_48), $f0b244c83fb25a7f$var$_48, z, $f0b244c83fb25a7f$var$zdet), $f0b244c83fb25a7f$var$zdet, $f0b244c83fb25a7f$var$_192, out);
}
function $f0b244c83fb25a7f$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, $1oUYY.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $1oUYY.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, $1oUYY.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $1oUYY.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    $f0b244c83fb25a7f$var$ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$ab[3] = ab3;
    s1 = bex * cey;
    c = (0, $1oUYY.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $1oUYY.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, $1oUYY.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $1oUYY.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    $f0b244c83fb25a7f$var$bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$bc[3] = bc3;
    s1 = cex * dey;
    c = (0, $1oUYY.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $1oUYY.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, $1oUYY.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $1oUYY.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    $f0b244c83fb25a7f$var$cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$cd[3] = cd3;
    s1 = dex * aey;
    c = (0, $1oUYY.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $1oUYY.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, $1oUYY.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $1oUYY.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    $f0b244c83fb25a7f$var$da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$da[3] = da3;
    s1 = aex * cey;
    c = (0, $1oUYY.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $1oUYY.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, $1oUYY.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $1oUYY.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    $f0b244c83fb25a7f$var$ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$ac[3] = ac3;
    s1 = bex * dey;
    c = (0, $1oUYY.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $1oUYY.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, $1oUYY.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $1oUYY.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $f0b244c83fb25a7f$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $f0b244c83fb25a7f$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    $f0b244c83fb25a7f$var$bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    $f0b244c83fb25a7f$var$bd[3] = bd3;
    const finlen = (0, $1oUYY.sum)((0, $1oUYY.sum)((0, $1oUYY.negate)($f0b244c83fb25a7f$var$liftadapt($f0b244c83fb25a7f$var$bc, $f0b244c83fb25a7f$var$cd, $f0b244c83fb25a7f$var$bd, dez, bez, -cez, aex, aey, aez, $f0b244c83fb25a7f$var$adet), $f0b244c83fb25a7f$var$adet), $f0b244c83fb25a7f$var$adet, $f0b244c83fb25a7f$var$liftadapt($f0b244c83fb25a7f$var$cd, $f0b244c83fb25a7f$var$da, $f0b244c83fb25a7f$var$ac, aez, cez, dez, bex, bey, bez, $f0b244c83fb25a7f$var$bdet), $f0b244c83fb25a7f$var$bdet, $f0b244c83fb25a7f$var$abdet), $f0b244c83fb25a7f$var$abdet, (0, $1oUYY.sum)((0, $1oUYY.negate)($f0b244c83fb25a7f$var$liftadapt($f0b244c83fb25a7f$var$da, $f0b244c83fb25a7f$var$ab, $f0b244c83fb25a7f$var$bd, bez, dez, aez, cex, cey, cez, $f0b244c83fb25a7f$var$cdet), $f0b244c83fb25a7f$var$cdet), $f0b244c83fb25a7f$var$cdet, $f0b244c83fb25a7f$var$liftadapt($f0b244c83fb25a7f$var$ab, $f0b244c83fb25a7f$var$bc, $f0b244c83fb25a7f$var$ac, cez, aez, -bez, dex, dey, dez, $f0b244c83fb25a7f$var$ddet), $f0b244c83fb25a7f$var$ddet, $f0b244c83fb25a7f$var$cddet), $f0b244c83fb25a7f$var$cddet, $f0b244c83fb25a7f$var$fin);
    let det = (0, $1oUYY.estimate)(finlen, $f0b244c83fb25a7f$var$fin);
    let errbound = $f0b244c83fb25a7f$var$isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = $f0b244c83fb25a7f$var$isperrboundC * permanent + (0, $1oUYY.resulterrbound) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return $f0b244c83fb25a7f$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function $f0b244c83fb25a7f$export$7846ecd8d3a5d1ac(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = $f0b244c83fb25a7f$var$isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -$f0b244c83fb25a7f$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function $f0b244c83fb25a7f$export$11235b985c819946(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}

});



parcelRegister("9ShOK", function(module, exports) {

$parcel$export(module.exports, "getCoord", () => $7306fa62fb11a7a6$export$b4663c6e64a770bc);
$parcel$export(module.exports, "getCoords", () => $7306fa62fb11a7a6$export$39e042fd83f1b62e);
$parcel$export(module.exports, "getGeom", () => $7306fa62fb11a7a6$export$b8f320eb9549c8fd);
// index.ts

var $ioYla = parcelRequire("ioYla");
function $7306fa62fb11a7a6$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return [
            ...coord.geometry.coordinates
        ];
        if (coord.type === "Point") return [
            ...coord.coordinates
        ];
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return [
        ...coord
    ];
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function $7306fa62fb11a7a6$export$39e042fd83f1b62e(coords) {
    if (Array.isArray(coords)) return coords;
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function $7306fa62fb11a7a6$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $ioYla.isNumber)(coordinates[0]) && (0, $ioYla.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $7306fa62fb11a7a6$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function $7306fa62fb11a7a6$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function $7306fa62fb11a7a6$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function $7306fa62fb11a7a6$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for (const feature of featureCollection.features){
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function $7306fa62fb11a7a6$export$b8f320eb9549c8fd(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function $7306fa62fb11a7a6$export$e2b5c5db9e2009fd(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}

});
parcelRegister("ioYla", function(module, exports) {

$parcel$export(module.exports, "earthRadius", () => $d659463d34172173$export$e3a1ee0e9945697f);
$parcel$export(module.exports, "feature", () => $d659463d34172173$export$ced6ed16dfd6a264);
$parcel$export(module.exports, "point", () => $d659463d34172173$export$105684a3041cb6f3);
$parcel$export(module.exports, "lineString", () => $d659463d34172173$export$98ec381bb06902c3);
$parcel$export(module.exports, "polygon", () => $d659463d34172173$export$b7b19aa0ee06c73);
$parcel$export(module.exports, "multiPolygon", () => $d659463d34172173$export$79bd594da96638d3);
$parcel$export(module.exports, "isNumber", () => $d659463d34172173$export$7e4aa119212bc614);
$parcel$export(module.exports, "featureCollection", () => $d659463d34172173$export$4717c67ac3e5e04d);
$parcel$export(module.exports, "radiansToLength", () => $d659463d34172173$export$f234631d6a2eedf8);
$parcel$export(module.exports, "radiansToDegrees", () => $d659463d34172173$export$c41dd2a8460d3196);
$parcel$export(module.exports, "degreesToRadians", () => $d659463d34172173$export$c9fcf1a7df975d78);
$parcel$export(module.exports, "isObject", () => $d659463d34172173$export$a6cdc56e425d0d0a);
// index.ts
var $d659463d34172173$export$e3a1ee0e9945697f = 63710088e-1;
var $d659463d34172173$export$f929e47acbed771a = {
    centimeters: $d659463d34172173$export$e3a1ee0e9945697f * 100,
    centimetres: $d659463d34172173$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $d659463d34172173$export$e3a1ee0e9945697f * 3.28084,
    inches: $d659463d34172173$export$e3a1ee0e9945697f * 39.37,
    kilometers: $d659463d34172173$export$e3a1ee0e9945697f / 1e3,
    kilometres: $d659463d34172173$export$e3a1ee0e9945697f / 1e3,
    meters: $d659463d34172173$export$e3a1ee0e9945697f,
    metres: $d659463d34172173$export$e3a1ee0e9945697f,
    miles: $d659463d34172173$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $d659463d34172173$export$e3a1ee0e9945697f * 1e3,
    millimetres: $d659463d34172173$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $d659463d34172173$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $d659463d34172173$export$e3a1ee0e9945697f * 1.0936
};
var $d659463d34172173$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $d659463d34172173$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $d659463d34172173$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $d659463d34172173$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $d659463d34172173$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $d659463d34172173$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $d659463d34172173$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $d659463d34172173$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $d659463d34172173$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$d659463d34172173$export$7e4aa119212bc614(coordinates[0]) || !$d659463d34172173$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $d659463d34172173$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $d659463d34172173$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $d659463d34172173$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $d659463d34172173$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $d659463d34172173$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $d659463d34172173$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $d659463d34172173$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $d659463d34172173$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $d659463d34172173$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $d659463d34172173$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $d659463d34172173$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $d659463d34172173$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $d659463d34172173$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $d659463d34172173$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $d659463d34172173$export$c7a138e00a89bd01(distance, units) {
    return $d659463d34172173$export$c41dd2a8460d3196($d659463d34172173$export$a2280f7debae8f10(distance, units));
}
function $d659463d34172173$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $d659463d34172173$export$b4c4eb04cfe49fab(angle) {
    angle = angle % 360;
    if (angle > 180) return angle - 360;
    else if (angle < -180) return angle + 360;
    return angle;
}
function $d659463d34172173$export$c41dd2a8460d3196(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
}
function $d659463d34172173$export$c9fcf1a7df975d78(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
}
function $d659463d34172173$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $d659463d34172173$export$f234631d6a2eedf8($d659463d34172173$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $d659463d34172173$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $d659463d34172173$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $d659463d34172173$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $d659463d34172173$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $d659463d34172173$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function $d659463d34172173$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$d659463d34172173$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $d659463d34172173$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}

});





parcelRegister("5kwJN", function(module, exports) {

$parcel$export(module.exports, "lastHangaredText", () => $96648370230c139c$export$bfa8edf98dec90b2);
$parcel$export(module.exports, "addTenantConformationText", () => $96648370230c139c$export$4f0f8084b976bfc3);

var $fqtQp = parcelRequire("fqtQp");
const $96648370230c139c$export$bfa8edf98dec90b2 = (value, currentlyInHangar)=>{
    if (currentlyInHangar) return "Today";
    if (!value) return "Never";
    return (0, $fqtQp.formatDistance)(new Date(value), new Date(), {
        addSuffix: true
    });
};
const $96648370230c139c$export$4f0f8084b976bfc3 = (locationType)=>{
    if (window.location.hash === "#/tenants") return `We\u{2019}ll add this new base tenant to the aircraft list. If you need to assign a default hangar for this aircraft, you can do so by editing the specific aircraft entry.`;
    // base + hangar
    if (locationType === "hangar") return "We\u2019ll assign this new Base Tenant to this hangar. If you need to change default hangar assignments, you can do that by editing this specific aircraft.";
    // base + ramp
    if (locationType === "ramp") return "We\u2019ll assign this new Tie-Down Tenant to this ramp. If you need to change default ramp assignments, you can do that by editing this specific aircraft.";
    // base + tenants page
    if (!locationType) return `We\u{2019}ll add this new base tenant to the aircraft list. If you need to assign a default hangar for this aircraft, you can do so by editing the specific aircraft entry.`;
};

});
parcelRegister("fqtQp", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $f62a2dc9582961f4$export$2c14ff85d6318973);

var $dg5qe = parcelRequire("dg5qe");

var $klgYS = parcelRequire("klgYS");

var $gwrwo = parcelRequire("gwrwo");

var $5YFet = parcelRequire("5YFet");

var $9Jots = parcelRequire("9Jots");

var $alq4V = parcelRequire("alq4V");

var $gpD2R = parcelRequire("gpD2R");

var $7MGTI = parcelRequire("7MGTI");
function $f62a2dc9582961f4$export$2c14ff85d6318973(date, baseDate, options) {
    const defaultOptions = (0, $gpD2R.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $alq4V.enUS);
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $dg5qe.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $9Jots.toDate)(baseDate);
        dateRight = (0, $9Jots.toDate)(date);
    } else {
        dateLeft = (0, $9Jots.toDate)(date);
        dateRight = (0, $9Jots.toDate)(baseDate);
    }
    const seconds = (0, $5YFet.differenceInSeconds)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $7MGTI.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $7MGTI.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, $klgYS.minutesInDay)) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, $klgYS.minutesInMonth)) {
        const days = Math.round(minutes / (0, $klgYS.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, $klgYS.minutesInMonth) * 2) {
        months = Math.round(minutes / (0, $klgYS.minutesInMonth));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $gwrwo.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / (0, $klgYS.minutesInMonth));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
var // Fallback for modularized imports:
$f62a2dc9582961f4$export$2e2bcd8739ae039 = $f62a2dc9582961f4$export$2c14ff85d6318973;

});
parcelRegister("dg5qe", function(module, exports) {

$parcel$export(module.exports, "compareAsc", () => $6a377fdb36b5bd3e$export$fe114145ae75d197);

var $9Jots = parcelRequire("9Jots");
function $6a377fdb36b5bd3e$export$fe114145ae75d197(dateLeft, dateRight) {
    const _dateLeft = (0, $9Jots.toDate)(dateLeft);
    const _dateRight = (0, $9Jots.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
var // Fallback for modularized imports:
$6a377fdb36b5bd3e$export$2e2bcd8739ae039 = $6a377fdb36b5bd3e$export$fe114145ae75d197;

});

parcelRegister("gwrwo", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", () => $3c5298d7c199ac67$export$fc1ed482c2861792);

var $dg5qe = parcelRequire("dg5qe");

var $k1GjM = parcelRequire("k1GjM");

var $024rZ = parcelRequire("024rZ");

var $9Jots = parcelRequire("9Jots");
function $3c5298d7c199ac67$export$fc1ed482c2861792(dateLeft, dateRight) {
    const _dateLeft = (0, $9Jots.toDate)(dateLeft);
    const _dateRight = (0, $9Jots.toDate)(dateRight);
    const sign = (0, $dg5qe.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $k1GjM.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $dg5qe.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $024rZ.isLastDayOfMonth)((0, $9Jots.toDate)(dateLeft)) && difference === 1 && (0, $dg5qe.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$3c5298d7c199ac67$export$2e2bcd8739ae039 = $3c5298d7c199ac67$export$fc1ed482c2861792;

});
parcelRegister("k1GjM", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", () => $307c6e78b97b7da7$export$489984ac7c996389);

var $9Jots = parcelRequire("9Jots");
function $307c6e78b97b7da7$export$489984ac7c996389(dateLeft, dateRight) {
    const _dateLeft = (0, $9Jots.toDate)(dateLeft);
    const _dateRight = (0, $9Jots.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}
var // Fallback for modularized imports:
$307c6e78b97b7da7$export$2e2bcd8739ae039 = $307c6e78b97b7da7$export$489984ac7c996389;

});

parcelRegister("024rZ", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", () => $c3f357bac150d8f7$export$c817d0312007ea5e);

var $2CcMD = parcelRequire("2CcMD");

var $7wnxM = parcelRequire("7wnxM");

var $9Jots = parcelRequire("9Jots");
function $c3f357bac150d8f7$export$c817d0312007ea5e(date) {
    const _date = (0, $9Jots.toDate)(date);
    return +(0, $2CcMD.endOfDay)(_date) === +(0, $7wnxM.endOfMonth)(_date);
}
var // Fallback for modularized imports:
$c3f357bac150d8f7$export$2e2bcd8739ae039 = $c3f357bac150d8f7$export$c817d0312007ea5e;

});
parcelRegister("2CcMD", function(module, exports) {

$parcel$export(module.exports, "endOfDay", () => $3a979b41ec74cff7$export$eb9a03f0e9aa6cea);

var $9Jots = parcelRequire("9Jots");
function $3a979b41ec74cff7$export$eb9a03f0e9aa6cea(date) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$3a979b41ec74cff7$export$2e2bcd8739ae039 = $3a979b41ec74cff7$export$eb9a03f0e9aa6cea;

});

parcelRegister("7wnxM", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", () => $32e1fec708db8003$export$a2258d9c4118825c);

var $9Jots = parcelRequire("9Jots");
function $32e1fec708db8003$export$a2258d9c4118825c(date) {
    const _date = (0, $9Jots.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$32e1fec708db8003$export$2e2bcd8739ae039 = $32e1fec708db8003$export$a2258d9c4118825c;

});



parcelRegister("5YFet", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", () => $5b5215a12243b80b$export$c1889aec51783710);

var $uEr0V = parcelRequire("uEr0V");

var $ostXp = parcelRequire("ostXp");
function $5b5215a12243b80b$export$c1889aec51783710(dateLeft, dateRight, options) {
    const diff = (0, $ostXp.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, $uEr0V.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$5b5215a12243b80b$export$2e2bcd8739ae039 = $5b5215a12243b80b$export$c1889aec51783710;

});
parcelRegister("uEr0V", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $5e8e6cce394871d8$export$b6474a47258c1211);
function $5e8e6cce394871d8$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("ostXp", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", () => $f20349020b0b0782$export$7be94d13716b4bf6);

var $9Jots = parcelRequire("9Jots");
function $f20349020b0b0782$export$7be94d13716b4bf6(dateLeft, dateRight) {
    return +(0, $9Jots.toDate)(dateLeft) - +(0, $9Jots.toDate)(dateRight);
}
var // Fallback for modularized imports:
$f20349020b0b0782$export$2e2bcd8739ae039 = $f20349020b0b0782$export$7be94d13716b4bf6;

});




parcelRegister("kgjm7", function(module, exports) {

$parcel$export(module.exports, "MovableObstacleGrid", () => $91fb00b76b897255$export$84f5b4778244bee5);

var $ayMG0 = parcelRequire("ayMG0");

var $2P5BT = parcelRequire("2P5BT");

var $6lXkL = parcelRequire("6lXkL");
var $hViLc = parcelRequire("hViLc");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");

var $1J2kR = parcelRequire("1J2kR");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");

var $lNEp2 = parcelRequire("lNEp2");
const $91fb00b76b897255$export$84f5b4778244bee5 = ({ movableObstacles: movableObstacles, location: location, stack: stack, setStack: setStack })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [filter, setFilter] = $acw62.useState();
    const movableObstaclesToDisplay = $acw62.useMemo(()=>{
        if (!filter) return movableObstacles;
        return movableObstacles.filter((mo)=>mo.name.toLocaleLowerCase().indexOf(filter) > -1);
    }, [
        movableObstacles,
        filter
    ]);
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const columns = [
        {
            field: "name",
            headerName: "Name",
            width: 200,
            editable: false,
            sortable: false
        },
        {
            field: "length",
            headerName: "Length (ft)",
            width: 125,
            editable: false,
            sortable: false,
            valueFormatter: (value)=>value === 0 ? "N/A" : (0, $cLNZr.round)(value, 2)
        },
        {
            field: "width",
            headerName: "Width (ft)",
            width: 125,
            editable: false,
            sortable: false,
            valueFormatter: (value)=>value === 0 ? "N/A" : (0, $cLNZr.round)(value, 2)
        },
        {
            field: "height",
            headerName: "Height (ft)",
            width: 125,
            editable: false,
            sortable: false,
            valueFormatter: (value)=>value === 0 ? "N/A" : (0, $cLNZr.round)(value, 2)
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 200,
            renderCell: (params)=>{
                const snackbar = (0, $6fDLr.useSnackbar)();
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    size: "small",
                    variant: "contained",
                    color: "info",
                    onClick: async ()=>{
                        const entity_id = (0, $lNEp2.uuidv4)();
                        const placement_id = (0, $lNEp2.uuidv4)();
                        const newObstacle = {
                            id: (0, $lNEp2.uuidv4)(),
                            fbo_id: activeFBO.id,
                            entity_id: entity_id,
                            obstacle_id: params.row.id,
                            obstacle: params.row,
                            selected: false,
                            placement_id: placement_id,
                            position: {
                                id: placement_id,
                                stack_id: stack.id,
                                entity_id: entity_id,
                                x: 0,
                                y: 0,
                                angle: 0,
                                preferences: []
                            }
                        };
                        // Save immediately to database
                        try {
                            await postgrest.from('movable_obstacle').upsert({
                                id: newObstacle.id,
                                fbo_id: newObstacle.fbo_id,
                                entity_id: newObstacle.entity_id,
                                obstacle_id: newObstacle.obstacle_id
                            });
                            await postgrest.from('position').upsert({
                                id: newObstacle.position.id,
                                stack_id: stack.id,
                                // Base stack ID
                                entity_id: newObstacle.entity_id,
                                x: newObstacle.position.x,
                                y: newObstacle.position.y,
                                angle: newObstacle.position.angle,
                                preferences: newObstacle.position.preferences || []
                            });
                            // Update UI state for immediate display
                            const newStack = {
                                ...stack,
                                movableObstacles: stack.movableObstacles.concat([
                                    newObstacle
                                ])
                            };
                            setStack(newStack);
                            snackbar.notify({
                                text: `${params.row.name} added to ${location.name}`,
                                severity: "success"
                            });
                        } catch (error) {
                            console.error('Database save failed:', error);
                            snackbar.notify({
                                text: `Failed to add ${params.row.name}: ${error.message}`,
                                severity: "error"
                            });
                        }
                    },
                    children: "Add"
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        sx: {
            height: "100%",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                fullWidth: true,
                placeholder: "Search for an obstacle type by name",
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                        position: "start",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                    })
                },
                onChange: (evt)=>setFilter(evt.target.value)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                disableColumnFilter: true,
                disableRowSelectionOnClick: true,
                disableColumnMenu: true,
                disableColumnSelector: true,
                rows: movableObstaclesToDisplay,
                columns: columns
            })
        ]
    });
};

});
parcelRegister("1J2kR", function(module, exports) {

$parcel$export(module.exports, "DataGrid", () => $141bce2f2738cba8$export$c8dd51eb24f71762);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $gJsNs = parcelRequire("gJsNs");

var $9PaJs = parcelRequire("9PaJs");

var $5tnRA = parcelRequire("5tnRA");

var $8TaLs = parcelRequire("8TaLs");

var $eu7ae = parcelRequire("eu7ae");

var $5W2Ws = parcelRequire("5W2Ws");

var $hiKx5 = parcelRequire("hiKx5");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $141bce2f2738cba8$var$configuration = {
    hooks: {
        useGridAriaAttributes: $5tnRA.useGridAriaAttributes,
        useGridRowAriaAttributes: $8TaLs.useGridRowAriaAttributes,
        useCellAggregationResult: ()=>null
    }
};
const $141bce2f2738cba8$var$DataGridRaw = (0, $gJsNs.forwardRef)(function DataGrid(inProps, ref) {
    const props = (0, $hiKx5.useDataGridProps)(inProps);
    const privateApiRef = (0, $5W2Ws.useDataGridComponent)(props.apiRef, props);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eu7ae.GridContextProvider), {
        privateApiRef: privateApiRef,
        configuration: $141bce2f2738cba8$var$configuration,
        props: props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9PaJs.GridRoot), (0, $8nd05.default)({
            className: props.className,
            style: props.style,
            sx: props.sx
        }, props.forwardedProps, props.slotProps?.root, {
            ref: ref
        }))
    });
});
const $141bce2f2738cba8$export$c8dd51eb24f71762 = /*#__PURE__*/ $acw62.memo($141bce2f2738cba8$var$DataGridRaw);
$141bce2f2738cba8$var$DataGridRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The ref object that allows Data Grid manipulation. Can be instantiated with `useGridApiRef()`.
   */ apiRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired
    }),
    /**
   * The label of the Data Grid.
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The id of the element containing a label for the Data Grid.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the Data Grid height is dynamic and follows the number of rows in the Data Grid.
   * @default false
   * @deprecated Use flex parent container instead: https://mui.com/x/react-data-grid/layout/#flex-parent-container
   * @example
   * <div style={{ display: 'flex', flexDirection: 'column' }}>
   *   <DataGrid />
   * </div>
   */ autoHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */ autosizeOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The options for autosize when user-initiated.
   */ autosizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        disableColumnVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        expand: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        includeHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        includeOutliers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        outliersFactor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    }),
    /**
   * Controls the modes of the cells.
   */ cellModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */ checkboxSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */ clipboardCopyCellDelimiter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */ columnBufferPx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Sets the height in pixels of the column group headers in the Data Grid.
   * Inherits the `columnHeaderHeight` value if not set.
   */ columnGroupHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    columnGroupingModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */ columnHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Set of columns of type [[GridColDef]][].
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Set the density of the Data Grid.
   * @default "standard"
   */ density: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'comfortable',
        'compact',
        'standard'
    ]),
    /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */ disableAutosize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, resizing columns is disabled.
   * @default false
   */ disableColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */ disableColumnSorting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */ disableEval: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */ disableMultipleRowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableRowSelectionOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'cell',
        'row'
    ]),
    /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */ estimatedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        warnIfFocusStateIsNotSynced: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    }),
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */ filterDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'client',
        'server'
    ]),
    /**
   * Set the filter model of the Data Grid.
   */ filterModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        items: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            field: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
            ]),
            operator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
        })).isRequired,
        logicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'and',
            'or'
        ]),
        quickFilterExcludeHiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        quickFilterLogicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'and',
            'or'
        ]),
        quickFilterValues: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
    }),
    /**
   * Forwarded props for the Data Grid root element.
   * @ignore - do not document.
   */ forwardedProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */ getDetailPanelContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Return the id of a given [[GridRowModel]].
   * Ensure the reference of this prop is stable to avoid performance implications.
   * It could be done by either defining the prop outside of the component or by memoizing it.
   */ getRowId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */ ignoreDiacritics: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */ ignoreValueFormatterDuringExport: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            clipboardExport: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            csvExport: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    /**
   * If `select`, a group header checkbox in indeterminate state (like "Select All" checkbox)
   * will select all the rows under it.
   * If `deselect`, it will deselect all the rows under it.
   * Works only if `checkboxSelection` is enabled.
   * @default "deselect"
   * @deprecated `select` will be the default behavior from v8 onwards
   */ indeterminateCheckboxAction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'deselect',
        'select'
    ]),
    /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the row is selectable.
   */ isRowSelectable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        debug: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        info: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        warn: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'debug',
        'error',
        'info',
        'warn',
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */ onClipboardCopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a contextmenu event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   */ onColumnHeaderContextMenu: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnWidthChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */ onDensityChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */ onPaginationMetaChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPaginationModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */ onRowCountChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowSelectionModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ pageSizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
        })
    ]).isRequired),
    pagination: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        true
    ]),
    /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */ paginationMeta: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        hasNextPage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    }),
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */ paginationModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        page: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
        pageSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
    }),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @param {{ rowId: GridRowId }} params Additional parameters.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the page is set to 0 after each sorting or filtering.
   * This prop will be removed in the next major version and resetting the page will become the default behavior.
   * @default false
   */ resetPageOnSortFilter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */ resizeThrottleMs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */ rowBufferPx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */ rowCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */ rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The milliseconds delay to wait after measuring the row height before recalculating row positions.
   * Setting it to a lower value could be useful when using dynamic row height,
   * but might reduce performance when displaying a large number of rows.
   * @default 166
   * @deprecated
   */ rowPositionsDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */ rowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Sets the row selection model of the Data Grid.
   */ rowSelectionModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]).isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'border',
        'margin'
    ]),
    /**
   * Override the height/width of the Data Grid inner scrollbar.
   */ scrollbarSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * If `true`, vertical borders will be displayed between cells.
   * @default false
   */ showCellVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, vertical borders will be displayed between column header items.
   * @default false
   */ showColumnVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable components.
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'asc',
        'desc'
    ])),
    /**
   * Set the sort model of the Data Grid.
   */ sortModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        field: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        sort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'asc',
            'desc'
        ])
    })),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * If `true`, the Data Grid will auto span the cells over the rows having the same value.
   * @default false
   */ unstable_rowSpanning: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the Data Grid enables column virtualization when `getRowHeight` is set to `() => 'auto'`.
   * By default, column virtualization is disabled when dynamic row height is enabled to measure the row height correctly.
   * For datasets with a large number of columns, this can cause performance issues.
   * The downside of enabling this prop is that the row height will be estimated based the cells that are currently rendered, which can cause row height change when scrolling horizontally.
   * @default false
   */ virtualizeColumnsWithAutoRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};

});
parcelRegister("gJsNs", function(module, exports) {

$parcel$export(module.exports, "forwardRef", () => $c2e72fc2a32cb61d$export$257a8862b851cb5b);

var $acw62 = parcelRequire("acw62");

var $4MIDC = parcelRequire("4MIDC");
const $c2e72fc2a32cb61d$export$257a8862b851cb5b = (render)=>{
    if ((0, $4MIDC.default) >= 19) {
        const Component = (props)=>render(props, props.ref ?? null);
        Component.displayName = render.displayName ?? render.name;
        return Component;
    }
    return /*#__PURE__*/ $acw62.forwardRef(render);
};

});
parcelRegister("4MIDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $37be454c011b6ea9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $37be454c011b6ea9$export$2e2bcd8739ae039 = parseInt($acw62.version, 10);

});


parcelRegister("9PaJs", function(module, exports) {

$parcel$export(module.exports, "GridRoot", () => $727133a3c635b8ae$export$8cdbcd3b320d39bf);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");
var $3qSdM = parcelRequire("3qSdM");

var $kUNkQ = parcelRequire("kUNkQ");

var $gJsNs = parcelRequire("gJsNs");

var $aOz2q = parcelRequire("aOz2q");

var $5sOMZ = parcelRequire("5sOMZ");

var $er55f = parcelRequire("er55f");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $fD9f4 = parcelRequire("fD9f4");

var $bX8Ys = parcelRequire("bX8Ys");

var $hHwPs = parcelRequire("hHwPs");

var $1etk0 = parcelRequire("1etk0");
var $ew3Bl = parcelRequire("ew3Bl");

var $ayMG0 = parcelRequire("ayMG0");
const $727133a3c635b8ae$var$_excluded = [
    "className",
    "children"
];
const $727133a3c635b8ae$var$useUtilityClasses = (ownerState, density)=>{
    const { autoHeight: autoHeight, classes: classes, showCellVerticalBorder: showCellVerticalBorder } = ownerState;
    const slots = {
        root: [
            'root',
            autoHeight && 'autoHeight',
            `root--density${(0, $gxvzd.default)(density)}`,
            ownerState.slots.toolbar === null && 'root--noToolbar',
            'withBorderColor',
            showCellVerticalBorder && 'withVerticalBorder'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $727133a3c635b8ae$var$GridRoot = (0, $gJsNs.forwardRef)(function GridRoot(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { className: className, children: children } = props, other = (0, $1En50.default)(props, $727133a3c635b8ae$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const density = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensitySelector));
    const rootElementRef = apiRef.current.rootElementRef;
    const rootMountCallback = $acw62.useCallback((node)=>{
        if (node === null) return;
        apiRef.current.publishEvent('rootMount', node);
    }, [
        apiRef
    ]);
    const handleRef = (0, $3qSdM.default)(rootElementRef, ref, rootMountCallback);
    const ownerState = rootProps;
    const classes = $727133a3c635b8ae$var$useUtilityClasses(ownerState, density);
    const isSSR = (0, $bX8Ys.useIsSSR)();
    if (isSSR) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aOz2q.GridRootStyles), (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hHwPs.GridHeader), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1etk0.GridVirtualScroller), {
                children: children
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew3Bl.GridFooterPlaceholder), {})
        ]
    }));
});
const $727133a3c635b8ae$export$8cdbcd3b320d39bf = (0, $kUNkQ.fastMemo)($727133a3c635b8ae$var$GridRoot);

});
parcelRegister("kUNkQ", function(module, exports) {

$parcel$export(module.exports, "fastMemo", () => $f39f4e89b691584e$export$fa306e0bc9a9d6b4);

var $acw62 = parcelRequire("acw62");

var $bPnI4 = parcelRequire("bPnI4");
function $f39f4e89b691584e$export$fa306e0bc9a9d6b4(component) {
    return /*#__PURE__*/ $acw62.memo(component, (0, $bPnI4.fastObjectShallowCompare));
}

});
parcelRegister("bPnI4", function(module, exports) {

$parcel$export(module.exports, "fastObjectShallowCompare", () => $89c6d962740be425$export$84d14f151b531ccb);
const $89c6d962740be425$var$is = Object.is;
function $89c6d962740be425$export$84d14f151b531ccb(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$89c6d962740be425$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    return aLength === bLength;
}

});


parcelRegister("aOz2q", function(module, exports) {

$parcel$export(module.exports, "GridRootStyles", () => $7df9c0c298ff1f9f$export$42458c7ae3a97297);

var $8nd05 = parcelRequire("8nd05");

var $8gMkr = parcelRequire("8gMkr");
var $d8seH = parcelRequire("d8seH");

var $5H1vo = parcelRequire("5H1vo");

var $5sOMZ = parcelRequire("5sOMZ");

var $er55f = parcelRequire("er55f");
function $7df9c0c298ff1f9f$var$getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if (theme.palette.mode === 'light') return (0, $8gMkr.lighten)((0, $8gMkr.alpha)(theme.palette.divider, 1), 0.88);
    return (0, $8gMkr.darken)((0, $8gMkr.alpha)(theme.palette.divider, 1), 0.68);
}
const $7df9c0c298ff1f9f$var$columnSeparatorTargetSize = 10;
const $7df9c0c298ff1f9f$var$columnSeparatorOffset = -5;
const $7df9c0c298ff1f9f$var$focusOutlineWidth = 1;
const $7df9c0c298ff1f9f$var$separatorIconDragStyles = {
    width: 3,
    rx: 1.5,
    x: 10.5
};
// Emotion thinks it knows better than us which selector we should use.
// https://github.com/emotion-js/emotion/issues/1105#issuecomment-1722524968
const $7df9c0c298ff1f9f$var$ignoreSsrWarning = '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';
const $7df9c0c298ff1f9f$var$shouldShowBorderTopRightRadiusSelector = (state)=>state.dimensions.hasScrollX && (!state.dimensions.hasScrollY || state.dimensions.scrollbarSize === 0);
const $7df9c0c298ff1f9f$export$42458c7ae3a97297 = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>[
            // Root overrides
            styles.root,
            {
                [`&.${(0, $5H1vo.gridClasses).autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${(0, $5H1vo.gridClasses).autosizing}`]: styles.autosizing
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['root--densityStandard']}`]: styles['root--densityStandard']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['root--densityComfortable']}`]: styles['root--densityComfortable']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['root--densityCompact']}`]: styles['root--densityCompact']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['root--disableUserSelection']}`]: styles['root--disableUserSelection']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['root--noToolbar']}`]: styles['root--noToolbar']
            },
            {
                [`&.${(0, $5H1vo.gridClasses).withVerticalBorder}`]: styles.withVerticalBorder
            },
            // Child element overrides
            // - Only declare overrides here for class names that are not applied to `styled` components.
            // - For `styled` components, declare overrides in the component itself.
            {
                [`& .${(0, $5H1vo.gridClasses).actionsCell}`]: styles.actionsCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses).booleanCell}`]: styles.booleanCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cell}`]: styles.cell
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--editable']}`]: styles['cell--editable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--editing']}`]: styles['cell--editing']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--flex']}`]: styles['cell--flex']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--pinnedLeft']}`]: styles['cell--pinnedLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--pinnedRight']}`]: styles['cell--pinnedRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--rangeBottom']}`]: styles['cell--rangeBottom']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--rangeLeft']}`]: styles['cell--rangeLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--rangeRight']}`]: styles['cell--rangeRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--rangeTop']}`]: styles['cell--rangeTop']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--selectionMode']}`]: styles['cell--selectionMode']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--textCenter']}`]: styles['cell--textCenter']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--textLeft']}`]: styles['cell--textLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--textRight']}`]: styles['cell--textRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--withLeftBorder']}`]: styles['cell--withLeftBorder']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--withRightBorder']}`]: styles['cell--withRightBorder']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cellEmpty}`]: styles.cellEmpty
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cellOffsetLeft}`]: styles.cellOffsetLeft
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${(0, $5H1vo.gridClasses).checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignCenter']}`]: styles['columnHeader--alignCenter']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignLeft']}`]: styles['columnHeader--alignLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']}`]: styles['columnHeader--alignRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--dragging']}`]: styles['columnHeader--dragging']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--emptyGroup']}`]: styles['columnHeader--emptyGroup']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--filledGroup']}`]: styles['columnHeader--filledGroup']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--filtered']}`]: styles['columnHeader--filtered']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--last']}`]: styles['columnHeader--last']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--lastUnpinned']}`]: styles['columnHeader--lastUnpinned']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--moving']}`]: styles['columnHeader--moving']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--numeric']}`]: styles['columnHeader--numeric']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--pinnedLeft']}`]: styles['columnHeader--pinnedLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--pinnedRight']}`]: styles['columnHeader--pinnedRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--siblingFocused']}`]: styles['columnHeader--siblingFocused']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--sortable']}`]: styles['columnHeader--sortable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--sorted']}`]: styles['columnHeader--sorted']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--withLeftBorder']}`]: styles['columnHeader--withLeftBorder']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--withRightBorder']}`]: styles['columnHeader--withRightBorder']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainerContent}`]: styles.columnHeaderTitleContainerContent
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnSeparator--resizable']}`]: styles['columnSeparator--resizable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnSeparator--resizing']}`]: styles['columnSeparator--resizing']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnSeparator--sideLeft']}`]: styles['columnSeparator--sideLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnSeparator--sideRight']}`]: styles['columnSeparator--sideRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['container--bottom']}`]: styles['container--bottom']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['container--top']}`]: styles['container--top']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['detailPanelToggleCell--expanded']}`]: styles['detailPanelToggleCell--expanded']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses).filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['filler--borderBottom']}`]: styles['filler--borderBottom']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['filler--pinnedLeft']}`]: styles['filler--pinnedLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['filler--pinnedRight']}`]: styles['filler--pinnedRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCell}`]: styles.groupingCriteriaCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCellLoadingContainer}`]: styles.groupingCriteriaCellLoadingContainer
            },
            {
                [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCellToggle}`]: styles.groupingCriteriaCellToggle
            },
            {
                [`& .${(0, $5H1vo.gridClasses).headerFilterRow}`]: styles.headerFilterRow
            },
            {
                [`& .${(0, $5H1vo.gridClasses).iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${(0, $5H1vo.gridClasses).menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${(0, $5H1vo.gridClasses).menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${(0, $5H1vo.gridClasses).menuList}`]: styles.menuList
            },
            {
                [`& .${(0, $5H1vo.gridClasses).menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${(0, $5H1vo.gridClasses).overlayWrapperInner}`]: styles.overlayWrapperInner
            },
            {
                [`& .${(0, $5H1vo.gridClasses).pinnedRows}`]: styles.pinnedRows
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['pinnedRows--bottom']}`]: styles['pinnedRows--bottom']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['pinnedRows--top']}`]: styles['pinnedRows--top']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).row}`]: styles.row
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--borderBottom']}`]: styles['row--borderBottom']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--detailPanelExpanded']}`]: styles['row--detailPanelExpanded']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--dragging']}`]: styles['row--dragging']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--dynamicHeight']}`]: styles['row--dynamicHeight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--editable']}`]: styles['row--editable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--editing']}`]: styles['row--editing']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--firstVisible']}`]: styles['row--firstVisible']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--lastVisible']}`]: styles['row--lastVisible']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['rowReorderCell--draggable']}`]: styles['rowReorderCell--draggable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).rowReorderCellContainer}`]: styles.rowReorderCellContainer
            },
            {
                [`& .${(0, $5H1vo.gridClasses).rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${(0, $5H1vo.gridClasses).rowSkeleton}`]: styles.rowSkeleton
            },
            {
                [`& .${(0, $5H1vo.gridClasses).scrollbar}`]: styles.scrollbar
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['scrollbar--horizontal']}`]: styles['scrollbar--horizontal']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['scrollbar--vertical']}`]: styles['scrollbar--vertical']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).scrollbarFiller}`]: styles.scrollbarFiller
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['scrollbarFiller--borderBottom']}`]: styles['scrollbarFiller--borderBottom']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['scrollbarFiller--borderTop']}`]: styles['scrollbarFiller--borderTop']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['scrollbarFiller--header']}`]: styles['scrollbarFiller--header']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['scrollbarFiller--pinnedRight']}`]: styles['scrollbarFiller--pinnedRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCellLoadingContainer}`]: styles.treeDataGroupingCellLoadingContainer
            },
            {
                [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${(0, $5H1vo.gridClasses).withBorderColor}`]: styles.withBorderColor
            }
        ]
})(({ theme: t })=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const shouldShowBorderTopRightRadius = (0, $5sOMZ.useGridSelector)(apiRef, $7df9c0c298ff1f9f$var$shouldShowBorderTopRightRadiusSelector);
    const borderColor = $7df9c0c298ff1f9f$var$getBorderColor(t);
    const radius = t.shape.borderRadius;
    const containerBackground = t.vars ? t.vars.palette.background.default : t.mixins.MuiDataGrid?.containerBackground ?? t.palette.background.default;
    const pinnedBackground = t.mixins.MuiDataGrid?.pinnedBackground ?? containerBackground;
    const overlayBackground = t.vars ? `rgba(${t.vars.palette.background.defaultChannel} / ${t.vars.palette.action.disabledOpacity})` : (0, $8gMkr.alpha)(t.palette.background.default, t.palette.action.disabledOpacity);
    const hoverOpacity = (t.vars || t).palette.action.hoverOpacity;
    const hoverColor = (t.vars || t).palette.action.hover;
    const selectedOpacity = (t.vars || t).palette.action.selectedOpacity;
    const selectedHoverOpacity = t.vars ? `calc(${hoverOpacity} + ${selectedOpacity})` // TODO: Improve type
     : hoverOpacity + selectedOpacity;
    const selectedBackground = t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / ${selectedOpacity})` : (0, $8gMkr.alpha)(t.palette.primary.main, selectedOpacity);
    const selectedHoverBackground = t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / ${selectedHoverOpacity})` : (0, $8gMkr.alpha)(t.palette.primary.main, selectedHoverOpacity);
    const blendFn = t.vars ? $7df9c0c298ff1f9f$var$blendCssVars : $7df9c0c298ff1f9f$var$blend;
    const getPinnedBackgroundStyles = (backgroundColor)=>({
            [`& .${(0, $5H1vo.gridClasses)['cell--pinnedLeft']}, & .${(0, $5H1vo.gridClasses)['cell--pinnedRight']}`]: {
                backgroundColor: backgroundColor,
                '&.Mui-selected': {
                    backgroundColor: blendFn(backgroundColor, selectedBackground, selectedOpacity),
                    '&:hover': {
                        backgroundColor: blendFn(backgroundColor, selectedBackground, selectedHoverOpacity)
                    }
                }
            }
        });
    const pinnedBackgroundColor = blendFn(pinnedBackground, hoverColor, hoverOpacity);
    const pinnedHoverStyles = getPinnedBackgroundStyles(pinnedBackgroundColor);
    const pinnedSelectedBackgroundColor = blendFn(pinnedBackground, selectedBackground, selectedOpacity);
    const pinnedSelectedStyles = getPinnedBackgroundStyles(pinnedSelectedBackgroundColor);
    const pinnedSelectedHoverBackgroundColor = blendFn(pinnedBackground, selectedHoverBackground, selectedHoverOpacity);
    const pinnedSelectedHoverStyles = getPinnedBackgroundStyles(pinnedSelectedHoverBackgroundColor);
    const selectedStyles = {
        backgroundColor: selectedBackground,
        '&:hover': {
            backgroundColor: selectedHoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: selectedBackground
            }
        }
    };
    const gridStyle = (0, $8nd05.default)({
        '--unstable_DataGrid-radius': typeof radius === 'number' ? `${radius}px` : radius,
        '--unstable_DataGrid-headWeight': t.typography.fontWeightMedium,
        '--unstable_DataGrid-overlayBackground': overlayBackground,
        '--DataGrid-containerBackground': containerBackground,
        '--DataGrid-pinnedBackground': pinnedBackground,
        '--DataGrid-rowBorderColor': borderColor,
        '--DataGrid-cellOffsetMultiplier': 2,
        '--DataGrid-width': '0px',
        '--DataGrid-hasScrollX': '0',
        '--DataGrid-hasScrollY': '0',
        '--DataGrid-scrollbarSize': '10px',
        '--DataGrid-rowWidth': '0px',
        '--DataGrid-columnsTotalWidth': '0px',
        '--DataGrid-leftPinnedWidth': '0px',
        '--DataGrid-rightPinnedWidth': '0px',
        '--DataGrid-headerHeight': '0px',
        '--DataGrid-headersTotalHeight': '0px',
        '--DataGrid-topContainerHeight': '0px',
        '--DataGrid-bottomContainerHeight': '0px',
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: borderColor,
        borderRadius: 'var(--unstable_DataGrid-radius)',
        color: (t.vars || t).palette.text.primary
    }, t.typography.body2, {
        outline: 'none',
        height: '100%',
        display: 'flex',
        minWidth: 0,
        // See https://github.com/mui/mui-x/issues/8547
        minHeight: 0,
        flexDirection: 'column',
        overflow: 'hidden',
        overflowAnchor: 'none',
        // Keep the same scrolling position
        transform: 'translate(0, 0)',
        // Create a stacking context to keep scrollbars from showing on top
        [`.${(0, $5H1vo.gridClasses).main} > *:first-child${$7df9c0c298ff1f9f$var$ignoreSsrWarning}`]: {
            borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
            borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
        },
        [`&.${(0, $5H1vo.gridClasses).autoHeight}`]: {
            height: 'auto'
        },
        [`&.${(0, $5H1vo.gridClasses).autosizing}`]: {
            [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainerContent} > *`]: {
                overflow: 'visible !important'
            },
            '@media (hover: hover)': {
                [`& .${(0, $5H1vo.gridClasses).menuIcon}`]: {
                    width: '0 !important',
                    visibility: 'hidden !important'
                }
            },
            [`& .${(0, $5H1vo.gridClasses).cell}`]: {
                overflow: 'visible !important',
                whiteSpace: 'nowrap',
                minWidth: 'max-content !important',
                maxWidth: 'max-content !important'
            },
            [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCell}`]: {
                width: 'unset'
            },
            [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCell}`]: {
                width: 'unset'
            }
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}, & .${(0, $5H1vo.gridClasses).cell}`]: {
            WebkitTapHighlightColor: 'transparent',
            padding: '0 10px',
            boxSizing: 'border-box'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}:focus-within, & .${(0, $5H1vo.gridClasses).cell}:focus-within`]: {
            outline: `solid ${t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / 0.5)` : (0, $8gMkr.alpha)(t.palette.primary.main, 0.5)} ${$7df9c0c298ff1f9f$var$focusOutlineWidth}px`,
            outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}:focus, & .${(0, $5H1vo.gridClasses).cell}:focus`]: {
            outline: `solid ${t.palette.primary.main} ${$7df9c0c298ff1f9f$var$focusOutlineWidth}px`,
            outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
        },
        // Hide the column separator when:
        // - the column is focused and has an outline
        // - the next column is focused and has an outline
        // - the column has a left or right border
        // - the next column is pinned right and has a left border
        [`& .${(0, $5H1vo.gridClasses).columnHeader}:focus,
      & .${(0, $5H1vo.gridClasses)['columnHeader--withLeftBorder']},
      & .${(0, $5H1vo.gridClasses)['columnHeader--withRightBorder']},
      & .${(0, $5H1vo.gridClasses)['columnHeader--siblingFocused']},
      & .${(0, $5H1vo.gridClasses)['virtualScroller--hasScrollX']} .${(0, $5H1vo.gridClasses)['columnHeader--lastUnpinned']},
      & .${(0, $5H1vo.gridClasses)['virtualScroller--hasScrollX']} .${(0, $5H1vo.gridClasses)['columnHeader--last']}
      `]: {
            [`& .${(0, $5H1vo.gridClasses).columnSeparator}`]: {
                opacity: 0
            },
            // Show resizable separators at all times on touch devices
            '@media (hover: none)': {
                [`& .${(0, $5H1vo.gridClasses)['columnSeparator--resizable']}`]: {
                    opacity: 1
                }
            },
            [`& .${(0, $5H1vo.gridClasses)['columnSeparator--resizable']}:hover`]: {
                opacity: 1
            }
        },
        [`&.${(0, $5H1vo.gridClasses)['root--noToolbar']} [aria-rowindex="1"] [aria-colindex="1"]`]: {
            borderTopLeftRadius: 'calc(var(--unstable_DataGrid-radius) - 1px)'
        },
        [`&.${(0, $5H1vo.gridClasses)['root--noToolbar']} [aria-rowindex="1"] .${(0, $5H1vo.gridClasses)['columnHeader--last']}`]: {
            borderTopRightRadius: shouldShowBorderTopRightRadius ? 'calc(var(--unstable_DataGrid-radius) - 1px)' : undefined
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaderCheckbox}, & .${(0, $5H1vo.gridClasses).cellCheckbox}`]: {
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}`]: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses)['virtualScroller--hasScrollX']} .${(0, $5H1vo.gridClasses)['columnHeader--last']}`]: {
            overflow: 'hidden'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--sorted']} .${(0, $5H1vo.gridClasses).iconButtonContainer}, & .${(0, $5H1vo.gridClasses)['columnHeader--filtered']} .${(0, $5H1vo.gridClasses).iconButtonContainer}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}:not(.${(0, $5H1vo.gridClasses)['columnHeader--sorted']}) .${(0, $5H1vo.gridClasses).sortButton}`]: {
            opacity: 0,
            transition: t.transitions.create([
                'opacity'
            ], {
                duration: t.transitions.duration.shorter
            })
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            gap: t.spacing(0.25),
            minWidth: 0,
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainerContent}`]: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--filledGroup']} .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${(0, $5H1vo.gridClasses).sortIcon}, & .${(0, $5H1vo.gridClasses).filterIcon}`]: {
            fontSize: 'inherit'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--sortable']}`]: {
            cursor: 'pointer'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignCenter']} .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            justifyContent: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']} .${(0, $5H1vo.gridClasses).columnHeaderDraggableContainer}, & .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']} .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            flexDirection: 'row-reverse'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignCenter']} .${(0, $5H1vo.gridClasses).menuIcon}`]: {
            marginLeft: 'auto'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']} .${(0, $5H1vo.gridClasses).menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -5
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--moving']}`]: {
            backgroundColor: (t.vars || t).palette.action.hover
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--pinnedLeft']}, & .${(0, $5H1vo.gridClasses)['columnHeader--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 40,
            // Should be above the column separator
            background: 'var(--DataGrid-pinnedBackground)'
        },
        [`& .${(0, $5H1vo.gridClasses).columnSeparator}`]: {
            position: 'absolute',
            overflow: 'hidden',
            zIndex: 30,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: $7df9c0c298ff1f9f$var$columnSeparatorTargetSize,
            color: borderColor
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaders}`]: {
            width: 'var(--DataGrid-rowWidth)'
        },
        '@media (hover: hover)': {
            [`& .${(0, $5H1vo.gridClasses).columnHeader}:hover`]: {
                [`& .${(0, $5H1vo.gridClasses).menuIcon}`]: {
                    width: 'auto',
                    visibility: 'visible'
                },
                [`& .${(0, $5H1vo.gridClasses).iconButtonContainer}`]: {
                    visibility: 'visible',
                    width: 'auto'
                }
            },
            [`& .${(0, $5H1vo.gridClasses).columnHeader}:not(.${(0, $5H1vo.gridClasses)['columnHeader--sorted']}):hover .${(0, $5H1vo.gridClasses).sortButton}`]: {
                opacity: 0.5
            }
        },
        '@media (hover: none)': {
            [`& .${(0, $5H1vo.gridClasses).columnHeader} .${(0, $5H1vo.gridClasses).menuIcon}`]: {
                width: 'auto',
                visibility: 'visible'
            },
            [`& .${(0, $5H1vo.gridClasses).columnHeader}:focus,
        & .${(0, $5H1vo.gridClasses)['columnHeader--siblingFocused']}`]: {
                [`.${(0, $5H1vo.gridClasses)['columnSeparator--resizable']}`]: {
                    color: (t.vars || t).palette.primary.main
                }
            }
        },
        [`& .${(0, $5H1vo.gridClasses)['columnSeparator--sideLeft']}`]: {
            left: $7df9c0c298ff1f9f$var$columnSeparatorOffset
        },
        [`& .${(0, $5H1vo.gridClasses)['columnSeparator--sideRight']}`]: {
            right: $7df9c0c298ff1f9f$var$columnSeparatorOffset
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--withRightBorder']} .${(0, $5H1vo.gridClasses)['columnSeparator--sideLeft']}`]: {
            left: $7df9c0c298ff1f9f$var$columnSeparatorOffset - 0.5
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--withRightBorder']} .${(0, $5H1vo.gridClasses)['columnSeparator--sideRight']}`]: {
            right: $7df9c0c298ff1f9f$var$columnSeparatorOffset - 0.5
        },
        [`& .${(0, $5H1vo.gridClasses)['columnSeparator--resizable']}`]: {
            cursor: 'col-resize',
            touchAction: 'none',
            [`&.${(0, $5H1vo.gridClasses)['columnSeparator--resizing']}`]: {
                color: (t.vars || t).palette.primary.main
            },
            // Always appear as draggable on touch devices
            '@media (hover: none)': {
                [`& .${(0, $5H1vo.gridClasses).iconSeparator} rect`]: $7df9c0c298ff1f9f$var$separatorIconDragStyles
            },
            '@media (hover: hover)': {
                '&:hover': {
                    color: (t.vars || t).palette.primary.main,
                    [`& .${(0, $5H1vo.gridClasses).iconSeparator} rect`]: $7df9c0c298ff1f9f$var$separatorIconDragStyles
                }
            },
            '& svg': {
                pointerEvents: 'none'
            }
        },
        [`& .${(0, $5H1vo.gridClasses).iconSeparator}`]: {
            color: 'inherit',
            transition: t.transitions.create([
                'color',
                'width'
            ], {
                duration: t.transitions.duration.shortest
            })
        },
        [`& .${(0, $5H1vo.gridClasses).menuIcon}`]: {
            width: 0,
            visibility: 'hidden',
            fontSize: 20,
            marginRight: -5,
            display: 'flex',
            alignItems: 'center'
        },
        [`.${(0, $5H1vo.gridClasses).menuOpen}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $5H1vo.gridClasses).headerFilterRow}`]: {
            [`& .${(0, $5H1vo.gridClasses).columnHeader}`]: {
                boxSizing: 'border-box',
                borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
            }
        },
        /* Bottom border of the top-container */ [`& .${(0, $5H1vo.gridClasses)['row--borderBottom']} .${(0, $5H1vo.gridClasses).columnHeader},
      & .${(0, $5H1vo.gridClasses)['row--borderBottom']} .${(0, $5H1vo.gridClasses).filler},
      & .${(0, $5H1vo.gridClasses)['row--borderBottom']} .${(0, $5H1vo.gridClasses).scrollbarFiller}`]: {
            borderBottom: `1px solid var(--DataGrid-rowBorderColor)`
        },
        [`& .${(0, $5H1vo.gridClasses)['row--borderBottom']} .${(0, $5H1vo.gridClasses).cell}`]: {
            borderBottom: `1px solid var(--rowBorderColor)`
        },
        /* Row styles */ [`.${(0, $5H1vo.gridClasses).row}`]: {
            display: 'flex',
            width: 'var(--DataGrid-rowWidth)',
            breakInside: 'avoid',
            // Avoid the row to be broken in two different print pages.
            '--rowBorderColor': 'var(--DataGrid-rowBorderColor)',
            [`&.${(0, $5H1vo.gridClasses)['row--firstVisible']}`]: {
                '--rowBorderColor': 'transparent'
            },
            '&:hover': {
                backgroundColor: (t.vars || t).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $5H1vo.gridClasses).rowSkeleton}:hover`]: {
                backgroundColor: 'transparent'
            },
            '&.Mui-selected': selectedStyles
        },
        [`& .${(0, $5H1vo.gridClasses)['container--top']}, & .${(0, $5H1vo.gridClasses)['container--bottom']}`]: {
            '[role=row]': {
                background: 'var(--DataGrid-containerBackground)'
            }
        },
        /* Cell styles */ [`& .${(0, $5H1vo.gridClasses).cell}`]: {
            flex: '0 0 auto',
            height: 'var(--height)',
            width: 'var(--width)',
            lineHeight: 'calc(var(--height) - 1px)',
            // -1px for the border
            boxSizing: 'border-box',
            borderTop: `1px solid var(--rowBorderColor)`,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            '&.Mui-selected': selectedStyles
        },
        [`& .${(0, $5H1vo.gridClasses)['virtualScrollerContent--overflowed']} .${(0, $5H1vo.gridClasses)['row--lastVisible']} .${(0, $5H1vo.gridClasses).cell}`]: {
            borderTopColor: 'transparent'
        },
        [`& .${(0, $5H1vo.gridClasses)['pinnedRows--top']} :first-of-type`]: {
            [`& .${(0, $5H1vo.gridClasses).cell}, .${(0, $5H1vo.gridClasses).scrollbarFiller}`]: {
                borderTop: 'none'
            }
        },
        [`&.${(0, $5H1vo.gridClasses)['root--disableUserSelection']}`]: {
            userSelect: 'none'
        },
        [`& .${(0, $5H1vo.gridClasses)['row--dynamicHeight']} > .${(0, $5H1vo.gridClasses).cell}`]: {
            whiteSpace: 'initial',
            lineHeight: 'inherit'
        },
        [`& .${(0, $5H1vo.gridClasses).cellEmpty}`]: {
            flex: 1,
            padding: 0,
            height: 'unset'
        },
        [`& .${(0, $5H1vo.gridClasses).cell}.${(0, $5H1vo.gridClasses)['cell--selectionMode']}`]: {
            cursor: 'default'
        },
        [`& .${(0, $5H1vo.gridClasses).cell}.${(0, $5H1vo.gridClasses)['cell--editing']}`]: {
            padding: 1,
            display: 'flex',
            boxShadow: t.shadows[2],
            backgroundColor: (t.vars || t).palette.background.paper,
            '&:focus-within': {
                outline: `${$7df9c0c298ff1f9f$var$focusOutlineWidth}px solid ${(t.vars || t).palette.primary.main}`,
                outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
            }
        },
        [`& .${(0, $5H1vo.gridClasses)['row--editing']}`]: {
            boxShadow: t.shadows[2]
        },
        [`& .${(0, $5H1vo.gridClasses)['row--editing']} .${(0, $5H1vo.gridClasses).cell}`]: {
            boxShadow: t.shadows[0],
            backgroundColor: (t.vars || t).palette.background.paper
        },
        [`& .${(0, $5H1vo.gridClasses).editBooleanCell}`]: {
            display: 'flex',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses).booleanCell}[data-value="true"]`]: {
            color: (t.vars || t).palette.text.secondary
        },
        [`& .${(0, $5H1vo.gridClasses).booleanCell}[data-value="false"]`]: {
            color: (t.vars || t).palette.text.disabled
        },
        [`& .${(0, $5H1vo.gridClasses).actionsCell}`]: {
            display: 'inline-flex',
            alignItems: 'center',
            gridGap: t.spacing(1)
        },
        [`& .${(0, $5H1vo.gridClasses).rowReorderCell}`]: {
            display: 'inline-flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: (t.vars || t).palette.action.disabledOpacity
        },
        [`& .${(0, $5H1vo.gridClasses)['rowReorderCell--draggable']}`]: {
            cursor: 'move',
            opacity: 1
        },
        [`& .${(0, $5H1vo.gridClasses).rowReorderCellContainer}`]: {
            padding: 0,
            display: 'flex',
            alignItems: 'stretch'
        },
        [`.${(0, $5H1vo.gridClasses).withBorderColor}`]: {
            borderColor: borderColor
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--withLeftBorder']}, & .${(0, $5H1vo.gridClasses)['columnHeader--withLeftBorder']}`]: {
            borderLeftColor: 'var(--DataGrid-rowBorderColor)',
            borderLeftWidth: '1px',
            borderLeftStyle: 'solid'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--withRightBorder']}, & .${(0, $5H1vo.gridClasses)['columnHeader--withRightBorder']}`]: {
            borderRightColor: 'var(--DataGrid-rowBorderColor)',
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--flex']}`]: {
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'inherit'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--textLeft']}`]: {
            textAlign: 'left',
            justifyContent: 'flex-start'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--textRight']}`]: {
            textAlign: 'right',
            justifyContent: 'flex-end'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--textCenter']}`]: {
            textAlign: 'center',
            justifyContent: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--pinnedLeft']}, & .${(0, $5H1vo.gridClasses)['cell--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 30,
            background: 'var(--DataGrid-pinnedBackground)',
            '&.Mui-selected': {
                backgroundColor: pinnedSelectedBackgroundColor
            }
        },
        [`& .${(0, $5H1vo.gridClasses).virtualScrollerContent} .${(0, $5H1vo.gridClasses).row}`]: {
            '&:hover': pinnedHoverStyles,
            '&.Mui-selected': pinnedSelectedStyles,
            '&.Mui-selected:hover': pinnedSelectedHoverStyles
        },
        [`& .${(0, $5H1vo.gridClasses).cellOffsetLeft}`]: {
            flex: '0 0 auto',
            display: 'inline-block'
        },
        [`& .${(0, $5H1vo.gridClasses).cellSkeleton}`]: {
            flex: '0 0 auto',
            height: '100%',
            display: 'inline-flex',
            alignItems: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaderDraggableContainer}`]: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        [`& .${(0, $5H1vo.gridClasses).rowReorderCellPlaceholder}`]: {
            display: 'none'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--dragging']}, & .${(0, $5H1vo.gridClasses)['row--dragging']}`]: {
            background: (t.vars || t).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (t.vars || t).palette.action.disabledOpacity
        },
        [`& .${(0, $5H1vo.gridClasses)['row--dragging']}`]: {
            background: (t.vars || t).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (t.vars || t).palette.action.disabledOpacity,
            [`& .${(0, $5H1vo.gridClasses).rowReorderCellPlaceholder}`]: {
                display: 'flex'
            }
        },
        [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: t.spacing(2)
        },
        [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCellLoadingContainer}, .${(0, $5H1vo.gridClasses).groupingCriteriaCellLoadingContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        },
        [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: t.spacing(2)
        },
        /* ScrollbarFiller styles */ [`.${(0, $5H1vo.gridClasses).scrollbarFiller}`]: {
            minWidth: 'calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
            alignSelf: 'stretch',
            [`&.${(0, $5H1vo.gridClasses)['scrollbarFiller--borderTop']}`]: {
                borderTop: '1px solid var(--DataGrid-rowBorderColor)'
            },
            [`&.${(0, $5H1vo.gridClasses)['scrollbarFiller--borderBottom']}`]: {
                borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
            },
            [`&.${(0, $5H1vo.gridClasses)['scrollbarFiller--pinnedRight']}`]: {
                backgroundColor: 'var(--DataGrid-pinnedBackground)',
                position: 'sticky',
                right: 0
            }
        },
        [`& .${(0, $5H1vo.gridClasses).filler}`]: {
            flex: '1 0 auto'
        },
        [`& .${(0, $5H1vo.gridClasses)['filler--borderBottom']}`]: {
            borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
        },
        /* Hide grid rows, row filler, and vertical scrollbar when skeleton overlay is visible */ [`& .${(0, $5H1vo.gridClasses)['main--hasSkeletonLoadingOverlay']}`]: {
            [`& .${(0, $5H1vo.gridClasses).virtualScrollerContent}`]: {
                // We use visibility hidden so that the virtual scroller content retains its height.
                // Position fixed is used to remove the virtual scroller content from the flow.
                // https://github.com/mui/mui-x/issues/14061
                position: 'fixed',
                visibility: 'hidden'
            },
            [`& .${(0, $5H1vo.gridClasses)['scrollbar--vertical']}, & .${(0, $5H1vo.gridClasses).pinnedRows}, & .${(0, $5H1vo.gridClasses).virtualScroller} > .${(0, $5H1vo.gridClasses).filler}`]: {
                display: 'none'
            }
        }
    });
    return gridStyle;
});
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 */ function $7df9c0c298ff1f9f$var$blend(background, overlay, opacity, gamma = 1) {
    const f = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = (0, $8gMkr.decomposeColor)(background);
    const overlayColor = (0, $8gMkr.decomposeColor)(overlay);
    const rgb = [
        f(backgroundColor.values[0], overlayColor.values[0]),
        f(backgroundColor.values[1], overlayColor.values[1]),
        f(backgroundColor.values[2], overlayColor.values[2])
    ];
    return (0, $8gMkr.recomposeColor)({
        type: 'rgb',
        values: rgb
    });
}
const $7df9c0c298ff1f9f$var$removeOpacity = (color)=>`rgb(from ${color} r g b / 1)`;
function $7df9c0c298ff1f9f$var$blendCssVars(background, overlay, opacity) {
    return `color-mix(in srgb,${background}, ${$7df9c0c298ff1f9f$var$removeOpacity(overlay)} calc(${opacity} * 100%))`;
}

});
parcelRegister("5H1vo", function(module, exports) {

$parcel$export(module.exports, "getDataGridUtilityClass", () => $425222d9b2251c12$export$a2aa36217b862c23);
$parcel$export(module.exports, "gridClasses", () => $425222d9b2251c12$export$2100d54e36406477);

var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $425222d9b2251c12$export$a2aa36217b862c23(slot) {
    return (0, $4Cod0.default)('MuiDataGrid', slot);
}
const $425222d9b2251c12$export$2100d54e36406477 = (0, $beCSm.default)('MuiDataGrid', [
    'actionsCell',
    'aggregationColumnHeader',
    'aggregationColumnHeader--alignLeft',
    'aggregationColumnHeader--alignCenter',
    'aggregationColumnHeader--alignRight',
    'aggregationColumnHeaderLabel',
    'autoHeight',
    'autosizing',
    'booleanCell',
    'cell--editable',
    'cell--editing',
    'cell--flex',
    'cell--textCenter',
    'cell--textLeft',
    'cell--textRight',
    'cell--rangeTop',
    'cell--rangeBottom',
    'cell--rangeLeft',
    'cell--rangeRight',
    'cell--pinnedLeft',
    'cell--pinnedRight',
    'cell--selectionMode',
    'cell',
    'cellCheckbox',
    'cellEmpty',
    'cellSkeleton',
    'cellOffsetLeft',
    'checkboxInput',
    'columnHeader',
    'columnHeader--alignCenter',
    'columnHeader--alignLeft',
    'columnHeader--alignRight',
    'columnHeader--dragging',
    'columnHeader--moving',
    'columnHeader--numeric',
    'columnHeader--sortable',
    'columnHeader--sorted',
    'columnHeader--filtered',
    'columnHeader--pinnedLeft',
    'columnHeader--pinnedRight',
    'columnHeader--last',
    'columnHeader--lastUnpinned',
    'columnHeader--siblingFocused',
    'columnHeaderCheckbox',
    'columnHeaderDraggableContainer',
    'columnHeaderTitle',
    'columnHeaderTitleContainer',
    'columnHeaderTitleContainerContent',
    'columnHeader--filledGroup',
    'columnHeader--emptyGroup',
    'columnHeaders',
    'columnSeparator--resizable',
    'columnSeparator--resizing',
    'columnSeparator--sideLeft',
    'columnSeparator--sideRight',
    'columnSeparator',
    'columnsManagement',
    'columnsManagementRow',
    'columnsManagementHeader',
    'columnsManagementSearchInput',
    'columnsManagementFooter',
    'container--top',
    'container--bottom',
    'detailPanel',
    'detailPanels',
    'detailPanelToggleCell',
    'detailPanelToggleCell--expanded',
    'footerCell',
    'panel',
    'panelHeader',
    'panelWrapper',
    'panelContent',
    'panelFooter',
    'paper',
    'editBooleanCell',
    'editInputCell',
    'filler',
    'filler--borderBottom',
    'filler--pinnedLeft',
    'filler--pinnedRight',
    'filterForm',
    'filterFormDeleteIcon',
    'filterFormLogicOperatorInput',
    'filterFormColumnInput',
    'filterFormOperatorInput',
    'filterFormValueInput',
    'filterIcon',
    'footerContainer',
    'headerFilterRow',
    'iconButtonContainer',
    'iconSeparator',
    'main',
    'main--hasPinnedRight',
    'main--hasSkeletonLoadingOverlay',
    'menu',
    'menuIcon',
    'menuIconButton',
    'menuOpen',
    'menuList',
    'overlay',
    'overlayWrapper',
    'overlayWrapperInner',
    'root',
    'root--densityStandard',
    'root--densityComfortable',
    'root--densityCompact',
    'root--disableUserSelection',
    'root--noToolbar',
    'row',
    'row--editable',
    'row--editing',
    'row--firstVisible',
    'row--lastVisible',
    'row--dragging',
    'row--dynamicHeight',
    'row--detailPanelExpanded',
    'row--borderBottom',
    'rowReorderCellPlaceholder',
    'rowCount',
    'rowReorderCellContainer',
    'rowReorderCell',
    'rowReorderCell--draggable',
    'rowSkeleton',
    'scrollArea--left',
    'scrollArea--right',
    'scrollArea--up',
    'scrollArea--down',
    'scrollArea',
    'scrollbar',
    'scrollbar--vertical',
    'scrollbar--horizontal',
    'scrollbarFiller',
    'scrollbarFiller--header',
    'scrollbarFiller--borderTop',
    'scrollbarFiller--borderBottom',
    'scrollbarFiller--pinnedRight',
    'selectedRowCount',
    'sortButton',
    'sortIcon',
    'toolbarContainer',
    'toolbarFilterList',
    'virtualScroller',
    'virtualScroller--hasScrollX',
    'virtualScrollerContent',
    'virtualScrollerContent--overflowed',
    'virtualScrollerRenderZone',
    'pinnedColumns',
    'withVerticalBorder',
    'withBorderColor',
    'cell--withRightBorder',
    'cell--withLeftBorder',
    'columnHeader--withRightBorder',
    'columnHeader--withLeftBorder',
    'treeDataGroupingCell',
    'treeDataGroupingCellToggle',
    'treeDataGroupingCellLoadingContainer',
    'groupingCriteriaCell',
    'groupingCriteriaCellToggle',
    'groupingCriteriaCellLoadingContainer',
    'pinnedRows',
    'pinnedRows--top',
    'pinnedRows--bottom',
    'pinnedRowsRenderZone'
]);

});

parcelRegister("5sOMZ", function(module, exports) {

$parcel$export(module.exports, "objectShallowCompare", () => $3fa6f6f21ffa38ee$export$8da4c691e5695191);
$parcel$export(module.exports, "argsEqual", () => $3fa6f6f21ffa38ee$export$5a7c3a25f6dab637);
$parcel$export(module.exports, "useGridSelector", () => $3fa6f6f21ffa38ee$export$f96fd476863f2e4a);
$parcel$export(module.exports, "useGridSelectorV8", () => $3fa6f6f21ffa38ee$export$3b2f72ef07abe101);

var $acw62 = parcelRequire("acw62");

var $bPnI4 = parcelRequire("bPnI4");


var $hfliI = parcelRequire("hfliI");

var $iYIN2 = parcelRequire("iYIN2");
function $3fa6f6f21ffa38ee$var$isOutputSelector(selector) {
    return selector.acceptsApiRef;
}
// TODO v8: Remove this function
function $3fa6f6f21ffa38ee$var$applySelector(apiRef, selector) {
    if ($3fa6f6f21ffa38ee$var$isOutputSelector(selector)) return selector(apiRef);
    return selector(apiRef.current.state);
}
// TODO v8: Rename this function to `applySelector`
function $3fa6f6f21ffa38ee$var$applySelectorV8(apiRef, selector, args, instanceId) {
    if ($3fa6f6f21ffa38ee$var$isOutputSelector(selector)) return selector(apiRef, args);
    return selector(apiRef.current.state, instanceId);
}
const $3fa6f6f21ffa38ee$var$defaultCompare = Object.is;
const $3fa6f6f21ffa38ee$export$8da4c691e5695191 = (0, $bPnI4.fastObjectShallowCompare);
const $3fa6f6f21ffa38ee$var$arrayShallowCompare = (a, b)=>{
    if (a === b) return true;
    return a.length === b.length && a.every((v, i)=>v === b[i]);
};
const $3fa6f6f21ffa38ee$export$5a7c3a25f6dab637 = (prev, curr)=>{
    let fn = Object.is;
    if (curr instanceof Array) fn = $3fa6f6f21ffa38ee$var$arrayShallowCompare;
    else if (curr instanceof Object) fn = $3fa6f6f21ffa38ee$export$8da4c691e5695191;
    return fn(prev, curr);
};
const $3fa6f6f21ffa38ee$var$createRefs = ()=>({
        state: null,
        equals: null,
        selector: null,
        args: undefined
    });
const $3fa6f6f21ffa38ee$var$EMPTY = [];
const $3fa6f6f21ffa38ee$var$emptyGetSnapshot = ()=>null;
const $3fa6f6f21ffa38ee$export$f96fd476863f2e4a = (apiRef, selector, equals = $3fa6f6f21ffa38ee$var$defaultCompare)=>{
    const refs = (0, $iYIN2.default)($3fa6f6f21ffa38ee$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $acw62.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : $3fa6f6f21ffa38ee$var$applySelector(apiRef, selector));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    const subscribe = $acw62.useCallback(()=>{
        if (refs.current.subscription) return null;
        refs.current.subscription = apiRef.current.store.subscribe(()=>{
            const newState = $3fa6f6f21ffa38ee$var$applySelector(apiRef, refs.current.selector);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    $3fa6f6f21ffa38ee$var$EMPTY);
    const unsubscribe = $acw62.useCallback(()=>{
        return ()=>{
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3fa6f6f21ffa38ee$var$EMPTY);
    (0, $hfliI.useSyncExternalStore)(unsubscribe, subscribe, $3fa6f6f21ffa38ee$var$emptyGetSnapshot);
    return state;
};
const $3fa6f6f21ffa38ee$export$3b2f72ef07abe101 = (apiRef, selector, args, equals = $3fa6f6f21ffa38ee$var$defaultCompare)=>{
    const refs = (0, $iYIN2.default)($3fa6f6f21ffa38ee$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $acw62.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : $3fa6f6f21ffa38ee$var$applySelectorV8(apiRef, selector, args, apiRef.current.instanceId));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    const prevArgs = refs.current.args;
    refs.current.args = args;
    if (didInit && !$3fa6f6f21ffa38ee$export$5a7c3a25f6dab637(prevArgs, args)) {
        const newState = $3fa6f6f21ffa38ee$var$applySelectorV8(apiRef, refs.current.selector, refs.current.args, apiRef.current.instanceId);
        if (!refs.current.equals(refs.current.state, newState)) {
            refs.current.state = newState;
            setState(newState);
        }
    }
    const subscribe = $acw62.useCallback(()=>{
        if (refs.current.subscription) return null;
        refs.current.subscription = apiRef.current.store.subscribe(()=>{
            const newState = $3fa6f6f21ffa38ee$var$applySelectorV8(apiRef, refs.current.selector, refs.current.args, apiRef.current.instanceId);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    $3fa6f6f21ffa38ee$var$EMPTY);
    const unsubscribe = $acw62.useCallback(()=>{
        return ()=>{
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3fa6f6f21ffa38ee$var$EMPTY);
    (0, $hfliI.useSyncExternalStore)(unsubscribe, subscribe, $3fa6f6f21ffa38ee$var$emptyGetSnapshot);
    return state;
};

});

parcelRegister("er55f", function(module, exports) {

$parcel$export(module.exports, "GridPrivateApiContext", () => $a82787d0b1c2b050$export$37099e7a34cbf988);
$parcel$export(module.exports, "useGridPrivateApiContext", () => $a82787d0b1c2b050$export$e1fd9274eb96ee18);

var $acw62 = parcelRequire("acw62");
const $a82787d0b1c2b050$export$37099e7a34cbf988 = /*#__PURE__*/ $acw62.createContext(undefined);
function $a82787d0b1c2b050$export$e1fd9274eb96ee18() {
    const privateApiRef = $acw62.useContext($a82787d0b1c2b050$export$37099e7a34cbf988);
    if (privateApiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid private context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return privateApiRef;
}

});


parcelRegister("jDpXp", function(module, exports) {

$parcel$export(module.exports, "useGridRootProps", () => $e4b5cb616f3aaa8a$export$8b0f8e71b71b7ed3);

var $acw62 = parcelRequire("acw62");

var $96LtV = parcelRequire("96LtV");
const $e4b5cb616f3aaa8a$export$8b0f8e71b71b7ed3 = ()=>{
    const contextValue = $acw62.useContext((0, $96LtV.GridRootPropsContext));
    if (!contextValue) throw new Error('MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
    return contextValue;
};

});
parcelRegister("96LtV", function(module, exports) {

$parcel$export(module.exports, "GridRootPropsContext", () => $6a19817c134c532b$export$e00c5fe7e13db7ba);

var $acw62 = parcelRequire("acw62");
'use client';
const $6a19817c134c532b$export$e00c5fe7e13db7ba = /*#__PURE__*/ $acw62.createContext(undefined);

});


parcelRegister("fD9f4", function(module, exports) {

$parcel$export(module.exports, "gridDensitySelector", () => $b611aad21a5b677d$export$806a039ece4425b4);
$parcel$export(module.exports, "gridDensityFactorSelector", () => $b611aad21a5b677d$export$c646201fb1d3e7a6);

var $cgQ4y = parcelRequire("cgQ4y");
const $b611aad21a5b677d$export$44e428f429332330 = 0.7;
const $b611aad21a5b677d$export$ff72d9a37c8f7b58 = 1.3;
const $b611aad21a5b677d$var$DENSITY_FACTORS = {
    compact: $b611aad21a5b677d$export$44e428f429332330,
    comfortable: $b611aad21a5b677d$export$ff72d9a37c8f7b58,
    standard: 1
};
const $b611aad21a5b677d$export$806a039ece4425b4 = (state)=>state.density;
const $b611aad21a5b677d$export$c646201fb1d3e7a6 = (0, $cgQ4y.createSelector)($b611aad21a5b677d$export$806a039ece4425b4, (density)=>$b611aad21a5b677d$var$DENSITY_FACTORS[density]);

});
parcelRegister("cgQ4y", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $8eef5f2af445e503$export$595d22ed68ca2841);
$parcel$export(module.exports, "createSelectorV8", () => $8eef5f2af445e503$export$89f5fc21559ede9b);
$parcel$export(module.exports, "createSelectorMemoized", () => $8eef5f2af445e503$export$2a3ca4704a61d1f4);

var $4KtEQ = parcelRequire("4KtEQ");


var $5sOMZ = parcelRequire("5sOMZ");
const $8eef5f2af445e503$var$reselectCreateSelector = (0, $4KtEQ.createSelectorCreator)({
    memoize: (0, $4KtEQ.lruMemoize),
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
// TODO v8: Remove this type
// TODO v8: Rename this type to `OutputSelector`
// TODO v8: Remove this type
// TODO v8: Rename this type to `SelectorArgs`
// TODO v8: Remove this type
// TODO v8: Rename this type to `CreateSelectorFunction`
const $8eef5f2af445e503$var$cache = new WeakMap();
function $8eef5f2af445e503$var$checkIsAPIRef(value) {
    return 'current' in value && 'instanceId' in value.current;
}
const $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID = {
    id: 'default'
};
const $8eef5f2af445e503$export$595d22ed68ca2841 = (a, b, c, d, e, f, ...other)=>{
    if (other.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    // eslint-disable-next-line id-denylist
    if (a && b && c && d && e && f) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        const ve = e(state, instanceId);
        return f(va, vb, vc, vd, ve);
    };
    else if (a && b && c && d && e) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        return e(va, vb, vc, vd);
    };
    else if (a && b && c && d) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        return d(va, vb, vc);
    };
    else if (a && b && c) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        return c(va, vb);
    };
    else if (a && b) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        return b(va);
    };
    else throw new Error('Missing arguments');
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $8eef5f2af445e503$export$89f5fc21559ede9b = (a, b, c, d, e, f, ...other)=>{
    if (other.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    // eslint-disable-next-line id-denylist
    if (a && b && c && d && e && f) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        const vb = b(state, args, instanceId);
        const vc = c(state, args, instanceId);
        const vd = d(state, args, instanceId);
        const ve = e(state, args, instanceId);
        return f(va, vb, vc, vd, ve, args);
    };
    else if (a && b && c && d && e) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        const vb = b(state, args, instanceId);
        const vc = c(state, args, instanceId);
        const vd = d(state, args, instanceId);
        return e(va, vb, vc, vd, args);
    };
    else if (a && b && c && d) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        const vb = b(state, args, instanceId);
        const vc = c(state, args, instanceId);
        return d(va, vb, vc, args);
    };
    else if (a && b && c) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        const vb = b(state, args, instanceId);
        return c(va, vb, args);
    };
    else if (a && b) selector = (stateOrApiRef, args, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam ?? (isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID);
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, args, instanceId);
        return b(va, args);
    };
    else throw new Error('Missing arguments');
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $8eef5f2af445e503$export$2a3ca4704a61d1f4 = (...args)=>{
    const selector = (stateOrApiRef, instanceId)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId ?? $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const cacheArgsInit = $8eef5f2af445e503$var$cache.get(cacheKey);
        const cacheArgs = cacheArgsInit ?? new Map();
        const cacheFn = cacheArgs?.get(args);
        if (cacheArgs && cacheFn) // We pass the cache key because the called selector might have as
        // dependency another selector created with this `createSelector`.
        return cacheFn(state, cacheKey);
        const fn = $8eef5f2af445e503$var$reselectCreateSelector(...args);
        if (!cacheArgsInit) $8eef5f2af445e503$var$cache.set(cacheKey, cacheArgs);
        cacheArgs.set(args, fn);
        return fn(state, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $8eef5f2af445e503$export$9da95869caa746c6 = (...args)=>{
    const selector = (stateOrApiRef, selectorArgs, instanceId)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId ?? $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const cacheArgsInit = $8eef5f2af445e503$var$cache.get(cacheKey);
        const cacheArgs = cacheArgsInit ?? new Map();
        const cacheFn = cacheArgs?.get(args);
        if (cacheArgs && cacheFn) {
            if (!(0, $5sOMZ.argsEqual)(cacheFn.selectorArgs, selectorArgs)) {
                const reselectArgs = selectorArgs !== undefined ? [
                    ...args.slice(0, args.length - 1),
                    ()=>selectorArgs,
                    args[args.length - 1]
                ] : args;
                const fn = $8eef5f2af445e503$var$reselectCreateSelector(...reselectArgs);
                fn.selectorArgs = selectorArgs;
                cacheArgs.set(args, fn);
                return fn(state, selectorArgs, cacheKey);
            }
            // We pass the cache key because the called selector might have as
            // dependency another selector created with this `createSelector`.
            return cacheFn(state, selectorArgs, cacheKey);
        }
        const reselectArgs = selectorArgs !== undefined ? [
            ...args.slice(0, args.length - 1),
            ()=>selectorArgs,
            args[args.length - 1]
        ] : args;
        const fn = $8eef5f2af445e503$var$reselectCreateSelector(...reselectArgs);
        fn.selectorArgs = selectorArgs;
        if (!cacheArgsInit) $8eef5f2af445e503$var$cache.set(cacheKey, cacheArgs);
        cacheArgs.set(args, fn);
        return fn(state, selectorArgs, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};

});
parcelRegister("4KtEQ", function(module, exports) {

$parcel$export(module.exports, "lruMemoize", () => $375276bea32f9eda$export$d8ead1d92249919b);
$parcel$export(module.exports, "createSelectorCreator", () => $375276bea32f9eda$export$5943f4447f6ef248);
$parcel$export(module.exports, "createSelector", () => $375276bea32f9eda$export$595d22ed68ca2841);
var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});

});



parcelRegister("bX8Ys", function(module, exports) {

$parcel$export(module.exports, "useIsSSR", () => $8b3c2a77bf85fdbc$export$535bd6ca7f90a273);

var $hfliI = parcelRequire("hfliI");
const $8b3c2a77bf85fdbc$var$emptySubscribe = ()=>()=>{};
const $8b3c2a77bf85fdbc$var$clientSnapshot = ()=>false;
const $8b3c2a77bf85fdbc$var$serverSnapshot = ()=>true;
const $8b3c2a77bf85fdbc$export$535bd6ca7f90a273 = ()=>(0, $hfliI.useSyncExternalStore)($8b3c2a77bf85fdbc$var$emptySubscribe, $8b3c2a77bf85fdbc$var$clientSnapshot, $8b3c2a77bf85fdbc$var$serverSnapshot);

});

parcelRegister("hHwPs", function(module, exports) {

$parcel$export(module.exports, "GridHeader", () => $ce2feaf42932ccbe$export$74ac40502a3200d3);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $jDpXp = parcelRequire("jDpXp");

var $tZfVk = parcelRequire("tZfVk");

var $ayMG0 = parcelRequire("ayMG0");
function $ce2feaf42932ccbe$export$74ac40502a3200d3() {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $tZfVk.GridPreferencesPanel), {}),
            rootProps.slots.toolbar && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.toolbar, (0, $8nd05.default)({}, rootProps.slotProps?.toolbar))
        ]
    });
}

});
parcelRegister("tZfVk", function(module, exports) {

$parcel$export(module.exports, "GridPreferencesPanel", () => $05a239ae20a1382d$export$6cff59e5608ce17d);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $6X2Yd = parcelRequire("6X2Yd");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $05a239ae20a1382d$export$6cff59e5608ce17d() {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnDefinitionsSelector));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const preferencePanelState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $6X2Yd.gridPreferencePanelStateSelector));
    const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, preferencePanelState.openedPanelValue ?? (0, $3PCYS.GridPreferencePanelsValue).filters);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.panel, (0, $8nd05.default)({
        as: rootProps.slots.basePopper,
        open: columns.length > 0 && preferencePanelState.open,
        id: preferencePanelState.panelId,
        "aria-labelledby": preferencePanelState.labelId
    }, rootProps.slotProps?.panel, rootProps.slotProps?.basePopper, {
        children: panelContent
    }));
}

});
parcelRegister("jQEEt", function(module, exports) {

$parcel$export(module.exports, "gridColumnsStateSelector", () => $e732684465924d20$export$858d15abb6cddc08);
$parcel$export(module.exports, "gridColumnFieldsSelector", () => $e732684465924d20$export$d8a3dfbb129c80db);
$parcel$export(module.exports, "gridColumnLookupSelector", () => $e732684465924d20$export$8a3a9a6db584d7fd);
$parcel$export(module.exports, "gridColumnDefinitionsSelector", () => $e732684465924d20$export$da85f06e3c19f1fd);
$parcel$export(module.exports, "gridColumnVisibilityModelSelector", () => $e732684465924d20$export$eb0d33595fe29bb4);
$parcel$export(module.exports, "gridVisibleColumnDefinitionsSelector", () => $e732684465924d20$export$16a65a9447d3dda9);
$parcel$export(module.exports, "gridVisibleColumnFieldsSelector", () => $e732684465924d20$export$c9491722e1d6e8d3);
$parcel$export(module.exports, "gridVisiblePinnedColumnDefinitionsSelector", () => $e732684465924d20$export$297e8079713afa11);
$parcel$export(module.exports, "gridColumnPositionsSelector", () => $e732684465924d20$export$fce7d810e48021e3);
$parcel$export(module.exports, "gridFilterableColumnDefinitionsSelector", () => $e732684465924d20$export$2cad659ba95fed71);
$parcel$export(module.exports, "gridFilterableColumnLookupSelector", () => $e732684465924d20$export$e84218276cc24419);
$parcel$export(module.exports, "gridHasColSpanSelector", () => $e732684465924d20$export$7aac81e7227448b4);

var $cgQ4y = parcelRequire("cgQ4y");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $9Yhwe = parcelRequire("9Yhwe");
const $e732684465924d20$export$858d15abb6cddc08 = (state)=>state.columns;
const $e732684465924d20$export$d8a3dfbb129c80db = (0, $cgQ4y.createSelector)($e732684465924d20$export$858d15abb6cddc08, (columnsState)=>columnsState.orderedFields);
const $e732684465924d20$export$8a3a9a6db584d7fd = (0, $cgQ4y.createSelector)($e732684465924d20$export$858d15abb6cddc08, (columnsState)=>columnsState.lookup);
const $e732684465924d20$export$da85f06e3c19f1fd = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$d8a3dfbb129c80db, $e732684465924d20$export$8a3a9a6db584d7fd, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
const $e732684465924d20$export$eb0d33595fe29bb4 = (0, $cgQ4y.createSelector)($e732684465924d20$export$858d15abb6cddc08, (columnsState)=>columnsState.columnVisibilityModel);
const $e732684465924d20$export$16a65a9447d3dda9 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$da85f06e3c19f1fd, $e732684465924d20$export$eb0d33595fe29bb4, (columns, columnVisibilityModel)=>columns.filter((column)=>columnVisibilityModel[column.field] !== false));
const $e732684465924d20$export$c9491722e1d6e8d3 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$16a65a9447d3dda9, (visibleColumns)=>visibleColumns.map((column)=>column.field));
const $e732684465924d20$export$1eea0bd4db853467 = (state)=>state.pinnedColumns;
const $e732684465924d20$export$92910475beda795c = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$1eea0bd4db853467, $e732684465924d20$export$d8a3dfbb129c80db, (0, $9Yhwe.gridIsRtlSelector), (model, orderedFields, isRtl)=>$e732684465924d20$var$filterMissingColumns(model, orderedFields, isRtl));
const $e732684465924d20$export$297e8079713afa11 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$858d15abb6cddc08, $e732684465924d20$export$1eea0bd4db853467, $e732684465924d20$export$c9491722e1d6e8d3, (0, $9Yhwe.gridIsRtlSelector), (columnsState, model, visibleColumnFields, isRtl)=>{
    const visiblePinnedFields = $e732684465924d20$var$filterMissingColumns(model, visibleColumnFields, isRtl);
    const visiblePinnedColumns = {
        left: visiblePinnedFields.left.map((field)=>columnsState.lookup[field]),
        right: visiblePinnedFields.right.map((field)=>columnsState.lookup[field])
    };
    return visiblePinnedColumns;
});
function $e732684465924d20$var$filterMissingColumns(pinnedColumns, columns, invert) {
    if (!Array.isArray(pinnedColumns.left) && !Array.isArray(pinnedColumns.right)) return 0, $4ZMWQ.EMPTY_PINNED_COLUMN_FIELDS;
    if (pinnedColumns.left?.length === 0 && pinnedColumns.right?.length === 0) return 0, $4ZMWQ.EMPTY_PINNED_COLUMN_FIELDS;
    const filter = (newPinnedColumns, remainingColumns)=>{
        if (!Array.isArray(newPinnedColumns)) return [];
        return newPinnedColumns.filter((field)=>remainingColumns.includes(field));
    };
    const leftPinnedColumns = filter(pinnedColumns.left, columns);
    const columnsWithoutLeftPinnedColumns = columns.filter(// Filter out from the remaining columns those columns already pinned to the left
    (field)=>!leftPinnedColumns.includes(field));
    const rightPinnedColumns = filter(pinnedColumns.right, columnsWithoutLeftPinnedColumns);
    if (invert) return {
        left: rightPinnedColumns,
        right: leftPinnedColumns
    };
    return {
        left: leftPinnedColumns,
        right: rightPinnedColumns
    };
}
const $e732684465924d20$export$fce7d810e48021e3 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$16a65a9447d3dda9, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
const $e732684465924d20$export$2cad659ba95fed71 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$da85f06e3c19f1fd, (columns)=>columns.filter((col)=>col.filterable));
const $e732684465924d20$export$e84218276cc24419 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$da85f06e3c19f1fd, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));
const $e732684465924d20$export$7aac81e7227448b4 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$da85f06e3c19f1fd, (columns)=>columns.some((column)=>column.colSpan !== undefined));

});
parcelRegister("4ZMWQ", function(module, exports) {

$parcel$export(module.exports, "GridPinnedColumnPosition", () => $3a32d3fdbf8b29fd$export$64f54b460f67389c);
$parcel$export(module.exports, "EMPTY_PINNED_COLUMN_FIELDS", () => $3a32d3fdbf8b29fd$export$77439b544edbbd66);
let $3a32d3fdbf8b29fd$export$64f54b460f67389c = /*#__PURE__*/ function(GridPinnedColumnPosition) {
    GridPinnedColumnPosition["LEFT"] = "left";
    GridPinnedColumnPosition["RIGHT"] = "right";
    return GridPinnedColumnPosition;
}({});
const $3a32d3fdbf8b29fd$export$77439b544edbbd66 = {
    left: [],
    right: []
};

});

parcelRegister("9Yhwe", function(module, exports) {

$parcel$export(module.exports, "gridIsRtlSelector", () => $74274e8a7594bea9$export$ece6490d69662ba0);
/**
 * Get the theme state
 * @category Core
 */ const $74274e8a7594bea9$export$ece6490d69662ba0 = (state)=>state.isRtl;

});


parcelRegister("6X2Yd", function(module, exports) {

$parcel$export(module.exports, "gridPreferencePanelStateSelector", () => $50fa8e974bf84473$export$37e5474577e02878);
$parcel$export(module.exports, "gridPreferencePanelSelectorWithLabel", () => $50fa8e974bf84473$export$d19024d6f0cb2c88);

var $cgQ4y = parcelRequire("cgQ4y");
const $50fa8e974bf84473$export$37e5474577e02878 = (state)=>state.preferencePanel;
const $50fa8e974bf84473$export$d19024d6f0cb2c88 = (0, $cgQ4y.createSelectorV8)($50fa8e974bf84473$export$37e5474577e02878, (panel, labelId)=>{
    if (panel.open && panel.labelId === labelId) return true;
    return false;
});

});

parcelRegister("3PCYS", function(module, exports) {

$parcel$export(module.exports, "GridPreferencePanelsValue", () => $2ca45f4bbfed6878$export$e7e5652452e44b);
var $2ca45f4bbfed6878$export$e7e5652452e44b = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    return GridPreferencePanelsValue;
}($2ca45f4bbfed6878$export$e7e5652452e44b || {});

});

parcelRegister("bDyDY", function(module, exports) {

$parcel$export(module.exports, "useGridApiContext", () => $878e35c228656139$export$2d14edd3a7db3bbf);

var $acw62 = parcelRequire("acw62");

var $YSznt = parcelRequire("YSznt");
function $878e35c228656139$export$2d14edd3a7db3bbf() {
    const apiRef = $acw62.useContext((0, $YSznt.GridApiContext));
    if (apiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return apiRef;
}

});
parcelRegister("YSznt", function(module, exports) {

$parcel$export(module.exports, "GridApiContext", () => $0b6fef1928293673$export$70c437c2dab15e52);

var $acw62 = parcelRequire("acw62");
'use client';
const $0b6fef1928293673$export$70c437c2dab15e52 = /*#__PURE__*/ $acw62.createContext(undefined);

});




parcelRegister("1etk0", function(module, exports) {

$parcel$export(module.exports, "GridVirtualScroller", () => $0e5dd7e9e576a614$export$febd8ae712031b27);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");

var $61HyH = parcelRequire("61HyH");

var $575FW = parcelRequire("575FW");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $5H1vo = parcelRequire("5H1vo");

var $fHEg1 = parcelRequire("fHEg1");

var $dDKMM = parcelRequire("dDKMM");

var $6ru7t = parcelRequire("6ru7t");

var $dS4gY = parcelRequire("dS4gY");

var $kcb79 = parcelRequire("kcb79");

var $8yMKs = parcelRequire("8yMKs");

var $1GTuR = parcelRequire("1GTuR");

var $lLmsJ = parcelRequire("lLmsJ");

var $a8jkJ = parcelRequire("a8jkJ");

var $5v0S6 = parcelRequire("5v0S6");

var $cv3bf = parcelRequire("cv3bf");

var $ayMG0 = parcelRequire("ayMG0");
const $0e5dd7e9e576a614$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, hasScrollX: hasScrollX, hasPinnedRight: hasPinnedRight, loadingOverlayVariant: loadingOverlayVariant } = ownerState;
    const slots = {
        root: [
            'main',
            hasPinnedRight && 'main--hasPinnedRight',
            loadingOverlayVariant === 'skeleton' && 'main--hasSkeletonLoadingOverlay'
        ],
        scroller: [
            'virtualScroller',
            hasScrollX && 'virtualScroller--hasScrollX'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $0e5dd7e9e576a614$var$Scroller = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScroller,
            ownerState.hasScrollX && styles['virtualScroller--hasScrollX']
        ];
    }
})({
    position: 'relative',
    height: '100%',
    flexGrow: 1,
    overflow: 'scroll',
    scrollbarWidth: 'none' /* Firefox */ ,
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
        display: 'none' /* Safari and Chrome */ 
    },
    '@media print': {
        overflow: 'hidden'
    },
    // See https://github.com/mui/mui-x/issues/10547
    zIndex: 0
});
const $0e5dd7e9e576a614$var$hasPinnedRightSelector = (state)=>state.dimensions.rightPinnedWidth > 0;
function $0e5dd7e9e576a614$export$febd8ae712031b27(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const hasScrollY = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridHasScrollYSelector));
    const hasScrollX = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridHasScrollXSelector));
    const hasPinnedRight = (0, $5sOMZ.useGridSelector)(apiRef, $0e5dd7e9e576a614$var$hasPinnedRightSelector);
    const hasBottomFiller = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridHasBottomFillerSelector));
    const overlaysProps = (0, $dDKMM.useGridOverlays)();
    const ownerState = {
        classes: rootProps.classes,
        hasScrollX: hasScrollX,
        hasPinnedRight: hasPinnedRight,
        loadingOverlayVariant: overlaysProps.loadingOverlayVariant
    };
    const classes = $0e5dd7e9e576a614$var$useUtilityClasses(ownerState);
    const virtualScroller = (0, $fHEg1.useGridVirtualScroller)();
    const { getContainerProps: getContainerProps, getScrollerProps: getScrollerProps, getContentProps: getContentProps, getRenderZoneProps: getRenderZoneProps, getScrollbarVerticalProps: getScrollbarVerticalProps, getScrollbarHorizontalProps: getScrollbarHorizontalProps, getRows: getRows, getScrollAreaProps: getScrollAreaProps } = virtualScroller;
    const rows = getRows();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kcb79.GridMainContainer), (0, $8nd05.default)({
        className: classes.root
    }, getContainerProps(), {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $575FW.GridScrollArea), (0, $8nd05.default)({
                scrollDirection: "left"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $575FW.GridScrollArea), (0, $8nd05.default)({
                scrollDirection: "right"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $575FW.GridScrollArea), (0, $8nd05.default)({
                scrollDirection: "up"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $575FW.GridScrollArea), (0, $8nd05.default)({
                scrollDirection: "down"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($0e5dd7e9e576a614$var$Scroller, (0, $8nd05.default)({
                className: classes.scroller
            }, getScrollerProps(), {
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8yMKs.GridTopContainer), {
                        children: [
                            !rootProps.unstable_listView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dS4gY.GridHeaders), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pinnedRows, {
                                position: "top",
                                virtualScroller: virtualScroller
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ru7t.GridOverlays), (0, $8nd05.default)({}, overlaysProps)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lLmsJ.GridVirtualScrollerContent), (0, $8nd05.default)({}, getContentProps(), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5v0S6.GridVirtualScrollerRenderZone), (0, $8nd05.default)({}, getRenderZoneProps(), {
                            children: [
                                rows,
                                /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.detailPanels, {
                                    virtualScroller: virtualScroller
                                })
                            ]
                        }))
                    })),
                    hasBottomFiller && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8jkJ.GridVirtualScrollerFiller), {
                        rowsLength: rows.length
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GTuR.GridBottomContainer), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pinnedRows, {
                            position: "bottom",
                            virtualScroller: virtualScroller
                        })
                    })
                ]
            })),
            hasScrollX && !rootProps.unstable_listView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cv3bf.GridVirtualScrollbar), (0, $8nd05.default)({
                position: "horizontal"
            }, getScrollbarHorizontalProps())),
            hasScrollY && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cv3bf.GridVirtualScrollbar), (0, $8nd05.default)({
                position: "vertical"
            }, getScrollbarVerticalProps())),
            props.children
        ]
    }));
}

});
parcelRegister("izOUK", function(module, exports) {
/**
 * @mui/system v7.3.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d862fd65d58a79bb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d862fd65d58a79bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d862fd65d58a79bb$var$_exportNames = {
    experimental_sx: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    GlobalStyles: true,
    borders: true,
    breakpoints: true,
    handleBreakpoints: true,
    mergeBreakpointsInOrder: true,
    unstable_resolveBreakpointValues: true,
    cssContainerQueries: true,
    compose: true,
    display: true,
    flexbox: true,
    grid: true,
    palette: true,
    positions: true,
    shadows: true,
    sizing: true,
    spacing: true,
    style: true,
    getPath: true,
    getStyleValue: true,
    typography: true,
    unstable_styleFunctionSx: true,
    unstable_createStyleFunctionSx: true,
    unstable_extendSxProp: true,
    unstable_defaultSxConfig: true,
    unstable_getThemeValue: true,
    Box: true,
    createBox: true,
    createStyled: true,
    styled: true,
    createTheme: true,
    createBreakpoints: true,
    createSpacing: true,
    shape: true,
    useThemeProps: true,
    getThemeProps: true,
    useTheme: true,
    useThemeWithoutDefault: true,
    useMediaQuery: true,
    ThemeProvider: true,
    unstable_memoTheme: true,
    unstable_createCssVarsProvider: true,
    unstable_createGetCssVar: true,
    unstable_cssVarsParser: true,
    unstable_prepareCssVars: true,
    unstable_createCssVarsTheme: true,
    responsivePropType: true,
    RtlProvider: true,
    createContainer: true,
    Container: true,
    Grid: true,
    Stack: true
};
Object.defineProperty(module.exports, "Box", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Box.default;
    }
});
Object.defineProperty(module.exports, "Container", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Container.default;
    }
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "RtlProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_RtlProvider.default;
    }
});
Object.defineProperty(module.exports, "Stack", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $bOOlK.StyledEngineProvider;
    }
});
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "borders", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_borders.default;
    }
});
Object.defineProperty(module.exports, "breakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.default;
    }
});
Object.defineProperty(module.exports, "compose", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_compose.default;
    }
});
Object.defineProperty(module.exports, "createBox", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createBox.default;
    }
});
Object.defineProperty(module.exports, "createBreakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "createContainer", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createContainer.default;
    }
});
Object.defineProperty(module.exports, "createSpacing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createSpacing.default;
    }
});
Object.defineProperty(module.exports, "createStyled", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createStyled.default;
    }
});
Object.defineProperty(module.exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $bOOlK.css;
    }
});
Object.defineProperty(module.exports, "cssContainerQueries", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "display", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_display.default;
    }
});
module.exports.experimental_sx = $d862fd65d58a79bb$var$experimental_sx;
Object.defineProperty(module.exports, "flexbox", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_flexbox.default;
    }
});
Object.defineProperty(module.exports, "getPath", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.getPath;
    }
});
Object.defineProperty(module.exports, "getStyleValue", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.getStyleValue;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeProps.getThemeProps;
    }
});
Object.defineProperty(module.exports, "grid", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssGrid.default;
    }
});
Object.defineProperty(module.exports, "handleBreakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.handleBreakpoints;
    }
});
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $bOOlK.keyframes;
    }
});
Object.defineProperty(module.exports, "mergeBreakpointsInOrder", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.mergeBreakpointsInOrder;
    }
});
Object.defineProperty(module.exports, "palette", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_palette.default;
    }
});
Object.defineProperty(module.exports, "positions", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_positions.default;
    }
});
Object.defineProperty(module.exports, "responsivePropType", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_responsivePropType.default;
    }
});
Object.defineProperty(module.exports, "shadows", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_shadows.default;
    }
});
Object.defineProperty(module.exports, "shape", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_shape.default;
    }
});
Object.defineProperty(module.exports, "sizing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_sizing.default;
    }
});
Object.defineProperty(module.exports, "spacing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_spacing.default;
    }
});
Object.defineProperty(module.exports, "style", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.default;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "typography", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_typography.default;
    }
});
Object.defineProperty(module.exports, "unstable_createCssVarsProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_createGetCssVar", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createGetCssVar.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_cssVarsParser", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssVarsParser.default;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.unstable_defaultSxConfig;
    }
});
Object.defineProperty(module.exports, "unstable_extendSxProp", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.extendSxProp;
    }
});
Object.defineProperty(module.exports, "unstable_getThemeValue", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_getThemeValue.default;
    }
});
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_prepareCssVars", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "unstable_resolveBreakpointValues", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.resolveBreakpointValues;
    }
});
Object.defineProperty(module.exports, "unstable_styleFunctionSx", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useMediaQuery.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useTheme.default;
    }
});
Object.defineProperty(module.exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "useThemeWithoutDefault", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeWithoutDefault.default;
    }
});

var $d862fd65d58a79bb$var$_formatMuiErrorMessage = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("aXtNH")));

var $bOOlK = parcelRequire("bOOlK");

var $d862fd65d58a79bb$var$_GlobalStyles = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("fJztl")));

var $d862fd65d58a79bb$var$_borders = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("7G2Ky")));
Object.keys($d862fd65d58a79bb$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_borders[key];
        }
    });
});

var $d862fd65d58a79bb$var$_breakpoints = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9mzYC")));

var $d862fd65d58a79bb$var$_cssContainerQueries = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d862fd65d58a79bb$var$_compose = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $d862fd65d58a79bb$var$_display = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("9p2mw")));

var $d862fd65d58a79bb$var$_flexbox = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("fbcSN")));
Object.keys($d862fd65d58a79bb$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_flexbox[key];
        }
    });
});

var $d862fd65d58a79bb$var$_cssGrid = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("bvdLQ")));
Object.keys($d862fd65d58a79bb$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_cssGrid[key];
        }
    });
});

var $d862fd65d58a79bb$var$_palette = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("7Izgs")));
Object.keys($d862fd65d58a79bb$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_palette[key];
        }
    });
});

var $d862fd65d58a79bb$var$_positions = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9cp7R")));
Object.keys($d862fd65d58a79bb$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_positions[key];
        }
    });
});

var $d862fd65d58a79bb$var$_shadows = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("euxvJ")));

var $d862fd65d58a79bb$var$_sizing = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("lk86k")));
Object.keys($d862fd65d58a79bb$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_sizing[key];
        }
    });
});

var $d862fd65d58a79bb$var$_spacing = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("8ZgMs")));
Object.keys($d862fd65d58a79bb$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_spacing[key];
        }
    });
});

var $d862fd65d58a79bb$var$_style = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("fuavR")));

var $d862fd65d58a79bb$var$_typography = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("6a6uc")));
Object.keys($d862fd65d58a79bb$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_typography[key];
        }
    });
});

var $d862fd65d58a79bb$var$_styleFunctionSx = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $d862fd65d58a79bb$var$_getThemeValue = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("fykTt")));

var $d862fd65d58a79bb$var$_Box = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("8XfTG")));

var $d862fd65d58a79bb$var$_createBox = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("7SBe1")));

var $d862fd65d58a79bb$var$_createStyled = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("bbeCr")));
Object.keys($d862fd65d58a79bb$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_createStyled[key];
        }
    });
});

var $d862fd65d58a79bb$var$_styled = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("kpukb")));

var $d862fd65d58a79bb$var$_createTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $d862fd65d58a79bb$var$_createBreakpoints = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d862fd65d58a79bb$var$_createSpacing = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d862fd65d58a79bb$var$_shape = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d862fd65d58a79bb$var$_useThemeProps = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("2LgDM")));

var $d862fd65d58a79bb$var$_useTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("lywMB")));

var $d862fd65d58a79bb$var$_useThemeWithoutDefault = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("f18iq")));

var $d862fd65d58a79bb$var$_useMediaQuery = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("8h4LK")));

var $h61zw = parcelRequire("h61zw");
Object.keys($h61zw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $h61zw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h61zw[key];
        }
    });
});

var $d862fd65d58a79bb$var$_ThemeProvider = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $d862fd65d58a79bb$var$_memoTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5Ts1H")));

var $d862fd65d58a79bb$var$_createCssVarsProvider = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("3Vfwq")));

var $d862fd65d58a79bb$var$_createGetCssVar = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("hKuOr")));

var $d862fd65d58a79bb$var$_cssVarsParser = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("ejFX8")));

var $d862fd65d58a79bb$var$_prepareCssVars = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5magr")));

var $d862fd65d58a79bb$var$_createCssVarsTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("73CWR")));

var $d862fd65d58a79bb$var$_responsivePropType = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $d862fd65d58a79bb$var$_RtlProvider = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9uEev")));
Object.keys($d862fd65d58a79bb$var$_RtlProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_RtlProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_RtlProvider[key];
        }
    });
});

var $1RRq5 = parcelRequire("1RRq5");
Object.keys($1RRq5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1RRq5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1RRq5[key];
        }
    });
});

var $d862fd65d58a79bb$var$_createContainer = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("689Qv")));

var $d862fd65d58a79bb$var$_Container = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("jYQTJ")));
Object.keys($d862fd65d58a79bb$var$_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_Container[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_Container[key];
        }
    });
});

var $d862fd65d58a79bb$var$_Grid = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("dy2yf")));

var $gxueG = parcelRequire("gxueG");
Object.keys($gxueG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gxueG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gxueG[key];
        }
    });
});

var $d862fd65d58a79bb$var$_Stack = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("kgIUX")));

var $106Hq = parcelRequire("106Hq");
Object.keys($106Hq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $106Hq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $106Hq[key];
        }
    });
});
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
function $d862fd65d58a79bb$var$experimental_sx() {
    throw new Error((0, $d862fd65d58a79bb$var$_formatMuiErrorMessage.default)(19));
} /** ----------------- */  /** Layout components */ 

});
parcelRegister("3pEGv", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $27c3440315f0d929$var$_typeof = $41YNz.default;
function $27c3440315f0d929$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = $27c3440315f0d929$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $27c3440315f0d929$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = $27c3440315f0d929$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aXtNH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7fa687dedd4adde2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7fa687dedd4adde2$var$_formatMuiErrorMessage.default;
    }
});

var $7fa687dedd4adde2$var$_formatMuiErrorMessage = $7fa687dedd4adde2$require$_interopRequireDefault((parcelRequire("4BDLq")));

});
parcelRegister("4BDLq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35a9766312304055$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $35a9766312304055$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("bOOlK", function(module, exports) {
/**
 * @mui/styled-engine v7.3.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $89ab6b9e702438b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $89ab6b9e702438b4$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $89ab6b9e702438b4$var$_StyledEngineProvider.default;
    }
});
Object.defineProperty(module.exports, "ThemeContext", {
    enumerable: true,
    get: function() {
        return $eP9YU.T;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $jjlaj.css;
    }
});
module.exports.default = $89ab6b9e702438b4$var$styled;
module.exports.internal_mutateStyles = $89ab6b9e702438b4$var$internal_mutateStyles;
module.exports.internal_serializeStyles = $89ab6b9e702438b4$var$internal_serializeStyles;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $jjlaj.keyframes;
    }
});

var $89ab6b9e702438b4$var$_styled = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("5rflj")));

var $8rteH = parcelRequire("8rteH");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $89ab6b9e702438b4$var$_StyledEngineProvider = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("dDJuN")));

var $89ab6b9e702438b4$var$_GlobalStyles = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("gfxtG")));
function $89ab6b9e702438b4$var$styled(tag, options) {
    const stylesFactory = (0, $89ab6b9e702438b4$var$_styled.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $89ab6b9e702438b4$var$internal_mutateStyles(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $89ab6b9e702438b4$var$wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function $89ab6b9e702438b4$var$internal_serializeStyles(styles) {
    $89ab6b9e702438b4$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($89ab6b9e702438b4$var$wrapper);
}

});
parcelRegister("dDJuN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9ee2355c3bd069c6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9ee2355c3bd069c6$var$_StyledEngineProvider.default;
    }
});

var $9ee2355c3bd069c6$var$_StyledEngineProvider = $9ee2355c3bd069c6$require$_interopRequireDefault((parcelRequire("2BuCw")));

});
parcelRegister("2BuCw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1e56ca0825dc344f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1e56ca0825dc344f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TEST_INTERNALS_DO_NOT_USE = void 0;
module.exports.default = $1e56ca0825dc344f$var$StyledEngineProvider;

var $1e56ca0825dc344f$var$React = $1e56ca0825dc344f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1e56ca0825dc344f$var$_propTypes = $1e56ca0825dc344f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $eP9YU = parcelRequire("eP9YU");

var $1e56ca0825dc344f$var$_cache = $1e56ca0825dc344f$require$_interopRequireDefault((parcelRequire("a9M6v")));

var $jmRmf = parcelRequire("jmRmf");

var $ayMG0 = parcelRequire("ayMG0");
// To fix [Jest performance](https://github.com/mui/material-ui/issues/45638).
const $1e56ca0825dc344f$var$cacheMap = new Map();
// Need to add a private variable to test the generated CSS from Emotion, this is the simplest way to do it.
// We can't test the CSS from `style` tag easily because the `speedy: true` (produce empty text content) is enabled by Emotion.
// Even if we disable it, JSDOM needs extra configuration to be able to parse `@layer` CSS.
const $1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE = module.exports.TEST_INTERNALS_DO_NOT_USE = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $1e56ca0825dc344f$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $1e56ca0825dc344f$var$_cache.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $1e56ca0825dc344f$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $1e56ca0825dc344f$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$1e56ca0825dc344f$var$insertionPoint) {
        $1e56ca0825dc344f$var$insertionPoint = document.createElement('meta');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($1e56ca0825dc344f$var$insertionPoint);
    }
}
function $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends $jmRmf.StyleSheet {
            insert(rule, options) {
                if ($1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE.insert) return $1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $1e56ca0825dc344f$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $1e56ca0825dc344f$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $1e56ca0825dc344f$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $1e56ca0825dc344f$var$StyledEngineProvider(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $1e56ca0825dc344f$var$React.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $1e56ca0825dc344f$var$cacheMap.has(cacheKey)) return $1e56ca0825dc344f$var$cacheMap.get(cacheKey);
        const fresh = $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer);
        $1e56ca0825dc344f$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $ayMG0.jsx)($eP9YU.C, {
        value: cache,
        children: children
    }) : children;
}

});


parcelRegister("gfxtG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bd48040d38052821$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bd48040d38052821$var$_GlobalStyles.default;
    }
});

var $bd48040d38052821$var$_GlobalStyles = $bd48040d38052821$require$_interopRequireDefault((parcelRequire("bBbjn")));

});
parcelRegister("bBbjn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $871beca1e2477cf0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $871beca1e2477cf0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $871beca1e2477cf0$var$GlobalStyles;

var $871beca1e2477cf0$var$React = $871beca1e2477cf0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $871beca1e2477cf0$var$_propTypes = $871beca1e2477cf0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$var$GlobalStyles(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($jjlaj.Global, {
        styles: globalStyles
    });
}

});



parcelRegister("fJztl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b7469308f94dcda5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b7469308f94dcda5$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b7469308f94dcda5$var$_GlobalStyles.default;
    }
});

var $b7469308f94dcda5$var$_GlobalStyles = $b7469308f94dcda5$require$_interopRequireWildcard((parcelRequire("csO1Z")));
Object.keys($b7469308f94dcda5$var$_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b7469308f94dcda5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b7469308f94dcda5$var$_GlobalStyles[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b7469308f94dcda5$var$_GlobalStyles[key];
        }
    });
});

});
parcelRegister("csO1Z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $912ee8b2b484e556$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $912ee8b2b484e556$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $912ee8b2b484e556$var$React = $912ee8b2b484e556$require$_interopRequireWildcard((parcelRequire("acw62")));

var $912ee8b2b484e556$var$_propTypes = $912ee8b2b484e556$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bOOlK = parcelRequire("bOOlK");

var $912ee8b2b484e556$var$_useTheme = $912ee8b2b484e556$require$_interopRequireDefault((parcelRequire("lywMB")));

var $ayMG0 = parcelRequire("ayMG0");
function $912ee8b2b484e556$var$wrapGlobalLayer(styles) {
    const serialized = (0, $bOOlK.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $912ee8b2b484e556$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $912ee8b2b484e556$var$_useTheme.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $912ee8b2b484e556$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $912ee8b2b484e556$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $912ee8b2b484e556$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.GlobalStyles, {
        styles: globalStyles
    });
}
var $912ee8b2b484e556$var$_default = module.exports.default = $912ee8b2b484e556$var$GlobalStyles;

});
parcelRegister("lywMB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fb1633f194eccc90$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fb1633f194eccc90$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb1633f194eccc90$var$_useTheme.default;
    }
});

var $fb1633f194eccc90$var$_useTheme = $fb1633f194eccc90$require$_interopRequireWildcard((parcelRequire("cpDNV")));
Object.keys($fb1633f194eccc90$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fb1633f194eccc90$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fb1633f194eccc90$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fb1633f194eccc90$var$_useTheme[key];
        }
    });
});

});
parcelRegister("cpDNV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9096b21b03fc4ec3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $9096b21b03fc4ec3$var$_createTheme = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9096b21b03fc4ec3$var$_useThemeWithoutDefault = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("f18iq")));
const $9096b21b03fc4ec3$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $9096b21b03fc4ec3$var$_createTheme.default)();
function $9096b21b03fc4ec3$var$useTheme(defaultTheme = $9096b21b03fc4ec3$var$systemDefaultTheme) {
    return (0, $9096b21b03fc4ec3$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $9096b21b03fc4ec3$var$_default = module.exports.default = $9096b21b03fc4ec3$var$useTheme;

});
parcelRegister("1dhnG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0e247cd7faad5b27$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_applyStyles.default;
    }
});

var $0e247cd7faad5b27$var$_createTheme = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("i6Yz2")));

var $0e247cd7faad5b27$var$_createBreakpoints = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $0e247cd7faad5b27$var$_applyStyles = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("e1wfH")));

});
parcelRegister("i6Yz2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2f7c454ab1ec68c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2f7c454ab1ec68c$var$_deepmerge = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("kFNAX")));

var $d2f7c454ab1ec68c$var$_createBreakpoints = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d2f7c454ab1ec68c$var$_cssContainerQueries = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d2f7c454ab1ec68c$var$_shape = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d2f7c454ab1ec68c$var$_createSpacing = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d2f7c454ab1ec68c$var$_styleFunctionSx = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("jUGyl")));

var $d2f7c454ab1ec68c$var$_defaultSxConfig = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("epNpO")));

var $d2f7c454ab1ec68c$var$_applyStyles = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("e1wfH")));
function $d2f7c454ab1ec68c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $d2f7c454ab1ec68c$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $d2f7c454ab1ec68c$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $d2f7c454ab1ec68c$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$d2f7c454ab1ec68c$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $d2f7c454ab1ec68c$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $d2f7c454ab1ec68c$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $d2f7c454ab1ec68c$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$d2f7c454ab1ec68c$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $d2f7c454ab1ec68c$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $d2f7c454ab1ec68c$var$_default = module.exports.default = $d2f7c454ab1ec68c$var$createTheme;

});
parcelRegister("kFNAX", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f0ce1b8e495ac507$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f0ce1b8e495ac507$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f0ce1b8e495ac507$var$_deepmerge.default;
    }
});

var $f0ce1b8e495ac507$var$_deepmerge = $f0ce1b8e495ac507$require$_interopRequireWildcard((parcelRequire("i6hom")));
Object.keys($f0ce1b8e495ac507$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f0ce1b8e495ac507$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f0ce1b8e495ac507$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f0ce1b8e495ac507$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("i6hom", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d2d64734ea9849f2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2d64734ea9849f2$var$deepmerge;
module.exports.isPlainObject = $d2d64734ea9849f2$var$isPlainObject;

var $d2d64734ea9849f2$var$React = $d2d64734ea9849f2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e1xPQ = parcelRequire("e1xPQ");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $d2d64734ea9849f2$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $d2d64734ea9849f2$var$deepClone(source) {
    if (/*#__PURE__*/ $d2d64734ea9849f2$var$React.isValidElement(source) || (0, $e1xPQ.isValidElementType)(source) || !$d2d64734ea9849f2$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $d2d64734ea9849f2$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $d2d64734ea9849f2$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($d2d64734ea9849f2$var$isPlainObject(target) && $d2d64734ea9849f2$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $d2d64734ea9849f2$var$React.isValidElement(source[key]) || (0, $e1xPQ.isValidElementType)(source[key])) output[key] = source[key];
        else if ($d2d64734ea9849f2$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $d2d64734ea9849f2$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $d2d64734ea9849f2$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $d2d64734ea9849f2$var$isPlainObject(source[key]) ? $d2d64734ea9849f2$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("e1xPQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lDLn8"));

});
parcelRegister("lDLn8", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $fc11fc9bcfef8212$export$a7c73072b1a182ae, (v) => $fc11fc9bcfef8212$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $fc11fc9bcfef8212$export$9f27bc3417b4524d, (v) => $fc11fc9bcfef8212$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $fc11fc9bcfef8212$export$db77ccec0bb4ccac, (v) => $fc11fc9bcfef8212$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $fc11fc9bcfef8212$export$8392c0c9d3dcbd35, (v) => $fc11fc9bcfef8212$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $fc11fc9bcfef8212$export$ffb0004e005737fa, (v) => $fc11fc9bcfef8212$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $fc11fc9bcfef8212$export$b624eff549462981, (v) => $fc11fc9bcfef8212$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $fc11fc9bcfef8212$export$7897aa7841a5380c, (v) => $fc11fc9bcfef8212$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $fc11fc9bcfef8212$export$602eac185826482c, (v) => $fc11fc9bcfef8212$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $fc11fc9bcfef8212$export$e2c29f18771995cb, (v) => $fc11fc9bcfef8212$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $fc11fc9bcfef8212$export$5f8d39834fd61797, (v) => $fc11fc9bcfef8212$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $fc11fc9bcfef8212$export$74bf444e3cd11ea5, (v) => $fc11fc9bcfef8212$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $fc11fc9bcfef8212$export$998bcd577473dd93, (v) => $fc11fc9bcfef8212$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $fc11fc9bcfef8212$export$b706b080d889d2c9, (v) => $fc11fc9bcfef8212$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $fc11fc9bcfef8212$export$5be5a87408f70ddc, (v) => $fc11fc9bcfef8212$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $fc11fc9bcfef8212$export$45a5e7f76e0caa8d, (v) => $fc11fc9bcfef8212$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $fc11fc9bcfef8212$export$455c2e768291efa6, (v) => $fc11fc9bcfef8212$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $fc11fc9bcfef8212$export$9522e17588c12572, (v) => $fc11fc9bcfef8212$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $fc11fc9bcfef8212$export$2110ac352bb060b9, (v) => $fc11fc9bcfef8212$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $fc11fc9bcfef8212$export$56885ab8b9c456ab, (v) => $fc11fc9bcfef8212$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $fc11fc9bcfef8212$export$d927fcb6adf8f9de, (v) => $fc11fc9bcfef8212$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $fc11fc9bcfef8212$export$b82d16f27459e05a, (v) => $fc11fc9bcfef8212$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $fc11fc9bcfef8212$export$522c17b4f5e123e8, (v) => $fc11fc9bcfef8212$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $fc11fc9bcfef8212$export$1aabd8a0274ecfd6, (v) => $fc11fc9bcfef8212$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $fc11fc9bcfef8212$export$3d6c20d97e46b957, (v) => $fc11fc9bcfef8212$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $fc11fc9bcfef8212$export$9b621391a187a31a, (v) => $fc11fc9bcfef8212$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $fc11fc9bcfef8212$export$f5bbd400c2f4426f, (v) => $fc11fc9bcfef8212$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fc11fc9bcfef8212$export$a7c73072b1a182ae;
var $fc11fc9bcfef8212$export$9f27bc3417b4524d;
var $fc11fc9bcfef8212$export$db77ccec0bb4ccac;
var $fc11fc9bcfef8212$export$8392c0c9d3dcbd35;
var $fc11fc9bcfef8212$export$ffb0004e005737fa;
var $fc11fc9bcfef8212$export$b624eff549462981;
var $fc11fc9bcfef8212$export$7897aa7841a5380c;
var $fc11fc9bcfef8212$export$602eac185826482c;
var $fc11fc9bcfef8212$export$e2c29f18771995cb;
var $fc11fc9bcfef8212$export$5f8d39834fd61797;
var $fc11fc9bcfef8212$export$74bf444e3cd11ea5;
var $fc11fc9bcfef8212$export$998bcd577473dd93;
var $fc11fc9bcfef8212$export$b706b080d889d2c9;
var $fc11fc9bcfef8212$export$5be5a87408f70ddc;
var $fc11fc9bcfef8212$export$45a5e7f76e0caa8d;
var $fc11fc9bcfef8212$export$455c2e768291efa6;
var $fc11fc9bcfef8212$export$9522e17588c12572;
var $fc11fc9bcfef8212$export$2110ac352bb060b9;
var $fc11fc9bcfef8212$export$56885ab8b9c456ab;
var $fc11fc9bcfef8212$export$d927fcb6adf8f9de;
var $fc11fc9bcfef8212$export$b82d16f27459e05a;
var $fc11fc9bcfef8212$export$522c17b4f5e123e8;
var $fc11fc9bcfef8212$export$1aabd8a0274ecfd6;
var $fc11fc9bcfef8212$export$3d6c20d97e46b957;
var $fc11fc9bcfef8212$export$9b621391a187a31a;
var $fc11fc9bcfef8212$export$f5bbd400c2f4426f;
"use strict";
var $fc11fc9bcfef8212$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $fc11fc9bcfef8212$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $fc11fc9bcfef8212$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $fc11fc9bcfef8212$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $fc11fc9bcfef8212$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $fc11fc9bcfef8212$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $fc11fc9bcfef8212$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $fc11fc9bcfef8212$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $fc11fc9bcfef8212$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $fc11fc9bcfef8212$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $fc11fc9bcfef8212$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $fc11fc9bcfef8212$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $fc11fc9bcfef8212$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $fc11fc9bcfef8212$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $fc11fc9bcfef8212$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $fc11fc9bcfef8212$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $fc11fc9bcfef8212$var$REACT_FRAGMENT_TYPE:
                    case $fc11fc9bcfef8212$var$REACT_PROFILER_TYPE:
                    case $fc11fc9bcfef8212$var$REACT_STRICT_MODE_TYPE:
                    case $fc11fc9bcfef8212$var$REACT_SUSPENSE_TYPE:
                    case $fc11fc9bcfef8212$var$REACT_SUSPENSE_LIST_TYPE:
                    case $fc11fc9bcfef8212$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $fc11fc9bcfef8212$var$REACT_CONTEXT_TYPE:
                            case $fc11fc9bcfef8212$var$REACT_FORWARD_REF_TYPE:
                            case $fc11fc9bcfef8212$var$REACT_LAZY_TYPE:
                            case $fc11fc9bcfef8212$var$REACT_MEMO_TYPE:
                                return object;
                            case $fc11fc9bcfef8212$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $fc11fc9bcfef8212$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$fc11fc9bcfef8212$export$a7c73072b1a182ae = $fc11fc9bcfef8212$var$REACT_CONSUMER_TYPE;
$fc11fc9bcfef8212$export$9f27bc3417b4524d = $fc11fc9bcfef8212$var$REACT_CONTEXT_TYPE;
$fc11fc9bcfef8212$export$db77ccec0bb4ccac = $fc11fc9bcfef8212$var$REACT_ELEMENT_TYPE;
$fc11fc9bcfef8212$export$8392c0c9d3dcbd35 = $fc11fc9bcfef8212$var$REACT_FORWARD_REF_TYPE;
$fc11fc9bcfef8212$export$ffb0004e005737fa = $fc11fc9bcfef8212$var$REACT_FRAGMENT_TYPE;
$fc11fc9bcfef8212$export$b624eff549462981 = $fc11fc9bcfef8212$var$REACT_LAZY_TYPE;
$fc11fc9bcfef8212$export$7897aa7841a5380c = $fc11fc9bcfef8212$var$REACT_MEMO_TYPE;
$fc11fc9bcfef8212$export$602eac185826482c = $fc11fc9bcfef8212$var$REACT_PORTAL_TYPE;
$fc11fc9bcfef8212$export$e2c29f18771995cb = $fc11fc9bcfef8212$var$REACT_PROFILER_TYPE;
$fc11fc9bcfef8212$export$5f8d39834fd61797 = $fc11fc9bcfef8212$var$REACT_STRICT_MODE_TYPE;
$fc11fc9bcfef8212$export$74bf444e3cd11ea5 = $fc11fc9bcfef8212$var$REACT_SUSPENSE_TYPE;
$fc11fc9bcfef8212$export$998bcd577473dd93 = $fc11fc9bcfef8212$var$REACT_SUSPENSE_LIST_TYPE;
$fc11fc9bcfef8212$export$b706b080d889d2c9 = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_CONSUMER_TYPE;
};
$fc11fc9bcfef8212$export$5be5a87408f70ddc = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_CONTEXT_TYPE;
};
$fc11fc9bcfef8212$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $fc11fc9bcfef8212$var$REACT_ELEMENT_TYPE;
};
$fc11fc9bcfef8212$export$455c2e768291efa6 = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_FORWARD_REF_TYPE;
};
$fc11fc9bcfef8212$export$9522e17588c12572 = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_FRAGMENT_TYPE;
};
$fc11fc9bcfef8212$export$2110ac352bb060b9 = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_LAZY_TYPE;
};
$fc11fc9bcfef8212$export$56885ab8b9c456ab = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_MEMO_TYPE;
};
$fc11fc9bcfef8212$export$d927fcb6adf8f9de = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_PORTAL_TYPE;
};
$fc11fc9bcfef8212$export$b82d16f27459e05a = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_PROFILER_TYPE;
};
$fc11fc9bcfef8212$export$522c17b4f5e123e8 = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_STRICT_MODE_TYPE;
};
$fc11fc9bcfef8212$export$1aabd8a0274ecfd6 = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_SUSPENSE_TYPE;
};
$fc11fc9bcfef8212$export$3d6c20d97e46b957 = function(object) {
    return $fc11fc9bcfef8212$var$typeOf(object) === $fc11fc9bcfef8212$var$REACT_SUSPENSE_LIST_TYPE;
};
$fc11fc9bcfef8212$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $fc11fc9bcfef8212$var$REACT_FRAGMENT_TYPE || type === $fc11fc9bcfef8212$var$REACT_PROFILER_TYPE || type === $fc11fc9bcfef8212$var$REACT_STRICT_MODE_TYPE || type === $fc11fc9bcfef8212$var$REACT_SUSPENSE_TYPE || type === $fc11fc9bcfef8212$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $fc11fc9bcfef8212$var$REACT_LAZY_TYPE || type.$$typeof === $fc11fc9bcfef8212$var$REACT_MEMO_TYPE || type.$$typeof === $fc11fc9bcfef8212$var$REACT_CONTEXT_TYPE || type.$$typeof === $fc11fc9bcfef8212$var$REACT_CONSUMER_TYPE || type.$$typeof === $fc11fc9bcfef8212$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $fc11fc9bcfef8212$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$fc11fc9bcfef8212$export$f5bbd400c2f4426f = $fc11fc9bcfef8212$var$typeOf;

});




parcelRegister("hVW0x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $d0e4c1a921a97ae9$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $d0e4c1a921a97ae9$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $d0e4c1a921a97ae9$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $d0e4c1a921a97ae9$var$createBreakpoints(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $d0e4c1a921a97ae9$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("18kGB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0d3695a183c24848$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $0d3695a183c24848$var$_cssContainerQueries = $0d3695a183c24848$require$_interopRequireWildcard((parcelRequire("hkwSq")));

});
parcelRegister("hkwSq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c9ddce8fd7553cea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9ddce8fd7553cea$var$cssContainerQueries;
module.exports.getContainerQuery = $c9ddce8fd7553cea$var$getContainerQuery;
module.exports.isCqShorthand = $c9ddce8fd7553cea$var$isCqShorthand;
module.exports.sortContainerQueries = $c9ddce8fd7553cea$var$sortContainerQueries;

var $c9ddce8fd7553cea$var$_formatMuiErrorMessage = $c9ddce8fd7553cea$require$_interopRequireDefault((parcelRequire("aXtNH")));
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function $c9ddce8fd7553cea$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $c9ddce8fd7553cea$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $c9ddce8fd7553cea$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $c9ddce8fd7553cea$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("5H6wp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $425606f5c9c02d28$var$shape = {
    borderRadius: 4
};
var $425606f5c9c02d28$var$_default = module.exports.default = $425606f5c9c02d28$var$shape;

});

parcelRegister("5pAhk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f0b6db0539d6afd$var$createSpacing;

var $8ZgMs = parcelRequire("8ZgMs");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $3f0b6db0539d6afd$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $8ZgMs.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("8ZgMs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68b10981a323f192$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68b10981a323f192$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68b10981a323f192$var$_spacing.default;
    }
});

var $68b10981a323f192$var$_spacing = $68b10981a323f192$require$_interopRequireWildcard((parcelRequire("lJr29")));
Object.keys($68b10981a323f192$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68b10981a323f192$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68b10981a323f192$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68b10981a323f192$var$_spacing[key];
        }
    });
});

});
parcelRegister("lJr29", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd22c53f9de5e49d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $fd22c53f9de5e49d$var$createUnarySpacing;
module.exports.createUnaryUnit = $fd22c53f9de5e49d$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getStyleFromPropValue = $fd22c53f9de5e49d$var$getStyleFromPropValue;
module.exports.getValue = $fd22c53f9de5e49d$var$getValue;
module.exports.margin = $fd22c53f9de5e49d$var$margin;
module.exports.marginKeys = void 0;
module.exports.padding = $fd22c53f9de5e49d$var$padding;
module.exports.paddingKeys = void 0;

var $fd22c53f9de5e49d$var$_responsivePropType = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");

var $fuavR = parcelRequire("fuavR");

var $fd22c53f9de5e49d$var$_merge = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("3naDD")));

var $fd22c53f9de5e49d$var$_memoize = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("iaYJn")));
const $fd22c53f9de5e49d$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $fd22c53f9de5e49d$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $fd22c53f9de5e49d$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $fd22c53f9de5e49d$var$getCssProperties = (0, $fd22c53f9de5e49d$var$_memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($fd22c53f9de5e49d$var$aliases[prop]) prop = $fd22c53f9de5e49d$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $fd22c53f9de5e49d$var$properties[a];
    const direction = $fd22c53f9de5e49d$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $fd22c53f9de5e49d$var$marginKeys = module.exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $fd22c53f9de5e49d$var$paddingKeys = module.exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $fd22c53f9de5e49d$var$spacingKeys = [
    ...$fd22c53f9de5e49d$var$marginKeys,
    ...$fd22c53f9de5e49d$var$paddingKeys
];
function $fd22c53f9de5e49d$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $fuavR.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $fd22c53f9de5e49d$var$createUnarySpacing(theme) {
    return $fd22c53f9de5e49d$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $fd22c53f9de5e49d$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $fd22c53f9de5e49d$var$getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $fd22c53f9de5e49d$var$getValue(transformer, propValue);
            return acc;
        }, {});
}
function $fd22c53f9de5e49d$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $fd22c53f9de5e49d$var$getCssProperties(prop);
    const styleFromPropValue = $fd22c53f9de5e49d$var$getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $fd22c53f9de5e49d$var$style(props, keys) {
    const transformer = $fd22c53f9de5e49d$var$createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>$fd22c53f9de5e49d$var$resolveCssProperty(props, keys, prop, transformer)).reduce($fd22c53f9de5e49d$var$_merge.default, {});
}
function $fd22c53f9de5e49d$var$margin(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$marginKeys);
}
$fd22c53f9de5e49d$var$margin.propTypes = {};
$fd22c53f9de5e49d$var$margin.filterProps = $fd22c53f9de5e49d$var$marginKeys;
function $fd22c53f9de5e49d$var$padding(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$paddingKeys);
}
$fd22c53f9de5e49d$var$padding.propTypes = {};
$fd22c53f9de5e49d$var$padding.filterProps = $fd22c53f9de5e49d$var$paddingKeys;
function $fd22c53f9de5e49d$var$spacing(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$spacingKeys);
}
$fd22c53f9de5e49d$var$spacing.propTypes = {};
$fd22c53f9de5e49d$var$spacing.filterProps = $fd22c53f9de5e49d$var$spacingKeys;
var $fd22c53f9de5e49d$var$_default = module.exports.default = $fd22c53f9de5e49d$var$spacing;

});
parcelRegister("h7FAc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c773589584969aa7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c773589584969aa7$var$_responsivePropType.default;
    }
});

var $c773589584969aa7$var$_responsivePropType = $c773589584969aa7$require$_interopRequireDefault((parcelRequire("aLDOi")));

});
parcelRegister("aLDOi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7d6d2ca3605e13f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d6d2ca3605e13f8$var$_propTypes = $7d6d2ca3605e13f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $7d6d2ca3605e13f8$var$responsivePropType = {};
var $7d6d2ca3605e13f8$var$_default = module.exports.default = $7d6d2ca3605e13f8$var$responsivePropType;

});


parcelRegister("9mzYC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d12135a7affaa27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d12135a7affaa27$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d12135a7affaa27$var$_breakpoints.default;
    }
});

var $6d12135a7affaa27$var$_breakpoints = $6d12135a7affaa27$require$_interopRequireWildcard((parcelRequire("1D6M1")));
Object.keys($6d12135a7affaa27$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d12135a7affaa27$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d12135a7affaa27$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d12135a7affaa27$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("1D6M1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $12feb01311e15547$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeBreakpointsBase = $12feb01311e15547$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $12feb01311e15547$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $12feb01311e15547$var$handleBreakpoints;
module.exports.mergeBreakpointsInOrder = $12feb01311e15547$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $12feb01311e15547$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $12feb01311e15547$var$resolveBreakpointValues;
module.exports.values = void 0;

var $12feb01311e15547$var$_propTypes = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $12feb01311e15547$var$_deepmerge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("kFNAX")));

var $12feb01311e15547$var$_merge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("3naDD")));

var $18kGB = parcelRequire("18kGB");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const $12feb01311e15547$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $12feb01311e15547$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$12feb01311e15547$var$values[key]}px)`
};
const $12feb01311e15547$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $12feb01311e15547$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $12feb01311e15547$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $18kGB.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $18kGB.getContainerQuery)(theme.containerQueries ? theme : $12feb01311e15547$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $12feb01311e15547$var$values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $12feb01311e15547$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $12feb01311e15547$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $12feb01311e15547$var$createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $12feb01311e15547$var$removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $12feb01311e15547$var$mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = $12feb01311e15547$var$createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $12feb01311e15547$var$_deepmerge.default)(prev, next), {});
    return $12feb01311e15547$var$removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $12feb01311e15547$var$resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $12feb01311e15547$var$_default = module.exports.default = $12feb01311e15547$var$breakpoints;

});
parcelRegister("3naDD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $274bc59c460c5c83$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $274bc59c460c5c83$var$_merge.default;
    }
});

var $274bc59c460c5c83$var$_merge = $274bc59c460c5c83$require$_interopRequireDefault((parcelRequire("jb2Pw")));

});
parcelRegister("jb2Pw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $df613d60ccca226b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df613d60ccca226b$var$_deepmerge = $df613d60ccca226b$require$_interopRequireDefault((parcelRequire("kFNAX")));
function $df613d60ccca226b$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $df613d60ccca226b$var$_deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $df613d60ccca226b$var$_default = module.exports.default = $df613d60ccca226b$var$merge;

});




parcelRegister("fuavR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b461d00304dae97f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b461d00304dae97f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b461d00304dae97f$var$_style.default;
    }
});

var $b461d00304dae97f$var$_style = $b461d00304dae97f$require$_interopRequireWildcard((parcelRequire("5Wz76")));
Object.keys($b461d00304dae97f$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b461d00304dae97f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b461d00304dae97f$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b461d00304dae97f$var$_style[key];
        }
    });
});

});
parcelRegister("5Wz76", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $453d9b5a5bc206c2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPath = $453d9b5a5bc206c2$var$getPath;
module.exports.getStyleValue = $453d9b5a5bc206c2$var$getStyleValue;

var $453d9b5a5bc206c2$var$_capitalize = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("hZn6N")));

var $453d9b5a5bc206c2$var$_responsivePropType = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");
function $453d9b5a5bc206c2$var$getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $453d9b5a5bc206c2$var$getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $453d9b5a5bc206c2$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $453d9b5a5bc206c2$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $453d9b5a5bc206c2$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $453d9b5a5bc206c2$var$_default = module.exports.default = $453d9b5a5bc206c2$var$style;

});
parcelRegister("hZn6N", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d18a0f131854a96a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d18a0f131854a96a$var$_capitalize.default;
    }
});

var $d18a0f131854a96a$var$_capitalize = $d18a0f131854a96a$require$_interopRequireDefault((parcelRequire("1ofQR")));

});
parcelRegister("1ofQR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $10345427e65857eb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $10345427e65857eb$var$capitalize;

var $10345427e65857eb$var$_formatMuiErrorMessage = $10345427e65857eb$require$_interopRequireDefault((parcelRequire("aXtNH")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $10345427e65857eb$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $10345427e65857eb$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRegister("iaYJn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d3b8450df3f074ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d3b8450df3f074ab$var$_memoize.default;
    }
});

var $d3b8450df3f074ab$var$_memoize = $d3b8450df3f074ab$require$_interopRequireDefault((parcelRequire("9Z7Cd")));

});
parcelRegister("9Z7Cd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $744fb7d21d4e0357$var$memoize;
function $744fb7d21d4e0357$var$memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});





parcelRegister("jUGyl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7f4416c1e9a283b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx;

var $e7f4416c1e9a283b$var$_capitalize = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("hZn6N")));

var $e7f4416c1e9a283b$var$_merge = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("3naDD")));

var $fuavR = parcelRequire("fuavR");

var $9mzYC = parcelRequire("9mzYC");

var $18kGB = parcelRequire("18kGB");

var $e7f4416c1e9a283b$var$_defaultSxConfig = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("epNpO")));
function $e7f4416c1e9a283b$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e7f4416c1e9a283b$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $fuavR.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $fuavR.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $fuavR.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $e7f4416c1e9a283b$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? $e7f4416c1e9a283b$var$_defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $9mzYC.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e7f4416c1e9a283b$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $9mzYC.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e7f4416c1e9a283b$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e7f4416c1e9a283b$var$styleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx();
$e7f4416c1e9a283b$var$styleFunctionSx.filterProps = [
    'sx'
];
var $e7f4416c1e9a283b$var$_default = module.exports.default = $e7f4416c1e9a283b$var$styleFunctionSx;

});
parcelRegister("epNpO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ZgMs = parcelRequire("8ZgMs");

var $7G2Ky = parcelRequire("7G2Ky");

var $bvdLQ = parcelRequire("bvdLQ");

var $7Izgs = parcelRequire("7Izgs");

var $lk86k = parcelRequire("lk86k");
const $a7e9bb596240d630$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $7G2Ky.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $7Izgs.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    // spacing
    p: {
        style: $8ZgMs.padding
    },
    pt: {
        style: $8ZgMs.padding
    },
    pr: {
        style: $8ZgMs.padding
    },
    pb: {
        style: $8ZgMs.padding
    },
    pl: {
        style: $8ZgMs.padding
    },
    px: {
        style: $8ZgMs.padding
    },
    py: {
        style: $8ZgMs.padding
    },
    padding: {
        style: $8ZgMs.padding
    },
    paddingTop: {
        style: $8ZgMs.padding
    },
    paddingRight: {
        style: $8ZgMs.padding
    },
    paddingBottom: {
        style: $8ZgMs.padding
    },
    paddingLeft: {
        style: $8ZgMs.padding
    },
    paddingX: {
        style: $8ZgMs.padding
    },
    paddingY: {
        style: $8ZgMs.padding
    },
    paddingInline: {
        style: $8ZgMs.padding
    },
    paddingInlineStart: {
        style: $8ZgMs.padding
    },
    paddingInlineEnd: {
        style: $8ZgMs.padding
    },
    paddingBlock: {
        style: $8ZgMs.padding
    },
    paddingBlockStart: {
        style: $8ZgMs.padding
    },
    paddingBlockEnd: {
        style: $8ZgMs.padding
    },
    m: {
        style: $8ZgMs.margin
    },
    mt: {
        style: $8ZgMs.margin
    },
    mr: {
        style: $8ZgMs.margin
    },
    mb: {
        style: $8ZgMs.margin
    },
    ml: {
        style: $8ZgMs.margin
    },
    mx: {
        style: $8ZgMs.margin
    },
    my: {
        style: $8ZgMs.margin
    },
    margin: {
        style: $8ZgMs.margin
    },
    marginTop: {
        style: $8ZgMs.margin
    },
    marginRight: {
        style: $8ZgMs.margin
    },
    marginBottom: {
        style: $8ZgMs.margin
    },
    marginLeft: {
        style: $8ZgMs.margin
    },
    marginX: {
        style: $8ZgMs.margin
    },
    marginY: {
        style: $8ZgMs.margin
    },
    marginInline: {
        style: $8ZgMs.margin
    },
    marginInlineStart: {
        style: $8ZgMs.margin
    },
    marginInlineEnd: {
        style: $8ZgMs.margin
    },
    marginBlock: {
        style: $8ZgMs.margin
    },
    marginBlockStart: {
        style: $8ZgMs.margin
    },
    marginBlockEnd: {
        style: $8ZgMs.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $bvdLQ.gap
    },
    rowGap: {
        style: $bvdLQ.rowGap
    },
    columnGap: {
        style: $bvdLQ.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $lk86k.sizingTransform
    },
    maxWidth: {
        style: $lk86k.maxWidth
    },
    minWidth: {
        transform: $lk86k.sizingTransform
    },
    height: {
        transform: $lk86k.sizingTransform
    },
    maxHeight: {
        transform: $lk86k.sizingTransform
    },
    minHeight: {
        transform: $lk86k.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $a7e9bb596240d630$var$_default = module.exports.default = $a7e9bb596240d630$var$defaultSxConfig;

});
parcelRegister("7G2Ky", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $596e96b5ea46c9bd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $596e96b5ea46c9bd$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $596e96b5ea46c9bd$var$_borders.default;
    }
});

var $596e96b5ea46c9bd$var$_borders = $596e96b5ea46c9bd$require$_interopRequireWildcard((parcelRequire("ey2Y4")));
Object.keys($596e96b5ea46c9bd$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($596e96b5ea46c9bd$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $596e96b5ea46c9bd$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $596e96b5ea46c9bd$var$_borders[key];
        }
    });
});

});
parcelRegister("ey2Y4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a9768b07cfcbed12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $a9768b07cfcbed12$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $a9768b07cfcbed12$var$_responsivePropType = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $a9768b07cfcbed12$var$_style = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a9768b07cfcbed12$var$_compose = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");
function $a9768b07cfcbed12$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $a9768b07cfcbed12$var$createBorderStyle(prop, transform) {
    return (0, $a9768b07cfcbed12$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $a9768b07cfcbed12$var$border = module.exports.border = $a9768b07cfcbed12$var$createBorderStyle('border', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderTop = module.exports.borderTop = $a9768b07cfcbed12$var$createBorderStyle('borderTop', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderRight = module.exports.borderRight = $a9768b07cfcbed12$var$createBorderStyle('borderRight', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderBottom = module.exports.borderBottom = $a9768b07cfcbed12$var$createBorderStyle('borderBottom', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderLeft = module.exports.borderLeft = $a9768b07cfcbed12$var$createBorderStyle('borderLeft', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderColor = module.exports.borderColor = $a9768b07cfcbed12$var$createBorderStyle('borderColor');
const $a9768b07cfcbed12$var$borderTopColor = module.exports.borderTopColor = $a9768b07cfcbed12$var$createBorderStyle('borderTopColor');
const $a9768b07cfcbed12$var$borderRightColor = module.exports.borderRightColor = $a9768b07cfcbed12$var$createBorderStyle('borderRightColor');
const $a9768b07cfcbed12$var$borderBottomColor = module.exports.borderBottomColor = $a9768b07cfcbed12$var$createBorderStyle('borderBottomColor');
const $a9768b07cfcbed12$var$borderLeftColor = module.exports.borderLeftColor = $a9768b07cfcbed12$var$createBorderStyle('borderLeftColor');
const $a9768b07cfcbed12$var$outline = module.exports.outline = $a9768b07cfcbed12$var$createBorderStyle('outline', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$outlineColor = module.exports.outlineColor = $a9768b07cfcbed12$var$createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const $a9768b07cfcbed12$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $a9768b07cfcbed12$var$borderRadius;
$a9768b07cfcbed12$var$borderRadius.propTypes = {};
$a9768b07cfcbed12$var$borderRadius.filterProps = [
    'borderRadius'
];
const $a9768b07cfcbed12$var$borders = (0, $a9768b07cfcbed12$var$_compose.default)($a9768b07cfcbed12$var$border, $a9768b07cfcbed12$var$borderTop, $a9768b07cfcbed12$var$borderRight, $a9768b07cfcbed12$var$borderBottom, $a9768b07cfcbed12$var$borderLeft, $a9768b07cfcbed12$var$borderColor, $a9768b07cfcbed12$var$borderTopColor, $a9768b07cfcbed12$var$borderRightColor, $a9768b07cfcbed12$var$borderBottomColor, $a9768b07cfcbed12$var$borderLeftColor, $a9768b07cfcbed12$var$borderRadius, $a9768b07cfcbed12$var$outline, $a9768b07cfcbed12$var$outlineColor);
var $a9768b07cfcbed12$var$_default = module.exports.default = $a9768b07cfcbed12$var$borders;

});
parcelRegister("79Mi4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $535ed5230f7674fe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $535ed5230f7674fe$var$_compose.default;
    }
});

var $535ed5230f7674fe$var$_compose = $535ed5230f7674fe$require$_interopRequireDefault((parcelRequire("8J1Q9")));

});
parcelRegister("8J1Q9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65a3f4214179460a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65a3f4214179460a$var$_merge = $65a3f4214179460a$require$_interopRequireDefault((parcelRequire("3naDD")));
function $65a3f4214179460a$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $65a3f4214179460a$var$_merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $65a3f4214179460a$var$_default = module.exports.default = $65a3f4214179460a$var$compose;

});




parcelRegister("bvdLQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85fd458c5ff1d64f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85fd458c5ff1d64f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85fd458c5ff1d64f$var$_cssGrid.default;
    }
});

var $85fd458c5ff1d64f$var$_cssGrid = $85fd458c5ff1d64f$require$_interopRequireWildcard((parcelRequire("guYP5")));
Object.keys($85fd458c5ff1d64f$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($85fd458c5ff1d64f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $85fd458c5ff1d64f$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $85fd458c5ff1d64f$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("guYP5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c02ea0e0a59e3ff1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $c02ea0e0a59e3ff1$var$_style = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $c02ea0e0a59e3ff1$var$_compose = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");

var $c02ea0e0a59e3ff1$var$_responsivePropType = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("h7FAc")));
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $c02ea0e0a59e3ff1$var$gap;
$c02ea0e0a59e3ff1$var$gap.propTypes = {};
$c02ea0e0a59e3ff1$var$gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $c02ea0e0a59e3ff1$var$columnGap;
$c02ea0e0a59e3ff1$var$columnGap.propTypes = {};
$c02ea0e0a59e3ff1$var$columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $c02ea0e0a59e3ff1$var$rowGap;
$c02ea0e0a59e3ff1$var$rowGap.propTypes = {};
$c02ea0e0a59e3ff1$var$rowGap.filterProps = [
    'rowGap'
];
const $c02ea0e0a59e3ff1$var$gridColumn = module.exports.gridColumn = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridColumn'
});
const $c02ea0e0a59e3ff1$var$gridRow = module.exports.gridRow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridRow'
});
const $c02ea0e0a59e3ff1$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $c02ea0e0a59e3ff1$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $c02ea0e0a59e3ff1$var$gridAutoRows = module.exports.gridAutoRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $c02ea0e0a59e3ff1$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $c02ea0e0a59e3ff1$var$gridArea = module.exports.gridArea = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridArea'
});
const $c02ea0e0a59e3ff1$var$grid = (0, $c02ea0e0a59e3ff1$var$_compose.default)($c02ea0e0a59e3ff1$var$gap, $c02ea0e0a59e3ff1$var$columnGap, $c02ea0e0a59e3ff1$var$rowGap, $c02ea0e0a59e3ff1$var$gridColumn, $c02ea0e0a59e3ff1$var$gridRow, $c02ea0e0a59e3ff1$var$gridAutoFlow, $c02ea0e0a59e3ff1$var$gridAutoColumns, $c02ea0e0a59e3ff1$var$gridAutoRows, $c02ea0e0a59e3ff1$var$gridTemplateColumns, $c02ea0e0a59e3ff1$var$gridTemplateRows, $c02ea0e0a59e3ff1$var$gridTemplateAreas, $c02ea0e0a59e3ff1$var$gridArea);
var $c02ea0e0a59e3ff1$var$_default = module.exports.default = $c02ea0e0a59e3ff1$var$grid;

});


parcelRegister("7Izgs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59e7ff3bb6005a45$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $59e7ff3bb6005a45$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $59e7ff3bb6005a45$var$_palette.default;
    }
});

var $59e7ff3bb6005a45$var$_palette = $59e7ff3bb6005a45$require$_interopRequireWildcard((parcelRequire("hQFW7")));
Object.keys($59e7ff3bb6005a45$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($59e7ff3bb6005a45$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $59e7ff3bb6005a45$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $59e7ff3bb6005a45$var$_palette[key];
        }
    });
});

});
parcelRegister("hQFW7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cfe7d2b3f50e7c96$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $cfe7d2b3f50e7c96$var$paletteTransform;

var $cfe7d2b3f50e7c96$var$_style = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("fuavR")));

var $cfe7d2b3f50e7c96$var$_compose = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("79Mi4")));
function $cfe7d2b3f50e7c96$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $cfe7d2b3f50e7c96$var$color = module.exports.color = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$bgcolor = module.exports.bgcolor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$backgroundColor = module.exports.backgroundColor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$palette = (0, $cfe7d2b3f50e7c96$var$_compose.default)($cfe7d2b3f50e7c96$var$color, $cfe7d2b3f50e7c96$var$bgcolor, $cfe7d2b3f50e7c96$var$backgroundColor);
var $cfe7d2b3f50e7c96$var$_default = module.exports.default = $cfe7d2b3f50e7c96$var$palette;

});


parcelRegister("lk86k", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f861bfedd540c484$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f861bfedd540c484$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f861bfedd540c484$var$_sizing.default;
    }
});

var $f861bfedd540c484$var$_sizing = $f861bfedd540c484$require$_interopRequireWildcard((parcelRequire("8hW4G")));
Object.keys($f861bfedd540c484$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f861bfedd540c484$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f861bfedd540c484$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f861bfedd540c484$var$_sizing[key];
        }
    });
});

});
parcelRegister("8hW4G", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $608cf5a5bac56020$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $608cf5a5bac56020$var$sizingTransform;
module.exports.width = void 0;

var $608cf5a5bac56020$var$_style = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("fuavR")));

var $608cf5a5bac56020$var$_compose = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $9mzYC = parcelRequire("9mzYC");
function $608cf5a5bac56020$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $608cf5a5bac56020$var$width = module.exports.width = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $9mzYC.values[propValue];
            if (!breakpoint) return {
                maxWidth: $608cf5a5bac56020$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $608cf5a5bac56020$var$maxWidth;
$608cf5a5bac56020$var$maxWidth.filterProps = [
    'maxWidth'
];
const $608cf5a5bac56020$var$minWidth = module.exports.minWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minWidth',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$height = module.exports.height = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxHeight = module.exports.maxHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'maxHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$minHeight = module.exports.minHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeWidth = module.exports.sizeWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeHeight = module.exports.sizeHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$boxSizing = module.exports.boxSizing = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'boxSizing'
});
const $608cf5a5bac56020$var$sizing = (0, $608cf5a5bac56020$var$_compose.default)($608cf5a5bac56020$var$width, $608cf5a5bac56020$var$maxWidth, $608cf5a5bac56020$var$minWidth, $608cf5a5bac56020$var$height, $608cf5a5bac56020$var$maxHeight, $608cf5a5bac56020$var$minHeight, $608cf5a5bac56020$var$boxSizing);
var $608cf5a5bac56020$var$_default = module.exports.default = $608cf5a5bac56020$var$sizing;

});




parcelRegister("e1wfH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a35a2d48af09cdf6$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $a35a2d48af09cdf6$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("f18iq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $aeed627b69a58b85$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $aeed627b69a58b85$var$_useThemeWithoutDefault.default;
    }
});

var $aeed627b69a58b85$var$_useThemeWithoutDefault = $aeed627b69a58b85$require$_interopRequireDefault((parcelRequire("7zQRf")));

});
parcelRegister("7zQRf", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5844cdc266ab80c7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5844cdc266ab80c7$var$React = $5844cdc266ab80c7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bOOlK = parcelRequire("bOOlK");
function $5844cdc266ab80c7$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5844cdc266ab80c7$var$useTheme(defaultTheme = null) {
    const contextTheme = $5844cdc266ab80c7$var$React.useContext($bOOlK.ThemeContext);
    return !contextTheme || $5844cdc266ab80c7$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5844cdc266ab80c7$var$_default = module.exports.default = $5844cdc266ab80c7$var$useTheme;

});






parcelRegister("9p2mw", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d8847f8b6214b1a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d8847f8b6214b1a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d8847f8b6214b1a$var$_display.default;
    }
});

var $6d8847f8b6214b1a$var$_display = $6d8847f8b6214b1a$require$_interopRequireWildcard((parcelRequire("71hhb")));
Object.keys($6d8847f8b6214b1a$var$_display).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d8847f8b6214b1a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d8847f8b6214b1a$var$_display[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d8847f8b6214b1a$var$_display[key];
        }
    });
});

});
parcelRegister("71hhb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $51c60716a78df046$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.whiteSpace = module.exports.visibility = module.exports.textOverflow = module.exports.overflow = module.exports.displayRaw = module.exports.displayPrint = module.exports.default = void 0;

var $51c60716a78df046$var$_style = $51c60716a78df046$require$_interopRequireDefault((parcelRequire("fuavR")));

var $51c60716a78df046$var$_compose = $51c60716a78df046$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $51c60716a78df046$var$displayPrint = module.exports.displayPrint = (0, $51c60716a78df046$var$_style.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: (value)=>({
            '@media print': {
                display: value
            }
        })
});
const $51c60716a78df046$var$displayRaw = module.exports.displayRaw = (0, $51c60716a78df046$var$_style.default)({
    prop: 'display'
});
const $51c60716a78df046$var$overflow = module.exports.overflow = (0, $51c60716a78df046$var$_style.default)({
    prop: 'overflow'
});
const $51c60716a78df046$var$textOverflow = module.exports.textOverflow = (0, $51c60716a78df046$var$_style.default)({
    prop: 'textOverflow'
});
const $51c60716a78df046$var$visibility = module.exports.visibility = (0, $51c60716a78df046$var$_style.default)({
    prop: 'visibility'
});
const $51c60716a78df046$var$whiteSpace = module.exports.whiteSpace = (0, $51c60716a78df046$var$_style.default)({
    prop: 'whiteSpace'
});
var $51c60716a78df046$var$_default = module.exports.default = (0, $51c60716a78df046$var$_compose.default)($51c60716a78df046$var$displayPrint, $51c60716a78df046$var$displayRaw, $51c60716a78df046$var$overflow, $51c60716a78df046$var$textOverflow, $51c60716a78df046$var$visibility, $51c60716a78df046$var$whiteSpace);

});


parcelRegister("fbcSN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b0d1e058eea97628$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b0d1e058eea97628$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b0d1e058eea97628$var$_flexbox.default;
    }
});

var $b0d1e058eea97628$var$_flexbox = $b0d1e058eea97628$require$_interopRequireWildcard((parcelRequire("44hET")));
Object.keys($b0d1e058eea97628$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b0d1e058eea97628$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b0d1e058eea97628$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b0d1e058eea97628$var$_flexbox[key];
        }
    });
});

});
parcelRegister("44hET", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2f653bbfbf134bed$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.order = module.exports.justifySelf = module.exports.justifyItems = module.exports.justifyContent = module.exports.flexWrap = module.exports.flexShrink = module.exports.flexGrow = module.exports.flexDirection = module.exports.flexBasis = module.exports.flex = module.exports.default = module.exports.alignSelf = module.exports.alignItems = module.exports.alignContent = void 0;

var $2f653bbfbf134bed$var$_style = $2f653bbfbf134bed$require$_interopRequireDefault((parcelRequire("fuavR")));

var $2f653bbfbf134bed$var$_compose = $2f653bbfbf134bed$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $2f653bbfbf134bed$var$flexBasis = module.exports.flexBasis = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexBasis'
});
const $2f653bbfbf134bed$var$flexDirection = module.exports.flexDirection = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexDirection'
});
const $2f653bbfbf134bed$var$flexWrap = module.exports.flexWrap = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexWrap'
});
const $2f653bbfbf134bed$var$justifyContent = module.exports.justifyContent = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifyContent'
});
const $2f653bbfbf134bed$var$alignItems = module.exports.alignItems = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignItems'
});
const $2f653bbfbf134bed$var$alignContent = module.exports.alignContent = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignContent'
});
const $2f653bbfbf134bed$var$order = module.exports.order = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'order'
});
const $2f653bbfbf134bed$var$flex = module.exports.flex = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flex'
});
const $2f653bbfbf134bed$var$flexGrow = module.exports.flexGrow = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexGrow'
});
const $2f653bbfbf134bed$var$flexShrink = module.exports.flexShrink = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexShrink'
});
const $2f653bbfbf134bed$var$alignSelf = module.exports.alignSelf = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignSelf'
});
const $2f653bbfbf134bed$var$justifyItems = module.exports.justifyItems = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifyItems'
});
const $2f653bbfbf134bed$var$justifySelf = module.exports.justifySelf = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifySelf'
});
const $2f653bbfbf134bed$var$flexbox = (0, $2f653bbfbf134bed$var$_compose.default)($2f653bbfbf134bed$var$flexBasis, $2f653bbfbf134bed$var$flexDirection, $2f653bbfbf134bed$var$flexWrap, $2f653bbfbf134bed$var$justifyContent, $2f653bbfbf134bed$var$alignItems, $2f653bbfbf134bed$var$alignContent, $2f653bbfbf134bed$var$order, $2f653bbfbf134bed$var$flex, $2f653bbfbf134bed$var$flexGrow, $2f653bbfbf134bed$var$flexShrink, $2f653bbfbf134bed$var$alignSelf, $2f653bbfbf134bed$var$justifyItems, $2f653bbfbf134bed$var$justifySelf);
var $2f653bbfbf134bed$var$_default = module.exports.default = $2f653bbfbf134bed$var$flexbox;

});


parcelRegister("9cp7R", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6b28b985c7e8e846$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6b28b985c7e8e846$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6b28b985c7e8e846$var$_positions.default;
    }
});

var $6b28b985c7e8e846$var$_positions = $6b28b985c7e8e846$require$_interopRequireWildcard((parcelRequire("ijOcq")));
Object.keys($6b28b985c7e8e846$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6b28b985c7e8e846$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6b28b985c7e8e846$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6b28b985c7e8e846$var$_positions[key];
        }
    });
});

});
parcelRegister("ijOcq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d560f0ea711888c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zIndex = module.exports.top = module.exports.right = module.exports.position = module.exports.left = module.exports.default = module.exports.bottom = void 0;

var $d560f0ea711888c1$var$_style = $d560f0ea711888c1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $d560f0ea711888c1$var$_compose = $d560f0ea711888c1$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $d560f0ea711888c1$var$position = module.exports.position = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'position'
});
const $d560f0ea711888c1$var$zIndex = module.exports.zIndex = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
const $d560f0ea711888c1$var$top = module.exports.top = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'top'
});
const $d560f0ea711888c1$var$right = module.exports.right = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'right'
});
const $d560f0ea711888c1$var$bottom = module.exports.bottom = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'bottom'
});
const $d560f0ea711888c1$var$left = module.exports.left = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'left'
});
var $d560f0ea711888c1$var$_default = module.exports.default = (0, $d560f0ea711888c1$var$_compose.default)($d560f0ea711888c1$var$position, $d560f0ea711888c1$var$zIndex, $d560f0ea711888c1$var$top, $d560f0ea711888c1$var$right, $d560f0ea711888c1$var$bottom, $d560f0ea711888c1$var$left);

});


parcelRegister("euxvJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8cddc970265def5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a8cddc970265def5$var$_shadows.default;
    }
});

var $a8cddc970265def5$var$_shadows = $a8cddc970265def5$require$_interopRequireDefault((parcelRequire("do9dk")));

});
parcelRegister("do9dk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9bf4a9f1ed138aac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bf4a9f1ed138aac$var$_style = $9bf4a9f1ed138aac$require$_interopRequireDefault((parcelRequire("fuavR")));
const $9bf4a9f1ed138aac$var$boxShadow = (0, $9bf4a9f1ed138aac$var$_style.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $9bf4a9f1ed138aac$var$_default = module.exports.default = $9bf4a9f1ed138aac$var$boxShadow;

});


parcelRegister("6a6uc", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $47c8b53a4e972b5f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $47c8b53a4e972b5f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $47c8b53a4e972b5f$var$_typography.default;
    }
});

var $47c8b53a4e972b5f$var$_typography = $47c8b53a4e972b5f$require$_interopRequireWildcard((parcelRequire("e7BDK")));
Object.keys($47c8b53a4e972b5f$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($47c8b53a4e972b5f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $47c8b53a4e972b5f$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $47c8b53a4e972b5f$var$_typography[key];
        }
    });
});

});
parcelRegister("e7BDK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a47eeaab0be0bf30$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typographyVariant = module.exports.textTransform = module.exports.textAlign = module.exports.lineHeight = module.exports.letterSpacing = module.exports.fontWeight = module.exports.fontStyle = module.exports.fontSize = module.exports.fontFamily = module.exports.default = void 0;

var $a47eeaab0be0bf30$var$_style = $a47eeaab0be0bf30$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a47eeaab0be0bf30$var$_compose = $a47eeaab0be0bf30$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $a47eeaab0be0bf30$var$fontFamily = module.exports.fontFamily = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontSize = module.exports.fontSize = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontStyle = module.exports.fontStyle = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontWeight = module.exports.fontWeight = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$letterSpacing = module.exports.letterSpacing = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'letterSpacing'
});
const $a47eeaab0be0bf30$var$textTransform = module.exports.textTransform = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'textTransform'
});
const $a47eeaab0be0bf30$var$lineHeight = module.exports.lineHeight = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'lineHeight'
});
const $a47eeaab0be0bf30$var$textAlign = module.exports.textAlign = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'textAlign'
});
const $a47eeaab0be0bf30$var$typographyVariant = module.exports.typographyVariant = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$typography = (0, $a47eeaab0be0bf30$var$_compose.default)($a47eeaab0be0bf30$var$typographyVariant, $a47eeaab0be0bf30$var$fontFamily, $a47eeaab0be0bf30$var$fontSize, $a47eeaab0be0bf30$var$fontStyle, $a47eeaab0be0bf30$var$fontWeight, $a47eeaab0be0bf30$var$letterSpacing, $a47eeaab0be0bf30$var$lineHeight, $a47eeaab0be0bf30$var$textAlign, $a47eeaab0be0bf30$var$textTransform);
var $a47eeaab0be0bf30$var$_default = module.exports.default = $a47eeaab0be0bf30$var$typography;

});


parcelRegister("l6FST", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f5daa5e44059b221$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5daa5e44059b221$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_defaultSxConfig.default;
    }
});

var $f5daa5e44059b221$var$_styleFunctionSx = $f5daa5e44059b221$require$_interopRequireWildcard((parcelRequire("jUGyl")));

var $f5daa5e44059b221$var$_extendSxProp = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("i3YEE")));

var $f5daa5e44059b221$var$_defaultSxConfig = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("epNpO")));

});
parcelRegister("i3YEE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2678e896d0416ce$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2678e896d0416ce$var$extendSxProp;

var $kFNAX = parcelRequire("kFNAX");

var $d2678e896d0416ce$var$_defaultSxConfig = $d2678e896d0416ce$require$_interopRequireDefault((parcelRequire("epNpO")));
const $d2678e896d0416ce$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $d2678e896d0416ce$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $d2678e896d0416ce$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $d2678e896d0416ce$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $kFNAX.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("fykTt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b52a3d10487329b6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b52a3d10487329b6$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b52a3d10487329b6$var$_getThemeValue.default;
    }
});

var $b52a3d10487329b6$var$_getThemeValue = $b52a3d10487329b6$require$_interopRequireWildcard((parcelRequire("bbSQf")));
Object.keys($b52a3d10487329b6$var$_getThemeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b52a3d10487329b6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b52a3d10487329b6$var$_getThemeValue[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b52a3d10487329b6$var$_getThemeValue[key];
        }
    });
});

});
parcelRegister("bbSQf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $825b4332527bbf7e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styleFunctionMapping = module.exports.propToStyleFunction = module.exports.default = void 0;

var $825b4332527bbf7e$var$_borders = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("7G2Ky")));

var $825b4332527bbf7e$var$_display = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("9p2mw")));

var $825b4332527bbf7e$var$_flexbox = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("fbcSN")));

var $825b4332527bbf7e$var$_cssGrid = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("bvdLQ")));

var $825b4332527bbf7e$var$_positions = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("9cp7R")));

var $825b4332527bbf7e$var$_palette = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("7Izgs")));

var $825b4332527bbf7e$var$_shadows = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("euxvJ")));

var $825b4332527bbf7e$var$_sizing = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("lk86k")));

var $825b4332527bbf7e$var$_spacing = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("8ZgMs")));

var $825b4332527bbf7e$var$_typography = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("6a6uc")));
const $825b4332527bbf7e$var$filterPropsMapping = {
    borders: $825b4332527bbf7e$var$_borders.default.filterProps,
    display: $825b4332527bbf7e$var$_display.default.filterProps,
    flexbox: $825b4332527bbf7e$var$_flexbox.default.filterProps,
    grid: $825b4332527bbf7e$var$_cssGrid.default.filterProps,
    positions: $825b4332527bbf7e$var$_positions.default.filterProps,
    palette: $825b4332527bbf7e$var$_palette.default.filterProps,
    shadows: $825b4332527bbf7e$var$_shadows.default.filterProps,
    sizing: $825b4332527bbf7e$var$_sizing.default.filterProps,
    spacing: $825b4332527bbf7e$var$_spacing.default.filterProps,
    typography: $825b4332527bbf7e$var$_typography.default.filterProps
};
const $825b4332527bbf7e$var$styleFunctionMapping = module.exports.styleFunctionMapping = {
    borders: $825b4332527bbf7e$var$_borders.default,
    display: $825b4332527bbf7e$var$_display.default,
    flexbox: $825b4332527bbf7e$var$_flexbox.default,
    grid: $825b4332527bbf7e$var$_cssGrid.default,
    positions: $825b4332527bbf7e$var$_positions.default,
    palette: $825b4332527bbf7e$var$_palette.default,
    shadows: $825b4332527bbf7e$var$_shadows.default,
    sizing: $825b4332527bbf7e$var$_sizing.default,
    spacing: $825b4332527bbf7e$var$_spacing.default,
    typography: $825b4332527bbf7e$var$_typography.default
};
const $825b4332527bbf7e$var$propToStyleFunction = module.exports.propToStyleFunction = Object.keys($825b4332527bbf7e$var$filterPropsMapping).reduce((acc, styleFnName)=>{
    $825b4332527bbf7e$var$filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = $825b4332527bbf7e$var$styleFunctionMapping[styleFnName];
    });
    return acc;
}, {});
function $825b4332527bbf7e$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $825b4332527bbf7e$var$propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $825b4332527bbf7e$var$_default = module.exports.default = $825b4332527bbf7e$var$getThemeValue;

});


parcelRegister("8XfTG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68502a45a27be93d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $68502a45a27be93d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68502a45a27be93d$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty(module.exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $68502a45a27be93d$var$_boxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68502a45a27be93d$var$_Box.default;
    }
});

var $68502a45a27be93d$var$_Box = $68502a45a27be93d$require$_interopRequireDefault((parcelRequire("767bZ")));

var $68502a45a27be93d$var$_boxClasses = $68502a45a27be93d$require$_interopRequireWildcard((parcelRequire("7b5dP")));
Object.keys($68502a45a27be93d$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68502a45a27be93d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68502a45a27be93d$var$_boxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68502a45a27be93d$var$_boxClasses[key];
        }
    });
});

});
parcelRegister("767bZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $52aeac2e4081d4b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52aeac2e4081d4b0$var$_propTypes = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $52aeac2e4081d4b0$var$_ClassNameGenerator = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("i8uPu")));

var $52aeac2e4081d4b0$var$_createBox = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("7SBe1")));

var $52aeac2e4081d4b0$var$_boxClasses = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("7b5dP")));
const $52aeac2e4081d4b0$var$Box = (0, $52aeac2e4081d4b0$var$_createBox.default)({
    defaultClassName: $52aeac2e4081d4b0$var$_boxClasses.default.root,
    generateClassName: $52aeac2e4081d4b0$var$_ClassNameGenerator.default.generate
});
var $52aeac2e4081d4b0$var$_default = module.exports.default = $52aeac2e4081d4b0$var$Box;

});
parcelRegister("i8uPu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d340e37384f81440$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d340e37384f81440$var$_ClassNameGenerator.default;
    }
});

var $d340e37384f81440$var$_ClassNameGenerator = $d340e37384f81440$require$_interopRequireDefault((parcelRequire("bWBF0")));

});
parcelRegister("bWBF0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $8b225312ab099d40$var$defaultGenerator = (componentName)=>componentName;
const $8b225312ab099d40$var$createClassNameGenerator = ()=>{
    let generate = $8b225312ab099d40$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8b225312ab099d40$var$defaultGenerator;
        }
    };
};
const $8b225312ab099d40$var$ClassNameGenerator = $8b225312ab099d40$var$createClassNameGenerator();
var $8b225312ab099d40$var$_default = module.exports.default = $8b225312ab099d40$var$ClassNameGenerator;

});


parcelRegister("7SBe1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5bca73b38b7b68b2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5bca73b38b7b68b2$var$_createBox.default;
    }
});

var $5bca73b38b7b68b2$var$_createBox = $5bca73b38b7b68b2$require$_interopRequireDefault((parcelRequire("310Oe")));

});
parcelRegister("310Oe", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $232217c4f59982d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $232217c4f59982d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $232217c4f59982d0$var$createBox;

var $232217c4f59982d0$var$React = $232217c4f59982d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $232217c4f59982d0$var$_clsx = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $232217c4f59982d0$var$_styledEngine = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("bOOlK")));

var $232217c4f59982d0$var$_styleFunctionSx = $232217c4f59982d0$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $232217c4f59982d0$var$_useTheme = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("lywMB")));

var $ayMG0 = parcelRequire("ayMG0");
function $232217c4f59982d0$var$createBox(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $232217c4f59982d0$var$_styledEngine.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })($232217c4f59982d0$var$_styleFunctionSx.default);
    const Box = /*#__PURE__*/ $232217c4f59982d0$var$React.forwardRef(function Box(inProps, ref) {
        const theme = (0, $232217c4f59982d0$var$_useTheme.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $232217c4f59982d0$var$_styleFunctionSx.extendSxProp)(inProps);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $232217c4f59982d0$var$_clsx.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});


parcelRegister("7b5dP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $539d9c7f6e95ee22$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $539d9c7f6e95ee22$var$_generateUtilityClasses = $539d9c7f6e95ee22$require$_interopRequireDefault((parcelRequire("9AMt1")));
const $539d9c7f6e95ee22$var$boxClasses = (0, $539d9c7f6e95ee22$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $539d9c7f6e95ee22$var$_default = module.exports.default = $539d9c7f6e95ee22$var$boxClasses;

});
parcelRegister("9AMt1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6fbd12663d813338$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6fbd12663d813338$var$_generateUtilityClasses.default;
    }
});

var $6fbd12663d813338$var$_generateUtilityClasses = $6fbd12663d813338$require$_interopRequireDefault((parcelRequire("fMG6v")));

});
parcelRegister("fMG6v", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b7dbffad59b22bcc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7dbffad59b22bcc$var$generateUtilityClasses;

var $b7dbffad59b22bcc$var$_generateUtilityClass = $b7dbffad59b22bcc$require$_interopRequireDefault((parcelRequire("iiFLb")));
function $b7dbffad59b22bcc$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $b7dbffad59b22bcc$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("iiFLb", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d52a4d1d8bd06ca6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d52a4d1d8bd06ca6$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d52a4d1d8bd06ca6$var$_generateUtilityClass.default;
    }
});

var $d52a4d1d8bd06ca6$var$_generateUtilityClass = $d52a4d1d8bd06ca6$require$_interopRequireWildcard((parcelRequire("8GTHq")));
Object.keys($d52a4d1d8bd06ca6$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d52a4d1d8bd06ca6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d52a4d1d8bd06ca6$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d52a4d1d8bd06ca6$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("8GTHq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $653d73b28706e128$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $653d73b28706e128$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $653d73b28706e128$var$isGlobalState;

var $653d73b28706e128$var$_ClassNameGenerator = $653d73b28706e128$require$_interopRequireDefault((parcelRequire("i8uPu")));
const $653d73b28706e128$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $653d73b28706e128$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $653d73b28706e128$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$653d73b28706e128$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $653d73b28706e128$var$isGlobalState(slot) {
    return $653d73b28706e128$var$globalStateClasses[slot] !== undefined;
}

});







parcelRegister("bbeCr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $823c0fd313341cc1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $823c0fd313341cc1$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $823c0fd313341cc1$var$_createStyled.default;
    }
});

var $823c0fd313341cc1$var$_createStyled = $823c0fd313341cc1$require$_interopRequireWildcard((parcelRequire("b8EC5")));
Object.keys($823c0fd313341cc1$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($823c0fd313341cc1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $823c0fd313341cc1$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $823c0fd313341cc1$var$_createStyled[key];
        }
    });
});

});
parcelRegister("b8EC5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $81bff209823fdfab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $81bff209823fdfab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81bff209823fdfab$var$createStyled;
module.exports.shouldForwardProp = $81bff209823fdfab$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $81bff209823fdfab$var$_styledEngine = $81bff209823fdfab$require$_interopRequireWildcard((parcelRequire("bOOlK")));

var $kFNAX = parcelRequire("kFNAX");

var $81bff209823fdfab$var$_capitalize = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("hZn6N")));

var $81bff209823fdfab$var$_getDisplayName = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("aTinY")));

var $81bff209823fdfab$var$_createTheme = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $81bff209823fdfab$var$_styleFunctionSx = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("l6FST")));

var $81bff209823fdfab$var$_preprocessStyles = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $81bff209823fdfab$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $81bff209823fdfab$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $81bff209823fdfab$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $81bff209823fdfab$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $81bff209823fdfab$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $81bff209823fdfab$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $81bff209823fdfab$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$81bff209823fdfab$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $81bff209823fdfab$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $81bff209823fdfab$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $81bff209823fdfab$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $81bff209823fdfab$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $81bff209823fdfab$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $81bff209823fdfab$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $81bff209823fdfab$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $81bff209823fdfab$var$defaultOverridesResolver($81bff209823fdfab$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $81bff209823fdfab$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($81bff209823fdfab$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $81bff209823fdfab$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $81bff209823fdfab$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $kFNAX.isPlainObject)(style)) {
                const serialized = (0, $81bff209823fdfab$var$_preprocessStyles.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $81bff209823fdfab$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $81bff209823fdfab$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $81bff209823fdfab$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $81bff209823fdfab$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push($81bff209823fdfab$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $81bff209823fdfab$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $81bff209823fdfab$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $81bff209823fdfab$var$_getDisplayName.default)(tag)})`;
}
function $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $81bff209823fdfab$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $81bff209823fdfab$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $81bff209823fdfab$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("aTinY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7edd4d741c450944$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7edd4d741c450944$var$_getDisplayName.default;
    }
});

var $7edd4d741c450944$var$_getDisplayName = $7edd4d741c450944$require$_interopRequireDefault((parcelRequire("8cm9u")));

});
parcelRegister("8cm9u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f80a0a252ce38ce$var$getDisplayName;

var $e1xPQ = parcelRequire("e1xPQ");
function $5f80a0a252ce38ce$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $5f80a0a252ce38ce$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $5f80a0a252ce38ce$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $5f80a0a252ce38ce$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $5f80a0a252ce38ce$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $e1xPQ.ForwardRef:
            return $5f80a0a252ce38ce$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $e1xPQ.Memo:
            return $5f80a0a252ce38ce$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("4bg7U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30b4b2e6e89e9da3$var$preprocessStyles;

var $bOOlK = parcelRequire("bOOlK");
function $30b4b2e6e89e9da3$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $bOOlK.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $bOOlK.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("kpukb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $edbdaa418a42b560$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edbdaa418a42b560$var$_styled.default;
    }
});

var $edbdaa418a42b560$var$_styled = $edbdaa418a42b560$require$_interopRequireDefault((parcelRequire("haNZP")));

});
parcelRegister("haNZP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c80a270d52203b73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c80a270d52203b73$var$_createStyled = $c80a270d52203b73$require$_interopRequireDefault((parcelRequire("bbeCr")));
const $c80a270d52203b73$var$styled = (0, $c80a270d52203b73$var$_createStyled.default)();
var $c80a270d52203b73$var$_default = module.exports.default = $c80a270d52203b73$var$styled;

});


parcelRegister("2LgDM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $202ce10b3dfaac20$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_getThemeProps.default;
    }
});

var $202ce10b3dfaac20$var$_useThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("lfKzS")));

var $202ce10b3dfaac20$var$_getThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("6wACh")));

});
parcelRegister("lfKzS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f78f2110a61a7e24$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f78f2110a61a7e24$var$useThemeProps;

var $f78f2110a61a7e24$var$_getThemeProps = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("6wACh")));

var $f78f2110a61a7e24$var$_useTheme = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("lywMB")));
function $f78f2110a61a7e24$var$useThemeProps({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $f78f2110a61a7e24$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $f78f2110a61a7e24$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("6wACh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4c022282094d7502$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c022282094d7502$var$getThemeProps;

var $4c022282094d7502$var$_resolveProps = $4c022282094d7502$require$_interopRequireDefault((parcelRequire("gkuWU")));
function $4c022282094d7502$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4c022282094d7502$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("gkuWU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0311653fc8e94045$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0311653fc8e94045$var$_resolveProps.default;
    }
});

var $0311653fc8e94045$var$_resolveProps = $0311653fc8e94045$require$_interopRequireDefault((parcelRequire("j1BJN")));

});
parcelRegister("j1BJN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dd9b623f82388fea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd9b623f82388fea$var$resolveProps;

var $dd9b623f82388fea$var$_clsx = $dd9b623f82388fea$require$_interopRequireDefault((parcelRequire("9QePP")));
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @param mergeClassNameAndStyle If `true`, merges `className` and `style` props instead of overriding them.
 *   When `false` (default), props override defaultProps. When `true`, `className` values are concatenated
 *   and `style` objects are merged with props taking precedence.
 * @returns resolved props
 */ function $dd9b623f82388fea$var$resolveProps(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $dd9b623f82388fea$var$resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, $dd9b623f82388fea$var$_clsx.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});





parcelRegister("8h4LK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $60639c4e52e8e25a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $60639c4e52e8e25a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $60639c4e52e8e25a$var$_useMediaQuery.default;
    }
});

var $60639c4e52e8e25a$var$_useMediaQuery = $60639c4e52e8e25a$require$_interopRequireWildcard((parcelRequire("78KYM")));
Object.keys($60639c4e52e8e25a$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($60639c4e52e8e25a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $60639c4e52e8e25a$var$_useMediaQuery[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $60639c4e52e8e25a$var$_useMediaQuery[key];
        }
    });
});

});
parcelRegister("78KYM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $532db8df695edb5e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $532db8df695edb5e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createUseMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery;

var $532db8df695edb5e$var$React = $532db8df695edb5e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $532db8df695edb5e$var$_useEnhancedEffect = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("890ZL")));

var $2LgDM = parcelRequire("2LgDM");

var $532db8df695edb5e$var$_useThemeWithoutDefault = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("f18iq")));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $532db8df695edb5e$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $532db8df695edb5e$var$React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $532db8df695edb5e$var$_useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $532db8df695edb5e$var$safeReact = {
    ...$532db8df695edb5e$var$React
};
const $532db8df695edb5e$var$maybeReactUseSyncExternalStore = $532db8df695edb5e$var$safeReact.useSyncExternalStore;
function $532db8df695edb5e$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $532db8df695edb5e$var$React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $532db8df695edb5e$var$React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $532db8df695edb5e$var$React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $532db8df695edb5e$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $532db8df695edb5e$var$unstable_createUseMediaQuery(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $532db8df695edb5e$var$_useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $2LgDM.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $532db8df695edb5e$var$maybeReactUseSyncExternalStore !== undefined ? $532db8df695edb5e$var$useMediaQueryNew : $532db8df695edb5e$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $532db8df695edb5e$var$useMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery();
var $532db8df695edb5e$var$_default = module.exports.default = $532db8df695edb5e$var$useMediaQuery;

});
parcelRegister("890ZL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5edfefa08f805b47$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5edfefa08f805b47$var$_useEnhancedEffect.default;
    }
});

var $5edfefa08f805b47$var$_useEnhancedEffect = $5edfefa08f805b47$require$_interopRequireDefault((parcelRequire("h1GbT")));

});
parcelRegister("h1GbT", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $c65341df60b5db1a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65341df60b5db1a$var$React = $c65341df60b5db1a$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $c65341df60b5db1a$var$useEnhancedEffect = typeof window !== 'undefined' ? $c65341df60b5db1a$var$React.useLayoutEffect : $c65341df60b5db1a$var$React.useEffect;
var $c65341df60b5db1a$var$_default = module.exports.default = $c65341df60b5db1a$var$useEnhancedEffect;

});




parcelRegister("h61zw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i0NBZ = parcelRequire("i0NBZ");
Object.keys($i0NBZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i0NBZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i0NBZ[key];
        }
    });
});

});
parcelRegister("i0NBZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1ceb5f718f3f33e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $d1ceb5f718f3f33e$var$alpha;
module.exports.blend = $d1ceb5f718f3f33e$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $d1ceb5f718f3f33e$var$darken;
module.exports.decomposeColor = $d1ceb5f718f3f33e$var$decomposeColor;
module.exports.emphasize = $d1ceb5f718f3f33e$var$emphasize;
module.exports.getContrastRatio = $d1ceb5f718f3f33e$var$getContrastRatio;
module.exports.getLuminance = $d1ceb5f718f3f33e$var$getLuminance;
module.exports.hexToRgb = $d1ceb5f718f3f33e$var$hexToRgb;
module.exports.hslToRgb = $d1ceb5f718f3f33e$var$hslToRgb;
module.exports.lighten = $d1ceb5f718f3f33e$var$lighten;
module.exports.private_safeAlpha = $d1ceb5f718f3f33e$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $d1ceb5f718f3f33e$var$private_safeDarken;
module.exports.private_safeEmphasize = $d1ceb5f718f3f33e$var$private_safeEmphasize;
module.exports.private_safeLighten = $d1ceb5f718f3f33e$var$private_safeLighten;
module.exports.recomposeColor = $d1ceb5f718f3f33e$var$recomposeColor;
module.exports.rgbToHex = $d1ceb5f718f3f33e$var$rgbToHex;

var $d1ceb5f718f3f33e$var$_formatMuiErrorMessage = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("aXtNH")));

var $d1ceb5f718f3f33e$var$_clamp = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("bmE2A")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d1ceb5f718f3f33e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $d1ceb5f718f3f33e$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $d1ceb5f718f3f33e$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $d1ceb5f718f3f33e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $d1ceb5f718f3f33e$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $d1ceb5f718f3f33e$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $d1ceb5f718f3f33e$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $d1ceb5f718f3f33e$var$colorChannel = (color)=>{
    const decomposedColor = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $d1ceb5f718f3f33e$var$colorChannel;
const $d1ceb5f718f3f33e$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $d1ceb5f718f3f33e$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $d1ceb5f718f3f33e$var$private_safeColorChannel;
function $d1ceb5f718f3f33e$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $d1ceb5f718f3f33e$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return `#${values.map((n, i)=>$d1ceb5f718f3f33e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $d1ceb5f718f3f33e$var$hslToRgb(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $d1ceb5f718f3f33e$var$getLuminance(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $d1ceb5f718f3f33e$var$getContrastRatio(foreground, background) {
    const lumA = $d1ceb5f718f3f33e$var$getLuminance(foreground);
    const lumB = $d1ceb5f718f3f33e$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$alpha(color, value) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    value = $d1ceb5f718f3f33e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeAlpha(color, value, warning) {
    try {
        return $d1ceb5f718f3f33e$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$darken(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$lighten(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$emphasize(color, coefficient = 0.15) {
    return $d1ceb5f718f3f33e$var$getLuminance(color) > 0.5 ? $d1ceb5f718f3f33e$var$darken(color, coefficient) : $d1ceb5f718f3f33e$var$lighten(color, coefficient);
}
function $d1ceb5f718f3f33e$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $d1ceb5f718f3f33e$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $d1ceb5f718f3f33e$var$decomposeColor(background);
    const overlayColor = $d1ceb5f718f3f33e$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("bmE2A", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8460cf0669851932$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8460cf0669851932$var$_clamp.default;
    }
});

var $8460cf0669851932$var$_clamp = $8460cf0669851932$require$_interopRequireDefault((parcelRequire("16GTp")));

});
parcelRegister("16GTp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $0ce79f928fa86694$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0ce79f928fa86694$var$_default = module.exports.default = $0ce79f928fa86694$var$clamp;

});




parcelRegister("ixP4k", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d802ec3fa7ccc11e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d802ec3fa7ccc11e$var$_ThemeProvider.default;
    }
});

var $d802ec3fa7ccc11e$var$_ThemeProvider = $d802ec3fa7ccc11e$require$_interopRequireDefault((parcelRequire("411Qv")));

});
parcelRegister("411Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2ec8aff4a7c0cf18$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2ec8aff4a7c0cf18$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ec8aff4a7c0cf18$var$React = $2ec8aff4a7c0cf18$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2ec8aff4a7c0cf18$var$_propTypes = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3YuG2 = parcelRequire("3YuG2");

var $2ec8aff4a7c0cf18$var$_exactProp = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("cMdTw")));

var $bOOlK = parcelRequire("bOOlK");

var $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("f18iq")));

var $2ec8aff4a7c0cf18$var$_RtlProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("9uEev")));

var $2ec8aff4a7c0cf18$var$_DefaultPropsProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("buuO7")));

var $2ec8aff4a7c0cf18$var$_useLayerOrder = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("66f2w")));

var $ayMG0 = parcelRequire("ayMG0");
const $2ec8aff4a7c0cf18$var$EMPTY_THEME = {};
function $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $2ec8aff4a7c0cf18$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $2ec8aff4a7c0cf18$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault.default)($2ec8aff4a7c0cf18$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $3YuG2.useTheme)() || $2ec8aff4a7c0cf18$var$EMPTY_THEME;
    const engineTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $2ec8aff4a7c0cf18$var$_useLayerOrder.default)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3YuG2.ThemeProvider, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.ThemeContext.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2ec8aff4a7c0cf18$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($2ec8aff4a7c0cf18$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $2ec8aff4a7c0cf18$var$_default = module.exports.default = $2ec8aff4a7c0cf18$var$ThemeProvider;

});
parcelRegister("3YuG2", function(module, exports) {
/**
 * @mui/private-theming v7.3.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $2e4ec584c6273f12$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2e4ec584c6273f12$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2e4ec584c6273f12$var$_exportNames = {
    ThemeProvider: true,
    useTheme: true
};
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $2e4ec584c6273f12$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $2e4ec584c6273f12$var$_useTheme.default;
    }
});

var $2e4ec584c6273f12$var$_ThemeProvider = $2e4ec584c6273f12$require$_interopRequireWildcard((parcelRequire("bAAZQ")));
Object.keys($2e4ec584c6273f12$var$_ThemeProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2e4ec584c6273f12$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2e4ec584c6273f12$var$_ThemeProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2e4ec584c6273f12$var$_ThemeProvider[key];
        }
    });
});

var $2e4ec584c6273f12$var$_useTheme = $2e4ec584c6273f12$require$_interopRequireDefault((parcelRequire("l03D8")));

});
parcelRegister("bAAZQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $86ffc1375996ef3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $86ffc1375996ef3d$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_nested", {
    enumerable: true,
    get: function() {
        return $86ffc1375996ef3d$var$_nested.default;
    }
});

var $86ffc1375996ef3d$var$_ThemeProvider = $86ffc1375996ef3d$require$_interopRequireDefault((parcelRequire("lYrbz")));

var $86ffc1375996ef3d$var$_nested = $86ffc1375996ef3d$require$_interopRequireDefault((parcelRequire("2NPLA")));

});
parcelRegister("lYrbz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fff44a152eb20ab0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fff44a152eb20ab0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fff44a152eb20ab0$var$React = $fff44a152eb20ab0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fff44a152eb20ab0$var$_propTypes = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fff44a152eb20ab0$var$_exactProp = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("holL2")));

var $fff44a152eb20ab0$var$_ThemeContext = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("fHPaR")));

var $fff44a152eb20ab0$var$_useTheme = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("l03D8")));

var $fff44a152eb20ab0$var$_nested = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("2NPLA")));

var $ayMG0 = parcelRequire("ayMG0");
// To support composition of theme.
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $fff44a152eb20ab0$var$_useTheme.default)();
    const theme = $fff44a152eb20ab0$var$React.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[$fff44a152eb20ab0$var$_nested.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fff44a152eb20ab0$var$_ThemeContext.default.Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$var$_default = module.exports.default = $fff44a152eb20ab0$var$ThemeProvider;

});
parcelRegister("holL2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ca958e2c82475923$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ca958e2c82475923$var$_exactProp.default;
    }
});

var $ca958e2c82475923$var$_exactProp = $ca958e2c82475923$require$_interopRequireDefault((parcelRequire("kqxHK")));

});
parcelRegister("kqxHK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edf0616133bd065a$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $edf0616133bd065a$var$specialProperty = 'exact-prop: \u200b';
function $edf0616133bd065a$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("fHPaR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b6f2914bcc222460$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6f2914bcc222460$var$React = $b6f2914bcc222460$require$_interopRequireWildcard((parcelRequire("acw62")));
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $b6f2914bcc222460$var$React.createContext(null);
var $b6f2914bcc222460$var$_default = module.exports.default = $b6f2914bcc222460$var$ThemeContext;

});

parcelRegister("l03D8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f49c69f16b6a34af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f49c69f16b6a34af$var$_useTheme.default;
    }
});

var $f49c69f16b6a34af$var$_useTheme = $f49c69f16b6a34af$require$_interopRequireDefault((parcelRequire("lT1cX")));

});
parcelRegister("lT1cX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $feefabedf550ce3f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $feefabedf550ce3f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $feefabedf550ce3f$var$useTheme;

var $feefabedf550ce3f$var$React = $feefabedf550ce3f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $feefabedf550ce3f$var$_ThemeContext = $feefabedf550ce3f$require$_interopRequireDefault((parcelRequire("fHPaR")));
function $feefabedf550ce3f$var$useTheme() {
    const theme = $feefabedf550ce3f$var$React.useContext($feefabedf550ce3f$var$_ThemeContext.default);
    return theme;
}

});


parcelRegister("2NPLA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $20a8501e6e2f4912$var$_default = module.exports.default = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});




parcelRegister("cMdTw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $94d4bee8734ffce7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $94d4bee8734ffce7$var$_exactProp.default;
    }
});

var $94d4bee8734ffce7$var$_exactProp = $94d4bee8734ffce7$require$_interopRequireDefault((parcelRequire("23Kmz")));

});
parcelRegister("23Kmz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17ffd351bdda3a0f$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $17ffd351bdda3a0f$var$specialProperty = 'exact-prop: \u200b';
function $17ffd351bdda3a0f$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("9uEev", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6e961fcfc1c15c66$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6e961fcfc1c15c66$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $6e961fcfc1c15c66$var$React = $6e961fcfc1c15c66$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6e961fcfc1c15c66$var$_propTypes = $6e961fcfc1c15c66$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ayMG0 = parcelRequire("ayMG0");
const $6e961fcfc1c15c66$var$RtlContext = /*#__PURE__*/ $6e961fcfc1c15c66$var$React.createContext();
function $6e961fcfc1c15c66$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6e961fcfc1c15c66$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $6e961fcfc1c15c66$var$useRtl = ()=>{
    const value = $6e961fcfc1c15c66$var$React.useContext($6e961fcfc1c15c66$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $6e961fcfc1c15c66$var$useRtl;
var $6e961fcfc1c15c66$var$_default = module.exports.default = $6e961fcfc1c15c66$var$RtlProvider;

});

parcelRegister("buuO7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85da64c4cc661dcb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $85da64c4cc661dcb$var$_DefaultPropsProvider = $85da64c4cc661dcb$require$_interopRequireWildcard((parcelRequire("k3xKF")));

});
parcelRegister("k3xKF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e99e44d394b0848b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e99e44d394b0848b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $e99e44d394b0848b$var$useDefaultProps;

var $e99e44d394b0848b$var$React = $e99e44d394b0848b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e99e44d394b0848b$var$_propTypes = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e99e44d394b0848b$var$_resolveProps = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("gkuWU")));

var $ayMG0 = parcelRequire("ayMG0");
const $e99e44d394b0848b$var$PropsContext = /*#__PURE__*/ $e99e44d394b0848b$var$React.createContext(undefined);
function $e99e44d394b0848b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e99e44d394b0848b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $e99e44d394b0848b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $e99e44d394b0848b$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $e99e44d394b0848b$var$React.useContext($e99e44d394b0848b$var$PropsContext);
    return $e99e44d394b0848b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $e99e44d394b0848b$var$_default = module.exports.default = $e99e44d394b0848b$var$DefaultPropsProvider;

});


parcelRegister("66f2w", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $470ef830d3f406b4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $470ef830d3f406b4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $470ef830d3f406b4$var$useLayerOrder;

var $470ef830d3f406b4$var$React = $470ef830d3f406b4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $470ef830d3f406b4$var$_useEnhancedEffect = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("890ZL")));

var $470ef830d3f406b4$var$_useId = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("epqQp")));

var $470ef830d3f406b4$var$_GlobalStyles = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("fJztl")));

var $470ef830d3f406b4$var$_useThemeWithoutDefault = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("f18iq")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */ function $470ef830d3f406b4$var$useLayerOrder(theme) {
    const upperTheme = (0, $470ef830d3f406b4$var$_useThemeWithoutDefault.default)();
    const id = (0, $470ef830d3f406b4$var$_useId.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $470ef830d3f406b4$var$_useEnhancedEffect.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($470ef830d3f406b4$var$_GlobalStyles.default, {
        styles: layerOrder
    });
}

});
parcelRegister("epqQp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a7d83939ffb68a01$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a7d83939ffb68a01$var$_useId.default;
    }
});

var $a7d83939ffb68a01$var$_useId = $a7d83939ffb68a01$require$_interopRequireDefault((parcelRequire("evJcX")));

});
parcelRegister("evJcX", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a907074a9c6df3b4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a907074a9c6df3b4$var$useId;

var $a907074a9c6df3b4$var$React = $a907074a9c6df3b4$require$_interopRequireWildcard((parcelRequire("acw62")));
let $a907074a9c6df3b4$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $a907074a9c6df3b4$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $a907074a9c6df3b4$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $a907074a9c6df3b4$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $a907074a9c6df3b4$var$globalId += 1;
            setDefaultId(`mui-${$a907074a9c6df3b4$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $a907074a9c6df3b4$var$safeReact = {
    ...$a907074a9c6df3b4$var$React
};
const $a907074a9c6df3b4$var$maybeReactUseId = $a907074a9c6df3b4$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $a907074a9c6df3b4$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($a907074a9c6df3b4$var$maybeReactUseId !== undefined) {
        const reactId = $a907074a9c6df3b4$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $a907074a9c6df3b4$var$useGlobalId(idOverride);
}

});





parcelRegister("5Ts1H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44a7d4485060e536$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44a7d4485060e536$var$unstable_memoTheme;

var $44a7d4485060e536$var$_preprocessStyles = $44a7d4485060e536$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $44a7d4485060e536$var$arg = {
    theme: undefined
};
/**
 * Memoize style function on theme.
 * Intended to be used in styled() calls that only need access to the theme.
 */ function $44a7d4485060e536$var$unstable_memoTheme(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $44a7d4485060e536$var$arg.theme = props.theme;
            value = (0, $44a7d4485060e536$var$_preprocessStyles.default)(styleFn($44a7d4485060e536$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});

parcelRegister("3Vfwq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2db2bc563e7e5e69$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2db2bc563e7e5e69$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $2db2bc563e7e5e69$var$createCssVarsProvider;

var $2db2bc563e7e5e69$var$React = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2db2bc563e7e5e69$var$_propTypes = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bOOlK = parcelRequire("bOOlK");

var $3YuG2 = parcelRequire("3YuG2");

var $2db2bc563e7e5e69$var$_useEnhancedEffect = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("890ZL")));

var $2db2bc563e7e5e69$var$_ThemeProvider = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $2db2bc563e7e5e69$var$_InitColorSchemeScript = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("79OI6")));

var $2db2bc563e7e5e69$var$_useCurrentColorScheme = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("srPro")));

var $ayMG0 = parcelRequire("ayMG0");
const $2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $2db2bc563e7e5e69$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $2db2bc563e7e5e69$var$_InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $2db2bc563e7e5e69$var$_InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $2db2bc563e7e5e69$var$React.createContext(undefined);
    const useColorScheme = ()=>$2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $2db2bc563e7e5e69$var$React.useRef(false);
        const upperTheme = (0, $3YuG2.useTheme)();
        const ctx = $2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $2db2bc563e7e5e69$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $2db2bc563e7e5e69$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $2db2bc563e7e5e69$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $2db2bc563e7e5e69$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($2db2bc563e7e5e69$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($2db2bc563e7e5e69$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.GlobalStyles, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $2db2bc563e7e5e69$var$_InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("79OI6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5360b5aae8294a93$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.default = $5360b5aae8294a93$var$InitColorSchemeScript;

var $5360b5aae8294a93$var$React = $5360b5aae8294a93$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Split this component for RSC import
 */ const $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function $5360b5aae8294a93$var$InitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("srPro", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $055833d66b0d6531$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $055833d66b0d6531$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $055833d66b0d6531$var$useCurrentColorScheme;
module.exports.getColorScheme = $055833d66b0d6531$var$getColorScheme;
module.exports.getSystemMode = $055833d66b0d6531$var$getSystemMode;

var $055833d66b0d6531$var$React = $055833d66b0d6531$require$_interopRequireWildcard((parcelRequire("acw62")));

var $79OI6 = parcelRequire("79OI6");

var $055833d66b0d6531$var$_localStorageManager = $055833d66b0d6531$require$_interopRequireDefault((parcelRequire("emFGB")));
function $055833d66b0d6531$var$noop() {}
function $055833d66b0d6531$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $055833d66b0d6531$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $055833d66b0d6531$var$getColorScheme(state) {
    return $055833d66b0d6531$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $055833d66b0d6531$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $79OI6.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $79OI6.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $055833d66b0d6531$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $055833d66b0d6531$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $055833d66b0d6531$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $055833d66b0d6531$var$React.useState(noSsr || !isMultiSchemes);
    $055833d66b0d6531$var$React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $055833d66b0d6531$var$getColorScheme(state);
    const setMode = $055833d66b0d6531$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $055833d66b0d6531$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $055833d66b0d6531$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $055833d66b0d6531$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $055833d66b0d6531$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $055833d66b0d6531$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $055833d66b0d6531$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("emFGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $a75374c871ddabd4$var$noop() {}
const $a75374c871ddabd4$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $a75374c871ddabd4$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $a75374c871ddabd4$var$_default = module.exports.default = $a75374c871ddabd4$var$localStorageManager;

});



parcelRegister("hKuOr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cebea242efdc3891$var$createGetCssVar;
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $cebea242efdc3891$var$createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("ejFX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $a6c361fa93759ec5$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $a6c361fa93759ec5$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $a6c361fa93759ec5$var$assignNestedKeys;
const $a6c361fa93759ec5$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $a6c361fa93759ec5$var$walkObjectDeep;
const $a6c361fa93759ec5$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $a6c361fa93759ec5$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $a6c361fa93759ec5$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $a6c361fa93759ec5$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $a6c361fa93759ec5$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $a6c361fa93759ec5$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});

parcelRegister("5magr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e66f819b409e224$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e66f819b409e224$var$_deepmerge = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("kFNAX")));

var $3e66f819b409e224$var$_cssVarsParser = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("ejFX8")));
function $3e66f819b409e224$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3e66f819b409e224$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $3e66f819b409e224$var$_default = module.exports.default = $3e66f819b409e224$var$prepareCssVars;

});

parcelRegister("73CWR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5237068774af7ee7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5237068774af7ee7$var$_prepareCssVars = $5237068774af7ee7$require$_interopRequireDefault((parcelRequire("5magr")));

var $9wccP = parcelRequire("9wccP");

var $79OI6 = parcelRequire("79OI6");
function $5237068774af7ee7$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$79OI6.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $5237068774af7ee7$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $9wccP.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var $5237068774af7ee7$var$_default = module.exports.default = $5237068774af7ee7$var$createCssVarsTheme;

});
parcelRegister("9wccP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $6ee0921037829b98$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $6ee0921037829b98$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});


parcelRegister("1RRq5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = module.exports.prerelease = module.exports.patch = module.exports.minor = module.exports.major = module.exports.default = void 0;
const $15c42dbad1fc53b5$var$version = module.exports.version = "7.3.2";
const $15c42dbad1fc53b5$var$major = module.exports.major = Number("7");
const $15c42dbad1fc53b5$var$minor = module.exports.minor = Number("3");
const $15c42dbad1fc53b5$var$patch = module.exports.patch = Number("2");
const $15c42dbad1fc53b5$var$prerelease = module.exports.prerelease = undefined;
var $15c42dbad1fc53b5$var$_default = module.exports.default = $15c42dbad1fc53b5$var$version;

});

parcelRegister("689Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $476b209a249f8c65$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $476b209a249f8c65$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $476b209a249f8c65$var$createContainer;

var $476b209a249f8c65$var$React = $476b209a249f8c65$require$_interopRequireWildcard((parcelRequire("acw62")));

var $476b209a249f8c65$var$_propTypes = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $476b209a249f8c65$var$_clsx = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("9QePP")));

var $476b209a249f8c65$var$_generateUtilityClass = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("iiFLb")));

var $476b209a249f8c65$var$_composeClasses = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("9SeTK")));

var $476b209a249f8c65$var$_capitalize = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("hZn6N")));

var $476b209a249f8c65$var$_useThemeProps = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $476b209a249f8c65$var$_styled = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("kpukb")));

var $476b209a249f8c65$var$_createTheme = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $ayMG0 = parcelRequire("ayMG0");
const $476b209a249f8c65$var$defaultTheme = (0, $476b209a249f8c65$var$_createTheme.default)();
const $476b209a249f8c65$var$defaultCreateStyledComponent = (0, $476b209a249f8c65$var$_styled.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $476b209a249f8c65$var$_capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $476b209a249f8c65$var$useThemePropsDefault = (inProps)=>(0, $476b209a249f8c65$var$_useThemeProps.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $476b209a249f8c65$var$defaultTheme
    });
const $476b209a249f8c65$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $476b209a249f8c65$var$_generateUtilityClass.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $476b209a249f8c65$var$_capitalize.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $476b209a249f8c65$var$_composeClasses.default)(slots, getContainerUtilityClass, classes);
};
function $476b209a249f8c65$var$createContainer(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $476b209a249f8c65$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $476b209a249f8c65$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $476b209a249f8c65$var$React.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $476b209a249f8c65$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $476b209a249f8c65$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

});
parcelRegister("9SeTK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7304b6b06de9bc8f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7304b6b06de9bc8f$var$_composeClasses.default;
    }
});

var $7304b6b06de9bc8f$var$_composeClasses = $7304b6b06de9bc8f$require$_interopRequireDefault((parcelRequire("5vHp8")));

});
parcelRegister("5vHp8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $403184373ea369ad$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $403184373ea369ad$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});



parcelRegister("jYQTJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e8bca752eef9579e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e8bca752eef9579e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e8bca752eef9579e$var$_exportNames = {
    containerClasses: true
};
Object.defineProperty(module.exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return $e8bca752eef9579e$var$_containerClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e8bca752eef9579e$var$_Container.default;
    }
});

var $e8bca752eef9579e$var$_Container = $e8bca752eef9579e$require$_interopRequireDefault((parcelRequire("gRSQN")));

var $e8bca752eef9579e$var$_containerClasses = $e8bca752eef9579e$require$_interopRequireWildcard((parcelRequire("brfSx")));
Object.keys($e8bca752eef9579e$var$_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e8bca752eef9579e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e8bca752eef9579e$var$_containerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e8bca752eef9579e$var$_containerClasses[key];
        }
    });
});

});
parcelRegister("gRSQN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c47c24bbe2a0d6f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c47c24bbe2a0d6f8$var$_propTypes = $c47c24bbe2a0d6f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c47c24bbe2a0d6f8$var$_createContainer = $c47c24bbe2a0d6f8$require$_interopRequireDefault((parcelRequire("689Qv")));
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */ const $c47c24bbe2a0d6f8$var$Container = (0, $c47c24bbe2a0d6f8$var$_createContainer.default)();
var $c47c24bbe2a0d6f8$var$_default = module.exports.default = $c47c24bbe2a0d6f8$var$Container;

});

parcelRegister("brfSx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $853e8880b5f4e64d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getContainerUtilityClass = $853e8880b5f4e64d$var$getContainerUtilityClass;

var $853e8880b5f4e64d$var$_generateUtilityClasses = $853e8880b5f4e64d$require$_interopRequireDefault((parcelRequire("9AMt1")));

var $853e8880b5f4e64d$var$_generateUtilityClass = $853e8880b5f4e64d$require$_interopRequireDefault((parcelRequire("iiFLb")));
function $853e8880b5f4e64d$var$getContainerUtilityClass(slot) {
    return (0, $853e8880b5f4e64d$var$_generateUtilityClass.default)('MuiContainer', slot);
}
const $853e8880b5f4e64d$var$containerClasses = (0, $853e8880b5f4e64d$var$_generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $853e8880b5f4e64d$var$_default = module.exports.default = $853e8880b5f4e64d$var$containerClasses;

});


parcelRegister("dy2yf", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9dd06e03e834ae16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dd06e03e834ae16$var$_propTypes = $9dd06e03e834ae16$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9dd06e03e834ae16$var$_createGrid = $9dd06e03e834ae16$require$_interopRequireDefault((parcelRequire("h0TiG")));
/**
 *
 * Demos:
 *
 * - [Grid (Joy UI)](https://mui.com/joy-ui/react-grid/)
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const $9dd06e03e834ae16$var$Grid = (0, $9dd06e03e834ae16$var$_createGrid.default)();
var $9dd06e03e834ae16$var$_default = module.exports.default = $9dd06e03e834ae16$var$Grid;

});
parcelRegister("h0TiG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c62d554115d846cf$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c62d554115d846cf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c62d554115d846cf$var$createGrid;

var $c62d554115d846cf$var$React = $c62d554115d846cf$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c62d554115d846cf$var$_propTypes = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c62d554115d846cf$var$_clsx = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c62d554115d846cf$var$_isMuiElement = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("3jhIu")));

var $c62d554115d846cf$var$_generateUtilityClass = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("iiFLb")));

var $c62d554115d846cf$var$_composeClasses = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("9SeTK")));

var $c62d554115d846cf$var$_styled = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("kpukb")));

var $c62d554115d846cf$var$_useThemeProps = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $c62d554115d846cf$var$_useTheme = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("lywMB")));

var $l6FST = parcelRequire("l6FST");

var $c62d554115d846cf$var$_createTheme = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $ggHhD = parcelRequire("ggHhD");

var $c62d554115d846cf$var$_deleteLegacyGridProps = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("g9pbx")));

var $ayMG0 = parcelRequire("ayMG0");
const $c62d554115d846cf$var$defaultTheme = (0, $c62d554115d846cf$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $c62d554115d846cf$var$defaultCreateStyledComponent = (0, $c62d554115d846cf$var$_styled.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $c62d554115d846cf$var$useThemePropsDefault(props) {
    return (0, $c62d554115d846cf$var$_useThemeProps.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $c62d554115d846cf$var$defaultTheme
    });
}
function $c62d554115d846cf$var$createGrid(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $c62d554115d846cf$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $c62d554115d846cf$var$useThemePropsDefault, useTheme: useTheme = $c62d554115d846cf$var$_useTheme.default, componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $ggHhD.generateDirectionClasses)(direction),
                ...(0, $ggHhD.generateSizeClassNames)(size),
                ...container ? (0, $ggHhD.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $c62d554115d846cf$var$_composeClasses.default)(slots, (slot)=>(0, $c62d554115d846cf$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent($ggHhD.generateGridColumnsStyles, $ggHhD.generateGridColumnSpacingStyles, $ggHhD.generateGridRowSpacingStyles, $ggHhD.generateGridSizeStyles, $ggHhD.generateGridDirectionStyles, $ggHhD.generateGridStyles, $ggHhD.generateGridOffsetStyles);
    const Grid = /*#__PURE__*/ $c62d554115d846cf$var$React.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $l6FST.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $c62d554115d846cf$var$_deleteLegacyGridProps.default)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $c62d554115d846cf$var$_clsx.default)(classes.root, className),
            ...other,
            children: $c62d554115d846cf$var$React.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $c62d554115d846cf$var$React.isValidElement(child) && (0, $c62d554115d846cf$var$_isMuiElement.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $c62d554115d846cf$var$React.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("3jhIu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2690e3950060780b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2690e3950060780b$var$_isMuiElement.default;
    }
});

var $2690e3950060780b$var$_isMuiElement = $2690e3950060780b$require$_interopRequireDefault((parcelRequire("bqkWo")));

});
parcelRegister("bqkWo", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85125dd2df77a93e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $85125dd2df77a93e$var$isMuiElement;

var $85125dd2df77a93e$var$React = $85125dd2df77a93e$require$_interopRequireWildcard((parcelRequire("acw62")));
function $85125dd2df77a93e$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $85125dd2df77a93e$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("ggHhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateSpacingClassNames = module.exports.generateSizeClassNames = module.exports.generateGridStyles = module.exports.generateGridSizeStyles = module.exports.generateGridRowSpacingStyles = module.exports.generateGridOffsetStyles = module.exports.generateGridDirectionStyles = module.exports.generateGridColumnsStyles = module.exports.generateGridColumnSpacingStyles = module.exports.generateDirectionClasses = void 0;

var $99OVR = parcelRequire("99OVR");
function $bd7fb721dfb6dcf0$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $bd7fb721dfb6dcf0$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $bd7fb721dfb6dcf0$var$selfColumnsVar = '--Grid-columns';
const $bd7fb721dfb6dcf0$var$parentColumnsVar = '--Grid-parent-columns';
const $bd7fb721dfb6dcf0$var$generateGridSizeStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) - (var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) - ${value}) * (var(${$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')}) / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridSizeStyles = $bd7fb721dfb6dcf0$var$generateGridSizeStyles;
const $bd7fb721dfb6dcf0$var$generateGridOffsetStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) + var(${$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')}) * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridOffsetStyles = $bd7fb721dfb6dcf0$var$generateGridOffsetStyles;
const $bd7fb721dfb6dcf0$var$generateGridColumnsStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$bd7fb721dfb6dcf0$var$selfColumnsVar]: 12
    };
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$selfColumnsVar]: columns,
            '> *': {
                [$bd7fb721dfb6dcf0$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnsStyles = $bd7fb721dfb6dcf0$var$generateGridColumnsStyles;
const $bd7fb721dfb6dcf0$var$generateGridRowSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$bd7fb721dfb6dcf0$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridRowSpacingStyles = $bd7fb721dfb6dcf0$var$generateGridRowSpacingStyles;
const $bd7fb721dfb6dcf0$var$generateGridColumnSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnSpacingStyles = $bd7fb721dfb6dcf0$var$generateGridColumnSpacingStyles;
const $bd7fb721dfb6dcf0$var$generateGridDirectionStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
module.exports.generateGridDirectionStyles = $bd7fb721dfb6dcf0$var$generateGridDirectionStyles;
const $bd7fb721dfb6dcf0$var$generateGridStyles = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$bd7fb721dfb6dcf0$var$getSelfSpacingVar('row')}) var(${$bd7fb721dfb6dcf0$var$getSelfSpacingVar('column')})`
        }
    };
};
module.exports.generateGridStyles = $bd7fb721dfb6dcf0$var$generateGridStyles;
const $bd7fb721dfb6dcf0$var$generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
module.exports.generateSizeClassNames = $bd7fb721dfb6dcf0$var$generateSizeClassNames;
const $bd7fb721dfb6dcf0$var$generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
module.exports.generateSpacingClassNames = $bd7fb721dfb6dcf0$var$generateSpacingClassNames;
const $bd7fb721dfb6dcf0$var$generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};
module.exports.generateDirectionClasses = $bd7fb721dfb6dcf0$var$generateDirectionClasses;

});
parcelRegister("99OVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.traverseBreakpoints = module.exports.filterBreakpointKeys = void 0;
const $6aac76618a3aa479$var$filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
module.exports.filterBreakpointKeys = $6aac76618a3aa479$var$filterBreakpointKeys;
const $6aac76618a3aa479$var$traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $6aac76618a3aa479$var$filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};
module.exports.traverseBreakpoints = $6aac76618a3aa479$var$traverseBreakpoints;

});


parcelRegister("g9pbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc2105d70693a6c1$var$deleteLegacyGridProps;
const $bc2105d70693a6c1$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $bc2105d70693a6c1$var$warnedAboutProps = [];
/**
 * Deletes the legacy Grid component props from the `props` object and warns once about them if found.
 *
 * @param {object} props The props object to remove the legacy Grid props from.
 * @param {Breakpoints} breakpoints The breakpoints object.
 */ function $bc2105d70693a6c1$var$deleteLegacyGridProps(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}

});



parcelRegister("gxueG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c0a72ea334f236a5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c0a72ea334f236a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c0a72ea334f236a5$var$_exportNames = {
    createGrid: true,
    gridClasses: true,
    unstable_traverseBreakpoints: true,
    unstable_generateDirectionClasses: true,
    unstable_generateSizeClassNames: true,
    unstable_generateSpacingClassNames: true
};
Object.defineProperty(module.exports, "createGrid", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_createGrid.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_gridClasses.default;
    }
});
Object.defineProperty(module.exports, "unstable_generateDirectionClasses", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateDirectionClasses;
    }
});
Object.defineProperty(module.exports, "unstable_generateSizeClassNames", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateSizeClassNames;
    }
});
Object.defineProperty(module.exports, "unstable_generateSpacingClassNames", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateSpacingClassNames;
    }
});
Object.defineProperty(module.exports, "unstable_traverseBreakpoints", {
    enumerable: true,
    get: function() {
        return $99OVR.traverseBreakpoints;
    }
});

var $c0a72ea334f236a5$var$_Grid = $c0a72ea334f236a5$require$_interopRequireDefault((parcelRequire("dy2yf")));

var $c0a72ea334f236a5$var$_createGrid = $c0a72ea334f236a5$require$_interopRequireDefault((parcelRequire("h0TiG")));

var $9GB8a = parcelRequire("9GB8a");
Object.keys($9GB8a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0a72ea334f236a5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9GB8a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9GB8a[key];
        }
    });
});

var $c0a72ea334f236a5$var$_gridClasses = $c0a72ea334f236a5$require$_interopRequireWildcard((parcelRequire("8HLwS")));
Object.keys($c0a72ea334f236a5$var$_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0a72ea334f236a5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c0a72ea334f236a5$var$_gridClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c0a72ea334f236a5$var$_gridClasses[key];
        }
    });
});

var $99OVR = parcelRequire("99OVR");

var $ggHhD = parcelRequire("ggHhD");

});
parcelRegister("9GB8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8HLwS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65673535bf7c146f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridUtilityClass = $65673535bf7c146f$var$getGridUtilityClass;

var $65673535bf7c146f$var$_generateUtilityClasses = $65673535bf7c146f$require$_interopRequireDefault((parcelRequire("9AMt1")));

var $65673535bf7c146f$var$_generateUtilityClass = $65673535bf7c146f$require$_interopRequireDefault((parcelRequire("iiFLb")));
function $65673535bf7c146f$var$getGridUtilityClass(slot) {
    return (0, $65673535bf7c146f$var$_generateUtilityClass.default)('MuiGrid', slot);
}
const $65673535bf7c146f$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $65673535bf7c146f$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $65673535bf7c146f$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $65673535bf7c146f$var$GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $65673535bf7c146f$var$gridClasses = (0, $65673535bf7c146f$var$_generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...$65673535bf7c146f$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$65673535bf7c146f$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$65673535bf7c146f$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $65673535bf7c146f$var$_default = module.exports.default = $65673535bf7c146f$var$gridClasses;

});


parcelRegister("kgIUX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ec1824feff65c009$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec1824feff65c009$var$_propTypes = $ec1824feff65c009$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ec1824feff65c009$var$_createStack = $ec1824feff65c009$require$_interopRequireDefault((parcelRequire("4N1IS")));
/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const $ec1824feff65c009$var$Stack = (0, $ec1824feff65c009$var$_createStack.default)();
var $ec1824feff65c009$var$_default = module.exports.default = $ec1824feff65c009$var$Stack;

});
parcelRegister("4N1IS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $37cd131ec442ac03$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $37cd131ec442ac03$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37cd131ec442ac03$var$createStack;
module.exports.style = void 0;

var $37cd131ec442ac03$var$React = $37cd131ec442ac03$require$_interopRequireWildcard((parcelRequire("acw62")));

var $37cd131ec442ac03$var$_propTypes = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $37cd131ec442ac03$var$_clsx = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("9QePP")));

var $37cd131ec442ac03$var$_deepmerge = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("kFNAX")));

var $37cd131ec442ac03$var$_generateUtilityClass = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("iiFLb")));

var $37cd131ec442ac03$var$_composeClasses = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("9SeTK")));

var $37cd131ec442ac03$var$_styled = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("kpukb")));

var $37cd131ec442ac03$var$_useThemeProps = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $l6FST = parcelRequire("l6FST");

var $37cd131ec442ac03$var$_createTheme = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9mzYC = parcelRequire("9mzYC");

var $8ZgMs = parcelRequire("8ZgMs");

var $ayMG0 = parcelRequire("ayMG0");
const $37cd131ec442ac03$var$defaultTheme = (0, $37cd131ec442ac03$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $37cd131ec442ac03$var$defaultCreateStyledComponent = (0, $37cd131ec442ac03$var$_styled.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $37cd131ec442ac03$var$useThemePropsDefault(props) {
    return (0, $37cd131ec442ac03$var$_useThemeProps.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $37cd131ec442ac03$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $37cd131ec442ac03$var$joinChildren(children, separator) {
    const childrenArray = $37cd131ec442ac03$var$React.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $37cd131ec442ac03$var$React.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $37cd131ec442ac03$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $37cd131ec442ac03$var$style = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $9mzYC.handleBreakpoints)({
            theme: theme
        }, (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $8ZgMs.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$37cd131ec442ac03$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $8ZgMs.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $37cd131ec442ac03$var$_deepmerge.default)(styles, (0, $9mzYC.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $9mzYC.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
module.exports.style = $37cd131ec442ac03$var$style;
function $37cd131ec442ac03$var$createStack(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $37cd131ec442ac03$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $37cd131ec442ac03$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $37cd131ec442ac03$var$_composeClasses.default)(slots, (slot)=>(0, $37cd131ec442ac03$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($37cd131ec442ac03$var$style);
    const Stack = /*#__PURE__*/ $37cd131ec442ac03$var$React.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $l6FST.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $37cd131ec442ac03$var$_clsx.default)(classes.root, className),
            ...other,
            children: divider ? $37cd131ec442ac03$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});


parcelRegister("106Hq", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0baafce1ff534af1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0baafce1ff534af1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0baafce1ff534af1$var$_exportNames = {
    createStack: true,
    stackClasses: true
};
Object.defineProperty(module.exports, "createStack", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_createStack.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_stackClasses.default;
    }
});

var $0baafce1ff534af1$var$_Stack = $0baafce1ff534af1$require$_interopRequireDefault((parcelRequire("kgIUX")));

var $0baafce1ff534af1$var$_createStack = $0baafce1ff534af1$require$_interopRequireDefault((parcelRequire("4N1IS")));

var $19rVF = parcelRequire("19rVF");
Object.keys($19rVF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0baafce1ff534af1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $19rVF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $19rVF[key];
        }
    });
});

var $0baafce1ff534af1$var$_stackClasses = $0baafce1ff534af1$require$_interopRequireWildcard((parcelRequire("eh1Yu")));
Object.keys($0baafce1ff534af1$var$_stackClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0baafce1ff534af1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0baafce1ff534af1$var$_stackClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0baafce1ff534af1$var$_stackClasses[key];
        }
    });
});

});
parcelRegister("19rVF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eh1Yu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a6442f55ec27dd44$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStackUtilityClass = $a6442f55ec27dd44$var$getStackUtilityClass;

var $a6442f55ec27dd44$var$_generateUtilityClasses = $a6442f55ec27dd44$require$_interopRequireDefault((parcelRequire("9AMt1")));

var $a6442f55ec27dd44$var$_generateUtilityClass = $a6442f55ec27dd44$require$_interopRequireDefault((parcelRequire("iiFLb")));
function $a6442f55ec27dd44$var$getStackUtilityClass(slot) {
    return (0, $a6442f55ec27dd44$var$_generateUtilityClass.default)('MuiStack', slot);
}
const $a6442f55ec27dd44$var$stackClasses = (0, $a6442f55ec27dd44$var$_generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var $a6442f55ec27dd44$var$_default = module.exports.default = $a6442f55ec27dd44$var$stackClasses;

});



parcelRegister("61HyH", function(module, exports) {

$parcel$export(module.exports, "gridDimensionsSelector", () => $46349fe7fabb2b4d$export$26d8768b83a52ffd);
$parcel$export(module.exports, "gridColumnsTotalWidthSelector", () => $46349fe7fabb2b4d$export$ab20f9d33edc7794);
$parcel$export(module.exports, "gridRowHeightSelector", () => $46349fe7fabb2b4d$export$2ca09da26466c31a);
$parcel$export(module.exports, "gridContentHeightSelector", () => $46349fe7fabb2b4d$export$83bdaba2ad532c80);
$parcel$export(module.exports, "gridHasScrollXSelector", () => $46349fe7fabb2b4d$export$5dfe533d5e873745);
$parcel$export(module.exports, "gridHasScrollYSelector", () => $46349fe7fabb2b4d$export$4fe814c21f610df);
$parcel$export(module.exports, "gridHasFillerSelector", () => $46349fe7fabb2b4d$export$34d7a8c547584228);
$parcel$export(module.exports, "gridHeaderHeightSelector", () => $46349fe7fabb2b4d$export$4b70ef0159fef49b);
$parcel$export(module.exports, "gridGroupHeaderHeightSelector", () => $46349fe7fabb2b4d$export$f49d78f35ee113b0);
$parcel$export(module.exports, "gridVerticalScrollbarWidthSelector", () => $46349fe7fabb2b4d$export$6615095b3c921727);
$parcel$export(module.exports, "gridHasBottomFillerSelector", () => $46349fe7fabb2b4d$export$98dc8438c286cc21);

var $cgQ4y = parcelRequire("cgQ4y");
const $46349fe7fabb2b4d$export$26d8768b83a52ffd = (state)=>state.dimensions;
const $46349fe7fabb2b4d$export$ab20f9d33edc7794 = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$export$26d8768b83a52ffd, (dimensions)=>dimensions.columnsTotalWidth);
const $46349fe7fabb2b4d$export$2ca09da26466c31a = (state)=>state.dimensions.rowHeight;
const $46349fe7fabb2b4d$export$83bdaba2ad532c80 = (state)=>state.dimensions.contentSize.height;
const $46349fe7fabb2b4d$export$5dfe533d5e873745 = (state)=>state.dimensions.hasScrollX;
const $46349fe7fabb2b4d$export$4fe814c21f610df = (state)=>state.dimensions.hasScrollY;
const $46349fe7fabb2b4d$export$34d7a8c547584228 = (state)=>state.dimensions.columnsTotalWidth < state.dimensions.viewportOuterSize.width;
const $46349fe7fabb2b4d$export$4b70ef0159fef49b = (state)=>state.dimensions.headerHeight;
const $46349fe7fabb2b4d$export$f49d78f35ee113b0 = (state)=>state.dimensions.groupHeaderHeight;
const $46349fe7fabb2b4d$export$c297d104bfb637f0 = (state)=>state.dimensions.headerFilterHeight;
const $46349fe7fabb2b4d$export$6615095b3c921727 = (state)=>state.dimensions.hasScrollY ? state.dimensions.scrollbarSize : 0;
const $46349fe7fabb2b4d$export$bfc2d49082e0c9a2 = (state)=>state.dimensions.hasScrollX ? state.dimensions.scrollbarSize : 0;
const $46349fe7fabb2b4d$export$98dc8438c286cc21 = (state)=>{
    const height = state.dimensions.hasScrollX ? state.dimensions.scrollbarSize : 0;
    const needsLastRowBorder = state.dimensions.viewportOuterSize.height - state.dimensions.minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return false;
    return true;
};

});

parcelRegister("575FW", function(module, exports) {

$parcel$export(module.exports, "GridScrollArea", () => $3b92023a13ae6811$export$40bcbdb719b20690);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8Indx = parcelRequire("8Indx");
var $13KXh = parcelRequire("13KXh");

var $izOUK = parcelRequire("izOUK");

var $kUNkQ = parcelRequire("kUNkQ");

var $gJsNs = parcelRequire("gJsNs");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $bDyDY = parcelRequire("bDyDY");

var $eFF1m = parcelRequire("eFF1m");

var $5sOMZ = parcelRequire("5sOMZ");

var $61HyH = parcelRequire("61HyH");

var $fD9f4 = parcelRequire("fD9f4");

var $lHOu3 = parcelRequire("lHOu3");

var $i0LyH = parcelRequire("i0LyH");

var $cgQ4y = parcelRequire("cgQ4y");

var $bdqIg = parcelRequire("bdqIg");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3b92023a13ae6811$var$CLIFF = 1;
const $3b92023a13ae6811$var$SLOP = 1.5;
const $3b92023a13ae6811$var$useUtilityClasses = (ownerState)=>{
    const { scrollDirection: scrollDirection, classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollArea',
            `scrollArea--${scrollDirection}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $3b92023a13ae6811$var$GridScrollAreaRawRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollArea',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $5H1vo.gridClasses)['scrollArea--left']}`]: styles['scrollArea--left']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['scrollArea--right']}`]: styles['scrollArea--right']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['scrollArea--up']}`]: styles['scrollArea--up']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['scrollArea--down']}`]: styles['scrollArea--down']
            },
            styles.scrollArea
        ]
})(()=>({
        position: 'absolute',
        zIndex: 101,
        // Horizontal scroll areas
        [`&.${(0, $5H1vo.gridClasses)['scrollArea--left']}`]: {
            top: 0,
            left: 0,
            width: 20,
            bottom: 0
        },
        [`&.${(0, $5H1vo.gridClasses)['scrollArea--right']}`]: {
            top: 0,
            right: 0,
            width: 20,
            bottom: 0
        },
        // Vertical scroll areas
        [`&.${(0, $5H1vo.gridClasses)['scrollArea--up']}`]: {
            top: 0,
            left: 0,
            right: 0,
            height: 20
        },
        [`&.${(0, $5H1vo.gridClasses)['scrollArea--down']}`]: {
            bottom: 0,
            left: 0,
            right: 0,
            height: 20
        }
    }));
const $3b92023a13ae6811$var$offsetSelector = (0, $cgQ4y.createSelectorV8)((0, $61HyH.gridDimensionsSelector), (dimensions, direction)=>{
    if (direction === 'left') return dimensions.leftPinnedWidth;
    if (direction === 'right') return dimensions.rightPinnedWidth + (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    // For vertical scroll areas, we don't need horizontal offset
    return 0;
});
function $3b92023a13ae6811$var$GridScrollAreaWrapper(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const [dragDirection, setDragDirection] = $acw62.useState('none');
    // Listen for both column and row drag events
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderDragStart', ()=>setDragDirection('horizontal'));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderDragEnd', ()=>setDragDirection('none'));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowDragStart', ()=>setDragDirection('vertical'));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowDragEnd', ()=>setDragDirection('none'));
    if (dragDirection === 'none') return null;
    if (dragDirection === 'horizontal') return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridHorizontalScrollAreaContent, (0, $8nd05.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridVerticalScrollAreaContent, (0, $8nd05.default)({}, props));
}
function $3b92023a13ae6811$var$GridHorizontalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $acw62.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const timeout = (0, $lHOu3.default)();
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityFactorSelector));
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridColumnsTotalWidthSelector));
    const sideOffset = (0, $5sOMZ.useGridSelectorV8)(apiRef, $3b92023a13ae6811$var$offsetSelector, scrollDirection);
    const getCanScrollMore = ()=>{
        const dimensions = (0, $61HyH.gridDimensionsSelector)(apiRef.current.state);
        if (scrollDirection === 'left') // Only render if the user has not reached yet the start of the list
        return scrollPosition.current.left > 0;
        if (scrollDirection === 'right') {
            // Only render if the user has not reached yet the end of the list
            const maxScrollLeft = columnsTotalWidth - dimensions.viewportInnerSize.width;
            return scrollPosition.current.left < maxScrollLeft;
        }
        return false;
    };
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalHeaderHeight = (0, $i0LyH.getTotalHeaderHeight)(apiRef, rootProps);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const style = (0, $8nd05.default)({
        height: headerHeight,
        top: totalHeaderHeight - headerHeight
    }, scrollDirection === 'left' ? {
        left: sideOffset
    } : {}, scrollDirection === 'right' ? {
        right: sideOffset
    } : {});
    const handleDragOver = (0, $13KXh.default)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'left') offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        else if (scrollDirection === 'right') offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $3b92023a13ae6811$var$CLIFF) * $3b92023a13ae6811$var$SLOP + $3b92023a13ae6811$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaContent, (0, $8nd05.default)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
function $3b92023a13ae6811$var$GridVerticalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $acw62.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const timeout = (0, $lHOu3.default)();
    const rowsMeta = (0, $5sOMZ.useGridSelector)(apiRef, (0, $bdqIg.gridRowsMetaSelector));
    const getCanScrollMore = ()=>{
        const dimensions = (0, $61HyH.gridDimensionsSelector)(apiRef.current.state);
        if (scrollDirection === 'up') // Only render if the user has not reached yet the top of the list
        return scrollPosition.current.top > 0;
        if (scrollDirection === 'down') {
            // Only render if the user has not reached yet the bottom of the list
            const totalRowsHeight = rowsMeta.currentPageTotalHeight || 0;
            const maxScrollTop = totalRowsHeight - dimensions.viewportInnerSize.height - dimensions.scrollbarSize;
            return scrollPosition.current.top < maxScrollTop;
        }
        return false;
    };
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalHeaderHeight = (0, $i0LyH.getTotalHeaderHeight)(apiRef, rootProps);
    const style = {
        top: scrollDirection === 'up' ? totalHeaderHeight : undefined,
        bottom: scrollDirection === 'down' ? 0 : undefined
    };
    const handleDragOver = (0, $13KXh.default)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'up') offset = event.clientY - rootRef.current.getBoundingClientRect().bottom;
        else if (scrollDirection === 'down') offset = Math.max(1, event.clientY - rootRef.current.getBoundingClientRect().top);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $3b92023a13ae6811$var$CLIFF) * $3b92023a13ae6811$var$SLOP + $3b92023a13ae6811$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left,
                top: scrollPosition.current.top + offset
            });
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaContent, (0, $8nd05.default)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
const $3b92023a13ae6811$var$GridScrollAreaContent = (0, $gJsNs.forwardRef)(function GridScrollAreaContent(props, ref) {
    const { scrollDirection: scrollDirection, getCanScrollMore: getCanScrollMore, style: style, handleDragOver: handleDragOver } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const [canScrollMore, setCanScrollMore] = $acw62.useState(getCanScrollMore);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, rootProps, {
        scrollDirection: scrollDirection
    });
    const classes = $3b92023a13ae6811$var$useUtilityClasses(ownerState);
    const handleScrolling = ()=>{
        setCanScrollMore(getCanScrollMore);
    };
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'scrollPositionChange', handleScrolling);
    if (!canScrollMore) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaRawRoot, {
        ref: ref,
        className: classes.root,
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: style
    });
});
const $3b92023a13ae6811$export$40bcbdb719b20690 = (0, $kUNkQ.fastMemo)($3b92023a13ae6811$var$GridScrollAreaWrapper);

});
parcelRegister("eFF1m", function(module, exports) {

$parcel$export(module.exports, "GridSignature", () => $aae4b6f00de039ba$export$544be0bdf85b5af1);
$parcel$export(module.exports, "useGridApiEventHandler", () => $aae4b6f00de039ba$export$223e28bfc0254c87);
$parcel$export(module.exports, "useGridApiOptionHandler", () => $aae4b6f00de039ba$export$d55ddab8b28954db);

var $acw62 = parcelRequire("acw62");

var $7j5jX = parcelRequire("7j5jX");

var $gCT87 = parcelRequire("gCT87");
/**
 * Signal to the underlying logic what version of the public component API
 * of the Data Grid is exposed.
 */ var $aae4b6f00de039ba$export$544be0bdf85b5af1 = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    GridSignature["DataGridPremium"] = "DataGridPremium";
    return GridSignature;
}($aae4b6f00de039ba$export$544be0bdf85b5af1 || {});
// We use class to make it easier to detect in heap snapshots by name
class $aae4b6f00de039ba$var$ObjectToBeRetainedByReact {
}
function $aae4b6f00de039ba$export$4c5a9251aa47d2f8(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useGridApiEventHandler(apiRef, eventName, handler, options) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new (0, $gCT87.FinalizationRegistryBasedCleanupTracking)() : new (0, $7j5jX.TimerBasedCleanupTracking)();
        const [objectRetainedByReact] = $acw62.useState(new $aae4b6f00de039ba$var$ObjectToBeRetainedByReact());
        const subscription = $acw62.useRef(null);
        const handlerRef = $acw62.useRef(null);
        handlerRef.current = handler;
        const cleanupTokenRef = $acw62.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                if (!event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                subscription.current?.();
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $acw62.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event, details)=>{
                    if (!event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
                };
                subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                subscription.current?.();
                subscription.current = null;
            };
        }, [
            apiRef,
            eventName,
            options
        ]);
    };
}
const $aae4b6f00de039ba$var$registryContainer = {
    registry: null
};
const $aae4b6f00de039ba$export$c5af18cc30c6146f = ()=>{
    $aae4b6f00de039ba$var$registryContainer.registry?.reset();
    $aae4b6f00de039ba$var$registryContainer.registry = null;
};
const $aae4b6f00de039ba$export$223e28bfc0254c87 = $aae4b6f00de039ba$export$4c5a9251aa47d2f8($aae4b6f00de039ba$var$registryContainer);
const $aae4b6f00de039ba$var$optionsSubscriberOptions = {
    isFirst: true
};
function $aae4b6f00de039ba$export$d55ddab8b28954db(apiRef, eventName, handler) {
    $aae4b6f00de039ba$export$223e28bfc0254c87(apiRef, eventName, handler, $aae4b6f00de039ba$var$optionsSubscriberOptions);
}

});
parcelRegister("7j5jX", function(module, exports) {

$parcel$export(module.exports, "TimerBasedCleanupTracking", () => $551e6f5a35c0c62f$export$c16cf791cc6bf0c7);
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $551e6f5a35c0c62f$export$c16cf791cc6bf0c7 {
    constructor(timeout = $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}

});

parcelRegister("gCT87", function(module, exports) {

$parcel$export(module.exports, "FinalizationRegistryBasedCleanupTracking", () => $c1aaf59f4b0a47d9$export$86b678dc9d8f7603);
class $c1aaf59f4b0a47d9$export$86b678dc9d8f7603 {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
}

});


parcelRegister("i0LyH", function(module, exports) {

$parcel$export(module.exports, "COLUMNS_DIMENSION_PROPERTIES", () => $d1cd1e3fd8558ad5$export$cd7252624d377ce0);
$parcel$export(module.exports, "hydrateColumnsWidth", () => $d1cd1e3fd8558ad5$export$cd8dc1fa232954ad);
$parcel$export(module.exports, "createColumnsState", () => $d1cd1e3fd8558ad5$export$f3ba81d24bd05452);
$parcel$export(module.exports, "getFirstNonSpannedColumnToRender", () => $d1cd1e3fd8558ad5$export$6143417adb92779f);
$parcel$export(module.exports, "getTotalHeaderHeight", () => $d1cd1e3fd8558ad5$export$659109c29172602f);

var $8nd05 = parcelRequire("8nd05");

var $4FZD0 = parcelRequire("4FZD0");

var $5rUcf = parcelRequire("5rUcf");
var $bSL2h = parcelRequire("bSL2h");

var $jQEEt = parcelRequire("jQEEt");

var $lR3Vo = parcelRequire("lR3Vo");

var $fD9f4 = parcelRequire("fD9f4");

var $6forD = parcelRequire("6forD");

var $hMyIf = parcelRequire("hMyIf");
const $d1cd1e3fd8558ad5$export$cd7252624d377ce0 = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
const $d1cd1e3fd8558ad5$var$COLUMN_TYPES = (0, $5rUcf.getGridDefaultColumnTypes)();
function $d1cd1e3fd8558ad5$export$1719bda669685455({ initialFreeSpace: initialFreeSpace, totalFlexUnits: totalFlexUnits, flexColumns: flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
            // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field: field })=>{
            flexColumnsLookup.freeze(field);
        });
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
const $d1cd1e3fd8558ad5$export$cd8dc1fa232954ad = (rawState, dimensions)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute their minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach((columnField)=>{
        let column = rawState.lookup[columnField];
        let computedWidth = 0;
        let isFlex = false;
        if (rawState.columnVisibilityModel[columnField] !== false) {
            if (column.flex && column.flex > 0) {
                totalFlexUnits += column.flex;
                isFlex = true;
            } else computedWidth = (0, $lR3Vo.clamp)(column.width || (0, $bSL2h.GRID_STRING_COL_DEF).width, column.minWidth || (0, $bSL2h.GRID_STRING_COL_DEF).minWidth, column.maxWidth || (0, $bSL2h.GRID_STRING_COL_DEF).maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
        }
        if (column.computedWidth !== computedWidth) column = (0, $8nd05.default)({}, column, {
            computedWidth: computedWidth
        });
        if (isFlex) flexColumns.push(column);
        columnsLookup[columnField] = column;
    });
    const availableWidth = dimensions === undefined ? 0 : dimensions.viewportOuterSize.width - (dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
    const initialFreeSpace = Math.max(availableWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && availableWidth > 0) {
        const computedColumnWidths = $d1cd1e3fd8558ad5$export$1719bda669685455({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
        });
    }
    return (0, $8nd05.default)({}, rawState, {
        lookup: columnsLookup
    });
};
const $d1cd1e3fd8558ad5$export$6e8a0938c76079c7 = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields: orderedFields = [], dimensions: dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, $8nd05.default)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, $8nd05.default)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = (0, $8nd05.default)({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
function $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(type) {
    let colDef = $d1cd1e3fd8558ad5$var$COLUMN_TYPES[0, $5rUcf.DEFAULT_GRID_COL_TYPE_KEY];
    if (type && $d1cd1e3fd8558ad5$var$COLUMN_TYPES[type]) colDef = $d1cd1e3fd8558ad5$var$COLUMN_TYPES[type];
    return colDef;
}
const $d1cd1e3fd8558ad5$export$f3ba81d24bd05452 = ({ apiRef: apiRef, columnsToUpsert: columnsToUpsert, initialState: initialState, columnVisibilityModel: columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef), keepOnlyColumnsToUpsert: keepOnlyColumnsToUpsert = false })=>{
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel: columnVisibilityModel
    };
    else {
        const currentState = (0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: (0, $8nd05.default)({}, currentState.lookup),
            columnVisibilityModel: // Will be cleaned later if keepOnlyColumnsToUpsert=true
            columnVisibilityModel
        };
    }
    let columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) columnsToKeep = Object.keys(columnsState.lookup).reduce((acc, key)=>(0, $8nd05.default)({}, acc, {
            [key]: false
        }), {});
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field: field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = (0, $8nd05.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) existingState = (0, $8nd05.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(newColumn.type), {
            field: field
        });
        let hasBeenResized = existingState.hasBeenResized;
        $d1cd1e3fd8558ad5$export$cd7252624d377ce0.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        columnsState.lookup[field] = (0, $4FZD0.default)(existingState, (0, $8nd05.default)({}, newColumn, {
            hasBeenResized: hasBeenResized
        }));
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    const columnsStateWithPortableColumns = $d1cd1e3fd8558ad5$export$6e8a0938c76079c7(columnsStateWithPreProcessing, initialState);
    return $d1cd1e3fd8558ad5$export$cd8dc1fa232954ad(columnsStateWithPortableColumns, apiRef.current.getRootDimensions?.() ?? undefined);
};
function $d1cd1e3fd8558ad5$export$6143417adb92779f({ firstColumnToRender: firstColumnToRender, apiRef: apiRef, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    let foundStableColumn = false;
    // Keep checking columns until we find one that's not spanned in any visible row
    while(!foundStableColumn){
        foundStableColumn = true;
        for(let i = firstRowToRender; i < lastRowToRender; i += 1){
            const row = visibleRows[i];
            if (row) {
                const rowId = visibleRows[i].id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstNonSpannedColumnToRender);
                if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan && cellColSpanInfo.leftVisibleCellIndex < firstNonSpannedColumnToRender) {
                    firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
                    foundStableColumn = false;
                    break; // Check the new column index against the visible rows, because it might be spanned
                }
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
function $d1cd1e3fd8558ad5$export$659109c29172602f(apiRef, props) {
    if (props.unstable_listView) return 0;
    const densityFactor = (0, $fD9f4.gridDensityFactorSelector)(apiRef);
    const maxDepth = (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector)(apiRef);
    const isHeaderFilteringEnabled = (0, $6forD.gridHeaderFilteringEnabledSelector)(apiRef);
    const columnHeadersHeight = Math.floor(props.columnHeaderHeight * densityFactor);
    const columnGroupHeadersHeight = Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * densityFactor);
    const filterHeadersHeight = isHeaderFilteringEnabled ? Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * densityFactor) : 0;
    return columnHeadersHeight + columnGroupHeadersHeight * maxDepth + filterHeadersHeight;
}

});
parcelRegister("5rUcf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GRID_COL_TYPE_KEY", () => $3f7b10d3cc3b3307$export$9459349d75dc87fe);
$parcel$export(module.exports, "getGridDefaultColumnTypes", () => $3f7b10d3cc3b3307$export$625c4e4511cf2d66);

var $bSL2h = parcelRequire("bSL2h");

var $e79LH = parcelRequire("e79LH");

var $axs1H = parcelRequire("axs1H");

var $iNueb = parcelRequire("iNueb");

var $2LzSK = parcelRequire("2LzSK");

var $8z2XQ = parcelRequire("8z2XQ");
const $3f7b10d3cc3b3307$export$9459349d75dc87fe = 'string';
const $3f7b10d3cc3b3307$export$625c4e4511cf2d66 = ()=>{
    const nativeColumnTypes = {
        string: (0, $bSL2h.GRID_STRING_COL_DEF),
        number: (0, $e79LH.GRID_NUMERIC_COL_DEF),
        date: (0, $axs1H.GRID_DATE_COL_DEF),
        dateTime: (0, $axs1H.GRID_DATETIME_COL_DEF),
        boolean: (0, $iNueb.GRID_BOOLEAN_COL_DEF),
        singleSelect: (0, $2LzSK.GRID_SINGLE_SELECT_COL_DEF),
        [(0, $8z2XQ.GRID_ACTIONS_COLUMN_TYPE)]: (0, $8z2XQ.GRID_ACTIONS_COL_DEF),
        custom: (0, $bSL2h.GRID_STRING_COL_DEF)
    };
    return nativeColumnTypes;
};

});
parcelRegister("bSL2h", function(module, exports) {

$parcel$export(module.exports, "GRID_STRING_COL_DEF", () => $8a69393405f257b1$export$db6fa9d0a45573e4);

var $4QDBh = parcelRequire("4QDBh");

var $h8fXG = parcelRequire("h8fXG");

var $hKY94 = parcelRequire("hKY94");
const $8a69393405f257b1$export$db6fa9d0a45573e4 = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    editable: false,
    sortComparator: (0, $h8fXG.gridStringOrNumberComparator),
    type: 'string',
    align: 'left',
    filterOperators: (0, $hKY94.getGridStringOperators)(),
    renderEditCell: (0, $4QDBh.renderEditInputCell),
    getApplyQuickFilterFn: (0, $hKY94.getGridStringQuickFilterFn)
};

});
parcelRegister("4QDBh", function(module, exports) {

$parcel$export(module.exports, "renderEditInputCell", () => $387abc8f0fc4c9a9$export$d1015f41e7e48c2e);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");

var $d8seH = parcelRequire("d8seH");

var $95gUw = parcelRequire("95gUw");

var $gJsNs = parcelRequire("gJsNs");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $387abc8f0fc4c9a9$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange"
];
const $387abc8f0fc4c9a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $387abc8f0fc4c9a9$var$GridEditInputCellRoot = (0, $d8seH.default)((0, $95gUw.default), {
    name: 'MuiDataGrid',
    slot: 'EditInputCell',
    overridesResolver: (props, styles)=>styles.editInputCell
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        padding: '1px 0',
        '& input': {
            padding: '0 16px',
            height: '100%'
        }
    }));
const $387abc8f0fc4c9a9$export$cd10ed3250a4d414 = (0, $gJsNs.forwardRef)((props, ref)=>{
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, debounceMs: debounceMs = 200, isProcessingProps: isProcessingProps, onValueChange: onValueChange } = props, other = (0, $1En50.default)(props, $387abc8f0fc4c9a9$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $acw62.useRef(null);
    const [valueState, setValueState] = $acw62.useState(value);
    const classes = $387abc8f0fc4c9a9$var$useUtilityClasses(rootProps);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newValue = event.target.value;
        if (onValueChange) await onValueChange(event, newValue);
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getRow(id), column, apiRef);
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    $acw62.useEffect(()=>{
        if (meta?.changeReason !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    (0, $eEJPp.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($387abc8f0fc4c9a9$var$GridEditInputCellRoot, (0, $8nd05.default)({
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === 'number' ? colDef.type : 'text',
        value: valueState ?? '',
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : undefined
    }, other, {
        ref: ref
    }));
});
const $387abc8f0fc4c9a9$export$d1015f41e7e48c2e = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($387abc8f0fc4c9a9$export$cd10ed3250a4d414, (0, $8nd05.default)({}, params));

});

parcelRegister("h8fXG", function(module, exports) {

$parcel$export(module.exports, "sanitizeSortModel", () => $c78f90aae54b126e$export$13eeac5ac15e0be5);
$parcel$export(module.exports, "mergeStateWithSortModel", () => $c78f90aae54b126e$export$3fc28d475ac000c0);
$parcel$export(module.exports, "buildAggregatedSortingApplier", () => $c78f90aae54b126e$export$b29e353d1a72dfda);
$parcel$export(module.exports, "getNextGridSortDirection", () => $c78f90aae54b126e$export$b3d84351ab2e3580);
$parcel$export(module.exports, "gridStringOrNumberComparator", () => $c78f90aae54b126e$export$db324d0b741f4529);
$parcel$export(module.exports, "gridNumberComparator", () => $c78f90aae54b126e$export$ecfdaa3722003888);
$parcel$export(module.exports, "gridDateComparator", () => $c78f90aae54b126e$export$74e685f55e96d6bc);

var $8nd05 = parcelRequire("8nd05");


var $goCyd = parcelRequire("goCyd");
const $c78f90aae54b126e$export$13eeac5ac15e0be5 = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) return [
        model[0]
    ];
    return model;
};
const $c78f90aae54b126e$export$3fc28d475ac000c0 = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, $8nd05.default)({}, state, {
            sorting: (0, $8nd05.default)({}, state.sorting, {
                sortModel: $c78f90aae54b126e$export$13eeac5ac15e0be5(sortModel, disableMultipleColumnsSorting)
            })
        });
const $c78f90aae54b126e$var$isDesc = (direction)=>direction === 'desc';
/**
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {RefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const $c78f90aae54b126e$var$parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column || sortItem.sort === null) return null;
    let comparator;
    if (column.getSortComparator) comparator = column.getSortComparator(sortItem.sort);
    else comparator = $c78f90aae54b126e$var$isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    if (!comparator) return null;
    const getSortCellParams = (id)=>({
            id: id,
            field: column.field,
            rowNode: (0, $goCyd.gridRowTreeSelector)(apiRef)[id],
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams: getSortCellParams,
        comparator: comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const $c78f90aae54b126e$var$compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
const $c78f90aae54b126e$export$b29e353d1a72dfda = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>$c78f90aae54b126e$var$parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node: node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>$c78f90aae54b126e$var$compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
const $c78f90aae54b126e$export$b3d84351ab2e3580 = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
const $c78f90aae54b126e$var$gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const $c78f90aae54b126e$var$collator = new Intl.Collator();
const $c78f90aae54b126e$export$db324d0b741f4529 = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === 'string') return $c78f90aae54b126e$var$collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
const $c78f90aae54b126e$export$ecfdaa3722003888 = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
const $c78f90aae54b126e$export$74e685f55e96d6bc = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};

});
parcelRegister("goCyd", function(module, exports) {

$parcel$export(module.exports, "gridRowCountSelector", () => $befccaa56b49492d$export$1641ef9d08e265ca);
$parcel$export(module.exports, "gridRowsLoadingSelector", () => $befccaa56b49492d$export$3c966d405f950b08);
$parcel$export(module.exports, "gridTopLevelRowCountSelector", () => $befccaa56b49492d$export$800ab0a68a9efc4f);
$parcel$export(module.exports, "gridRowsLookupSelector", () => $befccaa56b49492d$export$37767f9110c99048);
$parcel$export(module.exports, "gridRowsDataRowIdToIdLookupSelector", () => $befccaa56b49492d$export$451ff98f7dd9f13f);
$parcel$export(module.exports, "gridRowTreeSelector", () => $befccaa56b49492d$export$de9a43d646a9821d);
$parcel$export(module.exports, "gridRowGroupsToFetchSelector", () => $befccaa56b49492d$export$6c1cdbc7b5e9a3f4);
$parcel$export(module.exports, "gridRowGroupingNameSelector", () => $befccaa56b49492d$export$c263d91fb644e7a0);
$parcel$export(module.exports, "gridRowTreeDepthsSelector", () => $befccaa56b49492d$export$eb24598525413286);
$parcel$export(module.exports, "gridRowMaximumTreeDepthSelector", () => $befccaa56b49492d$export$4cdbe576751dd8e2);
$parcel$export(module.exports, "gridDataRowIdsSelector", () => $befccaa56b49492d$export$c7dcaab5e573753);
$parcel$export(module.exports, "gridPinnedRowsSelector", () => $befccaa56b49492d$export$ffe7071c481e32b0);
$parcel$export(module.exports, "gridPinnedRowsCountSelector", () => $befccaa56b49492d$export$8e3fb3525d7db988);

var $cgQ4y = parcelRequire("cgQ4y");
const $befccaa56b49492d$var$gridRowsStateSelector = (state)=>state.rows;
const $befccaa56b49492d$export$1641ef9d08e265ca = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.totalRowCount);
const $befccaa56b49492d$export$3c966d405f950b08 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.loading);
const $befccaa56b49492d$export$800ab0a68a9efc4f = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
const $befccaa56b49492d$export$37767f9110c99048 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToModelLookup);
const $befccaa56b49492d$export$451ff98f7dd9f13f = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToIdLookup);
const $befccaa56b49492d$export$de9a43d646a9821d = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.tree);
const $befccaa56b49492d$export$6c1cdbc7b5e9a3f4 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.groupsToFetch);
const $befccaa56b49492d$export$c263d91fb644e7a0 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.groupingName);
const $befccaa56b49492d$export$eb24598525413286 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.treeDepths);
const $befccaa56b49492d$export$4cdbe576751dd8e2 = (0, $cgQ4y.createSelectorMemoized)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) return 1;
    return (entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] ?? 0) + 1;
});
const $befccaa56b49492d$export$c7dcaab5e573753 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIds);
const $befccaa56b49492d$export$e8db8ec5e43400fa = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows?.additionalRowGroups);
const $befccaa56b49492d$export$ffe7071c481e32b0 = (0, $cgQ4y.createSelectorMemoized)($befccaa56b49492d$export$e8db8ec5e43400fa, (additionalRowGroups)=>{
    const rawPinnedRows = additionalRowGroups?.pinnedRows;
    return {
        bottom: rawPinnedRows?.bottom?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? [],
        top: rawPinnedRows?.top?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? []
    };
});
const $befccaa56b49492d$export$8e3fb3525d7db988 = (0, $cgQ4y.createSelector)($befccaa56b49492d$export$ffe7071c481e32b0, (pinnedRows)=>{
    return (pinnedRows?.top?.length || 0) + (pinnedRows?.bottom?.length || 0);
});

});


parcelRegister("hKY94", function(module, exports) {

$parcel$export(module.exports, "getGridStringQuickFilterFn", () => $ced5632839836707$export$4326c0ebf0c2f84b);
$parcel$export(module.exports, "getGridStringOperators", () => $ced5632839836707$export$dff3a5bcde5c5e41);

var $g7hyo = parcelRequire("g7hyo");

var $lR3Vo = parcelRequire("lR3Vo");

var $6tiPX = parcelRequire("6tiPX");

var $14dIX = parcelRequire("14dIX");
const $ced5632839836707$export$4326c0ebf0c2f84b = (value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, $lR3Vo.escapeRegExp)(value), 'i');
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = (0, $14dIX.removeDiacritics)(columnValue);
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
};
const $ced5632839836707$var$createContainsFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const filterRegex = new RegExp((0, $lR3Vo.escapeRegExp)(trimmedValue), 'i');
        return (value)=>{
            if (value == null) return negate;
            const matches = filterRegex.test(String(value));
            return negate ? !matches : matches;
        };
    };
const $ced5632839836707$var$createEqualityFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const collator = new Intl.Collator(undefined, {
            sensitivity: 'base',
            usage: 'search'
        });
        return (value)=>{
            if (value == null) return negate;
            const isEqual = collator.compare(trimmedValue, value.toString()) === 0;
            return negate ? !isEqual : isEqual;
        };
    };
const $ced5632839836707$var$createEmptyFilterFn = (negate)=>()=>{
        return (value)=>{
            const isEmpty = value === '' || value == null;
            return negate ? !isEmpty : isEmpty;
        };
    };
const $ced5632839836707$export$dff3a5bcde5c5e41 = (disableTrim = false)=>[
        {
            value: 'contains',
            getApplyFilterFn: $ced5632839836707$var$createContainsFilterFn(disableTrim, false),
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'doesNotContain',
            getApplyFilterFn: $ced5632839836707$var$createContainsFilterFn(disableTrim, true),
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'equals',
            getApplyFilterFn: $ced5632839836707$var$createEqualityFilterFn(disableTrim, false),
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'doesNotEqual',
            getApplyFilterFn: $ced5632839836707$var$createEqualityFilterFn(disableTrim, true),
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'startsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, $lR3Vo.escapeRegExp)(filterItemValue)}.*$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'endsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, $lR3Vo.escapeRegExp)(filterItemValue)}$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: $ced5632839836707$var$createEmptyFilterFn(false),
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: $ced5632839836707$var$createEmptyFilterFn(true),
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || '') === 0;
                    }) : false;
            },
            InputComponent: (0, $6tiPX.GridFilterInputMultipleValue)
        }
    ];

});
parcelRegister("g7hyo", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputValue", () => $bbbaea9771a9f69f$export$99d1f108a3f21b3);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $auC0X = parcelRequire("auC0X");

var $lHOu3 = parcelRequire("lHOu3");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $bbbaea9771a9f69f$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "clearButton",
    "InputProps",
    "variant"
];
function $bbbaea9771a9f69f$export$99d1f108a3f21b3(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, disabled: disabled, clearButton: clearButton, InputProps: InputProps, variant: variant = 'standard' } = props, others = (0, $1En50.default)(props, $bbbaea9771a9f69f$var$_excluded);
    const filterTimeout = (0, $lHOu3.default)();
    const [filterValueState, setFilterValueState] = $acw62.useState($bbbaea9771a9f69f$var$sanitizeFilterItemValue(item.value));
    const [applying, setIsApplying] = $acw62.useState(false);
    const id = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const onFilterChange = $acw62.useCallback((event)=>{
        const value = $bbbaea9771a9f69f$var$sanitizeFilterItemValue(event.target.value);
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = (0, $8nd05.default)({}, item, {
                value: type === 'number' && !Number.isNaN(Number(value)) ? Number(value) : value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        filterTimeout,
        rootProps.filterDebounceMs,
        item,
        type,
        id,
        applyValue
    ]);
    $acw62.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || item.value == null) setFilterValueState($bbbaea9771a9f69f$var$sanitizeFilterItemValue(item.value));
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState ?? '',
        onChange: onFilterChange,
        variant: variant,
        type: type || 'text',
        InputProps: (0, $8nd05.default)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $8nd05.default)({
                tabIndex: tabIndex
            }, InputProps?.inputProps)
        }),
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef
    }, others, rootProps.slotProps?.baseTextField));
}
function $bbbaea9771a9f69f$var$sanitizeFilterItemValue(value) {
    if (value == null || value === '') return undefined;
    return String(value);
}

});

parcelRegister("lR3Vo", function(module, exports) {

$parcel$export(module.exports, "isNumber", () => $fe919794eb3b24e8$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $fe919794eb3b24e8$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isObject", () => $fe919794eb3b24e8$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "localStorageAvailable", () => $fe919794eb3b24e8$export$c43914e0cb16a981);
$parcel$export(module.exports, "escapeRegExp", () => $fe919794eb3b24e8$export$7c57da42ce8e346f);
$parcel$export(module.exports, "clamp", () => $fe919794eb3b24e8$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "range", () => $fe919794eb3b24e8$export$d02631cccf789723);
$parcel$export(module.exports, "isDeepEqual", () => $fe919794eb3b24e8$export$78fdc9adc3f30400);
$parcel$export(module.exports, "createRandomNumberGenerator", () => $fe919794eb3b24e8$export$90ad2d37c2cc187e);
$parcel$export(module.exports, "deepClone", () => $fe919794eb3b24e8$export$b7d58db314e0ac27);
$parcel$export(module.exports, "eslintUseValue", () => $fe919794eb3b24e8$export$ec5767fa5c351320);
$parcel$export(module.exports, "runIf", () => $fe919794eb3b24e8$export$f546127afff6208d);
function $fe919794eb3b24e8$export$7e4aa119212bc614(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
function $fe919794eb3b24e8$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $fe919794eb3b24e8$export$a6cdc56e425d0d0a(value) {
    return typeof value === 'object' && value !== null;
}
function $fe919794eb3b24e8$export$c43914e0cb16a981() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = '__some_random_key_you_are_not_going_to_use__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function $fe919794eb3b24e8$export$7c57da42ce8e346f(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
const $fe919794eb3b24e8$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(max, value));
function $fe919794eb3b24e8$export$d02631cccf789723(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
function $fe919794eb3b24e8$export$78fdc9adc3f30400(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!$fe919794eb3b24e8$export$78fdc9adc3f30400(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!$fe919794eb3b24e8$export$78fdc9adc3f30400(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!$fe919794eb3b24e8$export$78fdc9adc3f30400(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}
// Pseudo random number. See https://stackoverflow.com/a/47593316
function $fe919794eb3b24e8$var$mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
function $fe919794eb3b24e8$export$90ad2d37c2cc187e(seed) {
    const random = $fe919794eb3b24e8$var$mulberry32(seed);
    return (min, max)=>min + (max - min) * random();
}
function $fe919794eb3b24e8$export$b7d58db314e0ac27(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
function $fe919794eb3b24e8$export$ec5767fa5c351320(_) {}
const $fe919794eb3b24e8$export$f546127afff6208d = (condition, fn)=>(params)=>{
        if (condition) fn(params);
    };

});

parcelRegister("6tiPX", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputMultipleValue", () => $4b64102825ff1e40$export$fec959c3691e0645);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $cFBau = parcelRequire("cFBau");

var $auC0X = parcelRequire("auC0X");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $4b64102825ff1e40$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
], $4b64102825ff1e40$var$_excluded2 = [
    "key"
];
function $4b64102825ff1e40$export$fec959c3691e0645(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $4b64102825ff1e40$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const [filterValueState, setFilterValueState] = $acw62.useState(item.value || []);
    const id = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    $acw62.useEffect(()=>{
        const itemValue = item.value ?? [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = $acw62.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, $8nd05.default)({}, item, {
            value: [
                ...value.map((filterItemValue)=>type === 'number' ? Number(filterItemValue) : filterItemValue)
            ]
        }));
    }, [
        applyValue,
        item,
        type
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), (0, $8nd05.default)({
        multiple: true,
        freeSolo: true,
        options: [],
        filterOptions: (options, params)=>{
            const { inputValue: inputValue } = params;
            return inputValue == null || inputValue === '' ? [] : [
                inputValue
            ];
        },
        id: id,
        value: filterValueState,
        onChange: handleChange,
        renderTags: (value, getTagProps)=>value.map((option, index)=>{
                const _getTagProps = getTagProps({
                    index: index
                }), { key: key } = _getTagProps, tagProps = (0, $1En50.default)(_getTagProps, $4b64102825ff1e40$var$_excluded2);
                return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseChip, (0, $8nd05.default)({
                    variant: "outlined",
                    size: "small",
                    label: option
                }, tagProps), key);
            }),
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: (0, $8nd05.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: type || 'text'
            }, TextFieldProps, rootProps.slotProps?.baseTextField))
    }, other));
}

});

parcelRegister("14dIX", function(module, exports) {

$parcel$export(module.exports, "cleanFilterItem", () => $0c70cf7c1343c218$export$eb76493d113de092);
$parcel$export(module.exports, "sanitizeFilterModel", () => $0c70cf7c1343c218$export$2a370a0aad2ac7e1);
$parcel$export(module.exports, "mergeStateWithFilterModel", () => $0c70cf7c1343c218$export$f4189e6c713e6dd8);
$parcel$export(module.exports, "removeDiacritics", () => $0c70cf7c1343c218$export$626da389515c02b3);
$parcel$export(module.exports, "shouldQuickFilterExcludeHiddenColumns", () => $0c70cf7c1343c218$export$cabca178b367efe0);
$parcel$export(module.exports, "buildAggregatedFilterApplier", () => $0c70cf7c1343c218$export$1c795c7c9654905e);
$parcel$export(module.exports, "passFilterLogic", () => $0c70cf7c1343c218$export$8d82b4490466f182);

var $8nd05 = parcelRequire("8nd05");


var $9jXuN = parcelRequire("9jXuN");

var $l4QMb = parcelRequire("l4QMb");

var $dmvst = parcelRequire("dmvst");

var $jQEEt = parcelRequire("jQEEt");
let $0c70cf7c1343c218$var$hasEval;
function $0c70cf7c1343c218$var$getHasEval() {
    if ($0c70cf7c1343c218$var$hasEval !== undefined) return $0c70cf7c1343c218$var$hasEval;
    try {
        $0c70cf7c1343c218$var$hasEval = new Function('return true')();
    } catch (_) {
        $0c70cf7c1343c218$var$hasEval = false;
    }
    return $0c70cf7c1343c218$var$hasEval;
}
const $0c70cf7c1343c218$export$eb76493d113de092 = (item, apiRef)=>{
    const cleanItem = (0, $8nd05.default)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operator == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, $jQEEt.gridColumnLookupSelector)(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
const $0c70cf7c1343c218$export$2a370a0aad2ac7e1 = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) items = [
        model.items[0]
    ];
    else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operator == null);
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, $8nd05.default)({}, model, {
        items: items.map((item)=>$0c70cf7c1343c218$export$eb76493d113de092(item, apiRef))
    });
    if (model.items !== items) return (0, $8nd05.default)({}, model, {
        items: items
    });
    return model;
};
const $0c70cf7c1343c218$export$f4189e6c713e6dd8 = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, $8nd05.default)({}, filteringState, {
            filterModel: $0c70cf7c1343c218$export$2a370a0aad2ac7e1(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
const $0c70cf7c1343c218$export$626da389515c02b3 = (value)=>{
    if (typeof value === 'string') return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value;
};
const $0c70cf7c1343c218$var$getFilterCallbackFromItem = (filterItem, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? filterItem.value?.map((x)=>parser(x, undefined, column, apiRef)) : parser(filterItem.value, undefined, column, apiRef);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = $0c70cf7c1343c218$export$626da389515c02b3(parsedValue);
    const newFilterItem = (0, $8nd05.default)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!filterOperators?.length) throw new Error(`MUI X: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI X: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const publicApiRef = (0, $dmvst.getPublicApiRef)(apiRef);
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== 'function') return null;
    return {
        item: newFilterItem,
        fn: (row)=>{
            let value = apiRef.current.getRowValue(row, column);
            if (ignoreDiacritics) value = $0c70cf7c1343c218$export$626da389515c02b3(value);
            return applyFilterOnRow(value, row, column, publicApiRef);
        }
    };
};
let $0c70cf7c1343c218$var$filterItemsApplierId = 1;
/**
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $0c70cf7c1343c218$var$buildAggregatedFilterItemsApplier = (filterModel, apiRef, disableEval)=>{
    const { items: items } = filterModel;
    const appliers = items.map((item)=>$0c70cf7c1343c218$var$getFilterCallbackFromItem(item, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    if (disableEval || !$0c70cf7c1343c218$var$getHasEval()) // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.fn(row);
        }
        return resultPerItemId;
    };
    // We generate a new function with `new Function()` to avoid expensive patterns for JS engines
    // such as a dynamic object assignment, for example `{ [dynamicKey]: value }`.
    const filterItemCore = new Function('appliers', 'row', 'shouldApplyFilter', `"use strict";
${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

const result$$ = {
${appliers.map((applier, i)=>`  ${JSON.stringify(String(applier.item.id))}: !shouldApply${i} ? false : appliers[${i}].fn(row),`).join('\n')}
};

return result$$;`.replaceAll('$$', String($0c70cf7c1343c218$var$filterItemsApplierId)));
    $0c70cf7c1343c218$var$filterItemsApplierId += 1;
    // Assign to the arrow function a name to help debugging
    const filterItem = (row, shouldApplyItem)=>filterItemCore(appliers, row, shouldApplyItem);
    return filterItem;
};
const $0c70cf7c1343c218$export$cabca178b367efe0 = (filterModel)=>{
    return filterModel.quickFilterExcludeHiddenColumns ?? true;
};
/**
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $0c70cf7c1343c218$var$buildAggregatedQuickFilterApplier = (filterModel, apiRef)=>{
    const quickFilterValues = filterModel.quickFilterValues?.filter(Boolean) ?? [];
    if (quickFilterValues.length === 0) return null;
    const columnFields = $0c70cf7c1343c218$export$cabca178b367efe0(filterModel) ? (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef) : (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
    const appliersPerField = [];
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = (0, $dmvst.getPublicApiRef)(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column?.getApplyQuickFilterFn;
        if (getApplyQuickFilterFn) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $0c70cf7c1343c218$export$626da389515c02b3(quickFilterValue) : quickFilterValue;
                return {
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
        const result = {};
        /* eslint-disable no-labels */ outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column: column, appliers: appliers } = appliersPerField[i];
                const { field: field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = apiRef.current.getRowValue(row, column);
                if (applier.fn === null) continue;
                if (ignoreDiacritics) value = $0c70cf7c1343c218$export$626da389515c02b3(value);
                const isMatching = applier.fn(value, row, column, publicApiRef);
                if (isMatching) {
                    result[filterValue] = true;
                    continue outer;
                }
            }
            result[filterValue] = false;
        }
        return result;
    };
};
const $0c70cf7c1343c218$export$1c795c7c9654905e = (filterModel, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = $0c70cf7c1343c218$var$buildAggregatedFilterItemsApplier(filterModel, apiRef, disableEval);
    const isRowMatchingQuickFilter = $0c70cf7c1343c218$var$buildAggregatedQuickFilterApplier(filterModel, apiRef);
    return function isRowMatchingFilters(row, shouldApplyFilter, result) {
        result.passingFilterItems = isRowMatchingFilterItems?.(row, shouldApplyFilter) ?? null;
        result.passingQuickFilterValues = isRowMatchingQuickFilter?.(row, shouldApplyFilter) ?? null;
    };
};
const $0c70cf7c1343c218$var$isNotNull = (result)=>result != null;
const $0c70cf7c1343c218$var$filterModelItems = (cache, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>$0c70cf7c1343c218$var$getFilterCallbackFromItem(item, apiRef) !== null);
    return cache.cleanedFilterItems;
};
const $0c70cf7c1343c218$export$8d82b4490466f182 = (allFilterItemResults, allQuickFilterResults, filterModel, apiRef, cache)=>{
    const cleanedFilterItems = $0c70cf7c1343c218$var$filterModelItems(cache, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter($0c70cf7c1343c218$var$isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter($0c70cf7c1343c218$var$isNotNull);
    // get result for filter items model
    if (cleanedFilterItemResults.length > 0) {
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        const logicOperator = filterModel.logicOperator ?? (0, $l4QMb.getDefaultGridFilterModel)().logicOperator;
        if (logicOperator === (0, $9jXuN.GridLogicOperator).And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    // get result for quick filter model
    if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        const quickFilterLogicOperator = filterModel.quickFilterLogicOperator ?? (0, $l4QMb.getDefaultGridFilterModel)().quickFilterLogicOperator;
        if (quickFilterLogicOperator === (0, $9jXuN.GridLogicOperator).And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};

});
parcelRegister("9jXuN", function(module, exports) {

$parcel$export(module.exports, "GridLogicOperator", () => $6c940a0517b1c6d5$export$90be184ccbab1c7a);
/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */ var $6c940a0517b1c6d5$export$90be184ccbab1c7a = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}($6c940a0517b1c6d5$export$90be184ccbab1c7a || {});

});

parcelRegister("l4QMb", function(module, exports) {

$parcel$export(module.exports, "defaultGridFilterLookup", () => $f582e8f6fdde33c9$export$f5e27122a659c0c);
$parcel$export(module.exports, "getDefaultGridFilterModel", () => $f582e8f6fdde33c9$export$7ea23129b8e10cdb);

var $9jXuN = parcelRequire("9jXuN");
const $f582e8f6fdde33c9$export$f5e27122a659c0c = {
    filteredRowsLookup: {},
    filteredChildrenCountLookup: {},
    filteredDescendantCountLookup: {}
};
const $f582e8f6fdde33c9$export$7ea23129b8e10cdb = ()=>({
        items: [],
        logicOperator: (0, $9jXuN.GridLogicOperator).And,
        quickFilterValues: [],
        quickFilterLogicOperator: (0, $9jXuN.GridLogicOperator).And
    }); /**
 * @param {GridRowId} rowId The id of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 */  /**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */ 

});

parcelRegister("dmvst", function(module, exports) {

$parcel$export(module.exports, "getPublicApiRef", () => $9ba5bb68a0cac1c6$export$fbb0da9fc679f98a);
function $9ba5bb68a0cac1c6$export$fbb0da9fc679f98a(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}

});




parcelRegister("e79LH", function(module, exports) {

$parcel$export(module.exports, "GRID_NUMERIC_COL_DEF", () => $a4694bea3e886bc3$export$ba08f73736670f91);

var $8nd05 = parcelRequire("8nd05");

var $h8fXG = parcelRequire("h8fXG");

var $lR3Vo = parcelRequire("lR3Vo");

var $8SI7h = parcelRequire("8SI7h");

var $bSL2h = parcelRequire("bSL2h");
const $a4694bea3e886bc3$export$ba08f73736670f91 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'number',
    align: 'right',
    headerAlign: 'right',
    sortComparator: (0, $h8fXG.gridNumberComparator),
    valueParser: (value)=>value === '' ? null : Number(value),
    valueFormatter: (value)=>(0, $lR3Vo.isNumber)(value) ? value.toLocaleString() : value || '',
    filterOperators: (0, $8SI7h.getGridNumericOperators)(),
    getApplyQuickFilterFn: (0, $8SI7h.getGridNumericQuickFilterFn)
});

});
parcelRegister("8SI7h", function(module, exports) {

$parcel$export(module.exports, "getGridNumericQuickFilterFn", () => $67759673d54fca41$export$78c55b2f3096aac8);
$parcel$export(module.exports, "getGridNumericOperators", () => $67759673d54fca41$export$37d963e5ee49abc6);

var $g7hyo = parcelRequire("g7hyo");

var $6tiPX = parcelRequire("6tiPX");
const $67759673d54fca41$var$parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const $67759673d54fca41$export$78c55b2f3096aac8 = (value)=>{
    if (value == null || Number.isNaN(value) || value === '') return null;
    return (columnValue)=>{
        return $67759673d54fca41$var$parseNumericValue(columnValue) === $67759673d54fca41$var$parseNumericValue(value);
    };
};
const $67759673d54fca41$export$37d963e5ee49abc6 = ()=>[
        {
            value: '=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $67759673d54fca41$var$parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '!=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $67759673d54fca41$var$parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return (value)=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: (0, $6tiPX.GridFilterInputMultipleValue),
            InputComponentProps: {
                type: 'number'
            }
        }
    ];

});


parcelRegister("axs1H", function(module, exports) {

$parcel$export(module.exports, "GRID_DATE_COL_DEF", () => $7ac2b9e608be0423$export$4c3b89749ea40e50);
$parcel$export(module.exports, "GRID_DATETIME_COL_DEF", () => $7ac2b9e608be0423$export$5bc7079eed6f3d7f);

var $8nd05 = parcelRequire("8nd05");

var $h8fXG = parcelRequire("h8fXG");

var $5GOJA = parcelRequire("5GOJA");

var $bSL2h = parcelRequire("bSL2h");

var $3D30W = parcelRequire("3D30W");

var $180lm = parcelRequire("180lm");
function $7ac2b9e608be0423$var$throwIfNotDateObject({ value: value, columnType: columnType, rowId: rowId, field: field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI X: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        'Use `valueGetter` to transform the value into a `Date` object.',
        `Row ID: ${rowId}, field: "${field}".`
    ].join('\n'));
}
const $7ac2b9e608be0423$export$c46cd449e66842a5 = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $180lm.gridRowIdSelector)(apiRef.current.state, row);
    $7ac2b9e608be0423$var$throwIfNotDateObject({
        value: value,
        columnType: 'date',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleDateString();
};
const $7ac2b9e608be0423$export$a62990620750ce8c = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $180lm.gridRowIdSelector)(apiRef.current.state, row);
    $7ac2b9e608be0423$var$throwIfNotDateObject({
        value: value,
        columnType: 'dateTime',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleString();
};
const $7ac2b9e608be0423$export$4c3b89749ea40e50 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'date',
    sortComparator: (0, $h8fXG.gridDateComparator),
    valueFormatter: $7ac2b9e608be0423$export$c46cd449e66842a5,
    filterOperators: (0, $5GOJA.getGridDateOperators)(),
    renderEditCell: (0, $3D30W.renderEditDateCell),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});
const $7ac2b9e608be0423$export$5bc7079eed6f3d7f = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'dateTime',
    sortComparator: (0, $h8fXG.gridDateComparator),
    valueFormatter: $7ac2b9e608be0423$export$a62990620750ce8c,
    filterOperators: (0, $5GOJA.getGridDateOperators)(true),
    renderEditCell: (0, $3D30W.renderEditDateCell),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});

});
parcelRegister("5GOJA", function(module, exports) {

$parcel$export(module.exports, "getGridDateOperators", () => $42483ac831686fc7$export$2fa54515db89172d);

var $5y3Nn = parcelRequire("5y3Nn");
function $42483ac831686fc7$var$buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const date = new Date(filterItem.value);
    if (showTime) date.setSeconds(0, 0);
    else {
        // In GMT-X timezone, the date will be one day behind.
        // For 2022-08-16:
        // GMT+2: Tue Aug 16 2022 02:00:00 GMT+0200
        // GMT-4: Mon Aug 15 2022 20:00:00 GMT-0400
        //
        // We need to add the offset before resetting the hours.
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        date.setHours(0, 0, 0, 0);
    }
    const time = date.getTime();
    return (value)=>{
        if (!value) return false;
        if (keepHours) return compareFn(value.getTime(), time);
        // Make a copy of the date to not reset the hours in the original object
        const dateCopy = new Date(value);
        if (showTime) dateCopy.setSeconds(0, 0);
        else dateCopy.setHours(0, 0, 0, 0);
        return compareFn(dateCopy.getTime(), time);
    };
}
const $42483ac831686fc7$export$2fa54515db89172d = (showTime)=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'after',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrAfter',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'before',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrBefore',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ];

});
parcelRegister("5y3Nn", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputDate", () => $40a3126b9e135d1e$export$f82b14e11ca0a1b4);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $auC0X = parcelRequire("auC0X");

var $lHOu3 = parcelRequire("lHOu3");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $40a3126b9e135d1e$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "InputProps",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "disabled"
];
function $40a3126b9e135d1e$var$convertFilterItemValueToInputValue(itemValue, inputType) {
    if (itemValue == null) return '';
    const dateCopy = new Date(itemValue);
    if (Number.isNaN(dateCopy.getTime())) return '';
    if (inputType === 'date') return dateCopy.toISOString().substring(0, 10);
    if (inputType === 'datetime-local') {
        // The date picker expects the date to be in the local timezone.
        // But .toISOString() converts it to UTC with zero offset.
        // So we need to subtract the timezone offset.
        dateCopy.setMinutes(dateCopy.getMinutes() - dateCopy.getTimezoneOffset());
        return dateCopy.toISOString().substring(0, 19);
    }
    return dateCopy.toISOString().substring(0, 10);
}
function $40a3126b9e135d1e$export$f82b14e11ca0a1b4(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, InputProps: InputProps, clearButton: clearButton, tabIndex: tabIndex, disabled: disabled } = props, other = (0, $1En50.default)(props, $40a3126b9e135d1e$var$_excluded);
    const filterTimeout = (0, $lHOu3.default)();
    const [filterValueState, setFilterValueState] = $acw62.useState(()=>$40a3126b9e135d1e$var$convertFilterItemValueToInputValue(item.value, type));
    const [applying, setIsApplying] = $acw62.useState(false);
    const id = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const onFilterChange = $acw62.useCallback((event)=>{
        filterTimeout.clear();
        const value = event.target.value;
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const date = new Date(value);
            applyValue((0, $8nd05.default)({}, item, {
                value: Number.isNaN(date.getTime()) ? undefined : date
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $acw62.useEffect(()=>{
        const value = $40a3126b9e135d1e$var$convertFilterItemValueToInputValue(item.value, type);
        setFilterValueState(value);
    }, [
        item.value,
        type
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({
        fullWidth: true,
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || 'text',
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef,
        InputProps: (0, $8nd05.default)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $8nd05.default)({
                max: type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31',
                tabIndex: tabIndex
            }, InputProps?.inputProps)
        })
    }, other, rootProps.slotProps?.baseTextField));
}

});


parcelRegister("3D30W", function(module, exports) {

$parcel$export(module.exports, "renderEditDateCell", () => $2a475a2a246869fc$export$b815d37f7a90225c);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");

var $95gUw = parcelRequire("95gUw");

var $d8seH = parcelRequire("d8seH");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $2a475a2a246869fc$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange"
];
const $2a475a2a246869fc$var$StyledInputBase = (0, $d8seH.default)((0, $95gUw.default))({
    fontSize: 'inherit'
});
const $2a475a2a246869fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $2a475a2a246869fc$export$b4fb7433f4444e3f(props) {
    const { id: id, value: valueProp, field: field, colDef: colDef, hasFocus: hasFocus, inputProps: inputProps, onValueChange: onValueChange } = props, other = (0, $1En50.default)(props, $2a475a2a246869fc$var$_excluded);
    const isDateTime = colDef.type === 'dateTime';
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $acw62.useRef(null);
    const valueTransformed = $acw62.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp ?? '').toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = '';
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = $acw62.useState(valueTransformed);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $2a475a2a246869fc$var$useUtilityClasses(ownerState);
    const parseValueToDate = $acw62.useCallback((value)=>{
        if (value === '') return null;
        const [date, time] = value.split('T');
        const [year, month, day] = date.split('-');
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(':');
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    $acw62.useEffect(()=>{
        setValueState((state)=>{
            if (valueTransformed.parsed !== state.parsed && valueTransformed.parsed?.getTime() !== state.parsed?.getTime()) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, $eEJPp.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2a475a2a246869fc$var$StyledInputBase, (0, $8nd05.default)({
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? 'datetime-local' : 'date',
        inputProps: (0, $8nd05.default)({
            max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
        }, inputProps),
        value: valueState.formatted,
        onChange: handleChange
    }, other));
}
const $2a475a2a246869fc$export$b815d37f7a90225c = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2a475a2a246869fc$export$b4fb7433f4444e3f, (0, $8nd05.default)({}, params));

});

parcelRegister("180lm", function(module, exports) {

$parcel$export(module.exports, "gridRowIdSelector", () => $0d26ce0880758663$export$5e766ecd73f055ed);

var $7sDf4 = parcelRequire("7sDf4");
const $0d26ce0880758663$export$5e766ecd73f055ed = (state, row)=>{
    if ((0, $7sDf4.GRID_ID_AUTOGENERATED) in row) return row[0, $7sDf4.GRID_ID_AUTOGENERATED];
    return state.props.getRowId ? state.props.getRowId(row) : row.id;
};

});
parcelRegister("7sDf4", function(module, exports) {

$parcel$export(module.exports, "GRID_ROOT_GROUP_ID", () => $0166dd44615cae0d$export$433b924dc2506913);
$parcel$export(module.exports, "GRID_ID_AUTOGENERATED", () => $0166dd44615cae0d$export$e8632b32bb8837db);
$parcel$export(module.exports, "buildRootGroup", () => $0166dd44615cae0d$export$96a607054e9bfd0c);
$parcel$export(module.exports, "getRowIdFromRowModel", () => $0166dd44615cae0d$export$a95fb784d0ca2e72);
$parcel$export(module.exports, "createRowsInternalCache", () => $0166dd44615cae0d$export$3496927f169f2d35);
$parcel$export(module.exports, "getTopLevelRowCount", () => $0166dd44615cae0d$export$e6ee03f0394a9759);
$parcel$export(module.exports, "getRowsStateFromCache", () => $0166dd44615cae0d$export$4dcb6d8dd06e4f39);
$parcel$export(module.exports, "isAutogeneratedRowNode", () => $0166dd44615cae0d$export$5f983e16b1e55860);
$parcel$export(module.exports, "getTreeNodeDescendants", () => $0166dd44615cae0d$export$9380f4bcafb87e49);
$parcel$export(module.exports, "updateCacheWithNewRows", () => $0166dd44615cae0d$export$b593607f8b00d104);
$parcel$export(module.exports, "minimalContentHeight", () => $0166dd44615cae0d$export$a95780409968416e);
$parcel$export(module.exports, "computeRowsUpdates", () => $0166dd44615cae0d$export$1560eaf12ed72130);
$parcel$export(module.exports, "getValidRowHeight", () => $0166dd44615cae0d$export$fa15c17c0798a441);
$parcel$export(module.exports, "rowHeightWarning", () => $0166dd44615cae0d$export$abf6a2a1a7dde56b);
$parcel$export(module.exports, "getRowHeightWarning", () => $0166dd44615cae0d$export$b35665e48a78b958);

var $8nd05 = parcelRequire("8nd05");
const $0166dd44615cae0d$export$433b924dc2506913 = `auto-generated-group-node-root`;
const $0166dd44615cae0d$export$e8632b32bb8837db = Symbol('mui.id_autogenerated');
const $0166dd44615cae0d$export$96a607054e9bfd0c = ()=>({
        type: 'group',
        id: $0166dd44615cae0d$export$433b924dc2506913,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
function $0166dd44615cae0d$export$de0419c0281531ca(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
    if (id == null) throw new Error([
        'MUI X: The Data Grid component requires all rows to have a unique `id` property.',
        'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.',
        detailErrorMessage,
        JSON.stringify(row)
    ].join('\n'));
}
const $0166dd44615cae0d$export$a95fb784d0ca2e72 = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    $0166dd44615cae0d$export$de0419c0281531ca(id, rowModel, detailErrorMessage);
    return id;
};
const $0166dd44615cae0d$export$3496927f169f2d35 = ({ rows: rows, getRowId: getRowId, loading: loading, rowCount: rowCount })=>{
    const updates = {
        type: 'full',
        rows: []
    };
    const dataRowIdToModelLookup = {};
    const dataRowIdToIdLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = $0166dd44615cae0d$export$a95fb784d0ca2e72(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        dataRowIdToIdLookup[id] = id;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates: updates,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        dataRowIdToModelLookup: dataRowIdToModelLookup
    };
};
const $0166dd44615cae0d$export$e6ee03f0394a9759 = ({ tree: tree, rowCountProp: rowCountProp = 0 })=>{
    const rootGroupNode = tree[$0166dd44615cae0d$export$433b924dc2506913];
    return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
const $0166dd44615cae0d$export$4dcb6d8dd06e4f39 = ({ apiRef: apiRef, rowCountProp: rowCountProp = 0, loadingProp: loadingProp, previousTree: previousTree, previousTreeDepths: previousTreeDepths, previousGroupsToFetch: previousGroupsToFetch })=>{
    const cache = apiRef.current.caches.rows;
    // 1. Apply the "rowTreeCreation" family processing.
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName: groupingName, groupsToFetch: groupsToFetch = [] } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
        previousTree: previousTree,
        previousTreeDepths: previousTreeDepths,
        updates: cache.updates,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup,
        previousGroupsToFetch: previousGroupsToFetch
    });
    // 2. Apply the "hydrateRows" pipe-processing.
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 3. Reset the cache updates
    apiRef.current.caches.rows.updates = {
        type: 'partial',
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return (0, $8nd05.default)({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: $0166dd44615cae0d$export$e6ee03f0394a9759({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp: rowCountProp
        }),
        groupingName: groupingName,
        loading: loadingProp,
        groupsToFetch: groupsToFetch
    });
};
const $0166dd44615cae0d$export$fe02ef72917d9a07 = (row)=>$0166dd44615cae0d$export$e8632b32bb8837db in row;
const $0166dd44615cae0d$export$5f983e16b1e55860 = (rowNode)=>rowNode.type === 'skeletonRow' || rowNode.type === 'footer' || rowNode.type === 'group' && rowNode.isAutoGenerated || rowNode.type === 'pinnedRow' && rowNode.isAutoGenerated;
const $0166dd44615cae0d$export$9380f4bcafb87e49 = (tree, parentId, skipAutoGeneratedRows)=>{
    const node = tree[parentId];
    if (node.type !== 'group') return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !$0166dd44615cae0d$export$5f983e16b1e55860(tree[child])) validDescendants.push(child);
        const childDescendants = $0166dd44615cae0d$export$9380f4bcafb87e49(tree, child, skipAutoGeneratedRows);
        for(let j = 0; j < childDescendants.length; j += 1)validDescendants.push(childDescendants[j]);
    }
    if (!skipAutoGeneratedRows && node.footerId != null) validDescendants.push(node.footerId);
    return validDescendants;
};
const $0166dd44615cae0d$export$b593607f8b00d104 = ({ previousCache: previousCache, getRowId: getRowId, updates: updates, groupKeys: groupKeys })=>{
    if (previousCache.updates.type === 'full') throw new Error('MUI X: Unable to prepare a partial update if a full update is not applied yet.');
    // Remove duplicate updates.
    // A server can batch updates, and send several updates for the same row in one fn call.
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = $0166dd44615cae0d$export$a95fb784d0ca2e72(update, getRowId, 'A row was provided without id when calling updateRows():');
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, $8nd05.default)({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: 'partial',
        actions: {
            insert: [
                ...previousCache.updates.actions.insert ?? []
            ],
            modify: [
                ...previousCache.updates.actions.modify ?? []
            ],
            remove: [
                ...previousCache.updates.actions.remove ?? []
            ]
        },
        idToActionLookup: (0, $8nd05.default)({}, previousCache.updates.idToActionLookup),
        groupKeys: groupKeys
    };
    const dataRowIdToModelLookup = (0, $8nd05.default)({}, previousCache.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = (0, $8nd05.default)({}, previousCache.dataRowIdToIdLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    // Depending on the action already applied to the data row,
    // We might want drop the already-applied-update.
    // For instance:
    // - if you delete then insert, then you don't want to apply the deletion in the tree.
    // - if you insert, then modify, then you just want to apply the insertion in the tree.
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        // Action === "delete"
        // eslint-disable-next-line no-underscore-dangle
        if (partialRow._action === 'delete') {
            // If the data row has been removed since the last state update,
            // Then do nothing.
            if (actionAlreadyAppliedToRow === 'remove' || !dataRowIdToModelLookup[id]) return;
            // If the data row has been inserted / modified since the last state update,
            // Then drop this "insert" / "modify" update.
            if (actionAlreadyAppliedToRow != null) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            // Remove the data row from the lookups and add it to the "delete" update.
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            delete dataRowIdToIdLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        // Action === "modify"
        if (oldRow) {
            // If the data row has been removed since the last state update,
            // Then drop this "remove" update and add it to the "modify" update instead.
            if (actionAlreadyAppliedToRow === 'remove') {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.modify.push(id);
            // Update the data row lookups.
            dataRowIdToModelLookup[id] = (0, $8nd05.default)({}, oldRow, partialRow);
            return;
        }
        // Action === "insert"
        // If the data row has been removed since the last state update,
        // Then drop the "remove" update and add it to the "insert" update instead.
        if (actionAlreadyAppliedToRow === 'remove') {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.insert.push(id);
        // Update the data row lookups.
        dataRowIdToModelLookup[id] = partialRow;
        dataRowIdToIdLookup[id] = id;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
const $0166dd44615cae0d$export$a95780409968416e = 'var(--DataGrid-overlayHeight, calc(var(--height) * 2))';
function $0166dd44615cae0d$export$1560eaf12ed72130(apiRef, updates, getRowId) {
    const nonPinnedRowsUpdates = [];
    updates.forEach((update)=>{
        const id = $0166dd44615cae0d$export$a95fb784d0ca2e72(update, getRowId, 'A row was provided without id when calling updateRows():');
        const rowNode = apiRef.current.getRowNode(id);
        if (rowNode?.type === 'pinnedRow') {
            // @ts-ignore because otherwise `release:build` doesn't work
            const pinnedRowsCache = apiRef.current.caches.pinnedRows;
            const prevModel = pinnedRowsCache.idLookup[id];
            if (prevModel) pinnedRowsCache.idLookup[id] = (0, $8nd05.default)({}, prevModel, update);
        } else nonPinnedRowsUpdates.push(update);
    });
    return nonPinnedRowsUpdates;
}
let $0166dd44615cae0d$var$warnedOnceInvalidRowHeight = false;
const $0166dd44615cae0d$export$fa15c17c0798a441 = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if (typeof rowHeightProp === 'number' && rowHeightProp > 0) return rowHeightProp;
    return defaultRowHeight;
};
const $0166dd44615cae0d$export$abf6a2a1a7dde56b = [
    `MUI X: The \`rowHeight\` prop should be a number greater than 0.`,
    `The default value will be used instead.`
].join('\n');
const $0166dd44615cae0d$export$b35665e48a78b958 = [
    `MUI X: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`,
    `The default value will be used instead.`
].join('\n');

});



parcelRegister("iNueb", function(module, exports) {

$parcel$export(module.exports, "GRID_BOOLEAN_COL_DEF", () => $daf44030e7d36790$export$220b51460e149ea9);

var $8nd05 = parcelRequire("8nd05");

var $bSL2h = parcelRequire("bSL2h");

var $8vJu2 = parcelRequire("8vJu2");

var $hsZ0E = parcelRequire("hsZ0E");

var $h8fXG = parcelRequire("h8fXG");

var $jWu8a = parcelRequire("jWu8a");
const $daf44030e7d36790$var$gridBooleanFormatter = (value, row, column, apiRef)=>{
    return value ? apiRef.current.getLocaleText('booleanCellTrueLabel') : apiRef.current.getLocaleText('booleanCellFalseLabel');
};
const $daf44030e7d36790$var$stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case 'null':
        case 'undefined':
            return false;
        default:
            return undefined;
    }
};
const $daf44030e7d36790$export$220b51460e149ea9 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'boolean',
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    renderCell: (0, $8vJu2.renderBooleanCell),
    renderEditCell: (0, $hsZ0E.renderEditBooleanCell),
    sortComparator: (0, $h8fXG.gridNumberComparator),
    valueFormatter: $daf44030e7d36790$var$gridBooleanFormatter,
    filterOperators: (0, $jWu8a.getGridBooleanOperators)(),
    getApplyQuickFilterFn: undefined,
    // @ts-ignore
    aggregable: false,
    // @ts-ignore
    pastedValueParser: (value)=>$daf44030e7d36790$var$stringToBoolean(value)
});

});
parcelRegister("8vJu2", function(module, exports) {

$parcel$export(module.exports, "renderBooleanCell", () => $6324800d89fce0fa$export$6c5a2392a8d4c6d6);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $5sOMZ = parcelRequire("5sOMZ");

var $goCyd = parcelRequire("goCyd");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $7sDf4 = parcelRequire("7sDf4");

var $jZka4 = parcelRequire("jZka4");

var $ayMG0 = parcelRequire("ayMG0");
const $6324800d89fce0fa$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex",
    "hideDescendantCount"
];
const $6324800d89fce0fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'booleanCell'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $6324800d89fce0fa$var$GridBooleanCellRaw(props) {
    const { value: value, rowNode: rowNode } = props, other = (0, $1En50.default)(props, $6324800d89fce0fa$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $6324800d89fce0fa$var$useUtilityClasses(ownerState);
    const maxDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowMaximumTreeDepthSelector));
    const isServerSideRowGroupingRow = // @ts-expect-error - Access tree data prop
    maxDepth > 0 && rowNode.type === 'group' && rootProps.treeData === false;
    const Icon = $acw62.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    if (isServerSideRowGroupingRow && value === undefined) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $8nd05.default)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
        "data-value": Boolean(value)
    }, other));
}
const $6324800d89fce0fa$export$9cc4d0e939884340 = /*#__PURE__*/ $acw62.memo($6324800d89fce0fa$var$GridBooleanCellRaw);
const $6324800d89fce0fa$export$6c5a2392a8d4c6d6 = (params)=>{
    if (params.field !== (0, $jZka4.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD) && (0, $7sDf4.isAutogeneratedRowNode)(params.rowNode)) return '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6324800d89fce0fa$export$9cc4d0e939884340, (0, $8nd05.default)({}, params));
};

});
parcelRegister("jZka4", function(module, exports) {

$parcel$export(module.exports, "GRID_TREE_DATA_GROUPING_FIELD", () => $e8d35a7c12bdaa1d$export$9cce4aaa860dd90a);
$parcel$export(module.exports, "GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD", () => $e8d35a7c12bdaa1d$export$bc5b5ba34587442e);
$parcel$export(module.exports, "GRID_DETAIL_PANEL_TOGGLE_FIELD", () => $e8d35a7c12bdaa1d$export$6e5a576305a34719);
$parcel$export(module.exports, "PinnedColumnPosition", () => $e8d35a7c12bdaa1d$export$f35946017bbd5a24);
const $e8d35a7c12bdaa1d$export$9cce4aaa860dd90a = '__tree_data_group__';
const $e8d35a7c12bdaa1d$export$bc5b5ba34587442e = '__row_group_by_columns_group__';
const $e8d35a7c12bdaa1d$export$6e5a576305a34719 = '__detail_panel_toggle__';
let $e8d35a7c12bdaa1d$export$f35946017bbd5a24 = /*#__PURE__*/ function(PinnedColumnPosition) {
    PinnedColumnPosition[PinnedColumnPosition["NONE"] = 0] = "NONE";
    PinnedColumnPosition[PinnedColumnPosition["LEFT"] = 1] = "LEFT";
    PinnedColumnPosition[PinnedColumnPosition["RIGHT"] = 2] = "RIGHT";
    PinnedColumnPosition[PinnedColumnPosition["VIRTUAL"] = 3] = "VIRTUAL";
    return PinnedColumnPosition;
}({});

});


parcelRegister("hsZ0E", function(module, exports) {

$parcel$export(module.exports, "renderEditBooleanCell", () => $cb74606ec716e4c3$export$9ef52be99fb661);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");
var $auC0X = parcelRequire("auC0X");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $cb74606ec716e4c3$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const $cb74606ec716e4c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $cb74606ec716e4c3$export$22bee653ea92336f(props) {
    const { id: idProp, value: value, field: field, className: className, hasFocus: hasFocus, onValueChange: onValueChange } = props, other = (0, $1En50.default)(props, $cb74606ec716e4c3$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $acw62.useRef(null);
    const id = (0, $auC0X.default)();
    const [valueState, setValueState] = $acw62.useState(value);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $cb74606ec716e4c3$var$useUtilityClasses(ownerState);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field: field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    $acw62.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, $eEJPp.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("label", (0, $8nd05.default)({
        htmlFor: id,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $8nd05.default)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, rootProps.slotProps?.baseCheckbox))
    }));
}
const $cb74606ec716e4c3$export$9ef52be99fb661 = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($cb74606ec716e4c3$export$22bee653ea92336f, (0, $8nd05.default)({}, params));

});

parcelRegister("jWu8a", function(module, exports) {

$parcel$export(module.exports, "getGridBooleanOperators", () => $e84ace6ba51eccb1$export$906a46f6c2359ef6);

var $hAdXB = parcelRequire("hAdXB");
const $e84ace6ba51eccb1$export$906a46f6c2359ef6 = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                const sanitizedValue = (0, $hAdXB.sanitizeFilterItemValue)(filterItem.value);
                if (sanitizedValue === undefined) return null;
                return (value)=>Boolean(value) === sanitizedValue;
            },
            InputComponent: (0, $hAdXB.GridFilterInputBoolean)
        }
    ];

});
parcelRegister("hAdXB", function(module, exports) {

$parcel$export(module.exports, "sanitizeFilterItemValue", () => $ccd0a0b443bb9406$export$ed06ceaa973db73f);
$parcel$export(module.exports, "GridFilterInputBoolean", () => $ccd0a0b443bb9406$export$f1030df85ee00af9);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $auC0X = parcelRequire("auC0X");

var $d8seH = parcelRequire("d8seH");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $ccd0a0b443bb9406$var$_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "label",
    "variant",
    "InputLabelProps"
];
const $ccd0a0b443bb9406$export$ed06ceaa973db73f = (value)=>{
    if (String(value).toLowerCase() === 'true') return true;
    if (String(value).toLowerCase() === 'false') return false;
    return undefined;
};
const $ccd0a0b443bb9406$var$BooleanOperatorContainer = (0, $d8seH.default)('div')({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    [`& button`]: {
        margin: 'auto 0px 5px 5px'
    }
});
function $ccd0a0b443bb9406$export$f1030df85ee00af9(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, clearButton: clearButton, tabIndex: tabIndex, label: labelProp, variant: variant = 'standard' } = props, others = (0, $1En50.default)(props, $ccd0a0b443bb9406$var$_excluded);
    const [filterValueState, setFilterValueState] = $acw62.useState($ccd0a0b443bb9406$export$ed06ceaa973db73f(item.value));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const labelId = (0, $auC0X.default)();
    const selectId = (0, $auC0X.default)();
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const onFilterChange = $acw62.useCallback((event)=>{
        const value = $ccd0a0b443bb9406$export$ed06ceaa973db73f(event.target.value);
        setFilterValueState(value);
        applyValue((0, $8nd05.default)({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    $acw62.useEffect(()=>{
        setFilterValueState($ccd0a0b443bb9406$export$ed06ceaa973db73f(item.value));
    }, [
        item.value
    ]);
    const label = labelProp ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ccd0a0b443bb9406$var$BooleanOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputLabel, (0, $8nd05.default)({}, rootProps.slotProps?.baseInputLabel, {
                        id: labelId,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                        labelId: labelId,
                        id: selectId,
                        label: label,
                        value: filterValueState === undefined ? '' : String(filterValueState),
                        onChange: onFilterChange,
                        variant: variant,
                        notched: variant === 'outlined' ? true : undefined,
                        native: isSelectNative,
                        displayEmpty: true,
                        inputProps: {
                            ref: focusElementRef,
                            tabIndex: tabIndex
                        }
                    }, others /* FIXME: typing error */ , baseSelectProps, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "",
                                children: apiRef.current.getLocaleText('filterValueAny')
                            })),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "true",
                                children: apiRef.current.getLocaleText('filterValueTrue')
                            })),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "false",
                                children: apiRef.current.getLocaleText('filterValueFalse')
                            }))
                        ]
                    }))
                ]
            }),
            clearButton
        ]
    });
}

});



parcelRegister("2LzSK", function(module, exports) {

$parcel$export(module.exports, "GRID_SINGLE_SELECT_COL_DEF", () => $203bce01501b8211$export$7acf0d6e5e468a51);

var $8nd05 = parcelRequire("8nd05");

var $bSL2h = parcelRequire("bSL2h");

var $7cMVI = parcelRequire("7cMVI");

var $hIUWG = parcelRequire("hIUWG");

var $5z7Pl = parcelRequire("5z7Pl");

var $lR3Vo = parcelRequire("lR3Vo");

var $180lm = parcelRequire("180lm");
const $203bce01501b8211$var$isArrayOfObjects = (options)=>{
    return typeof options[0] === 'object';
};
const $203bce01501b8211$var$defaultGetOptionValue = (value)=>{
    return (0, $lR3Vo.isObject)(value) ? value.value : value;
};
const $203bce01501b8211$var$defaultGetOptionLabel = (value)=>{
    return (0, $lR3Vo.isObject)(value) ? value.label : String(value);
};
const $203bce01501b8211$export$7acf0d6e5e468a51 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'singleSelect',
    getOptionLabel: $203bce01501b8211$var$defaultGetOptionLabel,
    getOptionValue: $203bce01501b8211$var$defaultGetOptionValue,
    valueFormatter (value, row, colDef, apiRef) {
        const rowId = (0, $180lm.gridRowIdSelector)(apiRef.current.state, row);
        if (!(0, $5z7Pl.isSingleSelectColDef)(colDef)) return '';
        const valueOptions = (0, $5z7Pl.getValueOptions)(colDef, {
            id: rowId,
            row: row
        });
        if (value == null) return '';
        if (!valueOptions) return value;
        if (!$203bce01501b8211$var$isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : '';
    },
    renderEditCell: (0, $7cMVI.renderEditSingleSelectCell),
    filterOperators: (0, $hIUWG.getGridSingleSelectOperators)(),
    // @ts-ignore
    pastedValueParser: (value, row, column)=>{
        const colDef = column;
        const valueOptions = (0, $5z7Pl.getValueOptions)(colDef) || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
        // do not paste the value if it is not in the valueOptions
        return undefined;
    }
});

});
parcelRegister("7cMVI", function(module, exports) {

$parcel$export(module.exports, "renderEditSingleSelectCell", () => $53ef9bd93fd99a94$export$13060fab7d49b7a1);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $eEJPp = parcelRequire("eEJPp");

var $iNfie = parcelRequire("iNfie");

var $jDpXp = parcelRequire("jDpXp");

var $jkRzp = parcelRequire("jkRzp");

var $5z7Pl = parcelRequire("5z7Pl");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $53ef9bd93fd99a94$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen"
], $53ef9bd93fd99a94$var$_excluded2 = [
    "MenuProps"
];
function $53ef9bd93fd99a94$var$isKeyboardEvent(event) {
    return !!event.key;
}
function $53ef9bd93fd99a94$export$df7446df636ddbed(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, value: valueProp, field: field, row: row, colDef: colDef, hasFocus: hasFocus, error: error, onValueChange: onValueChange, initialOpen: initialOpen = rootProps.editMode === (0, $jkRzp.GridEditModes).Cell } = props, other = (0, $1En50.default)(props, $53ef9bd93fd99a94$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ref = $acw62.useRef(null);
    const inputRef = $acw62.useRef(null);
    const [open, setOpen] = $acw62.useState(initialOpen);
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const _ref = rootProps.slotProps?.baseSelect || {}, { MenuProps: MenuProps } = _ref, otherBaseSelectProps = (0, $1En50.default)(_ref, $53ef9bd93fd99a94$var$_excluded2);
    (0, $eEJPp.default)(()=>{
        if (hasFocus) inputRef.current?.focus();
    }, [
        hasFocus
    ]);
    if (!(0, $5z7Pl.isSingleSelectColDef)(colDef)) return null;
    const valueOptions = (0, $5z7Pl.getValueOptions)(colDef, {
        id: id,
        row: row
    });
    if (!valueOptions) return null;
    const getOptionValue = colDef.getOptionValue;
    const getOptionLabel = colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!(0, $5z7Pl.isSingleSelectColDef)(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, $5z7Pl.getValueFromValueOptions)(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === (0, $jkRzp.GridEditModes).Row) {
            setOpen(false);
            return;
        }
        if (reason === 'backdropClick' || event.key === 'Escape') {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', (0, $8nd05.default)({}, params, {
                reason: event.key === 'Escape' ? (0, $iNfie.GridCellEditStopReasons).escapeKeyDown : (0, $iNfie.GridCellEditStopReasons).cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if ($53ef9bd93fd99a94$var$isKeyboardEvent(event) && event.key === 'Enter') return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
        ref: ref,
        inputRef: inputRef,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        MenuProps: (0, $8nd05.default)({
            onClose: handleClose
        }, MenuProps),
        error: error,
        native: isSelectNative,
        fullWidth: true
    }, other, otherBaseSelectProps, {
        children: valueOptions.map((valueOption)=>{
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, rootProps.slotProps?.baseSelectOption || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
const $53ef9bd93fd99a94$export$13060fab7d49b7a1 = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($53ef9bd93fd99a94$export$df7446df636ddbed, (0, $8nd05.default)({}, params));

});
parcelRegister("iNfie", function(module, exports) {

$parcel$export(module.exports, "GridCellEditStartReasons", () => $dae8aa7db1c69e5a$export$66744c3b0d0c6217);
$parcel$export(module.exports, "GridCellEditStopReasons", () => $dae8aa7db1c69e5a$export$73fccbaa325472ee);
/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ var $dae8aa7db1c69e5a$export$66744c3b0d0c6217 = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}($dae8aa7db1c69e5a$export$66744c3b0d0c6217 || {});
/**
 * Params passed to the `cellEditStart` event.
 */ var $dae8aa7db1c69e5a$export$73fccbaa325472ee = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}($dae8aa7db1c69e5a$export$73fccbaa325472ee || {});

});

parcelRegister("jkRzp", function(module, exports) {

$parcel$export(module.exports, "GridEditModes", () => $e139707caeafbfd6$export$bad6b7a934346f26);
$parcel$export(module.exports, "GridCellModes", () => $e139707caeafbfd6$export$84e4fdd8f295ca31);
$parcel$export(module.exports, "GridRowModes", () => $e139707caeafbfd6$export$d98c76b959bb0b5c);
var $e139707caeafbfd6$export$bad6b7a934346f26 = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}($e139707caeafbfd6$export$bad6b7a934346f26 || {});
var $e139707caeafbfd6$export$84e4fdd8f295ca31 = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}($e139707caeafbfd6$export$84e4fdd8f295ca31 || {});
var $e139707caeafbfd6$export$d98c76b959bb0b5c = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}($e139707caeafbfd6$export$d98c76b959bb0b5c || {});

});

parcelRegister("5z7Pl", function(module, exports) {

$parcel$export(module.exports, "isSingleSelectColDef", () => $40d64af47d07faaf$export$74006a51f68c6262);
$parcel$export(module.exports, "getValueOptions", () => $40d64af47d07faaf$export$b871910a1101d890);
$parcel$export(module.exports, "getValueFromValueOptions", () => $40d64af47d07faaf$export$b31a7985e33f7505);

var $8nd05 = parcelRequire("8nd05");
function $40d64af47d07faaf$export$74006a51f68c6262(colDef) {
    return colDef?.type === 'singleSelect';
}
function $40d64af47d07faaf$export$b871910a1101d890(column, additionalParams) {
    if (!column) return undefined;
    return typeof column.valueOptions === 'function' ? column.valueOptions((0, $8nd05.default)({
        field: column.field
    }, additionalParams)) : column.valueOptions;
}
function $40d64af47d07faaf$export$b31a7985e33f7505(value, valueOptions, getOptionValue) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}

});


parcelRegister("hIUWG", function(module, exports) {

$parcel$export(module.exports, "getGridSingleSelectOperators", () => $ce72b7e51ff8300c$export$fe632a61ba1bdc90);

var $4UMDV = parcelRequire("4UMDV");

var $DRQFc = parcelRequire("DRQFc");

var $lR3Vo = parcelRequire("lR3Vo");
const $ce72b7e51ff8300c$var$parseObjectValue = (value)=>{
    if (value == null || !(0, $lR3Vo.isObject)(value)) return value;
    return value.value;
};
const $ce72b7e51ff8300c$export$fe632a61ba1bdc90 = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$ce72b7e51ff8300c$var$parseObjectValue(value) === $ce72b7e51ff8300c$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $4UMDV.GridFilterInputSingleSelect)
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$ce72b7e51ff8300c$var$parseObjectValue(value) !== $ce72b7e51ff8300c$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $4UMDV.GridFilterInputSingleSelect)
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map($ce72b7e51ff8300c$var$parseObjectValue);
                return (value)=>filterItemValues.includes($ce72b7e51ff8300c$var$parseObjectValue(value));
            },
            InputComponent: (0, $DRQFc.GridFilterInputMultipleSingleSelect)
        }
    ];

});
parcelRegister("4UMDV", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputSingleSelect", () => $39421fe28cb0a5f3$export$760eb819dd95d361);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $auC0X = parcelRequire("auC0X");

var $d8seH = parcelRequire("d8seH");

var $jDpXp = parcelRequire("jDpXp");

var $5z7Pl = parcelRequire("5z7Pl");

var $ayMG0 = parcelRequire("ayMG0");
const $39421fe28cb0a5f3$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "placeholder",
    "tabIndex",
    "label",
    "variant",
    "isFilterActive",
    "clearButton",
    "InputLabelProps"
];
const $39421fe28cb0a5f3$var$renderSingleSelectOptions = ({ column: column, OptionComponent: OptionComponent, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isSelectNative: isSelectNative, baseSelectOptionProps: baseSelectOptionProps })=>{
    const iterableColumnValues = [
        '',
        ...(0, $5z7Pl.getValueOptions)(column) || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        let label = getOptionLabel(option);
        if (label === '') label = "\u2003"; // To force the height of the empty option
        return /*#__PURE__*/ (0, $acw62.createElement)(OptionComponent, (0, $8nd05.default)({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
const $39421fe28cb0a5f3$var$SingleSelectOperatorContainer = (0, $d8seH.default)('div')({
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    [`& button`]: {
        margin: 'auto 0px 5px 5px'
    }
});
function $39421fe28cb0a5f3$export$760eb819dd95d361(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, placeholder: placeholder, tabIndex: tabIndex, label: labelProp, variant: variant = 'standard', clearButton: clearButton } = props, others = (0, $1En50.default)(props, $39421fe28cb0a5f3$var$_excluded);
    const filterValue = item.value ?? '';
    const id = (0, $auC0X.default)();
    const labelId = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isSelectNative = rootProps.slotProps?.baseSelect?.native ?? false;
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $5z7Pl.isSingleSelectColDef)(column)) resolvedColumn = column;
    }
    const getOptionValue = resolvedColumn?.getOptionValue;
    const getOptionLabel = resolvedColumn?.getOptionLabel;
    const currentValueOptions = $acw62.useMemo(()=>{
        return (0, $5z7Pl.getValueOptions)(resolvedColumn);
    }, [
        resolvedColumn
    ]);
    const onFilterChange = $acw62.useCallback((event)=>{
        let value = event.target.value;
        // NativeSelect casts the value to a string.
        value = (0, $5z7Pl.getValueFromValueOptions)(value, currentValueOptions, getOptionValue);
        applyValue((0, $8nd05.default)({}, item, {
            value: value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    if (!(0, $5z7Pl.isSingleSelectColDef)(resolvedColumn)) return null;
    const label = labelProp ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($39421fe28cb0a5f3$var$SingleSelectOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputLabel, (0, $8nd05.default)({}, rootProps.slotProps?.baseInputLabel, {
                        id: labelId,
                        htmlFor: id,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                        id: id,
                        label: label,
                        labelId: labelId,
                        value: filterValue,
                        onChange: onFilterChange,
                        variant: variant,
                        type: type || 'text',
                        inputProps: {
                            tabIndex: tabIndex,
                            ref: focusElementRef,
                            placeholder: placeholder ?? apiRef.current.getLocaleText('filterPanelInputPlaceholder')
                        },
                        native: isSelectNative,
                        notched: variant === 'outlined' ? true : undefined
                    }, others /* FIXME: typing error */ , rootProps.slotProps?.baseSelect, {
                        children: $39421fe28cb0a5f3$var$renderSingleSelectOptions({
                            column: resolvedColumn,
                            OptionComponent: rootProps.slots.baseSelectOption,
                            getOptionLabel: getOptionLabel,
                            getOptionValue: getOptionValue,
                            isSelectNative: isSelectNative,
                            baseSelectOptionProps: rootProps.slotProps?.baseSelectOption
                        })
                    }))
                ]
            }),
            clearButton
        ]
    });
}

});

parcelRegister("DRQFc", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputMultipleSingleSelect", () => $077d69ce451095d0$export$a61be354e4fcf2c5);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $33DpT = parcelRequire("33DpT");
var $cFBau = parcelRequire("cFBau");

var $auC0X = parcelRequire("auC0X");

var $5z7Pl = parcelRequire("5z7Pl");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $077d69ce451095d0$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
], $077d69ce451095d0$var$_excluded2 = [
    "key"
];
const $077d69ce451095d0$var$filter = (0, $33DpT.createFilterOptions)();
function $077d69ce451095d0$export$a61be354e4fcf2c5(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $077d69ce451095d0$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const id = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $5z7Pl.isSingleSelectColDef)(column)) resolvedColumn = column;
    }
    const getOptionValue = resolvedColumn?.getOptionValue;
    const getOptionLabel = resolvedColumn?.getOptionLabel;
    const isOptionEqualToValue = $acw62.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = $acw62.useMemo(()=>{
        return (0, $5z7Pl.getValueOptions)(resolvedColumn) || [];
    }, [
        resolvedColumn
    ]);
    // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filteredValues = $acw62.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        return item.value.reduce((acc, value)=>{
            const resolvedValue = resolvedValueOptions.find((v)=>getOptionValue(v) === value);
            if (resolvedValue != null) acc.push(resolvedValue);
            return acc;
        }, []);
    }, [
        getOptionValue,
        item.value,
        resolvedValueOptions
    ]);
    const handleChange = $acw62.useCallback((event, value)=>{
        applyValue((0, $8nd05.default)({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), (0, $8nd05.default)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        filterOptions: $077d69ce451095d0$var$filter,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        renderTags: (value, getTagProps)=>value.map((option, index)=>{
                const _getTagProps = getTagProps({
                    index: index
                }), { key: key } = _getTagProps, tagProps = (0, $1En50.default)(_getTagProps, $077d69ce451095d0$var$_excluded2);
                return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseChip, (0, $8nd05.default)({
                    variant: "outlined",
                    size: "small",
                    label: getOptionLabel(option)
                }, tagProps), key);
            }),
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: (0, $8nd05.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: "singleSelect"
            }, TextFieldProps, rootProps.slotProps?.baseTextField))
    }, other));
}

});



parcelRegister("8z2XQ", function(module, exports) {

$parcel$export(module.exports, "GRID_ACTIONS_COLUMN_TYPE", () => $63c3e445c9bf0af1$export$e2523ab9efeb7465);
$parcel$export(module.exports, "GRID_ACTIONS_COL_DEF", () => $63c3e445c9bf0af1$export$cc51a5e65f00f971);

var $8nd05 = parcelRequire("8nd05");

var $bSL2h = parcelRequire("bSL2h");

var $cc312 = parcelRequire("cc312");
const $63c3e445c9bf0af1$export$e2523ab9efeb7465 = 'actions';
const $63c3e445c9bf0af1$export$cc51a5e65f00f971 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    width: 100,
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    headerName: '',
    disableColumnMenu: true,
    disableExport: true,
    renderCell: (0, $cc312.renderActionsCell),
    getApplyQuickFilterFn: undefined
});

});
parcelRegister("cc312", function(module, exports) {

$parcel$export(module.exports, "renderActionsCell", () => $8e08f1e439e1e2b5$export$974043ff7a6a1028);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $lBOb7 = parcelRequire("lBOb7");

var $9uEev = parcelRequire("9uEev");

var $auC0X = parcelRequire("auC0X");

var $5H1vo = parcelRequire("5H1vo");

var $ch6XH = parcelRequire("ch6XH");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $8e08f1e439e1e2b5$var$_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "focusElementRef"
];
const $8e08f1e439e1e2b5$var$hasActions = (colDef)=>typeof colDef.getActions === 'function';
function $8e08f1e439e1e2b5$export$e8966cddc2f9f685(props) {
    const { colDef: colDef, id: id, hasFocus: hasFocus, tabIndex: tabIndex, position: position = 'bottom-end', focusElementRef: focusElementRef } = props, other = (0, $1En50.default)(props, $8e08f1e439e1e2b5$var$_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = $acw62.useState(-1);
    const [open, setOpen] = $acw62.useState(false);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootRef = $acw62.useRef(null);
    const buttonRef = $acw62.useRef(null);
    const ignoreCallToFocus = $acw62.useRef(false);
    const touchRippleRefs = $acw62.useRef({});
    const isRtl = (0, $9uEev.useRtl)();
    const menuId = (0, $auC0X.default)();
    const buttonId = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (!$8e08f1e439e1e2b5$var$hasActions(colDef)) throw new Error('MUI X: Missing the `getActions` property in the `GridColDef`.');
    const options = colDef.getActions(apiRef.current.getRowParams(id));
    const iconButtons = options.filter((option)=>!option.props.showInMenu);
    const menuButtons = options.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    $acw62.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref?.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    $acw62.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    $acw62.useEffect(()=>{
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    $acw62.useImperativeHandle(focusElementRef, ()=>({
            focus () {
                // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
                if (!ignoreCallToFocus.current) {
                    // find the first focusable button and pass the index to the state
                    const focusableButtonIndex = options.findIndex((o)=>!o.props.disabled);
                    setFocusedButtonIndex(focusableButtonIndex);
                }
            }
        }), [
        options
    ]);
    $acw62.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const toggleMenu = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (open) hideMenu();
        else showMenu();
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            if (index < 0 || index > options.length) return index;
            // for rtl mode we need to reverse the direction
            const rtlMod = isRtl ? -1 : 1;
            const indexMod = (direction === 'left' ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return options[index + indexMod]?.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if (event.key === 'ArrowRight') newIndex = getNewIndex(focusedButtonIndex, 'right');
        else if (event.key === 'ArrowLeft') newIndex = getNewIndex(focusedButtonIndex, 'left');
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, for example ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ([
            'Tab',
            'Escape'
        ].includes(event.key)) hideMenu();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        role: "menu",
        ref: rootRef,
        tabIndex: -1,
        className: (0, $5H1vo.gridClasses).actionsCell,
        onKeyDown: handleRootKeyDown
    }, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: toggleMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ch6XH.GridMenu), {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lBOb7.default), {
                    id: menuId,
                    className: (0, $5H1vo.gridClasses).menuList,
                    onKeyDown: handleListKeyDown,
                    "aria-labelledby": buttonId,
                    variant: "menu",
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        }))
                })
            })
        ]
    }));
}
const $8e08f1e439e1e2b5$export$974043ff7a6a1028 = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8e08f1e439e1e2b5$export$e8966cddc2f9f685, (0, $8nd05.default)({}, params));

});
parcelRegister("ch6XH", function(module, exports) {

$parcel$export(module.exports, "GridMenu", () => $8efc7911d5661cb8$export$237948c71948075);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $kGwBF = parcelRequire("kGwBF");

var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");

var $iscuz = parcelRequire("iscuz");

var $7Frhn = parcelRequire("7Frhn");

var $e76iu = parcelRequire("e76iu");

var $d8seH = parcelRequire("d8seH");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $8efc7911d5661cb8$var$_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const $8efc7911d5661cb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'menu'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $8efc7911d5661cb8$var$GridMenuRoot = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiDataGrid',
    slot: 'Menu',
    overridesResolver: (_, styles)=>styles.menu
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal,
        [`& .${(0, $5H1vo.gridClasses).menuList}`]: {
            outline: 0
        }
    }));
const $8efc7911d5661cb8$var$transformOrigin = {
    'bottom-start': 'top left',
    'bottom-end': 'top right'
};
function $8efc7911d5661cb8$export$237948c71948075(props) {
    const { open: open, target: target, onClose: onClose, children: children, position: position, className: className, onExited: onExited } = props, other = (0, $1En50.default)(props, $8efc7911d5661cb8$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $8efc7911d5661cb8$var$useUtilityClasses(rootProps);
    const savedFocusRef = $acw62.useRef(null);
    (0, $eEJPp.default)(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            savedFocusRef.current?.focus?.();
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // Emit menuOpen or menuClose events
        const eventName = open ? 'menuOpen' : 'menuClose';
        apiRef.current.publishEvent(eventName, {
            target: target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleExited = (popperOnExited)=>(node)=>{
            if (popperOnExited) popperOnExited();
            if (onExited) onExited(node);
        };
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || target?.contains(event.target))) return;
        onClose(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$var$GridMenuRoot, (0, $8nd05.default)({
        as: rootProps.slots.basePopper,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps,
        open: open,
        anchorEl: target,
        transition: true,
        placement: position
    }, other, rootProps.slotProps?.basePopper, {
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), {
                onClickAway: handleClickAway,
                mouseEvent: "onMouseDown",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iscuz.default), (0, $8nd05.default)({}, TransitionProps, {
                    style: {
                        transformOrigin: $8efc7911d5661cb8$var$transformOrigin[placement]
                    },
                    onExited: handleExited(TransitionProps?.onExited),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                        children: children
                    })
                }))
            })
    }));
}

});
parcelRegister("kGwBF", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", () => $f0f105dbd8c07c9e$export$58385c17fee43f89);

var $acw62 = parcelRequire("acw62");


var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $2xc7G = parcelRequire("2xc7G");
'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://v6.mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://v6.mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $3qSdM.default)((0, $2xc7G.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $13KXh.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $6zeBo.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $acw62.cloneElement(children, childrenProps);
}

});





parcelRegister("6forD", function(module, exports) {

$parcel$export(module.exports, "gridHeaderFilteringEnabledSelector", () => $48c71b00043b47b4$export$5e071b12b66f124d);
$parcel$export(module.exports, "gridHeaderFilteringEditFieldSelector", () => $48c71b00043b47b4$export$d5104e3dccc7c49d);
$parcel$export(module.exports, "gridHeaderFilteringMenuSelector", () => $48c71b00043b47b4$export$c564e60305059ea4);

var $cgQ4y = parcelRequire("cgQ4y");
const $48c71b00043b47b4$export$372ceb7d0877dfb4 = (state)=>state.headerFiltering;
const $48c71b00043b47b4$export$5e071b12b66f124d = (0, $cgQ4y.createSelector)($48c71b00043b47b4$export$372ceb7d0877dfb4, // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
(headerFilteringState)=>headerFilteringState?.enabled ?? false);
const $48c71b00043b47b4$export$d5104e3dccc7c49d = (0, $cgQ4y.createSelector)($48c71b00043b47b4$export$372ceb7d0877dfb4, (headerFilteringState)=>headerFilteringState.editing);
const $48c71b00043b47b4$export$c564e60305059ea4 = (0, $cgQ4y.createSelector)($48c71b00043b47b4$export$372ceb7d0877dfb4, (headerFilteringState)=>headerFilteringState.menuOpen);

});

parcelRegister("hMyIf", function(module, exports) {

$parcel$export(module.exports, "gridColumnGroupsUnwrappedModelSelector", () => $cf21d895912d975b$export$78f140ad2e1dbc2b);
$parcel$export(module.exports, "gridColumnGroupsLookupSelector", () => $cf21d895912d975b$export$bdc2ff4432d8b29b);
$parcel$export(module.exports, "gridColumnGroupsHeaderStructureSelector", () => $cf21d895912d975b$export$8f859ed1f2777746);
$parcel$export(module.exports, "gridColumnGroupsHeaderMaxDepthSelector", () => $cf21d895912d975b$export$4cf0369c079b29be);

var $cgQ4y = parcelRequire("cgQ4y");
const $cf21d895912d975b$export$6f71a66e6e099ab2 = (state)=>state.columnGrouping;
const $cf21d895912d975b$export$78f140ad2e1dbc2b = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.unwrappedGroupingModel ?? {});
const $cf21d895912d975b$export$bdc2ff4432d8b29b = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.lookup ?? {});
const $cf21d895912d975b$export$8f859ed1f2777746 = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.headerStructure ?? []);
const $cf21d895912d975b$export$4cf0369c079b29be = (0, $cgQ4y.createSelector)($cf21d895912d975b$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.maxDepth ?? 0);

});


parcelRegister("bdqIg", function(module, exports) {

$parcel$export(module.exports, "gridRowsMetaSelector", () => $82a5a13765976ef2$export$4f32bfc70efeb4ab);
const $82a5a13765976ef2$export$4f32bfc70efeb4ab = (state)=>state.rowsMeta;

});


parcelRegister("fHEg1", function(module, exports) {

$parcel$export(module.exports, "useGridVirtualScroller", () => $b6ea197699b5ee12$export$fbe94079134c8d27);
$parcel$export(module.exports, "computeOffsetLeft", () => $b6ea197699b5ee12$export$fe1f1566870c3cbc);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");

var $iYIN2 = parcelRequire("iYIN2");

var $lHOu3 = parcelRequire("lHOu3");

var $9uEev = parcelRequire("9uEev");

var $1H8UY = parcelRequire("1H8UY");

var $61HyH = parcelRequire("61HyH");

var $er55f = parcelRequire("er55f");

var $jDpXp = parcelRequire("jDpXp");

var $5sOMZ = parcelRequire("5sOMZ");

var $gSdVD = parcelRequire("gSdVD");

var $jQEEt = parcelRequire("jQEEt");

var $goCyd = parcelRequire("goCyd");

var $aJApm = parcelRequire("aJApm");

var $eFF1m = parcelRequire("eFF1m");

var $eB8vK = parcelRequire("eB8vK");

var $lR3Vo = parcelRequire("lR3Vo");

var $av74L = parcelRequire("av74L");

var $bdqIg = parcelRequire("bdqIg");

var $i0LyH = parcelRequire("i0LyH");

var $9upDV = parcelRequire("9upDV");

var $dfzFI = parcelRequire("dfzFI");

var $hMoDT = parcelRequire("hMoDT");

var $8BltG = parcelRequire("8BltG");

var $7sDf4 = parcelRequire("7sDf4");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $98F89 = parcelRequire("98F89");

var $af8j6 = parcelRequire("af8j6");

var $hWI6v = parcelRequire("hWI6v");

var $ayMG0 = parcelRequire("ayMG0");
const $b6ea197699b5ee12$var$MINIMUM_COLUMN_WIDTH = 50;
var $b6ea197699b5ee12$var$ScrollDirection = /*#__PURE__*/ function(ScrollDirection) {
    ScrollDirection[ScrollDirection["NONE"] = 0] = "NONE";
    ScrollDirection[ScrollDirection["UP"] = 1] = "UP";
    ScrollDirection[ScrollDirection["DOWN"] = 2] = "DOWN";
    ScrollDirection[ScrollDirection["LEFT"] = 3] = "LEFT";
    ScrollDirection[ScrollDirection["RIGHT"] = 4] = "RIGHT";
    return ScrollDirection;
}($b6ea197699b5ee12$var$ScrollDirection || {});
const $b6ea197699b5ee12$var$EMPTY_SCROLL_POSITION = {
    top: 0,
    left: 0
};
const $b6ea197699b5ee12$export$68a3509179402d90 = Object.freeze(new Map());
const $b6ea197699b5ee12$var$createScrollCache = (isRtl, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)=>({
        direction: $b6ea197699b5ee12$var$ScrollDirection.NONE,
        buffer: $b6ea197699b5ee12$var$bufferForDirection(isRtl, $b6ea197699b5ee12$var$ScrollDirection.NONE, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)
    });
const $b6ea197699b5ee12$export$fbe94079134c8d27 = ()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { unstable_listView: listView } = rootProps;
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, ()=>listView ? [
            (0, $8BltG.gridListColumnSelector)(apiRef.current.state)
        ] : (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef));
    const enabledForRows = (0, $5sOMZ.useGridSelector)(apiRef, (0, $9upDV.gridVirtualizationRowEnabledSelector)) && !(0, $hWI6v.isJSDOM);
    const enabledForColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $9upDV.gridVirtualizationColumnEnabledSelector)) && !(0, $hWI6v.isJSDOM);
    const pinnedRows = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridPinnedRowsSelector));
    const pinnedColumnDefinitions = (0, $jQEEt.gridVisiblePinnedColumnDefinitionsSelector)(apiRef);
    const pinnedColumns = listView ? (0, $4ZMWQ.EMPTY_PINNED_COLUMN_FIELDS) : pinnedColumnDefinitions;
    const hasBottomPinnedRows = pinnedRows.bottom.length > 0;
    const [panels, setPanels] = $acw62.useState($b6ea197699b5ee12$export$68a3509179402d90);
    const isRtl = (0, $9uEev.useRtl)();
    const selectedRowsLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $av74L.selectedIdsLookupSelector));
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef);
    const mainRef = apiRef.current.mainElementRef;
    const scrollerRef = apiRef.current.virtualScrollerRef;
    const scrollbarVerticalRef = apiRef.current.virtualScrollbarVerticalRef;
    const scrollbarHorizontalRef = apiRef.current.virtualScrollbarHorizontalRef;
    const hasColSpan = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridHasColSpanSelector));
    const isRenderContextReady = $acw62.useRef(false);
    const rowHeight = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridRowHeightSelector));
    const contentHeight = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridContentHeightSelector));
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridColumnsTotalWidthSelector));
    const needsHorizontalScrollbar = (0, $5sOMZ.useGridSelector)(apiRef, $b6ea197699b5ee12$var$needsHorizontalScrollbarSelector);
    const verticalScrollbarWidth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridVerticalScrollbarWidthSelector));
    const gridHasFiller = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridHasFillerSelector));
    const previousSize = $acw62.useRef(null);
    const mainRefCallback = $acw62.useCallback((node)=>{
        mainRef.current = node;
        if (!node) return undefined;
        const initialRect = node.getBoundingClientRect();
        let lastSize = {
            width: (0, $af8j6.roundToDecimalPlaces)(initialRect.width, 1),
            height: (0, $af8j6.roundToDecimalPlaces)(initialRect.height, 1)
        };
        if (!previousSize.current || lastSize.width !== previousSize.current.width && lastSize.height !== previousSize.current.height) {
            previousSize.current = lastSize;
            apiRef.current.publishEvent('resize', lastSize);
        }
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver((entries)=>{
            const entry = entries[0];
            if (!entry) return;
            const newSize = {
                width: (0, $af8j6.roundToDecimalPlaces)(entry.contentRect.width, 1),
                height: (0, $af8j6.roundToDecimalPlaces)(entry.contentRect.height, 1)
            };
            if (newSize.width === lastSize.width && newSize.height === lastSize.height) return;
            apiRef.current.publishEvent('resize', newSize);
            lastSize = newSize;
        });
        observer.observe(node);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1H8UY))) >= 19) return ()=>{
            mainRef.current = null;
            observer.disconnect();
        };
        return undefined;
    }, [
        apiRef,
        mainRef
    ]);
    /*
   * Scroll context logic
   * ====================
   * We only render the cells contained in the `renderContext`. However, when the user starts scrolling the grid
   * in a direction, we want to render as many cells as possible in that direction, as to avoid presenting white
   * areas if the user scrolls too fast/far and the viewport ends up in a region we haven't rendered yet. To render
   * more cells, we store some offsets to add to the viewport in `scrollCache.buffer`. Those offsets make the render
   * context wider in the direction the user is going, but also makes the buffer around the viewport `0` for the
   * dimension (horizontal or vertical) in which the user is not scrolling. So if the normal viewport is 8 columns
   * wide, with a 1 column buffer (10 columns total), then we want it to be exactly 8 columns wide during vertical
   * scroll.
   * However, we don't want the rows in the old context to re-render from e.g. 10 columns to 8 columns, because that's
   * work that's not necessary. Thus we store the context at the start of the scroll in `frozenContext`, and the rows
   * that are part of this old context will keep their same render context as to avoid re-rendering.
   */ const scrollPosition = $acw62.useRef(rootProps.initialState?.scroll ?? $b6ea197699b5ee12$var$EMPTY_SCROLL_POSITION);
    const ignoreNextScrollEvent = $acw62.useRef(false);
    const previousContextScrollPosition = $acw62.useRef($b6ea197699b5ee12$var$EMPTY_SCROLL_POSITION);
    const previousRowContext = $acw62.useRef((0, $dfzFI.EMPTY_RENDER_CONTEXT));
    const renderContext = (0, $5sOMZ.useGridSelector)(apiRef, (0, $9upDV.gridRenderContextSelector));
    const focusedVirtualCell = (0, $5sOMZ.useGridSelector)(apiRef, (0, $98F89.gridFocusedVirtualCellSelector));
    const scrollTimeout = (0, $lHOu3.default)();
    const frozenContext = $acw62.useRef(undefined);
    const scrollCache = (0, $iYIN2.default)(()=>$b6ea197699b5ee12$var$createScrollCache(isRtl, rootProps.rowBufferPx, rootProps.columnBufferPx, rowHeight * 15, $b6ea197699b5ee12$var$MINIMUM_COLUMN_WIDTH * 6)).current;
    const updateRenderContext = $acw62.useCallback((nextRenderContext)=>{
        if ($b6ea197699b5ee12$export$6eb241d16b36f3b8(nextRenderContext, apiRef.current.state.virtualization.renderContext)) return;
        const didRowsIntervalChange = nextRenderContext.firstRowIndex !== previousRowContext.current.firstRowIndex || nextRenderContext.lastRowIndex !== previousRowContext.current.lastRowIndex;
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                virtualization: (0, $8nd05.default)({}, state.virtualization, {
                    renderContext: nextRenderContext
                })
            });
        });
        // The lazy-loading hook is listening to `renderedRowsIntervalChange`,
        // but only does something if we already have a render context, because
        // otherwise we would call an update directly on mount
        const isReady = (0, $61HyH.gridDimensionsSelector)(apiRef.current.state).isReady;
        if (isReady && didRowsIntervalChange) {
            previousRowContext.current = nextRenderContext;
            apiRef.current.publishEvent('renderedRowsIntervalChange', nextRenderContext);
        }
        previousContextScrollPosition.current = scrollPosition.current;
    }, [
        apiRef
    ]);
    const triggerUpdateRenderContext = (0, $13KXh.default)(()=>{
        const scroller = scrollerRef.current;
        if (!scroller) return undefined;
        const dimensions = (0, $61HyH.gridDimensionsSelector)(apiRef.current.state);
        const maxScrollTop = Math.ceil(dimensions.minimumSize.height - dimensions.viewportOuterSize.height);
        const maxScrollLeft = Math.ceil(dimensions.minimumSize.width - dimensions.viewportInnerSize.width);
        // Clamp the scroll position to the viewport to avoid re-calculating the render context for scroll bounce
        const newScroll = {
            top: (0, $lR3Vo.clamp)(scroller.scrollTop, 0, maxScrollTop),
            left: isRtl ? (0, $lR3Vo.clamp)(scroller.scrollLeft, -maxScrollLeft, 0) : (0, $lR3Vo.clamp)(scroller.scrollLeft, 0, maxScrollLeft)
        };
        const dx = newScroll.left - scrollPosition.current.left;
        const dy = newScroll.top - scrollPosition.current.top;
        const isScrolling = dx !== 0 || dy !== 0;
        scrollPosition.current = newScroll;
        const direction = isScrolling ? $b6ea197699b5ee12$var$directionForDelta(dx, dy) : $b6ea197699b5ee12$var$ScrollDirection.NONE;
        // Since previous render, we have scrolled...
        const rowScroll = Math.abs(scrollPosition.current.top - previousContextScrollPosition.current.top);
        const columnScroll = Math.abs(scrollPosition.current.left - previousContextScrollPosition.current.left);
        // PERF: use the computed minimum column width instead of a static one
        const didCrossThreshold = rowScroll >= rowHeight || columnScroll >= $b6ea197699b5ee12$var$MINIMUM_COLUMN_WIDTH;
        const didChangeDirection = scrollCache.direction !== direction;
        const shouldUpdate = didCrossThreshold || didChangeDirection;
        if (!shouldUpdate) return renderContext;
        // Render a new context
        if (didChangeDirection) switch(direction){
            case $b6ea197699b5ee12$var$ScrollDirection.NONE:
            case $b6ea197699b5ee12$var$ScrollDirection.LEFT:
            case $b6ea197699b5ee12$var$ScrollDirection.RIGHT:
                frozenContext.current = undefined;
                break;
            default:
                frozenContext.current = renderContext;
                break;
        }
        scrollCache.direction = direction;
        scrollCache.buffer = $b6ea197699b5ee12$var$bufferForDirection(isRtl, direction, rootProps.rowBufferPx, rootProps.columnBufferPx, rowHeight * 15, $b6ea197699b5ee12$var$MINIMUM_COLUMN_WIDTH * 6);
        const inputs = $b6ea197699b5ee12$var$inputsSelector(apiRef, rootProps, enabledForRows, enabledForColumns);
        const nextRenderContext = $b6ea197699b5ee12$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        if (!$b6ea197699b5ee12$export$6eb241d16b36f3b8(nextRenderContext, renderContext)) {
            // Prevents batching render context changes
            $1u0KT.flushSync(()=>{
                updateRenderContext(nextRenderContext);
            });
            scrollTimeout.start(1000, triggerUpdateRenderContext);
        }
        return nextRenderContext;
    });
    const forceUpdateRenderContext = ()=>{
        // skip update if dimensions are not ready and virtualization is enabled
        if (!(0, $61HyH.gridDimensionsSelector)(apiRef.current.state).isReady && (enabledForRows || enabledForColumns)) return;
        const inputs = $b6ea197699b5ee12$var$inputsSelector(apiRef, rootProps, enabledForRows, enabledForColumns);
        const nextRenderContext = $b6ea197699b5ee12$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        // Reset the frozen context when the render context changes, see the illustration in https://github.com/mui/mui-x/pull/12353
        frozenContext.current = undefined;
        updateRenderContext(nextRenderContext);
    };
    const handleScroll = (0, $13KXh.default)(()=>{
        if (ignoreNextScrollEvent.current) {
            ignoreNextScrollEvent.current = false;
            return;
        }
        const nextRenderContext = triggerUpdateRenderContext();
        apiRef.current.publishEvent('scrollPositionChange', {
            top: scrollPosition.current.top,
            left: scrollPosition.current.left,
            renderContext: nextRenderContext
        });
    });
    const handleWheel = (0, $13KXh.default)((event)=>{
        apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
    });
    const handleTouchMove = (0, $13KXh.default)((event)=>{
        apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
    });
    const getRows = (params = {})=>{
        if (!params.rows && !currentPage.range) return [];
        const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        let baseRenderContext = renderContext;
        if (params.renderContext) {
            baseRenderContext = params.renderContext;
            baseRenderContext.firstColumnIndex = renderContext.firstColumnIndex;
            baseRenderContext.lastColumnIndex = renderContext.lastColumnIndex;
        }
        const isLastSection = !hasBottomPinnedRows && params.position === undefined || hasBottomPinnedRows && params.position === 'bottom';
        const isPinnedSection = params.position !== undefined;
        let rowIndexOffset;
        // FIXME: Why is the switch check exhaustiveness not validated with typescript-eslint?
        // eslint-disable-next-line default-case
        switch(params.position){
            case 'top':
                rowIndexOffset = 0;
                break;
            case 'bottom':
                rowIndexOffset = pinnedRows.top.length + currentPage.rows.length;
                break;
            case undefined:
                rowIndexOffset = pinnedRows.top.length;
                break;
        }
        const rowModels = params.rows ?? currentPage.rows;
        const firstRowToRender = baseRenderContext.firstRowIndex;
        const lastRowToRender = Math.min(baseRenderContext.lastRowIndex, rowModels.length);
        const rowIndexes = params.rows ? (0, $lR3Vo.range)(0, params.rows.length) : (0, $lR3Vo.range)(firstRowToRender, lastRowToRender);
        let virtualRowIndex = -1;
        if (!isPinnedSection && focusedVirtualCell) {
            if (focusedVirtualCell.rowIndex < firstRowToRender) {
                rowIndexes.unshift(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
            if (focusedVirtualCell.rowIndex > lastRowToRender) {
                rowIndexes.push(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
        }
        const rows = [];
        const rowProps = rootProps.slotProps?.row;
        const columnPositions = (0, $jQEEt.gridColumnPositionsSelector)(apiRef);
        rowIndexes.forEach((rowIndexInPage)=>{
            const { id: id, model: model } = rowModels[rowIndexInPage];
            // In certain cases, the state might already be updated and `currentPage.rows` (which sets `rowModels`)
            // contains stale data.
            // In that case, skip any further row processing.
            // See:
            // - https://github.com/mui/mui-x/issues/16638
            // - https://github.com/mui/mui-x/issues/17022
            if (!rowTree[id]) return;
            const rowIndex = (currentPage?.range?.firstRowIndex || 0) + rowIndexOffset + rowIndexInPage;
            // NOTE: This is an expensive feature, the colSpan code could be optimized.
            if (hasColSpan) {
                const minFirstColumn = pinnedColumns.left.length;
                const maxLastColumn = visibleColumns.length - pinnedColumns.right.length;
                apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: minFirstColumn,
                    maxLastColumn: maxLastColumn,
                    columns: visibleColumns
                });
                if (pinnedColumns.left.length > 0) apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: 0,
                    maxLastColumn: pinnedColumns.left.length,
                    columns: visibleColumns
                });
                if (pinnedColumns.right.length > 0) apiRef.current.calculateColSpan({
                    rowId: id,
                    minFirstColumn: visibleColumns.length - pinnedColumns.right.length,
                    maxLastColumn: visibleColumns.length,
                    columns: visibleColumns
                });
            }
            const baseRowHeight = !apiRef.current.rowHasAutoHeight(id) ? apiRef.current.unstable_getRowHeight(id) : 'auto';
            let isSelected;
            if (selectedRowsLookup[id] == null) isSelected = false;
            else isSelected = apiRef.current.isRowSelectable(id);
            let isFirstVisible = false;
            if (params.position === undefined) isFirstVisible = rowIndexInPage === 0;
            let isLastVisible = false;
            const isLastVisibleInSection = rowIndexInPage === rowModels.length - 1;
            if (isLastSection) {
                if (!isPinnedSection) {
                    const lastIndex = currentPage.rows.length - 1;
                    const isLastVisibleRowIndex = rowIndexInPage === lastIndex;
                    if (isLastVisibleRowIndex) isLastVisible = true;
                } else isLastVisible = isLastVisibleInSection;
            }
            let currentRenderContext = baseRenderContext;
            if (frozenContext.current && rowIndexInPage >= frozenContext.current.firstRowIndex && rowIndexInPage < frozenContext.current.lastRowIndex) currentRenderContext = frozenContext.current;
            const isVirtualFocusRow = rowIndexInPage === virtualRowIndex;
            const isVirtualFocusColumn = focusedVirtualCell?.rowIndex === rowIndex;
            const offsetLeft = $b6ea197699b5ee12$export$fe1f1566870c3cbc(columnPositions, currentRenderContext, pinnedColumns.left.length);
            const showBottomBorder = isLastVisibleInSection && params.position === 'top';
            const firstColumnIndex = currentRenderContext.firstColumnIndex;
            const lastColumnIndex = currentRenderContext.lastColumnIndex;
            rows.push(/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.row, (0, $8nd05.default)({
                row: model,
                rowId: id,
                index: rowIndex,
                selected: isSelected,
                offsetLeft: offsetLeft,
                columnsTotalWidth: columnsTotalWidth,
                rowHeight: baseRowHeight,
                pinnedColumns: pinnedColumns,
                visibleColumns: visibleColumns,
                firstColumnIndex: firstColumnIndex,
                lastColumnIndex: lastColumnIndex,
                focusedColumnIndex: isVirtualFocusColumn ? focusedVirtualCell.columnIndex : undefined,
                isFirstVisible: isFirstVisible,
                isLastVisible: isLastVisible,
                isNotVisible: isVirtualFocusRow,
                showBottomBorder: showBottomBorder,
                scrollbarWidth: verticalScrollbarWidth,
                gridHasFiller: gridHasFiller
            }, rowProps), id));
            if (isVirtualFocusRow) return;
            const panel = panels.get(id);
            if (panel) rows.push(panel);
            if (params.position === undefined && isLastVisibleInSection) rows.push(apiRef.current.getInfiniteLoadingTriggerElement?.({
                lastRowId: id
            }));
        });
        return rows;
    };
    const scrollerStyle = $acw62.useMemo(()=>({
            overflowX: !needsHorizontalScrollbar || listView ? 'hidden' : undefined,
            overflowY: rootProps.autoHeight ? 'hidden' : undefined
        }), [
        needsHorizontalScrollbar,
        rootProps.autoHeight,
        listView
    ]);
    const contentSize = $acw62.useMemo(()=>{
        const size = {
            width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
            flexBasis: contentHeight,
            flexShrink: 0
        };
        if (size.flexBasis === 0) size.flexBasis = (0, $7sDf4.minimalContentHeight); // Give room to show the overlay when there no rows.
        return size;
    }, [
        columnsTotalWidth,
        contentHeight,
        needsHorizontalScrollbar
    ]);
    const onContentSizeApplied = $acw62.useCallback((node)=>{
        if (!node) return;
        apiRef.current.publishEvent('virtualScrollerContentSizeChange', {
            columnsTotalWidth: columnsTotalWidth,
            contentHeight: contentHeight
        });
    }, [
        apiRef,
        columnsTotalWidth,
        contentHeight
    ]);
    (0, $eEJPp.default)(()=>{
        if (!isRenderContextReady.current) return;
        apiRef.current.updateRenderContext?.();
    }, [
        apiRef,
        enabledForColumns,
        enabledForRows
    ]);
    (0, $eEJPp.default)(()=>{
        if (listView) scrollerRef.current.scrollLeft = 0;
    }, [
        listView,
        scrollerRef
    ]);
    (0, $gSdVD.useRunOnce)(renderContext !== (0, $dfzFI.EMPTY_RENDER_CONTEXT), ()=>{
        apiRef.current.publishEvent('scrollPositionChange', {
            top: scrollPosition.current.top,
            left: scrollPosition.current.left,
            renderContext: renderContext
        });
        isRenderContextReady.current = true;
        if (rootProps.initialState?.scroll && scrollerRef.current) {
            const scroller = scrollerRef.current;
            const { top: top, left: left } = rootProps.initialState.scroll;
            // On initial mount, if we have columns available, we can restore the horizontal scroll immediately, but we need to skip the resulting scroll event, otherwise we would recalculate the render context at position top=0, left=restoredValue, but the initial render context is already calculated based on the initial value of scrollPosition ref.
            const isScrollRestored = {
                top: !(top > 0),
                left: !(left > 0)
            };
            if (!isScrollRestored.left && columnsTotalWidth) {
                scroller.scrollLeft = left;
                ignoreNextScrollEvent.current = true;
                isScrollRestored.left = true;
            }
            // For the sake of completeness, but I'm not sure if contentHeight is ever available at this point. Maybe when virtualisation is disabled?
            if (!isScrollRestored.top && contentHeight) {
                scroller.scrollTop = top;
                ignoreNextScrollEvent.current = true;
                isScrollRestored.top = true;
            }
            // To restore the vertical scroll, we need to wait until the rows are available in the DOM (otherwise there's nowhere to scroll), but before paint to avoid reflows
            if (!isScrollRestored.top || !isScrollRestored.left) {
                const unsubscribeContentSizeChange = apiRef.current.subscribeEvent('virtualScrollerContentSizeChange', (params)=>{
                    if (!isScrollRestored.left && params.columnsTotalWidth) {
                        scroller.scrollLeft = left;
                        ignoreNextScrollEvent.current = true;
                        isScrollRestored.left = true;
                    }
                    if (!isScrollRestored.top && params.contentHeight) {
                        scroller.scrollTop = top;
                        ignoreNextScrollEvent.current = true;
                        isScrollRestored.top = true;
                    }
                    if (isScrollRestored.left && isScrollRestored.top) unsubscribeContentSizeChange();
                });
                return unsubscribeContentSizeChange;
            }
        }
        return undefined;
    });
    apiRef.current.register('private', {
        updateRenderContext: forceUpdateRenderContext
    });
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'sortedRowsSet', forceUpdateRenderContext);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'paginationModelChange', forceUpdateRenderContext);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnsChange', forceUpdateRenderContext);
    return {
        renderContext: renderContext,
        setPanels: setPanels,
        getRows: getRows,
        getContainerProps: ()=>({
                ref: mainRefCallback
            }),
        getScrollerProps: ()=>({
                ref: scrollerRef,
                onScroll: handleScroll,
                onWheel: handleWheel,
                onTouchMove: handleTouchMove,
                style: scrollerStyle,
                role: 'presentation',
                // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
                // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
                tabIndex: $eB8vK.isFirefox ? -1 : undefined
            }),
        getContentProps: ()=>({
                style: contentSize,
                role: 'presentation',
                ref: onContentSizeApplied
            }),
        getRenderZoneProps: ()=>({
                role: 'rowgroup'
            }),
        getScrollbarVerticalProps: ()=>({
                ref: scrollbarVerticalRef,
                scrollPosition: scrollPosition
            }),
        getScrollbarHorizontalProps: ()=>({
                ref: scrollbarHorizontalRef,
                scrollPosition: scrollPosition
            }),
        getScrollAreaProps: ()=>({
                scrollPosition: scrollPosition
            })
    };
};
// dimension selectors
function $b6ea197699b5ee12$var$needsHorizontalScrollbarSelector(state) {
    return state.dimensions.viewportOuterSize.width > 0 && state.dimensions.columnsTotalWidth > state.dimensions.viewportOuterSize.width;
}
function $b6ea197699b5ee12$var$inputsSelector(apiRef, rootProps, enabledForRows, enabledForColumns) {
    const dimensions = (0, $61HyH.gridDimensionsSelector)(apiRef.current.state);
    const currentPage = (0, $aJApm.getVisibleRows)(apiRef, rootProps);
    const visibleColumns = rootProps.unstable_listView ? [
        (0, $8BltG.gridListColumnSelector)(apiRef.current.state)
    ] : (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
    const hiddenCellsOriginMap = (0, $hMoDT.gridRowSpanningHiddenCellsOriginMapSelector)(apiRef);
    const lastRowId = apiRef.current.state.rows.dataRowIds.at(-1);
    const lastColumn = visibleColumns.at(-1);
    return {
        enabledForRows: enabledForRows,
        enabledForColumns: enabledForColumns,
        apiRef: apiRef,
        autoHeight: rootProps.autoHeight,
        rowBufferPx: rootProps.rowBufferPx,
        columnBufferPx: rootProps.columnBufferPx,
        leftPinnedWidth: dimensions.leftPinnedWidth,
        columnsTotalWidth: dimensions.columnsTotalWidth,
        viewportInnerWidth: dimensions.viewportInnerSize.width,
        viewportInnerHeight: dimensions.viewportInnerSize.height,
        lastRowHeight: lastRowId !== undefined ? apiRef.current.unstable_getRowHeight(lastRowId) : 0,
        lastColumnWidth: lastColumn?.computedWidth ?? 0,
        rowsMeta: (0, $bdqIg.gridRowsMetaSelector)(apiRef.current.state),
        columnPositions: (0, $jQEEt.gridColumnPositionsSelector)(apiRef),
        rows: currentPage.rows,
        range: currentPage.range,
        pinnedColumns: (0, $jQEEt.gridVisiblePinnedColumnDefinitionsSelector)(apiRef),
        visibleColumns: visibleColumns,
        hiddenCellsOriginMap: hiddenCellsOriginMap,
        listView: rootProps.unstable_listView ?? false,
        virtualizeColumnsWithAutoRowHeight: rootProps.virtualizeColumnsWithAutoRowHeight
    };
}
function $b6ea197699b5ee12$var$computeRenderContext(inputs, scrollPosition, scrollCache) {
    const renderContext = {
        firstRowIndex: 0,
        lastRowIndex: inputs.rows.length,
        firstColumnIndex: 0,
        lastColumnIndex: inputs.visibleColumns.length
    };
    const { top: top, left: left } = scrollPosition;
    const realLeft = Math.abs(left) + inputs.leftPinnedWidth;
    if (inputs.enabledForRows) {
        // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        let firstRowIndex = Math.min($b6ea197699b5ee12$var$getNearestIndexToRender(inputs, top, {
            atStart: true,
            lastPosition: inputs.rowsMeta.positions[inputs.rowsMeta.positions.length - 1] + inputs.lastRowHeight
        }), inputs.rowsMeta.positions.length - 1);
        // If any of the cells in the `firstRowIndex` is hidden due to an extended row span,
        // Make sure the row from where the rowSpan is originated is visible.
        const rowSpanHiddenCellOrigin = inputs.hiddenCellsOriginMap[firstRowIndex];
        if (rowSpanHiddenCellOrigin) {
            const minSpannedRowIndex = Math.min(...Object.values(rowSpanHiddenCellOrigin));
            firstRowIndex = Math.min(firstRowIndex, minSpannedRowIndex);
        }
        const lastRowIndex = inputs.autoHeight ? firstRowIndex + inputs.rows.length : $b6ea197699b5ee12$var$getNearestIndexToRender(inputs, top + inputs.viewportInnerHeight);
        renderContext.firstRowIndex = firstRowIndex;
        renderContext.lastRowIndex = lastRowIndex;
    }
    if (inputs.listView) return (0, $8nd05.default)({}, renderContext, {
        lastColumnIndex: 1
    });
    if (inputs.enabledForColumns) {
        let firstColumnIndex = 0;
        let lastColumnIndex = inputs.columnPositions.length;
        let hasRowWithAutoHeight = false;
        const [firstRowToRender, lastRowToRender] = $b6ea197699b5ee12$var$getIndexesToRender({
            firstIndex: renderContext.firstRowIndex,
            lastIndex: renderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: inputs.rows.length,
            bufferBefore: scrollCache.buffer.rowBefore,
            bufferAfter: scrollCache.buffer.rowAfter,
            positions: inputs.rowsMeta.positions,
            lastSize: inputs.lastRowHeight
        });
        if (!inputs.virtualizeColumnsWithAutoRowHeight) for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
            const row = inputs.rows[i];
            hasRowWithAutoHeight = inputs.apiRef.current.rowHasAutoHeight(row.id);
        }
        if (!hasRowWithAutoHeight || inputs.virtualizeColumnsWithAutoRowHeight) {
            firstColumnIndex = $b6ea197699b5ee12$var$binarySearch(realLeft, inputs.columnPositions, {
                atStart: true,
                lastPosition: inputs.columnsTotalWidth
            });
            lastColumnIndex = $b6ea197699b5ee12$var$binarySearch(realLeft + inputs.viewportInnerWidth, inputs.columnPositions);
        }
        renderContext.firstColumnIndex = firstColumnIndex;
        renderContext.lastColumnIndex = lastColumnIndex;
    }
    const actualRenderContext = $b6ea197699b5ee12$var$deriveRenderContext(inputs, renderContext, scrollCache);
    return actualRenderContext;
}
function $b6ea197699b5ee12$var$getNearestIndexToRender(inputs, offset, options) {
    const lastMeasuredIndexRelativeToAllRows = inputs.apiRef.current.getLastMeasuredRowIndex();
    let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
    if (inputs.range?.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
    allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= inputs.range.lastRowIndex;
    const lastMeasuredIndexRelativeToCurrentPage = (0, $lR3Vo.clamp)(lastMeasuredIndexRelativeToAllRows - (inputs.range?.firstRowIndex || 0), 0, inputs.rowsMeta.positions.length);
    if (allRowsMeasured || inputs.rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
    // were measured, then use a binary search because it's faster.
    return $b6ea197699b5ee12$var$binarySearch(offset, inputs.rowsMeta.positions, options);
    // Otherwise, use an exponential search.
    // If rows have "auto" as height, their positions will be based on estimated heights.
    // In this case, we can skip several steps until we find a position higher than the offset.
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    return $b6ea197699b5ee12$var$exponentialSearch(offset, inputs.rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage, options);
}
/**
 * Accepts as input a raw render context (the area visible in the viewport) and adds
 * computes the actual render context based on pinned elements, buffer dimensions and
 * spanning.
 */ function $b6ea197699b5ee12$var$deriveRenderContext(inputs, nextRenderContext, scrollCache) {
    const [firstRowToRender, lastRowToRender] = $b6ea197699b5ee12$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstRowIndex,
        lastIndex: nextRenderContext.lastRowIndex,
        minFirstIndex: 0,
        maxLastIndex: inputs.rows.length,
        bufferBefore: scrollCache.buffer.rowBefore,
        bufferAfter: scrollCache.buffer.rowAfter,
        positions: inputs.rowsMeta.positions,
        lastSize: inputs.lastRowHeight
    });
    const [initialFirstColumnToRender, lastColumnToRender] = $b6ea197699b5ee12$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstColumnIndex,
        lastIndex: nextRenderContext.lastColumnIndex,
        minFirstIndex: inputs.pinnedColumns.left.length,
        maxLastIndex: inputs.visibleColumns.length - inputs.pinnedColumns.right.length,
        bufferBefore: scrollCache.buffer.columnBefore,
        bufferAfter: scrollCache.buffer.columnAfter,
        positions: inputs.columnPositions,
        lastSize: inputs.lastColumnWidth
    });
    const firstColumnToRender = (0, $i0LyH.getFirstNonSpannedColumnToRender)({
        firstColumnToRender: initialFirstColumnToRender,
        apiRef: inputs.apiRef,
        firstRowToRender: firstRowToRender,
        lastRowToRender: lastRowToRender,
        visibleRows: inputs.rows
    });
    return {
        firstRowIndex: firstRowToRender,
        lastRowIndex: lastRowToRender,
        firstColumnIndex: firstColumnToRender,
        lastColumnIndex: lastColumnToRender
    };
}
/**
 * Use binary search to avoid looping through all possible positions.
 * The `options.atStart` provides the possibility to match for the first element that
 * intersects the screen, even if said element's start position is before `offset`. In
 * other words, we search for `offset + width`.
 */ function $b6ea197699b5ee12$var$binarySearch(offset, positions, options, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const position = positions[pivot];
    let isBefore;
    if (options?.atStart) {
        const width = (pivot === positions.length - 1 ? options.lastPosition : positions[pivot + 1]) - position;
        isBefore = offset - width < position;
    } else isBefore = offset <= position;
    return isBefore ? $b6ea197699b5ee12$var$binarySearch(offset, positions, options, sliceStart, pivot) : $b6ea197699b5ee12$var$binarySearch(offset, positions, options, pivot + 1, sliceEnd);
}
function $b6ea197699b5ee12$var$exponentialSearch(offset, positions, index, options) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return $b6ea197699b5ee12$var$binarySearch(offset, positions, options, Math.floor(index / 2), Math.min(index, positions.length));
}
function $b6ea197699b5ee12$var$getIndexesToRender({ firstIndex: firstIndex, lastIndex: lastIndex, bufferBefore: bufferBefore, bufferAfter: bufferAfter, minFirstIndex: minFirstIndex, maxLastIndex: maxLastIndex, positions: positions, lastSize: lastSize }) {
    const firstPosition = positions[firstIndex] - bufferBefore;
    const lastPosition = positions[lastIndex] + bufferAfter;
    const firstIndexPadded = $b6ea197699b5ee12$var$binarySearch(firstPosition, positions, {
        atStart: true,
        lastPosition: positions[positions.length - 1] + lastSize
    });
    const lastIndexPadded = $b6ea197699b5ee12$var$binarySearch(lastPosition, positions);
    return [
        (0, $lR3Vo.clamp)(firstIndexPadded, minFirstIndex, maxLastIndex),
        (0, $lR3Vo.clamp)(lastIndexPadded, minFirstIndex, maxLastIndex)
    ];
}
function $b6ea197699b5ee12$export$6eb241d16b36f3b8(context1, context2) {
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
}
function $b6ea197699b5ee12$export$fe1f1566870c3cbc(columnPositions, renderContext, pinnedLeftLength) {
    const left = (columnPositions[renderContext.firstColumnIndex] ?? 0) - (columnPositions[pinnedLeftLength] ?? 0);
    return Math.abs(left);
}
function $b6ea197699b5ee12$var$directionForDelta(dx, dy) {
    if (dx === 0 && dy === 0) return $b6ea197699b5ee12$var$ScrollDirection.NONE;
    /* eslint-disable */ if (Math.abs(dy) >= Math.abs(dx)) {
        if (dy > 0) return $b6ea197699b5ee12$var$ScrollDirection.DOWN;
        else return $b6ea197699b5ee12$var$ScrollDirection.UP;
    } else {
        if (dx > 0) return $b6ea197699b5ee12$var$ScrollDirection.RIGHT;
        else return $b6ea197699b5ee12$var$ScrollDirection.LEFT;
    }
/* eslint-enable */ }
function $b6ea197699b5ee12$var$bufferForDirection(isRtl, direction, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    if (isRtl) switch(direction){
        case $b6ea197699b5ee12$var$ScrollDirection.LEFT:
            direction = $b6ea197699b5ee12$var$ScrollDirection.RIGHT;
            break;
        case $b6ea197699b5ee12$var$ScrollDirection.RIGHT:
            direction = $b6ea197699b5ee12$var$ScrollDirection.LEFT;
            break;
        default:
    }
    switch(direction){
        case $b6ea197699b5ee12$var$ScrollDirection.NONE:
            return {
                rowAfter: rowBufferPx,
                rowBefore: rowBufferPx,
                columnAfter: columnBufferPx,
                columnBefore: columnBufferPx
            };
        case $b6ea197699b5ee12$var$ScrollDirection.LEFT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: horizontalBuffer
            };
        case $b6ea197699b5ee12$var$ScrollDirection.RIGHT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: horizontalBuffer,
                columnBefore: 0
            };
        case $b6ea197699b5ee12$var$ScrollDirection.UP:
            return {
                rowAfter: 0,
                rowBefore: verticalBuffer,
                columnAfter: 0,
                columnBefore: 0
            };
        case $b6ea197699b5ee12$var$ScrollDirection.DOWN:
            return {
                rowAfter: verticalBuffer,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: 0
            };
        default:
            // eslint unable to figure out enum exhaustiveness
            throw new Error('unreachable');
    }
}

});
parcelRegister("1H8UY", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $13c0b97cb0c358d5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13c0b97cb0c358d5$var$React = $13c0b97cb0c358d5$require$_interopRequireWildcard((parcelRequire("acw62")));
var $13c0b97cb0c358d5$var$_default = module.exports.default = parseInt($13c0b97cb0c358d5$var$React.version, 10);

});

parcelRegister("gSdVD", function(module, exports) {

$parcel$export(module.exports, "useRunOnce", () => $c48c7e6f82e468a0$export$a3576ea6e6df583c);

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
const $c48c7e6f82e468a0$var$noop = ()=>{};
const $c48c7e6f82e468a0$export$a3576ea6e6df583c = (condition, effect)=>{
    const didRun = $acw62.useRef(false);
    (0, $eEJPp.default)(()=>{
        if (didRun.current || !condition) return $c48c7e6f82e468a0$var$noop;
        didRun.current = true;
        return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        didRun.current || condition
    ]);
};

});

parcelRegister("aJApm", function(module, exports) {

$parcel$export(module.exports, "getVisibleRows", () => $7d0a5941a1add073$export$79b9fa322a34430b);
$parcel$export(module.exports, "useGridVisibleRows", () => $7d0a5941a1add073$export$d1914c80ff11e37a);

var $gPWuj = parcelRequire("gPWuj");

var $5sOMZ = parcelRequire("5sOMZ");
const $7d0a5941a1add073$export$79b9fa322a34430b = (apiRef, props)=>{
    return (0, $gPWuj.gridVisibleRowsSelector)(apiRef);
};
const $7d0a5941a1add073$export$d1914c80ff11e37a = (apiRef, props)=>{
    return (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridVisibleRowsSelector));
};

});
parcelRegister("gPWuj", function(module, exports) {

$parcel$export(module.exports, "gridPaginationSelector", () => $c41ec74257ca380c$export$24c945ea033ce6cf);
$parcel$export(module.exports, "gridPaginationModelSelector", () => $c41ec74257ca380c$export$ccc9f04e59d0d8e6);
$parcel$export(module.exports, "gridPaginationRowCountSelector", () => $c41ec74257ca380c$export$946e4ae85da77ef6);
$parcel$export(module.exports, "gridPaginationMetaSelector", () => $c41ec74257ca380c$export$4dee702a38e33bdb);
$parcel$export(module.exports, "gridPageSelector", () => $c41ec74257ca380c$export$1f7f64fcb62ccdad);
$parcel$export(module.exports, "gridPageSizeSelector", () => $c41ec74257ca380c$export$721a46720a2de097);
$parcel$export(module.exports, "gridPageCountSelector", () => $c41ec74257ca380c$export$b81026f1aaf843a4);
$parcel$export(module.exports, "gridPaginatedVisibleSortedGridRowIdsSelector", () => $c41ec74257ca380c$export$c1f6a976375edd4a);
$parcel$export(module.exports, "gridVisibleRowsSelector", () => $c41ec74257ca380c$export$33f627fc0fc60be4);

var $cgQ4y = parcelRequire("cgQ4y");

var $k278Q = parcelRequire("k278Q");

var $goCyd = parcelRequire("goCyd");

var $baj2X = parcelRequire("baj2X");
const $c41ec74257ca380c$var$ALL_RESULTS_PAGE_VALUE = -1;
const $c41ec74257ca380c$export$24c945ea033ce6cf = (state)=>state.pagination;
const $c41ec74257ca380c$export$19be8ebb403c941f = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$24c945ea033ce6cf, (pagination)=>pagination.enabled && pagination.paginationMode === 'client');
const $c41ec74257ca380c$export$ccc9f04e59d0d8e6 = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$24c945ea033ce6cf, (pagination)=>pagination.paginationModel);
const $c41ec74257ca380c$export$946e4ae85da77ef6 = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$24c945ea033ce6cf, (pagination)=>pagination.rowCount);
const $c41ec74257ca380c$export$4dee702a38e33bdb = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$24c945ea033ce6cf, (pagination)=>pagination.meta);
const $c41ec74257ca380c$export$1f7f64fcb62ccdad = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.page);
const $c41ec74257ca380c$export$721a46720a2de097 = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.pageSize);
const $c41ec74257ca380c$export$b81026f1aaf843a4 = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$ccc9f04e59d0d8e6, $c41ec74257ca380c$export$946e4ae85da77ef6, (paginationModel, rowCount)=>(0, $baj2X.getPageCount)(rowCount, paginationModel.pageSize, paginationModel.page));
const $c41ec74257ca380c$export$b76c99ac6ae901da = (0, $cgQ4y.createSelectorMemoized)($c41ec74257ca380c$export$19be8ebb403c941f, $c41ec74257ca380c$export$ccc9f04e59d0d8e6, (0, $goCyd.gridRowTreeSelector), (0, $goCyd.gridRowMaximumTreeDepthSelector), (0, $k278Q.gridExpandedSortedRowEntriesSelector), (0, $k278Q.gridFilteredSortedTopLevelRowEntriesSelector), (clientSidePaginationEnabled, paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    if (!clientSidePaginationEnabled) return null;
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = paginationModel.pageSize === $c41ec74257ca380c$var$ALL_RESULTS_PAGE_VALUE ? visibleTopLevelRowCount - 1 : Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
    // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (depth === 0) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
const $c41ec74257ca380c$export$abcd649e974e3e96 = (0, $cgQ4y.createSelectorMemoized)((0, $k278Q.gridExpandedSortedRowEntriesSelector), $c41ec74257ca380c$export$b76c99ac6ae901da, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $c41ec74257ca380c$export$c1f6a976375edd4a = (0, $cgQ4y.createSelectorMemoized)((0, $k278Q.gridExpandedSortedRowIdsSelector), $c41ec74257ca380c$export$b76c99ac6ae901da, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $c41ec74257ca380c$export$33f627fc0fc60be4 = (0, $cgQ4y.createSelectorMemoized)($c41ec74257ca380c$export$19be8ebb403c941f, $c41ec74257ca380c$export$b76c99ac6ae901da, $c41ec74257ca380c$export$abcd649e974e3e96, (0, $k278Q.gridExpandedSortedRowEntriesSelector), (clientPaginationEnabled, paginationRowRange, paginationRows, expandedSortedRowEntries)=>{
    if (clientPaginationEnabled) return {
        rows: paginationRows,
        range: paginationRowRange,
        rowToIndexMap: paginationRows.reduce((lookup, row, index)=>{
            lookup.set(row.model, index);
            return lookup;
        }, new Map())
    };
    return {
        rows: expandedSortedRowEntries,
        range: expandedSortedRowEntries.length === 0 ? null : {
            firstRowIndex: 0,
            lastRowIndex: expandedSortedRowEntries.length - 1
        },
        rowToIndexMap: expandedSortedRowEntries.reduce((lookup, row, index)=>{
            lookup.set(row.model, index);
            return lookup;
        }, new Map())
    };
});

});
parcelRegister("k278Q", function(module, exports) {

$parcel$export(module.exports, "gridFilterModelSelector", () => $e95988b653de2e96$export$280aedb9454597a5);
$parcel$export(module.exports, "gridFilteredRowsLookupSelector", () => $e95988b653de2e96$export$6d031b6e8cbaf41c);
$parcel$export(module.exports, "gridExpandedSortedRowEntriesSelector", () => $e95988b653de2e96$export$2f31562143a3e5d4);
$parcel$export(module.exports, "gridExpandedSortedRowIdsSelector", () => $e95988b653de2e96$export$7a99837e2fd93e42);
$parcel$export(module.exports, "gridFilteredSortedRowIdsSelector", () => $e95988b653de2e96$export$4e2a9d76902d271c);
$parcel$export(module.exports, "gridFilteredSortedTopLevelRowEntriesSelector", () => $e95988b653de2e96$export$b8a7110d1a4c4623);
$parcel$export(module.exports, "gridExpandedRowCountSelector", () => $e95988b653de2e96$export$96919017bbfaec0d);
$parcel$export(module.exports, "gridFilteredTopLevelRowCountSelector", () => $e95988b653de2e96$export$f88efd30675963d1);
$parcel$export(module.exports, "gridFilterActiveItemsSelector", () => $e95988b653de2e96$export$c7447bfbd4ecafcc);
$parcel$export(module.exports, "gridFilterActiveItemsLookupSelector", () => $e95988b653de2e96$export$6b2da1ecc84b757a);

var $cgQ4y = parcelRequire("cgQ4y");

var $iU3u2 = parcelRequire("iU3u2");

var $jQEEt = parcelRequire("jQEEt");

var $goCyd = parcelRequire("goCyd");
/**
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilterStateSelector = (state)=>state.filter;
const $e95988b653de2e96$export$280aedb9454597a5 = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filterModel);
const $e95988b653de2e96$export$6f9fe133e2c56816 = (0, $cgQ4y.createSelector)($e95988b653de2e96$export$280aedb9454597a5, (filterModel)=>filterModel.quickFilterValues);
const $e95988b653de2e96$export$7dcadad908a379a4 = (state)=>state.visibleRowsLookup;
const $e95988b653de2e96$export$6d031b6e8cbaf41c = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
const $e95988b653de2e96$export$5f10eab80a0f79a0 = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredChildrenCountLookup);
const $e95988b653de2e96$export$28e99d5260ff82e7 = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
const $e95988b653de2e96$export$2f31562143a3e5d4 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$7dcadad908a379a4, (0, $iU3u2.gridSortedRowEntriesSelector), (0, $goCyd.gridRowMaximumTreeDepthSelector), $e95988b653de2e96$export$280aedb9454597a5, $e95988b653de2e96$export$6f9fe133e2c56816, (visibleRowsLookup, sortedRows, maxDepth, filterModel, quickFilterValues)=>{
    if (maxDepth < 2 && !filterModel.items.length && !quickFilterValues?.length) return sortedRows;
    return sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false);
});
const $e95988b653de2e96$export$7a99837e2fd93e42 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$2f31562143a3e5d4, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
const $e95988b653de2e96$export$cd53824a2b232e36 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$6d031b6e8cbaf41c, (0, $iU3u2.gridSortedRowEntriesSelector), (filteredRowsLookup, sortedRows)=>sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
const $e95988b653de2e96$export$4e2a9d76902d271c = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
const $e95988b653de2e96$export$a77377d29742e9a9 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$7a99837e2fd93e42, (0, $goCyd.gridRowTreeSelector), (visibleSortedRowIds, rowTree)=>{
    const depthPositionCounter = {};
    let lastDepth = 0;
    return visibleSortedRowIds.reduce((acc, rowId)=>{
        const rowNode = rowTree[rowId];
        if (!depthPositionCounter[rowNode.depth]) depthPositionCounter[rowNode.depth] = 0;
        // going deeper in the tree should reset the counter
        // since it might have been used in some other branch at the same level, up in the tree
        // going back up should keep the counter and continue where it left off
        if (rowNode.depth > lastDepth) depthPositionCounter[rowNode.depth] = 0;
        lastDepth = rowNode.depth;
        depthPositionCounter[rowNode.depth] += 1;
        acc[rowId] = depthPositionCounter[rowNode.depth];
        return acc;
    }, {});
});
const $e95988b653de2e96$export$b8a7110d1a4c4623 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$2f31562143a3e5d4, (0, $goCyd.gridRowTreeSelector), (0, $goCyd.gridRowMaximumTreeDepthSelector), (visibleSortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return visibleSortedRows;
    return visibleSortedRows.filter((row)=>rowTree[row.id]?.depth === 0);
});
const $e95988b653de2e96$export$96919017bbfaec0d = (0, $cgQ4y.createSelector)($e95988b653de2e96$export$2f31562143a3e5d4, (visibleSortedRows)=>visibleSortedRows.length);
const $e95988b653de2e96$export$f88efd30675963d1 = (0, $cgQ4y.createSelector)($e95988b653de2e96$export$b8a7110d1a4c4623, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
const $e95988b653de2e96$export$ee3e723e6d15f78c = (0, $cgQ4y.createSelector)($e95988b653de2e96$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.length);
const $e95988b653de2e96$export$821b542222c57b39 = (0, $cgQ4y.createSelector)($e95988b653de2e96$export$ee3e723e6d15f78c, $e95988b653de2e96$export$f88efd30675963d1, (totalRowCount, topLevelRowCount)=>totalRowCount - topLevelRowCount);
const $e95988b653de2e96$export$c7447bfbd4ecafcc = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$280aedb9454597a5, (0, $jQEEt.gridColumnLookupSelector), (filterModel, columnLookup)=>filterModel.items?.filter((item)=>{
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!column?.filterOperators || column?.filterOperators?.length === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && item.value?.toString() !== '';
    }));
const $e95988b653de2e96$export$6b2da1ecc84b757a = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$c7447bfbd4ecafcc, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.field]) res[filterItem.field] = [
            filterItem
        ];
        else res[filterItem.field].push(filterItem);
        return res;
    }, {});
    return result;
});

});
parcelRegister("iU3u2", function(module, exports) {

$parcel$export(module.exports, "gridSortedRowIdsSelector", () => $dc3028b3b629fae7$export$e4979ad0a2db8752);
$parcel$export(module.exports, "gridSortedRowEntriesSelector", () => $dc3028b3b629fae7$export$8919e81647813e61);
$parcel$export(module.exports, "gridSortModelSelector", () => $dc3028b3b629fae7$export$55dcc66b73d9a0f9);
$parcel$export(module.exports, "gridSortColumnLookupSelector", () => $dc3028b3b629fae7$export$4dfdcc434a6c5081);

var $cgQ4y = parcelRequire("cgQ4y");

var $goCyd = parcelRequire("goCyd");

var $7sDf4 = parcelRequire("7sDf4");
/**
 * @category Sorting
 * @ignore - do not document.
 */ const $dc3028b3b629fae7$var$gridSortingStateSelector = (state)=>state.sorting;
const $dc3028b3b629fae7$export$e4979ad0a2db8752 = (0, $cgQ4y.createSelector)($dc3028b3b629fae7$var$gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
const $dc3028b3b629fae7$export$8919e81647813e61 = (0, $cgQ4y.createSelectorMemoized)($dc3028b3b629fae7$export$e4979ad0a2db8752, (0, $goCyd.gridRowsLookupSelector), (0, $goCyd.gridRowTreeSelector), (sortedIds, idRowsLookup, rowTree)=>sortedIds.reduce((acc, id)=>{
        const model = idRowsLookup[id];
        if (model) acc.push({
            id: id,
            model: model
        });
        else {
            const rowNode = rowTree[id];
            if (rowNode && (0, $7sDf4.isAutogeneratedRowNode)(rowNode)) acc.push({
                id: id,
                model: {
                    [(0, $7sDf4.GRID_ID_AUTOGENERATED)]: id
                }
            });
        }
        return acc;
    }, []));
const $dc3028b3b629fae7$export$55dcc66b73d9a0f9 = (0, $cgQ4y.createSelector)($dc3028b3b629fae7$var$gridSortingStateSelector, (sorting)=>sorting.sortModel);
const $dc3028b3b629fae7$export$4dfdcc434a6c5081 = (0, $cgQ4y.createSelectorMemoized)($dc3028b3b629fae7$export$55dcc66b73d9a0f9, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});
const $dc3028b3b629fae7$export$d0aac76ef888d9fe = (0, $cgQ4y.createSelectorMemoized)($dc3028b3b629fae7$export$e4979ad0a2db8752, (sortedIds)=>{
    return sortedIds.reduce((acc, id, index)=>{
        acc[id] = index;
        return acc;
    }, Object.create(null));
});

});


parcelRegister("baj2X", function(module, exports) {

$parcel$export(module.exports, "defaultPageSize", () => $820f672e99dc58bd$export$d515e179bb47bd84);
$parcel$export(module.exports, "getPageCount", () => $820f672e99dc58bd$export$b287f0ca5dbff6af);
$parcel$export(module.exports, "getDefaultGridPaginationModel", () => $820f672e99dc58bd$export$73aa7e9d0fff5ee4);
$parcel$export(module.exports, "getValidPage", () => $820f672e99dc58bd$export$41142e40198ee144);
$parcel$export(module.exports, "throwIfPageSizeExceedsTheLimit", () => $820f672e99dc58bd$export$d3cf54bfe8b6931);

var $eFF1m = parcelRequire("eFF1m");
const $820f672e99dc58bd$var$MAX_PAGE_SIZE = 100;
const $820f672e99dc58bd$export$d515e179bb47bd84 = (autoPageSize)=>autoPageSize ? 0 : 100;
const $820f672e99dc58bd$export$b287f0ca5dbff6af = (rowCount, pageSize, page)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    if (rowCount === -1) // With unknown row-count, we can assume a page after the current one
    return page + 2;
    return 0;
};
const $820f672e99dc58bd$export$73aa7e9d0fff5ee4 = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
const $820f672e99dc58bd$export$41142e40198ee144 = (page, pageCount = 0)=>{
    if (pageCount === 0) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
const $820f672e99dc58bd$export$d3cf54bfe8b6931 = (pageSize, signatureProp)=>{
    if (signatureProp === (0, $eFF1m.GridSignature).DataGrid && pageSize > $820f672e99dc58bd$var$MAX_PAGE_SIZE) throw new Error([
        'MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.',
        'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
    ].join('\n'));
};

});



parcelRegister("eB8vK", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $aa0b1f874e340ebd$export$b7d78993b74f766d);
const $aa0b1f874e340ebd$var$userAgent = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : 'empty';
const $aa0b1f874e340ebd$export$b7d78993b74f766d = $aa0b1f874e340ebd$var$userAgent.includes('firefox');

});

parcelRegister("av74L", function(module, exports) {

$parcel$export(module.exports, "gridRowSelectionStateSelector", () => $7a5249c135fd39c1$export$f663bee74a6091fc);
$parcel$export(module.exports, "selectedGridRowsCountSelector", () => $7a5249c135fd39c1$export$2e16a09b9ae82bd3);
$parcel$export(module.exports, "selectedGridRowsSelector", () => $7a5249c135fd39c1$export$dd53f67f8b4cd8b1);
$parcel$export(module.exports, "selectedIdsLookupSelector", () => $7a5249c135fd39c1$export$d5aede24ebfe3c98);

var $cgQ4y = parcelRequire("cgQ4y");

var $goCyd = parcelRequire("goCyd");
const $7a5249c135fd39c1$export$f663bee74a6091fc = (state)=>state.rowSelection;
const $7a5249c135fd39c1$export$2e16a09b9ae82bd3 = (0, $cgQ4y.createSelector)($7a5249c135fd39c1$export$f663bee74a6091fc, (selection)=>selection.length);
const $7a5249c135fd39c1$export$dd53f67f8b4cd8b1 = (0, $cgQ4y.createSelectorMemoized)($7a5249c135fd39c1$export$f663bee74a6091fc, (0, $goCyd.gridRowsLookupSelector), (selectedRows, rowsLookup)=>new Map(selectedRows.map((id)=>[
            id,
            rowsLookup[id]
        ])));
const $7a5249c135fd39c1$export$d5aede24ebfe3c98 = (0, $cgQ4y.createSelectorMemoized)($7a5249c135fd39c1$export$f663bee74a6091fc, (selection)=>selection.reduce((lookup, rowId)=>{
        lookup[rowId] = rowId;
        return lookup;
    }, {}));

});

parcelRegister("9upDV", function(module, exports) {

$parcel$export(module.exports, "gridVirtualizationColumnEnabledSelector", () => $6e8ace88dee0fb7c$export$ad2aa1e9d465cafa);
$parcel$export(module.exports, "gridVirtualizationRowEnabledSelector", () => $6e8ace88dee0fb7c$export$896d309ea36b40bd);
$parcel$export(module.exports, "gridRenderContextSelector", () => $6e8ace88dee0fb7c$export$4cf9f333a030f780);
$parcel$export(module.exports, "gridRenderContextColumnsSelector", () => $6e8ace88dee0fb7c$export$3a5705edd3d1af7e);

var $cgQ4y = parcelRequire("cgQ4y");
const $6e8ace88dee0fb7c$export$38fd8a77b05bfddf = (state)=>state.virtualization;
const $6e8ace88dee0fb7c$export$fb3400598da0ae89 = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$export$38fd8a77b05bfddf, (state)=>state.enabled);
const $6e8ace88dee0fb7c$export$ad2aa1e9d465cafa = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$export$38fd8a77b05bfddf, (state)=>state.enabledForColumns);
const $6e8ace88dee0fb7c$export$896d309ea36b40bd = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$export$38fd8a77b05bfddf, (state)=>state.enabledForRows);
const $6e8ace88dee0fb7c$export$4cf9f333a030f780 = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$export$38fd8a77b05bfddf, (state)=>state.renderContext);
const $6e8ace88dee0fb7c$export$3a5705edd3d1af7e = (0, $cgQ4y.createSelectorMemoized)((state)=>state.virtualization.renderContext.firstColumnIndex, (state)=>state.virtualization.renderContext.lastColumnIndex, (firstColumnIndex, lastColumnIndex)=>({
        firstColumnIndex: firstColumnIndex,
        lastColumnIndex: lastColumnIndex
    }));

});

parcelRegister("dfzFI", function(module, exports) {

$parcel$export(module.exports, "EMPTY_RENDER_CONTEXT", () => $9a5858bc9bdcaed0$export$27eb37bbcd78f450);
$parcel$export(module.exports, "virtualizationStateInitializer", () => $9a5858bc9bdcaed0$export$42963ad70bb69f54);
$parcel$export(module.exports, "useGridVirtualization", () => $9a5858bc9bdcaed0$export$aa0d6df32cccbd53);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
const $9a5858bc9bdcaed0$export$27eb37bbcd78f450 = {
    firstRowIndex: 0,
    lastRowIndex: 0,
    firstColumnIndex: 0,
    lastColumnIndex: 0
};
const $9a5858bc9bdcaed0$export$42963ad70bb69f54 = (state, props)=>{
    const { disableVirtualization: disableVirtualization, autoHeight: autoHeight } = props;
    const virtualization = {
        enabled: !disableVirtualization,
        enabledForColumns: !disableVirtualization,
        enabledForRows: !disableVirtualization && !autoHeight,
        renderContext: $9a5858bc9bdcaed0$export$27eb37bbcd78f450
    };
    return (0, $8nd05.default)({}, state, {
        virtualization: virtualization
    });
};
function $9a5858bc9bdcaed0$export$aa0d6df32cccbd53(apiRef, props) {
    /*
   * API METHODS
   */ const setVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                virtualization: (0, $8nd05.default)({}, state.virtualization, {
                    enabled: enabled,
                    enabledForColumns: enabled,
                    enabledForRows: enabled && !props.autoHeight
                })
            }));
    };
    const setColumnVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                virtualization: (0, $8nd05.default)({}, state.virtualization, {
                    enabledForColumns: enabled
                })
            }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    (0, $ivFej.useGridApiMethod)(apiRef, api, 'public');
    /*
   * EFFECTS
   */ /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(()=>{
        setVirtualization(!props.disableVirtualization);
    }, [
        props.disableVirtualization,
        props.autoHeight
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }

});
parcelRegister("ivFej", function(module, exports) {

$parcel$export(module.exports, "useGridApiMethod", () => $d79b1aa4f5237e85$export$739f6b6a65e76d6c);

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
function $d79b1aa4f5237e85$export$739f6b6a65e76d6c(privateApiRef, apiMethods, visibility) {
    const isFirstRender = $acw62.useRef(true);
    (0, $eEJPp.default)(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}

});


parcelRegister("hMoDT", function(module, exports) {

$parcel$export(module.exports, "gridRowSpanningHiddenCellsSelector", () => $cf1a08d3904b092e$export$229eb2b26df25c76);
$parcel$export(module.exports, "gridRowSpanningSpannedCellsSelector", () => $cf1a08d3904b092e$export$bd3ea60af8c4907f);
$parcel$export(module.exports, "gridRowSpanningHiddenCellsOriginMapSelector", () => $cf1a08d3904b092e$export$e64f0d3660d5db6b);

var $cgQ4y = parcelRequire("cgQ4y");
const $cf1a08d3904b092e$var$gridRowSpanningStateSelector = (state)=>state.rowSpanning;
const $cf1a08d3904b092e$export$229eb2b26df25c76 = (0, $cgQ4y.createSelector)($cf1a08d3904b092e$var$gridRowSpanningStateSelector, (rowSpanning)=>rowSpanning.hiddenCells);
const $cf1a08d3904b092e$export$bd3ea60af8c4907f = (0, $cgQ4y.createSelector)($cf1a08d3904b092e$var$gridRowSpanningStateSelector, (rowSpanning)=>rowSpanning.spannedCells);
const $cf1a08d3904b092e$export$e64f0d3660d5db6b = (0, $cgQ4y.createSelector)($cf1a08d3904b092e$var$gridRowSpanningStateSelector, (rowSpanning)=>rowSpanning.hiddenCellOriginMap);

});

parcelRegister("8BltG", function(module, exports) {

$parcel$export(module.exports, "gridListColumnSelector", () => $6432707a9c80427e$export$aeeda57ada9bc1ee);
/**
 * Get the list column definition
 * @category List View
 * @ignore - Do not document
 */ const $6432707a9c80427e$export$aeeda57ada9bc1ee = (state)=>state.listViewColumn;

});

parcelRegister("98F89", function(module, exports) {

$parcel$export(module.exports, "gridFocusedVirtualCellSelector", () => $6a74c410c8e04714$export$6082669fb6748800);

var $8nd05 = parcelRequire("8nd05");

var $4KtEQ = parcelRequire("4KtEQ");

var $cgQ4y = parcelRequire("cgQ4y");

var $jQEEt = parcelRequire("jQEEt");

var $9upDV = parcelRequire("9upDV");

var $drCmI = parcelRequire("drCmI");

var $gPWuj = parcelRequire("gPWuj");

var $goCyd = parcelRequire("goCyd");
const $6a74c410c8e04714$var$gridIsFocusedCellOutOfContext = (0, $4KtEQ.createSelector)((0, $drCmI.gridFocusCellSelector), (0, $9upDV.gridRenderContextSelector), (0, $gPWuj.gridVisibleRowsSelector), (0, $jQEEt.gridVisibleColumnDefinitionsSelector), (0, $goCyd.gridRowsLookupSelector), (focusedCell, renderContext, currentPage, visibleColumns, rows)=>{
    if (!focusedCell) return false;
    const row = rows[focusedCell.id];
    if (!row) return false;
    const rowIndex = currentPage.rowToIndexMap.get(row);
    const columnIndex = visibleColumns.slice(renderContext.firstColumnIndex, renderContext.lastColumnIndex).findIndex((column)=>column.field === focusedCell.field);
    const isInRenderContext = rowIndex !== undefined && columnIndex !== -1 && rowIndex >= renderContext.firstRowIndex && rowIndex <= renderContext.lastRowIndex;
    return !isInRenderContext;
});
const $6a74c410c8e04714$export$6082669fb6748800 = (0, $cgQ4y.createSelectorMemoized)($6a74c410c8e04714$var$gridIsFocusedCellOutOfContext, (0, $jQEEt.gridVisibleColumnDefinitionsSelector), (0, $gPWuj.gridVisibleRowsSelector), (0, $goCyd.gridRowsLookupSelector), (0, $drCmI.gridFocusCellSelector), (isFocusedCellOutOfRenderContext, visibleColumns, currentPage, rows, focusedCell)=>{
    if (!isFocusedCellOutOfRenderContext) return null;
    const row = rows[focusedCell.id];
    if (!row) return null;
    const rowIndex = currentPage.rowToIndexMap.get(row);
    if (rowIndex === undefined) return null;
    const columnIndex = visibleColumns.findIndex((column)=>column.field === focusedCell.field);
    if (columnIndex === -1) return null;
    return (0, $8nd05.default)({}, focusedCell, {
        rowIndex: rowIndex,
        columnIndex: columnIndex
    });
});

});
parcelRegister("drCmI", function(module, exports) {

$parcel$export(module.exports, "gridFocusCellSelector", () => $9c9b8e89fddd633d$export$74af8aada6269d3);
$parcel$export(module.exports, "gridFocusColumnHeaderSelector", () => $9c9b8e89fddd633d$export$cefd405855792f4a);
$parcel$export(module.exports, "gridFocusColumnGroupHeaderSelector", () => $9c9b8e89fddd633d$export$3eeedc3f7263df61);
$parcel$export(module.exports, "gridTabIndexCellSelector", () => $9c9b8e89fddd633d$export$2c47652a1f657d56);
$parcel$export(module.exports, "gridTabIndexColumnHeaderSelector", () => $9c9b8e89fddd633d$export$29da670438604dbd);
$parcel$export(module.exports, "gridTabIndexColumnGroupHeaderSelector", () => $9c9b8e89fddd633d$export$37a54bd010f498d2);

var $cgQ4y = parcelRequire("cgQ4y");
const $9c9b8e89fddd633d$export$ce21bef7bd3a9c4e = (state)=>state.focus;
const $9c9b8e89fddd633d$export$74af8aada6269d3 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$ce21bef7bd3a9c4e, (focusState)=>focusState.cell);
const $9c9b8e89fddd633d$export$cefd405855792f4a = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeader);
const $9c9b8e89fddd633d$export$50853df99eaddaf5 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeaderFilter);
const $9c9b8e89fddd633d$export$3eeedc3f7263df61 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnGroupHeader);
const $9c9b8e89fddd633d$export$3ab3abde27f70192 = (state)=>state.tabIndex;
const $9c9b8e89fddd633d$export$2c47652a1f657d56 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$3ab3abde27f70192, (state)=>state.cell);
const $9c9b8e89fddd633d$export$29da670438604dbd = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$3ab3abde27f70192, (state)=>state.columnHeader);
const $9c9b8e89fddd633d$export$441ae2090306a1e2 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$3ab3abde27f70192, (state)=>state.columnHeaderFilter);
const $9c9b8e89fddd633d$export$37a54bd010f498d2 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$3ab3abde27f70192, (state)=>state.columnGroupHeader);

});


parcelRegister("af8j6", function(module, exports) {

$parcel$export(module.exports, "roundToDecimalPlaces", () => $7751bfb0bc82a0cf$export$28cd30446ab5724a);
function $7751bfb0bc82a0cf$export$28cd30446ab5724a(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}

});

parcelRegister("hWI6v", function(module, exports) {

$parcel$export(module.exports, "isJSDOM", () => $d10a1095bdae3394$export$c8f880a2d81914c4);
const $d10a1095bdae3394$export$c8f880a2d81914c4 = typeof window !== 'undefined' && /jsdom|HappyDOM/.test(window.navigator.userAgent);

});


parcelRegister("dDKMM", function(module, exports) {

$parcel$export(module.exports, "useGridOverlays", () => $9ee3358fa4255e5b$export$ba0092e600a72afc);

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $k278Q = parcelRequire("k278Q");

var $goCyd = parcelRequire("goCyd");

var $goCyd = parcelRequire("goCyd");
const $9ee3358fa4255e5b$export$ba0092e600a72afc = ()=>{
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowCountSelector));
    const visibleRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridExpandedRowCountSelector));
    const pinnedRowsCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridPinnedRowsCountSelector));
    const noRows = totalRowCount === 0 && pinnedRowsCount === 0;
    const loading = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowsLoadingSelector));
    const showNoRowsOverlay = !loading && noRows;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    let overlayType = null;
    let loadingOverlayVariant = null;
    if (showNoRowsOverlay) overlayType = 'noRowsOverlay';
    if (showNoResultsOverlay) overlayType = 'noResultsOverlay';
    if (loading) {
        overlayType = 'loadingOverlay';
        loadingOverlayVariant = rootProps.slotProps?.loadingOverlay?.[noRows ? 'noRowsVariant' : 'variant'] || null;
    }
    return {
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
};

});

parcelRegister("6ru7t", function(module, exports) {

$parcel$export(module.exports, "GridOverlays", () => $4b0ca0cb82103871$export$867f5fc44327bee5);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");

var $7sDf4 = parcelRequire("7sDf4");

var $5sOMZ = parcelRequire("5sOMZ");

var $61HyH = parcelRequire("61HyH");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $4b0ca0cb82103871$var$GridOverlayWrapperRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapper',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant',
    overridesResolver: (props, styles)=>styles.overlayWrapper
})(({ overlayType: overlayType, loadingOverlayVariant: loadingOverlayVariant })=>// Skeleton overlay should flow with the scroll container and not be sticky
    loadingOverlayVariant !== 'skeleton' ? {
        position: 'sticky',
        // To stay in place while scrolling
        top: 'var(--DataGrid-headersTotalHeight)',
        // TODO: take pinned rows into account
        left: 0,
        width: 0,
        // To stay above the content instead of shifting it down
        height: 0,
        // To stay above the content instead of shifting it down
        zIndex: overlayType === 'loadingOverlay' ? 5 // Should be above pinned columns, pinned rows, and detail panel
         : 4 // Should be above pinned columns and detail panel
    } : {});
const $4b0ca0cb82103871$var$GridOverlayWrapperInner = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapperInner',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant',
    overridesResolver: (props, styles)=>styles.overlayWrapperInner
})({});
const $4b0ca0cb82103871$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlayWrapper'
        ],
        inner: [
            'overlayWrapperInner'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $4b0ca0cb82103871$var$GridOverlayWrapper(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const dimensions = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridDimensionsSelector));
    let height = Math.max(dimensions.viewportOuterSize.height - dimensions.topContainerHeight - dimensions.bottomContainerHeight - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0), 0);
    if (height === 0) height = (0, $7sDf4.minimalContentHeight);
    const classes = $4b0ca0cb82103871$var$useUtilityClasses((0, $8nd05.default)({}, props, {
        classes: rootProps.classes
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapperRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root)
    }, props, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapperInner, (0, $8nd05.default)({
            className: (0, $9QePP.default)(classes.inner),
            style: {
                height: height,
                width: dimensions.viewportOuterSize.width
            }
        }, props))
    }));
}
function $4b0ca0cb82103871$export$867f5fc44327bee5(props) {
    const { overlayType: overlayType } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (!overlayType) return null;
    const Overlay = rootProps.slots?.[overlayType];
    const overlayProps = rootProps.slotProps?.[overlayType];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapper, (0, $8nd05.default)({}, props, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Overlay, (0, $8nd05.default)({}, overlayProps))
    }));
}

});

parcelRegister("dS4gY", function(module, exports) {

$parcel$export(module.exports, "GridHeaders", () => $a193a1fff9f5c318$export$151397d1f4bb9231);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $kUNkQ = parcelRequire("kUNkQ");

var $er55f = parcelRequire("er55f");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $jQEEt = parcelRequire("jQEEt");

var $k278Q = parcelRequire("k278Q");

var $iU3u2 = parcelRequire("iU3u2");

var $drCmI = parcelRequire("drCmI");

var $hMyIf = parcelRequire("hMyIf");

var $eOaSX = parcelRequire("eOaSX");

var $ayMG0 = parcelRequire("ayMG0");
function $a193a1fff9f5c318$var$GridHeaders() {
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisibleColumnDefinitionsSelector));
    const filterColumnLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilterActiveItemsLookupSelector));
    const sortColumnLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $iU3u2.gridSortColumnLookupSelector));
    const columnHeaderTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridTabIndexColumnHeaderSelector));
    const hasNoCellTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, ()=>(0, $drCmI.gridTabIndexCellSelector)(apiRef) === null);
    const columnGroupHeaderTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridTabIndexColumnGroupHeaderSelector));
    const columnHeaderFocus = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridFocusColumnHeaderSelector));
    const columnGroupHeaderFocus = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridFocusColumnGroupHeaderSelector));
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector));
    const columnMenuState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $eOaSX.gridColumnMenuSelector));
    const columnVisibility = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnVisibilityModelSelector));
    const columnGroupsHeaderStructure = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsHeaderStructureSelector));
    const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && hasNoCellTabIndexState);
    const columnsContainerRef = apiRef.current.columnHeadersContainerRef;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaders, (0, $8nd05.default)({
        ref: columnsContainerRef,
        visibleColumns: visibleColumns,
        filterColumnLookup: filterColumnLookup,
        sortColumnLookup: sortColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    }, rootProps.slotProps?.columnHeaders));
}
const $a193a1fff9f5c318$export$151397d1f4bb9231 = (0, $kUNkQ.fastMemo)($a193a1fff9f5c318$var$GridHeaders);

});
parcelRegister("eOaSX", function(module, exports) {

$parcel$export(module.exports, "gridColumnMenuSelector", () => $ac7e2dd161e207a6$export$5479c2fb8e9fd070);
const $ac7e2dd161e207a6$export$5479c2fb8e9fd070 = (state)=>state.columnMenu;

});


parcelRegister("kcb79", function(module, exports) {

$parcel$export(module.exports, "GridMainContainer", () => $eb3d8cbc702f4647$export$74039dccf215bc2a);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $izOUK = parcelRequire("izOUK");

var $gJsNs = parcelRequire("gJsNs");

var $jDpXp = parcelRequire("jDpXp");

var $3J8MS = parcelRequire("3J8MS");

var $ayMG0 = parcelRequire("ayMG0");
const $eb3d8cbc702f4647$var$GridPanelAnchor = (0, $izOUK.styled)('div')({
    position: 'absolute',
    top: `var(--DataGrid-headersTotalHeight)`,
    left: 0,
    width: 'calc(100% - (var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))'
});
const $eb3d8cbc702f4647$var$Element = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Main',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.main,
            ownerState.hasPinnedRight && styles['main--hasPinnedRight'],
            ownerState.loadingOverlayVariant === 'skeleton' && styles['main--hasSkeletonLoadingOverlay']
        ];
    }
})({
    flexGrow: 1,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
});
const $eb3d8cbc702f4647$export$74039dccf215bc2a = (0, $gJsNs.forwardRef)((props, ref)=>{
    const { ownerState: ownerState } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const configuration = (0, $3J8MS.useGridConfiguration)();
    const ariaAttributes = configuration.hooks.useGridAriaAttributes();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($eb3d8cbc702f4647$var$Element, (0, $8nd05.default)({
        ownerState: ownerState,
        className: props.className,
        tabIndex: -1
    }, ariaAttributes, rootProps.slotProps?.main, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($eb3d8cbc702f4647$var$GridPanelAnchor, {
                role: "presentation",
                "data-id": "gridPanelAnchor"
            }),
            props.children
        ]
    }));
});

});
parcelRegister("3J8MS", function(module, exports) {

$parcel$export(module.exports, "useGridConfiguration", () => $2b6c64068d1db0b4$export$9fe1679701f06bb7);

var $acw62 = parcelRequire("acw62");

var $jdJe4 = parcelRequire("jdJe4");
const $2b6c64068d1db0b4$export$9fe1679701f06bb7 = ()=>{
    const configuration = $acw62.useContext((0, $jdJe4.GridConfigurationContext));
    if (configuration === undefined) throw new Error([
        'MUI X: Could not find the Data Grid configuration context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return configuration;
};

});
parcelRegister("jdJe4", function(module, exports) {

$parcel$export(module.exports, "GridConfigurationContext", () => $dfe2502031b16236$export$714d6aa898a12d6c);

var $acw62 = parcelRequire("acw62");
'use client';
const $dfe2502031b16236$export$714d6aa898a12d6c = /*#__PURE__*/ $acw62.createContext(undefined);

});



parcelRegister("8yMKs", function(module, exports) {

$parcel$export(module.exports, "GridTopContainer", () => $63b75016458d5774$export$820d93aabd2ee77d);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $63b75016458d5774$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'topContainer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), {});
};
const $63b75016458d5774$var$Element = (0, $izOUK.styled)('div')({
    position: 'sticky',
    zIndex: 40,
    top: 0
});
function $63b75016458d5774$export$820d93aabd2ee77d(props) {
    const classes = $63b75016458d5774$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($63b75016458d5774$var$Element, (0, $8nd05.default)({}, props, {
        className: (0, $9QePP.default)(classes.root, (0, $5H1vo.gridClasses)['container--top']),
        role: "presentation"
    }));
}

});

parcelRegister("1GTuR", function(module, exports) {

$parcel$export(module.exports, "GridBottomContainer", () => $13b4c32d410c28d7$export$7b1aa135d0232b20);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $13b4c32d410c28d7$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'bottomContainer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), {});
};
const $13b4c32d410c28d7$var$Element = (0, $izOUK.styled)('div')({
    position: 'sticky',
    zIndex: 40,
    bottom: 'calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))'
});
function $13b4c32d410c28d7$export$7b1aa135d0232b20(props) {
    const classes = $13b4c32d410c28d7$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($13b4c32d410c28d7$var$Element, (0, $8nd05.default)({}, props, {
        className: (0, $9QePP.default)(classes.root, (0, $5H1vo.gridClasses)['container--bottom']),
        role: "presentation"
    }));
}

});

parcelRegister("lLmsJ", function(module, exports) {

$parcel$export(module.exports, "GridVirtualScrollerContent", () => $fd7f69586e4a3224$export$97d48eb8ba00afb8);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");

var $gJsNs = parcelRequire("gJsNs");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $fd7f69586e4a3224$var$useUtilityClasses = (props, overflowedContent)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            'virtualScrollerContent',
            overflowedContent && 'virtualScrollerContent--overflowed'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $fd7f69586e4a3224$var$VirtualScrollerContentRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerContent',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScrollerContent,
            ownerState.overflowedContent && styles['virtualScrollerContent--overflowed']
        ];
    }
})({});
const $fd7f69586e4a3224$export$97d48eb8ba00afb8 = (0, $gJsNs.forwardRef)(function GridVirtualScrollerContent(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const overflowedContent = !rootProps.autoHeight && props.style?.minHeight === 'auto';
    const classes = $fd7f69586e4a3224$var$useUtilityClasses(rootProps, overflowedContent);
    const ownerState = {
        classes: rootProps.classes,
        overflowedContent: overflowedContent
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fd7f69586e4a3224$var$VirtualScrollerContentRoot, (0, $8nd05.default)({}, props, {
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, props.className),
        ref: ref
    }));
});

});

parcelRegister("a8jkJ", function(module, exports) {

$parcel$export(module.exports, "GridVirtualScrollerFiller", () => $7609a5f754a72e14$export$832a8b454433e1c8);
parcelRequire("acw62");

var $izOUK = parcelRequire("izOUK");

var $kUNkQ = parcelRequire("kUNkQ");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $61HyH = parcelRequire("61HyH");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $7609a5f754a72e14$var$Filler = (0, $izOUK.styled)('div')({
    display: 'flex',
    flexDirection: 'row',
    width: 'var(--DataGrid-rowWidth)',
    boxSizing: 'border-box'
});
const $7609a5f754a72e14$var$Pinned = (0, $izOUK.styled)('div')({
    position: 'sticky',
    height: '100%',
    boxSizing: 'border-box',
    borderTop: '1px solid var(--rowBorderColor)',
    backgroundColor: 'var(--DataGrid-pinnedBackground)'
});
const $7609a5f754a72e14$var$PinnedLeft = (0, $izOUK.styled)($7609a5f754a72e14$var$Pinned)({
    left: 0,
    borderRight: '1px solid var(--rowBorderColor)'
});
const $7609a5f754a72e14$var$PinnedRight = (0, $izOUK.styled)($7609a5f754a72e14$var$Pinned)({
    right: 0,
    borderLeft: '1px solid var(--rowBorderColor)'
});
const $7609a5f754a72e14$var$Main = (0, $izOUK.styled)('div')({
    flexGrow: 1,
    borderTop: '1px solid var(--rowBorderColor)'
});
function $7609a5f754a72e14$var$GridVirtualScrollerFiller({ rowsLength: rowsLength }) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const { viewportOuterSize: viewportOuterSize, minimumSize: minimumSize, hasScrollX: hasScrollX, hasScrollY: hasScrollY, scrollbarSize: scrollbarSize, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth } = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridDimensionsSelector));
    const height = hasScrollX ? scrollbarSize : 0;
    const needsLastRowBorder = viewportOuterSize.height - minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7609a5f754a72e14$var$Filler, {
        className: (0, $5H1vo.gridClasses).filler,
        role: "presentation",
        style: {
            height: height,
            '--rowBorderColor': rowsLength === 0 ? 'transparent' : 'var(--DataGrid-rowBorderColor)'
        },
        children: [
            leftPinnedWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$PinnedLeft, {
                className: (0, $5H1vo.gridClasses)['filler--pinnedLeft'],
                style: {
                    width: leftPinnedWidth
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$Main, {}),
            rightPinnedWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$PinnedRight, {
                className: (0, $5H1vo.gridClasses)['filler--pinnedRight'],
                style: {
                    width: rightPinnedWidth + (hasScrollY ? scrollbarSize : 0)
                }
            })
        ]
    });
}
const $7609a5f754a72e14$export$832a8b454433e1c8 = (0, $kUNkQ.fastMemo)($7609a5f754a72e14$var$GridVirtualScrollerFiller);

});

parcelRegister("5v0S6", function(module, exports) {

$parcel$export(module.exports, "GridVirtualScrollerRenderZone", () => $401086177e70acda$export$95930d31e6a9269f);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");

var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $bdqIg = parcelRequire("bdqIg");

var $9upDV = parcelRequire("9upDV");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $401086177e70acda$var$_excluded = [
    "className"
];
const $401086177e70acda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScrollerRenderZone'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $401086177e70acda$var$VirtualScrollerRenderZoneRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerRenderZone',
    overridesResolver: (props, styles)=>styles.virtualScrollerRenderZone
})({
    position: 'absolute',
    display: 'flex',
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: 'column'
});
const $401086177e70acda$export$95930d31e6a9269f = (0, $gJsNs.forwardRef)(function GridVirtualScrollerRenderZone(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $401086177e70acda$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $401086177e70acda$var$useUtilityClasses(rootProps);
    const offsetTop = (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
        const renderContext = (0, $9upDV.gridRenderContextSelector)(apiRef);
        const rowsMeta = (0, $bdqIg.gridRowsMetaSelector)(apiRef.current.state);
        return rowsMeta.positions[renderContext.firstRowIndex] ?? 0;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($401086177e70acda$var$VirtualScrollerRenderZoneRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps,
        style: {
            transform: `translate3d(0, ${offsetTop}px, 0)`
        }
    }, other, {
        ref: ref
    }));
});

});

parcelRegister("cv3bf", function(module, exports) {

$parcel$export(module.exports, "GridVirtualScrollbar", () => $919ad8d5ff9ebb8c$export$96aeae8bf32b76b8);

var $acw62 = parcelRequire("acw62");

var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $gJsNs = parcelRequire("gJsNs");

var $dOphX = parcelRequire("dOphX");

var $er55f = parcelRequire("er55f");

var $61HyH = parcelRequire("61HyH");
var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $919ad8d5ff9ebb8c$var$useUtilityClasses = (ownerState, position)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollbar',
            `scrollbar--${position}`
        ],
        content: [
            'scrollbarContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $919ad8d5ff9ebb8c$var$Scrollbar = (0, $izOUK.styled)('div')({
    position: 'absolute',
    display: 'inline-block',
    zIndex: 60,
    '&:hover': {
        zIndex: 70
    },
    // In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
    // their size to be 0px throughout all the calculations, but the floating scrollbar container does need
    // to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
    // don't have a method to find the required size for scrollbars on those platforms.
    '--size': 'calc(max(var(--DataGrid-scrollbarSize), 14px))'
});
const $919ad8d5ff9ebb8c$var$ScrollbarVertical = (0, $izOUK.styled)($919ad8d5ff9ebb8c$var$Scrollbar)({
    width: 'var(--size)',
    height: 'calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-topContainerHeight) - var(--DataGrid-bottomContainerHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))',
    overflowY: 'auto',
    overflowX: 'hidden',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        width: 'var(--size)'
    },
    top: 'var(--DataGrid-topContainerHeight)',
    right: '0px'
});
const $919ad8d5ff9ebb8c$var$ScrollbarHorizontal = (0, $izOUK.styled)($919ad8d5ff9ebb8c$var$Scrollbar)({
    width: '100%',
    height: 'var(--size)',
    overflowY: 'hidden',
    overflowX: 'auto',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        height: 'var(--size)'
    },
    bottom: '0px'
});
const $919ad8d5ff9ebb8c$export$96aeae8bf32b76b8 = (0, $gJsNs.forwardRef)(function GridVirtualScrollbar(props, ref) {
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isLocked = $acw62.useRef(false);
    const lastPosition = $acw62.useRef(0);
    const scrollbarRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const classes = $919ad8d5ff9ebb8c$var$useUtilityClasses(rootProps, props.position);
    const dimensions = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridDimensionsSelector));
    const propertyDimension = props.position === 'vertical' ? 'height' : 'width';
    const propertyScroll = props.position === 'vertical' ? 'scrollTop' : 'scrollLeft';
    const propertyScrollPosition = props.position === 'vertical' ? 'top' : 'left';
    const hasScroll = props.position === 'vertical' ? dimensions.hasScrollX : dimensions.hasScrollY;
    const contentSize = dimensions.minimumSize[propertyDimension] + (hasScroll ? dimensions.scrollbarSize : 0);
    const scrollbarSize = props.position === 'vertical' ? dimensions.viewportInnerSize.height : dimensions.viewportOuterSize.width;
    const scrollbarInnerSize = scrollbarSize * (contentSize / dimensions.viewportOuterSize[propertyDimension]);
    const onScrollerScroll = (0, $13KXh.default)(()=>{
        const scrollbar = scrollbarRef.current;
        const scrollPosition = props.scrollPosition.current;
        if (!scrollbar) return;
        if (scrollPosition[propertyScrollPosition] === lastPosition.current) return;
        lastPosition.current = scrollPosition[propertyScrollPosition];
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        const value = scrollPosition[propertyScrollPosition] / contentSize;
        scrollbar[propertyScroll] = value * scrollbarInnerSize;
    });
    const onScrollbarScroll = (0, $13KXh.default)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        if (!scrollbar) return;
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        const value = scrollbar[propertyScroll] / scrollbarInnerSize;
        scroller[propertyScroll] = value * contentSize;
    });
    (0, $dOphX.default)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        const options = {
            passive: true
        };
        scroller.addEventListener('scroll', onScrollerScroll, options);
        scrollbar.addEventListener('scroll', onScrollbarScroll, options);
        return ()=>{
            scroller.removeEventListener('scroll', onScrollerScroll, options);
            scrollbar.removeEventListener('scroll', onScrollbarScroll, options);
        };
    });
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        content.style.setProperty(propertyDimension, `${scrollbarInnerSize}px`);
    }, [
        scrollbarInnerSize,
        propertyDimension
    ]);
    const Container = props.position === 'vertical' ? $919ad8d5ff9ebb8c$var$ScrollbarVertical : $919ad8d5ff9ebb8c$var$ScrollbarHorizontal;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Container, {
        ref: (0, $3qSdM.default)(ref, scrollbarRef),
        className: classes.root,
        style: props.position === 'vertical' && rootProps.unstable_listView ? {
            height: '100%',
            top: 0
        } : undefined,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: (event)=>{
            event.target.blur();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ref: contentRef,
            className: classes.content
        })
    });
});

});


parcelRegister("ew3Bl", function(module, exports) {

$parcel$export(module.exports, "GridFooterPlaceholder", () => $a916d8fa7c7fb6bb$export$6d80c98441abb3ab);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $a916d8fa7c7fb6bb$export$6d80c98441abb3ab() {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.footer, (0, $8nd05.default)({}, rootProps.slotProps?.footer /* FIXME: typing error */ ));
}

});


parcelRegister("5tnRA", function(module, exports) {

$parcel$export(module.exports, "useGridAriaAttributes", () => $3fc22bf49019df83$export$89716d1110d32214);

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $hMyIf = parcelRequire("hMyIf");

var $goCyd = parcelRequire("goCyd");

var $er55f = parcelRequire("er55f");

var $iN63z = parcelRequire("iN63z");

var $k278Q = parcelRequire("k278Q");
const $3fc22bf49019df83$export$89716d1110d32214 = ()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisibleColumnDefinitionsSelector));
    const accessibleRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridExpandedRowCountSelector));
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector));
    const pinnedRowsCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridPinnedRowsCountSelector));
    return {
        role: 'grid',
        'aria-colcount': visibleColumns.length,
        'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + accessibleRowCount,
        'aria-multiselectable': (0, $iN63z.isMultipleRowSelectionEnabled)(rootProps)
    };
};

});
parcelRegister("iN63z", function(module, exports) {

$parcel$export(module.exports, "getCheckboxPropsSelector", () => $dae18049c8685698$export$7fbd0b5bf52ca533);
$parcel$export(module.exports, "isMultipleRowSelectionEnabled", () => $dae18049c8685698$export$cfcdc2e1121f7851);
$parcel$export(module.exports, "findRowsToSelect", () => $dae18049c8685698$export$a8171774e887a9d0);
$parcel$export(module.exports, "findRowsToDeselect", () => $dae18049c8685698$export$dbbc58cbb95afec2);

var $eFF1m = parcelRequire("eFF1m");

var $7sDf4 = parcelRequire("7sDf4");

var $k278Q = parcelRequire("k278Q");

var $iU3u2 = parcelRequire("iU3u2");

var $av74L = parcelRequire("av74L");

var $goCyd = parcelRequire("goCyd");

var $cgQ4y = parcelRequire("cgQ4y");
const $dae18049c8685698$export$aec8936a41d479a2 = {
    parents: false,
    descendants: false
};
function $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, groupId) {
    const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
    const sortedRowIds = (0, $iU3u2.gridSortedRowIdsSelector)(apiRef);
    const filteredRowsLookup = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
    const groupNode = rowTree[groupId];
    if (!groupNode || groupNode.type !== 'group') return [];
    const descendants = [];
    const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
    for(let index = startIndex; index < sortedRowIds.length && rowTree[sortedRowIds[index]]?.depth > groupNode.depth; index += 1){
        const id = sortedRowIds[index];
        if (filteredRowsLookup[id] !== false && apiRef.current.isRowSelectable(id)) descendants.push(id);
    }
    return descendants;
}
function $dae18049c8685698$export$7fbd0b5bf52ca533(groupId, autoSelectParents) {
    return (0, $cgQ4y.createSelector)((0, $goCyd.gridRowTreeSelector), (0, $iU3u2.gridSortedRowIdsSelector), (0, $k278Q.gridFilteredRowsLookupSelector), (0, $av74L.selectedIdsLookupSelector), (rowTree, sortedRowIds, filteredRowsLookup, rowSelectionLookup)=>{
        const groupNode = rowTree[groupId];
        if (!groupNode || groupNode.type !== 'group') return {
            isIndeterminate: false,
            isChecked: rowSelectionLookup[groupId] === groupId
        };
        if (rowSelectionLookup[groupId] === groupId) return {
            isIndeterminate: false,
            isChecked: true
        };
        let selectableDescendantsCount = 0;
        let selectedDescendantsCount = 0;
        const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
        for(let index = startIndex; index < sortedRowIds.length && rowTree[sortedRowIds[index]]?.depth > groupNode.depth; index += 1){
            const id = sortedRowIds[index];
            if (filteredRowsLookup[id] !== false) {
                selectableDescendantsCount += 1;
                if (rowSelectionLookup[id] !== undefined) selectedDescendantsCount += 1;
            }
        }
        return {
            isIndeterminate: selectedDescendantsCount > 0 && (selectedDescendantsCount < selectableDescendantsCount || rowSelectionLookup[groupId] === undefined),
            isChecked: autoSelectParents ? selectedDescendantsCount > 0 : rowSelectionLookup[groupId] === groupId
        };
    });
}
function $dae18049c8685698$export$cfcdc2e1121f7851(props) {
    if (props.signature === (0, $eFF1m.GridSignature).DataGrid) // DataGrid Community has multiple row selection enabled only if checkbox selection is enabled.
    return props.checkboxSelection && props.disableMultipleRowSelection !== true;
    return !props.disableMultipleRowSelection;
}
const $dae18049c8685698$var$getRowNodeParents = (tree, id)=>{
    const parents = [];
    let parent = id;
    while(parent != null && parent !== (0, $7sDf4.GRID_ROOT_GROUP_ID)){
        const node = tree[parent];
        if (!node) return parents;
        parents.push(parent);
        parent = node.parent;
    }
    return parents;
};
const $dae18049c8685698$var$getFilteredRowNodeSiblings = (tree, filteredRows, id)=>{
    const node = tree[id];
    if (!node) return [];
    const parent = node.parent;
    if (parent == null) return [];
    const parentNode = tree[parent];
    return parentNode.children.filter((childId)=>childId !== id && filteredRows[childId] !== false);
};
const $dae18049c8685698$export$a8171774e887a9d0 = (apiRef, tree, selectedRow, autoSelectDescendants, autoSelectParents, addRow, selectedIds = new Set((0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state)))=>{
    const filteredRows = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
    const selectedDescendants = new Set([]);
    if (!autoSelectDescendants && !autoSelectParents || filteredRows[selectedRow] === false) return;
    if (autoSelectDescendants) {
        const rowNode = tree[selectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, selectedRow);
            descendants.forEach((rowId)=>{
                addRow(rowId);
                selectedDescendants.add(rowId);
            });
        }
    }
    if (autoSelectParents) {
        const checkAllDescendantsSelected = (rowId)=>{
            if (!selectedIds.has(rowId) && !selectedDescendants.has(rowId)) return false;
            const node = tree[rowId];
            if (!node) return false;
            if (node.type !== 'group') return true;
            return node.children.every(checkAllDescendantsSelected);
        };
        const traverseParents = (rowId)=>{
            const siblings = $dae18049c8685698$var$getFilteredRowNodeSiblings(tree, filteredRows, rowId);
            if (siblings.length === 0 || siblings.every(checkAllDescendantsSelected)) {
                const rowNode = tree[rowId];
                const parent = rowNode?.parent;
                if (parent != null && parent !== (0, $7sDf4.GRID_ROOT_GROUP_ID) && apiRef.current.isRowSelectable(parent)) {
                    addRow(parent);
                    selectedDescendants.add(parent);
                    traverseParents(parent);
                }
            }
        };
        traverseParents(selectedRow);
    }
};
const $dae18049c8685698$export$dbbc58cbb95afec2 = (apiRef, tree, deselectedRow, autoSelectDescendants, autoSelectParents, removeRow)=>{
    const selectedIdsLookup = (0, $av74L.selectedIdsLookupSelector)(apiRef);
    if (!autoSelectParents && !autoSelectDescendants) return;
    if (autoSelectParents) {
        const allParents = $dae18049c8685698$var$getRowNodeParents(tree, deselectedRow);
        allParents.forEach((parent)=>{
            const isSelected = selectedIdsLookup[parent] === parent;
            if (isSelected) removeRow(parent);
        });
    }
    if (autoSelectDescendants) {
        const rowNode = tree[deselectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, deselectedRow);
            descendants.forEach((descendant)=>{
                removeRow(descendant);
            });
        }
    }
};

});


parcelRegister("8TaLs", function(module, exports) {

$parcel$export(module.exports, "useGridRowAriaAttributes", () => $678bcf5a7d335a8a$export$c27cdb450c323320);

var $acw62 = parcelRequire("acw62");

var $av74L = parcelRequire("av74L");

var $5sOMZ = parcelRequire("5sOMZ");

var $hMyIf = parcelRequire("hMyIf");

var $er55f = parcelRequire("er55f");
const $678bcf5a7d335a8a$export$c27cdb450c323320 = ()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const selectedIdsLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $av74L.selectedIdsLookupSelector));
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector));
    return $acw62.useCallback((rowNode, index)=>{
        const ariaAttributes = {};
        const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
        ariaAttributes['aria-rowindex'] = ariaRowIndex;
        if (apiRef.current.isRowSelectable(rowNode.id)) ariaAttributes['aria-selected'] = selectedIdsLookup[rowNode.id] !== undefined;
        return ariaAttributes;
    }, [
        apiRef,
        selectedIdsLookup,
        headerGroupingMaxDepth
    ]);
};

});

parcelRegister("eu7ae", function(module, exports) {

$parcel$export(module.exports, "GridContextProvider", () => $a8b96ca779d42ed2$export$4fd26c08a15cabb4);

var $acw62 = parcelRequire("acw62");

var $YSznt = parcelRequire("YSznt");

var $er55f = parcelRequire("er55f");

var $96LtV = parcelRequire("96LtV");

var $jdJe4 = parcelRequire("jdJe4");

var $ayMG0 = parcelRequire("ayMG0");
function $a8b96ca779d42ed2$export$4fd26c08a15cabb4({ privateApiRef: privateApiRef, configuration: configuration, props: props, children: children }) {
    const apiRef = $acw62.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jdJe4.GridConfigurationContext).Provider, {
        value: configuration,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96LtV.GridRootPropsContext).Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $er55f.GridPrivateApiContext).Provider, {
                value: privateApiRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $YSznt.GridApiContext).Provider, {
                    value: apiRef,
                    children: children
                })
            })
        })
    });
}

});

parcelRegister("5W2Ws", function(module, exports) {

$parcel$export(module.exports, "useDataGridComponent", () => $4524a6bb6d2f99a9$export$4b018ab7873d790d);

var $2ly38 = parcelRequire("2ly38");

var $n73Rs = parcelRequire("n73Rs");

var $DJVd0 = parcelRequire("DJVd0");

var $ervnQ = parcelRequire("ervnQ");

var $8JOxm = parcelRequire("8JOxm");

var $izeLD = parcelRequire("izeLD");

var $gU8sa = parcelRequire("gU8sa");

var $4D37q = parcelRequire("4D37q");

var $cx8m0 = parcelRequire("cx8m0");

var $1lT2X = parcelRequire("1lT2X");

var $12xQD = parcelRequire("12xQD");

var $3m1KX = parcelRequire("3m1KX");

var $4epuR = parcelRequire("4epuR");

var $fTRdy = parcelRequire("fTRdy");

var $2MkZt = parcelRequire("2MkZt");

var $5lqAx = parcelRequire("5lqAx");

var $6p8lp = parcelRequire("6p8lp");

var $cURqP = parcelRequire("cURqP");

var $5WmMt = parcelRequire("5WmMt");

var $jOu9i = parcelRequire("jOu9i");

var $gaDPW = parcelRequire("gaDPW");

var $2oqux = parcelRequire("2oqux");

var $Anab1 = parcelRequire("Anab1");

var $jBRsK = parcelRequire("jBRsK");

var $lb6pq = parcelRequire("lb6pq");

var $2H9Fl = parcelRequire("2H9Fl");

var $aFlgz = parcelRequire("aFlgz");

var $dfzFI = parcelRequire("dfzFI");

var $jDB9E = parcelRequire("jDB9E");

var $1n8rV = parcelRequire("1n8rV");

var $kbNad = parcelRequire("kbNad");

var $lWGH3 = parcelRequire("lWGH3");
const $4524a6bb6d2f99a9$export$4b018ab7873d790d = (inputApiRef, props)=>{
    const apiRef = (0, $2ly38.useGridInitialization)(inputApiRef, props);
    /**
   * Register all pre-processors called during state initialization here.
   */ (0, $5WmMt.useGridRowSelectionPreProcessors)(apiRef, props);
    (0, $5lqAx.useGridRowsPreProcessors)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, $n73Rs.useGridInitializeState)((0, $lWGH3.propsStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $cURqP.rowSelectionStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $8JOxm.columnsStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $2MkZt.rowsStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $3m1KX.paginationStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $fTRdy.editingStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $1lT2X.focusStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $jOu9i.sortingStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $4epuR.preferencePanelStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $cx8m0.filterStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $1n8rV.rowSpanningStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $izeLD.densityStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $jDB9E.columnResizeStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $ervnQ.columnMenuStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $aFlgz.columnGroupsStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $dfzFI.virtualizationStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $Anab1.dimensionsStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $jBRsK.rowsMetaStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $kbNad.listViewStateInitializer), apiRef, props);
    (0, $12xQD.useGridKeyboardNavigation)(apiRef, props);
    (0, $cURqP.useGridRowSelection)(apiRef, props);
    (0, $8JOxm.useGridColumns)(apiRef, props);
    (0, $2MkZt.useGridRows)(apiRef, props);
    (0, $1n8rV.useGridRowSpanning)(apiRef, props);
    (0, $6p8lp.useGridParamsApi)(apiRef, props);
    (0, $2H9Fl.useGridColumnSpanning)(apiRef);
    (0, $aFlgz.useGridColumnGrouping)(apiRef, props);
    (0, $fTRdy.useGridEditing)(apiRef, props);
    (0, $1lT2X.useGridFocus)(apiRef, props);
    (0, $4epuR.useGridPreferencesPanel)(apiRef, props);
    (0, $cx8m0.useGridFilter)(apiRef, props);
    (0, $jOu9i.useGridSorting)(apiRef, props);
    (0, $izeLD.useGridDensity)(apiRef, props);
    (0, $jDB9E.useGridColumnResize)(apiRef, props);
    (0, $3m1KX.useGridPagination)(apiRef, props);
    (0, $jBRsK.useGridRowsMeta)(apiRef, props);
    (0, $gaDPW.useGridScroll)(apiRef, props);
    (0, $ervnQ.useGridColumnMenu)(apiRef);
    (0, $gU8sa.useGridCsvExport)(apiRef, props);
    (0, $4D37q.useGridPrintExport)(apiRef, props);
    (0, $DJVd0.useGridClipboard)(apiRef, props);
    (0, $Anab1.useGridDimensions)(apiRef, props);
    (0, $2oqux.useGridEvents)(apiRef, props);
    (0, $lb6pq.useGridStatePersistence)(apiRef);
    (0, $dfzFI.useGridVirtualization)(apiRef, props);
    (0, $kbNad.useGridListView)(apiRef, props);
    return apiRef;
};

});
parcelRegister("2ly38", function(module, exports) {

$parcel$export(module.exports, "useGridInitialization", () => $1b57f47831f90cfc$export$b77462c86b28bbf0);

var $aALnq = parcelRequire("aALnq");

var $hbsqJ = parcelRequire("hbsqJ");

var $eCZBN = parcelRequire("eCZBN");

var $30tkX = parcelRequire("30tkX");

var $bPgEz = parcelRequire("bPgEz");

var $c4Tvs = parcelRequire("c4Tvs");

var $42J2j = parcelRequire("42J2j");

var $bh93C = parcelRequire("bh93C");

var $lWGH3 = parcelRequire("lWGH3");
const $1b57f47831f90cfc$export$b77462c86b28bbf0 = (inputApiRef, props)=>{
    const privateApiRef = (0, $30tkX.useGridApiInitialization)(inputApiRef, props);
    (0, $aALnq.useGridRefs)(privateApiRef);
    (0, $lWGH3.useGridProps)(privateApiRef, props);
    (0, $hbsqJ.useGridIsRtl)(privateApiRef);
    (0, $eCZBN.useGridLoggerFactory)(privateApiRef, props);
    (0, $bh93C.useGridStateInitialization)(privateApiRef);
    (0, $c4Tvs.useGridPipeProcessing)(privateApiRef);
    (0, $42J2j.useGridStrategyProcessing)(privateApiRef);
    (0, $bPgEz.useGridLocaleText)(privateApiRef, props);
    privateApiRef.current.register('private', {
        rootProps: props
    });
    return privateApiRef;
};

});
parcelRegister("aALnq", function(module, exports) {

$parcel$export(module.exports, "useGridRefs", () => $7b6204383fd9652e$export$9f7c27985c4a3681);

var $acw62 = parcelRequire("acw62");
const $7b6204383fd9652e$export$9f7c27985c4a3681 = (apiRef)=>{
    const rootElementRef = $acw62.useRef(null);
    const mainElementRef = $acw62.useRef(null);
    const virtualScrollerRef = $acw62.useRef(null);
    const virtualScrollbarVerticalRef = $acw62.useRef(null);
    const virtualScrollbarHorizontalRef = $acw62.useRef(null);
    const columnHeadersContainerRef = $acw62.useRef(null);
    apiRef.current.register('public', {
        rootElementRef: rootElementRef
    });
    apiRef.current.register('private', {
        mainElementRef: mainElementRef,
        virtualScrollerRef: virtualScrollerRef,
        virtualScrollbarVerticalRef: virtualScrollbarVerticalRef,
        virtualScrollbarHorizontalRef: virtualScrollbarHorizontalRef,
        columnHeadersContainerRef: columnHeadersContainerRef
    });
};

});

parcelRegister("hbsqJ", function(module, exports) {

$parcel$export(module.exports, "useGridIsRtl", () => $c829845f6b031fe6$export$f9172a9d6b7b2acd);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9uEev = parcelRequire("9uEev");
const $c829845f6b031fe6$export$f9172a9d6b7b2acd = (apiRef)=>{
    const isRtl = (0, $9uEev.useRtl)();
    if (apiRef.current.state.isRtl === undefined) apiRef.current.state.isRtl = isRtl;
    const isFirstEffect = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstEffect.current) isFirstEffect.current = false;
        else apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                isRtl: isRtl
            }));
    }, [
        apiRef,
        isRtl
    ]);
};

});

parcelRegister("eCZBN", function(module, exports) {

$parcel$export(module.exports, "useGridLoggerFactory", () => $aa6467766a16a196$export$db6c72f4003d67df);

var $acw62 = parcelRequire("acw62");

var $lR3Vo = parcelRequire("lR3Vo");

var $ivFej = parcelRequire("ivFej");
const $aa6467766a16a196$var$forceDebug = (0, $lR3Vo.localStorageAvailable)() && window.localStorage.getItem('DEBUG') != null;
const $aa6467766a16a196$var$noop = ()=>{};
const $aa6467766a16a196$var$noopLogger = {
    debug: $aa6467766a16a196$var$noop,
    info: $aa6467766a16a196$var$noop,
    warn: $aa6467766a16a196$var$noop,
    error: $aa6467766a16a196$var$noop
};
const $aa6467766a16a196$var$LOG_LEVELS = [
    'debug',
    'info',
    'warn',
    'error'
];
function $aa6467766a16a196$var$getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = $aa6467766a16a196$var$LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI X: Log level ${logLevel} not recognized.`);
    const logger = $aa6467766a16a196$var$LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI X: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = $aa6467766a16a196$var$noop;
        return loggerObj;
    }, {});
    return logger;
}
const $aa6467766a16a196$export$db6c72f4003d67df = (apiRef, props)=>{
    const getLogger = $acw62.useCallback((name)=>{
        if ($aa6467766a16a196$var$forceDebug) return $aa6467766a16a196$var$getAppender(name, 'debug', props.logger);
        if (!props.logLevel) return $aa6467766a16a196$var$noopLogger;
        return $aa6467766a16a196$var$getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    (0, $ivFej.useGridApiMethod)(apiRef, {
        getLogger: getLogger
    }, 'private');
};

});

parcelRegister("30tkX", function(module, exports) {

$parcel$export(module.exports, "useGridApiInitialization", () => $230820e73b0114fd$export$72d4a6c5ec1a4b32);

var $acw62 = parcelRequire("acw62");

var $d6UoI = parcelRequire("d6UoI");

var $66H87 = parcelRequire("66H87");

var $ivFej = parcelRequire("ivFej");

var $eFF1m = parcelRequire("eFF1m");
const $230820e73b0114fd$var$SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const $230820e73b0114fd$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
function $230820e73b0114fd$export$37686f243ec62a21(publicApi) {
    return publicApi[$230820e73b0114fd$var$SYMBOL_API_PRIVATE];
}
let $230820e73b0114fd$var$globalId = 0;
function $230820e73b0114fd$var$createPrivateAPI(publicApiRef) {
    const existingPrivateApi = publicApiRef.current?.[$230820e73b0114fd$var$SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state: state,
        store: (0, $66H87.Store).create(state),
        instanceId: {
            id: $230820e73b0114fd$var$globalId
        }
    };
    $230820e73b0114fd$var$globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if (currentPrivateMethod?.spying === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if (visibility === 'public') {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if (currentPublicMethod?.spying === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new (0, $d6UoI.EventManager)()
    });
    return privateApi;
}
function $230820e73b0114fd$var$createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [$230820e73b0114fd$var$SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function $230820e73b0114fd$export$72d4a6c5ec1a4b32(inputApiRef, props) {
    const publicApiRef = $acw62.useRef(null);
    const privateApiRef = $acw62.useRef(null);
    if (!privateApiRef.current) privateApiRef.current = $230820e73b0114fd$var$createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = $230820e73b0114fd$var$createPublicAPI(privateApiRef);
    const publishEvent = $acw62.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($230820e73b0114fd$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === (0, $eFF1m.GridSignature).DataGridPro || props.signature === (0, $eFF1m.GridSignature).DataGridPremium ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = $acw62.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    (0, $ivFej.useGridApiMethod)(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, 'public');
    if (inputApiRef && !inputApiRef.current?.state) inputApiRef.current = publicApiRef.current;
    $acw62.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    $acw62.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}

});
parcelRegister("d6UoI", function(module, exports) {

$parcel$export(module.exports, "EventManager", () => $98b7954737600c67$export$cc74486daaaef499);
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $98b7954737600c67$export$cc74486daaaef499 {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}

});

parcelRegister("66H87", function(module, exports) {

$parcel$export(module.exports, "Store", () => $4724c2545021bcfd$export$390f32400eaf98c9);
class $4724c2545021bcfd$export$390f32400eaf98c9 {
    static create(value) {
        return new $4724c2545021bcfd$export$390f32400eaf98c9(value);
    }
    constructor(_value){
        this.value = void 0;
        this.listeners = void 0;
        this.subscribe = (fn)=>{
            this.listeners.add(fn);
            return ()=>{
                this.listeners.delete(fn);
            };
        };
        this.getSnapshot = ()=>{
            return this.value;
        };
        this.update = (value)=>{
            this.value = value;
            this.listeners.forEach((l)=>l(value));
        };
        this.value = _value;
        this.listeners = new Set();
    }
}

});


parcelRegister("bPgEz", function(module, exports) {

$parcel$export(module.exports, "useGridLocaleText", () => $89c1602309335bde$export$9943f2ed4ddf85bf);

var $acw62 = parcelRequire("acw62");
const $89c1602309335bde$export$9943f2ed4ddf85bf = (apiRef, props)=>{
    const getLocaleText = $acw62.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register('public', {
        getLocaleText: getLocaleText
    });
};

});

parcelRegister("c4Tvs", function(module, exports) {

$parcel$export(module.exports, "useGridPipeProcessing", () => $8cb0ea30b515dc96$export$1c5794e7ed1dc58f);

var $1En50 = parcelRequire("1En50");

var $4ZreY = parcelRequire("4ZreY");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
const $8cb0ea30b515dc96$export$1c5794e7ed1dc58f = (apiRef)=>{
    const cache = $acw62.useRef({});
    const isRunning = $acw62.useRef(false);
    const runAppliers = $acw62.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = $acw62.useCallback((group, id, processor)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {}
        };
        const groupCache = cache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            groupCache.processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
            runAppliers(groupCache);
        }
        return ()=>{
            cache.current[group].processors.set(id, null);
            cache.current[group].processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
        };
    }, [
        runAppliers
    ]);
    const registerPipeApplier = $acw62.useCallback((group, id, applier)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {}
        };
        cache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = cache.current[group].appliers, otherAppliers = (0, $1En50.default)(_appliers, [
                id
            ].map((0, $4ZreY.default)));
            cache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = $acw62.useCallback((group)=>{
        runAppliers(cache.current[group]);
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = $acw62.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!cache.current[group]) return value;
        const processors = cache.current[group].processorsAsArray;
        let result = value;
        for(let i = 0; i < processors.length; i += 1)result = processors[i](result, context);
        return result;
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor: registerPipeProcessor,
        registerPipeApplier: registerPipeApplier,
        requestPipeProcessorsApplication: requestPipeProcessorsApplication
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, $ivFej.useGridApiMethod)(apiRef, preProcessingPrivateApi, 'private');
    (0, $ivFej.useGridApiMethod)(apiRef, preProcessingPublicApi, 'public');
};

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("42J2j", function(module, exports) {

$parcel$export(module.exports, "GRID_DEFAULT_STRATEGY", () => $2f1a4898f1e92309$export$84214fbf04c4094);
$parcel$export(module.exports, "useGridStrategyProcessing", () => $2f1a4898f1e92309$export$594711f8e5fa9b04);

var $1En50 = parcelRequire("1En50");

var $4ZreY = parcelRequire("4ZreY");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
const $2f1a4898f1e92309$export$84214fbf04c4094 = 'none';
const $2f1a4898f1e92309$export$8c4aa1977ad5d106 = {
    rowTreeCreation: 'rowTree',
    filtering: 'rowTree',
    sorting: 'rowTree',
    visibleRowsLookupCreation: 'rowTree'
};
const $2f1a4898f1e92309$export$594711f8e5fa9b04 = (apiRef)=>{
    const availableStrategies = $acw62.useRef(new Map());
    const strategiesCache = $acw62.useRef({});
    const registerStrategyProcessor = $acw62.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, $1En50.default)(_ref, [
                strategyName
            ].map((0, $4ZreY.default)));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy($2f1a4898f1e92309$export$8c4aa1977ad5d106[processorName])) apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = $acw62.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy($2f1a4898f1e92309$export$8c4aa1977ad5d106[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = $acw62.useCallback((strategyGroup)=>{
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return availableStrategyEntry?.[0] ?? $2f1a4898f1e92309$export$84214fbf04c4094;
    }, []);
    const setStrategyAvailability = $acw62.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable: isAvailable
        });
        apiRef.current.publishEvent('strategyAvailabilityChange');
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor: registerStrategyProcessor,
        applyStrategyProcessor: applyStrategyProcessor,
        getActiveStrategy: getActiveStrategy,
        setStrategyAvailability: setStrategyAvailability
    };
    (0, $ivFej.useGridApiMethod)(apiRef, strategyProcessingApi, 'private');
};

});

parcelRegister("bh93C", function(module, exports) {

$parcel$export(module.exports, "useGridStateInitialization", () => $83584edf0ae98213$export$53c7ec825c1e4d3f);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $lR3Vo = parcelRequire("lR3Vo");
const $83584edf0ae98213$export$53c7ec825c1e4d3f = (apiRef)=>{
    const controlStateMapRef = $acw62.useRef({});
    const registerControlState = $acw62.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = $acw62.useCallback((state, reason)=>{
        let newState;
        if ((0, $lR3Vo.isFunction)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        let ignoreSetState = false;
        // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef.current.state, apiRef.current.instanceId);
            const newSubState = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(', ')} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            apiRef.current.publishEvent('stateChange', newState);
            apiRef.current.store.update(newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId: stateId, hasPropChanged: hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (controlState.propOnChange && hasPropChanged) controlState.propOnChange(model, {
                reason: reason,
                api: apiRef.current
            });
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason: reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef
    ]);
    const updateControlState = $acw62.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, $8nd05.default)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const forceUpdate = $acw62.useCallback(()=>{
    // @deprecated - do nothing
    }, []);
    const publicStateApi = {
        setState: setState,
        forceUpdate: forceUpdate
    };
    const privateStateApi = {
        updateControlState: updateControlState,
        registerControlState: registerControlState
    };
    (0, $ivFej.useGridApiMethod)(apiRef, publicStateApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, privateStateApi, 'private');
};

});

parcelRegister("lWGH3", function(module, exports) {

$parcel$export(module.exports, "propsStateInitializer", () => $ffa021c6a8a175c3$export$eb04177a3403979f);
$parcel$export(module.exports, "useGridProps", () => $ffa021c6a8a175c3$export$38bbfdfacac6e6c2);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
const $ffa021c6a8a175c3$export$eb04177a3403979f = (state, props)=>{
    return (0, $8nd05.default)({}, state, {
        props: {
            getRowId: props.getRowId
        }
    });
};
const $ffa021c6a8a175c3$export$38bbfdfacac6e6c2 = (apiRef, props)=>{
    $acw62.useEffect(()=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                props: {
                    getRowId: props.getRowId
                }
            }));
    }, [
        apiRef,
        props.getRowId
    ]);
};

});


parcelRegister("n73Rs", function(module, exports) {

$parcel$export(module.exports, "useGridInitializeState", () => $0457a051e38141f4$export$f9587d613f2caeec);

var $acw62 = parcelRequire("acw62");
const $0457a051e38141f4$export$f9587d613f2caeec = (initializer, privateApiRef, props)=>{
    const isInitialized = $acw62.useRef(false);
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};

});

parcelRegister("DJVd0", function(module, exports) {

$parcel$export(module.exports, "useGridClipboard", () => $077743baf33b26c9$export$a44b2f69ac6aef73);

var $acw62 = parcelRequire("acw62");

var $eFF1m = parcelRequire("eFF1m");
var $dRE9O = parcelRequire("dRE9O");

var $drCmI = parcelRequire("drCmI");

var $k5aPx = parcelRequire("k5aPx");

var $dMF9H = parcelRequire("dMF9H");
function $077743baf33b26c9$var$writeToClipboardPolyfill(data) {
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre';
    span.style.userSelect = 'all';
    span.style.opacity = '0px';
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(span);
    }
}
function $077743baf33b26c9$var$copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        $077743baf33b26c9$var$writeToClipboardPolyfill(data);
    });
    else $077743baf33b26c9$var$writeToClipboardPolyfill(data);
}
function $077743baf33b26c9$var$hasNativeSelection(element) {
    // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
    if (window.getSelection()?.toString()) return true;
    // window.getSelection() returns an empty string in Firefox for selections inside a form element.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
    // Instead, we can use element.selectionStart that is only defined on form elements.
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
const $077743baf33b26c9$export$a44b2f69ac6aef73 = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = $acw62.useCallback((event)=>{
        if (!(0, $dMF9H.isCopyShortcut)(event)) return;
        // Do nothing if there's a native selection
        if ($077743baf33b26c9$var$hasNativeSelection(event.target)) return;
        let textToCopy = '';
        const selectedRows = apiRef.current.getSelectedRows();
        if (selectedRows.size > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            delimiter: clipboardCopyCellDelimiter,
            shouldAppendQuotes: false,
            escapeFormulas: false
        });
        else {
            const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = (0, $k5aPx.serializeCellValue)(cellParams, {
                    csvOptions: {
                        delimiter: clipboardCopyCellDelimiter,
                        shouldAppendQuotes: false,
                        escapeFormulas: false
                    },
                    ignoreValueFormatter: ignoreValueFormatter
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
        if (textToCopy) {
            $077743baf33b26c9$var$copyToClipboard(textToCopy);
            apiRef.current.publishEvent('clipboardCopy', textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    (0, $dRE9O.useGridNativeEventListener)(apiRef, ()=>apiRef.current.rootElementRef.current, 'keydown', handleCopy);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'clipboardCopy', props.onClipboardCopy);
};

});
parcelRegister("dRE9O", function(module, exports) {

$parcel$export(module.exports, "useGridNativeEventListener", () => $a17f600338696a2d$export$265f4c39182036e);

var $luu6e = parcelRequire("luu6e");

var $eFF1m = parcelRequire("eFF1m");
const $a17f600338696a2d$export$265f4c39182036e = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useNativeEventListener');
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rootMount', ()=>{
        const targetElement = typeof ref === 'function' ? ref() : ref.current;
        if (!targetElement || !eventName || !handler) return undefined;
        logger.debug(`Binding native ${eventName} event`);
        targetElement.addEventListener(eventName, handler, options);
        return ()=>{
            logger.debug(`Clearing native ${eventName} event`);
            targetElement.removeEventListener(eventName, handler, options);
        };
    });
};

});
parcelRegister("luu6e", function(module, exports) {

$parcel$export(module.exports, "useGridLogger", () => $fa53bf7350a63511$export$eb512164890e58f0);

var $acw62 = parcelRequire("acw62");
function $fa53bf7350a63511$export$eb512164890e58f0(privateApiRef, name) {
    const logger = $acw62.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}

});


parcelRegister("k5aPx", function(module, exports) {

$parcel$export(module.exports, "serializeCellValue", () => $e9ecacf5d98b0bad$export$edda57d2a460473d);
$parcel$export(module.exports, "buildCSV", () => $e9ecacf5d98b0bad$export$8bfbf32dccc29440);


var $5bG6h = parcelRequire("5bG6h");
function $e9ecacf5d98b0bad$var$sanitizeCellValue(value, csvOptions) {
    if (value === null || value === undefined) return '';
    const valueStr = typeof value === 'string' ? value : `${value}`;
    if (csvOptions.shouldAppendQuotes || csvOptions.escapeFormulas) {
        const escapedValue = valueStr.replace(/"/g, '""');
        if (csvOptions.escapeFormulas) {
            // See https://owasp.org/www-community/attacks/CSV_Injection
            if ([
                '=',
                '+',
                '-',
                '@',
                '\t',
                '\r'
            ].includes(escapedValue[0])) return `"'${escapedValue}"`;
        }
        // Make sure value containing delimiter or line break won't be split into multiple cells
        if ([
            csvOptions.delimiter,
            '\n',
            '\r',
            '"'
        ].some((delimiter)=>valueStr.includes(delimiter))) return `"${escapedValue}"`;
        return escapedValue;
    }
    return valueStr;
}
const $e9ecacf5d98b0bad$export$edda57d2a460473d = (cellParams, options)=>{
    const { csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter } = options;
    let value;
    if (ignoreValueFormatter) {
        const columnType = cellParams.colDef.type;
        if (columnType === 'number') value = String(cellParams.value);
        else if (columnType === 'date' || columnType === 'dateTime') value = cellParams.value?.toISOString();
        else if (typeof cellParams.value?.toString === 'function') value = cellParams.value.toString();
        else value = cellParams.value;
    } else value = cellParams.formattedValue;
    return $e9ecacf5d98b0bad$var$sanitizeCellValue(value, csvOptions);
};
class $e9ecacf5d98b0bad$var$CSVRow {
    constructor(options){
        this.options = void 0;
        this.rowString = '';
        this.isEmpty = true;
        this.options = options;
    }
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.csvOptions.delimiter;
        if (typeof this.options.sanitizeCellValue === 'function') this.rowString += this.options.sanitizeCellValue(value, this.options.csvOptions);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
}
const $e9ecacf5d98b0bad$var$serializeRow = ({ id: id, columns: columns, getCellParams: getCellParams, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter })=>{
    const row = new $e9ecacf5d98b0bad$var$CSVRow({
        csvOptions: csvOptions
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        row.addValue($e9ecacf5d98b0bad$export$edda57d2a460473d(cellParams, {
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        }));
    });
    return row.getRowString();
};
function $e9ecacf5d98b0bad$export$8bfbf32dccc29440(options) {
    const { columns: columns, rowIds: rowIds, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter, apiRef: apiRef } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${$e9ecacf5d98b0bad$var$serializeRow({
            id: id,
            columns: columns,
            getCellParams: apiRef.current.getCellParams,
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        })}\r\n`, '').trim();
    if (!csvOptions.includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field);
    const headerRows = [];
    if (csvOptions.includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new $e9ecacf5d98b0bad$var$CSVRow({
                csvOptions: csvOptions,
                sanitizeCellValue: $e9ecacf5d98b0bad$var$sanitizeCellValue
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
            });
        }
    }
    const mainHeaderRow = new $e9ecacf5d98b0bad$var$CSVRow({
        csvOptions: csvOptions,
        sanitizeCellValue: $e9ecacf5d98b0bad$var$sanitizeCellValue
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join('\r\n')}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}

});
parcelRegister("5bG6h", function(module, exports) {

$parcel$export(module.exports, "GRID_CHECKBOX_SELECTION_FIELD", () => $3c6ea315aeb792f9$export$322dfed7a1df1b02);
$parcel$export(module.exports, "GRID_CHECKBOX_SELECTION_COL_DEF", () => $3c6ea315aeb792f9$export$b2e9ab6103a664ad);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $fgOJy = parcelRequire("fgOJy");

var $4l3r5 = parcelRequire("4l3r5");

var $av74L = parcelRequire("av74L");

var $iNueb = parcelRequire("iNueb");

var $180lm = parcelRequire("180lm");

var $ayMG0 = parcelRequire("ayMG0");
const $3c6ea315aeb792f9$export$322dfed7a1df1b02 = '__check__';
const $3c6ea315aeb792f9$export$b2e9ab6103a664ad = (0, $8nd05.default)({}, (0, $iNueb.GRID_BOOLEAN_COL_DEF), {
    type: 'custom',
    field: $3c6ea315aeb792f9$export$322dfed7a1df1b02,
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: undefined,
    display: 'flex',
    valueGetter: (value, row, column, apiRef)=>{
        const selectionLookup = (0, $av74L.selectedIdsLookupSelector)(apiRef);
        const rowId = (0, $180lm.gridRowIdSelector)(apiRef.current.state, row);
        return selectionLookup[rowId] !== undefined;
    },
    renderHeader: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4l3r5.GridHeaderCheckbox), (0, $8nd05.default)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fgOJy.GridCellCheckboxRenderer), (0, $8nd05.default)({}, params))
});

});
parcelRegister("fgOJy", function(module, exports) {

$parcel$export(module.exports, "GridCellCheckboxRenderer", () => $b1dfb45352a7562a$export$6df0a29182db5ff8);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $3qSdM = parcelRequire("3qSdM");

var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $5sOMZ = parcelRequire("5sOMZ");

var $iN63z = parcelRequire("iN63z");

var $ayMG0 = parcelRequire("ayMG0");
const $b1dfb45352a7562a$var$_excluded = [
    "field",
    "id",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const $b1dfb45352a7562a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $b1dfb45352a7562a$export$de9fc2d8e98d780 = (0, $gJsNs.forwardRef)(function GridCellCheckboxRenderer(props, ref) {
    const { field: field, id: id, rowNode: rowNode, hasFocus: hasFocus, tabIndex: tabIndex } = props, other = (0, $1En50.default)(props, $b1dfb45352a7562a$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $b1dfb45352a7562a$var$useUtilityClasses(ownerState);
    const checkboxElement = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(checkboxElement, ref);
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked,
            id: id
        };
        apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
    };
    $acw62.useLayoutEffect(()=>{
        if (tabIndex === 0) {
            const element = apiRef.current.getCellElement(id, field);
            if (element) element.tabIndex = -1;
        }
    }, [
        apiRef,
        tabIndex,
        id,
        field
    ]);
    $acw62.useEffect(()=>{
        if (hasFocus) {
            const input = checkboxElement.current?.querySelector('input');
            input?.focus({
                preventScroll: true
            });
        } else if (rippleRef.current) // Only available in @mui/material v5.4.1 or later
        rippleRef.current.stop({});
    }, [
        hasFocus
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (event.key === ' ') // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
        // TODO: Remove and add a check inside useGridKeyboardNavigation
        event.stopPropagation();
    }, []);
    const isSelectable = apiRef.current.isRowSelectable(id);
    const checkboxPropsSelector = (0, $iN63z.getCheckboxPropsSelector)(id, rootProps.rowSelectionPropagation?.parents ?? false);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = (0, $5sOMZ.useGridSelector)(apiRef, checkboxPropsSelector, (0, $5sOMZ.objectShallowCompare));
    if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return null;
    const checked = rootProps.indeterminateCheckboxAction === 'select' ? isChecked && !isIndeterminate : isChecked;
    const label = apiRef.current.getLocaleText(checked ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $8nd05.default)({
        tabIndex: tabIndex,
        checked: checked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label,
            name: 'select_row'
        },
        onKeyDown: handleKeyDown,
        indeterminate: isIndeterminate,
        disabled: !isSelectable,
        touchRippleRef: rippleRef /* FIXME: typing error */ 
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: handleRef
    }));
});
const $b1dfb45352a7562a$export$6df0a29182db5ff8 = $b1dfb45352a7562a$export$de9fc2d8e98d780;

});

parcelRegister("4l3r5", function(module, exports) {

$parcel$export(module.exports, "GridHeaderCheckbox", () => $328bc9e57e6b696b$export$22c0c31c5dd8f5aa);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $gJsNs = parcelRequire("gJsNs");

var $iN63z = parcelRequire("iN63z");

var $5sOMZ = parcelRequire("5sOMZ");

var $drCmI = parcelRequire("drCmI");

var $av74L = parcelRequire("av74L");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $k278Q = parcelRequire("k278Q");

var $gPWuj = parcelRequire("gPWuj");

var $ayMG0 = parcelRequire("ayMG0");
const $328bc9e57e6b696b$var$_excluded = [
    "field",
    "colDef"
];
const $328bc9e57e6b696b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $328bc9e57e6b696b$export$22c0c31c5dd8f5aa = (0, $gJsNs.forwardRef)(function GridHeaderCheckbox(props, ref) {
    const other = (0, $1En50.default)(props, $328bc9e57e6b696b$var$_excluded);
    const [, forceUpdate] = $acw62.useState(false);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $328bc9e57e6b696b$var$useUtilityClasses(ownerState);
    const tabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridTabIndexColumnHeaderSelector));
    const selection = (0, $5sOMZ.useGridSelector)(apiRef, (0, $av74L.gridRowSelectionStateSelector));
    const visibleRowIds = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridExpandedSortedRowIdsSelector));
    const paginatedVisibleRowIds = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginatedVisibleSortedGridRowIdsSelector));
    const filteredSelection = $acw62.useMemo(()=>{
        if (typeof rootProps.isRowSelectable !== 'function') return selection;
        return selection.filter((id)=>{
            if (rootProps.keepNonExistentRowsSelected) return true;
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) return false;
            return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
        });
    }, [
        apiRef,
        rootProps.isRowSelectable,
        selection,
        rootProps.keepNonExistentRowsSelected
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = $acw62.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly || rootProps.paginationMode === 'server' ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to an object to make O(1) checking if a row exists or not
        // TODO create selector that returns visibleRowIds/paginatedVisibleRowIds as an object
        return rowIds.reduce((acc, id)=>{
            acc[id] = true;
            return acc;
        }, {});
    }, [
        rootProps.pagination,
        rootProps.paginationMode,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = $acw62.useMemo(()=>filteredSelection.filter((id)=>selectionCandidates[id]).length, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    $acw62.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (event.key === ' ') // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent('headerSelectionCheckboxChange', {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = $acw62.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    $acw62.useEffect(()=>{
        return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const checked = rootProps.indeterminateCheckboxAction === 'select' ? isChecked && !isIndeterminate : isChecked;
    const label = apiRef.current.getLocaleText(checked ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $8nd05.default)({
        indeterminate: isIndeterminate,
        checked: checked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label,
            name: 'select_all_rows'
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown,
        disabled: !(0, $iN63z.isMultipleRowSelectionEnabled)(rootProps)
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: ref
    }));
});

});



parcelRegister("dMF9H", function(module, exports) {

$parcel$export(module.exports, "isPrintableKey", () => $a08faead7d1bb429$export$b3f2c64190cf8c4);
$parcel$export(module.exports, "isNavigationKey", () => $a08faead7d1bb429$export$e13d96c38a470518);
$parcel$export(module.exports, "isKeyboardEvent", () => $a08faead7d1bb429$export$130b789831072f4c);
$parcel$export(module.exports, "isHideMenuKey", () => $a08faead7d1bb429$export$81301abbcd0c8143);
$parcel$export(module.exports, "isPasteShortcut", () => $a08faead7d1bb429$export$dc044e3b830c7edc);
$parcel$export(module.exports, "isCopyShortcut", () => $a08faead7d1bb429$export$b3bab6a2e94206d4);
// Non printable keys have a name, for example "ArrowRight", see the whole list:
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// So event.key.length === 1 is often enough.
//
// However, we also need to ignore shortcuts, for example: select all:
// - Windows: Ctrl+A, event.ctrlKey is true
// - macOS: ⌘ Command+A, event.metaKey is true
function $a08faead7d1bb429$export$b3f2c64190cf8c4(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const $a08faead7d1bb429$export$b7d709ba679d3811 = [
    'Meta',
    'Control',
    'Shift'
];
const $a08faead7d1bb429$export$cb76cac5e13767b3 = [
    'Enter',
    'Escape',
    'Tab'
];
const $a08faead7d1bb429$export$88516d667267d515 = [
    'Enter',
    'Tab'
];
const $a08faead7d1bb429$export$6ac2fcffa1f825f7 = (key)=>$a08faead7d1bb429$export$b7d709ba679d3811.indexOf(key) > -1;
const $a08faead7d1bb429$export$a8f5f024431d9642 = (event)=>$a08faead7d1bb429$export$b3f2c64190cf8c4(event) || event.key === 'Enter' || event.key === 'Backspace' || event.key === 'Delete';
const $a08faead7d1bb429$export$f6a96f75820f81fd = (key)=>$a08faead7d1bb429$export$cb76cac5e13767b3.indexOf(key) > -1;
const $a08faead7d1bb429$export$d3e9cf1edead7ecb = (key)=>$a08faead7d1bb429$export$88516d667267d515.indexOf(key) > -1;
const $a08faead7d1bb429$export$e13d96c38a470518 = (key)=>key.indexOf('Arrow') === 0 || key.indexOf('Page') === 0 || key === ' ' || key === 'Home' || key === 'End';
const $a08faead7d1bb429$export$130b789831072f4c = (event)=>!!event.key;
const $a08faead7d1bb429$export$81301abbcd0c8143 = (key)=>key === 'Tab' || key === 'Escape';
function $a08faead7d1bb429$export$dc044e3b830c7edc(event) {
    return (event.ctrlKey || event.metaKey) && // We can't use event.code === 'KeyV' as event.code assumes a QWERTY keyboard layout,
    // for example, it would be another letter on a Dvorak physical keyboard.
    // We can't use event.key === 'v' as event.key is not stable with key modifiers and keyboard layouts,
    // for example, it would be ה on a Hebrew keyboard layout.
    // https://github.com/w3c/uievents/issues/377 could be a long-term solution
    String.fromCharCode(event.keyCode) === 'V' && !event.shiftKey && !event.altKey;
}
function $a08faead7d1bb429$export$b3bab6a2e94206d4(event) {
    return (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'C' && !event.shiftKey && !event.altKey;
}

});


parcelRegister("ervnQ", function(module, exports) {

$parcel$export(module.exports, "columnMenuStateInitializer", () => $a83bee6df207757d$export$8574ffe06bf26347);
$parcel$export(module.exports, "useGridColumnMenu", () => $a83bee6df207757d$export$1fc2975c9a725449);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eFF1m = parcelRequire("eFF1m");
var $ivFej = parcelRequire("ivFej");
var $luu6e = parcelRequire("luu6e");

var $eOaSX = parcelRequire("eOaSX");

var $jQEEt = parcelRequire("jQEEt");
const $a83bee6df207757d$export$8574ffe06bf26347 = (state)=>(0, $8nd05.default)({}, state, {
        columnMenu: {
            open: false
        }
    });
const $a83bee6df207757d$export$1fc2975c9a725449 = (apiRef)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridColumnMenu');
    /**
   * API METHODS
   */ const showColumnMenu = $acw62.useCallback((field)=>{
        const columnMenuState = (0, $eOaSX.gridColumnMenuSelector)(apiRef.current.state);
        const newState = {
            open: true,
            field: field
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) {
            apiRef.current.setState((state)=>{
                if (state.columnMenu.open && state.columnMenu.field === field) return state;
                logger.debug('Opening Column Menu');
                return (0, $8nd05.default)({}, state, {
                    columnMenu: {
                        open: true,
                        field: field
                    }
                });
            });
            apiRef.current.hidePreferences();
        }
    }, [
        apiRef,
        logger
    ]);
    const hideColumnMenu = $acw62.useCallback(()=>{
        const columnMenuState = (0, $eOaSX.gridColumnMenuSelector)(apiRef.current.state);
        if (columnMenuState.field) {
            const columnLookup = (0, $jQEEt.gridColumnLookupSelector)(apiRef);
            const columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
            const orderedFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
            let fieldToFocus = columnMenuState.field;
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const newState = {
            open: false,
            field: undefined
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) apiRef.current.setState((state)=>{
            logger.debug('Hiding Column Menu');
            return (0, $8nd05.default)({}, state, {
                columnMenu: newState
            });
        });
    }, [
        apiRef,
        logger
    ]);
    const toggleColumnMenu = $acw62.useCallback((field)=>{
        logger.debug('Toggle Column Menu');
        const columnMenu = (0, $eOaSX.gridColumnMenuSelector)(apiRef.current.state);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu: showColumnMenu,
        hideColumnMenu: hideColumnMenu,
        toggleColumnMenu: toggleColumnMenu
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnMenuApi, 'public');
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResizeStart', hideColumnMenu);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'virtualScrollerWheel', apiRef.current.hideColumnMenu);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
};

});

parcelRegister("8JOxm", function(module, exports) {

$parcel$export(module.exports, "columnsStateInitializer", () => $65c9ba4e90cd61b6$export$8dcda879a58a8f96);
$parcel$export(module.exports, "useGridColumns", () => $65c9ba4e90cd61b6$export$fe9b9b8b4620abff);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $eFF1m = parcelRequire("eFF1m");

var $1xynw = parcelRequire("1xynw");
var $2kdmP = parcelRequire("2kdmP");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $i0LyH = parcelRequire("i0LyH");

var $3PCYS = parcelRequire("3PCYS");

var $ayMG0 = parcelRequire("ayMG0");
const $65c9ba4e90cd61b6$export$8dcda879a58a8f96 = (state, props, apiRef)=>{
    const columnsState = (0, $i0LyH.createColumnsState)({
        apiRef: apiRef,
        columnsToUpsert: props.columns,
        initialState: props.initialState?.columns,
        columnVisibilityModel: props.columnVisibilityModel ?? props.initialState?.columns?.columnVisibilityModel ?? {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, $8nd05.default)({}, state, {
        columns: columnsState,
        // In pro/premium, this part of the state is defined. We give it an empty but defined value
        // for the community version.
        pinnedColumns: state.pinnedColumns ?? (0, $4ZMWQ.EMPTY_PINNED_COLUMN_FIELDS)
    });
};
function $65c9ba4e90cd61b6$export$fe9b9b8b4620abff(apiRef, props) {
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridColumns');
    const previousColumnsProp = $acw62.useRef(props.columns);
    apiRef.current.registerControlState({
        stateId: 'visibleColumns',
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: (0, $jQEEt.gridColumnVisibilityModelSelector),
        changeEvent: 'columnVisibilityModelChange'
    });
    const setGridColumnsState = $acw62.useCallback((columnsState)=>{
        logger.debug('Updating columns state.');
        apiRef.current.setState($65c9ba4e90cd61b6$var$mergeColumnsState(columnsState));
        apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = $acw62.useCallback((field)=>(0, $jQEEt.gridColumnLookupSelector)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = $acw62.useCallback(()=>(0, $jQEEt.gridColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = $acw62.useCallback(()=>(0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = $acw62.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef) : (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = $acw62.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, $jQEEt.gridColumnPositionsSelector)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = $acw62.useCallback((model)=>{
        const currentModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    columns: (0, $i0LyH.createColumnsState)({
                        apiRef: apiRef,
                        columnsToUpsert: [],
                        initialState: undefined,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.updateRenderContext?.();
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef
    ]);
    const updateColumns = $acw62.useCallback((columns)=>{
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: columns,
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState
    ]);
    const setColumnVisibility = $acw62.useCallback((field, isVisible)=>{
        const columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const isCurrentlyVisible = columnVisibilityModel[field] ?? true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = (0, $8nd05.default)({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = $acw62.useCallback((field)=>{
        const allColumns = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = $acw62.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, $8nd05.default)({}, (0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent('columnIndexChange', params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = $acw62.useCallback((field, width)=>{
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = (0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state);
        const column = columnsState.lookup[field];
        const newColumn = (0, $8nd05.default)({}, column, {
            width: width,
            hasBeenResized: true
        });
        setGridColumnsState((0, $i0LyH.hydrateColumnsWidth)((0, $8nd05.default)({}, columnsState, {
            lookup: (0, $8nd05.default)({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), apiRef.current.getRootDimensions()));
        apiRef.current.publishEvent('columnWidthChange', {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width: width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn: getColumn,
        getAllColumns: getAllColumns,
        getColumnIndex: getColumnIndex,
        getColumnPosition: getColumnPosition,
        getVisibleColumns: getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns: getColumnIndexRelativeToVisibleColumns,
        updateColumns: updateColumns,
        setColumnVisibilityModel: setColumnVisibilityModel,
        setColumnVisibility: setColumnVisibility,
        setColumnWidth: setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex: setColumnIndex
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, columnReorderApi, props.signature === (0, $eFF1m.GridSignature).DataGrid ? 'private' : 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const shouldExportColumnVisibilityModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.columnVisibilityModel != null || // Always export if the model has been initialized
        // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
        Object.keys(props.initialState?.columns?.columnVisibilityModel ?? {}).length > 0 || // Always export if the model is not empty
        Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                (0, $i0LyH.COLUMNS_DIMENSION_PROPERTIES).forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, $8nd05.default)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        props.initialState?.columns
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const columnVisibilityModelToImport = context.stateToRestore.columns?.columnVisibilityModel;
        const initialState = context.stateToRestore.columns;
        if (columnVisibilityModelToImport == null && initialState == null) return params;
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        apiRef.current.setState($65c9ba4e90cd61b6$var$mergeColumnsState(columnsState));
        if (initialState != null) apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
        return params;
    }, [
        apiRef
    ]);
    const preferencePanelPreProcessing = $acw62.useCallback((initialValue, value)=>{
        if (value === (0, $3PCYS.GridPreferencePanelsValue).columns) {
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(ColumnsPanel, (0, $8nd05.default)({}, props.slotProps?.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        props.slotProps?.columnsPanel
    ]);
    const addColumnMenuItems = $acw62.useCallback((columnMenuItems)=>{
        if (props.disableColumnSelector) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuColumnsItem'
        ];
    }, [
        props.disableColumnSelector
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    /*
   * EVENTS
   */ const prevInnerWidth = $acw62.useRef(null);
    const handleGridSizeChange = (size)=>{
        if (prevInnerWidth.current !== size.width) {
            prevInnerWidth.current = size.width;
            const hasFlexColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).some((col)=>col.flex && col.flex > 0);
            if (!hasFlexColumns) return;
            setGridColumnsState((0, $i0LyH.hydrateColumnsWidth)((0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state), apiRef.current.getRootDimensions()));
        }
    };
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    /**
   * APPLIERS
   */ const hydrateColumns = $acw62.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    (0, $1xynw.useGridRegisterPipeApplier)(apiRef, 'hydrateColumns', hydrateColumns);
    /*
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        if (previousColumnsProp.current === props.columns) return;
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true
        });
        previousColumnsProp.current = props.columns;
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns
    ]);
    $acw62.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}
function $65c9ba4e90cd61b6$var$mergeColumnsState(columnsState) {
    return (state)=>(0, $8nd05.default)({}, state, {
            columns: columnsState
        });
}

});
parcelRegister("1xynw", function(module, exports) {

$parcel$export(module.exports, "useGridRegisterPipeApplier", () => $11f38a5cdcd4928d$export$98b68054bf03cb4);

var $acw62 = parcelRequire("acw62");

var $bc8LN = parcelRequire("bc8LN");
const $11f38a5cdcd4928d$export$98b68054bf03cb4 = (apiRef, group, callback)=>{
    const cleanup = $acw62.useRef(null);
    const id = $acw62.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $acw62.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};

});
parcelRegister("bc8LN", function(module, exports) {

$parcel$export(module.exports, "useFirstRender", () => $82679e37231fe76f$export$c5623aa1c38918b6);

var $acw62 = parcelRequire("acw62");
const $82679e37231fe76f$export$c5623aa1c38918b6 = (callback)=>{
    const isFirstRender = $acw62.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
};

});


parcelRegister("2kdmP", function(module, exports) {

$parcel$export(module.exports, "useGridRegisterPipeProcessor", () => $1b17d17d1651bc2f$export$faa98381ad228894);

var $acw62 = parcelRequire("acw62");

var $bc8LN = parcelRequire("bc8LN");
const $1b17d17d1651bc2f$export$faa98381ad228894 = (apiRef, group, callback, enabled = true)=>{
    const cleanup = $acw62.useRef(null);
    const id = $acw62.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $acw62.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        if (enabled) registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else if (enabled) registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor,
        enabled
    ]);
};

});


parcelRegister("izeLD", function(module, exports) {

$parcel$export(module.exports, "densityStateInitializer", () => $d846f35585bafc86$export$d6d71dbaaa6fec72);
$parcel$export(module.exports, "useGridDensity", () => $d846f35585bafc86$export$836c4be63cf7a42d);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");

var $luu6e = parcelRequire("luu6e");

var $ivFej = parcelRequire("ivFej");

var $fD9f4 = parcelRequire("fD9f4");

var $2kdmP = parcelRequire("2kdmP");
const $d846f35585bafc86$export$d6d71dbaaa6fec72 = (state, props)=>(0, $8nd05.default)({}, state, {
        density: props.initialState?.density ?? props.density ?? 'standard'
    });
const $d846f35585bafc86$export$836c4be63cf7a42d = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useDensity');
    apiRef.current.registerControlState({
        stateId: 'density',
        propModel: props.density,
        propOnChange: props.onDensityChange,
        stateSelector: (0, $fD9f4.gridDensitySelector),
        changeEvent: 'densityChange'
    });
    const setDensity = (0, $13KXh.default)((newDensity)=>{
        const currentDensity = (0, $fD9f4.gridDensitySelector)(apiRef.current.state);
        if (currentDensity === newDensity) return;
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                density: newDensity
            }));
    });
    const densityApi = {
        setDensity: setDensity
    };
    (0, $ivFej.useGridApiMethod)(apiRef, densityApi, 'public');
    const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const exportedDensity = (0, $fD9f4.gridDensitySelector)(apiRef.current.state);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `density` is controlled
        props.density != null || // Always export if the `density` has been initialized
        props.initialState?.density != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            density: exportedDensity
        });
    }, [
        apiRef,
        props.density,
        props.initialState?.density
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const restoredDensity = context.stateToRestore?.density ? context.stateToRestore.density : (0, $fD9f4.gridDensitySelector)(apiRef.current.state);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                density: restoredDensity
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    $acw62.useEffect(()=>{
        if (props.density) apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
};

});

parcelRegister("gU8sa", function(module, exports) {

$parcel$export(module.exports, "useGridCsvExport", () => $c4e86ef235136df5$export$6178dbab26611702);

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $8boSz = parcelRequire("8boSz");

var $k5aPx = parcelRequire("k5aPx");

var $jSbr9 = parcelRequire("jSbr9");

var $2kdmP = parcelRequire("2kdmP");

var $1v4Qb = parcelRequire("1v4Qb");

var $ayMG0 = parcelRequire("ayMG0");
const $c4e86ef235136df5$export$6178dbab26611702 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridCsvExport');
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = $acw62.useCallback((options = {})=>{
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, $jSbr9.getColumnsToExport)({
            apiRef: apiRef,
            options: options
        });
        const getRowsToExport = options.getRowsToExport ?? (0, $jSbr9.defaultGetRowsToExport);
        const exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        return (0, $k5aPx.buildCSV)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            csvOptions: {
                delimiter: options.delimiter || ',',
                shouldAppendQuotes: options.shouldAppendQuotes ?? true,
                includeHeaders: options.includeHeaders ?? true,
                includeColumnGroupsHeaders: options.includeColumnGroupsHeaders ?? true,
                escapeFormulas: options.escapeFormulas ?? true
            },
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = $acw62.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options?.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        (0, $8boSz.exportAs)(blob, 'csv', options?.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    (0, $ivFej.useGridApiMethod)(apiRef, csvExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $acw62.useCallback((initialValue, options)=>{
        if (options.csvOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1v4Qb.GridCsvExportMenuItem), {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ];
    }, []);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportMenu', addExportMenuButtons);
};

});
parcelRegister("8boSz", function(module, exports) {

$parcel$export(module.exports, "exportAs", () => $5f52a64decff8320$export$f95aebe89510930);
/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ function $5f52a64decff8320$export$f95aebe89510930(blob, extension = 'csv', filename = document.title || 'untitled') {
    const fullName = `${filename}.${extension}`;
    // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ('download' in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob);
        // Create a new anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = fullName;
        // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click();
        // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error('MUI X: exportAs not supported.');
}

});

parcelRegister("jSbr9", function(module, exports) {

$parcel$export(module.exports, "getColumnsToExport", () => $e77bee9f62f5124d$export$c5c7f3bb5f79a15d);
$parcel$export(module.exports, "defaultGetRowsToExport", () => $e77bee9f62f5124d$export$99156d1572dee776);

var $jQEEt = parcelRequire("jQEEt");

var $k278Q = parcelRequire("k278Q");

var $goCyd = parcelRequire("goCyd");
const $e77bee9f62f5124d$export$c5c7f3bb5f79a15d = ({ apiRef: apiRef, options: options })=>{
    const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
    return validColumns.filter((column)=>!column.disableExport);
};
const $e77bee9f62f5124d$export$99156d1572dee776 = ({ apiRef: apiRef })=>{
    const filteredSortedRowIds = (0, $k278Q.gridFilteredSortedRowIdsSelector)(apiRef);
    const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
    const selectedRows = apiRef.current.getSelectedRows();
    const bodyRows = filteredSortedRowIds.filter((id)=>rowTree[id].type !== 'footer');
    const pinnedRows = (0, $goCyd.gridPinnedRowsSelector)(apiRef);
    const topPinnedRowsIds = pinnedRows?.top?.map((row)=>row.id) || [];
    const bottomPinnedRowsIds = pinnedRows?.bottom?.map((row)=>row.id) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRows.size > 0) return bodyRows.filter((id)=>selectedRows.has(id));
    return bodyRows;
};

});

parcelRegister("1v4Qb", function(module, exports) {

$parcel$export(module.exports, "GridCsvExportMenuItem", () => $117c70f90fd64960$export$c0e66088a5c9ffbf);
$parcel$export(module.exports, "GridPrintExportMenuItem", () => $117c70f90fd64960$export$a6cd094b30f69b92);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $03n8N = parcelRequire("03n8N");

var $ayMG0 = parcelRequire("ayMG0");
const $117c70f90fd64960$var$_excluded = [
    "hideMenu",
    "options"
], $117c70f90fd64960$var$_excluded2 = [
    "hideMenu",
    "options"
], $117c70f90fd64960$var$_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function $117c70f90fd64960$export$c0e66088a5c9ffbf(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $1En50.default)(props, $117c70f90fd64960$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), (0, $8nd05.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportCSV')
    }));
}
function $117c70f90fd64960$export$a6cd094b30f69b92(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $1En50.default)(props, $117c70f90fd64960$var$_excluded2);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), (0, $8nd05.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportPrint')
    }));
}
const $117c70f90fd64960$export$ef68b449b329deb5 = (0, $gJsNs.forwardRef)(function GridToolbarExport(props, ref) {
    const _ref = props, { csvOptions: csvOptions = {}, printOptions: printOptions = {}, excelOptions: excelOptions } = _ref, other = (0, $1En50.default)(_ref, $117c70f90fd64960$var$_excluded3);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
        excelOptions: excelOptions,
        csvOptions: csvOptions,
        printOptions: printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03n8N.GridToolbarExportContainer), (0, $8nd05.default)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button.component, {
                key: index
            }))
    }));
});

});
parcelRegister("03n8N", function(module, exports) {

$parcel$export(module.exports, "GridToolbarExportContainer", () => $00a23b3a9224b6aa$export$9c3c7dbe6f1101cf);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $3qSdM = parcelRequire("3qSdM");
var $auC0X = parcelRequire("auC0X");

var $lBOb7 = parcelRequire("lBOb7");

var $gJsNs = parcelRequire("gJsNs");

var $dMF9H = parcelRequire("dMF9H");

var $bDyDY = parcelRequire("bDyDY");

var $ch6XH = parcelRequire("ch6XH");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $00a23b3a9224b6aa$export$9c3c7dbe6f1101cf = (0, $gJsNs.forwardRef)(function GridToolbarExportContainer(props, ref) {
    const { children: children, slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const exportButtonId = (0, $auC0X.default)();
    const exportMenuId = (0, $auC0X.default)();
    const [open, setOpen] = $acw62.useState(false);
    const buttonRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ((0, $dMF9H.isHideMenuKey)(event.key)) handleMenuClose();
    };
    if (children == null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $8nd05.default)({
                title: apiRef.current.getLocaleText('toolbarExportLabel'),
                enterDelay: 1000
            }, rootProps.slotProps?.baseTooltip, tooltipProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.exportIcon, {}),
                    "aria-expanded": open,
                    "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                    "aria-haspopup": "menu",
                    "aria-controls": open ? exportMenuId : undefined,
                    id: exportButtonId
                }, rootProps.slotProps?.baseButton, buttonProps, {
                    onClick: handleMenuOpen,
                    ref: handleRef,
                    children: apiRef.current.getLocaleText('toolbarExport')
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ch6XH.GridMenu), {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lBOb7.default), {
                    id: exportMenuId,
                    className: (0, $5H1vo.gridClasses).menuList,
                    "aria-labelledby": exportButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: $acw62.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return child;
                        return /*#__PURE__*/ $acw62.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});

});



parcelRegister("4D37q", function(module, exports) {

$parcel$export(module.exports, "useGridPrintExport", () => $35ed394581d01f61$export$41205b2521d4edd4);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");

var $luu6e = parcelRequire("luu6e");

var $k278Q = parcelRequire("k278Q");

var $jQEEt = parcelRequire("jQEEt");

var $5H1vo = parcelRequire("5H1vo");

var $ivFej = parcelRequire("ivFej");

var $bdqIg = parcelRequire("bdqIg");

var $7sDf4 = parcelRequire("7sDf4");

var $jSbr9 = parcelRequire("jSbr9");

var $87jE6 = parcelRequire("87jE6");

var $2kdmP = parcelRequire("2kdmP");

var $1v4Qb = parcelRequire("1v4Qb");

var $i0LyH = parcelRequire("i0LyH");

var $5bG6h = parcelRequire("5bG6h");

var $ayMG0 = parcelRequire("ayMG0");
function $35ed394581d01f61$var$raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function $35ed394581d01f61$var$buildPrintWindow(title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.style.position = 'absolute';
    iframeEl.style.width = '0px';
    iframeEl.style.height = '0px';
    iframeEl.title = title || document.title;
    return iframeEl;
}
const $35ed394581d01f61$export$41205b2521d4edd4 = (apiRef, props)=>{
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPrintExport');
    const doc = $acw62.useRef(null);
    const previousGridState = $acw62.useRef(null);
    const previousColumnVisibility = $acw62.useRef({});
    const previousRows = $acw62.useRef([]);
    const previousVirtualizationState = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        doc.current = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
    }, [
        apiRef,
        hasRootReference
    ]);
    // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = $acw62.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = (0, $jSbr9.getColumnsToExport)({
                apiRef: apiRef,
                options: {
                    fields: fields,
                    allColumns: allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[(0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = $acw62.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef: apiRef
        });
        const newRows = rowsToExportIds.reduce((acc, id)=>{
            const row = apiRef.current.getRow(id);
            if (!row[0, $7sDf4.GRID_ID_AUTOGENERATED]) acc.push(row);
            return acc;
        }, []);
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = $acw62.useCallback((printWindow, options)=>{
        const normalizeOptions = (0, $8nd05.default)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const rowsMeta = (0, $bdqIg.gridRowsMetaSelector)(apiRef.current.state);
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${(0, $5H1vo.gridClasses).main}`);
        gridMain.style.overflow = 'visible';
        // See https://support.google.com/chrome/thread/191619088?hl=en&msgid=193009642
        gridClone.style.contain = 'size';
        let gridToolbarElementHeight = gridRootElement.querySelector(`.${(0, $5H1vo.gridClasses).toolbarContainer}`)?.offsetHeight || 0;
        let gridFooterElementHeight = gridRootElement.querySelector(`.${(0, $5H1vo.gridClasses).footerContainer}`)?.offsetHeight || 0;
        const gridFooterElement = gridClone.querySelector(`.${(0, $5H1vo.gridClasses).footerContainer}`);
        if (normalizeOptions.hideToolbar) {
            gridClone.querySelector(`.${(0, $5H1vo.gridClasses).toolbarContainer}`)?.remove();
            gridToolbarElementHeight = 0;
        }
        if (normalizeOptions.hideFooter && gridFooterElement) {
            gridFooterElement.remove();
            gridFooterElementHeight = 0;
        }
        // Expand container height to accommodate all rows
        const computedTotalHeight = rowsMeta.currentPageTotalHeight + (0, $i0LyH.getTotalHeaderHeight)(apiRef, props) + gridToolbarElementHeight + gridFooterElementHeight;
        gridClone.style.height = `${computedTotalHeight}px`;
        // The height above does not include grid border width, so we need to exclude it
        gridClone.style.boxSizing = 'content-box';
        if (!normalizeOptions.hideFooter && gridFooterElement) {
            // the footer is always being placed at the bottom of the page as if all rows are exported
            // so if getRowsToExport is being used to only export a subset of rows then we need to
            // adjust the footer position to be correctly placed at the bottom of the grid
            gridFooterElement.style.position = 'absolute';
            gridFooterElement.style.width = '100%';
            gridFooterElement.style.top = `${computedTotalHeight - gridFooterElementHeight}px`;
        }
        // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement('div');
        container.appendChild(gridClone);
        // To avoid an empty page in start on Chromium based browsers
        printDoc.body.style.marginTop = '0px';
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === 'function' ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === 'string') {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement('style');
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
        const stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc.current;
            const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
            for(let i = 0; i < headStyleElements.length; i += 1){
                const node = headStyleElements[i];
                if (node.tagName === 'STYLE') {
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    const sheet = node.sheet;
                    if (sheet) {
                        let styleCSS = '';
                        // NOTE: for-of is not supported by IE
                        for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === 'string') styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                        newHeadStyleElements.appendChild(printDoc.createTextNode(styleCSS));
                        printDoc.head.appendChild(newHeadStyleElements);
                    }
                } else if (node.getAttribute('href')) {
                    // If `href` tag is empty, avoid loading these links
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    for(let j = 0; j < node.attributes.length; j += 1){
                        const attr = node.attributes[j];
                        if (attr) newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || '');
                    }
                    stylesheetLoadPromises.push(new Promise((resolve)=>{
                        newHeadStyleElements.addEventListener('load', ()=>resolve());
                    }));
                    printDoc.head.appendChild(newHeadStyleElements);
                }
            }
        }
        // wait for remote stylesheets to load
        Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc,
        props
    ]);
    const handlePrintWindowAfterPrint = $acw62.useCallback((printWindow)=>{
        // Remove the print iframe
        doc.current.body.removeChild(printWindow);
        // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!previousGridState.current?.columns?.columnVisibilityModel) // if the apiRef.current.exportState(); did not exported the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                virtualization: previousVirtualizationState.current
            }));
        apiRef.current.setRows(previousRows.current);
        // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = $acw62.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error('MUI X: No grid root element available.');
        previousGridState.current = apiRef.current.exportState();
        // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        previousRows.current = apiRef.current.getSortedRows().filter((row)=>!row[0, $7sDf4.GRID_ID_AUTOGENERATED]);
        if (props.pagination) {
            const visibleRowCount = (0, $k278Q.gridExpandedRowCountSelector)(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    pagination: (0, $8nd05.default)({}, state.pagination, {
                        paginationModel: (0, $87jE6.getDerivedPaginationModel)(state.pagination, // Using signature `DataGridPro` to allow more than 100 rows in the print export
                        'DataGridPro', paginationModel)
                    })
                }));
        }
        previousVirtualizationState.current = apiRef.current.state.virtualization;
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                virtualization: (0, $8nd05.default)({}, state.virtualization, {
                    enabled: false,
                    enabledForColumns: false
                })
            }));
        await updateGridColumnsForPrint(options?.fields, options?.allColumns, options?.includeCheckboxes);
        updateGridRowsForPrint(options?.getRowsToExport ?? (0, $jSbr9.defaultGetRowsToExport));
        await $35ed394581d01f61$var$raf(); // wait for the state changes to take action
        const printWindow = $35ed394581d01f61$var$buildPrintWindow(options?.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia('print');
            mediaQueryList.addEventListener('change', (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint: exportDataAsPrint
    };
    (0, $ivFej.useGridApiMethod)(apiRef, printExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $acw62.useCallback((initialValue, options)=>{
        if (options.printOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1v4Qb.GridPrintExportMenuItem), {
                    options: options.printOptions
                }),
                componentName: 'printExport'
            }
        ];
    }, []);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportMenu', addExportMenuButtons);
};

});
parcelRegister("87jE6", function(module, exports) {

$parcel$export(module.exports, "getDerivedPaginationModel", () => $5e8e37726d5ba261$export$16d1dc8477d07e4);
$parcel$export(module.exports, "useGridPaginationModel", () => $5e8e37726d5ba261$export$fb13b4a85293b054);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $k278Q = parcelRequire("k278Q");

var $fD9f4 = parcelRequire("fD9f4");

var $eFF1m = parcelRequire("eFF1m");
var $ivFej = parcelRequire("ivFej");
var $luu6e = parcelRequire("luu6e");
var $5sOMZ = parcelRequire("5sOMZ");

var $lR3Vo = parcelRequire("lR3Vo");

var $2kdmP = parcelRequire("2kdmP");

var $gPWuj = parcelRequire("gPWuj");

var $baj2X = parcelRequire("baj2X");
const $5e8e37726d5ba261$export$16d1dc8477d07e4 = (paginationState, signature, paginationModelProp)=>{
    let paginationModel = paginationState.paginationModel;
    const rowCount = paginationState.rowCount;
    const pageSize = paginationModelProp?.pageSize ?? paginationModel.pageSize;
    const page = paginationModelProp?.page ?? paginationModel.page;
    const pageCount = (0, $baj2X.getPageCount)(rowCount, pageSize, page);
    if (paginationModelProp && (paginationModelProp?.page !== paginationModel.page || paginationModelProp?.pageSize !== paginationModel.pageSize)) paginationModel = paginationModelProp;
    const validPage = pageSize === -1 ? 0 : (0, $baj2X.getValidPage)(paginationModel.page, pageCount);
    if (validPage !== paginationModel.page) paginationModel = (0, $8nd05.default)({}, paginationModel, {
        page: validPage
    });
    (0, $baj2X.throwIfPageSizeExceedsTheLimit)(paginationModel.pageSize, signature);
    return paginationModel;
};
const $5e8e37726d5ba261$export$fb13b4a85293b054 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPaginationModel');
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityFactorSelector));
    const previousFilterModel = $acw62.useRef((0, $k278Q.gridFilterModelSelector)(apiRef));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: 'paginationModel',
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: (0, $gPWuj.gridPaginationModelSelector),
        changeEvent: 'paginationModelChange'
    });
    /**
   * API METHODS
   */ const setPage = $acw62.useCallback((page)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page: page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const setPageSize = $acw62.useCallback((pageSize)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize: pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = $acw62.useCallback((paginationModel)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }), 'setPaginationModel');
    }, [
        apiRef,
        logger,
        props.signature
    ]);
    const paginationModelApi = {
        setPage: setPage,
        setPageSize: setPageSize,
        setPaginationModel: setPaginationModel
    };
    (0, $ivFej.useGridApiMethod)(apiRef, paginationModelApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        const shouldExportPaginationModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
        props.paginationModel != null || // Always export if the `paginationModel` has been initialized
        props.initialState?.pagination?.paginationModel != null || // Export if `page` or `pageSize` is not equal to the default value
        paginationModel.page !== 0 && paginationModel.pageSize !== (0, $baj2X.defaultPageSize)(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            pagination: (0, $8nd05.default)({}, prevState.pagination, {
                paginationModel: paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        props.initialState?.pagination?.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const paginationModel = context.stateToRestore.pagination?.paginationModel ? (0, $8nd05.default)({}, (0, $baj2X.getDefaultGridPaginationModel)(props.autoPageSize), context.stateToRestore.pagination?.paginationModel) : (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }), 'stateRestorePreProcessing');
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.signature
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = ()=>{
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (apiRef.current.virtualScrollerRef?.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
    };
    const handleUpdateAutoPageSize = $acw62.useCallback(()=>{
        if (!props.autoPageSize) return;
        const dimensions = apiRef.current.getRootDimensions();
        const maximumPageSizeWithoutScrollBar = Math.max(1, Math.floor(dimensions.viewportInnerSize.height / rowHeight));
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    const handleRowCountChange = $acw62.useCallback((newRowCount)=>{
        if (newRowCount == null) return;
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (paginationModel.page === 0) return;
        const pageCount = (0, $gPWuj.gridPageCountSelector)(apiRef);
        if (paginationModel.page > pageCount - 1) apiRef.current.setPage(Math.max(0, pageCount - 1));
    }, [
        apiRef
    ]);
    /**
   * Goes to the first row of the grid
   */ const navigateToStart = $acw62.useCallback(()=>{
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (paginationModel.page !== 0) apiRef.current.setPage(0);
        // If the page was not changed it might be needed to scroll to the top
        const scrollPosition = apiRef.current.getScrollPosition();
        if (scrollPosition.top !== 0) apiRef.current.scroll({
            top: 0
        });
    }, [
        apiRef
    ]);
    /**
   * Resets the page only if the active items or quick filter has changed from the last time.
   * This is to avoid resetting the page when the filter model is changed
   * because of and update of the operator from an item that does not have the value
   * or reseting when the filter panel is just opened
   */ const handleFilterModelChange = $acw62.useCallback((filterModel)=>{
        const currentActiveFilters = (0, $8nd05.default)({}, filterModel, {
            // replace items with the active items
            items: (0, $k278Q.gridFilterActiveItemsSelector)(apiRef)
        });
        if ((0, $lR3Vo.isDeepEqual)(currentActiveFilters, previousFilterModel.current)) return;
        previousFilterModel.current = currentActiveFilters;
        navigateToStart();
    }, [
        apiRef,
        navigateToStart
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowCountChange', handleRowCountChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'sortModelChange', (0, $lR3Vo.runIf)(props.resetPageOnSortFilter, navigateToStart));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'filterModelChange', (0, $lR3Vo.runIf)(props.resetPageOnSortFilter, handleFilterModelChange));
    /**
   * EFFECTS
   */ const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!props.pagination) return;
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$export$16d1dc8477d07e4(state.pagination, props.signature, props.paginationModel)
                })
            }));
    }, [
        apiRef,
        props.paginationModel,
        props.signature,
        props.pagination
    ]);
    $acw62.useEffect(()=>{
        apiRef.current.setState((state)=>{
            const isEnabled = props.pagination === true;
            if (state.pagination.paginationMode === props.paginationMode || state.pagination.enabled === isEnabled) return state;
            return (0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    paginationMode: props.paginationMode,
                    enabled: props.pagination === true
                })
            });
        });
    }, [
        apiRef,
        props.paginationMode,
        props.pagination
    ]);
    $acw62.useEffect(handleUpdateAutoPageSize, [
        handleUpdateAutoPageSize
    ]);
};

});


parcelRegister("cx8m0", function(module, exports) {

$parcel$export(module.exports, "filterStateInitializer", () => $91ff0c015e83a086$export$a3e5a984fe72a5db);
$parcel$export(module.exports, "useGridFilter", () => $91ff0c015e83a086$export$42838275cbf666c4);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $4KtEQ = parcelRequire("4KtEQ");

var $eEJPp = parcelRequire("eEJPp");

var $iYIN2 = parcelRequire("iYIN2");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $3PCYS = parcelRequire("3PCYS");

var $l4QMb = parcelRequire("l4QMb");

var $k278Q = parcelRequire("k278Q");

var $bc8LN = parcelRequire("bc8LN");

var $goCyd = parcelRequire("goCyd");

var $2kdmP = parcelRequire("2kdmP");

var $42J2j = parcelRequire("42J2j");
var $kmoo4 = parcelRequire("kmoo4");

var $14dIX = parcelRequire("14dIX");

var $lR3Vo = parcelRequire("lR3Vo");

var $ayMG0 = parcelRequire("ayMG0");
const $91ff0c015e83a086$export$a3e5a984fe72a5db = (state, props, apiRef)=>{
    const filterModel = props.filterModel ?? props.initialState?.filter?.filterModel ?? (0, $l4QMb.getDefaultGridFilterModel)();
    return (0, $8nd05.default)({}, state, {
        filter: (0, $8nd05.default)({
            filterModel: (0, $14dIX.sanitizeFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef)
        }, (0, $l4QMb.defaultGridFilterLookup)),
        visibleRowsLookup: {}
    });
};
const $91ff0c015e83a086$var$getVisibleRowsLookup = (params)=>{
    // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
    return params.filteredRowsLookup;
};
function $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function $91ff0c015e83a086$var$createMemoizedValues() {
    return (0, $4KtEQ.lruMemoize)(Object.values);
}
const $91ff0c015e83a086$export$42838275cbf666c4 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridFilter');
    apiRef.current.registerControlState({
        stateId: 'filter',
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: (0, $k278Q.gridFilterModelSelector),
        changeEvent: 'filterModelChange'
    });
    const updateFilteredRows = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, $k278Q.gridFilterModelSelector)(state, apiRef.current.instanceId);
            const filterState = apiRef.current.getFilterState(filterModel);
            const newState = (0, $8nd05.default)({}, state, {
                filter: (0, $8nd05.default)({}, state.filter, filterState)
            });
            const visibleRowsLookupState = $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, newState);
            return (0, $8nd05.default)({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent('filteredRowsSet');
    }, [
        apiRef
    ]);
    const addColumnMenuItem = $acw62.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.filterable === false || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuFilterItem'
        ];
    }, [
        props.disableColumnFilter
    ]);
    /**
   * API METHODS
   */ const applyFilters = $acw62.useCallback(()=>{
        updateFilteredRows();
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        updateFilteredRows
    ]);
    const upsertFilterItem = $acw62.useCallback((item)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: items
        }), 'upsertFilterItem');
    }, [
        apiRef
    ]);
    const upsertFilterItems = $acw62.useCallback((items)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = existingItems.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: existingItems
        }), 'upsertFilterItems');
    }, [
        apiRef
    ]);
    const deleteFilterItem = $acw62.useCallback((itemToDelete)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: items
        }), 'deleteFilterItem');
    }, [
        apiRef
    ]);
    const showFilterPanel = $acw62.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug('Displaying filter panel');
        if (targetColumnField) {
            const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                if (item.value !== undefined) {
                    // Some filters like `isAnyOf` support array as `item.value`.
                    // If array is empty, we want to remove it from the filter model.
                    if (Array.isArray(item.value) && item.value.length === 0) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = column.filterOperators?.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = typeof filterOperator?.requiresFilterValue === 'undefined' ? true : filterOperator?.requiresFilterValue;
                // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, $14dIX.cleanFilterItem)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, $14dIX.cleanFilterItem)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences((0, $3PCYS.GridPreferencePanelsValue).filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = $acw62.useCallback(()=>{
        logger.debug('Hiding filter panel');
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = $acw62.useCallback((logicOperator)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            logicOperator: logicOperator
        }), 'changeLogicOperator');
    }, [
        apiRef
    ]);
    const setQuickFilterValues = $acw62.useCallback((values)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if ((0, $lR3Vo.isDeepEqual)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = $acw62.useCallback((model, reason)=>{
        const currentModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug('Setting filter model');
            apiRef.current.updateControlState('filter', (0, $14dIX.mergeStateWithFilterModel)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const getFilterState = $acw62.useCallback((inputFilterModel)=>{
        const filterModel = (0, $14dIX.sanitizeFilterModel)(inputFilterModel, props.disableMultipleColumnsFiltering, apiRef);
        const isRowMatchingFilters = props.filterMode === 'client' ? (0, $14dIX.buildAggregatedFilterApplier)(filterModel, apiRef, props.disableEval) : null;
        const filterResult = apiRef.current.applyStrategyProcessor('filtering', {
            isRowMatchingFilters: isRowMatchingFilters,
            filterModel: filterModel ?? (0, $l4QMb.getDefaultGridFilterModel)()
        });
        return (0, $8nd05.default)({}, filterResult, {
            filterModel: filterModel
        });
    }, [
        props.disableMultipleColumnsFiltering,
        props.filterMode,
        props.disableEval,
        apiRef
    ]);
    const filterApi = {
        setFilterLogicOperator: setFilterLogicOperator,
        unstable_applyFilters: applyFilters,
        deleteFilterItem: deleteFilterItem,
        upsertFilterItem: upsertFilterItem,
        upsertFilterItems: upsertFilterItems,
        setFilterModel: setFilterModel,
        showFilterPanel: showFilterPanel,
        hideFilterPanel: hideFilterPanel,
        setQuickFilterValues: setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics,
        getFilterState: getFilterState
    };
    (0, $ivFej.useGridApiMethod)(apiRef, filterApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const filterModelToExport = (0, $k278Q.gridFilterModelSelector)(apiRef);
        // Remove the additional `fromInput` property from the filter model
        filterModelToExport.items.forEach((item)=>{
            delete item.fromInput;
        });
        const shouldExportFilterModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        props.initialState?.filter?.filterModel != null || // Export if the model is not equal to the default value
        !(0, $lR3Vo.isDeepEqual)(filterModelToExport, (0, $l4QMb.getDefaultGridFilterModel)());
        if (!shouldExportFilterModel) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        props.initialState?.filter?.filterModel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const filterModel = context.stateToRestore.filter?.filterModel;
        if (filterModel == null) return params;
        apiRef.current.updateControlState('filter', (0, $14dIX.mergeStateWithFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
        return (0, $8nd05.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = $acw62.useCallback((initialValue, value)=>{
        if (value === (0, $3PCYS.GridPreferencePanelsValue).filters) {
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(FilterPanel, (0, $8nd05.default)({}, props.slotProps?.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        props.slotProps?.filterPanel
    ]);
    const { getRowId: getRowId } = props;
    const getRowsRef = (0, $iYIN2.default)($91ff0c015e83a086$var$createMemoizedValues);
    const flatFilteringMethod = $acw62.useCallback((params)=>{
        if (props.filterMode !== 'client' || !params.isRowMatchingFilters || !params.filterModel.items.length && !params.filterModel.quickFilterValues?.length) return 0, $l4QMb.defaultGridFilterLookup;
        const dataRowIdToModelLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters: isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, undefined, result);
            const isRowPassing = (0, $14dIX.passFilterLogic)([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, apiRef, filterCache);
            filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = 'auto-generated-group-footer-root';
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup: filteredRowsLookup,
            filteredChildrenCountLookup: {},
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, (0, $42J2j.GRID_DEFAULT_STRATEGY), 'filtering', flatFilteringMethod);
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, (0, $42J2j.GRID_DEFAULT_STRATEGY), 'visibleRowsLookupCreation', $91ff0c015e83a086$var$getVisibleRowsLookup);
    /**
   * EVENTS
   */ const handleColumnsChange = $acw62.useCallback(()=>{
        logger.debug('onColUpdated - GridColumns changed, applying filters');
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const columnsLookup = (0, $jQEEt.gridColumnLookupSelector)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && columnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (methodName === 'filtering') apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                visibleRowsLookup: $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, state)
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    // Do not call `apiRef.current.forceUpdate` to avoid re-render before updating the sorted rows.
    // Otherwise, the state is not consistent during the render
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowsSet', updateFilteredRows);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnVisibilityModelChange', ()=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (filterModel.quickFilterValues && (0, $14dIX.shouldQuickFilterExcludeHiddenColumns)(filterModel)) // re-apply filters because the quick filter results may have changed
        apiRef.current.unstable_applyFilters();
    });
    /**
   * 1ST RENDER
   */ (0, $bc8LN.useFirstRender)(()=>{
        apiRef.current.unstable_applyFilters();
    });
    /**
   * EFFECTS
   */ (0, $eEJPp.default)(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};

});
parcelRegister("kmoo4", function(module, exports) {

$parcel$export(module.exports, "useGridRegisterStrategyProcessor", () => $ed28c789ae16a4b3$export$102a3f5a042c47c4);

var $acw62 = parcelRequire("acw62");

var $bc8LN = parcelRequire("bc8LN");
const $ed28c789ae16a4b3$export$102a3f5a042c47c4 = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = $acw62.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};

});


parcelRegister("1lT2X", function(module, exports) {

$parcel$export(module.exports, "focusStateInitializer", () => $0fc273bc52ff1742$export$bfde38b067fac467);
$parcel$export(module.exports, "useGridFocus", () => $0fc273bc52ff1742$export$8b69791fef06a777);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");

var $5H1vo = parcelRequire("5H1vo");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $eFF1m = parcelRequire("eFF1m");

var $dMF9H = parcelRequire("dMF9H");

var $drCmI = parcelRequire("drCmI");

var $jQEEt = parcelRequire("jQEEt");

var $aJApm = parcelRequire("aJApm");

var $lR3Vo = parcelRequire("lR3Vo");

var $goCyd = parcelRequire("goCyd");
const $0fc273bc52ff1742$export$bfde38b067fac467 = (state)=>(0, $8nd05.default)({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
const $0fc273bc52ff1742$export$8b69791fef06a777 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridFocus');
    const lastClickedCell = $acw62.useRef(null);
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const publishCellFocusOut = $acw62.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = $acw62.useCallback((id, field)=>{
        const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (focusedCell?.id === id && focusedCell?.field === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
        // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = $acw62.useCallback((field, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = $acw62.useCallback((field, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = $acw62.useCallback((field, depth, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (cell) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = $acw62.useCallback(()=>(0, $drCmI.gridFocusColumnGroupHeaderSelector)(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = $acw62.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = (0, $goCyd.gridPinnedRowsSelector)(apiRef);
        // Include pinned rows as well
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if (direction === 'right') columnIndexToFocus += 1;
        else if (direction === 'left') columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, $lR3Vo.clamp)(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === 'left' || direction === 'below') columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === 'right') columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, $lR3Vo.clamp)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = $acw62.useCallback(({ id: id, field: field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // GRID_CELL_NAVIGATION_KEY_DOWN handles the focus on Enter, Tab and navigation keys
        if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift' || (0, $dMF9H.isNavigationKey)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = $acw62.useCallback(({ field: field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = $acw62.useCallback(({ fields: fields, depth: depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = (0, $drCmI.gridFocusColumnGroupHeaderSelector)(apiRef);
        if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) // This group cell has already been focused
        return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = $acw62.useCallback((_, event)=>{
        if (event.relatedTarget?.getAttribute('class')?.includes((0, $5H1vo.gridClasses).columnHeader)) return;
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = $acw62.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = $acw62.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if (cellParams?.id === focusedCell.id && cellParams?.field === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement?.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            apiRef.current.forceUpdate();
            // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = $acw62.useCallback((params)=>{
        if (params.cellMode === 'view') return;
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (cell?.id !== params.id || cell?.field !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowSet = $acw62.useCallback(()=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        // If the focused cell is in a row which does not exist anymore,
        // focus previous row or remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) {
            const lastFocusedRowId = cell.id;
            let nextRowId = null;
            if (typeof lastFocusedRowId !== 'undefined') {
                const rowEl = apiRef.current.getRowElement(lastFocusedRowId);
                const lastFocusedRowIndex = rowEl?.dataset.rowindex ? Number(rowEl?.dataset.rowindex) : 0;
                const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
                    pagination: props.pagination,
                    paginationMode: props.paginationMode
                });
                const nextRow = currentPage.rows[(0, $lR3Vo.clamp)(lastFocusedRowIndex, 0, currentPage.rows.length - 1)];
                nextRowId = nextRow?.id ?? null;
            }
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    focus: {
                        cell: nextRowId === null ? null : {
                            id: nextRowId,
                            field: cell.field
                        },
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
        }
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handlePaginationModelChange = (0, $13KXh.default)(()=>{
        const currentFocusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage) return;
        const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            });
        });
    });
    const focusApi = {
        setCellFocus: setCellFocus,
        setColumnHeaderFocus: setColumnHeaderFocus,
        setColumnHeaderFilterFocus: setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell: moveFocusToRelativeCell,
        setColumnGroupHeaderFocus: setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus: getColumnGroupHeaderFocus
    };
    (0, $ivFej.useGridApiMethod)(apiRef, focusApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, focusPrivateApi, 'private');
    $acw62.useEffect(()=>{
        const doc = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
        doc.addEventListener('mouseup', handleDocumentClick);
        return ()=>{
            doc.removeEventListener('mouseup', handleDocumentClick);
        };
    }, [
        apiRef,
        hasRootReference,
        handleDocumentClick
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderBlur', handleBlur);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellDoubleClick', handleCellDoubleClick);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellMouseDown', handleCellMouseDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', handleCellKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellModeChange', handleCellModeChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowsSet', handleRowSet);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'paginationModelChange', handlePaginationModelChange);
};

});

parcelRegister("12xQD", function(module, exports) {

$parcel$export(module.exports, "useGridKeyboardNavigation", () => $0c203bd54aeaf237$export$142b8bb1fe6da473);

var $acw62 = parcelRequire("acw62");

var $9uEev = parcelRequire("9uEev");

var $jZka4 = parcelRequire("jZka4");

var $gRn8b = parcelRequire("gRn8b");

var $jQEEt = parcelRequire("jQEEt");

var $luu6e = parcelRequire("luu6e");

var $eFF1m = parcelRequire("eFF1m");

var $k278Q = parcelRequire("k278Q");

var $5bG6h = parcelRequire("5bG6h");

var $5H1vo = parcelRequire("5H1vo");

var $jkRzp = parcelRequire("jkRzp");

var $dMF9H = parcelRequire("dMF9H");

var $drCmI = parcelRequire("drCmI");

var $hMyIf = parcelRequire("hMyIf");

var $6forD = parcelRequire("6forD");

var $2kdmP = parcelRequire("2kdmP");

var $KtEo5 = parcelRequire("KtEo5");

var $39zQf = parcelRequire("39zQf");

var $8BltG = parcelRequire("8BltG");

var $cgQ4y = parcelRequire("cgQ4y");

var $gPWuj = parcelRequire("gPWuj");

var $goCyd = parcelRequire("goCyd");
const $0c203bd54aeaf237$var$gridVisibleRowsWithPinnedRowsSelector = (0, $cgQ4y.createSelectorMemoized)((0, $gPWuj.gridVisibleRowsSelector), (0, $goCyd.gridPinnedRowsSelector), (visibleRows, pinnedRows)=>{
    return (pinnedRows.top || []).concat(visibleRows.rows, pinnedRows.bottom || []);
});
const $0c203bd54aeaf237$export$142b8bb1fe6da473 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridKeyboardNavigation');
    const isRtl = (0, $9uEev.useRtl)();
    const listView = props.unstable_listView;
    const getCurrentPageRows = $acw62.useCallback(()=>{
        return $0c203bd54aeaf237$var$gridVisibleRowsWithPinnedRowsSelector(apiRef);
    }, [
        apiRef
    ]);
    const headerFilteringEnabled = props.signature !== 'DataGrid' && props.headerFilters;
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {GridRowId} rowId index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * @param {string} rowSpanScanDirection Which direction to search to find the next cell not hidden by `rowSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */ const goToCell = $acw62.useCallback((colIndex, rowId, closestColumnToUse = 'left', rowSpanScanDirection = 'up')=>{
        const visibleSortedRows = (0, $k278Q.gridExpandedSortedRowEntriesSelector)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === 'left') colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === 'right') colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        const field = listView ? (0, $8BltG.gridListColumnSelector)(apiRef.current.state).field : (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef)[colIndex];
        const nonRowSpannedRowId = (0, $39zQf.findNonRowSpannedCell)(apiRef, rowId, field, rowSpanScanDirection);
        // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === nonRowSpannedRowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        apiRef.current.setCellFocus(nonRowSpannedRowId, field);
    }, [
        apiRef,
        logger,
        listView
    ]);
    const goToHeader = $acw62.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = $acw62.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = $acw62.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const { field: field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = $acw62.useCallback((rowIndex)=>{
        return getCurrentPageRows()[rowIndex]?.id;
    }, [
        getCurrentPageRows
    ]);
    const handleColumnHeaderKeyDown = $acw62.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${(0, $5H1vo.gridClasses).columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        const columnGroupMaxDepth = (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector)(apiRef);
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else if (firstRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $39zQf.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeader(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $39zQf.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeader(leftColIndex, event);
                    break;
                }
            case 'ArrowUp':
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeader(firstColIndex, event);
                break;
            case 'End':
                goToHeader(lastColIndex, event);
                break;
            case 'Enter':
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        isRtl,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = $acw62.useCallback((params, event)=>{
        const isEditing = (0, $6forD.gridHeaderFilteringEditFieldSelector)(apiRef) === params.field;
        const isHeaderMenuOpen = (0, $6forD.gridHeaderFilteringMenuSelector)(apiRef) === params.field;
        if (isEditing || isHeaderMenuOpen || !(0, $dMF9H.isNavigationKey)(event.key)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                {
                    const rowId = getRowIdFromIndex(firstRowIndexInPage);
                    if (firstRowIndexInPage !== null && rowId != null) goToCell(colIndexBefore, rowId);
                    break;
                }
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $39zQf.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $39zQf.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case 'ArrowUp':
                goToHeader(colIndexBefore, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeaderFilter(firstColIndex, event);
                break;
            case 'End':
                goToHeaderFilter(lastColIndex, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        goToHeaderFilter,
        isRtl,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = $acw62.useCallback((params, event)=>{
        const focusedColumnGroup = (0, $drCmI.gridFocusColumnGroupHeaderSelector)(apiRef);
        if (focusedColumnGroup === null) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields: fields, depth: depth, maxDepth: maxDepth } = params;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case 'ArrowUp':
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case 'ArrowRight':
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case 'End':
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // Ignore portal
        if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
        // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === (0, $jkRzp.GridCellModes).Edit || !(0, $dMF9H.isNavigationKey)(event.key)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        const currentPageRows = getCurrentPageRows();
        if (currentPageRows.length === 0) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const getColumnIndexFn = listView ? ()=>0 : apiRef.current.getColumnIndex;
        const colIndexBefore = params.field ? getColumnIndexFn(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const visibleColumns = listView ? [
            (0, $8BltG.gridListColumnSelector)(apiRef.current.state)
        ] : (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const lastColIndex = visibleColumns.length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1), isRtl ? 'right' : 'left', 'down');
                break;
            case 'ArrowUp':
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else goToHeader(colIndexBefore, event);
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $39zQf.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'left' : 'right');
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $39zQf.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'right' : 'left');
                    break;
                }
            case 'Tab':
                // "Tab" is only triggered by the row / cell editing feature
                if (event.shiftKey && colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
                else if (!event.shiftKey && colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
                break;
            case ' ':
                {
                    const field = params.field;
                    if (field === (0, $jZka4.GRID_DETAIL_PANEL_TOGGLE_FIELD)) break;
                    const colDef = params.colDef;
                    if (colDef && (colDef.field === (0, $jZka4.GRID_TREE_DATA_GROUPING_FIELD) || (0, $gRn8b.isGroupingColumn)(colDef.field))) break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case 'PageDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'PageUp':
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case 'Home':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case 'End':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        isRtl,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader,
        listView
    ]);
    const checkIfCanStartEditing = $acw62.useCallback((initialValue, { event: event })=>{
        if (event.key === ' ') // Space scrolls to the last row
        return false;
        return initialValue;
    }, []);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'canStartEditing', checkIfCanStartEditing);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', handleCellKeyDown);
};

});
parcelRegister("gRn8b", function(module, exports) {

$parcel$export(module.exports, "isGroupingColumn", () => $c46389eb8540b1dc$export$452ffe3c6554619d);

var $jZka4 = parcelRequire("jZka4");
const $c46389eb8540b1dc$export$2c704fed6d7c53ee = (groupingColDefField)=>{
    const match = groupingColDefField.match(/^__row_group_by_columns_group_(.*)__$/);
    if (!match) return null;
    return match[1];
};
const $c46389eb8540b1dc$export$452ffe3c6554619d = (field)=>field === (0, $jZka4.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD) || $c46389eb8540b1dc$export$2c704fed6d7c53ee(field) !== null;

});

parcelRegister("KtEo5", function(module, exports) {

$parcel$export(module.exports, "isOverflown", () => $08bb4bf24f47b880$export$c8be9a8325efa7ee);
$parcel$export(module.exports, "findParentElementFromClassName", () => $08bb4bf24f47b880$export$2a63f1401414fc1a);
$parcel$export(module.exports, "escapeOperandAttributeSelector", () => $08bb4bf24f47b880$export$77eab2954df72e62);
$parcel$export(module.exports, "getGridColumnHeaderElement", () => $08bb4bf24f47b880$export$94318ffb75913a0b);
$parcel$export(module.exports, "getGridRowElement", () => $08bb4bf24f47b880$export$9bc8bb868a922a5f);
$parcel$export(module.exports, "getGridCellElement", () => $08bb4bf24f47b880$export$44827662627a59);
$parcel$export(module.exports, "isEventTargetInPortal", () => $08bb4bf24f47b880$export$8ce496ad3bfbe3a6);
$parcel$export(module.exports, "getFieldFromHeaderElem", () => $08bb4bf24f47b880$export$2c4260a98d98f894);
$parcel$export(module.exports, "findHeaderElementFromField", () => $08bb4bf24f47b880$export$a2d3aec9ff63900b);
$parcel$export(module.exports, "getFieldsFromGroupHeaderElem", () => $08bb4bf24f47b880$export$5d6880d172f0ecbb);
$parcel$export(module.exports, "findGroupHeaderElementsFromField", () => $08bb4bf24f47b880$export$1e5569d10c3ebc8b);
$parcel$export(module.exports, "findGridCellElementsFromCol", () => $08bb4bf24f47b880$export$53d8041b57f0055);
$parcel$export(module.exports, "findGridElement", () => $08bb4bf24f47b880$export$c16d6f1be06f3423);
$parcel$export(module.exports, "findLeftPinnedCellsAfterCol", () => $08bb4bf24f47b880$export$71cc5934f05ca0a1);
$parcel$export(module.exports, "findRightPinnedCellsBeforeCol", () => $08bb4bf24f47b880$export$2eb3bec73fd25ab);
$parcel$export(module.exports, "findLeftPinnedHeadersAfterCol", () => $08bb4bf24f47b880$export$18b98bbb853bc2c4);
$parcel$export(module.exports, "findRightPinnedHeadersBeforeCol", () => $08bb4bf24f47b880$export$a2731c8163776b73);
$parcel$export(module.exports, "findGridHeader", () => $08bb4bf24f47b880$export$5c4f873e8f18904d);
$parcel$export(module.exports, "findGridCells", () => $08bb4bf24f47b880$export$ee9bd404f74f7c9);

var $5H1vo = parcelRequire("5H1vo");
function $08bb4bf24f47b880$export$c8be9a8325efa7ee(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function $08bb4bf24f47b880$export$2a63f1401414fc1a(elem, className) {
    return elem.closest(`.${className}`);
}
function $08bb4bf24f47b880$export$77eab2954df72e62(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}
function $08bb4bf24f47b880$export$94318ffb75913a0b(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${$08bb4bf24f47b880$export$77eab2954df72e62(field)}"]`);
}
function $08bb4bf24f47b880$var$getGridRowElementSelector(id) {
    return `.${(0, $5H1vo.gridClasses).row}[data-id="${$08bb4bf24f47b880$export$77eab2954df72e62(String(id))}"]`;
}
function $08bb4bf24f47b880$export$9bc8bb868a922a5f(root, id) {
    return root.querySelector($08bb4bf24f47b880$var$getGridRowElementSelector(id));
}
function $08bb4bf24f47b880$export$44827662627a59(root, { id: id, field: field }) {
    const rowSelector = $08bb4bf24f47b880$var$getGridRowElementSelector(id);
    const cellSelector = `.${(0, $5H1vo.gridClasses).cell}[data-field="${$08bb4bf24f47b880$export$77eab2954df72e62(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
const $08bb4bf24f47b880$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $08bb4bf24f47b880$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
function $08bb4bf24f47b880$export$8ce496ad3bfbe3a6(event) {
    if (// The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return true;
    return false;
}
function $08bb4bf24f47b880$export$2c4260a98d98f894(colCellEl) {
    return colCellEl.getAttribute('data-field');
}
function $08bb4bf24f47b880$export$a2d3aec9ff63900b(elem, field) {
    return elem.querySelector(`[data-field="${$08bb4bf24f47b880$export$77eab2954df72e62(field)}"]`);
}
function $08bb4bf24f47b880$export$5d6880d172f0ecbb(colCellEl) {
    return colCellEl.getAttribute('data-fields').slice(2, -2).split('-|-');
}
function $08bb4bf24f47b880$export$1e5569d10c3ebc8b(elem, field) {
    return Array.from(elem.querySelectorAll(`[data-fields*="|-${$08bb4bf24f47b880$export$77eab2954df72e62(field)}-|"]`) ?? []);
}
function $08bb4bf24f47b880$export$53d8041b57f0055(col, api) {
    const root = $08bb4bf24f47b880$export$2a63f1401414fc1a(col, (0, $5H1vo.gridClasses).root);
    if (!root) throw new Error('MUI X: The root element is not found.');
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return [];
    const colIndex = Number(ariaColIndex) - 1;
    const cells = [];
    if (!api.virtualScrollerRef?.current) return [];
    $08bb4bf24f47b880$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        let columnIndex = colIndex;
        const cellColSpanInfo = api.unstable_getCellColSpanInfo(rowId, colIndex);
        if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) columnIndex = cellColSpanInfo.leftVisibleCellIndex;
        const cell = rowElement.querySelector(`[data-colindex="${columnIndex}"]`);
        if (cell) cells.push(cell);
    });
    return cells;
}
function $08bb4bf24f47b880$export$c16d6f1be06f3423(api, klass) {
    return api.rootElementRef.current.querySelector(`.${(0, $5H1vo.gridClasses)[klass]}`);
}
const $08bb4bf24f47b880$var$findPinnedCells = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (colIndex === null) return [];
    const cells = [];
    $08bb4bf24f47b880$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        rowElement.querySelectorAll(`.${(0, $5H1vo.gridClasses)[position === 'left' ? 'cell--pinnedLeft' : 'cell--pinnedRight']}`).forEach((cell)=>{
            const currentColIndex = $08bb4bf24f47b880$var$parseCellColIndex(cell);
            if (currentColIndex !== null && filterFn(currentColIndex)) cells.push(cell);
        });
    });
    return cells;
};
function $08bb4bf24f47b880$export$71cc5934f05ca0a1(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'right' : 'left',
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $08bb4bf24f47b880$export$2eb3bec73fd25ab(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'left' : 'right',
        filterFn: (index)=>isRtl ? index > colIndex : index < colIndex
    });
}
const $08bb4bf24f47b880$var$findPinnedHeaders = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (!api.columnHeadersContainerRef?.current) return [];
    if (colIndex === null) return [];
    const elements = [];
    api.columnHeadersContainerRef.current.querySelectorAll(`.${(0, $5H1vo.gridClasses)[position === 'left' ? 'columnHeader--pinnedLeft' : 'columnHeader--pinnedRight']}`).forEach((element)=>{
        const currentColIndex = $08bb4bf24f47b880$var$parseCellColIndex(element);
        if (currentColIndex !== null && filterFn(currentColIndex, element)) elements.push(element);
    });
    return elements;
};
function $08bb4bf24f47b880$export$18b98bbb853bc2c4(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'right' : 'left',
        colIndex: colIndex,
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $08bb4bf24f47b880$export$a2731c8163776b73(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'left' : 'right',
        colIndex: colIndex,
        filterFn: (index, element)=>{
            if (element.classList.contains((0, $5H1vo.gridClasses)['columnHeader--last'])) return false;
            return isRtl ? index > colIndex : index < colIndex;
        }
    });
}
function $08bb4bf24f47b880$export$5c4f873e8f18904d(api, field) {
    const headers = api.columnHeadersContainerRef.current;
    return headers.querySelector(`:scope > div > [data-field="${$08bb4bf24f47b880$export$77eab2954df72e62(field)}"][role="columnheader"]`);
}
function $08bb4bf24f47b880$export$ee9bd404f74f7c9(api, field) {
    const container = api.virtualScrollerRef.current;
    return Array.from(container.querySelectorAll(`:scope > div > div > div > [data-field="${$08bb4bf24f47b880$export$77eab2954df72e62(field)}"][role="gridcell"]`));
}
function $08bb4bf24f47b880$var$queryRows(api) {
    return api.virtualScrollerRef.current.querySelectorAll(// Use > to ignore rows from nested Data Grids (for example in detail panel)
    `:scope > div > div > .${(0, $5H1vo.gridClasses).row}`);
}
function $08bb4bf24f47b880$var$parseCellColIndex(col) {
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return null;
    return Number(ariaColIndex) - 1;
}

});

parcelRegister("39zQf", function(module, exports) {

$parcel$export(module.exports, "getLeftColumnIndex", () => $24be03c588f8c679$export$7c625e86ddfff1ed);
$parcel$export(module.exports, "getRightColumnIndex", () => $24be03c588f8c679$export$21527d4fb6084929);
$parcel$export(module.exports, "findNonRowSpannedCell", () => $24be03c588f8c679$export$d48a7b476a2f0ae5);

var $k278Q = parcelRequire("k278Q");

var $hMoDT = parcelRequire("hMoDT");
const $24be03c588f8c679$export$7c625e86ddfff1ed = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if (!isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
const $24be03c588f8c679$export$21527d4fb6084929 = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if (!isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
function $24be03c588f8c679$export$d48a7b476a2f0ae5(apiRef, rowId, field, rowSpanScanDirection) {
    const rowSpanHiddenCells = (0, $hMoDT.gridRowSpanningHiddenCellsSelector)(apiRef);
    if (!rowSpanHiddenCells[rowId]?.[field]) return rowId;
    const filteredSortedRowIds = (0, $k278Q.gridFilteredSortedRowIdsSelector)(apiRef);
    // find closest non row spanned cell in the given `rowSpanScanDirection`
    let nextRowIndex = filteredSortedRowIds.indexOf(rowId) + (rowSpanScanDirection === 'down' ? 1 : -1);
    while(nextRowIndex >= 0 && nextRowIndex < filteredSortedRowIds.length){
        const nextRowId = filteredSortedRowIds[nextRowIndex];
        if (!rowSpanHiddenCells[nextRowId]?.[field]) return nextRowId;
        nextRowIndex += rowSpanScanDirection === 'down' ? 1 : -1;
    }
    return rowId;
}

});


parcelRegister("3m1KX", function(module, exports) {

$parcel$export(module.exports, "paginationStateInitializer", () => $2714c9ed9cdf2996$export$951a05deca7e869f);
$parcel$export(module.exports, "useGridPagination", () => $2714c9ed9cdf2996$export$f1c8f1c02d202e22);

var $8nd05 = parcelRequire("8nd05");

var $baj2X = parcelRequire("baj2X");

var $87jE6 = parcelRequire("87jE6");

var $hVzRt = parcelRequire("hVzRt");

var $hT3rk = parcelRequire("hT3rk");
const $2714c9ed9cdf2996$export$951a05deca7e869f = (state, props)=>{
    const paginationModel = (0, $8nd05.default)({}, (0, $baj2X.getDefaultGridPaginationModel)(props.autoPageSize), props.paginationModel ?? props.initialState?.pagination?.paginationModel);
    (0, $baj2X.throwIfPageSizeExceedsTheLimit)(paginationModel.pageSize, props.signature);
    const rowCount = props.rowCount ?? props.initialState?.pagination?.rowCount ?? (props.paginationMode === 'client' ? state.rows?.totalRowCount : undefined);
    const meta = props.paginationMeta ?? props.initialState?.pagination?.meta ?? {};
    return (0, $8nd05.default)({}, state, {
        pagination: (0, $8nd05.default)({}, state.pagination, {
            paginationModel: paginationModel,
            rowCount: rowCount,
            meta: meta,
            enabled: props.pagination === true,
            paginationMode: props.paginationMode
        })
    });
};
const $2714c9ed9cdf2996$export$f1c8f1c02d202e22 = (apiRef, props)=>{
    (0, $hT3rk.useGridPaginationMeta)(apiRef, props);
    (0, $87jE6.useGridPaginationModel)(apiRef, props);
    (0, $hVzRt.useGridRowCount)(apiRef, props);
};

});
parcelRegister("hVzRt", function(module, exports) {

$parcel$export(module.exports, "useGridRowCount", () => $d0d393dcade2390b$export$229d07cf557fa73f);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $iYIN2 = parcelRequire("iYIN2");

var $k278Q = parcelRequire("k278Q");

var $eFF1m = parcelRequire("eFF1m");
var $ivFej = parcelRequire("ivFej");
var $luu6e = parcelRequire("luu6e");
var $5sOMZ = parcelRequire("5sOMZ");

var $2kdmP = parcelRequire("2kdmP");

var $gPWuj = parcelRequire("gPWuj");
const $d0d393dcade2390b$export$229d07cf557fa73f = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridRowCount');
    const visibleTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilteredTopLevelRowCountSelector));
    const rowCountState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationRowCountSelector));
    const paginationMeta = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationMetaSelector));
    const paginationModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationModelSelector));
    const previousPageSize = (0, $iYIN2.default)(()=>(0, $gPWuj.gridPaginationModelSelector)(apiRef).pageSize);
    apiRef.current.registerControlState({
        stateId: 'paginationRowCount',
        propModel: props.rowCount,
        propOnChange: props.onRowCountChange,
        stateSelector: (0, $gPWuj.gridPaginationRowCountSelector),
        changeEvent: 'rowCountChange'
    });
    /**
   * API METHODS
   */ const setRowCount = $acw62.useCallback((newRowCount)=>{
        if (rowCountState === newRowCount) return;
        logger.debug("Setting 'rowCount' to", newRowCount);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    rowCount: newRowCount
                })
            }));
    }, [
        apiRef,
        logger,
        rowCountState
    ]);
    const paginationRowCountApi = {
        setRowCount: setRowCount
    };
    (0, $ivFej.useGridApiMethod)(apiRef, paginationRowCountApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const exportedRowCount = (0, $gPWuj.gridPaginationRowCountSelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
        props.rowCount != null || // Always export if the `rowCount` has been initialized
        props.initialState?.pagination?.rowCount != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            pagination: (0, $8nd05.default)({}, prevState.pagination, {
                rowCount: exportedRowCount
            })
        });
    }, [
        apiRef,
        props.rowCount,
        props.initialState?.pagination?.rowCount
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const restoredRowCount = context.stateToRestore.pagination?.rowCount ? context.stateToRestore.pagination.rowCount : (0, $gPWuj.gridPaginationRowCountSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    rowCount: restoredRowCount
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = $acw62.useCallback((model)=>{
        if (props.paginationMode === 'client' || !previousPageSize.current) return;
        if (model.pageSize !== previousPageSize.current) {
            previousPageSize.current = model.pageSize;
            if (rowCountState === -1) // Row count unknown and page size changed, reset the page
            apiRef.current.setPage(0);
        }
    }, [
        props.paginationMode,
        previousPageSize,
        rowCountState,
        apiRef
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        if (props.paginationMode === 'client') apiRef.current.setRowCount(visibleTopLevelRowCount);
        else if (props.rowCount != null) apiRef.current.setRowCount(props.rowCount);
    }, [
        apiRef,
        props.paginationMode,
        visibleTopLevelRowCount,
        props.rowCount
    ]);
    const isLastPage = paginationMeta.hasNextPage === false;
    $acw62.useEffect(()=>{
        if (isLastPage && rowCountState === -1) apiRef.current.setRowCount(paginationModel.pageSize * paginationModel.page + visibleTopLevelRowCount);
    }, [
        apiRef,
        visibleTopLevelRowCount,
        isLastPage,
        rowCountState,
        paginationModel
    ]);
};

});

parcelRegister("hT3rk", function(module, exports) {

$parcel$export(module.exports, "useGridPaginationMeta", () => $d05a3dc983bf505e$export$3e4f856d83dbf104);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
var $luu6e = parcelRequire("luu6e");
var $5sOMZ = parcelRequire("5sOMZ");

var $2kdmP = parcelRequire("2kdmP");

var $gPWuj = parcelRequire("gPWuj");
const $d05a3dc983bf505e$export$3e4f856d83dbf104 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPaginationMeta');
    const paginationMeta = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationMetaSelector));
    apiRef.current.registerControlState({
        stateId: 'paginationMeta',
        propModel: props.paginationMeta,
        propOnChange: props.onPaginationMetaChange,
        stateSelector: (0, $gPWuj.gridPaginationMetaSelector),
        changeEvent: 'paginationMetaChange'
    });
    /**
   * API METHODS
   */ const setPaginationMeta = $acw62.useCallback((newPaginationMeta)=>{
        if (paginationMeta === newPaginationMeta) return;
        logger.debug("Setting 'paginationMeta' to", newPaginationMeta);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    meta: newPaginationMeta
                })
            }));
    }, [
        apiRef,
        logger,
        paginationMeta
    ]);
    const paginationMetaApi = {
        setPaginationMeta: setPaginationMeta
    };
    (0, $ivFej.useGridApiMethod)(apiRef, paginationMetaApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const exportedPaginationMeta = (0, $gPWuj.gridPaginationMetaSelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
        props.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
        props.initialState?.pagination?.meta != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            pagination: (0, $8nd05.default)({}, prevState.pagination, {
                meta: exportedPaginationMeta
            })
        });
    }, [
        apiRef,
        props.paginationMeta,
        props.initialState?.pagination?.meta
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const restoredPaginationMeta = context.stateToRestore.pagination?.meta ? context.stateToRestore.pagination.meta : (0, $gPWuj.gridPaginationMetaSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    meta: restoredPaginationMeta
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        if (props.paginationMeta) apiRef.current.setPaginationMeta(props.paginationMeta);
    }, [
        apiRef,
        props.paginationMeta
    ]);
};

});


parcelRegister("4epuR", function(module, exports) {

$parcel$export(module.exports, "preferencePanelStateInitializer", () => $314c3f5b8282a42e$export$a9f45f767b8ade48);
$parcel$export(module.exports, "useGridPreferencesPanel", () => $314c3f5b8282a42e$export$343dd9a605dbb75b);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $2kdmP = parcelRequire("2kdmP");

var $6X2Yd = parcelRequire("6X2Yd");
const $314c3f5b8282a42e$export$a9f45f767b8ade48 = (state, props)=>(0, $8nd05.default)({}, state, {
        preferencePanel: props.initialState?.preferencePanel ?? {
            open: false
        }
    });
const $314c3f5b8282a42e$export$343dd9a605dbb75b = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPreferencesPanel');
    /**
   * API METHODS
   */ const hidePreferences = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (!state.preferencePanel.open) return state;
            logger.debug('Hiding Preferences Panel');
            const preferencePanelState = (0, $6X2Yd.gridPreferencePanelStateSelector)(state);
            apiRef.current.publishEvent('preferencePanelClose', {
                openedPanelValue: preferencePanelState.openedPanelValue
            });
            return (0, $8nd05.default)({}, state, {
                preferencePanel: {
                    open: false
                }
            });
        });
    }, [
        apiRef,
        logger
    ]);
    const showPreferences = $acw62.useCallback((newValue, panelId, labelId)=>{
        logger.debug('Opening Preferences Panel');
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                preferencePanel: (0, $8nd05.default)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            }));
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
    }, [
        logger,
        apiRef
    ]);
    (0, $ivFej.useGridApiMethod)(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferences
    }, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const preferencePanelToExport = (0, $6X2Yd.gridPreferencePanelStateSelector)(apiRef.current.state);
        const shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        props.initialState?.preferencePanel != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        props.initialState?.preferencePanel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                preferencePanel: preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
};

});

parcelRegister("fTRdy", function(module, exports) {

$parcel$export(module.exports, "editingStateInitializer", () => $b93545fe9a3b3245$export$1094a2c822d71ffd);
$parcel$export(module.exports, "useGridEditing", () => $b93545fe9a3b3245$export$3a0db16b152b4c54);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $3uAik = parcelRequire("3uAik");

var $jkRzp = parcelRequire("jkRzp");

var $h652i = parcelRequire("h652i");

var $5Rfo7 = parcelRequire("5Rfo7");

var $7sDf4 = parcelRequire("7sDf4");
const $b93545fe9a3b3245$export$1094a2c822d71ffd = (state)=>(0, $8nd05.default)({}, state, {
        editRows: {}
    });
const $b93545fe9a3b3245$export$3a0db16b152b4c54 = (apiRef, props)=>{
    (0, $3uAik.useGridCellEditing)(apiRef, props);
    (0, $h652i.useGridRowEditing)(apiRef, props);
    const debounceMap = $acw62.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditable = $acw62.useCallback((params)=>{
        if ((0, $7sDf4.isAutogeneratedRowNode)(params.rowNode)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    $acw62.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = $acw62.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = $acw62.useCallback((params)=>{
        const { id: id, field: field, debounceMs: debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === (0, $jkRzp.GridEditModes).Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === (0, $jkRzp.GridCellModes).Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = $acw62.useCallback((id, field)=>{
        return props.editMode === (0, $jkRzp.GridEditModes).Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = $acw62.useCallback((id, field)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        return editingState[id]?.[field] ?? null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingSharedApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingSharedPrivateApi, 'private');
};

});
parcelRegister("3uAik", function(module, exports) {

$parcel$export(module.exports, "useGridCellEditing", () => $28b053c97cee4bd6$export$2c9a271ac5d3f446);

var $1En50 = parcelRequire("1En50");

var $4ZreY = parcelRequire("4ZreY");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");


var $eFF1m = parcelRequire("eFF1m");

var $jkRzp = parcelRequire("jkRzp");

var $ivFej = parcelRequire("ivFej");

var $5Rfo7 = parcelRequire("5Rfo7");

var $dMF9H = parcelRequire("dMF9H");

var $goCyd = parcelRequire("goCyd");

var $lR3Vo = parcelRequire("lR3Vo");

var $iNfie = parcelRequire("iNfie");

var $a4Ou4 = parcelRequire("a4Ou4");
const $28b053c97cee4bd6$var$_excluded = [
    "id",
    "field"
], $28b053c97cee4bd6$var$_excluded2 = [
    "id",
    "field"
];
const $28b053c97cee4bd6$export$2c9a271ac5d3f446 = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = $acw62.useState({});
    const cellModesModelRef = $acw62.useRef(cellModesModel);
    const prevCellModesModel = $acw62.useRef({});
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange: onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === (0, $jkRzp.GridEditModes).Cell) callback(...args);
        };
    const throwIfNotEditable = $acw62.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $acw62.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === (0, $jkRzp.GridCellModes).Edit) return;
        const newParams = (0, $8nd05.default)({}, params, {
            reason: (0, $iNfie.GridCellEditStartReasons).cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $jkRzp.GridCellModes).View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $jkRzp.GridCellModes).View) return;
        const newParams = (0, $8nd05.default)({}, params, {
            reason: (0, $iNfie.GridCellEditStopReasons).cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $jkRzp.GridCellModes).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $iNfie.GridCellEditStopReasons).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $iNfie.GridCellEditStopReasons).enterKeyDown;
            else if (event.key === 'Tab') {
                reason = event.shiftKey ? (0, $iNfie.GridCellEditStopReasons).shiftTabKeyDown : (0, $iNfie.GridCellEditStopReasons).tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, $8nd05.default)({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) return;
            if ((0, $dMF9H.isPrintableKey)(event)) reason = (0, $iNfie.GridCellEditStartReasons).printableKeyDown;
            else if ((0, $dMF9H.isPasteShortcut)(event)) reason = (0, $iNfie.GridCellEditStartReasons).pasteKeyDown;
            else if (event.key === 'Enter') reason = (0, $iNfie.GridCellEditStartReasons).enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = (0, $iNfie.GridCellEditStartReasons).deleteKeyDown;
            if (reason) {
                const newParams = (0, $8nd05.default)({}, params, {
                    reason: reason,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === (0, $iNfie.GridCellEditStartReasons).printableKeyDown || reason === (0, $iNfie.GridCellEditStartReasons).deleteKeyDown || reason === (0, $iNfie.GridCellEditStartReasons).pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === (0, $iNfie.GridCellEditStopReasons).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $iNfie.GridCellEditStopReasons).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $iNfie.GridCellEditStopReasons).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    const runIfNoFieldErrors = (callback)=>async (...args)=>{
            if (callback) {
                const { id: id, field: field } = args[0];
                const editRowsState = apiRef.current.state.editRows;
                const hasFieldErrors = editRowsState[id][field]?.error;
                if (!hasFieldErrors) callback(...args);
            }
        };
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellEditStart', props.onCellEditStart);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellEditStop', runIfNoFieldErrors(props.onCellEditStop));
    const getCellMode = $acw62.useCallback((id, field)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? (0, $jkRzp.GridCellModes).Edit : (0, $jkRzp.GridCellModes).View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, $13KXh.default)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    const updateFieldInCellModesModel = $acw62.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, $8nd05.default)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $8nd05.default)({}, newModel[id], {
            [field]: (0, $8nd05.default)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, $1En50.default)(_newModel$id, [
                field
            ].map((0, $4ZreY.default))); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = $acw62.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $8nd05.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $8nd05.default)({}, newEditingState[id], {
                [field]: (0, $8nd05.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $8nd05.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startCellEditMode = $acw62.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $1En50.default)(params, $28b053c97cee4bd6$var$_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $jkRzp.GridCellModes).View);
        updateFieldInCellModesModel(id, field, (0, $8nd05.default)({
            mode: (0, $jkRzp.GridCellModes).Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, $13KXh.default)(async (params)=>{
        const { id: id, field: field, deleteValue: deleteValue, initialValue: initialValue } = params;
        const value = apiRef.current.getCellValue(id, field);
        let newValue = value;
        if (deleteValue) newValue = (0, $a4Ou4.getDefaultCellValue)(apiRef.current.getColumn(field));
        else if (initialValue) newValue = initialValue;
        const column = apiRef.current.getColumn(field);
        const shouldProcessEditCellProps = !!column.preProcessEditCellProps && deleteValue;
        let newProps = {
            value: newValue,
            error: false,
            isProcessingProps: shouldProcessEditCellProps
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
        if (shouldProcessEditCellProps) {
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: apiRef.current.getRow(id),
                props: newProps,
                hasChanged: newValue !== value
            }));
            // Check if still in edit mode before updating
            if (apiRef.current.getCellMode(id, field) === (0, $jkRzp.GridCellModes).Edit) {
                const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
                updateOrDeleteFieldState(id, field, (0, $8nd05.default)({}, newProps, {
                    value: editingState[id][field].value,
                    isProcessingProps: false
                }));
            }
        }
    });
    const stopCellEditMode = $acw62.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $1En50.default)(params, $28b053c97cee4bd6$var$_excluded2);
        throwIfNotInMode(id, field, (0, $jkRzp.GridCellModes).Edit);
        updateFieldInCellModesModel(id, field, (0, $8nd05.default)({
            mode: (0, $jkRzp.GridCellModes).View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, $13KXh.default)(async (params)=>{
        const { id: id, field: field, ignoreModifications: ignoreModifications, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        throwIfNotInMode(id, field, (0, $jkRzp.GridCellModes).Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== 'none') apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const { error: error, isProcessingProps: isProcessingProps } = editingState[id][field];
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = (0, $jkRzp.GridCellModes).Edit;
            // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: (0, $jkRzp.GridCellModes).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = (0, $jkRzp.GridCellModes).Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: (0, $jkRzp.GridCellModes).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
            };
            try {
                const row = apiRef.current.getRow(id);
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = $acw62.useCallback(async (params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $jkRzp.GridCellModes).Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        let newProps = (0, $8nd05.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, $8nd05.default)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps,
                hasChanged: hasChanged
            }));
        }
        // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === (0, $jkRzp.GridCellModes).View) return false;
        editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        newProps = (0, $8nd05.default)({}, newProps, {
            isProcessingProps: false
        });
        // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        return !editingState[id]?.[field]?.error;
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = $acw62.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value: value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter(value, row, column, apiRef) : (0, $8nd05.default)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingPrivateApi, 'private');
    $acw62.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $eEJPp.default)(()=>{
        const rowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, $lR3Vo.deepClone)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                const prevMode = copyOfPrevCellModes[id]?.[field]?.mode || (0, $jkRzp.GridCellModes).View;
                const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
                if (params.mode === (0, $jkRzp.GridCellModes).Edit && prevMode === (0, $jkRzp.GridCellModes).View) updateStateToStartCellEditMode((0, $8nd05.default)({
                    id: originalId,
                    field: field
                }, params));
                else if (params.mode === (0, $jkRzp.GridCellModes).View && prevMode === (0, $jkRzp.GridCellModes).Edit) updateStateToStopCellEditMode((0, $8nd05.default)({
                    id: originalId,
                    field: field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};

});
parcelRegister("5Rfo7", function(module, exports) {

$parcel$export(module.exports, "gridEditRowsStateSelector", () => $443dd6b911893b50$export$91ed78b95c9e6636);
$parcel$export(module.exports, "gridRowIsEditingSelector", () => $443dd6b911893b50$export$3ca6aabd7600f0b3);
$parcel$export(module.exports, "gridEditCellStateSelector", () => $443dd6b911893b50$export$e6f93ce5e9b42cd9);

var $cgQ4y = parcelRequire("cgQ4y");

var $jkRzp = parcelRequire("jkRzp");
const $443dd6b911893b50$export$91ed78b95c9e6636 = (state)=>state.editRows;
const $443dd6b911893b50$export$3ca6aabd7600f0b3 = (0, $cgQ4y.createSelectorV8)($443dd6b911893b50$export$91ed78b95c9e6636, (editRows, { rowId: rowId, editMode: editMode })=>editMode === (0, $jkRzp.GridEditModes).Row && Boolean(editRows[rowId]));
const $443dd6b911893b50$export$e6f93ce5e9b42cd9 = (0, $cgQ4y.createSelectorV8)($443dd6b911893b50$export$91ed78b95c9e6636, (editRows, { rowId: rowId, field: field })=>editRows[rowId]?.[field] ?? null);

});

parcelRegister("a4Ou4", function(module, exports) {

$parcel$export(module.exports, "getDefaultCellValue", () => $7561702eaa720cf2$export$311bd602ebd44399);
const $7561702eaa720cf2$export$311bd602ebd44399 = (colDef)=>{
    switch(colDef.type){
        case 'boolean':
            return false;
        case 'date':
        case 'dateTime':
        case 'number':
            return undefined;
        case 'singleSelect':
            return null;
        case 'string':
        default:
            return '';
    }
};

});


parcelRegister("h652i", function(module, exports) {

$parcel$export(module.exports, "useGridRowEditing", () => $c726e745e154c244$export$a43bf4f64ed7f919);

var $4ZreY = parcelRequire("4ZreY");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");


var $eFF1m = parcelRequire("eFF1m");

var $jkRzp = parcelRequire("jkRzp");

var $ivFej = parcelRequire("ivFej");

var $5Rfo7 = parcelRequire("5Rfo7");

var $dMF9H = parcelRequire("dMF9H");

var $jQEEt = parcelRequire("jQEEt");

var $goCyd = parcelRequire("goCyd");

var $lR3Vo = parcelRequire("lR3Vo");

var $jfE7J = parcelRequire("jfE7J");

var $8z2XQ = parcelRequire("8z2XQ");

var $a4Ou4 = parcelRequire("a4Ou4");
const $c726e745e154c244$var$_excluded = [
    "id"
], $c726e745e154c244$var$_excluded2 = [
    "id"
];
const $c726e745e154c244$export$a43bf4f64ed7f919 = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = $acw62.useState({});
    const rowModesModelRef = $acw62.useRef(rowModesModel);
    const prevRowModesModel = $acw62.useRef({});
    const prevRowValuesLookup = $acw62.useRef({});
    const focusTimeout = $acw62.useRef(undefined);
    const nextFocusedCell = $acw62.useRef(null);
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange: onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === (0, $jkRzp.GridEditModes).Row) callback(...args);
        };
    const throwIfNotEditable = $acw62.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $acw62.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI X: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const hasFieldsWithErrors = $acw62.useCallback((rowId)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        return Object.values(editingState[rowId]).some((fieldProps)=>fieldProps.error);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $jkRzp.GridRowModes).Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, $8nd05.default)({}, rowParams, {
            field: params.field,
            reason: (0, $jfE7J.GridRowEditStartReasons).cellDoubleClick
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = $acw62.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $jkRzp.GridRowModes).View) return;
        // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            if (nextFocusedCell.current?.id !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === (0, $jkRzp.GridRowModes).View) return;
                if (hasFieldsWithErrors(params.id)) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $8nd05.default)({}, rowParams, {
                    field: params.field,
                    reason: (0, $jfE7J.GridRowEditStopReasons).rowFocusOut
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        });
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $jkRzp.GridRowModes).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $jfE7J.GridRowEditStopReasons).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $jfE7J.GridRowEditStopReasons).enterKeyDown;
            else if (event.key === 'Tab') {
                const columnFields = (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === (0, $8z2XQ.GRID_ACTIONS_COLUMN_TYPE)) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = (0, $jfE7J.GridRowEditStopReasons).shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = (0, $jfE7J.GridRowEditStopReasons).tabKeyDown;
                // Always prevent going to the next element in the tab sequence because the focus is
                // handled manually to support edit components rendered inside Portals
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                if (reason !== (0, $jfE7J.GridRowEditStopReasons).escapeKeyDown && hasFieldsWithErrors(params.id)) return;
                const newParams = (0, $8nd05.default)({}, apiRef.current.getRowParams(params.id), {
                    reason: reason,
                    field: params.field
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'row'
            });
            if (!canStartEditing) return;
            if ((0, $dMF9H.isPrintableKey)(event)) reason = (0, $jfE7J.GridRowEditStartReasons).printableKeyDown;
            else if ((0, $dMF9H.isPasteShortcut)(event)) reason = (0, $jfE7J.GridRowEditStartReasons).printableKeyDown;
            else if (event.key === 'Enter') reason = (0, $jfE7J.GridRowEditStartReasons).enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = (0, $jfE7J.GridRowEditStartReasons).deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $8nd05.default)({}, rowParams, {
                    field: params.field,
                    reason: reason
                });
                apiRef.current.publishEvent('rowEditStart', newParams, event);
            }
        }
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    const handleRowEditStart = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startRowEditModeParams = {
            id: id,
            fieldToFocus: field
        };
        if (reason === (0, $jfE7J.GridRowEditStartReasons).printableKeyDown || reason === (0, $jfE7J.GridRowEditStartReasons).deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = $acw62.useCallback((params)=>{
        const { id: id, reason: reason, field: field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === (0, $jfE7J.GridRowEditStopReasons).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $jfE7J.GridRowEditStopReasons).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $jfE7J.GridRowEditStopReasons).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopRowEditMode({
            id: id,
            ignoreModifications: ignoreModifications,
            field: field,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rowEditStart', props.onRowEditStart);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rowEditStop', props.onRowEditStop);
    const getRowMode = $acw62.useCallback((id)=>{
        const isEditing = (0, $5Rfo7.gridRowIsEditingSelector)(apiRef, {
            rowId: id,
            editMode: props.editMode
        });
        return isEditing ? (0, $jkRzp.GridRowModes).Edit : (0, $jkRzp.GridRowModes).View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, $13KXh.default)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent('rowModesModelChange', newModel);
    });
    const updateRowInRowModesModel = $acw62.useCallback((id, newProps)=>{
        const newModel = (0, $8nd05.default)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $8nd05.default)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = $acw62.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $8nd05.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, $8nd05.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = $acw62.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $8nd05.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $8nd05.default)({}, newEditingState[id], {
                [field]: (0, $8nd05.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $8nd05.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startRowEditMode = $acw62.useCallback((params)=>{
        const { id: id } = params, other = (0, $1En50.default)(params, $c726e745e154c244$var$_excluded);
        throwIfNotInMode(id, (0, $jkRzp.GridRowModes).View);
        updateRowInRowModesModel(id, (0, $8nd05.default)({
            mode: (0, $jkRzp.GridRowModes).Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, $13KXh.default)((params)=>{
        const { id: id, fieldToFocus: fieldToFocus, deleteValue: deleteValue, initialValue: initialValue } = params;
        const row = apiRef.current.getRow(id);
        const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
        const newProps = columns.reduce((acc, col)=>{
            const field = col.field;
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            const column = apiRef.current.getColumn(field);
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) {
                if (deleteValue) newValue = (0, $a4Ou4.getDefaultCellValue)(column);
                else if (initialValue) newValue = initialValue;
            }
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: column.editable && !!column.preProcessEditCellProps && deleteValue
            };
            return acc;
        }, {});
        prevRowValuesLookup.current[id] = row;
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
        columns.filter((column)=>{
            const isCellEditable = apiRef.current.getCellParams(id, column.field).isEditable;
            return isCellEditable && column.editable && !!column.preProcessEditCellProps && deleteValue;
        }).forEach((column)=>{
            const field = column.field;
            const value = apiRef.current.getCellValue(id, field);
            const newValue = deleteValue ? (0, $a4Ou4.getDefaultCellValue)(column) : initialValue ?? value;
            Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps[field],
                hasChanged: newValue !== value
            })).then((processedProps)=>{
                // Check if still in edit mode before updating
                if (apiRef.current.getRowMode(id) === (0, $jkRzp.GridRowModes).Edit) {
                    const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
                    updateOrDeleteFieldState(id, field, (0, $8nd05.default)({}, processedProps, {
                        value: editingState[id][field].value,
                        isProcessingProps: false
                    }));
                }
            });
        });
    });
    const stopRowEditMode = $acw62.useCallback((params)=>{
        const { id: id } = params, other = (0, $1En50.default)(params, $c726e745e154c244$var$_excluded2);
        throwIfNotInMode(id, (0, $jkRzp.GridRowModes).Edit);
        updateRowInRowModesModel(id, (0, $8nd05.default)({
            mode: (0, $jkRzp.GridRowModes).View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, $13KXh.default)((params)=>{
        const { id: id, ignoreModifications: ignoreModifications, field: focusedField, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== 'none' && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
            delete prevRowValuesLookup.current[id];
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const row = prevRowValuesLookup.current[id];
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = (0, $jkRzp.GridRowModes).Edit;
            return;
        }
        if (hasFieldsWithErrors(id)) {
            prevRowModesModel.current[id].mode = (0, $jkRzp.GridRowModes).Edit;
            // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: (0, $jkRzp.GridRowModes).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                // The row might have been deleted
                if (prevRowModesModel.current[id]) {
                    prevRowModesModel.current[id].mode = (0, $jkRzp.GridRowModes).Edit;
                    // Revert the mode in the rowModesModel prop back to "edit"
                    updateRowInRowModesModel(id, {
                        mode: (0, $jkRzp.GridRowModes).Edit
                    });
                }
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = $acw62.useCallback((params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        let newProps = (0, $8nd05.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, $8nd05.default)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, $1En50.default)(_editingState$id, [
                    field
                ].map((0, $4ZreY.default)));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: newProps,
                    hasChanged: hasChanged,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $jkRzp.GridRowModes).View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
                    processedProps = (0, $8nd05.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, $8nd05.default)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, $1En50.default)(_editingState$id2, [
                    thisField
                ].map((0, $4ZreY.default)));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $jkRzp.GridRowModes).View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, $8nd05.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === (0, $jkRzp.GridRowModes).Edit) {
                    editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = $acw62.useCallback((id)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = (0, $8nd05.default)({}, prevRowValuesLookup.current[id], row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            // Column might have been removed
            // see https://github.com/mui/mui-x/pull/16888
            if (column?.valueSetter) rowUpdate = column.valueSetter(fieldProps.value, rowUpdate, column, apiRef);
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode: getRowMode,
        startRowEditMode: startRowEditMode,
        stopRowEditMode: stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue: setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingPrivateApi, 'private');
    $acw62.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $eEJPp.default)(()=>{
        const rowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, $lR3Vo.deepClone)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        const ids = new Set([
            ...Object.keys(rowModesModel),
            ...Object.keys(copyOfPrevRowModesModel)
        ]);
        Array.from(ids).forEach((id)=>{
            const params = rowModesModel[id] ?? {
                mode: (0, $jkRzp.GridRowModes).View
            };
            const prevMode = copyOfPrevRowModesModel[id]?.mode || (0, $jkRzp.GridRowModes).View;
            const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
            if (params.mode === (0, $jkRzp.GridRowModes).Edit && prevMode === (0, $jkRzp.GridRowModes).View) updateStateToStartRowEditMode((0, $8nd05.default)({
                id: originalId
            }, params));
            else if (params.mode === (0, $jkRzp.GridRowModes).View && prevMode === (0, $jkRzp.GridRowModes).Edit) updateStateToStopRowEditMode((0, $8nd05.default)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};

});
parcelRegister("jfE7J", function(module, exports) {

$parcel$export(module.exports, "GridRowEditStartReasons", () => $e03e8aca644cf2db$export$535533732d8f5c0a);
$parcel$export(module.exports, "GridRowEditStopReasons", () => $e03e8aca644cf2db$export$723957c53726785f);
/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master detail](/x/react-data-grid/master-detail/)
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var $e03e8aca644cf2db$export$535533732d8f5c0a = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}($e03e8aca644cf2db$export$535533732d8f5c0a || {});
/**
 * Params passed to the `rowEditStart` event.
 */ var $e03e8aca644cf2db$export$723957c53726785f = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}($e03e8aca644cf2db$export$723957c53726785f || {});

});



parcelRegister("2MkZt", function(module, exports) {

$parcel$export(module.exports, "rowsStateInitializer", () => $206058c259ba36a5$export$1a6bb5bb341eadaa);
$parcel$export(module.exports, "useGridRows", () => $206058c259ba36a5$export$dd1a4469bbd9394e);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $iYIN2 = parcelRequire("iYIN2");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $goCyd = parcelRequire("goCyd");

var $180lm = parcelRequire("180lm");

var $lHOu3 = parcelRequire("lHOu3");

var $eFF1m = parcelRequire("eFF1m");

var $aJApm = parcelRequire("aJApm");

var $iU3u2 = parcelRequire("iU3u2");

var $k278Q = parcelRequire("k278Q");

var $7sDf4 = parcelRequire("7sDf4");

var $1xynw = parcelRequire("1xynw");
const $206058c259ba36a5$export$1a6bb5bb341eadaa = (state, props, apiRef)=>{
    const isDataSourceAvailable = !!props.unstable_dataSource;
    apiRef.current.caches.rows = (0, $7sDf4.createRowsInternalCache)({
        rows: isDataSourceAvailable ? [] : props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, $8nd05.default)({}, state, {
        rows: (0, $7sDf4.getRowsStateFromCache)({
            apiRef: apiRef,
            rowCountProp: props.rowCount,
            loadingProp: isDataSourceAvailable ? true : props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
const $206058c259ba36a5$export$dd1a4469bbd9394e = (apiRef, props)=>{
    var error;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridRows');
    const lastUpdateMs = $acw62.useRef(Date.now());
    const lastRowCount = $acw62.useRef(props.rowCount);
    const timeout = (0, $lHOu3.default)();
    const getRow = $acw62.useCallback((id)=>{
        const model = (0, $goCyd.gridRowsLookupSelector)(apiRef)[id];
        if (model) return model;
        const node = apiRef.current.getRowNode(id);
        if (node && (0, $7sDf4.isAutogeneratedRowNode)(node)) return {
            [(0, $7sDf4.GRID_ID_AUTOGENERATED)]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowId = $acw62.useCallback((row)=>(0, $180lm.gridRowIdSelector)(apiRef.current.state, row), [
        apiRef
    ]);
    const throttledRowsChange = $acw62.useCallback(({ cache: cache, throttle: throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    rows: (0, $7sDf4.getRowsStateFromCache)({
                        apiRef: apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: (0, $goCyd.gridRowTreeSelector)(apiRef),
                        previousTreeDepths: (0, $goCyd.gridRowTreeDepthsSelector)(apiRef),
                        previousGroupsToFetch: (0, $goCyd.gridRowGroupsToFetchSelector)(apiRef)
                    })
                }));
            apiRef.current.publishEvent('rowsSet');
            apiRef.current.forceUpdate();
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.start(throttleRemainingTimeMs, run);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    /**
   * API METHODS
   */ const setRows = $acw62.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        const cache = (0, $7sDf4.createRowsInternalCache)({
            rows: rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = $acw62.useCallback((updates)=>{
        if (props.signature === (0, $eFF1m.GridSignature).DataGrid && updates.length > 1) throw new Error([
            'MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        const nonPinnedRowsUpdates = (0, $7sDf4.computeRowsUpdates)(apiRef, updates, props.getRowId);
        const cache = (0, $7sDf4.updateCacheWithNewRows)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        props.signature,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const updateServerRows = $acw62.useCallback((updates, groupKeys)=>{
        const nonPinnedRowsUpdates = (0, $7sDf4.computeRowsUpdates)(apiRef, updates, props.getRowId);
        const cache = (0, $7sDf4.updateCacheWithNewRows)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows,
            groupKeys: groupKeys ?? []
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const setLoading = $acw62.useCallback((loading)=>{
        if (loading === props.loading) return;
        logger.debug(`Setting loading to ${loading}`);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, {
                    loading: loading
                })
            }));
        apiRef.current.caches.rows.loadingPropBeforePartialUpdates = loading;
    }, [
        props.loading,
        apiRef,
        logger
    ]);
    const getRowModels = $acw62.useCallback(()=>{
        const dataRows = (0, $goCyd.gridDataRowIdsSelector)(apiRef);
        const idRowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        return new Map(dataRows.map((id)=>[
                id,
                idRowsLookup[id] ?? {}
            ]));
    }, [
        apiRef
    ]);
    const getRowsCount = $acw62.useCallback(()=>(0, $goCyd.gridRowCountSelector)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = $acw62.useCallback(()=>(0, $goCyd.gridDataRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = $acw62.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        const { rowToIndexMap: rowToIndexMap } = (0, $aJApm.getVisibleRows)(apiRef);
        return rowToIndexMap.get(row);
    }, [
        apiRef
    ]);
    const setRowChildrenExpansion = $acw62.useCallback((id, isExpanded)=>{
        const currentNode = apiRef.current.getRowNode(id);
        if (!currentNode) throw new Error(`MUI X: No row with id #${id} found.`);
        if (currentNode.type !== 'group') throw new Error('MUI X: Only group nodes can be expanded or collapsed.');
        const newNode = (0, $8nd05.default)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, {
                    tree: (0, $8nd05.default)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent('rowExpansionChange', newNode);
    }, [
        apiRef
    ]);
    const getRowNode = $acw62.useCallback((id)=>(0, $goCyd.gridRowTreeSelector)(apiRef)[id] ?? null, [
        apiRef
    ]);
    const getRowGroupChildren = $acw62.useCallback(({ skipAutoGeneratedRows: skipAutoGeneratedRows = true, groupId: groupId, applySorting: applySorting, applyFiltering: applyFiltering })=>{
        const tree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, $iU3u2.gridSortedRowIdsSelector)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && tree[sortedRowIds[index]].depth > groupNode.depth; index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !(0, $7sDf4.isAutogeneratedRowNode)(tree[id])) children.push(id);
            }
        } else children = (0, $7sDf4.getTreeNodeDescendants)(tree, groupId, skipAutoGeneratedRows);
        if (applyFiltering) {
            const filteredRowsLookup = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
            children = children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const setRowIndex = $acw62.useCallback((rowId, targetIndex)=>{
        const node = apiRef.current.getRowNode(rowId);
        if (!node) throw new Error(`MUI X: No row with id #${rowId} found.`);
        if (node.parent !== (0, $7sDf4.GRID_ROOT_GROUP_ID)) throw new Error(`MUI X: The row reordering do not support reordering of grouped rows yet.`);
        if (node.type !== 'leaf') throw new Error(`MUI X: The row reordering do not support reordering of footer or grouping rows.`);
        apiRef.current.setState((state)=>{
            const group = (0, $goCyd.gridRowTreeSelector)(state, apiRef.current.instanceId)[0, $7sDf4.GRID_ROOT_GROUP_ID];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (oldIndex === -1 || oldIndex === targetIndex) return state;
            logger.debug(`Moving row ${rowId} to index ${targetIndex}`);
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return (0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, {
                    tree: (0, $8nd05.default)({}, state.rows.tree, {
                        [(0, $7sDf4.GRID_ROOT_GROUP_ID)]: (0, $8nd05.default)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        logger
    ]);
    const replaceRows = $acw62.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === (0, $eFF1m.GridSignature).DataGrid && newRows.length > 1) throw new Error([
            'MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (newRows.length === 0) return;
        const treeDepth = (0, $goCyd.gridRowMaximumTreeDepthSelector)(apiRef);
        if (treeDepth > 1) throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
        const tree = (0, $8nd05.default)({}, (0, $goCyd.gridRowTreeSelector)(apiRef));
        const dataRowIdToModelLookup = (0, $8nd05.default)({}, (0, $goCyd.gridRowsLookupSelector)(apiRef));
        const dataRowIdToIdLookup = (0, $8nd05.default)({}, (0, $goCyd.gridRowsDataRowIdToIdLookupSelector)(apiRef));
        const rootGroup = tree[0, $7sDf4.GRID_ROOT_GROUP_ID];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        const seenIds = new Set();
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = (0, $7sDf4.getRowIdFromRowModel)(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
            const [removedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            if (!seenIds.has(removedRowId)) {
                delete dataRowIdToModelLookup[removedRowId];
                delete dataRowIdToIdLookup[removedRowId];
                delete tree[removedRowId];
            }
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: (0, $7sDf4.GRID_ROOT_GROUP_ID),
                type: 'leaf',
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            dataRowIdToIdLookup[rowId] = rowId;
            tree[rowId] = rowTreeNodeConfig;
            seenIds.add(rowId);
        }
        tree[0, $7sDf4.GRID_ROOT_GROUP_ID] = (0, $8nd05.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        // Removes potential remaining skeleton rows from the dataRowIds.
        const dataRowIds = rootGroupChildren.filter((childId)=>tree[childId]?.type === 'leaf');
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.caches.rows.dataRowIdToIdLookup = dataRowIdToIdLookup;
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, {
                    dataRowIdToModelLookup: dataRowIdToModelLookup,
                    dataRowIdToIdLookup: dataRowIdToIdLookup,
                    dataRowIds: dataRowIds,
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.signature,
        props.getRowId
    ]);
    const rowApi = {
        getRow: getRow,
        setLoading: setLoading,
        getRowId: getRowId,
        getRowModels: getRowModels,
        getRowsCount: getRowsCount,
        getAllRowIds: getAllRowIds,
        setRows: setRows,
        updateRows: updateRows,
        getRowNode: getRowNode,
        getRowIndexRelativeToVisibleRows: getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex: setRowIndex,
        setRowChildrenExpansion: setRowChildrenExpansion,
        getRowGroupChildren: getRowGroupChildren
    };
    const rowProPrivateApi = {
        updateServerRows: updateServerRows
    };
    /**
   * EVENTS
   */ const groupRows = $acw62.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = (0, $8nd05.default)({}, apiRef.current.caches.rows, {
            updates: {
                type: 'full',
                rows: (0, $goCyd.gridDataRowIdsSelector)(apiRef)
            }
        });
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, $7sDf4.createRowsInternalCache)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const previousDataSource = (0, $iYIN2.default)(()=>props.unstable_dataSource);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (props.unstable_dataSource && props.unstable_dataSource !== previousDataSource.current) {
            previousDataSource.current = props.unstable_dataSource;
            return;
        }
        if (methodName === 'rowTreeCreation') groupRows();
    }, [
        groupRows,
        previousDataSource,
        props.unstable_dataSource
    ]);
    const handleStrategyActivityChange = $acw62.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.getActiveStrategy('rowTree') !== (0, $goCyd.gridRowGroupingNameSelector)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
                tree: (0, $goCyd.gridRowTreeSelector)(state, apiRef.current.instanceId),
                treeDepths: (0, $goCyd.gridRowTreeDepthsSelector)(state, apiRef.current.instanceId),
                dataRowIds: (0, $goCyd.gridDataRowIdsSelector)(state, apiRef.current.instanceId),
                dataRowIdToModelLookup: (0, $goCyd.gridRowsLookupSelector)(state, apiRef.current.instanceId),
                dataRowIdToIdLookup: (0, $goCyd.gridRowsDataRowIdToIdLookupSelector)(state, apiRef.current.instanceId)
            });
            return (0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, response, {
                    totalTopLevelRowCount: (0, $7sDf4.getTopLevelRowCount)({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.rowCount
    ]);
    (0, $1xynw.useGridRegisterPipeApplier)(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
    (0, $ivFej.useGridApiMethod)(apiRef, rowApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, rowProApi, props.signature === (0, $eFF1m.GridSignature).DataGrid ? 'private' : 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, rowProPrivateApi, 'private');
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        let isRowCountPropUpdated = false;
        if (props.rowCount !== lastRowCount.current) {
            isRowCountPropUpdated = true;
            lastRowCount.current = props.rowCount;
        }
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                        rows: (0, $8nd05.default)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
                apiRef.current.forceUpdate();
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                        rows: (0, $8nd05.default)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
                apiRef.current.forceUpdate();
            }
            if (!isRowCountPropUpdated) return;
        }
        logger.debug(`Updating all rows, new length ${props.rows?.length}`);
        throttledRowsChange({
            cache: (0, $7sDf4.createRowsInternalCache)({
                rows: props.rows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};

});

parcelRegister("5lqAx", function(module, exports) {

$parcel$export(module.exports, "useGridRowsPreProcessors", () => $3e4389cda192db48$export$cc1daa683bbe5702);

var $8nd05 = parcelRequire("8nd05");

var $42J2j = parcelRequire("42J2j");
var $kmoo4 = parcelRequire("kmoo4");

var $7sDf4 = parcelRequire("7sDf4");
const $3e4389cda192db48$var$createFlatRowTree = (rows)=>{
    const tree = {
        [(0, $7sDf4.GRID_ROOT_GROUP_ID)]: (0, $8nd05.default)({}, (0, $7sDf4.buildRootGroup)(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: (0, $7sDf4.GRID_ROOT_GROUP_ID),
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: (0, $42J2j.GRID_DEFAULT_STRATEGY),
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const $3e4389cda192db48$var$updateFlatRowTree = ({ previousTree: previousTree, actions: actions })=>{
    const tree = (0, $8nd05.default)({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: (0, $7sDf4.GRID_ROOT_GROUP_ID),
            type: 'leaf',
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    const rootGroup = tree[0, $7sDf4.GRID_ROOT_GROUP_ID];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[0, $7sDf4.GRID_ROOT_GROUP_ID] = (0, $8nd05.default)({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: (0, $42J2j.GRID_DEFAULT_STRATEGY),
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const $3e4389cda192db48$var$flatRowTreeCreationMethod = (params)=>{
    if (params.updates.type === 'full') return $3e4389cda192db48$var$createFlatRowTree(params.updates.rows);
    return $3e4389cda192db48$var$updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const $3e4389cda192db48$export$cc1daa683bbe5702 = (apiRef)=>{
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, (0, $42J2j.GRID_DEFAULT_STRATEGY), 'rowTreeCreation', $3e4389cda192db48$var$flatRowTreeCreationMethod);
};

});

parcelRegister("6p8lp", function(module, exports) {

$parcel$export(module.exports, "useGridParamsApi", () => $4a9b8ce6e6853f0a$export$d5da41ef394db9ef);

var $acw62 = parcelRequire("acw62");

var $KtEo5 = parcelRequire("KtEo5");

var $ivFej = parcelRequire("ivFej");

var $drCmI = parcelRequire("drCmI");

var $8BltG = parcelRequire("8BltG");
class $4a9b8ce6e6853f0a$export$f6bd549412d13610 extends Error {
}
function $4a9b8ce6e6853f0a$export$d5da41ef394db9ef(apiRef, props) {
    const getColumnHeaderParams = $acw62.useCallback((field)=>({
            field: field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = $acw62.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new $4a9b8ce6e6853f0a$export$f6bd549412d13610(`No row with id #${id} found`);
        const params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParamsForRow = $acw62.useCallback((id, field, row, { cellMode: cellMode, colDef: colDef, hasFocus: hasFocus, rowNode: rowNode, tabIndex: tabIndex })=>{
        const rawValue = row[field];
        const value = colDef?.valueGetter ? colDef.valueGetter(rawValue, row, colDef, apiRef) : rawValue;
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: cellMode,
            hasFocus: hasFocus,
            tabIndex: tabIndex,
            value: value,
            formattedValue: value,
            isEditable: false,
            api: apiRef.current
        };
        if (colDef && colDef.valueFormatter) params.formattedValue = colDef.valueFormatter(value, row, colDef, apiRef);
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = $acw62.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new $4a9b8ce6e6853f0a$export$f6bd549412d13610(`No row with id #${id} found`);
        const cellFocus = (0, $drCmI.gridFocusCellSelector)(apiRef);
        const cellTabIndex = (0, $drCmI.gridTabIndexCellSelector)(apiRef);
        const cellMode = apiRef.current.getCellMode(id, field);
        return apiRef.current.getCellParamsForRow(id, field, row, {
            colDef: props.unstable_listView && props.unstable_listColumn?.field === field ? (0, $8BltG.gridListColumnSelector)(apiRef.current.state) : apiRef.current.getColumn(field),
            rowNode: rowNode,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            cellMode: cellMode
        });
    }, [
        apiRef,
        props.unstable_listView,
        props.unstable_listColumn?.field
    ]);
    const getCellValue = $acw62.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        if (!row) throw new $4a9b8ce6e6853f0a$export$f6bd549412d13610(`No row with id #${id} found`);
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(row[colDef.field], row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowValue = $acw62.useCallback((row, colDef)=>{
        const field = colDef.field;
        if (!colDef || !colDef.valueGetter) return row[field];
        const value = row[colDef.field];
        return colDef.valueGetter(value, row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowFormattedValue = $acw62.useCallback((row, colDef)=>{
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        return colDef.valueFormatter(value, row, colDef, apiRef);
    }, [
        apiRef,
        getRowValue
    ]);
    const getColumnHeaderElement = $acw62.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridColumnHeaderElement)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = $acw62.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridRowElement)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = $acw62.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridCellElement)(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    const paramsApi = {
        getCellValue: getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    const paramsPrivateApi = {
        getCellParamsForRow: getCellParamsForRow
    };
    (0, $ivFej.useGridApiMethod)(apiRef, paramsApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, paramsPrivateApi, 'private');
}

});

parcelRegister("cURqP", function(module, exports) {

$parcel$export(module.exports, "rowSelectionStateInitializer", () => $9674296b6d32bca5$export$73be1d69367eeb5b);
$parcel$export(module.exports, "useGridRowSelection", () => $9674296b6d32bca5$export$3e2b6b991d9d83f0);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $4o7uD = parcelRequire("4o7uD");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $5sOMZ = parcelRequire("5sOMZ");

var $goCyd = parcelRequire("goCyd");

var $av74L = parcelRequire("av74L");

var $gPWuj = parcelRequire("gPWuj");

var $drCmI = parcelRequire("drCmI");

var $k278Q = parcelRequire("k278Q");

var $8z2XQ = parcelRequire("8z2XQ");
var $5bG6h = parcelRequire("5bG6h");

var $jkRzp = parcelRequire("jkRzp");

var $dMF9H = parcelRequire("dMF9H");

var $aJApm = parcelRequire("aJApm");

var $jZka4 = parcelRequire("jZka4");

var $5H1vo = parcelRequire("5H1vo");

var $KtEo5 = parcelRequire("KtEo5");

var $iN63z = parcelRequire("iN63z");
const $9674296b6d32bca5$var$getSelectionModelPropValue = (selectionModelProp, prevSelectionModel)=>{
    if (selectionModelProp == null) return selectionModelProp;
    if (Array.isArray(selectionModelProp)) return selectionModelProp;
    if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) return prevSelectionModel;
    return [
        selectionModelProp
    ];
};
const $9674296b6d32bca5$export$73be1d69367eeb5b = (state, props)=>(0, $8nd05.default)({}, state, {
        rowSelection: props.rowSelection ? $9674296b6d32bca5$var$getSelectionModelPropValue(props.rowSelectionModel) ?? [] : []
    });
const $9674296b6d32bca5$export$3e2b6b991d9d83f0 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridSelection');
    const runIfRowSelectionIsEnabled = $acw62.useCallback((callback)=>(...args)=>{
            if (props.rowSelection) callback(...args);
        }, [
        props.rowSelection
    ]);
    const applyAutoSelection = props.signature !== (0, $eFF1m.GridSignature).DataGrid && (props.rowSelectionPropagation?.parents || props.rowSelectionPropagation?.descendants);
    const propRowSelectionModel = $acw62.useMemo(()=>{
        return $9674296b6d32bca5$var$getSelectionModelPropValue(props.rowSelectionModel, (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state));
    }, [
        apiRef,
        props.rowSelectionModel
    ]);
    const lastRowToggled = $acw62.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: (0, $av74L.gridRowSelectionStateSelector),
        changeEvent: 'rowSelectionChange'
    });
    const { checkboxSelection: checkboxSelection, disableRowSelectionOnClick: disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = (0, $iN63z.isMultipleRowSelectionEnabled)(props);
    const tree = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowTreeSelector));
    const isNestedData = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowMaximumTreeDepthSelector)) > 1;
    const expandMouseRowRangeSelection = $acw62.useCallback((id)=>{
        let endId = id;
        const startId = lastRowToggled.current ?? id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    /*
   * API METHODS
   */ const setRowSelectionModel = $acw62.useCallback((model)=>{
        if (props.signature === (0, $eFF1m.GridSignature).DataGrid && !canHaveMultipleSelection && Array.isArray(model) && model.length > 1) throw new Error([
            'MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'
        ].join('\n'));
        const currentModel = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    rowSelection: props.rowSelection ? model : []
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        canHaveMultipleSelection
    ]);
    const isRowSelected = $acw62.useCallback((id)=>(0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state).includes(id), [
        apiRef
    ]);
    const isRowSelectable = $acw62.useCallback((id)=>{
        if (props.rowSelection === false) return false;
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = (0, $goCyd.gridRowTreeSelector)(apiRef)[id];
        if (rowNode?.type === 'footer' || rowNode?.type === 'pinnedRow') return false;
        return true;
    }, [
        apiRef,
        props.rowSelection,
        propIsRowSelectable
    ]);
    const getSelectedRows = $acw62.useCallback(()=>(0, $av74L.selectedGridRowsSelector)(apiRef), [
        apiRef
    ]);
    const selectRow = $acw62.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            const newSelection = [];
            const addRow = (rowId)=>{
                newSelection.push(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            }
            apiRef.current.setRowSelectionModel(newSelection);
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selection = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
            const newSelection = new Set(selection);
            newSelection.delete(id);
            const addRow = (rowId)=>{
                newSelection.add(rowId);
            };
            const removeRow = (rowId)=>{
                newSelection.delete(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            } else if (applyAutoSelection) (0, $iN63z.findRowsToDeselect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
            const isSelectionValid = newSelection.size < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(Array.from(newSelection));
        }
    }, [
        apiRef,
        logger,
        applyAutoSelection,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        canHaveMultipleSelection
    ]);
    const selectRows = $acw62.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        const selectableIds = ids.filter((id)=>apiRef.current.isRowSelectable(id));
        let newSelection;
        if (resetSelection) {
            if (isSelected) {
                newSelection = new Set(selectableIds);
                if (applyAutoSelection) {
                    const addRow = (rowId)=>{
                        newSelection.add(rowId);
                    };
                    selectableIds.forEach((id)=>{
                        (0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
                    });
                }
            } else newSelection = new Set();
            const currentLookup = (0, $av74L.selectedIdsLookupSelector)(apiRef);
            if (newSelection.size === Object.keys(currentLookup).length && Array.from(newSelection).every((id)=>currentLookup[id] === id)) return;
        } else {
            newSelection = new Set(Object.values((0, $av74L.selectedIdsLookupSelector)(apiRef)));
            const addRow = (rowId)=>{
                newSelection.add(rowId);
            };
            const removeRow = (rowId)=>{
                newSelection.delete(rowId);
            };
            selectableIds.forEach((id)=>{
                if (isSelected) {
                    newSelection.add(id);
                    if (applyAutoSelection) (0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
                } else {
                    removeRow(id);
                    if (applyAutoSelection) (0, $iN63z.findRowsToDeselect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
                }
            });
        }
        const isSelectionValid = newSelection.size < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(Array.from(newSelection));
    }, [
        logger,
        applyAutoSelection,
        canHaveMultipleSelection,
        apiRef,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents
    ]);
    const getPropagatedRowSelectionModel = $acw62.useCallback((inputSelectionModel)=>{
        if (!isNestedData || !applyAutoSelection || inputSelectionModel.length === 0) return inputSelectionModel;
        const propagatedSelectionModel = new Set(inputSelectionModel);
        const addRow = (rowId)=>{
            propagatedSelectionModel.add(rowId);
        };
        for (const id of inputSelectionModel)(0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow, propagatedSelectionModel);
        return Array.from(propagatedSelectionModel);
    }, [
        apiRef,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        isNestedData,
        applyAutoSelection
    ]);
    const selectRowRange = $acw62.useCallback(({ startId: startId, endId: endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange,
        getPropagatedRowSelectionModel: getPropagatedRowSelectionModel
    };
    (0, $ivFej.useGridApiMethod)(apiRef, selectionPublicApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, selectionPrivateApi, props.signature === (0, $eFF1m.GridSignature).DataGrid ? 'private' : 'public');
    /*
   * EVENTS
   */ const isFirstRender = $acw62.useRef(true);
    const removeOutdatedSelection = $acw62.useCallback((sortModelUpdated = false)=>{
        if (isFirstRender.current) return;
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
        const rowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        const filteredRowsLookup = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
        // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
        const selectionLookup = (0, $8nd05.default)({}, (0, $av74L.selectedIdsLookupSelector)(apiRef));
        const isNonExistent = (id)=>{
            if (props.filterMode === 'server') return !rowsLookup[id];
            return !rowsLookup[id] || filteredRowsLookup[id] === false;
        };
        let hasChanged = false;
        currentSelection.forEach((id)=>{
            if (isNonExistent(id)) {
                if (props.keepNonExistentRowsSelected) return;
                delete selectionLookup[id];
                hasChanged = true;
                return;
            }
            if (!props.rowSelectionPropagation?.parents) return;
            const node = tree[id];
            if (node.type === 'group') {
                const isAutoGenerated = node.isAutoGenerated;
                if (isAutoGenerated) {
                    delete selectionLookup[id];
                    hasChanged = true;
                    return;
                }
                // Keep previously selected tree data parents selected if all their children are filtered out
                if (!node.children.every((childId)=>filteredRowsLookup[childId] === false)) {
                    delete selectionLookup[id];
                    hasChanged = true;
                }
            }
        });
        // For nested data, on row tree updation (filtering, adding rows, etc.) when the selection is
        // not empty, we need to re-run scanning of the tree to propagate the selection changes
        // Example: A parent whose de-selected children are filtered out should now be selected
        const shouldReapplyPropagation = isNestedData && props.rowSelectionPropagation?.parents && Object.keys(selectionLookup).length > 0;
        if (hasChanged || shouldReapplyPropagation && !sortModelUpdated) {
            const newSelection = Object.values(selectionLookup);
            if (shouldReapplyPropagation) apiRef.current.selectRows(newSelection, true, true);
            else apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isNestedData,
        props.rowSelectionPropagation?.parents,
        props.keepNonExistentRowsSelected,
        props.filterMode,
        tree
    ]);
    const handleSingleRowSelection = $acw62.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, $dMF9H.isKeyboardEvent)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        if (resetSelection) apiRef.current.selectRow(id, !isMultipleSelectionDisabled ? !isSelected : true, true);
        else apiRef.current.selectRow(id, !isSelected, false);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = $acw62.useCallback((params, event)=>{
        if (disableRowSelectionOnClick) return;
        const field = event.target.closest(`.${(0, $5H1vo.gridClasses).cell}`)?.getAttribute('data-field');
        if (field === (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field) // click on checkbox should not trigger row selection
        return;
        if (field === (0, $jZka4.GRID_DETAIL_PANEL_TOGGLE_FIELD)) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if (column?.type === (0, $8z2XQ.GRID_ACTIONS_COLUMN_TYPE)) return;
        }
        const rowNode = (0, $goCyd.gridRowTreeSelector)(apiRef)[params.id];
        if (rowNode.type === 'pinnedRow') return;
        if (event.shiftKey && canHaveMultipleSelection) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = $acw62.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) window.getSelection()?.removeAllRanges();
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = $acw62.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value, !canHaveMultipleSelection);
    }, [
        apiRef,
        expandMouseRowRangeSelection,
        canHaveMultipleSelection
    ]);
    const handleHeaderSelectionCheckboxChange = $acw62.useCallback((params)=>{
        const rowsToBeSelected = props.pagination && props.checkboxSelectionVisibleOnly && props.paginationMode === 'client' ? (0, $gPWuj.gridPaginatedVisibleSortedGridRowIdsSelector)(apiRef) : (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
        apiRef.current.selectRows(rowsToBeSelected, params.value);
    }, [
        apiRef,
        props.checkboxSelectionVisibleOnly,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $jkRzp.GridCellModes).Edit) return;
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
        if ((0, $dMF9H.isNavigationKey)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const visibleRows = (0, $aJApm.getVisibleRows)(apiRef);
                const rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map((row)=>row.id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === ' ' && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (String.fromCharCode(event.keyCode) === 'A' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            selectRows(apiRef.current.getAllRowIds(), true);
        }
    }, [
        apiRef,
        handleSingleRowSelection,
        selectRows,
        canHaveMultipleSelection
    ]);
    const syncControlledState = (0, $4o7uD.default)(()=>{
        if (!props.rowSelection) {
            apiRef.current.setRowSelectionModel([]);
            return;
        }
        if (propRowSelectionModel === undefined) return;
        if (!applyAutoSelection || !isNestedData || propRowSelectionModel.length === 0) {
            apiRef.current.setRowSelectionModel(propRowSelectionModel);
            return;
        }
        const newSelectionModel = apiRef.current.getPropagatedRowSelectionModel(propRowSelectionModel);
        if (newSelectionModel.length !== propRowSelectionModel.length || !newSelectionModel.every((id)=>propRowSelectionModel.includes(id))) {
            apiRef.current.setRowSelectionModel(newSelectionModel);
            return;
        }
        apiRef.current.setRowSelectionModel(propRowSelectionModel);
    });
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'sortedRowsSet', runIfRowSelectionIsEnabled(()=>removeOutdatedSelection(true)));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'filteredRowsSet', runIfRowSelectionIsEnabled(()=>removeOutdatedSelection()));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));
    /*
   * EFFECTS
   */ $acw62.useEffect(()=>{
        syncControlledState();
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection,
        syncControlledState
    ]);
    const isStateControlled = propRowSelectionModel != null;
    $acw62.useEffect(()=>{
        if (isStateControlled || !props.rowSelection) return;
        // props.isRowSelectable changed
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
        if (isRowSelectable) {
            const newSelection = currentSelection.filter((id)=>isRowSelectable(id));
            if (newSelection.length < currentSelection.length) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    $acw62.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
        if (!canHaveMultipleSelection && currentSelection.length > 1) // See https://github.com/mui/mui-x/issues/8455
        apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
    $acw62.useEffect(()=>{
        runIfRowSelectionIsEnabled(removeOutdatedSelection);
    }, [
        removeOutdatedSelection,
        runIfRowSelectionIsEnabled
    ]);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
    }, []);
};

});

parcelRegister("5WmMt", function(module, exports) {

$parcel$export(module.exports, "useGridRowSelectionPreProcessors", () => $45340a55c38c89d7$export$fa1d7b0897c018ea);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8Indx = parcelRequire("8Indx");

var $2kdmP = parcelRequire("2kdmP");

var $5H1vo = parcelRequire("5H1vo");

var $5bG6h = parcelRequire("5bG6h");
const $45340a55c38c89d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $acw62.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                'cellCheckbox'
            ],
            columnHeaderCheckbox: [
                'columnHeaderCheckbox'
            ]
        };
        return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
    }, [
        classes
    ]);
};
const $45340a55c38c89d7$export$fa1d7b0897c018ea = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $45340a55c38c89d7$var$useUtilityClasses(ownerState);
    const updateSelectionColumn = $acw62.useCallback((columnsState)=>{
        const selectionColumn = (0, $8nd05.default)({}, (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF), {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const hasSelectionColumn = columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD] != null;
        if (shouldHaveSelectionColumn && !hasSelectionColumn) {
            columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD] = selectionColumn;
            columnsState.orderedFields = [
                (0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD),
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && hasSelectionColumn) {
            delete columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD));
        } else if (shouldHaveSelectionColumn && hasSelectionColumn) {
            columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD] = (0, $8nd05.default)({}, selectionColumn, columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD]);
            // If the column is not in the columns array (not a custom selection column), move it to the beginning of the column order
            if (!props.columns.some((col)=>col.field === (0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD))) columnsState.orderedFields = [
                (0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD),
                ...columnsState.orderedFields.filter((field)=>field !== (0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD))
            ];
        }
        return columnsState;
    }, [
        apiRef,
        classes,
        props.columns,
        props.checkboxSelection
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'hydrateColumns', updateSelectionColumn);
};

});

parcelRegister("jOu9i", function(module, exports) {

$parcel$export(module.exports, "sortingStateInitializer", () => $e6ca12cabeac117a$export$996e35c2eef351ae);
$parcel$export(module.exports, "useGridSorting", () => $e6ca12cabeac117a$export$951287757eb5d93c);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $iU3u2 = parcelRequire("iU3u2");

var $7sDf4 = parcelRequire("7sDf4");
var $goCyd = parcelRequire("goCyd");

var $bc8LN = parcelRequire("bc8LN");

var $42J2j = parcelRequire("42J2j");
var $kmoo4 = parcelRequire("kmoo4");

var $h8fXG = parcelRequire("h8fXG");

var $2kdmP = parcelRequire("2kdmP");

var $7sDf4 = parcelRequire("7sDf4");
const $e6ca12cabeac117a$export$996e35c2eef351ae = (state, props)=>{
    const sortModel = props.sortModel ?? props.initialState?.sorting?.sortModel ?? [];
    return (0, $8nd05.default)({}, state, {
        sorting: {
            sortModel: (0, $h8fXG.sanitizeSortModel)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
const $e6ca12cabeac117a$export$951287757eb5d93c = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridSorting');
    apiRef.current.registerControlState({
        stateId: 'sortModel',
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: (0, $iU3u2.gridSortModelSelector),
        changeEvent: 'sortModelChange'
    });
    const upsertSortModel = $acw62.useCallback((field, sortItem)=>{
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (sortItem?.sort == null) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = $acw62.useCallback((col, directionOverride)=>{
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            const nextSort = directionOverride === undefined ? (0, $h8fXG.getNextGridSortDirection)(col.sortingOrder ?? props.sortingOrder, existing.sort) : directionOverride;
            return nextSort === undefined ? undefined : (0, $8nd05.default)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, $h8fXG.getNextGridSortDirection)(col.sortingOrder ?? props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = $acw62.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.sortable === false || props.disableColumnSorting) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            'columnMenuSortItem'
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder,
        props.disableColumnSorting
    ]);
    /**
   * API METHODS
   */ const applySorting = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === 'server') {
                logger.debug('Skipping sorting rows as sortingMode = server');
                return (0, $8nd05.default)({}, state, {
                    sorting: (0, $8nd05.default)({}, state.sorting, {
                        sortedRows: (0, $7sDf4.getTreeNodeDescendants)((0, $goCyd.gridRowTreeSelector)(apiRef), (0, $7sDf4.GRID_ROOT_GROUP_ID), false)
                    })
                });
            }
            const sortModel = (0, $iU3u2.gridSortModelSelector)(state, apiRef.current.instanceId);
            const sortRowList = (0, $h8fXG.buildAggregatedSortingApplier)(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
                sortRowList: sortRowList
            });
            return (0, $8nd05.default)({}, state, {
                sorting: (0, $8nd05.default)({}, state.sorting, {
                    sortedRows: sortedRows
                })
            });
        });
        apiRef.current.publishEvent('sortedRowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = $acw62.useCallback((model)=>{
        const currentModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, $h8fXG.mergeStateWithSortModel)(model, props.disableMultipleColumnsSorting));
            apiRef.current.forceUpdate();
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = $acw62.useCallback((field, direction, allowMultipleSorting)=>{
        const column = apiRef.current.getColumn(field);
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = sortItem?.sort == null ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = $acw62.useCallback(()=>(0, $iU3u2.gridSortModelSelector)(apiRef), [
        apiRef
    ]);
    const getSortedRows = $acw62.useCallback(()=>{
        const sortedRows = (0, $iU3u2.gridSortedRowEntriesSelector)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = $acw62.useCallback(()=>(0, $iU3u2.gridSortedRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = $acw62.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel: getSortModel,
        getSortedRows: getSortedRows,
        getSortedRowIds: getSortedRowIds,
        getRowIdFromRowIndex: getRowIdFromRowIndex,
        setSortModel: setSortModel,
        sortColumn: sortColumn,
        applySorting: applySorting
    };
    (0, $ivFej.useGridApiMethod)(apiRef, sortApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const sortModelToExport = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const shouldExportSortModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        props.initialState?.sorting?.sortModel != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        props.initialState?.sorting?.sortModel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const sortModel = context.stateToRestore.sorting?.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, $h8fXG.mergeStateWithSortModel)(sortModel, props.disableMultipleColumnsSorting));
        return (0, $8nd05.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = $acw62.useCallback((params)=>{
        const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        const rootGroupNode = rowTree[0, $7sDf4.GRID_ROOT_GROUP_ID];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (rootGroupNode.footerId != null) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, (0, $42J2j.GRID_DEFAULT_STRATEGY), 'sorting', flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = $acw62.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        const allowMultipleSorting = event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(field, undefined, allowMultipleSorting);
    }, [
        sortColumn,
        props.disableColumnSorting
    ]);
    const handleColumnHeaderKeyDown = $acw62.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        // Ctrl + Enter opens the column menu
        if (event.key === 'Enter' && !event.ctrlKey && !event.metaKey) sortColumn(field, undefined, event.shiftKey);
    }, [
        sortColumn,
        props.disableColumnSorting
    ]);
    const handleColumnsChange = $acw62.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const latestColumns = (0, $jQEEt.gridColumnLookupSelector)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (methodName === 'sorting') apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowsSet', apiRef.current.applySorting);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, $bc8LN.useFirstRender)(()=>{
        apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ (0, $eEJPp.default)(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};

});

parcelRegister("gaDPW", function(module, exports) {

$parcel$export(module.exports, "useGridScroll", () => $bc5c7b440a851fd1$export$d3441dc29db31b8c);

var $acw62 = parcelRequire("acw62");

var $9uEev = parcelRequire("9uEev");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $gPWuj = parcelRequire("gPWuj");

var $goCyd = parcelRequire("goCyd");

var $bdqIg = parcelRequire("bdqIg");

var $ivFej = parcelRequire("ivFej");

var $k278Q = parcelRequire("k278Q");

var $61HyH = parcelRequire("61HyH");

var $8BltG = parcelRequire("8BltG");
// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function $bc5c7b440a851fd1$var$scrollIntoView(dimensions) {
    const { containerSize: containerSize, scrollPosition: scrollPosition, elementSize: elementSize, elementOffset: elementOffset } = dimensions;
    const elementEnd = elementOffset + elementSize;
    // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (elementSize > containerSize) return elementOffset;
    if (elementEnd - containerSize > scrollPosition) return elementEnd - containerSize;
    if (elementOffset < scrollPosition) return elementOffset;
    return undefined;
}
const $bc5c7b440a851fd1$export$d3441dc29db31b8c = (apiRef, props)=>{
    const isRtl = (0, $9uEev.useRtl)();
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridScroll');
    const colRef = apiRef.current.columnHeadersContainerRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const visibleSortedRows = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridExpandedSortedRowEntriesSelector));
    const scrollToIndexes = $acw62.useCallback((params)=>{
        const dimensions = (0, $61HyH.gridDimensionsSelector)(apiRef.current.state);
        const totalRowCount = (0, $goCyd.gridRowCountSelector)(apiRef);
        const visibleColumns = props.unstable_listView ? [
            (0, $8BltG.gridListColumnSelector)(apiRef.current.state)
        ] : (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex !== undefined) {
            const columnPositions = (0, $jQEEt.gridColumnPositionsSelector)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== 'undefined') {
                const rowId = visibleSortedRows[params.rowIndex]?.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === 'undefined') cellWidth = visibleColumns[params.colIndex].computedWidth;
            // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
            scrollCoordinates.left = $bc5c7b440a851fd1$var$scrollIntoView({
                containerSize: dimensions.viewportOuterSize.width,
                scrollPosition: Math.abs(virtualScrollerRef.current.scrollLeft),
                elementSize: cellWidth,
                elementOffset: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex !== undefined) {
            const rowsMeta = (0, $bdqIg.gridRowsMetaSelector)(apiRef.current.state);
            const page = (0, $gPWuj.gridPageSelector)(apiRef);
            const pageSize = (0, $gPWuj.gridPageSizeSelector)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            scrollCoordinates.top = $bc5c7b440a851fd1$var$scrollIntoView({
                containerSize: dimensions.viewportInnerSize.height,
                scrollPosition: virtualScrollerRef.current.scrollTop,
                elementSize: targetOffsetHeight,
                elementOffset: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
        scrollCoordinates.left;
        apiRef.current.scroll(scrollCoordinates);
        return true;
        return false;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination,
        visibleSortedRows,
        props.unstable_listView
    ]);
    const scroll = $acw62.useCallback((params)=>{
        if (virtualScrollerRef.current && params.left !== undefined && colRef.current) {
            const direction = isRtl ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && params.top !== undefined) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        virtualScrollerRef,
        isRtl,
        colRef,
        logger
    ]);
    const getScrollPosition = $acw62.useCallback(()=>{
        if (!virtualScrollerRef?.current) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll: scroll,
        scrollToIndexes: scrollToIndexes,
        getScrollPosition: getScrollPosition
    };
    (0, $ivFej.useGridApiMethod)(apiRef, scrollApi, 'public');
};

});

parcelRegister("2oqux", function(module, exports) {

$parcel$export(module.exports, "useGridEvents", () => $1be25f585207520f$export$8456f443918812d4);

var $eFF1m = parcelRequire("eFF1m");
function $1be25f585207520f$export$8456f443918812d4(apiRef, props) {
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderContextMenu', props.onColumnHeaderContextMenu);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellClick', props.onCellClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellKeyDown', props.onCellKeyDown);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'menuOpen', props.onMenuOpen);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'menuClose', props.onMenuClose);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rowClick', props.onRowClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'stateChange', props.onStateChange);
}

});

parcelRegister("Anab1", function(module, exports) {

$parcel$export(module.exports, "dimensionsStateInitializer", () => $06d554a00cf6d24e$export$c29f872c616fae5b);
$parcel$export(module.exports, "useGridDimensions", () => $06d554a00cf6d24e$export$b8364994f9eec67d);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");
var $9KvVX = parcelRequire("9KvVX");
var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");

var $8twQD = parcelRequire("8twQD");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $cgQ4y = parcelRequire("cgQ4y");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $61HyH = parcelRequire("61HyH");

var $fD9f4 = parcelRequire("fD9f4");

var $9upDV = parcelRequire("9upDV");

var $5sOMZ = parcelRequire("5sOMZ");

var $aJApm = parcelRequire("aJApm");

var $bdqIg = parcelRequire("bdqIg");

var $7sDf4 = parcelRequire("7sDf4");

var $i0LyH = parcelRequire("i0LyH");

var $1kYRD = parcelRequire("1kYRD");

var $af8j6 = parcelRequire("af8j6");

var $hWI6v = parcelRequire("hWI6v");

var $lR3Vo = parcelRequire("lR3Vo");
const $06d554a00cf6d24e$var$EMPTY_SIZE = {
    width: 0,
    height: 0
};
const $06d554a00cf6d24e$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: $06d554a00cf6d24e$var$EMPTY_SIZE,
    viewportOuterSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    viewportInnerSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    contentSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    minimumSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    headerHeight: 0,
    groupHeaderHeight: 0,
    headerFilterHeight: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    headersTotalHeight: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0
};
const $06d554a00cf6d24e$export$c29f872c616fae5b = (state, props, apiRef)=>{
    const dimensions = $06d554a00cf6d24e$var$EMPTY_DIMENSIONS;
    const density = (0, $fD9f4.gridDensityFactorSelector)(apiRef);
    return (0, $8nd05.default)({}, state, {
        dimensions: (0, $8nd05.default)({}, dimensions, $06d554a00cf6d24e$var$getStaticDimensions(props, apiRef, density, (0, $jQEEt.gridVisiblePinnedColumnDefinitionsSelector)(apiRef)))
    });
};
const $06d554a00cf6d24e$var$columnsTotalWidthSelector = (0, $cgQ4y.createSelector)((0, $jQEEt.gridVisibleColumnDefinitionsSelector), (0, $jQEEt.gridColumnPositionsSelector), (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return (0, $af8j6.roundToDecimalPlaces)(positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth, 1);
});
function $06d554a00cf6d24e$export$b8364994f9eec67d(apiRef, props) {
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useResizeContainer');
    const errorShown = $acw62.useRef(false);
    const rootDimensionsRef = $acw62.useRef($06d554a00cf6d24e$var$EMPTY_SIZE);
    const pinnedColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisiblePinnedColumnDefinitionsSelector));
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityFactorSelector));
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, $06d554a00cf6d24e$var$columnsTotalWidthSelector);
    const isFirstSizing = $acw62.useRef(true);
    const { rowHeight: rowHeight, headerHeight: headerHeight, groupHeaderHeight: groupHeaderHeight, headerFilterHeight: headerFilterHeight, headersTotalHeight: headersTotalHeight, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth } = $06d554a00cf6d24e$var$getStaticDimensions(props, apiRef, densityFactor, pinnedColumns);
    const previousSize = $acw62.useRef(undefined);
    const getRootDimensions = $acw62.useCallback(()=>(0, $61HyH.gridDimensionsSelector)(apiRef.current.state), [
        apiRef
    ]);
    const setDimensions = $acw62.useCallback((dimensions)=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                dimensions: dimensions
            }));
        if (apiRef.current.rootElementRef.current) $06d554a00cf6d24e$var$setCSSVariables(apiRef.current.rootElementRef.current, (0, $61HyH.gridDimensionsSelector)(apiRef.current.state));
    }, [
        apiRef
    ]);
    const resize = $acw62.useCallback(()=>{
        const element = apiRef.current.mainElementRef.current;
        if (!element) return;
        const computedStyle = (0, $9KvVX.default)(element).getComputedStyle(element);
        const newSize = {
            width: parseFloat(computedStyle.width) || 0,
            height: parseFloat(computedStyle.height) || 0
        };
        if (!previousSize.current || !$06d554a00cf6d24e$var$areElementSizesEqual(previousSize.current, newSize)) {
            apiRef.current.publishEvent('resize', newSize);
            previousSize.current = newSize;
        }
    }, [
        apiRef
    ]);
    const getViewportPageSize = $acw62.useCallback(()=>{
        const dimensions = (0, $61HyH.gridDimensionsSelector)(apiRef.current.state);
        if (!dimensions.isReady) return 0;
        const currentPage = (0, $aJApm.getVisibleRows)(apiRef);
        // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (props.getRowHeight) {
            const renderContext = (0, $9upDV.gridRenderContextSelector)(apiRef);
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, currentPage.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, currentPage.rows.length);
    }, [
        apiRef,
        props.getRowHeight,
        rowHeight
    ]);
    const updateDimensions = $acw62.useCallback(()=>{
        if (isFirstSizing.current) return;
        // All the floating point dimensions should be rounded to .1 decimal places to avoid subpixel rendering issues
        // https://github.com/mui/mui-x/issues/9550#issuecomment-1619020477
        // https://github.com/mui/mui-x/issues/15721
        const scrollbarSize = $06d554a00cf6d24e$var$measureScrollbarSize(apiRef.current.mainElementRef.current, props.scrollbarSize);
        const rowsMeta = (0, $bdqIg.gridRowsMetaSelector)(apiRef.current.state);
        const topContainerHeight = headersTotalHeight + rowsMeta.pinnedTopRowsTotalHeight;
        const bottomContainerHeight = rowsMeta.pinnedBottomRowsTotalHeight;
        const nonPinnedColumnsTotalWidth = columnsTotalWidth - leftPinnedWidth - rightPinnedWidth;
        const contentSize = {
            width: nonPinnedColumnsTotalWidth,
            height: (0, $af8j6.roundToDecimalPlaces)(rowsMeta.currentPageTotalHeight, 1)
        };
        let viewportOuterSize;
        let viewportInnerSize;
        let hasScrollX = false;
        let hasScrollY = false;
        if (props.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootDimensionsRef.current.width);
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: topContainerHeight + bottomContainerHeight + contentSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - (hasScrollY ? scrollbarSize : 0)),
                height: Math.max(0, viewportOuterSize.height - (hasScrollX ? scrollbarSize : 0))
            };
        } else {
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: rootDimensionsRef.current.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - leftPinnedWidth - rightPinnedWidth),
                height: Math.max(0, viewportOuterSize.height - topContainerHeight - bottomContainerHeight)
            };
            const content = contentSize;
            const container = viewportInnerSize;
            const hasScrollXIfNoYScrollBar = content.width > container.width;
            const hasScrollYIfNoXScrollBar = content.height > container.height;
            if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
                hasScrollY = hasScrollYIfNoXScrollBar;
                hasScrollX = content.width + (hasScrollY ? scrollbarSize : 0) > container.width;
                // We recalculate the scroll y to consider the size of the x scrollbar.
                if (hasScrollX) hasScrollY = content.height + scrollbarSize > container.height;
            }
            if (hasScrollY) viewportInnerSize.width -= scrollbarSize;
            if (hasScrollX) viewportInnerSize.height -= scrollbarSize;
        }
        const rowWidth = Math.max(viewportOuterSize.width, columnsTotalWidth + (hasScrollY ? scrollbarSize : 0));
        const minimumSize = {
            width: columnsTotalWidth,
            height: topContainerHeight + contentSize.height + bottomContainerHeight
        };
        const newDimensions = {
            isReady: true,
            root: rootDimensionsRef.current,
            viewportOuterSize: viewportOuterSize,
            viewportInnerSize: viewportInnerSize,
            contentSize: contentSize,
            minimumSize: minimumSize,
            hasScrollX: hasScrollX,
            hasScrollY: hasScrollY,
            scrollbarSize: scrollbarSize,
            headerHeight: headerHeight,
            groupHeaderHeight: groupHeaderHeight,
            headerFilterHeight: headerFilterHeight,
            rowWidth: rowWidth,
            rowHeight: rowHeight,
            columnsTotalWidth: columnsTotalWidth,
            leftPinnedWidth: leftPinnedWidth,
            rightPinnedWidth: rightPinnedWidth,
            headersTotalHeight: headersTotalHeight,
            topContainerHeight: topContainerHeight,
            bottomContainerHeight: bottomContainerHeight
        };
        const prevDimensions = apiRef.current.state.dimensions;
        if ((0, $lR3Vo.isDeepEqual)(prevDimensions, newDimensions)) return;
        setDimensions(newDimensions);
        if (!$06d554a00cf6d24e$var$areElementSizesEqual(newDimensions.viewportInnerSize, prevDimensions.viewportInnerSize)) apiRef.current.publishEvent('viewportInnerSizeChange', newDimensions.viewportInnerSize);
        apiRef.current.updateRenderContext?.();
    }, [
        apiRef,
        setDimensions,
        props.scrollbarSize,
        props.autoHeight,
        rowHeight,
        headerHeight,
        groupHeaderHeight,
        headerFilterHeight,
        columnsTotalWidth,
        headersTotalHeight,
        leftPinnedWidth,
        rightPinnedWidth
    ]);
    const updateDimensionCallback = (0, $13KXh.default)(updateDimensions);
    const debouncedUpdateDimensions = $acw62.useMemo(()=>props.resizeThrottleMs > 0 ? (0, $8twQD.throttle)(()=>{
            updateDimensionCallback();
            apiRef.current.publishEvent('debouncedResize', rootDimensionsRef.current);
        }, props.resizeThrottleMs) : undefined, [
        apiRef,
        props.resizeThrottleMs,
        updateDimensionCallback
    ]);
    $acw62.useEffect(()=>debouncedUpdateDimensions?.clear, [
        debouncedUpdateDimensions
    ]);
    const apiPublic = {
        resize: resize,
        getRootDimensions: getRootDimensions
    };
    const apiPrivate = {
        updateDimensions: updateDimensions,
        getViewportPageSize: getViewportPageSize
    };
    (0, $eEJPp.default)(updateDimensions, [
        updateDimensions
    ]);
    (0, $ivFej.useGridApiMethod)(apiRef, apiPublic, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, apiPrivate, 'private');
    const handleRootMount = $acw62.useCallback((root)=>{
        $06d554a00cf6d24e$var$setCSSVariables(root, (0, $61HyH.gridDimensionsSelector)(apiRef.current.state));
    }, [
        apiRef
    ]);
    const handleResize = $acw62.useCallback((size)=>{
        rootDimensionsRef.current = size;
        if (size.height === 0 && !errorShown.current && !props.autoHeight && !(0, $hWI6v.isJSDOM)) {
            logger.error([
                'The parent DOM element of the Data Grid has an empty height.',
                'Please make sure that this element has an intrinsic height.',
                'The grid displays with a height of 0px.',
                '',
                'More details: https://mui.com/r/x-data-grid-no-dimensions.'
            ].join('\n'));
            errorShown.current = true;
        }
        if (size.width === 0 && !errorShown.current && !(0, $hWI6v.isJSDOM)) {
            logger.error([
                'The parent DOM element of the Data Grid has an empty width.',
                'Please make sure that this element has an intrinsic width.',
                'The grid displays with a width of 0px.',
                '',
                'More details: https://mui.com/r/x-data-grid-no-dimensions.'
            ].join('\n'));
            errorShown.current = true;
        }
        if (isFirstSizing.current || !debouncedUpdateDimensions) {
            // We want to initialize the grid dimensions as soon as possible to avoid flickering
            isFirstSizing.current = false;
            updateDimensions();
            return;
        }
        debouncedUpdateDimensions();
    }, [
        updateDimensions,
        props.autoHeight,
        debouncedUpdateDimensions,
        logger
    ]);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rootMount', handleRootMount);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'resize', handleResize);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'debouncedResize', props.onResize);
}
function $06d554a00cf6d24e$var$setCSSVariables(root, dimensions) {
    const set = (k, v)=>root.style.setProperty(k, v);
    set('--DataGrid-hasScrollX', `${Number(dimensions.hasScrollX)}`);
    set('--DataGrid-hasScrollY', `${Number(dimensions.hasScrollY)}`);
    set('--DataGrid-scrollbarSize', `${dimensions.scrollbarSize}px`);
    set('--DataGrid-rowWidth', `${dimensions.rowWidth}px`);
    set('--DataGrid-columnsTotalWidth', `${dimensions.columnsTotalWidth}px`);
    set('--DataGrid-leftPinnedWidth', `${dimensions.leftPinnedWidth}px`);
    set('--DataGrid-rightPinnedWidth', `${dimensions.rightPinnedWidth}px`);
    set('--DataGrid-headerHeight', `${dimensions.headerHeight}px`);
    set('--DataGrid-headersTotalHeight', `${dimensions.headersTotalHeight}px`);
    set('--DataGrid-topContainerHeight', `${dimensions.topContainerHeight}px`);
    set('--DataGrid-bottomContainerHeight', `${dimensions.bottomContainerHeight}px`);
    set('--height', `${dimensions.rowHeight}px`);
}
function $06d554a00cf6d24e$var$getStaticDimensions(props, apiRef, density, pinnedColumnns) {
    const validRowHeight = (0, $7sDf4.getValidRowHeight)(props.rowHeight, (0, $1kYRD.DATA_GRID_PROPS_DEFAULT_VALUES).rowHeight, (0, $7sDf4.rowHeightWarning));
    return {
        rowHeight: Math.floor(validRowHeight * density),
        headerHeight: Math.floor(props.columnHeaderHeight * density),
        groupHeaderHeight: Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * density),
        headerFilterHeight: Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * density),
        columnsTotalWidth: $06d554a00cf6d24e$var$columnsTotalWidthSelector(apiRef),
        headersTotalHeight: (0, $i0LyH.getTotalHeaderHeight)(apiRef, props),
        leftPinnedWidth: pinnedColumnns.left.reduce((w, col)=>w + col.computedWidth, 0),
        rightPinnedWidth: pinnedColumnns.right.reduce((w, col)=>w + col.computedWidth, 0)
    };
}
const $06d554a00cf6d24e$var$scrollbarSizeCache = new WeakMap();
function $06d554a00cf6d24e$var$measureScrollbarSize(element, scrollbarSize) {
    if (scrollbarSize !== undefined) return scrollbarSize;
    if (element === null) return 0;
    const cachedSize = $06d554a00cf6d24e$var$scrollbarSizeCache.get(element);
    if (cachedSize !== undefined) return cachedSize;
    const doc = (0, $6zeBo.default)(element);
    const scrollDiv = doc.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.className = 'scrollDiv';
    element.appendChild(scrollDiv);
    const size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    element.removeChild(scrollDiv);
    $06d554a00cf6d24e$var$scrollbarSizeCache.set(element, size);
    return size;
}
function $06d554a00cf6d24e$var$areElementSizesEqual(a, b) {
    return a.width === b.width && a.height === b.height;
}

});
parcelRegister("8twQD", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $62ba831024416c9b$export$de363e709c412c8a);
function $62ba831024416c9b$export$de363e709c412c8a(func, wait = 166) {
    let timeout;
    let lastArgs;
    const later = ()=>{
        timeout = undefined;
        func(...lastArgs);
    };
    function throttled(...args) {
        lastArgs = args;
        if (timeout === undefined) timeout = setTimeout(later, wait);
    }
    throttled.clear = ()=>{
        clearTimeout(timeout);
        timeout = undefined;
    };
    return throttled;
}

});

parcelRegister("1kYRD", function(module, exports) {

$parcel$export(module.exports, "DATA_GRID_PROPS_DEFAULT_VALUES", () => $0f96df060f8ddda5$export$2733e0e1a1d288e7);

var $jkRzp = parcelRequire("jkRzp");
const $0f96df060f8ddda5$export$2733e0e1a1d288e7 = {
    autoHeight: false,
    autoPageSize: false,
    autosizeOnMount: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    clipboardCopyCellDelimiter: '\t',
    columnBufferPx: 150,
    columnHeaderHeight: 56,
    disableAutosize: false,
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnReorder: false,
    disableColumnResize: false,
    disableColumnSelector: false,
    disableColumnSorting: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleColumnsSorting: false,
    disableMultipleRowSelection: false,
    disableRowSelectionOnClick: false,
    disableVirtualization: false,
    editMode: (0, $jkRzp.GridEditModes).Cell,
    filterDebounceMs: 150,
    filterMode: 'client',
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    ignoreValueFormatterDuringExport: false,
    // TODO v8: Update to 'select'
    indeterminateCheckboxAction: 'deselect',
    keepColumnPositionIfDraggedOutside: false,
    keepNonExistentRowsSelected: false,
    loading: false,
    logger: console,
    logLevel: 'error',
    pageSizeOptions: [
        25,
        50,
        100
    ],
    pagination: false,
    paginationMode: 'client',
    resetPageOnSortFilter: false,
    resizeThrottleMs: 60,
    rowBufferPx: 150,
    rowHeight: 52,
    rowPositionsDebounceMs: 166,
    rows: [],
    rowSelection: true,
    rowSpacingType: 'margin',
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    sortingMode: 'client',
    sortingOrder: [
        'asc',
        'desc',
        null
    ],
    throttleRowsMs: 0,
    unstable_rowSpanning: false,
    virtualizeColumnsWithAutoRowHeight: false
};

});


parcelRegister("jBRsK", function(module, exports) {

$parcel$export(module.exports, "rowsMetaStateInitializer", () => $e46af192720967f4$export$4224c70cd0329965);
$parcel$export(module.exports, "useGridRowsMeta", () => $e46af192720967f4$export$8a4468671da3a64f);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $iYIN2 = parcelRequire("iYIN2");

var $eEJPp = parcelRequire("eEJPp");

var $bKpTj = parcelRequire("bKpTj");

var $aJApm = parcelRequire("aJApm");

var $lR3Vo = parcelRequire("lR3Vo");

var $ivFej = parcelRequire("ivFej");

var $5sOMZ = parcelRequire("5sOMZ");

var $fD9f4 = parcelRequire("fD9f4");

var $gPWuj = parcelRequire("gPWuj");

var $1xynw = parcelRequire("1xynw");

var $goCyd = parcelRequire("goCyd");

var $61HyH = parcelRequire("61HyH");

var $7sDf4 = parcelRequire("7sDf4");

var $98F89 = parcelRequire("98F89");
const $e46af192720967f4$export$4224c70cd0329965 = (state, props, apiRef)=>{
    apiRef.current.caches.rowsMeta = {
        heights: new Map()
    };
    const baseRowHeight = (0, $61HyH.gridRowHeightSelector)(apiRef.current.state);
    const dataRowCount = (0, $goCyd.gridRowCountSelector)(apiRef);
    const pagination = (0, $gPWuj.gridPaginationSelector)(apiRef.current.state);
    const rowCount = Math.min(pagination.enabled ? pagination.paginationModel.pageSize : dataRowCount, dataRowCount);
    return (0, $8nd05.default)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: rowCount * baseRowHeight,
            positions: Array.from({
                length: rowCount
            }, (_, i)=>i * baseRowHeight),
            pinnedTopRowsTotalHeight: 0,
            pinnedBottomRowsTotalHeight: 0
        }
    });
};
const $e46af192720967f4$export$8a4468671da3a64f = (apiRef, props)=>{
    const { getRowHeight: getRowHeightProp, getRowSpacing: getRowSpacing, getEstimatedRowHeight: getEstimatedRowHeight } = props;
    const heightCache = apiRef.current.caches.rowsMeta.heights;
    const lastMeasuredRowIndex = $acw62.useRef(-1);
    const hasRowWithAutoHeight = $acw62.useRef(false);
    const isHeightMetaValid = $acw62.useRef(false);
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityFactorSelector));
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef, props);
    const pinnedRows = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridPinnedRowsSelector));
    const rowHeight = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridRowHeightSelector));
    const getRowHeightEntry = (rowId)=>{
        let entry = heightCache.get(rowId);
        if (entry === undefined) {
            entry = {
                content: rowHeight,
                spacingTop: 0,
                spacingBottom: 0,
                detail: 0,
                autoHeight: false,
                needsFirstMeasurement: true
            };
            heightCache.set(rowId, entry);
        }
        return entry;
    };
    const processHeightEntry = $acw62.useCallback((row)=>{
        // HACK: rowHeight trails behind the most up-to-date value just enough to
        // mess the initial rowsMeta hydration :/
        const baseRowHeight = (0, $61HyH.gridDimensionsSelector)(apiRef.current.state).rowHeight;
        (0, $lR3Vo.eslintUseValue)(rowHeight);
        const entry = apiRef.current.getRowHeightEntry(row.id);
        if (!getRowHeightProp) {
            entry.content = baseRowHeight;
            entry.needsFirstMeasurement = false;
        } else {
            const rowHeightFromUser = getRowHeightProp((0, $8nd05.default)({}, row, {
                densityFactor: densityFactor
            }));
            if (rowHeightFromUser === 'auto') {
                if (entry.needsFirstMeasurement) {
                    const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight((0, $8nd05.default)({}, row, {
                        densityFactor: densityFactor
                    })) : baseRowHeight;
                    // If the row was not measured yet use the estimated row height
                    entry.content = estimatedRowHeight ?? baseRowHeight;
                }
                hasRowWithAutoHeight.current = true;
                entry.autoHeight = true;
            } else {
                // Default back to base rowHeight if getRowHeight returns invalid value.
                entry.content = (0, $7sDf4.getValidRowHeight)(rowHeightFromUser, baseRowHeight, (0, $7sDf4.getRowHeightWarning));
                entry.needsFirstMeasurement = false;
                entry.autoHeight = false;
            }
        }
        if (getRowSpacing) {
            const indexRelativeToCurrentPage = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
            const spacing = getRowSpacing((0, $8nd05.default)({}, row, {
                isFirstVisible: indexRelativeToCurrentPage === 0,
                isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                indexRelativeToCurrentPage: indexRelativeToCurrentPage
            }));
            entry.spacingTop = spacing.top ?? 0;
            entry.spacingBottom = spacing.bottom ?? 0;
        } else {
            entry.spacingTop = 0;
            entry.spacingBottom = 0;
        }
        apiRef.current.unstable_applyPipeProcessors('rowHeight', entry, row);
        return entry;
    }, [
        apiRef,
        currentPage.rows,
        getRowHeightProp,
        getEstimatedRowHeight,
        rowHeight,
        getRowSpacing,
        densityFactor
    ]);
    const hydrateRowsMeta = $acw62.useCallback(()=>{
        hasRowWithAutoHeight.current = false;
        const pinnedTopRowsTotalHeight = pinnedRows.top.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0);
        const pinnedBottomRowsTotalHeight = pinnedRows.bottom.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0);
        const positions = [];
        const currentPageTotalHeight = currentPage.rows.reduce((acc, row)=>{
            positions.push(acc);
            const entry = processHeightEntry(row);
            const total = entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
            return acc + total;
        }, 0);
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        const didHeightsChange = pinnedTopRowsTotalHeight !== apiRef.current.state.rowsMeta.pinnedTopRowsTotalHeight || pinnedBottomRowsTotalHeight !== apiRef.current.state.rowsMeta.pinnedBottomRowsTotalHeight || currentPageTotalHeight !== apiRef.current.state.rowsMeta.currentPageTotalHeight;
        const rowsMeta = {
            currentPageTotalHeight: currentPageTotalHeight,
            positions: positions,
            pinnedTopRowsTotalHeight: pinnedTopRowsTotalHeight,
            pinnedBottomRowsTotalHeight: pinnedBottomRowsTotalHeight
        };
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                rowsMeta: rowsMeta
            });
        });
        if (didHeightsChange) apiRef.current.updateDimensions();
        isHeightMetaValid.current = true;
    }, [
        apiRef,
        pinnedRows,
        currentPage.rows,
        processHeightEntry
    ]);
    const getRowHeight = (rowId)=>{
        return heightCache.get(rowId)?.content ?? rowHeight;
    };
    const storeRowHeightMeasurement = (id, height)=>{
        const entry = apiRef.current.getRowHeightEntry(id);
        const didChange = entry.content !== height;
        entry.needsFirstMeasurement = false;
        entry.content = height;
        isHeightMetaValid.current &&= !didChange;
    };
    const rowHasAutoHeight = (id)=>{
        return heightCache.get(id)?.autoHeight ?? false;
    };
    const getLastMeasuredRowIndex = ()=>{
        return lastMeasuredRowIndex.current;
    };
    const setLastMeasuredRowIndex = (index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    };
    const resetRowHeights = ()=>{
        heightCache.clear();
        hydrateRowsMeta();
    };
    const resizeObserver = (0, $iYIN2.default)(()=>new (0, $bKpTj.ResizeObserver)((entries)=>{
            for(let i = 0; i < entries.length; i += 1){
                const entry = entries[i];
                const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
                const rowId = entry.target.__mui_id;
                const focusedVirtualRowId = (0, $98F89.gridFocusedVirtualCellSelector)(apiRef)?.id;
                if (focusedVirtualRowId === rowId && height === 0) // Focused virtual row has 0 height.
                // We don't want to store it to avoid scroll jumping.
                // https://github.com/mui/mui-x/issues/14726
                return;
                apiRef.current.unstable_storeRowHeightMeasurement(rowId, height);
            }
            if (!isHeightMetaValid.current) // Avoids "ResizeObserver loop completed with undelivered notifications" error
            requestAnimationFrame(()=>{
                apiRef.current.requestPipeProcessorsApplication('rowHeight');
            });
        })).current;
    const observeRowHeight = (element, rowId)=>{
        element.__mui_id = rowId;
        resizeObserver.observe(element);
        return ()=>resizeObserver.unobserve(element);
    };
    (0, $1xynw.useGridRegisterPipeApplier)(apiRef, 'rowHeight', hydrateRowsMeta);
    // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    (0, $eEJPp.default)(()=>{
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    const rowsMetaApi = {
        unstable_getRowHeight: getRowHeight,
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_storeRowHeightMeasurement: storeRowHeightMeasurement,
        resetRowHeights: resetRowHeights
    };
    const rowsMetaPrivateApi = {
        hydrateRowsMeta: hydrateRowsMeta,
        observeRowHeight: observeRowHeight,
        rowHasAutoHeight: rowHasAutoHeight,
        getRowHeightEntry: getRowHeightEntry,
        getLastMeasuredRowIndex: getLastMeasuredRowIndex
    };
    (0, $ivFej.useGridApiMethod)(apiRef, rowsMetaApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, rowsMetaPrivateApi, 'private');
};

});
parcelRegister("bKpTj", function(module, exports) {

$parcel$export(module.exports, "ResizeObserver", () => $88d813097f05c175$export$9caf76241ca21a11);
/* eslint-disable */ /**
 * HACK: Minimal shim to get jsdom to work.
 */ const $88d813097f05c175$export$9caf76241ca21a11 = typeof globalThis.ResizeObserver !== 'undefined' ? globalThis.ResizeObserver : class ResizeObserver {
    observe() {}
    unobserve() {}
    disconnect() {}
};

});


parcelRegister("lb6pq", function(module, exports) {

$parcel$export(module.exports, "useGridStatePersistence", () => $f6af98c761dea48b$export$971de86bde7f86a1);

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
const $f6af98c761dea48b$export$971de86bde7f86a1 = (apiRef)=>{
    const exportState = $acw62.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = $acw62.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
            callbacks: []
        }, {
            stateToRestore: stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState: exportState,
        restoreState: restoreState
    };
    (0, $ivFej.useGridApiMethod)(apiRef, statePersistenceApi, 'public');
};

});

parcelRegister("2H9Fl", function(module, exports) {

$parcel$export(module.exports, "useGridColumnSpanning", () => $1f67185743ff4f77$export$ce7ce4871097b52e);

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $eFF1m = parcelRequire("eFF1m");
const $1f67185743ff4f77$export$ce7ce4871097b52e = (apiRef)=>{
    const lookup = $acw62.useRef({});
    const getCellColSpanInfo = (rowId, columnIndex)=>{
        return lookup.current[rowId]?.[columnIndex];
    };
    const resetColSpan = ()=>{
        lookup.current = {};
    };
    // Calculate `colSpan` for each cell in the row
    const calculateColSpan = $acw62.useCallback(({ rowId: rowId, minFirstColumn: minFirstColumn, maxLastColumn: maxLastColumn, columns: columns })=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = $1f67185743ff4f77$var$calculateCellColSpan({
                apiRef: apiRef,
                lookup: lookup.current,
                columnIndex: i,
                rowId: rowId,
                minFirstColumnIndex: minFirstColumn,
                maxLastColumnIndex: maxLastColumn,
                columns: columns
            });
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    }, [
        apiRef
    ]);
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        resetColSpan: resetColSpan,
        calculateColSpan: calculateColSpan
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnSpanningPublicApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, columnSpanningPrivateApi, 'private');
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnOrderChange', resetColSpan);
};
function $1f67185743ff4f77$var$calculateCellColSpan(params) {
    const { apiRef: apiRef, lookup: lookup, columnIndex: columnIndex, rowId: rowId, minFirstColumnIndex: minFirstColumnIndex, maxLastColumnIndex: maxLastColumnIndex, columns: columns } = params;
    const columnsLength = columns.length;
    const column = columns[columnIndex];
    const row = apiRef.current.getRow(rowId);
    const value = apiRef.current.getRowValue(row, column);
    const colSpan = typeof column.colSpan === 'function' ? column.colSpan(value, row, column, apiRef) : column.colSpan;
    if (!colSpan || colSpan === 1) {
        $1f67185743ff4f77$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: 1,
                width: column.computedWidth
            }
        });
        return {
            colSpan: 1
        };
    }
    let width = column.computedWidth;
    for(let j = 1; j < colSpan; j += 1){
        const nextColumnIndex = columnIndex + j;
        // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
        if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
            const nextColumn = columns[nextColumnIndex];
            width += nextColumn.computedWidth;
            $1f67185743ff4f77$var$setCellColSpanInfo(lookup, rowId, columnIndex + j, {
                spannedByColSpan: true,
                rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                leftVisibleCellIndex: columnIndex
            });
        }
        $1f67185743ff4f77$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: colSpan,
                width: width
            }
        });
    }
    return {
        colSpan: colSpan
    };
}
function $1f67185743ff4f77$var$setCellColSpanInfo(lookup, rowId, columnIndex, cellColSpanInfo) {
    if (!lookup[rowId]) lookup[rowId] = {};
    lookup[rowId][columnIndex] = cellColSpanInfo;
}

});

parcelRegister("aFlgz", function(module, exports) {

$parcel$export(module.exports, "columnGroupsStateInitializer", () => $7c3e3abbe30f48e1$export$21c841dc431b3cd0);
$parcel$export(module.exports, "useGridColumnGrouping", () => $7c3e3abbe30f48e1$export$510984a37e2e33f3);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $j57st = parcelRequire("j57st");

var $hMyIf = parcelRequire("hMyIf");

var $ivFej = parcelRequire("ivFej");

var $vzN4X = parcelRequire("vzN4X");

var $eFF1m = parcelRequire("eFF1m");

var $jQEEt = parcelRequire("jQEEt");
const $7c3e3abbe30f48e1$var$_excluded = [
    "groupId",
    "children"
];
const $7c3e3abbe30f48e1$var$createGroupLookup = (columnGroupingModel)=>{
    let groupLookup = {};
    columnGroupingModel.forEach((node)=>{
        if ((0, $j57st.isLeaf)(node)) return;
        const { groupId: groupId, children: children } = node, other = (0, $1En50.default)(node, $7c3e3abbe30f48e1$var$_excluded);
        if (!groupId) throw new Error('MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        const groupParam = (0, $8nd05.default)({}, other, {
            groupId: groupId
        });
        const subTreeLookup = $7c3e3abbe30f48e1$var$createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI X: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        groupLookup = (0, $8nd05.default)({}, groupLookup, subTreeLookup, {
            [groupId]: groupParam
        });
    });
    return (0, $8nd05.default)({}, groupLookup);
};
const $7c3e3abbe30f48e1$export$21c841dc431b3cd0 = (state, props, apiRef)=>{
    if (!props.columnGroupingModel) return state;
    const columnFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
    const visibleColumnFields = (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef);
    const groupLookup = $7c3e3abbe30f48e1$var$createGroupLookup(props.columnGroupingModel ?? []);
    const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)(props.columnGroupingModel ?? []);
    const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(columnFields, unwrappedGroupingModel, apiRef.current.state.pinnedColumns ?? {});
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
    return (0, $8nd05.default)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
const $7c3e3abbe30f48e1$export$510984a37e2e33f3 = (apiRef, props)=>{
    /**
   * API METHODS
   */ const getColumnGroupPath = $acw62.useCallback((field)=>{
        const unwrappedGroupingModel = (0, $hMyIf.gridColumnGroupsUnwrappedModelSelector)(apiRef);
        return unwrappedGroupingModel[field] ?? [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = $acw62.useCallback(()=>{
        const columnGroupLookup = (0, $hMyIf.gridColumnGroupsLookupSelector)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        getColumnGroupPath: getColumnGroupPath,
        getAllGroupDetails: getAllGroupDetails
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnGroupingApi, 'public');
    const handleColumnIndexChange = $acw62.useCallback(()=>{
        const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)(props.columnGroupingModel ?? []);
        apiRef.current.setState((state)=>{
            const orderedFields = state.columns?.orderedFields ?? [];
            const pinnedColumns = state.pinnedColumns ?? {};
            const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return (0, $8nd05.default)({}, state, {
                columnGrouping: (0, $8nd05.default)({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = $acw62.useCallback((columnGroupingModel)=>{
        // @ts-expect-error Move this logic to `Pro` package
        const pinnedColumns = apiRef.current.getPinnedColumns?.() ?? {};
        const columnFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const visibleColumnFields = (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef);
        const groupLookup = $7c3e3abbe30f48e1$var$createGroupLookup(columnGroupingModel ?? []);
        const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)(columnGroupingModel ?? []);
        const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnIndexChange', handleColumnIndexChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnsChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnVisibilityModelChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};

});
parcelRegister("j57st", function(module, exports) {

$parcel$export(module.exports, "isLeaf", () => $de4444ff1794c3fb$export$e132ced8f644a612);
function $de4444ff1794c3fb$export$e132ced8f644a612(node) {
    return node.field !== undefined;
} /**
 * A function used to process headerClassName params.
 */  /**
 * The union type representing the [[GridColDef]] column header class type.
 */ 

});

parcelRegister("vzN4X", function(module, exports) {

$parcel$export(module.exports, "unwrapGroupingColumnModel", () => $05eea8a1c02f601e$export$ea425f87fd536c4d);
$parcel$export(module.exports, "getColumnGroupsHeaderStructure", () => $05eea8a1c02f601e$export$c41225ff45feeb0e);

var $j57st = parcelRequire("j57st");

var $lR3Vo = parcelRequire("lR3Vo");
// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
const $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if ((0, $j57st.isLeaf)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) throw new Error([
            `MUI X: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`,
            `- ${parents.join(' > ')}`
        ].join('\n'));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId: groupId, children: children } = columnGroupNode;
    children.forEach((child)=>{
        $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
const $05eea8a1c02f601e$export$ea425f87fd536c4d = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
const $05eea8a1c02f601e$export$c41225ff45feeb0e = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>unwrappedGroupingModel[field] ?? [];
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>(0, $lR3Vo.isDeepEqual)(getParents(field1).slice(0, depth + 1), getParents(field2).slice(0, depth + 1));
    const haveDifferentContainers = (field1, field2)=>{
        if (pinnedFields?.left && pinnedFields.left.includes(field1) && !pinnedFields.left.includes(field2)) return true;
        if (pinnedFields?.right && !pinnedFields.right.includes(field1) && pinnedFields.right.includes(field2)) return true;
        return false;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = orderedColumns.reduce((structure, newField)=>{
            const groupId = getParents(newField)[depth] ?? null;
            if (structure.length === 0) return [
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            const lastGroup = structure[structure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            const prevGroupId = lastGroup.groupId;
            if (prevGroupId !== groupId || !haveSameParents(prevField, newField, depth) || // Fix for https://github.com/mui/mui-x/issues/7041
            haveDifferentContainers(prevField, newField)) // It's a new group
            return [
                ...structure,
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            // It extends the previous group
            return [
                ...structure.slice(0, structure.length - 1),
                {
                    columnFields: [
                        ...lastGroup.columnFields,
                        newField
                    ],
                    groupId: groupId
                }
            ];
        }, []);
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};

});


parcelRegister("jDB9E", function(module, exports) {

$parcel$export(module.exports, "columnResizeStateInitializer", () => $e4be7afefd9a1627$export$ac6ed2ccd52f643f);
$parcel$export(module.exports, "useGridColumnResize", () => $e4be7afefd9a1627$export$6761a7afeb3daa64);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");

var $iYIN2 = parcelRequire("iYIN2");

var $9uEev = parcelRequire("9uEev");

var $KtEo5 = parcelRequire("KtEo5");

var $6lOsW = parcelRequire("6lOsW");

var $5H1vo = parcelRequire("5H1vo");

var $eFF1m = parcelRequire("eFF1m");
var $ivFej = parcelRequire("ivFej");
var $luu6e = parcelRequire("luu6e");
var $dRE9O = parcelRequire("dRE9O");
var $5sOMZ = parcelRequire("5sOMZ");
var $dOphX = parcelRequire("dOphX");

var $9upDV = parcelRequire("9upDV");

var $1SkXC = parcelRequire("1SkXC");

var $lR3Vo = parcelRequire("lR3Vo");

var $lHOu3 = parcelRequire("lHOu3");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $jQEEt = parcelRequire("jQEEt");
function $e4be7afefd9a1627$var$trackFinger(event, currentTouchId) {
    if (currentTouchId !== undefined && event.changedTouches) {
        for(let i = 0; i < event.changedTouches.length; i += 1){
            const touch = event.changedTouches[i];
            if (touch.identifier === currentTouchId) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator, clickX, columnBounds, resizeDirection) {
    let newWidth = initialOffsetToSeparator;
    if (resizeDirection === 'Right') newWidth += clickX - columnBounds.left;
    else newWidth += columnBounds.right - clickX;
    return newWidth;
}
function $e4be7afefd9a1627$var$computeOffsetToSeparator(clickX, columnBounds, resizeDirection) {
    if (resizeDirection === 'Left') return clickX - columnBounds.left;
    return columnBounds.right - clickX;
}
function $e4be7afefd9a1627$var$flipResizeDirection(side) {
    if (side === 'Right') return 'Left';
    return 'Right';
}
function $e4be7afefd9a1627$var$getResizeDirection(separator, isRtl) {
    const side = separator.classList.contains((0, $5H1vo.gridClasses)['columnSeparator--sideRight']) ? 'Right' : 'Left';
    if (isRtl) // Resizing logic should be mirrored in the RTL case
    return $e4be7afefd9a1627$var$flipResizeDirection(side);
    return side;
}
function $e4be7afefd9a1627$var$preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
/**
 * Checker that returns a promise that resolves when the column virtualization
 * is disabled.
 */ function $e4be7afefd9a1627$var$useColumnVirtualizationDisabled(apiRef) {
    const promise = $acw62.useRef(undefined);
    const selector = ()=>(0, $9upDV.gridVirtualizationColumnEnabledSelector)(apiRef);
    const value = (0, $5sOMZ.useGridSelector)(apiRef, selector);
    $acw62.useEffect(()=>{
        if (promise.current && value === false) {
            promise.current.resolve();
            promise.current = undefined;
        }
    });
    const asyncCheck = ()=>{
        if (!promise.current) {
            if (selector() === false) return Promise.resolve();
            promise.current = (0, $1SkXC.createControllablePromise)();
        }
        return promise.current;
    };
    return asyncCheck;
}
/**
 * Basic statistical outlier detection, checks if the value is `F * IQR` away from
 * the Q1 and Q3 boundaries. IQR: interquartile range.
 */ function $e4be7afefd9a1627$var$excludeOutliers(inputValues, factor) {
    if (inputValues.length < 4) return inputValues;
    const values = inputValues.slice();
    values.sort((a, b)=>a - b);
    const q1 = values[Math.floor(values.length * 0.25)];
    const q3 = values[Math.floor(values.length * 0.75) - 1];
    const iqr = q3 - q1;
    // We make a small adjustment if `iqr < 5` for the cases where the IQR is
    // very small (for example zero) due to very close by values in the input data.
    // Otherwise, with an IQR of `0`, anything outside that would be considered
    // an outlier, but it makes more sense visually to allow for this 5px variance
    // rather than showing a cropped cell.
    const deviation = iqr < 5 ? 5 : iqr * factor;
    return values.filter((v)=>v > q1 - deviation && v < q3 + deviation);
}
function $e4be7afefd9a1627$var$extractColumnWidths(apiRef, options, columns) {
    const widthByField = {};
    const root = apiRef.current.rootElementRef.current;
    root.classList.add((0, $5H1vo.gridClasses).autosizing);
    columns.forEach((column)=>{
        const cells = (0, $KtEo5.findGridCells)(apiRef.current, column.field);
        const widths = cells.map((cell)=>{
            return cell.getBoundingClientRect().width ?? 0;
        });
        const filteredWidths = options.includeOutliers ? widths : $e4be7afefd9a1627$var$excludeOutliers(widths, options.outliersFactor);
        if (options.includeHeaders) {
            const header = (0, $KtEo5.findGridHeader)(apiRef.current, column.field);
            if (header) {
                const title = header.querySelector(`.${(0, $5H1vo.gridClasses).columnHeaderTitle}`);
                const content = header.querySelector(`.${(0, $5H1vo.gridClasses).columnHeaderTitleContainerContent}`);
                const iconContainer = header.querySelector(`.${(0, $5H1vo.gridClasses).iconButtonContainer}`);
                const menuContainer = header.querySelector(`.${(0, $5H1vo.gridClasses).menuIcon}`);
                const element = title ?? content;
                const style = window.getComputedStyle(header, null);
                const paddingWidth = parseInt(style.paddingLeft, 10) + parseInt(style.paddingRight, 10);
                const contentWidth = element.scrollWidth + 1;
                const width = contentWidth + paddingWidth + (iconContainer?.clientWidth ?? 0) + (menuContainer?.clientWidth ?? 0);
                filteredWidths.push(width);
            }
        }
        const hasColumnMin = column.minWidth !== -Infinity && column.minWidth !== undefined;
        const hasColumnMax = column.maxWidth !== Infinity && column.maxWidth !== undefined;
        const min = hasColumnMin ? column.minWidth : 0;
        const max = hasColumnMax ? column.maxWidth : Infinity;
        const maxContent = filteredWidths.length === 0 ? 0 : Math.max(...filteredWidths);
        widthByField[column.field] = (0, $lR3Vo.clamp)(maxContent, min, max);
    });
    root.classList.remove((0, $5H1vo.gridClasses).autosizing);
    return widthByField;
}
const $e4be7afefd9a1627$export$ac6ed2ccd52f643f = (state)=>(0, $8nd05.default)({}, state, {
        columnResize: {
            resizingColumnField: ''
        }
    });
function $e4be7afefd9a1627$var$createResizeRefs() {
    return {
        colDef: undefined,
        initialColWidth: 0,
        initialTotalWidth: 0,
        previousMouseClickEvent: undefined,
        columnHeaderElement: undefined,
        headerFilterElement: undefined,
        groupHeaderElements: [],
        cellElements: [],
        leftPinnedCellsAfter: [],
        rightPinnedCellsBefore: [],
        fillerLeft: undefined,
        fillerRight: undefined,
        leftPinnedHeadersAfter: [],
        rightPinnedHeadersBefore: []
    };
}
const $e4be7afefd9a1627$export$6761a7afeb3daa64 = (apiRef, props)=>{
    const isRtl = (0, $9uEev.useRtl)();
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridColumnResize');
    const refs = (0, $iYIN2.default)($e4be7afefd9a1627$var$createResizeRefs).current;
    // To improve accessibility, the separator has padding on both sides.
    // Clicking inside the padding area should be treated as a click in the separator.
    // This ref stores the offset between the click and the separator.
    const initialOffsetToSeparator = $acw62.useRef(null);
    const resizeDirection = $acw62.useRef(null);
    const stopResizeEventTimeout = (0, $lHOu3.default)();
    const touchId = $acw62.useRef(undefined);
    const updateWidth = (newWidth)=>{
        logger.debug(`Updating width to ${newWidth} for col ${refs.colDef.field}`);
        const prevWidth = refs.columnHeaderElement.offsetWidth;
        const widthDiff = newWidth - prevWidth;
        const columnWidthDiff = newWidth - refs.initialColWidth;
        if (columnWidthDiff > 0) {
            const newTotalWidth = refs.initialTotalWidth + columnWidthDiff;
            apiRef.current.rootElementRef?.current?.style.setProperty('--DataGrid-rowWidth', `${newTotalWidth}px`);
        }
        refs.colDef.computedWidth = newWidth;
        refs.colDef.width = newWidth;
        refs.colDef.flex = 0;
        refs.columnHeaderElement.style.width = `${newWidth}px`;
        const headerFilterElement = refs.headerFilterElement;
        if (headerFilterElement) headerFilterElement.style.width = `${newWidth}px`;
        refs.groupHeaderElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.width = finalWidth;
        });
        refs.cellElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.setProperty('--width', finalWidth);
        });
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        if (pinnedPosition === (0, $4ZMWQ.GridPinnedColumnPosition).LEFT) {
            $e4be7afefd9a1627$var$updateProperty(refs.fillerLeft, 'width', widthDiff);
            refs.leftPinnedCellsAfter.forEach((cell)=>{
                $e4be7afefd9a1627$var$updateProperty(cell, 'left', widthDiff);
            });
            refs.leftPinnedHeadersAfter.forEach((header)=>{
                $e4be7afefd9a1627$var$updateProperty(header, 'left', widthDiff);
            });
        }
        if (pinnedPosition === (0, $4ZMWQ.GridPinnedColumnPosition).RIGHT) {
            $e4be7afefd9a1627$var$updateProperty(refs.fillerRight, 'width', widthDiff);
            refs.rightPinnedCellsBefore.forEach((cell)=>{
                $e4be7afefd9a1627$var$updateProperty(cell, 'right', widthDiff);
            });
            refs.rightPinnedHeadersBefore.forEach((header)=>{
                $e4be7afefd9a1627$var$updateProperty(header, 'right', widthDiff);
            });
        }
    };
    const finishResize = (nativeEvent)=>{
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
        // Prevent double-clicks from being interpreted as two separate clicks
        if (refs.previousMouseClickEvent) {
            const prevEvent = refs.previousMouseClickEvent;
            const prevTimeStamp = prevEvent.timeStamp;
            const prevClientX = prevEvent.clientX;
            const prevClientY = prevEvent.clientY;
            // Check if the current event is part of a double-click
            if (nativeEvent.timeStamp - prevTimeStamp < 300 && nativeEvent.clientX === prevClientX && nativeEvent.clientY === prevClientY) {
                refs.previousMouseClickEvent = undefined;
                apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
                return;
            }
        }
        if (refs.colDef) {
            apiRef.current.setColumnWidth(refs.colDef.field, refs.colDef.width);
            logger.debug(`Updating col ${refs.colDef.field} with new width: ${refs.colDef.width}`);
            // Since during resizing we update the columns width outside of React, React is unable to
            // reapply the right style properties. We need to sync the state manually.
            // So we reapply the same logic as in https://github.com/mui/mui-x/blob/0511bf65543ca05d2602a5a3e0a6156f2fc8e759/packages/x-data-grid/src/hooks/features/columnHeaders/useGridColumnHeaders.tsx#L405
            const columnsState = (0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state);
            refs.groupHeaderElements.forEach((element)=>{
                const fields = (0, $KtEo5.getFieldsFromGroupHeaderElem)(element);
                const div = element;
                const newWidth = fields.reduce((acc, field)=>{
                    if (columnsState.columnVisibilityModel[field] !== false) return acc + columnsState.lookup[field].computedWidth;
                    return acc;
                }, 0);
                const finalWidth = `${newWidth}px`;
                div.style.width = finalWidth;
            });
        }
        stopResizeEventTimeout.start(0, ()=>{
            apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
        });
    };
    const storeReferences = (colDef, separator, xStart)=>{
        const root = apiRef.current.rootElementRef.current;
        refs.initialColWidth = colDef.computedWidth;
        refs.initialTotalWidth = apiRef.current.getRootDimensions().rowWidth;
        refs.colDef = colDef;
        refs.columnHeaderElement = (0, $KtEo5.findHeaderElementFromField)(apiRef.current.columnHeadersContainerRef.current, colDef.field);
        const headerFilterElement = root.querySelector(`.${(0, $5H1vo.gridClasses).headerFilterRow} [data-field="${(0, $KtEo5.escapeOperandAttributeSelector)(colDef.field)}"]`);
        if (headerFilterElement) refs.headerFilterElement = headerFilterElement;
        refs.groupHeaderElements = (0, $KtEo5.findGroupHeaderElementsFromField)(apiRef.current.columnHeadersContainerRef?.current, colDef.field);
        refs.cellElements = (0, $KtEo5.findGridCellElementsFromCol)(refs.columnHeaderElement, apiRef.current);
        refs.fillerLeft = (0, $KtEo5.findGridElement)(apiRef.current, isRtl ? 'filler--pinnedRight' : 'filler--pinnedLeft');
        refs.fillerRight = (0, $KtEo5.findGridElement)(apiRef.current, isRtl ? 'filler--pinnedLeft' : 'filler--pinnedRight');
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        refs.leftPinnedCellsAfter = pinnedPosition !== (0, $4ZMWQ.GridPinnedColumnPosition).LEFT ? [] : (0, $KtEo5.findLeftPinnedCellsAfterCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedCellsBefore = pinnedPosition !== (0, $4ZMWQ.GridPinnedColumnPosition).RIGHT ? [] : (0, $KtEo5.findRightPinnedCellsBeforeCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.leftPinnedHeadersAfter = pinnedPosition !== (0, $4ZMWQ.GridPinnedColumnPosition).LEFT ? [] : (0, $KtEo5.findLeftPinnedHeadersAfterCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedHeadersBefore = pinnedPosition !== (0, $4ZMWQ.GridPinnedColumnPosition).RIGHT ? [] : (0, $KtEo5.findRightPinnedHeadersBeforeCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        resizeDirection.current = $e4be7afefd9a1627$var$getResizeDirection(separator, isRtl);
        initialOffsetToSeparator.current = $e4be7afefd9a1627$var$computeOffsetToSeparator(xStart, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
    };
    const handleResizeMouseUp = (0, $13KXh.default)(finishResize);
    const handleResizeMouseMove = (0, $13KXh.default)((nativeEvent)=>{
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        if (nativeEvent.buttons === 0) {
            handleResizeMouseUp(nativeEvent);
            return;
        }
        let newWidth = $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator.current, nativeEvent.clientX, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $lR3Vo.clamp)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchEnd = (0, $13KXh.default)((nativeEvent)=>{
        const finger = $e4be7afefd9a1627$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        finishResize(nativeEvent);
    });
    const handleTouchMove = (0, $13KXh.default)((nativeEvent)=>{
        const finger = $e4be7afefd9a1627$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        // Cancel move in case some other element consumed a touchmove event and it was not fired.
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            handleTouchEnd(nativeEvent);
            return;
        }
        let newWidth = $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator.current, finger.x, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $lR3Vo.clamp)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchStart = (0, $13KXh.default)((event)=>{
        const cellSeparator = (0, $KtEo5.findParentElementFromClassName)(event.target, (0, $5H1vo.gridClasses)['columnSeparator--resizable']);
        // Let the event bubble if the target is not a col separator
        if (!cellSeparator) return;
        const touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const columnHeaderElement = (0, $KtEo5.findParentElementFromClassName)(event.target, (0, $5H1vo.gridClasses).columnHeader);
        const field = (0, $KtEo5.getFieldFromHeaderElem)(columnHeaderElement);
        const colDef = apiRef.current.getColumn(field);
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: field
        }, event);
        storeReferences(colDef, cellSeparator, touch.clientX);
        const doc = (0, $6zeBo.default)(event.currentTarget);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    const stopListening = $acw62.useCallback(()=>{
        const doc = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
        doc.body.style.removeProperty('cursor');
        doc.removeEventListener('mousemove', handleResizeMouseMove);
        doc.removeEventListener('mouseup', handleResizeMouseUp);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
        // The click event runs right after the mouseup event, we want to wait until it
        // has been canceled before removing our handler.
        setTimeout(()=>{
            doc.removeEventListener('click', $e4be7afefd9a1627$var$preventClick, true);
        }, 100);
        if (refs.columnHeaderElement) refs.columnHeaderElement.style.pointerEvents = 'unset';
    }, [
        apiRef,
        refs,
        handleResizeMouseMove,
        handleResizeMouseUp,
        handleTouchMove,
        handleTouchEnd
    ]);
    const handleResizeStart = $acw62.useCallback(({ field: field })=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                columnResize: (0, $8nd05.default)({}, state.columnResize, {
                    resizingColumnField: field
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const handleResizeStop = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                columnResize: (0, $8nd05.default)({}, state.columnResize, {
                    resizingColumnField: ''
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const handleColumnResizeMouseDown = (0, $13KXh.default)(({ colDef: colDef }, event)=>{
        // Only handle left clicks
        if (event.button !== 0) return;
        // Skip if the column isn't resizable
        if (!event.currentTarget.classList.contains((0, $5H1vo.gridClasses)['columnSeparator--resizable'])) return;
        // Avoid text selection
        event.preventDefault();
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: colDef.field
        }, event);
        storeReferences(colDef, event.currentTarget, event.clientX);
        const doc = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
        doc.body.style.cursor = 'col-resize';
        refs.previousMouseClickEvent = event.nativeEvent;
        doc.addEventListener('mousemove', handleResizeMouseMove);
        doc.addEventListener('mouseup', handleResizeMouseUp);
        // Prevent the click event if we have resized the column.
        // Fixes https://github.com/mui/mui-x/issues/4777
        doc.addEventListener('click', $e4be7afefd9a1627$var$preventClick, true);
    });
    const handleColumnSeparatorDoubleClick = (0, $13KXh.default)((params, event)=>{
        if (props.disableAutosize) return;
        // Only handle left clicks
        if (event.button !== 0) return;
        const column = apiRef.current.state.columns.lookup[params.field];
        if (column.resizable === false) return;
        apiRef.current.autosizeColumns((0, $8nd05.default)({}, props.autosizeOptions, {
            disableColumnVirtualization: false,
            columns: [
                column.field
            ]
        }));
    });
    /**
   * API METHODS
   */ const columnVirtualizationDisabled = $e4be7afefd9a1627$var$useColumnVirtualizationDisabled(apiRef);
    const isAutosizingRef = $acw62.useRef(false);
    const autosizeColumns = $acw62.useCallback(async (userOptions)=>{
        const root = apiRef.current.rootElementRef?.current;
        if (!root) return;
        if (isAutosizingRef.current) return;
        isAutosizingRef.current = true;
        const state = (0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state);
        const options = (0, $8nd05.default)({}, (0, $6lOsW.DEFAULT_GRID_AUTOSIZE_OPTIONS), userOptions, {
            columns: userOptions?.columns ?? state.orderedFields
        });
        options.columns = options.columns.filter((c)=>state.columnVisibilityModel[c] !== false);
        const columns = options.columns.map((c)=>apiRef.current.state.columns.lookup[c]);
        try {
            if (!props.disableVirtualization && options.disableColumnVirtualization) {
                apiRef.current.unstable_setColumnVirtualization(false);
                await columnVirtualizationDisabled();
            }
            const widthByField = $e4be7afefd9a1627$var$extractColumnWidths(apiRef, options, columns);
            const newColumns = columns.map((column)=>(0, $8nd05.default)({}, column, {
                    width: widthByField[column.field],
                    computedWidth: widthByField[column.field],
                    flex: 0
                }));
            if (options.expand) {
                const visibleColumns = state.orderedFields.map((field)=>state.lookup[field]).filter((c)=>state.columnVisibilityModel[c.field] !== false);
                const totalWidth = visibleColumns.reduce((total, column)=>total + (widthByField[column.field] ?? column.computedWidth ?? column.width), 0);
                const dimensions = apiRef.current.getRootDimensions();
                const availableWidth = dimensions.viewportInnerSize.width;
                const remainingWidth = availableWidth - totalWidth;
                if (remainingWidth > 0) {
                    const widthPerColumn = remainingWidth / (newColumns.length || 1);
                    newColumns.forEach((column)=>{
                        column.width += widthPerColumn;
                        column.computedWidth += widthPerColumn;
                    });
                }
            }
            apiRef.current.updateColumns(newColumns);
            newColumns.forEach((newColumn, index)=>{
                if (newColumn.width !== columns[index].width) {
                    const width = newColumn.width;
                    apiRef.current.publishEvent('columnWidthChange', {
                        element: apiRef.current.getColumnHeaderElement(newColumn.field),
                        colDef: newColumn,
                        width: width
                    });
                }
            });
        } finally{
            if (!props.disableVirtualization) apiRef.current.unstable_setColumnVirtualization(true);
            isAutosizingRef.current = false;
        }
    }, [
        apiRef,
        columnVirtualizationDisabled,
        props.disableVirtualization
    ]);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>stopListening, [
        stopListening
    ]);
    (0, $dOphX.default)(()=>{
        if (props.autosizeOnMount) Promise.resolve().then(()=>{
            apiRef.current.autosizeColumns(props.autosizeOptions);
        });
    });
    (0, $dRE9O.useGridNativeEventListener)(apiRef, ()=>apiRef.current.columnHeadersContainerRef?.current, 'touchstart', handleTouchStart, {
        passive: true
    });
    (0, $ivFej.useGridApiMethod)(apiRef, {
        autosizeColumns: autosizeColumns
    }, 'public');
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResizeStop', handleResizeStop);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResizeStart', handleResizeStart);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnSeparatorMouseDown', handleColumnResizeMouseDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnSeparatorDoubleClick', handleColumnSeparatorDoubleClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnResize', props.onColumnResize);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnWidthChange', props.onColumnWidthChange);
};
function $e4be7afefd9a1627$var$updateProperty(element, property, delta) {
    if (!element) return;
    element.style[property] = `${parseInt(element.style[property], 10) + delta}px`;
}

});
parcelRegister("6lOsW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GRID_AUTOSIZE_OPTIONS", () => $49fbd9b1282fca98$export$9707fe779d390182);
const $49fbd9b1282fca98$export$9707fe779d390182 = {
    includeHeaders: true,
    includeOutliers: false,
    outliersFactor: 1.5,
    expand: false,
    disableColumnVirtualization: true
}; /**
 * The Resize API interface that is available in the grid `apiRef`.
 */ 

});

parcelRegister("1SkXC", function(module, exports) {

$parcel$export(module.exports, "createControllablePromise", () => $15db17edb5d37fe8$export$7e10cfd0168dec8f);
function $15db17edb5d37fe8$export$7e10cfd0168dec8f() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    promise.resolve = resolve;
    promise.reject = reject;
    return promise;
}

});


parcelRegister("1n8rV", function(module, exports) {

$parcel$export(module.exports, "rowSpanningStateInitializer", () => $0ffe7e50943bb4c1$export$1fc0574395a3c13e);
$parcel$export(module.exports, "useGridRowSpanning", () => $0ffe7e50943bb4c1$export$bd58ae04485aa5f5);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $iYIN2 = parcelRequire("iYIN2");

var $jZka4 = parcelRequire("jZka4");

var $jQEEt = parcelRequire("jQEEt");

var $aJApm = parcelRequire("aJApm");

var $9upDV = parcelRequire("9upDV");

var $2QKlN = parcelRequire("2QKlN");

var $5bG6h = parcelRequire("5bG6h");

var $eFF1m = parcelRequire("eFF1m");

var $lR3Vo = parcelRequire("lR3Vo");

var $gPWuj = parcelRequire("gPWuj");

var $goCyd = parcelRequire("goCyd");
const $0ffe7e50943bb4c1$var$EMPTY_STATE = {
    spannedCells: {},
    hiddenCells: {},
    hiddenCellOriginMap: {}
};
const $0ffe7e50943bb4c1$var$EMPTY_RANGE = {
    firstRowIndex: 0,
    lastRowIndex: 0
};
const $0ffe7e50943bb4c1$var$skippedFields = new Set([
    (0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD),
    '__reorder__',
    (0, $jZka4.GRID_DETAIL_PANEL_TOGGLE_FIELD)
]);
/**
 * Default number of rows to process during state initialization to avoid flickering.
 * Number `20` is arbitrarily chosen to be large enough to cover most of the cases without
 * compromising performance.
 */ const $0ffe7e50943bb4c1$var$DEFAULT_ROWS_TO_PROCESS = 20;
const $0ffe7e50943bb4c1$var$computeRowSpanningState = (apiRef, colDefs, visibleRows, range, rangeToProcess, resetState, processedRange)=>{
    const spannedCells = resetState ? {} : (0, $8nd05.default)({}, apiRef.current.state.rowSpanning.spannedCells);
    const hiddenCells = resetState ? {} : (0, $8nd05.default)({}, apiRef.current.state.rowSpanning.hiddenCells);
    const hiddenCellOriginMap = resetState ? {} : (0, $8nd05.default)({}, apiRef.current.state.rowSpanning.hiddenCellOriginMap);
    if (resetState) processedRange = $0ffe7e50943bb4c1$var$EMPTY_RANGE;
    colDefs.forEach((colDef)=>{
        if ($0ffe7e50943bb4c1$var$skippedFields.has(colDef.field)) return;
        for(let index = rangeToProcess.firstRowIndex; index < rangeToProcess.lastRowIndex; index += 1){
            const row = visibleRows[index];
            if (hiddenCells[row.id]?.[colDef.field]) continue;
            const cellValue = (0, $2QKlN.getCellValue)(row.model, colDef, apiRef);
            if (cellValue == null) continue;
            let spannedRowId = row.id;
            let spannedRowIndex = index;
            let rowSpan = 0;
            // For first index, also scan in the previous rows to handle the reset state case e.g by sorting
            const backwardsHiddenCells = [];
            if (index === rangeToProcess.firstRowIndex) {
                let prevIndex = index - 1;
                let prevRowEntry = visibleRows[prevIndex];
                while(prevIndex >= range.firstRowIndex && prevRowEntry && (0, $2QKlN.getCellValue)(prevRowEntry.model, colDef, apiRef) === cellValue){
                    const currentRow = visibleRows[prevIndex + 1];
                    if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][colDef.field] = true;
                    else hiddenCells[currentRow.id] = {
                        [colDef.field]: true
                    };
                    backwardsHiddenCells.push(index);
                    rowSpan += 1;
                    spannedRowId = prevRowEntry.id;
                    spannedRowIndex = prevIndex;
                    prevIndex -= 1;
                    prevRowEntry = visibleRows[prevIndex];
                }
            }
            backwardsHiddenCells.forEach((hiddenCellIndex)=>{
                if (hiddenCellOriginMap[hiddenCellIndex]) hiddenCellOriginMap[hiddenCellIndex][colDef.field] = spannedRowIndex;
                else hiddenCellOriginMap[hiddenCellIndex] = {
                    [colDef.field]: spannedRowIndex
                };
            });
            // Scan the next rows
            let relativeIndex = index + 1;
            while(relativeIndex <= range.lastRowIndex && visibleRows[relativeIndex] && (0, $2QKlN.getCellValue)(visibleRows[relativeIndex].model, colDef, apiRef) === cellValue){
                const currentRow = visibleRows[relativeIndex];
                if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][colDef.field] = true;
                else hiddenCells[currentRow.id] = {
                    [colDef.field]: true
                };
                if (hiddenCellOriginMap[relativeIndex]) hiddenCellOriginMap[relativeIndex][colDef.field] = spannedRowIndex;
                else hiddenCellOriginMap[relativeIndex] = {
                    [colDef.field]: spannedRowIndex
                };
                relativeIndex += 1;
                rowSpan += 1;
            }
            if (rowSpan > 0) {
                if (spannedCells[spannedRowId]) spannedCells[spannedRowId][colDef.field] = rowSpan + 1;
                else spannedCells[spannedRowId] = {
                    [colDef.field]: rowSpan + 1
                };
            }
        }
        processedRange = {
            firstRowIndex: Math.min(processedRange.firstRowIndex, rangeToProcess.firstRowIndex),
            lastRowIndex: Math.max(processedRange.lastRowIndex, rangeToProcess.lastRowIndex)
        };
    });
    return {
        spannedCells: spannedCells,
        hiddenCells: hiddenCells,
        hiddenCellOriginMap: hiddenCellOriginMap,
        processedRange: processedRange
    };
};
const $0ffe7e50943bb4c1$var$getInitialRangeToProcess = (props, apiRef)=>{
    const rowCount = (0, $goCyd.gridDataRowIdsSelector)(apiRef).length;
    if (props.pagination) {
        const pageSize = (0, $gPWuj.gridPageSizeSelector)(apiRef);
        let paginationLastRowIndex = $0ffe7e50943bb4c1$var$DEFAULT_ROWS_TO_PROCESS;
        if (pageSize > 0) paginationLastRowIndex = pageSize - 1;
        return {
            firstRowIndex: 0,
            lastRowIndex: Math.min(paginationLastRowIndex, rowCount)
        };
    }
    return {
        firstRowIndex: 0,
        lastRowIndex: Math.min($0ffe7e50943bb4c1$var$DEFAULT_ROWS_TO_PROCESS, rowCount)
    };
};
const $0ffe7e50943bb4c1$export$1fc0574395a3c13e = (state, props, apiRef)=>{
    if (!props.unstable_rowSpanning) return (0, $8nd05.default)({}, state, {
        rowSpanning: $0ffe7e50943bb4c1$var$EMPTY_STATE
    });
    const rowIds = state.rows.dataRowIds || [];
    const orderedFields = state.columns.orderedFields || [];
    const dataRowIdToModelLookup = state.rows.dataRowIdToModelLookup;
    const columnsLookup = state.columns.lookup;
    const isFilteringPending = Boolean(state.filter.filterModel.items.length) || Boolean(state.filter.filterModel.quickFilterValues?.length);
    if (!rowIds.length || !orderedFields.length || !dataRowIdToModelLookup || !columnsLookup || isFilteringPending) return (0, $8nd05.default)({}, state, {
        rowSpanning: $0ffe7e50943bb4c1$var$EMPTY_STATE
    });
    const rangeToProcess = $0ffe7e50943bb4c1$var$getInitialRangeToProcess(props, apiRef);
    const rows = rowIds.map((id)=>({
            id: id,
            model: dataRowIdToModelLookup[id]
        }));
    const colDefs = orderedFields.map((field)=>columnsLookup[field]);
    const { spannedCells: spannedCells, hiddenCells: hiddenCells, hiddenCellOriginMap: hiddenCellOriginMap } = $0ffe7e50943bb4c1$var$computeRowSpanningState(apiRef, colDefs, rows, rangeToProcess, rangeToProcess, true, $0ffe7e50943bb4c1$var$EMPTY_RANGE);
    return (0, $8nd05.default)({}, state, {
        rowSpanning: {
            spannedCells: spannedCells,
            hiddenCells: hiddenCells,
            hiddenCellOriginMap: hiddenCellOriginMap
        }
    });
};
const $0ffe7e50943bb4c1$export$bd58ae04485aa5f5 = (apiRef, props)=>{
    const processedRange = (0, $iYIN2.default)(()=>{
        return apiRef.current.state.rowSpanning !== $0ffe7e50943bb4c1$var$EMPTY_STATE ? $0ffe7e50943bb4c1$var$getInitialRangeToProcess(props, apiRef) : $0ffe7e50943bb4c1$var$EMPTY_RANGE;
    });
    const updateRowSpanningState = $acw62.useCallback((renderContext, resetState = false)=>{
        const { range: range, rows: visibleRows } = (0, $aJApm.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        if (range === null || !(0, $2QKlN.isRowContextInitialized)(renderContext)) return;
        if (resetState) processedRange.current = $0ffe7e50943bb4c1$var$EMPTY_RANGE;
        const rangeToProcess = (0, $2QKlN.getUnprocessedRange)({
            firstRowIndex: renderContext.firstRowIndex,
            lastRowIndex: Math.min(renderContext.lastRowIndex, range.lastRowIndex + 1)
        }, processedRange.current);
        if (rangeToProcess === null) return;
        const colDefs = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const { spannedCells: spannedCells, hiddenCells: hiddenCells, hiddenCellOriginMap: hiddenCellOriginMap, processedRange: newProcessedRange } = $0ffe7e50943bb4c1$var$computeRowSpanningState(apiRef, colDefs, visibleRows, range, rangeToProcess, resetState, processedRange.current);
        processedRange.current = newProcessedRange;
        const newSpannedCellsCount = Object.keys(spannedCells).length;
        const newHiddenCellsCount = Object.keys(hiddenCells).length;
        const currentSpannedCellsCount = Object.keys(apiRef.current.state.rowSpanning.spannedCells).length;
        const currentHiddenCellsCount = Object.keys(apiRef.current.state.rowSpanning.hiddenCells).length;
        const shouldUpdateState = resetState || newSpannedCellsCount !== currentSpannedCellsCount || newHiddenCellsCount !== currentHiddenCellsCount;
        const hasNoSpannedCells = newSpannedCellsCount === 0 && currentSpannedCellsCount === 0;
        if (!shouldUpdateState || hasNoSpannedCells) return;
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                rowSpanning: {
                    spannedCells: spannedCells,
                    hiddenCells: hiddenCells,
                    hiddenCellOriginMap: hiddenCellOriginMap
                }
            });
        });
    }, [
        apiRef,
        processedRange,
        props.pagination,
        props.paginationMode
    ]);
    // Reset events trigger a full re-computation of the row spanning state:
    // - The `unstable_rowSpanning` prop is updated (feature flag)
    // - The filtering is applied
    // - The sorting is applied
    // - The `paginationModel` is updated
    // - The rows are updated
    const resetRowSpanningState = $acw62.useCallback(()=>{
        const renderContext = (0, $9upDV.gridRenderContextSelector)(apiRef);
        if (!(0, $2QKlN.isRowContextInitialized)(renderContext)) return;
        updateRowSpanningState(renderContext, true);
    }, [
        apiRef,
        updateRowSpanningState
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'renderedRowsIntervalChange', (0, $lR3Vo.runIf)(props.unstable_rowSpanning, updateRowSpanningState));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'sortedRowsSet', (0, $lR3Vo.runIf)(props.unstable_rowSpanning, resetRowSpanningState));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'paginationModelChange', (0, $lR3Vo.runIf)(props.unstable_rowSpanning, resetRowSpanningState));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'filteredRowsSet', (0, $lR3Vo.runIf)(props.unstable_rowSpanning, resetRowSpanningState));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnsChange', (0, $lR3Vo.runIf)(props.unstable_rowSpanning, resetRowSpanningState));
    $acw62.useEffect(()=>{
        if (!props.unstable_rowSpanning) {
            if (apiRef.current.state.rowSpanning !== $0ffe7e50943bb4c1$var$EMPTY_STATE) apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    rowSpanning: $0ffe7e50943bb4c1$var$EMPTY_STATE
                }));
        } else if (apiRef.current.state.rowSpanning === $0ffe7e50943bb4c1$var$EMPTY_STATE) resetRowSpanningState();
    }, [
        apiRef,
        resetRowSpanningState,
        props.unstable_rowSpanning
    ]);
};

});
parcelRegister("2QKlN", function(module, exports) {

$parcel$export(module.exports, "getUnprocessedRange", () => $2134645d829cdaa1$export$dfe82022b99d331c);
$parcel$export(module.exports, "isRowContextInitialized", () => $2134645d829cdaa1$export$55e910ce057d7a27);
$parcel$export(module.exports, "getCellValue", () => $2134645d829cdaa1$export$b1f6fa0c5f374def);
function $2134645d829cdaa1$export$dfe82022b99d331c(testRange, processedRange) {
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return null;
    // Overflowing at the end
    // Example: testRange={ firstRowIndex: 10, lastRowIndex: 20 }, processedRange={ firstRowIndex: 0, lastRowIndex: 15 }
    // Unprocessed Range={ firstRowIndex: 16, lastRowIndex: 20 }
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex > processedRange.lastRowIndex) return {
        firstRowIndex: processedRange.lastRowIndex,
        lastRowIndex: testRange.lastRowIndex
    };
    // Overflowing at the beginning
    // Example: testRange={ firstRowIndex: 0, lastRowIndex: 20 }, processedRange={ firstRowIndex: 16, lastRowIndex: 30 }
    // Unprocessed Range={ firstRowIndex: 0, lastRowIndex: 15 }
    if (testRange.firstRowIndex < processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return {
        firstRowIndex: testRange.firstRowIndex,
        lastRowIndex: processedRange.firstRowIndex - 1
    };
    // TODO: Should return two ranges handle overflowing at both ends ?
    return testRange;
}
function $2134645d829cdaa1$export$55e910ce057d7a27(renderContext) {
    return renderContext.firstRowIndex !== 0 || renderContext.lastRowIndex !== 0;
}
function $2134645d829cdaa1$export$23d54c9043f34b98(range1, range2) {
    return range1.firstRowIndex !== range2.firstRowIndex || range1.lastRowIndex !== range2.lastRowIndex;
}
const $2134645d829cdaa1$export$b1f6fa0c5f374def = (row, colDef, apiRef)=>{
    if (!row) return null;
    let cellValue = row[colDef.field];
    const valueGetter = colDef.rowSpanValueGetter ?? colDef.valueGetter;
    if (valueGetter) cellValue = valueGetter(cellValue, row, colDef, apiRef);
    return cellValue;
};

});


parcelRegister("kbNad", function(module, exports) {

$parcel$export(module.exports, "listViewStateInitializer", () => $eb2af8a38b4a65a4$export$5505a327712c37f5);
$parcel$export(module.exports, "useGridListView", () => $eb2af8a38b4a65a4$export$5ab13dce76367dce);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $k1l8W = parcelRequire("k1l8W");

var $61HyH = parcelRequire("61HyH");

var $eFF1m = parcelRequire("eFF1m");
const $eb2af8a38b4a65a4$export$5505a327712c37f5 = (state, props, apiRef)=>(0, $8nd05.default)({}, state, {
        listViewColumn: props.unstable_listColumn ? (0, $8nd05.default)({}, props.unstable_listColumn, {
            computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
        }) : undefined
    });
function $eb2af8a38b4a65a4$export$5ab13dce76367dce(apiRef, props) {
    /*
   * EVENTS
   */ const updateListColumnWidth = ()=>{
        apiRef.current.setState((state)=>{
            if (!state.listViewColumn) return state;
            return (0, $8nd05.default)({}, state, {
                listViewColumn: (0, $8nd05.default)({}, state.listViewColumn, {
                    computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
                })
            });
        });
    };
    const prevInnerWidth = $acw62.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            updateListColumnWidth();
        }
    };
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnVisibilityModelChange', updateListColumnWidth);
    /*
   * EFFECTS
   */ (0, $eEJPp.default)(()=>{
        const listColumn = props.unstable_listColumn;
        if (listColumn) apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                listViewColumn: (0, $8nd05.default)({}, listColumn, {
                    computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
                })
            });
        });
    }, [
        apiRef,
        props.unstable_listColumn
    ]);
    $acw62.useEffect(()=>{
        if (props.unstable_listView && !props.unstable_listColumn) (0, $k1l8W.warnOnce)([
            'MUI X: The `unstable_listColumn` prop must be set if `unstable_listView` is enabled.',
            'To fix, pass a column definition to the `unstable_listColumn` prop, e.g. `{ field: "example", renderCell: (params) => <div>{params.row.id}</div> }`.',
            'For more details, see https://mui.com/x/react-data-grid/list-view/'
        ]);
    }, [
        props.unstable_listView,
        props.unstable_listColumn
    ]);
}
function $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef) {
    return (0, $61HyH.gridDimensionsSelector)(apiRef.current.state).viewportInnerSize.width;
}

});
parcelRegister("k1l8W", function(module, exports) {

$parcel$export(module.exports, "warnOnce", () => $e9344d451944e2b7$export$5b28268982f175ba);
const $e9344d451944e2b7$var$warnedOnceCache = new Set();
function $e9344d451944e2b7$export$5b28268982f175ba(message, gravity = 'warning') {
    return;
}
function $e9344d451944e2b7$export$f090597298dd5ce2() {
    $e9344d451944e2b7$var$warnedOnceCache.clear();
}

});



parcelRegister("hiKx5", function(module, exports) {

$parcel$export(module.exports, "useDataGridProps", () => $c9883683c395e213$export$23366c9f040a985);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $14H9o = parcelRequire("14H9o");

var $izOUK = parcelRequire("izOUK");

var $hHZTP = parcelRequire("hHZTP");

var $fCO8m = parcelRequire("fCO8m");

var $4Yqqs = parcelRequire("4Yqqs");
var $4cd9P = parcelRequire("4cd9P");

var $1kYRD = parcelRequire("1kYRD");
const $c9883683c395e213$var$DATA_GRID_FORCED_PROPS = {
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    throttleRowsMs: undefined,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: 'DataGrid',
    unstable_listView: false
};
const $c9883683c395e213$var$defaultSlots = (0, $fCO8m.DATA_GRID_DEFAULT_SLOTS_COMPONENTS);
const $c9883683c395e213$export$23366c9f040a985 = (inProps)=>{
    const theme = (0, $14H9o.default)();
    const themedProps = (0, $4cd9P.useProps)($acw62.useMemo(()=>(0, $izOUK.getThemeProps)({
            props: inProps,
            theme: theme,
            name: 'MuiDataGrid'
        }), [
        theme,
        inProps
    ]));
    const localeText = $acw62.useMemo(()=>(0, $8nd05.default)({}, (0, $hHZTP.GRID_DEFAULT_LOCALE_TEXT), themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $acw62.useMemo(()=>(0, $4Yqqs.computeSlots)({
            defaultSlots: $c9883683c395e213$var$defaultSlots,
            slots: themedProps.slots
        }), [
        themedProps.slots
    ]);
    const injectDefaultProps = $acw62.useMemo(()=>{
        return Object.keys((0, $1kYRD.DATA_GRID_PROPS_DEFAULT_VALUES)).reduce((acc, key)=>{
            // @ts-ignore
            acc[key] = themedProps[key] ?? (0, $1kYRD.DATA_GRID_PROPS_DEFAULT_VALUES)[key];
            return acc;
        }, {});
    }, [
        themedProps
    ]);
    return $acw62.useMemo(()=>(0, $8nd05.default)({}, themedProps, injectDefaultProps, {
            localeText: localeText,
            slots: slots
        }, $c9883683c395e213$var$DATA_GRID_FORCED_PROPS), [
        themedProps,
        localeText,
        slots,
        injectDefaultProps
    ]);
};

});
parcelRegister("hHZTP", function(module, exports) {

$parcel$export(module.exports, "GRID_DEFAULT_LOCALE_TEXT", () => $ce4677c59813cb05$export$d217cc4e11b3c706);
const $ce4677c59813cb05$export$d217cc4e11b3c706 = {
    // Root
    noRowsLabel: 'No rows',
    noResultsOverlayLabel: 'No results found.',
    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    // Filters toolbar button text
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: 'Search',
    toolbarQuickFilterDeleteIconLabel: 'Clear',
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    toolbarExportPrint: 'Print',
    toolbarExportExcel: 'Download as Excel',
    // Columns management text
    columnsManagementSearchTitle: 'Search',
    columnsManagementNoColumns: 'No columns',
    columnsManagementShowHideAllText: 'Show/Hide All',
    columnsManagementReset: 'Reset',
    columnsManagementDeleteIconLabel: 'Clear',
    // Filter panel text
    filterPanelAddFilter: 'Add filter',
    filterPanelRemoveAll: 'Remove all',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelLogicOperator: 'Logic operator',
    filterPanelOperator: 'Operator',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    // Filter operators text
    filterOperatorContains: 'contains',
    filterOperatorDoesNotContain: 'does not contain',
    filterOperatorEquals: 'equals',
    filterOperatorDoesNotEqual: 'does not equal',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'is empty',
    filterOperatorIsNotEmpty: 'is not empty',
    filterOperatorIsAnyOf: 'is any of',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',
    // Header filter operators text
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorDoesNotContain: 'Does not contain',
    headerFilterOperatorEquals: 'Equals',
    headerFilterOperatorDoesNotEqual: 'Does not equal',
    headerFilterOperatorStartsWith: 'Starts with',
    headerFilterOperatorEndsWith: 'Ends with',
    headerFilterOperatorIs: 'Is',
    headerFilterOperatorNot: 'Is not',
    headerFilterOperatorAfter: 'Is after',
    headerFilterOperatorOnOrAfter: 'Is on or after',
    headerFilterOperatorBefore: 'Is before',
    headerFilterOperatorOnOrBefore: 'Is on or before',
    headerFilterOperatorIsEmpty: 'Is empty',
    headerFilterOperatorIsNotEmpty: 'Is not empty',
    headerFilterOperatorIsAnyOf: 'Is any of',
    'headerFilterOperator=': 'Equals',
    'headerFilterOperator!=': 'Not equals',
    'headerFilterOperator>': 'Greater than',
    'headerFilterOperator>=': 'Greater than or equal to',
    'headerFilterOperator<': 'Less than',
    'headerFilterOperator<=': 'Less than or equal to',
    // Filter values text
    filterValueAny: 'any',
    filterValueTrue: 'true',
    filterValueFalse: 'false',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuAriaLabel: (columnName)=>`${columnName} column menu`,
    columnMenuShowColumns: 'Show columns',
    columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide column',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: 'Total Rows:',
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Checkbox selection',
    checkboxSelectionSelectAllRows: 'Select all rows',
    checkboxSelectionUnselectAllRows: 'Unselect all rows',
    checkboxSelectionSelectRow: 'Select row',
    checkboxSelectionUnselectRow: 'Unselect row',
    // Boolean cell text
    booleanCellTrueLabel: 'yes',
    booleanCellFalseLabel: 'no',
    // Actions cell more text
    actionsCellMore: 'more',
    // Column pinning text
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    unpin: 'Unpin',
    // Tree Data
    treeDataGroupingHeaderName: 'Group',
    treeDataExpand: 'see children',
    treeDataCollapse: 'hide children',
    // Grouping columns
    groupingColumnHeaderName: 'Group',
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: 'Detail panel toggle',
    expandDetailPanel: 'Expand',
    collapseDetailPanel: 'Collapse',
    // Used core components translation keys
    MuiTablePagination: {},
    // Row reordering text
    rowReorderingHeaderName: 'Row reordering',
    // Aggregation
    aggregationMenuItemHeader: 'Aggregation',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'size'
};

});

parcelRegister("fCO8m", function(module, exports) {

$parcel$export(module.exports, "DATA_GRID_DEFAULT_SLOTS_COMPONENTS", () => $b6014b2d4bf32573$export$8a57bda01657743f);

var $8nd05 = parcelRequire("8nd05");

var $k8xn5 = parcelRequire("k8xn5");
var $960Cz = parcelRequire("960Cz");
var $4ix5g = parcelRequire("4ix5g");
var $l98cE = parcelRequire("l98cE");
var $kWNEF = parcelRequire("kWNEF");
var $jIkp9 = parcelRequire("jIkp9");
var $4YSVE = parcelRequire("4YSVE");
var $28JSg = parcelRequire("28JSg");
var $fuqu4 = parcelRequire("fuqu4");
var $kfa8b = parcelRequire("kfa8b");
var $kWPQR = parcelRequire("kWPQR");
var $l3iPY = parcelRequire("l3iPY");
var $etLiE = parcelRequire("etLiE");

var $6X2NG = parcelRequire("6X2NG");

var $sLaj5 = parcelRequire("sLaj5");

var $59mZx = parcelRequire("59mZx");

var $juiwS = parcelRequire("juiwS");

var $3sytP = parcelRequire("3sytP");

var $eaFJs = parcelRequire("eaFJs");

var $9lhjy = parcelRequire("9lhjy");
const $b6014b2d4bf32573$export$8a57bda01657743f = (0, $8nd05.default)({}, (0, $9lhjy.default), {
    cell: (0, $6X2NG.GridCell),
    skeletonCell: (0, $etLiE.GridSkeletonCell),
    columnHeaderFilterIconButton: (0, $k8xn5.GridColumnHeaderFilterIconButton),
    columnHeaderSortIcon: (0, $960Cz.GridColumnHeaderSortIcon),
    columnMenu: (0, $59mZx.GridColumnMenu),
    columnHeaders: (0, $sLaj5.GridColumnHeaders),
    detailPanels: (0, $juiwS.GridDetailPanels),
    footer: (0, $jIkp9.GridFooter),
    footerRowCount: (0, $l3iPY.GridRowCount),
    toolbar: null,
    pinnedRows: (0, $3sytP.GridPinnedRows),
    loadingOverlay: (0, $4YSVE.GridLoadingOverlay),
    noResultsOverlay: (0, $eaFJs.GridNoResultsOverlay),
    noRowsOverlay: (0, $28JSg.GridNoRowsOverlay),
    pagination: (0, $fuqu4.GridPagination),
    filterPanel: (0, $kWNEF.GridFilterPanel),
    columnsPanel: (0, $l98cE.GridColumnsPanel),
    columnsManagement: (0, $4ix5g.GridColumnsManagement),
    panel: (0, $kfa8b.GridPanel),
    row: (0, $kWPQR.GridRow)
});

});
parcelRegister("k8xn5", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderFilterIconButton", () => $ea8e70d6ac9b663f$export$35b5c67d267fafd7);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $auC0X = parcelRequire("auC0X");

var $5sOMZ = parcelRequire("5sOMZ");

var $6X2Yd = parcelRequire("6X2Yd");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $j4crP = parcelRequire("j4crP");

var $ayMG0 = parcelRequire("ayMG0");
const $ea8e70d6ac9b663f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'filterIcon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $ea8e70d6ac9b663f$export$35b5c67d267fafd7(props) {
    if (!props.counter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButton, (0, $8nd05.default)({}, props));
}
function $ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButton(props) {
    const { counter: counter, field: field, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $ea8e70d6ac9b663f$var$useUtilityClasses(ownerState);
    const labelId = (0, $auC0X.default)();
    const isOpen = (0, $5sOMZ.useGridSelectorV8)(apiRef, (0, $6X2Yd.gridPreferencePanelSelectorWithLabel), labelId);
    const panelId = (0, $auC0X.default)();
    const toggleFilter = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open: open, openedPanelValue: openedPanelValue } = (0, $6X2Yd.gridPreferencePanelStateSelector)(apiRef.current.state);
        if (open && openedPanelValue === (0, $3PCYS.GridPreferencePanelsValue).filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(undefined, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const iconButton = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
        id: labelId,
        onClick: toggleFilter,
        color: "default",
        "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-controls": isOpen ? panelId : undefined
    }, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $8nd05.default)({
        title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j4crP.GridIconButtonContainer), {
            children: [
                counter > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}

});
parcelRegister("j4crP", function(module, exports) {

$parcel$export(module.exports, "GridIconButtonContainer", () => $de180beae3cc7fe7$export$e67562d5b709404c);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $izOUK = parcelRequire("izOUK");

var $gJsNs = parcelRequire("gJsNs");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $de180beae3cc7fe7$var$_excluded = [
    "className"
];
const $de180beae3cc7fe7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'iconButtonContainer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $de180beae3cc7fe7$var$GridIconButtonContainerRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'IconButtonContainer',
    overridesResolver: (props, styles)=>styles.iconButtonContainer
})(()=>({
        display: 'flex',
        visibility: 'hidden',
        width: 0
    }));
const $de180beae3cc7fe7$export$e67562d5b709404c = (0, $gJsNs.forwardRef)(function GridIconButtonContainer(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $de180beae3cc7fe7$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $de180beae3cc7fe7$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($de180beae3cc7fe7$var$GridIconButtonContainerRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});

});


parcelRegister("960Cz", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderSortIcon", () => $69f527f26ff57ed6$export$80cd75c5dceceac6);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $j4crP = parcelRequire("j4crP");

var $ayMG0 = parcelRequire("ayMG0");
const $69f527f26ff57ed6$var$_excluded = [
    "direction",
    "index",
    "sortingOrder",
    "disabled",
    "className"
];
const $69f527f26ff57ed6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'sortButton'
        ],
        icon: [
            'sortIcon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $69f527f26ff57ed6$var$getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === 'asc') Icon = icons.columnSortedAscendingIcon;
    else if (direction === 'desc') Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $8nd05.default)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function $69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw(props) {
    const { direction: direction, index: index, sortingOrder: sortingOrder, disabled: disabled, className: className } = props, other = (0, $1En50.default)(props, $69f527f26ff57ed6$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $69f527f26ff57ed6$var$useUtilityClasses(ownerState);
    const iconElement = $69f527f26ff57ed6$var$getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
        tabIndex: -1,
        "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        size: "small",
        disabled: disabled,
        className: (0, $9QePP.default)(classes.root, className)
    }, rootProps.slotProps?.baseIconButton, other, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j4crP.GridIconButtonContainer), {
        children: [
            index != null && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, {
                badgeContent: index,
                color: "default",
                overlap: "circular",
                children: iconButton
            }),
            index == null && iconButton
        ]
    });
}
const $69f527f26ff57ed6$export$80cd75c5dceceac6 = /*#__PURE__*/ $acw62.memo($69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw);

});

parcelRegister("4ix5g", function(module, exports) {

$parcel$export(module.exports, "GridColumnsManagement", () => $321281a63dc6186b$export$3710e0bb3d9954d);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $2esSG = parcelRequire("2esSG");

var $d8seH = parcelRequire("d8seH");

var $iAtns = parcelRequire("iAtns");

var $dmljZ = parcelRequire("dmljZ");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $iYIN2 = parcelRequire("iYIN2");

var $btuMW = parcelRequire("btuMW");

var $ayMG0 = parcelRequire("ayMG0");
const $321281a63dc6186b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnsManagement'
        ],
        header: [
            'columnsManagementHeader'
        ],
        searchInput: [
            'columnsManagementSearchInput'
        ],
        footer: [
            'columnsManagementFooter'
        ],
        row: [
            'columnsManagementRow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $321281a63dc6186b$var$collator = new Intl.Collator();
function $321281a63dc6186b$export$3710e0bb3d9954d(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const searchInputRef = $acw62.useRef(null);
    const columns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnDefinitionsSelector));
    const initialColumnVisibilityModel = (0, $iYIN2.default)(()=>(0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef)).current;
    const columnVisibilityModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnVisibilityModelSelector));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [searchValue, setSearchValue] = $acw62.useState('');
    const classes = $321281a63dc6186b$var$useUtilityClasses(rootProps);
    const { sort: sort, searchPredicate: searchPredicate = (0, $btuMW.defaultSearchPredicate), autoFocusSearchField: autoFocusSearchField = true, disableShowHideToggle: disableShowHideToggle = false, disableResetButton: disableResetButton = false, toggleAllMode: toggleAllMode = 'all', getTogglableColumns: getTogglableColumns, searchInputProps: searchInputProps } = props;
    const isResetDisabled = $acw62.useMemo(()=>(0, $btuMW.checkColumnVisibilityModelsSame)(columnVisibilityModel, initialColumnVisibilityModel), [
        columnVisibilityModel,
        initialColumnVisibilityModel
    ]);
    const sortedColumns = $acw62.useMemo(()=>{
        switch(sort){
            case 'asc':
                return [
                    ...columns
                ].sort((a, b)=>$321281a63dc6186b$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            case 'desc':
                return [
                    ...columns
                ].sort((a, b)=>-$321281a63dc6186b$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const currentColumns = $acw62.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field: field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const toggleAllColumns = $acw62.useCallback((isVisible)=>{
        const currentModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const newModel = (0, $8nd05.default)({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        (toggleAllMode === 'filteredOnly' ? currentColumns : columns).forEach((col)=>{
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) // delete the key from the model instead of setting it to `true`
                delete newModel[col.field];
                else newModel[col.field] = false;
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns,
        toggleAllMode,
        currentColumns
    ]);
    const handleSearchValueChange = $acw62.useCallback((event)=>{
        setSearchValue(event.target.value);
    }, []);
    const hideableColumns = $acw62.useMemo(()=>currentColumns.filter((col)=>col.hideable), [
        currentColumns
    ]);
    const allHideableColumnsVisible = $acw62.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] == null || columnVisibilityModel[column.field] !== false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const allHideableColumnsHidden = $acw62.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] === false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const firstSwitchRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    const handleSearchReset = $acw62.useCallback(()=>{
        setSearchValue('');
        searchInputRef.current.focus();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementHeader, {
                className: classes.header,
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$SearchInput, (0, $8nd05.default)({
                    as: rootProps.slots.baseTextField,
                    ownerState: rootProps,
                    placeholder: apiRef.current.getLocaleText('columnsManagementSearchTitle'),
                    inputRef: searchInputRef,
                    className: classes.searchInput,
                    value: searchValue,
                    onChange: handleSearchValueChange,
                    variant: "outlined",
                    size: "small",
                    type: "search",
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputAdornment, {
                            position: "start",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterIcon, {})
                        }),
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
                            "aria-label": apiRef.current.getLocaleText('columnsManagementDeleteIconLabel'),
                            size: "small",
                            sx: [
                                searchValue ? {
                                    visibility: 'visible'
                                } : {
                                    visibility: 'hidden'
                                }
                            ],
                            tabIndex: -1,
                            onClick: handleSearchReset
                        }, rootProps.slotProps?.baseIconButton, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterClearIcon, {
                                fontSize: "small"
                            })
                        }))
                    },
                    inputProps: {
                        'aria-label': apiRef.current.getLocaleText('columnsManagementSearchTitle')
                    },
                    autoComplete: "off",
                    fullWidth: true
                }, rootProps.slotProps?.baseTextField, searchInputProps))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($321281a63dc6186b$var$GridColumnsManagementBody, {
                className: classes.root,
                ownerState: rootProps,
                children: [
                    currentColumns.map((column)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            className: classes.row,
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $8nd05.default)({
                                disabled: column.hideable === false,
                                checked: columnVisibilityModel[column.field] !== false,
                                onClick: toggleColumn,
                                name: column.field,
                                sx: {
                                    p: 0.5
                                },
                                inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined
                            }, rootProps.slotProps?.baseCheckbox)),
                            label: column.headerName || column.field
                        }, column.field)),
                    currentColumns.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementEmptyText, {
                        ownerState: rootProps,
                        children: apiRef.current.getLocaleText('columnsManagementNoColumns')
                    })
                ]
            }),
            (!disableShowHideToggle || !disableResetButton) && currentColumns.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)($321281a63dc6186b$var$GridColumnsManagementFooter, {
                ownerState: rootProps,
                className: classes.footer,
                children: [
                    !disableShowHideToggle ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $8nd05.default)({
                            disabled: hideableColumns.length === 0,
                            checked: allHideableColumnsVisible,
                            indeterminate: !allHideableColumnsVisible && !allHideableColumnsHidden,
                            onClick: ()=>toggleAllColumns(!allHideableColumnsVisible),
                            name: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                            sx: {
                                p: 0.5
                            }
                        }, rootProps.slotProps?.baseCheckbox)),
                        label: apiRef.current.getLocaleText('columnsManagementShowHideAllText')
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    !disableResetButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                        onClick: ()=>apiRef.current.setColumnVisibilityModel(initialColumnVisibilityModel),
                        disabled: isResetDisabled
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('columnsManagementReset')
                    })) : null
                ]
            }) : null
        ]
    });
}
const $321281a63dc6186b$var$GridColumnsManagementBody = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagement',
    overridesResolver: (props, styles)=>styles.columnsManagement
})(({ theme: theme })=>({
        padding: theme.spacing(0, 3, 1.5),
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        flex: '1 1',
        maxHeight: 400,
        alignItems: 'flex-start'
    }));
const $321281a63dc6186b$var$GridColumnsManagementHeader = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementHeader',
    overridesResolver: (props, styles)=>styles.columnsManagementHeader
})(({ theme: theme })=>({
        padding: theme.spacing(1.5, 3)
    }));
const $321281a63dc6186b$var$SearchInput = (0, $d8seH.default)((0, $iAtns.default), {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementSearchInput',
    overridesResolver: (props, styles)=>styles.columnsManagementSearchInput
})(({ theme: theme })=>({
        [`& .${(0, $dmljZ.default).root}`]: {
            padding: theme.spacing(0, 1.5, 0, 1.5)
        },
        [`& .${(0, $dmljZ.default).input}::-webkit-search-decoration,
  & .${(0, $dmljZ.default).input}::-webkit-search-cancel-button,
  & .${(0, $dmljZ.default).input}::-webkit-search-results-button,
  & .${(0, $dmljZ.default).input}::-webkit-search-results-decoration`]: {
            /* clears the 'X' icon from Chrome */ display: 'none'
        }
    }));
const $321281a63dc6186b$var$GridColumnsManagementFooter = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementFooter',
    overridesResolver: (props, styles)=>styles.columnsManagementFooter
})(({ theme: theme })=>({
        padding: theme.spacing(0.5, 1, 0.5, 3),
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: `1px solid ${theme.palette.divider}`
    }));
const $321281a63dc6186b$var$GridColumnsManagementEmptyText = (0, $d8seH.default)('div')(({ theme: theme })=>({
        padding: theme.spacing(0.5, 0),
        color: theme.palette.grey[500]
    }));

});
parcelRegister("btuMW", function(module, exports) {

$parcel$export(module.exports, "checkColumnVisibilityModelsSame", () => $85aa4911010e7c41$export$bfa7dd6f7574dd6b);
$parcel$export(module.exports, "defaultSearchPredicate", () => $85aa4911010e7c41$export$cbdfd8d51f352d2a);
const $85aa4911010e7c41$export$bfa7dd6f7574dd6b = (a, b)=>{
    // Filter `false` values only, as `true` and not having a key are the same
    const aFalseValues = new Set(Object.keys(a).filter((key)=>a[key] === false));
    const bFalseValues = new Set(Object.keys(b).filter((key)=>b[key] === false));
    if (aFalseValues.size !== bFalseValues.size) return false;
    let result = true;
    aFalseValues.forEach((key)=>{
        if (!bFalseValues.has(key)) result = false;
    });
    return result;
};
const $85aa4911010e7c41$export$cbdfd8d51f352d2a = (column, searchValue)=>(column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;

});


parcelRegister("l98cE", function(module, exports) {

$parcel$export(module.exports, "GridColumnsPanel", () => $f650cd2c2e66a414$export$39d43456ec96cf57);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $dQ4Fi = parcelRequire("dQ4Fi");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $f650cd2c2e66a414$export$39d43456ec96cf57(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dQ4Fi.GridPanelWrapper), (0, $8nd05.default)({}, props, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnsManagement, (0, $8nd05.default)({}, rootProps.slotProps?.columnsManagement))
    }));
}

});
parcelRegister("dQ4Fi", function(module, exports) {

$parcel$export(module.exports, "GridPanelWrapper", () => $a133c015d593f0ef$export$6a36e1ca07bd502c);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $kRwxQ = parcelRequire("kRwxQ");

var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $gJsNs = parcelRequire("gJsNs");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $a133c015d593f0ef$var$_excluded = [
    "className",
    "slotProps"
];
const $a133c015d593f0ef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $a133c015d593f0ef$var$GridPanelWrapperRoot = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelWrapper',
    overridesResolver: (props, styles)=>styles.panelWrapper
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '&:focus': {
        outline: 0
    }
});
const $a133c015d593f0ef$var$isEnabled = ()=>true;
const $a133c015d593f0ef$export$6a36e1ca07bd502c = (0, $gJsNs.forwardRef)(function GridPanelWrapper(props, ref) {
    const { className: className, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $a133c015d593f0ef$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $a133c015d593f0ef$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kRwxQ.default), (0, $8nd05.default)({
        open: true,
        disableEnforceFocus: true,
        isEnabled: $a133c015d593f0ef$var$isEnabled
    }, slotProps.TrapFocus, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a133c015d593f0ef$var$GridPanelWrapperRoot, (0, $8nd05.default)({
            tabIndex: -1,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: rootProps
        }, other, {
            ref: ref
        }))
    }));
});

});


parcelRegister("kWNEF", function(module, exports) {

$parcel$export(module.exports, "GridFilterPanel", () => $f3ffbde2bea4efe2$export$32c6e72be8ad862c);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $gJsNs = parcelRequire("gJsNs");

var $9jXuN = parcelRequire("9jXuN");

var $bDyDY = parcelRequire("bDyDY");

var $hbQyH = parcelRequire("hbQyH");

var $ip3sX = parcelRequire("ip3sX");

var $dQ4Fi = parcelRequire("dQ4Fi");

var $9De9Z = parcelRequire("9De9Z");

var $jDpXp = parcelRequire("jDpXp");

var $5sOMZ = parcelRequire("5sOMZ");

var $k278Q = parcelRequire("k278Q");

var $jQEEt = parcelRequire("jQEEt");

var $ayMG0 = parcelRequire("ayMG0");
const $f3ffbde2bea4efe2$var$_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const $f3ffbde2bea4efe2$export$7530149911670467 = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(Math.random() * 1e5)
    });
const $f3ffbde2bea4efe2$export$32c6e72be8ad862c = (0, $gJsNs.forwardRef)(function GridFilterPanel(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilterModelSelector));
    const filterableColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridFilterableColumnDefinitionsSelector));
    const filterableColumnsLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridFilterableColumnLookupSelector));
    const lastFilterRef = $acw62.useRef(null);
    const placeholderFilter = $acw62.useRef(null);
    const { logicOperators: logicOperators = [
        (0, $9jXuN.GridLogicOperator).And,
        (0, $9jXuN.GridLogicOperator).Or
    ], columnsSort: columnsSort, filterFormProps: filterFormProps, getColumnForNewFilter: getColumnForNewFilter, disableAddFilterButton: disableAddFilterButton = false, disableRemoveAllButton: disableRemoveAllButton = false } = props, other = (0, $1En50.default)(props, $f3ffbde2bea4efe2$var$_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = $acw62.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = $acw62.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && typeof getColumnForNewFilter === 'function') {
            // To allow override the column for default (first) filter
            const nextFieldName = getColumnForNewFilter({
                currentFilters: filterModel?.items || [],
                columns: filterableColumns
            });
            if (nextFieldName === null) return null;
            nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>colDef.filterOperators?.length);
        if (!nextColumnWithOperator) return null;
        return $f3ffbde2bea4efe2$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel?.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = $acw62.useCallback(()=>{
        if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== 'function') return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        // If no items are there in filterModel, we have to pass defaultFilter
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (nextColumnFieldName === null) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return $f3ffbde2bea4efe2$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = $acw62.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const { readOnlyFilters: readOnlyFilters, validFilters: validFilters } = $acw62.useMemo(()=>items.reduce((acc, item)=>{
            if (filterableColumnsLookup[item.field]) acc.validFilters.push(item);
            else acc.readOnlyFilters.push(item);
            return acc;
        }, {
            readOnlyFilters: [],
            validFilters: []
        }), [
        items,
        filterableColumnsLookup
    ]);
    const addNewFilter = $acw62.useCallback(()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    }, [
        apiRef,
        getNewFilter,
        items
    ]);
    const deleteFilter = $acw62.useCallback((item)=>{
        const shouldCloseFilterPanel = validFilters.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        validFilters.length
    ]);
    const handleRemoveAll = $acw62.useCallback(()=>{
        if (validFilters.length === 1 && validFilters[0].value === undefined) {
            apiRef.current.deleteFilterItem(validFilters[0]);
            return apiRef.current.hideFilterPanel();
        }
        return apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: readOnlyFilters
        }), 'removeAllFilterItems');
    }, [
        apiRef,
        readOnlyFilters,
        filterModel,
        validFilters
    ]);
    $acw62.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    $acw62.useEffect(()=>{
        if (validFilters.length > 0) lastFilterRef.current.focus();
    }, [
        validFilters.length
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dQ4Fi.GridPanelWrapper), (0, $8nd05.default)({}, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hbQyH.GridPanelContent), {
                children: [
                    readOnlyFilters.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9De9Z.GridFilterForm), (0, $8nd05.default)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: index > 0,
                            disableMultiFilterOperator: index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: null,
                            readOnly: true,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index : item.id)),
                    validFilters.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9De9Z.GridFilterForm), (0, $8nd05.default)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: readOnlyFilters.length + index > 0,
                            disableMultiFilterOperator: readOnlyFilters.length + index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: index === validFilters.length - 1 ? lastFilterRef : null,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index + readOnlyFilters.length : item.id))
                ]
            }),
            !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ip3sX.GridPanelFooter), {
                children: [
                    !disableAddFilterButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelAddFilter')
                    })) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    !disableRemoveAllButton && validFilters.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
                    })) : null
                ]
            }) : null
        ]
    }));
});

});
parcelRegister("hbQyH", function(module, exports) {

$parcel$export(module.exports, "GridPanelContent", () => $c83c3bce08f2b302$export$1b4102a66373332b);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $c83c3bce08f2b302$var$_excluded = [
    "className"
];
const $c83c3bce08f2b302$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $c83c3bce08f2b302$var$GridPanelContentRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelContent',
    overridesResolver: (props, styles)=>styles.panelContent
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1 1',
    maxHeight: 400
});
function $c83c3bce08f2b302$export$1b4102a66373332b(props) {
    const { className: className } = props, other = (0, $1En50.default)(props, $c83c3bce08f2b302$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $c83c3bce08f2b302$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c83c3bce08f2b302$var$GridPanelContentRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other));
}

});

parcelRegister("ip3sX", function(module, exports) {

$parcel$export(module.exports, "GridPanelFooter", () => $d65d401151f46b4c$export$18e44097a2744a);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $izOUK = parcelRequire("izOUK");

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $d65d401151f46b4c$var$_excluded = [
    "className"
];
const $d65d401151f46b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelFooter'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $d65d401151f46b4c$var$GridPanelFooterRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelFooter',
    overridesResolver: (props, styles)=>styles.panelFooter
})(({ theme: theme })=>({
        padding: theme.spacing(0.5),
        display: 'flex',
        justifyContent: 'space-between'
    }));
function $d65d401151f46b4c$export$18e44097a2744a(props) {
    const { className: className } = props, other = (0, $1En50.default)(props, $d65d401151f46b4c$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $d65d401151f46b4c$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d65d401151f46b4c$var$GridPanelFooterRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other));
}

});

parcelRegister("9De9Z", function(module, exports) {

$parcel$export(module.exports, "GridFilterForm", () => $7032bd7e5a458ec9$export$4c95feba7016dbe7);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");
var $auC0X = parcelRequire("auC0X");

var $d8seH = parcelRequire("d8seH");

var $9QePP = parcelRequire("9QePP");

var $gJsNs = parcelRequire("gJsNs");

var $jQEEt = parcelRequire("jQEEt");

var $k278Q = parcelRequire("k278Q");

var $5sOMZ = parcelRequire("5sOMZ");

var $9jXuN = parcelRequire("9jXuN");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $5z7Pl = parcelRequire("5z7Pl");

var $ayMG0 = parcelRequire("ayMG0");
const $7032bd7e5a458ec9$var$_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "readOnly",
    "children"
], $7032bd7e5a458ec9$var$_excluded2 = [
    "InputComponentProps"
];
const $7032bd7e5a458ec9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'filterForm'
        ],
        deleteIcon: [
            'filterFormDeleteIcon'
        ],
        logicOperatorInput: [
            'filterFormLogicOperatorInput'
        ],
        columnInput: [
            'filterFormColumnInput'
        ],
        operatorInput: [
            'filterFormOperatorInput'
        ],
        valueInput: [
            'filterFormValueInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $7032bd7e5a458ec9$var$GridFilterFormRoot = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterForm',
    overridesResolver: (props, styles)=>styles.filterForm
})(({ theme: theme })=>({
        display: 'flex',
        padding: theme.spacing(1)
    }));
const $7032bd7e5a458ec9$var$FilterFormDeleteIcon = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormDeleteIcon',
    overridesResolver: (_, styles)=>styles.filterFormDeleteIcon
})(({ theme: theme })=>({
        flexShrink: 0,
        justifyContent: 'flex-end',
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.2)
    }));
const $7032bd7e5a458ec9$var$FilterFormLogicOperatorInput = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormLogicOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormLogicOperatorInput
})({
    minWidth: 55,
    marginRight: 5,
    justifyContent: 'end'
});
const $7032bd7e5a458ec9$var$FilterFormColumnInput = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormColumnInput',
    overridesResolver: (_, styles)=>styles.filterFormColumnInput
})({
    width: 150
});
const $7032bd7e5a458ec9$var$FilterFormOperatorInput = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormOperatorInput
})({
    width: 150
});
const $7032bd7e5a458ec9$var$FilterFormValueInput = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormValueInput',
    overridesResolver: (_, styles)=>styles.filterFormValueInput
})({
    width: 190
});
const $7032bd7e5a458ec9$var$getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case (0, $9jXuN.GridLogicOperator).And:
            return 'filterPanelOperatorAnd';
        case (0, $9jXuN.GridLogicOperator).Or:
            return 'filterPanelOperatorOr';
        default:
            throw new Error('MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.');
    }
};
const $7032bd7e5a458ec9$var$getColumnLabel = (col)=>col.headerName || col.field;
const $7032bd7e5a458ec9$var$collator = new Intl.Collator();
const $7032bd7e5a458ec9$export$4c95feba7016dbe7 = (0, $gJsNs.forwardRef)(function GridFilterForm(props, ref) {
    const { item: item, hasMultipleFilters: hasMultipleFilters, deleteFilter: deleteFilter, applyFilterChanges: applyFilterChanges, showMultiFilterOperators: showMultiFilterOperators, disableMultiFilterOperator: disableMultiFilterOperator, applyMultiFilterOperatorChanges: applyMultiFilterOperatorChanges, focusElementRef: focusElementRef, logicOperators: logicOperators = [
        (0, $9jXuN.GridLogicOperator).And,
        (0, $9jXuN.GridLogicOperator).Or
    ], columnsSort: columnsSort, filterColumns: filterColumns, deleteIconProps: deleteIconProps = {}, logicOperatorInputProps: logicOperatorInputProps = {}, operatorInputProps: operatorInputProps = {}, columnInputProps: columnInputProps = {}, valueInputProps: valueInputProps = {}, readOnly: readOnly } = props, other = (0, $1En50.default)(props, $7032bd7e5a458ec9$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columnLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnLookupSelector));
    const filterableColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridFilterableColumnDefinitionsSelector));
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilterModelSelector));
    const columnSelectId = (0, $auC0X.default)();
    const columnSelectLabelId = (0, $auC0X.default)();
    const operatorSelectId = (0, $auC0X.default)();
    const operatorSelectLabelId = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $7032bd7e5a458ec9$var$useUtilityClasses(rootProps);
    const valueRef = $acw62.useRef(null);
    const filterSelectorRef = $acw62.useRef(null);
    const multiFilterOperator = filterModel.logicOperator ?? (0, $9jXuN.GridLogicOperator).And;
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseFormControlProps = rootProps.slotProps?.baseFormControl || {};
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isBaseSelectNative = baseSelectProps.native ?? false;
    const baseInputLabelProps = rootProps.slotProps?.baseInputLabel || {};
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const { InputComponentProps: InputComponentProps } = valueInputProps, valueInputPropsOther = (0, $1En50.default)(valueInputProps, $7032bd7e5a458ec9$var$_excluded2);
    const { filteredColumns: filteredColumns, selectedField: selectedField } = $acw62.useMemo(()=>{
        let itemField = item.field;
        // Yields a valid value if the current filter belongs to a column that is not filterable
        const selectedNonFilterableColumn = columnLookup[item.field].filterable === false ? columnLookup[item.field] : null;
        if (selectedNonFilterableColumn) return {
            filteredColumns: [
                selectedNonFilterableColumn
            ],
            selectedField: itemField
        };
        if (filterColumns === undefined || typeof filterColumns !== 'function') return {
            filteredColumns: filterableColumns,
            selectedField: itemField
        };
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: filterModel?.items || []
        });
        return {
            filteredColumns: filterableColumns.filter((column)=>{
                const isFieldIncluded = filteredFields.includes(column.field);
                if (column.field === item.field && !isFieldIncluded) itemField = undefined;
                return isFieldIncluded;
            }),
            selectedField: itemField
        };
    }, [
        filterColumns,
        filterModel?.items,
        filterableColumns,
        item.field,
        columnLookup
    ]);
    const sortedFilteredColumns = $acw62.useMemo(()=>{
        switch(columnsSort){
            case 'asc':
                return filteredColumns.sort((a, b)=>$7032bd7e5a458ec9$var$collator.compare($7032bd7e5a458ec9$var$getColumnLabel(a), $7032bd7e5a458ec9$var$getColumnLabel(b)));
            case 'desc':
                return filteredColumns.sort((a, b)=>-$7032bd7e5a458ec9$var$collator.compare($7032bd7e5a458ec9$var$getColumnLabel(a), $7032bd7e5a458ec9$var$getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = $acw62.useMemo(()=>{
        if (!item.operator || !currentColumn) return null;
        return currentColumn.filterOperators?.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = $acw62.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) // column did not change
        return;
        // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        // Erase filter value if the input component or filtered column type is modified
        const eraseFilterValue = !newOperator.InputComponent || newOperator.InputComponent !== currentOperator?.InputComponent || column.type !== currentColumn.type;
        let filterValue = eraseFilterValue ? undefined : item.value;
        // Check filter value against the new valueOptions
        if (column.type === 'singleSelect' && filterValue !== undefined) {
            const colDef = column;
            const valueOptions = (0, $5z7Pl.getValueOptions)(colDef);
            if (Array.isArray(filterValue)) filterValue = filterValue.filter((val)=>{
                return(// Only keep values that are in the new value options
                (0, $5z7Pl.getValueFromValueOptions)(val, valueOptions, colDef?.getOptionValue) !== undefined);
            });
            else if ((0, $5z7Pl.getValueFromValueOptions)(item.value, valueOptions, colDef?.getOptionValue) === undefined) // Reset the filter value if it is not in the new value options
            filterValue = undefined;
        }
        applyFilterChanges((0, $8nd05.default)({}, item, {
            field: field,
            operator: newOperator.value,
            value: filterValue
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = $acw62.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = currentColumn?.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !newOperator?.InputComponent || newOperator?.InputComponent !== currentOperator?.InputComponent;
        applyFilterChanges((0, $8nd05.default)({}, item, {
            operator: operator,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = $acw62.useCallback((event)=>{
        const logicOperator = event.target.value === (0, $9jXuN.GridLogicOperator).And.toString() ? (0, $9jXuN.GridLogicOperator).And : (0, $9jXuN.GridLogicOperator).Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        deleteFilter(item);
    };
    $acw62.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator?.InputComponent) valueRef?.current?.focus();
                else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7032bd7e5a458ec9$var$GridFilterFormRoot, (0, $8nd05.default)({
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormDeleteIcon, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, deleteIconProps, {
                className: (0, $9QePP.default)(classes.deleteIcon, baseFormControlProps.className, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
                    "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    onClick: handleDeleteFilter,
                    size: "small",
                    disabled: readOnly
                }, rootProps.slotProps?.baseIconButton, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormLogicOperatorInput, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, logicOperatorInputProps, {
                sx: [
                    hasLogicOperatorColumn ? {
                        display: 'flex'
                    } : {
                        display: 'none'
                    },
                    showMultiFilterOperators ? {
                        visibility: 'visible'
                    } : {
                        visibility: 'hidden'
                    },
                    baseFormControlProps.sx,
                    logicOperatorInputProps.sx
                ],
                className: (0, $9QePP.default)(classes.logicOperatorInput, baseFormControlProps.className, logicOperatorInputProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                    inputProps: {
                        'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
                    },
                    value: multiFilterOperator ?? '',
                    onChange: changeLogicOperator,
                    disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
                    native: isBaseSelectNative
                }, rootProps.slotProps?.baseSelect, {
                    children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                            native: isBaseSelectNative,
                            key: logicOperator.toString(),
                            value: logicOperator.toString()
                        }), apiRef.current.getLocaleText($7032bd7e5a458ec9$var$getLogicOperatorLocaleKey(logicOperator))))
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7032bd7e5a458ec9$var$FilterFormColumnInput, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, columnInputProps, {
                className: (0, $9QePP.default)(classes.columnInput, baseFormControlProps.className, columnInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputLabel, (0, $8nd05.default)({}, baseInputLabelProps, {
                        htmlFor: columnSelectId,
                        id: columnSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelColumns')
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                        labelId: columnSelectLabelId,
                        id: columnSelectId,
                        label: apiRef.current.getLocaleText('filterPanelColumns'),
                        value: selectedField ?? '',
                        onChange: changeColumn,
                        native: isBaseSelectNative,
                        disabled: readOnly
                    }, rootProps.slotProps?.baseSelect, {
                        children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: col.field,
                                value: col.field
                            }), $7032bd7e5a458ec9$var$getColumnLabel(col)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7032bd7e5a458ec9$var$FilterFormOperatorInput, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, operatorInputProps, {
                className: (0, $9QePP.default)(classes.operatorInput, baseFormControlProps.className, operatorInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputLabel, (0, $8nd05.default)({}, baseInputLabelProps, {
                        htmlFor: operatorSelectId,
                        id: operatorSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelOperator')
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                        labelId: operatorSelectLabelId,
                        label: apiRef.current.getLocaleText('filterPanelOperator'),
                        id: operatorSelectId,
                        value: item.operator,
                        onChange: changeOperator,
                        native: isBaseSelectNative,
                        inputRef: filterSelectorRef,
                        disabled: readOnly
                    }, rootProps.slotProps?.baseSelect, {
                        children: currentColumn?.filterOperators?.map((operator)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: operator.value,
                                value: operator.value
                            }), operator.label || apiRef.current.getLocaleText(`filterOperator${(0, $gxvzd.default)(operator.value)}`)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormValueInput, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, valueInputPropsOther, {
                className: (0, $9QePP.default)(classes.valueInput, baseFormControlProps.className, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator?.InputComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(currentOperator.InputComponent, (0, $8nd05.default)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef,
                    disabled: readOnly
                }, currentOperator.InputComponentProps, InputComponentProps), item.field) : null
            }))
        ]
    }));
});

});


parcelRegister("jIkp9", function(module, exports) {

$parcel$export(module.exports, "GridFooter", () => $e5a1f44ff53ee1a6$export$6ef0bfefb022d11e);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $gJsNs = parcelRequire("gJsNs");

var $5sOMZ = parcelRequire("5sOMZ");

var $goCyd = parcelRequire("goCyd");

var $av74L = parcelRequire("av74L");

var $k278Q = parcelRequire("k278Q");

var $bDyDY = parcelRequire("bDyDY");

var $fNKx6 = parcelRequire("fNKx6");

var $jgcq7 = parcelRequire("jgcq7");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $e5a1f44ff53ee1a6$export$6ef0bfefb022d11e = (0, $gJsNs.forwardRef)(function GridFooter(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridTopLevelRowCountSelector));
    const selectedRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $av74L.selectedGridRowsCountSelector));
    const visibleTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilteredTopLevelRowCountSelector));
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fNKx6.GridSelectedRowCount), {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.footerRowCount, (0, $8nd05.default)({}, rootProps.slotProps?.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    })) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pagination, (0, $8nd05.default)({}, rootProps.slotProps?.pagination));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $jgcq7.GridFooterContainer), (0, $8nd05.default)({}, props, {
        ref: ref,
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});

});
parcelRegister("fNKx6", function(module, exports) {

$parcel$export(module.exports, "GridSelectedRowCount", () => $b80f871a1017d664$export$e4c9f87515ca4b49);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $izOUK = parcelRequire("izOUK");

var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $b80f871a1017d664$var$_excluded = [
    "className",
    "selectedRowCount"
];
const $b80f871a1017d664$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'selectedRowCount'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $b80f871a1017d664$var$GridSelectedRowCountRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'SelectedRowCount',
    overridesResolver: (props, styles)=>styles.selectedRowCount
})(({ theme: theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2),
        visibility: 'hidden',
        width: 0,
        height: 0,
        [theme.breakpoints.up('sm')]: {
            visibility: 'visible',
            width: 'auto',
            height: 'auto'
        }
    }));
const $b80f871a1017d664$export$e4c9f87515ca4b49 = (0, $gJsNs.forwardRef)(function GridSelectedRowCount(props, ref) {
    const { className: className, selectedRowCount: selectedRowCount } = props, other = (0, $1En50.default)(props, $b80f871a1017d664$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ownerState = (0, $jDpXp.useGridRootProps)();
    const classes = $b80f871a1017d664$var$useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b80f871a1017d664$var$GridSelectedRowCountRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: rowSelectedText
    }));
});

});

parcelRegister("jgcq7", function(module, exports) {

$parcel$export(module.exports, "GridFooterContainer", () => $e05925554f74d684$export$dc81d5e0847a9805);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $izOUK = parcelRequire("izOUK");

var $gJsNs = parcelRequire("gJsNs");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $e05925554f74d684$var$_excluded = [
    "className"
];
const $e05925554f74d684$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'footerContainer',
            'withBorderColor'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $e05925554f74d684$var$GridFooterContainerRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterContainer',
    overridesResolver: (props, styles)=>styles.footerContainer
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 52,
    borderTop: '1px solid'
});
const $e05925554f74d684$export$dc81d5e0847a9805 = (0, $gJsNs.forwardRef)(function GridFooterContainer(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $e05925554f74d684$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $e05925554f74d684$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e05925554f74d684$var$GridFooterContainerRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});

});


parcelRegister("4YSVE", function(module, exports) {

$parcel$export(module.exports, "GridLoadingOverlay", () => $3a075fc4ca1dcd85$export$69e47a4ea5ffa191);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $1lfQl = parcelRequire("1lfQl");

var $2cPwN = parcelRequire("2cPwN");

var $gJsNs = parcelRequire("gJsNs");

var $809Ep = parcelRequire("809Ep");

var $hZJKl = parcelRequire("hZJKl");

var $bDyDY = parcelRequire("bDyDY");

var $goCyd = parcelRequire("goCyd");
var $5sOMZ = parcelRequire("5sOMZ");

var $ayMG0 = parcelRequire("ayMG0");
const $3a075fc4ca1dcd85$var$_excluded = [
    "variant",
    "noRowsVariant",
    "style"
];
const $3a075fc4ca1dcd85$var$LOADING_VARIANTS = {
    'circular-progress': {
        component: (0, $2cPwN.default),
        style: {}
    },
    'linear-progress': {
        component: (0, $1lfQl.default),
        style: {
            display: 'block'
        }
    },
    skeleton: {
        component: (0, $hZJKl.GridSkeletonLoadingOverlay),
        style: {
            display: 'block'
        }
    }
};
const $3a075fc4ca1dcd85$export$69e47a4ea5ffa191 = (0, $gJsNs.forwardRef)(function GridLoadingOverlay(props, ref) {
    const { variant: variant = 'circular-progress', noRowsVariant: noRowsVariant = 'circular-progress', style: style } = props, other = (0, $1En50.default)(props, $3a075fc4ca1dcd85$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rowsCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowCountSelector));
    const activeVariant = $3a075fc4ca1dcd85$var$LOADING_VARIANTS[rowsCount === 0 ? noRowsVariant : variant];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $809Ep.GridOverlay), (0, $8nd05.default)({
        style: (0, $8nd05.default)({}, activeVariant.style, style)
    }, other, {
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(activeVariant.component, {})
    }));
});

});
parcelRegister("1lfQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fa40ac3f678fedb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $bJeVA = parcelRequire("bJeVA");

var $jjlaj = parcelRequire("jjlaj");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $lJgAB = parcelRequire("lJgAB");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0fa40ac3f678fedb$var$TRANSITION_DURATION = 4; // seconds
const $0fa40ac3f678fedb$var$indeterminate1Keyframe = (0, $jjlaj.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $0fa40ac3f678fedb$var$indeterminate1Animation = typeof $0fa40ac3f678fedb$var$indeterminate1Keyframe !== 'string' ? (0, $jjlaj.css)`
        animation: ${$0fa40ac3f678fedb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $0fa40ac3f678fedb$var$indeterminate2Keyframe = (0, $jjlaj.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $0fa40ac3f678fedb$var$indeterminate2Animation = typeof $0fa40ac3f678fedb$var$indeterminate2Keyframe !== 'string' ? (0, $jjlaj.css)`
        animation: ${$0fa40ac3f678fedb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $0fa40ac3f678fedb$var$bufferKeyframe = (0, $jjlaj.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $0fa40ac3f678fedb$var$bufferAnimation = typeof $0fa40ac3f678fedb$var$bufferKeyframe !== 'string' ? (0, $jjlaj.css)`
        animation: ${$0fa40ac3f678fedb$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $0fa40ac3f678fedb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $jTnBY.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $jTnBY.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $jTnBY.default)(color)}`,
            variant === 'buffer' && `color${(0, $jTnBY.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lJgAB.getLinearProgressUtilityClass), classes);
};
const $0fa40ac3f678fedb$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $8gMkr.lighten)(theme.palette[color].main, 0.62) : (0, $8gMkr.darken)(theme.palette[color].main, 0.5);
};
const $0fa40ac3f678fedb$var$LinearProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $0fa40ac3f678fedb$var$LinearProgressDashed = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>{
                const backgroundColor = $0fa40ac3f678fedb$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $0fa40ac3f678fedb$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$0fa40ac3f678fedb$var$bufferKeyframe} 3s infinite linear`
});
const $0fa40ac3f678fedb$var$LinearProgressBar1 = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $jTnBY.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $0fa40ac3f678fedb$var$indeterminate1Animation || {
                    animation: `${$0fa40ac3f678fedb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $0fa40ac3f678fedb$var$LinearProgressBar2 = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $jTnBY.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, color),
                        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $0fa40ac3f678fedb$var$indeterminate2Animation || {
                    animation: `${$0fa40ac3f678fedb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $0fa40ac3f678fedb$var$LinearProgress = /*#__PURE__*/ $acw62.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $0fa40ac3f678fedb$var$useUtilityClasses(ownerState);
    const isRtl = (0, $bJeVA.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0fa40ac3f678fedb$var$LinearProgressRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $0fa40ac3f678fedb$export$2e2bcd8739ae039 = $0fa40ac3f678fedb$var$LinearProgress;

});
parcelRegister("lJgAB", function(module, exports) {

$parcel$export(module.exports, "getLinearProgressUtilityClass", () => $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $4Cod0.default)('MuiLinearProgress', slot);
}
const $fd1aab3db3503e90$var$linearProgressClasses = (0, $beCSm.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $fd1aab3db3503e90$export$2e2bcd8739ae039 = $fd1aab3db3503e90$var$linearProgressClasses;

});


parcelRegister("809Ep", function(module, exports) {

$parcel$export(module.exports, "GridOverlay", () => $0180de2e65ebf290$export$1c41ff9dbe11e487);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $izOUK = parcelRequire("izOUK");

var $gJsNs = parcelRequire("gJsNs");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $0180de2e65ebf290$var$_excluded = [
    "className"
];
const $0180de2e65ebf290$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlay'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $0180de2e65ebf290$var$GridOverlayRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Overlay',
    overridesResolver: (_, styles)=>styles.overlay
})({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--unstable_DataGrid-overlayBackground)'
});
const $0180de2e65ebf290$export$1c41ff9dbe11e487 = (0, $gJsNs.forwardRef)(function GridOverlay(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $0180de2e65ebf290$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $0180de2e65ebf290$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0180de2e65ebf290$var$GridOverlayRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});

});

parcelRegister("hZJKl", function(module, exports) {

$parcel$export(module.exports, "GridSkeletonLoadingOverlay", () => $d19b9e7dfc56bad3$export$123bd4ede2d9ef98);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $izOUK = parcelRequire("izOUK");

var $3qSdM = parcelRequire("3qSdM");

var $8Indx = parcelRequire("8Indx");

var $9uEev = parcelRequire("9uEev");

var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $jQEEt = parcelRequire("jQEEt");
var $61HyH = parcelRequire("61HyH");
var $eFF1m = parcelRequire("eFF1m");
var $5sOMZ = parcelRequire("5sOMZ");

var $jZka4 = parcelRequire("jZka4");

var $61HyH = parcelRequire("61HyH");

var $5H1vo = parcelRequire("5H1vo");

var $jWPPy = parcelRequire("jWPPy");

var $lbNvN = parcelRequire("lbNvN");

var $KtEo5 = parcelRequire("KtEo5");

var $cunsT = parcelRequire("cunsT");

var $eV2As = parcelRequire("eV2As");

var $kpwEY = parcelRequire("kpwEY");

var $ayMG0 = parcelRequire("ayMG0");
const $d19b9e7dfc56bad3$var$SkeletonOverlay = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'SkeletonLoadingOverlay',
    overridesResolver: (props, styles)=>styles.skeletonLoadingOverlay
})({
    minWidth: '100%',
    width: 'max-content',
    // prevents overflow: clip; cutting off the x axis
    height: '100%',
    overflow: 'clip' // y axis is hidden while the x axis is allowed to overflow
});
const $d19b9e7dfc56bad3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'skeletonLoadingOverlay'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $d19b9e7dfc56bad3$var$getColIndex = (el)=>parseInt(el.getAttribute('data-colindex'), 10);
const $d19b9e7dfc56bad3$export$123bd4ede2d9ef98 = (0, $gJsNs.forwardRef)(function GridSkeletonLoadingOverlay(props, forwardedRef) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { slots: slots } = rootProps;
    const isRtl = (0, $9uEev.useRtl)();
    const classes = $d19b9e7dfc56bad3$var$useUtilityClasses({
        classes: rootProps.classes
    });
    const ref = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, forwardedRef);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const dimensions = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridDimensionsSelector));
    const viewportHeight = dimensions?.viewportInnerSize.height ?? 0;
    const skeletonRowsCount = Math.ceil(viewportHeight / dimensions.rowHeight);
    const totalWidth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridColumnsTotalWidthSelector));
    const positions = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnPositionsSelector));
    const inViewportCount = $acw62.useMemo(()=>positions.filter((value)=>value <= totalWidth).length, [
        totalWidth,
        positions
    ]);
    const allVisibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisibleColumnDefinitionsSelector));
    const columns = $acw62.useMemo(()=>allVisibleColumns.slice(0, inViewportCount), [
        allVisibleColumns,
        inViewportCount
    ]);
    const pinnedColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisiblePinnedColumnDefinitionsSelector));
    const getPinnedPosition = $acw62.useCallback((field)=>{
        if (pinnedColumns.left.findIndex((col)=>col.field === field) !== -1) return (0, $jZka4.PinnedColumnPosition).LEFT;
        if (pinnedColumns.right.findIndex((col)=>col.field === field) !== -1) return (0, $jZka4.PinnedColumnPosition).RIGHT;
        return undefined;
    }, [
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const children = $acw62.useMemo(()=>{
        const array = [];
        for(let i = 0; i < skeletonRowsCount; i += 1){
            const rowCells = [];
            for(let colIndex = 0; colIndex < columns.length; colIndex += 1){
                const column = columns[colIndex];
                const pinnedPosition = getPinnedPosition(column.field);
                const isPinnedLeft = pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT;
                const isPinnedRight = pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT;
                const pinnedSide = (0, $eV2As.rtlFlipSide)(pinnedPosition, isRtl);
                const sectionLength = pinnedSide ? pinnedColumns[pinnedSide].length // pinned section
                 : columns.length - pinnedColumns.left.length - pinnedColumns.right.length; // middle section
                const sectionIndex = pinnedSide ? pinnedColumns[pinnedSide].findIndex((col)=>col.field === column.field) // pinned section
                 : colIndex - pinnedColumns.left.length; // middle section
                const scrollbarWidth = dimensions.hasScrollY ? dimensions.scrollbarSize : 0;
                const pinnedStyle = (0, $kpwEY.attachPinnedStyle)({}, isRtl, pinnedPosition, (0, $jWPPy.getPinnedCellOffset)(pinnedPosition, column.computedWidth, colIndex, positions, dimensions.columnsTotalWidth, scrollbarWidth));
                const gridHasFiller = dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width;
                const showRightBorder = (0, $lbNvN.shouldCellShowRightBorder)(pinnedPosition, sectionIndex, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller);
                const showLeftBorder = (0, $lbNvN.shouldCellShowLeftBorder)(pinnedPosition, sectionIndex);
                const isLastColumn = colIndex === columns.length - 1;
                const isFirstPinnedRight = isPinnedRight && sectionIndex === 0;
                const hasFillerBefore = isFirstPinnedRight && gridHasFiller;
                const hasFillerAfter = isLastColumn && !isFirstPinnedRight && gridHasFiller;
                const expandedWidth = dimensions.viewportOuterSize.width - dimensions.columnsTotalWidth;
                const emptyCellWidth = Math.max(0, expandedWidth);
                const emptyCell = /*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
                    width: emptyCellWidth,
                    empty: true
                }, `skeleton-filler-column-${i}`);
                const hasScrollbarFiller = isLastColumn && scrollbarWidth !== 0;
                if (hasFillerBefore) rowCells.push(emptyCell);
                rowCells.push(/*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
                    field: column.field,
                    type: column.type,
                    align: column.align,
                    width: "var(--width)",
                    height: dimensions.rowHeight,
                    "data-colindex": colIndex,
                    className: (0, $9QePP.default)(isPinnedLeft && (0, $5H1vo.gridClasses)['cell--pinnedLeft'], isPinnedRight && (0, $5H1vo.gridClasses)['cell--pinnedRight'], showRightBorder && (0, $5H1vo.gridClasses)['cell--withRightBorder'], showLeftBorder && (0, $5H1vo.gridClasses)['cell--withLeftBorder']),
                    style: (0, $8nd05.default)({
                        '--width': `${column.computedWidth}px`
                    }, pinnedStyle)
                }, `skeleton-column-${i}-${column.field}`));
                if (hasFillerAfter) rowCells.push(emptyCell);
                if (hasScrollbarFiller) rowCells.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cunsT.GridScrollbarFillerCell), {
                    pinnedRight: pinnedColumns.right.length > 0
                }, `skeleton-scrollbar-filler-${i}`));
            }
            array.push(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)((0, $5H1vo.gridClasses).row, (0, $5H1vo.gridClasses).rowSkeleton, i === 0 && (0, $5H1vo.gridClasses)['row--firstVisible']),
                children: rowCells
            }, `skeleton-row-${i}`));
        }
        return array;
    }, [
        slots,
        columns,
        pinnedColumns,
        skeletonRowsCount,
        rootProps.showCellVerticalBorder,
        dimensions,
        positions,
        getPinnedPosition,
        isRtl
    ]);
    // Sync the column resize of the overlay columns with the grid
    const handleColumnResize = (params)=>{
        const { colDef: colDef, width: width } = params;
        const cells = ref.current?.querySelectorAll(`[data-field="${(0, $KtEo5.escapeOperandAttributeSelector)(colDef.field)}"]`);
        if (!cells) throw new Error('MUI X: Expected skeleton cells to be defined with `data-field` attribute.');
        const resizedColIndex = columns.findIndex((col)=>col.field === colDef.field);
        const pinnedPosition = getPinnedPosition(colDef.field);
        const isPinnedLeft = pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT;
        const isPinnedRight = pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT;
        const currentWidth = getComputedStyle(cells[0]).getPropertyValue('--width');
        const delta = parseInt(currentWidth, 10) - width;
        if (cells) cells.forEach((element)=>{
            element.style.setProperty('--width', `${width}px`);
        });
        if (isPinnedLeft) {
            const pinnedCells = ref.current?.querySelectorAll(`.${(0, $5H1vo.gridClasses)['cell--pinnedLeft']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $d19b9e7dfc56bad3$var$getColIndex(element);
                if (colIndex > resizedColIndex) element.style.left = `${parseInt(getComputedStyle(element).left, 10) - delta}px`;
            });
        }
        if (isPinnedRight) {
            const pinnedCells = ref.current?.querySelectorAll(`.${(0, $5H1vo.gridClasses)['cell--pinnedRight']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $d19b9e7dfc56bad3$var$getColIndex(element);
                if (colIndex < resizedColIndex) element.style.right = `${parseInt(getComputedStyle(element).right, 10) + delta}px`;
            });
        }
    };
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResize', handleColumnResize);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d19b9e7dfc56bad3$var$SkeletonOverlay, (0, $8nd05.default)({
        className: classes.root
    }, props, {
        ref: handleRef,
        children: children
    }));
});

});
parcelRegister("jWPPy", function(module, exports) {

$parcel$export(module.exports, "getPinnedCellOffset", () => $e85ba38bf3b586f5$export$29949f0e748b68b8);

var $jZka4 = parcelRequire("jZka4");
const $e85ba38bf3b586f5$export$29949f0e748b68b8 = (pinnedPosition, computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth)=>{
    let pinnedOffset;
    switch(pinnedPosition){
        case (0, $jZka4.PinnedColumnPosition).LEFT:
            pinnedOffset = columnPositions[columnIndex];
            break;
        case (0, $jZka4.PinnedColumnPosition).RIGHT:
            pinnedOffset = columnsTotalWidth - columnPositions[columnIndex] - computedWidth + scrollbarWidth;
            break;
        default:
            pinnedOffset = undefined;
            break;
    }
    return pinnedOffset;
};

});

parcelRegister("lbNvN", function(module, exports) {

$parcel$export(module.exports, "shouldCellShowRightBorder", () => $f6d1081691c64c11$export$646c95cff4790794);
$parcel$export(module.exports, "shouldCellShowLeftBorder", () => $f6d1081691c64c11$export$c01fd18a9a3d03b3);

var $jZka4 = parcelRequire("jZka4");
const $f6d1081691c64c11$export$646c95cff4790794 = (pinnedPosition, indexInSection, sectionLength, showCellVerticalBorderRootProp, gridHasFiller)=>{
    const isSectionLastCell = indexInSection === sectionLength - 1;
    if (pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT && isSectionLastCell) return true;
    if (showCellVerticalBorderRootProp) {
        if (pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT) return true;
        if (pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT) return !isSectionLastCell;
        // pinnedPosition === undefined, middle section
        return !isSectionLastCell || gridHasFiller;
    }
    return false;
};
const $f6d1081691c64c11$export$c01fd18a9a3d03b3 = (pinnedPosition, indexInSection)=>{
    return pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT && indexInSection === 0;
};

});

parcelRegister("cunsT", function(module, exports) {

$parcel$export(module.exports, "GridScrollbarFillerCell", () => $917a7d0f9d31e9dd$export$69d401a304b172b5);
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $917a7d0f9d31e9dd$var$classes = {
    root: (0, $5H1vo.gridClasses).scrollbarFiller,
    header: (0, $5H1vo.gridClasses)['scrollbarFiller--header'],
    borderTop: (0, $5H1vo.gridClasses)['scrollbarFiller--borderTop'],
    borderBottom: (0, $5H1vo.gridClasses)['scrollbarFiller--borderBottom'],
    pinnedRight: (0, $5H1vo.gridClasses)['scrollbarFiller--pinnedRight']
};
function $917a7d0f9d31e9dd$export$69d401a304b172b5({ header: header, borderTop: borderTop = true, borderBottom: borderBottom, pinnedRight: pinnedRight }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "presentation",
        className: (0, $9QePP.default)($917a7d0f9d31e9dd$var$classes.root, header && $917a7d0f9d31e9dd$var$classes.header, borderTop && $917a7d0f9d31e9dd$var$classes.borderTop, borderBottom && $917a7d0f9d31e9dd$var$classes.borderBottom, pinnedRight && $917a7d0f9d31e9dd$var$classes.pinnedRight)
    });
}

});

parcelRegister("eV2As", function(module, exports) {

$parcel$export(module.exports, "rtlFlipSide", () => $02cd8e055a355186$export$5859c8b8d085a0c0);

var $jZka4 = parcelRequire("jZka4");
const $02cd8e055a355186$export$5859c8b8d085a0c0 = (position, isRtl)=>{
    if (!position) return undefined;
    if (!isRtl) {
        if (position === (0, $jZka4.PinnedColumnPosition).LEFT) return 'left';
        if (position === (0, $jZka4.PinnedColumnPosition).RIGHT) return 'right';
    } else {
        if (position === (0, $jZka4.PinnedColumnPosition).LEFT) return 'right';
        if (position === (0, $jZka4.PinnedColumnPosition).RIGHT) return 'left';
    }
    return undefined;
};

});

parcelRegister("kpwEY", function(module, exports) {

$parcel$export(module.exports, "attachPinnedStyle", () => $edbf7a081e32bed0$export$175ada5333288b48);

var $eV2As = parcelRequire("eV2As");
function $edbf7a081e32bed0$export$175ada5333288b48(style, isRtl, pinnedPosition, pinnedOffset) {
    const side = (0, $eV2As.rtlFlipSide)(pinnedPosition, isRtl);
    if (!side || pinnedOffset === undefined) return style;
    style[side] = pinnedOffset;
    return style;
}

});



parcelRegister("28JSg", function(module, exports) {

$parcel$export(module.exports, "GridNoRowsOverlay", () => $18efe9c687188074$export$a25f04494ce53510);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $809Ep = parcelRequire("809Ep");

var $ayMG0 = parcelRequire("ayMG0");
const $18efe9c687188074$export$a25f04494ce53510 = (0, $gJsNs.forwardRef)(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $809Ep.GridOverlay), (0, $8nd05.default)({}, props, {
        ref: ref,
        children: noRowsLabel
    }));
});

});

parcelRegister("fuqu4", function(module, exports) {

$parcel$export(module.exports, "GridPagination", () => $b46e33860b6061fb$export$fa9a503101f8d472);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");


var $kBtCg = parcelRequire("kBtCg");
var $inBkn = parcelRequire("inBkn");

var $gJsNs = parcelRequire("gJsNs");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $gPWuj = parcelRequire("gPWuj");

var $ayMG0 = parcelRequire("ayMG0");
const $b46e33860b6061fb$var$GridPaginationRoot = (0, $d8seH.default)((0, $kBtCg.default))(({ theme: theme })=>({
        maxHeight: 'calc(100% + 1px)',
        // border width
        flexGrow: 1,
        [`& .${(0, $inBkn.default).selectLabel}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block'
            }
        },
        [`& .${(0, $inBkn.default).input}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'inline-flex'
            }
        }
    }));
const $b46e33860b6061fb$var$wrapLabelDisplayedRows = (labelDisplayedRows, estimated)=>{
    return ({ from: from, to: to, count: count, page: page })=>labelDisplayedRows({
            from: from,
            to: to,
            count: count,
            page: page,
            estimated: estimated
        });
};
const $b46e33860b6061fb$var$defaultLabelDisplayedRows = ({ from: from, to: to, count: count, estimated: estimated })=>{
    if (!estimated) return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${estimated > to ? estimated : to}`}`;
};
// A mutable version of a readonly array.
const $b46e33860b6061fb$export$fa9a503101f8d472 = (0, $gJsNs.forwardRef)(function GridPagination(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const paginationModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationModelSelector));
    const rowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationRowCountSelector));
    const pageCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPageCountSelector));
    const { paginationMode: paginationMode, loading: loading, estimatedRowCount: estimatedRowCount } = rootProps;
    const computedProps = $acw62.useMemo(()=>{
        if (rowCount === -1 && paginationMode === 'server' && loading) return {
            backIconButtonProps: {
                disabled: true
            },
            nextIconButtonProps: {
                disabled: true
            }
        };
        return {};
    }, [
        loading,
        paginationMode,
        rowCount
    ]);
    const lastPage = $acw62.useMemo(()=>Math.max(0, pageCount - 1), [
        pageCount
    ]);
    const computedPage = $acw62.useMemo(()=>{
        if (rowCount === -1) return paginationModel.page;
        return paginationModel.page <= lastPage ? paginationModel.page : lastPage;
    }, [
        lastPage,
        paginationModel.page,
        rowCount
    ]);
    const handlePageSizeChange = $acw62.useCallback((event)=>{
        const pageSize = Number(event.target.value);
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = $acw62.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if (typeof option === 'number') {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    const locales = apiRef.current.getLocaleText('MuiTablePagination');
    const wrappedLabelDisplayedRows = $b46e33860b6061fb$var$wrapLabelDisplayedRows(locales.labelDisplayedRows || $b46e33860b6061fb$var$defaultLabelDisplayedRows, estimatedRowCount);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46e33860b6061fb$var$GridPaginationRoot, (0, $8nd05.default)({
        component: "div",
        count: rowCount,
        page: computedPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange
    }, computedProps, locales, {
        labelDisplayedRows: wrappedLabelDisplayedRows
    }, props, {
        ref: ref
    }));
});

});
parcelRegister("kBtCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $effe3c7e7b91170d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $95gUw = parcelRequire("95gUw");

var $2iAqv = parcelRequire("2iAqv");

var $cX7V2 = parcelRequire("cX7V2");

var $elyLx = parcelRequire("elyLx");

var $kyRsi = parcelRequire("kyRsi");

var $dLLxV = parcelRequire("dLLxV");

var $5A6d3 = parcelRequire("5A6d3");

var $inBkn = parcelRequire("inBkn");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $effe3c7e7b91170d$var$_InputBase;
const $effe3c7e7b91170d$var$TablePaginationRoot = (0, $d8seH.default)((0, $elyLx.default), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $aeD7H.default)(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    })));
const $effe3c7e7b91170d$var$TablePaginationToolbar = (0, $d8seH.default)((0, $kyRsi.default), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $inBkn.default).actions}`]: styles.actions,
            ...styles.toolbar
        })
})((0, $aeD7H.default)(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $inBkn.default).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    })));
const $effe3c7e7b91170d$var$TablePaginationSpacer = (0, $d8seH.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $effe3c7e7b91170d$var$TablePaginationSelectLabel = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
const $effe3c7e7b91170d$var$TablePaginationSelect = (0, $d8seH.default)((0, $cX7V2.default), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $inBkn.default).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $inBkn.default).select}`]: styles.select,
            ...styles.input,
            ...styles.selectRoot
        })
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $inBkn.default).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $effe3c7e7b91170d$var$TablePaginationMenuItem = (0, $d8seH.default)((0, $2iAqv.default), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $effe3c7e7b91170d$var$TablePaginationDisplayedRows = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
function $effe3c7e7b91170d$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $effe3c7e7b91170d$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $effe3c7e7b91170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $inBkn.getTablePaginationUtilityClass), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $effe3c7e7b91170d$var$TablePagination = /*#__PURE__*/ $acw62.forwardRef(function TablePagination(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $dLLxV.default), backIconButtonProps: backIconButtonProps, colSpan: colSpanProp, component: component = (0, $elyLx.default), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $effe3c7e7b91170d$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $effe3c7e7b91170d$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const ownerState = props;
    const classes = $effe3c7e7b91170d$var$useUtilityClasses(ownerState);
    const selectProps = slotProps?.select ?? SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $effe3c7e7b91170d$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $elyLx.default) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $5A6d3.default)(selectProps.id);
    const labelId = (0, $5A6d3.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        className: classes.root,
        elementType: $effe3c7e7b91170d$var$TablePaginationRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: component,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            colSpan: colSpan
        }
    });
    const [ToolbarSlot, toolbarSlotProps] = (0, $6lpak.default)('toolbar', {
        className: classes.toolbar,
        elementType: $effe3c7e7b91170d$var$TablePaginationToolbar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SpacerSlot, spacerSlotProps] = (0, $6lpak.default)('spacer', {
        className: classes.spacer,
        elementType: $effe3c7e7b91170d$var$TablePaginationSpacer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectLabelSlot, selectLabelSlotProps] = (0, $6lpak.default)('selectLabel', {
        className: classes.selectLabel,
        elementType: $effe3c7e7b91170d$var$TablePaginationSelectLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            id: labelId
        }
    });
    const [SelectSlot, selectSlotProps] = (0, $6lpak.default)('select', {
        className: classes.select,
        elementType: $effe3c7e7b91170d$var$TablePaginationSelect,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MenuItemSlot, menuItemSlotProps] = (0, $6lpak.default)('menuItem', {
        className: classes.menuItem,
        elementType: MenuItemComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DisplayedRows, displayedRowsProps] = (0, $6lpak.default)('displayedRows', {
        className: classes.displayedRows,
        elementType: $effe3c7e7b91170d$var$TablePaginationDisplayedRows,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(ToolbarSlot, {
            ...toolbarSlotProps,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(SpacerSlot, {
                    ...spacerSlotProps
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectLabelSlot, {
                    ...selectLabelSlotProps,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                    variant: "standard",
                    ...!selectProps.variant && {
                        input: $effe3c7e7b91170d$var$_InputBase || ($effe3c7e7b91170d$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {}))
                    },
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId,
                    ...selectProps,
                    classes: {
                        ...selectProps.classes,
                        // TODO v5 remove `classes.input`
                        root: (0, $9QePP.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $9QePP.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $9QePP.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    },
                    disabled: disabled,
                    ...selectSlotProps,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $acw62.createElement)(MenuItemSlot, {
                            ...menuItemSlotProps,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(DisplayedRows, {
                    ...displayedRowsProps,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    });
});
var $effe3c7e7b91170d$export$2e2bcd8739ae039 = $effe3c7e7b91170d$var$TablePagination;

});
parcelRegister("kyRsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8072c26f712b4c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $iaUmy = parcelRequire("iaUmy");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iaUmy.getToolbarUtilityClass), classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $ef8072c26f712b4c$export$2e2bcd8739ae039 = $ef8072c26f712b4c$var$Toolbar;

});
parcelRegister("iaUmy", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", () => $d3b4e1a115786e57$export$b12cb262231eef32);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d3b4e1a115786e57$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $beCSm.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$export$2e2bcd8739ae039 = $d3b4e1a115786e57$var$toolbarClasses;

});


parcelRegister("dLLxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0648bcf9b9d5e9c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $bJeVA = parcelRequire("bJeVA");

var $frMNQ = parcelRequire("frMNQ");

var $f46un = parcelRequire("f46un");

var $9Lykx = parcelRequire("9Lykx");

var $5izos = parcelRequire("5izos");

var $21SL6 = parcelRequire("21SL6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a0648bcf9b9d5e9c$var$TablePaginationActions = /*#__PURE__*/ $acw62.forwardRef(function TablePaginationActions(props, ref) {
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $bJeVA.useRtl)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = slots.firstButton ?? (0, $9Lykx.default);
    const LastButton = slots.lastButton ?? (0, $9Lykx.default);
    const NextButton = slots.nextButton ?? (0, $9Lykx.default);
    const PreviousButton = slots.previousButton ?? (0, $9Lykx.default);
    const FirstButtonIcon = slots.firstButtonIcon ?? (0, $21SL6.default);
    const LastButtonIcon = slots.lastButtonIcon ?? (0, $5izos.default);
    const NextButtonIcon = slots.nextButtonIcon ?? (0, $f46un.default);
    const PreviousButtonIcon = slots.previousButtonIcon ?? (0, $frMNQ.default);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: ref,
        ...other,
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, {
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page),
                ...firstButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, {
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page),
                ...previousButtonSlotProps ?? backIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, {
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page),
                ...nextButtonSlotProps ?? nextIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                })
            }),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, {
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page),
                ...lastButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                })
            })
        ]
    });
});
var $a0648bcf9b9d5e9c$export$2e2bcd8739ae039 = $a0648bcf9b9d5e9c$var$TablePaginationActions;

});
parcelRegister("5izos", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dba169293b5f5f0$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $3dba169293b5f5f0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

});

parcelRegister("21SL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $17a626ba35acf52f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $17a626ba35acf52f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

});


parcelRegister("inBkn", function(module, exports) {

$parcel$export(module.exports, "getTablePaginationUtilityClass", () => $d6175477fd255470$export$909e637b22246f4c);
$parcel$export(module.exports, "default", () => $d6175477fd255470$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d6175477fd255470$export$909e637b22246f4c(slot) {
    return (0, $4Cod0.default)('MuiTablePagination', slot);
}
const $d6175477fd255470$var$tablePaginationClasses = (0, $beCSm.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $d6175477fd255470$export$2e2bcd8739ae039 = $d6175477fd255470$var$tablePaginationClasses;

});



parcelRegister("kfa8b", function(module, exports) {

$parcel$export(module.exports, "GridPanel", () => $ebcd112530bc7823$export$cf917897ad2588b);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $kGwBF = parcelRequire("kGwBF");

var $7Frhn = parcelRequire("7Frhn");

var $e76iu = parcelRequire("e76iu");

var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $ebcd112530bc7823$var$_excluded = [
    "children",
    "className",
    "classes"
];
const $ebcd112530bc7823$export$e95ad8c1c287de86 = (0, $beCSm.default)('MuiDataGrid', [
    'panel',
    'paper'
]);
const $ebcd112530bc7823$var$GridPanelRoot = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiDataGrid',
    slot: 'Panel',
    overridesResolver: (props, styles)=>styles.panel
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $ebcd112530bc7823$var$GridPaperRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiDataGrid',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        minWidth: 300,
        maxHeight: 450,
        display: 'flex',
        maxWidth: `calc(100vw - ${theme.spacing(0.5)})`,
        overflow: 'auto'
    }));
const $ebcd112530bc7823$export$cf917897ad2588b = (0, $gJsNs.forwardRef)((props, ref)=>{
    const { children: children, className: className } = props, other = (0, $1En50.default)(props, $ebcd112530bc7823$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $ebcd112530bc7823$export$e95ad8c1c287de86;
    const [isPlaced, setIsPlaced] = $acw62.useState(false);
    const handleClickAway = $acw62.useCallback(()=>{
        apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (event.key === 'Escape') apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const modifiers = $acw62.useMemo(()=>[
            {
                name: 'flip',
                enabled: true,
                options: {
                    rootBoundary: 'document'
                }
            },
            {
                name: 'isPlaced',
                enabled: true,
                phase: 'main',
                fn: ()=>{
                    setIsPlaced(true);
                },
                effect: ()=>()=>{
                        setIsPlaced(false);
                    }
            }
        ], []);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        const panelAnchor = apiRef.current.rootElementRef?.current?.querySelector('[data-id="gridPanelAnchor"]');
        if (panelAnchor) setAnchorEl(panelAnchor);
    }, [
        apiRef
    ]);
    if (!anchorEl) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ebcd112530bc7823$var$GridPanelRoot, (0, $8nd05.default)({
        placement: "bottom-start",
        className: (0, $9QePP.default)(classes.panel, className),
        ownerState: rootProps,
        anchorEl: anchorEl,
        modifiers: modifiers
    }, other, {
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), {
            mouseEvent: "onPointerUp",
            touchEvent: false,
            onClickAway: handleClickAway,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ebcd112530bc7823$var$GridPaperRoot, {
                className: classes.paper,
                ownerState: rootProps,
                elevation: 8,
                onKeyDown: handleKeyDown,
                children: isPlaced && children
            })
        })
    }));
});

});

parcelRegister("kWPQR", function(module, exports) {

$parcel$export(module.exports, "GridRow", () => $f40172132c7a6c94$export$1fc5a7f035870658);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3qSdM = parcelRequire("3qSdM");

var $kUNkQ = parcelRequire("kUNkQ");

var $gJsNs = parcelRequire("gJsNs");

var $6hqfZ = parcelRequire("6hqfZ");

var $jkRzp = parcelRequire("jkRzp");

var $5H1vo = parcelRequire("5H1vo");

var $4P61c = parcelRequire("4P61c");

var $jDpXp = parcelRequire("jDpXp");

var $lbNvN = parcelRequire("lbNvN");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $aJApm = parcelRequire("aJApm");

var $KtEo5 = parcelRequire("KtEo5");

var $5bG6h = parcelRequire("5bG6h");

var $8z2XQ = parcelRequire("8z2XQ");

var $jZka4 = parcelRequire("jZka4");

var $iU3u2 = parcelRequire("iU3u2");

var $goCyd = parcelRequire("goCyd");

var $5Rfo7 = parcelRequire("5Rfo7");

var $cunsT = parcelRequire("cunsT");

var $jWPPy = parcelRequire("jWPPy");

var $3J8MS = parcelRequire("3J8MS");

var $er55f = parcelRequire("er55f");

var $cgQ4y = parcelRequire("cgQ4y");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f40172132c7a6c94$var$_excluded = [
    "selected",
    "rowId",
    "row",
    "index",
    "style",
    "rowHeight",
    "className",
    "visibleColumns",
    "pinnedColumns",
    "offsetLeft",
    "columnsTotalWidth",
    "firstColumnIndex",
    "lastColumnIndex",
    "focusedColumnIndex",
    "isFirstVisible",
    "isLastVisible",
    "isNotVisible",
    "showBottomBorder",
    "scrollbarWidth",
    "gridHasFiller",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const $f40172132c7a6c94$var$isRowReorderingEnabledSelector = (0, $cgQ4y.createSelectorV8)((0, $5Rfo7.gridEditRowsStateSelector), (editRows, rowReordering)=>{
    if (!rowReordering) return false;
    const isEditingRows = !(0, $6hqfZ.isObjectEmpty)(editRows);
    return !isEditingRows;
});
const $f40172132c7a6c94$var$GridRow = (0, $gJsNs.forwardRef)(function GridRow(props, refProp) {
    const { selected: selected, rowId: rowId, row: row, index: index, style: styleProp, rowHeight: rowHeight, className: className, visibleColumns: visibleColumns, pinnedColumns: pinnedColumns, offsetLeft: offsetLeft, columnsTotalWidth: columnsTotalWidth, firstColumnIndex: firstColumnIndex, lastColumnIndex: lastColumnIndex, focusedColumnIndex: focusedColumnIndex, isFirstVisible: isFirstVisible, isLastVisible: isLastVisible, isNotVisible: isNotVisible, showBottomBorder: showBottomBorder, scrollbarWidth: scrollbarWidth, gridHasFiller: gridHasFiller, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOut: onMouseOut, onMouseOver: onMouseOver } = props, other = (0, $1En50.default)(props, $f40172132c7a6c94$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const configuration = (0, $3J8MS.useGridConfiguration)();
    const ref = $acw62.useRef(null);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef, rootProps);
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $iU3u2.gridSortModelSelector));
    const treeDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowMaximumTreeDepthSelector));
    const columnPositions = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnPositionsSelector));
    const rowReordering = rootProps.rowReordering;
    const isRowReorderingEnabled = (0, $5sOMZ.useGridSelectorV8)(apiRef, $f40172132c7a6c94$var$isRowReorderingEnabledSelector, rowReordering);
    const handleRef = (0, $3qSdM.default)(ref, refProp);
    const rowNode = apiRef.current.getRowNode(rowId);
    const editing = (0, $5sOMZ.useGridSelectorV8)(apiRef, (0, $5Rfo7.gridRowIsEditingSelector), {
        rowId: rowId,
        editMode: rootProps.editMode
    });
    const editable = rootProps.editMode === (0, $jkRzp.GridEditModes).Row;
    const hasFocusCell = focusedColumnIndex !== undefined;
    const hasVirtualFocusCellLeft = hasFocusCell && focusedColumnIndex >= pinnedColumns.left.length && focusedColumnIndex < firstColumnIndex;
    const hasVirtualFocusCellRight = hasFocusCell && focusedColumnIndex < visibleColumns.length - pinnedColumns.right.length && focusedColumnIndex >= lastColumnIndex;
    const classes = (0, $4P61c.composeGridClasses)(rootProps.classes, {
        root: [
            'row',
            selected && 'selected',
            editable && 'row--editable',
            editing && 'row--editing',
            isFirstVisible && 'row--firstVisible',
            isLastVisible && 'row--lastVisible',
            showBottomBorder && 'row--borderBottom',
            rowHeight === 'auto' && 'row--dynamicHeight'
        ]
    });
    const getRowAriaAttributes = configuration.hooks.useGridRowAriaAttributes();
    $acw62.useLayoutEffect(()=>{
        if (currentPage.range) {
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            // Pinned rows are not part of the visible rows
            if (rowIndex !== undefined) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        if (ref.current && rowHeight === 'auto') return apiRef.current.observeRowHeight(ref.current, rowId);
        return undefined;
    }, [
        apiRef,
        currentPage.range,
        rowHeight,
        rowId
    ]);
    const publish = $acw62.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = $acw62.useCallback((event)=>{
        const cell = (0, $KtEo5.findParentElementFromClassName)(event.target, (0, $5H1vo.gridClasses).cell);
        const field = cell?.getAttribute('data-field');
        // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field) return;
            // User opened a detail panel
            if (field === (0, $jZka4.GRID_DETAIL_PANEL_TOGGLE_FIELD)) return;
            // User reorders a row
            if (field === '__reorder__') return;
            // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === (0, $jkRzp.GridCellModes).Edit) return;
            // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if (column?.type === (0, $8z2XQ.GRID_ACTIONS_COLUMN_TYPE)) return;
        }
        publish('rowClick', onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots: slots, slotProps: slotProps, disableColumnReorder: disableColumnReorder } = rootProps;
    const heightEntry = (0, $5sOMZ.useGridSelector)(apiRef, ()=>(0, $8nd05.default)({}, apiRef.current.getRowHeightEntry(rowId)), (0, $5sOMZ.objectShallowCompare));
    const style = $acw62.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = (0, $8nd05.default)({}, styleProp, {
            maxHeight: rowHeight === 'auto' ? 'none' : rowHeight,
            // max-height doesn't support "auto"
            minHeight: rowHeight,
            '--height': typeof rowHeight === 'number' ? `${rowHeight}px` : rowHeight
        });
        if (heightEntry.spacingTop) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderTopWidth' : 'marginTop';
            rowStyle[property] = heightEntry.spacingTop;
        }
        if (heightEntry.spacingBottom) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderBottomWidth' : 'marginBottom';
            let propertyValue = rowStyle[property];
            // avoid overriding existing value
            if (typeof propertyValue !== 'number') propertyValue = parseInt(propertyValue || '0', 10);
            propertyValue += heightEntry.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        heightEntry,
        rootProps.rowSpacingType
    ]);
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
    const ariaAttributes = getRowAriaAttributes(rowNode, index);
    if (typeof rootProps.getRowClassName === 'function') {
        const indexRelativeToCurrentPage = index - (currentPage.range?.firstRowIndex || 0);
        const rowParams = (0, $8nd05.default)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage: indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const getCell = (column, indexInSection, indexRelativeToAllColumns, sectionLength, pinnedPosition = (0, $jZka4.PinnedColumnPosition).NONE)=>{
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo?.spannedByColSpan) return null;
        const width = cellColSpanInfo?.cellProps.width ?? column.computedWidth;
        const colSpan = cellColSpanInfo?.cellProps.colSpan ?? 1;
        const pinnedOffset = (0, $jWPPy.getPinnedCellOffset)(pinnedPosition, column.computedWidth, indexRelativeToAllColumns, columnPositions, columnsTotalWidth, scrollbarWidth);
        if (rowNode.type === 'skeletonRow') return /*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
            type: column.type,
            width: width,
            height: rowHeight,
            field: column.field,
            align: column.align
        }, column.field);
        // when the cell is a reorder cell we are not allowing to reorder the col
        // fixes https://github.com/mui/mui-x/issues/11126
        const isReorderCell = column.field === '__reorder__';
        const canReorderColumn = !(disableColumnReorder || column.disableReorder);
        const canReorderRow = isRowReorderingEnabled && !sortModel.length && treeDepth <= 1;
        const disableDragEvents = !(canReorderColumn || isReorderCell && canReorderRow);
        const cellIsNotVisible = pinnedPosition === (0, $jZka4.PinnedColumnPosition).VIRTUAL;
        const showLeftBorder = (0, $lbNvN.shouldCellShowLeftBorder)(pinnedPosition, indexInSection);
        const showRightBorder = (0, $lbNvN.shouldCellShowRightBorder)(pinnedPosition, indexInSection, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(slots.cell, (0, $8nd05.default)({
            column: column,
            width: width,
            rowId: rowId,
            align: column.align || 'left',
            colIndex: indexRelativeToAllColumns,
            colSpan: colSpan,
            disableDragEvents: disableDragEvents,
            isNotVisible: cellIsNotVisible,
            pinnedOffset: pinnedOffset,
            pinnedPosition: pinnedPosition,
            showLeftBorder: showLeftBorder,
            showRightBorder: showRightBorder,
            row: row,
            rowNode: rowNode
        }, slotProps?.cell), column.field);
    };
    const leftCells = pinnedColumns.left.map((column, i)=>{
        const indexRelativeToAllColumns = i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.left.length, (0, $jZka4.PinnedColumnPosition).LEFT);
    });
    const rightCells = pinnedColumns.right.map((column, i)=>{
        const indexRelativeToAllColumns = visibleColumns.length - pinnedColumns.right.length + i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.right.length, (0, $jZka4.PinnedColumnPosition).RIGHT);
    });
    const middleColumnsLength = visibleColumns.length - pinnedColumns.left.length - pinnedColumns.right.length;
    const cells = [];
    if (hasVirtualFocusCellLeft) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, (0, $jZka4.PinnedColumnPosition).VIRTUAL));
    for(let i = firstColumnIndex; i < lastColumnIndex; i += 1){
        const column = visibleColumns[i];
        const indexInSection = i - pinnedColumns.left.length;
        if (!column) continue;
        cells.push(getCell(column, indexInSection, i, middleColumnsLength));
    }
    if (hasVirtualFocusCellRight) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, (0, $jZka4.PinnedColumnPosition).VIRTUAL));
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish('rowDoubleClick', onDoubleClick),
        onMouseEnter: publish('rowMouseEnter', onMouseEnter),
        onMouseLeave: publish('rowMouseLeave', onMouseLeave),
        onMouseOut: publish('rowMouseOut', onMouseOut),
        onMouseOver: publish('rowMouseOver', onMouseOver)
    } : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, $9QePP.default)(...rowClassNames, classes.root, className),
        style: style
    }, ariaAttributes, eventHandlers, other, {
        ref: handleRef,
        children: [
            leftCells,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "presentation",
                className: (0, $5H1vo.gridClasses).cellOffsetLeft,
                style: {
                    width: offsetLeft
                }
            }),
            cells,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "presentation",
                className: (0, $9QePP.default)((0, $5H1vo.gridClasses).cell, (0, $5H1vo.gridClasses).cellEmpty)
            }),
            rightCells,
            scrollbarWidth !== 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cunsT.GridScrollbarFillerCell), {
                pinnedRight: pinnedColumns.right.length > 0,
                borderTop: !isFirstVisible
            })
        ]
    }));
});
const $f40172132c7a6c94$export$1fc5a7f035870658 = (0, $kUNkQ.fastMemo)($f40172132c7a6c94$var$GridRow);

});
parcelRegister("6hqfZ", function(module, exports) {

$parcel$export(module.exports, "isObjectEmpty", () => $4928b2b12bcd438c$export$23cfe696632d10f4);
function $4928b2b12bcd438c$export$23cfe696632d10f4(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}

});

parcelRegister("4P61c", function(module, exports) {

$parcel$export(module.exports, "composeGridClasses", () => $383097f5e5f6c068$export$4631f4813a5310ce);

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");
function $383097f5e5f6c068$export$4631f4813a5310ce(classes, slots) {
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
}

});


parcelRegister("l3iPY", function(module, exports) {

$parcel$export(module.exports, "GridRowCount", () => $f5387d79a8532a8d$export$b92875c9af3e0a77);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $izOUK = parcelRequire("izOUK");

var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $f5387d79a8532a8d$var$_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const $f5387d79a8532a8d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'rowCount'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $f5387d79a8532a8d$var$GridRowCountRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'RowCount',
    overridesResolver: (props, styles)=>styles.rowCount
})(({ theme: theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2)
    }));
const $f5387d79a8532a8d$export$b92875c9af3e0a77 = (0, $gJsNs.forwardRef)(function GridRowCount(props, ref) {
    const { className: className, rowCount: rowCount, visibleRowCount: visibleRowCount } = props, other = (0, $1En50.default)(props, $f5387d79a8532a8d$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ownerState = (0, $jDpXp.useGridRootProps)();
    const classes = $f5387d79a8532a8d$var$useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f5387d79a8532a8d$var$GridRowCountRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: [
            apiRef.current.getLocaleText('footerTotalRows'),
            " ",
            text
        ]
    }));
});

});

parcelRegister("etLiE", function(module, exports) {

$parcel$export(module.exports, "GridSkeletonCell", () => $a8a876e822978977$export$d922c88d466d9c21);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $5RIww = parcelRequire("5RIww");

var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");

var $kUNkQ = parcelRequire("kUNkQ");

var $lR3Vo = parcelRequire("lR3Vo");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $a8a876e822978977$var$_excluded = [
    "field",
    "type",
    "align",
    "width",
    "height",
    "empty",
    "style",
    "className"
];
const $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE = '1.3em';
const $a8a876e822978977$var$CONTENT_HEIGHT = '1.2em';
const $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE = [
    40,
    80
];
const $a8a876e822978977$var$CONTENT_WIDTH_RANGE_BY_TYPE = {
    number: [
        40,
        60
    ],
    string: [
        40,
        80
    ],
    date: [
        40,
        60
    ],
    dateTime: [
        60,
        80
    ],
    singleSelect: [
        40,
        80
    ]
};
const $a8a876e822978977$var$useUtilityClasses = (ownerState)=>{
    const { align: align, classes: classes, empty: empty } = ownerState;
    const slots = {
        root: [
            'cell',
            'cellSkeleton',
            `cell--text${align ? (0, $gxvzd.default)(align) : 'Left'}`,
            empty && 'cellEmpty'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $a8a876e822978977$var$randomNumberGenerator = (0, $lR3Vo.createRandomNumberGenerator)(12345);
function $a8a876e822978977$var$GridSkeletonCell(props) {
    const { field: field, type: type, align: align, width: width, height: height, empty: empty = false, style: style, className: className } = props, other = (0, $1En50.default)(props, $a8a876e822978977$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        align: align,
        empty: empty
    };
    const classes = $a8a876e822978977$var$useUtilityClasses(ownerState);
    // Memo prevents the non-circular skeleton widths changing to random widths on every render
    const skeletonProps = $acw62.useMemo(()=>{
        const isCircularContent = type === 'boolean' || type === 'actions';
        if (isCircularContent) return {
            variant: 'circular',
            width: $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE,
            height: $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE
        };
        // The width of the skeleton is a random number between the min and max values
        // The min and max values are determined by the type of the column
        const [min, max] = type ? $a8a876e822978977$var$CONTENT_WIDTH_RANGE_BY_TYPE[type] ?? $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE : $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE;
        return {
            variant: 'text',
            width: `${Math.round($a8a876e822978977$var$randomNumberGenerator(min, max))}%`,
            height: $a8a876e822978977$var$CONTENT_HEIGHT
        };
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        "data-field": field,
        className: (0, $9QePP.default)(classes.root, className),
        style: (0, $8nd05.default)({
            height: height,
            maxWidth: width,
            minWidth: width
        }, style)
    }, other, {
        children: !empty && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), (0, $8nd05.default)({}, skeletonProps))
    }));
}
const $a8a876e822978977$export$d922c88d466d9c21 = (0, $kUNkQ.fastMemo)($a8a876e822978977$var$GridSkeletonCell);

});

parcelRegister("6X2NG", function(module, exports) {

$parcel$export(module.exports, "GridCell", () => $50fa6cd6ff946acb$export$1ce951ee41d30605);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");
var $6zeBo = parcelRequire("6zeBo");
var $3qSdM = parcelRequire("3qSdM");

var $kUNkQ = parcelRequire("kUNkQ");

var $9uEev = parcelRequire("9uEev");

var $gJsNs = parcelRequire("gJsNs");

var $g2vKb = parcelRequire("g2vKb");

var $5H1vo = parcelRequire("5H1vo");

var $jkRzp = parcelRequire("jkRzp");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $drCmI = parcelRequire("drCmI");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $jZka4 = parcelRequire("jZka4");

var $hMoDT = parcelRequire("hMoDT");

var $er55f = parcelRequire("er55f");

var $5Rfo7 = parcelRequire("5Rfo7");

var $kpwEY = parcelRequire("kpwEY");

var $3J8MS = parcelRequire("3J8MS");

var $ayMG0 = parcelRequire("ayMG0");
const $50fa6cd6ff946acb$var$_excluded = [
    "column",
    "row",
    "rowId",
    "rowNode",
    "align",
    "children",
    "colIndex",
    "width",
    "className",
    "style",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "pinnedOffset",
    "pinnedPosition",
    "showRightBorder",
    "showLeftBorder",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], $50fa6cd6ff946acb$var$_excluded2 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
const $50fa6cd6ff946acb$export$e4b557c91de463d4 = {
    [(0, $jZka4.PinnedColumnPosition).LEFT]: (0, $4ZMWQ.GridPinnedColumnPosition).LEFT,
    [(0, $jZka4.PinnedColumnPosition).RIGHT]: (0, $4ZMWQ.GridPinnedColumnPosition).RIGHT,
    [(0, $jZka4.PinnedColumnPosition).NONE]: undefined,
    [(0, $jZka4.PinnedColumnPosition).VIRTUAL]: undefined
};
const $50fa6cd6ff946acb$var$useUtilityClasses = (ownerState)=>{
    const { align: align, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, isEditable: isEditable, isSelected: isSelected, isSelectionMode: isSelectionMode, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            `cell--text${(0, $gxvzd.default)(align)}`,
            isSelected && 'selected',
            isEditable && 'cell--editable',
            showLeftBorder && 'cell--withLeftBorder',
            showRightBorder && 'cell--withRightBorder',
            pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT && 'cell--pinnedLeft',
            pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT && 'cell--pinnedRight',
            isSelectionMode && !isEditable && 'cell--selectionMode'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
let $50fa6cd6ff946acb$var$warnedOnce = false;
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const $50fa6cd6ff946acb$var$GridCell = (0, $gJsNs.forwardRef)(function GridCell(props, ref) {
    const { column: column, row: row, rowId: rowId, rowNode: rowNode, align: align, colIndex: colIndex, width: width, className: className, style: styleProp, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, pinnedOffset: pinnedOffset, pinnedPosition: pinnedPosition, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver } = props, other = (0, $1En50.default)(props, $50fa6cd6ff946acb$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const field = column.field;
    const editCellState = (0, $5sOMZ.useGridSelectorV8)(apiRef, (0, $5Rfo7.gridEditCellStateSelector), {
        rowId: rowId,
        field: field
    });
    const config = (0, $3J8MS.useGridConfiguration)();
    const cellAggregationResult = config.hooks.useCellAggregationResult(rowId, field);
    const cellMode = editCellState ? (0, $jkRzp.GridCellModes).Edit : (0, $jkRzp.GridCellModes).View;
    const cellParams = apiRef.current.getCellParamsForRow(rowId, field, row, {
        colDef: column,
        cellMode: cellMode,
        rowNode: rowNode,
        tabIndex: (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
            const cellTabIndex = (0, $drCmI.gridTabIndexCellSelector)(apiRef);
            return cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === rowId ? 0 : -1;
        }),
        hasFocus: (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
            const focus = (0, $drCmI.gridFocusCellSelector)(apiRef);
            return focus?.id === rowId && focus.field === field;
        })
    });
    cellParams.api = apiRef.current;
    if (cellAggregationResult) {
        cellParams.value = cellAggregationResult.value;
        cellParams.formattedValue = column.valueFormatter ? column.valueFormatter(cellParams.value, row, column, apiRef) : cellParams.value;
    }
    const isSelected = (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    const hiddenCells = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMoDT.gridRowSpanningHiddenCellsSelector));
    const spannedCells = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMoDT.gridRowSpanningSpannedCellsSelector));
    const { hasFocus: hasFocus, isEditable: isEditable = false, value: value } = cellParams;
    const canManageOwnFocus = column.type === 'actions' && column.getActions?.(apiRef.current.getRowParams(rowId)).some((action)=>!action.props.disabled);
    const tabIndex = (cellMode === 'view' || !isEditable) && !canManageOwnFocus ? cellParams.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    // There is a hidden grid state access in `applyPipeProcessor('cellClassName', ...)`
    const pipesClassName = (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
            id: rowId,
            field: field
        }).filter(Boolean).join(' '));
    const classNames = [
        pipesClassName
    ];
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParams) : column.cellClassName);
    if (column.display === 'flex') classNames.push((0, $5H1vo.gridClasses)['cell--flex']);
    if (getCellClassName) classNames.push(getCellClassName(cellParams));
    const valueToRender = cellParams.formattedValue ?? value;
    const cellRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, cellRef);
    const focusElementRef = $acw62.useRef(null);
    const isSelectionMode = rootProps.cellSelection ?? false;
    const ownerState = {
        align: align,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        pinnedPosition: pinnedPosition,
        isSelected: isSelected,
        isSelectionMode: isSelectionMode
    };
    const classes = $50fa6cd6ff946acb$var$useUtilityClasses(ownerState);
    const publishMouseUp = $acw62.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $acw62.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $acw62.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const isCellRowSpanned = hiddenCells[rowId]?.[field] ?? false;
    const rowSpan = spannedCells[rowId]?.[field] ?? 1;
    const style = $acw62.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            height: 0,
            border: 0
        };
        const cellStyle = (0, $kpwEY.attachPinnedStyle)((0, $8nd05.default)({
            '--width': `${width}px`
        }, styleProp), isRtl, pinnedPosition, pinnedOffset);
        const isLeftPinned = pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT;
        const isRightPinned = pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT;
        if (rowSpan > 1) {
            cellStyle.height = `calc(var(--height) * ${rowSpan})`;
            cellStyle.zIndex = 10;
            if (isLeftPinned || isRightPinned) cellStyle.zIndex = 40;
        }
        return cellStyle;
    }, [
        width,
        isNotVisible,
        styleProp,
        pinnedOffset,
        pinnedPosition,
        isRtl,
        rowSpan
    ]);
    $acw62.useEffect(()=>{
        if (!hasFocus || cellMode === (0, $jkRzp.GridCellModes).Edit) return;
        const doc = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if ((0, $g2vKb.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (isCellRowSpanned) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-colindex": colIndex,
        role: "presentation",
        style: (0, $8nd05.default)({
            width: 'var(--width)'
        }, style)
    });
    let handleFocus = other.onFocus;
    var event;
    let children;
    let title;
    if (editCellState === null && column.renderCell) children = column.renderCell(cellParams);
    if (editCellState !== null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $1En50.default)(editCellState, $50fa6cd6ff946acb$var$_excluded2);
        const formattedValue = column.valueFormatter ? column.valueFormatter(editCellState.value, updatedRow, column, apiRef) : cellParams.formattedValue;
        const params = (0, $8nd05.default)({}, cellParams, {
            row: updatedRow,
            formattedValue: formattedValue
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push((0, $5H1vo.gridClasses)['cell--editing']);
        classNames.push(rootClasses?.['cell--editing']);
    }
    if (children === undefined) {
        const valueString = valueToRender?.toString();
        children = valueString;
        title = valueString;
    }
    if (/*#__PURE__*/ $acw62.isValidElement(children) && canManageOwnFocus) children = /*#__PURE__*/ $acw62.cloneElement(children, {
        focusElementRef: focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, classNames, className),
        role: "gridcell",
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        "aria-rowspan": rowSpan,
        style: style,
        title: title,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        ref: handleRef,
        children: children
    }));
});
const $50fa6cd6ff946acb$export$1ce951ee41d30605 = (0, $kUNkQ.fastMemo)($50fa6cd6ff946acb$var$GridCell);

});
parcelRegister("g2vKb", function(module, exports) {

$parcel$export(module.exports, "doesSupportPreventScroll", () => $bad574edb71acea7$export$ed1f8daf96fc68fb);
// Based on https://stackoverflow.com/a/59518678
let $bad574edb71acea7$var$cachedSupportsPreventScroll;
function $bad574edb71acea7$export$ed1f8daf96fc68fb() {
    if ($bad574edb71acea7$var$cachedSupportsPreventScroll === undefined) document.createElement('div').focus({
        get preventScroll () {
            $bad574edb71acea7$var$cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return $bad574edb71acea7$var$cachedSupportsPreventScroll;
}

});


parcelRegister("sLaj5", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaders", () => $056733ac91e6ea07$export$4a3a74c44d0a6c04);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $kUNkQ = parcelRequire("kUNkQ");

var $gJsNs = parcelRequire("gJsNs");

var $hlKix = parcelRequire("hlKix");

var $2fAdp = parcelRequire("2fAdp");

var $ayMG0 = parcelRequire("ayMG0");
const $056733ac91e6ea07$var$_excluded = [
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $056733ac91e6ea07$var$GridColumnHeaders = (0, $gJsNs.forwardRef)(function GridColumnHeaders(props, ref) {
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $1En50.default)(props, $056733ac91e6ea07$var$_excluded);
    const { getInnerProps: getInnerProps, getColumnHeadersRow: getColumnHeadersRow, getColumnGroupHeadersRows: getColumnGroupHeadersRows } = (0, $hlKix.useGridColumnHeaders)({
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fAdp.GridBaseColumnHeaders), (0, $8nd05.default)({}, other, getInnerProps(), {
        ref: ref,
        children: [
            getColumnGroupHeadersRows(),
            getColumnHeadersRow()
        ]
    }));
});
const $056733ac91e6ea07$export$4a3a74c44d0a6c04 = (0, $kUNkQ.fastMemo)($056733ac91e6ea07$var$GridColumnHeaders);

});
parcelRegister("hlKix", function(module, exports) {

$parcel$export(module.exports, "useGridColumnHeaders", () => $ca184fa0bded5702$export$dd7dbc7d3ee10272);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");

var $eFF1m = parcelRequire("eFF1m");

var $bfoLE = parcelRequire("bfoLE");

var $61HyH = parcelRequire("61HyH");

var $9upDV = parcelRequire("9upDV");

var $fHEg1 = parcelRequire("fHEg1");

var $kAYrj = parcelRequire("kAYrj");

var $jQEEt = parcelRequire("jQEEt");

var $hMyIf = parcelRequire("hMyIf");

var $cunsT = parcelRequire("cunsT");

var $jWPPy = parcelRequire("jWPPy");

var $c0AIV = parcelRequire("c0AIV");

var $5H1vo = parcelRequire("5H1vo");

var $lbNvN = parcelRequire("lbNvN");

var $jZka4 = parcelRequire("jZka4");

var $ayMG0 = parcelRequire("ayMG0");
const $ca184fa0bded5702$export$7b391e1fd04597c4 = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow',
    overridesResolver: (_, styles)=>styles.columnHeaderRow
})({
    display: 'flex'
});
const $ca184fa0bded5702$export$dd7dbc7d3ee10272 = (props)=>{
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const [dragCol, setDragCol] = $acw62.useState('');
    const [resizeCol, setResizeCol] = $acw62.useState('');
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const columnGroupsModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsUnwrappedModelSelector));
    const columnPositions = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnPositionsSelector));
    const renderContext = (0, $5sOMZ.useGridSelector)(apiRef, (0, $9upDV.gridRenderContextColumnsSelector));
    const pinnedColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisiblePinnedColumnDefinitionsSelector));
    const columnsLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnLookupSelector));
    const offsetLeft = (0, $fHEg1.computeOffsetLeft)(columnPositions, renderContext, pinnedColumns.left.length);
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridColumnsTotalWidthSelector));
    const gridHasFiller = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridHasFillerSelector));
    const headerHeight = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridHeaderHeightSelector));
    const groupHeaderHeight = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridGroupHeaderHeightSelector));
    const scrollbarWidth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $61HyH.gridVerticalScrollbarWidthSelector));
    const handleColumnResizeStart = $acw62.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = $acw62.useCallback(()=>setResizeCol(''), []);
    const handleColumnReorderStart = $acw62.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = $acw62.useCallback(()=>setDragCol(''), []);
    const leftRenderContext = $acw62.useMemo(()=>{
        return pinnedColumns.left.length ? {
            firstColumnIndex: 0,
            lastColumnIndex: pinnedColumns.left.length
        } : null;
    }, [
        pinnedColumns.left.length
    ]);
    const rightRenderContext = $acw62.useMemo(()=>{
        return pinnedColumns.right.length ? {
            firstColumnIndex: visibleColumns.length - pinnedColumns.right.length,
            lastColumnIndex: visibleColumns.length
        } : null;
    }, [
        pinnedColumns.right.length,
        visibleColumns.length
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResizeStart', handleColumnResizeStart);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderDragEnd', handleColumnReorderStop);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: currentContext = renderContext } = params || {};
        const firstColumnToRender = currentContext.firstColumnIndex;
        const lastColumnToRender = currentContext.lastColumnIndex;
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender
        };
    };
    const getFillers = (params, children, leftOverflow, borderBottom = false)=>{
        const isPinnedRight = params?.position === (0, $jZka4.PinnedColumnPosition).RIGHT;
        const isNotPinned = params?.position === undefined;
        const hasScrollbarFiller = pinnedColumns.right.length > 0 && isPinnedRight || pinnedColumns.right.length === 0 && isNotPinned;
        const leftOffsetWidth = offsetLeft - leftOverflow;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                isNotPinned && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "presentation",
                    style: {
                        width: leftOffsetWidth
                    }
                }),
                children,
                isNotPinned && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "presentation",
                    className: (0, $9QePP.default)((0, $5H1vo.gridClasses).filler, borderBottom && (0, $5H1vo.gridClasses)['filler--borderBottom'])
                }),
                hasScrollbarFiller && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cunsT.GridScrollbarFillerCell), {
                    header: true,
                    pinnedRight: isPinnedRight,
                    borderBottom: borderBottom,
                    borderTop: false
                })
            ]
        });
    };
    const getColumnHeaders = (params, other = {})=>{
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = getColumnsToRender(params);
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            const pinnedPosition = params?.position;
            const pinnedOffset = (0, $jWPPy.getPinnedCellOffset)(pinnedPosition, colDef.computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            const siblingWithBorderingSeparator = pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT ? renderedColumns[i - 1] : renderedColumns[i + 1];
            const isSiblingFocused = siblingWithBorderingSeparator ? columnHeaderFocus !== null && columnHeaderFocus.field === siblingWithBorderingSeparator.field : false;
            const isLastUnpinned = columnIndex + 1 === columnPositions.length - pinnedColumns.right.length;
            const indexInSection = i;
            const sectionLength = renderedColumns.length;
            const showLeftBorder = (0, $lbNvN.shouldCellShowLeftBorder)(pinnedPosition, indexInSection);
            const showRightBorder = (0, $lbNvN.shouldCellShowRightBorder)(pinnedPosition, indexInSection, sectionLength, rootProps.showColumnVerticalBorder, gridHasFiller);
            columns.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfoLE.GridColumnHeaderItem), (0, $8nd05.default)({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                isLast: columnIndex === columnPositions.length - 1,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                isLastUnpinned: isLastUnpinned,
                isSiblingFocused: isSiblingFocused,
                showLeftBorder: showLeftBorder,
                showRightBorder: showRightBorder
            }, other), colDef.field));
        }
        return getFillers(params, columns, 0);
    };
    const getColumnHeadersRow = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ca184fa0bded5702$export$7b391e1fd04597c4, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            className: (0, $5H1vo.gridClasses)['row--borderBottom'],
            children: [
                leftRenderContext && getColumnHeaders({
                    position: (0, $jZka4.PinnedColumnPosition).LEFT,
                    renderContext: leftRenderContext
                }, {
                    disableReorder: true
                }),
                getColumnHeaders({
                    renderContext: renderContext
                }),
                rightRenderContext && getColumnHeaders({
                    position: (0, $jZka4.PinnedColumnPosition).RIGHT,
                    renderContext: rightRenderContext
                }, {
                    disableReorder: true,
                    separatorSide: (0, $c0AIV.GridColumnHeaderSeparatorSides).Left
                })
            ]
        });
    };
    const getColumnGroupHeaders = ({ depth: depth, params: params })=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender.renderedColumns.length === 0) return null;
        const { firstColumnToRender: firstColumnToRender, lastColumnToRender: lastColumnToRender } = columnsToRender;
        const rowStructure = columnGroupsHeaderStructure[depth];
        const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
        const firstGroupToRender = columnGroupsModel[firstColumnFieldToRender]?.[depth] ?? null;
        const firstGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
        const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
        const lastGroupToRender = columnGroupsModel[lastColumnFieldToRender]?.[depth] ?? null;
        const lastGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
        const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>{
            return (0, $8nd05.default)({}, groupStructure, {
                columnFields: groupStructure.columnFields.filter((field)=>columnVisibility[field] !== false)
            });
        }).filter((groupStructure)=>groupStructure.columnFields.length > 0);
        const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
        const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
        const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
            const column = columnsLookup[field];
            return acc + (column.computedWidth ?? 0);
        }, 0);
        let columnIndex = firstColumnToRender;
        const children = visibleColumnGroupHeader.map(({ groupId: groupId, columnFields: columnFields }, index)=>{
            const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
            const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
            const headerInfo = {
                groupId: groupId,
                width: columnFields.reduce((acc, field)=>acc + columnsLookup[field].computedWidth, 0),
                fields: columnFields,
                colIndex: columnIndex,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            };
            const pinnedPosition = params.position;
            const pinnedOffset = (0, $jWPPy.getPinnedCellOffset)(pinnedPosition, headerInfo.width, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            columnIndex += columnFields.length;
            let indexInSection = index;
            if (pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT) // Group headers can expand to multiple columns, we need to adjust the index
            indexInSection = columnIndex - 1;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAYrj.GridColumnGroupHeader), {
                groupId: groupId,
                width: headerInfo.width,
                fields: headerInfo.fields,
                colIndex: headerInfo.colIndex,
                depth: depth,
                isLastColumn: index === visibleColumnGroupHeader.length - 1,
                maxDepth: headerGroupingMaxDepth,
                height: groupHeaderHeight,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                showLeftBorder: (0, $lbNvN.shouldCellShowLeftBorder)(pinnedPosition, indexInSection),
                showRightBorder: (0, $lbNvN.shouldCellShowRightBorder)(pinnedPosition, indexInSection, visibleColumnGroupHeader.length, rootProps.showColumnVerticalBorder, gridHasFiller)
            }, index);
        });
        return getFillers(params, children, leftOverflow);
    };
    const getColumnGroupHeadersRows = ()=>{
        if (headerGroupingMaxDepth === 0) return null;
        const headerRows = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1)headerRows.push(/*#__PURE__*/ (0, $ayMG0.jsxs)($ca184fa0bded5702$export$7b391e1fd04597c4, {
            role: "row",
            "aria-rowindex": depth + 1,
            ownerState: rootProps,
            children: [
                leftRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: (0, $jZka4.PinnedColumnPosition).LEFT,
                        renderContext: leftRenderContext,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    }
                }),
                getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        renderContext: renderContext
                    }
                }),
                rightRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: (0, $jZka4.PinnedColumnPosition).RIGHT,
                        renderContext: rightRenderContext,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    }
                })
            ]
        }, depth));
        return headerRows;
    };
    return {
        renderContext: renderContext,
        leftRenderContext: leftRenderContext,
        rightRenderContext: rightRenderContext,
        pinnedColumns: pinnedColumns,
        visibleColumns: visibleColumns,
        columnPositions: columnPositions,
        getFillers: getFillers,
        getColumnHeadersRow: getColumnHeadersRow,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeadersRows: getColumnGroupHeadersRows,
        getPinnedCellOffset: $jWPPy.getPinnedCellOffset,
        isDragging: !!dragCol,
        getInnerProps: ()=>({
                role: 'rowgroup'
            })
    };
};

});
parcelRegister("bfoLE", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderItem", () => $83044eba4b8e40dc$export$10f6faff2f47edd);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");
var $auC0X = parcelRequire("auC0X");

var $kUNkQ = parcelRequire("kUNkQ");

var $9uEev = parcelRequire("9uEev");

var $er55f = parcelRequire("er55f");

var $6ZYGg = parcelRequire("6ZYGg");

var $le8d8 = parcelRequire("le8d8");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $4cOaX = parcelRequire("4cOaX");

var $KtEo5 = parcelRequire("KtEo5");

var $jZka4 = parcelRequire("jZka4");

var $kpwEY = parcelRequire("kpwEY");

var $ayMG0 = parcelRequire("ayMG0");
const $83044eba4b8e40dc$var$useUtilityClasses = (ownerState)=>{
    const { colDef: colDef, classes: classes, isDragging: isDragging, sortDirection: sortDirection, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, filterItemsCounter: filterItemsCounter, pinnedPosition: pinnedPosition, isLastUnpinned: isLastUnpinned, isSiblingFocused: isSiblingFocused } = ownerState;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = colDef.type === 'number';
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            colDef.sortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT && 'columnHeader--pinnedRight',
            // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
            // See https://github.com/mui/mui-x/pull/14559
            isLastUnpinned && 'columnHeader--lastUnpinned',
            isSiblingFocused && 'columnHeader--siblingFocused'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $83044eba4b8e40dc$var$GridColumnHeaderItem(props) {
    const { colDef: colDef, columnMenuOpen: columnMenuOpen, colIndex: colIndex, headerHeight: headerHeight, isResizing: isResizing, isLast: isLast, sortDirection: sortDirection, sortIndex: sortIndex, filterItemsCounter: filterItemsCounter, hasFocus: hasFocus, tabIndex: tabIndex, disableReorder: disableReorder, separatorSide: separatorSide, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const headerCellRef = $acw62.useRef(null);
    const columnMenuId = (0, $auC0X.default)();
    const columnMenuButtonId = (0, $auC0X.default)();
    const iconButtonRef = $acw62.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $acw62.useState(columnMenuOpen);
    const isDraggable = $acw62.useMemo(()=>!rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder, [
        rootProps.disableColumnReorder,
        disableReorder,
        colDef.disableReorder
    ]);
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes,
        showRightBorder: showRightBorder,
        showLeftBorder: showLeftBorder
    });
    const classes = $83044eba4b8e40dc$var$useUtilityClasses(ownerState);
    const publish = $acw62.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = $acw62.useMemo(()=>({
            onClick: publish('columnHeaderClick'),
            onContextMenu: publish('columnHeaderContextMenu'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            // TODO remove as it's not used
            onMouseOut: publish('columnHeaderOut'),
            // TODO remove as it's not used
            onMouseEnter: publish('columnHeaderEnter'),
            // TODO remove as it's not used
            onMouseLeave: publish('columnHeaderLeave'),
            // TODO remove as it's not used
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        }), [
        publish
    ]);
    const draggableEventHandlers = $acw62.useMemo(()=>isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEnd: publish('columnHeaderDragEnd')
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = $acw62.useMemo(()=>({
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        }), [
        publish
    ]);
    $acw62.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = $acw62.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ZYGg.ColumnHeaderMenuIcon), {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $le8d8.GridColumnHeaderMenu), {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: rootProps.slotProps?.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const showSortIcon = (colDef.sortable || sortDirection != null) && !colDef.hideSortIcons && !rootProps.disableColumnSorting;
    const columnTitleIconButtons = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaderFilterIconButton, (0, $8nd05.default)({
                field: colDef.field,
                counter: filterItemsCounter
            }, rootProps.slotProps?.columnHeaderFilterIconButton)),
            showSortIcon && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaderSortIcon, (0, $8nd05.default)({
                field: colDef.field,
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder,
                disabled: !colDef.sortable
            }, rootProps.slotProps?.columnHeaderSortIcon))
        ]
    });
    $acw62.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus?.focus();
            if (apiRef.current.columnHeadersContainerRef?.current) apiRef.current.columnHeadersContainerRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    const label = colDef.headerName ?? colDef.field;
    const style = $acw62.useMemo(()=>(0, $kpwEY.attachPinnedStyle)((0, $8nd05.default)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4cOaX.GridGenericColumnHeaderItem), (0, $8nd05.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: (0, $9QePP.default)(headerClassName, isLast && (0, $5H1vo.gridClasses)['columnHeader--last']),
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps,
        style: style
    }, mouseEventsHandlers));
}
const $83044eba4b8e40dc$export$10f6faff2f47edd = (0, $kUNkQ.fastMemo)($83044eba4b8e40dc$var$GridColumnHeaderItem);

});
parcelRegister("6ZYGg", function(module, exports) {

$parcel$export(module.exports, "ColumnHeaderMenuIcon", () => $5187827afc33a627$export$941072bb8af39847);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8Indx = parcelRequire("8Indx");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $5187827afc33a627$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open } = ownerState;
    const slots = {
        root: [
            'menuIcon',
            open && 'menuOpen'
        ],
        button: [
            'menuIconButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $5187827afc33a627$export$941072bb8af39847 = /*#__PURE__*/ $acw62.memo((props)=>{
    const { colDef: colDef, open: open, columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, iconButtonRef: iconButtonRef } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $5187827afc33a627$var$useUtilityClasses(ownerState);
    const handleMenuIconClick = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    const columnName = colDef.headerName ?? colDef.field;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $8nd05.default)({
            title: apiRef.current.getLocaleText('columnMenuLabel'),
            enterDelay: 1000
        }, rootProps.slotProps?.baseTooltip, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText('columnMenuAriaLabel')(columnName),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : undefined,
                id: columnMenuButtonId
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "inherit"
                })
            }))
        }))
    });
});

});

parcelRegister("le8d8", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderMenu", () => $f741464eaaf59d11$export$c096196819b00a09);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $13KXh = parcelRequire("13KXh");

var $bDyDY = parcelRequire("bDyDY");

var $ch6XH = parcelRequire("ch6XH");

var $ayMG0 = parcelRequire("ayMG0");
function $f741464eaaf59d11$export$c096196819b00a09({ columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, ContentComponent: ContentComponent, contentComponentProps: contentComponentProps, field: field, open: open, target: target, onExited: onExited }) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = (0, $13KXh.default)((event)=>{
        if (event) {
            // Prevent triggering the sorting
            event.stopPropagation();
            if (target?.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ch6XH.GridMenu), {
        placement: `bottom-${colDef.align === 'right' ? 'start' : 'end'}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContentComponent, (0, $8nd05.default)({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}

});

parcelRegister("4cOaX", function(module, exports) {

$parcel$export(module.exports, "GridGenericColumnHeaderItem", () => $30ff34474d4fdbcc$export$fd75c0d5b714072b);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $3qSdM = parcelRequire("3qSdM");

var $gJsNs = parcelRequire("gJsNs");

var $er55f = parcelRequire("er55f");

var $2jUq6 = parcelRequire("2jUq6");

var $c0AIV = parcelRequire("c0AIV");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $30ff34474d4fdbcc$var$_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps",
    "style"
];
const $30ff34474d4fdbcc$export$fd75c0d5b714072b = (0, $gJsNs.forwardRef)(function GridGenericColumnHeaderItem(props, ref) {
    const { classes: classes, colIndex: colIndex, height: height, isResizing: isResizing, sortDirection: sortDirection, hasFocus: hasFocus, tabIndex: tabIndex, separatorSide: separatorSide, isDraggable: isDraggable, headerComponent: headerComponent, description: description, width: width, columnMenuIconButton: columnMenuIconButton = null, columnMenu: columnMenu = null, columnTitleIconButtons: columnTitleIconButtons = null, headerClassName: headerClassName, label: label, resizable: resizable, draggableContainerProps: draggableContainerProps, columnHeaderSeparatorProps: columnHeaderSeparatorProps, style: style } = props, other = (0, $1En50.default)(props, $30ff34474d4fdbcc$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const headerCellRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(headerCellRef, ref);
    let ariaSort = 'none';
    if (sortDirection != null) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    $acw62.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus?.focus();
            if (apiRef.current.columnHeadersContainerRef?.current) apiRef.current.columnHeadersContainerRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, headerClassName),
        style: (0, $8nd05.default)({}, style, {
            height: height,
            width: width
        }),
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jUq6.GridColumnHeaderTitle), {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0AIV.GridColumnHeaderSeparator), (0, $8nd05.default)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});

});
parcelRegister("2jUq6", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderTitle", () => $1b091ef728f7a646$export$926bb04b6af55e42);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $izOUK = parcelRequire("izOUK");

var $gJsNs = parcelRequire("gJsNs");

var $KtEo5 = parcelRequire("KtEo5");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $1b091ef728f7a646$var$_excluded = [
    "className",
    "aria-label"
];
const $1b091ef728f7a646$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $1b091ef728f7a646$var$GridColumnHeaderTitleRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle',
    overridesResolver: (props, styles)=>styles.columnHeaderTitle
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)',
    lineHeight: 'normal'
});
const $1b091ef728f7a646$var$ColumnHeaderInnerTitle = (0, $gJsNs.forwardRef)(function ColumnHeaderInnerTitle(props, ref) {
    // Tooltip adds aria-label to the props, which is not needed since the children prop is a string
    // See https://github.com/mui/mui-x/pull/14482
    const { className: className } = props, other = (0, $1En50.default)(props, $1b091ef728f7a646$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $1b091ef728f7a646$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$var$GridColumnHeaderTitleRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function $1b091ef728f7a646$export$926bb04b6af55e42(props) {
    const { label: label, description: description } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const titleRef = $acw62.useRef(null);
    const [tooltip, setTooltip] = $acw62.useState('');
    const handleMouseOver = $acw62.useCallback(()=>{
        if (!description && titleRef?.current) {
            const isOver = (0, $KtEo5.isOverflown)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip('');
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $8nd05.default)({
        title: description || tooltip
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$var$ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}

});

parcelRegister("c0AIV", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderSeparatorSides", () => $8be1f8ad99c6bade$export$71ed79b4ccf06d60);
$parcel$export(module.exports, "GridColumnHeaderSeparator", () => $8be1f8ad99c6bade$export$a264529bdbb7adb7);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $8be1f8ad99c6bade$var$_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var $8be1f8ad99c6bade$export$71ed79b4ccf06d60 = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}($8be1f8ad99c6bade$export$71ed79b4ccf06d60 || {});
const $8be1f8ad99c6bade$var$useUtilityClasses = (ownerState)=>{
    const { resizable: resizable, resizing: resizing, classes: classes, side: side } = ownerState;
    const slots = {
        root: [
            'columnSeparator',
            resizable && 'columnSeparator--resizable',
            resizing && 'columnSeparator--resizing',
            side && `columnSeparator--side${(0, $gxvzd.default)(side)}`
        ],
        icon: [
            'iconSeparator'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw(props) {
    const { height: height, side: side = $8be1f8ad99c6bade$export$71ed79b4ccf06d60.Right } = props, other = (0, $1En50.default)(props, $8be1f8ad99c6bade$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, props, {
        side: side,
        classes: rootProps.classes
    });
    const classes = $8be1f8ad99c6bade$var$useUtilityClasses(ownerState);
    const stopClick = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        className: classes.root,
        style: {
            minHeight: height
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    })));
}
const $8be1f8ad99c6bade$export$a264529bdbb7adb7 = /*#__PURE__*/ $acw62.memo($8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw);

});



parcelRegister("kAYrj", function(module, exports) {

$parcel$export(module.exports, "GridColumnGroupHeader", () => $efe60d7621886a65$export$ff426d40d02e21be);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8Indx = parcelRequire("8Indx");
var $auC0X = parcelRequire("auC0X");

var $9uEev = parcelRequire("9uEev");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $hMyIf = parcelRequire("hMyIf");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $4cOaX = parcelRequire("4cOaX");

var $KtEo5 = parcelRequire("KtEo5");

var $jZka4 = parcelRequire("jZka4");

var $kpwEY = parcelRequire("kpwEY");

var $ayMG0 = parcelRequire("ayMG0");
const $efe60d7621886a65$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, headerAlign: headerAlign, isDragging: isDragging, isLastColumn: isLastColumn, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, groupId: groupId, pinnedPosition: pinnedPosition } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            headerAlign === 'left' && 'columnHeader--alignLeft',
            headerAlign === 'center' && 'columnHeader--alignCenter',
            headerAlign === 'right' && 'columnHeader--alignRight',
            isDragging && 'columnHeader--moving',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            'withBorderColor',
            groupId === null ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup',
            pinnedPosition === (0, $jZka4.PinnedColumnPosition).LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === (0, $jZka4.PinnedColumnPosition).RIGHT && 'columnHeader--pinnedRight',
            isLastColumn && 'columnHeader--last'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer',
            'withBorderColor'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $efe60d7621886a65$export$ff426d40d02e21be(props) {
    const { groupId: groupId, width: width, depth: depth, maxDepth: maxDepth, fields: fields, height: height, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex, isLastColumn: isLastColumn, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const headerCellRef = $acw62.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columnGroupsLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsLookupSelector));
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName: headerName = groupId ?? '', description: description = '', headerAlign: headerAlign } = group;
    let headerComponent;
    const render = groupId && columnGroupsLookup[groupId]?.renderHeaderGroup;
    const renderParams = $acw62.useMemo(()=>({
            groupId: groupId,
            headerName: headerName,
            description: description,
            depth: depth,
            maxDepth: maxDepth,
            fields: fields,
            colIndex: colIndex,
            isLastColumn: isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes,
        headerAlign: headerAlign,
        depth: depth,
        isDragging: false
    });
    const label = headerName ?? groupId;
    const id = (0, $auC0X.default)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = $efe60d7621886a65$var$useUtilityClasses(ownerState);
    $acw62.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus?.focus();
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = $acw62.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = $acw62.useMemo(()=>({
            onKeyDown: publish('columnGroupHeaderKeyDown'),
            onFocus: publish('columnGroupHeaderFocus'),
            onBlur: publish('columnGroupHeaderBlur')
        }), [
        publish
    ]);
    const headerClassName = typeof group.headerClassName === 'function' ? group.headerClassName(renderParams) : group.headerClassName;
    const style = $acw62.useMemo(()=>(0, $kpwEY.attachPinnedStyle)((0, $8nd05.default)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4cOaX.GridGenericColumnHeaderItem), (0, $8nd05.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join('-|-')}-|`,
        style: style
    }, mouseEventsHandlers));
}

});


parcelRegister("2fAdp", function(module, exports) {

$parcel$export(module.exports, "GridBaseColumnHeaders", () => $1a39131620112653$export$de91f7b8bf842ed8);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $izOUK = parcelRequire("izOUK");

var $gJsNs = parcelRequire("gJsNs");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $1a39131620112653$var$_excluded = [
    "className"
];
const $1a39131620112653$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaders'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $1a39131620112653$var$GridColumnHeadersRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaders',
    overridesResolver: (props, styles)=>styles.columnHeaders
})({
    display: 'flex',
    flexDirection: 'column',
    borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
    borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const $1a39131620112653$export$de91f7b8bf842ed8 = (0, $gJsNs.forwardRef)(function GridColumnHeaders(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $1a39131620112653$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $1a39131620112653$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1a39131620112653$var$GridColumnHeadersRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        role: "presentation",
        ref: ref
    }));
});

});


parcelRegister("59mZx", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenu", () => $3bffa0a776b5a050$export$53fbb13480dfeb67);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $gJsNs = parcelRequire("gJsNs");

var $jsV9n = parcelRequire("jsV9n");

var $unHVj = parcelRequire("unHVj");

var $6bz5h = parcelRequire("6bz5h");

var $cYNu4 = parcelRequire("cYNu4");

var $cKFTH = parcelRequire("cKFTH");

var $ayMG0 = parcelRequire("ayMG0");
const $3bffa0a776b5a050$var$_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const $3bffa0a776b5a050$export$5983f95fe9d3e659 = {
    columnMenuSortItem: (0, $cKFTH.GridColumnMenuSortItem),
    columnMenuFilterItem: (0, $cYNu4.GridColumnMenuFilterItem),
    columnMenuColumnsItem: (0, $6bz5h.GridColumnMenuColumnsItem)
};
const $3bffa0a776b5a050$export$c107bd4c779cece6 = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const $3bffa0a776b5a050$export$61ffa20907ac4a8e = (0, $gJsNs.forwardRef)(function GridGenericColumnMenu(props, ref) {
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $3bffa0a776b5a050$var$_excluded);
    const orderedSlots = (0, $jsV9n.useGridColumnMenuSlots)((0, $8nd05.default)({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $unHVj.GridColumnMenuContainer), (0, $8nd05.default)({}, other, {
        ref: ref,
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Component, (0, $8nd05.default)({}, otherProps), index))
    }));
});
const $3bffa0a776b5a050$export$53fbb13480dfeb67 = (0, $gJsNs.forwardRef)(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bffa0a776b5a050$export$61ffa20907ac4a8e, (0, $8nd05.default)({}, props, {
        ref: ref,
        defaultSlots: $3bffa0a776b5a050$export$5983f95fe9d3e659,
        defaultSlotProps: $3bffa0a776b5a050$export$c107bd4c779cece6
    }));
});

});
parcelRegister("jsV9n", function(module, exports) {

$parcel$export(module.exports, "useGridColumnMenuSlots", () => $e2bcf6b15e7fbab3$export$2ba37d64bee4cf68);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");
const $e2bcf6b15e7fbab3$var$_excluded = [
    "displayOrder"
];
const $e2bcf6b15e7fbab3$export$2ba37d64bee4cf68 = (props)=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {}, hideMenu: hideMenu, colDef: colDef, addDividers: addDividers = true } = props;
    const processedComponents = $acw62.useMemo(()=>(0, $8nd05.default)({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = $acw62.useMemo(()=>{
        if (!slotProps || Object.keys(slotProps).length === 0) return defaultSlotProps;
        const mergedProps = (0, $8nd05.default)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $8nd05.default)({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
    const userItems = $acw62.useMemo(()=>{
        const defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    }, [
        slots,
        defaultSlots
    ]);
    return $acw62.useMemo(()=>{
        const uniqueItems = Array.from(new Set([
            ...defaultItems,
            ...userItems
        ]));
        const cleansedItems = uniqueItems.filter((key)=>processedComponents[key] != null);
        const sorted = cleansedItems.sort((a, b)=>{
            const leftItemProps = processedSlotProps[a];
            const rightItemProps = processedSlotProps[b];
            const leftDisplayOrder = Number.isFinite(leftItemProps?.displayOrder) ? leftItemProps.displayOrder : 100;
            const rightDisplayOrder = Number.isFinite(rightItemProps?.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce((acc, key, index)=>{
            let itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = (0, $1En50.default)(processedComponentProps, $e2bcf6b15e7fbab3$var$_excluded);
                itemProps = (0, $8nd05.default)({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    rootProps.slots.baseDivider,
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems,
        rootProps.slots.baseDivider
    ]);
};

});

parcelRegister("unHVj", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuContainer", () => $05b53142b9ab08e6$export$595ece458604adc3);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

var $lBOb7 = parcelRequire("lBOb7");

var $d8seH = parcelRequire("d8seH");

var $gJsNs = parcelRequire("gJsNs");

var $dMF9H = parcelRequire("dMF9H");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $05b53142b9ab08e6$var$_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const $05b53142b9ab08e6$var$StyledMenuList = (0, $d8seH.default)((0, $lBOb7.default))(()=>({
        minWidth: 248
    }));
const $05b53142b9ab08e6$export$595ece458604adc3 = (0, $gJsNs.forwardRef)(function GridColumnMenuContainer(props, ref) {
    const { hideMenu: hideMenu, id: id, labelledby: labelledby, className: className, children: children, open: open } = props, other = (0, $1En50.default)(props, $05b53142b9ab08e6$var$_excluded);
    const handleListKeyDown = $acw62.useCallback((event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ((0, $dMF9H.isHideMenuKey)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($05b53142b9ab08e6$var$StyledMenuList, (0, $8nd05.default)({
        id: id,
        className: (0, $9QePP.default)((0, $5H1vo.gridClasses).menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        autoFocus: open
    }, other, {
        ref: ref,
        children: children
    }));
});

});

parcelRegister("6bz5h", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuColumnsItem", () => $480efc1ffdb54f08$export$fee567ee855db2cc);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9udtZ = parcelRequire("9udtZ");

var $kGBL7 = parcelRequire("kGBL7");

var $ayMG0 = parcelRequire("ayMG0");
function $480efc1ffdb54f08$export$fee567ee855db2cc(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9udtZ.GridColumnMenuHideItem), (0, $8nd05.default)({}, props)),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGBL7.GridColumnMenuManageItem), (0, $8nd05.default)({}, props))
        ]
    });
}

});
parcelRegister("9udtZ", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuHideItem", () => $6e815fc52eaddbf2$export$43421c0d197b);

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bjZRT = parcelRequire("bjZRT");

var $19ocJ = parcelRequire("19ocJ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $jQEEt = parcelRequire("jQEEt");

var $ayMG0 = parcelRequire("ayMG0");
function $6e815fc52eaddbf2$export$43421c0d197b(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true);
    // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = $acw62.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (colDef.hideable === false) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        onClick: toggleColumn,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuHideIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                children: apiRef.current.getLocaleText('columnMenuHideColumn')
            })
        ]
    });
}

});
parcelRegister("bjZRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $83e175cb7e49d325$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $doXfV = parcelRequire("doXfV");

var $3W6ht = parcelRequire("3W6ht");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $doXfV.getListItemIconUtilityClass), classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $83e175cb7e49d325$export$2e2bcd8739ae039 = $83e175cb7e49d325$var$ListItemIcon;

});


parcelRegister("kGBL7", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuManageItem", () => $f0f5050f3d38da77$export$dfc5e58327b7921f);

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bjZRT = parcelRequire("bjZRT");

var $19ocJ = parcelRequire("19ocJ");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $f0f5050f3d38da77$export$dfc5e58327b7921f(props) {
    const { onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const showColumns = $acw62.useCallback((event)=>{
        onClick(event); // hide column menu
        apiRef.current.showPreferences((0, $3PCYS.GridPreferencePanelsValue).columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        onClick: showColumns,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                children: apiRef.current.getLocaleText('columnMenuManageColumns')
            })
        ]
    });
}

});


parcelRegister("cYNu4", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuFilterItem", () => $97317925c823a2fa$export$a4dd856446268ffe);

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bjZRT = parcelRequire("bjZRT");

var $19ocJ = parcelRequire("19ocJ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $97317925c823a2fa$export$a4dd856446268ffe(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const showFilter = $acw62.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        onClick: showFilter,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuFilterIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                children: apiRef.current.getLocaleText('columnMenuFilter')
            })
        ]
    });
}

});

parcelRegister("cKFTH", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuSortItem", () => $948a47da9ef72c3c$export$e58710c52f856e65);

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bjZRT = parcelRequire("bjZRT");

var $19ocJ = parcelRequire("19ocJ");

var $5sOMZ = parcelRequire("5sOMZ");

var $iU3u2 = parcelRequire("iU3u2");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $948a47da9ef72c3c$export$e58710c52f856e65(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $iU3u2.gridSortModelSelector));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const sortDirection = $acw62.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return sortItem?.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const onSortMenuItemClick = $acw62.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute('data-value') || null;
        apiRef.current.sortColumn(colDef.field, direction === sortDirection ? null : direction);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection
    ]);
    if (rootProps.disableColumnSorting || !colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return typeof label === 'function' ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            sortingOrder.includes('asc') && sortDirection !== 'asc' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                        children: getLabel('columnMenuSortAsc')
                    })
                ]
            }) : null,
            sortingOrder.includes('desc') && sortDirection !== 'desc' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                        children: getLabel('columnMenuSortDesc')
                    })
                ]
            }) : null,
            sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                onClick: onSortMenuItemClick,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                        children: apiRef.current.getLocaleText('columnMenuUnsort')
                    })
                ]
            }) : null
        ]
    });
}

});


parcelRegister("juiwS", function(module, exports) {

$parcel$export(module.exports, "GridDetailPanels", () => $e2ff31365723feed$export$aa888f5144097c35);
function $e2ff31365723feed$export$aa888f5144097c35(_) {
    return null;
}

});

parcelRegister("3sytP", function(module, exports) {

$parcel$export(module.exports, "GridPinnedRows", () => $284ebba9b1828a42$export$58309d5251e10b9e);
function $284ebba9b1828a42$export$58309d5251e10b9e(_) {
    return null;
}

});

parcelRegister("eaFJs", function(module, exports) {

$parcel$export(module.exports, "GridNoResultsOverlay", () => $a5125f04ce420a8f$export$82fb990ffc125278);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $gJsNs = parcelRequire("gJsNs");

var $bDyDY = parcelRequire("bDyDY");

var $809Ep = parcelRequire("809Ep");

var $ayMG0 = parcelRequire("ayMG0");
const $a5125f04ce420a8f$export$82fb990ffc125278 = (0, $gJsNs.forwardRef)(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $809Ep.GridOverlay), (0, $8nd05.default)({}, props, {
        ref: ref,
        children: noResultsOverlayLabel
    }));
});

});

parcelRegister("9lhjy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cd3818014b55356$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $fagfG = parcelRequire("fagfG");

var $1Aijw = parcelRequire("1Aijw");

var $lkxXU = parcelRequire("lkxXU");

var $iAtns = parcelRequire("iAtns");

var $gd5y7 = parcelRequire("gd5y7");

var $cX7V2 = parcelRequire("cX7V2");

var $6lXkL = parcelRequire("6lXkL");

var $9Lykx = parcelRequire("9Lykx");

var $hViLc = parcelRequire("hViLc");

var $cVXaD = parcelRequire("cVXaD");

var $e76iu = parcelRequire("e76iu");

var $OEVqP = parcelRequire("OEVqP");

var $6ami2 = parcelRequire("6ami2");

var $g95sO = parcelRequire("g95sO");

var $fWql6 = parcelRequire("fWql6");

var $eUvXy = parcelRequire("eUvXy");
const $6cd3818014b55356$var$iconSlots = {
    booleanCellTrueIcon: (0, $fWql6.GridCheckIcon),
    booleanCellFalseIcon: (0, $fWql6.GridCloseIcon),
    columnMenuIcon: (0, $fWql6.GridTripleDotsVerticalIcon),
    openFilterButtonIcon: (0, $fWql6.GridFilterListIcon),
    filterPanelDeleteIcon: (0, $fWql6.GridCloseIcon),
    columnFilteredIcon: (0, $fWql6.GridFilterAltIcon),
    columnSelectorIcon: (0, $fWql6.GridColumnIcon),
    columnUnsortedIcon: (0, $g95sO.GridColumnUnsortedIcon),
    columnSortedAscendingIcon: (0, $fWql6.GridArrowUpwardIcon),
    columnSortedDescendingIcon: (0, $fWql6.GridArrowDownwardIcon),
    columnResizeIcon: (0, $fWql6.GridSeparatorIcon),
    densityCompactIcon: (0, $fWql6.GridViewHeadlineIcon),
    densityStandardIcon: (0, $fWql6.GridTableRowsIcon),
    densityComfortableIcon: (0, $fWql6.GridViewStreamIcon),
    exportIcon: (0, $fWql6.GridSaveAltIcon),
    moreActionsIcon: (0, $fWql6.GridMoreVertIcon),
    treeDataCollapseIcon: (0, $fWql6.GridExpandMoreIcon),
    treeDataExpandIcon: (0, $fWql6.GridKeyboardArrowRight),
    groupingCriteriaCollapseIcon: (0, $fWql6.GridExpandMoreIcon),
    groupingCriteriaExpandIcon: (0, $fWql6.GridKeyboardArrowRight),
    detailPanelExpandIcon: (0, $fWql6.GridAddIcon),
    detailPanelCollapseIcon: (0, $fWql6.GridRemoveIcon),
    rowReorderIcon: (0, $fWql6.GridDragIcon),
    quickFilterIcon: (0, $fWql6.GridSearchIcon),
    quickFilterClearIcon: (0, $fWql6.GridCloseIcon),
    columnMenuHideIcon: (0, $fWql6.GridVisibilityOffIcon),
    columnMenuSortAscendingIcon: (0, $fWql6.GridArrowUpwardIcon),
    columnMenuSortDescendingIcon: (0, $fWql6.GridArrowDownwardIcon),
    columnMenuFilterIcon: (0, $fWql6.GridFilterAltIcon),
    columnMenuManageColumnsIcon: (0, $fWql6.GridViewColumnIcon),
    columnMenuClearIcon: (0, $fWql6.GridClearIcon),
    loadIcon: (0, $fWql6.GridLoadIcon),
    filterPanelAddIcon: (0, $fWql6.GridAddIcon),
    filterPanelRemoveAllIcon: (0, $fWql6.GridDeleteForeverIcon),
    columnReorderIcon: (0, $fWql6.GridDragIcon)
};
const $6cd3818014b55356$var$materialSlots = (0, $8nd05.default)({}, $6cd3818014b55356$var$iconSlots, {
    baseBadge: (0, $fagfG.default),
    baseCheckbox: (0, $1Aijw.default),
    baseDivider: (0, $lkxXU.default),
    baseTextField: (0, $iAtns.default),
    baseFormControl: (0, $gd5y7.default),
    baseSelect: (0, $cX7V2.default),
    baseButton: (0, $6lXkL.default),
    baseIconButton: (0, $9Lykx.default),
    baseInputAdornment: (0, $hViLc.default),
    baseTooltip: (0, $cVXaD.default),
    basePopper: (0, $e76iu.default),
    baseInputLabel: (0, $OEVqP.default),
    baseSelectOption: (0, $eUvXy.default),
    baseChip: (0, $6ami2.default)
});
var $6cd3818014b55356$export$2e2bcd8739ae039 = $6cd3818014b55356$var$materialSlots;

});
parcelRegister("fagfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a465815ebe726f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $9D07P = parcelRequire("9D07P");

var $8Indx = parcelRequire("8Indx");

var $17KyE = parcelRequire("17KyE");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $8FqN6 = parcelRequire("8FqN6");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b0a465815ebe726f$var$RADIUS_STANDARD = 10;
const $b0a465815ebe726f$var$RADIUS_DOT = 4;
const $b0a465815ebe726f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}${(0, $jTnBY.default)(overlap)}`,
            `overlap${(0, $jTnBY.default)(overlap)}`,
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8FqN6.getBadgeUtilityClass), classes);
};
const $b0a465815ebe726f$var$BadgeRoot = (0, $d8seH.default)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $b0a465815ebe726f$var$BadgeBadge = (0, $d8seH.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}${(0, $jTnBY.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        borderRadius: $b0a465815ebe726f$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $b0a465815ebe726f$var$RADIUS_DOT,
                    height: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    minWidth: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function $b0a465815ebe726f$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $b0a465815ebe726f$var$Badge = /*#__PURE__*/ $acw62.forwardRef(function Badge(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $17KyE.default)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $9D07P.default)({
        anchorOrigin: $b0a465815ebe726f$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $b0a465815ebe726f$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $b0a465815ebe726f$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $b0a465815ebe726f$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $6lpak.default)('badge', {
        elementType: $b0a465815ebe726f$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $b0a465815ebe726f$export$2e2bcd8739ae039 = $b0a465815ebe726f$var$Badge;

});
parcelRegister("17KyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1a8f518d4ece30$export$2e2bcd8739ae039);

var $9D07P = parcelRequire("9D07P");
'use client';
/**
 *
 * Demos:
 *
 * - [Badge](https://mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $0d1a8f518d4ece30$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $9D07P.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $0d1a8f518d4ece30$export$2e2bcd8739ae039 = $0d1a8f518d4ece30$var$useBadge;

});

parcelRegister("8FqN6", function(module, exports) {

$parcel$export(module.exports, "getBadgeUtilityClass", () => $64f6ef338eb74fbc$export$aaccef17e6dab084);
$parcel$export(module.exports, "default", () => $64f6ef338eb74fbc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64f6ef338eb74fbc$export$aaccef17e6dab084(slot) {
    return (0, $4Cod0.default)('MuiBadge', slot);
}
const $64f6ef338eb74fbc$var$badgeClasses = (0, $beCSm.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $64f6ef338eb74fbc$export$2e2bcd8739ae039 = $64f6ef338eb74fbc$var$badgeClasses;

});


parcelRegister("g95sO", function(module, exports) {

$parcel$export(module.exports, "GridColumnUnsortedIcon", () => $bc11b9958af31e44$export$9e3e7f6bf3b8c7a7);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $bc11b9958af31e44$var$_excluded = [
    "sortingOrder"
];
const $bc11b9958af31e44$export$9e3e7f6bf3b8c7a7 = /*#__PURE__*/ $acw62.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder: sortingOrder } = props, other = (0, $1En50.default)(props, $bc11b9958af31e44$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $8nd05.default)({}, other)) : null;
});

});

parcelRegister("fWql6", function(module, exports) {

$parcel$export(module.exports, "GridArrowUpwardIcon", () => $b9b0b441ce479047$export$6de472a3df735882);
$parcel$export(module.exports, "GridArrowDownwardIcon", () => $b9b0b441ce479047$export$1f2d4db4a79871d4);
$parcel$export(module.exports, "GridKeyboardArrowRight", () => $b9b0b441ce479047$export$8da6370d9999894a);
$parcel$export(module.exports, "GridExpandMoreIcon", () => $b9b0b441ce479047$export$5b6f85a3ddabf4ca);
$parcel$export(module.exports, "GridFilterListIcon", () => $b9b0b441ce479047$export$cb1a577169e125de);
$parcel$export(module.exports, "GridFilterAltIcon", () => $b9b0b441ce479047$export$4f4f59585ffe8deb);
$parcel$export(module.exports, "GridSearchIcon", () => $b9b0b441ce479047$export$d33e6ad54b379a5d);
$parcel$export(module.exports, "GridColumnIcon", () => $b9b0b441ce479047$export$10a5a2f68ff67c50);
$parcel$export(module.exports, "GridSeparatorIcon", () => $b9b0b441ce479047$export$e918bd395b324de6);
$parcel$export(module.exports, "GridViewHeadlineIcon", () => $b9b0b441ce479047$export$3bcf566f7053b242);
$parcel$export(module.exports, "GridTableRowsIcon", () => $b9b0b441ce479047$export$adcade5d1a52a335);
$parcel$export(module.exports, "GridViewStreamIcon", () => $b9b0b441ce479047$export$60a4c153d2d7b084);
$parcel$export(module.exports, "GridTripleDotsVerticalIcon", () => $b9b0b441ce479047$export$2fbf0de7557957a8);
$parcel$export(module.exports, "GridCloseIcon", () => $b9b0b441ce479047$export$cbefef3cfb8e2783);
$parcel$export(module.exports, "GridAddIcon", () => $b9b0b441ce479047$export$e483c1441c7fca0b);
$parcel$export(module.exports, "GridRemoveIcon", () => $b9b0b441ce479047$export$d8fa92cc66e4dec8);
$parcel$export(module.exports, "GridLoadIcon", () => $b9b0b441ce479047$export$52992a9d5fa53c3c);
$parcel$export(module.exports, "GridDragIcon", () => $b9b0b441ce479047$export$305773dd821bb81d);
$parcel$export(module.exports, "GridSaveAltIcon", () => $b9b0b441ce479047$export$78df866ac12db1bd);
$parcel$export(module.exports, "GridCheckIcon", () => $b9b0b441ce479047$export$1f9ec58b2f66f46d);
$parcel$export(module.exports, "GridMoreVertIcon", () => $b9b0b441ce479047$export$6eaba7fcfbaac527);
$parcel$export(module.exports, "GridVisibilityOffIcon", () => $b9b0b441ce479047$export$9267feb6a6149971);
$parcel$export(module.exports, "GridViewColumnIcon", () => $b9b0b441ce479047$export$109d60d29e96616d);
$parcel$export(module.exports, "GridClearIcon", () => $b9b0b441ce479047$export$ab03f96923842ba7);
$parcel$export(module.exports, "GridDeleteForeverIcon", () => $b9b0b441ce479047$export$fc6ef585bd0ee189);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
const $b9b0b441ce479047$export$6de472a3df735882 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const $b9b0b441ce479047$export$1f2d4db4a79871d4 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const $b9b0b441ce479047$export$8da6370d9999894a = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const $b9b0b441ce479047$export$5b6f85a3ddabf4ca = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const $b9b0b441ce479047$export$cb1a577169e125de = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const $b9b0b441ce479047$export$4f4f59585ffe8deb = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const $b9b0b441ce479047$export$d33e6ad54b379a5d = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
const $b9b0b441ce479047$export$3c3b03774b2ed8ce = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
const $b9b0b441ce479047$export$7a7700ab3e9c7e95 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const $b9b0b441ce479047$export$10a5a2f68ff67c50 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), 'ColumnIcon');
const $b9b0b441ce479047$export$e918bd395b324de6 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
    width: "1",
    height: "24",
    x: "11.5",
    rx: "0.5"
}), 'Separator');
const $b9b0b441ce479047$export$3bcf566f7053b242 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const $b9b0b441ce479047$export$adcade5d1a52a335 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const $b9b0b441ce479047$export$60a4c153d2d7b084 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const $b9b0b441ce479047$export$2fbf0de7557957a8 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const $b9b0b441ce479047$export$cbefef3cfb8e2783 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const $b9b0b441ce479047$export$e483c1441c7fca0b = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const $b9b0b441ce479047$export$d8fa92cc66e4dec8 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const $b9b0b441ce479047$export$52992a9d5fa53c3c = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const $b9b0b441ce479047$export$305773dd821bb81d = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const $b9b0b441ce479047$export$78df866ac12db1bd = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');
const $b9b0b441ce479047$export$1f9ec58b2f66f46d = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const $b9b0b441ce479047$export$6eaba7fcfbaac527 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const $b9b0b441ce479047$export$9267feb6a6149971 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const $b9b0b441ce479047$export$109d60d29e96616d = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("g", {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), 'ViewColumn');
const $b9b0b441ce479047$export$ab03f96923842ba7 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
const $b9b0b441ce479047$export$4830297c7288dee4 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $b9b0b441ce479047$export$fc6ef585bd0ee189 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');

});

parcelRegister("eUvXy", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaf162330f6a0fb$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");

var $2iAqv = parcelRequire("2iAqv");

var $ayMG0 = parcelRequire("ayMG0");
const $adaf162330f6a0fb$var$_excluded = [
    "native"
];
function $adaf162330f6a0fb$export$2e2bcd8739ae039(_ref) {
    let { native: native } = _ref, props = (0, $1En50.default)(_ref, $adaf162330f6a0fb$var$_excluded);
    if (native) return /*#__PURE__*/ (0, $ayMG0.jsx)("option", (0, $8nd05.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), (0, $8nd05.default)({}, props));
}

});



parcelRegister("4Yqqs", function(module, exports) {

$parcel$export(module.exports, "computeSlots", () => $39f1439fa7b8d5d4$export$247af54f7c54fca);

var $8nd05 = parcelRequire("8nd05");
function $39f1439fa7b8d5d4$export$247af54f7c54fca({ defaultSlots: defaultSlots, slots: slots }) {
    const overrides = slots;
    if (!overrides || Object.keys(overrides).length === 0) return defaultSlots;
    const result = (0, $8nd05.default)({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (overrides[k] !== undefined) result[k] = overrides[k];
    });
    return result;
}

});

parcelRegister("4cd9P", function(module, exports) {

$parcel$export(module.exports, "useProps", () => $30e27d3e1a9d8664$export$1f264be2c424fccf);

var $acw62 = parcelRequire("acw62");
/** Gathers props for the root element into a single `.forwardedProps` field */ function $30e27d3e1a9d8664$var$groupForwardedProps(props) {
    if (props.slotProps?.root) return props;
    const keys = Object.keys(props);
    if (!keys.some((key)=>key.startsWith('aria-') || key.startsWith('data-'))) return props;
    const newProps = {};
    const forwardedProps = props.forwardedProps ?? {};
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if (key.startsWith('aria-') || key.startsWith('data-')) forwardedProps[key] = props[key];
        else newProps[key] = props[key];
    }
    newProps.forwardedProps = forwardedProps;
    return newProps;
}
function $30e27d3e1a9d8664$export$1f264be2c424fccf(allProps) {
    return $acw62.useMemo(()=>$30e27d3e1a9d8664$var$groupForwardedProps(allProps), [
        allProps
    ]);
}

});




parcelRegister("5nfKz", function(module, exports) {
$parcel$export(module.exports, "ConfirmationDialog", () => (parcelRequire("f4Dj1")).ConfirmationDialog);
parcelRequire("f4Dj1");

});
parcelRegister("f4Dj1", function(module, exports) {

$parcel$export(module.exports, "ConfirmationDialog", () => $5d3d9285a65c5046$export$b8704437d11c7fe7);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $eFqab = parcelRequire("eFqab");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");

var $acw62 = parcelRequire("acw62");
const $5d3d9285a65c5046$export$b8704437d11c7fe7 = ({ title: title, text: text, okText: okText, cancelText: cancelText, onCancel: onCancel, onOk: onOk, onClose: onClose, typeToConfirm: typeToConfirm, okButtonColor: okButtonColor = "success" })=>{
    const [confirmText, setConfirmText] = $acw62.useState("");
    const handleKeyDown = (event)=>{
        if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            onOk();
            onClose();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: true,
        onKeyDown: handleKeyDown,
        sx: {
            zIndex: 9600
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    typeToConfirm && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                                children: "Type 'delete' to confirm deletion."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                fullWidth: true,
                                size: "small",
                                placeholder: "delete",
                                onChange: (evt)=>setConfirmText(evt.target.value),
                                value: confirmText
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                children: [
                    Boolean(onCancel) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: ()=>{
                            onCancel();
                            onClose();
                        },
                        children: cancelText ?? "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        color: okButtonColor,
                        disabled: typeToConfirm && confirmText !== "delete",
                        onClick: ()=>{
                            onOk();
                            onClose();
                        },
                        children: okText ?? "OK"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("eFqab", function(module, exports) {

$parcel$export(module.exports, "default", () => $aad93085434ac13f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3bYfT = parcelRequire("3bYfT");

var $8ANtp = parcelRequire("8ANtp");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $aad93085434ac13f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $8ANtp.getDialogContentTextUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $aad93085434ac13f$var$DialogContentTextRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $aad93085434ac13f$var$DialogContentText = /*#__PURE__*/ $acw62.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $aad93085434ac13f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aad93085434ac13f$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $aad93085434ac13f$export$2e2bcd8739ae039 = $aad93085434ac13f$var$DialogContentText;

});
parcelRegister("8ANtp", function(module, exports) {

$parcel$export(module.exports, "getDialogContentTextUtilityClass", () => $64180fe1152829a7$export$d9c6dc45f75b0e4f);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64180fe1152829a7$export$d9c6dc45f75b0e4f(slot) {
    return (0, $4Cod0.default)('MuiDialogContentText', slot);
}
const $64180fe1152829a7$var$dialogContentTextClasses = (0, $beCSm.default)('MuiDialogContentText', [
    'root'
]);
var $64180fe1152829a7$export$2e2bcd8739ae039 = $64180fe1152829a7$var$dialogContentTextClasses;

});




parcelRegister("bj2A9", function(module, exports) {

$parcel$export(module.exports, "doBoundsIntersect", () => $cf909ff51e721377$export$f40f62d278cfa9b5);
$parcel$export(module.exports, "CollisionOverlay", () => $cf909ff51e721377$export$7c9b584fc4414daf);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("9vNAe");
var $jlYvG = parcelRequire("jlYvG");

var $cLNZr = parcelRequire("cLNZr");

var $gXRWv = parcelRequire("gXRWv");

var $acw62 = parcelRequire("acw62");
const $cf909ff51e721377$export$f40f62d278cfa9b5 = (boundsA, boundsB)=>{
    const [topLeftA, bottomRightA] = boundsA;
    const [topLeftB, bottomRightB] = boundsB;
    // check if boundsA is to the right of boundsB
    if (topLeftA[0] > bottomRightB[0]) return false;
    // check if boundsA is to the left of boundsB
    if (bottomRightA[0] < topLeftB[0]) return false;
    // check if boundsA is above boundsB
    if (topLeftA[1] > bottomRightB[1]) return false;
    // check if boundsA is below boundsB
    if (bottomRightA[1] < topLeftB[1]) return false;
    return true;
};
const $cf909ff51e721377$var$cache = {};
const $cf909ff51e721377$export$e597e30b4c4bc1fd = (boundsA, boundsB)=>{
    const keyA = JSON.stringify(boundsA);
    const keyB = JSON.stringify(boundsB);
    const key = [
        keyA,
        keyB
    ].sort().join("|");
    if ($cf909ff51e721377$var$cache[key]) return $cf909ff51e721377$var$cache[key];
    const result = $cf909ff51e721377$export$f40f62d278cfa9b5(boundsA, boundsB);
    $cf909ff51e721377$var$cache[key] = result;
    return result;
};
const $cf909ff51e721377$export$72209efa88586d42 = (a, b)=>{
    if (!a || !b) return {
        regions: [],
        inverted: false
    };
    // first, check to see if the bounds overlap at all
    if ($cf909ff51e721377$export$e597e30b4c4bc1fd(a.bounds, b.bounds) === false) return {
        regions: [],
        inverted: false
    };
    // if the bounds overlap, then we need to do a more expensive check
    return (0, $gXRWv.intersect)({
        regions: [
            a.polygon
        ],
        inverted: false
    }, {
        regions: [
            b.polygon
        ],
        inverted: false
    });
};
const $cf909ff51e721377$export$b693b4d8c047c78c = (polygon)=>{
    // Convert number[][] to geometric.Polygon (array of [x, y] tuples)
    const geometricPolygon = polygon.map((point)=>[
            point[0],
            point[1]
        ]);
    const interpolater = $jlYvG.polygonInterpolate(geometricPolygon);
    const interpolatedPolygon = (0, $cLNZr.range)(0, 1, 0.001).map((t)=>interpolater(t));
    return interpolatedPolygon;
};
const $cf909ff51e721377$var$intersectionsCache = new Map();
const $cf909ff51e721377$var$getMemoizedIntersection = (polygonA, polygonB)=>{
    // comparing A to B and B to A are the same thing
    // Use bounds as cache key - cheap to stringify and unique enough
    const keyA = JSON.stringify(polygonA.bounds);
    const keyB = JSON.stringify(polygonB.bounds);
    const key = [
        keyA,
        keyB
    ].sort().join("|");
    if ($cf909ff51e721377$var$intersectionsCache.has(key)) return $cf909ff51e721377$var$intersectionsCache.get(key);
    else {
        const intersection = $cf909ff51e721377$export$72209efa88586d42(polygonA, polygonB);
        $cf909ff51e721377$var$intersectionsCache.set(key, intersection);
        return intersection;
    }
};
const $cf909ff51e721377$export$7c9b584fc4414daf = ({ location: location, polygons: polygons })=>{
    // State to hold the computed collision components
    const [collisionComponents, setCollisionComponents] = $acw62.useState([]);
    // Ref to store the RAF ID for cleanup
    const rafIdRef = $acw62.useRef(null);
    // Effect that schedules collision calculation on RAF
    $acw62.useEffect(()=>{
        // Cancel any pending RAF callback
        if (rafIdRef.current !== null) cancelAnimationFrame(rafIdRef.current);
        // Schedule collision calculation for next frame
        rafIdRef.current = requestAnimationFrame(()=>{
            const collisions = [];
            // compare each polygon to each other polygon but only one time in either direction
            for(let i = 0; i < polygons.length; i++)for(let j = i + 1; j < polygons.length; j++){
                const intersection = $cf909ff51e721377$var$getMemoizedIntersection(polygons[i], polygons[j]);
                for (const region of intersection.regions){
                    const interpolatedRegion = $cf909ff51e721377$export$b693b4d8c047c78c(region);
                    collisions.push(interpolatedRegion);
                }
            }
            // Convert collisions to JSX elements
            const components = collisions.map((collision, idx)=>{
                const points = collision.map((point)=>`${point[0]}, ${location.depth - point[1]}`).join(" ");
                return /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                    points: points,
                    fill: "red",
                    opacity: 1
                }, `collision-polygon-${idx}`);
            });
            // Update state with new collision components
            setCollisionComponents(components);
            rafIdRef.current = null;
        });
        // Cleanup: cancel RAF on unmount or before next effect
        return ()=>{
            if (rafIdRef.current !== null) cancelAnimationFrame(rafIdRef.current);
        };
    }, [
        polygons,
        location.depth
    ]); // Recalculate when polygons or location changes
    // return a big SVG that we can overlay on top of the hangar/ramp
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        "data-id": `collision-overlay-${location.name}`,
        "data-name": "collisions",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${location.width} ${location.depth}`,
        style: {
            position: "absolute",
            left: 0,
            top: 0,
            zIndex: "5000",
            // So that clicking doesn't interfere with dragging
            pointerEvents: "none"
        },
        children: collisionComponents
    }, `collision`);
};

});
parcelRegister("gXRWv", function(module, exports) {
/*
 * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
 * @license MIT
 * @preserve Project Home: https://github.com/voidqk/polybooljs
 */ 
var $cclNX = parcelRequire("cclNX");

var $4YNFk = parcelRequire("4YNFk");

var $aC66b = parcelRequire("aC66b");

var $eOFOv = parcelRequire("eOFOv");

var $1Pf5Z = parcelRequire("1Pf5Z");

var $7boXV = parcelRequire("7boXV");
var $c59bffe587f4d9e4$var$buildLog = false;
var $c59bffe587f4d9e4$var$epsilon = $4YNFk();
var $c59bffe587f4d9e4$var$PolyBool;
$c59bffe587f4d9e4$var$PolyBool = {
    // getter/setter for buildLog
    buildLog: function(bl) {
        if (bl === true) $c59bffe587f4d9e4$var$buildLog = $cclNX();
        else if (bl === false) $c59bffe587f4d9e4$var$buildLog = false;
        return $c59bffe587f4d9e4$var$buildLog === false ? false : $c59bffe587f4d9e4$var$buildLog.list;
    },
    // getter/setter for epsilon
    epsilon: function(v) {
        return $c59bffe587f4d9e4$var$epsilon.epsilon(v);
    },
    // core API
    segments: function(poly) {
        var i = $aC66b(true, $c59bffe587f4d9e4$var$epsilon, $c59bffe587f4d9e4$var$buildLog);
        poly.regions.forEach(i.addRegion);
        return {
            segments: i.calculate(poly.inverted),
            inverted: poly.inverted
        };
    },
    combine: function(segments1, segments2) {
        var i3 = $aC66b(false, $c59bffe587f4d9e4$var$epsilon, $c59bffe587f4d9e4$var$buildLog);
        return {
            combined: i3.calculate(segments1.segments, segments1.inverted, segments2.segments, segments2.inverted),
            inverted1: segments1.inverted,
            inverted2: segments2.inverted
        };
    },
    selectUnion: function(combined) {
        return {
            segments: $1Pf5Z.union(combined.combined, $c59bffe587f4d9e4$var$buildLog),
            inverted: combined.inverted1 || combined.inverted2
        };
    },
    selectIntersect: function(combined) {
        return {
            segments: $1Pf5Z.intersect(combined.combined, $c59bffe587f4d9e4$var$buildLog),
            inverted: combined.inverted1 && combined.inverted2
        };
    },
    selectDifference: function(combined) {
        return {
            segments: $1Pf5Z.difference(combined.combined, $c59bffe587f4d9e4$var$buildLog),
            inverted: combined.inverted1 && !combined.inverted2
        };
    },
    selectDifferenceRev: function(combined) {
        return {
            segments: $1Pf5Z.differenceRev(combined.combined, $c59bffe587f4d9e4$var$buildLog),
            inverted: !combined.inverted1 && combined.inverted2
        };
    },
    selectXor: function(combined) {
        return {
            segments: $1Pf5Z.xor(combined.combined, $c59bffe587f4d9e4$var$buildLog),
            inverted: combined.inverted1 !== combined.inverted2
        };
    },
    polygon: function(segments) {
        return {
            regions: $eOFOv(segments.segments, $c59bffe587f4d9e4$var$epsilon, $c59bffe587f4d9e4$var$buildLog),
            inverted: segments.inverted
        };
    },
    // GeoJSON converters
    polygonFromGeoJSON: function(geojson) {
        return $7boXV.toPolygon($c59bffe587f4d9e4$var$PolyBool, geojson);
    },
    polygonToGeoJSON: function(poly) {
        return $7boXV.fromPolygon($c59bffe587f4d9e4$var$PolyBool, $c59bffe587f4d9e4$var$epsilon, poly);
    },
    // helper functions for common operations
    union: function(poly1, poly2) {
        return $c59bffe587f4d9e4$var$operate(poly1, poly2, $c59bffe587f4d9e4$var$PolyBool.selectUnion);
    },
    intersect: function(poly1, poly2) {
        return $c59bffe587f4d9e4$var$operate(poly1, poly2, $c59bffe587f4d9e4$var$PolyBool.selectIntersect);
    },
    difference: function(poly1, poly2) {
        return $c59bffe587f4d9e4$var$operate(poly1, poly2, $c59bffe587f4d9e4$var$PolyBool.selectDifference);
    },
    differenceRev: function(poly1, poly2) {
        return $c59bffe587f4d9e4$var$operate(poly1, poly2, $c59bffe587f4d9e4$var$PolyBool.selectDifferenceRev);
    },
    xor: function(poly1, poly2) {
        return $c59bffe587f4d9e4$var$operate(poly1, poly2, $c59bffe587f4d9e4$var$PolyBool.selectXor);
    }
};
function $c59bffe587f4d9e4$var$operate(poly1, poly2, selector) {
    var seg1 = $c59bffe587f4d9e4$var$PolyBool.segments(poly1);
    var seg2 = $c59bffe587f4d9e4$var$PolyBool.segments(poly2);
    var comb = $c59bffe587f4d9e4$var$PolyBool.combine(seg1, seg2);
    var seg3 = selector(comb);
    return $c59bffe587f4d9e4$var$PolyBool.polygon(seg3);
}
if (typeof window === 'object') window.PolyBool = $c59bffe587f4d9e4$var$PolyBool;
module.exports = $c59bffe587f4d9e4$var$PolyBool;

});
parcelRegister("cclNX", function(module, exports) {
// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// used strictly for logging the processing of the algorithm... only useful if you intend on
// looking under the covers (for pretty UI's or debugging)
//
function $8e1784fd9f15876e$var$BuildLog() {
    var my;
    var nextSegmentId = 0;
    var curVert = false;
    function push(type, data) {
        my.list.push({
            type: type,
            data: data ? JSON.parse(JSON.stringify(data)) : void 0
        });
        return my;
    }
    my = {
        list: [],
        segmentId: function() {
            return nextSegmentId++;
        },
        checkIntersection: function(seg1, seg2) {
            return push('check', {
                seg1: seg1,
                seg2: seg2
            });
        },
        segmentChop: function(seg, end) {
            push('div_seg', {
                seg: seg,
                pt: end
            });
            return push('chop', {
                seg: seg,
                pt: end
            });
        },
        statusRemove: function(seg) {
            return push('pop_seg', {
                seg: seg
            });
        },
        segmentUpdate: function(seg) {
            return push('seg_update', {
                seg: seg
            });
        },
        segmentNew: function(seg, primary) {
            return push('new_seg', {
                seg: seg,
                primary: primary
            });
        },
        segmentRemove: function(seg) {
            return push('rem_seg', {
                seg: seg
            });
        },
        tempStatus: function(seg, above, below) {
            return push('temp_status', {
                seg: seg,
                above: above,
                below: below
            });
        },
        rewind: function(seg) {
            return push('rewind', {
                seg: seg
            });
        },
        status: function(seg, above, below) {
            return push('status', {
                seg: seg,
                above: above,
                below: below
            });
        },
        vert: function(x) {
            if (x === curVert) return my;
            curVert = x;
            return push('vert', {
                x: x
            });
        },
        log: function(data) {
            if (typeof data !== 'string') data = JSON.stringify(data, false, '  ');
            return push('log', {
                txt: data
            });
        },
        reset: function() {
            return push('reset');
        },
        selected: function(segs) {
            return push('selected', {
                segs: segs
            });
        },
        chainStart: function(seg) {
            return push('chain_start', {
                seg: seg
            });
        },
        chainRemoveHead: function(index, pt) {
            return push('chain_rem_head', {
                index: index,
                pt: pt
            });
        },
        chainRemoveTail: function(index, pt) {
            return push('chain_rem_tail', {
                index: index,
                pt: pt
            });
        },
        chainNew: function(pt1, pt2) {
            return push('chain_new', {
                pt1: pt1,
                pt2: pt2
            });
        },
        chainMatch: function(index) {
            return push('chain_match', {
                index: index
            });
        },
        chainClose: function(index) {
            return push('chain_close', {
                index: index
            });
        },
        chainAddHead: function(index, pt) {
            return push('chain_add_head', {
                index: index,
                pt: pt
            });
        },
        chainAddTail: function(index, pt) {
            return push('chain_add_tail', {
                index: index,
                pt: pt
            });
        },
        chainConnect: function(index1, index2) {
            return push('chain_con', {
                index1: index1,
                index2: index2
            });
        },
        chainReverse: function(index) {
            return push('chain_rev', {
                index: index
            });
        },
        chainJoin: function(index1, index2) {
            return push('chain_join', {
                index1: index1,
                index2: index2
            });
        },
        done: function() {
            return push('done');
        }
    };
    return my;
}
module.exports = $8e1784fd9f15876e$var$BuildLog;

});

parcelRegister("4YNFk", function(module, exports) {
// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// provides the raw computation functions that takes epsilon into account
//
// zero is defined to be between (-epsilon, epsilon) exclusive
//
function $3a034a8d481dc3f1$var$Epsilon(eps) {
    if (typeof eps !== 'number') eps = 0.0000000001; // sane default? sure why not
    var my = {
        epsilon: function(v) {
            if (typeof v === 'number') eps = v;
            return eps;
        },
        pointAboveOrOnLine: function(pt, left, right) {
            var Ax = left[0];
            var Ay = left[1];
            var Bx = right[0];
            var By = right[1];
            var Cx = pt[0];
            var Cy = pt[1];
            return (Bx - Ax) * (Cy - Ay) - (By - Ay) * (Cx - Ax) >= -eps;
        },
        pointBetween: function(p, left, right) {
            // p must be collinear with left->right
            // returns false if p == left, p == right, or left == right
            var d_py_ly = p[1] - left[1];
            var d_rx_lx = right[0] - left[0];
            var d_px_lx = p[0] - left[0];
            var d_ry_ly = right[1] - left[1];
            var dot = d_px_lx * d_rx_lx + d_py_ly * d_ry_ly;
            // if `dot` is 0, then `p` == `left` or `left` == `right` (reject)
            // if `dot` is less than 0, then `p` is to the left of `left` (reject)
            if (dot < eps) return false;
            var sqlen = d_rx_lx * d_rx_lx + d_ry_ly * d_ry_ly;
            // if `dot` > `sqlen`, then `p` is to the right of `right` (reject)
            // therefore, if `dot - sqlen` is greater than 0, then `p` is to the right of `right` (reject)
            if (dot - sqlen > -eps) return false;
            return true;
        },
        pointsSameX: function(p1, p2) {
            return Math.abs(p1[0] - p2[0]) < eps;
        },
        pointsSameY: function(p1, p2) {
            return Math.abs(p1[1] - p2[1]) < eps;
        },
        pointsSame: function(p1, p2) {
            return my.pointsSameX(p1, p2) && my.pointsSameY(p1, p2);
        },
        pointsCompare: function(p1, p2) {
            // returns -1 if p1 is smaller, 1 if p2 is smaller, 0 if equal
            if (my.pointsSameX(p1, p2)) return my.pointsSameY(p1, p2) ? 0 : p1[1] < p2[1] ? -1 : 1;
            return p1[0] < p2[0] ? -1 : 1;
        },
        pointsCollinear: function(pt1, pt2, pt3) {
            // does pt1->pt2->pt3 make a straight line?
            // essentially this is just checking to see if the slope(pt1->pt2) === slope(pt2->pt3)
            // if slopes are equal, then they must be collinear, because they share pt2
            var dx1 = pt1[0] - pt2[0];
            var dy1 = pt1[1] - pt2[1];
            var dx2 = pt2[0] - pt3[0];
            var dy2 = pt2[1] - pt3[1];
            return Math.abs(dx1 * dy2 - dx2 * dy1) < eps;
        },
        linesIntersect: function(a0, a1, b0, b1) {
            // returns false if the lines are coincident (e.g., parallel or on top of each other)
            //
            // returns an object if the lines intersect:
            //   {
            //     pt: [x, y],    where the intersection point is at
            //     alongA: where intersection point is along A,
            //     alongB: where intersection point is along B
            //   }
            //
            //  alongA and alongB will each be one of: -2, -1, 0, 1, 2
            //
            //  with the following meaning:
            //
            //    -2   intersection point is before segment's first point
            //    -1   intersection point is directly on segment's first point
            //     0   intersection point is between segment's first and second points (exclusive)
            //     1   intersection point is directly on segment's second point
            //     2   intersection point is after segment's second point
            var adx = a1[0] - a0[0];
            var ady = a1[1] - a0[1];
            var bdx = b1[0] - b0[0];
            var bdy = b1[1] - b0[1];
            var axb = adx * bdy - ady * bdx;
            if (Math.abs(axb) < eps) return false; // lines are coincident
            var dx = a0[0] - b0[0];
            var dy = a0[1] - b0[1];
            var A = (bdx * dy - bdy * dx) / axb;
            var B = (adx * dy - ady * dx) / axb;
            var ret = {
                alongA: 0,
                alongB: 0,
                pt: [
                    a0[0] + A * adx,
                    a0[1] + A * ady
                ]
            };
            // categorize where intersection point is along A and B
            if (A <= -eps) ret.alongA = -2;
            else if (A < eps) ret.alongA = -1;
            else if (A - 1 <= -eps) ret.alongA = 0;
            else if (A - 1 < eps) ret.alongA = 1;
            else ret.alongA = 2;
            if (B <= -eps) ret.alongB = -2;
            else if (B < eps) ret.alongB = -1;
            else if (B - 1 <= -eps) ret.alongB = 0;
            else if (B - 1 < eps) ret.alongB = 1;
            else ret.alongB = 2;
            return ret;
        },
        pointInsideRegion: function(pt, region) {
            var x = pt[0];
            var y = pt[1];
            var last_x = region[region.length - 1][0];
            var last_y = region[region.length - 1][1];
            var inside = false;
            for(var i = 0; i < region.length; i++){
                var curr_x = region[i][0];
                var curr_y = region[i][1];
                // if y is between curr_y and last_y, and
                // x is to the right of the boundary created by the line
                if (curr_y - y > eps != last_y - y > eps && (last_x - curr_x) * (y - curr_y) / (last_y - curr_y) + curr_x - x > eps) inside = !inside;
                last_x = curr_x;
                last_y = curr_y;
            }
            return inside;
        }
    };
    return my;
}
module.exports = $3a034a8d481dc3f1$var$Epsilon;

});

parcelRegister("aC66b", function(module, exports) {
// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// this is the core work-horse
//

var $2rnqc = parcelRequire("2rnqc");
function $7ba22f0eee9cd60f$var$Intersecter(selfIntersection, eps, buildLog) {
    // selfIntersection is true/false depending on the phase of the overall algorithm
    //
    // segment creation
    //
    function segmentNew(start, end) {
        return {
            id: buildLog ? buildLog.segmentId() : -1,
            start: start,
            end: end,
            myFill: {
                above: null,
                below: null // is there fill below us?
            },
            otherFill: null
        };
    }
    function segmentCopy(start, end, seg) {
        return {
            id: buildLog ? buildLog.segmentId() : -1,
            start: start,
            end: end,
            myFill: {
                above: seg.myFill.above,
                below: seg.myFill.below
            },
            otherFill: null
        };
    }
    //
    // event logic
    //
    var event_root = $2rnqc.create();
    function eventCompare(p1_isStart, p1_1, p1_2, p2_isStart, p2_1, p2_2) {
        // compare the selected points first
        var comp = eps.pointsCompare(p1_1, p2_1);
        if (comp !== 0) return comp;
        // the selected points are the same
        if (eps.pointsSame(p1_2, p2_2)) return 0; // then the segments are equal
        if (p1_isStart !== p2_isStart) return p1_isStart ? 1 : -1; // favor the one that isn't the start
        // otherwise, we'll have to calculate which one is below the other manually
        return eps.pointAboveOrOnLine(p1_2, p2_isStart ? p2_1 : p2_2, p2_isStart ? p2_2 : p2_1) ? 1 : -1;
    }
    function eventAdd(ev, other_pt) {
        event_root.insertBefore(ev, function(here) {
            // should ev be inserted before here?
            var comp = eventCompare(ev.isStart, ev.pt, other_pt, here.isStart, here.pt, here.other.pt);
            return comp < 0;
        });
    }
    function eventAddSegmentStart(seg, primary) {
        var ev_start = $2rnqc.node({
            isStart: true,
            pt: seg.start,
            seg: seg,
            primary: primary,
            other: null,
            status: null
        });
        eventAdd(ev_start, seg.end);
        return ev_start;
    }
    function eventAddSegmentEnd(ev_start, seg, primary) {
        var ev_end = $2rnqc.node({
            isStart: false,
            pt: seg.end,
            seg: seg,
            primary: primary,
            other: ev_start,
            status: null
        });
        ev_start.other = ev_end;
        eventAdd(ev_end, ev_start.pt);
    }
    function eventAddSegment(seg, primary) {
        var ev_start = eventAddSegmentStart(seg, primary);
        eventAddSegmentEnd(ev_start, seg, primary);
        return ev_start;
    }
    function eventUpdateEnd(ev, end) {
        // slides an end backwards
        //   (start)------------(end)    to:
        //   (start)---(end)
        if (buildLog) buildLog.segmentChop(ev.seg, end);
        ev.other.remove();
        ev.seg.end = end;
        ev.other.pt = end;
        eventAdd(ev.other, ev.pt);
    }
    function eventDivide(ev, pt) {
        var ns = segmentCopy(pt, ev.seg.end, ev.seg);
        eventUpdateEnd(ev, pt);
        return eventAddSegment(ns, ev.primary);
    }
    function calculate(primaryPolyInverted, secondaryPolyInverted) {
        // if selfIntersection is true then there is no secondary polygon, so that isn't used
        //
        // status logic
        //
        var status_root = $2rnqc.create();
        function statusCompare(ev1, ev2) {
            var a1 = ev1.seg.start;
            var a2 = ev1.seg.end;
            var b1 = ev2.seg.start;
            var b2 = ev2.seg.end;
            if (eps.pointsCollinear(a1, b1, b2)) {
                if (eps.pointsCollinear(a2, b1, b2)) return 1; //eventCompare(true, a1, a2, true, b1, b2);
                return eps.pointAboveOrOnLine(a2, b1, b2) ? 1 : -1;
            }
            return eps.pointAboveOrOnLine(a1, b1, b2) ? 1 : -1;
        }
        function statusFindSurrounding(ev) {
            return status_root.findTransition(function(here) {
                var comp = statusCompare(ev, here.ev);
                return comp > 0;
            });
        }
        function checkIntersection(ev1, ev2) {
            // returns the segment equal to ev1, or false if nothing equal
            var seg1 = ev1.seg;
            var seg2 = ev2.seg;
            var a1 = seg1.start;
            var a2 = seg1.end;
            var b1 = seg2.start;
            var b2 = seg2.end;
            if (buildLog) buildLog.checkIntersection(seg1, seg2);
            var i = eps.linesIntersect(a1, a2, b1, b2);
            if (i === false) {
                // segments are parallel or coincident
                // if points aren't collinear, then the segments are parallel, so no intersections
                if (!eps.pointsCollinear(a1, a2, b1)) return false;
                // otherwise, segments are on top of each other somehow (aka coincident)
                if (eps.pointsSame(a1, b2) || eps.pointsSame(a2, b1)) return false; // segments touch at endpoints... no intersection
                var a1_equ_b1 = eps.pointsSame(a1, b1);
                var a2_equ_b2 = eps.pointsSame(a2, b2);
                if (a1_equ_b1 && a2_equ_b2) return ev2; // segments are exactly equal
                var a1_between = !a1_equ_b1 && eps.pointBetween(a1, b1, b2);
                var a2_between = !a2_equ_b2 && eps.pointBetween(a2, b1, b2);
                // handy for debugging:
                // buildLog.log({
                //	a1_equ_b1: a1_equ_b1,
                //	a2_equ_b2: a2_equ_b2,
                //	a1_between: a1_between,
                //	a2_between: a2_between
                // });
                if (a1_equ_b1) {
                    if (a2_between) //  (a1)---(a2)
                    //  (b1)----------(b2)
                    eventDivide(ev2, a2);
                    else //  (a1)----------(a2)
                    //  (b1)---(b2)
                    eventDivide(ev1, b2);
                    return ev2;
                } else if (a1_between) {
                    if (!a2_equ_b2) {
                        // make a2 equal to b2
                        if (a2_between) //         (a1)---(a2)
                        //  (b1)-----------------(b2)
                        eventDivide(ev2, a2);
                        else //         (a1)----------(a2)
                        //  (b1)----------(b2)
                        eventDivide(ev1, b2);
                    }
                    //         (a1)---(a2)
                    //  (b1)----------(b2)
                    eventDivide(ev2, a1);
                }
            } else {
                // otherwise, lines intersect at i.pt, which may or may not be between the endpoints
                // is A divided between its endpoints? (exclusive)
                if (i.alongA === 0) {
                    if (i.alongB === -1) eventDivide(ev1, b1);
                    else if (i.alongB === 0) eventDivide(ev1, i.pt);
                    else if (i.alongB === 1) eventDivide(ev1, b2);
                }
                // is B divided between its endpoints? (exclusive)
                if (i.alongB === 0) {
                    if (i.alongA === -1) eventDivide(ev2, a1);
                    else if (i.alongA === 0) eventDivide(ev2, i.pt);
                    else if (i.alongA === 1) eventDivide(ev2, a2);
                }
            }
            return false;
        }
        //
        // main event loop
        //
        var segments = [];
        while(!event_root.isEmpty()){
            var ev = event_root.getHead();
            if (buildLog) buildLog.vert(ev.pt[0]);
            if (ev.isStart) {
                if (buildLog) buildLog.segmentNew(ev.seg, ev.primary);
                var surrounding = statusFindSurrounding(ev);
                var above = surrounding.before ? surrounding.before.ev : null;
                var below = surrounding.after ? surrounding.after.ev : null;
                if (buildLog) buildLog.tempStatus(ev.seg, above ? above.seg : false, below ? below.seg : false);
                function checkBothIntersections() {
                    if (above) {
                        var eve = checkIntersection(ev, above);
                        if (eve) return eve;
                    }
                    if (below) return checkIntersection(ev, below);
                    return false;
                }
                var eve = checkBothIntersections();
                if (eve) {
                    // ev and eve are equal
                    // we'll keep eve and throw away ev
                    // merge ev.seg's fill information into eve.seg
                    if (selfIntersection) {
                        var toggle; // are we a toggling edge?
                        if (ev.seg.myFill.below === null) toggle = true;
                        else toggle = ev.seg.myFill.above !== ev.seg.myFill.below;
                        // merge two segments that belong to the same polygon
                        // think of this as sandwiching two segments together, where `eve.seg` is
                        // the bottom -- this will cause the above fill flag to toggle
                        if (toggle) eve.seg.myFill.above = !eve.seg.myFill.above;
                    } else // merge two segments that belong to different polygons
                    // each segment has distinct knowledge, so no special logic is needed
                    // note that this can only happen once per segment in this phase, because we
                    // are guaranteed that all self-intersections are gone
                    eve.seg.otherFill = ev.seg.myFill;
                    if (buildLog) buildLog.segmentUpdate(eve.seg);
                    ev.other.remove();
                    ev.remove();
                }
                if (event_root.getHead() !== ev) {
                    // something was inserted before us in the event queue, so loop back around and
                    // process it before continuing
                    if (buildLog) buildLog.rewind(ev.seg);
                    continue;
                }
                //
                // calculate fill flags
                //
                if (selfIntersection) {
                    var toggle; // are we a toggling edge?
                    if (ev.seg.myFill.below === null) toggle = true; // then we toggle
                    else toggle = ev.seg.myFill.above !== ev.seg.myFill.below; // calculate toggle
                    // next, calculate whether we are filled below us
                    if (!below) // we are filled below us if the polygon is inverted
                    ev.seg.myFill.below = primaryPolyInverted;
                    else // otherwise, we know the answer -- it's the same if whatever is below
                    // us is filled above it
                    ev.seg.myFill.below = below.seg.myFill.above;
                    // since now we know if we're filled below us, we can calculate whether
                    // we're filled above us by applying toggle to whatever is below us
                    if (toggle) ev.seg.myFill.above = !ev.seg.myFill.below;
                    else ev.seg.myFill.above = ev.seg.myFill.below;
                } else // now we fill in any missing transition information, since we are all-knowing
                // at this point
                if (ev.seg.otherFill === null) {
                    // if we don't have other information, then we need to figure out if we're
                    // inside the other polygon
                    var inside;
                    if (!below) // if nothing is below us, then we're inside if the other polygon is
                    // inverted
                    inside = ev.primary ? secondaryPolyInverted : primaryPolyInverted;
                    else // so copy the below segment's other polygon's above
                    if (ev.primary === below.primary) inside = below.seg.otherFill.above;
                    else inside = below.seg.myFill.above;
                    ev.seg.otherFill = {
                        above: inside,
                        below: inside
                    };
                }
                if (buildLog) buildLog.status(ev.seg, above ? above.seg : false, below ? below.seg : false);
                // insert the status and remember it for later removal
                ev.other.status = surrounding.insert($2rnqc.node({
                    ev: ev
                }));
            } else {
                var st = ev.status;
                if (st === null) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                // removing the status will create two new adjacent edges, so we'll need to check
                // for those
                if (status_root.exists(st.prev) && status_root.exists(st.next)) checkIntersection(st.prev.ev, st.next.ev);
                if (buildLog) buildLog.statusRemove(st.ev.seg);
                // remove the status
                st.remove();
                // if we've reached this point, we've calculated everything there is to know, so
                // save the segment for reporting
                if (!ev.primary) {
                    // make sure `seg.myFill` actually points to the primary polygon though
                    var s = ev.seg.myFill;
                    ev.seg.myFill = ev.seg.otherFill;
                    ev.seg.otherFill = s;
                }
                segments.push(ev.seg);
            }
            // remove the event and continue
            event_root.getHead().remove();
        }
        if (buildLog) buildLog.done();
        return segments;
    }
    // return the appropriate API depending on what we're doing
    if (!selfIntersection) // performing combination of polygons, so only deal with already-processed segments
    return {
        calculate: function(segments1, inverted1, segments2, inverted2) {
            // segmentsX come from the self-intersection API, or this API
            // invertedX is whether we treat that list of segments as an inverted polygon or not
            // returns segments that can be used for further operations
            segments1.forEach(function(seg) {
                eventAddSegment(segmentCopy(seg.start, seg.end, seg), true);
            });
            segments2.forEach(function(seg) {
                eventAddSegment(segmentCopy(seg.start, seg.end, seg), false);
            });
            return calculate(inverted1, inverted2);
        }
    };
    // otherwise, performing self-intersection, so deal with regions
    return {
        addRegion: function(region) {
            // regions are a list of points:
            //  [ [0, 0], [100, 0], [50, 100] ]
            // you can add multiple regions before running calculate
            var pt1;
            var pt2 = region[region.length - 1];
            for(var i = 0; i < region.length; i++){
                pt1 = pt2;
                pt2 = region[i];
                var forward = eps.pointsCompare(pt1, pt2);
                if (forward === 0) continue; // just skip it
                eventAddSegment(segmentNew(forward < 0 ? pt1 : pt2, forward < 0 ? pt2 : pt1), true);
            }
        },
        calculate: function(inverted) {
            // is the polygon inverted?
            // returns segments
            return calculate(inverted, false);
        }
    };
}
module.exports = $7ba22f0eee9cd60f$var$Intersecter;

});
parcelRegister("2rnqc", function(module, exports) {
// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// simple linked list implementation that allows you to traverse down nodes and save positions
//
var $1c70456fc112cb18$var$LinkedList = {
    create: function() {
        var my = {
            root: {
                root: true,
                next: null
            },
            exists: function(node) {
                if (node === null || node === my.root) return false;
                return true;
            },
            isEmpty: function() {
                return my.root.next === null;
            },
            getHead: function() {
                return my.root.next;
            },
            insertBefore: function(node, check) {
                var last = my.root;
                var here = my.root.next;
                while(here !== null){
                    if (check(here)) {
                        node.prev = here.prev;
                        node.next = here;
                        here.prev.next = node;
                        here.prev = node;
                        return;
                    }
                    last = here;
                    here = here.next;
                }
                last.next = node;
                node.prev = last;
                node.next = null;
            },
            findTransition: function(check) {
                var prev = my.root;
                var here = my.root.next;
                while(here !== null){
                    if (check(here)) break;
                    prev = here;
                    here = here.next;
                }
                return {
                    before: prev === my.root ? null : prev,
                    after: here,
                    insert: function(node) {
                        node.prev = prev;
                        node.next = here;
                        prev.next = node;
                        if (here !== null) here.prev = node;
                        return node;
                    }
                };
            }
        };
        return my;
    },
    node: function(data) {
        data.prev = null;
        data.next = null;
        data.remove = function() {
            data.prev.next = data.next;
            if (data.next) data.next.prev = data.prev;
            data.prev = null;
            data.next = null;
        };
        return data;
    }
};
module.exports = $1c70456fc112cb18$var$LinkedList;

});


parcelRegister("eOFOv", function(module, exports) {
// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// converts a list of segments into a list of regions, while also removing unnecessary verticies
//
function $02c89d9aff6b5e7d$var$SegmentChainer(segments, eps, buildLog) {
    var chains = [];
    var regions = [];
    segments.forEach(function(seg) {
        var pt1 = seg.start;
        var pt2 = seg.end;
        if (eps.pointsSame(pt1, pt2)) {
            console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");
            return;
        }
        if (buildLog) buildLog.chainStart(seg);
        // search for two chains that this segment matches
        var first_match = {
            index: 0,
            matches_head: false,
            matches_pt1: false
        };
        var second_match = {
            index: 0,
            matches_head: false,
            matches_pt1: false
        };
        var next_match = first_match;
        function setMatch(index, matches_head, matches_pt1) {
            // return true if we've matched twice
            next_match.index = index;
            next_match.matches_head = matches_head;
            next_match.matches_pt1 = matches_pt1;
            if (next_match === first_match) {
                next_match = second_match;
                return false;
            }
            next_match = null;
            return true; // we've matched twice, we're done here
        }
        for(var i = 0; i < chains.length; i++){
            var chain = chains[i];
            var head = chain[0];
            var head2 = chain[1];
            var tail = chain[chain.length - 1];
            var tail2 = chain[chain.length - 2];
            if (eps.pointsSame(head, pt1)) {
                if (setMatch(i, true, true)) break;
            } else if (eps.pointsSame(head, pt2)) {
                if (setMatch(i, true, false)) break;
            } else if (eps.pointsSame(tail, pt1)) {
                if (setMatch(i, false, true)) break;
            } else if (eps.pointsSame(tail, pt2)) {
                if (setMatch(i, false, false)) break;
            }
        }
        if (next_match === first_match) {
            // we didn't match anything, so create a new chain
            chains.push([
                pt1,
                pt2
            ]);
            if (buildLog) buildLog.chainNew(pt1, pt2);
            return;
        }
        if (next_match === second_match) {
            // we matched a single chain
            if (buildLog) buildLog.chainMatch(first_match.index);
            // add the other point to the apporpriate end, and check to see if we've closed the
            // chain into a loop
            var index = first_match.index;
            var pt = first_match.matches_pt1 ? pt2 : pt1; // if we matched pt1, then we add pt2, etc
            var addToHead = first_match.matches_head; // if we matched at head, then add to the head
            var chain = chains[index];
            var grow = addToHead ? chain[0] : chain[chain.length - 1];
            var grow2 = addToHead ? chain[1] : chain[chain.length - 2];
            var oppo = addToHead ? chain[chain.length - 1] : chain[0];
            var oppo2 = addToHead ? chain[chain.length - 2] : chain[1];
            if (eps.pointsCollinear(grow2, grow, pt)) {
                // grow isn't needed because it's directly between grow2 and pt:
                // grow2 ---grow---> pt
                if (addToHead) {
                    if (buildLog) buildLog.chainRemoveHead(first_match.index, pt);
                    chain.shift();
                } else {
                    if (buildLog) buildLog.chainRemoveTail(first_match.index, pt);
                    chain.pop();
                }
                grow = grow2; // old grow is gone... new grow is what grow2 was
            }
            if (eps.pointsSame(oppo, pt)) {
                // we're closing the loop, so remove chain from chains
                chains.splice(index, 1);
                if (eps.pointsCollinear(oppo2, oppo, grow)) {
                    // oppo isn't needed because it's directly between oppo2 and grow:
                    // oppo2 ---oppo--->grow
                    if (addToHead) {
                        if (buildLog) buildLog.chainRemoveTail(first_match.index, grow);
                        chain.pop();
                    } else {
                        if (buildLog) buildLog.chainRemoveHead(first_match.index, grow);
                        chain.shift();
                    }
                }
                if (buildLog) buildLog.chainClose(first_match.index);
                // we have a closed chain!
                regions.push(chain);
                return;
            }
            // not closing a loop, so just add it to the apporpriate side
            if (addToHead) {
                if (buildLog) buildLog.chainAddHead(first_match.index, pt);
                chain.unshift(pt);
            } else {
                if (buildLog) buildLog.chainAddTail(first_match.index, pt);
                chain.push(pt);
            }
            return;
        }
        // otherwise, we matched two chains, so we need to combine those chains together
        function reverseChain(index) {
            if (buildLog) buildLog.chainReverse(index);
            chains[index].reverse(); // gee, that's easy
        }
        function appendChain(index1, index2) {
            // index1 gets index2 appended to it, and index2 is removed
            var chain1 = chains[index1];
            var chain2 = chains[index2];
            var tail = chain1[chain1.length - 1];
            var tail2 = chain1[chain1.length - 2];
            var head = chain2[0];
            var head2 = chain2[1];
            if (eps.pointsCollinear(tail2, tail, head)) {
                // tail isn't needed because it's directly between tail2 and head
                // tail2 ---tail---> head
                if (buildLog) buildLog.chainRemoveTail(index1, tail);
                chain1.pop();
                tail = tail2; // old tail is gone... new tail is what tail2 was
            }
            if (eps.pointsCollinear(tail, head, head2)) {
                // head isn't needed because it's directly between tail and head2
                // tail ---head---> head2
                if (buildLog) buildLog.chainRemoveHead(index2, head);
                chain2.shift();
            }
            if (buildLog) buildLog.chainJoin(index1, index2);
            chains[index1] = chain1.concat(chain2);
            chains.splice(index2, 1);
        }
        var F = first_match.index;
        var S = second_match.index;
        if (buildLog) buildLog.chainConnect(F, S);
        var reverseF = chains[F].length < chains[S].length; // reverse the shorter chain, if needed
        if (first_match.matches_head) {
            if (second_match.matches_head) {
                if (reverseF) {
                    // <<<< F <<<< --- >>>> S >>>>
                    reverseChain(F);
                    // >>>> F >>>> --- >>>> S >>>>
                    appendChain(F, S);
                } else {
                    // <<<< F <<<< --- >>>> S >>>>
                    reverseChain(S);
                    // <<<< F <<<< --- <<<< S <<<<   logically same as:
                    // >>>> S >>>> --- >>>> F >>>>
                    appendChain(S, F);
                }
            } else // <<<< F <<<< --- <<<< S <<<<   logically same as:
            // >>>> S >>>> --- >>>> F >>>>
            appendChain(S, F);
        } else {
            if (second_match.matches_head) // >>>> F >>>> --- >>>> S >>>>
            appendChain(F, S);
            else if (reverseF) {
                // >>>> F >>>> --- <<<< S <<<<
                reverseChain(F);
                // <<<< F <<<< --- <<<< S <<<<   logically same as:
                // >>>> S >>>> --- >>>> F >>>>
                appendChain(S, F);
            } else {
                // >>>> F >>>> --- <<<< S <<<<
                reverseChain(S);
                // >>>> F >>>> --- >>>> S >>>>
                appendChain(F, S);
            }
        }
    });
    return regions;
}
module.exports = $02c89d9aff6b5e7d$var$SegmentChainer;

});

parcelRegister("1Pf5Z", function(module, exports) {
// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// filter a list of segments based on boolean operations
//
function $1546438d3c954468$var$select(segments, selection, buildLog) {
    var result = [];
    segments.forEach(function(seg) {
        var index = (seg.myFill.above ? 8 : 0) + (seg.myFill.below ? 4 : 0) + (seg.otherFill && seg.otherFill.above ? 2 : 0) + (seg.otherFill && seg.otherFill.below ? 1 : 0);
        if (selection[index] !== 0) // copy the segment to the results, while also calculating the fill status
        result.push({
            id: buildLog ? buildLog.segmentId() : -1,
            start: seg.start,
            end: seg.end,
            myFill: {
                above: selection[index] === 1,
                below: selection[index] === 2 // 2 if filled below
            },
            otherFill: null
        });
    });
    if (buildLog) buildLog.selected(result);
    return result;
}
var $1546438d3c954468$var$SegmentSelector = {
    union: function(segments, buildLog) {
        // above1 below1 above2 below2    Keep?               Value
        //    0      0      0      0   =>   no                  0
        //    0      0      0      1   =>   yes filled below    2
        //    0      0      1      0   =>   yes filled above    1
        //    0      0      1      1   =>   no                  0
        //    0      1      0      0   =>   yes filled below    2
        //    0      1      0      1   =>   yes filled below    2
        //    0      1      1      0   =>   no                  0
        //    0      1      1      1   =>   no                  0
        //    1      0      0      0   =>   yes filled above    1
        //    1      0      0      1   =>   no                  0
        //    1      0      1      0   =>   yes filled above    1
        //    1      0      1      1   =>   no                  0
        //    1      1      0      0   =>   no                  0
        //    1      1      0      1   =>   no                  0
        //    1      1      1      0   =>   no                  0
        //    1      1      1      1   =>   no                  0
        return $1546438d3c954468$var$select(segments, [
            0,
            2,
            1,
            0,
            2,
            2,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            0,
            0
        ], buildLog);
    },
    intersect: function(segments, buildLog) {
        // above1 below1 above2 below2    Keep?               Value
        //    0      0      0      0   =>   no                  0
        //    0      0      0      1   =>   no                  0
        //    0      0      1      0   =>   no                  0
        //    0      0      1      1   =>   no                  0
        //    0      1      0      0   =>   no                  0
        //    0      1      0      1   =>   yes filled below    2
        //    0      1      1      0   =>   no                  0
        //    0      1      1      1   =>   yes filled below    2
        //    1      0      0      0   =>   no                  0
        //    1      0      0      1   =>   no                  0
        //    1      0      1      0   =>   yes filled above    1
        //    1      0      1      1   =>   yes filled above    1
        //    1      1      0      0   =>   no                  0
        //    1      1      0      1   =>   yes filled below    2
        //    1      1      1      0   =>   yes filled above    1
        //    1      1      1      1   =>   no                  0
        return $1546438d3c954468$var$select(segments, [
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            2,
            0,
            0,
            1,
            1,
            0,
            2,
            1,
            0
        ], buildLog);
    },
    difference: function(segments, buildLog) {
        // above1 below1 above2 below2    Keep?               Value
        //    0      0      0      0   =>   no                  0
        //    0      0      0      1   =>   no                  0
        //    0      0      1      0   =>   no                  0
        //    0      0      1      1   =>   no                  0
        //    0      1      0      0   =>   yes filled below    2
        //    0      1      0      1   =>   no                  0
        //    0      1      1      0   =>   yes filled below    2
        //    0      1      1      1   =>   no                  0
        //    1      0      0      0   =>   yes filled above    1
        //    1      0      0      1   =>   yes filled above    1
        //    1      0      1      0   =>   no                  0
        //    1      0      1      1   =>   no                  0
        //    1      1      0      0   =>   no                  0
        //    1      1      0      1   =>   yes filled above    1
        //    1      1      1      0   =>   yes filled below    2
        //    1      1      1      1   =>   no                  0
        return $1546438d3c954468$var$select(segments, [
            0,
            0,
            0,
            0,
            2,
            0,
            2,
            0,
            1,
            1,
            0,
            0,
            0,
            1,
            2,
            0
        ], buildLog);
    },
    differenceRev: function(segments, buildLog) {
        // above1 below1 above2 below2    Keep?               Value
        //    0      0      0      0   =>   no                  0
        //    0      0      0      1   =>   yes filled below    2
        //    0      0      1      0   =>   yes filled above    1
        //    0      0      1      1   =>   no                  0
        //    0      1      0      0   =>   no                  0
        //    0      1      0      1   =>   no                  0
        //    0      1      1      0   =>   yes filled above    1
        //    0      1      1      1   =>   yes filled above    1
        //    1      0      0      0   =>   no                  0
        //    1      0      0      1   =>   yes filled below    2
        //    1      0      1      0   =>   no                  0
        //    1      0      1      1   =>   yes filled below    2
        //    1      1      0      0   =>   no                  0
        //    1      1      0      1   =>   no                  0
        //    1      1      1      0   =>   no                  0
        //    1      1      1      1   =>   no                  0
        return $1546438d3c954468$var$select(segments, [
            0,
            2,
            1,
            0,
            0,
            0,
            1,
            1,
            0,
            2,
            0,
            2,
            0,
            0,
            0,
            0
        ], buildLog);
    },
    xor: function(segments, buildLog) {
        // above1 below1 above2 below2    Keep?               Value
        //    0      0      0      0   =>   no                  0
        //    0      0      0      1   =>   yes filled below    2
        //    0      0      1      0   =>   yes filled above    1
        //    0      0      1      1   =>   no                  0
        //    0      1      0      0   =>   yes filled below    2
        //    0      1      0      1   =>   no                  0
        //    0      1      1      0   =>   no                  0
        //    0      1      1      1   =>   yes filled above    1
        //    1      0      0      0   =>   yes filled above    1
        //    1      0      0      1   =>   no                  0
        //    1      0      1      0   =>   no                  0
        //    1      0      1      1   =>   yes filled below    2
        //    1      1      0      0   =>   no                  0
        //    1      1      0      1   =>   yes filled above    1
        //    1      1      1      0   =>   yes filled below    2
        //    1      1      1      1   =>   no                  0
        return $1546438d3c954468$var$select(segments, [
            0,
            2,
            1,
            0,
            2,
            0,
            0,
            1,
            1,
            0,
            0,
            2,
            0,
            1,
            2,
            0
        ], buildLog);
    }
};
module.exports = $1546438d3c954468$var$SegmentSelector;

});

parcelRegister("7boXV", function(module, exports) {
// (c) Copyright 2017, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// convert between PolyBool polygon format and GeoJSON formats (Polygon and MultiPolygon)
//
var $53aced1c8d5f94f2$var$GeoJSON = {
    // convert a GeoJSON object to a PolyBool polygon
    toPolygon: function(PolyBool, geojson) {
        // converts list of LineString's to segments
        function GeoPoly(coords) {
            // check for empty coords
            if (coords.length <= 0) return PolyBool.segments({
                inverted: false,
                regions: []
            });
            // convert LineString to segments
            function LineString(ls) {
                // remove tail which should be the same as head
                var reg = ls.slice(0, ls.length - 1);
                return PolyBool.segments({
                    inverted: false,
                    regions: [
                        reg
                    ]
                });
            }
            // the first LineString is considered the outside
            var out = LineString(coords[0]);
            // the rest of the LineStrings are considered interior holes, so subtract them from the
            // current result
            for(var i = 1; i < coords.length; i++)out = PolyBool.selectDifference(PolyBool.combine(out, LineString(coords[i])));
            return out;
        }
        if (geojson.type === 'Polygon') // single polygon, so just convert it and we're done
        return PolyBool.polygon(GeoPoly(geojson.coordinates));
        else if (geojson.type === 'MultiPolygon') {
            // multiple polygons, so union all the polygons together
            var out = PolyBool.segments({
                inverted: false,
                regions: []
            });
            for(var i = 0; i < geojson.coordinates.length; i++)out = PolyBool.selectUnion(PolyBool.combine(out, GeoPoly(geojson.coordinates[i])));
            return PolyBool.polygon(out);
        }
        throw new Error('PolyBool: Cannot convert GeoJSON object to PolyBool polygon');
    },
    // convert a PolyBool polygon to a GeoJSON object
    fromPolygon: function(PolyBool, eps, poly) {
        // make sure out polygon is clean
        poly = PolyBool.polygon(PolyBool.segments(poly));
        // test if r1 is inside r2
        function regionInsideRegion(r1, r2) {
            // we're guaranteed no lines intersect (because the polygon is clean), but a vertex
            // could be on the edge -- so we just average pt[0] and pt[1] to produce a point on the
            // edge of the first line, which cannot be on an edge
            return eps.pointInsideRegion([
                (r1[0][0] + r1[1][0]) * 0.5,
                (r1[0][1] + r1[1][1]) * 0.5
            ], r2);
        }
        // calculate inside heirarchy
        //
        //  _____________________   _______    roots -> A       -> F
        // |          A          | |   F   |            |          |
        // |  _______   _______  | |  ___  |            +-- B      +-- G
        // | |   B   | |   C   | | | |   | |            |   |
        // | |  ___  | |  ___  | | | |   | |            |   +-- D
        // | | | D | | | | E | | | | | G | |            |
        // | | |___| | | |___| | | | |   | |            +-- C
        // | |_______| |_______| | | |___| |                |
        // |_____________________| |_______|                +-- E
        function newNode(region) {
            return {
                region: region,
                children: []
            };
        }
        var roots = newNode(null);
        function addChild(root, region) {
            // first check if we're inside any children
            for(var i = 0; i < root.children.length; i++){
                var child = root.children[i];
                if (regionInsideRegion(region, child.region)) {
                    // we are, so insert inside them instead
                    addChild(child, region);
                    return;
                }
            }
            // not inside any children, so check to see if any children are inside us
            var node = newNode(region);
            for(var i = 0; i < root.children.length; i++){
                var child = root.children[i];
                if (regionInsideRegion(child.region, region)) {
                    // oops... move the child beneath us, and remove them from root
                    node.children.push(child);
                    root.children.splice(i, 1);
                    i--;
                }
            }
            // now we can add ourselves
            root.children.push(node);
        }
        // add all regions to the root
        for(var i = 0; i < poly.regions.length; i++){
            var region = poly.regions[i];
            if (region.length < 3) continue;
            addChild(roots, region);
        }
        // with our heirarchy, we can distinguish between exterior borders, and interior holes
        // the root nodes are exterior, children are interior, children's children are exterior,
        // children's children's children are interior, etc
        // while we're at it, exteriors are counter-clockwise, and interiors are clockwise
        function forceWinding(region, clockwise) {
            // first, see if we're clockwise or counter-clockwise
            // https://en.wikipedia.org/wiki/Shoelace_formula
            var winding = 0;
            var last_x = region[region.length - 1][0];
            var last_y = region[region.length - 1][1];
            var copy = [];
            for(var i = 0; i < region.length; i++){
                var curr_x = region[i][0];
                var curr_y = region[i][1];
                copy.push([
                    curr_x,
                    curr_y
                ]); // create a copy while we're at it
                winding += curr_y * last_x - curr_x * last_y;
                last_x = curr_x;
                last_y = curr_y;
            }
            // this assumes Cartesian coordinates (Y is positive going up)
            var isclockwise = winding < 0;
            if (isclockwise !== clockwise) copy.reverse();
            // while we're here, the last point must be the first point...
            copy.push([
                copy[0][0],
                copy[0][1]
            ]);
            return copy;
        }
        var geopolys = [];
        function addExterior(node) {
            var poly = [
                forceWinding(node.region, false)
            ];
            geopolys.push(poly);
            // children of exteriors are interior
            for(var i = 0; i < node.children.length; i++)poly.push(getInterior(node.children[i]));
        }
        function getInterior(node) {
            // children of interiors are exterior
            for(var i = 0; i < node.children.length; i++)addExterior(node.children[i]);
            // return the clockwise interior
            return forceWinding(node.region, true);
        }
        // root nodes are exterior
        for(var i = 0; i < roots.children.length; i++)addExterior(roots.children[i]);
        // lastly, construct the approrpriate GeoJSON object
        if (geopolys.length <= 0) return {
            type: 'Polygon',
            coordinates: []
        };
        if (geopolys.length == 1) return {
            type: 'Polygon',
            coordinates: geopolys[0]
        };
        return {
            type: 'MultiPolygon',
            coordinates: geopolys
        };
    }
};
module.exports = $53aced1c8d5f94f2$var$GeoJSON;

});



parcelRegister("iEhC9", function(module, exports) {

$parcel$export(module.exports, "useLayoutCanvasState", () => $7d9cb92274123a54$export$a21876b505bdbd65);
$parcel$export(module.exports, "INFO_AND_CURRENT_AIRCRAFT_WIDTH", () => $7d9cb92274123a54$export$1f43794fd78f76cb);
$parcel$export(module.exports, "RampsPresenter", () => $7d9cb92274123a54$export$7bedfb93fa65e6af);

var $ayMG0 = parcelRequire("ayMG0");

var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $f4OIt = parcelRequire("f4OIt");

var $ZD2ym = parcelRequire("ZD2ym");

var $ciKN1 = parcelRequire("ciKN1");

var $1KiAb = parcelRequire("1KiAb");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");

var $eXGdF = parcelRequire("eXGdF");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");

var $d1mLJ = parcelRequire("d1mLJ");
parcelRequire("6qWGE");
var $c0zpU = parcelRequire("c0zpU");
parcelRequire("baghD");
var $drjQE = parcelRequire("drjQE");

var $jbTvW = parcelRequire("jbTvW");

var $14j5W = parcelRequire("14j5W");

var $dLqAw = parcelRequire("dLqAw");

var $3JLDK = parcelRequire("3JLDK");

var $8vHzJ = parcelRequire("8vHzJ");

var $lFx3G = parcelRequire("lFx3G");
const $7d9cb92274123a54$export$a21876b505bdbd65 = (0, $f4OIt.create)()((set)=>({
        x0: 0,
        setX0: (x0)=>set({
                x0: x0
            }),
        y0: 0,
        setY0: (y0)=>set({
                y0: y0
            }),
        initialPositionOffset: {
            xFeet: 0,
            yFeet: 0
        },
        setInitialPositionOffset: (initialPositionOffset)=>set({
                initialPositionOffset: initialPositionOffset
            })
    }));
const $7d9cb92274123a54$export$1f43794fd78f76cb = 400;
const $7d9cb92274123a54$export$7bedfb93fa65e6af = ()=>{
    const navigate = (0, $aphAM.useNavigate)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { ramp: ramp, setRamp: setRamp, history: history } = (0, $1KiAb.useRampState)();
    const [zoomLevel, setZoomLevel] = $acw62.useState(1);
    const [width, setWidth] = $acw62.useState(700);
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const div = $acw62.useCallback((node)=>{
        const heightOffsetForRamp = 150;
        if (node?.offsetWidth && node?.offsetHeight) {
            const widthBasedOnAvaiableWidth = node.offsetWidth;
            const widthBasedOnAvailableHeight = node.offsetHeight * ramp.width / ramp.depth - heightOffsetForRamp;
            setWidth(Math.min(widthBasedOnAvaiableWidth, widthBasedOnAvailableHeight));
        }
    }, [
        isDrawerOpen
    ]);
    const setStack = $acw62.useCallback((stack)=>{
        setRamp((ramp)=>({
                ...ramp,
                stack: {
                    ...ramp.stack,
                    ...stack
                }
            }));
    }, [
        setRamp
    ]);
    // Get AutoPark hook for incremental parking
    const { handleIncrementalPark: handleIncrementalPark } = (0, $dLqAw.useAutoPark)(ramp, ramp.stack, setStack);
    const zoomedWith = width * zoomLevel;
    const { feetToPixels: feetToPixels } = (0, $d1mLJ.useDimensions)({
        location: {
            type: "ramp",
            ...ramp
        },
        width: zoomedWith,
        height: zoomedWith * ramp.depth / ramp.width
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciKN1.AutocompleteResultsContainer), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
            direction: "column",
            justifyContent: "center",
            sx: {
                height: "100%",
                width: "100%"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                sx: {
                    width: "100%",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3JLDK.CollapsibleRampActionCard), {
                        location: {
                            type: "ramp",
                            ...ramp
                        },
                        onClickBack: ()=>navigate("/ramps"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            sx: {
                                maxHeight: "100%",
                                width: isDrawerOpen ? $7d9cb92274123a54$export$1f43794fd78f76cb : 125
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vHzJ.RampInfoCard), {
                                    isDrawerOpen: isDrawerOpen,
                                    ramp: ramp
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $14j5W.AutoPark), {
                                    ramp: ramp,
                                    stack: ramp.stack,
                                    setStack: setStack,
                                    isDrawerOpen: isDrawerOpen
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jbTvW.AircraftFinder), {
                                    mini: !isDrawerOpen,
                                    tenants: ramp.stack.tenants ?? [],
                                    onSelect: (tenant)=>{
                                        setStack({
                                            ...ramp.stack,
                                            tenants: ramp.stack.tenants.map((t)=>({
                                                    ...t,
                                                    selected: t.id === tenant.id
                                                }))
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eXGdF.CurrentAircraft), {
                                    feetToPixels: feetToPixels,
                                    readOnly: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                                    location: {
                                        type: "ramp",
                                        ...ramp
                                    },
                                    stack: ramp.stack,
                                    setStack: (stack)=>{
                                        setRamp({
                                            ...ramp,
                                            stack: {
                                                ...ramp.stack,
                                                ...stack
                                            }
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        sx: {
                            flex: 1,
                            height: "100%",
                            width: "100%"
                        },
                        ref: div,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0zpU.LayoutToolbar), {
                                location: {
                                    type: "ramp",
                                    ...ramp
                                },
                                setLocation: ({ type: _type, ...location })=>setRamp({
                                        ...ramp,
                                        ...location
                                    }),
                                stack: ramp.stack,
                                setStack: setStack,
                                setStacks: ()=>{
                                // don't need this b/c not autostacking
                                },
                                onClickUndo: ()=>{
                                    history && history.undo();
                                },
                                renderOnPrint: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lFx3G.RampPrintLayout), {
                                        ramp: ramp,
                                        stack: ramp.stack
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    flex: 1,
                                    // This stops the aircraft being dragged outside of this section
                                    // overflow: "scroll",
                                    position: "relative",
                                    height: "100%",
                                    margin: "20px"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                                    width: zoomedWith,
                                    location: {
                                        type: "ramp",
                                        ...ramp
                                    },
                                    stack: ramp?.stack,
                                    setStack: setStack,
                                    options: {
                                        hideUnplaced: false,
                                        readOnly: false,
                                        frozen: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                                        printable: false,
                                        selectable: false
                                    },
                                    zoomLevel: zoomLevel,
                                    onIncrementalPark: handleIncrementalPark
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drjQE.ZoomControl), {
                        currentZoom: zoomedWith,
                        increment: 0.1,
                        onClickPlus: (newZoomLevel)=>setZoomLevel(newZoomLevel),
                        onClickMinus: (newZoomLevel)=>setZoomLevel(newZoomLevel)
                    })
                ]
            })
        })
    });
};

});
parcelRegister("ciKN1", function(module, exports) {

$parcel$export(module.exports, "AutocompleteResultsContainer", () => $79df272b5dad15e3$export$e648eb5ba0009eb6);
$parcel$export(module.exports, "useAutocompleteResults", () => $79df272b5dad15e3$export$a89782deeafddee4);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ay9Yf = parcelRequire("ay9Yf");
const $79df272b5dad15e3$var$useAutocompleteResultsContainerState = ()=>{
    const [autocompleteResults, setAutocompleteResults] = $acw62.useState({
        id: null,
        hash: null,
        loading: false,
        tenant: null,
        orientation: null,
        suggestedPositions: []
    });
    return {
        autocompleteResults: autocompleteResults,
        setAutocompleteResults: setAutocompleteResults
    };
};
const $79df272b5dad15e3$var$AutocompleteResultsContainerState = (0, $ay9Yf.createContainer)($79df272b5dad15e3$var$useAutocompleteResultsContainerState);
const $79df272b5dad15e3$export$e648eb5ba0009eb6 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($79df272b5dad15e3$var$AutocompleteResultsContainerState.Provider, {
        children: children
    });
};
const $79df272b5dad15e3$export$a89782deeafddee4 = $79df272b5dad15e3$var$AutocompleteResultsContainerState.useContainer;

});

parcelRegister("1KiAb", function(module, exports) {

$parcel$export(module.exports, "RampStateContainer", () => $65bbf5f0e71cb5a2$export$fa36f095765cf934);
$parcel$export(module.exports, "useRampState", () => $65bbf5f0e71cb5a2$export$7c944fc0baa27a12);
$parcel$export(module.exports, "useOptionalRampState", () => $65bbf5f0e71cb5a2$export$22fb455a334a80aa);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $h4tDu = parcelRequire("h4tDu");

var $cBL90 = parcelRequire("cBL90");
const $65bbf5f0e71cb5a2$var$RampStateContainerState = /*#__PURE__*/ $acw62.createContext(undefined);
const $65bbf5f0e71cb5a2$export$fa36f095765cf934 = ({ children: children, initialState: initialState })=>{
    const { ready: ready, ramp: ramp, setRamp: setRamp, history: history } = (0, $h4tDu.useRamp)(initialState.ramp_id, initialState.isReference ?? false, initialState.includeReferenceImage ?? false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($65bbf5f0e71cb5a2$var$RampStateContainerState.Provider, {
        value: {
            ramp: ramp,
            setRamp: setRamp,
            history: history,
            isReference: initialState.isReference
        },
        children: ready ? children : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cBL90.RampSkeleton), {})
    });
};
const $65bbf5f0e71cb5a2$export$7c944fc0baa27a12 = ()=>{
    const context = $acw62.useContext($65bbf5f0e71cb5a2$var$RampStateContainerState);
    if (!context) throw new Error("useRampState must be used within a RampStateContainer");
    return context;
};
const $65bbf5f0e71cb5a2$export$22fb455a334a80aa = ()=>{
    const context = $acw62.useContext($65bbf5f0e71cb5a2$var$RampStateContainerState);
    return context;
};

});
parcelRegister("h4tDu", function(module, exports) {

$parcel$export(module.exports, "useRamp", () => $4c9b8310d8981e8f$export$af72ff5755343756);

var $lLxKB = parcelRequire("lLxKB");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $8GP8k = parcelRequire("8GP8k");

var $abvRu = parcelRequire("abvRu");

var $6TVXD = parcelRequire("6TVXD");

var $W9FY8 = parcelRequire("W9FY8");
const $4c9b8310d8981e8f$export$af72ff5755343756 = (ramp_id, isReference, includeReferenceImage)=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [ready, setReady] = $acw62.useState(false);
    const [ramp, setRamp, undo] = (0, $6TVXD.useStateHistory)(null, (0, $abvRu.isLocationChangeMeaningful));
    // 'stack' is just for convenience. the data that gets synced is the stack[] since it's now a table.
    $acw62.useEffect(()=>{
        if (!ramp?.stack) return;
        setRamp({
            ...ramp,
            stacks: ramp?.stacks?.map((stack)=>stack.id === ramp.stack.id ? ramp.stack : stack)
        });
    }, [
        (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify(ramp?.stack) ?? "")
    ]);
    (0, $W9FY8.default)({
        thingToWatch: ramp,
        tableName: "ramp"
    });
    const stacks = ramp?.stacks ?? [];
    (0, $W9FY8.default)({
        tableName: "stack",
        thingToWatch: Boolean(ramp) ? stacks : null
    });
    (0, $W9FY8.default)({
        // pass in null until we actually have data
        thingToWatch: Boolean(ramp) ? ramp?.stack?.tenants : null,
        tableName: "tenant",
        deleteFromDatabase: async ()=>{
        // we don't actually delete tenants. they just leave the hangar. we're still
        // tracking them in this file b/c we need to be able to edit their info from
        // the hangar.
        }
    });
    (0, $W9FY8.default)({
        thingToWatch: Boolean(ramp) ? ramp?.stack?.movableObstacles : null,
        tableName: "movable_obstacle",
        deleteFromDatabase: async ()=>{
        // we don't actually delete movable obstacles. they just leave the ramp. we're still
        // tracking them in this file b/c we need to be able to edit their info from
        // the ramp.
        }
    });
    const currentPositions = [];
    for (const stack of ramp?.stacks ?? []){
        for (const tenant of stack.tenants ?? [])currentPositions.push(tenant.position);
        for (const movableObstacle of stack.movableObstacles ?? [])currentPositions.push(movableObstacle.position);
    }
    (0, $W9FY8.default)({
        // pass in null until we actually have data
        thingToWatch: Boolean(ramp) ? currentPositions : null,
        tableName: "position",
        debounce: 500
    });
    (0, $W9FY8.default)({
        thingToWatch: Boolean(ramp) ? ramp?.markings : null,
        tableName: "marking"
    });
    (0, $W9FY8.default)({
        thingToWatch: Boolean(ramp) ? ramp?.shapes : null,
        tableName: "shape"
    });
    (0, $W9FY8.default)({
        thingToWatch: Boolean(ramp) ? ramp?.calibration_points : null,
        tableName: "calibration_point"
    });
    // ok let's grab the ramp! we only do this once. changes are tracked in memory that
    // match with the db
    $acw62.useEffect(()=>{
        (async ()=>{
            const zRamp = await (0, $8GP8k.fetchRamp)(postgrest, activeFBO, ramp_id, isReference, includeReferenceImage);
            setRamp({
                ...zRamp
            });
            setReady(true);
        })();
    }, [
        ramp_id
    ]);
    return {
        ready: ready && Boolean(ramp),
        ramp: ramp,
        setRamp: setRamp,
        isReference: isReference,
        history: {
            undo: undo
        }
    };
};

});
parcelRegister("abvRu", function(module, exports) {

$parcel$export(module.exports, "extractImportantLocationState", () => $ae308683258995d2$export$1fbd6dc5a52adfbb);
$parcel$export(module.exports, "isLocationChangeMeaningful", () => $ae308683258995d2$export$88a36d7efc895711);

var $lLxKB = parcelRequire("lLxKB");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $cLNZr = parcelRequire("cLNZr");

var $8GP8k = parcelRequire("8GP8k");

var $6TVXD = parcelRequire("6TVXD");

var $W9FY8 = parcelRequire("W9FY8");
const $ae308683258995d2$export$1fbd6dc5a52adfbb = (location)=>{
    if (!location?.stack) return null;
    const state = location.stack.tenants.sort((a, b)=>a.id.localeCompare(b.id)).map((t)=>({
            position: (0, $cLNZr.pick)(t.position, [
                "x",
                "y",
                "angle"
            ])
        }));
    return state;
};
const $ae308683258995d2$export$88a36d7efc895711 = (oldState, newState)=>{
    const oldStateHash = (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify($ae308683258995d2$export$1fbd6dc5a52adfbb(oldState)));
    const newStateHash = (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify($ae308683258995d2$export$1fbd6dc5a52adfbb(newState)));
    return oldStateHash !== newStateHash;
};
const $ae308683258995d2$export$a8029465d8244cf2 = (hangar_id, isReference)=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [ready, setReady] = $acw62.useState(false);
    // const [hangar, setHangar] = React.useState<Hangar>(null);
    const [hangar, setHangar] = (0, $6TVXD.useStateHistory)(null, $ae308683258995d2$export$88a36d7efc895711);
    // 'stack' is just for convenience. the data that gets synced is the stack[] since it's now a table.
    $acw62.useEffect(()=>{
        if (!hangar?.stack) return;
        setHangar({
            ...hangar,
            stacks: hangar?.stacks?.map((stack)=>stack.id === hangar.stack.id ? hangar.stack : stack)
        });
    }, [
        (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify(hangar?.stack) ?? "")
    ]);
    (0, $W9FY8.default)({
        thingToWatch: hangar,
        tableName: "hangar"
    });
    const stacks = hangar?.stacks ?? [];
    (0, $W9FY8.default)({
        tableName: "stack",
        thingToWatch: Boolean(hangar) ? stacks : null
    });
    (0, $W9FY8.default)({
        // pass in null until we actually have data
        thingToWatch: Boolean(hangar) ? hangar?.stack?.tenants : null,
        tableName: "tenant",
        deleteFromDatabase: async ()=>{
        // we don't actually delete tenants. they just leave the hangar. we're still
        // tracking them in this file b/c we need to be able to edit their info from
        // the hangar.
        }
    });
    (0, $W9FY8.default)({
        thingToWatch: Boolean(hangar) ? hangar?.stack?.movableObstacles : null,
        tableName: "movable_obstacle",
        deleteFromDatabase: async ()=>{
        // we don't actually delete movable obstacles. they just leave the hangar. we're still
        // tracking them in this file b/c we need to be able to edit their info from
        // the hangar.
        }
    });
    const currentPositions = [];
    for (const stack of hangar?.stacks ?? []){
        for (const tenant of stack.tenants ?? [])currentPositions.push(tenant.position);
        for (const movableObstacle of stack.movableObstacles ?? [])currentPositions.push(movableObstacle.position);
    }
    (0, $W9FY8.default)({
        // pass in null until we actually have data
        thingToWatch: Boolean(hangar) ? currentPositions : null,
        tableName: "position",
        debounce: 500
    });
    (0, $W9FY8.default)({
        thingToWatch: Boolean(hangar) ? hangar?.obstacles : null,
        tableName: "obstacle"
    });
    (0, $W9FY8.default)({
        thingToWatch: Boolean(hangar) ? hangar?.garageDoors : null,
        tableName: "garage_door"
    });
    // ok let's grab the hangar! we only do this once. changes made in memory will be
    // synced to the database via the useSyncToTable hook
    $acw62.useEffect(()=>{
        (async ()=>{
            const zHangar = await (0, $8GP8k.fetchHangar)(postgrest, activeFBO, hangar_id, isReference);
            setHangar(zHangar);
            setReady(true);
        })();
    }, []);
    return {
        ready: ready && Boolean(hangar),
        hangar: hangar,
        setHangar: (newHangar)=>{
            setHangar(newHangar);
        },
        history: {
            undo: (current, next)=>{
                return {
                    ...current,
                    stack: {
                        ...current.stack,
                        // replace the positions of the current with the positions of the next
                        tenants: current.stack.tenants.map((t)=>{
                            const nextTenant = next.stack.tenants.find((nt)=>nt.id === t.id);
                            if (!nextTenant) return t;
                            return {
                                ...t,
                                position: nextTenant.position
                            };
                        }),
                        movableObstacles: current.stack.movableObstacles.map((mo)=>{
                            const nextMovableObstacle = next.stack.movableObstacles.find((nmo)=>nmo.id === mo.id);
                            if (!nextMovableObstacle) return mo;
                            return {
                                ...mo,
                                position: nextMovableObstacle.position
                            };
                        })
                    }
                };
            }
        },
        isReference: isReference
    };
};

});
parcelRegister("6TVXD", function(module, exports) {

$parcel$export(module.exports, "useStateHistory", () => $0a8fa0f7cf815e54$export$b4effed71825dc9c);

var $acw62 = parcelRequire("acw62");
function $0a8fa0f7cf815e54$export$b4effed71825dc9c(_initialValue, predicate = ()=>true // Default predicate always returns true
) {
    const [stateHistory, setStateHistory] = (0, $acw62.useState)([]);
    const currentState = stateHistory[stateHistory.length - 1];
    const updateState = (0, $acw62.useCallback)((newValue)=>{
        setStateHistory((prev)=>{
            const resolvedValue = newValue instanceof Function ? newValue(currentState) : newValue;
            // Only update history if the predicate returns true and the new value is different
            if (predicate(currentState, resolvedValue)) return [
                ...prev,
                resolvedValue
            ];
            // Otherwise, return the current history. we will always replace the last item with the new value
            return [
                ...prev.slice(0, prev.length - 1),
                resolvedValue
            ];
        });
    }, [
        currentState,
        predicate
    ]); // Ensure predicate is stable or wrapped in useCallback if defined outside the hook
    const undo = (0, $acw62.useCallback)(()=>{
        const rollbackToState = stateHistory[stateHistory.length - 1];
        setStateHistory((prev)=>{
            if (prev.length > 1) return prev.slice(0, prev.length - 1);
            return prev;
        });
        return rollbackToState;
    }, []);
    return [
        currentState,
        updateState,
        undo
    ];
}

});



parcelRegister("cBL90", function(module, exports) {

$parcel$export(module.exports, "RampSkeleton", () => $e06a339ec0e9dd76$export$2b79203e498ddb22);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $lkxXU = parcelRequire("lkxXU");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
const $e06a339ec0e9dd76$export$2b79203e498ddb22 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            height: "100%",
            width: "100%",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: {
                        p: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                variant: "text",
                                width: 250,
                                height: 40
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rounded",
                                    width: 120,
                                    height: 40,
                                    sx: {
                                        animation: "pulse 1.5s ease-in-out 0.5s infinite"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rounded",
                                    width: 120,
                                    height: 40,
                                    sx: {
                                        animation: "pulse 1.5s ease-in-out 0.6s infinite"
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    sx: {
                        height: "calc(100% - 64px)",
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 2,
                            sx: {
                                width: 300,
                                p: 2,
                                borderRight: "1px solid rgba(0, 0, 0, 0.12)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                    variant: "outlined",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "h6",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                        width: 150
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 80
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 60
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 80
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 60
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                width: 120
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                width: 40
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle1",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                        width: 150
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    spacing: 1,
                                    children: [
                                        ...Array(5)
                                    ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                            variant: "outlined",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                                                sx: {
                                                    py: 1,
                                                    "&:last-child": {
                                                        pb: 1
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                            variant: "rectangular",
                                                            width: 40,
                                                            height: 40,
                                                            sx: {
                                                                borderRadius: 1,
                                                                animation: `pulse 1.5s ease-in-out ${0.5 + index * 0.1}s infinite`
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 120
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "caption",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 80
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, `aircraft-skeleton-${index}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                flex: 1,
                                position: "relative",
                                backgroundColor: "#f5f5f5",
                                overflow: "hidden"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: "100%",
                                    sx: {
                                        position: "absolute",
                                        animation: "pulse 1.5s ease-in-out 0.3s infinite",
                                        opacity: 0.7
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0
                                    },
                                    children: [
                                        [
                                            ...Array(5)
                                        ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                variant: "rectangular",
                                                width: "80%",
                                                height: 2,
                                                sx: {
                                                    position: "absolute",
                                                    top: `${15 + index * 20}%`,
                                                    left: "10%",
                                                    animation: `pulse 1.5s ease-in-out ${0.3 + index * 0.1}s infinite`,
                                                    opacity: 0.5
                                                }
                                            }, `h-marking-${index}`)),
                                        [
                                            ...Array(4)
                                        ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                variant: "rectangular",
                                                width: 2,
                                                height: "70%",
                                                sx: {
                                                    position: "absolute",
                                                    top: "15%",
                                                    left: `${20 + index * 20}%`,
                                                    animation: `pulse 1.5s ease-in-out ${0.3 + index * 0.1}s infinite`,
                                                    opacity: 0.5
                                                }
                                            }, `v-marking-${index}`)),
                                        [
                                            ...Array(3)
                                        ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                variant: "rounded",
                                                width: 120,
                                                height: 60,
                                                sx: {
                                                    position: "absolute",
                                                    top: `${20 + index * 25}%`,
                                                    left: `${25 + index * 15}%`,
                                                    animation: `pulse 1.5s ease-in-out ${0.5 + index * 0.2}s infinite`,
                                                    opacity: 0.6,
                                                    transform: `rotate(${index * 30}deg)`
                                                }
                                            }, `aircraft-shape-${index}`))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("eXGdF", function(module, exports) {

$parcel$export(module.exports, "CurrentAircraft", () => $e4cfdf4cbd596eae$export$cb675817ad8bbf7a);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $6rxM8 = parcelRequire("6rxM8");

var $dLqAw = parcelRequire("dLqAw");

var $3JLDK = parcelRequire("3JLDK");

var $8ORjT = parcelRequire("8ORjT");

var $lNEp2 = parcelRequire("lNEp2");

var $8QpHy = parcelRequire("8QpHy");

var $ZrAde = parcelRequire("ZrAde");
const $e4cfdf4cbd596eae$export$cb675817ad8bbf7a = ({ location: location, stack: stack, setStack: setStack, width: width, feetToPixels: feetToPixels, readOnly: readOnly = false, disableAutoOpen: disableAutoOpen = false, isScheduledView: isScheduledView = false, onAddTrip: onAddTrip, currentTime: currentTime })=>{
    const theme = (0, $14H9o.default)();
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const { sendToLocation: sendToLocation } = (0, $6rxM8.useLocationsState)();
    // Only use AutoPark hook for ramps
    const isRamp = location.type === "ramp";
    const autoPark = isRamp ? (0, $dLqAw.useAutoPark)(location, stack, setStack) : null;
    const sortedTenants = $acw62.useMemo(()=>[
            ...stack.tenants
        ].sort((a, b)=>{
            if (a.selected) return -1;
            if (b.selected) return 1;
            return a.tail_number.localeCompare(b.tail_number);
        }).filter((t)=>t.position.stack_id === stack.id).filter((tenant)=>tenant.aircraft?.make), [
        stack.tenants
    ]);
    // const sortedTenants = React.useMemo(() => stack.tenants, [stack.tenants]);
    const onAddAircraft = $acw62.useCallback((tenant)=>{
        if (Array.isArray(tenant)) {
            setStack({
                ...stack,
                tenants: [
                    ...tenant,
                    ...stack.tenants
                ]
            });
            return;
        }
        setStack({
            ...stack,
            tenants: [
                tenant,
                ...stack.tenants
            ]
        });
    }, [
        stack,
        setStack
    ]);
    const setTenant = $acw62.useCallback((tenant)=>{
        setStack({
            ...stack,
            tenants: stack.tenants.map((t)=>t.id === tenant.id ? tenant : t)
        });
    }, [
        stack,
        setStack
    ]);
    const onDeleteAircraft = $acw62.useCallback((tenant)=>{
        setStack({
            ...stack,
            tenants: stack.tenants.filter((t)=>t.placement_id !== tenant.placement_id)
        });
    }, [
        stack,
        setStack
    ]);
    const onSelectAircraft = $acw62.useCallback((tenant)=>{
        setStack({
            ...stack,
            tenants: stack.tenants.map((t)=>({
                    ...t,
                    selected: t.placement_id === tenant.placement_id ? !t.selected : false
                }))
        });
    }, [
        stack,
        setStack
    ]);
    if (!isDrawerOpen) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        spacing: 2,
        sx: {
            width: "100%",
            height: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ORjT.AddTenantButton), {
                iconButton: true,
                disabled: readOnly,
                onAdd: onAddAircraft,
                location: location,
                sendToLocation: sendToLocation,
                stack: stack,
                setStack: setStack,
                feetToPixels: feetToPixels,
                disableAutoOpen: disableAutoOpen,
                isScheduledView: isScheduledView,
                onAddTrip: onAddTrip,
                currentTime: currentTime
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                flexItem: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                alignItems: "center",
                sx: {
                    overflowY: "auto",
                    overflowX: "hidden",
                    width: "100%",
                    ...(0, $lNEp2.scrollSx)
                },
                children: sortedTenants.map((tenant)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        placement: "right",
                        title: `${tenant.tail_number || "N/A"} \u{2022}\xa0${tenant.aircraft.model}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            spacing: 1,
                            p: 1,
                            sx: {
                                width: "100%",
                                cursor: "pointer",
                                bgcolor: tenant.selected ? `${theme.palette.success.main}15` : "transparent",
                                "&:hover": {
                                    backgroundColor: `${theme.palette.success.main}15`
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    noWrap: true,
                                    maxWidth: 60,
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        onSelectAircraft(tenant);
                                    },
                                    children: tenant.tail_number || tenant.aircraft.model
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ZrAde.AircraftPreferencesListItemMenuButton), {
                                    stack: stack,
                                    setStack: setStack,
                                    tenant: tenant,
                                    setTenant: setTenant,
                                    preferences: tenant.position.preferences,
                                    setPreferences: (preferences)=>{
                                        setTenant({
                                            ...tenant,
                                            position: {
                                                ...tenant.position,
                                                preferences: preferences
                                            }
                                        });
                                    },
                                    onDeleteAircraft: ()=>onDeleteAircraft(tenant),
                                    onIncrementalPark: autoPark?.handleIncrementalPark || undefined
                                })
                            ]
                        }, `current-aircraft-${tenant.id}`)
                    }, `current-aircraft-${tenant.id}`))
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        sx: {
            minWidth: width ?? 400,
            height: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                sx: {
                    px: 1.5,
                    py: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: "Current Aircraft"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ORjT.AddTenantButton), {
                        disabled: readOnly,
                        onAdd: onAddAircraft,
                        location: location,
                        sendToLocation: sendToLocation,
                        stack: stack,
                        setStack: setStack,
                        feetToPixels: feetToPixels,
                        isScheduledView: isScheduledView,
                        onAddTrip: onAddTrip,
                        currentTime: currentTime
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    flex: 1,
                    height: "100%",
                    width: "100%",
                    overflowY: "auto",
                    overflowX: "hidden"
                },
                children: sortedTenants.map((tenant, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8QpHy.AircraftListItem), {
                                showBottomBorder: idx + 1 === stack.tenants.length,
                                stack: stack,
                                setStack: setStack,
                                tenant: tenant,
                                setTenant: setTenant,
                                onSelectAircraft: onSelectAircraft,
                                onDeleteAircraft: onDeleteAircraft,
                                onIncrementalPark: autoPark?.handleIncrementalPark || undefined
                            })
                        ]
                    }, `current-aircraft-${tenant.id}`))
            })
        ]
    });
};

});
parcelRegister("dLqAw", function(module, exports) {

$parcel$export(module.exports, "useAutoPark", () => $4659b73692a35ca8$export$4e9e7589b88f0721);

var $acw62 = parcelRequire("acw62");

var $6fDLr = parcelRequire("6fDLr");

var $8GP8k = parcelRequire("8GP8k");

var $jYWTx = parcelRequire("jYWTx");

var $aDzfS = parcelRequire("aDzfS");

var $3kHDf = parcelRequire("3kHDf");

var $hWiqZ = parcelRequire("hWiqZ");

var $8a5rg = parcelRequire("8a5rg");

var $i8ggZ = parcelRequire("i8ggZ");

var $h7RLZ = parcelRequire("h7RLZ");

var $kJI4m = parcelRequire("kJI4m");
function $4659b73692a35ca8$export$4e9e7589b88f0721(ramp, stack, setStack, isScheduledView, placementService, currentTime, postgrest, fbo, onScheduledUpdate) {
    const [dialogOpen, setDialogOpen] = (0, $acw62.useState)(false);
    const [logDialogOpen, setLogDialogOpen] = (0, $acw62.useState)(false);
    const [lastResult, setLastResult] = (0, $acw62.useState)(null);
    const [isApplying, setIsApplying] = (0, $acw62.useState)(false);
    const [applyProgress, setApplyProgress] = (0, $acw62.useState)({
        current: 0,
        total: 0,
        currentItem: ""
    });
    const snackbar = (0, $6fDLr.useSnackbar)();
    // Time range state for scheduled view
    // Use currentTime from scheduled view if available, otherwise default to now
    const now = currentTime || new Date();
    const tomorrow = new Date(now.getTime() + 86400000);
    const [timeRange, setTimeRange] = (0, $acw62.useState)({
        start: now,
        end: tomorrow
    });
    const [tripCount, setTripCount] = (0, $acw62.useState)(0);
    const [placements, setPlacements] = (0, $acw62.useState)([]);
    const [groupedTrips, setGroupedTrips] = (0, $acw62.useState)([]);
    const [selectedTripIds, setSelectedTripIds] = (0, $acw62.useState)(new Set());
    // Sync timeRange with currentTime when slider moves or dialog opens
    (0, $acw62.useEffect)(()=>{
        if (currentTime) {
            const newStart = currentTime;
            const newEnd = new Date(currentTime.getTime() + 86400000);
            setTimeRange({
                start: newStart,
                end: newEnd
            });
        }
    }, [
        currentTime,
        dialogOpen
    ]);
    // Fetch placements when time range changes (scheduled view only)
    (0, $acw62.useEffect)(()=>{
        if (!isScheduledView || !placementService || !ramp.id) return;
        const fetchPlacements = async ()=>{
            try {
                const fetchedPlacements = await placementService.getPlacementsInTimeRange(timeRange.start, timeRange.end, ramp.id, "ramp");
                // Fetch aircraft data for all placements
                const aircraftIds = Array.from(new Set(fetchedPlacements.map((p)=>p.aircraft_id).filter((id)=>id != null)));
                const aircrafts = await (0, $8GP8k.fetchAircraftWithCache)(postgrest, aircraftIds, fbo);
                const aircraftMap = new Map();
                aircrafts.forEach((aircraft)=>{
                    aircraftMap.set(aircraft.id, aircraft);
                });
                // Enrich placements with aircraft data
                const enrichedPlacements = fetchedPlacements.map((p)=>{
                    const aircraft = p.aircraft_id ? aircraftMap.get(p.aircraft_id) : undefined;
                    return {
                        ...p,
                        aircraft_make: aircraft?.make,
                        aircraft_model: aircraft?.model
                    };
                });
                setPlacements(enrichedPlacements);
                // Group placements by trip_id for display
                const grouped = (0, $kJI4m.groupPlacementsByTrip)(enrichedPlacements);
                setGroupedTrips(grouped);
                setTripCount(grouped.length);
                // Default all trips to selected
                const allTripIds = new Set(enrichedPlacements.map((p)=>p.trip_id));
                setSelectedTripIds(allTripIds);
            } catch (error) {
                console.error("[AutoPark useEffect] Failed to fetch placements:", error);
                setPlacements([]);
                setGroupedTrips([]);
                setTripCount(0);
                setSelectedTripIds(new Set());
            }
        };
        fetchPlacements();
    }, [
        isScheduledView,
        placementService,
        ramp.id,
        timeRange.start,
        timeRange.end,
        postgrest,
        fbo
    ]);
    // Use shared parking config hook with AutoPark defaults
    const parkingConfig = (0, $aDzfS.useParkingConfig)({
        bufferMinutes: 15,
        // Standard buffer
        plannedMoveCap: 0,
        // AutoPark default: no planned moves
        allowTrapping: true,
        // Allow temporal trapping (not a true trap if departure times allow egress)
        egressWeight: 1.0,
        wasteWeight: 1.0,
        structuralWeight: 0.1,
        sortingStrategy: "size-constrained",
        zonePriorityWeight: 1.0
    });
    const handleOpenDialog = (0, $acw62.useCallback)(()=>{
        setDialogOpen(true);
    }, []);
    const handleCloseDialog = (0, $acw62.useCallback)(()=>{
        setDialogOpen(false);
    }, []);
    const handleOpenLogDialog = (0, $acw62.useCallback)(()=>{
        setLogDialogOpen(true);
    }, []);
    const handleCloseLogDialog = (0, $acw62.useCallback)(()=>{
        setLogDialogOpen(false);
    }, []);
    // Snapshot parking (for CurrentRamp view - all aircraft at one moment)
    const runSnapshotAutoPark = (0, $acw62.useCallback)(()=>{
        try {
            // Run the placement algorithm asynchronously to prevent UI blocking
            setTimeout(()=>{
                const startTime = performance.now();
                try {
                    // Clear all aircraft positions to start fresh
                    const cleanStack = {
                        ...stack,
                        tenants: stack.tenants.map((tenant)=>({
                                ...tenant,
                                position: {
                                    ...tenant.position,
                                    x: null,
                                    y: null,
                                    angle: null
                                }
                            }))
                    };
                    const result = (0, $8a5rg.runSnapshotParkingOnRamp)(ramp, cleanStack, {
                        allowTrapping: parkingConfig.config.allowTrapping,
                        egressWeight: parkingConfig.config.egressWeight,
                        wasteWeight: parkingConfig.config.wasteWeight,
                        structuralWeight: parkingConfig.config.structuralWeight,
                        sortingStrategy: parkingConfig.config.sortingStrategy,
                        zonePriorityWeight: parkingConfig.config.zonePriorityWeight
                    });
                    // Calculate elapsed time
                    const elapsedMs = performance.now() - startTime;
                    // Add elapsedMs to statistics
                    const resultWithTiming = {
                        ...result,
                        statistics: {
                            ...result.statistics,
                            elapsedMs: elapsedMs
                        }
                    };
                    // Update the stack with new positions
                    setStack(resultWithTiming.updatedStack);
                    // Store the result for decision log viewer
                    setLastResult(resultWithTiming);
                    const severity = result.statistics.unplacedAircraft === 0 ? "success" : result.statistics.placedAircraft > 0 ? "warning" : "error";
                    snackbar.notify({
                        text: `AutoPark: Placed ${result.statistics.placedAircraft}/${result.statistics.totalAircraft} aircraft in ${(elapsedMs / 1000).toFixed(2)}s`,
                        severity: severity
                    });
                } catch (error) {}
            }, 0);
        } catch (error) {}
    }, [
        parkingConfig.config,
        ramp,
        stack,
        setStack,
        snackbar
    ]);
    // Temporal parking (for ScheduledRampView - aircraft have arrival/departure times)
    const runTemporalAutoPark = (0, $acw62.useCallback)(async ()=>{
        const startTime = performance.now();
        try {
            // Validate we have the required dependencies
            if (!postgrest || !fbo) {
                console.error("[Temporal AutoPark] Missing postgrest or fbo");
                snackbar.notify({
                    text: "AutoPark not available: missing required dependencies",
                    severity: "error"
                });
                return;
            }
            // Filter to selected trips (unlocked only - locked will be added separately)
            const selectedPlacements = placements.filter((p)=>selectedTripIds.has(p.trip_id) && !p.is_locked);
            // Also get locked placements in time range to show as fixed constraints
            const lockedPlacements = placements.filter((p)=>p.is_locked);
            if (selectedPlacements.length === 0 && lockedPlacements.length === 0) {
                console.warn("[Temporal AutoPark] No trips selected");
                snackbar.notify({
                    text: "No trips selected. Please select at least one trip to park.",
                    severity: "warning"
                });
                return;
            }
            console.log(`[Temporal AutoPark] Placing ${selectedPlacements.length} selected trips`);
            // Calculate horizon in hours
            const horizonHours = (timeRange.end.getTime() - timeRange.start.getTime()) / 3600000;
            console.log(`[Temporal AutoPark] Time range: ${timeRange.start.toISOString()} to ${timeRange.end.toISOString()} (${horizonHours.toFixed(1)}h)`);
            // Extract unique aircraft IDs from placements
            const aircraftIds = Array.from(new Set(selectedPlacements.map((p)=>p.aircraft_id).filter((id)=>id != null)));
            console.log(`[Temporal AutoPark] Fetching ${aircraftIds.length} aircraft...`);
            // Fetch real aircraft using the cache
            const aircrafts = await (0, $8GP8k.fetchAircraftWithCache)(postgrest, aircraftIds, fbo);
            // Create aircraft lookup map
            const aircraftMap = new Map();
            aircrafts.forEach((aircraft)=>{
                aircraftMap.set(aircraft.id, aircraft);
            });
            console.log(`[Temporal AutoPark] Fetched ${aircrafts.length} aircraft`);
            // Fetch trip-level arrival/departure dates for BOTH selected AND locked trips
            const uniqueTripIds = Array.from(new Set([
                ...selectedPlacements,
                ...lockedPlacements
            ].map((p)=>p.trip_id)));
            console.log(`[Temporal AutoPark] Fetching dates for ${uniqueTripIds.length} unique trips (${selectedPlacements.length} unlocked + ${lockedPlacements.length} locked placements)...`);
            const { data: trips, error: tripError } = await postgrest.from("trip").select("id, arrival_date, departure_date").in("id", uniqueTripIds);
            if (tripError) {
                console.error("[Temporal AutoPark] Failed to fetch trip dates:", tripError);
                snackbar.notify({
                    text: "Failed to load trip data",
                    severity: "error"
                });
                return;
            }
            // Build trip date lookup map
            const tripDateMap = new Map(trips?.map((t)=>[
                    t.id,
                    {
                        arrival_date: new Date(t.arrival_date),
                        departure_date: new Date(t.departure_date)
                    }
                ]) || []);
            console.log(`[Temporal AutoPark] Fetched dates for ${trips?.length || 0} trips`);
            // Deduplicate by trip_id (one placement per trip, not per segment!)
            const tripToPlacementMap = new Map();
            selectedPlacements.forEach((placement)=>{
                if (!tripToPlacementMap.has(placement.trip_id)) tripToPlacementMap.set(placement.trip_id, placement);
            });
            console.log(`[Temporal AutoPark] Deduplicated ${selectedPlacements.length} placement segments ` + `to ${tripToPlacementMap.size} unique trips`);
            console.log(`[Temporal AutoPark] Building parking requests...`);
            // Build ONE ParkingRequest per trip (not per segment!)
            const requests = Array.from(tripToPlacementMap.values()).map((placement)=>{
                // Get the real aircraft object
                const aircraft = placement.aircraft_id ? aircraftMap.get(placement.aircraft_id) : undefined;
                if (!aircraft) {
                    console.warn(`[Temporal AutoPark] Missing aircraft for trip ${placement.trip_id} (aircraft_id: ${placement.aircraft_id}), skipping`);
                    return null;
                }
                // Get trip-level dates (not segment times!)
                const tripDates = tripDateMap.get(placement.trip_id);
                if (!tripDates) {
                    console.warn(`[Temporal AutoPark] Missing trip dates for ${placement.trip_id}, skipping`);
                    return null;
                }
                const sizeCategory = (0, $8a5rg.aircraftToSizeCategory)(aircraft);
                // Use TRIP-LEVEL arrival/departure times (not segment times!)
                const arrivalBucket = (0, $8a5rg.dateToTimeBucket)(tripDates.arrival_date.toISOString(), timeRange.start);
                const departureBucket = (0, $8a5rg.dateToTimeBucket)(tripDates.departure_date.toISOString(), timeRange.start);
                // Clamp to planning window [0, horizonBuckets)
                const maxBucket = horizonHours * 4; // 15-min buckets per hour
                const clampedArrival = Math.max(0, arrivalBucket);
                const clampedDeparture = Math.min(departureBucket, maxBucket);
                // Skip trips that don't overlap the window at all
                if (clampedDeparture <= 0 || clampedArrival >= maxBucket) {
                    console.warn(`[Temporal AutoPark] Trip ${placement.trip_id} (${placement.tail_number}) outside planning window, skipping`);
                    return null;
                }
                // Window-aware staging: only stage if arrival/departure happens in window
                const tripArrivesInWindow = tripDates.arrival_date >= timeRange.start;
                const tripDepartsInWindow = tripDates.departure_date <= timeRange.end;
                return {
                    id: placement.trip_id,
                    // ✅ Use trip_id as unique ID (not placement.id!)
                    tail_number: placement.tail_number || "Unknown",
                    sizeCategory: sizeCategory,
                    arrivalBucket: clampedArrival,
                    departureBucket: clampedDeparture,
                    aircraft: aircraft,
                    trip_id: placement.trip_id,
                    placement_source: placement.placement_source || "auto",
                    is_locked: placement.is_locked || false,
                    metadata: {
                        tripArrivesInWindow: tripArrivesInWindow,
                        tripDepartsInWindow: tripDepartsInWindow
                    }
                };
            }).filter((r)=>r !== null);
            console.log(`[Temporal AutoPark] Built ${requests.length} parking requests`);
            // Extract spots and zones from ramp
            const spots = (0, $8a5rg.buildSpotsFromRamp)(ramp, horizonHours);
            const zones = (0, $8a5rg.buildZonesFromRamp)(ramp);
            const algorithmStart = performance.now();
            // Call parkingAlgorithm directly (bypassing runTemporalParkingOnRamp)
            const placement = (0, $3kHDf.parkingAlgorithm)(requests, spots, parkingConfig.config.bufferMinutes || 15, parkingConfig.config.plannedMoveCap || 0, parkingConfig.config.allowTrapping, parkingConfig.config.egressWeight, parkingConfig.config.wasteWeight, 0.1, // structuralWeight (fixed for temporal)
            "arrival", // sorting strategy (fixed for temporal)
            horizonHours, // shapes parameter removed - using spot.shape
            false, // useMaskOptimization
            false, // validateMasks
            parkingConfig.config.zonePriorityWeight, zones, parkingConfig.config.min_dwell_weight, 0.0, // stickinessWeight (not used in temporal mode)
            parkingConfig.config.enableArrivalStaging, parkingConfig.config.enableDepartureStaging, parkingConfig.config.arrivalStagingDwellMinutes, parkingConfig.config.departureStagingDwellMinutes, parkingConfig.config.quickTurnThresholdMinutes);
            const decisionLog = (0, $3kHDf.getDecisionLog)();
            // Capture test data for duplicate detection (only logs if duplicates found)
            (0, $i8ggZ.captureTestData)(requests, spots, zones, {
                bufferMinutes: parkingConfig.config.bufferMinutes || 15,
                plannedMoveCap: parkingConfig.config.plannedMoveCap || 0,
                allowTrapping: parkingConfig.config.allowTrapping,
                egressWeight: parkingConfig.config.egressWeight,
                wasteWeight: parkingConfig.config.wasteWeight,
                zonePriorityWeight: parkingConfig.config.zonePriorityWeight,
                horizonHours: horizonHours
            }, placement);
            // Calculate statistics
            const placedCount = Object.keys(placement).length;
            const unplacedCount = requests.length - placedCount;
            const algorithmElapsed = performance.now() - algorithmStart;
            console.log(`[Temporal AutoPark] Placement complete (${algorithmElapsed.toFixed(0)}ms):`, placement);
            // Calculate average moves
            let totalMoves = 0;
            let placementsWithSegments = 0;
            Object.values(placement).forEach((p)=>{
                if ("segments" in p && "moveCount" in p) {
                    totalMoves += p.moveCount;
                    placementsWithSegments++;
                }
            });
            const averageMoves = placementsWithSegments > 0 ? totalMoves / placementsWithSegments : 0;
            // Calculate total elapsed time
            const totalElapsedMs = performance.now() - startTime;
            // Detect partial placements (aircraft placed for only part of their trip)
            const partialPlacements = (0, $h7RLZ.detectPartialPlacements)(placement, requests, timeRange.start);
            const partiallyPlacedCount = partialPlacements.length;
            // Update placement_source to 'auto' for successfully placed UNLOCKED aircraft
            // Locked aircraft keep their original placement_source (manual) to show they were user-placed
            const updatedRequests = requests.map((req)=>{
                const wasPlaced = placement[req.id] !== undefined;
                const shouldMarkAsAuto = wasPlaced && !req.is_locked;
                return shouldMarkAsAuto ? {
                    ...req,
                    placement_source: "auto"
                } : req;
            });
            // Build ParkingRequest objects for LOCKED aircraft to show them in timeline
            // Use same logic as unlocked aircraft building
            const lockedTripMap = new Map();
            lockedPlacements.forEach((p)=>{
                if (!lockedTripMap.has(p.trip_id)) lockedTripMap.set(p.trip_id, p);
            });
            const lockedRequests = Array.from(lockedTripMap.values()).map((placement)=>{
                const aircraft = placement.aircraft_id ? aircraftMap.get(placement.aircraft_id) : undefined;
                if (!aircraft) return null;
                const tripDates = tripDateMap.get(placement.trip_id);
                if (!tripDates) return null;
                const sizeCategory = (0, $8a5rg.aircraftToSizeCategory)(aircraft);
                const arrivalBucket = (0, $8a5rg.dateToTimeBucket)(tripDates.arrival_date.toISOString(), timeRange.start);
                const departureBucket = (0, $8a5rg.dateToTimeBucket)(tripDates.departure_date.toISOString(), timeRange.start);
                const maxBucket = horizonHours * 4;
                const clampedArrival = Math.max(0, arrivalBucket);
                const clampedDeparture = Math.min(departureBucket, maxBucket);
                if (clampedDeparture <= 0 || clampedArrival >= maxBucket) return null;
                return {
                    id: placement.trip_id,
                    tail_number: placement.tail_number || "Unknown",
                    sizeCategory: sizeCategory,
                    arrivalBucket: clampedArrival,
                    departureBucket: clampedDeparture,
                    aircraft: aircraft,
                    trip_id: placement.trip_id,
                    placement_source: placement.placement_source || "manual",
                    // Keep as manual
                    is_locked: true,
                    // All locked
                    metadata: {
                        tripArrivesInWindow: tripDates.arrival_date >= timeRange.start,
                        tripDepartsInWindow: tripDates.departure_date <= timeRange.end
                    }
                };
            }).filter((r)=>r !== null);
            // Add synthetic placement entries for locked aircraft (using their current spot from DB)
            // This allows them to appear in the timeline in their locked positions
            const combinedPlacement = {
                ...placement
            };
            lockedRequests.forEach((lockedReq)=>{
                // Find the locked placement's current spot from database
                const lockedDbPlacement = lockedPlacements.find((p)=>p.trip_id === lockedReq.id);
                if (lockedDbPlacement && lockedDbPlacement.x != null && lockedDbPlacement.y != null) {
                    // Map position to spot ID using spot detection
                    const spotId = (0, $hWiqZ.findSpotForPosition)({
                        x: lockedDbPlacement.x,
                        y: lockedDbPlacement.y
                    }, ramp.shapes, ramp.depth);
                    if (spotId) // Add synthetic placement showing locked aircraft in its current spot
                    combinedPlacement[lockedReq.id] = {
                        spotId: spotId,
                        orientationId: "default" // Locked aircraft keep their manual orientation
                    };
                }
            });
            // Combine locked and unlocked requests for timeline display
            const allRequests = [
                ...updatedRequests,
                ...lockedRequests
            ];
            // Create result object matching TemporalPlacementResult interface
            const result = {
                placement: combinedPlacement,
                decisionLog: // Use combined placement (includes locked aircraft)
                decisionLog,
                updatedStack: stack,
                // Don't update stack for now (just show results)
                statistics: {
                    totalAircraft: allRequests.length,
                    // Total includes locked + unlocked
                    placedAircraft: placedCount + lockedRequests.length,
                    // Placed = algo results + locked (already placed)
                    unplacedAircraft: unplacedCount,
                    partiallyPlacedAircraft: partiallyPlacedCount,
                    averageMoves: averageMoves,
                    elapsedMs: totalElapsedMs
                },
                temporalData: {
                    spots: spots,
                    requests: allRequests,
                    zones: // Use combined requests (unlocked + locked)
                    zones,
                    horizonHours: horizonHours,
                    startTime: timeRange.start,
                    partialPlacements: partialPlacements
                }
            };
            // Store the result for decision log viewer
            setLastResult(result);
            // Auto-open the decision log dialog to show results
            handleOpenLogDialog();
            // Log summary
            console.log(`[Temporal AutoPark] Placed ${placedCount}/${requests.length} aircraft`);
            // Show snackbar notification
            const severity = unplacedCount === 0 ? "success" : placedCount > 0 ? "warning" : "error";
            snackbar.notify({
                text: `AutoPark: Placed ${placedCount}/${requests.length} aircraft in ${(algorithmElapsed / 1000).toFixed(2)}s`,
                severity: severity
            });
        } catch (error) {
            console.error("[Temporal AutoPark] Error:", error);
            snackbar.notify({
                text: `AutoPark failed: ${error instanceof Error ? error.message : "Unknown error"}`,
                severity: "error"
            });
        }
    }, [
        ramp,
        stack,
        placements,
        selectedTripIds,
        timeRange,
        parkingConfig.config,
        snackbar,
        postgrest,
        fbo
    ]);
    const handleAutoPark = (0, $acw62.useCallback)(()=>{
        // Close dialog first
        setDialogOpen(false);
        // Check if we have aircraft to place (snapshot mode only - scheduled mode uses selectedPlacements)
        if (!isScheduledView && (!stack.tenants || stack.tenants.length === 0)) return;
        // Check if we have spots
        const spots = ramp.shapes?.filter((s)=>s.type === "Spot") || [];
        if (spots.length === 0) return;
        // Branch on scheduled view mode
        const isScheduledMode = isScheduledView && timeRange && placements.length > 0;
        if (isScheduledMode) runTemporalAutoPark();
        else runSnapshotAutoPark();
    }, [
        isScheduledView,
        timeRange,
        placements,
        ramp,
        stack,
        runTemporalAutoPark,
        runSnapshotAutoPark,
        selectedTripIds
    ]);
    // Handle incremental parking for selected aircraft
    const handleIncrementalPark = (0, $acw62.useCallback)((aircraftId)=>{
        if (!aircraftId) return;
        // Find aircraft by ID (not by selected flag, since it might be toggled off)
        const selectedAircraft = stack.tenants.find((t)=>t.id === aircraftId);
        if (!selectedAircraft) return;
        // Check if we have spots
        const spots = ramp.shapes?.filter((s)=>s.type === "Spot") || [];
        if (spots.length === 0) return;
        try {
            const result = (0, $8a5rg.runIncrementalParkingOnRamp)(ramp, stack, selectedAircraft.id, {
                allowTrapping: parkingConfig.config.allowTrapping,
                egressWeight: parkingConfig.config.egressWeight,
                wasteWeight: parkingConfig.config.wasteWeight,
                structuralWeight: parkingConfig.config.structuralWeight,
                sortingStrategy: parkingConfig.config.sortingStrategy,
                zonePriorityWeight: parkingConfig.config.zonePriorityWeight
            });
            // Update stack with new position
            setStack(result.updatedStack);
            // Store result for decision log viewer
            setLastResult(result);
            // Create aircraft display name with fallback
            const aircraftName = selectedAircraft.tail_number || selectedAircraft.aircraft.model || "Aircraft";
            // Show snackbar notification
            if (result.statistics.placedAircraft === 1) {
                // Success - extract zone and spot information
                const placement = result.placement[selectedAircraft.id];
                if (placement) {
                    const spotId = "spotId" in placement ? placement.spotId : placement.segments[0].spotId;
                    const spotShape = ramp.shapes?.find((s)=>s.id === spotId && s.type === "Spot");
                    const spotName = spotShape?.text || spotId;
                    // Get zone information
                    const zoneId = spotShape?.metadata?.zoneId;
                    const zoneShape = zoneId ? ramp.shapes?.find((s)=>s.id === zoneId && s.type === "Zone") : null;
                    const zoneName = zoneShape?.text || (zoneId && zoneId !== "default" ? zoneId : "Default Zone");
                    snackbar.notify({
                        text: `${aircraftName} placed in ${zoneName} \u{2192} ${spotName}`,
                        severity: "success"
                    });
                } else // Fallback if we can't extract placement details
                snackbar.notify({
                    text: `${aircraftName} placed successfully`,
                    severity: "success"
                });
            } else // Failure - no available spots
            snackbar.notify({
                text: `No available spots for ${aircraftName}`,
                severity: "warning"
            });
        } catch (error) {
            console.error("[Incremental Park] Error:", error);
        }
    }, [
        ramp,
        stack,
        setStack,
        parkingConfig.config,
        snackbar,
        setLastResult
    ]);
    // Handle schedule changes from GANTT drag-and-drop
    const handleScheduleChanged = (0, $acw62.useCallback)((changes)=>{
        if (!lastResult || !("temporalData" in lastResult)) return;
        // Clone BOTH placement and requests (we may need to update both)
        const updatedPlacement = {
            ...lastResult.placement
        };
        const updatedRequests = lastResult.temporalData.requests ? [
            ...lastResult.temporalData.requests
        ] : [];
        changes.forEach((change)=>{
            const { aircraftId: aircraftId, newSpotId: newSpotId, newArrivalBucket: newArrivalBucket, newDepartureBucket: newDepartureBucket, segmentIndex: segmentIndex } = change;
            const currentPlacement = updatedPlacement[aircraftId];
            if (!currentPlacement) return;
            // Determine if this is a single or segmented placement
            const isSinglePlacement = "spotId" in currentPlacement;
            const isSegmented = "segments" in currentPlacement;
            // === HANDLE TIME CHANGES ===
            if (newArrivalBucket !== undefined || newDepartureBucket !== undefined) {
                if (isSinglePlacement) {
                    // Single placement: Update request's arrivalBucket/departureBucket
                    const requestIndex = updatedRequests.findIndex((r)=>r.id === aircraftId);
                    if (requestIndex !== -1) updatedRequests[requestIndex] = {
                        ...updatedRequests[requestIndex],
                        ...newArrivalBucket !== undefined && {
                            arrivalBucket: newArrivalBucket
                        },
                        ...newDepartureBucket !== undefined && {
                            departureBucket: newDepartureBucket
                        }
                    };
                } else if (isSegmented && segmentIndex !== null && segmentIndex !== undefined) {
                    // Segmented placement: Update specific segment's startBucket/endBucket
                    const segments = [
                        ...currentPlacement.segments
                    ];
                    if (segmentIndex < segments.length) {
                        segments[segmentIndex] = {
                            ...segments[segmentIndex],
                            ...newArrivalBucket !== undefined && {
                                startBucket: newArrivalBucket
                            },
                            ...newDepartureBucket !== undefined && {
                                endBucket: newDepartureBucket
                            }
                        };
                        updatedPlacement[aircraftId] = {
                            ...currentPlacement,
                            segments: segments
                        };
                    }
                }
            }
            // === HANDLE SPOT CHANGES ===
            if (newSpotId) {
                if (isSinglePlacement) // Single placement - update spot
                updatedPlacement[aircraftId] = {
                    ...currentPlacement,
                    spotId: newSpotId
                };
                else if (isSegmented && segmentIndex !== null && segmentIndex !== undefined) {
                    // Segmented placement - update ONLY the specific segment
                    const segments = [
                        ...currentPlacement.segments
                    ];
                    if (segmentIndex < segments.length) {
                        segments[segmentIndex] = {
                            ...segments[segmentIndex],
                            spotId: newSpotId
                        };
                        updatedPlacement[aircraftId] = {
                            ...currentPlacement,
                            segments: segments
                        };
                    }
                }
            }
        });
        // Update lastResult with modified placement AND requests
        setLastResult({
            ...lastResult,
            placement: updatedPlacement,
            temporalData: {
                ...lastResult.temporalData,
                requests: updatedRequests
            }
        });
    }, [
        lastResult,
        setLastResult
    ]);
    // Handle park next: place selected aircraft or largest aircraft without spot
    const handleParkNext = (0, $acw62.useCallback)(()=>{
        // Helper: Check if aircraft has a spot assigned
        const hasSpot = (tenant)=>{
            if (tenant.position.x === null || tenant.position.y === null) return false; // Unplaced = no spot
            // Build legacy spots from ramp shapes
            const spotShapes = ramp.shapes?.filter((s)=>s.type === "Spot") || [];
            const legacySpots = spotShapes.map((shape)=>({
                    points: shape.points,
                    referencePoints: shape.reference_points || []
                }));
            // Transform position from top-left origin to bottom-left origin
            // (getSpotForPositionLegacy expects bottom-left origin coordinates)
            const transformedPosition = {
                x: tenant.position.x,
                y: ramp.depth - tenant.position.y,
                // Y-flip transformation
                angle: tenant.position.angle
            };
            // Use getSpotForPositionLegacy to check if aircraft is in a spot
            const result = (0, $jYWTx.getSpotForPositionLegacy)(tenant, transformedPosition, // Use transformed position
            legacySpots, {});
            return result !== undefined; // Has spot if result is not undefined
        };
        // 1. Check if there's a selected aircraft
        const selectedAircraft = stack.tenants.find((t)=>t.selected);
        if (selectedAircraft) {
            // Selected aircraft exists - check if it has a spot
            if (hasSpot(selectedAircraft)) {
                snackbar.notify({
                    text: `${selectedAircraft.tail_number || "Aircraft"} is already in a spot`,
                    severity: "info"
                });
                return;
            }
            // Park the selected aircraft
            handleIncrementalPark(selectedAircraft.id);
            return;
        }
        // 2. No selection - find aircraft without spots
        const aircraftWithoutSpots = stack.tenants.filter((t)=>!hasSpot(t));
        if (aircraftWithoutSpots.length === 0) {
            snackbar.notify({
                text: "No unplaced aircraft available",
                severity: "info"
            });
            return;
        }
        // 3. Sort by size descending (largest first)
        const sortedBySize = [
            ...aircraftWithoutSpots
        ].sort((a, b)=>{
            const sizeA = Math.max(a.aircraft.wingspan, a.aircraft.length);
            const sizeB = Math.max(b.aircraft.wingspan, b.aircraft.length);
            return sizeB - sizeA;
        });
        // 4. Check if we have spots
        const spots = ramp.shapes?.filter((s)=>s.type === "Spot") || [];
        if (spots.length === 0) {
            snackbar.notify({
                text: "No spots available on ramp",
                severity: "error"
            });
            return;
        }
        // 5. Try to park aircraft in size order
        for (const aircraft of sortedBySize)try {
            const result = (0, $8a5rg.runIncrementalParkingOnRamp)(ramp, stack, aircraft.id, {
                allowTrapping: parkingConfig.config.allowTrapping,
                egressWeight: parkingConfig.config.egressWeight,
                wasteWeight: parkingConfig.config.wasteWeight,
                structuralWeight: parkingConfig.config.structuralWeight,
                sortingStrategy: parkingConfig.config.sortingStrategy,
                zonePriorityWeight: parkingConfig.config.zonePriorityWeight
            });
            // Check if placement was successful
            if (result.statistics.placedAircraft === 1) {
                // SUCCESS - update stack
                setStack(result.updatedStack);
                setLastResult(result);
                // Extract placement details for snackbar
                const aircraftName = aircraft.tail_number || aircraft.aircraft.model || "Aircraft";
                const placement = result.placement[aircraft.id];
                if (placement) {
                    const spotId = "spotId" in placement ? placement.spotId : placement.segments[0].spotId;
                    const spotShape = ramp.shapes?.find((s)=>s.id === spotId && s.type === "Spot");
                    const spotName = spotShape?.text || spotId;
                    // Get zone information
                    const zoneId = spotShape?.metadata?.zoneId;
                    const zoneShape = zoneId ? ramp.shapes?.find((s)=>s.id === zoneId && s.type === "Zone") : null;
                    const zoneName = zoneShape?.text || (zoneId && zoneId !== "default" ? zoneId : "Default Zone");
                    snackbar.notify({
                        text: `${aircraftName} placed in ${zoneName} \u{2192} ${spotName}`,
                        severity: "success"
                    });
                } else snackbar.notify({
                    text: `${aircraftName} placed successfully`,
                    severity: "success"
                });
                return; // Exit after first successful placement
            }
        } catch (error) {
            console.error(`[Park Next] Error placing ${aircraft.tail_number}:`, error);
        // Continue to next aircraft
        }
        // 6. If we get here, no aircraft could be placed
        snackbar.notify({
            text: `Unable to place any remaining aircraft (${aircraftWithoutSpots.length} without spots)`,
            severity: "warning"
        });
    }, [
        ramp,
        stack,
        setStack,
        parkingConfig.config,
        snackbar,
        setLastResult,
        handleIncrementalPark
    ]);
    const handleTimeRangeChange = (0, $acw62.useCallback)((start, end)=>{
        setTimeRange({
            start: start,
            end: end
        });
    }, []);
    const handleToggleTripSelection = (0, $acw62.useCallback)((tripId)=>{
        setSelectedTripIds((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(tripId)) newSet.delete(tripId);
            else newSet.add(tripId);
            return newSet;
        });
    }, []);
    const handleSelectAllTrips = (0, $acw62.useCallback)(()=>{
        const allTripIds = new Set(groupedTrips.map((t)=>t.trip_id));
        setSelectedTripIds(allTripIds);
    }, [
        groupedTrips
    ]);
    const handleDeselectAllTrips = (0, $acw62.useCallback)(()=>{
        setSelectedTripIds(new Set());
    }, []);
    const handleApplyResults = (0, $acw62.useCallback)(async ()=>{
        // Set loading state
        setIsApplying(true);
        setApplyProgress({
            current: 0,
            total: 0,
            currentItem: ""
        });
        // For testing I'm hiding the popup dialog so I can pause on a debugger
        // statement and see what's happening on the diagram
        //setLogDialogOpen(false)
        //await new Promise(resolve => setTimeout(resolve, 200))
        try {
            // Validate we have temporal results
            if (!lastResult || !("temporalData" in lastResult)) {
                console.error("[Apply Results] No temporal results available");
                snackbar.notify({
                    text: "No AutoPark results to apply",
                    severity: "error"
                });
                return;
            }
            // Validate required services
            if (!placementService || !postgrest) {
                console.error("[Apply Results] Missing required services");
                snackbar.notify({
                    text: "Cannot apply results: service not available",
                    severity: "error"
                });
                return;
            }
            // Extract data from lastResult
            const { placement: placement, temporalData: temporalData } = lastResult;
            const { requests: requests, horizonHours: horizonHours } = temporalData;
            // Build placement ID → request map (contains both aircraft and tail_number)
            const requestMap = new Map();
            requests.forEach((req)=>{
                requestMap.set(req.id, req);
            });
            // Build placement ID → trip ID map from requests (not placements state)
            const placementToTripMap = new Map();
            requests.forEach((req)=>{
                if (req.trip_id) placementToTripMap.set(req.id, req.trip_id);
            });
            // Convert placements to position segments using conversion utility
            const positionData = (0, $8a5rg.convertPlacementToPositionSegments)(placement, ramp.shapes, ramp, requestMap, timeRange.start, horizonHours);
            // Validate no duplicate positions at same time (algorithm bug detection)
            const positionMap = new Map();
            for (const { placementId: placementId, segments: segments } of positionData)for (const seg of segments){
                const posKey = `${seg.x.toFixed(1)},${seg.y.toFixed(1)},${seg.startTime.getTime()}`;
                const existing = positionMap.get(posKey);
                if (existing) console.warn(`[Apply Results] WARNING: Duplicate position detected: ${posKey} ` + `(placements ${existing} and ${placementId})`);
                positionMap.set(posKey, placementId);
            }
            // Track results
            let successCount = 0;
            let errorCount = 0;
            const errors = [];
            // Helper function to process a single trip (apply or dump)
            const processSingleTrip = async (tripId, displayName, dbSegments, isDump)=>{
                try {
                    // Update database atomically (deletes old + inserts new)
                    await placementService.rebuildTripCoverage(tripId, dbSegments);
                    console.log(isDump ? `[Apply Results] \u{2713} Dumped unplaced trip ${tripId}` : `[Apply Results] \u{2713} Updated trip ${tripId} with ${dbSegments.length} segment(s)`);
                    // Update progress counter after completion
                    setApplyProgress((prev)=>({
                            current: prev.current + 1,
                            total: prev.total,
                            currentItem: displayName
                        }));
                    return {
                        success: true
                    };
                } catch (error) {
                    console.error(`[Apply Results] Failed to ${isDump ? "dump" : "update"} trip ${tripId}:`, error);
                    // Update progress counter (count errors too)
                    setApplyProgress((prev)=>({
                            current: prev.current + 1,
                            total: prev.total,
                            currentItem: displayName
                        }));
                    return {
                        success: false,
                        error: `${isDump ? "Dump" : "Trip"} ${tripId}: ${error instanceof Error ? error.message : "Unknown error"}`
                    };
                }
            };
            // Build set of locked trip IDs from current placements state
            const lockedTripIds = new Set();
            placements?.forEach((p)=>{
                if (p.is_locked) lockedTripIds.add(p.trip_id);
            });
            if (lockedTripIds.size > 0) console.log(`[Apply Results] Found ${lockedTripIds.size} locked trips - will skip these`);
            // Build set of placed trip IDs and filter out invalid placements
            const placedTripIds = new Set();
            const validPlacements = [];
            for (const placement of positionData){
                const tripId = placementToTripMap.get(placement.placementId);
                if (!tripId) {
                    console.error(`[Apply Results] CRITICAL: No trip ID found for placement ${placement.placementId}`);
                    errors.push(`Placement ${placement.placementId}: No trip ID mapping found`);
                    errorCount++;
                } else {
                    placedTripIds.add(tripId);
                    validPlacements.push(placement);
                }
            }
            // Calculate total operations (all requests with trip_id)
            const totalOperations = requests.filter((req)=>req.trip_id).length;
            // Initialize progress
            setApplyProgress({
                current: 0,
                total: totalOperations,
                currentItem: ""
            });
            // Track locked trips that were skipped
            let lockedSkipCount = 0;
            // STEP 1: Build complete segments for ALL trips (placed + unplaced periods)
            // This ensures aircraft remain "assigned to ramp" even for time periods where
            // they couldn't be placed (ramp_id set but x/y/angle null)
            const allTripPromises = requests.map((req)=>{
                if (!req.trip_id) return null;
                const tripId = req.trip_id;
                // Skip locked trips
                if (lockedTripIds.has(tripId)) {
                    lockedSkipCount++;
                    return null;
                }
                const displayName = req.tail_number || req.id;
                const tripStart = (0, $8a5rg.timeBucketToDate)(req.arrivalBucket, timeRange.start);
                const tripEnd = (0, $8a5rg.timeBucketToDate)(req.departureBucket, timeRange.start);
                // Check if this trip has placement data
                const placementData = validPlacements.find((p)=>p.placementId === req.id);
                let dbSegments = [];
                if (placementData) {
                    // Aircraft was placed for at least part of its trip
                    // Convert placement segments to DB segments (with coordinates)
                    const placedSegments = placementData.segments.map((seg)=>({
                            start_time: seg.startTime.toISOString(),
                            end_time: seg.endTime.toISOString(),
                            ramp_id: ramp.id,
                            hangar_id: null,
                            x: seg.x,
                            y: seg.y,
                            angle: seg.angle,
                            placement_source: "auto",
                            is_locked: false
                        }));
                    // Build timeline of placed periods
                    const placedPeriods = placedSegments.map((seg)=>({
                            start: new Date(seg.start_time),
                            end: new Date(seg.end_time)
                        })).sort((a, b)=>a.start.getTime() - b.start.getTime());
                    // Fill gaps with ramp_id-only segments (assigned but not placed)
                    const allSegments = [];
                    let currentTime = tripStart;
                    for (const placedPeriod of placedPeriods){
                        // If there's a gap before this placed period, fill it with unplaced segment
                        if (currentTime < placedPeriod.start) allSegments.push({
                            start_time: currentTime.toISOString(),
                            end_time: placedPeriod.start.toISOString(),
                            ramp_id: ramp.id,
                            // Assigned to ramp
                            hangar_id: null,
                            x: null,
                            // No position (couldn't be placed)
                            y: null,
                            angle: null,
                            placement_source: "auto",
                            is_locked: false
                        });
                        // Add the placed segment with coordinates
                        const placedSegment = placedSegments.find((s)=>new Date(s.start_time).getTime() === placedPeriod.start.getTime());
                        if (placedSegment) allSegments.push(placedSegment);
                        currentTime = placedPeriod.end;
                    }
                    // If there's a gap after all placed periods, fill it with unplaced segment
                    if (currentTime < tripEnd) allSegments.push({
                        start_time: currentTime.toISOString(),
                        end_time: tripEnd.toISOString(),
                        ramp_id: ramp.id,
                        // Assigned to ramp
                        hangar_id: null,
                        x: null,
                        // No position (couldn't be placed)
                        y: null,
                        angle: null,
                        placement_source: "auto",
                        is_locked: false
                    });
                    dbSegments = allSegments;
                } else // Aircraft was NOT placed at all
                // Create single segment for entire trip with ramp_id but no position
                dbSegments = [
                    {
                        start_time: tripStart.toISOString(),
                        end_time: tripEnd.toISOString(),
                        ramp_id: ramp.id,
                        // Assigned to ramp
                        hangar_id: null,
                        x: null,
                        // No position (couldn't be placed)
                        y: null,
                        angle: null,
                        placement_source: "auto",
                        is_locked: false
                    }
                ];
                return processSingleTrip(tripId, displayName, dbSegments, !placementData);
            }).filter(Boolean);
            // Wait for all operations to complete
            const allResults = await Promise.all(allTripPromises);
            // Count results
            allResults.forEach((result)=>{
                if (result.success) successCount++;
                else {
                    errorCount++;
                    if (result.error) errors.push(result.error);
                }
            });
            // Show results to user
            if (errorCount === 0) {
                // Perfect success
                const lockedMsg = lockedSkipCount > 0 ? ` (${lockedSkipCount} locked)` : "";
                snackbar.notify({
                    text: `Applied ${successCount} aircraft placements to ramp${lockedMsg}`,
                    severity: "success"
                });
                // Close dialog on success
                handleCloseLogDialog();
                // Trigger refresh to reload all data from database
                if (onScheduledUpdate) onScheduledUpdate();
            } else if (successCount > 0) {
                // Partial success
                const lockedMsg = lockedSkipCount > 0 ? `, ${lockedSkipCount} locked` : "";
                snackbar.notify({
                    text: `Applied ${successCount}/${successCount + errorCount} placements (${errorCount} errors${lockedMsg})`,
                    severity: "warning"
                });
                // Show first few errors
                if (errors.length > 0) console.error("[Apply Results] Errors:", errors.slice(0, 5));
                // Still trigger refresh for partial success
                if (onScheduledUpdate) onScheduledUpdate();
            } else {
                // Complete failure - show which aircraft failed
                const failedAircraft = errors.map((err)=>{
                    // Try to extract tail number from error message
                    const tailMatch = err.match(/([A-Z0-9]{5,})/);
                    return tailMatch ? tailMatch[1] : null;
                }).filter(Boolean).slice(0, 3);
                const errorSummary = failedAircraft.length > 0 ? `${failedAircraft.join(", ")}${errorCount > 3 ? ` +${errorCount - 3} more` : ""}` : errors[0] || "Unknown error";
                snackbar.notify({
                    text: `Failed to apply placements (${errorCount} errors): ${errorSummary}`,
                    severity: "error"
                });
            }
        } catch (error) {
            console.error("[Apply Results] Unexpected error:", error);
            snackbar.notify({
                text: `Failed to apply results: ${error instanceof Error ? error.message : "Unknown error"}`,
                severity: "error"
            });
        } finally{
            // Always clear loading state
            setIsApplying(false);
        }
    }, [
        lastResult,
        placementService,
        postgrest,
        placements,
        ramp,
        timeRange,
        snackbar,
        handleCloseLogDialog
    ]);
    return {
        dialogOpen: dialogOpen,
        parkingConfig: parkingConfig,
        handleOpenDialog: handleOpenDialog,
        handleCloseDialog: handleCloseDialog,
        handleAutoPark: handleAutoPark,
        handleIncrementalPark: handleIncrementalPark,
        handleParkNext: handleParkNext,
        logDialogOpen: logDialogOpen,
        handleOpenLogDialog: handleOpenLogDialog,
        handleCloseLogDialog: handleCloseLogDialog,
        lastResult: lastResult,
        timeRange: timeRange,
        handleTimeRangeChange: handleTimeRangeChange,
        tripCount: tripCount,
        placements: placements,
        groupedTrips: groupedTrips,
        selectedTripIds: selectedTripIds,
        handleToggleTripSelection: handleToggleTripSelection,
        handleSelectAllTrips: handleSelectAllTrips,
        handleDeselectAllTrips: handleDeselectAllTrips,
        handleApplyResults: handleApplyResults,
        isApplying: isApplying,
        applyProgress: applyProgress,
        handleScheduleChanged: handleScheduleChanged
    };
}

});
parcelRegister("jYWTx", function(module, exports) {

$parcel$export(module.exports, "getPositionForSpot", () => $aaeda9bda89a078f$export$2cb72a5f3a651130);
$parcel$export(module.exports, "getPositionForSpotLegacy", () => $aaeda9bda89a078f$export$716610ec8e80788c);
$parcel$export(module.exports, "getSpotForPositionLegacy", () => $aaeda9bda89a078f$export$cd85741bea03dbdb);

var $3kJy3 = parcelRequire("3kJy3");

var $3DIQG = parcelRequire("3DIQG");

var $k3vcG = parcelRequire("k3vcG");

var $d7VTV = parcelRequire("d7VTV");
const $aaeda9bda89a078f$export$cdeacf2f45974715 = function(spotBoundary) {
    var p1 = (0, $3DIQG.convertPointTo3sf)(spotBoundary[0]);
    var p2 = (0, $3DIQG.convertPointTo3sf)(spotBoundary[1]);
    var p3 = (0, $3DIQG.convertPointTo3sf)(spotBoundary[2]);
    var p4 = (0, $3DIQG.convertPointTo3sf)(spotBoundary[3]);
    var xCoords = [
        p1.x,
        p2.x,
        p3.x,
        p4.x
    ];
    xCoords = xCoords.filter((o, i)=>i == xCoords.lastIndexOf(o));
    var yCoords = [
        p1.y,
        p2.y,
        p3.y,
        p4.y
    ];
    yCoords = yCoords.filter((o, i)=>i == yCoords.lastIndexOf(o));
    if (xCoords.length > 2 || yCoords.length > 2) throw new Error("Passed in box is not parallel to the x and y axes.");
    var minX = Math.min(...xCoords);
    var maxX = Math.max(...xCoords);
    var minY = Math.min(...yCoords);
    var maxY = Math.max(...yCoords);
    var sw = {
        x: minX,
        y: minY
    };
    var se = {
        x: maxX,
        y: minY
    };
    var ne = {
        x: maxX,
        y: maxY
    };
    var nw = {
        x: minX,
        y: maxY
    };
    if (!(sw.x == p1.x && sw.y == p1.y && se.x == p2.x && se.y == p2.y && ne.x == p3.x && ne.y == p3.y && nw.x == p4.x && nw.y == p4.y)) throw new Error("Coordinates are not in the correct order, i.e. South West, South East, North East, then North West.");
};
const $aaeda9bda89a078f$export$3c301d4a511ca3a8 = function(spotBoundary, referencePointName) {
    // original was inverted
    var sw = spotBoundary[0];
    var se = spotBoundary[1];
    var ne = spotBoundary[2];
    var nw = spotBoundary[3];
    switch(referencePointName){
        case "north":
            return {
                x: nw.x + (ne.x - nw.x) / 2,
                y: nw.y + (ne.y - nw.y) / 2
            };
        case "east":
            return {
                x: se.x + (ne.x - se.x) / 2,
                y: se.y + (ne.y - se.y) / 2
            };
        case "south":
            return {
                x: sw.x + (se.x - sw.x) / 2,
                y: sw.y + (se.y - sw.y) / 2
            };
        case "west":
            return {
                x: sw.x + (nw.x - sw.x) / 2,
                y: sw.y + (nw.y - sw.y) / 2
            };
        case "center":
            return {
                x: sw.x + (ne.x - sw.x) / 2,
                y: sw.y + (ne.y - sw.y) / 2
            };
        default:
            throw new Error(`Unknown referencePointName ${referencePointName}.`);
    }
};
const $aaeda9bda89a078f$var$getSpotClockAngle = function(points) {
    // The spot clock angle would be the equivilent of the rotation on the
    // west line
    return (0, $d7VTV.convertRadiansToDegress)((0, $3DIQG.getLineClockAngle)([
        points[3],
        points[0]
    ]));
};
const $aaeda9bda89a078f$export$2cb72a5f3a651130 = function getPositionForSpot(spot, rampShapes, orientation, tenant, options = {}) {
    var spotShape = rampShapes.find((s)=>s.id === spot.id && s.type === "Spot");
    if (!spotShape) {
        console.warn(`Spot shape ${spot.id} not found in ramp shapes`);
        // TODO Should throw instead?
        return undefined;
    }
    return $aaeda9bda89a078f$export$716610ec8e80788c({
        points: spotShape.points,
        referencePoints: spotShape.reference_points || []
    }, orientation, tenant, options);
};
const $aaeda9bda89a078f$export$716610ec8e80788c = function getPositionForSpotLegacy(spot, orientation, tenant, options = {}) {
    // The "orientation" value  functions as filter criteria for our available
    // reference positions, maybe in the future we'll add other filter criteria
    // like "north", "center", etc
    var referencePoints = spot.referencePoints.filter((o)=>{
        return o.validOrientations.includes(orientation);
    });
    // Out of our remaining reference points that are applicable let's check if
    // any work, and by work, we mean that the aircraft fits inside it when
    // anchored via the specified orientation.
    for (var referencePoint of referencePoints){
        var temp = $aaeda9bda89a078f$export$ec85054c51b236b9(spot.points, referencePoint.name, orientation, tenant, options);
        // The only way this will ne undefined is if the option
        // `checkAircraftFitsInBox` is set to true and in that scenario we check
        // the next valid option
        if (temp) return temp;
    }
};
const $aaeda9bda89a078f$export$ec85054c51b236b9 = function getPositionForSingleSpotGeometry(points, referencePointName, orientation, tenant, options = {}) {
    const { checkAircraftFitsInBox: checkAircraftFitsInBox = true, yAxisInverted: yAxisInverted, rampDepth: rampDepth = 0 } = options;
    //var drawLine = createDrawLine(document.getElementById('aircraftDebugDrawLayer'))
    //var drawPolygon = createDrawPolygon(drawLine)
    // If we're working on an inverted y axis then nip in the bud everything
    // that needs to be different here so that we don't have to handle
    // differences deeper in the stack
    if (yAxisInverted) {
        points = points.map((o)=>({
                y: rampDepth - o.y,
                x: o.x
            }));
        // We also need to change the order of points else our clock angle is
        // going to be wrong
        // South West, South East, North East, then North West
        points = [
            points[3],
            points[2],
            points[1],
            points[0]
        ];
    }
    //drawPolygon(spot.points.map(coord => scaleCoord(coord, feetToPixels)), 'red')
    // Let's get the angle of our spot, we'll use this later to know which
    // way the aircraft should face
    var spotClockAngle = $aaeda9bda89a078f$var$getSpotClockAngle(points);
    // We'll next rotate our box so north is always facing up on our coordinate
    // system, this will make doing our calculations a lot simpler, and when
    // we're done, we'll rotate back
    var northFacingSpotPoints = points.map((p)=>(0, $3DIQG.rotateAroundOrigin)(p, -(0, $d7VTV.convertDegreesToRadians)(spotClockAngle), points[0]));
    // Lets assert that our coordinates are in the right order because if they
    // are not we'll see weird positioning behaviour and create a very hard
    // to track down bug, so its better to throw now than suffer positioning bugs
    $aaeda9bda89a078f$export$cdeacf2f45974715(northFacingSpotPoints);
    var northFacingAnchorPoint = $aaeda9bda89a078f$export$3c301d4a511ca3a8(northFacingSpotPoints, referencePointName);
    //drawDot(scaleCoord(northFacingAnchorPoint, feetToPixels), 'pink')
    // Maps to the value our algo function uses, TODO we could refactor this out
    // by making them both use the same
    let anchorOn;
    let aircraftClockAngle;
    switch(orientation){
        case "center":
            anchorOn = "center";
            // When parking in the center position of a spot, we're assuming the
            // aircraft will be parked facing north, in the future maybe we could
            // expand the validOrientations to also include the parking angle
            aircraftClockAngle = 0;
            break;
        case "nose_to_line":
            anchorOn = "true_nose";
            aircraftClockAngle = 0;
            break;
        case "tail_to_line":
            anchorOn = "true_tail";
            // On tail to line and when aligned on the North edge the aircraft will
            // be pointing south
            aircraftClockAngle = 180;
            break;
        default:
            throw new Error(`Unknown orientation '${orientation}'.`);
    }
    // Based on our reference name let's adjust our a aircraft angle to face
    // the direction of which side of the box we're aligning on
    // TODO Maybe we could refactor these directions out by changing the
    // rotation step at the start
    switch(referencePointName){
        case "east":
            aircraftClockAngle += 90;
            break;
        case "south":
            aircraftClockAngle += 180;
            break;
        case "west":
            aircraftClockAngle += 270;
            break;
        // No adjustments needed
        case "center":
        case "north":
            break;
        default:
            throw new Error(`Unknown reference point name ${referencePointName}.`);
    }
    if (checkAircraftFitsInBox) {
        var northFaceingAircraftPosition = (0, $3kJy3.anchorAircraftToPoint)({
            aircraft: tenant.aircraft,
            anchorPosition: northFacingAnchorPoint,
            aircraftClockAngle: aircraftClockAngle,
            anchorOn: anchorOn
        });
        var northFaceingAircraftGeom = (0, $3kJy3.getAircraftKeyPositions)({
            aircraft: tenant.aircraft,
            aircraftOriginPosition: northFaceingAircraftPosition,
            aircraftClockAngle: aircraftClockAngle
        }).aircraftGeom;
        // There is an inaccuracy in the getAircraftKeyPositions, it could be
        // related to feetToPixel conversions but I don't want to refactor it
        // at this point because it works, but it might end up with a coordinate
        // that is 0.01 out from the exact value. And due to this, when checking
        // if the aircraft fits inside the box it will be ever so slightly out
        // on the anchor side. Or it could be slightly out due to a different
        // unknown reason.
        // But given we are anchoring on a specific edge it would be valid to assume
        // that if the aircraft goes over that edge when we anchor it on a point
        // we have told it to anchor on then we will still want to treat this
        // as valid so let's cap those positions at the respective
        // edges.
        // For example if aligning on the north edge at the center of the aircraft
        // it will overlap the edge, but that's what was asked of the algorithm to
        // do so it makes sense to be valid
        var boundingBox = (0, $k3vcG.getBoundingBox)(northFacingSpotPoints);
        // Mutates the aircraft polygon coordinates and clips them at the anchor
        // edge
        northFaceingAircraftGeom.forEach((o)=>{
            switch(referencePointName){
                case "east":
                    o.x = Math.min(o.x, boundingBox.maxX);
                    break;
                case "south":
                    o.y = Math.max(o.y, boundingBox.minY);
                    break;
                case "west":
                    o.x = Math.max(o.x, boundingBox.minX);
                    break;
                case "north":
                    o.y = Math.min(o.y, boundingBox.maxY);
                    break;
                default:
                    return o;
            }
        });
        /*
    var northFacingAircraftGeomPixels = northFaceingAircraftGeom.map(o => ({
    x: o.x * feetToPixels,
    y: o.y * feetToPixels,
    }))
    drawPolygon(northFacingAircraftGeomPixels, 'lightblue')*/ // This is our check that it's a valid position because if we do something
        // like anchoring on the nose in the center of the box we don't want
        // to return this position if half the aircraft is outside of the box
        // and there's subtler scenarios, for example an aircraft at 45° might
        // fit it's wings inside a box whereas it might not at 90°, and while
        // we don't support that yet we're doing the check so that we don't get
        // caught out in the future
        var aircraftFitsInSpot = $aaeda9bda89a078f$export$1439d7e0455da1d6(northFaceingAircraftGeom.map((0, $3DIQG.convertPointTo3sf)), northFacingSpotPoints.map((0, $3DIQG.convertPointTo3sf)));
        if (!aircraftFitsInSpot) return;
    }
    // The position is valid but we need to move it back to be aligned
    // with where the box was originally, i.e. not parallel to the coordinate
    // axes
    // So let's rotate our anchor point back and then calculate the position
    // based on that
    //drawDot(scaleCoord(northFaceingAircraftPosition, feetToPixels), 'yellow')
    //drawDot(scaleCoord(spot.points[0], feetToPixels), 'lightgreen')
    var anchorPoint = (0, $3DIQG.rotateAroundOrigin)(northFacingAnchorPoint, (0, $d7VTV.convertDegreesToRadians)(spotClockAngle), points[0]);
    //drawDot(scaleCoord(anchorPoint, feetToPixels), 'pink')
    var aircraftAngle = (aircraftClockAngle + spotClockAngle + 360) % 360;
    var aircraftPosition = (0, $3kJy3.anchorAircraftToPoint)({
        aircraft: tenant.aircraft,
        anchorPosition: anchorPoint,
        aircraftClockAngle: aircraftAngle,
        anchorOn: anchorOn
    });
    // Test it to make sure we've got the right position
    /*var aircraftGeom = getAircraftKeyPositions(
  {
    aircraft: tenant.aircraft, 
    aircraftOriginPosition: aircraftPosition, 
    aircraftClockAngle: aircraftAngle,
  }, 
  //feetToPixels,
  ).aircraftGeom
  var aircraftGeomPixels = aircraftGeom.map(o => ({
  x: o.x * feetToPixels,
  y: o.y * feetToPixels,
  }))
  drawPolygon(aircraftGeomPixels, 'purple')*/ if (yAxisInverted) // Map back to what we're expecting
    aircraftPosition = {
        x: aircraftPosition.x,
        y: rampDepth - aircraftPosition.y
    };
    return {
        ...aircraftPosition,
        angle: aircraftAngle
    };
};
const $aaeda9bda89a078f$export$cd85741bea03dbdb = function getSpotForPositionLegacy(tenant, aircraftPosition, spots, _options = {}) {
    // Test all orientations
    /*for (var spot of spots){
    spot.referencePoints = [
      { "name": "north", "validOrientations": [ "nose_to_line", "tail_to_line", "center" ] },
      { "name": "east", "validOrientations": [ "nose_to_line", "tail_to_line", "center" ] },
      { "name": "south", "validOrientations": [ "nose_to_line", "tail_to_line", "center" ] },
      { "name": "west", "validOrientations": [ "nose_to_line", "tail_to_line", "center" ] },
      { "name": "center", "validOrientations": [ "nose_to_line", "tail_to_line", "center" ] },
    ]
  }*/ //var drawLine = createDrawLine(document.getElementById('aircraftDebugDrawLayer'))
    //var drawPolygon = createDrawPolygon(drawLine)
    // For each spot calculate how much of the aircraft overlaps the spot
    // position and use the spot that overlaps the most
    var aircraftPolygon = (0, $3kJy3.getAircraftKeyPositions)({
        aircraft: tenant.aircraft,
        aircraftOriginPosition: {
            x: aircraftPosition.x,
            y: aircraftPosition.y
        },
        aircraftClockAngle: aircraftPosition.angle
    }).aircraftGeom;
    //drawPolygon(aircraftPolygon.map(coord => scaleCoord(coord, feetToPixels)), 'red')
    var largestOverlapSize;
    var closestMatchingSpot;
    for(var i = 0; i < spots.length; i++){
        var spot = spots[i];
        var tempOverlapSize = (0, $k3vcG.getPolygonOverlapAreaSize)(spot.points, aircraftPolygon);
        if (largestOverlapSize === undefined || tempOverlapSize > largestOverlapSize) {
            closestMatchingSpot = spot;
            largestOverlapSize = tempOverlapSize;
        }
    }
    // If the largest overlap size is 0 then we know there's no overlap
    if (!closestMatchingSpot || largestOverlapSize == 0) return undefined;
    // Iterate the orientations and grab the one that has the closest matching
    // angle to the existing aircraft angle
    var alignmentMatchDtos = [];
    for (var r of closestMatchingSpot.referencePoints)for (var o of r.validOrientations){
        var orientationAircraftAngle = $aaeda9bda89a078f$var$getOrientationAircraftNoseAngle(closestMatchingSpot, r.name, o);
        var tempDiffBetweenAngles = (0, $d7VTV.getDifferenceBetweenAngles)(orientationAircraftAngle, aircraftPosition.angle);
        // Gather details on all our alignments because we may have two identical
        // alignments, e.g. an aircraft fully contained within a spot
        // where one is nose_to_line facing east and the other is tail_to_line
        // facing west, both of these will have exactly the same angle
        // Of these matching alignments we'll check which one is closer to
        // the aircraft position
        alignmentMatchDtos.push({
            referencePoint: r,
            orientation: o,
            // Make the angles only to 3SF so that any JS rounding errors won't
            // give us the wrong result
            angleDifference: (0, $d7VTV.roundTo3sf)(tempDiffBetweenAngles)
        });
    }
    if (alignmentMatchDtos.length == 0) return undefined;
    var lowestAngle = alignmentMatchDtos[0].angleDifference;
    for(var i = 1; i < alignmentMatchDtos.length; i++){
        var temp = alignmentMatchDtos[i];
        if (temp.angleDifference < lowestAngle) lowestAngle = temp.angleDifference;
    }
    var possibleOptions = alignmentMatchDtos.filter((o)=>o.angleDifference == lowestAngle);
    // If there's only one possible option then there's no need to do any expensive
    // compute
    if (possibleOptions.length == 1) //drawPolygon(closestMatchingSpot.points.map(coord => scaleCoord(coord, feetToPixels)), 'lightblue')
    //drawLine.destroy()
    return {
        spot: closestMatchingSpot,
        referencePointName: possibleOptions[0].referencePoint.name,
        orientation: possibleOptions[0].orientation
    };
    // Let's compute how far away the aircraft is from our possible position
    // options
    var targetOption = possibleOptions[0];
    var targetOptionPosition = $aaeda9bda89a078f$export$ec85054c51b236b9(closestMatchingSpot.points, targetOption.referencePoint.name, targetOption.orientation, tenant);
    // if the position is undefined there's no point continuing. this happens when
    // the aircraft doesn't fit in the spot for that reference point + orientation
    if (!targetOptionPosition) return undefined;
    var targetOptionDistance = (0, $3DIQG.getDistanceBetweenCoords)({
        x: aircraftPosition.x,
        y: aircraftPosition.y
    }, {
        x: targetOptionPosition.x,
        y: targetOptionPosition.y
    });
    for(var i = 1; i < possibleOptions.length; i++){
        var possibleOption = possibleOptions[i];
        /*var orientationAircraftAngle = getOrientationAircraftNoseAngle(
      closestMatchingSpot, r.name, o)*/ //var drawLine2 = createDrawLine(document.getElementById('aircraftDebugDrawLayer'))
        //var drawPolygon2 = createDrawPolygon(drawLine)
        var position = $aaeda9bda89a078f$export$ec85054c51b236b9(closestMatchingSpot.points, possibleOption.referencePoint.name, possibleOption.orientation, tenant);
        var tempDistance = (0, $3DIQG.getDistanceBetweenCoords)({
            x: aircraftPosition.x,
            y: aircraftPosition.y
        }, {
            x: position.x,
            y: position.y
        });
        if (tempDistance < targetOptionDistance) {
            targetOption = possibleOption;
            targetOptionPosition = position;
            targetOptionDistance = tempDistance;
        }
    //drawLine2.destroy()
    }
    var referencePointName = targetOption.referencePoint.name;
    var orientation = targetOption.orientation;
    //drawPolygon(closestMatchingSpot.points.map(coord => scaleCoord(coord, feetToPixels)), 'lightblue')
    //debugger
    //drawLine.destroy()
    return {
        spot: closestMatchingSpot,
        referencePointName: referencePointName,
        orientation: orientation
    };
};
function $aaeda9bda89a078f$export$1439d7e0455da1d6(polygon, axesAlignedBoxPoints) {
    var boundingBox = (0, $k3vcG.getBoundingBox)(axesAlignedBoxPoints);
    return polygon.every((o)=>{
        // Is point inside the box
        return boundingBox.minX <= o.x && o.x <= boundingBox.maxX && boundingBox.minY <= o.y && o.y <= boundingBox.maxY;
    });
}
/**
 * Given a spot, reference point and orientation this returns which angle
 * the nose of the aircraft would be facing.
 */ function $aaeda9bda89a078f$var$getOrientationAircraftNoseAngle(spot, referencePointName, orientationType) {
    var spotClockAngle = $aaeda9bda89a078f$var$getSpotClockAngle(spot.points);
    switch(referencePointName){
        case "east":
            spotClockAngle += 90;
            break;
        case "south":
            spotClockAngle += 180;
            break;
        case "west":
            spotClockAngle += 270;
            break;
        case "north":
        default:
    }
    switch(orientationType){
        case "tail_to_line":
            spotClockAngle += 180;
            break;
        case "center":
        case "nose_to_line":
    }
    return spotClockAngle;
}

});
parcelRegister("3kJy3", function(module, exports) {

$parcel$export(module.exports, "anchorAircraftToPoint", () => $95e5e347b273e5ae$export$54cef0438b201015);
$parcel$export(module.exports, "getAircraftKeyPositions", () => $95e5e347b273e5ae$export$5dcfa6705d9a2a40);

var $tdfUy = parcelRequire("tdfUy");

var $3DIQG = parcelRequire("3DIQG");

var $d7VTV = parcelRequire("d7VTV");

var $5XN7w = parcelRequire("5XN7w");
const $95e5e347b273e5ae$export$54cef0438b201015 = function(params) {
    const { aircraft: aircraft, anchorPosition: anchorPosition, aircraftClockAngle: aircraftClockAngle, feetToPixels: feetToPixels = 1, anchorOn: anchorOn = 'nose' } = params;
    var keyPositions = $95e5e347b273e5ae$export$5dcfa6705d9a2a40({
        aircraft: aircraft,
        aircraftOriginPosition: anchorPosition,
        aircraftClockAngle: aircraftClockAngle
    }, feetToPixels);
    // Now check how the rotation moved the point we care about away from
    // our target anchor point and we'll return that + our target anchor point
    switch(anchorOn){
        case 'nose':
            var translation = (0, $3DIQG.subtractCoords)(anchorPosition, keyPositions.nose);
            break;
        case 'true_nose':
            var translation = (0, $3DIQG.subtractCoords)(anchorPosition, keyPositions.top);
            break;
        case 'tail':
            var translation = (0, $3DIQG.subtractCoords)(anchorPosition, keyPositions.tail);
            break;
        case 'true_tail':
            // Note we don't use the tail position as the tips of the tail wings
            // can overlap the line, so instead we use the bottom most position
            // of the aircraft
            var translation = (0, $3DIQG.subtractCoords)(anchorPosition, keyPositions.bottom);
            break;
        case 'center':
            var translation = (0, $3DIQG.subtractCoords)(anchorPosition, keyPositions.center);
            break;
        default:
            throw new Error(`Unknown anchorOn ${anchorOn}.`);
    }
    return (0, $3DIQG.addCoords)(anchorPosition, translation);
};
const $95e5e347b273e5ae$export$8ec9fba12121d165 = function(params) {
    const { parkingPosition: parkingPosition, feetToPixels: feetToPixels } = params;
    // Create a box on the area that the plane takes up. This box is going to
    // be different based on how the plane is anchored to the line.
    // Let's start with nose to keep it simple
    // Multiplying it by feetToPixels here gives it the true value in pixel
    // space
    var wingspanPx = feetToPixels * parkingPosition.aircraft.wingspan;
    var heightPx = feetToPixels * parkingPosition.aircraft.length;
    // Let's draw a line from the nose to the tail
    var nosePos = $95e5e347b273e5ae$export$5010839e5874248c({
        ...parkingPosition,
        // We don't want to rotate yet because we need the wing to align along
        // the x axis for easy math
        aircraftAngle: 0
    }, feetToPixels);
    var tailPos = {
        x: nosePos.x,
        y: nosePos.y - heightPx
    };
    var centerPos = $95e5e347b273e5ae$export$e454352797853bbf({
        ...parkingPosition,
        aircraftAngle: 0
    }, feetToPixels);
    var leftWingPos = {
        x: centerPos.x - wingspanPx / 2,
        y: centerPos.y
    };
    var rightWingPos = {
        x: centerPos.x + wingspanPx / 2,
        y: centerPos.y
    };
    // TODO We could convert our cross into a box here
    var box = [
        {
            x: leftWingPos.x,
            y: nosePos.y
        },
        {
            x: rightWingPos.x,
            y: nosePos.y
        },
        {
            x: rightWingPos.x,
            y: tailPos.y
        },
        {
            x: leftWingPos.x,
            y: tailPos.y
        }
    ];
    // Let's now rotate our cross to where it should be along the line
    var rearWheelPos = $95e5e347b273e5ae$export$798180540e5f7117(parkingPosition, feetToPixels);
    // Rotate our box points
    box = box.map((point)=>(0, $3DIQG.rotateAroundOrigin)(point, (0, $d7VTV.convertDegreesToRadians)(parkingPosition.aircraftAngle), rearWheelPos));
    return box;
};
const $95e5e347b273e5ae$export$1b42d75221b203cc = function(params) {
    const { parkingPosition: parkingPosition, feetToPixels: feetToPixels } = params;
    return $95e5e347b273e5ae$export$5dcfa6705d9a2a40({
        aircraft: parkingPosition.aircraft,
        aircraftOriginPosition: parkingPosition.aircraftPosition,
        aircraftClockAngle: parkingPosition.aircraftAngle
    }, feetToPixels).aircraftGeom;
};
const $95e5e347b273e5ae$export$5010839e5874248c = function(params, feetToPixels) {
    var { aircraft: aircraft, aircraftPosition: aircraftPosition, aircraftAngle: aircraftAngle } = params;
    return $95e5e347b273e5ae$export$5dcfa6705d9a2a40({
        aircraft: aircraft,
        aircraftOriginPosition: aircraftPosition,
        aircraftClockAngle: aircraftAngle
    }, feetToPixels).nose;
};
const $95e5e347b273e5ae$export$fec2c5376f6c409c = function(params, feetToPixels) {
    var { aircraft: aircraft, aircraftPosition: aircraftPosition, aircraftAngle: aircraftAngle } = params;
    return $95e5e347b273e5ae$export$5dcfa6705d9a2a40({
        aircraft: aircraft,
        aircraftOriginPosition: aircraftPosition,
        aircraftClockAngle: aircraftAngle
    }, feetToPixels).tail;
};
const $95e5e347b273e5ae$export$e454352797853bbf = function(params, feetToPixels) {
    var { aircraft: aircraft, aircraftPosition: aircraftPosition, aircraftAngle: aircraftAngle } = params;
    return $95e5e347b273e5ae$export$5dcfa6705d9a2a40({
        aircraft: aircraft,
        aircraftOriginPosition: aircraftPosition,
        aircraftClockAngle: aircraftAngle
    }, feetToPixels).center;
};
const $95e5e347b273e5ae$export$798180540e5f7117 = function(params, feetToPixels) {
    var { aircraft: aircraft, aircraftPosition: aircraftPosition, aircraftAngle: aircraftAngle } = params;
    return $95e5e347b273e5ae$export$5dcfa6705d9a2a40({
        aircraft: aircraft,
        aircraftOriginPosition: aircraftPosition,
        aircraftClockAngle: aircraftAngle
    }, feetToPixels).rearWheels;
};
const $95e5e347b273e5ae$export$5dcfa6705d9a2a40 = (0, $5XN7w.memorize)(function(params, feetToPixels = 1) {
    const { aircraft: aircraft, aircraftOriginPosition: aircraftOriginPosition, aircraftClockAngle: aircraftClockAngle } = params;
    // These are the key points relative to the 600x600 pixel aircraft image.
    var relativeNosePosition600x = {
        x: 600 - aircraft.nose.coordinates[0],
        y: 600 - aircraft.nose.coordinates[1]
    };
    var relativeTopOfAircraftPosition600x = {
        x: aircraft.midline,
        y: Math.max(...aircraft.geom.coordinates[0].map((o)=>o[1]))
    };
    var relativeTailPosition600x = {
        x: aircraft.midline,
        y: aircraft.tail_bottom
    };
    var relativeBottomOfAircraftPosition600x = {
        x: aircraft.midline,
        y: Math.min(...aircraft.geom.coordinates[0].map((o)=>o[1]))
    };
    var relativeRearWheelsPosition600x = {
        x: 600 - aircraft.midline,
        y: 600 - aircraft.rear_wheels
    };
    var relativeCenterPosition600x = {
        x: 600 - aircraft.centroid.coordinates[0],
        y: 600 - aircraft.centroid.coordinates[1]
    };
    var aircraftGeomPolygon600x = aircraft.geom.coordinates[0];
    aircraftGeomPolygon600x = aircraftGeomPolygon600x.map((o)=>({
            x: 600 - o[0],
            y: 600 - o[1]
        }));
    // This is the aircraft size in pixels.
    var aircraftSizePx = (0, $tdfUy.calculateAircraftImageDimensions)(feetToPixels, aircraft);
    // These are the key points but relative to the pixel dimensions on screen.
    // e.g. if the image is rendered at 60x60 pixels then this will be the 
    // coordinates above scaled down to a 10th.
    var relativeNoseCoordPx = (0, $3DIQG.scaleCoord)(relativeNosePosition600x, aircraftSizePx.height / 600);
    var relativeTopPosPx = (0, $3DIQG.scaleCoord)(relativeTopOfAircraftPosition600x, aircraftSizePx.height / 600);
    var relativeTailPosPx = (0, $3DIQG.scaleCoord)(relativeTailPosition600x, aircraftSizePx.height / 600);
    var relativeBottomPosPx = (0, $3DIQG.scaleCoord)(relativeBottomOfAircraftPosition600x, aircraftSizePx.height / 600);
    var relativeRearWheelsPx = (0, $3DIQG.scaleCoord)(relativeRearWheelsPosition600x, aircraftSizePx.height / 600);
    var relativeCenterPositionPx = (0, $3DIQG.scaleCoord)(relativeCenterPosition600x, aircraftSizePx.height / 600);
    var relativeAircraftGeomPolygonPx = aircraftGeomPolygon600x.map((coord)=>(0, $3DIQG.scaleCoord)(coord, aircraftSizePx.height / 600));
    // Set the relative positions against our target anchor position
    var noseCoordPx = (0, $3DIQG.addCoords)(aircraftOriginPosition, relativeNoseCoordPx);
    var topPosPx = (0, $3DIQG.addCoords)(aircraftOriginPosition, relativeTopPosPx);
    var rearWheelsPx = (0, $3DIQG.addCoords)(aircraftOriginPosition, relativeRearWheelsPx);
    var tailPosPx = (0, $3DIQG.addCoords)(aircraftOriginPosition, relativeTailPosPx);
    var bottomPosPx = (0, $3DIQG.addCoords)(aircraftOriginPosition, relativeBottomPosPx);
    var centerPosPx = (0, $3DIQG.addCoords)(aircraftOriginPosition, relativeCenterPositionPx);
    var aircraftGeomPolygonPx = relativeAircraftGeomPolygonPx.map((coord)=>(0, $3DIQG.addCoords)(aircraftOriginPosition, coord));
    //drawDot(noseCoordPx, 'green')
    //drawDot(rearWheelsPx, 'orange')
    //drawDot(tailPosPx, 'yellow')
    //drawDot(centerPosPx, 'blue')
    // Do our rotation around the rear wheels
    noseCoordPx = (0, $3DIQG.rotateAroundOrigin)(noseCoordPx, (0, $d7VTV.convertDegreesToRadians)(aircraftClockAngle), rearWheelsPx);
    topPosPx = (0, $3DIQG.rotateAroundOrigin)(topPosPx, (0, $d7VTV.convertDegreesToRadians)(aircraftClockAngle), rearWheelsPx);
    // Probably don't need to do this rotation but leaving it in so it's 
    // consistent with the method for all points
    rearWheelsPx = (0, $3DIQG.rotateAroundOrigin)(rearWheelsPx, (0, $d7VTV.convertDegreesToRadians)(aircraftClockAngle), rearWheelsPx);
    tailPosPx = (0, $3DIQG.rotateAroundOrigin)(tailPosPx, (0, $d7VTV.convertDegreesToRadians)(aircraftClockAngle), rearWheelsPx);
    bottomPosPx = (0, $3DIQG.rotateAroundOrigin)(bottomPosPx, (0, $d7VTV.convertDegreesToRadians)(aircraftClockAngle), rearWheelsPx);
    centerPosPx = (0, $3DIQG.rotateAroundOrigin)(centerPosPx, (0, $d7VTV.convertDegreesToRadians)(aircraftClockAngle), rearWheelsPx);
    aircraftGeomPolygonPx = aircraftGeomPolygonPx.map((coord)=>(0, $3DIQG.rotateAroundOrigin)(coord, (0, $d7VTV.convertDegreesToRadians)(aircraftClockAngle), rearWheelsPx));
    return {
        nose: noseCoordPx,
        top: topPosPx,
        rearWheels: rearWheelsPx,
        tail: tailPosPx,
        bottom: bottomPosPx,
        center: centerPosPx,
        aircraftGeom: aircraftGeomPolygonPx
    };
}, {
    cacheKey: (params, feetToPixels)=>'getAircraftKeyPositions:' + JSON.stringify(params) + ':' + String(feetToPixels)
});

});
parcelRegister("tdfUy", function(module, exports) {

$parcel$export(module.exports, "calculateAircraftImageDimensions", () => $13edffc7e8b30d1f$export$a969c891aa9b2bf6);
$parcel$export(module.exports, "calculateObstacleImageDimensions", () => $13edffc7e8b30d1f$export$b31bb3892af13e26);
const $13edffc7e8b30d1f$export$a969c891aa9b2bf6 = (pixelToFeet, placedAircraft)=>{
    let height, width;
    // aircraft is longer than it is wide, we can assume the length = 600px
    if (placedAircraft.length > placedAircraft.wingspan) {
        height = pixelToFeet * placedAircraft.length;
        width = height * (placedAircraft.wingspan / placedAircraft.length);
    } else {
        // aircraft is wider than it is long, we can assume the wingspan = 600px
        width = pixelToFeet * placedAircraft.wingspan;
        height = width * (placedAircraft.length / placedAircraft.wingspan);
    }
    // we take the max because everything becomes a square
    return {
        width: Math.max(width, height),
        height: Math.max(width, height)
    };
};
const $13edffc7e8b30d1f$export$b31bb3892af13e26 = (pixelToFeet, movableObstacle)=>{
    let height, width;
    // aircraft is longer than it is wide, we can assume the length = 600px
    if (movableObstacle.obstacle.length > movableObstacle.obstacle.width) {
        height = pixelToFeet * movableObstacle.obstacle.length;
        width = height * (movableObstacle.obstacle.width / movableObstacle.obstacle.length);
    } else {
        // aircraft is wider than it is long, we can assume the wingspan = 600px
        width = pixelToFeet * movableObstacle.obstacle.width;
        height = width * (movableObstacle.obstacle.length / movableObstacle.obstacle.width);
    }
    // we take the max because everything becomes a square
    return {
        width: Math.max(width, height),
        height: Math.max(width, height)
    };
};

});

parcelRegister("3DIQG", function(module, exports) {

$parcel$export(module.exports, "subtractCoords", () => $2301d4567098bd7f$export$ad19a5094122dc9b);
$parcel$export(module.exports, "addCoords", () => $2301d4567098bd7f$export$55aead7ac2bb39fc);
$parcel$export(module.exports, "scaleCoord", () => $2301d4567098bd7f$export$773feb8e255b4e5f);
$parcel$export(module.exports, "getDistanceBetweenCoords", () => $2301d4567098bd7f$export$76d43481c9fad04);
$parcel$export(module.exports, "rotateAroundOrigin", () => $2301d4567098bd7f$export$4726de5c59b02f7b);
$parcel$export(module.exports, "getLineClockAngle", () => $2301d4567098bd7f$export$b4de25b9b281e4a4);
$parcel$export(module.exports, "convertPointTo3sf", () => $2301d4567098bd7f$export$6ee9579ba7bc58cf);

var $5XN7w = parcelRequire("5XN7w");

var $d7VTV = parcelRequire("d7VTV");
const $2301d4567098bd7f$export$ad19a5094122dc9b = function(coordA, coordB) {
    return {
        x: coordA.x - coordB.x,
        y: coordA.y - coordB.y
    };
};
const $2301d4567098bd7f$export$55aead7ac2bb39fc = function(coordA, coordB) {
    return {
        x: coordA.x + coordB.x,
        y: coordA.y + coordB.y
    };
};
const $2301d4567098bd7f$export$773feb8e255b4e5f = function(coord, scale) {
    return {
        x: coord.x * scale,
        y: coord.y * scale
    };
};
const $2301d4567098bd7f$export$76d43481c9fad04 = function(coordA, coordB) {
    var temp = $2301d4567098bd7f$export$ad19a5094122dc9b(coordB, coordA);
    return (0, $d7VTV.getHypotenuse)(temp.x, temp.y);
};
const $2301d4567098bd7f$export$f3b4c4d48d06a69d = function(coordA, coordB) {
    return {
        x: (coordA.x + coordB.x) / 2,
        y: (coordA.y + coordB.y) / 2
    };
};
const $2301d4567098bd7f$export$4726de5c59b02f7b = function(coord, angle, origin) {
    if (!origin) origin = {
        x: 0,
        y: 0
    };
    var coordRelativeToOrigin = {
        x: coord.x - origin.x,
        y: coord.y - origin.y
    };
    var { x: x, y: y } = coordRelativeToOrigin;
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var rotatedCoordRelativeToOrigin = {
        x: cos * x + sin * y,
        y: cos * y - sin * x
    };
    return {
        x: rotatedCoordRelativeToOrigin.x + origin.x,
        y: rotatedCoordRelativeToOrigin.y + origin.y
    };
};
const $2301d4567098bd7f$export$52fad5983d99fb90 = function(coord) {
    var { x: x, y: y } = coord;
    // Depending on if the coordinate is in the north-east, south-east, south-west
    // or north-west side of the x and y axises we solve the problem for each
    // quadrant and then add the respective angle multiples of 90°
    // Math.atan will give 180 degree different answers if you use a negative
    // 0 instead of a positive 0 🤷, effectively you're dividing by 0 so doing
    // atan on Infinity and -Infinity
    if (y == 0) y = 0;
    if (x == 0 && y == 0) return 0;
    // This is the north-east section of the axises
    if (x >= 0 && y >= 0) // This gives us the angle between the y-axis and the hypothenus
    return Math.atan(x / y);
    else if (x >= 0 && y < 0) {
        // The south-east section
        var theta = Math.atan(y * -1 / x);
        // Add 90° to the angle
        return Math.PI / 2 + theta;
    } else if (x < 0 && y < 0) {
        // The south-west section
        var theta = Math.atan(x * -1 / (y * -1));
        // Add 180° to the angle
        return Math.PI + theta;
    } else {
        var theta = Math.atan(y / (x * -1));
        // Add 270° to the angle
        return Math.PI * 3 / 2 + theta;
    }
};
const $2301d4567098bd7f$export$b4de25b9b281e4a4 = function(line) {
    var temp = $2301d4567098bd7f$export$ad19a5094122dc9b(line[0], line[1]);
    // This is the clock angle of the line, i.e. if the line were vertical
    // how much would you need to rotate it clockwise in order to match
    // it's orientation.
    return $2301d4567098bd7f$export$52fad5983d99fb90(temp);
};
const $2301d4567098bd7f$export$6ee9579ba7bc58cf = function(point) {
    return {
        x: (0, $d7VTV.roundTo3sf)(point.x),
        y: (0, $d7VTV.roundTo3sf)(point.y)
    };
};
const $2301d4567098bd7f$export$a9d79e465ba8baeb = (0, $5XN7w.memorize)(function(line, trim1, trim2) {
    // Rotate the line so that it's vertical
    var clockAngle = $2301d4567098bd7f$export$b4de25b9b281e4a4(line);
    var newLineStart = {
        x: line[0].x,
        y: line[0].y - trim1
    };
    var lineEndRotated = $2301d4567098bd7f$export$4726de5c59b02f7b(line[1], -clockAngle, line[0]);
    // Apply the trim
    var newLineEnd = {
        x: lineEndRotated.x,
        y: lineEndRotated.y + trim2
    };
    return [
        $2301d4567098bd7f$export$4726de5c59b02f7b(newLineStart, clockAngle, line[0]),
        $2301d4567098bd7f$export$4726de5c59b02f7b(newLineEnd, clockAngle, line[0])
    ];
}, {
    cacheKey: (line, trim1, trim2)=>"trimLine:" + JSON.stringify(line) + ":" + JSON.stringify(trim1) + ":" + JSON.stringify(trim2)
});

});
parcelRegister("5XN7w", function(module, exports) {

$parcel$export(module.exports, "memorize", () => $34a66e8e2cfac90a$export$b8d461729841c899);

var $jPpZh = parcelRequire("jPpZh");
function $34a66e8e2cfac90a$export$b8d461729841c899(handler, options) {
    const { cacheKey: cacheKeyFunction } = options;
    (0, $jPpZh.assert)(cacheKeyFunction, 'cacheKey is required.');
    var cache = {};
    return function(...args) {
        var cacheKey = cacheKeyFunction(args);
        if (cache[cacheKey]) return cache[cacheKey];
        cache[cacheKey] = handler.apply(this, args);
        return cache[cacheKey];
    };
}

});
parcelRegister("jPpZh", function(module, exports) {

$parcel$export(module.exports, "assert", () => $0584ddc2e3cbe9e6$export$a7a9523472993e97);
const $0584ddc2e3cbe9e6$export$a7a9523472993e97 = function(condition, message) {
    if (!condition) throw new Error(message);
};

});




parcelRegister("k3vcG", function(module, exports) {

$parcel$export(module.exports, "getBoundingBox", () => $f9d7252290e3d886$export$895c5e634403eaa7);
$parcel$export(module.exports, "getPolygonOverlapAreaSize", () => $f9d7252290e3d886$export$f38ee52fa3faa00b);

var $gvPrN = parcelRequire("gvPrN");

var $peeMZ = parcelRequire("peeMZ");

var $ikT3E = parcelRequire("ikT3E");

var $ioYla = parcelRequire("ioYla");

var $fZn7A = parcelRequire("fZn7A");

var $5XN7w = parcelRequire("5XN7w");

var $3DIQG = parcelRequire("3DIQG");
function $f9d7252290e3d886$export$275055d6b5b28ab(polygon1, polygon2, buffer = 0 // Vertical buffer distance
) {
    // Convert polygons to Turf.js GeoJSON Polygons (ignore Z and M for 2D checks)
    const turfPolygon1 = (0, $ioYla.polygon)([
        polygon1.map(([x, y])=>[
                x,
                y
            ])
    ]);
    const turfPolygon2 = (0, $ioYla.polygon)([
        polygon2.map(([x, y])=>[
                x,
                y
            ])
    ]);
    // Use Turf.js to find all intersections (can return multiple features)
    const intersection = (0, $fZn7A.default)((0, $ioYla.featureCollection)([
        turfPolygon1,
        turfPolygon2
    ]));
    if (!intersection || !intersection.geometry) // No intersection in 2D
    return {
        intersections: []
    };
    // Extract the intersection geometries (handles MultiPolygon or Polygon)
    const geometries = intersection.geometry.type === "MultiPolygon" ? intersection.geometry.coordinates : [
        intersection.geometry.coordinates
    ];
    // Iterate through each intersecting geometry and determine type
    const intersections = geometries.map((geometry)=>{
        const intersectionCoordinates = geometry[0]; // Get the first ring of the polygon
        // Get height ranges for this intersecting area
        const [z1Min, z1Max] = $f9d7252290e3d886$var$getHeightRangeForIntersection(polygon1, intersectionCoordinates);
        const [z2Min, z2Max] = $f9d7252290e3d886$var$getHeightRangeForIntersection(polygon2, intersectionCoordinates);
        // Adjust height ranges with buffer
        const z1BufferedMin = z1Min - buffer;
        const z1BufferedMax = z1Max + buffer;
        const z2BufferedMin = z2Min - buffer;
        const z2BufferedMax = z2Max + buffer;
        // Check if height ranges collide or overlap
        const heightCollides = z1BufferedMin < z2BufferedMax && z2BufferedMin < z1BufferedMax;
        const type = heightCollides ? "collision" : "overlap";
        return {
            type: type,
            coordinates: intersectionCoordinates
        };
    });
    return {
        intersections: intersections
    };
}
function $f9d7252290e3d886$export$42ade076c4d3b725(polygon) {
    let zMin = Infinity;
    let zMax = -Infinity;
    for (const [, , z = 0, m = 0] of polygon){
        zMin = Math.min(zMin, z);
        zMax = Math.max(zMax, m);
    }
    return [
        zMin,
        zMax
    ];
}
function $f9d7252290e3d886$var$getHeightRangeForIntersection(polygon, intersection) {
    let zMin = Infinity;
    let zMax = -Infinity;
    // Iterate through the intersection points
    for (const [ix, iy] of intersection){
        // Find the corresponding point in the original polygon
        const matchingPoint = polygon.find(([px, py])=>Math.abs(px - ix) < 1e-6 && Math.abs(py - iy) < 1e-6);
        if (matchingPoint) {
            const [, , z = 0, m = 0] = matchingPoint;
            zMin = Math.min(zMin, z);
            zMax = Math.max(zMax, m);
        }
    }
    return [
        zMin,
        zMax
    ];
}
function $f9d7252290e3d886$export$b693b4d8c047c78c(polygon, steps) {
    if (steps < 1 || polygon.length < 2) return polygon; // No interpolation needed
    const interpolated = [];
    for(let i = 0; i < polygon.length - 1; i++){
        const start = polygon[i];
        const end = polygon[i + 1];
        // Add the start point
        interpolated.push(start);
        // Interpolate points between start and end
        for(let step = 1; step <= steps; step++){
            const t = step / (steps + 1); // Interpolation factor
            const interpolatedPoint = [
                $f9d7252290e3d886$var$interpolateValue(start[0], end[0], t),
                // Interpolate X
                $f9d7252290e3d886$var$interpolateValue(start[1], end[1], t),
                // Interpolate Y
                $f9d7252290e3d886$var$interpolateValue(start[2] ?? 0, end[2] ?? 0, t),
                // Interpolate Z (default to 0 if undefined)
                $f9d7252290e3d886$var$interpolateValue(start[3] ?? 0, end[3] ?? 0, t) // Interpolate M (default to 0 if undefined)
            ];
            interpolated.push(interpolatedPoint);
        }
    }
    // Add the last point to close the polygon if needed
    interpolated.push(polygon[polygon.length - 1]);
    return interpolated;
}
/**
 * Linearly interpolates between two values.
 *
 * @param start - The start value.
 * @param end - The end value.
 * @param t - The interpolation factor (0 <= t <= 1).
 * @returns The interpolated value.
 */ function $f9d7252290e3d886$var$interpolateValue(start, end, t) {
    return start + t * (end - start);
}
/**
 * Normalizes a vector to a length of 1. This function was generated with AI.
 * @param {Point} vector - The vector to normalize.
 * @returns {Point} The normalized vector.
 */ function $f9d7252290e3d886$var$normalizeVector(vector) {
    const magnitude = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
    if (magnitude === 0) return {
        x: 0,
        y: 0
    };
    return {
        x: vector.x / magnitude,
        y: vector.y / magnitude
    };
}
const $f9d7252290e3d886$export$388c202cb0c132b4 = (0, $5XN7w.memorize)(function(params) {
    var { polygon: polygon, buffer: buffer, centroid: centroid } = params;
    polygon = polygon.map((0, $3DIQG.convertPointTo3sf));
    // Sort the vertices of both polygons to ensure consistent winding order
    polygon = $f9d7252290e3d886$export$d92f3b6a255efd3d(polygon);
    if (polygon.length < 3) throw new Error("A polygon must have at least 3 vertices.");
    const newPolygon = [];
    for (const vertex of polygon){
        // Calculate the vector from the centroid to the current vertex
        const vectorFromCentroid = {
            x: vertex.x - centroid.x,
            y: vertex.y - centroid.y
        };
        // Normalize this vector to a length of 1
        const normalizedVector = $f9d7252290e3d886$var$normalizeVector(vectorFromCentroid);
        // Extend the polygon by moving each vertex along its normalized vector
        const newVertex = {
            x: vertex.x + normalizedVector.x * buffer,
            y: vertex.y + normalizedVector.y * buffer
        };
        newPolygon.push(newVertex);
    }
    return newPolygon;
}, {
    cacheKey: (params)=>"addPolygonBuffer:" + JSON.stringify(params)
});
function $f9d7252290e3d886$export$d92f3b6a255efd3d(polygon) {
    // Find the centroid of the polygon
    const center = {
        x: 0,
        y: 0
    };
    for (const p of polygon){
        center.x += p.x;
        center.y += p.y;
    }
    center.x /= polygon.length;
    center.y /= polygon.length;
    // Sort the vertices by the angle they make with the centroid
    return [
        ...polygon
    ].sort((a, b)=>{
        const angleA = Math.atan2(a.y - center.y, a.x - center.x);
        const angleB = Math.atan2(b.y - center.y, b.x - center.x);
        return angleA - angleB;
    });
}
const $f9d7252290e3d886$export$bac43aa8db42cb9a = (0, $5XN7w.memorize)(function checkOverlap(polygonA, polygonB) {
    polygonA = polygonA.map((0, $3DIQG.convertPointTo3sf));
    polygonB = polygonB.map((0, $3DIQG.convertPointTo3sf));
    polygonA = polygonA.map((o)=>[
            o.x,
            o.y
        ]);
    polygonB = polygonB.map((o)=>[
            o.x,
            o.y
        ]);
    var temp1 = [
        ...polygonA,
        polygonA[0]
    ];
    var temp2 = [
        ...polygonB,
        polygonB[0]
    ];
    //console.log('temp1', temp1)
    var polygonAGeoJson = (0, $ioYla.polygon)([
        temp1
    ]);
    var polygonBGeoJson = (0, $ioYla.polygon)([
        temp2
    ]);
    if ((0, $ikT3E.default)(polygonAGeoJson, polygonBGeoJson)) return true;
    if ((0, $peeMZ.default)(polygonAGeoJson, polygonBGeoJson)) return true;
    if ((0, $peeMZ.default)(polygonBGeoJson, polygonAGeoJson)) return true;
    return false;
}, {
    cacheKey: (polygonA, polygonB)=>"checkOverlap:" + JSON.stringify(polygonA) + ":" + JSON.stringify(polygonB)
});
/**
 * Represents a 2D point or vector.
 * @typedef {{x: number, y: number}} Point
 */ /**
 * Represents a polygon as an array of vertices.
 * @typedef {Point[]} Polygon
 */ /**
 * Represents a Bounding Box.
 * @typedef {{minX: number, maxX: number, minY: number, maxY: number}} BoundingBox
 */ const $f9d7252290e3d886$var$EPSILON = 1e-9;
const $f9d7252290e3d886$export$895c5e634403eaa7 = (0, $5XN7w.memorize)(function(polygon) {
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;
    for (const { x: x, y: y } of polygon){
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
    }
    return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
    };
}, {
    cacheKey: (polygon)=>"getBoundingBox:" + JSON.stringify(polygon)
});
/**
 * Checks if two Axis-Aligned Bounding Boxes overlap.
 */ const $f9d7252290e3d886$var$checkAABBOverlap = function(boxA, boxB) {
    // Check for separation on the X-axis
    if (boxA.maxX < boxB.minX || boxB.maxX < boxA.minX) return false;
    // Check for separation on the Y-axis
    if (boxA.maxY < boxB.minY || boxB.maxY < boxA.minY) return false;
    // If no separation found, they overlap
    return true;
};
/**
 * Checks if a point is on a line segment (simplified for this check).
 */ function $f9d7252290e3d886$var$isPointOnSegment(p, a, b) {
    const crossProduct = (p.y - a.y) * (b.x - a.x) - (p.x - a.x) * (b.y - a.y);
    if (Math.abs(crossProduct) > $f9d7252290e3d886$var$EPSILON) return false;
    const dotProduct = (p.x - a.x) * (b.x - a.x) + (p.y - a.y) * (b.y - a.y);
    if (dotProduct < 0) return false;
    const squaredLength = (b.x - a.x) * (b.x - a.x) + (b.y - a.y) * (b.y - a.y);
    if (dotProduct > squaredLength + $f9d7252290e3d886$var$EPSILON) return false;
    return true;
}
/**
 * Checks if a point is inside a polygon using the robust Ray Casting Algorithm.
 * **(The robust version from the previous turn is kept for final containment check)**
 */ const $f9d7252290e3d886$var$isPointInPolygon = (0, $5XN7w.memorize)(function(point, polygon) {
    let intersections = 0;
    const n = polygon.length;
    for(let i = 0; i < n; i++){
        const p1 = polygon[i];
        const p2 = polygon[(i + 1) % n];
        // 1. Edge Check
        if ($f9d7252290e3d886$var$isPointOnSegment(point, p1, p2)) return true;
        const x = point.x;
        const y = point.y;
        const y1 = p1.y;
        const y2 = p2.y;
        const x1 = p1.x;
        const x2 = p2.x;
        // 2. Robust Ray Casting Logic
        if ((y1 <= y && y < y2 || y2 <= y && y < y1) && x < (x2 - x1) * (y - y1) / (y2 - y1) + x1) intersections++;
    }
    return intersections % 2 !== 0;
}, {
    cacheKey: (polygon)=>"isPointInPolygon:" + JSON.stringify(polygon)
});
const $f9d7252290e3d886$export$d0bbde50be470b76 = (0, $5XN7w.memorize)(function(polygonA, polygonB) {
    polygonA = polygonA.map((0, $3DIQG.convertPointTo3sf));
    polygonB = polygonB.map((0, $3DIQG.convertPointTo3sf));
    const boxA = $f9d7252290e3d886$export$895c5e634403eaa7(polygonA);
    const boxB = $f9d7252290e3d886$export$895c5e634403eaa7(polygonB);
    // 1. FAST PRE-CHECK: If Bounding Boxes don't overlap, Polygons can't overlap.
    if (!$f9d7252290e3d886$var$checkAABBOverlap(boxA, boxB)) return false;
    // 2. DETAILED CHECK: Use robust PIP only if boxes overlap.
    // Check if any vertex of A is inside B
    for (const vertex of polygonA){
        if ($f9d7252290e3d886$var$isPointInPolygon(vertex, polygonB)) return true;
    }
    // Check if any vertex of B is inside A
    for (const vertex of polygonB){
        if ($f9d7252290e3d886$var$isPointInPolygon(vertex, polygonA)) return true;
    }
    // After AABB overlap and no vertex containment found,
    // the complex nature of the polygon requires an edge-intersection
    // check (like SAT/decomposition). Since we are avoiding complex libraries,
    // for practical, fast collision, we assume no overlap at this point.
    return false;
}, {
    cacheKey: (polygonA, polygonB)=>"checkOverlapQuick:" + JSON.stringify(polygonA) + ":" + JSON.stringify(polygonB)
});
const $f9d7252290e3d886$export$a77ffba2440404d1 = function(polygonA, polygonB) {
    polygonA = polygonA.map((o)=>[
            o.x,
            o.y
        ]);
    polygonB = polygonB.map((o)=>[
            o.x,
            o.y
        ]);
    var temp1 = [
        ...polygonA,
        polygonA[0]
    ];
    var temp2 = [
        ...polygonB,
        polygonB[0]
    ];
    //console.log('temp1', temp1)
    var polygonAGeoJson = (0, $ioYla.polygon)([
        temp1
    ]);
    var polygonBGeoJson = (0, $ioYla.polygon)([
        temp2
    ]);
    return (0, $fZn7A.default)((0, $ioYla.featureCollection)([
        polygonAGeoJson,
        polygonBGeoJson
    ]));
};
const $f9d7252290e3d886$export$f38ee52fa3faa00b = function(polygonA, polygonB) {
    var intersection = $f9d7252290e3d886$export$a77ffba2440404d1(polygonA, polygonB);
    if (!intersection) return 0;
    return (0, $gvPrN.default)(intersection);
};

});
parcelRegister("gvPrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05772f71b69dc10$export$2e2bcd8739ae039);
// index.ts

var $ioYla = parcelRequire("ioYla");

var $25Xct = parcelRequire("25Xct");
function $c05772f71b69dc10$export$bb3edc44842b5f2e(geojson) {
    return (0, $25Xct.geomReduce)(geojson, (value, geom)=>{
        return value + $c05772f71b69dc10$var$calculateArea(geom);
    }, 0);
}
function $c05772f71b69dc10$var$calculateArea(geom) {
    let total = 0;
    let i;
    switch(geom.type){
        case "Polygon":
            return $c05772f71b69dc10$var$polygonArea(geom.coordinates);
        case "MultiPolygon":
            for(i = 0; i < geom.coordinates.length; i++)total += $c05772f71b69dc10$var$polygonArea(geom.coordinates[i]);
            return total;
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
            return 0;
    }
    return 0;
}
function $c05772f71b69dc10$var$polygonArea(coords) {
    let total = 0;
    if (coords && coords.length > 0) {
        total += Math.abs($c05772f71b69dc10$var$ringArea(coords[0]));
        for(let i = 1; i < coords.length; i++)total -= Math.abs($c05772f71b69dc10$var$ringArea(coords[i]));
    }
    return total;
}
var $c05772f71b69dc10$var$FACTOR = (0, $ioYla.earthRadius) * (0, $ioYla.earthRadius) / 2;
var $c05772f71b69dc10$var$PI_OVER_180 = Math.PI / 180;
function $c05772f71b69dc10$var$ringArea(coords) {
    const coordsLength = coords.length - 1;
    if (coordsLength <= 2) return 0;
    let total = 0;
    let i = 0;
    while(i < coordsLength){
        const lower = coords[i];
        const middle = coords[i + 1 === coordsLength ? 0 : i + 1];
        const upper = coords[i + 2 >= coordsLength ? (i + 2) % coordsLength : i + 2];
        const lowerX = lower[0] * $c05772f71b69dc10$var$PI_OVER_180;
        const middleY = middle[1] * $c05772f71b69dc10$var$PI_OVER_180;
        const upperX = upper[0] * $c05772f71b69dc10$var$PI_OVER_180;
        total += (upperX - lowerX) * Math.sin(middleY);
        i++;
    }
    return total * $c05772f71b69dc10$var$FACTOR;
}
var $c05772f71b69dc10$export$2e2bcd8739ae039 = $c05772f71b69dc10$export$bb3edc44842b5f2e;

});
parcelRegister("25Xct", function(module, exports) {

$parcel$export(module.exports, "coordEach", () => $1869f852f62750e6$export$6e011439fde007ae);
$parcel$export(module.exports, "featureEach", () => $1869f852f62750e6$export$45a31c4de8035258);
$parcel$export(module.exports, "geomEach", () => $1869f852f62750e6$export$d2d248a56672ab3d);
$parcel$export(module.exports, "geomReduce", () => $1869f852f62750e6$export$30055ae7bd157809);
$parcel$export(module.exports, "flattenEach", () => $1869f852f62750e6$export$12cba8b31beb353b);
$parcel$export(module.exports, "segmentEach", () => $1869f852f62750e6$export$d3ecc1efb2be121e);
// index.js

var $ioYla = parcelRequire("ioYla");
function $1869f852f62750e6$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($1869f852f62750e6$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
function $1869f852f62750e6$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $1869f852f62750e6$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
function $1869f852f62750e6$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
function $1869f852f62750e6$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1869f852f62750e6$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
function $1869f852f62750e6$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
function $1869f852f62750e6$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1869f852f62750e6$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
function $1869f852f62750e6$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $1869f852f62750e6$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
function $1869f852f62750e6$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
function $1869f852f62750e6$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1869f852f62750e6$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
function $1869f852f62750e6$export$12cba8b31beb353b(geojson, callback) {
    $1869f852f62750e6$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $ioYla.feature)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $ioYla.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
function $1869f852f62750e6$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1869f852f62750e6$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
function $1869f852f62750e6$export$d3ecc1efb2be121e(geojson, callback) {
    $1869f852f62750e6$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($1869f852f62750e6$export$6e011439fde007ae(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $ioYla.lineString)([
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
function $1869f852f62750e6$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $1869f852f62750e6$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
function $1869f852f62750e6$export$985a91771cfc783d(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    $1869f852f62750e6$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $ioYla.lineString)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
function $1869f852f62750e6$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1869f852f62750e6$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
function $1869f852f62750e6$export$2b6ba91fd8680d67(geojson, options) {
    options = options || {};
    if (!(0, $ioYla.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $ioYla.lineString)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $ioYla.lineString)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $ioYla.lineString)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $ioYla.lineString)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
function $1869f852f62750e6$export$ed60ae5df1bac687(geojson, options) {
    options = options || {};
    if (!(0, $ioYla.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $ioYla.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $ioYla.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $ioYla.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $ioYla.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $ioYla.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $ioYla.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

});


parcelRegister("peeMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $04bd61312d6aa0c5$export$2e2bcd8739ae039);
// index.ts

var $degxL = parcelRequire("degxL");

var $kcAwA = parcelRequire("kcAwA");

var $fV7vT = parcelRequire("fV7vT");

var $9ShOK = parcelRequire("9ShOK");
function $04bd61312d6aa0c5$export$77359c28326a9990(feature1, feature2) {
    const geom1 = (0, $9ShOK.getGeom)(feature1);
    const geom2 = (0, $9ShOK.getGeom)(feature2);
    const type1 = geom1.type;
    const type2 = geom2.type;
    const coords1 = geom1.coordinates;
    const coords2 = geom2.coordinates;
    switch(type1){
        case "Point":
            switch(type2){
                case "Point":
                    return $04bd61312d6aa0c5$export$9bab41078959a0ee(coords1, coords2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "MultiPoint":
            switch(type2){
                case "Point":
                    return $04bd61312d6aa0c5$export$62c03e52e70d456a(geom1, geom2);
                case "MultiPoint":
                    return $04bd61312d6aa0c5$export$80ac7ad77496bedc(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "LineString":
            switch(type2){
                case "Point":
                    return (0, $fV7vT.booleanPointOnLine)(geom2, geom1, {
                        ignoreEndVertices: true
                    });
                case "LineString":
                    return $04bd61312d6aa0c5$export$c6689c4ec75f7fad(geom1, geom2);
                case "MultiPoint":
                    return $04bd61312d6aa0c5$export$67a916ba1ba6dd44(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "Polygon":
            switch(type2){
                case "Point":
                    return (0, $kcAwA.booleanPointInPolygon)(geom2, geom1, {
                        ignoreBoundary: true
                    });
                case "LineString":
                    return $04bd61312d6aa0c5$export$b651c5f269ada05c(geom1, geom2);
                case "Polygon":
                    return $04bd61312d6aa0c5$export$35b39c512485988c(geom1, geom2);
                case "MultiPoint":
                    return $04bd61312d6aa0c5$export$828282160b2155f9(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "MultiPolygon":
            switch(type2){
                case "Polygon":
                    return $04bd61312d6aa0c5$export$ededb65e23b2faf7(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        default:
            throw new Error("feature1 " + type1 + " geometry not supported");
    }
}
function $04bd61312d6aa0c5$export$ededb65e23b2faf7(multiPolygon, polygon) {
    return multiPolygon.coordinates.some((coords)=>$04bd61312d6aa0c5$export$35b39c512485988c({
            type: "Polygon",
            coordinates: coords
        }, polygon));
}
function $04bd61312d6aa0c5$export$62c03e52e70d456a(multiPoint, pt) {
    let i;
    let output = false;
    for(i = 0; i < multiPoint.coordinates.length; i++)if ($04bd61312d6aa0c5$export$9bab41078959a0ee(multiPoint.coordinates[i], pt.coordinates)) {
        output = true;
        break;
    }
    return output;
}
function $04bd61312d6aa0c5$export$80ac7ad77496bedc(multiPoint1, multiPoint2) {
    for (const coord2 of multiPoint2.coordinates){
        let matchFound = false;
        for (const coord1 of multiPoint1.coordinates)if ($04bd61312d6aa0c5$export$9bab41078959a0ee(coord2, coord1)) {
            matchFound = true;
            break;
        }
        if (!matchFound) return false;
    }
    return true;
}
function $04bd61312d6aa0c5$export$67a916ba1ba6dd44(lineString, multiPoint) {
    let haveFoundInteriorPoint = false;
    for (const coord of multiPoint.coordinates){
        if ((0, $fV7vT.booleanPointOnLine)(coord, lineString, {
            ignoreEndVertices: true
        })) haveFoundInteriorPoint = true;
        if (!(0, $fV7vT.booleanPointOnLine)(coord, lineString)) return false;
    }
    if (haveFoundInteriorPoint) return true;
    return false;
}
function $04bd61312d6aa0c5$export$828282160b2155f9(polygon, multiPoint) {
    for (const coord of multiPoint.coordinates){
        if (!(0, $kcAwA.booleanPointInPolygon)(coord, polygon, {
            ignoreBoundary: true
        })) return false;
    }
    return true;
}
function $04bd61312d6aa0c5$export$c6689c4ec75f7fad(lineString1, lineString2) {
    let haveFoundInteriorPoint = false;
    for (const coords of lineString2.coordinates){
        if ((0, $fV7vT.booleanPointOnLine)({
            type: "Point",
            coordinates: coords
        }, lineString1, {
            ignoreEndVertices: true
        })) haveFoundInteriorPoint = true;
        if (!(0, $fV7vT.booleanPointOnLine)({
            type: "Point",
            coordinates: coords
        }, lineString1, {
            ignoreEndVertices: false
        })) return false;
    }
    return haveFoundInteriorPoint;
}
function $04bd61312d6aa0c5$export$b651c5f269ada05c(polygon, linestring) {
    let output = false;
    let i = 0;
    const polyBbox = (0, $degxL.bbox)(polygon);
    const lineBbox = (0, $degxL.bbox)(linestring);
    if (!$04bd61312d6aa0c5$export$c40cc8c91b61b9f7(polyBbox, lineBbox)) return false;
    for(i; i < linestring.coordinates.length - 1; i++){
        const midPoint = $04bd61312d6aa0c5$export$b820caf342892892(linestring.coordinates[i], linestring.coordinates[i + 1]);
        if ((0, $kcAwA.booleanPointInPolygon)({
            type: "Point",
            coordinates: midPoint
        }, polygon, {
            ignoreBoundary: true
        })) {
            output = true;
            break;
        }
    }
    return output;
}
function $04bd61312d6aa0c5$export$35b39c512485988c(feature1, feature2) {
    if (feature1.type === "Feature" && feature1.geometry === null) return false;
    if (feature2.type === "Feature" && feature2.geometry === null) return false;
    const poly1Bbox = (0, $degxL.bbox)(feature1);
    const poly2Bbox = (0, $degxL.bbox)(feature2);
    if (!$04bd61312d6aa0c5$export$c40cc8c91b61b9f7(poly1Bbox, poly2Bbox)) return false;
    const coords = (0, $9ShOK.getGeom)(feature2).coordinates;
    for (const ring of coords)for (const coord of ring){
        if (!(0, $kcAwA.booleanPointInPolygon)(coord, feature1)) return false;
    }
    return true;
}
function $04bd61312d6aa0c5$export$c40cc8c91b61b9f7(bbox1, bbox2) {
    if (bbox1[0] > bbox2[0]) return false;
    if (bbox1[2] < bbox2[2]) return false;
    if (bbox1[1] > bbox2[1]) return false;
    if (bbox1[3] < bbox2[3]) return false;
    return true;
}
function $04bd61312d6aa0c5$export$9bab41078959a0ee(pair1, pair2) {
    return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}
function $04bd61312d6aa0c5$export$b820caf342892892(pair1, pair2) {
    return [
        (pair1[0] + pair2[0]) / 2,
        (pair1[1] + pair2[1]) / 2
    ];
}
var $04bd61312d6aa0c5$export$2e2bcd8739ae039 = $04bd61312d6aa0c5$export$77359c28326a9990;

});
parcelRegister("degxL", function(module, exports) {

$parcel$export(module.exports, "bbox", () => $9a196a5aa97f2529$export$bf67010aacbe66fa);
// index.ts

var $25Xct = parcelRequire("25Xct");
function $9a196a5aa97f2529$export$bf67010aacbe66fa(geojson, options = {}) {
    if (geojson.bbox != null && true !== options.recompute) return geojson.bbox;
    const result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $25Xct.coordEach)(geojson, (coord)=>{
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
var $9a196a5aa97f2529$export$2e2bcd8739ae039 = $9a196a5aa97f2529$export$bf67010aacbe66fa;

});

parcelRegister("fV7vT", function(module, exports) {

$parcel$export(module.exports, "booleanPointOnLine", () => $b97201ddadb68fbc$export$f86ceb061fe3ce3a);
// index.ts

var $9ShOK = parcelRequire("9ShOK");
function $b97201ddadb68fbc$export$f86ceb061fe3ce3a(pt, line, options = {}) {
    const ptCoords = (0, $9ShOK.getCoord)(pt);
    const lineCoords = (0, $9ShOK.getCoords)(line);
    for(let i = 0; i < lineCoords.length - 1; i++){
        let ignoreBoundary = false;
        if (options.ignoreEndVertices) {
            if (i === 0) ignoreBoundary = "start";
            if (i === lineCoords.length - 2) ignoreBoundary = "end";
            if (i === 0 && i + 1 === lineCoords.length - 1) ignoreBoundary = "both";
        }
        if ($b97201ddadb68fbc$var$isPointOnLineSegment(lineCoords[i], lineCoords[i + 1], ptCoords, ignoreBoundary, typeof options.epsilon === "undefined" ? null : options.epsilon)) return true;
    }
    return false;
}
function $b97201ddadb68fbc$var$isPointOnLineSegment(lineSegmentStart, lineSegmentEnd, pt, excludeBoundary, epsilon) {
    const x = pt[0];
    const y = pt[1];
    const x1 = lineSegmentStart[0];
    const y1 = lineSegmentStart[1];
    const x2 = lineSegmentEnd[0];
    const y2 = lineSegmentEnd[1];
    const dxc = pt[0] - x1;
    const dyc = pt[1] - y1;
    const dxl = x2 - x1;
    const dyl = y2 - y1;
    const cross = dxc * dyl - dyc * dxl;
    if (epsilon !== null) {
        if (Math.abs(cross) > epsilon) return false;
    } else if (cross !== 0) return false;
    if (Math.abs(dxl) === Math.abs(dyl) && Math.abs(dxl) === 0) {
        if (excludeBoundary) return false;
        if (pt[0] === lineSegmentStart[0] && pt[1] === lineSegmentStart[1]) return true;
        else return false;
    }
    if (!excludeBoundary) {
        if (Math.abs(dxl) >= Math.abs(dyl)) return dxl > 0 ? x1 <= x && x <= x2 : x2 <= x && x <= x1;
        return dyl > 0 ? y1 <= y && y <= y2 : y2 <= y && y <= y1;
    } else if (excludeBoundary === "start") {
        if (Math.abs(dxl) >= Math.abs(dyl)) return dxl > 0 ? x1 < x && x <= x2 : x2 <= x && x < x1;
        return dyl > 0 ? y1 < y && y <= y2 : y2 <= y && y < y1;
    } else if (excludeBoundary === "end") {
        if (Math.abs(dxl) >= Math.abs(dyl)) return dxl > 0 ? x1 <= x && x < x2 : x2 < x && x <= x1;
        return dyl > 0 ? y1 <= y && y < y2 : y2 < y && y <= y1;
    } else if (excludeBoundary === "both") {
        if (Math.abs(dxl) >= Math.abs(dyl)) return dxl > 0 ? x1 < x && x < x2 : x2 < x && x < x1;
        return dyl > 0 ? y1 < y && y < y2 : y2 < y && y < y1;
    }
    return false;
}
var $b97201ddadb68fbc$export$2e2bcd8739ae039 = $b97201ddadb68fbc$export$f86ceb061fe3ce3a;

});


parcelRegister("ikT3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d594cd9fc67046f7$export$2e2bcd8739ae039);
// index.ts

var $25Xct = parcelRequire("25Xct");

var $9ShOK = parcelRequire("9ShOK");

var $g4BHj = parcelRequire("g4BHj");

var $8OyPR = parcelRequire("8OyPR");

var $8C5YG = parcelRequire("8C5YG");
function $d594cd9fc67046f7$export$6536c88af002dfcf(feature1, feature2) {
    const geom1 = (0, $9ShOK.getGeom)(feature1);
    const geom2 = (0, $9ShOK.getGeom)(feature2);
    const type1 = geom1.type;
    const type2 = geom2.type;
    if (type1 === "MultiPoint" && type2 !== "MultiPoint" || (type1 === "LineString" || type1 === "MultiLineString") && type2 !== "LineString" && type2 !== "MultiLineString" || (type1 === "Polygon" || type1 === "MultiPolygon") && type2 !== "Polygon" && type2 !== "MultiPolygon") throw new Error("features must be of the same type");
    if (type1 === "Point") throw new Error("Point geometry not supported");
    if ((0, $8C5YG.geojsonEquality)(feature1, feature2, {
        precision: 6
    })) return false;
    let overlap = 0;
    switch(type1){
        case "MultiPoint":
            for(var i = 0; i < geom1.coordinates.length; i++)for(var j = 0; j < geom2.coordinates.length; j++){
                var coord1 = geom1.coordinates[i];
                var coord2 = geom2.coordinates[j];
                if (coord1[0] === coord2[0] && coord1[1] === coord2[1]) return true;
            }
            return false;
        case "LineString":
        case "MultiLineString":
            (0, $25Xct.segmentEach)(feature1, (segment1)=>{
                (0, $25Xct.segmentEach)(feature2, (segment2)=>{
                    if ((0, $g4BHj.lineOverlap)(segment1, segment2).features.length) overlap++;
                });
            });
            break;
        case "Polygon":
        case "MultiPolygon":
            (0, $25Xct.segmentEach)(feature1, (segment1)=>{
                (0, $25Xct.segmentEach)(feature2, (segment2)=>{
                    if ((0, $8OyPR.lineIntersect)(segment1, segment2).features.length) overlap++;
                });
            });
            break;
    }
    return overlap > 0;
}
var $d594cd9fc67046f7$export$2e2bcd8739ae039 = $d594cd9fc67046f7$export$6536c88af002dfcf;

});
parcelRegister("g4BHj", function(module, exports) {

$parcel$export(module.exports, "lineOverlap", () => $bb3a430076f9e791$export$7fae5198fd58f283);
// index.ts

var $fv532 = parcelRequire("fv532");

var $eTAvv = parcelRequire("eTAvv");

var $3W3nn = parcelRequire("3W3nn");

var $fV7vT = parcelRequire("fV7vT");

var $9ShOK = parcelRequire("9ShOK");

var $25Xct = parcelRequire("25Xct");

var $ioYla = parcelRequire("ioYla");

var $7hFx0 = parcelRequire("7hFx0");
function $bb3a430076f9e791$export$7fae5198fd58f283(line1, line2, options = {}) {
    options = options || {};
    if (!(0, $ioYla.isObject)(options)) throw new Error("options is invalid");
    var tolerance = options.tolerance || 0;
    var features = [];
    var tree = (0, $fv532.geojsonRbush)();
    const line = (0, $eTAvv.lineSegment)(line1);
    tree.load(line);
    var overlapSegment;
    let additionalSegments = [];
    (0, $25Xct.segmentEach)(line2, function(segment) {
        var doesOverlaps = false;
        if (!segment) return;
        (0, $25Xct.featureEach)(tree.search(segment), function(match) {
            if (doesOverlaps === false) {
                var coordsSegment = (0, $9ShOK.getCoords)(segment).sort();
                var coordsMatch = (0, $9ShOK.getCoords)(match).sort();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(coordsSegment, coordsMatch)) {
                    doesOverlaps = true;
                    if (overlapSegment) overlapSegment = $bb3a430076f9e791$var$concatSegment(overlapSegment, segment) || overlapSegment;
                    else overlapSegment = segment;
                } else if (tolerance === 0 ? (0, $fV7vT.booleanPointOnLine)(coordsSegment[0], match) && (0, $fV7vT.booleanPointOnLine)(coordsSegment[1], match) : (0, $3W3nn.nearestPointOnLine)(match, coordsSegment[0]).properties.dist <= tolerance && (0, $3W3nn.nearestPointOnLine)(match, coordsSegment[1]).properties.dist <= tolerance) {
                    doesOverlaps = true;
                    if (overlapSegment) overlapSegment = $bb3a430076f9e791$var$concatSegment(overlapSegment, segment) || overlapSegment;
                    else overlapSegment = segment;
                } else if (tolerance === 0 ? (0, $fV7vT.booleanPointOnLine)(coordsMatch[0], segment) && (0, $fV7vT.booleanPointOnLine)(coordsMatch[1], segment) : (0, $3W3nn.nearestPointOnLine)(segment, coordsMatch[0]).properties.dist <= tolerance && (0, $3W3nn.nearestPointOnLine)(segment, coordsMatch[1]).properties.dist <= tolerance) {
                    if (overlapSegment) {
                        const combinedSegment = $bb3a430076f9e791$var$concatSegment(overlapSegment, match);
                        if (combinedSegment) overlapSegment = combinedSegment;
                        else additionalSegments.push(match);
                    } else overlapSegment = match;
                }
            }
        });
        if (doesOverlaps === false && overlapSegment) {
            features.push(overlapSegment);
            if (additionalSegments.length) {
                features = features.concat(additionalSegments);
                additionalSegments = [];
            }
            overlapSegment = void 0;
        }
    });
    if (overlapSegment) features.push(overlapSegment);
    return (0, $ioYla.featureCollection)(features);
}
function $bb3a430076f9e791$var$concatSegment(line, segment) {
    var coords = (0, $9ShOK.getCoords)(segment);
    var lineCoords = (0, $9ShOK.getCoords)(line);
    var start = lineCoords[0];
    var end = lineCoords[lineCoords.length - 1];
    var geom = line.geometry.coordinates;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(coords[0], start)) geom.unshift(coords[1]);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(coords[0], end)) geom.push(coords[1]);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(coords[1], start)) geom.unshift(coords[0]);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(coords[1], end)) geom.push(coords[0]);
    else return;
    return line;
}
var $bb3a430076f9e791$export$2e2bcd8739ae039 = $bb3a430076f9e791$export$7fae5198fd58f283;

});
parcelRegister("fv532", function(module, exports) {

$parcel$export(module.exports, "geojsonRbush", () => $b48daab0e15f1016$export$60c6381a0feb79ff);
// index.js

var $20GDs = parcelRequire("20GDs");

var $ioYla = parcelRequire("ioYla");

var $25Xct = parcelRequire("25Xct");

var $degxL = parcelRequire("degxL");
function $b48daab0e15f1016$export$60c6381a0feb79ff(maxEntries) {
    var tree = new (0, (/*@__PURE__*/$parcel$interopDefault($20GDs)))(maxEntries);
    tree.insert = function(feature) {
        if (feature.type !== "Feature") throw new Error("invalid feature");
        feature.bbox = feature.bbox ? feature.bbox : (0, $degxL.bbox)(feature);
        return (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.insert.call(this, feature);
    };
    tree.load = function(features) {
        var load = [];
        if (Array.isArray(features)) features.forEach(function(feature) {
            if (feature.type !== "Feature") throw new Error("invalid features");
            feature.bbox = feature.bbox ? feature.bbox : (0, $degxL.bbox)(feature);
            load.push(feature);
        });
        else (0, $25Xct.featureEach)(features, function(feature) {
            if (feature.type !== "Feature") throw new Error("invalid features");
            feature.bbox = feature.bbox ? feature.bbox : (0, $degxL.bbox)(feature);
            load.push(feature);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.load.call(this, load);
    };
    tree.remove = function(feature, equals) {
        if (feature.type !== "Feature") throw new Error("invalid feature");
        feature.bbox = feature.bbox ? feature.bbox : (0, $degxL.bbox)(feature);
        return (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.remove.call(this, feature, equals);
    };
    tree.clear = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.clear.call(this);
    };
    tree.search = function(geojson) {
        var features = (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.search.call(this, this.toBBox(geojson));
        return (0, $ioYla.featureCollection)(features);
    };
    tree.collides = function(geojson) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.collides.call(this, this.toBBox(geojson));
    };
    tree.all = function() {
        var features = (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.all.call(this);
        return (0, $ioYla.featureCollection)(features);
    };
    tree.toJSON = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.toJSON.call(this);
    };
    tree.fromJSON = function(json) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($20GDs))).prototype.fromJSON.call(this, json);
    };
    tree.toBBox = function(geojson) {
        var bbox;
        if (geojson.bbox) bbox = geojson.bbox;
        else if (Array.isArray(geojson) && geojson.length === 4) bbox = geojson;
        else if (Array.isArray(geojson) && geojson.length === 6) bbox = [
            geojson[0],
            geojson[1],
            geojson[3],
            geojson[4]
        ];
        else if (geojson.type === "Feature") bbox = (0, $degxL.bbox)(geojson);
        else if (geojson.type === "FeatureCollection") bbox = (0, $degxL.bbox)(geojson);
        else throw new Error("invalid geojson");
        return {
            minX: bbox[0],
            minY: bbox[1],
            maxX: bbox[2],
            maxY: bbox[3]
        };
    };
    return tree;
}
var $b48daab0e15f1016$export$2e2bcd8739ae039 = $b48daab0e15f1016$export$60c6381a0feb79ff;

});
parcelRegister("20GDs", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    function t(t, r, e, a, h) {
        !function t(n, r, e, a, h) {
            for(; a > e;){
                if (a - e > 600) {
                    var o = a - e + 1, s = r - e + 1, l = Math.log(o), f = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * f * (o - f) / o) * (s - o / 2 < 0 ? -1 : 1), m = Math.max(e, Math.floor(r - s * f / o + u)), c = Math.min(a, Math.floor(r + (o - s) * f / o + u));
                    t(n, r, m, c, h);
                }
                var p = n[r], d = e, x = a;
                for(i(n, e, r), h(n[a], p) > 0 && i(n, e, a); d < x;){
                    for(i(n, d, x), d++, x--; h(n[d], p) < 0;)d++;
                    for(; h(n[x], p) > 0;)x--;
                }
                0 === h(n[e], p) ? i(n, e, x) : i(n, ++x, a), x <= r && (e = x + 1), r <= x && (a = x - 1);
            }
        }(t, r, e || 0, a || t.length - 1, h || n);
    }
    function i(t, i, n) {
        var r = t[i];
        t[i] = t[n], t[n] = r;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    var r = function(t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    };
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(var r = 0; r < i.length; r++)if (n(t, i[r])) return r;
        return -1;
    }
    function a(t, i) {
        h(t, 0, t.children.length, i, t);
    }
    function h(t, i, n, r, e) {
        e || (e = p(null)), e.minX = 1 / 0, e.minY = 1 / 0, e.maxX = -1 / 0, e.maxY = -1 / 0;
        for(var a = i; a < n; a++){
            var h = t.children[a];
            o(e, t.leaf ? r(h) : h);
        }
        return e;
    }
    function o(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function s(t, i) {
        return t.minX - i.minX;
    }
    function l(t, i) {
        return t.minY - i.minY;
    }
    function f(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function u(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function c(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function p(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function d(i, n, r, e, a) {
        for(var h = [
            n,
            r
        ]; h.length;)if (!((r = h.pop()) - (n = h.pop()) <= e)) {
            var o = n + Math.ceil((r - n) / e / 2) * e;
            t(i, o, n, r, a), h.push(n, o, o, r);
        }
    }
    return r.prototype.all = function() {
        return this._all(this.data, []);
    }, r.prototype.search = function(t) {
        var i = this.data, n = [];
        if (!c(t, i)) return n;
        for(var r = this.toBBox, e = []; i;){
            for(var a = 0; a < i.children.length; a++){
                var h = i.children[a], o = i.leaf ? r(h) : h;
                c(t, o) && (i.leaf ? n.push(h) : m(t, o) ? this._all(h, n) : e.push(h));
            }
            i = e.pop();
        }
        return n;
    }, r.prototype.collides = function(t) {
        var i = this.data;
        if (!c(t, i)) return !1;
        for(var n = []; i;){
            for(var r = 0; r < i.children.length; r++){
                var e = i.children[r], a = i.leaf ? this.toBBox(e) : e;
                if (c(t, a)) {
                    if (i.leaf || m(t, a)) return !0;
                    n.push(e);
                }
            }
            i = n.pop();
        }
        return !1;
    }, r.prototype.load = function(t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
            for(var i = 0; i < t.length; i++)this.insert(t[i]);
            return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
            if (this.data.height === n.height) this._splitRoot(this.data, n);
            else {
                if (this.data.height < n.height) {
                    var r = this.data;
                    this.data = n, n = r;
                }
                this._insert(n, this.data.height - n.height - 1, !0);
            }
        } else this.data = n;
        return this;
    }, r.prototype.insert = function(t) {
        return t && this._insert(t, this.data.height - 1), this;
    }, r.prototype.clear = function() {
        return this.data = p([]), this;
    }, r.prototype.remove = function(t, i) {
        if (!t) return this;
        for(var n, r, a, h = this.data, o = this.toBBox(t), s = [], l = []; h || s.length;){
            if (h || (h = s.pop(), r = s[s.length - 1], n = l.pop(), a = !0), h.leaf) {
                var f = e(t, h.children, i);
                if (-1 !== f) return h.children.splice(f, 1), s.push(h), this._condense(s), this;
            }
            a || h.leaf || !m(h, o) ? r ? (n++, h = r.children[n], a = !1) : h = null : (s.push(h), l.push(n), n = 0, r = h, h = h.children[0]);
        }
        return this;
    }, r.prototype.toBBox = function(t) {
        return t;
    }, r.prototype.compareMinX = function(t, i) {
        return t.minX - i.minX;
    }, r.prototype.compareMinY = function(t, i) {
        return t.minY - i.minY;
    }, r.prototype.toJSON = function() {
        return this.data;
    }, r.prototype.fromJSON = function(t) {
        return this.data = t, this;
    }, r.prototype._all = function(t, i) {
        for(var n = []; t;)t.leaf ? i.push.apply(i, t.children) : n.push.apply(n, t.children), t = n.pop();
        return i;
    }, r.prototype._build = function(t, i, n, r) {
        var e, h = n - i + 1, o = this._maxEntries;
        if (h <= o) return a(e = p(t.slice(i, n + 1)), this.toBBox), e;
        r || (r = Math.ceil(Math.log(h) / Math.log(o)), o = Math.ceil(h / Math.pow(o, r - 1))), (e = p([])).leaf = !1, e.height = r;
        var s = Math.ceil(h / o), l = s * Math.ceil(Math.sqrt(o));
        d(t, i, n, l, this.compareMinX);
        for(var f = i; f <= n; f += l){
            var u = Math.min(f + l - 1, n);
            d(t, f, u, s, this.compareMinY);
            for(var m = f; m <= u; m += s){
                var c = Math.min(m + s - 1, u);
                e.children.push(this._build(t, m, c, r - 1));
            }
        }
        return a(e, this.toBBox), e;
    }, r.prototype._chooseSubtree = function(t, i, n, r) {
        for(; r.push(i), !i.leaf && r.length - 1 !== n;){
            for(var e = 1 / 0, a = 1 / 0, h = void 0, o = 0; o < i.children.length; o++){
                var s = i.children[o], l = f(s), u = (m = t, c = s, (Math.max(c.maxX, m.maxX) - Math.min(c.minX, m.minX)) * (Math.max(c.maxY, m.maxY) - Math.min(c.minY, m.minY)) - l);
                u < a ? (a = u, e = l < e ? l : e, h = s) : u === a && l < e && (e = l, h = s);
            }
            i = h || i.children[0];
        }
        var m, c;
        return i;
    }, r.prototype._insert = function(t, i, n) {
        var r = n ? t : this.toBBox(t), e = [], a = this._chooseSubtree(r, this.data, i, e);
        for(a.children.push(t), o(a, r); i >= 0 && e[i].children.length > this._maxEntries;)this._split(e, i), i--;
        this._adjustParentBBoxes(r, e, i);
    }, r.prototype._split = function(t, i) {
        var n = t[i], r = n.children.length, e = this._minEntries;
        this._chooseSplitAxis(n, e, r);
        var h = this._chooseSplitIndex(n, e, r), o = p(n.children.splice(h, n.children.length - h));
        o.height = n.height, o.leaf = n.leaf, a(n, this.toBBox), a(o, this.toBBox), i ? t[i - 1].children.push(o) : this._splitRoot(n, o);
    }, r.prototype._splitRoot = function(t, i) {
        this.data = p([
            t,
            i
        ]), this.data.height = t.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, r.prototype._chooseSplitIndex = function(t, i, n) {
        for(var r, e, a, o, s, l, u, m = 1 / 0, c = 1 / 0, p = i; p <= n - i; p++){
            var d = h(t, 0, p, this.toBBox), x = h(t, p, n, this.toBBox), v = (e = d, a = x, o = void 0, s = void 0, l = void 0, u = void 0, o = Math.max(e.minX, a.minX), s = Math.max(e.minY, a.minY), l = Math.min(e.maxX, a.maxX), u = Math.min(e.maxY, a.maxY), Math.max(0, l - o) * Math.max(0, u - s)), M = f(d) + f(x);
            v < m ? (m = v, r = p, c = M < c ? M : c) : v === m && M < c && (c = M, r = p);
        }
        return r || n - i;
    }, r.prototype._chooseSplitAxis = function(t, i, n) {
        var r = t.leaf ? this.compareMinX : s, e = t.leaf ? this.compareMinY : l;
        this._allDistMargin(t, i, n, r) < this._allDistMargin(t, i, n, e) && t.children.sort(r);
    }, r.prototype._allDistMargin = function(t, i, n, r) {
        t.children.sort(r);
        for(var e = this.toBBox, a = h(t, 0, i, e), s = h(t, n - i, n, e), l = u(a) + u(s), f = i; f < n - i; f++){
            var m = t.children[f];
            o(a, t.leaf ? e(m) : m), l += u(a);
        }
        for(var c = n - i - 1; c >= i; c--){
            var p = t.children[c];
            o(s, t.leaf ? e(p) : p), l += u(s);
        }
        return l;
    }, r.prototype._adjustParentBBoxes = function(t, i, n) {
        for(var r = n; r >= 0; r--)o(i[r], t);
    }, r.prototype._condense = function(t) {
        for(var i = t.length - 1, n = void 0; i >= 0; i--)0 === t[i].children.length ? i > 0 ? (n = t[i - 1].children).splice(n.indexOf(t[i]), 1) : this.clear() : a(t[i], this.toBBox);
    }, r;
});

});


parcelRegister("eTAvv", function(module, exports) {

$parcel$export(module.exports, "lineSegment", () => $ad82854be00d3a1a$export$72bbd6d4e887720d);
// index.ts

var $ioYla = parcelRequire("ioYla");

var $9ShOK = parcelRequire("9ShOK");

var $25Xct = parcelRequire("25Xct");
function $ad82854be00d3a1a$export$72bbd6d4e887720d(geojson) {
    if (!geojson) throw new Error("geojson is required");
    const results = [];
    (0, $25Xct.flattenEach)(geojson, (feature)=>{
        $ad82854be00d3a1a$var$lineSegmentFeature(feature, results);
    });
    return (0, $ioYla.featureCollection)(results);
}
function $ad82854be00d3a1a$var$lineSegmentFeature(geojson, results) {
    let coords = [];
    const geometry = geojson.geometry;
    if (geometry !== null) {
        switch(geometry.type){
            case "Polygon":
                coords = (0, $9ShOK.getCoords)(geometry);
                break;
            case "LineString":
                coords = [
                    (0, $9ShOK.getCoords)(geometry)
                ];
        }
        coords.forEach((coord)=>{
            const segments = $ad82854be00d3a1a$var$createSegments(coord, geojson.properties);
            segments.forEach((segment)=>{
                segment.id = results.length;
                results.push(segment);
            });
        });
    }
}
function $ad82854be00d3a1a$var$createSegments(coords, properties) {
    const segments = [];
    coords.reduce((previousCoords, currentCoords)=>{
        const segment = (0, $ioYla.lineString)([
            previousCoords,
            currentCoords
        ], properties);
        segment.bbox = $ad82854be00d3a1a$var$bbox(previousCoords, currentCoords);
        segments.push(segment);
        return currentCoords;
    });
    return segments;
}
function $ad82854be00d3a1a$var$bbox(coords1, coords2) {
    const x1 = coords1[0];
    const y1 = coords1[1];
    const x2 = coords2[0];
    const y2 = coords2[1];
    const west = x1 < x2 ? x1 : x2;
    const south = y1 < y2 ? y1 : y2;
    const east = x1 > x2 ? x1 : x2;
    const north = y1 > y2 ? y1 : y2;
    return [
        west,
        south,
        east,
        north
    ];
}
var $ad82854be00d3a1a$export$2e2bcd8739ae039 = $ad82854be00d3a1a$export$72bbd6d4e887720d;

});

parcelRegister("3W3nn", function(module, exports) {

$parcel$export(module.exports, "nearestPointOnLine", () => $2dd9684c7eb4a061$export$d62bc67813d804ea);

var $dLTXy = parcelRequire("dLTXy");

var $25Xct = parcelRequire("25Xct");

var $ioYla = parcelRequire("ioYla");

var $9ShOK = parcelRequire("9ShOK");
var $2dd9684c7eb4a061$var$__defProp = Object.defineProperty;
var $2dd9684c7eb4a061$var$__defProps = Object.defineProperties;
var $2dd9684c7eb4a061$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2dd9684c7eb4a061$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2dd9684c7eb4a061$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2dd9684c7eb4a061$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2dd9684c7eb4a061$var$__defNormalProp = (obj, key, value)=>key in obj ? $2dd9684c7eb4a061$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2dd9684c7eb4a061$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2dd9684c7eb4a061$var$__hasOwnProp.call(b, prop)) $2dd9684c7eb4a061$var$__defNormalProp(a, prop, b[prop]);
    if ($2dd9684c7eb4a061$var$__getOwnPropSymbols) {
        for (var prop of $2dd9684c7eb4a061$var$__getOwnPropSymbols(b))if ($2dd9684c7eb4a061$var$__propIsEnum.call(b, prop)) $2dd9684c7eb4a061$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2dd9684c7eb4a061$var$__spreadProps = (a, b)=>$2dd9684c7eb4a061$var$__defProps(a, $2dd9684c7eb4a061$var$__getOwnPropDescs(b));
function $2dd9684c7eb4a061$export$d62bc67813d804ea(lines, pt, options = {}) {
    if (!lines || !pt) throw new Error("lines and pt are required arguments");
    const ptPos = (0, $9ShOK.getCoord)(pt);
    let closestPt = (0, $ioYla.point)([
        Infinity,
        Infinity
    ], {
        dist: Infinity,
        index: -1,
        multiFeatureIndex: -1,
        location: -1
    });
    let length = 0;
    (0, $25Xct.flattenEach)(lines, function(line, _featureIndex, multiFeatureIndex) {
        const coords = (0, $9ShOK.getCoords)(line);
        for(let i = 0; i < coords.length - 1; i++){
            const start = (0, $ioYla.point)(coords[i]);
            start.properties.dist = (0, $dLTXy.distance)(pt, start, options);
            const startPos = (0, $9ShOK.getCoord)(start);
            const stop = (0, $ioYla.point)(coords[i + 1]);
            stop.properties.dist = (0, $dLTXy.distance)(pt, stop, options);
            const stopPos = (0, $9ShOK.getCoord)(stop);
            const sectionLength = (0, $dLTXy.distance)(start, stop, options);
            let intersectPos;
            let wasEnd;
            if (startPos[0] === ptPos[0] && startPos[1] === ptPos[1]) [intersectPos, , wasEnd] = [
                startPos,
                void 0,
                false
            ];
            else if (stopPos[0] === ptPos[0] && stopPos[1] === ptPos[1]) [intersectPos, , wasEnd] = [
                stopPos,
                void 0,
                true
            ];
            else [intersectPos, , wasEnd] = $2dd9684c7eb4a061$var$nearestPointOnSegment(start.geometry.coordinates, stop.geometry.coordinates, (0, $9ShOK.getCoord)(pt));
            let intersectPt;
            if (intersectPos) intersectPt = (0, $ioYla.point)(intersectPos, {
                dist: (0, $dLTXy.distance)(pt, intersectPos, options),
                multiFeatureIndex: multiFeatureIndex,
                location: length + (0, $dLTXy.distance)(start, intersectPos, options)
            });
            if (intersectPt && intersectPt.properties.dist < closestPt.properties.dist) closestPt = $2dd9684c7eb4a061$var$__spreadProps($2dd9684c7eb4a061$var$__spreadValues({}, intersectPt), {
                properties: $2dd9684c7eb4a061$var$__spreadProps($2dd9684c7eb4a061$var$__spreadValues({}, intersectPt.properties), {
                    // Legacy behaviour where index progresses to next segment # if we
                    // went with the end point this iteration.
                    index: wasEnd ? i + 1 : i
                })
            });
            length += sectionLength;
        }
    });
    return closestPt;
}
function $2dd9684c7eb4a061$var$dot(v1, v2) {
    const [v1x, v1y, v1z] = v1;
    const [v2x, v2y, v2z] = v2;
    return v1x * v2x + v1y * v2y + v1z * v2z;
}
function $2dd9684c7eb4a061$var$cross(v1, v2) {
    const [v1x, v1y, v1z] = v1;
    const [v2x, v2y, v2z] = v2;
    return [
        v1y * v2z - v1z * v2y,
        v1z * v2x - v1x * v2z,
        v1x * v2y - v1y * v2x
    ];
}
function $2dd9684c7eb4a061$var$magnitude(v) {
    return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2) + Math.pow(v[2], 2));
}
function $2dd9684c7eb4a061$var$angle(v1, v2) {
    const theta = $2dd9684c7eb4a061$var$dot(v1, v2) / ($2dd9684c7eb4a061$var$magnitude(v1) * $2dd9684c7eb4a061$var$magnitude(v2));
    return Math.acos(Math.min(Math.max(theta, -1), 1));
}
function $2dd9684c7eb4a061$var$lngLatToVector(a) {
    const lat = (0, $ioYla.degreesToRadians)(a[1]);
    const lng = (0, $ioYla.degreesToRadians)(a[0]);
    return [
        Math.cos(lat) * Math.cos(lng),
        Math.cos(lat) * Math.sin(lng),
        Math.sin(lat)
    ];
}
function $2dd9684c7eb4a061$var$vectorToLngLat(v) {
    const [x, y, z] = v;
    const lat = (0, $ioYla.radiansToDegrees)(Math.asin(z));
    const lng = (0, $ioYla.radiansToDegrees)(Math.atan2(y, x));
    return [
        lng,
        lat
    ];
}
function $2dd9684c7eb4a061$var$nearestPointOnSegment(posA, posB, posC) {
    const A = $2dd9684c7eb4a061$var$lngLatToVector(posA);
    const B = $2dd9684c7eb4a061$var$lngLatToVector(posB);
    const C = $2dd9684c7eb4a061$var$lngLatToVector(posC);
    const [Cx, Cy, Cz] = C;
    const [D, E, F] = $2dd9684c7eb4a061$var$cross(A, B);
    const a = E * Cz - F * Cy;
    const b = F * Cx - D * Cz;
    const c = D * Cy - E * Cx;
    const f = c * E - b * F;
    const g = a * F - c * D;
    const h = b * D - a * E;
    const t = 1 / Math.sqrt(Math.pow(f, 2) + Math.pow(g, 2) + Math.pow(h, 2));
    const I1 = [
        f * t,
        g * t,
        h * t
    ];
    const I2 = [
        -1 * f * t,
        -1 * g * t,
        -1 * h * t
    ];
    const angleAB = $2dd9684c7eb4a061$var$angle(A, B);
    const angleAI1 = $2dd9684c7eb4a061$var$angle(A, I1);
    const angleBI1 = $2dd9684c7eb4a061$var$angle(B, I1);
    const angleAI2 = $2dd9684c7eb4a061$var$angle(A, I2);
    const angleBI2 = $2dd9684c7eb4a061$var$angle(B, I2);
    let I;
    if (angleAI1 < angleAI2 && angleAI1 < angleBI2 || angleBI1 < angleAI2 && angleBI1 < angleBI2) I = I1;
    else I = I2;
    if ($2dd9684c7eb4a061$var$angle(A, I) > angleAB || $2dd9684c7eb4a061$var$angle(B, I) > angleAB) {
        if ((0, $dLTXy.distance)($2dd9684c7eb4a061$var$vectorToLngLat(I), $2dd9684c7eb4a061$var$vectorToLngLat(A)) <= (0, $dLTXy.distance)($2dd9684c7eb4a061$var$vectorToLngLat(I), $2dd9684c7eb4a061$var$vectorToLngLat(B))) return [
            $2dd9684c7eb4a061$var$vectorToLngLat(A),
            true,
            false
        ];
        else return [
            $2dd9684c7eb4a061$var$vectorToLngLat(B),
            false,
            true
        ];
    }
    return [
        $2dd9684c7eb4a061$var$vectorToLngLat(I),
        false,
        false
    ];
}
var $2dd9684c7eb4a061$export$2e2bcd8739ae039 = $2dd9684c7eb4a061$export$d62bc67813d804ea;

});
parcelRegister("dLTXy", function(module, exports) {

$parcel$export(module.exports, "distance", () => $a06b12901ab6746c$export$9f17032d917177de);
// index.ts

var $9ShOK = parcelRequire("9ShOK");

var $ioYla = parcelRequire("ioYla");
function $a06b12901ab6746c$export$9f17032d917177de(from, to, options = {}) {
    var coordinates1 = (0, $9ShOK.getCoord)(from);
    var coordinates2 = (0, $9ShOK.getCoord)(to);
    var dLat = (0, $ioYla.degreesToRadians)(coordinates2[1] - coordinates1[1]);
    var dLon = (0, $ioYla.degreesToRadians)(coordinates2[0] - coordinates1[0]);
    var lat1 = (0, $ioYla.degreesToRadians)(coordinates1[1]);
    var lat2 = (0, $ioYla.degreesToRadians)(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return (0, $ioYla.radiansToLength)(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}
var $a06b12901ab6746c$export$2e2bcd8739ae039 = $a06b12901ab6746c$export$9f17032d917177de;

});


parcelRegister("7hFx0", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});


parcelRegister("8OyPR", function(module, exports) {

$parcel$export(module.exports, "lineIntersect", () => $66ae03d9c2724e1e$export$63824e7f1fb0f995);
// index.ts

var $ioYla = parcelRequire("ioYla");

var $7AY50 = parcelRequire("7AY50");
var $66ae03d9c2724e1e$var$sweeplineIntersections = (0, $7AY50.default);
// index.ts
function $66ae03d9c2724e1e$export$63824e7f1fb0f995(line1, line2, options = {}) {
    const { removeDuplicates: removeDuplicates = true, ignoreSelfIntersections: ignoreSelfIntersections = true } = options;
    let features = [];
    if (line1.type === "FeatureCollection") features = features.concat(line1.features);
    else if (line1.type === "Feature") features.push(line1);
    else if (line1.type === "LineString" || line1.type === "Polygon" || line1.type === "MultiLineString" || line1.type === "MultiPolygon") features.push((0, $ioYla.feature)(line1));
    if (line2.type === "FeatureCollection") features = features.concat(line2.features);
    else if (line2.type === "Feature") features.push(line2);
    else if (line2.type === "LineString" || line2.type === "Polygon" || line2.type === "MultiLineString" || line2.type === "MultiPolygon") features.push((0, $ioYla.feature)(line2));
    const intersections = $66ae03d9c2724e1e$var$sweeplineIntersections((0, $ioYla.featureCollection)(features), ignoreSelfIntersections);
    let results = [];
    if (removeDuplicates) {
        const unique = {};
        intersections.forEach((intersection)=>{
            const key = intersection.join(",");
            if (!unique[key]) {
                unique[key] = true;
                results.push(intersection);
            }
        });
    } else results = intersections;
    return (0, $ioYla.featureCollection)(results.map((r)=>(0, $ioYla.point)(r)));
}
var $66ae03d9c2724e1e$export$2e2bcd8739ae039 = $66ae03d9c2724e1e$export$63824e7f1fb0f995;

});
parcelRegister("7AY50", function(module, exports) {

$parcel$export(module.exports, "default", () => $587a7fce420e6aca$export$2e2bcd8739ae039);
class $587a7fce420e6aca$var$TinyQueue {
    constructor(data = [], compare = $587a7fce420e6aca$var$defaultCompare){
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;
        if (this.length > 0) for(let i = (this.length >> 1) - 1; i >= 0; i--)this._down(i);
    }
    push(item) {
        this.data.push(item);
        this.length++;
        this._up(this.length - 1);
    }
    pop() {
        if (this.length === 0) return undefined;
        const top = this.data[0];
        const bottom = this.data.pop();
        this.length--;
        if (this.length > 0) {
            this.data[0] = bottom;
            this._down(0);
        }
        return top;
    }
    peek() {
        return this.data[0];
    }
    _up(pos) {
        const { data: data, compare: compare } = this;
        const item = data[pos];
        while(pos > 0){
            const parent = pos - 1 >> 1;
            const current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }
        data[pos] = item;
    }
    _down(pos) {
        const { data: data, compare: compare } = this;
        const halfLength = this.length >> 1;
        const item = data[pos];
        while(pos < halfLength){
            let left = (pos << 1) + 1;
            let best = data[left];
            const right = left + 1;
            if (right < this.length && compare(data[right], best) < 0) {
                left = right;
                best = data[right];
            }
            if (compare(best, item) >= 0) break;
            data[pos] = best;
            pos = left;
        }
        data[pos] = item;
    }
}
function $587a7fce420e6aca$var$defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $587a7fce420e6aca$var$checkWhichEventIsLeft(e1, e2) {
    if (e1.p.x > e2.p.x) return 1;
    if (e1.p.x < e2.p.x) return -1;
    if (e1.p.y !== e2.p.y) return e1.p.y > e2.p.y ? 1 : -1;
    return 1;
}
function $587a7fce420e6aca$var$checkWhichSegmentHasRightEndpointFirst(seg1, seg2) {
    if (seg1.rightSweepEvent.p.x > seg2.rightSweepEvent.p.x) return 1;
    if (seg1.rightSweepEvent.p.x < seg2.rightSweepEvent.p.x) return -1;
    if (seg1.rightSweepEvent.p.y !== seg2.rightSweepEvent.p.y) return seg1.rightSweepEvent.p.y < seg2.rightSweepEvent.p.y ? 1 : -1;
    return 1;
}
class $587a7fce420e6aca$var$Event {
    constructor(p, featureId, ringId, eventId){
        this.p = {
            x: p[0],
            y: p[1]
        };
        this.featureId = featureId;
        this.ringId = ringId;
        this.eventId = eventId;
        this.otherEvent = null;
        this.isLeftEndpoint = null;
    }
    isSamePoint(eventToCheck) {
        return this.p.x === eventToCheck.p.x && this.p.y === eventToCheck.p.y;
    }
}
function $587a7fce420e6aca$var$fillEventQueue(geojson, eventQueue) {
    if (geojson.type === 'FeatureCollection') {
        const features = geojson.features;
        for(let i = 0; i < features.length; i++)$587a7fce420e6aca$var$processFeature(features[i], eventQueue);
    } else $587a7fce420e6aca$var$processFeature(geojson, eventQueue);
}
let $587a7fce420e6aca$var$featureId = 0;
let $587a7fce420e6aca$var$ringId = 0;
let $587a7fce420e6aca$var$eventId = 0;
function $587a7fce420e6aca$var$processFeature(featureOrGeometry, eventQueue) {
    const geom = featureOrGeometry.type === 'Feature' ? featureOrGeometry.geometry : featureOrGeometry;
    let coords = geom.coordinates;
    // standardise the input
    if (geom.type === 'Polygon' || geom.type === 'MultiLineString') coords = [
        coords
    ];
    if (geom.type === 'LineString') coords = [
        [
            coords
        ]
    ];
    for(let i = 0; i < coords.length; i++)for(let ii = 0; ii < coords[i].length; ii++){
        let currentP = coords[i][ii][0];
        let nextP = null;
        $587a7fce420e6aca$var$ringId = $587a7fce420e6aca$var$ringId + 1;
        for(let iii = 0; iii < coords[i][ii].length - 1; iii++){
            nextP = coords[i][ii][iii + 1];
            const e1 = new $587a7fce420e6aca$var$Event(currentP, $587a7fce420e6aca$var$featureId, $587a7fce420e6aca$var$ringId, $587a7fce420e6aca$var$eventId);
            const e2 = new $587a7fce420e6aca$var$Event(nextP, $587a7fce420e6aca$var$featureId, $587a7fce420e6aca$var$ringId, $587a7fce420e6aca$var$eventId + 1);
            e1.otherEvent = e2;
            e2.otherEvent = e1;
            if ($587a7fce420e6aca$var$checkWhichEventIsLeft(e1, e2) > 0) {
                e2.isLeftEndpoint = true;
                e1.isLeftEndpoint = false;
            } else {
                e1.isLeftEndpoint = true;
                e2.isLeftEndpoint = false;
            }
            eventQueue.push(e1);
            eventQueue.push(e2);
            currentP = nextP;
            $587a7fce420e6aca$var$eventId = $587a7fce420e6aca$var$eventId + 1;
        }
    }
    $587a7fce420e6aca$var$featureId = $587a7fce420e6aca$var$featureId + 1;
}
class $587a7fce420e6aca$var$Segment {
    constructor(event){
        this.leftSweepEvent = event;
        this.rightSweepEvent = event.otherEvent;
    }
}
function $587a7fce420e6aca$var$testSegmentIntersect(seg1, seg2) {
    if (seg1 === null || seg2 === null) return false;
    if (seg1.leftSweepEvent.ringId === seg2.leftSweepEvent.ringId && (seg1.rightSweepEvent.isSamePoint(seg2.leftSweepEvent) || seg1.rightSweepEvent.isSamePoint(seg2.leftSweepEvent) || seg1.rightSweepEvent.isSamePoint(seg2.rightSweepEvent) || seg1.leftSweepEvent.isSamePoint(seg2.leftSweepEvent) || seg1.leftSweepEvent.isSamePoint(seg2.rightSweepEvent))) return false;
    const x1 = seg1.leftSweepEvent.p.x;
    const y1 = seg1.leftSweepEvent.p.y;
    const x2 = seg1.rightSweepEvent.p.x;
    const y2 = seg1.rightSweepEvent.p.y;
    const x3 = seg2.leftSweepEvent.p.x;
    const y3 = seg2.leftSweepEvent.p.y;
    const x4 = seg2.rightSweepEvent.p.x;
    const y4 = seg2.rightSweepEvent.p.y;
    const denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
    const numeA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
    const numeB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
    if (denom === 0) {
        if (numeA === 0 && numeB === 0) return false;
        return false;
    }
    const uA = numeA / denom;
    const uB = numeB / denom;
    if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
        const x = x1 + uA * (x2 - x1);
        const y = y1 + uA * (y2 - y1);
        return [
            x,
            y
        ];
    }
    return false;
}
// import {debugEventAndSegments, debugRemovingSegment} from './debug'
function $587a7fce420e6aca$var$runCheck(eventQueue, ignoreSelfIntersections) {
    ignoreSelfIntersections = ignoreSelfIntersections ? ignoreSelfIntersections : false;
    const intersectionPoints = [];
    const outQueue = new $587a7fce420e6aca$var$TinyQueue([], $587a7fce420e6aca$var$checkWhichSegmentHasRightEndpointFirst);
    while(eventQueue.length){
        const event = eventQueue.pop();
        if (event.isLeftEndpoint) {
            // debugEventAndSegments(event.p, outQueue.data)
            const segment = new $587a7fce420e6aca$var$Segment(event);
            for(let i = 0; i < outQueue.data.length; i++){
                const otherSeg = outQueue.data[i];
                if (ignoreSelfIntersections) {
                    if (otherSeg.leftSweepEvent.featureId === event.featureId) continue;
                }
                const intersection = $587a7fce420e6aca$var$testSegmentIntersect(segment, otherSeg);
                if (intersection !== false) intersectionPoints.push(intersection);
            }
            outQueue.push(segment);
        } else if (event.isLeftEndpoint === false) outQueue.pop();
    }
    return intersectionPoints;
}
function $587a7fce420e6aca$var$sweeplineIntersections(geojson, ignoreSelfIntersections) {
    const eventQueue = new $587a7fce420e6aca$var$TinyQueue([], $587a7fce420e6aca$var$checkWhichEventIsLeft);
    $587a7fce420e6aca$var$fillEventQueue(geojson, eventQueue);
    return $587a7fce420e6aca$var$runCheck(eventQueue, ignoreSelfIntersections);
}
var $587a7fce420e6aca$export$2e2bcd8739ae039 = $587a7fce420e6aca$var$sweeplineIntersections;

});


parcelRegister("8C5YG", function(module, exports) {

$parcel$export(module.exports, "geojsonEquality", () => $64568260bbbf7e85$export$a022e873aee62a2a);
var $64568260bbbf7e85$var$__defProp = Object.defineProperty;
var $64568260bbbf7e85$var$__name = (target, value)=>$64568260bbbf7e85$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// index.ts
var $64568260bbbf7e85$var$_GeojsonEquality = class _GeojsonEquality {
    constructor(opts){
        this.direction = false;
        this.compareProperties = true;
        var _a, _b, _c;
        this.precision = 10 ** -((_a = opts == null ? void 0 : opts.precision) != null ? _a : 17);
        this.direction = (_b = opts == null ? void 0 : opts.direction) != null ? _b : false;
        this.compareProperties = (_c = opts == null ? void 0 : opts.compareProperties) != null ? _c : true;
    }
    compare(g1, g2) {
        if (g1.type !== g2.type) return false;
        if (!$64568260bbbf7e85$var$sameLength(g1, g2)) return false;
        switch(g1.type){
            case "Point":
                return this.compareCoord(g1.coordinates, g2.coordinates);
            case "LineString":
                return this.compareLine(g1.coordinates, g2.coordinates);
            case "Polygon":
                return this.comparePolygon(g1, g2);
            case "GeometryCollection":
                return this.compareGeometryCollection(g1, g2);
            case "Feature":
                return this.compareFeature(g1, g2);
            case "FeatureCollection":
                return this.compareFeatureCollection(g1, g2);
            default:
                if (g1.type.startsWith("Multi")) {
                    const g1s = $64568260bbbf7e85$var$explode(g1);
                    const g2s = $64568260bbbf7e85$var$explode(g2);
                    return g1s.every((g1part)=>g2s.some((g2part)=>this.compare(g1part, g2part)));
                }
        }
        return false;
    }
    compareCoord(c1, c2) {
        return c1.length === c2.length && c1.every((c, i)=>Math.abs(c - c2[i]) < this.precision);
    }
    compareLine(path1, path2, ind = 0, isPoly = false) {
        if (!$64568260bbbf7e85$var$sameLength(path1, path2)) return false;
        const p1 = path1;
        let p2 = path2;
        if (isPoly && !this.compareCoord(p1[0], p2[0])) {
            const startIndex = this.fixStartIndex(p2, p1);
            if (!startIndex) return false;
            else p2 = startIndex;
        }
        const sameDirection = this.compareCoord(p1[ind], p2[ind]);
        if (this.direction || sameDirection) return this.comparePath(p1, p2);
        else {
            if (this.compareCoord(p1[ind], p2[p2.length - (1 + ind)])) return this.comparePath(p1.slice().reverse(), p2);
            return false;
        }
    }
    fixStartIndex(sourcePath, targetPath) {
        let correctPath, ind = -1;
        for(let i = 0; i < sourcePath.length; i++)if (this.compareCoord(sourcePath[i], targetPath[0])) {
            ind = i;
            break;
        }
        if (ind >= 0) correctPath = [].concat(sourcePath.slice(ind, sourcePath.length), sourcePath.slice(1, ind + 1));
        return correctPath;
    }
    comparePath(p1, p2) {
        return p1.every((c, i)=>this.compareCoord(c, p2[i]));
    }
    comparePolygon(g1, g2) {
        if (this.compareLine(g1.coordinates[0], g2.coordinates[0], 1, true)) {
            const holes1 = g1.coordinates.slice(1, g1.coordinates.length);
            const holes2 = g2.coordinates.slice(1, g2.coordinates.length);
            return holes1.every((h1)=>holes2.some((h2)=>this.compareLine(h1, h2, 1, true)));
        }
        return false;
    }
    compareGeometryCollection(g1, g2) {
        return $64568260bbbf7e85$var$sameLength(g1.geometries, g2.geometries) && this.compareBBox(g1, g2) && g1.geometries.every((g, i)=>this.compare(g, g2.geometries[i]));
    }
    compareFeature(g1, g2) {
        return g1.id === g2.id && (this.compareProperties ? $64568260bbbf7e85$var$equal(g1.properties, g2.properties) : true) && this.compareBBox(g1, g2) && this.compare(g1.geometry, g2.geometry);
    }
    compareFeatureCollection(g1, g2) {
        return $64568260bbbf7e85$var$sameLength(g1.features, g2.features) && this.compareBBox(g1, g2) && g1.features.every((f, i)=>this.compare(f, g2.features[i]));
    }
    compareBBox(g1, g2) {
        return Boolean(!g1.bbox && !g2.bbox) || (g1.bbox && g2.bbox ? this.compareCoord(g1.bbox, g2.bbox) : false);
    }
};
$64568260bbbf7e85$var$__name($64568260bbbf7e85$var$_GeojsonEquality, "GeojsonEquality");
var $64568260bbbf7e85$export$63730496493291e4 = $64568260bbbf7e85$var$_GeojsonEquality;
function $64568260bbbf7e85$var$sameLength(g1, g2) {
    return g1.coordinates ? g1.coordinates.length === g2.coordinates.length : g1.length === g2.length;
}
$64568260bbbf7e85$var$__name($64568260bbbf7e85$var$sameLength, "sameLength");
function $64568260bbbf7e85$var$explode(g) {
    return g.coordinates.map((part)=>({
            type: g.type.replace("Multi", ""),
            coordinates: part
        }));
}
$64568260bbbf7e85$var$__name($64568260bbbf7e85$var$explode, "explode");
function $64568260bbbf7e85$export$a022e873aee62a2a(g1, g2, opts) {
    const eq = new $64568260bbbf7e85$export$63730496493291e4(opts);
    return eq.compare(g1, g2);
}
$64568260bbbf7e85$var$__name($64568260bbbf7e85$export$a022e873aee62a2a, "geojsonEquality");
function $64568260bbbf7e85$var$equal(object1, object2) {
    if (object1 === null && object2 === null) return true;
    if (object1 === null || object2 === null) return false;
    const objKeys1 = Object.keys(object1);
    const objKeys2 = Object.keys(object2);
    if (objKeys1.length !== objKeys2.length) return false;
    for (var key of objKeys1){
        const value1 = object1[key];
        const value2 = object2[key];
        const isObjects = $64568260bbbf7e85$var$isObject(value1) && $64568260bbbf7e85$var$isObject(value2);
        if (isObjects && !$64568260bbbf7e85$var$equal(value1, value2) || !isObjects && value1 !== value2) return false;
    }
    return true;
}
$64568260bbbf7e85$var$__name($64568260bbbf7e85$var$equal, "equal");
var $64568260bbbf7e85$var$isObject = /* @__PURE__ */ $64568260bbbf7e85$var$__name((object)=>{
    return object != null && typeof object === "object";
}, "isObject");
var $64568260bbbf7e85$export$2e2bcd8739ae039 = $64568260bbbf7e85$export$63730496493291e4;

});


parcelRegister("fZn7A", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba3e7cef391ae3f0$export$2e2bcd8739ae039);
// index.ts

var $ioYla = parcelRequire("ioYla");

var $25Xct = parcelRequire("25Xct");

var $kxJOP = parcelRequire("kxJOP");
function $ba3e7cef391ae3f0$export$1f4807a235930d45(features, options = {}) {
    const geoms = [];
    (0, $25Xct.geomEach)(features, (geom)=>{
        geoms.push(geom.coordinates);
    });
    if (geoms.length < 2) throw new Error("Must specify at least 2 geometries");
    const intersection2 = $kxJOP.intersection(geoms[0], ...geoms.slice(1));
    if (intersection2.length === 0) return null;
    if (intersection2.length === 1) return (0, $ioYla.polygon)(intersection2[0], options.properties);
    return (0, $ioYla.multiPolygon)(intersection2, options.properties);
}
var $ba3e7cef391ae3f0$export$2e2bcd8739ae039 = $ba3e7cef391ae3f0$export$1f4807a235930d45;

});
parcelRegister("kxJOP", function(module, exports) {

$parcel$export(module.exports, "union", () => $ef4a6e628e3fb851$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "intersection", () => $ef4a6e628e3fb851$export$bc86dfbf7795668c);
$parcel$export(module.exports, "difference", () => $ef4a6e628e3fb851$export$acaf96a27438246b);
// src/geom-in.ts

var $5Kq8F = parcelRequire("5Kq8F");

var $bPBby = parcelRequire("bPBby");
// src/constant.ts
var $ef4a6e628e3fb851$var$constant_default = (x)=>{
    return ()=>{
        return x;
    };
};
// src/compare.ts
var $ef4a6e628e3fb851$var$compare_default = (eps)=>{
    const almostEqual = eps ? (a, b)=>b.minus(a).abs().isLessThanOrEqualTo(eps) : $ef4a6e628e3fb851$var$constant_default(false);
    return (a, b)=>{
        if (almostEqual(a, b)) return 0;
        return a.comparedTo(b);
    };
};
// src/orient.ts
function $ef4a6e628e3fb851$var$orient_default(eps) {
    const almostCollinear = eps ? (area2, ax, ay, cx, cy)=>area2.exponentiatedBy(2).isLessThanOrEqualTo(cx.minus(ax).exponentiatedBy(2).plus(cy.minus(ay).exponentiatedBy(2)).times(eps)) : $ef4a6e628e3fb851$var$constant_default(false);
    return (a, b, c)=>{
        const ax = a.x, ay = a.y, cx = c.x, cy = c.y;
        const area2 = ay.minus(cy).times(b.x.minus(cx)).minus(ax.minus(cx).times(b.y.minus(cy)));
        if (almostCollinear(area2, ax, ay, cx, cy)) return 0;
        return area2.comparedTo(0);
    };
}
// src/identity.ts
var $ef4a6e628e3fb851$var$identity_default = (x)=>{
    return x;
};
// src/snap.ts
var $ef4a6e628e3fb851$var$snap_default = (eps)=>{
    if (eps) {
        const xTree = new (0, $bPBby.SplayTreeSet)($ef4a6e628e3fb851$var$compare_default(eps));
        const yTree = new (0, $bPBby.SplayTreeSet)($ef4a6e628e3fb851$var$compare_default(eps));
        const snapCoord = (coord, tree)=>{
            return tree.addAndReturn(coord);
        };
        const snap = (v)=>{
            return {
                x: snapCoord(v.x, xTree),
                y: snapCoord(v.y, yTree)
            };
        };
        snap({
            x: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(0),
            y: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(0)
        });
        return snap;
    }
    return $ef4a6e628e3fb851$var$identity_default;
};
// src/precision.ts
var $ef4a6e628e3fb851$var$set = (eps)=>{
    return {
        set: (eps2)=>{
            $ef4a6e628e3fb851$var$precision = $ef4a6e628e3fb851$var$set(eps2);
        },
        reset: ()=>$ef4a6e628e3fb851$var$set(eps),
        compare: $ef4a6e628e3fb851$var$compare_default(eps),
        snap: $ef4a6e628e3fb851$var$snap_default(eps),
        orient: $ef4a6e628e3fb851$var$orient_default(eps)
    };
};
var $ef4a6e628e3fb851$var$precision = $ef4a6e628e3fb851$var$set();
// src/bbox.ts
var $ef4a6e628e3fb851$var$isInBbox = (bbox, point)=>{
    return bbox.ll.x.isLessThanOrEqualTo(point.x) && point.x.isLessThanOrEqualTo(bbox.ur.x) && bbox.ll.y.isLessThanOrEqualTo(point.y) && point.y.isLessThanOrEqualTo(bbox.ur.y);
};
var $ef4a6e628e3fb851$var$getBboxOverlap = (b1, b2)=>{
    if (b2.ur.x.isLessThan(b1.ll.x) || b1.ur.x.isLessThan(b2.ll.x) || b2.ur.y.isLessThan(b1.ll.y) || b1.ur.y.isLessThan(b2.ll.y)) return null;
    const lowerX = b1.ll.x.isLessThan(b2.ll.x) ? b2.ll.x : b1.ll.x;
    const upperX = b1.ur.x.isLessThan(b2.ur.x) ? b1.ur.x : b2.ur.x;
    const lowerY = b1.ll.y.isLessThan(b2.ll.y) ? b2.ll.y : b1.ll.y;
    const upperY = b1.ur.y.isLessThan(b2.ur.y) ? b1.ur.y : b2.ur.y;
    return {
        ll: {
            x: lowerX,
            y: lowerY
        },
        ur: {
            x: upperX,
            y: upperY
        }
    };
};
// src/vector.ts
var $ef4a6e628e3fb851$var$crossProduct = (a, b)=>a.x.times(b.y).minus(a.y.times(b.x));
var $ef4a6e628e3fb851$var$dotProduct = (a, b)=>a.x.times(b.x).plus(a.y.times(b.y));
var $ef4a6e628e3fb851$var$length = (v)=>$ef4a6e628e3fb851$var$dotProduct(v, v).sqrt();
var $ef4a6e628e3fb851$var$sineOfAngle = (pShared, pBase, pAngle)=>{
    const vBase = {
        x: pBase.x.minus(pShared.x),
        y: pBase.y.minus(pShared.y)
    };
    const vAngle = {
        x: pAngle.x.minus(pShared.x),
        y: pAngle.y.minus(pShared.y)
    };
    return $ef4a6e628e3fb851$var$crossProduct(vAngle, vBase).div($ef4a6e628e3fb851$var$length(vAngle)).div($ef4a6e628e3fb851$var$length(vBase));
};
var $ef4a6e628e3fb851$var$cosineOfAngle = (pShared, pBase, pAngle)=>{
    const vBase = {
        x: pBase.x.minus(pShared.x),
        y: pBase.y.minus(pShared.y)
    };
    const vAngle = {
        x: pAngle.x.minus(pShared.x),
        y: pAngle.y.minus(pShared.y)
    };
    return $ef4a6e628e3fb851$var$dotProduct(vAngle, vBase).div($ef4a6e628e3fb851$var$length(vAngle)).div($ef4a6e628e3fb851$var$length(vBase));
};
var $ef4a6e628e3fb851$var$horizontalIntersection = (pt, v, y)=>{
    if (v.y.isZero()) return null;
    return {
        x: pt.x.plus(v.x.div(v.y).times(y.minus(pt.y))),
        y: y
    };
};
var $ef4a6e628e3fb851$var$verticalIntersection = (pt, v, x)=>{
    if (v.x.isZero()) return null;
    return {
        x: x,
        y: pt.y.plus(v.y.div(v.x).times(x.minus(pt.x)))
    };
};
var $ef4a6e628e3fb851$var$intersection = (pt1, v1, pt2, v2)=>{
    if (v1.x.isZero()) return $ef4a6e628e3fb851$var$verticalIntersection(pt2, v2, pt1.x);
    if (v2.x.isZero()) return $ef4a6e628e3fb851$var$verticalIntersection(pt1, v1, pt2.x);
    if (v1.y.isZero()) return $ef4a6e628e3fb851$var$horizontalIntersection(pt2, v2, pt1.y);
    if (v2.y.isZero()) return $ef4a6e628e3fb851$var$horizontalIntersection(pt1, v1, pt2.y);
    const kross = $ef4a6e628e3fb851$var$crossProduct(v1, v2);
    if (kross.isZero()) return null;
    const ve = {
        x: pt2.x.minus(pt1.x),
        y: pt2.y.minus(pt1.y)
    };
    const d1 = $ef4a6e628e3fb851$var$crossProduct(ve, v1).div(kross);
    const d2 = $ef4a6e628e3fb851$var$crossProduct(ve, v2).div(kross);
    const x1 = pt1.x.plus(d2.times(v1.x)), x2 = pt2.x.plus(d1.times(v2.x));
    const y1 = pt1.y.plus(d2.times(v1.y)), y2 = pt2.y.plus(d1.times(v2.y));
    const x = x1.plus(x2).div(2);
    const y = y1.plus(y2).div(2);
    return {
        x: x,
        y: y
    };
};
// src/sweep-event.ts
var $ef4a6e628e3fb851$var$SweepEvent = class _SweepEvent {
    point;
    isLeft;
    segment;
    otherSE;
    consumedBy;
    // for ordering sweep events in the sweep event queue
    static compare(a, b) {
        const ptCmp = _SweepEvent.comparePoints(a.point, b.point);
        if (ptCmp !== 0) return ptCmp;
        if (a.point !== b.point) a.link(b);
        if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1;
        return $ef4a6e628e3fb851$var$Segment.compare(a.segment, b.segment);
    }
    // for ordering points in sweep line order
    static comparePoints(aPt, bPt) {
        if (aPt.x.isLessThan(bPt.x)) return -1;
        if (aPt.x.isGreaterThan(bPt.x)) return 1;
        if (aPt.y.isLessThan(bPt.y)) return -1;
        if (aPt.y.isGreaterThan(bPt.y)) return 1;
        return 0;
    }
    // Warning: 'point' input will be modified and re-used (for performance)
    constructor(point, isLeft){
        if (point.events === void 0) point.events = [
            this
        ];
        else point.events.push(this);
        this.point = point;
        this.isLeft = isLeft;
    }
    link(other) {
        if (other.point === this.point) throw new Error("Tried to link already linked events");
        const otherEvents = other.point.events;
        for(let i = 0, iMax = otherEvents.length; i < iMax; i++){
            const evt = otherEvents[i];
            this.point.events.push(evt);
            evt.point = this.point;
        }
        this.checkForConsuming();
    }
    /* Do a pass over our linked events and check to see if any pair
   * of segments match, and should be consumed. */ checkForConsuming() {
        const numEvents = this.point.events.length;
        for(let i = 0; i < numEvents; i++){
            const evt1 = this.point.events[i];
            if (evt1.segment.consumedBy !== void 0) continue;
            for(let j = i + 1; j < numEvents; j++){
                const evt2 = this.point.events[j];
                if (evt2.consumedBy !== void 0) continue;
                if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
                evt1.segment.consume(evt2.segment);
            }
        }
    }
    getAvailableLinkedEvents() {
        const events = [];
        for(let i = 0, iMax = this.point.events.length; i < iMax; i++){
            const evt = this.point.events[i];
            if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) events.push(evt);
        }
        return events;
    }
    /**
   * Returns a comparator function for sorting linked events that will
   * favor the event that will give us the smallest left-side angle.
   * All ring construction starts as low as possible heading to the right,
   * so by always turning left as sharp as possible we'll get polygons
   * without uncessary loops & holes.
   *
   * The comparator function has a compute cache such that it avoids
   * re-computing already-computed values.
   */ getLeftmostComparator(baseEvent) {
        const cache = /* @__PURE__ */ new Map();
        const fillCache = (linkedEvent)=>{
            const nextEvent = linkedEvent.otherSE;
            cache.set(linkedEvent, {
                sine: $ef4a6e628e3fb851$var$sineOfAngle(this.point, baseEvent.point, nextEvent.point),
                cosine: $ef4a6e628e3fb851$var$cosineOfAngle(this.point, baseEvent.point, nextEvent.point)
            });
        };
        return (a, b)=>{
            if (!cache.has(a)) fillCache(a);
            if (!cache.has(b)) fillCache(b);
            const { sine: asine, cosine: acosine } = cache.get(a);
            const { sine: bsine, cosine: bcosine } = cache.get(b);
            if (asine.isGreaterThanOrEqualTo(0) && bsine.isGreaterThanOrEqualTo(0)) {
                if (acosine.isLessThan(bcosine)) return 1;
                if (acosine.isGreaterThan(bcosine)) return -1;
                return 0;
            }
            if (asine.isLessThan(0) && bsine.isLessThan(0)) {
                if (acosine.isLessThan(bcosine)) return -1;
                if (acosine.isGreaterThan(bcosine)) return 1;
                return 0;
            }
            if (bsine.isLessThan(asine)) return -1;
            if (bsine.isGreaterThan(asine)) return 1;
            return 0;
        };
    }
};
// src/geom-out.ts
var $ef4a6e628e3fb851$var$RingOut = class _RingOut {
    events;
    poly;
    _isExteriorRing;
    _enclosingRing;
    /* Given the segments from the sweep line pass, compute & return a series
   * of closed rings from all the segments marked to be part of the result */ static factory(allSegments) {
        const ringsOut = [];
        for(let i = 0, iMax = allSegments.length; i < iMax; i++){
            const segment = allSegments[i];
            if (!segment.isInResult() || segment.ringOut) continue;
            let prevEvent = null;
            let event = segment.leftSE;
            let nextEvent = segment.rightSE;
            const events = [
                event
            ];
            const startingPoint = event.point;
            const intersectionLEs = [];
            while(true){
                prevEvent = event;
                event = nextEvent;
                events.push(event);
                if (event.point === startingPoint) break;
                while(true){
                    const availableLEs = event.getAvailableLinkedEvents();
                    if (availableLEs.length === 0) {
                        const firstPt = events[0].point;
                        const lastPt = events[events.length - 1].point;
                        throw new Error(`Unable to complete output ring starting at [${firstPt.x}, ${firstPt.y}]. Last matching segment found ends at [${lastPt.x}, ${lastPt.y}].`);
                    }
                    if (availableLEs.length === 1) {
                        nextEvent = availableLEs[0].otherSE;
                        break;
                    }
                    let indexLE = null;
                    for(let j = 0, jMax = intersectionLEs.length; j < jMax; j++)if (intersectionLEs[j].point === event.point) {
                        indexLE = j;
                        break;
                    }
                    if (indexLE !== null) {
                        const intersectionLE = intersectionLEs.splice(indexLE)[0];
                        const ringEvents = events.splice(intersectionLE.index);
                        ringEvents.unshift(ringEvents[0].otherSE);
                        ringsOut.push(new _RingOut(ringEvents.reverse()));
                        continue;
                    }
                    intersectionLEs.push({
                        index: events.length,
                        point: event.point
                    });
                    const comparator = event.getLeftmostComparator(prevEvent);
                    nextEvent = availableLEs.sort(comparator)[0].otherSE;
                    break;
                }
            }
            ringsOut.push(new _RingOut(events));
        }
        return ringsOut;
    }
    constructor(events){
        this.events = events;
        for(let i = 0, iMax = events.length; i < iMax; i++)events[i].segment.ringOut = this;
        this.poly = null;
    }
    getGeom() {
        let prevPt = this.events[0].point;
        const points = [
            prevPt
        ];
        for(let i = 1, iMax = this.events.length - 1; i < iMax; i++){
            const pt2 = this.events[i].point;
            const nextPt2 = this.events[i + 1].point;
            if ($ef4a6e628e3fb851$var$precision.orient(pt2, prevPt, nextPt2) === 0) continue;
            points.push(pt2);
            prevPt = pt2;
        }
        if (points.length === 1) return null;
        const pt = points[0];
        const nextPt = points[1];
        if ($ef4a6e628e3fb851$var$precision.orient(pt, prevPt, nextPt) === 0) points.shift();
        points.push(points[0]);
        const step = this.isExteriorRing() ? 1 : -1;
        const iStart = this.isExteriorRing() ? 0 : points.length - 1;
        const iEnd = this.isExteriorRing() ? points.length : -1;
        const orderedPoints = [];
        for(let i = iStart; i != iEnd; i += step)orderedPoints.push([
            points[i].x.toNumber(),
            points[i].y.toNumber()
        ]);
        return orderedPoints;
    }
    isExteriorRing() {
        if (this._isExteriorRing === void 0) {
            const enclosing = this.enclosingRing();
            this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
        }
        return this._isExteriorRing;
    }
    enclosingRing() {
        if (this._enclosingRing === void 0) this._enclosingRing = this._calcEnclosingRing();
        return this._enclosingRing;
    }
    /* Returns the ring that encloses this one, if any */ _calcEnclosingRing() {
        let leftMostEvt = this.events[0];
        for(let i = 1, iMax = this.events.length; i < iMax; i++){
            const evt = this.events[i];
            if ($ef4a6e628e3fb851$var$SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
        }
        let prevSeg = leftMostEvt.segment.prevInResult();
        let prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
        while(true){
            if (!prevSeg) return null;
            if (!prevPrevSeg) return prevSeg.ringOut;
            if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
                if (prevPrevSeg.ringOut?.enclosingRing() !== prevSeg.ringOut) return prevSeg.ringOut;
                else return prevSeg.ringOut?.enclosingRing();
            }
            prevSeg = prevPrevSeg.prevInResult();
            prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
        }
    }
};
var $ef4a6e628e3fb851$var$PolyOut = class {
    exteriorRing;
    interiorRings;
    constructor(exteriorRing){
        this.exteriorRing = exteriorRing;
        exteriorRing.poly = this;
        this.interiorRings = [];
    }
    addInterior(ring) {
        this.interiorRings.push(ring);
        ring.poly = this;
    }
    getGeom() {
        const geom0 = this.exteriorRing.getGeom();
        if (geom0 === null) return null;
        const geom = [
            geom0
        ];
        for(let i = 0, iMax = this.interiorRings.length; i < iMax; i++){
            const ringGeom = this.interiorRings[i].getGeom();
            if (ringGeom === null) continue;
            geom.push(ringGeom);
        }
        return geom;
    }
};
var $ef4a6e628e3fb851$var$MultiPolyOut = class {
    rings;
    polys;
    constructor(rings){
        this.rings = rings;
        this.polys = this._composePolys(rings);
    }
    getGeom() {
        const geom = [];
        for(let i = 0, iMax = this.polys.length; i < iMax; i++){
            const polyGeom = this.polys[i].getGeom();
            if (polyGeom === null) continue;
            geom.push(polyGeom);
        }
        return geom;
    }
    _composePolys(rings) {
        const polys = [];
        for(let i = 0, iMax = rings.length; i < iMax; i++){
            const ring = rings[i];
            if (ring.poly) continue;
            if (ring.isExteriorRing()) polys.push(new $ef4a6e628e3fb851$var$PolyOut(ring));
            else {
                const enclosingRing = ring.enclosingRing();
                if (!enclosingRing?.poly) polys.push(new $ef4a6e628e3fb851$var$PolyOut(enclosingRing));
                enclosingRing?.poly?.addInterior(ring);
            }
        }
        return polys;
    }
};
var $ef4a6e628e3fb851$var$SweepLine = class {
    queue;
    tree;
    segments;
    constructor(queue, comparator = $ef4a6e628e3fb851$var$Segment.compare){
        this.queue = queue;
        this.tree = new (0, $bPBby.SplayTreeSet)(comparator);
        this.segments = [];
    }
    process(event) {
        const segment = event.segment;
        const newEvents = [];
        if (event.consumedBy) {
            if (event.isLeft) this.queue.delete(event.otherSE);
            else this.tree.delete(segment);
            return newEvents;
        }
        if (event.isLeft) this.tree.add(segment);
        let prevSeg = segment;
        let nextSeg = segment;
        do prevSeg = this.tree.lastBefore(prevSeg);
        while (prevSeg != null && prevSeg.consumedBy != void 0);
        do nextSeg = this.tree.firstAfter(nextSeg);
        while (nextSeg != null && nextSeg.consumedBy != void 0);
        if (event.isLeft) {
            let prevMySplitter = null;
            if (prevSeg) {
                const prevInter = prevSeg.getIntersection(segment);
                if (prevInter !== null) {
                    if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
                    if (!prevSeg.isAnEndpoint(prevInter)) {
                        const newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
                        for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                    }
                }
            }
            let nextMySplitter = null;
            if (nextSeg) {
                const nextInter = nextSeg.getIntersection(segment);
                if (nextInter !== null) {
                    if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
                    if (!nextSeg.isAnEndpoint(nextInter)) {
                        const newEventsFromSplit = this._splitSafely(nextSeg, nextInter);
                        for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                    }
                }
            }
            if (prevMySplitter !== null || nextMySplitter !== null) {
                let mySplitter = null;
                if (prevMySplitter === null) mySplitter = nextMySplitter;
                else if (nextMySplitter === null) mySplitter = prevMySplitter;
                else {
                    const cmpSplitters = $ef4a6e628e3fb851$var$SweepEvent.comparePoints(prevMySplitter, nextMySplitter);
                    mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
                }
                this.queue.delete(segment.rightSE);
                newEvents.push(segment.rightSE);
                const newEventsFromSplit = segment.split(mySplitter);
                for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
            }
            if (newEvents.length > 0) {
                this.tree.delete(segment);
                newEvents.push(event);
            } else {
                this.segments.push(segment);
                segment.prev = prevSeg;
            }
        } else {
            if (prevSeg && nextSeg) {
                const inter = prevSeg.getIntersection(nextSeg);
                if (inter !== null) {
                    if (!prevSeg.isAnEndpoint(inter)) {
                        const newEventsFromSplit = this._splitSafely(prevSeg, inter);
                        for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                    }
                    if (!nextSeg.isAnEndpoint(inter)) {
                        const newEventsFromSplit = this._splitSafely(nextSeg, inter);
                        for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                    }
                }
            }
            this.tree.delete(segment);
        }
        return newEvents;
    }
    /* Safely split a segment that is currently in the datastructures
   * IE - a segment other than the one that is currently being processed. */ _splitSafely(seg, pt) {
        this.tree.delete(seg);
        const rightSE = seg.rightSE;
        this.queue.delete(rightSE);
        const newEvents = seg.split(pt);
        newEvents.push(rightSE);
        if (seg.consumedBy === void 0) this.tree.add(seg);
        return newEvents;
    }
};
// src/operation.ts
var $ef4a6e628e3fb851$var$Operation = class {
    type;
    numMultiPolys;
    run(type, geom, moreGeoms) {
        $ef4a6e628e3fb851$var$operation.type = type;
        const multipolys = [
            new $ef4a6e628e3fb851$var$MultiPolyIn(geom, true)
        ];
        for(let i = 0, iMax = moreGeoms.length; i < iMax; i++)multipolys.push(new $ef4a6e628e3fb851$var$MultiPolyIn(moreGeoms[i], false));
        $ef4a6e628e3fb851$var$operation.numMultiPolys = multipolys.length;
        if ($ef4a6e628e3fb851$var$operation.type === "difference") {
            const subject = multipolys[0];
            let i = 1;
            while(i < multipolys.length)if ($ef4a6e628e3fb851$var$getBboxOverlap(multipolys[i].bbox, subject.bbox) !== null) i++;
            else multipolys.splice(i, 1);
        }
        if ($ef4a6e628e3fb851$var$operation.type === "intersection") for(let i = 0, iMax = multipolys.length; i < iMax; i++){
            const mpA = multipolys[i];
            for(let j = i + 1, jMax = multipolys.length; j < jMax; j++){
                if ($ef4a6e628e3fb851$var$getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
            }
        }
        const queue = new (0, $bPBby.SplayTreeSet)($ef4a6e628e3fb851$var$SweepEvent.compare);
        for(let i = 0, iMax = multipolys.length; i < iMax; i++){
            const sweepEvents = multipolys[i].getSweepEvents();
            for(let j = 0, jMax = sweepEvents.length; j < jMax; j++)queue.add(sweepEvents[j]);
        }
        const sweepLine = new $ef4a6e628e3fb851$var$SweepLine(queue);
        let evt = null;
        if (queue.size != 0) {
            evt = queue.first();
            queue.delete(evt);
        }
        while(evt){
            const newEvents = sweepLine.process(evt);
            for(let i = 0, iMax = newEvents.length; i < iMax; i++){
                const evt2 = newEvents[i];
                if (evt2.consumedBy === void 0) queue.add(evt2);
            }
            if (queue.size != 0) {
                evt = queue.first();
                queue.delete(evt);
            } else evt = null;
        }
        $ef4a6e628e3fb851$var$precision.reset();
        const ringsOut = $ef4a6e628e3fb851$var$RingOut.factory(sweepLine.segments);
        const result = new $ef4a6e628e3fb851$var$MultiPolyOut(ringsOut);
        return result.getGeom();
    }
};
var $ef4a6e628e3fb851$var$operation = new $ef4a6e628e3fb851$var$Operation();
var $ef4a6e628e3fb851$var$operation_default = $ef4a6e628e3fb851$var$operation;
// src/segment.ts
var $ef4a6e628e3fb851$var$segmentId = 0;
var $ef4a6e628e3fb851$var$Segment = class _Segment {
    id;
    leftSE;
    rightSE;
    rings;
    windings;
    ringOut;
    consumedBy;
    prev;
    _prevInResult;
    _beforeState;
    _afterState;
    _isInResult;
    /* This compare() function is for ordering segments in the sweep
   * line tree, and does so according to the following criteria:
   *
   * Consider the vertical line that lies an infinestimal step to the
   * right of the right-more of the two left endpoints of the input
   * segments. Imagine slowly moving a point up from negative infinity
   * in the increasing y direction. Which of the two segments will that
   * point intersect first? That segment comes 'before' the other one.
   *
   * If neither segment would be intersected by such a line, (if one
   * or more of the segments are vertical) then the line to be considered
   * is directly on the right-more of the two left inputs.
   */ static compare(a, b) {
        const alx = a.leftSE.point.x;
        const blx = b.leftSE.point.x;
        const arx = a.rightSE.point.x;
        const brx = b.rightSE.point.x;
        if (brx.isLessThan(alx)) return 1;
        if (arx.isLessThan(blx)) return -1;
        const aly = a.leftSE.point.y;
        const bly = b.leftSE.point.y;
        const ary = a.rightSE.point.y;
        const bry = b.rightSE.point.y;
        if (alx.isLessThan(blx)) {
            if (bly.isLessThan(aly) && bly.isLessThan(ary)) return 1;
            if (bly.isGreaterThan(aly) && bly.isGreaterThan(ary)) return -1;
            const aCmpBLeft = a.comparePoint(b.leftSE.point);
            if (aCmpBLeft < 0) return 1;
            if (aCmpBLeft > 0) return -1;
            const bCmpARight = b.comparePoint(a.rightSE.point);
            if (bCmpARight !== 0) return bCmpARight;
            return -1;
        }
        if (alx.isGreaterThan(blx)) {
            if (aly.isLessThan(bly) && aly.isLessThan(bry)) return -1;
            if (aly.isGreaterThan(bly) && aly.isGreaterThan(bry)) return 1;
            const bCmpALeft = b.comparePoint(a.leftSE.point);
            if (bCmpALeft !== 0) return bCmpALeft;
            const aCmpBRight = a.comparePoint(b.rightSE.point);
            if (aCmpBRight < 0) return 1;
            if (aCmpBRight > 0) return -1;
            return 1;
        }
        if (aly.isLessThan(bly)) return -1;
        if (aly.isGreaterThan(bly)) return 1;
        if (arx.isLessThan(brx)) {
            const bCmpARight = b.comparePoint(a.rightSE.point);
            if (bCmpARight !== 0) return bCmpARight;
        }
        if (arx.isGreaterThan(brx)) {
            const aCmpBRight = a.comparePoint(b.rightSE.point);
            if (aCmpBRight < 0) return 1;
            if (aCmpBRight > 0) return -1;
        }
        if (!arx.eq(brx)) {
            const ay = ary.minus(aly);
            const ax = arx.minus(alx);
            const by = bry.minus(bly);
            const bx = brx.minus(blx);
            if (ay.isGreaterThan(ax) && by.isLessThan(bx)) return 1;
            if (ay.isLessThan(ax) && by.isGreaterThan(bx)) return -1;
        }
        if (arx.isGreaterThan(brx)) return 1;
        if (arx.isLessThan(brx)) return -1;
        if (ary.isLessThan(bry)) return -1;
        if (ary.isGreaterThan(bry)) return 1;
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
    }
    /* Warning: a reference to ringWindings input will be stored,
   *  and possibly will be later modified */ constructor(leftSE, rightSE, rings, windings){
        this.id = ++$ef4a6e628e3fb851$var$segmentId;
        this.leftSE = leftSE;
        leftSE.segment = this;
        leftSE.otherSE = rightSE;
        this.rightSE = rightSE;
        rightSE.segment = this;
        rightSE.otherSE = leftSE;
        this.rings = rings;
        this.windings = windings;
    }
    static fromRing(pt1, pt2, ring) {
        let leftPt, rightPt, winding;
        const cmpPts = $ef4a6e628e3fb851$var$SweepEvent.comparePoints(pt1, pt2);
        if (cmpPts < 0) {
            leftPt = pt1;
            rightPt = pt2;
            winding = 1;
        } else if (cmpPts > 0) {
            leftPt = pt2;
            rightPt = pt1;
            winding = -1;
        } else throw new Error(`Tried to create degenerate segment at [${pt1.x}, ${pt1.y}]`);
        const leftSE = new $ef4a6e628e3fb851$var$SweepEvent(leftPt, true);
        const rightSE = new $ef4a6e628e3fb851$var$SweepEvent(rightPt, false);
        return new _Segment(leftSE, rightSE, [
            ring
        ], [
            winding
        ]);
    }
    /* When a segment is split, the rightSE is replaced with a new sweep event */ replaceRightSE(newRightSE) {
        this.rightSE = newRightSE;
        this.rightSE.segment = this;
        this.rightSE.otherSE = this.leftSE;
        this.leftSE.otherSE = this.rightSE;
    }
    bbox() {
        const y1 = this.leftSE.point.y;
        const y2 = this.rightSE.point.y;
        return {
            ll: {
                x: this.leftSE.point.x,
                y: y1.isLessThan(y2) ? y1 : y2
            },
            ur: {
                x: this.rightSE.point.x,
                y: y1.isGreaterThan(y2) ? y1 : y2
            }
        };
    }
    /* A vector from the left point to the right */ vector() {
        return {
            x: this.rightSE.point.x.minus(this.leftSE.point.x),
            y: this.rightSE.point.y.minus(this.leftSE.point.y)
        };
    }
    isAnEndpoint(pt) {
        return pt.x.eq(this.leftSE.point.x) && pt.y.eq(this.leftSE.point.y) || pt.x.eq(this.rightSE.point.x) && pt.y.eq(this.rightSE.point.y);
    }
    /* Compare this segment with a point.
   *
   * A point P is considered to be colinear to a segment if there
   * exists a distance D such that if we travel along the segment
   * from one * endpoint towards the other a distance D, we find
   * ourselves at point P.
   *
   * Return value indicates:
   *
   *   1: point lies above the segment (to the left of vertical)
   *   0: point is colinear to segment
   *  -1: point lies below the segment (to the right of vertical)
   */ comparePoint(point) {
        return $ef4a6e628e3fb851$var$precision.orient(this.leftSE.point, point, this.rightSE.point);
    }
    /**
   * Given another segment, returns the first non-trivial intersection
   * between the two segments (in terms of sweep line ordering), if it exists.
   *
   * A 'non-trivial' intersection is one that will cause one or both of the
   * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
   *
   *   * endpoint of segA with endpoint of segB --> trivial
   *   * endpoint of segA with point along segB --> non-trivial
   *   * endpoint of segB with point along segA --> non-trivial
   *   * point along segA with point along segB --> non-trivial
   *
   * If no non-trivial intersection exists, return null
   * Else, return null.
   */ getIntersection(other) {
        const tBbox = this.bbox();
        const oBbox = other.bbox();
        const bboxOverlap = $ef4a6e628e3fb851$var$getBboxOverlap(tBbox, oBbox);
        if (bboxOverlap === null) return null;
        const tlp = this.leftSE.point;
        const trp = this.rightSE.point;
        const olp = other.leftSE.point;
        const orp = other.rightSE.point;
        const touchesOtherLSE = $ef4a6e628e3fb851$var$isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
        const touchesThisLSE = $ef4a6e628e3fb851$var$isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
        const touchesOtherRSE = $ef4a6e628e3fb851$var$isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
        const touchesThisRSE = $ef4a6e628e3fb851$var$isInBbox(oBbox, trp) && other.comparePoint(trp) === 0;
        if (touchesThisLSE && touchesOtherLSE) {
            if (touchesThisRSE && !touchesOtherRSE) return trp;
            if (!touchesThisRSE && touchesOtherRSE) return orp;
            return null;
        }
        if (touchesThisLSE) {
            if (touchesOtherRSE) {
                if (tlp.x.eq(orp.x) && tlp.y.eq(orp.y)) return null;
            }
            return tlp;
        }
        if (touchesOtherLSE) {
            if (touchesThisRSE) {
                if (trp.x.eq(olp.x) && trp.y.eq(olp.y)) return null;
            }
            return olp;
        }
        if (touchesThisRSE && touchesOtherRSE) return null;
        if (touchesThisRSE) return trp;
        if (touchesOtherRSE) return orp;
        const pt = $ef4a6e628e3fb851$var$intersection(tlp, this.vector(), olp, other.vector());
        if (pt === null) return null;
        if (!$ef4a6e628e3fb851$var$isInBbox(bboxOverlap, pt)) return null;
        return $ef4a6e628e3fb851$var$precision.snap(pt);
    }
    /**
   * Split the given segment into multiple segments on the given points.
   *  * Each existing segment will retain its leftSE and a new rightSE will be
   *    generated for it.
   *  * A new segment will be generated which will adopt the original segment's
   *    rightSE, and a new leftSE will be generated for it.
   *  * If there are more than two points given to split on, new segments
   *    in the middle will be generated with new leftSE and rightSE's.
   *  * An array of the newly generated SweepEvents will be returned.
   *
   * Warning: input array of points is modified
   */ split(point) {
        const newEvents = [];
        const alreadyLinked = point.events !== void 0;
        const newLeftSE = new $ef4a6e628e3fb851$var$SweepEvent(point, true);
        const newRightSE = new $ef4a6e628e3fb851$var$SweepEvent(point, false);
        const oldRightSE = this.rightSE;
        this.replaceRightSE(newRightSE);
        newEvents.push(newRightSE);
        newEvents.push(newLeftSE);
        const newSeg = new _Segment(newLeftSE, oldRightSE, this.rings.slice(), this.windings.slice());
        if ($ef4a6e628e3fb851$var$SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) newSeg.swapEvents();
        if ($ef4a6e628e3fb851$var$SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) this.swapEvents();
        if (alreadyLinked) {
            newLeftSE.checkForConsuming();
            newRightSE.checkForConsuming();
        }
        return newEvents;
    }
    /* Swap which event is left and right */ swapEvents() {
        const tmpEvt = this.rightSE;
        this.rightSE = this.leftSE;
        this.leftSE = tmpEvt;
        this.leftSE.isLeft = true;
        this.rightSE.isLeft = false;
        for(let i = 0, iMax = this.windings.length; i < iMax; i++)this.windings[i] *= -1;
    }
    /* Consume another segment. We take their rings under our wing
   * and mark them as consumed. Use for perfectly overlapping segments */ consume(other) {
        let consumer = this;
        let consumee = other;
        while(consumer.consumedBy)consumer = consumer.consumedBy;
        while(consumee.consumedBy)consumee = consumee.consumedBy;
        const cmp = _Segment.compare(consumer, consumee);
        if (cmp === 0) return;
        if (cmp > 0) {
            const tmp = consumer;
            consumer = consumee;
            consumee = tmp;
        }
        if (consumer.prev === consumee) {
            const tmp = consumer;
            consumer = consumee;
            consumee = tmp;
        }
        for(let i = 0, iMax = consumee.rings.length; i < iMax; i++){
            const ring = consumee.rings[i];
            const winding = consumee.windings[i];
            const index = consumer.rings.indexOf(ring);
            if (index === -1) {
                consumer.rings.push(ring);
                consumer.windings.push(winding);
            } else consumer.windings[index] += winding;
        }
        consumee.rings = null;
        consumee.windings = null;
        consumee.consumedBy = consumer;
        consumee.leftSE.consumedBy = consumer.leftSE;
        consumee.rightSE.consumedBy = consumer.rightSE;
    }
    /* The first segment previous segment chain that is in the result */ prevInResult() {
        if (this._prevInResult !== void 0) return this._prevInResult;
        if (!this.prev) this._prevInResult = null;
        else if (this.prev.isInResult()) this._prevInResult = this.prev;
        else this._prevInResult = this.prev.prevInResult();
        return this._prevInResult;
    }
    beforeState() {
        if (this._beforeState !== void 0) return this._beforeState;
        if (!this.prev) this._beforeState = {
            rings: [],
            windings: [],
            multiPolys: []
        };
        else {
            const seg = this.prev.consumedBy || this.prev;
            this._beforeState = seg.afterState();
        }
        return this._beforeState;
    }
    afterState() {
        if (this._afterState !== void 0) return this._afterState;
        const beforeState = this.beforeState();
        this._afterState = {
            rings: beforeState.rings.slice(0),
            windings: beforeState.windings.slice(0),
            multiPolys: []
        };
        const ringsAfter = this._afterState.rings;
        const windingsAfter = this._afterState.windings;
        const mpsAfter = this._afterState.multiPolys;
        for(let i = 0, iMax = this.rings.length; i < iMax; i++){
            const ring = this.rings[i];
            const winding = this.windings[i];
            const index = ringsAfter.indexOf(ring);
            if (index === -1) {
                ringsAfter.push(ring);
                windingsAfter.push(winding);
            } else windingsAfter[index] += winding;
        }
        const polysAfter = [];
        const polysExclude = [];
        for(let i = 0, iMax = ringsAfter.length; i < iMax; i++){
            if (windingsAfter[i] === 0) continue;
            const ring = ringsAfter[i];
            const poly = ring.poly;
            if (polysExclude.indexOf(poly) !== -1) continue;
            if (ring.isExterior) polysAfter.push(poly);
            else {
                if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
                const index = polysAfter.indexOf(ring.poly);
                if (index !== -1) polysAfter.splice(index, 1);
            }
        }
        for(let i = 0, iMax = polysAfter.length; i < iMax; i++){
            const mp = polysAfter[i].multiPoly;
            if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
        }
        return this._afterState;
    }
    /* Is this segment part of the final result? */ isInResult() {
        if (this.consumedBy) return false;
        if (this._isInResult !== void 0) return this._isInResult;
        const mpsBefore = this.beforeState().multiPolys;
        const mpsAfter = this.afterState().multiPolys;
        switch($ef4a6e628e3fb851$var$operation_default.type){
            case "union":
                {
                    const noBefores = mpsBefore.length === 0;
                    const noAfters = mpsAfter.length === 0;
                    this._isInResult = noBefores !== noAfters;
                    break;
                }
            case "intersection":
                {
                    let least;
                    let most;
                    if (mpsBefore.length < mpsAfter.length) {
                        least = mpsBefore.length;
                        most = mpsAfter.length;
                    } else {
                        least = mpsAfter.length;
                        most = mpsBefore.length;
                    }
                    this._isInResult = most === $ef4a6e628e3fb851$var$operation_default.numMultiPolys && least < most;
                    break;
                }
            case "xor":
                {
                    const diff = Math.abs(mpsBefore.length - mpsAfter.length);
                    this._isInResult = diff % 2 === 1;
                    break;
                }
            case "difference":
                {
                    const isJustSubject = (mps)=>mps.length === 1 && mps[0].isSubject;
                    this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
                    break;
                }
        }
        return this._isInResult;
    }
};
// src/geom-in.ts
var $ef4a6e628e3fb851$var$RingIn = class {
    poly;
    isExterior;
    segments;
    bbox;
    constructor(geomRing, poly, isExterior){
        if (!Array.isArray(geomRing) || geomRing.length === 0) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        this.poly = poly;
        this.isExterior = isExterior;
        this.segments = [];
        if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        const firstPoint = $ef4a6e628e3fb851$var$precision.snap({
            x: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(geomRing[0][0]),
            y: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(geomRing[0][1])
        });
        this.bbox = {
            ll: {
                x: firstPoint.x,
                y: firstPoint.y
            },
            ur: {
                x: firstPoint.x,
                y: firstPoint.y
            }
        };
        let prevPoint = firstPoint;
        for(let i = 1, iMax = geomRing.length; i < iMax; i++){
            if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            const point = $ef4a6e628e3fb851$var$precision.snap({
                x: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(geomRing[i][0]),
                y: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(geomRing[i][1])
            });
            if (point.x.eq(prevPoint.x) && point.y.eq(prevPoint.y)) continue;
            this.segments.push($ef4a6e628e3fb851$var$Segment.fromRing(prevPoint, point, this));
            if (point.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = point.x;
            if (point.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = point.y;
            if (point.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = point.x;
            if (point.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = point.y;
            prevPoint = point;
        }
        if (!firstPoint.x.eq(prevPoint.x) || !firstPoint.y.eq(prevPoint.y)) this.segments.push($ef4a6e628e3fb851$var$Segment.fromRing(prevPoint, firstPoint, this));
    }
    getSweepEvents() {
        const sweepEvents = [];
        for(let i = 0, iMax = this.segments.length; i < iMax; i++){
            const segment = this.segments[i];
            sweepEvents.push(segment.leftSE);
            sweepEvents.push(segment.rightSE);
        }
        return sweepEvents;
    }
};
var $ef4a6e628e3fb851$var$PolyIn = class {
    multiPoly;
    exteriorRing;
    interiorRings;
    bbox;
    constructor(geomPoly, multiPoly){
        if (!Array.isArray(geomPoly)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        this.exteriorRing = new $ef4a6e628e3fb851$var$RingIn(geomPoly[0], this, true);
        this.bbox = {
            ll: {
                x: this.exteriorRing.bbox.ll.x,
                y: this.exteriorRing.bbox.ll.y
            },
            ur: {
                x: this.exteriorRing.bbox.ur.x,
                y: this.exteriorRing.bbox.ur.y
            }
        };
        this.interiorRings = [];
        for(let i = 1, iMax = geomPoly.length; i < iMax; i++){
            const ring = new $ef4a6e628e3fb851$var$RingIn(geomPoly[i], this, false);
            if (ring.bbox.ll.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = ring.bbox.ll.x;
            if (ring.bbox.ll.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = ring.bbox.ll.y;
            if (ring.bbox.ur.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = ring.bbox.ur.x;
            if (ring.bbox.ur.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = ring.bbox.ur.y;
            this.interiorRings.push(ring);
        }
        this.multiPoly = multiPoly;
    }
    getSweepEvents() {
        const sweepEvents = this.exteriorRing.getSweepEvents();
        for(let i = 0, iMax = this.interiorRings.length; i < iMax; i++){
            const ringSweepEvents = this.interiorRings[i].getSweepEvents();
            for(let j = 0, jMax = ringSweepEvents.length; j < jMax; j++)sweepEvents.push(ringSweepEvents[j]);
        }
        return sweepEvents;
    }
};
var $ef4a6e628e3fb851$var$MultiPolyIn = class {
    isSubject;
    polys;
    bbox;
    constructor(geom, isSubject){
        if (!Array.isArray(geom)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        try {
            if (typeof geom[0][0][0] === "number") geom = [
                geom
            ];
        } catch (ex) {}
        this.polys = [];
        this.bbox = {
            ll: {
                x: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(Number.POSITIVE_INFINITY),
                y: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(Number.POSITIVE_INFINITY)
            },
            ur: {
                x: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(Number.NEGATIVE_INFINITY),
                y: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(Number.NEGATIVE_INFINITY)
            }
        };
        for(let i = 0, iMax = geom.length; i < iMax; i++){
            const poly = new $ef4a6e628e3fb851$var$PolyIn(geom[i], this);
            if (poly.bbox.ll.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = poly.bbox.ll.x;
            if (poly.bbox.ll.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = poly.bbox.ll.y;
            if (poly.bbox.ur.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = poly.bbox.ur.x;
            if (poly.bbox.ur.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = poly.bbox.ur.y;
            this.polys.push(poly);
        }
        this.isSubject = isSubject;
    }
    getSweepEvents() {
        const sweepEvents = [];
        for(let i = 0, iMax = this.polys.length; i < iMax; i++){
            const polySweepEvents = this.polys[i].getSweepEvents();
            for(let j = 0, jMax = polySweepEvents.length; j < jMax; j++)sweepEvents.push(polySweepEvents[j]);
        }
        return sweepEvents;
    }
};
// src/index.ts
var $ef4a6e628e3fb851$export$971dd5b0dfd021b6 = (geom, ...moreGeoms)=>$ef4a6e628e3fb851$var$operation_default.run("union", geom, moreGeoms);
var $ef4a6e628e3fb851$export$bc86dfbf7795668c = (geom, ...moreGeoms)=>$ef4a6e628e3fb851$var$operation_default.run("intersection", geom, moreGeoms);
var $ef4a6e628e3fb851$export$6444ef5cd411280c = (geom, ...moreGeoms)=>$ef4a6e628e3fb851$var$operation_default.run("xor", geom, moreGeoms);
var $ef4a6e628e3fb851$export$acaf96a27438246b = (geom, ...moreGeoms)=>$ef4a6e628e3fb851$var$operation_default.run("difference", geom, moreGeoms);
var $ef4a6e628e3fb851$export$c4b85a3b3361e135 = $ef4a6e628e3fb851$var$precision.set;

});
parcelRegister("5Kq8F", function(module, exports) {
(function(globalObject) {
    'use strict';
    /*
 *      bignumber.js v9.3.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = '[BigNumber Error] ', tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ', BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: '',
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ',',
            decimalSeparator: '.',
            fractionGroupSize: 0,
            fractionGroupSeparator: '\xA0',
            suffix: ''
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == 'number') && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, 'Base');
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == 'number') {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == '.') // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += '0');
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == 'object') {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = 'RANGE')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + ' cannot be zero: ' + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = 'CRYPTO')) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + 'crypto unavailable');
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + ' not true or false: ' + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = 'FORMAT')) {
                        v = obj[p];
                        if (typeof v == 'object') FORMAT = v;
                        else throw Error(bignumberError + p + ' not an object: ' + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = 'ALPHABET')) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + ' invalid: ' + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + 'Object expected: ' + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == '[object Array]') {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + 'Invalid BigNumber: ' + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + 'crypto unavailable');
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = '0123456789';
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace('.', '');
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // The index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, '0');
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += '0', len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne + (id === 2 && e > ne);
                    str = toFixedPoint(str, e, '0');
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += '.'; i--; str += '0');
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += '.';
                            for(; i--; str += '0');
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? '-' + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, '0');
            return n.s < 0 ? '-' + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + 'Exponent not an integer: ' + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times('1e' + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += '0';
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = '5e' + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf('e') + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + '');
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == '9999' || !rep && n == '4999') {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == 'object') {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == 'object') {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != 'object') throw Error(bignumberError + 'Argument not an object: ' + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
            }
            return (format.prefix || '') + str + (format.suffix || '');
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = 'Infinity';
                    if (s < 0) str = '-' + str;
                } else str = 'NaN';
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, '0');
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, '0');
                } else {
                    intCheck(b, 2, ALPHABET.length, 'Base');
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = '-' + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + '';
        for(; i < j;){
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for(; z--; s = '0' + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + '.'; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return BigNumber;
    });
    else if (module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != 'undefined' && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});

parcelRegister("bPBby", function(module, exports) {

$parcel$export(module.exports, "SplayTreeSet", () => $89d14d591dd759f8$export$67cc753ed1a46d8f);
// src/index.ts
var $89d14d591dd759f8$var$SplayTreeNode = class {
    key;
    left = null;
    right = null;
    constructor(key){
        this.key = key;
    }
};
var $89d14d591dd759f8$var$SplayTreeSetNode = class extends $89d14d591dd759f8$var$SplayTreeNode {
    constructor(key){
        super(key);
    }
};
var $89d14d591dd759f8$var$SplayTreeMapNode = class _SplayTreeMapNode extends $89d14d591dd759f8$var$SplayTreeNode {
    value;
    constructor(key, value){
        super(key);
        this.value = value;
    }
    replaceValue(value) {
        const node = new _SplayTreeMapNode(this.key, value);
        node.left = this.left;
        node.right = this.right;
        return node;
    }
};
var $89d14d591dd759f8$var$SplayTree = class {
    size = 0;
    modificationCount = 0;
    splayCount = 0;
    splay(key) {
        const root = this.root;
        if (root == null) {
            this.compare(key, key);
            return -1;
        }
        let right = null;
        let newTreeRight = null;
        let left = null;
        let newTreeLeft = null;
        let current = root;
        const compare = this.compare;
        let comp;
        while(true){
            comp = compare(current.key, key);
            if (comp > 0) {
                let currentLeft = current.left;
                if (currentLeft == null) break;
                comp = compare(currentLeft.key, key);
                if (comp > 0) {
                    current.left = currentLeft.right;
                    currentLeft.right = current;
                    current = currentLeft;
                    currentLeft = current.left;
                    if (currentLeft == null) break;
                }
                if (right == null) newTreeRight = current;
                else right.left = current;
                right = current;
                current = currentLeft;
            } else if (comp < 0) {
                let currentRight = current.right;
                if (currentRight == null) break;
                comp = compare(currentRight.key, key);
                if (comp < 0) {
                    current.right = currentRight.left;
                    currentRight.left = current;
                    current = currentRight;
                    currentRight = current.right;
                    if (currentRight == null) break;
                }
                if (left == null) newTreeLeft = current;
                else left.right = current;
                left = current;
                current = currentRight;
            } else break;
        }
        if (left != null) {
            left.right = current.left;
            current.left = newTreeLeft;
        }
        if (right != null) {
            right.left = current.right;
            current.right = newTreeRight;
        }
        if (this.root !== current) {
            this.root = current;
            this.splayCount++;
        }
        return comp;
    }
    splayMin(node) {
        let current = node;
        let nextLeft = current.left;
        while(nextLeft != null){
            const left = nextLeft;
            current.left = left.right;
            left.right = current;
            current = left;
            nextLeft = current.left;
        }
        return current;
    }
    splayMax(node) {
        let current = node;
        let nextRight = current.right;
        while(nextRight != null){
            const right = nextRight;
            current.right = right.left;
            right.left = current;
            current = right;
            nextRight = current.right;
        }
        return current;
    }
    _delete(key) {
        if (this.root == null) return null;
        const comp = this.splay(key);
        if (comp != 0) return null;
        let root = this.root;
        const result = root;
        const left = root.left;
        this.size--;
        if (left == null) this.root = root.right;
        else {
            const right = root.right;
            root = this.splayMax(left);
            root.right = right;
            this.root = root;
        }
        this.modificationCount++;
        return result;
    }
    addNewRoot(node, comp) {
        this.size++;
        this.modificationCount++;
        const root = this.root;
        if (root == null) {
            this.root = node;
            return;
        }
        if (comp < 0) {
            node.left = root;
            node.right = root.right;
            root.right = null;
        } else {
            node.right = root;
            node.left = root.left;
            root.left = null;
        }
        this.root = node;
    }
    _first() {
        const root = this.root;
        if (root == null) return null;
        this.root = this.splayMin(root);
        return this.root;
    }
    _last() {
        const root = this.root;
        if (root == null) return null;
        this.root = this.splayMax(root);
        return this.root;
    }
    clear() {
        this.root = null;
        this.size = 0;
        this.modificationCount++;
    }
    has(key) {
        return this.validKey(key) && this.splay(key) == 0;
    }
    defaultCompare() {
        return (a, b)=>a < b ? -1 : a > b ? 1 : 0;
    }
    wrap() {
        return {
            getRoot: ()=>{
                return this.root;
            },
            setRoot: (root)=>{
                this.root = root;
            },
            getSize: ()=>{
                return this.size;
            },
            getModificationCount: ()=>{
                return this.modificationCount;
            },
            getSplayCount: ()=>{
                return this.splayCount;
            },
            setSplayCount: (count)=>{
                this.splayCount = count;
            },
            splay: (key)=>{
                return this.splay(key);
            },
            has: (key)=>{
                return this.has(key);
            }
        };
    }
};
var $89d14d591dd759f8$export$63207fedc0254bf6 = class extends $89d14d591dd759f8$var$SplayTree {
    root = null;
    compare;
    validKey;
    constructor(compare, isValidKey){
        super();
        this.compare = compare ?? this.defaultCompare();
        this.validKey = isValidKey ?? ((a)=>a != null && a != void 0);
    }
    delete(key) {
        if (!this.validKey(key)) return false;
        return this._delete(key) != null;
    }
    forEach(f) {
        const nodes = new $89d14d591dd759f8$var$SplayTreeMapEntryIterableIterator(this.wrap());
        let result;
        while(result = nodes.next(), !result.done)f(result.value[1], result.value[0], this);
    }
    get(key) {
        if (!this.validKey(key)) return void 0;
        if (this.root != null) {
            const comp = this.splay(key);
            if (comp == 0) return this.root.value;
        }
        return void 0;
    }
    hasValue(value) {
        const initialSplayCount = this.splayCount;
        const visit = (node)=>{
            while(node != null){
                if (node.value == value) return true;
                if (initialSplayCount != this.splayCount) throw "Concurrent modification during iteration.";
                if (node.right != null && visit(node.right)) return true;
                node = node.left;
            }
            return false;
        };
        return visit(this.root);
    }
    set(key, value) {
        const comp = this.splay(key);
        if (comp == 0) {
            this.root = this.root.replaceValue(value);
            this.splayCount += 1;
            return this;
        }
        this.addNewRoot(new $89d14d591dd759f8$var$SplayTreeMapNode(key, value), comp);
        return this;
    }
    setAll(other) {
        other.forEach((value, key)=>{
            this.set(key, value);
        });
    }
    setIfAbsent(key, ifAbsent) {
        let comp = this.splay(key);
        if (comp == 0) return this.root.value;
        const modificationCount = this.modificationCount;
        const splayCount = this.splayCount;
        const value = ifAbsent();
        if (modificationCount != this.modificationCount) throw "Concurrent modification during iteration.";
        if (splayCount != this.splayCount) comp = this.splay(key);
        this.addNewRoot(new $89d14d591dd759f8$var$SplayTreeMapNode(key, value), comp);
        return value;
    }
    isEmpty() {
        return this.root == null;
    }
    isNotEmpty() {
        return !this.isEmpty();
    }
    firstKey() {
        if (this.root == null) return null;
        return this._first().key;
    }
    lastKey() {
        if (this.root == null) return null;
        return this._last().key;
    }
    lastKeyBefore(key) {
        if (key == null) throw "Invalid arguments(s)";
        if (this.root == null) return null;
        const comp = this.splay(key);
        if (comp < 0) return this.root.key;
        let node = this.root.left;
        if (node == null) return null;
        let nodeRight = node.right;
        while(nodeRight != null){
            node = nodeRight;
            nodeRight = node.right;
        }
        return node.key;
    }
    firstKeyAfter(key) {
        if (key == null) throw "Invalid arguments(s)";
        if (this.root == null) return null;
        const comp = this.splay(key);
        if (comp > 0) return this.root.key;
        let node = this.root.right;
        if (node == null) return null;
        let nodeLeft = node.left;
        while(nodeLeft != null){
            node = nodeLeft;
            nodeLeft = node.left;
        }
        return node.key;
    }
    update(key, update, ifAbsent) {
        let comp = this.splay(key);
        if (comp == 0) {
            const modificationCount = this.modificationCount;
            const splayCount = this.splayCount;
            const newValue = update(this.root.value);
            if (modificationCount != this.modificationCount) throw "Concurrent modification during iteration.";
            if (splayCount != this.splayCount) this.splay(key);
            this.root = this.root.replaceValue(newValue);
            this.splayCount += 1;
            return newValue;
        }
        if (ifAbsent != null) {
            const modificationCount = this.modificationCount;
            const splayCount = this.splayCount;
            const newValue = ifAbsent();
            if (modificationCount != this.modificationCount) throw "Concurrent modification during iteration.";
            if (splayCount != this.splayCount) comp = this.splay(key);
            this.addNewRoot(new $89d14d591dd759f8$var$SplayTreeMapNode(key, newValue), comp);
            return newValue;
        }
        throw "Invalid argument (key): Key not in map.";
    }
    updateAll(update) {
        const root = this.root;
        if (root == null) return;
        const iterator = new $89d14d591dd759f8$var$SplayTreeMapEntryIterableIterator(this.wrap());
        let node;
        while(node = iterator.next(), !node.done){
            const newValue = update(...node.value);
            iterator.replaceValue(newValue);
        }
    }
    keys() {
        return new $89d14d591dd759f8$var$SplayTreeKeyIterableIterator(this.wrap());
    }
    values() {
        return new $89d14d591dd759f8$var$SplayTreeValueIterableIterator(this.wrap());
    }
    entries() {
        return this[Symbol.iterator]();
    }
    [Symbol.iterator]() {
        return new $89d14d591dd759f8$var$SplayTreeMapEntryIterableIterator(this.wrap());
    }
    [Symbol.toStringTag] = "[object Map]";
};
var $89d14d591dd759f8$export$67cc753ed1a46d8f = class _SplayTreeSet extends $89d14d591dd759f8$var$SplayTree {
    root = null;
    compare;
    validKey;
    constructor(compare, isValidKey){
        super();
        this.compare = compare ?? this.defaultCompare();
        this.validKey = isValidKey ?? ((v)=>v != null && v != void 0);
    }
    delete(element) {
        if (!this.validKey(element)) return false;
        return this._delete(element) != null;
    }
    deleteAll(elements) {
        for (const element of elements)this.delete(element);
    }
    forEach(f) {
        const nodes = this[Symbol.iterator]();
        let result;
        while(result = nodes.next(), !result.done)f(result.value, result.value, this);
    }
    add(element) {
        const compare = this.splay(element);
        if (compare != 0) this.addNewRoot(new $89d14d591dd759f8$var$SplayTreeSetNode(element), compare);
        return this;
    }
    addAndReturn(element) {
        const compare = this.splay(element);
        if (compare != 0) this.addNewRoot(new $89d14d591dd759f8$var$SplayTreeSetNode(element), compare);
        return this.root.key;
    }
    addAll(elements) {
        for (const element of elements)this.add(element);
    }
    isEmpty() {
        return this.root == null;
    }
    isNotEmpty() {
        return this.root != null;
    }
    single() {
        if (this.size == 0) throw "Bad state: No element";
        if (this.size > 1) throw "Bad state: Too many element";
        return this.root.key;
    }
    first() {
        if (this.size == 0) throw "Bad state: No element";
        return this._first().key;
    }
    last() {
        if (this.size == 0) throw "Bad state: No element";
        return this._last().key;
    }
    lastBefore(element) {
        if (element == null) throw "Invalid arguments(s)";
        if (this.root == null) return null;
        const comp = this.splay(element);
        if (comp < 0) return this.root.key;
        let node = this.root.left;
        if (node == null) return null;
        let nodeRight = node.right;
        while(nodeRight != null){
            node = nodeRight;
            nodeRight = node.right;
        }
        return node.key;
    }
    firstAfter(element) {
        if (element == null) throw "Invalid arguments(s)";
        if (this.root == null) return null;
        const comp = this.splay(element);
        if (comp > 0) return this.root.key;
        let node = this.root.right;
        if (node == null) return null;
        let nodeLeft = node.left;
        while(nodeLeft != null){
            node = nodeLeft;
            nodeLeft = node.left;
        }
        return node.key;
    }
    retainAll(elements) {
        const retainSet = new _SplayTreeSet(this.compare, this.validKey);
        const modificationCount = this.modificationCount;
        for (const object of elements){
            if (modificationCount != this.modificationCount) throw "Concurrent modification during iteration.";
            if (this.validKey(object) && this.splay(object) == 0) retainSet.add(this.root.key);
        }
        if (retainSet.size != this.size) {
            this.root = retainSet.root;
            this.size = retainSet.size;
            this.modificationCount++;
        }
    }
    lookup(object) {
        if (!this.validKey(object)) return null;
        const comp = this.splay(object);
        if (comp != 0) return null;
        return this.root.key;
    }
    intersection(other) {
        const result = new _SplayTreeSet(this.compare, this.validKey);
        for (const element of this)if (other.has(element)) result.add(element);
        return result;
    }
    difference(other) {
        const result = new _SplayTreeSet(this.compare, this.validKey);
        for (const element of this)if (!other.has(element)) result.add(element);
        return result;
    }
    union(other) {
        const u = this.clone();
        u.addAll(other);
        return u;
    }
    clone() {
        const set = new _SplayTreeSet(this.compare, this.validKey);
        set.size = this.size;
        set.root = this.copyNode(this.root);
        return set;
    }
    copyNode(node) {
        if (node == null) return null;
        function copyChildren(node2, dest) {
            let left;
            let right;
            do {
                left = node2.left;
                right = node2.right;
                if (left != null) {
                    const newLeft = new $89d14d591dd759f8$var$SplayTreeSetNode(left.key);
                    dest.left = newLeft;
                    copyChildren(left, newLeft);
                }
                if (right != null) {
                    const newRight = new $89d14d591dd759f8$var$SplayTreeSetNode(right.key);
                    dest.right = newRight;
                    node2 = right;
                    dest = newRight;
                }
            }while (right != null);
        }
        const result = new $89d14d591dd759f8$var$SplayTreeSetNode(node.key);
        copyChildren(node, result);
        return result;
    }
    toSet() {
        return this.clone();
    }
    entries() {
        return new $89d14d591dd759f8$var$SplayTreeSetEntryIterableIterator(this.wrap());
    }
    keys() {
        return this[Symbol.iterator]();
    }
    values() {
        return this[Symbol.iterator]();
    }
    [Symbol.iterator]() {
        return new $89d14d591dd759f8$var$SplayTreeKeyIterableIterator(this.wrap());
    }
    [Symbol.toStringTag] = "[object Set]";
};
var $89d14d591dd759f8$var$SplayTreeIterableIterator = class {
    tree;
    path = new Array();
    modificationCount = null;
    splayCount;
    constructor(tree){
        this.tree = tree;
        this.splayCount = tree.getSplayCount();
    }
    [Symbol.iterator]() {
        return this;
    }
    next() {
        if (this.moveNext()) return {
            done: false,
            value: this.current()
        };
        return {
            done: true,
            value: null
        };
    }
    current() {
        if (!this.path.length) return null;
        const node = this.path[this.path.length - 1];
        return this.getValue(node);
    }
    rebuildPath(key) {
        this.path.splice(0, this.path.length);
        this.tree.splay(key);
        this.path.push(this.tree.getRoot());
        this.splayCount = this.tree.getSplayCount();
    }
    findLeftMostDescendent(node) {
        while(node != null){
            this.path.push(node);
            node = node.left;
        }
    }
    moveNext() {
        if (this.modificationCount != this.tree.getModificationCount()) {
            if (this.modificationCount == null) {
                this.modificationCount = this.tree.getModificationCount();
                let node2 = this.tree.getRoot();
                while(node2 != null){
                    this.path.push(node2);
                    node2 = node2.left;
                }
                return this.path.length > 0;
            }
            throw "Concurrent modification during iteration.";
        }
        if (!this.path.length) return false;
        if (this.splayCount != this.tree.getSplayCount()) this.rebuildPath(this.path[this.path.length - 1].key);
        let node = this.path[this.path.length - 1];
        let next = node.right;
        if (next != null) {
            while(next != null){
                this.path.push(next);
                next = next.left;
            }
            return true;
        }
        this.path.pop();
        while(this.path.length && this.path[this.path.length - 1].right === node)node = this.path.pop();
        return this.path.length > 0;
    }
};
var $89d14d591dd759f8$var$SplayTreeKeyIterableIterator = class extends $89d14d591dd759f8$var$SplayTreeIterableIterator {
    getValue(node) {
        return node.key;
    }
};
var $89d14d591dd759f8$var$SplayTreeSetEntryIterableIterator = class extends $89d14d591dd759f8$var$SplayTreeIterableIterator {
    getValue(node) {
        return [
            node.key,
            node.key
        ];
    }
};
var $89d14d591dd759f8$var$SplayTreeValueIterableIterator = class extends $89d14d591dd759f8$var$SplayTreeIterableIterator {
    constructor(map){
        super(map);
    }
    getValue(node) {
        return node.value;
    }
};
var $89d14d591dd759f8$var$SplayTreeMapEntryIterableIterator = class extends $89d14d591dd759f8$var$SplayTreeIterableIterator {
    constructor(map){
        super(map);
    }
    getValue(node) {
        return [
            node.key,
            node.value
        ];
    }
    replaceValue(value) {
        if (this.modificationCount != this.tree.getModificationCount()) throw "Concurrent modification during iteration.";
        if (this.splayCount != this.tree.getSplayCount()) this.rebuildPath(this.path[this.path.length - 1].key);
        const last = this.path.pop();
        const newLast = last.replaceValue(value);
        if (!this.path.length) this.tree.setRoot(newLast);
        else {
            const parent = this.path[this.path.length - 1];
            if (last === parent.left) parent.left = newLast;
            else parent.right = newLast;
        }
        this.path.push(newLast);
        const count = this.tree.getSplayCount() + 1;
        this.tree.setSplayCount(count);
        this.splayCount = count;
    }
};

});





parcelRegister("aDzfS", function(module, exports) {

$parcel$export(module.exports, "validateArrivalStagingDwell", () => $ca50beedde6641c6$export$d3ee0f954cf69808);
$parcel$export(module.exports, "validateDepartureStagingDwell", () => $ca50beedde6641c6$export$ee40f17fff659da6);
$parcel$export(module.exports, "validateQuickTurnThreshold", () => $ca50beedde6641c6$export$8fd3f0083de00fac);
$parcel$export(module.exports, "useParkingConfig", () => $ca50beedde6641c6$export$a83f4655ee29c6c1);

var $acw62 = parcelRequire("acw62");

var $h3XF9 = parcelRequire("h3XF9");
function $ca50beedde6641c6$export$d3ee0f954cf69808(value) {
    if (value < (0, $h3XF9.MIN_ARRIVAL_STAGING_MINUTES)) return {
        isValid: false,
        message: `Arrival staging must be at least ${0, $h3XF9.MIN_ARRIVAL_STAGING_MINUTES} minutes`
    };
    if (value > (0, $h3XF9.MAX_ARRIVAL_STAGING_MINUTES)) return {
        isValid: false,
        message: `Arrival staging cannot exceed ${0, $h3XF9.MAX_ARRIVAL_STAGING_MINUTES} minutes`
    };
    return {
        isValid: true
    };
}
function $ca50beedde6641c6$export$ee40f17fff659da6(value) {
    if (value < (0, $h3XF9.MIN_DEPARTURE_STAGING_MINUTES)) return {
        isValid: false,
        message: `Departure staging must be at least ${0, $h3XF9.MIN_DEPARTURE_STAGING_MINUTES} minutes`
    };
    if (value > (0, $h3XF9.MAX_DEPARTURE_STAGING_MINUTES)) return {
        isValid: false,
        message: `Departure staging cannot exceed ${0, $h3XF9.MAX_DEPARTURE_STAGING_MINUTES} minutes`
    };
    return {
        isValid: true
    };
}
function $ca50beedde6641c6$export$8fd3f0083de00fac(value) {
    if (value < (0, $h3XF9.MIN_QUICK_TURN_THRESHOLD_MINUTES)) return {
        isValid: false,
        message: `Quick turn threshold must be at least ${0, $h3XF9.MIN_QUICK_TURN_THRESHOLD_MINUTES} minutes`
    };
    if (value > (0, $h3XF9.MAX_QUICK_TURN_THRESHOLD_MINUTES)) return {
        isValid: false,
        message: `Quick turn threshold cannot exceed ${0, $h3XF9.MAX_QUICK_TURN_THRESHOLD_MINUTES} minutes`
    };
    return {
        isValid: true
    };
}
function $ca50beedde6641c6$export$ed913fb9fb831720(arrivalDwell, departureDwell, quickTurnThreshold) {
    const arrivalResult = $ca50beedde6641c6$export$d3ee0f954cf69808(arrivalDwell);
    if (!arrivalResult.isValid) return arrivalResult;
    const departureResult = $ca50beedde6641c6$export$ee40f17fff659da6(departureDwell);
    if (!departureResult.isValid) return departureResult;
    const thresholdResult = $ca50beedde6641c6$export$8fd3f0083de00fac(quickTurnThreshold);
    if (!thresholdResult.isValid) return thresholdResult;
    return {
        isValid: true
    };
}
function $ca50beedde6641c6$export$a83f4655ee29c6c1(defaults) {
    const [bufferMinutes, setBufferMinutes] = (0, $acw62.useState)(defaults?.bufferMinutes ?? 15);
    const [plannedMoveCap, setPlannedMoveCap] = (0, $acw62.useState)(defaults?.plannedMoveCap ?? 0);
    const [allowTrapping, setAllowTrapping] = (0, $acw62.useState)(defaults?.allowTrapping ?? true);
    const [egressWeight, setEgressWeight] = (0, $acw62.useState)(defaults?.egressWeight ?? 1.0);
    const [wasteWeight, setWasteWeight] = (0, $acw62.useState)(defaults?.wasteWeight ?? 1.0);
    const [structuralWeight, setStructuralWeight] = (0, $acw62.useState)(defaults?.structuralWeight ?? 0.1);
    const [zonePriorityWeight, setZonePriorityWeight] = (0, $acw62.useState)(defaults?.zonePriorityWeight ?? 1.0);
    const [min_dwell_weight, setMinDwellWeight] = (0, $acw62.useState)(defaults?.min_dwell_weight ?? 2.0);
    const [sortingStrategy, setSortingStrategy] = (0, $acw62.useState)(defaults?.sortingStrategy ?? "size-constrained");
    const [arrivalStagingDwellMinutes, setArrivalStagingDwellMinutes] = (0, $acw62.useState)(defaults?.arrivalStagingDwellMinutes ?? (defaults?.enableArrivalStaging ? (0, $h3XF9.DEFAULT_ARRIVAL_STAGING_DWELL_MINUTES) : 0));
    const [departureStagingDwellMinutes, setDepartureStagingDwellMinutes] = (0, $acw62.useState)(defaults?.departureStagingDwellMinutes ?? (defaults?.enableDepartureStaging ? (0, $h3XF9.DEFAULT_DEPARTURE_STAGING_DWELL_MINUTES) : 0));
    const [quickTurnThresholdMinutes, setQuickTurnThresholdMinutes] = (0, $acw62.useState)(defaults?.quickTurnThresholdMinutes ?? (0, $h3XF9.DEFAULT_QUICK_TURN_THRESHOLD_MINUTES));
    const config = (0, $acw62.useMemo)(()=>({
            bufferMinutes: bufferMinutes,
            plannedMoveCap: plannedMoveCap,
            allowTrapping: allowTrapping,
            egressWeight: egressWeight,
            wasteWeight: wasteWeight,
            structuralWeight: structuralWeight,
            zonePriorityWeight: zonePriorityWeight,
            min_dwell_weight: min_dwell_weight,
            sortingStrategy: sortingStrategy,
            enableArrivalStaging: arrivalStagingDwellMinutes > 0,
            enableDepartureStaging: departureStagingDwellMinutes > 0,
            arrivalStagingDwellMinutes: arrivalStagingDwellMinutes,
            departureStagingDwellMinutes: departureStagingDwellMinutes,
            quickTurnThresholdMinutes: quickTurnThresholdMinutes
        }), [
        bufferMinutes,
        plannedMoveCap,
        allowTrapping,
        egressWeight,
        wasteWeight,
        structuralWeight,
        zonePriorityWeight,
        min_dwell_weight,
        sortingStrategy,
        arrivalStagingDwellMinutes,
        departureStagingDwellMinutes,
        quickTurnThresholdMinutes
    ]);
    return {
        config: config,
        setBufferMinutes: (0, $acw62.useCallback)(setBufferMinutes, []),
        setPlannedMoveCap: (0, $acw62.useCallback)(setPlannedMoveCap, []),
        setAllowTrapping: (0, $acw62.useCallback)(setAllowTrapping, []),
        setEgressWeight: (0, $acw62.useCallback)(setEgressWeight, []),
        setWasteWeight: (0, $acw62.useCallback)(setWasteWeight, []),
        setStructuralWeight: (0, $acw62.useCallback)(setStructuralWeight, []),
        setZonePriorityWeight: (0, $acw62.useCallback)(setZonePriorityWeight, []),
        setMinDwellWeight: (0, $acw62.useCallback)(setMinDwellWeight, []),
        setSortingStrategy: (0, $acw62.useCallback)(setSortingStrategy, []),
        setArrivalStagingDwellMinutes: (0, $acw62.useCallback)(setArrivalStagingDwellMinutes, []),
        setDepartureStagingDwellMinutes: (0, $acw62.useCallback)(setDepartureStagingDwellMinutes, []),
        setQuickTurnThresholdMinutes: (0, $acw62.useCallback)(setQuickTurnThresholdMinutes, [])
    };
}

});
parcelRegister("h3XF9", function(module, exports) {

$parcel$export(module.exports, "MINUTES_PER_BUCKET", () => $2564b090039577bb$export$dae5792ea1644531);
$parcel$export(module.exports, "DEFAULT_QUICK_TURN_THRESHOLD_MINUTES", () => $2564b090039577bb$export$82dc1fc830bd8826);
$parcel$export(module.exports, "DEFAULT_ARRIVAL_STAGING_DWELL_MINUTES", () => $2564b090039577bb$export$8fd676e67c884557);
$parcel$export(module.exports, "DEFAULT_DEPARTURE_STAGING_DWELL_MINUTES", () => $2564b090039577bb$export$401f3186b039b1f8);
$parcel$export(module.exports, "MIN_ARRIVAL_STAGING_MINUTES", () => $2564b090039577bb$export$e930cf10388c6718);
$parcel$export(module.exports, "MAX_ARRIVAL_STAGING_MINUTES", () => $2564b090039577bb$export$ccb8e90208de37dc);
$parcel$export(module.exports, "MIN_DEPARTURE_STAGING_MINUTES", () => $2564b090039577bb$export$39e6a0effaea72a8);
$parcel$export(module.exports, "MAX_DEPARTURE_STAGING_MINUTES", () => $2564b090039577bb$export$b39ae6b6b2c5a3f8);
$parcel$export(module.exports, "MIN_QUICK_TURN_THRESHOLD_MINUTES", () => $2564b090039577bb$export$7799fb2222bcda5f);
$parcel$export(module.exports, "MAX_QUICK_TURN_THRESHOLD_MINUTES", () => $2564b090039577bb$export$b864c10338b1310b);
/**
 * Temporal Parking Types - Step 0+1 Implementation
 * Based on plans/ramp-temporal-parking.md
 */ const $2564b090039577bb$export$dae5792ea1644531 = 15;
const $2564b090039577bb$export$89ed1553b4aa6f2e = 4;
const $2564b090039577bb$export$82dc1fc830bd8826 = 120;
const $2564b090039577bb$export$8fd676e67c884557 = 60;
const $2564b090039577bb$export$401f3186b039b1f8 = 30;
const $2564b090039577bb$export$e930cf10388c6718 = 15;
const $2564b090039577bb$export$ccb8e90208de37dc = 180;
const $2564b090039577bb$export$39e6a0effaea72a8 = 15;
const $2564b090039577bb$export$b39ae6b6b2c5a3f8 = 120;
const $2564b090039577bb$export$7799fb2222bcda5f = 30;
const $2564b090039577bb$export$b864c10338b1310b = 360;

});


parcelRegister("3kHDf", function(module, exports) {

$parcel$export(module.exports, "getDecisionLog", () => $6376581398fa7741$export$b617c04531473ed5);
$parcel$export(module.exports, "parkingAlgorithm", () => $6376581398fa7741$export$c0902b24f2934d89);
/**
 * Dummy Placement Algorithm - Simplified Greedy First-Fit with Segmentation
 * For testing temporal parking without the full spatial solver
 */ 
var $elGuA = parcelRequire("elGuA");

var $7O8dW = parcelRequire("7O8dW");

var $ad1qL = parcelRequire("ad1qL");

var $77E3s = parcelRequire("77E3s");

var $8mB0X = parcelRequire("8mB0X");

var $hddnH = parcelRequire("hddnH");

var $esyom = parcelRequire("esyom");

var $6moNe = parcelRequire("6moNe");

var $kbn5z = parcelRequire("kbn5z");

var $3qqrt = parcelRequire("3qqrt");

var $h3XF9 = parcelRequire("h3XF9");

var $846sO = parcelRequire("846sO");

var $3MLDv = parcelRequire("3MLDv");

var $8L6tD = parcelRequire("8L6tD");
// Global decision log (reset on each algorithm run)
let $6376581398fa7741$var$decisionLog = [];
// Tagged logger for staging-related operations
const $6376581398fa7741$var$stagingLogger = (0, $3MLDv.createTaggedLogger)('STAGING');
function $6376581398fa7741$export$b617c04531473ed5() {
    return $6376581398fa7741$var$decisionLog;
}
function $6376581398fa7741$var$logEntry(entry) {
    $6376581398fa7741$var$decisionLog.push(entry);
}
/**
 * Generate actionable suggestions based on filter breakdown
 * Identifies the primary blocker and provides specific recommendations
 *
 * @param breakdown - Filter breakdown showing elimination counts
 * @param aircraft - Aircraft that couldn't be placed
 * @returns Suggestion string with actionable advice
 */ function $6376581398fa7741$var$generateFilterSuggestion(breakdown, aircraft) {
    // Find the filter that eliminated the most spots
    const filters = [
        {
            name: "disabled",
            count: breakdown.disabled,
            suggestion: "Enable more spots or zones that are currently disabled"
        },
        {
            name: "sizeIncompatible",
            count: breakdown.sizeIncompatible,
            suggestion: `Add more spots that allow ${aircraft.sizeCategory} aircraft, or use smaller aircraft`
        },
        {
            name: "timeConflict",
            count: breakdown.timeConflict,
            suggestion: "Reduce scheduling conflicts by adjusting arrival/departure times or adding more spots"
        },
        {
            name: "durationExceeded",
            count: breakdown.durationExceeded,
            suggestion: "Increase max_dwell_minutes limits on overflow spots or shorten aircraft stay"
        },
        {
            name: "geometryCollision",
            count: breakdown.geometryCollision,
            suggestion: "Move blocking aircraft to free up gap spots"
        }
    ];
    // Sort by count descending to find primary blocker
    filters.sort((a, b)=>b.count - a.count);
    const primaryBlocker = filters[0];
    if (primaryBlocker.count === 0) return "No spots configured for this ramp";
    return primaryBlocker.suggestion;
}
/**
 * Identify "near miss" spots that passed most filters but failed on exactly one
 * Inspired by Gurobi's IIS (Irreducible Inconsistent Subsystem) concept
 * These represent the easiest opportunities for placement
 *
 * @param spots - All spots to analyze
 * @param aircraft - Aircraft that couldn't be placed
 * @param dwellMask - Time mask for aircraft dwell
 * @param placement - Current placement state
 * @param placedAircraftPolygons - Polygon map for geometry checking
 * @param shapes - Shapes for geometry checking
 * @param zones - All zones on the ramp
 * @returns List of near-miss spots with failure details
 */ function $6376581398fa7741$var$findNearMissSpots(spots, aircraft, dwellMask, placement, placedAircraftPolygons, // shapes parameter REMOVED - use spot.shape instead
zones = []) {
    const nearMisses = [];
    for (const spot of spots){
        const passedFilters = [];
        let failedFilter = null;
        let specificIssue = "";
        let easyFix;
        // Check each filter in order
        const enabled = (0, $6moNe.isSpotEnabled)(spot, zones);
        if (enabled) passedFilters.push("enabled");
        else if (failedFilter === null) {
            failedFilter = "disabled";
            const zone = zones.find((z)=>z.id === spot.zoneId);
            if (spot.disabled) {
                specificIssue = `Spot ${spot.id} is disabled`;
                easyFix = `Enable spot ${spot.id}`;
            } else if (zone?.disabled) {
                specificIssue = `Zone ${zone.name} is disabled`;
                easyFix = `Enable zone ${zone.name}`;
            }
        }
        const sizeOk = (0, $6moNe.isSizeCompatible)(spot, aircraft);
        if (sizeOk) passedFilters.push("size");
        else if (failedFilter === null) {
            failedFilter = "size";
            specificIssue = `Spot allows ${spot.allowedSizes.join(", ")} but aircraft is ${aircraft.sizeCategory}`;
            easyFix = `Change spot ${spot.id} to allow ${aircraft.sizeCategory} aircraft`;
        }
        const timeOk = (0, $6moNe.isTimeAvailable)(spot, dwellMask);
        if (timeOk) passedFilters.push("time");
        else if (failedFilter === null) {
            failedFilter = "time";
            const formatBucket = (bucket)=>{
                const hours = Math.floor(bucket / 4);
                const mins = bucket % 4 * 15;
                return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
            };
            specificIssue = `Spot occupied during ${formatBucket(aircraft.arrivalBucket)}-${formatBucket(aircraft.departureBucket)}`;
            easyFix = `Shift arrival/departure to avoid conflict`;
        }
        const durationOk = (0, $6moNe.isDurationValid)(spot, aircraft);
        if (durationOk) passedFilters.push("duration");
        else if (failedFilter === null) {
            failedFilter = "duration";
            const dwellMinutes = (aircraft.departureBucket - aircraft.arrivalBucket) * 15;
            specificIssue = `Needs ${dwellMinutes} min, limit: ${spot.max_dwell_minutes} min`;
            easyFix = `Increase max_dwell_minutes to ${dwellMinutes} minutes`;
        }
        const geometryOk = !(0, $6moNe.hasGeometryCollision)(spot, aircraft, placement, placedAircraftPolygons);
        if (geometryOk) passedFilters.push("geometry");
        else if (failedFilter === null) {
            failedFilter = "geometry";
            specificIssue = `Gap spot blocked by aircraft geometry`;
            easyFix = `Reposition blocking aircraft`;
        }
        // Only include spots that passed at least 3 filters (failed on 1 or 2)
        // These are the "closest" to working
        if (passedFilters.length >= 3 && failedFilter !== null) nearMisses.push({
            spotId: spot.id,
            failedFilter: failedFilter,
            passedFilters: passedFilters,
            specificIssue: specificIssue,
            easyFix: easyFix
        });
    }
    // Sort by number of passed filters (descending) - closest to working first
    nearMisses.sort((a, b)=>b.passedFilters.length - a.passedFilters.length);
    // Return top 3 near-misses
    return nearMisses.slice(0, 3);
}
/**
 * Generate enhanced actionable suggestions with numeric analysis
 * Inspired by best practices from Rust compiler, Kubernetes, PostgreSQL, and Gurobi
 *
 * @param breakdown - Filter breakdown showing elimination counts
 * @param aircraft - Aircraft that couldn't be placed
 * @param spots - All spots on the ramp
 * @param zones - All zones on the ramp
 * @param dwellMask - Time mask for near-miss analysis
 * @param placement - Current placement for near-miss analysis
 * @param placedAircraftPolygons - Polygons for near-miss analysis
 * @param shapes - Shapes for near-miss analysis
 * @returns Detailed suggestion with analysis and actionable recommendations
 */ function $6376581398fa7741$var$generateEnhancedSuggestions(breakdown, aircraft, spots, zones = [], dwellMask, placement, placedAircraftPolygons) {
    const suggestions = [];
    // Determine primary blocker
    const filters = [
        {
            name: "disabled",
            count: breakdown.disabled
        },
        {
            name: "size",
            count: breakdown.sizeIncompatible
        },
        {
            name: "time",
            count: breakdown.timeConflict
        },
        {
            name: "duration",
            count: breakdown.durationExceeded
        },
        {
            name: "geometry",
            count: breakdown.geometryCollision
        }
    ];
    filters.sort((a, b)=>b.count - a.count);
    const primaryBlocker = filters[0].count > 0 ? filters[0].name : "none";
    // Size Analysis (Phase 1: Numeric Specificity)
    let sizeAnalysis;
    if (breakdown.sizeIncompatible > 0) {
        const spotsBySize = {
            "very-small": 0,
            small: 0,
            midsize: 0,
            "super-midsize": 0,
            large: 0,
            enormous: 0
        };
        // Count spots by their maximum allowed size
        spots.forEach((spot)=>{
            const maxSize = spot.allowedSizes[spot.allowedSizes.length - 1];
            if (maxSize) spotsBySize[maxSize]++;
        });
        // Count current spots that can fit this aircraft
        const currentAvailable = spots.filter((spot)=>spot.allowedSizes.includes(aircraft.sizeCategory)).length;
        sizeAnalysis = {
            aircraftSize: aircraft.sizeCategory,
            aircraftWingspan: aircraft.aircraft?.wingspan,
            aircraftLength: aircraft.aircraft?.length,
            spotsBySize: spotsBySize,
            minimumNeeded: 1,
            currentAvailable: currentAvailable
        };
        // Generate size-based suggestions (infrastructure/configuration only)
        const sizePriority = primaryBlocker === "size" ? 1 : 2;
        // Suggest adding spots of the right size
        suggestions.push({
            priority: sizePriority,
            category: "size",
            title: `Add ${aircraft.sizeCategory} spots to ramp`,
            description: `Only ${currentAvailable} of ${breakdown.total} spots accommodate ${aircraft.sizeCategory} aircraft`,
            impact: undefined,
            // Can't predict how many you'll add
            specificAction: `Add spots that allow ${aircraft.sizeCategory} aircraft`
        });
        // Suggest reconfiguring existing spots to allow this size
        suggestions.push({
            priority: sizePriority + 1,
            category: "size",
            title: `Reconfigure spots to allow ${aircraft.sizeCategory}`,
            description: `${breakdown.sizeIncompatible} spots currently exclude ${aircraft.sizeCategory} aircraft`,
            impact: `Up to +${breakdown.sizeIncompatible} spots`,
            specificAction: `Update spot size policies to include ${aircraft.sizeCategory}`
        });
    }
    // Time Analysis (Phase 2: Temporal Analysis)
    let timeAnalysis;
    if (breakdown.timeConflict > 0) {
        const dwellDurationBuckets = aircraft.departureBucket - aircraft.arrivalBucket;
        const dwellDurationMinutes = dwellDurationBuckets * 15;
        // Analyze when congestion peaks by checking occupancy across all size-compatible spots
        // This helps identify the specific time window causing conflicts
        let peakCongestionStart;
        let peakCongestionEnd;
        let peakOccupiedSpots;
        const sizeCompatibleSpots = spots.filter((spot)=>spot.allowedSizes.includes(aircraft.sizeCategory));
        if (sizeCompatibleSpots.length > 0) {
            // Count how many spots are occupied at each bucket during aircraft's dwell
            const occupancyByBucket = [];
            for(let bucket = aircraft.arrivalBucket; bucket < aircraft.departureBucket; bucket++){
                let occupiedCount = 0;
                for (const spot of sizeCompatibleSpots){
                    // Check if this bucket is set in the spot's occupancy bitmap
                    const wordIndex = Math.floor(bucket / 64);
                    const bitIndex = bucket % 64;
                    if (spot.occupancy[wordIndex] & BigInt(1) << BigInt(bitIndex)) occupiedCount++;
                }
                occupancyByBucket.push(occupiedCount);
            }
            // Find the peak congestion period (consecutive buckets with highest occupancy)
            peakOccupiedSpots = Math.max(...occupancyByBucket);
            if (peakOccupiedSpots > 0) {
                // Find first occurrence of peak
                const peakIndex = occupancyByBucket.indexOf(peakOccupiedSpots);
                peakCongestionStart = aircraft.arrivalBucket + peakIndex;
                // Find end of peak period (last consecutive bucket with peak occupancy)
                let endIndex = peakIndex;
                while(endIndex < occupancyByBucket.length && occupancyByBucket[endIndex] >= peakOccupiedSpots * 0.8 // Within 80% of peak
                )endIndex++;
                peakCongestionEnd = aircraft.arrivalBucket + endIndex;
            }
        }
        const conflictWindowBuckets = peakCongestionStart !== undefined && peakCongestionEnd !== undefined ? peakCongestionEnd - peakCongestionStart : undefined;
        timeAnalysis = {
            aircraftArrivalBucket: aircraft.arrivalBucket,
            aircraftDepartureBucket: aircraft.departureBucket,
            dwellDurationBuckets: dwellDurationBuckets,
            dwellDurationMinutes: dwellDurationMinutes,
            peakCongestionStart: peakCongestionStart,
            peakCongestionEnd: peakCongestionEnd,
            peakOccupiedSpots: peakOccupiedSpots,
            conflictWindowBuckets: conflictWindowBuckets
        };
        // Generate time-based suggestions (prioritize infrastructure over coordination)
        const timePriority = primaryBlocker === "time" ? 1 : 3;
        // Suggestion 1: Add capacity (infrastructure - direct control)
        suggestions.push({
            priority: timePriority,
            category: "time",
            title: "Add more spots to handle peak demand",
            description: `${breakdown.timeConflict} of ${breakdown.total} spots have scheduling conflicts`,
            impact: undefined,
            // Can't predict capacity additions
            specificAction: `Add spots to accommodate concurrent aircraft during peak periods`
        });
        // Suggestion 2: Coordinate timing (requires customer agreement - lower priority)
        if (peakCongestionStart !== undefined && peakCongestionEnd !== undefined && conflictWindowBuckets !== undefined) {
            const formatBucket = (bucket)=>{
                const hours = Math.floor(bucket / 4);
                const mins = bucket % 4 * 15;
                return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
            };
            const delayMinutes = (peakCongestionEnd - aircraft.arrivalBucket) * 15;
            suggestions.push({
                priority: timePriority + 1,
                category: "time",
                title: `Coordinate ${delayMinutes}-min delay (if customer agrees)`,
                description: `Peak congestion ${formatBucket(peakCongestionStart)}-${formatBucket(peakCongestionEnd)} blocks ${peakOccupiedSpots} of ${sizeCompatibleSpots.length} spots`,
                impact: "May reduce conflicts",
                specificAction: `Coordinate with customer to shift arrival from ${formatBucket(aircraft.arrivalBucket)} to ${formatBucket(peakCongestionEnd)}`
            });
        } else // Fallback if peak analysis fails
        suggestions.push({
            priority: timePriority + 1,
            category: "time",
            title: "Coordinate schedule adjustment (if customer agrees)",
            description: `${breakdown.timeConflict} spots have scheduling conflicts`,
            impact: "May reduce conflicts",
            specificAction: "Work with customer to adjust arrival/departure times"
        });
    }
    // Duration Analysis (Phase 1)
    let durationAnalysis;
    if (breakdown.durationExceeded > 0) {
        const requiredDwellMinutes = (aircraft.departureBucket - aircraft.arrivalBucket) * 15;
        const spotsWithLimits = spots.filter((s)=>s.max_dwell_minutes !== undefined).length;
        const limitsValues = spots.filter((s)=>s.max_dwell_minutes !== undefined).map((s)=>s.max_dwell_minutes);
        const mostRestrictiveLimit = limitsValues.length > 0 ? Math.min(...limitsValues) : undefined;
        const excessDuration = mostRestrictiveLimit ? requiredDwellMinutes - mostRestrictiveLimit : undefined;
        durationAnalysis = {
            requiredDwellMinutes: requiredDwellMinutes,
            spotsWithLimits: spotsWithLimits,
            mostRestrictiveLimit: mostRestrictiveLimit,
            excessDuration: excessDuration
        };
        // Generate duration-based suggestions (configuration control)
        const durationPriority = primaryBlocker === "duration" ? 1 : 4;
        if (mostRestrictiveLimit !== undefined && excessDuration !== undefined) // Suggestion: Extend limits (direct control)
        suggestions.push({
            priority: durationPriority,
            category: "duration",
            title: `Extend max dwell limits to ${requiredDwellMinutes} min`,
            description: `Aircraft needs ${requiredDwellMinutes} min but overflow spots limited to ${mostRestrictiveLimit} min`,
            impact: `+${breakdown.durationExceeded} spots available`,
            specificAction: `Increase max_dwell_minutes from ${mostRestrictiveLimit} to ${requiredDwellMinutes} minutes`
        });
    }
    // Disabled spots analysis (configuration - high priority, immediate impact)
    if (breakdown.disabled > 0) {
        // Highest priority for disabled spots since it's easy and immediate
        const disabledPriority = primaryBlocker === "disabled" ? 1 : 2;
        suggestions.push({
            priority: disabledPriority,
            category: "disabled",
            title: "Enable disabled spots/zones",
            description: `${breakdown.disabled} spots currently disabled (maintenance/construction)`,
            impact: `+${breakdown.disabled} spots`,
            specificAction: "Re-enable spots/zones in ramp configuration"
        });
    }
    // Geometry collision analysis (operational - requires aircraft movement)
    if (breakdown.geometryCollision > 0) {
        const geometryPriority = primaryBlocker === "geometry" ? 1 : 5;
        suggestions.push({
            priority: geometryPriority,
            category: "geometry",
            title: "Reposition aircraft to free gap spots",
            description: `${breakdown.geometryCollision} gap spots blocked by aircraft geometry`,
            impact: `+${breakdown.geometryCollision} spots`,
            specificAction: "Move aircraft in required spots to eliminate geometry collision"
        });
    }
    // Sort suggestions by priority
    suggestions.sort((a, b)=>a.priority - b.priority);
    // Phase 4: Find near-miss spots (spots that almost worked)
    let nearMisses;
    if (dwellMask && placement) {
        nearMisses = $6376581398fa7741$var$findNearMissSpots(spots, aircraft, dwellMask, placement, placedAircraftPolygons, // shapes parameter removed
        zones);
        // Only include if we found any near-misses
        if (nearMisses.length === 0) nearMisses = undefined;
    }
    return {
        primaryBlocker: primaryBlocker,
        sizeAnalysis: sizeAnalysis,
        timeAnalysis: timeAnalysis,
        durationAnalysis: durationAnalysis,
        nearMisses: nearMisses,
        suggestions: suggestions
    };
}
/**
 * Check gap spot status and return detailed information
 * Used for decision log entries to explain gap spot availability
 *
 * @param spot - The gap spot to check
 * @param currentPlacement - Current placement state
 * @param placedAircraftPolygons - Map of aircraft footprints (Phase 3)
 * @returns Gap spot status information
 */ function $6376581398fa7741$var$getGapSpotStatus(spot, currentPlacement, placedAircraftPolygons) {
    if (!spot.isGapSpot) return {
        available: true,
        dependenciesMet: 0,
        dependenciesTotal: 0,
        collision: false,
        reason: "Not a gap spot"
    };
    const requiredSpots = spot.requiresOccupiedSpots || [];
    const dependenciesTotal = requiredSpots.length;
    // Count how many required spots are occupied
    const dependenciesMet = requiredSpots.filter((requiredSpotId)=>{
        return Object.values(currentPlacement).some((placementData)=>{
            if ("spotId" in placementData) return placementData.spotId === requiredSpotId;
            return false;
        });
    }).length;
    // Check if all dependencies are met
    const allDependenciesMet = dependenciesMet === dependenciesTotal;
    if (!allDependenciesMet) return {
        available: false,
        dependenciesMet: dependenciesMet,
        dependenciesTotal: dependenciesTotal,
        collision: false,
        reason: `Gap spot requires ${requiredSpots.join(", ")} to be occupied (${dependenciesMet}/${dependenciesTotal} occupied)`
    };
    // Dependencies are met - check for geometry collision (Phase 3)
    // Dummy aircraft for collision check (not used in current implementation)
    const collision = (0, $6moNe.hasGeometryCollision)(spot, {}, currentPlacement, placedAircraftPolygons);
    if (collision) return {
        available: false,
        dependenciesMet: dependenciesMet,
        dependenciesTotal: dependenciesTotal,
        collision: true,
        reason: `Gap spot blocked by geometry collision with aircraft in required spots`
    };
    return {
        available: true,
        dependenciesMet: dependenciesMet,
        dependenciesTotal: dependenciesTotal,
        collision: false,
        reason: `Gap spot available (${requiredSpots.join(", ")} occupied, no collision)`
    };
}
/**
 * Generate detailed blocking information for decision logging
 * Shows which spots are blocked and whether they result in traps
 *
 * @param candidateAircraft - Aircraft being considered for placement
 * @param blockedSpotIds - Spot IDs blocked by the chosen lane
 * @param placement - Current placement state
 * @param allAircraft - All aircraft in the scenario
 * @returns Array of blocking details for each blocked spot
 */ function $6376581398fa7741$var$generateBlockingDetails(candidateAircraft, blockedSpotIds, placement, allAircraft) {
    return blockedSpotIds.map((spotId)=>{
        // Find if this spot is occupied
        const occupiedEntry = Object.entries(placement).find(([_, placementInfo])=>{
            if ("segments" in placementInfo) return placementInfo.segments[0].spotId === spotId;
            return placementInfo.spotId === spotId;
        });
        if (!occupiedEntry) return {
            spotId: spotId,
            isTrapped: false,
            reason: "Empty (no aircraft)"
        };
        const [occupiedAircraftId, _] = occupiedEntry;
        const occupiedAircraft = allAircraft.find((a)=>a.id === occupiedAircraftId);
        if (!occupiedAircraft) return {
            spotId: spotId,
            isTrapped: false,
            reason: "Empty (no aircraft)"
        };
        // Check if candidate would trap the occupied aircraft
        const candidateDeparture = candidateAircraft.departureBucket;
        const occupiedDeparture = occupiedAircraft.departureBucket;
        const isTrapped = candidateDeparture > occupiedDeparture;
        // Format departure times as HH:MM
        const formatBucket = (bucket)=>{
            const hours = Math.floor(bucket / 4);
            const mins = bucket % 4 * 15;
            return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
        };
        const aircraftName = (0, $846sO.getAircraftDisplayName)(occupiedAircraft);
        const reason = isTrapped ? `\u{26A0}\u{FE0F} Traps ${aircraftName} (departs ${formatBucket(candidateDeparture)} > ${formatBucket(occupiedDeparture)})` : `\u{23F1}\u{FE0F} No trap (departs ${formatBucket(candidateDeparture)} < ${formatBucket(occupiedDeparture)})`;
        return {
            spotId: spotId,
            occupiedBy: aircraftName,
            isTrapped: isTrapped,
            reason: reason
        };
    });
}
function $6376581398fa7741$export$c0902b24f2934d89(requests, spots, bufferMinutes = 0, plannedMoveCap = 0, allowTrapping = true, egressWeight = 1.0, wasteWeight = 1.0, structuralWeight = 0.1, sortingStrategy = "arrival", horizonHours = 24, useMaskOptimization = false, validateMasks = false, zonePriorityWeight = 1.0, zones = [], min_dwell_weight = 2.0, stickinessWeight = 0.0, enableArrivalStaging = false, enableDepartureStaging = false, arrivalStagingDwellMinutes = 60, departureStagingDwellMinutes = 30, quickTurnThresholdMinutes = 120) {
    // Reset decision log at start
    $6376581398fa7741$var$decisionLog = [];
    const placement = {};
    // Staging Area Validation: Check if staging is configured correctly
    let effectiveEnableArrival = enableArrivalStaging;
    let effectiveEnableDeparture = enableDepartureStaging;
    let effectivePlannedMoveCap = plannedMoveCap;
    const anyStaging = enableArrivalStaging || enableDepartureStaging;
    if (anyStaging) {
        const stagingSpots = spots.filter((s)=>(0, $kbn5z.isSpotInStagingZone)(s));
        if (stagingSpots.length === 0) {
            console.warn(`[parkingAlgorithm] WARNING: Staging enabled but no staging zones found! ` + `Mark zones with metadata.is_staging=true to use staging workflow. ` + `Disabling staging for this run to prevent placement failures.`);
            effectiveEnableArrival = false; // Auto-disable both
            effectiveEnableDeparture = false;
        } else {
            console.log(`[parkingAlgorithm] Staging enabled: ${stagingSpots.length} staging spots available ` + `(arrival=${enableArrivalStaging}, departure=${enableDepartureStaging})`);
            // Auto-increase plannedMoveCap based on enabled staging
            // Both enabled = 2 moves, one enabled = 1 move
            const requiredMoves = enableArrivalStaging && enableDepartureStaging ? 2 : 1;
            if (plannedMoveCap < requiredMoves) {
                console.warn(`[parkingAlgorithm] WARNING: Staging enabled requires plannedMoveCap >= ${requiredMoves}. ` + `Auto-increasing from ${plannedMoveCap} to ${requiredMoves}.`);
                effectivePlannedMoveCap = requiredMoves; // Allow staging moves
            }
        }
    }
    // Phase 9: If mask optimization enabled, precompute masks once at start
    // NOTE: Masks will be updated incrementally as aircraft are placed
    if (useMaskOptimization) (0, $ad1qL.precomputeAllEgressMasks)(spots, placement, requests, 0);
    // Phase 3: Initialize running polygon map for gap spot collision detection
    // TODO: Replace size-based footprints with real aircraft geometry when available
    const placedAircraftPolygons = new Map();
    // Sort parking requests using specified strategy
    const sortFn = (0, $esyom.getSortingStrategy)(sortingStrategy);
    const sortedRequests = sortFn(requests, spots);
    for (const request of sortedRequests){
        const mask = (0, $elGuA.dwellMask)(request, bufferMinutes, horizonHours);
        // ===== LOCK PATH =====
        // Check if this aircraft has temporal locks
        const hasLocks = request.locks && request.locks.length > 0;
        if (hasLocks) {
            console.log(`[parkingAlgorithm] Aircraft ${request.tail_number} has ${request.locks.length} lock(s)`);
            const result = (0, $8mB0X.findSpotChainWithLocks)(request, spots, effectivePlannedMoveCap, bufferMinutes, horizonHours, egressWeight, wasteWeight);
            if (result.success) {
                // Success - place with segments
                const chain = result.chain;
                placement[request.id] = {
                    segments: chain.segments,
                    moveCount: chain.moveCount
                };
                // Reserve bitmaps for each segment
                for (const segment of chain.segments){
                    const spot = spots.find((s)=>s.id === segment.spotId);
                    if (spot) {
                        const segmentRequest = {
                            ...request,
                            arrivalBucket: segment.startBucket,
                            departureBucket: segment.endBucket
                        };
                        const segmentMask = (0, $elGuA.dwellMask)(segmentRequest, 0, horizonHours);
                        (0, $elGuA.orInto)(spot.occupancy, segmentMask);
                    }
                }
                // Log successful placement with lock info
                const lockedSegments = chain.segments.filter((seg)=>{
                    const lock = request.locks.find((l)=>l.spotId === seg.spotId && l.startBucket === seg.startBucket && l.endBucket === seg.endBucket);
                    return !!lock;
                });
                const lockReasons = request.locks.filter((l)=>lockedSegments.some((seg)=>seg.spotId === l.spotId && seg.startBucket === l.startBucket && seg.endBucket === l.endBucket)).map((l)=>l.reason).filter(Boolean);
                $6376581398fa7741$var$logEntry({
                    aircraftId: request.id,
                    type: "placed",
                    spotId: chain.segments[0].spotId,
                    reason: `Placed with ${chain.segments.length} segments (${lockedSegments.length} locked, ${chain.moveCount} moves)`,
                    lockConstraint: lockedSegments.length > 0 ? {
                        spotId: lockedSegments[0].spotId,
                        reason: lockReasons[0],
                        isLocked: true,
                        lockValidated: true
                    } : undefined
                });
                // Phase 9: Recompute egress masks after locked placement
                if (useMaskOptimization) (0, $ad1qL.precomputeAllEgressMasks)(spots, placement, requests, 0);
                // Phase 3: Add aircraft footprint for first segment position
                if (request.aircraft) {
                    const firstSegment = chain.segments[0];
                    const spot = spots.find((s)=>s.id === firstSegment.spotId);
                    if (spot) {
                        // No null check needed - shape is required
                        const footprint = (0, $77E3s.createAircraftFootprint)(request, spot.shape, firstSegment.orientationId);
                        placedAircraftPolygons.set(request.id, footprint);
                    }
                }
            } else // Failed to satisfy locks - log detailed failure reason
            if (result.success === false) {
                const failure = result.failure;
                let reason;
                let lockSpotId;
                let lockReason;
                switch(failure.failureType){
                    case "lock_validation":
                        reason = `Lock validation failed: ${failure.validationReason}`;
                        lockSpotId = failure.failedLock?.spotId;
                        lockReason = failure.failedLock?.reason;
                        break;
                    case "move_cap":
                        reason = `Lock placement failed: ${failure.validationReason}`;
                        // For move cap, show first lock as representative
                        lockSpotId = request.locks[0].spotId;
                        lockReason = request.locks[0].reason;
                        break;
                    case "no_spots":
                        reason = `Lock placement failed: ${failure.validationReason}`;
                        lockSpotId = request.locks[0].spotId;
                        lockReason = request.locks[0].reason;
                        break;
                }
                $6376581398fa7741$var$logEntry({
                    aircraftId: request.id,
                    type: "rejected",
                    reason: reason,
                    lockConstraint: {
                        spotId: lockSpotId || request.locks[0].spotId,
                        reason: lockReason,
                        isLocked: true,
                        lockValidated: false
                    }
                });
            }
            continue; // Skip to next aircraft (lock path handled)
        }
        // ===== STAGING PATH =====
        // Check if this aircraft should use arrival/departure staging
        const dwellMinutes = (request.departureBucket - request.arrivalBucket) * (0, $h3XF9.MINUTES_PER_BUCKET);
        // Window-aware staging: only stage if arrival/departure happens in planning window
        const tripArrivesInWindow = request.metadata?.tripArrivesInWindow ?? true;
        const tripDepartsInWindow = request.metadata?.tripDepartsInWindow ?? true;
        const stagingConfig = (0, $kbn5z.shouldUseStaging)(request, effectiveEnableArrival && tripArrivesInWindow, // Only if trip arrives in window
        effectiveEnableDeparture && tripDepartsInWindow, // Only if trip departs in window
        quickTurnThresholdMinutes, arrivalStagingDwellMinutes, departureStagingDwellMinutes);
        const needsStaging = stagingConfig.useArrival || stagingConfig.useDeparture;
        if (needsStaging) {
            const stagingType = stagingConfig.useArrival && stagingConfig.useDeparture ? "both arrival and departure" : stagingConfig.useArrival ? "arrival only" : "departure only";
            $6376581398fa7741$var$stagingLogger.info(`${request.tail_number}: Eligible for staging workflow (${dwellMinutes} min, ${stagingType})`);
            const arrivalStagingBuckets = Math.floor(arrivalStagingDwellMinutes / (0, $h3XF9.MINUTES_PER_BUCKET));
            const departureStagingBuckets = Math.floor(departureStagingDwellMinutes / (0, $h3XF9.MINUTES_PER_BUCKET));
            const stagingResult = (0, $3qqrt.findStagingChain)(request, spots, stagingConfig.useArrival, stagingConfig.useDeparture, arrivalStagingBuckets, departureStagingBuckets, zones, horizonHours, placement, sortedRequests, egressWeight, wasteWeight, structuralWeight, zonePriorityWeight, min_dwell_weight, stickinessWeight, placedAircraftPolygons, $6376581398fa7741$var$logEntry);
            if (stagingResult.success) {
                // Success - place with staging segments
                placement[request.id] = {
                    segments: stagingResult.segments,
                    moveCount: stagingResult.moveCount
                };
                // Reserve bitmaps for each segment
                for (const segment of stagingResult.segments){
                    const spot = spots.find((s)=>s.id === segment.spotId);
                    if (spot) {
                        const segmentRequest = {
                            ...request,
                            arrivalBucket: segment.startBucket,
                            departureBucket: segment.endBucket
                        };
                        const segmentMask = (0, $elGuA.dwellMask)(segmentRequest, 0, horizonHours);
                        (0, $elGuA.orInto)(spot.occupancy, segmentMask);
                    }
                }
                // Build dynamic log message based on actual segments
                const segmentDescriptions = stagingResult.segments.map((seg, idx)=>{
                    const duration = (seg.endBucket - seg.startBucket) * (0, $h3XF9.MINUTES_PER_BUCKET);
                    const spot = spots.find((s)=>s.id === seg.spotId);
                    const spotName = spot?.shape?.text || seg.spotId;
                    // Determine segment type based on position and configuration
                    let type;
                    if (idx === 0 && stagingConfig.useArrival) type = "arrival staging";
                    else if (idx === stagingResult.segments.length - 1 && stagingConfig.useDeparture) type = "departure staging";
                    else type = "permanent";
                    return `${spotName} (${type}, ${duration} min)`;
                });
                const chainDescription = segmentDescriptions.join(" \u2192 ");
                $6376581398fa7741$var$logEntry({
                    aircraftId: request.id,
                    type: "placed",
                    spotId: stagingResult.segments[0].spotId,
                    reason: `Placed with staging workflow (${stagingResult.moveCount} moves): ${chainDescription}`
                });
                // Phase 9: Recompute egress masks after staging placement
                if (useMaskOptimization) (0, $ad1qL.precomputeAllEgressMasks)(spots, placement, requests, 0);
                // Phase 3: Add aircraft footprint for first segment position
                if (request.aircraft) {
                    const firstSegment = stagingResult.segments[0];
                    const spot = spots.find((s)=>s.id === firstSegment.spotId);
                    if (spot) {
                        const footprint = (0, $77E3s.createAircraftFootprint)(request, spot.shape, firstSegment.orientationId);
                        placedAircraftPolygons.set(request.id, footprint);
                    }
                }
                continue; // Skip to next aircraft (staging path handled)
            } else // Staging chain failed - log reason and fall through to regular placement
            if (stagingResult.success === false) {
                $6376581398fa7741$var$stagingLogger.warn(`${request.tail_number}: Staging chain failed - ${stagingResult.reason}. Falling back to regular placement.`);
                $6376581398fa7741$var$logEntry({
                    aircraftId: request.id,
                    type: "eval",
                    reason: `Staging workflow failed (${stagingResult.failedSegment} segment): ${stagingResult.reason}. Attempting regular placement.`
                });
            }
        } else if (anyStaging && !needsStaging) {
            // Staging enabled but this aircraft bypasses (quick turn or insufficient time)
            $6376581398fa7741$var$stagingLogger.debug(`${request.tail_number}: Bypassing staging (${dwellMinutes} min \u{2264} ${quickTurnThresholdMinutes} min threshold or insufficient time)`);
            $6376581398fa7741$var$logEntry({
                aircraftId: request.id,
                type: "eval",
                reason: `Quick turn detected (${dwellMinutes} min) - bypassing staging workflow`
            });
        }
        // ===== NORMAL PATH (no locks, no staging, or staging failed) =====
        // Log gap spot status BEFORE filtering
        // This shows gap spots that will be filtered out due to dependencies or collision
        spots.forEach((spot)=>{
            if (spot.isGapSpot && spot.allowedSizes.includes(request.sizeCategory)) {
                const gapStatus = $6376581398fa7741$var$getGapSpotStatus(spot, placement, placedAircraftPolygons);
                // Only log gap spots that are NOT available (filtered out)
                if (!gapStatus.available) $6376581398fa7741$var$logEntry({
                    aircraftId: request.id,
                    spotId: spot.id,
                    type: "eval",
                    timeAvailable: true,
                    // Gap spot passed time check but failed dependency/collision
                    isGapSpot: true,
                    gapRequiredSpots: spot.requiresOccupiedSpots,
                    gapDependenciesMet: gapStatus.dependenciesMet,
                    gapDependenciesTotal: gapStatus.dependenciesTotal,
                    gapCollision: gapStatus.collision,
                    reason: gapStatus.reason
                });
            }
        });
        // Get all available spots with detailed breakdown tracking
        // Applies size compatibility, time availability, duration limits, and geometry collision filters (Phase 3)
        const { availableSpots: timeAvailableSpots, breakdown: filterBreakdown } = (0, $6moNe.getAvailableSpotsWithBreakdown)(spots, request, mask, placement, placedAircraftPolygons, // shapes parameter removed - spotFiltering will use spot.shape
        zones);
        // If no spots available after filtering, log detailed breakdown
        if (timeAvailableSpots.length === 0) {
            // Generate legacy suggestion for backward compatibility
            const suggestion = $6376581398fa7741$var$generateFilterSuggestion(filterBreakdown, request);
            // Generate enhanced suggestions with analysis (Phase 4: includes near-miss analysis)
            const suggestionDetails = $6376581398fa7741$var$generateEnhancedSuggestions(filterBreakdown, request, spots, zones, mask, placement, placedAircraftPolygons);
            // Create detailed breakdown message
            const breakdownDetails = [
                `Total: ${filterBreakdown.total}`,
                filterBreakdown.disabled > 0 ? `Disabled: ${filterBreakdown.disabled}` : null,
                filterBreakdown.sizeIncompatible > 0 ? `Size incompatible: ${filterBreakdown.sizeIncompatible}` : null,
                filterBreakdown.timeConflict > 0 ? `Time conflicts: ${filterBreakdown.timeConflict}` : null,
                filterBreakdown.durationExceeded > 0 ? `Duration exceeded: ${filterBreakdown.durationExceeded}` : null,
                filterBreakdown.geometryCollision > 0 ? `Geometry collision: ${filterBreakdown.geometryCollision}` : null
            ].filter(Boolean).join(", ");
            $6376581398fa7741$var$logEntry({
                aircraftId: request.id,
                type: "rejected",
                reason: `No available spots (${breakdownDetails}). Suggestion: ${suggestion}`,
                filterBreakdown: filterBreakdown,
                suggestionDetails: suggestionDetails,
                sizeMismatch: filterBreakdown.sizeIncompatible > 0,
                aircraftSize: request.sizeCategory
            });
            continue; // Skip to next parking request
        }
        if (timeAvailableSpots.length > 0) {
            // Score each spot by how many aircraft it would trap (fewer is better)
            // Apply egress weight to amplify the penalty for trapping
            const scoredSpots = timeAvailableSpots.map((spot)=>{
                // Phase 9: Use fast path if mask optimization enabled
                let trappedCount;
                let maskDebug;
                if (useMaskOptimization) {
                    const result = (0, $7O8dW.countTrappedAircraftFast)(request, spot, placement, requests, spots, validateMasks);
                    trappedCount = result.count;
                    maskDebug = result.maskDebug;
                } else trappedCount = (0, $7O8dW.countTrappedAircraft)(request, spot, placement, requests, spots);
                const trappedAircraft = (0, $7O8dW.findTrappedAircraft)(request, spot, placement, requests, spots);
                // Multi-lane egress support: Determine which lane was chosen (best lane)
                // The algorithm uses min() logic, so we need to find the lane with fewest traps
                const egressOptions = spot.egressOptions || [];
                let chosenEgressOption;
                let blockedSpots = [];
                if (egressOptions.length > 0) {
                    // Find the lane with minimum traps (same logic as countTrappedAircraft)
                    let minTraps = Infinity;
                    let bestOption;
                    for (const option of egressOptions){
                        // Count traps for this specific lane
                        let trapsForLane = 0;
                        for(const aircraftId in placement){
                            const placedInfo = placement[aircraftId];
                            const placedAircraft = requests.find((ac)=>ac.id === aircraftId);
                            if (!placedAircraft) continue;
                            const placedSpotId = "segments" in placedInfo ? placedInfo.segments[0].spotId : placedInfo.spotId;
                            if (option.blocksSpotIds.includes(placedSpotId) && request.departureBucket > placedAircraft.departureBucket) trapsForLane++;
                        }
                        if (trapsForLane < minTraps) {
                            minTraps = trapsForLane;
                            bestOption = option;
                        }
                    }
                    if (bestOption) {
                        chosenEgressOption = {
                            laneId: bestOption.laneId,
                            laneName: bestOption.laneName,
                            blocksCount: bestOption.blocksSpotIds.length
                        };
                        blockedSpots = bestOption.blocksSpotIds;
                    }
                }
                // Calculate egress score (trapping penalty)
                // WHY: Higher weight makes algorithm strongly prefer spots that don't trap
                // EXAMPLE: trappedCount=2, egressWeight=5.0 → egressScore=10.0
                const egressScore = trappedCount * egressWeight;
                // Calculate structural complexity penalty
                // WHY: Prefer "clean" spots (no blocking) over complex ones, even when no actual conflict
                // RATIONALE: Save complex spots for when you need them, use simple spots first
                // EXAMPLE: spot blocks 3 others, structuralWeight=0.1 → structuralPenalty=0.3
                const structuralComplexity = (0, $8L6tD.calculateStructuralComplexity)(spot);
                const structuralPenalty = structuralComplexity * structuralWeight;
                // Calculate waste score (spot size mismatch penalty)
                // WHY: Penalize using oversized spots to reserve premium capacity for large aircraft
                // SCALE: waste (0-4) × wasteWeight → comparable to egress penalty
                // EXAMPLE: Citation (small) in large spot: waste=3, wasteWeight=1.0 → wasteScore=3.0
                // STAGING EXEMPTION: Small aircraft can use large staging spots without penalty
                const wasteScore = (0, $8L6tD.calculateSpotWaste)(request, spot);
                const isInStagingZone = (0, $kbn5z.isSpotInStagingZone)(spot);
                const isStagingPlacement = isInStagingZone && request.isStagingSegment;
                const wastePenalty = isStagingPlacement ? 0 : wasteScore * wasteWeight;
                // Calculate dwell duration (used by multiple penalties)
                const dwellBuckets = request.departureBucket - request.arrivalBucket;
                const dwellMinutes = dwellBuckets * 15;
                // Calculate zone priority penalty
                // WHY: Prefer spots in high-priority zones (premium areas, near services)
                // FORMULA: (10 - zonePriority) × zonePriorityWeight
                // EXAMPLE: Priority 10 (best) → penalty 0, Priority 5 (neutral) → penalty 5, Priority 0 (worst) → penalty 10
                const zone = zones.find((z)=>z.id === spot.zoneId);
                const zonePriority = zone?.priority ?? 5; // Default priority = 5 (neutral)
                const zonePenalty = (10 - zonePriority) * zonePriorityWeight;
                // WARNING: Zone lookup failed - this is a data integrity issue
                if (!zone && spot.zoneId !== "default") console.warn(`[parkingAlgorithm] \u{26A0}\u{FE0F} WARNING: Spot ${spot.id} references zone "${spot.zoneId}" which was not found!`, `\nAvailable zones:`, zones.map((z)=>z.id), `\nUsing default priority ${zonePriority}`);
                // Calculate min dwell time penalty/bonus
                // WHY: Reserve remote/overflow spots for long-stay aircraft
                // LOGIC: Aircraft dwell >= min_dwell → BONUS (negative penalty to lower score)
                //        Aircraft dwell < min_dwell → PENALTY (positive penalty to raise score)
                // EXAMPLE: 480 min requirement, 600 min dwell → bonus=-5×weight (attracts long-stay)
                //          480 min requirement, 120 min dwell → penalty=+5×weight (repels short-stay)
                let min_dwell_penalty = 0;
                if (spot.min_dwell_minutes) {
                    if (dwellMinutes >= spot.min_dwell_minutes) // Long-stay aircraft → BONUS (negative penalty)
                    min_dwell_penalty = -5 * min_dwell_weight;
                    else // Short-stay aircraft → PENALTY (positive penalty)
                    min_dwell_penalty = 5 * min_dwell_weight;
                }
                // Calculate stickiness penalty (last-minute insertion)
                // WHY: Preserve existing schedule by penalizing moves from previous placements
                // LOGIC: If aircraft was in prevSpotId and we're considering a different spot, add penalty
                // VALIDATION: Only apply if prevSpotId actually exists in spot list
                // EXAMPLE: Aircraft in A1, considering A2, stickinessWeight=10 → penalty=10
                const prevSpotExists = request.prevSpotId && spots.find((s)=>s.id === request.prevSpotId);
                const stickyPenalty = prevSpotExists && request.prevSpotId !== spot.id ? stickinessWeight : 0;
                // Total score combines egress safety + structural simplicity + spot efficiency + zone preference + min dwell match + stickiness
                // Lower score = better candidate
                const totalScore = egressScore + structuralPenalty + wastePenalty + zonePenalty + min_dwell_penalty + stickyPenalty;
                // Log spot evaluation with both egress and waste details
                // For gap spots, include dependency and collision status
                const gapStatus = spot.isGapSpot ? $6376581398fa7741$var$getGapSpotStatus(spot, placement, placedAircraftPolygons) : null;
                // Generate detailed blocking information
                const blockingDetails = blockedSpots.length > 0 ? $6376581398fa7741$var$generateBlockingDetails(request, blockedSpots, placement, requests) : undefined;
                // Check if duration exceeded (for logging)
                const duration_exceeded = spot.max_dwell_minutes && dwellMinutes > spot.max_dwell_minutes;
                $6376581398fa7741$var$logEntry({
                    aircraftId: request.id,
                    spotId: spot.id,
                    type: "eval",
                    timeAvailable: true,
                    trappedCount: trappedCount,
                    chosenEgressOption: // Multi-lane egress fields
                    chosenEgressOption,
                    availableEgressOptions: egressOptions.length > 0 ? egressOptions.length : undefined,
                    blockedSpots: blockedSpots.length > 0 ? blockedSpots : undefined,
                    blockingDetails: blockingDetails,
                    blockedAircraft: trappedAircraft.length > 0 ? trappedAircraft.map((0, $846sO.getAircraftDisplayName)) : undefined,
                    egressScore: egressScore,
                    egressWeight: egressWeight,
                    structuralComplexity: // Structural complexity fields
                    structuralComplexity,
                    structuralWeight: structuralWeight,
                    structuralPenalty: structuralPenalty,
                    wasteScore: wasteScore,
                    wasteWeight: wasteWeight,
                    wastePenalty: wastePenalty,
                    zonePriority: // Zone priority fields
                    zonePriority,
                    zonePriorityWeight: zonePriorityWeight,
                    zonePenalty: zonePenalty,
                    // Duration fields
                    max_dwell_minutes: spot.max_dwell_minutes,
                    actual_dwell_minutes: dwellMinutes,
                    duration_exceeded: duration_exceeded,
                    // Min dwell fields
                    min_dwell_minutes: spot.min_dwell_minutes,
                    min_dwell_penalty: min_dwell_penalty,
                    min_dwell_weight: min_dwell_weight,
                    // Stickiness fields (last-minute insertion)
                    prevSpotId: request.prevSpotId,
                    stickyPenalty: request.prevSpotId ? stickyPenalty : undefined,
                    // Only log if prevSpotId set
                    stickinessWeight: request.prevSpotId && stickinessWeight !== 0 ? stickinessWeight : undefined,
                    // Only log if active
                    // Disabled status fields
                    spot_disabled: spot.disabled,
                    zone_disabled: zone?.disabled,
                    // Gap spot fields
                    isGapSpot: spot.isGapSpot,
                    gapRequiredSpots: spot.isGapSpot ? spot.requiresOccupiedSpots : undefined,
                    gapDependenciesMet: gapStatus ? gapStatus.dependenciesMet : undefined,
                    gapDependenciesTotal: gapStatus ? gapStatus.dependenciesTotal : undefined,
                    gapCollision: gapStatus ? gapStatus.collision : undefined,
                    maskDebug: // Phase 9: Mask debug info (if validation mode enabled)
                    maskDebug
                });
                return {
                    spot: spot,
                    trappedCount: trappedCount,
                    score: totalScore
                };
            });
            // If allowTrapping=false, filter out spots that would trap any aircraft
            let candidateSpots = scoredSpots;
            if (!allowTrapping) candidateSpots = scoredSpots.filter((s)=>s.trappedCount === 0);
            // If no clean spots remain (all trap) and allowTrapping=false, skip placement
            if (candidateSpots.length === 0) {
                // Find all trapped aircraft across all time-available spots
                const allTrappedAircraft = new Set();
                timeAvailableSpots.forEach((spot)=>{
                    const trapped = (0, $7O8dW.findTrappedAircraft)(request, spot, placement, requests, spots);
                    trapped.forEach((t)=>allTrappedAircraft.add((0, $846sO.getAircraftDisplayName)(t)));
                });
                $6376581398fa7741$var$logEntry({
                    aircraftId: request.id,
                    type: "rejected",
                    reason: `All ${timeAvailableSpots.length} time-available spots would trap aircraft (allowTrapping=false)`,
                    blockedAircraft: Array.from(allTrappedAircraft)
                });
                continue; // Leave parking request unplaced
            }
            // Sort by weighted score (ascending) - pick spot with lowest egress penalty
            // WHY: Lower score = fewer traps or less impact from weight
            // EXAMPLE: score=0 (no traps) always wins, score=10 (2 traps × 5x weight) loses to score=2 (2 traps × 1x weight)
            candidateSpots.sort((a, b)=>a.score - b.score);
            const bestSpot = candidateSpots[0].spot;
            const trappedAircraft = (0, $7O8dW.findTrappedAircraft)(request, bestSpot, placement, requests, spots);
            // Full dwell in one spot - simple case
            placement[request.id] = {
                spotId: bestSpot.id,
                orientationId: bestSpot.orientations[0].id
            };
            // Log placement success with egress details and gap spot information
            const placedGapStatus = bestSpot.isGapSpot ? $6376581398fa7741$var$getGapSpotStatus(bestSpot, placement, placedAircraftPolygons) : null;
            const gapReason = bestSpot.isGapSpot && bestSpot.requiresOccupiedSpots ? `Placed in gap spot (requires ${bestSpot.requiresOccupiedSpots.join(", ")})` : undefined;
            // Find zone for placed spot
            const placedZone = zones.find((z)=>z.id === bestSpot.zoneId);
            // Calculate stickiness penalty for placed spot (with validation)
            const prevSpotExists = request.prevSpotId && spots.find((s)=>s.id === request.prevSpotId);
            const placedStickyPenalty = prevSpotExists && request.prevSpotId !== bestSpot.id ? stickinessWeight : 0;
            $6376581398fa7741$var$logEntry({
                aircraftId: request.id,
                spotId: bestSpot.id,
                type: "placed",
                trappedCount: candidateSpots[0].trappedCount,
                blockedAircraft: trappedAircraft.length > 0 ? trappedAircraft.map((0, $846sO.getAircraftDisplayName)) : undefined,
                egressScore: candidateSpots[0].score,
                egressWeight: egressWeight,
                // Zone priority fields
                zonePriority: placedZone?.priority,
                zonePriorityWeight: zonePriorityWeight,
                // Min dwell fields
                min_dwell_minutes: bestSpot.min_dwell_minutes,
                min_dwell_weight: min_dwell_weight,
                // Stickiness fields
                prevSpotId: request.prevSpotId,
                stickyPenalty: request.prevSpotId ? placedStickyPenalty : undefined,
                // Only log if prevSpotId set
                stickinessWeight: request.prevSpotId && stickinessWeight !== 0 ? stickinessWeight : undefined,
                // Only log if active
                // Gap spot fields
                isGapSpot: bestSpot.isGapSpot,
                gapRequiredSpots: bestSpot.isGapSpot ? bestSpot.requiresOccupiedSpots : undefined,
                gapDependenciesMet: placedGapStatus ? placedGapStatus.dependenciesMet : undefined,
                gapDependenciesTotal: placedGapStatus ? placedGapStatus.dependenciesTotal : undefined,
                reason: gapReason
            });
            // Reserve the spot immediately to prevent double-booking
            (0, $elGuA.orInto)(bestSpot.occupancy, mask);
            // Phase 9: Recompute egress masks after placement (incremental update)
            if (useMaskOptimization) (0, $ad1qL.precomputeAllEgressMasks)(spots, placement, requests, 0);
            // Phase 3: Add aircraft footprint to polygon map for gap spot collision detection
            // Uses real aircraft dimensions when available (request.aircraft.wingspan/length)
            // No null check needed - shape is required
            const aircraftFootprint = (0, $77E3s.createAircraftFootprint)(request, bestSpot.shape, bestSpot.orientations[0].id);
            placedAircraftPolygons.set(request.id, aircraftFootprint);
        } else if (effectivePlannedMoveCap > 0) {
            // No single spot available - try segmented placement
            // Get size-compatible spots for segmentation (segmentation does its own time filtering)
            const sizeCompatibleSpots = spots.filter((spot)=>spot.allowedSizes.includes(request.sizeCategory));
            const chain = (0, $hddnH.findSpotChain)(request, sizeCompatibleSpots, effectivePlannedMoveCap, bufferMinutes, horizonHours);
            if (chain) {
                // Found a valid chain within move cap
                placement[request.id] = {
                    segments: chain.segments,
                    moveCount: chain.moveCount
                };
                // Log segmented placement
                $6376581398fa7741$var$logEntry({
                    aircraftId: request.id,
                    type: "segmented",
                    reason: `${chain.segments.length} segments (${chain.segments.length - 1} moves)`
                });
                // Reserve all segments
                (0, $hddnH.applySpotChain)(chain, spots);
                // Phase 9: Recompute egress masks after segmented placement
                if (useMaskOptimization) (0, $ad1qL.precomputeAllEgressMasks)(spots, placement, requests, 0);
                // Phase 3: Add aircraft footprint for final segment position
                // Uses real aircraft dimensions when available (request.aircraft.wingspan/length)
                if (chain.segments.length > 0) {
                    const lastSegment = chain.segments[chain.segments.length - 1];
                    const spot = spots.find((s)=>s.id === lastSegment.spotId);
                    if (spot) {
                        // No null check needed - shape is required
                        const aircraftFootprint = (0, $77E3s.createAircraftFootprint)(request, spot.shape, lastSegment.orientationId);
                        placedAircraftPolygons.set(request.id, aircraftFootprint);
                    }
                }
            } else // No chain found
            $6376581398fa7741$var$logEntry({
                aircraftId: request.id,
                type: "rejected",
                reason: `No single spot time-available and no valid segmentation chain found (move cap: ${effectivePlannedMoveCap})`
            });
        } else {
            // plannedMoveCap === 0 and no spot available - use breakdown from earlier
            // Note: filterBreakdown should already be defined from earlier in the loop
            const suggestion = $6376581398fa7741$var$generateFilterSuggestion(filterBreakdown, request);
            // Generate enhanced suggestions with analysis (Phase 4: includes near-miss analysis)
            const suggestionDetails = $6376581398fa7741$var$generateEnhancedSuggestions(filterBreakdown, request, spots, zones, mask, placement, placedAircraftPolygons);
            const breakdownDetails = [
                `Total: ${filterBreakdown.total}`,
                filterBreakdown.disabled > 0 ? `Disabled: ${filterBreakdown.disabled}` : null,
                filterBreakdown.sizeIncompatible > 0 ? `Size incompatible: ${filterBreakdown.sizeIncompatible}` : null,
                filterBreakdown.timeConflict > 0 ? `Time conflicts: ${filterBreakdown.timeConflict}` : null,
                filterBreakdown.durationExceeded > 0 ? `Duration exceeded: ${filterBreakdown.durationExceeded}` : null,
                filterBreakdown.geometryCollision > 0 ? `Geometry collision: ${filterBreakdown.geometryCollision}` : null
            ].filter(Boolean).join(", ");
            $6376581398fa7741$var$logEntry({
                aircraftId: request.id,
                type: "rejected",
                reason: `No available spots (${breakdownDetails}, segmentation disabled). Suggestion: ${suggestion}`,
                filterBreakdown: filterBreakdown,
                suggestionDetails: suggestionDetails
            });
        }
    }
    return placement;
}

});
parcelRegister("elGuA", function(module, exports) {

$parcel$export(module.exports, "calculateTotalSlots", () => $2a19f38aa823f2ba$export$799f004dc28b8c38);
$parcel$export(module.exports, "calculateWordCount", () => $2a19f38aa823f2ba$export$ee077c18dd20cd22);
$parcel$export(module.exports, "TOTAL_SLOTS", () => $2a19f38aa823f2ba$export$d871accbd9c9720a);
$parcel$export(module.exports, "makeEmptyMask", () => $2a19f38aa823f2ba$export$9ee7d845225cf68a);
$parcel$export(module.exports, "setRange", () => $2a19f38aa823f2ba$export$9644c4f5061d3b67);
$parcel$export(module.exports, "intersects", () => $2a19f38aa823f2ba$export$7b0a31e10bbff018);
$parcel$export(module.exports, "orInto", () => $2a19f38aa823f2ba$export$f0dedc7fa00b200f);
$parcel$export(module.exports, "dwellMask", () => $2a19f38aa823f2ba$export$5ae24f44d5648ef3);
$parcel$export(module.exports, "timeStringToBucket", () => $2a19f38aa823f2ba$export$55be663af0051327);
$parcel$export(module.exports, "bucketToTimeString", () => $2a19f38aa823f2ba$export$6195229897f78e16);
$parcel$export(module.exports, "findAvailableWindows", () => $2a19f38aa823f2ba$export$3312e4b6ea0a78b3);
/**
 * Bitmap Helpers for Temporal Parking
 * Based on plans/ramp-temporal-parking.md
 *
 * Uses BigUint64Array for efficient bitwise operations on time slots.
 * Each bit represents a 15-minute bucket. 1 = occupied/reserved, 0 = free.
 */ const $2a19f38aa823f2ba$export$a832159802c7c0ab = 4; // 15-minute buckets per hour
const $2a19f38aa823f2ba$export$7bb37b8f8d331025 = 96; // 15-minute buckets per day (24 * 4)
const $2a19f38aa823f2ba$export$14c83b7aa44806d0 = 64; // 64-bit lane per element
const $2a19f38aa823f2ba$var$ONE = 1n;
const $2a19f38aa823f2ba$export$9af449f1f636bbb0 = 24;
const $2a19f38aa823f2ba$export$ce982769008d1e80 = 2160; // 90 days
function $2a19f38aa823f2ba$export$799f004dc28b8c38(horizonHours) {
    return horizonHours * $2a19f38aa823f2ba$export$a832159802c7c0ab;
}
function $2a19f38aa823f2ba$export$ee077c18dd20cd22(totalSlots) {
    return Math.ceil(totalSlots / $2a19f38aa823f2ba$export$14c83b7aa44806d0);
}
const $2a19f38aa823f2ba$export$d871accbd9c9720a = $2a19f38aa823f2ba$export$799f004dc28b8c38($2a19f38aa823f2ba$export$9af449f1f636bbb0);
const $2a19f38aa823f2ba$export$9e037301e93f6765 = $2a19f38aa823f2ba$export$ee077c18dd20cd22($2a19f38aa823f2ba$export$d871accbd9c9720a);
function $2a19f38aa823f2ba$export$9ee7d845225cf68a(horizonHours = $2a19f38aa823f2ba$export$9af449f1f636bbb0) {
    const totalSlots = $2a19f38aa823f2ba$export$799f004dc28b8c38(horizonHours);
    const wordCount = $2a19f38aa823f2ba$export$ee077c18dd20cd22(totalSlots);
    return new BigUint64Array(wordCount);
}
function $2a19f38aa823f2ba$export$9644c4f5061d3b67(mask, start, end) {
    for(let i = start; i <= end; i++){
        const wordIndex = Math.floor(i / $2a19f38aa823f2ba$export$14c83b7aa44806d0);
        const bitIndex = BigInt(i % $2a19f38aa823f2ba$export$14c83b7aa44806d0);
        mask[wordIndex] |= $2a19f38aa823f2ba$var$ONE << bitIndex;
    }
}
function $2a19f38aa823f2ba$export$7b0a31e10bbff018(a, b) {
    const len = Math.min(a.length, b.length);
    for(let i = 0; i < len; i++){
        if ((a[i] & b[i]) !== 0n) return true;
    }
    return false;
}
function $2a19f38aa823f2ba$export$f0dedc7fa00b200f(a, b) {
    const len = Math.min(a.length, b.length);
    for(let i = 0; i < len; i++)a[i] |= b[i];
}
function $2a19f38aa823f2ba$export$2fa599f945b4fb70(a, b) {
    const len = Math.min(a.length, b.length);
    for(let i = 0; i < len; i++)a[i] &= ~b[i];
}
function $2a19f38aa823f2ba$export$5ae24f44d5648ef3(aircraft, bufferMinutes = 0, horizonHours = $2a19f38aa823f2ba$export$9af449f1f636bbb0) {
    const mask = $2a19f38aa823f2ba$export$9ee7d845225cf68a(horizonHours);
    const totalSlots = $2a19f38aa823f2ba$export$799f004dc28b8c38(horizonHours);
    // Note: departureBucket is exclusive (not set in the mask)
    // This follows convention where [arrival, departure) is the dwell interval
    // Convert buffer from minutes to buckets (15-minute buckets)
    const bufferBuckets = Math.ceil(bufferMinutes / 15);
    // Apply buffer: extend backwards for arrival, forwards for departure
    const start = Math.max(0, aircraft.arrivalBucket - bufferBuckets);
    const end = Math.min(totalSlots - 1, aircraft.departureBucket - 1 + bufferBuckets);
    if (end >= start) $2a19f38aa823f2ba$export$9644c4f5061d3b67(mask, start, end);
    return mask;
}
function $2a19f38aa823f2ba$export$55be663af0051327(timeStr, startTime = "00:00") {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    const startTotalMinutes = startHours * 60 + startMinutes;
    let deltaMinutes = totalMinutes - startTotalMinutes;
    // Handle wrap-around (e.g., night shift 18:00-06:00)
    // If time is before start time, assume it's the next day
    if (deltaMinutes < 0) deltaMinutes += 1440; // Add 24 hours
    return Math.floor(deltaMinutes / 15);
}
function $2a19f38aa823f2ba$export$6195229897f78e16(bucket, startTime = new Date(new Date().setHours(0, 0, 0, 0)), showDay = false) {
    const startHours = startTime.getHours();
    const startMinutes = startTime.getMinutes();
    const startTotalMinutes = startHours * 60 + startMinutes;
    const bucketMinutes = bucket * 15;
    const absoluteMinutes = startTotalMinutes + bucketMinutes;
    const days = Math.floor(absoluteMinutes / 1440);
    const remainingMinutes = absoluteMinutes % 1440;
    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;
    const timeStr = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    if (showDay && days > 0) return `Day ${days + 1} ${timeStr}`;
    return timeStr;
}
function $2a19f38aa823f2ba$export$3312e4b6ea0a78b3(occupancy, requestStart, requestEnd) {
    const windows = [];
    let windowStart = null;
    // Scan through requested range looking for free buckets
    for(let bucket = requestStart; bucket < requestEnd; bucket++){
        const wordIndex = Math.floor(bucket / 64);
        const bitIndex = bucket % 64;
        const isOccupied = (occupancy[wordIndex] & 1n << BigInt(bitIndex)) !== 0n;
        if (!isOccupied) // Free bucket - start or extend window
        {
            if (windowStart === null) windowStart = bucket;
        } else // Occupied bucket - close window if one was open
        if (windowStart !== null) {
            windows.push([
                windowStart,
                bucket
            ]);
            windowStart = null;
        }
    }
    // Close final window if we ended on a free bucket
    if (windowStart !== null) windows.push([
        windowStart,
        requestEnd
    ]);
    return windows;
}

});

parcelRegister("7O8dW", function(module, exports) {

$parcel$export(module.exports, "countTrappedAircraft", () => $f6569233d9b1357b$export$29cde8d6c36fe423);
$parcel$export(module.exports, "findTrappedAircraft", () => $f6569233d9b1357b$export$fa65df3bc102e97a);
$parcel$export(module.exports, "countTrappedAircraftFast", () => $f6569233d9b1357b$export$118b96047ad09c6d);
/**
 * Egress Blocking Detection
 * Step 2: Functions for detecting and penalizing egress conflicts
 */ 
var $elGuA = parcelRequire("elGuA");

var $6moNe = parcelRequire("6moNe");
function $f6569233d9b1357b$export$2a5e47372ca33252(blockingAircraft, blockingSpot, blockedAircraft, blockedSpot) {
    // Multi-lane support: Check if ANY egress lane blocks the blocked spot
    const egressOptions = blockingSpot.egressOptions || [];
    if (egressOptions.length === 0) return false; // No egress options = no blocking
    // Check if ANY lane blocks this spot
    let hasBlockingRelationship = false;
    for (const option of egressOptions)if (option.blocksSpotIds.includes(blockedSpot.id)) {
        hasBlockingRelationship = true;
        break;
    }
    if (!hasBlockingRelationship) return false; // No physical blocking relationship
    // Check 2: Would the blocking aircraft depart AFTER the blocked aircraft?
    // If blocker departs after blocked, it's a trap
    // If blocker departs before or at same time, no trap
    const blockerDepartsAfter = blockingAircraft.departureBucket > blockedAircraft.departureBucket;
    return blockerDepartsAfter;
}
/**
 * Helper: Check if an aircraft could feasibly be placed at any of the given spots
 *
 * Checks if the aircraft is size-compatible and time-available at ANY of the spots.
 * This is used to determine if a future unplaced aircraft could end up at a spot
 * that would be blocked by the candidate placement.
 *
 * @param aircraft - Aircraft to check
 * @param spotIds - Array of spot IDs to check against
 * @param allSpots - Full list of spots
 * @returns true if aircraft could fit at ANY of the spots
 */ function $f6569233d9b1357b$var$couldFitAtAnySpot(aircraft, spotIds, allSpots) {
    if (spotIds.length === 0) return false;
    const mask = (0, $elGuA.dwellMask)(aircraft, 0); // No buffer for feasibility check
    return spotIds.some((spotId)=>{
        const spot = allSpots.find((s)=>s.id === spotId);
        if (!spot) return false;
        // Check size compatibility and time availability
        return (0, $6moNe.isSizeCompatible)(spot, aircraft) && (0, $6moNe.isTimeAvailable)(spot, mask);
    });
}
function $f6569233d9b1357b$export$c5753a39246c00e(candidateAircraft, candidateSpot, placement, allAircraft, allSpots) {
    // Multi-lane support: Calculate future trap count for EACH lane, then return min
    const egressOptions = candidateSpot.egressOptions || [];
    if (egressOptions.length === 0) return 0; // No egress options = no future traps
    // Multi-lane logic: Calculate future trap count for EACH lane
    const futureTrappedCountsPerLane = [];
    for (const option of egressOptions){
        // Only count future aircraft if this lane blocks at least one spot
        if (option.blocksSpotIds.length === 0) {
            futureTrappedCountsPerLane.push(0);
            continue;
        }
        let futureTrappedCountForLane = 0;
        const placedIds = new Set(Object.keys(placement));
        for (const unplacedAircraft of allAircraft){
            if (placedIds.has(unplacedAircraft.id)) continue;
            if (unplacedAircraft.id === candidateAircraft.id) continue;
            // Check if candidate departs after unplaced
            if (candidateAircraft.departureBucket > unplacedAircraft.departureBucket) // Only count if unplaced aircraft could actually fit at a blocked spot
            {
                if ($f6569233d9b1357b$var$couldFitAtAnySpot(unplacedAircraft, option.blocksSpotIds, allSpots)) futureTrappedCountForLane++;
            }
        }
        futureTrappedCountsPerLane.push(futureTrappedCountForLane);
    }
    // Return the MINIMUM future trap count across all lanes
    return Math.min(...futureTrappedCountsPerLane);
}
function $f6569233d9b1357b$export$29cde8d6c36fe423(candidateAircraft, candidateSpot, placement, allAircraft, allSpots) {
    // Multi-lane support: Calculate trap count for EACH lane, then return min
    const egressOptions = candidateSpot.egressOptions || [];
    if (egressOptions.length === 0) return 0; // No egress options = no blocking
    // Multi-lane logic: Calculate trap count for EACH lane
    const trapCountsPerLane = [];
    for (const option of egressOptions){
        // Only count trapped aircraft if this lane blocks at least one spot
        if (option.blocksSpotIds.length === 0) {
            trapCountsPerLane.push(0);
            continue;
        }
        let trappedCountForLane = 0;
        // Count already-placed aircraft trapped by this specific lane
        for(const aircraftId in placement){
            const placedInfo = placement[aircraftId];
            const placedAircraft = allAircraft.find((ac)=>ac.id === aircraftId);
            if (!placedAircraft) continue;
            let placedSpotId;
            if ("segments" in placedInfo) placedSpotId = placedInfo.segments[0].spotId;
            else placedSpotId = placedInfo.spotId;
            // Check if this lane blocks this specific spot
            if (!option.blocksSpotIds.includes(placedSpotId)) continue; // This lane doesn't block this spot
            // Check for trap/conflict
            // Snapshot mode: all aircraft have same departure time → spatial conflict
            // Temporal mode: check departure ordering → temporal trap
            const isTemporal = candidateAircraft.departureBucket !== placedAircraft.departureBucket;
            if (isTemporal) // Temporal mode: candidate must depart after placed to trap
            {
                if (candidateAircraft.departureBucket > placedAircraft.departureBucket) trappedCountForLane++;
            } else // Snapshot mode: any blocking of occupied spot is a spatial conflict
            trappedCountForLane++;
        }
        // Count future aircraft trapped by this specific lane
        // NOTE: In snapshot mode, unplaced aircraft can't be "trapped" because they
        // don't have positions yet - they'll just be placed elsewhere.
        // Only count future traps in temporal mode.
        const placedIds = new Set(Object.keys(placement));
        for (const unplacedAircraft of allAircraft){
            if (placedIds.has(unplacedAircraft.id)) continue;
            if (unplacedAircraft.id === candidateAircraft.id) continue;
            // Only count if unplaced aircraft could actually fit at a blocked spot
            if (!$f6569233d9b1357b$var$couldFitAtAnySpot(unplacedAircraft, option.blocksSpotIds, allSpots)) continue;
            // Check for future trap/conflict
            const isTemporal = candidateAircraft.departureBucket !== unplacedAircraft.departureBucket;
            if (isTemporal) // Temporal mode: candidate must depart after unplaced to trap
            {
                if (candidateAircraft.departureBucket > unplacedAircraft.departureBucket) trappedCountForLane++;
            }
        // Snapshot mode: Skip - unplaced aircraft aren't trapped (no position yet)
        }
        trapCountsPerLane.push(trappedCountForLane);
    }
    // Return the MINIMUM trap count across all lanes
    // WHY: Aircraft will choose the lane with fewest traps at departure
    return Math.min(...trapCountsPerLane);
}
function $f6569233d9b1357b$export$fa65df3bc102e97a(candidateAircraft, candidateSpot, placement, allAircraft, allSpots) {
    // Multi-lane support: Find trapped aircraft for EACH lane, then return min
    const egressOptions = candidateSpot.egressOptions || [];
    if (egressOptions.length === 0) return []; // No egress options = no trapped aircraft
    // Multi-lane logic: Calculate trapped aircraft for EACH lane
    const trappedPerLane = [];
    for (const option of egressOptions){
        const trappedForLane = [];
        // PART 1: Check already-placed aircraft trapped by this lane
        for(const aircraftId in placement){
            const placedAircraft = allAircraft.find((ac)=>ac.id === aircraftId);
            if (!placedAircraft) continue;
            const placedInfo = placement[aircraftId];
            const placedSpotId = "segments" in placedInfo ? placedInfo.segments[0].spotId : placedInfo.spotId;
            // Check if this lane blocks this specific spot
            if (!option.blocksSpotIds.includes(placedSpotId)) continue; // This lane doesn't block this spot
            // Check for trap/conflict
            const isTemporal = candidateAircraft.departureBucket !== placedAircraft.departureBucket;
            if (isTemporal) // Temporal mode: check departure ordering
            {
                if (candidateAircraft.departureBucket > placedAircraft.departureBucket) trappedForLane.push(placedAircraft);
            } else // Snapshot mode: any blocking of occupied spot is a spatial conflict
            trappedForLane.push(placedAircraft);
        }
        // PART 2: Check future aircraft trapped by this lane
        // NOTE: In snapshot mode, unplaced aircraft can't be "trapped" because they
        // don't have positions yet - they'll just be placed elsewhere.
        // Only count future traps in temporal mode.
        const placedIds = new Set(Object.keys(placement));
        for (const unplacedAircraft of allAircraft){
            if (placedIds.has(unplacedAircraft.id)) continue;
            if (unplacedAircraft.id === candidateAircraft.id) continue;
            // Only count if unplaced aircraft could actually fit at a blocked spot
            if (!$f6569233d9b1357b$var$couldFitAtAnySpot(unplacedAircraft, option.blocksSpotIds, allSpots)) continue;
            // Check for future trap/conflict
            const isTemporal = candidateAircraft.departureBucket !== unplacedAircraft.departureBucket;
            if (isTemporal) // Temporal mode: check departure ordering
            {
                if (candidateAircraft.departureBucket > unplacedAircraft.departureBucket) trappedForLane.push(unplacedAircraft);
            }
        // Snapshot mode: Skip - unplaced aircraft aren't trapped (no position yet)
        }
        trappedPerLane.push(trappedForLane);
    }
    // Return the aircraft from the lane with FEWEST traps (min)
    // WHY: Aircraft will choose the lane with fewest traps at departure
    let minTrappedCount = Infinity;
    let bestLaneTrapped = [];
    for (const trappedForLane of trappedPerLane)if (trappedForLane.length < minTrappedCount) {
        minTrappedCount = trappedForLane.length;
        bestLaneTrapped = trappedForLane;
    }
    return bestLaneTrapped;
}
function $f6569233d9b1357b$export$118b96047ad09c6d(candidateAircraft, candidateSpot, placement, allAircraft, allSpots, validate = false) {
    // Check if masks are available
    const hasMasks = candidateSpot.egressMasks && candidateSpot.egressMasks.perLane.length > 0;
    if (!hasMasks) {
        // Fallback to loop-based approach
        const loopCount = $f6569233d9b1357b$export$29cde8d6c36fe423(candidateAircraft, candidateSpot, placement, allAircraft, allSpots);
        return {
            count: loopCount,
            maskDebug: validate ? {
                usedMasks: false,
                loopResult: loopCount
            } : undefined
        };
    }
    // FAST PATH: Use masks
    const trapCountsPerLane = [];
    for (const laneMask of candidateSpot.egressMasks.perLane){
        // Count traps for this lane using mask intersection
        let trappedCountForLane = 0;
        // Check if candidate aircraft's dwell overlaps with this lane's blocked spots' departures
        // We need to count how many aircraft this placement would trap
        // For each spot blocked by this lane, check if occupied aircraft would be trapped
        for (const blockedSpotId of laneMask.blocksSpotIds)// Find if this spot is occupied
        for(const aircraftId in placement){
            const placedInfo = placement[aircraftId];
            const placedAircraft = allAircraft.find((ac)=>ac.id === aircraftId);
            if (!placedAircraft) continue;
            let placedSpotId;
            if ("segments" in placedInfo) placedSpotId = placedInfo.segments[0].spotId;
            else placedSpotId = placedInfo.spotId;
            // Check if this aircraft is at the blocked spot
            if (placedSpotId !== blockedSpotId) continue;
            // Check for trap/conflict
            const isTemporal = candidateAircraft.departureBucket !== placedAircraft.departureBucket;
            if (isTemporal) // Temporal mode: check departure ordering
            {
                if (candidateAircraft.departureBucket > placedAircraft.departureBucket) trappedCountForLane++;
            } else // Snapshot mode: any blocking of occupied spot is a spatial conflict
            trappedCountForLane++;
        }
        // Count future aircraft that could be trapped by this lane
        // NOTE: In snapshot mode, unplaced aircraft can't be "trapped" because they
        // don't have positions yet - they'll just be placed elsewhere.
        // Only count future traps in temporal mode.
        const placedIds = new Set(Object.keys(placement));
        for (const unplacedAircraft of allAircraft){
            if (placedIds.has(unplacedAircraft.id)) continue;
            if (unplacedAircraft.id === candidateAircraft.id) continue;
            // Only count if unplaced aircraft could actually fit at a blocked spot
            if (!$f6569233d9b1357b$var$couldFitAtAnySpot(unplacedAircraft, laneMask.blocksSpotIds, allSpots)) continue;
            // Check for future trap/conflict
            const isTemporal = candidateAircraft.departureBucket !== unplacedAircraft.departureBucket;
            if (isTemporal) // Temporal mode: check departure ordering
            {
                if (candidateAircraft.departureBucket > unplacedAircraft.departureBucket) trappedCountForLane++;
            }
        // Snapshot mode: Skip - unplaced aircraft aren't trapped (no position yet)
        }
        trapCountsPerLane.push(trappedCountForLane);
    }
    const maskResult = Math.min(...trapCountsPerLane);
    // VALIDATION MODE: Compare with loop-based approach
    if (validate) {
        const loopResult = $f6569233d9b1357b$export$29cde8d6c36fe423(candidateAircraft, candidateSpot, placement, allAircraft, allSpots);
        const matched = maskResult === loopResult;
        if (!matched) console.warn(`[Phase 9 Validation] Mismatch detected for ${candidateAircraft.tail_number} at ${candidateSpot.id}:`, `mask=${maskResult}, loop=${loopResult}`);
        return {
            count: maskResult,
            maskDebug: {
                usedMasks: true,
                maskResult: maskResult,
                loopResult: loopResult,
                matched: matched
            }
        };
    }
    // Normal mode: just return mask result
    return {
        count: maskResult,
        maskDebug: {
            usedMasks: true,
            maskResult: maskResult
        }
    };
}

});
parcelRegister("6moNe", function(module, exports) {

$parcel$export(module.exports, "isSpotEnabled", () => $654e14227e87883e$export$b3077b8952a406c6);
$parcel$export(module.exports, "isSizeCompatible", () => $654e14227e87883e$export$3f1151552782feb2);
$parcel$export(module.exports, "isTimeAvailable", () => $654e14227e87883e$export$4bd9dbcb34d1913);
$parcel$export(module.exports, "isDurationValid", () => $654e14227e87883e$export$4bba44c8fcc0fa);
$parcel$export(module.exports, "hasGeometryCollision", () => $654e14227e87883e$export$777f7541e142b29a);
$parcel$export(module.exports, "getAvailableSpots", () => $654e14227e87883e$export$ed60d4c55bf90f51);
$parcel$export(module.exports, "getAvailableSpotsWithBreakdown", () => $654e14227e87883e$export$fc2866e031bab53a);
/**
 * Spot Filtering Module
 * Consolidates all spot filtering logic for the temporal parking algorithm
 *
 * Filters are applied in order:
 * 1. Size compatibility (aircraft fits in spot)
 * 2. Time availability (no scheduling conflict)
 * 3. Geometry collision (gap spots only - Phase 3)
 */ 
var $elGuA = parcelRequire("elGuA");

var $77E3s = parcelRequire("77E3s");

var $kbn5z = parcelRequire("kbn5z");
function $654e14227e87883e$export$b3077b8952a406c6(spot, zones) {
    // Check if spot is directly disabled
    if (spot.disabled === true) return false;
    // Check if spot's zone is disabled
    const zone = zones.find((z)=>z.id === spot.zoneId);
    if (zone && zone.disabled === true) return false;
    // Spot is enabled (or zone not found - fail safe to enabled)
    return true;
}
function $654e14227e87883e$export$3f1151552782feb2(spot, aircraft) {
    return spot.allowedSizes.includes(aircraft.sizeCategory);
}
function $654e14227e87883e$export$4bd9dbcb34d1913(spot, dwellMask) {
    return !(0, $elGuA.intersects)(spot.occupancy, dwellMask);
}
function $654e14227e87883e$export$4bba44c8fcc0fa(spot, aircraft) {
    // No limit set - spot accepts any duration
    if (!spot.max_dwell_minutes) return true;
    // Calculate aircraft dwell duration in minutes
    const dwellBuckets = aircraft.departureBucket - aircraft.arrivalBucket;
    const dwellMinutes = dwellBuckets * 15; // 15 minutes per bucket
    // Check if within limit
    return dwellMinutes <= spot.max_dwell_minutes;
}
function $654e14227e87883e$export$777f7541e142b29a(spot, aircraft, currentPlacement, placedAircraftPolygons) {
    // Only check gap spots
    if (!spot.isGapSpot) return false;
    // Phase 2d: Check if all required spots are occupied
    if (spot.requiresOccupiedSpots && spot.requiresOccupiedSpots.length > 0) {
        const allOccupied = spot.requiresOccupiedSpots.every((requiredSpotId)=>{
            // Check if any aircraft is placed in this required spot
            return Object.values(currentPlacement).some((placementData)=>{
                if ("spotId" in placementData) return placementData.spotId === requiredSpotId;
                return false; // Skip segmented placements
            });
        });
        if (!allOccupied) return true; // Not all dependencies met - treat as collision/unavailable
    }
    // Phase 3: Geometry collision check
    // TODO: This uses size-based approximations. Replace with real aircraft geometry when available.
    if (!placedAircraftPolygons) return false; // No geometry data available - skip check
    // No null check needed - shape is required
    // Check each placed aircraft polygon
    for (const [aircraftId, aircraftPolygon] of placedAircraftPolygons){
        // Check if this aircraft is in one of the required spots
        const placementData = currentPlacement[aircraftId];
        if (!placementData || !("spotId" in placementData)) continue;
        const isInRequiredSpot = spot.requiresOccupiedSpots?.includes(placementData.spotId);
        if (!isInRequiredSpot) continue;
        // Check collision between aircraft polygon and gap spot polygon
        if ((0, $77E3s.polygonsIntersect)(aircraftPolygon, spot.shape.points)) return true; // COLLISION! Parked aircraft overlaps gap spot
    }
    // No collision detected - gap spot is clear
    return false;
}
function $654e14227e87883e$export$ed60d4c55bf90f51(spots, aircraft, dwellMask, currentPlacement, placedAircraftPolygons, shapes, zones = []) {
    return spots.filter((spot)=>{
        // Filter 0: Enabled status (spot and zone not disabled)
        if (!$654e14227e87883e$export$b3077b8952a406c6(spot, zones)) return false;
        // Filter 1: Size compatibility
        if (!$654e14227e87883e$export$3f1151552782feb2(spot, aircraft)) return false;
        // Filter 2: Time availability
        if (!$654e14227e87883e$export$4bd9dbcb34d1913(spot, dwellMask)) return false;
        // Filter 3: Duration limit
        if (!$654e14227e87883e$export$4bba44c8fcc0fa(spot, aircraft)) return false;
        // Filter 4: Geometry collision (gap spots only - Phase 3)
        if ($654e14227e87883e$export$777f7541e142b29a(spot, aircraft, currentPlacement, placedAircraftPolygons)) return false;
        return true;
    });
}
function $654e14227e87883e$export$fc2866e031bab53a(spots, aircraft, dwellMask, currentPlacement, placedAircraftPolygons, // shapes parameter REMOVED - use spot.shape instead
zones = []) {
    const breakdown = {
        total: spots.length,
        disabled: 0,
        stagingIncompatible: 0,
        sizeIncompatible: 0,
        timeConflict: 0,
        durationExceeded: 0,
        geometryCollision: 0,
        available: 0
    };
    let remainingSpots = spots;
    // Filter 0: Enabled status
    const enabledSpots = remainingSpots.filter((spot)=>$654e14227e87883e$export$b3077b8952a406c6(spot, zones));
    breakdown.disabled = remainingSpots.length - enabledSpots.length;
    remainingSpots = enabledSpots;
    // Filter 1: Staging zone compatibility
    // Staging segments MUST use staging zones, permanent segments MUST NOT use staging zones
    const stagingCompatibleSpots = remainingSpots.filter((spot)=>{
        const isStaging = (0, $kbn5z.isSpotInStagingZone)(spot);
        if (aircraft.isStagingSegment) return isStaging; // Staging segment requires staging zone
        else return !isStaging; // Permanent segment cannot use staging zone
    });
    breakdown.stagingIncompatible = remainingSpots.length - stagingCompatibleSpots.length;
    remainingSpots = stagingCompatibleSpots;
    // Filter 2: Size compatibility
    const sizeCompatibleSpots = remainingSpots.filter((spot)=>$654e14227e87883e$export$3f1151552782feb2(spot, aircraft));
    breakdown.sizeIncompatible = remainingSpots.length - sizeCompatibleSpots.length;
    remainingSpots = sizeCompatibleSpots;
    // Filter 3: Time availability
    const timeAvailableSpots = remainingSpots.filter((spot)=>$654e14227e87883e$export$4bd9dbcb34d1913(spot, dwellMask));
    breakdown.timeConflict = remainingSpots.length - timeAvailableSpots.length;
    remainingSpots = timeAvailableSpots;
    // Filter 4: Duration limit
    const durationValidSpots = remainingSpots.filter((spot)=>$654e14227e87883e$export$4bba44c8fcc0fa(spot, aircraft));
    breakdown.durationExceeded = remainingSpots.length - durationValidSpots.length;
    remainingSpots = durationValidSpots;
    // Filter 5: Geometry collision (gap spots only - Phase 3)
    const availableSpots = remainingSpots.filter((spot)=>{
        return !$654e14227e87883e$export$777f7541e142b29a(spot, aircraft, currentPlacement, placedAircraftPolygons);
    });
    breakdown.geometryCollision = remainingSpots.length - availableSpots.length;
    breakdown.available = availableSpots.length;
    return {
        availableSpots: availableSpots,
        breakdown: breakdown
    };
}

});
parcelRegister("77E3s", function(module, exports) {

$parcel$export(module.exports, "createAircraftFootprint", () => $89edc73c3ef09ff2$export$b33ab08a1f2cf101);
$parcel$export(module.exports, "getCentroid", () => $89edc73c3ef09ff2$export$836ff99bad0a09da);
$parcel$export(module.exports, "polygonsIntersect", () => $89edc73c3ef09ff2$export$4d52d1ebaf6857b4);
/**
 * Geometry Utilities for Gap Spot Collision Detection (Phase 3)
 *
 * Provides functions for creating approximate aircraft footprints and checking
 * polygon intersections to determine if gap spots are clear.
 */ /**
 * Standard aircraft dimensions by size category (in feet)
 * Based on typical aircraft in each category
 *
 * Used as fallback when ParkingRequest.aircraft field is not populated
 * (e.g., in tests or when real aircraft data is unavailable)
 */ const $89edc73c3ef09ff2$var$AIRCRAFT_DIMENSIONS = {
    "very-small": {
        wingspan: 40,
        length: 35
    },
    // Cessna 172, Piper PA-28
    "small": {
        wingspan: 55,
        length: 50
    },
    // Citation, Phenom 300
    "midsize": {
        wingspan: 68,
        length: 62
    },
    // Challenger 604, Falcon 900
    "super-midsize": {
        wingspan: 90,
        length: 80
    },
    // Falcon 7X, G500
    "large": {
        wingspan: 115,
        length: 100
    },
    // Global 7500, G700
    "enormous": {
        wingspan: 150,
        length: 135
    } // BBJ 787, ACJ series
};
function $89edc73c3ef09ff2$export$b33ab08a1f2cf101(request, spotShape, orientationId) {
    // Use real aircraft dimensions if available, otherwise fall back to size category
    const dimensions = request.aircraft ? {
        wingspan: request.aircraft.wingspan,
        length: request.aircraft.length
    } : $89edc73c3ef09ff2$var$AIRCRAFT_DIMENSIONS[request.sizeCategory];
    const center = $89edc73c3ef09ff2$export$836ff99bad0a09da(spotShape.points);
    const angleRad = $89edc73c3ef09ff2$export$105317be260bcbd4(orientationId);
    // Create rectangle centered at origin
    const halfWidth = dimensions.wingspan / 2;
    const halfLength = dimensions.length / 2;
    const rect = [
        {
            x: -halfWidth,
            y: -halfLength
        },
        // Bottom-left
        {
            x: halfWidth,
            y: -halfLength
        },
        // Bottom-right
        {
            x: halfWidth,
            y: halfLength
        },
        // Top-right
        {
            x: -halfWidth,
            y: halfLength
        } // Top-left
    ];
    // Rotate and translate to spot position
    // 2D rotation matrix: [cos -sin; sin cos]
    return rect.map((p)=>({
            x: center.x + (p.x * Math.cos(angleRad) - p.y * Math.sin(angleRad)),
            y: center.y + (p.x * Math.sin(angleRad) + p.y * Math.cos(angleRad))
        }));
}
function $89edc73c3ef09ff2$export$836ff99bad0a09da(points) {
    if (points.length === 0) return {
        x: 0,
        y: 0
    };
    const sumX = points.reduce((sum, p)=>sum + p.x, 0);
    const sumY = points.reduce((sum, p)=>sum + p.y, 0);
    return {
        x: sumX / points.length,
        y: sumY / points.length
    };
}
function $89edc73c3ef09ff2$export$105317be260bcbd4(orientationId) {
    // Parse cardinal directions from orientation ID
    if (orientationId.includes("north")) return 0;
    if (orientationId.includes("east")) return Math.PI / 2;
    if (orientationId.includes("south")) return Math.PI;
    if (orientationId.includes("west")) return 3 * Math.PI / 2;
    // Default to north (0 radians) for unknown orientations
    return 0;
}
function $89edc73c3ef09ff2$export$895c5e634403eaa7(points) {
    if (points.length === 0) return {
        minX: 0,
        maxX: 0,
        minY: 0,
        maxY: 0
    };
    const xs = points.map((p)=>p.x);
    const ys = points.map((p)=>p.y);
    return {
        minX: Math.min(...xs),
        maxX: Math.max(...xs),
        minY: Math.min(...ys),
        maxY: Math.max(...ys)
    };
}
function $89edc73c3ef09ff2$export$1e1136aa0bcf4995(b1, b2) {
    // Boxes do NOT intersect if separated on any axis
    return !(b1.maxX < b2.minX || b1.minX > b2.maxX || b1.maxY < b2.minY || b1.minY > b2.maxY);
}
function $89edc73c3ef09ff2$export$4d52d1ebaf6857b4(poly1, poly2) {
    // Fast bounding box check
    const bounds1 = $89edc73c3ef09ff2$export$895c5e634403eaa7(poly1);
    const bounds2 = $89edc73c3ef09ff2$export$895c5e634403eaa7(poly2);
    return $89edc73c3ef09ff2$export$1e1136aa0bcf4995(bounds1, bounds2);
// TODO: For higher accuracy, implement full polygon intersection:
// - Use library like 'polygon-clipping' or 'polybooljs'
// - Or implement SAT (Separating Axis Theorem)
// - Or implement GJK algorithm
}

});

parcelRegister("kbn5z", function(module, exports) {

$parcel$export(module.exports, "isSpotInStagingZone", () => $34a3bc4bf546d8d6$export$6aa364604b65748f);
$parcel$export(module.exports, "shouldUseStaging", () => $34a3bc4bf546d8d6$export$dc4d046c26fe1146);
/**
 * Staging Area Feature - Helper Functions (Phase 3)
 *
 * Provides core functionality for staging area workflow where aircraft are
 * temporarily placed in staging zones for servicing operations before/after
 * their permanent parking spots.
 *
 * Typical workflow:
 * 1. Aircraft lands → Staging area (30-60 min for unloading/servicing)
 * 2. Staging → Permanent spot (main dwell time)
 * 3. Permanent → Staging area (30-60 min for departure prep)
 * 4. Staging → Takeoff
 */ 
var $h3XF9 = parcelRequire("h3XF9");
function $34a3bc4bf546d8d6$export$6aa364604b65748f(spot) {
    return spot.shape?.metadata?.is_staging === true;
}
function $34a3bc4bf546d8d6$export$dc4d046c26fe1146(request, enableArrivalStaging, enableDepartureStaging, quickTurnThresholdMinutes, arrivalStagingDwellMinutes, departureStagingDwellMinutes) {
    // Calculate dwell time in minutes
    const dwellBuckets = request.departureBucket - request.arrivalBucket;
    const dwellMinutes = dwellBuckets * (0, $h3XF9.MINUTES_PER_BUCKET);
    // Quick turn bypass - below threshold
    if (dwellMinutes <= quickTurnThresholdMinutes) return {
        useArrival: false,
        useDeparture: false
    };
    // Calculate minimum required time based on enabled staging
    const requiredMinutes = (enableArrivalStaging ? arrivalStagingDwellMinutes : 0) + (enableDepartureStaging ? departureStagingDwellMinutes : 0);
    // Insufficient dwell time for requested staging
    if (dwellMinutes < requiredMinutes) return {
        useArrival: false,
        useDeparture: false
    };
    // Return configuration based on enabled flags
    return {
        useArrival: enableArrivalStaging,
        useDeparture: enableDepartureStaging
    };
}
function $34a3bc4bf546d8d6$export$99f6408b0b4b45d6(request, stagingDwellBuckets) {
    const { arrivalBucket: arrivalBucket, departureBucket: departureBucket } = request;
    // Validate sufficient dwell time for 2× staging periods
    const totalBuckets = departureBucket - arrivalBucket;
    const requiredBuckets = stagingDwellBuckets * 2;
    if (totalBuckets < requiredBuckets) {
        const totalMinutes = totalBuckets * (0, $h3XF9.MINUTES_PER_BUCKET);
        const requiredMinutes = requiredBuckets * (0, $h3XF9.MINUTES_PER_BUCKET);
        throw new Error(`Insufficient dwell time for staging workflow: aircraft ${request.tail_number} ` + `has ${totalMinutes} min available, but ${requiredMinutes} min required ` + `(2\xd7 ${stagingDwellBuckets * (0, $h3XF9.MINUTES_PER_BUCKET)} min staging periods). ` + `This should have been caught by shouldUseStaging().`);
    }
    // Segment 1: Arrival staging
    const arrivalStagingEnd = arrivalBucket + stagingDwellBuckets;
    // Segment 2: Permanent spot (middle)
    const permanentStart = arrivalStagingEnd;
    const permanentEnd = departureBucket - stagingDwellBuckets;
    // Segment 3: Departure staging
    const departureStagingStart = permanentEnd;
    return [
        // Arrival staging segment
        {
            ...request,
            arrivalBucket: arrivalBucket,
            departureBucket: arrivalStagingEnd,
            isStagingSegment: true
        },
        // Permanent segment (no staging flag)
        {
            ...request,
            arrivalBucket: permanentStart,
            departureBucket: permanentEnd,
            isStagingSegment: undefined // Explicit undefined for clarity
        },
        // Departure staging segment
        {
            ...request,
            arrivalBucket: departureStagingStart,
            departureBucket: departureBucket,
            isStagingSegment: true
        }
    ];
}

});



parcelRegister("ad1qL", function(module, exports) {

$parcel$export(module.exports, "precomputeAllEgressMasks", () => $90d22a78fc433da7$export$f329871eb3a10051);
/**
 * Egress Masks - Precomputed Time-Based Blocking Detection
 * Step 2 Optimization: Convert O(n²) trap detection to O(1) bitmap operations
 *
 * WHY: Current approach loops through all aircraft for each placement check.
 * With masks, we precompute departure time windows once and use fast bitmap operations.
 *
 * TRADE-OFF: Memory (store bitmaps) for speed (bitmap AND vs loops)
 *
 * STATUS: Masks are computed and available but NOT YET used in algorithm.
 * The algorithm still uses dynamic wouldBlock() checks (correct but slower).
 * Future optimization: Replace countTrappedAircraft() with isBlockedByEgressMask()
 * in parkingAlgorithm.ts for O(1) filtering.
 */ 
var $elGuA = parcelRequire("elGuA");
function $90d22a78fc433da7$export$6ebdb3b8fdaebe5e(aircraft, towBufferMinutes = 0) {
    const mask = (0, $elGuA.makeEmptyMask)();
    // Convert tow buffer from minutes to buckets (15-min intervals)
    const towBufferBuckets = Math.floor(towBufferMinutes / 15);
    // Set bits from departure bucket through tow buffer
    // Clamp end to TOTAL_SLOTS-1 to avoid overflow
    const startBucket = aircraft.departureBucket;
    const endBucket = Math.min(aircraft.departureBucket + towBufferBuckets, (0, $elGuA.TOTAL_SLOTS) - 1);
    (0, $elGuA.setRange)(mask, startBucket, endBucket);
    return mask;
}
function $90d22a78fc433da7$export$a92aa1b96c31b385(spot, allSpots, placement, allAircraft, towBufferMinutes = 0) {
    const egressOptions = spot.egressOptions || [];
    if (egressOptions.length === 0) // No egress options = no masks needed
    return {
        perLane: []
    };
    // Compute masks for each lane
    return {
        perLane: egressOptions.map((option)=>{
            const blocksMask = (0, $elGuA.makeEmptyMask)();
            const blockedByMask = (0, $elGuA.makeEmptyMask)();
            // PART 1: Compute "blocks" mask for this lane
            // (when THIS spot blocks others via this lane)
            // Find all aircraft currently placed at this spot
            for(const aircraftId in placement){
                const placementInfo = placement[aircraftId];
                // Check if aircraft is at this spot
                let isAtThisSpot = false;
                if ("segments" in placementInfo) // Segmented placement: check if any segment uses this spot
                isAtThisSpot = placementInfo.segments.some((seg)=>seg.spotId === spot.id);
                else // Simple placement: check if spotId matches
                isAtThisSpot = placementInfo.spotId === spot.id;
                if (!isAtThisSpot) continue;
                // Find the aircraft object
                const aircraft = allAircraft.find((ac)=>ac.id === aircraftId);
                if (!aircraft) continue;
                // Compute departure mask and OR into blocks mask
                const departureMask = $90d22a78fc433da7$export$6ebdb3b8fdaebe5e(aircraft, towBufferMinutes);
                (0, $elGuA.orInto)(blocksMask, departureMask);
            }
            // PART 2: Compute "blockedBy" mask for this lane
            // (when THIS lane is blocked by others)
            // Find all spots that block THIS spot via THIS lane
            for (const otherSpot of allSpots){
                const otherEgressOptions = otherSpot.egressOptions || [];
                // Check if any of otherSpot's lanes block us
                const blocksUs = otherEgressOptions.some((opt)=>opt.blocksSpotIds.includes(spot.id));
                if (!blocksUs) continue;
                // Find all aircraft at the blocking spot
                for(const aircraftId in placement){
                    const placementInfo = placement[aircraftId];
                    // Check if aircraft is at blocking spot
                    let isAtBlockingSpot = false;
                    if ("segments" in placementInfo) isAtBlockingSpot = placementInfo.segments.some((seg)=>seg.spotId === otherSpot.id);
                    else isAtBlockingSpot = placementInfo.spotId === otherSpot.id;
                    if (!isAtBlockingSpot) continue;
                    // Find the aircraft object
                    const aircraft = allAircraft.find((ac)=>ac.id === aircraftId);
                    if (!aircraft) continue;
                    // Compute departure mask and OR into blockedBy mask
                    const departureMask = $90d22a78fc433da7$export$6ebdb3b8fdaebe5e(aircraft, towBufferMinutes);
                    (0, $elGuA.orInto)(blockedByMask, departureMask);
                }
            }
            return {
                laneId: option.laneId,
                blocksSpotIds: option.blocksSpotIds,
                blocks: blocksMask,
                blockedBy: blockedByMask
            };
        })
    };
}
function $90d22a78fc433da7$export$85e7647ab87e4c00(spot, dwellMask) {
    // If no egress masks computed, assume not blocked
    // WHY: Spot might not have masks yet, or blocking detection disabled
    if (!spot.egressMasks || spot.egressMasks.perLane.length === 0) return false;
    // Check if ALL lanes are blocked
    // WHY: If ANY lane is clear, aircraft can use that lane (return false)
    // Only return true if ALL lanes blocked (no escape route)
    return spot.egressMasks.perLane.every((laneMask)=>(0, $elGuA.intersects)(dwellMask, laneMask.blockedBy));
}
function $90d22a78fc433da7$export$f329871eb3a10051(spots, placement, aircraft, towBufferMinutes = 0) {
    for (const spot of spots)spot.egressMasks = $90d22a78fc433da7$export$a92aa1b96c31b385(spot, spots, placement, aircraft, towBufferMinutes);
}

});

parcelRegister("8mB0X", function(module, exports) {

$parcel$export(module.exports, "findSpotChainWithLocks", () => $79111461dcae07fb$export$feeeedb76827f4c9);
/**
 * Lock-Aware Segmentation
 * Phase 3: Find spot chains for aircraft with temporal lock constraints
 *
 * This module extends the normal segmentation logic to handle aircraft with
 * time-bounded spot locks (hard constraints). Locked segments MUST use the
 * specified spot, while non-locked segments use greedy optimization.
 */ 
var $elGuA = parcelRequire("elGuA");

var $bZWsU = parcelRequire("bZWsU");

var $6moNe = parcelRequire("6moNe");

var $8L6tD = parcelRequire("8L6tD");
function $79111461dcae07fb$export$feeeedb76827f4c9(request, spots, plannedMoveCap, bufferMinutes, horizonHours, _egressWeight = 1.0, wasteWeight = 1.0) {
    console.log(`[findSpotChainWithLocks] Request ${request.tail_number}, locks: ${request.locks?.length || 0}`);
    // Split dwell by lock boundaries
    const timeSegments = (0, $bZWsU.splitDwellByLocks)(request, bufferMinutes);
    console.log(`[findSpotChainWithLocks] Time segments: ${timeSegments.length}`, JSON.stringify(timeSegments.map((s)=>({
            start: s.start,
            end: s.end,
            locked: s.lockedSpotId || "none"
        }))));
    const chain = [];
    // Process each time segment
    for (const segment of timeSegments)if (segment.lockedSpotId) {
        // ===== LOCKED SEGMENT =====
        // Must use specified spot (hard constraint)
        const spot = spots.find((s)=>s.id === segment.lockedSpotId);
        const lock = request.locks.find((l)=>l.spotId === segment.lockedSpotId);
        if (!spot || !lock) {
            console.warn(`[findSpotChainWithLocks] Lock validation failed: spot ${segment.lockedSpotId} not found`);
            return {
                success: false,
                failure: {
                    failureType: "lock_validation",
                    failedLock: lock,
                    validationReason: `Spot ${segment.lockedSpotId} not found`
                }
            };
        }
        // Validate lock (size + availability)
        const validation = (0, $bZWsU.validateLock)(lock, request, spots, horizonHours);
        if (!validation.valid) {
            console.warn(`[findSpotChainWithLocks] Lock validation failed: ${validation.reason}`);
            return {
                success: false,
                failure: {
                    failureType: "lock_validation",
                    failedLock: lock,
                    validationReason: validation.reason
                }
            };
        }
        // Add locked segment
        chain.push({
            spotId: spot.id,
            orientationId: spot.orientations[0].id,
            startBucket: segment.start,
            endBucket: segment.end
        });
        console.log(`[findSpotChainWithLocks] Locked segment: ${spot.id} [${segment.start}, ${segment.end})`);
    } else {
        // ===== NON-LOCKED SEGMENT =====
        // Use greedy optimization (same logic as normal placement)
        // Create temporary request for this segment
        const segmentRequest = {
            ...request,
            arrivalBucket: segment.start,
            departureBucket: segment.end
        };
        // Create mask for segment (no buffer - already applied in split)
        const segmentMask = (0, $elGuA.dwellMask)(segmentRequest, 0, horizonHours);
        // Get available spots for this segment
        const availableSpots = (0, $6moNe.getAvailableSpots)(spots, segmentRequest, segmentMask, {}, // Empty placement (segments are independent)
        undefined, undefined);
        if (availableSpots.length === 0) {
            console.warn(`[findSpotChainWithLocks] No available spots for non-locked segment [${segment.start}, ${segment.end})`);
            return {
                success: false,
                failure: {
                    failureType: "no_spots",
                    validationReason: `No available spots for non-locked segment [${segment.start}, ${segment.end})`
                }
            };
        }
        // Score spots (waste only - egress scoring would require final placement context)
        // In a real implementation, you might want to defer egress scoring until all segments are known
        const scoredSpots = availableSpots.map((spot)=>{
            const wasteScore = (0, $8L6tD.calculateSpotWaste)(segmentRequest, spot);
            const score = wasteScore * wasteWeight;
            return {
                spot: spot,
                score: score
            };
        });
        // Pick best spot (lowest score)
        scoredSpots.sort((a, b)=>a.score - b.score);
        const bestSpot = scoredSpots[0].spot;
        // Add non-locked segment
        chain.push({
            spotId: bestSpot.id,
            orientationId: bestSpot.orientations[0].id,
            startBucket: segment.start,
            endBucket: segment.end
        });
        console.log(`[findSpotChainWithLocks] Non-locked segment: ${bestSpot.id} [${segment.start}, ${segment.end}) (waste=${scoredSpots[0].score})`);
    }
    // Count ACTUAL moves = spot changes, not segment boundaries
    // Example: [A1, A1, A1] = 0 moves, [A1, B2, A1] = 2 moves
    let actualMoves = 0;
    for(let i = 1; i < chain.length; i++)if (chain[i].spotId !== chain[i - 1].spotId) actualMoves++;
    if (actualMoves > plannedMoveCap) {
        console.warn(`[findSpotChainWithLocks] Move count ${actualMoves} exceeds cap ${plannedMoveCap}`);
        return {
            success: false,
            failure: {
                failureType: "move_cap",
                requiredMoves: actualMoves,
                moveCap: plannedMoveCap,
                validationReason: `Requires ${actualMoves} moves, exceeds cap of ${plannedMoveCap}`
            }
        };
    }
    console.log(`[findSpotChainWithLocks] Success: ${chain.length} segments, ${actualMoves} moves`);
    return {
        success: true,
        chain: {
            segments: chain,
            moveCount: actualMoves
        }
    };
}

});
parcelRegister("bZWsU", function(module, exports) {

$parcel$export(module.exports, "validateLock", () => $43b9391e8767af63$export$eb48ff0dcf710e63);
$parcel$export(module.exports, "splitDwellByLocks", () => $43b9391e8767af63$export$d0dfa3b52b6b475d);
/**
 * Lock Validation Utilities
 * Phase 2: Validate temporal locks and split dwell by lock boundaries
 */ 
var $elGuA = parcelRequire("elGuA");
function $43b9391e8767af63$export$eb48ff0dcf710e63(lock, request, spots, horizonHours) {
    // Check 1: Spot exists
    const spot = spots.find((s)=>s.id === lock.spotId);
    if (!spot) return {
        valid: false,
        reason: `Lock spot ${lock.spotId} not found`
    };
    // Check 2: Size compatibility
    if (!spot.allowedSizes.includes(request.sizeCategory)) return {
        valid: false,
        reason: `Lock spot ${lock.spotId} does not allow ${request.sizeCategory} aircraft`
    };
    // Check 3: Time availability
    // Create mask for lock period and check against spot occupancy
    const totalSlots = (0, $elGuA.calculateTotalSlots)(horizonHours);
    const WORD_COUNT = (0, $elGuA.calculateWordCount)(totalSlots);
    const lockMask = new BigUint64Array(WORD_COUNT);
    // Set bits for lock period
    for(let bucket = lock.startBucket; bucket < lock.endBucket; bucket++){
        const wordIdx = Math.floor(bucket / 64);
        const bitIdx = BigInt(bucket % 64);
        if (wordIdx < WORD_COUNT) lockMask[wordIdx] |= 1n << bitIdx;
    }
    if ((0, $elGuA.intersects)(spot.occupancy, lockMask)) return {
        valid: false,
        reason: `Lock spot ${lock.spotId} is occupied during lock period [${lock.startBucket}, ${lock.endBucket})`
    };
    return {
        valid: true
    };
}
function $43b9391e8767af63$export$d0dfa3b52b6b475d(request, bufferMinutes) {
    const bufferBuckets = Math.ceil(bufferMinutes / 15);
    const dwellStart = Math.max(0, request.arrivalBucket - bufferBuckets);
    const dwellEnd = request.departureBucket + bufferBuckets;
    // No locks → single segment covering full dwell
    if (!request.locks || request.locks.length === 0) return [
        {
            start: dwellStart,
            end: dwellEnd
        }
    ];
    // Sort locks chronologically
    const sortedLocks = [
        ...request.locks
    ].sort((a, b)=>a.startBucket - b.startBucket);
    const segments = [];
    let cursor = dwellStart;
    for (const lock of sortedLocks){
        // Add non-locked segment before this lock (if gap exists)
        if (cursor < lock.startBucket) segments.push({
            start: cursor,
            end: lock.startBucket,
            lockedSpotId: undefined
        });
        // Add locked segment
        segments.push({
            start: lock.startBucket,
            end: lock.endBucket,
            lockedSpotId: lock.spotId
        });
        cursor = lock.endBucket;
    }
    // Add final non-locked segment after last lock (if remaining time)
    if (cursor < dwellEnd) segments.push({
        start: cursor,
        end: dwellEnd,
        lockedSpotId: undefined
    });
    return segments;
}

});

parcelRegister("8L6tD", function(module, exports) {

$parcel$export(module.exports, "calculateSpotWaste", () => $c6fccd0ec42f2a72$export$be8802b5dc1aab82);
$parcel$export(module.exports, "calculateStructuralComplexity", () => $c6fccd0ec42f2a72$export$f0fe5a6c96fcc249);
const $c6fccd0ec42f2a72$export$fde17e203f3a1953 = [
    "very-small",
    "small",
    "midsize",
    "super-midsize",
    "large"
];
function $c6fccd0ec42f2a72$export$be8802b5dc1aab82(aircraft, spot) {
    // Get aircraft size index (0-4)
    const aircraftSizeIndex = $c6fccd0ec42f2a72$export$fde17e203f3a1953.indexOf(aircraft.sizeCategory);
    // Get spot's maximum allowed size index (0-4)
    // Example: allowedSizes=["small", "large"] → max index is 4 (large)
    const spotMaxSizeIndex = Math.max(...spot.allowedSizes.map((s)=>$c6fccd0ec42f2a72$export$fde17e203f3a1953.indexOf(s)));
    // Waste = how many size categories larger the spot is
    // If spot is smaller than aircraft (shouldn't happen due to size filtering), return 0
    // Example: Citation (index 1) in large spot (index 4) → 4 - 1 = 3 waste
    return Math.max(0, spotMaxSizeIndex - aircraftSizeIndex);
}
function $c6fccd0ec42f2a72$export$1861110af7ba7830(waste) {
    if (waste === 0) return "Perfect fit";
    if (waste === 1) return "1 size too large";
    return `${waste} sizes too large`;
}
function $c6fccd0ec42f2a72$export$f0fe5a6c96fcc249(spot) {
    // No egress options = no blocking = no complexity
    if (!spot.egressOptions || spot.egressOptions.length === 0) return 0;
    // Find the lane with minimum blocked spots
    // WHY: Aircraft will choose best available lane at departure, so we penalize
    //      based on the best-case scenario (not worst-case)
    const minBlockedSpots = Math.min(...spot.egressOptions.map((opt)=>opt.blocksSpotIds.length));
    return minBlockedSpots;
}

});


parcelRegister("hddnH", function(module, exports) {

$parcel$export(module.exports, "findSpotChain", () => $3c01328095029a41$export$7c5f8d39406989b0);
$parcel$export(module.exports, "applySpotChain", () => $3c01328095029a41$export$c0153321e6b1e5fb);
/**
 * Segmented Dwell Handling
 *
 * Finds optimal spot chains when no single spot can accommodate an aircraft's full dwell.
 * This enables the temporal parking algorithm to place aircraft across multiple spots with
 * planned moves between them during the dwell period.
 *
 * KEY BEHAVIORS:
 *
 * 1. GREEDY WINDOW SELECTION
 *    Always picks the spot with the longest available window from the current bucket position.
 *    This naturally prefers single-spot placements when possible, only creating multi-spot
 *    splits when genuinely required by capacity constraints.
 *
 * 2. SKIP-AHEAD LOGIC
 *    If no spot is available at the aircraft's arrival time (all spots occupied), the algorithm
 *    can "skip ahead" to the first available window, creating a delayed/partial placement.
 *    This is indicated by the first segment starting after the aircraft's actual arrival.
 *
 * 3. REAL-WORLD USE CASES
 *    Multi-spot splits are most valuable in production scenarios with:
 *    - Immovable aircraft already on ramp (pre-existing occupancy constraints)
 *    - Spot restrictions/priorities (certain aircraft limited to certain zones)
 *    - Peak capacity periods (arrival clustering during busy times)
 *    - Long planning horizons (multi-day scheduling with complex overlaps)
 *
 * 4. TESTING CHALLENGES
 *    In "clean" test scenarios with empty initial states, the greedy algorithm typically finds
 *    single-spot solutions because it has maximum flexibility. This doesn't mean the feature is
 *    broken - it means the algorithm is working efficiently. True multi-spot splits naturally
 *    emerge from real-world constraints, not artificial test cases.
 */ 
var $elGuA = parcelRequire("elGuA");
function $3c01328095029a41$export$7c5f8d39406989b0(request, spots, plannedMoveCap, bufferMinutes = 0, horizonHours = 24) {
    const bufferBuckets = Math.ceil(bufferMinutes / 15);
    const dwellStart = Math.max(0, request.arrivalBucket - bufferBuckets);
    const totalSlots = horizonHours * 4;
    const dwellEnd = Math.min(totalSlots, request.departureBucket + bufferBuckets);
    console.log(`[findSpotChain] Request ${request.tail_number} needs coverage ${dwellStart}-${dwellEnd}, plannedMoveCap=${plannedMoveCap}`);
    // Greedy chain building: iteratively pick the spot with longest coverage from current position
    const segments = [];
    let currentBucket = dwellStart;
    while(currentBucket < dwellEnd){
        // STEP 1: Find the spot with the longest available window covering currentBucket
        let bestSpot = null;
        let bestWindow = null;
        let maxCoverage = 0;
        for (const spot of spots){
            // Find all available windows in this spot's occupancy bitmap
            // We search the full range [dwellStart, dwellEnd) to see all gaps
            const windows = (0, $elGuA.findAvailableWindows)(spot.occupancy, dwellStart, dwellEnd);
            console.log(`[findSpotChain]   Spot ${spot.id} windows from ${dwellStart}:`, JSON.stringify(windows));
            // Check each window to see if it covers our current position
            for (const [start, end] of windows)// Window must overlap currentBucket (start <= currentBucket < end)
            // This includes windows that:
            // - Start before currentBucket (continuing from previous segment)
            // - Start exactly at currentBucket (ideal handoff)
            if (start <= currentBucket && end > currentBucket) {
                // Greedy: pick the window with maximum coverage from currentBucket forward
                const coverage = end - currentBucket;
                if (coverage > maxCoverage) {
                    maxCoverage = coverage;
                    bestSpot = spot;
                    bestWindow = [
                        start,
                        end
                    ];
                }
            }
        }
        // STEP 2: Handle case where no spot available at currentBucket
        if (!bestSpot || !bestWindow) {
            // SKIP-AHEAD LOGIC: Only allowed for the first segment (delayed arrival)
            // This creates a partial placement where the aircraft parks later than requested
            if (segments.length === 0) {
                console.log(`[findSpotChain]   No spot at bucket ${currentBucket}, searching for earliest available window...`);
                // Find the earliest window that starts AFTER currentBucket
                let earliestStart = Infinity;
                for (const spot of spots){
                    const windows = (0, $elGuA.findAvailableWindows)(spot.occupancy, dwellStart, dwellEnd);
                    for (const [start, end] of windows)if (start > currentBucket && start < earliestStart) {
                        earliestStart = start;
                        bestSpot = spot;
                        bestWindow = [
                            start,
                            end
                        ];
                        maxCoverage = end - start;
                    }
                }
                if (bestSpot && bestWindow) {
                    console.log(`[findSpotChain]   Skipping ahead to bucket ${earliestStart}, using ${bestSpot.id}`);
                    currentBucket = earliestStart; // Jump forward to first availability
                } else {
                    console.log(`[findSpotChain]   No future windows available - chain impossible`);
                    return null;
                }
            } else {
                // Mid-chain gap: cannot skip ahead after first segment (would create disconnect)
                console.log(`[findSpotChain]   No spot available at bucket ${currentBucket} - chain impossible`);
                return null;
            }
        }
        console.log(`[findSpotChain]   Best: ${bestSpot.id} covers ${currentBucket}-${bestWindow[1]}`);
        // STEP 3: Add segment covering from currentBucket to end of selected window
        segments.push({
            spotId: bestSpot.id,
            orientationId: bestSpot.orientations[0].id,
            startBucket: currentBucket,
            endBucket: bestWindow[1]
        });
        // STEP 4: Advance to next uncovered bucket
        currentBucket = bestWindow[1];
        // STEP 5: Check if we exceeded the planned move cap
        const moveCount = segments.length - 1;
        if (moveCount > plannedMoveCap) {
            console.log(`[findSpotChain]   Exceeded move cap: ${moveCount} > ${plannedMoveCap}`);
            return null; // Too many moves required
        }
    }
    // ============================================================================
    // PARTIAL PLACEMENT PREVENTION
    // ============================================================================
    // Validate that the chain covers the ENTIRE trip duration with no gaps.
    // This prevents partial placements where aircraft are only placed for part
    // of their trip (e.g., placed May 22-23 but trip runs May 22-28).
    //
    // Real-world rationale: FBOs don't do partial assignments. Aircraft are either
    // fully accommodated or the operator finds alternative arrangements.
    //
    // TO RE-ENABLE PARTIAL PLACEMENTS (if an FBO requests this feature):
    // 1. Comment out or remove this entire validation block (lines below)
    // 2. OR add a config parameter: allowPartialPlacements: boolean
    // 3. Update ParkingConfig type and UI to expose the toggle
    // 4. Gate this validation: if (!allowPartialPlacements) { ... }
    //
    // NOTE: Partial placements can occur in three ways:
    // - Gap at start: first segment starts AFTER trip arrival
    // - Gap at end: last segment ends BEFORE trip departure
    // - Gap in middle: segments are not continuous (multi-segment chains)
    // ============================================================================
    const firstSegmentStart = segments[0].startBucket;
    const lastSegmentEnd = segments[segments.length - 1].endBucket;
    // Check 1: Verify chain starts at trip arrival (no gap at beginning)
    if (firstSegmentStart > dwellStart) {
        console.log(`[findSpotChain]   Rejecting partial placement: chain starts at bucket ${firstSegmentStart}, ` + `but trip arrives at bucket ${dwellStart} (gap: ${firstSegmentStart - dwellStart} buckets = ` + `${(firstSegmentStart - dwellStart) * 0.25} hours)`);
        return null;
    }
    // Check 2: Verify chain ends at trip departure (no gap at end)
    if (lastSegmentEnd < dwellEnd) {
        console.log(`[findSpotChain]   Rejecting partial placement: chain ends at bucket ${lastSegmentEnd}, ` + `but trip departs at bucket ${dwellEnd} (gap: ${dwellEnd - lastSegmentEnd} buckets = ` + `${(dwellEnd - lastSegmentEnd) * 0.25} hours)`);
        return null;
    }
    // Check 3: Verify no gaps between segments (for multi-segment chains)
    for(let i = 0; i < segments.length - 1; i++){
        const currentEnd = segments[i].endBucket;
        const nextStart = segments[i + 1].startBucket;
        if (currentEnd !== nextStart) {
            console.log(`[findSpotChain]   Rejecting partial placement: gap between segments ${i} and ${i + 1}. ` + `Segment ${i} (${segments[i].spotId}) ends at bucket ${currentEnd}, ` + `segment ${i + 1} (${segments[i + 1].spotId}) starts at bucket ${nextStart} ` + `(gap: ${nextStart - currentEnd} buckets = ${(nextStart - currentEnd) * 0.25} hours)`);
            return null;
        }
    }
    console.log(`[findSpotChain]   Success! Chain covers full trip ${dwellStart}-${dwellEnd}:`, segments.map((s)=>`${s.spotId}(${s.startBucket}-${s.endBucket})`));
    return {
        segments: segments,
        moveCount: segments.length - 1
    };
}
function $3c01328095029a41$export$c0153321e6b1e5fb(chain, spots) {
    for (const segment of chain.segments){
        const spot = spots.find((s)=>s.id === segment.spotId);
        if (!spot) throw new Error(`Spot ${segment.spotId} not found`);
        // Create a bitmap mask for this segment's time range
        // Each bit represents a 15-minute bucket (96 buckets = 24 hours)
        const mask = new BigUint64Array(2);
        for(let bucket = segment.startBucket; bucket < segment.endBucket; bucket++){
            const wordIndex = Math.floor(bucket / 64);
            const bitIndex = bucket % 64;
            mask[wordIndex] |= 1n << BigInt(bitIndex);
        }
        // OR the mask into the spot's occupancy bitmap to reserve these buckets
        (0, $elGuA.orInto)(spot.occupancy, mask);
    }
}

});

parcelRegister("esyom", function(module, exports) {

$parcel$export(module.exports, "getSortingStrategy", () => $bb777fd4785c0d7f$export$c5075eaaaf74dc73);
/**
 * Parking Request Sorting Strategies
 *
 * Different orderings for greedy placement algorithm.
 * Greedy processes requests sequentially - order matters!
 *
 * WHY: Placing constrained requests first prevents blocking.
 *
 * WHEN TO USE EACH:
 * - arrival: Realistic, respects actual timeline (default)
 * - size-constrained: Heterogeneous spots (some Small-only, some Flex)
 * - longest-dwell: Mix of quick-turns and overnights
 * - latest-departure: Overnight parking optimization
 * - hybrid: Complex scenarios with multiple constraints
 */ 
var $jBjdy = parcelRequire("jBjdy");
function $bb777fd4785c0d7f$export$44f93cfa2c196070(requests, _spots) {
    return [
        ...requests
    ].sort((a, b)=>{
        if (a.arrivalBucket !== b.arrivalBucket) return a.arrivalBucket - b.arrivalBucket;
        // Stable sort: maintain original order for ties
        return 0;
    });
}
function $bb777fd4785c0d7f$export$f6e50050d74f0694(requests, spots) {
    return [
        ...requests
    ].sort((a, b)=>{
        const aCompatible = $bb777fd4785c0d7f$var$countCompatibleSpots(a, spots);
        const bCompatible = $bb777fd4785c0d7f$var$countCompatibleSpots(b, spots);
        if (aCompatible !== bCompatible) return aCompatible - bCompatible; // Fewer spots = higher priority
        // Tiebreaker: arrival time
        return a.arrivalBucket - b.arrivalBucket;
    });
}
function $bb777fd4785c0d7f$export$a7a0b12b617e9e4b(requests, _spots) {
    return [
        ...requests
    ].sort((a, b)=>{
        const aDwell = $bb777fd4785c0d7f$var$getDwellLength(a);
        const bDwell = $bb777fd4785c0d7f$var$getDwellLength(b);
        if (aDwell !== bDwell) return bDwell - aDwell; // Longer dwell = higher priority
        // Tiebreaker: arrival time
        return a.arrivalBucket - b.arrivalBucket;
    });
}
function $bb777fd4785c0d7f$export$857b3ae65e822c59(requests, _spots) {
    return [
        ...requests
    ].sort((a, b)=>{
        if (a.departureBucket !== b.departureBucket) return b.departureBucket - a.departureBucket; // Later departure = higher priority
        // Tiebreaker: arrival time
        return a.arrivalBucket - b.arrivalBucket;
    });
}
function $bb777fd4785c0d7f$export$c15d538525df6a30(requests, spots) {
    return [
        ...requests
    ].sort((a, b)=>{
        // Primary: size constraint
        const aCompatible = $bb777fd4785c0d7f$var$countCompatibleSpots(a, spots);
        const bCompatible = $bb777fd4785c0d7f$var$countCompatibleSpots(b, spots);
        if (aCompatible !== bCompatible) return aCompatible - bCompatible; // Fewer spots = higher priority
        // Secondary: dwell length
        const aDwell = $bb777fd4785c0d7f$var$getDwellLength(a);
        const bDwell = $bb777fd4785c0d7f$var$getDwellLength(b);
        if (aDwell !== bDwell) return bDwell - aDwell; // Longer dwell = higher priority
        // Tertiary: arrival time
        return a.arrivalBucket - b.arrivalBucket;
    });
}
function $bb777fd4785c0d7f$export$2aed73e56484199d(requests, _spots) {
    return [
        ...requests
    ].sort((a, b)=>{
        const aSizeRank = $bb777fd4785c0d7f$var$getSizeRank(a.sizeCategory);
        const bSizeRank = $bb777fd4785c0d7f$var$getSizeRank(b.sizeCategory);
        if (aSizeRank !== bSizeRank) return bSizeRank - aSizeRank; // Higher rank (larger) = higher priority
        // Tiebreaker: arrival time
        return a.arrivalBucket - b.arrivalBucket;
    });
}
function $bb777fd4785c0d7f$export$c5075eaaaf74dc73(strategy) {
    switch(strategy){
        case "arrival":
            return $bb777fd4785c0d7f$export$44f93cfa2c196070;
        case "size-constrained":
            return $bb777fd4785c0d7f$export$f6e50050d74f0694;
        case "longest-dwell":
            return $bb777fd4785c0d7f$export$a7a0b12b617e9e4b;
        case "latest-departure":
            return $bb777fd4785c0d7f$export$857b3ae65e822c59;
        case "hybrid":
            return $bb777fd4785c0d7f$export$c15d538525df6a30;
        case "largest-first":
            return $bb777fd4785c0d7f$export$2aed73e56484199d;
        default:
            throw new Error(`Unknown sorting strategy: ${strategy}`);
    }
}
// ============================================================================
// Helpers
// ============================================================================
/**
 * Count compatible spots for a parking request
 *
 * @param request - Parking request to check
 * @param spots - Available spots
 * @returns Number of spots that allow this request's aircraft size
 */ function $bb777fd4785c0d7f$var$countCompatibleSpots(request, spots) {
    return spots.filter((spot)=>(0, $jBjdy.canAircraftUseSpot)(request, spot)).length;
}
/**
 * Calculate dwell length in buckets
 *
 * @param request - Parking request to measure
 * @returns Dwell length (departureBucket - arrivalBucket)
 */ function $bb777fd4785c0d7f$var$getDwellLength(request) {
    return request.departureBucket - request.arrivalBucket;
}
/**
 * Get numeric rank for aircraft size category
 *
 * @param size - Size category
 * @returns Numeric rank (0-4, higher = larger aircraft)
 */ function $bb777fd4785c0d7f$var$getSizeRank(size) {
    const sizeRanking = {
        "very-small": 0,
        "small": 1,
        "midsize": 2,
        "super-midsize": 3,
        "large": 4
    };
    return sizeRanking[size];
}

});
parcelRegister("jBjdy", function(module, exports) {

$parcel$export(module.exports, "canAircraftUseSpot", () => $a4f4b0d868d76b82$export$a7d258c0dd486caf);
/**
 * Size Category Compatibility Functions
 * Handles aircraft size-based spot filtering and compatibility checks
 */ function $a4f4b0d868d76b82$export$a7d258c0dd486caf(aircraft, spot) {
    return spot.allowedSizes.includes(aircraft.sizeCategory);
}

});


parcelRegister("3qqrt", function(module, exports) {

$parcel$export(module.exports, "findStagingChain", () => $31f03c4c4dc58de7$export$ade877ff07607b52);
/**
 * Staging Area Segmentation
 *
 * Handles finding a 3-segment spot chain for staging workflow:
 * 1. Arrival staging (fixed duration in staging zone)
 * 2. Permanent parking (remaining time in non-staging zone)
 * 3. Departure staging (fixed duration in staging zone)
 */ 
var $elGuA = parcelRequire("elGuA");

var $7O8dW = parcelRequire("7O8dW");

var $6moNe = parcelRequire("6moNe");

var $kbn5z = parcelRequire("kbn5z");

var $h3XF9 = parcelRequire("h3XF9");

var $846sO = parcelRequire("846sO");

var $3MLDv = parcelRequire("3MLDv");

var $8L6tD = parcelRequire("8L6tD");
const $31f03c4c4dc58de7$var$logger = (0, $3MLDv.createTaggedLogger)("STAGING");
function $31f03c4c4dc58de7$export$ade877ff07607b52(request, spots, useArrival, useDeparture, arrivalStagingDwellBuckets, departureStagingDwellBuckets, zones, horizonHours, placement, allRequests, egressWeight, wasteWeight, structuralWeight, zonePriorityWeight, minDwellWeight, stickinessWeight, placedAircraftPolygons, logEntry) {
    const { arrivalBucket: arrivalBucket, departureBucket: departureBucket } = request;
    // Calculate segment time windows based on enabled staging
    const arrivalStagingEnd = useArrival ? arrivalBucket + arrivalStagingDwellBuckets : arrivalBucket;
    const departureStagingStart = useDeparture ? departureBucket - departureStagingDwellBuckets : departureBucket;
    // Filter to enabled spots only (not disabled, zone not disabled)
    const enabledSpots = spots.filter((s)=>(0, $6moNe.isSpotEnabled)(s, zones));
    // Separate enabled spots into staging and permanent
    const stagingSpots = enabledSpots.filter((s)=>(0, $kbn5z.isSpotInStagingZone)(s));
    const permanentSpots = enabledSpots.filter((s)=>!(0, $kbn5z.isSpotInStagingZone)(s));
    $31f03c4c4dc58de7$var$logger.debug(`[findStagingChain] ${request.tail_number}: ` + `${stagingSpots.length} staging spots, ${permanentSpots.length} permanent spots, ` + `useArrival=${useArrival}, useDeparture=${useDeparture}`);
    // Arrival staging spot (conditional)
    let arrivalSpot = null;
    if (useArrival) {
        // Find BEST staging spot for arrival (with scoring)
        // Note: Buffer NOT applied - staging dwell time already includes operational buffer
        const arrivalSegmentRequest = {
            ...request,
            arrivalBucket: arrivalBucket,
            departureBucket: arrivalStagingEnd
        };
        const arrivalMask = (0, $elGuA.dwellMask)(arrivalSegmentRequest, 0, horizonHours);
        // Filter to available staging spots (with all hard constraints)
        const availableArrivalSpots = stagingSpots.filter((spot)=>spot.allowedSizes.includes(request.sizeCategory) && !(0, $elGuA.intersects)(spot.occupancy, arrivalMask) && (0, $6moNe.isDurationValid)(spot, arrivalSegmentRequest) && (0, $6moNe.isSpotEnabled)(spot, zones) && !(0, $6moNe.hasGeometryCollision)(spot, arrivalSegmentRequest, placement, placedAircraftPolygons));
        if (availableArrivalSpots.length === 0) return {
            success: false,
            reason: `No staging spot available for arrival (${arrivalBucket}-${arrivalStagingEnd}, size: ${request.sizeCategory})`,
            failedSegment: "arrival"
        };
        // Score and pick best staging spot for arrival
        // Staging segments: NO waste penalty (exempted), but apply zone/egress/structural/min_dwell/stickiness
        const scoredArrivalSpots = availableArrivalSpots.map((spot)=>{
            const egressScore = (0, $7O8dW.countTrappedAircraft)(arrivalSegmentRequest, spot, placement, allRequests, spots) * egressWeight;
            const structuralPenalty = (0, $8L6tD.calculateStructuralComplexity)(spot) * structuralWeight;
            const zone = zones.find((z)=>z.id === spot.zoneId);
            const zonePriority = zone?.priority ?? 5;
            const zonePenalty = (10 - zonePriority) * zonePriorityWeight;
            // Min dwell penalty: prefer spots that match dwell time requirements
            const dwellMinutes = (arrivalSegmentRequest.departureBucket - arrivalSegmentRequest.arrivalBucket) * (0, $h3XF9.MINUTES_PER_BUCKET);
            let minDwellPenalty = 0;
            if (spot.min_dwell_minutes) minDwellPenalty = dwellMinutes >= spot.min_dwell_minutes ? -5 * minDwellWeight // Bonus for long stays matching remote spot requirements
             : 5 * minDwellWeight; // Penalty for short stays in remote spots
            // Stickiness penalty: preserve existing assignments (last-minute insertion)
            const prevSpotExists = request.prevSpotId && spots.find((s)=>s.id === request.prevSpotId);
            const stickyPenalty = prevSpotExists && request.prevSpotId !== spot.id ? stickinessWeight : 0;
            // Waste penalty EXEMPTED for staging segments
            const totalScore = egressScore + structuralPenalty + zonePenalty + minDwellPenalty + stickyPenalty;
            return {
                spot: spot,
                score: totalScore
            };
        });
        scoredArrivalSpots.sort((a, b)=>a.score - b.score);
        // Log section header
        logEntry({
            aircraftId: request.id,
            type: "section-header",
            reason: `=== Arrival Staging Selection (${availableArrivalSpots.length} candidates) ===`
        });
        // Log top 10 arrival staging candidates
        const topArrivalCandidates = scoredArrivalSpots.slice(0, 10);
        for (const { spot: spot } of topArrivalCandidates){
            const trappedAircraft = (0, $7O8dW.findTrappedAircraft)(arrivalSegmentRequest, spot, placement, allRequests, spots);
            const trappedCount = trappedAircraft.length;
            const egressScore = trappedCount * egressWeight;
            const structuralComplexity = (0, $8L6tD.calculateStructuralComplexity)(spot);
            const structuralPenalty = structuralComplexity * structuralWeight;
            const zone = zones.find((z)=>z.id === spot.zoneId);
            const zonePriority = zone?.priority ?? 5;
            const zonePenalty = (10 - zonePriority) * zonePriorityWeight;
            // Waste exemption for staging segments
            const wasteScore = (0, $8L6tD.calculateSpotWaste)(arrivalSegmentRequest, spot);
            const wastePenalty = 0; // Exempted for staging
            logEntry({
                aircraftId: request.id,
                spotId: spot.id,
                type: "eval",
                timeAvailable: true,
                trappedCount: trappedCount,
                egressScore: egressScore,
                egressWeight: egressWeight,
                structuralComplexity: structuralComplexity,
                structuralWeight: structuralWeight,
                structuralPenalty: structuralPenalty,
                wasteScore: wasteScore,
                wasteWeight: wasteWeight,
                wastePenalty: wastePenalty,
                zonePriority: zonePriority,
                zonePriorityWeight: zonePriorityWeight,
                zonePenalty: zonePenalty,
                blockedAircraft: trappedAircraft.length > 0 ? trappedAircraft.map((ac)=>(0, $846sO.getAircraftDisplayName)(ac)) : undefined,
                reason: `[Arrival Staging] Evaluation`
            });
        }
        arrivalSpot = scoredArrivalSpots[0].spot;
        $31f03c4c4dc58de7$var$logger.info(`${request.tail_number} arrival: Selected ${arrivalSpot.id} ` + `(score: ${scoredArrivalSpots[0].score.toFixed(2)} from ${availableArrivalSpots.length} candidates)`);
    }
    // Segment 2: Find BEST permanent spot for middle period (with full scoring)
    const permanentSegmentRequest = {
        ...request,
        arrivalBucket: arrivalStagingEnd,
        departureBucket: departureStagingStart
    };
    const permanentMask = (0, $elGuA.dwellMask)(permanentSegmentRequest, 0, horizonHours);
    // Filter to available permanent spots (with all hard constraints)
    const availablePermanentSpots = permanentSpots.filter((spot)=>spot.allowedSizes.includes(request.sizeCategory) && !(0, $elGuA.intersects)(spot.occupancy, permanentMask) && (0, $6moNe.isDurationValid)(spot, permanentSegmentRequest) && (0, $6moNe.isSpotEnabled)(spot, zones) && !(0, $6moNe.hasGeometryCollision)(spot, permanentSegmentRequest, placement, placedAircraftPolygons));
    if (availablePermanentSpots.length === 0) return {
        success: false,
        reason: `No permanent spot available for main dwell (${arrivalStagingEnd}-${departureStagingStart}, size: ${request.sizeCategory})`,
        failedSegment: "permanent"
    };
    // Score and pick best permanent spot
    // Permanent segment: Apply ALL penalties (waste, zone, egress, structural, min_dwell, stickiness)
    const scoredPermanentSpots = availablePermanentSpots.map((spot)=>{
        const egressScore = (0, $7O8dW.countTrappedAircraft)(permanentSegmentRequest, spot, placement, allRequests, spots) * egressWeight;
        const structuralPenalty = (0, $8L6tD.calculateStructuralComplexity)(spot) * structuralWeight;
        const wasteScore = (0, $8L6tD.calculateSpotWaste)(permanentSegmentRequest, spot);
        const wastePenalty = wasteScore * wasteWeight; // Normal waste penalty applies
        const zone = zones.find((z)=>z.id === spot.zoneId);
        const zonePriority = zone?.priority ?? 5;
        const zonePenalty = (10 - zonePriority) * zonePriorityWeight;
        // Min dwell penalty: prefer spots that match dwell time requirements
        const dwellMinutes = (permanentSegmentRequest.departureBucket - permanentSegmentRequest.arrivalBucket) * (0, $h3XF9.MINUTES_PER_BUCKET);
        let minDwellPenalty = 0;
        if (spot.min_dwell_minutes) minDwellPenalty = dwellMinutes >= spot.min_dwell_minutes ? -5 * minDwellWeight // Bonus for long stays matching remote spot requirements
         : 5 * minDwellWeight; // Penalty for short stays in remote spots
        // Stickiness penalty: preserve existing assignments (last-minute insertion)
        const prevSpotExists = request.prevSpotId && spots.find((s)=>s.id === request.prevSpotId);
        const stickyPenalty = prevSpotExists && request.prevSpotId !== spot.id ? stickinessWeight : 0;
        const totalScore = egressScore + structuralPenalty + wastePenalty + zonePenalty + minDwellPenalty + stickyPenalty;
        return {
            spot: spot,
            score: totalScore
        };
    });
    scoredPermanentSpots.sort((a, b)=>a.score - b.score);
    // Log section header
    logEntry({
        aircraftId: request.id,
        type: "section-header",
        reason: `=== Permanent Spot Selection (${availablePermanentSpots.length} candidates) ===`
    });
    // Log top 10 permanent spot candidates
    const topPermanentCandidates = scoredPermanentSpots.slice(0, 10);
    for (const { spot: spot } of topPermanentCandidates){
        const trappedAircraft = (0, $7O8dW.findTrappedAircraft)(permanentSegmentRequest, spot, placement, allRequests, spots);
        const trappedCount = trappedAircraft.length;
        const egressScore = trappedCount * egressWeight;
        const structuralComplexity = (0, $8L6tD.calculateStructuralComplexity)(spot);
        const structuralPenalty = structuralComplexity * structuralWeight;
        const zone = zones.find((z)=>z.id === spot.zoneId);
        const zonePriority = zone?.priority ?? 5;
        const zonePenalty = (10 - zonePriority) * zonePriorityWeight;
        // Normal waste penalty for permanent segments
        const wasteScore = (0, $8L6tD.calculateSpotWaste)(permanentSegmentRequest, spot);
        const wastePenalty = wasteScore * wasteWeight;
        logEntry({
            aircraftId: request.id,
            spotId: spot.id,
            type: "eval",
            timeAvailable: true,
            trappedCount: trappedCount,
            egressScore: egressScore,
            egressWeight: egressWeight,
            structuralComplexity: structuralComplexity,
            structuralWeight: structuralWeight,
            structuralPenalty: structuralPenalty,
            wasteScore: wasteScore,
            wasteWeight: wasteWeight,
            wastePenalty: wastePenalty,
            zonePriority: zonePriority,
            zonePriorityWeight: zonePriorityWeight,
            zonePenalty: zonePenalty,
            blockedAircraft: trappedAircraft.length > 0 ? trappedAircraft.map((ac)=>(0, $846sO.getAircraftDisplayName)(ac)) : undefined,
            reason: `[Permanent] Evaluation`
        });
    }
    const permanentSpot = scoredPermanentSpots[0].spot;
    $31f03c4c4dc58de7$var$logger.info(`${request.tail_number} permanent: Selected ${permanentSpot.id} ` + `(score: ${scoredPermanentSpots[0].score.toFixed(2)} from ${availablePermanentSpots.length} candidates)`);
    // Departure staging spot (conditional)
    let departureSpot = null;
    if (useDeparture) {
        // Find BEST staging spot for departure (with scoring)
        const departureSegmentRequest = {
            ...request,
            arrivalBucket: departureStagingStart,
            departureBucket: departureBucket
        };
        const departureMask = (0, $elGuA.dwellMask)(departureSegmentRequest, 0, horizonHours);
        // Filter to available staging spots (with all hard constraints)
        const availableDepartureSpots = stagingSpots.filter((spot)=>spot.allowedSizes.includes(request.sizeCategory) && !(0, $elGuA.intersects)(spot.occupancy, departureMask) && (0, $6moNe.isDurationValid)(spot, departureSegmentRequest) && (0, $6moNe.isSpotEnabled)(spot, zones) && !(0, $6moNe.hasGeometryCollision)(spot, departureSegmentRequest, placement, placedAircraftPolygons));
        if (availableDepartureSpots.length === 0) return {
            success: false,
            reason: `No staging spot available for departure (${departureStagingStart}-${departureBucket}, size: ${request.sizeCategory})`,
            failedSegment: "departure"
        };
        // Score and pick best staging spot for departure
        // Staging segments: NO waste penalty (exempted), but apply zone/egress/structural/min_dwell/stickiness
        const scoredDepartureSpots = availableDepartureSpots.map((spot)=>{
            const egressScore = (0, $7O8dW.countTrappedAircraft)(departureSegmentRequest, spot, placement, allRequests, spots) * egressWeight;
            const structuralPenalty = (0, $8L6tD.calculateStructuralComplexity)(spot) * structuralWeight;
            const zone = zones.find((z)=>z.id === spot.zoneId);
            const zonePriority = zone?.priority ?? 5;
            const zonePenalty = (10 - zonePriority) * zonePriorityWeight;
            // Min dwell penalty: prefer spots that match dwell time requirements
            const dwellMinutes = (departureSegmentRequest.departureBucket - departureSegmentRequest.arrivalBucket) * (0, $h3XF9.MINUTES_PER_BUCKET);
            let minDwellPenalty = 0;
            if (spot.min_dwell_minutes) minDwellPenalty = dwellMinutes >= spot.min_dwell_minutes ? -5 * minDwellWeight // Bonus for long stays matching remote spot requirements
             : 5 * minDwellWeight; // Penalty for short stays in remote spots
            // Stickiness penalty: preserve existing assignments (last-minute insertion)
            const prevSpotExists = request.prevSpotId && spots.find((s)=>s.id === request.prevSpotId);
            const stickyPenalty = prevSpotExists && request.prevSpotId !== spot.id ? stickinessWeight : 0;
            // Waste penalty EXEMPTED for staging segments
            const totalScore = egressScore + structuralPenalty + zonePenalty + minDwellPenalty + stickyPenalty;
            return {
                spot: spot,
                score: totalScore
            };
        });
        scoredDepartureSpots.sort((a, b)=>a.score - b.score);
        // Log section header
        logEntry({
            aircraftId: request.id,
            type: "section-header",
            reason: `=== Departure Staging Selection (${availableDepartureSpots.length} candidates) ===`
        });
        // Log top 10 departure staging candidates
        const topDepartureCandidates = scoredDepartureSpots.slice(0, 10);
        for (const { spot: spot } of topDepartureCandidates){
            const trappedAircraft = (0, $7O8dW.findTrappedAircraft)(departureSegmentRequest, spot, placement, allRequests, spots);
            const trappedCount = trappedAircraft.length;
            const egressScore = trappedCount * egressWeight;
            const structuralComplexity = (0, $8L6tD.calculateStructuralComplexity)(spot);
            const structuralPenalty = structuralComplexity * structuralWeight;
            const zone = zones.find((z)=>z.id === spot.zoneId);
            const zonePriority = zone?.priority ?? 5;
            const zonePenalty = (10 - zonePriority) * zonePriorityWeight;
            // Waste exemption for staging segments
            const wasteScore = (0, $8L6tD.calculateSpotWaste)(departureSegmentRequest, spot);
            const wastePenalty = 0; // Exempted for staging
            logEntry({
                aircraftId: request.id,
                spotId: spot.id,
                type: "eval",
                timeAvailable: true,
                trappedCount: trappedCount,
                egressScore: egressScore,
                egressWeight: egressWeight,
                structuralComplexity: structuralComplexity,
                structuralWeight: structuralWeight,
                structuralPenalty: structuralPenalty,
                wasteScore: wasteScore,
                wasteWeight: wasteWeight,
                wastePenalty: wastePenalty,
                zonePriority: zonePriority,
                zonePriorityWeight: zonePriorityWeight,
                zonePenalty: zonePenalty,
                blockedAircraft: trappedAircraft.length > 0 ? trappedAircraft.map((ac)=>(0, $846sO.getAircraftDisplayName)(ac)) : undefined,
                reason: `[Departure Staging] Evaluation`
            });
        }
        departureSpot = scoredDepartureSpots[0].spot;
        $31f03c4c4dc58de7$var$logger.info(`${request.tail_number} departure: Selected ${departureSpot.id} ` + `(score: ${scoredDepartureSpots[0].score.toFixed(2)} from ${availableDepartureSpots.length} candidates)`);
    }
    // Build segment chain dynamically based on enabled staging
    const segments = [];
    // Add arrival staging segment if enabled
    if (useArrival && arrivalSpot) segments.push({
        spotId: arrivalSpot.id,
        orientationId: arrivalSpot.orientations[0].id,
        startBucket: arrivalBucket,
        endBucket: arrivalStagingEnd
    });
    // Always add permanent segment (time range adjusted for enabled staging)
    segments.push({
        spotId: permanentSpot.id,
        orientationId: permanentSpot.orientations[0].id,
        startBucket: arrivalStagingEnd,
        // Adjusted if arrival staging enabled
        endBucket: departureStagingStart // Adjusted if departure staging enabled
    });
    // Add departure staging segment if enabled
    if (useDeparture && departureSpot) segments.push({
        spotId: departureSpot.id,
        orientationId: departureSpot.orientations[0].id,
        startBucket: departureStagingStart,
        endBucket: departureBucket
    });
    // Build readable chain description
    const chainDescription = segments.map((seg, idx)=>{
        const duration = (seg.endBucket - seg.startBucket) * (0, $h3XF9.MINUTES_PER_BUCKET);
        const type = idx === 0 && useArrival ? "arrival" : idx === segments.length - 1 && useDeparture ? "departure" : "permanent";
        return `${seg.spotId} (${type}, ${duration}m)`;
    }).join(" \u2192 ");
    $31f03c4c4dc58de7$var$logger.info(`${request.tail_number}: \u{2713} Staging chain found (${segments.length} segments): ${chainDescription}`);
    return {
        success: true,
        segments: segments,
        moveCount: segments.length - 1 // Dynamic: 0, 1, or 2 moves
    };
}

});
parcelRegister("846sO", function(module, exports) {

$parcel$export(module.exports, "getAircraftDisplayName", () => $da54ade0a64c3728$export$30b633959203211e);
/**
 * Aircraft utility functions for temporal parking
 */ function $da54ade0a64c3728$export$30b633959203211e(aircraft) {
    return aircraft.tail_number || aircraft.aircraft?.model || aircraft.id;
}

});

parcelRegister("3MLDv", function(module, exports) {

$parcel$export(module.exports, "createTaggedLogger", () => $fc4793c5111458c4$export$3a39fa76718a945b);
/**
 * Logger Utility for Temporal Parking Algorithm
 *
 * Provides environment-aware logging with multiple severity levels.
 * Defaults to INFO level to prevent performance issues from verbose DEBUG logs.
 *
 * Usage:
 * ```typescript
 * import { logger } from './utils/logger';
 *
 * logger.debug('Detailed debug information', { data });
 * logger.info('General information', value);
 * logger.warn('Warning message', issue);
 * logger.error('Error occurred', error);
 * ```
 *
 * To enable DEBUG logs (for troubleshooting):
 * ```typescript
 * // In browser console or at app startup:
 * logger.configure({ minLevel: 'DEBUG' });
 * ```
 */ const $fc4793c5111458c4$var$LOG_LEVELS = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3
};
/**
 * Default configuration
 * - Always defaults to INFO level to avoid performance issues
 * - Can be changed at runtime with logger.configure({ minLevel: 'DEBUG' })
 */ const $fc4793c5111458c4$var$defaultConfig = {
    minLevel: "INFO",
    enabled: true
};
let $fc4793c5111458c4$var$config = {
    ...$fc4793c5111458c4$var$defaultConfig
};
/**
 * Format log prefix with level and optional tag
 */ function $fc4793c5111458c4$var$formatPrefix(level, tag) {
    try {
        const timestamp = new Date().toISOString().split("T")[1].slice(0, -1); // HH:MM:SS.mmm
        const tagStr = tag ? ` [${tag}]` : "";
        return `[${timestamp}] [${level}]${tagStr}`;
    } catch (e) {
        // Fallback if timestamp formatting fails
        const tagStr = tag ? ` [${tag}]` : "";
        return `[${level}]${tagStr}`;
    }
}
/**
 * Check if a log level should be displayed
 */ function $fc4793c5111458c4$var$shouldLog(level) {
    if (!$fc4793c5111458c4$var$config.enabled) return false;
    return $fc4793c5111458c4$var$LOG_LEVELS[level] >= $fc4793c5111458c4$var$LOG_LEVELS[$fc4793c5111458c4$var$config.minLevel];
}
const $fc4793c5111458c4$export$af88d00dbe7f521 = {
    /**
   * Debug-level logging (verbose, detailed information)
   * Suppressed in production environments
   *
   * Use for: Algorithm internals, detailed state, trace information
   */ debug (message, ...args) {
        if ($fc4793c5111458c4$var$shouldLog("DEBUG")) console.log($fc4793c5111458c4$var$formatPrefix("DEBUG"), message, ...args);
    },
    /**
   * Info-level logging (general information)
   * Displayed in all environments
   *
   * Use for: Key events, successful operations, important milestones
   */ info (message, ...args) {
        if ($fc4793c5111458c4$var$shouldLog("INFO")) console.log($fc4793c5111458c4$var$formatPrefix("INFO"), message, ...args);
    },
    /**
   * Warning-level logging (potential issues)
   * Displayed in all environments
   *
   * Use for: Fallback scenarios, degraded functionality, validation warnings
   */ warn (message, ...args) {
        if ($fc4793c5111458c4$var$shouldLog("WARN")) console.warn($fc4793c5111458c4$var$formatPrefix("WARN"), message, ...args);
    },
    /**
   * Error-level logging (errors and failures)
   * Always displayed
   *
   * Use for: Exceptions, critical failures, data integrity issues
   */ error (message, ...args) {
        if ($fc4793c5111458c4$var$shouldLog("ERROR")) console.error($fc4793c5111458c4$var$formatPrefix("ERROR"), message, ...args);
    },
    /**
   * Configure logger settings
   * Useful for testing or runtime configuration changes
   */ configure (newConfig) {
        $fc4793c5111458c4$var$config = {
            ...$fc4793c5111458c4$var$config,
            ...newConfig
        };
    },
    /**
   * Reset logger to default configuration
   */ reset () {
        $fc4793c5111458c4$var$config = {
            ...$fc4793c5111458c4$var$defaultConfig
        };
    },
    /**
   * Get current configuration
   */ getConfig () {
        return {
            ...$fc4793c5111458c4$var$config
        };
    }
};
function $fc4793c5111458c4$export$3a39fa76718a945b(tag) {
    return {
        debug (message, ...args) {
            if ($fc4793c5111458c4$var$shouldLog("DEBUG")) console.log($fc4793c5111458c4$var$formatPrefix("DEBUG", tag), message, ...args);
        },
        info (message, ...args) {
            if ($fc4793c5111458c4$var$shouldLog("INFO")) console.log($fc4793c5111458c4$var$formatPrefix("INFO", tag), message, ...args);
        },
        warn (message, ...args) {
            if ($fc4793c5111458c4$var$shouldLog("WARN")) console.warn($fc4793c5111458c4$var$formatPrefix("WARN", tag), message, ...args);
        },
        error (message, ...args) {
            if ($fc4793c5111458c4$var$shouldLog("ERROR")) console.error($fc4793c5111458c4$var$formatPrefix("ERROR", tag), message, ...args);
        }
    };
}

});



parcelRegister("hWiqZ", function(module, exports) {

$parcel$export(module.exports, "findSpotForPosition", () => $89ff4f4f70501ae0$export$d146a30c7f5a340);
/**
 * Position Mapping Utilities for Incremental Parking
 *
 * Converts aircraft positions → spot IDs using point-in-polygon tests.
 * Used to treat existing placements as locked during incremental placement.
 */ 
var $elGuA = parcelRequire("elGuA");
/**
 * Check if a point is inside a polygon using ray casting algorithm
 * (Copied from zoneHelpers.ts for reusability)
 */ function $89ff4f4f70501ae0$var$isPointInPolygon(point, polygon) {
    if (!polygon || polygon.length < 3) return false;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > point.y !== yj > point.y && point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $89ff4f4f70501ae0$export$d146a30c7f5a340(position, shapes, rampDepth) {
    // Handle unplaced aircraft
    if (position.x === null || position.y === null) return null;
    const point = {
        x: position.x,
        y: position.y
    };
    // Find spot shapes
    const spotShapes = shapes.filter((s)=>s.type === "Spot");
    for (const shape of spotShapes){
        if (!shape.points || shape.points.length === 0) continue;
        // Y-flip shape points to match database coordinate system (bottom-left origin)
        // This is the same transformation used in AutoPark (runSnapshotParkingOnRamp, etc.)
        const flippedPoints = shape.points.map((p)=>({
                x: p.x,
                y: rampDepth - p.y
            }));
        const isInside = $89ff4f4f70501ae0$var$isPointInPolygon(point, flippedPoints);
        if (isInside) return shape.id;
    }
    return null;
}
function $89ff4f4f70501ae0$export$bef6a3e6c10ac9f5(placedAircraft, spots, shapes, rampDepth, startBucket = 0, endBucket = 1) {
    for (const aircraft of placedAircraft){
        const spotId = $89ff4f4f70501ae0$export$d146a30c7f5a340(aircraft.position, shapes, rampDepth);
        if (!spotId) continue;
        const spot = spots.find((s)=>s.id === spotId);
        if (!spot) {
            console.warn(`[markExistingSpotsOccupied] Spot ${spotId} not found in spots array for aircraft ${aircraft.id}`);
            continue;
        }
        // Mark spot as occupied using bitmap operations
        const WORD_COUNT = spot.occupancy.length;
        const mask = (0, $elGuA.makeEmptyMask)(WORD_COUNT * 64);
        for(let bucket = startBucket; bucket < endBucket; bucket++){
            const wordIdx = Math.floor(bucket / 64);
            const bitIdx = BigInt(bucket % 64);
            if (wordIdx < WORD_COUNT) mask[wordIdx] |= 1n << bitIdx;
        }
        (0, $elGuA.orInto)(spot.occupancy, mask);
    }
}

});

parcelRegister("8a5rg", function(module, exports) {

$parcel$export(module.exports, "aircraftToSizeCategory", () => $b18ba07d05ded4df$export$db1dadba2808d36f);
$parcel$export(module.exports, "dateToTimeBucket", () => $b18ba07d05ded4df$export$732f75bee4e67e5d);
$parcel$export(module.exports, "timeBucketToDate", () => $b18ba07d05ded4df$export$2dee90bd4bc0bd81);
$parcel$export(module.exports, "buildSpotsFromRamp", () => $b18ba07d05ded4df$export$1e4c578fa22d9e0f);
$parcel$export(module.exports, "buildZonesFromRamp", () => $b18ba07d05ded4df$export$539c5a1a756b7d9c);
$parcel$export(module.exports, "runSnapshotParkingOnRamp", () => $b18ba07d05ded4df$export$6d7ca8761ada6758);
$parcel$export(module.exports, "runIncrementalParkingOnRamp", () => $b18ba07d05ded4df$export$b4e1ee1ebb5caead);
$parcel$export(module.exports, "convertPlacementToPositionSegments", () => $b18ba07d05ded4df$export$dacd122271c2d117);
$parcel$export(module.exports, "runLastMinuteInsertionOnRamp", () => $b18ba07d05ded4df$export$558184291489d78b);
/**
 * Temporal Parking Integration for Ramp + Stack
 *
 * Bridges the gap between domain data structures (Ramp, Stack, Tenant) and
 * the temporal parking algorithm (parkingAlgorithm, Spot, Zone, ParkingRequest).
 *
 * Similar pattern to RampOptimization/algo/placement/rampIntegration.ts but for
 * time-based scheduling instead of spatial placement.
 */ 
var $jYWTx = parcelRequire("jYWTx");

var $elGuA = parcelRequire("elGuA");

var $l9gjg = parcelRequire("l9gjg");

var $6Fyp7 = parcelRequire("6Fyp7");

var $3kHDf = parcelRequire("3kHDf");

var $hWiqZ = parcelRequire("hWiqZ");

var $ixuXj = parcelRequire("ixuXj");
function $b18ba07d05ded4df$export$db1dadba2808d36f(aircraft) {
    const maxDimension = Math.max(aircraft.wingspan, aircraft.length);
    if (maxDimension <= 40) return "very-small"; // Cessna 172, Piper PA-28
    if (maxDimension <= 60) return "small"; // Citations, Phenom 300
    if (maxDimension <= 80) return "midsize"; // Challenger 604/605
    if (maxDimension <= 100) return "super-midsize"; // Falcon 7X, G650
    if (maxDimension <= 120) return "large"; // Global 6000/7500, BBJ
    return "enormous"; // Aircraft too large for standard spots
}
function $b18ba07d05ded4df$export$732f75bee4e67e5d(date, startTime) {
    const targetDate = new Date(date);
    const minutesSinceStart = (targetDate.getTime() - startTime.getTime()) / 60000;
    return Math.floor(minutesSinceStart / 15); // 15-minute buckets
}
function $b18ba07d05ded4df$export$2dee90bd4bc0bd81(bucket, startTime) {
    const minutesOffset = bucket * 15;
    return new Date(startTime.getTime() + minutesOffset * 60000);
}
/**
 * Extract orientations from spot reference points
 * Maps reference point validOrientations to unique orientation IDs
 */ function $b18ba07d05ded4df$var$extractOrientationsFromReferencePoints(shape) {
    const orientationSet = new Set();
    // Extract all unique orientations from all reference points
    if (shape.reference_points) {
        for (const refPoint of shape.reference_points)for (const orientation of refPoint.validOrientations)orientationSet.add(orientation);
    }
    // Convert to Orientation objects
    if (orientationSet.size > 0) return Array.from(orientationSet).map((id)=>({
            id: id
        }));
    // Fallback to center if no reference points
    return [
        {
            id: "center"
        }
    ];
}
function $b18ba07d05ded4df$export$1e4c578fa22d9e0f(ramp, horizonHours) {
    const totalBuckets = horizonHours * 4; // 15-minute buckets
    // Build map of zoneId → is_staging flag for propagation to spots
    const zoneMetadataMap = new Map();
    ramp.shapes.filter((shape)=>shape.type === "Zone").forEach((zoneShape)=>{
        const zoneMetadata = zoneShape.metadata;
        zoneMetadataMap.set(zoneShape.id, {
            is_staging: zoneMetadata?.is_staging || false
        });
    });
    const spots = ramp.shapes.filter((shape)=>shape.type === "Spot").map((shape)=>{
        const metadata = shape.metadata;
        // Propagate zone's is_staging flag to spot metadata
        const zoneId = metadata?.zoneId || "default";
        const zoneMetadata = zoneMetadataMap.get(zoneId);
        const isStaging = zoneMetadata?.is_staging || false;
        // Convert egress options from shape metadata
        const egressOptions = metadata?.egressOptions?.map((opt)=>({
                laneId: opt.laneId,
                laneName: opt.laneName,
                blocksSpotIds: opt.blocksSpotIds
            }));
        // Extract orientations from reference_points
        const orientations = $b18ba07d05ded4df$var$extractOrientationsFromReferencePoints(shape);
        // Merge zone's staging flag into spot's shape metadata
        const enrichedShape = {
            ...shape,
            metadata: {
                ...shape.metadata,
                is_staging: isStaging // Propagate zone's is_staging to spot
            }
        };
        return {
            id: shape.id,
            zoneId: metadata?.zoneId || "default",
            allowedSizes: metadata?.allowedSizes || [],
            occupancy: (0, $elGuA.makeEmptyMask)(totalBuckets),
            orientations: orientations,
            egressOptions: egressOptions,
            max_dwell_minutes: metadata?.max_dwell_minutes,
            // Extract max duration limit from metadata
            min_dwell_minutes: metadata?.min_dwell_minutes,
            // Extract min duration requirement from metadata
            disabled: metadata?.disabled,
            // Extract disabled flag from metadata
            shape: enrichedShape // REQUIRED - Include enriched Shape object with staging flag
        };
    });
    // Log sample of spots with their zone references and duration limits
    console.log(`[buildSpotsFromRamp] Built ${spots.length} spots, sample zoneIds:`, spots.slice(0, 3).map((s)=>({
            spotId: s.id,
            zoneId: s.zoneId
        })));
    // Log spots with duration limits
    const spotsWithLimits = spots.filter((s)=>s.max_dwell_minutes);
    if (spotsWithLimits.length > 0) console.log(`[buildSpotsFromRamp] Found ${spotsWithLimits.length} spots with duration limits:`, spotsWithLimits.slice(0, 5).map((s)=>({
            spotId: s.id,
            maxDwell: s.max_dwell_minutes
        })));
    // Log spots with min dwell requirements
    const spotsWithMinDwell = spots.filter((s)=>s.min_dwell_minutes);
    if (spotsWithMinDwell.length > 0) console.log(`[buildSpotsFromRamp] Found ${spotsWithMinDwell.length} spots with min dwell requirements:`, spotsWithMinDwell.slice(0, 5).map((s)=>({
            spotId: s.id,
            minDwell: s.min_dwell_minutes
        })));
    // Log disabled spots
    const disabledSpots = spots.filter((s)=>s.disabled);
    if (disabledSpots.length > 0) console.log(`[buildSpotsFromRamp] Found ${disabledSpots.length} disabled spots:`, disabledSpots.slice(0, 5).map((s)=>s.id));
    // Log staging spots (propagated from zone metadata)
    const stagingSpots = spots.filter((s)=>s.shape?.metadata?.is_staging);
    if (stagingSpots.length > 0) console.log(`[buildSpotsFromRamp] Found ${stagingSpots.length} staging spots:`, stagingSpots.slice(0, 5).map((s)=>({
            spotId: s.id,
            zoneId: s.zoneId
        })));
    return spots;
}
function $b18ba07d05ded4df$export$539c5a1a756b7d9c(ramp) {
    const zones = [];
    // Find all zone shapes
    const zoneShapes = ramp.shapes.filter((shape)=>shape.type === "Zone");
    console.log(`[buildZonesFromRamp] Found ${zoneShapes.length} zone shapes`);
    for (const zoneShape of zoneShapes){
        // Find all spots belonging to this zone
        const spotIds = ramp.shapes.filter((shape)=>{
            if (shape.type !== "Spot") return false;
            const metadata = shape.metadata;
            return metadata?.zoneId === zoneShape.id;
        }).map((shape)=>shape.id);
        // Extract priority from shape.priority column (single source of truth)
        const priority = zoneShape.priority ?? 5;
        // Extract disabled flag from metadata
        const disabled = zoneShape.metadata?.disabled;
        zones.push({
            id: zoneShape.id,
            name: zoneShape.text || `Zone ${zoneShape.id}`,
            spotIds: spotIds,
            priority: priority,
            shapeId: zoneShape.id,
            disabled: disabled
        });
    }
    // Add default zone for spots without explicit zone
    const spotsWithoutZone = ramp.shapes.filter((shape)=>{
        if (shape.type !== "Spot") return false;
        const metadata = shape.metadata;
        return !metadata?.zoneId || metadata.zoneId === "default";
    }).map((shape)=>shape.id);
    if (spotsWithoutZone.length > 0) zones.push({
        id: "default",
        name: "Default Zone",
        spotIds: spotsWithoutZone
    });
    // Cross-reference check: Find spots that reference non-existent zones
    const zoneIds = new Set(zones.map((z)=>z.id));
    const allSpots = ramp.shapes.filter((s)=>s.type === "Spot");
    const orphanedSpots = allSpots.filter((spot)=>{
        const metadata = spot.metadata;
        const spotZoneId = metadata?.zoneId;
        return spotZoneId && spotZoneId !== "default" && !zoneIds.has(spotZoneId);
    });
    console.log(`[buildZonesFromRamp] Zone IDs extracted:`, Array.from(zoneIds));
    if (orphanedSpots.length > 0) {
        console.warn(`[buildZonesFromRamp] \u{26A0}\u{FE0F} WARNING: ${orphanedSpots.length} spots reference non-existent zones!`);
        orphanedSpots.slice(0, 5).forEach((spot)=>{
            const metadata = spot.metadata;
            console.warn(`  - Spot ${spot.text || spot.id} references zone "${metadata?.zoneId}" which doesn't exist`);
        });
        if (orphanedSpots.length > 5) console.warn(`  ... and ${orphanedSpots.length - 5} more spots with orphaned zone references`);
    }
    // Log disabled zones
    const disabledZones = zones.filter((z)=>z.disabled);
    if (disabledZones.length > 0) console.log(`[buildZonesFromRamp] Found ${disabledZones.length} disabled zones:`, disabledZones.map((z)=>({
            id: z.id,
            name: z.name,
            spotCount: z.spotIds.length
        })));
    return zones;
}
/**
 * Convert stack tenants with trips to parking requests
 * Uses real trip timing data when provided via tripTimings map
 */ function $b18ba07d05ded4df$var$buildParkingRequests(stack, startTime, _horizonHours, tripTimings) {
    return stack.tenants.filter((tenant)=>tenant.trip_id) // Only tenants with scheduled trips
    .map((tenant)=>{
        // Get real trip timings from map
        const timing = tripTimings.get(tenant.trip_id);
        if (!timing) {
            console.warn(`[buildParkingRequests] No timing data for trip ${tenant.trip_id}, skipping`);
            return null;
        }
        // Convert real times to time buckets
        const arrivalBucket = $b18ba07d05ded4df$export$732f75bee4e67e5d(timing.startTime.toISOString(), startTime);
        const departureBucket = $b18ba07d05ded4df$export$732f75bee4e67e5d(timing.endTime.toISOString(), startTime);
        return {
            id: tenant.id,
            tail_number: tenant.tail_number,
            sizeCategory: $b18ba07d05ded4df$export$db1dadba2808d36f(tenant.aircraft),
            arrivalBucket: arrivalBucket,
            departureBucket: departureBucket,
            aircraft: tenant.aircraft
        };
    }).filter((r)=>r !== null); // Filter out nulls
}
/**
 * Apply temporal placement results back to stack
 * Updates tenant positions based on algorithm placement
 */ function $b18ba07d05ded4df$var$applyTemporalPlacementsToStack(stack, placement, spots, rampShapes, options) {
    if (!options.rampDepth) throw new Error("rampDepth is required.");
    const updatedTenants = stack.tenants.map((tenant)=>{
        const tenantPlacement = placement[tenant.id];
        if (!tenantPlacement) // Not placed - leave position unchanged
        return tenant;
        // Extract spotId and orientationId from placement
        let spotId;
        let orientationId;
        if ("spotId" in tenantPlacement) {
            spotId = tenantPlacement.spotId;
            orientationId = tenantPlacement.orientationId;
        } else {
            spotId = tenantPlacement.segments[0].spotId;
            orientationId = tenantPlacement.segments[0].orientationId;
        }
        const spot = spots.find((s)=>s.id === spotId);
        // Find spot shape (has reference_points and geometry)
        if (!spot) {
            console.log(`Failed to find spot with id ${spotId}`);
            return tenant;
        }
        // Get position using orientationId from placement
        console.log(`positioning tenant ${tenant.tail_number} at spot ${spotId}`, spot);
        const position = (0, $jYWTx.getPositionForSpot)(spot, rampShapes, orientationId, tenant, {
            checkAircraftFitsInBox: false,
            //feetToPixels: options?.feetToPixels,
            yAxisInverted: true
        });
        if (!position) {
            console.error(`Failed to get position for ${tenant.tail_number} at spot ${spotId} with orientation ${orientationId}`);
            return tenant; // Keep original position - placement is invalid
        }
        return {
            ...tenant,
            position: {
                ...tenant.position,
                x: position.x,
                // We have passed in to the getPositionForSpot function a coordinate system where
                // the origin is top left, but we need to return a coordinate system
                // where the origin is bottom left for this positioning, so we modify it
                // here
                // TODO It doesn't make sense that we're passing in top left origin coords
                // and returning something different, there must be a conversion going
                // on somewhere else that we can remove and then remove this.
                y: options?.rampDepth - position.y,
                angle: position.angle,
                timestamp: Date.now()
            }
        };
    });
    return {
        ...stack,
        tenants: updatedTenants
    };
}
function $b18ba07d05ded4df$export$4f04b1822b8fcb41(ramp, stack, options = {}) {
    const { startTime: startTime = new Date(), horizonHours: horizonHours = 24, bufferMinutes: bufferMinutes = 15, plannedMoveCap: plannedMoveCap = 0, allowTrapping: allowTrapping = false, egressWeight: egressWeight = 1.0, wasteWeight: wasteWeight = 1.0, zonePriorityWeight: zonePriorityWeight = 1.0, min_dwell_weight: min_dwell_weight = 2.0, tripTimings: tripTimings = new Map(), enableArrivalStaging: enableArrivalStaging = false, enableDepartureStaging: enableDepartureStaging = false, arrivalStagingDwellMinutes: arrivalStagingDwellMinutes = 60, departureStagingDwellMinutes: departureStagingDwellMinutes = 30, quickTurnThresholdMinutes: quickTurnThresholdMinutes = 120 } = options;
    console.log(`[Temporal Parking] Running on ramp "${ramp.name}" with ${stack.tenants.length} aircraft`);
    // Convert ramp data to algorithm format
    const spots = $b18ba07d05ded4df$export$1e4c578fa22d9e0f(ramp, horizonHours);
    const zones = $b18ba07d05ded4df$export$539c5a1a756b7d9c(ramp);
    const requests = $b18ba07d05ded4df$var$buildParkingRequests(stack, startTime, horizonHours, tripTimings);
    console.log(`[Temporal Parking] Found ${spots.length} spots, ${zones.length} zones, ${requests.length} requests`);
    // Validate we have spots
    if (spots.length === 0) {
        console.warn("[Temporal Parking] No spots found in ramp. Add shapes with type='Spot'");
        return {
            placement: {},
            decisionLog: [],
            updatedStack: stack,
            statistics: {
                totalAircraft: requests.length,
                placedAircraft: 0,
                unplacedAircraft: requests.length,
                averageMoves: 0
            }
        };
    }
    // Run temporal parking algorithm
    const placement = (0, $3kHDf.parkingAlgorithm)(requests, spots, bufferMinutes, plannedMoveCap, allowTrapping, egressWeight, wasteWeight, 0.1, // structuralWeight (fixed for temporal)
    "arrival", // sorting strategy
    horizonHours, // shapes parameter removed - using spot.shape
    false, // useMaskOptimization
    false, // validateMasks
    zonePriorityWeight, zones, min_dwell_weight, 0.0, // stickinessWeight (not used in temporal mode)
    enableArrivalStaging, enableDepartureStaging, arrivalStagingDwellMinutes, departureStagingDwellMinutes, quickTurnThresholdMinutes);
    const decisionLog = (0, $3kHDf.getDecisionLog)();
    // Apply results back to stack
    const updatedStack = $b18ba07d05ded4df$var$applyTemporalPlacementsToStack(stack, placement, spots, ramp.shapes, {
        rampDepth: ramp.depth
    });
    // Calculate statistics
    const placedCount = Object.keys(placement).length;
    const unplacedCount = requests.length - placedCount;
    // Calculate average moves
    let totalMoves = 0;
    let placementsWithSegments = 0;
    Object.values(placement).forEach((p)=>{
        if ("segments" in p && "moveCount" in p) {
            totalMoves += p.moveCount;
            placementsWithSegments++;
        }
    });
    const averageMoves = placementsWithSegments > 0 ? totalMoves / placementsWithSegments : 0;
    console.log(`[Temporal Parking] Placed ${placedCount}/${requests.length}, avg moves: ${averageMoves.toFixed(2)}`);
    // Log decision log for debugging
    if (decisionLog.length > 0) console.log("[Temporal Parking] Decision Log:\n" + JSON.stringify(decisionLog, null, 2));
    return {
        placement: placement,
        decisionLog: decisionLog,
        updatedStack: updatedStack,
        statistics: {
            totalAircraft: requests.length,
            placedAircraft: placedCount,
            unplacedAircraft: unplacedCount,
            averageMoves: averageMoves
        }
    };
}
/**
 * Build snapshot parking requests (no temporal data needed)
 * All aircraft exist at bucket 0 (single moment in time)
 *
 * @param stack - Stack with tenants to place
 * @returns Parking requests configured for snapshot mode
 */ function $b18ba07d05ded4df$var$buildSnapshotRequests(stack) {
    return stack.tenants.map((tenant)=>({
            id: tenant.id,
            tail_number: tenant.tail_number,
            sizeCategory: $b18ba07d05ded4df$export$db1dadba2808d36f(tenant.aircraft),
            arrivalBucket: 0,
            // Snapshot mode: all at bucket 0
            departureBucket: 1,
            // Snapshot mode: all at bucket 1
            aircraft: tenant.aircraft,
            placement_source: tenant.placement_source || "auto",
            is_locked: tenant.is_locked || false
        }));
}
function $b18ba07d05ded4df$export$6d7ca8761ada6758(ramp, stack, options = {}) {
    const { allowTrapping: allowTrapping = false, egressWeight: egressWeight = 1.0, wasteWeight: wasteWeight = 1.0, structuralWeight: structuralWeight = 0.1, sortingStrategy: sortingStrategy = "size-constrained", zonePriorityWeight: zonePriorityWeight = 1.0 } = options;
    console.log(`[Snapshot Parking] Running on ramp "${ramp.name}" with ${stack.tenants.length} aircraft`);
    // Convert ramp data to algorithm format (reuse temporal functions)
    const spots = $b18ba07d05ded4df$export$1e4c578fa22d9e0f(ramp, 0.25); // 1 bucket for snapshot
    const zones = $b18ba07d05ded4df$export$539c5a1a756b7d9c(ramp);
    const requests = $b18ba07d05ded4df$var$buildSnapshotRequests(stack);
    console.log(`[Snapshot Parking] Found ${spots.length} spots, ${zones.length} zones, ${requests.length} requests`);
    // Validate we have spots
    if (spots.length === 0) {
        console.warn("[Snapshot Parking] No spots found in ramp. Add shapes with type='Spot'");
        return {
            placement: {},
            decisionLog: [],
            updatedStack: stack,
            statistics: {
                totalAircraft: requests.length,
                placedAircraft: 0,
                unplacedAircraft: requests.length
            }
        };
    }
    // Run snapshot placement algorithm
    const result = (0, $ixuXj.planSnapshotPlacement)(requests, spots, allowTrapping, egressWeight, wasteWeight, structuralWeight, sortingStrategy, zonePriorityWeight, zones);
    const decisionLog = (0, $3kHDf.getDecisionLog)();
    // Apply results back to stack (reuse temporal function)
    const updatedStack = $b18ba07d05ded4df$var$applyTemporalPlacementsToStack(stack, result.placement, spots, ramp.shapes, {
        rampDepth: ramp.depth
    });
    // Calculate statistics
    const placedCount = Object.keys(result.placement).length;
    const unplacedCount = requests.length - placedCount;
    // Log decision log for debugging
    if (decisionLog.length > 0) console.log("[Snapshot Parking] Decision Log:\n" + JSON.stringify(decisionLog, null, 2));
    return {
        placement: result.placement,
        decisionLog: decisionLog,
        updatedStack: updatedStack,
        statistics: {
            totalAircraft: requests.length,
            placedAircraft: placedCount,
            unplacedAircraft: unplacedCount
        }
    };
}
function $b18ba07d05ded4df$export$b4e1ee1ebb5caead(ramp, stack, selectedAircraftId, options = {}) {
    // 1. Find selected aircraft
    const selectedAircraft = stack.tenants.find((t)=>t.id === selectedAircraftId);
    if (!selectedAircraft) throw new Error(`Selected aircraft ${selectedAircraftId} not found in stack`);
    // 2. Get existing placements (all others with positions set)
    const existingPlacements = stack.tenants.filter((t)=>t.id !== selectedAircraftId && t.position.x !== null && t.position.y !== null);
    // 3. Build spots from ramp (snapshot mode: 1 bucket)
    const spots = $b18ba07d05ded4df$export$1e4c578fa22d9e0f(ramp, 0.25);
    const zones = $b18ba07d05ded4df$export$539c5a1a756b7d9c(ramp);
    // Validate we have spots
    if (spots.length === 0) {
        console.warn("[Incremental Parking] No spots found in ramp. Add shapes with type='Spot'");
        return {
            placement: {},
            decisionLog: [],
            updatedStack: stack,
            statistics: {
                totalAircraft: 1,
                placedAircraft: 0,
                unplacedAircraft: 1
            }
        };
    }
    // 4. Mark existing placements as occupied in spot bitmaps
    // Convert spots to legacy format for getSpotForPositionLegacy
    const legacySpots = spots.map((spot)=>({
            points: spot.shape.points,
            referencePoints: spot.shape.reference_points || []
        }));
    // Mark each existing placement's spot as occupied
    for (const tenant of existingPlacements){
        const result = (0, $jYWTx.getSpotForPositionLegacy)(tenant, tenant.position, legacySpots, {});
        if (result) {
            // Find matching Spot object by comparing geometry (points array reference)
            const spotIndex = spots.findIndex((s)=>s.shape.points === result.spot.points);
            if (spotIndex !== -1) // Mark entire spot as occupied for all time buckets
            // Fill all 64-bit words with 1s (fully occupied)
            spots[spotIndex].occupancy.fill(BigInt("0xFFFFFFFFFFFFFFFF"));
            else console.warn(`[Incremental Parking] Could not find spot for tenant ${tenant.tail_number} at position (${tenant.position.x}, ${tenant.position.y})`);
        }
    }
    // 5. Create parking request for selected aircraft only
    const request = {
        id: selectedAircraft.id,
        tail_number: selectedAircraft.tail_number,
        sizeCategory: $b18ba07d05ded4df$export$db1dadba2808d36f(selectedAircraft.aircraft),
        arrivalBucket: 0,
        // Snapshot mode
        departureBucket: 1,
        // Snapshot mode
        aircraft: selectedAircraft.aircraft,
        placement_source: selectedAircraft.placement_source || "auto",
        is_locked: selectedAircraft.is_locked || false
    };
    // 6. Run snapshot placement for single aircraft
    const result = (0, $ixuXj.planSnapshotPlacement)([
        request
    ], // Single aircraft
    spots, options.allowTrapping ?? false, options.egressWeight ?? 1.0, options.wasteWeight ?? 1.0, options.structuralWeight ?? 0.1, options.sortingStrategy ?? "size-constrained", options.zonePriorityWeight ?? 1.0, zones);
    // 7. Get decision log
    const decisionLog = (0, $3kHDf.getDecisionLog)();
    // 8. Apply placement to stack (only updates selected aircraft)
    const updatedStack = $b18ba07d05ded4df$var$applyTemporalPlacementsToStack(stack, result.placement, spots, ramp.shapes, {
        rampDepth: ramp.depth
    });
    // 9. Return result
    const placedCount = Object.keys(result.placement).length;
    return {
        placement: result.placement,
        decisionLog: decisionLog,
        updatedStack: updatedStack,
        statistics: {
            totalAircraft: 1,
            placedAircraft: placedCount,
            unplacedAircraft: placedCount === 0 ? 1 : 0
        }
    };
}
function $b18ba07d05ded4df$export$dacd122271c2d117(placement, rampShapes, ramp, requestMap, startTime, _horizonHours) {
    const results = [];
    // Process each placed aircraft
    for (const [placementId, placementData] of Object.entries(placement)){
        // Get request data (contains both aircraft and tail_number)
        const request = requestMap.get(placementId);
        if (!request) {
            console.warn(`[convertPlacementToPositionSegments] No request found for placement ${placementId}, skipping`);
            continue;
        }
        const aircraft = request.aircraft;
        // Build list of time segments with spot IDs
        const timeSegments = [];
        if ("spotId" in placementData) // Single-spot placement (no moves)
        // Full dwell time = trip arrival to departure (not entire horizon)
        timeSegments.push({
            spotId: placementData.spotId,
            orientationId: placementData.orientationId,
            startBucket: request.arrivalBucket,
            endBucket: request.departureBucket
        });
        else // Multi-segment placement (with moves)
        for (const seg of placementData.segments)timeSegments.push({
            spotId: seg.spotId,
            orientationId: seg.orientationId,
            startBucket: seg.startBucket,
            endBucket: seg.endBucket
        });
        // Convert each time segment to position coordinates
        const positionSegments = timeSegments.map((seg)=>{
            // Find spot shape for geometry
            var spotShape = rampShapes.find((s)=>s.id === seg.spotId && s.type === "Spot");
            if (!spotShape) throw new Error(`Spot shape ${seg.spotId} not found in ramp shapes. ` + `Cannot convert placement ${placementId} to position coordinates.`);
            // The current spot position has an origin of the top left of the screen
            // so we need to invert it in the y axis and reverse the corners. This
            // ensures it matches the coordinate system of everything else
            spotShape = Object.assign({}, spotShape);
            spotShape.points = spotShape.points.map((o)=>({
                    x: o.x,
                    y: ramp.depth - o.y
                }));
            spotShape.points.reverse();
            // Build spot object for getPositionForSpot
            const spotUtil = {
                points: spotShape.points,
                referencePoints: spotShape.reference_points || []
            };
            // Create minimal tenant object for getPositionForSpot
            // (getPositionForSpot needs aircraft dimensions)
            const minimalTenant = {
                aircraft: aircraft
            };
            // Calculate position for database storage
            // NOTE: Unlike visual display (Timeline), database uses snapshot mode coordinates
            const position = (0, $jYWTx.getPositionForSpotLegacy)(spotUtil, seg.orientationId, minimalTenant, {
                checkAircraftFitsInBox: false
            });
            if (!position) throw new Error(`Failed to calculate position for aircraft at spot ${seg.spotId} ` + `with orientation ${seg.orientationId}. ` + `placementId: ${placementId}`);
            // Convert time buckets to Date objects
            const segmentStart = $b18ba07d05ded4df$export$2dee90bd4bc0bd81(seg.startBucket, startTime);
            const segmentEnd = $b18ba07d05ded4df$export$2dee90bd4bc0bd81(seg.endBucket, startTime);
            return {
                startTime: segmentStart,
                endTime: segmentEnd,
                x: position.x,
                y: position.y,
                angle: position.angle
            };
        });
        results.push({
            placementId: placementId,
            segments: positionSegments
        });
    }
    console.log(`[convertPlacementToPositionSegments] Converted ${results.length} placements to position segments`);
    return results;
}
function $b18ba07d05ded4df$export$558184291489d78b(ramp, stack, newTrip, options) {
    const startMs = performance.now();
    const { startTime: startTime = new Date(), horizonHours: horizonHours = 24, maxDisruption: maxDisruption, stickinessWeight: stickinessWeight = 10.0, bufferMinutes: bufferMinutes = 15, egressWeight: egressWeight = 5.0, allowTrapping: allowTrapping = false, tryLocalRepair: tryLocalRepair = true } = options;
    // 1. Build spots and zones from ramp geometry
    const spots = $b18ba07d05ded4df$export$1e4c578fa22d9e0f(ramp, horizonHours);
    if (spots.length === 0) throw new Error("No spots found in ramp. Add shapes with type='Spot'");
    // 2. Filter existing tenants with positions
    const existingTenants = stack.tenants.filter((t)=>t.position.x !== null && t.position.y !== null);
    // 3. Build placement map and mark spots occupied (single pass)
    // Create spot lookup map for O(1) access
    const spotMap = new Map(spots.map((s)=>[
            s.id,
            s
        ]));
    const existingPlacements = {};
    const existingRequests = [];
    // Filter to only tenants with temporal data (type-safe)
    const scheduledTenants = existingTenants.filter((t)=>{
        // Type guard: check if tenant has required temporal properties
        const hasTemporalData = t.trip_id != null && t.start_time != null && t.end_time != null;
        if (!hasTemporalData) console.warn(`[runLastMinuteInsertionOnRamp] Tenant ${t.id} missing temporal data, skipping`);
        return hasTemporalData;
    });
    for (const tenant of scheduledTenants){
        // Find which spot tenant is in (using proper point-in-polygon)
        const spotId = (0, $hWiqZ.findSpotForPosition)(tenant.position, ramp.shapes, ramp.depth);
        if (!spotId) {
            // Tenant position not in any spot - warn and skip
            console.warn(`[runLastMinuteInsertionOnRamp] Tenant ${tenant.id} (${tenant.tail_number}) at position (${tenant.position.x}, ${tenant.position.y}) is not in any spot`);
            continue;
        }
        const spot = spotMap.get(spotId);
        if (!spot) {
            console.warn(`[runLastMinuteInsertionOnRamp] Spot ${spotId} found for tenant but not in spots array`);
            continue;
        }
        // Convert tenant's start/end times to buckets
        const arrivalBucket = $b18ba07d05ded4df$var$timeToBucket(new Date(tenant.start_time), startTime);
        const departureBucket = $b18ba07d05ded4df$var$timeToBucket(new Date(tenant.end_time), startTime);
        // Mark spot as occupied for tenant's time window
        (0, $l9gjg.markOccupied)(spot, arrivalBucket, departureBucket);
        // Determine orientation from tenant's current angle or use default
        const orientationId = $b18ba07d05ded4df$var$determineOrientation(tenant.position.angle, spot);
        // Build placement entry
        existingPlacements[tenant.id] = {
            spotId: spotId,
            orientationId: orientationId
        };
        // Build parking request (avoiding duplicate loop)
        existingRequests.push({
            id: tenant.id,
            tail_number: tenant.tail_number,
            sizeCategory: $b18ba07d05ded4df$export$db1dadba2808d36f(tenant.aircraft),
            arrivalBucket: arrivalBucket,
            departureBucket: departureBucket,
            aircraft: tenant.aircraft
        });
    }
    // 4. Validate new trip time range
    if (newTrip.startTime >= newTrip.endTime) throw new Error(`Invalid time range: startTime (${newTrip.startTime.toISOString()}) must be before endTime (${newTrip.endTime.toISOString()})`);
    // 5. Build ParkingRequest for new trip
    const newRequest = {
        id: newTrip.trip_id || `new-${Date.now()}`,
        tail_number: newTrip.aircraft.tail_number,
        sizeCategory: $b18ba07d05ded4df$export$db1dadba2808d36f(newTrip.aircraft),
        arrivalBucket: $b18ba07d05ded4df$var$timeToBucket(newTrip.startTime, startTime),
        departureBucket: $b18ba07d05ded4df$var$timeToBucket(newTrip.endTime, startTime),
        aircraft: newTrip.aircraft,
        trip_id: newTrip.trip_id
    };
    // 6. Call attemptLastMinuteInsertion
    const insertionResult = (0, $6Fyp7.attemptLastMinuteInsertion)(newRequest, existingPlacements, spots, existingRequests, {
        maxDisruption: maxDisruption,
        stickinessWeight: stickinessWeight,
        bufferMinutes: bufferMinutes,
        egressWeight: egressWeight,
        allowTrapping: allowTrapping,
        horizonHours: horizonHours,
        tryLocalRepair: tryLocalRepair
    });
    // 7. Apply results to stack (if successful)
    let updatedStack = stack;
    if (insertionResult.success && insertionResult.placement) {
        // Apply only the new trip's placement to stack
        const newTripPlacement = insertionResult.placement[newRequest.id];
        if (newTripPlacement && "spotId" in newTripPlacement) {
            // Find spot shape
            const spot = spots.find((s)=>s.id === newTripPlacement.spotId);
            if (spot) try {
                // Create minimal tenant object for getPositionForSpot
                const tempTenant = {
                    id: newRequest.id,
                    aircraft: newTrip.aircraft,
                    tail_number: newRequest.tail_number
                };
                // Get position for spot with correct arguments
                const position = (0, $jYWTx.getPositionForSpot)(spot, ramp.shapes, newTripPlacement.orientationId, tempTenant, {});
                if (position) {
                    // Create updated stack with new tenant
                    // Note: This is a simplified version - real implementation would
                    // add tenant to database and reload
                    const newTenant = {
                        id: newRequest.id,
                        tail_number: newRequest.tail_number,
                        aircraft: newTrip.aircraft,
                        position: {
                            x: position.x,
                            y: position.y,
                            angle: position.angle
                        },
                        start_time: newTrip.startTime.toISOString(),
                        end_time: newTrip.endTime.toISOString()
                    };
                    updatedStack = {
                        ...stack,
                        tenants: [
                            ...stack.tenants,
                            newTenant
                        ]
                    };
                }
            } catch (error) {
                // getPositionForSpot may fail if shape doesn't have proper metadata
                // This is okay for algorithm testing - stack update is Phase 6 concern
                console.warn("[runLastMinuteInsertionOnRamp] Could not get position for spot, skipping stack update:", error);
            }
        }
    }
    const elapsedMs = performance.now() - startMs;
    // 8. Return result with insertion analysis
    return {
        placement: insertionResult.placement || {},
        decisionLog: insertionResult.decisionLog,
        updatedStack: updatedStack,
        statistics: {
            totalAircraft: 1,
            placedAircraft: insertionResult.success ? 1 : 0,
            unplacedAircraft: insertionResult.success ? 0 : 1,
            averageMoves: insertionResult.totalMoves,
            elapsedMs: elapsedMs
        },
        insertionAnalysis: insertionResult
    };
}
/**
 * Helper: Determine orientation ID from tenant angle
 * Maps tenant's current angle to spot's available orientations
 */ function $b18ba07d05ded4df$var$determineOrientation(tenantAngle, spot) {
    // If tenant has no angle or spot has no orientations, use default
    if (tenantAngle === null || !spot.orientations || spot.orientations.length === 0) return "nose_in";
    // For now, just use spot's first orientation
    // Future: Could map angle to closest orientation
    return spot.orientations[0].id;
}
/**
 * Helper: Convert JavaScript Date to bucket index
 */ function $b18ba07d05ded4df$var$timeToBucket(time, startTime) {
    const diffMs = time.getTime() - startTime.getTime();
    const diffMinutes = diffMs / 60000;
    const bucket = Math.floor(diffMinutes / 15); // 15-minute buckets
    return Math.max(0, bucket);
}

});
parcelRegister("l9gjg", function(module, exports) {

$parcel$export(module.exports, "markOccupied", () => $b98dbaf4e4d00ff2$export$c039f42b6f13b6ab);
$parcel$export(module.exports, "tryCascadeRepair", () => $b98dbaf4e4d00ff2$export$510c3d29f21ee9a9);
/**
 * Cascade Repair Module - Phase 2.1
 * Last-Minute Insertion Implementation
 *
 * Implements recursive cascade repair with rollback for moving aircraft
 * to make space for last-minute insertions.
 *
 * Key features:
 * - Recursive cascade handling (A→B→C chains)
 * - Total move counting (all moves in chain)
 * - Rollback on failure (restore original state)
 * - Move budget enforcement (user-configurable limit)
 */ 
var $elGuA = parcelRequire("elGuA");
/**
 * Transaction log for rollback
 * More memory efficient than copying entire BigUint64Arrays
 */ class $b98dbaf4e4d00ff2$var$TransactionLog {
    record(spot, startBucket, endBucket, operation) {
        this.transactions.push({
            spot: spot,
            startBucket: startBucket,
            endBucket: endBucket,
            operation: operation
        });
    }
    rollback() {
        // Undo in reverse order (LIFO)
        for(let i = this.transactions.length - 1; i >= 0; i--){
            const tx = this.transactions[i];
            if (tx.operation === 'mark') // Undo mark = clear
            $b98dbaf4e4d00ff2$var$clearOccupancyInternal(tx.spot, tx.startBucket, tx.endBucket);
            else // Undo clear = mark
            $b98dbaf4e4d00ff2$var$markOccupiedInternal(tx.spot, tx.startBucket, tx.endBucket);
        }
        this.transactions = [];
    }
    clear() {
        this.transactions = [];
    }
    constructor(){
        this.transactions = [];
    }
}
/**
 * Internal: Mark spot occupied without validation (for rollback)
 */ function $b98dbaf4e4d00ff2$var$markOccupiedInternal(spot, startBucket, endBucket) {
    (0, $elGuA.setRange)(spot.occupancy, startBucket, endBucket - 1); // setRange is inclusive, so -1
}
/**
 * Internal: Clear occupancy without validation (for rollback)
 */ function $b98dbaf4e4d00ff2$var$clearOccupancyInternal(spot, startBucket, endBucket) {
    for(let bucket = startBucket; bucket < endBucket; bucket++){
        const wordIndex = Math.floor(bucket / 64);
        const bitIndex = BigInt(bucket % 64);
        spot.occupancy[wordIndex] &= ~(1n << bitIndex);
    }
}
function $b98dbaf4e4d00ff2$export$c039f42b6f13b6ab(spot, startBucket, endBucket) {
    if (endBucket <= startBucket) throw new Error(`Invalid range: endBucket (${endBucket}) must be > startBucket (${startBucket})`);
    $b98dbaf4e4d00ff2$var$markOccupiedInternal(spot, startBucket, endBucket);
}
/**
 * Clear occupancy from a spot for a time range
 * @param spot Spot to clear
 * @param startBucket Start bucket (inclusive)
 * @param endBucket End bucket (EXCLUSIVE)
 * @throws Error if endBucket <= startBucket (validation)
 */ function $b98dbaf4e4d00ff2$var$clearOccupancy(spot, startBucket, endBucket) {
    if (endBucket <= startBucket) throw new Error(`Invalid range: endBucket (${endBucket}) must be > startBucket (${startBucket})`);
    $b98dbaf4e4d00ff2$var$clearOccupancyInternal(spot, startBucket, endBucket);
}
function $b98dbaf4e4d00ff2$export$d2f44a0250447fe3(spot, startBucket, endBucket) {
    if (endBucket <= startBucket) throw new Error(`Invalid range: endBucket (${endBucket}) must be > startBucket (${startBucket})`);
    for(let bucket = startBucket; bucket < endBucket; bucket++){
        const wordIndex = Math.floor(bucket / 64);
        const bitIndex = BigInt(bucket % 64);
        if ((spot.occupancy[wordIndex] & 1n << bitIndex) !== 0n) return false; // Occupied
    }
    return true; // Free
}
function $b98dbaf4e4d00ff2$export$510c3d29f21ee9a9(mover, target, placement, spots, allAircraft, options, moveChain, depth) {
    const { maxRepairMoves: maxRepairMoves = 3, maxDepth: maxDepth = 3 } = options;
    // Enforce move budget
    if (moveChain.length >= maxRepairMoves) return {
        success: false,
        moves: []
    };
    // Enforce depth limit
    if (depth >= maxDepth) return {
        success: false,
        moves: []
    };
    // Performance optimization: Create spot lookup map (O(1) instead of O(n))
    const spotMap = new Map(spots.map((s)=>[
            s.id,
            s
        ]));
    // Get mover's current spot
    const moverPlacement = placement[mover.id];
    if (!moverPlacement || !("spotId" in moverPlacement)) return {
        success: false,
        moves: []
    };
    const originalSpotId = moverPlacement.spotId;
    const originalOrientationId = moverPlacement.orientationId;
    // Find mover's current spot object
    const originalSpot = spotMap.get(originalSpotId);
    if (!originalSpot) return {
        success: false,
        moves: []
    };
    // Transaction log for rollback (more memory efficient than BigUint64Array copy)
    const txLog = new $b98dbaf4e4d00ff2$var$TransactionLog();
    // Remove mover from current spot
    $b98dbaf4e4d00ff2$var$clearOccupancy(originalSpot, mover.arrivalBucket, mover.departureBucket);
    txLog.record(originalSpot, mover.arrivalBucket, mover.departureBucket, 'clear');
    const originalPlacement = placement[mover.id];
    delete placement[mover.id];
    // Check if target can fit in mover's old spot now
    const targetCanFitInOriginal = originalSpot.allowedSizes.includes(target.sizeCategory) && $b98dbaf4e4d00ff2$export$d2f44a0250447fe3(originalSpot, target.arrivalBucket, target.departureBucket);
    if (!targetCanFitInOriginal) {
        // Target still can't fit - rollback and fail
        txLog.rollback();
        placement[mover.id] = originalPlacement;
        return {
            success: false,
            moves: []
        };
    }
    // Target CAN fit! Now find a SIZE-COMPATIBLE spot for mover (excluding original spot)
    // Strategy: Prefer free spots (no cascade), fallback to occupied spots (cascade required)
    let newSpot = null;
    let occupant = null;
    let occupiedCandidate = null;
    // Single pass: Find best spot (free preferred, occupied as fallback)
    for (const spot of spots){
        if (spot.id === originalSpotId) continue; // Skip original
        if (!spot.allowedSizes.includes(mover.sizeCategory)) continue; // Size check
        // Check if spot is free
        const isFree = $b98dbaf4e4d00ff2$export$d2f44a0250447fe3(spot, mover.arrivalBucket, mover.departureBucket);
        if (isFree) {
            // Found a free spot! Use it immediately
            newSpot = spot;
            occupant = null;
            break;
        } else if (!occupiedCandidate) {
            // Not free, but save as fallback candidate for cascading
            const potentialOccupant = $b98dbaf4e4d00ff2$export$6f68ecd6a0141dfe(spot.id, placement, allAircraft);
            if (potentialOccupant) occupiedCandidate = {
                spot: spot,
                occupant: potentialOccupant
            };
        }
    }
    // If no free spot found, use occupied candidate (requires cascade)
    if (!newSpot && occupiedCandidate) {
        newSpot = occupiedCandidate.spot;
        occupant = occupiedCandidate.occupant;
    }
    if (!newSpot) {
        // Can't re-place mover anywhere - rollback and fail
        txLog.rollback();
        placement[mover.id] = originalPlacement;
        return {
            success: false,
            moves: []
        };
    }
    if (occupant === null) {
        // FREE SPOT - success!
        // Place target in original spot
        $b98dbaf4e4d00ff2$export$c039f42b6f13b6ab(originalSpot, target.arrivalBucket, target.departureBucket);
        txLog.record(originalSpot, target.arrivalBucket, target.departureBucket, 'mark');
        placement[target.id] = {
            spotId: originalSpotId,
            orientationId: originalOrientationId
        };
        // Place mover in new spot
        $b98dbaf4e4d00ff2$export$c039f42b6f13b6ab(newSpot, mover.arrivalBucket, mover.departureBucket);
        txLog.record(newSpot, mover.arrivalBucket, mover.departureBucket, 'mark');
        placement[mover.id] = {
            spotId: newSpot.id,
            orientationId: newSpot.orientations[0]?.id || "nose_in" // Use spot's first orientation
        };
        // Success! Clear transaction log (no rollback needed)
        txLog.clear();
        return {
            success: true,
            moves: [
                ...moveChain,
                {
                    aircraft: mover,
                    fromSpot: originalSpotId,
                    toSpot: newSpot.id
                }
            ],
            targetPlacement: {
                spotId: originalSpotId,
                orientationId: originalOrientationId
            }
        };
    } else {
        // CASCADE NEEDED - recursively move occupant
        // First, tentatively place target
        $b98dbaf4e4d00ff2$export$c039f42b6f13b6ab(originalSpot, target.arrivalBucket, target.departureBucket);
        txLog.record(originalSpot, target.arrivalBucket, target.departureBucket, 'mark');
        placement[target.id] = {
            spotId: originalSpotId,
            orientationId: originalOrientationId
        };
        // Try to cascade (nested call will manage its own rollback if needed)
        const cascadeResult = $b98dbaf4e4d00ff2$export$510c3d29f21ee9a9(occupant, target, placement, spots, allAircraft, options, [
            ...moveChain,
            {
                aircraft: mover,
                fromSpot: originalSpotId,
                toSpot: newSpot.id
            }
        ], depth + 1);
        if (cascadeResult.success) {
            // Cascade succeeded! Place mover in new spot
            $b98dbaf4e4d00ff2$export$c039f42b6f13b6ab(newSpot, mover.arrivalBucket, mover.departureBucket);
            txLog.clear(); // Success, no rollback needed
            placement[mover.id] = {
                spotId: newSpot.id,
                orientationId: newSpot.orientations[0]?.id || "nose_in" // Use spot's first orientation
            };
            return cascadeResult;
        } else {
            // Cascade failed - rollback all changes made at this level
            txLog.rollback();
            // Restore placement state
            delete placement[target.id];
            placement[mover.id] = originalPlacement;
            return {
                success: false,
                moves: []
            };
        }
    }
}
function $b98dbaf4e4d00ff2$export$6f68ecd6a0141dfe(spotId, placement, allAircraft) {
    for (const aircraft of allAircraft){
        const aircraftPlacement = placement[aircraft.id];
        if (!aircraftPlacement) continue;
        // Handle single-segment placements
        if ("spotId" in aircraftPlacement) {
            if (aircraftPlacement.spotId === spotId) return aircraft;
        } else // Handle multi-segment placements - check ALL segments
        for (const segment of aircraftPlacement.segments){
            if (segment.spotId === spotId) return aircraft;
        }
    }
    return null;
}

});

parcelRegister("6Fyp7", function(module, exports) {

$parcel$export(module.exports, "attemptLastMinuteInsertion", () => $c80f30b1a85264e7$export$2530c63aad3220fa);
/**
 * Last-Minute Insertion Module - Phase 4
 * Last-Minute Insertion Implementation
 *
 * Combines all pieces into three-tier insertion strategy:
 * - Tier 1: Zero-disruption (try with all existing locked)
 * - Tier 2: Local repair (allow limited moves with cascade)
 * - Tier 3: Failed (report impossibility with analysis)
 */ 
var $l9gjg = parcelRequire("l9gjg");

var $lp3Lc = parcelRequire("lp3Lc");

var $3kHDf = parcelRequire("3kHDf");
function $c80f30b1a85264e7$export$2530c63aad3220fa(newTrip, existingPlacements, spots, allRequests, options) {
    const { maxDisruption: maxDisruption, stickinessWeight: stickinessWeight = 10.0, allowTrapping: allowTrapping = false, egressWeight: egressWeight = 5.0, bufferMinutes: bufferMinutes = 15, tryLocalRepair: tryLocalRepair = true, horizonHours: horizonHours = 24 } = options;
    // Validate maxDisruption range (0-5 per design spec)
    if (maxDisruption < 0 || maxDisruption > 5) throw new Error(`maxDisruption must be between 0-5, got ${maxDisruption}`);
    // Clone spots for Tier 1 to prevent bitmap corruption
    // parkingAlgorithm mutates occupancy bitmaps, so we need clean state for Tier 2
    const spotsCopyTier1 = spots.map((s)=>({
            ...s,
            occupancy: new BigUint64Array(s.occupancy)
        }));
    // TIER 1: Zero-disruption attempt
    const zeroResult = $c80f30b1a85264e7$var$tryZeroDisruptionPlacement(newTrip, existingPlacements, spotsCopyTier1, // Use copy to prevent corruption
    {
        bufferMinutes: bufferMinutes,
        egressWeight: egressWeight,
        allowTrapping: allowTrapping,
        horizonHours: horizonHours
    });
    if (zeroResult.success) return {
        success: true,
        tier: "zero-disruption",
        placement: zeroResult.placement,
        disruptedAircraft: [],
        totalMoves: 0,
        decisionLog: zeroResult.decisionLog,
        analysis: {
            attemptedZeroDisruption: true,
            attemptedLocalRepair: false
        }
    };
    // TIER 2: Local repair (if enabled and budget allows)
    if (tryLocalRepair && maxDisruption > 0) {
        const repairResult = $c80f30b1a85264e7$var$tryLocalRepairInsertion(newTrip, existingPlacements, spots, allRequests, {
            maxDisruption: maxDisruption,
            stickinessWeight: stickinessWeight,
            egressWeight: egressWeight,
            bufferMinutes: bufferMinutes,
            allowTrapping: allowTrapping
        });
        if (repairResult.success && repairResult.totalMoves <= maxDisruption) {
            // Combine zero-disruption log (NEW's attempt) with repair log (moves)
            const combinedLog = [
                ...zeroResult.decisionLog,
                ...repairResult.decisionLog
            ];
            return {
                success: true,
                tier: "local-repair",
                placement: repairResult.placement,
                disruptedAircraft: repairResult.disruptedAircraft,
                totalMoves: repairResult.totalMoves,
                decisionLog: combinedLog,
                analysis: {
                    attemptedZeroDisruption: true,
                    attemptedLocalRepair: true
                }
            };
        }
    }
    // TIER 3: Failed
    const failureReason = $c80f30b1a85264e7$var$generateFailureReason(newTrip, spots, allRequests, maxDisruption, zeroResult.decisionLog);
    return {
        success: false,
        tier: "failed",
        disruptedAircraft: [],
        totalMoves: 0,
        decisionLog: zeroResult.decisionLog,
        analysis: {
            attemptedZeroDisruption: true,
            attemptedLocalRepair: tryLocalRepair && maxDisruption > 0,
            failureReason: failureReason
        }
    };
}
/**
 * Tier 1: Try zero-disruption placement
 * Tries to place new trip WITHOUT moving any existing aircraft
 * Assumes spots' bitmaps already reflect existing placements
 */ function $c80f30b1a85264e7$var$tryZeroDisruptionPlacement(newTrip, existingPlacements, spots, options) {
    // Run algorithm with ONLY the new trip
    // Existing aircraft's spots are already marked occupied in bitmaps
    const zones = [];
    const placement = (0, $3kHDf.parkingAlgorithm)([
        newTrip
    ], // ONLY new trip
    spots, options.bufferMinutes, 0, // plannedMoveCap
    options.allowTrapping, options.egressWeight, 1.0, // wasteWeight - standard waste penalty
    0.1, // structuralWeight - tiebreaker for spot complexity
    "arrival", options.horizonHours, false, // useMaskOptimization
    false, // validateMasks
    1.0, // zonePriorityWeight - standard zone preference
    zones, 2.0, // min_dwell_weight - standard min dwell enforcement
    0.0 // No stickiness for new trip (no previous placement)
    );
    const log = (0, $3kHDf.getDecisionLog)();
    // Check if new trip was placed
    const newTripPlaced = placement[newTrip.id] !== undefined;
    // Merge with existing placements if successful
    const finalPlacement = newTripPlaced ? {
        ...existingPlacements,
        ...placement
    } : undefined;
    return {
        success: newTripPlaced,
        placement: finalPlacement,
        decisionLog: log
    };
}
/**
 * Tier 2: Try local repair with cascades
 * Uses neighborhood selection and cascade repair
 */ function $c80f30b1a85264e7$var$tryLocalRepairInsertion(newTrip, existingPlacements, spots, allRequests, options) {
    // Find candidate aircraft to move
    const candidates = (0, $lp3Lc.findRepairNeighborhood)(newTrip, existingPlacements, spots, allRequests);
    if (candidates.length === 0) // No candidates (all aircraft in incompatible spots)
    return {
        success: false,
        disruptedAircraft: [],
        totalMoves: 0,
        decisionLog: []
    };
    // Try cascade repair with each candidate (sorted by moveability)
    // No need to clone - tryCascadeRepair handles rollback with TransactionLog
    for (const candidate of candidates){
        // Create working copies of placement and spots for this attempt
        // Deep clone placement (simple object structure)
        const placementCopy = {};
        for (const [id, place] of Object.entries(existingPlacements))if ("spotId" in place) placementCopy[id] = {
            spotId: place.spotId,
            orientationId: place.orientationId
        };
        else placementCopy[id] = {
            segments: place.segments.map((seg)=>({
                    ...seg
                })),
            moveCount: place.moveCount
        };
        // Clone spots (including shape reference - shallow copy is fine)
        const spotsCopy = spots.map((s)=>({
                ...s,
                occupancy: new BigUint64Array(s.occupancy)
            }));
        const result = (0, $l9gjg.tryCascadeRepair)(candidate, newTrip, placementCopy, spotsCopy, allRequests, {
            maxRepairMoves: options.maxDisruption,
            maxDepth: 3
        }, [], 0);
        if (result.success && result.moves.length <= options.maxDisruption) {
            // Success! Build decision log entries for moves
            const moveLog = result.moves.map((move)=>({
                    aircraftId: move.aircraft.id,
                    spotId: move.toSpot,
                    type: "moved",
                    fromSpot: move.fromSpot,
                    toSpot: move.toSpot,
                    moveReason: "Last-minute insertion cascade"
                }));
            return {
                success: true,
                placement: placementCopy,
                disruptedAircraft: result.moves.map((m)=>m.aircraft.id),
                totalMoves: result.moves.length,
                decisionLog: moveLog
            };
        }
    // tryCascadeRepair rolled back on failure, spotsCopy discarded
    // Continue to next candidate
    }
    // All candidates failed
    return {
        success: false,
        disruptedAircraft: [],
        totalMoves: 0,
        decisionLog: []
    };
}
/**
 * Generate helpful failure reason
 */ function $c80f30b1a85264e7$var$generateFailureReason(newTrip, spots, _allRequests, maxDisruption, _decisionLog) {
    // Find compatible spots
    const compatibleSpots = spots.filter((s)=>s.allowedSizes.includes(newTrip.sizeCategory));
    if (compatibleSpots.length === 0) return `No spots on ramp can accommodate ${newTrip.sizeCategory} aircraft`;
    // Check if it's a budget issue
    if (maxDisruption === 0) return `Cannot fit without disruption. All ${compatibleSpots.length} compatible spots are occupied. Increase maxDisruption to allow moves.`;
    // General failure
    return `Cannot fit within ${maxDisruption} move budget. Try increasing maxDisruption or adjusting arrival/departure times.`;
}

});
parcelRegister("lp3Lc", function(module, exports) {

$parcel$export(module.exports, "findRepairNeighborhood", () => $428f99a9bf28ad42$export$f08653f361cad991);
/**
 * Neighborhood Selection Module - Phase 1.2
 * Last-Minute Insertion Implementation
 *
 * Finds candidate aircraft that could be moved to make space
 * for last-minute insertions.
 *
 * Critical optimization: Size compatibility filter eliminates 80%+ of candidates
 * by only considering aircraft in spots where the target aircraft can physically fit.
 */ 
var $aFzkS = parcelRequire("aFzkS");
/**
 * Get spot IDs where aircraft is placed during target's time window
 * Handles both single-segment and multi-segment placements
 */ function $428f99a9bf28ad42$var$getSpotsOccupiedDuringWindow(placement, targetStart, targetEnd) {
    if ("spotId" in placement) // Single segment - always occupies this spot
    return [
        placement.spotId
    ];
    // Multi-segment - find segments that overlap target's time window
    const overlappingSpots = [];
    for (const segment of placement.segments)// Check if segment overlaps with target window
    // Overlap if: segment.end > targetStart AND segment.start < targetEnd
    if (segment.endBucket > targetStart && segment.startBucket < targetEnd) overlappingSpots.push(segment.spotId);
    return overlappingSpots;
}
function $428f99a9bf28ad42$export$f08653f361cad991(target, existingPlacements, spots, allAircraft, options = {}) {
    const { maxNeighborSize: maxNeighborSize = 8 } = options;
    // Performance optimization: Create spot lookup map (O(1) instead of O(n))
    const spotMap = new Map(spots.map((s)=>[
            s.id,
            s
        ]));
    const candidates = [];
    for (const other of allAircraft){
        // Skip the target aircraft itself
        if (other.id === target.id) continue;
        // Filter 1: Temporal overlap
        // Aircraft must be present during some portion of target's dwell
        // Overlap condition: other departs after target arrives AND other arrives before target departs
        const overlaps = other.departureBucket > target.arrivalBucket && other.arrivalBucket < target.departureBucket;
        if (!overlaps) continue;
        // Filter 2: SIZE COMPATIBILITY - Critical optimization!
        // Only consider aircraft in spots where target can physically fit
        // This eliminates 80%+ of candidates immediately
        const otherPlacement = existingPlacements[other.id];
        if (!otherPlacement) continue; // Aircraft not placed yet, skip
        // Get all spots where 'other' is located during target's time window
        const occupiedSpotIds = $428f99a9bf28ad42$var$getSpotsOccupiedDuringWindow(otherPlacement, target.arrivalBucket, target.departureBucket);
        if (occupiedSpotIds.length === 0) continue; // No spots occupied during overlap (shouldn't happen if temporal filter worked)
        // Check if target can fit in ANY of the spots this aircraft occupies
        const targetCanFitInAnySpot = occupiedSpotIds.some((spotId)=>{
            const spot = spotMap.get(spotId);
            return spot && spot.allowedSizes.includes(target.sizeCategory);
        });
        if (!targetCanFitInAnySpot) continue; // Skip - target can't use any of the spots this aircraft occupies
        // Filter 3: Compute moveability
        const moveability = (0, $aFzkS.computeMoveability)(other, spots);
        candidates.push({
            aircraft: other,
            moveability: moveability
        });
    }
    // Sort by moveability (lower score = easier to move = higher priority)
    candidates.sort((a, b)=>a.moveability - b.moveability);
    // Take top N candidates
    const topCandidates = candidates.slice(0, maxNeighborSize);
    // Return just the aircraft (strip moveability scores)
    return topCandidates.map((c)=>c.aircraft);
}

});
parcelRegister("aFzkS", function(module, exports) {

$parcel$export(module.exports, "computeMoveability", () => $735e4a98220c5f6f$export$92eb7646572fa45f);
/**
 * Moveability Scoring Module - Phase 1.1
 * Last-Minute Insertion Implementation
 *
 * Determines which aircraft are "cheap" to move when making space
 * for last-minute insertions.
 *
 * Lower score = easier to move
 *
 * Scoring factors:
 * 1. Priority (higher priority = harder to move)
 * 2. Locked status (locked = essentially unmoveable)
 * 3. Fairness (exponential penalty for recent moves)
 * 4. Dwell length (longer dwell = harder to re-place)
 * 5. Alternative spots (fewer alternatives = harder to move)
 */ function $735e4a98220c5f6f$export$92eb7646572fa45f(aircraft, spots, options = {}) {
    const { priorityWeight: priorityWeight = 100, dwellWeight: dwellWeight = 1.0, fairnessWeight: fairnessWeight = 50, alternativesWeight: alternativesWeight = 20, currentBucket: currentBucket = 0 } = options;
    let score = 0;
    // 1. Priority factor (higher priority = harder to move)
    const priority = aircraft.priority ?? 5; // Default priority is 5 (use ?? to handle 0)
    score += priority * priorityWeight;
    // 2. Locked status (essentially unmoveable)
    if (aircraft.lockedUntilBucket && currentBucket < aircraft.lockedUntilBucket) score += 10000; // Make locked aircraft essentially unmoveable
    // 3. Fairness - exponential penalty for recent moves
    // Formula: 2^n - 1, where n = number of moves
    // Results: 0 moves → 0, 1 move → 1, 2 moves → 3, 3 moves → 7, etc.
    const moveHistory = aircraft.metadata?.moveHistory || [];
    const fairnessPenalty = Math.pow(2, moveHistory.length) - 1;
    score += fairnessPenalty * fairnessWeight;
    // 4. Dwell length (longer = harder to re-place)
    const dwellBuckets = aircraft.departureBucket - aircraft.arrivalBucket;
    score += dwellBuckets * dwellWeight;
    // 5. Alternative spots (fewer = harder to move)
    // Use inverse ratio: 0 alternatives = max penalty, all spots = 0 penalty
    const alternativeCount = $735e4a98220c5f6f$export$86b7a514999b6963(aircraft, spots);
    const totalSpots = spots.length;
    const flexibilityRatio = totalSpots > 0 ? alternativeCount / totalSpots : 0;
    const alternativesPenalty = (1 - flexibilityRatio) * alternativesWeight * 10;
    score += alternativesPenalty;
    return score;
}
function $735e4a98220c5f6f$export$86b7a514999b6963(aircraft, spots, checkTimeAvailability = false) {
    let count = 0;
    for (const spot of spots){
        // Check if aircraft size is in spot's allowedSizes array
        if (!spot.allowedSizes.includes(aircraft.sizeCategory)) continue;
        // Optionally check time availability (more accurate but slower)
        if (checkTimeAvailability) {
            // Check if spot is available during aircraft's dwell
            let available = true;
            for(let bucket = aircraft.arrivalBucket; bucket < aircraft.departureBucket; bucket++){
                const wordIndex = Math.floor(bucket / 64);
                const bitIndex = BigInt(bucket % 64);
                if ((spot.occupancy[wordIndex] & 1n << bitIndex) !== 0n) {
                    available = false;
                    break;
                }
            }
            if (!available) continue;
        }
        count++;
    }
    return count;
}

});



parcelRegister("ixuXj", function(module, exports) {

$parcel$export(module.exports, "planParkingAssignments", () => $76b459c158a3ec46$export$ebba00cbc93c5030);
$parcel$export(module.exports, "planSnapshotPlacement", () => $76b459c158a3ec46$export$dcb4465661e2670a);
/**
 * Temporal Planner - Step 0+1 Implementation
 * Wraps placement algorithm with time bitmap management
 *
 * Provides two interfaces:
 * - planParkingAssignments: Full temporal planning over time horizon
 * - planSnapshotPlacement: Simplified API for current ramp state (single moment)
 */ 
var $3kHDf = parcelRequire("3kHDf");
function $76b459c158a3ec46$export$ebba00cbc93c5030(requests, spots, bufferMinutes = 15, plannedMoveCap = 0, allowTrapping = true, egressWeight = 1.0, wasteWeight = 1.0, structuralWeight = 0.1, sortingStrategy = "arrival", horizonHours = 24, // shapes parameter REMOVED - use spot.shape instead
useMaskOptimization = false, validateMasks = false, zonePriorityWeight = 1.0, zones = [], min_dwell_weight = 2.0) {
    console.log(`[TemporalPlanner] Starting placement for ${requests.length} requests on ${spots.length} spots`);
    console.log(`[TemporalPlanner] Buffer: ${bufferMinutes}min, Move cap: ${plannedMoveCap}, Allow trapping: ${allowTrapping}, Egress weight: ${egressWeight}x, Waste weight: ${wasteWeight}x, Structural weight: ${structuralWeight}x, Sorting: ${sortingStrategy}`);
    if (useMaskOptimization) console.log(`[TemporalPlanner] Phase 9: Mask optimization enabled (validate: ${validateMasks})`);
    // Call placement algorithm
    // The algorithm checks time availability using spot.occupancy bitmaps
    // and reserves spots as it makes placements
    const placement = (0, $3kHDf.parkingAlgorithm)(requests, spots, bufferMinutes, plannedMoveCap, allowTrapping, egressWeight, wasteWeight, structuralWeight, sortingStrategy, horizonHours, // shapes parameter removed - using spot.shape
    useMaskOptimization, validateMasks, zonePriorityWeight, zones, min_dwell_weight);
    // Gather stats
    const placedIds = new Set(Object.keys(placement));
    const unplacedAircraftIds = requests.filter((req)=>!placedIds.has(req.id)).map((req)=>req.id);
    // Count segmented placements (aircraft with multiple segments)
    let plannedMoves = 0;
    for(const aircraftId in placement){
        const p = placement[aircraftId];
        if ("segments" in p && p.segments.length > 1) plannedMoves++;
    }
    const stats = {
        totalAircraft: requests.length,
        placed: placedIds.size,
        unplaced: unplacedAircraftIds.length,
        totalMovements: 0,
        plannedMoves: // unused in v1
        plannedMoves
    };
    return {
        placement: placement,
        stats: stats,
        unplacedAircraftIds: unplacedAircraftIds,
        log: (0, $3kHDf.getDecisionLog)()
    };
}
function $76b459c158a3ec46$export$dcb4465661e2670a(requests, spots, allowTrapping = false, egressWeight = 1.0, wasteWeight = 1.0, structuralWeight = 0.1, sortingStrategy = "size-constrained", zonePriorityWeight = 1.0, zones = []) {
    // Convert all requests to snapshot mode (all at bucket 0)
    // This eliminates time conflicts - all aircraft exist at same moment
    const snapshotRequests = requests.map((req)=>({
            ...req,
            arrivalBucket: 0,
            departureBucket: 1 // Single bucket [0, 1) represents the snapshot moment
        }));
    // Call full temporal planner with snapshot-appropriate settings
    return $76b459c158a3ec46$export$ebba00cbc93c5030(snapshotRequests, spots, 0, // bufferMinutes: no buffers for snapshot
    0, // plannedMoveCap: no segmentation for snapshot
    allowTrapping, egressWeight, wasteWeight, structuralWeight, sortingStrategy, 0.25, // horizonHours: 1 bucket = 15 minutes (0.25 hours) is sufficient for snapshot
    // shapes parameter removed
    false, // useMaskOptimization: not needed for snapshot
    false, // validateMasks: not needed for snapshot
    zonePriorityWeight, zones);
}

});


parcelRegister("i8ggZ", function(module, exports) {

$parcel$export(module.exports, "captureTestData", () => $75cd57c8d8d957af$export$4feab7091ba2265f);
/**
 * Test Data Capture for AutoPark Debugging
 *
 * Automatically captures all inputs/outputs when AutoPark runs, detects duplicates,
 * and generates ready-to-use unit test code for reproduction.
 */ function $75cd57c8d8d957af$export$7286052e0d0247f4(placement, requests) {
    const result = {
        hasDuplicates: false,
        duplicateAircraft: [],
        overlappingSpots: []
    };
    // Build request lookup map for tail numbers
    const requestMap = new Map();
    requests.forEach((req)=>{
        requestMap.set(req.id, req);
    });
    // Check 1: Same aircraft placed multiple times
    // (Single-spot placements should never duplicate, but multi-segment might have bugs)
    const aircraftSpots = new Map();
    for (const [requestId, placementData] of Object.entries(placement)){
        const spots = [];
        if ("spotId" in placementData) {
            // Single-spot placement
            const request = requestMap.get(requestId);
            if (request) spots.push({
                spotId: placementData.spotId,
                startBucket: request.arrivalBucket,
                endBucket: request.departureBucket
            });
        } else // Multi-segment placement
        for (const seg of placementData.segments)spots.push({
            spotId: seg.spotId,
            startBucket: seg.startBucket,
            endBucket: seg.endBucket
        });
        aircraftSpots.set(requestId, spots);
    }
    // Check for aircraft with overlapping time ranges in different spots
    for (const [requestId, spots] of aircraftSpots.entries())if (spots.length > 1) {
        // Check if any segments overlap in time
        const hasOverlap = spots.some((spot1, i)=>spots.slice(i + 1).some((spot2)=>{
                const overlap = spot1.startBucket < spot2.endBucket && spot2.startBucket < spot1.endBucket;
                return overlap;
            }));
        if (hasOverlap) {
            const request = requestMap.get(requestId);
            result.hasDuplicates = true;
            result.duplicateAircraft.push({
                requestId: requestId,
                tailNumber: request?.tail_number || "Unknown",
                spots: spots
            });
        }
    }
    // Check 2: Multiple aircraft in same spot at same time
    // Build spot → aircraft map with time ranges
    const spotOccupancy = new Map();
    for (const [requestId, placementData] of Object.entries(placement)){
        const request = requestMap.get(requestId);
        const tailNumber = request?.tail_number || "Unknown";
        if ("spotId" in placementData) {
            // Single-spot placement
            const spotId = placementData.spotId;
            if (!spotOccupancy.has(spotId)) spotOccupancy.set(spotId, []);
            if (request) spotOccupancy.get(spotId).push({
                requestId: requestId,
                tailNumber: tailNumber,
                startBucket: request.arrivalBucket,
                endBucket: request.departureBucket
            });
        } else // Multi-segment placement
        for (const seg of placementData.segments){
            if (!spotOccupancy.has(seg.spotId)) spotOccupancy.set(seg.spotId, []);
            spotOccupancy.get(seg.spotId).push({
                requestId: requestId,
                tailNumber: tailNumber,
                startBucket: seg.startBucket,
                endBucket: seg.endBucket
            });
        }
    }
    // Check each spot for overlapping aircraft
    for (const [spotId, aircraft] of spotOccupancy.entries())if (aircraft.length > 1) {
        // Check if any aircraft overlap in time
        for(let i = 0; i < aircraft.length; i++)for(let j = i + 1; j < aircraft.length; j++){
            const a1 = aircraft[i];
            const a2 = aircraft[j];
            const overlap = a1.startBucket < a2.endBucket && a2.startBucket < a1.endBucket;
            if (overlap) {
                result.hasDuplicates = true;
                // Check if already added
                if (!result.overlappingSpots.some((s)=>s.spotId === spotId && s.aircraft.length === aircraft.length)) result.overlappingSpots.push({
                    spotId: spotId,
                    aircraft: aircraft
                });
                break;
            }
        }
    }
    return result;
}
/**
 * Serialize spot for test data (minimal representation)
 * Removes occupancy bitmap (runtime state) and includes only essential fields
 */ function $75cd57c8d8d957af$var$serializeSpot(spot) {
    return `{
    id: "${spot.id}",
    zoneId: "${spot.zoneId}",
    allowedSizes: [${spot.allowedSizes.map((s)=>`"${s}"`).join(", ")}],
    orientations: [${spot.orientations.map((o)=>`{ id: "${o.id}" }`).join(", ")}],
    max_dwell_minutes: ${spot.max_dwell_minutes ?? "undefined"},
    disabled: ${spot.disabled ?? false},
    ${spot.egressOptions ? `egressOptions: [${spot.egressOptions.map((opt)=>`{ laneId: "${opt.laneId}", laneName: "${opt.laneName}", blocksSpotIds: [${opt.blocksSpotIds.map((id)=>`"${id}"`).join(", ")}] }`).join(", ")}],` : ""}
  }`;
}
/**
 * Serialize parking request for test data
 */ function $75cd57c8d8d957af$var$serializeRequest(request) {
    return `{
    id: "${request.id}",
    tail_number: "${request.tail_number || "Unknown"}",
    sizeCategory: "${request.sizeCategory}",
    arrivalBucket: ${request.arrivalBucket},
    departureBucket: ${request.departureBucket},
    aircraft: {
      wingspan: ${request.aircraft?.wingspan ?? 0},
      length: ${request.aircraft?.length ?? 0},
    },
  }`;
}
/**
 * Serialize zone for test data
 */ function $75cd57c8d8d957af$var$serializeZone(zone) {
    return `{
    id: "${zone.id}",
    name: "${zone.name}",
    spotIds: [${zone.spotIds.map((id)=>`"${id}"`).join(", ")}],
    priority: ${zone.priority ?? 5},
    disabled: ${zone.disabled ?? false},
  }`;
}
function $75cd57c8d8d957af$export$ebb3df2c6d9fb774(requests, spots, zones, config, placement, duplicateInfo) {
    const testName = `reproduces duplicate placement bug (${new Date().toISOString()})`;
    return `
/**
 * AUTO-GENERATED TEST DATA
 * Captured from AutoPark run at ${new Date().toISOString()}
 *
 * Duplicate Detection:
${duplicateInfo.duplicateAircraft.map((dup)=>` * - Aircraft ${dup.tailNumber} (${dup.requestId}) placed in ${dup.spots.length} spots`).join("\n")}
${duplicateInfo.overlappingSpots.map((overlap)=>` * - Spot ${overlap.spotId} has ${overlap.aircraft.length} overlapping aircraft`).join("\n")}
 */

import { parkingAlgorithm } from "../parkingAlgorithm";
import { detectDuplicates } from "../testDataCapture";
import { makeEmptyMask } from "../bitmap";
import { ParkingRequest, Spot, Zone } from "../types";

describe("AutoPark duplicate bug", () => {
  it("${testName}", () => {
    // Test data captured from production run
    const horizonHours = ${config.horizonHours};
    const totalBuckets = horizonHours * 4;

    const requests: ParkingRequest[] = [
${requests.map((req)=>"      " + $75cd57c8d8d957af$var$serializeRequest(req)).join(",\n")}
    ];

    const spots: Spot[] = [
${spots.map((spot)=>"      " + $75cd57c8d8d957af$var$serializeSpot(spot)).join(",\n")}
    ].map(spot => ({
      ...spot,
      occupancy: makeEmptyMask(totalBuckets),
    }));

    const zones: Zone[] = [
${zones.map((zone)=>"      " + $75cd57c8d8d957af$var$serializeZone(zone)).join(",\n")}
    ];

    // Run algorithm with captured config
    const placement = parkingAlgorithm(
      requests,
      spots,
      ${config.bufferMinutes}, // bufferMinutes
      ${config.plannedMoveCap}, // plannedMoveCap
      ${config.allowTrapping}, // allowTrapping
      ${config.egressWeight}, // egressWeight
      ${config.wasteWeight}, // wasteWeight
      0.1, // structuralWeight
      "arrival", // sortingStrategy
      horizonHours,
      undefined, // shapes
      false, // useMaskOptimization
      false, // validateMasks
      ${config.zonePriorityWeight}, // zonePriorityWeight
      zones
    );

    // Detect duplicates
    const duplicateInfo = detectDuplicates(placement, requests);

    // Log duplicates for debugging
    if (duplicateInfo.hasDuplicates) {
      console.log("=== DUPLICATES DETECTED ===");
      console.log("Duplicate Aircraft:", JSON.stringify(duplicateInfo.duplicateAircraft, null, 2));
      console.log("Overlapping Spots:", JSON.stringify(duplicateInfo.overlappingSpots, null, 2));
    }

    // Assert no duplicates
    expect(duplicateInfo.hasDuplicates).toBe(false);
    expect(duplicateInfo.duplicateAircraft).toHaveLength(0);
    expect(duplicateInfo.overlappingSpots).toHaveLength(0);
  });
});
`;
}
function $75cd57c8d8d957af$export$4feab7091ba2265f(requests, spots, zones, config, placement) {
    // Detect duplicates
    const duplicateInfo = $75cd57c8d8d957af$export$7286052e0d0247f4(placement, requests);
    // Only log if duplicates detected
    if (duplicateInfo.hasDuplicates) {
        console.error("=== \u26A0\uFE0F  DUPLICATE PLACEMENT DETECTED IN AUTOPARK ===");
        console.error(`Found ${duplicateInfo.duplicateAircraft.length} aircraft with duplicate placements`);
        console.error(`Found ${duplicateInfo.overlappingSpots.length} spots with overlapping aircraft`);
        // Log details
        duplicateInfo.duplicateAircraft.forEach((dup)=>{
            console.error(`  - Aircraft ${dup.tailNumber} (${dup.requestId}) placed in ${dup.spots.length} spots:`);
            dup.spots.forEach((spot)=>{
                console.error(`    - Spot ${spot.spotId}: buckets ${spot.startBucket}-${spot.endBucket}`);
            });
        });
        duplicateInfo.overlappingSpots.forEach((overlap)=>{
            console.error(`  - Spot ${overlap.spotId} has ${overlap.aircraft.length} overlapping aircraft:`);
            overlap.aircraft.forEach((ac)=>{
                console.error(`    - ${ac.tailNumber} (${ac.requestId}): buckets ${ac.startBucket}-${ac.endBucket}`);
            });
        });
        // Generate test code
        const testCode = $75cd57c8d8d957af$export$ebb3df2c6d9fb774(requests, spots, zones, config, placement, duplicateInfo);
        console.error("\n=== COPY THIS TEST CODE TO REPRODUCE ===");
        console.error("File: app/src/screens/Ramp/TemporalTest/__tests__/duplicateBug.test.ts");
        console.error(testCode);
        console.error("=== END TEST CODE ===\n");
    }
}

});

parcelRegister("h7RLZ", function(module, exports) {

$parcel$export(module.exports, "detectPartialPlacements", () => $f40ca3616e00e1af$export$d3650980a73c8ed0);
$parcel$export(module.exports, "formatDuration", () => $f40ca3616e00e1af$export$bc733b0c5cbb3e8a);
$parcel$export(module.exports, "formatTimeRange", () => $f40ca3616e00e1af$export$b40fc491ceb69c4e);
/**
 * Utility for detecting partial placements in AutoPark results
 *
 * A "partial placement" occurs when an aircraft is placed for only PART of its trip duration,
 * leaving gaps where it's assigned to the ramp but has no physical position.
 */ function $f40ca3616e00e1af$export$d3650980a73c8ed0(placement, requests, startTime) {
    const partialPlacements = [];
    // Convert time bucket to actual date
    const bucketToDate = (bucket)=>{
        const minutes = bucket * 15; // 15-minute buckets
        return new Date(startTime.getTime() + minutes * 60000);
    };
    // Process each request to check for partial placements
    for (const request of requests){
        const placementData = placement[request.id];
        // Skip if aircraft wasn't placed at all
        if (!placementData) continue;
        const tripStart = bucketToDate(request.arrivalBucket);
        const tripEnd = bucketToDate(request.departureBucket);
        const totalDurationMinutes = (tripEnd.getTime() - tripStart.getTime()) / 60000;
        // Collect all placed time periods
        const placedPeriods = [];
        if ("spotId" in placementData) // Single-spot placement (no moves)
        placedPeriods.push({
            start: tripStart,
            end: tripEnd
        });
        else // Multi-segment placement (with moves)
        for (const segment of placementData.segments)placedPeriods.push({
            start: bucketToDate(segment.startBucket),
            end: bucketToDate(segment.endBucket)
        });
        // Sort placed periods by start time
        placedPeriods.sort((a, b)=>a.start.getTime() - b.start.getTime());
        // Calculate total placed duration
        const placedDurationMinutes = placedPeriods.reduce((sum, period)=>sum + (period.end.getTime() - period.start.getTime()) / 60000, 0);
        // Detect gaps in the timeline
        const gaps = [];
        let currentTime = tripStart;
        for (const placedPeriod of placedPeriods){
            // If there's a gap before this placed period
            if (currentTime < placedPeriod.start) {
                const gapDuration = (placedPeriod.start.getTime() - currentTime.getTime()) / 60000;
                gaps.push({
                    startTime: currentTime,
                    endTime: placedPeriod.start,
                    durationMinutes: gapDuration
                });
            }
            currentTime = placedPeriod.end;
        }
        // Check for gap after all placed periods
        if (currentTime < tripEnd) {
            const gapDuration = (tripEnd.getTime() - currentTime.getTime()) / 60000;
            gaps.push({
                startTime: currentTime,
                endTime: tripEnd,
                durationMinutes: gapDuration
            });
        }
        // If there are gaps, this is a partial placement
        if (gaps.length > 0) {
            const gapDurationMinutes = gaps.reduce((sum, gap)=>sum + gap.durationMinutes, 0);
            const gapPercentage = gapDurationMinutes / totalDurationMinutes * 100;
            partialPlacements.push({
                aircraftId: request.id,
                tailNumber: request.tail_number || request.id,
                tripStart: tripStart,
                tripEnd: tripEnd,
                totalDurationMinutes: totalDurationMinutes,
                placedDurationMinutes: placedDurationMinutes,
                gapDurationMinutes: gapDurationMinutes,
                gapPercentage: gapPercentage,
                gaps: gaps
            });
        }
    }
    return partialPlacements;
}
function $f40ca3616e00e1af$export$bc733b0c5cbb3e8a(minutes) {
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor(minutes % 1440 / 60);
    const mins = Math.floor(minutes % 60);
    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (mins > 0) parts.push(`${mins}m`);
    return parts.length > 0 ? parts.join(" ") : "0m";
}
function $f40ca3616e00e1af$export$b40fc491ceb69c4e(startTime, endTime) {
    const formatDate = (date)=>{
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
    };
    const formatTime = (date)=>{
        return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };
    const startDate = formatDate(startTime);
    const endDate = formatDate(endTime);
    const startTimeStr = formatTime(startTime);
    const endTimeStr = formatTime(endTime);
    if (startDate === endDate) return `${startDate} ${startTimeStr} - ${endTimeStr}`;
    else return `${startDate} at ${startTimeStr} - ${endDate} at ${endTimeStr}`;
}

});

parcelRegister("kJI4m", function(module, exports) {

$parcel$export(module.exports, "groupPlacementsByTrip", () => $82980847855f463f$export$1d00f75fddf2128f);
function $82980847855f463f$export$1d00f75fddf2128f(placements) {
    // Group placements by trip_id
    const tripMap = new Map();
    placements.forEach((placement)=>{
        const tripId = placement.trip_id;
        if (!tripMap.has(tripId)) tripMap.set(tripId, []);
        tripMap.get(tripId).push(placement);
    });
    // Convert to GroupedTrip array
    const groupedTrips = [];
    tripMap.forEach((segments, tripId)=>{
        // Sort segments by start time
        const sortedSegments = segments.sort((a, b)=>new Date(a.start_time).getTime() - new Date(b.start_time).getTime());
        // Use first segment for aircraft details (all segments should have same details)
        const firstSegment = sortedSegments[0];
        // Find earliest start and latest end across all segments
        const startTime = sortedSegments.reduce((earliest, seg)=>{
            const segStart = new Date(seg.start_time);
            return segStart < new Date(earliest) ? seg.start_time : earliest;
        }, sortedSegments[0].start_time);
        const endTime = sortedSegments.reduce((latest, seg)=>{
            const segEnd = new Date(seg.end_time);
            return segEnd > new Date(latest) ? seg.end_time : latest;
        }, sortedSegments[0].end_time);
        groupedTrips.push({
            trip_id: tripId,
            tail_number: firstSegment.tail_number,
            aircraft_model: firstSegment.aircraft_model,
            aircraft_make: firstSegment.aircraft_make,
            start_time: startTime,
            end_time: endTime,
            segment_count: segments.length,
            placement_ids: segments.map((s)=>s.id)
        });
    });
    // Sort by start time for consistent display
    return groupedTrips.sort((a, b)=>new Date(a.start_time).getTime() - new Date(b.start_time).getTime());
}

});


parcelRegister("8QpHy", function(module, exports) {

$parcel$export(module.exports, "AircraftListItem", () => $0e8fbea5ecb28545$export$c13fce52ebfd2e64);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $fu9Og = parcelRequire("fu9Og");

var $1KiAb = parcelRequire("1KiAb");

var $keHtM = parcelRequire("keHtM");

var $ZrAde = parcelRequire("ZrAde");

var $85p2A = parcelRequire("85p2A");

var $24c6l = parcelRequire("24c6l");
const $0e8fbea5ecb28545$var$PlacementSetting = ({ icon: icon, text: text })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "caption",
                children: text
            })
        ]
    }, `PlacementSetting-${text.replace(/ /g, "-")}`);
const $0e8fbea5ecb28545$var$ORDERED_PREFERENCES = [
    (0, $keHtM.Preference).TAIL_IN,
    (0, $keHtM.Preference).NOSE_IN,
    (0, $keHtM.Preference).PREFER_FRONT_ROW,
    (0, $keHtM.Preference).PREFER_BACK_ROW,
    (0, $keHtM.Preference).OK_TO_LEAVE_OUT,
    (0, $keHtM.Preference).LOCKED,
    (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN,
    (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN
];
const $0e8fbea5ecb28545$export$5ecb4548b7ebc388 = ({ stack: stack, setStack: setStack, tenant: tenant, setTenant: setTenant, onSelectAircraft: onSelectAircraft, onDeleteAircraft: onDeleteAircraft, onIncrementalPark: onIncrementalPark })=>{
    const rampState = (0, $1KiAb.useOptionalRampState)();
    const isRamp = Boolean(rampState?.ramp);
    const theme = (0, $14H9o.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        className: tenant.selected && "selected",
        "data-element": "li_current_aircraft",
        spacing: 1,
        sx: {
            backgroundColor: tenant.selected && `${theme.palette.success.main}15`,
            p: 0,
            py: 1.5,
            // Vertical padding only
            cursor: "pointer"
        },
        onClick: onSelectAircraft,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                justifyContent: "space-between",
                sx: {
                    px: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            Boolean(tenant.tail_number) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                size: "small",
                                label: tenant.tail_number
                            }),
                            tenant.type === "base" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                size: "small",
                                variant: "outlined",
                                label: "Tenant"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                size: "small",
                                variant: "outlined",
                                label: "Transient"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        onClick: (evt)=>evt.stopPropagation(),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ZrAde.AircraftPreferencesListItemMenuButton), {
                            tenant: tenant,
                            stack: stack,
                            setStack: setStack,
                            setTenant: setTenant,
                            preferences: tenant.position.preferences,
                            setPreferences: (preferences)=>{
                                setTenant({
                                    ...tenant,
                                    position: {
                                        ...tenant.position,
                                        preferences: preferences
                                    }
                                });
                            },
                            onDeleteAircraft: onDeleteAircraft,
                            onIncrementalPark: onIncrementalPark
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                alignItems: "center",
                sx: {
                    px: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: tenant.aircraft.model
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85p2A.AircraftSpecsTooltip), {
                        aircraft: tenant.aircraft
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24c6l.NoteTooltip), {
                        note: tenant.note
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                sx: {
                    px: 1.5
                },
                justifyContent: "start",
                spacing: 2,
                children: isRamp ? [] : $0e8fbea5ecb28545$var$ORDERED_PREFERENCES.filter((p)=>tenant.position.preferences.indexOf(p) > -1).map((setting)=>{
                    let content = null;
                    if (setting === (0, $keHtM.Preference).NOSE_IN) content = /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$var$PlacementSetting, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "FlightIcon",
                            fontSize: "small"
                        }),
                        text: "Nose In"
                    });
                    if (setting === (0, $keHtM.Preference).TAIL_IN) content = /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$var$PlacementSetting, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "FlightIcon",
                            fontSize: "small",
                            sx: {
                                transform: "rotate(180deg)"
                            }
                        }),
                        text: "Tail In"
                    });
                    if (setting === (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN) content = /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$var$PlacementSetting, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "FlightIcon",
                            fontSize: "small"
                        }),
                        text: "Nose In"
                    });
                    if (setting === (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN) content = /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$var$PlacementSetting, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "FlightIcon",
                            fontSize: "small",
                            sx: {
                                transform: "rotate(180deg)"
                            }
                        }),
                        text: "Tail In"
                    });
                    if (setting === (0, $keHtM.Preference).PREFER_FRONT_ROW) content = /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$var$PlacementSetting, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "SwitchLeftIcon",
                            fontSize: "small",
                            sx: {
                                transform: "rotate(90deg)"
                            }
                        }),
                        text: "Front"
                    });
                    if (setting === (0, $keHtM.Preference).PREFER_BACK_ROW) content = /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$var$PlacementSetting, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "SwitchLeftIcon",
                            fontSize: "small",
                            sx: {
                                transform: "rotate(-90deg)"
                            }
                        }),
                        text: "Back"
                    });
                    if (setting === (0, $keHtM.Preference).OK_TO_LEAVE_OUT) content = /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$var$PlacementSetting, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "BeachAccessIcon",
                            fontSize: "small"
                        }),
                        text: "OK Outside"
                    });
                    if (setting === (0, $keHtM.Preference).LOCKED) content = /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$var$PlacementSetting, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "LockIcon",
                            fontSize: "small"
                        }),
                        text: "Locked"
                    });
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                        children: content
                    }, `setting-${setting}`);
                })
            })
        ]
    });
};
const $0e8fbea5ecb28545$export$c13fce52ebfd2e64 = ({ stack: stack, setStack: setStack, tenant: tenant, showBottomBorder: showBottomBorder, setTenant: setTenant, onSelectAircraft: onSelectAircraft, onDeleteAircraft: onDeleteAircraft, onIncrementalPark: onIncrementalPark })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0e8fbea5ecb28545$export$5ecb4548b7ebc388, {
        tenant: tenant,
        stack: stack,
        setStack: setStack,
        setTenant: setTenant,
        onSelectAircraft: ()=>onSelectAircraft(tenant),
        onDeleteAircraft: ()=>onDeleteAircraft(tenant),
        showBottomBorder: showBottomBorder,
        onIncrementalPark: onIncrementalPark
    });
};

});
parcelRegister("ZrAde", function(module, exports) {

$parcel$export(module.exports, "AircraftPreferencesListItemMenuButton", () => $1e4d0a6bd7cbfc34$export$1e65da44beab784d);
$parcel$export(module.exports, "MovableObstacleContextMenu", () => $1e4d0a6bd7cbfc34$export$6cf0b557f08fca37);
$parcel$export(module.exports, "AircraftPreferencesContextMenu", () => $1e4d0a6bd7cbfc34$export$4155677a2a2d873f);

var $ayMG0 = parcelRequire("ayMG0");

var $fZSPM = parcelRequire("fZSPM");

var $hzsFs = parcelRequire("hzsFs");

var $6lXkL = parcelRequire("6lXkL");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $bjZRT = parcelRequire("bjZRT");
var $19ocJ = parcelRequire("19ocJ");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");
var $lBOb7 = parcelRequire("lBOb7");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $6rxM8 = parcelRequire("6rxM8");

var $1KiAb = parcelRequire("1KiAb");

var $kWYrU = parcelRequire("kWYrU");

var $gZQV9 = parcelRequire("gZQV9");

var $keHtM = parcelRequire("keHtM");

var $aHqXU = parcelRequire("aHqXU");

var $j3VXW = parcelRequire("j3VXW");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");
parcelRequire("7o8I0");
var $3XtNi = parcelRequire("3XtNi");

var $adL8n = parcelRequire("adL8n");
const $1e4d0a6bd7cbfc34$export$1e65da44beab784d = ({ stack: stack, setStack: setStack, tenant: tenant, setTenant: setTenant, preferences: preferences, setPreferences: setPreferences, onDeleteAircraft: onDeleteAircraft, onIncrementalPark: onIncrementalPark })=>{
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [openEdit, setOpenEdit] = $acw62.useState(false);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                "data-testid": "more_aircraft_options",
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hzsFs))), {
                    color: "primary"
                })
            }),
            openEdit && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6rxM8.LocationsContainer), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3XtNi.EditTenant), {
                    displayTypeAndLocation: false,
                    stack: stack,
                    setStack: setStack,
                    tenant: tenant,
                    setTenant: setTenant,
                    onClose: ()=>setOpenEdit(false)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$export$43b0aa8b353ff01, {
                stack: stack,
                setStack: setStack,
                tenant: tenant,
                setTenant: setTenant,
                componentType: "menu",
                onEditAircraft: ()=>{
                    setAnchorEl(null);
                    setOpenEdit(true);
                },
                preferences: preferences,
                setPreferences: setPreferences,
                menuProps: {
                    anchorEl: anchorEl,
                    open: open,
                    onClose: handleClose,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    }
                },
                onDeleteAircraft: ()=>{
                    onDeleteAircraft();
                    handleClose();
                },
                onIncrementalPark: onIncrementalPark
            })
        ]
    });
};
const $1e4d0a6bd7cbfc34$export$43b0aa8b353ff01 = (props)=>{
    const { componentType: componentType = "menulist", menuProps: menuProps, onIncrementalPark: onIncrementalPark, ...otherProps } = props;
    if (componentType === "menu") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
        "data-element": "aircraft_menu",
        "data-testid": "preferences_menu",
        open: true,
        MenuListProps: {
            dense: false
        },
        ...menuProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$var$MenuListItems, {
            onIncrementalPark: onIncrementalPark,
            ...otherProps
        })
    });
    return null;
};
const $1e4d0a6bd7cbfc34$export$6cf0b557f08fca37 = ({ menuProps: menuProps, onDelete: onDelete })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lBOb7.default), {
        dense: false,
        ...menuProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
            fullWidth: true,
            color: "error",
            onClick: onDelete,
            children: "Remove Obstacle"
        })
    });
};
const $1e4d0a6bd7cbfc34$export$4155677a2a2d873f = ({ stack: stack, setStack: setStack, ...props })=>{
    const [openEdit, setOpenEdit] = $acw62.useState(false);
    const { tenant: tenant, setTenant: setTenant, menuProps: menuProps, ...otherProps } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lBOb7.default), {
                dense: false,
                ...menuProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$var$MenuListItems, {
                    stack: stack,
                    setStack: setStack,
                    tenant: tenant,
                    setTenant: setTenant,
                    onEditAircraft: ()=>setOpenEdit(true),
                    ...otherProps
                })
            }),
            openEdit && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6rxM8.LocationsContainer), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3XtNi.EditTenant), {
                    displayTypeAndLocation: false,
                    stack: stack,
                    setStack: setStack,
                    tenant: tenant,
                    setTenant: setTenant,
                    onClose: ()=>{
                        setOpenEdit(false);
                    }
                })
            })
        ]
    });
};
const $1e4d0a6bd7cbfc34$var$StackOptionButton = ({ text: text, selected: selected, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        onClick: onClick,
        children: [
            selected && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fZSPM))), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                inset: !selected,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "button",
                    fontWeight: 700,
                    children: text
                })
            })
        ]
    });
};
const $1e4d0a6bd7cbfc34$var$MenuListItems = ({ tenant: tenant, preferences: preferences, setPreferences: setPreferences, onEditAircraft: onEditAircraft, onDeleteAircraft: onDeleteAircraft, setStack: setStack, stack: passedStack, onIncrementalPark: onIncrementalPark })=>{
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const [confirmDelete, setConfirmDelete] = $acw62.useState(false);
    const { hangar: hangar } = (0, $gZQV9.useThisHangar)();
    const rampState = (0, $1KiAb.useOptionalRampState)();
    const ramp = rampState?.ramp;
    const isHangar = Boolean(hangar);
    const stack = hangar?.stack ?? ramp?.stack;
    const isNoseIn = preferences.indexOf((0, $keHtM.Preference).NOSE_IN) > -1 || preferences.indexOf((0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN) > -1;
    const isTailIn = preferences.indexOf((0, $keHtM.Preference).TAIL_IN) > -1 || preferences.indexOf((0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN) > -1;
    if (!hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j3VXW.ButtonNotes), {
            disabled: true,
            tenant: tenant,
            setTenant: (tenant)=>{
                setStack({
                    ...stack,
                    tenants: stack.tenants.map((t)=>t.id === tenant.id ? tenant : t)
                });
            }
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            confirmDelete && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: `Please Confirm`,
                text: stack.isReference ? `Making this Tenant into a Transient means this aircraft is no longer based in your hangars. It will remain on your transient list of aircraft.` : `This aircraft will be removed from this ${isHangar ? "hangar" : "ramp"}.`,
                okText: "Yes, remove this aircraft",
                onOk: onDeleteAircraft,
                onClose: ()=>setConfirmDelete(false),
                onCancel: ()=>setConfirmDelete(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j3VXW.ButtonNotes), {
                        tenant: tenant,
                        setTenant: (tenant)=>{
                            setStack({
                                ...stack,
                                tenants: stack.tenants.map((t)=>t.id === tenant.id ? tenant : t)
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
                ]
            }),
            isHangar && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "preferences_menu",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$var$StackOptionButton, {
                        selected: isTailIn,
                        text: "Tail In",
                        onClick: ()=>{
                            if (isTailIn) setPreferences(preferences.filter((p)=>p !== (0, $keHtM.Preference).TAIL_IN && p !== (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN));
                            else {
                                const newPreference = tenant.aircraft.tail_wheel ? (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN : (0, $keHtM.Preference).TAIL_IN;
                                setPreferences([
                                    ...preferences,
                                    newPreference
                                ].filter((p)=>p !== (0, $keHtM.Preference).NOSE_IN && p !== (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN));
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$var$StackOptionButton, {
                        selected: isNoseIn,
                        text: "Nose In",
                        onClick: ()=>{
                            if (isNoseIn) setPreferences(preferences.filter((p)=>p !== (0, $keHtM.Preference).NOSE_IN && p !== (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN));
                            else {
                                const newPreference = tenant.aircraft.tail_wheel ? (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN : (0, $keHtM.Preference).NOSE_IN;
                                setPreferences([
                                    ...preferences,
                                    newPreference
                                ].filter((p)=>p !== (0, $keHtM.Preference).TAIL_IN && p !== (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN));
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$var$StackOptionButton, {
                        selected: preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1,
                        text: "Front Row",
                        onClick: ()=>{
                            if (preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1) setPreferences(preferences.filter((p)=>p !== (0, $keHtM.Preference).PREFER_FRONT_ROW));
                            else setPreferences([
                                ...preferences,
                                (0, $keHtM.Preference).PREFER_FRONT_ROW
                            ].filter((p)=>p !== (0, $keHtM.Preference).PREFER_BACK_ROW));
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$var$StackOptionButton, {
                        selected: preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1,
                        text: "Back Row",
                        onClick: ()=>{
                            if (preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1) setPreferences(preferences.filter((p)=>p !== (0, $keHtM.Preference).PREFER_BACK_ROW));
                            else setPreferences([
                                ...preferences,
                                (0, $keHtM.Preference).PREFER_BACK_ROW
                            ].filter((p)=>p !== (0, $keHtM.Preference).PREFER_FRONT_ROW));
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$var$StackOptionButton, {
                        selected: preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1,
                        text: "OK Outside",
                        onClick: ()=>{
                            if (preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) setPreferences(preferences.filter((p)=>p !== (0, $keHtM.Preference).OK_TO_LEAVE_OUT));
                            else setPreferences([
                                ...preferences,
                                (0, $keHtM.Preference).OK_TO_LEAVE_OUT
                            ]);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1e4d0a6bd7cbfc34$var$StackOptionButton, {
                        selected: preferences.indexOf((0, $keHtM.Preference).LOCKED) > -1,
                        text: "Locked",
                        onClick: ()=>{
                            if (preferences.indexOf((0, $keHtM.Preference).LOCKED) > -1) setPreferences(preferences.filter((p)=>p !== (0, $keHtM.Preference).LOCKED));
                            else setPreferences([
                                ...preferences,
                                (0, $keHtM.Preference).LOCKED
                            ]);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adL8n.ButtonMoveTo), {
                        tenant: tenant,
                        stack: passedStack || stack,
                        setStack: setStack
                    }),
                    !isHangar && ramp?.autoparking_enabled && onIncrementalPark && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        fullWidth: true,
                        color: "primary",
                        onClick: ()=>{
                            onIncrementalPark(tenant.id);
                        },
                        children: "Incremental Park"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        fullWidth: true,
                        color: "primary",
                        onClick: onEditAircraft,
                        children: "Edit Aircraft"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        fullWidth: true,
                        color: "error",
                        onClick: ()=>setConfirmDelete(true),
                        children: "Remove Aircraft"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("j3VXW", function(module, exports) {

$parcel$export(module.exports, "ButtonNotes", () => $04fcec04e38016c9$export$3539593b136c8c3b);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");

var $acw62 = parcelRequire("acw62");

var $iQnDL = parcelRequire("iQnDL");
const $04fcec04e38016c9$export$3539593b136c8c3b = ({ disabled: disabled = false, variant: variant, tenant: tenant, setTenant: setTenant })=>{
    const [open, setOpen] = $acw62.useState(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                size: "small",
                color: variant === "contained" ? "info" : "inherit",
                variant: variant ?? "text",
                onClick: ()=>setOpen(true),
                disabled: disabled,
                children: "Notes"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iQnDL.NotesDialog), {
                disabled: disabled,
                tenant: tenant,
                setTenant: setTenant,
                open: open,
                setOpen: setOpen
            })
        ]
    });
};

});
parcelRegister("iQnDL", function(module, exports) {

$parcel$export(module.exports, "NotesDialog", () => $0643821743c01c02$export$132e12ea55142936);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $fqtQp = parcelRequire("fqtQp");

var $acw62 = parcelRequire("acw62");

var $gqehT = parcelRequire("gqehT");
const $0643821743c01c02$export$132e12ea55142936 = ({ open: open, setOpen: setOpen, tenant: tenant, setTenant: setTenant, disabled: disabled })=>{
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const [localTenant, setLocalTenant] = $acw62.useState(tenant);
    $acw62.useEffect(()=>{
        if (open) setLocalTenant(tenant);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        maxWidth: "xs",
        fullWidth: true,
        "data-element": "notes-dialog",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: "Aircraft Notes"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 1,
                    p: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            disabled: disabled,
                            autoFocus: true,
                            margin: "dense",
                            label: "Notes",
                            type: "text",
                            fullWidth: true,
                            placeholder: "Departure Time: 05/24/2025 12:00 PM",
                            multiline: true,
                            minRows: 5,
                            onChange: (evt)=>{
                                setLocalTenant({
                                    ...tenant,
                                    note: evt.target.value,
                                    note_last_updated: new Date().toISOString(),
                                    note_last_updated_by: airplxIdentity?.email ?? "Unknown"
                                });
                            },
                            value: localTenant.note ?? ""
                        }),
                        Boolean(tenant.note_last_updated) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "body2",
                            children: [
                                "Last update:",
                                " ",
                                (0, $fqtQp.formatDistance)(new Date(tenant.note_last_updated), new Date(), {
                                    addSuffix: true
                                }),
                                " ",
                                "(",
                                new Date(tenant.note_last_updated).toLocaleDateString(),
                                ") by",
                                " ",
                                tenant.note_last_updated_by
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: ()=>setOpen(false),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        disabled: disabled,
                        variant: "contained",
                        onClick: ()=>{
                            setTenant(localTenant);
                            setOpen(false);
                        },
                        children: "Save"
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("7o8I0", function(module, exports) {
$parcel$export(module.exports, "EditTenant", () => (parcelRequire("3XtNi")).EditTenant);
parcelRequire("3XtNi");

});
parcelRegister("3XtNi", function(module, exports) {

$parcel$export(module.exports, "EditTenant", () => $dcf16856b045d193$export$84c34d012858389e);

var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $6rxM8 = parcelRequire("6rxM8");

var $bvqAP = parcelRequire("bvqAP");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");

var $cjIVL = parcelRequire("cjIVL");
const $dcf16856b045d193$export$84c34d012858389e = ({ displayTypeAndLocation: displayTypeAndLocation = false, stack: stack, setStack: setStack, tenant: tenant, setTenant: setTenant, onClose: onClose })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { locations: locations, findTenantLocations: findTenantLocations, sendToLocation: sendToLocation } = (0, $6rxM8.useLocationsState)();
    const [localTenant, setLocalTenant] = $acw62.useState(tenant);
    const [localCurrentLocation, setLocalCurrentLocation] = $acw62.useState();
    const [localAssignedLocation, setLocalAssignedLocation] = $acw62.useState();
    const tenantService = $acw62.useMemo(()=>new (0, $bvqAP.TenantService)(postgrest), [
        postgrest
    ]);
    $acw62.useEffect(()=>{
        const { current: current, assigned: assigned } = findTenantLocations(tenant);
        setLocalCurrentLocation(current);
        setLocalAssignedLocation(assigned);
    }, [
        tenant,
        locations
    ]);
    const onSave = async ()=>{
        const { current: current, assigned: assigned } = findTenantLocations(tenant);
        if (Boolean(stack) && current?.id !== localCurrentLocation?.id) setStack({
            ...stack,
            tenants: stack.tenants.filter((t)=>t.id !== localTenant.id)
        });
        if (Boolean(stack) && assigned?.id !== localAssignedLocation?.id) setStack({
            ...stack,
            tenants: stack.tenants.filter((t)=>t.id !== localTenant.id)
        });
        // Persist tenant field changes to database
        const tenantUpdates = {};
        let needTenantUpdate = false;
        if (localTenant.tail_number !== tenant.tail_number) {
            tenantUpdates.tail_number = localTenant.tail_number;
            needTenantUpdate = true;
        }
        if (localTenant.owner_manager !== tenant.owner_manager) {
            tenantUpdates.owner_manager = localTenant.owner_manager;
            needTenantUpdate = true;
        }
        if (localTenant.aircraft_id !== tenant.aircraft_id) {
            tenantUpdates.aircraft_id = localTenant.aircraft_id;
            needTenantUpdate = true;
        }
        if (localTenant.note !== tenant.note) {
            tenantUpdates.note = localTenant.note || null;
            tenantUpdates.note_last_updated = localTenant.note_last_updated;
            tenantUpdates.note_last_updated_by = localTenant.note_last_updated_by;
            needTenantUpdate = true;
        }
        if (needTenantUpdate) await tenantService.updateTenant(localTenant.id, tenantUpdates);
        setTenant(localTenant);
        // TODO: could this be simplified / get rid of sendToLocation?
        if (current?.id !== localCurrentLocation?.id) await sendToLocation(localCurrentLocation, "current", localTenant);
        if (assigned?.id !== localAssignedLocation?.id) await sendToLocation(localAssignedLocation, "reference", localTenant);
    };
    if (!hasPermission((0, $aHqXU.Permission).MODIFY_TENANTS) && tenant.type === "base") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
        title: "Insufficient Permission",
        text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
            variant: "body1",
            children: [
                "Insufficient permission to modify a base tenant. Currently you have the role of ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                    children: (0, $aHqXU.formatRoleName)(activeFBO.user_role)
                }),
                ". You need to be an ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                    children: "FBO Admin"
                }),
                " or ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                    children: "Manager"
                }),
                " to modify a base tenant. Please contact your AirPlx admin if you think this is a mistake."
            ]
        }),
        onOk: function() {
        // nothing to do
        },
        onClose: function() {
            onClose();
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjIVL.EditTenantPresenter), {
        displayTypeAndLocation: displayTypeAndLocation,
        isReference: stack?.isReference ?? false,
        tenant: localTenant,
        setTenant: setLocalTenant,
        currentLocation: localCurrentLocation,
        setCurrentLocation: setLocalCurrentLocation,
        assignedLocation: localAssignedLocation,
        setAssignedLocation: setLocalAssignedLocation,
        onSave: onSave,
        onClose: onClose
    });
};

});
parcelRegister("bvqAP", function(module, exports) {

$parcel$export(module.exports, "TenantService", () => $62ed2f8aa0c42f66$export$b119e5a94742f590);
class $62ed2f8aa0c42f66$export$b119e5a94742f590 {
    constructor(postgrest){
        this.postgrest = postgrest;
    }
    /**
   * Update tenant information
   */ async updateTenant(tenantId, updates) {
        const { data: data, error: error } = await this.postgrest.from("tenant").update(updates).eq("id", tenantId).select().single();
        if (error) throw new Error(`Failed to update tenant: ${error.message}`);
        return data;
    }
    /**
   * Get tenant by ID
   */ async getTenant(tenantId) {
        const { data: data, error: error } = await this.postgrest.from("tenant").select().eq("id", tenantId).single();
        if (error) throw new Error(`Failed to get tenant: ${error.message}`);
        return data;
    }
    /**
   * Create or update tenant in database
   * Uses upsert to handle both new and existing tenants
   */ async createTenant(tenant) {
        const { data: data, error: error } = await this.postgrest.from("tenant").upsert({
            id: tenant.id,
            fbo_id: tenant.fbo_id,
            entity_id: tenant.entity_id,
            owner_manager: tenant.owner_manager,
            tail_number: tenant.tail_number,
            type: tenant.type,
            aircraft_id: tenant.aircraft_id,
            note: tenant.note,
            note_last_updated: tenant.note_last_updated,
            note_last_updated_by: tenant.note_last_updated_by
        }).select().single();
        if (error) throw new Error(`Failed to create tenant: ${error.message}`);
        return data;
    }
}

});

parcelRegister("cjIVL", function(module, exports) {

$parcel$export(module.exports, "EditTenantPresenter", () => $6afc5b23d5c42575$export$68bc386be20353b8);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $gqehT = parcelRequire("gqehT");

var $6rxM8 = parcelRequire("6rxM8");

var $9OZOC = parcelRequire("9OZOC");

var $hTRQz = parcelRequire("hTRQz");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");
parcelRequire("briyn");
var $1gbL9 = parcelRequire("1gbL9");
parcelRequire("bPruZ");
var $gDfVd = parcelRequire("gDfVd");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $fqtQp = parcelRequire("fqtQp");

var $5kwJN = parcelRequire("5kwJN");
const $6afc5b23d5c42575$export$68bc386be20353b8 = ({ displayTypeAndLocation: displayTypeAndLocation, tenant: tenant, setTenant: setTenant, currentLocation: currentLocation, setCurrentLocation: setCurrentLocation, assignedLocation: assignedLocation, setAssignedLocation: setAssignedLocation, onSave: onSave, onClose: onClose })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { locations: locations } = (0, $6rxM8.useLocationsState)();
    const { tenants: tenants } = (0, $9OZOC.useTenants)();
    const flashTimeoutRef = $acw62.useRef(null);
    const [shouldFlashAircraft, setShouldFlashAircraft] = $acw62.useState(false);
    const [showConfirmation, setShowConfirmation] = $acw62.useState({
        text: "",
        onOk: ()=>{
        //
        }
    });
    const handleClose = ()=>{
        onClose();
    };
    const isDuplicateTailNumber = $acw62.useMemo(()=>{
        return Boolean(tenants.filter((t)=>t.tail_number).find((t)=>t.id !== tenant.id && t.tail_number.toLocaleUpperCase() === tenant.tail_number.toLocaleUpperCase()));
    }, [
        tenants,
        tenant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: true,
        onClose: handleClose,
        maxWidth: "lg",
        "data-element": "edit_tenant",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: "Edit Aircraft"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                sx: {
                    width: 500
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 2,
                        sx: {
                            mt: 1,
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                                label: "Select an Aircraft",
                                onSelect: (aircraft)=>{
                                    setTenant({
                                        ...tenant,
                                        aircraft_id: aircraft.id,
                                        aircraft: aircraft
                                    });
                                },
                                defaultSelected: tenant.aircraft,
                                shouldFlash: shouldFlashAircraft
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gDfVd.SelectTailNumber), {
                                        disableAutocomplete: false,
                                        warning: isDuplicateTailNumber && "Duplicate tail number",
                                        tenants: tenants,
                                        defaultValue: tenant.tail_number,
                                        onInputChange: (tailNumber)=>{
                                            setTenant({
                                                ...tenant,
                                                tail_number: tailNumber
                                            });
                                        },
                                        onChange: (selectedTenant)=>{
                                            if (selectedTenant?.aircraft) {
                                                setTenant({
                                                    ...tenant,
                                                    tail_number: selectedTenant.tail_number,
                                                    aircraft_id: selectedTenant.aircraft.id,
                                                    aircraft: selectedTenant.aircraft
                                                });
                                                // Trigger flash animation when user selects from tail number dropdown
                                                setShouldFlashAircraft(true);
                                                // Reset flash state after the animation completes
                                                if (flashTimeoutRef.current !== null) clearTimeout(flashTimeoutRef.current);
                                                flashTimeoutRef.current = window.setTimeout(()=>{
                                                    setShouldFlashAircraft(false);
                                                    flashTimeoutRef.current = null;
                                                }, 1500);
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                inputProps: {
                                                    testid: "owner_manager"
                                                },
                                                size: "small",
                                                fullWidth: true,
                                                label: "Owner/Manager",
                                                onChange: (evt)=>setTenant({
                                                        ...tenant,
                                                        owner_manager: evt.target.value
                                                    }),
                                                value: tenant.owner_manager
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "error"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        inputProps: {
                                            testid: "note"
                                        },
                                        size: "small",
                                        fullWidth: true,
                                        multiline: true,
                                        rows: 4,
                                        label: "Notes",
                                        placeholder: "Add notes about this aircraft...",
                                        onChange: (evt)=>setTenant({
                                                ...tenant,
                                                note: evt.target.value,
                                                note_last_updated: new Date().toISOString(),
                                                note_last_updated_by: airplxIdentity?.email ?? "Unknown"
                                            }),
                                        value: tenant.note || ""
                                    }),
                                    Boolean(tenant.note && tenant.note_last_updated) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: [
                                            "Last update:",
                                            " ",
                                            (0, $fqtQp.formatDistance)(new Date(tenant.note_last_updated), new Date(), {
                                                addSuffix: true
                                            }),
                                            " ",
                                            "(",
                                            new Date(tenant.note_last_updated).toLocaleDateString(),
                                            ") by",
                                            " ",
                                            tenant.note_last_updated_by
                                        ]
                                    })
                                ]
                            }),
                            displayTypeAndLocation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                            disabled: !hasPermission((0, $aHqXU.Permission).MODIFY_TENANTS),
                                            select: true,
                                            size: "small",
                                            fullWidth: true,
                                            label: "Type",
                                            onChange: (evt)=>{
                                                if (evt.target.value === "transient") {
                                                    setShowConfirmation({
                                                        text: "Making this Base Tenant into a Transient means this aircraft is no longer based in your hangars. It will remain on your transient list of aircraft.",
                                                        onOk: ()=>{
                                                            setTenant({
                                                                ...tenant,
                                                                type: evt.target.value
                                                            }), setAssignedLocation(null);
                                                        }
                                                    });
                                                    return;
                                                }
                                                if (evt.target.value === "base") {
                                                    setShowConfirmation({
                                                        text: (0, $5kwJN.addTenantConformationText)(currentLocation ? "hangar" : null),
                                                        onOk: ()=>setTenant({
                                                                ...tenant,
                                                                type: evt.target.value
                                                            })
                                                    });
                                                    return;
                                                }
                                            },
                                            value: tenant.type,
                                            sx: {
                                                height: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                    value: "base",
                                                    children: "Tenant"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                    value: "transient",
                                                    children: "Transient"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "column",
                                            spacing: 2,
                                            sx: {
                                                width: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1gbL9.LocationTextField), {
                                                    disabled: !hasPermission((0, $aHqXU.Permission).MODIFY_TENANTS) || tenant.type !== "base",
                                                    isReference: true,
                                                    unassignedText: tenant.type === "base" ? "Unassigned" : "N/A",
                                                    selectedLocationId: assignedLocation?.location_id,
                                                    onChange: (newLocationId)=>{
                                                        const newLocation = locations.find((l)=>l.location_id === newLocationId);
                                                        setAssignedLocation(newLocation);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1gbL9.LocationTextField), {
                                                    isReference: false,
                                                    selectedLocationId: currentLocation?.location_id,
                                                    unassignedText: "Not Hangared",
                                                    onChange: (newLocationId)=>{
                                                        const newLocation = locations.find((l)=>l.location_id === newLocationId);
                                                        setCurrentLocation(newLocation);
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    Boolean(showConfirmation?.text) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                        title: "Please Confirm",
                        text: showConfirmation?.text,
                        onCancel: ()=>{
                        // do nothing
                        },
                        onOk: ()=>showConfirmation?.onOk(),
                        onClose: ()=>{
                            setShowConfirmation({
                                text: "",
                                onOk: ()=>{
                                //
                                }
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        disabled: isDuplicateTailNumber,
                        variant: "contained",
                        color: "success",
                        onClick: async ()=>{
                            await onSave();
                            handleClose();
                        },
                        children: "Save"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("briyn", function(module, exports) {
$parcel$export(module.exports, "LocationTextField", () => (parcelRequire("1gbL9")).LocationTextField);
parcelRequire("1gbL9");

});
parcelRegister("1gbL9", function(module, exports) {

$parcel$export(module.exports, "LocationTextField", () => $e40c5cc0eb9b9086$export$a2b51a013b55cdb3);

var $ayMG0 = parcelRequire("ayMG0");

var $6ami2 = parcelRequire("6ami2");
var $2iAqv = parcelRequire("2iAqv");
var $iAtns = parcelRequire("iAtns");
parcelRequire("acw62");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");
const $e40c5cc0eb9b9086$export$a2b51a013b55cdb3 = ({ isReference: isReference = false, disabled: disabled = false, selectedLocationId: selectedLocationId, onChange: onChange, readOnly: readOnly = false, unassignedText: unassignedText = "Unassigned", link: link = false })=>{
    const { ramps: ramps } = (0, $3AGzj.useRampsState)();
    const { hangars: hangars } = (0, $7FzhI.useHangarsState)();
    if (readOnly) {
        const location = hangars?.find((h)=>h.location_id === selectedLocationId) ?? ramps?.find((r)=>r.location_id === selectedLocationId);
        const isRamp = Boolean(ramps.find((r)=>r.location_id === selectedLocationId));
        const href = isRamp ? `#/${isReference ? "reference-" : ""}ramps/${location?.id}` : `#/${isReference ? "reference-" : ""}hangars/${location?.id}`;
        const hrefProps = link && Boolean(selectedLocationId) ? {
            href: href,
            sx: {
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    color: "#ffffff"
                }
            }
        } : {};
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
            variant: "filled",
            size: "small",
            component: "a",
            label: location?.name ?? unassignedText,
            ...hrefProps
        });
    }
    const locationType = Boolean(ramps.find((r)=>r.location_id === selectedLocationId)) ? "Ramp" : "Hangar";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
        disabled: disabled,
        select: true,
        size: "small",
        fullWidth: true,
        label: isReference ? `Assigned ${locationType}` : `Current ${locationType}`,
        onChange: (evt)=>onChange(evt.target.value === "Unassigned" ? null : evt.target.value),
        value: selectedLocationId ?? "Unassigned",
        children: [
            hangars.map((hangar)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                    value: hangar.location_id,
                    children: hangar.name
                }, `hangar-select-${hangar.location_id}`)),
            ramps.map((ramp)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                    value: ramp.location_id,
                    children: ramp.name
                }, `ramp-select-${ramp.location_id}`)),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                value: "Unassigned",
                children: unassignedText
            })
        ]
    });
};

});


parcelRegister("bPruZ", function(module, exports) {
$parcel$export(module.exports, "SelectTailNumber", () => (parcelRequire("gDfVd")).SelectTailNumber);
parcelRequire("gDfVd");

});
parcelRegister("gDfVd", function(module, exports) {

$parcel$export(module.exports, "SelectTailNumber", () => $8c50bed6e51ff993$export$93ace8e939b8c173);

var $ayMG0 = parcelRequire("ayMG0");

var $cFBau = parcelRequire("cFBau");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $eFqab = parcelRequire("eFqab");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $3kyM0 = parcelRequire("3kyM0");

var $8GP8k = parcelRequire("8GP8k");

var $4bqcK = parcelRequire("4bqcK");

var $3XcNI = parcelRequire("3XcNI");
const $8c50bed6e51ff993$var$levenshteinDistance = (s, t)=>{
    if (!s.length) return t.length;
    if (!t.length) return s.length;
    const arr = [];
    for(let i = 0; i <= t.length; i++){
        arr[i] = [
            i
        ];
        for(let j = 1; j <= s.length; j++)arr[i][j] = i === 0 ? j : Math.min(arr[i - 1][j] + 1, arr[i][j - 1] + 1, arr[i - 1][j - 1] + (s[j - 1] === t[i - 1] ? 0 : 1));
    }
    return arr[t.length][s.length];
};
const $8c50bed6e51ff993$var$RGX_VALID_REGISTRATIONS = /[A-Z]/;
const $8c50bed6e51ff993$export$93ace8e939b8c173 = ({ disableAutocomplete: disableAutocomplete, defaultValue: defaultValue = "", warning: warning, tenants: tenants = [], onChange: onChange = ()=>{}, onInputChange: onInputChange = ()=>{} })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { url: tokenMakerURL } = (0, $3kyM0.useTokenMaker)();
    const [value, setValue] = $acw62.useState("");
    const [debouncedValue, setDebouncedValue] = $acw62.useState("");
    const [requestDialogOpen, setRequestDialogOpen] = $acw62.useState(false);
    const [confirmationDialogOpen, setConfirmationDialogOpen] = $acw62.useState(false);
    const [tailNumberToRequest, setTailNumberToRequest] = $acw62.useState("");
    const [isFocused, setIsFocused] = $acw62.useState(false);
    // Debounce the value to synchronize filtering with FAA API data fetch (300ms)
    // This prevents the dropdown from "bouncing" when FAA data arrives
    $acw62.useEffect(()=>{
        const timer = setTimeout(()=>{
            setDebouncedValue(value);
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        value
    ]);
    // Memoize the exclude list to prevent unnecessary re-renders of the hook
    const excludeTailNumbers = $acw62.useMemo(()=>tenants.map((t)=>t.tail_number), [
        tenants
    ]);
    // useFAATailNumbers is used to fetch FAA tail numbers. exclude the ones that are already in the tenants list
    // to avoid duplicates in the autocomplete list
    const { loading: loading, tailNumbers: tailNumbers } = (0, $4bqcK.useFAATailNumbers)(value, excludeTailNumbers);
    const tenantsForAutocomplete = $acw62.useMemo(()=>{
        return [
            ...tenants,
            ...tailNumbers
        ].filter((t)=>t.tail_number?.length > 2);
    }, [
        tenants,
        tailNumbers
    ]);
    // Memoize sorted options to prevent recalculation on every render
    // Uses debouncedValue to sync with FAA API data arrival
    const sortedOptions = $acw62.useMemo(()=>{
        // If no input, return alphabetically sorted list
        if (!debouncedValue || debouncedValue.length < 1) return [
            ...tenantsForAutocomplete
        ].sort((a, b)=>a.tail_number.localeCompare(b.tail_number));
        const valueUpper = debouncedValue.toUpperCase();
        // Sort with prefix-aware scoring (hyphen-flexible)
        return [
            ...tenantsForAutocomplete
        ].sort((a, b)=>{
            const aNum = a.tail_number.toUpperCase();
            const bNum = b.tail_number.toUpperCase();
            // Priority 1: Exact match (ignoring hyphens)
            const aExact = (0, $3XcNI.tailNumbersMatch)(aNum, valueUpper) ? 0 : 1;
            const bExact = (0, $3XcNI.tailNumbersMatch)(bNum, valueUpper) ? 0 : 1;
            if (aExact !== bExact) return aExact - bExact;
            // Priority 2: Starts with (prefix match, ignoring hyphens) - prioritizes C-AAC for "C" or "CAAC"
            const aStarts = (0, $3XcNI.tailNumberStartsWith)(aNum, valueUpper) ? 0 : 1;
            const bStarts = (0, $3XcNI.tailNumberStartsWith)(bNum, valueUpper) ? 0 : 1;
            if (aStarts !== bStarts) return aStarts - bStarts;
            // Priority 3: Levenshtein distance for fuzzy matching (using normalized tail numbers)
            const aDist = $8c50bed6e51ff993$var$levenshteinDistance((0, $3XcNI.stripHyphens)(valueUpper), (0, $3XcNI.stripHyphens)(aNum));
            const bDist = $8c50bed6e51ff993$var$levenshteinDistance((0, $3XcNI.stripHyphens)(valueUpper), (0, $3XcNI.stripHyphens)(bNum));
            if (aDist !== bDist) return aDist - bDist;
            // Priority 4: Alphabetical
            return aNum.localeCompare(bNum);
        });
    }, [
        tenantsForAutocomplete,
        debouncedValue
    ]);
    // Check if the current value is not found in registry
    // Uses debouncedValue to prevent premature banner appearance while FAA data loads
    // Also checks loading state to prevent banner flash during API fetch
    // Only shows banner when there are NO results at all (not just no exact match)
    const isNotInRegistry = $acw62.useMemo(()=>{
        if (!debouncedValue || debouncedValue.length < 2) return false;
        if (loading) return false; // Don't show banner while still loading FAA data
        // Check if any tail numbers in the list partially match the input
        const hasMatches = tenantsForAutocomplete.some((tenant)=>(0, $3XcNI.tailNumberIncludes)(tenant.tail_number, debouncedValue));
        return !hasMatches;
    }, [
        debouncedValue,
        loading,
        tenantsForAutocomplete
    ]);
    // Handle aircraft request submission
    const handleAircraftRequest = async ()=>{
        try {
            // First, insert into database via PostgREST
            const { error: dbError } = await postgrest.from("tail_number_requests").insert({
                tail_number: tailNumberToRequest,
                fbo_id: activeFBO?.id,
                requested_by: airplxIdentity.userid
            });
            if (dbError) {
                console.error("Failed to save request to database:", dbError);
                throw new Error("Database insert failed");
            }
            // Then, send email notification (optional - don't fail if email service is down)
            try {
                const params = new URLSearchParams({
                    fbo_name: activeFBO?.name || "Unknown FBO",
                    user_email: airplxIdentity.email,
                    make: "Unknown",
                    model: "Unknown",
                    tail_number: tailNumberToRequest,
                    uniqueMods: "Tail number not in registry",
                    timeframe: "ASAP"
                });
                await fetch(`${tokenMakerURL}/request_aircraft?${params.toString()}`);
            } catch (emailError) {
                // Email failed but request was saved to database - that's fine
                console.warn("Email notification failed, but request was saved:", emailError);
            }
            setRequestDialogOpen(false);
            setConfirmationDialogOpen(true);
        } catch (error) {
            console.error("Failed to submit aircraft request:", error);
        // TODO: Show error snackbar to user
        }
    };
    $acw62.useEffect(()=>{
        setValue(defaultValue);
    }, [
        defaultValue
    ]);
    // Memoize filter function to prevent recreation on every render
    const memoizedFilterOptions = $acw62.useCallback((options, state)=>{
        const q = state.inputValue;
        if (!q) return options; // Don't filter if no input
        return options.filter((o)=>(0, $3XcNI.tailNumberIncludes)(o.tail_number, q));
    }, []);
    if (disableAutocomplete) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        inputProps: {
                            testid: "tail_number"
                        },
                        fullWidth: true,
                        size: "small",
                        label: "Tail #",
                        onChange: (evt)=>{
                            let newInputValue = evt.target.value.toLocaleUpperCase();
                            // Only auto-prepend "N" if user is typing numbers and there's actual content
                            if (newInputValue && !$8c50bed6e51ff993$var$RGX_VALID_REGISTRATIONS.test(newInputValue)) // default to N since it is the most common
                            newInputValue = "N" + newInputValue;
                            onInputChange(newInputValue);
                            setValue(newInputValue);
                        },
                        onFocus: ()=>setIsFocused(true),
                        onBlur: ()=>setIsFocused(false),
                        value: value
                    }),
                    " ",
                    isNotInRegistry && value.length >= 2 && isFocused && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        alignItems: "center",
                        spacing: 1,
                        sx: {
                            mt: 1,
                            p: 1.5,
                            backgroundColor: "background.paper",
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: 1,
                            minHeight: 48
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "text.secondary",
                                sx: {
                                    flex: 1,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                },
                                children: "Not in registry yet."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                size: "small",
                                variant: "contained",
                                color: "primary",
                                sx: {
                                    flexShrink: 0
                                },
                                onMouseDown: (e)=>{
                                    e.preventDefault(); // Prevent blur from firing
                                    setTailNumberToRequest(value);
                                    setRequestDialogOpen(true);
                                },
                                children: "Request"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "error",
                        children: warning
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: requestDialogOpen,
                onClose: ()=>setRequestDialogOpen(false),
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "New Aircraft Request"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                                children: "This aircraft isn't in our registry yet. Press 'Request' to submit it to our team."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 2,
                                sx: {
                                    mt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        disabled: true,
                                        label: "Tail Number",
                                        value: tailNumberToRequest,
                                        fullWidth: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        disabled: true,
                                        label: "FBO",
                                        value: activeFBO.name,
                                        fullWidth: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        disabled: true,
                                        label: "Requested By",
                                        value: airplxIdentity.email,
                                        fullWidth: true
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setRequestDialogOpen(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "primary",
                                onClick: handleAircraftRequest,
                                children: "Request"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: confirmationDialogOpen,
                onClose: ()=>setConfirmationDialogOpen(false),
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "\u2708\uFE0F Aircraft Request Sent!"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eFqab.default), {
                            children: [
                                "We've received your request for aircraft",
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: tailNumberToRequest
                                }),
                                ". Our team will review and add it to the registry soon. You'll be notified once it's available."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            onClick: ()=>setConfirmationDialogOpen(false),
                            children: "Got it!"
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                        size: "small",
                        fullWidth: true,
                        freeSolo: true,
                        options: sortedOptions,
                        getOptionLabel: (option)=>{
                            if (typeof option === "string") return option;
                            return option.tail_number;
                        },
                        filterOptions: memoizedFilterOptions,
                        ListboxProps: {
                            style: {
                                maxHeight: '40vh',
                                overflow: 'auto'
                            }
                        },
                        slotProps: {
                            popper: {
                                sx: {
                                    zIndex: 10000 // Higher than dialog (9600)
                                }
                            }
                        },
                        onInputChange: (event, newInputValue)=>{
                            newInputValue = newInputValue.toLocaleUpperCase();
                            // Only auto-prepend "N" if user is typing numbers and there's actual content
                            if (newInputValue && !$8c50bed6e51ff993$var$RGX_VALID_REGISTRATIONS.test(newInputValue)) // default to N since it is the most common
                            newInputValue = "N" + newInputValue;
                            onInputChange(newInputValue);
                            setValue(newInputValue);
                        },
                        onChange: async (event, tenant)=>{
                            if (!tenant?.aircraft && tenant?.aircraft_id) {
                                // if the tenant has an aircraft_id but no aircraft, we need to fetch it
                                const aircraft = await (0, $8GP8k.fetchAircraft)(postgrest, tenant.aircraft_id, activeFBO);
                                tenant.aircraft = aircraft;
                            }
                            if (tenant && !tenant?.type) tenant.type = "transient"; // default type if not set
                            onChange(tenant);
                        },
                        value: value,
                        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                ...params,
                                fullWidth: true,
                                label: "Tail #",
                                onFocus: ()=>setIsFocused(true),
                                onBlur: ()=>setIsFocused(false),
                                inputProps: {
                                    testid: "tail_number",
                                    ...params.inputProps,
                                    onKeyDown: (e)=>{
                                        // i don't want user to ever hit enter in this form
                                        if (e.key === "Enter") e.stopPropagation();
                                    }
                                }
                            })
                    }),
                    isNotInRegistry && value.length >= 2 && isFocused && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        sx: {
                            mt: 1,
                            p: 1,
                            backgroundColor: "background.paper",
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: 1,
                            minHeight: 40
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "text.secondary",
                                sx: {
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                    mr: 1
                                },
                                children: "This aircraft isn't in our registry yet."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                size: "small",
                                variant: "contained",
                                color: "primary",
                                sx: {
                                    flexShrink: 0
                                },
                                onMouseDown: (e)=>{
                                    e.preventDefault(); // Prevent blur from firing
                                    setTailNumberToRequest(value);
                                    setRequestDialogOpen(true);
                                },
                                children: "Request"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: requestDialogOpen,
                onClose: ()=>setRequestDialogOpen(false),
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "New Aircraft Request"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                                children: "This aircraft isn't in our registry yet. Press 'Request' to submit it to our team."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 2,
                                sx: {
                                    mt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        disabled: true,
                                        label: "Tail Number",
                                        value: tailNumberToRequest,
                                        fullWidth: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        disabled: true,
                                        label: "FBO",
                                        value: activeFBO.name,
                                        fullWidth: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        disabled: true,
                                        label: "Requested By",
                                        value: airplxIdentity.email,
                                        fullWidth: true
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setRequestDialogOpen(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "primary",
                                onClick: handleAircraftRequest,
                                children: "Request"
                            })
                        ]
                    })
                ]
            }),
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: confirmationDialogOpen,
                onClose: ()=>setConfirmationDialogOpen(false),
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "\u2708\uFE0F Aircraft Request Sent!"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eFqab.default), {
                            children: [
                                "We've received your request for aircraft",
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: tailNumberToRequest
                                }),
                                ". Our team will review and add it to the registry soon. You'll be notified once it's available."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            onClick: ()=>setConfirmationDialogOpen(false),
                            children: "Got it!"
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("4bqcK", function(module, exports) {

$parcel$export(module.exports, "useFAATailNumbers", () => $bfc7d2342acec918$export$6e70b052d3bdc40f);
$parcel$export(module.exports, "lookupAircraftByTailNumber", () => $bfc7d2342acec918$export$230c45c3fc69b858);
// a react hook that fetches filtered tail numbers from the database in the vw_faa_tail_numbers

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $64iGd = parcelRequire("64iGd");

var $8GP8k = parcelRequire("8GP8k");

var $3XcNI = parcelRequire("3XcNI");
const $bfc7d2342acec918$export$6e70b052d3bdc40f = (filter, excludeTailNumbers = [])=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    // Debounce the filter to avoid too many queries
    const debouncedFilter = (0, $64iGd.useDebouncedValue)(()=>filter, 300, [
        filter
    ]);
    // Memoize the exclude list to avoid unnecessary re-renders
    const memoizedExcludeTailNumbers = $acw62.useMemo(()=>excludeTailNumbers, [
        excludeTailNumbers.join(",")
    ]);
    // State management
    const [loading, setLoading] = $acw62.useState(false);
    const [tailNumbers, setTailNumbers] = $acw62.useState([]);
    // Server-side filtering with database query
    $acw62.useEffect(()=>{
        // Don't search for empty filters
        if (debouncedFilter.length < 1) {
            setTailNumbers([]);
            return;
        }
        const fetchTailNumbers = async ()=>{
            if (!postgrest) return;
            setLoading(true);
            try {
                // Build search patterns to handle hyphens flexibly
                const patterns = [
                    debouncedFilter
                ]; // Original input
                // If input doesn't have hyphen, try adding hyphen after first char (e.g., "CFWAP" -> "C-FWAP")
                if (!debouncedFilter.includes('-') && debouncedFilter.length > 1) {
                    const withHyphen = `${debouncedFilter[0]}-${debouncedFilter.slice(1)}`;
                    patterns.push(withHyphen);
                }
                // If input has hyphen, try without hyphen (e.g., "C-FWAP" -> "CFWAP")
                if (debouncedFilter.includes('-')) {
                    const withoutHyphen = (0, $3XcNI.stripHyphens)(debouncedFilter);
                    patterns.push(withoutHyphen);
                }
                // Build OR query for multiple patterns
                const orConditions = patterns.map((p)=>`tail_number.ilike.${p}%`).join(',');
                const { data: data, error: error } = await postgrest.from("vw_faa_tail_numbers").select("tail_number, aircraft_id").or(orConditions).limit(100).order("tail_number", {
                    ascending: true
                });
                if (error) {
                    console.error("Error fetching FAA tail numbers:", error);
                    setTailNumbers([]);
                    return;
                }
                // Filter out excluded tail numbers
                const filteredData = (data || []).filter((item)=>!memoizedExcludeTailNumbers.includes(item.tail_number)).map((item)=>({
                        aircraft_id: item.aircraft_id,
                        tail_number: item.tail_number
                    }));
                setTailNumbers(filteredData);
            } catch (error) {
                console.error("Error fetching FAA tail numbers:", error);
                setTailNumbers([]);
            } finally{
                setLoading(false);
            }
        };
        fetchTailNumbers();
    }, [
        debouncedFilter,
        memoizedExcludeTailNumbers,
        postgrest
    ]);
    return {
        loading: loading,
        tailNumbers: tailNumbers
    };
};
const $bfc7d2342acec918$export$230c45c3fc69b858 = async (postgrest, tailNumber, activeFBO)=>{
    if (!postgrest || !tailNumber?.trim() || !activeFBO) return null;
    try {
        const trimmedTailNumber = tailNumber.trim();
        // Build search patterns to handle hyphens flexibly
        const patterns = [
            trimmedTailNumber
        ]; // Original input
        // If input doesn't have hyphen, try adding hyphen after first char (e.g., "CFWAP" -> "C-FWAP")
        if (!trimmedTailNumber.includes('-') && trimmedTailNumber.length > 1) {
            const withHyphen = `${trimmedTailNumber[0]}-${trimmedTailNumber.slice(1)}`;
            patterns.push(withHyphen);
        }
        // If input has hyphen, try without hyphen (e.g., "C-FWAP" -> "CFWAP")
        if (trimmedTailNumber.includes('-')) {
            const withoutHyphen = (0, $3XcNI.stripHyphens)(trimmedTailNumber);
            patterns.push(withoutHyphen);
        }
        // Try each pattern until we find a match
        for (const pattern of patterns){
            const { data: data, error: error } = await postgrest.from("vw_faa_tail_numbers").select("aircraft_id").ilike("tail_number", pattern).limit(1).maybeSingle();
            if (!error && data?.aircraft_id) {
                // Use existing fetchAircraft helper to get full aircraft details (with caching)
                const aircraft = await (0, $8GP8k.fetchAircraft)(postgrest, data.aircraft_id, activeFBO);
                return aircraft;
            }
        }
        return null;
    } catch (error) {
        console.error(`Failed to lookup aircraft for ${tailNumber}:`, error);
        return null;
    }
};

});
parcelRegister("3XcNI", function(module, exports) {

$parcel$export(module.exports, "stripHyphens", () => $f0073b762d189201$export$ac5e38f78bae750c);
$parcel$export(module.exports, "tailNumbersMatch", () => $f0073b762d189201$export$19cb8137e238cc87);
$parcel$export(module.exports, "tailNumberStartsWith", () => $f0073b762d189201$export$d206b9103fd8802f);
$parcel$export(module.exports, "tailNumberIncludes", () => $f0073b762d189201$export$e3d1976a580a5308);
/**
 * Utility functions for normalizing and comparing tail numbers.
 * Handles international tail numbers that may include hyphens (e.g., "C-FWAP").
 */ /**
 * Removes hyphens from a tail number for comparison purposes.
 * @param tailNumber - The tail number to normalize (e.g., "C-FWAP" or "N12345")
 * @returns The tail number without hyphens (e.g., "CFWAP" or "N12345")
 */ function $f0073b762d189201$export$ac5e38f78bae750c(tailNumber) {
    return tailNumber.replace(/-/g, '');
}
function $f0073b762d189201$export$19cb8137e238cc87(a, b) {
    return $f0073b762d189201$export$ac5e38f78bae750c(a.toUpperCase()) === $f0073b762d189201$export$ac5e38f78bae750c(b.toUpperCase());
}
function $f0073b762d189201$export$d206b9103fd8802f(tailNumber, prefix) {
    return $f0073b762d189201$export$ac5e38f78bae750c(tailNumber.toUpperCase()).startsWith($f0073b762d189201$export$ac5e38f78bae750c(prefix.toUpperCase()));
}
function $f0073b762d189201$export$e3d1976a580a5308(tailNumber, substring) {
    return $f0073b762d189201$export$ac5e38f78bae750c(tailNumber.toUpperCase()).includes($f0073b762d189201$export$ac5e38f78bae750c(substring.toUpperCase()));
}

});







parcelRegister("adL8n", function(module, exports) {

$parcel$export(module.exports, "ButtonMoveTo", () => $01c00cba059b7635$export$7372e0187a0c2b4);

var $ayMG0 = parcelRequire("ayMG0");

var $kT7QH = parcelRequire("kT7QH");

var $6lXkL = parcelRequire("6lXkL");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $7FzhI = parcelRequire("7FzhI");

var $7p8YN = parcelRequire("7p8YN");

var $1KiAb = parcelRequire("1KiAb");

var $3AGzj = parcelRequire("3AGzj");

var $fZ41T = parcelRequire("fZ41T");

var $bTM6K = parcelRequire("bTM6K");

var $gZQV9 = parcelRequire("gZQV9");
const $01c00cba059b7635$export$7372e0187a0c2b4 = ({ tenant: tenant, stack: stack, setStack: setStack })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hangar: hangar } = (0, $gZQV9.useThisHangar)();
    const { isMultiHangar: isMultiHangar, hangars: hangars, setHangars: setHangars } = (0, $7p8YN.useMultiHangarState)();
    const { sendToLocation: sendToLocation } = (0, $bTM6K.useLocations)();
    const rampState = (0, $1KiAb.useOptionalRampState)();
    const ramp = rampState?.ramp;
    const { hangars: allHangars } = (0, $7FzhI.useHangarsState)();
    const { ramps: ramps } = (0, $3AGzj.useRampsState)();
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const tenantLocationId = isMultiHangar ? hangars.find((h)=>h.stack.tenants.find((t)=>t.id === tenant.id)).location_id : ramp?.location_id || hangar?.location_id;
    const handleLocationClick = (location)=>{
        if (isMultiHangar) {
            setHangars(hangars.map((hangar)=>({
                    ...hangar,
                    stack: {
                        ...hangar.stack,
                        tenants: hangar.id === location.id ? [
                            ...hangar.stack.tenants,
                            {
                                ...tenant,
                                position: {
                                    ...tenant.position,
                                    stack_id: location.stack.id,
                                    entity_id: tenant.entity_id,
                                    x: null,
                                    y: null,
                                    angle: null,
                                    preferences: tenant.position.preferences
                                }
                            }
                        ] : hangar.stack.tenants.filter((t)=>t.id !== tenant.id)
                    }
                })));
            handleClose();
            return;
        }
        // remove from the stack
        setStack({
            ...stack,
            tenants: stack.tenants.map((t)=>t.id === tenant.id ? {
                    ...t,
                    position: {
                        ...t.position,
                        stack_id: location.stack.id,
                        entity_id: tenant.entity_id,
                        x: null,
                        y: null,
                        angle: null,
                        preferences: tenant.position.preferences
                    }
                } : t)
        });
        handleClose();
    };
    const { renderMenuItems: renderMenuItems } = (0, $fZ41T.useGroupedLocationMenu)({
        hangars: allHangars,
        ramps: ramps,
        activeFBO: activeFBO,
        currentLocationId: tenantLocationId,
        onLocationClick: handleLocationClick
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                color: "primary",
                endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kT7QH))), {}),
                onClick: handleClick,
                id: "demo-positioned-button",
                "aria-controls": open ? "demo-positioned-menu" : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? "true" : undefined,
                children: stack.isReference ? "Assign To" : "Move To"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4F5tJ.default), {
                id: "demo-positioned-menu",
                "aria-labelledby": "demo-positioned-button",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "center",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                children: [
                    renderMenuItems(),
                    stack.isReference && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                        onClick: ()=>{
                            sendToLocation(null, "reference", tenant);
                            if (isMultiHangar) {
                                setHangars(hangars.map((hangar)=>({
                                        ...hangar,
                                        stack: {
                                            ...hangar.stack,
                                            tenants: hangar.stack.tenants.filter((t)=>t.id !== tenant.id)
                                        }
                                    })));
                                return;
                            }
                            setStack({
                                ...stack,
                                tenants: stack.tenants.map((t)=>t.id === tenant.id ? {
                                        ...t,
                                        position: {
                                            ...t.position,
                                            stack_id: null,
                                            entity_id: tenant.entity_id,
                                            x: null,
                                            y: null,
                                            angle: null,
                                            preferences: tenant.position.preferences
                                        }
                                    } : t)
                            });
                            handleClose();
                        },
                        children: "Unassigned"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("fZ41T", function(module, exports) {

$parcel$export(module.exports, "useGroupedLocationMenu", () => $3365613ead988578$export$e5290436587c3561);

var $ayMG0 = parcelRequire("ayMG0");

var $fZSPM = parcelRequire("fZSPM");

var $bjZRT = parcelRequire("bjZRT");
var $19ocJ = parcelRequire("19ocJ");
var $7djgP = parcelRequire("7djgP");
var $2iAqv = parcelRequire("2iAqv");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $97sqG = parcelRequire("97sqG");

var $5HLUx = parcelRequire("5HLUx");
function $3365613ead988578$export$e5290436587c3561({ hangars: hangars, ramps: ramps, activeFBO: activeFBO, currentLocationId: currentLocationId, onLocationClick: onLocationClick }) {
    // Sort hangars and ramps using existing sort functions
    const sortedHangars = $acw62.useMemo(()=>hangars.sort((a, b)=>(0, $97sqG.sortHangars)(a, b, activeFBO?.settings?.hangarDisplayOrder)), [
        hangars,
        activeFBO
    ]);
    const sortedRamps = $acw62.useMemo(()=>ramps.sort((a, b)=>(0, $5HLUx.sortRamps)(a, b, activeFBO?.settings?.rampDisplayOrder)), [
        ramps,
        activeFBO
    ]);
    // Render a single location menu item
    const renderLocationItem = $acw62.useCallback((location)=>{
        const isCurrentLocation = location.id === currentLocationId;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
            onClick: ()=>onLocationClick(location),
            children: [
                isCurrentLocation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fZSPM))), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                    inset: !isCurrentLocation,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "button",
                        children: location.name
                    })
                })
            ]
        }, `location-${location.id}`);
    }, [
        currentLocationId,
        onLocationClick
    ]);
    // Render all grouped menu items
    const renderMenuItems = $acw62.useCallback(()=>{
        const items = [];
        // Hangars section
        if (sortedHangars.length > 0) {
            items.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7djgP.default), {
                sx: {
                    fontSize: 11,
                    fontWeight: 700,
                    lineHeight: "32px",
                    py: 0,
                    mt: 0.5,
                    mb: 0
                },
                children: "HANGARS"
            }, "hangars-header"));
            sortedHangars.forEach((hangar)=>{
                items.push(renderLocationItem(hangar));
            });
        }
        // Ramps section
        if (sortedRamps.length > 0) {
            items.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7djgP.default), {
                sx: {
                    fontSize: 11,
                    fontWeight: 700,
                    lineHeight: "32px",
                    py: 0,
                    mt: 0.5,
                    mb: 0
                },
                children: "RAMPS"
            }, "ramps-header"));
            sortedRamps.forEach((ramp)=>{
                items.push(renderLocationItem(ramp));
            });
        }
        return items;
    }, [
        sortedHangars,
        sortedRamps,
        renderLocationItem
    ]);
    return {
        renderMenuItems: renderMenuItems,
        sortedHangars: sortedHangars,
        sortedRamps: sortedRamps
    };
}

});



parcelRegister("24c6l", function(module, exports) {

$parcel$export(module.exports, "NoteTooltip", () => $f5149daf14c120c4$export$a623ad325377de8c);

var $ayMG0 = parcelRequire("ayMG0");

var $gPeoT = parcelRequire("gPeoT");

var $cVXaD = parcelRequire("cVXaD");

var $eU5ou = parcelRequire("eU5ou");
parcelRequire("acw62");
const $f5149daf14c120c4$export$a623ad325377de8c = ({ note: note })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        disableHoverListener: !Boolean(note),
        title: note ?? "",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gPeoT))), {
            fontSize: "small",
            sx: {
                color: !Boolean(note) ? (0, $eU5ou.default)[500] : "inherit"
            }
        })
    });
};

});



parcelRegister("lFMxC", function(module, exports) {
$parcel$export(module.exports, "Layout", () => (parcelRequire("bXDUV")).Layout);
parcelRequire("bXDUV");

});
parcelRegister("bXDUV", function(module, exports) {

$parcel$export(module.exports, "Layout", () => $d8924d23380d48ce$export$c84671f46d6a1ca);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $14H9o = parcelRequire("14H9o");

var $2LXej = parcelRequire("2LXej");

var $ciKN1 = parcelRequire("ciKN1");

var $89b86 = parcelRequire("89b86");

var $fC0pb = parcelRequire("fC0pb");

var $br620 = parcelRequire("br620");

var $dd9SG = parcelRequire("dd9SG");

var $d1mLJ = parcelRequire("d1mLJ");

var $6ERoB = parcelRequire("6ERoB");

var $gHTMg = parcelRequire("gHTMg");

var $4okQ5 = parcelRequire("4okQ5");

var $7EoDj = parcelRequire("7EoDj");

var $8cYjj = parcelRequire("8cYjj");

var $3STt9 = parcelRequire("3STt9");

var $7WaJM = parcelRequire("7WaJM");

var $lvKwx = parcelRequire("lvKwx");

var $eT5g6 = parcelRequire("eT5g6");

var $bj2A9 = parcelRequire("bj2A9");

var $gkftL = parcelRequire("gkftL");

var $15URU = parcelRequire("15URU");

var $hEqwk = parcelRequire("hEqwk");

var $keHtM = parcelRequire("keHtM");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");

var $41u54 = parcelRequire("41u54");
const $d8924d23380d48ce$export$32f5b8ab45fa2334 = {
    reference: "#F4D2CD",
    testing: "#23967F"
};
const $d8924d23380d48ce$export$c84671f46d6a1ca = ({ stack: stack, setStack: setStack, location: location, autocomplete: originalAutocomplete, options: options, zoomLevel: zoomLevel, onScheduledUpdate: onScheduledUpdate, scheduledViewProps: scheduledViewProps, onIncrementalPark: onIncrementalPark, ...props })=>{
    const autocomplete = originalAutocomplete ?? (async ()=>[]);
    const { setShow: setShowLoadingProgress } = (0, $89b86.useLoadingProgress)();
    const hideUnplaced = options?.hideUnplaced ?? false;
    const readOnly = options?.readOnly ?? false;
    const frozen = options?.frozen ?? false;
    const printable = options?.printable ?? false;
    const spacingBufferRef = $acw62.useRef();
    const spacingBufferOverlayElement = spacingBufferRef.current;
    const [blockGhostHighlight, setBlockGhostHightlight] = $acw62.useState(false);
    const theme = (0, $14H9o.default)();
    const isDarkMode = theme.palette.mode === 'dark';
    const bboxRef = $acw62.useRef(null);
    const [ghostMouseOverIndex, setGhostMouseOverIndex] = $acw62.useState();
    // Type guard to narrow Location<Hangar | Ramp> to Location<Hangar>
    const isHangarLocation = (loc)=>{
        return loc.type === "hangar";
    };
    const { loading: loadingUserPreferences, preferences: preferences } = (0, $fC0pb.useUserPreferences)();
    const [rightClick, setRightClick] = $acw62.useState(null);
    const { autocompleteResults: autocompleteResults, setAutocompleteResults: setAutocompleteResults } = (0, $ciKN1.useAutocompleteResults)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [deleteConfirmation, setDeleteConfirmation] = $acw62.useState(null);
    // Store stack in ref to prevent flicker
    const stackRef = $acw62.useRef(stack);
    stackRef.current = stack; // Direct update during render (safe for refs)
    const { width: width, height: height, feetToPixels: feetToPixels } = (0, $d1mLJ.useDimensions)({
        location: location,
        height: props.height,
        width: props.width
    });
    const { polygons: polygons } = (0, $7WaJM.usePolygons)({
        stack: stack,
        width: width,
        feetToPixels: feetToPixels,
        isHoldingArea: location.id === "holding-area"
    }, [
        width,
        stack.tenants,
        stack.movableObstacles,
        feetToPixels
    ]);
    // TODO: make ghost and moving aircraft use hook
    const { polygons: ghostPolygons } = (0, $7WaJM.usePolygons)({
        stack: {
            ...stack,
            tenants: autocompleteResults.suggestedPositions.filter((sp)=>sp.hangar_id === location.id).map((position)=>({
                    ...autocompleteResults.tenant,
                    position: {
                        ...autocompleteResults.tenant?.position,
                        ...position
                    }
                })),
            movableObstacles: []
        },
        width: width,
        feetToPixels: feetToPixels
    }, [
        width,
        autocompleteResults
    ]);
    // This hook is responsible for unselecting an aircraft if the user taps
    // anywhere on the page except for a plane or the aircraft list
    (0, $lvKwx.useUnselect)({
        stack: stack,
        setStack: setStack
    }, [
        stack,
        setStack
    ]);
    const isInLayout = (0, $4okQ5.useIsInLayout)({
        location: location,
        stack: stack,
        polygons: polygons
    }, [
        stack.tenants,
        stack.movableObstacles,
        polygons
    ]);
    const getClickedEntity = (0, $6ERoB.useGetClickedEntity)({
        bboxRef: bboxRef,
        stack: stack,
        polygons: polygons,
        feetToPixels: feetToPixels
    }, [
        stack,
        polygons,
        feetToPixels
    ]);
    const getIndexOfGhostAircraftHoveringOver = (0, $gHTMg.useGetIndexOfGhostAircraftHoveringOver)(bboxRef, stack, ghostPolygons, feetToPixels, width);
    /**
   * Autocomplete the aircraft position
   */ const autocompleteTenant = (0, $dd9SG.useAutocompleteTenant)({
        hangarId: location.id,
        enabled: Boolean(originalAutocomplete),
        stack: stack,
        preferences: preferences,
        autocomplete: async (tenant)=>await autocomplete(tenant),
        isInLayout: isInLayout,
        autocompleteResults: autocompleteResults,
        setAutocompleteResults: setAutocompleteResults
    }, [
        stack,
        preferences,
        autocompleteResults
    ]);
    // Store latest autocompleteTenant in a ref to prevent infinite loops
    const autocompleteTenantRef = $acw62.useRef(autocompleteTenant);
    $acw62.useEffect(()=>{
        autocompleteTenantRef.current = autocompleteTenant;
    }, [
        autocompleteTenant
    ]);
    // Run autocomplete when an aircraft is selected (only when selection actually changes)
    const selectedTenantIdRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        const selectedTenant = stack.tenants.find((t)=>t.selected);
        const selectedId = selectedTenant?.id || null;
        // Only run autocomplete if the selected tenant ID actually changed
        // (prevents infinite loop when stack.tenants array is recreated with same content)
        if (selectedTenantIdRef.current === selectedId) return;
        selectedTenantIdRef.current = selectedId;
        if (selectedTenant) autocompleteTenantRef.current(selectedTenant);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stack.tenants
    ]);
    // Note: autocompleteTenant intentionally NOT in deps - using ref to prevent infinite loop
    // (autocompleteResults changes → autocompleteTenant recreated → would trigger this effect again)
    // Re-run autocomplete when Co-Pilot is enabled while an aircraft is selected
    const prevEnableCoPilotRef = $acw62.useRef(preferences?.enableCoPilot);
    $acw62.useEffect(()=>{
        const wasEnabled = prevEnableCoPilotRef.current;
        const isEnabled = preferences?.enableCoPilot;
        prevEnableCoPilotRef.current = isEnabled;
        // Only trigger when toggled from OFF to ON
        if (!wasEnabled && isEnabled) {
            const selectedTenant = stack.tenants.find((t)=>t.selected);
            if (selectedTenant) autocompleteTenantRef.current(selectedTenant);
        }
    }, [
        preferences?.enableCoPilot,
        stack.tenants
    ]);
    // Delete key shortcut
    $acw62.useEffect(()=>{
        const handleKeyDown = (e)=>{
            const target = e.target;
            if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
            if (readOnly || frozen) return;
            if (e.key === 'Delete' || e.key === 'Backspace') {
                const currentStack = stackRef.current;
                const selectedTenant = currentStack.tenants.find((t)=>t.selected);
                if (selectedTenant) {
                    e.preventDefault();
                    setDeleteConfirmation({
                        type: 'aircraft',
                        tenant: selectedTenant
                    });
                    return;
                }
                const selectedObstacle = currentStack.movableObstacles.find((mo)=>mo.selected);
                if (selectedObstacle) {
                    e.preventDefault();
                    setDeleteConfirmation({
                        type: 'obstacle',
                        obstacle: selectedObstacle
                    });
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>window.removeEventListener('keydown', handleKeyDown);
    }, [
        readOnly,
        frozen
    ]);
    const handleConfirmDelete = $acw62.useCallback(async ()=>{
        if (!deleteConfirmation) return;
        const currentStack = stackRef.current; // Read from ref, not closure
        if (deleteConfirmation.type === 'aircraft' && deleteConfirmation.tenant) {
            const tenant = deleteConfirmation.tenant;
            setStack({
                ...currentStack,
                tenants: currentStack.tenants.filter((t)=>t.placement_id !== tenant.placement_id)
            });
            if (currentStack.name === 'reference') await postgrest.from('tenant').update({
                type: 'transient'
            }).eq('id', tenant.id);
            // Trigger refresh for scheduled view
            if (onScheduledUpdate) onScheduledUpdate();
        } else if (deleteConfirmation.type === 'obstacle' && deleteConfirmation.obstacle) {
            setStack({
                ...currentStack,
                movableObstacles: currentStack.movableObstacles.filter((mo)=>mo.entity_id !== deleteConfirmation.obstacle.entity_id)
            });
            // Trigger refresh for scheduled view
            if (onScheduledUpdate) onScheduledUpdate();
        }
        setDeleteConfirmation(null);
    }, [
        deleteConfirmation,
        setStack,
        postgrest,
        onScheduledUpdate
    ]);
    // Note: stack removed from dependencies - using stackRef prevents callback recreation on every drag
    const onClick = (0, $8cYjj.useOnClick)({
        location: location,
        stack: stack,
        setStack: setStack,
        autocompleteResults: autocompleteResults,
        setAutocompleteResults: setAutocompleteResults,
        rightClick: rightClick,
        getClickedEntity: getClickedEntity,
        getIndexOfGhostAircraftHoveringOver: getIndexOfGhostAircraftHoveringOver
    }, [
        stack,
        setStack,
        ghostPolygons,
        autocompleteResults,
        rightClick,
        getClickedEntity,
        getIndexOfGhostAircraftHoveringOver
    ]);
    const onMouseMove = $acw62.useCallback((evt)=>{
        if (blockGhostHighlight) return;
        const index = getIndexOfGhostAircraftHoveringOver(evt);
        setGhostMouseOverIndex(index);
    }, [
        stack,
        ghostPolygons,
        getIndexOfGhostAircraftHoveringOver,
        blockGhostHighlight
    ]);
    const onContextMenu = (0, $3STt9.useOnContextMenu)({
        stack: stack,
        getClickedEntity: getClickedEntity,
        setRightClick: setRightClick
    }, [
        stack,
        getClickedEntity
    ]);
    const Aircraft = (0, $br620.useAircraft)({
        location: location,
        stack: stack,
        setStack: setStack,
        hideUnplaced: hideUnplaced,
        isInLayout: isInLayout,
        preferences: preferences,
        printable: printable,
        rightClick: rightClick,
        setRightClick: setRightClick,
        readOnly: readOnly,
        frozen: frozen,
        width: width,
        height: height,
        feetToPixels: feetToPixels,
        spacingBufferOverlayElement: spacingBufferOverlayElement,
        options: options,
        onScheduledUpdate: onScheduledUpdate,
        scheduledViewProps: scheduledViewProps,
        onIncrementalPark: onIncrementalPark
    }, [
        location,
        stack,
        setStack,
        readOnly,
        height,
        feetToPixels,
        preferences,
        rightClick,
        setRightClick,
        spacingBufferOverlayElement,
        options
    ]);
    const MovableObstacles = (0, $7EoDj.useMovableObstacles)({
        location: location,
        stack: stack,
        setStack: setStack,
        preferences: preferences,
        rightClick: rightClick,
        setRightClick: setRightClick,
        readOnly: readOnly,
        height: height,
        feetToPixels: feetToPixels,
        spacingBufferOverlayElement: spacingBufferOverlayElement,
        options: options
    }, [
        stack,
        setStack,
        readOnly,
        height,
        feetToPixels,
        preferences,
        rightClick,
        setRightClick,
        spacingBufferOverlayElement,
        options
    ]);
    $acw62.useEffect(()=>{
        setShowLoadingProgress(autocompleteResults?.loading);
    }, [
        autocompleteResults?.loading
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            // Clear autocomplete results and hide loading progress when unmounting
            setAutocompleteResults({
                id: null,
                hash: null,
                loading: false,
                tenant: null,
                orientation: null,
                suggestedPositions: []
            });
            setShowLoadingProgress(false);
        };
    }, []);
    // if a locked aircraft is moved outside the hangar, then unlock it
    $acw62.useEffect(()=>{
        for (const tenant of stack.tenants){
            if (tenant.position.preferences.includes((0, $keHtM.Preference).LOCKED)) {
                if (!isInLayout(tenant)) setStack({
                    ...stack,
                    tenants: stack.tenants.map((t)=>{
                        if (t.id === tenant.id) return {
                            ...t,
                            position: {
                                ...t.position,
                                preferences: t.position.preferences.filter((p)=>p !== (0, $keHtM.Preference).LOCKED)
                            }
                        };
                        return t;
                    })
                });
            }
        }
    }, [
        stack.tenants
    ]);
    const onMouseDown = ()=>setBlockGhostHightlight(true);
    const onMouseUp = ()=>setBlockGhostHightlight(false);
    // wait for user prefs...
    if (loadingUserPreferences) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {});
    const backgroundColor = options?.backgroundColor ?? (stack.isReference ? $d8924d23380d48ce$export$32f5b8ab45fa2334.reference : isDarkMode ? theme.palette.background.default : "#aab1c7");
    const dashColor = options?.dashColor ?? (stack.isReference ? "#f8f8f8" : isDarkMode ? "#5a6775" : "#5474a4");
    const borderColor = options?.borderColor ?? (isDarkMode ? theme.palette.divider : undefined);
    const autocompleteResultsForThisLayout = {
        ...autocompleteResults,
        suggestedPositions: autocompleteResults.suggestedPositions.filter((sp)=>sp.hangar_id === location.id)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $41u54.DraggingScrollContainer), {
        disabled: readOnly || options?.disableGrabScroll,
        feetToPixels: feetToPixels,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        onClick: onClick,
        onContextMenu: onContextMenu,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-location-id": location.id,
                "data-layout": stack.id,
                style: {
                    display: "flex"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eT5g6.LayoutBackground), {
                    ref: bboxRef,
                    location: location,
                    preferences: preferences,
                    selectable: false,
                    width: width,
                    height: height,
                    feetToPixels: feetToPixels,
                    zoomLevel: zoomLevel,
                    backgroundColor: backgroundColor,
                    dashColor: dashColor,
                    borderColor: borderColor,
                    printable: printable,
                    onClick: onClick,
                    onMouseDown: onMouseDown,
                    onMouseUp: onMouseUp,
                    onMouseMove: onMouseMove,
                    onMouseEnter: ()=>null,
                    onContextMenu: onContextMenu,
                    heatmapPlacements: scheduledViewProps?.heatmapPlacements,
                    heatmapSelectedDate: scheduledViewProps?.currentTime,
                    children: [
                        !readOnly && preferences.showOverlaps && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bj2A9.CollisionOverlay), {
                            location: location,
                            polygons: polygons ?? []
                        }),
                        location.type === "hangar" && Boolean(location.left_door) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gkftL.Door), {
                            feetToPixels: feetToPixels,
                            position: "left",
                            width: location.left_door
                        }),
                        location.type === "hangar" && Boolean(location.right_door) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gkftL.Door), {
                            feetToPixels: feetToPixels,
                            position: "right",
                            width: location.right_door
                        }),
                        isHangarLocation(location) && location.obstacles.map((obstacle)=>/*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hEqwk.Obstacle), {
                                    ...obstacle,
                                    feetToPixels: feetToPixels
                                })
                            }, `obstacle-${obstacle.id}`)),
                        isHangarLocation(location) && location.garageDoors.map((garageDoor)=>/*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gkftL.Door), {
                                    type: "garage",
                                    feetToPixels: feetToPixels,
                                    position: garageDoor.wall,
                                    offset: garageDoor.wall === "back" ? garageDoor.x : garageDoor.y,
                                    width: garageDoor.width
                                })
                            }, `garage-door-${garageDoor.id}`)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: spacingBufferRef
                        }),
                        Aircraft,
                        MovableObstacles,
                        Boolean(preferences?.enableCoPilot) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15URU.GhostAircraft), {
                            location: location,
                            stack: stack,
                            polygons: polygons,
                            autocompleteResults: autocompleteResultsForThisLayout,
                            mouseOverIndex: ghostMouseOverIndex,
                            feetToPixels: feetToPixels,
                            height: height
                        })
                    ]
                })
            }),
            deleteConfirmation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Please Confirm",
                text: deleteConfirmation.type === 'aircraft' ? stack.name === 'reference' ? 'Making this Tenant into a Transient means this aircraft is no longer based in your hangars. It will remain on your transient list of aircraft.' : `This aircraft will be removed from this ${location.type}.` : 'This movable obstacle will be removed.',
                okText: deleteConfirmation.type === 'aircraft' ? 'Yes, remove this aircraft' : 'Yes, remove this obstacle',
                onOk: handleConfirmDelete,
                onClose: ()=>setDeleteConfirmation(null),
                onCancel: ()=>setDeleteConfirmation(null)
            })
        ]
    });
};

});
parcelRegister("89b86", function(module, exports) {

$parcel$export(module.exports, "LoadingProgressContainer", () => $4a55980e19fadf8e$export$4769f27a3f395f2f);
$parcel$export(module.exports, "useLoadingProgress", () => $4a55980e19fadf8e$export$98b6fa2380836911);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ay9Yf = parcelRequire("ay9Yf");
const $4a55980e19fadf8e$var$useLoadingProgressContainer = ()=>{
    const [show, setShow] = $acw62.useState(false);
    return {
        show: show,
        setShow: setShow
    };
};
const $4a55980e19fadf8e$var$LoadingProgressContainerState = (0, $ay9Yf.createContainer)($4a55980e19fadf8e$var$useLoadingProgressContainer);
const $4a55980e19fadf8e$export$4769f27a3f395f2f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4a55980e19fadf8e$var$LoadingProgressContainerState.Provider, {
        children: children
    });
};
const $4a55980e19fadf8e$export$98b6fa2380836911 = $4a55980e19fadf8e$var$LoadingProgressContainerState.useContainer;

});

parcelRegister("br620", function(module, exports) {

$parcel$export(module.exports, "useAircraft", () => $09e2c3609b0d574e$export$3523f37fd7d0411b);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7p8YN = parcelRequire("7p8YN");

var $g7var = parcelRequire("g7var");

var $5U03M = parcelRequire("5U03M");

var $dn13k = parcelRequire("dn13k");

var $eFVLn = parcelRequire("eFVLn");
const $09e2c3609b0d574e$export$73b2f16e6a60ae8 = (position)=>{
    return position.x !== null && position.y !== null && position.angle !== null;
};
const $09e2c3609b0d574e$export$3523f37fd7d0411b = (props, deps = [])=>{
    const { location: location, stack: stack, setStack: setStack, hideUnplaced: hideUnplaced, isInLayout: isInLayout, printable: printable, width: width, height: height, readOnly: readOnly, frozen: frozen, feetToPixels: feetToPixels, rightClick: rightClick, setRightClick: setRightClick, preferences: preferences, spacingBufferOverlayElement: spacingBufferOverlayElement, options: options, onScheduledUpdate: onScheduledUpdate, scheduledViewProps: scheduledViewProps, onIncrementalPark: onIncrementalPark } = props;
    const { isMultiHangar: isMultiHangar } = (0, $7p8YN.useMultiHangarState)();
    const onPositionChange = (0, $eFVLn.useOnPositionChange)({
        location: location,
        stack: stack,
        setStack: setStack,
        disableDragProtection: options.disableDragProtection ?? false
    }, [
        stack.tenants,
        stack.movableObstacles,
        setStack,
        location
    ]);
    const isHoldingArea = location.id === (0, $5U03M.HOLDING_AREA_ID);
    return $acw62.useMemo(()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: (0, $g7var.wrapUnplacedAirplanes)(stack?.tenants.filter((tenant)=>tenant.position.stack_id === stack.id).filter((tenant)=>{
                return !hideUnplaced || isInLayout(tenant, 10);
            }).filter((tenant)=>{
                if (printable) return isInLayout(tenant, 10);
                return true;
            }), width, feetToPixels, isMultiHangar, isHoldingArea).map((tenant)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dn13k.FullyLoadedDraggableAircraft), {
                        isHangar: location.type === "hangar",
                        readOnly: readOnly,
                        frozen: frozen,
                        layoutHeight: height,
                        feetToPixels: feetToPixels,
                        tenant: {
                            ...tenant,
                            selected: tenant.selected || rightClick?.entity_id === tenant.entity_id
                        },
                        stack: stack,
                        onScheduledUpdate: onScheduledUpdate,
                        scheduledViewProps: scheduledViewProps,
                        // small problem. if we wrap the unplaced aircraft we've changed the position of the tenant
                        // so we need to ignore positions that don't have a valid x, y, and angle.
                        setStack: (stack)=>{
                            setStack({
                                ...stack,
                                tenants: stack.tenants.map((t)=>{
                                    if (!$09e2c3609b0d574e$export$73b2f16e6a60ae8(t.position)) return {
                                        ...t,
                                        position: {
                                            ...t.position,
                                            x: null,
                                            y: null,
                                            angle: null
                                        }
                                    };
                                    return t;
                                })
                            });
                        },
                        preferences: {
                            ...preferences,
                            forceDisplayTailNumber: options.hideTailNumbers ? false : preferences.forceDisplayTailNumber,
                            notes: options.hideNotes ? false : preferences.notes
                        },
                        onPositionChange: (placement_id, position)=>// small problem. if we wrap the unplaced aircraft we've changed the position of the tenant
                            // so we need to ignore positions that don't have a valid x, y, and angle.
                            onPositionChange(placement_id, {
                                ...position,
                                ...!$09e2c3609b0d574e$export$73b2f16e6a60ae8(position) ? {
                                    x: null,
                                    y: null,
                                    angle: null
                                } : {}
                            }),
                        onChange: ()=>{},
                        rightClick: rightClick,
                        setRightClick: setRightClick,
                        spacingBufferOverlayElement: spacingBufferOverlayElement,
                        onIncrementalPark: onIncrementalPark
                    })
                }, `draggable-aircraft-${stack.id}-${tenant.entity_id}`);
            })
        }), deps);
};

});
parcelRegister("dn13k", function(module, exports) {

$parcel$export(module.exports, "FullyLoadedDraggableAircraft", () => $aef28e1e3b869b84$export$e3fba1ed7a9df78);

var $ayMG0 = parcelRequire("ayMG0");

var $6MV2p = parcelRequire("6MV2p");
var $6Q1H5 = parcelRequire("6Q1H5");
var $6el2W = parcelRequire("6el2W");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");
parcelRequire("awKYK");
var $34myE = parcelRequire("34myE");

var $tdfUy = parcelRequire("tdfUy");

var $2znSD = parcelRequire("2znSD");

var $iQnDL = parcelRequire("iQnDL");

var $ZrAde = parcelRequire("ZrAde");

var $9CHh9 = parcelRequire("9CHh9");
const $aef28e1e3b869b84$export$e3fba1ed7a9df78 = ({ tenant: tenant, feetToPixels: feetToPixels, stack: stack, setStack: setStack, preferences: preferences, layoutHeight: layoutHeight, onPositionChange: onPositionChange, onChange: onChange = ()=>{}, rightClick: rightClick, setRightClick: setRightClick, spacingBufferOverlayElement: spacingBufferOverlayElement, readOnly: readOnly = false, frozen: frozen = false, isHangar: isHangar = true, hotkey: hotkey, onScheduledUpdate: onScheduledUpdate, scheduledViewProps: scheduledViewProps, onIncrementalPark: onIncrementalPark })=>{
    const [showNotes, setShowNotes] = $acw62.useState(false);
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    // Detect if we're in scheduled mode
    const isScheduledMode = stack.name?.includes("Scheduled View") || tenant.id?.startsWith("scheduled-");
    // Extract trip ID from tenant (if in scheduled mode)
    const tripId = tenant.trip_id;
    const imageDimensions = {
        ...(0, $tdfUy.calculateAircraftImageDimensions)(feetToPixels, tenant.aircraft)
    };
    const position = {
        x: tenant.position.x * feetToPixels,
        y: tenant.position.y * feetToPixels,
        angle: tenant.position.angle,
        timestamp: tenant.position.timestamp
    };
    // This assumes the y position is an alignment to the bottom of the
    // hangar and this reverses it to align to the top to pass on to
    // the DraggableAircraftNew
    position.y = layoutHeight - (position.y + imageDimensions.height);
    let label = "";
    if (!preferences.forceDisplayTailNumber && !preferences.forceDisplayModel && preferences.notes) {
        if (tenant.selected) label = tenant.tail_number || "N/A";
        else label = ``;
    } else if (preferences.forceDisplayTailNumber && preferences.forceDisplayModel) label = `${tenant.tail_number || "N/A"}\n${(0, $2znSD.truncateAt15Chars)(tenant.aircraft.model)}`;
    else if (preferences.forceDisplayTailNumber) label = `${tenant.tail_number || "N/A"}`;
    else if (preferences.forceDisplayModel) label = `${(0, $2znSD.truncateAt15Chars)(tenant.aircraft.model)}`;
    else label = `${tenant.tail_number || "N/A"}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34myE.DraggableAircraft), {
                tenantType: tenant.type,
                entity_id: tenant.entity_id,
                readOnly: readOnly,
                frozen: frozen,
                label: label,
                hotkey: hotkey,
                note: preferences.notes ? tenant.note : "",
                labelWidth: preferences.forceDisplayModel ? 105 : null,
                forceDisplayLabel: preferences.forceDisplayTailNumber || preferences.forceDisplayModel || Boolean(hotkey) || preferences.notes && tenant.note,
                forceDisplayNotes: activeFBO?.settings?.forceDisplayNotes && Boolean(preferences.notes) && Boolean(tenant.note),
                spacingBufferOverlayElement: !readOnly && preferences.showSOPSpacing ? spacingBufferOverlayElement : null,
                placementSource: tenant.placement_source,
                isLocked: tenant.is_locked,
                aircraft: {
                    ...tenant.aircraft,
                    selected: tenant.selected,
                    tail_number: tenant.tail_number || "N/A",
                    position: position,
                    ...(0, $2znSD.getSpacingBufferDimensions)(isHangar, tenant.aircraft, {
                        feetToPixels: feetToPixels
                    }),
                    placement_id: tenant.placement_id
                },
                imageDimensions: imageDimensions,
                onPositionChange: (position)=>{
                    // Adjust the position to be aligned to the bottom
                    // as it will come from the component aligned to the top
                    // Switch the y position to align to the bottom of the hangar
                    position.y = layoutHeight - (position.y + imageDimensions.height);
                    const fullPosition = {
                        id: tenant.position.id,
                        stack_id: tenant.position.stack_id,
                        entity_id: tenant.entity_id,
                        x: position.x / feetToPixels,
                        y: position.y / feetToPixels,
                        angle: position.angle,
                        preferences: tenant.position.preferences ?? [],
                        timestamp: position.timestamp
                    };
                    onPositionChange(tenant.entity_id, fullPosition);
                },
                onChange: (position)=>{
                    // Adjust the position to be aligned to the bottom
                    // as it will come from the component aligned to the top
                    // Switch the y position to align to the bottom of the hangar
                    position.y = layoutHeight - (position.y + imageDimensions.height);
                    const fullPosition = {
                        id: tenant.position.id,
                        stack_id: tenant.position.stack_id,
                        entity_id: tenant.entity_id,
                        x: position.x / feetToPixels,
                        y: position.y / feetToPixels,
                        angle: position.angle,
                        preferences: tenant.position.preferences ?? [],
                        timestamp: position.timestamp
                    };
                    onChange(tenant.entity_id, fullPosition);
                },
                onPlaneClick: ()=>{
                // moved to the global onclick event
                },
                onPlaneRightClick: ()=>{
                // moved to the global onclick event
                },
                onStartTowing: ()=>{
                    // we want to make sure the aircraft is selected
                    setStack({
                        ...stack,
                        tenants: stack.tenants.map((t)=>({
                                ...t,
                                selected: t.placement_id === tenant.placement_id ? true : false
                            }))
                    });
                },
                onClickNotesButton: ()=>{
                    setShowNotes(true);
                },
                feetToPixels: feetToPixels
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MV2p.default), {
                open: showNotes,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: tenant.note
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iQnDL.NotesDialog), {
                open: showNotes,
                setOpen: setShowNotes,
                disabled: false,
                tenant: tenant,
                setTenant: (updatedTenant)=>{
                    setStack({
                        ...stack,
                        tenants: stack.tenants.map((t)=>t.id === updatedTenant.id ? updatedTenant : t)
                    });
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
                id: `popover-right-click-${tenant.id}`,
                open: rightClick?.entity_id === tenant.entity_id,
                onClose: ()=>setRightClick(null),
                anchorReference: "anchorPosition",
                anchorPosition: rightClick !== null ? {
                    top: rightClick.mouseY,
                    left: rightClick.mouseX
                } : undefined,
                children: isScheduledMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9CHh9.ScheduledAircraftContextMenu), {
                    tenant: tenant,
                    tripId: tripId,
                    currentTimestamp: scheduledViewProps?.currentTime || (tenant.position?.timestamp ? new Date(tenant.position.timestamp) : new Date()),
                    stack: stack,
                    setStack: setStack,
                    onClose: ()=>setRightClick(null),
                    onRefresh: ()=>{
                        setRightClick(null);
                        if (onScheduledUpdate) onScheduledUpdate();
                    },
                    menuProps: {
                        open: true
                    }
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ZrAde.AircraftPreferencesContextMenu), {
                    componentType: "menulist",
                    tenant: tenant,
                    setTenant: (newTenant)=>{
                        setStack({
                            ...stack,
                            tenants: stack.tenants.map((t)=>t.placement_id == tenant.placement_id ? newTenant : t)
                        });
                    },
                    preferences: tenant.position.preferences ?? [],
                    setPreferences: (preferences)=>{
                        setStack({
                            ...stack,
                            tenants: stack.tenants.map((t)=>({
                                    ...t,
                                    position: {
                                        ...t.position,
                                        preferences: t.placement_id === tenant.placement_id ? preferences : t.position.preferences
                                    }
                                }))
                        });
                    },
                    onDeleteAircraft: async ()=>{
                        setStack({
                            ...stack,
                            tenants: stack.tenants.filter((t)=>t.placement_id !== tenant.placement_id)
                        });
                        // if the stack is a reference, then we also need to convert the tenant to a transient
                        if (stack.name === "reference") await postgrest.from("tenant").update({
                            type: "transient"
                        }).eq("id", tenant.id);
                        setRightClick(null);
                    },
                    menuProps: {
                        open: true
                    },
                    stack: stack,
                    setStack: (updatedStack)=>{
                        setStack({
                            ...stack,
                            ...updatedStack
                        });
                    },
                    onIncrementalPark: onIncrementalPark
                })
            })
        ]
    });
};

});
parcelRegister("awKYK", function(module, exports) {
$parcel$export(module.exports, "DraggableAircraft", () => (parcelRequire("34myE")).DraggableAircraft);
parcelRequire("34myE");

});
parcelRegister("34myE", function(module, exports) {

$parcel$export(module.exports, "DraggableAircraft", () => $11043ae253ccbc9f$export$3f5015058e41e9e2);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2TpcN = parcelRequire("2TpcN");

var $gxaW2 = parcelRequire("gxaW2");

var $aQSqz = parcelRequire("aQSqz");
const { useEffect: $11043ae253ccbc9f$var$useEffect, useRef: $11043ae253ccbc9f$var$useRef } = $acw62;
const $11043ae253ccbc9f$export$3f5015058e41e9e2 = ({ entity_id: entity_id, tenantType: tenantType = "transient", readOnly: readOnly = false, frozen: frozen = false, hideDragIndicator: hideDragIndicator = false, forceDisplayLabel: forceDisplayLabel = false, forceDisplayNotes: forceDisplayNotes = false, label: label = "N/A", hotkey: hotkey, note: note, labelWidth: labelWidth, aircraft: aircraft, imageDimensions: imageDimensions, onPositionChange: onPositionChange, onChange: onChange = ()=>{}, onPlaneClick: onPlaneClick, onPlaneRightClick: onPlaneRightClick, onStartTowing: onStartTowing, onClickNotesButton: onClickNotesButton_, spacingBufferOverlayElement: spacingBufferOverlayElement, feetToPixels: feetToPixels, placementSource: placementSource, isLocked: isLocked })=>{
    const onClickNotesButton = onClickNotesButton_ || function() {};
    // This reference is used for the DOM div element that we'll render the drag
    // UI instance into.
    var planeRefElement = $11043ae253ccbc9f$var$useRef();
    // This ref is used to keep hold of the drag UI instance. Technically
    // we could probably use one ref but I think it's better to use each ref for
    // only one purpose
    var planeRef = $11043ae253ccbc9f$var$useRef({
        instance: null,
        // We use this attribute as a way to prevent old React state overriding
        // the current aircraft position, as set by the user.
        // As React state updates asynchonously
        pendingChangeTimestamp: aircraft.position.timestamp
    }).current;
    const onInstanceChange = $acw62.useCallback((event)=>{
        var timestamp = new Date().valueOf();
        planeRef.pendingChangeTimestamp = timestamp;
        var position = {
            x: event.x,
            y: event.y,
            angle: (0, $2TpcN.convertRadiansToDegress)(event.angle),
            timestamp: timestamp
        };
        onPositionChange(position);
    }, [
        onPositionChange
    ]);
    const onIncrementalChange = $acw62.useCallback((event)=>{
        var timestamp = new Date().valueOf();
        planeRef.pendingChangeTimestamp = timestamp;
        var position = {
            x: event.x,
            y: event.y,
            angle: (0, $2TpcN.convertRadiansToDegress)(event.angle),
            timestamp: timestamp
        };
        onChange(position);
    }, [
        onChange
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        var aircraftDto = {
            type: tenantType,
            entity_id: entity_id,
            make: aircraft.make,
            model: aircraft.model,
            width: imageDimensions.width,
            height: imageDimensions.height,
            front_wheels: aircraft.front_wheels * imageDimensions.height / 600,
            rear_wheels: aircraft.rear_wheels * imageDimensions.height / 600,
            image: aircraft.image,
            position: {
                // NOTE: modified for the new data model. `position` is { x, y, angle }
                x: aircraft.position.x,
                y: aircraft.position.y,
                angle: (0, $2TpcN.convertDegreesToRadians)(aircraft.position.angle)
            },
            wheel_rotation_limit: aircraft.wheel_rotation_limit,
            geom: aircraft.geom,
            tail_number: aircraft.tail_number,
            tail_height: aircraft.tail_height,
            // The scaled geom version is 180° rotated compared with the 'geom' so
            // this normalises it to be the same orientation
            spacing_buffer_geom: aircraft.spacing_buffer_geom,
            spacing_buffer_geom_dimensions: aircraft.spacing_buffer_geom_dimensions
        };
        // const aircraftDto = makeMinimalAircraft(aircraft, imageDimensions);
        planeRef.instance = new (0, $aQSqz.default)(aircraftDto, {
            selected: aircraft.selected,
            readOnly: readOnly,
            frozen: frozen,
            forceDisplayLabel: forceDisplayLabel,
            forceDisplayNotes: forceDisplayNotes,
            label: label,
            hotkey: hotkey,
            labelWidth: labelWidth,
            hideDragIndicator: hideDragIndicator,
            spacingBufferOverlay: spacingBufferOverlayElement,
            note: note,
            placementSource: placementSource,
            isLocked: isLocked
        });
        (0, $gxaW2.default).addAircraft(planeRef.instance);
        planeRef.instance.render(planeRefElement.current);
        return ()=>{
            (0, $gxaW2.default).removeAircraft(planeRef.instance);
            planeRef.instance.destroy();
        };
    }, [
        // If we change the aircraft completely tear it down and rebuild it
        aircraft?.id
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        var aircraftDto = {
            type: tenantType,
            entity_id: entity_id,
            make: aircraft.make,
            model: aircraft.model,
            width: imageDimensions.width,
            height: imageDimensions.height,
            front_wheels: aircraft.front_wheels * imageDimensions.height / 600,
            rear_wheels: aircraft.rear_wheels * imageDimensions.height / 600,
            image: aircraft.image,
            // We handle setting the aircraft position slightly differently, as
            // there's a check that isn't covered here to ensure we're not setting
            // the position to out of date state. More info in the `useEffect` hook
            // below.
            // position: {
            //   x: aircraft.position.x,
            //   y: aircraft.position.y,
            //   angle: convertDegreesToRadians(aircraft.position.angle),
            // },
            wheel_rotation_limit: aircraft.wheel_rotation_limit,
            geom: aircraft.geom,
            tail_number: aircraft.tail_number,
            tail_height: aircraft.tail_height,
            spacing_buffer_geom: aircraft.spacing_buffer_geom,
            spacing_buffer_geom_dimensions: aircraft.spacing_buffer_geom_dimensions
        };
        // const aircraftDto = makeMinimalAircraft(aircraft, imageDimensions);
        planeRef.instance.updateAircraft(aircraftDto);
        planeRef.instance.addEventListener("change", onIncrementalChange);
        // NOTE: changed the event to on dragEnd. this isn't neccessary depending on the
        // implementation.
        planeRef.instance.addEventListener("start", onStartTowing);
        planeRef.instance.addEventListener("dragEnd", onInstanceChange);
        planeRef.instance.addEventListener("rotateEnd", onInstanceChange);
        planeRef.instance.addEventListener("click", onPlaneClick);
        planeRef.instance.addEventListener("rightClick", onPlaneRightClick);
        planeRef.instance.addEventListener("onClickNotesButton", onClickNotesButton);
        return ()=>{
            planeRef.instance.removeEventListener("change", onIncrementalChange);
            // NOTE: changed the event to on dragEnd. this isn't neccessary depending on the
            // implementation.
            planeRef.instance.removeEventListener("start", onStartTowing);
            planeRef.instance.removeEventListener("dragEnd", onInstanceChange);
            planeRef.instance.removeEventListener("rotateEnd", onInstanceChange);
            planeRef.instance.removeEventListener("click", onPlaneClick);
            planeRef.instance.removeEventListener("rightClick", onPlaneRightClick);
            planeRef.instance.removeEventListener("onClickNotesButton", onClickNotesButton);
        };
    }, [
        aircraft,
        imageDimensions,
        // We have to reattach the event listeners if the feet to pixels ratio
        // changes because otherwise the event listener will be attached with the
        // wrong ratio in scope
        feetToPixels
    ]);
    /**
   * The feetToPixels value changes when React is doing multiple renders
   * and figuring out what the correct ratio should be. In this scenario
   * we need to reset the aircraft position.
   * That said we don't want to set the aircraft position when the user
   * is interacting with the diagram because React's state update is async
   * so this can mean we're setting the aircraft to a stale position.
   * What the user does is the source of truth, so there's no need to
   * set it to a different value.
   */ $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        // Due to React's state update cycle being async, the user may have
        // triggered a new position change before the position change comes
        // full cycle and passed back here.
        // Without this check we could end up setting the aircraft to an old / stale
        // position
        if (planeRef.pendingChangeTimestamp && aircraft.position.timestamp && planeRef.pendingChangeTimestamp == aircraft.position.timestamp) {
            // React has caught up, clear out the timestamp, if we don't
            // then the undo functionality won't work
            // because when tapping undo the pending change would otherwise always
            // be old
            delete planeRef.pendingChangeTimestamp;
            return;
        }
        if (planeRef.pendingChangeTimestamp && aircraft.position.timestamp && planeRef.pendingChangeTimestamp > aircraft.position.timestamp) // A user triggered an update faster than react re-renders, so we'll
        // ignore running this because it will set the aircraft to an old
        // position
        return;
        // if there is a pending timestamp update on the aircraft but the aircraft itself doesn't
        // have a timestamp update, don't update the planeRef.
        if (planeRef.pendingChangeTimestamp && !aircraft.position.timestamp) return;
        planeRef.instance.updateAircraft({
            position: {
                x: aircraft.position.x,
                y: aircraft.position.y,
                angle: (0, $2TpcN.convertDegreesToRadians)(aircraft.position.angle)
            }
        });
    }, [
        aircraft,
        feetToPixels
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setSelected(aircraft?.selected);
    }, [
        aircraft?.selected
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setForceDisplayLabel(forceDisplayLabel);
    }, [
        forceDisplayLabel
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setForceDisplayNotes(forceDisplayNotes);
    }, [
        forceDisplayNotes
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setLabel(label);
    }, [
        label
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setHotkey(hotkey);
    }, [
        hotkey
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setNote(note);
    }, [
        note
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setLabelWidth(labelWidth);
    }, [
        labelWidth
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setSpacingBufferOverlay(spacingBufferOverlayElement);
    }, [
        spacingBufferOverlayElement
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setPlacementSource(placementSource);
    }, [
        placementSource
    ]);
    $11043ae253ccbc9f$var$useEffect(()=>{
        if (!planeRef.instance) return;
        planeRef.instance.setIsLocked(isLocked);
    }, [
        isLocked
    ]);
    const name = Boolean(aircraft.make) ? `${aircraft.make} ${aircraft.model}` : `${label}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-attr": name,
        style: {
            zIndex: 100 + Math.ceil(100 * (aircraft.tail_bottom ?? 0))
        },
        ref: planeRefElement
    });
};

});
parcelRegister("2TpcN", function(module, exports) {

$parcel$export(module.exports, "getClockAngle", () => $bf3296dcf7fe3665$export$52fad5983d99fb90);
$parcel$export(module.exports, "getHypotenuse", () => $bf3296dcf7fe3665$export$4373f688011b89a3);
$parcel$export(module.exports, "convertDegreesToRadians", () => $bf3296dcf7fe3665$export$c29e4604bcc6f4d3);
$parcel$export(module.exports, "convertRadiansToDegress", () => $bf3296dcf7fe3665$export$e6f1e0795aba3e4f);
$parcel$export(module.exports, "rotateAroundOrigin", () => $bf3296dcf7fe3665$export$4726de5c59b02f7b);
$parcel$export(module.exports, "snapToNearest45Degrees", () => $bf3296dcf7fe3665$export$ce0edf259dd4ec2c);
/**
 * Given a coordinate, if a line was drawn from the 0,0 origin to this coordinate
 * then return the angle of this line as if it was a rotation around the z axis
 * |
 * |         x (2,2)
 * |
 * |
 * |________________________
 * 0,0
 */ const $bf3296dcf7fe3665$export$52fad5983d99fb90 = function(coord) {
    var { x: x, y: y } = coord;
    // Depending on if the coordinate is in the north-east, south-east, south-west
    // or north-west side of the x and y axises we solve the problem for each
    // quadrant and then add the respective angle multiples of 90°
    // Math.atan will give 180 degree different answers if you use a negative
    // 0 instead of a positive 0 🤷, effectively you're dividing by 0 so doing
    // atan on Infinity and -Infinity
    if (y == 0) y = 0;
    if (x == 0 && y == 0) return 0;
    // This is the north-east section of the axises
    if (x >= 0 && y >= 0) // This gives us the angle between the y-axis and the hypothenus
    return Math.atan(x / y);
    else if (x >= 0 && y < 0) {
        // The south-east section
        var theta = Math.atan(y * -1 / x);
        // Add 90° to the angle
        return Math.PI / 2 + theta;
    } else if (x < 0 && y < 0) {
        // The south-west section
        var theta = Math.atan(x * -1 / (y * -1));
        // Add 180° to the angle
        return Math.PI + theta;
    } else {
        var theta = Math.atan(y / (x * -1));
        // Add 270° to the angle
        return Math.PI * 3 / 2 + theta;
    }
};
const $bf3296dcf7fe3665$export$4373f688011b89a3 = function(coord) {
    return Math.sqrt(Math.pow(coord.x, 2) + Math.pow(coord.y, 2));
};
const $bf3296dcf7fe3665$export$c29e4604bcc6f4d3 = function(degrees) {
    return degrees * (Math.PI / 180);
};
const $bf3296dcf7fe3665$export$e6f1e0795aba3e4f = function(radians) {
    return radians / (Math.PI / 180);
};
const $bf3296dcf7fe3665$export$4726de5c59b02f7b = function(coord, angle, origin = {
    x: 0,
    y: 0
}) {
    var coordRelativeToOrigin = {
        x: coord.x - origin.x,
        y: coord.y - origin.y
    };
    var { x: x, y: y } = coordRelativeToOrigin;
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var rotatedCoordRelativeToOrigin = {
        x: cos * x + sin * y,
        y: cos * y - sin * x
    };
    return {
        x: rotatedCoordRelativeToOrigin.x + origin.x,
        y: rotatedCoordRelativeToOrigin.y + origin.y
    };
};
const $bf3296dcf7fe3665$export$ce0edf259dd4ec2c = function(angle) {
    // 45 degrees in radians = π/4
    var increment = Math.PI / 4;
    // Normalize angle to 0-2π range
    var normalizedAngle = angle % (2 * Math.PI);
    if (normalizedAngle < 0) normalizedAngle += 2 * Math.PI;
    // Snap to nearest π/4 increment
    return Math.round(normalizedAngle / increment) * increment;
};

});

parcelRegister("gxaW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31cbc836e394298c$export$2e2bcd8739ae039);
/**
 * @fileOverview This only serves as a place to lump all interactive aircraft
 * into a global array, the same could likely be achieved by passing down
 * a ref from the parent component that makes use of it.
 * The reason for doing this is when the user taps anywhere on the screen
 * it deselects the current aircraft, but we don't want this behaviour if
 * the user has been rotating a plane around it's rotation handles. But it's
 * quite likely that releasing the mouse after rotating will not be over the
 * top of the draggable aircraft, and so we need to query at that point if
 * any aircraft are being dragged so we can cancel the deselection.
 */ var $31cbc836e394298c$var$DraggableAircraftRegistry = function() {
    this.aircraft_ = [];
};
$31cbc836e394298c$var$DraggableAircraftRegistry.prototype.addAircraft = function(aircraft) {
    this.aircraft_.push(aircraft);
};
$31cbc836e394298c$var$DraggableAircraftRegistry.prototype.removeAircraft = function(aircraft) {
    var foundIndex = this.aircraft_.findIndex((a)=>aircraft == a);
    if (foundIndex == -1) throw new Error('Aircraft instance not found in registry.');
    this.aircraft_.splice(foundIndex, 1);
};
$31cbc836e394298c$var$DraggableAircraftRegistry.prototype.isAnyAircraftBeingInteractedWith = function() {
    return this.aircraft_.some((a)=>a.isBeingInteractedWith());
};
var $31cbc836e394298c$export$2e2bcd8739ae039 = new $31cbc836e394298c$var$DraggableAircraftRegistry();

});

parcelRegister("aQSqz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e07ceb8cb15392$export$2e2bcd8739ae039);


var $zjHy4 = parcelRequire("zjHy4");

var $8kLxM = parcelRequire("8kLxM");

var $lg081 = parcelRequire("lg081");

var $5J9LZ = parcelRequire("5J9LZ");

var $2TpcN = parcelRequire("2TpcN");

var $3Ju9e = parcelRequire("3Ju9e");

var $9LbHN = parcelRequire("9LbHN");

var $4VRZh = parcelRequire("4VRZh");

var $iWuOJ = parcelRequire("iWuOJ");

var $bycdy = parcelRequire("bycdy");
const $a5e07ceb8cb15392$var$defaultOptions = {
    selected: false,
    readOnly: false,
    frozen: false,
    forceDisplayLabel: false,
    forceDisplayNotes: false,
    hideDragIndicator: false,
    spacingBufferOverlay: null,
    note: null
};
var $a5e07ceb8cb15392$var$DraggablePlane = function(aircraft, options = $a5e07ceb8cb15392$var$defaultOptions) {
    (0, $iWuOJ.default).call(this);
    // Clone the aircraft so any changes to its props won't affect this
    // interaction
    this.aircraft = {
        ...aircraft,
        position: {
            ...aircraft.position
        }
    };
    // Chances are this won't trigger unless there's a non 0 starting rotation
    // but still throw as a way to help catch mistakes when non radians are
    // used
    if (aircraft.position.angle > Math.PI * 2) throw new Error(`Aircraft angle should be in radians not degrees ${aircraft.position.angle}`);
    this.type_ = aircraft.type;
    this.rotation_ = aircraft.position.angle || 0;
    this.wheelRotationLimit_ = aircraft.wheel_rotation_limit;
    // For testing
    // this.wheelRotationLimit_ = 45;
    //this.wheelRotationLimit_ = null
    this.frontWheelDragHandler_ = new (0, $8kLxM.default)();
    this.frontWheelDragHandler_.setPosition(this.getFrontWheelsPos_());
    this.aircraftDragHandler_ = new (0, $8kLxM.default)();
    this.aircraftDragHandler_.setPosition(this.getRearWheelsPos_());
    this.rotationNEDragHandler_ = new (0, $8kLxM.default)();
    this.rotationSEDragHandler_ = new (0, $8kLxM.default)();
    this.rotationSWDragHandler_ = new (0, $8kLxM.default)();
    this.rotationNWDragHandler_ = new (0, $8kLxM.default)();
    this.bindedOnFrontWheelDragHandlerStart_ = this.onFrontWheelDragHandlerStart_.bind(this);
    this.bindedOnFrontWheelDragHandlerMove_ = this.onFrontWheelDragHandlerMove_.bind(this);
    this.bindedOnFrontWheelDragHandlerStop_ = this.onFrontWheelDragHandlerStop_.bind(this);
    this.bindedOnAircraftDragHandlerStart_ = this.onAircraftDragHandlerStart_.bind(this);
    this.bindedOnAircraftDragHandlerMove_ = this.onAircraftDragHandlerMove_.bind(this);
    this.bindedOnAircraftDragHandlerChange_ = this.onAircraftDragHandlerChange_.bind(this);
    this.bindedOnAircraftDragHandlerStop_ = this.onAircraftDragHandlerStop_.bind(this);
    this.bindedComputeFrame_ = this.computeFrame_.bind(this);
    this.bindedOnClick_ = this.onClick_.bind(this);
    this.bindedOnRightClick_ = this.onRightClick_.bind(this);
    this.bindedOnClickNotesButton_ = this.onClickNotesButton_.bind(this);
    this.debouncedMarkExtremeAngle_ = (0, $5J9LZ.debounce)(this.markExtremeAngle_, 40);
    this.bindedOnRotationNEDragHandlerStart_ = this.onRotationNEDragHandlerStart_.bind(this);
    this.bindedOnRotationNEDragHandlerMove_ = this.onRotationNEDragHandlerMove_.bind(this);
    this.bindedOnRotationNEDragHandlerStop_ = this.onRotationNEDragHandlerStop_.bind(this);
    this.bindedOnRotationSEDragHandlerStart_ = this.onRotationSEDragHandlerStart_.bind(this);
    this.bindedOnRotationSEDragHandlerMove_ = this.onRotationSEDragHandlerMove_.bind(this);
    this.bindedOnRotationSEDragHandlerStop_ = this.onRotationSEDragHandlerStop_.bind(this);
    this.bindedOnRotationSWDragHandlerStart_ = this.onRotationSWDragHandlerStart_.bind(this);
    this.bindedOnRotationSWDragHandlerMove_ = this.onRotationSWDragHandlerMove_.bind(this);
    this.bindedOnRotationSWDragHandlerStop_ = this.onRotationSWDragHandlerStop_.bind(this);
    this.bindedOnRotationNWDragHandlerStart_ = this.onRotationNWDragHandlerStart_.bind(this);
    this.bindedOnRotationNWDragHandlerMove_ = this.onRotationNWDragHandlerMove_.bind(this);
    this.bindedOnRotationNWDragHandlerStop_ = this.onRotationNWDragHandlerStop_.bind(this);
    this.movementHistory_ = [];
    // We use this as a flag to know the instance has been destroyed
    this.alive_ = true;
    const { selected: selected, readOnly: readOnly, frozen: frozen, forceDisplayLabel: forceDisplayLabel, forceDisplayNotes: forceDisplayNotes, hideDragIndicator: hideDragIndicator, spacingBufferOverlay: spacingBufferOverlay, label: label, hotkey: hotkey, note: note, labelWidth: labelWidth, placementSource: placementSource, isLocked: isLocked } = options;
    this.selected_ = !!selected;
    this.readOnly_ = readOnly;
    this.frozen_ = frozen;
    this.forceDisplayLabel_ = forceDisplayLabel;
    this.forceDisplayNotes_ = forceDisplayNotes;
    this.hideDragIndicator_ = hideDragIndicator;
    this.spacingBufferOverlay_ = spacingBufferOverlay;
    this.label_ = label;
    this.labelWidth_ = labelWidth;
    this.hotkey_ = hotkey;
    this.note_ = note;
    this.placementSource_ = placementSource;
    this.isLocked_ = isLocked;
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype = new (0, $iWuOJ.default)();
/**
 * Get the plane's rear wheel position relative to the top left.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.getRearWheelsPos_ = function() {
    return {
        x: this.aircraft.position.x + this.aircraft.width / 2,
        y: this.aircraft.position.y + this.aircraft.rear_wheels
    };
};
/**
 * Get the plane's front wheel position relative to the top left.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.getFrontWheelsPos_ = function() {
    var rearWheelsPos = this.getRearWheelsPos_();
    return (0, $2TpcN.rotateAroundOrigin)({
        x: rearWheelsPos.x,
        y: rearWheelsPos.y - this.getDistanceBetweenWheels_()
    }, -this.rotation_, rearWheelsPos);
};
/**
 * Get the distance between the front and rear wheels.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.getDistanceBetweenWheels_ = function() {
    return this.aircraft.rear_wheels - this.aircraft.front_wheels;
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.createDom = function() {
    const c = this.dom_.createElement.bind(this.dom_);
    var origin = c("div", {
        class: "origin"
    }, c("span"));
    this.originElement_ = origin;
    if (this.hideDragIndicator_) this.frontWheelsDragElement_ = c("div", {
        class: ""
    }, c("span"));
    else {
        const frontWheelsClass = this.type_ === "base" ? "frontWheels tenant" : "frontWheels";
        this.frontWheelsDragElement_ = c("div", {
            class: frontWheelsClass
        }, c("span"));
    }
    // This is only used for debugging, the user does not interact with this
    // element, it only shows where the position of the front wheel drag handler
    // is located
    this.frontWheelDragIndicator_ = c("div", {
        class: "frontWheelDragIndicator"
    }, c("span"));
    this.aircraftDragIndicator_ = c("div", {
        class: "aircraftDragIndicator"
    }, c("span"));
    this.aircraftTransformOriginIndicator_ = c("div", {
        class: "originIndicator"
    }, c("span"));
    var viewBoxMaxValue = Math.max(...this.aircraft.geom["coordinates"][0].map((coord)=>Math.max(...coord)));
    this.planePolygon_ = new (0, $bycdy.default)(this.aircraft.geom, // The aircraft polygon should always be square
    `0 0 ${viewBoxMaxValue} ${viewBoxMaxValue}`);
    this.planePolygon_.createDom();
    // Create the rotation drag handles
    this.rotationHandleNW_ = c("div", {
        class: "rotationHandle nw"
    }, c("span"));
    this.rotationHandleNE_ = c("div", {
        class: "rotationHandle ne"
    }, c("span"));
    this.rotationHandleSE_ = c("div", {
        class: "rotationHandle se"
    }, c("span"));
    this.rotationHandleSW_ = c("div", {
        class: "rotationHandle sw"
    }, c("span"));
    this.rotationHandleHitboxNE_ = c("div", {
        class: "rotationHandleHitbox ne"
    }, c("span"));
    this.rotationHandleHitboxSE_ = c("div", {
        class: "rotationHandleHitbox se"
    }, c("span"));
    this.rotationHandleHitboxSW_ = c("div", {
        class: "rotationHandleHitbox sw"
    }, c("span"));
    this.rotationHandleHitboxNW_ = c("div", {
        class: "rotationHandleHitbox nw"
    }, c("span"));
    this.clockwiseArrowNE_ = new (0, $4VRZh.default)();
    this.clockwiseArrowNE_.createDom();
    this.clockwiseArrowNE_.getElement().setAttribute("class", "ClockwiseArrow ne");
    this.clockwiseArrowSE_ = new (0, $4VRZh.default)();
    this.clockwiseArrowSE_.createDom();
    this.clockwiseArrowSE_.getElement().setAttribute("class", "ClockwiseArrow se");
    this.clockwiseArrowSW_ = new (0, $4VRZh.default)();
    this.clockwiseArrowSW_.createDom();
    this.clockwiseArrowSW_.getElement().setAttribute("class", "ClockwiseArrow sw");
    this.clockwiseArrowNW_ = new (0, $4VRZh.default)();
    this.clockwiseArrowNW_.createDom();
    this.clockwiseArrowNW_.getElement().setAttribute("class", "ClockwiseArrow nw");
    this.antiClockwiseArrowNE_ = new (0, $9LbHN.default)();
    this.antiClockwiseArrowNE_.createDom();
    this.antiClockwiseArrowNE_.getElement().setAttribute("class", "AntiClockwiseArrow ne");
    this.antiClockwiseArrowSE_ = new (0, $9LbHN.default)();
    this.antiClockwiseArrowSE_.createDom();
    this.antiClockwiseArrowSE_.getElement().setAttribute("class", "AntiClockwiseArrow se");
    this.antiClockwiseArrowSW_ = new (0, $9LbHN.default)();
    this.antiClockwiseArrowSW_.createDom();
    this.antiClockwiseArrowSW_.getElement().setAttribute("class", "AntiClockwiseArrow sw");
    this.antiClockwiseArrowNW_ = new (0, $9LbHN.default)();
    this.antiClockwiseArrowNW_.createDom();
    this.antiClockwiseArrowNW_.getElement().setAttribute("class", "AntiClockwiseArrow nw");
    // This will end up being attached to the spacing buffer container if one
    // exists, which is an element that is external to this component
    this.spacingBufferAircraftContainer_ = c("div", {
        id: `spacing-buffer-aircraft-container-${this.aircraft.entity_id}`,
        class: "DraggablePlane-SpacingBufferAircraftContainer"
    });
    if (this.aircraft.spacing_buffer_geom) this.createBufferPlanePolygon_();
    var aircraftImage = c("div", {
        [`data-entity_id`]: this.aircraft.entity_id,
        class: "aircraftImage"
    }, this.planePolygon_.getElement(), this.aircraftTransformOriginIndicator_, this.rotationHandleNW_, this.rotationHandleNE_, this.rotationHandleSE_, this.rotationHandleSW_, this.clockwiseArrowNE_.getElement(), this.clockwiseArrowSE_.getElement(), this.clockwiseArrowSW_.getElement(), this.clockwiseArrowNW_.getElement(), this.antiClockwiseArrowNE_.getElement(), this.antiClockwiseArrowSE_.getElement(), this.antiClockwiseArrowSW_.getElement(), this.antiClockwiseArrowNW_.getElement(), this.rotationHandleHitboxNE_, this.rotationHandleHitboxSE_, this.rotationHandleHitboxSW_, this.rotationHandleHitboxNW_);
    this.aircraftImage_ = aircraftImage;
    this.tailNumberTextElement_ = c("span");
    let tailNumberElementClass = "tailNumber";
    if (this.hotkey_) tailNumberElementClass += " hotkey";
    if (this.note_) tailNumberElementClass += " note";
    // Add placement source class
    if (this.placementSource_ === "auto") tailNumberElementClass += " placement-auto";
    else if (this.placementSource_ === "manual") tailNumberElementClass += " placement-manual";
    // Add locked class
    if (this.isLocked_) tailNumberElementClass += " placement-locked";
    this.tailNumberElement_ = c("div", {
        class: tailNumberElementClass
    }, c("span", null, this.tailNumberTextElement_, c("div", {
        class: "noteTooltip"
    }, c("span", null, this.note_ ?? ""))));
    this.noteToolTipSpan_ = this.tailNumberElement_.querySelector(".noteTooltip span");
    const mainClass = `DraggablePlane${this.selected_ ? " selected" : ""}${this.readOnly_ ? " readOnly" : ""}`;
    this.element_ = c("div", {
        class: mainClass
    }, aircraftImage, origin, this.frontWheelsDragElement_, this.frontWheelDragIndicator_, this.aircraftDragIndicator_, this.tailNumberElement_);
    if (this.forceDisplayLabel_) this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "forceShow");
    if (this.forceDisplayNotes_) this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "forceDisplayNotes");
    // Add max angle of rotation indicators
    if (this.wheelRotationLimit_) {
        var angleLeft = c("div", {
            class: "wheelAngle"
        });
        angleLeft.style.transform = `rotate(${180 - this.wheelRotationLimit_}deg)`;
        var angleRight = c("div", {
            class: "wheelAngle wheelAngleRight"
        });
        angleRight.style.transform = `rotate(${180 + this.wheelRotationLimit_}deg)`;
        this.frontWheelsDragElement_.appendChild(angleLeft);
        this.frontWheelsDragElement_.appendChild(angleRight);
        this.angleLeft_ = angleLeft;
        this.angleRight_ = angleRight;
        // For testing add the rear wheel angle, i.e when moving the plane backwards
        var rearAngleLeft = c("div", {
            class: "wheelAngleRear"
        });
        rearAngleLeft.style.transform = `rotate(${this.wheelRotationLimit_}deg)`;
        var rearAngleRight = c("div", {
            class: "wheelAngleRear wheelAngleRearRight"
        });
        rearAngleRight.style.transform = `rotate(${-this.wheelRotationLimit_}deg)`;
        this.frontWheelsDragElement_.appendChild(rearAngleLeft);
        this.frontWheelsDragElement_.appendChild(rearAngleRight);
    } else if (this.wheelRotationLimit_ === null) {
        // There's unlimited rotation specified
        var unlimitedAngle = c("div", {
            class: "unlimitedWheelAngle"
        });
        this.frontWheelsDragElement_.appendChild(unlimitedAngle);
        this.unlimitedAngle_ = unlimitedAngle;
    }
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.render = function(container) {
    (0, $iWuOJ.default).prototype.render.call(this, container);
    if (!this.readOnly_ && !this.frozen_) this.addEventListeners_();
    this.paint_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.addEventListeners_ = function() {
    (0, $lg081.default).listen(this.frontWheelDragHandler_, "start", this.bindedOnFrontWheelDragHandlerStart_);
    (0, $lg081.default).listen(this.frontWheelDragHandler_, "move", this.bindedOnFrontWheelDragHandlerMove_);
    (0, $lg081.default).listen(this.frontWheelDragHandler_, "stop", this.bindedOnFrontWheelDragHandlerStop_);
    (0, $lg081.default).listen(this.aircraftDragHandler_, "start", this.bindedOnAircraftDragHandlerStart_);
    (0, $lg081.default).listen(this.aircraftDragHandler_, "move", this.bindedOnAircraftDragHandlerMove_);
    (0, $lg081.default).listen(this.aircraftDragHandler_, "change", this.bindedOnAircraftDragHandlerChange_);
    (0, $lg081.default).listen(this.aircraftDragHandler_, "stop", this.bindedOnAircraftDragHandlerStop_);
    (0, $lg081.default).listen(this.rotationNEDragHandler_, "start", this.bindedOnRotationNEDragHandlerStart_);
    (0, $lg081.default).listen(this.rotationNEDragHandler_, "move", this.bindedOnRotationNEDragHandlerMove_);
    (0, $lg081.default).listen(this.rotationNEDragHandler_, "stop", this.bindedOnRotationNEDragHandlerStop_);
    (0, $lg081.default).listen(this.rotationSEDragHandler_, "start", this.bindedOnRotationSEDragHandlerStart_);
    (0, $lg081.default).listen(this.rotationSEDragHandler_, "move", this.bindedOnRotationSEDragHandlerMove_);
    (0, $lg081.default).listen(this.rotationSEDragHandler_, "stop", this.bindedOnRotationSEDragHandlerStop_);
    (0, $lg081.default).listen(this.rotationSWDragHandler_, "start", this.bindedOnRotationSWDragHandlerStart_);
    (0, $lg081.default).listen(this.rotationSWDragHandler_, "move", this.bindedOnRotationSWDragHandlerMove_);
    (0, $lg081.default).listen(this.rotationSWDragHandler_, "stop", this.bindedOnRotationSWDragHandlerStop_);
    (0, $lg081.default).listen(this.rotationNWDragHandler_, "start", this.bindedOnRotationNWDragHandlerStart_);
    (0, $lg081.default).listen(this.rotationNWDragHandler_, "move", this.bindedOnRotationNWDragHandlerMove_);
    (0, $lg081.default).listen(this.rotationNWDragHandler_, "stop", this.bindedOnRotationNWDragHandlerStop_);
    (0, $lg081.default).listen(this.planePolygon_, "pointerup", this.bindedOnClick_);
    (0, $lg081.default).listen(this.planePolygon_, "contextmenu", this.bindedOnRightClick_);
    (0, $lg081.default).listen(this.noteToolTipSpan_, "dblclick", this.bindedOnClickNotesButton_);
    this.frontWheelDragHandler_.attachTo(this.frontWheelsDragElement_);
    this.aircraftDragHandler_.attachTo(this.planePolygon_.getPolygonElement());
    this.aircraftDragHandler_.attachTo(this.tailNumberTextElement_);
    this.rotationNEDragHandler_.attachTo(this.rotationHandleHitboxNE_);
    this.rotationSEDragHandler_.attachTo(this.rotationHandleHitboxSE_);
    this.rotationSWDragHandler_.attachTo(this.rotationHandleHitboxSW_);
    this.rotationNWDragHandler_.attachTo(this.rotationHandleHitboxNW_);
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.removeEventListeners_ = function() {
    (0, $lg081.default).unlisten(this.frontWheelDragHandler_, "start", this.bindedOnFrontWheelDragHandlerStart_);
    (0, $lg081.default).unlisten(this.frontWheelDragHandler_, "move", this.bindedOnFrontWheelDragHandlerMove_);
    (0, $lg081.default).unlisten(this.frontWheelDragHandler_, "stop", this.bindedOnFrontWheelDragHandlerStop_);
    (0, $lg081.default).unlisten(this.aircraftDragHandler_, "start", this.bindedOnAircraftDragHandlerStart_);
    (0, $lg081.default).unlisten(this.aircraftDragHandler_, "move", this.bindedOnAircraftDragHandlerMove_);
    (0, $lg081.default).unlisten(this.aircraftDragHandler_, "change", this.bindedOnAircraftDragHandlerChange_);
    (0, $lg081.default).unlisten(this.aircraftDragHandler_, "stop", this.bindedOnAircraftDragHandlerStop_);
    (0, $lg081.default).unlisten(this.rotationNEDragHandler_, "start", this.bindedOnRotationNEDragHandlerStart_);
    (0, $lg081.default).unlisten(this.rotationNEDragHandler_, "move", this.bindedOnRotationNEDragHandlerMove_);
    (0, $lg081.default).unlisten(this.rotationNEDragHandler_, "stop", this.bindedOnRotationNEDragHandlerStop_);
    (0, $lg081.default).unlisten(this.rotationSEDragHandler_, "start", this.bindedOnRotationSEDragHandlerStart_);
    (0, $lg081.default).unlisten(this.rotationSEDragHandler_, "move", this.bindedOnRotationSEDragHandlerMove_);
    (0, $lg081.default).unlisten(this.rotationSEDragHandler_, "stop", this.bindedOnRotationSEDragHandlerStop_);
    (0, $lg081.default).unlisten(this.rotationSWDragHandler_, "start", this.bindedOnRotationSWDragHandlerStart_);
    (0, $lg081.default).unlisten(this.rotationSWDragHandler_, "move", this.bindedOnRotationSWDragHandlerMove_);
    (0, $lg081.default).unlisten(this.rotationSWDragHandler_, "stop", this.bindedOnRotationSWDragHandlerStop_);
    (0, $lg081.default).unlisten(this.rotationNWDragHandler_, "start", this.bindedOnRotationNWDragHandlerStart_);
    (0, $lg081.default).unlisten(this.rotationNWDragHandler_, "move", this.bindedOnRotationNWDragHandlerMove_);
    (0, $lg081.default).unlisten(this.rotationNWDragHandler_, "stop", this.bindedOnRotationNWDragHandlerStop_);
    (0, $lg081.default).unlisten(this.planePolygon_, "pointerup", this.bindedOnClick_);
    (0, $lg081.default).unlisten(this.planePolygon_, "contextmenu", this.bindedOnRightClick_);
    (0, $lg081.default).unlisten(this.noteToolTipSpan_, "dblclick", this.bindedOnClickNotesButton_);
// TODO Add detachFrom method for drag handlers
};
/**
 * Fires when the user begins dragging the front wheel.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onFrontWheelDragHandlerStart_ = function() {
    this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "frontWheelDragging");
    this.onDraggingStart_();
};
/**
 * Fires when the user starts dragging the aircraft
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onAircraftDragHandlerStart_ = function() {
    this.onDraggingStart_();
};
/**
 * Fire when the user starts dragging, causes the UI to update on each
 * animation frame.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onDraggingStart_ = function() {
    this.dragging_ = true;
    this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "dragging");
    window.requestAnimationFrame(this.bindedComputeFrame_);
    this.dispatchEvent({
        type: "start"
    });
};
/**
 * Fires when the user is dragging the front wheel
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onFrontWheelDragHandlerMove_ = function(e) {
    var dragPos = e;
    var rearWheelsPos = this.getRearWheelsPos_();
    // Here we check if the front wheel is turning at an angle that is too extreme
    // for the maximum front wheel rotation
    var isFrontWheelAngleTooExtreme = (()=>{
        if (!this.wheelRotationLimit_) return false;
        this.movementHistory_.push({
            mousePos: dragPos,
            rearWheelPos: rearWheelsPos,
            rotation: this.rotation_
        });
        var angle = (0, $3Ju9e.getMovementAngle)(this.movementHistory_);
        if (!angle) return false;
        var d = (0, $2TpcN.convertRadiansToDegress)(angle);
        d = (d + 360) % 360;
        var maxAngle = this.wheelRotationLimit_;
        var topSideAntiClockwiseAngleLimit = 360 - maxAngle;
        var topSideClockwiseAngleLimit = maxAngle;
        var bottomSideAntiClockwiseAngleLimit = 180 + maxAngle;
        var bottomSideClockwiseAngleLimit = 180 - maxAngle;
        if (d < topSideAntiClockwiseAngleLimit && d >= 270) return true;
        if (d > topSideClockwiseAngleLimit && d <= 90) return true;
        if (d < bottomSideClockwiseAngleLimit && d > 90) return true;
        if (d > bottomSideAntiClockwiseAngleLimit && d < 270) return true;
        return false;
    })();
    if (this.extremeAngle_ != isFrontWheelAngleTooExtreme) {
        this.extremeAngle_ = isFrontWheelAngleTooExtreme;
        // Only fire this if the value changes, so that we get the right behaviour
        // on the debounce, i.e. it'll ignore flip-flopping
        this.debouncedMarkExtremeAngle_(isFrontWheelAngleTooExtreme);
    }
    var mouseRelativeToOrigin = {
        x: dragPos.x - rearWheelsPos.x,
        y: dragPos.y - rearWheelsPos.y
    };
    var rotation = (0, $2TpcN.getClockAngle)({
        x: mouseRelativeToOrigin.x,
        y: mouseRelativeToOrigin.y // * -1,
    });
    // We do PI minus rotation here because the y coordinate we're working with
    // is inversed respective to the needed rotation, i.e.
    // 0 aligns to the top of the screen not the bottom
    this.rotation_ = Math.PI - rotation;
    // Get the new origin / rear wheel pos based on moving along the plane axis
    var currentHypothenus = (0, $2TpcN.getHypotenuse)(mouseRelativeToOrigin);
    var scaleChange = (currentHypothenus - this.getDistanceBetweenWheels_()) / currentHypothenus;
    var originMovement = {
        x: mouseRelativeToOrigin.x * scaleChange,
        y: mouseRelativeToOrigin.y * scaleChange
    };
    this.aircraft.position.x = this.aircraft.position.x + originMovement.x;
    this.aircraft.position.y = this.aircraft.position.y + originMovement.y;
    // TODO Put this in the aircraft drag handler and the rotating drag handler
    // functions if relying on it
    this.dispatchEvent({
        type: "change",
        x: this.aircraft.position.x,
        y: this.aircraft.position.y,
        angle: this.rotation_
    });
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onAircraftDragHandlerMove_ = function(e) {
    this.aircraft.position.x = e.x - this.aircraft.width / 2;
    this.aircraft.position.y = e.y - this.aircraft.rear_wheels;
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onAircraftDragHandlerChange_ = function(e) {
    this.dispatchEvent({
        type: "change",
        x: e.x - this.aircraft.width / 2,
        y: e.y - this.aircraft.rear_wheels,
        angle: this.rotation_
    });
};
/**
 * Fires when the user stops dragging the front wheel
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onFrontWheelDragHandlerStop_ = function() {
    this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "frontWheelDragging");
    this.onDraggingStop_();
};
/**
 * Fires when the user stops dragging the aircraft.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onAircraftDragHandlerStop_ = function() {
    this.onDraggingStop_();
};
/**
 * Fire after stopping dragging the aircraft.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onDraggingStop_ = function() {
    this.dragging_ = false;
    this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "dragging");
    this.resetDragHandlerPositions_();
    this.dispatchEvent({
        type: "dragEnd",
        x: this.aircraft.position.x,
        y: this.aircraft.position.y,
        angle: this.rotation_
    });
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.computeFrame_ = function() {
    this.paint_();
    if (this.dragging_ || this.rotating_) window.requestAnimationFrame(this.bindedComputeFrame_);
};
/**
 * Call this at any time to update the aircraft on the screen. It uses the
 * following air craft properties
 * Requires the following properties to be set.
 * - `this.aircraft.width`
 * - `this.aircraft.height`
 * - `this.aircraft.rear_wheels`
 * - `this.rotation_`
 * - `this.aircraft.image`
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.paint_ = function() {
    var frontWheelDragPos = this.frontWheelDragHandler_.getPosition();
    this.frontWheelDragIndicator_.style.top = frontWheelDragPos.y + "px";
    this.frontWheelDragIndicator_.style.left = frontWheelDragPos.x + "px";
    var aircraftDragPos = this.aircraftDragHandler_.getPosition();
    this.aircraftDragIndicator_.style.top = aircraftDragPos.y + "px";
    this.aircraftDragIndicator_.style.left = aircraftDragPos.x + "px";
    var frontWheelPos = this.getFrontWheelsPos_();
    var rearWheelsPos = this.getRearWheelsPos_();
    this.frontWheelsDragElement_.style.top = frontWheelPos.y + "px";
    this.frontWheelsDragElement_.style.left = frontWheelPos.x + "px";
    if (this.readOnly_ || this.frozen_) this.frontWheelsDragElement_.firstChild.style.backgroundColor = "transparent";
    var translation = {
        x: rearWheelsPos.x - this.aircraft.width / 2,
        y: rearWheelsPos.y - this.aircraft.rear_wheels
    };
    // The spacing buffer is slightly larger than the aircraft dimensions
    // Here we figure out its translation so that it aligns with the aircraft
    // image position but overlaps equally on all sides
    if (this.aircraft.spacing_buffer_geom_dimensions) {
        var spacingBufferTranslation = {
            x: rearWheelsPos.x - this.aircraft.spacing_buffer_geom_dimensions.width / 2,
            y: rearWheelsPos.y - this.aircraft.rear_wheels
        };
        // The aircraft and buffer polygon are aligned on the Y axis, i.e the x
        // cordinate in the centre of both are exactly the same, the only
        // variation is in the y direction because the buffer polygon is larger.
        // All rotation is taken care of by the css rotate prop but we need to
        // account for the slight difference in the y direction as this won't
        // be accounted for by the css rotation as the alignment will be slightly
        // off
        var mod = {
            x: 0,
            y: -((this.aircraft.spacing_buffer_geom_dimensions.height - this.aircraft.height) / 2)
        };
        var mod2 = (0, $2TpcN.rotateAroundOrigin)(mod, -this.rotation_, {
            x: 0,
            y: 0
        });
        spacingBufferTranslation.x += mod2.x;
        spacingBufferTranslation.y += mod2.y;
    }
    // TODO Do this via a transform for an optimisation
    this.aircraftImage_.style.backgroundImage = `url(${this.aircraft.image})`;
    this.aircraftImage_.style.left = translation.x + "px";
    this.aircraftImage_.style.top = translation.y + "px";
    this.aircraftImage_.style.transform = `rotate(${this.rotation_}rad)`;
    this.aircraftImage_.style.transformOrigin = `${this.aircraft.width / 2}px ${this.aircraft.rear_wheels}px`;
    this.aircraftImage_.style.width = `${this.aircraft.width}px`;
    this.aircraftImage_.style.height = `${this.aircraft.height}px`;
    if (this.aircraft.spacing_buffer_geom_dimensions) {
        this.spacingBufferAircraftContainer_.style.left = spacingBufferTranslation.x + "px";
        this.spacingBufferAircraftContainer_.style.top = spacingBufferTranslation.y + "px";
        this.spacingBufferAircraftContainer_.style.transform = `rotate(${this.rotation_}rad)`;
        this.spacingBufferAircraftContainer_.style.transformOrigin = `${this.aircraft.spacing_buffer_geom_dimensions.width / 2}px ${this.aircraft.rear_wheels}px`;
        this.spacingBufferAircraftContainer_.style.width = `${this.aircraft.spacing_buffer_geom_dimensions.width}px`;
        this.spacingBufferAircraftContainer_.style.height = `${this.aircraft.spacing_buffer_geom_dimensions.height}px`;
        if (this.spacingBufferOverlay_) {
            if (!this.spacingBufferAircraftContainer_.parentNode) {
                // remove all existing spacing buffer aircraft containers in the DOM
                const aircraftSpacingBufferContainerId = `spacing-buffer-aircraft-container-${this.aircraft.entity_id}`;
                const existingSpacingBufferAircraftContainers = document.querySelectorAll(`#${aircraftSpacingBufferContainerId}`);
                existingSpacingBufferAircraftContainers.forEach((el)=>el.parentNode.removeChild(el));
                this.spacingBufferOverlay_.appendChild(this.spacingBufferAircraftContainer_);
            }
        } else if (this.spacingBufferAircraftContainer_.parentNode) this.spacingBufferAircraftContainer_.parentNode.removeChild(this.spacingBufferAircraftContainer_);
    }
    if (!this.planePolygon_.getElement()) return;
    this.planePolygon_.getElement().style.left = "0px";
    this.planePolygon_.getElement().style.top = "0px";
    this.aircraftTransformOriginIndicator_.style.left = `${this.aircraft.width / 2}px`;
    this.aircraftTransformOriginIndicator_.style.top = `${this.aircraft.rear_wheels}px`;
    this.originElement_.style.top = rearWheelsPos.y + "px";
    this.originElement_.style.left = rearWheelsPos.x + "px";
    this.frontWheelsDragElement_.style.transform = `rotate(${this.rotation_}rad)`;
    this.frontWheelsDragElement_.style.transformOrigin = `0 0`;
    this.tailNumberElement_.style.top = rearWheelsPos.y + "px";
    this.tailNumberElement_.style.left = rearWheelsPos.x + "px";
    if (this.note_) this.tailNumberElement_.className = (0, $zjHy4.addClass)(this.tailNumberElement_.className, "note");
    else this.tailNumberElement_.className = (0, $zjHy4.removeClass)(this.tailNumberElement_.className, "note");
    // do this no matter what. handles when user deletes the note
    const noteTooltipContent = this.tailNumberElement_.querySelector(".noteTooltip span");
    if (noteTooltipContent) noteTooltipContent.textContent = this.note_;
    this.aircraftTransformOriginIndicator_.style.left = `${this.aircraft.width / 2}px`;
    this.aircraftTransformOriginIndicator_.style.top = `${this.aircraft.rear_wheels}px`;
    this.planePolygon_.getElement().style.width = `${this.aircraft.width}px`;
    this.planePolygon_.getElement().style.height = `${this.aircraft.height}px`;
    this.tailNumberTextElement_.innerText = this.hotkey_ ?? this.label_;
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.destroy = function() {
    if (!this.readOnly_ && !this.frozen_) this.removeEventListeners_();
    if (this.spacingBufferAircraftContainer_.parentNode) this.spacingBufferAircraftContainer_.parentNode.removeChild(this.spacingBufferAircraftContainer_);
    this.frontWheelDragHandler_.destroy();
    this.planePolygon_.destroy();
    (0, $iWuOJ.default).prototype.destroy.call(this);
    delete this.movementHistory_;
    delete this.alive_;
    delete this.dragging_;
};
/**
 * Pass in any props that you want to update on the aircraft, if props are
 * omitted then that aspect won't be updated.
 *
 * Note to remove the spacing buffer_geom, you must pass in null, if you
 * pass in undefined it will be treated as "don't change".
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.updateAircraft = function(aircraft) {
    if (aircraft.image !== undefined && aircraft.image != this.aircraft.image) this.aircraftImage_.style.backgroundImage = `url(${this.aircraft.image})`;
    // If we now have a buffer polygon then create it
    var shouldCreatePolygon = aircraft.spacing_buffer_geom && !this.aircraft.spacing_buffer_geom;
    // Else if we now don't have a buffer then delete it
    var shouldDeletePolygon = aircraft.spacing_buffer_geom === null && this.aircraft.spacing_buffer_geom;
    this.aircraft = {
        ...this.aircraft,
        ...aircraft
    };
    if (aircraft.position) {
        this.aircraft = {
            ...this.aircraft,
            position: {
                ...aircraft.position
            }
        };
        // Chances are this won't trigger unless there's a non 0 starting rotation
        // but still throw as a way to help catch mistakes when non radians are
        // used
        if (aircraft.position.angle > Math.PI * 2) throw new Error("Aircraft angle should be in radians not degrees");
        this.rotation_ = aircraft.position.angle || 0;
        this.resetDragHandlerPositions_();
    }
    if (shouldCreatePolygon) this.createBufferPlanePolygon_();
    if (shouldDeletePolygon && this.bufferPlanePolygon_) {
        this.bufferPlanePolygon_.destroy();
        delete this.bufferPlanePolygon_;
    }
    this.paint_();
};
/**
 * Mark the rotation indicators as at an extreme angle.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.markExtremeAngle_ = function(value) {
    if (value) this.frontWheelsDragElement_.className = (0, $zjHy4.addClass)(this.frontWheelsDragElement_.className, "extremeAngle");
    else this.frontWheelsDragElement_.className = (0, $zjHy4.removeClass)(this.frontWheelsDragElement_.className, "extremeAngle");
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onClick_ = function() {
    if (this.dragging_ || this.rotating_) // Don't fire the tap if we were dragging or rotating
    return;
    this.dispatchEvent({
        // It's actually a mouse up event but we'll fire as a click, this is so
        // we have control over only triggering a click if its not a drag
        type: "click"
    });
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onRightClick_ = function(event) {
    if (this.dragging_ || this.rotating_) // Don't fire the tap if we were dragging or rotating
    return;
    this.dispatchEvent({
        // It's actually a mouse up event but we'll fire as a click, this is so
        // we have control over only triggering a click if its not a drag
        type: "rightClick",
        event: event
    });
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onClickNotesButton_ = function(event) {
    this.dispatchEvent({
        // It's actually a mouse up event but we'll fire as a click, this is so
        // we have control over only triggering a click if its not a drag
        type: "onClickNotesButton",
        event: event
    });
};
/**
 * Set that the aircraft is selected.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.setSelected = function(val) {
    this.selected_ = val;
    if (this.element_) {
        if (this.selected_) {
            const paddingThreshhold = 50;
            if (this.aircraft.width < paddingThreshhold || this.aircraft.height < paddingThreshhold) this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "padded");
            this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "selected");
        } else this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "selected");
    }
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.setLabel = function(val) {
    this.label_ = val;
    this.paint_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.setHotkey = function(val) {
    this.hotkey_ = val;
    this.paint_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.setNote = function(val) {
    this.note_ = val;
    this.paint_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.setLabelWidth = function(val) {
    this.labelWidth_ = val;
    this.paint_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.setForceDisplayLabel = function(val) {
    this.forceDisplayLabel_ = val;
    if (this.forceDisplayLabel_) this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "forceShow");
    else this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "forceShow");
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.updateTailNumberClasses_ = function() {
    if (!this.tailNumberElement_) return;
    let classes = [
        "tailNumber"
    ];
    if (this.hotkey_) classes.push("hotkey");
    if (this.note_) classes.push("note");
    if (this.placementSource_ === "auto") classes.push("placement-auto");
    else if (this.placementSource_ === "manual") classes.push("placement-manual");
    if (this.isLocked_) classes.push("placement-locked");
    this.tailNumberElement_.className = classes.join(" ");
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.setPlacementSource = function(val) {
    if (this.placementSource_ === val) return;
    this.placementSource_ = val;
    this.updateTailNumberClasses_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.setIsLocked = function(val) {
    if (this.isLocked_ === val) return;
    this.isLocked_ = val;
    this.updateTailNumberClasses_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.setForceDisplayNotes = function(val) {
    this.forceDisplayNotes_ = val;
    if (this.forceDisplayNotes_) this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "forceDisplayNotes");
    else this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "forceDisplayNotes");
};
/**
 * Fired when the user starts dragging the north east dragger
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationNEDragHandlerStart_ = function() {
    var topRightPos = {
        x: this.aircraft.position.x + this.aircraft.width,
        y: this.aircraft.position.y
    };
    // Adjust it to match current rotation
    this.rotationNEDragHandlerStartPos_ = (0, $2TpcN.rotateAroundOrigin)(topRightPos, -this.rotation_, this.getRearWheelsPos_());
    this.onRotatingStart_();
};
/**
 * Fired when the user starts dragging the south east dragger
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationSEDragHandlerStart_ = function() {
    var bottomRightPos = {
        x: this.aircraft.position.x + this.aircraft.width,
        y: this.aircraft.position.y + this.aircraft.height
    };
    // Adjust it to match current rotation
    this.rotationSEDragHandlerStartPos_ = (0, $2TpcN.rotateAroundOrigin)(bottomRightPos, -this.rotation_, this.getRearWheelsPos_());
    this.onRotatingStart_();
};
/**
 * Fired when the user starts dragging the south west dragger
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationSWDragHandlerStart_ = function() {
    var bottomLeftPos = {
        x: this.aircraft.position.x,
        y: this.aircraft.position.y + this.aircraft.height
    };
    // Adjust it to match current rotation
    this.rotationSWDragHandlerStartPos_ = (0, $2TpcN.rotateAroundOrigin)(bottomLeftPos, -this.rotation_, this.getRearWheelsPos_());
    this.onRotatingStart_();
};
/**
 * Fired when the user starts dragging the north west dragger
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationNWDragHandlerStart_ = function() {
    var topLeftPos = {
        x: this.aircraft.position.x,
        y: this.aircraft.position.y
    };
    // Adjust it to match current rotation
    this.rotationNWDragHandlerStartPos_ = (0, $2TpcN.rotateAroundOrigin)(topLeftPos, -this.rotation_, this.getRearWheelsPos_());
    this.onRotatingStart_();
};
/**
 * Fired when the North-East rotation drag handler is moved.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationNEDragHandlerMove_ = function(e) {
    // Get the current absolute position of the mouse
    var mousePos = {
        x: this.rotationNEDragHandlerStartPos_.x + e.x,
        y: this.rotationNEDragHandlerStartPos_.y + e.y
    };
    // Get the relative position of the mouse to the origin / rear wheels
    var rotationOrigin = this.getRearWheelsPos_();
    var relativeMousePosToOrigin = {
        x: mousePos.x - rotationOrigin.x,
        y: (mousePos.y - rotationOrigin.y) * -1
    };
    // Get the angle of rotation
    var newRotation = (0, $2TpcN.getClockAngle)(relativeMousePosToOrigin);
    // Because this is the top right rotation handle then that handle is
    // that rotation from the origin so adjust back by that amount to get the
    // y axis rotation
    var angleToNECorner = (0, $2TpcN.getClockAngle)({
        x: this.aircraft.width / 2,
        y: this.aircraft.rear_wheels
    });
    newRotation -= angleToNECorner;
    this.onRotatingSet_(newRotation, e.shiftKey);
};
/**
 * Fired when the South-East rotation drag handler is moved.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationSEDragHandlerMove_ = function(e) {
    // Get the current absolute position of the mouse
    var mousePos = {
        x: this.rotationSEDragHandlerStartPos_.x + e.x,
        y: this.rotationSEDragHandlerStartPos_.y + e.y
    };
    // Get the relative position of the mouse to the origin / rear wheels
    var rotationOrigin = this.getRearWheelsPos_();
    var relativeMousePosToOrigin = {
        x: mousePos.x - rotationOrigin.x,
        y: (mousePos.y - rotationOrigin.y) * -1
    };
    // Get the angle of rotation
    var newRotation = (0, $2TpcN.getClockAngle)(relativeMousePosToOrigin);
    // Because this is the bottom right rotation handle then that handle is
    // approx 135° from the rear wheels of the plane
    var angleToSECorner = (0, $2TpcN.getClockAngle)({
        x: this.aircraft.width / 2,
        y: this.aircraft.rear_wheels - this.aircraft.width
    });
    newRotation -= angleToSECorner;
    this.onRotatingSet_(newRotation, e.shiftKey);
};
/**
 * Fired when the South-West rotation drag handler is moved.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationSWDragHandlerMove_ = function(e) {
    // Get the current absolute position of the mouse
    var mousePos = {
        x: this.rotationSWDragHandlerStartPos_.x + e.x,
        y: this.rotationSWDragHandlerStartPos_.y + e.y
    };
    // Get the relative position of the mouse to the origin / rear wheels
    var rotationOrigin = this.getRearWheelsPos_();
    var relativeMousePosToOrigin = {
        x: mousePos.x - rotationOrigin.x,
        y: (mousePos.y - rotationOrigin.y) * -1
    };
    // Get the angle of rotation
    var newRotation = (0, $2TpcN.getClockAngle)(relativeMousePosToOrigin);
    // Because this is the bottom right rotation handle then that handle is
    // approx 225° from the rear wheels of the plane
    var angleToSWCorner = (0, $2TpcN.getClockAngle)({
        x: -this.aircraft.width / 2,
        y: this.aircraft.rear_wheels - this.aircraft.width
    });
    newRotation -= angleToSWCorner;
    this.onRotatingSet_(newRotation, e.shiftKey);
};
/**
 * Fired when the North-West rotation drag handler is moved.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationNWDragHandlerMove_ = function(e) {
    // Get the current absolute position of the mouse
    var mousePos = {
        x: this.rotationNWDragHandlerStartPos_.x + e.x,
        y: this.rotationNWDragHandlerStartPos_.y + e.y
    };
    // Get the relative position of the mouse to the origin / rear wheels
    var rotationOrigin = this.getRearWheelsPos_();
    var relativeMousePosToOrigin = {
        x: mousePos.x - rotationOrigin.x,
        y: (mousePos.y - rotationOrigin.y) * -1
    };
    // Get the angle of rotation
    var newRotation = (0, $2TpcN.getClockAngle)(relativeMousePosToOrigin);
    // Because this is the bottom right rotation handle then that handle is
    // approx 315° from the rear wheels of the plane
    var angleToNWCorner = (0, $2TpcN.getClockAngle)({
        x: -this.aircraft.width / 2,
        y: this.aircraft.rear_wheels
    });
    newRotation -= angleToNWCorner;
    this.onRotatingSet_(newRotation, e.shiftKey);
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationNEDragHandlerStop_ = function() {
    this.rotationNEDragHandler_.setPosition({
        x: 0,
        y: 0
    });
    this.onRotatingStop_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationSEDragHandlerStop_ = function() {
    this.rotationSEDragHandler_.setPosition({
        x: 0,
        y: 0
    });
    this.onRotatingStop_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationSWDragHandlerStop_ = function() {
    this.rotationSWDragHandler_.setPosition({
        x: 0,
        y: 0
    });
    this.onRotatingStop_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotationNWDragHandlerStop_ = function() {
    this.rotationNWDragHandler_.setPosition({
        x: 0,
        y: 0
    });
    this.onRotatingStop_();
};
/**
 * Fire when the user starts rotating, causes the UI to update on each
 * animation frame.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotatingStart_ = function() {
    this.rotating_ = true;
    this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "rotating");
    window.requestAnimationFrame(this.bindedComputeFrame_);
};
/**
 * Set the rotation value when the user is rotating the aircraft.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotatingSet_ = function(newRotation, shiftKey) {
    // Apply 45-degree snapping when Shift key is held
    if (shiftKey) newRotation = (0, $2TpcN.snapToNearest45Degrees)(newRotation);
    this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "rotatingAntiClockwise");
    this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "rotatingClockwise");
    if (this.rotation_) {
        if (newRotation + Math.PI * 2 > this.rotation_ + Math.PI * 2) this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "rotatingClockwise");
        else this.element_.className = (0, $zjHy4.addClass)(this.element_.className, "rotatingAntiClockwise");
    }
    this.rotation_ = newRotation;
};
/**
 * Fire when the user stops rotating.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.onRotatingStop_ = function() {
    this.rotating_ = false;
    this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "rotating");
    this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "rotatingAntiClockwise");
    this.element_.className = (0, $zjHy4.removeClass)(this.element_.className, "rotatingClockwise");
    // We need to reset the drag handler positions
    this.resetDragHandlerPositions_();
    this.dispatchEvent({
        type: "rotateEnd",
        x: this.aircraft.position.x,
        y: this.aircraft.position.y,
        angle: this.rotation_
    });
};
/**
 * Returns true if the user is currently rotating, dragging or moving the plane
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.isBeingInteractedWith = function() {
    return this.dragging_ || this.rotating_;
};
/**
 * If set then the aircraft spacing buffer polygon will be rendered inside this
 * container at the same position the aircraft is rendered.
 * To not render the spacing buffer overlay then set this to null.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.setSpacingBufferOverlay = function(spacingBufferOverlay) {
    this.spacingBufferOverlay_ = spacingBufferOverlay;
    if (this.element_) this.paint_();
};
$a5e07ceb8cb15392$var$DraggablePlane.prototype.createBufferPlanePolygon_ = function() {
    this.bufferPlanePolygon_ = new (0, $bycdy.default)(this.aircraft.spacing_buffer_geom);
    this.bufferPlanePolygon_.setFillColor("red");
    this.bufferPlanePolygon_.setOpacity(0.5);
    this.bufferPlanePolygon_.createDom();
    this.spacingBufferAircraftContainer_.appendChild(this.bufferPlanePolygon_.getElement());
};
/**
 * This needs to be called after finishing interacting with a drag handler
 * it repositions the internal values of all drag handlers based on the
 * current aircraft position.
 */ $a5e07ceb8cb15392$var$DraggablePlane.prototype.resetDragHandlerPositions_ = function() {
    this.frontWheelDragHandler_.setPosition(this.getFrontWheelsPos_());
    this.aircraftDragHandler_.setPosition(this.getRearWheelsPos_());
};
var $a5e07ceb8cb15392$export$2e2bcd8739ae039 = $a5e07ceb8cb15392$var$DraggablePlane;

});
parcelRegister("zjHy4", function(module, exports) {

$parcel$export(module.exports, "addClass", () => $06a28d49131efbb9$export$d2cf6cd1dc7067d3);
$parcel$export(module.exports, "removeClass", () => $06a28d49131efbb9$export$c2255604a80b4506);
/**
 * Adds a class to a class string
 */ const $06a28d49131efbb9$export$d2cf6cd1dc7067d3 = function(existingClasses, newClass) {
    var classes = existingClasses.split(/\s/g);
    var classesHash = {};
    for (var className of classes)classesHash[className] = className;
    classesHash[newClass] = newClass;
    return Object.keys(classesHash).join(" ");
};
const $06a28d49131efbb9$export$c2255604a80b4506 = function(existingClasses, removeClass) {
    var classes = existingClasses.split(/\s/g);
    var classesHash = {};
    for (var className of classes)classesHash[className] = className;
    delete classesHash[removeClass];
    return Object.keys(classesHash).join(" ");
};

});

parcelRegister("8kLxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e5b84dc28de8a3$export$2e2bcd8739ae039);

var $lg081 = parcelRequire("lg081");

var $72HgK = parcelRequire("72HgK");
/**
 * @fileOverview A class that's responsible for assisting with handling
 * dragging on an element. It dispatches events when the user is dragging.
 */ var $a1e5b84dc28de8a3$var$DragHandler = function() {
    (0, $72HgK.default).call(this);
    this.elements_ = [];
    this.bindedOnPointerDown_ = this.onPointerDown_.bind(this);
    this.bindedOnPointerUp_ = this.onPointerUp_.bind(this);
    this.bindedOnPointerMove_ = this.onPointerMove_.bind(this);
    this.bindedOnPointerLeave_ = this.onPointerLeave_.bind(this);
    this.currentX_ = 0;
    this.currentY_ = 0;
};
$a1e5b84dc28de8a3$var$DragHandler.prototype = new (0, $72HgK.default)();
$a1e5b84dc28de8a3$var$DragHandler.prototype.attachTo = function(element) {
    var matchingElementIndex = this.elements_.findIndex((e)=>e == element);
    // Check if its already attached
    if (matchingElementIndex != -1) return;
    this.elements_.push(element);
    (0, $lg081.default).listen(element, "pointerdown", this.bindedOnPointerDown_);
    this.addGlobalEventListeners_();
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.removeFrom = function(element) {
    var matchingElementIndex = this.elements_.findIndex((e)=>e == element);
    if (matchingElementIndex == -1) return;
    this.elements_.splice(matchingElementIndex, 1);
    (0, $lg081.default).unlisten(element, "pointerdown", this.bindedOnPointerDown_);
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.addGlobalEventListeners_ = function() {
    if (this.globalEventListenersAdded_) return;
    this.globalEventListenersAdded_ = true;
    // Use passive: false to allow preventDefault on touch devices
    var options = {
        passive: false
    };
    document.body.addEventListener("pointerup", this.bindedOnPointerUp_, options);
    document.body.addEventListener("pointermove", this.bindedOnPointerMove_, options);
    document.body.addEventListener("pointerleave", this.bindedOnPointerLeave_, options);
    document.body.addEventListener("pointercancel", this.bindedOnPointerUp_, options);
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.onPointerDown_ = function(e) {
    // Only handle primary pointer (ignore multi-touch)
    if (!e.isPrimary) return;
    clearTimeout(this.dragStartDelay_);
    // Store the pointer ID and target element for capture
    this.activePointerId_ = e.pointerId;
    this.activePointerTarget_ = e.currentTarget;
    // This helps prevent a very slight drag if the user nudges the pointer from
    // triggering as a drag
    this.dragStartDelay_ = setTimeout(()=>{
        this.dragging_ = true;
        // Capture the pointer to ensure we get all events even if pointer leaves element
        if (this.activePointerTarget_ && this.activePointerId_ !== undefined) try {
            this.activePointerTarget_.setPointerCapture(this.activePointerId_);
        } catch (ex) {
        // Pointer capture not supported or failed
        }
    }, 40);
    // Prevent default touch behavior (e.g., scrolling) when starting a drag
    if (e.pointerType === 'touch') e.preventDefault();
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.onPointerUp_ = function(_e) {
    // Release pointer capture if we had it
    if (this.activePointerTarget_ && this.activePointerId_ !== undefined) try {
        this.activePointerTarget_.releasePointerCapture(this.activePointerId_);
    } catch (ex) {
    // Pointer capture release failed or not supported
    }
    delete this.dragging_;
    delete this.startDragPos_;
    delete this.activePointerId_;
    delete this.activePointerTarget_;
    clearTimeout(this.dragStartDelay_);
    if (!this.dragChange_) return;
    this.currentX_ = this.currentX_ + this.dragChange_.clientX;
    this.currentY_ = this.currentY_ + this.dragChange_.clientY;
    delete this.startDragPos_;
    delete this.dragChange_;
    this.dispatchEvent({
        type: "stop",
        x: this.currentX_,
        y: this.currentY_
    });
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.onPointerMove_ = function(e) {
    if (!this.dragging_) return;
    // Only handle the pointer that started the drag
    if (this.activePointerId_ !== undefined && e.pointerId !== this.activePointerId_) return;
    // Track Shift key state
    this.lastKnownShiftKey_ = e.shiftKey;
    // Prevent scrolling/zooming during drag on touch devices
    if (e.pointerType === 'touch') e.preventDefault();
    if (!this.startDragPos_) {
        this.startDragPos_ = {
            clientX: e.clientX,
            clientY: e.clientY
        };
        this.dispatchEvent({
            type: "start",
            x: this.currentX_,
            y: this.currentY_,
            shiftKey: e.shiftKey
        });
    }
    this.dragChange_ = {
        clientX: e.clientX - this.startDragPos_.clientX,
        clientY: e.clientY - this.startDragPos_.clientY
    };
    this.dispatchMovement_();
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.onPointerLeave_ = function(e) {
    this.onPointerUp_(e);
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.dispatchMovement_ = function() {
    if (!this.dragChange_) return this.dispatchEvent({
        type: "move",
        x: this.currentX_,
        y: this.currentY_,
        shiftKey: this.lastKnownShiftKey_ || false
    });
    this.dispatchEvent({
        type: "change",
        x: this.currentX_ + this.dragChange_.clientX,
        y: this.currentY_ + this.dragChange_.clientY,
        shiftKey: this.lastKnownShiftKey_ || false
    });
    return this.dispatchEvent({
        type: "move",
        x: this.currentX_ + this.dragChange_.clientX,
        y: this.currentY_ + this.dragChange_.clientY,
        shiftKey: this.lastKnownShiftKey_ || false
    });
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.destroy = function() {
    for (var element of this.elements_)(0, $lg081.default).unlisten(element, "pointerdown", this.bindedOnPointerDown_);
    document.body.removeEventListener("pointerup", this.bindedOnPointerUp_);
    document.body.removeEventListener("pointermove", this.bindedOnPointerMove_);
    document.body.removeEventListener("pointerleave", this.bindedOnPointerLeave_);
    document.body.removeEventListener("pointercancel", this.bindedOnPointerUp_);
    (0, $72HgK.default).prototype.destroy.call(this);
};
/**
 * Resets the x and y offsets to 0
 */ $a1e5b84dc28de8a3$var$DragHandler.prototype.reset = function() {
    this.currentX_ = 0;
    this.currentY_ = 0;
};
/**
 * Set the current x and y position.
 */ $a1e5b84dc28de8a3$var$DragHandler.prototype.setPosition = function(coord) {
    this.currentX_ = coord.x;
    this.currentY_ = coord.y;
};
$a1e5b84dc28de8a3$var$DragHandler.prototype.getPosition = function() {
    return {
        x: this.currentX_,
        y: this.currentY_
    };
};
var $a1e5b84dc28de8a3$export$2e2bcd8739ae039 = $a1e5b84dc28de8a3$var$DragHandler;

});
parcelRegister("lg081", function(module, exports) {

$parcel$export(module.exports, "default", () => $f79b3119bb275d3d$export$2e2bcd8739ae039);

var $72HgK = parcelRequire("72HgK");
const $f79b3119bb275d3d$var$events = {};
$f79b3119bb275d3d$var$events.listen = function(src, type, listener, opt_options, opt_handler) {
    if (!src) throw new Error(`'src' is required.`);
    if (!type) throw new Error(`'type' is required.`);
    if (!listener) throw new Error(`'listener' is required.`);
    if (src instanceof (0, $72HgK.default)) {
        var listenerMap = src.listenerMap;
        listenerMap.add(type, listener, undefined, undefined, opt_handler);
    } else if (src instanceof Element) {
        if (opt_handler) throw new Error(`Cannot use the opt_helper handler context when listening
        to a browser element, instead bind the listener function before calling
        this method.`.replace(/\s/g, " "));
        // For pointer events, use passive: false to allow preventDefault
        var options = opt_options;
        if (type.startsWith('pointer')) {
            options = options || {};
            if (typeof options === 'boolean') options = {
                capture: options,
                passive: false
            };
            else options.passive = false;
        }
        src.addEventListener(type, listener, options);
    } else throw new Error(`Invalid 'src' value.`);
};
$f79b3119bb275d3d$var$events.unlisten = function(src, type, listener, opt_options /*, opt_handler*/ ) {
    if (src instanceof (0, $72HgK.default)) {
        var listenerMap = src.listenerMap;
        listenerMap.remove(type, listener);
    } else if (src instanceof Element) {
        // Match the options used when adding the listener
        var options = opt_options;
        if (type.startsWith('pointer')) {
            options = options || {};
            if (typeof options === 'boolean') options = {
                capture: options,
                passive: false
            };
            else options.passive = false;
        }
        src.removeEventListener(type, listener, options);
    } else throw new Error(`Invalid 'src' value.`);
};
$f79b3119bb275d3d$var$events.unlistenAll = function(src, type) {
    if (src instanceof (0, $72HgK.default)) {
        var listenerMap = src.listenerMap;
        listenerMap.removeAll(type);
    } else if (src instanceof Element) throw new Error("unlistenAll method not yet supported for native elements.");
    else throw new Error(`Invalid 'src' value.`);
};
$f79b3119bb275d3d$var$events.hasListener = function(src, type, listener /*, opt_options, opt_handler*/ ) {
    if (src instanceof (0, $72HgK.default)) {
        var listenerMap = src.listenerMap;
        listenerMap.hasListener(type, listener);
    } else if (src instanceof Element) throw new Error("hasListener method not yet supported for native elements.");
    else throw new Error(`Invalid 'src' value.`);
};
$f79b3119bb275d3d$var$events.listenOnce = function(src, type, listener, opt_options, opt_handler) {
    var tempListener = function() {
        $f79b3119bb275d3d$var$events.unlisten(src, type, tempListener, opt_options, opt_handler);
        listener.apply(this, arguments);
    };
    $f79b3119bb275d3d$var$events.listen(src, type, tempListener, opt_options, opt_handler);
};
var $f79b3119bb275d3d$export$2e2bcd8739ae039 = $f79b3119bb275d3d$var$events;

});
parcelRegister("72HgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $520a48ac453d07bb$export$2e2bcd8739ae039);
/**
 * @fileOverview Inherit from this class to support the object dispatching
 * events.
 * Follows the [EventTarget](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget)
 * interface.
 */ 
var $4Dwfv = parcelRequire("4Dwfv");

var $lg081 = parcelRequire("lg081");
const $520a48ac453d07bb$var$EventTarget = function() {
    this.listenerMap = new (0, $4Dwfv.default)(this);
};
/**
 * @param {EventLike} e
 */ $520a48ac453d07bb$var$EventTarget.prototype.dispatchEvent = function(e) {
    var type, event;
    if (typeof e == "string") {
        type = e;
        event = {
            type: type
        };
    } else {
        type = e.type;
        event = e;
    }
    this.fireListeners(type, undefined, event);
};
$520a48ac453d07bb$var$EventTarget.prototype.fireListeners = function(type, capture, event) {
    var listenerArray = this.listenerMap.listeners[String(type)];
    if (listenerArray) // Clone the array encase firing the listeners removes or adds new ones
    listenerArray = listenerArray.slice(0);
    else listenerArray = [];
    for(var i = 0; i < listenerArray.length; i++){
        var listener = listenerArray[i];
        const listenerFn = listener.listener;
        const listenerHandler = listener.handler || listener.src;
        listenerFn.call(listenerHandler, event);
    }
};
$520a48ac453d07bb$var$EventTarget.prototype.destroy = function() {
    this.listenerMap.destroy();
};
$520a48ac453d07bb$var$EventTarget.prototype.setLogFunction = function(func) {
    this.logFunction_ = func;
};
$520a48ac453d07bb$var$EventTarget.prototype.log_ = function() {
    console.log(...arguments);
};
$520a48ac453d07bb$var$EventTarget.prototype.addEventListener = function(type, listener, opt_options, opt_handler) {
    (0, $lg081.default).listen(this, type, listener, opt_options, opt_handler);
};
$520a48ac453d07bb$var$EventTarget.prototype.removeEventListener = function(type, listener, opt_options, opt_handler) {
    (0, $lg081.default).unlisten(this, type, listener, opt_options, opt_handler);
};
var $520a48ac453d07bb$export$2e2bcd8739ae039 = $520a48ac453d07bb$var$EventTarget;

});
parcelRegister("4Dwfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3603d1ece6575eb7$export$2e2bcd8739ae039);

var $izGC2 = parcelRequire("izGC2");
var $3603d1ece6575eb7$var$ListenerMap = function(src) {
    this.src = src;
    this.listeners = {};
};
$3603d1ece6575eb7$var$ListenerMap.prototype.add = function(type, listener, callOnce, opt_useCapture, opt_listenerScope) {
    var listenerArray = this.listeners[type];
    if (!listenerArray) listenerArray = this.listeners[type] = [];
    var listenerObj = new (0, $izGC2.default)(listener, null, this.src, type, !!opt_useCapture, opt_listenerScope);
    listenerArray.push(listenerObj);
};
/**
 * Remove a listener from the map.
 */ $3603d1ece6575eb7$var$ListenerMap.prototype.remove = function(type, listener) {
    var listenerArray = this.listeners[type] || [];
    var matchedIndex = listenerArray.findIndex((l)=>{
        return l.listener == listener;
    });
    if (matchedIndex == -1) throw new Error("Listener not found.");
    listenerArray.splice(matchedIndex, 1);
};
/**
 * Remove a listener from the map.
 */ $3603d1ece6575eb7$var$ListenerMap.prototype.removeAll = function(type) {
    var listenerArray = this.listeners[type] || [];
    listenerArray.splice(0, listenerArray.length);
};
/**
 * Remove a listener from the map.
 */ $3603d1ece6575eb7$var$ListenerMap.prototype.hasListener = function(type, listener) {
    var listenerArray = this.listeners[type] || [];
    var matchedIndex = listenerArray.findIndex((l)=>{
        return l.listener = listener;
    });
    if (matchedIndex == -1) return false;
    return true;
};
$3603d1ece6575eb7$var$ListenerMap.prototype.destroy = function() {
    delete this.src;
    // Could probably delete more here
    delete this.listeners;
};
var $3603d1ece6575eb7$export$2e2bcd8739ae039 = $3603d1ece6575eb7$var$ListenerMap;

});
parcelRegister("izGC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85c8cd6dfeecdc0$export$2e2bcd8739ae039);
const $d85c8cd6dfeecdc0$var$Listener = function(listener, proxy, src, type, capture, opt_handler) {
    this.listener = listener;
    this.proxy = proxy;
    this.src = src;
    this.type = type;
    this.handler = opt_handler;
};
var $d85c8cd6dfeecdc0$export$2e2bcd8739ae039 = $d85c8cd6dfeecdc0$var$Listener;

});





parcelRegister("5J9LZ", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $42b8bc7335681523$export$61fc7d43ac8f84b0);
/**
 * Debounce a function
 */ const $42b8bc7335681523$export$61fc7d43ac8f84b0 = function(func, ms) {
    var timer;
    return function() {
        var self = this;
        var args = arguments;
        clearTimeout(timer);
        var callMethod = function() {
            func.apply(self, args);
        };
        timer = setTimeout(callMethod, ms);
    };
};

});

parcelRegister("3Ju9e", function(module, exports) {

$parcel$export(module.exports, "getMovementAngle", () => $845c48421be623ab$export$c77e4a7ba37152b9);

var $2TpcN = parcelRequire("2TpcN");
const $845c48421be623ab$export$c77e4a7ba37152b9 = function(movementHistory) {
    if (movementHistory.length <= 1) return null;
    var currentDto = movementHistory[movementHistory.length - 1];
    var currentPosition = currentDto.mousePos;
    var minimumMovement = 5;
    // Find the previous movement that was at least the minimum distance away
    for(var i = movementHistory.length - 2; i--; i){
        var historicDto = movementHistory[i];
        var historicPosition = historicDto.mousePos;
        var translation = {
            x: historicPosition.x - currentPosition.x,
            y: historicPosition.y - currentPosition.y
        };
        var distance = (0, $2TpcN.getHypotenuse)(translation);
        if (distance >= minimumMovement) {
            // First rotate both positions around the original rear wheel pos
            // so that the angle is relative to the front of the aircraft
            var rearWheelPos = historicDto.rearWheelPos;
            var mouse1RelativeToOrigin = {
                x: currentPosition.x - rearWheelPos.x,
                y: currentPosition.y - rearWheelPos.y
            };
            // Invert the y axis as it's easier to reason about
            mouse1RelativeToOrigin = {
                ...mouse1RelativeToOrigin,
                y: mouse1RelativeToOrigin.y * -1
            };
            // This is the mouse1 position aligned on the y axis
            var mouse1AlignedOnYOrigin = (0, $2TpcN.rotateAroundOrigin)(mouse1RelativeToOrigin, -historicDto.rotation);
            var mouse2RelativeToOrigin = {
                x: historicPosition.x - rearWheelPos.x,
                y: historicPosition.y - rearWheelPos.y
            };
            // Invert the y axis as it's easier to reason about
            mouse2RelativeToOrigin = {
                ...mouse2RelativeToOrigin,
                y: mouse2RelativeToOrigin.y * -1
            };
            var mouse2AlignedOnYOrigin = (0, $2TpcN.rotateAroundOrigin)(mouse2RelativeToOrigin, -historicDto.rotation);
            var translation = {
                x: mouse2AlignedOnYOrigin.x - mouse1AlignedOnYOrigin.x,
                y: mouse2AlignedOnYOrigin.y - mouse1AlignedOnYOrigin.y
            };
            var angle = (0, $2TpcN.getClockAngle)(translation);
            break;
        }
    }
    // Prune older movement history 
    movementHistory.splice(0, i);
    return Math.PI - angle;
};

});

parcelRegister("9LbHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aa0bcae9ac24d3e$export$2e2bcd8739ae039);

var $iWuOJ = parcelRequire("iWuOJ");
const $7aa0bcae9ac24d3e$var$AntiClockwiseArrow = function() {
    (0, $iWuOJ.default).call(this);
};
$7aa0bcae9ac24d3e$var$AntiClockwiseArrow.prototype = new (0, $iWuOJ.default)();
$7aa0bcae9ac24d3e$var$AntiClockwiseArrow.prototype.createDom = function() {
    var c = this.dom_.createElementNS.bind(this.dom_, 'http://www.w3.org/2000/svg');
    this.element_ = c('svg', {
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'AntiClockwiseArrow',
        fill: '#286ff1'
    }, c('path', {
        d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z'
    }));
};
var $7aa0bcae9ac24d3e$export$2e2bcd8739ae039 = $7aa0bcae9ac24d3e$var$AntiClockwiseArrow;

});
parcelRegister("iWuOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dca58c6a155266e9$export$2e2bcd8739ae039);
/**
 * @fileOverview This is a base class to inherit from when building low level
 * components. It follows a pattern of creating all the DOM elements inside
 * the `createDom` method and then when you're ready to attach the component
 * to the DOM you call `render`. It inherits from the EventTarget class
 * so that components can dispatch events.
 */ 
var $82N3a = parcelRequire("82N3a");

var $72HgK = parcelRequire("72HgK");
/**
 * @constructor
 */ const $dca58c6a155266e9$var$Component = function() {
    (0, $72HgK.default).call(this);
    this.dom_ = new (0, $82N3a.default)();
};
$dca58c6a155266e9$var$Component.prototype = new (0, $72HgK.default)();
$dca58c6a155266e9$var$Component.prototype.createDom = function() {};
$dca58c6a155266e9$var$Component.prototype.render = function(container) {
    if (!this.element_) this.createDom();
    container.appendChild(this.element_);
};
$dca58c6a155266e9$var$Component.prototype.getElement = function() {
    /*if (!this.element_) {
    this.createDom()
  }*/ return this.element_;
};
$dca58c6a155266e9$var$Component.prototype.destroy = function() {
    if (this.element_) {
        if (this.element_.parentNode) this.element_.parentNode.removeChild(this.element_);
    }
    delete this.element_;
};
var $dca58c6a155266e9$export$2e2bcd8739ae039 = $dca58c6a155266e9$var$Component;

});
parcelRegister("82N3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $15121bae3997e363$export$2e2bcd8739ae039);

var $iWuOJ = parcelRequire("iWuOJ");
/**
 * @fileOverview Provides a tool for building DOM elements in a slightly easier
 * way to the native API and also auto renders low level Components
 * Normally to create a styled div with another div nested inside you would
 * write something like this.
 * ```
 * var div = document.createElement('div')
 * div.className = 'foo'
 * var childDiv = document.createElement('div')
 * childDiv.className = 'bar'
 * div.appendChild(childDiv)
 * ```
 * Using this tool you can chain the element creation to make it a little
 * less verbose
 * ```
 * var domHelper = new DomHelper()
 * var div = domHelper.createElement('div', { 'class': 'foo' },
 *   domHelper.createElement('div', { 'class': 'bar' })
 * ```
 *
 * If you pass in an instance of the Component class it will render that
 * component and append it to the parent node. e.g.
 * ```
 * var domHelper = new DomHelper()
 * var draggableAircraft = new DraggableAircraft(aircraft)
 * var container = domHelper.createElement(
 *  'div',
 *  { 'class': 'container' },
 *  draggableAircraft
 * )
 * ```
 * NOTE: Technically this isn't needed. At the time of writing it is used to
 * make things slightly easier in the `createDom` method of the `DraggablePlane`
 * class, but that could be rewritten to only use the native
 * `document.createElement` api.
 */ const $15121bae3997e363$var$DomHelper = function() {
    this.doc_ = window.document;
};
$15121bae3997e363$var$DomHelper.prototype.createElement = function(tagName, props, ...children) {
    var ele = this.doc_.createElement(tagName);
    if (props) $15121bae3997e363$var$DomHelper.applyAttributesToElement(ele, props);
    $15121bae3997e363$var$DomHelper.appendChildrenToElement(this.doc_, ele, children);
    return ele;
};
$15121bae3997e363$var$DomHelper.prototype.createElementNS = function(namespaceURI, tagName, props, ...children) {
    var ele = this.doc_.createElementNS(namespaceURI, tagName);
    if (props) $15121bae3997e363$var$DomHelper.applyAttributesToElement(ele, props);
    $15121bae3997e363$var$DomHelper.appendChildrenToElement(this.doc_, ele, children);
    return ele;
};
$15121bae3997e363$var$DomHelper.prototype.getDocument = function() {
    return this.doc_;
};
$15121bae3997e363$var$DomHelper.applyAttributesToElement = function(ele, props) {
    var propKeys = Object.keys(props);
    for(var i = 0; i < propKeys.length; i++){
        var key = propKeys[i];
        ele.setAttribute(key, props[key]);
    }
};
$15121bae3997e363$var$DomHelper.appendChildrenToElement = function(doc, ele, children) {
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if (typeof child === "string" || typeof child === "number") child = doc.createTextNode(String(child));
        if (child instanceof (0, $iWuOJ.default)) {
            var element = child.getElement();
            if (!element) {
                child.createDom();
                child = child.getElement();
                if (!child) throw new Error("Component has no element after calling createDom.");
            }
        }
        ele.appendChild(child);
    }
};
var $15121bae3997e363$export$2e2bcd8739ae039 = $15121bae3997e363$var$DomHelper;

});



parcelRegister("4VRZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e15f361cfae88c4$export$2e2bcd8739ae039);

var $iWuOJ = parcelRequire("iWuOJ");
const $7e15f361cfae88c4$var$ClockwiseArrow = function() {
    (0, $iWuOJ.default).call(this);
};
$7e15f361cfae88c4$var$ClockwiseArrow.prototype = new (0, $iWuOJ.default)();
$7e15f361cfae88c4$var$ClockwiseArrow.prototype.createDom = function() {
    var c = this.dom_.createElementNS.bind(this.dom_, 'http://www.w3.org/2000/svg');
    this.element_ = c('svg', {
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'ClockwiseArrow',
        fill: '#286ff1'
    }, c('path', {
        d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z'
    }));
};
var $7e15f361cfae88c4$export$2e2bcd8739ae039 = $7e15f361cfae88c4$var$ClockwiseArrow;

});

parcelRegister("bycdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5633e6c8447bba63$export$2e2bcd8739ae039);

var $lg081 = parcelRequire("lg081");

var $iWuOJ = parcelRequire("iWuOJ");
/**
 * @fileOverview Builds a transparent plane SVG using the aircraft geom object,s
 * dispatches a click event when pressed.
 */ var $5633e6c8447bba63$var$PlanePolygon = function(geom, viewBox = null) {
    (0, $iWuOJ.default).call(this);
    this.geom_ = geom;
    this.bindedOnClick_ = this.onClick_.bind(this);
    this.bindedOnRightClick_ = this.onRightClick_.bind(this);
    this.bindedOnMouseUp_ = this.onMouseUp_.bind(this);
    if (viewBox) this.viewBoxString_ = viewBox;
    else {
        var yCoords = geom["coordinates"][0].map((coord)=>coord[1]);
        var xCoords = geom["coordinates"][0].map((coord)=>coord[0]);
        var maxX = Math.max(...xCoords);
        var maxY = Math.max(...yCoords);
        this.viewBoxString_ = `0 0 ${maxX} ${maxY}`;
    }
    this.fillColor_ = "transparent";
    this.opacity_ = 1;
};
$5633e6c8447bba63$var$PlanePolygon.prototype = new (0, $iWuOJ.default)();
$5633e6c8447bba63$var$PlanePolygon.prototype.createDom = function() {
    if (this.geom_["type"] != "Polygon") throw new Error("Can only render geom of type Polygon.");
    var pointsStr = this.geom_["coordinates"][0].map((coord)=>{
        return `${coord[0]}, ${coord[1]}`;
    }).join(" ");
    this.polygon_ = this.dom_.createElementNS("http://www.w3.org/2000/svg", "polygon", {
        points: pointsStr,
        fill: this.fillColor_,
        opacity: this.opacity_
    });
    this.element_ = this.dom_.createElementNS("http://www.w3.org/2000/svg", "svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: this.viewBoxString_,
        class: "PlanePolygon"
    }, this.polygon_);
    this.addEventListeners_();
};
$5633e6c8447bba63$var$PlanePolygon.prototype.onClick_ = function(e) {
    this.dispatchEvent(e);
};
$5633e6c8447bba63$var$PlanePolygon.prototype.onRightClick_ = function(e) {
    this.dispatchEvent(e);
};
$5633e6c8447bba63$var$PlanePolygon.prototype.onMouseUp_ = function(e) {
    this.dispatchEvent(e);
};
$5633e6c8447bba63$var$PlanePolygon.prototype.addEventListeners_ = function() {
    (0, $lg081.default).listen(this.polygon_, "click", this.bindedOnClick_);
    (0, $lg081.default).listen(this.polygon_, "contextmenu", this.bindedOnRightClick_);
    (0, $lg081.default).listen(this.polygon_, "pointerup", this.bindedOnMouseUp_);
};
$5633e6c8447bba63$var$PlanePolygon.prototype.removeEventListeners_ = function() {
    (0, $lg081.default).unlisten(this.polygon_, "click", this.bindedOnClick_);
    (0, $lg081.default).unlisten(this.polygon_, "contextmenu", this.bindedOnRightClick_);
    (0, $lg081.default).unlisten(this.polygon_, "pointerup", this.bindedOnMouseUp_);
};
$5633e6c8447bba63$var$PlanePolygon.prototype.destroy = function() {
    this.removeEventListeners_();
    (0, $iWuOJ.default).prototype.destroy.call(this);
};
$5633e6c8447bba63$var$PlanePolygon.prototype.getPolygonElement = function() {
    return this.polygon_;
};
$5633e6c8447bba63$var$PlanePolygon.prototype.setFillColor = function(color) {
    this.fillColor_ = color;
    if (this.polygon_) this.polygon_.setAttribute("fill", color);
};
$5633e6c8447bba63$var$PlanePolygon.prototype.setOpacity = function(opacity) {
    this.opacity_ = opacity;
    if (this.polygon_) this.polygon_.setAttribute("opacity", this.opacity_);
};
var $5633e6c8447bba63$export$2e2bcd8739ae039 = $5633e6c8447bba63$var$PlanePolygon;

});




parcelRegister("2znSD", function(module, exports) {

$parcel$export(module.exports, "truncateAt15Chars", () => $68b59e203aa86b17$export$f87ac26719c81965);
$parcel$export(module.exports, "getSpacingBufferDimensions", () => $68b59e203aa86b17$export$1badb74d44348f1a);

var $1AV0B = parcelRequire("1AV0B");
const $68b59e203aa86b17$export$f87ac26719c81965 = (text)=>{
    if (text.length <= 15) return text;
    return text.slice(0, 15) + "...";
};
const $68b59e203aa86b17$export$1badb74d44348f1a = (isHangar, aircraft, params)=>{
    const { feetToPixels: feetToPixels } = params;
    const geom = isHangar ? aircraft.geom_scaled_buffer : aircraft.ramp_geom_scaled_buffer;
    var yCoords = geom["coordinates"][0].map((coord)=>coord[1]);
    var xCoords = geom["coordinates"][0].map((coord)=>coord[0]);
    var maxY = Math.max(...yCoords);
    var minY = Math.min(...yCoords);
    var maxX = Math.max(...xCoords);
    var minX = Math.min(...xCoords);
    // The Geometry for the geom_scaled_buffer is not at the same scale
    // as the geom object, it is at the scale 1 foot = 1 pixel (or SVG unit)
    // The geom object is the aircraft within a 600x600 square
    // We are using the above to figure out the dimensions of the
    // geom_scaled_buffer which we can then use against the current hangar
    // scale to get the true pixel size of the spacing buffer
    var spacingBufferImageDimensions = {
        width: maxX - minX,
        height: maxY - minY
    };
    var tempGeomScaledBuffer = geom;
    // The polygon will get turned into an SVG so lets align all points
    // to 0,0
    tempGeomScaledBuffer = (0, $1AV0B.translatePolygon)(tempGeomScaledBuffer, {
        x: -minX,
        y: -minY
    });
    // Knowing the SVG dimensions we can now rotate around the mid point
    // because the geom_scaled_buffer is at a 180 compared to the geom
    // polygon
    tempGeomScaledBuffer = (0, $1AV0B.rotatePolygon)(tempGeomScaledBuffer, Math.PI, {
        x: spacingBufferImageDimensions.width / 2,
        y: spacingBufferImageDimensions.height / 2
    });
    // Do the scale to get the pixel size
    spacingBufferImageDimensions.width *= feetToPixels;
    spacingBufferImageDimensions.height *= feetToPixels;
    return {
        spacing_buffer_geom: tempGeomScaledBuffer,
        spacing_buffer_geom_dimensions: spacingBufferImageDimensions
    };
};

});
parcelRegister("1AV0B", function(module, exports) {

$parcel$export(module.exports, "rotatePolygon", () => $5a60e1f3c6a369ff$export$b5c4b052119a81d8);
$parcel$export(module.exports, "translatePolygon", () => $5a60e1f3c6a369ff$export$bf389ed589e3a7f3);

var $2TpcN = parcelRequire("2TpcN");
const $5a60e1f3c6a369ff$export$b5c4b052119a81d8 = function(polygon, angle, origin) {
    if (polygon["type"] != "Polygon") throw new Error("Only expects type 'Polygon'.");
    var newPolygon = {
        type: "Polygon",
        coordinates: [
            polygon["coordinates"][0].map(([x, y])=>{
                var temp = (0, $2TpcN.rotateAroundOrigin)({
                    x: x,
                    y: y
                }, angle, origin);
                return [
                    temp.x,
                    temp.y
                ];
            })
        ]
    };
    return newPolygon;
};
const $5a60e1f3c6a369ff$export$b32c4d26933d0880 = function(polygon, scale) {
    if (polygon["type"] != "Polygon") throw new Error("Only expects type 'Polygon'.");
    var newPolygon = {
        type: "Polygon",
        coordinates: [
            polygon["coordinates"][0].map(([x, y])=>{
                return [
                    x * scale,
                    y * scale
                ];
            })
        ]
    };
    return newPolygon;
};
const $5a60e1f3c6a369ff$export$bf389ed589e3a7f3 = function(polygon, translation) {
    if (polygon["type"] != "Polygon") throw new Error("Only expects type 'Polygon'.");
    var newPolygon = {
        type: "Polygon",
        coordinates: [
            polygon["coordinates"][0].map(([x, y])=>{
                return [
                    x += translation.x,
                    y += translation.y
                ];
            })
        ]
    };
    return newPolygon;
};

});


parcelRegister("9CHh9", function(module, exports) {

$parcel$export(module.exports, "ScheduledAircraftContextMenu", () => $53e0159d132a6286$export$456790e34378e651);

var $ayMG0 = parcelRequire("ayMG0");

var $fZSPM = parcelRequire("fZSPM");

var $kT7QH = parcelRequire("kT7QH");

var $iwiZ3 = parcelRequire("iwiZ3");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $lkxXU = parcelRequire("lkxXU");
var $bjZRT = parcelRequire("bjZRT");
var $19ocJ = parcelRequire("19ocJ");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");
var $lBOb7 = parcelRequire("lBOb7");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $fZ41T = parcelRequire("fZ41T");

var $kWYrU = parcelRequire("kWYrU");

var $a7gZr = parcelRequire("a7gZr");

var $keHtM = parcelRequire("keHtM");

var $aHqXU = parcelRequire("aHqXU");

var $j3VXW = parcelRequire("j3VXW");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");
parcelRequire("7o8I0");
var $3XtNi = parcelRequire("3XtNi");

var $6rxM8 = parcelRequire("6rxM8");

var $6RcbS = parcelRequire("6RcbS");

var $lQ8IB = parcelRequire("lQ8IB");
// StackOptionButton component for preference options
const $53e0159d132a6286$var$StackOptionButton = ({ text: text, selected: selected, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        onClick: onClick,
        "data-testid": `preferences_menu_${text}`,
        children: [
            selected && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fZSPM))), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                inset: !selected,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "button",
                    children: text
                })
            })
        ]
    });
};
const $53e0159d132a6286$export$456790e34378e651 = ({ tenant: tenant, tripId: tripId, currentTimestamp: currentTimestamp, stack: stack, setStack: setStack, onClose: onClose, onRefresh: onRefresh, onRemoveAircraft: onRemoveAircraft, menuProps: menuProps = {} })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { hangars: allHangars } = (0, $7FzhI.useHangarsState)();
    const { ramps: ramps } = (0, $3AGzj.useRampsState)();
    const [isUpdating, setIsUpdating] = $acw62.useState(false);
    const [error, setError] = $acw62.useState(null);
    const [moveToAnchor, setMoveToAnchor] = $acw62.useState(null);
    const moveToOpen = Boolean(moveToAnchor);
    const [openEdit, setOpenEdit] = $acw62.useState(false);
    const [confirmDelete, setConfirmDelete] = $acw62.useState(false);
    const [viewTripsOpen, setViewTripsOpen] = $acw62.useState(false);
    const [aircraftTrips, setAircraftTrips] = $acw62.useState([]);
    const [selectedTrip, setSelectedTrip] = $acw62.useState(null);
    const [tripsLoading, setTripsLoading] = $acw62.useState(false);
    // Extract current preferences from tenant
    const [preferences, setPreferences] = $acw62.useState(tenant.position?.preferences || []);
    // Determine current location
    const currentLocationId = $acw62.useMemo(()=>{
        // Try to find the current location from the stack
        const hangar = allHangars.find((h)=>h.id === stack.location_id);
        if (hangar) return hangar.id;
        const ramp = ramps.find((r)=>r.id === stack.location_id);
        if (ramp) return ramp.id;
        return null;
    }, [
        stack,
        allHangars,
        ramps
    ]);
    const handleLocationClick = (location)=>{
        const locationType = "stacks" in location ? "hangar" : "ramp";
        handleLocationChange(location.id, locationType);
        handleMoveToClose();
    };
    const { renderMenuItems: renderMenuItems } = (0, $fZ41T.useGroupedLocationMenu)({
        hangars: allHangars,
        ramps: ramps,
        activeFBO: activeFBO,
        currentLocationId: currentLocationId,
        onLocationClick: handleLocationClick
    });
    // Check if in hangar
    const isHangar = allHangars.some((h)=>h.id === stack.location_id);
    // Preference state helpers
    const isNoseIn = preferences.indexOf((0, $keHtM.Preference).NOSE_IN) > -1 || preferences.indexOf((0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN) > -1;
    const isTailIn = preferences.indexOf((0, $keHtM.Preference).TAIL_IN) > -1 || preferences.indexOf((0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN) > -1;
    const handleLocationChange = async (locationId, locationType, position)=>{
        // Clear any previous errors
        setError(null);
        // Validate required data
        if (!tripId || !postgrest || !currentTimestamp) {
            setError("Missing required data for location change");
            return;
        }
        setIsUpdating(true);
        try {
            const placementService = new (0, $a7gZr.PlacementService)(postgrest);
            const startTimeISO = currentTimestamp.toISOString();
            // Determine if we should clear position
            // Clear position when: moving to unassigned OR moving to a different location
            const shouldClearPosition = !locationId || locationId !== currentLocationId;
            const finalPosition = shouldClearPosition ? {
                x: null,
                y: null,
                angle: null
            } : position || {
                x: tenant.position?.x || null,
                y: tenant.position?.y || null,
                angle: tenant.position?.angle || null
            };
            // Use the stored procedure with gap filling
            // excludeConflicts is TRUE to allow scheduling flexibility - users can manage conflicts
            await placementService.assignToLocationWithGapFilling(tripId, locationId, locationType, startTimeISO, // Only affect from current time forward
            undefined, // Let it go to trip end
            true, // Allow moves even with conflicts - scheduling needs flexibility
            finalPosition // Pass the position explicitly
            );
            // Success! Trigger refresh to reload data
            onRefresh();
            // Close the menus
            setMoveToAnchor(null);
            onClose();
        } catch (error) {
            console.error("Failed to update location:", error);
            // Show user-friendly error message
            if (error.message?.includes('conflict')) setError("Another aircraft is already in this location at this time");
            else if (error.message?.includes('gap')) setError("Cannot create gaps in the schedule");
            else setError(error.message || "Failed to update location");
        } finally{
            setIsUpdating(false);
        }
    };
    const handleMoveToClick = (event)=>{
        setMoveToAnchor(event.currentTarget);
    };
    const handleMoveToClose = ()=>{
        setMoveToAnchor(null);
    };
    if (!hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lBOb7.default), {
        dense: false,
        ...menuProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
            direction: "column",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j3VXW.ButtonNotes), {
                disabled: true,
                tenant: tenant,
                setTenant: ()=>{}
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            confirmDelete && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Please Confirm",
                text: "This will remove the aircraft from the schedule at this time.",
                okText: "Yes, remove from schedule",
                onOk: ()=>{
                    if (onRemoveAircraft) onRemoveAircraft(tenant.id, tripId);
                    else handleLocationChange(null, null);
                    setConfirmDelete(false);
                },
                onClose: ()=>setConfirmDelete(false),
                onCancel: ()=>setConfirmDelete(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lBOb7.default), {
                dense: false,
                ...menuProps,
                children: [
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                        severity: "error",
                        onClose: ()=>setError(null),
                        sx: {
                            m: 1
                        },
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j3VXW.ButtonNotes), {
                                tenant: tenant,
                                setTenant: (updatedTenant)=>{
                                    setStack({
                                        ...stack,
                                        tenants: stack.tenants.map((t)=>t.id === tenant.id ? updatedTenant : t)
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                size: "small",
                                color: "inherit",
                                variant: "text",
                                onClick: async ()=>{
                                    if (!activeFBO?.id || !tenant.tail_number) return;
                                    // Close any open submenus
                                    setMoveToAnchor(null);
                                    setTripsLoading(true);
                                    try {
                                        const tripService = new (0, $lQ8IB.TripService)(postgrest);
                                        const trips = await tripService.getTripsByTailNumber(activeFBO.id, tenant.tail_number);
                                        setAircraftTrips(trips);
                                        // Find the current trip or the most recent one
                                        const currentTrip = trips.find((t)=>t.trip_id === tripId) || trips.find((t)=>t.status === 'active') || trips[trips.length - 1];
                                        if (currentTrip) {
                                            setSelectedTrip(currentTrip);
                                            setViewTripsOpen(true);
                                        }
                                    } catch (error) {
                                        console.error('Failed to fetch trips:', error);
                                        setError('Failed to load trips for this aircraft');
                                    } finally{
                                        setTripsLoading(false);
                                    }
                                },
                                disabled: tripsLoading,
                                children: tripsLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 16
                                }) : "View Trips"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                size: "small",
                                color: "inherit",
                                variant: "text",
                                onClick: async ()=>{
                                    if (!postgrest || !tenant.placement_id) return;
                                    const newLockState = !tenant.is_locked;
                                    const placementService = new (0, $a7gZr.PlacementService)(postgrest);
                                    try {
                                        await placementService.toggleLock(tenant.placement_id, newLockState);
                                        // Update local state
                                        setStack({
                                            ...stack,
                                            tenants: stack.tenants.map((t)=>t.id === tenant.id ? {
                                                    ...t,
                                                    is_locked: newLockState
                                                } : t)
                                        });
                                        onClose();
                                        onRefresh();
                                    } catch (error) {
                                        console.error('Failed to toggle lock:', error);
                                        setError('Failed to toggle lock status');
                                    }
                                },
                                children: tenant.is_locked ? "\uD83D\uDD13 Unlock" : "\uD83D\uDD12 Lock"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
                        ]
                    }),
                    isHangar && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($53e0159d132a6286$var$StackOptionButton, {
                                selected: isTailIn,
                                text: "Tail In",
                                onClick: ()=>{
                                    const newPrefs = isTailIn ? preferences.filter((p)=>p !== (0, $keHtM.Preference).TAIL_IN && p !== (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN) : [
                                        ...preferences.filter((p)=>p !== (0, $keHtM.Preference).NOSE_IN && p !== (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN),
                                        tenant.aircraft?.tail_wheel ? (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN : (0, $keHtM.Preference).TAIL_IN
                                    ];
                                    setPreferences(newPrefs);
                                // TODO: Update preferences in database
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($53e0159d132a6286$var$StackOptionButton, {
                                selected: isNoseIn,
                                text: "Nose In",
                                onClick: ()=>{
                                    const newPrefs = isNoseIn ? preferences.filter((p)=>p !== (0, $keHtM.Preference).NOSE_IN && p !== (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN) : [
                                        ...preferences.filter((p)=>p !== (0, $keHtM.Preference).TAIL_IN && p !== (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN),
                                        tenant.aircraft?.tail_wheel ? (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN : (0, $keHtM.Preference).NOSE_IN
                                    ];
                                    setPreferences(newPrefs);
                                // TODO: Update preferences in database
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($53e0159d132a6286$var$StackOptionButton, {
                                selected: preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1,
                                text: "Front Row",
                                onClick: ()=>{
                                    const newPrefs = preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1 ? preferences.filter((p)=>p !== (0, $keHtM.Preference).PREFER_FRONT_ROW) : [
                                        ...preferences.filter((p)=>p !== (0, $keHtM.Preference).PREFER_BACK_ROW),
                                        (0, $keHtM.Preference).PREFER_FRONT_ROW
                                    ];
                                    setPreferences(newPrefs);
                                // TODO: Update preferences in database
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($53e0159d132a6286$var$StackOptionButton, {
                                selected: preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1,
                                text: "Back Row",
                                onClick: ()=>{
                                    const newPrefs = preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1 ? preferences.filter((p)=>p !== (0, $keHtM.Preference).PREFER_BACK_ROW) : [
                                        ...preferences.filter((p)=>p !== (0, $keHtM.Preference).PREFER_FRONT_ROW),
                                        (0, $keHtM.Preference).PREFER_BACK_ROW
                                    ];
                                    setPreferences(newPrefs);
                                // TODO: Update preferences in database
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($53e0159d132a6286$var$StackOptionButton, {
                                selected: preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1,
                                text: "OK Outside",
                                onClick: ()=>{
                                    const newPrefs = preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1 ? preferences.filter((p)=>p !== (0, $keHtM.Preference).OK_TO_LEAVE_OUT) : [
                                        ...preferences,
                                        (0, $keHtM.Preference).OK_TO_LEAVE_OUT
                                    ];
                                    setPreferences(newPrefs);
                                // TODO: Update preferences in database
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($53e0159d132a6286$var$StackOptionButton, {
                                selected: preferences.indexOf((0, $keHtM.Preference).LOCKED) > -1,
                                text: "Locked",
                                onClick: ()=>{
                                    const newPrefs = preferences.indexOf((0, $keHtM.Preference).LOCKED) > -1 ? preferences.filter((p)=>p !== (0, $keHtM.Preference).LOCKED) : [
                                        ...preferences,
                                        (0, $keHtM.Preference).LOCKED
                                    ];
                                    setPreferences(newPrefs);
                                // TODO: Update preferences in database
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                fullWidth: true,
                                color: "primary",
                                endIcon: moveToOpen ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kT7QH))), {}),
                                onClick: handleMoveToClick,
                                disabled: isUpdating,
                                children: isUpdating ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 20
                                }) : "Move To"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                fullWidth: true,
                                color: "primary",
                                onClick: ()=>setOpenEdit(true),
                                children: "Edit Aircraft"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                fullWidth: true,
                                color: "error",
                                onClick: ()=>setConfirmDelete(true),
                                disabled: isUpdating,
                                children: "Remove Aircraft"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4F5tJ.default), {
                anchorEl: moveToAnchor,
                open: moveToOpen,
                onClose: handleMoveToClose,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                children: [
                    renderMenuItems(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                        disabled: isUpdating,
                        onClick: ()=>{
                            handleLocationChange(null, null);
                            handleMoveToClose();
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "button",
                                children: "Unassigned"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6RcbS.TripDetailsModal), {
                open: viewTripsOpen,
                trip: selectedTrip,
                trips: aircraftTrips,
                onClose: ()=>{
                    setViewTripsOpen(false);
                    setSelectedTrip(null);
                },
                onNavigate: (newTripId)=>{
                    const newTrip = aircraftTrips.find((t)=>t.trip_id === newTripId);
                    if (newTrip) setSelectedTrip(newTrip);
                },
                onTripChanged: async ()=>{
                    // Refresh trips after changes
                    if (!activeFBO?.id || !tenant.tail_number) return;
                    try {
                        const tripService = new (0, $lQ8IB.TripService)(postgrest);
                        const trips = await tripService.getTripsByTailNumber(activeFBO.id, tenant.tail_number);
                        setAircraftTrips(trips);
                        // Update selected trip if it still exists
                        if (selectedTrip) {
                            const updatedTrip = trips.find((t)=>t.trip_id === selectedTrip.trip_id);
                            if (updatedTrip) setSelectedTrip(updatedTrip);
                        }
                    } catch (error) {
                        console.error('Failed to refresh trips:', error);
                    }
                    onRefresh();
                },
                currentTimestamp: currentTimestamp
            }),
            openEdit && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6rxM8.LocationsContainer), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3XtNi.EditTenant), {
                    displayTypeAndLocation: false,
                    onClose: ()=>setOpenEdit(false),
                    tenant: tenant,
                    setTenant: (updatedTenant)=>{
                        setStack({
                            ...stack,
                            tenants: stack.tenants.map((t)=>t.id === tenant.id ? updatedTenant : t)
                        });
                        setOpenEdit(false);
                        onRefresh(); // Refresh the view after editing
                    }
                })
            })
        ]
    });
};

});
parcelRegister("a7gZr", function(module, exports) {

$parcel$export(module.exports, "PlacementService", () => $dc88e5dd8340abd5$export$7cf3f94eafb60774);
class $dc88e5dd8340abd5$export$7cf3f94eafb60774 {
    constructor(postgrest){
        this.postgrest = postgrest;
    }
    /**
   * Get placements at a specific point in time with full aircraft data
   */ async getPlacementsAtTime(timestamp) {
        const { data: data, error: error } = await this.postgrest.rpc("placements_at_time_with_aircraft", {
            p_timestamp: timestamp.toISOString()
        });
        if (error) throw new Error(`Failed to get placements at time: ${error.message}`);
        return data || [];
    }
    /**
   * Get all placements for a trip
   */ async getPlacementsByTrip(tripId) {
        const { data: data, error: error } = await this.postgrest.from("trip_placement").select().eq("trip_id", tripId).order("start_time", {
            ascending: true
        });
        if (error) throw new Error(`Failed to get placements for trip: ${error.message}`);
        return data || [];
    }
    /**
   * Get all placements within a time range for a specific location
   */ async getPlacementsInTimeRange(startDate, endDate, locationId, locationType) {
        // Use the view that includes trip and tenant data
        let query = this.postgrest.from("trip_placement_with_location").select("*").lte("start_time", endDate.toISOString()).gte("end_time", startDate.toISOString());
        // Filter by location if provided
        if (locationId && locationType === "hangar") query = query.eq("hangar_id", locationId);
        else if (locationId && locationType === "ramp") query = query.eq("ramp_id", locationId);
        const { data: data, error: error } = await query;
        if (error) throw new Error(`Failed to get placements in time range: ${error.message}`);
        return data || [];
    }
    /**
   * Get trip counts per date for calendar indicators
   * Efficiently aggregates trip counts by date for a specific location.
   * Multi-day trips are counted on all dates they span.
   * Returns a Map where keys are ISO date strings (YYYY-MM-DD) and values are trip counts.
   */ async getTripCountsByDate(startDate, endDate, locationId, locationType) {
        const { data: data, error: error } = await this.postgrest.rpc("get_trip_counts_by_date", {
            p_start_date: startDate.toISOString().split("T")[0],
            // YYYY-MM-DD format
            p_end_date: endDate.toISOString().split("T")[0],
            p_location_id: locationId,
            p_location_type: locationType
        });
        if (error) throw new Error(`Failed to get trip counts by date: ${error.message}`);
        // Convert array of {date, trip_count} to Map<string, number>
        const countMap = new Map();
        if (data) data.forEach((row)=>{
            countMap.set(row.date, row.trip_count);
        });
        return countMap;
    }
    /**
   * Get all trips with placement status, including unassigned trips
   * This uses the comprehensive view that includes trips without placements
   * Used for search functionality to ensure all scheduled aircraft are findable
   */ async getAllTripsWithPlacementStatus(startDate, endDate) {
        // Use the comprehensive view that includes unassigned trips
        const { data: data, error: error } = await this.postgrest.from("all_trips_with_placement_status").select("*").lte("start_time", endDate.toISOString()).gte("end_time", startDate.toISOString());
        if (error) throw new Error(`Failed to get all trips with placement status: ${error.message}`);
        return data || [];
    }
    /**
   * Find the next trip start time after the current time for a location
   */ async getNextTripTime(locationId, locationType, currentTime) {
        let query = this.postgrest.from("trip_placement").select("start_time").gt("start_time", currentTime.toISOString()).order("start_time", {
            ascending: true
        }).limit(1);
        // Filter by location type
        if (locationType === "hangar") query = query.eq("hangar_id", locationId);
        else query = query.eq("ramp_id", locationId);
        const { data: data, error: error } = await query;
        if (error) {
            console.error("Failed to get next trip time:", error);
            return null;
        }
        if (data && data.length > 0) return new Date(data[0].start_time);
        return null;
    }
    /**
   * Find the previous trip start time before the current time for a location
   * Excludes currently active trips by ensuring end_time < currentTime
   */ async getPreviousTripTime(locationId, locationType, currentTime) {
        // Query for trips that have started AND ended before current time
        let query = this.postgrest.from("trip_placement").select("start_time, end_time").lt("end_time", currentTime.toISOString()).order("start_time", {
            ascending: false
        }).limit(1);
        // Filter by location type
        if (locationType === "hangar") query = query.eq("hangar_id", locationId);
        else query = query.eq("ramp_id", locationId);
        const { data: data, error: error } = await query;
        if (error) {
            console.error("Failed to get previous trip time:", error);
            return null;
        }
        if (data && data.length > 0) return new Date(data[0].start_time);
        return null;
    }
    /**
   * Get the next trip time for a specific aircraft (by tail number)
   * Optionally filter by location and type
   */ async getNextTripTimeForAircraft(tailNumber, currentTime, locationId, locationType) {
        // Use RPC function or direct join query instead of nested PostgREST filtering
        let query = this.postgrest.from("trip_placement").select(`
        start_time,
        trip!inner (
          tenant!inner (*)
        )
      `).gt("start_time", currentTime.toISOString()).order("start_time", {
            ascending: true
        });
        // Optionally filter by location
        if (locationId && locationType) {
            if (locationType === "hangar") query = query.eq("hangar_id", locationId);
            else query = query.eq("ramp_id", locationId);
        }
        const { data: data, error: error } = await query;
        if (error) {
            console.error("Failed to get next trip time for aircraft:", error);
            return null;
        }
        // Filter by tail number in JavaScript since PostgREST nested filtering might not work
        const matchingTrips = data?.filter((placement)=>{
            const placementTailNumber = placement.trip?.tenant?.tail_number;
            return placementTailNumber === tailNumber;
        });
        if (matchingTrips && matchingTrips.length > 0) return new Date(matchingTrips[0].start_time);
        return null;
    }
    /**
   * Get the previous trip time for a specific aircraft (by tail number)
   * Excludes currently active trips by ensuring end_time < currentTime
   * Optionally filter by location and type
   */ async getPreviousTripTimeForAircraft(tailNumber, currentTime, locationId, locationType) {
        // Query for trips that have ended before current time
        let query = this.postgrest.from("trip_placement").select(`
        start_time,
        end_time,
        trip!inner (
          tenant!inner (*)
        )
      `).lt("end_time", currentTime.toISOString()).order("start_time", {
            ascending: false
        });
        // Optionally filter by location
        if (locationId && locationType) {
            if (locationType === "hangar") query = query.eq("hangar_id", locationId);
            else query = query.eq("ramp_id", locationId);
        }
        const { data: data, error: error } = await query;
        if (error) {
            console.error("Failed to get previous trip time for aircraft:", error);
            return null;
        }
        // Filter by tail number in JavaScript since PostgREST nested filtering might not work
        const matchingTrips = data?.filter((placement)=>{
            const placementTailNumber = placement.trip?.tenant?.tail_number;
            return placementTailNumber === tailNumber;
        });
        if (matchingTrips && matchingTrips.length > 0) return new Date(matchingTrips[0].start_time);
        return null;
    }
    /**
   * Get placements with location details for a trip
   */ async getPlacementsWithLocation(tripId) {
        const { data: data, error: error } = await this.postgrest.from("trip_placement_with_location").select().eq("trip_id", tripId).order("start_time", {
            ascending: true
        });
        if (error) throw new Error(`Failed to get placements with location: ${error.message}`);
        return data || [];
    }
    /**
   * Get available locations for a time range
   */ async getAvailableLocations(startTime, endTime, fboId) {
        try {
            // Get all hangars and ramps for the FBO
            const [hangarsResponse, rampsResponse] = await Promise.all([
                this.postgrest.from("hangar").select("id, name").eq("fbo_id", fboId),
                this.postgrest.from("ramp").select("id, name").eq("fbo_id", fboId)
            ]);
            if (hangarsResponse.error) throw hangarsResponse.error;
            if (rampsResponse.error) throw rampsResponse.error;
            // Format response
            const locations = [];
            // Add hangars
            hangarsResponse.data?.forEach((hangar)=>{
                locations.push({
                    id: hangar.id,
                    name: hangar.name,
                    type: "hangar"
                });
            });
            // Add ramps
            rampsResponse.data?.forEach((ramp)=>{
                locations.push({
                    id: ramp.id,
                    name: ramp.name,
                    type: "ramp"
                });
            });
            // Sort by type then name
            return locations.sort((a, b)=>{
                if (a.type !== b.type) return a.type === "hangar" ? -1 : 1;
                return a.name.localeCompare(b.name);
            });
        } catch (error) {
            throw new Error(`Failed to get available locations: ${error.message}`);
        }
    }
    /**
   * Assign a trip to a location with automatic gap filling for partial assignments
   * This method uses the database stored procedure for atomic, consistent operations
   */ async assignToLocationWithGapFilling(tripId, locationId, locationType, startTime, endTime, excludeConflicts = true, // Default to allowing overlaps
    _position) {
        // Use the stored procedure for atomic assignment with gap filling
        // NOTE: This procedure only handles location assignment, not position within location
        const { data: data, error: error } = await this.postgrest.rpc("assign_trip_to_location", {
            p_trip_id: tripId,
            p_location_id: locationId,
            p_location_type: locationType,
            p_start_time: startTime || null,
            p_end_time: endTime || null,
            p_exclude_trip_from_conflicts: excludeConflicts
        });
        if (error) {
            console.error("Failed to assign location:", error);
            throw new Error(error.message || "Failed to assign location");
        }
        const result = data;
        // Check if the stored procedure returned an error
        if (result && !result.success) {
            console.error("Assignment failed:", result.error);
            throw new Error(result.error || "Failed to assign location");
        }
        // Log any conflicts that were detected
        if (result && result.conflicts && result.conflicts.length > 0) console.warn(`Assignment created with ${result.conflict_count} conflict(s):`, result.conflicts);
    }
    /**
   * Complete trip coverage rebuilder with auto-gap-fill
   *
   * Rebuilds complete trip coverage from desired segments with:
   * - Deterministic UUIDs (same placement = same ID always)
   * - Auto-gap-fill with unassigned placements
   * - Atomic delete/recreate operation
   * - Returns warnings for auto-filled segments
   *
   * Replaces all previous placement functions with a single atomic operation
   */ async rebuildTripCoverage(tripId, segments) {
        const { data: data, error: error } = await this.postgrest.rpc("rebuild_trip_coverage", {
            p_trip_id: tripId,
            p_segments: segments
        });
        if (error) throw new Error(`Failed to rebuild trip coverage: ${error.message}`);
        const result = data;
        if (!result || result.success !== true) throw new Error(result?.message || "Failed to rebuild trip coverage");
        return result;
    }
    /**
   * Helper: Move aircraft to new location (uses rebuild function)
   */ async moveAircraftAtTime(tripId, newLocationId, locationType, changeTime, position = {}, isLocked = true) {
        // Get current trip placements
        const placements = await this.getPlacementsByTrip(tripId);
        // Find placement that contains the change time
        const targetPlacement = placements.find((p)=>new Date(p.start_time) <= changeTime && new Date(p.end_time) > changeTime);
        if (!targetPlacement) throw new Error("No placement found at the specified time");
        // Create new segments: before + moved + after
        const segments = [];
        // Add any placements before the target (preserve their metadata)
        placements.forEach((p)=>{
            if (new Date(p.end_time) <= changeTime) segments.push({
                start_time: p.start_time,
                end_time: p.end_time,
                hangar_id: p.hangar_id,
                ramp_id: p.ramp_id,
                x: p.x,
                y: p.y,
                angle: p.angle,
                placement_source: p.placement_source || "manual",
                is_locked: p.is_locked ?? false
            });
        });
        // Add the "before" part of split placement if needed (preserve metadata)
        if (new Date(targetPlacement.start_time) < changeTime) segments.push({
            start_time: targetPlacement.start_time,
            end_time: changeTime.toISOString(),
            hangar_id: targetPlacement.hangar_id,
            ramp_id: targetPlacement.ramp_id,
            x: targetPlacement.x,
            y: targetPlacement.y,
            angle: targetPlacement.angle,
            placement_source: targetPlacement.placement_source || "manual",
            is_locked: targetPlacement.is_locked ?? false
        });
        // Add the moved segment with manual source and locked status
        segments.push({
            start_time: changeTime.toISOString(),
            end_time: targetPlacement.end_time,
            hangar_id: locationType === "hangar" ? newLocationId : null,
            ramp_id: locationType === "ramp" ? newLocationId : null,
            x: position.x !== undefined ? position.x : null,
            y: position.y !== undefined ? position.y : null,
            angle: position.angle !== undefined ? position.angle : null,
            placement_source: "manual",
            is_locked: isLocked
        });
        // Add any placements after the target (preserve their metadata)
        placements.forEach((p)=>{
            if (new Date(p.start_time) >= new Date(targetPlacement.end_time)) segments.push({
                start_time: p.start_time,
                end_time: p.end_time,
                hangar_id: p.hangar_id,
                ramp_id: p.ramp_id,
                x: p.x,
                y: p.y,
                angle: p.angle,
                placement_source: p.placement_source || "manual",
                is_locked: p.is_locked ?? false
            });
        });
        // Rebuild coverage with new segments
        await this.rebuildTripCoverage(tripId, segments);
    }
    /**
   * Toggle lock status on a placement
   */ async toggleLock(placementId, isLocked) {
        // Get the placement to find its trip_id
        const { data: placement, error: fetchError } = await this.postgrest.from("trip_placement").select("trip_id").eq("id", placementId).single();
        if (fetchError || !placement) throw new Error(`Failed to fetch placement: ${fetchError?.message || "Not found"}`);
        // Update ALL segments for this trip (not just one segment)
        const { error: error } = await this.postgrest.from("trip_placement").update({
            is_locked: isLocked
        }).eq("trip_id", placement.trip_id);
        if (error) throw new Error(`Failed to toggle lock: ${error.message}`);
    }
}

});

parcelRegister("6RcbS", function(module, exports) {

$parcel$export(module.exports, "TripDetailsModal", () => $cea447c9650ebb33$export$5476cdf39a01c480);

var $ayMG0 = parcelRequire("ayMG0");

var $7S0ew = parcelRequire("7S0ew");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $2LXej = parcelRequire("2LXej");

var $a7gZr = parcelRequire("a7gZr");

var $bvqAP = parcelRequire("bvqAP");

var $lQ8IB = parcelRequire("lQ8IB");

var $dlEXA = parcelRequire("dlEXA");

var $7kLf7 = parcelRequire("7kLf7");
const $cea447c9650ebb33$export$5476cdf39a01c480 = ({ open: open, trip: trip, trips: trips, onClose: onClose, onUpdate: onUpdate, onNavigate: onNavigate, onTripChanged: onTripChanged, currentTimestamp: currentTimestamp })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const navigate = (0, $aphAM.useNavigate)();
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // Form state
    const [editedTrip, setEditedTrip] = (0, $acw62.useState)({});
    const [selectedAircraft, setSelectedAircraft] = (0, $acw62.useState)(null);
    // Placement state
    const [placements, setPlacements] = (0, $acw62.useState)([]);
    const [_, setPlacementsLoading] = (0, $acw62.useState)(false);
    // Services and hooks
    const tenantService = (0, $acw62.useMemo)(()=>new (0, $bvqAP.TenantService)(postgrest), [
        postgrest
    ]);
    // Location assignment dialog state
    const [assignLocationOpen, setAssignLocationOpen] = (0, $acw62.useState)(false);
    // Create trip dialog state
    const [createDialogOpen, setCreateDialogOpen] = (0, $acw62.useState)(false);
    // Handle location navigation
    const handleLocationClick = (0, $acw62.useCallback)((placement)=>{
        if (!placement.hangar_id && !placement.ramp_id) return;
        const arrivalTime = (0, $dlEXA.encodeTimeToUrl)(new Date(placement.start_time));
        if (placement.hangar_id) navigate(`/hangars/${placement.hangar_id}/schedule?date=${arrivalTime}`);
        else if (placement.ramp_id) navigate(`/ramps/${placement.ramp_id}/schedule?date=${arrivalTime}`);
    }, [
        navigate
    ]);
    // Confirmation dialog state
    const [deleteConfirmOpen, setDeleteConfirmOpen] = (0, $acw62.useState)(false);
    const [cancelConfirmOpen, setCancelConfirmOpen] = (0, $acw62.useState)(false);
    // Initialize services
    const placementService = (0, $acw62.useMemo)(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    const tripService = (0, $acw62.useMemo)(()=>new (0, $lQ8IB.TripService)(postgrest), [
        postgrest
    ]);
    // Get current placement location (for AssignLocationDialog)
    const currentLocation = (0, $acw62.useMemo)(()=>{
        if (!placements || placements.length === 0) return null;
        const currentPlacement = placements[0];
        if (currentPlacement.id === "synthetic") return null;
        return currentPlacement.hangar_id || currentPlacement.ramp_id || null;
    }, [
        placements
    ]);
    // Get current location type
    const currentLocationType = (0, $acw62.useMemo)(()=>{
        if (!placements || placements.length === 0) return undefined;
        const currentPlacement = placements[0];
        if (currentPlacement.id === "synthetic") return undefined;
        if (currentPlacement.hangar_id) return "hangar";
        if (currentPlacement.ramp_id) return "ramp";
        return undefined;
    }, [
        placements
    ]);
    // Reset when trip changes
    (0, $acw62.useEffect)(()=>{
        if (trip) {
            setEditedTrip({
                arrival_date: trip.arrival_date,
                departure_date: trip.departure_date,
                status: trip.status,
                notes: trip.notes || "",
                tail_number: trip.tail_number || "",
                owner_manager: trip.owner_manager || ""
            });
            // Set current aircraft based on make and model
            if (trip.aircraft_manufacturer && trip.aircraft_model) setSelectedAircraft({
                id: "",
                make: trip.aircraft_manufacturer,
                model: trip.aircraft_model
            });
            else setSelectedAircraft(null);
            setIsEditing(false);
            setError(null);
        }
    }, [
        trip
    ]);
    // Helper function to fetch placements (reusable)
    const fetchPlacements = async ()=>{
        if (!trip) return;
        setPlacementsLoading(true);
        try {
            const data = await placementService.getPlacementsWithLocation(trip.trip_id);
            // If no placements exist, create a synthetic "Unassigned" placement
            if (data.length === 0) setPlacements([
                {
                    id: "synthetic",
                    trip_id: trip.trip_id,
                    start_time: trip.arrival_date,
                    end_time: trip.departure_date,
                    location_name: "Unassigned",
                    location_type: "transient",
                    created_at: "",
                    updated_at: "",
                    version: 1
                }
            ]);
            else setPlacements(data);
        } catch (err) {
            console.error("Failed to fetch placements:", err);
            setPlacements([
                {
                    id: "synthetic",
                    trip_id: trip.trip_id,
                    start_time: trip.arrival_date,
                    end_time: trip.departure_date,
                    location_name: "Unassigned",
                    location_type: "transient",
                    created_at: "",
                    updated_at: "",
                    version: 1
                }
            ]);
        } finally{
            setPlacementsLoading(false);
        }
    };
    // Fetch placements when trip changes
    (0, $acw62.useEffect)(()=>{
        fetchPlacements();
    }, [
        trip
    ]);
    // Find next trip for the same aircraft (tail number)
    const nextTrip = (0, $acw62.useMemo)(()=>{
        if (!trip) return null;
        const aircraftTrips = trips.filter((t)=>t.tail_number === trip.tail_number && t.trip_id !== trip.trip_id).sort((a, b)=>new Date(a.arrival_date).getTime() - new Date(b.arrival_date).getTime());
        return aircraftTrips.find((t)=>new Date(t.arrival_date) > new Date(trip.departure_date)) || null;
    }, [
        trip,
        trips
    ]);
    // Find previous trip for the same aircraft (tail number)
    const previousTrip = (0, $acw62.useMemo)(()=>{
        if (!trip) return null;
        const aircraftTrips = trips.filter((t)=>t.tail_number === trip.tail_number && t.trip_id !== trip.trip_id).sort((a, b)=>new Date(b.departure_date).getTime() - new Date(a.departure_date).getTime());
        return aircraftTrips.find((t)=>new Date(t.departure_date) < new Date(trip.arrival_date)) || null;
    }, [
        trip,
        trips
    ]);
    const handleSave = async ()=>{
        if (!trip) return;
        setLoading(true);
        setError(null);
        try {
            const tripService = new (0, $lQ8IB.TripService)(postgrest);
            // Step 1: Update trip fields (dates, status, notes)
            const tripUpdates = {
                arrival_date: editedTrip.arrival_date,
                departure_date: editedTrip.departure_date,
                status: editedTrip.status,
                notes: editedTrip.notes
            };
            // Call parent's onUpdate or use TripService directly
            if (onUpdate) await onUpdate(trip.trip_id, tripUpdates);
            else await tripService.updateTrip(trip.trip_id, tripUpdates);
            // Step 2: Update tenant fields if changed
            const tenantUpdates = {};
            let needTenantUpdate = false;
            // Check if tail number changed
            if (editedTrip.tail_number !== trip.tail_number) {
                tenantUpdates.tail_number = editedTrip.tail_number?.trim().toUpperCase() || null;
                needTenantUpdate = true;
            }
            // Check if owner/manager changed
            if (editedTrip.owner_manager !== trip.owner_manager) {
                tenantUpdates.owner_manager = editedTrip.owner_manager?.trim() || null;
                needTenantUpdate = true;
            }
            // Check if aircraft changed
            if (selectedAircraft && (selectedAircraft.make !== trip.aircraft_manufacturer || selectedAircraft.model !== trip.aircraft_model)) {
                tenantUpdates.aircraft_id = selectedAircraft.id || null;
                needTenantUpdate = true;
            }
            // Update tenant if needed
            if (needTenantUpdate && trip.tenant_id) await tenantService.updateTenant(trip.tenant_id, tenantUpdates);
            // Refresh the trip data
            onTripChanged?.();
            setIsEditing(false);
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to update trip");
        } finally{
            setLoading(false);
        }
    };
    const handleCancel = ()=>{
        if (trip) {
            setEditedTrip({
                arrival_date: trip.arrival_date,
                departure_date: trip.departure_date,
                status: trip.status,
                notes: trip.notes || "",
                tail_number: trip.tail_number || "",
                owner_manager: trip.owner_manager || ""
            });
            // Reset aircraft selection
            if (trip.aircraft_manufacturer && trip.aircraft_model) setSelectedAircraft({
                id: "",
                make: trip.aircraft_manufacturer,
                model: trip.aircraft_model
            });
            else setSelectedAircraft(null);
        }
        setIsEditing(false);
        setError(null);
    };
    // Handle cancelling a trip (set status to cancelled)
    // NOTE: Cancelled trips are automatically unassigned from all hangars/ramps
    // by the database trigger 'auto_unassign_cancelled_trips'
    // See: src/web/schema/V0.45__auto_unassign_cancelled_trips.sql
    const handleCancelTrip = async ()=>{
        if (!trip) return;
        setLoading(true);
        setError(null);
        setCancelConfirmOpen(false);
        try {
            await tripService.updateTripStatus(trip.trip_id, "cancelled");
            onTripChanged?.();
            onClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to cancel trip");
        } finally{
            setLoading(false);
        }
    };
    // Handle deleting a trip
    const handleDeleteTrip = async ()=>{
        if (!trip) return;
        setLoading(true);
        setError(null);
        setDeleteConfirmOpen(false);
        try {
            await tripService.deleteTrip(trip.trip_id);
            onTripChanged?.();
            onClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to delete trip");
        } finally{
            setLoading(false);
        }
    };
    // Handle location assignment
    const handleLocationAssigned = async ()=>{
        setAssignLocationOpen(false);
        // Refresh placements to show the new location
        await fetchPlacements();
        // Notify parent that trip was changed
        onTripChanged?.();
    };
    // Handle new trip creation
    const handleTripCreated = async ()=>{
        setCreateDialogOpen(false);
        // Notify parent that a new trip was created
        onTripChanged?.();
    };
    // Calculate initial dates for new trip (avoid overlap with current trip)
    const getInitialDatesForNewTrip = ()=>{
        if (!trip) return {
            arrivalDate: new Date(),
            departureDate: (0, $7S0ew.addDays)(new Date(), 2)
        };
        // Start new trip after current trip's departure
        const departureDate = new Date(trip.departure_date);
        const newArrivalDate = (0, $7S0ew.addDays)(departureDate, 1);
        const newDepartureDate = (0, $7S0ew.addDays)(newArrivalDate, 2);
        return {
            arrivalDate: newArrivalDate,
            departureDate: newDepartureDate
        };
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7kLf7.TripDetailsModalPresenter), {
        open: open,
        trip: trip,
        onClose: onClose,
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        loading: loading,
        error: error,
        setError: setError,
        editedTrip: editedTrip,
        setEditedTrip: setEditedTrip,
        selectedAircraft: selectedAircraft,
        setSelectedAircraft: setSelectedAircraft,
        placements: placements,
        currentLocation: currentLocation,
        currentLocationType: currentLocationType,
        currentTimestamp: currentTimestamp,
        previousTrip: previousTrip,
        nextTrip: nextTrip,
        onNavigate: onNavigate,
        handleSave: handleSave,
        handleCancel: handleCancel,
        handleCancelTrip: handleCancelTrip,
        handleDeleteTrip: handleDeleteTrip,
        handleLocationClick: handleLocationClick,
        handleLocationAssigned: handleLocationAssigned,
        deleteConfirmOpen: deleteConfirmOpen,
        setDeleteConfirmOpen: setDeleteConfirmOpen,
        cancelConfirmOpen: cancelConfirmOpen,
        setCancelConfirmOpen: setCancelConfirmOpen,
        assignLocationOpen: assignLocationOpen,
        setAssignLocationOpen: setAssignLocationOpen,
        createDialogOpen: createDialogOpen,
        setCreateDialogOpen: setCreateDialogOpen,
        onTripCreated: handleTripCreated,
        getInitialDatesForNewTrip: getInitialDatesForNewTrip
    });
};

});
parcelRegister("7S0ew", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $43c6d634ecd98fac$export$dd412b56f1e4d8aa);

var $9Jots = parcelRequire("9Jots");

var $bXANJ = parcelRequire("bXANJ");
function $43c6d634ecd98fac$export$dd412b56f1e4d8aa(date, amount) {
    const _date = (0, $9Jots.toDate)(date);
    if (isNaN(amount)) return (0, $bXANJ.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$43c6d634ecd98fac$export$2e2bcd8739ae039 = $43c6d634ecd98fac$export$dd412b56f1e4d8aa;

});

parcelRegister("lQ8IB", function(module, exports) {

$parcel$export(module.exports, "TripService", () => $ffdf8fc1d61b5344$export$96b7c126c063e736);

var $gYLUy = parcelRequire("gYLUy");
class $ffdf8fc1d61b5344$export$96b7c126c063e736 {
    constructor(postgrest){
        this.postgrest = postgrest;
    }
    /**
   * Create a new trip
   * 
   * NOTE: This only creates the trip record without any placement.
   * To assign it to a location, use assignToLocation() after creation,
   * or use createTripWithLocation() for atomic creation with initial assignment.
   * 
   * @param trip - Trip data (must include tenant_id, fbo_id, arrival_date, departure_date)
   * @returns Created trip with generated ID and version=1
   * @throws Error if dates are invalid or required fields missing
   */ async createTrip(trip) {
        // Validate required fields
        if (!trip.tenant_id) throw new Error("tenant_id is required");
        if (!trip.fbo_id) throw new Error("fbo_id is required");
        if (!trip.arrival_date) throw new Error("arrival_date is required");
        if (!trip.departure_date) throw new Error("departure_date is required");
        // Validate date logic
        const arrival = new Date(trip.arrival_date);
        if (isNaN(arrival.getTime())) throw new Error("Invalid arrival_date format");
        // Skip departure validation if it's infinity (base tenant / indefinite stay)
        if (!(0, $gYLUy.isInfinityDate)(trip.departure_date)) {
            const departure = new Date(trip.departure_date);
            if (isNaN(departure.getTime())) throw new Error("Invalid departure_date format");
            if (arrival >= departure) throw new Error("arrival_date must be before departure_date");
        }
        // Execute insert
        const { data: data, error: error } = await this.postgrest.from("trip").insert(trip).select().single();
        if (error) {
            // Check for specific constraint violations
            if (error.message.includes("overlapping")) throw new Error(`Trip overlaps with existing trip for this tenant`);
            throw new Error(`Failed to create trip: ${error.message}`);
        }
        return data;
    }
    /**
   * Update an existing trip
   */ async updateTrip(id, updates) {
        const { data: data, error: error } = await this.postgrest.from("trip").update({
            ...updates,
            updated_at: new Date().toISOString()
        }).eq("id", id).select().single();
        if (error) throw new Error(`Failed to update trip: ${error.message}`);
        return data;
    }
    /**
   * Update trip with optimistic locking
   */ async updateTripWithVersion(id, updates, expectedVersion) {
        const { data: data, error: error } = await this.postgrest.from("trip").update({
            ...updates,
            version: expectedVersion + 1,
            updated_at: new Date().toISOString()
        }).eq("id", id).eq("version", expectedVersion).select().single();
        if (error) throw new Error(`Failed to update trip: ${error.message}`);
        if (!data) throw new Error("VERSION_CONFLICT: Trip was modified by another user");
        return data;
    }
    /**
   * Get a single trip by ID
   */ async getTrip(id) {
        const { data: data, error: error } = await this.postgrest.from("trip").select().eq("id", id).single();
        if (error) throw new Error(`Failed to get trip: ${error.message}`);
        return data;
    }
    /**
   * Get a trip with tenant details
   */ async getTripWithTenant(id) {
        const { data: data, error: error } = await this.postgrest.from("trip_with_tenant").select().eq("trip_id", id).single();
        if (error) throw new Error(`Failed to get trip with tenant: ${error.message}`);
        return data;
    }
    /**
   * List all trips for an FBO
   */ async listTrips(fboId) {
        const { data: data, error: error } = await this.postgrest.from("trip").select().eq("fbo_id", fboId).order("arrival_date", {
            ascending: true
        });
        if (error) throw new Error(`Failed to list trips: ${error.message}`);
        return data || [];
    }
    /**
   * List trips with tenant details for an FBO
   */ async listTripsWithTenant(fboId) {
        const { data: data, error: error } = await this.postgrest.from("trip_with_tenant").select().eq("fbo_id", fboId).order("arrival_date", {
            ascending: true
        });
        if (error) throw new Error(`Failed to list trips with tenant: ${error.message}`);
        return data || [];
    }
    /**
   * List all trips with tenant AND placement information for an FBO
   * This includes the current hangar/ramp assignment for each trip
   */ async listTripsWithTenantAndPlacement(fboId) {
        // First get trips with tenant info
        const { data: trips, error: tripsError } = await this.postgrest.from("trip_with_tenant").select().eq("fbo_id", fboId).order("arrival_date", {
            ascending: true
        });
        if (tripsError) throw new Error(`Failed to list trips: ${tripsError.message}`);
        if (!trips || trips.length === 0) return [];
        // Get all placement data for these trips in one query
        const tripIds = trips.map((t)=>t.trip_id);
        const { data: placements, error: placementsError } = await this.postgrest.from("trip_placement_with_location").select("trip_id, hangar_id, ramp_id, hangar_name, ramp_name, location_name, location_type").in("trip_id", tripIds);
        if (placementsError) {
            console.error("Failed to fetch placements:", placementsError);
            // Return trips without placement data rather than failing
            return trips.map((trip)=>({
                    ...trip,
                    location_name: null,
                    location_type: null
                }));
        }
        // Create a map of trip_id to placement for efficient lookup
        const placementMap = new Map();
        (placements || []).forEach((p)=>{
            // Use the most recent placement if there are multiple
            if (!placementMap.has(p.trip_id)) placementMap.set(p.trip_id, p);
        });
        // Merge trips with their placement data
        return trips.map((trip)=>{
            const placement = placementMap.get(trip.trip_id);
            return {
                ...trip,
                hangar_id: placement?.hangar_id || null,
                ramp_id: placement?.ramp_id || null,
                hangar_name: placement?.hangar_name || null,
                ramp_name: placement?.ramp_name || null,
                location_name: placement?.location_name || null,
                location_type: placement?.location_type || null
            };
        });
    }
    /**
   * List trips for a specific tenant
   */ async listTripsByTenant(tenantId) {
        const { data: data, error: error } = await this.postgrest.from("trip").select().eq("tenant_id", tenantId).order("arrival_date", {
            ascending: true
        });
        if (error) throw new Error(`Failed to list trips by tenant: ${error.message}`);
        return data || [];
    }
    /**
   * List active trips (scheduled or active status) within a date range
   */ async listActiveTrips(fboId, startDate, endDate) {
        const { data: data, error: error } = await this.postgrest.from("trip").select().eq("fbo_id", fboId).in("status", [
            "scheduled",
            "active"
        ]).gte("departure_date", startDate).lte("arrival_date", endDate).order("arrival_date", {
            ascending: true
        });
        if (error) throw new Error(`Failed to list active trips: ${error.message}`);
        return data || [];
    }
    /**
   * Delete a trip
   */ async deleteTrip(id) {
        const { error: error } = await this.postgrest.from("trip").delete().eq("id", id);
        if (error) throw new Error(`Failed to delete trip: ${error.message}`);
    }
    /**
   * Update trip status
   *
   * NOTE: When a trip is cancelled (status = 'cancelled'), all hangar/ramp assignments
   * are automatically removed by the database trigger 'auto_unassign_cancelled_trips'.
   * See: src/web/schema/V0.45__auto_unassign_cancelled_trips.sql
   */ async updateTripStatus(id, status) {
        const { data: data, error: error } = await this.postgrest.from("trip").update({
            status: status,
            updated_at: new Date().toISOString()
        }).eq("id", id).select().single();
        if (error) throw new Error(`Failed to update trip status: ${error.message}`);
        return data;
    }
    /**
   * Cancel a trip (soft delete)
   * Sets the trip status to 'cancelled', which automatically unassigns it from any location.
   */ async cancelTrip(id) {
        return this.updateTripStatus(id, 'cancelled');
    }
    /**
   * Create a new trip with optional initial location assignment
   * 
   * This method atomically creates a trip and assigns it to a location in a single
   * database transaction. If no location is provided, an unassigned placement is
   * created covering the full trip duration.
   * 
   * @param trip - Trip data (must include tenant_id, fbo_id, arrival_date, departure_date)
   * @param locationId - Optional initial location ID (hangar or ramp)
   * @param locationType - Optional location type ('hangar' or 'ramp')
   * @returns Created trip with placement information
   * @throws Error if creation fails or location assignment fails
   */ async createTripWithLocation(trip, locationId, locationType) {
        // Validate required fields
        if (!trip.tenant_id) throw new Error("tenant_id is required");
        if (!trip.fbo_id) throw new Error("fbo_id is required");
        if (!trip.arrival_date) throw new Error("arrival_date is required");
        if (!trip.departure_date) throw new Error("departure_date is required");
        // Validate date logic
        const arrival = new Date(trip.arrival_date);
        if (isNaN(arrival.getTime())) throw new Error("Invalid arrival_date format");
        // Skip departure validation if it's infinity (base tenant / indefinite stay)
        if (!(0, $gYLUy.isInfinityDate)(trip.departure_date)) {
            const departure = new Date(trip.departure_date);
            if (isNaN(departure.getTime())) throw new Error("Invalid departure_date format");
            if (arrival >= departure) throw new Error("arrival_date must be before departure_date");
        }
        // Validate location parameters
        if (locationId && !locationType) throw new Error("locationType is required when locationId is provided");
        if (locationType && ![
            'hangar',
            'ramp'
        ].includes(locationType)) throw new Error("locationType must be 'hangar' or 'ramp'");
        // Call the stored procedure
        const { data: data, error: error } = await this.postgrest.rpc('create_trip_with_location', {
            p_tenant_id: trip.tenant_id,
            p_fbo_id: trip.fbo_id,
            p_arrival_date: trip.arrival_date,
            p_departure_date: trip.departure_date,
            p_status: trip.status || 'scheduled',
            p_notes: trip.notes || null,
            p_confirmation_code: trip.confirmation_code || null,
            p_initial_location_id: locationId || null,
            p_initial_location_type: locationType || null
        });
        if (error) throw new Error(`Failed to create trip with location: ${error.message}`);
        if (!data || !data.success) throw new Error(data?.error || 'Failed to create trip with location');
        return data.trip;
    }
    /**
   * Get all trips for a specific aircraft (by tail number)
   * 
   * @param fboId - FBO identifier
   * @param tailNumber - Aircraft tail number to search for
   * @returns Array of trips with tenant information for the aircraft
   */ async getTripsByTailNumber(fboId, tailNumber) {
        const { data: data, error: error } = await this.postgrest.from("trip_with_tenant").select().eq("fbo_id", fboId).eq("tail_number", tailNumber).order("arrival_date", {
            ascending: true
        });
        if (error) throw new Error(`Failed to get trips for aircraft ${tailNumber}: ${error.message}`);
        return data || [];
    }
}

});

parcelRegister("dlEXA", function(module, exports) {

$parcel$export(module.exports, "encodeTimeToUrl", () => $74157a0864543836$export$f95ce0da3a3f4b55);
$parcel$export(module.exports, "decodeTimeFromUrl", () => $74157a0864543836$export$93786ff2d52b8602);
$parcel$export(module.exports, "createShareableScheduleUrl", () => $74157a0864543836$export$1f5338857c523942);

var $55RUj = parcelRequire("55RUj");
const $74157a0864543836$export$f95ce0da3a3f4b55 = (date)=>{
    const pad = (num)=>num.toString().padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hour = pad(date.getHours());
    const minute = pad(date.getMinutes());
    return `${year}-${month}-${day}T${hour}:${minute}`;
};
const $74157a0864543836$export$93786ff2d52b8602 = (dateParam)=>{
    if (!dateParam) return null;
    // Handle different date formats that might be in the URL
    let cleanParam = dateParam.trim();
    // Replace space with T for ISO format compatibility
    cleanParam = cleanParam.replace(' ', 'T');
    // If only date is provided (YYYY-MM-DD), default to 8:00 AM
    if (/^\d{4}-\d{2}-\d{2}$/.test(cleanParam)) cleanParam += 'T08:00';
    // Validate format: YYYY-MM-DDTHH:mm
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(cleanParam)) return null;
    const parsedDate = new Date(cleanParam);
    // Check if the date is valid
    if (isNaN(parsedDate.getTime())) return null;
    // Snap to quarter hour to maintain consistency with the application's time handling
    return (0, $55RUj.snapToQuarterHour)(parsedDate);
};
const $74157a0864543836$export$d5a5a83169d61f0 = (dateParam)=>{
    if (!dateParam) return false;
    return $74157a0864543836$export$93786ff2d52b8602(dateParam) !== null;
};
const $74157a0864543836$export$4014887b6f91ae04 = (date, baseUrl)=>{
    const url = baseUrl || window.location.href;
    const [baseUrlPart, queryString] = url.split('?');
    const searchParams = new URLSearchParams(queryString || '');
    searchParams.set('date', $74157a0864543836$export$f95ce0da3a3f4b55(date));
    return `${baseUrlPart}?${searchParams.toString()}`;
};
const $74157a0864543836$export$1f5338857c523942 = (date)=>{
    return $74157a0864543836$export$4014887b6f91ae04(date);
};

});
parcelRegister("55RUj", function(module, exports) {

$parcel$export(module.exports, "snapToQuarterHour", () => $3b3c6a200dbfe4ef$export$c8c74ef456ccf3a6);
$parcel$export(module.exports, "floorToQuarterHour", () => $3b3c6a200dbfe4ef$export$bd998295a933ce47);
$parcel$export(module.exports, "ceilToQuarterHour", () => $3b3c6a200dbfe4ef$export$fa8b90f8dcb2aa05);
/**
 * Snap a date to the nearest 15-minute interval
 * @param date The date to snap
 * @returns A new date snapped to the nearest 15-minute interval
 */ const $3b3c6a200dbfe4ef$export$c8c74ef456ccf3a6 = (date)=>{
    const snapped = new Date(date);
    const minutes = snapped.getMinutes();
    const roundedMinutes = Math.round(minutes / 15) * 15;
    // Handle edge case where rounding to 60 minutes
    if (roundedMinutes === 60) {
        snapped.setHours(snapped.getHours() + 1);
        snapped.setMinutes(0, 0, 0);
    } else snapped.setMinutes(roundedMinutes, 0, 0);
    return snapped;
};
const $3b3c6a200dbfe4ef$export$bd998295a933ce47 = (date)=>{
    const floored = new Date(date);
    const minutes = floored.getMinutes();
    const flooredMinutes = Math.floor(minutes / 15) * 15;
    floored.setMinutes(flooredMinutes, 0, 0);
    return floored;
};
const $3b3c6a200dbfe4ef$export$fa8b90f8dcb2aa05 = (date)=>{
    const ceiled = new Date(date);
    const minutes = ceiled.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 15) * 15;
    // Handle edge case where ceiling to 60 minutes
    if (ceiledMinutes === 60) {
        ceiled.setHours(ceiled.getHours() + 1);
        ceiled.setMinutes(0, 0, 0);
    } else ceiled.setMinutes(ceiledMinutes, 0, 0);
    return ceiled;
};

});


parcelRegister("7kLf7", function(module, exports) {

$parcel$export(module.exports, "TripDetailsModalPresenter", () => $3cdc48e89f3a4ba2$export$938ac8fa07f2fe92);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $1YLXO = parcelRequire("1YLXO");

var $1BbPR = parcelRequire("1BbPR");

var $at4qK = parcelRequire("at4qK");

var $dqlTG = parcelRequire("dqlTG");

var $1MdOk = parcelRequire("1MdOk");

var $c3r8Q = parcelRequire("c3r8Q");

var $iGBB4 = parcelRequire("iGBB4");

var $ap4xJ = parcelRequire("ap4xJ");

var $ex6lH = parcelRequire("ex6lH");

var $aF8PJ = parcelRequire("aF8PJ");

var $dTjVb = parcelRequire("dTjVb");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $7Frhn = parcelRequire("7Frhn");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $iAtns = parcelRequire("iAtns");
var $eJ0JC = parcelRequire("eJ0JC");
var $9ZYXn = parcelRequire("9ZYXn");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $78ow6 = parcelRequire("78ow6");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $4HKwc = parcelRequire("4HKwc");
var $lGkA3 = parcelRequire("lGkA3");
var $3WoNO = parcelRequire("3WoNO");
var $kfA3C = parcelRequire("kfA3C");
var $7761d = parcelRequire("7761d");
parcelRequire("acw62");

var $e6g4k = parcelRequire("e6g4k");

var $gYLUy = parcelRequire("gYLUy");

var $gtiLb = parcelRequire("gtiLb");

var $apzof = parcelRequire("apzof");

var $hTRQz = parcelRequire("hTRQz");

var $85kUh = parcelRequire("85kUh");

var $35bYL = parcelRequire("35bYL");
const $3cdc48e89f3a4ba2$var$TOOLTIP_MESSAGES = {
    unassigned: "Aircraft is not assigned to a specific hangar or ramp location during this time period. It may be in transient parking or awaiting placement assignment."
};
const $3cdc48e89f3a4ba2$export$938ac8fa07f2fe92 = ({ open: open, trip: trip, onClose: onClose, isEditing: isEditing, setIsEditing: setIsEditing, loading: loading, error: error, setError: setError, editedTrip: editedTrip, setEditedTrip: setEditedTrip, selectedAircraft: selectedAircraft, setSelectedAircraft: setSelectedAircraft, placements: placements, currentLocation: currentLocation, currentLocationType: currentLocationType, currentTimestamp: currentTimestamp, previousTrip: previousTrip, nextTrip: nextTrip, onNavigate: onNavigate, handleSave: handleSave, handleCancel: handleCancel, handleCancelTrip: handleCancelTrip, handleDeleteTrip: handleDeleteTrip, handleLocationClick: handleLocationClick, handleLocationAssigned: handleLocationAssigned, deleteConfirmOpen: deleteConfirmOpen, setDeleteConfirmOpen: setDeleteConfirmOpen, cancelConfirmOpen: cancelConfirmOpen, setCancelConfirmOpen: setCancelConfirmOpen, assignLocationOpen: assignLocationOpen, setAssignLocationOpen: setAssignLocationOpen, createDialogOpen: createDialogOpen, setCreateDialogOpen: setCreateDialogOpen, onTripCreated: onTripCreated, getInitialDatesForNewTrip: getInitialDatesForNewTrip })=>{
    const getStatusColor = (status)=>{
        switch(status){
            case "active":
                return "primary";
            case "scheduled":
                return "default";
            case "completed":
                return "success";
            case "cancelled":
                return "error";
            case "departed":
                return "warning";
            default:
                return "default";
        }
    };
    const getDisplayStatus = (trip)=>{
        // If trip has been explicitly marked as cancelled or completed, show that
        if (trip.status === "cancelled" || trip.status === "completed") return trip.status;
        const now = new Date();
        const arrivalDate = (0, $7761d.parseISO)(trip.arrival_date);
        // Handle infinity departure (base tenants)
        if ((0, $gYLUy.isInfinityDate)(trip.departure_date)) // If arrival has passed, trip is active (never departs)
        return now >= arrivalDate ? "active" : "scheduled";
        const departureDate = (0, $7761d.parseISO)(trip.departure_date);
        // Compute display status based on current time and trip dates
        if (now >= departureDate) return "departed";
        else if (now >= arrivalDate && now < departureDate) return "active";
        else return "scheduled";
    };
    const calculateDuration = (startTime, endTime)=>{
        // Handle infinity end time (base tenants)
        if ((0, $gYLUy.isInfinityDate)(endTime)) return "Indefinite";
        const start = (0, $7761d.parseISO)(startTime);
        const end = (0, $7761d.parseISO)(endTime);
        const days = (0, $4HKwc.differenceInDays)(end, start);
        const hours = (0, $lGkA3.differenceInHours)(end, start) % 24;
        const minutes = (0, $3WoNO.differenceInMinutes)(end, start) % 60;
        if (days > 0) return `${days}d ${hours}h ${minutes}m`;
        else if (hours > 0) return `${hours}h ${minutes}m`;
        else return `${minutes}m`;
    };
    const getLocationIcon = (locationType)=>{
        switch(locationType){
            case "hangar":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtiLb.HangarIcon), {});
            case "ramp":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $apzof.RampIcon), {});
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: $3cdc48e89f3a4ba2$var$TOOLTIP_MESSAGES.unassigned,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                        sx: {
                            color: "info.dark"
                        },
                        fontSize: "small"
                    })
                });
        }
    };
    if (!trip) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: onClose,
                maxWidth: "md",
                fullWidth: true,
                PaperProps: {
                    sx: {
                        borderRadius: 2,
                        maxWidth: {
                            xs: "100%",
                            sm: "600px",
                            md: "800px"
                        },
                        margin: {
                            xs: 1,
                            sm: 2
                        },
                        maxHeight: {
                            xs: "100vh",
                            sm: "90vh"
                        },
                        zIndex: 9500
                    },
                    elevation: 1
                },
                sx: {
                    zIndex: 9500
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        sx: {
                            pb: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "h6",
                                    children: "Trip Details"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    display: "flex",
                                    gap: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "outlined",
                                            size: "small",
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                            onClick: ()=>setCreateDialogOpen(true),
                                            children: "New Trip"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ZYXn.default), {
                                            value: isEditing ? "edit" : "view",
                                            exclusive: true,
                                            onChange: (_, newMode)=>{
                                                if (newMode && trip.status !== "completed") setIsEditing(newMode === "edit");
                                            },
                                            size: "small",
                                            sx: {
                                                backgroundColor: "background.paper",
                                                boxShadow: isEditing ? 1 : 0,
                                                transition: "box-shadow 0.2s ease",
                                                "& .MuiToggleButton-root": {
                                                    px: 2,
                                                    py: 0.5,
                                                    textTransform: "none",
                                                    fontWeight: 400,
                                                    "&.Mui-selected": {
                                                        backgroundColor: "primary.main",
                                                        color: "primary.contrastText",
                                                        fontWeight: 500,
                                                        "&:hover": {
                                                            backgroundColor: "primary.dark"
                                                        }
                                                    }
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJ0JC.default), {
                                                    value: "view",
                                                    children: "View"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJ0JC.default), {
                                                    value: "edit",
                                                    disabled: trip.status === "completed",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3r8Q))), {
                                                            sx: {
                                                                fontSize: 16,
                                                                mr: 0.5
                                                            }
                                                        }),
                                                        "Edit"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                            size: "small",
                                            onClick: onClose,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 3,
                            children: [
                                error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                    severity: "error",
                                    onClose: ()=>setError(null),
                                    children: error
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    p: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 2,
                                            children: [
                                                isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                    size: "small",
                                                    variant: "outlined",
                                                    label: "Tail Number",
                                                    value: editedTrip.tail_number || "",
                                                    onChange: (e)=>setEditedTrip({
                                                            ...editedTrip,
                                                            tail_number: e.target.value.toUpperCase()
                                                        }),
                                                    sx: {
                                                        width: 150
                                                    },
                                                    inputProps: {
                                                        style: {
                                                            textTransform: "uppercase"
                                                        }
                                                    }
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "h6",
                                                    fontWeight: 600,
                                                    children: trip.tail_number || "Unknown"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                    label: isEditing ? editedTrip.status : getDisplayStatus(trip),
                                                    size: "small",
                                                    color: getStatusColor(isEditing ? editedTrip.status : getDisplayStatus(trip)),
                                                    variant: (isEditing ? editedTrip.status : getDisplayStatus(trip)) === "active" || !isEditing && getDisplayStatus(trip) === "departed" ? "filled" : "outlined"
                                                }),
                                                trip.aircraft_type === "transient" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                    label: "Transient",
                                                    size: "small",
                                                    variant: "outlined"
                                                })
                                            ]
                                        }),
                                        isEditing ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            spacing: 2,
                                            mt: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                    size: "small",
                                                    variant: "outlined",
                                                    label: "Owner/Manager",
                                                    fullWidth: true,
                                                    value: editedTrip.owner_manager || "",
                                                    onChange: (e)=>setEditedTrip({
                                                            ...editedTrip,
                                                            owner_manager: e.target.value
                                                        }),
                                                    placeholder: "Enter owner or manager name"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                                                    label: "Aircraft",
                                                    onSelect: (newValue)=>setSelectedAircraft(newValue),
                                                    defaultSelected: selectedAircraft || undefined
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                trip.owner_manager && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    color: "text.secondary",
                                                    mt: 0.5,
                                                    children: trip.owner_manager
                                                }),
                                                (trip.aircraft_type || trip.aircraft_model) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    color: "text.secondary",
                                                    mt: 0.5,
                                                    children: [
                                                        trip.aircraft_type,
                                                        trip.aircraft_model
                                                    ].filter(Boolean).join(" ")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
                                    dateAdapter: (0, $78ow6.AdapterDateFns),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                spacing: 2,
                                                sx: {
                                                    "& > *": {
                                                        display: "flex",
                                                        flexDirection: "column"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                        sx: {
                                                            flex: 1,
                                                            minWidth: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                spacing: 1,
                                                                alignItems: "center",
                                                                sx: {
                                                                    mb: 1,
                                                                    minHeight: 24
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                                                        fontSize: "small",
                                                                        color: "action"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "subtitle2",
                                                                        color: "text.secondary",
                                                                        children: "Arrival"
                                                                    })
                                                                ]
                                                            }),
                                                            isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                                                value: editedTrip.arrival_date ? new Date(editedTrip.arrival_date) : null,
                                                                onChange: (value)=>setEditedTrip({
                                                                        ...editedTrip,
                                                                        arrival_date: value?.toISOString()
                                                                    }),
                                                                minDate: (0, $e6g4k.SCHEDULE_MIN_DATE),
                                                                maxDate: (0, $e6g4k.SCHEDULE_MAX_DATE),
                                                                slotProps: {
                                                                    textField: {
                                                                        fullWidth: true,
                                                                        size: "small"
                                                                    },
                                                                    popper: {
                                                                        sx: {
                                                                            zIndex: 9700
                                                                        }
                                                                    }
                                                                }
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                                sx: {
                                                                    border: 1,
                                                                    borderColor: "divider",
                                                                    borderRadius: 1,
                                                                    px: 1.5,
                                                                    py: 1,
                                                                    backgroundColor: "background.paper"
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: (0, $kfA3C.format)((0, $7761d.parseISO)(trip.arrival_date), "MM/dd/yyyy hh:mm a")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                        sx: {
                                                            flex: 1,
                                                            minWidth: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                spacing: 1,
                                                                alignItems: "center",
                                                                sx: {
                                                                    mb: 1,
                                                                    minHeight: 24
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                                                        fontSize: "small",
                                                                        color: "action"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "subtitle2",
                                                                        color: "text.secondary",
                                                                        children: "Departure"
                                                                    })
                                                                ]
                                                            }),
                                                            isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                                                value: editedTrip.departure_date ? new Date(editedTrip.departure_date) : null,
                                                                onChange: (value)=>setEditedTrip({
                                                                        ...editedTrip,
                                                                        departure_date: value?.toISOString()
                                                                    }),
                                                                minDate: (0, $e6g4k.SCHEDULE_MIN_DATE),
                                                                minDateTime: editedTrip.arrival_date ? new Date(editedTrip.arrival_date) : undefined,
                                                                maxDate: (0, $e6g4k.SCHEDULE_MAX_DATE),
                                                                slotProps: {
                                                                    textField: {
                                                                        fullWidth: true,
                                                                        size: "small"
                                                                    },
                                                                    popper: {
                                                                        sx: {
                                                                            zIndex: 9700
                                                                        }
                                                                    }
                                                                }
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                                sx: {
                                                                    border: 1,
                                                                    borderColor: "divider",
                                                                    borderRadius: 1,
                                                                    px: 1.5,
                                                                    py: 1,
                                                                    backgroundColor: "background.paper"
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: (0, $gYLUy.formatDepartureDate)(trip.departure_date)
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                        sx: {
                                                            flex: 0.6,
                                                            minWidth: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                spacing: 1,
                                                                alignItems: "center",
                                                                sx: {
                                                                    mb: 1,
                                                                    minHeight: 24
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTjVb))), {
                                                                        fontSize: "small",
                                                                        color: "action"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "subtitle2",
                                                                        color: "text.secondary",
                                                                        children: "Duration"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                                sx: {
                                                                    height: 40,
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    fontWeight: 500,
                                                                    children: isEditing ? editedTrip.arrival_date && editedTrip.departure_date ? calculateDuration(editedTrip.arrival_date, editedTrip.departure_date) : "\u2014" : calculateDuration(trip.arrival_date, trip.departure_date)
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "subtitle2",
                                                        color: "text.secondary",
                                                        gutterBottom: true,
                                                        children: "Notes"
                                                    }),
                                                    isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                        multiline: true,
                                                        rows: 3,
                                                        fullWidth: true,
                                                        size: "small",
                                                        value: editedTrip.notes || "",
                                                        onChange: (e)=>setEditedTrip({
                                                                ...editedTrip,
                                                                notes: e.target.value
                                                            }),
                                                        placeholder: "Add notes..."
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        color: trip.notes ? "text.primary" : "text.secondary",
                                                        children: trip.notes || "No notes"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                !isEditing && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    mb: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "subtitle2",
                                                            color: "text.secondary",
                                                            children: "Location History"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                            size: "small",
                                                            variant: "outlined",
                                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aF8PJ))), {}),
                                                            onClick: ()=>setAssignLocationOpen(true),
                                                            disabled: trip.status === "completed" || trip.status === "cancelled",
                                                            children: "Assign to Location"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                                                    component: (0, $7Frhn.default),
                                                    variant: "outlined",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                                        size: "small",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                            children: "Location"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                            children: "Arrival"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                            children: "Departure"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                            align: "right",
                                                                            children: "Duration"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                                                children: (()=>{
                                                                    const consolidatedPlacements = (()=>{
                                                                        if (!placements.length) return [];
                                                                        const consolidated = [];
                                                                        let current = {
                                                                            ...placements[0]
                                                                        };
                                                                        for(let i = 1; i < placements.length; i++){
                                                                            const next = placements[i];
                                                                            if (current.hangar_id === next.hangar_id && current.ramp_id === next.ramp_id && current.location_name === next.location_name) current = {
                                                                                ...current,
                                                                                end_time: next.end_time
                                                                            };
                                                                            else {
                                                                                consolidated.push(current);
                                                                                current = {
                                                                                    ...next
                                                                                };
                                                                            }
                                                                        }
                                                                        consolidated.push(current);
                                                                        return consolidated;
                                                                    })();
                                                                    return consolidatedPlacements.map((placement)=>{
                                                                        const isCurrentPlacement = currentTimestamp ? new Date(placement.start_time) <= currentTimestamp && new Date(placement.end_time) > currentTimestamp : false;
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                                            sx: {
                                                                                backgroundColor: isCurrentPlacement ? "rgba(25, 118, 210, 0.05)" : "inherit",
                                                                                borderLeft: isCurrentPlacement ? "4px solid" : "none",
                                                                                borderLeftColor: "primary.main"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: 0.5,
                                                                                        children: [
                                                                                            getLocationIcon(placement.location_type),
                                                                                            placement.location_name && placement.location_name !== "Unassigned" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                                variant: "body2",
                                                                                                sx: {
                                                                                                    color: "primary.main",
                                                                                                    cursor: "pointer",
                                                                                                    textDecoration: "underline",
                                                                                                    "&:hover": {
                                                                                                        textDecoration: "none",
                                                                                                        backgroundColor: "action.hover",
                                                                                                        borderRadius: 1,
                                                                                                        px: 0.5
                                                                                                    }
                                                                                                },
                                                                                                onClick: ()=>handleLocationClick(placement),
                                                                                                children: placement.location_name
                                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                                variant: "body2",
                                                                                                color: "text.secondary",
                                                                                                children: "Unassigned"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                        variant: "body2",
                                                                                        children: (0, $kfA3C.format)((0, $7761d.parseISO)(placement.start_time), "MMM d 'at' h:mm a")
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                        variant: "body2",
                                                                                        children: (0, $kfA3C.format)((0, $7761d.parseISO)(placement.end_time), "MMM d 'at' h:mm a")
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                                    align: "right",
                                                                                    sx: {
                                                                                        whiteSpace: "nowrap"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                        variant: "body2",
                                                                                        children: calculateDuration(placement.start_time, placement.end_time)
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, placement.id);
                                                                    });
                                                                })()
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "subtitle2",
                                                    color: "text.secondary",
                                                    gutterBottom: true,
                                                    children: [
                                                        "Other Trips for ",
                                                        trip.tail_number
                                                    ]
                                                }),
                                                !previousTrip && !nextTrip ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    color: "text.disabled",
                                                    sx: {
                                                        py: 1
                                                    },
                                                    children: "No other trips"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                            sx: {
                                                                flex: 1
                                                            },
                                                            children: previousTrip && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                                                                variant: "outlined",
                                                                size: "small",
                                                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YLXO))), {}),
                                                                onClick: ()=>onNavigate?.(previousTrip.trip_id),
                                                                sx: {
                                                                    justifyContent: "flex-start"
                                                                },
                                                                fullWidth: true,
                                                                children: [
                                                                    "Previous:",
                                                                    " ",
                                                                    (0, $kfA3C.format)((0, $7761d.parseISO)(previousTrip.arrival_date), "MMM d"),
                                                                    " ",
                                                                    "-",
                                                                    " ",
                                                                    (0, $gYLUy.isInfinityDate)(previousTrip.departure_date) ? "\u221E" : (0, $kfA3C.format)((0, $7761d.parseISO)(previousTrip.departure_date), "MMM d")
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                            sx: {
                                                                flex: 1
                                                            },
                                                            children: nextTrip && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                                                                variant: "outlined",
                                                                size: "small",
                                                                endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BbPR))), {}),
                                                                onClick: ()=>onNavigate?.(nextTrip.trip_id),
                                                                sx: {
                                                                    justifyContent: "flex-start"
                                                                },
                                                                fullWidth: true,
                                                                children: [
                                                                    "Next:",
                                                                    " ",
                                                                    (0, $kfA3C.format)((0, $7761d.parseISO)(nextTrip.arrival_date), "MMM d"),
                                                                    " -",
                                                                    " ",
                                                                    (0, $gYLUy.isInfinityDate)(nextTrip.departure_date) ? "\u221E" : (0, $kfA3C.format)((0, $7761d.parseISO)(nextTrip.departure_date), "MMM d")
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        sx: {
                            px: 3,
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    display: "flex",
                                    gap: 1,
                                    mr: "auto"
                                },
                                children: trip.status !== "completed" && trip.status !== "cancelled" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($at4qK))), {}),
                                            onClick: ()=>setCancelConfirmOpen(true),
                                            disabled: loading,
                                            color: "warning",
                                            size: "small",
                                            children: "Cancel Trip"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {}),
                                            onClick: ()=>setDeleteConfirmOpen(true),
                                            disabled: loading,
                                            color: "error",
                                            size: "small",
                                            children: "Delete Trip"
                                        })
                                    ]
                                })
                            }),
                            isEditing ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    display: "flex",
                                    gap: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        onClick: handleCancel,
                                        disabled: loading,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "contained",
                                        size: "small",
                                        color: "primary",
                                        onClick: handleSave,
                                        disabled: loading,
                                        sx: {
                                            minWidth: 100
                                        },
                                        children: loading ? "Saving..." : "Save"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: onClose,
                                size: "small",
                                children: "Close"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: deleteConfirmOpen,
                onClose: ()=>setDeleteConfirmOpen(false),
                maxWidth: "sm",
                "aria-labelledby": "delete-confirmation-title",
                sx: {
                    zIndex: 9600
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        id: "delete-confirmation-title",
                        children: "Delete Trip"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            children: [
                                "Are you sure you want to permanently delete this trip for",
                                " ",
                                trip?.tail_number,
                                "? This action cannot be undone and will remove all placement history."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setDeleteConfirmOpen(false),
                                disabled: loading,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleDeleteTrip,
                                color: "error",
                                variant: "contained",
                                disabled: loading,
                                children: loading ? "Deleting..." : "Delete Trip"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: cancelConfirmOpen,
                onClose: ()=>setCancelConfirmOpen(false),
                maxWidth: "sm",
                "aria-labelledby": "cancel-confirmation-title",
                sx: {
                    zIndex: 9600
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        id: "cancel-confirmation-title",
                        children: "Cancel Trip"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            children: [
                                "Are you sure you want to cancel this trip for ",
                                trip?.tail_number,
                                '? This will change the trip status to "cancelled" and it cannot be easily undone.'
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setCancelConfirmOpen(false),
                                disabled: loading,
                                children: "Keep Trip"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleCancelTrip,
                                color: "warning",
                                variant: "contained",
                                disabled: loading,
                                children: loading ? "Cancelling..." : "Cancel Trip"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85kUh.AssignLocationDialog), {
                open: assignLocationOpen,
                trip: trip,
                currentLocation: currentLocation,
                onClose: ()=>setAssignLocationOpen(false),
                onAssign: handleLocationAssigned
            }),
            trip && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35bYL.CreateTripDialog), {
                open: createDialogOpen,
                onClose: ()=>setCreateDialogOpen(false),
                onSuccess: onTripCreated,
                initialArrivalDate: getInitialDatesForNewTrip().arrivalDate,
                initialDepartureDate: getInitialDatesForNewTrip().departureDate,
                currentLocationId: currentLocation || undefined,
                currentLocationType: currentLocationType,
                simpleMode: true,
                existingTenant: trip
            })
        ]
    });
};

});
parcelRegister("1BbPR", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $12a26d70a091a9bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a26d70a091a9bc$var$_createSvgIcon = $12a26d70a091a9bc$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $12a26d70a091a9bc$var$_default = module.exports.default = (0, $12a26d70a091a9bc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

});

parcelRegister("at4qK", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $79f00c956e46f4d6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79f00c956e46f4d6$var$_createSvgIcon = $79f00c956e46f4d6$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $79f00c956e46f4d6$var$_default = module.exports.default = (0, $79f00c956e46f4d6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');

});

parcelRegister("aF8PJ", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $7c3495d857096b79$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c3495d857096b79$var$_createSvgIcon = $7c3495d857096b79$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $7c3495d857096b79$var$_default = module.exports.default = (0, $7c3495d857096b79$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), 'LocationOn');

});

parcelRegister("81yMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7964a6269b66c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $lNHXc = parcelRequire("lNHXc");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lNHXc.getTableContainerUtilityClass), classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $d8seH.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var $5d7964a6269b66c8$export$2e2bcd8739ae039 = $5d7964a6269b66c8$var$TableContainer;

});
parcelRegister("lNHXc", function(module, exports) {

$parcel$export(module.exports, "getTableContainerUtilityClass", () => $fdf044e88b1c9ad4$export$eed427986a7abdf9);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fdf044e88b1c9ad4$export$eed427986a7abdf9(slot) {
    return (0, $4Cod0.default)('MuiTableContainer', slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $beCSm.default)('MuiTableContainer', [
    'root'
]);
var $fdf044e88b1c9ad4$export$2e2bcd8739ae039 = $fdf044e88b1c9ad4$var$tableContainerClasses;

});


parcelRegister("eJ0JC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab85d69438d76ec5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $3cuAs = parcelRequire("3cuAs");

var $lOkLt = parcelRequire("lOkLt");

var $jCUp4 = parcelRequire("jCUp4");

var $d0d3x = parcelRequire("d0d3x");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ab85d69438d76ec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $jTnBY.default)(size)}`,
            color
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3cuAs.getToggleButtonUtilityClass), classes);
};
const $ab85d69438d76ec5$var$ToggleButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.button,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $3cuAs.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            {
                props: {
                    color: 'standard'
                },
                style: {
                    [`&.${(0, $3cuAs.default).selected}`]: {
                        color: (theme.vars || theme).palette.text.primary,
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity),
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8gMkr.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity)
                            }
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $3cuAs.default).selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity),
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity)
                                }
                            }
                        }
                    }
                })),
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 7,
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 15,
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $ab85d69438d76ec5$var$ToggleButton = /*#__PURE__*/ $acw62.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const { value: contextValue, ...contextProps } = $acw62.useContext((0, $lOkLt.default));
    const toggleButtonGroupButtonContextPositionClassName = $acw62.useContext((0, $jCUp4.default));
    const resolvedProps = (0, $4FZD0.default)({
        ...contextProps,
        selected: (0, $d0d3x.default)(inProps.value, contextValue)
    }, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    };
    const classes = $ab85d69438d76ec5$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab85d69438d76ec5$var$ToggleButtonRoot, {
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected,
        ...other,
        children: children
    });
});
var $ab85d69438d76ec5$export$2e2bcd8739ae039 = $ab85d69438d76ec5$var$ToggleButton;

});
parcelRegister("3cuAs", function(module, exports) {

$parcel$export(module.exports, "getToggleButtonUtilityClass", () => $254a3802f36599bb$export$21f89b560b65a301);
$parcel$export(module.exports, "default", () => $254a3802f36599bb$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $254a3802f36599bb$export$21f89b560b65a301(slot) {
    return (0, $4Cod0.default)('MuiToggleButton', slot);
}
const $254a3802f36599bb$var$toggleButtonClasses = (0, $beCSm.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $254a3802f36599bb$export$2e2bcd8739ae039 = $254a3802f36599bb$var$toggleButtonClasses;

});

parcelRegister("lOkLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0e5fe90030f3ad$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $fe0e5fe90030f3ad$var$ToggleButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $fe0e5fe90030f3ad$export$2e2bcd8739ae039 = $fe0e5fe90030f3ad$var$ToggleButtonGroupContext;

});

parcelRegister("jCUp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49d517bbbfb7eee$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $e49d517bbbfb7eee$export$2e2bcd8739ae039 = $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext;

});

parcelRegister("d0d3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9775671ab3ebd2db$export$2e2bcd8739ae039);
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $9775671ab3ebd2db$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.includes(value);
    return value === candidate;
}

});


parcelRegister("9ZYXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7479184c3cda7f5d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $djmpM = parcelRequire("djmpM");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $i9RU8 = parcelRequire("i9RU8");

var $lOkLt = parcelRequire("lOkLt");

var $jCUp4 = parcelRequire("jCUp4");

var $3cuAs = parcelRequire("3cuAs");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7479184c3cda7f5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $jTnBY.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $i9RU8.getToggleButtonGroupUtilityClass), classes);
};
const $7479184c3cda7f5d$var$ToggleButtonGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $i9RU8.default).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $i9RU8.default).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $i9RU8.default).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $i9RU8.default).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $i9RU8.default).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $i9RU8.default).grouped}`]: {
                        [`&.${(0, $i9RU8.default).selected} + .${(0, $i9RU8.default).grouped}.${(0, $i9RU8.default).selected}`]: {
                            borderTop: 0,
                            marginTop: 0
                        }
                    },
                    [`& .${(0, $i9RU8.default).firstButton},& .${(0, $i9RU8.default).middleButton}`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $i9RU8.default).lastButton},& .${(0, $i9RU8.default).middleButton}`]: {
                        marginTop: -1,
                        borderTop: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                    [`& .${(0, $i9RU8.default).lastButton}.${(0, $3cuAs.default).disabled},& .${(0, $i9RU8.default).middleButton}.${(0, $3cuAs.default).disabled}`]: {
                        borderTop: '1px solid transparent'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $i9RU8.default).grouped}`]: {
                        [`&.${(0, $i9RU8.default).selected} + .${(0, $i9RU8.default).grouped}.${(0, $i9RU8.default).selected}`]: {
                            borderLeft: 0,
                            marginLeft: 0
                        }
                    },
                    [`& .${(0, $i9RU8.default).firstButton},& .${(0, $i9RU8.default).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $i9RU8.default).lastButton},& .${(0, $i9RU8.default).middleButton}`]: {
                        marginLeft: -1,
                        borderLeft: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    },
                    [`& .${(0, $i9RU8.default).lastButton}.${(0, $3cuAs.default).disabled},& .${(0, $i9RU8.default).middleButton}.${(0, $3cuAs.default).disabled}`]: {
                        borderLeft: '1px solid transparent'
                    }
                }
            }
        ]
    })));
const $7479184c3cda7f5d$var$ToggleButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    };
    const classes = $7479184c3cda7f5d$var$useUtilityClasses(ownerState);
    const handleChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $djmpM.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$ToggleButtonGroupRoot, {
        role: "group",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOkLt.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jCUp4.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $7479184c3cda7f5d$export$2e2bcd8739ae039 = $7479184c3cda7f5d$var$ToggleButtonGroup;

});
parcelRegister("djmpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b0e6fd5d31b1b95$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $9b0e6fd5d31b1b95$export$2e2bcd8739ae039(children) {
    return $acw62.Children.toArray(children).filter((child)=>/*#__PURE__*/ $acw62.isValidElement(child));
}

});

parcelRegister("i9RU8", function(module, exports) {

$parcel$export(module.exports, "getToggleButtonGroupUtilityClass", () => $d382e18949ecbd32$export$44aa3ae5b353cef1);
$parcel$export(module.exports, "default", () => $d382e18949ecbd32$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d382e18949ecbd32$export$44aa3ae5b353cef1(slot) {
    return (0, $4Cod0.default)('MuiToggleButtonGroup', slot);
}
const $d382e18949ecbd32$var$toggleButtonGroupClasses = (0, $beCSm.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $d382e18949ecbd32$export$2e2bcd8739ae039 = $d382e18949ecbd32$var$toggleButtonGroupClasses;

});


parcelRegister("78ow6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "AdapterDateFns", {
    enumerable: true,
    get: function() {
        return $dZo3Q.AdapterDateFns;
    }
});

var $dZo3Q = parcelRequire("dZo3Q");

});
parcelRegister("dZo3Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdapterDateFns = void 0;

var $e1kwM = parcelRequire("e1kwM");

var $kiEfO = parcelRequire("kiEfO");

var $jZtIs = parcelRequire("jZtIs");

var $iMX5A = parcelRequire("iMX5A");

var $gdvs1 = parcelRequire("gdvs1");

var $cls5f = parcelRequire("cls5f");

var $3cpd6 = parcelRequire("3cpd6");

var $fG9DL = parcelRequire("fG9DL");

var $iiR1c = parcelRequire("iiR1c");

var $9kRZo = parcelRequire("9kRZo");

var $48K34 = parcelRequire("48K34");

var $inqX7 = parcelRequire("inqX7");

var $7uieS = parcelRequire("7uieS");

var $lIpMn = parcelRequire("lIpMn");

var $12jbR = parcelRequire("12jbR");

var $9xRRE = parcelRequire("9xRRE");

var $ebQpN = parcelRequire("ebQpN");

var $c1AiI = parcelRequire("c1AiI");

var $1wdT6 = parcelRequire("1wdT6");

var $5CRrs = parcelRequire("5CRrs");

var $aFxrf = parcelRequire("aFxrf");

var $i5nf8 = parcelRequire("i5nf8");

var $aw1Xf = parcelRequire("aw1Xf");

var $3p5lI = parcelRequire("3p5lI");

var $ea2hS = parcelRequire("ea2hS");

var $AFgUD = parcelRequire("AFgUD");

var $5hZu1 = parcelRequire("5hZu1");

var $kPCB6 = parcelRequire("kPCB6");

var $bUtct = parcelRequire("bUtct");

var $jD0I3 = parcelRequire("jD0I3");

var $8l96w = parcelRequire("8l96w");

var $JJ6gI = parcelRequire("JJ6gI");

var $1VSw7 = parcelRequire("1VSw7");

var $f23Gj = parcelRequire("f23Gj");

var $iOqGj = parcelRequire("iOqGj");

var $75Jn2 = parcelRequire("75Jn2");

var $fH0a1 = parcelRequire("fH0a1");

var $gxLWY = parcelRequire("gxLWY");

var $jHGP1 = parcelRequire("jHGP1");

var $8ple2 = parcelRequire("8ple2");

var $3Au2i = parcelRequire("3Au2i");

var $dzPMY = parcelRequire("dzPMY");

var $hBsHh = parcelRequire("hBsHh");

var $a8CH1 = parcelRequire("a8CH1");
/**
 * Based on `@date-io/date-fns`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ class $a2f3a2e6b4ef1860$var$AdapterDateFns extends $a8CH1.AdapterDateFnsBase {
    constructor({ locale: locale, formats: formats } = {}){
        /* v8 ignore stop */ super({
            locale: locale ?? $hBsHh.enUS,
            formats: formats,
            longFormatters: $48K34.longFormatters
        });
    }
    // TODO: explicit return types can be removed once there is only one date-fns version supported
    parse = (value, format)=>{
        if (value === '') return null;
        return (0, $bUtct.parse)(value, format, new Date(), {
            locale: this.locale
        });
    };
    isValid = (value)=>{
        if (value == null) return false;
        return (0, $kPCB6.isValid)(value);
    };
    format = (value, formatKey)=>{
        return this.formatByString(value, this.formats[formatKey]);
    };
    formatByString = (value, formatString)=>{
        return (0, $48K34.format)(value, formatString, {
            locale: this.locale
        });
    };
    isEqual = (value, comparing)=>{
        if (value === null && comparing === null) return true;
        if (value === null || comparing === null) return false;
        return (0, $aw1Xf.isEqual)(value, comparing);
    };
    isSameYear = (value, comparing)=>{
        return (0, $ea2hS.isSameYear)(value, comparing);
    };
    isSameMonth = (value, comparing)=>{
        return (0, $AFgUD.isSameMonth)(value, comparing);
    };
    isSameDay = (value, comparing)=>{
        return (0, $3p5lI.isSameDay)(value, comparing);
    };
    isSameHour = (value, comparing)=>{
        return (0, $5hZu1.isSameHour)(value, comparing);
    };
    isAfter = (value, comparing)=>{
        return (0, $aFxrf.isAfter)(value, comparing);
    };
    isAfterYear = (value, comparing)=>{
        return (0, $aFxrf.isAfter)(value, (0, $9kRZo.endOfYear)(comparing));
    };
    isAfterDay = (value, comparing)=>{
        return (0, $aFxrf.isAfter)(value, (0, $fG9DL.endOfDay)(comparing));
    };
    isBefore = (value, comparing)=>{
        return (0, $i5nf8.isBefore)(value, comparing);
    };
    isBeforeYear = (value, comparing)=>{
        return (0, $i5nf8.isBefore)(value, this.startOfYear(comparing));
    };
    isBeforeDay = (value, comparing)=>{
        return (0, $i5nf8.isBefore)(value, this.startOfDay(comparing));
    };
    isWithinRange = (value, [start, end])=>{
        return (0, $dzPMY.isWithinInterval)(value, {
            start: start,
            end: end
        });
    };
    startOfYear = (value)=>{
        return (0, $3Au2i.startOfYear)(value);
    };
    startOfMonth = (value)=>{
        return (0, $gxLWY.startOfMonth)(value);
    };
    startOfWeek = (value)=>{
        return (0, $8ple2.startOfWeek)(value, {
            locale: this.locale
        });
    };
    startOfDay = (value)=>{
        return (0, $fH0a1.startOfDay)(value);
    };
    endOfYear = (value)=>{
        return (0, $9kRZo.endOfYear)(value);
    };
    endOfMonth = (value)=>{
        return (0, $jHGP1.endOfMonth)(value);
    };
    endOfWeek = (value)=>{
        return (0, $iiR1c.endOfWeek)(value, {
            locale: this.locale
        });
    };
    endOfDay = (value)=>{
        return (0, $fG9DL.endOfDay)(value);
    };
    addYears = (value, amount)=>{
        return (0, $3cpd6.addYears)(value, amount);
    };
    addMonths = (value, amount)=>{
        return (0, $cls5f.addMonths)(value, amount);
    };
    addWeeks = (value, amount)=>{
        return (0, $gdvs1.addWeeks)(value, amount);
    };
    addDays = (value, amount)=>{
        return (0, $e1kwM.addDays)(value, amount);
    };
    addHours = (value, amount)=>{
        return (0, $iMX5A.addHours)(value, amount);
    };
    addMinutes = (value, amount)=>{
        return (0, $jZtIs.addMinutes)(value, amount);
    };
    addSeconds = (value, amount)=>{
        return (0, $kiEfO.addSeconds)(value, amount);
    };
    getYear = (value)=>{
        return (0, $5CRrs.getYear)(value);
    };
    getMonth = (value)=>{
        return (0, $9xRRE.getMonth)(value);
    };
    getDate = (value)=>{
        return (0, $inqX7.getDate)(value);
    };
    getHours = (value)=>{
        return (0, $lIpMn.getHours)(value);
    };
    getMinutes = (value)=>{
        return (0, $12jbR.getMinutes)(value);
    };
    getSeconds = (value)=>{
        return (0, $ebQpN.getSeconds)(value);
    };
    getMilliseconds = (value)=>{
        return (0, $c1AiI.getMilliseconds)(value);
    };
    setYear = (value, year)=>{
        return (0, $75Jn2.setYear)(value, year);
    };
    setMonth = (value, month)=>{
        return (0, $1VSw7.setMonth)(value, month);
    };
    setDate = (value, date)=>{
        return (0, $jD0I3.setDate)(value, date);
    };
    setHours = (value, hours)=>{
        return (0, $8l96w.setHours)(value, hours);
    };
    setMinutes = (value, minutes)=>{
        return (0, $JJ6gI.setMinutes)(value, minutes);
    };
    setSeconds = (value, seconds)=>{
        return (0, $f23Gj.setSeconds)(value, seconds);
    };
    setMilliseconds = (value, milliseconds)=>{
        return (0, $iOqGj.setMilliseconds)(value, milliseconds);
    };
    getDaysInMonth = (value)=>{
        return (0, $7uieS.getDaysInMonth)(value);
    };
    getWeekArray = (value)=>{
        const start = this.startOfWeek(this.startOfMonth(value));
        const end = this.endOfWeek(this.endOfMonth(value));
        let count = 0;
        let current = start;
        const nestedWeeks = [];
        while(this.isBefore(current, end)){
            const weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = this.addDays(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    getWeekNumber = (value)=>{
        return (0, $1wdT6.getWeek)(value, {
            locale: this.locale
        });
    };
    getYearRange = ([start, end])=>{
        const startDate = this.startOfYear(start);
        const endDate = this.endOfYear(end);
        const years = [];
        let current = startDate;
        while(this.isBefore(current, endDate)){
            years.push(current);
            current = this.addYears(current, 1);
        }
        return years;
    };
}
module.exports.AdapterDateFns = $a2f3a2e6b4ef1860$var$AdapterDateFns;

});
parcelRegister("e1kwM", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $a351150ce2eb3ddb$export$dd412b56f1e4d8aa, (v) => $a351150ce2eb3ddb$export$dd412b56f1e4d8aa = v);
var $a351150ce2eb3ddb$export$dd412b56f1e4d8aa;
"use strict";
$a351150ce2eb3ddb$export$dd412b56f1e4d8aa = $a351150ce2eb3ddb$var$addDays;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $a351150ce2eb3ddb$var$addDays(date, amount) {
    const _date = (0, $30SVQ.toDate)(date);
    if (isNaN(amount)) return (0, $eK5z7.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});
parcelRegister("30SVQ", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $231bfb8d72679740$export$e67a095c620b86fe, (v) => $231bfb8d72679740$export$e67a095c620b86fe = v);
var $231bfb8d72679740$export$e67a095c620b86fe;
"use strict";
$231bfb8d72679740$export$e67a095c620b86fe = $231bfb8d72679740$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $231bfb8d72679740$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});

parcelRegister("eK5z7", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $abb9adbdb26342b3$export$ead8a1812b171991, (v) => $abb9adbdb26342b3$export$ead8a1812b171991 = v);
var $abb9adbdb26342b3$export$ead8a1812b171991;
"use strict";
$abb9adbdb26342b3$export$ead8a1812b171991 = $abb9adbdb26342b3$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $abb9adbdb26342b3$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});


parcelRegister("kiEfO", function(module, exports) {

$parcel$export(module.exports, "addSeconds", () => $ec74b6b01c6372f4$export$3cb31b0df13be68, (v) => $ec74b6b01c6372f4$export$3cb31b0df13be68 = v);
var $ec74b6b01c6372f4$export$3cb31b0df13be68;
"use strict";
$ec74b6b01c6372f4$export$3cb31b0df13be68 = $ec74b6b01c6372f4$var$addSeconds;

var $dR7TY = parcelRequire("dR7TY");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $ec74b6b01c6372f4$var$addSeconds(date, amount) {
    return (0, $dR7TY.addMilliseconds)(date, amount * 1000);
}

});
parcelRegister("dR7TY", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", () => $a1665abf6052bbc9$export$baf757aaf0c95c94, (v) => $a1665abf6052bbc9$export$baf757aaf0c95c94 = v);
var $a1665abf6052bbc9$export$baf757aaf0c95c94;
"use strict";
$a1665abf6052bbc9$export$baf757aaf0c95c94 = $a1665abf6052bbc9$var$addMilliseconds;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $a1665abf6052bbc9$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $30SVQ.toDate)(date);
    return (0, $eK5z7.constructFrom)(date, timestamp + amount);
}

});


parcelRegister("jZtIs", function(module, exports) {

$parcel$export(module.exports, "addMinutes", () => $e8dac3cf5df5dbc8$export$2287e3d29250119e, (v) => $e8dac3cf5df5dbc8$export$2287e3d29250119e = v);
var $e8dac3cf5df5dbc8$export$2287e3d29250119e;
"use strict";
$e8dac3cf5df5dbc8$export$2287e3d29250119e = $e8dac3cf5df5dbc8$var$addMinutes;

var $dR7TY = parcelRequire("dR7TY");

var $briB4 = parcelRequire("briB4");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $e8dac3cf5df5dbc8$var$addMinutes(date, amount) {
    return (0, $dR7TY.addMilliseconds)(date, amount * $briB4.millisecondsInMinute);
}

});
parcelRegister("briB4", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", () => $8540a44f59a4af84$export$4fad13613e88edc8, (v) => $8540a44f59a4af84$export$4fad13613e88edc8 = v);
$parcel$export(module.exports, "millisecondsInSecond", () => $8540a44f59a4af84$export$397c2d5776aa9055, (v) => $8540a44f59a4af84$export$397c2d5776aa9055 = v);
$parcel$export(module.exports, "millisecondsInMinute", () => $8540a44f59a4af84$export$91246f0b9bd9beff, (v) => $8540a44f59a4af84$export$91246f0b9bd9beff = v);
$parcel$export(module.exports, "millisecondsInHour", () => $8540a44f59a4af84$export$7f72910d6dfd237a, (v) => $8540a44f59a4af84$export$7f72910d6dfd237a = v);
$parcel$export(module.exports, "millisecondsInDay", () => $8540a44f59a4af84$export$b76b1809a2898f9a, (v) => $8540a44f59a4af84$export$b76b1809a2898f9a = v);
var $8540a44f59a4af84$export$7271e9e3478110d1;
var $8540a44f59a4af84$export$34804a017b31e2fe;
var $8540a44f59a4af84$export$be1dccf2de902d31;
var $8540a44f59a4af84$export$8e6600bbdee7dabb;
var $8540a44f59a4af84$export$a77c1a7ebebe2a5a;
var $8540a44f59a4af84$export$698aec755e92c695;
var $8540a44f59a4af84$export$815a9362476d2fe3;
var $8540a44f59a4af84$export$4db7641526e3241f;
var $8540a44f59a4af84$export$80d7e435f744f319;
var $8540a44f59a4af84$export$3c58128db900d44e;
var $8540a44f59a4af84$export$3633035e63cee86a;
var $8540a44f59a4af84$export$ab7da2ccd1075c38;
var $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f;
var $8540a44f59a4af84$export$2423174df8cd3cd2;
var $8540a44f59a4af84$export$4dec998e48f9c246;
var $8540a44f59a4af84$export$4fad13613e88edc8;
var $8540a44f59a4af84$export$397c2d5776aa9055;
var $8540a44f59a4af84$export$91246f0b9bd9beff;
var $8540a44f59a4af84$export$7f72910d6dfd237a;
var $8540a44f59a4af84$export$b76b1809a2898f9a;
var $8540a44f59a4af84$export$81caae6e1cc7a622;
var $8540a44f59a4af84$export$3913210603d8e9ae;
var $8540a44f59a4af84$export$dfd9b671c89acc8e;
"use strict";
$8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$export$a77c1a7ebebe2a5a = $8540a44f59a4af84$export$698aec755e92c695 = $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$export$4db7641526e3241f = $8540a44f59a4af84$export$80d7e435f744f319 = $8540a44f59a4af84$export$3c58128db900d44e = $8540a44f59a4af84$export$3633035e63cee86a = $8540a44f59a4af84$export$ab7da2ccd1075c38 = $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = $8540a44f59a4af84$export$2423174df8cd3cd2 = $8540a44f59a4af84$export$4dec998e48f9c246 = $8540a44f59a4af84$export$4fad13613e88edc8 = $8540a44f59a4af84$export$397c2d5776aa9055 = $8540a44f59a4af84$export$91246f0b9bd9beff = $8540a44f59a4af84$export$7f72910d6dfd237a = $8540a44f59a4af84$export$b76b1809a2898f9a = $8540a44f59a4af84$export$81caae6e1cc7a622 = $8540a44f59a4af84$export$3913210603d8e9ae = $8540a44f59a4af84$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8540a44f59a4af84$var$daysInWeek = $8540a44f59a4af84$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $8540a44f59a4af84$var$daysInYear = $8540a44f59a4af84$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $8540a44f59a4af84$var$maxTime = $8540a44f59a4af84$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $8540a44f59a4af84$var$minTime = $8540a44f59a4af84$export$4dec998e48f9c246 = -$8540a44f59a4af84$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $8540a44f59a4af84$var$millisecondsInWeek = $8540a44f59a4af84$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $8540a44f59a4af84$var$millisecondsInDay = $8540a44f59a4af84$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $8540a44f59a4af84$var$millisecondsInMinute = $8540a44f59a4af84$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $8540a44f59a4af84$var$millisecondsInHour = $8540a44f59a4af84$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $8540a44f59a4af84$var$millisecondsInSecond = $8540a44f59a4af84$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $8540a44f59a4af84$var$minutesInYear = $8540a44f59a4af84$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $8540a44f59a4af84$var$minutesInMonth = $8540a44f59a4af84$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $8540a44f59a4af84$var$minutesInDay = $8540a44f59a4af84$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $8540a44f59a4af84$var$minutesInHour = $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $8540a44f59a4af84$var$monthsInQuarter = $8540a44f59a4af84$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $8540a44f59a4af84$var$monthsInYear = $8540a44f59a4af84$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $8540a44f59a4af84$var$quartersInYear = $8540a44f59a4af84$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $8540a44f59a4af84$var$secondsInHour = $8540a44f59a4af84$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $8540a44f59a4af84$var$secondsInMinute = $8540a44f59a4af84$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $8540a44f59a4af84$var$secondsInDay = $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $8540a44f59a4af84$var$secondsInWeek = $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $8540a44f59a4af84$var$secondsInYear = $8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$var$secondsInDay * $8540a44f59a4af84$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $8540a44f59a4af84$var$secondsInMonth = $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $8540a44f59a4af84$var$secondsInQuarter = $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$var$secondsInMonth * 3;

});


parcelRegister("iMX5A", function(module, exports) {

$parcel$export(module.exports, "addHours", () => $dada8b88b0873e8d$export$4a4306ad4fa0e5e6, (v) => $dada8b88b0873e8d$export$4a4306ad4fa0e5e6 = v);
var $dada8b88b0873e8d$export$4a4306ad4fa0e5e6;
"use strict";
$dada8b88b0873e8d$export$4a4306ad4fa0e5e6 = $dada8b88b0873e8d$var$addHours;

var $dR7TY = parcelRequire("dR7TY");

var $briB4 = parcelRequire("briB4");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $dada8b88b0873e8d$var$addHours(date, amount) {
    return (0, $dR7TY.addMilliseconds)(date, amount * $briB4.millisecondsInHour);
}

});

parcelRegister("gdvs1", function(module, exports) {

$parcel$export(module.exports, "addWeeks", () => $bce641bd93181421$export$ef501a2bb4f3ee6b, (v) => $bce641bd93181421$export$ef501a2bb4f3ee6b = v);
var $bce641bd93181421$export$ef501a2bb4f3ee6b;
"use strict";
$bce641bd93181421$export$ef501a2bb4f3ee6b = $bce641bd93181421$var$addWeeks;

var $e1kwM = parcelRequire("e1kwM");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $bce641bd93181421$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $e1kwM.addDays)(date, days);
}

});

parcelRegister("cls5f", function(module, exports) {

$parcel$export(module.exports, "addMonths", () => $8fcd3b0bf5df7635$export$17c93e242b2d3a22, (v) => $8fcd3b0bf5df7635$export$17c93e242b2d3a22 = v);
var $8fcd3b0bf5df7635$export$17c93e242b2d3a22;
"use strict";
$8fcd3b0bf5df7635$export$17c93e242b2d3a22 = $8fcd3b0bf5df7635$var$addMonths;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $8fcd3b0bf5df7635$var$addMonths(date, amount) {
    const _date = (0, $30SVQ.toDate)(date);
    if (isNaN(amount)) return (0, $eK5z7.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $eK5z7.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});

parcelRegister("3cpd6", function(module, exports) {

$parcel$export(module.exports, "addYears", () => $25460c542fb3bf74$export$3d83eec43f4ea476, (v) => $25460c542fb3bf74$export$3d83eec43f4ea476 = v);
var $25460c542fb3bf74$export$3d83eec43f4ea476;
"use strict";
$25460c542fb3bf74$export$3d83eec43f4ea476 = $25460c542fb3bf74$var$addYears;

var $cls5f = parcelRequire("cls5f");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $25460c542fb3bf74$var$addYears(date, amount) {
    return (0, $cls5f.addMonths)(date, amount * 12);
}

});

parcelRegister("fG9DL", function(module, exports) {

$parcel$export(module.exports, "endOfDay", () => $b6a2419fd0059687$export$eb9a03f0e9aa6cea, (v) => $b6a2419fd0059687$export$eb9a03f0e9aa6cea = v);
var $b6a2419fd0059687$export$eb9a03f0e9aa6cea;
"use strict";
$b6a2419fd0059687$export$eb9a03f0e9aa6cea = $b6a2419fd0059687$var$endOfDay;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $b6a2419fd0059687$var$endOfDay(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("iiR1c", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", () => $d53308c42f1e4c62$export$ef8b6d9133084f4e, (v) => $d53308c42f1e4c62$export$ef8b6d9133084f4e = v);
var $d53308c42f1e4c62$export$ef8b6d9133084f4e;
"use strict";
$d53308c42f1e4c62$export$ef8b6d9133084f4e = $d53308c42f1e4c62$var$endOfWeek;

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $d53308c42f1e4c62$var$endOfWeek(date, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $30SVQ.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});
parcelRegister("4UP3S", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $39440020b58e1ef8$export$430a3269e24b912e, (v) => $39440020b58e1ef8$export$430a3269e24b912e = v);
var $39440020b58e1ef8$export$430a3269e24b912e;
var $39440020b58e1ef8$export$95365be1b0704abc;
"use strict";
$39440020b58e1ef8$export$430a3269e24b912e = $39440020b58e1ef8$var$getDefaultOptions;
$39440020b58e1ef8$export$95365be1b0704abc = $39440020b58e1ef8$var$setDefaultOptions;
let $39440020b58e1ef8$var$defaultOptions = {};
function $39440020b58e1ef8$var$getDefaultOptions() {
    return $39440020b58e1ef8$var$defaultOptions;
}
function $39440020b58e1ef8$var$setDefaultOptions(newOptions) {
    $39440020b58e1ef8$var$defaultOptions = newOptions;
}

});


parcelRegister("9kRZo", function(module, exports) {

$parcel$export(module.exports, "endOfYear", () => $6cbfdc6d008595cd$export$8b7aa55c66d5569e, (v) => $6cbfdc6d008595cd$export$8b7aa55c66d5569e = v);
var $6cbfdc6d008595cd$export$8b7aa55c66d5569e;
"use strict";
$6cbfdc6d008595cd$export$8b7aa55c66d5569e = $6cbfdc6d008595cd$var$endOfYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $6cbfdc6d008595cd$var$endOfYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("48K34", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $303ba10db2c74ab4$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $02Zw7.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $7hoR9.longFormatters;
    }
});

var $k1YNI = parcelRequire("k1YNI");

var $4UP3S = parcelRequire("4UP3S");

var $02Zw7 = parcelRequire("02Zw7");

var $7hoR9 = parcelRequire("7hoR9");

var $aRzsd = parcelRequire("aRzsd");

var $kPCB6 = parcelRequire("kPCB6");

var $30SVQ = parcelRequire("30SVQ");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $303ba10db2c74ab4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $303ba10db2c74ab4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $303ba10db2c74ab4$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $303ba10db2c74ab4$var$doubleQuoteRegExp = /''/g;
const $303ba10db2c74ab4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $303ba10db2c74ab4$var$format(date, formatStr, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $k1YNI.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $30SVQ.toDate)(date);
    if (!(0, $kPCB6.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($303ba10db2c74ab4$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $7hoR9.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($303ba10db2c74ab4$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $303ba10db2c74ab4$var$cleanEscapedString(substring)
        };
        if ($02Zw7.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($303ba10db2c74ab4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $aRzsd.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $aRzsd.isProtectedDayOfYearToken)(token)) (0, $aRzsd.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $02Zw7.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $303ba10db2c74ab4$var$cleanEscapedString(input) {
    const matched = input.match($303ba10db2c74ab4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($303ba10db2c74ab4$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("k1YNI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $hBsHh.enUS;
    }
});

var $hBsHh = parcelRequire("hBsHh");

});
parcelRegister("hBsHh", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $cd0c27002eb93234$export$137380d9ce54f7f, (v) => $cd0c27002eb93234$export$137380d9ce54f7f = v);
var $cd0c27002eb93234$export$137380d9ce54f7f;
"use strict";
$cd0c27002eb93234$export$137380d9ce54f7f = void 0;

var $10Jzk = parcelRequire("10Jzk");

var $8yY6E = parcelRequire("8yY6E");

var $l2ZM0 = parcelRequire("l2ZM0");

var $ke9K7 = parcelRequire("ke9K7");

var $i71E4 = parcelRequire("i71E4");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $cd0c27002eb93234$var$enUS = $cd0c27002eb93234$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $10Jzk.formatDistance,
    formatLong: $8yY6E.formatLong,
    formatRelative: $l2ZM0.formatRelative,
    localize: $ke9K7.localize,
    match: $i71E4.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("10Jzk", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $0bc92389da5ca8f2$export$2c14ff85d6318973, (v) => $0bc92389da5ca8f2$export$2c14ff85d6318973 = v);
var $0bc92389da5ca8f2$export$2c14ff85d6318973;
"use strict";
$0bc92389da5ca8f2$export$2c14ff85d6318973 = void 0;
const $0bc92389da5ca8f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0bc92389da5ca8f2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $0bc92389da5ca8f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$0bc92389da5ca8f2$export$2c14ff85d6318973 = $0bc92389da5ca8f2$var$formatDistance;

});

parcelRegister("8yY6E", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $63c01f9040a729a9$export$cbf60ecb96cbb82f, (v) => $63c01f9040a729a9$export$cbf60ecb96cbb82f = v);
var $63c01f9040a729a9$export$cbf60ecb96cbb82f;
"use strict";
$63c01f9040a729a9$export$cbf60ecb96cbb82f = void 0;

var $64fKv = parcelRequire("64fKv");
const $63c01f9040a729a9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $63c01f9040a729a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $63c01f9040a729a9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63c01f9040a729a9$var$formatLong = $63c01f9040a729a9$export$cbf60ecb96cbb82f = {
    date: (0, $64fKv.buildFormatLongFn)({
        formats: $63c01f9040a729a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $64fKv.buildFormatLongFn)({
        formats: $63c01f9040a729a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $64fKv.buildFormatLongFn)({
        formats: $63c01f9040a729a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("64fKv", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $46af55383084911e$export$38e44e97ce4dbb7d, (v) => $46af55383084911e$export$38e44e97ce4dbb7d = v);
var $46af55383084911e$export$38e44e97ce4dbb7d;
"use strict";
$46af55383084911e$export$38e44e97ce4dbb7d = $46af55383084911e$var$buildFormatLongFn;
function $46af55383084911e$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("l2ZM0", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $f529b3bee3f6d835$export$8fbbfd65594f46a0, (v) => $f529b3bee3f6d835$export$8fbbfd65594f46a0 = v);
var $f529b3bee3f6d835$export$8fbbfd65594f46a0;
"use strict";
$f529b3bee3f6d835$export$8fbbfd65594f46a0 = void 0;
const $f529b3bee3f6d835$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f529b3bee3f6d835$var$formatRelative = (token, _date, _baseDate, _options)=>$f529b3bee3f6d835$var$formatRelativeLocale[token];
$f529b3bee3f6d835$export$8fbbfd65594f46a0 = $f529b3bee3f6d835$var$formatRelative;

});

parcelRegister("ke9K7", function(module, exports) {

$parcel$export(module.exports, "localize", () => $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63, (v) => $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = v);
var $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63;
"use strict";
$eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = void 0;

var $4WM5U = parcelRequire("4WM5U");
const $eb9cac2ee97a0b54$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $eb9cac2ee97a0b54$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eb9cac2ee97a0b54$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $eb9cac2ee97a0b54$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $eb9cac2ee97a0b54$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $eb9cac2ee97a0b54$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $eb9cac2ee97a0b54$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $eb9cac2ee97a0b54$var$localize = $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eb9cac2ee97a0b54$var$ordinalNumber,
    era: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eb9cac2ee97a0b54$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("4WM5U", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $39a1e2b6239b09b3$export$63596d6ee8878b25, (v) => $39a1e2b6239b09b3$export$63596d6ee8878b25 = v);
var $39a1e2b6239b09b3$export$63596d6ee8878b25;
"use strict";
$39a1e2b6239b09b3$export$63596d6ee8878b25 = $39a1e2b6239b09b3$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $39a1e2b6239b09b3$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("i71E4", function(module, exports) {

$parcel$export(module.exports, "match", () => $d2fa28259adb3ab1$export$4659b591c19bdf3d, (v) => $d2fa28259adb3ab1$export$4659b591c19bdf3d = v);
var $d2fa28259adb3ab1$export$4659b591c19bdf3d;
"use strict";
$d2fa28259adb3ab1$export$4659b591c19bdf3d = void 0;

var $jEhBR = parcelRequire("jEhBR");

var $3e2wr = parcelRequire("3e2wr");
const $d2fa28259adb3ab1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2fa28259adb3ab1$var$parseOrdinalNumberPattern = /\d+/i;
const $d2fa28259adb3ab1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2fa28259adb3ab1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2fa28259adb3ab1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2fa28259adb3ab1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2fa28259adb3ab1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2fa28259adb3ab1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2fa28259adb3ab1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2fa28259adb3ab1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2fa28259adb3ab1$var$match = $d2fa28259adb3ab1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $3e2wr.buildMatchPatternFn)({
        matchPattern: $d2fa28259adb3ab1$var$matchOrdinalNumberPattern,
        parsePattern: $d2fa28259adb3ab1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("jEhBR", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $e4df69a5a2d494a3$export$1430a0f35710914d, (v) => $e4df69a5a2d494a3$export$1430a0f35710914d = v);
var $e4df69a5a2d494a3$export$1430a0f35710914d;
"use strict";
$e4df69a5a2d494a3$export$1430a0f35710914d = $e4df69a5a2d494a3$var$buildMatchFn;
function $e4df69a5a2d494a3$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e4df69a5a2d494a3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e4df69a5a2d494a3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e4df69a5a2d494a3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e4df69a5a2d494a3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("3e2wr", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $2594a2c0202dabc6$export$fdaf2fd6d7edde95, (v) => $2594a2c0202dabc6$export$fdaf2fd6d7edde95 = v);
var $2594a2c0202dabc6$export$fdaf2fd6d7edde95;
"use strict";
$2594a2c0202dabc6$export$fdaf2fd6d7edde95 = $2594a2c0202dabc6$var$buildMatchPatternFn;
function $2594a2c0202dabc6$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("02Zw7", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $008fe800ab658844$export$fe98a034cfb96d55, (v) => $008fe800ab658844$export$fe98a034cfb96d55 = v);
var $008fe800ab658844$export$fe98a034cfb96d55;
"use strict";
$008fe800ab658844$export$fe98a034cfb96d55 = void 0;

var $49JO2 = parcelRequire("49JO2");

var $bjZpy = parcelRequire("bjZpy");

var $hhS6V = parcelRequire("hhS6V");

var $1wdT6 = parcelRequire("1wdT6");

var $7Fy3C = parcelRequire("7Fy3C");

var $krIED = parcelRequire("krIED");

var $9KWEw = parcelRequire("9KWEw");
const $008fe800ab658844$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $008fe800ab658844$var$formatters = $008fe800ab658844$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $9KWEw.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $7Fy3C.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $krIED.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $krIED.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $hhS6V.getISOWeekYear)(date);
        // Padding
        return (0, $krIED.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $krIED.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $krIED.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $krIED.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $9KWEw.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $krIED.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $1wdT6.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $krIED.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $bjZpy.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $krIED.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $9KWEw.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $49JO2.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $krIED.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $krIED.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $krIED.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $krIED.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $9KWEw.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $9KWEw.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $krIED.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $krIED.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $9KWEw.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $9KWEw.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $9KWEw.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $krIED.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $krIED.addLeadingZeros)(timestamp, token.length);
    }
};
function $008fe800ab658844$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $krIED.addLeadingZeros)(minutes, 2);
}
function $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $krIED.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $008fe800ab658844$var$formatTimezone(offset, delimiter);
}
function $008fe800ab658844$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $krIED.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $krIED.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("49JO2", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $306b88ce50904f9c$export$d3b42cd8452deec, (v) => $306b88ce50904f9c$export$d3b42cd8452deec = v);
var $306b88ce50904f9c$export$d3b42cd8452deec;
"use strict";
$306b88ce50904f9c$export$d3b42cd8452deec = $306b88ce50904f9c$var$getDayOfYear;

var $9UMYl = parcelRequire("9UMYl");

var $3Au2i = parcelRequire("3Au2i");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $306b88ce50904f9c$var$getDayOfYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = (0, $9UMYl.differenceInCalendarDays)(_date, (0, $3Au2i.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});
parcelRegister("9UMYl", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $737f54e9ffaddc15$export$4a02e9c37dab4871, (v) => $737f54e9ffaddc15$export$4a02e9c37dab4871 = v);
var $737f54e9ffaddc15$export$4a02e9c37dab4871;
"use strict";
$737f54e9ffaddc15$export$4a02e9c37dab4871 = $737f54e9ffaddc15$var$differenceInCalendarDays;

var $briB4 = parcelRequire("briB4");

var $fH0a1 = parcelRequire("fH0a1");

var $cBJez = parcelRequire("cBJez");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $737f54e9ffaddc15$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $fH0a1.startOfDay)(dateLeft);
    const startOfDayRight = (0, $fH0a1.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $cBJez.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $cBJez.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $briB4.millisecondsInDay);
}

});
parcelRegister("fH0a1", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $b6caff0bf13dcaf5$export$63fa379ae8a9ba2, (v) => $b6caff0bf13dcaf5$export$63fa379ae8a9ba2 = v);
var $b6caff0bf13dcaf5$export$63fa379ae8a9ba2;
"use strict";
$b6caff0bf13dcaf5$export$63fa379ae8a9ba2 = $b6caff0bf13dcaf5$var$startOfDay;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $b6caff0bf13dcaf5$var$startOfDay(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("cBJez", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $92dc0740ffabe180$export$113002b5eff6e430, (v) => $92dc0740ffabe180$export$113002b5eff6e430 = v);
var $92dc0740ffabe180$export$113002b5eff6e430;
"use strict";
$92dc0740ffabe180$export$113002b5eff6e430 = $92dc0740ffabe180$var$getTimezoneOffsetInMilliseconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $92dc0740ffabe180$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("3Au2i", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $29cc086f79701cd9$export$f91e89d3d0406102, (v) => $29cc086f79701cd9$export$f91e89d3d0406102 = v);
var $29cc086f79701cd9$export$f91e89d3d0406102;
"use strict";
$29cc086f79701cd9$export$f91e89d3d0406102 = $29cc086f79701cd9$var$startOfYear;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $29cc086f79701cd9$var$startOfYear(date) {
    const cleanDate = (0, $30SVQ.toDate)(date);
    const _date = (0, $eK5z7.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("bjZpy", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $83e11b0db4cec366$export$7cabdc5698b63e2f, (v) => $83e11b0db4cec366$export$7cabdc5698b63e2f = v);
var $83e11b0db4cec366$export$7cabdc5698b63e2f;
"use strict";
$83e11b0db4cec366$export$7cabdc5698b63e2f = $83e11b0db4cec366$var$getISOWeek;

var $briB4 = parcelRequire("briB4");

var $2sjl8 = parcelRequire("2sjl8");

var $551eW = parcelRequire("551eW");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $83e11b0db4cec366$var$getISOWeek(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = +(0, $2sjl8.startOfISOWeek)(_date) - +(0, $551eW.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $briB4.millisecondsInWeek) + 1;
}

});
parcelRegister("2sjl8", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $1c9d32c6cb108460$export$6173213f95a4431e, (v) => $1c9d32c6cb108460$export$6173213f95a4431e = v);
var $1c9d32c6cb108460$export$6173213f95a4431e;
"use strict";
$1c9d32c6cb108460$export$6173213f95a4431e = $1c9d32c6cb108460$var$startOfISOWeek;

var $8ple2 = parcelRequire("8ple2");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $1c9d32c6cb108460$var$startOfISOWeek(date) {
    return (0, $8ple2.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("8ple2", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $61f11f7a26b3ab78$export$42c81a444fbfb5d4, (v) => $61f11f7a26b3ab78$export$42c81a444fbfb5d4 = v);
var $61f11f7a26b3ab78$export$42c81a444fbfb5d4;
"use strict";
$61f11f7a26b3ab78$export$42c81a444fbfb5d4 = $61f11f7a26b3ab78$var$startOfWeek;

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $61f11f7a26b3ab78$var$startOfWeek(date, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $30SVQ.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("551eW", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $3b2e6199275b27d6$export$236bdfa374eb69a9, (v) => $3b2e6199275b27d6$export$236bdfa374eb69a9 = v);
var $3b2e6199275b27d6$export$236bdfa374eb69a9;
"use strict";
$3b2e6199275b27d6$export$236bdfa374eb69a9 = $3b2e6199275b27d6$var$startOfISOWeekYear;

var $hhS6V = parcelRequire("hhS6V");

var $2sjl8 = parcelRequire("2sjl8");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $3b2e6199275b27d6$var$startOfISOWeekYear(date) {
    const year = (0, $hhS6V.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $2sjl8.startOfISOWeek)(fourthOfJanuary);
}

});
parcelRegister("hhS6V", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $c95dff76bf2f692a$export$3dbc52535f6f8fcc, (v) => $c95dff76bf2f692a$export$3dbc52535f6f8fcc = v);
var $c95dff76bf2f692a$export$3dbc52535f6f8fcc;
"use strict";
$c95dff76bf2f692a$export$3dbc52535f6f8fcc = $c95dff76bf2f692a$var$getISOWeekYear;

var $eK5z7 = parcelRequire("eK5z7");

var $2sjl8 = parcelRequire("2sjl8");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $c95dff76bf2f692a$var$getISOWeekYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $2sjl8.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $2sjl8.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("1wdT6", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $11b38d723fd57381$export$efe19b760242b2fc, (v) => $11b38d723fd57381$export$efe19b760242b2fc = v);
var $11b38d723fd57381$export$efe19b760242b2fc;
"use strict";
$11b38d723fd57381$export$efe19b760242b2fc = $11b38d723fd57381$var$getWeek;

var $briB4 = parcelRequire("briB4");

var $8ple2 = parcelRequire("8ple2");

var $eO0Fp = parcelRequire("eO0Fp");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $11b38d723fd57381$var$getWeek(date, options) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = +(0, $8ple2.startOfWeek)(_date, options) - +(0, $eO0Fp.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $briB4.millisecondsInWeek) + 1;
}

});
parcelRegister("eO0Fp", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $ac7640a7ade5a435$export$bb7b45bb8e74da0f, (v) => $ac7640a7ade5a435$export$bb7b45bb8e74da0f = v);
var $ac7640a7ade5a435$export$bb7b45bb8e74da0f;
"use strict";
$ac7640a7ade5a435$export$bb7b45bb8e74da0f = $ac7640a7ade5a435$var$startOfWeekYear;

var $eK5z7 = parcelRequire("eK5z7");

var $7Fy3C = parcelRequire("7Fy3C");

var $8ple2 = parcelRequire("8ple2");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $ac7640a7ade5a435$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $7Fy3C.getWeekYear)(date, options);
    const firstWeek = (0, $eK5z7.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $8ple2.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRegister("7Fy3C", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $0170e230c8468ebb$export$12d572480ceb6e58, (v) => $0170e230c8468ebb$export$12d572480ceb6e58 = v);
var $0170e230c8468ebb$export$12d572480ceb6e58;
"use strict";
$0170e230c8468ebb$export$12d572480ceb6e58 = $0170e230c8468ebb$var$getWeekYear;

var $eK5z7 = parcelRequire("eK5z7");

var $8ple2 = parcelRequire("8ple2");

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $0170e230c8468ebb$var$getWeekYear(date, options) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $eK5z7.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $8ple2.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $eK5z7.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $8ple2.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("krIED", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $03d75ed55eeb99fa$export$c8306e720e213c0f, (v) => $03d75ed55eeb99fa$export$c8306e720e213c0f = v);
var $03d75ed55eeb99fa$export$c8306e720e213c0f;
"use strict";
$03d75ed55eeb99fa$export$c8306e720e213c0f = $03d75ed55eeb99fa$var$addLeadingZeros;
function $03d75ed55eeb99fa$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("9KWEw", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $71a5e81f1193b7a8$export$b0d4b338e1516f13, (v) => $71a5e81f1193b7a8$export$b0d4b338e1516f13 = v);
var $71a5e81f1193b7a8$export$b0d4b338e1516f13;
"use strict";
$71a5e81f1193b7a8$export$b0d4b338e1516f13 = void 0;

var $krIED = parcelRequire("krIED");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $71a5e81f1193b7a8$var$lightFormatters = $71a5e81f1193b7a8$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $krIED.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $krIED.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $krIED.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("7hoR9", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $54cd66db3e5e74df$export$70cc8fd02856fd58, (v) => $54cd66db3e5e74df$export$70cc8fd02856fd58 = v);
var $54cd66db3e5e74df$export$70cc8fd02856fd58;
"use strict";
$54cd66db3e5e74df$export$70cc8fd02856fd58 = void 0;
const $54cd66db3e5e74df$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $54cd66db3e5e74df$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $54cd66db3e5e74df$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $54cd66db3e5e74df$var$timeLongFormatter(timePattern, formatLong));
};
const $54cd66db3e5e74df$var$longFormatters = $54cd66db3e5e74df$export$70cc8fd02856fd58 = {
    p: $54cd66db3e5e74df$var$timeLongFormatter,
    P: $54cd66db3e5e74df$var$dateTimeLongFormatter
};

});

parcelRegister("aRzsd", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $7e8a5b0b77bf77b9$export$c6cc36aa33304772, (v) => $7e8a5b0b77bf77b9$export$c6cc36aa33304772 = v);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1, (v) => $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1 = v);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879, (v) => $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879 = v);
var $7e8a5b0b77bf77b9$export$c6cc36aa33304772;
var $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1;
var $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879;
"use strict";
$7e8a5b0b77bf77b9$export$c6cc36aa33304772 = $7e8a5b0b77bf77b9$var$isProtectedDayOfYearToken;
$7e8a5b0b77bf77b9$export$c6b49d6dceb604a1 = $7e8a5b0b77bf77b9$var$isProtectedWeekYearToken;
$7e8a5b0b77bf77b9$export$f5f38f90ecaaf879 = $7e8a5b0b77bf77b9$var$warnOrThrowProtectedError;
const $7e8a5b0b77bf77b9$var$dayOfYearTokenRE = /^D+$/;
const $7e8a5b0b77bf77b9$var$weekYearTokenRE = /^Y+$/;
const $7e8a5b0b77bf77b9$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7e8a5b0b77bf77b9$var$isProtectedDayOfYearToken(token) {
    return $7e8a5b0b77bf77b9$var$dayOfYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$var$isProtectedWeekYearToken(token) {
    return $7e8a5b0b77bf77b9$var$weekYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $7e8a5b0b77bf77b9$var$message(token, format, input);
    console.warn(_message);
    if ($7e8a5b0b77bf77b9$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7e8a5b0b77bf77b9$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("kPCB6", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $f2a682b251363bc2$export$1ea939691cdc45b8, (v) => $f2a682b251363bc2$export$1ea939691cdc45b8 = v);
var $f2a682b251363bc2$export$1ea939691cdc45b8;
"use strict";
$f2a682b251363bc2$export$1ea939691cdc45b8 = $f2a682b251363bc2$var$isValid;

var $26SSu = parcelRequire("26SSu");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $f2a682b251363bc2$var$isValid(date) {
    if (!(0, $26SSu.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $30SVQ.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRegister("26SSu", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $1896b5e28554d57b$export$871608497c498473, (v) => $1896b5e28554d57b$export$871608497c498473 = v);
var $1896b5e28554d57b$export$871608497c498473;
"use strict";
$1896b5e28554d57b$export$871608497c498473 = $1896b5e28554d57b$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $1896b5e28554d57b$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});



parcelRegister("inqX7", function(module, exports) {

$parcel$export(module.exports, "getDate", () => $d60f4829c70cb6da$export$aa350b96d91cd94, (v) => $d60f4829c70cb6da$export$aa350b96d91cd94 = v);
var $d60f4829c70cb6da$export$aa350b96d91cd94;
"use strict";
$d60f4829c70cb6da$export$aa350b96d91cd94 = $d60f4829c70cb6da$var$getDate;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $d60f4829c70cb6da$var$getDate(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRegister("7uieS", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", () => $57397b9e44500b87$export$f645ddd439eb259d, (v) => $57397b9e44500b87$export$f645ddd439eb259d = v);
var $57397b9e44500b87$export$f645ddd439eb259d;
"use strict";
$57397b9e44500b87$export$f645ddd439eb259d = $57397b9e44500b87$var$getDaysInMonth;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $57397b9e44500b87$var$getDaysInMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $eK5z7.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("lIpMn", function(module, exports) {

$parcel$export(module.exports, "getHours", () => $fcf1b449283ad4a9$export$257b40f71c07d58f, (v) => $fcf1b449283ad4a9$export$257b40f71c07d58f = v);
var $fcf1b449283ad4a9$export$257b40f71c07d58f;
"use strict";
$fcf1b449283ad4a9$export$257b40f71c07d58f = $fcf1b449283ad4a9$var$getHours;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $fcf1b449283ad4a9$var$getHours(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRegister("12jbR", function(module, exports) {

$parcel$export(module.exports, "getMinutes", () => $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145, (v) => $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145 = v);
var $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145;
"use strict";
$0c14dd26da4d9afe$export$b7f1bc3ea3ac4145 = $0c14dd26da4d9afe$var$getMinutes;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $0c14dd26da4d9afe$var$getMinutes(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRegister("9xRRE", function(module, exports) {

$parcel$export(module.exports, "getMonth", () => $6f30fa731c19b802$export$6ce1b5acc29cb53b, (v) => $6f30fa731c19b802$export$6ce1b5acc29cb53b = v);
var $6f30fa731c19b802$export$6ce1b5acc29cb53b;
"use strict";
$6f30fa731c19b802$export$6ce1b5acc29cb53b = $6f30fa731c19b802$var$getMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $6f30fa731c19b802$var$getMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRegister("ebQpN", function(module, exports) {

$parcel$export(module.exports, "getSeconds", () => $a54ac051af9fd19a$export$5e9417507ff28427, (v) => $a54ac051af9fd19a$export$5e9417507ff28427 = v);
var $a54ac051af9fd19a$export$5e9417507ff28427;
"use strict";
$a54ac051af9fd19a$export$5e9417507ff28427 = $a54ac051af9fd19a$var$getSeconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $a54ac051af9fd19a$var$getSeconds(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRegister("c1AiI", function(module, exports) {

$parcel$export(module.exports, "getMilliseconds", () => $8c11bc9b369aea05$export$b8e4380f312797af, (v) => $8c11bc9b369aea05$export$b8e4380f312797af = v);
var $8c11bc9b369aea05$export$b8e4380f312797af;
"use strict";
$8c11bc9b369aea05$export$b8e4380f312797af = $8c11bc9b369aea05$var$getMilliseconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $8c11bc9b369aea05$var$getMilliseconds(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}

});

parcelRegister("5CRrs", function(module, exports) {

$parcel$export(module.exports, "getYear", () => $4189f4c9c3b9878d$export$5846dc2d57a5c860, (v) => $4189f4c9c3b9878d$export$5846dc2d57a5c860 = v);
var $4189f4c9c3b9878d$export$5846dc2d57a5c860;
"use strict";
$4189f4c9c3b9878d$export$5846dc2d57a5c860 = $4189f4c9c3b9878d$var$getYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $4189f4c9c3b9878d$var$getYear(date) {
    return (0, $30SVQ.toDate)(date).getFullYear();
}

});

parcelRegister("aFxrf", function(module, exports) {

$parcel$export(module.exports, "isAfter", () => $7c47abeb099a42c0$export$e4de839670987035, (v) => $7c47abeb099a42c0$export$e4de839670987035 = v);
var $7c47abeb099a42c0$export$e4de839670987035;
"use strict";
$7c47abeb099a42c0$export$e4de839670987035 = $7c47abeb099a42c0$var$isAfter;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $7c47abeb099a42c0$var$isAfter(date, dateToCompare) {
    const _date = (0, $30SVQ.toDate)(date);
    const _dateToCompare = (0, $30SVQ.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRegister("i5nf8", function(module, exports) {

$parcel$export(module.exports, "isBefore", () => $d2aab93838002ade$export$5c007e10c6929c95, (v) => $d2aab93838002ade$export$5c007e10c6929c95 = v);
var $d2aab93838002ade$export$5c007e10c6929c95;
"use strict";
$d2aab93838002ade$export$5c007e10c6929c95 = $d2aab93838002ade$var$isBefore;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $d2aab93838002ade$var$isBefore(date, dateToCompare) {
    const _date = (0, $30SVQ.toDate)(date);
    const _dateToCompare = (0, $30SVQ.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRegister("aw1Xf", function(module, exports) {

$parcel$export(module.exports, "isEqual", () => $7a7e68b5aa0b9077$export$248d38f6296296c5, (v) => $7a7e68b5aa0b9077$export$248d38f6296296c5 = v);
var $7a7e68b5aa0b9077$export$248d38f6296296c5;
"use strict";
$7a7e68b5aa0b9077$export$248d38f6296296c5 = $7a7e68b5aa0b9077$var$isEqual;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $7a7e68b5aa0b9077$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $30SVQ.toDate)(leftDate);
    const _dateRight = (0, $30SVQ.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRegister("3p5lI", function(module, exports) {

$parcel$export(module.exports, "isSameDay", () => $27a7db21eafd685b$export$ea39ec197993aef0, (v) => $27a7db21eafd685b$export$ea39ec197993aef0 = v);
var $27a7db21eafd685b$export$ea39ec197993aef0;
"use strict";
$27a7db21eafd685b$export$ea39ec197993aef0 = $27a7db21eafd685b$var$isSameDay;

var $fH0a1 = parcelRequire("fH0a1");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $27a7db21eafd685b$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $fH0a1.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $fH0a1.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRegister("ea2hS", function(module, exports) {

$parcel$export(module.exports, "isSameYear", () => $a4f3c61641c4093b$export$5841f9eb9773f25f, (v) => $a4f3c61641c4093b$export$5841f9eb9773f25f = v);
var $a4f3c61641c4093b$export$5841f9eb9773f25f;
"use strict";
$a4f3c61641c4093b$export$5841f9eb9773f25f = $a4f3c61641c4093b$var$isSameYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $a4f3c61641c4093b$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRegister("AFgUD", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", () => $06e3609fc2fbc2e2$export$a18c89cbd24170ff, (v) => $06e3609fc2fbc2e2$export$a18c89cbd24170ff = v);
var $06e3609fc2fbc2e2$export$a18c89cbd24170ff;
"use strict";
$06e3609fc2fbc2e2$export$a18c89cbd24170ff = $06e3609fc2fbc2e2$var$isSameMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $06e3609fc2fbc2e2$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRegister("5hZu1", function(module, exports) {

$parcel$export(module.exports, "isSameHour", () => $3d9e3b90112ffc43$export$f9f3a94a0371013, (v) => $3d9e3b90112ffc43$export$f9f3a94a0371013 = v);
var $3d9e3b90112ffc43$export$f9f3a94a0371013;
"use strict";
$3d9e3b90112ffc43$export$f9f3a94a0371013 = $3d9e3b90112ffc43$var$isSameHour;

var $hYeCp = parcelRequire("hYeCp");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $3d9e3b90112ffc43$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $hYeCp.startOfHour)(dateLeft);
    const dateRightStartOfHour = (0, $hYeCp.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

});
parcelRegister("hYeCp", function(module, exports) {

$parcel$export(module.exports, "startOfHour", () => $d153613108f3ff12$export$24f91f68e7c9d9d5, (v) => $d153613108f3ff12$export$24f91f68e7c9d9d5 = v);
var $d153613108f3ff12$export$24f91f68e7c9d9d5;
"use strict";
$d153613108f3ff12$export$24f91f68e7c9d9d5 = $d153613108f3ff12$var$startOfHour;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $d153613108f3ff12$var$startOfHour(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

});


parcelRegister("bUtct", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $7hoR9.longFormatters;
    }
});
module.exports.parse = $8abb93379891fb3e$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $7YLa0.parsers;
    }
});

var $eK5z7 = parcelRequire("eK5z7");

var $kWcwI = parcelRequire("kWcwI");

var $k1YNI = parcelRequire("k1YNI");

var $30SVQ = parcelRequire("30SVQ");

var $7hoR9 = parcelRequire("7hoR9");

var $aRzsd = parcelRequire("aRzsd");

var $7YLa0 = parcelRequire("7YLa0");

var $3Mmu1 = parcelRequire("3Mmu1");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8abb93379891fb3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8abb93379891fb3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8abb93379891fb3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8abb93379891fb3e$var$doubleQuoteRegExp = /''/g;
const $8abb93379891fb3e$var$notWhitespaceRegExp = /\S/;
const $8abb93379891fb3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $8abb93379891fb3e$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $kWcwI.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $k1YNI.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $30SVQ.toDate)(referenceDate);
        else return (0, $eK5z7.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $3Mmu1.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($8abb93379891fb3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $7hoR9.longFormatters) {
            const longFormatter = $7hoR9.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8abb93379891fb3e$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $aRzsd.isProtectedWeekYearToken)(token)) (0, $aRzsd.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $aRzsd.isProtectedDayOfYearToken)(token)) (0, $aRzsd.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $7YLa0.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $eK5z7.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($8abb93379891fb3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $8abb93379891fb3e$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $eK5z7.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $8abb93379891fb3e$var$notWhitespaceRegExp.test(dateStr)) return (0, $eK5z7.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $30SVQ.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $eK5z7.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $eK5z7.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $eK5z7.constructFrom)(referenceDate, date);
}
function $8abb93379891fb3e$var$cleanEscapedString(input) {
    return input.match($8abb93379891fb3e$var$escapedStringRegExp)[1].replace($8abb93379891fb3e$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("kWcwI", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $f3e2f0f906df8397$export$430a3269e24b912e, (v) => $f3e2f0f906df8397$export$430a3269e24b912e = v);
var $f3e2f0f906df8397$export$430a3269e24b912e;
"use strict";
$f3e2f0f906df8397$export$430a3269e24b912e = $f3e2f0f906df8397$var$getDefaultOptions;

var $4UP3S = parcelRequire("4UP3S");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $f3e2f0f906df8397$var$getDefaultOptions() {
    return Object.assign({}, (0, $4UP3S.getDefaultOptions)());
}

});

parcelRegister("7YLa0", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $5cf2b811a6ff5b69$export$19131010e7fd8373, (v) => $5cf2b811a6ff5b69$export$19131010e7fd8373 = v);
var $5cf2b811a6ff5b69$export$19131010e7fd8373;
"use strict";
$5cf2b811a6ff5b69$export$19131010e7fd8373 = void 0;

var $iNZ6W = parcelRequire("iNZ6W");

var $8Ltc2 = parcelRequire("8Ltc2");

var $dITef = parcelRequire("dITef");

var $2eUn4 = parcelRequire("2eUn4");

var $gMKCI = parcelRequire("gMKCI");

var $hZFMM = parcelRequire("hZFMM");

var $8tt4y = parcelRequire("8tt4y");

var $5TjZC = parcelRequire("5TjZC");

var $leRh0 = parcelRequire("leRh0");

var $1aJ6D = parcelRequire("1aJ6D");

var $8VFCo = parcelRequire("8VFCo");

var $jgEUH = parcelRequire("jgEUH");

var $9csEn = parcelRequire("9csEn");

var $dpfSm = parcelRequire("dpfSm");

var $lYulP = parcelRequire("lYulP");

var $1OfTe = parcelRequire("1OfTe");

var $8ADKY = parcelRequire("8ADKY");

var $imMH6 = parcelRequire("imMH6");

var $5zEqc = parcelRequire("5zEqc");

var $a0YFJ = parcelRequire("a0YFJ");

var $gU9jF = parcelRequire("gU9jF");

var $q1nV3 = parcelRequire("q1nV3");

var $fMKKf = parcelRequire("fMKKf");

var $3E4gZ = parcelRequire("3E4gZ");

var $lHBzG = parcelRequire("lHBzG");

var $2ucqy = parcelRequire("2ucqy");

var $cDVgN = parcelRequire("cDVgN");

var $ccq0m = parcelRequire("ccq0m");

var $b7ibZ = parcelRequire("b7ibZ");

var $epFsP = parcelRequire("epFsP");

var $je1c0 = parcelRequire("je1c0");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $5cf2b811a6ff5b69$var$parsers = $5cf2b811a6ff5b69$export$19131010e7fd8373 = {
    G: new $iNZ6W.EraParser(),
    y: new $8Ltc2.YearParser(),
    Y: new $dITef.LocalWeekYearParser(),
    R: new $2eUn4.ISOWeekYearParser(),
    u: new $gMKCI.ExtendedYearParser(),
    Q: new $hZFMM.QuarterParser(),
    q: new $8tt4y.StandAloneQuarterParser(),
    M: new $5TjZC.MonthParser(),
    L: new $leRh0.StandAloneMonthParser(),
    w: new $1aJ6D.LocalWeekParser(),
    I: new $8VFCo.ISOWeekParser(),
    d: new $jgEUH.DateParser(),
    D: new $9csEn.DayOfYearParser(),
    E: new $dpfSm.DayParser(),
    e: new $lYulP.LocalDayParser(),
    c: new $1OfTe.StandAloneLocalDayParser(),
    i: new $8ADKY.ISODayParser(),
    a: new $imMH6.AMPMParser(),
    b: new $5zEqc.AMPMMidnightParser(),
    B: new $a0YFJ.DayPeriodParser(),
    h: new $gU9jF.Hour1to12Parser(),
    H: new $q1nV3.Hour0to23Parser(),
    K: new $fMKKf.Hour0To11Parser(),
    k: new $3E4gZ.Hour1To24Parser(),
    m: new $lHBzG.MinuteParser(),
    s: new $2ucqy.SecondParser(),
    S: new $cDVgN.FractionOfSecondParser(),
    X: new $ccq0m.ISOTimezoneWithZParser(),
    x: new $b7ibZ.ISOTimezoneParser(),
    t: new $epFsP.TimestampSecondsParser(),
    T: new $je1c0.TimestampMillisecondsParser()
};

});
parcelRegister("iNZ6W", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $db0c34f9a22bf78d$export$8e5a1d3f85a9688, (v) => $db0c34f9a22bf78d$export$8e5a1d3f85a9688 = v);
var $db0c34f9a22bf78d$export$8e5a1d3f85a9688;
"use strict";
$db0c34f9a22bf78d$export$8e5a1d3f85a9688 = void 0;

var $g9CO5 = parcelRequire("g9CO5");
class $db0c34f9a22bf78d$var$EraParser extends $g9CO5.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$db0c34f9a22bf78d$export$8e5a1d3f85a9688 = $db0c34f9a22bf78d$var$EraParser;

});
parcelRegister("g9CO5", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $bc2b96d39fc4c3d8$export$7acfa6ed01010e37, (v) => $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = v);
var $bc2b96d39fc4c3d8$export$7acfa6ed01010e37;
"use strict";
$bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = void 0;

var $3Mmu1 = parcelRequire("3Mmu1");
class $bc2b96d39fc4c3d8$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $3Mmu1.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = $bc2b96d39fc4c3d8$var$Parser;

});
parcelRegister("3Mmu1", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5, (v) => $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = v);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee, (v) => $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = v);
var $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5;
var $2c074b7ab8cd2d6d$export$81d53e3678089a6;
var $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee;
"use strict";
$2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = $2c074b7ab8cd2d6d$export$81d53e3678089a6 = $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = void 0;

var $7F7K0 = parcelRequire("7F7K0");

var $eK5z7 = parcelRequire("eK5z7");
const $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $2c074b7ab8cd2d6d$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$2c074b7ab8cd2d6d$export$81d53e3678089a6 = $2c074b7ab8cd2d6d$var$Setter;
class $2c074b7ab8cd2d6d$var$ValueSetter extends $2c074b7ab8cd2d6d$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = $2c074b7ab8cd2d6d$var$ValueSetter;
class $2c074b7ab8cd2d6d$var$DateToSystemTimezoneSetter extends $2c074b7ab8cd2d6d$var$Setter {
    priority = $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $eK5z7.constructFrom)(date, (0, $7F7K0.transpose)(date, Date));
    }
}
$2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = $2c074b7ab8cd2d6d$var$DateToSystemTimezoneSetter;

});
parcelRegister("7F7K0", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $59425df5ba0b4bea$export$9cb09a71b7d66923, (v) => $59425df5ba0b4bea$export$9cb09a71b7d66923 = v);
var $59425df5ba0b4bea$export$9cb09a71b7d66923;
"use strict";
$59425df5ba0b4bea$export$9cb09a71b7d66923 = $59425df5ba0b4bea$var$transpose;

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $59425df5ba0b4bea$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $eK5z7.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRegister("8Ltc2", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $66195bae0f19f15a$export$48d352de7cd4a988, (v) => $66195bae0f19f15a$export$48d352de7cd4a988 = v);
var $66195bae0f19f15a$export$48d352de7cd4a988;
"use strict";
$66195bae0f19f15a$export$48d352de7cd4a988 = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $66195bae0f19f15a$var$YearParser extends $g9CO5.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $aHGaK.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$66195bae0f19f15a$export$48d352de7cd4a988 = $66195bae0f19f15a$var$YearParser;

});
parcelRegister("aHGaK", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", () => $7caea2161b2082cf$export$fb506d2676e7f207, (v) => $7caea2161b2082cf$export$fb506d2676e7f207 = v);
$parcel$export(module.exports, "isLeapYearIndex", () => $7caea2161b2082cf$export$3d50627710b84d75, (v) => $7caea2161b2082cf$export$3d50627710b84d75 = v);
$parcel$export(module.exports, "mapValue", () => $7caea2161b2082cf$export$4f84e3a82c7b538, (v) => $7caea2161b2082cf$export$4f84e3a82c7b538 = v);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $7caea2161b2082cf$export$29126f735cbf69f7, (v) => $7caea2161b2082cf$export$29126f735cbf69f7 = v);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $7caea2161b2082cf$export$d931c43c4608a164, (v) => $7caea2161b2082cf$export$d931c43c4608a164 = v);
$parcel$export(module.exports, "parseNDigits", () => $7caea2161b2082cf$export$513bb01536146ab6, (v) => $7caea2161b2082cf$export$513bb01536146ab6 = v);
$parcel$export(module.exports, "parseNDigitsSigned", () => $7caea2161b2082cf$export$2c9307b2e29c533c, (v) => $7caea2161b2082cf$export$2c9307b2e29c533c = v);
$parcel$export(module.exports, "parseNumericPattern", () => $7caea2161b2082cf$export$cc7cc9e2a3ff9388, (v) => $7caea2161b2082cf$export$cc7cc9e2a3ff9388 = v);
$parcel$export(module.exports, "parseTimezonePattern", () => $7caea2161b2082cf$export$6497f4c0ecdfba8e, (v) => $7caea2161b2082cf$export$6497f4c0ecdfba8e = v);
var $7caea2161b2082cf$export$fb506d2676e7f207;
var $7caea2161b2082cf$export$3d50627710b84d75;
var $7caea2161b2082cf$export$4f84e3a82c7b538;
var $7caea2161b2082cf$export$29126f735cbf69f7;
var $7caea2161b2082cf$export$d931c43c4608a164;
var $7caea2161b2082cf$export$513bb01536146ab6;
var $7caea2161b2082cf$export$2c9307b2e29c533c;
var $7caea2161b2082cf$export$cc7cc9e2a3ff9388;
var $7caea2161b2082cf$export$6497f4c0ecdfba8e;
"use strict";
$7caea2161b2082cf$export$fb506d2676e7f207 = $7caea2161b2082cf$var$dayPeriodEnumToHours;
$7caea2161b2082cf$export$3d50627710b84d75 = $7caea2161b2082cf$var$isLeapYearIndex;
$7caea2161b2082cf$export$4f84e3a82c7b538 = $7caea2161b2082cf$var$mapValue;
$7caea2161b2082cf$export$29126f735cbf69f7 = $7caea2161b2082cf$var$normalizeTwoDigitYear;
$7caea2161b2082cf$export$d931c43c4608a164 = $7caea2161b2082cf$var$parseAnyDigitsSigned;
$7caea2161b2082cf$export$513bb01536146ab6 = $7caea2161b2082cf$var$parseNDigits;
$7caea2161b2082cf$export$2c9307b2e29c533c = $7caea2161b2082cf$var$parseNDigitsSigned;
$7caea2161b2082cf$export$cc7cc9e2a3ff9388 = $7caea2161b2082cf$var$parseNumericPattern;
$7caea2161b2082cf$export$6497f4c0ecdfba8e = $7caea2161b2082cf$var$parseTimezonePattern;

var $briB4 = parcelRequire("briB4");

var $crnJg = parcelRequire("crnJg");
function $7caea2161b2082cf$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7caea2161b2082cf$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $briB4.millisecondsInHour + minutes * $briB4.millisecondsInMinute + seconds * $briB4.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$var$parseAnyDigitsSigned(dateString) {
    return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.anyDigitsSigned, dateString);
}
function $7caea2161b2082cf$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.singleDigit, dateString);
        case 2:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.twoDigits, dateString);
        case 3:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.threeDigits, dateString);
        case 4:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.fourDigits, dateString);
        default:
            return $7caea2161b2082cf$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $7caea2161b2082cf$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7caea2161b2082cf$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7caea2161b2082cf$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("crnJg", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", () => $90ea69bf2b625c49$export$a7ee192b982af9c1, (v) => $90ea69bf2b625c49$export$a7ee192b982af9c1 = v);
$parcel$export(module.exports, "numericPatterns", () => $90ea69bf2b625c49$export$c123ee06d9da8480, (v) => $90ea69bf2b625c49$export$c123ee06d9da8480 = v);
var $90ea69bf2b625c49$export$a7ee192b982af9c1;
var $90ea69bf2b625c49$export$c123ee06d9da8480;
"use strict";
$90ea69bf2b625c49$export$a7ee192b982af9c1 = $90ea69bf2b625c49$export$c123ee06d9da8480 = void 0;
const $90ea69bf2b625c49$var$numericPatterns = $90ea69bf2b625c49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $90ea69bf2b625c49$var$timezonePatterns = $90ea69bf2b625c49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("dITef", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $9fda39b31cab7345$export$b8ef38dfcf05d5db, (v) => $9fda39b31cab7345$export$b8ef38dfcf05d5db = v);
var $9fda39b31cab7345$export$b8ef38dfcf05d5db;
"use strict";
$9fda39b31cab7345$export$b8ef38dfcf05d5db = void 0;

var $7Fy3C = parcelRequire("7Fy3C");

var $8ple2 = parcelRequire("8ple2");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Local week-numbering year
class $9fda39b31cab7345$var$LocalWeekYearParser extends $g9CO5.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $7Fy3C.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $aHGaK.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $8ple2.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $8ple2.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$9fda39b31cab7345$export$b8ef38dfcf05d5db = $9fda39b31cab7345$var$LocalWeekYearParser;

});

parcelRegister("2eUn4", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $1a189db5f2a1065c$export$951d1df011fde06f, (v) => $1a189db5f2a1065c$export$951d1df011fde06f = v);
var $1a189db5f2a1065c$export$951d1df011fde06f;
"use strict";
$1a189db5f2a1065c$export$951d1df011fde06f = void 0;

var $2sjl8 = parcelRequire("2sjl8");

var $eK5z7 = parcelRequire("eK5z7");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// ISO week-numbering year
class $1a189db5f2a1065c$var$ISOWeekYearParser extends $g9CO5.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $aHGaK.parseNDigitsSigned)(4, dateString);
        return (0, $aHGaK.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $eK5z7.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $2sjl8.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$1a189db5f2a1065c$export$951d1df011fde06f = $1a189db5f2a1065c$var$ISOWeekYearParser;

});

parcelRegister("gMKCI", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $c3854b7a937037cd$export$bad9d2ea38e8f1a, (v) => $c3854b7a937037cd$export$bad9d2ea38e8f1a = v);
var $c3854b7a937037cd$export$bad9d2ea38e8f1a;
"use strict";
$c3854b7a937037cd$export$bad9d2ea38e8f1a = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $c3854b7a937037cd$var$ExtendedYearParser extends $g9CO5.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $aHGaK.parseNDigitsSigned)(4, dateString);
        return (0, $aHGaK.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$c3854b7a937037cd$export$bad9d2ea38e8f1a = $c3854b7a937037cd$var$ExtendedYearParser;

});

parcelRegister("hZFMM", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $d1988bf983127f3e$export$5cb0f701186dde1d, (v) => $d1988bf983127f3e$export$5cb0f701186dde1d = v);
var $d1988bf983127f3e$export$5cb0f701186dde1d;
"use strict";
$d1988bf983127f3e$export$5cb0f701186dde1d = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $d1988bf983127f3e$var$QuarterParser extends $g9CO5.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$d1988bf983127f3e$export$5cb0f701186dde1d = $d1988bf983127f3e$var$QuarterParser;

});

parcelRegister("8tt4y", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $62b79555ac1f33b0$export$300c0c2990e20e6d, (v) => $62b79555ac1f33b0$export$300c0c2990e20e6d = v);
var $62b79555ac1f33b0$export$300c0c2990e20e6d;
"use strict";
$62b79555ac1f33b0$export$300c0c2990e20e6d = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $62b79555ac1f33b0$var$StandAloneQuarterParser extends $g9CO5.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$62b79555ac1f33b0$export$300c0c2990e20e6d = $62b79555ac1f33b0$var$StandAloneQuarterParser;

});

parcelRegister("5TjZC", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $44a198f4e488a239$export$400dd8b40ef138a3, (v) => $44a198f4e488a239$export$400dd8b40ef138a3 = v);
var $44a198f4e488a239$export$400dd8b40ef138a3;
"use strict";
$44a198f4e488a239$export$400dd8b40ef138a3 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $44a198f4e488a239$var$MonthParser extends $g9CO5.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$44a198f4e488a239$export$400dd8b40ef138a3 = $44a198f4e488a239$var$MonthParser;

});

parcelRegister("leRh0", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $f7643ab884280f91$export$1d7eaa53eaa5deba, (v) => $f7643ab884280f91$export$1d7eaa53eaa5deba = v);
var $f7643ab884280f91$export$1d7eaa53eaa5deba;
"use strict";
$f7643ab884280f91$export$1d7eaa53eaa5deba = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $f7643ab884280f91$var$StandAloneMonthParser extends $g9CO5.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f7643ab884280f91$export$1d7eaa53eaa5deba = $f7643ab884280f91$var$StandAloneMonthParser;

});

parcelRegister("1aJ6D", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $0da9b6c0b13ee7fd$export$c4005ffc174e07c0, (v) => $0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = v);
var $0da9b6c0b13ee7fd$export$c4005ffc174e07c0;
"use strict";
$0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = void 0;

var $8P5CE = parcelRequire("8P5CE");

var $8ple2 = parcelRequire("8ple2");

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Local week of year
class $0da9b6c0b13ee7fd$var$LocalWeekParser extends $g9CO5.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $8ple2.startOfWeek)((0, $8P5CE.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = $0da9b6c0b13ee7fd$var$LocalWeekParser;

});
parcelRegister("8P5CE", function(module, exports) {

$parcel$export(module.exports, "setWeek", () => $66c7729eb95aa501$export$4b3066ce4afafd88, (v) => $66c7729eb95aa501$export$4b3066ce4afafd88 = v);
var $66c7729eb95aa501$export$4b3066ce4afafd88;
"use strict";
$66c7729eb95aa501$export$4b3066ce4afafd88 = $66c7729eb95aa501$var$setWeek;

var $1wdT6 = parcelRequire("1wdT6");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $66c7729eb95aa501$var$setWeek(date, week, options) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = (0, $1wdT6.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("8VFCo", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $6803ee1ef2b46eaa$export$6fc8dbedd560a6af, (v) => $6803ee1ef2b46eaa$export$6fc8dbedd560a6af = v);
var $6803ee1ef2b46eaa$export$6fc8dbedd560a6af;
"use strict";
$6803ee1ef2b46eaa$export$6fc8dbedd560a6af = void 0;

var $hTRRJ = parcelRequire("hTRRJ");

var $2sjl8 = parcelRequire("2sjl8");

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// ISO week of year
class $6803ee1ef2b46eaa$var$ISOWeekParser extends $g9CO5.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $2sjl8.startOfISOWeek)((0, $hTRRJ.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6803ee1ef2b46eaa$export$6fc8dbedd560a6af = $6803ee1ef2b46eaa$var$ISOWeekParser;

});
parcelRegister("hTRRJ", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", () => $d0815b4ed45bc80a$export$6542bebf6be94082, (v) => $d0815b4ed45bc80a$export$6542bebf6be94082 = v);
var $d0815b4ed45bc80a$export$6542bebf6be94082;
"use strict";
$d0815b4ed45bc80a$export$6542bebf6be94082 = $d0815b4ed45bc80a$var$setISOWeek;

var $bjZpy = parcelRequire("bjZpy");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $d0815b4ed45bc80a$var$setISOWeek(date, week) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = (0, $bjZpy.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("jgEUH", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $e06f3f7fc9153746$export$e8d4b28a20981dd2, (v) => $e06f3f7fc9153746$export$e8d4b28a20981dd2 = v);
var $e06f3f7fc9153746$export$e8d4b28a20981dd2;
"use strict";
$e06f3f7fc9153746$export$e8d4b28a20981dd2 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
const $e06f3f7fc9153746$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $e06f3f7fc9153746$var$DateParser extends $g9CO5.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $aHGaK.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$e06f3f7fc9153746$export$e8d4b28a20981dd2 = $e06f3f7fc9153746$var$DateParser;

});

parcelRegister("9csEn", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $6b2b75646543924f$export$6cfe0d613455f615, (v) => $6b2b75646543924f$export$6cfe0d613455f615 = v);
var $6b2b75646543924f$export$6cfe0d613455f615;
"use strict";
$6b2b75646543924f$export$6cfe0d613455f615 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $6b2b75646543924f$var$DayOfYearParser extends $g9CO5.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $aHGaK.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6b2b75646543924f$export$6cfe0d613455f615 = $6b2b75646543924f$var$DayOfYearParser;

});

parcelRegister("dpfSm", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $9c29ecc5d15fe12f$export$1b03c8b76262f7bd, (v) => $9c29ecc5d15fe12f$export$1b03c8b76262f7bd = v);
var $9c29ecc5d15fe12f$export$1b03c8b76262f7bd;
"use strict";
$9c29ecc5d15fe12f$export$1b03c8b76262f7bd = void 0;

var $1GcKu = parcelRequire("1GcKu");

var $g9CO5 = parcelRequire("g9CO5");
// Day of week
class $9c29ecc5d15fe12f$var$DayParser extends $g9CO5.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1GcKu.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$9c29ecc5d15fe12f$export$1b03c8b76262f7bd = $9c29ecc5d15fe12f$var$DayParser;

});
parcelRegister("1GcKu", function(module, exports) {

$parcel$export(module.exports, "setDay", () => $13939a537621d91b$export$b04fdcda82decc6c, (v) => $13939a537621d91b$export$b04fdcda82decc6c = v);
var $13939a537621d91b$export$b04fdcda82decc6c;
"use strict";
$13939a537621d91b$export$b04fdcda82decc6c = $13939a537621d91b$var$setDay;

var $e1kwM = parcelRequire("e1kwM");

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $13939a537621d91b$var$setDay(date, day, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $30SVQ.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $e1kwM.addDays)(_date, diff);
}

});


parcelRegister("lYulP", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $fff6beaa36b4d0e5$export$44d1c127ab42c480, (v) => $fff6beaa36b4d0e5$export$44d1c127ab42c480 = v);
var $fff6beaa36b4d0e5$export$44d1c127ab42c480;
"use strict";
$fff6beaa36b4d0e5$export$44d1c127ab42c480 = void 0;

var $1GcKu = parcelRequire("1GcKu");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Local day of week
class $fff6beaa36b4d0e5$var$LocalDayParser extends $g9CO5.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1GcKu.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$fff6beaa36b4d0e5$export$44d1c127ab42c480 = $fff6beaa36b4d0e5$var$LocalDayParser;

});

parcelRegister("1OfTe", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $1516c9543f7b6045$export$e447a647caaaec1d, (v) => $1516c9543f7b6045$export$e447a647caaaec1d = v);
var $1516c9543f7b6045$export$e447a647caaaec1d;
"use strict";
$1516c9543f7b6045$export$e447a647caaaec1d = void 0;

var $1GcKu = parcelRequire("1GcKu");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Stand-alone local day of week
class $1516c9543f7b6045$var$StandAloneLocalDayParser extends $g9CO5.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1GcKu.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$1516c9543f7b6045$export$e447a647caaaec1d = $1516c9543f7b6045$var$StandAloneLocalDayParser;

});

parcelRegister("8ADKY", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $6410865f895f2a05$export$693fb1e525095b2a, (v) => $6410865f895f2a05$export$693fb1e525095b2a = v);
var $6410865f895f2a05$export$693fb1e525095b2a;
"use strict";
$6410865f895f2a05$export$693fb1e525095b2a = void 0;

var $bE3Y3 = parcelRequire("bE3Y3");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// ISO day of week
class $6410865f895f2a05$var$ISODayParser extends $g9CO5.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $aHGaK.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $aHGaK.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $aHGaK.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $aHGaK.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $bE3Y3.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6410865f895f2a05$export$693fb1e525095b2a = $6410865f895f2a05$var$ISODayParser;

});
parcelRegister("bE3Y3", function(module, exports) {

$parcel$export(module.exports, "setISODay", () => $87a68208fbd57247$export$1fd9df65adb0d1aa, (v) => $87a68208fbd57247$export$1fd9df65adb0d1aa = v);
var $87a68208fbd57247$export$1fd9df65adb0d1aa;
"use strict";
$87a68208fbd57247$export$1fd9df65adb0d1aa = $87a68208fbd57247$var$setISODay;

var $e1kwM = parcelRequire("e1kwM");

var $9zwKS = parcelRequire("9zwKS");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $87a68208fbd57247$var$setISODay(date, day) {
    const _date = (0, $30SVQ.toDate)(date);
    const currentDay = (0, $9zwKS.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $e1kwM.addDays)(_date, diff);
}

});
parcelRegister("9zwKS", function(module, exports) {

$parcel$export(module.exports, "getISODay", () => $6f80ca66d6710e40$export$c514f4c1a8ed5e9e, (v) => $6f80ca66d6710e40$export$c514f4c1a8ed5e9e = v);
var $6f80ca66d6710e40$export$c514f4c1a8ed5e9e;
"use strict";
$6f80ca66d6710e40$export$c514f4c1a8ed5e9e = $6f80ca66d6710e40$var$getISODay;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $6f80ca66d6710e40$var$getISODay(date) {
    const _date = (0, $30SVQ.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});



parcelRegister("imMH6", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $d5f00db985cb1985$export$8d1e08492351df91, (v) => $d5f00db985cb1985$export$8d1e08492351df91 = v);
var $d5f00db985cb1985$export$8d1e08492351df91;
"use strict";
$d5f00db985cb1985$export$8d1e08492351df91 = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $d5f00db985cb1985$var$AMPMParser extends $g9CO5.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $aHGaK.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$d5f00db985cb1985$export$8d1e08492351df91 = $d5f00db985cb1985$var$AMPMParser;

});

parcelRegister("5zEqc", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $40ef93898dc5fd94$export$73ca2bd0a17d273, (v) => $40ef93898dc5fd94$export$73ca2bd0a17d273 = v);
var $40ef93898dc5fd94$export$73ca2bd0a17d273;
"use strict";
$40ef93898dc5fd94$export$73ca2bd0a17d273 = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $40ef93898dc5fd94$var$AMPMMidnightParser extends $g9CO5.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $aHGaK.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$40ef93898dc5fd94$export$73ca2bd0a17d273 = $40ef93898dc5fd94$var$AMPMMidnightParser;

});

parcelRegister("a0YFJ", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $74a8f7a92cf7f4b7$export$bb9212adf05373db, (v) => $74a8f7a92cf7f4b7$export$bb9212adf05373db = v);
var $74a8f7a92cf7f4b7$export$bb9212adf05373db;
"use strict";
$74a8f7a92cf7f4b7$export$bb9212adf05373db = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// in the morning, in the afternoon, in the evening, at night
class $74a8f7a92cf7f4b7$var$DayPeriodParser extends $g9CO5.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $aHGaK.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$74a8f7a92cf7f4b7$export$bb9212adf05373db = $74a8f7a92cf7f4b7$var$DayPeriodParser;

});

parcelRegister("gU9jF", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $c4e91a5550a4af76$export$8a04050a727a1756, (v) => $c4e91a5550a4af76$export$8a04050a727a1756 = v);
var $c4e91a5550a4af76$export$8a04050a727a1756;
"use strict";
$c4e91a5550a4af76$export$8a04050a727a1756 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $c4e91a5550a4af76$var$Hour1to12Parser extends $g9CO5.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$c4e91a5550a4af76$export$8a04050a727a1756 = $c4e91a5550a4af76$var$Hour1to12Parser;

});

parcelRegister("q1nV3", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $04e380d05021e0e6$export$e56f4dea2c3e56dd, (v) => $04e380d05021e0e6$export$e56f4dea2c3e56dd = v);
var $04e380d05021e0e6$export$e56f4dea2c3e56dd;
"use strict";
$04e380d05021e0e6$export$e56f4dea2c3e56dd = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $04e380d05021e0e6$var$Hour0to23Parser extends $g9CO5.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$04e380d05021e0e6$export$e56f4dea2c3e56dd = $04e380d05021e0e6$var$Hour0to23Parser;

});

parcelRegister("fMKKf", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $b7df994bc976acad$export$cbbe855312f87d77, (v) => $b7df994bc976acad$export$cbbe855312f87d77 = v);
var $b7df994bc976acad$export$cbbe855312f87d77;
"use strict";
$b7df994bc976acad$export$cbbe855312f87d77 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $b7df994bc976acad$var$Hour0To11Parser extends $g9CO5.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$b7df994bc976acad$export$cbbe855312f87d77 = $b7df994bc976acad$var$Hour0To11Parser;

});

parcelRegister("3E4gZ", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $2a786c11f89b58f4$export$6008046d2b34b6a5, (v) => $2a786c11f89b58f4$export$6008046d2b34b6a5 = v);
var $2a786c11f89b58f4$export$6008046d2b34b6a5;
"use strict";
$2a786c11f89b58f4$export$6008046d2b34b6a5 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $2a786c11f89b58f4$var$Hour1To24Parser extends $g9CO5.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$2a786c11f89b58f4$export$6008046d2b34b6a5 = $2a786c11f89b58f4$var$Hour1To24Parser;

});

parcelRegister("lHBzG", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $fccac2a30b38ae4c$export$2b52670d9e2be53, (v) => $fccac2a30b38ae4c$export$2b52670d9e2be53 = v);
var $fccac2a30b38ae4c$export$2b52670d9e2be53;
"use strict";
$fccac2a30b38ae4c$export$2b52670d9e2be53 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $fccac2a30b38ae4c$var$MinuteParser extends $g9CO5.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$fccac2a30b38ae4c$export$2b52670d9e2be53 = $fccac2a30b38ae4c$var$MinuteParser;

});

parcelRegister("2ucqy", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $1cf805ecbd4f0c4e$export$94d46d540cf1366a, (v) => $1cf805ecbd4f0c4e$export$94d46d540cf1366a = v);
var $1cf805ecbd4f0c4e$export$94d46d540cf1366a;
"use strict";
$1cf805ecbd4f0c4e$export$94d46d540cf1366a = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $1cf805ecbd4f0c4e$var$SecondParser extends $g9CO5.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$1cf805ecbd4f0c4e$export$94d46d540cf1366a = $1cf805ecbd4f0c4e$var$SecondParser;

});

parcelRegister("cDVgN", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $93458d2bd887c060$export$b8e6f8b2d70893b1, (v) => $93458d2bd887c060$export$b8e6f8b2d70893b1 = v);
var $93458d2bd887c060$export$b8e6f8b2d70893b1;
"use strict";
$93458d2bd887c060$export$b8e6f8b2d70893b1 = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $93458d2bd887c060$var$FractionOfSecondParser extends $g9CO5.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$93458d2bd887c060$export$b8e6f8b2d70893b1 = $93458d2bd887c060$var$FractionOfSecondParser;

});

parcelRegister("ccq0m", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $8e1ac7071c05f7b7$export$104d901d49fea29b, (v) => $8e1ac7071c05f7b7$export$104d901d49fea29b = v);
var $8e1ac7071c05f7b7$export$104d901d49fea29b;
"use strict";
$8e1ac7071c05f7b7$export$104d901d49fea29b = void 0;

var $eK5z7 = parcelRequire("eK5z7");

var $cBJez = parcelRequire("cBJez");

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $8e1ac7071c05f7b7$var$ISOTimezoneWithZParser extends $g9CO5.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $eK5z7.constructFrom)(date, date.getTime() - (0, $cBJez.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$8e1ac7071c05f7b7$export$104d901d49fea29b = $8e1ac7071c05f7b7$var$ISOTimezoneWithZParser;

});

parcelRegister("b7ibZ", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $817e75c4dd06b66a$export$12910e5204b52b9, (v) => $817e75c4dd06b66a$export$12910e5204b52b9 = v);
var $817e75c4dd06b66a$export$12910e5204b52b9;
"use strict";
$817e75c4dd06b66a$export$12910e5204b52b9 = void 0;

var $eK5z7 = parcelRequire("eK5z7");

var $cBJez = parcelRequire("cBJez");

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Timezone (ISO-8601)
class $817e75c4dd06b66a$var$ISOTimezoneParser extends $g9CO5.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $eK5z7.constructFrom)(date, date.getTime() - (0, $cBJez.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$817e75c4dd06b66a$export$12910e5204b52b9 = $817e75c4dd06b66a$var$ISOTimezoneParser;

});

parcelRegister("epFsP", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $a7e39061a4ba0a45$export$2cd8bf877a05e96, (v) => $a7e39061a4ba0a45$export$2cd8bf877a05e96 = v);
var $a7e39061a4ba0a45$export$2cd8bf877a05e96;
"use strict";
$a7e39061a4ba0a45$export$2cd8bf877a05e96 = void 0;

var $eK5z7 = parcelRequire("eK5z7");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $a7e39061a4ba0a45$var$TimestampSecondsParser extends $g9CO5.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $aHGaK.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $eK5z7.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$a7e39061a4ba0a45$export$2cd8bf877a05e96 = $a7e39061a4ba0a45$var$TimestampSecondsParser;

});

parcelRegister("je1c0", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $dff03ff1496c0b81$export$6d8f69c6906d6368, (v) => $dff03ff1496c0b81$export$6d8f69c6906d6368 = v);
var $dff03ff1496c0b81$export$6d8f69c6906d6368;
"use strict";
$dff03ff1496c0b81$export$6d8f69c6906d6368 = void 0;

var $eK5z7 = parcelRequire("eK5z7");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $dff03ff1496c0b81$var$TimestampMillisecondsParser extends $g9CO5.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $aHGaK.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $eK5z7.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$dff03ff1496c0b81$export$6d8f69c6906d6368 = $dff03ff1496c0b81$var$TimestampMillisecondsParser;

});



parcelRegister("jD0I3", function(module, exports) {

$parcel$export(module.exports, "setDate", () => $e4a235b7a447c4f0$export$566174fa40823587, (v) => $e4a235b7a447c4f0$export$566174fa40823587 = v);
var $e4a235b7a447c4f0$export$566174fa40823587;
"use strict";
$e4a235b7a447c4f0$export$566174fa40823587 = $e4a235b7a447c4f0$var$setDate;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $e4a235b7a447c4f0$var$setDate(date, dayOfMonth) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

});

parcelRegister("8l96w", function(module, exports) {

$parcel$export(module.exports, "setHours", () => $612758c85246c1d0$export$f86b797a4659b781, (v) => $612758c85246c1d0$export$f86b797a4659b781 = v);
var $612758c85246c1d0$export$f86b797a4659b781;
"use strict";
$612758c85246c1d0$export$f86b797a4659b781 = $612758c85246c1d0$var$setHours;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $612758c85246c1d0$var$setHours(date, hours) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRegister("JJ6gI", function(module, exports) {

$parcel$export(module.exports, "setMinutes", () => $089730068462d950$export$ad569bf1c79ea89d, (v) => $089730068462d950$export$ad569bf1c79ea89d = v);
var $089730068462d950$export$ad569bf1c79ea89d;
"use strict";
$089730068462d950$export$ad569bf1c79ea89d = $089730068462d950$var$setMinutes;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $089730068462d950$var$setMinutes(date, minutes) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRegister("1VSw7", function(module, exports) {

$parcel$export(module.exports, "setMonth", () => $16856745969af5fc$export$63264690f8e36790, (v) => $16856745969af5fc$export$63264690f8e36790 = v);
var $16856745969af5fc$export$63264690f8e36790;
"use strict";
$16856745969af5fc$export$63264690f8e36790 = $16856745969af5fc$var$setMonth;

var $eK5z7 = parcelRequire("eK5z7");

var $7uieS = parcelRequire("7uieS");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $16856745969af5fc$var$setMonth(date, month) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $eK5z7.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $7uieS.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});

parcelRegister("f23Gj", function(module, exports) {

$parcel$export(module.exports, "setSeconds", () => $af19e5fb9b37deaf$export$aec44746644cbf43, (v) => $af19e5fb9b37deaf$export$aec44746644cbf43 = v);
var $af19e5fb9b37deaf$export$aec44746644cbf43;
"use strict";
$af19e5fb9b37deaf$export$aec44746644cbf43 = $af19e5fb9b37deaf$var$setSeconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $af19e5fb9b37deaf$var$setSeconds(date, seconds) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRegister("iOqGj", function(module, exports) {

$parcel$export(module.exports, "setMilliseconds", () => $db2197e0fa774070$export$de5664029b35e06d, (v) => $db2197e0fa774070$export$de5664029b35e06d = v);
var $db2197e0fa774070$export$de5664029b35e06d;
"use strict";
$db2197e0fa774070$export$de5664029b35e06d = $db2197e0fa774070$var$setMilliseconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $db2197e0fa774070$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

});

parcelRegister("75Jn2", function(module, exports) {

$parcel$export(module.exports, "setYear", () => $529c31b1ede64581$export$a8408b6c5639cab7, (v) => $529c31b1ede64581$export$a8408b6c5639cab7 = v);
var $529c31b1ede64581$export$a8408b6c5639cab7;
"use strict";
$529c31b1ede64581$export$a8408b6c5639cab7 = $529c31b1ede64581$var$setYear;

var $eK5z7 = parcelRequire("eK5z7");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $529c31b1ede64581$var$setYear(date, year) {
    const _date = (0, $30SVQ.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $eK5z7.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRegister("gxLWY", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", () => $c0b4ec5551eca4c9$export$a5a3b454ada2268e, (v) => $c0b4ec5551eca4c9$export$a5a3b454ada2268e = v);
var $c0b4ec5551eca4c9$export$a5a3b454ada2268e;
"use strict";
$c0b4ec5551eca4c9$export$a5a3b454ada2268e = $c0b4ec5551eca4c9$var$startOfMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $c0b4ec5551eca4c9$var$startOfMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("jHGP1", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", () => $e58340063d97ab50$export$a2258d9c4118825c, (v) => $e58340063d97ab50$export$a2258d9c4118825c = v);
var $e58340063d97ab50$export$a2258d9c4118825c;
"use strict";
$e58340063d97ab50$export$a2258d9c4118825c = $e58340063d97ab50$var$endOfMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $e58340063d97ab50$var$endOfMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("dzPMY", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", () => $9e26b76e988d89a9$export$d7deef7a3738e19d, (v) => $9e26b76e988d89a9$export$d7deef7a3738e19d = v);
var $9e26b76e988d89a9$export$d7deef7a3738e19d;
"use strict";
$9e26b76e988d89a9$export$d7deef7a3738e19d = $9e26b76e988d89a9$var$isWithinInterval;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $9e26b76e988d89a9$var$isWithinInterval(date, interval) {
    const time = +(0, $30SVQ.toDate)(date);
    const [startTime, endTime] = [
        +(0, $30SVQ.toDate)(interval.start),
        +(0, $30SVQ.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRegister("a8CH1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "AdapterDateFnsBase", {
    enumerable: true,
    get: function() {
        return $bBBcI.AdapterDateFnsBase;
    }
});

var $bBBcI = parcelRequire("bBBcI");

});
parcelRegister("bBBcI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8730025af2ed6349$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdapterDateFnsBase = void 0;

var $8730025af2ed6349$var$_extends2 = $8730025af2ed6349$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $8730025af2ed6349$var$formatTokenMap = {
    // Year
    y: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yy: 'year',
    yyy: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yyyy: 'year',
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    L: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    LL: 'month',
    LLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    LLLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    d: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    dd: 'day',
    do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    E: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    i: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ii: 'weekDay',
    iii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    iiii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // eslint-disable-next-line id-denylist
    e: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ee: 'weekDay',
    eee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    c: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    cc: 'weekDay',
    ccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    a: 'meridiem',
    aa: 'meridiem',
    aaa: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $8730025af2ed6349$var$defaultFormats = {
    year: 'yyyy',
    month: 'LLLL',
    monthShort: 'MMM',
    dayOfMonth: 'd',
    dayOfMonthFull: 'do',
    weekday: 'EEEE',
    weekdayShort: 'EEEEEE',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'aa',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'PP',
    keyboardDate: 'P',
    shortDate: 'MMM d',
    normalDate: 'd MMMM',
    normalDateWithWeekday: 'EEE, MMM d',
    fullTime12h: 'hh:mm aa',
    fullTime24h: 'HH:mm',
    keyboardDateTime12h: 'P hh:mm aa',
    keyboardDateTime24h: 'P HH:mm'
};
/**
 * Based on `@date-io/date-fns`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ class $8730025af2ed6349$var$AdapterDateFnsBase {
    isMUIAdapter = true;
    isTimezoneCompatible = false;
    formatTokenMap = $8730025af2ed6349$var$formatTokenMap;
    escapedCharacters = {
        start: "'",
        end: "'"
    };
    constructor(props){
        const { locale: locale, formats: formats, longFormatters: longFormatters, lib: lib } = props;
        this.locale = locale;
        this.formats = (0, $8730025af2ed6349$var$_extends2.default)({}, $8730025af2ed6349$var$defaultFormats, formats);
        this.longFormatters = longFormatters;
        this.lib = lib || 'date-fns';
    }
    date = (value)=>{
        if (typeof value === 'undefined') return new Date();
        if (value === null) return null;
        return new Date(value);
    };
    getInvalidDate = ()=>new Date('Invalid Date');
    getTimezone = ()=>{
        return 'default';
    };
    setTimezone = (value)=>{
        return value;
    };
    toJsDate = (value)=>{
        return value;
    };
    getCurrentLocaleCode = ()=>{
        // `code` is undefined only in `date-fns` types, but all locales have it
        return this.locale.code;
    };
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    is12HourCycleInCurrentLocale = ()=>{
        return /a/.test(this.locale.formatLong.time({
            width: 'short'
        }));
    };
    expandFormat = (format)=>{
        const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
        // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
        return format.match(longFormatRegexp).map((token)=>{
            const firstCharacter = token[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
                const longFormatter = this.longFormatters[firstCharacter];
                return longFormatter(token, this.locale.formatLong);
            }
            return token;
        }).join('');
    };
    formatNumber = (numberToFormat)=>{
        return numberToFormat;
    };
    getDayOfWeek = (value)=>{
        return value.getDay() + 1;
    };
}
module.exports.AdapterDateFnsBase = $8730025af2ed6349$var$AdapterDateFnsBase;

});




parcelRegister("dNxct", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DateTimePicker", {
    enumerable: true,
    get: function() {
        return $dXB4Y.DateTimePicker;
    }
});
Object.defineProperty(module.exports, "DateTimePickerTabs", {
    enumerable: true,
    get: function() {
        return $dzkyd.DateTimePickerTabs;
    }
});
Object.defineProperty(module.exports, "DateTimePickerToolbar", {
    enumerable: true,
    get: function() {
        return $gZb82.DateTimePickerToolbar;
    }
});
Object.defineProperty(module.exports, "dateTimePickerTabsClasses", {
    enumerable: true,
    get: function() {
        return $an26n.dateTimePickerTabsClasses;
    }
});
Object.defineProperty(module.exports, "dateTimePickerToolbarClasses", {
    enumerable: true,
    get: function() {
        return $frSrH.dateTimePickerToolbarClasses;
    }
});

var $dXB4Y = parcelRequire("dXB4Y");

var $dzkyd = parcelRequire("dzkyd");

var $an26n = parcelRequire("an26n");

var $gZb82 = parcelRequire("gZb82");

var $frSrH = parcelRequire("frSrH");

});
parcelRegister("dXB4Y", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a29d8c31e22f2a54$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a29d8c31e22f2a54$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimePicker = void 0;

var $a29d8c31e22f2a54$var$_extends2 = $a29d8c31e22f2a54$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a29d8c31e22f2a54$var$_objectWithoutPropertiesLoose2 = $a29d8c31e22f2a54$require$_interopRequireDefault((parcelRequire("c05no")));

var $a29d8c31e22f2a54$var$React = $a29d8c31e22f2a54$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a29d8c31e22f2a54$var$_propTypes = $a29d8c31e22f2a54$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a29d8c31e22f2a54$var$_useMediaQuery = $a29d8c31e22f2a54$require$_interopRequireDefault((parcelRequire("18tt9")));

var $6g9fa = parcelRequire("6g9fa");

var $a29d8c31e22f2a54$var$_refType = $a29d8c31e22f2a54$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $13GLd = parcelRequire("13GLd");

var $l0Lh3 = parcelRequire("l0Lh3");

var $l16rr = parcelRequire("l16rr");

var $ayMG0 = parcelRequire("ayMG0");
const $a29d8c31e22f2a54$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateTimePicker API](https://mui.com/x/api/date-pickers/date-time-picker/)
 */ const $a29d8c31e22f2a54$var$DateTimePicker = module.exports.DateTimePicker = /*#__PURE__*/ $a29d8c31e22f2a54$var$React.forwardRef(function DateTimePicker(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiDateTimePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = $l16rr.DEFAULT_DESKTOP_MODE_MEDIA_QUERY } = props, other = (0, $a29d8c31e22f2a54$var$_objectWithoutPropertiesLoose2.default)(props, $a29d8c31e22f2a54$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $a29d8c31e22f2a54$var$_useMediaQuery.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $ayMG0.jsx)($13GLd.DesktopDateTimePicker, (0, $a29d8c31e22f2a54$var$_extends2.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($l0Lh3.MobileDateTimePicker, (0, $a29d8c31e22f2a54$var$_extends2.default)({
        ref: ref
    }, other));
});

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6g9fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $48eb684ebe9272b4$export$2e2bcd8739ae039);

var $7qEX0 = parcelRequire("7qEX0");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $48eb684ebe9272b4$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $7qEX0.default)({
        props: props,
        name: name,
        defaultTheme: $jR9F1.default,
        themeId: (0, $4jPsi.default)
    });
}

});

parcelRegister("8KGQh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65f3da3426cc7b19$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $65f3da3426cc7b19$var$_refType.default;
    }
});

var $65f3da3426cc7b19$var$_refType = $65f3da3426cc7b19$require$_interopRequireDefault((parcelRequire("dImBr")));

});
parcelRegister("dImBr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9fc0eadfdf3488bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fc0eadfdf3488bc$var$_propTypes = $9fc0eadfdf3488bc$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $9fc0eadfdf3488bc$var$refType = $9fc0eadfdf3488bc$var$_propTypes.default.oneOfType([
    $9fc0eadfdf3488bc$var$_propTypes.default.func,
    $9fc0eadfdf3488bc$var$_propTypes.default.object
]);
var $9fc0eadfdf3488bc$var$_default = module.exports.default = $9fc0eadfdf3488bc$var$refType;

});


parcelRegister("13GLd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DesktopDateTimePicker", {
    enumerable: true,
    get: function() {
        return $a4b7X.DesktopDateTimePicker;
    }
});
Object.defineProperty(module.exports, "DesktopDateTimePickerLayout", {
    enumerable: true,
    get: function() {
        return $aZ46o.DesktopDateTimePickerLayout;
    }
});

var $a4b7X = parcelRequire("a4b7X");

var $aZ46o = parcelRequire("aZ46o");

});
parcelRegister("a4b7X", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7542e8c92ad4e15b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7542e8c92ad4e15b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DesktopDateTimePicker = void 0;

var $7542e8c92ad4e15b$var$_extends2 = $7542e8c92ad4e15b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7542e8c92ad4e15b$var$_objectWithoutPropertiesLoose2 = $7542e8c92ad4e15b$require$_interopRequireDefault((parcelRequire("c05no")));

var $7542e8c92ad4e15b$var$React = $7542e8c92ad4e15b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7542e8c92ad4e15b$var$_propTypes = $7542e8c92ad4e15b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7542e8c92ad4e15b$var$_resolveComponentProps = $7542e8c92ad4e15b$require$_interopRequireDefault((parcelRequire("4sXkv")));

var $7542e8c92ad4e15b$var$_refType = $7542e8c92ad4e15b$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $7542e8c92ad4e15b$var$_Divider = $7542e8c92ad4e15b$require$_interopRequireDefault((parcelRequire("g6BeY")));

var $1M3bL = parcelRequire("1M3bL");

var $2EpWj = parcelRequire("2EpWj");

var $jHZPa = parcelRequire("jHZPa");

var $8uN0h = parcelRequire("8uN0h");

var $3nE24 = parcelRequire("3nE24");

var $5UoGz = parcelRequire("5UoGz");

var $1hdeH = parcelRequire("1hdeH");

var $3eed6 = parcelRequire("3eed6");

var $l5kHo = parcelRequire("l5kHo");

var $2QxZ0 = parcelRequire("2QxZ0");

var $hOsJb = parcelRequire("hOsJb");

var $aZ46o = parcelRequire("aZ46o");

var $99eO4 = parcelRequire("99eO4");

var $cElCc = parcelRequire("cElCc");

var $NRNex = parcelRequire("NRNex");

var $ayMG0 = parcelRequire("ayMG0");
const $7542e8c92ad4e15b$var$_excluded = [
    "openTo",
    "focusedView",
    "timeViewsCount"
];
const $7542e8c92ad4e15b$var$rendererInterceptor = function RendererInterceptor(props) {
    const { viewRenderers: viewRenderers, popperView: popperView, rendererProps: rendererProps } = props;
    const { openTo: openTo, focusedView: focusedView, timeViewsCount: timeViewsCount } = rendererProps, otherProps = (0, $7542e8c92ad4e15b$var$_objectWithoutPropertiesLoose2.default)(rendererProps, $7542e8c92ad4e15b$var$_excluded);
    const finalProps = (0, $7542e8c92ad4e15b$var$_extends2.default)({}, otherProps, {
        // we control the focused view manually
        autoFocus: false,
        focusedView: null,
        sx: [
            {
                [`&.${$2QxZ0.multiSectionDigitalClockClasses.root}`]: {
                    borderBottom: 0
                },
                [`&.${$2QxZ0.multiSectionDigitalClockClasses.root}, .${$2QxZ0.multiSectionDigitalClockSectionClasses.root}, &.${$hOsJb.digitalClockClasses.root}`]: {
                    maxHeight: $99eO4.VIEW_HEIGHT
                }
            }
        ]
    });
    const isTimeViewActive = (0, $cElCc.isInternalTimeView)(popperView);
    const dateView = isTimeViewActive ? 'day' : popperView;
    const timeView = isTimeViewActive ? popperView : 'hours';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7542e8c92ad4e15b$var$React.Fragment, {
        children: [
            viewRenderers[dateView]?.((0, $7542e8c92ad4e15b$var$_extends2.default)({}, rendererProps, {
                view: !isTimeViewActive ? popperView : 'day',
                focusedView: focusedView && (0, $NRNex.isDatePickerView)(focusedView) ? focusedView : null,
                views: rendererProps.views.filter($NRNex.isDatePickerView),
                sx: [
                    {
                        gridColumn: 1
                    },
                    ...finalProps.sx
                ]
            })),
            timeViewsCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($7542e8c92ad4e15b$var$React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7542e8c92ad4e15b$var$_Divider.default, {
                        orientation: "vertical",
                        sx: {
                            gridColumn: 2
                        }
                    }),
                    viewRenderers[timeView]?.((0, $7542e8c92ad4e15b$var$_extends2.default)({}, finalProps, {
                        view: isTimeViewActive ? popperView : 'hours',
                        focusedView: focusedView && (0, $cElCc.isInternalTimeView)(focusedView) ? focusedView : null,
                        openTo: (0, $cElCc.isInternalTimeView)(openTo) ? openTo : 'hours',
                        views: rendererProps.views.filter($cElCc.isInternalTimeView),
                        sx: [
                            {
                                gridColumn: 3
                            },
                            ...finalProps.sx
                        ]
                    }))
                ]
            })
        ]
    });
};
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDateTimePicker API](https://mui.com/x/api/date-pickers/desktop-date-time-picker/)
 */ const $7542e8c92ad4e15b$var$DesktopDateTimePicker = module.exports.DesktopDateTimePicker = /*#__PURE__*/ $7542e8c92ad4e15b$var$React.forwardRef(function DesktopDateTimePicker(inProps, ref) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $jHZPa.useDateTimePickerDefaultizedProps)(inProps, 'MuiDesktopDateTimePicker');
    const renderTimeView = defaultizedProps.shouldRenderTimeInASingleColumn ? $l5kHo.renderDigitalClockTimeView : $l5kHo.renderMultiSectionDigitalClockTimeView;
    const viewRenderers = (0, $7542e8c92ad4e15b$var$_extends2.default)({
        day: $8uN0h.renderDateViewCalendar,
        month: $8uN0h.renderDateViewCalendar,
        year: $8uN0h.renderDateViewCalendar,
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? true;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === $l5kHo.renderMultiSectionDigitalClockTimeView.name;
    const views = !shouldHoursRendererContainMeridiemView ? defaultizedProps.views.filter((view)=>view !== 'meridiem') : defaultizedProps.views;
    // Props with the default values specific to the desktop variant
    const props = (0, $7542e8c92ad4e15b$var$_extends2.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $3eed6.resolveDateTimeFormat)(adapter, defaultizedProps),
        views: views,
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        ampmInClock: ampmInClock,
        slots: (0, $7542e8c92ad4e15b$var$_extends2.default)({
            field: $2EpWj.DateTimeField,
            layout: $aZ46o.DesktopDateTimePickerLayout
        }, defaultizedProps.slots),
        slotProps: (0, $7542e8c92ad4e15b$var$_extends2.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $7542e8c92ad4e15b$var$_extends2.default)({}, (0, $7542e8c92ad4e15b$var$_resolveComponentProps.default)(defaultizedProps.slotProps?.field, ownerState), (0, $5UoGz.extractValidationProps)(defaultizedProps)),
            toolbar: (0, $7542e8c92ad4e15b$var$_extends2.default)({
                hidden: true,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $7542e8c92ad4e15b$var$_extends2.default)({
                hidden: true
            }, defaultizedProps.slotProps?.tabs)
        })
    });
    const { renderPicker: renderPicker } = (0, $1hdeH.useDesktopPicker)({
        ref: ref,
        props: props,
        valueManager: $1M3bL.singleItemValueManager,
        valueType: 'date-time',
        validator: $5UoGz.validateDateTime,
        rendererInterceptor: $7542e8c92ad4e15b$var$rendererInterceptor,
        steps: null
    });
    return renderPicker();
});
$7542e8c92ad4e15b$var$DesktopDateTimePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default adapter.is12HourCycleInCurrentLocale()
   */ ampm: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    className: $7542e8c92ad4e15b$var$_propTypes.default.string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: $7542e8c92ad4e15b$var$_propTypes.default.any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: $7542e8c92ad4e15b$var$_propTypes.default.number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: $7542e8c92ad4e15b$var$_propTypes.default.string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: $7542e8c92ad4e15b$var$_propTypes.default.oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $7542e8c92ad4e15b$var$_refType.default,
    /**
   * The label content.
   */ label: $7542e8c92ad4e15b$var$_propTypes.default.node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: $7542e8c92ad4e15b$var$_propTypes.default.number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: $7542e8c92ad4e15b$var$_propTypes.default.oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: $7542e8c92ad4e15b$var$_propTypes.default.string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: $7542e8c92ad4e15b$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: $7542e8c92ad4e15b$var$_propTypes.default.oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: $7542e8c92ad4e15b$var$_propTypes.default.oneOfType([
        $7542e8c92ad4e15b$var$_propTypes.default.oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        $7542e8c92ad4e15b$var$_propTypes.default.number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Disable specific time.
   * @param {PickerValidDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: $7542e8c92ad4e15b$var$_propTypes.default.func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: $7542e8c92ad4e15b$var$_propTypes.default.bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $7542e8c92ad4e15b$var$_propTypes.default.oneOfType([
        $7542e8c92ad4e15b$var$_propTypes.default.arrayOf($7542e8c92ad4e15b$var$_propTypes.default.oneOfType([
            $7542e8c92ad4e15b$var$_propTypes.default.func,
            $7542e8c92ad4e15b$var$_propTypes.default.object,
            $7542e8c92ad4e15b$var$_propTypes.default.bool
        ])),
        $7542e8c92ad4e15b$var$_propTypes.default.func,
        $7542e8c92ad4e15b$var$_propTypes.default.object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: $7542e8c92ad4e15b$var$_propTypes.default.number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeSteps.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeSteps.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: $7542e8c92ad4e15b$var$_propTypes.default.shape({
        hours: $7542e8c92ad4e15b$var$_propTypes.default.number,
        minutes: $7542e8c92ad4e15b$var$_propTypes.default.number,
        seconds: $7542e8c92ad4e15b$var$_propTypes.default.number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: $7542e8c92ad4e15b$var$_propTypes.default.string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: $7542e8c92ad4e15b$var$_propTypes.default.object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: $7542e8c92ad4e15b$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: $7542e8c92ad4e15b$var$_propTypes.default.shape({
        day: $7542e8c92ad4e15b$var$_propTypes.default.func,
        hours: $7542e8c92ad4e15b$var$_propTypes.default.func,
        meridiem: $7542e8c92ad4e15b$var$_propTypes.default.func,
        minutes: $7542e8c92ad4e15b$var$_propTypes.default.func,
        month: $7542e8c92ad4e15b$var$_propTypes.default.func,
        seconds: $7542e8c92ad4e15b$var$_propTypes.default.func,
        year: $7542e8c92ad4e15b$var$_propTypes.default.func
    }),
    /**
   * Available views.
   */ views: $7542e8c92ad4e15b$var$_propTypes.default.arrayOf($7542e8c92ad4e15b$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: $7542e8c92ad4e15b$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: $7542e8c92ad4e15b$var$_propTypes.default.oneOf([
        3,
        4
    ])
};

});
parcelRegister("4sXkv", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3407cc92f33abe00$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3407cc92f33abe00$var$_resolveComponentProps.default;
    }
});

var $3407cc92f33abe00$var$_resolveComponentProps = $3407cc92f33abe00$require$_interopRequireDefault((parcelRequire("bs2yT")));

});
parcelRegister("bs2yT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $0226c76b41a4a51a$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $0226c76b41a4a51a$var$_default = module.exports.default = $0226c76b41a4a51a$var$resolveComponentProps;

});


parcelRegister("g6BeY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("lkxXU")).default);
$parcel$export(module.exports, "dividerClasses", () => (parcelRequire("cbVYE")).default);

var $lkxXU = parcelRequire("lkxXU");

var $cbVYE = parcelRequire("cbVYE");
$parcel$exportWildcard(module.exports, $cbVYE);

});

parcelRegister("1M3bL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $14acbf5609fff29c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.singleItemValueManager = module.exports.singleItemFieldValueManager = void 0;

var $14acbf5609fff29c$var$_extends2 = $14acbf5609fff29c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $14acbf5609fff29c$var$_objectWithoutPropertiesLoose2 = $14acbf5609fff29c$require$_interopRequireDefault((parcelRequire("c05no")));

var $NRNex = parcelRequire("NRNex");

var $gUrai = parcelRequire("gUrai");

var $l9aHF = parcelRequire("l9aHF");
const $14acbf5609fff29c$var$_excluded = [
    "value",
    "referenceDate"
];
const $14acbf5609fff29c$var$singleItemValueManager = module.exports.singleItemValueManager = {
    emptyValue: null,
    getTodayValue: $NRNex.getTodayDate,
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $14acbf5609fff29c$var$_objectWithoutPropertiesLoose2.default)(_ref, $14acbf5609fff29c$var$_excluded);
        if (params.adapter.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $gUrai.getDefaultReferenceDate)(params);
    },
    cleanValue: $NRNex.replaceInvalidDateByNull,
    areValuesEqual: $NRNex.areDatesEqual,
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (adapter, value)=>adapter.isValid(value) ? adapter.getTimezone(value) : null,
    setTimezone: (adapter, timezone, value)=>value == null ? null : adapter.setTimezone(value, timezone)
};
const $14acbf5609fff29c$var$singleItemFieldValueManager = module.exports.singleItemFieldValueManager = {
    updateReferenceValue: (adapter, value, prevReferenceValue)=>adapter.isValid(value) ? value : prevReferenceValue,
    getSectionsFromValue: (date, getSectionsFromDate)=>getSectionsFromDate(date),
    getV7HiddenInputValueFromSections: $l9aHF.createDateStrForV7HiddenInputFromSections,
    getV6InputValueFromSections: $l9aHF.createDateStrForV6InputFromSections,
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue),
    getDateFromSection: (value)=>value,
    getDateSectionsFromValue: (sections)=>sections,
    updateDateInValue: (value, activeSection, activeDate)=>activeDate,
    clearDateSections: (sections)=>sections.map((section)=>(0, $14acbf5609fff29c$var$_extends2.default)({}, section, {
                value: ''
            }))
};

});
parcelRegister("NRNex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveDateFormat = module.exports.replaceInvalidDateByNull = module.exports.mergeDateAndTime = module.exports.isDatePickerView = module.exports.getWeekdays = module.exports.getTodayDate = module.exports.getMonthsInYear = module.exports.formatMeridiem = module.exports.findClosestEnabledDate = module.exports.areDatesEqual = module.exports.applyDefaultDate = module.exports.DATE_VIEWS = void 0;

var $kqIjR = parcelRequire("kqIjR");
const $095e4de7afe66795$var$mergeDateAndTime = (adapter, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = adapter.setHours(mergedDate, adapter.getHours(timeParam));
    mergedDate = adapter.setMinutes(mergedDate, adapter.getMinutes(timeParam));
    mergedDate = adapter.setSeconds(mergedDate, adapter.getSeconds(timeParam));
    mergedDate = adapter.setMilliseconds(mergedDate, adapter.getMilliseconds(timeParam));
    return mergedDate;
};
module.exports.mergeDateAndTime = $095e4de7afe66795$var$mergeDateAndTime;
const $095e4de7afe66795$var$findClosestEnabledDate = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, adapter: adapter, timezone: timezone })=>{
    const today = $095e4de7afe66795$var$mergeDateAndTime(adapter, adapter.date(undefined, timezone), date);
    if (disablePast && adapter.isBefore(minDate, today)) minDate = today;
    if (disableFuture && adapter.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (adapter.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (adapter.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && adapter.isAfter(forward, maxDate)) forward = null;
        if (backward && adapter.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = adapter.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = adapter.addDays(backward, -1);
        }
    }
    return null;
};
module.exports.findClosestEnabledDate = $095e4de7afe66795$var$findClosestEnabledDate;
const $095e4de7afe66795$var$replaceInvalidDateByNull = (adapter, value)=>!adapter.isValid(value) ? null : value;
module.exports.replaceInvalidDateByNull = $095e4de7afe66795$var$replaceInvalidDateByNull;
const $095e4de7afe66795$var$applyDefaultDate = (adapter, value, defaultValue)=>{
    if (value == null || !adapter.isValid(value)) return defaultValue;
    return value;
};
module.exports.applyDefaultDate = $095e4de7afe66795$var$applyDefaultDate;
const $095e4de7afe66795$var$areDatesEqual = (adapter, a, b)=>{
    if (!adapter.isValid(a) && a != null && !adapter.isValid(b) && b != null) return true;
    return adapter.isEqual(a, b);
};
module.exports.areDatesEqual = $095e4de7afe66795$var$areDatesEqual;
const $095e4de7afe66795$var$getMonthsInYear = (adapter, year)=>{
    const firstMonth = adapter.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(adapter.addMonths(prevMonth, 1));
    }
    return months;
};
module.exports.getMonthsInYear = $095e4de7afe66795$var$getMonthsInYear;
const $095e4de7afe66795$var$getTodayDate = (adapter, timezone, valueType)=>valueType === 'date' ? adapter.startOfDay(adapter.date(undefined, timezone)) : adapter.date(undefined, timezone);
module.exports.getTodayDate = $095e4de7afe66795$var$getTodayDate;
const $095e4de7afe66795$var$formatMeridiem = (adapter, meridiem)=>{
    const date = adapter.setHours(adapter.date(), meridiem === 'am' ? 2 : 14);
    return adapter.format(date, 'meridiem');
};
module.exports.formatMeridiem = $095e4de7afe66795$var$formatMeridiem;
const $095e4de7afe66795$var$DATE_VIEWS = module.exports.DATE_VIEWS = [
    'year',
    'month',
    'day'
];
const $095e4de7afe66795$var$isDatePickerView = (view)=>$095e4de7afe66795$var$DATE_VIEWS.includes(view);
module.exports.isDatePickerView = $095e4de7afe66795$var$isDatePickerView;
const $095e4de7afe66795$var$resolveDateFormat = (adapter, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'year'
    ])) return formats.year;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'month'
    ])) return formats.month;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(adapter.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
module.exports.resolveDateFormat = $095e4de7afe66795$var$resolveDateFormat;
const $095e4de7afe66795$var$getWeekdays = (adapter, date)=>{
    const start = adapter.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>adapter.addDays(start, diff));
};
module.exports.getWeekdays = $095e4de7afe66795$var$getWeekdays;

});
parcelRegister("kqIjR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.areViewsEqual = module.exports.applyDefaultViewProps = void 0;
const $edf89d3e5f97447f$var$areViewsEqual = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
module.exports.areViewsEqual = $edf89d3e5f97447f$var$areViewsEqual;
const $edf89d3e5f97447f$var$applyDefaultViewProps = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};
module.exports.applyDefaultViewProps = $edf89d3e5f97447f$var$applyDefaultViewProps;

});


parcelRegister("gUrai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSectionTypeGranularity = module.exports.getDefaultReferenceDate = module.exports.SECTION_TYPE_GRANULARITY = void 0;

var $cElCc = parcelRequire("cElCc");

var $NRNex = parcelRequire("NRNex");
const $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY = module.exports.SECTION_TYPE_GRANULARITY = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $c4f6f2b8fcbb5fe9$var$getSectionTypeGranularity = (sections)=>Math.max(...sections.map((section)=>$c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY[section.type] ?? 1));
module.exports.getSectionTypeGranularity = $c4f6f2b8fcbb5fe9$var$getSectionTypeGranularity;
const $c4f6f2b8fcbb5fe9$var$roundDate = (adapter, granularity, date)=>{
    if (granularity === $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.year) return adapter.startOfYear(date);
    if (granularity === $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.month) return adapter.startOfMonth(date);
    if (granularity === $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.day) return adapter.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.minutes) roundedDate = adapter.setMinutes(roundedDate, 0);
    if (granularity < $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.seconds) roundedDate = adapter.setSeconds(roundedDate, 0);
    if (granularity < $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.milliseconds) roundedDate = adapter.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $c4f6f2b8fcbb5fe9$var$getDefaultReferenceDate = ({ props: props, adapter: adapter, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, (0, $NRNex.getTodayDate)(adapter, timezone));
    if (props.minDate != null && adapter.isAfterDay(props.minDate, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, props.minDate);
    if (props.maxDate != null && adapter.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, props.maxDate);
    const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(props.disableIgnoringDatePartForTimeValidation ?? false, adapter);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $NRNex.mergeDateAndTime)(adapter, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $NRNex.mergeDateAndTime)(adapter, referenceDate, props.maxTime));
    return referenceDate;
};
module.exports.getDefaultReferenceDate = $c4f6f2b8fcbb5fe9$var$getDefaultReferenceDate;

});
parcelRegister("cElCc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveTimeFormat = module.exports.isTimeView = module.exports.isInternalTimeView = module.exports.getSecondsInDay = module.exports.getMeridiem = module.exports.createIsAfterIgnoreDatePart = module.exports.convertValueToMeridiem = module.exports.convertToMeridiem = module.exports.TIME_VIEWS = module.exports.EXPORTED_TIME_VIEWS = void 0;

var $kqIjR = parcelRequire("kqIjR");
const $9359fccca2daa962$var$EXPORTED_TIME_VIEWS = module.exports.EXPORTED_TIME_VIEWS = [
    'hours',
    'minutes',
    'seconds'
];
const $9359fccca2daa962$var$TIME_VIEWS = module.exports.TIME_VIEWS = [
    'hours',
    'minutes',
    'seconds',
    'meridiem'
];
const $9359fccca2daa962$var$isTimeView = (view)=>$9359fccca2daa962$var$EXPORTED_TIME_VIEWS.includes(view);
module.exports.isTimeView = $9359fccca2daa962$var$isTimeView;
const $9359fccca2daa962$var$isInternalTimeView = (view)=>$9359fccca2daa962$var$TIME_VIEWS.includes(view);
module.exports.isInternalTimeView = $9359fccca2daa962$var$isInternalTimeView;
const $9359fccca2daa962$var$getMeridiem = (date, adapter)=>{
    if (!date) return null;
    return adapter.getHours(date) >= 12 ? 'pm' : 'am';
};
module.exports.getMeridiem = $9359fccca2daa962$var$getMeridiem;
const $9359fccca2daa962$var$convertValueToMeridiem = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
module.exports.convertValueToMeridiem = $9359fccca2daa962$var$convertValueToMeridiem;
const $9359fccca2daa962$var$convertToMeridiem = (time, meridiem, ampm, adapter)=>{
    const newHoursAmount = $9359fccca2daa962$var$convertValueToMeridiem(adapter.getHours(time), meridiem, ampm);
    return adapter.setHours(time, newHoursAmount);
};
module.exports.convertToMeridiem = $9359fccca2daa962$var$convertToMeridiem;
const $9359fccca2daa962$var$getSecondsInDay = (date, adapter)=>{
    return adapter.getHours(date) * 3600 + adapter.getMinutes(date) * 60 + adapter.getSeconds(date);
};
module.exports.getSecondsInDay = $9359fccca2daa962$var$getSecondsInDay;
const $9359fccca2daa962$var$createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, adapter)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return adapter.isAfter(dateLeft, dateRight);
        return $9359fccca2daa962$var$getSecondsInDay(dateLeft, adapter) > $9359fccca2daa962$var$getSecondsInDay(dateRight, adapter);
    };
module.exports.createIsAfterIgnoreDatePart = $9359fccca2daa962$var$createIsAfterIgnoreDatePart;
const $9359fccca2daa962$var$resolveTimeFormat = (adapter, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};
module.exports.resolveTimeFormat = $9359fccca2daa962$var$resolveTimeFormat;

});


parcelRegister("l9aHF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSections = module.exports.removeLocalizedDigits = module.exports.parseSelectedSections = module.exports.mergeDateIntoReferenceDate = module.exports.isStringNumber = module.exports.isAndroid = module.exports.getSectionsBoundaries = module.exports.getSectionVisibleValue = module.exports.getSectionOrder = module.exports.getLocalizedDigits = module.exports.getLetterEditingOptions = module.exports.getDaysInWeekStr = module.exports.getDateSectionConfigFromFormatToken = module.exports.getDateFromDateSections = module.exports.doesSectionFormatHaveLeadingZeros = module.exports.createDateStrForV7HiddenInputFromSections = module.exports.createDateStrForV6InputFromSections = module.exports.cleanLeadingZeros = module.exports.cleanDigitSectionValue = module.exports.changeSectionValueFormat = module.exports.applyLocalizedDigits = module.exports.FORMAT_SECONDS_NO_LEADING_ZEROS = void 0;

var $NRNex = parcelRequire("NRNex");
const $f652bdb72e319cb0$var$getDateSectionConfigFromFormatToken = (adapter, formatToken)=>{
    const config = adapter.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
module.exports.getDateSectionConfigFromFormatToken = $f652bdb72e319cb0$var$getDateSectionConfigFromFormatToken;
const $f652bdb72e319cb0$var$getDaysInWeekStr = (adapter, format)=>{
    const elements = [];
    const now = adapter.date(undefined, 'default');
    const startDate = adapter.startOfWeek(now);
    const endDate = adapter.endOfWeek(now);
    let current = startDate;
    while(adapter.isBefore(current, endDate)){
        elements.push(current);
        current = adapter.addDays(current, 1);
    }
    return elements.map((weekDay)=>adapter.formatByString(weekDay, format));
};
module.exports.getDaysInWeekStr = $f652bdb72e319cb0$var$getDaysInWeekStr;
const $f652bdb72e319cb0$var$getLetterEditingOptions = (adapter, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $NRNex.getMonthsInYear)(adapter, adapter.date(undefined, timezone)).map((month)=>adapter.formatByString(month, format));
        case 'weekDay':
            return $f652bdb72e319cb0$var$getDaysInWeekStr(adapter, format);
        case 'meridiem':
            {
                const now = adapter.date(undefined, timezone);
                return [
                    adapter.startOfDay(now),
                    adapter.endOfDay(now)
                ].map((date)=>adapter.formatByString(date, format));
            }
        default:
            return [];
    }
};
// This format should be the same on all the adapters
// If some adapter does not respect this convention, then we will need to hardcode the format on each adapter.
module.exports.getLetterEditingOptions = $f652bdb72e319cb0$var$getLetterEditingOptions;
const $f652bdb72e319cb0$var$FORMAT_SECONDS_NO_LEADING_ZEROS = module.exports.FORMAT_SECONDS_NO_LEADING_ZEROS = 's';
const $f652bdb72e319cb0$var$NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const $f652bdb72e319cb0$var$getLocalizedDigits = (adapter)=>{
    const today = adapter.date(undefined);
    const formattedZero = adapter.formatByString(adapter.setSeconds(today, 0), $f652bdb72e319cb0$var$FORMAT_SECONDS_NO_LEADING_ZEROS);
    if (formattedZero === '0') return $f652bdb72e319cb0$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>adapter.formatByString(adapter.setSeconds(today, index), $f652bdb72e319cb0$var$FORMAT_SECONDS_NO_LEADING_ZEROS));
};
module.exports.getLocalizedDigits = $f652bdb72e319cb0$var$getLocalizedDigits;
const $f652bdb72e319cb0$var$removeLocalizedDigits = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
module.exports.removeLocalizedDigits = $f652bdb72e319cb0$var$removeLocalizedDigits;
const $f652bdb72e319cb0$var$applyLocalizedDigits = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
module.exports.applyLocalizedDigits = $f652bdb72e319cb0$var$applyLocalizedDigits;
const $f652bdb72e319cb0$var$isStringNumber = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $f652bdb72e319cb0$var$removeLocalizedDigits(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
/**
 * Make sure the value of a digit section have the right amount of leading zeros.
 * E.g.: `03` => `3`
 * Warning: Should only be called with non-localized digits. Call `removeLocalizedDigits` with your value if needed.
 */ module.exports.isStringNumber = $f652bdb72e319cb0$var$isStringNumber;
const $f652bdb72e319cb0$var$cleanLeadingZeros = (valueStr, size)=>{
    // Remove the leading zeros and then add back as many as needed.
    return Number(valueStr).toString().padStart(size, '0');
};
module.exports.cleanLeadingZeros = $f652bdb72e319cb0$var$cleanLeadingZeros;
const $f652bdb72e319cb0$var$cleanDigitSectionValue = (adapter, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = adapter.setDate(sectionBoundaries.longestMonth, value);
        return adapter.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $f652bdb72e319cb0$var$cleanLeadingZeros(valueStr, section.maxLength);
    return $f652bdb72e319cb0$var$applyLocalizedDigits(valueStr, localizedDigits);
};
module.exports.cleanDigitSectionValue = $f652bdb72e319cb0$var$cleanDigitSectionValue;
const $f652bdb72e319cb0$var$getSectionVisibleValue = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($f652bdb72e319cb0$var$removeLocalizedDigits(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
module.exports.getSectionVisibleValue = $f652bdb72e319cb0$var$getSectionVisibleValue;
const $f652bdb72e319cb0$var$changeSectionValueFormat = (adapter, valueStr, currentFormat, newFormat)=>{
    return adapter.formatByString(adapter.parse(valueStr, currentFormat), newFormat);
};
module.exports.changeSectionValueFormat = $f652bdb72e319cb0$var$changeSectionValueFormat;
const $f652bdb72e319cb0$var$isFourDigitYearFormat = (adapter, format)=>adapter.formatByString(adapter.date(undefined, 'system'), format).length === 4;
const $f652bdb72e319cb0$var$doesSectionFormatHaveLeadingZeros = (adapter, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = adapter.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `adapter.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            // Remove once https://github.com/iamkun/dayjs/pull/2847 is merged and bump dayjs version
            if (adapter.lib === 'dayjs' && format === 'YY') return true;
            return adapter.formatByString(adapter.setYear(now, 1), format).startsWith('0');
        case 'month':
            return adapter.formatByString(adapter.startOfYear(now), format).length > 1;
        case 'day':
            return adapter.formatByString(adapter.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return adapter.formatByString(adapter.startOfWeek(now), format).length > 1;
        case 'hours':
            return adapter.formatByString(adapter.setHours(now, 1), format).length > 1;
        case 'minutes':
            return adapter.formatByString(adapter.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return adapter.formatByString(adapter.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
/**
 * Some date libraries like `dayjs` don't support parsing from date with escaped characters.
 * To make sure that the parsing works, we are building a format and a date without any separator.
 */ module.exports.doesSectionFormatHaveLeadingZeros = $f652bdb72e319cb0$var$doesSectionFormatHaveLeadingZeros;
const $f652bdb72e319cb0$var$getDateFromDateSections = (adapter, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($f652bdb72e319cb0$var$getSectionVisibleValue(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return adapter.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
module.exports.getDateFromDateSections = $f652bdb72e319cb0$var$getDateFromDateSections;
const $f652bdb72e319cb0$var$createDateStrForV7HiddenInputFromSections = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
module.exports.createDateStrForV7HiddenInputFromSections = $f652bdb72e319cb0$var$createDateStrForV7HiddenInputFromSections;
const $f652bdb72e319cb0$var$createDateStrForV6InputFromSections = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $f652bdb72e319cb0$var$getSectionVisibleValue(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
module.exports.createDateStrForV6InputFromSections = $f652bdb72e319cb0$var$createDateStrForV6InputFromSections;
const $f652bdb72e319cb0$var$getSectionsBoundaries = (adapter, localizedDigits, timezone)=>{
    const today = adapter.date(undefined, timezone);
    const endOfYear = adapter.endOfYear(today);
    const endOfDay = adapter.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $NRNex.getMonthsInYear)(adapter, today).reduce((acc, month)=>{
        const daysInMonth = adapter.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $f652bdb72e319cb0$var$isFourDigitYearFormat(adapter, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: adapter.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: adapter.isValid(currentDate) ? adapter.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $f652bdb72e319cb0$var$getDaysInWeekStr(adapter, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = adapter.getHours(endOfDay);
            const hasMeridiem = $f652bdb72e319cb0$var$removeLocalizedDigits(adapter.formatByString(adapter.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($f652bdb72e319cb0$var$removeLocalizedDigits(adapter.formatByString(adapter.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: adapter.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: adapter.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
module.exports.getSectionsBoundaries = $f652bdb72e319cb0$var$getSectionsBoundaries;
let $f652bdb72e319cb0$var$warnedOnceInvalidSection = false;
const $f652bdb72e319cb0$var$validateSections = (sections, valueType)=>{};
module.exports.validateSections = $f652bdb72e319cb0$var$validateSections;
const $f652bdb72e319cb0$var$transferDateSectionValue = (adapter, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return adapter.setYear(dateToTransferTo, adapter.getYear(dateToTransferFrom));
        case 'month':
            return adapter.setMonth(dateToTransferTo, adapter.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                let dayInWeekStrOfActiveDate = adapter.formatByString(dateToTransferFrom, section.format);
                if (section.hasLeadingZerosInInput) dayInWeekStrOfActiveDate = $f652bdb72e319cb0$var$cleanLeadingZeros(dayInWeekStrOfActiveDate, section.maxLength);
                const formattedDaysInWeek = $f652bdb72e319cb0$var$getDaysInWeekStr(adapter, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return adapter.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return adapter.setDate(dateToTransferTo, adapter.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = adapter.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = adapter.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return adapter.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return adapter.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return adapter.setHours(dateToTransferTo, adapter.getHours(dateToTransferFrom));
        case 'minutes':
            return adapter.setMinutes(dateToTransferTo, adapter.getMinutes(dateToTransferFrom));
        case 'seconds':
            return adapter.setSeconds(dateToTransferTo, adapter.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $f652bdb72e319cb0$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $f652bdb72e319cb0$var$mergeDateIntoReferenceDate = (adapter, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$f652bdb72e319cb0$var$reliableSectionModificationOrder[a.type] - $f652bdb72e319cb0$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $f652bdb72e319cb0$var$transferDateSectionValue(adapter, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
module.exports.mergeDateIntoReferenceDate = $f652bdb72e319cb0$var$mergeDateIntoReferenceDate;
const $f652bdb72e319cb0$var$isAndroid = ()=>navigator.userAgent.toLowerCase().includes('android');
// TODO v9: Remove
module.exports.isAndroid = $f652bdb72e319cb0$var$isAndroid;
const $f652bdb72e319cb0$var$getSectionOrder = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ');
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
module.exports.getSectionOrder = $f652bdb72e319cb0$var$getSectionOrder;
const $f652bdb72e319cb0$var$parseSelectedSections = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};
module.exports.parseSelectedSections = $f652bdb72e319cb0$var$parseSelectedSections;

});


parcelRegister("2EpWj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DateTimeField", {
    enumerable: true,
    get: function() {
        return $jRanZ.DateTimeField;
    }
});
Object.defineProperty(module.exports, "unstable_useDateTimeField", {
    enumerable: true,
    get: function() {
        return $dtG8S.useDateTimeField;
    }
});

var $jRanZ = parcelRequire("jRanZ");

var $dtG8S = parcelRequire("dtG8S");

});
parcelRegister("jRanZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e74b05fedf1e5845$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e74b05fedf1e5845$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimeField = void 0;

var $e74b05fedf1e5845$var$_objectWithoutPropertiesLoose2 = $e74b05fedf1e5845$require$_interopRequireDefault((parcelRequire("c05no")));

var $e74b05fedf1e5845$var$React = $e74b05fedf1e5845$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e74b05fedf1e5845$var$_propTypes = $e74b05fedf1e5845$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6g9fa = parcelRequire("6g9fa");

var $e74b05fedf1e5845$var$_refType = $e74b05fedf1e5845$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $dtG8S = parcelRequire("dtG8S");

var $w6zXP = parcelRequire("w6zXP");

var $1SVAo = parcelRequire("1SVAo");

var $ayMG0 = parcelRequire("ayMG0");
const $e74b05fedf1e5845$var$_excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateTimeField](http://mui.com/x/react-date-pickers/date-time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateTimeField API](https://mui.com/x/api/date-pickers/date-time-field/)
 */ const $e74b05fedf1e5845$var$DateTimeField = module.exports.DateTimeField = /*#__PURE__*/ $e74b05fedf1e5845$var$React.forwardRef(function DateTimeField(inProps, inRef) {
    const themeProps = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiDateTimeField'
    });
    const { slots: slots, slotProps: slotProps } = themeProps, other = (0, $e74b05fedf1e5845$var$_objectWithoutPropertiesLoose2.default)(themeProps, $e74b05fedf1e5845$var$_excluded);
    const textFieldProps = (0, $w6zXP.useFieldTextFieldProps)({
        slotProps: slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, $dtG8S.useDateTimeField)(textFieldProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($w6zXP.PickerFieldUI, {
        slots: slots,
        slotProps: slotProps,
        fieldResponse: fieldResponse,
        defaultOpenPickerIcon: $1SVAo.CalendarIcon
    });
});

});
parcelRegister("dtG8S", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDateTimeField = void 0;

var $g3v6z = parcelRequire("g3v6z");

var $8tpPE = parcelRequire("8tpPE");
const $9cfeac5d7b0a3dba$var$useDateTimeField = (props)=>{
    const manager = (0, $8tpPE.useDateTimeManager)(props);
    return (0, $g3v6z.useField)({
        manager: manager,
        props: props
    });
};
module.exports.useDateTimeField = $9cfeac5d7b0a3dba$var$useDateTimeField;

});
parcelRegister("g3v6z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createDateStrForV6InputFromSections", {
    enumerable: true,
    get: function() {
        return $l9aHF.createDateStrForV6InputFromSections;
    }
});
Object.defineProperty(module.exports, "createDateStrForV7HiddenInputFromSections", {
    enumerable: true,
    get: function() {
        return $l9aHF.createDateStrForV7HiddenInputFromSections;
    }
});
Object.defineProperty(module.exports, "useField", {
    enumerable: true,
    get: function() {
        return $j9lLh.useField;
    }
});
Object.defineProperty(module.exports, "useFieldInternalPropsWithDefaults", {
    enumerable: true,
    get: function() {
        return $8wNUU.useFieldInternalPropsWithDefaults;
    }
});

var $j9lLh = parcelRequire("j9lLh");

var $l9aHF = parcelRequire("l9aHF");

var $8wNUU = parcelRequire("8wNUU");

});
parcelRegister("j9lLh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useField = void 0;

var $fgmlt = parcelRequire("fgmlt");

var $3Pdrd = parcelRequire("3Pdrd");

var $6zwRZ = parcelRequire("6zwRZ");
const $df0fbd014072b490$var$useField = (parameters)=>{
    const fieldPrivateContext = (0, $6zwRZ.useNullableFieldPrivateContext)();
    const enableAccessibleFieldDOMStructure = parameters.props.enableAccessibleFieldDOMStructure ?? fieldPrivateContext?.enableAccessibleFieldDOMStructure ?? true;
    const useFieldTextField = enableAccessibleFieldDOMStructure ? $fgmlt.useFieldV7TextField : $3Pdrd.useFieldV6TextField;
    return useFieldTextField(parameters);
};
module.exports.useField = $df0fbd014072b490$var$useField;

});
parcelRegister("fgmlt", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b1c9aeef70035656$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b1c9aeef70035656$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldV7TextField = void 0;

var $b1c9aeef70035656$var$_extends2 = $b1c9aeef70035656$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b1c9aeef70035656$var$React = $b1c9aeef70035656$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b1c9aeef70035656$var$_useForkRef = $b1c9aeef70035656$require$_interopRequireDefault((parcelRequire("88PIk")));

var $b1c9aeef70035656$var$_useEventCallback = $b1c9aeef70035656$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $b1c9aeef70035656$var$_useEnhancedEffect = $b1c9aeef70035656$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $l9aHF = parcelRequire("l9aHF");

var $l16rr = parcelRequire("l16rr");

var $BKARN = parcelRequire("BKARN");

var $LYmdu = parcelRequire("LYmdu");

var $b1YwV = parcelRequire("b1YwV");

var $8wNUU = parcelRequire("8wNUU");

var $aUKcB = parcelRequire("aUKcB");

var $e0rC1 = parcelRequire("e0rC1");

var $13xsf = parcelRequire("13xsf");

var $cb1pF = parcelRequire("cb1pF");

var $uhMTw = parcelRequire("uhMTw");
const $b1c9aeef70035656$var$useFieldV7TextField = (parameters)=>{
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $BKARN.useSplitFieldProps)(props, valueType);
    const internalPropsWithDefaults = (0, $8wNUU.useFieldInternalPropsWithDefaults)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { sectionListRef: sectionListRefProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable } = forwardedProps;
    const { disabled: disabled = false, readOnly: readOnly = false, autoFocus: autoFocus = false, focused: focusedProp, unstableFieldRef: unstableFieldRef } = internalPropsWithDefaults;
    const sectionListRef = $b1c9aeef70035656$var$React.useRef(null);
    const handleSectionListRef = (0, $b1c9aeef70035656$var$_useForkRef.default)(sectionListRefProp, sectionListRef);
    const domGetters = $b1c9aeef70035656$var$React.useMemo(()=>({
            isReady: ()=>sectionListRef.current != null,
            getRoot: ()=>sectionListRef.current.getRoot(),
            getSectionContainer: (sectionIndex)=>sectionListRef.current.getSectionContainer(sectionIndex),
            getSectionContent: (sectionIndex)=>sectionListRef.current.getSectionContent(sectionIndex),
            getSectionIndexFromDOMElement: (element)=>sectionListRef.current.getSectionIndexFromDOMElement(element)
        }), [
        sectionListRef
    ]);
    const stateResponse = (0, $b1YwV.useFieldState)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, error: error, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, setSelectedSections: setSelectedSections } = stateResponse;
    const applyCharacterEditing = (0, $LYmdu.useFieldCharacterEditing)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const [focused, setFocused] = $b1c9aeef70035656$var$React.useState(false);
    function focusField(newSelectedSections = 0) {
        if (disabled || !sectionListRef.current || // if the field is already focused, we don't need to focus it again
        $b1c9aeef70035656$var$getActiveSectionIndex(sectionListRef) != null) return;
        const newParsedSelectedSections = (0, $l9aHF.parseSelectedSections)(newSelectedSections, state.sections);
        setFocused(true);
        sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
    }
    const rootProps = (0, $e0rC1.useFieldRootProps)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        focused: focused,
        setFocused: setFocused,
        domGetters: domGetters
    });
    const hiddenInputProps = (0, $13xsf.useFieldHiddenInputProps)({
        manager: manager,
        stateResponse: stateResponse
    });
    const createSectionContainerProps = (0, $cb1pF.useFieldSectionContainerProps)({
        stateResponse: stateResponse,
        internalPropsWithDefaults: internalPropsWithDefaults
    });
    const createSectionContentProps = (0, $uhMTw.useFieldSectionContentProps)({
        manager: manager,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        internalPropsWithDefaults: internalPropsWithDefaults,
        domGetters: domGetters,
        focused: focused
    });
    const handleRootKeyDown = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onKeyDown?.(event);
        rootProps.onKeyDown(event);
    });
    const handleRootBlur = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onBlur?.(event);
        rootProps.onBlur(event);
    });
    const handleRootFocus = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onFocus?.(event);
        rootProps.onFocus(event);
    });
    const handleRootClick = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        // The click event on the clear or open button would propagate to the input, trigger this handler and result in an inadvertent section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a propagated call, which should be skipped.
        if (event.isDefaultPrevented()) return;
        onClick?.(event);
        rootProps.onClick(event);
    });
    const handleRootPaste = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onPaste?.(event);
        rootProps.onPaste(event);
    });
    const handleRootInput = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onInput?.(event);
        rootProps.onInput(event);
    });
    const handleClear = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!$b1c9aeef70035656$var$isFieldFocused(sectionListRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const elements = $b1c9aeef70035656$var$React.useMemo(()=>{
        return state.sections.map((section, sectionIndex)=>{
            const content = createSectionContentProps(section, sectionIndex);
            return {
                container: createSectionContainerProps(sectionIndex),
                content: createSectionContentProps(section, sectionIndex),
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator,
                    'data-range-position': section.isEndFormatSeparator ? content['data-range-position'] : undefined
                }
            };
        });
    }, [
        state.sections,
        createSectionContainerProps,
        createSectionContentProps
    ]);
    $b1c9aeef70035656$var$React.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            'MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`',
            'You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.',
            '',
            'If you want to keep using an `<input />` HTML element for the editing, please add the `enableAccessibleFieldDOMStructure={false}` prop to your Picker or Field component:',
            '',
            '<DatePicker enableAccessibleFieldDOMStructure={false} slots={{ textField: MyCustomTextField }} />',
            '',
            'Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element'
        ].join('\n'));
        if (autoFocus && !disabled && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $b1c9aeef70035656$var$_useEnhancedEffect.default)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    (0, $b1c9aeef70035656$var$_useEnhancedEffect.default)(()=>{
        (0, $aUKcB.syncSelectionToDOM)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    $b1c9aeef70035656$var$React.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>$b1c9aeef70035656$var$getActiveSectionIndex(sectionListRef),
            setSelectedSections: (newSelectedSections)=>{
                if (disabled || !sectionListRef.current) return;
                const newParsedSelectedSections = (0, $l9aHF.parseSelectedSections)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            focusField: focusField,
            isFieldFocused: ()=>$b1c9aeef70035656$var$isFieldFocused(sectionListRef)
        }));
    return (0, $b1c9aeef70035656$var$_extends2.default)({}, forwardedProps, rootProps, {
        onBlur: handleRootBlur,
        onClick: handleRootClick,
        onFocus: handleRootFocus,
        onInput: handleRootInput,
        onPaste: handleRootPaste,
        onKeyDown: handleRootKeyDown,
        onClear: handleClear
    }, hiddenInputProps, {
        error: error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        focused: focusedProp ?? focused,
        sectionListRef: handleSectionListRef,
        // Additional
        enableAccessibleFieldDOMStructure: true,
        elements: elements,
        areAllSectionsEmpty: areAllSectionsEmpty,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
module.exports.useFieldV7TextField = $b1c9aeef70035656$var$useFieldV7TextField;
function $b1c9aeef70035656$var$getActiveSectionIndex(sectionListRef) {
    const activeElement = (0, $l16rr.getActiveElement)(sectionListRef.current?.getRoot());
    if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
    return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
}
function $b1c9aeef70035656$var$isFieldFocused(sectionListRef) {
    const activeElement = (0, $l16rr.getActiveElement)(sectionListRef.current?.getRoot());
    return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
}

});
parcelRegister("88PIk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5ed72f64b461b408$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5ed72f64b461b408$var$_useForkRef.default;
    }
});

var $5ed72f64b461b408$var$_useForkRef = $5ed72f64b461b408$require$_interopRequireDefault((parcelRequire("15Qny")));

});
parcelRegister("15Qny", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0cbee3738c45df67$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0cbee3738c45df67$var$useForkRef;

var $0cbee3738c45df67$var$React = $0cbee3738c45df67$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function $0cbee3738c45df67$var$useForkRef(...refs) {
    const cleanupRef = $0cbee3738c45df67$var$React.useRef(undefined);
    const refEffect = $0cbee3738c45df67$var$React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $0cbee3738c45df67$var$React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("67oiZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4746400d96193000$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4746400d96193000$var$_useEventCallback.default;
    }
});

var $4746400d96193000$var$_useEventCallback = $4746400d96193000$require$_interopRequireDefault((parcelRequire("gwBEL")));

});
parcelRegister("gwBEL", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c07cd844f57d1a2a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c07cd844f57d1a2a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c07cd844f57d1a2a$var$React = $c07cd844f57d1a2a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c07cd844f57d1a2a$var$_useEnhancedEffect = $c07cd844f57d1a2a$require$_interopRequireDefault((parcelRequire("eDo7c")));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $c07cd844f57d1a2a$var$useEventCallback(fn) {
    const ref = $c07cd844f57d1a2a$var$React.useRef(fn);
    (0, $c07cd844f57d1a2a$var$_useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return $c07cd844f57d1a2a$var$React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $c07cd844f57d1a2a$var$_default = module.exports.default = $c07cd844f57d1a2a$var$useEventCallback;

});
parcelRegister("eDo7c", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $aa7769f53d9ace43$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $aa7769f53d9ace43$var$_useEnhancedEffect.default;
    }
});

var $aa7769f53d9ace43$var$_useEnhancedEffect = $aa7769f53d9ace43$require$_interopRequireDefault((parcelRequire("hsqsB")));

});
parcelRegister("hsqsB", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $cb5993b08e159612$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5993b08e159612$var$React = $cb5993b08e159612$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $cb5993b08e159612$var$useEnhancedEffect = typeof window !== 'undefined' ? $cb5993b08e159612$var$React.useLayoutEffect : $cb5993b08e159612$var$React.useEffect;
var $cb5993b08e159612$var$_default = module.exports.default = $cb5993b08e159612$var$useEnhancedEffect;

});




parcelRegister("l16rr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f4ceb023c3ba7bf1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_DESKTOP_MODE_MEDIA_QUERY = void 0;
module.exports.arrayIncludes = $f4ceb023c3ba7bf1$var$arrayIncludes;
module.exports.getFocusedListItemIndex = module.exports.getActiveElement = module.exports.executeInTheNextEventLoopTick = void 0;
module.exports.mergeSx = $f4ceb023c3ba7bf1$var$mergeSx;
module.exports.onSpaceOrEnter = void 0;

var $f4ceb023c3ba7bf1$var$_ownerDocument = $f4ceb023c3ba7bf1$require$_interopRequireDefault((parcelRequire("lznhl")));
/* Use it instead of .includes method for IE support */ function $f4ceb023c3ba7bf1$var$arrayIncludes(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $f4ceb023c3ba7bf1$var$onSpaceOrEnter = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
module.exports.onSpaceOrEnter = $f4ceb023c3ba7bf1$var$onSpaceOrEnter;
const $f4ceb023c3ba7bf1$var$executeInTheNextEventLoopTick = (fn)=>{
    setTimeout(fn, 0);
};
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
module.exports.executeInTheNextEventLoopTick = $f4ceb023c3ba7bf1$var$executeInTheNextEventLoopTick;
const $f4ceb023c3ba7bf1$var$getActiveElementInternal = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $f4ceb023c3ba7bf1$var$getActiveElementInternal(activeEl.shadowRoot);
    return activeEl;
};
/**
 * Gets the currently active element within a given node's document.
 * This function traverses shadow DOM if necessary.
 * @param node - The node from which to get the active element.
 * @returns The currently active element, or null if none is found.
 */ const $f4ceb023c3ba7bf1$var$getActiveElement = (node)=>{
    return $f4ceb023c3ba7bf1$var$getActiveElementInternal((0, $f4ceb023c3ba7bf1$var$_ownerDocument.default)(node));
};
/**
 * Gets the index of the focused list item in a given ul list element.
 *
 * @param {HTMLUListElement} listElement - The list element to search within.
 * @returns {number} The index of the focused list item, or -1 if none is focused.
 */ module.exports.getActiveElement = $f4ceb023c3ba7bf1$var$getActiveElement;
const $f4ceb023c3ba7bf1$var$getFocusedListItemIndex = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($f4ceb023c3ba7bf1$var$getActiveElement(listElement));
};
module.exports.getFocusedListItemIndex = $f4ceb023c3ba7bf1$var$getFocusedListItemIndex;
const $f4ceb023c3ba7bf1$var$DEFAULT_DESKTOP_MODE_MEDIA_QUERY = module.exports.DEFAULT_DESKTOP_MODE_MEDIA_QUERY = '@media (pointer: fine)';
function $f4ceb023c3ba7bf1$var$mergeSx(...sxProps) {
    return sxProps.reduce((acc, sxProp)=>{
        if (Array.isArray(sxProp)) acc.push(...sxProp);
        else if (sxProp != null) acc.push(sxProp);
        return acc;
    }, []);
}

});
parcelRegister("lznhl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fb3eec86d3dabee5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb3eec86d3dabee5$var$_ownerDocument.default;
    }
});

var $fb3eec86d3dabee5$var$_ownerDocument = $fb3eec86d3dabee5$require$_interopRequireDefault((parcelRequire("i71NF")));

});
parcelRegister("i71NF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2fa46e129c2df91$var$ownerDocument;
function $d2fa46e129c2df91$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("BKARN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useIsValidValue", {
    enumerable: true,
    get: function() {
        return $eg515.useIsValidValue;
    }
});
Object.defineProperty(module.exports, "useParsedFormat", {
    enumerable: true,
    get: function() {
        return $hszez.useParsedFormat;
    }
});
Object.defineProperty(module.exports, "usePickerActionsContext", {
    enumerable: true,
    get: function() {
        return $20yLR.usePickerActionsContext;
    }
});
Object.defineProperty(module.exports, "usePickerAdapter", {
    enumerable: true,
    get: function() {
        return $3nE24.usePickerAdapter;
    }
});
Object.defineProperty(module.exports, "usePickerContext", {
    enumerable: true,
    get: function() {
        return $6DVo4.usePickerContext;
    }
});
Object.defineProperty(module.exports, "usePickerTranslations", {
    enumerable: true,
    get: function() {
        return $83GPg.usePickerTranslations;
    }
});
Object.defineProperty(module.exports, "useSplitFieldProps", {
    enumerable: true,
    get: function() {
        return $5pN9w.useSplitFieldProps;
    }
});

var $83GPg = parcelRequire("83GPg");

var $5pN9w = parcelRequire("5pN9w");

var $hszez = parcelRequire("hszez");

var $6DVo4 = parcelRequire("6DVo4");

var $20yLR = parcelRequire("20yLR");

var $eg515 = parcelRequire("eg515");

var $3nE24 = parcelRequire("3nE24");

});
parcelRegister("83GPg", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerTranslations = void 0;

var $3nE24 = parcelRequire("3nE24");
const $5ddfd2dd7a45f0f3$var$usePickerTranslations = ()=>(0, $3nE24.useLocalizationContext)().localeText;
module.exports.usePickerTranslations = $5ddfd2dd7a45f0f3$var$usePickerTranslations;

});
parcelRegister("3nE24", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $276292a7c4ad1718$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $276292a7c4ad1718$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerAdapter = module.exports.useLocalizationContext = void 0;

var $276292a7c4ad1718$var$_extends2 = $276292a7c4ad1718$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $276292a7c4ad1718$var$React = $276292a7c4ad1718$require$_interopRequireWildcard((parcelRequire("acw62")));

var $eXXn3 = parcelRequire("eXXn3");

var $luD6R = parcelRequire("luD6R");
const $276292a7c4ad1718$var$useLocalizationContext = ()=>{
    const localization = $276292a7c4ad1718$var$React.useContext($luD6R.PickerAdapterContext);
    if (localization === null) throw new Error([
        'MUI X: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.adapter === null) throw new Error([
        'MUI X: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $276292a7c4ad1718$var$React.useMemo(()=>(0, $276292a7c4ad1718$var$_extends2.default)({}, $eXXn3.DEFAULT_LOCALE, localization.localeText), [
        localization.localeText
    ]);
    return $276292a7c4ad1718$var$React.useMemo(()=>(0, $276292a7c4ad1718$var$_extends2.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
module.exports.useLocalizationContext = $276292a7c4ad1718$var$useLocalizationContext;
const $276292a7c4ad1718$var$usePickerAdapter = ()=>$276292a7c4ad1718$var$useLocalizationContext().adapter;
module.exports.usePickerAdapter = $276292a7c4ad1718$var$usePickerAdapter;

});
parcelRegister("eXXn3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.enUS = module.exports.DEFAULT_LOCALE = void 0;

var $gwyDC = parcelRequire("gwyDC");
// This object is not Partial<PickersLocaleText> because it is the default values
const $ae54a135ca8b48bd$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    nextStepButtonLabel: 'Next',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    timeRangePickerToolbarTitle: 'Select time range',
    // Clock labels
    clockLabelText: (view, formattedTime)=>`Select ${view}. ${!formattedTime ? 'No time selected' : `Selected time is ${formattedTime}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open Picker labels
    openDatePickerDialogue: (formattedDate)=>formattedDate ? `Choose date, selected date is ${formattedDate}` : 'Choose date',
    openTimePickerDialogue: (formattedTime)=>formattedTime ? `Choose time, selected time is ${formattedTime}` : 'Choose time',
    openRangePickerDialogue: (formattedRange)=>formattedRange ? `Choose range, selected range is ${formattedRange}` : 'Choose range',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const $ae54a135ca8b48bd$var$DEFAULT_LOCALE = module.exports.DEFAULT_LOCALE = $ae54a135ca8b48bd$var$enUSPickers;
const $ae54a135ca8b48bd$var$enUS = module.exports.enUS = (0, $gwyDC.getPickersLocalization)($ae54a135ca8b48bd$var$enUSPickers);

});
parcelRegister("gwyDC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c07a80e9c07fbe5a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersLocalization = void 0;

var $c07a80e9c07fbe5a$var$_extends2 = $c07a80e9c07fbe5a$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $c07a80e9c07fbe5a$var$getPickersLocalization = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $c07a80e9c07fbe5a$var$_extends2.default)({}, pickersTranslations)
                }
            }
        }
    };
};
module.exports.getPickersLocalization = $c07a80e9c07fbe5a$var$getPickersLocalization;

});


parcelRegister("luD6R", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fa5abcb204c6ca4b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fa5abcb204c6ca4b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerAdapterContext = module.exports.MuiPickersAdapterContext = module.exports.LocalizationProvider = void 0;

var $fa5abcb204c6ca4b$var$_extends2 = $fa5abcb204c6ca4b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fa5abcb204c6ca4b$var$_objectWithoutPropertiesLoose2 = $fa5abcb204c6ca4b$require$_interopRequireDefault((parcelRequire("c05no")));

var $fa5abcb204c6ca4b$var$React = $fa5abcb204c6ca4b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fa5abcb204c6ca4b$var$_propTypes = $fa5abcb204c6ca4b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6g9fa = parcelRequire("6g9fa");

var $ayMG0 = parcelRequire("ayMG0");
const $fa5abcb204c6ca4b$var$_excluded = [
    "localeText"
];
const $fa5abcb204c6ca4b$var$PickerAdapterContext = module.exports.PickerAdapterContext = /*#__PURE__*/ $fa5abcb204c6ca4b$var$React.createContext(null);
const $fa5abcb204c6ca4b$var$MuiPickersAdapterContext = module.exports.MuiPickersAdapterContext = $fa5abcb204c6ca4b$var$PickerAdapterContext;
/**
 * Demos:
 *
 * - [Date format and localization](https://mui.com/x/react-date-pickers/adapters-locale/)
 * - [Calendar systems](https://mui.com/x/react-date-pickers/calendar-systems/)
 * - [Translated components](https://mui.com/x/react-date-pickers/localization/)
 * - [UTC and timezones](https://mui.com/x/react-date-pickers/timezone/)
 *
 * API:
 *
 * - [LocalizationProvider API](https://mui.com/x/api/date-pickers/localization-provider/)
 */ const $fa5abcb204c6ca4b$var$LocalizationProvider = module.exports.LocalizationProvider = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $fa5abcb204c6ca4b$var$_objectWithoutPropertiesLoose2.default)(inProps, $fa5abcb204c6ca4b$var$_excluded);
    const { adapter: parentAdapter, localeText: parentLocaleText } = $fa5abcb204c6ca4b$var$React.useContext($fa5abcb204c6ca4b$var$PickerAdapterContext) ?? {
        utils: undefined,
        adapter: undefined,
        localeText: undefined
    };
    const props = (0, $6g9fa.default)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $fa5abcb204c6ca4b$var$React.useMemo(()=>(0, $fa5abcb204c6ca4b$var$_extends2.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const adapter = $fa5abcb204c6ca4b$var$React.useMemo(()=>{
        if (!DateAdapter) {
            if (parentAdapter) return parentAdapter;
            return null;
        }
        const dateAdapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!dateAdapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/quickstart/#installation'
        ].join(`\n`));
        return dateAdapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentAdapter
    ]);
    const defaultDates = $fa5abcb204c6ca4b$var$React.useMemo(()=>{
        if (!adapter) return null;
        return {
            minDate: adapter.date('1900-01-01T00:00:00.000'),
            maxDate: adapter.date('2099-12-31T00:00:00.000')
        };
    }, [
        adapter
    ]);
    const contextValue = $fa5abcb204c6ca4b$var$React.useMemo(()=>{
        return {
            utils: adapter,
            adapter: adapter,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        adapter,
        localeText
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fa5abcb204c6ca4b$var$PickerAdapterContext.Provider, {
        value: contextValue,
        children: children
    });
};

});



parcelRegister("5pN9w", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3f156a3b21b74a46$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3f156a3b21b74a46$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSplitFieldProps = void 0;

var $3f156a3b21b74a46$var$_extends2 = $3f156a3b21b74a46$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3f156a3b21b74a46$var$React = $3f156a3b21b74a46$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6vW2j = parcelRequire("6vW2j");
const $3f156a3b21b74a46$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'unstableStartFieldRef',
    'unstableEndFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator',
    'autoFocus',
    'focused'
];
/**
 * Split the props received by the field component into:
 * - `internalProps` which are used by the various hooks called by the field component.
 * - `forwardedProps` which are passed to the underlying component.
 * Note that some forwarded props might be used by the hooks as well.
 * For instance, hooks like `useDateField` need props like `onKeyDown` to merge the default event handler and the one provided by the application.
 * @template TProps, TValueType
 * @param {TProps} props The props received by the field component.
 * @param {TValueType} valueType The type of the field value ('date', 'time', or 'date-time').
 */ const $3f156a3b21b74a46$var$useSplitFieldProps = (props, valueType)=>{
    return $3f156a3b21b74a46$var$React.useMemo(()=>{
        const forwardedProps = (0, $3f156a3b21b74a46$var$_extends2.default)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $3f156a3b21b74a46$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') $6vW2j.DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
        else if (valueType === 'time') $6vW2j.TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
        else if (valueType === 'date-time') {
            $6vW2j.DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
            $6vW2j.TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
            $6vW2j.DATE_TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
};
/**
 * Extract the internal props from the props received by the field component.
 * This makes sure that the internal props not defined in the props are not present in the result.
 */ module.exports.useSplitFieldProps = $3f156a3b21b74a46$var$useSplitFieldProps;

});
parcelRegister("6vW2j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractValidationProps = module.exports.TIME_VALIDATION_PROP_NAMES = module.exports.DATE_VALIDATION_PROP_NAMES = module.exports.DATE_TIME_VALIDATION_PROP_NAMES = void 0;
const $4be2a81b5d2111e4$var$DATE_VALIDATION_PROP_NAMES = module.exports.DATE_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $4be2a81b5d2111e4$var$TIME_VALIDATION_PROP_NAMES = module.exports.TIME_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $4be2a81b5d2111e4$var$DATE_TIME_VALIDATION_PROP_NAMES = module.exports.DATE_TIME_VALIDATION_PROP_NAMES = [
    'minDateTime',
    'maxDateTime'
];
const $4be2a81b5d2111e4$var$VALIDATION_PROP_NAMES = [
    ...$4be2a81b5d2111e4$var$DATE_VALIDATION_PROP_NAMES,
    ...$4be2a81b5d2111e4$var$TIME_VALIDATION_PROP_NAMES,
    ...$4be2a81b5d2111e4$var$DATE_TIME_VALIDATION_PROP_NAMES
];
/**
 * Extract the validation props for the props received by a component.
 * Limit the risk of forgetting some of them and reduce the bundle size.
 */ const $4be2a81b5d2111e4$var$extractValidationProps = (props)=>$4be2a81b5d2111e4$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});
module.exports.extractValidationProps = $4be2a81b5d2111e4$var$extractValidationProps;

});


parcelRegister("hszez", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $cb6061e890b8c017$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useParsedFormat = void 0;

var $cb6061e890b8c017$var$React = $cb6061e890b8c017$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $3nE24 = parcelRequire("3nE24");

var $iq4Gd = parcelRequire("iq4Gd");

var $l9aHF = parcelRequire("l9aHF");

var $83GPg = parcelRequire("83GPg");

var $yCVZs = parcelRequire("yCVZs");
/**
 * Returns the parsed format to be rendered in the field when there is no value or in other parts of the Picker.
 * This format is localized (for example `AAAA` for the year with the French locale) and cannot be parsed by your date library.
 * @param {object} The parameters needed to build the placeholder.
 * @param {string} params.format Format to parse.
 * @returns
 */ const $cb6061e890b8c017$var$useParsedFormat = (parameters = {})=>{
    const pickerContext = (0, $yCVZs.useNullablePickerContext)();
    const adapter = (0, $3nE24.usePickerAdapter)();
    const isRtl = (0, $9uEev.useRtl)();
    const translations = (0, $83GPg.usePickerTranslations)();
    const localizedDigits = $cb6061e890b8c017$var$React.useMemo(()=>(0, $l9aHF.getLocalizedDigits)(adapter), [
        adapter
    ]);
    const { format: format = pickerContext?.fieldFormat ?? adapter.formats.fullDate } = parameters;
    return $cb6061e890b8c017$var$React.useMemo(()=>{
        const sections = (0, $iq4Gd.buildSectionsFromFormat)({
            adapter: adapter,
            format: format,
            formatDensity: 'dense',
            isRtl: isRtl,
            shouldRespectLeadingZeros: true,
            localeText: translations,
            localizedDigits: localizedDigits,
            date: null,
            // TODO v9: Make sure we still don't reverse in `buildSectionsFromFormat` when using `useParsedFormat`.
            enableAccessibleFieldDOMStructure: false
        });
        return sections.map((section)=>`${section.startSeparator}${section.placeholder}${section.endSeparator}`).join('');
    }, [
        adapter,
        isRtl,
        translations,
        localizedDigits,
        format
    ]);
};
module.exports.useParsedFormat = $cb6061e890b8c017$var$useParsedFormat;

});
parcelRegister("iq4Gd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d68e490b4aa36330$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildSectionsFromFormat = void 0;

var $d68e490b4aa36330$var$_extends2 = $d68e490b4aa36330$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $l9aHF = parcelRequire("l9aHF");
const $d68e490b4aa36330$var$expandFormat = ({ adapter: adapter, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = adapter.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = adapter.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the component.');
    }
    return nextFormat;
};
const $d68e490b4aa36330$var$getEscapedPartsFromFormat = ({ adapter: adapter, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = adapter.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $d68e490b4aa36330$var$getSectionPlaceholder = (adapter, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: adapter.formatByString(adapter.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $d68e490b4aa36330$var$createSection = ({ adapter: adapter, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === '') throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = (0, $l9aHF.getDateSectionConfigFromFormatToken)(adapter, token);
    const hasLeadingZerosInFormat = (0, $l9aHF.doesSectionFormatHaveLeadingZeros)(adapter, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = adapter.isValid(date);
    let sectionValue = isValidDate ? adapter.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? adapter.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxLength' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $l9aHF.applyLocalizedDigits)((0, $l9aHF.cleanLeadingZeros)((0, $l9aHF.removeLocalizedDigits)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $d68e490b4aa36330$var$_extends2.default)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $d68e490b4aa36330$var$getSectionPlaceholder(adapter, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
};
const $d68e490b4aa36330$var$buildSections = (parameters)=>{
    const { adapter: adapter, expandedFormat: expandedFormat, escapedParts: escapedParts } = parameters;
    const now = adapter.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(adapter.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($d68e490b4aa36330$var$createSection((0, $d68e490b4aa36330$var$_extends2.default)({}, parameters, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else {
                    sections[sections.length - 1].endSeparator += char;
                    sections[sections.length - 1].isEndFormatSeparator = true;
                }
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const $d68e490b4aa36330$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $d68e490b4aa36330$var$buildSectionsFromFormat = (parameters)=>{
    let expandedFormat = $d68e490b4aa36330$var$expandFormat(parameters);
    if (parameters.isRtl && parameters.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = $d68e490b4aa36330$var$getEscapedPartsFromFormat((0, $d68e490b4aa36330$var$_extends2.default)({}, parameters, {
        expandedFormat: expandedFormat
    }));
    const sections = $d68e490b4aa36330$var$buildSections((0, $d68e490b4aa36330$var$_extends2.default)({}, parameters, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $d68e490b4aa36330$var$postProcessSections((0, $d68e490b4aa36330$var$_extends2.default)({}, parameters, {
        sections: sections
    }));
};
module.exports.buildSectionsFromFormat = $d68e490b4aa36330$var$buildSectionsFromFormat;

});

parcelRegister("yCVZs", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $068160a30ef67ebd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useNullablePickerContext = void 0;

var $068160a30ef67ebd$var$React = $068160a30ef67ebd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6DVo4 = parcelRequire("6DVo4");
/**
 * Returns the context passed by the Picker wrapping the current component.
 * If the context is not found, returns `null`.
 */ const $068160a30ef67ebd$var$useNullablePickerContext = ()=>$068160a30ef67ebd$var$React.useContext($6DVo4.PickerContext);
module.exports.useNullablePickerContext = $068160a30ef67ebd$var$useNullablePickerContext;

});
parcelRegister("6DVo4", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4d62e685733303de$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerContext = module.exports.PickerContext = void 0;

var $4d62e685733303de$var$React = $4d62e685733303de$require$_interopRequireWildcard((parcelRequire("acw62")));
const $4d62e685733303de$var$PickerContext = module.exports.PickerContext = /*#__PURE__*/ $4d62e685733303de$var$React.createContext(null);
const $4d62e685733303de$var$usePickerContext = ()=>{
    const value = $4d62e685733303de$var$React.useContext($4d62e685733303de$var$PickerContext);
    if (value == null) throw new Error('MUI X: The `usePickerContext` hook can only be called inside the context of a Picker component');
    return value;
};
module.exports.usePickerContext = $4d62e685733303de$var$usePickerContext;

});



parcelRegister("20yLR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $17668da305eabda2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerActionsContext = void 0;

var $17668da305eabda2$var$React = $17668da305eabda2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jk6Bf = parcelRequire("jk6Bf");
/**
 * Returns a subset of the context passed by the Picker wrapping the current component.
 * It only contains the actions and never causes a re-render of the component using it.
 */ const $17668da305eabda2$var$usePickerActionsContext = ()=>{
    const value = $17668da305eabda2$var$React.useContext($jk6Bf.PickerActionsContext);
    if (value == null) throw new Error([
        'MUI X: The `usePickerActionsContext` can only be called in fields that are used as a slot of a Picker component'
    ].join('\n'));
    return value;
};
module.exports.usePickerActionsContext = $17668da305eabda2$var$usePickerActionsContext;

});
parcelRegister("jk6Bf", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e1150121cdd65ad2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerPrivateContext = module.exports.PickerActionsContext = void 0;
module.exports.PickerProvider = $e1150121cdd65ad2$var$PickerProvider;

var $e1150121cdd65ad2$var$React = $e1150121cdd65ad2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $uaXRK = parcelRequire("uaXRK");

var $eg515 = parcelRequire("eg515");

var $6zwRZ = parcelRequire("6zwRZ");

var $6DVo4 = parcelRequire("6DVo4");

var $ayMG0 = parcelRequire("ayMG0");
const $e1150121cdd65ad2$var$PickerActionsContext = module.exports.PickerActionsContext = /*#__PURE__*/ $e1150121cdd65ad2$var$React.createContext(null);
const $e1150121cdd65ad2$var$PickerPrivateContext = module.exports.PickerPrivateContext = /*#__PURE__*/ $e1150121cdd65ad2$var$React.createContext({
    ownerState: {
        isPickerDisabled: false,
        isPickerReadOnly: false,
        isPickerValueEmpty: false,
        isPickerOpen: false,
        pickerVariant: 'desktop',
        pickerOrientation: 'portrait'
    },
    rootRefObject: {
        current: null
    },
    labelId: undefined,
    dismissViews: ()=>{},
    hasUIView: true,
    getCurrentViewMode: ()=>'UI',
    triggerElement: null,
    viewContainerRole: null,
    defaultActionBarActions: [],
    onPopperExited: undefined
});
function $e1150121cdd65ad2$var$PickerProvider(props) {
    const { contextValue: contextValue, actionsContextValue: actionsContextValue, privateContextValue: privateContextValue, fieldPrivateContextValue: fieldPrivateContextValue, isValidContextValue: isValidContextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6DVo4.PickerContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e1150121cdd65ad2$var$PickerActionsContext.Provider, {
            value: actionsContextValue,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($e1150121cdd65ad2$var$PickerPrivateContext.Provider, {
                value: privateContextValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6zwRZ.PickerFieldPrivateContext.Provider, {
                    value: fieldPrivateContextValue,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($eg515.IsValidValueContext.Provider, {
                        value: isValidContextValue,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($uaXRK.LocalizationProvider, {
                            localeText: localeText,
                            children: children
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("uaXRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "LocalizationProvider", {
    enumerable: true,
    get: function() {
        return $luD6R.LocalizationProvider;
    }
});
Object.defineProperty(module.exports, "MuiPickersAdapterContext", {
    enumerable: true,
    get: function() {
        return $luD6R.MuiPickersAdapterContext;
    }
});

var $luD6R = parcelRequire("luD6R");

});

parcelRegister("eg515", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a6167378c591e0ae$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsValidValueContext = void 0;
module.exports.useIsValidValue = $a6167378c591e0ae$var$useIsValidValue;

var $a6167378c591e0ae$var$React = $a6167378c591e0ae$require$_interopRequireWildcard((parcelRequire("acw62")));
const $a6167378c591e0ae$var$IsValidValueContext = module.exports.IsValidValueContext = /*#__PURE__*/ $a6167378c591e0ae$var$React.createContext(()=>true);
function $a6167378c591e0ae$var$useIsValidValue() {
    return $a6167378c591e0ae$var$React.useContext($a6167378c591e0ae$var$IsValidValueContext);
}

});

parcelRegister("6zwRZ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4c8f82354f487b58$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerFieldPrivateContext = void 0;
module.exports.useNullableFieldPrivateContext = $4c8f82354f487b58$var$useNullableFieldPrivateContext;

var $4c8f82354f487b58$var$React = $4c8f82354f487b58$require$_interopRequireWildcard((parcelRequire("acw62")));
const $4c8f82354f487b58$var$PickerFieldPrivateContext = module.exports.PickerFieldPrivateContext = /*#__PURE__*/ $4c8f82354f487b58$var$React.createContext(null);
function $4c8f82354f487b58$var$useNullableFieldPrivateContext() {
    return $4c8f82354f487b58$var$React.useContext($4c8f82354f487b58$var$PickerFieldPrivateContext);
}

});




parcelRegister("LYmdu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0903359c0c4ccba9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldCharacterEditing = void 0;

var $0903359c0c4ccba9$var$_extends2 = $0903359c0c4ccba9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0903359c0c4ccba9$var$_useEventCallback = $0903359c0c4ccba9$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $l9aHF = parcelRequire("l9aHF");

var $3nE24 = parcelRequire("3nE24");
const $0903359c0c4ccba9$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
/**
 * Update the active section value when the user pressed a key that is not a navigation key (arrow key for example).
 * This hook has two main editing behaviors
 *
 * 1. The numeric editing when the user presses a digit
 * 2. The letter editing when the user presses another key
 */ const $0903359c0c4ccba9$var$useFieldCharacterEditing = ({ stateResponse: { localizedDigits: // States and derived states
localizedDigits, sectionsValueBoundaries: sectionsValueBoundaries, state: state, timezone: timezone, setCharacterQuery: // Methods to update the states
setCharacterQuery, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue } })=>{
    const adapter = (0, $3nE24.usePickerAdapter)();
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = state.sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (state.characterQuery != null && (!isValidQueryValue || isValidQueryValue(state.characterQuery.value)) && state.characterQuery.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${state.characterQuery.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse)) {
                setCharacterQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            setCharacterQuery(null);
            return null;
        }
        setCharacterQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $l9aHF.getLetterEditingOptions)(adapter, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $l9aHF.getDateSectionConfigFromFormatToken)(adapter, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $0903359c0c4ccba9$var$_extends2.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $l9aHF.changeSectionValueFormat)(adapter, fallbackValue, adapter.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = ({ queryValue: queryValue, skipIfBelowMinimum: skipIfBelowMinimum, section: section })=>{
            const cleanQueryValue = (0, $l9aHF.removeLocalizedDigits)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (skipIfBelowMinimum && queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $l9aHF.cleanDigitSectionValue)(adapter, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue({
                queryValue: queryValue,
                skipIfBelowMinimum: false,
                section: activeSection
            });
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $l9aHF.doesSectionFormatHaveLeadingZeros)(adapter, 'digit', 'month', 'MM');
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: {
                        type: activeSection.type,
                        format: 'MM',
                        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                        hasLeadingZerosInInput: true,
                        contentType: 'digit',
                        maxLength: 2
                    }
                });
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $l9aHF.changeSectionValueFormat)(adapter, response.sectionValue, 'MM', activeSection.format);
                return (0, $0903359c0c4ccba9$var$_extends2.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: activeSection
                });
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $l9aHF.getDaysInWeekStr)(adapter, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $0903359c0c4ccba9$var$_extends2.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $l9aHF.isStringNumber)(queryValue, localizedDigits));
    };
    return (0, $0903359c0c4ccba9$var$_useEventCallback.default)((params)=>{
        const section = state.sections[params.sectionIndex];
        const isNumericEditing = (0, $l9aHF.isStringNumber)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $0903359c0c4ccba9$var$_extends2.default)({}, params, {
            keyPressed: (0, $l9aHF.applyLocalizedDigits)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            section: section,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
};
/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ module.exports.useFieldCharacterEditing = $0903359c0c4ccba9$var$useFieldCharacterEditing;

});

parcelRegister("b1YwV", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $807ebdbb6685e382$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $807ebdbb6685e382$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldState = void 0;

var $807ebdbb6685e382$var$_extends2 = $807ebdbb6685e382$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $807ebdbb6685e382$var$React = $807ebdbb6685e382$require$_interopRequireWildcard((parcelRequire("acw62")));

var $807ebdbb6685e382$var$_useControlled = $807ebdbb6685e382$require$_interopRequireDefault((parcelRequire("ik3FS")));

var $807ebdbb6685e382$var$_useTimeout = $807ebdbb6685e382$require$_interopRequireDefault((parcelRequire("5D8gi")));

var $807ebdbb6685e382$var$_useEventCallback = $807ebdbb6685e382$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $9uEev = parcelRequire("9uEev");

var $BKARN = parcelRequire("BKARN");

var $l9aHF = parcelRequire("l9aHF");

var $iq4Gd = parcelRequire("iq4Gd");

var $5UoGz = parcelRequire("5UoGz");

var $hagTn = parcelRequire("hagTn");

var $gUrai = parcelRequire("gUrai");
const $807ebdbb6685e382$var$QUERY_LIFE_DURATION_MS = 5000;
const $807ebdbb6685e382$var$useFieldState = (parameters)=>{
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const isRtl = (0, $9uEev.useRtl)();
    const { manager: { validator: validator, valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: internalPropsWithDefaults, internalPropsWithDefaults: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true }, forwardedProps: { error: errorProp } } = parameters;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'a field component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: valueManager
    });
    const valueRef = $807ebdbb6685e382$var$React.useRef(value);
    $807ebdbb6685e382$var$React.useEffect(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    const { hasValidationError: hasValidationError } = (0, $5UoGz.useValidation)({
        props: internalPropsWithDefaults,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: internalPropsWithDefaults.onError
    });
    const error = $807ebdbb6685e382$var$React.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (errorProp !== undefined) return errorProp;
        return hasValidationError;
    }, [
        hasValidationError,
        errorProp
    ]);
    const localizedDigits = $807ebdbb6685e382$var$React.useMemo(()=>(0, $l9aHF.getLocalizedDigits)(adapter), [
        adapter
    ]);
    const sectionsValueBoundaries = $807ebdbb6685e382$var$React.useMemo(()=>(0, $l9aHF.getSectionsBoundaries)(adapter, localizedDigits, timezone), [
        adapter,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $807ebdbb6685e382$var$React.useCallback((valueToAnalyze)=>fieldValueManager.getSectionsFromValue(valueToAnalyze, (date)=>(0, $iq4Gd.buildSectionsFromFormat)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        adapter,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $807ebdbb6685e382$var$React.useState(()=>{
        const sections = getSectionsFromValue(value);
        (0, $l9aHF.validateSections)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            lastExternalValue: value,
            lastSectionsDependencies: {
                format: format,
                isRtl: isRtl,
                locale: adapter.locale
            },
            tempValueStrAndroid: null,
            characterQuery: null
        };
        const granularity = (0, $gUrai.getSectionTypeGranularity)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: value,
            adapter: adapter,
            props: internalPropsWithDefaults,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $807ebdbb6685e382$var$_extends2.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $807ebdbb6685e382$var$_useControlled.default)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $807ebdbb6685e382$var$React.useMemo(()=>(0, $l9aHF.parseSelectedSections)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const sectionOrder = $807ebdbb6685e382$var$React.useMemo(()=>(0, $l9aHF.getSectionOrder)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const areAllSectionsEmpty = $807ebdbb6685e382$var$React.useMemo(()=>state.sections.every((section)=>section.value === ''), [
        state.sections
    ]);
    const publishValue = (newValue)=>{
        const context = {
            validationError: validator({
                adapter: adapter,
                value: newValue,
                timezone: timezone,
                props: internalPropsWithDefaults
            })
        };
        handleValueChange(newValue, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $807ebdbb6685e382$var$_extends2.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const sectionToUpdateOnNextInvalidDateRef = $807ebdbb6685e382$var$React.useRef(null);
    const updateSectionValueOnNextInvalidDateTimeout = (0, $807ebdbb6685e382$var$_useTimeout.default)();
    const setSectionUpdateToApplyOnNextInvalidDate = (newSectionValue)=>{
        if (activeSectionIndex == null) return;
        sectionToUpdateOnNextInvalidDateRef.current = {
            sectionIndex: activeSectionIndex,
            value: newSectionValue
        };
        updateSectionValueOnNextInvalidDateTimeout.start(0, ()=>{
            sectionToUpdateOnNextInvalidDateRef.current = null;
        });
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(adapter, value, valueManager.emptyValue)) setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                sections: prevState.sections.map((section)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, section, {
                        value: ''
                    })),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(valueManager.emptyValue);
        }
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        if (activeSection.value === '') return;
        setSectionUpdateToApplyOnNextInvalidDate('');
        if (fieldValueManager.getDateFromSection(value, activeSection) === null) setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                sections: setSectionValue(activeSectionIndex, ''),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(fieldValueManager.updateDateInValue(value, activeSection, null));
        }
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = adapter.parse(dateStr, format);
            if (!adapter.isValid(date)) return null;
            const sections = (0, $iq4Gd.buildSectionsFromFormat)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            });
            return (0, $l9aHF.mergeDateIntoReferenceDate)(adapter, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        publishValue(newValue);
    };
    const cleanActiveDateSectionsIfValueNullTimeout = (0, $807ebdbb6685e382$var$_useTimeout.default)();
    const updateSectionValue = ({ section: section, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        updateSectionValueOnNextInvalidDateTimeout.clear();
        cleanActiveDateSectionsIfValueNullTimeout.clear();
        const activeDate = fieldValueManager.getDateFromSection(value, section);
        /**
     * Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * Try to build a valid date from the new section value
     */ const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = fieldValueManager.getDateSectionsFromValue(newSections, section);
        const newActiveDate = (0, $l9aHF.getDateFromDateSections)(adapter, newActiveDateSections, localizedDigits);
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (adapter.isValid(newActiveDate)) {
            const mergedDate = (0, $l9aHF.mergeDateIntoReferenceDate)(adapter, newActiveDate, newActiveDateSections, fieldValueManager.getDateFromSection(state.referenceValue, section), true);
            if (activeDate == null) cleanActiveDateSectionsIfValueNullTimeout.start(0, ()=>{
                if (valueRef.current === value) setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                        sections: fieldValueManager.clearDateSections(state.sections, section),
                        tempValueStrAndroid: null
                    }));
            });
            return publishValue(fieldValueManager.updateDateInValue(value, section, mergedDate));
        }
        /**
     * If all the sections are filled but the date is invalid and the previous date is valid or null,
     * Then we publish an invalid date.
     */ if (newActiveDateSections.every((sectionBis)=>sectionBis.value !== '') && (activeDate == null || adapter.isValid(activeDate))) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is not null,
     * Then we publish the date as `null`.
     */ if (activeDate != null) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, null));
        }
        /**
     * If the previous date is already null,
     * Then we don't publish the date and we update the sections.
     */ return setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    const setCharacterQuery = (0, $807ebdbb6685e382$var$_useEventCallback.default)((newCharacterQuery)=>{
        setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                characterQuery: newCharacterQuery
            }));
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) {
        let sections;
        if (sectionToUpdateOnNextInvalidDateRef.current != null && !adapter.isValid(fieldValueManager.getDateFromSection(value, state.sections[sectionToUpdateOnNextInvalidDateRef.current.sectionIndex]))) sections = setSectionValue(sectionToUpdateOnNextInvalidDateRef.current.sectionIndex, sectionToUpdateOnNextInvalidDateRef.current.value);
        else sections = getSectionsFromValue(value);
        setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                lastExternalValue: value,
                sections: sections,
                sectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                referenceValue: fieldValueManager.updateReferenceValue(adapter, value, prevState.referenceValue),
                tempValueStrAndroid: null
            }));
    }
    if (isRtl !== state.lastSectionsDependencies.isRtl || format !== state.lastSectionsDependencies.format || adapter.locale !== state.lastSectionsDependencies.locale) {
        const sections = getSectionsFromValue(value);
        (0, $l9aHF.validateSections)(sections, valueType);
        setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                lastSectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                sections: sections,
                tempValueStrAndroid: null,
                characterQuery: null
            }));
    }
    if (state.characterQuery != null && !error && activeSectionIndex == null) setCharacterQuery(null);
    if (state.characterQuery != null && state.sections[state.characterQuery.sectionIndex]?.type !== state.characterQuery.sectionType) setCharacterQuery(null);
    $807ebdbb6685e382$var$React.useEffect(()=>{
        if (sectionToUpdateOnNextInvalidDateRef.current != null) sectionToUpdateOnNextInvalidDateRef.current = null;
    });
    const cleanCharacterQueryTimeout = (0, $807ebdbb6685e382$var$_useTimeout.default)();
    $807ebdbb6685e382$var$React.useEffect(()=>{
        if (state.characterQuery != null) cleanCharacterQueryTimeout.start($807ebdbb6685e382$var$QUERY_LIFE_DURATION_MS, ()=>setCharacterQuery(null));
        return ()=>{};
    }, [
        state.characterQuery,
        setCharacterQuery,
        cleanCharacterQueryTimeout
    ]);
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $807ebdbb6685e382$var$React.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) clearActiveSection();
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        activeSectionIndex: // States and derived states
        activeSectionIndex,
        areAllSectionsEmpty: areAllSectionsEmpty,
        error: error,
        localizedDigits: localizedDigits,
        parsedSelectedSections: parsedSelectedSections,
        sectionOrder: sectionOrder,
        sectionsValueBoundaries: sectionsValueBoundaries,
        state: state,
        timezone: timezone,
        value: value,
        clearValue: // Methods to update the states
        clearValue,
        clearActiveSection: clearActiveSection,
        setCharacterQuery: setCharacterQuery,
        setSelectedSections: setSelectedSections,
        setTempAndroidValueStr: setTempAndroidValueStr,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        getSectionsFromValue: // Utilities methods
        getSectionsFromValue
    };
};
module.exports.useFieldState = $807ebdbb6685e382$var$useFieldState;

});
parcelRegister("ik3FS", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d56cf1f020548395$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d56cf1f020548395$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d56cf1f020548395$var$_useControlled.default;
    }
});

var $d56cf1f020548395$var$_useControlled = $d56cf1f020548395$require$_interopRequireWildcard((parcelRequire("982mR")));
Object.keys($d56cf1f020548395$var$_useControlled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d56cf1f020548395$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d56cf1f020548395$var$_useControlled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d56cf1f020548395$var$_useControlled[key];
        }
    });
});

});
parcelRegister("982mR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6a56b29d683421a2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a56b29d683421a2$var$useControlled;

var $6a56b29d683421a2$var$React = $6a56b29d683421a2$require$_interopRequireWildcard((parcelRequire("acw62")));
function $6a56b29d683421a2$var$useControlled(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $6a56b29d683421a2$var$React.useRef(controlled !== undefined);
    const [valueState, setValue] = $6a56b29d683421a2$var$React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $6a56b29d683421a2$var$React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("5D8gi", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $419700ea08333314$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Timeout", {
    enumerable: true,
    get: function() {
        return $419700ea08333314$var$_useTimeout.Timeout;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $419700ea08333314$var$_useTimeout.default;
    }
});

var $419700ea08333314$var$_useTimeout = $419700ea08333314$require$_interopRequireWildcard((parcelRequire("97Clh")));

});
parcelRegister("97Clh", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6a428273d164de46$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
module.exports.default = $6a428273d164de46$var$useTimeout;

var $6a428273d164de46$var$_useLazyRef = $6a428273d164de46$require$_interopRequireDefault((parcelRequire("70azy")));

var $6a428273d164de46$var$_useOnMount = $6a428273d164de46$require$_interopRequireDefault((parcelRequire("oj38f")));
class $6a428273d164de46$var$Timeout {
    static create() {
        return new $6a428273d164de46$var$Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
module.exports.Timeout = $6a428273d164de46$var$Timeout;
function $6a428273d164de46$var$useTimeout() {
    const timeout = (0, $6a428273d164de46$var$_useLazyRef.default)($6a428273d164de46$var$Timeout.create).current;
    (0, $6a428273d164de46$var$_useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("70azy", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5190bbf2f5a574bb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5190bbf2f5a574bb$var$useLazyRef;

var $5190bbf2f5a574bb$var$React = $5190bbf2f5a574bb$require$_interopRequireWildcard((parcelRequire("acw62")));
const $5190bbf2f5a574bb$var$UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function $5190bbf2f5a574bb$var$useLazyRef(init, initArg) {
    const ref = $5190bbf2f5a574bb$var$React.useRef($5190bbf2f5a574bb$var$UNINITIALIZED);
    if (ref.current === $5190bbf2f5a574bb$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("oj38f", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $049104d7b104fe3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $049104d7b104fe3c$var$useOnMount;

var $049104d7b104fe3c$var$React = $049104d7b104fe3c$require$_interopRequireWildcard((parcelRequire("acw62")));
const $049104d7b104fe3c$var$EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function $049104d7b104fe3c$var$useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $049104d7b104fe3c$var$React.useEffect(fn, $049104d7b104fe3c$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});



parcelRegister("5UoGz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "extractValidationProps", {
    enumerable: true,
    get: function() {
        return $6vW2j.extractValidationProps;
    }
});
Object.defineProperty(module.exports, "useValidation", {
    enumerable: true,
    get: function() {
        return $9frIG.useValidation;
    }
});
Object.defineProperty(module.exports, "validateDate", {
    enumerable: true,
    get: function() {
        return $clUaJ.validateDate;
    }
});
Object.defineProperty(module.exports, "validateDateTime", {
    enumerable: true,
    get: function() {
        return $32d8x.validateDateTime;
    }
});
Object.defineProperty(module.exports, "validateTime", {
    enumerable: true,
    get: function() {
        return $9l9jb.validateTime;
    }
});

var $clUaJ = parcelRequire("clUaJ");

var $9l9jb = parcelRequire("9l9jb");

var $32d8x = parcelRequire("32d8x");

var $6vW2j = parcelRequire("6vW2j");

var $9frIG = parcelRequire("9frIG");

});
parcelRegister("clUaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateDate = void 0;

var $1M3bL = parcelRequire("1M3bL");
/**
 * Validation props used by the Date Picker, Date Field and Date Calendar components.
 */ /**
 * Validation props as received by the validateDate method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateDate method.
 */ const $8fe304ca4ba155e2$var$validateDate = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate } = props;
    const now = adapter.date(undefined, timezone);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
module.exports.validateDate = $8fe304ca4ba155e2$var$validateDate;
$8fe304ca4ba155e2$var$validateDate.valueManager = $1M3bL.singleItemValueManager;

});

parcelRegister("9l9jb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTime = void 0;

var $cElCc = parcelRequire("cElCc");

var $1M3bL = parcelRequire("1M3bL");
/**
 * Validation props used by the Time Picker, Time Field and Clock components.
 */ /**
 * Validation props as received by the validateTime method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateTime method.
 */ const $6ccd4ba717e38ef2$var$validateTime = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.date(undefined, timezone);
    const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, value)):
            return 'minTime';
        case Boolean(maxTime && isAfter(value, maxTime)):
            return 'maxTime';
        case Boolean(disableFuture && adapter.isAfter(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBefore(value, now)):
            return 'disablePast';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(minutesStep && adapter.getMinutes(value) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};
module.exports.validateTime = $6ccd4ba717e38ef2$var$validateTime;
$6ccd4ba717e38ef2$var$validateTime.valueManager = $1M3bL.singleItemValueManager;

});

parcelRegister("32d8x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateDateTime = void 0;

var $clUaJ = parcelRequire("clUaJ");

var $9l9jb = parcelRequire("9l9jb");

var $1M3bL = parcelRequire("1M3bL");
/**
 * Validation props used by the Date Time Picker and Date Time Field components.
 */ /**
 * Validation props as received by the validateDateTime method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateDateTime method.
 */ const $235bbfad3f014fc4$var$validateDateTime = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    const dateValidationResult = (0, $clUaJ.validateDate)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, $9l9jb.validateTime)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
};
module.exports.validateDateTime = $235bbfad3f014fc4$var$validateDateTime;
$235bbfad3f014fc4$var$validateDateTime.valueManager = $1M3bL.singleItemValueManager;

});

parcelRegister("9frIG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $01bcd2a693711309$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $01bcd2a693711309$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useValidation = $01bcd2a693711309$var$useValidation;

var $01bcd2a693711309$var$React = $01bcd2a693711309$require$_interopRequireWildcard((parcelRequire("acw62")));

var $01bcd2a693711309$var$_useEventCallback = $01bcd2a693711309$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $BKARN = parcelRequire("BKARN");
/**
 * Utility hook to check if a given value is valid based on the provided validation props.
 * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
 * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
 * @param {UseValidationOptions<TValue, TError, TValidationProps>} options The options to configure the hook.
 * @param {TValue} options.value The value to validate.
 * @param {PickersTimezone} options.timezone The timezone to use for the validation.
 * @param {Validator<TValue, TError, TValidationProps>} options.validator The validator function to use.
 * @param {TValidationProps} options.props The validation props, they differ depending on the component.
 * @param {(error: TError, value: TValue) => void} options.onError Callback fired when the error associated with the current value changes.
 */ function $01bcd2a693711309$var$useValidation(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $BKARN.usePickerAdapter)();
    const previousValidationErrorRef = $01bcd2a693711309$var$React.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $01bcd2a693711309$var$React.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $01bcd2a693711309$var$_useEventCallback.default)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}

});


parcelRegister("hagTn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c7f0794a849d6845$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c7f0794a849d6845$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useControlledValue = void 0;

var $c7f0794a849d6845$var$React = $c7f0794a849d6845$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c7f0794a849d6845$var$_useEventCallback = $c7f0794a849d6845$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $c7f0794a849d6845$var$_useControlled = $c7f0794a849d6845$require$_interopRequireDefault((parcelRequire("ik3FS")));

var $3nE24 = parcelRequire("3nE24");
/**
 * Hooks controlling the value while making sure that:
 * - The value returned by `onChange` always have the timezone of `props.value` or `props.defaultValue` if defined
 * - The value rendered is always the one from `props.timezone` if defined
 */ const $c7f0794a849d6845$var$useControlledValue = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChangeProp, valueManager: valueManager })=>{
    const adapter = (0, $3nE24.usePickerAdapter)();
    const [valueWithInputTimezone, setValue] = (0, $c7f0794a849d6845$var$_useControlled.default)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const inputTimezone = $c7f0794a849d6845$var$React.useMemo(()=>valueManager.getTimezone(adapter, valueWithInputTimezone), [
        adapter,
        valueManager,
        valueWithInputTimezone
    ]);
    const setInputTimezone = (0, $c7f0794a849d6845$var$_useEventCallback.default)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(adapter, inputTimezone, newValue);
    });
    const timezoneToRender = $c7f0794a849d6845$var$React.useMemo(()=>{
        if (timezoneProp) return timezoneProp;
        if (inputTimezone) return inputTimezone;
        if (referenceDate) return adapter.getTimezone(Array.isArray(referenceDate) ? referenceDate[0] : referenceDate);
        return 'default';
    }, [
        timezoneProp,
        inputTimezone,
        referenceDate,
        adapter
    ]);
    const valueWithTimezoneToRender = $c7f0794a849d6845$var$React.useMemo(()=>valueManager.setTimezone(adapter, timezoneToRender, valueWithInputTimezone), [
        valueManager,
        adapter,
        timezoneToRender,
        valueWithInputTimezone
    ]);
    const handleValueChange = (0, $c7f0794a849d6845$var$_useEventCallback.default)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        setValue(newValueWithInputTimezone);
        onChangeProp?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
module.exports.useControlledValue = $c7f0794a849d6845$var$useControlledValue;

});


parcelRegister("8wNUU", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6358085614f491c6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6358085614f491c6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldInternalPropsWithDefaults = $6358085614f491c6$var$useFieldInternalPropsWithDefaults;

var $6358085614f491c6$var$_extends2 = $6358085614f491c6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6358085614f491c6$var$React = $6358085614f491c6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6358085614f491c6$var$_useForkRef = $6358085614f491c6$require$_interopRequireDefault((parcelRequire("88PIk")));

var $yCVZs = parcelRequire("yCVZs");

var $6zwRZ = parcelRequire("6zwRZ");
/**
 * Applies the default values to the field internal props.
 * This is a temporary hook that will be removed during a follow up when `useField` will receive the internal props without the defaults.
 * It is only here to allow the migration to be done in smaller steps.
 */ function $6358085614f491c6$var$useFieldInternalPropsWithDefaults(parameters) {
    const { manager: { internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToFieldInternalProps }, internalProps: internalProps, skipContextFieldRefAssignment: skipContextFieldRefAssignment } = parameters;
    const pickerContext = (0, $yCVZs.useNullablePickerContext)();
    const fieldPrivateContext = (0, $6zwRZ.useNullableFieldPrivateContext)();
    const handleFieldRef = (0, $6358085614f491c6$var$_useForkRef.default)(internalProps.unstableFieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext?.fieldRef);
    const setValue = pickerContext?.setValue;
    const handleChangeFromPicker = $6358085614f491c6$var$React.useCallback((newValue, ctx)=>{
        return setValue?.(newValue, {
            validationError: ctx.validationError,
            shouldClose: false
        });
    }, [
        setValue
    ]);
    const internalPropsWithDefaultsFromContext = $6358085614f491c6$var$React.useMemo(()=>{
        // If one of the context is null,
        // Then the field is used as a standalone component and the other context will be null as well.
        if (fieldPrivateContext != null && pickerContext != null) return (0, $6358085614f491c6$var$_extends2.default)({
            value: pickerContext.value,
            onChange: handleChangeFromPicker,
            timezone: pickerContext.timezone,
            disabled: pickerContext.disabled,
            readOnly: pickerContext.readOnly,
            autoFocus: pickerContext.autoFocus && !pickerContext.open,
            focused: pickerContext.open ? true : undefined,
            format: pickerContext.fieldFormat,
            formatDensity: fieldPrivateContext.formatDensity,
            enableAccessibleFieldDOMStructure: fieldPrivateContext.enableAccessibleFieldDOMStructure,
            selectedSections: fieldPrivateContext.selectedSections,
            onSelectedSectionsChange: fieldPrivateContext.onSelectedSectionsChange,
            unstableFieldRef: handleFieldRef
        }, internalProps);
        return internalProps;
    }, [
        pickerContext,
        fieldPrivateContext,
        internalProps,
        handleChangeFromPicker,
        handleFieldRef
    ]);
    return useApplyDefaultValuesToFieldInternalProps(internalPropsWithDefaultsFromContext);
}

});

parcelRegister("aUKcB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7f22f924f94e9ae4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.syncSelectionToDOM = $7f22f924f94e9ae4$var$syncSelectionToDOM;

var $7f22f924f94e9ae4$var$_ownerDocument = $7f22f924f94e9ae4$require$_interopRequireDefault((parcelRequire("lznhl")));

var $l16rr = parcelRequire("l16rr");
function $7f22f924f94e9ae4$var$syncSelectionToDOM(parameters) {
    const { focused: focused, domGetters: domGetters, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, state: state } } = parameters;
    if (!domGetters.isReady()) return;
    const selection = (0, $7f22f924f94e9ae4$var$_ownerDocument.default)(domGetters.getRoot()).getSelection();
    if (!selection) return;
    if (parsedSelectedSections == null) {
        // If the selection contains an element inside the field, we reset it.
        if (selection.rangeCount > 0 && // Firefox can return a Restricted object here
        selection.getRangeAt(0).startContainer instanceof Node && domGetters.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
        if (focused) domGetters.getRoot().blur();
        return;
    }
    // On multi input range pickers we want to update selection range only for the active input
    if (!domGetters.getRoot().contains((0, $l16rr.getActiveElement)(domGetters.getRoot()))) return;
    const range = new window.Range();
    let target;
    if (parsedSelectedSections === 'all') target = domGetters.getRoot();
    else {
        const section = state.sections[parsedSelectedSections];
        if (section.type === 'empty') target = domGetters.getSectionContainer(parsedSelectedSections);
        else target = domGetters.getSectionContent(parsedSelectedSections);
    }
    range.selectNodeContents(target);
    target.focus();
    selection.removeAllRanges();
    selection.addRange(range);
}

});

parcelRegister("e0rC1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a3267c01476ba616$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldRootProps = $a3267c01476ba616$var$useFieldRootProps;

var $a3267c01476ba616$var$_useEventCallback = $a3267c01476ba616$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $a3267c01476ba616$var$_useTimeout = $a3267c01476ba616$require$_interopRequireDefault((parcelRequire("5D8gi")));

var $erM5F = parcelRequire("erM5F");

var $l16rr = parcelRequire("l16rr");

var $aUKcB = parcelRequire("aUKcB");
/**
 * Generate the props to pass to the root element of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the root element of the field.
 */ function $a3267c01476ba616$var$useFieldRootProps(parameters) {
    const { manager: manager, focused: focused, setFocused: setFocused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, internalPropsWithDefaults: internalPropsWithDefaults, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionOrder: sectionOrder, state: state, clearValue: // Methods to update the states
    clearValue, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    // TODO: Inline onContainerKeyDown once the old DOM structure is removed
    const handleKeyDown = (0, $erM5F.useFieldRootHandleKeyDown)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse
    });
    const containerClickTimeout = (0, $a3267c01476ba616$var$_useTimeout.default)();
    const handleClick = (0, $a3267c01476ba616$var$_useEventCallback.default)((event)=>{
        if (disabled || !domGetters.isReady()) return;
        setFocused(true);
        if (parsedSelectedSections === 'all') containerClickTimeout.start(0, ()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = domGetters.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleInput = (0, $a3267c01476ba616$var$_useEventCallback.default)((event)=>{
        if (!domGetters.isReady() || parsedSelectedSections !== 'all') return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        domGetters.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        (0, $aUKcB.syncSelectionToDOM)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed: keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handlePaste = (0, $a3267c01476ba616$var$_useEventCallback.default)((event)=>{
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleFocus = (0, $a3267c01476ba616$var$_useEventCallback.default)(()=>{
        if (focused || disabled || !domGetters.isReady()) return;
        const activeElement = (0, $l16rr.getActiveElement)(domGetters.getRoot());
        setFocused(true);
        const isFocusInsideASection = domGetters.getSectionIndexFromDOMElement(activeElement) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleBlur = (0, $a3267c01476ba616$var$_useEventCallback.default)(()=>{
        setTimeout(()=>{
            if (!domGetters.isReady()) return;
            const activeElement = (0, $l16rr.getActiveElement)(domGetters.getRoot());
            const shouldBlur = !domGetters.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    return {
        // Event handlers
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onClick: handleClick,
        onPaste: handlePaste,
        onInput: handleInput,
        // Other
        contentEditable: parsedSelectedSections === 'all',
        tabIndex: parsedSelectedSections === 0 ? -1 : 0 // TODO: Try to set to undefined when there is a section selected.
    };
}

});
parcelRegister("erM5F", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a848e40bec4af3b9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldRootHandleKeyDown = $a848e40bec4af3b9$var$useFieldRootHandleKeyDown;

var $a848e40bec4af3b9$var$_useEventCallback = $a848e40bec4af3b9$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $l9aHF = parcelRequire("l9aHF");

var $3nE24 = parcelRequire("3nE24");
/**
 * Returns the `onKeyDown` handler to pass to the root element of the field.
 */ function $a848e40bec4af3b9$var$useFieldRootHandleKeyDown(parameters) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { manager: { internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: { minutesStep: minutesStep, disabled: disabled, readOnly: readOnly }, stateResponse: { state: // States and derived states
    state, value: value, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone, sectionOrder: sectionOrder, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue } } = parameters;
    return (0, $a848e40bec4af3b9$var$_useEventCallback.default)((event)=>{
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'A' && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const newSectionValue = $a848e40bec4af3b9$var$adjustSectionValue(adapter, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, fieldValueManager.getDateFromSection(value, activeSection), {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        section: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
}
function $a848e40bec4af3b9$var$getDeltaFromKeyCode(keyCode) {
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
}
function $a848e40bec4af3b9$var$adjustSectionValue(adapter, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) {
    const delta = $a848e40bec4af3b9$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>(0, $l9aHF.cleanDigitSectionValue)(adapter, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        let newSectionValueNumber;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return adapter.formatByString(adapter.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        } else {
            const currentSectionValue = parseInt((0, $l9aHF.removeLocalizedDigits)(section.value, localizedDigits), 10);
            newSectionValueNumber = currentSectionValue + delta * step;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = (0, $l9aHF.getLetterEditingOptions)(adapter, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
}

});


parcelRegister("13xsf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0c5005a788847ea8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0c5005a788847ea8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldHiddenInputProps = $0c5005a788847ea8$var$useFieldHiddenInputProps;

var $0c5005a788847ea8$var$React = $0c5005a788847ea8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0c5005a788847ea8$var$_useEventCallback = $0c5005a788847ea8$require$_interopRequireDefault((parcelRequire("67oiZ")));
/**
 * Generate the props to pass to the hidden input element of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldHiddenInputPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldHiddenInputPropsReturnValue} The props to forward to the hidden input element of the field.
 */ function $0c5005a788847ea8$var$useFieldHiddenInputProps(parameters) {
    const { manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, state: state, updateValueFromValueStr: // Methods to update the states
    updateValueFromValueStr } } = parameters;
    const handleChange = (0, $0c5005a788847ea8$var$_useEventCallback.default)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $0c5005a788847ea8$var$React.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    return {
        value: valueStr,
        onChange: handleChange
    };
}

});

parcelRegister("cb1pF", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $8dd79bb441a37a9b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldSectionContainerProps = $8dd79bb441a37a9b$var$useFieldSectionContainerProps;

var $8dd79bb441a37a9b$var$React = $8dd79bb441a37a9b$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Generate the props to pass to the container element of each section of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the container element of each section of the field.
 */ function $8dd79bb441a37a9b$var$useFieldSectionContainerProps(parameters) {
    const { stateResponse: { setSelectedSections: // Methods to update the states
    setSelectedSections }, internalPropsWithDefaults: { disabled: disabled = false } } = parameters;
    const createHandleClick = $8dd79bb441a37a9b$var$React.useCallback((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (disabled || event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $8dd79bb441a37a9b$var$React.useCallback((sectionIndex)=>({
            'data-sectionindex': sectionIndex,
            onClick: createHandleClick(sectionIndex)
        }), [
        createHandleClick
    ]);
}

});

parcelRegister("uhMTw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05b099b5410563cd$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $05b099b5410563cd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldSectionContentProps = $05b099b5410563cd$var$useFieldSectionContentProps;

var $05b099b5410563cd$var$React = $05b099b5410563cd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $05b099b5410563cd$var$_useEventCallback = $05b099b5410563cd$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $05b099b5410563cd$var$_useId = $05b099b5410563cd$require$_interopRequireDefault((parcelRequire("5Db2s")));

var $BKARN = parcelRequire("BKARN");

var $aUKcB = parcelRequire("aUKcB");
/**
 * Generate the props to pass to the content element of each section of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the content element of each section of the field.
 */ function $05b099b5410563cd$var$useFieldSectionContentProps(parameters) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const id = (0, $05b099b5410563cd$var$_useId.default)();
    const { focused: focused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, state: state, value: value, clearActiveSection: // Methods to update the states
    clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    const isContainerEditable = parsedSelectedSections === 'all';
    const isEditable = !isContainerEditable && !disabled && !readOnly;
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $05b099b5410563cd$var$_useEventCallback.default)((sectionIndex)=>{
        if (!domGetters.isReady()) return;
        const section = state.sections[sectionIndex];
        domGetters.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        (0, $aUKcB.syncSelectionToDOM)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    const handleInput = (0, $05b099b5410563cd$var$_useEventCallback.default)((event)=>{
        if (!domGetters.isReady()) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = domGetters.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            revertDOMSectionChange(sectionIndex);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    const handleMouseUp = (0, $05b099b5410563cd$var$_useEventCallback.default)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handlePaste = (0, $05b099b5410563cd$var$_useEventCallback.default)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            setCharacterQuery(null);
            updateSectionValue({
                section: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            setCharacterQuery(null);
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleDragOver = (0, $05b099b5410563cd$var$_useEventCallback.default)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const createFocusHandler = $05b099b5410563cd$var$React.useCallback((sectionIndex)=>()=>{
            if (disabled) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $05b099b5410563cd$var$React.useCallback((section, sectionIndex)=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: fieldValueManager.getDateFromSection(value, section),
            contentType: section.contentType,
            format: section.format
        });
        return {
            // Event handlers
            onInput: handleInput,
            onPaste: handlePaste,
            onMouseUp: handleMouseUp,
            onDragOver: handleDragOver,
            onFocus: createFocusHandler(sectionIndex),
            // Aria attributes
            'aria-labelledby': `${id}-${section.type}`,
            'aria-readonly': readOnly,
            'aria-valuenow': $05b099b5410563cd$var$getSectionValueNow(section, adapter),
            'aria-valuemin': sectionBoundaries.minimum,
            'aria-valuemax': sectionBoundaries.maximum,
            'aria-valuetext': section.value ? $05b099b5410563cd$var$getSectionValueText(section, adapter) : translations.empty,
            'aria-label': translations[section.type],
            'aria-disabled': disabled,
            // Other
            tabIndex: isContainerEditable || sectionIndex > 0 ? -1 : 0,
            contentEditable: !isContainerEditable && !disabled && !readOnly,
            role: 'spinbutton',
            id: `${id}-${section.type}`,
            'data-range-position': section.dateName || undefined,
            spellCheck: isEditable ? false : undefined,
            autoCapitalize: isEditable ? 'off' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            children: section.value || section.placeholder,
            inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
        };
    }, [
        sectionsValueBoundaries,
        id,
        isContainerEditable,
        disabled,
        readOnly,
        isEditable,
        translations,
        adapter,
        handleInput,
        handlePaste,
        handleMouseUp,
        handleDragOver,
        createFocusHandler,
        fieldValueManager,
        value
    ]);
}
function $05b099b5410563cd$var$getSectionValueText(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') return adapter.format(adapter.setMonth(adapter.date(), Number(section.value) - 1), 'month');
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate ? adapter.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            return section.contentType === 'digit' ? adapter.format(adapter.setDate(adapter.startOfYear(adapter.date()), Number(section.value)), 'dayOfMonthFull') : section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
}
function $05b099b5410563cd$var$getSectionValueNow(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = adapter.parse(`01:00 ${section.value}`, `${adapter.formats.hours12h}:${adapter.formats.minutes} ${section.format}`);
                if (parsedDate) return adapter.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(section.value);
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate ? adapter.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(section.value) : undefined;
    }
}

});
parcelRegister("5Db2s", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4199284a4efa20ce$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4199284a4efa20ce$var$_useId.default;
    }
});

var $4199284a4efa20ce$var$_useId = $4199284a4efa20ce$require$_interopRequireDefault((parcelRequire("8pBH2")));

});
parcelRegister("8pBH2", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $61fde59b1558f0d9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61fde59b1558f0d9$var$useId;

var $61fde59b1558f0d9$var$React = $61fde59b1558f0d9$require$_interopRequireWildcard((parcelRequire("acw62")));
let $61fde59b1558f0d9$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $61fde59b1558f0d9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $61fde59b1558f0d9$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $61fde59b1558f0d9$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $61fde59b1558f0d9$var$globalId += 1;
            setDefaultId(`mui-${$61fde59b1558f0d9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $61fde59b1558f0d9$var$safeReact = {
    ...$61fde59b1558f0d9$var$React
};
const $61fde59b1558f0d9$var$maybeReactUseId = $61fde59b1558f0d9$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $61fde59b1558f0d9$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($61fde59b1558f0d9$var$maybeReactUseId !== undefined) {
        const reactId = $61fde59b1558f0d9$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $61fde59b1558f0d9$var$useGlobalId(idOverride);
}

});




parcelRegister("3Pdrd", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $2c908f051ecf8b71$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2c908f051ecf8b71$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldV6TextField = module.exports.addPositionPropertiesToSections = void 0;

var $2c908f051ecf8b71$var$_extends2 = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2c908f051ecf8b71$var$React = $2c908f051ecf8b71$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $2c908f051ecf8b71$var$_useEnhancedEffect = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $2c908f051ecf8b71$var$_useEventCallback = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $2c908f051ecf8b71$var$_useTimeout = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("5D8gi")));

var $2c908f051ecf8b71$var$_useForkRef = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("88PIk")));

var $BKARN = parcelRequire("BKARN");

var $l16rr = parcelRequire("l16rr");

var $l9aHF = parcelRequire("l9aHF");

var $LYmdu = parcelRequire("LYmdu");

var $erM5F = parcelRequire("erM5F");

var $b1YwV = parcelRequire("b1YwV");

var $8wNUU = parcelRequire("8wNUU");
const $2c908f051ecf8b71$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $2c908f051ecf8b71$var$addPositionPropertiesToSections = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $l9aHF.getSectionVisibleValue)(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $2c908f051ecf8b71$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $2c908f051ecf8b71$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === '' ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $2c908f051ecf8b71$var$_extends2.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
module.exports.addPositionPropertiesToSections = $2c908f051ecf8b71$var$addPositionPropertiesToSections;
const $2c908f051ecf8b71$var$useFieldV6TextField = (parameters)=>{
    const isRtl = (0, $9uEev.useRtl)();
    const focusTimeout = (0, $2c908f051ecf8b71$var$_useTimeout.default)();
    const selectionSyncTimeout = (0, $2c908f051ecf8b71$var$_useTimeout.default)();
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $BKARN.useSplitFieldProps)(props, valueType);
    const internalPropsWithDefaults = (0, $8wNUU.useFieldInternalPropsWithDefaults)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable, inputRef: inputRefProp, placeholder: inPlaceholder } = forwardedProps;
    const { readOnly: readOnly = false, disabled: disabled = false, autoFocus: autoFocus = false, focused: focused, unstableFieldRef: unstableFieldRef } = internalPropsWithDefaults;
    const inputRef = $2c908f051ecf8b71$var$React.useRef(null);
    const handleRef = (0, $2c908f051ecf8b71$var$_useForkRef.default)(inputRefProp, inputRef);
    const stateResponse = (0, $b1YwV.useFieldState)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { activeSectionIndex: // States and derived states
    activeSectionIndex, areAllSectionsEmpty: areAllSectionsEmpty, error: error, localizedDigits: localizedDigits, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, getSectionsFromValue: // Utilities methods
    getSectionsFromValue } = stateResponse;
    const applyCharacterEditing = (0, $LYmdu.useFieldCharacterEditing)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const sections = $2c908f051ecf8b71$var$React.useMemo(()=>$2c908f051ecf8b71$var$addPositionPropertiesToSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    function syncSelectionFromDOM() {
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    }
    function focusField(newSelectedSection = 0) {
        if ((0, $l16rr.getActiveElement)(inputRef.current) === inputRef.current) return;
        inputRef.current?.focus();
        setSelectedSections(newSelectedSection);
    }
    const handleInputFocus = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        onFocus?.(event);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        focusTimeout.start(0, ()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData('text');
        if (typeof parsedSelectedSections === 'number') {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                setCharacterQuery(null);
                updateSectionValue({
                    section: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        onBlur?.(event);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $2c908f051ecf8b71$var$cleanString(valueStr);
        if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === 'all' && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $2c908f051ecf8b71$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $2c908f051ecf8b71$var$cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + $2c908f051ecf8b71$var$cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $l9aHF.isAndroid)()) setTempAndroidValueStr(valueStr);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const handleClear = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!$2c908f051ecf8b71$var$isFieldFocused(inputRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerKeyDown = (0, $erM5F.useFieldRootHandleKeyDown)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse
    });
    const wrappedHandleContainerKeyDown = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        onKeyDown?.(event);
        handleContainerKeyDown(event);
    });
    const placeholder = $2c908f051ecf8b71$var$React.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = $2c908f051ecf8b71$var$React.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    $2c908f051ecf8b71$var$React.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current)) setSelectedSections('all');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $2c908f051ecf8b71$var$_useEnhancedEffect.default)(()=>{
        function syncSelectionToDOM() {
            if (!inputRef.current) return;
            if (parsedSelectedSections == null) {
                if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                // setting selection range to 0 causes issues in Safari.
                // https://bugs.webkit.org/show_bug.cgi?id=224425
                inputRef.current.scrollLeft = 0;
                return;
            }
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current !== (0, $l16rr.getActiveElement)(inputRef.current)) return;
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            if (parsedSelectedSections === 'all') inputRef.current.select();
            else {
                const selectedSection = sections[parsedSelectedSections];
                const selectionStart = selectedSection.type === 'empty' ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                const selectionEnd = selectedSection.type === 'empty' ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                    if (inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                }
                selectionSyncTimeout.start(0, ()=>{
                    // handle case when the selection is not updated correctly
                    // could happen on Android
                    if (inputRef.current && inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current) && // The section might loose all selection, where `selectionStart === selectionEnd`
                    // https://github.com/mui/mui-x/pull/13652
                    inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) syncSelectionToDOM();
                });
            }
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
        syncSelectionToDOM();
    });
    const inputMode = $2c908f051ecf8b71$var$React.useMemo(()=>{
        if (activeSectionIndex == null) return 'text';
        if (state.sections[activeSectionIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    $2c908f051ecf8b71$var$React.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            focusField: focusField,
            isFieldFocused: ()=>$2c908f051ecf8b71$var$isFieldFocused(inputRef)
        }));
    return (0, $2c908f051ecf8b71$var$_extends2.default)({}, forwardedProps, {
        error: error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        onBlur: handleContainerBlur,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onPaste: handleInputPaste,
        onKeyDown: wrappedHandleContainerKeyDown,
        onClear: handleClear,
        inputRef: handleRef,
        // Additional
        enableAccessibleFieldDOMStructure: false,
        placeholder: placeholder,
        inputMode: inputMode,
        autoComplete: 'off',
        value: shouldShowPlaceholder ? '' : valueStr,
        onChange: handleInputChange,
        focused: focused,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
module.exports.useFieldV6TextField = $2c908f051ecf8b71$var$useFieldV6TextField;
function $2c908f051ecf8b71$var$isFieldFocused(inputRef) {
    return inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current);
}

});



parcelRegister("8tpPE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useDateManager", {
    enumerable: true,
    get: function() {
        return $1aSwN.useDateManager;
    }
});
Object.defineProperty(module.exports, "useDateTimeManager", {
    enumerable: true,
    get: function() {
        return $2wsa0.useDateTimeManager;
    }
});
Object.defineProperty(module.exports, "useTimeManager", {
    enumerable: true,
    get: function() {
        return $dWSXy.useTimeManager;
    }
});

var $1aSwN = parcelRequire("1aSwN");

var $dWSXy = parcelRequire("dWSXy");

var $2wsa0 = parcelRequire("2wsa0");

});
parcelRegister("1aSwN", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0db105bf1f5518e9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0db105bf1f5518e9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useApplyDefaultValuesToDateValidationProps = $0db105bf1f5518e9$var$useApplyDefaultValuesToDateValidationProps;
module.exports.useDateManager = $0db105bf1f5518e9$var$useDateManager;

var $0db105bf1f5518e9$var$_extends2 = $0db105bf1f5518e9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0db105bf1f5518e9$var$React = $0db105bf1f5518e9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $NRNex = parcelRequire("NRNex");

var $1M3bL = parcelRequire("1M3bL");

var $5UoGz = parcelRequire("5UoGz");

var $3vagl = parcelRequire("3vagl");

var $BKARN = parcelRequire("BKARN");
function $0db105bf1f5518e9$var$useDateManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true } = parameters;
    return $0db105bf1f5518e9$var$React.useMemo(()=>({
            valueType: 'date',
            validator: $5UoGz.validateDate,
            internal_valueManager: $1M3bL.singleItemValueManager,
            internal_fieldValueManager: $1M3bL.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $0db105bf1f5518e9$var$useApplyDefaultValuesToDateFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $0db105bf1f5518e9$var$useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function $0db105bf1f5518e9$var$useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    return $0db105bf1f5518e9$var$React.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function $0db105bf1f5518e9$var$useApplyDefaultValuesToDateFieldInternalProps(internalProps) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const validationProps = $0db105bf1f5518e9$var$useApplyDefaultValuesToDateValidationProps(internalProps);
    return $0db105bf1f5518e9$var$React.useMemo(()=>(0, $0db105bf1f5518e9$var$_extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? adapter.formats.keyboardDate
        }), [
        internalProps,
        validationProps,
        adapter
    ]);
}
function $0db105bf1f5518e9$var$useApplyDefaultValuesToDateValidationProps(props) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const defaultDates = (0, $3vagl.useDefaultDates)();
    return $0db105bf1f5518e9$var$React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            minDate: (0, $NRNex.applyDefaultDate)(adapter, props.minDate, defaultDates.minDate),
            maxDate: (0, $NRNex.applyDefaultDate)(adapter, props.maxDate, defaultDates.maxDate)
        }), [
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}

});
parcelRegister("3vagl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $28cc3a450bd9076f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useNow = module.exports.useDefaultDates = void 0;

var $28cc3a450bd9076f$var$React = $28cc3a450bd9076f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3nE24 = parcelRequire("3nE24");
const $28cc3a450bd9076f$var$useDefaultDates = ()=>(0, $3nE24.useLocalizationContext)().defaultDates;
module.exports.useDefaultDates = $28cc3a450bd9076f$var$useDefaultDates;
const $28cc3a450bd9076f$var$useNow = (timezone)=>{
    const adapter = (0, $3nE24.usePickerAdapter)();
    const now = $28cc3a450bd9076f$var$React.useRef(undefined);
    if (now.current === undefined) now.current = adapter.date(undefined, timezone);
    return now.current;
};
module.exports.useNow = $28cc3a450bd9076f$var$useNow;

});


parcelRegister("dWSXy", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a27b52f65f4c000d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a27b52f65f4c000d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useApplyDefaultValuesToTimeValidationProps = $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeValidationProps;
module.exports.useTimeManager = $a27b52f65f4c000d$var$useTimeManager;

var $a27b52f65f4c000d$var$_extends2 = $a27b52f65f4c000d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a27b52f65f4c000d$var$React = $a27b52f65f4c000d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1M3bL = parcelRequire("1M3bL");

var $5UoGz = parcelRequire("5UoGz");

var $BKARN = parcelRequire("BKARN");
function $a27b52f65f4c000d$var$useTimeManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true, ampm: ampm } = parameters;
    return $a27b52f65f4c000d$var$React.useMemo(()=>({
            valueType: 'time',
            validator: $5UoGz.validateTime,
            internal_valueManager: $1M3bL.singleItemValueManager,
            internal_fieldValueManager: $1M3bL.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $a27b52f65f4c000d$var$createUseOpenPickerButtonAriaLabel(ampm)
        }), [
        ampm,
        enableAccessibleFieldDOMStructure
    ]);
}
function $a27b52f65f4c000d$var$createUseOpenPickerButtonAriaLabel(ampm) {
    return function useOpenPickerButtonAriaLabel(value) {
        const adapter = (0, $BKARN.usePickerAdapter)();
        const translations = (0, $BKARN.usePickerTranslations)();
        return $a27b52f65f4c000d$var$React.useMemo(()=>{
            const formatKey = ampm ?? adapter.is12HourCycleInCurrentLocale() ? 'fullTime12h' : 'fullTime24h';
            const formattedValue = adapter.isValid(value) ? adapter.format(value, formatKey) : null;
            return translations.openTimePickerDialogue(formattedValue);
        }, [
            value,
            translations,
            adapter
        ]);
    };
}
function $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeFieldInternalProps(internalProps) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const validationProps = $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeValidationProps(internalProps);
    const ampm = $a27b52f65f4c000d$var$React.useMemo(()=>internalProps.ampm ?? adapter.is12HourCycleInCurrentLocale(), [
        internalProps.ampm,
        adapter
    ]);
    return $a27b52f65f4c000d$var$React.useMemo(()=>(0, $a27b52f65f4c000d$var$_extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? (ampm ? adapter.formats.fullTime12h : adapter.formats.fullTime24h)
        }), [
        internalProps,
        validationProps,
        ampm,
        adapter
    ]);
}
function $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeValidationProps(props) {
    return $a27b52f65f4c000d$var$React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false
        }), [
        props.disablePast,
        props.disableFuture
    ]);
}

});

parcelRegister("2wsa0", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $1d6469ff6cf05a6f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1d6469ff6cf05a6f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useApplyDefaultValuesToDateTimeValidationProps = $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeValidationProps;
module.exports.useDateTimeManager = $1d6469ff6cf05a6f$var$useDateTimeManager;

var $1d6469ff6cf05a6f$var$_extends2 = $1d6469ff6cf05a6f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $1d6469ff6cf05a6f$var$React = $1d6469ff6cf05a6f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $NRNex = parcelRequire("NRNex");

var $1M3bL = parcelRequire("1M3bL");

var $5UoGz = parcelRequire("5UoGz");

var $3vagl = parcelRequire("3vagl");

var $BKARN = parcelRequire("BKARN");
function $1d6469ff6cf05a6f$var$useDateTimeManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true } = parameters;
    return $1d6469ff6cf05a6f$var$React.useMemo(()=>({
            valueType: 'date-time',
            validator: $5UoGz.validateDateTime,
            internal_valueManager: $1M3bL.singleItemValueManager,
            internal_fieldValueManager: $1M3bL.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $1d6469ff6cf05a6f$var$useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function $1d6469ff6cf05a6f$var$useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    return $1d6469ff6cf05a6f$var$React.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeFieldInternalProps(internalProps) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const validationProps = $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeValidationProps(internalProps);
    const ampm = $1d6469ff6cf05a6f$var$React.useMemo(()=>internalProps.ampm ?? adapter.is12HourCycleInCurrentLocale(), [
        internalProps.ampm,
        adapter
    ]);
    return $1d6469ff6cf05a6f$var$React.useMemo(()=>(0, $1d6469ff6cf05a6f$var$_extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? (ampm ? adapter.formats.keyboardDateTime12h : adapter.formats.keyboardDateTime24h)
        }), [
        internalProps,
        validationProps,
        ampm,
        adapter
    ]);
}
function $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeValidationProps(props) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const defaultDates = (0, $3vagl.useDefaultDates)();
    return $1d6469ff6cf05a6f$var$React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            // TODO: Explore if we can remove it from the public API
            disableIgnoringDatePartForTimeValidation: !!props.minDateTime || !!props.maxDateTime || !!props.disableFuture || !!props.disablePast,
            minDate: (0, $NRNex.applyDefaultDate)(adapter, props.minDateTime ?? props.minDate, defaultDates.minDate),
            maxDate: (0, $NRNex.applyDefaultDate)(adapter, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
            minTime: props.minDateTime ?? props.minTime,
            maxTime: props.maxDateTime ?? props.maxTime
        }), [
        props.minDateTime,
        props.maxDateTime,
        props.minTime,
        props.maxTime,
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}

});



parcelRegister("w6zXP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $060817bd35ed0d61$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $060817bd35ed0d61$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerFieldUI = $060817bd35ed0d61$var$PickerFieldUI;
module.exports.PickerFieldUIContext = void 0;
module.exports.PickerFieldUIContextProvider = $060817bd35ed0d61$var$PickerFieldUIContextProvider;
module.exports.cleanFieldResponse = void 0;
module.exports.mergeSlotProps = $060817bd35ed0d61$var$mergeSlotProps;
module.exports.useFieldTextFieldProps = $060817bd35ed0d61$var$useFieldTextFieldProps;

var $060817bd35ed0d61$var$_extends2 = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2 = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("c05no")));

var $060817bd35ed0d61$var$React = $060817bd35ed0d61$require$_interopRequireWildcard((parcelRequire("acw62")));

var $060817bd35ed0d61$var$_useEventCallback = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $060817bd35ed0d61$var$_useForkRef = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("88PIk")));

var $060817bd35ed0d61$var$_resolveComponentProps = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("4sXkv")));

var $060817bd35ed0d61$var$_TextField = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("hABDe")));

var $060817bd35ed0d61$var$_IconButton = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("825Zh")));

var $060817bd35ed0d61$var$_InputAdornment = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("9bswS")));

var $060817bd35ed0d61$var$_useSlotProps5 = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $d51Yx = parcelRequire("d51Yx");

var $BKARN = parcelRequire("BKARN");

var $1SVAo = parcelRequire("1SVAo");

var $yCVZs = parcelRequire("yCVZs");

var $3Gp0b = parcelRequire("3Gp0b");

var $ayMG0 = parcelRequire("ayMG0");
const $060817bd35ed0d61$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $060817bd35ed0d61$var$_excluded2 = [
    "InputProps",
    "readOnly",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], $060817bd35ed0d61$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], $060817bd35ed0d61$var$_excluded4 = [
    "ownerState"
], $060817bd35ed0d61$var$_excluded5 = [
    "ownerState"
], $060817bd35ed0d61$var$_excluded6 = [
    "ownerState"
], $060817bd35ed0d61$var$_excluded7 = [
    "ownerState"
], $060817bd35ed0d61$var$_excluded8 = [
    "InputProps",
    "inputProps"
];
const $060817bd35ed0d61$var$cleanFieldResponse = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_ref, $060817bd35ed0d61$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel } = fieldResponse, other = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(fieldResponse, $060817bd35ed0d61$var$_excluded2);
        return {
            clearable: clearable,
            onClear: onClear,
            clearButtonPosition: clearButtonPosition,
            openPickerButtonPosition: openPickerButtonPosition,
            openPickerAriaLabel: openPickerAriaLabel,
            textFieldProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, other, {
                InputProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, InputProps ?? {}, {
                    readOnly: readOnly
                })
            })
        };
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel } = fieldResponse, other = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(fieldResponse, $060817bd35ed0d61$var$_excluded3);
    return {
        clearable: clearable,
        onClear: onClear,
        clearButtonPosition: clearButtonPosition,
        openPickerButtonPosition: openPickerButtonPosition,
        openPickerAriaLabel: openPickerAriaLabel,
        textFieldProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, other, {
            InputProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, InputProps ?? {}, {
                readOnly: readOnly
            }),
            inputProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, inputProps ?? {}, {
                inputMode: inputMode,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                ref: inputRef
            })
        })
    };
};
module.exports.cleanFieldResponse = $060817bd35ed0d61$var$cleanFieldResponse;
const $060817bd35ed0d61$var$PickerFieldUIContext = module.exports.PickerFieldUIContext = /*#__PURE__*/ $060817bd35ed0d61$var$React.createContext({
    slots: {},
    slotProps: {},
    inputRef: undefined
});
function $060817bd35ed0d61$var$PickerFieldUI(props) {
    const { slots: slots, slotProps: slotProps, fieldResponse: fieldResponse, defaultOpenPickerIcon: defaultOpenPickerIcon } = props;
    const translations = (0, $BKARN.usePickerTranslations)();
    const pickerContext = (0, $yCVZs.useNullablePickerContext)();
    const pickerFieldUIContext = $060817bd35ed0d61$var$React.useContext($060817bd35ed0d61$var$PickerFieldUIContext);
    const { textFieldProps: textFieldProps, onClear: onClear, clearable: clearable, openPickerAriaLabel: openPickerAriaLabel, clearButtonPosition: clearButtonPositionProp = 'end', openPickerButtonPosition: openPickerButtonPositionProp = 'end' } = $060817bd35ed0d61$var$cleanFieldResponse(fieldResponse);
    const ownerState = (0, $d51Yx.useFieldOwnerState)(textFieldProps);
    const handleClickOpeningButton = (0, $060817bd35ed0d61$var$_useEventCallback.default)((event)=>{
        event.preventDefault();
        pickerContext?.setOpen((prev)=>!prev);
    });
    const triggerStatus = pickerContext ? pickerContext.triggerStatus : 'hidden';
    const clearButtonPosition = clearable ? clearButtonPositionProp : null;
    const openPickerButtonPosition = triggerStatus !== 'hidden' ? openPickerButtonPositionProp : null;
    const TextField = slots?.textField ?? pickerFieldUIContext.slots.textField ?? (fieldResponse.enableAccessibleFieldDOMStructure === false ? $060817bd35ed0d61$var$_TextField.default : $3Gp0b.PickersTextField);
    const InputAdornment = slots?.inputAdornment ?? pickerFieldUIContext.slots.inputAdornment ?? $060817bd35ed0d61$var$_InputAdornment.default;
    const _useSlotProps = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: InputAdornment,
        externalSlotProps: $060817bd35ed0d61$var$mergeSlotProps(pickerFieldUIContext.slotProps.inputAdornment, slotProps?.inputAdornment),
        additionalProps: {
            position: 'start'
        },
        ownerState: (0, $060817bd35ed0d61$var$_extends2.default)({}, ownerState, {
            position: 'start'
        })
    }), startInputAdornmentProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $060817bd35ed0d61$var$_excluded4);
    const _useSlotProps2 = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: InputAdornment,
        externalSlotProps: $060817bd35ed0d61$var$mergeSlotProps(pickerFieldUIContext.slotProps.inputAdornment, slotProps?.inputAdornment),
        additionalProps: {
            position: 'end'
        },
        ownerState: (0, $060817bd35ed0d61$var$_extends2.default)({}, ownerState, {
            position: 'end'
        })
    }), endInputAdornmentProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps2, $060817bd35ed0d61$var$_excluded5);
    const OpenPickerButton = pickerFieldUIContext.slots.openPickerButton ?? $060817bd35ed0d61$var$_IconButton.default;
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps3 = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: OpenPickerButton,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerButton,
        additionalProps: {
            disabled: triggerStatus === 'disabled',
            onClick: handleClickOpeningButton,
            'aria-label': openPickerAriaLabel,
            edge: // open button is always rendered at the edge
            textFieldProps.variant !== 'standard' ? openPickerButtonPosition : false
        },
        ownerState: ownerState
    }), openPickerButtonProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps3, $060817bd35ed0d61$var$_excluded6);
    const OpenPickerIcon = pickerFieldUIContext.slots.openPickerIcon ?? defaultOpenPickerIcon;
    const openPickerIconProps = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: OpenPickerIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerIcon,
        ownerState: ownerState
    });
    const ClearButton = slots?.clearButton ?? pickerFieldUIContext.slots.clearButton ?? $060817bd35ed0d61$var$_IconButton.default;
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps4 = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: ClearButton,
        externalSlotProps: $060817bd35ed0d61$var$mergeSlotProps(pickerFieldUIContext.slotProps.clearButton, slotProps?.clearButton),
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel,
            tabIndex: -1,
            onClick: onClear,
            disabled: fieldResponse.disabled || fieldResponse.readOnly,
            edge: // clear button can only be at the edge if it's position differs from the open button
            textFieldProps.variant !== 'standard' && clearButtonPosition !== openPickerButtonPosition ? clearButtonPosition : false
        },
        ownerState: ownerState
    }), clearButtonProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps4, $060817bd35ed0d61$var$_excluded7);
    const ClearIcon = slots?.clearIcon ?? pickerFieldUIContext.slots.clearIcon ?? $1SVAo.ClearIcon;
    const clearIconProps = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: ClearIcon,
        externalSlotProps: $060817bd35ed0d61$var$mergeSlotProps(pickerFieldUIContext.slotProps.clearIcon, slotProps?.clearIcon),
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    textFieldProps.ref = (0, $060817bd35ed0d61$var$_useForkRef.default)(textFieldProps.ref, pickerContext?.rootRef);
    if (!textFieldProps.InputProps) textFieldProps.InputProps = {};
    if (pickerContext) textFieldProps.InputProps.ref = pickerContext.triggerRef;
    if (!textFieldProps.InputProps?.startAdornment && (clearButtonPosition === 'start' || openPickerButtonPosition === 'start')) textFieldProps.InputProps.startAdornment = /*#__PURE__*/ (0, $ayMG0.jsxs)(InputAdornment, (0, $060817bd35ed0d61$var$_extends2.default)({}, startInputAdornmentProps, {
        children: [
            openPickerButtonPosition === 'start' && /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerButton, (0, $060817bd35ed0d61$var$_extends2.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerIcon, (0, $060817bd35ed0d61$var$_extends2.default)({}, openPickerIconProps))
            })),
            clearButtonPosition === 'start' && /*#__PURE__*/ (0, $ayMG0.jsx)(ClearButton, (0, $060817bd35ed0d61$var$_extends2.default)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(ClearIcon, (0, $060817bd35ed0d61$var$_extends2.default)({}, clearIconProps))
            }))
        ]
    }));
    if (!textFieldProps.InputProps?.endAdornment && (clearButtonPosition === 'end' || openPickerButtonPosition === 'end')) textFieldProps.InputProps.endAdornment = /*#__PURE__*/ (0, $ayMG0.jsxs)(InputAdornment, (0, $060817bd35ed0d61$var$_extends2.default)({}, endInputAdornmentProps, {
        children: [
            clearButtonPosition === 'end' && /*#__PURE__*/ (0, $ayMG0.jsx)(ClearButton, (0, $060817bd35ed0d61$var$_extends2.default)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(ClearIcon, (0, $060817bd35ed0d61$var$_extends2.default)({}, clearIconProps))
            })),
            openPickerButtonPosition === 'end' && /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerButton, (0, $060817bd35ed0d61$var$_extends2.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerIcon, (0, $060817bd35ed0d61$var$_extends2.default)({}, openPickerIconProps))
            }))
        ]
    }));
    if (clearButtonPosition != null) textFieldProps.sx = [
        {
            '& .clearButton': {
                opacity: 1
            },
            '@media (pointer: fine)': {
                '& .clearButton': {
                    opacity: 0
                },
                '&:hover, &:focus-within': {
                    '.clearButton': {
                        opacity: 1
                    }
                }
            }
        },
        ...Array.isArray(textFieldProps.sx) ? textFieldProps.sx : [
            textFieldProps.sx
        ]
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TextField, (0, $060817bd35ed0d61$var$_extends2.default)({}, textFieldProps));
}
function $060817bd35ed0d61$var$mergeSlotProps(slotPropsA, slotPropsB) {
    if (!slotPropsA) return slotPropsB;
    if (!slotPropsB) return slotPropsA;
    return (ownerState)=>{
        return (0, $060817bd35ed0d61$var$_extends2.default)({}, (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(slotPropsB, ownerState), (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(slotPropsA, ownerState));
    };
}
/**
 * The `textField` slot props cannot be handled inside `PickerFieldUI` because it would be a breaking change to not pass the enriched props to `useField`.
 * Once the non-accessible DOM structure will be removed, we will be able to remove the `textField` slot and clean this logic.
 */ function $060817bd35ed0d61$var$useFieldTextFieldProps(parameters) {
    const { ref: ref, externalForwardedProps: externalForwardedProps, slotProps: slotProps } = parameters;
    const pickerFieldUIContext = $060817bd35ed0d61$var$React.useContext($060817bd35ed0d61$var$PickerFieldUIContext);
    const pickerContext = (0, $yCVZs.useNullablePickerContext)();
    const ownerState = (0, $d51Yx.useFieldOwnerState)(externalForwardedProps);
    const { InputProps: InputProps, inputProps: inputProps } = externalForwardedProps, otherExternalForwardedProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(externalForwardedProps, $060817bd35ed0d61$var$_excluded8);
    const textFieldProps = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: $3Gp0b.PickersTextField,
        externalSlotProps: $060817bd35ed0d61$var$mergeSlotProps(pickerFieldUIContext.slotProps.textField, slotProps?.textField),
        externalForwardedProps: otherExternalForwardedProps,
        additionalProps: {
            ref: ref,
            sx: pickerContext?.rootSx,
            label: pickerContext?.label,
            name: pickerContext?.name,
            className: pickerContext?.rootClassName,
            inputRef: pickerFieldUIContext.inputRef
        },
        ownerState: ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $060817bd35ed0d61$var$_extends2.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $060817bd35ed0d61$var$_extends2.default)({}, InputProps, textFieldProps.InputProps);
    return textFieldProps;
}
function $060817bd35ed0d61$var$PickerFieldUIContextProvider(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, inputRef: inputRef, children: children } = props;
    const contextValue = $060817bd35ed0d61$var$React.useMemo(()=>({
            inputRef: inputRef,
            slots: {
                openPickerButton: slots.openPickerButton,
                openPickerIcon: slots.openPickerIcon,
                textField: slots.textField,
                inputAdornment: slots.inputAdornment,
                clearIcon: slots.clearIcon,
                clearButton: slots.clearButton
            },
            slotProps: {
                openPickerButton: slotProps.openPickerButton,
                openPickerIcon: slotProps.openPickerIcon,
                textField: slotProps.textField,
                inputAdornment: slotProps.inputAdornment,
                clearIcon: slotProps.clearIcon,
                clearButton: slotProps.clearButton
            }
        }), [
        inputRef,
        slots.openPickerButton,
        slots.openPickerIcon,
        slots.textField,
        slots.inputAdornment,
        slots.clearIcon,
        slots.clearButton,
        slotProps.openPickerButton,
        slotProps.openPickerIcon,
        slotProps.textField,
        slotProps.inputAdornment,
        slotProps.clearIcon,
        slotProps.clearButton
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($060817bd35ed0d61$var$PickerFieldUIContext.Provider, {
        value: contextValue,
        children: children
    });
}

});
parcelRegister("hABDe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("iAtns")).default);
$parcel$export(module.exports, "textFieldClasses", () => (parcelRequire("3epOE")).default);

var $iAtns = parcelRequire("iAtns");

var $3epOE = parcelRequire("3epOE");
$parcel$exportWildcard(module.exports, $3epOE);

});

parcelRegister("825Zh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9Lykx")).default);
$parcel$export(module.exports, "iconButtonClasses", () => (parcelRequire("jzUw6")).default);

var $9Lykx = parcelRequire("9Lykx");

var $jzUw6 = parcelRequire("jzUw6");
$parcel$exportWildcard(module.exports, $jzUw6);

});

parcelRegister("9bswS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("hViLc")).default);
$parcel$export(module.exports, "inputAdornmentClasses", () => (parcelRequire("kWfSh")).default);

var $hViLc = parcelRequire("hViLc");

var $kWfSh = parcelRequire("kWfSh");
$parcel$exportWildcard(module.exports, $kWfSh);

});

parcelRegister("8rVIo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $626d9d53bf62195d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $626d9d53bf62195d$var$_useSlotProps.default;
    }
});

var $626d9d53bf62195d$var$_useSlotProps = $626d9d53bf62195d$require$_interopRequireDefault((parcelRequire("am7hN")));

});
parcelRegister("am7hN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $78a19c4cfeef937d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a19c4cfeef937d$var$_useForkRef = $78a19c4cfeef937d$require$_interopRequireDefault((parcelRequire("88PIk")));

var $78a19c4cfeef937d$var$_appendOwnerState = $78a19c4cfeef937d$require$_interopRequireDefault((parcelRequire("1BnxV")));

var $78a19c4cfeef937d$var$_mergeSlotProps = $78a19c4cfeef937d$require$_interopRequireDefault((parcelRequire("jaDH7")));

var $78a19c4cfeef937d$var$_resolveComponentProps = $78a19c4cfeef937d$require$_interopRequireDefault((parcelRequire("4sXkv")));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $78a19c4cfeef937d$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $78a19c4cfeef937d$var$_resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $78a19c4cfeef937d$var$_mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $78a19c4cfeef937d$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $78a19c4cfeef937d$var$_appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $78a19c4cfeef937d$var$_default = module.exports.default = $78a19c4cfeef937d$var$useSlotProps;

});
parcelRegister("1BnxV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $12ab82efb2fa7c5b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $12ab82efb2fa7c5b$var$_appendOwnerState.default;
    }
});

var $12ab82efb2fa7c5b$var$_appendOwnerState = $12ab82efb2fa7c5b$require$_interopRequireDefault((parcelRequire("epBpf")));

});
parcelRegister("epBpf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a7e06a9c249ff1cd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7e06a9c249ff1cd$var$_isHostComponent = $a7e06a9c249ff1cd$require$_interopRequireDefault((parcelRequire("MeRRd")));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $a7e06a9c249ff1cd$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $a7e06a9c249ff1cd$var$_isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $a7e06a9c249ff1cd$var$_default = module.exports.default = $a7e06a9c249ff1cd$var$appendOwnerState;

});
parcelRegister("MeRRd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $09100437d9354aa0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $09100437d9354aa0$var$_isHostComponent.default;
    }
});

var $09100437d9354aa0$var$_isHostComponent = $09100437d9354aa0$require$_interopRequireDefault((parcelRequire("9ltb1")));

});
parcelRegister("9ltb1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $6cdcb521d53aec67$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $6cdcb521d53aec67$var$_default = module.exports.default = $6cdcb521d53aec67$var$isHostComponent;

});




parcelRegister("jaDH7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $df4dbdf83c895ebb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $df4dbdf83c895ebb$var$_mergeSlotProps.default;
    }
});

var $df4dbdf83c895ebb$var$_mergeSlotProps = $df4dbdf83c895ebb$require$_interopRequireDefault((parcelRequire("7fFSJ")));

});
parcelRegister("7fFSJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $547a6bf60c3ff6c0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $547a6bf60c3ff6c0$var$_clsx = $547a6bf60c3ff6c0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $547a6bf60c3ff6c0$var$_extractEventHandlers = $547a6bf60c3ff6c0$require$_interopRequireDefault((parcelRequire("90r1B")));

var $547a6bf60c3ff6c0$var$_omitEventHandlers = $547a6bf60c3ff6c0$require$_interopRequireDefault((parcelRequire("3tTzD")));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $547a6bf60c3ff6c0$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $547a6bf60c3ff6c0$var$_clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $547a6bf60c3ff6c0$var$_extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $547a6bf60c3ff6c0$var$_omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $547a6bf60c3ff6c0$var$_omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $547a6bf60c3ff6c0$var$_clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $547a6bf60c3ff6c0$var$_default = module.exports.default = $547a6bf60c3ff6c0$var$mergeSlotProps;

});
parcelRegister("90r1B", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $68e913b1e963fa3a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68e913b1e963fa3a$var$_extractEventHandlers.default;
    }
});

var $68e913b1e963fa3a$var$_extractEventHandlers = $68e913b1e963fa3a$require$_interopRequireDefault((parcelRequire("4fAtR")));

});
parcelRegister("4fAtR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $3184dc6936bc3466$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3184dc6936bc3466$var$_default = module.exports.default = $3184dc6936bc3466$var$extractEventHandlers;

});


parcelRegister("3tTzD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $288f304dafc08f46$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $288f304dafc08f46$var$_omitEventHandlers.default;
    }
});

var $288f304dafc08f46$var$_omitEventHandlers = $288f304dafc08f46$require$_interopRequireDefault((parcelRequire("9pPxq")));

});
parcelRegister("9pPxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $6dae6d405b272c0e$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $6dae6d405b272c0e$var$_default = module.exports.default = $6dae6d405b272c0e$var$omitEventHandlers;

});






parcelRegister("d51Yx", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $985d464b7bb70bde$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $985d464b7bb70bde$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldOwnerState = $985d464b7bb70bde$var$useFieldOwnerState;

var $985d464b7bb70bde$var$_extends2 = $985d464b7bb70bde$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $985d464b7bb70bde$var$React = $985d464b7bb70bde$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $7OOd8 = parcelRequire("7OOd8");
function $985d464b7bb70bde$var$useFieldOwnerState(parameters) {
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const isRtl = (0, $9uEev.useRtl)();
    return $985d464b7bb70bde$var$React.useMemo(()=>(0, $985d464b7bb70bde$var$_extends2.default)({}, pickerOwnerState, {
            isFieldDisabled: parameters.disabled ?? false,
            isFieldReadOnly: parameters.readOnly ?? false,
            isFieldRequired: parameters.required ?? false,
            fieldDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        parameters.disabled,
        parameters.readOnly,
        parameters.required,
        isRtl
    ]);
}

});
parcelRegister("7OOd8", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5b1426c0e5210fae$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerPrivateContext = void 0;

var $5b1426c0e5210fae$var$React = $5b1426c0e5210fae$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jk6Bf = parcelRequire("jk6Bf");
/**
 * Returns the private context passed by the Picker wrapping the current component.
 */ const $5b1426c0e5210fae$var$usePickerPrivateContext = ()=>$5b1426c0e5210fae$var$React.useContext($jk6Bf.PickerPrivateContext);
module.exports.usePickerPrivateContext = $5b1426c0e5210fae$var$usePickerPrivateContext;

});


parcelRegister("1SVAo", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $15f780f59fa32b0f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeIcon = module.exports.DateRangeIcon = module.exports.ClockIcon = module.exports.ClearIcon = module.exports.CalendarIcon = module.exports.ArrowRightIcon = module.exports.ArrowLeftIcon = module.exports.ArrowDropDownIcon = void 0;

var $bbT5Q = parcelRequire("bbT5Q");

var $15f780f59fa32b0f$var$React = $15f780f59fa32b0f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ArrowDropDownIcon = module.exports.ArrowDropDownIcon = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ArrowLeftIcon = module.exports.ArrowLeftIcon = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ArrowRightIcon = module.exports.ArrowRightIcon = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$CalendarIcon = module.exports.CalendarIcon = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ClockIcon = module.exports.ClockIcon = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($15f780f59fa32b0f$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$DateRangeIcon = module.exports.DateRangeIcon = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$TimeIcon = module.exports.TimeIcon = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($15f780f59fa32b0f$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ClearIcon = module.exports.ClearIcon = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

});

parcelRegister("3Gp0b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2ae8b0334fa2115e$var$_exportNames = {
    PickersTextField: true,
    pickersTextFieldClasses: true,
    getPickersTextFieldUtilityClass: true
};
Object.defineProperty(module.exports, "PickersTextField", {
    enumerable: true,
    get: function() {
        return $xZ8Ea.PickersTextField;
    }
});
Object.defineProperty(module.exports, "getPickersTextFieldUtilityClass", {
    enumerable: true,
    get: function() {
        return $5rDth.getPickersTextFieldUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersTextFieldClasses", {
    enumerable: true,
    get: function() {
        return $5rDth.pickersTextFieldClasses;
    }
});

var $xZ8Ea = parcelRequire("xZ8Ea");

var $5rDth = parcelRequire("5rDth");

var $aaK30 = parcelRequire("aaK30");
Object.keys($aaK30).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ae8b0334fa2115e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $aaK30[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aaK30[key];
        }
    });
});

var $2CiZK = parcelRequire("2CiZK");
Object.keys($2CiZK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ae8b0334fa2115e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2CiZK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2CiZK[key];
        }
    });
});

var $3KixP = parcelRequire("3KixP");
Object.keys($3KixP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ae8b0334fa2115e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3KixP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3KixP[key];
        }
    });
});

var $id0az = parcelRequire("id0az");
Object.keys($id0az).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ae8b0334fa2115e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $id0az[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $id0az[key];
        }
    });
});

});
parcelRegister("xZ8Ea", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $06628201f2cc4505$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $06628201f2cc4505$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersTextField = void 0;

var $06628201f2cc4505$var$_extends2 = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $06628201f2cc4505$var$_objectWithoutPropertiesLoose2 = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("c05no")));

var $06628201f2cc4505$var$React = $06628201f2cc4505$require$_interopRequireWildcard((parcelRequire("acw62")));

var $06628201f2cc4505$var$_propTypes = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $06628201f2cc4505$var$_clsx = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $06628201f2cc4505$var$_refType = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $06628201f2cc4505$var$_useForkRef = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("88PIk")));

var $06628201f2cc4505$var$_composeClasses = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $06628201f2cc4505$var$_useId = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("5Db2s")));

var $06628201f2cc4505$var$_InputLabel = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("k9xmz")));

var $06628201f2cc4505$var$_FormHelperText = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("4xkW2")));

var $06628201f2cc4505$var$_FormControl = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("iA4iQ")));

var $5rDth = parcelRequire("5rDth");

var $3KixP = parcelRequire("3KixP");

var $2CiZK = parcelRequire("2CiZK");

var $aaK30 = parcelRequire("aaK30");

var $d51Yx = parcelRequire("d51Yx");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $06628201f2cc4505$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "classes",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "hiddenLabel",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps",
    "data-active-range-position"
];
const $06628201f2cc4505$var$VARIANT_COMPONENT = {
    standard: $aaK30.PickersInput,
    filled: $2CiZK.PickersFilledInput,
    outlined: $3KixP.PickersOutlinedInput
};
const $06628201f2cc4505$var$PickersTextFieldRoot = (0, $d8seH.default)($06628201f2cc4505$var$_FormControl.default, {
    name: 'MuiPickersTextField',
    slot: 'Root'
})({
    maxWidth: '100%'
});
const $06628201f2cc4505$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldRequired: isFieldRequired } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldRequired && 'required'
        ]
    };
    return (0, $06628201f2cc4505$var$_composeClasses.default)(slots, $5rDth.getPickersTextFieldUtilityClass, classes);
};
const $06628201f2cc4505$var$PickersTextField = module.exports.PickersTextField = /*#__PURE__*/ $06628201f2cc4505$var$React.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, classes: classesProp, color: color = 'primary', disabled: disabled = false, error: error = false, variant: variant = 'outlined', required: required = false, hiddenLabel: hiddenLabel = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps, // @ts-ignore
    'data-active-range-position': dataActiveRangePosition } = props, other = (0, $06628201f2cc4505$var$_objectWithoutPropertiesLoose2.default)(props, $06628201f2cc4505$var$_excluded);
    const rootRef = $06628201f2cc4505$var$React.useRef(null);
    const handleRootRef = (0, $06628201f2cc4505$var$_useForkRef.default)(ref, rootRef);
    const id = (0, $06628201f2cc4505$var$_useId.default)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const fieldOwnerState = (0, $d51Yx.useFieldOwnerState)({
        disabled: props.disabled,
        required: props.required,
        readOnly: InputProps?.readOnly
    });
    const ownerState = $06628201f2cc4505$var$React.useMemo(()=>(0, $06628201f2cc4505$var$_extends2.default)({}, fieldOwnerState, {
            isFieldValueEmpty: areAllSectionsEmpty,
            isFieldFocused: focused ?? false,
            hasFieldError: error ?? false,
            inputSize: props.size ?? 'medium',
            inputColor: color ?? 'primary',
            isInputInFullWidth: fullWidth ?? false,
            hasStartAdornment: Boolean(startAdornment ?? InputProps?.startAdornment),
            hasEndAdornment: Boolean(endAdornment ?? InputProps?.endAdornment),
            inputHasLabel: !!label,
            isLabelShrunk: Boolean(InputLabelProps?.shrink)
        }), [
        fieldOwnerState,
        areAllSectionsEmpty,
        focused,
        error,
        props.size,
        color,
        fullWidth,
        startAdornment,
        endAdornment,
        InputProps?.startAdornment,
        InputProps?.endAdornment,
        label,
        InputLabelProps?.shrink
    ]);
    const classes = $06628201f2cc4505$var$useUtilityClasses(classesProp, ownerState);
    const PickersInputComponent = $06628201f2cc4505$var$VARIANT_COMPONENT[variant];
    const inputAdditionalProps = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') inputAdditionalProps.notched = InputLabelProps.shrink;
        inputAdditionalProps.label = label;
    } else if (variant === 'filled') inputAdditionalProps.hiddenLabel = hiddenLabel;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8COFU.PickerTextFieldOwnerStateContext.Provider, {
        value: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($06628201f2cc4505$var$PickersTextFieldRoot, (0, $06628201f2cc4505$var$_extends2.default)({
            className: (0, $06628201f2cc4505$var$_clsx.default)(classes.root, className),
            ref: handleRootRef,
            focused: focused,
            disabled: disabled,
            variant: variant,
            error: error,
            color: color,
            fullWidth: fullWidth,
            required: required,
            ownerState: ownerState
        }, other, {
            children: [
                label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)($06628201f2cc4505$var$_InputLabel.default, (0, $06628201f2cc4505$var$_extends2.default)({
                    htmlFor: id,
                    id: inputLabelId
                }, InputLabelProps, {
                    children: label
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)(PickersInputComponent, (0, $06628201f2cc4505$var$_extends2.default)({
                    elements: elements,
                    areAllSectionsEmpty: areAllSectionsEmpty,
                    onClick: onClick,
                    onKeyDown: onKeyDown,
                    onKeyUp: onKeyUp,
                    onInput: onInput,
                    onPaste: onPaste,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    endAdornment: endAdornment,
                    startAdornment: startAdornment,
                    tabIndex: tabIndex,
                    contentEditable: contentEditable,
                    value: value,
                    onChange: onChange,
                    id: id,
                    fullWidth: fullWidth,
                    inputProps: inputProps,
                    inputRef: inputRef,
                    sectionListRef: sectionListRef,
                    label: label,
                    name: name,
                    role: "group",
                    "aria-labelledby": inputLabelId,
                    "aria-describedby": helperTextId,
                    "aria-live": helperTextId ? 'polite' : undefined,
                    "data-active-range-position": dataActiveRangePosition
                }, inputAdditionalProps, InputProps)),
                helperText && /*#__PURE__*/ (0, $ayMG0.jsx)($06628201f2cc4505$var$_FormHelperText.default, (0, $06628201f2cc4505$var$_extends2.default)({
                    id: helperTextId
                }, FormHelperTextProps, {
                    children: helperText
                }))
            ]
        }))
    });
});

});
parcelRegister("1gqgQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0ebba9ddb7bb973c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0ebba9ddb7bb973c$var$_composeClasses.default;
    }
});

var $0ebba9ddb7bb973c$var$_composeClasses = $0ebba9ddb7bb973c$require$_interopRequireDefault((parcelRequire("60wJT")));

});
parcelRegister("60wJT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45fc2377ccc817db$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $45fc2377ccc817db$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});


parcelRegister("k9xmz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("OEVqP")).default);
$parcel$export(module.exports, "inputLabelClasses", () => (parcelRequire("cCThE")).default);

var $OEVqP = parcelRequire("OEVqP");

var $cCThE = parcelRequire("cCThE");
$parcel$exportWildcard(module.exports, $cCThE);

});

parcelRegister("4xkW2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("i32L9")).default);
$parcel$export(module.exports, "formHelperTextClasses", () => (parcelRequire("e7ceb")).default);

var $i32L9 = parcelRequire("i32L9");

var $e7ceb = parcelRequire("e7ceb");
$parcel$exportWildcard(module.exports, $e7ceb);

});

parcelRegister("iA4iQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("gd5y7")).default);
$parcel$export(module.exports, "useFormControl", () => (parcelRequire("cJQfW")).default);
$parcel$export(module.exports, "formControlClasses", () => (parcelRequire("hGBKj")).default);

var $gd5y7 = parcelRequire("gd5y7");

var $cJQfW = parcelRequire("cJQfW");

var $hGBKj = parcelRequire("hGBKj");
$parcel$exportWildcard(module.exports, $hGBKj);

});

parcelRegister("5rDth", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3f6e178f64e28835$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersTextFieldUtilityClass = $3f6e178f64e28835$var$getPickersTextFieldUtilityClass;
module.exports.pickersTextFieldClasses = void 0;

var $3f6e178f64e28835$var$_generateUtilityClass = $3f6e178f64e28835$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $3f6e178f64e28835$var$_generateUtilityClasses = $3f6e178f64e28835$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $3f6e178f64e28835$var$getPickersTextFieldUtilityClass(slot) {
    return (0, $3f6e178f64e28835$var$_generateUtilityClass.default)('MuiPickersTextField', slot);
}
const $3f6e178f64e28835$var$pickersTextFieldClasses = module.exports.pickersTextFieldClasses = (0, $3f6e178f64e28835$var$_generateUtilityClasses.default)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);

});
parcelRegister("l9FHx", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f66ac93a0b424597$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f66ac93a0b424597$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f66ac93a0b424597$var$_generateUtilityClass.default;
    }
});

var $f66ac93a0b424597$var$_generateUtilityClass = $f66ac93a0b424597$require$_interopRequireWildcard((parcelRequire("c375a")));
Object.keys($f66ac93a0b424597$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f66ac93a0b424597$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f66ac93a0b424597$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f66ac93a0b424597$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("c375a", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8c5b42419317f394$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c5b42419317f394$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $8c5b42419317f394$var$isGlobalState;

var $8c5b42419317f394$var$_ClassNameGenerator = $8c5b42419317f394$require$_interopRequireDefault((parcelRequire("ikm3S")));
const $8c5b42419317f394$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $8c5b42419317f394$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $8c5b42419317f394$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$8c5b42419317f394$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $8c5b42419317f394$var$isGlobalState(slot) {
    return $8c5b42419317f394$var$globalStateClasses[slot] !== undefined;
}

});
parcelRegister("ikm3S", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d57b353b5c425d8b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d57b353b5c425d8b$var$_ClassNameGenerator.default;
    }
});

var $d57b353b5c425d8b$var$_ClassNameGenerator = $d57b353b5c425d8b$require$_interopRequireDefault((parcelRequire("d1z6h")));

});
parcelRegister("d1z6h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $97b6988a5fef6a77$var$defaultGenerator = (componentName)=>componentName;
const $97b6988a5fef6a77$var$createClassNameGenerator = ()=>{
    let generate = $97b6988a5fef6a77$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $97b6988a5fef6a77$var$defaultGenerator;
        }
    };
};
const $97b6988a5fef6a77$var$ClassNameGenerator = $97b6988a5fef6a77$var$createClassNameGenerator();
var $97b6988a5fef6a77$var$_default = module.exports.default = $97b6988a5fef6a77$var$ClassNameGenerator;

});




parcelRegister("fXRFb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b9f5fe1c709af903$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b9f5fe1c709af903$var$_generateUtilityClasses.default;
    }
});

var $b9f5fe1c709af903$var$_generateUtilityClasses = $b9f5fe1c709af903$require$_interopRequireDefault((parcelRequire("bLCfB")));

});
parcelRegister("bLCfB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8911c14d46856143$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8911c14d46856143$var$generateUtilityClasses;

var $8911c14d46856143$var$_generateUtilityClass = $8911c14d46856143$require$_interopRequireDefault((parcelRequire("l9FHx")));
function $8911c14d46856143$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $8911c14d46856143$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});



parcelRegister("3KixP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersOutlinedInput", {
    enumerable: true,
    get: function() {
        return $2ONZk.PickersOutlinedInput;
    }
});
Object.defineProperty(module.exports, "getPickersOutlinedInputUtilityClass", {
    enumerable: true,
    get: function() {
        return $1lpfw.getPickersOutlinedInputUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersOutlinedInputClasses", {
    enumerable: true,
    get: function() {
        return $1lpfw.pickersOutlinedInputClasses;
    }
});

var $2ONZk = parcelRequire("2ONZk");

var $1lpfw = parcelRequire("1lpfw");

});
parcelRegister("2ONZk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $20d706e29be2fff2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $20d706e29be2fff2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersOutlinedInput = void 0;

var $20d706e29be2fff2$var$_objectWithoutPropertiesLoose2 = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("c05no")));

var $20d706e29be2fff2$var$_extends2 = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $20d706e29be2fff2$var$React = $20d706e29be2fff2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $20d706e29be2fff2$var$_propTypes = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $20d706e29be2fff2$var$_refType = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $20d706e29be2fff2$var$_composeClasses = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $1lpfw = parcelRequire("1lpfw");

var $20d706e29be2fff2$var$_Outline = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("3f6Ua")));

var $id0az = parcelRequire("id0az");

var $f9pWD = parcelRequire("f9pWD");

var $ayMG0 = parcelRequire("ayMG0");
const $20d706e29be2fff2$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "classes",
    "notched"
];
const $20d706e29be2fff2$var$PickersOutlinedInputRoot = (0, $d8seH.default)($f9pWD.PickersInputBaseRoot, {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${$1lpfw.pickersOutlinedInputClasses.focused} .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${$1lpfw.pickersOutlinedInputClasses.disabled}`]: {
            [`& .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${$1lpfw.pickersOutlinedInputClasses.error} .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    inputColor: color
                },
                style: {
                    [`&.${$1lpfw.pickersOutlinedInputClasses.focused}:not(.${$1lpfw.pickersOutlinedInputClasses.error}) .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $20d706e29be2fff2$var$PickersOutlinedInputSectionsContainer = (0, $d8seH.default)($f9pWD.PickersInputBaseSectionsContainer, {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer'
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const $20d706e29be2fff2$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $20d706e29be2fff2$var$_composeClasses.default)(slots, $1lpfw.getPickersOutlinedInputUtilityClass, classes);
    return (0, $20d706e29be2fff2$var$_extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $20d706e29be2fff2$var$PickersOutlinedInput = module.exports.PickersOutlinedInput = /*#__PURE__*/ $20d706e29be2fff2$var$React.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label: label, classes: classesProp, notched: notched } = props, other = (0, $20d706e29be2fff2$var$_objectWithoutPropertiesLoose2.default)(props, $20d706e29be2fff2$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const classes = $20d706e29be2fff2$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($id0az.PickersInputBase, (0, $20d706e29be2fff2$var$_extends2.default)({
        slots: {
            root: $20d706e29be2fff2$var$PickersOutlinedInputRoot,
            input: $20d706e29be2fff2$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($20d706e29be2fff2$var$_Outline.default, {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== '' && muiFormControl?.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($20d706e29be2fff2$var$React.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$20d706e29be2fff2$var$PickersOutlinedInput.muiName = 'Input';

});
parcelRegister("1lpfw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0fab569a23858f12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersOutlinedInputUtilityClass = $0fab569a23858f12$var$getPickersOutlinedInputUtilityClass;
module.exports.pickersOutlinedInputClasses = void 0;

var $0fab569a23858f12$var$_extends2 = $0fab569a23858f12$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0fab569a23858f12$var$_generateUtilityClasses = $0fab569a23858f12$require$_interopRequireDefault((parcelRequire("fXRFb")));

var $0fab569a23858f12$var$_generateUtilityClass = $0fab569a23858f12$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $id0az = parcelRequire("id0az");
function $0fab569a23858f12$var$getPickersOutlinedInputUtilityClass(slot) {
    return (0, $0fab569a23858f12$var$_generateUtilityClass.default)('MuiPickersOutlinedInput', slot);
}
const $0fab569a23858f12$var$pickersOutlinedInputClasses = module.exports.pickersOutlinedInputClasses = (0, $0fab569a23858f12$var$_extends2.default)({}, $id0az.pickersInputBaseClasses, (0, $0fab569a23858f12$var$_generateUtilityClasses.default)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));

});
parcelRegister("id0az", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersInputBase", {
    enumerable: true,
    get: function() {
        return $f9pWD.PickersInputBase;
    }
});
Object.defineProperty(module.exports, "getPickersInputBaseUtilityClass", {
    enumerable: true,
    get: function() {
        return $acVM5.getPickersInputBaseUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersInputBaseClasses", {
    enumerable: true,
    get: function() {
        return $acVM5.pickersInputBaseClasses;
    }
});

var $f9pWD = parcelRequire("f9pWD");

var $acVM5 = parcelRequire("acVM5");

});
parcelRegister("f9pWD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b07bd25b455bc147$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b07bd25b455bc147$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersInputBaseSectionsContainer = module.exports.PickersInputBaseRoot = module.exports.PickersInputBase = void 0;

var $b07bd25b455bc147$var$_objectWithoutPropertiesLoose2 = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("c05no")));

var $b07bd25b455bc147$var$_extends2 = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b07bd25b455bc147$var$React = $b07bd25b455bc147$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b07bd25b455bc147$var$_propTypes = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $b07bd25b455bc147$var$_useForkRef = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("88PIk")));

var $b07bd25b455bc147$var$_refType = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $b07bd25b455bc147$var$_composeClasses = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $b07bd25b455bc147$var$_capitalize = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("fpkXn")));

var $b07bd25b455bc147$var$_useSlotProps = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $b07bd25b455bc147$var$_visuallyHidden = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("u8J1M")));

var $acVM5 = parcelRequire("acVM5");

var $c07gn = parcelRequire("c07gn");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $b07bd25b455bc147$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "onFocus",
    "onBlur",
    "classes",
    "ownerState"
];
const $b07bd25b455bc147$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $b07bd25b455bc147$var$PickersInputBaseRoot = module.exports.PickersInputBaseRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root'
})(({ theme: theme })=>(0, $b07bd25b455bc147$var$_extends2.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$b07bd25b455bc147$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    isInputInFullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $b07bd25b455bc147$var$PickersInputBaseSectionsContainer = module.exports.PickersInputBaseSectionsContainer = (0, $d8seH.default)($c07gn.Unstable_PickersSectionListRoot, {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer'
})(({ theme: theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    fieldDirection: 'rtl'
                },
                style: {
                    justifyContent: 'end'
                }
            },
            {
                props: {
                    inputSize: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: false
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: true,
                    isLabelShrunk: true
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            }
        ]
    }));
const $b07bd25b455bc147$var$PickersInputBaseSection = (0, $d8seH.default)($c07gn.Unstable_PickersSectionListSection, {
    name: 'MuiPickersInputBase',
    slot: 'Section'
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const $b07bd25b455bc147$var$PickersInputBaseSectionContent = (0, $d8seH.default)($c07gn.Unstable_PickersSectionListSectionContent, {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content // FIXME: Inconsistent naming with slot
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const $b07bd25b455bc147$var$PickersInputBaseSectionSeparator = (0, $d8seH.default)($c07gn.Unstable_PickersSectionListSectionSeparator, {
    name: 'MuiPickersInputBase',
    slot: 'Separator'
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const $b07bd25b455bc147$var$PickersInputBaseInput = (0, $d8seH.default)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput // FIXME: Inconsistent naming with slot
})((0, $b07bd25b455bc147$var$_extends2.default)({}, $b07bd25b455bc147$var$_visuallyHidden.default));
const $b07bd25b455bc147$var$PickersInputBaseActiveBar = (0, $d8seH.default)('div', {
    name: 'MuiPickersInputBase',
    slot: 'ActiveBar'
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'none',
        position: 'absolute',
        height: 2,
        bottom: 2,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        transition: theme.transitions.create([
            'width',
            'left'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.primary.main,
        '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
            display: 'block'
        },
        '[data-active-range-position="start"] &': {
            left: ownerState.sectionOffsets[0]
        },
        '[data-active-range-position="end"] &': {
            left: ownerState.sectionOffsets[1]
        }
    }));
const $b07bd25b455bc147$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldReadOnly: isFieldReadOnly, hasFieldError: hasFieldError, inputSize: inputSize, isInputInFullWidth: isInputInFullWidth, inputColor: inputColor, hasStartAdornment: hasStartAdornment, hasEndAdornment: hasEndAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldReadOnly && 'readOnly',
            hasFieldError && 'error',
            isInputInFullWidth && 'fullWidth',
            `color${(0, $b07bd25b455bc147$var$_capitalize.default)(inputColor)}`,
            inputSize === 'small' && 'inputSizeSmall',
            hasStartAdornment && 'adornedStart',
            hasEndAdornment && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ],
        activeBar: [
            'activeBar'
        ]
    };
    return (0, $b07bd25b455bc147$var$_composeClasses.default)(slots, $acVM5.getPickersInputBaseUtilityClass, classes);
};
function $b07bd25b455bc147$var$resolveSectionElementWidth(sectionElement, rootRef, index, dateRangePosition) {
    if (sectionElement.content.id) {
        const activeSectionElements = rootRef.current?.querySelectorAll(`[data-sectionindex="${index}"] [data-range-position="${dateRangePosition}"]`);
        if (activeSectionElements) return Array.from(activeSectionElements).reduce((currentActiveBarWidth, element)=>{
            return currentActiveBarWidth + element.offsetWidth;
        }, 0);
    }
    return 0;
}
function $b07bd25b455bc147$var$resolveSectionWidthAndOffsets(elements, rootRef) {
    let activeBarWidth = 0;
    const activeRangePosition = rootRef.current?.getAttribute('data-active-range-position');
    if (activeRangePosition === 'end') for(let i = elements.length - 1; i >= elements.length / 2; i -= 1)activeBarWidth += $b07bd25b455bc147$var$resolveSectionElementWidth(elements[i], rootRef, i, 'end');
    else for(let i = 0; i < elements.length / 2; i += 1)activeBarWidth += $b07bd25b455bc147$var$resolveSectionElementWidth(elements[i], rootRef, i, 'start');
    return {
        activeBarWidth: activeBarWidth,
        sectionOffsets: [
            rootRef.current?.querySelector(`[data-sectionindex="0"]`)?.offsetLeft || 0,
            rootRef.current?.querySelector(`[data-sectionindex="${elements.length / 2}"]`)?.offsetLeft || 0
        ]
    };
}
/**
 * @ignore - internal component.
 */ const $b07bd25b455bc147$var$PickersInputBase = module.exports.PickersInputBase = /*#__PURE__*/ $b07bd25b455bc147$var$React.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, onFocus: onFocus, onBlur: onBlur, classes: classesProp, ownerState: ownerStateProp } = props, other = (0, $b07bd25b455bc147$var$_objectWithoutPropertiesLoose2.default)(props, $b07bd25b455bc147$var$_excluded);
    const ownerStateContext = (0, $8COFU.usePickerTextFieldOwnerState)();
    const rootRef = $b07bd25b455bc147$var$React.useRef(null);
    const activeBarRef = $b07bd25b455bc147$var$React.useRef(null);
    const sectionOffsetsRef = $b07bd25b455bc147$var$React.useRef([]);
    const handleRootRef = (0, $b07bd25b455bc147$var$_useForkRef.default)(ref, rootRef);
    const handleInputRef = (0, $b07bd25b455bc147$var$_useForkRef.default)(inputProps?.ref, inputRef);
    const muiFormControl = (0, $cJQfW.default)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const ownerState = ownerStateProp ?? ownerStateContext;
    const handleInputFocus = (event)=>{
        muiFormControl.onFocus?.(event);
        onFocus?.(event);
    };
    const handleHiddenInputFocus = (event)=>{
        handleInputFocus(event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (event.key === 'Enter' && !event.defaultMuiPrevented) {
            // Do nothing if it's a multi input field
            if (rootRef.current?.dataset.multiInput) return;
            const closestForm = rootRef.current?.closest('form');
            const submitTrigger = closestForm?.querySelector('[type="submit"]');
            if (!closestForm || !submitTrigger) // do nothing if there is no form or no submit button (trigger)
            return;
            event.preventDefault();
            // native input trigger submit with the `submitter` field set
            closestForm.requestSubmit(submitTrigger);
        }
    };
    const handleInputBlur = (event)=>{
        muiFormControl.onBlur?.(event);
        onBlur?.(event);
    };
    $b07bd25b455bc147$var$React.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $b07bd25b455bc147$var$React.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const classes = $b07bd25b455bc147$var$useUtilityClasses(classesProp, ownerState);
    const InputRoot = slots?.root || $b07bd25b455bc147$var$PickersInputBaseRoot;
    const inputRootProps = (0, $b07bd25b455bc147$var$_useSlotProps.default)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $b07bd25b455bc147$var$PickersInputBaseSectionsContainer;
    const isSingleInputRange = elements.some((element)=>element.content['data-range-position'] !== undefined);
    $b07bd25b455bc147$var$React.useEffect(()=>{
        if (!isSingleInputRange || !ownerState.isPickerOpen) return;
        const { activeBarWidth: activeBarWidth, sectionOffsets: sectionOffsets } = $b07bd25b455bc147$var$resolveSectionWidthAndOffsets(elements, rootRef);
        sectionOffsetsRef.current = [
            sectionOffsets[0],
            sectionOffsets[1]
        ];
        if (activeBarRef.current) activeBarRef.current.style.width = `${activeBarWidth}px`;
    }, [
        elements,
        isSingleInputRange,
        ownerState.isPickerOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(InputRoot, (0, $b07bd25b455bc147$var$_extends2.default)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $ayMG0.jsx)($c07gn.Unstable_PickersSectionList, {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: handleKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $b07bd25b455bc147$var$PickersInputBaseSection,
                    sectionContent: $b07bd25b455bc147$var$PickersInputBaseSectionContent,
                    sectionSeparator: $b07bd25b455bc147$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: (0, $b07bd25b455bc147$var$_extends2.default)({}, slotProps?.input, {
                        ownerState: ownerState
                    }),
                    sectionContent: {
                        className: $acVM5.pickersInputBaseClasses.sectionContent
                    },
                    sectionSeparator: ({ separatorPosition: separatorPosition })=>({
                            className: separatorPosition === 'before' ? $acVM5.pickersInputBaseClasses.sectionBefore : $acVM5.pickersInputBaseClasses.sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $b07bd25b455bc147$var$_extends2.default)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($b07bd25b455bc147$var$PickersInputBaseInput, (0, $b07bd25b455bc147$var$_extends2.default)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled,
                onFocus: handleHiddenInputFocus
            }, inputProps, {
                ref: handleInputRef
            })),
            isSingleInputRange && /*#__PURE__*/ (0, $ayMG0.jsx)($b07bd25b455bc147$var$PickersInputBaseActiveBar, {
                className: classes.activeBar,
                ref: activeBarRef,
                ownerState: {
                    sectionOffsets: sectionOffsetsRef.current
                }
            })
        ]
    }));
});

});
parcelRegister("fpkXn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b3797264e68f4fcf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b3797264e68f4fcf$var$_capitalize.default;
    }
});

var $b3797264e68f4fcf$var$_capitalize = $b3797264e68f4fcf$require$_interopRequireDefault((parcelRequire("icANi")));

});
parcelRegister("icANi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d405e389239a5500$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d405e389239a5500$var$capitalize;

var $d405e389239a5500$var$_formatMuiErrorMessage = $d405e389239a5500$require$_interopRequireDefault((parcelRequire("5qeiU")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $d405e389239a5500$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $d405e389239a5500$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("5qeiU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3f2a79e998d021e4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3f2a79e998d021e4$var$_formatMuiErrorMessage.default;
    }
});

var $3f2a79e998d021e4$var$_formatMuiErrorMessage = $3f2a79e998d021e4$require$_interopRequireDefault((parcelRequire("PnBEj")));

});
parcelRegister("PnBEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $09a7133e59d0261e$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $09a7133e59d0261e$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});




parcelRegister("u8J1M", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05a9921c49575b99$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $05a9921c49575b99$var$_visuallyHidden.default;
    }
});

var $05a9921c49575b99$var$_visuallyHidden = $05a9921c49575b99$require$_interopRequireDefault((parcelRequire("cYLNH")));

});
parcelRegister("cYLNH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $97302ad2e8a72bc6$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $97302ad2e8a72bc6$var$_default = module.exports.default = $97302ad2e8a72bc6$var$visuallyHidden;

});


parcelRegister("acVM5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $76e7d735dfe68a88$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersInputBaseUtilityClass = $76e7d735dfe68a88$var$getPickersInputBaseUtilityClass;
module.exports.pickersInputBaseClasses = void 0;

var $76e7d735dfe68a88$var$_generateUtilityClass = $76e7d735dfe68a88$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $76e7d735dfe68a88$var$_generateUtilityClasses = $76e7d735dfe68a88$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $76e7d735dfe68a88$var$getPickersInputBaseUtilityClass(slot) {
    return (0, $76e7d735dfe68a88$var$_generateUtilityClass.default)('MuiPickersInputBase', slot);
}
const $76e7d735dfe68a88$var$pickersInputBaseClasses = module.exports.pickersInputBaseClasses = (0, $76e7d735dfe68a88$var$_generateUtilityClasses.default)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input',
    'inputSizeSmall',
    'activeBar'
]);

});

parcelRegister("c07gn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Unstable_PickersSectionList", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionList;
    }
});
Object.defineProperty(module.exports, "Unstable_PickersSectionListRoot", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionListRoot;
    }
});
Object.defineProperty(module.exports, "Unstable_PickersSectionListSection", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionListSection;
    }
});
Object.defineProperty(module.exports, "Unstable_PickersSectionListSectionContent", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionListSectionContent;
    }
});
Object.defineProperty(module.exports, "Unstable_PickersSectionListSectionSeparator", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionListSectionSeparator;
    }
});
Object.defineProperty(module.exports, "getPickersSectionListUtilityClass", {
    enumerable: true,
    get: function() {
        return $1v8a2.getPickersSectionListUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersSectionListClasses", {
    enumerable: true,
    get: function() {
        return $1v8a2.pickersSectionListClasses;
    }
});

var $8STD8 = parcelRequire("8STD8");

var $1v8a2 = parcelRequire("1v8a2");

});
parcelRegister("8STD8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $677e84dab89c4abd$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $677e84dab89c4abd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersSectionListSectionSeparator = module.exports.PickersSectionListSectionContent = module.exports.PickersSectionListSection = module.exports.PickersSectionListRoot = module.exports.PickersSectionList = void 0;

var $677e84dab89c4abd$var$_objectWithoutPropertiesLoose2 = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("c05no")));

var $677e84dab89c4abd$var$_extends2 = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $677e84dab89c4abd$var$React = $677e84dab89c4abd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $677e84dab89c4abd$var$_propTypes = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $677e84dab89c4abd$var$_useSlotProps = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $677e84dab89c4abd$var$_composeClasses = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $677e84dab89c4abd$var$_useForkRef = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("88PIk")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $1v8a2 = parcelRequire("1v8a2");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $677e84dab89c4abd$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef",
    "classes"
];
const $677e84dab89c4abd$var$PickersSectionListRoot = module.exports.PickersSectionListRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root'
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const $677e84dab89c4abd$var$PickersSectionListSection = module.exports.PickersSectionListSection = (0, $d8seH.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section'
})({});
const $677e84dab89c4abd$var$PickersSectionListSectionSeparator = module.exports.PickersSectionListSectionSeparator = (0, $d8seH.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator'
})({
    whiteSpace: 'pre'
});
const $677e84dab89c4abd$var$PickersSectionListSectionContent = module.exports.PickersSectionListSectionContent = (0, $d8seH.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent'
})({
    outline: 'none'
});
const $677e84dab89c4abd$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, $677e84dab89c4abd$var$_composeClasses.default)(slots, $1v8a2.getPickersSectionListUtilityClass, classes);
};
function $677e84dab89c4abd$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const Section = slots?.section ?? $677e84dab89c4abd$var$PickersSectionListSection;
    const sectionProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: ownerState
    });
    const SectionContent = slots?.sectionContent ?? $677e84dab89c4abd$var$PickersSectionListSectionContent;
    const sectionContentProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: ownerState
    });
    const SectionSeparator = slots?.sectionSeparator ?? $677e84dab89c4abd$var$PickersSectionListSectionSeparator;
    const sectionSeparatorBeforeProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: (0, $677e84dab89c4abd$var$_extends2.default)({}, ownerState, {
            separatorPosition: 'before'
        })
    });
    const sectionSeparatorAfterProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: (0, $677e84dab89c4abd$var$_extends2.default)({}, ownerState, {
            separatorPosition: 'after'
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(Section, (0, $677e84dab89c4abd$var$_extends2.default)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionSeparator, (0, $677e84dab89c4abd$var$_extends2.default)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionContent, (0, $677e84dab89c4abd$var$_extends2.default)({}, sectionContentProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionSeparator, (0, $677e84dab89c4abd$var$_extends2.default)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $677e84dab89c4abd$var$PickersSectionList = module.exports.PickersSectionList = /*#__PURE__*/ $677e84dab89c4abd$var$React.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef, classes: classesProp } = props, other = (0, $677e84dab89c4abd$var$_objectWithoutPropertiesLoose2.default)(props, $677e84dab89c4abd$var$_excluded);
    const classes = $677e84dab89c4abd$var$useUtilityClasses(classesProp);
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const rootRef = $677e84dab89c4abd$var$React.useRef(null);
    const handleRootRef = (0, $677e84dab89c4abd$var$_useForkRef.default)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $677e84dab89c4abd$var$React.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${$1v8a2.pickersSectionListClasses.section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${$1v8a2.pickersSectionListClasses.section}[data-sectionindex="${index}"] .${$1v8a2.pickersSectionListClasses.sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains($1v8a2.pickersSectionListClasses.section)) sectionContainer = element;
                else if (element.classList.contains($1v8a2.pickersSectionListClasses.sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $677e84dab89c4abd$var$PickersSectionListRoot;
    const rootProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $677e84dab89c4abd$var$_extends2.default)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, $ayMG0.jsx)($677e84dab89c4abd$var$React.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($677e84dab89c4abd$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});

});
parcelRegister("1v8a2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $117f0443ae3d158a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersSectionListUtilityClass = $117f0443ae3d158a$var$getPickersSectionListUtilityClass;
module.exports.pickersSectionListClasses = void 0;

var $117f0443ae3d158a$var$_generateUtilityClass = $117f0443ae3d158a$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $117f0443ae3d158a$var$_generateUtilityClasses = $117f0443ae3d158a$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $117f0443ae3d158a$var$getPickersSectionListUtilityClass(slot) {
    return (0, $117f0443ae3d158a$var$_generateUtilityClass.default)('MuiPickersSectionList', slot);
}
const $117f0443ae3d158a$var$pickersSectionListClasses = module.exports.pickersSectionListClasses = (0, $117f0443ae3d158a$var$_generateUtilityClasses.default)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);

});



parcelRegister("8COFU", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $64792e4f229a7d73$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerTextFieldOwnerState = module.exports.PickerTextFieldOwnerStateContext = void 0;

var $64792e4f229a7d73$var$React = $64792e4f229a7d73$require$_interopRequireWildcard((parcelRequire("acw62")));
const $64792e4f229a7d73$var$PickerTextFieldOwnerStateContext = module.exports.PickerTextFieldOwnerStateContext = /*#__PURE__*/ $64792e4f229a7d73$var$React.createContext(null);
const $64792e4f229a7d73$var$usePickerTextFieldOwnerState = ()=>{
    const value = $64792e4f229a7d73$var$React.useContext($64792e4f229a7d73$var$PickerTextFieldOwnerStateContext);
    if (value == null) throw new Error([
        'MUI X: The `usePickerTextFieldOwnerState` can only be called in components that are used inside a PickerTextField component'
    ].join('\n'));
    return value;
};
module.exports.usePickerTextFieldOwnerState = $64792e4f229a7d73$var$usePickerTextFieldOwnerState;

});




parcelRegister("3f6Ua", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25c820f8a71a2e52$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $25c820f8a71a2e52$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25c820f8a71a2e52$var$Outline;

var $25c820f8a71a2e52$var$_extends2 = $25c820f8a71a2e52$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $25c820f8a71a2e52$var$_objectWithoutPropertiesLoose2 = $25c820f8a71a2e52$require$_interopRequireDefault((parcelRequire("c05no")));

var $25c820f8a71a2e52$var$React = $25c820f8a71a2e52$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d8seH = parcelRequire("d8seH");

var $bbeCr = parcelRequire("bbeCr");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $25c820f8a71a2e52$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $25c820f8a71a2e52$var$OutlineRoot = (0, $d8seH.default)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $25c820f8a71a2e52$var$OutlineLabel = (0, $d8seH.default)('span')(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const $25c820f8a71a2e52$var$OutlineLegend = (0, $d8seH.default)('legend', {
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'notched'
})(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    inputHasLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    inputHasLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    inputHasLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function $25c820f8a71a2e52$var$Outline(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $25c820f8a71a2e52$var$_objectWithoutPropertiesLoose2.default)(props, $25c820f8a71a2e52$var$_excluded);
    const ownerState = (0, $8COFU.usePickerTextFieldOwnerState)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineRoot, (0, $25c820f8a71a2e52$var$_extends2.default)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLegend, {
            ownerState: ownerState,
            notched: notched,
            children: label ? /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}

});



parcelRegister("2CiZK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersFilledInput", {
    enumerable: true,
    get: function() {
        return $6dR0p.PickersFilledInput;
    }
});
Object.defineProperty(module.exports, "getPickersFilledInputUtilityClass", {
    enumerable: true,
    get: function() {
        return $gapTW.getPickersFilledInputUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersFilledInputClasses", {
    enumerable: true,
    get: function() {
        return $gapTW.pickersFilledInputClasses;
    }
});

var $6dR0p = parcelRequire("6dR0p");

var $gapTW = parcelRequire("gapTW");

});
parcelRegister("6dR0p", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $487d12cb311e9418$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $487d12cb311e9418$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersFilledInput = void 0;

var $487d12cb311e9418$var$_objectWithoutPropertiesLoose2 = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("c05no")));

var $487d12cb311e9418$var$_extends2 = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $487d12cb311e9418$var$React = $487d12cb311e9418$require$_interopRequireWildcard((parcelRequire("acw62")));

var $487d12cb311e9418$var$_propTypes = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $izOUK = parcelRequire("izOUK");

var $487d12cb311e9418$var$_refType = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $487d12cb311e9418$var$_composeClasses = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $gapTW = parcelRequire("gapTW");

var $id0az = parcelRequire("id0az");

var $f9pWD = parcelRequire("f9pWD");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $487d12cb311e9418$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "hiddenLabel",
    "classes"
];
const $487d12cb311e9418$var$PickersFilledInputRoot = (0, $d8seH.default)($f9pWD.PickersInputBaseRoot, {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $izOUK.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${$gapTW.pickersFilledInputClasses.focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${$gapTW.pickersFilledInputClasses.disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${$gapTW.pickersFilledInputClasses.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${$gapTW.pickersFilledInputClasses.error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${$gapTW.pickersFilledInputClasses.disabled}, .${$gapTW.pickersFilledInputClasses.error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${$gapTW.pickersFilledInputClasses.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: {
                    hasStartAdornment: true
                },
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: {
                    hasEndAdornment: true
                },
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $487d12cb311e9418$var$PickersFilledSectionsContainer = (0, $d8seH.default)($f9pWD.PickersInputBaseSectionsContainer, {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    shouldForwardProp: (prop)=>(0, $izOUK.shouldForwardProp)(prop) && prop !== 'hiddenLabel'
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: {
                hasStartAdornment: true
            },
            style: {
                paddingLeft: 0
            }
        },
        {
            props: {
                hasEndAdornment: true
            },
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                inputSize: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $487d12cb311e9418$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $487d12cb311e9418$var$_composeClasses.default)(slots, $gapTW.getPickersFilledInputUtilityClass, classes);
    return (0, $487d12cb311e9418$var$_extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $487d12cb311e9418$var$PickersFilledInput = module.exports.PickersFilledInput = /*#__PURE__*/ $487d12cb311e9418$var$React.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, hiddenLabel: hiddenLabel = false, classes: classesProp } = props, other = (0, $487d12cb311e9418$var$_objectWithoutPropertiesLoose2.default)(props, $487d12cb311e9418$var$_excluded);
    const pickerTextFieldOwnerState = (0, $8COFU.usePickerTextFieldOwnerState)();
    const ownerState = (0, $487d12cb311e9418$var$_extends2.default)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $487d12cb311e9418$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($id0az.PickersInputBase, (0, $487d12cb311e9418$var$_extends2.default)({
        slots: {
            root: $487d12cb311e9418$var$PickersFilledInputRoot,
            input: $487d12cb311e9418$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            },
            input: {
                hiddenLabel: hiddenLabel
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref,
        ownerState: ownerState
    }));
});
$487d12cb311e9418$var$PickersFilledInput.muiName = 'Input';

});
parcelRegister("gapTW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bc51abfce30b7e59$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersFilledInputUtilityClass = $bc51abfce30b7e59$var$getPickersFilledInputUtilityClass;
module.exports.pickersFilledInputClasses = void 0;

var $bc51abfce30b7e59$var$_extends2 = $bc51abfce30b7e59$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bc51abfce30b7e59$var$_generateUtilityClasses = $bc51abfce30b7e59$require$_interopRequireDefault((parcelRequire("fXRFb")));

var $bc51abfce30b7e59$var$_generateUtilityClass = $bc51abfce30b7e59$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $id0az = parcelRequire("id0az");
function $bc51abfce30b7e59$var$getPickersFilledInputUtilityClass(slot) {
    return (0, $bc51abfce30b7e59$var$_generateUtilityClass.default)('MuiPickersFilledInput', slot);
}
const $bc51abfce30b7e59$var$pickersFilledInputClasses = module.exports.pickersFilledInputClasses = (0, $bc51abfce30b7e59$var$_extends2.default)({}, $id0az.pickersInputBaseClasses, (0, $bc51abfce30b7e59$var$_generateUtilityClasses.default)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));

});



parcelRegister("aaK30", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersInput", {
    enumerable: true,
    get: function() {
        return $e5z90.PickersInput;
    }
});
Object.defineProperty(module.exports, "getPickersInputUtilityClass", {
    enumerable: true,
    get: function() {
        return $5dqa3.getPickersInputUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersInputClasses", {
    enumerable: true,
    get: function() {
        return $5dqa3.pickersInputClasses;
    }
});

var $e5z90 = parcelRequire("e5z90");

var $5dqa3 = parcelRequire("5dqa3");

});
parcelRegister("e5z90", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a41ccb38ff41e328$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a41ccb38ff41e328$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersInput = void 0;

var $a41ccb38ff41e328$var$_objectWithoutPropertiesLoose2 = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("c05no")));

var $a41ccb38ff41e328$var$_extends2 = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a41ccb38ff41e328$var$React = $a41ccb38ff41e328$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a41ccb38ff41e328$var$_propTypes = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $bbeCr = parcelRequire("bbeCr");

var $a41ccb38ff41e328$var$_refType = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $a41ccb38ff41e328$var$_composeClasses = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $5dqa3 = parcelRequire("5dqa3");

var $id0az = parcelRequire("id0az");

var $f9pWD = parcelRequire("f9pWD");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $a41ccb38ff41e328$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState",
    "classes"
];
const $a41ccb38ff41e328$var$PickersInputRoot = (0, $d8seH.default)($f9pWD.PickersInputBaseRoot, {
    name: 'MuiPickersInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        inputHasUnderline: true
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    inputHasUnderline: true
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${$5dqa3.pickersInputClasses.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${$5dqa3.pickersInputClasses.error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${$5dqa3.pickersInputClasses.disabled}, .${$5dqa3.pickersInputClasses.error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${$5dqa3.pickersInputClasses.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const $a41ccb38ff41e328$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $a41ccb38ff41e328$var$_composeClasses.default)(slots, $5dqa3.getPickersInputUtilityClass, classes);
    return (0, $a41ccb38ff41e328$var$_extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $a41ccb38ff41e328$var$PickersInput = module.exports.PickersInput = /*#__PURE__*/ $a41ccb38ff41e328$var$React.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, classes: classesProp } = props, other = (0, $a41ccb38ff41e328$var$_objectWithoutPropertiesLoose2.default)(props, $a41ccb38ff41e328$var$_excluded);
    const pickerTextFieldOwnerState = (0, $8COFU.usePickerTextFieldOwnerState)();
    const ownerState = (0, $a41ccb38ff41e328$var$_extends2.default)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $a41ccb38ff41e328$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($id0az.PickersInputBase, (0, $a41ccb38ff41e328$var$_extends2.default)({
        slots: {
            root: $a41ccb38ff41e328$var$PickersInputRoot
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        ownerState: ownerState,
        label: label,
        classes: classes,
        ref: ref
    }));
});
$a41ccb38ff41e328$var$PickersInput.muiName = 'Input';

});
parcelRegister("5dqa3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3cc275b483512649$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersInputUtilityClass = $3cc275b483512649$var$getPickersInputUtilityClass;
module.exports.pickersInputClasses = void 0;

var $3cc275b483512649$var$_extends2 = $3cc275b483512649$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3cc275b483512649$var$_generateUtilityClasses = $3cc275b483512649$require$_interopRequireDefault((parcelRequire("fXRFb")));

var $3cc275b483512649$var$_generateUtilityClass = $3cc275b483512649$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $id0az = parcelRequire("id0az");
function $3cc275b483512649$var$getPickersInputUtilityClass(slot) {
    return (0, $3cc275b483512649$var$_generateUtilityClass.default)('MuiPickersFilledInput', slot);
}
const $3cc275b483512649$var$pickersInputClasses = module.exports.pickersInputClasses = (0, $3cc275b483512649$var$_extends2.default)({}, $id0az.pickersInputBaseClasses, (0, $3cc275b483512649$var$_generateUtilityClasses.default)('MuiPickersInput', [
    'root',
    'underline',
    'input'
]));

});








parcelRegister("jHZPa", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e591fd7cb660b8e1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e591fd7cb660b8e1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDateTimePickerDefaultizedProps = $e591fd7cb660b8e1$var$useDateTimePickerDefaultizedProps;

var $e591fd7cb660b8e1$var$_extends2 = $e591fd7cb660b8e1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e591fd7cb660b8e1$var$React = $e591fd7cb660b8e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6g9fa = parcelRequire("6g9fa");

var $3nE24 = parcelRequire("3nE24");

var $dzkyd = parcelRequire("dzkyd");

var $gZb82 = parcelRequire("gZb82");

var $kqIjR = parcelRequire("kqIjR");

var $3eed6 = parcelRequire("3eed6");

var $2wsa0 = parcelRequire("2wsa0");
function $e591fd7cb660b8e1$var$useDateTimePickerDefaultizedProps(props, name) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    const themeProps = (0, $6g9fa.default)({
        props: props,
        name: name
    });
    const validationProps = (0, $2wsa0.useApplyDefaultValuesToDateTimeValidationProps)(themeProps);
    const ampm = themeProps.ampm ?? adapter.is12HourCycleInCurrentLocale();
    const localeText = $e591fd7cb660b8e1$var$React.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $e591fd7cb660b8e1$var$_extends2.default)({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const { openTo: openTo, views: defaultViews } = (0, $kqIjR.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day',
            'hours',
            'minutes'
        ],
        defaultOpenTo: 'day'
    });
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn, views: views, timeSteps: timeSteps } = (0, $3eed6.resolveTimeViewsResponse)({
        thresholdToRenderTimeInASingleColumn: themeProps.thresholdToRenderTimeInASingleColumn,
        ampm: ampm,
        timeSteps: themeProps.timeSteps,
        views: defaultViews
    });
    return (0, $e591fd7cb660b8e1$var$_extends2.default)({}, themeProps, validationProps, {
        timeSteps: timeSteps,
        openTo: openTo,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        views: views,
        ampm: ampm,
        localeText: localeText,
        orientation: themeProps.orientation ?? 'portrait',
        slots: (0, $e591fd7cb660b8e1$var$_extends2.default)({
            toolbar: $gZb82.DateTimePickerToolbar,
            tabs: $dzkyd.DateTimePickerTabs
        }, themeProps.slots),
        slotProps: (0, $e591fd7cb660b8e1$var$_extends2.default)({}, themeProps.slotProps, {
            toolbar: (0, $e591fd7cb660b8e1$var$_extends2.default)({
                ampm: ampm
            }, themeProps.slotProps?.toolbar)
        })
    });
}

});
parcelRegister("dzkyd", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9e0e7c3eb94e4e22$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9e0e7c3eb94e4e22$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimePickerTabs = void 0;

var $9e0e7c3eb94e4e22$var$React = $9e0e7c3eb94e4e22$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9e0e7c3eb94e4e22$var$_clsx = $9e0e7c3eb94e4e22$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9e0e7c3eb94e4e22$var$_propTypes = $9e0e7c3eb94e4e22$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9e0e7c3eb94e4e22$var$_Tab = $9e0e7c3eb94e4e22$require$_interopRequireDefault((parcelRequire("90blG")));

var $9e0e7c3eb94e4e22$var$_Tabs = $9e0e7c3eb94e4e22$require$_interopRequireWildcard((parcelRequire("dKcJh")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $9e0e7c3eb94e4e22$var$_composeClasses = $9e0e7c3eb94e4e22$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $1SVAo = parcelRequire("1SVAo");

var $83GPg = parcelRequire("83GPg");

var $an26n = parcelRequire("an26n");

var $NRNex = parcelRequire("NRNex");

var $7OOd8 = parcelRequire("7OOd8");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $9e0e7c3eb94e4e22$var$viewToTab = (view)=>{
    if ((0, $NRNex.isDatePickerView)(view)) return 'date';
    return 'time';
};
const $9e0e7c3eb94e4e22$var$tabToView = (tab)=>{
    if (tab === 'date') return 'day';
    return 'hours';
};
const $9e0e7c3eb94e4e22$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $9e0e7c3eb94e4e22$var$_composeClasses.default)(slots, $an26n.getDateTimePickerTabsUtilityClass, classes);
};
const $9e0e7c3eb94e4e22$var$DateTimePickerTabsRoot = (0, $d8seH.default)($9e0e7c3eb94e4e22$var$_Tabs.default, {
    name: 'MuiDateTimePickerTabs',
    slot: 'Root'
})(({ theme: theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        '&:last-child': {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${$9e0e7c3eb94e4e22$var$_Tabs.tabsClasses.indicator}`]: {
                bottom: 'auto',
                top: 0
            }
        }
    }));
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerTabs API](https://mui.com/x/api/date-pickers/date-time-picker-tabs/)
 */ const $9e0e7c3eb94e4e22$var$DateTimePickerTabs = module.exports.DateTimePickerTabs = function DateTimePickerTabs(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiDateTimePickerTabs'
    });
    const { dateIcon: dateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($1SVAo.DateRangeIcon, {}), timeIcon: timeIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($1SVAo.TimeIcon, {}), hidden: hidden = typeof window === 'undefined' || window.innerHeight < 667, className: className, classes: classesProp, sx: sx } = props;
    const translations = (0, $83GPg.usePickerTranslations)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const { view: view, setView: setView } = (0, $BKARN.usePickerContext)();
    const classes = $9e0e7c3eb94e4e22$var$useUtilityClasses(classesProp);
    const handleChange = (event, value)=>{
        setView($9e0e7c3eb94e4e22$var$tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9e0e7c3eb94e4e22$var$DateTimePickerTabsRoot, {
        ownerState: ownerState,
        variant: "fullWidth",
        value: $9e0e7c3eb94e4e22$var$viewToTab(view),
        onChange: handleChange,
        className: (0, $9e0e7c3eb94e4e22$var$_clsx.default)(className, classes.root),
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9e0e7c3eb94e4e22$var$_Tab.default, {
                value: "date",
                "aria-label": translations.dateTableLabel,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($9e0e7c3eb94e4e22$var$React.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9e0e7c3eb94e4e22$var$_Tab.default, {
                value: "time",
                "aria-label": translations.timeTableLabel,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($9e0e7c3eb94e4e22$var$React.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};

});
parcelRegister("90blG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("jNGAr")).default);
$parcel$export(module.exports, "tabClasses", () => (parcelRequire("jHfLJ")).default);

var $jNGAr = parcelRequire("jNGAr");

var $jHfLJ = parcelRequire("jHfLJ");
$parcel$exportWildcard(module.exports, $jHfLJ);

});

parcelRegister("dKcJh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("aDtBU")).default);
$parcel$export(module.exports, "tabsClasses", () => (parcelRequire("bTm2Q")).default);

var $aDtBU = parcelRequire("aDtBU");

var $bTm2Q = parcelRequire("bTm2Q");
$parcel$exportWildcard(module.exports, $bTm2Q);

});

parcelRegister("an26n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $78cdaec54bb38039$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dateTimePickerTabsClasses = void 0;
module.exports.getDateTimePickerTabsUtilityClass = $78cdaec54bb38039$var$getDateTimePickerTabsUtilityClass;

var $78cdaec54bb38039$var$_generateUtilityClass = $78cdaec54bb38039$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $78cdaec54bb38039$var$_generateUtilityClasses = $78cdaec54bb38039$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $78cdaec54bb38039$var$getDateTimePickerTabsUtilityClass(slot) {
    return (0, $78cdaec54bb38039$var$_generateUtilityClass.default)('MuiDateTimePickerTabs', slot);
}
const $78cdaec54bb38039$var$dateTimePickerTabsClasses = module.exports.dateTimePickerTabsClasses = (0, $78cdaec54bb38039$var$_generateUtilityClasses.default)('MuiDateTimePickerTabs', [
    'root'
]);

});


parcelRegister("gZb82", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c5daf9c8f6912bf3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c5daf9c8f6912bf3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimePickerToolbar = $c5daf9c8f6912bf3$var$DateTimePickerToolbar;
module.exports.DateTimePickerToolbarOverrideContext = void 0;

var $c5daf9c8f6912bf3$var$_extends2 = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c5daf9c8f6912bf3$var$_objectWithoutPropertiesLoose2 = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("c05no")));

var $c5daf9c8f6912bf3$var$React = $c5daf9c8f6912bf3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c5daf9c8f6912bf3$var$_clsx = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c5daf9c8f6912bf3$var$_propTypes = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $c5daf9c8f6912bf3$var$_composeClasses = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $bbeCr = parcelRequire("bbeCr");

var $oSSgR = parcelRequire("oSSgR");

var $1YoVy = parcelRequire("1YoVy");

var $8RLZv = parcelRequire("8RLZv");

var $BKARN = parcelRequire("BKARN");

var $frSrH = parcelRequire("frSrH");

var $lfVfV = parcelRequire("lfVfV");

var $99eO4 = parcelRequire("99eO4");

var $NRNex = parcelRequire("NRNex");

var $lCT63 = parcelRequire("lCT63");

var $igERR = parcelRequire("igERR");

var $6DVo4 = parcelRequire("6DVo4");

var $1IRkN = parcelRequire("1IRkN");

var $ayMG0 = parcelRequire("ayMG0");
const $c5daf9c8f6912bf3$var$_excluded = [
    "ampm",
    "ampmInClock",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "className",
    "classes"
];
const $c5daf9c8f6912bf3$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation, toolbarDirection: toolbarDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        dateContainer: [
            'dateContainer'
        ],
        timeContainer: [
            'timeContainer',
            toolbarDirection === 'rtl' && 'timeLabelReverse'
        ],
        timeDigitsContainer: [
            'timeDigitsContainer',
            toolbarDirection === 'rtl' && 'timeLabelReverse'
        ],
        separator: [
            'separator'
        ],
        ampmSelection: [
            'ampmSelection',
            pickerOrientation === 'landscape' && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return (0, $c5daf9c8f6912bf3$var$_composeClasses.default)(slots, $frSrH.getDateTimePickerToolbarUtilityClass, classes);
};
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarRoot = (0, $d8seH.default)($1YoVy.PickersToolbar, {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})(({ theme: theme })=>({
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: 'space-around',
        position: 'relative',
        variants: [
            {
                props: {
                    toolbarVariant: 'desktop'
                },
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    [`& .${$igERR.pickersToolbarClasses.content} .${$lCT63.pickersToolbarTextClasses.root}[data-selected]`]: {
                        color: (theme.vars || theme).palette.primary.main,
                        fontWeight: theme.typography.fontWeightBold
                    }
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    pickerOrientation: 'landscape'
                },
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    pickerOrientation: 'portrait'
                },
                style: {
                    paddingLeft: 24,
                    paddingRight: 0
                }
            }
        ]
    }));
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarDateContainer = (0, $d8seH.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'DateContainer'
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
});
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarTimeContainer = (0, $d8seH.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeContainer',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    display: 'flex',
    flexDirection: 'row',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                toolbarVariant: 'desktop',
                pickerOrientation: 'portrait'
            },
            style: {
                gap: 9,
                marginRight: 4,
                alignSelf: 'flex-end'
            }
        },
        {
            props: ({ pickerOrientation: pickerOrientation, toolbarVariant: toolbarVariant })=>pickerOrientation === 'landscape' && toolbarVariant !== 'desktop',
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ pickerOrientation: pickerOrientation, toolbarVariant: toolbarVariant, toolbarDirection: toolbarDirection })=>pickerOrientation === 'landscape' && toolbarVariant !== 'desktop' && toolbarDirection === 'rtl',
            style: {
                flexDirection: 'column-reverse'
            }
        }
    ]
});
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarTimeDigitsContainer = (0, $d8seH.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeDigitsContainer',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    display: 'flex',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                gap: 1.5
            }
        }
    ]
});
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarSeparator = (0, $d8seH.default)($oSSgR.PickersToolbarText, {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Separator',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    margin: '0 4px 0 2px',
    cursor: 'default',
    variants: [
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                margin: 0
            }
        }
    ]
});
// Taken from TimePickerToolbar
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarAmPmSelection = (0, $d8seH.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${$frSrH.dateTimePickerToolbarClasses.ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${$frSrH.dateTimePickerToolbarClasses.ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'auto',
    marginLeft: 12,
    [`& .${$frSrH.dateTimePickerToolbarClasses.ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: '4px 0 auto',
                flexDirection: 'row',
                justifyContent: 'space-around',
                width: '100%'
            }
        }
    ]
});
/**
 * If `forceDesktopVariant` is set to `true`, the toolbar will always be rendered in the desktop mode.
 * If `onViewChange` is defined, the toolbar will call it instead of calling the default handler from `usePickerContext`.
 * This is used by the Date Time Range Picker Toolbar.
 */ const $c5daf9c8f6912bf3$var$DateTimePickerToolbarOverrideContext = module.exports.DateTimePickerToolbarOverrideContext = /*#__PURE__*/ $c5daf9c8f6912bf3$var$React.createContext(null);
function $c5daf9c8f6912bf3$var$DateTimePickerToolbar(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiDateTimePickerToolbar'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", toolbarTitle: inToolbarTitle, className: className, classes: classesProp } = props, other = (0, $c5daf9c8f6912bf3$var$_objectWithoutPropertiesLoose2.default)(props, $c5daf9c8f6912bf3$var$_excluded);
    const { value: valueContext, setValue: setValueContext, disabled: disabled, readOnly: readOnly, variant: variant, orientation: orientation, view: viewContext, setView: setViewContext, views: views } = (0, $6DVo4.usePickerContext)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const ownerState = (0, $1IRkN.useToolbarOwnerState)();
    const classes = $c5daf9c8f6912bf3$var$useUtilityClasses(classesProp, ownerState);
    const adapter = (0, $BKARN.usePickerAdapter)();
    const overrides = $c5daf9c8f6912bf3$var$React.useContext($c5daf9c8f6912bf3$var$DateTimePickerToolbarOverrideContext);
    const value = overrides ? overrides.value : valueContext;
    const setValue = overrides ? overrides.setValue : setValueContext;
    const view = overrides ? overrides.view : viewContext;
    const setView = overrides ? overrides.setView : setViewContext;
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $lfVfV.useMeridiemMode)(value, ampm, (newValue)=>setValue(newValue, {
            changeImportance: 'set'
        }));
    const toolbarVariant = overrides?.forceDesktopVariant ? 'desktop' : variant;
    const isDesktop = toolbarVariant === 'desktop';
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const toolbarTitle = inToolbarTitle ?? translations.dateTimePickerToolbarTitle;
    const dateText = $c5daf9c8f6912bf3$var$React.useMemo(()=>{
        if (!adapter.isValid(value)) return toolbarPlaceholder;
        if (toolbarFormat) return adapter.formatByString(value, toolbarFormat);
        return adapter.format(value, 'shortDate');
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        adapter
    ]);
    const formatSection = (format, fallback)=>{
        if (!adapter.isValid(value)) return fallback;
        return adapter.format(value, format);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarRoot, (0, $c5daf9c8f6912bf3$var$_extends2.default)({
        className: (0, $c5daf9c8f6912bf3$var$_clsx.default)(classes.root, className),
        toolbarTitle: toolbarTitle,
        toolbarVariant: toolbarVariant
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes('year') && /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>setView('year'),
                        selected: view === 'year',
                        value: formatSection('year', "\u2013")
                    }),
                    views.includes('day') && /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                        tabIndex: -1,
                        variant: isDesktop ? 'h5' : 'h4',
                        onClick: ()=>setView('day'),
                        selected: view === 'day',
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                toolbarVariant: toolbarVariant,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        toolbarVariant: toolbarVariant,
                        children: [
                            views.includes('hours') && /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$React.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH : undefined,
                                        onClick: ()=>setView('hours'),
                                        selected: view === 'hours',
                                        value: formatSection(ampm ? 'hours12h' : 'hours24h', '--')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c5daf9c8f6912bf3$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState,
                                        toolbarVariant: toolbarVariant
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH : undefined,
                                        onClick: ()=>setView('minutes'),
                                        selected: view === 'minutes' || !views.includes('minutes') && view === 'hours',
                                        value: formatSection('minutes', '--'),
                                        disabled: !views.includes('minutes')
                                    })
                                ]
                            }),
                            views.includes('seconds') && /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$React.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c5daf9c8f6912bf3$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState,
                                        toolbarVariant: toolbarVariant
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH : undefined,
                                        onClick: ()=>setView('seconds'),
                                        selected: view === 'seconds',
                                        value: formatSection('seconds', '--')
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                variant: "subtitle2",
                                selected: meridiemMode === 'am',
                                typographyClassName: classes.ampmLabel,
                                value: (0, $NRNex.formatMeridiem)(adapter, 'am'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                variant: "subtitle2",
                                selected: meridiemMode === 'pm',
                                typographyClassName: classes.ampmLabel,
                                value: (0, $NRNex.formatMeridiem)(adapter, 'pm'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                        variant: "h5",
                        onClick: ()=>setView('meridiem'),
                        selected: view === 'meridiem',
                        value: value && meridiemMode ? (0, $NRNex.formatMeridiem)(adapter, meridiemMode) : '--',
                        width: $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH
                    })
                ]
            })
        ]
    }));
}

});
parcelRegister("oSSgR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $04accee7e7bec8c5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $04accee7e7bec8c5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersToolbarText = void 0;

var $04accee7e7bec8c5$var$_extends2 = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $04accee7e7bec8c5$var$_objectWithoutPropertiesLoose2 = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("c05no")));

var $04accee7e7bec8c5$var$React = $04accee7e7bec8c5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $04accee7e7bec8c5$var$_clsx = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("9QePP")));

var $04accee7e7bec8c5$var$_Typography = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $04accee7e7bec8c5$var$_composeClasses = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $lCT63 = parcelRequire("lCT63");

var $ayMG0 = parcelRequire("ayMG0");
const $04accee7e7bec8c5$var$_excluded = [
    "className",
    "classes",
    "selected",
    "value"
];
const $04accee7e7bec8c5$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $04accee7e7bec8c5$var$_composeClasses.default)(slots, $lCT63.getPickersToolbarTextUtilityClass, classes);
};
const $04accee7e7bec8c5$var$PickersToolbarTextRoot = (0, $d8seH.default)($04accee7e7bec8c5$var$_Typography.default, {
    name: 'MuiPickersToolbarText',
    slot: 'Root'
})(({ theme: theme })=>({
        transition: theme.transitions.create('color'),
        color: (theme.vars || theme).palette.text.secondary,
        [`&[data-selected]`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $04accee7e7bec8c5$var$PickersToolbarText = module.exports.PickersToolbarText = /*#__PURE__*/ $04accee7e7bec8c5$var$React.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersToolbarText'
    });
    const { className: className, classes: classesProp, selected: selected, value: value } = props, other = (0, $04accee7e7bec8c5$var$_objectWithoutPropertiesLoose2.default)(props, $04accee7e7bec8c5$var$_excluded);
    const classes = $04accee7e7bec8c5$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($04accee7e7bec8c5$var$PickersToolbarTextRoot, (0, $04accee7e7bec8c5$var$_extends2.default)({
        ref: ref,
        className: (0, $04accee7e7bec8c5$var$_clsx.default)(classes.root, className),
        component: "span",
        ownerState: props
    }, selected && {
        'data-selected': true
    }, other, {
        children: value
    }));
});

});
parcelRegister("2dUd7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("3bYfT")).default);
$parcel$export(module.exports, "typographyClasses", () => (parcelRequire("bhKtZ")).default);

var $3bYfT = parcelRequire("3bYfT");

var $bhKtZ = parcelRequire("bhKtZ");
$parcel$exportWildcard(module.exports, $bhKtZ);

});

parcelRegister("lCT63", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fbe7e2a463bd8c2a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersToolbarTextUtilityClass = $fbe7e2a463bd8c2a$var$getPickersToolbarTextUtilityClass;
module.exports.pickersToolbarTextClasses = void 0;

var $fbe7e2a463bd8c2a$var$_generateUtilityClass = $fbe7e2a463bd8c2a$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $fbe7e2a463bd8c2a$var$_generateUtilityClasses = $fbe7e2a463bd8c2a$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $fbe7e2a463bd8c2a$var$getPickersToolbarTextUtilityClass(slot) {
    return (0, $fbe7e2a463bd8c2a$var$_generateUtilityClass.default)('MuiPickersToolbarText', slot);
}
const $fbe7e2a463bd8c2a$var$pickersToolbarTextClasses = module.exports.pickersToolbarTextClasses = (0, $fbe7e2a463bd8c2a$var$_generateUtilityClasses.default)('MuiPickersToolbarText', [
    'root'
]);

});


parcelRegister("1YoVy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $16febb16e5b74478$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $16febb16e5b74478$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersToolbar = void 0;

var $16febb16e5b74478$var$_extends2 = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $16febb16e5b74478$var$_objectWithoutPropertiesLoose2 = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("c05no")));

var $16febb16e5b74478$var$React = $16febb16e5b74478$require$_interopRequireWildcard((parcelRequire("acw62")));

var $16febb16e5b74478$var$_clsx = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("9QePP")));

var $16febb16e5b74478$var$_Typography = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $16febb16e5b74478$var$_composeClasses = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $bbeCr = parcelRequire("bbeCr");

var $igERR = parcelRequire("igERR");

var $1IRkN = parcelRequire("1IRkN");

var $ayMG0 = parcelRequire("ayMG0");
const $16febb16e5b74478$var$_excluded = [
    "children",
    "className",
    "classes",
    "toolbarTitle",
    "hidden",
    "titleId",
    "classes",
    "landscapeDirection"
];
const $16febb16e5b74478$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ],
        content: [
            'content'
        ]
    };
    return (0, $16febb16e5b74478$var$_composeClasses.default)(slots, $igERR.getPickersToolbarUtilityClass, classes);
};
const $16febb16e5b74478$var$PickersToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root'
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    pickerOrientation: 'landscape'
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const $16febb16e5b74478$var$PickersToolbarContent = (0, $d8seH.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'landscapeDirection'
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const $16febb16e5b74478$var$PickersToolbar = module.exports.PickersToolbar = /*#__PURE__*/ $16febb16e5b74478$var$React.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, classes: classesProp, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId, landscapeDirection: landscapeDirection } = props, other = (0, $16febb16e5b74478$var$_objectWithoutPropertiesLoose2.default)(props, $16febb16e5b74478$var$_excluded);
    const ownerState = (0, $1IRkN.useToolbarOwnerState)();
    const classes = $16febb16e5b74478$var$useUtilityClasses(classesProp);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($16febb16e5b74478$var$PickersToolbarRoot, (0, $16febb16e5b74478$var$_extends2.default)({
        ref: ref,
        className: (0, $16febb16e5b74478$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($16febb16e5b74478$var$_Typography.default, {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                className: classes.title,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($16febb16e5b74478$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                landscapeDirection: landscapeDirection,
                children: children
            })
        ]
    }));
});

});
parcelRegister("igERR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d4c96c197d3f31f2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersToolbarUtilityClass = $d4c96c197d3f31f2$var$getPickersToolbarUtilityClass;
module.exports.pickersToolbarClasses = void 0;

var $d4c96c197d3f31f2$var$_generateUtilityClass = $d4c96c197d3f31f2$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $d4c96c197d3f31f2$var$_generateUtilityClasses = $d4c96c197d3f31f2$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $d4c96c197d3f31f2$var$getPickersToolbarUtilityClass(slot) {
    return (0, $d4c96c197d3f31f2$var$_generateUtilityClass.default)('MuiPickersToolbar', slot);
}
const $d4c96c197d3f31f2$var$pickersToolbarClasses = module.exports.pickersToolbarClasses = (0, $d4c96c197d3f31f2$var$_generateUtilityClasses.default)('MuiPickersToolbar', [
    'root',
    'title',
    'content'
]);

});

parcelRegister("1IRkN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $14134597d325236b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $14134597d325236b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useToolbarOwnerState = $14134597d325236b$var$useToolbarOwnerState;

var $14134597d325236b$var$_extends2 = $14134597d325236b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $14134597d325236b$var$React = $14134597d325236b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $7OOd8 = parcelRequire("7OOd8");
function $14134597d325236b$var$useToolbarOwnerState() {
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const isRtl = (0, $9uEev.useRtl)();
    return $14134597d325236b$var$React.useMemo(()=>(0, $14134597d325236b$var$_extends2.default)({}, pickerOwnerState, {
            toolbarDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        isRtl
    ]);
}

});


parcelRegister("8RLZv", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $67487ff97c20054e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $67487ff97c20054e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersToolbarButton = void 0;

var $67487ff97c20054e$var$_extends2 = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $67487ff97c20054e$var$_objectWithoutPropertiesLoose2 = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("c05no")));

var $67487ff97c20054e$var$React = $67487ff97c20054e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $67487ff97c20054e$var$_clsx = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $67487ff97c20054e$var$_Button = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("bBQKz")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $67487ff97c20054e$var$_composeClasses = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $oSSgR = parcelRequire("oSSgR");

var $igERR = parcelRequire("igERR");

var $ayMG0 = parcelRequire("ayMG0");
const $67487ff97c20054e$var$_excluded = [
    "align",
    "className",
    "classes",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $67487ff97c20054e$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $67487ff97c20054e$var$_composeClasses.default)(slots, $igERR.getPickersToolbarUtilityClass, classes);
};
const $67487ff97c20054e$var$PickersToolbarButtonRoot = (0, $d8seH.default)($67487ff97c20054e$var$_Button.default, {
    name: 'MuiPickersToolbarButton',
    slot: 'Root'
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const $67487ff97c20054e$var$PickersToolbarButton = module.exports.PickersToolbarButton = /*#__PURE__*/ $67487ff97c20054e$var$React.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align: align, className: className, classes: classesProp, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $67487ff97c20054e$var$_objectWithoutPropertiesLoose2.default)(props, $67487ff97c20054e$var$_excluded);
    const classes = $67487ff97c20054e$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($67487ff97c20054e$var$PickersToolbarButtonRoot, (0, $67487ff97c20054e$var$_extends2.default)({
        variant: "text",
        ref: ref,
        className: (0, $67487ff97c20054e$var$_clsx.default)(classes.root, className),
        ownerState: props
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($oSSgR.PickersToolbarText, {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});

});
parcelRegister("bBQKz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6lXkL")).default);
$parcel$export(module.exports, "buttonClasses", () => (parcelRequire("1xAC3")).default);

var $6lXkL = parcelRequire("6lXkL");

var $1xAC3 = parcelRequire("1xAC3");
$parcel$exportWildcard(module.exports, $1xAC3);

});


parcelRegister("frSrH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b3f39c6baf320405$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dateTimePickerToolbarClasses = void 0;
module.exports.getDateTimePickerToolbarUtilityClass = $b3f39c6baf320405$var$getDateTimePickerToolbarUtilityClass;

var $b3f39c6baf320405$var$_generateUtilityClass = $b3f39c6baf320405$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $b3f39c6baf320405$var$_generateUtilityClasses = $b3f39c6baf320405$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $b3f39c6baf320405$var$getDateTimePickerToolbarUtilityClass(slot) {
    return (0, $b3f39c6baf320405$var$_generateUtilityClass.default)('MuiDateTimePickerToolbar', slot);
}
const $b3f39c6baf320405$var$dateTimePickerToolbarClasses = module.exports.dateTimePickerToolbarClasses = (0, $b3f39c6baf320405$var$_generateUtilityClasses.default)('MuiDateTimePickerToolbar', [
    'root',
    'dateContainer',
    'timeContainer',
    'timeDigitsContainer',
    'separator',
    'timeLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);

});

parcelRegister("lfVfV", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f797697c3611afd3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMeridiemMode = $f797697c3611afd3$var$useMeridiemMode;
module.exports.useNextMonthDisabled = $f797697c3611afd3$var$useNextMonthDisabled;
module.exports.usePreviousMonthDisabled = $f797697c3611afd3$var$usePreviousMonthDisabled;

var $f797697c3611afd3$var$React = $f797697c3611afd3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cElCc = parcelRequire("cElCc");

var $3nE24 = parcelRequire("3nE24");
function $f797697c3611afd3$var$useNextMonthDisabled(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    return $f797697c3611afd3$var$React.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        return !adapter.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        adapter,
        timezone
    ]);
}
function $f797697c3611afd3$var$usePreviousMonthDisabled(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    return $f797697c3611afd3$var$React.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        return !adapter.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        adapter,
        timezone
    ]);
}
function $f797697c3611afd3$var$useMeridiemMode(date, ampm, onChange, selectionState) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    const cleanDate = $f797697c3611afd3$var$React.useMemo(()=>!adapter.isValid(date) ? null : date, [
        adapter,
        date
    ]);
    const meridiemMode = (0, $cElCc.getMeridiem)(cleanDate, adapter);
    const handleMeridiemChange = $f797697c3611afd3$var$React.useCallback((mode)=>{
        const timeWithMeridiem = cleanDate == null ? null : (0, $cElCc.convertToMeridiem)(cleanDate, mode, Boolean(ampm), adapter);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        cleanDate,
        onChange,
        selectionState,
        adapter
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}

});

parcelRegister("99eO4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VIEW_HEIGHT = module.exports.MULTI_SECTION_CLOCK_SECTION_WIDTH = module.exports.MAX_CALENDAR_HEIGHT = module.exports.DIGITAL_CLOCK_VIEW_HEIGHT = module.exports.DIALOG_WIDTH = module.exports.DAY_SIZE = module.exports.DAY_MARGIN = void 0;
const $6a907094a8780175$var$DAY_SIZE = module.exports.DAY_SIZE = 36;
const $6a907094a8780175$var$DAY_MARGIN = module.exports.DAY_MARGIN = 2;
const $6a907094a8780175$var$DIALOG_WIDTH = module.exports.DIALOG_WIDTH = 320;
const $6a907094a8780175$var$MAX_CALENDAR_HEIGHT = module.exports.MAX_CALENDAR_HEIGHT = 280;
const $6a907094a8780175$var$VIEW_HEIGHT = module.exports.VIEW_HEIGHT = 336;
const $6a907094a8780175$var$DIGITAL_CLOCK_VIEW_HEIGHT = module.exports.DIGITAL_CLOCK_VIEW_HEIGHT = 232;
const $6a907094a8780175$var$MULTI_SECTION_CLOCK_SECTION_WIDTH = module.exports.MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;

});


parcelRegister("3eed6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $259db3c2f1b14ed0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveDateTimeFormat = void 0;
module.exports.resolveTimeViewsResponse = $259db3c2f1b14ed0$var$resolveTimeViewsResponse;

var $259db3c2f1b14ed0$var$_extends2 = $259db3c2f1b14ed0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $259db3c2f1b14ed0$var$_objectWithoutPropertiesLoose2 = $259db3c2f1b14ed0$require$_interopRequireDefault((parcelRequire("c05no")));

var $cElCc = parcelRequire("cElCc");

var $NRNex = parcelRequire("NRNex");
const $259db3c2f1b14ed0$var$_excluded = [
    "views",
    "format"
];
const $259db3c2f1b14ed0$var$resolveDateTimeFormat = (adapter, _ref, ignoreDateResolving)=>{
    let { views: views, format: format } = _ref, other = (0, $259db3c2f1b14ed0$var$_objectWithoutPropertiesLoose2.default)(_ref, $259db3c2f1b14ed0$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $cElCc.isTimeView)(view)) timeViews.push(view);
        else if ((0, $NRNex.isDatePickerView)(view)) dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $NRNex.resolveDateFormat)(adapter, (0, $259db3c2f1b14ed0$var$_extends2.default)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $cElCc.resolveTimeFormat)(adapter, (0, $259db3c2f1b14ed0$var$_extends2.default)({
        views: timeViews
    }, other));
    const timeFormat = (0, $cElCc.resolveTimeFormat)(adapter, (0, $259db3c2f1b14ed0$var$_extends2.default)({
        views: timeViews
    }, other));
    const dateFormat = ignoreDateResolving ? adapter.formats.keyboardDate : (0, $NRNex.resolveDateFormat)(adapter, (0, $259db3c2f1b14ed0$var$_extends2.default)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
module.exports.resolveDateTimeFormat = $259db3c2f1b14ed0$var$resolveDateTimeFormat;
const $259db3c2f1b14ed0$var$resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, $cElCc.isInternalTimeView)(view) || view === 'hours');
    return ampm ? [
        ...views,
        'meridiem'
    ] : views;
};
const $259db3c2f1b14ed0$var$resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>1440 / ((timeSteps.hours ?? 1) * (timeSteps.minutes ?? 5)) <= threshold;
function $259db3c2f1b14ed0$var$resolveTimeViewsResponse({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm: ampm, timeSteps: inTimeSteps, views: views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold ?? 24;
    const timeSteps = (0, $259db3c2f1b14ed0$var$_extends2.default)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = $259db3c2f1b14ed0$var$resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        timeSteps: timeSteps,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        views: $259db3c2f1b14ed0$var$resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}

});


parcelRegister("8uN0h", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $62f723267dd87cd0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.renderDateViewCalendar = void 0;

var $62f723267dd87cd0$var$React = $62f723267dd87cd0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6BOGh = parcelRequire("6BOGh");

var $NRNex = parcelRequire("NRNex");

var $ayMG0 = parcelRequire("ayMG0");
const $62f723267dd87cd0$var$renderDateViewCalendar = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)($6BOGh.DateCalendar, {
        view: view,
        onViewChange: onViewChange,
        views: views.filter($NRNex.isDatePickerView),
        focusedView: focusedView && (0, $NRNex.isDatePickerView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });
module.exports.renderDateViewCalendar = $62f723267dd87cd0$var$renderDateViewCalendar;

});
parcelRegister("6BOGh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DateCalendar", {
    enumerable: true,
    get: function() {
        return $gvmDt.DateCalendar;
    }
});
Object.defineProperty(module.exports, "dateCalendarClasses", {
    enumerable: true,
    get: function() {
        return $e7rSK.dateCalendarClasses;
    }
});
Object.defineProperty(module.exports, "dayCalendarClasses", {
    enumerable: true,
    get: function() {
        return $66c8j.dayCalendarClasses;
    }
});
Object.defineProperty(module.exports, "getDateCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return $e7rSK.getDateCalendarUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersFadeTransitionGroupClasses", {
    enumerable: true,
    get: function() {
        return $hj2cL.pickersFadeTransitionGroupClasses;
    }
});
Object.defineProperty(module.exports, "pickersSlideTransitionClasses", {
    enumerable: true,
    get: function() {
        return $ha1fF.pickersSlideTransitionClasses;
    }
});

var $gvmDt = parcelRequire("gvmDt");

var $e7rSK = parcelRequire("e7rSK");

var $66c8j = parcelRequire("66c8j");

var $hj2cL = parcelRequire("hj2cL");

var $ha1fF = parcelRequire("ha1fF");

});
parcelRegister("gvmDt", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c041198f38a260e6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c041198f38a260e6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateCalendar = void 0;

var $c041198f38a260e6$var$_objectWithoutPropertiesLoose2 = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("c05no")));

var $c041198f38a260e6$var$_extends2 = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c041198f38a260e6$var$React = $c041198f38a260e6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c041198f38a260e6$var$_propTypes = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c041198f38a260e6$var$_clsx = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c041198f38a260e6$var$_useSlotProps = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $c041198f38a260e6$var$_composeClasses = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $c041198f38a260e6$var$_useId = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("5Db2s")));

var $c041198f38a260e6$var$_useEventCallback = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $580ir = parcelRequire("580ir");

var $eW408 = parcelRequire("eW408");

var $3UaqM = parcelRequire("3UaqM");

var $gYuM1 = parcelRequire("gYuM1");

var $haVKB = parcelRequire("haVKB");

var $3cW2G = parcelRequire("3cW2G");

var $dAsZ9 = parcelRequire("dAsZ9");

var $NRNex = parcelRequire("NRNex");

var $fQ7ML = parcelRequire("fQ7ML");

var $4eUCS = parcelRequire("4eUCS");

var $e7rSK = parcelRequire("e7rSK");

var $hagTn = parcelRequire("hagTn");

var $1M3bL = parcelRequire("1M3bL");

var $99eO4 = parcelRequire("99eO4");

var $7OOd8 = parcelRequire("7OOd8");

var $1aSwN = parcelRequire("1aSwN");

var $3nE24 = parcelRequire("3nE24");

var $ayMG0 = parcelRequire("ayMG0");
const $c041198f38a260e6$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $c041198f38a260e6$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $c041198f38a260e6$var$_composeClasses.default)(slots, $e7rSK.getDateCalendarUtilityClass, classes);
};
function $c041198f38a260e6$var$useDateCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $6g9fa.default)({
        props: props,
        name: name
    });
    const reduceAnimations = (0, $4eUCS.useReduceAnimations)(themeProps.reduceAnimations);
    const validationProps = (0, $1aSwN.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, $c041198f38a260e6$var$_extends2.default)({}, themeProps, validationProps, {
        loading: themeProps.loading ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations: reduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: "..."
            }))
    });
}
const $c041198f38a260e6$var$DateCalendarRoot = (0, $d8seH.default)($fQ7ML.PickerViewRoot, {
    name: 'MuiDateCalendar',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    height: $99eO4.VIEW_HEIGHT
});
const $c041198f38a260e6$var$DateCalendarViewTransitionContainer = (0, $d8seH.default)($eW408.PickersFadeTransitionGroup, {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer'
})({});
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateCalendar API](https://mui.com/x/api/date-pickers/date-calendar/)
 */ const $c041198f38a260e6$var$DateCalendar = module.exports.DateCalendar = /*#__PURE__*/ $c041198f38a260e6$var$React.forwardRef(function DateCalendar(inProps, ref) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const id = (0, $c041198f38a260e6$var$_useId.default)();
    const props = $c041198f38a260e6$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: focusedViewProp, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $c041198f38a260e6$var$_objectWithoutPropertiesLoose2.default)(props, $c041198f38a260e6$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $3cW2G.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: focusedViewProp,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, setVisibleDate: setVisibleDate, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $580ir.useCalendarState)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone,
        getCurrentMonthFromVisibleDate: (visibleDate, prevMonth)=>{
            if (adapter.isSameMonth(visibleDate, prevMonth)) return prevMonth;
            return adapter.startOfMonth(visibleDate);
        }
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? $dAsZ9.PickersCalendarHeader;
    const calendarHeaderProps = (0, $c041198f38a260e6$var$_useSlotProps.default)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (month)=>setVisibleDate({
                    target: month,
                    reason: 'header-navigation'
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: ownerState
    });
    const handleDateMonthChange = (0, $c041198f38a260e6$var$_useEventCallback.default)((newDate)=>{
        const startOfMonth = adapter.startOfMonth(newDate);
        const endOfMonth = adapter.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $NRNex.findClosestEnabledDate)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfMonth,
                reason: 'cell-interaction'
            });
        }
    });
    const handleDateYearChange = (0, $c041198f38a260e6$var$_useEventCallback.default)((newDate)=>{
        const startOfYear = adapter.startOfYear(newDate);
        const endOfYear = adapter.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $NRNex.findClosestEnabledDate)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: adapter.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfYear,
                reason: 'cell-interaction'
            });
        }
    });
    const handleSelectedDayChange = (0, $c041198f38a260e6$var$_useEventCallback.default)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $NRNex.mergeDateAndTime)(adapter, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $c041198f38a260e6$var$React.useEffect(()=>{
        if (adapter.isValid(value)) setVisibleDate({
            target: value,
            reason: 'controlled-value-change'
        });
    }, [
        value
    ]); // eslint-disable-line
    const classes = $c041198f38a260e6$var$useUtilityClasses(classesProp);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $c041198f38a260e6$var$React.useRef(view);
    $c041198f38a260e6$var$React.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $c041198f38a260e6$var$React.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c041198f38a260e6$var$DateCalendarRoot, (0, $c041198f38a260e6$var$_extends2.default)({
        ref: ref,
        className: (0, $c041198f38a260e6$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(CalendarHeader, (0, $c041198f38a260e6$var$_extends2.default)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c041198f38a260e6$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $ayMG0.jsx)($haVKB.YearCalendar, (0, $c041198f38a260e6$var$_extends2.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $ayMG0.jsx)($gYuM1.MonthCalendar, (0, $c041198f38a260e6$var$_extends2.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $ayMG0.jsx)($3UaqM.DayCalendar, (0, $c041198f38a260e6$var$_extends2.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            hasFocus: hasFocus,
                            onFocusedDayChange: (focusedDate)=>setVisibleDate({
                                    target: focusedDate,
                                    reason: 'cell-interaction'
                                }),
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});

});
parcelRegister("580ir", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3bbdedfd37de0fee$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3bbdedfd37de0fee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useCalendarState = void 0;

var $3bbdedfd37de0fee$var$_extends2 = $3bbdedfd37de0fee$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3bbdedfd37de0fee$var$React = $3bbdedfd37de0fee$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3bbdedfd37de0fee$var$_useEventCallback = $3bbdedfd37de0fee$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $d9zNj = parcelRequire("d9zNj");

var $1M3bL = parcelRequire("1M3bL");

var $gUrai = parcelRequire("gUrai");

var $NRNex = parcelRequire("NRNex");

var $3nE24 = parcelRequire("3nE24");
const $3bbdedfd37de0fee$var$createCalendarStateReducer = (reduceAnimations, adapter)=>(state, action)=>{
        switch(action.type){
            case 'setVisibleDate':
                return (0, $3bbdedfd37de0fee$var$_extends2.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.month,
                    isMonthSwitchingAnimating: !adapter.isSameMonth(action.month, state.currentMonth) && !reduceAnimations && !action.skipAnimation,
                    focusedDay: action.focusedDay
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (adapter.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = adapter.setTimezone(state.currentMonth, newTimezone);
                    if (adapter.getMonth(newCurrentMonth) !== adapter.getMonth(state.currentMonth)) newCurrentMonth = adapter.setMonth(newCurrentMonth, adapter.getMonth(state.currentMonth));
                    return (0, $3bbdedfd37de0fee$var$_extends2.default)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, $3bbdedfd37de0fee$var$_extends2.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            default:
                throw new Error('missing support');
        }
    };
const $3bbdedfd37de0fee$var$useCalendarState = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onYearChange: onYearChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone, getCurrentMonthFromVisibleDate: getCurrentMonthFromVisibleDate } = params;
    const adapter = (0, $3nE24.usePickerAdapter)();
    const reducerFn = $3bbdedfd37de0fee$var$React.useRef($3bbdedfd37de0fee$var$createCalendarStateReducer(Boolean(reduceAnimations), adapter)).current;
    const referenceDate = $3bbdedfd37de0fee$var$React.useMemo(()=>{
        return $1M3bL.singleItemValueManager.getInitialReferenceValue({
            value: value,
            adapter: adapter,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: $gUrai.SECTION_TYPE_GRANULARITY.day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $3bbdedfd37de0fee$var$React.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: adapter.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const isDateDisabled = (0, $d9zNj.useIsDateDisabled)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $3bbdedfd37de0fee$var$React.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: adapter.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        adapter
    ]);
    const setVisibleDate = (0, $3bbdedfd37de0fee$var$_useEventCallback.default)(({ target: target, reason: reason })=>{
        if (reason === 'cell-interaction' && calendarState.focusedDay != null && adapter.isSameDay(target, calendarState.focusedDay)) return;
        const skipAnimation = reason === 'cell-interaction';
        let month;
        let focusedDay;
        if (reason === 'cell-interaction') {
            month = getCurrentMonthFromVisibleDate(target, calendarState.currentMonth);
            focusedDay = target;
        } else {
            month = adapter.isSameMonth(target, calendarState.currentMonth) ? calendarState.currentMonth : adapter.startOfMonth(target);
            focusedDay = target;
            // If the date is disabled, we try to find a non-disabled date inside the same month.
            if (isDateDisabled(focusedDay)) {
                const startOfMonth = adapter.startOfMonth(target);
                const endOfMonth = adapter.endOfMonth(target);
                focusedDay = (0, $NRNex.findClosestEnabledDate)({
                    adapter: adapter,
                    date: focusedDay,
                    minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
                    maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
                    disablePast: disablePast,
                    disableFuture: disableFuture,
                    isDateDisabled: isDateDisabled,
                    timezone: timezone
                });
            }
        }
        const hasChangedMonth = !adapter.isSameMonth(calendarState.currentMonth, month);
        const hasChangedYear = !adapter.isSameYear(calendarState.currentMonth, month);
        if (hasChangedMonth) onMonthChange?.(month);
        if (hasChangedYear) onYearChange?.(adapter.startOfYear(month));
        dispatch({
            type: 'setVisibleDate',
            month: month,
            direction: adapter.isAfterDay(month, calendarState.currentMonth) ? 'left' : 'right',
            focusedDay: calendarState.focusedDay != null && focusedDay != null && adapter.isSameDay(focusedDay, calendarState.focusedDay) ? calendarState.focusedDay : focusedDay,
            skipAnimation: skipAnimation
        });
    });
    const onMonthSwitchingAnimationEnd = $3bbdedfd37de0fee$var$React.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        setVisibleDate: setVisibleDate,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd
    };
};
module.exports.useCalendarState = $3bbdedfd37de0fee$var$useCalendarState;

});
parcelRegister("d9zNj", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9937e1a8ba43913d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsDateDisabled = void 0;

var $9937e1a8ba43913d$var$React = $9937e1a8ba43913d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5UoGz = parcelRequire("5UoGz");

var $3nE24 = parcelRequire("3nE24");
const $9937e1a8ba43913d$var$useIsDateDisabled = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $3nE24.usePickerAdapter)();
    return $9937e1a8ba43913d$var$React.useCallback((day)=>(0, $5UoGz.validateDate)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};
module.exports.useIsDateDisabled = $9937e1a8ba43913d$var$useIsDateDisabled;

});


parcelRegister("eW408", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $adf9960a2516beaf$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $adf9960a2516beaf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersFadeTransitionGroup = $adf9960a2516beaf$var$PickersFadeTransitionGroup;

var $adf9960a2516beaf$var$_objectWithoutPropertiesLoose2 = $adf9960a2516beaf$require$_interopRequireDefault((parcelRequire("c05no")));

var $adf9960a2516beaf$var$React = $adf9960a2516beaf$require$_interopRequireWildcard((parcelRequire("acw62")));

var $adf9960a2516beaf$var$_clsx = $adf9960a2516beaf$require$_interopRequireDefault((parcelRequire("9QePP")));

var $jEvxL = parcelRequire("jEvxL");

var $adf9960a2516beaf$var$_Fade = $adf9960a2516beaf$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");
var $6g9fa = parcelRequire("6g9fa");

var $adf9960a2516beaf$var$_composeClasses = $adf9960a2516beaf$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $hj2cL = parcelRequire("hj2cL");

var $ayMG0 = parcelRequire("ayMG0");
const $adf9960a2516beaf$var$_excluded = [
    "children"
];
const $adf9960a2516beaf$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $adf9960a2516beaf$var$_composeClasses.default)(slots, $hj2cL.getPickersFadeTransitionGroupUtilityClass, classes);
};
const $adf9960a2516beaf$var$PickersFadeTransitionGroupRoot = (0, $d8seH.default)($jEvxL.default, {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root'
})({
    display: 'block',
    position: 'relative'
});
/**
 * @ignore - do not document.
 */ function $adf9960a2516beaf$var$PickersFadeTransitionGroup(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { className: className, reduceAnimations: reduceAnimations, transKey: transKey, classes: classesProp } = props;
    const { children: children } = props, other = (0, $adf9960a2516beaf$var$_objectWithoutPropertiesLoose2.default)(props, $adf9960a2516beaf$var$_excluded);
    const classes = $adf9960a2516beaf$var$useUtilityClasses(classesProp);
    const theme = (0, $14H9o.default)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($adf9960a2516beaf$var$PickersFadeTransitionGroupRoot, {
        className: (0, $adf9960a2516beaf$var$_clsx.default)(classes.root, className),
        ownerState: other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($adf9960a2516beaf$var$_Fade.default, {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}

});
parcelRegister("5iZHj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("86f4a")).default);

var $86f4a = parcelRequire("86f4a");

});

parcelRegister("hj2cL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c995ebd7b0d30b08$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pickersFadeTransitionGroupClasses = module.exports.getPickersFadeTransitionGroupUtilityClass = void 0;

var $c995ebd7b0d30b08$var$_generateUtilityClass = $c995ebd7b0d30b08$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $c995ebd7b0d30b08$var$_generateUtilityClasses = $c995ebd7b0d30b08$require$_interopRequireDefault((parcelRequire("fXRFb")));
const $c995ebd7b0d30b08$var$getPickersFadeTransitionGroupUtilityClass = (slot)=>(0, $c995ebd7b0d30b08$var$_generateUtilityClass.default)('MuiPickersFadeTransitionGroup', slot);
module.exports.getPickersFadeTransitionGroupUtilityClass = $c995ebd7b0d30b08$var$getPickersFadeTransitionGroupUtilityClass;
const $c995ebd7b0d30b08$var$pickersFadeTransitionGroupClasses = module.exports.pickersFadeTransitionGroupClasses = (0, $c995ebd7b0d30b08$var$_generateUtilityClasses.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);

});


parcelRegister("3UaqM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2d7eb168b763dabb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2d7eb168b763dabb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DayCalendar = $2d7eb168b763dabb$var$DayCalendar;

var $2d7eb168b763dabb$var$_objectWithoutPropertiesLoose2 = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("c05no")));

var $2d7eb168b763dabb$var$_extends2 = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2d7eb168b763dabb$var$React = $2d7eb168b763dabb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2d7eb168b763dabb$var$_useEventCallback = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $2d7eb168b763dabb$var$_Typography = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $2d7eb168b763dabb$var$_useSlotProps2 = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $9uEev = parcelRequire("9uEev");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $2d7eb168b763dabb$var$_composeClasses = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $2d7eb168b763dabb$var$_clsx = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5XNc8 = parcelRequire("5XNc8");

var $BKARN = parcelRequire("BKARN");

var $3vagl = parcelRequire("3vagl");

var $99eO4 = parcelRequire("99eO4");

var $3wpx4 = parcelRequire("3wpx4");

var $d9zNj = parcelRequire("d9zNj");

var $NRNex = parcelRequire("NRNex");

var $66c8j = parcelRequire("66c8j");

var $iFeOh = parcelRequire("iFeOh");

var $ayMG0 = parcelRequire("ayMG0");
const $2d7eb168b763dabb$var$_excluded = [
    "parentProps",
    "day",
    "focusedDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $2d7eb168b763dabb$var$_excluded2 = [
    "ownerState"
];
const $2d7eb168b763dabb$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $2d7eb168b763dabb$var$_composeClasses.default)(slots, $66c8j.getDayCalendarUtilityClass, classes);
};
const $2d7eb168b763dabb$var$weeksContainerHeight = ($99eO4.DAY_SIZE + $99eO4.DAY_MARGIN * 2) * 6;
const $2d7eb168b763dabb$var$PickersCalendarDayRoot = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root'
})({});
const $2d7eb168b763dabb$var$PickersCalendarDayHeader = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $2d7eb168b763dabb$var$PickersCalendarWeekDayLabel = (0, $d8seH.default)($2d7eb168b763dabb$var$_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $2d7eb168b763dabb$var$PickersCalendarWeekNumberLabel = (0, $d8seH.default)($2d7eb168b763dabb$var$_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.disabled
    }));
const $2d7eb168b763dabb$var$PickersCalendarWeekNumber = (0, $d8seH.default)($2d7eb168b763dabb$var$_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber'
})(({ theme: theme })=>(0, $2d7eb168b763dabb$var$_extends2.default)({}, theme.typography.caption, {
        width: $99eO4.DAY_SIZE,
        height: $99eO4.DAY_SIZE,
        padding: 0,
        margin: `0 ${$99eO4.DAY_MARGIN}px`,
        color: (theme.vars || theme).palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $2d7eb168b763dabb$var$PickersCalendarLoadingContainer = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $2d7eb168b763dabb$var$weeksContainerHeight
});
const $2d7eb168b763dabb$var$PickersCalendarSlideTransition = (0, $d8seH.default)($3wpx4.PickersSlideTransition, {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition'
})({
    minHeight: $2d7eb168b763dabb$var$weeksContainerHeight
});
const $2d7eb168b763dabb$var$PickersCalendarWeekContainer = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer'
})({
    overflow: 'hidden'
});
const $2d7eb168b763dabb$var$PickersCalendarWeek = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer'
})({
    margin: `${$99eO4.DAY_MARGIN}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $2d7eb168b763dabb$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusedDay: focusedDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $2d7eb168b763dabb$var$_objectWithoutPropertiesLoose2.default)(_ref, $2d7eb168b763dabb$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const adapter = (0, $BKARN.usePickerAdapter)();
    const now = (0, $3vagl.useNow)(timezone);
    const isFocusableDay = focusedDay != null && adapter.isSameDay(day, focusedDay);
    const isFocusedDay = isViewFocused && isFocusableDay;
    const isSelected = selectedDays.some((selectedDay)=>adapter.isSameDay(selectedDay, day));
    const isToday = adapter.isSameDay(day, now);
    const isDisabled = $2d7eb168b763dabb$var$React.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const isOutsideCurrentMonth = $2d7eb168b763dabb$var$React.useMemo(()=>adapter.getMonth(day) !== currentMonthNumber, [
        adapter,
        day,
        currentMonthNumber
    ]);
    const ownerState = (0, $iFeOh.usePickerDayOwnerState)({
        day: day,
        selected: isSelected,
        disabled: isDisabled,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        disableMargin: undefined,
        disableHighlightToday: // This prop can only be defined using slotProps.day so the ownerState for useSlotProps cannot have its value.
        disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const Day = slots?.day ?? $5XNc8.PickersDay;
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $2d7eb168b763dabb$var$_useSlotProps2.default)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $2d7eb168b763dabb$var$_extends2.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': adapter.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $2d7eb168b763dabb$var$_extends2.default)({}, ownerState, {
            day: day,
            isDayDisabled: isDisabled,
            isDaySelected: isSelected
        })
    }), dayProps = (0, $2d7eb168b763dabb$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $2d7eb168b763dabb$var$_excluded2);
    const isFirstVisibleCell = $2d7eb168b763dabb$var$React.useMemo(()=>{
        const startOfMonth = adapter.startOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, startOfMonth);
        return adapter.isSameDay(day, adapter.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    const isLastVisibleCell = $2d7eb168b763dabb$var$React.useMemo(()=>{
        const endOfMonth = adapter.endOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, endOfMonth);
        return adapter.isSameDay(day, adapter.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Day, (0, $2d7eb168b763dabb$var$_extends2.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: !isOutsideCurrentMonth && isFocusedDay,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
/**
 * @ignore - do not document.
 */ function $2d7eb168b763dabb$var$DayCalendar(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const adapter = (0, $BKARN.usePickerAdapter)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, classes: classesProp, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>adapter.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, timezone: timezone } = props;
    const now = (0, $3vagl.useNow)(timezone);
    const classes = $2d7eb168b763dabb$var$useUtilityClasses(classesProp);
    const isRtl = (0, $9uEev.useRtl)();
    const isDateDisabled = (0, $d9zNj.useIsDateDisabled)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $BKARN.usePickerTranslations)();
    const handleDaySelect = (0, $2d7eb168b763dabb$var$_useEventCallback.default)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            onFocusedViewChange?.(true);
        }
    };
    const handleKeyDown = (0, $2d7eb168b763dabb$var$_useEventCallback.default)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(adapter.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(adapter.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $NRNex.findClosestEnabledDate)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : adapter.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? adapter.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $NRNex.findClosestEnabledDate)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? adapter.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : adapter.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(adapter.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(adapter.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(adapter.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(adapter.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $2d7eb168b763dabb$var$_useEventCallback.default)((event, day)=>focusDay(day));
    const handleBlur = (0, $2d7eb168b763dabb$var$_useEventCallback.default)((event, day)=>{
        if (focusedDay != null && adapter.isSameDay(focusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = adapter.getMonth(currentMonth);
    const currentYearNumber = adapter.getYear(currentMonth);
    const validSelectedDays = $2d7eb168b763dabb$var$React.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>adapter.startOfDay(day)), [
        adapter,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $2d7eb168b763dabb$var$React.useMemo(()=>/*#__PURE__*/ $2d7eb168b763dabb$var$React.createRef(), [
        transitionKey
    ]);
    const weeksToDisplay = $2d7eb168b763dabb$var$React.useMemo(()=>{
        const toDisplay = adapter.getWeekArray(currentMonth);
        let nextMonth = adapter.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = adapter.getWeekArray(nextMonth);
            const hasCommonWeek = adapter.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = adapter.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        adapter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $NRNex.getWeekdays)(adapter, now).map((weekday, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": adapter.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarSlideTransition, (0, $2d7eb168b763dabb$var$_extends2.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $2d7eb168b763dabb$var$_clsx.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(adapter.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(adapter.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        isViewFocused: hasFocus,
                                        focusedDay: focusedDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}

});
parcelRegister("5XNc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersDay", {
    enumerable: true,
    get: function() {
        return $dULUG.PickersDay;
    }
});
Object.defineProperty(module.exports, "getPickersDayUtilityClass", {
    enumerable: true,
    get: function() {
        return $baaJf.getPickersDayUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersDayClasses", {
    enumerable: true,
    get: function() {
        return $baaJf.pickersDayClasses;
    }
});

var $dULUG = parcelRequire("dULUG");

var $baaJf = parcelRequire("baaJf");

});
parcelRegister("dULUG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a215abe4b2054e88$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a215abe4b2054e88$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersDay = void 0;

var $a215abe4b2054e88$var$_objectWithoutPropertiesLoose2 = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("c05no")));

var $a215abe4b2054e88$var$_extends2 = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a215abe4b2054e88$var$React = $a215abe4b2054e88$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a215abe4b2054e88$var$_propTypes = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a215abe4b2054e88$var$_clsx = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a215abe4b2054e88$var$_ButtonBase = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $a215abe4b2054e88$var$_useEnhancedEffect = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $a215abe4b2054e88$var$_composeClasses = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $a215abe4b2054e88$var$_useForkRef = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("88PIk")));

var $8gMkr = parcelRequire("8gMkr");
var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $3nE24 = parcelRequire("3nE24");

var $99eO4 = parcelRequire("99eO4");

var $baaJf = parcelRequire("baaJf");

var $iFeOh = parcelRequire("iFeOh");

var $ayMG0 = parcelRequire("ayMG0");
const $a215abe4b2054e88$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "children",
    "isFirstVisibleCell",
    "isLastVisibleCell",
    "day",
    "selected",
    "disabled",
    "today",
    "outsideCurrentMonth",
    "disableMargin",
    "disableHighlightToday",
    "showDaysOutsideCurrentMonth"
];
const $a215abe4b2054e88$var$useUtilityClasses = (classes, ownerState)=>{
    const { isDaySelected: isDaySelected, isDayDisabled: isDayDisabled, isDayCurrent: isDayCurrent, isDayOutsideMonth: isDayOutsideMonth, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = ownerState;
    const isHiddenDaySpacingFiller = isDayOutsideMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            isDaySelected && !isHiddenDaySpacingFiller && 'selected',
            isDayDisabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && isDayCurrent && 'today',
            isDayOutsideMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $a215abe4b2054e88$var$_composeClasses.default)(slots, $baaJf.getPickersDayUtilityClass, classes);
};
const $a215abe4b2054e88$var$styleArg = ({ theme: theme })=>(0, $a215abe4b2054e88$var$_extends2.default)({}, theme.typography.caption, {
        width: $99eO4.DAY_SIZE,
        height: $99eO4.DAY_SIZE,
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${$baaJf.pickersDayClasses.selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${$baaJf.pickersDayClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${$baaJf.pickersDayClasses.disabled}:not(.${$baaJf.pickersDayClasses.selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${$baaJf.pickersDayClasses.disabled}&.${$baaJf.pickersDayClasses.selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${$99eO4.DAY_MARGIN}px`
                }
            },
            {
                props: {
                    isDayOutsideMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    isDayCurrent: true
                },
                style: {
                    [`&:not(.${$baaJf.pickersDayClasses.selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $a215abe4b2054e88$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.isDayCurrent && styles.today,
        !ownerState.isDayOutsideMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.isDayOutsideMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $a215abe4b2054e88$var$PickersDayRoot = (0, $d8seH.default)($a215abe4b2054e88$var$_ButtonBase.default, {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a215abe4b2054e88$var$overridesResolver
})($a215abe4b2054e88$var$styleArg);
const $a215abe4b2054e88$var$PickersDayFiller = (0, $d8seH.default)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a215abe4b2054e88$var$overridesResolver
})(({ theme: theme })=>(0, $a215abe4b2054e88$var$_extends2.default)({}, $a215abe4b2054e88$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $a215abe4b2054e88$var$noop = ()=>{};
const $a215abe4b2054e88$var$PickersDayRaw = /*#__PURE__*/ $a215abe4b2054e88$var$React.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, classes: classesProp, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $a215abe4b2054e88$var$noop, onBlur: onBlur = $a215abe4b2054e88$var$noop, onKeyDown: onKeyDown = $a215abe4b2054e88$var$noop, onMouseDown: onMouseDown = $a215abe4b2054e88$var$noop, onMouseEnter: onMouseEnter = $a215abe4b2054e88$var$noop, children: children, day: day, selected: selected, disabled: disabled, today: today, outsideCurrentMonth: outsideCurrentMonth, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = props, other = (0, $a215abe4b2054e88$var$_objectWithoutPropertiesLoose2.default)(props, $a215abe4b2054e88$var$_excluded);
    const ownerState = (0, $iFeOh.usePickerDayOwnerState)({
        day: day,
        selected: selected,
        disabled: disabled,
        today: today,
        outsideCurrentMonth: outsideCurrentMonth,
        disableMargin: disableMargin,
        disableHighlightToday: disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const classes = $a215abe4b2054e88$var$useUtilityClasses(classesProp, ownerState);
    const adapter = (0, $3nE24.usePickerAdapter)();
    const ref = $a215abe4b2054e88$var$React.useRef(null);
    const handleRef = (0, $a215abe4b2054e88$var$_useForkRef.default)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $a215abe4b2054e88$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        event.defaultMuiPrevented = true;
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $ayMG0.jsx)($a215abe4b2054e88$var$PickersDayFiller, {
        className: (0, $a215abe4b2054e88$var$_clsx.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a215abe4b2054e88$var$PickersDayRoot, (0, $a215abe4b2054e88$var$_extends2.default)({
        className: (0, $a215abe4b2054e88$var$_clsx.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: children ?? adapter.format(day, 'dayOfMonth')
    }));
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * API:
 *
 * - [PickersDay API](https://mui.com/x/api/date-pickers/pickers-day/)
 */ const $a215abe4b2054e88$var$PickersDay = module.exports.PickersDay = /*#__PURE__*/ $a215abe4b2054e88$var$React.memo($a215abe4b2054e88$var$PickersDayRaw);

});
parcelRegister("hhs3r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6n0Ko")).default);
$parcel$export(module.exports, "buttonBaseClasses", () => (parcelRequire("5JO1P")).default);
$parcel$export(module.exports, "touchRippleClasses", () => (parcelRequire("a4Mf7")).default);

var $6n0Ko = parcelRequire("6n0Ko");

var $5JO1P = parcelRequire("5JO1P");

var $a4Mf7 = parcelRequire("a4Mf7");
$parcel$exportWildcard(module.exports, $5JO1P);
$parcel$exportWildcard(module.exports, $a4Mf7);

});

parcelRegister("baaJf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8208f360828d6fb0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersDayUtilityClass = $8208f360828d6fb0$var$getPickersDayUtilityClass;
module.exports.pickersDayClasses = void 0;

var $8208f360828d6fb0$var$_generateUtilityClass = $8208f360828d6fb0$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $8208f360828d6fb0$var$_generateUtilityClasses = $8208f360828d6fb0$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $8208f360828d6fb0$var$getPickersDayUtilityClass(slot) {
    return (0, $8208f360828d6fb0$var$_generateUtilityClass.default)('MuiPickersDay', slot);
}
const $8208f360828d6fb0$var$pickersDayClasses = module.exports.pickersDayClasses = (0, $8208f360828d6fb0$var$_generateUtilityClasses.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);

});

parcelRegister("iFeOh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d9678b4949009dc3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d9678b4949009dc3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerDayOwnerState = $d9678b4949009dc3$var$usePickerDayOwnerState;

var $d9678b4949009dc3$var$_extends2 = $d9678b4949009dc3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d9678b4949009dc3$var$React = $d9678b4949009dc3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7OOd8 = parcelRequire("7OOd8");

var $3nE24 = parcelRequire("3nE24");
function $d9678b4949009dc3$var$usePickerDayOwnerState(parameters) {
    const { disabled: disabled, selected: selected, today: today, outsideCurrentMonth: outsideCurrentMonth, day: day, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = parameters;
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    return $d9678b4949009dc3$var$React.useMemo(()=>(0, $d9678b4949009dc3$var$_extends2.default)({}, pickerOwnerState, {
            day: day,
            isDaySelected: selected ?? false,
            isDayDisabled: disabled ?? false,
            isDayCurrent: today ?? false,
            isDayOutsideMonth: outsideCurrentMonth ?? false,
            isDayStartOfWeek: adapter.isSameDay(day, adapter.startOfWeek(day)),
            isDayEndOfWeek: adapter.isSameDay(day, adapter.endOfWeek(day)),
            disableMargin: disableMargin ?? false,
            disableHighlightToday: disableHighlightToday ?? false,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth ?? false
        }), [
        adapter,
        pickerOwnerState,
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableMargin,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    ]);
}

});



parcelRegister("3wpx4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $29082a754ce64855$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $29082a754ce64855$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersSlideTransition = $29082a754ce64855$var$PickersSlideTransition;

var $29082a754ce64855$var$_extends2 = $29082a754ce64855$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $29082a754ce64855$var$_objectWithoutPropertiesLoose2 = $29082a754ce64855$require$_interopRequireDefault((parcelRequire("c05no")));

var $29082a754ce64855$var$React = $29082a754ce64855$require$_interopRequireWildcard((parcelRequire("acw62")));

var $29082a754ce64855$var$_clsx = $29082a754ce64855$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");
var $6g9fa = parcelRequire("6g9fa");

var $29082a754ce64855$var$_composeClasses = $29082a754ce64855$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $krPIU = parcelRequire("krPIU");
var $jEvxL = parcelRequire("jEvxL");

var $ha1fF = parcelRequire("ha1fF");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $29082a754ce64855$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $29082a754ce64855$var$useUtilityClasses = (classes, ownerState)=>{
    const { slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $29082a754ce64855$var$_composeClasses.default)(slots, $ha1fF.getPickersSlideTransitionUtilityClass, classes);
};
const $29082a754ce64855$var$PickersSlideTransitionRoot = (0, $d8seH.default)($jEvxL.default, {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${$ha1fF.pickersSlideTransitionClasses['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses.slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses.slideExit}`]: styles.slideExit
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses.slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses.slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
/**
 * @ignore - do not document.
 */ function $29082a754ce64855$var$PickersSlideTransition(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, slideDirection: slideDirection, transKey: transKey, classes: classesProp } = props, other = (0, $29082a754ce64855$var$_objectWithoutPropertiesLoose2.default)(props, $29082a754ce64855$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $29082a754ce64855$var$_extends2.default)({}, pickerOwnerState, {
        slideDirection: slideDirection
    });
    const classes = $29082a754ce64855$var$useUtilityClasses(classesProp, ownerState);
    const theme = (0, $14H9o.default)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $29082a754ce64855$var$_clsx.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($29082a754ce64855$var$PickersSlideTransitionRoot, {
        className: (0, $29082a754ce64855$var$_clsx.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $29082a754ce64855$var$React.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($krPIU.default, (0, $29082a754ce64855$var$_extends2.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}

});
parcelRegister("krPIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2e736fe07a2c40$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $8pZ1o = parcelRequire("8pZ1o");

var $gFyrF = parcelRequire("gFyrF");

var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");


var $4NYRH = parcelRequire("4NYRH");
var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $8pZ1o.default)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $gFyrF.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $4NYRH.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $1En50.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1mPeS.default), (0, $8nd05.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ''
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = {};
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;

});
parcelRegister("8pZ1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $620ffe1c3bcccf8e$export$2e2bcd8739ae039);

var $59GJ0 = parcelRequire("59GJ0");
function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $59GJ0.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("59GJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c0eef4e7b8d3866$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("gFyrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c22b31c675df16bf$export$2e2bcd8739ae039);
function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});


parcelRegister("ha1fF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c7e4576059c0fe7a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pickersSlideTransitionClasses = module.exports.getPickersSlideTransitionUtilityClass = void 0;

var $c7e4576059c0fe7a$var$_generateUtilityClass = $c7e4576059c0fe7a$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $c7e4576059c0fe7a$var$_generateUtilityClasses = $c7e4576059c0fe7a$require$_interopRequireDefault((parcelRequire("fXRFb")));
const $c7e4576059c0fe7a$var$getPickersSlideTransitionUtilityClass = (slot)=>(0, $c7e4576059c0fe7a$var$_generateUtilityClass.default)('MuiPickersSlideTransition', slot);
module.exports.getPickersSlideTransitionUtilityClass = $c7e4576059c0fe7a$var$getPickersSlideTransitionUtilityClass;
const $c7e4576059c0fe7a$var$pickersSlideTransitionClasses = module.exports.pickersSlideTransitionClasses = (0, $c7e4576059c0fe7a$var$_generateUtilityClasses.default)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);

});


parcelRegister("66c8j", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $01255dca2f143194$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDayCalendarUtilityClass = module.exports.dayCalendarClasses = void 0;

var $01255dca2f143194$var$_generateUtilityClass = $01255dca2f143194$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $01255dca2f143194$var$_generateUtilityClasses = $01255dca2f143194$require$_interopRequireDefault((parcelRequire("fXRFb")));
const $01255dca2f143194$var$getDayCalendarUtilityClass = (slot)=>(0, $01255dca2f143194$var$_generateUtilityClass.default)('MuiDayCalendar', slot);
module.exports.getDayCalendarUtilityClass = $01255dca2f143194$var$getDayCalendarUtilityClass;
const $01255dca2f143194$var$dayCalendarClasses = module.exports.dayCalendarClasses = (0, $01255dca2f143194$var$_generateUtilityClasses.default)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);

});


parcelRegister("gYuM1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "MonthCalendar", {
    enumerable: true,
    get: function() {
        return $7aXUm.MonthCalendar;
    }
});
Object.defineProperty(module.exports, "getMonthCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return $yRsP7.getMonthCalendarUtilityClass;
    }
});
Object.defineProperty(module.exports, "monthCalendarClasses", {
    enumerable: true,
    get: function() {
        return $yRsP7.monthCalendarClasses;
    }
});

var $7aXUm = parcelRequire("7aXUm");

var $yRsP7 = parcelRequire("yRsP7");

});
parcelRegister("7aXUm", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5397f01707da67a7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5397f01707da67a7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MonthCalendar = void 0;
module.exports.useMonthCalendarDefaultizedProps = $5397f01707da67a7$var$useMonthCalendarDefaultizedProps;

var $5397f01707da67a7$var$_objectWithoutPropertiesLoose2 = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("c05no")));

var $5397f01707da67a7$var$_extends2 = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5397f01707da67a7$var$React = $5397f01707da67a7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5397f01707da67a7$var$_propTypes = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5397f01707da67a7$var$_clsx = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9uEev = parcelRequire("9uEev");

var $bbeCr = parcelRequire("bbeCr");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $5397f01707da67a7$var$_useControlled = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("ik3FS")));

var $5397f01707da67a7$var$_composeClasses = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $5397f01707da67a7$var$_useEventCallback = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $cm4Q0 = parcelRequire("cm4Q0");

var $3vagl = parcelRequire("3vagl");

var $yRsP7 = parcelRequire("yRsP7");

var $NRNex = parcelRequire("NRNex");

var $1M3bL = parcelRequire("1M3bL");

var $gUrai = parcelRequire("gUrai");

var $hagTn = parcelRequire("hagTn");

var $99eO4 = parcelRequire("99eO4");

var $7OOd8 = parcelRequire("7OOd8");

var $1aSwN = parcelRequire("1aSwN");

var $3nE24 = parcelRequire("3nE24");

var $ayMG0 = parcelRequire("ayMG0");
const $5397f01707da67a7$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $5397f01707da67a7$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5397f01707da67a7$var$_composeClasses.default)(slots, $yRsP7.getMonthCalendarUtilityClass, classes);
};
function $5397f01707da67a7$var$useMonthCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $6g9fa.default)({
        props: props,
        name: name
    });
    const validationProps = (0, $1aSwN.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, $5397f01707da67a7$var$_extends2.default)({}, themeProps, validationProps, {
        monthsPerRow: themeProps.monthsPerRow ?? 3
    });
}
const $5397f01707da67a7$var$MonthCalendarRoot = (0, $d8seH.default)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'monthsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 16,
    padding: '8px 0',
    width: $99eO4.DIALOG_WIDTH,
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    variants: [
        {
            props: {
                monthsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                columnGap: 0
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 *
 * API:
 *
 * - [MonthCalendar API](https://mui.com/x/api/date-pickers/month-calendar/)
 */ const $5397f01707da67a7$var$MonthCalendar = module.exports.MonthCalendar = /*#__PURE__*/ $5397f01707da67a7$var$React.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $5397f01707da67a7$var$useMonthCalendarDefaultizedProps(inProps, 'MuiMonthCalendar');
    const { autoFocus: autoFocus, className: className, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $5397f01707da67a7$var$_objectWithoutPropertiesLoose2.default)(props, $5397f01707da67a7$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const now = (0, $3vagl.useNow)(timezone);
    const isRtl = (0, $9uEev.useRtl)();
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const referenceDate = $5397f01707da67a7$var$React.useMemo(()=>$1M3bL.singleItemValueManager.getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: $gUrai.SECTION_TYPE_GRANULARITY.month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $5397f01707da67a7$var$useUtilityClasses(classesProp);
    const todayMonth = $5397f01707da67a7$var$React.useMemo(()=>adapter.getMonth(now), [
        adapter,
        now
    ]);
    const selectedMonth = $5397f01707da67a7$var$React.useMemo(()=>{
        if (value != null) return adapter.getMonth(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedMonth, setFocusedMonth] = $5397f01707da67a7$var$React.useState(()=>selectedMonth || adapter.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $5397f01707da67a7$var$_useControlled.default)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $5397f01707da67a7$var$_useEventCallback.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $5397f01707da67a7$var$React.useCallback((dateToValidate)=>{
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = adapter.startOfMonth(dateToValidate);
        if (adapter.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (adapter.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        adapter
    ]);
    const handleMonthSelection = (0, $5397f01707da67a7$var$_useEventCallback.default)((event, month)=>{
        if (readOnly) return;
        const newDate = adapter.setMonth(value ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $5397f01707da67a7$var$_useEventCallback.default)((month)=>{
        if (!isMonthDisabled(adapter.setMonth(value ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $5397f01707da67a7$var$React.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $5397f01707da67a7$var$_useEventCallback.default)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $5397f01707da67a7$var$_useEventCallback.default)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $5397f01707da67a7$var$_useEventCallback.default)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5397f01707da67a7$var$MonthCalendarRoot, (0, $5397f01707da67a7$var$_extends2.default)({
        ref: ref,
        className: (0, $5397f01707da67a7$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        monthsPerRow: monthsPerRow
    }, other, {
        children: (0, $NRNex.getMonthsInYear)(adapter, value ?? referenceDate).map((month)=>{
            const monthNumber = adapter.getMonth(month);
            const monthText = adapter.format(month, 'monthShort');
            const monthLabel = adapter.format(month, 'month');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $ayMG0.jsx)($cm4Q0.MonthCalendarButton, {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : undefined,
                "aria-label": monthLabel,
                slots: slots,
                slotProps: slotProps,
                classes: classesProp,
                children: monthText
            }, monthText);
        })
    }));
});

});
parcelRegister("cm4Q0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8feb4accebf80a5e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8feb4accebf80a5e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MonthCalendarButton = void 0;

var $8feb4accebf80a5e$var$_objectWithoutPropertiesLoose2 = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("c05no")));

var $8feb4accebf80a5e$var$_extends2 = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8feb4accebf80a5e$var$React = $8feb4accebf80a5e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8gMkr = parcelRequire("8gMkr");
var $d8seH = parcelRequire("d8seH");

var $8feb4accebf80a5e$var$_useSlotProps = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $8feb4accebf80a5e$var$_composeClasses = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $8feb4accebf80a5e$var$_useEnhancedEffect = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $7OOd8 = parcelRequire("7OOd8");

var $yRsP7 = parcelRequire("yRsP7");

var $ayMG0 = parcelRequire("ayMG0");
const $8feb4accebf80a5e$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $8feb4accebf80a5e$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isMonthDisabled && 'disabled',
            ownerState.isMonthSelected && 'selected'
        ]
    };
    return (0, $8feb4accebf80a5e$var$_composeClasses.default)(slots, $yRsP7.getMonthCalendarUtilityClass, classes);
};
const $8feb4accebf80a5e$var$DefaultMonthButton = (0, $d8seH.default)('button', {
    name: 'MuiMonthCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${$yRsP7.monthCalendarClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${$yRsP7.monthCalendarClasses.selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $8feb4accebf80a5e$var$_extends2.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${$yRsP7.monthCalendarClasses.disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${$yRsP7.monthCalendarClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
/**
 * @ignore - do not document.
 */ const $8feb4accebf80a5e$var$MonthCalendarButton = module.exports.MonthCalendarButton = /*#__PURE__*/ $8feb4accebf80a5e$var$React.memo(function MonthCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $8feb4accebf80a5e$var$_objectWithoutPropertiesLoose2.default)(props, $8feb4accebf80a5e$var$_excluded);
    const ref = $8feb4accebf80a5e$var$React.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $8feb4accebf80a5e$var$_extends2.default)({}, pickerOwnerState, {
        isMonthDisabled: disabled,
        isMonthSelected: selected
    });
    const classes = $8feb4accebf80a5e$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $8feb4accebf80a5e$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? $8feb4accebf80a5e$var$DefaultMonthButton;
    const monthButtonProps = (0, $8feb4accebf80a5e$var$_useSlotProps.default)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(MonthButton, (0, $8feb4accebf80a5e$var$_extends2.default)({}, monthButtonProps));
});

});
parcelRegister("yRsP7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $068ca5e81320aff6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMonthCalendarUtilityClass = $068ca5e81320aff6$var$getMonthCalendarUtilityClass;
module.exports.monthCalendarClasses = void 0;

var $068ca5e81320aff6$var$_generateUtilityClass = $068ca5e81320aff6$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $068ca5e81320aff6$var$_generateUtilityClasses = $068ca5e81320aff6$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $068ca5e81320aff6$var$getMonthCalendarUtilityClass(slot) {
    return (0, $068ca5e81320aff6$var$_generateUtilityClass.default)('MuiMonthCalendar', slot);
}
const $068ca5e81320aff6$var$monthCalendarClasses = module.exports.monthCalendarClasses = (0, $068ca5e81320aff6$var$_generateUtilityClasses.default)('MuiMonthCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);

});




parcelRegister("haVKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "YearCalendar", {
    enumerable: true,
    get: function() {
        return $18Z8C.YearCalendar;
    }
});
Object.defineProperty(module.exports, "getYearCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return $7vcQG.getYearCalendarUtilityClass;
    }
});
Object.defineProperty(module.exports, "yearCalendarClasses", {
    enumerable: true,
    get: function() {
        return $7vcQG.yearCalendarClasses;
    }
});

var $18Z8C = parcelRequire("18Z8C");

var $7vcQG = parcelRequire("7vcQG");

});
parcelRegister("18Z8C", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0d55f68b977aee64$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0d55f68b977aee64$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.YearCalendar = void 0;

var $0d55f68b977aee64$var$_objectWithoutPropertiesLoose2 = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("c05no")));

var $0d55f68b977aee64$var$_extends2 = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0d55f68b977aee64$var$React = $0d55f68b977aee64$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0d55f68b977aee64$var$_propTypes = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0d55f68b977aee64$var$_clsx = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9uEev = parcelRequire("9uEev");

var $bbeCr = parcelRequire("bbeCr");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $0d55f68b977aee64$var$_useForkRef = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("88PIk")));

var $0d55f68b977aee64$var$_composeClasses = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $0d55f68b977aee64$var$_useControlled = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("ik3FS")));

var $0d55f68b977aee64$var$_useEventCallback = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $dpAAI = parcelRequire("dpAAI");

var $3vagl = parcelRequire("3vagl");

var $7vcQG = parcelRequire("7vcQG");

var $1M3bL = parcelRequire("1M3bL");

var $gUrai = parcelRequire("gUrai");

var $hagTn = parcelRequire("hagTn");

var $99eO4 = parcelRequire("99eO4");

var $7OOd8 = parcelRequire("7OOd8");

var $1aSwN = parcelRequire("1aSwN");

var $3nE24 = parcelRequire("3nE24");

var $ayMG0 = parcelRequire("ayMG0");
const $0d55f68b977aee64$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $0d55f68b977aee64$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $0d55f68b977aee64$var$_composeClasses.default)(slots, $7vcQG.getYearCalendarUtilityClass, classes);
};
function $0d55f68b977aee64$var$useYearCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $6g9fa.default)({
        props: props,
        name: name
    });
    const validationProps = (0, $1aSwN.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, $0d55f68b977aee64$var$_extends2.default)({}, themeProps, validationProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        yearsOrder: themeProps.yearsOrder ?? 'asc'
    });
}
const $0d55f68b977aee64$var$YearCalendarRoot = (0, $d8seH.default)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'yearsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 12,
    padding: '6px 0',
    overflowY: 'auto',
    height: '100%',
    width: $99eO4.DIALOG_WIDTH,
    maxHeight: $99eO4.MAX_CALENDAR_HEIGHT,
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative',
    variants: [
        {
            props: {
                yearsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                columnGap: 0,
                padding: '0 2px'
            }
        }
    ]
});
const $0d55f68b977aee64$var$YearCalendarButtonFiller = (0, $d8seH.default)('div', {
    name: 'MuiYearCalendar',
    slot: 'ButtonFiller'
})({
    height: 36,
    width: 72
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 *
 * API:
 *
 * - [YearCalendar API](https://mui.com/x/api/date-pickers/year-calendar/)
 */ const $0d55f68b977aee64$var$YearCalendar = module.exports.YearCalendar = /*#__PURE__*/ $0d55f68b977aee64$var$React.forwardRef(function YearCalendar(inProps, ref) {
    const props = $0d55f68b977aee64$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $0d55f68b977aee64$var$_objectWithoutPropertiesLoose2.default)(props, $0d55f68b977aee64$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const now = (0, $3vagl.useNow)(timezone);
    const isRtl = (0, $9uEev.useRtl)();
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const referenceDate = $0d55f68b977aee64$var$React.useMemo(()=>$1M3bL.singleItemValueManager.getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: $gUrai.SECTION_TYPE_GRANULARITY.year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $0d55f68b977aee64$var$useUtilityClasses(classesProp);
    const todayYear = $0d55f68b977aee64$var$React.useMemo(()=>adapter.getYear(now), [
        adapter,
        now
    ]);
    const selectedYear = $0d55f68b977aee64$var$React.useMemo(()=>{
        if (value != null) return adapter.getYear(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedYear, setFocusedYear] = $0d55f68b977aee64$var$React.useState(()=>selectedYear || adapter.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $0d55f68b977aee64$var$_useControlled.default)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $0d55f68b977aee64$var$_useEventCallback.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $0d55f68b977aee64$var$React.useCallback((dateToValidate)=>{
        if (disablePast && adapter.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && adapter.isAfterYear(dateToValidate, now)) return true;
        if (minDate && adapter.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && adapter.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = adapter.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        adapter
    ]);
    const handleYearSelection = (0, $0d55f68b977aee64$var$_useEventCallback.default)((event, year)=>{
        if (readOnly) return;
        const newDate = adapter.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $0d55f68b977aee64$var$_useEventCallback.default)((year)=>{
        if (!isYearDisabled(adapter.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $0d55f68b977aee64$var$React.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, $0d55f68b977aee64$var$_useEventCallback.default)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $0d55f68b977aee64$var$_useEventCallback.default)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $0d55f68b977aee64$var$_useEventCallback.default)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $0d55f68b977aee64$var$React.useRef(null);
    const handleRef = (0, $0d55f68b977aee64$var$_useForkRef.default)(ref, scrollerRef);
    $0d55f68b977aee64$var$React.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = adapter.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    let fillerAmount = yearsPerRow - yearRange.length % yearsPerRow;
    if (fillerAmount === yearsPerRow) fillerAmount = 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d55f68b977aee64$var$YearCalendarRoot, (0, $0d55f68b977aee64$var$_extends2.default)({
        ref: handleRef,
        className: (0, $0d55f68b977aee64$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        yearsPerRow: yearsPerRow
    }, other, {
        children: [
            yearRange.map((year)=>{
                const yearNumber = adapter.getYear(year);
                const isSelected = yearNumber === selectedYear;
                const isDisabled = disabled || isYearDisabled(year);
                return /*#__PURE__*/ (0, $ayMG0.jsx)($dpAAI.YearCalendarButton, {
                    selected: isSelected,
                    value: yearNumber,
                    onClick: handleYearSelection,
                    onKeyDown: handleKeyDown,
                    autoFocus: internalHasFocus && yearNumber === focusedYear,
                    disabled: isDisabled,
                    tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                    onFocus: handleYearFocus,
                    onBlur: handleYearBlur,
                    "aria-current": todayYear === yearNumber ? 'date' : undefined,
                    slots: slots,
                    slotProps: slotProps,
                    classes: classesProp,
                    children: adapter.format(year, 'year')
                }, adapter.format(year, 'year'));
            }),
            Array.from({
                length: fillerAmount
            }, (_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0d55f68b977aee64$var$YearCalendarButtonFiller, {}, index))
        ]
    }));
});

});
parcelRegister("dpAAI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9c39fe654796b109$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9c39fe654796b109$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.YearCalendarButton = void 0;

var $9c39fe654796b109$var$_objectWithoutPropertiesLoose2 = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("c05no")));

var $9c39fe654796b109$var$_extends2 = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9c39fe654796b109$var$React = $9c39fe654796b109$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8gMkr = parcelRequire("8gMkr");
var $d8seH = parcelRequire("d8seH");

var $9c39fe654796b109$var$_useSlotProps = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $9c39fe654796b109$var$_composeClasses = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $9c39fe654796b109$var$_useEnhancedEffect = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $7OOd8 = parcelRequire("7OOd8");

var $7vcQG = parcelRequire("7vcQG");

var $ayMG0 = parcelRequire("ayMG0");
const $9c39fe654796b109$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $9c39fe654796b109$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isYearDisabled && 'disabled',
            ownerState.isYearSelected && 'selected'
        ]
    };
    return (0, $9c39fe654796b109$var$_composeClasses.default)(slots, $7vcQG.getYearCalendarUtilityClass, classes);
};
const $9c39fe654796b109$var$DefaultYearButton = (0, $d8seH.default)('button', {
    name: 'MuiYearCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${$7vcQG.yearCalendarClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${$7vcQG.yearCalendarClasses.selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $9c39fe654796b109$var$_extends2.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8gMkr.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${$7vcQG.yearCalendarClasses.disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${$7vcQG.yearCalendarClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
/**
 * @ignore - internal component.
 */ const $9c39fe654796b109$var$YearCalendarButton = module.exports.YearCalendarButton = /*#__PURE__*/ $9c39fe654796b109$var$React.memo(function YearCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $9c39fe654796b109$var$_objectWithoutPropertiesLoose2.default)(props, $9c39fe654796b109$var$_excluded);
    const ref = $9c39fe654796b109$var$React.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $9c39fe654796b109$var$_extends2.default)({}, pickerOwnerState, {
        isYearDisabled: disabled,
        isYearSelected: selected
    });
    const classes = $9c39fe654796b109$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $9c39fe654796b109$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? $9c39fe654796b109$var$DefaultYearButton;
    const yearButtonProps = (0, $9c39fe654796b109$var$_useSlotProps.default)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(YearButton, (0, $9c39fe654796b109$var$_extends2.default)({}, yearButtonProps));
});

});
parcelRegister("7vcQG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5765652a82ee3360$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getYearCalendarUtilityClass = $5765652a82ee3360$var$getYearCalendarUtilityClass;
module.exports.yearCalendarClasses = void 0;

var $5765652a82ee3360$var$_generateUtilityClass = $5765652a82ee3360$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $5765652a82ee3360$var$_generateUtilityClasses = $5765652a82ee3360$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $5765652a82ee3360$var$getYearCalendarUtilityClass(slot) {
    return (0, $5765652a82ee3360$var$_generateUtilityClass.default)('MuiYearCalendar', slot);
}
const $5765652a82ee3360$var$yearCalendarClasses = module.exports.yearCalendarClasses = (0, $5765652a82ee3360$var$_generateUtilityClasses.default)('MuiYearCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);

});




parcelRegister("3cW2G", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $255f841782d21111$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $255f841782d21111$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useViews = $255f841782d21111$var$useViews;

var $255f841782d21111$var$_extends2 = $255f841782d21111$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $255f841782d21111$var$React = $255f841782d21111$require$_interopRequireWildcard((parcelRequire("acw62")));

var $255f841782d21111$var$_useEventCallback = $255f841782d21111$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $255f841782d21111$var$_useControlled = $255f841782d21111$require$_interopRequireDefault((parcelRequire("ik3FS")));

var $kHgod = parcelRequire("kHgod");
let $255f841782d21111$var$warnedOnceNotValidView = false;
function $255f841782d21111$var$useViews({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, getStepNavigation: getStepNavigation }) {
    const previousOpenTo = $255f841782d21111$var$React.useRef(openTo);
    const previousViews = $255f841782d21111$var$React.useRef(views);
    const defaultView = $255f841782d21111$var$React.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $255f841782d21111$var$_useControlled.default)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $255f841782d21111$var$React.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $255f841782d21111$var$_useControlled.default)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    const stepNavigation = getStepNavigation ? getStepNavigation({
        setView: setView,
        view: view,
        defaultView: defaultView.current,
        views: views
    }) : $kHgod.DEFAULT_STEP_NAVIGATION;
    $255f841782d21111$var$React.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $255f841782d21111$var$_useEventCallback.default)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $255f841782d21111$var$_useEventCallback.default)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $255f841782d21111$var$_useEventCallback.default)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $255f841782d21111$var$_useEventCallback.default)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // The selected view can be different from the active view,
        // This can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        let currentView = null;
        if (selectedView != null && selectedView !== view) currentView = selectedView;
        else if (isSelectionFinishedOnCurrentView) currentView = view;
        if (currentView == null) return;
        const viewToNavigateTo = views[views.indexOf(currentView) + 1];
        if (viewToNavigateTo == null || !stepNavigation.areViewsInSameStep(currentView, viewToNavigateTo)) return;
        handleChangeView(viewToNavigateTo);
    });
    return (0, $255f841782d21111$var$_extends2.default)({}, stepNavigation, {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    });
}

});
parcelRegister("kHgod", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f114897171fbb236$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_STEP_NAVIGATION = void 0;
module.exports.createStepNavigation = $f114897171fbb236$var$createStepNavigation;

var $f114897171fbb236$var$_extends2 = $f114897171fbb236$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $f114897171fbb236$var$DEFAULT_STEP_NAVIGATION = module.exports.DEFAULT_STEP_NAVIGATION = {
    hasNextStep: false,
    hasSeveralSteps: false,
    goToNextStep: ()=>{},
    areViewsInSameStep: ()=>true
};
/**
 * Create an object that determines whether there is a next step and allows to go to the next step.
 * @param {CreateStepNavigationParameters<TStep>} parameters The parameters of the createStepNavigation function
 * @returns {CreateStepNavigationReturnValue} The return value of the createStepNavigation function
 */ function $f114897171fbb236$var$createStepNavigation(parameters) {
    const { steps: steps, isViewMatchingStep: isViewMatchingStep, onStepChange: onStepChange } = parameters;
    return (parametersBis)=>{
        if (steps == null) return $f114897171fbb236$var$DEFAULT_STEP_NAVIGATION;
        const currentStepIndex = steps.findIndex((step)=>isViewMatchingStep(parametersBis.view, step));
        const nextStep = currentStepIndex === -1 || currentStepIndex === steps.length - 1 ? null : steps[currentStepIndex + 1];
        return {
            hasNextStep: nextStep != null,
            hasSeveralSteps: steps.length > 1,
            goToNextStep: ()=>{
                if (nextStep == null) return;
                onStepChange((0, $f114897171fbb236$var$_extends2.default)({}, parametersBis, {
                    step: nextStep
                }));
            },
            areViewsInSameStep: (viewA, viewB)=>{
                const stepA = steps.find((step)=>isViewMatchingStep(viewA, step));
                const stepB = steps.find((step)=>isViewMatchingStep(viewB, step));
                return stepA === stepB;
            }
        };
    };
}

});


parcelRegister("dAsZ9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersCalendarHeader", {
    enumerable: true,
    get: function() {
        return $91SiU.PickersCalendarHeader;
    }
});
Object.defineProperty(module.exports, "pickersCalendarHeaderClasses", {
    enumerable: true,
    get: function() {
        return $1YeNp.pickersCalendarHeaderClasses;
    }
});

var $1YeNp = parcelRequire("1YeNp");

var $91SiU = parcelRequire("91SiU");

});
parcelRegister("1YeNp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $16f6df38d2155e06$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pickersCalendarHeaderClasses = module.exports.getPickersCalendarHeaderUtilityClass = void 0;

var $16f6df38d2155e06$var$_generateUtilityClass = $16f6df38d2155e06$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $16f6df38d2155e06$var$_generateUtilityClasses = $16f6df38d2155e06$require$_interopRequireDefault((parcelRequire("fXRFb")));
const $16f6df38d2155e06$var$getPickersCalendarHeaderUtilityClass = (slot)=>(0, $16f6df38d2155e06$var$_generateUtilityClass.default)('MuiPickersCalendarHeader', slot);
module.exports.getPickersCalendarHeaderUtilityClass = $16f6df38d2155e06$var$getPickersCalendarHeaderUtilityClass;
const $16f6df38d2155e06$var$pickersCalendarHeaderClasses = module.exports.pickersCalendarHeaderClasses = (0, $16f6df38d2155e06$var$_generateUtilityClasses.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);

});

parcelRegister("91SiU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $692e54af110ba23d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $692e54af110ba23d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersCalendarHeader = void 0;

var $692e54af110ba23d$var$_objectWithoutPropertiesLoose2 = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("c05no")));

var $692e54af110ba23d$var$_extends2 = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $692e54af110ba23d$var$React = $692e54af110ba23d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $692e54af110ba23d$var$_propTypes = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $692e54af110ba23d$var$_clsx = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $692e54af110ba23d$var$_Fade = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $692e54af110ba23d$var$_useSlotProps2 = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $692e54af110ba23d$var$_composeClasses = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $692e54af110ba23d$var$_IconButton = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("825Zh")));

var $BKARN = parcelRequire("BKARN");

var $eW408 = parcelRequire("eW408");

var $1SVAo = parcelRequire("1SVAo");

var $ecN6O = parcelRequire("ecN6O");

var $lfVfV = parcelRequire("lfVfV");

var $1YeNp = parcelRequire("1YeNp");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $692e54af110ba23d$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "classes",
    "timezone",
    "format"
], $692e54af110ba23d$var$_excluded2 = [
    "ownerState"
];
const $692e54af110ba23d$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $692e54af110ba23d$var$_composeClasses.default)(slots, $1YeNp.getPickersCalendarHeaderUtilityClass, classes);
};
const $692e54af110ba23d$var$PickersCalendarHeaderRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root'
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $692e54af110ba23d$var$PickersCalendarHeaderLabelContainer = (0, $d8seH.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer'
})(({ theme: theme })=>(0, $692e54af110ba23d$var$_extends2.default)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $692e54af110ba23d$var$PickersCalendarHeaderLabel = (0, $d8seH.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label'
})({
    marginRight: 6
});
const $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewButton = (0, $d8seH.default)($692e54af110ba23d$var$_IconButton.default, {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton'
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${$1YeNp.pickersCalendarHeaderClasses.switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewIcon = (0, $d8seH.default)($1SVAo.ArrowDropDownIcon, {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon'
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $692e54af110ba23d$var$PickersCalendarHeader = module.exports.PickersCalendarHeader = /*#__PURE__*/ $692e54af110ba23d$var$React.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $BKARN.usePickerTranslations)();
    const adapter = (0, $BKARN.usePickerAdapter)();
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, classes: classesProp, timezone: timezone, format: format = `${adapter.formats.month} ${adapter.formats.year}` } = props, other = (0, $692e54af110ba23d$var$_objectWithoutPropertiesLoose2.default)(props, $692e54af110ba23d$var$_excluded);
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const classes = $692e54af110ba23d$var$useUtilityClasses(classesProp);
    const SwitchViewButton = slots?.switchViewButton ?? $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $692e54af110ba23d$var$_useSlotProps2.default)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: (0, $692e54af110ba23d$var$_extends2.default)({}, ownerState, {
            view: view
        }),
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $692e54af110ba23d$var$_useSlotProps2.default)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $692e54af110ba23d$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $692e54af110ba23d$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(adapter.addMonths(month, 1));
    const selectPreviousMonth = ()=>onMonthChange(adapter.addMonths(month, -1));
    const isNextMonthDisabled = (0, $lfVfV.useNextMonthDisabled)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $lfVfV.usePreviousMonthDisabled)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = adapter.formatByString(month, format);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($692e54af110ba23d$var$PickersCalendarHeaderRoot, (0, $692e54af110ba23d$var$_extends2.default)({}, other, {
        ownerState: ownerState,
        className: (0, $692e54af110ba23d$var$_clsx.default)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($692e54af110ba23d$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($eW408.PickersFadeTransitionGroup, {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($692e54af110ba23d$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $ayMG0.jsx)(SwitchViewButton, (0, $692e54af110ba23d$var$_extends2.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(SwitchViewIcon, (0, $692e54af110ba23d$var$_extends2.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($692e54af110ba23d$var$_Fade.default, {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ecN6O.PickersArrowSwitcher, {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});

});
parcelRegister("ecN6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersArrowSwitcher", {
    enumerable: true,
    get: function() {
        return $b1I5K.PickersArrowSwitcher;
    }
});
Object.defineProperty(module.exports, "getPickersArrowSwitcherUtilityClass", {
    enumerable: true,
    get: function() {
        return $7cGQb.getPickersArrowSwitcherUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersArrowSwitcherClasses", {
    enumerable: true,
    get: function() {
        return $7cGQb.pickersArrowSwitcherClasses;
    }
});

var $b1I5K = parcelRequire("b1I5K");

var $7cGQb = parcelRequire("7cGQb");

});
parcelRegister("b1I5K", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8071fd6781eab512$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8071fd6781eab512$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersArrowSwitcher = void 0;

var $8071fd6781eab512$var$_extends2 = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8071fd6781eab512$var$_objectWithoutPropertiesLoose2 = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("c05no")));

var $8071fd6781eab512$var$React = $8071fd6781eab512$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8071fd6781eab512$var$_clsx = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8071fd6781eab512$var$_Typography = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $9uEev = parcelRequire("9uEev");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $8071fd6781eab512$var$_composeClasses = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $8071fd6781eab512$var$_useSlotProps3 = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $8071fd6781eab512$var$_IconButton = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("825Zh")));

var $1SVAo = parcelRequire("1SVAo");

var $7cGQb = parcelRequire("7cGQb");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $8071fd6781eab512$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId",
    "classes"
], $8071fd6781eab512$var$_excluded2 = [
    "ownerState"
], $8071fd6781eab512$var$_excluded3 = [
    "ownerState"
];
const $8071fd6781eab512$var$PickersArrowSwitcherRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root'
})({
    display: 'flex'
});
const $8071fd6781eab512$var$PickersArrowSwitcherSpacer = (0, $d8seH.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer'
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $8071fd6781eab512$var$PickersArrowSwitcherButton = (0, $d8seH.default)($8071fd6781eab512$var$_IconButton.default, {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button'
})({
    variants: [
        {
            props: {
                isButtonHidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const $8071fd6781eab512$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, $8071fd6781eab512$var$_composeClasses.default)(slots, $7cGQb.getPickersArrowSwitcherUtilityClass, classes);
};
const $8071fd6781eab512$var$PickersArrowSwitcher = module.exports.PickersArrowSwitcher = /*#__PURE__*/ $8071fd6781eab512$var$React.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $9uEev.useRtl)();
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId, classes: classesProp } = props, other = (0, $8071fd6781eab512$var$_objectWithoutPropertiesLoose2.default)(props, $8071fd6781eab512$var$_excluded);
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const classes = $8071fd6781eab512$var$useUtilityClasses(classesProp);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $8071fd6781eab512$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $8071fd6781eab512$var$_useSlotProps3.default)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $8071fd6781eab512$var$_extends2.default)({}, ownerState, {
            isButtonHidden: previousProps.isHidden ?? false
        }),
        className: (0, $8071fd6781eab512$var$_clsx.default)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? $8071fd6781eab512$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $8071fd6781eab512$var$_useSlotProps3.default)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $8071fd6781eab512$var$_extends2.default)({}, ownerState, {
            isButtonHidden: nextProps.isHidden ?? false
        }),
        className: (0, $8071fd6781eab512$var$_clsx.default)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? $1SVAo.ArrowLeftIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $8071fd6781eab512$var$_useSlotProps3.default)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $8071fd6781eab512$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $8071fd6781eab512$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? $1SVAo.ArrowRightIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $8071fd6781eab512$var$_useSlotProps3.default)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $8071fd6781eab512$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps2, $8071fd6781eab512$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8071fd6781eab512$var$PickersArrowSwitcherRoot, (0, $8071fd6781eab512$var$_extends2.default)({
        ref: ref,
        className: (0, $8071fd6781eab512$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousIconButton, (0, $8071fd6781eab512$var$_extends2.default)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(RightArrowIcon, (0, $8071fd6781eab512$var$_extends2.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(LeftArrowIcon, (0, $8071fd6781eab512$var$_extends2.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $ayMG0.jsx)($8071fd6781eab512$var$_Typography.default, {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($8071fd6781eab512$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextIconButton, (0, $8071fd6781eab512$var$_extends2.default)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LeftArrowIcon, (0, $8071fd6781eab512$var$_extends2.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(RightArrowIcon, (0, $8071fd6781eab512$var$_extends2.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});

});
parcelRegister("7cGQb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $015a7f86ee044f5d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersArrowSwitcherUtilityClass = $015a7f86ee044f5d$var$getPickersArrowSwitcherUtilityClass;
module.exports.pickersArrowSwitcherClasses = void 0;

var $015a7f86ee044f5d$var$_generateUtilityClass = $015a7f86ee044f5d$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $015a7f86ee044f5d$var$_generateUtilityClasses = $015a7f86ee044f5d$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $015a7f86ee044f5d$var$getPickersArrowSwitcherUtilityClass(slot) {
    return (0, $015a7f86ee044f5d$var$_generateUtilityClass.default)('MuiPickersArrowSwitcher', slot);
}
const $015a7f86ee044f5d$var$pickersArrowSwitcherClasses = module.exports.pickersArrowSwitcherClasses = (0, $015a7f86ee044f5d$var$_generateUtilityClasses.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);

});





parcelRegister("fQ7ML", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickerViewRoot", {
    enumerable: true,
    get: function() {
        return $ghKQ9.PickerViewRoot;
    }
});

var $ghKQ9 = parcelRequire("ghKQ9");

});
parcelRegister("ghKQ9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerViewRoot = void 0;

var $d8seH = parcelRequire("d8seH");

var $99eO4 = parcelRequire("99eO4");
const $bdb2915bd58d0724$var$PickerViewRoot = module.exports.PickerViewRoot = (0, $d8seH.default)('div')({
    overflow: 'hidden',
    width: $99eO4.DIALOG_WIDTH,
    maxHeight: $99eO4.VIEW_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});

});


parcelRegister("4eUCS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $316464f7737d959f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slowAnimationDevices = void 0;
module.exports.useReduceAnimations = $316464f7737d959f$var$useReduceAnimations;

var $316464f7737d959f$var$_useMediaQuery = $316464f7737d959f$require$_interopRequireDefault((parcelRequire("18tt9")));
const $316464f7737d959f$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $316464f7737d959f$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $316464f7737d959f$var$androidVersion = $316464f7737d959f$var$mobileVersionMatches && $316464f7737d959f$var$mobileVersionMatches[1] ? parseInt($316464f7737d959f$var$mobileVersionMatches[1], 10) : null;
const $316464f7737d959f$var$iOSVersion = $316464f7737d959f$var$mobileVersionMatches && $316464f7737d959f$var$mobileVersionMatches[2] ? parseInt($316464f7737d959f$var$mobileVersionMatches[2], 10) : null;
const $316464f7737d959f$var$slowAnimationDevices = module.exports.slowAnimationDevices = $316464f7737d959f$var$androidVersion && $316464f7737d959f$var$androidVersion < 10 || $316464f7737d959f$var$iOSVersion && $316464f7737d959f$var$iOSVersion < 13 || false;
function $316464f7737d959f$var$useReduceAnimations(customReduceAnimations) {
    const prefersReduced = (0, $316464f7737d959f$var$_useMediaQuery.default)($316464f7737d959f$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    if (customReduceAnimations != null) return customReduceAnimations;
    return prefersReduced || $316464f7737d959f$var$slowAnimationDevices;
}

});

parcelRegister("e7rSK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a47758ea7aed0899$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDateCalendarUtilityClass = module.exports.dateCalendarClasses = void 0;

var $a47758ea7aed0899$var$_generateUtilityClass = $a47758ea7aed0899$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $a47758ea7aed0899$var$_generateUtilityClasses = $a47758ea7aed0899$require$_interopRequireDefault((parcelRequire("fXRFb")));
const $a47758ea7aed0899$var$getDateCalendarUtilityClass = (slot)=>(0, $a47758ea7aed0899$var$_generateUtilityClass.default)('MuiDateCalendar', slot);
module.exports.getDateCalendarUtilityClass = $a47758ea7aed0899$var$getDateCalendarUtilityClass;
const $a47758ea7aed0899$var$dateCalendarClasses = module.exports.dateCalendarClasses = (0, $a47758ea7aed0899$var$_generateUtilityClasses.default)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);

});




parcelRegister("1hdeH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useDesktopPicker", {
    enumerable: true,
    get: function() {
        return $6cF6o.useDesktopPicker;
    }
});

var $6cF6o = parcelRequire("6cF6o");

});
parcelRegister("6cF6o", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4843bf1c616982ea$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4843bf1c616982ea$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDesktopPicker = void 0;

var $4843bf1c616982ea$var$_extends2 = $4843bf1c616982ea$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4843bf1c616982ea$var$_objectWithoutPropertiesLoose2 = $4843bf1c616982ea$require$_interopRequireDefault((parcelRequire("c05no")));

var $4843bf1c616982ea$var$React = $4843bf1c616982ea$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4843bf1c616982ea$var$_useSlotProps2 = $4843bf1c616982ea$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $c2l6h = parcelRequire("c2l6h");

var $hz59J = parcelRequire("hz59J");

var $g0CIC = parcelRequire("g0CIC");

var $jk6Bf = parcelRequire("jk6Bf");

var $w6zXP = parcelRequire("w6zXP");

var $a2Tw3 = parcelRequire("a2Tw3");

var $ayMG0 = parcelRequire("ayMG0");
const $4843bf1c616982ea$var$_excluded = [
    "props",
    "steps"
], $4843bf1c616982ea$var$_excluded2 = [
    "ownerState"
];
/**
 * Hook managing all the single-date desktop pickers:
 * - DesktopDatePicker
 * - DesktopDateTimePicker
 * - DesktopTimePicker
 */ const $4843bf1c616982ea$var$useDesktopPicker = (_ref)=>{
    let { props: props, steps: steps } = _ref, pickerParams = (0, $4843bf1c616982ea$var$_objectWithoutPropertiesLoose2.default)(_ref, $4843bf1c616982ea$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $a2Tw3.createNonRangePickerStepNavigation)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $hz59J.usePicker)((0, $4843bf1c616982ea$var$_extends2.default)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'desktop',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, $4843bf1c616982ea$var$_useSlotProps2.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $4843bf1c616982ea$var$_extends2.default)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $4843bf1c616982ea$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $4843bf1c616982ea$var$_excluded2);
    const Layout = slots.layout ?? $g0CIC.PickersLayout;
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $4843bf1c616982ea$var$_extends2.default)({}, innerSlotProps, {
        toolbar: (0, $4843bf1c616982ea$var$_extends2.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, $4843bf1c616982ea$var$_extends2.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($jk6Bf.PickerProvider, (0, $4843bf1c616982ea$var$_extends2.default)({}, providerProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($w6zXP.PickerFieldUIContextProvider, {
                slots: slots,
                slotProps: slotProps,
                inputRef: inputRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Field, (0, $4843bf1c616982ea$var$_extends2.default)({}, fieldProps)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c2l6h.PickerPopper, {
                        slots: slots,
                        slotProps: slotProps,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Layout, (0, $4843bf1c616982ea$var$_extends2.default)({}, slotProps?.layout, {
                            slots: slots,
                            slotProps: slotProps,
                            children: renderCurrentView()
                        }))
                    })
                ]
            })
        }));
    return {
        renderPicker: renderPicker
    };
};
module.exports.useDesktopPicker = $4843bf1c616982ea$var$useDesktopPicker;

});
parcelRegister("c2l6h", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8c3609ff821a7fc9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8c3609ff821a7fc9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerPopper = $8c3609ff821a7fc9$var$PickerPopper;

var $8c3609ff821a7fc9$var$_extends2 = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8c3609ff821a7fc9$var$_objectWithoutPropertiesLoose2 = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("c05no")));

var $8c3609ff821a7fc9$var$React = $8c3609ff821a7fc9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8c3609ff821a7fc9$var$_useSlotProps = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $8c3609ff821a7fc9$var$_Grow = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $8c3609ff821a7fc9$var$_Fade = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $8c3609ff821a7fc9$var$_Paper = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $8c3609ff821a7fc9$var$_Popper = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("eWJe7")));

var $8c3609ff821a7fc9$var$_Unstable_TrapFocus = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("c94Y8")));

var $8c3609ff821a7fc9$var$_useForkRef = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("88PIk")));

var $8c3609ff821a7fc9$var$_useEventCallback = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $8c3609ff821a7fc9$var$_ownerDocument = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("lznhl")));

var $8c3609ff821a7fc9$var$_composeClasses = $8c3609ff821a7fc9$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $eTeuS = parcelRequire("eTeuS");

var $l16rr = parcelRequire("l16rr");

var $7OOd8 = parcelRequire("7OOd8");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $8c3609ff821a7fc9$var$_excluded = [
    "PaperComponent",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $8c3609ff821a7fc9$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8c3609ff821a7fc9$var$_composeClasses.default)(slots, $eTeuS.getPickerPopperUtilityClass, classes);
};
const $8c3609ff821a7fc9$var$PickerPopperRoot = (0, $d8seH.default)($8c3609ff821a7fc9$var$_Popper.default, {
    name: 'MuiPickerPopper',
    slot: 'Root'
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $8c3609ff821a7fc9$var$PickerPopperPaper = (0, $d8seH.default)($8c3609ff821a7fc9$var$_Paper.default, {
    name: 'MuiPickerPopper',
    slot: 'Paper'
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ popperPlacement: popperPlacement })=>new Set([
                    'top',
                    'top-start',
                    'top-end'
                ]).has(popperPlacement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function $8c3609ff821a7fc9$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $8c3609ff821a7fc9$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $8c3609ff821a7fc9$var$React.useRef(false);
    const syntheticEventRef = $8c3609ff821a7fc9$var$React.useRef(false);
    const nodeRef = $8c3609ff821a7fc9$var$React.useRef(null);
    const activatedRef = $8c3609ff821a7fc9$var$React.useRef(false);
    $8c3609ff821a7fc9$var$React.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $8c3609ff821a7fc9$var$_useEventCallback.default)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $8c3609ff821a7fc9$var$_ownerDocument.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $8c3609ff821a7fc9$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = (event)=>{
        // Ignore events handled by our internal components
        if (!event.defaultMuiPrevented) syntheticEventRef.current = true;
    };
    $8c3609ff821a7fc9$var$React.useEffect(()=>{
        if (active) {
            const doc = (0, $8c3609ff821a7fc9$var$_ownerDocument.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $8c3609ff821a7fc9$var$React.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $8c3609ff821a7fc9$var$_ownerDocument.default)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $8c3609ff821a7fc9$var$PickerPopperPaperWrapper = /*#__PURE__*/ $8c3609ff821a7fc9$var$React.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, ownerState: ownerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $8c3609ff821a7fc9$var$_objectWithoutPropertiesLoose2.default)(props, $8c3609ff821a7fc9$var$_excluded);
    const paperProps = (0, $8c3609ff821a7fc9$var$_useSlotProps.default)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(PaperComponent, (0, $8c3609ff821a7fc9$var$_extends2.default)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $8c3609ff821a7fc9$var$PickerPopper(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickerPopper'
    });
    const { children: children, placement: placement = 'bottom-start', slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const { open: open, popupRef: popupRef, reduceAnimations: reduceAnimations } = (0, $BKARN.usePickerContext)();
    const { ownerState: pickerOwnerState, rootRefObject: rootRefObject } = (0, $7OOd8.usePickerPrivateContext)();
    const { dismissViews: dismissViews, getCurrentViewMode: getCurrentViewMode, onPopperExited: onPopperExited, triggerElement: triggerElement, viewContainerRole: viewContainerRole } = (0, $7OOd8.usePickerPrivateContext)();
    $8c3609ff821a7fc9$var$React.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === 'Escape') dismissViews();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        dismissViews,
        open
    ]);
    const lastFocusedElementRef = $8c3609ff821a7fc9$var$React.useRef(null);
    $8c3609ff821a7fc9$var$React.useEffect(()=>{
        if (viewContainerRole === 'tooltip' || getCurrentViewMode() === 'field') return;
        if (open) lastFocusedElementRef.current = (0, $l16rr.getActiveElement)(rootRefObject.current);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        viewContainerRole,
        getCurrentViewMode,
        rootRefObject
    ]);
    const classes = $8c3609ff821a7fc9$var$useUtilityClasses(classesProp);
    const handleClickAway = (0, $8c3609ff821a7fc9$var$_useEventCallback.default)(()=>{
        if (viewContainerRole === 'tooltip') (0, $l16rr.executeInTheNextEventLoopTick)(()=>{
            if (rootRefObject.current?.contains((0, $l16rr.getActiveElement)(rootRefObject.current)) || popupRef.current?.contains((0, $l16rr.getActiveElement)(popupRef.current))) return;
            dismissViews();
        });
        else dismissViews();
    });
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $8c3609ff821a7fc9$var$useClickAwayListener(open, handleClickAway);
    const paperRef = $8c3609ff821a7fc9$var$React.useRef(null);
    const handleRef = (0, $8c3609ff821a7fc9$var$_useForkRef.default)(paperRef, popupRef);
    const handlePaperRef = (0, $8c3609ff821a7fc9$var$_useForkRef.default)(handleRef, clickAwayRef);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            dismissViews();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? $8c3609ff821a7fc9$var$_Fade.default : $8c3609ff821a7fc9$var$_Grow.default;
    const FocusTrap = slots?.desktopTrapFocus ?? $8c3609ff821a7fc9$var$_Unstable_TrapFocus.default;
    const Paper = slots?.desktopPaper ?? $8c3609ff821a7fc9$var$PickerPopperPaper;
    const Popper = slots?.popper ?? $8c3609ff821a7fc9$var$PickerPopperRoot;
    const popperProps = (0, $8c3609ff821a7fc9$var$_useSlotProps.default)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: viewContainerRole == null ? undefined : viewContainerRole,
            open: open,
            placement: placement,
            anchorEl: triggerElement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: pickerOwnerState
    });
    const ownerState = $8c3609ff821a7fc9$var$React.useMemo(()=>(0, $8c3609ff821a7fc9$var$_extends2.default)({}, pickerOwnerState, {
            popperPlacement: popperProps.placement
        }), [
        pickerOwnerState,
        popperProps.placement
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Popper, (0, $8c3609ff821a7fc9$var$_extends2.default)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)(FocusTrap, (0, $8c3609ff821a7fc9$var$_extends2.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: viewContainerRole === 'tooltip',
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Transition, (0, $8c3609ff821a7fc9$var$_extends2.default)({}, TransitionProps, slotProps?.desktopTransition, {
                    onExited: (event)=>{
                        onPopperExited?.();
                        slotProps?.desktopTransition?.onExited?.(event);
                        TransitionProps?.onExited?.();
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($8c3609ff821a7fc9$var$PickerPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}

});
parcelRegister("6dJ4n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("iscuz")).default);

var $iscuz = parcelRequire("iscuz");

});

parcelRegister("juRJQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7Frhn")).default);
$parcel$export(module.exports, "paperClasses", () => (parcelRequire("6LfkK")).default);

var $7Frhn = parcelRequire("7Frhn");

var $6LfkK = parcelRequire("6LfkK");
$parcel$exportWildcard(module.exports, $6LfkK);

});

parcelRegister("eWJe7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("e76iu")).default);

var $e76iu = parcelRequire("e76iu");

var $g3XLf = parcelRequire("g3XLf");
$parcel$exportWildcard(module.exports, $g3XLf);

});

parcelRegister("c94Y8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("kRwxQ")).default);

var $kRwxQ = parcelRequire("kRwxQ");

});

parcelRegister("eTeuS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ad71728c8716bbc2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickerPopperUtilityClass = $ad71728c8716bbc2$var$getPickerPopperUtilityClass;
module.exports.pickerPopperClasses = void 0;

var $ad71728c8716bbc2$var$_generateUtilityClass = $ad71728c8716bbc2$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $ad71728c8716bbc2$var$_generateUtilityClasses = $ad71728c8716bbc2$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $ad71728c8716bbc2$var$getPickerPopperUtilityClass(slot) {
    return (0, $ad71728c8716bbc2$var$_generateUtilityClass.default)('MuiPickerPopper', slot);
}
const $ad71728c8716bbc2$var$pickerPopperClasses = module.exports.pickerPopperClasses = (0, $ad71728c8716bbc2$var$_generateUtilityClasses.default)('MuiPickerPopper', [
    'root',
    'paper'
]);

});


parcelRegister("hz59J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "usePicker", {
    enumerable: true,
    get: function() {
        return $9QI1Q.usePicker;
    }
});

var $9QI1Q = parcelRequire("9QI1Q");

});
parcelRegister("9QI1Q", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $72bb1f98949e4fd5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $72bb1f98949e4fd5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePicker = void 0;

var $72bb1f98949e4fd5$var$_extends2 = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $72bb1f98949e4fd5$var$_objectWithoutPropertiesLoose2 = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("c05no")));

var $72bb1f98949e4fd5$var$React = $72bb1f98949e4fd5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $72bb1f98949e4fd5$var$_useEnhancedEffect = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $72bb1f98949e4fd5$var$_useEventCallback = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $72bb1f98949e4fd5$var$_useForkRef = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("88PIk")));

var $72bb1f98949e4fd5$var$_useId = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("5Db2s")));

var $3nE24 = parcelRequire("3nE24");

var $4eUCS = parcelRequire("4eUCS");

var $cElCc = parcelRequire("cElCc");

var $3cW2G = parcelRequire("3cW2G");

var $9iyk0 = parcelRequire("9iyk0");

var $kZzZK = parcelRequire("kZzZK");

var $ayMG0 = parcelRequire("ayMG0");
const $72bb1f98949e4fd5$var$_excluded = [
    "className",
    "sx"
];
const $72bb1f98949e4fd5$var$usePicker = ({ ref: ref, props: props, valueManager: valueManager, valueType: valueType, variant: variant, validator: validator, onPopperExited: onPopperExited, autoFocusView: autoFocusView, rendererInterceptor: RendererInterceptor, localeText: localeText, viewContainerRole: viewContainerRole, getStepNavigation: getStepNavigation })=>{
    const { views: // View props
    views, view: viewProp, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, reduceAnimations: reduceAnimationsProp, orientation: orientationProp, disableOpenPicker: disableOpenPicker, closeOnSelect: closeOnSelect, disabled: // Form props
    disabled, readOnly: readOnly, formatDensity: // Field props
    formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, format: format, label: label, autoFocus: // Other props
    autoFocus, name: name } = props;
    const { className: className, sx: sx } = props, propsToForwardToView = (0, $72bb1f98949e4fd5$var$_objectWithoutPropertiesLoose2.default)(props, $72bb1f98949e4fd5$var$_excluded);
    /**
   * TODO: Improve how we generate the aria-label and aria-labelledby attributes.
   */ const labelId = (0, $72bb1f98949e4fd5$var$_useId.default)();
    const adapter = (0, $3nE24.usePickerAdapter)();
    const reduceAnimations = (0, $4eUCS.useReduceAnimations)(reduceAnimationsProp);
    const orientation = (0, $9iyk0.useOrientation)(views, orientationProp);
    const { current: initialView } = $72bb1f98949e4fd5$var$React.useRef(openTo ?? null);
    /**
   * Refs
   */ const [triggerElement, triggerRef] = $72bb1f98949e4fd5$var$React.useState(null);
    const popupRef = $72bb1f98949e4fd5$var$React.useRef(null);
    const fieldRef = $72bb1f98949e4fd5$var$React.useRef(null);
    const rootRefObject = $72bb1f98949e4fd5$var$React.useRef(null);
    const rootRef = (0, $72bb1f98949e4fd5$var$_useForkRef.default)(ref, rootRefObject);
    const { timezone: timezone, state: state, setOpen: setOpen, setValue: setValue, setValueFromView: setValueFromView, value: value, viewValue: viewValue } = (0, $kZzZK.useValueAndOpenStates)({
        props: props,
        valueManager: valueManager,
        validator: validator
    });
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView, goToNextStep: goToNextStep, hasNextStep: hasNextStep, hasSeveralSteps: hasSeveralSteps } = (0, $3cW2G.useViews)({
        view: viewProp,
        views: views,
        openTo: openTo,
        onChange: setValueFromView,
        onViewChange: onViewChange,
        autoFocus: autoFocusView,
        getStepNavigation: getStepNavigation
    });
    const clearValue = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>setValue(valueManager.emptyValue));
    const setValueToToday = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>setValue(valueManager.getTodayValue(adapter, timezone, valueType)));
    const acceptValueChanges = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>setValue(value));
    const cancelValueChanges = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>setValue(state.lastCommittedValue, {
            skipPublicationIfPristine: true
        }));
    const dismissViews = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>{
        setValue(value, {
            skipPublicationIfPristine: true
        });
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup, timeViewsCount: timeViewsCount } = $72bb1f98949e4fd5$var$React.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            const viewMode = viewRenderers[viewForReduce] == null ? 'field' : 'UI';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') {
                acc.hasUIView = true;
                if ((0, $cElCc.isTimeView)(viewForReduce)) acc.timeViewsCount += 1;
            }
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {},
            timeViewsCount: 0
        }), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const getCurrentViewMode = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>currentViewMode);
    const [popperView, setPopperView] = $72bb1f98949e4fd5$var$React.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $72bb1f98949e4fd5$var$_useEnhancedEffect.default)(()=>{
        // Handle case of Date Time Picker without time renderers
        if (currentViewMode === 'field' && state.open) {
            setOpen(false);
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $72bb1f98949e4fd5$var$_useEnhancedEffect.default)(()=>{
        if (!state.open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        state.open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const ownerState = $72bb1f98949e4fd5$var$React.useMemo(()=>({
            isPickerValueEmpty: valueManager.areValuesEqual(adapter, value, valueManager.emptyValue),
            isPickerOpen: state.open,
            isPickerDisabled: props.disabled ?? false,
            isPickerReadOnly: props.readOnly ?? false,
            pickerOrientation: orientation,
            pickerVariant: variant
        }), [
        adapter,
        valueManager,
        value,
        state.open,
        orientation,
        variant,
        props.disabled,
        props.readOnly
    ]);
    const triggerStatus = $72bb1f98949e4fd5$var$React.useMemo(()=>{
        if (disableOpenPicker || !hasUIView) return 'hidden';
        if (disabled || readOnly) return 'disabled';
        return 'enabled';
    }, [
        disableOpenPicker,
        hasUIView,
        disabled,
        readOnly
    ]);
    const wrappedGoToNextStep = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(goToNextStep);
    const defaultActionBarActions = $72bb1f98949e4fd5$var$React.useMemo(()=>{
        if (closeOnSelect && !hasSeveralSteps) return [];
        return [
            'cancel',
            'nextOrAccept'
        ];
    }, [
        closeOnSelect,
        hasSeveralSteps
    ]);
    const actionsContextValue = $72bb1f98949e4fd5$var$React.useMemo(()=>({
            setValue: setValue,
            setOpen: setOpen,
            clearValue: clearValue,
            setValueToToday: setValueToToday,
            acceptValueChanges: acceptValueChanges,
            cancelValueChanges: cancelValueChanges,
            setView: setView,
            goToNextStep: wrappedGoToNextStep
        }), [
        setValue,
        setOpen,
        clearValue,
        setValueToToday,
        acceptValueChanges,
        cancelValueChanges,
        setView,
        wrappedGoToNextStep
    ]);
    const contextValue = $72bb1f98949e4fd5$var$React.useMemo(()=>(0, $72bb1f98949e4fd5$var$_extends2.default)({}, actionsContextValue, {
            value: value,
            timezone: timezone,
            open: state.open,
            views: views,
            view: popperView,
            initialView: initialView,
            disabled: disabled ?? false,
            readOnly: readOnly ?? false,
            autoFocus: autoFocus ?? false,
            variant: variant,
            orientation: orientation,
            popupRef: popupRef,
            reduceAnimations: reduceAnimations,
            triggerRef: triggerRef,
            triggerStatus: triggerStatus,
            hasNextStep: hasNextStep,
            fieldFormat: format ?? '',
            name: name,
            label: label,
            rootSx: sx,
            rootRef: rootRef,
            rootClassName: className
        }), [
        actionsContextValue,
        value,
        rootRef,
        variant,
        orientation,
        reduceAnimations,
        disabled,
        readOnly,
        format,
        className,
        name,
        label,
        sx,
        triggerStatus,
        hasNextStep,
        timezone,
        state.open,
        popperView,
        views,
        initialView,
        autoFocus
    ]);
    const privateContextValue = $72bb1f98949e4fd5$var$React.useMemo(()=>({
            dismissViews: dismissViews,
            ownerState: ownerState,
            hasUIView: hasUIView,
            getCurrentViewMode: getCurrentViewMode,
            rootRefObject: rootRefObject,
            labelId: labelId,
            triggerElement: triggerElement,
            viewContainerRole: viewContainerRole,
            defaultActionBarActions: defaultActionBarActions,
            onPopperExited: onPopperExited
        }), [
        dismissViews,
        ownerState,
        hasUIView,
        getCurrentViewMode,
        labelId,
        triggerElement,
        viewContainerRole,
        defaultActionBarActions,
        onPopperExited
    ]);
    const fieldPrivateContextValue = $72bb1f98949e4fd5$var$React.useMemo(()=>({
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            fieldRef: fieldRef
        }), [
        formatDensity,
        enableAccessibleFieldDOMStructure,
        selectedSections,
        onSelectedSectionsChange,
        fieldRef
    ]);
    const isValidContextValue = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const renderCurrentView = ()=>{
        if (popperView == null) return null;
        const renderer = viewRenderers[popperView];
        if (renderer == null) return null;
        const rendererProps = (0, $72bb1f98949e4fd5$var$_extends2.default)({}, propsToForwardToView, {
            views: views,
            timezone: timezone,
            value: viewValue,
            onChange: setValueAndGoToNextView,
            view: popperView,
            onViewChange: setView,
            showViewSwitcher: timeViewsCount > 1,
            timeViewsCount: timeViewsCount
        }, viewContainerRole === 'tooltip' ? {
            focusedView: null,
            onFocusedViewChange: ()=>{}
        } : {
            focusedView: focusedView,
            onFocusedViewChange: setFocusedView
        });
        if (RendererInterceptor) return /*#__PURE__*/ (0, $ayMG0.jsx)(RendererInterceptor, {
            viewRenderers: viewRenderers,
            popperView: popperView,
            rendererProps: rendererProps
        });
        return renderer(rendererProps);
    };
    return {
        providerProps: {
            localeText: localeText,
            contextValue: contextValue,
            privateContextValue: privateContextValue,
            actionsContextValue: actionsContextValue,
            fieldPrivateContextValue: fieldPrivateContextValue,
            isValidContextValue: isValidContextValue
        },
        renderCurrentView: renderCurrentView,
        ownerState: ownerState
    };
};
module.exports.usePicker = $72bb1f98949e4fd5$var$usePicker;

});
parcelRegister("9iyk0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6c506b1759d68a5d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6c506b1759d68a5d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOrientation = $6c506b1759d68a5d$var$useOrientation;

var $6c506b1759d68a5d$var$React = $6c506b1759d68a5d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6c506b1759d68a5d$var$_useEnhancedEffect = $6c506b1759d68a5d$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $l16rr = parcelRequire("l16rr");
function $6c506b1759d68a5d$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
function $6c506b1759d68a5d$var$useOrientation(views, customOrientation) {
    const [orientation, setOrientation] = $6c506b1759d68a5d$var$React.useState($6c506b1759d68a5d$var$getOrientation);
    (0, $6c506b1759d68a5d$var$_useEnhancedEffect.default)(()=>{
        const eventHandler = ()=>{
            setOrientation($6c506b1759d68a5d$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $l16rr.arrayIncludes)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return 'portrait';
    return customOrientation ?? orientation;
}

});

parcelRegister("kZzZK", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f4856cf9dd817ed8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f4856cf9dd817ed8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useValueAndOpenStates = $f4856cf9dd817ed8$var$useValueAndOpenStates;

var $f4856cf9dd817ed8$var$_extends2 = $f4856cf9dd817ed8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f4856cf9dd817ed8$var$React = $f4856cf9dd817ed8$require$_interopRequireWildcard((parcelRequire("acw62")));


var $f4856cf9dd817ed8$var$_useEventCallback = $f4856cf9dd817ed8$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $hagTn = parcelRequire("hagTn");

var $3nE24 = parcelRequire("3nE24");

var $5UoGz = parcelRequire("5UoGz");
function $f4856cf9dd817ed8$var$useValueAndOpenStates(parameters) {
    const { props: props, valueManager: valueManager, validator: validator } = parameters;
    const { value: valueProp, defaultValue: defaultValueProp, onChange: onChange, referenceDate: referenceDate, timezone: timezoneProp, onAccept: onAccept, closeOnSelect: closeOnSelect, open: openProp, onOpen: onOpen, onClose: onClose } = props;
    const { current: defaultValue } = $f4856cf9dd817ed8$var$React.useRef(defaultValueProp);
    const { current: isValueControlled } = $f4856cf9dd817ed8$var$React.useRef(valueProp !== undefined);
    const { current: isOpenControlled } = $f4856cf9dd817ed8$var$React.useRef(openProp !== undefined);
    const adapter = (0, $3nE24.usePickerAdapter)();
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const { timezone: timezone, value: value, handleValueChange: handleValueChange } = (0, $hagTn.useControlledValue)({
        name: 'a picker component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
    const [state, setState] = $f4856cf9dd817ed8$var$React.useState(()=>({
            open: false,
            lastExternalValue: value,
            clockShallowValue: undefined,
            lastCommittedValue: value,
            hasBeenModifiedSinceMount: false
        }));
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $5UoGz.useValidation)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: props.onError
    });
    const setOpen = (0, $f4856cf9dd817ed8$var$_useEventCallback.default)((action)=>{
        const newOpen = typeof action === 'function' ? action(state.open) : action;
        if (!isOpenControlled) setState((prevState)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prevState, {
                open: newOpen
            }));
        if (newOpen && onOpen) onOpen();
        if (!newOpen) onClose?.();
    });
    const setValue = (0, $f4856cf9dd817ed8$var$_useEventCallback.default)((newValue, options)=>{
        const { changeImportance: changeImportance = 'accept', skipPublicationIfPristine: skipPublicationIfPristine = false, validationError: validationError, shortcut: shortcut, shouldClose: shouldClose = changeImportance === 'accept' } = options ?? {};
        let shouldFireOnChange;
        let shouldFireOnAccept;
        if (!skipPublicationIfPristine && !isValueControlled && !state.hasBeenModifiedSinceMount) {
            // If the value is not controlled and the value has never been modified before,
            // Then clicking on any value (including the one equal to `defaultValue`) should call `onChange` and `onAccept`
            shouldFireOnChange = true;
            shouldFireOnAccept = changeImportance === 'accept';
        } else {
            shouldFireOnChange = !valueManager.areValuesEqual(adapter, newValue, value);
            shouldFireOnAccept = changeImportance === 'accept' && !valueManager.areValuesEqual(adapter, newValue, state.lastCommittedValue);
        }
        setState((prevState)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prevState, {
                // We reset the shallow value whenever we fire onChange.
                clockShallowValue: shouldFireOnChange ? undefined : prevState.clockShallowValue,
                lastCommittedValue: shouldFireOnAccept ? newValue : prevState.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                cachedContext = {
                    validationError: validationError == null ? getValidationErrorForNewValue(newValue) : validationError
                };
                if (shortcut) cachedContext.shortcut = shortcut;
            }
            return cachedContext;
        };
        if (shouldFireOnChange) handleValueChange(newValue, getContext());
        if (shouldFireOnAccept && onAccept) onAccept(newValue, getContext());
        if (shouldClose) setOpen(false);
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) setState((prevState)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prevState, {
            lastExternalValue: value,
            clockShallowValue: undefined,
            hasBeenModifiedSinceMount: true
        }));
    const setValueFromView = (0, $f4856cf9dd817ed8$var$_useEventCallback.default)((newValue, selectionState = 'partial')=>{
        // TODO: Expose a new method (private?) like `setView` that only updates the clock shallow value.
        if (selectionState === 'shallow') {
            setState((prev)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prev, {
                    clockShallowValue: newValue,
                    hasBeenModifiedSinceMount: true
                }));
            return;
        }
        setValue(newValue, {
            changeImportance: selectionState === 'finish' && closeOnSelect ? 'accept' : 'set'
        });
    });
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $f4856cf9dd817ed8$var$React.useEffect(()=>{
        if (isOpenControlled) {
            if (openProp === undefined) throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setState((prevState)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prevState, {
                    open: openProp
                }));
        }
    }, [
        isOpenControlled,
        openProp
    ]);
    const viewValue = $f4856cf9dd817ed8$var$React.useMemo(()=>valueManager.cleanValue(adapter, state.clockShallowValue === undefined ? value : state.clockShallowValue), [
        adapter,
        valueManager,
        state.clockShallowValue,
        value
    ]);
    return {
        timezone: timezone,
        state: state,
        setValue: setValue,
        setValueFromView: setValueFromView,
        setOpen: setOpen,
        value: value,
        viewValue: viewValue
    };
}

});



parcelRegister("g0CIC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ba7aae28ccdef24f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersLayout", {
    enumerable: true,
    get: function() {
        return $cj57l.PickersLayout;
    }
});
Object.defineProperty(module.exports, "PickersLayoutContentWrapper", {
    enumerable: true,
    get: function() {
        return $cj57l.PickersLayoutContentWrapper;
    }
});
Object.defineProperty(module.exports, "PickersLayoutRoot", {
    enumerable: true,
    get: function() {
        return $cj57l.PickersLayoutRoot;
    }
});
Object.defineProperty(module.exports, "pickersLayoutClasses", {
    enumerable: true,
    get: function() {
        return $9k6Dk.pickersLayoutClasses;
    }
});
Object.defineProperty(module.exports, "usePickerLayout", {
    enumerable: true,
    get: function() {
        return $ba7aae28ccdef24f$var$_usePickerLayout.default;
    }
});

var $cj57l = parcelRequire("cj57l");

var $ba7aae28ccdef24f$var$_usePickerLayout = $ba7aae28ccdef24f$require$_interopRequireDefault((parcelRequire("ECdxX")));

var $9k6Dk = parcelRequire("9k6Dk");

});
parcelRegister("cj57l", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8f5b3a99831a0c63$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8f5b3a99831a0c63$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersLayoutRoot = module.exports.PickersLayoutContentWrapper = module.exports.PickersLayout = void 0;

var $8f5b3a99831a0c63$var$React = $8f5b3a99831a0c63$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8f5b3a99831a0c63$var$_propTypes = $8f5b3a99831a0c63$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8f5b3a99831a0c63$var$_clsx = $8f5b3a99831a0c63$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $8f5b3a99831a0c63$var$_composeClasses = $8f5b3a99831a0c63$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $9k6Dk = parcelRequire("9k6Dk");

var $8f5b3a99831a0c63$var$_usePickerLayout = $8f5b3a99831a0c63$require$_interopRequireDefault((parcelRequire("ECdxX")));

var $6DVo4 = parcelRequire("6DVo4");

var $ayMG0 = parcelRequire("ayMG0");
const $8f5b3a99831a0c63$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $8f5b3a99831a0c63$var$_composeClasses.default)(slots, $9k6Dk.getPickersLayoutUtilityClass, classes);
};
const $8f5b3a99831a0c63$var$PickersLayoutRoot = module.exports.PickersLayoutRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root'
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${$9k6Dk.pickersLayoutClasses.actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: false
            },
            style: {
                [`& .${$9k6Dk.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '1 / 3'
                }
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: true
            },
            style: {
                [`& .${$9k6Dk.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1,
                    maxWidth: 'max-content'
                },
                [`& .${$9k6Dk.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: 2
                }
            }
        },
        {
            props: {
                pickerOrientation: 'portrait'
            },
            style: {
                [`& .${$9k6Dk.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${$9k6Dk.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                hasShortcuts: true,
                layoutDirection: 'rtl'
            },
            style: {
                [`& .${$9k6Dk.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 4
                }
            }
        }
    ]
});
const $8f5b3a99831a0c63$var$PickersLayoutContentWrapper = module.exports.PickersLayoutContentWrapper = (0, $d8seH.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper'
})({
    gridColumn: '2 / 4',
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $8f5b3a99831a0c63$var$PickersLayout = module.exports.PickersLayout = /*#__PURE__*/ $8f5b3a99831a0c63$var$React.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts, ownerState: ownerState } = (0, $8f5b3a99831a0c63$var$_usePickerLayout.default)(props);
    const { orientation: orientation, variant: variant } = (0, $6DVo4.usePickerContext)();
    const { sx: sx, className: className, classes: classesProp } = props;
    const classes = $8f5b3a99831a0c63$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8f5b3a99831a0c63$var$PickersLayoutRoot, {
        ref: ref,
        sx: sx,
        className: (0, $8f5b3a99831a0c63$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $ayMG0.jsx)($8f5b3a99831a0c63$var$PickersLayoutContentWrapper, {
                className: classes.contentWrapper,
                ownerState: ownerState,
                children: variant === 'desktop' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($8f5b3a99831a0c63$var$React.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($8f5b3a99831a0c63$var$React.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});

});
parcelRegister("9k6Dk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6c9b2087702d19e3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersLayoutUtilityClass = $6c9b2087702d19e3$var$getPickersLayoutUtilityClass;
module.exports.pickersLayoutClasses = void 0;

var $6c9b2087702d19e3$var$_generateUtilityClass = $6c9b2087702d19e3$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $6c9b2087702d19e3$var$_generateUtilityClasses = $6c9b2087702d19e3$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $6c9b2087702d19e3$var$getPickersLayoutUtilityClass(slot) {
    return (0, $6c9b2087702d19e3$var$_generateUtilityClass.default)('MuiPickersLayout', slot);
}
const $6c9b2087702d19e3$var$pickersLayoutClasses = module.exports.pickersLayoutClasses = (0, $6c9b2087702d19e3$var$_generateUtilityClasses.default)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);

});

parcelRegister("ECdxX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $07a161bd56d089a9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $07a161bd56d089a9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07a161bd56d089a9$var$_objectWithoutPropertiesLoose2 = $07a161bd56d089a9$require$_interopRequireDefault((parcelRequire("c05no")));

var $07a161bd56d089a9$var$_extends2 = $07a161bd56d089a9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $07a161bd56d089a9$var$React = $07a161bd56d089a9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $07a161bd56d089a9$var$_useSlotProps2 = $07a161bd56d089a9$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $07a161bd56d089a9$var$_composeClasses = $07a161bd56d089a9$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $9uEev = parcelRequire("9uEev");

var $97UU8 = parcelRequire("97UU8");

var $9k6Dk = parcelRequire("9k6Dk");

var $aT4uh = parcelRequire("aT4uh");

var $7OOd8 = parcelRequire("7OOd8");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $07a161bd56d089a9$var$_excluded = [
    "ownerState"
];
function $07a161bd56d089a9$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $07a161bd56d089a9$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $07a161bd56d089a9$var$_composeClasses.default)(slots, $9k6Dk.getPickersLayoutUtilityClass, classes);
};
const $07a161bd56d089a9$var$usePickerLayout = (props)=>{
    const { ownerState: pickerOwnerState, defaultActionBarActions: defaultActionBarActions } = (0, $7OOd8.usePickerPrivateContext)();
    const { view: view } = (0, $BKARN.usePickerContext)();
    const isRtl = (0, $9uEev.useRtl)();
    const { children: children, slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const ownerState = $07a161bd56d089a9$var$React.useMemo(()=>(0, $07a161bd56d089a9$var$_extends2.default)({}, pickerOwnerState, {
            layoutDirection: isRtl ? 'rtl' : 'ltr',
            hasShortcuts: false
        }), [
        pickerOwnerState,
        isRtl
    ]);
    const classes = $07a161bd56d089a9$var$useUtilityClasses(classesProp, ownerState);
    // Action bar
    const ActionBar = slots?.actionBar ?? $97UU8.PickersActionBar;
    const _useSlotProps = (0, $07a161bd56d089a9$var$_useSlotProps2.default)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            actions: defaultActionBarActions
        },
        className: classes.actionBar,
        ownerState: ownerState
    }), actionBarProps = (0, $07a161bd56d089a9$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $07a161bd56d089a9$var$_excluded);
    const actionBar = /*#__PURE__*/ (0, $ayMG0.jsx)(ActionBar, (0, $07a161bd56d089a9$var$_extends2.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $07a161bd56d089a9$var$_useSlotProps2.default)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        className: classes.toolbar,
        ownerState: ownerState
    });
    const toolbar = $07a161bd56d089a9$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $07a161bd56d089a9$var$_extends2.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $ayMG0.jsx)(Tabs, (0, $07a161bd56d089a9$var$_extends2.default)({
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? $aT4uh.PickersShortcuts;
    const shortcutsProps = (0, $07a161bd56d089a9$var$_useSlotProps2.default)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        className: classes.shortcuts,
        ownerState: ownerState
    });
    const hasShortcuts = Array.isArray(shortcutsProps?.items) && shortcutsProps.items.length > 0;
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $ayMG0.jsx)(Shortcuts, (0, $07a161bd56d089a9$var$_extends2.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts,
        ownerState: (0, $07a161bd56d089a9$var$_extends2.default)({}, ownerState, {
            hasShortcuts: hasShortcuts
        })
    };
};
var $07a161bd56d089a9$var$_default = module.exports.default = $07a161bd56d089a9$var$usePickerLayout;

});
parcelRegister("97UU8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersActionBar", {
    enumerable: true,
    get: function() {
        return $iHEnb.PickersActionBar;
    }
});

var $iHEnb = parcelRequire("iHEnb");

});
parcelRegister("iHEnb", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d9db8f61ff28a432$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d9db8f61ff28a432$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersActionBar = void 0;

var $d9db8f61ff28a432$var$_extends2 = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d9db8f61ff28a432$var$_objectWithoutPropertiesLoose2 = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("c05no")));

var $d9db8f61ff28a432$var$React = $d9db8f61ff28a432$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d9db8f61ff28a432$var$_propTypes = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d8seH = parcelRequire("d8seH");

var $d9db8f61ff28a432$var$_Button = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("bBQKz")));

var $d9db8f61ff28a432$var$_DialogActions = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("l5BZB")));

var $83GPg = parcelRequire("83GPg");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $d9db8f61ff28a432$var$_excluded = [
    "actions"
];
const $d9db8f61ff28a432$var$PickersActionBarRoot = (0, $d8seH.default)($d9db8f61ff28a432$var$_DialogActions.default, {
    name: 'MuiPickersLayout',
    slot: 'ActionBar'
})({});
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $d9db8f61ff28a432$var$PickersActionBarComponent(props) {
    const { actions: actions } = props, other = (0, $d9db8f61ff28a432$var$_objectWithoutPropertiesLoose2.default)(props, $d9db8f61ff28a432$var$_excluded);
    const translations = (0, $83GPg.usePickerTranslations)();
    const { clearValue: clearValue, setValueToToday: setValueToToday, acceptValueChanges: acceptValueChanges, cancelValueChanges: cancelValueChanges, goToNextStep: goToNextStep, hasNextStep: hasNextStep } = (0, $BKARN.usePickerContext)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: clearValue,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: cancelValueChanges,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: setValueToToday,
                    children: translations.todayButtonLabel
                }, actionType);
            case 'next':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
            case 'nextOrAccept':
                if (hasNextStep) return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$PickersActionBarRoot, (0, $d9db8f61ff28a432$var$_extends2.default)({}, other, {
        children: buttons
    }));
}
const $d9db8f61ff28a432$var$PickersActionBar = module.exports.PickersActionBar = /*#__PURE__*/ $d9db8f61ff28a432$var$React.memo($d9db8f61ff28a432$var$PickersActionBarComponent);

});
parcelRegister("l5BZB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("2MUlQ")).default);
$parcel$export(module.exports, "dialogActionsClasses", () => (parcelRequire("4ZLz5")).default);

var $2MUlQ = parcelRequire("2MUlQ");

var $4ZLz5 = parcelRequire("4ZLz5");
$parcel$exportWildcard(module.exports, $4ZLz5);

});



parcelRegister("aT4uh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersShortcuts", {
    enumerable: true,
    get: function() {
        return $g9DEN.PickersShortcuts;
    }
});

var $g9DEN = parcelRequire("g9DEN");

});
parcelRegister("g9DEN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bc2c3fa74ca71715$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bc2c3fa74ca71715$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersShortcuts = $bc2c3fa74ca71715$var$PickersShortcuts;

var $bc2c3fa74ca71715$var$_extends2 = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bc2c3fa74ca71715$var$_objectWithoutPropertiesLoose2 = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("c05no")));

var $bc2c3fa74ca71715$var$React = $bc2c3fa74ca71715$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d8seH = parcelRequire("d8seH");

var $bc2c3fa74ca71715$var$_propTypes = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bc2c3fa74ca71715$var$_List = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("ib3g2")));

var $bc2c3fa74ca71715$var$_ListItem = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("hOLYA")));

var $bc2c3fa74ca71715$var$_Chip = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("6p5K7")));

var $99eO4 = parcelRequire("99eO4");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $bc2c3fa74ca71715$var$_excluded = [
    "items",
    "changeImportance"
], $bc2c3fa74ca71715$var$_excluded2 = [
    "getValue"
];
const $bc2c3fa74ca71715$var$PickersShortcutsRoot = (0, $d8seH.default)($bc2c3fa74ca71715$var$_List.default, {
    name: 'MuiPickersLayout',
    slot: 'Shortcuts'
})({});
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $bc2c3fa74ca71715$var$PickersShortcuts(props) {
    const { items: items, changeImportance: changeImportance = 'accept' } = props, other = (0, $bc2c3fa74ca71715$var$_objectWithoutPropertiesLoose2.default)(props, $bc2c3fa74ca71715$var$_excluded);
    const { setValue: setValue } = (0, $BKARN.usePickerActionsContext)();
    const isValidValue = (0, $BKARN.useIsValidValue)();
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $bc2c3fa74ca71715$var$_objectWithoutPropertiesLoose2.default)(_ref, $bc2c3fa74ca71715$var$_excluded2);
        const newValue = getValue({
            isValid: isValidValue
        });
        return (0, $bc2c3fa74ca71715$var$_extends2.default)({}, item, {
            label: item.label,
            onClick: ()=>{
                setValue(newValue, {
                    changeImportance: changeImportance,
                    shortcut: item
                });
            },
            disabled: !isValidValue(newValue)
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bc2c3fa74ca71715$var$PickersShortcutsRoot, (0, $bc2c3fa74ca71715$var$_extends2.default)({
        dense: true,
        sx: [
            {
                maxHeight: $99eO4.VIEW_HEIGHT,
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)($bc2c3fa74ca71715$var$_ListItem.default, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($bc2c3fa74ca71715$var$_Chip.default, (0, $bc2c3fa74ca71715$var$_extends2.default)({}, item))
            }, item.id ?? item.label);
        })
    }));
}

});
parcelRegister("ib3g2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8AyZl")).default);
$parcel$export(module.exports, "listClasses", () => (parcelRequire("eUMjp")).default);

var $8AyZl = parcelRequire("8AyZl");

var $eUMjp = parcelRequire("eUMjp");
$parcel$exportWildcard(module.exports, $eUMjp);

});

parcelRegister("hOLYA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("lofVM")).default);
$parcel$export(module.exports, "listItemClasses", () => (parcelRequire("fiKZz")).default);

var $lofVM = parcelRequire("lofVM");

var $fiKZz = parcelRequire("fiKZz");
$parcel$exportWildcard(module.exports, $fiKZz);

});
parcelRegister("lofVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92832698674c928$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $c1jOg = parcelRequire("c1jOg");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $cpXNi = parcelRequire("cpXNi");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3W6ht = parcelRequire("3W6ht");

var $fiKZz = parcelRequire("fiKZz");

var $dUgGz = parcelRequire("dUgGz");

var $d9alg = parcelRequire("d9alg");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f92832698674c928$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fiKZz.getListItemUtilityClass), classes);
};
const $f92832698674c928$export$aed538f7519abe89 = (0, $d8seH.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$export$4334bb34c76fef24
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $dUgGz.default).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $f92832698674c928$var$ListItemContainer = (0, $d8seH.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in v7
    const hasSecondaryAction = children.length && (0, $cpXNi.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $9Rgf1.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $f92832698674c928$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in v7
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $c1jOg.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $c1jOg.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9alg.default), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $f92832698674c928$export$2e2bcd8739ae039 = $f92832698674c928$var$ListItem;

});
parcelRegister("fiKZz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getListItemUtilityClass", () => $b23cfd2067550897$export$5682c366c0c669d9);
$parcel$export(module.exports, "default", () => $b23cfd2067550897$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b23cfd2067550897$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $beCSm.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $b23cfd2067550897$export$2e2bcd8739ae039 = $b23cfd2067550897$var$listItemClasses;

});

parcelRegister("dUgGz", function(module, exports) {

$parcel$export(module.exports, "getListItemButtonUtilityClass", () => $a1fd72c2634274a8$export$c09531d8563c67a5);
$parcel$export(module.exports, "default", () => $a1fd72c2634274a8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a1fd72c2634274a8$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $beCSm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$export$2e2bcd8739ae039 = $a1fd72c2634274a8$var$listItemButtonClasses;

});

parcelRegister("d9alg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9924235485c5a222$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $7lon8 = parcelRequire("7lon8");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7lon8.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$export$2e2bcd8739ae039 = $9924235485c5a222$var$ListItemSecondaryAction;

});
parcelRegister("7lon8", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", () => $558d665a4b71ad4c$export$ccdb26aeba48a86e);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $558d665a4b71ad4c$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $beCSm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$export$2e2bcd8739ae039 = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;

});




parcelRegister("6p5K7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6ami2")).default);
$parcel$export(module.exports, "chipClasses", () => (parcelRequire("iNSYf")).default);

var $6ami2 = parcelRequire("6ami2");

var $iNSYf = parcelRequire("iNSYf");
$parcel$exportWildcard(module.exports, $iNSYf);

});






parcelRegister("a2Tw3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNonRangePickerStepNavigation = $7505279b16728fc6$var$createNonRangePickerStepNavigation;

var $kHgod = parcelRequire("kHgod");
function $7505279b16728fc6$var$createNonRangePickerStepNavigation(parameters) {
    const { steps: steps } = parameters;
    return (0, $kHgod.createStepNavigation)({
        steps: steps,
        isViewMatchingStep: (view, step)=>{
            return step.views == null || step.views.includes(view);
        },
        onStepChange: ({ step: step, defaultView: defaultView, setView: setView, view: view, views: views })=>{
            const targetView = step.views == null ? defaultView : step.views.find((viewBis)=>views.includes(viewBis));
            if (targetView !== view) setView(targetView);
        }
    });
}

});



parcelRegister("l5kHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "renderDigitalClockTimeView", {
    enumerable: true,
    get: function() {
        return $etqB7.renderDigitalClockTimeView;
    }
});
Object.defineProperty(module.exports, "renderMultiSectionDigitalClockTimeView", {
    enumerable: true,
    get: function() {
        return $etqB7.renderMultiSectionDigitalClockTimeView;
    }
});
Object.defineProperty(module.exports, "renderTimeViewClock", {
    enumerable: true,
    get: function() {
        return $etqB7.renderTimeViewClock;
    }
});

var $etqB7 = parcelRequire("etqB7");

});
parcelRegister("etqB7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a89867de13b97115$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.renderTimeViewClock = module.exports.renderMultiSectionDigitalClockTimeView = module.exports.renderDigitalClockTimeView = void 0;

var $a89867de13b97115$var$React = $a89867de13b97115$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c4qm5 = parcelRequire("c4qm5");

var $hOsJb = parcelRequire("hOsJb");

var $2QxZ0 = parcelRequire("2QxZ0");

var $cElCc = parcelRequire("cElCc");

var $ayMG0 = parcelRequire("ayMG0");
const $a89867de13b97115$var$renderTimeViewClock = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)($c4qm5.TimeClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $cElCc.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter($cElCc.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
module.exports.renderTimeViewClock = $a89867de13b97115$var$renderTimeViewClock;
const $a89867de13b97115$var$renderDigitalClockTimeView = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)($hOsJb.DigitalClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $cElCc.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter($cElCc.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
module.exports.renderDigitalClockTimeView = $a89867de13b97115$var$renderDigitalClockTimeView;
const $a89867de13b97115$var$renderMultiSectionDigitalClockTimeView = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)($2QxZ0.MultiSectionDigitalClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $cElCc.isInternalTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter($cElCc.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
module.exports.renderMultiSectionDigitalClockTimeView = $a89867de13b97115$var$renderMultiSectionDigitalClockTimeView;

});
parcelRegister("c4qm5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "TimeClock", {
    enumerable: true,
    get: function() {
        return $j3vom.TimeClock;
    }
});
Object.defineProperty(module.exports, "clockClasses", {
    enumerable: true,
    get: function() {
        return $87p9A.clockClasses;
    }
});
Object.defineProperty(module.exports, "clockNumberClasses", {
    enumerable: true,
    get: function() {
        return $3qpqB.clockNumberClasses;
    }
});
Object.defineProperty(module.exports, "clockPointerClasses", {
    enumerable: true,
    get: function() {
        return $jzIlH.clockPointerClasses;
    }
});
Object.defineProperty(module.exports, "getTimeClockUtilityClass", {
    enumerable: true,
    get: function() {
        return $dYrN2.getTimeClockUtilityClass;
    }
});
Object.defineProperty(module.exports, "timeClockClasses", {
    enumerable: true,
    get: function() {
        return $dYrN2.timeClockClasses;
    }
});

var $j3vom = parcelRequire("j3vom");

var $87p9A = parcelRequire("87p9A");

var $3qpqB = parcelRequire("3qpqB");

var $dYrN2 = parcelRequire("dYrN2");

var $jzIlH = parcelRequire("jzIlH");

});
parcelRegister("j3vom", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ddf6a5e91208f965$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ddf6a5e91208f965$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeClock = void 0;

var $ddf6a5e91208f965$var$_extends2 = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ddf6a5e91208f965$var$_objectWithoutPropertiesLoose2 = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("c05no")));

var $ddf6a5e91208f965$var$React = $ddf6a5e91208f965$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ddf6a5e91208f965$var$_clsx = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ddf6a5e91208f965$var$_propTypes = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $ddf6a5e91208f965$var$_composeClasses = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $ddf6a5e91208f965$var$_useId = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("5Db2s")));

var $BKARN = parcelRequire("BKARN");

var $3vagl = parcelRequire("3vagl");

var $ecN6O = parcelRequire("ecN6O");

var $cElCc = parcelRequire("cElCc");

var $3cW2G = parcelRequire("3cW2G");

var $lfVfV = parcelRequire("lfVfV");

var $fQ7ML = parcelRequire("fQ7ML");

var $dYrN2 = parcelRequire("dYrN2");

var $jHpqT = parcelRequire("jHpqT");

var $dRi4s = parcelRequire("dRi4s");

var $hagTn = parcelRequire("hagTn");

var $1M3bL = parcelRequire("1M3bL");

var $gBP5e = parcelRequire("gBP5e");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $ddf6a5e91208f965$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "timezone"
];
const $ddf6a5e91208f965$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, $ddf6a5e91208f965$var$_composeClasses.default)(slots, $dYrN2.getTimeClockUtilityClass, classes);
};
const $ddf6a5e91208f965$var$TimeClockRoot = (0, $d8seH.default)($fQ7ML.PickerViewRoot, {
    name: 'MuiTimeClock',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const $ddf6a5e91208f965$var$TimeClockArrowSwitcher = (0, $d8seH.default)($ecN6O.PickersArrowSwitcher, {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher'
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const $ddf6a5e91208f965$var$TIME_CLOCK_DEFAULT_VIEWS = [
    'hours',
    'minutes'
];
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [TimeClock](https://mui.com/x/react-date-pickers/time-clock/)
 *
 * API:
 *
 * - [TimeClock API](https://mui.com/x/api/date-pickers/time-clock/)
 */ const $ddf6a5e91208f965$var$TimeClock = module.exports.TimeClock = /*#__PURE__*/ $ddf6a5e91208f965$var$React.forwardRef(function TimeClock(inProps, ref) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $ddf6a5e91208f965$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $ddf6a5e91208f965$var$_objectWithoutPropertiesLoose2.default)(props, $ddf6a5e91208f965$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'TimeClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const valueOrReferenceDate = (0, $gBP5e.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const translations = (0, $BKARN.usePickerTranslations)();
    const now = (0, $3vagl.useNow)(timezone);
    const selectedId = (0, $ddf6a5e91208f965$var$_useId.default)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $3cW2G.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $lfVfV.useMeridiemMode)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $ddf6a5e91208f965$var$React.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(adapter.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(adapter.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(adapter.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $cElCc.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = adapter.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (adapter.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 0), 0);
                    const end = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = adapter.setMinutes(valueOrReferenceDate, rawValue);
                    const start = adapter.setSeconds(dateWithNewMinutes, 0);
                    const end = adapter.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = adapter.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        adapter,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const viewProps = $ddf6a5e91208f965$var$React.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $cElCc.convertValueToMeridiem)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(adapter.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, 'hours');
                    };
                    const viewValue = adapter.getHours(valueOrReferenceDate);
                    let viewRange;
                    if (ampm) {
                        if (viewValue > 12) viewRange = [
                            12,
                            23
                        ];
                        else viewRange = [
                            0,
                            11
                        ];
                    } else viewRange = [
                        0,
                        23
                    ];
                    return {
                        onChange: handleHoursChange,
                        viewValue: viewValue,
                        children: (0, $dRi4s.getHourNumbers)({
                            value: value,
                            adapter: adapter,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: translations.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId: selectedId
                        }),
                        viewRange: viewRange
                    };
                }
            case 'minutes':
                {
                    const minutesValue = adapter.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(adapter.setMinutes(valueOrReferenceDate, minuteValue), isFinish, 'minutes');
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $dRi4s.getMinutesNumbers)({
                            adapter: adapter,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: translations.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId: selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            case 'seconds':
                {
                    const secondsValue = adapter.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(adapter.setSeconds(valueOrReferenceDate, secondValue), isFinish, 'seconds');
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $dRi4s.getMinutesNumbers)({
                            adapter: adapter,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: translations.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId: selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        adapter,
        value,
        ampm,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const classes = $ddf6a5e91208f965$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ddf6a5e91208f965$var$TimeClockRoot, (0, $ddf6a5e91208f965$var$_extends2.default)({
        ref: ref,
        className: (0, $ddf6a5e91208f965$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($jHpqT.Clock, (0, $ddf6a5e91208f965$var$_extends2.default)({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $ayMG0.jsx)($ddf6a5e91208f965$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: translations.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: translations.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});

});
parcelRegister("dYrN2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a2c66f75362e3156$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTimeClockUtilityClass = $a2c66f75362e3156$var$getTimeClockUtilityClass;
module.exports.timeClockClasses = void 0;

var $a2c66f75362e3156$var$_generateUtilityClass = $a2c66f75362e3156$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $a2c66f75362e3156$var$_generateUtilityClasses = $a2c66f75362e3156$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $a2c66f75362e3156$var$getTimeClockUtilityClass(slot) {
    return (0, $a2c66f75362e3156$var$_generateUtilityClass.default)('MuiTimeClock', slot);
}
const $a2c66f75362e3156$var$timeClockClasses = module.exports.timeClockClasses = (0, $a2c66f75362e3156$var$_generateUtilityClasses.default)('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);

});

parcelRegister("jHpqT", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e575c2e563c85584$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e575c2e563c85584$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Clock = $e575c2e563c85584$var$Clock;

var $e575c2e563c85584$var$_extends2 = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e575c2e563c85584$var$React = $e575c2e563c85584$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e575c2e563c85584$var$_clsx = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("9QePP")));

var $e575c2e563c85584$var$_IconButton = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("825Zh")));

var $e575c2e563c85584$var$_Typography = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $e575c2e563c85584$var$_useEnhancedEffect = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $e575c2e563c85584$var$_composeClasses = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $5Nqk8 = parcelRequire("5Nqk8");

var $BKARN = parcelRequire("BKARN");

var $2aAi1 = parcelRequire("2aAi1");

var $87p9A = parcelRequire("87p9A");

var $NRNex = parcelRequire("NRNex");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $e575c2e563c85584$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton',
            ownerState.clockMeridiemMode === 'am' && 'selected'
        ],
        pmButton: [
            'pmButton',
            ownerState.clockMeridiemMode === 'pm' && 'selected'
        ],
        meridiemText: [
            'meridiemText'
        ]
    };
    return (0, $e575c2e563c85584$var$_composeClasses.default)(slots, $87p9A.getClockUtilityClass, classes);
};
const $e575c2e563c85584$var$ClockRoot = (0, $d8seH.default)('div', {
    name: 'MuiClock',
    slot: 'Root'
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const $e575c2e563c85584$var$ClockClock = (0, $d8seH.default)('div', {
    name: 'MuiClock',
    slot: 'Clock'
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const $e575c2e563c85584$var$ClockWrapper = (0, $d8seH.default)('div', {
    name: 'MuiClock',
    slot: 'Wrapper'
})({
    '&:focus': {
        outline: 'none'
    }
});
const $e575c2e563c85584$var$ClockSquareMask = (0, $d8seH.default)('div', {
    name: 'MuiClock',
    slot: 'SquareMask'
})({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    // Disable scroll capabilities.
    touchAction: 'none',
    userSelect: 'none',
    variants: [
        {
            props: {
                isClockDisabled: false
            },
            style: {
                '@media (pointer: fine)': {
                    cursor: 'pointer',
                    borderRadius: '50%'
                },
                '&:active': {
                    cursor: 'move'
                }
            }
        }
    ]
});
const $e575c2e563c85584$var$ClockPin = (0, $d8seH.default)('div', {
    name: 'MuiClock',
    slot: 'Pin'
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const $e575c2e563c85584$var$meridiemButtonCommonStyles = (theme, clockMeridiemMode)=>({
        zIndex: 1,
        bottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: $2aAi1.CLOCK_HOUR_WIDTH,
        variants: [
            {
                props: {
                    clockMeridiemMode: clockMeridiemMode
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    });
const $e575c2e563c85584$var$ClockAmButton = (0, $d8seH.default)($e575c2e563c85584$var$_IconButton.default, {
    name: 'MuiClock',
    slot: 'AmButton'
})(({ theme: theme })=>(0, $e575c2e563c85584$var$_extends2.default)({}, $e575c2e563c85584$var$meridiemButtonCommonStyles(theme, 'am'), {
        // keeping it here to make TS happy
        position: 'absolute',
        left: 8
    }));
const $e575c2e563c85584$var$ClockPmButton = (0, $d8seH.default)($e575c2e563c85584$var$_IconButton.default, {
    name: 'MuiClock',
    slot: 'PmButton'
})(({ theme: theme })=>(0, $e575c2e563c85584$var$_extends2.default)({}, $e575c2e563c85584$var$meridiemButtonCommonStyles(theme, 'pm'), {
        // keeping it here to make TS happy
        position: 'absolute',
        right: 8
    }));
const $e575c2e563c85584$var$ClockMeridiemText = (0, $d8seH.default)($e575c2e563c85584$var$_Typography.default, {
    name: 'MuiClock',
    slot: 'MeridiemText'
})({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
/**
 * @ignore - internal component.
 */ function $e575c2e563c85584$var$Clock(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, viewRange: [minViewValue, maxViewValue], disabled: disabled = false, readOnly: readOnly, className: className, classes: classesProp } = props;
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $e575c2e563c85584$var$_extends2.default)({}, pickerOwnerState, {
        isClockDisabled: disabled,
        clockMeridiemMode: meridiemMode
    });
    const isMoving = $e575c2e563c85584$var$React.useRef(false);
    const classes = $e575c2e563c85584$var$useUtilityClasses(classesProp, ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === 'hours' && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, $2aAi1.getMinutes)(offsetX, offsetY, minutesStep) : (0, $2aAi1.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchSelection = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
        event.preventDefault();
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const isPointerBetweenTwoClockValues = type === 'hours' ? false : viewValue % 5 !== 0;
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = $e575c2e563c85584$var$React.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $e575c2e563c85584$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const clampValue = (newValue)=>Math.max(minViewValue, Math.min(maxViewValue, newValue));
    const circleValue = (newValue)=>(newValue + (maxViewValue + 1)) % (maxViewValue + 1);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // reset both hours and minutes
                handleValueChange(minViewValue, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(maxViewValue, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(circleValue(viewValue + keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(circleValue(viewValue - keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'PageUp':
                handleValueChange(clampValue(viewValue + 5), 'partial');
                event.preventDefault();
                break;
            case 'PageDown':
                handleValueChange(clampValue(viewValue - 5), 'partial');
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleValueChange(viewValue, 'finish');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e575c2e563c85584$var$ClockRoot, {
        className: (0, $e575c2e563c85584$var$_clsx.default)(classes.root, className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e575c2e563c85584$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockSquareMask, {
                        onTouchMove: handleTouchSelection,
                        onTouchStart: handleTouchSelection,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: ownerState,
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $ayMG0.jsxs)($e575c2e563c85584$var$React.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $ayMG0.jsx)($5Nqk8.ClockPointer, {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                isBetweenTwoClockValues: isPointerBetweenTwoClockValues
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": translations.clockLabelText(type, value == null ? null : adapter.format(value, ampm ? 'fullTime12h' : 'fullTime24h')),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $ayMG0.jsxs)($e575c2e563c85584$var$React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $NRNex.formatMeridiem)(adapter, 'am'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $NRNex.formatMeridiem)(adapter, 'am')
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $NRNex.formatMeridiem)(adapter, 'pm'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $NRNex.formatMeridiem)(adapter, 'pm')
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("5Nqk8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4385f2b113626448$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4385f2b113626448$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClockPointer = $4385f2b113626448$var$ClockPointer;

var $4385f2b113626448$var$_extends2 = $4385f2b113626448$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4385f2b113626448$var$_objectWithoutPropertiesLoose2 = $4385f2b113626448$require$_interopRequireDefault((parcelRequire("c05no")));

var $4385f2b113626448$var$React = $4385f2b113626448$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4385f2b113626448$var$_clsx = $4385f2b113626448$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $4385f2b113626448$var$_composeClasses = $4385f2b113626448$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $2aAi1 = parcelRequire("2aAi1");

var $jzIlH = parcelRequire("jzIlH");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $4385f2b113626448$var$_excluded = [
    "className",
    "classes",
    "isBetweenTwoClockValues",
    "isInner",
    "type",
    "viewValue"
];
const $4385f2b113626448$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, $4385f2b113626448$var$_composeClasses.default)(slots, $jzIlH.getClockPointerUtilityClass, classes);
};
const $4385f2b113626448$var$ClockPointerRoot = (0, $d8seH.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Root'
})(({ theme: theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px',
        variants: [
            {
                props: {
                    isClockPointerAnimated: true
                },
                style: {
                    transition: theme.transitions.create([
                        'transform',
                        'height'
                    ])
                }
            }
        ]
    }));
const $4385f2b113626448$var$ClockPointerThumb = (0, $d8seH.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb'
})(({ theme: theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${$2aAi1.CLOCK_HOUR_WIDTH / 2}px)`,
        border: `${($2aAi1.CLOCK_HOUR_WIDTH - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box',
        variants: [
            {
                props: {
                    isClockPointerBetweenTwoValues: false
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function $4385f2b113626448$var$ClockPointer(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className: className, classes: classesProp, isBetweenTwoClockValues: isBetweenTwoClockValues, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $4385f2b113626448$var$_objectWithoutPropertiesLoose2.default)(props, $4385f2b113626448$var$_excluded);
    const previousType = $4385f2b113626448$var$React.useRef(type);
    $4385f2b113626448$var$React.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $4385f2b113626448$var$_extends2.default)({}, pickerOwnerState, {
        isClockPointerAnimated: previousType.current !== type,
        isClockPointerBetweenTwoValues: isBetweenTwoClockValues
    });
    const classes = $4385f2b113626448$var$useUtilityClasses(classesProp);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === 'hours' && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * $2aAi1.CLOCK_WIDTH),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4385f2b113626448$var$ClockPointerRoot, (0, $4385f2b113626448$var$_extends2.default)({
        style: getAngleStyle(),
        className: (0, $4385f2b113626448$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4385f2b113626448$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}

});
parcelRegister("2aAi1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMinutes = module.exports.getHours = module.exports.CLOCK_WIDTH = module.exports.CLOCK_HOUR_WIDTH = void 0;
const $1948aa4fa91b9e03$var$CLOCK_WIDTH = module.exports.CLOCK_WIDTH = 220;
const $1948aa4fa91b9e03$var$CLOCK_HOUR_WIDTH = module.exports.CLOCK_HOUR_WIDTH = 36;
const $1948aa4fa91b9e03$var$clockCenter = {
    x: $1948aa4fa91b9e03$var$CLOCK_WIDTH / 2,
    y: $1948aa4fa91b9e03$var$CLOCK_WIDTH / 2
};
const $1948aa4fa91b9e03$var$baseClockPoint = {
    x: $1948aa4fa91b9e03$var$clockCenter.x,
    y: 0
};
const $1948aa4fa91b9e03$var$cx = $1948aa4fa91b9e03$var$baseClockPoint.x - $1948aa4fa91b9e03$var$clockCenter.x;
const $1948aa4fa91b9e03$var$cy = $1948aa4fa91b9e03$var$baseClockPoint.y - $1948aa4fa91b9e03$var$clockCenter.y;
const $1948aa4fa91b9e03$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $1948aa4fa91b9e03$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $1948aa4fa91b9e03$var$clockCenter.x;
    const y = offsetY - $1948aa4fa91b9e03$var$clockCenter.y;
    const atan = Math.atan2($1948aa4fa91b9e03$var$cx, $1948aa4fa91b9e03$var$cy) - Math.atan2(x, y);
    let deg = $1948aa4fa91b9e03$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $1948aa4fa91b9e03$var$getMinutes = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $1948aa4fa91b9e03$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
module.exports.getMinutes = $1948aa4fa91b9e03$var$getMinutes;
const $1948aa4fa91b9e03$var$getHours = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $1948aa4fa91b9e03$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $1948aa4fa91b9e03$var$CLOCK_WIDTH / 2 - $1948aa4fa91b9e03$var$CLOCK_HOUR_WIDTH) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};
module.exports.getHours = $1948aa4fa91b9e03$var$getHours;

});

parcelRegister("jzIlH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e403b003f661ed3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clockPointerClasses = void 0;
module.exports.getClockPointerUtilityClass = $e403b003f661ed3d$var$getClockPointerUtilityClass;

var $e403b003f661ed3d$var$_generateUtilityClass = $e403b003f661ed3d$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $e403b003f661ed3d$var$_generateUtilityClasses = $e403b003f661ed3d$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $e403b003f661ed3d$var$getClockPointerUtilityClass(slot) {
    return (0, $e403b003f661ed3d$var$_generateUtilityClass.default)('MuiClockPointer', slot);
}
const $e403b003f661ed3d$var$clockPointerClasses = module.exports.clockPointerClasses = (0, $e403b003f661ed3d$var$_generateUtilityClasses.default)('MuiClockPointer', [
    'root',
    'thumb'
]);

});


parcelRegister("87p9A", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5e927d23a0de1f23$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clockClasses = void 0;
module.exports.getClockUtilityClass = $5e927d23a0de1f23$var$getClockUtilityClass;

var $5e927d23a0de1f23$var$_generateUtilityClass = $5e927d23a0de1f23$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $5e927d23a0de1f23$var$_generateUtilityClasses = $5e927d23a0de1f23$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $5e927d23a0de1f23$var$getClockUtilityClass(slot) {
    return (0, $5e927d23a0de1f23$var$_generateUtilityClass.default)('MuiClock', slot);
}
const $5e927d23a0de1f23$var$clockClasses = module.exports.clockClasses = (0, $5e927d23a0de1f23$var$_generateUtilityClasses.default)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton',
    'meridiemText',
    'selected'
]);

});


parcelRegister("dRi4s", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a16e3e169e75b2e9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMinutesNumbers = module.exports.getHourNumbers = void 0;

var $a16e3e169e75b2e9$var$React = $a16e3e169e75b2e9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $dvTuG = parcelRequire("dvTuG");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ const $a16e3e169e75b2e9$var$getHourNumbers = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, adapter: adapter })=>{
    const currentHours = value ? adapter.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = adapter.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $ayMG0.jsx)($dvTuG.ClockNumber, {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
module.exports.getHourNumbers = $a16e3e169e75b2e9$var$getHourNumbers;
const $a16e3e169e75b2e9$var$getMinutesNumbers = ({ adapter: adapter, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = adapter.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($dvTuG.ClockNumber, {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};
module.exports.getMinutesNumbers = $a16e3e169e75b2e9$var$getMinutesNumbers;

});
parcelRegister("dvTuG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9d69378f413baf58$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9d69378f413baf58$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClockNumber = $9d69378f413baf58$var$ClockNumber;

var $9d69378f413baf58$var$_objectWithoutPropertiesLoose2 = $9d69378f413baf58$require$_interopRequireDefault((parcelRequire("c05no")));

var $9d69378f413baf58$var$_extends2 = $9d69378f413baf58$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9d69378f413baf58$var$React = $9d69378f413baf58$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9d69378f413baf58$var$_clsx = $9d69378f413baf58$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $9d69378f413baf58$var$_composeClasses = $9d69378f413baf58$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $2aAi1 = parcelRequire("2aAi1");

var $3qpqB = parcelRequire("3qpqB");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $9d69378f413baf58$var$_excluded = [
    "className",
    "classes",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $9d69378f413baf58$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root',
            ownerState.isClockNumberSelected && 'selected',
            ownerState.isClockNumberDisabled && 'disabled'
        ]
    };
    return (0, $9d69378f413baf58$var$_composeClasses.default)(slots, $3qpqB.getClockNumberUtilityClass, classes);
};
const $9d69378f413baf58$var$ClockNumberRoot = (0, $d8seH.default)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${$3qpqB.clockNumberClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${$3qpqB.clockNumberClasses.selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        height: $2aAi1.CLOCK_HOUR_WIDTH,
        width: $2aAi1.CLOCK_HOUR_WIDTH,
        position: 'absolute',
        left: `calc((100% - ${$2aAi1.CLOCK_HOUR_WIDTH}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${$3qpqB.clockNumberClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${$3qpqB.clockNumberClasses.disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    isClockNumberInInnerRing: true
                },
                style: (0, $9d69378f413baf58$var$_extends2.default)({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function $9d69378f413baf58$var$ClockNumber(inProps) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className: className, classes: classesProp, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $9d69378f413baf58$var$_objectWithoutPropertiesLoose2.default)(props, $9d69378f413baf58$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $9d69378f413baf58$var$_extends2.default)({}, pickerOwnerState, {
        isClockNumberInInnerRing: inner,
        isClockNumberSelected: selected,
        isClockNumberDisabled: disabled
    });
    const classes = $9d69378f413baf58$var$useUtilityClasses(classesProp, ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ($2aAi1.CLOCK_WIDTH - $2aAi1.CLOCK_HOUR_WIDTH - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9d69378f413baf58$var$ClockNumberRoot, (0, $9d69378f413baf58$var$_extends2.default)({
        className: (0, $9d69378f413baf58$var$_clsx.default)(classes.root, className),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ($2aAi1.CLOCK_WIDTH - $2aAi1.CLOCK_HOUR_WIDTH) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}

});
parcelRegister("3qpqB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $27e7864e7261f573$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clockNumberClasses = void 0;
module.exports.getClockNumberUtilityClass = $27e7864e7261f573$var$getClockNumberUtilityClass;

var $27e7864e7261f573$var$_generateUtilityClass = $27e7864e7261f573$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $27e7864e7261f573$var$_generateUtilityClasses = $27e7864e7261f573$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $27e7864e7261f573$var$getClockNumberUtilityClass(slot) {
    return (0, $27e7864e7261f573$var$_generateUtilityClass.default)('MuiClockNumber', slot);
}
const $27e7864e7261f573$var$clockNumberClasses = module.exports.clockNumberClasses = (0, $27e7864e7261f573$var$_generateUtilityClasses.default)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);

});



parcelRegister("gBP5e", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c177ba245e259df4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useClockReferenceDate = void 0;

var $c177ba245e259df4$var$React = $c177ba245e259df4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1M3bL = parcelRequire("1M3bL");

var $NRNex = parcelRequire("NRNex");

var $gUrai = parcelRequire("gUrai");
const $c177ba245e259df4$var$useClockReferenceDate = ({ value: value, referenceDate: referenceDateProp, adapter: adapter, props: props, timezone: timezone })=>{
    const referenceDate = $c177ba245e259df4$var$React.useMemo(()=>$1M3bL.singleItemValueManager.getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            referenceDate: referenceDateProp,
            granularity: $gUrai.SECTION_TYPE_GRANULARITY.day,
            timezone: timezone,
            getTodayDate: ()=>(0, $NRNex.getTodayDate)(adapter, timezone, 'date')
        }), // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    [
        referenceDateProp,
        timezone
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value ?? referenceDate;
};
module.exports.useClockReferenceDate = $c177ba245e259df4$var$useClockReferenceDate;

});



parcelRegister("hOsJb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DigitalClock", {
    enumerable: true,
    get: function() {
        return $exqUd.DigitalClock;
    }
});
Object.defineProperty(module.exports, "DigitalClockItem", {
    enumerable: true,
    get: function() {
        return $exqUd.DigitalClockItem;
    }
});
Object.defineProperty(module.exports, "digitalClockClasses", {
    enumerable: true,
    get: function() {
        return $dYkom.digitalClockClasses;
    }
});
Object.defineProperty(module.exports, "getDigitalClockUtilityClass", {
    enumerable: true,
    get: function() {
        return $dYkom.getDigitalClockUtilityClass;
    }
});

var $exqUd = parcelRequire("exqUd");

var $dYkom = parcelRequire("dYkom");

});
parcelRegister("exqUd", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a95904b0c8aa06aa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a95904b0c8aa06aa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DigitalClockItem = module.exports.DigitalClock = void 0;

var $a95904b0c8aa06aa$var$_extends2 = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a95904b0c8aa06aa$var$_objectWithoutPropertiesLoose2 = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("c05no")));

var $a95904b0c8aa06aa$var$React = $a95904b0c8aa06aa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a95904b0c8aa06aa$var$_clsx = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a95904b0c8aa06aa$var$_propTypes = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a95904b0c8aa06aa$var$_useSlotProps = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $8gMkr = parcelRequire("8gMkr");
var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $a95904b0c8aa06aa$var$_useEventCallback = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $a95904b0c8aa06aa$var$_composeClasses = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $a95904b0c8aa06aa$var$_MenuItem = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("iZ4W7")));

var $a95904b0c8aa06aa$var$_MenuList = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("8qqwQ")));

var $a95904b0c8aa06aa$var$_useForkRef = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("88PIk")));

var $a95904b0c8aa06aa$var$_useEnhancedEffect = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $BKARN = parcelRequire("BKARN");

var $3vagl = parcelRequire("3vagl");

var $cElCc = parcelRequire("cElCc");

var $fQ7ML = parcelRequire("fQ7ML");

var $dYkom = parcelRequire("dYkom");

var $3cW2G = parcelRequire("3cW2G");

var $99eO4 = parcelRequire("99eO4");

var $hagTn = parcelRequire("hagTn");

var $1M3bL = parcelRequire("1M3bL");

var $gBP5e = parcelRequire("gBP5e");

var $l16rr = parcelRequire("l16rr");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $a95904b0c8aa06aa$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $a95904b0c8aa06aa$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        list: [
            'list'
        ],
        item: [
            'item'
        ]
    };
    return (0, $a95904b0c8aa06aa$var$_composeClasses.default)(slots, $dYkom.getDigitalClockUtilityClass, classes);
};
const $a95904b0c8aa06aa$var$DigitalClockRoot = (0, $d8seH.default)($fQ7ML.PickerViewRoot, {
    name: 'MuiDigitalClock',
    slot: 'Root'
})({
    overflowY: 'auto',
    width: '100%',
    scrollbarWidth: 'thin',
    '@media (prefers-reduced-motion: no-preference)': {
        scrollBehavior: 'auto'
    },
    maxHeight: $99eO4.DIGITAL_CLOCK_VIEW_HEIGHT,
    variants: [
        {
            props: {
                hasDigitalClockAlreadyBeenRendered: true
            },
            style: {
                '@media (prefers-reduced-motion: no-preference)': {
                    scrollBehavior: 'smooth'
                }
            }
        }
    ]
});
const $a95904b0c8aa06aa$var$DigitalClockList = (0, $d8seH.default)($a95904b0c8aa06aa$var$_MenuList.default, {
    name: 'MuiDigitalClock',
    slot: 'List'
})({
    padding: 0
});
const $a95904b0c8aa06aa$var$DigitalClockItem = module.exports.DigitalClockItem = (0, $d8seH.default)($a95904b0c8aa06aa$var$_MenuItem.default, {
    name: 'MuiDigitalClock',
    slot: 'Item',
    shouldForwardProp: (prop)=>prop !== 'itemValue' && prop !== 'formattedValue'
})(({ theme: theme })=>({
        padding: '8px 16px',
        margin: '2px 4px',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [DigitalClock](https://mui.com/x/react-date-pickers/digital-clock/)
 *
 * API:
 *
 * - [DigitalClock API](https://mui.com/x/api/date-pickers/digital-clock/)
 */ const $a95904b0c8aa06aa$var$DigitalClock = module.exports.DigitalClock = /*#__PURE__*/ $a95904b0c8aa06aa$var$React.forwardRef(function DigitalClock(inProps, ref) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const containerRef = $a95904b0c8aa06aa$var$React.useRef(null);
    const handleRef = (0, $a95904b0c8aa06aa$var$_useForkRef.default)(ref, containerRef);
    const listRef = $a95904b0c8aa06aa$var$React.useRef(null);
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiDigitalClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, views: views = [
        'hours'
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $a95904b0c8aa06aa$var$_objectWithoutPropertiesLoose2.default)(props, $a95904b0c8aa06aa$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'DigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const translations = (0, $BKARN.usePickerTranslations)();
    const now = (0, $3vagl.useNow)(timezone);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $a95904b0c8aa06aa$var$_extends2.default)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = $a95904b0c8aa06aa$var$useUtilityClasses(classesProp);
    const ClockItem = slots?.digitalClockItem ?? $a95904b0c8aa06aa$var$DigitalClockItem;
    const clockItemProps = (0, $a95904b0c8aa06aa$var$_useSlotProps.default)({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState: ownerState,
        className: classes.item
    });
    const valueOrReferenceDate = (0, $gBP5e.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $a95904b0c8aa06aa$var$_useEventCallback.default)((newValue)=>handleRawValueChange(newValue, 'finish', 'hours'));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $3cW2G.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $a95904b0c8aa06aa$var$_useEventCallback.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish');
    });
    (0, $a95904b0c8aa06aa$var$_useEnhancedEffect.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $a95904b0c8aa06aa$var$React.useCallback((valueToCheck)=>{
        const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (adapter.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, 'hours');
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        adapter,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = $a95904b0c8aa06aa$var$React.useMemo(()=>{
        const result = [];
        const startOfDay = adapter.startOfDay(valueOrReferenceDate);
        let nextTimeStepOption = startOfDay;
        while(adapter.isSameDay(valueOrReferenceDate, nextTimeStepOption)){
            result.push(nextTimeStepOption);
            nextTimeStepOption = adapter.addMinutes(nextTimeStepOption, timeStep);
        }
        return result;
    }, [
        valueOrReferenceDate,
        timeStep,
        adapter
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>adapter.isEqual(option, valueOrReferenceDate));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, $l16rr.getFocusedListItemIndex)(listRef.current) - 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, $l16rr.getFocusedListItemIndex)(listRef.current) + 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a95904b0c8aa06aa$var$DigitalClockRoot, (0, $a95904b0c8aa06aa$var$_extends2.default)({
        ref: handleRef,
        className: (0, $a95904b0c8aa06aa$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a95904b0c8aa06aa$var$DigitalClockList, {
            ref: listRef,
            role: "listbox",
            "aria-label": translations.timePickerToolbarTitle,
            className: classes.list,
            onKeyDown: handleKeyDown,
            children: timeOptions.map((option, index)=>{
                const optionDisabled = isTimeDisabled(option);
                if (skipDisabled && optionDisabled) return null;
                const isSelected = adapter.isEqual(option, value);
                const formattedValue = adapter.format(option, ampm ? 'fullTime12h' : 'fullTime24h');
                const isFocused = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0;
                const tabIndex = isFocused ? 0 : -1;
                return /*#__PURE__*/ (0, $ayMG0.jsx)(ClockItem, (0, $a95904b0c8aa06aa$var$_extends2.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || optionDisabled,
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex,
                    itemValue: option,
                    formattedValue: formattedValue
                }, clockItemProps, {
                    children: formattedValue
                }), `${option.valueOf()}-${formattedValue}`);
            })
        })
    }));
});

});
parcelRegister("iZ4W7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("2iAqv")).default);
$parcel$export(module.exports, "menuItemClasses", () => (parcelRequire("eWb0W")).default);

var $2iAqv = parcelRequire("2iAqv");

var $eWb0W = parcelRequire("eWb0W");
$parcel$exportWildcard(module.exports, $eWb0W);

});

parcelRegister("8qqwQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("lBOb7")).default);

var $lBOb7 = parcelRequire("lBOb7");

});

parcelRegister("dYkom", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a2c0b25d5f0c5c41$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.digitalClockClasses = void 0;
module.exports.getDigitalClockUtilityClass = $a2c0b25d5f0c5c41$var$getDigitalClockUtilityClass;

var $a2c0b25d5f0c5c41$var$_generateUtilityClass = $a2c0b25d5f0c5c41$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $a2c0b25d5f0c5c41$var$_generateUtilityClasses = $a2c0b25d5f0c5c41$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $a2c0b25d5f0c5c41$var$getDigitalClockUtilityClass(slot) {
    return (0, $a2c0b25d5f0c5c41$var$_generateUtilityClass.default)('MuiDigitalClock', slot);
}
const $a2c0b25d5f0c5c41$var$digitalClockClasses = module.exports.digitalClockClasses = (0, $a2c0b25d5f0c5c41$var$_generateUtilityClasses.default)('MuiDigitalClock', [
    'root',
    'list',
    'item'
]);

});



parcelRegister("2QxZ0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "MultiSectionDigitalClock", {
    enumerable: true,
    get: function() {
        return $eGsTL.MultiSectionDigitalClock;
    }
});
Object.defineProperty(module.exports, "getMultiSectionDigitalClockUtilityClass", {
    enumerable: true,
    get: function() {
        return $idkVD.getMultiSectionDigitalClockUtilityClass;
    }
});
Object.defineProperty(module.exports, "multiSectionDigitalClockClasses", {
    enumerable: true,
    get: function() {
        return $idkVD.multiSectionDigitalClockClasses;
    }
});
Object.defineProperty(module.exports, "multiSectionDigitalClockSectionClasses", {
    enumerable: true,
    get: function() {
        return $6fquT.multiSectionDigitalClockSectionClasses;
    }
});

var $eGsTL = parcelRequire("eGsTL");

var $6fquT = parcelRequire("6fquT");

var $idkVD = parcelRequire("idkVD");

});
parcelRegister("eGsTL", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ab0b678aa6d5d752$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ab0b678aa6d5d752$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultiSectionDigitalClock = void 0;

var $ab0b678aa6d5d752$var$_extends2 = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ab0b678aa6d5d752$var$_objectWithoutPropertiesLoose2 = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("c05no")));

var $ab0b678aa6d5d752$var$React = $ab0b678aa6d5d752$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ab0b678aa6d5d752$var$_clsx = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ab0b678aa6d5d752$var$_propTypes = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9uEev = parcelRequire("9uEev");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $ab0b678aa6d5d752$var$_useEventCallback = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("67oiZ")));

var $ab0b678aa6d5d752$var$_composeClasses = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $BKARN = parcelRequire("BKARN");

var $3vagl = parcelRequire("3vagl");

var $cElCc = parcelRequire("cElCc");

var $3cW2G = parcelRequire("3cW2G");

var $lfVfV = parcelRequire("lfVfV");

var $fQ7ML = parcelRequire("fQ7ML");

var $idkVD = parcelRequire("idkVD");

var $eynvO = parcelRequire("eynvO");

var $lPzno = parcelRequire("lPzno");

var $hagTn = parcelRequire("hagTn");

var $1M3bL = parcelRequire("1M3bL");

var $gBP5e = parcelRequire("gBP5e");

var $NRNex = parcelRequire("NRNex");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $ab0b678aa6d5d752$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $ab0b678aa6d5d752$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $ab0b678aa6d5d752$var$_composeClasses.default)(slots, $idkVD.getMultiSectionDigitalClockUtilityClass, classes);
};
const $ab0b678aa6d5d752$var$MultiSectionDigitalClockRoot = (0, $d8seH.default)($fQ7ML.PickerViewRoot, {
    name: 'MuiMultiSectionDigitalClock',
    slot: 'Root'
})(({ theme: theme })=>({
        flexDirection: 'row',
        width: '100%',
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [DigitalClock](https://mui.com/x/react-date-pickers/digital-clock/)
 *
 * API:
 *
 * - [MultiSectionDigitalClock API](https://mui.com/x/api/date-pickers/multi-section-digital-clock/)
 */ const $ab0b678aa6d5d752$var$MultiSectionDigitalClock = module.exports.MultiSectionDigitalClock = /*#__PURE__*/ $ab0b678aa6d5d752$var$React.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const isRtl = (0, $9uEev.useRtl)();
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        'hours',
        'minutes'
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $ab0b678aa6d5d752$var$_objectWithoutPropertiesLoose2.default)(props, $ab0b678aa6d5d752$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'MultiSectionDigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const translations = (0, $BKARN.usePickerTranslations)();
    const now = (0, $3vagl.useNow)(timezone);
    const timeSteps = $ab0b678aa6d5d752$var$React.useMemo(()=>(0, $ab0b678aa6d5d752$var$_extends2.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $gBP5e.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $ab0b678aa6d5d752$var$_useEventCallback.default)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $ab0b678aa6d5d752$var$React.useMemo(()=>{
        if (!ampm || !inViews.includes('hours')) return inViews;
        return inViews.includes('meridiem') ? inViews : [
            ...inViews,
            'meridiem'
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToNextView: setValueAndGoToNextView, focusedView: focusedView } = (0, $3cW2G.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $ab0b678aa6d5d752$var$_useEventCallback.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish', 'meridiem');
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $lfVfV.useMeridiemMode)(valueOrReferenceDate, ampm, handleMeridiemValueChange, 'finish');
    const isTimeDisabled = $ab0b678aa6d5d752$var$React.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(adapter.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(adapter.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(adapter.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $cElCc.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = adapter.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (adapter.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 0), 0);
                    const end = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = adapter.setMinutes(valueOrReferenceDate, rawValue);
                    const start = adapter.setSeconds(dateWithNewMinutes, 0);
                    const end = adapter.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = adapter.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        adapter,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = $ab0b678aa6d5d752$var$React.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case 'hours':
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $cElCc.convertValueToMeridiem)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(adapter.setHours(valueOrReferenceDate, valueWithMeridiem), 'finish', 'hours');
                    },
                    items: (0, $lPzno.getHourSectionOptions)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        adapter: adapter,
                        isDisabled: (hours)=>isTimeDisabled(hours, 'hours'),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: translations.hoursClockNumberText,
                        valueOrReferenceDate: valueOrReferenceDate
                    })
                };
            case 'minutes':
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(adapter.setMinutes(valueOrReferenceDate, minutes), 'finish', 'minutes');
                    },
                    items: (0, $lPzno.getTimeSectionOptions)({
                        value: adapter.getMinutes(valueOrReferenceDate),
                        adapter: adapter,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, 'minutes'),
                        resolveLabel: (minutes)=>adapter.format(adapter.setMinutes(now, minutes), 'minutes'),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: translations.minutesClockNumberText
                    })
                };
            case 'seconds':
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(adapter.setSeconds(valueOrReferenceDate, seconds), 'finish', 'seconds');
                    },
                    items: (0, $lPzno.getTimeSectionOptions)({
                        value: adapter.getSeconds(valueOrReferenceDate),
                        adapter: adapter,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, 'seconds'),
                        resolveLabel: (seconds)=>adapter.format(adapter.setSeconds(now, seconds), 'seconds'),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: translations.secondsClockNumberText
                    })
                };
            case 'meridiem':
                {
                    const amLabel = (0, $NRNex.formatMeridiem)(adapter, 'am');
                    const pmLabel = (0, $NRNex.formatMeridiem)(adapter, 'pm');
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: 'am',
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === 'am',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'am',
                                ariaLabel: amLabel
                            },
                            {
                                value: 'pm',
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === 'pm',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'pm',
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        adapter,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewsToRender = $ab0b678aa6d5d752$var$React.useMemo(()=>{
        if (!isRtl) return views;
        const digitViews = views.filter((v)=>v !== 'meridiem');
        digitViews.reverse();
        if (views.includes('meridiem')) digitViews.push('meridiem');
        return digitViews;
    }, [
        isRtl,
        views
    ]);
    const viewTimeOptions = $ab0b678aa6d5d752$var$React.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $ab0b678aa6d5d752$var$_extends2.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const classes = $ab0b678aa6d5d752$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab0b678aa6d5d752$var$MultiSectionDigitalClockRoot, (0, $ab0b678aa6d5d752$var$_extends2.default)({
        ref: ref,
        className: (0, $ab0b678aa6d5d752$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: viewsToRender.map((timeView)=>/*#__PURE__*/ (0, $ayMG0.jsx)($eynvO.MultiSectionDigitalClockSection, {
                items: viewTimeOptions[timeView].items,
                onChange: viewTimeOptions[timeView].onChange,
                active: view === timeView,
                autoFocus: autoFocus || focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": translations.selectViewText(timeView)
            }, timeView))
    }));
});

});
parcelRegister("idkVD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d429acda3bdcbd14$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMultiSectionDigitalClockUtilityClass = $d429acda3bdcbd14$var$getMultiSectionDigitalClockUtilityClass;
module.exports.multiSectionDigitalClockClasses = void 0;

var $d429acda3bdcbd14$var$_generateUtilityClass = $d429acda3bdcbd14$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $d429acda3bdcbd14$var$_generateUtilityClasses = $d429acda3bdcbd14$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $d429acda3bdcbd14$var$getMultiSectionDigitalClockUtilityClass(slot) {
    return (0, $d429acda3bdcbd14$var$_generateUtilityClass.default)('MuiMultiSectionDigitalClock', slot);
}
const $d429acda3bdcbd14$var$multiSectionDigitalClockClasses = module.exports.multiSectionDigitalClockClasses = (0, $d429acda3bdcbd14$var$_generateUtilityClasses.default)('MuiMultiSectionDigitalClock', [
    'root'
]);

});

parcelRegister("eynvO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a9867aae4b0582f7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a9867aae4b0582f7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultiSectionDigitalClockSection = void 0;

var $a9867aae4b0582f7$var$_extends2 = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a9867aae4b0582f7$var$_objectWithoutPropertiesLoose2 = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("c05no")));

var $a9867aae4b0582f7$var$React = $a9867aae4b0582f7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a9867aae4b0582f7$var$_clsx = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8gMkr = parcelRequire("8gMkr");
var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $a9867aae4b0582f7$var$_composeClasses = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $a9867aae4b0582f7$var$_MenuList = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("8qqwQ")));

var $a9867aae4b0582f7$var$_MenuItem = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("iZ4W7")));

var $a9867aae4b0582f7$var$_useForkRef = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("88PIk")));

var $a9867aae4b0582f7$var$_useEnhancedEffect = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("eDo7c")));

var $6fquT = parcelRequire("6fquT");

var $99eO4 = parcelRequire("99eO4");

var $l16rr = parcelRequire("l16rr");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $a9867aae4b0582f7$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $a9867aae4b0582f7$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        item: [
            'item'
        ]
    };
    return (0, $a9867aae4b0582f7$var$_composeClasses.default)(slots, $6fquT.getMultiSectionDigitalClockSectionUtilityClass, classes);
};
const $a9867aae4b0582f7$var$MultiSectionDigitalClockSectionRoot = (0, $d8seH.default)($a9867aae4b0582f7$var$_MenuList.default, {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Root'
})(({ theme: theme })=>({
        maxHeight: $99eO4.DIGITAL_CLOCK_VIEW_HEIGHT,
        width: 56,
        padding: 0,
        overflow: 'hidden',
        scrollbarWidth: 'thin',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: 'auto'
        },
        '@media (pointer: fine)': {
            '&:hover': {
                overflowY: 'auto'
            }
        },
        '@media (pointer: none), (pointer: coarse)': {
            overflowY: 'auto'
        },
        '&:not(:first-of-type)': {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        '&::after': {
            display: 'block',
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: 'calc(100% - 40px - 6px)'
        },
        variants: [
            {
                props: {
                    hasDigitalClockAlreadyBeenRendered: true
                },
                style: {
                    '@media (prefers-reduced-motion: no-preference)': {
                        scrollBehavior: 'smooth'
                    }
                }
            }
        ]
    }));
const $a9867aae4b0582f7$var$MultiSectionDigitalClockSectionItem = (0, $d8seH.default)($a9867aae4b0582f7$var$_MenuItem.default, {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Item'
})(({ theme: theme })=>({
        padding: 8,
        margin: '2px 4px',
        width: $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH,
        justifyContent: 'center',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
/**
 * @ignore - internal component.
 */ const $a9867aae4b0582f7$var$MultiSectionDigitalClockSection = module.exports.MultiSectionDigitalClockSection = /*#__PURE__*/ $a9867aae4b0582f7$var$React.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    const containerRef = $a9867aae4b0582f7$var$React.useRef(null);
    const handleRef = (0, $a9867aae4b0582f7$var$_useForkRef.default)(ref, containerRef);
    const previousActive = $a9867aae4b0582f7$var$React.useRef(null);
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClockSection'
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $a9867aae4b0582f7$var$_objectWithoutPropertiesLoose2.default)(props, $a9867aae4b0582f7$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $a9867aae4b0582f7$var$_extends2.default)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = $a9867aae4b0582f7$var$useUtilityClasses(classesProp);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? $a9867aae4b0582f7$var$MultiSectionDigitalClockSectionItem;
    (0, $a9867aae4b0582f7$var$_useEnhancedEffect.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, $l16rr.getFocusedListItemIndex)(containerRef.current) - 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, $l16rr.getFocusedListItemIndex)(containerRef.current) + 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a9867aae4b0582f7$var$MultiSectionDigitalClockSectionRoot, (0, $a9867aae4b0582f7$var$_extends2.default)({
        ref: handleRef,
        className: (0, $a9867aae4b0582f7$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox",
        onKeyDown: handleKeyDown
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(DigitalClockSectionItem, (0, $a9867aae4b0582f7$var$_extends2.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || undefined,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});

});
parcelRegister("6fquT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $48c8b29a513664e2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMultiSectionDigitalClockSectionUtilityClass = $48c8b29a513664e2$var$getMultiSectionDigitalClockSectionUtilityClass;
module.exports.multiSectionDigitalClockSectionClasses = void 0;

var $48c8b29a513664e2$var$_generateUtilityClass = $48c8b29a513664e2$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $48c8b29a513664e2$var$_generateUtilityClasses = $48c8b29a513664e2$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $48c8b29a513664e2$var$getMultiSectionDigitalClockSectionUtilityClass(slot) {
    return (0, $48c8b29a513664e2$var$_generateUtilityClass.default)('MuiMultiSectionDigitalClockSection', slot);
}
const $48c8b29a513664e2$var$multiSectionDigitalClockSectionClasses = module.exports.multiSectionDigitalClockSectionClasses = (0, $48c8b29a513664e2$var$_generateUtilityClasses.default)('MuiMultiSectionDigitalClockSection', [
    'root',
    'item'
]);

});


parcelRegister("lPzno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTimeSectionOptions = module.exports.getHourSectionOptions = void 0;
const $fe49cd62fa638160$var$getHourSectionOptions = ({ now: now, value: value, adapter: adapter, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep, valueOrReferenceDate: valueOrReferenceDate })=>{
    const currentHours = value ? adapter.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (resolvedCurrentHours === null) return false;
        if (ampm) {
            if (hour === 12) return resolvedCurrentHours === 12 || resolvedCurrentHours === 0;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>{
        return isSelected(hour, adapter.getHours(valueOrReferenceDate));
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = adapter.format(adapter.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = adapter.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            isFocused: isFocused,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
module.exports.getHourSectionOptions = $fe49cd62fa638160$var$getHourSectionOptions;
const $fe49cd62fa638160$var$getTimeSectionOptions = ({ value: value, adapter: adapter, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>{
        return value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: adapter.formatNumber(resolveLabel(timeValue)),
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};
module.exports.getTimeSectionOptions = $fe49cd62fa638160$var$getTimeSectionOptions;

});





parcelRegister("aZ46o", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7ff2c8750d82b477$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7ff2c8750d82b477$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DesktopDateTimePickerLayout = void 0;

var $7ff2c8750d82b477$var$React = $7ff2c8750d82b477$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7ff2c8750d82b477$var$_propTypes = $7ff2c8750d82b477$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7ff2c8750d82b477$var$_clsx = $7ff2c8750d82b477$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7ff2c8750d82b477$var$_Divider = $7ff2c8750d82b477$require$_interopRequireDefault((parcelRequire("g6BeY")));

var $g0CIC = parcelRequire("g0CIC");

var $6DVo4 = parcelRequire("6DVo4");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ const $7ff2c8750d82b477$var$DesktopDateTimePickerLayout = module.exports.DesktopDateTimePickerLayout = /*#__PURE__*/ $7ff2c8750d82b477$var$React.forwardRef(function DesktopDateTimePickerLayout(props, ref) {
    const { toolbar: toolbar, tabs: tabs, content: content, actionBar: actionBar, shortcuts: shortcuts, ownerState: ownerState } = (0, $g0CIC.usePickerLayout)(props);
    const { orientation: orientation } = (0, $6DVo4.usePickerContext)();
    const { sx: sx, className: className, classes: classes } = props;
    const isActionBarVisible = actionBar && (actionBar.props.actions?.length ?? 0) > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($g0CIC.PickersLayoutRoot, {
        ref: ref,
        className: (0, $7ff2c8750d82b477$var$_clsx.default)($g0CIC.pickersLayoutClasses.root, classes?.root, className),
        sx: [
            {
                [`& .${$g0CIC.pickersLayoutClasses.tabs}`]: {
                    gridRow: 4,
                    gridColumn: '1 / 4'
                },
                [`& .${$g0CIC.pickersLayoutClasses.actionBar}`]: {
                    gridRow: 5
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($g0CIC.PickersLayoutContentWrapper, {
                className: (0, $7ff2c8750d82b477$var$_clsx.default)($g0CIC.pickersLayoutClasses.contentWrapper, classes?.contentWrapper),
                ownerState: ownerState,
                sx: {
                    display: 'grid'
                },
                children: [
                    content,
                    tabs,
                    isActionBarVisible && /*#__PURE__*/ (0, $ayMG0.jsx)($7ff2c8750d82b477$var$_Divider.default, {
                        sx: {
                            gridRow: 3,
                            gridColumn: '1 / 4'
                        }
                    })
                ]
            }),
            actionBar
        ]
    });
});

});



parcelRegister("l0Lh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "MobileDateTimePicker", {
    enumerable: true,
    get: function() {
        return $frD2Q.MobileDateTimePicker;
    }
});

var $frD2Q = parcelRequire("frD2Q");

});
parcelRegister("frD2Q", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b3e7aa1da004c619$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b3e7aa1da004c619$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MobileDateTimePicker = void 0;

var $b3e7aa1da004c619$var$_extends2 = $b3e7aa1da004c619$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b3e7aa1da004c619$var$React = $b3e7aa1da004c619$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b3e7aa1da004c619$var$_propTypes = $b3e7aa1da004c619$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b3e7aa1da004c619$var$_resolveComponentProps = $b3e7aa1da004c619$require$_interopRequireDefault((parcelRequire("4sXkv")));

var $b3e7aa1da004c619$var$_refType = $b3e7aa1da004c619$require$_interopRequireDefault((parcelRequire("8KGQh")));

var $1M3bL = parcelRequire("1M3bL");

var $2EpWj = parcelRequire("2EpWj");

var $jHZPa = parcelRequire("jHZPa");

var $3nE24 = parcelRequire("3nE24");

var $5UoGz = parcelRequire("5UoGz");

var $cLPus = parcelRequire("cLPus");

var $5TrXg = parcelRequire("5TrXg");

var $l5kHo = parcelRequire("l5kHo");

var $3eed6 = parcelRequire("3eed6");

var $99eO4 = parcelRequire("99eO4");

var $2QxZ0 = parcelRequire("2QxZ0");

var $l16rr = parcelRequire("l16rr");

var $hOsJb = parcelRequire("hOsJb");

var $cElCc = parcelRequire("cElCc");

var $NRNex = parcelRequire("NRNex");
const $b3e7aa1da004c619$var$STEPS = [
    {
        views: $NRNex.DATE_VIEWS
    },
    {
        views: $cElCc.EXPORTED_TIME_VIEWS
    }
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateTimePicker API](https://mui.com/x/api/date-pickers/mobile-date-time-picker/)
 */ const $b3e7aa1da004c619$var$MobileDateTimePicker = module.exports.MobileDateTimePicker = /*#__PURE__*/ $b3e7aa1da004c619$var$React.forwardRef(function MobileDateTimePicker(inProps, ref) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $jHZPa.useDateTimePickerDefaultizedProps)(inProps, 'MuiMobileDateTimePicker');
    const renderTimeView = defaultizedProps.shouldRenderTimeInASingleColumn ? $l5kHo.renderDigitalClockTimeView : $l5kHo.renderMultiSectionDigitalClockTimeView;
    const viewRenderers = (0, $b3e7aa1da004c619$var$_extends2.default)({
        day: $5TrXg.renderDateViewCalendar,
        month: $5TrXg.renderDateViewCalendar,
        year: $5TrXg.renderDateViewCalendar,
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === $l5kHo.renderMultiSectionDigitalClockTimeView.name;
    const views = !shouldHoursRendererContainMeridiemView ? defaultizedProps.views.filter((view)=>view !== 'meridiem') : defaultizedProps.views;
    // Props with the default values specific to the mobile variant
    const props = (0, $b3e7aa1da004c619$var$_extends2.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $3eed6.resolveDateTimeFormat)(adapter, defaultizedProps),
        views: views,
        ampmInClock: ampmInClock,
        slots: (0, $b3e7aa1da004c619$var$_extends2.default)({
            field: $2EpWj.DateTimeField
        }, defaultizedProps.slots),
        slotProps: (0, $b3e7aa1da004c619$var$_extends2.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $b3e7aa1da004c619$var$_extends2.default)({}, (0, $b3e7aa1da004c619$var$_resolveComponentProps.default)(defaultizedProps.slotProps?.field, ownerState), (0, $5UoGz.extractValidationProps)(defaultizedProps)),
            toolbar: (0, $b3e7aa1da004c619$var$_extends2.default)({
                hidden: false,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $b3e7aa1da004c619$var$_extends2.default)({
                hidden: false
            }, defaultizedProps.slotProps?.tabs),
            layout: (0, $b3e7aa1da004c619$var$_extends2.default)({}, defaultizedProps.slotProps?.layout, {
                sx: (0, $l16rr.mergeSx)([
                    {
                        [`& .${$2QxZ0.multiSectionDigitalClockClasses.root}`]: {
                            width: $99eO4.DIALOG_WIDTH
                        },
                        [`& .${$2QxZ0.multiSectionDigitalClockSectionClasses.root}`]: {
                            flex: 1,
                            // account for the border on `MultiSectionDigitalClock`
                            maxHeight: $99eO4.VIEW_HEIGHT - 1,
                            [`.${$2QxZ0.multiSectionDigitalClockSectionClasses.item}`]: {
                                width: 'auto'
                            }
                        },
                        [`& .${$hOsJb.digitalClockClasses.root}`]: {
                            width: $99eO4.DIALOG_WIDTH,
                            maxHeight: $99eO4.VIEW_HEIGHT,
                            flex: 1,
                            [`.${$hOsJb.digitalClockClasses.item}`]: {
                                justifyContent: 'center'
                            }
                        }
                    }
                ], defaultizedProps.slotProps?.layout?.sx)
            })
        })
    });
    const { renderPicker: renderPicker } = (0, $cLPus.useMobilePicker)({
        ref: ref,
        props: props,
        valueManager: $1M3bL.singleItemValueManager,
        valueType: 'date-time',
        validator: $5UoGz.validateDateTime,
        steps: $b3e7aa1da004c619$var$STEPS
    });
    return renderPicker();
});
$b3e7aa1da004c619$var$MobileDateTimePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default adapter.is12HourCycleInCurrentLocale()
   */ ampm: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: $b3e7aa1da004c619$var$_propTypes.default.bool,
    className: $b3e7aa1da004c619$var$_propTypes.default.string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: $b3e7aa1da004c619$var$_propTypes.default.any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: $b3e7aa1da004c619$var$_propTypes.default.number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: $b3e7aa1da004c619$var$_propTypes.default.string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $b3e7aa1da004c619$var$_refType.default,
    /**
   * The label content.
   */ label: $b3e7aa1da004c619$var$_propTypes.default.node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: $b3e7aa1da004c619$var$_propTypes.default.number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: $b3e7aa1da004c619$var$_propTypes.default.string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: $b3e7aa1da004c619$var$_propTypes.default.oneOfType([
        $b3e7aa1da004c619$var$_propTypes.default.oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        $b3e7aa1da004c619$var$_propTypes.default.number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Disable specific time.
   * @param {PickerValidDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $b3e7aa1da004c619$var$_propTypes.default.oneOfType([
        $b3e7aa1da004c619$var$_propTypes.default.arrayOf($b3e7aa1da004c619$var$_propTypes.default.oneOfType([
            $b3e7aa1da004c619$var$_propTypes.default.func,
            $b3e7aa1da004c619$var$_propTypes.default.object,
            $b3e7aa1da004c619$var$_propTypes.default.bool
        ])),
        $b3e7aa1da004c619$var$_propTypes.default.func,
        $b3e7aa1da004c619$var$_propTypes.default.object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: $b3e7aa1da004c619$var$_propTypes.default.number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeSteps.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeSteps.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: $b3e7aa1da004c619$var$_propTypes.default.shape({
        hours: $b3e7aa1da004c619$var$_propTypes.default.number,
        minutes: $b3e7aa1da004c619$var$_propTypes.default.number,
        seconds: $b3e7aa1da004c619$var$_propTypes.default.number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: $b3e7aa1da004c619$var$_propTypes.default.string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: $b3e7aa1da004c619$var$_propTypes.default.shape({
        day: $b3e7aa1da004c619$var$_propTypes.default.func,
        hours: $b3e7aa1da004c619$var$_propTypes.default.func,
        meridiem: $b3e7aa1da004c619$var$_propTypes.default.func,
        minutes: $b3e7aa1da004c619$var$_propTypes.default.func,
        month: $b3e7aa1da004c619$var$_propTypes.default.func,
        seconds: $b3e7aa1da004c619$var$_propTypes.default.func,
        year: $b3e7aa1da004c619$var$_propTypes.default.func
    }),
    /**
   * Available views.
   */ views: $b3e7aa1da004c619$var$_propTypes.default.arrayOf($b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        3,
        4
    ])
};

});
parcelRegister("cLPus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useMobilePicker", {
    enumerable: true,
    get: function() {
        return $7a3Ek.useMobilePicker;
    }
});

var $7a3Ek = parcelRequire("7a3Ek");

});
parcelRegister("7a3Ek", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $536c4c4d895120f2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $536c4c4d895120f2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMobilePicker = void 0;

var $536c4c4d895120f2$var$_extends2 = $536c4c4d895120f2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $536c4c4d895120f2$var$_objectWithoutPropertiesLoose2 = $536c4c4d895120f2$require$_interopRequireDefault((parcelRequire("c05no")));

var $536c4c4d895120f2$var$React = $536c4c4d895120f2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $536c4c4d895120f2$var$_useSlotProps2 = $536c4c4d895120f2$require$_interopRequireDefault((parcelRequire("8rVIo")));

var $fpltD = parcelRequire("fpltD");

var $hz59J = parcelRequire("hz59J");

var $g0CIC = parcelRequire("g0CIC");

var $jk6Bf = parcelRequire("jk6Bf");

var $w6zXP = parcelRequire("w6zXP");

var $a2Tw3 = parcelRequire("a2Tw3");

var $ayMG0 = parcelRequire("ayMG0");
const $536c4c4d895120f2$var$_excluded = [
    "props",
    "steps"
], $536c4c4d895120f2$var$_excluded2 = [
    "ownerState"
];
/**
 * Hook managing all the single-date mobile pickers:
 * - MobileDatePicker
 * - MobileDateTimePicker
 * - MobileTimePicker
 */ const $536c4c4d895120f2$var$useMobilePicker = (_ref)=>{
    let { props: props, steps: steps } = _ref, pickerParams = (0, $536c4c4d895120f2$var$_objectWithoutPropertiesLoose2.default)(_ref, $536c4c4d895120f2$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $a2Tw3.createNonRangePickerStepNavigation)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $hz59J.usePicker)((0, $536c4c4d895120f2$var$_extends2.default)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'mobile',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, $536c4c4d895120f2$var$_useSlotProps2.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $536c4c4d895120f2$var$_extends2.default)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $536c4c4d895120f2$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $536c4c4d895120f2$var$_excluded2);
    const Layout = slots.layout ?? $g0CIC.PickersLayout;
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $536c4c4d895120f2$var$_extends2.default)({}, innerSlotProps, {
        toolbar: (0, $536c4c4d895120f2$var$_extends2.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $536c4c4d895120f2$var$_extends2.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($jk6Bf.PickerProvider, (0, $536c4c4d895120f2$var$_extends2.default)({}, providerProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($w6zXP.PickerFieldUIContextProvider, {
                slots: slots,
                slotProps: slotProps,
                inputRef: inputRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Field, (0, $536c4c4d895120f2$var$_extends2.default)({}, fieldProps)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fpltD.PickersModalDialog, {
                        slots: slots,
                        slotProps: slotProps,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Layout, (0, $536c4c4d895120f2$var$_extends2.default)({}, slotProps?.layout, {
                            slots: slots,
                            slotProps: slotProps,
                            children: renderCurrentView()
                        }))
                    })
                ]
            })
        }));
    return {
        renderPicker: renderPicker
    };
};
module.exports.useMobilePicker = $536c4c4d895120f2$var$useMobilePicker;

});
parcelRegister("fpltD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b379d9b00a13e481$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b379d9b00a13e481$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersModalDialog = $b379d9b00a13e481$var$PickersModalDialog;

var $b379d9b00a13e481$var$_extends2 = $b379d9b00a13e481$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b379d9b00a13e481$var$React = $b379d9b00a13e481$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b379d9b00a13e481$var$_DialogContent = $b379d9b00a13e481$require$_interopRequireDefault((parcelRequire("hJoSv")));

var $b379d9b00a13e481$var$_Fade = $b379d9b00a13e481$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $b379d9b00a13e481$var$_Dialog = $b379d9b00a13e481$require$_interopRequireWildcard((parcelRequire("iZIMH")));

var $d8seH = parcelRequire("d8seH");

var $99eO4 = parcelRequire("99eO4");

var $BKARN = parcelRequire("BKARN");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $b379d9b00a13e481$var$PickersModalDialogRoot = (0, $d8seH.default)($b379d9b00a13e481$var$_Dialog.default)({
    [`& .${$b379d9b00a13e481$var$_Dialog.dialogClasses.container}`]: {
        outline: 0
    },
    [`& .${$b379d9b00a13e481$var$_Dialog.dialogClasses.paper}`]: {
        outline: 0,
        minWidth: $99eO4.DIALOG_WIDTH
    }
});
const $b379d9b00a13e481$var$PickersModalDialogContent = (0, $d8seH.default)($b379d9b00a13e481$var$_DialogContent.default)({
    '&:first-of-type': {
        padding: 0
    }
});
function $b379d9b00a13e481$var$PickersModalDialog(props) {
    const { children: children, slots: slots, slotProps: slotProps } = props;
    const { open: open } = (0, $BKARN.usePickerContext)();
    const { dismissViews: dismissViews, onPopperExited: onPopperExited } = (0, $7OOd8.usePickerPrivateContext)();
    const Dialog = slots?.dialog ?? $b379d9b00a13e481$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? $b379d9b00a13e481$var$_Fade.default;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Dialog, (0, $b379d9b00a13e481$var$_extends2.default)({
        open: open,
        onClose: ()=>{
            dismissViews();
            onPopperExited?.();
        }
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b379d9b00a13e481$var$PickersModalDialogContent, {
            children: children
        })
    }));
}

});
parcelRegister("hJoSv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6Q1H5")).default);
$parcel$export(module.exports, "dialogContentClasses", () => (parcelRequire("hd5xz")).default);

var $6Q1H5 = parcelRequire("6Q1H5");

var $hd5xz = parcelRequire("hd5xz");
$parcel$exportWildcard(module.exports, $hd5xz);

});

parcelRegister("iZIMH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6MV2p")).default);
$parcel$export(module.exports, "dialogClasses", () => (parcelRequire("gX5bM")).default);

var $6MV2p = parcelRequire("6MV2p");

var $gX5bM = parcelRequire("gX5bM");
$parcel$exportWildcard(module.exports, $gX5bM);

});




parcelRegister("5TrXg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "renderDateViewCalendar", {
    enumerable: true,
    get: function() {
        return $8uN0h.renderDateViewCalendar;
    }
});

var $8uN0h = parcelRequire("8uN0h");

});





parcelRegister("4HKwc", function(module, exports) {

$parcel$export(module.exports, "differenceInDays", () => $beed7bfc27ef6789$export$86415ebf4eb36b8c);

var $j6qpa = parcelRequire("j6qpa");

var $9Jots = parcelRequire("9Jots");
function $beed7bfc27ef6789$export$86415ebf4eb36b8c(dateLeft, dateRight) {
    const _dateLeft = (0, $9Jots.toDate)(dateLeft);
    const _dateRight = (0, $9Jots.toDate)(dateRight);
    const sign = $beed7bfc27ef6789$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $j6qpa.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($beed7bfc27ef6789$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $beed7bfc27ef6789$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
var // Fallback for modularized imports:
$beed7bfc27ef6789$export$2e2bcd8739ae039 = $beed7bfc27ef6789$export$86415ebf4eb36b8c;

});

parcelRegister("lGkA3", function(module, exports) {

$parcel$export(module.exports, "differenceInHours", () => $8fc55af93c017018$export$5436ca250d4d6872);

var $uEr0V = parcelRequire("uEr0V");

var $klgYS = parcelRequire("klgYS");

var $ostXp = parcelRequire("ostXp");
function $8fc55af93c017018$export$5436ca250d4d6872(dateLeft, dateRight, options) {
    const diff = (0, $ostXp.differenceInMilliseconds)(dateLeft, dateRight) / (0, $klgYS.millisecondsInHour);
    return (0, $uEr0V.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$8fc55af93c017018$export$2e2bcd8739ae039 = $8fc55af93c017018$export$5436ca250d4d6872;

});

parcelRegister("3WoNO", function(module, exports) {

$parcel$export(module.exports, "differenceInMinutes", () => $a8c2246fb679421b$export$d904251335be481a);

var $uEr0V = parcelRequire("uEr0V");

var $klgYS = parcelRequire("klgYS");

var $ostXp = parcelRequire("ostXp");
function $a8c2246fb679421b$export$d904251335be481a(dateLeft, dateRight, options) {
    const diff = (0, $ostXp.differenceInMilliseconds)(dateLeft, dateRight) / (0, $klgYS.millisecondsInMinute);
    return (0, $uEr0V.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$a8c2246fb679421b$export$2e2bcd8739ae039 = $a8c2246fb679421b$export$d904251335be481a;

});

parcelRegister("e6g4k", function(module, exports) {

$parcel$export(module.exports, "SCHEDULE_MIN_DATE", () => $04b7b31c0ed06f3a$export$fbe8caced27bf97);
$parcel$export(module.exports, "SCHEDULE_MAX_DATE", () => $04b7b31c0ed06f3a$export$a77ed1c1c49fd64f);
/**
 * Date constants for the Schedule and Trip functionality
 */ // Minimum date for all schedule-related date pickers
// Prevents new customers from seeing/selecting dates before 2025
const $04b7b31c0ed06f3a$export$fbe8caced27bf97 = new Date("2025-01-02");
const $04b7b31c0ed06f3a$export$a77ed1c1c49fd64f = new Date("2030-12-31");

});

parcelRegister("85kUh", function(module, exports) {

$parcel$export(module.exports, "AssignLocationDialog", () => $76fa8168596cc11e$export$80a0ede96e267902);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $a7gZr = parcelRequire("a7gZr");

var $4ajQ4 = parcelRequire("4ajQ4");
const $76fa8168596cc11e$export$80a0ede96e267902 = ({ open: open, trip: trip, currentLocation: currentLocation, onClose: onClose, onAssign: onAssign })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [assigning, setAssigning] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [locations, setLocations] = (0, $acw62.useState)([]);
    const [selectedLocation, setSelectedLocation] = (0, $acw62.useState)("");
    // Date range state
    const [useCustomDates, setUseCustomDates] = (0, $acw62.useState)(false);
    const [startTime, setStartTime] = (0, $acw62.useState)(null);
    const [endTime, setEndTime] = (0, $acw62.useState)(null);
    const placementService = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    // Initialize dates when dialog opens
    (0, $acw62.useEffect)(()=>{
        if (!open || !trip) return;
        // Initialize date range to current time and trip departure (forward-fill)
        const now = new Date();
        const arrival = new Date(trip.arrival_date);
        const departure = new Date(trip.departure_date);
        // Start time is the later of now or arrival
        setStartTime(now > arrival ? now : arrival);
        setEndTime(departure);
        setUseCustomDates(false);
        setSelectedLocation(currentLocation || "unassigned");
    }, [
        open,
        trip,
        currentLocation
    ]);
    // Load available locations
    (0, $acw62.useEffect)(()=>{
        const loadLocations = async ()=>{
            if (!open || !trip || !activeFBO) return;
            setLoading(true);
            setError(null);
            try {
                // Check availability for the custom date range if set
                const checkStartTime = useCustomDates && startTime ? startTime.toISOString() : trip.arrival_date;
                const checkEndTime = useCustomDates && endTime ? endTime.toISOString() : trip.departure_date;
                const availableLocations = await placementService.getAvailableLocations(checkStartTime, checkEndTime, activeFBO.id);
                setLocations(availableLocations);
            } catch (err) {
                console.error("Failed to load locations:", err);
                setError(err.message || "Failed to load available locations");
            } finally{
                setLoading(false);
            }
        };
        loadLocations();
    }, [
        open,
        trip,
        activeFBO,
        placementService,
        useCustomDates,
        startTime,
        endTime
    ]);
    // Handle location assignment
    const handleAssign = async ()=>{
        if (!trip) {
            onClose();
            return;
        }
        setAssigning(true);
        setError(null);
        try {
            // Handle unassigned case
            if (selectedLocation === "unassigned") await placementService.assignToLocationWithGapFilling(trip.trip_id, null, null, useCustomDates && startTime ? startTime.toISOString() : undefined, useCustomDates && endTime ? endTime.toISOString() : undefined, true // excludeConflicts = true (allow overlaps)
            );
            else {
                // Find the selected location details
                const location = locations.find((l)=>l.id === selectedLocation);
                if (!location) throw new Error("Selected location not found");
                // Use the stored procedure method for assignments
                // Note: We allow conflicts (excludeConflicts = true) so users can assign anywhere
                await placementService.assignToLocationWithGapFilling(trip.trip_id, location.id, location.type, useCustomDates && startTime ? startTime.toISOString() : undefined, useCustomDates && endTime ? endTime.toISOString() : undefined, true // excludeConflicts = true (allow overlaps)
                );
            }
            // Success! Close dialog and refresh
            onAssign();
            onClose();
        } catch (err) {
            console.error("Failed to assign location:", err);
            setError(err.message || "Failed to assign location");
        } finally{
            setAssigning(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ajQ4.AssignLocationDialogPresenter), {
        open: open,
        onClose: onClose,
        trip: trip,
        currentLocation: currentLocation,
        loading: loading,
        assigning: assigning,
        error: error,
        setError: setError,
        locations: locations,
        selectedLocation: selectedLocation,
        setSelectedLocation: setSelectedLocation,
        useCustomDates: useCustomDates,
        setUseCustomDates: setUseCustomDates,
        startTime: startTime,
        setStartTime: setStartTime,
        endTime: endTime,
        setEndTime: setEndTime,
        handleAssign: handleAssign
    });
};

});
parcelRegister("4ajQ4", function(module, exports) {

$parcel$export(module.exports, "AssignLocationDialogPresenter", () => $ef3411fb17c4152b$export$8ca4967f03c14624);

var $ayMG0 = parcelRequire("ayMG0");

var $hbZ6O = parcelRequire("hbZ6O");

var $aF8PJ = parcelRequire("aF8PJ");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $2cPwN = parcelRequire("2cPwN");
var $bnA1h = parcelRequire("bnA1h");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $gd5y7 = parcelRequire("gd5y7");
var $2esSG = parcelRequire("2esSG");
var $9SK5h = parcelRequire("9SK5h");
var $hrMZe = parcelRequire("hrMZe");
var $8IWga = parcelRequire("8IWga");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $78ow6 = parcelRequire("78ow6");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $kfA3C = parcelRequire("kfA3C");
var $7761d = parcelRequire("7761d");

var $acw62 = parcelRequire("acw62");

var $e6g4k = parcelRequire("e6g4k");

var $gtiLb = parcelRequire("gtiLb");

var $apzof = parcelRequire("apzof");
const $ef3411fb17c4152b$export$8ca4967f03c14624 = ({ open: open, onClose: onClose, trip: trip, currentLocation: currentLocation, loading: loading, assigning: assigning, error: error, setError: setError, locations: locations, selectedLocation: selectedLocation, setSelectedLocation: setSelectedLocation, setUseCustomDates: setUseCustomDates, startTime: startTime, setStartTime: setStartTime, endTime: endTime, setEndTime: setEndTime, handleAssign: handleAssign })=>{
    const [showCustomDates, setShowCustomDates] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Group locations by type
    const hangars = locations.filter((l)=>l.type === "hangar");
    const ramps = locations.filter((l)=>l.type === "ramp");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "xs",
        fullWidth: true,
        PaperProps: {
            sx: {
                borderRadius: 2
            },
            elevation: 1
        },
        sx: {
            zIndex: 9600
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 0.5,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "h6",
                            children: "Assign Aircraft to Location"
                        }),
                        trip && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "body2",
                            color: "text.secondary",
                            children: [
                                trip.tail_number,
                                " \u2022",
                                " ",
                                (0, $kfA3C.format)((0, $7761d.parseISO)(trip.arrival_date), "MMM d"),
                                " -",
                                " ",
                                (0, $kfA3C.format)((0, $7761d.parseISO)(trip.departure_date), "MMM d, yyyy")
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                dividers: true,
                children: [
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                        severity: "error",
                        sx: {
                            mb: 1.5
                        },
                        onClose: ()=>setError(null),
                        children: error
                    }),
                    loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        spacing: 0.5,
                        children: Array.from({
                            length: 5
                        }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                variant: "rectangular",
                                height: 40,
                                sx: {
                                    borderRadius: 1
                                }
                            }, i))
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                        component: "fieldset",
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8IWga.default), {
                            value: selectedLocation,
                            onChange: (e)=>setSelectedLocation(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    onClick: ()=>setSelectedLocation("unassigned"),
                                    sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        px: 1.5,
                                        py: 1,
                                        borderRadius: 1,
                                        cursor: "pointer",
                                        bgcolor: selectedLocation === "unassigned" ? "primary.50" : "transparent",
                                        "&:hover": {
                                            bgcolor: selectedLocation === "unassigned" ? "primary.50" : "grey.50"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        value: "unassigned",
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {
                                            size: "small"
                                        }),
                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    children: "Keep Unassigned"
                                                }),
                                                currentLocation === null && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                    label: "Current",
                                                    size: "small",
                                                    color: "primary",
                                                    variant: "outlined",
                                                    sx: {
                                                        height: 20,
                                                        fontSize: "0.7rem"
                                                    }
                                                })
                                            ]
                                        }),
                                        sx: {
                                            m: 0,
                                            width: "100%",
                                            pointerEvents: "none"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                    sx: {
                                        my: 1.5
                                    }
                                }),
                                hangars.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        mb: 1.5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                mb: 0.5,
                                                fontWeight: 600,
                                                color: "text.secondary",
                                                px: 1.5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtiLb.HangarIcon), {
                                                    sx: {
                                                        fontSize: 16
                                                    }
                                                }),
                                                "Hangars"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                            spacing: 0.5,
                                            children: hangars.map((location)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                    onClick: ()=>setSelectedLocation(location.id),
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        px: 1.5,
                                                        py: 1,
                                                        borderRadius: 1,
                                                        cursor: "pointer",
                                                        bgcolor: selectedLocation === location.id ? "primary.50" : "transparent",
                                                        "&:hover": {
                                                            bgcolor: selectedLocation === location.id ? "primary.50" : "grey.50"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                        value: location.id,
                                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {
                                                            size: "small"
                                                        }),
                                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            alignItems: "center",
                                                            spacing: 1,
                                                            sx: {
                                                                width: "100%"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    sx: {
                                                                        flexGrow: 1
                                                                    },
                                                                    children: location.name
                                                                }),
                                                                currentLocation === location.id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                    label: "Current",
                                                                    size: "small",
                                                                    color: "primary",
                                                                    variant: "outlined",
                                                                    sx: {
                                                                        height: 20,
                                                                        fontSize: "0.7rem"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        sx: {
                                                            m: 0,
                                                            width: "100%",
                                                            pointerEvents: "none"
                                                        }
                                                    })
                                                }, location.id))
                                        })
                                    ]
                                }),
                                ramps.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                mb: 0.5,
                                                fontWeight: 600,
                                                color: "text.secondary",
                                                px: 1.5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $apzof.RampIcon), {
                                                    sx: {
                                                        fontSize: 16
                                                    }
                                                }),
                                                "Ramps"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                            spacing: 0.5,
                                            children: ramps.map((location)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                    onClick: ()=>setSelectedLocation(location.id),
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        px: 1.5,
                                                        py: 1,
                                                        borderRadius: 1,
                                                        cursor: "pointer",
                                                        bgcolor: selectedLocation === location.id ? "primary.50" : "transparent",
                                                        "&:hover": {
                                                            bgcolor: selectedLocation === location.id ? "primary.50" : "grey.50"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                        value: location.id,
                                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {
                                                            size: "small"
                                                        }),
                                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            alignItems: "center",
                                                            spacing: 1,
                                                            sx: {
                                                                width: "100%"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    sx: {
                                                                        flexGrow: 1
                                                                    },
                                                                    children: location.name
                                                                }),
                                                                currentLocation === location.id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                    label: "Current",
                                                                    size: "small",
                                                                    color: "primary",
                                                                    variant: "outlined",
                                                                    sx: {
                                                                        height: 20,
                                                                        fontSize: "0.7rem"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        sx: {
                                                            m: 0,
                                                            width: "100%",
                                                            pointerEvents: "none"
                                                        }
                                                    })
                                                }, location.id))
                                        })
                                    ]
                                }),
                                locations.length === 0 && !loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                    severity: "info",
                                    sx: {
                                        mt: 1
                                    },
                                    children: "No locations available for the selected time period."
                                })
                            ]
                        })
                    }),
                    trip && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            mt: 2,
                            pt: 2,
                            borderTop: 1,
                            borderColor: "divider"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9SK5h.default), {
                                component: "button",
                                variant: "body2",
                                onClick: ()=>{
                                    setShowCustomDates(!showCustomDates);
                                    if (!showCustomDates) setUseCustomDates(true);
                                    else setUseCustomDates(false);
                                },
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {
                                        sx: {
                                            fontSize: 18,
                                            transform: showCustomDates ? "rotate(180deg)" : "none",
                                            transition: "transform 0.2s"
                                        }
                                    }),
                                    "Custom time range"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnA1h.default), {
                                in: showCustomDates,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        mt: 1.5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
                                            dateAdapter: (0, $78ow6.AdapterDateFns),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 1.5,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                                        label: "Start Time",
                                                        value: startTime,
                                                        onChange: (value)=>setStartTime(value),
                                                        minDate: (0, $e6g4k.SCHEDULE_MIN_DATE),
                                                        minDateTime: new Date(trip.arrival_date),
                                                        maxDateTime: endTime || new Date(trip.departure_date),
                                                        slotProps: {
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true
                                                            }
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                                        label: "End Time",
                                                        value: endTime,
                                                        onChange: (value)=>setEndTime(value),
                                                        minDate: (0, $e6g4k.SCHEDULE_MIN_DATE),
                                                        minDateTime: startTime || new Date(trip.arrival_date),
                                                        maxDateTime: new Date(trip.departure_date),
                                                        slotProps: {
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true
                                                            }
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        startTime && endTime && selectedLocation && selectedLocation !== "unassigned" && (startTime > new Date(trip.arrival_date) || endTime < new Date(trip.departure_date)) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                            severity: "info",
                                            sx: {
                                                mt: 1.5,
                                                py: 0.5
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                sx: {
                                                    display: "block"
                                                },
                                                children: "Unassigned periods will be created before/after this time range"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                sx: {
                    px: 2,
                    py: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: onClose,
                        disabled: assigning,
                        size: "small",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleAssign,
                        variant: "contained",
                        disabled: assigning || loading || !selectedLocation,
                        startIcon: assigning ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                            size: 16
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aF8PJ))), {}),
                        size: "small",
                        children: assigning ? "Assigning..." : "Assign"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("bnA1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $848dc8709a4309c5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $1mPeS = parcelRequire("1mPeS");

var $lHOu3 = parcelRequire("lHOu3");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $bmoVh = parcelRequire("bmoVh");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $38bi6 = parcelRequire("38bi6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $38bi6.getCollapseUtilityClass), classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $bmoVh.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $14H9o.default)();
    const timer = (0, $lHOu3.default)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseRoot, {
                as: component,
                className: (0, $9QePP.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ownerState: {
                    ...ownerState,
                    state: state
                },
                ...restChildProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state: state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state: state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if ($848dc8709a4309c5$var$Collapse) $848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$export$2e2bcd8739ae039 = $848dc8709a4309c5$var$Collapse;

});
parcelRegister("38bi6", function(module, exports) {

$parcel$export(module.exports, "getCollapseUtilityClass", () => $247ae09dccc3464c$export$5162da8f798e0959);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $247ae09dccc3464c$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)('MuiCollapse', slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $beCSm.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $247ae09dccc3464c$export$2e2bcd8739ae039 = $247ae09dccc3464c$var$collapseClasses;

});


parcelRegister("9SK5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $731ce78e0c47d0a7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8gMkr = parcelRequire("8gMkr");


var $8Indx = parcelRequire("8Indx");

var $52FI1 = parcelRequire("52FI1");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $3bYfT = parcelRequire("3bYfT");

var $lLIcc = parcelRequire("lLIcc");

var $2LVI8 = parcelRequire("2LVI8");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $731ce78e0c47d0a7$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $731ce78e0c47d0a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $jTnBY.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lLIcc.getLinkUtilityClass), classes);
};
const $731ce78e0c47d0a7$var$LinkRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $jTnBY.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.4)` : (0, $8gMkr.alpha)(theme.palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $8gMkr.alpha)(theme.palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.secondaryChannel} / 0.4)` : (0, $8gMkr.alpha)(theme.palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $lLIcc.default).focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $731ce78e0c47d0a7$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $14H9o.default)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $52FI1.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $52FI1.default)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $731ce78e0c47d0a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($731ce78e0c47d0a7$var$LinkRoot, {
        color: color,
        className: (0, $9QePP.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$731ce78e0c47d0a7$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$731ce78e0c47d0a7$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $2LVI8.default)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $731ce78e0c47d0a7$export$2e2bcd8739ae039 = $731ce78e0c47d0a7$var$Link;

});
parcelRegister("lLIcc", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", () => $fd904517f2a78af6$export$d6efab9620b78fec);
$parcel$export(module.exports, "default", () => $fd904517f2a78af6$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd904517f2a78af6$export$d6efab9620b78fec(slot) {
    return (0, $4Cod0.default)('MuiLink', slot);
}
const $fd904517f2a78af6$var$linkClasses = (0, $beCSm.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $fd904517f2a78af6$export$2e2bcd8739ae039 = $fd904517f2a78af6$var$linkClasses;

});

parcelRegister("2LVI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $204cbcbead979fad$export$2e2bcd8739ae039);

var $85acy = parcelRequire("85acy");

var $8gMkr = parcelRequire("8gMkr");
const $204cbcbead979fad$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $85acy.getPath)(theme, `palette.${transformedColor}.main`, false) || (0, $85acy.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $85acy.getPath)(theme, `palette.${transformedColor}.mainChannel`) || (0, $85acy.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $8gMkr.alpha)(color, 0.4);
};
var $204cbcbead979fad$export$2e2bcd8739ae039 = $204cbcbead979fad$var$getTextDecoration;

});


parcelRegister("hrMZe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3af4fea2cad44e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $kVqvD = parcelRequire("kVqvD");

var $9plBP = parcelRequire("9plBP");

var $jTnBY = parcelRequire("jTnBY");

var $5gbhl = parcelRequire("5gbhl");

var $cJQfW = parcelRequire("cJQfW");

var $k0Fx1 = parcelRequire("k0Fx1");

var $iHxWE = parcelRequire("iHxWE");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $6lpak = parcelRequire("6lpak");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $cb3af4fea2cad44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            size !== 'medium' && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $8Indx.default)(slots, (0, $iHxWE.getRadioUtilityClass), classes)
    };
};
const $cb3af4fea2cad44e$var$RadioRoot = (0, $d8seH.default)((0, $kVqvD.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $iHxWE.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8gMkr.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $iHxWE.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $cb3af4fea2cad44e$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $cb3af4fea2cad44e$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9plBP.default), {
    checked: true
});
const $cb3af4fea2cad44e$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9plBP.default), {});
const $cb3af4fea2cad44e$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $cb3af4fea2cad44e$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $cb3af4fea2cad44e$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ??= false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $cb3af4fea2cad44e$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $k0Fx1.default)();
    let checked = checkedProp;
    const onChange = (0, $5gbhl.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $cb3af4fea2cad44e$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $cb3af4fea2cad44e$var$RadioRoot,
        className: (0, $9QePP.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $cb3af4fea2cad44e$export$2e2bcd8739ae039 = $cb3af4fea2cad44e$var$Radio;

});
parcelRegister("9plBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d9735fee3c00fe1$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $k0iyu = parcelRequire("k0iyu");

var $jA2KS = parcelRequire("jA2KS");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6d9735fee3c00fe1$var$RadioButtonIconRoot = (0, $d8seH.default)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $8Uq77.default)
})({
    position: 'relative',
    display: 'flex'
});
const $6d9735fee3c00fe1$var$RadioButtonIconBackground = (0, $d8seH.default)((0, $k0iyu.default), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $6d9735fee3c00fe1$var$RadioButtonIconDot = (0, $d8seH.default)((0, $jA2KS.default), {
    name: 'MuiRadioButtonIcon'
})((0, $aeD7H.default)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $6d9735fee3c00fe1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6d9735fee3c00fe1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $6d9735fee3c00fe1$export$2e2bcd8739ae039 = $6d9735fee3c00fe1$var$RadioButtonIcon;

});
parcelRegister("k0iyu", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c2199a765ab5af$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $03c2199a765ab5af$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

});

parcelRegister("jA2KS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e413843d0810bb75$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $e413843d0810bb75$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

});


parcelRegister("5gbhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d47321b9fcbcb38$export$2e2bcd8739ae039);

var $hPGQj = parcelRequire("hPGQj");
var $3d47321b9fcbcb38$export$2e2bcd8739ae039 = (0, $hPGQj.default);

});

parcelRegister("k0Fx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9140607eee18105$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $lsybK = parcelRequire("lsybK");
'use client';
function $e9140607eee18105$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $lsybK.default));
}

});
parcelRegister("lsybK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9f6bb9b992d33b5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $f9f6bb9b992d33b5$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $f9f6bb9b992d33b5$export$2e2bcd8739ae039 = $f9f6bb9b992d33b5$var$RadioGroupContext;

});


parcelRegister("iHxWE", function(module, exports) {

$parcel$export(module.exports, "getRadioUtilityClass", () => $d9d692e9561f6352$export$192f7b2363c77155);
$parcel$export(module.exports, "default", () => $d9d692e9561f6352$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d9d692e9561f6352$export$192f7b2363c77155(slot) {
    return (0, $4Cod0.default)('MuiRadio', slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $beCSm.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $d9d692e9561f6352$export$2e2bcd8739ae039 = $d9d692e9561f6352$var$radioClasses;

});


parcelRegister("8IWga", function(module, exports) {

$parcel$export(module.exports, "default", () => $659f9ff12b4e3755$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $6Tegk = parcelRequire("6Tegk");

var $gWj0r = parcelRequire("gWj0r");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3yddg = parcelRequire("3yddg");

var $lsybK = parcelRequire("lsybK");

var $5A6d3 = parcelRequire("5A6d3");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $659f9ff12b4e3755$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $gWj0r.getRadioGroupUtilityClass), classes);
};
const $659f9ff12b4e3755$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $acw62.useRef(null);
    const classes = $659f9ff12b4e3755$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $3yddg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $acw62.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $9Rgf1.default)(ref, rootRef);
    const name = (0, $5A6d3.default)(nameProp);
    const contextValue = $acw62.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsybK.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Tegk.default), {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var $659f9ff12b4e3755$export$2e2bcd8739ae039 = $659f9ff12b4e3755$var$RadioGroup;

});
parcelRegister("6Tegk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5042f159189dda87$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $j5wWn = parcelRequire("j5wWn");

var $cJQfW = parcelRequire("cJQfW");

var $aaphR = parcelRequire("aaphR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $j5wWn.getFormGroupUtilityClass), classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $5042f159189dda87$export$2e2bcd8739ae039 = $5042f159189dda87$var$FormGroup;

});
parcelRegister("j5wWn", function(module, exports) {

$parcel$export(module.exports, "getFormGroupUtilityClass", () => $de580948e3d734b1$export$d72d4cbdc30b331f);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $de580948e3d734b1$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)('MuiFormGroup', slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $beCSm.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $de580948e3d734b1$export$2e2bcd8739ae039 = $de580948e3d734b1$var$formGroupClasses;

});


parcelRegister("gWj0r", function(module, exports) {

$parcel$export(module.exports, "getRadioGroupUtilityClass", () => $c550ce5d3f5617f8$export$c4cff3a43f7cabb6);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c550ce5d3f5617f8$export$c4cff3a43f7cabb6(slot) {
    return (0, $4Cod0.default)('MuiRadioGroup', slot);
}
const $c550ce5d3f5617f8$var$radioGroupClasses = (0, $beCSm.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $c550ce5d3f5617f8$export$2e2bcd8739ae039 = $c550ce5d3f5617f8$var$radioGroupClasses;

});




parcelRegister("35bYL", function(module, exports) {

$parcel$export(module.exports, "CreateTripDialog", () => $53d911938ab5ce23$export$5ce47d685ff39800);

var $ayMG0 = parcelRequire("ayMG0");

var $7S0ew = parcelRequire("7S0ew");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $aKUfR = parcelRequire("aKUfR");

var $lQ8IB = parcelRequire("lQ8IB");

var $keHtM = parcelRequire("keHtM");

var $gYLUy = parcelRequire("gYLUy");

var $gPNwt = parcelRequire("gPNwt");
const $53d911938ab5ce23$export$5ce47d685ff39800 = ({ open: open, onClose: onClose, onSuccess: onSuccess, initialArrivalDate: initialArrivalDate, initialDepartureDate: initialDepartureDate, currentLocationId: currentLocationId, currentLocationType: currentLocationType, simpleMode: simpleMode = false, existingTenant: existingTenant })=>{
    // Initialize shared hook with initial form data
    const initialFormData = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            arrivalDate: initialArrivalDate || new Date(),
            departureDate: initialDepartureDate || (0, $7S0ew.addDays)(initialArrivalDate || new Date(), 2)
        }), [
        initialArrivalDate,
        initialDepartureDate
    ]);
    const { formData: formData, setFormData: setFormData, loading: loading, error: error, validationErrors: validationErrors, createTrip: createTrip, setError: setError, isFormValid: isFormValid, tenants: tenants } = (0, $aKUfR.useCreateTrip)(initialFormData);
    // Additional UI state
    const [conflictWarning, setConflictWarning] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [checkingConflicts, setCheckingConflicts] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Initialize services for conflict checking
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const tripService = (0, $acw62.useMemo)(()=>new (0, $lQ8IB.TripService)(postgrest), [
        postgrest
    ]);
    // Reset form when dialog opens/closes
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            // Calculate dates with proper validation
            const arrivalDate = initialArrivalDate || new Date();
            let departureDate = initialDepartureDate || (0, $7S0ew.addDays)(arrivalDate, 2);
            // Ensure departure is after arrival
            if (departureDate <= arrivalDate) departureDate = (0, $7S0ew.addDays)(arrivalDate, 2);
            if (simpleMode && existingTenant) // In simple mode, pre-populate with existing tenant data
            setFormData({
                tailNumber: existingTenant.tail_number || "",
                ownerManager: existingTenant.owner_manager || "",
                tenantType: (0, $keHtM.TenantType).TRANSIENT,
                selectedAircraft: existingTenant.aircraft_model ? {
                    id: "",
                    make: existingTenant.aircraft_manufacturer || "",
                    model: existingTenant.aircraft_model || ""
                } : null,
                selectedTenant: {
                    id: existingTenant.tenant_id,
                    tail_number: existingTenant.tail_number,
                    owner_manager: existingTenant.owner_manager,
                    aircraft: existingTenant.aircraft_model ? {
                        id: "",
                        make: existingTenant.aircraft_manufacturer || "",
                        model: existingTenant.aircraft_model || ""
                    } : undefined
                },
                arrivalDate: arrivalDate,
                departureDate: departureDate,
                notes: ""
            });
            else // Normal mode - empty form
            setFormData({
                tailNumber: "",
                ownerManager: "",
                tenantType: (0, $keHtM.TenantType).TRANSIENT,
                selectedAircraft: null,
                selectedTenant: null,
                arrivalDate: arrivalDate,
                departureDate: departureDate,
                notes: ""
            });
            setError(null);
            setConflictWarning(null);
        }
    }, [
        open,
        initialArrivalDate,
        initialDepartureDate,
        simpleMode,
        existingTenant,
        setFormData,
        setError
    ]);
    // Check for conflicts with existing trips
    const checkForConflicts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (tenantId, arrival, departure)=>{
        if (!tenantId || !arrival || !departure) return null;
        try {
            const existingTrips = await tripService.listTripsByTenant(tenantId);
            // Check each existing trip for overlap
            for (const trip of existingTrips){
                const existingArrival = new Date(trip.arrival_date);
                const existingDeparture = trip.departure_date; // Keep as string, might be infinity
                // Handle infinity dates in overlap detection
                const isCurrentInfinity = (0, $gYLUy.isInfinityDate)(departure);
                const isExistingInfinity = (0, $gYLUy.isInfinityDate)(existingDeparture);
                let overlaps = false;
                if (isCurrentInfinity || isExistingInfinity) // Infinity trips overlap with all future trips from the same tenant
                overlaps = isCurrentInfinity || isExistingInfinity;
                else {
                    // Both finite - use standard overlap logic
                    const departureDate = new Date(departure);
                    const existingDepartureDate = new Date(existingDeparture);
                    overlaps = arrival >= existingArrival && arrival < existingDepartureDate || departureDate > existingArrival && departureDate <= existingDepartureDate || arrival <= existingArrival && departureDate >= existingDepartureDate;
                }
                if (overlaps) {
                    const arrivalStr = existingArrival.toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "2-digit"
                    });
                    const departureStr = isExistingInfinity ? "No scheduled departure" : new Date(existingDeparture).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "2-digit"
                    });
                    return `This aircraft already has a trip scheduled from ${arrivalStr} to ${departureStr}. Please adjust your dates to avoid overlap.`;
                }
            }
        } catch (error) {
            console.error("Failed to check for conflicts:", error);
        // Don't block creation if we can't check - database will enforce
        }
        return null;
    }, [
        tripService
    ]);
    // Handle tenant selection from SelectTailNumber
    const handleTenantChange = (tenant)=>{
        if (tenant) // Autofill form fields from selected tenant
        setFormData({
            selectedTenant: tenant,
            tailNumber: tenant.tail_number || "",
            ownerManager: tenant.owner_manager || "",
            tenantType: tenant.type || (0, $keHtM.TenantType).TRANSIENT,
            selectedAircraft: tenant.aircraft || null
        });
        else setFormData({
            selectedTenant: null
        });
    };
    // Handle tail number input change
    const handleTailNumberChange = (tailNumber)=>{
        setFormData({
            tailNumber: tailNumber
        });
        // Clear selected tenant if user is typing a new tail number
        if (formData.selectedTenant && formData.selectedTenant.tail_number !== tailNumber) setFormData({
            selectedTenant: null
        });
        // Clear conflict warning when changing aircraft
        setConflictWarning(null);
    };
    // Check for conflicts when dates or tenant change
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (formData.selectedTenant && formData.arrivalDate && formData.departureDate && open) {
            setCheckingConflicts(true);
            checkForConflicts(formData.selectedTenant.id, formData.arrivalDate, formData.departureDate).then((conflict)=>{
                setConflictWarning(conflict);
                setCheckingConflicts(false);
            }).catch(()=>{
                setCheckingConflicts(false);
            });
        } else setConflictWarning(null);
    }, [
        formData.selectedTenant,
        formData.arrivalDate,
        formData.departureDate,
        open,
        checkForConflicts
    ]);
    // Handle form submission
    const handleSubmit = async ()=>{
        try {
            const trip = await createTrip({
                locationId: currentLocationId,
                locationType: currentLocationType,
                useGapFilling: false // Use atomic createTripWithLocation for dialog
            });
            onSuccess(trip);
            onClose();
        } catch (err) {
            console.error("Failed to create trip:", err);
        // Error is already set by the shared hook
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gPNwt.CreateTripDialogPresenter), {
        open: open,
        onClose: onClose,
        formData: formData,
        setFormData: setFormData,
        handleTenantChange: handleTenantChange,
        handleTailNumberChange: handleTailNumberChange,
        handleSubmit: handleSubmit,
        validationErrors: validationErrors,
        isFormValid: isFormValid,
        loading: loading,
        checkingConflicts: checkingConflicts,
        error: error,
        setError: setError,
        conflictWarning: conflictWarning,
        setConflictWarning: setConflictWarning,
        tenants: tenants,
        currentLocationId: currentLocationId,
        currentLocationType: currentLocationType,
        simpleMode: simpleMode,
        existingTenant: existingTenant
    });
};

});
parcelRegister("aKUfR", function(module, exports) {

$parcel$export(module.exports, "useCreateTrip", () => $7fe1ea28844b025e$export$41e9fb2aa481b797);

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $a7gZr = parcelRequire("a7gZr");

var $lQ8IB = parcelRequire("lQ8IB");

var $keHtM = parcelRequire("keHtM");

var $gYLUy = parcelRequire("gYLUy");

var $9OZOC = parcelRequire("9OZOC");
const $7fe1ea28844b025e$var$initialFormData = {
    tailNumber: "",
    ownerManager: "",
    tenantType: (0, $keHtM.TenantType).TRANSIENT,
    selectedAircraft: null,
    selectedTenant: null,
    arrivalDate: null,
    departureDate: null,
    notes: ""
};
const $7fe1ea28844b025e$export$41e9fb2aa481b797 = (initialData)=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { tenants: tenants } = (0, $9OZOC.useTenants)();
    // Services
    const tripService = (0, $acw62.useMemo)(()=>new (0, $lQ8IB.TripService)(postgrest), [
        postgrest
    ]);
    const placementService = (0, $acw62.useMemo)(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    // Form state
    const [formData, setFormDataState] = (0, $acw62.useState)({
        ...$7fe1ea28844b025e$var$initialFormData,
        ...initialData
    });
    // UI state
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [validationErrors, setValidationErrors] = (0, $acw62.useState)({});
    // Form data setter
    const setFormData = (0, $acw62.useCallback)((data)=>{
        setFormDataState((prev)=>({
                ...prev,
                ...data
            }));
        // Clear validation errors for fields that are being updated
        setValidationErrors((prev)=>{
            const newErrors = {
                ...prev
            };
            Object.keys(data).forEach((key)=>{
                if (key in newErrors) delete newErrors[key];
            });
            return newErrors;
        });
    }, []);
    // Helper function to find or create tenant
    const findOrCreateTenant = (0, $acw62.useCallback)(async (tailNumber, tenantType, ownerManager, selectedAircraft)=>{
        // Check existing tenants first
        const existingTenant = tenants.find((t)=>t.tail_number?.toLowerCase() === tailNumber.toLowerCase());
        if (existingTenant) return existingTenant.id;
        // For new tenant, require aircraft to be selected
        if (!selectedAircraft) throw new Error("Aircraft selection is required for new tenants");
        if (!activeFBO?.id) throw new Error("No active FBO selected");
        const { data: newTenant, error: tenantError } = await postgrest.from("tenant").insert({
            fbo_id: activeFBO.id,
            tail_number: tailNumber.trim(),
            aircraft_id: selectedAircraft.id,
            type: tenantType,
            owner_manager: ownerManager.trim() || null
        }).select().single();
        if (tenantError) throw new Error(`Failed to create tenant: ${tenantError.message}`);
        return newTenant.id;
    }, [
        tenants,
        activeFBO,
        postgrest
    ]);
    // Check for overlapping trips
    const checkForOverlaps = (0, $acw62.useCallback)((arrivalDate, departureDate, existingTrips)=>{
        if (!arrivalDate || !departureDate || !existingTrips.length) return null;
        const isCurrentInfinity = (0, $gYLUy.isInfinityDate)(departureDate);
        // Check each existing trip for overlap
        for (const trip of existingTrips){
            const existingArrival = new Date(trip.arrival_date);
            const isExistingInfinity = (0, $gYLUy.isInfinityDate)(trip.departure_date);
            let hasOverlap = false;
            if (isCurrentInfinity || isExistingInfinity) // Infinity trips overlap with all other trips for the same tenant
            hasOverlap = true;
            else {
                // Both finite - use standard overlap logic
                const departureAsDate = typeof departureDate === 'string' ? new Date(departureDate) : departureDate;
                const existingDeparture = new Date(trip.departure_date);
                hasOverlap = arrivalDate >= existingArrival && arrivalDate < existingDeparture || departureAsDate > existingArrival && departureAsDate <= existingDeparture || arrivalDate <= existingArrival && departureAsDate >= existingDeparture || existingArrival <= arrivalDate && existingDeparture >= departureAsDate;
            }
            if (hasOverlap) {
                const formatDate = (date)=>{
                    return date.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                };
                const departureStr = isExistingInfinity ? "No scheduled departure" : formatDate(new Date(trip.departure_date));
                return `Overlaps with existing trip: ${formatDate(existingArrival)} - ${departureStr}`;
            }
        }
        return null;
    }, []);
    // Form validation
    const validateForm = (0, $acw62.useCallback)((existingTrips)=>{
        const errors = {};
        if (!formData.tailNumber.trim()) errors.tailNumber = "Tail number is required";
        if (!formData.selectedAircraft && !formData.selectedTenant?.aircraft) errors.aircraft = "Aircraft selection is required. Either select an existing tail number or manually choose an aircraft.";
        if (!formData.arrivalDate) errors.arrivalDate = "Arrival date is required";
        if (!formData.departureDate) errors.departureDate = "Departure date is required";
        // Skip date comparison if departure is infinity (base tenant)
        if (formData.arrivalDate && formData.departureDate && !(0, $gYLUy.isInfinityDate)(formData.departureDate) && formData.arrivalDate >= formData.departureDate) errors.departureDate = "Departure must be after arrival";
        // Check for overlaps with existing trips if provided
        if (existingTrips && existingTrips.length > 0) {
            const overlapMessage = checkForOverlaps(formData.arrivalDate, formData.departureDate, existingTrips);
            if (overlapMessage) {
                errors.overlap = overlapMessage;
                // Also set specific errors on date fields
                errors.arrivalDate = errors.arrivalDate || "Dates overlap with existing trip";
                errors.departureDate = errors.departureDate || "Dates overlap with existing trip";
            }
        }
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    }, [
        formData,
        checkForOverlaps
    ]);
    // Create trip
    const createTrip = (0, $acw62.useCallback)(async (options = {})=>{
        if (!validateForm()) throw new Error("Form validation failed");
        if (!activeFBO?.id) throw new Error("No active FBO selected");
        setLoading(true);
        setError(null);
        try {
            // Find or create tenant
            const tenantId = await findOrCreateTenant(formData.tailNumber, formData.tenantType, formData.ownerManager, formData.selectedAircraft || formData.selectedTenant?.aircraft || null);
            // Create trip data
            const tripData = {
                tenant_id: tenantId,
                fbo_id: activeFBO.id,
                arrival_date: formData.arrivalDate.toISOString(),
                // Handle infinity string or convert Date to ISO string
                departure_date: typeof formData.departureDate === 'string' ? formData.departureDate : formData.departureDate.toISOString(),
                status: "scheduled",
                notes: formData.notes.trim() || undefined
            };
            let trip;
            // Create trip with or without location assignment
            if (options.locationId && options.locationType) {
                if (options.useGapFilling) {
                    // Use regular createTrip + assignToLocationWithGapFilling for AddTripTab
                    trip = await tripService.createTrip(tripData);
                    await placementService.assignToLocationWithGapFilling(trip.id, options.locationId, options.locationType, formData.arrivalDate.toISOString(), // Handle infinity string or convert Date to ISO string
                    typeof formData.departureDate === 'string' ? formData.departureDate : formData.departureDate.toISOString());
                } else // Use atomic createTripWithLocation for CreateTripDialog
                trip = await tripService.createTripWithLocation(tripData, options.locationId, options.locationType);
            } else // No location assignment
            trip = await tripService.createTrip(tripData);
            return trip;
        } catch (err) {
            const errorMessage = err.message || "Failed to create trip. Please try again.";
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally{
            setLoading(false);
        }
    }, [
        activeFBO,
        findOrCreateTenant,
        tripService,
        placementService,
        validateForm,
        formData
    ]);
    // Reset form
    const resetForm = (0, $acw62.useCallback)(()=>{
        setFormDataState({
            ...$7fe1ea28844b025e$var$initialFormData,
            ...initialData
        });
        setValidationErrors({});
        setError(null);
    }, [
        initialData
    ]);
    // Derived state
    const isFormValid = (0, $acw62.useMemo)(()=>{
        // Check if departure is infinity (base tenant)
        const hasValidDeparture = formData.departureDate && ((0, $gYLUy.isInfinityDate)(formData.departureDate) || formData.arrivalDate && formData.departureDate instanceof Date && formData.arrivalDate < formData.departureDate);
        return !!(formData.tailNumber.trim() && (formData.selectedAircraft || formData.selectedTenant?.aircraft) && formData.arrivalDate && hasValidDeparture);
    }, [
        formData
    ]);
    return {
        formData: formData,
        setFormData: setFormData,
        loading: loading,
        error: error,
        validationErrors: validationErrors,
        createTrip: createTrip,
        validateForm: validateForm,
        resetForm: resetForm,
        setError: setError,
        checkForOverlaps: checkForOverlaps,
        isFormValid: isFormValid,
        tenants: tenants
    };
};

});

parcelRegister("gPNwt", function(module, exports) {

$parcel$export(module.exports, "CreateTripDialogPresenter", () => $146692a43be7bc7d$export$91c041cc8ae8bb68);

var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");
var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $2esSG = parcelRequire("2esSG");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $78ow6 = parcelRequire("78ow6");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $7S0ew = parcelRequire("7S0ew");

var $acw62 = parcelRequire("acw62");

var $keHtM = parcelRequire("keHtM");

var $e6g4k = parcelRequire("e6g4k");

var $gYLUy = parcelRequire("gYLUy");
parcelRequire("bPruZ");
var $gDfVd = parcelRequire("gDfVd");

var $hTRQz = parcelRequire("hTRQz");
const $146692a43be7bc7d$export$91c041cc8ae8bb68 = ({ open: open, onClose: onClose, formData: formData, setFormData: setFormData, handleTenantChange: handleTenantChange, handleTailNumberChange: handleTailNumberChange, handleSubmit: handleSubmit, validationErrors: validationErrors, isFormValid: isFormValid, loading: loading, checkingConflicts: checkingConflicts, error: error, setError: setError, conflictWarning: conflictWarning, setConflictWarning: setConflictWarning, tenants: tenants, currentLocationId: currentLocationId, currentLocationType: currentLocationType, simpleMode: simpleMode = false, existingTenant: existingTenant })=>{
    // Track whether "No scheduled departure" checkbox is checked
    const [noScheduledDeparture, setNoScheduledDeparture] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Sync checkbox state with formData.departureDate
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setNoScheduledDeparture((0, $gYLUy.isInfinityDate)(formData.departureDate));
    }, [
        formData.departureDate
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
        dateAdapter: (0, $78ow6.AdapterDateFns),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
            open: open,
            onClose: onClose,
            maxWidth: "sm",
            fullWidth: true,
            "aria-labelledby": "create-trip-dialog-title",
            PaperProps: {
                sx: {
                    // iPad optimization
                    maxWidth: {
                        xs: "100%",
                        sm: "500px",
                        md: "600px"
                    },
                    margin: {
                        xs: 1,
                        sm: 2
                    },
                    maxHeight: {
                        xs: "100vh",
                        sm: "85vh"
                    },
                    zIndex: 9600 // Higher than TripDetailsModal (9500)
                }
            },
            sx: {
                zIndex: 9600 // Ensure backdrop is also above TripDetailsModal
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                    id: "create-trip-dialog-title",
                    children: simpleMode && existingTenant ? `New Trip for ${existingTenant.tail_number}` : "Create New Trip"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 3,
                        sx: {
                            mt: 1
                        },
                        children: [
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                severity: "error",
                                onClose: ()=>setError(null),
                                children: error
                            }),
                            conflictWarning && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                severity: "warning",
                                onClose: ()=>setConflictWarning(null),
                                action: checkingConflicts ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 20
                                }) : undefined,
                                children: conflictWarning
                            }),
                            simpleMode && existingTenant ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                severity: "info",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: existingTenant.tail_number
                                        }),
                                        existingTenant.owner_manager && ` \u{2022} ${existingTenant.owner_manager}`,
                                        existingTenant.aircraft_model && ` \u{2022} ${existingTenant.aircraft_model}`
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gDfVd.SelectTailNumber), {
                                        disableAutocomplete: false,
                                        defaultValue: "",
                                        tenants: tenants,
                                        onInputChange: handleTailNumberChange,
                                        onChange: handleTenantChange,
                                        warning: validationErrors.tailNumber
                                    }, open ? "dialog-open" : "dialog-closed"),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                label: "Owner/Manager",
                                                value: formData.ownerManager,
                                                onChange: (e)=>setFormData({
                                                        ownerManager: e.target.value
                                                    }),
                                                fullWidth: true,
                                                size: "small",
                                                placeholder: "e.g., John Smith"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                                select: true,
                                                label: "Type",
                                                value: formData.tenantType,
                                                onChange: (e)=>setFormData({
                                                        tenantType: e.target.value
                                                    }),
                                                size: "small",
                                                sx: {
                                                    minWidth: 120
                                                },
                                                SelectProps: {
                                                    MenuProps: {
                                                        sx: {
                                                            zIndex: 10000 // Higher than dialog (9600)
                                                        }
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: (0, $keHtM.TenantType).TRANSIENT,
                                                        children: "Transient"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: (0, $keHtM.TenantType).BASE,
                                                        children: "Base"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                                                label: "Search by make and model",
                                                onSelect: (aircraft)=>setFormData({
                                                        selectedAircraft: aircraft
                                                    }),
                                                defaultSelected: formData.selectedAircraft
                                            }, formData.selectedAircraft?.id || "no-aircraft"),
                                            validationErrors.aircraft && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "error",
                                                sx: {
                                                    mt: 0.5
                                                },
                                                children: validationErrors.aircraft
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: [
                                            "Arrival Date & Time ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    color: 'red'
                                                },
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                        label: "",
                                        value: formData.arrivalDate,
                                        onChange: (newValue)=>setFormData({
                                                arrivalDate: newValue
                                            }),
                                        minDate: (0, $e6g4k.SCHEDULE_MIN_DATE),
                                        ampm: false,
                                        minutesStep: 15,
                                        maxDate: (0, $e6g4k.SCHEDULE_MAX_DATE),
                                        slotProps: {
                                            textField: {
                                                fullWidth: true,
                                                required: true,
                                                size: "small",
                                                error: !!validationErrors.arrivalDate,
                                                helperText: validationErrors.arrivalDate
                                            },
                                            popper: {
                                                sx: {
                                                    zIndex: 10000 // Higher than dialog (9600)
                                                }
                                            }
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                children: [
                                                    "Departure Date & Time ",
                                                    !noScheduledDeparture && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            color: 'red'
                                                        },
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                    checked: noScheduledDeparture,
                                                    onChange: (e)=>{
                                                        const checked = e.target.checked;
                                                        setNoScheduledDeparture(checked);
                                                        if (checked) // Set departure to infinity
                                                        setFormData({
                                                            departureDate: (0, $gYLUy.INFINITY_DATE_STRING)
                                                        });
                                                        else {
                                                            // Reset to default (2 days from arrival)
                                                            const defaultDeparture = formData.arrivalDate ? (0, $7S0ew.addDays)(formData.arrivalDate, 2) : (0, $7S0ew.addDays)(new Date(), 2);
                                                            setFormData({
                                                                departureDate: defaultDeparture
                                                            });
                                                        }
                                                    },
                                                    disabled: loading
                                                }),
                                                label: "No departure"
                                            })
                                        ]
                                    }),
                                    !noScheduledDeparture ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                        label: "",
                                        value: formData.departureDate instanceof Date ? formData.departureDate : null,
                                        onChange: (newValue)=>setFormData({
                                                departureDate: newValue
                                            }),
                                        minDate: formData.arrivalDate && formData.arrivalDate > (0, $e6g4k.SCHEDULE_MIN_DATE) ? formData.arrivalDate : (0, $e6g4k.SCHEDULE_MIN_DATE),
                                        ampm: false,
                                        minutesStep: 15,
                                        minDateTime: formData.arrivalDate || undefined,
                                        maxDate: (0, $e6g4k.SCHEDULE_MAX_DATE),
                                        slotProps: {
                                            textField: {
                                                fullWidth: true,
                                                required: true,
                                                size: "small",
                                                error: !!validationErrors.departureDate,
                                                helperText: validationErrors.departureDate
                                            },
                                            popper: {
                                                sx: {
                                                    zIndex: 10000 // Higher than dialog (9600)
                                                }
                                            }
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                        severity: "info",
                                        sx: {
                                            mt: 1
                                        },
                                        children: "This aircraft will remain at the FBO indefinitely with no scheduled departure."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                label: "Notes",
                                value: formData.notes,
                                onChange: (e)=>setFormData({
                                        notes: e.target.value
                                    }),
                                multiline: true,
                                rows: 3,
                                fullWidth: true,
                                size: "small",
                                placeholder: "Any special requirements or notes..."
                            }),
                            simpleMode ? currentLocationId ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                                severity: "success",
                                children: [
                                    "This trip will be automatically assigned to the current",
                                    " ",
                                    currentLocationType,
                                    "."
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                severity: "info",
                                children: "The trip will be created for this aircraft and can be positioned after creation."
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    !currentLocationId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                        severity: "info",
                                        children: 'The aircraft will be initially placed as "unassigned" and can be positioned in a hangar or ramp area after creation.'
                                    }),
                                    currentLocationId && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                                        severity: "success",
                                        children: [
                                            "This trip will be automatically assigned to the current",
                                            " ",
                                            currentLocationType,
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: onClose,
                            disabled: loading,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: handleSubmit,
                            variant: "contained",
                            disabled: loading || !isFormValid || !!conflictWarning,
                            title: conflictWarning ? "Cannot create trip - overlaps with existing trip" : !isFormValid ? "Please fill in all required fields" : "",
                            children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                size: 24
                            }) : "Create Trip"
                        })
                    ]
                })
            ]
        })
    });
};

});






parcelRegister("eFVLn", function(module, exports) {

$parcel$export(module.exports, "useOnPositionChange", () => $3aa7d9735cd01701$export$bb0ef7947048adfc);

var $acw62 = parcelRequire("acw62");

var $4o1tI = parcelRequire("4o1tI");

var $lNEp2 = parcelRequire("lNEp2");

var $7R9OT = parcelRequire("7R9OT");
const $3aa7d9735cd01701$export$bb0ef7947048adfc = (props, deps = [])=>{
    const onMoveTenantEvent = (0, $4o1tI.useEventContainer)();
    const { location: location, stack: stack, setStack: setStack } = props;
    return $acw62.useCallback((entity_id, position)=>{
        const tenantMoved = stack.tenants.find((t)=>t.entity_id === entity_id);
        (0, $7R9OT.default).track("Aircraft Movement", {
            location_name: location.name,
            location_type: location.type,
            location_tenant_type: stack?.isReference ? "reference" : "current",
            aircraft_type: tenantMoved?.aircraft?.model,
            aircraft_tail_number: tenantMoved?.tail_number,
            aircraft_tenant_type: tenantMoved?.type
        });
        /**
      * I think this was preventing the user from putting the plane "under" the current info card.
    if (!disableDragProtection && position.x && position.x < -1 * span) {
      position.x = 0;
    }
    */ const updatedTenant = stack.tenants.find((t)=>t.entity_id === entity_id);
        const tenant = updatedTenant && {
            ...updatedTenant,
            last_hangared: new Date().toISOString(),
            position: {
                id: (0, $lNEp2.uuidv4)(),
                ...updatedTenant.position,
                ...position
            }
        };
        const updatedMovableObstacle = stack.movableObstacles.find((mo)=>mo.entity_id === entity_id);
        const movableObstacle = updatedMovableObstacle && {
            ...updatedMovableObstacle,
            position: {
                id: (0, $lNEp2.uuidv4)(),
                ...updatedMovableObstacle.position,
                ...position
            }
        };
        setStack({
            ...stack,
            tenants: stack.tenants.map((t)=>t.id === tenant?.id ? tenant : t),
            movableObstacles: stack.movableObstacles.map((mo)=>mo.id === movableObstacle?.id ? movableObstacle : mo)
        });
        if (updatedTenant) onMoveTenantEvent.emitEvent("moveEntity", {
            data: {
                direction: "anything",
                entity: {
                    entity_type: "tenant",
                    ...tenant
                },
                previousPosition: updatedTenant.position,
                locationId: location.id
            }
        });
        if (updatedMovableObstacle) onMoveTenantEvent.emitEvent("moveEntity", {
            data: {
                direction: "anything",
                entity: {
                    entity_type: "movableObstacle",
                    ...movableObstacle
                },
                previousPosition: updatedMovableObstacle.position,
                locationId: location.id
            }
        });
    }, deps);
};

});
parcelRegister("4o1tI", function(module, exports) {

$parcel$export(module.exports, "useEventContainer", () => $f936738ffff15c98$export$737f985c5a7de28);
$parcel$export(module.exports, "EventContainerProvider", () => $f936738ffff15c98$export$77c6976975fd8dc);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $f936738ffff15c98$var$EventContainerContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $f936738ffff15c98$export$737f985c5a7de28 = ()=>{
    const context = (0, $acw62.useContext)($f936738ffff15c98$var$EventContainerContext);
    if (!context) throw new Error('useEventContainer must be used within an EventContainerProvider');
    return context;
};
const $f936738ffff15c98$export$77c6976975fd8dc = ({ children: children })=>{
    const emitEvent = (eventType, payload)=>{
        if (eventListeners[eventType]) eventListeners[eventType].forEach((listener)=>listener(payload));
    };
    const addEventListener = (eventType, callback)=>{
        if (!eventListeners[eventType]) eventListeners[eventType] = [];
        eventListeners[eventType].push(callback);
    };
    const removeEventListener = (eventType, callback)=>{
        if (eventListeners[eventType]) eventListeners[eventType] = eventListeners[eventType].filter((listener)=>listener !== callback);
    };
    const eventListeners = {};
    const contextValue = {
        emitEvent: emitEvent,
        addEventListener: addEventListener,
        removeEventListener: removeEventListener
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f936738ffff15c98$var$EventContainerContext.Provider, {
        value: contextValue,
        children: children
    });
};

});



parcelRegister("dd9SG", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteTenant", () => $ae390dc125bcad47$export$f868121d75842b2d);

var $lLxKB = parcelRequire("lLxKB");

var $acw62 = parcelRequire("acw62");

var $7p8YN = parcelRequire("7p8YN");

var $6fDLr = parcelRequire("6fDLr");

var $g7var = parcelRequire("g7var");

var $5U03M = parcelRequire("5U03M");
const $ae390dc125bcad47$export$f868121d75842b2d = (props, deps = [])=>{
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { isMultiHangar: isMultiHangar, hangars: hangars } = (0, $7p8YN.useMultiHangarState)();
    const { hangarId: hangarId, enabled: enabled, stack: stack, preferences: preferences, isInLayout: isInLayout, autocomplete: autocomplete, autocompleteResults: autocompleteResults, setAutocompleteResults: setAutocompleteResults } = props;
    return $acw62.useCallback(async (tenant)=>{
        if (!enabled) return;
        if (!preferences.enableCoPilot || !autocomplete) return;
        if (isInLayout(tenant) && hangarId !== (0, $5U03M.HOLDING_AREA_ID)) return;
        // Prevent concurrent autocomplete runs (fixes infinite notification loop)
        if (autocompleteResults?.loading) return;
        const hash = (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify(isMultiHangar ? hangars.map((h)=>h.stack) : stack));
        const currentOrientation = (0, $g7var.getOrientation)(tenant);
        // need to also test that our cached results are still valid based on the
        // other tenants
        if (autocompleteResults?.id === tenant.id && currentOrientation === autocompleteResults?.orientation && hash === autocompleteResults?.hash) return;
        // marker to indicate we've started the autocomplete process
        setAutocompleteResults({
            id: tenant.id,
            hash: hash,
            tenant: tenant,
            loading: true,
            orientation: currentOrientation,
            suggestedPositions: []
        });
        const suggestedPositions = await autocomplete(tenant);
        setAutocompleteResults({
            id: tenant.id,
            hash: hash,
            tenant: tenant,
            loading: false,
            orientation: currentOrientation,
            suggestedPositions: suggestedPositions
        });
        if (suggestedPositions.length === 0) snackbar.notify({
            text: `No viable positions found.`,
            severity: "warning"
        });
    }, deps);
};

});

parcelRegister("d1mLJ", function(module, exports) {

$parcel$export(module.exports, "useDimensions", () => $8fd67bc8ff3790d3$export$d04af0e501fb729f);
const $8fd67bc8ff3790d3$export$d04af0e501fb729f = (props)=>{
    const { location: location } = props;
    let { width: width, height: height } = props;
    if (width) height = width * (location?.depth / location?.width);
    else if (height) width = height * (location?.width / location?.depth);
    else {
        width = 300;
        height = width * (location?.depth / location?.width);
    }
    const feetToPixels = width / location?.width;
    return {
        width: width,
        height: height,
        feetToPixels: feetToPixels
    };
};

});

parcelRegister("6ERoB", function(module, exports) {

$parcel$export(module.exports, "useGetClickedEntity", () => $104a1556210d8737$export$dd6f5480343b583);
parcelRequire("9vNAe");
var $g2BFU = parcelRequire("g2BFU");

var $acw62 = parcelRequire("acw62");

var $cLNZr = parcelRequire("cLNZr");
const $104a1556210d8737$export$dd6f5480343b583 = (props, deps = [])=>{
    const { bboxRef: bboxRef, stack: stack, polygons: polygons, feetToPixels: feetToPixels } = props;
    return $acw62.useCallback((evt)=>{
        if (!bboxRef.current) return {
            entity: null,
            mousePosition: {
                x: null,
                y: null,
                absoluteX: null,
                absoluteY: null
            }
        };
        const bounds = bboxRef.current.getBoundingClientRect();
        const x = (evt.clientX - bounds.left) / feetToPixels;
        const y = (bounds.bottom - evt.clientY) / feetToPixels;
        const clickedEntities = [];
        for (const { entity_id: entity_id, polygon: polygon } of polygons)if ($g2BFU.pointInPolygon([
            x,
            y
        ], polygon.coordinates[0])) {
            const tenantFound = stack.tenants.find((t)=>t.entity_id === entity_id);
            if (tenantFound) {
                clickedEntities.push({
                    ...tenantFound,
                    entity_type: "tenant"
                });
                continue;
            }
            const movableObstacleFound = stack.movableObstacles.find((t)=>t.entity_id === entity_id);
            if (movableObstacleFound) {
                clickedEntities.push({
                    ...movableObstacleFound,
                    entity_type: "movableObstacle"
                });
                continue;
            }
        }
        if (!clickedEntities.length) return {
            entity: null,
            mousePosition: {
                x: x,
                y: y,
                absoluteX: evt.clientX,
                absoluteY: evt.clientY
            }
        };
        let entity;
        if (clickedEntities.length === 1) return {
            entity: {
                ...clickedEntities[0]
            },
            mousePosition: {
                x: x,
                y: y,
                absoluteX: evt.clientX,
                absoluteY: evt.clientY
            }
        };
        else {
            // first look for one that's already selected
            entity = clickedEntities.find((t)=>t.selected);
            if (entity) return {
                entity: entity,
                mousePosition: {
                    x: x,
                    y: y,
                    absoluteX: evt.clientX,
                    absoluteY: evt.clientY
                }
            };
            // otherwise pick the tallest plane
            return {
                entity: (0, $cLNZr.orderBy)(clickedEntities, [
                    (item)=>'aircraft' in item ? item.aircraft.tail_height : 0
                ], [
                    "desc"
                ])[0],
                mousePosition: {
                    x: x,
                    y: y,
                    absoluteX: evt.clientX,
                    absoluteY: evt.clientY
                }
            };
        }
    }, deps);
};

});

parcelRegister("gHTMg", function(module, exports) {

$parcel$export(module.exports, "useGetIndexOfGhostAircraftHoveringOver", () => $37c0d3f13c441fb8$export$e4206b5bc8768658);
parcelRequire("9vNAe");
var $g2BFU = parcelRequire("g2BFU");

var $acw62 = parcelRequire("acw62");
const $37c0d3f13c441fb8$export$e4206b5bc8768658 = (bboxRef, stack, ghostPolygons, feetToPixels, width)=>{
    return $acw62.useCallback((evt)=>{
        if (!bboxRef.current) return null;
        const bounds = bboxRef.current.getBoundingClientRect();
        const x = (evt.clientX - bounds.left) / feetToPixels;
        const y = (bounds.bottom - evt.clientY) / feetToPixels;
        let i = 0;
        for (const { polygon: polygon } of ghostPolygons){
            if ($g2BFU.pointInPolygon([
                x,
                y
            ], polygon.coordinates[0])) return i;
            i++;
        }
    }, [
        stack,
        ghostPolygons,
        width
    ]);
};

});

parcelRegister("4okQ5", function(module, exports) {

$parcel$export(module.exports, "useIsInLayout", () => $91bd236b9d9a11c7$export$8ceb17d9f688344);
$parcel$export(module.exports, "useIsInAnyLayout", () => $91bd236b9d9a11c7$export$7bccc423c0d6c07b);
parcelRequire("9vNAe");
var $dfdxy = parcelRequire("dfdxy");

var $acw62 = parcelRequire("acw62");

var $7p8YN = parcelRequire("7p8YN");

var $5KGQl = parcelRequire("5KGQl");

var $5U03M = parcelRequire("5U03M");
const $91bd236b9d9a11c7$export$8ceb17d9f688344 = (props, deps = [])=>{
    const { location: location, polygons: polygons } = props;
    return $acw62.useCallback((tenant, buffer = 2.5)=>{
        const { polygon: polygon } = polygons.find((p)=>p.entity_id === tenant.entity_id);
        const layoutPolygon = [
            [
                -buffer,
                -buffer
            ],
            [
                location.width + buffer,
                -buffer
            ],
            [
                location.width + buffer,
                location.depth + buffer
            ],
            [
                -buffer,
                location.depth + buffer
            ],
            [
                -buffer,
                -buffer
            ]
        ];
        return (0, $dfdxy.polygonInPolygon)(polygon.coordinates[0].map(([x, y])=>[
                x,
                y
            ]), layoutPolygon);
    }, deps);
};
const $91bd236b9d9a11c7$export$7bccc423c0d6c07b = (props, deps = [])=>{
    const { feetToPixels: feetToPixels } = props;
    const { hangars: hangars } = (0, $7p8YN.useMultiHangarState)();
    return $acw62.useCallback((tenant, buffer = 2.5)=>{
        const polygons = hangars.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID)).map((hangar)=>({
                hangar: [
                    [
                        -buffer,
                        -buffer
                    ],
                    [
                        hangar.width + buffer,
                        -buffer
                    ],
                    [
                        hangar.width + buffer,
                        hangar.depth + buffer
                    ],
                    [
                        -buffer,
                        hangar.depth + buffer
                    ],
                    [
                        -buffer,
                        -buffer
                    ]
                ],
                tenants: (0, $5KGQl.getStackPolygons)(hangar.stack, hangar.width, feetToPixels, null, false)
            }));
        for (const polygon of polygons){
            const tenantPolygon = polygon.tenants.find((t)=>t.entity_id === tenant.entity_id)?.polygon;
            if (!tenantPolygon) continue;
            if ((0, $dfdxy.polygonInPolygon)(tenantPolygon.coordinates[0].map(([x, y])=>[
                    x,
                    y
                ]), polygon.hangar)) return true;
        }
        return false;
    }, [
        ...deps,
        hangars,
        feetToPixels
    ]);
};

});

parcelRegister("7EoDj", function(module, exports) {

$parcel$export(module.exports, "useMovableObstacles", () => $b64a6db442057516$export$3b40c3326a1e7b81);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jhw2A = parcelRequire("jhw2A");

var $eFVLn = parcelRequire("eFVLn");
const $b64a6db442057516$export$73b2f16e6a60ae8 = (position)=>{
    return position.x !== null && position.y !== null && position.angle !== null;
};
const $b64a6db442057516$export$3b40c3326a1e7b81 = (props, deps = [])=>{
    const { location: location, stack: stack, setStack: setStack, height: height, readOnly: readOnly, feetToPixels: feetToPixels, rightClick: rightClick, setRightClick: setRightClick, preferences: preferences, spacingBufferOverlayElement: spacingBufferOverlayElement, options: options } = props;
    const onPositionChange = (0, $eFVLn.useOnPositionChange)({
        location: location,
        stack: stack,
        setStack: setStack
    }, [
        stack.tenants,
        stack.movableObstacles,
        setStack,
        location
    ]);
    // Override preferences based on layout options, similar to useAircraft
    const overriddenPreferences = {
        ...preferences,
        forceDisplayTailNumber: options.hideTailNumbers ? false : preferences.forceDisplayTailNumber,
        forceDisplayModel: options.hideTailNumbers ? false : preferences.forceDisplayModel,
        notes: options.hideNotes ? false : preferences.notes
    };
    return $acw62.useMemo(()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: stack?.movableObstacles.map((movableObstacle)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jhw2A.FullyLoadedDraggableObstacle), {
                        readOnly: readOnly,
                        layoutHeight: height,
                        feetToPixels: feetToPixels,
                        movableObstacle: {
                            ...movableObstacle,
                            selected: movableObstacle.selected || rightClick?.entity_id === movableObstacle.entity_id
                        },
                        stack: stack,
                        setStack: setStack,
                        preferences: overriddenPreferences,
                        onPositionChange: onPositionChange,
                        rightClick: rightClick,
                        setRightClick: setRightClick,
                        spacingBufferOverlayElement: spacingBufferOverlayElement
                    })
                }, `draggable-movableobstacle-${stack.id}-${movableObstacle.entity_id}`);
            })
        }), deps);
};

});
parcelRegister("jhw2A", function(module, exports) {

$parcel$export(module.exports, "FullyLoadedDraggableObstacle", () => $aff05df3c4843137$export$71d6fcf8823c014f);

var $ayMG0 = parcelRequire("ayMG0");

var $6el2W = parcelRequire("6el2W");
parcelRequire("acw62");
parcelRequire("awKYK");
var $34myE = parcelRequire("34myE");

var $tdfUy = parcelRequire("tdfUy");

var $54aSv = parcelRequire("54aSv");

var $ZrAde = parcelRequire("ZrAde");
const $aff05df3c4843137$export$71d6fcf8823c014f = ({ movableObstacle: movableObstacle, feetToPixels: feetToPixels, stack: stack, setStack: setStack, preferences: preferences, layoutHeight: layoutHeight, onPositionChange: onPositionChange, rightClick: rightClick, setRightClick: setRightClick, spacingBufferOverlayElement: spacingBufferOverlayElement, readOnly: readOnly = false })=>{
    const imageDimensions = {
        ...(0, $tdfUy.calculateObstacleImageDimensions)(feetToPixels, movableObstacle)
    };
    const position = {
        x: movableObstacle.position.x * feetToPixels,
        y: movableObstacle.position.y * feetToPixels,
        angle: movableObstacle.position.angle,
        timestamp: movableObstacle.position.timestamp
    };
    // This assumes the y position is an alignment to the bottom of the
    // hangar and this reverses it to align to the top to pass on to
    // the DraggableAircraftNew
    position.y = layoutHeight - (position.y + imageDimensions.height);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34myE.DraggableAircraft), {
                entity_id: movableObstacle.entity_id,
                hideDragIndicator: true,
                readOnly: readOnly,
                spacingBufferOverlayElement: !readOnly && preferences.showSOPSpacing ? spacingBufferOverlayElement : null,
                forceDisplayLabel: preferences.forceDisplayTailNumber || preferences.forceDisplayModel,
                label: movableObstacle.obstacle.name,
                aircraft: {
                    // From PredefinedObstacle
                    id: movableObstacle.obstacle.id,
                    length: movableObstacle.obstacle.length,
                    geom: movableObstacle.obstacle.geom ?? null,
                    geomz: movableObstacle.obstacle.geomz ?? null,
                    image: (0, $54aSv.getObstacleImageUrl)(movableObstacle.obstacle.id),
                    created_at: movableObstacle.obstacle.created_at ?? new Date().toISOString(),
                    // Required Aircraft fields with sensible defaults
                    linked_to: "",
                    make: "",
                    model: movableObstacle.obstacle.name,
                    wingspan: movableObstacle.obstacle.width,
                    midline: movableObstacle.obstacle.length / 2,
                    tail_height: movableObstacle.obstacle.height,
                    side_image: "",
                    nose: null,
                    centroid: null,
                    wheel_rotation_limit: 0,
                    front_wheels: 0,
                    rear_wheels: 300,
                    wing_geom: null,
                    wing_top: 0,
                    wing_bottom: 0,
                    tail_geom: null,
                    tail_top: 0,
                    tail_bottom: 0,
                    vertical_tail_fin_geom: null,
                    vertical_tail_fin_top: 0,
                    vertical_tail_fin_bottom: 0,
                    cabin_top: 0,
                    cabin_bottom: 0,
                    reference_point_wing_bottom: 0,
                    reference_point_wing_top: 0,
                    reference_point_tail_bottom: 0,
                    reference_point_tail_top: 0,
                    reference_point_cabin_bottom: 0,
                    reference_point_cabin_top: 0,
                    reference_point_vertical_tail_fin_bottom: 0,
                    reference_point_vertical_tail_fin_top: 0,
                    propeller_geom: null,
                    placement_id: movableObstacle.placement_id,
                    tail_number: movableObstacle.obstacle.name,
                    // Position and state
                    position: position,
                    selected: movableObstacle.selected,
                    spacing_buffer_geom: null,
                    spacing_buffer_geom_dimensions: {
                        width: 0,
                        height: 0
                    }
                },
                imageDimensions: imageDimensions,
                onPositionChange: (position)=>{
                    // Adjust the position to be aligned to the bottom
                    // as it will come from the component aligned to the top
                    // Switch the y position to align to the bottom of the hangar
                    position.y = layoutHeight - (position.y + imageDimensions.height);
                    const fullPosition = {
                        id: movableObstacle.position.id,
                        stack_id: movableObstacle.position.stack_id,
                        entity_id: movableObstacle.entity_id,
                        x: position.x / feetToPixels,
                        y: position.y / feetToPixels,
                        angle: position.angle,
                        preferences: movableObstacle.position.preferences ?? [],
                        timestamp: position.timestamp
                    };
                    onPositionChange(movableObstacle.entity_id, fullPosition);
                },
                onChange: ()=>{
                //
                },
                onPlaneClick: ()=>{
                // moved to the global onclick event
                },
                onPlaneRightClick: ()=>{
                // moved to the global onclick event
                },
                onStartTowing: ()=>{
                    var mo;
                    return;
                },
                onClickNotesButton: ()=>{
                // No notes functionality for obstacles
                },
                feetToPixels: feetToPixels
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
                id: `popover-right-click-${movableObstacle.entity_id}`,
                open: rightClick?.entity_id === movableObstacle.entity_id,
                onClose: ()=>setRightClick(null),
                anchorReference: "anchorPosition",
                anchorPosition: rightClick !== null ? {
                    top: rightClick.mouseY,
                    left: rightClick.mouseX
                } : undefined,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ZrAde.MovableObstacleContextMenu), {
                    onDelete: async ()=>{
                        setStack({
                            ...stack,
                            movableObstacles: stack.movableObstacles.filter((e)=>e.entity_id !== movableObstacle.entity_id)
                        });
                        setRightClick(null);
                    },
                    menuProps: {
                        open: true
                    }
                })
            })
        ]
    });
};

});
parcelRegister("54aSv", function(module, exports) {

$parcel$export(module.exports, "getObstacleImageUrl", () => $b670c0df7eaa43e0$export$2c7f7aaccab3e690);
const $b670c0df7eaa43e0$export$2c7f7aaccab3e690 = (obstacleId, imageFilename)=>{
    // Use the stored filename if available, otherwise default to .png
    const filename = imageFilename || `${obstacleId}.png`;
    // Always use the CDN URL for consistent image loading
    return `https://static.airplx.com/${filename}`;
};

});



parcelRegister("8cYjj", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $3f8389b9a4e08839$export$a81c45382e7253ac);

var $acw62 = parcelRequire("acw62");

var $7R9OT = parcelRequire("7R9OT");
const $3f8389b9a4e08839$var$spliceInTenant = (stack, movedTenant, newPosition)=>{
    const newTenants = [
        ...stack.tenants
    ];
    const newTenant = {
        ...movedTenant,
        position: {
            ...movedTenant.position,
            stack_id: stack.id,
            x: newPosition.x,
            y: newPosition.y,
            angle: newPosition.angle
        }
    };
    if (newTenants.find((t)=>t.entity_id === newTenant.entity_id)) return newTenants.map((t)=>t.entity_id === newTenant.entity_id ? newTenant : t);
    newTenants.push(newTenant);
    return newTenants;
};
const $3f8389b9a4e08839$export$a81c45382e7253ac = ({ location: location, stack: stack, setStack: setStack, autocompleteResults: autocompleteResults, setAutocompleteResults: setAutocompleteResults, rightClick: rightClick, getClickedEntity: getClickedEntity, getIndexOfGhostAircraftHoveringOver: getIndexOfGhostAircraftHoveringOver }, deps = [])=>{
    return $acw62.useCallback((evt)=>{
        if (rightClick) return;
        const { entity: entity } = getClickedEntity(evt);
        if (!entity) {
            const clickedGhostPolygonIndex = getIndexOfGhostAircraftHoveringOver(evt);
            if (clickedGhostPolygonIndex > -1) {
                const tenantMoved = {
                    ...autocompleteResults.tenant
                };
                if (!tenantMoved) return;
                const suggestedPosition = autocompleteResults.suggestedPositions.filter((p)=>p.hangar_id === location.id)[clickedGhostPolygonIndex];
                (0, $7R9OT.default).track("Autocomplete", {
                    location_name: location.name,
                    location_type: "hangar",
                    suggestion_index: clickedGhostPolygonIndex
                });
                const tenants = $3f8389b9a4e08839$var$spliceInTenant(stack, tenantMoved, suggestedPosition);
                setStack({
                    ...stack,
                    tenants: tenants
                });
                // clear the results but keep the id and orientation. prevents from running
                // another autocomplete
                setAutocompleteResults({
                    ...autocompleteResults,
                    hash: null,
                    tenant: null,
                    loading: false,
                    suggestedPositions: []
                });
            }
            return;
        }
        setStack({
            ...stack,
            tenants: stack.tenants.map((t)=>({
                    ...t,
                    selected: t.entity_id === entity.entity_id ? true : false
                })),
            movableObstacles: stack.movableObstacles.map((mo)=>({
                    ...mo,
                    selected: mo.entity_id === entity.entity_id ? true : false
                }))
        });
        return entity;
    }, deps);
};

});

parcelRegister("3STt9", function(module, exports) {

$parcel$export(module.exports, "useOnContextMenu", () => $b05502689a6c365a$export$ca7798d25343efd8);

var $acw62 = parcelRequire("acw62");
const $b05502689a6c365a$export$ca7798d25343efd8 = (props, deps = [])=>{
    const { setRightClick: setRightClick, getClickedEntity: getClickedEntity } = props;
    return $acw62.useCallback((evt)=>{
        const { entity: entity, mousePosition: mousePosition } = getClickedEntity(evt);
        if (!entity) return;
        evt.stopPropagation();
        evt.preventDefault();
        setRightClick({
            entity_id: entity.entity_id,
            mouseX: mousePosition.absoluteX,
            mouseY: mousePosition.absoluteY
        });
    }, deps);
};

});

parcelRegister("7WaJM", function(module, exports) {

$parcel$export(module.exports, "usePolygons", () => $686d771c1af85774$export$f4bf7ce3067ca5fb);

var $acw62 = parcelRequire("acw62");

var $5KGQl = parcelRequire("5KGQl");
const $686d771c1af85774$export$f4bf7ce3067ca5fb = (props, deps = [])=>{
    const { stack: stack, width: width, feetToPixels: feetToPixels } = props;
    const polygons = $acw62.useMemo(()=>(0, $5KGQl.getStackPolygons)(stack, width, feetToPixels, null, props.isHoldingArea ?? false), deps);
    return {
        polygons: polygons
    };
};

});

parcelRegister("lvKwx", function(module, exports) {

$parcel$export(module.exports, "useUnselect", () => $2a0e807c044aaba9$export$5f26aec0bb580bd6);

var $acw62 = parcelRequire("acw62");

var $7p8YN = parcelRequire("7p8YN");

var $gxaW2 = parcelRequire("gxaW2");
const $2a0e807c044aaba9$export$5f26aec0bb580bd6 = (props, deps = [])=>{
    const { hangars: hangars } = (0, $7p8YN.useMultiHangarState)();
    // problem here is that if we have multiple hangars on the screen, this is going to be hangingonto the same
    // piece of the DOM which is going to cause problems. we need to have a unique ref for each hangar
    if (hangars.length > 1) {
        $2a0e807c044aaba9$export$16ca3b34b41b72d6();
        return;
    }
    const { stack: stack, setStack: setStack } = props;
    // This hook is responsible for unselecting an aircraft if the user taps
    // anywhere on the page except for a plane or the aircraft list
    $acw62.useEffect(()=>{
        // TODO: this should be a callback looking at hangar?
        const onBodyClick = (e)=>{
            var userIsBusy = (0, $gxaW2.default).isAnyAircraftBeingInteractedWith();
            if (userIsBusy) return;
            var node = e.target;
            while(true){
                if (!node || node == document.body) break;
                if (typeof node.className === "string" && node.className.includes("DraggablePlane")) // User tapped on a plane so don't unselect anything
                return;
                const dataElement = node.getAttribute("data-element");
                // User tapped on either the aircraft list or something within/related to it. in these cases
                // we want to keep the aircraft selected. this implementation is a bit hacky but it works for now.
                const elementsToIgnore = [
                    "li_current_aircraft",
                    "aircraft_menu",
                    "notes-dialog",
                    "edit_tenant"
                ];
                if (elementsToIgnore.includes(dataElement)) return;
                node = node.parentNode;
            }
            setStack({
                ...stack,
                tenants: stack.tenants.map((t)=>({
                        ...t,
                        selected: false
                    })),
                movableObstacles: stack.movableObstacles.map((mo)=>({
                        ...mo,
                        selected: false
                    }))
            });
        };
        document.body.addEventListener("mouseup", onBodyClick, {
            // We need this so that this listener fires before the drag event
            // has ended.
            capture: true
        });
        return ()=>{
            document.body.removeEventListener("mouseup", onBodyClick, {
                capture: true
            });
        };
    }, deps);
};
const $2a0e807c044aaba9$export$16ca3b34b41b72d6 = ()=>{
    const { hangars: hangars, setHangars: setHangars } = (0, $7p8YN.useMultiHangarState)();
    // This hook is responsible for unselecting an aircraft if the user taps
    // anywhere on the page except for a plane or the aircraft list
    $acw62.useEffect(()=>{
        // TODO: this should be a callback looking at hangar?
        const onBodyClick = (e)=>{
            var userIsBusy = (0, $gxaW2.default).isAnyAircraftBeingInteractedWith();
            if (userIsBusy) return;
            var node = e.target;
            while(true){
                if (!node || node == document.body) break;
                if (typeof node.className === "string" && node.className.includes("DraggablePlane")) // User tapped on a plane so don't unselect anything
                return;
                // User tapped on the aircraft list
                // if (node == aircraftListRef.current) {
                //   return;
                // }
                node = node.parentNode;
            }
            setHangars(hangars.map((hangar)=>({
                    ...hangar,
                    stack: {
                        ...hangar.stack,
                        tenants: hangar.stack.tenants.map((t)=>({
                                ...t,
                                selected: false
                            })),
                        movableObstacles: hangar.stack.movableObstacles.map((mo)=>({
                                ...mo,
                                selected: false
                            }))
                    }
                })));
        };
        document.body.addEventListener("mouseup", onBodyClick, {
            // We need this so that this listener fires before the drag event
            // has ended.
            capture: true
        });
        return ()=>{
            document.body.removeEventListener("mouseup", onBodyClick, {
                capture: true
            });
        };
    }, [
        hangars,
        setHangars
    ]);
};

});

parcelRegister("eT5g6", function(module, exports) {

$parcel$export(module.exports, "LayoutBackground", () => $924309148300c049$export$de55e91281495215);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");

var $acw62 = parcelRequire("acw62");

var $7p8YN = parcelRequire("7p8YN");

var $1KiAb = parcelRequire("1KiAb");

var $gZQV9 = parcelRequire("gZQV9");

var $8HlSi = parcelRequire("8HlSi");

var $4HQuu = parcelRequire("4HQuu");

var $1DTXq = parcelRequire("1DTXq");

var $gSUrX = parcelRequire("gSUrX");

var $ckvc5 = parcelRequire("ckvc5");

var $akvO8 = parcelRequire("akvO8");
const $924309148300c049$export$de55e91281495215 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { selectable: selectable, location: location, preferences: preferences, width: width, height: height, feetToPixels: feetToPixels, zoomLevel: zoomLevel, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onContextMenu: onContextMenu, backgroundColor: backgroundColor, dashColor: dashColor, borderColor: borderColor, printable: printable, heatmapPlacements: heatmapPlacements, heatmapSelectedDate: heatmapSelectedDate } = props;
    // TODO: not sure wtf is going on here...
    const { getHangar: getHangar, isMultiHangar: isMultiHangar } = (0, $7p8YN.useMultiHangarState)();
    const { hangar: hangarX } = (0, $gZQV9.useThisHangar)();
    const hangar = (isMultiHangar ? getHangar(location.id) : hangarX) || location;
    if (location.type === "hangar") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $akvO8.MeasuringTool), {
        pixelsToFeetRatio: feetToPixels,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ckvc5.HangarLayoutBackground), {
            ref: ref,
            hangar: hangar,
            selectable: false,
            width: width,
            height: height,
            feetToPixels: feetToPixels,
            preferences: preferences,
            backgroundColor: backgroundColor,
            dashColor: dashColor,
            borderColor: borderColor,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseMove: onMouseMove,
            onMouseEnter: onMouseEnter,
            onContextMenu: onContextMenu,
            children: props.children
        })
    });
    const { ramp: ramp } = (0, $1KiAb.useRampState)();
    const showReferenceImage = preferences?.showRampReferenceImage ?? false;
    const showSpots = preferences?.showSpots ?? false;
    const showHeatmap = preferences?.showZoneHeatmap ?? false;
    const rampBackgroundColor = showReferenceImage ? `${props.backgroundColor}80` : props.backgroundColor;
    // Calculate heatmap data for scheduled view
    const heatmapData = (0, $4HQuu.useHeatmapData)(heatmapPlacements || [], ramp?.shapes || [], heatmapSelectedDate || new Date(), ramp?.depth || 0, // Ramp depth for Y-axis coordinate flip
    preferences?.heatmapHorizonHours || 72 // User-configurable time horizon
    );
    if (printable) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            props.children,
            ramp?.version === "v1" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gSUrX.RampCanvasReadOnly), {
                ramp: ramp,
                width: width,
                backgroundColor: rampBackgroundColor,
                showReferenceImage: showReferenceImage
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DTXq.RampCanvasReadOnlyNew), {
                ramp: ramp,
                width: width,
                showReferenceImage: showReferenceImage,
                showSpots: showSpots,
                zoomLevel: zoomLevel || 1
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $akvO8.MeasuringTool), {
        pixelsToFeetRatio: feetToPixels,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            ref: ref,
            onClick: onClick,
            onContextMenu: onContextMenu,
            sx: {
                position: "relative",
                width: width,
                // height,
                height: "100%",
                marginBottom: "-7px",
                // TODO: i'm not sure why this was here, but it was causing the planes at the bottom of the ramp to be cut off
                // overflow: "hidden",
                "&:hover": selectable ? {
                    border: "2px solid black",
                    borderColor: "success.main",
                    cursor: "pointer"
                } : {}
            },
            children: [
                props.children,
                ramp?.version === "v1" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gSUrX.RampCanvasReadOnly), {
                    ramp: ramp,
                    width: width,
                    backgroundColor: rampBackgroundColor,
                    showReferenceImage: showReferenceImage
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DTXq.RampCanvasReadOnlyNew), {
                    ramp: ramp,
                    width: width,
                    showReferenceImage: showReferenceImage,
                    showSpots: showSpots,
                    zoomLevel: zoomLevel || 1
                }),
                showHeatmap && heatmapSelectedDate && ramp?.shapes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8HlSi.ZoneHeatmap), {
                    shapes: ramp.shapes,
                    occupancyData: heatmapData,
                    width: width,
                    height: height,
                    pixelsToFeetRatio: feetToPixels,
                    visible: showHeatmap
                })
            ]
        })
    });
});

});
parcelRegister("8HlSi", function(module, exports) {

$parcel$export(module.exports, "ZoneHeatmap", () => $700f9233a320d3b5$export$4f71b863b72abd71);
/**
 * Zone Heatmap Component
 *
 * Renders a continuous density heatmap showing spot occupancy over time.
 * Uses radial gradients with additive blending for smooth visualization.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6zwbt = parcelRequire("6zwbt");
/**
 * Calculate centroid and radius for a spot polygon
 */ function $700f9233a320d3b5$var$calculateSpotCentroid(points, pixelsToFeetRatio) {
    if (!points || points.length === 0) return {
        x: 0,
        y: 0,
        radius: 0
    };
    // Calculate centroid
    let sumX = 0;
    let sumY = 0;
    for (const point of points){
        sumX += point.x;
        sumY += point.y;
    }
    const centroidX = sumX / points.length * pixelsToFeetRatio;
    const centroidY = sumY / points.length * pixelsToFeetRatio;
    // Calculate diagonal (max distance from centroid) for radius
    let maxDistance = 0;
    for (const point of points){
        const px = point.x * pixelsToFeetRatio;
        const py = point.y * pixelsToFeetRatio;
        const distance = Math.sqrt(Math.pow(px - centroidX, 2) + Math.pow(py - centroidY, 2));
        maxDistance = Math.max(maxDistance, distance);
    }
    const radius = maxDistance * (0, $6zwbt.HEATMAP_GRADIENT_RADIUS_MULTIPLIER);
    return {
        x: centroidX,
        y: centroidY,
        radius: radius
    };
}
/**
 * Get color for occupancy percentage using smooth gradient interpolation
 * Returns RGBA color string
 *
 * Color scale: Green (0%) → Yellow (50%) → Red (100%)
 */ function $700f9233a320d3b5$var$getColorForOccupancy(occupancyPercent, alpha) {
    // Clamp to 0-100 range
    const percent = Math.max(0, Math.min(100, occupancyPercent));
    if (percent < 50) {
        // Green → Yellow (0% to 50%)
        // Green: rgb(76, 175, 80)
        // Yellow: rgb(255, 235, 59)
        const t = percent / 50; // 0 to 1
        const r = Math.round(76 + 179 * t);
        const g = Math.round(175 + 60 * t);
        const b = Math.round(80 + -21 * t);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else {
        // Yellow → Red (50% to 100%)
        // Yellow: rgb(255, 235, 59)
        // Red: rgb(244, 67, 54)
        const t = (percent - 50) / 50; // 0 to 1
        const r = Math.round(255 + -11 * t);
        const g = Math.round(235 + -168 * t);
        const b = Math.round(59 + -5 * t);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
}
const $700f9233a320d3b5$export$4f71b863b72abd71 = ({ shapes: shapes, occupancyData: occupancyData, width: width, height: height, pixelsToFeetRatio: pixelsToFeetRatio, visible: visible })=>{
    const canvasRef = (0, $acw62.useRef)(null);
    // Pre-compute spot centroids (memoized)
    const spotCentroids = (0, $acw62.useMemo)(()=>{
        const spotShapes = shapes.filter((s)=>s.type === "Spot");
        const centroids = [];
        for (const shape of spotShapes){
            if (!shape.points || shape.points.length === 0) continue;
            const { x: x, y: y, radius: radius } = $700f9233a320d3b5$var$calculateSpotCentroid(shape.points, pixelsToFeetRatio);
            centroids.push({
                spotId: shape.id,
                x: x,
                y: y,
                radius: radius
            });
        }
        return centroids;
    }, [
        shapes,
        pixelsToFeetRatio
    ]);
    // Draw heatmap
    const drawHeatmap = (0, $acw62.useCallback)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        // Clear canvas
        ctx.clearRect(0, 0, width, height);
        if (!visible) return;
        // Use additive blending for overlapping gradients
        ctx.globalCompositeOperation = "lighter";
        // Draw radial gradient for ALL spots (including 0% occupancy as baseline green)
        for (const centroid of spotCentroids){
            // Get occupancy data, default to 0% if not found
            const occupancy = occupancyData.get(centroid.spotId);
            const occupancyPercent = occupancy?.occupancyPercent ?? 0;
            const { x: x, y: y, radius: radius } = centroid;
            // Create radial gradient
            const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
            const color = $700f9233a320d3b5$var$getColorForOccupancy(occupancyPercent, (0, $6zwbt.HEATMAP_BASE_OPACITY));
            const transparentColor = $700f9233a320d3b5$var$getColorForOccupancy(occupancyPercent, 0);
            gradient.addColorStop(0, color);
            gradient.addColorStop(1, transparentColor);
            // Draw filled circle with gradient
            ctx.fillStyle = gradient;
            ctx.beginPath();
            ctx.arc(x, y, radius, 0, 2 * Math.PI);
            ctx.fill();
        }
        // Reset composite operation
        ctx.globalCompositeOperation = "source-over";
    }, [
        visible,
        occupancyData,
        spotCentroids,
        width,
        height
    ]);
    // Redraw when dependencies change
    (0, $acw62.useEffect)(()=>{
        drawHeatmap();
    }, [
        drawHeatmap
    ]);
    if (!visible) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("canvas", {
        ref: canvasRef,
        width: width,
        height: height,
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            pointerEvents: "none",
            // Pass-through - don't block interactions with aircraft
            zIndex: 1.5 // Between ramp image (0) and aircraft (higher)
        }
    });
};

});
parcelRegister("6zwbt", function(module, exports) {

$parcel$export(module.exports, "HEATMAP_HORIZON_HOURS", () => $75dba46c25301f6a$export$f68ef1fd68fb877f);
$parcel$export(module.exports, "HEATMAP_BASE_OPACITY", () => $75dba46c25301f6a$export$c43cfa1f40ecc4c6);
$parcel$export(module.exports, "HEATMAP_GRADIENT_RADIUS_MULTIPLIER", () => $75dba46c25301f6a$export$37ecb3538a724de7);
/**
 * Configuration constants for Zone Heatmap visualization
 */ /**
 * Default time horizon for heatmap occupancy calculation (in hours)
 * This serves as the fallback when user hasn't configured a preference.
 *
 * Users can configure the horizon via View Settings:
 * - 24: 1 day
 * - 72: 3 days (default)
 * - 168: 1 week
 *
 * The actual horizon used is: preferences.heatmapHorizonHours || HEATMAP_HORIZON_HOURS
 */ const $75dba46c25301f6a$export$f68ef1fd68fb877f = 72;
const $75dba46c25301f6a$export$7e5661790f008c7 = $75dba46c25301f6a$export$f68ef1fd68fb877f * 60;
const $75dba46c25301f6a$export$9f195fb065ec61df = {
    LOW: 33,
    // 0-33%: Green (low occupancy)
    MEDIUM: 66,
    // 34-66%: Yellow (medium occupancy)
    HIGH: 100 // 67-100%: Red (high occupancy)
};
const $75dba46c25301f6a$export$c43cfa1f40ecc4c6 = 0.8; // 80%
const $75dba46c25301f6a$export$37ecb3538a724de7 = 1.0;

});


parcelRegister("4HQuu", function(module, exports) {

$parcel$export(module.exports, "useHeatmapData", () => $31893840c41613da$export$fc42dd0832b0e228);
/**
 * Hook for calculating zone heatmap occupancy data
 */ 
var $acw62 = parcelRequire("acw62");

var $6zwbt = parcelRequire("6zwbt");

var $hWiqZ = parcelRequire("hWiqZ");

var $lxGzW = parcelRequire("lxGzW");
function $31893840c41613da$export$33a2fefa667b35d4(placements, shapes, startDate, rampDepth, horizonHours = (0, $6zwbt.HEATMAP_HORIZON_HOURS)) {
    const horizonMinutes = horizonHours * 60;
    const endDate = new Date(startDate.getTime() + horizonHours * 3600000);
    const startTime = startDate.getTime();
    const endTime = endDate.getTime();
    // Map to accumulate occupied minutes per spot
    const spotOccupancyMap = new Map();
    for (const placement of placements){
        // Skip placements without positions
        if (placement.x === null || placement.x === undefined || placement.y === null || placement.y === undefined) continue;
        // Find which spot this placement occupies
        // NOTE: findSpotForPosition handles Y-axis flipping internally
        // Placements use database coordinates (origin bottom-left, Y↑)
        // Shapes use SVG coordinates (origin top-left, Y↓)
        const spotId = (0, $hWiqZ.findSpotForPosition)({
            x: placement.x,
            y: placement.y // Pass directly - findSpotForPosition handles Y-flip
        }, shapes, rampDepth);
        if (!spotId) continue;
        // Calculate overlap between placement time range and heatmap window
        const placementStart = new Date(placement.start_time).getTime();
        const placementEnd = new Date(placement.end_time).getTime();
        const overlapStart = Math.max(placementStart, startTime);
        const overlapEnd = Math.min(placementEnd, endTime);
        if (overlapStart >= overlapEnd) continue;
        const overlapMinutes = (overlapEnd - overlapStart) / 60000;
        // Accumulate occupied time for this spot
        const currentOccupancy = spotOccupancyMap.get(spotId) || 0;
        spotOccupancyMap.set(spotId, currentOccupancy + overlapMinutes);
    }
    // Convert to final data structure with normalized percentages
    const result = new Map();
    // Convert Map entries to array to avoid downlevelIteration requirement
    Array.from(spotOccupancyMap.entries()).forEach(([spotId, occupiedMinutes])=>{
        // Cap at 100% (in case of overlapping placements or data issues)
        const cappedMinutes = Math.min(occupiedMinutes, horizonMinutes);
        const occupancyPercent = cappedMinutes / horizonMinutes * 100;
        const availableMinutes = horizonMinutes - cappedMinutes;
        result.set(spotId, {
            spotId: spotId,
            occupancyPercent: occupancyPercent,
            occupiedMinutes: cappedMinutes,
            availableMinutes: Math.max(0, availableMinutes)
        });
    });
    return result;
}
function $31893840c41613da$export$260df8a863148a33(spotOccupancy, shapes) {
    const spotShapes = shapes.filter((s)=>s.type === "Spot");
    const zoneShapes = shapes.filter((s)=>s.type === "Zone");
    // Assign spots to zones using existing helper
    const zoneToSpots = (0, $lxGzW.assignSpotsToZones)(spotShapes, zoneShapes);
    const result = new Map();
    for (const zoneShape of zoneShapes){
        const spotIds = zoneToSpots.get(zoneShape.id) || [];
        if (spotIds.length === 0) {
            // Zone with no spots - show as 0% occupancy (baseline green)
            result.set(zoneShape.id, {
                zoneId: zoneShape.id,
                zoneName: zoneShape.text || zoneShape.id,
                occupancyPercent: 0,
                totalSpots: 0,
                occupiedSpots: 0
            });
            continue;
        }
        // Calculate average occupancy across all spots in zone
        let totalOccupancy = 0;
        let occupiedSpotsCount = 0;
        for (const spotId of spotIds){
            const spotData = spotOccupancy.get(spotId);
            if (spotData) {
                totalOccupancy += spotData.occupancyPercent;
                if (spotData.occupancyPercent > 0) occupiedSpotsCount++;
            }
        }
        const avgOccupancy = totalOccupancy / spotIds.length;
        result.set(zoneShape.id, {
            zoneId: zoneShape.id,
            zoneName: zoneShape.text || zoneShape.id,
            occupancyPercent: avgOccupancy,
            totalSpots: spotIds.length,
            occupiedSpots: occupiedSpotsCount
        });
    }
    return result;
}
function $31893840c41613da$export$fc42dd0832b0e228(placements, shapes, selectedDate, rampDepth, horizonHours) {
    return (0, $acw62.useMemo)(()=>{
        return $31893840c41613da$export$33a2fefa667b35d4(placements, shapes, selectedDate, rampDepth, horizonHours);
    }, [
        placements,
        shapes,
        selectedDate,
        rampDepth,
        horizonHours
    ]);
}

});
parcelRegister("lxGzW", function(module, exports) {

$parcel$export(module.exports, "assignSpotsToZones", () => $205e4e3c7f292def$export$ef7f9007e308733d);
/**
 * Helper functions for extracting and working with Zones from Ramp shapes
 */ /**
 * Calculate the center point of a spot's bounding box
 */ function $205e4e3c7f292def$var$getSpotCenter(spot) {
    if (!spot.points || spot.points.length === 0) return {
        x: 0,
        y: 0
    };
    const xs = spot.points.map((p)=>p.x);
    const ys = spot.points.map((p)=>p.y);
    return {
        x: (Math.min(...xs) + Math.max(...xs)) / 2,
        y: (Math.min(...ys) + Math.max(...ys)) / 2
    };
}
/**
 * Check if a point is inside a polygon using ray casting algorithm
 * @param point - The point to test
 * @param polygon - Array of points defining the polygon
 * @returns true if point is inside polygon
 */ function $205e4e3c7f292def$var$isPointInPolygon(point, polygon) {
    if (!polygon || polygon.length < 3) return false;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > point.y !== yj > point.y && point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $205e4e3c7f292def$export$ef7f9007e308733d(spots, zoneShapes) {
    const zoneToSpots = new Map();
    // Initialize map with empty arrays for each zone
    zoneShapes.forEach((zone)=>{
        zoneToSpots.set(zone.id, []);
    });
    // For each spot, find which zone(s) contain it
    spots.forEach((spot)=>{
        const center = $205e4e3c7f292def$var$getSpotCenter(spot);
        zoneShapes.forEach((zone)=>{
            if ($205e4e3c7f292def$var$isPointInPolygon(center, zone.points)) zoneToSpots.get(zone.id)?.push(spot.id);
        });
    });
    return zoneToSpots;
}
function $205e4e3c7f292def$export$715a352df7d53445(ramp) {
    if (!ramp?.shapes) return [];
    const zoneShapes = ramp.shapes.filter((s)=>s.type === "Zone");
    const spotShapes = ramp.shapes.filter((s)=>s.type === "Spot");
    // Get spatial assignments
    const zoneToSpots = $205e4e3c7f292def$export$ef7f9007e308733d(spotShapes, zoneShapes);
    return zoneShapes.map((shape)=>({
            id: shape.id,
            name: shape.text || `Zone ${shape.id.slice(0, 8)}`,
            spotIds: zoneToSpots.get(shape.id) || [],
            priority: shape.priority ?? 5,
            // Use shape.priority column (single source of truth)
            shapeId: shape.id
        }));
}
function $205e4e3c7f292def$export$d00604b771465ff0(spotId, zones) {
    return zones.find((zone)=>zone.spotIds.includes(spotId));
}
function $205e4e3c7f292def$export$abafe37a8c526c7b(spotId, zoneId, zones) {
    return zones.map((zone)=>{
        if (zone.id === zoneId) {
            // Add spot to this zone if not already present
            if (!zone.spotIds.includes(spotId)) return {
                ...zone,
                spotIds: [
                    ...zone.spotIds,
                    spotId
                ]
            };
        } else // Remove spot from other zones
        return {
            ...zone,
            spotIds: zone.spotIds.filter((id)=>id !== spotId)
        };
        return zone;
    });
}

});


parcelRegister("1DTXq", function(module, exports) {

$parcel$export(module.exports, "RampCanvasReadOnlyNew", () => $376b29589c5c76c1$export$e0a8e7a181ae5aaa);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $2LXej = parcelRequire("2LXej");

var $ga8GY = parcelRequire("ga8GY");

var $ZD2ym = parcelRequire("ZD2ym");

var $iEhC9 = parcelRequire("iEhC9");

var $bKsdy = parcelRequire("bKsdy");

var $flHhZ = parcelRequire("flHhZ");
const $376b29589c5c76c1$export$e0a8e7a181ae5aaa = ({ ramp: ramp, width: width, showReferenceImage: showReferenceImage, showSpots: showSpots, zoomLevel: zoomLevel })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { x0: x0, y0: y0, setInitialPositionOffset: setInitialPositionOffset } = (0, $iEhC9.useLayoutCanvasState)();
    const rampImage = (0, $2NPdf.default)(async ()=>{
        if (ramp.id && showReferenceImage) try {
            const { data: data } = await postgrest.from("ramp").select("reference_image").eq("id", ramp.id).single();
            return data.reference_image;
        } catch (error) {
            console.error(`Error loading reference image for ramp: ${ramp.id}`, error);
            return null;
        }
        return null;
    }, [
        showReferenceImage,
        ramp.reference_image
    ]);
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const canvasWidth = width;
    const canvasHeight = canvasWidth / (ramp.width / ramp.depth);
    const pixelsToFeetRatio = canvasHeight / (ramp?.depth ?? 1);
    const pixelsToFeet = (px)=>px / pixelsToFeetRatio;
    const { loading: loadingPatterns, patterns: patterns } = (0, $flHhZ.usePatterns)();
    // convert shapes to pixels and filter out spots if needed
    const shapes = $acw62.useMemo(()=>{
        const filteredShapes = showSpots ? ramp.shapes : ramp.shapes.filter((shape)=>shape.type !== 'Spot');
        return filteredShapes.map((shape)=>({
                ...shape,
                points: shape.points.map((point)=>({
                        x: point.x * pixelsToFeetRatio,
                        y: point.y * pixelsToFeetRatio
                    }))
            }));
    }, [
        ramp.shapes,
        pixelsToFeetRatio,
        showSpots
    ]);
    const draw = $acw62.useCallback((context)=>{
        (0, $bKsdy.drawMain)(context, {
            shapes: shapes,
            currentShape: null,
            highlightedShapes: [],
            mousePosition: null,
            calibrationPoints: ramp?.calibration_points,
            showCalibrationPoints: true,
            // Always show in read-only mode for now
            highlightedCalibrationPoint: null,
            canvasRef: canvasRef,
            pixelsToFeet: pixelsToFeet,
            showMeasurements: false,
            showGuideLines: false,
            pixelsToFeetRatio: pixelsToFeetRatio,
            activeShapes: [],
            patterns: patterns,
            isShiftPressed: false,
            zoomLevel: zoomLevel,
            isMetric: activeFBO?.settings?.useMetricSystem
        });
    }, [
        shapes,
        canvasRef,
        pixelsToFeet,
        pixelsToFeetRatio,
        patterns,
        ramp?.calibration_points
    ]);
    $acw62.useEffect(()=>{
        // draw a square that is 100px by 100px in the viewable bottom-left corner of the ramp
        const xOffsetPixels = x0 * pixelsToFeetRatio;
        // how much of the y distance on the canvas is not visable in the viewport
        const rect = canvasRef.current?.getBoundingClientRect();
        if (!rect?.bottom) return;
        const yOffsetPixels = Math.max(0, rect.bottom - window.innerHeight);
        setInitialPositionOffset({
            xFeet: xOffsetPixels / pixelsToFeetRatio,
            yFeet: yOffsetPixels / pixelsToFeetRatio
        });
    }, [
        x0,
        y0,
        pixelsToFeetRatio
    ]);
    $acw62.useEffect(()=>{
        const canvas = canvasRef.current;
        const context = canvas?.getContext("2d");
        if (canvas && context) draw(context);
    }, [
        canvasRef,
        draw
    ]);
    // Simple check to prevent "undefined" in image URLs
    const safeImageUrl = $acw62.useMemo(()=>{
        if (rampImage.value && typeof rampImage.value === "string" && rampImage.value.includes("undefined")) {
            console.warn(`Invalid URL with 'undefined' detected: ${rampImage.value}`);
            return null;
        }
        return rampImage.value;
    }, [
        rampImage.value
    ]);
    if (loadingPatterns) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: "relative",
            display: "inline-block"
        },
        children: [
            showReferenceImage && safeImageUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: safeImageUrl,
                alt: "Ramp reference background",
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: canvasWidth,
                    height: canvasHeight,
                    objectFit: "cover",
                    zIndex: 0,
                    pointerEvents: "none" // Prevent interference with canvas interactions
                },
                onError: (e)=>console.error("Failed to load ramp background image:", e)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ga8GY.default), {
                ref: canvasRef,
                draw: draw,
                width: canvasWidth,
                height: canvasHeight,
                style: {
                    position: "relative",
                    zIndex: 1,
                    backgroundColor: showReferenceImage ? "transparent" : undefined
                }
            })
        ]
    });
};

});
parcelRegister("bKsdy", function(module, exports) {

$parcel$export(module.exports, "drawMain", () => $e4e7103f236b635c$export$afa480c697f2c957);
$parcel$export(module.exports, "measureText", () => $e4e7103f236b635c$export$866cc30a33805630);
$parcel$export(module.exports, "createImagePattern", () => $e4e7103f236b635c$export$9e48607da5089928);

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");

var $czco8 = parcelRequire("czco8");

var $2v7Ik = parcelRequire("2v7Ik");

var $67btB = parcelRequire("67btB");
const $e4e7103f236b635c$export$afa480c697f2c957 = (context, drawingState)=>{
    const { shapes: shapes, currentShape: currentShape, highlightedShapes: highlightedShapes, mousePosition: mousePosition, calibrationPoints: calibrationPoints, showCalibrationPoints: showCalibrationPoints, highlightedCalibrationPoint: highlightedCalibrationPoint, previewSpots: previewSpots, canvasRef: //
    canvasRef, pixelsToFeet: pixelsToFeet, showMeasurements: showMeasurements, showGuideLines: showGuideLines, pixelsToFeetRatio: pixelsToFeetRatio, activeShapes: activeShapes, patterns: patterns, isShiftPressed: isShiftPressed, zoomLevel: zoomLevel, isMetric: isMetric } = drawingState;
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    const orderedShapes = [
        ...shapes.filter((shape)=>!activeShapes.includes(shape.id)),
        ...shapes.filter((shape)=>activeShapes.includes(shape.id))
    ];
    orderedShapes.forEach((shape, index)=>{
        const isHighlighted = highlightedShapes.includes(shape.id);
        $e4e7103f236b635c$export$71b514a25c47df50(context, shape, index, {
            pixelsToFeet: pixelsToFeet,
            showMeasurements: showMeasurements,
            showGuideLines: showGuideLines,
            pixelsToFeetRatio: pixelsToFeetRatio,
            activeShapes: activeShapes,
            patterns: patterns,
            zoomLevel: zoomLevel,
            isMetric: isMetric
        }, isHighlighted);
    });
    // Draw preview spots with semi-transparent appearance
    if (previewSpots && previewSpots.length > 0) {
        context.save();
        context.globalAlpha = 0.3;
        previewSpots.forEach((previewSpot, index)=>{
            $e4e7103f236b635c$export$71b514a25c47df50(context, previewSpot, index, {
                pixelsToFeet: pixelsToFeet,
                showMeasurements: showMeasurements,
                showGuideLines: showGuideLines,
                pixelsToFeetRatio: pixelsToFeetRatio,
                activeShapes: activeShapes,
                patterns: patterns,
                zoomLevel: zoomLevel,
                isMetric: isMetric
            }, false);
        });
        context.restore();
    }
    // ok we're done drawing all the shapes. now we need to draw the current shape
    if (!currentShape) return;
    context.beginPath();
    context.lineWidth = 3;
    context.strokeStyle = "blue";
    context.setLineDash($e4e7103f236b635c$export$32878419db87e5ea(currentShape.line_style));
    context.lineWidth = currentShape.line_width;
    currentShape.points.forEach((point, pointIndex)=>{
        if (pointIndex === 0) context.moveTo(point.x, point.y);
        else context.lineTo(point.x, point.y);
    });
    context.stroke();
    currentShape.points.forEach((point, index)=>{
        if (index === 0) context.moveTo(point.x, point.y);
        else context.lineTo(point.x, point.y);
        // Draw points with red fill and white outline
        $e4e7103f236b635c$export$654275d54901f10e(context, point.x, point.y);
    });
    // Draw the "live" line to the current mouse position if in progress
    if (mousePosition && currentShape.points.length > 0) {
        const lastPoint = currentShape.points[currentShape.points.length - 1];
        context.beginPath();
        // if Shift is pressed, snap the line to the nearest 45 degree angle
        if (isShiftPressed) {
            const snapPoint = (0, $2v7Ik.getSnapPoint)(mousePosition, lastPoint);
            context.moveTo(lastPoint.x, lastPoint.y);
            context.lineTo(snapPoint.x, snapPoint.y);
        } else {
            context.moveTo(lastPoint.x, lastPoint.y);
            context.lineTo(mousePosition.x, mousePosition.y);
        }
        context.strokeStyle = "blue";
        context.setLineDash($e4e7103f236b635c$export$32878419db87e5ea(currentShape.line_style));
        context.lineWidth = currentShape.line_width;
        context.lineWidth = 2;
        context.stroke();
        // Calculate the length of the line segment
        const length = pixelsToFeet(Math.hypot(mousePosition.x - lastPoint.x, mousePosition.y - lastPoint.y));
        if (showMeasurements) {
            // Draw the length of the line segment
            const lengthFormatted = isMetric ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(length), 0)} m` : `${(0, $lNEp2.formatNumber)(length, 0)} ft`;
            $e4e7103f236b635c$export$ddcf896b6327de6(context, (lastPoint.x + mousePosition.x) / 2, (lastPoint.y + mousePosition.y) / 2, lengthFormatted);
        }
    }
    // check if mouse position is close to a point
    if (mousePosition) {
        // convert mousePosition to canvas coordinates
        const rect = canvasRef.current?.getBoundingClientRect();
        if (!rect) return;
        currentShape.points.forEach((point)=>{
            if (Math.hypot(point.x - mousePosition.x, point.y - mousePosition.y) < 10) $e4e7103f236b635c$export$654275d54901f10e(context, point.x, point.y, null, null, "limegreen", "white");
        });
    }
    // Draw guide lines if enabled
    if (showGuideLines) $e4e7103f236b635c$export$9bee30a770f37a3e(context, context.canvas.width, context.canvas.height);
    // Draw calibration points if enabled
    if (showCalibrationPoints && calibrationPoints) calibrationPoints.forEach((point)=>{
        $e4e7103f236b635c$export$23caadd723b75c8(context, point, pixelsToFeetRatio, highlightedCalibrationPoint === point.id);
    });
};
const $e4e7103f236b635c$export$71b514a25c47df50 = (context, shape, index, state, isHighlighted)=>{
    const hoveredShapeIndex = null;
    const highlightedColor = `#32cd3270`;
    const strokeStyle = isHighlighted ? highlightedColor : shape.stroke_style;
    const fillStyle = isHighlighted ? highlightedColor : shape.fill_style;
    const { pixelsToFeet: pixelsToFeet, showMeasurements: showMeasurements, pixelsToFeetRatio: pixelsToFeetRatio, activeShapes: activeShapes, patterns: patterns, isMetric: isMetric } = state;
    if (shape.type === "Text") {
        const fontSize = Math.min(128, Math.max(12, shape.font_size));
        $e4e7103f236b635c$export$b11bd9a0808bdc9(context, shape.points[0].x, shape.points[0].y, shape.text, strokeStyle, fontSize, hoveredShapeIndex === index || activeShapes.includes(shape.id), context.canvas.height / shape.reference_image_height);
        return;
    }
    if (shape.type === "Tie Down T" || shape.type === "Double T") {
        // Draw the shape
        context.beginPath();
        context.lineWidth = 3;
        context.strokeStyle = strokeStyle;
        context.fillStyle = fillStyle;
        context.setLineDash($e4e7103f236b635c$export$32878419db87e5ea(shape.line_style));
        context.lineWidth = shape.line_width;
        const center = (0, $2v7Ik.getCenter)(shape.points);
        // horizontal line
        context.beginPath();
        context.moveTo(shape.points[0].x, shape.points[0].y);
        context.lineTo(shape.points[1].x, shape.points[1].y);
        context.stroke();
        // Vertical line
        context.beginPath();
        context.stroke();
        const angle = Math.atan2(shape.points[1].y - shape.points[0].y, shape.points[1].x - shape.points[0].x);
        const length = Math.hypot(shape.points[1].x - shape.points[0].x, shape.points[1].y - shape.points[0].y);
        const verticalLength = length / 2; // Adjust this value as needed
        const verticalPoint1 = {
            x: center.x - verticalLength * Math.sin(angle),
            y: center.y + verticalLength * Math.cos(angle)
        };
        const verticalPoint2 = {
            x: center.x + verticalLength * Math.sin(angle),
            y: center.y - verticalLength * Math.cos(angle)
        };
        context.moveTo(verticalPoint1.x, verticalPoint1.y);
        context.lineTo(verticalPoint2.x, verticalPoint2.y);
        context.stroke();
        // add the second line for the Double T
        if (shape.type === "Double T") {
            context.moveTo(shape.points[2].x, shape.points[2].y);
            context.lineTo(shape.points[3].x, shape.points[3].y);
            context.stroke();
        }
    }
    // draw the compass rose
    if (shape.type === "Compass Rose") {
        const center = (0, $2v7Ik.getCenter)(shape.points);
        // Calculate angle based on the first two points directly
        const angle = Math.atan2(shape.points[1].y - shape.points[0].y, shape.points[1].x - shape.points[0].x);
        const length = Math.hypot(shape.points[1].x - shape.points[0].x, shape.points[1].y - shape.points[0].y);
        const radius = length / 2;
        // Save context state
        context.save();
        context.translate(center.x, center.y);
        context.rotate(angle);
        // Draw the outer circle
        context.beginPath();
        context.arc(0, 0, radius, 0, 2 * Math.PI);
        context.strokeStyle = strokeStyle;
        context.lineWidth = shape.line_width || 8;
        context.fillStyle = "white";
        context.stroke();
        context.fill();
        // Draw direction lines
        const lineCount = 8;
        context.beginPath();
        for(let i = 0; i < lineCount; i++){
            const lineAngle = Math.PI * 2 * i / lineCount;
            const innerRadius = radius * 0.2;
            const outerRadius = radius * 0.9;
            context.moveTo(innerRadius * Math.sin(lineAngle), innerRadius * Math.cos(lineAngle));
            context.lineTo(outerRadius * Math.sin(lineAngle), outerRadius * Math.cos(lineAngle));
        }
        context.lineWidth = 1.25;
        context.strokeStyle = strokeStyle;
        context.stroke();
        // Draw the N label at the top
        context.fillStyle = strokeStyle;
        context.font = `bold ${radius * 0.65}px Lexend Deca`;
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillText("N", 0, -radius * 1.35);
        // Draw the diamond/arrow pointing north and south
        // North-pointing triangle (darker)
        context.beginPath();
        context.moveTo(0, -radius * 0.7); // Top point
        context.lineTo(radius * 0.3, 0); // Right point
        context.lineTo(-radius * 0.3, 0); // Left point
        context.closePath();
        context.fillStyle = strokeStyle;
        context.fill();
        // South-pointing triangle (lighter)
        context.beginPath();
        context.moveTo(0, radius * 0.7); // Bottom point
        context.lineTo(radius * 0.3, 0); // Right point
        context.lineTo(-radius * 0.3, 0); // Left point
        context.closePath();
        context.fillStyle = "white"; // Reset fill style to transparent
        context.strokeStyle = strokeStyle; // Use the same stroke style
        context.fill();
        context.stroke();
        // Draw the inner white circle
        context.beginPath();
        context.arc(0, 0, radius * 0.1, 0, 2 * Math.PI);
        context.fillStyle = "white";
        context.fill();
        context.strokeStyle = strokeStyle;
        context.lineWidth = 1;
        context.stroke();
        // Restore context state
        context.restore();
    }
    if (shape.type === "Circle" || shape.type === "Helipad") {
        const center = (0, $2v7Ik.getCenter)(shape.points);
        const radius = Math.hypot(shape.points[1].x - shape.points[0].x, shape.points[1].y - shape.points[0].y) / 2;
        context.setLineDash($e4e7103f236b635c$export$32878419db87e5ea(shape.line_style));
        context.lineWidth = shape.line_width;
        context.strokeStyle = strokeStyle;
        context.beginPath();
        context.arc(center.x, center.y, radius, 0, 2 * Math.PI);
        context.stroke();
        if (fillStyle) {
            context.fillStyle = fillStyle;
            context.fill();
        }
    }
    if (shape.type === "Spot") {
        context.setLineDash($e4e7103f236b635c$export$32878419db87e5ea(shape.line_style));
        context.lineWidth = shape.line_width;
        context.strokeStyle = strokeStyle;
        context.beginPath();
        context.moveTo(shape.points[0].x, shape.points[0].y);
        context.lineTo(shape.points[1].x, shape.points[1].y);
        context.lineTo(shape.points[2].x, shape.points[2].y);
        context.lineTo(shape.points[3].x, shape.points[3].y);
        context.closePath();
        context.stroke();
        // Draw property badges
        $e4e7103f236b635c$var$drawSpotPropertyBadges(context, shape, state);
    }
    // Draw the shape
    context.beginPath();
    context.lineWidth = 3;
    context.setLineDash($e4e7103f236b635c$export$32878419db87e5ea(shape.line_style));
    context.lineWidth = shape.line_width;
    context.strokeStyle = strokeStyle;
    context.fillStyle = fillStyle;
    shape.points.forEach((point, pointIndex)=>{
        if (pointIndex === 0) context.moveTo(point.x, point.y);
        else context.lineTo(point.x, point.y);
    });
    // Areas should be a closed shape. And only closed shapes need a fill()
    // for Areas, we'll show the sqft of the area
    if (shape.type === "Area") {
        context.closePath();
        if (fillStyle || shape.fill_pattern) {
            if (fillStyle) context.fillStyle = fillStyle;
            else context.fillStyle = patterns[shape.fill_pattern];
            context.fill();
        }
        context.stroke();
        if (!shape.locked && (hoveredShapeIndex === index || activeShapes.includes(shape.id))) {
            const area = (0, $2v7Ik.calculateArea)(shape.points, 1 / pixelsToFeetRatio);
            if (showMeasurements) {
                const center = (0, $2v7Ik.getCenter)(shape.points);
                const areaFormatted = isMetric ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.squareFeetToSquareMeters)(area), 0)} m\xb2` : `${(0, $lNEp2.formatNumber)(area, 0)} ft\xb2`;
                $e4e7103f236b635c$export$ddcf896b6327de6(context, center.x, center.y, areaFormatted);
            }
        }
    }
    // Zones should be closed shapes with solid white outline and zone name label
    if (shape.type === "Zone") {
        context.closePath();
        // Fill zone if fillStyle is defined (typically zones have no fill)
        if (fillStyle) {
            context.fillStyle = fillStyle;
            context.fill();
        }
        context.stroke();
        // Display zone name at center
        const center = (0, $2v7Ik.getCenter)(shape.points);
        const zoneName = shape.text || "Zone";
        const label = zoneName;
        // Draw zone label with database font_size
        const fontSize = Math.min(128, Math.max(12, shape.font_size || 14));
        $e4e7103f236b635c$export$b11bd9a0808bdc9(context, center.x, center.y, label, "#FFFFFF", // White text to match white outline
        fontSize, false, context.canvas.height / shape.reference_image_height);
    }
    if (shape.type === "Tie Down T" || shape.type === "Double T" || shape.type === "Circle" || shape.type === "Helipad" || shape.type === "Compass Rose" || shape.type === "Spot" || shape.type === "Zone") context.closePath();
    if (shape.type !== "Tie Down T" && shape.type !== "Double T" && shape.type !== "Circle" && shape.type !== "Helipad" && shape.type !== "Compass Rose" && shape.type !== "Spot" && shape.type !== "Zone") context.stroke();
    // Draw the text if the shape has any (exclude Zones as they have their own specialized rendering)
    if (shape.text && shape.type !== "Zone") {
        // For Line shapes, check metadata for visibility/position
        const lineMetadata = shape.type === "Line" ? shape.metadata : null;
        const showText = lineMetadata?.show_text !== false; // Default: true
        if (!showText) ;
        else if (shape.type === "Helipad") {
            // Helipad: "H" takes up 80% of the width/height of the shape
            const center = (0, $2v7Ik.getCenter)(shape.points);
            const segmentSize = Math.hypot(shape.points[1].x - shape.points[0].x, shape.points[1].y - shape.points[0].y);
            const fontSize = 0.8 * segmentSize;
            $e4e7103f236b635c$export$b11bd9a0808bdc9(context, center.x, center.y, shape.text, strokeStyle, fontSize, null, context.canvas.height / shape.reference_image_height);
        } else if (shape.type === "Line" && shape.points.length >= 2) {
            // Line-specific positioning (start/middle/end)
            const position = lineMetadata?.text_position || "middle";
            let labelX, labelY;
            if (position === "start") {
                // Near first point - 10% offset toward second point to avoid vertex overlap
                const p0 = shape.points[0];
                const p1 = shape.points[1];
                labelX = p0.x + (p1.x - p0.x) * 0.1;
                labelY = p0.y + (p1.y - p0.y) * 0.1;
            } else if (position === "end") {
                // Near last point - 10% offset toward second-to-last point
                const pLast = shape.points[shape.points.length - 1];
                const pPrev = shape.points[shape.points.length - 2];
                labelX = pLast.x + (pPrev.x - pLast.x) * 0.1;
                labelY = pLast.y + (pPrev.y - pLast.y) * 0.1;
            } else {
                // 'middle' - average of all points (getCenter uses polygon formula which doesn't work for lines)
                labelX = shape.points.reduce((sum, p)=>sum + p.x, 0) / shape.points.length;
                labelY = shape.points.reduce((sum, p)=>sum + p.y, 0) / shape.points.length;
            }
            // Add perpendicular offset so text appears beside the line, not on it
            const dx = shape.points[1].x - shape.points[0].x;
            const dy = shape.points[1].y - shape.points[0].y;
            const lineLength = Math.hypot(dx, dy);
            if (lineLength > 0) {
                // Perpendicular unit vector (rotated 90 degrees)
                const perpX = -dy / lineLength;
                const perpY = dx / lineLength;
                // Offset text perpendicular to line
                const offset = 15;
                labelX += perpX * offset;
                labelY += perpY * offset;
            }
            const fontSize = Math.min(128, Math.max(12, shape.font_size));
            $e4e7103f236b635c$export$b11bd9a0808bdc9(context, labelX, labelY, shape.text, strokeStyle, fontSize, false, context.canvas.height / shape.reference_image_height);
        } else {
            // Other shapes - existing center logic
            const center = (0, $2v7Ik.getCenter)(shape.points);
            const fontSize = Math.min(128, Math.max(12, shape.font_size));
            $e4e7103f236b635c$export$b11bd9a0808bdc9(context, center.x, center.y, shape.text, strokeStyle, fontSize, false, context.canvas.height / shape.reference_image_height);
        }
    }
    // Annotate the line segments with their lengths
    if (hoveredShapeIndex === index || activeShapes.includes(shape.id)) shape.points.forEach((point, pointIndex)=>{
        // this is the "closing" segment of a shape. we don't need to draw the length
        // for tha tone since the Line is not a closed form.
        if ((shape.type === "Line" || shape.type === "Tie Down T" || shape.type === "Double T" || shape.type === "Circle" || shape.type === "Helipad" || shape.type === "Compass Rose" || shape.type === "Spot" || shape.type === "Zone") && pointIndex === shape.points.length - 1) return;
        const nextPoint = shape.points[(pointIndex + 1) % shape.points.length];
        const length = pixelsToFeet(Math.hypot(nextPoint.x - point.x, nextPoint.y - point.y));
        if (showMeasurements) {
            if (shape.type === "Circle" && pointIndex !== 1) return;
            if (shape.type === "Helipad" && pointIndex !== 1) return;
            if (shape.type === "Tie Down T" && pointIndex !== 2) return;
            if (shape.type === "Double T" && pointIndex !== 2) return;
            if (shape.type === "Compass Rose" && pointIndex !== 2) return;
            if (shape.type === "Spot" && pointIndex !== 0) return;
            if (!shape.locked) {
                const lengthFormatted = isMetric ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(length), 0)} m` : `${(0, $lNEp2.formatNumber)(length, 0)} ft`;
                $e4e7103f236b635c$export$ddcf896b6327de6(context, (point.x + nextPoint.x) / 2, (point.y + nextPoint.y) / 2, lengthFormatted);
            }
        }
    });
    // Draw points with red fill and white outline
    if (!shape.locked && (hoveredShapeIndex === index || activeShapes.includes(shape.id))) shape.points.forEach((point)=>$e4e7103f236b635c$export$654275d54901f10e(context, point.x, point.y));
};
const $e4e7103f236b635c$export$654275d54901f10e = (context, x, y, radius = 4, lineWidth = 2, fillStyle = "red", strokeStyle = "white")=>{
    context.fillStyle = fillStyle;
    context.strokeStyle = strokeStyle;
    context.lineWidth = lineWidth;
    context.setLineDash([]);
    context.beginPath();
    context.arc(x, y, radius, 0, Math.PI * 2); // 6px radius for the point
    context.fill();
    context.stroke();
};
const $e4e7103f236b635c$export$866cc30a33805630 = (context, shape)=>{
    const text = shape.text;
    const fontSize = shape.font_size;
    context.font = `${fontSize}px Lexend Deca`;
    const metrics = context.measureText(text);
    return metrics;
};
const $e4e7103f236b635c$export$b11bd9a0808bdc9 = (context, midX, midY, text, color = "black", fontSize = 12, border = false, referenceScaleRatio)=>{
    // if the reference_reference_image_height is provided, we will make the font
    // size proportional to the height of the reference image. we do this by multiplying
    // the ([current image height] / [reference_reference_image_height]) * fontSize
    if (referenceScaleRatio && isFinite(referenceScaleRatio) && referenceScaleRatio !== 0) fontSize = referenceScaleRatio ? fontSize * referenceScaleRatio : fontSize;
    const padding = 10;
    context.font = `${fontSize}px Lexend Deca`;
    context.fillStyle = color;
    // Measure text width
    const textMetrics = context.measureText(text);
    const textWidth = textMetrics.width;
    // Calculate text height (approximation using font size)
    const textHeight = fontSize;
    // Adjust position to center text
    const x = midX - textWidth / 2;
    const y = midY + textHeight / 3; // Adjust to align the vertical center
    // Calculate box dimensions with padding
    const boxX = x - padding;
    const boxY = y - textHeight - padding;
    const boxWidth = textWidth + padding * 2;
    const boxHeight = textHeight + padding * 2;
    if (border) {
        // Draw box border
        context.strokeStyle = "blue";
        context.strokeRect(boxX, boxY, boxWidth, boxHeight);
    }
    // Draw the text
    context.fillStyle = color;
    context.fillText(text, x, y);
};
const $e4e7103f236b635c$export$ddcf896b6327de6 = (context, midX, midY, text, fontSize = 12)=>{
    // Draw a rounded rectangle for the distance box
    const padding = 4;
    context.font = `${fontSize}px Lexend Deca`;
    const textWidth = context.measureText(text).width;
    const boxWidth = textWidth + padding * 2;
    const boxHeight = fontSize + padding * 2;
    const radius = 5;
    context.fillStyle = "white";
    context.strokeStyle = "black";
    context.lineWidth = 1;
    context.beginPath();
    context.moveTo(midX - boxWidth / 2 + radius, midY - boxHeight / 2);
    context.lineTo(midX + boxWidth / 2 - radius, midY - boxHeight / 2);
    context.quadraticCurveTo(midX + boxWidth / 2, midY - boxHeight / 2, midX + boxWidth / 2, midY - boxHeight / 2 + radius);
    context.lineTo(midX + boxWidth / 2, midY + boxHeight / 2 - radius);
    context.quadraticCurveTo(midX + boxWidth / 2, midY + boxHeight / 2, midX + boxWidth / 2 - radius, midY + boxHeight / 2);
    context.lineTo(midX - boxWidth / 2 + radius, midY + boxHeight / 2);
    context.quadraticCurveTo(midX - boxWidth / 2, midY + boxHeight / 2, midX - boxWidth / 2, midY + boxHeight / 2 - radius);
    context.lineTo(midX - boxWidth / 2, midY - boxHeight / 2 + radius);
    context.quadraticCurveTo(midX - boxWidth / 2, midY - boxHeight / 2, midX - boxWidth / 2 + radius, midY - boxHeight / 2);
    context.closePath();
    context.fill();
    context.stroke();
    context.fillStyle = "black";
    context.fillText(text, midX - textWidth / 2, midY + fontSize / 2 - padding);
};
// Helper function to calculate spot bounding box from points
const $e4e7103f236b635c$var$getSpotBounds = (points)=>{
    const xs = points.map((p)=>p.x);
    const ys = points.map((p)=>p.y);
    return {
        minX: Math.min(...xs),
        maxX: Math.max(...xs),
        minY: Math.min(...ys),
        maxY: Math.max(...ys),
        width: Math.max(...xs) - Math.min(...xs),
        height: Math.max(...ys) - Math.min(...ys)
    };
};
// Helper to check if two arrays are equal (for size comparison)
const $e4e7103f236b635c$var$arraysEqual = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
};
// Check if allowedSizes is non-default for spot's size
const $e4e7103f236b635c$var$isNonDefaultSizes = (spotSize, allowedSizes)=>{
    if (!allowedSizes || allowedSizes.length === 0) return false;
    // Determine spot's default category based on size
    let defaultCategory = "large"; // fallback
    for (const option of (0, $67btB.SIZE_CATEGORY_OPTIONS))if (spotSize <= option.maxFeet) {
        defaultCategory = option.value;
        break;
    }
    // Default should allow all sizes <= spot's category
    const sizeHierarchy = (0, $67btB.SIZE_CATEGORY_OPTIONS).map((opt)=>opt.value);
    const expectedDefaults = sizeHierarchy.slice(0, sizeHierarchy.indexOf(defaultCategory) + 1);
    // Check if allowedSizes differs from default
    return !$e4e7103f236b635c$var$arraysEqual(allowedSizes.slice().sort(), expectedDefaults.slice().sort());
};
// Format allowed sizes as abbreviated string (uses shared formatter for consistency)
const $e4e7103f236b635c$var$formatAllowedSizes = (0, $czco8.formatSizeCategories);
// Format dwell time in minutes to readable string
const $e4e7103f236b635c$var$formatDwellTime = (minutes)=>{
    if (minutes < 60) return `${minutes}m`;
    if (minutes < 1440) return `${Math.floor(minutes / 60)}h`;
    return `${Math.floor(minutes / 1440)}d`;
};
// Format reference points with orientations as abbreviated string
const $e4e7103f236b635c$var$formatReferencePoints = (referencePoints)=>{
    const pointAbbrevs = {
        north: "N",
        south: "S",
        east: "E",
        west: "W",
        center: "C"
    };
    const orientAbbrevs = {
        nose_to_line: "N",
        tail_to_line: "T",
        center: "C"
    };
    // Format each reference point with its orientations
    const formatted = referencePoints.map((rp)=>{
        const point = pointAbbrevs[rp.name] || rp.name.charAt(0).toUpperCase();
        const orients = rp.validOrientations.map((o)=>orientAbbrevs[o] || o.charAt(0).toUpperCase()).join("");
        return `${point}:${orients}`;
    });
    return formatted.join(" ");
};
// Draw property badges for a Spot shape
const $e4e7103f236b635c$var$drawSpotPropertyBadges = (context, shape, state)=>{
    // Early exit if zoom too low
    if (state.zoomLevel < 0.5) return;
    const metadata = shape.metadata;
    if (!metadata) return;
    const bounds = $e4e7103f236b635c$var$getSpotBounds(shape.points);
    const baseFontSize = 8;
    const fontSize = baseFontSize * Math.max(0.8, state.zoomLevel);
    const padding = 3;
    const badgeSpacing = 2; // Space between badges in the column
    // Calculate spot size in feet
    const spotWidthFeet = bounds.width / state.pixelsToFeetRatio;
    // Collect badge texts and colors (we'll position them in a row later)
    const badgeData = [];
    // Reference Points & Orientations
    if (shape.reference_points && shape.reference_points.length > 0) badgeData.push({
        text: $e4e7103f236b635c$var$formatReferencePoints(shape.reference_points),
        color: "#44AAFF"
    });
    // Allowed Sizes (only if non-default)
    if (metadata.allowedSizes && $e4e7103f236b635c$var$isNonDefaultSizes(spotWidthFeet, metadata.allowedSizes)) badgeData.push({
        text: $e4e7103f236b635c$var$formatAllowedSizes(metadata.allowedSizes),
        color: "#4444FF"
    });
    // Egress Lanes
    if (metadata.egressLanes && metadata.egressLanes.length > 0) badgeData.push({
        text: `${metadata.egressLanes.length}L`,
        color: "#44AA44"
    });
    // Gap Spot
    if (metadata.isGapSpot) badgeData.push({
        text: "GAP",
        color: "#FFAA44"
    });
    // Min Dwell
    if (metadata.min_dwell_minutes) badgeData.push({
        text: `${$e4e7103f236b635c$var$formatDwellTime(metadata.min_dwell_minutes)}+`,
        color: "#AA44FF"
    });
    // Max Dwell
    if (metadata.max_dwell_minutes) badgeData.push({
        text: `${$e4e7103f236b635c$var$formatDwellTime(metadata.max_dwell_minutes)} max`,
        color: "#FF4444"
    });
    // Disabled
    if (metadata.disabled) badgeData.push({
        text: "X",
        color: "#FF4444"
    });
    // If no badges, return early
    if (badgeData.length === 0) return;
    // Set up font for measuring
    context.save();
    context.font = `600 ${fontSize}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto`;
    // Calculate widths for all badges and find max width for right-alignment
    const badgeWidths = badgeData.map((badge)=>{
        const metrics = context.measureText(badge.text);
        return metrics.width + padding * 2;
    });
    const pillHeight = fontSize + padding * 2;
    // Get the right edge of the spot (points 1 and 2 in a quad)
    // Spot points are typically: [top-left, top-right, bottom-right, bottom-left]
    const topRight = shape.points[1];
    const bottomRight = shape.points[2];
    // Calculate angle of right edge
    const rightEdgeAngle = Math.atan2(bottomRight.y - topRight.y, bottomRight.x - topRight.x);
    // Calculate perpendicular angle (pointing inward from right edge)
    const perpAngle = rightEdgeAngle - Math.PI / 2;
    // Position: start from bottom-right corner, move inward perpendicular to edge
    const inset = 8;
    let currentX = bottomRight.x + inset * Math.cos(perpAngle);
    let currentY = bottomRight.y + inset * Math.sin(perpAngle);
    // Move up along the right edge to position first badge
    const totalHeight = badgeData.length * pillHeight + (badgeData.length - 1) * badgeSpacing;
    currentX -= totalHeight * Math.cos(rightEdgeAngle);
    currentY -= totalHeight * Math.sin(rightEdgeAngle);
    // Render badges in a vertical column (horizontal text, positioned along rotated edge)
    badgeData.forEach((badge, index)=>{
        const pillWidth = badgeWidths[index];
        // Calculate center position for this badge (move down along right edge)
        const badgeCenterX = currentX + pillHeight / 2 * Math.cos(rightEdgeAngle);
        const badgeCenterY = currentY + pillHeight / 2 * Math.sin(rightEdgeAngle);
        // Draw background pill (horizontal, no rotation)
        context.fillStyle = badge.color;
        context.globalAlpha = 0.7;
        context.beginPath();
        context.roundRect(badgeCenterX - pillWidth, badgeCenterY - pillHeight / 2, pillWidth, pillHeight, 4);
        context.fill();
        // Draw text (horizontal, right-aligned)
        context.globalAlpha = 0.9;
        context.fillStyle = "#FFFFFF";
        context.textAlign = "right";
        context.textBaseline = "middle";
        context.fillText(badge.text, badgeCenterX - padding, badgeCenterY);
        // Move to next badge position (move down along right edge)
        const offsetDelta = pillHeight + badgeSpacing;
        currentX += offsetDelta * Math.cos(rightEdgeAngle);
        currentY += offsetDelta * Math.sin(rightEdgeAngle);
    });
    context.restore();
};
const $e4e7103f236b635c$export$32878419db87e5ea = (lineStyle)=>{
    switch(lineStyle){
        case "dashed":
            return [
                3,
                3
            ];
        case "dotted":
            return [
                2,
                2
            ];
        case "solid":
        default:
            return [];
    }
};
const $e4e7103f236b635c$export$9bee30a770f37a3e = (context, canvasWidth, canvasHeight)=>{
    const inset = 30; // 30px from edges
    const thickness = 0.5; // 0.5px thickness
    context.save();
    context.strokeStyle = "#00ff19ff"; // Bright green color for better visibility
    context.lineWidth = thickness;
    context.setLineDash([]);
    context.beginPath();
    // Top line
    context.moveTo(inset, inset);
    context.lineTo(canvasWidth - inset, inset);
    // Right line
    context.moveTo(canvasWidth - inset, inset);
    context.lineTo(canvasWidth - inset, canvasHeight - inset);
    // Bottom line
    context.moveTo(canvasWidth - inset, canvasHeight - inset);
    context.lineTo(inset, canvasHeight - inset);
    // Left line
    context.moveTo(inset, canvasHeight - inset);
    context.lineTo(inset, inset);
    context.stroke();
    context.restore();
};
const $e4e7103f236b635c$export$9e48607da5089928 = async (canvas, imagePath, alpha = 1.0 // Alpha value between 0 (fully transparent) and 1 (fully opaque)
)=>{
    return new Promise((resolve, reject)=>{
        const context = canvas.getContext("2d");
        const image = new Image();
        image.src = imagePath;
        image.onload = ()=>{
            // Create an offscreen canvas
            const offscreenCanvas = document.createElement("canvas");
            offscreenCanvas.width = image.width;
            offscreenCanvas.height = image.height;
            const offscreenContext = offscreenCanvas.getContext("2d");
            if (offscreenContext) {
                // Draw the image onto the offscreen canvas
                offscreenContext.globalAlpha = alpha; // Set alpha transparency
                offscreenContext.drawImage(image, 0, 0);
                // Create a pattern from the offscreen canvas
                const pattern = context.createPattern(offscreenCanvas, "repeat");
                if (pattern) resolve(pattern);
                else reject(new Error("Failed to create pattern"));
            } else reject(new Error("Failed to get context for offscreen canvas"));
        };
        image.onerror = ()=>{
            reject(new Error(`Failed to load image at ${imagePath}`));
        };
    });
};
const $e4e7103f236b635c$export$23caadd723b75c8 = (context, point, pixelsToFeetRatio, isHighlighted = false)=>{
    // Convert relative coordinates to pixel coordinates
    // point.x and point.y are relative (0.0 to 1.0)
    const canvasWidth = context.canvas.width;
    const canvasHeight = context.canvas.height;
    const x = point.x * canvasWidth;
    const y = point.y * canvasHeight;
    const size = 20; // Size of the target icon
    const radius = size / 2;
    context.save();
    // Set colors based on highlight state
    const strokeColor = isHighlighted ? "#00ff00" : "#e74c3c"; // Bright green for hover, red for normal
    const strokeWidth = isHighlighted ? 3 : 2;
    context.strokeStyle = strokeColor;
    context.lineWidth = strokeWidth;
    context.setLineDash([]);
    // Draw outer circle
    context.beginPath();
    context.arc(x, y, radius, 0, 2 * Math.PI);
    context.stroke();
    // Draw inner circle
    context.beginPath();
    context.arc(x, y, radius * 0.6, 0, 2 * Math.PI);
    context.stroke();
    // Draw center dot
    context.fillStyle = strokeColor;
    context.beginPath();
    context.arc(x, y, radius * 0.2, 0, 2 * Math.PI);
    context.fill();
    // Draw crosshairs
    const crosshairLength = radius * 1.4;
    context.lineWidth = strokeWidth;
    // Horizontal line
    context.beginPath();
    context.moveTo(x - crosshairLength, y);
    context.lineTo(x + crosshairLength, y);
    context.stroke();
    // Vertical line
    context.beginPath();
    context.moveTo(x, y - crosshairLength);
    context.lineTo(x, y + crosshairLength);
    context.stroke();
    // No text label needed for calibration points
    context.restore();
};

});
parcelRegister("czco8", function(module, exports) {

$parcel$export(module.exports, "formatSizeCategory", () => $9a19001dceefab02$export$52df254465883645);
$parcel$export(module.exports, "formatSizeCategories", () => $9a19001dceefab02$export$16627f243c8fd9e5);
/**
 * Canonical ordering for size categories (smallest to largest)
 */ const $9a19001dceefab02$var$SIZE_ORDER = [
    "very-small",
    "small",
    "midsize",
    "super-midsize",
    "large",
    "enormous"
];
function $9a19001dceefab02$export$52df254465883645(size) {
    const labels = {
        "very-small": "VS",
        "small": "S",
        "midsize": "M",
        "super-midsize": "SM",
        "large": "L",
        "enormous": "E"
    };
    return labels[size] || size;
}
function $9a19001dceefab02$export$9c2dccf874c7d915(sizes) {
    return [
        ...sizes
    ].sort((a, b)=>{
        const indexA = $9a19001dceefab02$var$SIZE_ORDER.indexOf(a);
        const indexB = $9a19001dceefab02$var$SIZE_ORDER.indexOf(b);
        return indexA - indexB;
    });
}
function $9a19001dceefab02$export$16627f243c8fd9e5(sizes) {
    return $9a19001dceefab02$export$9c2dccf874c7d915(sizes).map($9a19001dceefab02$export$52df254465883645).join("/");
}

});

parcelRegister("2v7Ik", function(module, exports) {

$parcel$export(module.exports, "isOnText", () => $b31f2d0e4733ee85$export$fec357683a728109);
$parcel$export(module.exports, "isPointInShapeOrOnEdge", () => $b31f2d0e4733ee85$export$977cead8aca24441);
$parcel$export(module.exports, "pointToSegmentDistance", () => $b31f2d0e4733ee85$export$f96afe567099ccbe);
$parcel$export(module.exports, "calculateArea", () => $b31f2d0e4733ee85$export$1667c98eaa3bae62);
$parcel$export(module.exports, "rotatePoints", () => $b31f2d0e4733ee85$export$42659cf1c7f6609a);
$parcel$export(module.exports, "getCenter", () => $b31f2d0e4733ee85$export$c91255cadecfe081);
$parcel$export(module.exports, "adjustSquare", () => $b31f2d0e4733ee85$export$388b94dde1773a02);
$parcel$export(module.exports, "insertNewPoint", () => $b31f2d0e4733ee85$export$8c6ddc6a451bc74f);
$parcel$export(module.exports, "scalePolygon", () => $b31f2d0e4733ee85$export$b32c4d26933d0880);
$parcel$export(module.exports, "getDimensions", () => $b31f2d0e4733ee85$export$d1aa971bf69c7e87);
$parcel$export(module.exports, "getSnapPoint", () => $b31f2d0e4733ee85$export$dbeb706076cd0a68);
$parcel$export(module.exports, "snapSquare", () => $b31f2d0e4733ee85$export$2ec58ef430f1aabe);

var $bKsdy = parcelRequire("bKsdy");
const $b31f2d0e4733ee85$export$fec357683a728109 = (canvas, shape, point)=>{
    const padding = 10;
    const context = canvas?.getContext("2d");
    const textWidth = (0, $bKsdy.measureText)(context, shape).width;
    const textHeight = shape.font_size;
    const points = [
        {
            x: shape.points[0].x - textWidth / 2 - padding,
            y: shape.points[0].y - textHeight / 2 - padding
        },
        {
            x: shape.points[0].x + textWidth / 2 + padding,
            y: shape.points[0].y - textHeight / 2 - padding
        },
        {
            x: shape.points[0].x + textWidth / 2 + padding,
            y: shape.points[0].y + textHeight / 2 + padding
        },
        {
            x: shape.points[0].x - textWidth / 2 - padding,
            y: shape.points[0].y + textHeight / 2 + padding
        }
    ];
    return $b31f2d0e4733ee85$export$977cead8aca24441(point, points);
};
const $b31f2d0e4733ee85$export$977cead8aca24441 = (point, shapePoints)=>{
    // Handle the case where the shape is a single point
    if (shapePoints.length === 1) return Math.hypot(point.x - shapePoints[0].x, point.y - shapePoints[0].y) < 10;
    // Check if the point is inside the shape using ray-casting algorithm
    let isInside = false;
    for(let i = 0, j = shapePoints.length - 1; i < shapePoints.length; j = i++){
        const xi = shapePoints[i].x, yi = shapePoints[i].y;
        const xj = shapePoints[j].x, yj = shapePoints[j].y;
        const intersect = yi > point.y !== yj > point.y && point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    // Check if the point is on any of the edges of the shape
    for(let i = 0, j = shapePoints.length - 1; i < shapePoints.length; j = i++){
        if ($b31f2d0e4733ee85$export$f96afe567099ccbe(point, shapePoints[i], shapePoints[j]) < 10) return true;
    }
    return isInside;
};
const $b31f2d0e4733ee85$export$f96afe567099ccbe = (point, start, end)=>{
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const lengthSquared = dx * dx + dy * dy;
    let t = ((point.x - start.x) * dx + (point.y - start.y) * dy) / lengthSquared;
    t = Math.max(0, Math.min(1, t));
    const nearestX = start.x + t * dx;
    const nearestY = start.y + t * dy;
    return Math.hypot(point.x - nearestX, point.y - nearestY);
};
const $b31f2d0e4733ee85$export$d7ab4a18a6b0f37e = (points, smoothingFactor = 0.75)=>{
    // No smoothing needed if less than 3 points
    if (points.length < 3) return points;
    const smoothedPoints = [];
    // Generate smoothed points using Catmull-Rom spline
    for(let i = 0; i < points.length - 1; i++){
        const p0 = points[i - 1] || points[i]; // Previous point (or duplicate of current for edge cases)
        const p1 = points[i]; // Current point
        const p2 = points[i + 1]; // Next point
        const p3 = points[i + 2] || points[i + 1]; // Point after next (or duplicate for edge cases)
        // Generate control points
        for(let t = 0; t <= 1; t += smoothingFactor){
            const t2 = t * t;
            const t3 = t2 * t;
            const x = 0.5 * (2 * p1.x + (-p0.x + p2.x) * t + (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * t2 + (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * t3);
            const y = 0.5 * (2 * p1.y + (-p0.y + p2.y) * t + (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * t2 + (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * t3);
            smoothedPoints.push({
                x: x,
                y: y
            });
        }
    }
    return smoothedPoints;
};
const $b31f2d0e4733ee85$export$4fadfe14f316aee7 = (lastPoint, currentPoint)=>{
    // Calculate the difference in x and y
    const dx = currentPoint.x - lastPoint.x;
    const dy = currentPoint.y - lastPoint.y;
    // Calculate the angle in degrees
    const angle = Math.atan2(dy, dx) * (180 / Math.PI);
    // Snap angle to nearest 45 degrees
    const snappedAngle = Math.round(angle / 45) * 45;
    // Convert snapped angle back to radians
    const radians = snappedAngle * Math.PI / 180;
    // Calculate new dx and dy using the snapped angle and original distance
    const distance = Math.sqrt(dx * dx + dy * dy);
    const snappedDx = Math.cos(radians) * distance;
    const snappedDy = Math.sin(radians) * distance;
    // Return the new snapped point
    return {
        x: lastPoint.x + snappedDx,
        y: lastPoint.y + snappedDy
    };
};
const $b31f2d0e4733ee85$export$1667c98eaa3bae62 = (points, scale = 1)=>{
    const numPoints = points.length;
    const scaledPoints = points.map((point)=>({
            x: point.x * scale,
            y: point.y * scale
        }));
    // A shape with less than 3 points has no area
    if (numPoints < 3) return 0;
    let area = 0;
    for(let i = 0; i < numPoints; i++){
        const j = (i + 1) % numPoints; // Wrap around to the first point
        area += scaledPoints[i].x * scaledPoints[j].y - scaledPoints[j].x * scaledPoints[i].y;
    }
    return Math.abs(area / 2);
};
const $b31f2d0e4733ee85$export$4d2d86455defa0a5 = (point, center, angle)=>{
    const radians = angle * Math.PI / 180;
    const cos = Math.cos(radians);
    const sin = Math.sin(radians);
    const translatedX = point.x - center.x;
    const translatedY = point.y - center.y;
    return {
        x: translatedX * cos - translatedY * sin + center.x,
        y: translatedX * sin + translatedY * cos + center.y
    };
};
const $b31f2d0e4733ee85$export$42659cf1c7f6609a = (points, angle)=>{
    const center = $b31f2d0e4733ee85$export$c91255cadecfe081(points);
    // Rotate each point in the shape by the incremental angle change
    return points.map((point)=>$b31f2d0e4733ee85$export$4d2d86455defa0a5(point, center, angle));
};
const $b31f2d0e4733ee85$export$c91255cadecfe081 = (points)=>{
    let area = 0; // Signed area of the polygon
    let cx = 0; // X-coordinate of the centroid
    let cy = 0; // Y-coordinate of the centroid
    const n = points.length;
    // Loop through the polygon vertices
    for(let i = 0; i < n; i++){
        const x0 = points[i].x;
        const y0 = points[i].y;
        const x1 = points[(i + 1) % n].x; // Wrap around for the last vertex
        const y1 = points[(i + 1) % n].y;
        const crossProduct = x0 * y1 - x1 * y0;
        area += crossProduct;
        cx += (x0 + x1) * crossProduct;
        cy += (y0 + y1) * crossProduct;
    }
    area *= 0.5;
    cx /= 6 * area;
    cy /= 6 * area;
    return {
        x: cx,
        y: cy
    };
};
const $b31f2d0e4733ee85$export$388b94dde1773a02 = (points, draggedIndex, draggedPoint, center)=>{
    const oppositeIndex = (draggedIndex + 2) % 4; // Opposite vertex in a square
    const newPoints = [
        ...points
    ];
    // Calculate the vector from the center to the dragged point
    const dx = draggedPoint.x - center.x;
    const dy = draggedPoint.y - center.y;
    // Adjust the dragged point
    newPoints[draggedIndex] = draggedPoint;
    // Adjust the opposite point
    newPoints[oppositeIndex] = {
        x: center.x - dx,
        y: center.y - dy
    };
    // Adjust the adjacent points to maintain proportions
    const adjacent1 = (draggedIndex + 1) % 4;
    const adjacent2 = (draggedIndex + 3) % 4;
    newPoints[adjacent1] = {
        x: center.x - dy,
        y: center.y + dx
    };
    newPoints[adjacent2] = {
        x: center.x + dy,
        y: center.y - dx
    };
    return newPoints;
};
const $b31f2d0e4733ee85$export$8c6ddc6a451bc74f = (points, newPoint)=>{
    const newPoints = [];
    // TODO: fix. put this between the correct points
    // Check if the point is on any of the edges of the shape
    for(let i = 0, j = points.length - 1; i < points.length; j = i++){
        if ($b31f2d0e4733ee85$export$f96afe567099ccbe(newPoint, points[i], points[j]) < 10) newPoints.push(newPoint);
        newPoints.push(points[i]);
    }
    return newPoints;
};
const $b31f2d0e4733ee85$export$21cc35e7141a659e = (shape, factor)=>{
    return {
        ...shape,
        points: shape.points.map((point)=>{
            return {
                x: point.x * factor,
                y: point.y * factor
            };
        })
    };
};
const $b31f2d0e4733ee85$export$b32c4d26933d0880 = (points, scale)=>{
    const centroid = $b31f2d0e4733ee85$export$c91255cadecfe081(points);
    return points.map((point)=>{
        return {
            x: centroid.x + (point.x - centroid.x) * scale,
            y: centroid.y + (point.y - centroid.y) * scale
        };
    });
};
const $b31f2d0e4733ee85$export$d1aa971bf69c7e87 = (points)=>{
    const minX = Math.min(...points.map((point)=>point.x));
    const maxX = Math.max(...points.map((point)=>point.x));
    const minY = Math.min(...points.map((point)=>point.y));
    const maxY = Math.max(...points.map((point)=>point.y));
    return {
        width: maxX - minX,
        height: maxY - minY
    };
};
const $b31f2d0e4733ee85$export$dbeb706076cd0a68 = (mousePosition, lastPoint)=>{
    const angle = Math.atan2(mousePosition.y - lastPoint.y, mousePosition.x - lastPoint.x);
    const snapAngle = Math.round(angle * 4 / Math.PI) * (Math.PI / 4);
    const snapDistance = Math.hypot(mousePosition.x - lastPoint.x, mousePosition.y - lastPoint.y);
    const snapX = lastPoint.x + snapDistance * Math.cos(snapAngle);
    const snapY = lastPoint.y + snapDistance * Math.sin(snapAngle);
    return {
        x: snapX,
        y: snapY
    };
};
const $b31f2d0e4733ee85$export$2ec58ef430f1aabe = (points)=>{
    const center = $b31f2d0e4733ee85$export$c91255cadecfe081(points);
    const newPoints = [
        ...points
    ];
    for(let i = 0; i < points.length; i++){
        const point = points[i];
        const snapPoint = $b31f2d0e4733ee85$export$4fadfe14f316aee7(center, point);
        newPoints[i] = snapPoint;
    }
    return newPoints;
};

});

parcelRegister("67btB", function(module, exports) {

$parcel$export(module.exports, "SIZE_CATEGORY_OPTIONS", () => $b76d1d6ed6dd8a7d$export$b044b3f7cdcbe87f);
$parcel$export(module.exports, "getDefaultSizeCategory", () => $b76d1d6ed6dd8a7d$export$435692eda06f1794);
$parcel$export(module.exports, "getMaxAllowedSizes", () => $b76d1d6ed6dd8a7d$export$95f30ca2ef5c97cc);
$parcel$export(module.exports, "makeDefaultShape", () => $b76d1d6ed6dd8a7d$export$4aed17209e53506f);
$parcel$export(module.exports, "RampCanvas", () => $b76d1d6ed6dd8a7d$export$a8c0ffb08a92108c);

var $ayMG0 = parcelRequire("ayMG0");

var $fDKu1 = parcelRequire("fDKu1");

var $5H68o = parcelRequire("5H68o");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");

var $acw62 = parcelRequire("acw62");

var $5TxR8 = parcelRequire("5TxR8");

var $5sKyw = parcelRequire("5sKyw");

var $akvO8 = parcelRequire("akvO8");

var $ga8GY = parcelRequire("ga8GY");
parcelRequire("baghD");
var $drjQE = parcelRequire("drjQE");

var $ceJla = parcelRequire("ceJla");

var $ZD2ym = parcelRequire("ZD2ym");

var $41u54 = parcelRequire("41u54");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");

var $8ZoVx = parcelRequire("8ZoVx");

var $bKsdy = parcelRequire("bKsdy");

var $6qXZS = parcelRequire("6qXZS");

var $d9sFw = parcelRequire("d9sFw");

var $655Fv = parcelRequire("655Fv");

var $90nUZ = parcelRequire("90nUZ");

var $gC9gt = parcelRequire("gC9gt");

var $flHhZ = parcelRequire("flHhZ");

var $7mOBL = parcelRequire("7mOBL");
const $b76d1d6ed6dd8a7d$export$b044b3f7cdcbe87f = [
    {
        value: "very-small",
        label: "Very Small (\u226440ft)",
        maxFeet: 40
    },
    {
        value: "small",
        label: "Small (\u226460ft)",
        maxFeet: 60
    },
    {
        value: "midsize",
        label: "Midsize (\u226480ft)",
        maxFeet: 80
    },
    {
        value: "super-midsize",
        label: "S-Mid (\u2264100ft)",
        maxFeet: 100
    },
    {
        value: "large",
        label: "Large (\u2264120ft)",
        maxFeet: 120
    }
];
function $b76d1d6ed6dd8a7d$export$435692eda06f1794(spotFeet) {
    for (const option of $b76d1d6ed6dd8a7d$export$b044b3f7cdcbe87f){
        if (spotFeet <= option.maxFeet) return option.value;
    }
    return "large"; // Fallback for > 120ft
}
function $b76d1d6ed6dd8a7d$export$95f30ca2ef5c97cc(spotSize) {
    const sizeHierarchy = [
        "very-small",
        "small",
        "midsize",
        "super-midsize",
        "large"
    ];
    const maxIndex = sizeHierarchy.indexOf(spotSize);
    return sizeHierarchy.slice(0, maxIndex + 1);
}
const $b76d1d6ed6dd8a7d$export$4aed17209e53506f = (fbo_id, ramp_id)=>({
        id: (0, $5sKyw.default)(),
        ramp_id: ramp_id,
        fbo_id: fbo_id,
        tags: [],
        points: [],
        type: "Line",
        locked: false,
        line_style: "solid",
        line_width: 1,
        stroke_style: (0, $7mOBL.SHAPE_COLORS)[0],
        fill_style: "",
        fill_pattern: "",
        font_size: 24,
        text: "",
        priority: 5
    });
const $b76d1d6ed6dd8a7d$export$a8c0ffb08a92108c = ({ selectedTool: selectedTool, setSelectedTool: setSelectedTool })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { ramp: ramp, setRamp: setRamp, highlightedShapes: highlightedShapes, activeShapes: activeShapes, setActiveShapes: setActiveShapes } = (0, $ceJla.useLocalRampState)();
    const [history, setHistory] = $acw62.useState([]); // History stack
    const { showReferenceImage: showReferenceImage, showMeasurements: showMeasurements, showGuideLines: showGuideLines, showCalibrationPoints: showCalibrationPoints, highlightedCalibrationPoint: highlightedCalibrationPoint } = (0, $ceJla.useRampEditorState)();
    const [zoomLevel, setZoomLevel] = $acw62.useState(1);
    const [canvasWidth, setCanvasWidth] = $acw62.useState(600);
    const div = $acw62.useCallback((node)=>{
        if (node?.offsetWidth) setCanvasWidth(node.offsetWidth * 0.9);
    }, []);
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const pixelsToFeetRatio = canvasWidth / (ramp?.width ?? 1);
    const canvasHeight = canvasWidth * ramp?.depth / ramp?.width;
    const pixelsToFeet = (px)=>px / pixelsToFeetRatio;
    const { loading: loadingPatterns, patterns: patterns } = (0, $flHhZ.usePatterns)();
    // convert shapes to pixels
    const shapes = $acw62.useMemo(()=>ramp?.shapes?.map((shape)=>({
                ...shape,
                points: shape.points.map((point)=>({
                        x: point.x * pixelsToFeetRatio,
                        y: point.y * pixelsToFeetRatio
                    }))
            })) || [], [
        ramp?.shapes,
        pixelsToFeetRatio
    ]);
    // returns active shapes in pixels
    const getActiveShapes = $acw62.useCallback(()=>{
        return shapes.filter((s)=>activeShapes.includes(s.id) || draggingShape?.shapeId === s.id).filter((s)=>!s.locked);
    }, [
        shapes,
        activeShapes
    ]);
    // set a given shape, converting from pixels to feet
    const setShape = $acw62.useCallback((id, zShape)=>{
        setRamp((currentRamp)=>{
            if (!currentRamp) {
                console.error("[RampCanvas] setShape called but currentRamp is undefined");
                return currentRamp;
            }
            return {
                ...currentRamp,
                shapes: currentRamp.shapes.map((shape)=>{
                    if (shape.id === id) // zShape is in pixels, convert to feet
                    return {
                        ...zShape,
                        points: zShape.points.map((point)=>({
                                x: point.x / pixelsToFeetRatio,
                                y: point.y / pixelsToFeetRatio
                            }))
                    };
                    // Other shapes are already in feet, return as-is
                    return shape;
                })
            };
        });
    }, [
        setRamp,
        pixelsToFeetRatio
    ]);
    // set shapes, converting from pixels to feet
    const setShapes = $acw62.useCallback((shapesOrUpdater)=>{
        setRamp((currentRamp)=>{
            if (!currentRamp) {
                console.error("[RampCanvas] setShapes called but currentRamp is undefined");
                return currentRamp;
            }
            const updatedShapes = typeof shapesOrUpdater === "function" ? shapesOrUpdater(currentRamp.shapes.map((shape)=>({
                    ...shape,
                    points: shape.points.map((point)=>({
                            x: point.x * pixelsToFeetRatio,
                            y: point.y * pixelsToFeetRatio
                        }))
                }))) : shapesOrUpdater;
            return {
                ...currentRamp,
                shapes: updatedShapes.map((shape)=>({
                        ...shape,
                        points: shape.points.map((point)=>({
                                x: point.x / pixelsToFeetRatio,
                                y: point.y / pixelsToFeetRatio
                            }))
                    }))
            };
        });
    }, [
        setRamp,
        pixelsToFeetRatio
    ]);
    const duplicateShapes = ()=>{
        if (activeShapes.length > 0) {
            const updatedShapes = [
                ...shapes
            ];
            getActiveShapes().forEach((shape)=>{
                updatedShapes.unshift({
                    ...shape,
                    id: (0, $5sKyw.default)(),
                    points: shape.points.map((point)=>({
                            x: point.x + pixelsToFeetRatio * 25,
                            y: point.y + pixelsToFeetRatio * 25
                        }))
                });
            });
            setShapes(updatedShapes);
            setActiveShapes([
                ...activeShapes,
                updatedShapes[0].id
            ]);
        }
    };
    // Undo the last action
    const undo = ()=>{
        if (history.length > 0) {
            const previousState = history[history.length - 1]; // Get the last saved state
            if (!previousState) return;
            setShapes(previousState); // Revert to the last state
            setHistory((prevHistory)=>prevHistory.slice(0, -1)); // Remove the last state from history
        }
    };
    const [currentShape, setCurrentShape] = $acw62.useState($b76d1d6ed6dd8a7d$export$4aed17209e53506f(ramp.fbo_id, ramp.id));
    const [draggingPoint, setDraggingPoint] = $acw62.useState(null);
    const [draggingShape, setDraggingShape] = $acw62.useState(null);
    const [mousePosition, setMousePosition] = $acw62.useState(null);
    const [contextMenu, setContextMenu] = $acw62.useState(null);
    const [previewSpots, setPreviewSpots] = $acw62.useState([]);
    const [textPrompt, setTextPrompt] = $acw62.useState({
        open: false
    });
    const [cursor, setCursor] = $acw62.useState(null);
    const [isShiftPressed] = (0, $5TxR8.default)("Shift");
    const [isCommandPressed] = (0, $5TxR8.default)("Meta");
    const [isOptPressed] = (0, $5TxR8.default)("Alt");
    (0, $6qXZS.useCanvasHotkeys)({
        activeShapes: activeShapes,
        setActiveShapes: setActiveShapes,
        getActiveShapes: getActiveShapes,
        pixelsToFeetRatio: pixelsToFeetRatio,
        shapes: shapes,
        setShapes: setShapes,
        undo: undo,
        duplicateShapes: duplicateShapes
    });
    const draw = $acw62.useCallback((context)=>{
        (0, $bKsdy.drawMain)(context, {
            shapes: shapes,
            currentShape: currentShape,
            highlightedShapes: highlightedShapes,
            mousePosition: mousePosition,
            calibrationPoints: ramp?.calibration_points,
            showCalibrationPoints: showCalibrationPoints,
            highlightedCalibrationPoint: highlightedCalibrationPoint,
            canvasRef: canvasRef,
            pixelsToFeet: pixelsToFeet,
            showMeasurements: showMeasurements,
            showGuideLines: showGuideLines,
            pixelsToFeetRatio: pixelsToFeetRatio,
            activeShapes: activeShapes,
            patterns: patterns,
            isShiftPressed: isShiftPressed,
            zoomLevel: zoomLevel,
            isMetric: activeFBO?.settings?.useMetricSystem || false,
            previewSpots: previewSpots
        });
    }, [
        shapes,
        currentShape,
        previewSpots,
        activeShapes,
        mousePosition,
        isShiftPressed,
        highlightedShapes,
        canvasRef,
        pixelsToFeet,
        showMeasurements,
        showGuideLines,
        showCalibrationPoints,
        ramp?.calibration_points,
        highlightedCalibrationPoint,
        pixelsToFeetRatio,
        patterns
    ]);
    $acw62.useEffect(()=>{
        const canvas = canvasRef.current;
        const context = canvas?.getContext("2d");
        if (canvas && context) draw(context);
    }, [
        canvasRef,
        draw
    ]);
    // Simple check to prevent "undefined" in image URLs
    const safeImageUrl = $acw62.useMemo(()=>{
        if (ramp.reference_image && typeof ramp.reference_image === "string" && ramp.reference_image.includes("undefined")) {
            console.warn(`Invalid URL with 'undefined' detected: ${ramp.reference_image}`);
            return null;
        }
        return ramp.reference_image;
    }, [
        ramp.reference_image
    ]);
    // Add a point to the current shape or complete the shape if clicking on the first point
    const handleCanvasClick = (0, $d9sFw.useOnCanvasClick)({
        selectedTool: selectedTool,
        shapes: shapes,
        setShapes: setShapes,
        currentShape: currentShape,
        setCurrentShape: setCurrentShape,
        setMousePosition: setMousePosition,
        setSelectedTool: setSelectedTool,
        ramp: ramp,
        activeShapes: activeShapes,
        setActiveShapes: setActiveShapes,
        canvasRef: canvasRef,
        isCommandPressed: isCommandPressed,
        isOptPressed: isOptPressed,
        isShiftPressed: isShiftPressed,
        setShape: setShape,
        setContextMenu: setContextMenu,
        pixelsToFeetRatio: pixelsToFeetRatio
    });
    // Start dragging a point (either from existing shapes or the current shape)
    const handleMouseDown = (0, $90nUZ.useOnMouseDown)({
        selectedTool: selectedTool,
        setSelectedTool: setSelectedTool,
        shapes: shapes,
        setShapes: setShapes,
        currentShape: currentShape,
        setDraggingPoint: setDraggingPoint,
        setDraggingShape: setDraggingShape,
        draggingPoint: draggingPoint,
        draggingShape: draggingShape,
        canvasRef: canvasRef,
        ramp: ramp,
        setHistory: setHistory,
        setTextPrompt: setTextPrompt
    });
    // Drag the point
    const handleMouseMove = (0, $gC9gt.useOnMouseMove)({
        selectedTool: selectedTool,
        shapes: shapes,
        setShapes: setShapes,
        currentShape: currentShape,
        setDraggingPoint: setDraggingPoint,
        setDraggingShape: setDraggingShape,
        draggingPoint: draggingPoint,
        draggingShape: draggingShape,
        canvasRef: canvasRef,
        ramp: ramp,
        isShiftPressed: isShiftPressed,
        setMousePosition: setMousePosition,
        getActiveShapes: getActiveShapes,
        setSelectedTool: setSelectedTool
    });
    const handleContextMenu = (0, $655Fv.useOnContextMenu)({
        selectedTool: selectedTool,
        shapes: shapes,
        setContextMenu: setContextMenu,
        canvasRef: canvasRef
    });
    // Finish dragging
    const handleMouseUp = ()=>{
        setDraggingShape(null);
        setDraggingPoint(null);
    };
    if (loadingPatterns) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                justifyContent: "flex-end",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: navigator.platform.includes("Mac") ? `\u{2318} + d` : `alt + d`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            color: "info",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fDKu1))), {}),
                            onClick: duplicateShapes,
                            children: "Copy Selected"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: navigator.platform.includes("Mac") ? `\u{2318} + z` : `alt + z`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            color: "info",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5H68o))), {}),
                            onClick: undo,
                            children: "Undo"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                ref: div,
                sx: {
                    cursor: cursor,
                    position: "relative",
                    overflowX: "scroll"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41u54.DraggingScrollContainer), {
                    zoomLevel: zoomLevel,
                    feetToPixels: 1 / pixelsToFeetRatio,
                    disabled: false,
                    onClick: handleCanvasClick,
                    onMouseDown: handleMouseDown,
                    onMouseMove: handleMouseMove,
                    onMouseUp: handleMouseUp,
                    onContextMenu: handleContextMenu,
                    preventDefault: (event)=>{
                        if (selectedTool === "Select") return (0, $90nUZ.clickedShape)(canvasRef, event, shapes);
                        return true;
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $akvO8.MeasuringTool), {
                        pixelsToFeetRatio: pixelsToFeetRatio,
                        overlayExpansionRatio: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ga8GY.default), {
                            ref: canvasRef,
                            draw: draw,
                            width: canvasWidth,
                            height: canvasHeight,
                            onClick: handleCanvasClick,
                            onMouseDown: handleMouseDown,
                            onMouseMove: (evt)=>{
                                if ((0, $90nUZ.clickedShape)(canvasRef, evt, shapes)) setCursor("default");
                                else setCursor(null);
                                handleMouseMove(evt);
                            },
                            onMouseUp: handleMouseUp,
                            onContextMenu: handleContextMenu,
                            style: {
                                border: "1px solid black",
                                cursor: selectedTool === "Select" ? cursor : "crosshair",
                                backgroundImage: showReferenceImage && safeImageUrl ? `url(${safeImageUrl})` : undefined,
                                backgroundSize: showReferenceImage && "cover",
                                margin: "20px"
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7mOBL.ShapeEditDialog), {
                contextMenu: contextMenu,
                setContextMenu: setContextMenu,
                onClose: ()=>{
                    setDraggingShape(null);
                    setDraggingPoint(null);
                    setContextMenu(null);
                    setPreviewSpots([]);
                },
                shapes: shapes,
                setShapes: setShapes,
                canvasHeight: canvasHeight,
                canvasWidth: canvasWidth,
                previewSpots: previewSpots,
                setPreviewSpots: setPreviewSpots
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drjQE.ZoomControl), {
                currentZoom: canvasWidth,
                increment: 0.1,
                onClickPlus: ()=>{
                    // Limit zoom to 250%
                    if (zoomLevel < 2.5) {
                        setZoomLevel(zoomLevel * 1.1);
                        setCanvasWidth(canvasWidth * 1.1);
                        setCurrentShape({
                            ...currentShape,
                            points: currentShape.points.map((point)=>({
                                    x: point.x * 1.1,
                                    y: point.y * 1.1
                                }))
                        });
                    }
                },
                onClickMinus: ()=>{
                    setZoomLevel(zoomLevel * 0.9);
                    setCanvasWidth(canvasWidth * 0.9);
                    setCurrentShape({
                        ...currentShape,
                        points: currentShape.points.map((point)=>({
                                x: point.x * 0.9,
                                y: point.y * 0.9
                            }))
                    });
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ZoVx.CanvasTextInput), {
                open: textPrompt.open,
                setOpen: (open)=>setTextPrompt({
                        open: open
                    }),
                onDone: (text)=>{
                    const updatedShapes = [
                        ...shapes
                    ];
                    updatedShapes.unshift({
                        id: (0, $5sKyw.default)(),
                        fbo_id: ramp.fbo_id,
                        ramp_id: ramp.id,
                        tags: [],
                        points: [
                            {
                                x: textPrompt.x,
                                y: textPrompt.y
                            }
                        ],
                        locked: false,
                        type: "Text",
                        stroke_style: "white",
                        line_style: "solid",
                        line_width: 3,
                        text: text,
                        font_size: 18,
                        reference_image_height: canvasHeight
                    });
                    setShapes(updatedShapes);
                    setSelectedTool("Select");
                }
            })
        ]
    });
};

});
parcelRegister("5TxR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $44ac59e7503fcc2c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hIZ0l = parcelRequire("hIZ0l");
var $44ac59e7503fcc2c$var$useKeyPress = function(keyFilter) {
    var _a = (0, $acw62.useState)([
        false,
        null
    ]), state = _a[0], set = _a[1];
    (0, $hIZ0l.default)(keyFilter, function(event) {
        return set([
            true,
            event
        ]);
    }, {
        event: 'keydown'
    }, [
        state
    ]);
    (0, $hIZ0l.default)(keyFilter, function(event) {
        return set([
            false,
            event
        ]);
    }, {
        event: 'keyup'
    }, [
        state
    ]);
    return state;
};
var $44ac59e7503fcc2c$export$2e2bcd8739ae039 = $44ac59e7503fcc2c$var$useKeyPress;

});
parcelRegister("hIZ0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce75ddf11f50419c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7RFff = parcelRequire("7RFff");

var $iG64q = parcelRequire("iG64q");
var $ce75ddf11f50419c$var$createKeyPredicate = function(keyFilter) {
    return typeof keyFilter === 'function' ? keyFilter : typeof keyFilter === 'string' ? function(event) {
        return event.key === keyFilter;
    } : keyFilter ? function() {
        return true;
    } : function() {
        return false;
    };
};
var $ce75ddf11f50419c$var$useKey = function(key, fn, opts, deps) {
    if (fn === void 0) fn = (0, $iG64q.noop);
    if (opts === void 0) opts = {};
    if (deps === void 0) deps = [
        key
    ];
    var _a = opts.event, event = _a === void 0 ? 'keydown' : _a, target = opts.target, options = opts.options;
    var useMemoHandler = (0, $acw62.useMemo)(function() {
        var predicate = $ce75ddf11f50419c$var$createKeyPredicate(key);
        var handler = function(handlerEvent) {
            if (predicate(handlerEvent)) return fn(handlerEvent);
        };
        return handler;
    }, deps);
    (0, $7RFff.default)(event, useMemoHandler, target, options);
};
var $ce75ddf11f50419c$export$2e2bcd8739ae039 = $ce75ddf11f50419c$var$useKey;

});
parcelRegister("7RFff", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b9d7a0b58d00300$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $iG64q = parcelRequire("iG64q");
var $5b9d7a0b58d00300$var$defaultTarget = (0, $iG64q.isBrowser) ? window : null;
var $5b9d7a0b58d00300$var$isListenerType1 = function(target) {
    return !!target.addEventListener;
};
var $5b9d7a0b58d00300$var$isListenerType2 = function(target) {
    return !!target.on;
};
var $5b9d7a0b58d00300$var$useEvent = function(name, handler, target, options) {
    if (target === void 0) target = $5b9d7a0b58d00300$var$defaultTarget;
    (0, $acw62.useEffect)(function() {
        if (!handler) return;
        if (!target) return;
        if ($5b9d7a0b58d00300$var$isListenerType1(target)) (0, $iG64q.on)(target, name, handler, options);
        else if ($5b9d7a0b58d00300$var$isListenerType2(target)) target.on(name, handler, options);
        return function() {
            if ($5b9d7a0b58d00300$var$isListenerType1(target)) (0, $iG64q.off)(target, name, handler, options);
            else if ($5b9d7a0b58d00300$var$isListenerType2(target)) target.off(name, handler, options);
        };
    }, [
        name,
        handler,
        target,
        JSON.stringify(options)
    ]);
};
var $5b9d7a0b58d00300$export$2e2bcd8739ae039 = $5b9d7a0b58d00300$var$useEvent;

});



parcelRegister("akvO8", function(module, exports) {

$parcel$export(module.exports, "MeasuringTool", () => $5fe4aa3ba10d1288$export$cdaa6ddcd20699df);

var $ayMG0 = parcelRequire("ayMG0");

var $kGwBF = parcelRequire("kGwBF");

var $acw62 = parcelRequire("acw62");

var $5TxR8 = parcelRequire("5TxR8");

var $ZD2ym = parcelRequire("ZD2ym");

var $5Bqq3 = parcelRequire("5Bqq3");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");

var $kkNbz = parcelRequire("kkNbz");
const $5fe4aa3ba10d1288$var$handleDrawLineWithTicksAndDistance = (ctx, startX, startY, endX, endY, distance, isShiftPressed)=>{
    // Adjust endX and endY to make the line straight if shift is pressed
    if (isShiftPressed) {
        if (Math.abs(endX - startX) > Math.abs(endY - startY)) endY = startY;
        else endX = startX;
    }
    // Draw the main line
    ctx.strokeStyle = "black";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo(endX, endY);
    ctx.stroke();
    // Calculate the angle of the line
    const dx = endX - startX;
    const dy = endY - startY;
    const length = Math.sqrt(dx * dx + dy * dy);
    const unitX = dx / length;
    const unitY = dy / length;
    // Perpendicular vector
    const perpX = -unitY;
    const perpY = unitX;
    // Length of the tick
    const tickLength = 10;
    // Draw tick at the start of the line
    ctx.beginPath();
    ctx.moveTo(startX + perpX * tickLength, startY + perpY * tickLength);
    ctx.lineTo(startX - perpX * tickLength, startY - perpY * tickLength);
    ctx.stroke();
    // Draw tick at the end of the line
    ctx.beginPath();
    ctx.moveTo(endX + perpX * tickLength, endY + perpY * tickLength);
    ctx.lineTo(endX - perpX * tickLength, endY - perpY * tickLength);
    ctx.stroke();
    // Calculate the midpoint of the line for the distance label
    const midX = (startX + endX) / 2;
    const midY = (startY + endY) / 2;
    // Set font and styles for the distance box
    const fontSize = 16;
    ctx.font = `${fontSize}px Lexend Deca`;
    ctx.fillStyle = "white";
    ctx.strokeStyle = "black";
    ctx.lineWidth = 1;
    // Calculate text width and height
    const textWidth = ctx.measureText(distance).width;
    const padding = 10;
    const boxWidth = textWidth + padding * 2;
    const boxHeight = fontSize + padding * 1.5;
    // Determine if the label should be inline or off to the side
    if (length > boxHeight * 2) {
        // Inline positioning
        const boxX = midX - boxWidth / 2;
        const boxY = midY - boxHeight / 2;
        // Draw a rounded rectangle for the distance box (inline)
        const radius = 5;
        ctx.beginPath();
        ctx.moveTo(boxX + radius, boxY);
        ctx.lineTo(boxX + boxWidth - radius, boxY);
        ctx.quadraticCurveTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + radius);
        ctx.lineTo(boxX + boxWidth, boxY + boxHeight - radius);
        ctx.quadraticCurveTo(boxX + boxWidth, boxY + boxHeight, boxX + boxWidth - radius, boxY + boxHeight);
        ctx.lineTo(boxX + radius, boxY + boxHeight);
        ctx.quadraticCurveTo(boxX, boxY + boxHeight, boxX, boxY + boxHeight - radius);
        ctx.lineTo(boxX, boxY + radius);
        ctx.quadraticCurveTo(boxX, boxY, boxX + radius, boxY);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        // Draw the distance text inside the box (inline)
        ctx.fillStyle = "black"; // Change text color to black
        ctx.fillText(distance, boxX + padding, boxY + fontSize + padding / 2);
    } else {
        // Off to the side positioning
        const offset = Math.max(50, length / 3); // Adjust offset for small distances
        // Calculate the box's top-left corner with dynamic offset
        const boxX = midX + perpX * offset - boxWidth / 2;
        const boxY = midY + perpY * offset - boxHeight / 2;
        // Draw a rounded rectangle for the distance box (off to the side)
        const radius = 5;
        ctx.beginPath();
        ctx.moveTo(boxX + radius, boxY);
        ctx.lineTo(boxX + boxWidth - radius, boxY);
        ctx.quadraticCurveTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + radius);
        ctx.lineTo(boxX + boxWidth, boxY + boxHeight - radius);
        ctx.quadraticCurveTo(boxX + boxWidth, boxY + boxHeight, boxX + boxWidth - radius, boxY + boxHeight);
        ctx.lineTo(boxX + radius, boxY + boxHeight);
        ctx.quadraticCurveTo(boxX, boxY + boxHeight, boxX, boxY + boxHeight - radius);
        ctx.lineTo(boxX, boxY + radius);
        ctx.quadraticCurveTo(boxX, boxY, boxX + radius, boxY);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        // Draw the distance text inside the box (off to the side)
        ctx.fillStyle = "black"; // Change text color to black
        ctx.fillText(distance, boxX + padding, boxY + fontSize + padding / 2);
    }
};
const $5fe4aa3ba10d1288$export$cdaa6ddcd20699df = ({ children: children, pixelsToFeetRatio: pixelsToFeetRatio, overlayExpansionRatio: overlayExpansionRatio = 1.25 })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { active: measuringToolActive, setActive: setMeasuringToolActive } = (0, $5Bqq3.useMeasuringToolState)();
    const [measuringToolState, setMeasuringToolState] = $acw62.useState(0);
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const [startPoint, setStartPoint] = $acw62.useState(null);
    const [endPoint, setEndPoint] = $acw62.useState(null);
    const [isShiftPressed] = (0, $5TxR8.default)("Shift");
    $acw62.useEffect(()=>{
        if (measuringToolActive) {
            setStartPoint(null);
            setEndPoint(null);
            setMeasuringToolState(0);
        }
    }, [
        measuringToolActive
    ]);
    const handleCanvasClick = (e)=>{
        if (!measuringToolActive) return;
        const rect = canvasRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        if (!startPoint) {
            // First click - store the starting point
            setStartPoint({
                x: x,
                y: y
            });
            setMeasuringToolState(1);
        } else if (endPoint && measuringToolState === 1) {
            if (isShiftPressed) {
                if (Math.abs(endPoint.x - startPoint.x) > Math.abs(endPoint.y - startPoint.y)) setEndPoint({
                    x: x,
                    y: startPoint.y
                });
                else setStartPoint({
                    x: startPoint.x,
                    y: y
                });
            }
            setMeasuringToolState(2);
        } else if (endPoint && measuringToolState === 2) {
            // Second click - store the end point and calculate the distance
            clearMeasurements();
            setMeasuringToolState(0);
        }
    };
    const clearMeasurements = ()=>{
        setStartPoint(null);
        setEndPoint(null);
        if (!canvasRef.current) return;
        const ctx = canvasRef.current.getContext("2d");
        ctx?.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    };
    const draw = $acw62.useCallback((ctx)=>{
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        drawMeasurement();
    }, []);
    const drawMeasurement = $acw62.useCallback(()=>{
        if (!measuringToolActive) return;
        if (!startPoint || !endPoint) return;
        const ctx = canvasRef.current?.getContext("2d");
        if (!ctx) return;
        // Calculate distance in pixels
        const pixelDistance = Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2));
        // Convert to feet
        const distanceInHumanReadable = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(pixelDistance / pixelsToFeetRatio), 2)} m` : `${(0, $lNEp2.formatNumber)(pixelDistance / pixelsToFeetRatio, 1)} ft`;
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        // Draw the line between the two points
        $5fe4aa3ba10d1288$var$handleDrawLineWithTicksAndDistance(ctx, startPoint.x, startPoint.y, endPoint.x, endPoint.y, distanceInHumanReadable, isShiftPressed);
    }, [
        startPoint,
        endPoint,
        measuringToolState,
        isShiftPressed
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), {
        onClickAway: ()=>{
            clearMeasurements();
            if (measuringToolState > 0) {
                setMeasuringToolState(0);
                setMeasuringToolActive(false);
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kkNbz.ClearCanvasOverlay), {
            active: measuringToolActive,
            ref: canvasRef,
            expandBy: overlayExpansionRatio,
            onClick: handleCanvasClick,
            onDraw: draw,
            onMouseMove: (e)=>{
                if (startPoint && measuringToolState < 2) {
                    const rect = canvasRef.current.getBoundingClientRect();
                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;
                    setEndPoint({
                        x: x,
                        y: y
                    });
                }
                if (startPoint && endPoint) drawMeasurement();
            },
            style: {
                cursor: "crosshair"
            },
            children: children
        })
    });
};

});
parcelRegister("5Bqq3", function(module, exports) {

$parcel$export(module.exports, "useMeasuringToolState", () => $ea30ee41babb05f9$export$2eec59d76500d10e);

var $f4OIt = parcelRequire("f4OIt");
const $ea30ee41babb05f9$export$2eec59d76500d10e = (0, $f4OIt.create)()((set)=>({
        active: false,
        setActive: (active)=>set({
                active: active
            })
    }));

});

parcelRegister("kkNbz", function(module, exports) {

$parcel$export(module.exports, "ClearCanvasOverlay", () => $ec365b31369169b2$export$726d1d70be24d4d9);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");

var $acw62 = parcelRequire("acw62");
const $ec365b31369169b2$export$726d1d70be24d4d9 = /*#__PURE__*/ $acw62.forwardRef(({ active: active, children: children, onMouseMove: onMouseMove, onDraw: onDraw, onClick: onClick, expandBy: expandBy = 1, style: style }, ref)=>{
    const containerRef = (0, $acw62.useRef)(null);
    const canvasRef = (0, $acw62.useRef)(null);
    const [dimensions, setDimensions] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    const [isDrawing, setIsDrawing] = (0, $acw62.useState)(false);
    const pointerDownPos = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // Update the dimensions of the canvas based on the child component
        const updateDimensions = ()=>{
            if (containerRef.current) {
                const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = containerRef.current;
                setDimensions({
                    width: offsetWidth * expandBy,
                    height: offsetHeight * expandBy
                });
            }
        };
        updateDimensions(); // Update dimensions on mount
        window.addEventListener("resize", updateDimensions); // Adjust on window resize
        return ()=>window.removeEventListener("resize", updateDimensions);
    }, // if the containerRef changes, update the dimensions
    [
        containerRef?.current?.offsetWidth,
        containerRef?.current?.offsetHeight
    ]);
    (0, $acw62.useEffect)(()=>{
        if (canvasRef.current) {
            const canvas = canvasRef.current;
            canvas.width = dimensions.width;
            canvas.height = dimensions.height;
        }
    }, [
        dimensions
    ]);
    (0, $acw62.useEffect)(()=>{
        // Assign ref if a ref is passed from the parent
        if (ref && canvasRef.current) {
            if (typeof ref === "function") ref(canvasRef.current);
            else ref.current = canvasRef.current;
        }
    }, [
        ref
    ]);
    const handlePointerMove = (e)=>{
        // Ignore multi-touch gestures (only handle primary pointer)
        if (!e.isPrimary) return;
        // Prevent scrolling during drag on touch devices
        if (e.pointerType === 'touch' && isDrawing) e.preventDefault();
        if (onMouseMove && canvasRef.current) {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext("2d");
            if (ctx) onMouseMove(e, ctx);
        }
        if (isDrawing && canvasRef.current && onDraw) {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext("2d");
            const rect = canvas.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            if (ctx) onDraw(ctx, x, y);
        }
    };
    const handlePointerDown = (e)=>{
        // Ignore multi-touch gestures (only handle primary pointer)
        if (!e.isPrimary) return;
        // Prevent scrolling/zooming on touch devices
        if (e.pointerType === 'touch') e.preventDefault();
        // Store pointer down position for click detection
        const rect = canvasRef.current?.getBoundingClientRect();
        if (rect) pointerDownPos.current = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        };
        setIsDrawing(true);
        // Capture pointer for reliable event tracking
        if (canvasRef.current) try {
            canvasRef.current.setPointerCapture(e.pointerId);
        } catch (ex) {
        // Pointer capture not supported or failed
        }
    };
    const handlePointerUp = (e)=>{
        if (!e.isPrimary) return;
        setIsDrawing(false);
        // Release pointer capture
        if (canvasRef.current) try {
            canvasRef.current.releasePointerCapture(e.pointerId);
        } catch (ex) {
        // Capture not supported or already released
        }
        // Detect if this is a click (not a drag) and trigger onClick callback
        if (onClick && pointerDownPos.current && canvasRef.current) {
            const rect = canvasRef.current.getBoundingClientRect();
            const upX = e.clientX - rect.left;
            const upY = e.clientY - rect.top;
            // Calculate distance moved since pointer down
            const dx = upX - pointerDownPos.current.x;
            const dy = upY - pointerDownPos.current.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            // If moved less than 5px, treat as a click
            if (distance < 5) {
                const ctx = canvasRef.current.getContext("2d");
                if (ctx) onClick(e, ctx, upX, upY);
            }
        }
        // Clear pointer down position
        pointerDownPos.current = null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        ref: containerRef,
        position: "relative",
        display: "inline-block",
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: active ? 100000 : -1,
                    // Ensure the canvas is on top
                    pointerEvents: active ? 'auto' : 'none',
                    // Don't intercept events when inactive
                    width: dimensions.width,
                    height: dimensions.height,
                    touchAction: 'none',
                    // Prevent browser touch gestures (scroll, zoom, etc.)
                    ...style
                },
                onPointerMove: handlePointerMove,
                onPointerDown: handlePointerDown,
                onPointerUp: handlePointerUp,
                onPointerCancel: handlePointerUp
            })
        ]
    });
});

});


parcelRegister("baghD", function(module, exports) {
$parcel$export(module.exports, "ZoomControl", () => (parcelRequire("drjQE")).ZoomControl);
parcelRequire("drjQE");

});
parcelRegister("drjQE", function(module, exports) {

$parcel$export(module.exports, "ZoomControl", () => $86eed88aa3e5689b$export$dd36b6cb96de1ba3);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $3zG2N = parcelRequire("3zG2N");

var $jJ7EI = parcelRequire("jJ7EI");

var $2p5OG = parcelRequire("2p5OG");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");
const $86eed88aa3e5689b$export$dd36b6cb96de1ba3 = ({ increment: increment = 0.1, onClickPlus: onClickPlus, onClickMinus: onClickMinus, onClickReset: onClickReset, showResetButton: showResetButton = false, position: position = 'fixed', bottom: bottom, right: right })=>{
    const theme = (0, $14H9o.default)();
    const [zoomChange, setZoomChange] = $acw62.useState(0);
    const [, setShowZoomLevel] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        // Show the zoom level for 2 seconds
        setShowZoomLevel(true);
        const timer = setTimeout(()=>{
            setShowZoomLevel(false);
        }, 1500);
        return ()=>clearTimeout(timer);
    }, [
        zoomChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        spacing: 1,
        sx: {
            position: position,
            bottom: bottom ?? theme.spacing(2),
            right: right ?? theme.spacing(2),
            zIndex: theme.zIndex.mobileStepper - 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2p5OG.default), {
            orientation: "vertical",
            variant: "contained",
            sx: {
                backgroundColor: "white"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: "Zoom In",
                    placement: "left",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        onClick: ()=>{
                            const newZoomLevel = 1 + (zoomChange + 1) * increment;
                            onClickPlus(newZoomLevel);
                            setZoomChange(zoomChange + 1);
                        },
                        sx: {
                            borderRadius: 0,
                            color: "white",
                            backgroundColor: "success.main"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {})
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: "Zoom Out",
                    placement: "left",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        onClick: ()=>{
                            const newZoomLevel = 1 + (zoomChange - 1) * increment;
                            if (newZoomLevel <= 0) return;
                            onClickMinus(newZoomLevel);
                            setZoomChange(zoomChange - 1);
                        },
                        sx: {
                            borderRadius: 0,
                            color: "white",
                            backgroundColor: "success.main"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3zG2N))), {})
                    })
                }),
                showResetButton && onClickReset && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "Reset Zoom",
                            placement: "left",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                onClick: ()=>{
                                    onClickReset();
                                    setZoomChange(0);
                                },
                                sx: {
                                    borderRadius: 0,
                                    color: "white",
                                    backgroundColor: "success.main"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jJ7EI))), {})
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("jJ7EI", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e5c8288d724f3d85$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5c8288d724f3d85$var$_createSvgIcon = $e5c8288d724f3d85$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e5c8288d724f3d85$var$_default = module.exports.default = (0, $e5c8288d724f3d85$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m-7 7H3v4c0 1.1.9 2 2 2h4v-2H5zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2m0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2z"
}), 'CenterFocusStrong');

});

parcelRegister("2p5OG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c026d95d0d4d482$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $djmpM = parcelRequire("djmpM");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $d8s3C = parcelRequire("d8s3C");

var $bwtSM = parcelRequire("bwtSM");

var $3eDio = parcelRequire("3eDio");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1c026d95d0d4d482$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $d8s3C.default).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $d8s3C.default).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $d8s3C.default).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $d8s3C.default).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}${(0, $jTnBY.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $d8s3C.default).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}${(0, $jTnBY.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $d8s3C.default).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $d8s3C.default).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $d8s3C.default).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $1c026d95d0d4d482$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $jTnBY.default)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $jTnBY.default)(orientation)}`,
            `grouped${(0, $jTnBY.default)(variant)}`,
            `grouped${(0, $jTnBY.default)(variant)}${(0, $jTnBY.default)(orientation)}`,
            `grouped${(0, $jTnBY.default)(variant)}${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d8s3C.getButtonGroupUtilityClass), classes);
};
const $1c026d95d0d4d482$var$ButtonGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $1c026d95d0d4d482$var$overridesResolver
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $d8s3C.default).lastButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $d8s3C.default).lastButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $d8s3C.default).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $d8s3C.default).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                                borderColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $8gMkr.alpha)(theme.palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $d8s3C.default).lastButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $d8s3C.default).lastButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $d8s3C.default).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $d8s3C.default).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $d8s3C.default).firstButton},& .${(0, $d8s3C.default).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $d8s3C.default).grouped}`]: {
            minWidth: 40,
            boxShadow: 'none',
            props: {
                variant: 'contained'
            },
            style: {
                '&:hover': {
                    boxShadow: 'none'
                }
            }
        }
    })));
const $1c026d95d0d4d482$var$ButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $1c026d95d0d4d482$var$useUtilityClasses(ownerState);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $djmpM.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bwtSM.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3eDio.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $1c026d95d0d4d482$export$2e2bcd8739ae039 = $1c026d95d0d4d482$var$ButtonGroup;

});
parcelRegister("d8s3C", function(module, exports) {

$parcel$export(module.exports, "getButtonGroupUtilityClass", () => $9901c9510940cf3a$export$b85c003f960b1f3a);
$parcel$export(module.exports, "default", () => $9901c9510940cf3a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9901c9510940cf3a$export$b85c003f960b1f3a(slot) {
    return (0, $4Cod0.default)('MuiButtonGroup', slot);
}
const $9901c9510940cf3a$var$buttonGroupClasses = (0, $beCSm.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $9901c9510940cf3a$export$2e2bcd8739ae039 = $9901c9510940cf3a$var$buttonGroupClasses;

});




parcelRegister("ceJla", function(module, exports) {

$parcel$export(module.exports, "useRampEditorState", () => $c3f797e949353d66$export$ab51105a484a9a2e);
$parcel$export(module.exports, "useLocalRampState", () => $c3f797e949353d66$export$44fa60f2534c8771);
$parcel$export(module.exports, "useCalibrationState", () => $c3f797e949353d66$export$bbf2ec4fb52497a1);
$parcel$export(module.exports, "RampEditorPresenter", () => $c3f797e949353d66$export$16a77ff22275e5f8);

var $ayMG0 = parcelRequire("ayMG0");

var $1YLXO = parcelRequire("1YLXO");

var $03mUs = parcelRequire("03mUs");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $f4OIt = parcelRequire("f4OIt");

var $1KiAb = parcelRequire("1KiAb");

var $6fDLr = parcelRequire("6fDLr");

var $fC0pb = parcelRequire("fC0pb");

var $67btB = parcelRequire("67btB");

var $8tVFU = parcelRequire("8tVFU");

var $kwTeI = parcelRequire("kwTeI");
const $c3f797e949353d66$export$ab51105a484a9a2e = (0, $f4OIt.create)((set)=>({
        showReferenceImage: true,
        setShowReferenceImage: (showReferenceImage)=>set({
                showReferenceImage: showReferenceImage
            }),
        showMeasurements: true,
        setShowMeasurements: (showMeasurements)=>set({
                showMeasurements: showMeasurements
            }),
        showGuideLines: true,
        setShowGuideLines: (showGuideLines)=>set({
                showGuideLines: showGuideLines
            }),
        showCalibrationPoints: true,
        setShowCalibrationPoints: (showCalibrationPoints)=>set({
                showCalibrationPoints: showCalibrationPoints
            }),
        highlightedCalibrationPoint: null,
        setHighlightedCalibrationPoint: (highlightedCalibrationPoint)=>set({
                highlightedCalibrationPoint: highlightedCalibrationPoint
            }),
        useV2: false,
        setUseV2: (useV2)=>set({
                useV2: useV2
            })
    }));
const $c3f797e949353d66$export$44fa60f2534c8771 = (0, $f4OIt.create)((set, get)=>({
        ramp: undefined,
        setRamp: (rampOrUpdater)=>{
            if (typeof rampOrUpdater === "function") set((state)=>{
                if (!state.ramp) {
                    console.error("[useLocalRampState] Cannot use functional update when ramp is undefined");
                    return state;
                }
                return {
                    ramp: rampOrUpdater(state.ramp)
                };
            });
            else set({
                ramp: rampOrUpdater
            });
        },
        //
        activeShapes: [],
        setActiveShapes: (activeShapes)=>set({
                activeShapes: activeShapes
            }),
        getActiveShapes () {
            return get().ramp.shapes.filter((s)=>get().activeShapes.includes(s.id));
        },
        //
        highlightedShapes: [],
        setHighlightedShapes: (highlightedShapes)=>set({
                highlightedShapes: highlightedShapes
            }),
        //
        reset: ()=>set({
                ramp: undefined,
                activeShapes: [],
                highlightedShapes: []
            })
    }));
const $c3f797e949353d66$export$8b3618924a1cdac2 = (0, $f4OIt.create)((set)=>({
        selectedTool: "Select",
        setSelectedTool: (selectedTool)=>set({
                selectedTool: selectedTool
            })
    }));
const $c3f797e949353d66$export$bbf2ec4fb52497a1 = (0, $f4OIt.create)((set)=>({
        isAddingCalibrationPoint: false,
        setIsAddingCalibrationPoint: (isAddingCalibrationPoint)=>set({
                isAddingCalibrationPoint: isAddingCalibrationPoint
            })
    }));
const $c3f797e949353d66$export$16a77ff22275e5f8 = ({ onClose: onClose })=>{
    const navigate = (0, $aphAM.useNavigate)();
    const { ramp: ramp, setRamp: setRamp } = (0, $1KiAb.useRampState)();
    const { setRamp: setLocalRamp, ramp: localRamp } = $c3f797e949353d66$export$44fa60f2534c8771();
    const { selectedTool: selectedTool, setSelectedTool: setSelectedTool } = $c3f797e949353d66$export$8b3618924a1cdac2();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { preferences: preferences, setPreferences: setPreferences } = (0, $fC0pb.useUserPreferences)();
    const { showGuideLines: showGuideLines } = $c3f797e949353d66$export$ab51105a484a9a2e();
    const hasLoadedInitialPreferences = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Only set local ramp if we have a valid ramp from the container
        if (ramp && ramp.id) setLocalRamp(ramp);
    }, [
        ramp
    ]);
    // Load initial preference once
    $acw62.useEffect(()=>{
        if (!hasLoadedInitialPreferences.current && preferences.showGuideLines !== undefined) {
            $c3f797e949353d66$export$ab51105a484a9a2e.getState().setShowGuideLines(preferences.showGuideLines);
            hasLoadedInitialPreferences.current = true;
        }
    }, [
        preferences.showGuideLines
    ]);
    // Save preference when it changes (but not on initial load)
    $acw62.useEffect(()=>{
        if (hasLoadedInitialPreferences.current) setPreferences((currentPreferences)=>({
                ...currentPreferences,
                showGuideLines: showGuideLines
            }));
    }, [
        showGuideLines,
        setPreferences
    ]);
    // Auto-calculate egress whenever shapes change (debounced)
    (0, $kwTeI.useAutoEgress)();
    const onClickSaveRamp = ()=>{
        setRamp(localRamp);
        // setRamps(ramps.map((r) => (r.id === localRamp.id ? localRamp : r)));
        snackbar.notify({
            text: "Ramp changes saved.",
            severity: "success"
        });
    };
    /**
   * make a ramp
   * give it a name
   * upload an image
   * make a reference line to tell us how many pixels = how many feet
   * add an outline
   * add other markings
   */ if (!localRamp) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        spacing: 8,
        alignItems: "flex-start",
        width: "100%",
        height: "100%",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    p: 1,
                    width: 280,
                    // position: "sticky", // Makes the Box sticky
                    // top: 0, // Stick to the top of the parent container
                    alignSelf: "flex-start",
                    // Align properly within the parent
                    maxHeight: "100%",
                    overflowY: "auto"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>navigate(`/settings?tab=Ramps`),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YLXO))), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    children: "Edit Ramp"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8tVFU.RampEditorForm), {
                        ramp: localRamp,
                        setRamp: setLocalRamp,
                        onClickSaveRamp: onClickSaveRamp,
                        onClose: onClose,
                        selectedTool: selectedTool,
                        setSelectedTool: setSelectedTool
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                width: "100%",
                sx: {
                    overflowY: "auto",
                    // Allow vertical scrolling for this section
                    maxHeight: "100vh" // Limit height to viewport for scrollable content
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67btB.RampCanvas), {
                    ramp: localRamp,
                    setRamp: setLocalRamp,
                    selectedTool: selectedTool,
                    setSelectedTool: setSelectedTool
                })
            })
        ]
    });
};

});
parcelRegister("8tVFU", function(module, exports) {

$parcel$export(module.exports, "RampEditorForm", () => $0085912b295a5400$export$5d7781dc1b2ffaff);

var $ayMG0 = parcelRequire("ayMG0");

var $1MdOk = parcelRequire("1MdOk");

var $e70ED = parcelRequire("e70ED");

var $hbZ6O = parcelRequire("hbZ6O");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $bnA1h = parcelRequire("bnA1h");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");

var $kzQHY = parcelRequire("kzQHY");

var $2gI2i = parcelRequire("2gI2i");

var $bpwzj = parcelRequire("bpwzj");
const $0085912b295a5400$export$5d7781dc1b2ffaff = ({ ramp: ramp, setRamp: setRamp, onClickSaveRamp: onClickSaveRamp, onClose: onClose, selectedTool: selectedTool, setSelectedTool: setSelectedTool })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [confirmSave, setConfirmSave] = $acw62.useState(null);
    // Ramp details collapse state with localStorage persistence
    const [rampDetailsExpanded, setRampDetailsExpanded] = $acw62.useState(()=>{
        const saved = localStorage.getItem("ramp-editor-ramp-details-expanded");
        return saved !== null ? JSON.parse(saved) : true;
    });
    // Save ramp details expanded state to localStorage
    $acw62.useEffect(()=>{
        localStorage.setItem("ramp-editor-ramp-details-expanded", JSON.stringify(rampDetailsExpanded));
    }, [
        rampDetailsExpanded
    ]);
    const handleClose = ()=>{
        onClose();
    };
    const boundingBox = (0, $bpwzj.calculateRampBoundingBox)(ramp);
    const unit = activeFBO?.settings?.useMetricSystem ? "m" : "ft";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 0.5,
        sx: {
            p: 1,
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "action.hover"
                    },
                    borderRadius: 1,
                    px: 0.5,
                    py: 0.25
                },
                onClick: ()=>setRampDetailsExpanded(!rampDetailsExpanded),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        children: ramp?.name || "Edit Ramp"
                    }),
                    rampDetailsExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e70ED))), {
                        fontSize: "small"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {
                        fontSize: "small"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnA1h.default), {
                in: rampDetailsExpanded,
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            fullWidth: true,
                            size: "small",
                            label: "Ramp Name",
                            onChange: (evt)=>{
                                setRamp((currentRamp)=>({
                                        ...currentRamp,
                                        name: evt.target.value
                                    }));
                            },
                            value: ramp?.name ?? ""
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                    type: "number",
                                    fullWidth: true,
                                    disabled: true,
                                    InputProps: {
                                        inputProps: {
                                            min: 1,
                                            max: 10000
                                        }
                                    },
                                    size: "small",
                                    label: `Width (${unit})`,
                                    onChange: (value)=>{
                                        setRamp((currentRamp)=>({
                                                ...currentRamp,
                                                width: value
                                            }));
                                    },
                                    value: (0, $cLNZr.round)(ramp?.width, 0)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                    type: "number",
                                    disabled: true,
                                    fullWidth: true,
                                    InputProps: {
                                        inputProps: {
                                            min: 1,
                                            max: 10000
                                        }
                                    },
                                    size: "small",
                                    label: `Depth (${unit})`,
                                    onChange: (value)=>{
                                        setRamp((currentRamp)=>({
                                                ...currentRamp,
                                                depth: value
                                            }));
                                    },
                                    value: (0, $cLNZr.round)(ramp?.depth, 0)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    children: "Bounding Box Coordinates"
                                }),
                                boundingBox ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    spacing: 0.25,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        minWidth: 80,
                                                        fontWeight: "medium",
                                                        fontSize: "0.7rem",
                                                        whiteSpace: "nowrap"
                                                    },
                                                    children: "Top-Left:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        fontFamily: "monospace",
                                                        backgroundColor: "grey.100",
                                                        px: 0.5,
                                                        py: 0.25,
                                                        borderRadius: 0.5,
                                                        fontSize: "0.7rem"
                                                    },
                                                    children: [
                                                        boundingBox.topLeft[0],
                                                        ", ",
                                                        boundingBox.topLeft[1]
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        minWidth: 80,
                                                        fontWeight: "medium",
                                                        fontSize: "0.7rem",
                                                        whiteSpace: "nowrap"
                                                    },
                                                    children: "Top-Right:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        fontFamily: "monospace",
                                                        backgroundColor: "grey.100",
                                                        px: 0.5,
                                                        py: 0.25,
                                                        borderRadius: 0.5,
                                                        fontSize: "0.7rem"
                                                    },
                                                    children: [
                                                        boundingBox.topRight[0],
                                                        ", ",
                                                        boundingBox.topRight[1]
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        minWidth: 80,
                                                        fontWeight: "medium",
                                                        fontSize: "0.7rem",
                                                        whiteSpace: "nowrap"
                                                    },
                                                    children: "Bottom-Left:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        fontFamily: "monospace",
                                                        backgroundColor: "grey.100",
                                                        px: 0.5,
                                                        py: 0.25,
                                                        borderRadius: 0.5,
                                                        fontSize: "0.7rem"
                                                    },
                                                    children: [
                                                        boundingBox.bottomLeft[0],
                                                        ", ",
                                                        boundingBox.bottomLeft[1]
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        minWidth: 80,
                                                        fontWeight: "medium",
                                                        fontSize: "0.7rem",
                                                        whiteSpace: "nowrap"
                                                    },
                                                    children: "Bottom-Right:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        fontFamily: "monospace",
                                                        backgroundColor: "grey.100",
                                                        px: 0.5,
                                                        py: 0.25,
                                                        borderRadius: 0.5,
                                                        fontSize: "0.7rem"
                                                    },
                                                    children: [
                                                        boundingBox.bottomRight[0],
                                                        ", ",
                                                        boundingBox.bottomRight[1]
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: "Need at least 2 calibration points to calculate bounding box"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                children: ramp?.markings?.map((marking, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        onMouseEnter: ()=>{
                            setRamp((currentRamp)=>({
                                    ...currentRamp,
                                    markings: currentRamp.markings.map((m)=>({
                                            ...m,
                                            selected: m.id === marking.id
                                        }))
                                }));
                        },
                        onMouseLeave: ()=>{
                            setRamp((currentRamp)=>({
                                    ...currentRamp,
                                    markings: currentRamp.markings.map((m)=>({
                                            ...m,
                                            selected: false
                                        }))
                                }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                children: marking.type
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                onClick: ()=>{
                                    setRamp((currentRamp)=>({
                                            ...currentRamp,
                                            markings: currentRamp.markings.filter((m, i)=>i !== idx)
                                        }));
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {})
                            })
                        ]
                    }, `marking-${idx}`))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gI2i.Toolbar), {
                selectedTool: selectedTool,
                setSelectedTool: setSelectedTool
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        fullWidth: true,
                        size: "small",
                        variant: "contained",
                        color: "inherit",
                        onClick: handleClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        fullWidth: true,
                        size: "small",
                        variant: "contained",
                        color: "success",
                        onClick: ()=>{
                            setConfirmSave({
                                title: "Save Changes?",
                                text: "Are you sure you want to save these changes?",
                                onCancel: ()=>setConfirmSave(null),
                                onClose: ()=>setConfirmSave(null),
                                okText: "Save",
                                onOk: ()=>{
                                    onClickSaveRamp();
                                    setConfirmSave(null);
                                }
                            });
                        },
                        children: "Save"
                    })
                ]
            }),
            Boolean(confirmSave) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                ...confirmSave
            })
        ]
    });
};

});
parcelRegister("2gI2i", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $70509b508cb01b10$export$4c260019440d418f);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $hFfv7 = parcelRequire("hFfv7");

var $7fruN = parcelRequire("7fruN");

var $lG3ek = parcelRequire("lG3ek");

var $e70ED = parcelRequire("e70ED");

var $hbZ6O = parcelRequire("hbZ6O");

var $bOiZ6 = parcelRequire("bOiZ6");

var $lsdhg = parcelRequire("lsdhg");

var $67oTk = parcelRequire("67oTk");

var $4WTQ1 = parcelRequire("4WTQ1");

var $l5Oj5 = parcelRequire("l5Oj5");

var $9dUJu = parcelRequire("9dUJu");

var $1oB2K = parcelRequire("1oB2K");

var $j8sxO = parcelRequire("j8sxO");

var $2g1w6 = parcelRequire("2g1w6");

var $2jjgy = parcelRequire("2jjgy");

var $9HeVX = parcelRequire("9HeVX");

var $hmGhT = parcelRequire("hmGhT");

var $3M2I5 = parcelRequire("3M2I5");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $bnA1h = parcelRequire("bnA1h");
var $lkxXU = parcelRequire("lkxXU");
var $2esSG = parcelRequire("2esSG");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $7FzhI = parcelRequire("7FzhI");

var $5Bqq3 = parcelRequire("5Bqq3");

var $lNEp2 = parcelRequire("lNEp2");

var $apzof = parcelRequire("apzof");
parcelRequire("79mJW");
var $c9nMz = parcelRequire("c9nMz");

var $5iWzk = parcelRequire("5iWzk");

var $lq8o1 = parcelRequire("lq8o1");

var $6fDLr = parcelRequire("6fDLr");

var $YOQGa = parcelRequire("YOQGa");

var $bqlkg = parcelRequire("bqlkg");

var $d7yp1 = parcelRequire("d7yp1");

var $kLvAj = parcelRequire("kLvAj");

var $67btB = parcelRequire("67btB");

var $5nYIu = parcelRequire("5nYIu");

var $ceJla = parcelRequire("ceJla");

var $7pqnS = parcelRequire("7pqnS");
const $70509b508cb01b10$export$4c260019440d418f = ({ selectedTool: selectedTool, setSelectedTool: setSelectedTool })=>{
    const { showReferenceImage: showReferenceImage, setShowReferenceImage: setShowReferenceImage, showMeasurements: showMeasurements, setShowMeasurements: setShowMeasurements, showGuideLines: showGuideLines, setShowGuideLines: setShowGuideLines, showCalibrationPoints: showCalibrationPoints, setShowCalibrationPoints: setShowCalibrationPoints, setHighlightedCalibrationPoint: setHighlightedCalibrationPoint } = (0, $ceJla.useRampEditorState)();
    const { ramp: ramp, setRamp: setRamp, setActiveShapes: setActiveShapes } = (0, $ceJla.useLocalRampState)();
    const { isAddingCalibrationPoint: isAddingCalibrationPoint, setIsAddingCalibrationPoint: setIsAddingCalibrationPoint } = (0, $ceJla.useCalibrationState)();
    const { hangars: hangars } = (0, $7FzhI.useHangarsState)();
    const measuringToolState = (0, $5Bqq3.useMeasuringToolState)();
    const [activeTab, setActiveTab] = $acw62.useState("Tools");
    const [calibrationDialog, setCalibrationDialog] = $acw62.useState({
        open: false
    });
    const [gisImportDialogOpen, setGisImportDialogOpen] = $acw62.useState(false);
    const [egressDialogOpen, setEgressDialogOpen] = $acw62.useState(false);
    const [egressResult, setEgressResult] = $acw62.useState(null);
    // Image upload hook
    const { handleUpload: handleImageUpload, isUploading: isUploadingImage } = (0, $lq8o1.useImageUpload)(ramp, setRamp);
    // Snackbar for notifications
    const snackbar = (0, $6fDLr.useSnackbar)();
    // Loading state for compress button
    const [isCompressing, setIsCompressing] = $acw62.useState(false);
    // Compress existing image by calling backend directly
    const handleCompressImage = async ()=>{
        if (!ramp.reference_image || isUploadingImage || isCompressing) return;
        setIsCompressing(true);
        try {
            // Convert Base64 data URI to Blob
            const response = await fetch(ramp.reference_image);
            const blob = await response.blob();
            const file = new File([
                blob
            ], "image.png", {
                type: blob.type
            });
            // Call compression service
            const result = await (0, $YOQGa.compressImageServerSide)(file);
            // Update ramp with compressed image
            setRamp({
                ...ramp,
                reference_image: result.data
            });
            // Calculate KB saved for display
            const savedKilobytes = ((result.originalSize - result.compressedSize) / 1024).toFixed(0);
            // Show success notification with savings
            snackbar.notify({
                text: `Saved ${savedKilobytes}KB (${result.savings}%)`,
                severity: "success",
                duration: 4000
            });
        } catch (error) {
            console.error("Failed to compress image:", error);
            snackbar.notify({
                text: "Failed to compress image. See console for details.",
                severity: "error"
            });
        } finally{
            setIsCompressing(false);
        }
    };
    // Options panel collapse state with localStorage persistence
    const [optionsExpanded, setOptionsExpanded] = $acw62.useState(()=>{
        const saved = localStorage.getItem("ramp-editor-options-expanded");
        return saved !== null ? JSON.parse(saved) : true;
    });
    // Calibration Points panel collapse state with localStorage persistence
    const [calibrationPointsExpanded, setCalibrationPointsExpanded] = $acw62.useState(()=>{
        const saved = localStorage.getItem("ramp-editor-calibration-points-expanded");
        return saved !== null ? JSON.parse(saved) : true;
    });
    // Save options expanded state to localStorage
    $acw62.useEffect(()=>{
        localStorage.setItem("ramp-editor-options-expanded", JSON.stringify(optionsExpanded));
    }, [
        optionsExpanded
    ]);
    // Save calibration points expanded state to localStorage
    $acw62.useEffect(()=>{
        localStorage.setItem("ramp-editor-calibration-points-expanded", JSON.stringify(calibrationPointsExpanded));
    }, [
        calibrationPointsExpanded
    ]);
    const setShapes = $acw62.useCallback((shapesOrUpdater)=>{
        setRamp((currentRamp)=>{
            if (!currentRamp) return currentRamp;
            return {
                ...currentRamp,
                shapes: typeof shapesOrUpdater === "function" ? shapesOrUpdater(currentRamp.shapes || []) : shapesOrUpdater
            };
        });
    }, [
        setRamp
    ]);
    const handleAddCalibrationPoint = (x, y)=>{
        setCalibrationDialog({
            open: true,
            x: x,
            y: y
        });
    };
    const handleSaveCalibrationPoint = (point)=>{
        const existingIndex = ramp.calibration_points?.findIndex((p)=>p.id === point.id);
        let updatedPoints = ramp.calibration_points || [];
        if (existingIndex !== undefined && existingIndex >= 0) updatedPoints[existingIndex] = point;
        else updatedPoints = [
            ...updatedPoints,
            point
        ];
        setRamp({
            ...ramp,
            calibration_points: updatedPoints
        });
    };
    const handleDeleteCalibrationPoint = (pointId)=>{
        setRamp({
            ...ramp,
            calibration_points: ramp.calibration_points?.filter((p)=>p.id !== pointId) || []
        });
    };
    const handleImportGISShapes = (newShapes)=>{
        setRamp((currentRamp)=>({
                ...currentRamp,
                shapes: [
                    ...currentRamp.shapes,
                    ...newShapes
                ]
            }));
        setGisImportDialogOpen(false);
    };
    // Guard to ensure ramp is properly loaded
    const isRampValid = ()=>{
        if (!ramp || !ramp.id || !ramp.fbo_id) {
            console.error("Ramp not properly loaded - cannot create shape");
            return false;
        }
        return true;
    };
    // Expose the add calibration point function globally for use by canvas
    $acw62.useEffect(()=>{
        if (isAddingCalibrationPoint) window.addCalibrationPoint = handleAddCalibrationPoint;
        else delete window.addCalibrationPoint;
    }, [
        isAddingCalibrationPoint
    ]);
    const startingPoint = {
        x: (ramp?.width ?? 0) / 2,
        y: (ramp?.depth ?? 0) / 2
    };
    const DEFAULT_SPOT_COLOR = "#FFFFFF";
    const createSpotShape = (size)=>{
        if (!isRampValid()) return;
        setActiveShapes([]);
        // Get label and size category for this spot
        const sizeOption = (0, $67btB.SIZE_CATEGORY_OPTIONS).find((opt)=>opt.maxFeet === size);
        const sizeCategory = (0, $67btB.getDefaultSizeCategory)(size);
        setShapes([
            {
                id: (0, $lNEp2.uuidv4)(),
                fbo_id: ramp.fbo_id,
                ramp_id: ramp.id,
                tags: [
                    "spot"
                ],
                type: "Spot",
                locked: false,
                points: [
                    {
                        x: startingPoint.x - size / 2,
                        y: startingPoint.y - size / 2
                    },
                    {
                        x: startingPoint.x + size / 2,
                        y: startingPoint.y - size / 2
                    },
                    {
                        x: startingPoint.x + size / 2,
                        y: startingPoint.y + size / 2
                    },
                    {
                        x: startingPoint.x - size / 2,
                        y: startingPoint.y + size / 2
                    }
                ],
                stroke_style: DEFAULT_SPOT_COLOR,
                line_style: "dashed",
                line_width: 3,
                fill_style: null,
                font_size: 14,
                reference_image_height: null,
                text: sizeOption?.label || size.toString(),
                reference_points: [
                    {
                        name: "north",
                        validOrientations: [
                            "nose_to_line",
                            "tail_to_line"
                        ]
                    }
                ],
                metadata: {
                    allowedSizes: [
                        sizeCategory
                    ],
                    egressLanes: []
                }
            },
            ...ramp.shapes
        ]);
        setSelectedTool("Select");
        measuringToolState.setActive(false);
    };
    const tools = [
        {
            name: "Select",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oB2K))), {}),
            onClick: ()=>{
                setActiveShapes([]);
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Area",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmGhT))), {}),
            shortcut: "A",
            onClick: ()=>{
                setActiveShapes([]);
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Zone",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($67oTk))), {}),
            onClick: ()=>{
                setActiveShapes([]);
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Line",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4WTQ1))), {}),
            shortcut: "L",
            onClick: ()=>{
                setActiveShapes([]);
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Tie Down T",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3M2I5))), {}),
            shortcut: "Tie Down T",
            onClick: ()=>{
                if (!isRampValid()) return;
                setActiveShapes([]);
                setShapes([
                    {
                        id: (0, $lNEp2.uuidv4)(),
                        fbo_id: ramp.fbo_id,
                        ramp_id: ramp.id,
                        tags: [],
                        type: "Tie Down T",
                        locked: false,
                        points: [
                            {
                                x: 0 + startingPoint.x - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 100
                            },
                            {
                                x: 0 + startingPoint.x - 50,
                                y: startingPoint.y + 100
                            }
                        ],
                        stroke_style: "black"
                    },
                    ...ramp.shapes
                ]);
                setSelectedTool("Select");
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Double T",
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    position: "relative",
                    width: 20,
                    // Adjust size as needed
                    height: 20
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3M2I5))), {
                        sx: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            fontSize: 20,
                            color: "black"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3M2I5))), {
                        sx: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            fontSize: 20,
                            color: "black",
                            // Different color for distinction
                            transform: "rotate(180deg)"
                        }
                    })
                ]
            }),
            shortcut: "Double T",
            onClick: ()=>{
                if (!isRampValid()) return;
                setActiveShapes([]);
                setShapes([
                    {
                        id: (0, $lNEp2.uuidv4)(),
                        fbo_id: ramp.fbo_id,
                        ramp_id: ramp.id,
                        tags: [],
                        type: "Double T",
                        locked: false,
                        points: [
                            {
                                x: 0 + startingPoint.x - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 100
                            },
                            {
                                x: 0 + startingPoint.x - 50,
                                y: startingPoint.y + 100
                            }
                        ],
                        stroke_style: "black"
                    },
                    ...ramp.shapes
                ]);
                setSelectedTool("Select");
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Circle",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j8sxO))), {}),
            onClick: ()=>{
                if (!isRampValid()) return;
                setActiveShapes([]);
                setShapes([
                    {
                        id: (0, $lNEp2.uuidv4)(),
                        fbo_id: ramp.fbo_id,
                        ramp_id: ramp.id,
                        tags: [],
                        type: "Circle",
                        locked: false,
                        points: [
                            {
                                x: startingPoint.x + 0 - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 100
                            },
                            {
                                x: startingPoint.x + 0 - 50,
                                y: startingPoint.y + 100
                            }
                        ],
                        stroke_style: "black",
                        line_style: "solid",
                        line_width: 3,
                        fill_style: null,
                        font_size: null,
                        reference_image_height: null,
                        text: null
                    },
                    ...ramp.shapes
                ]);
                setSelectedTool("Select");
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Helipad",
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 24,
                    // Adjust size as needed
                    height: 24
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j8sxO))), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        sx: {
                            position: "absolute",
                            color: "black",
                            fontWeight: "bold"
                        },
                        children: "H"
                    })
                ]
            }),
            onClick: ()=>{
                if (!isRampValid()) return;
                setActiveShapes([]);
                setShapes([
                    {
                        id: (0, $lNEp2.uuidv4)(),
                        fbo_id: ramp.fbo_id,
                        ramp_id: ramp.id,
                        tags: [],
                        type: "Helipad",
                        locked: false,
                        points: [
                            {
                                x: startingPoint.x + 0 - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 100
                            },
                            {
                                x: startingPoint.x + 0 - 50,
                                y: startingPoint.y + 100
                            }
                        ],
                        stroke_style: "#f9de55",
                        line_style: "solid",
                        line_width: 3,
                        fill_style: null,
                        font_size: 50,
                        reference_image_height: null,
                        text: "H"
                    },
                    ...ramp.shapes
                ]);
                setSelectedTool("Select");
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Spot",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5Oj5))), {}),
            onClick: ()=>{
            // This is a placeholder - actual rendering uses SplitButton
            }
        },
        {
            name: "Text",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9HeVX))), {}),
            onClick: ()=>{
                setActiveShapes([]);
                console.log("Text");
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Measuring",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2jjgy))), {}),
            onClick: ()=>{
                setActiveShapes([]);
                measuringToolState.setActive(true);
            }
        },
        {
            name: "Compass Rose",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dUJu))), {}),
            onClick: ()=>{
                if (!isRampValid()) return;
                setActiveShapes([]);
                // if there is already a compass rose, don't add another one
                if (ramp.shapes.find((s)=>s.type === "Compass Rose")) {
                    console.log("Already a compass rose in this ramp");
                    return;
                }
                setShapes([
                    {
                        id: (0, $lNEp2.uuidv4)(),
                        fbo_id: ramp.fbo_id,
                        ramp_id: ramp.id,
                        tags: [],
                        type: "Compass Rose",
                        locked: false,
                        points: [
                            {
                                x: 0 + startingPoint.x - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 0
                            },
                            {
                                x: startingPoint.x + 100 - 50,
                                y: startingPoint.y + 100
                            },
                            {
                                x: 0 + startingPoint.x - 50,
                                y: startingPoint.y + 100
                            }
                        ],
                        stroke_style: "#000000"
                    },
                    ...ramp.shapes
                ]);
                setSelectedTool("Select");
                measuringToolState.setActive(false);
            }
        }
    ];
    const bulkTools = [
        {
            name: "Import GIS Shapes",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $apzof.RampIcon), {}),
            onClick: ()=>{
                setGisImportDialogOpen(true);
                setActiveShapes([]);
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Calculate Egress",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2g1w6))), {}),
            onClick: ()=>{
                if (!isRampValid()) return;
                const result = (0, $5nYIu.calculateBlockedSpots)(ramp.shapes);
                setEgressResult(result);
                setShapes(result.shapes);
                setEgressDialogOpen(true);
                setActiveShapes([]);
                measuringToolState.setActive(false);
            }
        },
        {
            name: "Auto-Name Spots",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lsdhg))), {}),
            onClick: ()=>{
                if (!isRampValid()) return;
                const updatedShapes = (0, $5nYIu.calculateSpotNames)(ramp.shapes);
                setShapes(updatedShapes);
                setActiveShapes([]);
                measuringToolState.setActive(false);
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        alignItems: "flex-start",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "action.hover"
                    },
                    borderRadius: 1,
                    px: 0.5,
                    py: 0.25
                },
                onClick: ()=>setOptionsExpanded(!optionsExpanded),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        children: "Options"
                    }),
                    optionsExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e70ED))), {
                        fontSize: "small"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {
                        fontSize: "small"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnA1h.default), {
                in: optionsExpanded,
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    alignItems: "flex-start",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                        size: "small",
                                        color: "primary",
                                        checked: showReferenceImage,
                                        onChange: ()=>{
                                            setShowReferenceImage(!showReferenceImage);
                                        }
                                    }),
                                    label: "Image",
                                    labelPlacement: "start"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Download ramp image",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        onClick: ()=>{
                                            // download the image (ramp.reference_image)
                                            const a = document.createElement("a");
                                            a.href = ramp.reference_image;
                                            a.download = `image-${ramp.name}.png`;
                                            a.click();
                                        },
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fruN))), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Upload new ramp image",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        component: "span",
                                        sx: {
                                            display: "inline-flex"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9Lykx.default), {
                                            size: "small",
                                            component: "label",
                                            disabled: isUploadingImage,
                                            sx: {
                                                p: 0
                                            },
                                            children: [
                                                isUploadingImage ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                                    size: 20
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lG3ek))), {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "file",
                                                    hidden: true,
                                                    accept: "image/*",
                                                    onChange: handleImageUpload
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Compress existing image",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        component: "span",
                                        sx: {
                                            display: "inline-flex"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                            size: "small",
                                            onClick: handleCompressImage,
                                            disabled: isUploadingImage || isCompressing || !ramp.reference_image,
                                            sx: {
                                                p: 0
                                            },
                                            children: isCompressing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                                size: 20
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hFfv7))), {})
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                size: "small",
                                color: "primary",
                                checked: showMeasurements,
                                onChange: ()=>setShowMeasurements(!showMeasurements)
                            }),
                            label: "Measurements",
                            labelPlacement: "start"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                size: "small",
                                color: "primary",
                                checked: ramp?.version === "v2",
                                onChange: ()=>setRamp({
                                        ...ramp,
                                        version: ramp?.version === "v2" ? "v1" : "v2"
                                    })
                            }),
                            label: "Ramp v2.0",
                            labelPlacement: "start"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                size: "small",
                                color: "primary",
                                checked: ramp?.autoparking_enabled ?? false,
                                onChange: ()=>setRamp({
                                        ...ramp,
                                        autoparking_enabled: !ramp?.autoparking_enabled
                                    })
                            }),
                            label: "AutoParking",
                            labelPlacement: "start"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                size: "small",
                                color: "primary",
                                checked: showGuideLines,
                                onChange: ()=>setShowGuideLines(!showGuideLines)
                            }),
                            label: "Guide Lines",
                            labelPlacement: "start"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "action.hover"
                    },
                    borderRadius: 1,
                    px: 0.5,
                    py: 0.25
                },
                onClick: ()=>setCalibrationPointsExpanded(!calibrationPointsExpanded),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        children: "Calibration Points"
                    }),
                    calibrationPointsExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e70ED))), {
                        fontSize: "small"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {
                        fontSize: "small"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnA1h.default), {
                in: calibrationPointsExpanded,
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 1,
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                size: "small",
                                color: "primary",
                                checked: showCalibrationPoints,
                                onChange: ()=>setShowCalibrationPoints(!showCalibrationPoints)
                            }),
                            label: "Show points",
                            labelPlacement: "start",
                            sx: {
                                "& .MuiFormControlLabel-label": {
                                    fontSize: "0.875rem"
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            size: "small",
                            variant: isAddingCalibrationPoint ? "contained" : "outlined",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bOiZ6))), {}),
                            onClick: ()=>{
                                setIsAddingCalibrationPoint(!isAddingCalibrationPoint);
                                setSelectedTool(isAddingCalibrationPoint ? "Select" : "CalibrationPoint");
                            },
                            color: isAddingCalibrationPoint ? "primary" : "inherit",
                            children: isAddingCalibrationPoint ? "Finished Adding" : "Add Point"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bqlkg.CalibrationPointsList), {
                            calibrationPoints: ramp.calibration_points || [],
                            onEdit: (point)=>setCalibrationDialog({
                                    open: true,
                                    point: point
                                }),
                            onDelete: handleDeleteCalibrationPoint,
                            onHighlight: setHighlightedCalibrationPoint
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                value: activeTab,
                onChange: (_, newValue)=>setActiveTab(newValue),
                variant: "scrollable",
                scrollButtons: "auto",
                sx: {
                    width: "100%",
                    minHeight: "auto",
                    "& .MuiTabs-indicator": {
                        height: 2
                    },
                    "& .MuiTab-root": {
                        minHeight: 32,
                        minWidth: 0,
                        padding: "6px 8px",
                        fontSize: "0.75rem",
                        textTransform: "none",
                        flex: 1
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        label: "Tools",
                        value: "Tools"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        label: "Shapes",
                        value: "Shapes"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        label: "Hangars",
                        value: "Hangars"
                    })
                ]
            }),
            activeTab === "Tools" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                alignItems: "flex-start",
                spacing: 1,
                width: "100%",
                children: [
                    tools.map((tool)=>{
                        if (tool.name === "Spot") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9nMz.SplitButton), {
                            startIcon: tool.icon,
                            variant: "text",
                            color: selectedTool === tool.name ? "primary" : "inherit",
                            size: "medium",
                            defaultSelectedIndex: 3,
                            options: [
                                {
                                    label: "Very Small (x40ft)",
                                    onClick: ()=>{
                                        createSpotShape(40);
                                    }
                                },
                                {
                                    label: "Small (x60ft)",
                                    onClick: ()=>{
                                        createSpotShape(60);
                                    }
                                },
                                {
                                    label: "Midsize (x80ft)",
                                    onClick: ()=>{
                                        createSpotShape(80);
                                    }
                                },
                                {
                                    label: "S-Mid (x100ft)",
                                    onClick: ()=>{
                                        createSpotShape(100);
                                    }
                                },
                                {
                                    label: "Large (x120ft)",
                                    onClick: ()=>{
                                        createSpotShape(120);
                                    }
                                }
                            ]
                        }, `tool-button-${tool.name}`);
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            startIcon: tool.icon,
                            variant: selectedTool === tool.name ? "contained" : "text",
                            onClick: ()=>{
                                setSelectedTool(tool.name);
                                tool.onClick();
                            },
                            children: tool.name
                        }, `tool-button-${tool.name}`);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        flexItem: true,
                        sx: {
                            my: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        sx: {
                            pl: 1,
                            color: "text.secondary"
                        },
                        children: "Bulk Operations"
                    }),
                    bulkTools.map((tool)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            startIcon: tool.icon,
                            variant: "text",
                            onClick: tool.onClick,
                            sx: {
                                justifyContent: "flex-start"
                            },
                            children: tool.name
                        }, `bulk-tool-button-${tool.name}`))
                ]
            }),
            activeTab === "Shapes" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pqnS.ShapeElements), {
                shapes: ramp?.shapes || [],
                setShapes: setShapes,
                tools: tools
            }),
            activeTab === "Hangars" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                alignItems: "flex-start",
                width: "100%",
                children: [
                    hangars.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        align: "center",
                        children: "No hangars available"
                    }),
                    hangars.map((hangar)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "text",
                            disabled: Boolean(ramp.shapes.find((s)=>s.hangar_id === hangar.id)),
                            onClick: ()=>{
                                if (!isRampValid()) return;
                                console.log(`${hangar.width} ft x ${hangar.depth} ft`);
                                setShapes([
                                    {
                                        id: (0, $lNEp2.uuidv4)(),
                                        fbo_id: ramp.fbo_id,
                                        ramp_id: ramp.id,
                                        hangar_id: hangar.id,
                                        tags: [
                                            "hangar"
                                        ],
                                        type: "Area",
                                        locked: false,
                                        line_style: "solid",
                                        line_width: 3,
                                        fill_style: "#c8cfde50",
                                        stroke_style: "#3e5d8c",
                                        text: hangar.name,
                                        font_size: 12,
                                        reference_image_height: null,
                                        points: [
                                            {
                                                x: startingPoint.x + 0 - hangar.width / 2,
                                                y: startingPoint.y + 0
                                            },
                                            {
                                                x: startingPoint.x + hangar.width - hangar.width / 2,
                                                y: startingPoint.y + 0
                                            },
                                            {
                                                x: startingPoint.x + hangar.width - hangar.width / 2,
                                                y: startingPoint.y + hangar.depth
                                            },
                                            {
                                                x: startingPoint.x + 0 - hangar.width / 2,
                                                y: startingPoint.y + hangar.depth
                                            }
                                        ]
                                    },
                                    ...ramp.shapes
                                ]);
                            },
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                            children: hangar.name
                        }, `hangar-button-${hangar.id}`))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                flexItem: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5iWzk.CalibrationPointDialog), {
                open: calibrationDialog.open,
                onClose: ()=>setCalibrationDialog({
                        open: false
                    }),
                onSave: handleSaveCalibrationPoint,
                point: calibrationDialog.point,
                x: calibrationDialog.x || 0,
                y: calibrationDialog.y || 0,
                rampId: ramp.id
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7yp1.GISImportDialog), {
                open: gisImportDialogOpen,
                onClose: ()=>setGisImportDialogOpen(false),
                onImportShapes: handleImportGISShapes,
                ramp: ramp
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kLvAj.EgressCalculationDialog), {
                open: egressDialogOpen,
                onClose: ()=>setEgressDialogOpen(false),
                result: egressResult
            })
        ]
    });
};

});
parcelRegister("hFfv7", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $cdc24a2bb376733b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cdc24a2bb376733b$var$_createSvgIcon = $cdc24a2bb376733b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $cdc24a2bb376733b$var$_default = module.exports.default = (0, $cdc24a2bb376733b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 9v2h16V9zm12-5-1.41-1.41L13 4.17V1h-2v3.19L9.39 2.61 8 4l4 4zM4 14h16v-2H4zm4 5 1.39 1.39L11 18.81V22h2v-3.17l1.59 1.59L16 19l-4-4z"
}), 'CompressOutlined');

});

parcelRegister("lG3ek", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $fc8006a90dad711b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc8006a90dad711b$var$_createSvgIcon = $fc8006a90dad711b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $fc8006a90dad711b$var$_default = module.exports.default = (0, $fc8006a90dad711b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zm0-10h4v6h6v-6h4l-7-7z"
}), 'Upload');

});

parcelRegister("67oTk", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $4746b46c9ce21ad5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4746b46c9ce21ad5$var$_createSvgIcon = $4746b46c9ce21ad5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4746b46c9ce21ad5$var$_default = module.exports.default = (0, $4746b46c9ce21ad5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27z"
}), 'Layers');

});

parcelRegister("l5Oj5", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $f5b1167f7b3c02b9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5b1167f7b3c02b9$var$_createSvgIcon = $f5b1167f7b3c02b9$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $f5b1167f7b3c02b9$var$_default = module.exports.default = (0, $f5b1167f7b3c02b9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 3v18h18V3zm16 16H5V5h14zM11 7h2v2h-2zM7 7h2v2H7zm8 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
}), 'Margin');

});

parcelRegister("2g1w6", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1a4e4099d62460c9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a4e4099d62460c9$var$_createSvgIcon = $1a4e4099d62460c9$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1a4e4099d62460c9$var$_default = module.exports.default = (0, $1a4e4099d62460c9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 15.18V7c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 1.1-.9 2-2 2s-2-.9-2-2V8.82C8.16 8.4 9 7.3 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6c0 1.3.84 2.4 2 2.82V17c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-1.1.9-2 2-2s2 .9 2 2v8.18c-1.16.41-2 1.51-2 2.82 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82"
}), 'Route');

});

parcelRegister("79mJW", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => (parcelRequire("c9nMz")).SplitButton);
parcelRequire("c9nMz");

});
parcelRegister("c9nMz", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $d1ad13ac00c14ccd$export$651ad66661acd392);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");

var $2p5OG = parcelRequire("2p5OG");

var $kGwBF = parcelRequire("kGwBF");

var $iscuz = parcelRequire("iscuz");

var $2iAqv = parcelRequire("2iAqv");

var $lBOb7 = parcelRequire("lBOb7");

var $7Frhn = parcelRequire("7Frhn");

var $e76iu = parcelRequire("e76iu");

var $acw62 = parcelRequire("acw62");

var $fu9Og = parcelRequire("fu9Og");
const $d1ad13ac00c14ccd$export$651ad66661acd392 = ({ disabled: disabled = false, options: options, startIcon: startIcon, color: color = "primary", size: size = "medium", variant: variant = "contained", defaultSelectedIndex: defaultSelectedIndex = 0 })=>{
    const [open, setOpen] = $acw62.useState(false);
    const anchorRef = $acw62.useRef(null);
    const [selectedIndex, setSelectedIndex] = $acw62.useState(defaultSelectedIndex);
    // If there's only one option, render a simple button instead of a split button
    if (options.length === 1) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
        disabled: disabled || options[0].disabled,
        color: color,
        variant: variant,
        startIcon: startIcon,
        onClick: options[0].onClick,
        size: size,
        children: options[0].label
    });
    const handleClick = ()=>{
        options[selectedIndex].onClick();
    };
    const handleMenuItemClick = (_event, index)=>{
        setSelectedIndex(index);
        setOpen(false);
    };
    const handleToggle = ()=>{
        setOpen((prevOpen)=>!prevOpen);
    };
    const handleClose = (event)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2p5OG.default), {
                disableElevation: true,
                disabled: disabled,
                color: color,
                variant: variant,
                ref: anchorRef,
                "aria-label": "split button",
                size: size,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        startIcon: startIcon,
                        onClick: handleClick,
                        children: options[selectedIndex].label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        "data-testid": "split_button",
                        size: "small",
                        color: color,
                        "aria-controls": open ? "split-button-menu" : undefined,
                        "aria-expanded": open ? "true" : undefined,
                        "aria-label": "select merge strategy",
                        "aria-haspopup": "menu",
                        onClick: handleToggle,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "ArrowDropDownIcon"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e76iu.default), {
                sx: {
                    zIndex: 9999
                },
                open: open,
                anchorEl: anchorRef.current,
                role: undefined,
                transition: true,
                disablePortal: true,
                children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iscuz.default), {
                        ...TransitionProps,
                        style: {
                            transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), {
                                onClickAway: handleClose,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lBOb7.default), {
                                    id: "split-button-menu",
                                    autoFocusItem: true,
                                    children: options.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                            selected: index === selectedIndex,
                                            disabled: option.disabled,
                                            onClick: (event)=>handleMenuItemClick(event, index),
                                            children: option.label
                                        }, option.label))
                                })
                            })
                        })
                    })
            })
        ]
    });
};

});


parcelRegister("5iWzk", function(module, exports) {

$parcel$export(module.exports, "CalibrationPointDialog", () => $9b1710ce2c9d0600$export$c7a9e425b3b63a4a);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $9b1710ce2c9d0600$export$c7a9e425b3b63a4a = ({ open: open, onClose: onClose, onSave: onSave, point: point, x: x, y: y, rampId: rampId })=>{
    const [coordinates, setCoordinates] = $acw62.useState("");
    const [latitude, setLatitude] = $acw62.useState("");
    const [longitude, setLongitude] = $acw62.useState("");
    $acw62.useEffect(()=>{
        if (open) {
            // Clear form when dialog opens to prevent showing previous point's data
            if (point) {
                setLatitude(point.latitude.toString());
                setLongitude(point.longitude.toString());
                setCoordinates(`${point.latitude}, ${point.longitude}`);
            } else {
                setLatitude("");
                setLongitude("");
                setCoordinates("");
            }
        }
    }, [
        point,
        open
    ]);
    const handleCoordinatesChange = (value)=>{
        setCoordinates(value);
        // Try to parse coordinates from the string
        const parts = value.split(",").map((s)=>s.trim());
        if (parts.length === 2) {
            const lat = parseFloat(parts[0]);
            const lng = parseFloat(parts[1]);
            if (!isNaN(lat) && !isNaN(lng)) {
                setLatitude(lat.toString());
                setLongitude(lng.toString());
            }
        }
    };
    const handleSave = ()=>{
        const lat = parseFloat(latitude);
        const lng = parseFloat(longitude);
        if (isNaN(lat) || isNaN(lng)) return;
        const calibrationPoint = {
            id: point?.id || crypto.randomUUID(),
            ramp_id: rampId,
            x: x,
            y: y,
            latitude: lat,
            longitude: lng
        };
        onSave(calibrationPoint);
        onClose();
    };
    const isValid = !isNaN(parseFloat(latitude)) && !isNaN(parseFloat(longitude));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "xs",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                sx: {
                    pb: 1
                },
                children: point ? "Edit Calibration Point" : "Add Calibration Point"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                sx: {
                    py: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 1.5,
                    sx: {
                        mt: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            children: [
                                "Position: (",
                                (x * 100).toFixed(1),
                                "%, ",
                                (y * 100).toFixed(1),
                                "%)"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            fullWidth: true,
                            label: "Coordinates (Paste from Google Maps)",
                            placeholder: "39.973, -105.251",
                            value: coordinates,
                            onChange: (e)=>handleCoordinatesChange(e.target.value),
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    fullWidth: true,
                                    label: "Latitude",
                                    type: "number",
                                    value: latitude,
                                    onChange: (e)=>setLatitude(e.target.value),
                                    inputProps: {
                                        step: "any"
                                    },
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    fullWidth: true,
                                    label: "Longitude",
                                    type: "number",
                                    value: longitude,
                                    onChange: (e)=>setLongitude(e.target.value),
                                    inputProps: {
                                        step: "any"
                                    },
                                    size: "small"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                sx: {
                    px: 3,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: onClose,
                        size: "small",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleSave,
                        variant: "contained",
                        disabled: !isValid,
                        size: "small",
                        children: point ? "Update" : "Add"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("lq8o1", function(module, exports) {

$parcel$export(module.exports, "useImageUpload", () => $c298bd634bc5a6a9$export$820f40e29d6d68a6);

var $acw62 = parcelRequire("acw62");

var $YOQGa = parcelRequire("YOQGa");
// Helper: Get image dimensions from base64 string
const $c298bd634bc5a6a9$var$getImageDimensions = (imageSrc)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        };
        img.onerror = reject;
        img.src = imageSrc;
    });
};
// Helper: Build dimension mismatch warning message
const $c298bd634bc5a6a9$var$buildDimensionMismatchWarning = (existing, newDim)=>{
    return `\u{26A0}\u{FE0F} WARNING: Image Dimension Mismatch!

` + `Existing image: ${existing.width} \xd7 ${existing.height}px\n` + `New image: ${newDim.width} \xd7 ${newDim.height}px\n\n` + `Replacing with a different size will BREAK CALIBRATION and require recalibrating all:\n` + `\u{2022} Calibration points
` + `\u{2022} Spot positions
` + `\u{2022} Zone boundaries
` + `\u{2022} Markings

` + `This is NOT recommended unless you are starting fresh.\n\n` + `Do you really want to continue?`;
};
// Helper: Validate image dimensions against existing image
const $c298bd634bc5a6a9$var$validateImageDimensions = async (newImageSrc, existingImageSrc)=>{
    // No validation needed if no existing image
    if (!existingImageSrc) return true;
    const [newDims, existingDims] = await Promise.all([
        $c298bd634bc5a6a9$var$getImageDimensions(newImageSrc),
        $c298bd634bc5a6a9$var$getImageDimensions(existingImageSrc)
    ]);
    // Dimensions match - no warning needed
    if (newDims.width === existingDims.width && newDims.height === existingDims.height) return true;
    // Dimensions don't match - show warning and get user confirmation
    return window.confirm($c298bd634bc5a6a9$var$buildDimensionMismatchWarning(existingDims, newDims));
};
const $c298bd634bc5a6a9$export$820f40e29d6d68a6 = (ramp, setRamp)=>{
    const [isUploading, setIsUploading] = $acw62.useState(false);
    const handleUpload = $acw62.useCallback(async (event)=>{
        const file = event.target.files?.[0];
        if (!file) return;
        setIsUploading(true);
        try {
            // Step 1: Compress image (server-side with fallback to client-side)
            const base64Image = await (0, $YOQGa.compressImageWithFallback)(file);
            // Step 2: Validate dimensions (shows warning if needed)
            const isValid = await $c298bd634bc5a6a9$var$validateImageDimensions(base64Image, ramp.reference_image);
            if (!isValid) {
                setIsUploading(false);
                return;
            }
            // Step 3: Update local ramp state
            setRamp({
                ...ramp,
                reference_image: base64Image
            });
            setIsUploading(false);
        } catch (error) {
            console.error("Failed to upload image:", error);
            setIsUploading(false);
        } finally{
            // Reset input to allow re-uploading same file
            event.target.value = "";
        }
    }, [
        ramp,
        setRamp
    ]);
    return {
        handleUpload: handleUpload,
        isUploading: isUploading
    };
};

});
parcelRegister("YOQGa", function(module, exports) {

$parcel$export(module.exports, "compressImageServerSide", () => $bdfe0c75693893c1$export$678bc5a8910f0269);
$parcel$export(module.exports, "compressImageWithFallback", () => $bdfe0c75693893c1$export$457fa8ca316b0c8d);
/**
 * Shared image compression service
 * Provides centralized compression logic with server-side processing and client-side fallback
 */ 
var $kcyGx = parcelRequire("kcyGx");

var $5PyF6 = parcelRequire("5PyF6");

var $hELAN = parcelRequire("hELAN");
// Client-side compression configuration
const $bdfe0c75693893c1$var$CLIENT_COMPRESSION_CONFIG = {
    maxSizeMB: 2,
    maxWidthOrHeight: 1920,
    useWebWorker: true
};
/**
 * Helper: Read file as data URL
 */ function $bdfe0c75693893c1$var$readFileAsDataURL(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = (e)=>resolve(e.target?.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
async function $bdfe0c75693893c1$export$678bc5a8910f0269(file) {
    const formData = new FormData();
    formData.append("image", file);
    const response = await fetch((0, $5PyF6.getCompressionUrl)(), {
        method: "POST",
        body: formData
    });
    if (!response.ok) throw new Error(`Server compression failed: ${response.statusText}`);
    const result = await response.json();
    // Log success with statistics
    (0, $hELAN.compressionLogger).success(result.originalSize, result.compressedSize, result.format, {
        width: result.width,
        height: result.height
    });
    return result;
}
async function $bdfe0c75693893c1$export$438a715a82263e71(file) {
    const originalSize = file.size;
    const compressedFile = await (0, $kcyGx.default)(file, $bdfe0c75693893c1$var$CLIENT_COMPRESSION_CONFIG);
    (0, $hELAN.compressionLogger).clientSide(originalSize, compressedFile.size);
    return await $bdfe0c75693893c1$var$readFileAsDataURL(compressedFile);
}
async function $bdfe0c75693893c1$export$457fa8ca316b0c8d(file) {
    try {
        const result = await $bdfe0c75693893c1$export$678bc5a8910f0269(file);
        return result.data;
    } catch (error) {
        (0, $hELAN.compressionLogger).fallback(error);
        return await $bdfe0c75693893c1$export$438a715a82263e71(file);
    }
}

});
parcelRegister("kcyGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8225ba78123222c8$export$2e2bcd8739ae039);
/**
 * Browser Image Compression
 * v2.0.2
 * by Donald <donaldcwl@gmail.com>
 * https://github.com/Donaldcwl/browser-image-compression
 */ function $8225ba78123222c8$var$_mergeNamespaces(e, t1) {
    return t1.forEach(function(t1) {
        t1 && "string" != typeof t1 && !Array.isArray(t1) && Object.keys(t1).forEach(function(r) {
            if ("default" !== r && !(r in e)) {
                var i = Object.getOwnPropertyDescriptor(t1, r);
                Object.defineProperty(e, r, i.get ? i : {
                    enumerable: !0,
                    get: function() {
                        return t1[r];
                    }
                });
            }
        });
    }), Object.freeze(e);
}
function $8225ba78123222c8$var$copyExifWithoutOrientation(e, t1) {
    return new Promise(function(r, i) {
        let o;
        return $8225ba78123222c8$var$getApp1Segment(e).then(function(e) {
            try {
                return o = e, r(new Blob([
                    t1.slice(0, 2),
                    o,
                    t1.slice(2)
                ], {
                    type: "image/jpeg"
                }));
            } catch (e) {
                return i(e);
            }
        }, i);
    });
}
const $8225ba78123222c8$var$getApp1Segment = (e)=>new Promise((t1, r)=>{
        const i = new FileReader;
        i.addEventListener("load", ({ target: { result: e } })=>{
            const i = new DataView(e);
            let o = 0;
            if (65496 !== i.getUint16(o)) return r("not a valid JPEG");
            for(o += 2;;){
                const a = i.getUint16(o);
                if (65498 === a) break;
                const s = i.getUint16(o + 2);
                if (65505 === a && 1165519206 === i.getUint32(o + 4)) {
                    const a = o + 10;
                    let f;
                    switch(i.getUint16(a)){
                        case 18761:
                            f = !0;
                            break;
                        case 19789:
                            f = !1;
                            break;
                        default:
                            return r("TIFF header contains invalid endian");
                    }
                    if (42 !== i.getUint16(a + 2, f)) return r("TIFF header contains invalid version");
                    const l = i.getUint32(a + 4, f), c = a + l + 2 + 12 * i.getUint16(a + l, f);
                    for(let e = a + l + 2; e < c; e += 12)if (274 == i.getUint16(e, f)) {
                        if (3 !== i.getUint16(e + 2, f)) return r("Orientation data type is invalid");
                        if (1 !== i.getUint32(e + 4, f)) return r("Orientation data count is invalid");
                        i.setUint16(e + 8, 1, f);
                        break;
                    }
                    return t1(e.slice(o, o + 2 + s));
                }
                o += 2 + s;
            }
            return t1(new Blob);
        }), i.readAsArrayBuffer(e);
    });
var $8225ba78123222c8$var$e = {}, $8225ba78123222c8$var$t1 = {
    get exports () {
        return $8225ba78123222c8$var$e;
    },
    set exports (t){
        $8225ba78123222c8$var$e = t;
    }
};
!function(e) {
    var r, i, UZIP = {};
    $8225ba78123222c8$var$t1.exports = UZIP, UZIP.parse = function(e, t1) {
        for(var r = UZIP.bin.readUshort, i = UZIP.bin.readUint, o = 0, a = {}, s = new Uint8Array(e), f = s.length - 4; 101010256 != i(s, f);)f--;
        o = f;
        o += 4;
        var l = r(s, o += 4);
        r(s, o += 2);
        var c = i(s, o += 2), u = i(s, o += 4);
        o += 4, o = u;
        for(var h = 0; h < l; h++){
            i(s, o), o += 4, o += 4, o += 4, i(s, o += 4);
            c = i(s, o += 4);
            var d = i(s, o += 4), A = r(s, o += 4), g = r(s, o + 2), p = r(s, o + 4);
            o += 6;
            var m = i(s, o += 8);
            o += 4, o += A + g + p, UZIP._readLocal(s, m, a, c, d, t1);
        }
        return a;
    }, UZIP._readLocal = function(e, t1, r, i, o, a) {
        var s = UZIP.bin.readUshort, f = UZIP.bin.readUint;
        f(e, t1), s(e, t1 += 4), s(e, t1 += 2);
        var l = s(e, t1 += 2);
        f(e, t1 += 2), f(e, t1 += 4), t1 += 4;
        var c = s(e, t1 += 8), u = s(e, t1 += 2);
        t1 += 2;
        var h = UZIP.bin.readUTF8(e, t1, c);
        if (t1 += c, t1 += u, a) r[h] = {
            size: o,
            csize: i
        };
        else {
            var d = new Uint8Array(e.buffer, t1);
            if (0 == l) r[h] = new Uint8Array(d.buffer.slice(t1, t1 + i));
            else {
                if (8 != l) throw "unknown compression method: " + l;
                var A = new Uint8Array(o);
                UZIP.inflateRaw(d, A), r[h] = A;
            }
        }
    }, UZIP.inflateRaw = function(e, t1) {
        return UZIP.F.inflate(e, t1);
    }, UZIP.inflate = function(e, t1) {
        return e[0], e[1], UZIP.inflateRaw(new Uint8Array(e.buffer, e.byteOffset + 2, e.length - 6), t1);
    }, UZIP.deflate = function(e, t1) {
        null == t1 && (t1 = {
            level: 6
        });
        var r = 0, i = new Uint8Array(50 + Math.floor(1.1 * e.length));
        i[r] = 120, i[r + 1] = 156, r += 2, r = UZIP.F.deflateRaw(e, i, r, t1.level);
        var o = UZIP.adler(e, 0, e.length);
        return i[r + 0] = o >>> 24 & 255, i[r + 1] = o >>> 16 & 255, i[r + 2] = o >>> 8 & 255, i[r + 3] = o >>> 0 & 255, new Uint8Array(i.buffer, 0, r + 4);
    }, UZIP.deflateRaw = function(e, t1) {
        null == t1 && (t1 = {
            level: 6
        });
        var r = new Uint8Array(50 + Math.floor(1.1 * e.length)), i = UZIP.F.deflateRaw(e, r, i, t1.level);
        return new Uint8Array(r.buffer, 0, i);
    }, UZIP.encode = function(e, t1) {
        null == t1 && (t1 = !1);
        var r = 0, i = UZIP.bin.writeUint, o = UZIP.bin.writeUshort, a = {};
        for(var s in e){
            var f = !UZIP._noNeed(s) && !t1, l = e[s], c = UZIP.crc.crc(l, 0, l.length);
            a[s] = {
                cpr: f,
                usize: l.length,
                crc: c,
                file: f ? UZIP.deflateRaw(l) : l
            };
        }
        for(var s in a)r += a[s].file.length + 30 + 46 + 2 * UZIP.bin.sizeUTF8(s);
        r += 22;
        var u = new Uint8Array(r), h = 0, d = [];
        for(var s in a){
            var A = a[s];
            d.push(h), h = UZIP._writeHeader(u, h, s, A, 0);
        }
        var g = 0, p = h;
        for(var s in a){
            A = a[s];
            d.push(h), h = UZIP._writeHeader(u, h, s, A, 1, d[g++]);
        }
        var m = h - p;
        return i(u, h, 101010256), h += 4, o(u, h += 4, g), o(u, h += 2, g), i(u, h += 2, m), i(u, h += 4, p), h += 4, h += 2, u.buffer;
    }, UZIP._noNeed = function(e) {
        var t1 = e.split(".").pop().toLowerCase();
        return -1 != "png,jpg,jpeg,zip".indexOf(t1);
    }, UZIP._writeHeader = function(e, t1, r, i, o, a) {
        var s = UZIP.bin.writeUint, f = UZIP.bin.writeUshort, l = i.file;
        return s(e, t1, 0 == o ? 67324752 : 33639248), t1 += 4, 1 == o && (t1 += 2), f(e, t1, 20), f(e, t1 += 2, 0), f(e, t1 += 2, i.cpr ? 8 : 0), s(e, t1 += 2, 0), s(e, t1 += 4, i.crc), s(e, t1 += 4, l.length), s(e, t1 += 4, i.usize), f(e, t1 += 4, UZIP.bin.sizeUTF8(r)), f(e, t1 += 2, 0), t1 += 2, 1 == o && (t1 += 2, t1 += 2, s(e, t1 += 6, a), t1 += 4), t1 += UZIP.bin.writeUTF8(e, t1, r), 0 == o && (e.set(l, t1), t1 += l.length), t1;
    }, UZIP.crc = {
        table: function() {
            for(var e = new Uint32Array(256), t1 = 0; t1 < 256; t1++){
                for(var r = t1, i = 0; i < 8; i++)1 & r ? r = 3988292384 ^ r >>> 1 : r >>>= 1;
                e[t1] = r;
            }
            return e;
        }(),
        update: function(e, t1, r, i) {
            for(var o = 0; o < i; o++)e = UZIP.crc.table[255 & (e ^ t1[r + o])] ^ e >>> 8;
            return e;
        },
        crc: function(e, t1, r) {
            return 4294967295 ^ UZIP.crc.update(4294967295, e, t1, r);
        }
    }, UZIP.adler = function(e, t1, r) {
        for(var i = 1, o = 0, a = t1, s = t1 + r; a < s;){
            for(var f = Math.min(a + 5552, s); a < f;)o += i += e[a++];
            i %= 65521, o %= 65521;
        }
        return o << 16 | i;
    }, UZIP.bin = {
        readUshort: function(e, t1) {
            return e[t1] | e[t1 + 1] << 8;
        },
        writeUshort: function(e, t1, r) {
            e[t1] = 255 & r, e[t1 + 1] = r >> 8 & 255;
        },
        readUint: function(e, t1) {
            return 16777216 * e[t1 + 3] + (e[t1 + 2] << 16 | e[t1 + 1] << 8 | e[t1]);
        },
        writeUint: function(e, t1, r) {
            e[t1] = 255 & r, e[t1 + 1] = r >> 8 & 255, e[t1 + 2] = r >> 16 & 255, e[t1 + 3] = r >> 24 & 255;
        },
        readASCII: function(e, t1, r) {
            for(var i = "", o = 0; o < r; o++)i += String.fromCharCode(e[t1 + o]);
            return i;
        },
        writeASCII: function(e, t1, r) {
            for(var i = 0; i < r.length; i++)e[t1 + i] = r.charCodeAt(i);
        },
        pad: function(e) {
            return e.length < 2 ? "0" + e : e;
        },
        readUTF8: function(e, t1, r) {
            for(var i, o = "", a = 0; a < r; a++)o += "%" + UZIP.bin.pad(e[t1 + a].toString(16));
            try {
                i = decodeURIComponent(o);
            } catch (i) {
                return UZIP.bin.readASCII(e, t1, r);
            }
            return i;
        },
        writeUTF8: function(e, t1, r) {
            for(var i = r.length, o = 0, a = 0; a < i; a++){
                var s = r.charCodeAt(a);
                if (0 == (4294967168 & s)) e[t1 + o] = s, o++;
                else if (0 == (4294965248 & s)) e[t1 + o] = 192 | s >> 6, e[t1 + o + 1] = 128 | s >> 0 & 63, o += 2;
                else if (0 == (4294901760 & s)) e[t1 + o] = 224 | s >> 12, e[t1 + o + 1] = 128 | s >> 6 & 63, e[t1 + o + 2] = 128 | s >> 0 & 63, o += 3;
                else {
                    if (0 != (4292870144 & s)) throw "e";
                    e[t1 + o] = 240 | s >> 18, e[t1 + o + 1] = 128 | s >> 12 & 63, e[t1 + o + 2] = 128 | s >> 6 & 63, e[t1 + o + 3] = 128 | s >> 0 & 63, o += 4;
                }
            }
            return o;
        },
        sizeUTF8: function(e) {
            for(var t1 = e.length, r = 0, i = 0; i < t1; i++){
                var o = e.charCodeAt(i);
                if (0 == (4294967168 & o)) r++;
                else if (0 == (4294965248 & o)) r += 2;
                else if (0 == (4294901760 & o)) r += 3;
                else {
                    if (0 != (4292870144 & o)) throw "e";
                    r += 4;
                }
            }
            return r;
        }
    }, UZIP.F = {}, UZIP.F.deflateRaw = function(e, t1, r, i) {
        var o = [
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                4,
                4,
                8,
                4,
                0
            ],
            [
                4,
                5,
                16,
                8,
                0
            ],
            [
                4,
                6,
                16,
                16,
                0
            ],
            [
                4,
                10,
                16,
                32,
                0
            ],
            [
                8,
                16,
                32,
                32,
                0
            ],
            [
                8,
                16,
                128,
                128,
                0
            ],
            [
                8,
                32,
                128,
                256,
                0
            ],
            [
                32,
                128,
                258,
                1024,
                1
            ],
            [
                32,
                258,
                258,
                4096,
                1
            ]
        ][i], a = UZIP.F.U, s = UZIP.F._goodIndex;
        UZIP.F._hash;
        var f = UZIP.F._putsE, l = 0, c = r << 3, u = 0, h = e.length;
        if (0 == i) {
            for(; l < h;)f(t1, c, l + (_ = Math.min(65535, h - l)) == h ? 1 : 0), c = UZIP.F._copyExact(e, l, _, t1, c + 8), l += _;
            return c >>> 3;
        }
        var d = a.lits, A = a.strt, g = a.prev, p = 0, m = 0, w = 0, v = 0, b = 0, y = 0;
        for(h > 2 && (A[y = UZIP.F._hash(e, 0)] = 0), l = 0; l < h; l++){
            if (b = y, l + 1 < h - 2) {
                y = UZIP.F._hash(e, l + 1);
                var E = l + 1 & 32767;
                g[E] = A[y], A[y] = E;
            }
            if (u <= l) {
                (p > 14e3 || m > 26697) && h - l > 100 && (u < l && (d[p] = l - u, p += 2, u = l), c = UZIP.F._writeBlock(l == h - 1 || u == h ? 1 : 0, d, p, v, e, w, l - w, t1, c), p = m = v = 0, w = l);
                var F = 0;
                l < h - 2 && (F = UZIP.F._bestMatch(e, l, g, b, Math.min(o[2], h - l), o[3]));
                var _ = F >>> 16, B = 65535 & F;
                if (0 != F) {
                    B = 65535 & F;
                    var U = s(_ = F >>> 16, a.of0);
                    a.lhst[257 + U]++;
                    var C = s(B, a.df0);
                    a.dhst[C]++, v += a.exb[U] + a.dxb[C], d[p] = _ << 23 | l - u, d[p + 1] = B << 16 | U << 8 | C, p += 2, u = l + _;
                } else a.lhst[e[l]]++;
                m++;
            }
        }
        for(w == l && 0 != e.length || (u < l && (d[p] = l - u, p += 2, u = l), c = UZIP.F._writeBlock(1, d, p, v, e, w, l - w, t1, c), p = 0, m = 0, p = m = v = 0, w = l); 0 != (7 & c);)c++;
        return c >>> 3;
    }, UZIP.F._bestMatch = function(e, t1, r, i, o, a) {
        var s = 32767 & t1, f = r[s], l = s - f + 32768 & 32767;
        if (f == s || i != UZIP.F._hash(e, t1 - l)) return 0;
        for(var c = 0, u = 0, h = Math.min(32767, t1); l <= h && 0 != --a && f != s;){
            if (0 == c || e[t1 + c] == e[t1 + c - l]) {
                var d = UZIP.F._howLong(e, t1, l);
                if (d > c) {
                    if (u = l, (c = d) >= o) break;
                    l + 2 < d && (d = l + 2);
                    for(var A = 0, g = 0; g < d - 2; g++){
                        var p = t1 - l + g + 32768 & 32767, m = p - r[p] + 32768 & 32767;
                        m > A && (A = m, f = p);
                    }
                }
            }
            l += (s = f) - (f = r[s]) + 32768 & 32767;
        }
        return c << 16 | u;
    }, UZIP.F._howLong = function(e, t1, r) {
        if (e[t1] != e[t1 - r] || e[t1 + 1] != e[t1 + 1 - r] || e[t1 + 2] != e[t1 + 2 - r]) return 0;
        var i = t1, o = Math.min(e.length, t1 + 258);
        for(t1 += 3; t1 < o && e[t1] == e[t1 - r];)t1++;
        return t1 - i;
    }, UZIP.F._hash = function(e, t1) {
        return (e[t1] << 8 | e[t1 + 1]) + (e[t1 + 2] << 4) & 65535;
    }, UZIP.saved = 0, UZIP.F._writeBlock = function(e, t1, r, i, o, a, s, f, l) {
        var c, u, h, d, A, g, p, m, w, v = UZIP.F.U, b = UZIP.F._putsF, y = UZIP.F._putsE;
        v.lhst[256]++, u = (c = UZIP.F.getTrees())[0], h = c[1], d = c[2], A = c[3], g = c[4], p = c[5], m = c[6], w = c[7];
        var E = 32 + (0 == (l + 3 & 7) ? 0 : 8 - (l + 3 & 7)) + (s << 3), F = i + UZIP.F.contSize(v.fltree, v.lhst) + UZIP.F.contSize(v.fdtree, v.dhst), _ = i + UZIP.F.contSize(v.ltree, v.lhst) + UZIP.F.contSize(v.dtree, v.dhst);
        _ += 14 + 3 * p + UZIP.F.contSize(v.itree, v.ihst) + (2 * v.ihst[16] + 3 * v.ihst[17] + 7 * v.ihst[18]);
        for(var B = 0; B < 286; B++)v.lhst[B] = 0;
        for(B = 0; B < 30; B++)v.dhst[B] = 0;
        for(B = 0; B < 19; B++)v.ihst[B] = 0;
        var U = E < F && E < _ ? 0 : F < _ ? 1 : 2;
        if (b(f, l, e), b(f, l + 1, U), l += 3, 0 == U) {
            for(; 0 != (7 & l);)l++;
            l = UZIP.F._copyExact(o, a, s, f, l);
        } else {
            var C, I;
            if (1 == U && (C = v.fltree, I = v.fdtree), 2 == U) {
                UZIP.F.makeCodes(v.ltree, u), UZIP.F.revCodes(v.ltree, u), UZIP.F.makeCodes(v.dtree, h), UZIP.F.revCodes(v.dtree, h), UZIP.F.makeCodes(v.itree, d), UZIP.F.revCodes(v.itree, d), C = v.ltree, I = v.dtree, y(f, l, A - 257), y(f, l += 5, g - 1), y(f, l += 5, p - 4), l += 4;
                for(var Q = 0; Q < p; Q++)y(f, l + 3 * Q, v.itree[1 + (v.ordr[Q] << 1)]);
                l += 3 * p, l = UZIP.F._codeTiny(m, v.itree, f, l), l = UZIP.F._codeTiny(w, v.itree, f, l);
            }
            for(var M = a, x = 0; x < r; x += 2){
                for(var S = t1[x], R = S >>> 23, T = M + (8388607 & S); M < T;)l = UZIP.F._writeLit(o[M++], C, f, l);
                if (0 != R) {
                    var O = t1[x + 1], P = O >> 16, H = O >> 8 & 255, L = 255 & O;
                    y(f, l = UZIP.F._writeLit(257 + H, C, f, l), R - v.of0[H]), l += v.exb[H], b(f, l = UZIP.F._writeLit(L, I, f, l), P - v.df0[L]), l += v.dxb[L], M += R;
                }
            }
            l = UZIP.F._writeLit(256, C, f, l);
        }
        return l;
    }, UZIP.F._copyExact = function(e, t1, r, i, o) {
        var a = o >>> 3;
        return i[a] = r, i[a + 1] = r >>> 8, i[a + 2] = 255 - i[a], i[a + 3] = 255 - i[a + 1], a += 4, i.set(new Uint8Array(e.buffer, t1, r), a), o + (r + 4 << 3);
    }, UZIP.F.getTrees = function() {
        for(var e = UZIP.F.U, t1 = UZIP.F._hufTree(e.lhst, e.ltree, 15), r = UZIP.F._hufTree(e.dhst, e.dtree, 15), i = [], o = UZIP.F._lenCodes(e.ltree, i), a = [], s = UZIP.F._lenCodes(e.dtree, a), f = 0; f < i.length; f += 2)e.ihst[i[f]]++;
        for(f = 0; f < a.length; f += 2)e.ihst[a[f]]++;
        for(var l = UZIP.F._hufTree(e.ihst, e.itree, 7), c = 19; c > 4 && 0 == e.itree[1 + (e.ordr[c - 1] << 1)];)c--;
        return [
            t1,
            r,
            l,
            o,
            s,
            c,
            i,
            a
        ];
    }, UZIP.F.getSecond = function(e) {
        for(var t1 = [], r = 0; r < e.length; r += 2)t1.push(e[r + 1]);
        return t1;
    }, UZIP.F.nonZero = function(e) {
        for(var t1 = "", r = 0; r < e.length; r += 2)0 != e[r + 1] && (t1 += (r >> 1) + ",");
        return t1;
    }, UZIP.F.contSize = function(e, t1) {
        for(var r = 0, i = 0; i < t1.length; i++)r += t1[i] * e[1 + (i << 1)];
        return r;
    }, UZIP.F._codeTiny = function(e, t1, r, i) {
        for(var o = 0; o < e.length; o += 2){
            var a = e[o], s = e[o + 1];
            i = UZIP.F._writeLit(a, t1, r, i);
            var f = 16 == a ? 2 : 17 == a ? 3 : 7;
            a > 15 && (UZIP.F._putsE(r, i, s, f), i += f);
        }
        return i;
    }, UZIP.F._lenCodes = function(e, t1) {
        for(var r = e.length; 2 != r && 0 == e[r - 1];)r -= 2;
        for(var i = 0; i < r; i += 2){
            var o = e[i + 1], a = i + 3 < r ? e[i + 3] : -1, s = i + 5 < r ? e[i + 5] : -1, f = 0 == i ? -1 : e[i - 1];
            if (0 == o && a == o && s == o) {
                for(var l = i + 5; l + 2 < r && e[l + 2] == o;)l += 2;
                (c = Math.min(l + 1 - i >>> 1, 138)) < 11 ? t1.push(17, c - 3) : t1.push(18, c - 11), i += 2 * c - 2;
            } else if (o == f && a == o && s == o) {
                for(l = i + 5; l + 2 < r && e[l + 2] == o;)l += 2;
                var c = Math.min(l + 1 - i >>> 1, 6);
                t1.push(16, c - 3), i += 2 * c - 2;
            } else t1.push(o, 0);
        }
        return r >>> 1;
    }, UZIP.F._hufTree = function(e, t1, r) {
        var i = [], o = e.length, a = t1.length, s = 0;
        for(s = 0; s < a; s += 2)t1[s] = 0, t1[s + 1] = 0;
        for(s = 0; s < o; s++)0 != e[s] && i.push({
            lit: s,
            f: e[s]
        });
        var f = i.length, l = i.slice(0);
        if (0 == f) return 0;
        if (1 == f) {
            var c = i[0].lit;
            l = 0 == c ? 1 : 0;
            return t1[1 + (c << 1)] = 1, t1[1 + (l << 1)] = 1, 1;
        }
        i.sort(function(e, t1) {
            return e.f - t1.f;
        });
        var u = i[0], h = i[1], d = 0, A = 1, g = 2;
        for(i[0] = {
            lit: -1,
            f: u.f + h.f,
            l: u,
            r: h,
            d: 0
        }; A != f - 1;)u = d != A && (g == f || i[d].f < i[g].f) ? i[d++] : i[g++], h = d != A && (g == f || i[d].f < i[g].f) ? i[d++] : i[g++], i[A++] = {
            lit: -1,
            f: u.f + h.f,
            l: u,
            r: h
        };
        var p = UZIP.F.setDepth(i[A - 1], 0);
        for(p > r && (UZIP.F.restrictDepth(l, r, p), p = r), s = 0; s < f; s++)t1[1 + (l[s].lit << 1)] = l[s].d;
        return p;
    }, UZIP.F.setDepth = function(e, t1) {
        return -1 != e.lit ? (e.d = t1, t1) : Math.max(UZIP.F.setDepth(e.l, t1 + 1), UZIP.F.setDepth(e.r, t1 + 1));
    }, UZIP.F.restrictDepth = function(e, t1, r) {
        var i = 0, o = 1 << r - t1, a = 0;
        for(e.sort(function(e, t1) {
            return t1.d == e.d ? e.f - t1.f : t1.d - e.d;
        }), i = 0; i < e.length && e[i].d > t1; i++){
            var s = e[i].d;
            e[i].d = t1, a += o - (1 << r - s);
        }
        for(a >>>= r - t1; a > 0;)(s = e[i].d) < t1 ? (e[i].d++, a -= 1 << t1 - s - 1) : i++;
        for(; i >= 0; i--)e[i].d == t1 && a < 0 && (e[i].d--, a++);
        0 != a && console.log("debt left");
    }, UZIP.F._goodIndex = function(e, t1) {
        var r = 0;
        return t1[16 | r] <= e && (r |= 16), t1[8 | r] <= e && (r |= 8), t1[4 | r] <= e && (r |= 4), t1[2 | r] <= e && (r |= 2), t1[1 | r] <= e && (r |= 1), r;
    }, UZIP.F._writeLit = function(e, t1, r, i) {
        return UZIP.F._putsF(r, i, t1[e << 1]), i + t1[1 + (e << 1)];
    }, UZIP.F.inflate = function(e, t1) {
        var r = Uint8Array;
        if (3 == e[0] && 0 == e[1]) return t1 || new r(0);
        var i = UZIP.F, o = i._bitsF, a = i._bitsE, s = i._decodeTiny, f = i.makeCodes, l = i.codes2map, c = i._get17, u = i.U, h = null == t1;
        h && (t1 = new r(e.length >>> 2 << 3));
        for(var d, A, g = 0, p = 0, m = 0, w = 0, v = 0, b = 0, y = 0, E = 0, F = 0; 0 == g;)if (g = o(e, F, 1), p = o(e, F + 1, 2), F += 3, 0 != p) {
            if (h && (t1 = UZIP.F._check(t1, E + 131072)), 1 == p && (d = u.flmap, A = u.fdmap, b = 511, y = 31), 2 == p) {
                m = a(e, F, 5) + 257, w = a(e, F + 5, 5) + 1, v = a(e, F + 10, 4) + 4, F += 14;
                for(var _ = 0; _ < 38; _ += 2)u.itree[_] = 0, u.itree[_ + 1] = 0;
                var B = 1;
                for(_ = 0; _ < v; _++){
                    var U = a(e, F + 3 * _, 3);
                    u.itree[1 + (u.ordr[_] << 1)] = U, U > B && (B = U);
                }
                F += 3 * v, f(u.itree, B), l(u.itree, B, u.imap), d = u.lmap, A = u.dmap, F = s(u.imap, (1 << B) - 1, m + w, e, F, u.ttree);
                var C = i._copyOut(u.ttree, 0, m, u.ltree);
                b = (1 << C) - 1;
                var I = i._copyOut(u.ttree, m, w, u.dtree);
                y = (1 << I) - 1, f(u.ltree, C), l(u.ltree, C, d), f(u.dtree, I), l(u.dtree, I, A);
            }
            for(;;){
                var Q = d[c(e, F) & b];
                F += 15 & Q;
                var M = Q >>> 4;
                if (M >>> 8 == 0) t1[E++] = M;
                else {
                    if (256 == M) break;
                    var x = E + M - 254;
                    if (M > 264) {
                        var S = u.ldef[M - 257];
                        x = E + (S >>> 3) + a(e, F, 7 & S), F += 7 & S;
                    }
                    var R = A[c(e, F) & y];
                    F += 15 & R;
                    var T = R >>> 4, O = u.ddef[T], P = (O >>> 4) + o(e, F, 15 & O);
                    for(F += 15 & O, h && (t1 = UZIP.F._check(t1, E + 131072)); E < x;)t1[E] = t1[E++ - P], t1[E] = t1[E++ - P], t1[E] = t1[E++ - P], t1[E] = t1[E++ - P];
                    E = x;
                }
            }
        } else {
            0 != (7 & F) && (F += 8 - (7 & F));
            var H = 4 + (F >>> 3), L = e[H - 4] | e[H - 3] << 8;
            h && (t1 = UZIP.F._check(t1, E + L)), t1.set(new r(e.buffer, e.byteOffset + H, L), E), F = H + L << 3, E += L;
        }
        return t1.length == E ? t1 : t1.slice(0, E);
    }, UZIP.F._check = function(e, t1) {
        var r = e.length;
        if (t1 <= r) return e;
        var i = new Uint8Array(Math.max(r << 1, t1));
        return i.set(e, 0), i;
    }, UZIP.F._decodeTiny = function(e, t1, r, i, o, a) {
        for(var s = UZIP.F._bitsE, f = UZIP.F._get17, l = 0; l < r;){
            var c = e[f(i, o) & t1];
            o += 15 & c;
            var u = c >>> 4;
            if (u <= 15) a[l] = u, l++;
            else {
                var h = 0, d = 0;
                16 == u ? (d = 3 + s(i, o, 2), o += 2, h = a[l - 1]) : 17 == u ? (d = 3 + s(i, o, 3), o += 3) : 18 == u && (d = 11 + s(i, o, 7), o += 7);
                for(var A = l + d; l < A;)a[l] = h, l++;
            }
        }
        return o;
    }, UZIP.F._copyOut = function(e, t1, r, i) {
        for(var o = 0, a = 0, s = i.length >>> 1; a < r;){
            var f = e[a + t1];
            i[a << 1] = 0, i[1 + (a << 1)] = f, f > o && (o = f), a++;
        }
        for(; a < s;)i[a << 1] = 0, i[1 + (a << 1)] = 0, a++;
        return o;
    }, UZIP.F.makeCodes = function(e, t1) {
        for(var r, i, o, a, s = UZIP.F.U, f = e.length, l = s.bl_count, c = 0; c <= t1; c++)l[c] = 0;
        for(c = 1; c < f; c += 2)l[e[c]]++;
        var u = s.next_code;
        for(r = 0, l[0] = 0, i = 1; i <= t1; i++)r = r + l[i - 1] << 1, u[i] = r;
        for(o = 0; o < f; o += 2)0 != (a = e[o + 1]) && (e[o] = u[a], u[a]++);
    }, UZIP.F.codes2map = function(e, t1, r) {
        for(var i = e.length, o = UZIP.F.U.rev15, a = 0; a < i; a += 2)if (0 != e[a + 1]) for(var s = a >> 1, f = e[a + 1], l = s << 4 | f, c = t1 - f, u = e[a] << c, h = u + (1 << c); u != h;)r[o[u] >>> 15 - t1] = l, u++;
    }, UZIP.F.revCodes = function(e, t1) {
        for(var r = UZIP.F.U.rev15, i = 15 - t1, o = 0; o < e.length; o += 2){
            var a = e[o] << t1 - e[o + 1];
            e[o] = r[a] >>> i;
        }
    }, UZIP.F._putsE = function(e, t1, r) {
        r <<= 7 & t1;
        var i = t1 >>> 3;
        e[i] |= r, e[i + 1] |= r >>> 8;
    }, UZIP.F._putsF = function(e, t1, r) {
        r <<= 7 & t1;
        var i = t1 >>> 3;
        e[i] |= r, e[i + 1] |= r >>> 8, e[i + 2] |= r >>> 16;
    }, UZIP.F._bitsE = function(e, t1, r) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8) >>> (7 & t1) & (1 << r) - 1;
    }, UZIP.F._bitsF = function(e, t1, r) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1) & (1 << r) - 1;
    }, UZIP.F._get17 = function(e, t1) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1);
    }, UZIP.F._get25 = function(e, t1) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16 | e[3 + (t1 >>> 3)] << 24) >>> (7 & t1);
    }, UZIP.F.U = (r = Uint16Array, i = Uint32Array, {
        next_code: new r(16),
        bl_count: new r(16),
        ordr: [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ],
        of0: [
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            13,
            15,
            17,
            19,
            23,
            27,
            31,
            35,
            43,
            51,
            59,
            67,
            83,
            99,
            115,
            131,
            163,
            195,
            227,
            258,
            999,
            999,
            999
        ],
        exb: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ],
        ldef: new r(32),
        df0: [
            1,
            2,
            3,
            4,
            5,
            7,
            9,
            13,
            17,
            25,
            33,
            49,
            65,
            97,
            129,
            193,
            257,
            385,
            513,
            769,
            1025,
            1537,
            2049,
            3073,
            4097,
            6145,
            8193,
            12289,
            16385,
            24577,
            65535,
            65535
        ],
        dxb: [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ],
        ddef: new i(32),
        flmap: new r(512),
        fltree: [],
        fdmap: new r(32),
        fdtree: [],
        lmap: new r(32768),
        ltree: [],
        ttree: [],
        dmap: new r(32768),
        dtree: [],
        imap: new r(512),
        itree: [],
        rev15: new r(32768),
        lhst: new i(286),
        dhst: new i(30),
        ihst: new i(19),
        lits: new i(15e3),
        strt: new r(65536),
        prev: new r(32768)
    }), function() {
        for(var e = UZIP.F.U, t1 = 0; t1 < 32768; t1++){
            var r = t1;
            r = (4278255360 & (r = (4042322160 & (r = (3435973836 & (r = (2863311530 & r) >>> 1 | (1431655765 & r) << 1)) >>> 2 | (858993459 & r) << 2)) >>> 4 | (252645135 & r) << 4)) >>> 8 | (16711935 & r) << 8, e.rev15[t1] = (r >>> 16 | r << 16) >>> 17;
        }
        function pushV(e, t1, r) {
            for(; 0 != t1--;)e.push(0, r);
        }
        for(t1 = 0; t1 < 32; t1++)e.ldef[t1] = e.of0[t1] << 3 | e.exb[t1], e.ddef[t1] = e.df0[t1] << 4 | e.dxb[t1];
        pushV(e.fltree, 144, 8), pushV(e.fltree, 112, 9), pushV(e.fltree, 24, 7), pushV(e.fltree, 8, 8), UZIP.F.makeCodes(e.fltree, 9), UZIP.F.codes2map(e.fltree, 9, e.flmap), UZIP.F.revCodes(e.fltree, 9), pushV(e.fdtree, 32, 5), UZIP.F.makeCodes(e.fdtree, 5), UZIP.F.codes2map(e.fdtree, 5, e.fdmap), UZIP.F.revCodes(e.fdtree, 5), pushV(e.itree, 19, 0), pushV(e.ltree, 286, 0), pushV(e.dtree, 30, 0), pushV(e.ttree, 320, 0);
    }();
}();
var $8225ba78123222c8$var$UZIP = $8225ba78123222c8$var$_mergeNamespaces({
    __proto__: null,
    default: $8225ba78123222c8$var$e
}, [
    $8225ba78123222c8$var$e
]);
const $8225ba78123222c8$var$UPNG = function() {
    var e = {
        nextZero (e, t1) {
            for(; 0 != e[t1];)t1++;
            return t1;
        },
        readUshort: (e, t1)=>e[t1] << 8 | e[t1 + 1],
        writeUshort (e, t1, r) {
            e[t1] = r >> 8 & 255, e[t1 + 1] = 255 & r;
        },
        readUint: (e, t1)=>16777216 * e[t1] + (e[t1 + 1] << 16 | e[t1 + 2] << 8 | e[t1 + 3]),
        writeUint (e, t1, r) {
            e[t1] = r >> 24 & 255, e[t1 + 1] = r >> 16 & 255, e[t1 + 2] = r >> 8 & 255, e[t1 + 3] = 255 & r;
        },
        readASCII (e, t1, r) {
            let i = "";
            for(let o = 0; o < r; o++)i += String.fromCharCode(e[t1 + o]);
            return i;
        },
        writeASCII (e, t1, r) {
            for(let i = 0; i < r.length; i++)e[t1 + i] = r.charCodeAt(i);
        },
        readBytes (e, t1, r) {
            const i = [];
            for(let o = 0; o < r; o++)i.push(e[t1 + o]);
            return i;
        },
        pad: (e)=>e.length < 2 ? `0${e}` : e,
        readUTF8 (t1, r, i) {
            let o, a = "";
            for(let o = 0; o < i; o++)a += `%${e.pad(t1[r + o].toString(16))}`;
            try {
                o = decodeURIComponent(a);
            } catch (o) {
                return e.readASCII(t1, r, i);
            }
            return o;
        }
    };
    function decodeImage(t1, r, i, o) {
        const a = r * i, s = _getBPP(o), f = Math.ceil(r * s / 8), l = new Uint8Array(4 * a), c = new Uint32Array(l.buffer), { ctype: u } = o, { depth: h } = o, d = e.readUshort;
        if (6 == u) {
            const e = a << 2;
            if (8 == h) for(var A = 0; A < e; A += 4)l[A] = t1[A], l[A + 1] = t1[A + 1], l[A + 2] = t1[A + 2], l[A + 3] = t1[A + 3];
            if (16 == h) for(A = 0; A < e; A++)l[A] = t1[A << 1];
        } else if (2 == u) {
            const e = o.tabs.tRNS;
            if (null == e) {
                if (8 == h) for(A = 0; A < a; A++){
                    var g = 3 * A;
                    c[A] = -16777216 | t1[g + 2] << 16 | t1[g + 1] << 8 | t1[g];
                }
                if (16 == h) for(A = 0; A < a; A++){
                    g = 6 * A;
                    c[A] = -16777216 | t1[g + 4] << 16 | t1[g + 2] << 8 | t1[g];
                }
            } else {
                var p = e[0];
                const r = e[1], i = e[2];
                if (8 == h) for(A = 0; A < a; A++){
                    var m = A << 2;
                    g = 3 * A;
                    c[A] = -16777216 | t1[g + 2] << 16 | t1[g + 1] << 8 | t1[g], t1[g] == p && t1[g + 1] == r && t1[g + 2] == i && (l[m + 3] = 0);
                }
                if (16 == h) for(A = 0; A < a; A++){
                    m = A << 2, g = 6 * A;
                    c[A] = -16777216 | t1[g + 4] << 16 | t1[g + 2] << 8 | t1[g], d(t1, g) == p && d(t1, g + 2) == r && d(t1, g + 4) == i && (l[m + 3] = 0);
                }
            }
        } else if (3 == u) {
            const e = o.tabs.PLTE, s = o.tabs.tRNS, c = s ? s.length : 0;
            if (1 == h) for(var w = 0; w < i; w++){
                var v = w * f, b = w * r;
                for(A = 0; A < r; A++){
                    m = b + A << 2;
                    var y = 3 * (E = t1[v + (A >> 3)] >> 7 - ((7 & A) << 0) & 1);
                    l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
                }
            }
            if (2 == h) for(w = 0; w < i; w++)for(v = w * f, b = w * r, A = 0; A < r; A++){
                m = b + A << 2, y = 3 * (E = t1[v + (A >> 2)] >> 6 - ((3 & A) << 1) & 3);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
            if (4 == h) for(w = 0; w < i; w++)for(v = w * f, b = w * r, A = 0; A < r; A++){
                m = b + A << 2, y = 3 * (E = t1[v + (A >> 1)] >> 4 - ((1 & A) << 2) & 15);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
            if (8 == h) for(A = 0; A < a; A++){
                var E;
                m = A << 2, y = 3 * (E = t1[A]);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
        } else if (4 == u) {
            if (8 == h) for(A = 0; A < a; A++){
                m = A << 2;
                var F = t1[_ = A << 1];
                l[m] = F, l[m + 1] = F, l[m + 2] = F, l[m + 3] = t1[_ + 1];
            }
            if (16 == h) for(A = 0; A < a; A++){
                var _;
                m = A << 2, F = t1[_ = A << 2];
                l[m] = F, l[m + 1] = F, l[m + 2] = F, l[m + 3] = t1[_ + 2];
            }
        } else if (0 == u) for(p = o.tabs.tRNS ? o.tabs.tRNS : -1, w = 0; w < i; w++){
            const e = w * f, i = w * r;
            if (1 == h) for(var B = 0; B < r; B++){
                var U = (F = 255 * (t1[e + (B >>> 3)] >>> 7 - (7 & B) & 1)) == 255 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (2 == h) for(B = 0; B < r; B++){
                U = (F = 85 * (t1[e + (B >>> 2)] >>> 6 - ((3 & B) << 1) & 3)) == 85 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (4 == h) for(B = 0; B < r; B++){
                U = (F = 17 * (t1[e + (B >>> 1)] >>> 4 - ((1 & B) << 2) & 15)) == 17 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (8 == h) for(B = 0; B < r; B++){
                U = (F = t1[e + B]) == p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (16 == h) for(B = 0; B < r; B++){
                F = t1[e + (B << 1)], U = d(t1, e + (B << 1)) == p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
        }
        return l;
    }
    function _decompress(e, r, i, o) {
        const a = _getBPP(e), s = Math.ceil(i * a / 8), f = new Uint8Array((s + 1 + e.interlace) * o);
        return r = e.tabs.CgBI ? t1(r, f) : _inflate(r, f), 0 == e.interlace ? r = _filterZero(r, e, 0, i, o) : 1 == e.interlace && (r = function _readInterlace(e, t1) {
            const r = t1.width, i = t1.height, o = _getBPP(t1), a = o >> 3, s = Math.ceil(r * o / 8), f = new Uint8Array(i * s);
            let l = 0;
            const c = [
                0,
                0,
                4,
                0,
                2,
                0,
                1
            ], u = [
                0,
                4,
                0,
                2,
                0,
                1,
                0
            ], h = [
                8,
                8,
                8,
                4,
                4,
                2,
                2
            ], d = [
                8,
                8,
                4,
                4,
                2,
                2,
                1
            ];
            let A = 0;
            for(; A < 7;){
                const p = h[A], m = d[A];
                let w = 0, v = 0, b = c[A];
                for(; b < i;)b += p, v++;
                let y = u[A];
                for(; y < r;)y += m, w++;
                const E = Math.ceil(w * o / 8);
                _filterZero(e, t1, l, w, v);
                let F = 0, _ = c[A];
                for(; _ < i;){
                    let t1 = u[A], i = l + F * E << 3;
                    for(; t1 < r;){
                        var g;
                        if (1 == o) g = (g = e[i >> 3]) >> 7 - (7 & i) & 1, f[_ * s + (t1 >> 3)] |= g << 7 - ((7 & t1) << 0);
                        if (2 == o) g = (g = e[i >> 3]) >> 6 - (7 & i) & 3, f[_ * s + (t1 >> 2)] |= g << 6 - ((3 & t1) << 1);
                        if (4 == o) g = (g = e[i >> 3]) >> 4 - (7 & i) & 15, f[_ * s + (t1 >> 1)] |= g << 4 - ((1 & t1) << 2);
                        if (o >= 8) {
                            const r = _ * s + t1 * a;
                            for(let t1 = 0; t1 < a; t1++)f[r + t1] = e[(i >> 3) + t1];
                        }
                        i += o, t1 += m;
                    }
                    F++, _ += p;
                }
                w * v != 0 && (l += v * (1 + E)), A += 1;
            }
            return f;
        }(r, e)), r;
    }
    function _inflate(e, r) {
        return t1(new Uint8Array(e.buffer, 2, e.length - 6), r);
    }
    var t1 = function() {
        const e = {
            H: {}
        };
        return e.H.N = function(t1, r) {
            const i = Uint8Array;
            let o, a, s = 0, f = 0, l = 0, c = 0, u = 0, h = 0, d = 0, A = 0, g = 0;
            if (3 == t1[0] && 0 == t1[1]) return r || new i(0);
            const p = e.H, m = p.b, w = p.e, v = p.R, b = p.n, y = p.A, E = p.Z, F = p.m, _ = null == r;
            for(_ && (r = new i(t1.length >>> 2 << 5)); 0 == s;)if (s = m(t1, g, 1), f = m(t1, g + 1, 2), g += 3, 0 != f) {
                if (_ && (r = e.H.W(r, A + 131072)), 1 == f && (o = F.J, a = F.h, h = 511, d = 31), 2 == f) {
                    l = w(t1, g, 5) + 257, c = w(t1, g + 5, 5) + 1, u = w(t1, g + 10, 4) + 4, g += 14;
                    let e = 1;
                    for(var B = 0; B < 38; B += 2)F.Q[B] = 0, F.Q[B + 1] = 0;
                    for(B = 0; B < u; B++){
                        const r = w(t1, g + 3 * B, 3);
                        F.Q[1 + (F.X[B] << 1)] = r, r > e && (e = r);
                    }
                    g += 3 * u, b(F.Q, e), y(F.Q, e, F.u), o = F.w, a = F.d, g = v(F.u, (1 << e) - 1, l + c, t1, g, F.v);
                    const r = p.V(F.v, 0, l, F.C);
                    h = (1 << r) - 1;
                    const i = p.V(F.v, l, c, F.D);
                    d = (1 << i) - 1, b(F.C, r), y(F.C, r, o), b(F.D, i), y(F.D, i, a);
                }
                for(;;){
                    const e = o[E(t1, g) & h];
                    g += 15 & e;
                    const i = e >>> 4;
                    if (i >>> 8 == 0) r[A++] = i;
                    else {
                        if (256 == i) break;
                        {
                            let e = A + i - 254;
                            if (i > 264) {
                                const r = F.q[i - 257];
                                e = A + (r >>> 3) + w(t1, g, 7 & r), g += 7 & r;
                            }
                            const o = a[E(t1, g) & d];
                            g += 15 & o;
                            const s = o >>> 4, f = F.c[s], l = (f >>> 4) + m(t1, g, 15 & f);
                            for(g += 15 & f; A < e;)r[A] = r[A++ - l], r[A] = r[A++ - l], r[A] = r[A++ - l], r[A] = r[A++ - l];
                            A = e;
                        }
                    }
                }
            } else {
                0 != (7 & g) && (g += 8 - (7 & g));
                const o = 4 + (g >>> 3), a = t1[o - 4] | t1[o - 3] << 8;
                _ && (r = e.H.W(r, A + a)), r.set(new i(t1.buffer, t1.byteOffset + o, a), A), g = o + a << 3, A += a;
            }
            return r.length == A ? r : r.slice(0, A);
        }, e.H.W = function(e, t1) {
            const r = e.length;
            if (t1 <= r) return e;
            const i = new Uint8Array(r << 1);
            return i.set(e, 0), i;
        }, e.H.R = function(t1, r, i, o, a, s) {
            const f = e.H.e, l = e.H.Z;
            let c = 0;
            for(; c < i;){
                const e = t1[l(o, a) & r];
                a += 15 & e;
                const i = e >>> 4;
                if (i <= 15) s[c] = i, c++;
                else {
                    let e = 0, t1 = 0;
                    16 == i ? (t1 = 3 + f(o, a, 2), a += 2, e = s[c - 1]) : 17 == i ? (t1 = 3 + f(o, a, 3), a += 3) : 18 == i && (t1 = 11 + f(o, a, 7), a += 7);
                    const r = c + t1;
                    for(; c < r;)s[c] = e, c++;
                }
            }
            return a;
        }, e.H.V = function(e, t1, r, i) {
            let o = 0, a = 0;
            const s = i.length >>> 1;
            for(; a < r;){
                const r = e[a + t1];
                i[a << 1] = 0, i[1 + (a << 1)] = r, r > o && (o = r), a++;
            }
            for(; a < s;)i[a << 1] = 0, i[1 + (a << 1)] = 0, a++;
            return o;
        }, e.H.n = function(t1, r) {
            const i = e.H.m, o = t1.length;
            let a, s, f;
            let l;
            const c = i.j;
            for(var u = 0; u <= r; u++)c[u] = 0;
            for(u = 1; u < o; u += 2)c[t1[u]]++;
            const h = i.K;
            for(a = 0, c[0] = 0, s = 1; s <= r; s++)a = a + c[s - 1] << 1, h[s] = a;
            for(f = 0; f < o; f += 2)l = t1[f + 1], 0 != l && (t1[f] = h[l], h[l]++);
        }, e.H.A = function(t1, r, i) {
            const o = t1.length, a = e.H.m.r;
            for(let e = 0; e < o; e += 2)if (0 != t1[e + 1]) {
                const o = e >> 1, s = t1[e + 1], f = o << 4 | s, l = r - s;
                let c = t1[e] << l;
                const u = c + (1 << l);
                for(; c != u;)i[a[c] >>> 15 - r] = f, c++;
            }
        }, e.H.l = function(t1, r) {
            const i = e.H.m.r, o = 15 - r;
            for(let e = 0; e < t1.length; e += 2){
                const a = t1[e] << r - t1[e + 1];
                t1[e] = i[a] >>> o;
            }
        }, e.H.M = function(e, t1, r) {
            r <<= 7 & t1;
            const i = t1 >>> 3;
            e[i] |= r, e[i + 1] |= r >>> 8;
        }, e.H.I = function(e, t1, r) {
            r <<= 7 & t1;
            const i = t1 >>> 3;
            e[i] |= r, e[i + 1] |= r >>> 8, e[i + 2] |= r >>> 16;
        }, e.H.e = function(e, t1, r) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8) >>> (7 & t1) & (1 << r) - 1;
        }, e.H.b = function(e, t1, r) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1) & (1 << r) - 1;
        }, e.H.Z = function(e, t1) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1);
        }, e.H.i = function(e, t1) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16 | e[3 + (t1 >>> 3)] << 24) >>> (7 & t1);
        }, e.H.m = function() {
            const e = Uint16Array, t1 = Uint32Array;
            return {
                K: new e(16),
                j: new e(16),
                X: [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ],
                S: [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    999,
                    999,
                    999
                ],
                T: [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0,
                    0,
                    0,
                    0
                ],
                q: new e(32),
                p: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    65535,
                    65535
                ],
                z: [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13,
                    0,
                    0
                ],
                c: new t1(32),
                J: new e(512),
                _: [],
                h: new e(32),
                $: [],
                w: new e(32768),
                C: [],
                v: [],
                d: new e(32768),
                D: [],
                u: new e(512),
                Q: [],
                r: new e(32768),
                s: new t1(286),
                Y: new t1(30),
                a: new t1(19),
                t: new t1(15e3),
                k: new e(65536),
                g: new e(32768)
            };
        }(), function() {
            const t1 = e.H.m;
            for(var r = 0; r < 32768; r++){
                let e = r;
                e = (2863311530 & e) >>> 1 | (1431655765 & e) << 1, e = (3435973836 & e) >>> 2 | (858993459 & e) << 2, e = (4042322160 & e) >>> 4 | (252645135 & e) << 4, e = (4278255360 & e) >>> 8 | (16711935 & e) << 8, t1.r[r] = (e >>> 16 | e << 16) >>> 17;
            }
            function n(e, t1, r) {
                for(; 0 != t1--;)e.push(0, r);
            }
            for(r = 0; r < 32; r++)t1.q[r] = t1.S[r] << 3 | t1.T[r], t1.c[r] = t1.p[r] << 4 | t1.z[r];
            n(t1._, 144, 8), n(t1._, 112, 9), n(t1._, 24, 7), n(t1._, 8, 8), e.H.n(t1._, 9), e.H.A(t1._, 9, t1.J), e.H.l(t1._, 9), n(t1.$, 32, 5), e.H.n(t1.$, 5), e.H.A(t1.$, 5, t1.h), e.H.l(t1.$, 5), n(t1.Q, 19, 0), n(t1.C, 286, 0), n(t1.D, 30, 0), n(t1.v, 320, 0);
        }(), e.H.N;
    }();
    function _getBPP(e) {
        return [
            1,
            null,
            3,
            1,
            2,
            null,
            4
        ][e.ctype] * e.depth;
    }
    function _filterZero(e, t1, r, i, o) {
        let a = _getBPP(t1);
        const s = Math.ceil(i * a / 8);
        let f, l;
        a = Math.ceil(a / 8);
        let c = e[r], u = 0;
        if (c > 1 && (e[r] = [
            0,
            0,
            1
        ][c - 2]), 3 == c) for(u = a; u < s; u++)e[u + 1] = e[u + 1] + (e[u + 1 - a] >>> 1) & 255;
        for(let t1 = 0; t1 < o; t1++)if (f = r + t1 * s, l = f + t1 + 1, c = e[l - 1], u = 0, 0 == c) for(; u < s; u++)e[f + u] = e[l + u];
        else if (1 == c) {
            for(; u < a; u++)e[f + u] = e[l + u];
            for(; u < s; u++)e[f + u] = e[l + u] + e[f + u - a];
        } else if (2 == c) for(; u < s; u++)e[f + u] = e[l + u] + e[f + u - s];
        else if (3 == c) {
            for(; u < a; u++)e[f + u] = e[l + u] + (e[f + u - s] >>> 1);
            for(; u < s; u++)e[f + u] = e[l + u] + (e[f + u - s] + e[f + u - a] >>> 1);
        } else {
            for(; u < a; u++)e[f + u] = e[l + u] + _paeth(0, e[f + u - s], 0);
            for(; u < s; u++)e[f + u] = e[l + u] + _paeth(e[f + u - a], e[f + u - s], e[f + u - a - s]);
        }
        return e;
    }
    function _paeth(e, t1, r) {
        const i = e + t1 - r, o = i - e, a = i - t1, s = i - r;
        return o * o <= a * a && o * o <= s * s ? e : a * a <= s * s ? t1 : r;
    }
    function _IHDR(t1, r, i) {
        i.width = e.readUint(t1, r), r += 4, i.height = e.readUint(t1, r), r += 4, i.depth = t1[r], r++, i.ctype = t1[r], r++, i.compress = t1[r], r++, i.filter = t1[r], r++, i.interlace = t1[r], r++;
    }
    function _copyTile(e, t1, r, i, o, a, s, f, l) {
        const c = Math.min(t1, o), u = Math.min(r, a);
        let h = 0, d = 0;
        for(let r = 0; r < u; r++)for(let a = 0; a < c; a++)if (s >= 0 && f >= 0 ? (h = r * t1 + a << 2, d = (f + r) * o + s + a << 2) : (h = (-f + r) * t1 - s + a << 2, d = r * o + a << 2), 0 == l) i[d] = e[h], i[d + 1] = e[h + 1], i[d + 2] = e[h + 2], i[d + 3] = e[h + 3];
        else if (1 == l) {
            var A = e[h + 3] * (1 / 255), g = e[h] * A, p = e[h + 1] * A, m = e[h + 2] * A, w = i[d + 3] * (1 / 255), v = i[d] * w, b = i[d + 1] * w, y = i[d + 2] * w;
            const t1 = 1 - A, r = A + w * t1, o = 0 == r ? 0 : 1 / r;
            i[d + 3] = 255 * r, i[d + 0] = (g + v * t1) * o, i[d + 1] = (p + b * t1) * o, i[d + 2] = (m + y * t1) * o;
        } else if (2 == l) {
            A = e[h + 3], g = e[h], p = e[h + 1], m = e[h + 2], w = i[d + 3], v = i[d], b = i[d + 1], y = i[d + 2];
            A == w && g == v && p == b && m == y ? (i[d] = 0, i[d + 1] = 0, i[d + 2] = 0, i[d + 3] = 0) : (i[d] = g, i[d + 1] = p, i[d + 2] = m, i[d + 3] = A);
        } else if (3 == l) {
            A = e[h + 3], g = e[h], p = e[h + 1], m = e[h + 2], w = i[d + 3], v = i[d], b = i[d + 1], y = i[d + 2];
            if (A == w && g == v && p == b && m == y) continue;
            if (A < 220 && w > 20) return !1;
        }
        return !0;
    }
    return {
        decode: function decode(r) {
            const i = new Uint8Array(r);
            let o = 8;
            const a = e, s = a.readUshort, f = a.readUint, l = {
                tabs: {},
                frames: []
            }, c = new Uint8Array(i.length);
            let u, h = 0, d = 0;
            const A = [
                137,
                80,
                78,
                71,
                13,
                10,
                26,
                10
            ];
            for(var g = 0; g < 8; g++)if (i[g] != A[g]) throw "The input is not a PNG file!";
            for(; o < i.length;){
                const e = a.readUint(i, o);
                o += 4;
                const r = a.readASCII(i, o, 4);
                if (o += 4, "IHDR" == r) _IHDR(i, o, l);
                else if ("iCCP" == r) {
                    for(var p = o; 0 != i[p];)p++;
                    a.readASCII(i, o, p - o), i[p + 1];
                    const s = i.slice(p + 2, o + e);
                    let f = null;
                    try {
                        f = _inflate(s);
                    } catch (e) {
                        f = t1(s);
                    }
                    l.tabs[r] = f;
                } else if ("CgBI" == r) l.tabs[r] = i.slice(o, o + 4);
                else if ("IDAT" == r) {
                    for(g = 0; g < e; g++)c[h + g] = i[o + g];
                    h += e;
                } else if ("acTL" == r) l.tabs[r] = {
                    num_frames: f(i, o),
                    num_plays: f(i, o + 4)
                }, u = new Uint8Array(i.length);
                else if ("fcTL" == r) {
                    if (0 != d) (E = l.frames[l.frames.length - 1]).data = _decompress(l, u.slice(0, d), E.rect.width, E.rect.height), d = 0;
                    const e = {
                        x: f(i, o + 12),
                        y: f(i, o + 16),
                        width: f(i, o + 4),
                        height: f(i, o + 8)
                    };
                    let t1 = s(i, o + 22);
                    t1 = s(i, o + 20) / (0 == t1 ? 100 : t1);
                    const r = {
                        rect: e,
                        delay: Math.round(1e3 * t1),
                        dispose: i[o + 24],
                        blend: i[o + 25]
                    };
                    l.frames.push(r);
                } else if ("fdAT" == r) {
                    for(g = 0; g < e - 4; g++)u[d + g] = i[o + g + 4];
                    d += e - 4;
                } else if ("pHYs" == r) l.tabs[r] = [
                    a.readUint(i, o),
                    a.readUint(i, o + 4),
                    i[o + 8]
                ];
                else if ("cHRM" == r) {
                    l.tabs[r] = [];
                    for(g = 0; g < 8; g++)l.tabs[r].push(a.readUint(i, o + 4 * g));
                } else if ("tEXt" == r || "zTXt" == r) {
                    null == l.tabs[r] && (l.tabs[r] = {});
                    var m = a.nextZero(i, o), w = a.readASCII(i, o, m - o), v = o + e - m - 1;
                    if ("tEXt" == r) y = a.readASCII(i, m + 1, v);
                    else {
                        var b = _inflate(i.slice(m + 2, m + 2 + v));
                        y = a.readUTF8(b, 0, b.length);
                    }
                    l.tabs[r][w] = y;
                } else if ("iTXt" == r) {
                    null == l.tabs[r] && (l.tabs[r] = {});
                    m = 0, p = o;
                    m = a.nextZero(i, p);
                    w = a.readASCII(i, p, m - p);
                    const t1 = i[p = m + 1];
                    var y;
                    i[p + 1], p += 2, m = a.nextZero(i, p), a.readASCII(i, p, m - p), p = m + 1, m = a.nextZero(i, p), a.readUTF8(i, p, m - p);
                    v = e - ((p = m + 1) - o);
                    if (0 == t1) y = a.readUTF8(i, p, v);
                    else {
                        b = _inflate(i.slice(p, p + v));
                        y = a.readUTF8(b, 0, b.length);
                    }
                    l.tabs[r][w] = y;
                } else if ("PLTE" == r) l.tabs[r] = a.readBytes(i, o, e);
                else if ("hIST" == r) {
                    const e = l.tabs.PLTE.length / 3;
                    l.tabs[r] = [];
                    for(g = 0; g < e; g++)l.tabs[r].push(s(i, o + 2 * g));
                } else if ("tRNS" == r) 3 == l.ctype ? l.tabs[r] = a.readBytes(i, o, e) : 0 == l.ctype ? l.tabs[r] = s(i, o) : 2 == l.ctype && (l.tabs[r] = [
                    s(i, o),
                    s(i, o + 2),
                    s(i, o + 4)
                ]);
                else if ("gAMA" == r) l.tabs[r] = a.readUint(i, o) / 1e5;
                else if ("sRGB" == r) l.tabs[r] = i[o];
                else if ("bKGD" == r) 0 == l.ctype || 4 == l.ctype ? l.tabs[r] = [
                    s(i, o)
                ] : 2 == l.ctype || 6 == l.ctype ? l.tabs[r] = [
                    s(i, o),
                    s(i, o + 2),
                    s(i, o + 4)
                ] : 3 == l.ctype && (l.tabs[r] = i[o]);
                else if ("IEND" == r) break;
                o += e, a.readUint(i, o), o += 4;
            }
            var E;
            return 0 != d && ((E = l.frames[l.frames.length - 1]).data = _decompress(l, u.slice(0, d), E.rect.width, E.rect.height)), l.data = _decompress(l, c, l.width, l.height), delete l.compress, delete l.interlace, delete l.filter, l;
        },
        toRGBA8: function toRGBA8(e) {
            const t1 = e.width, r = e.height;
            if (null == e.tabs.acTL) return [
                decodeImage(e.data, t1, r, e).buffer
            ];
            const i = [];
            null == e.frames[0].data && (e.frames[0].data = e.data);
            const o = t1 * r * 4, a = new Uint8Array(o), s = new Uint8Array(o), f = new Uint8Array(o);
            for(let c = 0; c < e.frames.length; c++){
                const u = e.frames[c], h = u.rect.x, d = u.rect.y, A = u.rect.width, g = u.rect.height, p = decodeImage(u.data, A, g, e);
                if (0 != c) for(var l = 0; l < o; l++)f[l] = a[l];
                if (0 == u.blend ? _copyTile(p, A, g, a, t1, r, h, d, 0) : 1 == u.blend && _copyTile(p, A, g, a, t1, r, h, d, 1), i.push(a.buffer.slice(0)), 0 == u.dispose) ;
                else if (1 == u.dispose) _copyTile(s, A, g, a, t1, r, h, d, 0);
                else if (2 == u.dispose) for(l = 0; l < o; l++)a[l] = f[l];
            }
            return i;
        },
        _paeth: _paeth,
        _copyTile: _copyTile,
        _bin: e
    };
}();
!function() {
    const { _copyTile: e } = $8225ba78123222c8$var$UPNG, { _bin: t1 } = $8225ba78123222c8$var$UPNG, r = $8225ba78123222c8$var$UPNG._paeth;
    var i = {
        table: function() {
            const e = new Uint32Array(256);
            for(let t1 = 0; t1 < 256; t1++){
                let r = t1;
                for(let e = 0; e < 8; e++)1 & r ? r = 3988292384 ^ r >>> 1 : r >>>= 1;
                e[t1] = r;
            }
            return e;
        }(),
        update (e, t1, r, o) {
            for(let a = 0; a < o; a++)e = i.table[255 & (e ^ t1[r + a])] ^ e >>> 8;
            return e;
        },
        crc: (e, t1, r)=>4294967295 ^ i.update(4294967295, e, t1, r)
    };
    function addErr(e, t1, r, i) {
        t1[r] += e[0] * i >> 4, t1[r + 1] += e[1] * i >> 4, t1[r + 2] += e[2] * i >> 4, t1[r + 3] += e[3] * i >> 4;
    }
    function N(e) {
        return Math.max(0, Math.min(255, e));
    }
    function D(e, t1) {
        const r = e[0] - t1[0], i = e[1] - t1[1], o = e[2] - t1[2], a = e[3] - t1[3];
        return r * r + i * i + o * o + a * a;
    }
    function dither(e, t1, r, i, o, a, s) {
        null == s && (s = 1);
        const f = i.length, l = [];
        for(var c = 0; c < f; c++){
            const e = i[c];
            l.push([
                e >>> 0 & 255,
                e >>> 8 & 255,
                e >>> 16 & 255,
                e >>> 24 & 255
            ]);
        }
        for(c = 0; c < f; c++){
            let e = 4294967295;
            for(var u = 0, h = 0; h < f; h++){
                var d = D(l[c], l[h]);
                h != c && d < e && (e = d, u = h);
            }
        }
        const A = new Uint32Array(o.buffer), g = new Int16Array(t1 * r * 4), p = [
            0,
            8,
            2,
            10,
            12,
            4,
            14,
            6,
            3,
            11,
            1,
            9,
            15,
            7,
            13,
            5
        ];
        for(c = 0; c < p.length; c++)p[c] = 255 * ((p[c] + .5) / 16 - .5);
        for(let o = 0; o < r; o++)for(let w = 0; w < t1; w++){
            var m;
            c = 4 * (o * t1 + w);
            if (2 != s) m = [
                N(e[c] + g[c]),
                N(e[c + 1] + g[c + 1]),
                N(e[c + 2] + g[c + 2]),
                N(e[c + 3] + g[c + 3])
            ];
            else {
                d = p[4 * (3 & o) + (3 & w)];
                m = [
                    N(e[c] + d),
                    N(e[c + 1] + d),
                    N(e[c + 2] + d),
                    N(e[c + 3] + d)
                ];
            }
            u = 0;
            let v = 16777215;
            for(h = 0; h < f; h++){
                const e = D(m, l[h]);
                e < v && (v = e, u = h);
            }
            const b = l[u], y = [
                m[0] - b[0],
                m[1] - b[1],
                m[2] - b[2],
                m[3] - b[3]
            ];
            1 == s && (w != t1 - 1 && addErr(y, g, c + 4, 7), o != r - 1 && (0 != w && addErr(y, g, c + 4 * t1 - 4, 3), addErr(y, g, c + 4 * t1, 5), w != t1 - 1 && addErr(y, g, c + 4 * t1 + 4, 1))), a[c >> 2] = u, A[c >> 2] = i[u];
        }
    }
    function _main(e, r, o, a, s) {
        null == s && (s = {});
        const { crc: f } = i, l = t1.writeUint, c = t1.writeUshort, u = t1.writeASCII;
        let h = 8;
        const d = e.frames.length > 1;
        let A, g = !1, p = 33 + (d ? 20 : 0);
        if (null != s.sRGB && (p += 13), null != s.pHYs && (p += 21), null != s.iCCP && (A = pako.deflate(s.iCCP), p += 21 + A.length + 4), 3 == e.ctype) {
            for(var m = e.plte.length, w = 0; w < m; w++)e.plte[w] >>> 24 != 255 && (g = !0);
            p += 8 + 3 * m + 4 + (g ? 8 + 1 * m + 4 : 0);
        }
        for(var v = 0; v < e.frames.length; v++)d && (p += 38), p += (F = e.frames[v]).cimg.length + 12, 0 != v && (p += 4);
        p += 12;
        const b = new Uint8Array(p), y = [
            137,
            80,
            78,
            71,
            13,
            10,
            26,
            10
        ];
        for(w = 0; w < 8; w++)b[w] = y[w];
        if (l(b, h, 13), h += 4, u(b, h, "IHDR"), h += 4, l(b, h, r), h += 4, l(b, h, o), h += 4, b[h] = e.depth, h++, b[h] = e.ctype, h++, b[h] = 0, h++, b[h] = 0, h++, b[h] = 0, h++, l(b, h, f(b, h - 17, 17)), h += 4, null != s.sRGB && (l(b, h, 1), h += 4, u(b, h, "sRGB"), h += 4, b[h] = s.sRGB, h++, l(b, h, f(b, h - 5, 5)), h += 4), null != s.iCCP) {
            const e = 13 + A.length;
            l(b, h, e), h += 4, u(b, h, "iCCP"), h += 4, u(b, h, "ICC profile"), h += 11, h += 2, b.set(A, h), h += A.length, l(b, h, f(b, h - (e + 4), e + 4)), h += 4;
        }
        if (null != s.pHYs && (l(b, h, 9), h += 4, u(b, h, "pHYs"), h += 4, l(b, h, s.pHYs[0]), h += 4, l(b, h, s.pHYs[1]), h += 4, b[h] = s.pHYs[2], h++, l(b, h, f(b, h - 13, 13)), h += 4), d && (l(b, h, 8), h += 4, u(b, h, "acTL"), h += 4, l(b, h, e.frames.length), h += 4, l(b, h, null != s.loop ? s.loop : 0), h += 4, l(b, h, f(b, h - 12, 12)), h += 4), 3 == e.ctype) {
            l(b, h, 3 * (m = e.plte.length)), h += 4, u(b, h, "PLTE"), h += 4;
            for(w = 0; w < m; w++){
                const t1 = 3 * w, r = e.plte[w], i = 255 & r, o = r >>> 8 & 255, a = r >>> 16 & 255;
                b[h + t1 + 0] = i, b[h + t1 + 1] = o, b[h + t1 + 2] = a;
            }
            if (h += 3 * m, l(b, h, f(b, h - 3 * m - 4, 3 * m + 4)), h += 4, g) {
                l(b, h, m), h += 4, u(b, h, "tRNS"), h += 4;
                for(w = 0; w < m; w++)b[h + w] = e.plte[w] >>> 24 & 255;
                h += m, l(b, h, f(b, h - m - 4, m + 4)), h += 4;
            }
        }
        let E = 0;
        for(v = 0; v < e.frames.length; v++){
            var F = e.frames[v];
            d && (l(b, h, 26), h += 4, u(b, h, "fcTL"), h += 4, l(b, h, E++), h += 4, l(b, h, F.rect.width), h += 4, l(b, h, F.rect.height), h += 4, l(b, h, F.rect.x), h += 4, l(b, h, F.rect.y), h += 4, c(b, h, a[v]), h += 2, c(b, h, 1e3), h += 2, b[h] = F.dispose, h++, b[h] = F.blend, h++, l(b, h, f(b, h - 30, 30)), h += 4);
            const t1 = F.cimg;
            l(b, h, (m = t1.length) + (0 == v ? 0 : 4)), h += 4;
            const r = h;
            u(b, h, 0 == v ? "IDAT" : "fdAT"), h += 4, 0 != v && (l(b, h, E++), h += 4), b.set(t1, h), h += m, l(b, h, f(b, r, h - r)), h += 4;
        }
        return l(b, h, 0), h += 4, u(b, h, "IEND"), h += 4, l(b, h, f(b, h - 4, 4)), h += 4, b.buffer;
    }
    function compressPNG(e, t1, r) {
        for(let i = 0; i < e.frames.length; i++){
            const o = e.frames[i];
            o.rect.width;
            const a = o.rect.height, s = new Uint8Array(a * o.bpl + a);
            o.cimg = _filterZero(o.img, a, o.bpp, o.bpl, s, t1, r);
        }
    }
    function compress(t1, r, i, o, a) {
        const s = a[0], f = a[1], l = a[2], c = a[3], u = a[4], h = a[5];
        let d = 6, A = 8, g = 255;
        for(var p = 0; p < t1.length; p++){
            const e = new Uint8Array(t1[p]);
            for(var m = e.length, w = 0; w < m; w += 4)g &= e[w + 3];
        }
        const v = 255 != g, b = function framize(t1, r, i, o, a, s) {
            const f = [];
            for(var l = 0; l < t1.length; l++){
                const h = new Uint8Array(t1[l]), A = new Uint32Array(h.buffer);
                var c;
                let g = 0, p = 0, m = r, w = i, v = o ? 1 : 0;
                if (0 != l) {
                    const b = s || o || 1 == l || 0 != f[l - 2].dispose ? 1 : 2;
                    let y = 0, E = 1e9;
                    for(let e = 0; e < b; e++){
                        var u = new Uint8Array(t1[l - 1 - e]);
                        const o = new Uint32Array(t1[l - 1 - e]);
                        let s = r, f = i, c = -1, h = -1;
                        for(let e = 0; e < i; e++)for(let t1 = 0; t1 < r; t1++)A[d = e * r + t1] != o[d] && (t1 < s && (s = t1), t1 > c && (c = t1), e < f && (f = e), e > h && (h = e));
                        -1 == c && (s = f = c = h = 0), a && (1 == (1 & s) && s--, 1 == (1 & f) && f--);
                        const v = (c - s + 1) * (h - f + 1);
                        v < E && (E = v, y = e, g = s, p = f, m = c - s + 1, w = h - f + 1);
                    }
                    u = new Uint8Array(t1[l - 1 - y]);
                    1 == y && (f[l - 1].dispose = 2), c = new Uint8Array(m * w * 4), e(u, r, i, c, m, w, -g, -p, 0), v = e(h, r, i, c, m, w, -g, -p, 3) ? 1 : 0, 1 == v ? _prepareDiff(h, r, i, c, {
                        x: g,
                        y: p,
                        width: m,
                        height: w
                    }) : e(h, r, i, c, m, w, -g, -p, 0);
                } else c = h.slice(0);
                f.push({
                    rect: {
                        x: g,
                        y: p,
                        width: m,
                        height: w
                    },
                    img: c,
                    blend: v,
                    dispose: 0
                });
            }
            if (o) for(l = 0; l < f.length; l++){
                if (1 == (A = f[l]).blend) continue;
                const e = A.rect, o = f[l - 1].rect, s = Math.min(e.x, o.x), c = Math.min(e.y, o.y), u = {
                    x: s,
                    y: c,
                    width: Math.max(e.x + e.width, o.x + o.width) - s,
                    height: Math.max(e.y + e.height, o.y + o.height) - c
                };
                f[l - 1].dispose = 1, l - 1 != 0 && _updateFrame(t1, r, i, f, l - 1, u, a), _updateFrame(t1, r, i, f, l, u, a);
            }
            let h = 0;
            if (1 != t1.length) for(var d = 0; d < f.length; d++){
                var A;
                h += (A = f[d]).rect.width * A.rect.height;
            }
            return f;
        }(t1, r, i, s, f, l), y = {}, E = [], F = [];
        if (0 != o) {
            const e = [];
            for(w = 0; w < b.length; w++)e.push(b[w].img.buffer);
            const t1 = function concatRGBA(e) {
                let t1 = 0;
                for(var r = 0; r < e.length; r++)t1 += e[r].byteLength;
                const i = new Uint8Array(t1);
                let o = 0;
                for(r = 0; r < e.length; r++){
                    const t1 = new Uint8Array(e[r]), a = t1.length;
                    for(let e = 0; e < a; e += 4){
                        let r = t1[e], a = t1[e + 1], s = t1[e + 2];
                        const f = t1[e + 3];
                        0 == f && (r = a = s = 0), i[o + e] = r, i[o + e + 1] = a, i[o + e + 2] = s, i[o + e + 3] = f;
                    }
                    o += a;
                }
                return i.buffer;
            }(e), r = quantize(t1, o);
            for(w = 0; w < r.plte.length; w++)E.push(r.plte[w].est.rgba);
            let i = 0;
            for(w = 0; w < b.length; w++){
                const e = (B = b[w]).img.length;
                var _ = new Uint8Array(r.inds.buffer, i >> 2, e >> 2);
                F.push(_);
                const t1 = new Uint8Array(r.abuf, i, e);
                h && dither(B.img, B.rect.width, B.rect.height, E, t1, _), B.img.set(t1), i += e;
            }
        } else for(p = 0; p < b.length; p++){
            var B = b[p];
            const e = new Uint32Array(B.img.buffer);
            var U = B.rect.width;
            m = e.length, _ = new Uint8Array(m);
            F.push(_);
            for(w = 0; w < m; w++){
                const t1 = e[w];
                if (0 != w && t1 == e[w - 1]) _[w] = _[w - 1];
                else if (w > U && t1 == e[w - U]) _[w] = _[w - U];
                else {
                    let e = y[t1];
                    if (null == e && (y[t1] = e = E.length, E.push(t1), E.length >= 300)) break;
                    _[w] = e;
                }
            }
        }
        const C = E.length;
        C <= 256 && 0 == u && (A = C <= 2 ? 1 : C <= 4 ? 2 : C <= 16 ? 4 : 8, A = Math.max(A, c));
        for(p = 0; p < b.length; p++){
            (B = b[p]).rect.x, B.rect.y;
            U = B.rect.width;
            const e = B.rect.height;
            let t1 = B.img;
            new Uint32Array(t1.buffer);
            let r = 4 * U, i = 4;
            if (C <= 256 && 0 == u) {
                r = Math.ceil(A * U / 8);
                var I = new Uint8Array(r * e);
                const o = F[p];
                for(let t1 = 0; t1 < e; t1++){
                    w = t1 * r;
                    const e = t1 * U;
                    if (8 == A) for(var Q = 0; Q < U; Q++)I[w + Q] = o[e + Q];
                    else if (4 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 1)] |= o[e + Q] << 4 - 4 * (1 & Q);
                    else if (2 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 2)] |= o[e + Q] << 6 - 2 * (3 & Q);
                    else if (1 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 3)] |= o[e + Q] << 7 - 1 * (7 & Q);
                }
                t1 = I, d = 3, i = 1;
            } else if (0 == v && 1 == b.length) {
                I = new Uint8Array(U * e * 3);
                const o = U * e;
                for(w = 0; w < o; w++){
                    const e = 3 * w, r = 4 * w;
                    I[e] = t1[r], I[e + 1] = t1[r + 1], I[e + 2] = t1[r + 2];
                }
                t1 = I, d = 2, i = 3, r = 3 * U;
            }
            B.img = t1, B.bpl = r, B.bpp = i;
        }
        return {
            ctype: d,
            depth: A,
            plte: E,
            frames: b
        };
    }
    function _updateFrame(t1, r, i, o, a, s, f) {
        const l = Uint8Array, c = Uint32Array, u = new l(t1[a - 1]), h = new c(t1[a - 1]), d = a + 1 < t1.length ? new l(t1[a + 1]) : null, A = new l(t1[a]), g = new c(A.buffer);
        let p = r, m = i, w = -1, v = -1;
        for(let e = 0; e < s.height; e++)for(let t1 = 0; t1 < s.width; t1++){
            const i = s.x + t1, f = s.y + e, l = f * r + i, c = g[l];
            0 == c || 0 == o[a - 1].dispose && h[l] == c && (null == d || 0 != d[4 * l + 3]) || (i < p && (p = i), i > w && (w = i), f < m && (m = f), f > v && (v = f));
        }
        -1 == w && (p = m = w = v = 0), f && (1 == (1 & p) && p--, 1 == (1 & m) && m--), s = {
            x: p,
            y: m,
            width: w - p + 1,
            height: v - m + 1
        };
        const b = o[a];
        b.rect = s, b.blend = 1, b.img = new Uint8Array(s.width * s.height * 4), 0 == o[a - 1].dispose ? (e(u, r, i, b.img, s.width, s.height, -s.x, -s.y, 0), _prepareDiff(A, r, i, b.img, s)) : e(A, r, i, b.img, s.width, s.height, -s.x, -s.y, 0);
    }
    function _prepareDiff(t1, r, i, o, a) {
        e(t1, r, i, o, a.width, a.height, -a.x, -a.y, 2);
    }
    function _filterZero(e, t1, r, i, o, a, s) {
        const f = [];
        let l, c = [
            0,
            1,
            2,
            3,
            4
        ];
        -1 != a ? c = [
            a
        ] : (t1 * i > 5e5 || 1 == r) && (c = [
            0
        ]), s && (l = {
            level: 0
        });
        const u = $8225ba78123222c8$var$UZIP;
        for(var h = 0; h < c.length; h++){
            for(let a = 0; a < t1; a++)_filterLine(o, e, a, i, r, c[h]);
            f.push(u.deflate(o, l));
        }
        let d, A = 1e9;
        for(h = 0; h < f.length; h++)f[h].length < A && (d = h, A = f[h].length);
        return f[d];
    }
    function _filterLine(e, t1, i, o, a, s) {
        const f = i * o;
        let l = f + i;
        if (e[l] = s, l++, 0 == s) {
            if (o < 500) for(var c = 0; c < o; c++)e[l + c] = t1[f + c];
            else e.set(new Uint8Array(t1.buffer, f, o), l);
        } else if (1 == s) {
            for(c = 0; c < a; c++)e[l + c] = t1[f + c];
            for(c = a; c < o; c++)e[l + c] = t1[f + c] - t1[f + c - a] + 256 & 255;
        } else if (0 == i) {
            for(c = 0; c < a; c++)e[l + c] = t1[f + c];
            if (2 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c];
            if (3 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c] - (t1[f + c - a] >> 1) + 256 & 255;
            if (4 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c] - r(t1[f + c - a], 0, 0) + 256 & 255;
        } else {
            if (2 == s) for(c = 0; c < o; c++)e[l + c] = t1[f + c] + 256 - t1[f + c - o] & 255;
            if (3 == s) {
                for(c = 0; c < a; c++)e[l + c] = t1[f + c] + 256 - (t1[f + c - o] >> 1) & 255;
                for(c = a; c < o; c++)e[l + c] = t1[f + c] + 256 - (t1[f + c - o] + t1[f + c - a] >> 1) & 255;
            }
            if (4 == s) {
                for(c = 0; c < a; c++)e[l + c] = t1[f + c] + 256 - r(0, t1[f + c - o], 0) & 255;
                for(c = a; c < o; c++)e[l + c] = t1[f + c] + 256 - r(t1[f + c - a], t1[f + c - o], t1[f + c - a - o]) & 255;
            }
        }
    }
    function quantize(e, t1) {
        const r = new Uint8Array(e), i = r.slice(0), o = new Uint32Array(i.buffer), a = getKDtree(i, t1), s = a[0], f = a[1], l = r.length, c = new Uint8Array(l >> 2);
        let u;
        if (r.length < 2e7) for(var h = 0; h < l; h += 4)u = getNearest(s, d = r[h] * (1 / 255), A = r[h + 1] * (1 / 255), g = r[h + 2] * (1 / 255), p = r[h + 3] * (1 / 255)), c[h >> 2] = u.ind, o[h >> 2] = u.est.rgba;
        else for(h = 0; h < l; h += 4){
            var d = r[h] * (1 / 255), A = r[h + 1] * (1 / 255), g = r[h + 2] * (1 / 255), p = r[h + 3] * (1 / 255);
            for(u = s; u.left;)u = planeDst(u.est, d, A, g, p) <= 0 ? u.left : u.right;
            c[h >> 2] = u.ind, o[h >> 2] = u.est.rgba;
        }
        return {
            abuf: i.buffer,
            inds: c,
            plte: f
        };
    }
    function getKDtree(e, t1, r) {
        null == r && (r = 1e-4);
        const i = new Uint32Array(e.buffer), o = {
            i0: 0,
            i1: e.length,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        o.bst = stats(e, o.i0, o.i1), o.est = estats(o.bst);
        const a = [
            o
        ];
        for(; a.length < t1;){
            let t1 = 0, o = 0;
            for(var s = 0; s < a.length; s++)a[s].est.L > t1 && (t1 = a[s].est.L, o = s);
            if (t1 < r) break;
            const f = a[o], l = splitPixels(e, i, f.i0, f.i1, f.est.e, f.est.eMq255);
            if (f.i0 >= l || f.i1 <= l) {
                f.est.L = 0;
                continue;
            }
            const c = {
                i0: f.i0,
                i1: l,
                bst: null,
                est: null,
                tdst: 0,
                left: null,
                right: null
            };
            c.bst = stats(e, c.i0, c.i1), c.est = estats(c.bst);
            const u = {
                i0: l,
                i1: f.i1,
                bst: null,
                est: null,
                tdst: 0,
                left: null,
                right: null
            };
            u.bst = {
                R: [],
                m: [],
                N: f.bst.N - c.bst.N
            };
            for(s = 0; s < 16; s++)u.bst.R[s] = f.bst.R[s] - c.bst.R[s];
            for(s = 0; s < 4; s++)u.bst.m[s] = f.bst.m[s] - c.bst.m[s];
            u.est = estats(u.bst), f.left = c, f.right = u, a[o] = c, a.push(u);
        }
        a.sort((e, t1)=>t1.bst.N - e.bst.N);
        for(s = 0; s < a.length; s++)a[s].ind = s;
        return [
            o,
            a
        ];
    }
    function getNearest(e, t1, r, i, o) {
        if (null == e.left) return e.tdst = function dist(e, t1, r, i, o) {
            const a = t1 - e[0], s = r - e[1], f = i - e[2], l = o - e[3];
            return a * a + s * s + f * f + l * l;
        }(e.est.q, t1, r, i, o), e;
        const a = planeDst(e.est, t1, r, i, o);
        let s = e.left, f = e.right;
        a > 0 && (s = e.right, f = e.left);
        const l = getNearest(s, t1, r, i, o);
        if (l.tdst <= a * a) return l;
        const c = getNearest(f, t1, r, i, o);
        return c.tdst < l.tdst ? c : l;
    }
    function planeDst(e, t1, r, i, o) {
        const { e: a } = e;
        return a[0] * t1 + a[1] * r + a[2] * i + a[3] * o - e.eMq;
    }
    function splitPixels(e, t1, r, i, o, a) {
        for(i -= 4; r < i;){
            for(; vecDot(e, r, o) <= a;)r += 4;
            for(; vecDot(e, i, o) > a;)i -= 4;
            if (r >= i) break;
            const s = t1[r >> 2];
            t1[r >> 2] = t1[i >> 2], t1[i >> 2] = s, r += 4, i -= 4;
        }
        for(; vecDot(e, r, o) > a;)r -= 4;
        return r + 4;
    }
    function vecDot(e, t1, r) {
        return e[t1] * r[0] + e[t1 + 1] * r[1] + e[t1 + 2] * r[2] + e[t1 + 3] * r[3];
    }
    function stats(e, t1, r) {
        const i = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], o = [
            0,
            0,
            0,
            0
        ], a = r - t1 >> 2;
        for(let a = t1; a < r; a += 4){
            const t1 = e[a] * (1 / 255), r = e[a + 1] * (1 / 255), s = e[a + 2] * (1 / 255), f = e[a + 3] * (1 / 255);
            o[0] += t1, o[1] += r, o[2] += s, o[3] += f, i[0] += t1 * t1, i[1] += t1 * r, i[2] += t1 * s, i[3] += t1 * f, i[5] += r * r, i[6] += r * s, i[7] += r * f, i[10] += s * s, i[11] += s * f, i[15] += f * f;
        }
        return i[4] = i[1], i[8] = i[2], i[9] = i[6], i[12] = i[3], i[13] = i[7], i[14] = i[11], {
            R: i,
            m: o,
            N: a
        };
    }
    function estats(e) {
        const { R: t1 } = e, { m: r } = e, { N: i } = e, a = r[0], s = r[1], f = r[2], l = r[3], c = 0 == i ? 0 : 1 / i, u = [
            t1[0] - a * a * c,
            t1[1] - a * s * c,
            t1[2] - a * f * c,
            t1[3] - a * l * c,
            t1[4] - s * a * c,
            t1[5] - s * s * c,
            t1[6] - s * f * c,
            t1[7] - s * l * c,
            t1[8] - f * a * c,
            t1[9] - f * s * c,
            t1[10] - f * f * c,
            t1[11] - f * l * c,
            t1[12] - l * a * c,
            t1[13] - l * s * c,
            t1[14] - l * f * c,
            t1[15] - l * l * c
        ], h = u, d = o;
        let A = [
            Math.random(),
            Math.random(),
            Math.random(),
            Math.random()
        ], g = 0, p = 0;
        if (0 != i) for(let e = 0; e < 16 && (A = d.multVec(h, A), p = Math.sqrt(d.dot(A, A)), A = d.sml(1 / p, A), !(0 != e && Math.abs(p - g) < 1e-9)); e++)g = p;
        const m = [
            a * c,
            s * c,
            f * c,
            l * c
        ];
        return {
            Cov: u,
            q: m,
            e: A,
            L: g,
            eMq255: d.dot(d.sml(255, m), A),
            eMq: d.dot(A, m),
            rgba: (Math.round(255 * m[3]) << 24 | Math.round(255 * m[2]) << 16 | Math.round(255 * m[1]) << 8 | Math.round(255 * m[0]) << 0) >>> 0
        };
    }
    var o = {
        multVec: (e, t1)=>[
                e[0] * t1[0] + e[1] * t1[1] + e[2] * t1[2] + e[3] * t1[3],
                e[4] * t1[0] + e[5] * t1[1] + e[6] * t1[2] + e[7] * t1[3],
                e[8] * t1[0] + e[9] * t1[1] + e[10] * t1[2] + e[11] * t1[3],
                e[12] * t1[0] + e[13] * t1[1] + e[14] * t1[2] + e[15] * t1[3]
            ],
        dot: (e, t1)=>e[0] * t1[0] + e[1] * t1[1] + e[2] * t1[2] + e[3] * t1[3],
        sml: (e, t1)=>[
                e * t1[0],
                e * t1[1],
                e * t1[2],
                e * t1[3]
            ]
    };
    $8225ba78123222c8$var$UPNG.encode = function encode(e, t1, r, i, o, a, s) {
        null == i && (i = 0), null == s && (s = !1);
        const f = compress(e, t1, r, i, [
            !1,
            !1,
            !1,
            0,
            s,
            !1
        ]);
        return compressPNG(f, -1), _main(f, t1, r, o, a);
    }, $8225ba78123222c8$var$UPNG.encodeLL = function encodeLL(e, t1, r, i, o, a, s, f) {
        const l = {
            ctype: 0 + (1 == i ? 0 : 2) + (0 == o ? 0 : 4),
            depth: a,
            frames: []
        }, c = (i + o) * a, u = c * t1;
        for(let i = 0; i < e.length; i++)l.frames.push({
            rect: {
                x: 0,
                y: 0,
                width: t1,
                height: r
            },
            img: new Uint8Array(e[i]),
            blend: 0,
            dispose: 1,
            bpp: Math.ceil(c / 8),
            bpl: Math.ceil(u / 8)
        });
        return compressPNG(l, 0, !0), _main(l, t1, r, s, f);
    }, $8225ba78123222c8$var$UPNG.encode.compress = compress, $8225ba78123222c8$var$UPNG.encode.dither = dither, $8225ba78123222c8$var$UPNG.quantize = quantize, $8225ba78123222c8$var$UPNG.quantize.getKDtree = getKDtree, $8225ba78123222c8$var$UPNG.quantize.getNearest = getNearest;
}();
const $8225ba78123222c8$var$r = {
    toArrayBuffer (e, t1) {
        const i = e.width, o = e.height, a = i << 2, s = e.getContext("2d").getImageData(0, 0, i, o), f = new Uint32Array(s.data.buffer), l = (32 * i + 31) / 32 << 2, c = l * o, u = 122 + c, h = new ArrayBuffer(u), d = new DataView(h), A = 1048576;
        let g, p, m, w, v = A, b = 0, y = 0, E = 0;
        function set16(e) {
            d.setUint16(y, e, !0), y += 2;
        }
        function set32(e) {
            d.setUint32(y, e, !0), y += 4;
        }
        function seek(e) {
            y += e;
        }
        set16(19778), set32(u), seek(4), set32(122), set32(108), set32(i), set32(-o >>> 0), set16(1), set16(32), set32(3), set32(c), set32(2835), set32(2835), seek(8), set32(16711680), set32(65280), set32(255), set32(4278190080), set32(1466527264), function convert() {
            for(; b < o && v > 0;){
                for(w = 122 + b * l, g = 0; g < a;)v--, p = f[E++], m = p >>> 24, d.setUint32(w + g, p << 8 | m), g += 4;
                b++;
            }
            E < f.length ? (v = A, setTimeout(convert, $8225ba78123222c8$var$r._dly)) : t1(h);
        }();
    },
    toBlob (e, t1) {
        this.toArrayBuffer(e, (e)=>{
            t1(new Blob([
                e
            ], {
                type: "image/bmp"
            }));
        });
    },
    _dly: 9
};
var $8225ba78123222c8$var$i = {
    CHROME: "CHROME",
    FIREFOX: "FIREFOX",
    DESKTOP_SAFARI: "DESKTOP_SAFARI",
    IE: "IE",
    IOS: "IOS",
    ETC: "ETC"
}, $8225ba78123222c8$var$o = {
    [$8225ba78123222c8$var$i.CHROME]: 16384,
    [$8225ba78123222c8$var$i.FIREFOX]: 11180,
    [$8225ba78123222c8$var$i.DESKTOP_SAFARI]: 16384,
    [$8225ba78123222c8$var$i.IE]: 8192,
    [$8225ba78123222c8$var$i.IOS]: 4096,
    [$8225ba78123222c8$var$i.ETC]: 8192
};
const $8225ba78123222c8$var$a = "undefined" != typeof window, $8225ba78123222c8$var$s = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope, $8225ba78123222c8$var$f = $8225ba78123222c8$var$a && window.cordova && window.cordova.require && window.cordova.require("cordova/modulemapper"), $8225ba78123222c8$var$CustomFile = ($8225ba78123222c8$var$a || $8225ba78123222c8$var$s) && ($8225ba78123222c8$var$f && $8225ba78123222c8$var$f.getOriginalSymbol(window, "File") || "undefined" != typeof File && File), $8225ba78123222c8$var$CustomFileReader = ($8225ba78123222c8$var$a || $8225ba78123222c8$var$s) && ($8225ba78123222c8$var$f && $8225ba78123222c8$var$f.getOriginalSymbol(window, "FileReader") || "undefined" != typeof FileReader && FileReader);
function $8225ba78123222c8$var$getFilefromDataUrl(e, t1, r = Date.now()) {
    return new Promise((i)=>{
        const o = e.split(","), a = o[0].match(/:(.*?);/)[1], s = globalThis.atob(o[1]);
        let f = s.length;
        const l = new Uint8Array(f);
        for(; f--;)l[f] = s.charCodeAt(f);
        const c = new Blob([
            l
        ], {
            type: a
        });
        c.name = t1, c.lastModified = r, i(c);
    });
}
function $8225ba78123222c8$var$getDataUrlFromFile(e) {
    return new Promise((t1, r)=>{
        const i = new $8225ba78123222c8$var$CustomFileReader;
        i.onload = ()=>t1(i.result), i.onerror = (e)=>r(e), i.readAsDataURL(e);
    });
}
function $8225ba78123222c8$var$loadImage(e) {
    return new Promise((t1, r)=>{
        const i = new Image;
        i.onload = ()=>t1(i), i.onerror = (e)=>r(e), i.src = e;
    });
}
function $8225ba78123222c8$var$getBrowserName() {
    if (void 0 !== $8225ba78123222c8$var$getBrowserName.cachedResult) return $8225ba78123222c8$var$getBrowserName.cachedResult;
    let e = $8225ba78123222c8$var$i.ETC;
    const { userAgent: t1 } = navigator;
    return /Chrom(e|ium)/i.test(t1) ? e = $8225ba78123222c8$var$i.CHROME : /iP(ad|od|hone)/i.test(t1) && /WebKit/i.test(t1) ? e = $8225ba78123222c8$var$i.IOS : /Safari/i.test(t1) ? e = $8225ba78123222c8$var$i.DESKTOP_SAFARI : /Firefox/i.test(t1) ? e = $8225ba78123222c8$var$i.FIREFOX : (/MSIE/i.test(t1) || !0 == !!document.documentMode) && (e = $8225ba78123222c8$var$i.IE), $8225ba78123222c8$var$getBrowserName.cachedResult = e, $8225ba78123222c8$var$getBrowserName.cachedResult;
}
function $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser(e, t1) {
    const r = $8225ba78123222c8$var$getBrowserName(), i = $8225ba78123222c8$var$o[r];
    let a = e, s = t1, f = a * s;
    const l = a > s ? s / a : a / s;
    for(; f > i * i;){
        const e = (i + a) / 2, t1 = (i + s) / 2;
        e < t1 ? (s = t1, a = t1 * l) : (s = e * l, a = e), f = a * s;
    }
    return {
        width: a,
        height: s
    };
}
function $8225ba78123222c8$var$getNewCanvasAndCtx(e, t1) {
    let r, i;
    try {
        if (r = new OffscreenCanvas(e, t1), i = r.getContext("2d"), null === i) throw new Error("getContext of OffscreenCanvas returns null");
    } catch (e) {
        r = document.createElement("canvas"), i = r.getContext("2d");
    }
    return r.width = e, r.height = t1, [
        r,
        i
    ];
}
function $8225ba78123222c8$var$drawImageInCanvas(e, t1) {
    const { width: r, height: i } = $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser(e.width, e.height), [o, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i);
    return t1 && /jpe?g/.test(t1) && (a.fillStyle = "white", a.fillRect(0, 0, o.width, o.height)), a.drawImage(e, 0, 0, o.width, o.height), o;
}
function $8225ba78123222c8$var$isIOS() {
    return void 0 !== $8225ba78123222c8$var$isIOS.cachedResult || ($8225ba78123222c8$var$isIOS.cachedResult = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "undefined" != typeof document && "ontouchend" in document), $8225ba78123222c8$var$isIOS.cachedResult;
}
function $8225ba78123222c8$var$drawFileInCanvas(e, t1 = {}) {
    return new Promise(function(r, o) {
        let a, s;
        var $Try_2_Post = function() {
            try {
                return s = $8225ba78123222c8$var$drawImageInCanvas(a, t1.fileType || e.type), r([
                    a,
                    s
                ]);
            } catch (e) {
                return o(e);
            }
        }, $Try_2_Catch = function(t1) {
            try {
                var $Try_3_Catch = function(e) {
                    try {
                        throw e;
                    } catch (e) {
                        return o(e);
                    }
                };
                try {
                    let t1;
                    return $8225ba78123222c8$var$getDataUrlFromFile(e).then(function(e) {
                        try {
                            return t1 = e, $8225ba78123222c8$var$loadImage(t1).then(function(e) {
                                try {
                                    return a = e, function() {
                                        try {
                                            return $Try_2_Post();
                                        } catch (e) {
                                            return o(e);
                                        }
                                    }();
                                } catch (e) {
                                    return $Try_3_Catch(e);
                                }
                            }, $Try_3_Catch);
                        } catch (e) {
                            return $Try_3_Catch(e);
                        }
                    }, $Try_3_Catch);
                } catch (e) {
                    $Try_3_Catch(e);
                }
            } catch (e) {
                return o(e);
            }
        };
        try {
            if ($8225ba78123222c8$var$isIOS() || [
                $8225ba78123222c8$var$i.DESKTOP_SAFARI,
                $8225ba78123222c8$var$i.MOBILE_SAFARI
            ].includes($8225ba78123222c8$var$getBrowserName())) throw new Error("Skip createImageBitmap on IOS and Safari");
            return createImageBitmap(e).then(function(e) {
                try {
                    return a = e, $Try_2_Post();
                } catch (e) {
                    return $Try_2_Catch();
                }
            }, $Try_2_Catch);
        } catch (e) {
            $Try_2_Catch();
        }
    });
}
function $8225ba78123222c8$var$canvasToFile(e, t1, i, o, a = 1) {
    return new Promise(function(s, f) {
        let l;
        if ("image/png" === t1) {
            let c, u, h;
            return c = e.getContext("2d"), { data: u } = c.getImageData(0, 0, e.width, e.height), h = $8225ba78123222c8$var$UPNG.encode([
                u.buffer
            ], e.width, e.height, 4096 * a), l = new Blob([
                h
            ], {
                type: t1
            }), l.name = i, l.lastModified = o, $If_4.call(this);
        }
        {
            if ("image/bmp" === t1) return new Promise((t1)=>$8225ba78123222c8$var$r.toBlob(e, t1)).then((function(e) {
                try {
                    return l = e, l.name = i, l.lastModified = o, $If_5.call(this);
                } catch (e) {
                    return f(e);
                }
            }).bind(this), f);
            {
                if ("function" == typeof OffscreenCanvas && e instanceof OffscreenCanvas) return e.convertToBlob({
                    type: t1,
                    quality: a
                }).then((function(e) {
                    try {
                        return l = e, l.name = i, l.lastModified = o, $If_6.call(this);
                    } catch (e) {
                        return f(e);
                    }
                }).bind(this), f);
                {
                    let d;
                    return d = e.toDataURL(t1, a), $8225ba78123222c8$var$getFilefromDataUrl(d, i, o).then((function(e) {
                        try {
                            return l = e, $If_6.call(this);
                        } catch (e) {
                            return f(e);
                        }
                    }).bind(this), f);
                }
                function $If_6() {
                    return $If_5.call(this);
                }
            }
            function $If_5() {
                return $If_4.call(this);
            }
        }
        function $If_4() {
            return s(l);
        }
    });
}
function $8225ba78123222c8$var$cleanupCanvasMemory(e) {
    e.width = 0, e.height = 0;
}
function $8225ba78123222c8$var$isAutoOrientationInBrowser() {
    return new Promise(function(e, t1) {
        let r, i, o, a, s;
        return void 0 !== $8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult ? e($8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult) : (r = "data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", $8225ba78123222c8$var$getFilefromDataUrl("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", "test.jpg", Date.now()).then(function(r) {
            try {
                return i = r, $8225ba78123222c8$var$drawFileInCanvas(i).then(function(r) {
                    try {
                        return o = r[1], $8225ba78123222c8$var$canvasToFile(o, i.type, i.name, i.lastModified).then(function(r) {
                            try {
                                return a = r, $8225ba78123222c8$var$cleanupCanvasMemory(o), $8225ba78123222c8$var$drawFileInCanvas(a).then(function(r) {
                                    try {
                                        return s = r[0], $8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult = 1 === s.width && 2 === s.height, e($8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult);
                                    } catch (e) {
                                        return t1(e);
                                    }
                                }, t1);
                            } catch (e) {
                                return t1(e);
                            }
                        }, t1);
                    } catch (e) {
                        return t1(e);
                    }
                }, t1);
            } catch (e) {
                return t1(e);
            }
        }, t1));
    });
}
function $8225ba78123222c8$var$getExifOrientation(e) {
    return new Promise((t1, r)=>{
        const i = new $8225ba78123222c8$var$CustomFileReader;
        i.onload = (e)=>{
            const r = new DataView(e.target.result);
            if (65496 != r.getUint16(0, !1)) return t1(-2);
            const i = r.byteLength;
            let o = 2;
            for(; o < i;){
                if (r.getUint16(o + 2, !1) <= 8) return t1(-1);
                const e = r.getUint16(o, !1);
                if (o += 2, 65505 == e) {
                    if (1165519206 != r.getUint32(o += 2, !1)) return t1(-1);
                    const e = 18761 == r.getUint16(o += 6, !1);
                    o += r.getUint32(o + 4, e);
                    const i = r.getUint16(o, e);
                    o += 2;
                    for(let a = 0; a < i; a++)if (274 == r.getUint16(o + 12 * a, e)) return t1(r.getUint16(o + 12 * a + 8, e));
                } else {
                    if (65280 != (65280 & e)) break;
                    o += r.getUint16(o, !1);
                }
            }
            return t1(-1);
        }, i.onerror = (e)=>r(e), i.readAsArrayBuffer(e);
    });
}
function $8225ba78123222c8$var$handleMaxWidthOrHeight(e, t1) {
    const { width: r } = e, { height: i } = e, { maxWidthOrHeight: o } = t1;
    let a, s = e;
    return isFinite(o) && (r > o || i > o) && ([s, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i), r > i ? (s.width = o, s.height = i / r * o) : (s.width = r / i * o, s.height = o), a.drawImage(e, 0, 0, s.width, s.height), $8225ba78123222c8$var$cleanupCanvasMemory(e)), s;
}
function $8225ba78123222c8$var$followExifOrientation(e, t1) {
    const { width: r } = e, { height: i } = e, [o, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i);
    switch(t1 > 4 && t1 < 9 ? (o.width = i, o.height = r) : (o.width = r, o.height = i), t1){
        case 2:
            a.transform(-1, 0, 0, 1, r, 0);
            break;
        case 3:
            a.transform(-1, 0, 0, -1, r, i);
            break;
        case 4:
            a.transform(1, 0, 0, -1, 0, i);
            break;
        case 5:
            a.transform(0, 1, 1, 0, 0, 0);
            break;
        case 6:
            a.transform(0, 1, -1, 0, i, 0);
            break;
        case 7:
            a.transform(0, -1, -1, 0, i, r);
            break;
        case 8:
            a.transform(0, -1, 1, 0, 0, r);
    }
    return a.drawImage(e, 0, 0, r, i), $8225ba78123222c8$var$cleanupCanvasMemory(e), o;
}
function $8225ba78123222c8$var$compress(e, t1, r = 0) {
    return new Promise(function(i, o) {
        let a, s, f, l, c, u, h, d, A, g, p, m, w, v, b, y, E, F, _, B;
        function incProgress(e = 5) {
            if (t1.signal && t1.signal.aborted) throw t1.signal.reason;
            a += e, t1.onProgress(Math.min(a, 100));
        }
        function setProgress(e) {
            if (t1.signal && t1.signal.aborted) throw t1.signal.reason;
            a = Math.min(Math.max(e, a), 100), t1.onProgress(a);
        }
        return a = r, s = t1.maxIteration || 10, f = 1024 * t1.maxSizeMB * 1024, incProgress(), $8225ba78123222c8$var$drawFileInCanvas(e, t1).then((function(r) {
            try {
                return [, l] = r, incProgress(), c = $8225ba78123222c8$var$handleMaxWidthOrHeight(l, t1), incProgress(), new Promise(function(r, i) {
                    var o;
                    if (!(o = t1.exifOrientation)) return $8225ba78123222c8$var$getExifOrientation(e).then((function(e) {
                        try {
                            return o = e, $If_2.call(this);
                        } catch (e) {
                            return i(e);
                        }
                    }).bind(this), i);
                    function $If_2() {
                        return r(o);
                    }
                    return $If_2.call(this);
                }).then((function(r) {
                    try {
                        return u = r, incProgress(), $8225ba78123222c8$var$isAutoOrientationInBrowser().then((function(r) {
                            try {
                                return h = r ? c : $8225ba78123222c8$var$followExifOrientation(c, u), incProgress(), d = t1.initialQuality || 1, A = t1.fileType || e.type, $8225ba78123222c8$var$canvasToFile(h, A, e.name, e.lastModified, d).then((function(r) {
                                    try {
                                        {
                                            if (g = r, incProgress(), p = g.size > f, m = g.size > e.size, !p && !m) return setProgress(100), i(g);
                                            var a;
                                            function $Loop_3() {
                                                if (s-- && (b > f || b > w)) {
                                                    let t1, r;
                                                    return t1 = B ? .95 * _.width : _.width, r = B ? .95 * _.height : _.height, [E, F] = $8225ba78123222c8$var$getNewCanvasAndCtx(t1, r), F.drawImage(_, 0, 0, t1, r), d *= "image/png" === A ? .85 : .95, $8225ba78123222c8$var$canvasToFile(E, A, e.name, e.lastModified, d).then(function(e) {
                                                        try {
                                                            return y = e, $8225ba78123222c8$var$cleanupCanvasMemory(_), _ = E, b = y.size, setProgress(Math.min(99, Math.floor((v - b) / (v - f) * 100))), $Loop_3;
                                                        } catch (e) {
                                                            return o(e);
                                                        }
                                                    }, o);
                                                }
                                                return [
                                                    1
                                                ];
                                            }
                                            return w = e.size, v = g.size, b = v, _ = h, B = !t1.alwaysKeepResolution && p, (a = (function(e) {
                                                for(; e;){
                                                    if (e.then) return void e.then(a, o);
                                                    try {
                                                        if (e.pop) {
                                                            if (e.length) return e.pop() ? $Loop_3_exit.call(this) : e;
                                                            e = $Loop_3;
                                                        } else e = e.call(this);
                                                    } catch (e) {
                                                        return o(e);
                                                    }
                                                }
                                            }).bind(this))($Loop_3);
                                            function $Loop_3_exit() {
                                                return $8225ba78123222c8$var$cleanupCanvasMemory(_), $8225ba78123222c8$var$cleanupCanvasMemory(E), $8225ba78123222c8$var$cleanupCanvasMemory(c), $8225ba78123222c8$var$cleanupCanvasMemory(h), $8225ba78123222c8$var$cleanupCanvasMemory(l), setProgress(100), i(y);
                                            }
                                        }
                                    } catch (u) {
                                        return o(u);
                                    }
                                }).bind(this), o);
                            } catch (e) {
                                return o(e);
                            }
                        }).bind(this), o);
                    } catch (e) {
                        return o(e);
                    }
                }).bind(this), o);
            } catch (e) {
                return o(e);
            }
        }).bind(this), o);
    });
}
const $8225ba78123222c8$var$l = "\nlet scriptImported = false\nself.addEventListener('message', async (e) => {\n  const { file, id, imageCompressionLibUrl, options } = e.data\n  options.onProgress = (progress) => self.postMessage({ progress, id })\n  try {\n    if (!scriptImported) {\n      // console.log('[worker] importScripts', imageCompressionLibUrl)\n      self.importScripts(imageCompressionLibUrl)\n      scriptImported = true\n    }\n    // console.log('[worker] self', self)\n    const compressedFile = await imageCompression(file, options)\n    self.postMessage({ file: compressedFile, id })\n  } catch (e) {\n    // console.error('[worker] error', e)\n    self.postMessage({ error: e.message + '\\n' + e.stack, id })\n  }\n})\n";
let $8225ba78123222c8$var$c;
function $8225ba78123222c8$var$compressOnWebWorker(e, t1) {
    return new Promise((r, i)=>{
        $8225ba78123222c8$var$c || ($8225ba78123222c8$var$c = function createWorkerScriptURL(e) {
            const t1 = [];
            return "function" == typeof e ? t1.push(`(${e})()`) : t1.push(e), URL.createObjectURL(new Blob(t1));
        }($8225ba78123222c8$var$l));
        const o = new Worker($8225ba78123222c8$var$c);
        o.addEventListener("message", function handler(e) {
            if (t1.signal && t1.signal.aborted) o.terminate();
            else if (void 0 === e.data.progress) {
                if (e.data.error) return i(new Error(e.data.error)), void o.terminate();
                r(e.data.file), o.terminate();
            } else t1.onProgress(e.data.progress);
        }), o.addEventListener("error", i), t1.signal && t1.signal.addEventListener("abort", ()=>{
            i(t1.signal.reason), o.terminate();
        }), o.postMessage({
            file: e,
            imageCompressionLibUrl: t1.libURL,
            options: {
                ...t1,
                onProgress: void 0,
                signal: void 0
            }
        });
    });
}
function $8225ba78123222c8$export$2e2bcd8739ae039(e, t1) {
    return new Promise(function(r, i) {
        let o, a, s, f, l, c;
        if (o = {
            ...t1
        }, s = 0, { onProgress: f } = o, o.maxSizeMB = o.maxSizeMB || Number.POSITIVE_INFINITY, l = "boolean" != typeof o.useWebWorker || o.useWebWorker, delete o.useWebWorker, o.onProgress = (e)=>{
            s = e, "function" == typeof f && f(s);
        }, !(e instanceof Blob || e instanceof $8225ba78123222c8$var$CustomFile)) return i(new Error("The file given is not an instance of Blob or File"));
        if (!/^image/.test(e.type)) return i(new Error("The file given is not an image"));
        if (c = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope, !l || "function" != typeof Worker || c) return $8225ba78123222c8$var$compress(e, o).then((function(e) {
            try {
                return a = e, $If_4.call(this);
            } catch (e) {
                return i(e);
            }
        }).bind(this), i);
        var u = (function() {
            try {
                return $If_4.call(this);
            } catch (e) {
                return i(e);
            }
        }).bind(this), $Try_1_Catch = function(t1) {
            try {
                return $8225ba78123222c8$var$compress(e, o).then(function(e) {
                    try {
                        return a = e, u();
                    } catch (e) {
                        return i(e);
                    }
                }, i);
            } catch (e) {
                return i(e);
            }
        };
        try {
            return o.libURL = o.libURL || "https://cdn.jsdelivr.net/npm/browser-image-compression@2.0.2/dist/browser-image-compression.js", $8225ba78123222c8$var$compressOnWebWorker(e, o).then(function(e) {
                try {
                    return a = e, u();
                } catch (e) {
                    return $Try_1_Catch();
                }
            }, $Try_1_Catch);
        } catch (e) {
            $Try_1_Catch();
        }
        function $If_4() {
            try {
                a.name = e.name, a.lastModified = e.lastModified;
            } catch (e) {}
            try {
                o.preserveExif && "image/jpeg" === e.type && (!o.fileType || o.fileType && o.fileType === e.type) && (a = $8225ba78123222c8$var$copyExifWithoutOrientation(e, a));
            } catch (e) {}
            return r(a);
        }
    });
}
$8225ba78123222c8$export$2e2bcd8739ae039.getDataUrlFromFile = $8225ba78123222c8$var$getDataUrlFromFile, $8225ba78123222c8$export$2e2bcd8739ae039.getFilefromDataUrl = $8225ba78123222c8$var$getFilefromDataUrl, $8225ba78123222c8$export$2e2bcd8739ae039.loadImage = $8225ba78123222c8$var$loadImage, $8225ba78123222c8$export$2e2bcd8739ae039.drawImageInCanvas = $8225ba78123222c8$var$drawImageInCanvas, $8225ba78123222c8$export$2e2bcd8739ae039.drawFileInCanvas = $8225ba78123222c8$var$drawFileInCanvas, $8225ba78123222c8$export$2e2bcd8739ae039.canvasToFile = $8225ba78123222c8$var$canvasToFile, $8225ba78123222c8$export$2e2bcd8739ae039.getExifOrientation = $8225ba78123222c8$var$getExifOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.handleMaxWidthOrHeight = $8225ba78123222c8$var$handleMaxWidthOrHeight, $8225ba78123222c8$export$2e2bcd8739ae039.followExifOrientation = $8225ba78123222c8$var$followExifOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.cleanupCanvasMemory = $8225ba78123222c8$var$cleanupCanvasMemory, $8225ba78123222c8$export$2e2bcd8739ae039.isAutoOrientationInBrowser = $8225ba78123222c8$var$isAutoOrientationInBrowser, $8225ba78123222c8$export$2e2bcd8739ae039.approximateBelowMaximumCanvasSizeOfBrowser = $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser, $8225ba78123222c8$export$2e2bcd8739ae039.copyExifWithoutOrientation = $8225ba78123222c8$var$copyExifWithoutOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.getBrowserName = $8225ba78123222c8$var$getBrowserName, $8225ba78123222c8$export$2e2bcd8739ae039.version = "2.0.2";

});

parcelRegister("5PyF6", function(module, exports) {

$parcel$export(module.exports, "getCompressionUrl", () => $a2272ba6ffffab4b$export$a06eba2dfe024a55);
/**
 * API configuration for backend services
 */ 
var $lNEp2 = parcelRequire("lNEp2");
const $a2272ba6ffffab4b$export$c8422a29a076b4c0 = {
    endpoints: {
        compressImage: "/api/ramp-images/compress"
    }
};
function $a2272ba6ffffab4b$export$a06eba2dfe024a55() {
    return `${(0, $lNEp2.getTokenMakerUrl)()}${$a2272ba6ffffab4b$export$c8422a29a076b4c0.endpoints.compressImage}`;
}

});

parcelRegister("hELAN", function(module, exports) {

$parcel$export(module.exports, "compressionLogger", () => $7c52bdeed3b6cd70$export$5b5cac72f2889161);
/**
 * Centralized logging utility for image compression operations
 */ const $7c52bdeed3b6cd70$export$5b5cac72f2889161 = {
    /**
   * Log successful compression with statistics
   */ success: (originalSize, compressedSize, format, dimensions)=>{
        const savings = ((originalSize - compressedSize) / originalSize * 100).toFixed(1);
        console.log(`[Image Compression] Success\n` + `  Size: ${originalSize} \u{2192} ${compressedSize} bytes (${savings}% smaller)\n` + `  Format: ${format.toUpperCase()}` + (dimensions ? `\n  Dimensions: ${dimensions.width}x${dimensions.height}` : ""));
    },
    /**
   * Log fallback to client-side compression
   */ fallback: (error)=>{
        const message = error instanceof Error ? error.message : String(error);
        console.warn(`[Image Compression] Server compression failed, using client-side fallback`, message);
    },
    /**
   * Log compression failure
   */ error: (error)=>{
        console.error("[Image Compression] Failed:", error);
    },
    /**
   * Log client-side compression statistics
   */ clientSide: (originalSize, compressedSize)=>{
        const savings = ((originalSize - compressedSize) / originalSize * 100).toFixed(1);
        console.log(`[Client Compression] ${originalSize} \u{2192} ${compressedSize} bytes (${savings}% smaller)`);
    }
};

});



parcelRegister("bqlkg", function(module, exports) {

$parcel$export(module.exports, "CalibrationPointsList", () => $64d0d9ee60582a3c$export$fb79ed9f8e870bcc);

var $ayMG0 = parcelRequire("ayMG0");

var $1MdOk = parcelRequire("1MdOk");

var $03mUs = parcelRequire("03mUs");
var $9Lykx = parcelRequire("9Lykx");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $64d0d9ee60582a3c$export$fb79ed9f8e870bcc = ({ calibrationPoints: calibrationPoints, onDelete: onDelete, onHighlight: onHighlight })=>{
    if (calibrationPoints.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
        variant: "body2",
        color: "text.secondary",
        align: "center",
        children: "No calibration points added"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            maxHeight: 200,
            overflowY: "auto"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
            dense: true,
            sx: {
                py: 0
            },
            children: calibrationPoints.map((point)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                    onMouseEnter: ()=>onHighlight(point.id),
                    onMouseLeave: ()=>onHighlight(null),
                    sx: {
                        borderRadius: 1,
                        mb: 0.5,
                        py: 1.5,
                        px: 2,
                        border: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.paper",
                        "&:hover": {
                            backgroundColor: "action.hover",
                            borderColor: "primary.main"
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                sx: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        component: "div",
                                        variant: "caption",
                                        sx: {
                                            fontFamily: "monospace",
                                            color: "text.primary",
                                            fontSize: "0.7rem"
                                        },
                                        children: [
                                            point.latitude,
                                            ", ",
                                            point.longitude
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        component: "div",
                                        variant: "caption",
                                        color: "text.secondary",
                                        sx: {
                                            fontSize: "0.7rem"
                                        },
                                        children: [
                                            "Position: (",
                                            point.x * 100,
                                            "%, ",
                                            (point.y * 100).toFixed(1),
                                            "%)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 0.5,
                                sx: {
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    size: "small",
                                    onClick: ()=>onDelete(point.id),
                                    color: "error",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {
                                        fontSize: "small"
                                    })
                                })
                            })
                        ]
                    })
                }, point.id))
        })
    });
};

});

parcelRegister("d7yp1", function(module, exports) {

$parcel$export(module.exports, "GISImportDialog", () => $c35f18364ce2058d$export$9cec274c67496387);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $lNEp2 = parcelRequire("lNEp2");

var $ebLIv = parcelRequire("ebLIv");

var $bng5f = parcelRequire("bng5f");
const $c35f18364ce2058d$export$9cec274c67496387 = ({ open: open, onClose: onClose, onImportShapes: onImportShapes, ramp: ramp })=>{
    const [csvContent, setCsvContent] = $acw62.useState("");
    const [importedShapes, setImportedShapes] = $acw62.useState([]);
    const [hasProcessed, setHasProcessed] = $acw62.useState(false);
    const [error, setError] = $acw62.useState("");
    // Reset state when dialog opens/closes
    $acw62.useEffect(()=>{
        if (open) {
            // Reset all state when dialog opens
            setCsvContent("");
            setImportedShapes([]);
            setHasProcessed(false);
            setError("");
        }
    }, [
        open
    ]);
    const handleProcessCSV = ()=>{
        try {
            setError("");
            if (!ramp.calibration_points || ramp.calibration_points.length < 2) {
                setError("Ramp must have at least 2 calibration points to import GIS shapes");
                return;
            }
            const parsedData = (0, $bng5f.parseGISCSV)(csvContent);
            const shapes = parsedData.map((row)=>({
                    id: (0, $lNEp2.uuidv4)(),
                    label: row.ramp_label || "Imported Shape",
                    originalPolygon: row.polygon,
                    pixelPoints: (0, $bng5f.convertGISPolygonToPixels)(row.polygon, ramp.calibration_points, ramp.width, ramp.depth, 1000 // Default canvas width used by the ramp editor
                    ),
                    tags: [],
                    stroke_style: row.stroke_style || "#3c6ce9",
                    fill_style: row.fill_style || "rgba(60, 108, 233, 0.1)",
                    font_size: row.font_size || 14,
                    text: row.text || row.ramp_label || "",
                    // Optional attributes from CSV
                    type: row.type,
                    locked: row.locked,
                    line_style: row.line_style,
                    line_width: row.line_width,
                    fill_pattern: row.fill_pattern
                }));
            setImportedShapes(shapes);
            setHasProcessed(true);
        } catch (err) {
            setError(err.message || "Failed to process CSV data");
        }
    };
    const handleDownloadSample = ()=>{
        // Provide sample in TSV format (tab-separated) which is common when copying from spreadsheets
        const sampleTSV = `ramp_label	ramp_polygon	type	locked	stroke_style	line_style	line_width	fill_style	fill_pattern	text	font_size
"Hangar A"	"[[-73.70404052734375, 41.06755447387695], [-73.70372772216797, 41.0671501159668], [-73.70323181152344, 41.06735610961914], [-73.70356750488281, 41.0677604675293], [-73.70404052734375, 41.06755447387695]]"	Area	false	#FF0000	solid	2	#FF000033		Hangar A	14
"Parking Zone B"	"[[-73.70435333251953, 41.06752395629883], [-73.70458221435547, 41.06742477416992], [-73.7043228149414, 41.06711959838867], [-73.70410919189453, 41.067222595214844], [-73.70435333251953, 41.06752395629883]]"	Area	true	#00FF00	dashed	3	#00FF004D	diagonal	"Parking B"	16
"Taxiway Line"	"[[-73.70281219482422, 41.06663131713867], [-73.70298767089844, 41.06631088256836], [-73.7027359008789, 41.066226959228516], [-73.70256805419922, 41.06655502319336]]"	Line	false	#0000FF	solid	4	transparent	none	Taxiway	12
"Fuel Station"	"[[-73.70306396484375, 41.066707611083984], [-73.7032470703125, 41.0663948059082], [-73.70298767089844, 41.06631088256836], [-73.70281219482422, 41.06663131713867]]"	Area	false	#FFFF00	dotted	1	#FFFF0026	solid	"Fuel"	18`;
        const blob = new Blob([
            sampleTSV
        ], {
            type: "text/tab-separated-values;charset=utf-8;"
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "gis_shapes_sample.tsv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleImport = ()=>{
        const shapes = importedShapes.map((gisShape)=>({
                id: gisShape.id,
                fbo_id: ramp.fbo_id,
                ramp_id: ramp.id,
                tags: gisShape.tags,
                points: gisShape.pixelPoints,
                type: gisShape.type || "Area",
                locked: gisShape.locked ?? false,
                stroke_style: gisShape.stroke_style,
                line_style: gisShape.line_style || "solid",
                line_width: gisShape.line_width ?? 2,
                fill_style: gisShape.fill_style,
                fill_pattern: gisShape.fill_pattern,
                text: gisShape.text,
                font_size: gisShape.font_size,
                reference_image_height: null
            }));
        onImportShapes(shapes);
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "lg",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: "Import GIS Shapes"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 3,
                    sx: {
                        minHeight: 400
                    },
                    children: !hasProcessed ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle1",
                                        children: "CSV Format Requirements"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "body2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: "Delimiter:"
                                                    }),
                                                    " Comma (,) or Tab (\\t)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "body2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: "Required columns:"
                                                    }),
                                                    " ramp_label, ramp_polygon"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "body2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: "Optional styling columns:"
                                                    }),
                                                    " type, locked, stroke_style, line_style, line_width, fill_style, fill_pattern, text, font_size"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: "Download the sample file below to see examples with all supported columns and formatting."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    multiline: true,
                                    rows: 12,
                                    fullWidth: true,
                                    placeholder: `ramp_label	ramp_polygon	type	stroke_style	fill_style
"Hangar A"	"[[-73.70404052734375, 41.06755447387695], [-73.70372772216797, 41.0671501159668]]"	Area	#FF0000	#FF000033
"Parking Zone B"	"[[-73.70404052734375, 41.06755447387695], [-73.70372772216797, 41.0671501159668]]"	Area	#00FF00	#00FF004D`,
                                    value: csvContent,
                                    onChange: (e)=>setCsvContent(e.target.value),
                                    variant: "outlined"
                                })
                            }),
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                color: "error",
                                variant: "body2",
                                children: error
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "h6",
                                children: [
                                    "Imported Shapes (",
                                    importedShapes.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebLIv.GISShapeEditGrid), {
                                shapes: importedShapes,
                                setShapes: setImportedShapes,
                                ramp: ramp
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    !hasProcessed ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "outlined",
                                onClick: handleDownloadSample,
                                sx: {
                                    mr: 1
                                },
                                children: "Download Sample TSV"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                onClick: handleProcessCSV,
                                disabled: !csvContent.trim(),
                                children: "Process CSV"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                        variant: "contained",
                        color: "success",
                        onClick: handleImport,
                        disabled: importedShapes.length === 0,
                        children: [
                            "Import ",
                            importedShapes.length,
                            " Shapes"
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("ebLIv", function(module, exports) {

$parcel$export(module.exports, "GISShapeEditGrid", () => $bfae07694b5d743d$export$c04881a5a4faaea8);

var $ayMG0 = parcelRequire("ayMG0");

var $1MdOk = parcelRequire("1MdOk");

var $c3r8Q = parcelRequire("c3r8Q");

var $5y9fX = parcelRequire("5y9fX");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $6ami2 = parcelRequire("6ami2");
var $2esSG = parcelRequire("2esSG");
var $9Lykx = parcelRequire("9Lykx");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $axXzj = parcelRequire("axXzj");

var $acw62 = parcelRequire("acw62");

var $7mOBL = parcelRequire("7mOBL");

var $bng5f = parcelRequire("bng5f");
const $bfae07694b5d743d$export$c04881a5a4faaea8 = ({ shapes: shapes, setShapes: setShapes, ramp: ramp })=>{
    const [editingShapeId, setEditingShapeId] = $acw62.useState(null);
    const [inlineEditingFields, setInlineEditingFields] = $acw62.useState({});
    const [localValues, setLocalValues] = $acw62.useState({});
    const toggleInlineEdit = $acw62.useCallback((shapeId, field)=>{
        setInlineEditingFields((prev)=>{
            const shapeFields = prev[shapeId] || new Set();
            const newShapeFields = new Set(shapeFields);
            if (newShapeFields.has(field)) newShapeFields.delete(field);
            else {
                newShapeFields.add(field);
                // Initialize local value when starting to edit
                const shape = shapes.find((s)=>s.id === shapeId);
                if (shape) setLocalValues((prevLocal)=>({
                        ...prevLocal,
                        [shapeId]: {
                            ...prevLocal[shapeId],
                            [field]: shape[field]
                        }
                    }));
            }
            return {
                ...prev,
                [shapeId]: newShapeFields
            };
        });
    }, [
        shapes
    ]);
    const isInlineEditing = $acw62.useCallback((shapeId, field)=>{
        return inlineEditingFields[shapeId]?.has(field) || false;
    }, [
        inlineEditingFields
    ]);
    const getFieldValue = $acw62.useCallback((shape, field)=>{
        // Return local value if we're editing this field, otherwise return the shape's value
        if (isInlineEditing(shape.id, field) && localValues[shape.id]?.[field] !== undefined) return localValues[shape.id][field];
        return shape[field];
    }, [
        isInlineEditing,
        localValues
    ]);
    const updateLocalValue = $acw62.useCallback((shapeId, field, value)=>{
        setLocalValues((prev)=>({
                ...prev,
                [shapeId]: {
                    ...prev[shapeId],
                    [field]: value
                }
            }));
    }, []);
    const commitLocalValue = $acw62.useCallback((shapeId, field)=>{
        const localValue = localValues[shapeId]?.[field];
        if (localValue !== undefined) updateShape(shapeId, {
            [field]: localValue
        });
        toggleInlineEdit(shapeId, field);
    }, [
        localValues,
        toggleInlineEdit
    ]);
    const updateShape = $acw62.useCallback((shapeId, updates)=>{
        setShapes((shapes)=>shapes.map((shape)=>shape.id === shapeId ? {
                    ...shape,
                    ...updates
                } : shape));
    }, [
        setShapes
    ]);
    const removeShape = (shapeId)=>{
        setShapes((shapes)=>shapes.filter((shape)=>shape.id !== shapeId));
    };
    const handleTagToggle = (shapeId, tag)=>{
        const shape = shapes.find((s)=>s.id === shapeId);
        if (!shape) return;
        const currentTags = shape.tags || [];
        const newTags = currentTags.includes(tag) ? currentTags.filter((t)=>t !== tag) : [
            ...currentTags,
            tag
        ];
        updateShape(shapeId, {
            tags: newTags
        });
    };
    const ShapeEditRow = ({ shape: shape })=>{
        const isEditing = editingShapeId === shape.id;
        const isWithinBounds = (0, $bng5f.isShapeWithinRampBounds)(shape.originalPolygon, ramp);
        if (!isEditing) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            !isWithinBounds && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                title: "This shape may not be visible within the ramp's current bounding box",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5y9fX))), {
                                    color: "warning",
                                    fontSize: "small"
                                })
                            }),
                            isInlineEditing(shape.id, "text") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                size: "small",
                                value: shape.text,
                                onChange: (e)=>updateShape(shape.id, {
                                        text: e.target.value
                                    }),
                                onBlur: ()=>toggleInlineEdit(shape.id, "text"),
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter" || e.key === "Escape") toggleInlineEdit(shape.id, "text");
                                },
                                autoFocus: true
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                onClick: ()=>toggleInlineEdit(shape.id, "text"),
                                sx: {
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "action.hover"
                                    },
                                    px: 1,
                                    py: 0.5,
                                    borderRadius: 1
                                },
                                children: shape.text || shape.label
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 0.5,
                        children: shape.tags.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                label: tag,
                                size: "small"
                            }, tag))
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            width: 24,
                            height: 24,
                            backgroundColor: shape.fill_style,
                            border: `2px solid ${shape.stroke_style}`,
                            borderRadius: 1
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: isInlineEditing(shape.id, "font_size") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        size: "small",
                        type: "number",
                        inputProps: {
                            min: 8,
                            max: 64
                        },
                        value: getFieldValue(shape, "font_size"),
                        onChange: (e)=>updateLocalValue(shape.id, "font_size", Number(e.target.value)),
                        onBlur: ()=>commitLocalValue(shape.id, "font_size"),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter") commitLocalValue(shape.id, "font_size");
                            else if (e.key === "Escape") toggleInlineEdit(shape.id, "font_size");
                        },
                        autoFocus: true,
                        sx: {
                            width: 80
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        onClick: ()=>toggleInlineEdit(shape.id, "font_size"),
                        sx: {
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "action.hover"
                            },
                            px: 1,
                            py: 0.5,
                            borderRadius: 1
                        },
                        children: shape.font_size
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 0.5,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                size: "small",
                                onClick: ()=>setEditingShapeId(shape.id),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3r8Q))), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                size: "small",
                                color: "error",
                                onClick: ()=>removeShape(shape.id),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {})
                            })
                        ]
                    })
                })
            ]
        }, shape.id);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        size: "small",
                        fullWidth: true,
                        value: getFieldValue(shape, "text"),
                        onChange: (e)=>{
                            if (isEditing) updateLocalValue(shape.id, "text", e.target.value);
                            else updateShape(shape.id, {
                                text: e.target.value
                            });
                        },
                        onBlur: ()=>{
                            if (isEditing) commitLocalValue(shape.id, "text");
                        },
                        placeholder: "Shape text"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        children: (0, $7mOBL.TAG_OPTIONS).map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                    checked: shape.tags?.includes(tag) || false,
                                    onChange: ()=>handleTagToggle(shape.id, tag),
                                    size: "small"
                                }),
                                label: tag,
                                sx: {
                                    margin: 0
                                }
                            }, tag))
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                size: "small",
                                label: "Preset",
                                select: true,
                                value: "",
                                onChange: (e)=>{
                                    const preset = (0, $7mOBL.PREFIXED_COLORS).find((p)=>p.label === e.target.value);
                                    if (preset) updateShape(shape.id, {
                                        stroke_style: preset.stroke_style,
                                        fill_style: preset.fill_style
                                    });
                                },
                                children: (0, $7mOBL.PREFIXED_COLORS).map((preset)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        value: preset.label,
                                        children: preset.label
                                    }, preset.label))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $axXzj.MuiColorInput), {
                                size: "small",
                                label: "Stroke",
                                value: shape.stroke_style,
                                onChange: (value)=>updateShape(shape.id, {
                                        stroke_style: value
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $axXzj.MuiColorInput), {
                                size: "small",
                                label: "Fill",
                                value: shape.fill_style,
                                onChange: (value)=>updateShape(shape.id, {
                                        fill_style: value
                                    })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        size: "small",
                        type: "number",
                        inputProps: {
                            min: 8,
                            max: 64
                        },
                        value: getFieldValue(shape, "font_size"),
                        onChange: (e)=>{
                            const value = Number(e.target.value);
                            if (isEditing) updateLocalValue(shape.id, "font_size", value);
                            else updateShape(shape.id, {
                                font_size: value
                            });
                        },
                        onBlur: ()=>{
                            if (isEditing) commitLocalValue(shape.id, "font_size");
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        onClick: ()=>setEditingShapeId(null),
                        children: "Done"
                    })
                })
            ]
        }, shape.id);
    };
    if (shapes.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
        variant: "body2",
        color: "text.secondary",
        align: "center",
        children: "No shapes to display"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        children: "Click on text/label or font size to edit inline. Use the edit icon for colors and tags."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "outlined",
                        onClick: ()=>{
                            // Apply default styling to all shapes
                            const defaultUpdates = {
                                stroke_style: "#3c6ce9",
                                fill_style: "rgba(60, 108, 233, 0.1)",
                                font_size: 14,
                                tags: [
                                    "parkable"
                                ]
                            };
                            setShapes((shapes)=>shapes.map((shape)=>({
                                        ...shape,
                                        ...defaultUpdates
                                    })));
                        },
                        children: "Apply Default Styling"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                sx: {
                    maxHeight: 400
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                    size: "small",
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: "Text/Label"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: "Tags"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: "Colors"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: "Font Size"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                            children: shapes.map((shape)=>/*#__PURE__*/ (0, $ayMG0.jsx)(ShapeEditRow, {
                                    shape: shape
                                }, shape.id))
                        })
                    ]
                })
            }),
            shapes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "caption",
                color: "text.secondary",
                sx: {
                    mt: 1,
                    display: "block"
                },
                children: [
                    shapes.length,
                    " shape",
                    shapes.length !== 1 ? "s" : "",
                    " ready for import"
                ]
            })
        ]
    });
};

});
parcelRegister("axXzj", function(module, exports) {

$parcel$export(module.exports, "MuiColorInput", () => $7adb3183a4fada57$export$ed5bd2c23e384de);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");

var $d8seH = parcelRequire("d8seH");

var $6el2W = parcelRequire("6el2W");

var $jU0bc = parcelRequire("jU0bc");

var $03mUs = parcelRequire("03mUs");

var $iAtns = parcelRequire("iAtns");

var $hViLc = parcelRequire("hViLc");
const $7adb3183a4fada57$var$$t = "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%) /*! @noflip */", $7adb3183a4fada57$var$It = "linear-gradient(to top, #000000, transparent), linear-gradient(to right, #ffffff, transparent) /*! @noflip */", $7adb3183a4fada57$var$Bt = {
    Button: (0, $d8seH.default)((0, $6lXkL.default))(()=>({
            backgroundSize: "8px 8px",
            backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
            transition: "none",
            boxShadow: "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)",
            border: 0,
            borderRadius: 4,
            width: "24px",
            aspectRatio: "1 / 1",
            height: "24px",
            minWidth: 0
        }))
}, $7adb3183a4fada57$export$30f8104594140054 = (r)=>{
    const { bgColor: e, className: t, disablePopover: n, isBgColorValid: i, ...s } = r;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Bt.Button, {
        disableTouchRipple: !0,
        style: {
            backgroundColor: i ? e : void 0,
            backgroundImage: i ? void 0 : $7adb3183a4fada57$var$$t,
            cursor: n ? "default" : void 0
        },
        className: `MuiColorInput-Button ${t || ""}`,
        variant: "text",
        disableElevation: !1,
        ...s
    });
}, $7adb3183a4fada57$var$Pt = {
    Container: (0, $d8seH.default)("div")(()=>({
            width: 300,
            padding: 8
        }))
}, $7adb3183a4fada57$var$Et = ({ children: r, className: e, position: t = "start", ...n })=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $6el2W.default), {
        className: `MuiColorInput-Popover ${e || ""}`,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: t === "start" ? "left" : "right"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: t === "start" ? "left" : "right"
        },
        ...n,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Pt.Container, {
            children: r
        })
    }), $7adb3183a4fada57$var$Nt = {
    Slider: (0, $d8seH.default)((0, $jU0bc.default), {
        shouldForwardProp: (r)=>r !== "$rgbaFrom" && r !== "$rgbaTo"
    })(()=>({
            height: 8,
            "& .MuiSlider-rail": {
                opacity: 1,
                // TODO: find better way for perf
                background: "linear-gradient(to right, rgba(var(--rgb-r), var(--rgb-g), var(--rgb-b), 0) 0%, rgba(var(--rgb-r), var(--rgb-g), var(--rgb-b), 1) 100%)"
            },
            "& .MuiSlider-track": {
                color: "transparent",
                border: 0
            },
            "& .MuiSlider-thumb": {
                backgroundColor: "#ffffff",
                border: "3px solid currentColor"
            }
        }))
}, $7adb3183a4fada57$var$Vt = (r)=>{
    const { rgbColor: e, style: t, className: n, ...i } = r, s = {
        "--rgb-r": e.r,
        "--rgb-g": e.g,
        "--rgb-b": e.b,
        ...t
    };
    return /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Nt.Slider, {
        className: `MuiColorInput-AlphaSlider ${n || ""}`,
        style: s,
        ...i
    });
}, $7adb3183a4fada57$var$L = {
    up: "ArrowUp",
    down: "ArrowDown",
    left: "ArrowLeft",
    right: "ArrowRight"
}, $7adb3183a4fada57$var$Tt = {
    ArrowUp: {
        type: "hsvV",
        value: 1
    },
    ArrowDown: {
        type: "hsvV",
        value: -1
    },
    ArrowLeft: {
        type: "hsvS",
        value: -1
    },
    ArrowRight: {
        type: "hsvS",
        value: 1
    }
};
function $7adb3183a4fada57$var$Ot(r) {
    return r === $7adb3183a4fada57$var$L.up || r === $7adb3183a4fada57$var$L.down || r === $7adb3183a4fada57$var$L.left || r === $7adb3183a4fada57$var$L.right;
}
function $7adb3183a4fada57$var$W(r, e, t) {
    return Math.max(e, Math.min(r, t));
}
function $7adb3183a4fada57$var$et(r) {
    return typeof r == "number";
}
function $7adb3183a4fada57$var$rt(r, e, t) {
    const n = r.toLocaleString("en", {
        useGrouping: !1,
        minimumFractionDigits: e,
        maximumFractionDigits: t
    });
    return Number(n);
}
function $7adb3183a4fada57$var$Dt(r, e, t) {
    const n = r.getBoundingClientRect(), i = e - n.left, s = t - n.top;
    return {
        x: $7adb3183a4fada57$var$W(i / n.width, 0, 1),
        y: $7adb3183a4fada57$var$W(1 - s / n.height, 0, 1)
    };
}
function $7adb3183a4fada57$var$Lt(r) {
    const e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    return e.current = r, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((...t)=>e.current?.(...t), []);
}
const $7adb3183a4fada57$var$nt = {
    Space: (0, $d8seH.default)("div")(()=>({
            width: "100%",
            height: "180px",
            boxSizing: "border-box",
            outline: 0,
            position: "relative",
            backgroundImage: $7adb3183a4fada57$var$It
        })),
    Thumb: (0, $d8seH.default)("div")(()=>({
            position: "absolute",
            border: "3px solid #ffffff",
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            marginLeft: "-10px /*! @noflip */",
            marginBottom: "-10px /*! @noflip */",
            outline: 0,
            boxSizing: "border-box",
            willChange: "left, bottom",
            transition: "box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            "&:hover": {
                boxShadow: "0px 0px 0px 4px rgba(255 255 255 / 0.16)"
            },
            "&.MuiColorInput-Thumb-active": {
                boxShadow: "0px 0px 0px 8px rgba(255 255 255 / 0.16)"
            },
            "@media (hover: none)": {
                boxShadow: "none"
            }
        }))
}, $7adb3183a4fada57$var$jt = (r)=>{
    const { hsv: e, onChange: t, currentHue: n } = r, i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(!1), s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), [a, o] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!1), u = $7adb3183a4fada57$var$Lt((b, k)=>{
        if (!s.current) return;
        const { x: $, y: A } = $7adb3183a4fada57$var$Dt(s.current, b, k);
        t({
            s: $,
            v: A
        }), s.current && document.activeElement !== s.current && s.current.focus();
    }), w = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        i.current && (i.current = !1, o(!1));
    }, []), p = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((b)=>{
        i.current && u(b.clientX, b.clientY);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>(document.addEventListener("pointermove", p, !1), document.addEventListener("pointerup", w, !1), ()=>{
            document.removeEventListener("pointermove", p, !1), document.removeEventListener("pointerup", w, !1);
        }), [
        w,
        p
    ]);
    const m = (b)=>{
        b.preventDefault(), i.current = !0, u(b.clientX, b.clientY), o(!0);
    }, y = (b)=>{
        if ($7adb3183a4fada57$var$Ot(b.key)) {
            b.preventDefault();
            const { type: k, value: $ } = $7adb3183a4fada57$var$Tt[b.key], A = b.shiftKey ? 10 : 1, T = k === "hsvS" ? e.s : e.v, E = $7adb3183a4fada57$var$W(T + $ * A * 0.01, 0, 1);
            o(!0), t({
                s: k === "hsvS" ? E : e.s,
                v: k === "hsvV" ? E : e.v
            });
        }
    }, M = e.s * 100, H = e.v * 100;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$nt.Space, {
        onPointerDown: m,
        ref: s,
        className: "MuiColorInput-ColorSpace",
        style: {
            backgroundColor: `hsl(${n} 100% 50%)`,
            touchAction: "none"
        },
        role: "slider",
        "aria-valuetext": `Saturation ${$7adb3183a4fada57$var$rt(M, 0, 0)}%, Brightness ${$7adb3183a4fada57$var$rt(H, 0, 0)}%`,
        onKeyDown: y,
        tabIndex: 0,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$nt.Thumb, {
            "aria-label": "Color space thumb",
            className: a ? "MuiColorInput-Thumb-active" : "",
            style: {
                left: `${M}%`,
                bottom: `${H}%`
            }
        })
    });
}, $7adb3183a4fada57$var$Gt = {
    Slider: (0, $d8seH.default)((0, $jU0bc.default))(()=>({
            height: 8,
            "& .MuiSlider-rail": {
                opacity: 1,
                background: "linear-gradient(to right, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%) /*! @noflip */"
            },
            "& .MuiSlider-track": {
                color: "transparent",
                border: 0
            },
            "& .MuiSlider-thumb": {
                backgroundColor: "#ffffff",
                border: "3px solid currentColor"
            }
        }))
}, $7adb3183a4fada57$var$qt = (r)=>{
    const { className: e, ...t } = r;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Gt.Slider, {
        className: `MuiColorInput-HueSlider ${e || ""}`,
        ...t
    });
};
function $7adb3183a4fada57$var$Wt(r) {
    return typeof r == "string";
}
function $7adb3183a4fada57$var$g(r, e) {
    $7adb3183a4fada57$var$Kt(r) && (r = "100%");
    const t = $7adb3183a4fada57$var$Ut(r);
    return r = e === 360 ? r : Math.min(e, Math.max(0, parseFloat(r))), t && (r = parseInt(String(r * e), 10) / 100), Math.abs(r - e) < 1e-6 ? 1 : (e === 360 ? r = (r < 0 ? r % e + e : r % e) / parseFloat(String(e)) : r = r % e / parseFloat(String(e)), r);
}
function $7adb3183a4fada57$var$j(r) {
    return Math.min(1, Math.max(0, r));
}
function $7adb3183a4fada57$var$Kt(r) {
    return typeof r == "string" && r.indexOf(".") !== -1 && parseFloat(r) === 1;
}
function $7adb3183a4fada57$var$Ut(r) {
    return typeof r == "string" && r.indexOf("%") !== -1;
}
function $7adb3183a4fada57$var$dt(r) {
    return r = parseFloat(r), (isNaN(r) || r < 0 || r > 1) && (r = 1), r;
}
function $7adb3183a4fada57$var$G(r) {
    return Number(r) <= 1 ? `${Number(r) * 100}%` : r;
}
function $7adb3183a4fada57$var$R(r) {
    return r.length === 1 ? "0" + r : String(r);
}
function $7adb3183a4fada57$var$zt(r, e, t) {
    return {
        r: $7adb3183a4fada57$var$g(r, 255) * 255,
        g: $7adb3183a4fada57$var$g(e, 255) * 255,
        b: $7adb3183a4fada57$var$g(t, 255) * 255
    };
}
function $7adb3183a4fada57$var$st(r, e, t) {
    r = $7adb3183a4fada57$var$g(r, 255), e = $7adb3183a4fada57$var$g(e, 255), t = $7adb3183a4fada57$var$g(t, 255);
    const n = Math.max(r, e, t), i = Math.min(r, e, t);
    let s = 0, a = 0;
    const o = (n + i) / 2;
    if (n === i) a = 0, s = 0;
    else {
        const u = n - i;
        switch(a = o > 0.5 ? u / (2 - n - i) : u / (n + i), n){
            case r:
                s = (e - t) / u + (e < t ? 6 : 0);
                break;
            case e:
                s = (t - r) / u + 2;
                break;
            case t:
                s = (r - e) / u + 4;
                break;
        }
        s /= 6;
    }
    return {
        h: s,
        s: a,
        l: o
    };
}
function $7adb3183a4fada57$var$Y(r, e, t) {
    return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? r + (e - r) * (6 * t) : t < 0.5 ? e : t < 2 / 3 ? r + (e - r) * (2 / 3 - t) * 6 : r;
}
function $7adb3183a4fada57$var$Yt(r, e, t) {
    let n, i, s;
    if (r = $7adb3183a4fada57$var$g(r, 360), e = $7adb3183a4fada57$var$g(e, 100), t = $7adb3183a4fada57$var$g(t, 100), e === 0) i = t, s = t, n = t;
    else {
        const a = t < 0.5 ? t * (1 + e) : t + e - t * e, o = 2 * t - a;
        n = $7adb3183a4fada57$var$Y(o, a, r + 1 / 3), i = $7adb3183a4fada57$var$Y(o, a, r), s = $7adb3183a4fada57$var$Y(o, a, r - 1 / 3);
    }
    return {
        r: n * 255,
        g: i * 255,
        b: s * 255
    };
}
function $7adb3183a4fada57$var$it(r, e, t) {
    r = $7adb3183a4fada57$var$g(r, 255), e = $7adb3183a4fada57$var$g(e, 255), t = $7adb3183a4fada57$var$g(t, 255);
    const n = Math.max(r, e, t), i = Math.min(r, e, t);
    let s = 0;
    const a = n, o = n - i, u = n === 0 ? 0 : o / n;
    if (n === i) s = 0;
    else {
        switch(n){
            case r:
                s = (e - t) / o + (e < t ? 6 : 0);
                break;
            case e:
                s = (t - r) / o + 2;
                break;
            case t:
                s = (r - e) / o + 4;
                break;
        }
        s /= 6;
    }
    return {
        h: s,
        s: u,
        v: a
    };
}
function $7adb3183a4fada57$var$Xt(r, e, t) {
    r = $7adb3183a4fada57$var$g(r, 360) * 6, e = $7adb3183a4fada57$var$g(e, 100), t = $7adb3183a4fada57$var$g(t, 100);
    const n = Math.floor(r), i = r - n, s = t * (1 - e), a = t * (1 - i * e), o = t * (1 - (1 - i) * e), u = n % 6, w = [
        t,
        a,
        s,
        s,
        o,
        t
    ][u], p = [
        o,
        t,
        t,
        a,
        s,
        s
    ][u], m = [
        s,
        s,
        o,
        t,
        t,
        a
    ][u];
    return {
        r: w * 255,
        g: p * 255,
        b: m * 255
    };
}
function $7adb3183a4fada57$var$at(r, e, t, n) {
    const i = [
        $7adb3183a4fada57$var$R(Math.round(r).toString(16)),
        $7adb3183a4fada57$var$R(Math.round(e).toString(16)),
        $7adb3183a4fada57$var$R(Math.round(t).toString(16))
    ];
    return n && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function $7adb3183a4fada57$var$Zt(r, e, t, n, i) {
    const s = [
        $7adb3183a4fada57$var$R(Math.round(r).toString(16)),
        $7adb3183a4fada57$var$R(Math.round(e).toString(16)),
        $7adb3183a4fada57$var$R(Math.round(t).toString(16)),
        $7adb3183a4fada57$var$R($7adb3183a4fada57$var$Qt(n))
    ];
    return i && s[0].startsWith(s[0].charAt(1)) && s[1].startsWith(s[1].charAt(1)) && s[2].startsWith(s[2].charAt(1)) && s[3].startsWith(s[3].charAt(1)) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) + s[3].charAt(0) : s.join("");
}
function $7adb3183a4fada57$var$Jt(r, e, t, n) {
    const i = r / 100, s = e / 100, a = t / 100, o = n / 100, u = 255 * (1 - i) * (1 - o), w = 255 * (1 - s) * (1 - o), p = 255 * (1 - a) * (1 - o);
    return {
        r: u,
        g: w,
        b: p
    };
}
function $7adb3183a4fada57$var$ot(r, e, t) {
    let n = 1 - r / 255, i = 1 - e / 255, s = 1 - t / 255, a = Math.min(n, i, s);
    return a === 1 ? (n = 0, i = 0, s = 0) : (n = (n - a) / (1 - a) * 100, i = (i - a) / (1 - a) * 100, s = (s - a) / (1 - a) * 100), a *= 100, {
        c: Math.round(n),
        m: Math.round(i),
        y: Math.round(s),
        k: Math.round(a)
    };
}
function $7adb3183a4fada57$var$Qt(r) {
    return Math.round(parseFloat(r) * 255).toString(16);
}
function $7adb3183a4fada57$var$ht(r) {
    return $7adb3183a4fada57$var$S(r) / 255;
}
function $7adb3183a4fada57$var$S(r) {
    return parseInt(r, 16);
}
function $7adb3183a4fada57$var$_t(r) {
    return {
        r: r >> 16,
        g: (r & 65280) >> 8,
        b: r & 255
    };
}
const $7adb3183a4fada57$var$Z = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};
function $7adb3183a4fada57$var$te(r) {
    let e = {
        r: 0,
        g: 0,
        b: 0
    }, t = 1, n = null, i = null, s = null, a = !1, o = !1;
    return typeof r == "string" && (r = $7adb3183a4fada57$var$ne(r)), typeof r == "object" && ($7adb3183a4fada57$var$x(r.r) && $7adb3183a4fada57$var$x(r.g) && $7adb3183a4fada57$var$x(r.b) ? (e = $7adb3183a4fada57$var$zt(r.r, r.g, r.b), a = !0, o = String(r.r).substr(-1) === "%" ? "prgb" : "rgb") : $7adb3183a4fada57$var$x(r.h) && $7adb3183a4fada57$var$x(r.s) && $7adb3183a4fada57$var$x(r.v) ? (n = $7adb3183a4fada57$var$G(r.s), i = $7adb3183a4fada57$var$G(r.v), e = $7adb3183a4fada57$var$Xt(r.h, n, i), a = !0, o = "hsv") : $7adb3183a4fada57$var$x(r.h) && $7adb3183a4fada57$var$x(r.s) && $7adb3183a4fada57$var$x(r.l) ? (n = $7adb3183a4fada57$var$G(r.s), s = $7adb3183a4fada57$var$G(r.l), e = $7adb3183a4fada57$var$Yt(r.h, n, s), a = !0, o = "hsl") : $7adb3183a4fada57$var$x(r.c) && $7adb3183a4fada57$var$x(r.m) && $7adb3183a4fada57$var$x(r.y) && $7adb3183a4fada57$var$x(r.k) && (e = $7adb3183a4fada57$var$Jt(r.c, r.m, r.y, r.k), a = !0, o = "cmyk"), Object.prototype.hasOwnProperty.call(r, "a") && (t = r.a)), t = $7adb3183a4fada57$var$dt(t), {
        ok: a,
        format: r.format || o,
        r: Math.min(255, Math.max(e.r, 0)),
        g: Math.min(255, Math.max(e.g, 0)),
        b: Math.min(255, Math.max(e.b, 0)),
        a: t
    };
}
const $7adb3183a4fada57$var$ee = "[-\\+]?\\d+%?", $7adb3183a4fada57$var$re = "[-\\+]?\\d*\\.\\d+%?", $7adb3183a4fada57$var$C = "(?:" + $7adb3183a4fada57$var$re + ")|(?:" + $7adb3183a4fada57$var$ee + ")", $7adb3183a4fada57$var$X = "[\\s|\\(]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")\\s*\\)?", $7adb3183a4fada57$var$q = // eslint-disable-next-line prettier/prettier
"[\\s|\\(]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")\\s*\\)?", $7adb3183a4fada57$var$v = {
    CSS_UNIT: new RegExp($7adb3183a4fada57$var$C),
    rgb: new RegExp("rgb" + $7adb3183a4fada57$var$X),
    rgba: new RegExp("rgba" + $7adb3183a4fada57$var$q),
    hsl: new RegExp("hsl" + $7adb3183a4fada57$var$X),
    hsla: new RegExp("hsla" + $7adb3183a4fada57$var$q),
    hsv: new RegExp("hsv" + $7adb3183a4fada57$var$X),
    hsva: new RegExp("hsva" + $7adb3183a4fada57$var$q),
    cmyk: new RegExp("cmyk" + $7adb3183a4fada57$var$q),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $7adb3183a4fada57$var$ne(r) {
    if (r = r.trim().toLowerCase(), r.length === 0) return !1;
    let e = !1;
    if ($7adb3183a4fada57$var$Z[r]) r = $7adb3183a4fada57$var$Z[r], e = !0;
    else if (r === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    let t = $7adb3183a4fada57$var$v.rgb.exec(r);
    return t ? {
        r: t[1],
        g: t[2],
        b: t[3]
    } : (t = $7adb3183a4fada57$var$v.rgba.exec(r), t ? {
        r: t[1],
        g: t[2],
        b: t[3],
        a: t[4]
    } : (t = $7adb3183a4fada57$var$v.hsl.exec(r), t ? {
        h: t[1],
        s: t[2],
        l: t[3]
    } : (t = $7adb3183a4fada57$var$v.hsla.exec(r), t ? {
        h: t[1],
        s: t[2],
        l: t[3],
        a: t[4]
    } : (t = $7adb3183a4fada57$var$v.hsv.exec(r), t ? {
        h: t[1],
        s: t[2],
        v: t[3]
    } : (t = $7adb3183a4fada57$var$v.hsva.exec(r), t ? {
        h: t[1],
        s: t[2],
        v: t[3],
        a: t[4]
    } : (t = $7adb3183a4fada57$var$v.cmyk.exec(r), t ? {
        c: t[1],
        m: t[2],
        y: t[3],
        k: t[4]
    } : (t = $7adb3183a4fada57$var$v.hex8.exec(r), t ? {
        r: $7adb3183a4fada57$var$S(t[1]),
        g: $7adb3183a4fada57$var$S(t[2]),
        b: $7adb3183a4fada57$var$S(t[3]),
        a: $7adb3183a4fada57$var$ht(t[4]),
        format: e ? "name" : "hex8"
    } : (t = $7adb3183a4fada57$var$v.hex6.exec(r), t ? {
        r: $7adb3183a4fada57$var$S(t[1]),
        g: $7adb3183a4fada57$var$S(t[2]),
        b: $7adb3183a4fada57$var$S(t[3]),
        format: e ? "name" : "hex"
    } : (t = $7adb3183a4fada57$var$v.hex4.exec(r), t ? {
        r: $7adb3183a4fada57$var$S(t[1] + t[1]),
        g: $7adb3183a4fada57$var$S(t[2] + t[2]),
        b: $7adb3183a4fada57$var$S(t[3] + t[3]),
        a: $7adb3183a4fada57$var$ht(t[4] + t[4]),
        format: e ? "name" : "hex8"
    } : (t = $7adb3183a4fada57$var$v.hex3.exec(r), t ? {
        r: $7adb3183a4fada57$var$S(t[1] + t[1]),
        g: $7adb3183a4fada57$var$S(t[2] + t[2]),
        b: $7adb3183a4fada57$var$S(t[3] + t[3]),
        format: e ? "name" : "hex"
    } : !1))))))))));
}
function $7adb3183a4fada57$var$x(r) {
    return typeof r == "number" ? !Number.isNaN(r) : $7adb3183a4fada57$var$v.CSS_UNIT.test(r);
}
class $7adb3183a4fada57$var$h {
    constructor(e = "", t = {}){
        if (e instanceof $7adb3183a4fada57$var$h) return e;
        typeof e == "number" && (e = $7adb3183a4fada57$var$_t(e)), this.originalInput = e;
        const n = $7adb3183a4fada57$var$te(e);
        this.originalInput = e, this.r = n.r, this.g = n.g, this.b = n.b, this.a = n.a, this.roundA = Math.round(100 * this.a) / 100, this.format = t.format ?? n.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = n.ok;
    }
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return !this.isDark();
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   */ getBrightness() {
        const e = this.toRgb();
        return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
    }
    /**
   * Returns the perceived luminance of a color, from 0-1.
   */ getLuminance() {
        const e = this.toRgb();
        let t, n, i;
        const s = e.r / 255, a = e.g / 255, o = e.b / 255;
        return s <= 0.03928 ? t = s / 12.92 : t = Math.pow((s + 0.055) / 1.055, 2.4), a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), o <= 0.03928 ? i = o / 12.92 : i = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * i;
    }
    /**
   * Returns the alpha value of a color, from 0-1.
   */ getAlpha() {
        return this.a;
    }
    /**
   * Sets the alpha value on the current color.
   *
   * @param alpha - The new alpha value. The accepted range is 0-1.
   */ setAlpha(e) {
        return this.a = $7adb3183a4fada57$var$dt(e), this.roundA = Math.round(100 * this.a) / 100, this;
    }
    /**
   * Returns whether the color is monochrome.
   */ isMonochrome() {
        const { s: e } = this.toHsl();
        return e === 0;
    }
    /**
   * Returns the object as a HSVA object.
   */ toHsv() {
        const e = $7adb3183a4fada57$var$it(this.r, this.g, this.b);
        return {
            h: e.h * 360,
            s: e.s,
            v: e.v,
            a: this.a
        };
    }
    /**
   * Returns the hsva values interpolated into a string with the following format:
   * "hsva(xxx, xxx, xxx, xx)".
   */ toHsvString() {
        const e = $7adb3183a4fada57$var$it(this.r, this.g, this.b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), i = Math.round(e.v * 100);
        return this.a === 1 ? `hsv(${t}, ${n}%, ${i}%)` : `hsva(${t}, ${n}%, ${i}%, ${this.roundA})`;
    }
    /**
   * Returns the object as a HSLA object.
   */ toHsl() {
        const e = $7adb3183a4fada57$var$st(this.r, this.g, this.b);
        return {
            h: e.h * 360,
            s: e.s,
            l: e.l,
            a: this.a
        };
    }
    /**
   * Returns the hsla values interpolated into a string with the following format:
   * "hsla(xxx, xxx, xxx, xx)".
   */ toHslString() {
        const e = $7adb3183a4fada57$var$st(this.r, this.g, this.b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), i = Math.round(e.l * 100);
        return this.a === 1 ? `hsl(${t}, ${n}%, ${i}%)` : `hsla(${t}, ${n}%, ${i}%, ${this.roundA})`;
    }
    /**
   * Returns the hex value of the color.
   * @param allow3Char will shorten hex value to 3 char if possible
   */ toHex(e = !1) {
        return $7adb3183a4fada57$var$at(this.r, this.g, this.b, e);
    }
    /**
   * Returns the hex value of the color -with a # prefixed.
   * @param allow3Char will shorten hex value to 3 char if possible
   */ toHexString(e = !1) {
        return "#" + this.toHex(e);
    }
    /**
   * Returns the hex 8 value of the color.
   * @param allow4Char will shorten hex value to 4 char if possible
   */ toHex8(e = !1) {
        return $7adb3183a4fada57$var$Zt(this.r, this.g, this.b, this.a, e);
    }
    /**
   * Returns the hex 8 value of the color -with a # prefixed.
   * @param allow4Char will shorten hex value to 4 char if possible
   */ toHex8String(e = !1) {
        return "#" + this.toHex8(e);
    }
    /**
   * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
   * @param allowShortChar will shorten hex value to 3 or 4 char if possible
   */ toHexShortString(e = !1) {
        return this.a === 1 ? this.toHexString(e) : this.toHex8String(e);
    }
    /**
   * Returns the object as a RGBA object.
   */ toRgb() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    }
    /**
   * Returns the RGBA values interpolated into a string with the following format:
   * "RGBA(xxx, xxx, xxx, xx)".
   */ toRgbString() {
        const e = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
        return this.a === 1 ? `rgb(${e}, ${t}, ${n})` : `rgba(${e}, ${t}, ${n}, ${this.roundA})`;
    }
    /**
   * Returns the object as a RGBA object.
   */ toPercentageRgb() {
        const e = (t)=>`${Math.round($7adb3183a4fada57$var$g(t, 255) * 100)}%`;
        return {
            r: e(this.r),
            g: e(this.g),
            b: e(this.b),
            a: this.a
        };
    }
    /**
   * Returns the RGBA relative values interpolated into a string
   */ toPercentageRgbString() {
        const e = (t)=>Math.round($7adb3183a4fada57$var$g(t, 255) * 100);
        return this.a === 1 ? `rgb(${e(this.r)}%, ${e(this.g)}%, ${e(this.b)}%)` : `rgba(${e(this.r)}%, ${e(this.g)}%, ${e(this.b)}%, ${this.roundA})`;
    }
    toCmyk() {
        return {
            ...$7adb3183a4fada57$var$ot(this.r, this.g, this.b)
        };
    }
    toCmykString() {
        const { c: e, m: t, y: n, k: i } = $7adb3183a4fada57$var$ot(this.r, this.g, this.b);
        return `cmyk(${e}, ${t}, ${n}, ${i})`;
    }
    /**
   * The 'real' name of the color -if there is one.
   */ toName() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return !1;
        const e = "#" + $7adb3183a4fada57$var$at(this.r, this.g, this.b, !1);
        for (const [t, n] of Object.entries($7adb3183a4fada57$var$Z))if (e === n) return t;
        return !1;
    }
    toString(e) {
        const t = !!e;
        e = e ?? this.format;
        let n = !1;
        const i = this.a < 1 && this.a >= 0;
        return !t && i && (e.startsWith("hex") || e === "name") ? e === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), e === "cmyk" && (n = this.toCmykString()), n || this.toHexString());
    }
    toNumber() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }
    clone() {
        return new $7adb3183a4fada57$var$h(this.toString());
    }
    /**
   * Lighten the color a given amount. Providing 100 will always return white.
   * @param amount - valid between 1-100
   */ lighten(e = 10) {
        const t = this.toHsl();
        return t.l += e / 100, t.l = $7adb3183a4fada57$var$j(t.l), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Brighten the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */ brighten(e = 10) {
        const t = this.toRgb();
        return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(e / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(e / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(e / 100)))), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Darken the color a given amount, from 0 to 100.
   * Providing 100 will always return black.
   * @param amount - valid between 1-100
   */ darken(e = 10) {
        const t = this.toHsl();
        return t.l -= e / 100, t.l = $7adb3183a4fada57$var$j(t.l), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   * @param amount - valid between 1-100
   */ tint(e = 10) {
        return this.mix("white", e);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   * @param amount - valid between 1-100
   */ shade(e = 10) {
        return this.mix("black", e);
    }
    /**
   * Desaturate the color a given amount, from 0 to 100.
   * Providing 100 will is the same as calling greyscale
   * @param amount - valid between 1-100
   */ desaturate(e = 10) {
        const t = this.toHsl();
        return t.s -= e / 100, t.s = $7adb3183a4fada57$var$j(t.s), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Saturate the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */ saturate(e = 10) {
        const t = this.toHsl();
        return t.s += e / 100, t.s = $7adb3183a4fada57$var$j(t.s), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Completely desaturates a color into greyscale.
   * Same as calling `desaturate(100)`
   */ greyscale() {
        return this.desaturate(100);
    }
    /**
   * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
   * Values outside of this range will be wrapped into this range.
   */ spin(e) {
        const t = this.toHsl(), n = (t.h + e) % 360;
        return t.h = n < 0 ? 360 + n : n, new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(e, t = 50) {
        const n = this.toRgb(), i = new $7adb3183a4fada57$var$h(e).toRgb(), s = t / 100, a = {
            r: (i.r - n.r) * s + n.r,
            g: (i.g - n.g) * s + n.g,
            b: (i.b - n.b) * s + n.b,
            a: (i.a - n.a) * s + n.a
        };
        return new $7adb3183a4fada57$var$h(a);
    }
    analogous(e = 6, t = 30) {
        const n = this.toHsl(), i = 360 / t, s = [
            this
        ];
        for(n.h = (n.h - (i * e >> 1) + 720) % 360; --e;)n.h = (n.h + i) % 360, s.push(new $7adb3183a4fada57$var$h(n));
        return s;
    }
    /**
   * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
   */ complement() {
        const e = this.toHsl();
        return e.h = (e.h + 180) % 360, new $7adb3183a4fada57$var$h(e);
    }
    monochromatic(e = 6) {
        const t = this.toHsv(), { h: n } = t, { s: i } = t;
        let { v: s } = t;
        const a = [], o = 1 / e;
        for(; e--;)a.push(new $7adb3183a4fada57$var$h({
            h: n,
            s: i,
            v: s
        })), s = (s + o) % 1;
        return a;
    }
    splitcomplement() {
        const e = this.toHsl(), { h: t } = e;
        return [
            this,
            new $7adb3183a4fada57$var$h({
                h: (t + 72) % 360,
                s: e.s,
                l: e.l
            }),
            new $7adb3183a4fada57$var$h({
                h: (t + 216) % 360,
                s: e.s,
                l: e.l
            })
        ];
    }
    /**
   * Compute how the color would appear on a background
   */ onBackground(e) {
        const t = this.toRgb(), n = new $7adb3183a4fada57$var$h(e).toRgb(), i = t.a + n.a * (1 - t.a);
        return new $7adb3183a4fada57$var$h({
            r: (t.r * t.a + n.r * n.a * (1 - t.a)) / i,
            g: (t.g * t.a + n.g * n.a * (1 - t.a)) / i,
            b: (t.b * t.a + n.b * n.a * (1 - t.a)) / i,
            a: i
        });
    }
    /**
   * Alias for `polyad(3)`
   */ triad() {
        return this.polyad(3);
    }
    /**
   * Alias for `polyad(4)`
   */ tetrad() {
        return this.polyad(4);
    }
    /**
   * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
   * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
   */ polyad(e) {
        const t = this.toHsl(), { h: n } = t, i = [
            this
        ], s = 360 / e;
        for(let a = 1; a < e; a++)i.push(new $7adb3183a4fada57$var$h({
            h: (n + a * s) % 360,
            s: t.s,
            l: t.l
        }));
        return i;
    }
    /**
   * compare color vs current color
   */ equals(e) {
        const t = new $7adb3183a4fada57$var$h(e);
        return this.format === "cmyk" || t.format === "cmyk" ? this.toCmykString() === t.toCmykString() : this.toRgbString() === t.toRgbString();
    }
}
function $7adb3183a4fada57$var$F(r, e) {
    return r.isValid ? r.toString(e) : r.originalInput.toString();
}
function $7adb3183a4fada57$var$ut(r, e) {
    return new $7adb3183a4fada57$var$h(r, e);
}
function $7adb3183a4fada57$var$se(r) {
    return $7adb3183a4fada57$var$Wt(r) ? r : new $7adb3183a4fada57$var$h(r).toString();
}
const $7adb3183a4fada57$var$ie = (r)=>{
    const { currentColor: e, format: t, onChange: n, isAlphaHidden: i } = r, [s, a] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(e.toHsv()), o = (p, m)=>{
        if (!$7adb3183a4fada57$var$et(m)) return;
        const y = $7adb3183a4fada57$var$W(360 * m / 100, 0, 359);
        a((H)=>({
                ...H,
                h: y
            }));
        const M = new $7adb3183a4fada57$var$h({
            ...s,
            a: e.toHsv().a,
            h: y
        });
        n?.($7adb3183a4fada57$var$F(M, t));
    }, u = (p, m)=>{
        if (!$7adb3183a4fada57$var$et(m)) return;
        const y = e.clone().setAlpha(m);
        n?.($7adb3183a4fada57$var$F(y, t));
    }, w = ({ s: p, v: m })=>{
        const y = new $7adb3183a4fada57$var$h({
            h: s.h,
            a: e.toHsv().a,
            s: p,
            v: m
        });
        a((M)=>({
                ...M,
                s: p,
                v: m
            })), n?.($7adb3183a4fada57$var$F(y, t));
    };
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        className: "MuiColorInput-PopoverBody",
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$jt, {
                currentHue: s.h,
                hsv: s,
                onChange: w
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)((0, $03mUs.default), {
                mt: "10px",
                px: "3px",
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$qt, {
                    min: 0,
                    max: 100,
                    step: 1,
                    onChange: o,
                    "aria-label": "hue",
                    value: s.h * 100 / 360
                })
            }),
            i ? null : /* @__PURE__ */ (0, $ayMG0.jsx)((0, $03mUs.default), {
                mt: "10px",
                px: "3px",
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Vt, {
                    min: 0,
                    max: 1,
                    step: 0.01,
                    "aria-label": "alpha",
                    rgbColor: e.toRgb(),
                    onChange: u,
                    value: e.getAlpha()
                })
            })
        ]
    });
}, $7adb3183a4fada57$var$ae = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((r, e)=>{
    const { className: t, ...n } = r;
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $iAtns.default), {
        className: `MuiColorInput-TextField ${t || ""}`,
        ref: e,
        ...n
    });
}), $7adb3183a4fada57$var$oe = "rgb";
function $7adb3183a4fada57$var$he(r) {
    return typeof r == "object" && !Array.isArray(r) && r !== null;
}
function $7adb3183a4fada57$var$ft(r, e) {
    typeof e == "function" ? e(r) : e && $7adb3183a4fada57$var$he(e) && "current" in e && (e.current = r);
}
function $7adb3183a4fada57$export$ea7662cd66cffda6(r) {
    return new $7adb3183a4fada57$var$h(r).isValid;
}
const $7adb3183a4fada57$export$ed5bd2c23e384de = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: r, format: e, onChange: t, adornmentPosition: n = "start", PopoverProps: i, Adornment: s = $7adb3183a4fada57$export$30f8104594140054, fallbackValue: a, isAlphaHidden: o, disablePopover: u, ...w }, p)=>{
    const { onBlur: m, slotProps: y, ...M } = w, { onClose: H, ...b } = i || {}, k = M.disabled || !1, $ = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), A = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), [T, E] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), I = e || $7adb3183a4fada57$var$oe, K = $7adb3183a4fada57$var$ut(r, {
        format: I
    }), [O, N] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(r), [J, V] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(r), gt = (f)=>{
        f.preventDefault(), f.stopPropagation(), !k && !u && E($.current);
    }, D = (f)=>{
        const c = new $7adb3183a4fada57$var$h(f);
        t?.(f, {
            hex: c.isValid ? c.toHexString() : "",
            hsv: c.isValid ? c.toHsvString() : "",
            hsl: c.isValid ? c.toHslString() : "",
            rgb: c.isValid ? c.toRgbString() : "",
            hex8: c.isValid ? c.toHex8String() : ""
        });
    }, bt = (f)=>{
        const c = f.target.value;
        if (N(c), c === "") V(""), D("");
        else {
            const U = new $7adb3183a4fada57$var$h(c), B = $7adb3183a4fada57$var$F(U, I);
            V(B), D(B);
        }
    }, pt = (...f)=>{
        H?.(...f), E(null), queueMicrotask(()=>{
            A.current?.focus();
        });
    }, mt = (f)=>{
        m?.(f);
        const c = new $7adb3183a4fada57$var$h(O);
        if (c.isValid) c.format !== I && N($7adb3183a4fada57$var$F(c, I));
        else {
            if (O === "") return;
            if (a) {
                const U = new $7adb3183a4fada57$var$h(a), B = $7adb3183a4fada57$var$F(U, I);
                N(B), V(B), D(B);
            }
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (r !== J) {
            const c = $7adb3183a4fada57$var$ut(r).originalInput;
            V(c), N(c);
        }
    }, [
        r,
        J
    ]);
    const xt = (f)=>{
        N(f), V(f), D(f);
    }, St = (f)=>{
        $.current = f, $7adb3183a4fada57$var$ft(f, p);
    }, vt = (f)=>{
        A.current = f, $7adb3183a4fada57$var$ft(f, A);
    }, Q = !!T, _ = Q ? "color-popover" : void 0, tt = /* @__PURE__ */ (0, $ayMG0.jsx)((0, $hViLc.default), {
        position: n,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)(s, {
            disabled: k,
            "aria-describedby": _,
            disablePopover: u || !1,
            component: u ? "span" : void 0,
            bgColor: K.toString(),
            isBgColorValid: !!(O !== "" && K.isValid),
            onClick: u ? void 0 : gt
        })
    }), { input: wt, ...yt } = y || {}, Mt = {
        startAdornment: n === "start" ? tt : void 0,
        endAdornment: n === "end" ? tt : void 0,
        ...wt
    };
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$ae, {
                ref: St,
                spellCheck: "false",
                type: "text",
                autoComplete: "off",
                onChange: bt,
                value: $7adb3183a4fada57$var$se(O),
                onBlur: mt,
                inputRef: vt,
                disabled: k,
                slotProps: {
                    input: Mt,
                    ...yt
                },
                ...M
            }),
            u ? null : /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Et, {
                id: _,
                open: Q,
                position: n,
                anchorEl: T,
                onClose: pt,
                ...b,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$ie, {
                    onChange: xt,
                    currentColor: K,
                    format: I,
                    isAlphaHidden: o
                })
            })
        ]
    });
});

});

parcelRegister("7mOBL", function(module, exports) {

$parcel$export(module.exports, "TAG_OPTIONS", () => $e248307011085aba$export$153ed18fe495cf1);
$parcel$export(module.exports, "PREFIXED_COLORS", () => $e248307011085aba$export$782b4a944ea5d3a3);
$parcel$export(module.exports, "SHAPE_COLORS", () => $e248307011085aba$export$fd05a211833d79fc);
$parcel$export(module.exports, "ShapeEditDialog", () => $e248307011085aba$export$3f1c0b4d7b38874f);

var $ayMG0 = parcelRequire("ayMG0");

var $axXzj = parcelRequire("axXzj");

var $ipR47 = parcelRequire("ipR47");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $2Ed4H = parcelRequire("2Ed4H");
var $2esSG = parcelRequire("2esSG");
var $9Lykx = parcelRequire("9Lykx");
var $2iAqv = parcelRequire("2iAqv");
var $jU0bc = parcelRequire("jU0bc");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $jNGAr = parcelRequire("jNGAr");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $aDtBU = parcelRequire("aDtBU");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $lTOh0 = parcelRequire("lTOh0");

var $lNEp2 = parcelRequire("lNEp2");

var $ceJla = parcelRequire("ceJla");

var $eF1ay = parcelRequire("eF1ay");

var $flHhZ = parcelRequire("flHhZ");

var $9s9MA = parcelRequire("9s9MA");
const $e248307011085aba$export$153ed18fe495cf1 = [
    "hangar",
    "parkable",
    "obstruction",
    "utilization",
    "reference_line",
    "spot",
    "zone",
    "egress_lane"
];
const $e248307011085aba$export$782b4a944ea5d3a3 = [
    {
        label: "Reference Line",
        stroke_style: "#00CED1",
        fill_style: "rgba(0, 206, 209, 0.10)"
    },
    {
        label: "Parking Area",
        stroke_style: "#3c6ce9",
        fill_style: "rgba(238, 239, 243, 0.10)"
    },
    {
        label: "Hazard Area",
        stroke_style: "#FF0000",
        fill_style: "#FF000030"
    },
    {
        label: "Taxi / Runway Area",
        stroke_style: "#eed202",
        fill_style: "#eed20230"
    },
    {
        label: "Free Space Area",
        stroke_style: "#00FF00",
        fill_style: "rgba(0, 255, 0, 0.38)"
    },
    {
        label: "Ground Vehicles Area",
        stroke_style: "#FCFAFF",
        fill_style: "#FCFAFF30"
    },
    {
        label: "Taxi Line",
        stroke_style: "#eed202",
        fill_style: "#eed20230"
    },
    {
        label: "Runway Lines",
        stroke_style: "#FFFFFF",
        fill_style: "#FFFFFF30"
    },
    {
        label: "Hangar Area",
        fill_style: "#c8cfde50",
        stroke_style: "#3e5d8c"
    }
];
const $e248307011085aba$export$fd05a211833d79fc = [
    "rgba(255, 0, 0, 0.5)",
    "rgba(255, 255, 0, 0.5)",
    "rgba(0, 255, 0, 0.5)",
    "rgba(0, 0, 255, 0.5)"
];
const $e248307011085aba$export$78dafc18d6355ced = [
    "black",
    "white",
    "red",
    "green",
    "blue",
    "yellow",
    "purple",
    "orange",
    "pink",
    "brown"
];
const $e248307011085aba$export$a1205a8cc23056a6 = [
    "solid",
    "dashed",
    "dotted"
];
const $e248307011085aba$export$66e1bd537a5bf507 = [
    {
        value: "start",
        label: "Start"
    },
    {
        value: "middle",
        label: "Middle"
    },
    {
        value: "end",
        label: "End"
    }
];
const $e248307011085aba$export$3f1c0b4d7b38874f = ({ contextMenu: contextMenu, setContextMenu: setContextMenu, onClose: onClose, shapes: shapes, setShapes: setShapes, canvasHeight: _canvasHeight = 0, canvasWidth: canvasWidth = 0, previewSpots: previewSpots = [], setPreviewSpots: setPreviewSpots = ()=>{} })=>{
    const { activeShapes: activeShapes, setActiveShapes: setActiveShapes, ramp: ramp } = (0, $ceJla.useLocalRampState)();
    const [activeTab, setActiveTab] = $acw62.useState(0);
    const shape = $acw62.useMemo(()=>shapes.find((s)=>s.id === contextMenu?.shapeId), [
        shapes,
        contextMenu?.shapeId
    ]);
    // Calculate the total number of tabs and reset if out of bounds
    $acw62.useEffect(()=>{
        // Early exit if no shape
        if (!shape) return;
        const showAlgorithmTab = shape?.tags?.includes("parkable") || shape?.tags?.includes("reference_line") || shape?.tags?.includes("spot") || shape?.type === "Spot" || shape?.type === "Zone";
        const totalTabs = showAlgorithmTab ? 3 : 2;
        if (activeTab >= totalTabs) setActiveTab(totalTabs - 1);
    }, [
        shape,
        activeTab
    ]);
    // Keyboard shortcuts for tab switching
    $acw62.useEffect(()=>{
        if (!contextMenu || !shape) return;
        const handleKeyDown = (e)=>{
            // Check for Ctrl+1/2/3 (or Cmd on Mac)
            if (e.ctrlKey || e.metaKey) {
                const showAlgorithmTab = shape?.tags?.includes("parkable") || shape?.tags?.includes("reference_line") || shape?.tags?.includes("spot") || shape?.type === "Spot" || shape?.type === "Zone";
                const totalTabs = showAlgorithmTab ? 3 : 2;
                if (e.key === "1") {
                    e.preventDefault();
                    setActiveTab(0);
                } else if (e.key === "2") {
                    e.preventDefault();
                    setActiveTab(1);
                } else if (e.key === "3" && totalTabs >= 3) {
                    e.preventDefault();
                    setActiveTab(2);
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        contextMenu,
        shape
    ]);
    const setSelectedShapes = (attribute, value)=>{
        const updatedShapes = shapes.map((shape)=>{
            if (activeShapes.includes(shape.id) || shape.id === contextMenu?.shapeId) return {
                ...shape,
                [attribute]: value
            };
            return shape;
        });
        setShapes(updatedShapes);
    };
    const setSelectedShapesMultiple = (attributes)=>{
        const updatedShapes = shapes.map((shape)=>{
            if (activeShapes.includes(shape.id) || shape.id === contextMenu?.shapeId) return {
                ...shape,
                ...attributes
            };
            return shape;
        });
        setShapes(updatedShapes);
    };
    if (!shape) return null;
    const prefixedValue = $e248307011085aba$export$782b4a944ea5d3a3.find((option)=>option.stroke_style === shape.stroke_style && option.fill_style === shape.fill_style)?.label;
    // Determine if Algorithm tab should be shown
    const showAlgorithmTab = shape?.tags?.includes("parkable") || shape?.tags?.includes("reference_line") || shape?.tags?.includes("spot") || shape?.type === "Spot" || shape?.type === "Zone";
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Ed4H.default), {
        open: !!contextMenu,
        onClose: onClose,
        anchor: "left",
        hideBackdrop: false,
        ModalProps: {
            BackdropProps: {
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.1)" // Very light - 10% opacity
                }
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            sx: {
                width: 400,
                height: "100vh",
                display: "flex",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "h6",
                            sx: {
                                p: 2,
                                pb: 0
                            },
                            children: "Shape Properties"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                            value: activeTab,
                            onChange: (_, newValue)=>setActiveTab(newValue),
                            sx: {
                                borderBottom: 1,
                                borderColor: "divider",
                                px: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                    label: "Properties (\u23181)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                    label: "Styling (\u23182)"
                                }),
                                showAlgorithmTab && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                    label: "Algorithm (\u23183)"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        flexGrow: 1,
                        overflowY: "auto",
                        overflowX: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                            value: activeTab,
                            index: 0,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                            checked: shape?.locked ?? false
                                        }),
                                        onChange: ()=>setSelectedShapes("locked", !shape?.locked),
                                        label: "Locked?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        size: "small",
                                        fullWidth: true,
                                        label: "Tags",
                                        select: true,
                                        onChange: (event)=>{
                                            const value = event.target.value;
                                            setSelectedShapes("tags", typeof value === "string" ? value.split(",") : value);
                                        },
                                        value: shape?.tags ?? [],
                                        SelectProps: {
                                            multiple: true,
                                            renderValue: (selected)=>{
                                                if (Array.isArray(selected)) return selected.join(", ");
                                                return String(selected);
                                            },
                                            MenuProps: {
                                                PaperProps: {
                                                    sx: {
                                                        zIndex: 9999
                                                    }
                                                }
                                            }
                                        },
                                        children: $e248307011085aba$export$153ed18fe495cf1.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: tag,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                        checked: shape?.tags?.includes(tag) || false,
                                                        onChange: (e)=>{
                                                            const currentTags = [
                                                                ...shape?.tags || []
                                                            ];
                                                            if (e.target.checked) {
                                                                if (!currentTags.includes(tag)) setSelectedShapes("tags", [
                                                                    ...currentTags,
                                                                    tag
                                                                ]);
                                                            } else setSelectedShapes("tags", currentTags.filter((t)=>t !== tag));
                                                        }
                                                    }),
                                                    label: tag,
                                                    onClick: (e)=>e.stopPropagation()
                                                })
                                            }, tag))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        size: "small",
                                        label: "Text",
                                        fullWidth: true,
                                        onChange: (event)=>{
                                            setSelectedShapes("text", event.target.value);
                                        },
                                        value: shape?.text || ""
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                            value: activeTab,
                            index: 1,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                        size: "small",
                                        fullWidth: true,
                                        label: "Pre-fixed Colors",
                                        select: true,
                                        onChange: (event)=>{
                                            const option = $e248307011085aba$export$782b4a944ea5d3a3.find((option)=>option.label === event.target.value);
                                            setSelectedShapesMultiple({
                                                stroke_style: option?.stroke_style,
                                                fill_style: option?.fill_style,
                                                fill_pattern: ""
                                            });
                                        },
                                        sx: {
                                            zIndex: 9999
                                        },
                                        SelectProps: {
                                            MenuProps: {
                                                PaperProps: {
                                                    sx: {
                                                        zIndex: 9999
                                                    } // Ensure Menu aligns with Drawer
                                                }
                                            }
                                        },
                                        value: prefixedValue ?? "custom",
                                        children: [
                                            $e248307011085aba$export$782b4a944ea5d3a3.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                    value: option.label,
                                                    children: option.label
                                                }, option.label)),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "custom",
                                                children: "Custom"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            mt: 1
                                        },
                                        children: "Fill"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $axXzj.MuiColorInput), {
                                                fullWidth: true,
                                                size: "small",
                                                label: "Color",
                                                isAlphaHidden: false,
                                                onChange: (value, colors)=>{
                                                    setSelectedShapesMultiple({
                                                        fill_style: colors.hex8,
                                                        fill_pattern: ""
                                                    });
                                                },
                                                value: shape?.fill_style ?? ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                size: "small",
                                                fullWidth: true,
                                                label: "Pattern",
                                                select: true,
                                                onChange: (event)=>{
                                                    setSelectedShapesMultiple({
                                                        fill_style: "",
                                                        fill_pattern: event.target.value
                                                    });
                                                },
                                                value: shape?.fill_pattern || "",
                                                children: (0, $flHhZ.FILL_PATTERNS)().map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: option.label,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            spacing: 1,
                                                            alignItems: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: option.value,
                                                                    style: {
                                                                        width: 24,
                                                                        height: 24,
                                                                        border: `1px solid darkgrey`
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "inherit",
                                                                    children: option.label
                                                                })
                                                            ]
                                                        })
                                                    }, option.label))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            mt: 1
                                        },
                                        children: "Line"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $axXzj.MuiColorInput), {
                                                fullWidth: true,
                                                size: "small",
                                                label: "Color",
                                                isAlphaHidden: false,
                                                onChange: (value, colors)=>{
                                                    setSelectedShapes("stroke_style", colors.hex8);
                                                },
                                                value: shape?.stroke_style ?? ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                size: "small",
                                                fullWidth: true,
                                                label: "Line Style",
                                                select: true,
                                                value: shape?.line_style || "solid",
                                                onChange: (event)=>{
                                                    setSelectedShapes("line_style", event.target.value);
                                                },
                                                children: [
                                                    ...$e248307011085aba$export$a1205a8cc23056a6
                                                ].map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: option,
                                                        children: option
                                                    }, option))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                fullWidth: true,
                                                size: "small",
                                                type: "number",
                                                label: "Line Width",
                                                inputProps: {
                                                    min: 1,
                                                    max: 20,
                                                    step: 1
                                                },
                                                onChange: (event)=>{
                                                    setSelectedShapes("line_width", Number(event.target.value));
                                                },
                                                value: shape?.line_width ?? 1
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            mt: 1
                                        },
                                        children: "Text"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            fullWidth: true,
                                            size: "small",
                                            type: "number",
                                            label: "Font Size",
                                            inputProps: {
                                                min: 10,
                                                max: 64,
                                                step: 1
                                            },
                                            onChange: (event)=>{
                                                setSelectedShapes("font_size", Number(event.target.value));
                                            },
                                            value: shape?.font_size ?? 12
                                        })
                                    }),
                                    shape?.type === "Line" && shape?.text && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                                    checked: shape.metadata?.show_text !== false,
                                                    onChange: (e)=>{
                                                        const updatedShapes = shapes.map((s)=>{
                                                            if (activeShapes.includes(s.id) || s.id === contextMenu?.shapeId) return {
                                                                ...s,
                                                                metadata: {
                                                                    ...s.metadata,
                                                                    show_text: e.target.checked
                                                                }
                                                            };
                                                            return s;
                                                        });
                                                        setShapes(updatedShapes);
                                                    }
                                                }),
                                                label: "Show Text"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                fullWidth: true,
                                                size: "small",
                                                select: true,
                                                label: "Text Position",
                                                value: shape.metadata?.text_position || "middle",
                                                onChange: (e)=>{
                                                    const updatedShapes = shapes.map((s)=>{
                                                        if (activeShapes.includes(s.id) || s.id === contextMenu?.shapeId) return {
                                                            ...s,
                                                            metadata: {
                                                                ...s.metadata,
                                                                text_position: e.target.value
                                                            }
                                                        };
                                                        return s;
                                                    });
                                                    setShapes(updatedShapes);
                                                },
                                                SelectProps: {
                                                    MenuProps: {
                                                        PaperProps: {
                                                            sx: {
                                                                zIndex: 9999
                                                            }
                                                        }
                                                    }
                                                },
                                                children: $e248307011085aba$export$66e1bd537a5bf507.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: opt.value,
                                                        children: opt.label
                                                    }, opt.value))
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        showAlgorithmTab && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                            value: activeTab,
                            index: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 2,
                                children: [
                                    (shape?.tags?.includes("parkable") || shape?.tags?.includes("reference_line")) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                sx: {
                                                    mt: 2
                                                },
                                                children: "Algorithm Settings"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    mt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        gutterBottom: true,
                                                        children: "Priority (0-10, higher = preferred)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jU0bc.default), {
                                                        value: shape?.priority ?? 5,
                                                        onChange: (_, value)=>setSelectedShapes("priority", value),
                                                        min: 0,
                                                        max: 10,
                                                        step: 0.1,
                                                        marks: [
                                                            {
                                                                value: 0,
                                                                label: "0"
                                                            },
                                                            {
                                                                value: 5,
                                                                label: "5"
                                                            },
                                                            {
                                                                value: 10,
                                                                label: "10"
                                                            }
                                                        ],
                                                        valueLabelDisplay: "auto"
                                                    })
                                                ]
                                            }),
                                            shape?.tags?.includes("reference_line") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    mt: 2
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        gutterBottom: true,
                                                        children: "Aircraft Orientation (select all that apply)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                        direction: "column",
                                                        spacing: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                                    checked: (shape?.orientation || []).includes("nose_to_line"),
                                                                    onChange: (e)=>{
                                                                        const currentOrientations = shape?.orientation || [];
                                                                        if (e.target.checked) {
                                                                            if (!currentOrientations.includes("nose_to_line")) setSelectedShapes("orientation", [
                                                                                ...currentOrientations,
                                                                                "nose_to_line"
                                                                            ]);
                                                                        } else setSelectedShapes("orientation", currentOrientations.filter((o)=>o !== "nose_to_line"));
                                                                    }
                                                                }),
                                                                label: "Nose to Line"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                                    checked: (shape?.orientation || []).includes("tail_to_line"),
                                                                    onChange: (e)=>{
                                                                        const currentOrientations = shape?.orientation || [];
                                                                        if (e.target.checked) {
                                                                            if (!currentOrientations.includes("tail_to_line")) setSelectedShapes("orientation", [
                                                                                ...currentOrientations,
                                                                                "tail_to_line"
                                                                            ]);
                                                                        } else setSelectedShapes("orientation", currentOrientations.filter((o)=>o !== "tail_to_line"));
                                                                    }
                                                                }),
                                                                label: "Tail to Line"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    shape?.tags?.includes("spot") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            mt: 2,
                                            mb: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                gutterBottom: true,
                                                children: "Reference Points & Orientations"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                                size: "small",
                                                sx: {
                                                    mt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                    sx: {
                                                                        py: 0.5,
                                                                        px: 1
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                    align: "center",
                                                                    sx: {
                                                                        py: 0.5,
                                                                        px: 0.5,
                                                                        fontSize: "0.75rem"
                                                                    },
                                                                    children: "Nose"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                    align: "center",
                                                                    sx: {
                                                                        py: 0.5,
                                                                        px: 0.5,
                                                                        fontSize: "0.75rem"
                                                                    },
                                                                    children: "Tail"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                    align: "center",
                                                                    sx: {
                                                                        py: 0.5,
                                                                        px: 0.5,
                                                                        fontSize: "0.75rem"
                                                                    },
                                                                    children: "Center"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                                        children: [
                                                            {
                                                                name: "north",
                                                                label: "North",
                                                                tooltip: "Top edge center"
                                                            },
                                                            {
                                                                name: "south",
                                                                label: "South",
                                                                tooltip: "Bottom edge center"
                                                            },
                                                            {
                                                                name: "east",
                                                                label: "East",
                                                                tooltip: "Right edge center"
                                                            },
                                                            {
                                                                name: "west",
                                                                label: "West",
                                                                tooltip: "Left edge center"
                                                            },
                                                            {
                                                                name: "center",
                                                                label: "Center",
                                                                tooltip: "Centroid of the spot"
                                                            }
                                                        ].map((refPoint)=>{
                                                            const handleOrientationChange = (orientation, checked)=>{
                                                                const currentRefPoints = [
                                                                    ...shape?.reference_points || []
                                                                ];
                                                                const index = currentRefPoints.findIndex((rp)=>rp.name === refPoint.name);
                                                                if (checked) {
                                                                    if (index >= 0) {
                                                                        const currentOrientations = currentRefPoints[index].validOrientations;
                                                                        if (!currentOrientations.includes(orientation)) currentRefPoints[index].validOrientations = [
                                                                            ...currentOrientations,
                                                                            orientation
                                                                        ];
                                                                    } else currentRefPoints.push({
                                                                        name: refPoint.name,
                                                                        validOrientations: [
                                                                            orientation
                                                                        ]
                                                                    });
                                                                } else if (index >= 0) {
                                                                    const newOrientations = currentRefPoints[index].validOrientations.filter((o)=>o !== orientation);
                                                                    if (newOrientations.length === 0) currentRefPoints.splice(index, 1);
                                                                    else currentRefPoints[index].validOrientations = newOrientations;
                                                                }
                                                                setSelectedShapes("reference_points", currentRefPoints);
                                                            };
                                                            const refPointData = (shape?.reference_points || []).find((rp)=>rp.name === refPoint.name);
                                                            const isNoseChecked = refPointData?.validOrientations.includes("nose_to_line") || false;
                                                            const isTailChecked = refPointData?.validOrientations.includes("tail_to_line") || false;
                                                            const isCenterChecked = refPointData?.validOrientations.includes("center") || false;
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                        sx: {
                                                                            py: 0.5,
                                                                            px: 1
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                            direction: "row",
                                                                            alignItems: "center",
                                                                            spacing: 0.5,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                    variant: "body2",
                                                                                    children: refPoint.label
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                                    title: refPoint.tooltip,
                                                                                    placement: "right",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                                                        size: "small",
                                                                                        sx: {
                                                                                            p: 0
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                                                                            sx: {
                                                                                                fontSize: 14,
                                                                                                color: "text.secondary"
                                                                                            }
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                        align: "center",
                                                                        sx: {
                                                                            py: 0.5,
                                                                            px: 0.5
                                                                        },
                                                                        children: refPoint.name !== "center" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                                            size: "small",
                                                                            checked: isNoseChecked,
                                                                            onChange: (e)=>handleOrientationChange("nose_to_line", e.target.checked),
                                                                            sx: {
                                                                                p: 0
                                                                            }
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                            variant: "body2",
                                                                            color: "text.disabled",
                                                                            children: "-"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                        align: "center",
                                                                        sx: {
                                                                            py: 0.5,
                                                                            px: 0.5
                                                                        },
                                                                        children: refPoint.name !== "center" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                                            size: "small",
                                                                            checked: isTailChecked,
                                                                            onChange: (e)=>handleOrientationChange("tail_to_line", e.target.checked),
                                                                            sx: {
                                                                                p: 0
                                                                            }
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                            variant: "body2",
                                                                            color: "text.disabled",
                                                                            children: "-"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                        align: "center",
                                                                        sx: {
                                                                            py: 0.5,
                                                                            px: 0.5
                                                                        },
                                                                        children: refPoint.name === "center" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                                            size: "small",
                                                                            checked: isCenterChecked,
                                                                            onChange: (e)=>handleOrientationChange("center", e.target.checked),
                                                                            sx: {
                                                                                p: 0
                                                                            }
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                            variant: "body2",
                                                                            color: "text.disabled",
                                                                            children: "-"
                                                                        })
                                                                    })
                                                                ]
                                                            }, refPoint.name);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    shape?.type === "Spot" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eF1ay.SpotPropertiesSection), {
                                        shape: shape,
                                        shapes: shapes,
                                        activeShapes: activeShapes,
                                        contextMenu: contextMenu,
                                        setShapes: setShapes,
                                        canvasWidth: canvasWidth,
                                        previewSpots: previewSpots,
                                        setPreviewSpots: setPreviewSpots
                                    }),
                                    shape?.type === "Zone" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            mt: 2,
                                            mb: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle2",
                                                gutterBottom: true,
                                                children: "Zone Properties"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 2,
                                                sx: {
                                                    mt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                                            checked: shape.metadata?.disabled || false,
                                                            onChange: (e)=>{
                                                                const updatedShapes = shapes.map((s)=>{
                                                                    if (activeShapes.includes(s.id) || s.id === contextMenu?.shapeId) return {
                                                                        ...s,
                                                                        metadata: {
                                                                            ...s.metadata,
                                                                            disabled: e.target.checked
                                                                        }
                                                                    };
                                                                    return s;
                                                                });
                                                                setShapes(updatedShapes);
                                                            }
                                                        }),
                                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            alignItems: "center",
                                                            spacing: 0.5,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: "Disabled (exclude all spots in zone)"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                    title: "When enabled, all spots in this zone will be unavailable to the parking algorithm. Use for closing entire zones during maintenance or construction.",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                                        size: "small",
                                                                        sx: {
                                                                            p: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                                                            sx: {
                                                                                fontSize: 14,
                                                                                color: "text.secondary"
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                                            checked: shape.metadata?.is_staging || false,
                                                            onChange: (e)=>{
                                                                const updatedShapes = shapes.map((s)=>{
                                                                    if (activeShapes.includes(s.id) || s.id === contextMenu?.shapeId) return {
                                                                        ...s,
                                                                        metadata: {
                                                                            ...s.metadata,
                                                                            is_staging: e.target.checked
                                                                        }
                                                                    };
                                                                    return s;
                                                                });
                                                                setShapes(updatedShapes);
                                                            }
                                                        }),
                                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            alignItems: "center",
                                                            spacing: 0.5,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: "Staging Area"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                    title: "Mark this zone as a staging area for aircraft servicing. When staging workflow is enabled, long-stay aircraft will use staging zones for arrival/departure servicing operations before/after permanent parking. Typical use: areas near fuel trucks, maintenance facilities, or passenger terminals.",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                                        size: "small",
                                                                        sx: {
                                                                            p: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                                                            sx: {
                                                                                fontSize: 14,
                                                                                color: "text.secondary"
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                        size: "small",
                                                        fullWidth: true,
                                                        label: "Zone Name",
                                                        value: shape?.text || "",
                                                        onChange: (e)=>setSelectedShapes("text", e.target.value),
                                                        placeholder: "e.g., A, B, North, Transient",
                                                        helperText: "Zone name used for spot naming (e.g., 'A' \u2192 A01, A02)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "body2",
                                                                gutterBottom: true,
                                                                children: "Priority (0-10, higher = preferred)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jU0bc.default), {
                                                                value: shape?.priority ?? 5,
                                                                onChange: (_, value)=>setSelectedShapes("priority", value),
                                                                min: 0,
                                                                max: 10,
                                                                step: 1,
                                                                marks: [
                                                                    {
                                                                        value: 0,
                                                                        label: "0"
                                                                    },
                                                                    {
                                                                        value: 5,
                                                                        label: "5"
                                                                    },
                                                                    {
                                                                        value: 10,
                                                                        label: "10"
                                                                    }
                                                                ],
                                                                valueLabelDisplay: "auto"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "caption",
                                                                color: "text.secondary",
                                                                children: "Higher priority zones preferred in temporal parking"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        p: 2,
                        borderTop: 1,
                        borderColor: "divider",
                        flexShrink: 0,
                        bgcolor: "background.paper"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                color: "error",
                                onClick: ()=>{
                                    // delete this shape and all selected shapes
                                    const updatedShapes = shapes.filter((s)=>!activeShapes.includes(s.id) && s.id !== contextMenu.shapeId);
                                    setActiveShapes([]);
                                    setShapes(updatedShapes);
                                    setContextMenu(null);
                                },
                                children: "Delete"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>{
                                            // Ensure we have a valid ramp context
                                            if (!ramp || !ramp.id || !ramp.fbo_id) {
                                                console.error("Cannot copy shape - ramp not properly loaded");
                                                return;
                                            }
                                            const updatedShapes = [
                                                ...shapes
                                            ];
                                            updatedShapes.push({
                                                ...shape,
                                                id: (0, $lNEp2.uuidv4)(),
                                                // Generate new ID for the copied shape
                                                ramp_id: ramp.id,
                                                // Explicitly use current ramp's ID
                                                fbo_id: ramp.fbo_id // Explicitly use current FBO's ID
                                            });
                                            setShapes(updatedShapes);
                                        },
                                        children: "Copy"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: onClose,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "contained",
                                        onClick: ()=>{
                                            // Re-detect required spots if this is a gap spot
                                            if (shape?.type === "Spot" && shape.metadata?.isGapSpot) {
                                                const requiredSpotIds = (0, $9s9MA.detectRequiredSpots)(shape, shapes);
                                                const updatedShapes = shapes.map((s)=>{
                                                    if (s.id === shape.id) return {
                                                        ...s,
                                                        metadata: {
                                                            ...s.metadata,
                                                            requiresOccupiedSpots: requiredSpotIds
                                                        }
                                                    };
                                                    return s;
                                                });
                                                setShapes(updatedShapes);
                                            }
                                            onClose();
                                        },
                                        children: "OK"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("ipR47", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d683b97fd1dcbc68$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d683b97fd1dcbc68$var$_createSvgIcon = $d683b97fd1dcbc68$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d683b97fd1dcbc68$var$_default = module.exports.default = (0, $d683b97fd1dcbc68$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');

});

parcelRegister("2Ed4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ed9758f3bc045cc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $bJeVA = parcelRequire("bJeVA");

var $118QM = parcelRequire("118QM");

var $6FKde = parcelRequire("6FKde");

var $7Frhn = parcelRequire("7Frhn");

var $jTnBY = parcelRequire("jTnBY");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $4G59M = parcelRequire("4G59M");

var $6lpak = parcelRequire("6lpak");

var $f8X1n = parcelRequire("f8X1n");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ed9758f3bc045cc$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $1ed9758f3bc045cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, $jTnBY.default)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $jTnBY.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $jTnBY.default)(anchor)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4G59M.getDrawerUtilityClass), classes);
};
const $1ed9758f3bc045cc$var$DrawerRoot = (0, $d8seH.default)((0, $118QM.default), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})((0, $aeD7H.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $1ed9758f3bc045cc$var$DrawerDockedRoot = (0, $d8seH.default)('div', {
    shouldForwardProp: (0, $8Uq77.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $1ed9758f3bc045cc$var$DrawerPaper = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $jTnBY.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $jTnBY.default)(ownerState.anchor)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $1ed9758f3bc045cc$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $1ed9758f3bc045cc$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function $1ed9758f3bc045cc$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $1ed9758f3bc045cc$export$2a62b49acb270576(anchor) ? $1ed9758f3bc045cc$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $1ed9758f3bc045cc$var$Drawer = /*#__PURE__*/ $acw62.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $bJeVA.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $1ed9758f3bc045cc$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant,
        ...other
    };
    const classes = $1ed9758f3bc045cc$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            paper: PaperProps,
            transition: SlideProps,
            ...slotProps,
            backdrop: (0, $f8X1n.default)(slotProps.backdrop || {
                ...BackdropProps,
                ...BackdropPropsProp
            }, {
                transitionDuration: transitionDuration
            })
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $1ed9758f3bc045cc$var$DrawerRoot,
        className: (0, $9QePP.default)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            ...ModalProps
        },
        additionalProps: {
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, $6lpak.default)('paper', {
        elementType: $1ed9758f3bc045cc$var$DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, $9QePP.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, $6lpak.default)('docked', {
        elementType: $1ed9758f3bc045cc$var$DrawerDockedRoot,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $6FKde.default),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: $1ed9758f3bc045cc$var$oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    });
    const drawer = /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
        ...paperSlotProps,
        children: children
    });
    if (variant === 'permanent') return /*#__PURE__*/ (0, $ayMG0.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        ...transitionSlotProps,
        children: drawer
    });
    if (variant === 'persistent') return /*#__PURE__*/ (0, $ayMG0.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: slidingDrawer
    });
});
var $1ed9758f3bc045cc$export$2e2bcd8739ae039 = $1ed9758f3bc045cc$var$Drawer;

});
parcelRegister("6FKde", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dba6b402693f5d6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $1mPeS = parcelRequire("1mPeS");




var $2xc7G = parcelRequire("2xc7G");

var $1iGrQ = parcelRequire("1iGrQ");

var $9Rgf1 = parcelRequire("9Rgf1");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Evvr = parcelRequire("9Evvr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $9Evvr.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4dba6b402693f5d6$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $4dba6b402693f5d6$var$resolveContainer(containerProp);
    const transform = $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4dba6b402693f5d6$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    const theme = (0, $14H9o.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const childrenRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)((0, $2xc7G.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $hweuE.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create('transform', {
            ...transitionProps
        });
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $acw62.useCallback(()=>{
        if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $1iGrQ.default)(()=>{
            if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $9Evvr.default)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var $4dba6b402693f5d6$export$2e2bcd8739ae039 = $4dba6b402693f5d6$var$Slide;

});

parcelRegister("4G59M", function(module, exports) {

$parcel$export(module.exports, "getDrawerUtilityClass", () => $367f15b5d414b8d7$export$b801318a856c9cd2);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $367f15b5d414b8d7$export$b801318a856c9cd2(slot) {
    return (0, $4Cod0.default)('MuiDrawer', slot);
}
const $367f15b5d414b8d7$var$drawerClasses = (0, $beCSm.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $367f15b5d414b8d7$export$2e2bcd8739ae039 = $367f15b5d414b8d7$var$drawerClasses;

});


parcelRegister("lTOh0", function(module, exports) {

$parcel$export(module.exports, "TabPanel", () => $54f1185d5c2a9ece$export$3d96ec278d3efce4);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
parcelRequire("acw62");
function $54f1185d5c2a9ece$export$3d96ec278d3efce4(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `tabpanel-${index}`,
        "aria-labelledby": `tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
            sx: {
                p: 2
            },
            children: children
        })
    });
}

});

parcelRegister("eF1ay", function(module, exports) {

$parcel$export(module.exports, "SpotPropertiesSection", () => $f57f61b610b94918$export$cfbe1fae3ec8e80b);

var $ayMG0 = parcelRequire("ayMG0");

var $22J5Z = parcelRequire("22J5Z");

var $ipR47 = parcelRequire("ipR47");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $6ami2 = parcelRequire("6ami2");
var $gd5y7 = parcelRequire("gd5y7");
var $2esSG = parcelRequire("2esSG");
var $6Tegk = parcelRequire("6Tegk");
var $9Lykx = parcelRequire("9Lykx");
var $19ocJ = parcelRequire("19ocJ");
var $2iAqv = parcelRequire("2iAqv");
var $cX7V2 = parcelRequire("cX7V2");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $kzQHY = parcelRequire("kzQHY");

var $ceJla = parcelRequire("ceJla");

var $67btB = parcelRequire("67btB");

var $hUlRk = parcelRequire("hUlRk");

var $5nYIu = parcelRequire("5nYIu");

var $9s9MA = parcelRequire("9s9MA");
const $f57f61b610b94918$export$cfbe1fae3ec8e80b = ({ shape: shape, shapes: shapes, activeShapes: activeShapes, contextMenu: contextMenu, setShapes: setShapes, canvasWidth: canvasWidth, setPreviewSpots: setPreviewSpots })=>{
    const { ramp: ramp } = (0, $ceJla.useLocalRampState)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [tileAnchorEl, setTileAnchorEl] = $acw62.useState(null);
    const [bufferFeet, setBufferFeet] = $acw62.useState(0);
    // Calculate actual spot dimensions using edge lengths (works for any rotation)
    const spotPixelSize = $acw62.useMemo(()=>{
        if (!shape.points || shape.points.length < 2) return 100; // fallback
        // Calculate actual edge lengths (not axis-aligned bounding box)
        const edge1Length = Math.sqrt(Math.pow(shape.points[1].x - shape.points[0].x, 2) + Math.pow(shape.points[1].y - shape.points[0].y, 2));
        if (shape.points.length < 3) return edge1Length;
        const edge2Length = Math.sqrt(Math.pow(shape.points[2].x - shape.points[1].x, 2) + Math.pow(shape.points[2].y - shape.points[1].y, 2));
        return Math.max(edge1Length, edge2Length);
    }, [
        shape.points
    ]);
    // Convert pixel size to feet using ramp scale
    const pixelsToFeetRatio = canvasWidth / (ramp?.width ?? 1);
    const spotFeet = Math.round(spotPixelSize / pixelsToFeetRatio);
    const pixelsPerFoot = pixelsToFeetRatio;
    const spotCategory = (0, $67btB.getDefaultSizeCategory)(spotFeet);
    const maxAllowed = (0, $67btB.getMaxAllowedSizes)(spotCategory);
    // Current values
    const currentAllowed = shape.metadata?.allowedSizes || [
        spotCategory
    ];
    const currentLaneIds = shape.metadata?.egressLanes || [];
    // Available egress lanes (sorted alphabetically by text)
    const egressLanes = shapes.filter((s)=>s.tags?.includes("egress_lane")).sort((a, b)=>{
        const aText = a.text || `Lane ${a.id.slice(0, 8)}`;
        const bText = b.text || `Lane ${b.id.slice(0, 8)}`;
        return aText.localeCompare(bText);
    });
    // Helper to update metadata
    const updateMetadata = (updates)=>{
        const updatedShapes = shapes.map((s)=>{
            if (activeShapes.includes(s.id) || s.id === contextMenu?.shapeId) return {
                ...s,
                metadata: {
                    ...s.metadata,
                    ...updates
                }
            };
            return s;
        });
        setShapes(updatedShapes);
    };
    // Handle tile grid hover - update preview
    const handleTileHover = (rows, cols)=>{
        if (!ramp?.id || !ramp?.fbo_id) return;
        const bufferPixels = bufferFeet * pixelsPerFoot;
        const tiledSpots = (0, $5nYIu.tileSpot)(shape, rows, cols, bufferPixels, ramp.id, ramp.fbo_id);
        const updatedShapes = [
            ...shapes,
            ...tiledSpots
        ];
        const namedShapes = (0, $5nYIu.calculateSpotNames)(updatedShapes);
        // Extract only the newly added spots (last N items) with their calculated names
        const namedTiledSpots = namedShapes.slice(-tiledSpots.length);
        setPreviewSpots(namedTiledSpots);
    };
    // Handle tile grid selection - add spots to canvas
    const handleTileSelect = (rows, cols)=>{
        if (!ramp?.id || !ramp?.fbo_id) return;
        const bufferPixels = bufferFeet * pixelsPerFoot;
        const tiledSpots = (0, $5nYIu.tileSpot)(shape, rows, cols, bufferPixels, ramp.id, ramp.fbo_id);
        const updatedShapes = [
            ...shapes,
            ...tiledSpots
        ];
        const namedShapes = (0, $5nYIu.calculateSpotNames)(updatedShapes);
        setShapes(namedShapes);
        setPreviewSpots([]);
    };
    // Handle tile picker close - clear preview
    const handleTileClose = ()=>{
        setTileAnchorEl(null);
        setPreviewSpots([]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                            checked: shape.metadata?.disabled || false,
                            onChange: (e)=>updateMetadata({
                                    disabled: e.target.checked
                                })
                        }),
                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 0.5,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Disabled (exclude from algorithm)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "When enabled, this spot will be unavailable to the parking algorithm. Use for maintenance or construction.",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            sx: {
                                                fontSize: 14,
                                                color: "text.secondary"
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 0.5,
                            sx: {
                                mb: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Allowed Aircraft Sizes"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Spots can only allow aircraft sizes \u2264 their own size.",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            sx: {
                                                fontSize: 14,
                                                color: "text.secondary"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "caption",
                            sx: {
                                display: "block",
                                mb: 1,
                                fontWeight: 600
                            },
                            children: [
                                "This spot: ",
                                spotFeet,
                                "ft = ",
                                spotCategory.toUpperCase()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Tegk.default), {
                            children: (0, $67btB.SIZE_CATEGORY_OPTIONS).map((size)=>{
                                const isAllowed = maxAllowed.includes(size.value);
                                const isChecked = currentAllowed.includes(size.value);
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    disabled: !isAllowed,
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                        size: "small",
                                        checked: isChecked,
                                        onChange: (e)=>{
                                            const updated = e.target.checked ? [
                                                ...currentAllowed,
                                                size.value
                                            ] : currentAllowed.filter((s)=>s !== size.value);
                                            updateMetadata({
                                                allowedSizes: updated
                                            });
                                        }
                                    }),
                                    label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: isAllowed ? "text.primary" : "text.disabled",
                                        children: [
                                            size.label,
                                            " ",
                                            !isAllowed && "(too large)"
                                        ]
                                    })
                                }, size.value);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 0.5,
                            sx: {
                                mb: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Egress Lanes"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Select egress lanes this spot can use. Create lanes by drawing Lines and tagging them 'egress_lane'.",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            sx: {
                                                fontSize: 14,
                                                color: "text.secondary"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                            fullWidth: true,
                            size: "small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                                multiple: true,
                                value: currentLaneIds,
                                onChange: (e)=>updateMetadata({
                                        egressLanes: e.target.value
                                    }),
                                renderValue: (selected)=>{
                                    const names = selected.map((id)=>egressLanes.find((l)=>l.id === id)?.text || id).join(", ");
                                    return names || "None selected";
                                },
                                children: [
                                    egressLanes.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        disabled: true,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                            children: 'No egress lanes defined (draw Lines tagged "egress_lane")'
                                        })
                                    }),
                                    egressLanes.map((lane)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                            value: lane.id,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                    checked: currentLaneIds.includes(lane.id)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                                    primary: lane.text || `Lane ${lane.id.slice(0, 8)}`
                                                })
                                            ]
                                        }, lane.id))
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 0.5,
                            sx: {
                                mb: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Gap Spot"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Mark this spot as a gap spot - smaller spot that overlaps larger spots spatially. Becomes available when surrounding larger spots are occupied.",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            sx: {
                                                fontSize: 14,
                                                color: "text.secondary"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                size: "small",
                                checked: shape.metadata?.isGapSpot || false,
                                onChange: (e)=>{
                                    const isChecked = e.target.checked;
                                    const updates = {
                                        isGapSpot: isChecked
                                    };
                                    // Auto-detect required spots when checked
                                    if (isChecked) {
                                        const requiredSpotIds = (0, $9s9MA.detectRequiredSpots)(shape, shapes);
                                        updates.requiresOccupiedSpots = requiredSpotIds;
                                    } else // Clear when unchecked
                                    updates.requiresOccupiedSpots = [];
                                    updateMetadata(updates);
                                }
                            }),
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                children: "This is a gap spot"
                            })
                        }),
                        shape.metadata?.isGapSpot && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                mt: 1,
                                ml: 4
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    sx: {
                                        display: "block",
                                        mb: 0.5
                                    },
                                    children: "Required Occupied Spots (auto-detected):"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 0.5,
                                    flexWrap: "wrap",
                                    children: (shape.metadata?.requiresOccupiedSpots || []).length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: "None detected"
                                    }) : (shape.metadata?.requiresOccupiedSpots || []).map((id)=>{
                                        const spot = shapes.find((s)=>s.id === id && s.type === "Spot");
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: spot?.text || id.slice(0, 8),
                                            size: "small",
                                            disabled: true
                                        }, id);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 0.5,
                            sx: {
                                mb: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Max Dwell Time"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Maximum time (in minutes) aircraft can stay in this spot. Leave empty for no limit. Use for overflow/emergency spots.",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            sx: {
                                                fontSize: 14,
                                                color: "text.secondary"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            fullWidth: true,
                            size: "small",
                            type: "number",
                            label: "Minutes",
                            placeholder: "No limit",
                            inputProps: {
                                min: 0,
                                step: 15
                            },
                            value: shape.metadata?.max_dwell_minutes ?? "",
                            onChange: (e)=>{
                                const value = e.target.value === "" ? undefined : Number(e.target.value);
                                updateMetadata({
                                    max_dwell_minutes: value
                                });
                            },
                            helperText: "Examples: 60 (1 hour), 180 (3 hours), 1440 (1 day)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 0.5,
                            sx: {
                                mb: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Min Dwell Time"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Minimum time (in minutes) aircraft should stay in this spot. Aircraft staying longer get priority placement here. Use for remote/overflow spots to sequester long-stay aircraft.",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            sx: {
                                                fontSize: 14,
                                                color: "text.secondary"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            fullWidth: true,
                            size: "small",
                            type: "number",
                            label: "Minutes",
                            placeholder: "No minimum",
                            inputProps: {
                                min: 0,
                                step: 15
                            },
                            value: shape.metadata?.min_dwell_minutes ?? "",
                            onChange: (e)=>{
                                const value = e.target.value === "" ? undefined : Number(e.target.value);
                                updateMetadata({
                                    min_dwell_minutes: value
                                });
                            },
                            helperText: "Examples: 480 (8 hours), 1440 (1 day), 4320 (3 days)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 0.5,
                            sx: {
                                mb: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Blocking Spots (by lane)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Spots blocked during egress, calculated per lane. Aircraft uses lane with fewest blocks. Run 'Calculate Blocked Spots' to update.",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            sx: {
                                                fontSize: 14,
                                                color: "text.secondary"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        (shape.metadata?.egressOptions || []).length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            children: 'None (run "Calculate Blocked Spots")'
                        }) : // Multi-lane display
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            spacing: 1,
                            children: (shape.metadata?.egressOptions || []).map((option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                fontWeight: 600,
                                                display: "block"
                                            },
                                            children: [
                                                option.laneName,
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                            direction: "row",
                                            spacing: 0.5,
                                            flexWrap: "wrap",
                                            sx: {
                                                mt: 0.5
                                            },
                                            children: option.blocksSpotIds.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: "No blocks"
                                            }) : option.blocksSpotIds.map((id)=>{
                                                const spot = shapes.find((s)=>s.id === id && s.type === "Spot");
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                    label: spot?.text || id.slice(0, 8),
                                                    size: "small",
                                                    disabled: true
                                                }, id);
                                            })
                                        })
                                    ]
                                }, option.laneId))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 0.5,
                            sx: {
                                mb: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Tiling"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Create a grid of duplicate spots based on this spot's size and properties",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            sx: {
                                                fontSize: 14,
                                                color: "text.secondary"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "outlined",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22J5Z))), {}),
                                    onClick: (e)=>setTileAnchorEl(e.currentTarget),
                                    size: "small",
                                    children: "Tile Spot"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                    size: "small",
                                    label: "Buffer",
                                    value: bufferFeet,
                                    onChange: (valueInFeet)=>setBufferFeet(Math.max(0, valueInFeet || 0)),
                                    sx: {
                                        width: 85
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUlRk.SpotTilePicker), {
                            anchorEl: tileAnchorEl,
                            open: Boolean(tileAnchorEl),
                            onClose: handleTileClose,
                            onSelect: handleTileSelect,
                            onHover: handleTileHover
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("22J5Z", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $17cebfbf0aacdf60$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17cebfbf0aacdf60$var$_createSvgIcon = $17cebfbf0aacdf60$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $17cebfbf0aacdf60$var$_default = module.exports.default = (0, $17cebfbf0aacdf60$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M8 20H4v-4h4zm0-6H4v-4h4zm0-6H4V4h4zm6 12h-4v-4h4zm0-6h-4v-4h4zm0-6h-4V4h4zm6 12h-4v-4h4zm0-6h-4v-4h4zm0-6h-4V4h4z"
}), 'GridOn');

});

parcelRegister("hUlRk", function(module, exports) {

$parcel$export(module.exports, "SpotTilePicker", () => $fbab152c4ba3d558$export$7e5deafb7af078c1);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $cJu23 = parcelRequire("cJu23");
var $7Frhn = parcelRequire("7Frhn");
var $6el2W = parcelRequire("6el2W");
var $3bYfT = parcelRequire("3bYfT");
const $fbab152c4ba3d558$var$MAX_GRID_SIZE = 10;
const $fbab152c4ba3d558$export$7e5deafb7af078c1 = ({ anchorEl: anchorEl, open: open, onClose: onClose, onSelect: onSelect, onHover: onHover })=>{
    const [hoveredCell, setHoveredCell] = $acw62.useState(null);
    const handleCellHover = (row, col)=>{
        setHoveredCell({
            row: row,
            col: col
        });
        onHover(row + 1, col + 1); // +1 because we want 1-indexed for display
    };
    const handleCellClick = (row, col)=>{
        onSelect(row + 1, col + 1); // +1 because we want 1-indexed
        onClose();
    };
    const handleClose = ()=>{
        setHoveredCell(null);
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
        open: open,
        anchorEl: anchorEl,
        onClose: handleClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            sx: {
                p: 2
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                    container: true,
                    spacing: 0.5,
                    sx: {
                        width: 220
                    },
                    children: Array.from({
                        length: $fbab152c4ba3d558$var$MAX_GRID_SIZE
                    }).map((_, row)=>/*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                            children: Array.from({
                                length: $fbab152c4ba3d558$var$MAX_GRID_SIZE
                            }).map((_, col)=>{
                                const isHighlighted = hoveredCell && row <= hoveredCell.row && col <= hoveredCell.col;
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                                    item: true,
                                    xs: 1.2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                                        elevation: isHighlighted ? 2 : 0,
                                        sx: {
                                            width: 18,
                                            height: 18,
                                            backgroundColor: isHighlighted ? "primary.main" : "action.hover",
                                            cursor: "pointer",
                                            transition: "all 0.1s",
                                            "&:hover": {
                                                backgroundColor: "primary.light"
                                            }
                                        },
                                        onMouseEnter: ()=>handleCellHover(row, col),
                                        onClick: ()=>handleCellClick(row, col)
                                    })
                                }, `${row}-${col}`);
                            })
                        }, row))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body2",
                    align: "center",
                    sx: {
                        mt: 1,
                        fontWeight: "bold"
                    },
                    children: hoveredCell ? `${hoveredCell.row + 1} \xd7 ${hoveredCell.col + 1}` : "Hover to select"
                })
            ]
        })
    });
};

});
parcelRegister("cJu23", function(module, exports) {

$parcel$export(module.exports, "default", () => $9450fbc34cc5b2ea$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $fkf5V = parcelRequire("fkf5V");

var $6hiu6 = parcelRequire("6hiu6");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $14H9o = parcelRequire("14H9o");

var $jnQKR = parcelRequire("jnQKR");

var $kTnYy = parcelRequire("kTnYy");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $fkf5V.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${themeSpacing})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = {
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width,
                ...more
            };
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $fkf5V.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $fkf5V.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.startsWith('column')) output[`& > .${(0, $kTnYy.default).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $fkf5V.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $fkf5V.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `calc(-1 * ${themeSpacing})`,
                [`& > .${(0, $kTnYy.default).item}`]: {
                    paddingTop: themeSpacing
                }
            };
            if (zeroValueBreakpointKeys?.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $kTnYy.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $fkf5V.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $fkf5V.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') {
                const negativeValue = `calc(-1 * ${themeSpacing})`;
                return {
                    width: `calc(100% + ${themeSpacing})`,
                    marginLeft: negativeValue,
                    [`& > .${(0, $kTnYy.default).item}`]: {
                        paddingLeft: themeSpacing
                    }
                };
            }
            if (zeroValueBreakpointKeys?.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $kTnYy.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $d8seH.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(// FIXME(romgrk): Can't use memoTheme here
({ ownerState: ownerState })=>({
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%'
        },
        ...ownerState.item && {
            margin: 0 // For instance, it's useful when used with a `figure` element.
        },
        ...ownerState.zeroMinWidth && {
            minWidth: 0
        },
        ...ownerState.wrap !== 'wrap' && {
            flexWrap: ownerState.wrap
        }
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kTnYy.getGridUtilityClass), classes);
};
/**
 * @deprecated Use the [`Grid2`](https://mui.com/material-ui/react-grid2/) component instead.
 */ const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $14H9o.default)();
    const props = (0, $6hiu6.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false, ...other } = props;
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $jnQKR.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = {
        ...other
    };
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = {
        ...props,
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing,
        ...breakpointsValues,
        breakpoints: breakpoints.keys
    };
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jnQKR.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9450fbc34cc5b2ea$var$GridRoot, {
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            ...otherFiltered
        })
    });
});
var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;

});
parcelRegister("jnQKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c9164ec15102c7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;

});

parcelRegister("kTnYy", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", () => $f35b8acab3fc2f62$export$9973ac5fd0181f33);
$parcel$export(module.exports, "default", () => $f35b8acab3fc2f62$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $4Cod0.default)('MuiGrid', slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f35b8acab3fc2f62$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $beCSm.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;

});



parcelRegister("5nYIu", function(module, exports) {

$parcel$export(module.exports, "calculateBlockedSpots", () => $ed0c90ce9469110f$export$6f4c0be5e27e762e);
$parcel$export(module.exports, "assignSpotsToZones", () => $ed0c90ce9469110f$export$ef7f9007e308733d);
$parcel$export(module.exports, "calculateSpotNames", () => $ed0c90ce9469110f$export$16bee1eb9d59b1a2);
$parcel$export(module.exports, "tileSpot", () => $ed0c90ce9469110f$export$28f278c3713bb08b);
/**
 * Spot Helper Functions for Egress Blocking Calculation
 * Calculates which spots block other spots during egress based on spatial geometry
 */ function $ed0c90ce9469110f$export$fede11584128d629(spot) {
    if (!spot.points || spot.points.length === 0) return {
        x: 0,
        y: 0
    };
    const xs = spot.points.map((p)=>p.x);
    const ys = spot.points.map((p)=>p.y);
    return {
        x: (Math.min(...xs) + Math.max(...xs)) / 2,
        y: (Math.min(...ys) + Math.max(...ys)) / 2
    };
}
function $ed0c90ce9469110f$export$c7e3680d669d8c6c(spot) {
    if (!spot.points || spot.points.length === 0) return 0;
    const xs = spot.points.map((p)=>p.x);
    const ys = spot.points.map((p)=>p.y);
    const width = Math.max(...xs) - Math.min(...xs);
    const height = Math.max(...ys) - Math.min(...ys);
    return Math.max(width, height);
}
function $ed0c90ce9469110f$export$85a9612c57b714b(point, linePoints) {
    if (linePoints.length === 0) return point;
    if (linePoints.length === 1) return linePoints[0];
    let nearestPoint = linePoints[0];
    let minDistance = Infinity;
    // Check each line segment
    for(let i = 0; i < linePoints.length - 1; i++){
        const segmentStart = linePoints[i];
        const segmentEnd = linePoints[i + 1];
        const nearest = $ed0c90ce9469110f$var$nearestPointOnSegment(point, segmentStart, segmentEnd);
        const distance = $ed0c90ce9469110f$var$distanceBetweenPoints(point, nearest);
        if (distance < minDistance) {
            minDistance = distance;
            nearestPoint = nearest;
        }
    }
    return nearestPoint;
}
/**
 * Find the nearest point on a line segment to a given point
 */ function $ed0c90ce9469110f$var$nearestPointOnSegment(point, segmentStart, segmentEnd) {
    const dx = segmentEnd.x - segmentStart.x;
    const dy = segmentEnd.y - segmentStart.y;
    // If segment is actually a point
    if (dx === 0 && dy === 0) return segmentStart;
    // Calculate parameter t for point projection
    const t = Math.max(0, Math.min(1, ((point.x - segmentStart.x) * dx + (point.y - segmentStart.y) * dy) / (dx * dx + dy * dy)));
    return {
        x: segmentStart.x + t * dx,
        y: segmentStart.y + t * dy
    };
}
/**
 * Calculate distance between two points
 */ function $ed0c90ce9469110f$var$distanceBetweenPoints(p1, p2) {
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
}
function $ed0c90ce9469110f$export$7f6bc8d3d7d61b11(point, polygon) {
    if (polygon.length < 3) return false;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > point.y !== yj > point.y && point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $ed0c90ce9469110f$export$4bebce3efc71a095(start, end, width) {
    // Calculate direction vector
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const length = Math.sqrt(dx * dx + dy * dy);
    // Handle case where start and end are the same
    if (length === 0) {
        const halfWidth = width / 2;
        return [
            {
                x: start.x - halfWidth,
                y: start.y - halfWidth
            },
            {
                x: start.x + halfWidth,
                y: start.y - halfWidth
            },
            {
                x: start.x + halfWidth,
                y: start.y + halfWidth
            },
            {
                x: start.x - halfWidth,
                y: start.y + halfWidth
            }
        ];
    }
    // Normalize direction vector
    const ux = dx / length;
    const uy = dy / length;
    // Perpendicular vector (rotated 90 degrees)
    const px = -uy;
    const py = ux;
    // Half width offset
    const halfWidth = width / 2;
    // Create rectangle corners
    return [
        {
            x: start.x + px * halfWidth,
            y: start.y + py * halfWidth
        },
        {
            x: end.x + px * halfWidth,
            y: end.y + py * halfWidth
        },
        {
            x: end.x - px * halfWidth,
            y: end.y - py * halfWidth
        },
        {
            x: start.x - px * halfWidth,
            y: start.y - py * halfWidth
        }
    ];
}
function $ed0c90ce9469110f$export$4d52d1ebaf6857b4(poly1, poly2) {
    // Edge case: empty polygons
    if (poly1.length < 3 || poly2.length < 3) return false;
    // Test all edges from both polygons as potential separating axes
    return !$ed0c90ce9469110f$var$isSeparated(poly1, poly2) && !$ed0c90ce9469110f$var$isSeparated(poly2, poly1);
}
/**
 * Check if there's a separating axis between two polygons
 * If we find a separating axis, polygons don't intersect
 */ function $ed0c90ce9469110f$var$isSeparated(poly1, poly2) {
    for(let i = 0; i < poly1.length; i++){
        const p1 = poly1[i];
        const p2 = poly1[(i + 1) % poly1.length];
        // Get edge vector and perpendicular (normal)
        const edge = {
            x: p2.x - p1.x,
            y: p2.y - p1.y
        };
        const normal = {
            x: -edge.y,
            y: edge.x
        };
        // Project both polygons onto this axis
        const [min1, max1] = $ed0c90ce9469110f$var$projectPolygon(poly1, normal);
        const [min2, max2] = $ed0c90ce9469110f$var$projectPolygon(poly2, normal);
        // Check for gap (separation)
        if (max1 < min2 || max2 < min1) return true; // Found separating axis
    }
    return false; // No separating axis found
}
/**
 * Project a polygon onto an axis and return min/max values
 */ function $ed0c90ce9469110f$var$projectPolygon(polygon, axis) {
    let min = Infinity;
    let max = -Infinity;
    for (const point of polygon){
        const projection = point.x * axis.x + point.y * axis.y;
        min = Math.min(min, projection);
        max = Math.max(max, projection);
    }
    return [
        min,
        max
    ];
}
function $ed0c90ce9469110f$export$6f4c0be5e27e762e(shapes) {
    const logs = [];
    let totalBlockingRelationships = 0;
    let spotsWithEgress = 0;
    let spotsWithoutEgress = 0;
    // 1. Create new array and initialize all spots with empty egressOptions
    const updatedShapes = shapes.map((s)=>{
        if (s.type === "Spot") return {
            ...s,
            metadata: {
                ...s.metadata,
                blocksSpotIds: [],
                egressOptions: [] // Initialize empty for all spots
            }
        };
        return s;
    });
    // 2. Get spots and egress lanes
    const spots = updatedShapes.filter((s)=>s.type === "Spot");
    const lanes = updatedShapes.filter((s)=>s.tags?.includes("egress_lane"));
    // 3. For each spot with egress lane, find which spots it would be blocked by
    // Key insight: If spotA's corridor to egress intersects spotB, then spotB BLOCKS spotA
    // (not the other way around - spotB is in the way of spotA's departure)
    // Track which spots have egress lanes for logging
    const spotsWithEgressLanes = new Set();
    const blockingMap = new Map(); // blocker spotId -> list of spots it blocks
    for (const spotA of spots){
        const metadata = spotA.metadata;
        const egressLanes = metadata?.egressLanes || [];
        const spotName = spotA.text || `Spot ${spotA.id.slice(0, 8)}`;
        // Skip if no egress lane defined
        if (egressLanes.length === 0) {
            spotsWithoutEgress++;
            continue;
        }
        spotsWithEgress++;
        spotsWithEgressLanes.add(spotA.id);
        // For each egress lane option that spotA has
        for (const laneId of egressLanes){
            const lane = lanes.find((l)=>l.id === laneId);
            if (!lane) {
                console.warn(`Lane ${laneId} not found for spot ${spotName}`);
                continue;
            }
            const laneName = lane.text || `Lane ${laneId.slice(0, 8)}`;
            // Calculate corridor from spotA to this lane
            const centerA = $ed0c90ce9469110f$export$fede11584128d629(spotA);
            const maxWidth = $ed0c90ce9469110f$export$c7e3680d669d8c6c(spotA);
            const nearestPoint = $ed0c90ce9469110f$export$85a9612c57b714b(centerA, lane.points);
            const corridor = $ed0c90ce9469110f$export$4bebce3efc71a095(centerA, nearestPoint, maxWidth);
            // Check which spots this corridor intersects
            // If spotA's corridor intersects spotB, then spotB BLOCKS spotA
            for (const spotB of spots){
                if (spotB.id === spotA.id) continue; // Skip self
                // Skip if spotA is a gap spot that requires spotB to be occupied
                // WHY: Gap spots sit in the physical space BETWEEN their required spots
                // EXAMPLE: B06 sits between B01 and B02. When aircraft at B01 departs, it doesn't
                //          block B06 because B06 is positioned in the gap, not on the egress path.
                // LOGIC: If spotA requires spotB to be occupied, then spotB cannot block spotA
                //        (they have a dependency relationship, not a blocking relationship)
                const requiresOccupiedSpots = metadata.requiresOccupiedSpots || [];
                if (requiresOccupiedSpots.includes(spotB.id)) continue; // Gap spot dependency, not a blocking relationship
                if ($ed0c90ce9469110f$export$4d52d1ebaf6857b4(corridor, spotB.points)) {
                    // spotB blocks spotA (spotB is in the way of spotA's egress)
                    // Store this in spotB's blocking list
                    if (!blockingMap.has(spotB.id)) blockingMap.set(spotB.id, []);
                    blockingMap.get(spotB.id).push({
                        blockedSpotId: spotA.id,
                        laneId: laneId,
                        laneName: laneName
                    });
                    totalBlockingRelationships++;
                }
            }
        }
    }
    // 4. Consolidate blocking entries into egressOptions for each spot
    // Group by laneId to create the proper egressOptions structure
    for (const spot of spots){
        const blockingEntries = blockingMap.get(spot.id) || [];
        if (blockingEntries.length === 0) continue;
        // Group by laneId
        const byLane = new Map();
        for (const entry of blockingEntries){
            if (!byLane.has(entry.laneId)) byLane.set(entry.laneId, {
                laneName: entry.laneName,
                blocksSpotIds: []
            });
            byLane.get(entry.laneId).blocksSpotIds.push(entry.blockedSpotId);
        }
        // Convert to egressOptions array
        const egressOptions = [];
        for (const [laneId, data] of byLane)egressOptions.push({
            laneId: laneId,
            laneName: data.laneName,
            blocksSpotIds: data.blocksSpotIds
        });
        // Store in spot metadata
        spot.metadata = {
            ...spot.metadata,
            egressOptions: egressOptions
        };
    }
    // 5. Generate logs for display
    for (const spot of spots){
        const metadata = spot.metadata;
        const spotName = spot.text || `Spot ${spot.id.slice(0, 8)}`;
        const egressOptions = metadata?.egressOptions || [];
        const hasEgressLane = spotsWithEgressLanes.has(spot.id);
        if (!hasEgressLane) {
            logs.push({
                spotId: spot.id,
                spotName: spotName,
                hasEgressLane: false,
                blocksSpots: [],
                skipped: true,
                reason: "No egress lane",
                intersectionCount: 0
            });
            continue;
        }
        if (egressOptions.length === 0) {
            // Has egress lane but doesn't block anyone
            logs.push({
                spotId: spot.id,
                spotName: spotName,
                egressLane: "No blocking",
                hasEgressLane: true,
                blocksSpots: [],
                skipped: false,
                reason: "0 lane(s) calculated",
                intersectionCount: spots.length - 1
            });
            continue;
        }
        // Collect all blocked spot IDs (union across lanes)
        const allBlockedSpotIds = new Set();
        for (const option of egressOptions)option.blocksSpotIds.forEach((id)=>allBlockedSpotIds.add(id));
        // Log with multi-lane summary
        const lanesSummary = egressOptions.map((opt)=>`${opt.laneName} (${opt.blocksSpotIds.length})`).join(", ");
        logs.push({
            spotId: spot.id,
            spotName: spotName,
            egressLane: lanesSummary,
            hasEgressLane: true,
            blocksSpots: Array.from(allBlockedSpotIds),
            skipped: false,
            reason: `${egressOptions.length} lane(s) calculated`,
            intersectionCount: spots.length - 1
        });
    }
    return {
        shapes: updatedShapes,
        logs: logs,
        totalSpots: spots.length,
        spotsWithEgress: spotsWithEgress,
        spotsWithoutEgress: spotsWithoutEgress,
        totalBlockingRelationships: totalBlockingRelationships
    };
}
function $ed0c90ce9469110f$export$ef7f9007e308733d(shapes) {
    const zones = shapes.filter((s)=>s.type === "Zone");
    return shapes.map((shape)=>{
        if (shape.type !== "Spot") return shape;
        // Find zone that contains this spot's center point
        const spotCenter = $ed0c90ce9469110f$export$fede11584128d629(shape);
        const containingZone = zones.find((zone)=>$ed0c90ce9469110f$export$7f6bc8d3d7d61b11(spotCenter, zone.points));
        if (containingZone) return {
            ...shape,
            metadata: {
                ...shape.metadata,
                zoneId: containingZone.id
            }
        };
        // No zone contains this spot - clear zoneId if it had one
        return {
            ...shape,
            metadata: {
                ...shape.metadata,
                zoneId: undefined
            }
        };
    });
}
function $ed0c90ce9469110f$export$16bee1eb9d59b1a2(shapes) {
    // First, assign zones
    const shapesWithZones = $ed0c90ce9469110f$export$ef7f9007e308733d(shapes);
    // Group spots by zone
    const spotsByZone = new Map();
    const spotsWithoutZone = [];
    shapesWithZones.forEach((shape)=>{
        if (shape.type !== "Spot") return;
        const metadata = shape.metadata;
        const zoneId = metadata?.zoneId;
        if (zoneId) {
            if (!spotsByZone.has(zoneId)) spotsByZone.set(zoneId, []);
            spotsByZone.get(zoneId).push(shape);
        } else spotsWithoutZone.push(shape);
    });
    // For each zone, sort spots and assign names
    const updatedShapes = shapesWithZones.map((shape)=>{
        if (shape.type !== "Spot") return shape;
        const metadata = shape.metadata;
        const zoneId = metadata?.zoneId;
        if (!zoneId) {
            // Spots without zones get sequential "?" prefix names
            // Find this spot's index among all spots without zones
            const sortedSpotsWithoutZone = [
                ...spotsWithoutZone
            ].sort((a, b)=>{
                const topLeftA = {
                    x: Math.min(...a.points.map((p)=>p.x)),
                    y: Math.min(...a.points.map((p)=>p.y))
                };
                const topLeftB = {
                    x: Math.min(...b.points.map((p)=>p.x)),
                    y: Math.min(...b.points.map((p)=>p.y))
                };
                if (Math.abs(topLeftA.y - topLeftB.y) > 10) return topLeftA.y - topLeftB.y;
                return topLeftA.x - topLeftB.x;
            });
            const spotIndex = sortedSpotsWithoutZone.findIndex((s)=>s.id === shape.id);
            if (spotIndex !== -1) {
                const spotNumber = spotIndex + 1;
                const newName = `?${spotNumber.toString().padStart(2, "0")}`;
                return {
                    ...shape,
                    text: newName
                };
            }
            return shape;
        }
        const zone = shapesWithZones.find((s)=>s.id === zoneId && s.type === "Zone");
        if (!zone) return shape;
        // Get zone prefix from zone.text (fallback to "Z")
        const zonePrefix = zone.text?.trim() || "Z";
        // Get all spots in this zone and sort them
        const spotsInZone = spotsByZone.get(zoneId) || [];
        // Sort by Y (top to bottom), then X (left to right)
        // Use top-left corner for natural reading order
        const sortedSpots = [
            ...spotsInZone
        ].sort((a, b)=>{
            const topLeftA = {
                x: Math.min(...a.points.map((p)=>p.x)),
                y: Math.min(...a.points.map((p)=>p.y))
            };
            const topLeftB = {
                x: Math.min(...b.points.map((p)=>p.x)),
                y: Math.min(...b.points.map((p)=>p.y))
            };
            // Primary sort: Y position (top to bottom)
            if (Math.abs(topLeftA.y - topLeftB.y) > 10) return topLeftA.y - topLeftB.y;
            // Secondary sort: X position (left to right)
            return topLeftA.x - topLeftB.x;
        });
        // Find this spot's index in the sorted list
        const spotIndex = sortedSpots.findIndex((s)=>s.id === shape.id);
        if (spotIndex === -1) return shape;
        // Generate name: {prefix}{number:02d}
        const spotNumber = spotIndex + 1;
        const newName = `${zonePrefix}${spotNumber.toString().padStart(2, "0")}`;
        return {
            ...shape,
            text: newName
        };
    });
    return updatedShapes;
}
function $ed0c90ce9469110f$export$c0187fc56ab31216(spot) {
    if (!spot.points || spot.points.length < 2) return {
        width: 0,
        height: 0,
        angle: 0,
        center: {
            x: 0,
            y: 0
        },
        minX: 0,
        minY: 0,
        maxX: 0,
        maxY: 0
    };
    // Calculate bounding box
    const xs = spot.points.map((p)=>p.x);
    const ys = spot.points.map((p)=>p.y);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const width = maxX - minX;
    const height = maxY - minY;
    const center = $ed0c90ce9469110f$export$fede11584128d629(spot);
    // Calculate rotation angle from first edge
    const angle = Math.atan2(spot.points[1].y - spot.points[0].y, spot.points[1].x - spot.points[0].x);
    return {
        width: width,
        height: height,
        angle: angle,
        center: center,
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
}
function $ed0c90ce9469110f$export$28f278c3713bb08b(sourceSpot, rows, cols, spacing = 0, rampId, fboId) {
    const geometry = $ed0c90ce9469110f$export$c0187fc56ab31216(sourceSpot);
    const { width: width, height: height, angle: angle } = geometry;
    const tiledSpots = [];
    // Generate UUID function
    const generateId = ()=>{
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    };
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        // Skip (0,0) to avoid creating a duplicate at the source spot's position
        if (row === 0 && col === 0) continue;
        // Calculate offset in the spot's local coordinate system
        const localOffsetX = col * (width + spacing);
        const localOffsetY = row * (height + spacing);
        // Rotate the offset to match the spot's orientation
        const offsetX = localOffsetX * Math.cos(angle) - localOffsetY * Math.sin(angle);
        const offsetY = localOffsetX * Math.sin(angle) + localOffsetY * Math.cos(angle);
        // Create new spot with transformed points
        const newPoints = sourceSpot.points.map((p)=>({
                x: p.x + offsetX,
                y: p.y + offsetY
            }));
        tiledSpots.push({
            ...sourceSpot,
            id: generateId(),
            ramp_id: rampId,
            fbo_id: fboId,
            points: newPoints,
            metadata: {
                ...sourceSpot.metadata,
                // Clear gap spot metadata - tiled spots need gap detection re-run
                requiresOccupiedSpots: undefined
            }
        });
    }
    return tiledSpots;
}

});

parcelRegister("9s9MA", function(module, exports) {

$parcel$export(module.exports, "detectRequiredSpots", () => $021149838946ef79$export$3609a99632d05743);
/**
 * Gap Spot Detection Utilities (Phase 2c)
 *
 * Detects which spots a gap spot depends on by finding spots that:
 * 1. Spatially overlap with the gap spot
 * 2. Are larger than the gap spot (based on allowedSizes)
 */ /**
 * Size category ranking (smaller to larger)
 * Used to compare spot sizes
 */ const $021149838946ef79$var$SIZE_RANKING = {
    "very-small": 1,
    "small": 2,
    "midsize": 3,
    "super-midsize": 4,
    "large": 5
};
/**
 * Get the maximum size category allowed by a spot
 *
 * @param spot - The spot to check
 * @returns The largest size category in allowedSizes, or "very-small" if none
 */ function $021149838946ef79$var$getMaxSizeCategory(spot) {
    const metadata = spot.metadata;
    const allowedSizes = metadata?.allowedSizes || [];
    if (allowedSizes.length === 0) return "very-small";
    // Find the largest category
    let maxRank = 0;
    let maxCategory = "very-small";
    for (const size of allowedSizes){
        const rank = $021149838946ef79$var$SIZE_RANKING[size] || 0;
        if (rank > maxRank) {
            maxRank = rank;
            maxCategory = size;
        }
    }
    return maxCategory;
}
function $021149838946ef79$export$af5566b470928348(spot1, spot2) {
    const size1 = $021149838946ef79$var$getMaxSizeCategory(spot1);
    const size2 = $021149838946ef79$var$getMaxSizeCategory(spot2);
    return $021149838946ef79$var$SIZE_RANKING[size1] > $021149838946ef79$var$SIZE_RANKING[size2];
}
function $021149838946ef79$export$26be73ece3b28c87(spot1, spot2) {
    if (!spot1.points || spot1.points.length === 0) return false;
    if (!spot2.points || spot2.points.length === 0) return false;
    // Get bounding boxes
    const box1 = $021149838946ef79$var$getBoundingBox(spot1);
    const box2 = $021149838946ef79$var$getBoundingBox(spot2);
    // Check if bounding boxes overlap
    // Boxes overlap if they intersect on both axes
    const xOverlap = box1.minX <= box2.maxX && box1.maxX >= box2.minX;
    const yOverlap = box1.minY <= box2.maxY && box1.maxY >= box2.minY;
    return xOverlap && yOverlap;
}
/**
 * Get bounding box for a spot
 */ function $021149838946ef79$var$getBoundingBox(spot) {
    const xs = spot.points.map((p)=>p.x);
    const ys = spot.points.map((p)=>p.y);
    return {
        minX: Math.min(...xs),
        maxX: Math.max(...xs),
        minY: Math.min(...ys),
        maxY: Math.max(...ys)
    };
}
function $021149838946ef79$export$3609a99632d05743(targetSpot, allSpots) {
    // Only analyze Spot type shapes
    if (targetSpot.type !== "Spot") return [];
    const requiredSpots = allSpots.filter((spot)=>{
        // Must be a Spot type
        if (spot.type !== "Spot") return false;
        // Exclude self
        if (spot.id === targetSpot.id) return false;
        // Must spatially overlap
        if (!$021149838946ef79$export$26be73ece3b28c87(targetSpot, spot)) return false;
        // Must be larger
        if (!$021149838946ef79$export$af5566b470928348(spot, targetSpot)) return false;
        return true;
    }).map((spot)=>spot.id);
    return requiredSpots;
}

});


parcelRegister("flHhZ", function(module, exports) {

$parcel$export(module.exports, "FILL_PATTERNS", () => $5143fc2613d0d1b5$export$47d3cf5a27ec62a6);
$parcel$export(module.exports, "usePatterns", () => $5143fc2613d0d1b5$export$ac1c710aefe54182);

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $bKsdy = parcelRequire("bKsdy");
const $5143fc2613d0d1b5$export$47d3cf5a27ec62a6 = ()=>{
    const BASE_PATTERNS = [
        {
            label: "Red Stripe",
            value: "/diagonal_red_transparent_stripes.png"
        },
        {
            label: "Yellow Stripe",
            value: "/diagonal_yellow_transparent_stripes.png"
        },
        {
            label: "White Stripe",
            value: "/diagonal_white_transparent_stripes.png"
        }
    ];
    const patterns = [];
    for (const pattern of BASE_PATTERNS)for(let i = 0.3; i <= 1; i += 0.3)patterns.push({
        label: `${pattern.label} ${(i * 100).toFixed(0)}%`,
        value: pattern.value,
        opacity: i
    });
    return patterns;
};
const $5143fc2613d0d1b5$export$ac1c710aefe54182 = ()=>{
    const tempCanvasRef = (0, $acw62.useRef)(null);
    const { loading: loading, value: patterns } = (0, $2NPdf.default)(async ()=>{
        // Create a temporary canvas element if it doesn't exist
        if (!tempCanvasRef.current) {
            tempCanvasRef.current = document.createElement("canvas");
            tempCanvasRef.current.width = 256; // Adjust size as needed
            tempCanvasRef.current.height = 256;
        }
        // Map and create patterns
        const promises = $5143fc2613d0d1b5$export$47d3cf5a27ec62a6().map(async (pattern)=>{
            return [
                // `${pattern.value}?opacity=${pattern.opacity}`,
                pattern.label,
                await (0, $bKsdy.createImagePattern)(tempCanvasRef.current, pattern.value, pattern.opacity)
            ];
        });
        return Object.fromEntries(await Promise.all(promises));
    }, []);
    return {
        loading: loading,
        patterns: patterns
    };
};

});


parcelRegister("bng5f", function(module, exports) {

$parcel$export(module.exports, "parseGISCSV", () => $b681e702aceefc50$export$288a54da89dde2ff);
$parcel$export(module.exports, "convertGISPolygonToPixels", () => $b681e702aceefc50$export$ee881a61bcd83fab);
$parcel$export(module.exports, "isShapeWithinRampBounds", () => $b681e702aceefc50$export$7e80c9f8b4e49926);
function $b681e702aceefc50$export$288a54da89dde2ff(csvContent) {
    const lines = csvContent.trim().split("\n");
    if (lines.length < 2) throw new Error("Data must have at least a header row and one data row");
    const headerLine = lines[0];
    // Auto-detect delimiter (CSV vs TSV)
    const delimiter = $b681e702aceefc50$var$detectDelimiter(headerLine);
    const headers = $b681e702aceefc50$var$parseDelimitedLine(headerLine, delimiter).map((h)=>h.toLowerCase().trim());
    // Required columns
    const requiredColumns = [
        "ramp_label",
        "ramp_polygon"
    ];
    // Check that required columns exist
    for (const required of requiredColumns){
        if (!headers.includes(required)) throw new Error(`Missing required column: ${required}`);
    }
    // Map header names to column indices
    const columnMap = {};
    headers.forEach((header, index)=>{
        columnMap[header] = index;
    });
    // Optional shape attribute columns with their default values
    const optionalColumns = {
        id: null,
        airport: null,
        tenant: null,
        type: "Area",
        locked: false,
        stroke_style: "#3c6ce9",
        line_style: "solid",
        line_width: 2,
        fill_style: "rgba(60, 108, 233, 0.1)",
        fill_pattern: null,
        text: null,
        font_size: 14
    };
    const results = [];
    for(let i = 1; i < lines.length; i++)try {
        const line = lines[i].trim();
        if (!line) continue;
        const parsed = $b681e702aceefc50$var$parseDelimitedLine(line, delimiter);
        // Get required fields
        const ramp_label = parsed[columnMap["ramp_label"]]?.trim() || `Shape ${i}`;
        const ramp_polygon_str = parsed[columnMap["ramp_polygon"]]?.trim();
        if (!ramp_polygon_str) {
            console.warn(`Skipping line ${i + 1}: missing ramp_polygon`);
            continue;
        }
        // Parse the polygon coordinates
        let polygon;
        try {
            // Remove quotes and parse JSON
            const polygonStr = ramp_polygon_str.replace(/^"(.*)"$/, "$1");
            polygon = JSON.parse(polygonStr);
            if (!Array.isArray(polygon) || polygon.length === 0) throw new Error("Invalid polygon format");
            // Validate coordinate format
            for (const coord of polygon){
                if (!Array.isArray(coord) || coord.length !== 2) throw new Error("Each coordinate must be [longitude, latitude]");
            }
        } catch (err) {
            console.warn(`Skipping line ${i + 1}: invalid polygon data - ${err.message}`);
            continue;
        }
        // Build the result object with required fields
        const row = {
            ramp_label: ramp_label,
            polygon: polygon
        };
        // Add optional fields if they exist in the CSV
        Object.keys(optionalColumns).forEach((key)=>{
            const columnIndex = columnMap[key];
            if (columnIndex !== undefined && parsed[columnIndex] !== undefined) {
                const value = parsed[columnIndex]?.trim();
                if (value !== undefined && value !== "") // Type conversion based on the field
                switch(key){
                    case "locked":
                        row[key] = value.toLowerCase() === "true" || value === "1";
                        break;
                    case "line_width":
                    case "font_size":
                        const numValue = parseFloat(value);
                        if (!isNaN(numValue)) row[key] = numValue;
                        break;
                    default:
                        row[key] = value;
                }
            }
        });
        // Apply defaults for any missing optional fields
        Object.keys(optionalColumns).forEach((key)=>{
            if (row[key] === undefined) {
                const defaultValue = optionalColumns[key];
                if (defaultValue !== null) row[key] = defaultValue;
                else if (key === "fill_pattern") // fill_pattern should be undefined when not specified
                row[key] = undefined;
            }
        });
        // Special handling for text field - use ramp_label as default if empty
        if (!row.text) row.text = ramp_label;
        results.push(row);
    } catch (err) {
        console.warn(`Skipping line ${i + 1}: ${err.message}`);
    }
    if (results.length === 0) throw new Error("No valid polygon data found in the uploaded data");
    return results;
}
/**
 * Detect delimiter (comma or tab) based on the header line
 */ function $b681e702aceefc50$var$detectDelimiter(line) {
    // Count occurrences of comma and tab outside of quotes
    let commaCount = 0;
    let tabCount = 0;
    let inQuotes = false;
    for(let i = 0; i < line.length; i++){
        const char = line[i];
        if (char === '"') inQuotes = !inQuotes;
        else if (!inQuotes) {
            if (char === ",") commaCount++;
            else if (char === "\t") tabCount++;
        }
    }
    // Return the delimiter with higher count, default to comma
    return tabCount > commaCount ? "\t" : ",";
}
/**
 * Parse a delimited line (CSV or TSV) handling quoted values
 */ function $b681e702aceefc50$var$parseDelimitedLine(line, delimiter) {
    const result = [];
    let current = "";
    let inQuotes = false;
    for(let i = 0; i < line.length; i++){
        const char = line[i];
        if (char === '"') {
            // Handle escaped quotes (double quotes inside quotes)
            if (inQuotes && i + 1 < line.length && line[i + 1] === '"') {
                current += '"';
                i++; // Skip the next quote
            } else inQuotes = !inQuotes;
        } else if (char === delimiter && !inQuotes) {
            result.push(current.trim());
            current = "";
        } else current += char;
    }
    result.push(current.trim());
    return result;
}
function $b681e702aceefc50$export$ee881a61bcd83fab(polygon, calibrationPoints, rampWidth, rampDepth, canvasWidth) {
    if (calibrationPoints.length < 2) throw new Error("Need at least 2 calibration points for coordinate conversion");
    try {
        // Calculate the pixels to feet ratio used by the ramp system
        const pixelsToFeetRatio = canvasWidth / rampWidth;
        const canvasHeight = canvasWidth * rampDepth / rampWidth;
        return polygon.map(([lng, lat])=>{
            // Transform GPS coordinates to pixel coordinates using calibration points
            // Note: polygon coordinates come as [longitude, latitude] but we need to pass (latitude, longitude)
            const { pixelX: pixelX, pixelY: pixelY } = $b681e702aceefc50$var$transformGPSToPixelSimple(lat, lng, calibrationPoints, canvasWidth, canvasHeight);
            // Convert to ramp coordinate system (stored coordinates = pixels / pixelsToFeetRatio)
            const x = pixelX / pixelsToFeetRatio;
            const y = pixelY / pixelsToFeetRatio;
            return {
                x: Math.round(x * 100) / 100,
                y: Math.round(y * 100) / 100
            };
        });
    } catch (err) {
        console.error("Error converting GIS coordinates:", err);
        throw new Error(`Failed to convert coordinates: ${err.message}`);
    }
}
/**
 * Transform GPS coordinates to pixel coordinates using 2 calibration points
 * This approach creates an affine transformation using the calibration points
 */ function $b681e702aceefc50$var$transformGPSToPixelSimple(lat, lng, calibrationPoints, canvasWidth, canvasHeight) {
    const point1 = calibrationPoints[0];
    const point2 = calibrationPoints[1];
    // Convert relative coordinates to pixel coordinates
    // Note: Y coordinates need to be inverted because canvas Y increases downward
    // but the ramp system uses Y increasing upward (like GPS)
    const point1PixelX = point1.x * canvasWidth;
    const point1PixelY = (1 - point1.y) * canvasHeight; // Invert Y
    const point2PixelX = point2.x * canvasWidth;
    const point2PixelY = (1 - point2.y) * canvasHeight; // Invert Y
    // Use a more robust GPS coordinate conversion
    // Convert all coordinates to a local tangent plane in meters
    const earthRadius = 6378137; // WGS84 Earth radius in meters
    const toRadians = (deg)=>deg * Math.PI / 180;
    // Reference point (use first calibration point as origin)
    const refLat = point1.latitude;
    const refLng = point1.longitude;
    const refLatRad = toRadians(refLat);
    // Convert GPS coordinates to local meters (tangent plane projection)
    const convertToLocalMeters = (lat, lng)=>{
        const latRad = toRadians(lat);
        const lngRad = toRadians(lng);
        const refLngRad = toRadians(refLng);
        const x = earthRadius * (lngRad - refLngRad) * Math.cos(refLatRad);
        const y = earthRadius * (latRad - refLatRad);
        return {
            x: x,
            y: y
        };
    };
    // Convert calibration points and target point to local meters
    const point1Meters = convertToLocalMeters(point1.latitude, point1.longitude); // Should be (0, 0)
    const point2Meters = convertToLocalMeters(point2.latitude, point2.longitude);
    const targetMeters = convertToLocalMeters(lat, lng);
    // Calculate the transformation matrix from GPS meters to pixel coordinates
    // We have two corresponding point pairs: (point1Meters, point1Pixel) and (point2Meters, point2Pixel)
    const metersVectorX = point2Meters.x - point1Meters.x;
    const metersVectorY = point2Meters.y - point1Meters.y;
    const pixelVectorX = point2PixelX - point1PixelX;
    const pixelVectorY = point2PixelY - point1PixelY;
    const metersDistance = Math.sqrt(metersVectorX * metersVectorX + metersVectorY * metersVectorY);
    const pixelDistance = Math.sqrt(pixelVectorX * pixelVectorX + pixelVectorY * pixelVectorY);
    if (metersDistance === 0) throw new Error("Calibration points are at the same GPS location");
    const scale = pixelDistance / metersDistance;
    // Calculate rotation angle
    const metersAngle = Math.atan2(metersVectorY, metersVectorX);
    const pixelAngle = Math.atan2(pixelVectorY, pixelVectorX);
    const rotation = pixelAngle - metersAngle;
    // Transform target point from meters to pixels
    const targetVectorX = targetMeters.x - point1Meters.x;
    const targetVectorY = targetMeters.y - point1Meters.y;
    // Apply rotation and scaling
    const cos = Math.cos(rotation);
    const sin = Math.sin(rotation);
    const rotatedX = targetVectorX * cos - targetVectorY * sin;
    const rotatedY = targetVectorX * sin + targetVectorY * cos;
    // Scale and translate to final pixel coordinates
    const pixelX = point1PixelX + rotatedX * scale;
    const pixelY = point1PixelY + rotatedY * scale;
    // Invert Y back to ramp coordinate system (Y increases upward)
    const rampPixelY = canvasHeight - pixelY;
    return {
        pixelX: pixelX,
        pixelY: rampPixelY
    };
}
function $b681e702aceefc50$export$e5d7042567f370de(points, rampWidth = 1000, rampDepth = 600) {
    for (const point of points){
        // Check if coordinates are within reasonable bounds for the ramp coordinate system
        // Since stored coordinates = pixels / pixelsToFeetRatio, reasonable values would be
        // roughly in the range of 0 to rampWidth (for the coordinate system scale)
        if (point.x < -rampWidth || point.x > rampWidth * 2 || point.y < -rampDepth || point.y > rampDepth * 2) return false;
    }
    return true;
}
function $b681e702aceefc50$export$7e80c9f8b4e49926(polygon, ramp) {
    // Need at least 2 calibration points for coordinate transformation
    if (!ramp.calibration_points || ramp.calibration_points.length < 2) // If we can't do coordinate transformation, assume it's visible
    return true;
    try {
        // Convert the GIS polygon to pixel coordinates using the same logic as convertGISPolygonToPixels
        const pixelPoints = $b681e702aceefc50$export$ee881a61bcd83fab(polygon, ramp.calibration_points, ramp.width, ramp.depth, 1000 // Default canvas width used by the ramp editor
        );
        // Use a more generous margin to reduce false positives
        // Many legitimate shapes extend slightly beyond the ramp boundaries
        const margin = Math.max(ramp.width, ramp.depth) * 1.0; // Increased from 0.5 to 1.0 (100% margin)
        const minX = -margin;
        const maxX = ramp.width + margin;
        const minY = -margin;
        const maxY = ramp.depth + margin;
        // Check if any point is within the generous bounds
        for (const point of pixelPoints){
            if (point.x >= minX && point.x <= maxX && point.y >= minY && point.y <= maxY) return true;
        }
        // Check if the shape completely contains the ramp center
        const rampCenterX = ramp.width / 2;
        const rampCenterY = ramp.depth / 2;
        if ($b681e702aceefc50$var$isPointInPolygon([
            rampCenterX,
            rampCenterY
        ], pixelPoints.map((p)=>[
                p.x,
                p.y
            ]))) return true;
        // Additional check: If the shape intersects with the core ramp area at all
        // This helps catch shapes that might cross through the ramp even if no single point is within bounds
        const coreRampPolygon = [
            [
                0,
                0
            ],
            [
                ramp.width,
                0
            ],
            [
                ramp.width,
                ramp.depth
            ],
            [
                0,
                ramp.depth
            ]
        ];
        // Check if any edge of the shape intersects with the ramp bounds
        for(let i = 0; i < pixelPoints.length; i++){
            const p1 = pixelPoints[i];
            const p2 = pixelPoints[(i + 1) % pixelPoints.length];
            // Check if this edge intersects with any edge of the ramp
            for(let j = 0; j < coreRampPolygon.length; j++){
                const r1 = coreRampPolygon[j];
                const r2 = coreRampPolygon[(j + 1) % coreRampPolygon.length];
                if ($b681e702aceefc50$var$doLinesIntersect([
                    p1.x,
                    p1.y
                ], [
                    p2.x,
                    p2.y
                ], r1, r2)) return true;
            }
        }
        return false;
    } catch (error) {
        console.warn("Failed to check shape bounds, assuming visible:", error);
        // If coordinate transformation fails, assume it's visible to avoid false negatives
        return true;
    }
}
/**
 * Check if a point is inside a polygon using the ray casting algorithm
 */ function $b681e702aceefc50$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const [xi, yi] = polygon[i];
        const [xj, yj] = polygon[j];
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) inside = !inside;
    }
    return inside;
}
/**
 * Check if two line segments intersect
 */ function $b681e702aceefc50$var$doLinesIntersect(line1Start, line1End, line2Start, line2End) {
    const [x1, y1] = line1Start;
    const [x2, y2] = line1End;
    const [x3, y3] = line2Start;
    const [x4, y4] = line2End;
    const denom = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    if (Math.abs(denom) < 1e-10) // Lines are parallel
    return false;
    const t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denom;
    const u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denom;
    return t >= 0 && t <= 1 && u >= 0 && u <= 1;
}

});



parcelRegister("kLvAj", function(module, exports) {

$parcel$export(module.exports, "EgressCalculationDialog", () => $545ceaea16f3135b$export$14349b9fe5508ec9);

var $ayMG0 = parcelRequire("ayMG0");

var $at4qK = parcelRequire("at4qK");

var $hmTQO = parcelRequire("hmTQO");

var $ipR47 = parcelRequire("ipR47");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $545ceaea16f3135b$export$14349b9fe5508ec9 = ({ open: open, onClose: onClose, result: result })=>{
    if (!result) return null;
    const { logs: logs, totalSpots: totalSpots, spotsWithEgress: spotsWithEgress, spotsWithoutEgress: spotsWithoutEgress, totalBlockingRelationships: totalBlockingRelationships } = result;
    // Sort logs alphabetically by spot name
    const sortedLogs = [
        ...logs
    ].sort((a, b)=>a.spotName.localeCompare(b.spotName));
    // Calculate blocked-by counts for each spot
    const blockedByMap = new Map();
    sortedLogs.forEach((log)=>{
        blockedByMap.set(log.spotId, 0);
    });
    sortedLogs.forEach((log)=>{
        log.blocksSpots.forEach((blockedSpotId)=>{
            blockedByMap.set(blockedSpotId, (blockedByMap.get(blockedSpotId) || 0) + 1);
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: "Egress Blocking Calculation Results"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    gutterBottom: true,
                                    children: "Summary"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 2,
                                    flexWrap: "wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `${totalSpots} Total Spots`,
                                            color: "primary"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `${spotsWithEgress} With Egress Lane`,
                                            color: "success"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `${spotsWithoutEgress} Without Egress Lane`,
                                            color: "default"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `${totalBlockingRelationships} Blocking Relationships`,
                                            color: "warning"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    gutterBottom: true,
                                    children: "Spot Analysis"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                    size: "small",
                                    sx: {
                                        border: 1,
                                        borderColor: "divider"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                sx: {
                                                    backgroundColor: "action.hover"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        sx: {
                                                            fontWeight: "bold"
                                                        },
                                                        children: "Spot"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        sx: {
                                                            fontWeight: "bold"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                            sx: {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 0.5
                                                            },
                                                            children: [
                                                                "Egress Lane",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                    title: "Shows available egress lanes with format: Lane Name (# spots blocked). Spots with multiple lanes will choose the lane with fewest blocks at departure time.",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                                                        fontSize: "small",
                                                                        sx: {
                                                                            color: "text.secondary"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        sx: {
                                                            fontWeight: "bold"
                                                        },
                                                        align: "center",
                                                        children: "Has Lane?"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        sx: {
                                                            fontWeight: "bold"
                                                        },
                                                        align: "center",
                                                        children: "Blocking #"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        sx: {
                                                            fontWeight: "bold"
                                                        },
                                                        align: "center",
                                                        children: "Blocked By #"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                        sx: {
                                                            fontWeight: "bold"
                                                        },
                                                        children: "Status"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                            children: sortedLogs.map((log)=>{
                                                const blockedByCount = blockedByMap.get(log.spotId) || 0;
                                                const hasConflict = log.blocksSpots.length > 0 || blockedByCount > 0;
                                                // Find which spots block this spot
                                                const blockedBySpots = sortedLogs.filter((l)=>l.blocksSpots.includes(log.spotId)).map((l)=>l.spotName);
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                    sx: {
                                                        backgroundColor: log.skipped ? "action.disabledBackground" : hasConflict ? "warning.lighter" : "success.lighter"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: log.spotName
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: log.egressLane || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            align: "center",
                                                            children: log.hasEgressLane ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmTQO))), {
                                                                color: "success",
                                                                fontSize: "small"
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($at4qK))), {
                                                                color: "disabled",
                                                                fontSize: "small"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            align: "center",
                                                            children: log.blocksSpots.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                title: `Blocks: ${log.blocksSpots.map((id)=>{
                                                                    const spot = sortedLogs.find((l)=>l.spotId === id);
                                                                    return spot?.spotName || id.slice(0, 8);
                                                                }).join(", ")}`,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                    label: log.blocksSpots.length,
                                                                    size: "small",
                                                                    color: "warning"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "body2",
                                                                color: "text.secondary",
                                                                children: "0"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            align: "center",
                                                            children: blockedByCount > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                title: `Blocked by: ${blockedBySpots.join(", ")}`,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                    label: blockedByCount,
                                                                    size: "small",
                                                                    color: "error"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "body2",
                                                                color: "text.secondary",
                                                                children: "0"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "caption",
                                                                color: log.skipped ? "text.secondary" : "text.primary",
                                                                children: log.reason
                                                            })
                                                        })
                                                    ]
                                                }, log.spotId);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        totalBlockingRelationships > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    gutterBottom: true,
                                    children: "Details"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    sx: {
                                        display: "block",
                                        mb: 1,
                                        fontStyle: "italic"
                                    },
                                    children: "Note: Gap spots are not blocked by their required spots since they sit in the gap between them"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    spacing: 0.5,
                                    children: sortedLogs.filter((log)=>log.blocksSpots.length > 0).map((log)=>{
                                        const blockedNames = log.blocksSpots.map((id)=>{
                                            const bl = sortedLogs.find((l)=>l.spotId === id);
                                            return bl?.spotName || id.slice(0, 8);
                                        }).join(", ");
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "caption",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                    component: "span",
                                                    sx: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: [
                                                        log.spotName,
                                                        " blocks:"
                                                    ]
                                                }),
                                                " ",
                                                blockedNames
                                            ]
                                        }, log.spotId);
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    onClick: onClose,
                    variant: "contained",
                    children: "Close"
                })
            })
        ]
    });
};

});
parcelRegister("hmTQO", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ca4fd08777d4e412$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca4fd08777d4e412$var$_createSvgIcon = $ca4fd08777d4e412$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ca4fd08777d4e412$var$_default = module.exports.default = (0, $ca4fd08777d4e412$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');

});


parcelRegister("7pqnS", function(module, exports) {

$parcel$export(module.exports, "ShapeElements", () => $1c302402f4b8cf1e$export$105b49f9ad0d3025);

var $ayMG0 = parcelRequire("ayMG0");

var $1MdOk = parcelRequire("1MdOk");

var $c3r8Q = parcelRequire("c3r8Q");

var $ewtCw = parcelRequire("ewtCw");

var $fpqo6 = parcelRequire("fpqo6");

var $03mUs = parcelRequire("03mUs");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");

var $2v7Ik = parcelRequire("2v7Ik");

var $7mOBL = parcelRequire("7mOBL");

var $ceJla = parcelRequire("ceJla");
const $1c302402f4b8cf1e$export$105b49f9ad0d3025 = ({ shapes: shapes, setShapes: setShapes, tools: tools })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { setHighlightedShapes: setHighlightedShapes } = (0, $ceJla.useLocalRampState)();
    const [editShapeId, setEditShapeId] = $acw62.useState(null);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        width: "100%",
        sx: {
            maxHeight: 400,
            overflowY: "auto"
        },
        children: [
            (!shapes || shapes.length === 0) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "subtitle2",
                align: "center",
                children: "No shapes added"
            }),
            shapes?.map((shape, index)=>{
                const dimensions = (0, $2v7Ik.getDimensions)(shape.points);
                const formattedDimensions = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(dimensions.width), 0)}m x ${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(dimensions.height), 0)}m` : `${(0, $lNEp2.formatNumber)(dimensions.width, 0)}ft x ${(0, $lNEp2.formatNumber)(dimensions.height, 0)}ft`;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    onMouseEnter: async ()=>{
                        setHighlightedShapes([
                            shape.id
                        ]);
                    },
                    onMouseLeave: async ()=>{
                        setHighlightedShapes([]);
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                tools.find((t)=>t.name === shape.type)?.icon,
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    children: formattedDimensions
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>{
                                        setShapes((currentShapes)=>currentShapes.map((s)=>({
                                                    ...s,
                                                    locked: s.id === shape.id ? !shape.locked : s.locked
                                                })));
                                    },
                                    children: shape.locked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ewtCw))), {
                                        sx: {
                                            fontSize: 18
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fpqo6))), {
                                        sx: {
                                            fontSize: 18
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>setEditShapeId(shape.id),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3r8Q))), {
                                        sx: {
                                            fontSize: 18
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>{
                                        setShapes((currentShapes)=>currentShapes.filter((s)=>s.id !== shape.id));
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {
                                        sx: {
                                            fontSize: 18
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }, `shape-stack-${index}`);
            }),
            editShapeId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7mOBL.ShapeEditDialog), {
                contextMenu: {
                    x: 0,
                    y: 0,
                    shapeId: editShapeId
                },
                setContextMenu: ()=>{},
                onClose: ()=>setEditShapeId(null),
                shapes: shapes,
                setShapes: setShapes
            })
        ]
    });
};

});


parcelRegister("bpwzj", function(module, exports) {

$parcel$export(module.exports, "calculateRampBoundingBox", () => $c6c2af71dd65af8a$export$e021a97092379ec1);
function $c6c2af71dd65af8a$var$toRadians(deg) {
    return deg * Math.PI / 180;
}
function $c6c2af71dd65af8a$var$toDegrees(rad) {
    return rad * 180 / Math.PI;
}
function $c6c2af71dd65af8a$var$latlonToMeters(lat1, lon1, lat2, lon2) {
    const R = 6371000; // Earth radius in meters
    const dLat = $c6c2af71dd65af8a$var$toRadians(lat2 - lat1);
    const dLon = $c6c2af71dd65af8a$var$toRadians(lon2 - lon1);
    const avgLat = $c6c2af71dd65af8a$var$toRadians((lat1 + lat2) / 2);
    const dx = dLon * R * Math.cos(avgLat);
    const dy = dLat * R;
    return [
        dx,
        dy
    ];
}
function $c6c2af71dd65af8a$export$304a77437d6f4368(points) {
    // Need at least 2 points to estimate
    if (points.length < 2) throw new Error("Need at least 2 calibration points to estimate origin");
    // Use the first point as a reference
    const reference = points[0];
    // Calculate scaling factors using all other points relative to the reference
    let totalSx = 0;
    let totalSy = 0;
    let validPoints = 0;
    for(let i = 1; i < points.length; i++){
        const point = points[i];
        const dxCanvas = point.x - reference.x;
        const dyCanvas = point.y - reference.y;
        // Skip points that are too close in canvas space
        if (Math.abs(dxCanvas) < 1e-10 || Math.abs(dyCanvas) < 1e-10) continue;
        const [dxGeo, dyGeo] = $c6c2af71dd65af8a$var$latlonToMeters(reference.latitude, reference.longitude, point.latitude, point.longitude);
        totalSx += dxGeo / dxCanvas;
        totalSy += dyGeo / dyCanvas;
        validPoints++;
    }
    if (validPoints === 0) throw new Error("Could not calculate valid scaling factors");
    // Average scaling factors
    const sx = totalSx / validPoints;
    const sy = totalSy / validPoints;
    // Calculate origin using the reference point and average scaling
    const dxM = -reference.x * sx;
    const dyM = -reference.y * sy;
    const lat0 = reference.latitude;
    const lon0 = reference.longitude;
    const originLat = lat0 + $c6c2af71dd65af8a$var$toDegrees(dyM / 6371000);
    const originLon = lon0 + $c6c2af71dd65af8a$var$toDegrees(dxM / (6371000 * Math.cos($c6c2af71dd65af8a$var$toRadians(lat0))));
    return [
        originLat,
        originLon
    ];
}
function $c6c2af71dd65af8a$export$e021a97092379ec1(ramp) {
    // Need at least 2 calibration points and valid dimensions
    if (!ramp.calibration_points || ramp.calibration_points.length < 2 || !ramp.width || !ramp.depth) return null;
    try {
        // Get the origin (top-left corner)
        const [originLat, originLon] = $c6c2af71dd65af8a$export$304a77437d6f4368(ramp.calibration_points);
        // Calculate scaling factors from calibration points
        const reference = ramp.calibration_points[0];
        let validPoints = 0;
        for(let i = 1; i < ramp.calibration_points.length; i++){
            const point = ramp.calibration_points[i];
            const dxCanvas = point.x - reference.x;
            const dyCanvas = point.y - reference.y;
            if (Math.abs(dxCanvas) < 1e-10 || Math.abs(dyCanvas) < 1e-10) continue;
            validPoints++;
        }
        if (validPoints === 0) return null;
        // Convert feet to meters if needed
        const widthMeters = ramp.width * 0.3048; // feet to meters
        const depthMeters = ramp.depth * 0.3048; // feet to meters
        // Calculate the four corners
        // Top-left is the origin
        const topLeft = [
            originLat,
            originLon
        ];
        // Top-right: move east by width
        const topRightLon = originLon + $c6c2af71dd65af8a$var$toDegrees(widthMeters / (6371000 * Math.cos($c6c2af71dd65af8a$var$toRadians(originLat))));
        const topRight = [
            originLat,
            topRightLon
        ];
        // Bottom-left: move south by depth
        const bottomLeftLat = originLat - $c6c2af71dd65af8a$var$toDegrees(depthMeters / 6371000);
        const bottomLeft = [
            bottomLeftLat,
            originLon
        ];
        // Bottom-right: move both south and east
        const bottomRight = [
            bottomLeftLat,
            topRightLon
        ];
        return {
            topLeft: topLeft,
            topRight: topRight,
            bottomLeft: bottomLeft,
            bottomRight: bottomRight
        };
    } catch (error) {
        console.warn("Failed to calculate bounding box:", error);
        return null;
    }
}

});


parcelRegister("kwTeI", function(module, exports) {

$parcel$export(module.exports, "useAutoEgress", () => $66c559ee3897417d$export$af5487744c9d764d);

var $acw62 = parcelRequire("acw62");

var $5nYIu = parcelRequire("5nYIu");

var $ceJla = parcelRequire("ceJla");
function $66c559ee3897417d$export$af5487744c9d764d(debounceMs = 300) {
    const lastGeometryHash = (0, $acw62.useRef)('');
    const isFirstRun = (0, $acw62.useRef)(true);
    const timeoutRef = (0, $acw62.useRef)(null);
    // Subscribe directly to the Zustand store
    const shapes = (0, $ceJla.useLocalRampState)((state)=>state.ramp?.shapes);
    const setRamp = (0, $ceJla.useLocalRampState)((state)=>state.setRamp);
    (0, $acw62.useEffect)(()=>{
        // Clear any pending timeout
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (!shapes || shapes.length === 0) return;
        const currentHash = $66c559ee3897417d$var$getShapesGeometryHash(shapes);
        // Skip if hash hasn't changed
        if (currentHash === lastGeometryHash.current) return;
        // Skip first run (data may already be calculated)
        if (isFirstRun.current) {
            isFirstRun.current = false;
            lastGeometryHash.current = currentHash;
            return;
        }
        // Debounce the calculation
        timeoutRef.current = setTimeout(()=>{
            lastGeometryHash.current = currentHash;
            // Assign spots to zones first, then calculate egress
            const shapesWithZones = (0, $5nYIu.assignSpotsToZones)(shapes);
            const result = (0, $5nYIu.calculateBlockedSpots)(shapesWithZones);
            // Update shapes with egress data
            setRamp((prev)=>prev ? {
                    ...prev,
                    shapes: result.shapes
                } : prev);
        }, debounceMs);
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [
        shapes,
        setRamp,
        debounceMs
    ]);
    // Reset state when shapes become undefined (e.g., ramp switch)
    (0, $acw62.useEffect)(()=>{
        if (!shapes) {
            lastGeometryHash.current = '';
            isFirstRun.current = true;
        }
    }, [
        shapes
    ]);
}
/**
 * Create a hash of shape geometry that affects egress calculations.
 * Excludes calculated fields (egressOptions) to prevent infinite loops.
 */ function $66c559ee3897417d$var$getShapesGeometryHash(shapes) {
    const relevantData = shapes.map((s)=>({
            id: s.id,
            type: s.type,
            points: s.points,
            // Include tags to detect egress lane shapes
            isEgressLane: s.tags?.includes('egress_lane'),
            // Include egress lane assignments (user-defined, not calculated)
            egressLanes: s.type === 'Spot' ? s.metadata?.egressLanes : undefined
        }));
    return JSON.stringify(relevantData);
}

});


parcelRegister("41u54", function(module, exports) {

$parcel$export(module.exports, "DraggingScrollContainer", () => $43c119f5d834c625$export$5546e5dac97d6096);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");

var $acw62 = parcelRequire("acw62");

var $5Bqq3 = parcelRequire("5Bqq3");

var $3JLDK = parcelRequire("3JLDK");

var $iEhC9 = parcelRequire("iEhC9");

var $lNEp2 = parcelRequire("lNEp2");
const $43c119f5d834c625$export$5546e5dac97d6096 = ({ children: children, feetToPixels: feetToPixels, disabled: disabled = false, onClick: onClick, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseUp: onMouseUp, onMouseLeave: onMouseLeave, onContextMenu: onContextMenu, preventDefault: preventDefault, zoomLevel: zoomLevel })=>{
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const { active: isMeasuringToolActive } = (0, $5Bqq3.useMeasuringToolState)();
    const { setX0: setX0, setY0: setY0 } = (0, $iEhC9.useLayoutCanvasState)();
    // Begin grab scroll state mgmt
    const containerRef = $acw62.useRef(null);
    const [isDragging, setIsDragging] = $acw62.useState(false);
    const [dragStart, setDragStart] = $acw62.useState({
        x: 0,
        y: 0
    });
    const [scrollStart, setScrollStart] = $acw62.useState({
        x: 0,
        y: 0
    });
    const containerBounds = $acw62.useMemo(()=>{
        if (!containerRef.current) return {
            x: 20,
            y: 20
        };
        const rect = containerRef.current.getBoundingClientRect();
        return rect;
    }, [
        containerRef?.current,
        isDrawerOpen,
        zoomLevel
    ]);
    $acw62.useEffect(()=>{
        if (containerRef.current) {
            setX0(containerRef.current.scrollLeft / feetToPixels);
            setY0(containerRef.current.scrollTop / feetToPixels);
        }
    }, [
        containerRef.current,
        feetToPixels,
        zoomLevel
    ]);
    const dragThreshold = 5; // Minimum movement to consider a drag
    // end grab scroll state mgmt
    // Begin grab scroll handlers
    const handleParentMouseDown = (event)=>{
        // if there's no target, bail
        if (!event.target) return;
        // we need to distinguish between Select mode and other modes. If we're in Select mode, we want to
        // scroll if the click doesn't select anything.
        if (preventDefault?.(event)) {
            onMouseDown?.(event); // Call child handler
            return;
        }
        const isGrabbingContainer = event.target.getAttribute("data-grabbing-container");
        // check to see if they're dragging the layout background
        const isRampBackground = event.target.tagName === "CANVAS";
        const isHangarBackground = event.target.getAttribute("data-id") === "hangar-layout-background";
        if (!isRampBackground && !isHangarBackground && !isGrabbingContainer) return; // Ignore the event if it's not on the canvas
        setDragStart({
            x: event.clientX,
            y: event.clientY
        });
        setScrollStart({
            x: containerRef.current?.scrollLeft || 0,
            y: containerRef.current?.scrollTop || 0
        });
        setIsDragging(false);
        onMouseDown?.(event); // Call child handler
    };
    const handleParentMouseMove = (event)=>{
        if (preventDefault?.(event)) {
            onMouseMove(event); // Call child handler
            return;
        }
        if (!dragStart.x && !dragStart.y) return;
        const dx = event.clientX - dragStart.x;
        const dy = event.clientY - dragStart.y;
        if (!isDragging && (Math.abs(dx) > dragThreshold || Math.abs(dy) > dragThreshold)) setIsDragging(true);
        if (isDragging && containerRef.current) {
            containerRef.current.scrollLeft = scrollStart.x - dx;
            containerRef.current.scrollTop = scrollStart.y - dy;
        } else onMouseMove(event); // Defer to child if not dragging
    };
    const handleParentMouseUp = (event)=>{
        if (preventDefault?.(event)) {
            onMouseUp(event); // Call child handler
            return;
        }
        if (!isDragging) onClick(event); // Trigger click if not dragging
        setIsDragging(false);
        setDragStart({
            x: 0,
            y: 0
        });
        setScrollStart({
            x: 0,
            y: 0
        });
        onMouseUp?.(event); // Call child handler
    };
    const handleMouseLeave = (event)=>{
        setIsDragging(false);
        setDragStart({
            x: 0,
            y: 0
        });
        setScrollStart({
            x: 0,
            y: 0
        });
        onMouseLeave?.(event);
    };
    // if we're in read-only mode or for whatever reason we don't want to use the drag-scroll,
    // then we're just displaying so we don't need the drag scroll
    if (disabled) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
    // if the measuring tool is active, then we don't need the drag scroll
    if (isMeasuringToolActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        "data-grabbing-container": true,
        ref: containerRef,
        sx: {
            width: "100%",
            height: "100%",
            // maxWidth: `calc(100vw - ${containerBounds.x}px)`,
            maxHeight: `calc(100vh - ${containerBounds.y}px)`,
            overflow: disabled ? "inherit" : "scroll",
            cursor: isDragging ? "grabbing" : "grab",
            position: "relative",
            ...(0, $lNEp2.scrollSx)
        },
        children: children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        "data-grabbing-container": true,
        ref: containerRef,
        onScroll: ()=>{
            setX0(containerRef.current.scrollLeft / feetToPixels);
            setY0(containerRef.current.scrollTop / feetToPixels);
        },
        sx: {
            width: "100%",
            height: "100%",
            // maxWidth: `calc(100vw - ${containerBounds.x}px)`,
            maxHeight: `calc(100vh - ${containerBounds.y}px)`,
            overflow: disabled ? "inherit" : "scroll",
            cursor: isDragging ? "grabbing" : "grab",
            position: "relative",
            ...(0, $lNEp2.scrollSx)
        },
        onMouseDown: handleParentMouseDown,
        onMouseMove: handleParentMouseMove,
        onMouseUp: handleParentMouseUp,
        onMouseLeave: handleMouseLeave,
        onContextMenu: onContextMenu,
        children: children
    });
};

});

parcelRegister("7pCBl", function(module, exports) {
$parcel$export(module.exports, "Loading", () => (parcelRequire("6G9QQ")).Loading);
parcelRequire("6G9QQ");

});
parcelRegister("6G9QQ", function(module, exports) {

$parcel$export(module.exports, "Loading", () => $5ce545800af0fb12$export$669f6ea7d267feaf);

var $ayMG0 = parcelRequire("ayMG0");

var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
// Inline SVG component like other icons in the codebase
const $5ce545800af0fb12$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            margin: "auto",
            background: "transparent",
            display: "block",
            shapeRendering: "auto"
        },
        width: "150px",
        height: "150px",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                transform: "translate(26.666666666666668,26.666666666666668)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "-20",
                    y: "-20",
                    width: "40",
                    height: "40",
                    fill: "#000000",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "scale",
                        repeatCount: "indefinite",
                        dur: "1.1111111111111112s",
                        keyTimes: "0;1",
                        values: "1.1500000000000001;1",
                        begin: "-0.3333333333333333s"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                transform: "translate(73.33333333333333,26.666666666666668)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "-20",
                    y: "-20",
                    width: "40",
                    height: "40",
                    fill: "#e13123",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "scale",
                        repeatCount: "indefinite",
                        dur: "1.1111111111111112s",
                        keyTimes: "0;1",
                        values: "1.1500000000000001;1",
                        begin: "-0.22222222222222224s"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                transform: "translate(26.666666666666668,73.33333333333333)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "-20",
                    y: "-20",
                    width: "40",
                    height: "40",
                    fill: "#e13123",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "scale",
                        repeatCount: "indefinite",
                        dur: "1.1111111111111112s",
                        keyTimes: "0;1",
                        values: "1.1500000000000001;1",
                        begin: "0s"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                transform: "translate(73.33333333333333,73.33333333333333)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "-20",
                    y: "-20",
                    width: "40",
                    height: "40",
                    fill: "#000000",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "scale",
                        repeatCount: "indefinite",
                        dur: "1.1111111111111112s",
                        keyTimes: "0;1",
                        values: "1.1500000000000001;1",
                        begin: "-0.11111111111111112s"
                    })
                })
            })
        ]
    });
const $5ce545800af0fb12$export$669f6ea7d267feaf = ({ message: message })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        alignItems: "center",
        justifyContent: "center",
        sx: {
            height: "100%",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5ce545800af0fb12$var$LoadingSpinner, {}),
            // If a message is provided, display it
            message && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                children: message
            })
        ]
    });

});


parcelRegister("8ZoVx", function(module, exports) {

$parcel$export(module.exports, "CanvasTextInput", () => $8f9fcc11d27ef3f8$export$4f75a751904f4e10);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $8f9fcc11d27ef3f8$export$4f75a751904f4e10 = ({ open: open, setOpen: setOpen, onDone: onDone })=>{
    const [text, setText] = $acw62.useState("");
    $acw62.useEffect(()=>{
        setText("");
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MV2p.default), {
        open: open,
        onClose: ()=>setOpen(false),
        maxWidth: "xs",
        fullWidth: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            spacing: 1,
            p: 2,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    children: "Input Text"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    variant: "outlined",
                    size: "small",
                    autoFocus: true,
                    type: "text",
                    label: "Name",
                    fullWidth: true,
                    onChange: (e)=>setText(e.target.value),
                    value: text
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>{
                                setOpen(false);
                                setText("");
                            },
                            color: "primary",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            color: "success",
                            onClick: ()=>{
                                setOpen(false);
                                onDone(text);
                            },
                            children: "Save"
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("6qXZS", function(module, exports) {

$parcel$export(module.exports, "useCanvasHotkeys", () => $28cfb5f919b22c1c$export$10df1b17773e40e1);

var $acw62 = parcelRequire("acw62");

var $8BlBC = parcelRequire("8BlBC");

var $5TxR8 = parcelRequire("5TxR8");

var $2v7Ik = parcelRequire("2v7Ik");

var $5gjkj = parcelRequire("5gjkj");
const $28cfb5f919b22c1c$export$10df1b17773e40e1 = (props)=>{
    const { shapes: shapes, setShapes: setShapes, activeShapes: activeShapes, pixelsToFeetRatio: pixelsToFeetRatio, undo: undo, duplicateShapes: duplicateShapes } = props;
    /**
   * Rotate the shape we're hover over when shift + <arrow> is pressed
   */ const [isShiftPressed] = (0, $5TxR8.default)("Shift");
    const [isRightArrowPressed] = (0, $5TxR8.default)("ArrowRight");
    const [isLeftArrowPressed] = (0, $5TxR8.default)("ArrowLeft");
    const [isUpArrowPressed] = (0, $5TxR8.default)("ArrowUp");
    const [isDownArrowPressed] = (0, $5TxR8.default)("ArrowDown");
    // Extract movement logic into a memoized callback
    const performMovement = (0, $acw62.useCallback)(()=>{
        if (activeShapes.length === 0) return;
        // Rotation with Shift + Left/Right
        if (isShiftPressed && (isRightArrowPressed || isLeftArrowPressed)) {
            setShapes((currentShapes)=>{
                const selectedShapes = currentShapes.filter((s)=>activeShapes.includes(s.id));
                // T-shape snapping logic
                if ((selectedShapes.every((shape)=>shape.type === "Tie Down T") || selectedShapes.every((shape)=>shape.type === "Double T")) && !selectedShapes.map((shape)=>Math.round(100 * Math.atan2(shape.points[1].y - shape.points[0].y, shape.points[1].x - shape.points[0].x))).every((val, i, arr)=>val === arr[0])) {
                    const referenceAngle = Math.atan2(selectedShapes[0].points[1].y - selectedShapes[0].points[0].y, selectedShapes[0].points[1].x - selectedShapes[0].points[0].x);
                    let updatedShapes = [
                        ...currentShapes
                    ];
                    selectedShapes.forEach((shape)=>{
                        const currentAngle = Math.atan2(shape.points[1].y - shape.points[0].y, shape.points[1].x - shape.points[0].x);
                        const angleDifference = referenceAngle - currentAngle;
                        const rotatedPoints = (0, $2v7Ik.rotatePoints)(shape.points, angleDifference * 180 / Math.PI);
                        updatedShapes = (0, $5gjkj.updateAtId)(updatedShapes, {
                            ...shape,
                            points: rotatedPoints
                        });
                    });
                    return updatedShapes;
                }
                // Regular rotation
                let updatedShapes = [
                    ...currentShapes
                ];
                selectedShapes.forEach((shape)=>{
                    updatedShapes = (0, $5gjkj.updateAtId)(updatedShapes, {
                        ...shape,
                        points: (0, $2v7Ik.rotatePoints)(shape.points, isRightArrowPressed ? 0.1 : -0.1)
                    });
                });
                return updatedShapes;
            });
            return;
        }
        // Scaling with Shift + Up/Down
        if (isShiftPressed && (isUpArrowPressed || isDownArrowPressed)) {
            setShapes((currentShapes)=>{
                const selectedShapes = currentShapes.filter((s)=>activeShapes.includes(s.id));
                let updatedShapes = [
                    ...currentShapes
                ];
                selectedShapes.forEach((shape)=>{
                    updatedShapes = (0, $5gjkj.updateAtId)(updatedShapes, {
                        ...shape,
                        points: (0, $2v7Ik.scalePolygon)(shape.points, isUpArrowPressed ? 1.01 : 0.99)
                    });
                });
                return updatedShapes;
            });
            return;
        }
        // Regular movement (no Shift)
        if (!isShiftPressed) setShapes((currentShapes)=>{
            const relevantShapes = currentShapes.filter((s)=>activeShapes.includes(s.id));
            let updatedShapes = [
                ...currentShapes
            ];
            relevantShapes.forEach((shape)=>{
                const dx = isRightArrowPressed ? 1 : isLeftArrowPressed ? -1 : 0;
                const dy = isDownArrowPressed ? 1 : isUpArrowPressed ? -1 : 0;
                updatedShapes = (0, $5gjkj.updateAtId)(updatedShapes, {
                    ...shape,
                    points: shape.points.map((point)=>({
                            x: point.x + dx * pixelsToFeetRatio,
                            y: point.y + dy * pixelsToFeetRatio
                        }))
                });
            });
            return updatedShapes;
        });
    }, [
        setShapes,
        activeShapes,
        pixelsToFeetRatio,
        isShiftPressed,
        isRightArrowPressed,
        isLeftArrowPressed,
        isUpArrowPressed,
        isDownArrowPressed
    ]);
    (0, $acw62.useEffect)(()=>{
        // Don't set up interval if no keys are pressed
        const anyKeyPressed = isLeftArrowPressed || isRightArrowPressed || isDownArrowPressed || isUpArrowPressed;
        if (!anyKeyPressed || activeShapes.length === 0) return;
        // Run immediately on first key press
        performMovement();
        // Set up interval for continuous movement while key is held (50ms = 20 updates/sec)
        const interval = setInterval(performMovement, 5);
        // Cleanup interval when keys are released or component unmounts
        return ()=>clearInterval(interval);
    }, [
        performMovement,
        activeShapes,
        isLeftArrowPressed,
        isRightArrowPressed,
        isDownArrowPressed,
        isUpArrowPressed
    ]);
    (0, $8BlBC.useHotkeys)("ctrl+d", ()=>{
        duplicateShapes();
    }, [
        activeShapes,
        shapes
    ]);
    (0, $8BlBC.useHotkeys)([
        "meta+z",
        "ctrl+z"
    ], ()=>{
        undo();
    }, [
        undo
    ]);
};

});
parcelRegister("8BlBC", function(module, exports) {

$parcel$export(module.exports, "useHotkeys", () => $643289de0f480f5f$export$1b0c17123b4f3646);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
function $643289de0f480f5f$var$_extends() {
    return $643289de0f480f5f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $643289de0f480f5f$var$_extends.apply(null, arguments);
}
var $643289de0f480f5f$var$reservedModifierKeywords = [
    'shift',
    'alt',
    'meta',
    'mod',
    'ctrl'
];
var $643289de0f480f5f$var$mappedKeys = {
    esc: 'escape',
    "return": 'enter',
    '.': 'period',
    ',': 'comma',
    '-': 'slash',
    ' ': 'space',
    '`': 'backquote',
    '#': 'backslash',
    '+': 'bracketright',
    ShiftLeft: 'shift',
    ShiftRight: 'shift',
    AltLeft: 'alt',
    AltRight: 'alt',
    MetaLeft: 'meta',
    MetaRight: 'meta',
    OSLeft: 'meta',
    OSRight: 'meta',
    ControlLeft: 'ctrl',
    ControlRight: 'ctrl'
};
function $643289de0f480f5f$var$mapKey(key) {
    return (key && $643289de0f480f5f$var$mappedKeys[key] || key || '').trim().toLowerCase().replace(/key|digit|numpad|arrow/, '');
}
function $643289de0f480f5f$var$isHotkeyModifier(key) {
    return $643289de0f480f5f$var$reservedModifierKeywords.includes(key);
}
function $643289de0f480f5f$var$parseKeysHookInput(keys, splitKey) {
    if (splitKey === void 0) splitKey = ',';
    return keys.split(splitKey);
}
function $643289de0f480f5f$var$parseHotkey(hotkey, combinationKey, description) {
    if (combinationKey === void 0) combinationKey = '+';
    var keys = hotkey.toLocaleLowerCase().split(combinationKey).map(function(k) {
        return $643289de0f480f5f$var$mapKey(k);
    });
    var modifiers = {
        alt: keys.includes('alt'),
        ctrl: keys.includes('ctrl') || keys.includes('control'),
        shift: keys.includes('shift'),
        meta: keys.includes('meta'),
        mod: keys.includes('mod')
    };
    var singleCharKeys = keys.filter(function(k) {
        return !$643289de0f480f5f$var$reservedModifierKeywords.includes(k);
    });
    return $643289de0f480f5f$var$_extends({}, modifiers, {
        keys: singleCharKeys,
        description: description,
        hotkey: hotkey
    });
}
(function() {
    if (typeof document !== 'undefined') {
        document.addEventListener('keydown', function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $643289de0f480f5f$var$pushToCurrentlyPressedKeys([
                $643289de0f480f5f$var$mapKey(e.key),
                $643289de0f480f5f$var$mapKey(e.code)
            ]);
        });
        document.addEventListener('keyup', function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $643289de0f480f5f$var$removeFromCurrentlyPressedKeys([
                $643289de0f480f5f$var$mapKey(e.key),
                $643289de0f480f5f$var$mapKey(e.code)
            ]);
        });
    }
    if (typeof window !== 'undefined') window.addEventListener('blur', function() {
        $643289de0f480f5f$var$currentlyPressedKeys.clear();
    });
})();
var $643289de0f480f5f$var$currentlyPressedKeys = /*#__PURE__*/ new Set();
// https://github.com/microsoft/TypeScript/issues/17002
function $643289de0f480f5f$var$isReadonlyArray(value) {
    return Array.isArray(value);
}
function $643289de0f480f5f$export$eae3d25ef8fab782(key, splitKey) {
    if (splitKey === void 0) splitKey = ',';
    var hotkeyArray = $643289de0f480f5f$var$isReadonlyArray(key) ? key : key.split(splitKey);
    return hotkeyArray.every(function(hotkey) {
        return $643289de0f480f5f$var$currentlyPressedKeys.has(hotkey.trim().toLowerCase());
    });
}
function $643289de0f480f5f$var$pushToCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if ($643289de0f480f5f$var$currentlyPressedKeys.has('meta')) $643289de0f480f5f$var$currentlyPressedKeys.forEach(function(key) {
        return !$643289de0f480f5f$var$isHotkeyModifier(key) && $643289de0f480f5f$var$currentlyPressedKeys["delete"](key.toLowerCase());
    });
    hotkeyArray.forEach(function(hotkey) {
        return $643289de0f480f5f$var$currentlyPressedKeys.add(hotkey.toLowerCase());
    });
}
function $643289de0f480f5f$var$removeFromCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if (key === 'meta') $643289de0f480f5f$var$currentlyPressedKeys.clear();
    else hotkeyArray.forEach(function(hotkey) {
        return $643289de0f480f5f$var$currentlyPressedKeys["delete"](hotkey.toLowerCase());
    });
}
function $643289de0f480f5f$var$maybePreventDefault(e, hotkey, preventDefault) {
    if (typeof preventDefault === 'function' && preventDefault(e, hotkey) || preventDefault === true) e.preventDefault();
}
function $643289de0f480f5f$var$isHotkeyEnabled(e, hotkey, enabled) {
    if (typeof enabled === 'function') return enabled(e, hotkey);
    return enabled === true || enabled === undefined;
}
function $643289de0f480f5f$var$isKeyboardEventTriggeredByInput(ev) {
    return $643289de0f480f5f$var$isHotkeyEnabledOnTag(ev, [
        'input',
        'textarea',
        'select'
    ]);
}
function $643289de0f480f5f$var$isHotkeyEnabledOnTag(event, enabledOnTags) {
    if (enabledOnTags === void 0) enabledOnTags = false;
    var target = event.target, composed = event.composed;
    var targetTagName = null;
    if ($643289de0f480f5f$var$isCustomElement(target) && composed) targetTagName = event.composedPath()[0] && event.composedPath()[0].tagName;
    else targetTagName = target && target.tagName;
    if ($643289de0f480f5f$var$isReadonlyArray(enabledOnTags)) return Boolean(targetTagName && enabledOnTags && enabledOnTags.some(function(tag) {
        var _targetTagName;
        return tag.toLowerCase() === ((_targetTagName = targetTagName) == null ? void 0 : _targetTagName.toLowerCase());
    }));
    return Boolean(targetTagName && enabledOnTags && enabledOnTags);
}
function $643289de0f480f5f$var$isCustomElement(element) {
    // We just do a basic check w/o any complex RegEx or validation against the list of legacy names containing a hyphen,
    // as none of them is likely to be an event target, and it won't hurt anyway if we miss.
    // see: https://html.spec.whatwg.org/multipage/custom-elements.html#prod-potentialcustomelementname
    return !!element.tagName && !element.tagName.startsWith("-") && element.tagName.includes("-");
}
function $643289de0f480f5f$var$isScopeActive(activeScopes, scopes) {
    if (activeScopes.length === 0 && scopes) {
        console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>');
        return true;
    }
    if (!scopes) return true;
    return activeScopes.some(function(scope) {
        return scopes.includes(scope);
    }) || activeScopes.includes('*');
}
var $643289de0f480f5f$var$isHotkeyMatchingKeyboardEvent = function isHotkeyMatchingKeyboardEvent(e, hotkey, ignoreModifiers) {
    if (ignoreModifiers === void 0) ignoreModifiers = false;
    var alt = hotkey.alt, meta = hotkey.meta, mod = hotkey.mod, shift = hotkey.shift, ctrl = hotkey.ctrl, keys = hotkey.keys;
    var pressedKeyUppercase = e.key, code = e.code, ctrlKey = e.ctrlKey, metaKey = e.metaKey, shiftKey = e.shiftKey, altKey = e.altKey;
    var keyCode = $643289de0f480f5f$var$mapKey(code);
    var pressedKey = pressedKeyUppercase.toLowerCase();
    if (!(keys != null && keys.includes(keyCode)) && !(keys != null && keys.includes(pressedKey)) && ![
        'ctrl',
        'control',
        'unknown',
        'meta',
        'alt',
        'shift',
        'os'
    ].includes(keyCode)) return false;
    if (!ignoreModifiers) {
        // We check the pressed keys for compatibility with the keyup event. In keyup events the modifier flags are not set.
        if (alt === !altKey && pressedKey !== 'alt') return false;
        if (shift === !shiftKey && pressedKey !== 'shift') return false;
        // Mod is a special key name that is checking for meta on macOS and ctrl on other platforms
        if (mod) {
            if (!metaKey && !ctrlKey) return false;
        } else {
            if (meta === !metaKey && pressedKey !== 'meta' && pressedKey !== 'os') return false;
            if (ctrl === !ctrlKey && pressedKey !== 'ctrl' && pressedKey !== 'control') return false;
        }
    }
    // All modifiers are correct, now check the key
    // If the key is set, we check for the key
    if (keys && keys.length === 1 && (keys.includes(pressedKey) || keys.includes(keyCode))) return true;
    else if (keys) // Check if all keys are present in pressedDownKeys set
    return $643289de0f480f5f$export$eae3d25ef8fab782(keys);
    else if (!keys) // If the key is not set, we only listen for modifiers, that check went alright, so we return true
    return true;
    // There is nothing that matches.
    return false;
};
var $643289de0f480f5f$var$BoundHotkeysProxyProvider = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $643289de0f480f5f$var$useBoundHotkeysProxy = function useBoundHotkeysProxy() {
    return (0, $acw62.useContext)($643289de0f480f5f$var$BoundHotkeysProxyProvider);
};
function $643289de0f480f5f$var$BoundHotkeysProxyProviderProvider(_ref) {
    var addHotkey = _ref.addHotkey, removeHotkey = _ref.removeHotkey, children = _ref.children;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($643289de0f480f5f$var$BoundHotkeysProxyProvider.Provider, {
        value: {
            addHotkey: addHotkey,
            removeHotkey: removeHotkey
        },
        children: children
    });
}
function $643289de0f480f5f$var$deepEqual(x, y) {
    //@ts-ignore
    return x && y && typeof x === 'object' && typeof y === 'object' ? Object.keys(x).length === Object.keys(y).length && //@ts-ignore
    Object.keys(x).reduce(function(isEqual, key) {
        return isEqual && $643289de0f480f5f$var$deepEqual(x[key], y[key]);
    }, true) : x === y;
}
var $643289de0f480f5f$var$HotkeysContext = /*#__PURE__*/ (0, $acw62.createContext)({
    hotkeys: [],
    enabledScopes: [],
    toggleScope: function toggleScope() {},
    enableScope: function enableScope() {},
    disableScope: function disableScope() {}
});
var $643289de0f480f5f$export$183c7bf336967877 = function useHotkeysContext() {
    return (0, $acw62.useContext)($643289de0f480f5f$var$HotkeysContext);
};
var $643289de0f480f5f$export$9d58aaad435254c0 = function HotkeysProvider(_ref) {
    var _ref$initiallyActiveS = _ref.initiallyActiveScopes, initiallyActiveScopes = _ref$initiallyActiveS === void 0 ? [
        '*'
    ] : _ref$initiallyActiveS, children = _ref.children;
    var _useState = (0, $acw62.useState)((initiallyActiveScopes == null ? void 0 : initiallyActiveScopes.length) > 0 ? initiallyActiveScopes : [
        '*'
    ]), internalActiveScopes = _useState[0], setInternalActiveScopes = _useState[1];
    var _useState2 = (0, $acw62.useState)([]), boundHotkeys = _useState2[0], setBoundHotkeys = _useState2[1];
    var enableScope = (0, $acw62.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes('*')) return [
                scope
            ];
            return Array.from(new Set([].concat(prev, [
                scope
            ])));
        });
    }, []);
    var disableScope = (0, $acw62.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.filter(function(s) {
                return s !== scope;
            }).length === 0) return [
                '*'
            ];
            else return prev.filter(function(s) {
                return s !== scope;
            });
        });
    }, []);
    var toggleScope = (0, $acw62.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes(scope)) {
                if (prev.filter(function(s) {
                    return s !== scope;
                }).length === 0) return [
                    '*'
                ];
                else return prev.filter(function(s) {
                    return s !== scope;
                });
            } else {
                if (prev.includes('*')) return [
                    scope
                ];
                return Array.from(new Set([].concat(prev, [
                    scope
                ])));
            }
        });
    }, []);
    var addBoundHotkey = (0, $acw62.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return [].concat(prev, [
                hotkey
            ]);
        });
    }, []);
    var removeBoundHotkey = (0, $acw62.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return prev.filter(function(h) {
                return !$643289de0f480f5f$var$deepEqual(h, hotkey);
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($643289de0f480f5f$var$HotkeysContext.Provider, {
        value: {
            enabledScopes: internalActiveScopes,
            hotkeys: boundHotkeys,
            enableScope: enableScope,
            disableScope: disableScope,
            toggleScope: toggleScope
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($643289de0f480f5f$var$BoundHotkeysProxyProviderProvider, {
            addHotkey: addBoundHotkey,
            removeHotkey: removeBoundHotkey,
            children: children
        })
    });
};
function $643289de0f480f5f$var$useDeepEqualMemo(value) {
    var ref = (0, $acw62.useRef)(undefined);
    if (!$643289de0f480f5f$var$deepEqual(ref.current, value)) ref.current = value;
    return ref.current;
}
var $643289de0f480f5f$var$stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
};
var $643289de0f480f5f$var$useSafeLayoutEffect = typeof window !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $643289de0f480f5f$export$1b0c17123b4f3646(keys, callback, options, dependencies) {
    var _useState = (0, $acw62.useState)(null), ref = _useState[0], setRef = _useState[1];
    var hasTriggeredRef = (0, $acw62.useRef)(false);
    var _options = !(options instanceof Array) ? options : !(dependencies instanceof Array) ? dependencies : undefined;
    var _keys = $643289de0f480f5f$var$isReadonlyArray(keys) ? keys.join(_options == null ? void 0 : _options.splitKey) : keys;
    var _deps = options instanceof Array ? options : dependencies instanceof Array ? dependencies : undefined;
    var memoisedCB = (0, $acw62.useCallback)(callback, _deps != null ? _deps : []);
    var cbRef = (0, $acw62.useRef)(memoisedCB);
    if (_deps) cbRef.current = memoisedCB;
    else cbRef.current = callback;
    var memoisedOptions = $643289de0f480f5f$var$useDeepEqualMemo(_options);
    var _useHotkeysContext = $643289de0f480f5f$export$183c7bf336967877(), enabledScopes = _useHotkeysContext.enabledScopes;
    var proxy = $643289de0f480f5f$var$useBoundHotkeysProxy();
    $643289de0f480f5f$var$useSafeLayoutEffect(function() {
        if ((memoisedOptions == null ? void 0 : memoisedOptions.enabled) === false || !$643289de0f480f5f$var$isScopeActive(enabledScopes, memoisedOptions == null ? void 0 : memoisedOptions.scopes)) return;
        var listener = function listener(e, isKeyUp) {
            var _e$target;
            if (isKeyUp === void 0) isKeyUp = false;
            if ($643289de0f480f5f$var$isKeyboardEventTriggeredByInput(e) && !$643289de0f480f5f$var$isHotkeyEnabledOnTag(e, memoisedOptions == null ? void 0 : memoisedOptions.enableOnFormTags)) return;
            // TODO: SINCE THE EVENT IS NOW ATTACHED TO THE REF, THE ACTIVE ELEMENT CAN NEVER BE INSIDE THE REF. THE HOTKEY ONLY TRIGGERS IF THE
            // REF IS THE ACTIVE ELEMENT. THIS IS A PROBLEM SINCE FOCUSED SUB COMPONENTS WON'T TRIGGER THE HOTKEY.
            if (ref !== null) {
                var rootNode = ref.getRootNode();
                if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement !== ref && !ref.contains(rootNode.activeElement)) {
                    $643289de0f480f5f$var$stopPropagation(e);
                    return;
                }
            }
            if ((_e$target = e.target) != null && _e$target.isContentEditable && !(memoisedOptions != null && memoisedOptions.enableOnContentEditable)) return;
            $643289de0f480f5f$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                var _hotkey$keys;
                var hotkey = $643289de0f480f5f$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey);
                if ($643289de0f480f5f$var$isHotkeyMatchingKeyboardEvent(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.ignoreModifiers) || (_hotkey$keys = hotkey.keys) != null && _hotkey$keys.includes('*')) {
                    if (memoisedOptions != null && memoisedOptions.ignoreEventWhen != null && memoisedOptions.ignoreEventWhen(e)) return;
                    if (isKeyUp && hasTriggeredRef.current) return;
                    $643289de0f480f5f$var$maybePreventDefault(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.preventDefault);
                    if (!$643289de0f480f5f$var$isHotkeyEnabled(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.enabled)) {
                        $643289de0f480f5f$var$stopPropagation(e);
                        return;
                    }
                    // Execute the user callback for that hotkey
                    cbRef.current(e, hotkey);
                    if (!isKeyUp) hasTriggeredRef.current = true;
                }
            });
        };
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $643289de0f480f5f$var$pushToCurrentlyPressedKeys($643289de0f480f5f$var$mapKey(event.code));
            if ((memoisedOptions == null ? void 0 : memoisedOptions.keydown) === undefined && (memoisedOptions == null ? void 0 : memoisedOptions.keyup) !== true || memoisedOptions != null && memoisedOptions.keydown) listener(event);
        };
        var handleKeyUp = function handleKeyUp(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $643289de0f480f5f$var$removeFromCurrentlyPressedKeys($643289de0f480f5f$var$mapKey(event.code));
            hasTriggeredRef.current = false;
            if (memoisedOptions != null && memoisedOptions.keyup) listener(event, true);
        };
        var domNode = ref || (_options == null ? void 0 : _options.document) || document;
        // @ts-ignore
        domNode.addEventListener('keyup', handleKeyUp, _options == null ? void 0 : _options.eventListenerOptions);
        // @ts-ignore
        domNode.addEventListener('keydown', handleKeyDown, _options == null ? void 0 : _options.eventListenerOptions);
        if (proxy) $643289de0f480f5f$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
            return proxy.addHotkey($643289de0f480f5f$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
        });
        return function() {
            // @ts-ignore
            domNode.removeEventListener('keyup', handleKeyUp, _options == null ? void 0 : _options.eventListenerOptions);
            // @ts-ignore
            domNode.removeEventListener('keydown', handleKeyDown, _options == null ? void 0 : _options.eventListenerOptions);
            if (proxy) $643289de0f480f5f$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                return proxy.removeHotkey($643289de0f480f5f$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
            });
        };
    }, [
        ref,
        _keys,
        memoisedOptions,
        enabledScopes
    ]);
    return setRef;
}
function $643289de0f480f5f$export$175b3984f625ab17() {
    var _useState = (0, $acw62.useState)(new Set()), keys = _useState[0], setKeys = _useState[1];
    var _useState2 = (0, $acw62.useState)(false), isRecording = _useState2[0], setIsRecording = _useState2[1];
    var handler = (0, $acw62.useCallback)(function(event) {
        if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
        return;
        event.preventDefault();
        event.stopPropagation();
        setKeys(function(prev) {
            var newKeys = new Set(prev);
            newKeys.add($643289de0f480f5f$var$mapKey(event.code));
            return newKeys;
        });
    }, []);
    var stop = (0, $acw62.useCallback)(function() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('keydown', handler);
            setIsRecording(false);
        }
    }, [
        handler
    ]);
    var start = (0, $acw62.useCallback)(function() {
        setKeys(new Set());
        if (typeof document !== 'undefined') {
            stop();
            document.addEventListener('keydown', handler);
            setIsRecording(true);
        }
    }, [
        handler,
        stop
    ]);
    var resetKeys = (0, $acw62.useCallback)(function() {
        setKeys(new Set());
    }, []);
    return [
        keys,
        {
            start: start,
            stop: stop,
            resetKeys: resetKeys,
            isRecording: isRecording
        }
    ];
}

});

parcelRegister("5gjkj", function(module, exports) {

$parcel$export(module.exports, "updateAtId", () => $d5e6ce70141b9e6b$export$82b565b671f7579a);
const $d5e6ce70141b9e6b$export$82b565b671f7579a = (shapes, newShape)=>{
    const updatedShapes = shapes.filter((s)=>s.id !== newShape.id);
    return [
        newShape,
        ...updatedShapes
    ];
};

});


parcelRegister("d9sFw", function(module, exports) {

$parcel$export(module.exports, "useOnCanvasClick", () => $8bb0b3b145764c08$export$199d87aabe9d2aa9);

var $acw62 = parcelRequire("acw62");

var $2v7Ik = parcelRequire("2v7Ik");

var $67btB = parcelRequire("67btB");

var $7mOBL = parcelRequire("7mOBL");
const $8bb0b3b145764c08$export$199d87aabe9d2aa9 = (props)=>{
    const { selectedTool: selectedTool, shapes: shapes, currentShape: currentShape, setCurrentShape: setCurrentShape, setShape: setShape, setShapes: setShapes, setActiveShapes: setActiveShapes, activeShapes: activeShapes, canvasRef: canvasRef, ramp: ramp, isShiftPressed: isShiftPressed, isCommandPressed: isCommandPressed, isOptPressed: isOptPressed, setMousePosition: setMousePosition, setSelectedTool: setSelectedTool, setContextMenu: setContextMenu } = props;
    return (0, $acw62.useCallback)((event)=>{
        if (selectedTool === "Measuring") return;
        const rect = canvasRef.current?.getBoundingClientRect();
        if (!rect) return;
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        // Handle calibration point addition
        if (selectedTool === "CalibrationPoint") {
            if (window.addCalibrationPoint) {
                // Convert pixel coordinates to relative coordinates for storage
                // x and y are canvas pixel coordinates, convert to relative (0.0 to 1.0)
                const canvasWidth = canvasRef.current?.width || 1;
                const canvasHeight = canvasRef.current?.height || 1;
                const xRelative = x / canvasWidth;
                const yRelative = y / canvasHeight;
                window.addCalibrationPoint(xRelative, yRelative);
            }
            return;
        }
        if (selectedTool === "Select") {
            // look for any shapes that are clicked on
            const clickedShape = shapes.find((shape)=>{
                if (shape.locked) return false;
                if (shape.type === "Text") {
                    // since Text is just a single point, just evaluate that point w/ a nice buffer
                    // adjust for the length of the text. the user will perceive the shape as being
                    // the full length of the text on the screen
                    const canvas = canvasRef.current;
                    return (0, $2v7Ik.isOnText)(canvas, shape, {
                        x: x,
                        y: y
                    });
                }
                return (0, $2v7Ik.isPointInShapeOrOnEdge)({
                    x: x,
                    y: y
                }, shape.points);
            });
            if (clickedShape) {
                if ([
                    "Line",
                    "Area"
                ].includes(clickedShape.type)) {
                    // handle inserting a point
                    if (isCommandPressed) {
                        setShape(clickedShape.id, {
                            ...clickedShape,
                            points: (0, $2v7Ik.insertNewPoint)(clickedShape.points, {
                                x: x,
                                y: y
                            })
                        });
                        return;
                    }
                    // handle deleting a point
                    if (isOptPressed) {
                        // if area only has 3 points, delete the whole shape. if line has 2 points, delete the whole shape
                        const newPoints = clickedShape.points.filter((point)=>Math.hypot(point.x - x, point.y - y) > 10);
                        if (clickedShape.type === "Area" && newPoints.length < 3 || clickedShape.type === "Line" && newPoints.length < 2) setShapes(shapes.filter((shape)=>shape.id !== clickedShape.id));
                        else setShape(clickedShape.id, {
                            ...clickedShape,
                            points: newPoints
                        });
                        return;
                    }
                }
                // check to see if we're in multi-select mode
                if (isShiftPressed) {
                    // handle shape selection (multi-select mode - don't open dialog)
                    if (activeShapes.includes(clickedShape.id)) setActiveShapes(activeShapes.filter((id)=>id !== clickedShape.id));
                    else setActiveShapes([
                        ...activeShapes,
                        clickedShape.id
                    ]);
                } else {
                    // Single selection - open the properties dialog
                    if (activeShapes.includes(clickedShape.id)) setActiveShapes(activeShapes);
                    else setActiveShapes([
                        clickedShape.id
                    ]);
                    // Auto-open the Shape Properties dialog
                    setContextMenu({
                        x: x,
                        y: y,
                        shapeId: clickedShape.id
                    });
                }
            } else {
                setActiveShapes([]);
                setContextMenu(null);
            }
            return;
        }
        // if we're in Line mode, check to see if we're done
        if (currentShape.points.length > 0) {
            const lastPoint = currentShape.points[currentShape.points.length - 1];
            // Check if the click is on the starting point to complete the shape
            if (Math.hypot(lastPoint.x - x, lastPoint.y - y) < 10) {
                setShapes([
                    currentShape,
                    ...shapes
                ]);
                setCurrentShape((0, $67btB.makeDefaultShape)(ramp.fbo_id, ramp.id));
                setMousePosition(null);
                setSelectedTool("Select");
                return;
            }
        }
        // if we're in Area mode, check to see if we're done
        if (currentShape.points.length > 0) {
            const firstPoint = currentShape.points[0];
            // Check if the click is on the starting point to complete the shape
            if (Math.hypot(firstPoint.x - x, firstPoint.y - y) < 10) {
                setShapes([
                    currentShape,
                    ...shapes
                ]);
                setCurrentShape({
                    ...(0, $67btB.makeDefaultShape)(ramp.fbo_id, ramp.id),
                    fill_style: (0, $7mOBL.SHAPE_COLORS)[0]
                });
                setMousePosition(null);
                setSelectedTool("Select");
                return;
            }
        }
        /**
     * If we're in 'snap' mode, then modify what will be the next point.
     */ const isSnapMode = isShiftPressed && [
            "Line",
            "Area",
            "Zone"
        ].includes(selectedTool);
        const points = currentShape.points;
        const nextPoint = isSnapMode ? (0, $2v7Ik.getSnapPoint)({
            x: x,
            y: y
        }, points[points.length - 1]) : {
            x: x,
            y: y
        };
        // Add a new point to the current shape
        setCurrentShape({
            ...currentShape,
            type: selectedTool === "Area" ? "Area" : selectedTool === "Zone" ? "Zone" : "Line",
            line_style: selectedTool === "Zone" ? "solid" : "solid",
            line_width: selectedTool === "Zone" ? 2 : 3,
            stroke_style: selectedTool === "Zone" ? "#FFFFFF" : (0, $7mOBL.SHAPE_COLORS)[0],
            fill_style: selectedTool === "Zone" ? "" : currentShape.fill_style,
            text: selectedTool === "Zone" ? "New Zone" : currentShape.text,
            metadata: selectedTool === "Zone" ? {} : currentShape.metadata,
            tags: selectedTool === "Zone" ? [
                "zone"
            ] : currentShape.tags || [],
            points: [
                ...currentShape.points,
                nextPoint
            ]
        });
    }, [
        props
    ]);
};

});

parcelRegister("655Fv", function(module, exports) {

$parcel$export(module.exports, "useOnContextMenu", () => $6b6ba81f8783aaf5$export$ca7798d25343efd8);

var $acw62 = parcelRequire("acw62");

var $2v7Ik = parcelRequire("2v7Ik");
const $6b6ba81f8783aaf5$export$ca7798d25343efd8 = (props)=>{
    const { selectedTool: selectedTool, shapes: shapes, setContextMenu: setContextMenu, canvasRef: canvasRef } = props;
    return (0, $acw62.useCallback)((event)=>{
        if (selectedTool === "Measuring") return;
        event.preventDefault();
        const rect = canvasRef.current?.getBoundingClientRect();
        if (!rect) return;
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        // Check if the right-click is within any shape
        const clickedShape = shapes.filter((s)=>!s.locked).find((shape)=>{
            // since Text is just a single point, just evaluate that point w/ a nice buffer
            if (shape.type === "Text") {
                // adjust for the length of the text. the user will perceive the shape as being
                // the full length of the text on the screen
                const textWidth = shape.text.length * shape.font_size;
                const textHeight = shape.font_size;
                const points = [
                    {
                        x: shape.points[0].x - textWidth / 2,
                        y: shape.points[0].y - textHeight / 2
                    },
                    {
                        x: shape.points[0].x + textWidth / 2,
                        y: shape.points[0].y - textHeight / 2
                    },
                    {
                        x: shape.points[0].x + textWidth / 2,
                        y: shape.points[0].y + textHeight / 2
                    },
                    {
                        x: shape.points[0].x - textWidth / 2,
                        y: shape.points[0].y + textHeight / 2
                    }
                ];
                return (0, $2v7Ik.isPointInShapeOrOnEdge)({
                    x: x,
                    y: y
                }, points);
            }
            return (0, $2v7Ik.isPointInShapeOrOnEdge)({
                x: x,
                y: y
            }, shape.points);
        });
        if (clickedShape) setContextMenu({
            x: x,
            y: y,
            shapeId: clickedShape.id
        });
    }, [
        props
    ]);
};

});

parcelRegister("90nUZ", function(module, exports) {

$parcel$export(module.exports, "clickedShape", () => $eaa85fa4d52e719a$export$5ca00649c00f6200);
$parcel$export(module.exports, "useOnMouseDown", () => $eaa85fa4d52e719a$export$e38175919194eb6a);

var $acw62 = parcelRequire("acw62");
parcelRequire("lNEp2");

var $2v7Ik = parcelRequire("2v7Ik");
const $eaa85fa4d52e719a$export$5ca00649c00f6200 = (canvasRef, event, shapes)=>{
    const rect = canvasRef.current?.getBoundingClientRect();
    if (!rect) return;
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    // Check if we're clicking on a point in an existing shape
    for (const shape of shapes){
        if (shape.locked) continue;
        const pointIndex = shape.points.findIndex((point)=>Math.hypot(point.x - x, point.y - y) < 10);
        if (pointIndex !== -1) return true;
        if (shape.type === "Text") {
            // since Text is just a single point, just evaluate that point w/ a nice buffer
            // adjust for the length of the text. the user will perceive the shape as being
            // the full length of the text on the screen
            const canvas = canvasRef.current;
            if ((0, $2v7Ik.isOnText)(canvas, shape, {
                x: x,
                y: y
            })) return true;
        }
        // check if the mouse is inside the shape
        if ((0, $2v7Ik.isPointInShapeOrOnEdge)({
            x: x,
            y: y
        }, shape.points)) return true;
        // Check if the mouse is close to any line segment of the shape
        for(let j = 0; j < shape.points.length; j++){
            const start = shape.points[j];
            const end = shape.points[(j + 1) % shape.points.length];
            const distToLine = (0, $2v7Ik.pointToSegmentDistance)({
                x: x,
                y: y
            }, start, end);
            if (distToLine < 10) // Threshold to detect the line
            return true;
        }
    }
    return false;
};
const $eaa85fa4d52e719a$export$e38175919194eb6a = (props)=>{
    const { selectedTool: selectedTool, setSelectedTool: setSelectedTool, shapes: shapes, setShapes: setShapes, currentShape: currentShape, setDraggingPoint: setDraggingPoint, setDraggingShape: setDraggingShape, canvasRef: canvasRef, ramp: ramp, setHistory: setHistory, setTextPrompt: setTextPrompt } = props;
    return (0, $acw62.useCallback)((event)=>{
        if (selectedTool === "Measuring") return;
        setHistory((previousHistory)=>{
            // check if the md5 of the last shape is the same as the current shape
            // if it is, don't add it to the history
            if (previousHistory.length > 0 && JSON.stringify(previousHistory[previousHistory.length - 1]) === JSON.stringify(shapes)) return previousHistory;
            return [
                ...previousHistory,
                shapes
            ];
        });
        const rect = canvasRef.current?.getBoundingClientRect();
        if (!rect) return;
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        // if we're in Text mode, add a text pill
        if (selectedTool === "Text") {
            setTextPrompt({
                open: true,
                x: x,
                y: y
            });
            return;
        }
        // Check if we're clicking on a point in an existing shape
        for (const shape of shapes){
            if (shape.locked) continue;
            const pointIndex = shape.points.findIndex((point)=>Math.hypot(point.x - x, point.y - y) < 10);
            if (pointIndex !== -1) {
                // Prevent dragging corner points for Spots (fixed size)
                if (shape.type === "Spot") continue;
                setDraggingPoint({
                    shapeId: shape.id,
                    pointIndex: pointIndex
                });
                return;
            }
            if (shape.type === "Text") {
                // since Text is just a single point, just evaluate that point w/ a nice buffer
                // adjust for the length of the text. the user will perceive the shape as being
                // the full length of the text on the screen
                const canvas = canvasRef.current;
                if ((0, $2v7Ik.isOnText)(canvas, shape, {
                    x: x,
                    y: y
                })) {
                    setDraggingShape({
                        shapeId: shape.id,
                        offset: {
                            x: x,
                            y: y
                        }
                    });
                    return;
                }
            }
            // check if the mouse is inside the shape
            if ((0, $2v7Ik.isPointInShapeOrOnEdge)({
                x: x,
                y: y
            }, shape.points)) {
                setDraggingShape({
                    shapeId: shape.id,
                    offset: {
                        x: x,
                        y: y
                    }
                });
                return;
            }
            // Check if the mouse is close to any line segment of the shape
            for(let j = 0; j < shape.points.length; j++){
                const start = shape.points[j];
                const end = shape.points[(j + 1) % shape.points.length];
                const distToLine = (0, $2v7Ik.pointToSegmentDistance)({
                    x: x,
                    y: y
                }, start, end);
                if (distToLine < 10) {
                    // Threshold to detect the line
                    setDraggingShape({
                        shapeId: shape.id,
                        offset: {
                            x: x,
                            y: y
                        }
                    });
                    return;
                }
            }
        }
        // Check if we're clicking on a point in the current shape
        const pointIndex = currentShape.points.findIndex((point)=>Math.hypot(point.x - x, point.y - y) < 10);
        if (pointIndex !== -1) setDraggingPoint({
            shapeId: null,
            pointIndex: pointIndex
        });
    }, [
        props
    ]);
};

});

parcelRegister("gC9gt", function(module, exports) {

$parcel$export(module.exports, "useOnMouseMove", () => $7dd14b929958089e$export$97edce5f2fe1cbac);

var $acw62 = parcelRequire("acw62");

var $2v7Ik = parcelRequire("2v7Ik");

var $5gjkj = parcelRequire("5gjkj");
const $7dd14b929958089e$export$97edce5f2fe1cbac = (props)=>{
    const { selectedTool: selectedTool, shapes: shapes, setShapes: setShapes, setDraggingShape: setDraggingShape, draggingPoint: draggingPoint, draggingShape: draggingShape, canvasRef: canvasRef, isShiftPressed: isShiftPressed, setMousePosition: setMousePosition, getActiveShapes: getActiveShapes } = props;
    return (0, $acw62.useCallback)((event)=>{
        if (selectedTool === "Measuring") return;
        const rect = canvasRef.current?.getBoundingClientRect();
        if (!rect) return;
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        setMousePosition({
            x: x,
            y: y
        });
        if (draggingPoint) {
            const { shapeId: shapeId, pointIndex: pointIndex } = draggingPoint;
            if (shapeId) {
                const updatedShape = shapes.find((s)=>s.id === shapeId);
                if (updatedShape.type === "Tie Down T" || updatedShape.type === "Double T" || updatedShape.type === "Circle" || updatedShape.type === "Helipad" || updatedShape?.type === "Compass Rose") {
                    // Fixed adjustment logic for square
                    const center = (0, $2v7Ik.getCenter)(updatedShape.points);
                    const adjustedPoints = (0, $2v7Ik.adjustSquare)(updatedShape.points, pointIndex, {
                        x: x,
                        y: y
                    }, center);
                    // if shift is pressed, snap to 45 degree angles
                    if (isShiftPressed) //  TODO: implement here
                    updatedShape.points = (0, $2v7Ik.snapSquare)(adjustedPoints);
                    else updatedShape.points = adjustedPoints;
                } else updatedShape.points[pointIndex] = {
                    x: x,
                    y: y
                };
                setShapes((0, $5gjkj.updateAtId)(shapes, updatedShape));
            } else if (draggingShape) {
                // Update point in an existing shape
                let updatedShapes = [
                    ...shapes
                ];
                const draggingShape = shapes.find((s)=>s.id === shapeId);
                if (draggingShape?.type === "Tie Down T" || draggingShape?.type === "Double T" || draggingShape?.type === "Circle" || draggingShape?.type === "Helipad" || draggingShape?.type === "Compass Rose") {
                    // Fixed adjustment logic for square
                    const center = (0, $2v7Ik.getCenter)(draggingShape.points);
                    const adjustedPoints = (0, $2v7Ik.adjustSquare)(draggingShape.points, pointIndex, {
                        x: x,
                        y: y
                    }, center);
                    // if shift is pressed, snap to 45 degree angles
                    if (isShiftPressed) //  TODO: implement here
                    draggingShape.points = (0, $2v7Ik.snapSquare)(adjustedPoints);
                    else draggingShape.points = adjustedPoints;
                } else draggingShape.points[pointIndex] = {
                    x: x,
                    y: y
                };
                setShapes((0, $5gjkj.updateAtId)(updatedShapes, draggingShape));
            }
        } else if (draggingShape) {
            const { shapeId: shapeId, offset: offset } = draggingShape;
            const dx = x - offset.x;
            const dy = y - offset.y;
            let updatedShapes = [
                ...shapes
            ];
            getActiveShapes().forEach((shape)=>{
                updatedShapes = (0, $5gjkj.updateAtId)(updatedShapes, {
                    ...shape,
                    points: shape.points.map((point)=>({
                            x: point.x + dx,
                            y: point.y + dy
                        }))
                });
            });
            setShapes(updatedShapes);
            setDraggingShape({
                shapeId: shapeId,
                offset: {
                    x: x,
                    y: y
                }
            });
        }
    }, [
        props
    ]);
};

});




parcelRegister("gSUrX", function(module, exports) {

$parcel$export(module.exports, "RampCanvasReadOnly", () => $74c00e9918f0aa36$export$132875b24523ef2b);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $5sKyw = parcelRequire("5sKyw");

var $2LXej = parcelRequire("2LXej");

var $keHtM = parcelRequire("keHtM");

var $ga8GY = parcelRequire("ga8GY");
const $74c00e9918f0aa36$export$4499223ad823a374 = (ctx, points, style, feetToPixels, closePolygon, readOnly)=>{
    let isFirst = true;
    for (const point of points){
        const pointInPixels = point.map(feetToPixels);
        if (!readOnly) ctx.fillRect(pointInPixels[0] - style.lineWidth, ctx.canvas.height - pointInPixels[1] - style.lineWidth, style.lineWidth * 2, style.lineWidth * 2);
        if (isFirst) {
            ctx.moveTo(pointInPixels[0], ctx.canvas.height - pointInPixels[1]);
            isFirst = false;
        } else ctx.lineTo(pointInPixels[0], ctx.canvas.height - pointInPixels[1]);
    }
    if (closePolygon && points?.length) {
        const pointInPixels = points[0].map(feetToPixels);
        ctx.lineTo(pointInPixels[0], ctx.canvas.height - pointInPixels[1]);
    }
};
const $74c00e9918f0aa36$export$e449647777f39c4d = (ctx, marking, feetToPixels, readOnly, styleOverrides = {})=>{
    ctx.beginPath();
    ctx.save();
    const style = {
        fillStyle: "magenta",
        strokeStyle: "magenta",
        lineWidth: 2,
        lineCap: null
    };
    if (marking.type === (0, $keHtM.MarkingType).OUTLINE) {
        style.fillStyle = "#3c6ce9";
        style.strokeStyle = "#3c6ce9";
        style.lineWidth = readOnly ? 2 : 2;
    } else if (marking.type === (0, $keHtM.MarkingType).RED_SOLID) {
        style.strokeStyle = "red";
        style.fillStyle = "red";
        style.lineWidth = readOnly ? 2 : 2;
    } else if (marking.type === (0, $keHtM.MarkingType).GREY) {
        style.strokeStyle = "grey";
        style.fillStyle = "grey";
        style.lineWidth = readOnly ? 2 : 2;
    } else if (marking.type === (0, $keHtM.MarkingType).WHITE_SOLID) {
        style.strokeStyle = "#FCFAFF";
        style.fillStyle = "#FCFAFF";
        style.lineWidth = readOnly ? 2 : 2;
    } else if (marking.type === (0, $keHtM.MarkingType).WHITE_DASHED) {
        style.strokeStyle = "#FCFAFF";
        style.fillStyle = "#FCFAFF";
        style.lineWidth = readOnly ? 2 : 2;
        ctx.setLineDash([
            10
        ]);
    } else if (marking.type === (0, $keHtM.MarkingType).YELLOW_SOLID) {
        style.strokeStyle = "#eed202";
        style.fillStyle = "#eed202";
        style.lineWidth = readOnly ? 2 : 2;
    } else if (marking.type === (0, $keHtM.MarkingType).YELLOW_SOLID_CURVED) {
        style.strokeStyle = "#eed202";
        style.fillStyle = "#eed202";
        style.lineWidth = readOnly ? 2 : 2;
        style.lineCap = "round";
    } else if (marking.type === (0, $keHtM.MarkingType).YELLOW_DASHED) {
        style.strokeStyle = "#eed202";
        style.fillStyle = "#eed202";
        style.lineWidth = readOnly ? 2 : 2;
        ctx.setLineDash([
            10
        ]);
    } else if (marking.type === (0, $keHtM.MarkingType).REFERENCE_DISTANCE) {
        style.strokeStyle = "#e3c783";
        style.fillStyle = "#e3c783";
        style.lineWidth = readOnly ? 2 : 2;
    } else {
        ctx.restore();
        return;
    }
    ctx.fillStyle = marking.selected ? "hotpink" : style.fillStyle;
    ctx.strokeStyle = marking.selected ? "hotpink" : style.strokeStyle;
    ctx.lineWidth = style.lineWidth;
    const points = marking?.geom.coordinates.flat() ?? [];
    $74c00e9918f0aa36$export$4499223ad823a374(ctx, points, style, feetToPixels, marking.type === (0, $keHtM.MarkingType).OUTLINE, readOnly);
    ctx.stroke();
    if (marking.type === (0, $keHtM.MarkingType).OUTLINE) {
        ctx.beginPath();
        $74c00e9918f0aa36$export$4499223ad823a374(ctx, points, style, feetToPixels, true, readOnly);
        ctx.fillStyle = styleOverrides.fillStyle ?? "#D3D3D360";
        ctx.fill();
    }
    ctx.restore();
};
const $74c00e9918f0aa36$export$132875b24523ef2b = ({ width: width, ramp: ramp, backgroundColor: backgroundColor, showReferenceImage: showReferenceImage = false })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const pixelsToFeetRatio = (ramp?.width ?? 1) / width;
    const canvasWidth = width;
    const canvasHeight = canvasWidth * ramp?.depth / ramp?.width;
    const feetToPixels = (feet)=>feet / pixelsToFeetRatio;
    const rampImage = (0, $2NPdf.default)(async ()=>{
        if (ramp.id && showReferenceImage) {
            const { data: data } = await postgrest.from("ramp").select("reference_image").eq("id", ramp.id).single();
            return data.reference_image;
        }
        return null;
    }, [
        showReferenceImage,
        ramp.reference_image
    ]);
    const draw = $acw62.useCallback((ctx)=>{
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
        // draw stuff!
        if (ramp?.outline) $74c00e9918f0aa36$export$e449647777f39c4d(ctx, {
            id: (0, $5sKyw.default)(),
            ramp_id: ramp.id,
            type: (0, $keHtM.MarkingType).OUTLINE,
            geom: ramp.outline
        }, feetToPixels, true, {
            fillStyle: backgroundColor
        });
        for (const marking of ramp.markings)$74c00e9918f0aa36$export$e449647777f39c4d(ctx, marking, feetToPixels, true);
    }, [
        ramp,
        width
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            cursor: "inherit",
            position: "relative",
            backgroundColor: "transparent",
            display: "inline-block"
        },
        children: [
            showReferenceImage && rampImage?.value && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: rampImage.value,
                alt: "Ramp reference background",
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: canvasWidth,
                    height: canvasHeight,
                    objectFit: "cover",
                    zIndex: 0,
                    pointerEvents: "none" // Prevent interference with canvas interactions
                },
                onLoad: ()=>console.log("Legacy ramp background image loaded successfully"),
                onError: (e)=>console.error("Failed to load legacy ramp background image:", e)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ga8GY.default), {
                ref: canvasRef,
                width: canvasWidth,
                height: canvasHeight,
                draw: draw,
                style: {
                    position: "relative",
                    zIndex: 1,
                    backgroundColor: showReferenceImage ? "transparent" : undefined
                }
            })
        ]
    });
};

});

parcelRegister("ckvc5", function(module, exports) {

$parcel$export(module.exports, "HangarLayoutBackground", () => $41dfa4811ace983d$export$284f3dd9eea6ece0);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $kfxZt = parcelRequire("kfxZt");

var $ga8GY = parcelRequire("ga8GY");
const $41dfa4811ace983d$export$284f3dd9eea6ece0 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { width: width, height: height, hangar: hangar, feetToPixels: feetToPixels, preferences: preferences, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onContextMenu: onContextMenu, ...otherProps } = props;
    const theme = (0, $14H9o.default)();
    const isDarkMode = theme.palette.mode === 'dark';
    const gridSize = (width > 600 ? 10 : 10) * feetToPixels;
    const dashLength = gridSize / 10;
    const dashWidth = dashLength / 4;
    const backgroundColor = otherProps.backgroundColor ?? (isDarkMode ? theme.palette.background.default : "#c8cfde");
    const borderColor = otherProps.borderColor ?? (isDarkMode ? theme.palette.divider : "#7a94bb");
    const dashColor = otherProps.dashColor ?? (isDarkMode ? "#5a6775" : "#7a94bb");
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const draw = $acw62.useCallback((ctx)=>{
        // Clear the canvas (accounting for the 0.5 pixel translation)
        ctx.clearRect(-1, -1, width + 2, height + 2);
        (0, $kfxZt.drawSpacingBuffers)(ctx, hangar, (x)=>x * feetToPixels, {
            lineWidth: width > 600 ? 1.5 : 1,
            lineDash: width > 600 ? null : [
                dashLength * 2,
                dashLength * 2
            ],
            showWallSpacingFill: preferences?.showWallSpacingFill ?? false
        });
        // Draw bay boundaries if enabled
        if (preferences?.showBayBoundaries && hangar.bays?.length > 0) (0, $kfxZt.drawBayBoundaries)(ctx, hangar.bays, hangar, (x)=>x * feetToPixels);
        // Draw hangar name watermark in the center
        if (hangar.name) {
            ctx.save();
            // Calculate responsive font size based on canvas dimensions
            const minDimension = Math.min(width, height);
            let fontSize = Math.min(40, minDimension * 0.16);
            fontSize = Math.max(16, fontSize); // Ensure minimum readability
            ctx.font = `${fontSize}px "Lexend Deca", sans-serif`;
            // Measure text and scale down if it's too wide
            const textMetrics = ctx.measureText(hangar.name);
            const maxWidth = width * 0.8; // Use 80% of width
            if (textMetrics.width > maxWidth) {
                fontSize = fontSize * (maxWidth / textMetrics.width);
                ctx.font = `${fontSize}px "Lexend Deca", sans-serif`;
            }
            ctx.fillStyle = isDarkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgba(51, 51, 51, 0.25)';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(hangar.name, width / 2, height / 2);
            ctx.restore();
        }
    }, [
        hangar,
        height,
        preferences?.showWallSpacingFill,
        preferences?.showBayBoundaries,
        width,
        feetToPixels,
        dashLength,
        isDarkMode
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        ref: ref,
        sx: {
            position: "relative",
            m: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                "data-id": "hangar-layout-background",
                onClick: onClick,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onMouseMove: onMouseMove,
                onMouseEnter: onMouseEnter,
                onContextMenu: onContextMenu,
                sx: {
                    position: "absolute",
                    // need to account for border here
                    width: width,
                    height: height
                },
                children: props.children
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ga8GY.default), {
                ref: canvasRef,
                width: width,
                height: height,
                draw: draw,
                style: {
                    outline: `2px solid ${borderColor}`,
                    backgroundColor: backgroundColor,
                    backgroundSize: `${dashLength * 2}px ${dashLength * 2}px, ${gridSize}px ${gridSize}px`,
                    backgroundPosition: `${-dashWidth / 2}px ${-dashWidth / 2}px`,
                    backgroundImage: `linear-gradient(to bottom, transparent ${dashLength}px, ${backgroundColor} ${dashLength}px),
                linear-gradient(to right, ${dashColor}50 ${dashLength * 3 / 5}px, transparent ${dashLength * 3 / 5}px),
                linear-gradient(to right, transparent ${dashLength}px, ${backgroundColor} ${dashLength}px),
                linear-gradient(to bottom, ${dashColor}50 ${dashLength * 3 / 5}px, transparent ${dashLength * 3 / 5}px)
              `
                }
            })
        ]
    });
});

});


parcelRegister("gkftL", function(module, exports) {

$parcel$export(module.exports, "Door", () => $ae6b451ffd57ce2a$export$602193f4ae91c7b9);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
const $ae6b451ffd57ce2a$export$602193f4ae91c7b9 = ({ type: type = "hangar", offset: offset = 0, feetToPixels: feetToPixels, position: position, width: width })=>{
    if (type === "garage") {
        if (position === "back") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
            "data-type": "garage_door",
            sx: {
                position: "absolute",
                top: 0,
                left: feetToPixels * offset,
                width: feetToPixels * width,
                height: feetToPixels * 2,
                backgroundColor: "#FFAC1C80"
            }
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
            "data-type": "garage_door",
            sx: {
                position: "absolute",
                top: feetToPixels * offset,
                height: feetToPixels * width,
                left: position === "left" && 0,
                right: position === "right" && 0,
                width: feetToPixels * 2,
                backgroundColor: "#FFAC1C80"
            }
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        "data-type": "garage_door",
        sx: {
            position: "absolute",
            bottom: 0,
            left: position === "left" && 0,
            right: position === "right" && 0,
            width: feetToPixels * width,
            height: feetToPixels * 2,
            backgroundColor: "info.dark"
        }
    });
};

});

parcelRegister("15URU", function(module, exports) {

$parcel$export(module.exports, "GhostAircraft", () => $f37e53af2de554d7$export$13bdf67a75ef39ed);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");

var $kPMZ3 = parcelRequire("kPMZ3");

var $dn13k = parcelRequire("dn13k");

var $4okQ5 = parcelRequire("4okQ5");

var $7p8YN = parcelRequire("7p8YN");
const $f37e53af2de554d7$export$13bdf67a75ef39ed = ({ location: location, stack: stack, polygons: polygons, autocompleteResults: autocompleteResults, feetToPixels: feetToPixels, mouseOverIndex: mouseOverIndex, height: height })=>{
    const { isMultiHangar: isMultiHangar, hangars: hangars } = (0, $7p8YN.useMultiHangarState)();
    const isInAnyLayout = (0, $4okQ5.useIsInAnyLayout)({
        feetToPixels: feetToPixels
    }, []);
    // Find selected tenant from the stack prop (which is the correct stack for this view)
    const selectedTenant = stack.tenants.find((t)=>t.selected) || hangars.find((h)=>h.stack.tenants.find((t)=>t.selected))?.stack.tenants.find((t)=>t.selected);
    const { tenant: tenantBeingAutocompleted } = autocompleteResults;
    const selected = Boolean(stack.tenants.find((t)=>t.selected) || hangars.find((h)=>h.stack.tenants.find((t)=>t.selected)));
    if (!selected) return null;
    if (!tenantBeingAutocompleted) return null;
    if (selectedTenant?.id !== tenantBeingAutocompleted.id) return null;
    // Check if tenant is fully in the location (only for hangars)
    if (location.type === "hangar") {
        // Create a hangar-like object with the current stack and location dimensions
        const hangarForCheck = {
            ...location,
            stack: stack
        };
        if ((0, $kPMZ3.findTenantsFullyInHangar)(hangarForCheck, polygons).find((t)=>t.id === tenantBeingAutocompleted.id)) return null;
    }
    if (isMultiHangar && isInAnyLayout(tenantBeingAutocompleted)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: autocompleteResults.suggestedPositions.filter((x)=>x)?.map((suggestedPosition, idx)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    opacity: idx === mouseOverIndex ? 0.9 : 0.4,
                    filter: idx === mouseOverIndex ? "brightness(0.3)" : "brightness(1)"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dn13k.FullyLoadedDraggableAircraft), {
                    readOnly: true,
                    layoutHeight: height,
                    feetToPixels: feetToPixels,
                    tenant: {
                        ...tenantBeingAutocompleted,
                        id: suggestedPosition.id,
                        selected: false,
                        position: {
                            ...tenantBeingAutocompleted.position,
                            ...suggestedPosition
                        }
                    },
                    stack: stack,
                    setStack: ()=>{},
                    preferences: [],
                    onPositionChange: ()=>{},
                    rightClick: null,
                    setRightClick: ()=>{},
                    spacingBufferOverlayElement: null
                })
            }, `suggested-position-aircraft-${stack.id}-${suggestedPosition.id}`);
        })
    }, `suggested-aircraft-${stack.id}-${tenantBeingAutocompleted?.entity_id}`);
};

});

parcelRegister("hEqwk", function(module, exports) {

$parcel$export(module.exports, "Obstacle", () => $4670d01158095eea$export$83b45c7b75260f83);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
parcelRequire("acw62");

var $keHtM = parcelRequire("keHtM");
const $4670d01158095eea$export$4ed541c92de44a42 = {
    [(0, $keHtM.ObstacleType).OBSTRUCTION]: {
        backgroundColor: "#d7d7d7"
    },
    [(0, $keHtM.ObstacleType).NO_TOW_AREA]: {
        backgroundColor: "transparent",
        outlineColor: "red",
        outlineWidth: "2px",
        outlineStyle: "dashed"
    },
    [(0, $keHtM.ObstacleType).UNOBSTRUCTIVE]: {
        backgroundColor: "#3c6ce990"
    },
    [(0, $keHtM.ObstacleType).CAUTION]: {
        backgroundColor: "#ECE81A90"
    }
};
const $4670d01158095eea$export$83b45c7b75260f83 = ({ feetToPixels: feetToPixels, x: x, y: y, type: type, width: width, depth: depth })=>{
    // if it's a NO_TOW_AREA and it's touching a wall, we don't render it
    if (type === (0, $keHtM.ObstacleType).NO_TOW_AREA) {
        const isTouchingWall = x <= 0 && y <= 0 || // Top-left corner
        x + width >= 1 && y <= 0 || // Top-right corner
        x <= 0 && y + depth >= 1 || // Bottom-left corner
        x + width >= 1 && y + depth >= 1; // Bottom-right corner
        if (isTouchingWall) return null;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        "data-type": `obstacle-${type}`,
        sx: {
            zIndex: type === (0, $keHtM.ObstacleType).OBSTRUCTION ? 2 : 1,
            position: "absolute",
            top: `${feetToPixels * y}px`,
            left: `${feetToPixels * x}px`,
            width: `${feetToPixels * width}px`,
            height: `${feetToPixels * depth}px`,
            ...$4670d01158095eea$export$4ed541c92de44a42[type]
        }
    });
};

});



parcelRegister("6qWGE", function(module, exports) {
$parcel$export(module.exports, "LayoutToolbar", () => (parcelRequire("c0zpU")).LayoutToolbar);
parcelRequire("c0zpU");

});
parcelRegister("c0zpU", function(module, exports) {

$parcel$export(module.exports, "LayoutToolbar", () => $a8bf3c708d939f09$export$17f786cd5a0797c);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $7JB23 = parcelRequire("7JB23");

var $acw62 = parcelRequire("acw62");

var $Aoavo = parcelRequire("Aoavo");

var $fu9Og = parcelRequire("fu9Og");

var $2LXej = parcelRequire("2LXej");

var $89b86 = parcelRequire("89b86");

var $5Bqq3 = parcelRequire("5Bqq3");

var $7p8YN = parcelRequire("7p8YN");

var $6fDLr = parcelRequire("6fDLr");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");

var $5U03M = parcelRequire("5U03M");

var $3JLDK = parcelRequire("3JLDK");

var $iEhC9 = parcelRequire("iEhC9");

var $lNEp2 = parcelRequire("lNEp2");

var $1NUjF = parcelRequire("1NUjF");

var $7R9OT = parcelRequire("7R9OT");

var $dlEXA = parcelRequire("dlEXA");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");

var $btULL = parcelRequire("btULL");
parcelRequire("79mJW");
var $c9nMz = parcelRequire("c9nMz");
parcelRequire("iM6w0");
var $cuIiG = parcelRequire("cuIiG");

var $amnUw = parcelRequire("amnUw");

var $8vQkJ = parcelRequire("8vQkJ");
const $a8bf3c708d939f09$export$17f786cd5a0797c = ({ location: location, setLocation: setLocation, stack: stack, setStack: setStack, setStacks: setStacks, onClickUndo: onClickUndo, renderOnPrint: renderOnPrint, isScheduledView: isScheduledView = false, scheduledViewProps: scheduledViewProps })=>{
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [fireFoxError, setShowFireFoxError] = $acw62.useState(false);
    const [copyError, setCopyError] = $acw62.useState(false);
    const [copyErrorMessage, setCopyErrorMessage] = $acw62.useState("Failed to copy the image to clipboard. The image may be too large or there might be an issue with background images.");
    const [confirm, setConfirm] = $acw62.useState({
        open: false,
        text: "",
        okText: "",
        onOk: ()=>{},
        renderSecondaryAction: false
    });
    const measuringToolState = (0, $5Bqq3.useMeasuringToolState)();
    const theme = (0, $14H9o.default)();
    const [idsToPrint, setIdsToPrint] = $acw62.useState([]);
    const { isMultiHangar: isMultiHangar, hangarIds: hangarIds, hangars: hangars, setHangars: setHangars } = (0, $7p8YN.useMultiHangarState)();
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const [showMultiHangarPrint, setShowMultiHangarPrint] = $acw62.useState(false);
    const [showMultiHangarCopy, setShowMultiHangarCopy] = $acw62.useState(false);
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { setShow: setShowLoadingProgress } = (0, $89b86.useLoadingProgress)();
    const [print, setPrint] = $acw62.useState(false);
    const [copy, setCopy] = $acw62.useState(false);
    const [isPreparingCopy, setIsPreparingCopy] = $acw62.useState(false);
    const [, setCopySuccess] = $acw62.useState(false);
    const componentRef = $acw62.useRef(null);
    const copyRef = $acw62.useRef(null);
    const handlePrint = (0, $Aoavo.useReactToPrint)({
        contentRef: componentRef
    });
    $acw62.useEffect(()=>{
        // on mount clear out any existing measuring tool state
        measuringToolState.setActive(false);
    }, []);
    // Determine disabled actions based on permissions
    const disabled = [];
    if (!hasPermission((0, $aHqXU.Permission).USE_FAVORITES)) disabled.push("favorites");
    // View-only mode is automatically enforced in hasPermission for write operations
    if (!hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT)) {
        disabled.push("favorites");
        disabled.push("clear");
        disabled.push("undo");
    }
    // Handle location update (for tug selection changes)
    const handleLocationUpdate = $acw62.useCallback(async ()=>{
        try {
            const tableName = location.type === "hangar" ? "hangar" : "ramp";
            const { data: data, error: error } = await postgrest.from(tableName).select("*").eq("id", location.id).single();
            if (error) throw error;
            if (data) setLocation({
                ...location,
                ...data
            });
        } catch (error) {
            console.error("Failed to refresh location:", error);
        }
    }, [
        location,
        postgrest,
        setLocation
    ]);
    // Share URL functionality
    const handleCopyUrl = async ()=>{
        try {
            const shareableUrl = (0, $dlEXA.createShareableScheduleUrl)(new Date());
            await navigator.clipboard.writeText(shareableUrl);
            setCopySuccess(true);
            setTimeout(()=>setCopySuccess(false), 2000); // Reset after 2 seconds
            snackbar.notify({
                text: "URL copied to clipboard",
                severity: "success"
            });
        } catch (error) {
            console.error("Failed to copy URL:", error);
            // Fallback for older browsers
            try {
                const textArea = document.createElement("textarea");
                textArea.value = (0, $dlEXA.createShareableScheduleUrl)(new Date());
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                setCopySuccess(true);
                setTimeout(()=>setCopySuccess(false), 2000);
                snackbar.notify({
                    text: "URL copied to clipboard",
                    severity: "success"
                });
            } catch (fallbackError) {
                console.error("Fallback copy also failed:", fallbackError);
                snackbar.notify({
                    text: "Failed to copy URL",
                    severity: "error"
                });
            }
        }
    };
    // Enhanced helper function to preload both background images and regular IMG elements
    const preloadBackgroundImages = async (element)=>{
        try {
            // Find all elements with background images
            const elementsWithBackgrounds = Array.from(element.querySelectorAll("*")).filter((el)=>{
                const style = window.getComputedStyle(el);
                return style.backgroundImage && style.backgroundImage !== "none";
            });
            // Add the element itself if it has a background
            const style = window.getComputedStyle(element);
            if (style.backgroundImage && style.backgroundImage !== "none") elementsWithBackgrounds.push(element);
            // Find all img elements too
            const imgElements = Array.from(element.querySelectorAll("img"));
            const totalImages = elementsWithBackgrounds.length + imgElements.length;
            if (totalImages === 0) return Promise.resolve();
            // Create promises for each background image
            const backgroundPromises = elementsWithBackgrounds.map((el, index)=>{
                return new Promise((resolve)=>{
                    const style = window.getComputedStyle(el);
                    const bgImage = style.backgroundImage;
                    // Skip CSS gradients and other non-URL background values
                    if (!bgImage || bgImage === "none" || bgImage.includes("gradient") || !bgImage.includes("url(")) {
                        resolve();
                        return;
                    }
                    // Extract URL from url(...) syntax
                    const bgUrl = bgImage.replace(/url\(['"]?(.*?)['"]?\)/g, "$1");
                    if (!bgUrl || bgUrl === "none") {
                        resolve();
                        return;
                    }
                    // Retry mechanism for failed loads
                    const tryLoadImage = (attempt)=>{
                        const img = new Image();
                        img.onload = ()=>{
                            resolve();
                        };
                        img.onerror = ()=>{
                            if (attempt < 3) setTimeout(()=>tryLoadImage(attempt + 1), 1000);
                            else {
                                console.error(`Background image ${index + 1} failed after 3 attempts: ${bgUrl}`);
                                resolve(); // Resolve anyway to continue the process
                            }
                        };
                        // Add a cache-busting parameter to force reload
                        img.src = bgUrl.includes("?") ? `${bgUrl}&_t=${Date.now()}&attempt=${attempt}` : `${bgUrl}?_t=${Date.now()}&attempt=${attempt}`;
                        // Set a timeout to resolve anyway after 10 seconds per attempt
                        setTimeout(()=>{
                            if (attempt >= 3) resolve();
                        }, 10000);
                    };
                    tryLoadImage(1);
                });
            });
            // Create promises for each img element
            const imgPromises = imgElements.map((img, index)=>{
                return new Promise((resolve)=>{
                    if (img.complete && img.naturalWidth > 0) {
                        resolve();
                        return;
                    }
                    const onLoad = ()=>{
                        img.removeEventListener("load", onLoad);
                        img.removeEventListener("error", onError);
                        resolve();
                    };
                    const onError = (e)=>{
                        console.error(`IMG element ${index + 1} failed to load:`, e);
                        img.removeEventListener("load", onLoad);
                        img.removeEventListener("error", onError);
                        resolve(); // Resolve anyway to continue
                    };
                    img.addEventListener("load", onLoad);
                    img.addEventListener("error", onError);
                    // Set a timeout to resolve anyway after 15 seconds
                    setTimeout(()=>{
                        img.removeEventListener("load", onLoad);
                        img.removeEventListener("error", onError);
                        resolve();
                    }, 15000);
                });
            });
            // Wait for all images to load or timeout
            await Promise.all([
                ...backgroundPromises,
                ...imgPromises
            ]);
        } catch (error) {
            console.error("Error in preloadBackgroundImages:", error);
        // Don't throw - we want the copy process to continue even if preloading fails
        }
    };
    const infoDrawerWidth = isDrawerOpen ? (0, $iEhC9.INFO_AND_CURRENT_AIRCRAFT_WIDTH) : 125;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        sx: {
            pt: 1,
            pl: 1,
            maxWidth: `calc(100vw - ${(0, $btULL.DRAWER_WIDTH)}px - ${infoDrawerWidth}px - 2px - 8px)`,
            zIndex: theme.zIndex.modal - 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vQkJ.ViewSettings), {
                locationType: location.type,
                isScheduledView: isScheduledView,
                location: location,
                onLocationUpdate: handleLocationUpdate
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                children: [
                    !isMultiHangar && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Measuring Tool",
                        placement: "left",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            disabled: disabled.includes("measuring"),
                            color: measuringToolState.active ? "success" : "info",
                            variant: "contained",
                            onClick: ()=>{
                                measuringToolState.setActive(!measuringToolState.active);
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                                name: "StraightenIcon"
                            })
                        })
                    }),
                    stack.name !== "reference" && !isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cuIiG.FavoritesButton), {
                        disabled: disabled.includes("favorites"),
                        location: location,
                        setLocation: setLocation,
                        stacks: location.stacks.filter((s)=>Boolean(s?.name) && [
                                "current",
                                "reference"
                            ].indexOf(s.name || "") === -1)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9nMz.SplitButton), {
                        disabled: disabled.includes("clear"),
                        color: "info",
                        options: [
                            // Only show Clear option when not in scheduled view
                            ...isScheduledView ? [] : [
                                {
                                    label: "Clear",
                                    disabled: false,
                                    onClick: ()=>{
                                        setStacks([]);
                                        const text = isMultiHangar ? `This will remove all aircraft listed in the selected hangars.` : isScheduledView ? `\u{2622}\u{FE0F} NUCLEAR OPTION: This will unassign ALL aircraft from this ${location.type} from the current time through the end of their trips. This cannot be undone easily. Are you sure?` : `This will remove all aircraft listed in this ${location.type}.`;
                                        const onOk = isMultiHangar ? (ids)=>{
                                            if (!ids) return;
                                            setHangars(hangars.map((h)=>ids.includes(h.id) ? {
                                                    ...h,
                                                    stack: {
                                                        ...h.stack,
                                                        tenants: [],
                                                        movableObstacles: []
                                                    }
                                                } : h));
                                        } : async ()=>{
                                            setStacks([]);
                                            if (isScheduledView && scheduledViewProps) {
                                                // Nuclear option for scheduled views - clear all trips from current time forward
                                                const { tenantTripMap: tenantTripMap, currentTime: currentTime, onScheduledUpdate: onScheduledUpdate } = scheduledViewProps;
                                                try {
                                                    for (const tenant of stack.tenants){
                                                        const tripId = tenantTripMap.get(tenant.id);
                                                        if (tripId) {
                                                            // Use stored procedure to unassign trip from current time forward
                                                            const { error: error } = await postgrest.rpc("assign_trip_to_location", {
                                                                p_trip_id: tripId,
                                                                p_location_id: null,
                                                                // Unassigned
                                                                p_location_type: null,
                                                                // Unassigned
                                                                p_start_time: currentTime.toISOString(),
                                                                p_end_time: null // Through end of trip
                                                            });
                                                            if (error) console.error(`Failed to unassign trip ${tripId}:`, error);
                                                        }
                                                    }
                                                    // Trigger refresh to show cleared placements
                                                    onScheduledUpdate();
                                                } catch (error) {
                                                    console.error("Failed to clear scheduled placements:", error);
                                                }
                                            } else // Original logic for current views
                                            setStack({
                                                ...stack,
                                                tenants: [],
                                                movableObstacles: []
                                            });
                                        };
                                        setConfirm({
                                            open: true,
                                            text: text,
                                            okText: isScheduledView ? "Yes, clear all trips (NUCLEAR)" : "Yes, remove all aircraft",
                                            onOk: onOk,
                                            okButtonColor: isScheduledView ? "error" : "success"
                                        });
                                    }
                                }
                            ],
                            {
                                label: "Dump",
                                disabled: false,
                                onClick: ()=>{
                                    const text = isMultiHangar ? `This will dump all aircraft from the selected hangars.` : isScheduledView ? `This will remove all aircraft from this ${location.type} for their entire trip duration.` : `This will dump all aircraft to the front.`;
                                    const okText = isMultiHangar ? "Yes, dump hangars" : isScheduledView ? `Yes, remove from ${location.type}` : "Yes, dump hangar";
                                    const onOk = isMultiHangar ? (ids, dumpTo)=>{
                                        if (!ids) return;
                                        setStacks([]);
                                        if (dumpTo === "HOLDING_AREA") {
                                            const holdingAreaHangar = hangars.find((h)=>h.id === (0, $5U03M.HOLDING_AREA_ID));
                                            const tenantsForHoldingArea = hangars.filter((h)=>ids.includes(h.id)).map((h)=>h.stack.tenants).flat().map((t)=>({
                                                    ...t,
                                                    position: {
                                                        ...t.position,
                                                        stack_id: holdingAreaHangar?.stack.id,
                                                        x: null,
                                                        y: null,
                                                        angle: null
                                                    }
                                                }));
                                            setHangars(hangars.map((h)=>ids.includes(h.id) ? {
                                                    ...h,
                                                    stack: {
                                                        ...h.stack,
                                                        tenants: []
                                                    }
                                                } : h).map((h)=>h.id === (0, $5U03M.HOLDING_AREA_ID) ? {
                                                    ...h,
                                                    stack: {
                                                        ...h.stack,
                                                        tenants: [
                                                            ...h.stack.tenants,
                                                            ...tenantsForHoldingArea
                                                        ]
                                                    }
                                                } : h));
                                            return;
                                        }
                                        setHangars(hangars.map((h)=>ids.includes(h.id) ? {
                                                ...h,
                                                stack: {
                                                    ...h.stack,
                                                    tenants: h.stack.tenants.map((t)=>({
                                                            ...t,
                                                            position: {
                                                                ...t.position,
                                                                x: null,
                                                                y: null,
                                                                angle: null
                                                            }
                                                        }))
                                                }
                                            } : h));
                                    } : async ()=>{
                                        setStacks([]);
                                        if (isScheduledView && scheduledViewProps) {
                                            // Simplified logic for scheduled views - just clear positions for current aircraft
                                            const { placementService: placementService, onScheduledUpdate: onScheduledUpdate, tenantTripMap: tenantTripMap, currentTime: currentTime } = scheduledViewProps;
                                            setShowLoadingProgress(true);
                                            try {
                                                // Get all tenants and their trip IDs
                                                for (const tenant of stack.tenants){
                                                    const tripId = tenantTripMap.get(tenant.id);
                                                    if (!tripId) {
                                                        console.warn(`No trip ID found for tenant ${tenant.id}`);
                                                        continue;
                                                    }
                                                    // Determine location type and ID from the current tenant position
                                                    let locationId = null;
                                                    let locationType = null;
                                                    if (location.type === "hangar") {
                                                        locationId = location.id;
                                                        locationType = "hangar";
                                                    } else if (location.type === "ramp") {
                                                        locationId = location.id;
                                                        locationType = "ramp";
                                                    }
                                                    // Clear the position using moveAircraftAtTime with null coordinates
                                                    await placementService.moveAircraftAtTime(tripId, locationId, locationType, currentTime, {
                                                        x: null,
                                                        y: null,
                                                        angle: null
                                                    });
                                                }
                                                // Trigger refresh to show updated placements
                                                onScheduledUpdate();
                                            } catch (error) {
                                                console.error("Failed to dump scheduled placements:", error);
                                            } finally{
                                                setShowLoadingProgress(false);
                                            }
                                        } else // Original logic for current views
                                        setStack({
                                            ...stack,
                                            tenants: stack.tenants.map((t)=>({
                                                    ...t,
                                                    position: {
                                                        ...t.position,
                                                        x: null,
                                                        y: null,
                                                        angle: null
                                                    }
                                                }))
                                        });
                                    };
                                    setConfirm({
                                        open: true,
                                        text: text,
                                        okText: okText,
                                        onOk: onOk,
                                        renderSecondaryAction: true
                                    });
                                }
                            },
                            // Hide "All Tenants" option in scheduled views since it doesn't apply to trip management
                            ...isScheduledView ? [] : [
                                {
                                    label: "All Tenants",
                                    disabled: stack.isReference,
                                    onClick: async ()=>{
                                        const text = isMultiHangar ? "This will reset the selected hangars to the all tenant hangar layout." : `This will reset to the all tenant ${location.type} layout.`;
                                        const onOk = isMultiHangar ? (ids)=>{
                                            setStacks([]);
                                            const resetHangarToReference = (h)=>{
                                                const referenceStack = h.stacks.find((s)=>s?.name === "reference");
                                                return {
                                                    ...h,
                                                    stack: {
                                                        ...h.stack,
                                                        tenants: [
                                                            ...referenceStack.tenants
                                                        ].map((t)=>({
                                                                ...t,
                                                                position: {
                                                                    ...t.position,
                                                                    id: (0, $lNEp2.uuidv4)(),
                                                                    stack_id: h.stack.id,
                                                                    entity_id: t.entity_id
                                                                }
                                                            })),
                                                        movableObstacles: [
                                                            ...referenceStack.movableObstacles
                                                        ].map((mo)=>({
                                                                ...mo,
                                                                position: {
                                                                    ...mo.position,
                                                                    id: (0, $lNEp2.uuidv4)(),
                                                                    stack_id: h.stack.id,
                                                                    entity_id: mo.entity_id
                                                                }
                                                            }))
                                                    }
                                                };
                                            };
                                            setHangars(hangars.map((h)=>ids.includes(h.id) ? resetHangarToReference(h) : h));
                                        } : ()=>{
                                            setStacks([]);
                                            const referenceStack = location.stacks.find((s)=>s?.name === "reference");
                                            setLocation({
                                                ...location,
                                                stack: {
                                                    ...location.stack,
                                                    tenants: [
                                                        ...referenceStack.tenants
                                                    ].map((t)=>({
                                                            ...t,
                                                            position: {
                                                                ...t.position,
                                                                id: (0, $lNEp2.uuidv4)(),
                                                                stack_id: location.stack.id,
                                                                entity_id: t.entity_id
                                                            }
                                                        })),
                                                    movableObstacles: [
                                                        ...referenceStack.movableObstacles
                                                    ].map((mo)=>({
                                                            ...mo,
                                                            position: {
                                                                ...mo.position,
                                                                id: (0, $lNEp2.uuidv4)(),
                                                                stack_id: location.stack.id,
                                                                entity_id: mo.entity_id
                                                            }
                                                        }))
                                                }
                                            });
                                        };
                                        setConfirm({
                                            open: true,
                                            text: text,
                                            okText: "Yes, reset",
                                            onOk: onOk,
                                            renderSecondaryAction: false
                                        });
                                    }
                                }
                            ]
                        ],
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "CleaningServicesIcon"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        disabled: disabled.includes("undo"),
                        variant: "contained",
                        color: "info",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "ReplayIcon"
                        }),
                        onClick: onClickUndo,
                        children: "Undo"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9nMz.SplitButton), {
                        disabled: disabled.includes("print"),
                        color: "info",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                            name: "PrintIcon"
                        }),
                        options: [
                            {
                                label: "Print",
                                disabled: false,
                                onClick: ()=>{
                                    // if user is on firefox, tell them they can't do this
                                    if (navigator.userAgent.toLowerCase().includes("firefox")) {
                                        setShowFireFoxError(true);
                                        return;
                                    }
                                    if (isMultiHangar) {
                                        setShowMultiHangarPrint(true);
                                        return;
                                    }
                                    setPrint(true);
                                    setTimeout(()=>{
                                        handlePrint();
                                        setPrint(false);
                                    }, 1000);
                                    (0, $7R9OT.default).track("Print", {
                                        location_name: location.name,
                                        location_type: location.type
                                    });
                                }
                            },
                            {
                                label: "Copy",
                                disabled: false,
                                onClick: ()=>{
                                    if (navigator.userAgent.toLowerCase().includes("firefox")) {
                                        setShowFireFoxError(true);
                                        return;
                                    }
                                    if (isMultiHangar) {
                                        setShowMultiHangarCopy(true);
                                        return;
                                    }
                                    (0, $7R9OT.default).track("Copy", {
                                        location_name: location.name,
                                        location_type: location.type
                                    });
                                    // Show loading state while preparing
                                    setIsPreparingCopy(true);
                                    setCopy(true);
                                    // Use setTimeout to allow the UI to update with increased timeout for complex layouts
                                    setTimeout(async ()=>{
                                        try {
                                            // First preload all background images to ensure they're loaded
                                            if (copyRef.current) {
                                                await preloadBackgroundImages(copyRef.current);
                                                // Additional wait for complex layouts to finish rendering
                                                await new Promise((resolve)=>setTimeout(resolve, 1000));
                                            }
                                            // html2canvas is statically imported at top of file for reliability
                                            // Enhanced html2canvas configuration for better handling of background images and canvas content
                                            const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(copyRef.current, {
                                                useCORS: true,
                                                allowTaint: true,
                                                backgroundColor: null,
                                                logging: true,
                                                // Enable logging for debugging
                                                imageTimeout: 15000,
                                                // Longer timeout for image loading
                                                scale: window.devicePixelRatio > 1 ? 1 : 2,
                                                // Use higher scale on low-DPI screens
                                                onclone: (clonedDoc)=>{
                                                    // Force any background images to load before capture
                                                    const images = clonedDoc.querySelectorAll("img");
                                                    // Force images to load
                                                    images.forEach((img)=>{
                                                        if (!img.complete) img.src = img.src; // Trigger reload
                                                    });
                                                    // Copy canvas content from original document to cloned document
                                                    const originalCanvases = copyRef.current.querySelectorAll("canvas");
                                                    const clonedCanvases = clonedDoc.querySelectorAll("canvas");
                                                    // Improved canvas copying with better error handling and verification
                                                    for(let i = 0; i < Math.min(originalCanvases.length, clonedCanvases.length); i++)try {
                                                        const originalCanvas = originalCanvases[i];
                                                        const clonedCanvas = clonedCanvases[i];
                                                        if (originalCanvas && clonedCanvas) {
                                                            // Verify canvas dimensions match
                                                            if (originalCanvas.width === 0 || originalCanvas.height === 0) continue;
                                                            // Set the cloned canvas dimensions to match original
                                                            clonedCanvas.width = originalCanvas.width;
                                                            clonedCanvas.height = originalCanvas.height;
                                                            // Get the context of the cloned canvas
                                                            const clonedContext = clonedCanvas.getContext("2d");
                                                            if (!clonedContext) {
                                                                console.error(`Could not get 2D context for cloned canvas ${i + 1}`);
                                                                continue;
                                                            }
                                                            // Copy all canvas properties
                                                            clonedContext.imageSmoothingEnabled = originalCanvas.getContext("2d")?.imageSmoothingEnabled ?? true;
                                                            clonedContext.imageSmoothingQuality = originalCanvas.getContext("2d")?.imageSmoothingQuality ?? "high";
                                                            // Draw the original canvas onto the cloned canvas with exact dimensions
                                                            clonedContext.drawImage(originalCanvas, 0, 0, originalCanvas.width, originalCanvas.height, 0, 0, clonedCanvas.width, clonedCanvas.height);
                                                        }
                                                    } catch (err) {
                                                        const error = err;
                                                        console.error(`Error copying canvas ${i + 1} content:`, error);
                                                    }
                                                    return clonedDoc;
                                                }
                                            });
                                            const hangarURL = window.location.href;
                                            // Use the updated copyImageAndUrlToClipboard function with error handling
                                            const success = await (0, $1NUjF.copyImageAndUrlToClipboard)(canvas, hangarURL, location.type);
                                            if (success) snackbar.notify({
                                                text: "Copied to clipboard",
                                                severity: "success"
                                            });
                                            else {
                                                const detailedError = `Copy failed for ${location.type} "${location.name}". Canvas size: ${canvas.width}x${canvas.height}. Check browser console for detailed logs.`;
                                                console.error(detailedError);
                                                setCopyErrorMessage(`Failed to copy ${location.type} to clipboard. The image may be too large for your device's memory or there was an issue with aircraft rendering. Try again or check the console for details.`);
                                                setCopyError(true);
                                            }
                                        } catch (err) {
                                            const errorDetails = {
                                                message: err.message || "Unknown error",
                                                stack: err.stack,
                                                locationName: location.name,
                                                locationType: location.type,
                                                tenantCount: stack?.tenants?.length || 0,
                                                timestamp: new Date().toISOString()
                                            };
                                            console.error("Error during copy operation:", errorDetails);
                                            setCopyErrorMessage(`Error copying ${location.type} "${location.name}" to clipboard: ${err.message || "Unknown error"}. ${stack?.tenants?.length || 0} aircraft were being copied. Check console for detailed error information.`);
                                            setCopyError(true);
                                        } finally{
                                            setCopy(false);
                                            setIsPreparingCopy(false);
                                        }
                                    }, 3000); // Increased timeout to allow complex layouts to fully render
                                }
                            },
                            {
                                label: "Share",
                                disabled: false,
                                onClick: ()=>{
                                    handleCopyUrl();
                                    (0, $7R9OT.default).track("Share", {
                                        location_name: location.name,
                                        location_type: location.type
                                    });
                                }
                            }
                        ]
                    })
                ]
            }),
            confirm?.open && !isMultiHangar && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Please Confirm",
                onCancel: ()=>setConfirm(null),
                onClose: ()=>setConfirm(null),
                ...confirm
            }),
            print && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    top: "100vh"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ref: componentRef,
                    style: {
                        display: "block",
                        padding: 15,
                        marginLeft: 50
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                                type: "text/css",
                                media: "print",
                                children: `@page { size: ${"portrait"}; }`
                            }),
                            renderOnPrint(idsToPrint)
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MV2p.default), {
                open: copy || isPreparingCopy,
                fullScreen: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {})
            }),
            copy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    // move this thing to Siberia
                    position: "absolute",
                    top: "200vh",
                    left: "200vw"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ref: copyRef,
                    style: {
                        position: "absolute",
                        bottom: 0,
                        right: "100%",
                        display: "block",
                        padding: 15,
                        marginLeft: 50
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "column",
                        justifyContent: "space-between",
                        children: renderOnPrint(idsToPrint)
                    })
                })
            }),
            showMultiHangarPrint && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amnUw.MultiHangarSelect), {
                title: "Print Hangars",
                caption: "Select the hangars you would like to print.",
                okText: "Print",
                hangars: hangars.filter((h)=>hangarIds.indexOf(h.id) > -1),
                onCancel: ()=>setShowMultiHangarPrint(false),
                onOk: (idsToPrint)=>{
                    setPrint(true);
                    setIdsToPrint(idsToPrint);
                    setTimeout(()=>{
                        handlePrint();
                        setPrint(false);
                        setShowMultiHangarPrint(false);
                    }, 1000);
                    (0, $7R9OT.default).track("Print", {
                        location_name: location.name,
                        location_type: location.type
                    });
                }
            }),
            showMultiHangarCopy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amnUw.MultiHangarSelect), {
                title: "Copy Hangars",
                caption: "Select the hangars you would like to copy.",
                okText: "Copy",
                hangars: hangars.filter((h)=>hangarIds.indexOf(h.id) > -1),
                onCancel: ()=>setShowMultiHangarCopy(false),
                onOk: (idsToPrint)=>{
                    // Show loading state while preparing
                    setIsPreparingCopy(true);
                    setCopy(true);
                    setIdsToPrint(idsToPrint);
                    // Increased timeout for multi-hangar layouts which are typically more complex
                    setTimeout(async ()=>{
                        try {
                            // First preload all background images to ensure they're loaded
                            if (copyRef.current) {
                                await preloadBackgroundImages(copyRef.current);
                                // Additional wait for complex multi-hangar layouts to finish rendering
                                await new Promise((resolve)=>setTimeout(resolve, 1000));
                            }
                            // html2canvas is statically imported at top of file for reliability
                            // Enhanced html2canvas configuration for better handling of background images and canvas content
                            const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(copyRef.current, {
                                useCORS: true,
                                allowTaint: true,
                                backgroundColor: null,
                                logging: true,
                                // Enable logging for debugging
                                imageTimeout: 15000,
                                // Longer timeout for image loading
                                scale: window.devicePixelRatio > 1 ? 1 : 2,
                                // Use higher scale on low-DPI screens
                                onclone: (clonedDoc)=>{
                                    // Force any background images to load before capture
                                    const images = clonedDoc.querySelectorAll("img");
                                    // Force images to load
                                    images.forEach((img)=>{
                                        if (!img.complete) img.src = img.src; // Trigger reload
                                    });
                                    // Copy canvas content from original document to cloned document
                                    const originalCanvases = copyRef.current.querySelectorAll("canvas");
                                    const clonedCanvases = clonedDoc.querySelectorAll("canvas");
                                    // Improved canvas copying with better error handling and verification
                                    for(let i = 0; i < Math.min(originalCanvases.length, clonedCanvases.length); i++)try {
                                        const originalCanvas = originalCanvases[i];
                                        const clonedCanvas = clonedCanvases[i];
                                        if (originalCanvas && clonedCanvas) {
                                            // Verify canvas dimensions match
                                            if (originalCanvas.width === 0 || originalCanvas.height === 0) continue;
                                            // Set the cloned canvas dimensions to match original
                                            clonedCanvas.width = originalCanvas.width;
                                            clonedCanvas.height = originalCanvas.height;
                                            // Get the context of the cloned canvas
                                            const clonedContext = clonedCanvas.getContext("2d");
                                            if (!clonedContext) {
                                                console.error(`Could not get 2D context for multi-hangar cloned canvas ${i + 1}`);
                                                continue;
                                            }
                                            // Copy all canvas properties
                                            clonedContext.imageSmoothingEnabled = originalCanvas.getContext("2d")?.imageSmoothingEnabled ?? true;
                                            clonedContext.imageSmoothingQuality = originalCanvas.getContext("2d")?.imageSmoothingQuality ?? "high";
                                            // Draw the original canvas onto the cloned canvas with exact dimensions
                                            clonedContext.drawImage(originalCanvas, 0, 0, originalCanvas.width, originalCanvas.height, 0, 0, clonedCanvas.width, clonedCanvas.height);
                                        }
                                    } catch (err) {
                                        console.error(`Error copying multi-hangar canvas ${i + 1} content:`, err);
                                    }
                                    return clonedDoc;
                                }
                            });
                            const hangarURL = window.location.href;
                            // Use the updated copyImageAndUrlToClipboard function with error handling
                            const success = await (0, $1NUjF.copyImageAndUrlToClipboard)(canvas, hangarURL, location.type);
                            if (success) snackbar.notify({
                                text: "Copied to clipboard",
                                severity: "success"
                            });
                            else {
                                const detailedError = `Multi-hangar copy failed. Canvas size: ${canvas.width}x${canvas.height}. Selected hangars: ${idsToPrint.length}. Check browser console for detailed logs.`;
                                console.error(detailedError);
                                setCopyErrorMessage(`Failed to copy multi-hangar layout to clipboard. The image may be too large for your device's memory or there was an issue with aircraft rendering. Selected ${idsToPrint.length} hangars. Try selecting fewer hangars or check the console for details.`);
                                setCopyError(true);
                            }
                        } catch (err) {
                            const errorDetails = {
                                message: err.message || "Unknown error",
                                stack: err.stack,
                                locationName: location.name,
                                locationType: location.type,
                                selectedHangars: idsToPrint?.length || 0,
                                hangarIds: idsToPrint,
                                timestamp: new Date().toISOString()
                            };
                            console.error("Error during multi-hangar copy operation:", errorDetails);
                            setCopyErrorMessage(`Error copying multi-hangar layout to clipboard: ${err.message || "Unknown error"}. Selected ${idsToPrint?.length || 0} hangars. Check console for detailed error information.`);
                            setCopyError(true);
                        } finally{
                            setCopy(false);
                            setIsPreparingCopy(false);
                            setShowMultiHangarCopy(false);
                        }
                    }, 3000); // Increased timeout for complex multi-hangar layouts
                    (0, $7R9OT.default).track("Copy", {
                        location_name: location.name,
                        location_type: location.type
                    });
                }
            }),
            confirm?.open && isMultiHangar && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amnUw.MultiHangarSelect), {
                title: "Please Confirm",
                caption: confirm.text,
                okText: confirm.okText,
                hangars: hangars.filter((h)=>hangarIds.indexOf(h.id) > -1),
                onCancel: ()=>setConfirm(null),
                renderSecondaryAction: confirm.renderSecondaryAction,
                onOk: (idsToPrint, dumpTo)=>{
                    confirm.onOk(idsToPrint, dumpTo);
                    setConfirm(null);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: fireFoxError,
                onClose: ()=>setShowFireFoxError(false),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Feature Not Supported"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: "This feature is not supported on Firefox. If you wish to use this feature, please use a different browser."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>setShowFireFoxError(false),
                            children: "OK"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: copyError,
                onClose: ()=>setCopyError(false),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Copy Failed"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: copyErrorMessage
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>setCopyError(false),
                            children: "OK"
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7JB23", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});

parcelRegister("Aoavo", function(module, exports) {

!function(e, t) {
    module.exports = t((parcelRequire("acw62")));
}("undefined" != typeof self ? self : module.exports, function(e) {
    return function() {
        "use strict";
        var t = {
            155: function(t) {
                t.exports = e;
            }
        }, o = {};
        function n(e) {
            var r = o[e];
            if (void 0 !== r) return r.exports;
            var s = o[e] = {
                exports: {}
            };
            return t[e](s, s.exports, n), s.exports;
        }
        n.d = function(e, t) {
            for(var o in t)n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
                enumerable: !0,
                get: t[o]
            });
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var r = {};
        n.r(r), n.d(r, {
            useReactToPrint: function() {
                return f;
            }
        });
        var s = n(155);
        function i({ level: e = "error", messages: t, suppressErrors: o = !1 }) {
            o || ("error" === e ? console.error(t) : "warning" === e ? console.warn(t) : console.debug(t));
        }
        function l(e, t) {
            if (t || !e) {
                const e = document.getElementById("printWindow");
                e && document.body.removeChild(e);
            }
        }
        function a(e) {
            return e instanceof Error ? e : new Error("Unknown Error");
        }
        function c(e, t) {
            const { documentTitle: o, onAfterPrint: n, onPrintError: r, preserveAfterPrint: s, print: c, suppressErrors: d } = t;
            setTimeout(()=>{
                var t, u;
                if (e.contentWindow) {
                    function p() {
                        null == n || n(), l(s);
                    }
                    if (e.contentWindow.focus(), c) c(e).then(p).catch((e)=>{
                        r ? r("print", a(e)) : i({
                            messages: [
                                "An error was thrown by the specified `print` function"
                            ],
                            suppressErrors: d
                        });
                    });
                    else {
                        if (e.contentWindow.print) {
                            const h = null !== (u = null === (t = e.contentDocument) || void 0 === t ? void 0 : t.title) && void 0 !== u ? u : "", f = e.ownerDocument.title;
                            o && (e.ownerDocument.title = o, e.contentDocument && (e.contentDocument.title = o)), e.contentWindow.print(), o && (e.ownerDocument.title = f, e.contentDocument && (e.contentDocument.title = h));
                        } else i({
                            messages: [
                                "Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."
                            ],
                            suppressErrors: d
                        });
                        [
                            /Android/i,
                            /webOS/i,
                            /iPhone/i,
                            /iPad/i,
                            /iPod/i,
                            /BlackBerry/i,
                            /Windows Phone/i
                        ].some((e)=>{
                            var t, o;
                            return (null !== (o = null !== (t = navigator.userAgent) && void 0 !== t ? t : navigator.vendor) && void 0 !== o ? o : "opera" in window && window.opera).match(e);
                        }) ? setTimeout(p, 500) : p();
                    }
                } else i({
                    messages: [
                        "Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/MatthewHerbst/react-to-print/issues/"
                    ],
                    suppressErrors: d
                });
            }, 500);
        }
        function d(e) {
            const t = [], o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, null);
            let n = o.nextNode();
            for(; n;)t.push(n), n = o.nextNode();
            return t;
        }
        function u(e, t, o) {
            const n = d(e), r = d(t);
            if (n.length === r.length) for(let e = 0; e < n.length; e++){
                const t = n[e], s = r[e], i = t.shadowRoot;
                if (null !== i) {
                    const e = s.attachShadow({
                        mode: i.mode
                    });
                    e.innerHTML = i.innerHTML, u(i, e, o);
                }
            }
            else i({
                messages: [
                    "When cloning shadow root content, source and target elements have different size. `onBeforePrint` likely resolved too early.",
                    e,
                    t
                ],
                suppressErrors: o
            });
        }
        const p = '\n    @page {\n        /* Remove browser default header (title) and footer (url) */\n        margin: 0;\n    }\n    @media print {\n        body {\n            /* Tell browsers to print background colors */\n            color-adjust: exact; /* Firefox. This is an older version of "print-color-adjust" */\n            print-color-adjust: exact; /* Firefox/Safari */\n            -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n        }\n    }\n';
        function h(e, t, o, n) {
            var r, s, l, d, h;
            const { contentNode: f, clonedContentNode: g, clonedImgNodes: m, clonedVideoNodes: b, numResourcesToLoad: y, originalCanvasNodes: v } = o, { bodyClass: w, fonts: E, ignoreGlobalStyles: A, pageStyle: T, nonce: S, suppressErrors: P, copyShadowRoots: k } = n;
            e.onload = null;
            const x = null !== (r = e.contentDocument) && void 0 !== r ? r : null === (s = e.contentWindow) || void 0 === s ? void 0 : s.document;
            if (x) {
                const o = x.body.appendChild(g);
                k && u(f, o, !!P), E && ((null === (l = e.contentDocument) || void 0 === l ? void 0 : l.fonts) && (null === (d = e.contentWindow) || void 0 === d ? void 0 : d.FontFace) ? E.forEach((o)=>{
                    const n = new FontFace(o.family, o.source, {
                        weight: o.weight,
                        style: o.style
                    });
                    e.contentDocument.fonts.add(n), n.loaded.then(()=>{
                        t(n);
                    }).catch((e)=>{
                        t(n, [
                            "Failed loading the font:",
                            n,
                            "Load error:",
                            a(e)
                        ]);
                    });
                }) : (E.forEach((e)=>{
                    t(e);
                }), i({
                    messages: [
                        '"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'
                    ],
                    suppressErrors: P
                })));
                const n = null != T ? T : p, r = x.createElement("style");
                S && (r.setAttribute("nonce", S), x.head.setAttribute("nonce", S)), r.appendChild(x.createTextNode(n)), x.head.appendChild(r), w && x.body.classList.add(...w.split(" "));
                const s = x.querySelectorAll("canvas");
                for(let e = 0; e < v.length; ++e){
                    const t = v[e], o = s[e];
                    if (void 0 === o) {
                        i({
                            messages: [
                                "A canvas element could not be copied for printing, has it loaded? `onBeforePrint` likely resolved too early.",
                                t
                            ],
                            suppressErrors: P
                        });
                        continue;
                    }
                    const n = o.getContext("2d");
                    n && n.drawImage(t, 0, 0);
                }
                for(let e = 0; e < m.length; e++){
                    const o = m[e], n = o.getAttribute("src");
                    if (n) {
                        const e = new Image;
                        e.onload = ()=>{
                            t(o);
                        }, e.onerror = (e, n, r, s, i)=>{
                            t(o, [
                                "Error loading <img>",
                                o,
                                "Error",
                                i
                            ]);
                        }, e.src = n;
                    } else t(o, [
                        'Found an <img> tag with an empty "src" attribute. This prevents pre-loading it.',
                        o
                    ]);
                }
                for(let e = 0; e < b.length; e++){
                    const o = b[e];
                    o.preload = "auto";
                    const n = o.getAttribute("poster");
                    if (n) {
                        const e = new Image;
                        e.onload = ()=>{
                            t(o);
                        }, e.onerror = (e, r, s, i, l)=>{
                            t(o, [
                                "Error loading video poster",
                                n,
                                "for video",
                                o,
                                "Error:",
                                l
                            ]);
                        }, e.src = n;
                    } else o.readyState >= 2 ? t(o) : o.src ? (o.onloadeddata = ()=>{
                        t(o);
                    }, o.onerror = (e, n, r, s, i)=>{
                        t(o, [
                            "Error loading video",
                            o,
                            "Error",
                            i
                        ]);
                    }, o.onstalled = ()=>{
                        t(o, [
                            "Loading video stalled, skipping",
                            o
                        ]);
                    }) : t(o, [
                        "Error loading video, `src` is empty",
                        o
                    ]);
                }
                const c = "select", y = f.querySelectorAll(c), C = x.querySelectorAll(c);
                for(let e = 0; e < y.length; e++)C[e].value = y[e].value;
                if (!A) {
                    const e = document.querySelectorAll("style, link[rel~='stylesheet'], link[as='style']");
                    for(let o = 0, n = e.length; o < n; ++o){
                        const n = e[o];
                        if ("style" === n.tagName.toLowerCase()) {
                            const e = x.createElement(n.tagName), t = n.sheet;
                            if (t) {
                                let r = "";
                                try {
                                    const e = t.cssRules.length;
                                    for(let o = 0; o < e; ++o)"string" == typeof t.cssRules[o].cssText && (r += `${t.cssRules[o].cssText}\r\n`);
                                } catch (e) {
                                    i({
                                        messages: [
                                            "A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/MatthewHerbst/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",
                                            n,
                                            `Original error: ${a(e).message}`
                                        ],
                                        level: "warning"
                                    });
                                }
                                e.setAttribute("id", `react-to-print-${o}`), S && e.setAttribute("nonce", S), e.appendChild(x.createTextNode(r)), x.head.appendChild(e);
                            }
                        } else if (n.getAttribute("href")) {
                            if (n.hasAttribute("disabled")) i({
                                messages: [
                                    "`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",
                                    n
                                ],
                                level: "warning"
                            }), t(n);
                            else {
                                const e = x.createElement(n.tagName);
                                for(let t = 0, o = n.attributes.length; t < o; ++t){
                                    const o = n.attributes[t];
                                    o && e.setAttribute(o.nodeName, null !== (h = o.nodeValue) && void 0 !== h ? h : "");
                                }
                                e.onload = ()=>{
                                    t(e);
                                }, e.onerror = (o, n, r, s, i)=>{
                                    t(e, [
                                        "Failed to load",
                                        e,
                                        "Error:",
                                        i
                                    ]);
                                }, S && e.setAttribute("nonce", S), x.head.appendChild(e);
                            }
                        } else i({
                            messages: [
                                "`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",
                                n
                            ],
                            level: "warning"
                        }), t(n);
                    }
                }
            }
            0 === y && c(e, n);
        }
        function f({ bodyClass: e, contentRef: t, copyShadowRoots: o, documentTitle: n, fonts: r, ignoreGlobalStyles: d, nonce: u, onAfterPrint: p, onBeforePrint: f, onPrintError: g, pageStyle: m, preserveAfterPrint: b, print: y, suppressErrors: v }) {
            return (0, s.useCallback)((s)=>{
                function w() {
                    const l = {
                        bodyClass: e,
                        contentRef: t,
                        copyShadowRoots: o,
                        documentTitle: n,
                        fonts: r,
                        ignoreGlobalStyles: d,
                        nonce: u,
                        onAfterPrint: p,
                        onBeforePrint: f,
                        onPrintError: g,
                        pageStyle: m,
                        preserveAfterPrint: b,
                        print: y,
                        suppressErrors: v
                    }, a = function() {
                        const e = document.createElement("iframe");
                        return e.width = `${document.documentElement.clientWidth}px`, e.height = `${document.documentElement.clientHeight}px`, e.style.position = "absolute", e.style.top = `-${document.documentElement.clientHeight + 100}px`, e.style.left = `-${document.documentElement.clientWidth + 100}px`, e.id = "printWindow", e.srcdoc = "<!DOCTYPE html>", e;
                    }(), w = function(e, t) {
                        const { contentRef: o, fonts: n, ignoreGlobalStyles: r, suppressErrors: s } = t, l = function({ contentRef: e, optionalContent: t, suppressErrors: o }) {
                            return t && "function" == typeof t ? (e && i({
                                level: "warning",
                                messages: [
                                    '"react-to-print" received a `contentRef` option and an optional-content param passed to its callback. The `contentRef` option will be ignored.'
                                ]
                            }), t()) : e ? e.current : void i({
                                messages: [
                                    '"react-to-print" did not receive a `contentRef` option or a optional-content param pass to its callback.'
                                ],
                                suppressErrors: o
                            });
                        }({
                            contentRef: o,
                            optionalContent: e,
                            suppressErrors: s
                        });
                        if (!l) return;
                        const a = l.cloneNode(!0), c = document.querySelectorAll("link[rel~='stylesheet'], link[as='style']"), d = a.querySelectorAll("img"), u = a.querySelectorAll("video"), p = n ? n.length : 0;
                        return {
                            contentNode: l,
                            clonedContentNode: a,
                            clonedImgNodes: d,
                            clonedVideoNodes: u,
                            numResourcesToLoad: (r ? 0 : c.length) + d.length + u.length + p,
                            originalCanvasNodes: l.querySelectorAll("canvas")
                        };
                    }(s, l);
                    if (!w) return void i({
                        messages: [
                            "There is nothing to print"
                        ],
                        suppressErrors: v
                    });
                    const E = function(e, t, o) {
                        const { suppressErrors: n } = e, r = [], s = [];
                        return function(l, a) {
                            r.includes(l) ? i({
                                level: "debug",
                                messages: [
                                    "Tried to mark a resource that has already been handled",
                                    l
                                ],
                                suppressErrors: n
                            }) : (a ? (i({
                                messages: [
                                    '"react-to-print" was unable to load a resource but will continue attempting to print the page',
                                    ...a
                                ],
                                suppressErrors: n
                            }), s.push(l)) : r.push(l), r.length + s.length === t && c(o, e));
                        };
                    }(l, w.numResourcesToLoad, a);
                    !function(e, t, o, n) {
                        e.onload = ()=>{
                            h(e, t, o, n);
                        }, document.body.appendChild(e);
                    }(a, E, w, l);
                }
                l(b, !0), f ? f().then(()=>{
                    w();
                }).catch((e)=>{
                    null == g || g("onBeforePrint", a(e));
                }) : w();
            }, [
                e,
                t,
                o,
                n,
                r,
                d,
                u,
                p,
                f,
                g,
                m,
                b,
                y,
                v
            ]);
        }
        return r;
    }();
});

});

parcelRegister("btULL", function(module, exports) {

$parcel$export(module.exports, "DRAWER_WIDTH", () => $a9b1f4db4dde82b8$export$6b8066407e4765b1);
$parcel$export(module.exports, "SideIconButton", () => $a9b1f4db4dde82b8$export$302a3bb906e220c5);
$parcel$export(module.exports, "SideDrawer", () => $a9b1f4db4dde82b8$export$7ecb9218e6b31c93);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $2Ed4H = parcelRequire("2Ed4H");
var $9Lykx = parcelRequire("9Lykx");
var $8AyZl = parcelRequire("8AyZl");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");

var $d8seH = parcelRequire("d8seH");
parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $fu9Og = parcelRequire("fu9Og");

var $6j0MM = parcelRequire("6j0MM");

var $ZD2ym = parcelRequire("ZD2ym");

var $gqehT = parcelRequire("gqehT");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");

var $l9Qe0 = parcelRequire("l9Qe0");

var $gtiLb = parcelRequire("gtiLb");

var $apzof = parcelRequire("apzof");

var $f0cxD = parcelRequire("f0cxD");
// import logo from "../../../airplx-logo-transparent-square-no-text.png";
const $a9b1f4db4dde82b8$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $a9b1f4db4dde82b8$export$6b8066407e4765b1 = 73;
const $a9b1f4db4dde82b8$export$e0675076a0a84731 = 240;
const $a9b1f4db4dde82b8$var$openedMixin = (theme)=>({
        width: $a9b1f4db4dde82b8$export$e0675076a0a84731,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        overflow: "hidden"
    });
const $a9b1f4db4dde82b8$var$closedMixin = (theme)=>({
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflow: "hidden",
        width: `calc(${theme.spacing(7)} + 1px)`,
        [theme.breakpoints.up("sm")]: {
            width: `calc(${theme.spacing(9)} + 1px)`
        }
    });
const $a9b1f4db4dde82b8$export$bb68d554ded258ea = (0, $d8seH.default)("div", {
    shouldForwardProp: (prop)=>prop !== "open"
})(({ theme: theme, open: open })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: open ? "flex-end" : "flex-center",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar
    }));
const $a9b1f4db4dde82b8$var$Drawer = (0, $d8seH.default)((0, $2Ed4H.default), {
    shouldForwardProp: (prop)=>prop !== "open"
})(({ theme: theme, open: open })=>({
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        ...open && {
            // ...openedMixin(theme),
            "& .MuiDrawer-paper": {
                ...$a9b1f4db4dde82b8$var$openedMixin(theme),
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary
            }
        },
        ...!open && {
            // ...closedMixin(theme),
            "& .MuiDrawer-paper": {
                ...$a9b1f4db4dde82b8$var$closedMixin(theme),
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary
            }
        }
    }));
const $a9b1f4db4dde82b8$export$302a3bb906e220c5 = ({ active: active = false, onClickRoute: onClickRoute, label: label, icon: icon })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        sx: {
            m: 1.5
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
            title: label,
            placement: "right",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                size: "large",
                sx: {
                    color: active ? "primary.contrastText" : "primary.main",
                    backgroundColor: active ? "primary.main" : "inherit",
                    "&:hover": {
                        color: "primary.main",
                        backgroundColor: "action.hover"
                    }
                },
                onClick: onClickRoute,
                children: icon
            })
        })
    });
};
const $a9b1f4db4dde82b8$export$7ecb9218e6b31c93 = ({ open: open, onClickRoute: onClickRoute })=>{
    const { logout: logout } = (0, $gqehT.useIdentity)();
    const location = (0, $aphAM.useLocation)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    // Helper function to check if a route is active
    const isRouteActive = (routePath)=>{
        return location.pathname.startsWith(routePath);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a9b1f4db4dde82b8$var$Drawer, {
        variant: "permanent",
        open: open,
        sx: {
            zIndex: 5249,
            width: $a9b1f4db4dde82b8$export$6b8066407e4765b1,
            height: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                "data-testid": "sidedrawer_logo",
                src: $a9b1f4db4dde82b8$var$logo,
                alt: "AirPLX Logo",
                style: {
                    marginLeft: "auto",
                    marginRight: "auto",
                    width: 25,
                    marginTop: 10
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "space-between",
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
                        sx: {
                            mt: 0,
                            pt: 0
                        },
                        children: [
                            hasPermission((0, $aHqXU.Permission).ACCESS_SUPER_ADMIN) && activeFBO?.settings?.enableOpsCenter && /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                active: location.pathname === "/ops-center",
                                label: "Ops Center",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.default), {
                                    name: "SupportAgentIcon"
                                }),
                                onClickRoute: ()=>onClickRoute("/ops-center")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                active: isRouteActive("/hangars"),
                                label: "Hangars",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtiLb.HangarIcon), {}),
                                onClickRoute: ()=>onClickRoute("/hangars")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                active: isRouteActive("/ramps"),
                                label: "Ramps",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $apzof.RampIcon), {}),
                                onClickRoute: ()=>onClickRoute("/ramps")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                active: location.pathname === "/tenants",
                                label: "Aircraft",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l9Qe0.AirplaneTailsIcon), {}),
                                onClickRoute: ()=>onClickRoute("/tenants")
                            }),
                            activeFBO?.settings?.enableScheduling && /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                active: location.pathname === "/schedule",
                                label: "Trip Schedule",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.default), {
                                    name: "CalendarMonthIcon"
                                }),
                                onClickRoute: ()=>onClickRoute("/schedule")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                active: location.pathname === "/fee-calculator",
                                label: "Fee Calculator",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.default), {
                                    name: "MonetizationOnIcon"
                                }),
                                onClickRoute: ()=>onClickRoute("/fee-calculator")
                            }),
                            hasPermission((0, $aHqXU.Permission).ACCESS_SUPER_ADMIN) && false,
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                active: false,
                                label: "Help",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.default), {
                                    name: "HelpIcon"
                                }),
                                onClickRoute: ()=>{
                                    window.open("https://help.airplx.com/docs/Hangars%20and%20Ramps/Current%20Hangar", "_blank").focus();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6j0MM.AdminOnly), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                    active: location.pathname === "/super-admin",
                                    label: "Super Admin",
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.default), {
                                        name: "SupportIcon"
                                    }),
                                    onClickRoute: ()=>onClickRoute("/super-admin")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                active: isRouteActive("/settings"),
                                label: "Settings",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.default), {
                                    name: "SettingsIcon"
                                }),
                                onClickRoute: ()=>onClickRoute("/settings")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0cxD.FBOMenu), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a9b1f4db4dde82b8$export$302a3bb906e220c5, {
                                label: "Logout",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.default), {
                                    name: "LogoutIcon"
                                }),
                                onClickRoute: ()=>{
                                    logout();
                                    onClickRoute("/login");
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("6j0MM", function(module, exports) {

$parcel$export(module.exports, "AdminOnly", () => $26f1eb6c7821b4d5$export$321c0b5049a3aec5);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");
function $26f1eb6c7821b4d5$export$e743319a7758f958({ permission: permission, fallback: fallback = null, children: children }) {
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    if (!hasPermission(permission)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: fallback
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
}
function $26f1eb6c7821b4d5$export$321c0b5049a3aec5({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($26f1eb6c7821b4d5$export$e743319a7758f958, {
        permission: (0, $aHqXU.Permission).ACCESS_SUPER_ADMIN,
        fallback: fallback,
        children: children
    });
}
function $26f1eb6c7821b4d5$export$3ceb934888475511({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($26f1eb6c7821b4d5$export$e743319a7758f958, {
        permission: (0, $aHqXU.Permission).MODIFY_LAYOUT,
        fallback: fallback,
        children: children
    });
}
function $26f1eb6c7821b4d5$export$f36635d3c8e78e8({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($26f1eb6c7821b4d5$export$e743319a7758f958, {
        permission: (0, $aHqXU.Permission).USE_FAVORITES,
        fallback: fallback,
        children: children
    });
}

});

parcelRegister("l9Qe0", function(module, exports) {

$parcel$export(module.exports, "AirplaneTailsIcon", () => $4400a4fe018fb9da$export$19fa8bdfd7d099c5);

var $ayMG0 = parcelRequire("ayMG0");

var $cGE4z = parcelRequire("cGE4z");
const $4400a4fe018fb9da$export$19fa8bdfd7d099c5 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cGE4z.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 128 128",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                style: {
                    stroke: "none",
                    fillRule: "nonzero",
                    fill: "currentColor",
                    fillOpacity: 1
                },
                d: "M 62.539062 45.421875 L 62.597656 45.421875 C 65.660156 45.539062 68.539062 47.039062 70.339844 49.441406 L 89.539062 74.699219 C 89.898438 75.121094 90.4375 75.421875 90.980469 75.421875 L 99.980469 75.421875 C 101 75.421875 101.777344 74.640625 101.777344 73.621094 C 101.777344 72.601562 101 71.820312 99.980469 71.820312 L 91.878906 71.820312 L 73.277344 47.28125 C 70.9375 44.21875 67.460938 42.300781 63.621094 41.878906 L 55.878906 31.679688 C 53.300781 28.261719 49.160156 26.21875 44.898438 26.21875 L 34.640625 26.21875 C 34.097656 26.21875 33.558594 26.460938 33.199219 26.941406 C 32.839844 27.421875 32.71875 27.960938 32.898438 28.5 L 42.679688 64.199219 L 29 69.839844 C 27.320312 70.558594 26.300781 72.179688 26.359375 74.039062 C 26.417969 75.898438 27.679688 77.398438 29.417969 77.878906 L 50 83.820312 C 50.058594 83.820312 50.179688 83.878906 50.238281 83.878906 L 46.398438 85.5 C 44.71875 86.21875 43.699219 87.839844 43.757812 89.699219 C 43.820312 91.558594 45.078125 93.058594 46.820312 93.539062 L 67.339844 99.480469 C 72.917969 101.101562 78.679688 101.878906 84.4375 101.878906 L 100.039062 101.878906 C 101.058594 101.878906 101.839844 101.101562 101.839844 100.078125 C 101.839844 99.058594 101.058594 98.28125 100.039062 98.28125 L 84.5 98.28125 C 79.039062 98.28125 73.640625 97.5 68.359375 96 L 47.839844 90.058594 C 47.417969 89.941406 47.359375 89.640625 47.359375 89.460938 C 47.359375 89.28125 47.359375 88.980469 47.777344 88.800781 L 56.71875 85.078125 L 62.898438 82.5 C 63.738281 82.140625 64.160156 81.238281 63.917969 80.339844 L 54.378906 45.421875 L 62.238281 45.421875 C 62.359375 45.421875 62.480469 45.421875 62.539062 45.421875 Z M 62.539062 45.421875 "
            })
        })
    });

});
parcelRegister("cGE4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $93c87ddcceadf9a1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $8vYwX = parcelRequire("8vYwX");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $93c87ddcceadf9a1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8vYwX.getIconUtilityClass), classes);
};
const $93c87ddcceadf9a1$var$IconRoot = (0, $d8seH.default)('span', {
    name: 'MuiIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        // Chrome fix for https://issues.chromium.org/issues/41375697
        // To remove at some point.
        overflow: 'hidden',
        display: 'inline-block',
        // allow overflow hidden to take action
        textAlign: 'center',
        // support non-square icon
        flexShrink: 0,
        variants: [
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(20)
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography.pxToRem(24)
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(36)
                }
            },
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars || theme).palette.action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $93c87ddcceadf9a1$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function Icon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIcon'
    });
    const { baseClassName: baseClassName = 'material-icons', className: className, color: color = 'inherit', component: Component = 'span', fontSize: fontSize = 'medium', ...other } = props;
    const ownerState = {
        ...props,
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    };
    const classes = $93c87ddcceadf9a1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($93c87ddcceadf9a1$var$IconRoot, {
        as: Component,
        className: (0, $9QePP.default)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        'notranslate', classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref,
        ...other
    });
});
$93c87ddcceadf9a1$var$Icon.muiName = 'Icon';
var $93c87ddcceadf9a1$export$2e2bcd8739ae039 = $93c87ddcceadf9a1$var$Icon;

});
parcelRegister("8vYwX", function(module, exports) {

$parcel$export(module.exports, "getIconUtilityClass", () => $63302c123a5539bd$export$e7545bb336f9a5fc);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $63302c123a5539bd$export$e7545bb336f9a5fc(slot) {
    return (0, $4Cod0.default)('MuiIcon', slot);
}
const $63302c123a5539bd$var$iconClasses = (0, $beCSm.default)('MuiIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $63302c123a5539bd$export$2e2bcd8739ae039 = $63302c123a5539bd$var$iconClasses;

});



parcelRegister("f0cxD", function(module, exports) {

$parcel$export(module.exports, "FBOMenu", () => $efc636afee4e825b$export$ed08cd54da04f63f);

var $ayMG0 = parcelRequire("ayMG0");

var $h0pvP = parcelRequire("h0pvP");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $eFqab = parcelRequire("eFqab");
var $ejcfT = parcelRequire("ejcfT");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $btULL = parcelRequire("btULL");
const $efc636afee4e825b$export$ed08cd54da04f63f = ({})=>{
    const { activeFBO: activeFBO, setActiveFBOId: setActiveFBOId, fbos: fbos } = (0, $ZD2ym.useActiveFBOs)();
    const [displayNoFBO, setDisplayNoFBO] = $acw62.useState(false);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const handleMenu = (event)=>{
        if (!fbos.length) {
            setDisplayNoFBO(true);
            return;
        }
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const sortedFBOs = $acw62.useMemo(()=>{
        return (0, $cLNZr.orderBy)(fbos, [
            "name"
        ], [
            "asc"
        ]);
    }, [
        fbos
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                alignItems: "center",
                spacing: -2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $btULL.SideIconButton), {
                        onClickRoute: handleMenu,
                        label: "Switch FBO",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h0pvP))), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "primary.main",
                        noWrap: true,
                        align: "center",
                        sx: {
                            width: "90%"
                        },
                        children: activeFBO?.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: displayNoFBO,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "No FBO Found"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                            children: "You currently do not belong to an FBO. Please contact your system administrator to join one."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>setDisplayNoFBO(false),
                            children: "OK"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
                disablePortal: true,
                keepMounted: true,
                id: "menu-fbo",
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                open: Boolean(anchorEl),
                onClose: handleClose,
                sx: {
                    zIndex: 99999999999
                },
                children: sortedFBOs.map((fbo)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                        onClick: ()=>{
                            setActiveFBOId(fbo.id);
                            window.location.href = "/#/hangars";
                            window.location.reload();
                        },
                        sx: {
                            backgroundColor: activeFBO?.id === fbo.id ? 'common.black' : 'transparent',
                            color: activeFBO?.id === fbo.id ? 'common.white' : 'text.primary',
                            '&:hover': {
                                backgroundColor: activeFBO?.id === fbo.id ? 'grey.900' : 'action.hover'
                            }
                        },
                        children: [
                            fbo?.subscription === "inactive" ? "\xd7 " : "",
                            fbo.name
                        ]
                    }, `active-fbo-menu-item=${fbo.id}`))
            })
        ]
    });
};

});


parcelRegister("iM6w0", function(module, exports) {
$parcel$export(module.exports, "FavoritesButton", () => (parcelRequire("cuIiG")).FavoritesButton);
parcelRequire("cuIiG");

});
parcelRegister("cuIiG", function(module, exports) {

$parcel$export(module.exports, "FavoritesButton", () => $4a3e590c10fff050$export$92099bd1e2b5685c);

var $ayMG0 = parcelRequire("ayMG0");

var $dqlTG = parcelRequire("dqlTG");

var $9wvX1 = parcelRequire("9wvX1");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2p5OG = parcelRequire("2p5OG");
var $6MV2p = parcelRequire("6MV2p");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $7p8YN = parcelRequire("7p8YN");

var $lNEp2 = parcelRequire("lNEp2");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");

var $g12SE = parcelRequire("g12SE");

var $4HjN0 = parcelRequire("4HjN0");

var $4d3Tw = parcelRequire("4d3Tw");

var $9cfaq = parcelRequire("9cfaq");
const $4a3e590c10fff050$export$92099bd1e2b5685c = ({ disabled: disabled = false, location: location, setLocation: setLocation, stacks: stacks })=>{
    const { isMultiHangar: isMultiHangar } = (0, $7p8YN.useMultiHangarState)();
    const [confirm, setConfirm] = $acw62.useState({
        open: false,
        text: "",
        okText: "",
        onOk: ()=>{}
    });
    const [open, setOpen] = $acw62.useState(false);
    const [openNameField, setOpenNameField] = $acw62.useState(false);
    const [name, setName] = $acw62.useState("");
    const favorites = $acw62.useMemo(()=>{
        return (0, $cLNZr.orderBy)(stacks, [
            "name"
        ], [
            "asc"
        ]);
    }, [
        location,
        stacks,
        open
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2p5OG.default), {
                disabled: disabled,
                color: "info",
                variant: "contained",
                sx: {
                    boxShadow: "none"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: ()=>setOpenNameField(true),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9wvX1))), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: ()=>setOpen(true),
                        children: "Favorites"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: openNameField,
                onClose: ()=>setOpenNameField(false),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Save Favorite Stack"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            isMultiHangar ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4HjN0.MultiLocationSave), {
                                name: name,
                                setName: setName,
                                setOpenNameField: setOpenNameField,
                                setConfirm: setConfirm
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9cfaq.SingleLocationSave), {
                                location: location,
                                setLocation: setLocation,
                                name: name,
                                setName: setName,
                                setOpenNameField: setOpenNameField,
                                setConfirm: setConfirm
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: ()=>setOpen(false),
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "h6",
                                    children: "Favorites"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>setOpen(false),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        sx: {
                            ...(0, $lNEp2.scrollSx)
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                mt: 2,
                                mb: 2,
                                // minWidth: favorites.length > 0 ? 1000 : 300,
                                minWidth: 1000,
                                height: favorites.length === 0 ? 150 : undefined,
                                minHeight: 600
                            },
                            children: isMultiHangar ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g12SE.MultiHangarFavoritesPresenter), {
                                setOpen: setOpen,
                                setConfirm: setConfirm
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d3Tw.SingleFavoritesPresenter), {
                                favorites: favorites,
                                location: location,
                                setLocation: setLocation,
                                setName: setName,
                                setOpen: setOpen
                            })
                        })
                    })
                ]
            }),
            confirm?.open && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Please Confirm",
                onCancel: ()=>setConfirm(null),
                onClose: ()=>setConfirm(null),
                ...confirm
            })
        ]
    });
};

});
parcelRegister("g12SE", function(module, exports) {

$parcel$export(module.exports, "MultiHangarFavoritesPresenter", () => $7d58c3a2f29a5cbc$export$b1f27ecb16071d7b);

var $ayMG0 = parcelRequire("ayMG0");

var $cFBau = parcelRequire("cFBau");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $7p8YN = parcelRequire("7p8YN");

var $5U03M = parcelRequire("5U03M");

var $lNEp2 = parcelRequire("lNEp2");
parcelRequire("dYVUB");
var $25Lfr = parcelRequire("25Lfr");

var $bXDUV = parcelRequire("bXDUV");

var $a97EO = parcelRequire("a97EO");
const $7d58c3a2f29a5cbc$export$3657e816c20780c2 = ({ setOpen: setOpen, setConfirm: setConfirm, stackName: stackName })=>{
    const { hangars: hangars, setHangars: setHangars } = (0, $7p8YN.useMultiHangarState)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        justifyContent: "center",
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                textAlign: "center",
                sx: {
                    width: "100%"
                },
                children: stackName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        color: "success",
                        onClick: ()=>{
                            setConfirm({
                                open: true,
                                text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "inherit",
                                    children: [
                                        `Remove all aircraft from selected hangar(s) and replace with aircraft for \u{2018}${stackName}\u{2019}.`,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        `Note: Aircraft in this saved stack will be moved from other hangars if needed.`
                                    ]
                                }),
                                okText: `Yes, reset`,
                                onOk: ()=>{
                                    // deduplicates tenants and movable obstacles across hangars
                                    const entityAssignments = {};
                                    for (const hangar of hangars){
                                        const favorite = hangar.stacks.find((s)=>s.name === stackName);
                                        if (!favorite) continue;
                                        for (const tenant of favorite.tenants){
                                            if (entityAssignments[tenant.id]) continue;
                                            entityAssignments[tenant.id] = hangar.id;
                                        }
                                        for (const movableObstacle of favorite.movableObstacles){
                                            if (entityAssignments[movableObstacle.id]) continue;
                                            entityAssignments[movableObstacle.id] = hangar.id;
                                        }
                                    }
                                    setHangars(hangars.map((hangar)=>{
                                        const favorite = hangar.stacks.find((s)=>s.name === stackName);
                                        const isInThisHangar = (e)=>{
                                            if (entityAssignments[e.id]) return entityAssignments[e.id] === hangar.id;
                                            return true;
                                        };
                                        if (!favorite) return {
                                            ...hangar,
                                            stack: {
                                                ...hangar.stack,
                                                tenants: hangar.stack.tenants.filter(isInThisHangar),
                                                movableObstacles: hangar.stack.movableObstacles.filter(isInThisHangar)
                                            }
                                        };
                                        const tenants = favorite.tenants.filter(isInThisHangar);
                                        const movableObstacles = favorite.movableObstacles.filter(isInThisHangar);
                                        return {
                                            ...hangar,
                                            stack: {
                                                ...hangar.stack,
                                                tenants: tenants.map((t)=>({
                                                        ...t,
                                                        position: {
                                                            ...t.position,
                                                            id: (0, $lNEp2.uuidv4)(),
                                                            stack_id: hangar.stack.id,
                                                            entity_id: t.entity_id
                                                        }
                                                    })),
                                                movableObstacles: movableObstacles.map((mo)=>({
                                                        ...mo,
                                                        position: {
                                                            ...mo.position,
                                                            id: (0, $lNEp2.uuidv4)(),
                                                            stack_id: hangar.stack.id,
                                                            entity_id: mo.entity_id
                                                        }
                                                    }))
                                            }
                                        };
                                    }));
                                    setOpen(false);
                                }
                            });
                        },
                        children: "Use"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        color: "error",
                        onClick: ()=>{
                            setConfirm({
                                open: true,
                                text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "inherit",
                                    children: [
                                        `You are about to delete '${stackName} from all selected hangars.`,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        `Meaning\u{2026}that if '${stackName} is saved for hangars A, B, C\u{2026}but Ive only selected A and B\u{2026}then C still keeps it\u{2019}s saved '${stackName}`
                                    ]
                                }),
                                okText: `Yes, delete this favorite`,
                                onOk: ()=>{
                                    setHangars(hangars.map((hangar)=>({
                                            ...hangar,
                                            stacks: hangar.stacks.filter((s)=>s.name !== stackName)
                                        })));
                                }
                            });
                        },
                        children: "Delete"
                    })
                ]
            })
        ]
    });
};
const $7d58c3a2f29a5cbc$export$72b150f6b010c3a6 = (hangar, stackName)=>{
    const stack = hangar.stacks.find((s)=>s.name === stackName);
    if (!stack) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            height: "154px",
            p: 2
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: "caption",
            component: "p",
            textAlign: "center",
            alignItems: "center",
            sx: {
                width: "100%",
                mt: "75px"
            },
            children: "No stack"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
            stack: stack,
            setStack: ()=>{
            // not needed
            },
            location: {
                type: "hangar",
                ...hangar
            },
            height: 150,
            options: {
                hideUnplaced: true,
                readOnly: true,
                selectable: false,
                printable: false
            }
        })
    });
};
const $7d58c3a2f29a5cbc$export$b1f27ecb16071d7b = ({ setOpen: setOpen, setConfirm: setConfirm })=>{
    const [stackFilter, setStackFilter] = $acw62.useState("");
    const { hangars: allHangars } = (0, $7p8YN.useMultiHangarState)();
    const hangars = allHangars.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID));
    const stackNames = (0, $cLNZr.uniq)(hangars.flatMap((h)=>h.stacks.map((s)=>s.name))).sort().filter((name)=>name != null && ![
            "current",
            "reference"
        ].includes(name)).filter((name)=>{
        if (!stackFilter) return true;
        return name?.toLocaleLowerCase().indexOf(stackFilter.toLocaleLowerCase()) > -1;
    });
    const columns = [
        {
            id: "stackchooser",
            label: "Stack",
            render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                    disablePortal: true,
                    size: "small",
                    onChange: (_event, newValue)=>{
                        setStackFilter(newValue || "");
                    },
                    options: stackNames,
                    sx: {
                        width: "100%"
                    },
                    renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            ...params,
                            variant: "outlined",
                            placeholder: "Search for stack"
                        })
                })
        },
        ...hangars.map((hangar)=>({
                id: hangar.id,
                label: hangar.name
            }))
    ];
    const rows = stackNames.map((stackName)=>({
            id: stackName,
            render: (columnId, _row)=>{
                if (columnId === "stackchooser") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    height: 200,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($7d58c3a2f29a5cbc$export$3657e816c20780c2, {
                        setOpen: setOpen,
                        setConfirm: setConfirm,
                        stackName: stackName
                    })
                });
                const hangar = hangars.find((h)=>h.id === columnId);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    height: 200,
                    children: hangar && $7d58c3a2f29a5cbc$export$72b150f6b010c3a6(hangar, stackName)
                });
            }
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            height: 600
        },
        children: rows.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a97EO.FavoritesEmptyState), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25Lfr.FrozenGrid), {
            columns: columns,
            rows: rows
        })
    });
};

});
parcelRegister("dYVUB", function(module, exports) {
$parcel$export(module.exports, "FrozenGrid", () => (parcelRequire("25Lfr")).FrozenGrid);
parcelRequire("25Lfr");

});
parcelRegister("25Lfr", function(module, exports) {

$parcel$export(module.exports, "FrozenGrid", () => $3ba99cc0e4935e64$export$9238c7d3274adde5);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $lNEp2 = parcelRequire("lNEp2");
const $3ba99cc0e4935e64$export$9238c7d3274adde5 = ({ columns: columns, rows: rows })=>{
    const theme = (0, $14H9o.default)();
    const gridStyle = {
        display: "grid",
        gridTemplateColumns: `200px repeat(${columns.length - 1}, 400px)`,
        width: "fit-content"
    };
    const cellStyle = {
        padding: theme.spacing(1)
    };
    const gridHeader = {
        ...cellStyle,
        backgroundColor: "white",
        position: "sticky",
        top: 0,
        zIndex: 100000,
        borderBottomColor: theme.palette.divider,
        borderBottomWidth: 2,
        borderBottomStyle: "solid"
    };
    const gridHeaderFixed = {
        ...gridHeader,
        zIndex: 1000002,
        position: "sticky",
        left: 0,
        borderBottomWidth: 0
    };
    const gridEntry = {
        ...cellStyle,
        height: 200,
        backgroundColor: "white"
    };
    const gridEntryFixedLeft = {
        ...gridEntry,
        position: "sticky",
        left: 0,
        zIndex: 999999
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            overflow: "scroll",
            height: "100%",
            ...(0, $lNEp2.scrollSx)
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            sx: gridStyle,
            children: [
                columns.map((column, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        style: idx === 0 ? gridHeaderFixed : gridHeader,
                        textAlign: "center",
                        children: Boolean(column.render) ? column.render() : column.label
                    }, `grid-header-${idx}`)),
                rows.map((row, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                        children: columns.map((column, idx2)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: idx2 === 0 ? gridEntryFixedLeft : gridEntry,
                                children: row.render(column.id, row)
                            }, `row-${idx}-column-${idx2}`))
                    }, `row-${idx}`))
            ]
        })
    });
};
var $3ba99cc0e4935e64$export$2e2bcd8739ae039 = $3ba99cc0e4935e64$export$9238c7d3274adde5;

});


parcelRegister("a97EO", function(module, exports) {

$parcel$export(module.exports, "FavoritesEmptyState", () => $41b37d1f295f60a8$export$de10979095de4926);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
// Use direct URL path like logo (PNG imports return objects in Parcel)
const $41b37d1f295f60a8$var$favoritesScreenshot = "/favorites-screenshot.png";
const $41b37d1f295f60a8$export$de10979095de4926 = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    mb: 2,
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    p: 1,
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: $41b37d1f295f60a8$var$favoritesScreenshot,
                    alt: "No favorites",
                    style: {
                        height: 100
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                textAlign: "center",
                variant: "body1",
                maxWidth: 500,
                children: "No favorites currently saved. Click the \u201CSave\u201D icon to start saving your favorites stacks."
            })
        ]
    });

});


parcelRegister("4HjN0", function(module, exports) {

$parcel$export(module.exports, "MultiLocationSave", () => $609ff863ee129fdb$export$8387f55269c5d13);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $7p8YN = parcelRequire("7p8YN");

var $5U03M = parcelRequire("5U03M");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $amnUw = parcelRequire("amnUw");
const $609ff863ee129fdb$export$8387f55269c5d13 = ({ name: name, setName: setName, setOpenNameField: setOpenNameField, setConfirm: setConfirm })=>{
    const [selectedHangarIds, setSelectedHangarIds] = $acw62.useState([]);
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hangars: hangars, setHangars: setHangars } = (0, $7p8YN.useMultiHangarState)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        sx: {
            minWidth: 400
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amnUw.MultiHangarSelectForm), {
                hangars: hangars.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID)),
                onChange: setSelectedHangarIds
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 2,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        type: "text",
                        size: "small",
                        label: "Name",
                        fullWidth: true,
                        value: name,
                        onChange: (e)=>setName(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: ()=>setOpenNameField(false),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        color: "success",
                        disabled: name.length === 0,
                        onClick: ()=>{
                            const save = ()=>{
                                setOpenNameField(false);
                                setHangars(hangars.map((hangar)=>{
                                    if (!selectedHangarIds.includes(hangar.id)) return hangar;
                                    const existingStack = hangar.stacks.find((s)=>s.name === name);
                                    const stackId = existingStack?.id || (0, $lNEp2.uuidv4)();
                                    return {
                                        ...hangar,
                                        stacks: [
                                            ...hangar.stacks,
                                            {
                                                id: stackId,
                                                location_id: hangar.location_id,
                                                isReference: false,
                                                name: name,
                                                tenants: hangar.stack.tenants.map((t)=>({
                                                        ...t,
                                                        position: {
                                                            ...t.position,
                                                            id: (0, $lNEp2.uuidv4)(),
                                                            stack_id: stackId,
                                                            entity_id: t.entity_id
                                                        }
                                                    })),
                                                movableObstacles: hangar.stack.movableObstacles.map((mo)=>({
                                                        ...mo,
                                                        position: {
                                                            ...mo.position,
                                                            id: (0, $lNEp2.uuidv4)(),
                                                            stack_id: stackId,
                                                            entity_id: mo.entity_id
                                                        }
                                                    })),
                                                options: {
                                                    // these are the defaults
                                                    wall_spacing_left: 2,
                                                    wall_spacing_back: 2,
                                                    wall_spacing_right: 2,
                                                    horizontal_spacing: activeFBO?.sop_horizontal_spacing,
                                                    vertical_spacing: activeFBO?.sop_vertical_spacing,
                                                    overlap: activeFBO?.sop_overlap,
                                                    tug_spacing: 10,
                                                    density_threshold: 0.8,
                                                    towing_equipment_id: null,
                                                    corner_strategy: [
                                                        (0, $keHtM.CornerStrategy).ANGLE_45,
                                                        (0, $keHtM.CornerStrategy).ANGLE_45
                                                    ],
                                                    cloud_position_prioritization: true,
                                                    sample_size: 1000,
                                                    xy_weights: [
                                                        1,
                                                        2
                                                    ]
                                                }
                                            }
                                        ]
                                    };
                                }));
                            };
                            const existingStack = hangars.flatMap((h)=>h.stacks).find((s)=>s?.name === name);
                            if (existingStack) {
                                setConfirm({
                                    open: true,
                                    text: `A favorite named '${name}' already exists. Do you want to overwrite it?`,
                                    okText: "Yes, overwrite it",
                                    onOk: ()=>{
                                        save();
                                    }
                                });
                                return;
                            }
                            save();
                        },
                        children: "Save"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("amnUw", function(module, exports) {

$parcel$export(module.exports, "MultiHangarSelectForm", () => $144d7b0d38b23472$export$aef9b4857c323b9e);
$parcel$export(module.exports, "MultiHangarSelect", () => $144d7b0d38b23472$export$aab38e28cfad6f16);

var $ayMG0 = parcelRequire("ayMG0");

var $1Aijw = parcelRequire("1Aijw");
var $lkxXU = parcelRequire("lkxXU");
var $2esSG = parcelRequire("2esSG");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $30UGG = parcelRequire("30UGG");

var $6lXkL = parcelRequire("6lXkL");

var $6MV2p = parcelRequire("6MV2p");

var $2MUlQ = parcelRequire("2MUlQ");

var $6Q1H5 = parcelRequire("6Q1H5");

var $eFqab = parcelRequire("eFqab");

var $ejcfT = parcelRequire("ejcfT");

var $acw62 = parcelRequire("acw62");

var $88ea6 = parcelRequire("88ea6");
const $144d7b0d38b23472$export$aef9b4857c323b9e = ({ hangars: hangars, onChange: onChange })=>{
    const [selectedHangarIds, setSelectedHangarIds] = $acw62.useState(hangars.map((h)=>h.id));
    $acw62.useEffect(()=>{
        onChange(selectedHangarIds);
    }, [
        selectedHangarIds
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                        checked: selectedHangarIds.length === hangars.length,
                        onClick: (e)=>{
                            const target = e.target;
                            if (target.checked) setSelectedHangarIds(hangars.map((h)=>h.id));
                            else setSelectedHangarIds([]);
                        }
                    }),
                    label: "Select All"
                })
            }, `checkbox-all`),
            hangars.map((hangar)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                            checked: selectedHangarIds.indexOf(hangar.id) > -1,
                            onClick: (e)=>{
                                const target = e.target;
                                if (target.checked) setSelectedHangarIds([
                                    ...selectedHangarIds,
                                    hangar.id
                                ]);
                                else setSelectedHangarIds(selectedHangarIds.filter((id)=>id !== hangar.id));
                            }
                        }),
                        label: hangar.name
                    })
                }, `checkbox-${hangar.id}`))
        ]
    });
};
const $144d7b0d38b23472$export$aab38e28cfad6f16 = ({ title: title, caption: caption, cancelText: cancelText, okText: okText, hangars: hangars, onCancel: onCancel, renderSecondaryAction: renderSecondaryAction, onOk: onOk })=>{
    const [selectedHangarIds, setSelectedHangarIds] = $acw62.useState(hangars.map((h)=>h.id));
    const [dumpTo, setDumpTo] = $acw62.useState("HOLDING_AREA");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
            open: true,
            fullWidth: true,
            maxWidth: Boolean(renderSecondaryAction) ? "sm" : "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                            children: caption
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                    checked: selectedHangarIds.length === hangars.length,
                                                    onClick: (e)=>{
                                                        const target = e.target;
                                                        if (target.checked) setSelectedHangarIds(hangars.map((h)=>h.id));
                                                        else setSelectedHangarIds([]);
                                                    }
                                                }),
                                                label: "Select All"
                                            })
                                        }, `checkbox-all`),
                                        hangars.map((hangar)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                                        checked: selectedHangarIds.indexOf(hangar.id) > -1,
                                                        onClick: (e)=>{
                                                            const target = e.target;
                                                            if (target.checked) setSelectedHangarIds([
                                                                ...selectedHangarIds,
                                                                hangar.id
                                                            ]);
                                                            else setSelectedHangarIds(selectedHangarIds.filter((id)=>id !== hangar.id));
                                                        }
                                                    }),
                                                    label: hangar.name
                                                })
                                            }, `checkbox-${hangar.id}`))
                                    ]
                                }),
                                Boolean(renderSecondaryAction) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                            orientation: "vertical",
                                            sx: {
                                                mt: 3,
                                                height: "200px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88ea6.SelectDumpTo), {
                                            dumpTo: dumpTo,
                                            setDumpTo: setDumpTo
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: onCancel,
                            children: cancelText ?? "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            color: "success",
                            onClick: ()=>{
                                onOk(selectedHangarIds, dumpTo);
                            },
                            children: okText ?? "OK"
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("88ea6", function(module, exports) {

$parcel$export(module.exports, "SelectDumpTo", () => $17d76f3477e1ecb4$export$114bc68f6bb623e8);

var $ayMG0 = parcelRequire("ayMG0");

var $gd5y7 = parcelRequire("gd5y7");
var $2esSG = parcelRequire("2esSG");
var $djhCy = parcelRequire("djhCy");
var $hrMZe = parcelRequire("hrMZe");
var $8IWga = parcelRequire("8IWga");
parcelRequire("acw62");
const $17d76f3477e1ecb4$export$114bc68f6bb623e8 = ({ setDumpTo: setDumpTo })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
        sx: {
            width: 300,
            mt: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $djhCy.default), {
                children: "To:"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8IWga.default), {
                defaultValue: "HOLDING_AREA",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        value: "HOLDING_AREA",
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {}),
                        label: "Holding Area",
                        onClick: ()=>setDumpTo("HOLDING_AREA")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        value: "FRONT",
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {}),
                        label: "Front of Hangar",
                        onClick: ()=>setDumpTo("FRONT")
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("4d3Tw", function(module, exports) {

$parcel$export(module.exports, "SingleFavoritesPresenter", () => $630de6a290e467f7$export$d33ce1a9322d57e9);

var $ayMG0 = parcelRequire("ayMG0");

var $cFBau = parcelRequire("cFBau");
var $cJu23 = parcelRequire("cJu23");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $lNEp2 = parcelRequire("lNEp2");

var $dFGKX = parcelRequire("dFGKX");

var $a97EO = parcelRequire("a97EO");
const $630de6a290e467f7$export$d33ce1a9322d57e9 = ({ favorites: favorites, location: location, setLocation: setLocation, setOpen: setOpen, setName: setName })=>{
    const [stackFilter, setStackFilter] = $acw62.useState("");
    const stackNames = (0, $cLNZr.uniq)(location.stacks.map((s)=>s.name)).sort().filter((name)=>name != null && ![
            "current",
            "reference"
        ].includes(name)).filter((name)=>{
        if (!stackFilter) return true;
        return name?.toLocaleLowerCase().indexOf(stackFilter.toLocaleLowerCase()) > -1;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                disablePortal: true,
                size: "small",
                onChange: (_event, newValue)=>{
                    setStackFilter(newValue || "");
                },
                options: stackNames,
                sx: {
                    width: "100%"
                },
                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        ...params,
                        variant: "outlined",
                        placeholder: "Search for stack"
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cJu23.default), {
                container: true,
                direction: "row",
                justifyContent: "start",
                alignItems: "center",
                spacing: 8,
                width: "100%",
                children: [
                    favorites.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a97EO.FavoritesEmptyState), {})
                    }),
                    favorites.filter((fav)=>stackFilter ? fav.name?.toLocaleLowerCase()?.indexOf(stackFilter.toLocaleLowerCase()) > -1 : true).map((favorite)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                            item: true,
                            xs: 6,
                            sx: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                direction: "column",
                                alignItems: "center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dFGKX.FavoritePresenter), {
                                    location: location,
                                    favorite: favorite,
                                    onUse: (favorite)=>{
                                        setOpen(false);
                                        setLocation({
                                            ...location,
                                            stack: {
                                                ...location.stack,
                                                tenants: [
                                                    ...favorite.tenants
                                                ].map((t)=>({
                                                        ...t,
                                                        position: {
                                                            ...t.position,
                                                            id: (0, $lNEp2.uuidv4)(),
                                                            stack_id: location.stack.id,
                                                            entity_id: t.entity_id
                                                        }
                                                    })),
                                                movableObstacles: [
                                                    ...favorite.movableObstacles
                                                ].map((mo)=>({
                                                        ...mo,
                                                        position: {
                                                            ...mo.position,
                                                            id: (0, $lNEp2.uuidv4)(),
                                                            stack_id: location.stack.id,
                                                            entity_id: mo.entity_id
                                                        }
                                                    }))
                                            }
                                        });
                                        setName(favorite.name || "");
                                    },
                                    onDelete: (favorite)=>{
                                        setLocation({
                                            ...location,
                                            stacks: location.stacks.filter((s)=>s.id !== favorite.id)
                                        });
                                    }
                                })
                            })
                        }, `favorite-${favorite.id}`))
                ]
            })
        ]
    });
};

});
parcelRegister("dFGKX", function(module, exports) {

$parcel$export(module.exports, "FavoritePresenter", () => $4d005652d5f142c7$export$7c03cebb8e1b10ad);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $Aoavo = parcelRequire("Aoavo");

var $64aJt = parcelRequire("64aJt");

var $lFx3G = parcelRequire("lFx3G");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");
const $4d005652d5f142c7$export$7c03cebb8e1b10ad = ({ location: location, favorite: favorite, onUse: onUse, onDelete: onDelete })=>{
    const [confirm, setConfirm] = $acw62.useState({
        open: false,
        text: "",
        okText: "",
        onOk: ()=>{}
    });
    const [print, setPrint] = $acw62.useState(false);
    const printComponentRef = $acw62.useRef(null);
    const handlePrint = (0, $Aoavo.useReactToPrint)({
        contentRef: printComponentRef
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        sx: {
            p: 1,
            height: 300,
            width: 300
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 0,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        textAlign: "center",
                        variant: "subtitle2",
                        children: favorite.name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                        stack: favorite,
                        setStack: ()=>{
                        // not needed
                        },
                        location: location,
                        height: location.width / location.depth > 1.75 ? 175 : 250,
                        zoomLevel: 0.25,
                        options: {
                            hideUnplaced: true,
                            readOnly: true,
                            selectable: false,
                            printable: false
                        }
                    }),
                    print && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            position: "absolute",
                            top: "100vh"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: printComponentRef,
                            style: {
                                display: "block",
                                padding: 15,
                                marginLeft: 50
                            },
                            children: location.type === "ramp" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lFx3G.RampPrintLayout), {
                                ramp: location,
                                stack: favorite,
                                subtitle: `Favorite: ${favorite.name}`
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $64aJt.HangarPrintLayout), {
                                hangar: location,
                                stack: favorite,
                                subtitle: `Favorite: ${favorite.name}`
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        justifyContent: "center",
                        mt: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                onClick: ()=>{
                                    setConfirm({
                                        open: true,
                                        text: `Remove all aircaft from your current ${location.type} and replace with aircraft from '${favorite.name}'.`,
                                        okText: `Yes, reset to this saved stack`,
                                        onOk: ()=>{
                                            onUse(favorite);
                                        }
                                    });
                                },
                                children: "Use"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "error",
                                onClick: ()=>{
                                    setConfirm({
                                        open: true,
                                        text: `You are about to delete ${favorite.name}.`,
                                        okText: "Yes, delete this favorite",
                                        onOk: ()=>{
                                            onDelete(favorite);
                                        }
                                    });
                                },
                                children: "Delete"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "info",
                                onClick: ()=>{
                                    setPrint(true);
                                    setTimeout(()=>{
                                        handlePrint();
                                        setPrint(false);
                                    }, 1000);
                                },
                                children: "Print"
                            })
                        ]
                    })
                ]
            }),
            confirm?.open && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Please Confirm",
                onCancel: ()=>setConfirm(null),
                onClose: ()=>setConfirm(null),
                ...confirm
            })
        ]
    });
};

});
parcelRegister("64aJt", function(module, exports) {

$parcel$export(module.exports, "HangarPrintLayout", () => $ff105cadb3fef1f5$export$8f3647f6a4daa6b6);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");


var $ZD2ym = parcelRequire("ZD2ym");

var $4ckAs = parcelRequire("4ckAs");

var $5KGQl = parcelRequire("5KGQl");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");

var $97sqG = parcelRequire("97sqG");

var $kPMZ3 = parcelRequire("kPMZ3");
const $ff105cadb3fef1f5$export$8f3647f6a4daa6b6 = ({ hangar: currentHangar, stack: stack, subtitle: subtitle })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { isConference: isConference } = (0, $4ckAs.useFeatureFlags)();
    const hangar = {
        ...currentHangar,
        stack: stack
    };
    const polygons = (0, $5KGQl.getStackPolygons)(stack, hangar.width, 1, false);
    const dimensions = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(hangar.width), 2)}w x ${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(hangar.depth), 2)}d  x ${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(hangar.height), 2)}h` : `${(0, $lNEp2.formatNumber)(hangar.width, 2)}w x ${(0, $lNEp2.formatNumber)(hangar.depth, 2)}d  x ${(0, $lNEp2.formatNumber)(hangar.height, 2)}h`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                        type: "text/css",
                        media: "print",
                        children: `@page { size: ${hangar.depth > hangar.width ? "portrait" : "landscape"}; }`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        children: subtitle ? `${hangar.name}: ${subtitle}` : hangar.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: dimensions
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                justifyContent: "flex-end",
                                spacing: 1,
                                sx: {
                                    width: 500,
                                    height: 50
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle1",
                                                children: "Aircraft"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                textAlign: "center",
                                                color: "info.dark",
                                                children: (0, $kPMZ3.findTenantsFullyInHangar)(hangar, polygons).length
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                        orientation: "vertical"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle1",
                                                children: "Utilization"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                textAlign: "center",
                                                color: "info.dark",
                                                children: [
                                                    (0, $kPMZ3.calculateUtilization)(hangar, polygons, true, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false),
                                                    "%",
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    isConference && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                orientation: "vertical"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "column",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "subtitle1",
                                                        children: "Est. Value"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        textAlign: "center",
                                                        color: "info.dark",
                                                        children: (0, $97sqG.estimateValue)(activeFBO, hangar, polygons, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                orientation: "vertical"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "column",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "subtitle1",
                                                        children: "Est. Tow Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        textAlign: "center",
                                                        color: "info.dark",
                                                        children: (0, $97sqG.calcEstimateTowTime)(hangar, polygons)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                        stack: stack,
                        setStack: ()=>{
                        // not needed
                        },
                        location: {
                            ...hangar,
                            type: "hangar"
                        },
                        height: hangar.depth > hangar.width ? hangar.depth / hangar.width * 600 : hangar.depth / hangar.width * 650,
                        options: {
                            hideUnplaced: true,
                            readOnly: true,
                            selectable: false,
                            printable: true
                        }
                    })
                ]
            }),
            isConference && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                justifyContent: "right",
                alignItems: "center",
                sx: {
                    position: "absolute",
                    right: 0,
                    bottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        align: "right",
                        children: [
                            "Automatically optimized by",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Contact us at www.airplx.com or peter@airplx.com."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, {}),
                        style: {
                            width: 175
                        }
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("4ckAs", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagsContainer", () => $a3f797de5e267654$export$c518a6c3736e9db7);
$parcel$export(module.exports, "useFeatureFlags", () => $a3f797de5e267654$export$90335b3ff08f335);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9u6WY = parcelRequire("9u6WY");

var $ay9Yf = parcelRequire("ay9Yf");
const $a3f797de5e267654$var$useFeatureFlagsContainerState = ()=>{
    return (0, $9u6WY.activeFeatures)();
};
const $a3f797de5e267654$var$FeatureFlagsContainerState = (0, $ay9Yf.createContainer)($a3f797de5e267654$var$useFeatureFlagsContainerState);
const $a3f797de5e267654$export$c518a6c3736e9db7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a3f797de5e267654$var$FeatureFlagsContainerState.Provider, {
        children: children
    });
};
const $a3f797de5e267654$export$90335b3ff08f335 = $a3f797de5e267654$var$FeatureFlagsContainerState.useContainer;

});
parcelRegister("9u6WY", function(module, exports) {

$parcel$export(module.exports, "activeFeatures", () => $13ea870cf7a6609c$export$a206a84b42e66eca);
const $13ea870cf7a6609c$export$a206a84b42e66eca = (hostname = window.location.hostname)=>{
    return {
        isProduction: hostname === "app.airplx.com",
        isStaging: hostname === "staging.airplx.com",
        isDev: hostname === "localhost",
        isConference: false,
        isMaintenance: false,
        maintenanceEndTime: `March 24 2023 9:15am EST`
    };
};

});



parcelRegister("lFx3G", function(module, exports) {

$parcel$export(module.exports, "RampPrintLayout", () => $5bbdfb6d1c5d8785$export$45a6ce3663afcd06);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");


var $ZD2ym = parcelRequire("ZD2ym");

var $4ckAs = parcelRequire("4ckAs");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");
const $5bbdfb6d1c5d8785$export$45a6ce3663afcd06 = ({ ramp: currentRamp, stack: stack, subtitle: subtitle })=>{
    const { isConference: isConference } = (0, $4ckAs.useFeatureFlags)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const ramp = {
        ...currentRamp,
        stack: stack
    };
    const width = $acw62.useMemo(()=>{
        const standardWidth = 800;
        const standardDepth = 800;
        if (ramp.depth >= ramp.width) {
            const ratio = ramp.width / ramp.depth;
            return standardDepth * ratio;
        }
        return standardWidth;
    }, []);
    const dimensions = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(ramp.width), 2)}w x ${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(ramp.depth), 2)}d` : `${ramp.width}w x ${ramp.depth}d`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                        type: "text/css",
                        media: "print",
                        children: `@page { size: ${ramp.depth > ramp.width ? "portrait" : "landscape"}; }`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        children: subtitle ? `${ramp.name}: ${subtitle}` : ramp.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: dimensions
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                direction: "row",
                                justifyContent: "flex-end",
                                spacing: 1,
                                sx: {
                                    width: 500,
                                    height: 50
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "subtitle1",
                                            children: "Aircraft"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: stack.tenants.length
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                        width: width,
                        location: {
                            type: "ramp",
                            ...ramp
                        },
                        stack: stack,
                        setStack: ()=>null,
                        options: {
                            hideUnplaced: false,
                            readOnly: true,
                            printable: true,
                            selectable: false
                        }
                    })
                ]
            }),
            isConference && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                justifyContent: "right",
                alignItems: "center",
                sx: {
                    position: "absolute",
                    right: 0,
                    bottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        align: "right",
                        children: [
                            "Automatically optimized by",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Contact us at www.airplx.com or peter@airplx.com."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, {}),
                        style: {
                            width: 175
                        }
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("9cfaq", function(module, exports) {

$parcel$export(module.exports, "SingleLocationSave", () => $107b7be041ad7854$export$bf10af84445fa9cb);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");
const $107b7be041ad7854$export$bf10af84445fa9cb = ({ location: location, setLocation: setLocation, name: name, setName: setName, setOpenNameField: setOpenNameField, setConfirm: setConfirm })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        sx: {
            minWidth: 400
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "row",
            spacing: 2,
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    type: "text",
                    size: "small",
                    label: "Name",
                    fullWidth: true,
                    value: name,
                    onChange: (e)=>setName(e.target.value)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    onClick: ()=>setOpenNameField(false),
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "contained",
                    color: "success",
                    disabled: name.length === 0,
                    onClick: ()=>{
                        const save = (stackId)=>{
                            setOpenNameField(false);
                            const favoriteStack = {
                                id: stackId,
                                location_id: location.location_id,
                                isReference: false,
                                name: name,
                                tenants: location.stack.tenants.map((t)=>({
                                        ...t,
                                        position: {
                                            ...t.position,
                                            id: (0, $lNEp2.uuidv4)(),
                                            stack_id: stackId,
                                            entity_id: t.entity_id
                                        }
                                    })),
                                movableObstacles: location.stack.movableObstacles.map((mo)=>({
                                        ...mo,
                                        position: {
                                            ...mo.position,
                                            id: (0, $lNEp2.uuidv4)(),
                                            stack_id: stackId,
                                            entity_id: mo.entity_id
                                        }
                                    })),
                                options: {
                                    // these are the defaults
                                    wall_spacing_left: 2,
                                    wall_spacing_back: 2,
                                    wall_spacing_right: 2,
                                    horizontal_spacing: activeFBO?.sop_horizontal_spacing ?? 0,
                                    vertical_spacing: activeFBO?.sop_vertical_spacing ?? 0,
                                    overlap: activeFBO?.sop_overlap ?? false,
                                    tug_spacing: 10,
                                    density_threshold: 0.8,
                                    towing_equipment_id: null,
                                    corner_strategy: [
                                        (0, $keHtM.CornerStrategy).ANGLE_45,
                                        (0, $keHtM.CornerStrategy).ANGLE_45
                                    ],
                                    cloud_position_prioritization: true,
                                    sample_size: 1000,
                                    xy_weights: [
                                        1,
                                        2
                                    ]
                                }
                            };
                            setLocation({
                                ...location,
                                stacks: [
                                    ...location.stacks.filter((s)=>s.id !== stackId),
                                    favoriteStack
                                ]
                            });
                        };
                        const stackId = location.stacks.find((s)=>s?.name === name)?.id;
                        if (stackId) {
                            setConfirm({
                                open: true,
                                text: `A favorite named '${name}' already exists. Do you want to overwrite it?`,
                                okText: "Yes, overwrite it",
                                onOk: ()=>{
                                    save(stackId);
                                }
                            });
                            return;
                        }
                        save((0, $lNEp2.uuidv4)());
                    },
                    children: "Save"
                })
            ]
        })
    });
};

});



parcelRegister("8vQkJ", function(module, exports) {

$parcel$export(module.exports, "ViewSettings", () => $4eb66b424ee55df7$export$4d0b6d35abb3362d);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2esSG = parcelRequire("2esSG");
var $2iAqv = parcelRequire("2iAqv");
var $6el2W = parcelRequire("6el2W");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $iAtns = parcelRequire("iAtns");
var $eJ0JC = parcelRequire("eJ0JC");
var $9ZYXn = parcelRequire("9ZYXn");
var $cVXaD = parcelRequire("cVXaD");

var $acw62 = parcelRequire("acw62");

var $fu9Og = parcelRequire("fu9Og");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");

var $6AlVH = parcelRequire("6AlVH");

var $fC0pb = parcelRequire("fC0pb");
const $4eb66b424ee55df7$export$4d0b6d35abb3362d = ({ locationType: locationType, isScheduledView: isScheduledView = false, location: location, onLocationUpdate: onLocationUpdate })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { towingEquipments: towingEquipments } = (0, $6AlVH.useTowingEquipmentState)();
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const { preferences: preferences, setPreferences: setPreferences } = (0, $fC0pb.useUserPreferences)();
    const isAutoParkEnabled = activeFBO?.settings?.enableAutoParking ?? false;
    const showCoPilot = locationType === "hangar" && activeFBO?.subscription.includes("autostacking");
    const handleTugChange = async (evt)=>{
        const newTugId = evt.target.value || null;
        if (!location) {
            snackbar.notify({
                text: "Location not available",
                severity: "error"
            });
            return;
        }
        try {
            if (locationType === "hangar") await postgrest.from("hangar").update({
                towing_equipment_id: newTugId
            }).eq("id", location.id);
            else if (locationType === "ramp") await postgrest.from("ramp").update({
                towing_equipment_id: newTugId
            }).eq("id", location.id);
            snackbar.notify({
                text: `Tug updated for ${location.name}`,
                severity: "success"
            });
            onLocationUpdate?.();
        } catch (error) {
            console.error("Failed to update tug:", error);
            snackbar.notify({
                text: "Failed to update tug",
                severity: "error"
            });
        }
    };
    const fboDefaultTug = towingEquipments?.find((t)=>t.is_default);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                variant: "contained",
                color: "info",
                onClick: handleClick,
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                    name: "TuneIcon"
                }),
                sx: {
                    "@media (max-width: 1300px)": {
                        display: "none"
                    }
                },
                children: "View Settings"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                color: "info",
                variant: "contained",
                onClick: handleClick,
                sx: {
                    "@media (min-width: 1300px)": {
                        display: "none"
                    },
                    mr: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                    name: "TuneIcon"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
                "data-testid": "view_settings",
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    alignItems: "flex-end",
                    sx: {
                        p: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "Display tail number on aircraft",
                            placement: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    "data-testid": "toggle_tail_number",
                                    color: "primary",
                                    checked: preferences.forceDisplayTailNumber ?? false,
                                    onChange: ()=>setPreferences({
                                            ...preferences,
                                            forceDisplayTailNumber: !preferences.forceDisplayTailNumber
                                        })
                                }),
                                label: "Tail #",
                                labelPlacement: "start"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "To see single note vs all notes, go to Settings > Configuration",
                            placement: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    color: "primary",
                                    checked: preferences.notes ?? false,
                                    onChange: ()=>setPreferences({
                                            ...preferences,
                                            notes: !preferences.notes
                                        })
                                }),
                                label: "Notes",
                                labelPlacement: "start"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "Display aircraft model on aircraft",
                            placement: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    "data-testid": "toggle_model",
                                    color: "primary",
                                    checked: preferences.forceDisplayModel ?? false,
                                    onChange: ()=>setPreferences({
                                            ...preferences,
                                            forceDisplayModel: !preferences.forceDisplayModel
                                        })
                                }),
                                label: "Model",
                                labelPlacement: "start"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "Horizontal spacing outline",
                            placement: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    "data-testid": "toggle_sop_spacing",
                                    color: "primary",
                                    checked: preferences.showSOPSpacing ?? false,
                                    onChange: ()=>setPreferences({
                                            ...preferences,
                                            showSOPSpacing: !preferences.showSOPSpacing
                                        })
                                }),
                                label: "SOP Spacing",
                                labelPlacement: "start"
                            })
                        }),
                        locationType === "hangar" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Wall spacing visual fill areas",
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                            "data-testid": "toggle_wall_spacing_fill",
                                            color: "primary",
                                            checked: preferences.showWallSpacingFill ?? false,
                                            onChange: ()=>setPreferences({
                                                    ...preferences,
                                                    showWallSpacingFill: !preferences.showWallSpacingFill
                                                })
                                        }),
                                        label: "Wall Spacing Fill",
                                        labelPlacement: "start"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Show bay boundaries for stepped-eave hangars",
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                            "data-testid": "toggle_bay_boundaries",
                                            color: "primary",
                                            checked: preferences.showBayBoundaries ?? false,
                                            onChange: ()=>setPreferences({
                                                    ...preferences,
                                                    showBayBoundaries: !preferences.showBayBoundaries
                                                })
                                        }),
                                        label: "Bay Boundaries",
                                        labelPlacement: "start"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "Highlights all overlaps, doesn't evaluate vertical spacing safety",
                            placement: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    "data-testid": "toggle_overlap",
                                    color: "primary",
                                    checked: preferences.showOverlaps ?? false,
                                    onChange: ()=>setPreferences({
                                            ...preferences,
                                            showOverlaps: !preferences.showOverlaps
                                        })
                                }),
                                label: "Overlaps",
                                labelPlacement: "start"
                            })
                        }),
                        showCoPilot && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "Select unstacked aircraft and get SOP-compliant options",
                            placement: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                disabled: !activeFBO?.subscription.includes("autostacking"),
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    "data-testid": "toggle_copilot",
                                    color: "primary",
                                    checked: preferences.enableCoPilot ?? false,
                                    onChange: ()=>setPreferences({
                                            ...preferences,
                                            enableCoPilot: !preferences.enableCoPilot
                                        })
                                }),
                                label: "Co-Pilot",
                                labelPlacement: "start"
                            })
                        }),
                        locationType === "hangar" && location && towingEquipments && towingEquipments.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                            select: true,
                            label: "Tug",
                            value: location.towing_equipment_id || "",
                            size: "small",
                            sx: {
                                minWidth: 200
                            },
                            InputLabelProps: {
                                shrink: true
                            },
                            SelectProps: {
                                displayEmpty: true,
                                onChange: handleTugChange,
                                renderValue: (value)=>{
                                    if (!value) return `Use FBO Default (${fboDefaultTug?.name || "None"})`;
                                    const tug = towingEquipments.find((t)=>t.towing_equipment_id === value);
                                    return tug?.name || value;
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                    value: "",
                                    children: [
                                        "Use FBO Default (",
                                        fboDefaultTug?.name || "None",
                                        ")"
                                    ]
                                }),
                                towingEquipments.filter((t)=>t.in_use).map((tug)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        value: tug.towing_equipment_id,
                                        children: tug.name
                                    }, tug.towing_equipment_id))
                            ]
                        }),
                        locationType === "ramp" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Display parking spots on ramp",
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                            "data-testid": "toggle_spots",
                                            color: "primary",
                                            checked: preferences.showSpots ?? false,
                                            onChange: ()=>setPreferences({
                                                    ...preferences,
                                                    showSpots: !preferences.showSpots
                                                })
                                        }),
                                        label: "Spots",
                                        labelPlacement: "start"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Overlay ramp satellite image",
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                            "data-testid": "toggle_ramp_reference_image",
                                            color: "primary",
                                            checked: preferences.showRampReferenceImage ?? false,
                                            onChange: ()=>setPreferences({
                                                    ...preferences,
                                                    showRampReferenceImage: !preferences.showRampReferenceImage
                                                })
                                        }),
                                        label: "Ramp Image",
                                        labelPlacement: "start"
                                    })
                                }),
                                isScheduledView && isAutoParkEnabled && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: `Show zone occupancy heatmap (next ${preferences.heatmapHorizonHours || 72}h)`,
                                            placement: "right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                                    "data-testid": "toggle_zone_heatmap",
                                                    color: "primary",
                                                    checked: preferences.showZoneHeatmap ?? false,
                                                    onChange: ()=>setPreferences({
                                                            ...preferences,
                                                            showZoneHeatmap: !preferences.showZoneHeatmap
                                                        })
                                                }),
                                                label: "Zone Heatmap",
                                                labelPlacement: "start"
                                            })
                                        }),
                                        preferences.showZoneHeatmap && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            sx: {
                                                pl: 7,
                                                pb: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ZYXn.default), {
                                                size: "small",
                                                value: preferences.heatmapHorizonHours || 72,
                                                exclusive: true,
                                                onChange: (e, value)=>{
                                                    if (value !== null) setPreferences({
                                                        ...preferences,
                                                        heatmapHorizonHours: value
                                                    });
                                                },
                                                sx: {
                                                    height: 28
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJ0JC.default), {
                                                        value: 24,
                                                        children: "24h"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJ0JC.default), {
                                                        value: 72,
                                                        children: "72h"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJ0JC.default), {
                                                        value: 168,
                                                        children: "1w"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                location && towingEquipments && towingEquipments.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                    select: true,
                                    label: "Tug",
                                    value: location.towing_equipment_id || "",
                                    size: "small",
                                    sx: {
                                        minWidth: 200
                                    },
                                    InputLabelProps: {
                                        shrink: true
                                    },
                                    SelectProps: {
                                        displayEmpty: true,
                                        onChange: handleTugChange,
                                        renderValue: (value)=>{
                                            if (!value) return `Use FBO Default (${fboDefaultTug?.name || "None"})`;
                                            const tug = towingEquipments.find((t)=>t.towing_equipment_id === value);
                                            return tug?.name || value;
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                            value: "",
                                            children: [
                                                "Use FBO Default (",
                                                fboDefaultTug?.name || "None",
                                                ")"
                                            ]
                                        }),
                                        towingEquipments.filter((t)=>t.in_use).map((tug)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: tug.towing_equipment_id,
                                                children: tug.name
                                            }, tug.towing_equipment_id))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});



parcelRegister("jbTvW", function(module, exports) {

$parcel$export(module.exports, "AircraftFinder", () => $1cf8c920ac492c5d$export$c2ddd87966f41ebd);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jO6ya = parcelRequire("jO6ya");

var $le4Y6 = parcelRequire("le4Y6");

var $2P5BT = parcelRequire("2P5BT");

var $cFBau = parcelRequire("cFBau");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $hViLc = parcelRequire("hViLc");
var $6el2W = parcelRequire("6el2W");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $3XcNI = parcelRequire("3XcNI");
const $1cf8c920ac492c5d$export$c2ddd87966f41ebd = ({ mini: mini, ...props })=>{
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "searchPopover" : undefined;
    if (mini) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: "Find aircraft",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    size: "small",
                    variant: "contained",
                    color: "info",
                    onClick: handleClick,
                    sx: {
                        alignSelf: "center",
                        width: "80%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        alignItems: "center",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($le4Y6))), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    width: 300,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1cf8c920ac492c5d$var$AircraftFinderAutocomplete, {
                        ...props
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1cf8c920ac492c5d$var$AircraftFinderAutocomplete, {
        ...props
    });
};
const $1cf8c920ac492c5d$var$AircraftFinderAutocomplete = ({ tenants: tenants, onSelect: onSelect })=>{
    const [inputValue, setInputValue] = $acw62.useState("");
    const options = $acw62.useMemo(()=>tenants.sort((a, b)=>{
            const cmpTail = a.tail_number.localeCompare(b.tail_number);
            if (cmpTail !== 0) return cmpTail;
            return a.aircraft.model.localeCompare(b.aircraft.model);
        }), [
        tenants.length
    ]);
    // Custom filter function to handle hyphen-flexible tail number matching
    const filterOptions = $acw62.useCallback((options, state)=>{
        const query = state.inputValue;
        if (!query) return options;
        return options.filter((option)=>(0, $3XcNI.tailNumberIncludes)(option.tail_number, query) || option.aircraft.model.toLowerCase().includes(query.toLowerCase()));
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            px: 1.5,
            pb: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
            fullWidth: true,
            size: "small",
            popupIcon: null,
            inputValue: inputValue,
            onInputChange: (event, newInputValue)=>{
                setInputValue(newInputValue);
            },
            onChange: (event, newValue)=>{
                if (!newValue || !newValue?.id) return;
                onSelect(newValue);
            },
            options: options,
            filterOptions: filterOptions,
            getOptionLabel: (option)=>{
                return option.tail_number ?? "";
            },
            renderOption: (props, option)=>{
                const isInHangar = tenants.find((tenant)=>tenant.id === option.id);
                let text = "";
                if (!option.tail_number) text = `${option.aircraft.model}`;
                else text = `${option.tail_number} - ${option.aircraft.model}`;
                return /*#__PURE__*/ (0, $acw62.createElement)("li", {
                    ...props,
                    key: `search-hangars-${option.id}`,
                    style: {
                        backgroundColor: isInHangar ? `#c8cfde40` : "transparent"
                    }
                }, /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "inherit",
                    children: text
                }));
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    ...params,
                    variant: "outlined",
                    placeholder: "Search for aircraft",
                    InputProps: {
                        ...params.InputProps,
                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                            position: "start",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                        }),
                        endAdornment: inputValue && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                            position: "end",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                size: "small",
                                onClick: ()=>setInputValue(""),
                                edge: "end",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jO6ya))), {})
                            })
                        })
                    }
                })
        })
    });
};

});

parcelRegister("14j5W", function(module, exports) {

$parcel$export(module.exports, "AutoPark", () => $35aa15d6398fa6e2$export$811b029517bf743a);

var $ayMG0 = parcelRequire("ayMG0");

var $exFSQ = parcelRequire("exFSQ");

var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $jYWTx = parcelRequire("jYWTx");
parcelRequire("ais5p");
var $e8Zsn = parcelRequire("e8Zsn");

var $8a5rg = parcelRequire("8a5rg");

var $5s57J = parcelRequire("5s57J");

var $lcj2t = parcelRequire("lcj2t");

var $e2U90 = parcelRequire("e2U90");

var $5o4Wz = parcelRequire("5o4Wz");

var $bnXem = parcelRequire("bnXem");

var $dLqAw = parcelRequire("dLqAw");
const $35aa15d6398fa6e2$export$811b029517bf743a = ({ ramp: ramp, stack: stack, setStack: setStack, isScheduledView: isScheduledView, placementService: placementService, currentTime: currentTime, postgrest: postgrest, fbo: fbo, onScheduledUpdate: onScheduledUpdate, isDrawerOpen: isDrawerOpen = true })=>{
    const { dialogOpen: dialogOpen, parkingConfig: parkingConfig, handleOpenDialog: handleOpenDialog, handleCloseDialog: handleCloseDialog, handleAutoPark: handleAutoPark, handleParkNext: handleParkNext, logDialogOpen: logDialogOpen, handleOpenLogDialog: handleOpenLogDialog, handleCloseLogDialog: handleCloseLogDialog, lastResult: lastResult, timeRange: timeRange, handleTimeRangeChange: handleTimeRangeChange, tripCount: tripCount, placements: placements, groupedTrips: groupedTrips, selectedTripIds: selectedTripIds, handleToggleTripSelection: handleToggleTripSelection, handleApplyResults: handleApplyResults, isApplying: isApplying, applyProgress: applyProgress, handleScheduleChanged: handleScheduleChanged } = (0, $dLqAw.useAutoPark)(ramp, stack, setStack, isScheduledView, placementService, currentTime, postgrest, fbo, onScheduledUpdate);
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    // Check both FBO-wide setting and per-ramp setting
    const isFBOAutoParkingEnabled = activeFBO?.settings?.enableAutoParking ?? false;
    const isRampAutoParkingEnabled = ramp.autoparking_enabled ?? false;
    const isEnabled = isFBOAutoParkingEnabled && isRampAutoParkingEnabled;
    // If FBO-wide setting is disabled, don't show any auto parking UI
    if (!isFBOAutoParkingEnabled) return null;
    // State for last-minute insertion dialog (Phase 7)
    const [lastMinuteDialogOpen, setLastMinuteDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Calculate if we have aircraft without spots (for button enabled state)
    const hasUnplacedAircraft = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // Helper: Check if aircraft has a spot assigned
        const hasSpot = (tenant)=>{
            if (tenant.position.x === null || tenant.position.y === null) return false; // Unplaced = no spot
            // Build legacy spots from ramp shapes
            const spotShapes = ramp.shapes?.filter((s)=>s.type === "Spot") || [];
            const legacySpots = spotShapes.map((shape)=>({
                    points: shape.points,
                    referencePoints: shape.reference_points || []
                }));
            // Transform position from top-left origin to bottom-left origin
            // (getSpotForPositionLegacy expects bottom-left origin coordinates)
            const transformedPosition = {
                x: tenant.position.x,
                y: ramp.depth - tenant.position.y,
                // Y-flip transformation
                angle: tenant.position.angle
            };
            // Use getSpotForPositionLegacy to check if aircraft is in a spot
            const result = (0, $jYWTx.getSpotForPositionLegacy)(tenant, transformedPosition, // Use transformed position
            legacySpots, {});
            return result !== undefined;
        };
        // Check if selected aircraft doesn't have a spot
        const selectedAircraft = stack.tenants.find((t)=>t.selected);
        if (selectedAircraft && !hasSpot(selectedAircraft)) return true;
        // Check if any aircraft doesn't have a spot
        return stack.tenants.some((t)=>!hasSpot(t));
    }, [
        stack.tenants,
        ramp.shapes,
        ramp.depth
    ]);
    // Build parking requests for decision log viewer
    // Use requests from temporalData if available (temporal parking)
    // Otherwise reconstruct from stack/placements (snapshot parking)
    const parkingRequests = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!lastResult) return [];
        // If we have temporal data, use the exact requests from the algorithm
        if ("temporalData" in lastResult && lastResult.temporalData?.requests) return lastResult.temporalData.requests;
        // Fallback for snapshot parking: reconstruct from stack
        return stack.tenants.map((tenant)=>({
                id: tenant.id,
                tail_number: tenant.tail_number,
                sizeCategory: (0, $8a5rg.aircraftToSizeCategory)(tenant.aircraft),
                arrivalBucket: 0,
                departureBucket: 1,
                aircraft: tenant.aircraft
            }));
    }, [
        lastResult,
        stack.tenants
    ]);
    const compact = !isDrawerOpen;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                alignItems: compact ? "center" : "stretch",
                sx: {
                    mb: 1
                },
                children: compact ? // Collapsed: Vertical stack of icon buttons
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lcj2t.AutoParkButton), {
                            onClick: handleOpenDialog,
                            disabled: !isEnabled,
                            disabledMessage: "AutoParking is not enabled for this ramp. Enable it in the ramp settings.",
                            compact: compact,
                            inGroup: false
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnXem.ParkNextButton), {
                            onClick: handleParkNext,
                            disabled: !isEnabled || !hasUnplacedAircraft,
                            disabledMessage: !isEnabled ? "AutoParking is not enabled for this ramp." : "No unplaced aircraft available.",
                            compact: compact,
                            inGroup: false
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                            title: "Check Fit",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>setLastMinuteDialogOpen(true),
                                    disabled: !isScheduledView,
                                    color: "primary",
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exFSQ))), {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2U90.DecisionLogButton), {
                            onClick: handleOpenLogDialog,
                            disabled: !lastResult || lastResult.decisionLog.length === 0
                        })
                    ]
                }) : // Expanded: All buttons on single row
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lcj2t.AutoParkButton), {
                            onClick: handleOpenDialog,
                            disabled: !isEnabled,
                            disabledMessage: "AutoParking is not enabled for this ramp. Enable it in the ramp settings.",
                            compact: false,
                            inGroup: false
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnXem.ParkNextButton), {
                            onClick: handleParkNext,
                            disabled: !isEnabled || !hasUnplacedAircraft,
                            disabledMessage: !isEnabled ? "AutoParking is not enabled for this ramp." : "No unplaced aircraft available.",
                            compact: false,
                            inGroup: false
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>setLastMinuteDialogOpen(true),
                            disabled: !isScheduledView,
                            variant: "outlined",
                            color: "primary",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exFSQ))), {}),
                            size: "small",
                            children: "Check Fit"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2U90.DecisionLogButton), {
                            onClick: handleOpenLogDialog,
                            disabled: !lastResult || lastResult.decisionLog.length === 0
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5s57J.AutoParkDialog), {
                open: dialogOpen,
                onClose: handleCloseDialog,
                config: parkingConfig.config,
                onConfigChange: (updates)=>{
                    if (updates.bufferMinutes !== undefined) parkingConfig.setBufferMinutes(updates.bufferMinutes);
                    if (updates.plannedMoveCap !== undefined) parkingConfig.setPlannedMoveCap(updates.plannedMoveCap);
                    if (updates.allowTrapping !== undefined) parkingConfig.setAllowTrapping(updates.allowTrapping);
                    if (updates.egressWeight !== undefined) parkingConfig.setEgressWeight(updates.egressWeight);
                    if (updates.wasteWeight !== undefined) parkingConfig.setWasteWeight(updates.wasteWeight);
                    if (updates.structuralWeight !== undefined) parkingConfig.setStructuralWeight(updates.structuralWeight);
                    if (updates.zonePriorityWeight !== undefined) parkingConfig.setZonePriorityWeight(updates.zonePriorityWeight);
                    if (updates.min_dwell_weight !== undefined) parkingConfig.setMinDwellWeight(updates.min_dwell_weight);
                    if (updates.sortingStrategy !== undefined) parkingConfig.setSortingStrategy(updates.sortingStrategy);
                    if (updates.arrivalStagingDwellMinutes !== undefined) parkingConfig.setArrivalStagingDwellMinutes(updates.arrivalStagingDwellMinutes);
                    if (updates.departureStagingDwellMinutes !== undefined) parkingConfig.setDepartureStagingDwellMinutes(updates.departureStagingDwellMinutes);
                    if (updates.quickTurnThresholdMinutes !== undefined) parkingConfig.setQuickTurnThresholdMinutes(updates.quickTurnThresholdMinutes);
                },
                onRunAutoPark: handleAutoPark,
                isScheduledView: isScheduledView,
                timeRange: timeRange,
                onTimeRangeChange: handleTimeRangeChange,
                tripCount: tripCount,
                placements: placements,
                groupedTrips: groupedTrips,
                selectedTripIds: selectedTripIds,
                onToggleTripSelection: handleToggleTripSelection
            }),
            lastResult && logDialogOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5o4Wz.DecisionLogDialog), {
                open: logDialogOpen,
                onClose: handleCloseLogDialog,
                decisionLog: lastResult.decisionLog,
                requests: parkingRequests,
                rampShapes: ramp.shapes,
                spots: 'temporalData' in lastResult ? lastResult.temporalData?.spots : undefined,
                placement: lastResult.placement,
                zones: 'temporalData' in lastResult ? lastResult.temporalData?.zones : undefined,
                horizonHours: 'temporalData' in lastResult ? lastResult.temporalData?.horizonHours : undefined,
                startTime: 'temporalData' in lastResult ? lastResult.temporalData?.startTime : undefined,
                partialPlacements: 'temporalData' in lastResult ? lastResult.temporalData?.partialPlacements : undefined,
                statistics: lastResult.statistics,
                onApply: isScheduledView ? handleApplyResults : undefined,
                isApplying: isApplying,
                applyProgress: applyProgress,
                showDetailedView: fbo?.settings.displayDetailedDecisionLog ?? false,
                onScheduleChanged: handleScheduleChanged
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8Zsn.AddLastMinuteTripDialog), {
                open: lastMinuteDialogOpen,
                onClose: ()=>setLastMinuteDialogOpen(false),
                ramp: ramp,
                stack: stack,
                placements: placements,
                currentTime: currentTime
            })
        ]
    });
};

});
parcelRegister("exFSQ", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a964a2f20652464a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a964a2f20652464a$var$_createSvgIcon = $a964a2f20652464a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a964a2f20652464a$var$_default = module.exports.default = (0, $a964a2f20652464a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m9.78 11.16-1.42 1.42c-.68-.69-1.34-1.58-1.79-2.94l1.94-.49c.32.89.77 1.5 1.27 2.01M11 6 7 2 3 6h3.02c.02.81.08 1.54.19 2.17l1.94-.49C8.08 7.2 8.03 6.63 8.02 6zm10 0-4-4-4 4h2.99c-.1 3.68-1.28 4.75-2.54 5.88-.5.44-1.01.92-1.45 1.55-.34-.49-.73-.88-1.13-1.24L9.46 13.6c.93.85 1.54 1.54 1.54 3.4v5h2v-5c0-2.02.71-2.66 1.79-3.63 1.38-1.24 3.08-2.78 3.2-7.37z"
}), 'AltRoute');

});

parcelRegister("ais5p", function(module, exports) {

$parcel$export(module.exports, "AddLastMinuteTripDialog", () => (parcelRequire("e8Zsn")).AddLastMinuteTripDialog);
/**
 * Last-Minute Insertion UI Components
 * Phase 7 - Preview-only dialog for checking trip insertion feasibility
 */ 
var $e8Zsn = parcelRequire("e8Zsn");

});
parcelRegister("e8Zsn", function(module, exports) {

$parcel$export(module.exports, "AddLastMinuteTripDialog", () => $b491fc68b7f99181$export$113fdabdefc04ea4);
/**
 * Add Last-Minute Trip Dialog - Phase 7
 * Preview-only dialog for checking if new trip can fit
 * Shows three-tier result: zero-disruption / local-repair / failed
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lCWOH = parcelRequire("lCWOH");

var $aF8PJ = parcelRequire("aF8PJ");

var $iwiZ3 = parcelRequire("iwiZ3");
var $cFBau = parcelRequire("cFBau");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $19ocJ = parcelRequire("19ocJ");
var $jU0bc = parcelRequire("jU0bc");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $78ow6 = parcelRequire("78ow6");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $kCLFX = parcelRequire("kCLFX");

var $hWiqZ = parcelRequire("hWiqZ");

var $8a5rg = parcelRequire("8a5rg");
function $b491fc68b7f99181$export$113fdabdefc04ea4({ open: open, onClose: onClose, ramp: ramp, stack: stack, placements: placements, currentTime: currentTime }) {
    const defaultStart = currentTime || new Date();
    const [selectedTenant, setSelectedTenant] = (0, $acw62.useState)(null);
    const [startTime, setStartTime] = (0, $acw62.useState)(defaultStart);
    const [endTime, setEndTime] = (0, $acw62.useState)((0, $kCLFX.addHours)(defaultStart, 4));
    const [maxDisruption, setMaxDisruption] = (0, $acw62.useState)(2);
    const [previewResult, setPreviewResult] = (0, $acw62.useState)(null);
    // Reset state when dialog opens
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setSelectedTenant(null);
            setStartTime(currentTime || new Date());
            setEndTime((0, $kCLFX.addHours)(currentTime || new Date(), 4));
            setMaxDisruption(2);
            setPreviewResult(null);
        }
    }, [
        open,
        currentTime
    ]);
    // Get tenant options from stack (both placed and unplaced)
    const tenantOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return stack.tenants.filter((t)=>t.aircraft != null);
    }, [
        stack.tenants
    ]);
    const handlePreview = ()=>{
        if (!selectedTenant || !selectedTenant.aircraft) return;
        // Validate time range
        if (startTime >= endTime) {
            alert("Start time must be before end time");
            return;
        }
        try {
            const result = (0, $8a5rg.runLastMinuteInsertionOnRamp)(ramp, stack, {
                aircraft: selectedTenant.aircraft,
                startTime: startTime,
                endTime: endTime,
                trip_id: selectedTenant.id // Ensure placement key matches lookup key
            }, {
                maxDisruption: maxDisruption,
                startTime: currentTime || new Date(),
                horizonHours: 24
            });
            setPreviewResult(result);
        } catch (error) {
            console.error("[AddLastMinuteTrip] Preview error:", error);
            alert(`Preview failed: ${error instanceof Error ? error.message : "Unknown error"}`);
        }
    };
    // Helper: Get tail number from aircraft ID
    const getTailNumber = (aircraftId)=>{
        const placement = placements.find((p)=>p.id === aircraftId);
        return placement?.tail_number || aircraftId;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
        dateAdapter: (0, $78ow6.AdapterDateFns),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
            open: open,
            onClose: onClose,
            maxWidth: "sm",
            fullWidth: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                    children: "Add Last-Minute Trip - Preview"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 3,
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle2",
                                        gutterBottom: true,
                                        children: "Aircraft"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                        value: selectedTenant,
                                        onChange: (_, value)=>setSelectedTenant(value),
                                        options: tenantOptions,
                                        getOptionLabel: (tenant)=>`${tenant.tail_number} - ${tenant.aircraft?.model || "Unknown"}`,
                                        renderOption: (props, tenant)=>{
                                            // Calculate status info for this tenant
                                            let statusLabel = "Unplaced";
                                            let statusColor = undefined;
                                            let statusVariant = "outlined";
                                            let statusIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lCWOH))), {});
                                            if (tenant.position.x !== null && tenant.position.y !== null) {
                                                // Find which spot tenant is in
                                                const spotId = (0, $hWiqZ.findSpotForPosition)(tenant.position, ramp.shapes, ramp.depth);
                                                // Look up spot name from shapes (name stored in .text property)
                                                const spot = ramp.shapes.find((s)=>s.id === spotId);
                                                const spotName = spot?.text || "Spot Unknown";
                                                statusLabel = spotName;
                                                statusColor = "info";
                                                statusVariant = "outlined";
                                                statusIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aF8PJ))), {});
                                            }
                                            return /*#__PURE__*/ (0, $acw62.createElement)("li", {
                                                ...props,
                                                key: tenant.id
                                            }, /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "100%",
                                                    gap: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                        sx: {
                                                            flex: 1
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            children: [
                                                                tenant.tail_number,
                                                                " -",
                                                                " ",
                                                                tenant.aircraft?.model || "Unknown"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                        label: statusLabel,
                                                        size: "small",
                                                        color: statusColor,
                                                        variant: statusVariant,
                                                        icon: statusIcon
                                                    })
                                                ]
                                            }));
                                        },
                                        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                ...params,
                                                placeholder: "Select aircraft..."
                                            }),
                                        fullWidth: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle2",
                                                gutterBottom: true,
                                                children: "Arrival Time"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                                value: startTime,
                                                onChange: (newValue)=>newValue && setStartTime(newValue),
                                                ampm: false,
                                                slotProps: {
                                                    textField: {
                                                        fullWidth: true
                                                    }
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle2",
                                                gutterBottom: true,
                                                children: "Departure Time"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                                value: endTime,
                                                onChange: (newValue)=>newValue && setEndTime(newValue),
                                                ampm: false,
                                                slotProps: {
                                                    textField: {
                                                        fullWidth: true
                                                    }
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "subtitle2",
                                        gutterBottom: true,
                                        children: [
                                            "Max Aircraft Moves: ",
                                            maxDisruption
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jU0bc.default), {
                                        value: maxDisruption,
                                        onChange: (_, val)=>setMaxDisruption(val),
                                        min: 0,
                                        max: 5,
                                        step: 1,
                                        marks: [
                                            {
                                                value: 0,
                                                label: "Zero"
                                            },
                                            {
                                                value: 2,
                                                label: "2"
                                            },
                                            {
                                                value: 5,
                                                label: "Max"
                                            }
                                        ],
                                        valueLabelDisplay: "auto"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                onClick: handlePreview,
                                disabled: !selectedTenant,
                                fullWidth: true,
                                children: "Check Availability"
                            }),
                            previewResult && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                children: [
                                    previewResult.insertionAnalysis.tier === "zero-disruption" && (()=>{
                                        // Extract spot name from placement result
                                        const placement = previewResult.insertionAnalysis.placement?.[selectedTenant?.id || ""];
                                        const spotId = placement && "spotId" in placement ? placement.spotId : null;
                                        const spot = ramp.shapes.find((s)=>s.id === spotId);
                                        const spotName = spot?.text || "Spot Unknown";
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                                            severity: "success",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    fontWeight: 500,
                                                    children: [
                                                        "Can fit in ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: spotName
                                                        }),
                                                        " with ZERO disruption!"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    children: [
                                                        selectedTenant?.tail_number,
                                                        " can be placed without moving any existing aircraft."
                                                    ]
                                                })
                                            ]
                                        });
                                    })(),
                                    previewResult.insertionAnalysis.tier === "local-repair" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                                        severity: "warning",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "body2",
                                                fontWeight: 500,
                                                gutterBottom: true,
                                                children: [
                                                    "Requires moving",
                                                    " ",
                                                    previewResult.insertionAnalysis.totalMoves,
                                                    " aircraft:"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
                                                dense: true,
                                                sx: {
                                                    mt: 1
                                                },
                                                children: previewResult.insertionAnalysis.disruptedAircraft.map((id)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                                                        sx: {
                                                            py: 0
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                                            primary: getTailNumber(id),
                                                            primaryTypographyProps: {
                                                                variant: "body2"
                                                            }
                                                        })
                                                    }, id))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                sx: {
                                                    mt: 1,
                                                    display: "block"
                                                },
                                                children: [
                                                    "These aircraft would need to be moved to make space for",
                                                    " ",
                                                    selectedTenant?.tail_number,
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    previewResult.insertionAnalysis.tier === "failed" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                                        severity: "error",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "body2",
                                                fontWeight: 500,
                                                gutterBottom: true,
                                                children: [
                                                    "Cannot fit within ",
                                                    maxDisruption,
                                                    " move",
                                                    maxDisruption !== 1 ? "s" : ""
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                sx: {
                                                    mt: 1
                                                },
                                                children: previewResult.insertionAnalysis.analysis.failureReason
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                sx: {
                                                    mt: 1,
                                                    display: "block"
                                                },
                                                children: "Try: Increase max disruption, adjust arrival/departure times, or use smaller aircraft."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: onClose,
                        children: "Close"
                    })
                })
            ]
        })
    });
}

});
parcelRegister("lCWOH", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $fbeac559a0537929$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbeac559a0537929$var$_createSvgIcon = $fbeac559a0537929$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $fbeac559a0537929$var$_default = module.exports.default = (0, $fbeac559a0537929$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84m4.37 9.6-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73z"
}), 'LocationOff');

});

parcelRegister("kCLFX", function(module, exports) {

$parcel$export(module.exports, "addHours", () => $ad7d7a6c940573d9$export$4a4306ad4fa0e5e6);

var $3iqQT = parcelRequire("3iqQT");

var $klgYS = parcelRequire("klgYS");
function $ad7d7a6c940573d9$export$4a4306ad4fa0e5e6(date, amount) {
    return (0, $3iqQT.addMilliseconds)(date, amount * (0, $klgYS.millisecondsInHour));
}
var // Fallback for modularized imports:
$ad7d7a6c940573d9$export$2e2bcd8739ae039 = $ad7d7a6c940573d9$export$4a4306ad4fa0e5e6;

});
parcelRegister("3iqQT", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", () => $4e48e89beadf9b6b$export$baf757aaf0c95c94);

var $9Jots = parcelRequire("9Jots");

var $bXANJ = parcelRequire("bXANJ");
function $4e48e89beadf9b6b$export$baf757aaf0c95c94(date, amount) {
    const timestamp = +(0, $9Jots.toDate)(date);
    return (0, $bXANJ.constructFrom)(date, timestamp + amount);
}
var // Fallback for modularized imports:
$4e48e89beadf9b6b$export$2e2bcd8739ae039 = $4e48e89beadf9b6b$export$baf757aaf0c95c94;

});




parcelRegister("5s57J", function(module, exports) {

$parcel$export(module.exports, "AutoParkDialog", () => $444a7fda36437644$export$359e7c99394bd970);

var $ayMG0 = parcelRequire("ayMG0");

var $euRCv = parcelRequire("euRCv");

var $dTjVb = parcelRequire("dTjVb");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2p5OG = parcelRequire("2p5OG");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");
var $3bYfT = parcelRequire("3bYfT");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $78ow6 = parcelRequire("78ow6");

var $7S0ew = parcelRequire("7S0ew");
var $4HKwc = parcelRequire("4HKwc");
var $lGkA3 = parcelRequire("lGkA3");
var $3WoNO = parcelRequire("3WoNO");

var $acw62 = parcelRequire("acw62");

var $lTOh0 = parcelRequire("lTOh0");

var $3tkEe = parcelRequire("3tkEe");

var $hLfsQ = parcelRequire("hLfsQ");
const $444a7fda36437644$export$359e7c99394bd970 = ({ open: open, onClose: onClose, config: config, onConfigChange: onConfigChange, onRunAutoPark: onRunAutoPark, isScheduledView: isScheduledView = false, timeRange: timeRange, onTimeRangeChange: onTimeRangeChange, tripCount: tripCount = 0, groupedTrips: groupedTrips = [], selectedTripIds: selectedTripIds, onToggleTripSelection: onToggleTripSelection })=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)(0);
    // Reset to Time Range tab whenever dialog opens
    (0, $acw62.useEffect)(()=>{
        if (open) setActiveTab(0);
    }, [
        open
    ]);
    // Calculate duration between start and end times
    const calculateDuration = (start, end)=>{
        const days = (0, $4HKwc.differenceInDays)(end, start);
        const hours = (0, $lGkA3.differenceInHours)(end, start) % 24;
        const minutes = (0, $3WoNO.differenceInMinutes)(end, start) % 60;
        if (days > 0) return `${days}d ${hours}h ${minutes}m`;
        else if (hours > 0) return `${hours}h ${minutes}m`;
        else return `${minutes}m`;
    };
    // Quick duration preset handlers
    const handleOneDayRange = ()=>{
        if (timeRange && onTimeRangeChange) {
            const newEnd = (0, $7S0ew.addDays)(timeRange.start, 1);
            onTimeRangeChange(timeRange.start, newEnd);
        }
    };
    const handleThreeDayRange = ()=>{
        if (timeRange && onTimeRangeChange) {
            const newEnd = (0, $7S0ew.addDays)(timeRange.start, 3);
            onTimeRangeChange(timeRange.start, newEnd);
        }
    };
    const handleSevenDayRange = ()=>{
        if (timeRange && onTimeRangeChange) {
            const newEnd = (0, $7S0ew.addDays)(timeRange.start, 7);
            onTimeRangeChange(timeRange.start, newEnd);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: "AutoPark Configuration"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                sx: {
                    maxHeight: "70vh",
                    overflowY: "auto"
                },
                children: isScheduledView ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $uaXRK.LocalizationProvider), {
                    dateAdapter: (0, $78ow6.AdapterDateFns),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                            value: activeTab,
                            onChange: (_, newValue)=>setActiveTab(newValue),
                            sx: {
                                borderBottom: 1,
                                borderColor: "divider",
                                mb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                    label: "Time Range"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                    label: "Algorithm"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                            value: activeTab,
                            index: 0,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 1.5,
                                        alignItems: "flex-end",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 1,
                                                sx: {
                                                    flexGrow: 1,
                                                    flexShrink: 1,
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "subtitle2",
                                                        color: "text.secondary",
                                                        children: "Start Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                                        value: timeRange?.start || new Date(),
                                                        onChange: (newValue)=>{
                                                            if (newValue && timeRange && onTimeRangeChange) onTimeRangeChange(newValue, timeRange.end);
                                                        },
                                                        ampm: false,
                                                        slotProps: {
                                                            textField: {
                                                                fullWidth: true,
                                                                size: "small"
                                                            }
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 1,
                                                sx: {
                                                    flexGrow: 1,
                                                    flexShrink: 1,
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "subtitle2",
                                                        color: "text.secondary",
                                                        children: "End Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                                                        value: timeRange?.end || new Date(),
                                                        onChange: (newValue)=>{
                                                            if (newValue && timeRange && onTimeRangeChange) onTimeRangeChange(timeRange.start, newValue);
                                                        },
                                                        ampm: false,
                                                        slotProps: {
                                                            textField: {
                                                                fullWidth: true,
                                                                size: "small"
                                                            }
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 1,
                                                sx: {
                                                    flexShrink: 0,
                                                    width: 90
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                        direction: "row",
                                                        spacing: 0.5,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTjVb))), {
                                                                fontSize: "small",
                                                                color: "action"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "subtitle2",
                                                                color: "text.secondary",
                                                                noWrap: true,
                                                                children: "Duration"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        fontWeight: 500,
                                                        noWrap: true,
                                                        sx: {
                                                            height: 40,
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: timeRange ? calculateDuration(timeRange.start, timeRange.end) : "\u2014"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                        direction: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        sx: {
                                            mt: -1
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2p5OG.default), {
                                            variant: "outlined",
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    onClick: handleOneDayRange,
                                                    children: "1 Day"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    onClick: handleThreeDayRange,
                                                    children: "3 Days"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    onClick: handleSevenDayRange,
                                                    children: "7 Days"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "subtitle2",
                                                color: "text.secondary",
                                                children: [
                                                    "Trips in selected range: ",
                                                    selectedTripIds?.size || 0,
                                                    " of ",
                                                    tripCount,
                                                    " selected"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hLfsQ.TripList), {
                                                groupedTrips: groupedTrips,
                                                selectedTripIds: selectedTripIds || new Set(),
                                                onToggleTripSelection: onToggleTripSelection || (()=>{})
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                            value: activeTab,
                            index: 1,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3tkEe.ParkingConfigForm), {
                                bufferMinutes: config.bufferMinutes,
                                plannedMoveCap: config.plannedMoveCap,
                                allowTrapping: config.allowTrapping,
                                egressWeight: config.egressWeight,
                                wasteWeight: config.wasteWeight,
                                structuralWeight: config.structuralWeight,
                                zonePriorityWeight: config.zonePriorityWeight,
                                min_dwell_weight: config.min_dwell_weight,
                                sortingStrategy: config.sortingStrategy,
                                arrivalStagingDwellMinutes: config.arrivalStagingDwellMinutes,
                                departureStagingDwellMinutes: config.departureStagingDwellMinutes,
                                quickTurnThresholdMinutes: config.quickTurnThresholdMinutes,
                                onBufferMinutesChange: (value)=>onConfigChange({
                                        bufferMinutes: value
                                    }),
                                onPlannedMoveCapChange: (value)=>onConfigChange({
                                        plannedMoveCap: value
                                    }),
                                onAllowTrappingChange: (value)=>onConfigChange({
                                        allowTrapping: value
                                    }),
                                onEgressWeightChange: (value)=>onConfigChange({
                                        egressWeight: value
                                    }),
                                onWasteWeightChange: (value)=>onConfigChange({
                                        wasteWeight: value
                                    }),
                                onStructuralWeightChange: (value)=>onConfigChange({
                                        structuralWeight: value
                                    }),
                                onZonePriorityWeightChange: (value)=>onConfigChange({
                                        zonePriorityWeight: value
                                    }),
                                onMinDwellWeightChange: (value)=>onConfigChange({
                                        min_dwell_weight: value
                                    }),
                                onSortingStrategyChange: (value)=>onConfigChange({
                                        sortingStrategy: value
                                    }),
                                onArrivalStagingDwellMinutesChange: (value)=>onConfigChange({
                                        arrivalStagingDwellMinutes: value
                                    }),
                                onDepartureStagingDwellMinutesChange: (value)=>onConfigChange({
                                        departureStagingDwellMinutes: value
                                    }),
                                onQuickTurnThresholdMinutesChange: (value)=>onConfigChange({
                                        quickTurnThresholdMinutes: value
                                    }),
                                size: "small",
                                layout: "column",
                                disabledFields: [],
                                disabledSortingOptions: [
                                    "arrival",
                                    "longest-dwell",
                                    "latest-departure",
                                    "hybrid"
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    p: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3tkEe.ParkingConfigForm), {
                        bufferMinutes: config.bufferMinutes,
                        plannedMoveCap: config.plannedMoveCap,
                        allowTrapping: config.allowTrapping,
                        egressWeight: config.egressWeight,
                        wasteWeight: config.wasteWeight,
                        structuralWeight: config.structuralWeight,
                        zonePriorityWeight: config.zonePriorityWeight,
                        min_dwell_weight: config.min_dwell_weight,
                        sortingStrategy: config.sortingStrategy,
                        arrivalStagingDwellMinutes: config.arrivalStagingDwellMinutes,
                        departureStagingDwellMinutes: config.departureStagingDwellMinutes,
                        quickTurnThresholdMinutes: config.quickTurnThresholdMinutes,
                        onBufferMinutesChange: (value)=>onConfigChange({
                                bufferMinutes: value
                            }),
                        onPlannedMoveCapChange: (value)=>onConfigChange({
                                plannedMoveCap: value
                            }),
                        onAllowTrappingChange: (value)=>onConfigChange({
                                allowTrapping: value
                            }),
                        onEgressWeightChange: (value)=>onConfigChange({
                                egressWeight: value
                            }),
                        onWasteWeightChange: (value)=>onConfigChange({
                                wasteWeight: value
                            }),
                        onStructuralWeightChange: (value)=>onConfigChange({
                                structuralWeight: value
                            }),
                        onZonePriorityWeightChange: (value)=>onConfigChange({
                                zonePriorityWeight: value
                            }),
                        onMinDwellWeightChange: (value)=>onConfigChange({
                                min_dwell_weight: value
                            }),
                        onSortingStrategyChange: (value)=>onConfigChange({
                                sortingStrategy: value
                            }),
                        onArrivalStagingDwellMinutesChange: (value)=>onConfigChange({
                                arrivalStagingDwellMinutes: value
                            }),
                        onDepartureStagingDwellMinutesChange: (value)=>onConfigChange({
                                departureStagingDwellMinutes: value
                            }),
                        onQuickTurnThresholdMinutesChange: (value)=>onConfigChange({
                                quickTurnThresholdMinutes: value
                            }),
                        size: "small",
                        layout: "column",
                        disabledFields: [],
                        disabledSortingOptions: [
                            "arrival",
                            "longest-dwell",
                            "latest-departure",
                            "hybrid"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                sx: {
                    px: 3,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: onRunAutoPark,
                        variant: "contained",
                        color: "primary",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euRCv))), {}),
                        disabled: isScheduledView && (tripCount === 0 || (selectedTripIds?.size || 0) === 0),
                        children: "Run AutoPark"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("3tkEe", function(module, exports) {

$parcel$export(module.exports, "ParkingConfigForm", () => $0ba4f86f5204010e$export$e1323c4513243868);

var $ayMG0 = parcelRequire("ayMG0");

var $1Aijw = parcelRequire("1Aijw");
var $gd5y7 = parcelRequire("gd5y7");
var $2esSG = parcelRequire("2esSG");
var $i32L9 = parcelRequire("i32L9");
var $2iAqv = parcelRequire("2iAqv");
var $cX7V2 = parcelRequire("cX7V2");
var $jU0bc = parcelRequire("jU0bc");
var $30UGG = parcelRequire("30UGG");
parcelRequire("acw62");

var $aDzfS = parcelRequire("aDzfS");

var $h3XF9 = parcelRequire("h3XF9");

var $7HqvR = parcelRequire("7HqvR");
/**
 * Formats minutes into a human-readable time string
 * @param minutes - Number of minutes to format
 * @returns Formatted string (e.g., "30 min", "1 hour", "1 hour 15 min")
 */ function $0ba4f86f5204010e$var$formatTimeMinutes(minutes) {
    if (minutes === 0) return "0 min";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours === 0) return `${mins} min`;
    else if (mins === 0) return hours === 1 ? "1 hour" : `${hours} hours`;
    else return `${hours} hour${hours > 1 ? "s" : ""} ${mins} min`;
}
const $0ba4f86f5204010e$export$e1323c4513243868 = ({ bufferMinutes: bufferMinutes, plannedMoveCap: plannedMoveCap, allowTrapping: allowTrapping, egressWeight: egressWeight, wasteWeight: wasteWeight, structuralWeight: structuralWeight, zonePriorityWeight: zonePriorityWeight, min_dwell_weight: min_dwell_weight, sortingStrategy: sortingStrategy, arrivalStagingDwellMinutes: arrivalStagingDwellMinutes, departureStagingDwellMinutes: departureStagingDwellMinutes, quickTurnThresholdMinutes: quickTurnThresholdMinutes, onBufferMinutesChange: onBufferMinutesChange, onPlannedMoveCapChange: onPlannedMoveCapChange, onAllowTrappingChange: onAllowTrappingChange, onEgressWeightChange: onEgressWeightChange, onWasteWeightChange: onWasteWeightChange, onStructuralWeightChange: onStructuralWeightChange, onZonePriorityWeightChange: onZonePriorityWeightChange, onMinDwellWeightChange: onMinDwellWeightChange, onSortingStrategyChange: onSortingStrategyChange, onArrivalStagingDwellMinutesChange: onArrivalStagingDwellMinutesChange, onDepartureStagingDwellMinutesChange: onDepartureStagingDwellMinutesChange, onQuickTurnThresholdMinutesChange: onQuickTurnThresholdMinutesChange, size: size = "small", layout: layout = "row", disabledFields: disabledFields = [], disabledSortingOptions: disabledSortingOptions = [] })=>{
    // Validate staging configuration values
    const arrivalValidation = (0, $aDzfS.validateArrivalStagingDwell)(arrivalStagingDwellMinutes);
    const departureValidation = (0, $aDzfS.validateDepartureStagingDwell)(departureStagingDwellMinutes);
    const thresholdValidation = (0, $aDzfS.validateQuickTurnThreshold)(quickTurnThresholdMinutes);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: layout,
        spacing: layout === "column" ? 1.5 : 1,
        alignItems: layout === "row" ? "flex-start" : "stretch",
        flexWrap: "wrap",
        sx: layout === "row" ? {
            p: 1,
            borderRadius: 1
        } : undefined,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Buffer",
                helpText: "Extra time (minutes) added before arrival and after departure to prevent tight spacing conflicts. Example: Aircraft departs at 10:00. With 15min buffer, spot becomes available at 10:15.",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: bufferMinutes,
                        onChange: (e)=>onBufferMinutesChange(Number(e.target.value)),
                        disabled: disabledFields.includes("bufferMinutes"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0,
                                children: "No Buffer (0)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 10,
                                children: "10 minutes"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 15,
                                children: "Standard (15)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 20,
                                children: "High (20)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Planned Moves",
                helpText: "Maximum number of times an aircraft can be relocated during its dwell. 0 = no moves (aircraft stays in one spot). Example: With 1 move allowed, aircraft could park at Spot A (8:00-12:00) then move to Spot B (12:00-16:00).",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: plannedMoveCap,
                        onChange: (e)=>onPlannedMoveCapChange(Number(e.target.value)),
                        disabled: disabledFields.includes("plannedMoveCap"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0,
                                children: "No Splits (0)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 1,
                                children: "Allow 1 Move"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 2,
                                children: "Allow 2 Moves"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 3,
                                children: "Allow 3 Moves"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Allow Trapping",
                helpText: "When checked, allows placing aircraft in spots that block others' departure paths. When unchecked, only places aircraft in spots that don't trap others (may leave aircraft unplaced).",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                        checked: allowTrapping,
                        onChange: (e)=>onAllowTrappingChange(e.target.checked),
                        size: size
                    }),
                    label: "Allow Trapping"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Egress Weight",
                helpText: "Controls how strongly the algorithm avoids placements that trap other aircraft. Low (1x): minimal penalty. Medium (2x): moderate penalty. High (5x): strong penalty.",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: egressWeight,
                        onChange: (e)=>onEgressWeightChange(Number(e.target.value)),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 1.0,
                                children: "Low (1x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 2.0,
                                children: "Medium (2x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 5.0,
                                children: "High (5x)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Waste Weight",
                helpText: "Controls how strongly the algorithm avoids placing small aircraft in oversized spots. Helps reserve premium large spots for large aircraft that actually need them.",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: wasteWeight,
                        onChange: (e)=>onWasteWeightChange(Number(e.target.value)),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0,
                                children: "Disabled (0x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0.5,
                                children: "Low (0.5x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 1.0,
                                children: "Medium (1x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 2.0,
                                children: "High (2x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 3.0,
                                children: "Very High (3x)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Structural Weight",
                helpText: "Controls penalty for spots with complex blocking topology. Encourages using 'clean' spots first, saving complex spots as last resort. Low (0.05x): minimal. Standard (0.1x): tiebreaker. High (0.5x): strong preference.",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: structuralWeight,
                        onChange: (e)=>onStructuralWeightChange(Number(e.target.value)),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0,
                                children: "Disabled (0x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0.05,
                                children: "Low (0.05x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0.1,
                                children: "Standard (0.1x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0.2,
                                children: "Medium (0.2x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0.5,
                                children: "High (0.5x)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Zone Priority Weight",
                helpText: "Controls preference for high-priority zones. Disabled (0x): ignore zones. Low (0.5x): minor preference. Standard (1x): balanced. High (2x): strong preference. Very High (3x): maximum preference.",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: zonePriorityWeight,
                        onChange: (e)=>onZonePriorityWeightChange(Number(e.target.value)),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0,
                                children: "Disabled (0x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0.5,
                                children: "Low (0.5x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 1.0,
                                children: "Standard (1x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 2.0,
                                children: "High (2x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 3.0,
                                children: "Very High (3x)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Min Dwell Weight",
                helpText: "Controls preference for spots with min dwell requirements. Attracts long-stay aircraft to remote/overflow spots and repels short-stay aircraft. Disabled (0x): ignore min dwell. Low (0.5x): minor preference. Standard (1x): balanced. High (2x): strong preference. Very High (3x): maximum preference.",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: min_dwell_weight,
                        onChange: (e)=>onMinDwellWeightChange(Number(e.target.value)),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0,
                                children: "Disabled (0x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 0.5,
                                children: "Low (0.5x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 1.0,
                                children: "Standard (1x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 2.0,
                                children: "High (2x)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: 3.0,
                                children: "Very High (3x)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Arrival Staging Time",
                helpText: `Duration for arrival servicing operations: unloading, customs, refueling, cleaning. Set to 0 to disable arrival staging. Requires staging zones configured on ramp. Valid range: 0-${(0, $h3XF9.MAX_ARRIVAL_STAGING_MINUTES)} minutes.`,
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jU0bc.default), {
                            value: arrivalStagingDwellMinutes,
                            onChange: (_, value)=>onArrivalStagingDwellMinutesChange(value),
                            disabled: disabledFields.includes("arrivalStagingDwellMinutes"),
                            min: 0,
                            max: 90,
                            step: 15,
                            marks: true,
                            valueLabelDisplay: "auto",
                            valueLabelFormat: (value)=>$0ba4f86f5204010e$var$formatTimeMinutes(value)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $i32L9.default), {
                            sx: {
                                mt: 1
                            },
                            children: [
                                arrivalStagingDwellMinutes === 0 ? "0 min (disabled)" : $0ba4f86f5204010e$var$formatTimeMinutes(arrivalStagingDwellMinutes),
                                !arrivalValidation.isValid && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        marginLeft: "8px"
                                    },
                                    children: arrivalValidation.message
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Departure Staging Time",
                helpText: `Duration for departure preparation: boarding, final checks, paperwork. Set to 0 to disable departure staging. Requires staging zones configured on ramp. Valid range: 0-${(0, $h3XF9.MAX_DEPARTURE_STAGING_MINUTES)} minutes.`,
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jU0bc.default), {
                            value: departureStagingDwellMinutes,
                            onChange: (_, value)=>onDepartureStagingDwellMinutesChange(value),
                            disabled: disabledFields.includes("departureStagingDwellMinutes"),
                            min: 0,
                            max: 90,
                            step: 15,
                            marks: true,
                            valueLabelDisplay: "auto",
                            valueLabelFormat: (value)=>$0ba4f86f5204010e$var$formatTimeMinutes(value)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $i32L9.default), {
                            sx: {
                                mt: 1
                            },
                            children: [
                                departureStagingDwellMinutes === 0 ? "0 min (disabled)" : $0ba4f86f5204010e$var$formatTimeMinutes(departureStagingDwellMinutes),
                                !departureValidation.isValid && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        marginLeft: "8px"
                                    },
                                    children: departureValidation.message
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Quick Turn Threshold",
                helpText: `Minimum total dwell time to use staging workflow. Aircraft with shorter stays bypass staging and go directly to permanent spots. Valid range: ${(0, $h3XF9.MIN_QUICK_TURN_THRESHOLD_MINUTES)}-${(0, $h3XF9.MAX_QUICK_TURN_THRESHOLD_MINUTES)} minutes.`,
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    error: !thresholdValidation.isValid,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                            value: quickTurnThresholdMinutes,
                            onChange: (e)=>onQuickTurnThresholdMinutesChange(Number(e.target.value)),
                            disabled: arrivalStagingDwellMinutes === 0 && departureStagingDwellMinutes === 0 || disabledFields.includes("quickTurnThresholdMinutes"),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: 60,
                                    children: "1 hour"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: 90,
                                    children: "1.5 hours"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: 120,
                                    children: "Standard (2 hours)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: 180,
                                    children: "3 hours"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: 240,
                                    children: "4 hours"
                                })
                            ]
                        }),
                        !thresholdValidation.isValid && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                            children: thresholdValidation.message
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HqvR.ParkingConfigControl), {
                title: "Sorting Strategy",
                helpText: "Controls the order in which aircraft are processed. Size-Constrained: places aircraft with fewer spot options first. Arrival: processes by arrival time. Hybrid: combines size-constrained + longest-dwell.",
                layout: layout,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    fullWidth: true,
                    size: size,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        value: sortingStrategy,
                        onChange: (e)=>onSortingStrategyChange(e.target.value),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "arrival",
                                disabled: disabledSortingOptions.includes("arrival"),
                                children: "Arrival Order"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "size-constrained",
                                disabled: disabledSortingOptions.includes("size-constrained"),
                                children: "Size-Constrained First"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "longest-dwell",
                                disabled: disabledSortingOptions.includes("longest-dwell"),
                                children: "Longest Dwell First"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "latest-departure",
                                disabled: disabledSortingOptions.includes("latest-departure"),
                                children: "Latest Departure First"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "hybrid",
                                disabled: disabledSortingOptions.includes("hybrid"),
                                children: "Hybrid (Size + Dwell)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "largest-first",
                                disabled: disabledSortingOptions.includes("largest-first"),
                                children: "Largest First"
                            })
                        ]
                    })
                })
            })
        ]
    });
};

});
parcelRegister("7HqvR", function(module, exports) {

$parcel$export(module.exports, "ParkingConfigControl", () => $64b8c62566a7f17d$export$30201be403c31186);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $ipR47 = parcelRequire("ipR47");
parcelRequire("acw62");
const $64b8c62566a7f17d$export$30201be403c31186 = ({ title: title, helpText: helpText, children: children, layout: layout = "column" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            width: layout === "row" ? 180 : "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: layout === "row" ? "flex-start" : "stretch"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 0.5,
                alignItems: "center",
                sx: {
                    mb: 0.5,
                    height: 20
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        sx: {
                            fontWeight: 500,
                            fontSize: "0.7rem",
                            color: "text.secondary",
                            lineHeight: "20px"
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: helpText,
                        placement: "top",
                        arrow: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                            sx: {
                                fontSize: 14,
                                color: "action.active",
                                cursor: "help"
                            }
                        })
                    })
                ]
            }),
            children
        ]
    });
};

});


parcelRegister("hLfsQ", function(module, exports) {

$parcel$export(module.exports, "TripList", () => $c163505ca4954055$export$5b79c131a51fd1a0);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $1Aijw = parcelRequire("1Aijw");
var $6ami2 = parcelRequire("6ami2");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $cSDx2 = parcelRequire("cSDx2");
var $bjZRT = parcelRequire("bjZRT");
var $19ocJ = parcelRequire("19ocJ");
var $3bYfT = parcelRequire("3bYfT");

var $kfA3C = parcelRequire("kfA3C");
parcelRequire("acw62");
const $c163505ca4954055$export$5b79c131a51fd1a0 = ({ groupedTrips: groupedTrips, selectedTripIds: selectedTripIds, onToggleTripSelection: onToggleTripSelection })=>{
    if (groupedTrips.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 3,
            textAlign: "center",
            color: "text.secondary"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: "body2",
            children: "No trips in selected range"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
        sx: {
            maxHeight: 300,
            overflowY: "auto",
            border: 1,
            borderColor: "divider",
            borderRadius: 1,
            p: 0
        },
        children: groupedTrips.map((trip, index)=>{
            const isChecked = selectedTripIds.has(trip.trip_id);
            const startTime = new Date(trip.start_time);
            const endTime = new Date(trip.end_time);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                disablePadding: true,
                sx: {
                    borderBottom: index < groupedTrips.length - 1 ? 1 : 0,
                    borderColor: "divider"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cSDx2.default), {
                    dense: true,
                    onClick: ()=>onToggleTripSelection(trip.trip_id),
                    sx: {
                        py: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                            sx: {
                                minWidth: 40
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                edge: "start",
                                checked: isChecked,
                                tabIndex: -1,
                                disableRipple: true
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                            primary: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1
                                },
                                children: [
                                    trip.tail_number && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                        label: trip.tail_number,
                                        size: "small",
                                        sx: {
                                            height: 20
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        sx: {
                                            flex: 1
                                        },
                                        children: trip.aircraft_model || trip.aircraft_make || "Unknown Aircraft"
                                    })
                                ]
                            }),
                            secondary: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "text.secondary",
                                children: [
                                    (0, $kfA3C.format)(startTime, "MMM d, HH:mm"),
                                    " -",
                                    " ",
                                    (0, $kfA3C.format)(endTime, "MMM d, HH:mm")
                                ]
                            })
                        })
                    ]
                })
            }, trip.trip_id);
        })
    });
};

});
parcelRegister("cSDx2", function(module, exports) {

$parcel$export(module.exports, "default", () => $960931686a59e228$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $8Uq77 = parcelRequire("8Uq77");

var $6n0Ko = parcelRequire("6n0Ko");

var $khjmj = parcelRequire("khjmj");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3W6ht = parcelRequire("3W6ht");

var $dUgGz = parcelRequire("dUgGz");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $960931686a59e228$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $960931686a59e228$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $dUgGz.getListItemButtonUtilityClass), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $960931686a59e228$var$ListItemButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $960931686a59e228$export$4334bb34c76fef24
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $dUgGz.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $dUgGz.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $dUgGz.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8gMkr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $dUgGz.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $dUgGz.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const $960931686a59e228$var$ListItemButton = /*#__PURE__*/ $acw62.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $khjmj.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    };
    const classes = $960931686a59e228$var$useUtilityClasses(ownerState);
    const handleRef = (0, $9Rgf1.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($960931686a59e228$var$ListItemButtonRoot, {
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            classes: classes,
            children: children
        })
    });
});
var $960931686a59e228$export$2e2bcd8739ae039 = $960931686a59e228$var$ListItemButton;

});



parcelRegister("lcj2t", function(module, exports) {

$parcel$export(module.exports, "AutoParkButton", () => $703f47c79e09bc80$export$af32abfe7800c46f);

var $ayMG0 = parcelRequire("ayMG0");

var $euRCv = parcelRequire("euRCv");

var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $cVXaD = parcelRequire("cVXaD");
parcelRequire("acw62");
const $703f47c79e09bc80$export$af32abfe7800c46f = ({ onClick: onClick, disabled: disabled, disabledMessage: disabledMessage = "AutoParking is not enabled for this ramp. Enable it in the ramp settings.", compact: compact = false, fullWidth: fullWidth = false })=>{
    const button = compact ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
        color: "primary",
        onClick: onClick,
        disabled: disabled,
        size: "small",
        sx: {
            bgcolor: disabled ? undefined : "primary.main",
            color: disabled ? undefined : "white",
            "&:hover": {
                bgcolor: disabled ? undefined : "primary.dark"
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euRCv))), {})
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
        variant: "contained",
        color: "primary",
        onClick: onClick,
        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euRCv))), {}),
        fullWidth: fullWidth,
        disabled: disabled,
        size: "small",
        children: "AutoPark"
    });
    const tooltipTitle = compact ? "AutoPark" : disabled ? disabledMessage : "";
    if (disabled || compact) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: tooltipTitle || disabledMessage,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: button
        })
    });
    return button;
};

});

parcelRegister("e2U90", function(module, exports) {

$parcel$export(module.exports, "DecisionLogButton", () => $5c1bf01a62671ad8$export$c910dce7a0e23206);

var $ayMG0 = parcelRequire("ayMG0");

var $d8apZ = parcelRequire("d8apZ");

var $9Lykx = parcelRequire("9Lykx");
var $cVXaD = parcelRequire("cVXaD");
parcelRequire("acw62");
const $5c1bf01a62671ad8$export$c910dce7a0e23206 = ({ onClick: onClick, disabled: disabled })=>{
    const button = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
        color: "primary",
        onClick: onClick,
        disabled: disabled,
        size: "medium",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8apZ))), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: disabled ? "Run AutoPark first to generate decision log" : "View Decision Log",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: button
        })
    });
};

});
parcelRegister("d8apZ", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $98f41a89733d2f6f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98f41a89733d2f6f$var$_createSvgIcon = $98f41a89733d2f6f$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $98f41a89733d2f6f$var$_default = module.exports.default = (0, $98f41a89733d2f6f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H4.99C3.89 3 3 3.9 3 5l.01 14c0 1.1.89 2 1.99 2h10l6-6V5c0-1.1-.9-2-2-2M7 8h10v2H7zm5 6H7v-2h5zm2 5.5V14h5.5z"
}), 'StickyNote2');

});


parcelRegister("5o4Wz", function(module, exports) {

$parcel$export(module.exports, "DecisionLogDialog", () => $bd407ff8536b629e$export$ff704e0a403c2514);

var $ayMG0 = parcelRequire("ayMG0");

var $fZSPM = parcelRequire("fZSPM");

var $dqlTG = parcelRequire("dqlTG");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $6GL0S = parcelRequire("6GL0S");

var $lTOh0 = parcelRequire("lTOh0");

var $25rQi = parcelRequire("25rQi");

var $bXsOq = parcelRequire("bXsOq");

var $gqmpX = parcelRequire("gqmpX");

var $hfdp4 = parcelRequire("hfdp4");

var $4H2Jj = parcelRequire("4H2Jj");
const $bd407ff8536b629e$export$ff704e0a403c2514 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ open: open, onClose: onClose, decisionLog: decisionLog, requests: requests, rampShapes: rampShapes = [], spots: spots, placement: placement, zones: zones, horizonHours: horizonHours = 24, startTime: startTime = new Date(), partialPlacements: partialPlacements = [], statistics: statistics, onApply: onApply, isApplying: isApplying, applyProgress: applyProgress, showDetailedView: showDetailedView = false, onScheduleChanged: onScheduleChanged })=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)(0);
    const [placementFilter, setPlacementFilter] = (0, $acw62.useState)("all");
    // Create mapping from spot ID to spot name
    const spotIdToName = (0, $acw62.useMemo)(()=>{
        const mapping = {};
        rampShapes.forEach((shape)=>{
            if (shape.type === "Spot" && shape.text) mapping[shape.id] = shape.text;
        });
        return mapping;
    }, [
        rampShapes
    ]);
    // Check if we have temporal data for timeline view
    const hasTimelineData = Boolean(spots && placement);
    // Memoize requests with logs to avoid re-filtering on every render
    const requestsWithLogs = (0, $acw62.useMemo)(()=>{
        return requests.filter((request)=>{
            const requestLogs = decisionLog.filter((e)=>e.aircraftId === request.id);
            return requestLogs.length > 0;
        });
    }, [
        requests,
        decisionLog
    ]);
    // Helper function to determine if aircraft was placed or unplaced
    const getAircraftStatus = (request)=>{
        const requestLogs = decisionLog.filter((e)=>e.aircraftId === request.id);
        const hasRejectedLog = requestLogs.some((e)=>e.type === "rejected");
        return hasRejectedLog ? "unplaced" : "placed";
    };
    // Filter requests based on placement filter
    const filteredRequests = (0, $acw62.useMemo)(()=>{
        if (placementFilter === "all") return requestsWithLogs;
        return requestsWithLogs.filter((request)=>{
            return getAircraftStatus(request) === placementFilter;
        });
    }, [
        requestsWithLogs,
        placementFilter,
        decisionLog
    ]);
    // Calculate counts for each filter option
    const filterCounts = (0, $acw62.useMemo)(()=>{
        const placedCount = requestsWithLogs.filter((r)=>getAircraftStatus(r) === "placed").length;
        const unplacedCount = requestsWithLogs.filter((r)=>getAircraftStatus(r) === "unplaced").length;
        return {
            all: requestsWithLogs.length,
            placed: placedCount,
            unplaced: unplacedCount
        };
    }, [
        requestsWithLogs,
        decisionLog
    ]);
    // Calculate capacity data for CapacityBar
    const capacityData = (0, $acw62.useMemo)(()=>{
        // Total spots on ramp
        const totalSpots = rampShapes.filter((s)=>s.type === "Spot").length;
        // Number of aircraft placed (same as filterCounts.placed)
        const placedCount = filterCounts.placed;
        // Aggregate filter breakdowns from all rejected aircraft
        // Note: We need to find the "worst case" breakdown - the one showing maximum constraints
        const rejectedLogs = decisionLog.filter((e)=>e.type === "rejected");
        let aggregatedBreakdown;
        if (rejectedLogs.length > 0) {
            // Find the rejection with the most comprehensive breakdown
            // (typically the first rejection will have full spot list)
            const breakdownLog = rejectedLogs.find((e)=>e.filterBreakdown);
            if (breakdownLog && breakdownLog.filterBreakdown) aggregatedBreakdown = breakdownLog.filterBreakdown;
        }
        // Calculate available spots (spots that passed filters for at least one aircraft)
        // This is an approximation: totalSpots - placed - filtered
        const availableCount = aggregatedBreakdown ? Math.max(0, totalSpots - placedCount - (aggregatedBreakdown.total - aggregatedBreakdown.available)) : Math.max(0, totalSpots - placedCount);
        return {
            totalSpots: totalSpots,
            placedCount: placedCount,
            availableCount: availableCount,
            filterBreakdown: aggregatedBreakdown
        };
    }, [
        rampShapes,
        filterCounts.placed,
        decisionLog
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: onClose,
                fullScreen: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ejcfT.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    edge: "end",
                                    color: "inherit",
                                    onClick: onClose,
                                    "aria-label": "close",
                                    sx: {
                                        ml: "auto"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                                })
                            }),
                            hasTimelineData && showDetailedView && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                                value: activeTab,
                                onChange: (_, newValue)=>setActiveTab(newValue),
                                sx: {
                                    borderBottom: 1,
                                    borderColor: "divider",
                                    mt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                        label: "Spot Occupancy"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                        label: "List View"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                        label: "Timeline (Dev)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                        label: `Decision Log (${filteredRequests.length} aircraft)`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        dividers: showDetailedView,
                        sx: {
                            p: showDetailedView ? 3 : 0,
                            height: "100%"
                        },
                        children: hasTimelineData ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                !showDetailedView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4H2Jj.SpotOccupancyGantt), {
                                    spots: spots,
                                    aircraft: requests,
                                    placement: placement,
                                    horizonHours: horizonHours,
                                    startTime: startTime,
                                    rampShapes: rampShapes,
                                    zones: zones,
                                    statistics: statistics,
                                    partialPlacements: partialPlacements,
                                    enableEditing: true,
                                    onScheduleChanged: onScheduleChanged,
                                    decisionLog: decisionLog,
                                    showDetailedView: showDetailedView
                                }),
                                showDetailedView && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                                            value: activeTab,
                                            index: 0,
                                            children: activeTab === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4H2Jj.SpotOccupancyGantt), {
                                                spots: spots,
                                                aircraft: requests,
                                                placement: placement,
                                                horizonHours: horizonHours,
                                                startTime: startTime,
                                                rampShapes: rampShapes,
                                                zones: zones,
                                                statistics: statistics,
                                                partialPlacements: partialPlacements,
                                                enableEditing: true,
                                                onScheduleChanged: onScheduleChanged,
                                                decisionLog: decisionLog,
                                                showDetailedView: showDetailedView
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                                            value: activeTab,
                                            index: 1,
                                            children: activeTab === 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hfdp4.PlacementTableView), {
                                                statistics: statistics,
                                                placement: placement,
                                                requests: requests,
                                                spots: spots,
                                                zones: zones,
                                                rampShapes: rampShapes,
                                                startTime: startTime,
                                                horizonHours: horizonHours,
                                                partialPlacements: partialPlacements,
                                                enableEditing: true,
                                                onScheduleChanged: onScheduleChanged
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                                            value: activeTab,
                                            index: 2,
                                            children: activeTab === 2 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    statistics && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                        sx: {
                                                            display: "grid",
                                                            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                                                            gap: 2,
                                                            mb: 2
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                sx: {
                                                                    border: 1,
                                                                    borderColor: "divider",
                                                                    borderRadius: 1,
                                                                    p: 2
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        color: "text.secondary",
                                                                        gutterBottom: true,
                                                                        children: "Aircraft Placed"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                        variant: "h4",
                                                                        component: "div",
                                                                        children: [
                                                                            statistics.placedAircraft,
                                                                            " /",
                                                                            " ",
                                                                            statistics.totalAircraft
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                sx: {
                                                                    border: 1,
                                                                    borderColor: "divider",
                                                                    borderRadius: 1,
                                                                    p: 2
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        color: "text.secondary",
                                                                        gutterBottom: true,
                                                                        children: "Success Rate"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                        variant: "h4",
                                                                        component: "div",
                                                                        children: [
                                                                            Math.round(statistics.placedAircraft / statistics.totalAircraft * 100),
                                                                            "%"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            statistics.unplacedAircraft > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                sx: {
                                                                    border: 1,
                                                                    borderColor: "divider",
                                                                    borderRadius: 1,
                                                                    p: 2
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        color: "text.secondary",
                                                                        gutterBottom: true,
                                                                        children: "Unplaced Aircraft"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "h4",
                                                                        component: "div",
                                                                        children: statistics.unplacedAircraft
                                                                    })
                                                                ]
                                                            }),
                                                            statistics.partiallyPlacedAircraft !== undefined && statistics.partiallyPlacedAircraft > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                sx: {
                                                                    border: 1,
                                                                    borderColor: "warning.main",
                                                                    borderRadius: 1,
                                                                    p: 2,
                                                                    bgcolor: "warning.lighter"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        color: "warning.dark",
                                                                        gutterBottom: true,
                                                                        children: "Partially Placed"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "h4",
                                                                        component: "div",
                                                                        color: "warning.dark",
                                                                        children: statistics.partiallyPlacedAircraft
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "caption",
                                                                        color: "warning.dark",
                                                                        sx: {
                                                                            mt: 0.5,
                                                                            display: "block"
                                                                        },
                                                                        children: "Placed for part of trip"
                                                                    })
                                                                ]
                                                            }),
                                                            statistics.averageMoves !== undefined && statistics.averageMoves > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                sx: {
                                                                    border: 1,
                                                                    borderColor: "divider",
                                                                    borderRadius: 1,
                                                                    p: 2
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        color: "text.secondary",
                                                                        gutterBottom: true,
                                                                        children: "Average Moves"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "h4",
                                                                        component: "div",
                                                                        children: statistics.averageMoves.toFixed(2)
                                                                    })
                                                                ]
                                                            }),
                                                            statistics.elapsedMs !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                sx: {
                                                                    border: 1,
                                                                    borderColor: "divider",
                                                                    borderRadius: 1,
                                                                    p: 2
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        color: "text.secondary",
                                                                        gutterBottom: true,
                                                                        children: "Execution Time"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "h4",
                                                                        component: "div",
                                                                        children: statistics.elapsedMs < 1000 ? `${Math.round(statistics.elapsedMs)}ms` : `${(statistics.elapsedMs / 1000).toFixed(2)}s`
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXsOq.TimelineView), {
                                                        spots: spots,
                                                        aircraft: requests,
                                                        placement: placement,
                                                        log: decisionLog,
                                                        zones: zones,
                                                        horizonHours: horizonHours,
                                                        startTime: startTime,
                                                        spotIdToName: spotIdToName
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                                            value: activeTab,
                                            index: 3,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    maxHeight: "100%",
                                                    overflow: "auto"
                                                },
                                                children: [
                                                    capacityData.totalSpots > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gqmpX.CapacityBar), {
                                                        totalSpots: capacityData.totalSpots,
                                                        placedCount: capacityData.placedCount,
                                                        availableCount: capacityData.availableCount,
                                                        filterBreakdown: capacityData.filterBreakdown
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                        direction: "row",
                                                        spacing: 1,
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        sx: {
                                                            mb: 2
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                label: `All (${filterCounts.all})`,
                                                                variant: placementFilter === "all" ? "filled" : "outlined",
                                                                clickable: true,
                                                                onClick: ()=>setPlacementFilter("all"),
                                                                sx: {
                                                                    fontSize: "0.875rem",
                                                                    height: "32px",
                                                                    borderRadius: "16px",
                                                                    fontWeight: 500,
                                                                    transition: "all 0.2s ease-in-out",
                                                                    "&.MuiChip-outlined": {
                                                                        borderColor: "divider",
                                                                        backgroundColor: "transparent",
                                                                        color: "text.secondary",
                                                                        "&:hover": {
                                                                            borderColor: "primary.main",
                                                                            backgroundColor: "action.hover",
                                                                            color: "text.primary"
                                                                        }
                                                                    },
                                                                    "&.MuiChip-filled": {
                                                                        backgroundColor: "primary.main",
                                                                        borderColor: "primary.main",
                                                                        color: "primary.contrastText",
                                                                        fontWeight: 600,
                                                                        "&:hover": {
                                                                            backgroundColor: "primary.dark",
                                                                            borderColor: "primary.dark"
                                                                        }
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                label: `Placed (${filterCounts.placed})`,
                                                                variant: placementFilter === "placed" ? "filled" : "outlined",
                                                                clickable: true,
                                                                onClick: ()=>setPlacementFilter("placed"),
                                                                sx: {
                                                                    fontSize: "0.875rem",
                                                                    height: "32px",
                                                                    borderRadius: "16px",
                                                                    fontWeight: 500,
                                                                    transition: "all 0.2s ease-in-out",
                                                                    "&.MuiChip-outlined": {
                                                                        borderColor: "divider",
                                                                        backgroundColor: "transparent",
                                                                        color: "text.secondary",
                                                                        "&:hover": {
                                                                            borderColor: "success.main",
                                                                            backgroundColor: "action.hover",
                                                                            color: "text.primary"
                                                                        }
                                                                    },
                                                                    "&.MuiChip-filled": {
                                                                        backgroundColor: "success.main",
                                                                        borderColor: "success.main",
                                                                        color: "success.contrastText",
                                                                        fontWeight: 600,
                                                                        "&:hover": {
                                                                            backgroundColor: "success.dark",
                                                                            borderColor: "success.dark"
                                                                        }
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                label: `Unplaced (${filterCounts.unplaced})`,
                                                                variant: placementFilter === "unplaced" ? "filled" : "outlined",
                                                                clickable: true,
                                                                onClick: ()=>setPlacementFilter("unplaced"),
                                                                sx: {
                                                                    fontSize: "0.875rem",
                                                                    height: "32px",
                                                                    borderRadius: "16px",
                                                                    fontWeight: 500,
                                                                    transition: "all 0.2s ease-in-out",
                                                                    "&.MuiChip-outlined": {
                                                                        borderColor: "divider",
                                                                        backgroundColor: "transparent",
                                                                        color: "text.secondary",
                                                                        "&:hover": {
                                                                            borderColor: "error.main",
                                                                            backgroundColor: "action.hover",
                                                                            color: "text.primary"
                                                                        }
                                                                    },
                                                                    "&.MuiChip-filled": {
                                                                        backgroundColor: "error.main",
                                                                        borderColor: "error.main",
                                                                        color: "error.contrastText",
                                                                        fontWeight: 600,
                                                                        "&:hover": {
                                                                            backgroundColor: "error.dark",
                                                                            borderColor: "error.dark"
                                                                        }
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    filteredRequests.map((request)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                            sx: {
                                                                mb: 2
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25rQi.DecisionLogDisplay), {
                                                                aircraft: request,
                                                                log: decisionLog,
                                                                spotIdToName: spotIdToName
                                                            })
                                                        }, request.id))
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                maxHeight: "100%",
                                overflow: "auto"
                            },
                            children: [
                                capacityData.totalSpots > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gqmpX.CapacityBar), {
                                    totalSpots: capacityData.totalSpots,
                                    placedCount: capacityData.placedCount,
                                    availableCount: capacityData.availableCount,
                                    filterBreakdown: capacityData.filterBreakdown
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    sx: {
                                        mb: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `All (${filterCounts.all})`,
                                            variant: placementFilter === "all" ? "filled" : "outlined",
                                            clickable: true,
                                            onClick: ()=>setPlacementFilter("all"),
                                            sx: {
                                                fontSize: "0.875rem",
                                                height: "32px",
                                                borderRadius: "16px",
                                                fontWeight: 500,
                                                transition: "all 0.2s ease-in-out",
                                                "&.MuiChip-outlined": {
                                                    borderColor: "divider",
                                                    backgroundColor: "transparent",
                                                    color: "text.secondary",
                                                    "&:hover": {
                                                        borderColor: "primary.main",
                                                        backgroundColor: "action.hover",
                                                        color: "text.primary"
                                                    }
                                                },
                                                "&.MuiChip-filled": {
                                                    backgroundColor: "primary.main",
                                                    borderColor: "primary.main",
                                                    color: "primary.contrastText",
                                                    fontWeight: 600,
                                                    "&:hover": {
                                                        backgroundColor: "primary.dark",
                                                        borderColor: "primary.dark"
                                                    }
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `Placed (${filterCounts.placed})`,
                                            variant: placementFilter === "placed" ? "filled" : "outlined",
                                            clickable: true,
                                            onClick: ()=>setPlacementFilter("placed"),
                                            sx: {
                                                fontSize: "0.875rem",
                                                height: "32px",
                                                borderRadius: "16px",
                                                fontWeight: 500,
                                                transition: "all 0.2s ease-in-out",
                                                "&.MuiChip-outlined": {
                                                    borderColor: "divider",
                                                    backgroundColor: "transparent",
                                                    color: "text.secondary",
                                                    "&:hover": {
                                                        borderColor: "success.main",
                                                        backgroundColor: "action.hover",
                                                        color: "text.primary"
                                                    }
                                                },
                                                "&.MuiChip-filled": {
                                                    backgroundColor: "success.main",
                                                    borderColor: "success.main",
                                                    color: "success.contrastText",
                                                    fontWeight: 600,
                                                    "&:hover": {
                                                        backgroundColor: "success.dark",
                                                        borderColor: "success.dark"
                                                    }
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `Unplaced (${filterCounts.unplaced})`,
                                            variant: placementFilter === "unplaced" ? "filled" : "outlined",
                                            clickable: true,
                                            onClick: ()=>setPlacementFilter("unplaced"),
                                            sx: {
                                                fontSize: "0.875rem",
                                                height: "32px",
                                                borderRadius: "16px",
                                                fontWeight: 500,
                                                transition: "all 0.2s ease-in-out",
                                                "&.MuiChip-outlined": {
                                                    borderColor: "divider",
                                                    backgroundColor: "transparent",
                                                    color: "text.secondary",
                                                    "&:hover": {
                                                        borderColor: "error.main",
                                                        backgroundColor: "action.hover",
                                                        color: "text.primary"
                                                    }
                                                },
                                                "&.MuiChip-filled": {
                                                    backgroundColor: "error.main",
                                                    borderColor: "error.main",
                                                    color: "error.contrastText",
                                                    fontWeight: 600,
                                                    "&:hover": {
                                                        backgroundColor: "error.dark",
                                                        borderColor: "error.dark"
                                                    }
                                                }
                                            }
                                        })
                                    ]
                                }),
                                filteredRequests.map((request)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            mb: 2
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25rQi.DecisionLogDisplay), {
                                            aircraft: request,
                                            log: decisionLog,
                                            spotIdToName: spotIdToName
                                        })
                                    }, request.id))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        sx: {
                            px: 3,
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    flex: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: onClose,
                                disabled: isApplying,
                                children: "Close"
                            }),
                            onApply && hasTimelineData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: onApply,
                                variant: "contained",
                                color: "primary",
                                startIcon: isApplying ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 20,
                                    color: "inherit"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fZSPM))), {}),
                                disabled: isApplying,
                                children: isApplying ? "Applying..." : "Apply to Ramp"
                            })
                        ]
                    })
                ]
            }),
            isApplying && applyProgress && applyProgress.total > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6GL0S.ProgressDialog), {
                open: isApplying,
                title: "Applying Results to Database",
                message: "Saving aircraft placements to the database. Please wait...",
                current: applyProgress.current,
                total: applyProgress.total,
                itemName: "placement",
                currentItem: applyProgress.currentItem
            })
        ]
    });
});

});
parcelRegister("6GL0S", function(module, exports) {

$parcel$export(module.exports, "ProgressDialog", () => $2e058ab849c0e9f3$export$412ca83d4373e030);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $1lfQl = parcelRequire("1lfQl");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $2e058ab849c0e9f3$export$412ca83d4373e030 = ({ open: open, title: title, message: message, current: current, total: total, itemName: itemName = "item", currentItem: currentItem })=>{
    // Calculate progress percentage
    const progress = total > 0 ? current / total * 100 : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        maxWidth: "sm",
        fullWidth: true,
        disableEscapeKeyDown: true,
        PaperProps: {
            sx: {
                minHeight: 200
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                            size: 24
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "h6",
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "body1",
                            color: "text.secondary",
                            children: message
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {
                                variant: "determinate",
                                value: progress,
                                sx: {
                                    height: 8,
                                    borderRadius: 4
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: [
                                        "Processing ",
                                        current,
                                        " of ",
                                        total,
                                        " ",
                                        itemName,
                                        total > 1 ? "s" : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    fontWeight: "bold",
                                    children: [
                                        Math.round(progress),
                                        "%"
                                    ]
                                })
                            ]
                        }),
                        currentItem && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "body2",
                            color: "primary",
                            sx: {
                                fontStyle: "italic"
                            },
                            children: [
                                "Current: ",
                                currentItem
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("25rQi", function(module, exports) {

$parcel$export(module.exports, "DecisionLogDisplay", () => $d826d4eeeb979148$export$370f03de4f7085c);
/**
 * DecisionLogDisplay Component
 * Displays decision log entries for a parking request with formatting
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $ewtCw = parcelRequire("ewtCw");

var $03mUs = parcelRequire("03mUs");

var $acw62 = parcelRequire("acw62");

var $czco8 = parcelRequire("czco8");
/**
 * Format size category as short label (uses shared formatter for consistency)
 */ const $d826d4eeeb979148$var$formatSizeLabel = (0, $czco8.formatSizeCategory);
/**
 * Format bucket index as HH:MM time string
 */ const $d826d4eeeb979148$var$formatBucketTime = (bucket)=>{
    const hours = Math.floor(bucket / 4);
    const mins = bucket % 4 * 15;
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};
const $d826d4eeeb979148$export$370f03de4f7085c = /*#__PURE__*/ $acw62.memo(({ aircraft: aircraft, log: log, compact: compact = false, spotIdToName: spotIdToName = {} })=>{
    // Helper function to get spot display name
    const getSpotName = (spotId)=>{
        if (!spotId) return "";
        return spotIdToName[spotId] || spotId;
    };
    // Helper function to format lane name (ensure "Lane" prefix)
    const formatLaneName = (laneName)=>{
        // If it's just a number, prepend "Lane"
        if (/^\d+$/.test(laneName)) return `Lane ${laneName}`;
        return laneName;
    };
    const acLogs = log.filter((e)=>e.aircraftId === aircraft.id);
    if (acLogs.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            color: "text.secondary",
            fontSize: "0.85rem"
        },
        children: "No decision log entries"
    });
    const placedLogs = acLogs.filter((e)=>e.type === "placed");
    const rejectedLog = acLogs.find((e)=>e.type === "rejected");
    const segmentedLog = acLogs.find((e)=>e.type === "segmented");
    // Combine section headers and eval logs, preserving original order
    const evalAndHeaders = acLogs.filter((e)=>e.type === "eval" || e.type === "section-header");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            fontFamily: "monospace",
            fontSize: compact ? "0.85rem" : "0.875rem"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    fontWeight: "bold",
                    mb: compact ? 0.5 : 0.5,
                    color: "text.primary"
                },
                children: [
                    "\u2708\uFE0F ",
                    aircraft.tail_number,
                    " [",
                    $d826d4eeeb979148$var$formatSizeLabel(aircraft.sizeCategory),
                    "] (",
                    String(Math.floor(aircraft.arrivalBucket / 4)).padStart(2, "0"),
                    ":",
                    String(aircraft.arrivalBucket % 4 * 15).padStart(2, "0"),
                    " -",
                    " ",
                    String(Math.floor(aircraft.departureBucket / 4)).padStart(2, "0"),
                    ":",
                    String(aircraft.departureBucket % 4 * 15).padStart(2, "0"),
                    ")"
                ]
            }),
            evalAndHeaders.map((entry, idx)=>{
                // Render section headers
                if (entry.type === "section-header") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        fontWeight: "bold",
                        fontSize: "0.95rem",
                        color: "info.main",
                        mt: 1,
                        mb: 1,
                        borderBottom: "2px solid",
                        borderColor: "info.main",
                        pb: 0.5
                    },
                    children: entry.reason
                }, `header-${idx}`);
                // Render eval logs (existing code)
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        pl: compact ? 0 : 2,
                        color: "text.secondary",
                        mb: compact ? 0.5 : 0
                    },
                    children: [
                        "\uD83C\uDD7F\uFE0F ",
                        getSpotName(entry.spotId),
                        entry.isGapSpot && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                color: "#9C27B0",
                                fontWeight: "bold"
                            },
                            children: [
                                " ",
                                "[GAP]"
                            ]
                        }),
                        entry.chosenEgressOption && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                opacity: 0.7
                            },
                            children: [
                                " ",
                                "(",
                                formatLaneName(entry.chosenEgressOption.laneName),
                                entry.availableEgressOptions && entry.availableEgressOptions > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        fontSize: "0.9em"
                                    },
                                    children: [
                                        " ",
                                        "\u2013 ",
                                        entry.availableEgressOptions,
                                        " lanes"
                                    ]
                                }),
                                ")"
                            ]
                        }),
                        " ",
                        "-",
                        " ",
                        entry.timeAvailable ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                color: "green"
                            },
                            children: [
                                "\u2705 Available, ",
                                entry.trappedCount,
                                " traps",
                                entry.wasteScore !== undefined && entry.wasteScore > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        opacity: 0.7,
                                        fontSize: "0.85em"
                                    },
                                    children: [
                                        ", waste: ",
                                        entry.wasteScore
                                    ]
                                }),
                                entry.structuralComplexity !== undefined && entry.structuralComplexity > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        opacity: 0.7,
                                        fontSize: "0.85em"
                                    },
                                    children: [
                                        ", complexity: ",
                                        entry.structuralComplexity
                                    ]
                                }),
                                entry.zonePriority !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        opacity: 0.7,
                                        fontSize: "0.85em"
                                    },
                                    children: [
                                        ", zone: ",
                                        entry.zonePriority
                                    ]
                                }),
                                (entry.egressScore !== undefined || entry.structuralPenalty !== undefined || entry.wastePenalty !== undefined || entry.zonePenalty !== undefined || entry.min_dwell_penalty !== undefined) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        opacity: 0.7,
                                        fontSize: "0.85em"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "(score: egress(",
                                        entry.trappedCount || 0,
                                        "\xd7",
                                        entry.egressWeight ?? 1.0,
                                        "=",
                                        (entry.egressScore || 0).toFixed(1),
                                        ") + struct(",
                                        entry.structuralComplexity || 0,
                                        "\xd7",
                                        entry.structuralWeight ?? 0.1,
                                        "=",
                                        (entry.structuralPenalty || 0).toFixed(1),
                                        ") + waste(",
                                        entry.wasteScore || 0,
                                        "\xd7",
                                        entry.wasteWeight ?? 1.0,
                                        "=",
                                        (entry.wastePenalty || 0).toFixed(1),
                                        ") + zone(",
                                        entry.zonePriority !== undefined ? 10 - entry.zonePriority : 0,
                                        "\xd7",
                                        entry.zonePriorityWeight ?? 0,
                                        "=",
                                        (entry.zonePenalty || 0).toFixed(1),
                                        ")",
                                        entry.min_dwell_penalty !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                " + minDwell(",
                                                entry.min_dwell_penalty.toFixed(1),
                                                ")"
                                            ]
                                        }),
                                        " ",
                                        "=",
                                        " ",
                                        ((entry.egressScore || 0) + (entry.structuralPenalty || 0) + (entry.wastePenalty || 0) + (entry.zonePenalty || 0) + (entry.min_dwell_penalty || 0)).toFixed(1),
                                        ")"
                                    ]
                                }),
                                entry.blockedAircraft && entry.blockedAircraft.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        opacity: 0.8,
                                        fontSize: "0.85em"
                                    },
                                    children: [
                                        " ",
                                        "[blocks: ",
                                        entry.blockedAircraft.join(", "),
                                        "]"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: "red"
                            },
                            children: "\u274C Time conflict"
                        }),
                        entry.blockingDetails && entry.blockingDetails.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                pl: compact ? 1 : 2,
                                fontSize: "0.8em",
                                fontWeight: "normal",
                                color: "text.secondary",
                                mt: 0.25
                            },
                            children: entry.blockingDetails.map((detail, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        fontFamily: "monospace"
                                    },
                                    children: [
                                        "\uD83D\uDCCD Blocks ",
                                        getSpotName(detail.spotId),
                                        detail.occupiedBy && ` (${detail.occupiedBy})`,
                                        " - ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                color: detail.isTrapped ? "#ff9800" : "#4caf50"
                                            },
                                            children: detail.reason
                                        })
                                    ]
                                }, idx))
                        }),
                        entry.isGapSpot && entry.gapRequiredSpots && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                pl: compact ? 1 : 2,
                                fontSize: "0.85em",
                                fontWeight: "normal",
                                color: "text.secondary",
                                mt: 0.25
                            },
                            children: [
                                entry.gapDependenciesMet === entry.gapDependenciesTotal ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        color: "green"
                                    },
                                    children: [
                                        "\u2713 Deps: ",
                                        entry.gapRequiredSpots.join(", "),
                                        " (",
                                        entry.gapDependenciesMet,
                                        "/",
                                        entry.gapDependenciesTotal,
                                        ")"
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        color: "orange"
                                    },
                                    children: [
                                        "\u26A0 Deps: ",
                                        entry.gapRequiredSpots.join(", "),
                                        " (",
                                        entry.gapDependenciesMet,
                                        "/",
                                        entry.gapDependenciesTotal,
                                        ")"
                                    ]
                                }),
                                entry.gapCollision && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        color: "red"
                                    },
                                    children: " \u26A0 Collision"
                                })
                            ]
                        }),
                        entry.isGapSpot && entry.reason && !entry.gapRequiredSpots && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                pl: compact ? 1 : 2,
                                fontSize: "0.85em",
                                fontWeight: "normal",
                                color: "info.main",
                                mt: 0.25
                            },
                            children: [
                                "\u2139\uFE0F ",
                                entry.reason
                            ]
                        }),
                        entry.maskDebug && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                pl: compact ? 1 : 2,
                                fontSize: "0.8em",
                                fontWeight: "normal",
                                color: entry.maskDebug.matched === false ? "error.main" : "info.main",
                                mt: 0.25
                            },
                            children: entry.maskDebug.usedMasks ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "\uD83D\uDD27 Mask: ",
                                    entry.maskDebug.maskResult,
                                    entry.maskDebug.loopResult !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            " ",
                                            "| Loop: ",
                                            entry.maskDebug.loopResult,
                                            entry.maskDebug.matched === false && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    color: "#f44336",
                                                    fontWeight: "bold"
                                                },
                                                children: [
                                                    " ",
                                                    "\u274C MISMATCH"
                                                ]
                                            }),
                                            entry.maskDebug.matched === true && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    color: "#4caf50"
                                                },
                                                children: " \u2713"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "\uD83D\uDD27 Loop fallback (no masks)"
                            })
                        })
                    ]
                }, idx);
            }),
            placedLogs.map((placedLog, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        pl: compact ? 0 : 2,
                        color: "success.main",
                        fontWeight: "bold",
                        mb: compact ? 0.5 : 0
                    },
                    children: [
                        "\u2705 Placed at ",
                        getSpotName(placedLog.spotId),
                        placedLog.isGapSpot && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: "#9C27B0"
                            },
                            children: " [GAP]"
                        }),
                        placedLog.lockConstraint && placedLog.lockConstraint.isLocked && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                color: "#FF6F00",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px"
                            },
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ewtCw))), {
                                    sx: {
                                        fontSize: "0.9em"
                                    }
                                }),
                                "[LOCKED]",
                                placedLog.lockConstraint.reason && ` (${placedLog.lockConstraint.reason})`
                            ]
                        }),
                        placedLog.chosenEgressOption && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                opacity: 0.8
                            },
                            children: [
                                " ",
                                "(",
                                formatLaneName(placedLog.chosenEgressOption.laneName),
                                placedLog.availableEgressOptions && placedLog.availableEgressOptions > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        fontSize: "0.9em"
                                    },
                                    children: [
                                        " ",
                                        "\u2013 ",
                                        placedLog.availableEgressOptions,
                                        " lanes"
                                    ]
                                }),
                                ")"
                            ]
                        }),
                        (placedLog.trappedCount !== undefined || placedLog.structuralComplexity !== undefined || placedLog.wasteScore !== undefined || placedLog.zonePriority !== undefined) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                " ",
                                "(",
                                placedLog.trappedCount !== undefined && `${placedLog.trappedCount} traps`,
                                placedLog.trappedCount !== undefined && (placedLog.structuralComplexity !== undefined || placedLog.wasteScore !== undefined || placedLog.zonePriority !== undefined) && ", ",
                                placedLog.structuralComplexity !== undefined && placedLog.structuralComplexity > 0 && `complexity: ${placedLog.structuralComplexity}`,
                                placedLog.structuralComplexity !== undefined && placedLog.structuralComplexity > 0 && (placedLog.wasteScore !== undefined || placedLog.zonePriority !== undefined) && ", ",
                                placedLog.wasteScore !== undefined && placedLog.wasteScore > 0 && `waste: ${placedLog.wasteScore}`,
                                placedLog.wasteScore !== undefined && placedLog.wasteScore > 0 && placedLog.zonePriority !== undefined && ", ",
                                placedLog.zonePriority !== undefined && `zone: ${placedLog.zonePriority}`,
                                (placedLog.egressScore !== undefined || placedLog.structuralPenalty !== undefined || placedLog.wastePenalty !== undefined || placedLog.zonePenalty !== undefined) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        opacity: 0.7,
                                        fontSize: "0.85em",
                                        fontWeight: "normal"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "score: egress(",
                                        placedLog.trappedCount || 0,
                                        "\xd7",
                                        placedLog.egressWeight ?? 1.0,
                                        "=",
                                        (placedLog.egressScore || 0).toFixed(1),
                                        ") + struct(",
                                        placedLog.structuralComplexity || 0,
                                        "\xd7",
                                        placedLog.structuralWeight ?? 0.1,
                                        "=",
                                        (placedLog.structuralPenalty || 0).toFixed(1),
                                        ") + waste(",
                                        placedLog.wasteScore || 0,
                                        "\xd7",
                                        placedLog.wasteWeight ?? 1.0,
                                        "=",
                                        (placedLog.wastePenalty || 0).toFixed(1),
                                        ") + zone(",
                                        placedLog.zonePriority !== undefined ? 10 - placedLog.zonePriority : 0,
                                        "\xd7",
                                        placedLog.zonePriorityWeight ?? 0,
                                        "=",
                                        (placedLog.zonePenalty || 0).toFixed(1),
                                        ")",
                                        placedLog.min_dwell_penalty !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                " + minDwell(",
                                                placedLog.min_dwell_penalty.toFixed(1),
                                                ")"
                                            ]
                                        }),
                                        " ",
                                        "=",
                                        " ",
                                        ((placedLog.egressScore || 0) + (placedLog.structuralPenalty || 0) + (placedLog.wastePenalty || 0) + (placedLog.zonePenalty || 0) + (placedLog.min_dwell_penalty || 0)).toFixed(1)
                                    ]
                                }),
                                ")"
                            ]
                        }),
                        placedLog.blockedAircraft && placedLog.blockedAircraft.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                opacity: 0.8,
                                fontSize: "0.85em",
                                fontWeight: "normal"
                            },
                            children: [
                                " ",
                                "[blocks: ",
                                placedLog.blockedAircraft.join(", "),
                                "]"
                            ]
                        }),
                        placedLog.reason && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                pl: compact ? 1 : 2,
                                fontSize: "0.85em",
                                fontWeight: "normal",
                                color: "info.main"
                            },
                            children: [
                                "\u2139\uFE0F ",
                                placedLog.reason
                            ]
                        })
                    ]
                }, `placed-${idx}`)),
            segmentedLog && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    pl: compact ? 0 : 2,
                    color: "info.main",
                    fontWeight: "bold",
                    mb: compact ? 0.5 : 0
                },
                children: [
                    "\uD83D\uDD00 Segmented: ",
                    segmentedLog.reason
                ]
            }),
            rejectedLog && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    pl: compact ? 0 : 2,
                    color: "error.main",
                    fontWeight: "bold",
                    mb: compact ? 0.5 : 0
                },
                children: [
                    "\u274C ",
                    rejectedLog.reason,
                    rejectedLog.lockConstraint && !rejectedLog.lockConstraint.lockValidated && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            color: "#FF6F00",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px"
                        },
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ewtCw))), {
                                sx: {
                                    fontSize: "0.9em"
                                }
                            }),
                            "[LOCK FAILED]",
                            rejectedLog.lockConstraint.reason && ` (${rejectedLog.lockConstraint.reason})`
                        ]
                    }),
                    rejectedLog.suggestionDetails && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            pl: compact ? 1 : 2,
                            fontSize: "0.85em",
                            mt: 0.5,
                            fontFamily: "monospace"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    color: "error.main",
                                    fontWeight: "bold",
                                    mb: 0.25
                                },
                                children: [
                                    "\uD83C\uDFAF PRIMARY BLOCKER:",
                                    " ",
                                    rejectedLog.suggestionDetails.primaryBlocker === "size" ? "Size incompatible" : rejectedLog.suggestionDetails.primaryBlocker === "time" ? "Time conflicts" : rejectedLog.suggestionDetails.primaryBlocker === "duration" ? "Duration exceeded" : rejectedLog.suggestionDetails.primaryBlocker === "disabled" ? "Spots disabled" : rejectedLog.suggestionDetails.primaryBlocker === "geometry" ? "Geometry collision" : "Unknown",
                                    " ",
                                    "(",
                                    rejectedLog.suggestionDetails.primaryBlocker === "size" ? rejectedLog.filterBreakdown?.sizeIncompatible : rejectedLog.suggestionDetails.primaryBlocker === "time" ? rejectedLog.filterBreakdown?.timeConflict : rejectedLog.suggestionDetails.primaryBlocker === "duration" ? rejectedLog.filterBreakdown?.durationExceeded : rejectedLog.suggestionDetails.primaryBlocker === "disabled" ? rejectedLog.filterBreakdown?.disabled : rejectedLog.suggestionDetails.primaryBlocker === "geometry" ? rejectedLog.filterBreakdown?.geometryCollision : 0,
                                    " ",
                                    "of ",
                                    rejectedLog.filterBreakdown?.total,
                                    " spots)"
                                ]
                            }),
                            rejectedLog.suggestionDetails.suggestions[0] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    color: "primary.main",
                                    fontWeight: "bold",
                                    ml: 1
                                },
                                children: [
                                    "\u2192 ",
                                    rejectedLog.suggestionDetails.suggestions[0].title,
                                    rejectedLog.suggestionDetails.suggestions[0].impact && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            color: "#4caf50"
                                        },
                                        children: [
                                            " ",
                                            "(",
                                            rejectedLog.suggestionDetails.suggestions[0].impact,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    rejectedLog.filterBreakdown && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            pl: compact ? 1 : 2,
                            fontSize: "0.75em",
                            fontWeight: "normal",
                            color: "text.secondary",
                            mt: 0.75,
                            fontFamily: "monospace",
                            opacity: 0.8
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    fontWeight: "bold",
                                    mb: 0.15,
                                    color: "text.primary",
                                    fontSize: "0.95em"
                                },
                                children: "Breakdown:"
                            }),
                            (()=>{
                                const total = rejectedLog.filterBreakdown.total;
                                let remaining = total;
                                const filters = [];
                                // Determine primary blocker for highlighting
                                const primaryBlockerCount = Math.max(rejectedLog.filterBreakdown.disabled, rejectedLog.filterBreakdown.sizeIncompatible, rejectedLog.filterBreakdown.timeConflict, rejectedLog.filterBreakdown.durationExceeded, rejectedLog.filterBreakdown.geometryCollision);
                                if (rejectedLog.filterBreakdown.disabled > 0) {
                                    const isPrimary = rejectedLog.filterBreakdown.disabled === primaryBlockerCount;
                                    filters.push({
                                        label: "Disabled",
                                        eliminated: rejectedLog.filterBreakdown.disabled,
                                        remaining: remaining - rejectedLog.filterBreakdown.disabled,
                                        isPrimary: isPrimary
                                    });
                                    remaining -= rejectedLog.filterBreakdown.disabled;
                                }
                                if (rejectedLog.filterBreakdown.sizeIncompatible > 0) {
                                    const isPrimary = rejectedLog.filterBreakdown.sizeIncompatible === primaryBlockerCount;
                                    filters.push({
                                        label: "Size incompatible",
                                        eliminated: rejectedLog.filterBreakdown.sizeIncompatible,
                                        remaining: remaining - rejectedLog.filterBreakdown.sizeIncompatible,
                                        isPrimary: isPrimary
                                    });
                                    remaining -= rejectedLog.filterBreakdown.sizeIncompatible;
                                }
                                if (rejectedLog.filterBreakdown.timeConflict > 0) {
                                    const isPrimary = rejectedLog.filterBreakdown.timeConflict === primaryBlockerCount;
                                    filters.push({
                                        label: "Time conflicts",
                                        eliminated: rejectedLog.filterBreakdown.timeConflict,
                                        remaining: remaining - rejectedLog.filterBreakdown.timeConflict,
                                        isPrimary: isPrimary
                                    });
                                    remaining -= rejectedLog.filterBreakdown.timeConflict;
                                }
                                if (rejectedLog.filterBreakdown.durationExceeded > 0) {
                                    const isPrimary = rejectedLog.filterBreakdown.durationExceeded === primaryBlockerCount;
                                    filters.push({
                                        label: "Duration exceeded",
                                        eliminated: rejectedLog.filterBreakdown.durationExceeded,
                                        remaining: remaining - rejectedLog.filterBreakdown.durationExceeded,
                                        isPrimary: isPrimary
                                    });
                                    remaining -= rejectedLog.filterBreakdown.durationExceeded;
                                }
                                if (rejectedLog.filterBreakdown.geometryCollision > 0) {
                                    const isPrimary = rejectedLog.filterBreakdown.geometryCollision === primaryBlockerCount;
                                    filters.push({
                                        label: "Geometry collision",
                                        eliminated: rejectedLog.filterBreakdown.geometryCollision,
                                        remaining: remaining - rejectedLog.filterBreakdown.geometryCollision,
                                        isPrimary: isPrimary
                                    });
                                    remaining -= rejectedLog.filterBreakdown.geometryCollision;
                                }
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        ml: 1
                                    },
                                    children: filters.map((filter, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                fontSize: "0.95em",
                                                lineHeight: 1.3
                                            },
                                            children: [
                                                "-",
                                                filter.eliminated,
                                                " ",
                                                filter.label.toLowerCase(),
                                                " (",
                                                Math.round(filter.eliminated / total * 100),
                                                "%)",
                                                filter.isPrimary && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        color: "#f44336",
                                                        marginLeft: "4px"
                                                    },
                                                    children: "\u2190 PRIMARY"
                                                })
                                            ]
                                        }, idx))
                                });
                            })()
                        ]
                    }),
                    rejectedLog.suggestionDetails && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            pl: compact ? 1 : 2,
                            fontSize: "0.75em",
                            fontWeight: "normal",
                            color: "text.secondary",
                            mt: 0.5,
                            fontFamily: "monospace",
                            opacity: 0.85
                        },
                        children: [
                            rejectedLog.suggestionDetails.sizeAnalysis && rejectedLog.suggestionDetails.primaryBlocker === "size" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    mb: 0.75
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            fontWeight: "bold",
                                            mb: 0.25,
                                            color: "text.primary"
                                        },
                                        children: "\uD83D\uDCCA Size Analysis:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            ml: 1
                                        },
                                        children: [
                                            "\u2022 Aircraft:",
                                            " ",
                                            rejectedLog.suggestionDetails.sizeAnalysis.aircraftSize,
                                            rejectedLog.suggestionDetails.sizeAnalysis.aircraftWingspan && rejectedLog.suggestionDetails.sizeAnalysis.aircraftLength && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    opacity: 0.7
                                                },
                                                children: [
                                                    " ",
                                                    "(wingspan:",
                                                    " ",
                                                    rejectedLog.suggestionDetails.sizeAnalysis.aircraftWingspan,
                                                    "ft, length:",
                                                    " ",
                                                    rejectedLog.suggestionDetails.sizeAnalysis.aircraftLength,
                                                    "ft)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            ml: 1
                                        },
                                        children: [
                                            "\u2022 Spots by size:",
                                            " ",
                                            Object.entries(rejectedLog.suggestionDetails.sizeAnalysis.spotsBySize).filter(([_, count])=>count > 0).map(([size, count])=>`${count} ${size}`).join(", ") || "none"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            ml: 1,
                                            color: "error.main",
                                            fontWeight: "bold"
                                        },
                                        children: [
                                            "\u2022 Spots allowing",
                                            " ",
                                            rejectedLog.suggestionDetails.sizeAnalysis.aircraftSize,
                                            ":",
                                            " ",
                                            rejectedLog.suggestionDetails.sizeAnalysis.currentAvailable,
                                            " ",
                                            "of ",
                                            rejectedLog.filterBreakdown?.total || 0
                                        ]
                                    })
                                ]
                            }),
                            rejectedLog.suggestionDetails.timeAnalysis && rejectedLog.suggestionDetails.primaryBlocker === "time" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    mb: 0.75
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            fontWeight: "bold",
                                            mb: 0.25,
                                            color: "text.primary"
                                        },
                                        children: "\u23F0 Time Analysis:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            ml: 1
                                        },
                                        children: [
                                            "\u2022 Aircraft dwell:",
                                            " ",
                                            $d826d4eeeb979148$var$formatBucketTime(rejectedLog.suggestionDetails.timeAnalysis.aircraftArrivalBucket),
                                            " ",
                                            "-",
                                            " ",
                                            $d826d4eeeb979148$var$formatBucketTime(rejectedLog.suggestionDetails.timeAnalysis.aircraftDepartureBucket),
                                            " ",
                                            "(",
                                            rejectedLog.suggestionDetails.timeAnalysis.dwellDurationMinutes,
                                            " ",
                                            "minutes)"
                                        ]
                                    }),
                                    rejectedLog.suggestionDetails.timeAnalysis.peakCongestionStart !== undefined && rejectedLog.suggestionDetails.timeAnalysis.peakCongestionEnd !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    ml: 1,
                                                    color: "warning.main",
                                                    fontWeight: "bold"
                                                },
                                                children: [
                                                    "\u2022 Peak congestion:",
                                                    " ",
                                                    $d826d4eeeb979148$var$formatBucketTime(rejectedLog.suggestionDetails.timeAnalysis.peakCongestionStart),
                                                    " ",
                                                    "-",
                                                    " ",
                                                    $d826d4eeeb979148$var$formatBucketTime(rejectedLog.suggestionDetails.timeAnalysis.peakCongestionEnd),
                                                    rejectedLog.suggestionDetails.timeAnalysis.peakOccupiedSpots !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            opacity: 0.8
                                                        },
                                                        children: [
                                                            " ",
                                                            "(",
                                                            rejectedLog.suggestionDetails.timeAnalysis.peakOccupiedSpots,
                                                            " ",
                                                            "spots occupied)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            rejectedLog.suggestionDetails.timeAnalysis.conflictWindowBuckets !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: [
                                                    "\u2022 Conflict window:",
                                                    " ",
                                                    rejectedLog.suggestionDetails.timeAnalysis.conflictWindowBuckets * 15,
                                                    " ",
                                                    "minutes"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            ml: 1,
                                            color: "error.main",
                                            fontWeight: "bold"
                                        },
                                        children: [
                                            "\u2022 Time conflicts:",
                                            " ",
                                            rejectedLog.filterBreakdown?.timeConflict || 0,
                                            " of",
                                            " ",
                                            rejectedLog.filterBreakdown?.total || 0,
                                            " spots occupied"
                                        ]
                                    })
                                ]
                            }),
                            rejectedLog.suggestionDetails.durationAnalysis && rejectedLog.suggestionDetails.primaryBlocker === "duration" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    mb: 0.75
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            fontWeight: "bold",
                                            mb: 0.25,
                                            color: "text.primary"
                                        },
                                        children: "\u23F1\uFE0F Duration Analysis:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            ml: 1
                                        },
                                        children: [
                                            "\u2022 Required dwell:",
                                            " ",
                                            rejectedLog.suggestionDetails.durationAnalysis.requiredDwellMinutes,
                                            " ",
                                            "minutes"
                                        ]
                                    }),
                                    rejectedLog.suggestionDetails.durationAnalysis.mostRestrictiveLimit && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: [
                                                    "\u2022 Spot limit:",
                                                    " ",
                                                    rejectedLog.suggestionDetails.durationAnalysis.mostRestrictiveLimit,
                                                    " ",
                                                    "minutes"
                                                ]
                                            }),
                                            rejectedLog.suggestionDetails.durationAnalysis.excessDuration && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    ml: 1,
                                                    color: "error.main",
                                                    fontWeight: "bold"
                                                },
                                                children: [
                                                    "\u2022 Exceeds by:",
                                                    " ",
                                                    rejectedLog.suggestionDetails.durationAnalysis.excessDuration,
                                                    " ",
                                                    "minutes"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            rejectedLog.suggestionDetails.nearMisses && rejectedLog.suggestionDetails.nearMisses.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    mb: 0.5,
                                    fontSize: "0.95em"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        color: "warning.main",
                                        fontWeight: "bold"
                                    },
                                    children: [
                                        "\uD83D\uDD0D Quick fix:",
                                        " ",
                                        getSpotName(rejectedLog.suggestionDetails.nearMisses[0].spotId),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                opacity: 0.8
                                            },
                                            children: [
                                                "(",
                                                rejectedLog.suggestionDetails.nearMisses[0].specificIssue,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            rejectedLog.suggestionDetails.suggestions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    mb: 0.25,
                                    mt: 0.5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            fontWeight: "bold",
                                            mb: 0.15,
                                            color: "text.primary",
                                            fontSize: "0.95em"
                                        },
                                        children: "Other options:"
                                    }),
                                    rejectedLog.suggestionDetails.suggestions.slice(1, 2).map((suggestion, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                ml: 1,
                                                fontSize: "0.95em",
                                                opacity: 0.9
                                            },
                                            children: [
                                                "\u2022 ",
                                                suggestion.title,
                                                suggestion.impact && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    style: {
                                                        color: "#4caf50",
                                                        marginLeft: "4px"
                                                    },
                                                    children: [
                                                        "(",
                                                        suggestion.impact,
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }, idx))
                                ]
                            })
                        ]
                    }),
                    rejectedLog.sizeMismatch && rejectedLog.aircraftSize && !rejectedLog.filterBreakdown && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            pl: compact ? 1 : 2,
                            fontSize: "0.85em",
                            fontWeight: "normal",
                            color: "error.dark",
                            opacity: 0.9
                        },
                        children: [
                            "\uD83D\uDD37 Aircraft size: ",
                            $d826d4eeeb979148$var$formatSizeLabel(rejectedLog.aircraftSize),
                            " ",
                            "(",
                            rejectedLog.aircraftSize,
                            ")"
                        ]
                    }),
                    rejectedLog.blockedAircraft && rejectedLog.blockedAircraft.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            opacity: 0.8,
                            fontSize: "0.85em",
                            fontWeight: "normal"
                        },
                        children: [
                            " ",
                            "[would block: ",
                            rejectedLog.blockedAircraft.join(", "),
                            "]"
                        ]
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("bXsOq", function(module, exports) {

$parcel$export(module.exports, "TimelineView", () => $8f55baf62b1fa8f3$export$4e254246a3a175f9);
/**
 * TimelineView Component
 * Visualizes spot occupancy bitmaps over time
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $7Frhn = parcelRequire("7Frhn");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $elGuA = parcelRequire("elGuA");

var $6moNe = parcelRequire("6moNe");

var $kbn5z = parcelRequire("kbn5z");

var $czco8 = parcelRequire("czco8");

var $25rQi = parcelRequire("25rQi");

var $izFuk = parcelRequire("izFuk");
/**
 * Get a color for an aircraft (consistent across timeline)
 *
 * Generated 40 visually distinct colors using HSL color space to avoid repetition
 * when displaying large numbers of aircraft (e.g., TEB schedule with 36 aircraft)
 */ const $8f55baf62b1fa8f3$var$COLORS = [
    "#e63946",
    "#f77f00",
    "#fcbf49",
    "#06d6a0",
    "#118ab2",
    "#073b4c",
    "#9d4edd",
    "#ff006e",
    "#8338ec",
    "#3a86ff",
    "#fb5607",
    "#ffbe0b",
    "#38b000",
    "#00b4d8",
    "#0077b6",
    "#c9184a",
    "#ff4d6d",
    "#ff758f",
    "#06ffa5",
    "#03045e",
    "#7209b7",
    "#b5179e",
    "#f72585",
    "#4361ee",
    "#4cc9f0",
    "#e85d04",
    "#dc2f02",
    "#d00000",
    "#9d0208",
    "#6a040f",
    "#588157",
    "#3a5a40",
    "#344e41",
    "#a3b18a",
    "#dad7cd",
    "#03071e",
    "#370617",
    "#6a040f",
    "#9d0208",
    "#d00000"
];
function $8f55baf62b1fa8f3$var$getAircraftColor(aircraftId, allAircraft) {
    const index = allAircraft.findIndex((ac)=>ac.id === aircraftId);
    // With 40 colors, should cover most scenarios without repetition
    return $8f55baf62b1fa8f3$var$COLORS[index % $8f55baf62b1fa8f3$var$COLORS.length];
}
/**
 * Determine if a specific bucket is in a staging segment
 * Returns segment index if staging, null if permanent or single-spot
 */ function $8f55baf62b1fa8f3$var$getStagingSegmentInfo(spotId, bucket, aircraft, placement, spots) {
    const placed = placement[aircraft.id];
    if (!placed || !("segments" in placed)) // Single-spot placement - not staging
    return {
        isStaging: false,
        segmentIndex: null,
        segmentType: null
    };
    // Find which segment contains this bucket
    const segmentIndex = placed.segments.findIndex((seg)=>seg.spotId === spotId && bucket >= seg.startBucket && bucket < seg.endBucket);
    if (segmentIndex === -1) return {
        isStaging: false,
        segmentIndex: null,
        segmentType: null
    };
    const segment = placed.segments[segmentIndex];
    const spot = spots.find((s)=>s.id === segment.spotId);
    if (!spot) return {
        isStaging: false,
        segmentIndex: segmentIndex,
        segmentType: null
    };
    const isStaging = (0, $kbn5z.isSpotInStagingZone)(spot);
    // Determine segment type based on position and staging status
    let segmentType = null;
    if (isStaging) {
        // Staging segments: first is arrival, last is departure
        if (segmentIndex === 0) segmentType = "arrival";
        else if (segmentIndex === placed.segments.length - 1) segmentType = "departure";
    } else segmentType = "permanent";
    return {
        isStaging: isStaging,
        segmentIndex: segmentIndex,
        segmentType: segmentType
    };
}
/**
 * Extract unique lane IDs and names from spots' egress options
 * Returns array of {laneId, laneName} objects
 */ function $8f55baf62b1fa8f3$var$extractUniqueLanes(spots) {
    const laneMap = new Map();
    for (const spot of spots)if (spot.egressOptions) {
        for (const option of spot.egressOptions)if (!laneMap.has(option.laneId)) laneMap.set(option.laneId, option.laneName);
    }
    return Array.from(laneMap.entries()).map(([laneId, laneName])=>({
            laneId: laneId,
            laneName: laneName
        }));
}
const $8f55baf62b1fa8f3$export$4e254246a3a175f9 = ({ spots: spots, aircraft: aircraft, placement: placement, log: log, zones: zones = [], horizonHours: horizonHours = 24, startTime: startTime = new Date(new Date().setHours(0, 0, 0, 0)), spotIdToName: spotIdToName })=>{
    // State for unplaced aircraft dialog
    const [unplacedDialogOpen, setUnplacedDialogOpen] = $acw62.useState(false);
    const [selectedBucket, setSelectedBucket] = $acw62.useState(0);
    // Calculate total slots (always 15-minute buckets for data accuracy)
    const totalSlots = $acw62.useMemo(()=>horizonHours * 4, [
        horizonHours
    ]);
    // Dynamic display sampling to prevent DOM bloat
    // Data stays at 15-minute resolution, but we only render subset for display
    // 1-2 days: Show every bucket (15-minute precision)
    // 3-7 days: Show every 4th bucket (hourly precision, 4× fewer cells)
    // 8+ days: Show every 8th bucket (2-hour precision, 8× fewer cells)
    const displaySamplingRate = $acw62.useMemo(()=>{
        if (horizonHours <= 48) return 1; // Every bucket (15-min)
        if (horizonHours <= 168) return 4; // Every 4th bucket (hourly)
        return 8; // Every 8th bucket (2-hour)
    }, [
        horizonHours
    ]);
    // Show sampled buckets for display (memoized)
    const buckets = $acw62.useMemo(()=>Array.from({
            length: totalSlots
        }, (_, i)=>i).filter((b)=>b % displaySamplingRate === 0), [
        totalSlots,
        displaySamplingRate
    ]);
    // Determine if we need day labels (multi-day scenarios)
    const showDayLabels = horizonHours > 24;
    // Extract unique lanes from spots for lane utilization rows and sort by name (memoized)
    const lanes = $acw62.useMemo(()=>$8f55baf62b1fa8f3$var$extractUniqueLanes(spots).sort((a, b)=>a.laneName.localeCompare(b.laneName, undefined, {
                numeric: true
            })), [
        spots
    ]);
    // Sort spots by display name for better visual organization (memoized)
    const sortedSpots = $acw62.useMemo(()=>[
            ...spots
        ].sort((a, b)=>{
            const nameA = spotIdToName?.[a.id] || a.id;
            const nameB = spotIdToName?.[b.id] || b.id;
            return nameA.localeCompare(nameB, undefined, {
                numeric: true
            });
        }), [
        spots,
        spotIdToName
    ]);
    // Pre-compute ALL timeline data in a single pass to eliminate race conditions
    // This ensures all cells read from the same snapshot of data
    const timelineData = $acw62.useMemo(()=>{
        // Map: `${spotId}-${bucket}` → aircraft occupying that spot at that time
        const aircraftAtSpotMap = new Map();
        // Map: `${spotId}-${bucket}` → blocking information (if blocked)
        const blockingInfoMap = new Map();
        // Array: utilization data per bucket
        const utilizationData = [];
        // Array: unplaced aircraft per bucket
        const unplacedData = [];
        // Map: `${laneId}-${bucket}` → aircraft departing on that lane at that time
        const laneData = new Map();
        // Map: `${spotId}-${aircraftId}` → block span for tail number display
        const blockSpans = new Map();
        // Pass 1: Build aircraft placement map
        for (const ac of aircraft){
            const placed = placement[ac.id];
            if (!placed) continue;
            if ("segments" in placed) {
                // Segmented placement
                for (const segment of placed.segments)for(let b = segment.startBucket; b < segment.endBucket; b++)aircraftAtSpotMap.set(`${segment.spotId}-${b}`, ac);
            } else // Single placement
            for(let b = ac.arrivalBucket; b < ac.departureBucket; b++)aircraftAtSpotMap.set(`${placed.spotId}-${b}`, ac);
        }
        // Pass 2: Build blocking info map
        for (const spot of spots)for(let bucket = 0; bucket < totalSlots; bucket++){
            const acAtSpot = aircraftAtSpotMap.get(`${spot.id}-${bucket}`);
            if (acAtSpot) continue; // Already occupied, not blocked
            // Check if blocked by another spot
            for (const otherSpot of spots){
                const blocksThisSpot = (otherSpot.egressOptions || []).some((option)=>option.blocksSpotIds.includes(spot.id));
                if (!blocksThisSpot) continue;
                const blockingAircraft = aircraftAtSpotMap.get(`${otherSpot.id}-${bucket}`);
                if (!blockingAircraft) continue;
                if (bucket < blockingAircraft.departureBucket) {
                    blockingInfoMap.set(`${spot.id}-${bucket}`, {
                        blockedBy: blockingAircraft,
                        reason: `Blocked by ${blockingAircraft.tail_number} at ${otherSpot.id} (departs ${(0, $elGuA.bucketToTimeString)(blockingAircraft.departureBucket)})`
                    });
                    break; // Only need one blocking reason
                }
            }
        }
        // Pass 3: Build utilization data
        for(let bucket = 0; bucket < totalSlots; bucket++){
            let occupiedCount = 0;
            for (const spot of spots)if (aircraftAtSpotMap.has(`${spot.id}-${bucket}`)) occupiedCount++;
            const percentage = spots.length > 0 ? Math.round(occupiedCount / spots.length * 100) : 0;
            utilizationData.push({
                count: occupiedCount,
                percentage: percentage
            });
        }
        // Pass 4: Build unplaced aircraft data
        for(let bucket = 0; bucket < totalSlots; bucket++){
            const unplaced = aircraft.filter((ac)=>{
                if (placement[ac.id]) return false;
                return bucket >= ac.arrivalBucket && bucket < ac.departureBucket;
            });
            unplacedData.push(unplaced);
        }
        // Pass 5: Build lane departure data
        for (const lane of lanes)for(let bucket = 0; bucket < totalSlots; bucket++){
            const departing = [];
            for (const ac of aircraft){
                const placed = placement[ac.id];
                if (!placed || ac.departureBucket !== bucket) continue;
                let spotId;
                if ("segments" in placed) spotId = placed.segments[placed.segments.length - 1].spotId;
                else spotId = placed.spotId;
                const spot = spots.find((s)=>s.id === spotId);
                if (spot && spot.egressOptions) {
                    const hasLane = spot.egressOptions.some((option)=>option.laneId === lane.laneId || option.laneName === lane.laneId);
                    if (hasLane) departing.push(ac);
                }
            }
            if (departing.length > 0) laneData.set(`${lane.laneId}-${bucket}`, departing);
        }
        // Pass 6: Build block spans for tail number display
        for (const spot of sortedSpots){
            const blocks = new Map();
            // Find continuous blocks for each aircraft
            for(let bucket = 0; bucket < totalSlots; bucket++){
                const ac = aircraftAtSpotMap.get(`${spot.id}-${bucket}`);
                if (!ac) continue;
                const key = ac.id;
                if (!blocks.has(key)) blocks.set(key, {
                    start: bucket,
                    end: bucket
                });
                else {
                    const block = blocks.get(key);
                    if (bucket === block.end + 1) // Continuous block
                    block.end = bucket;
                    else {
                        // New block (gap in between) - finalize previous and start new
                        const span = block.end - block.start + 1;
                        const middle = block.start + Math.floor(span / 2);
                        blockSpans.set(`${spot.id}-${key}`, {
                            start: block.start,
                            middle: middle,
                            end: block.end
                        });
                        blocks.set(key, {
                            start: bucket,
                            end: bucket
                        });
                    }
                }
            }
            // Finalize remaining blocks
            for (const [acId, block] of blocks.entries()){
                const span = block.end - block.start + 1;
                const middle = block.start + Math.floor(span / 2);
                blockSpans.set(`${spot.id}-${acId}`, {
                    start: block.start,
                    middle: middle,
                    end: block.end
                });
            }
        }
        return {
            aircraftAtSpotMap: aircraftAtSpotMap,
            blockingInfoMap: blockingInfoMap,
            utilizationData: utilizationData,
            unplacedData: unplacedData,
            laneData: laneData,
            blockSpans: blockSpans
        };
    }, [
        spots,
        aircraft,
        placement,
        totalSlots,
        lanes,
        sortedSpots
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7Frhn.default), {
        "data-testid": "timeline-view",
        elevation: 1,
        sx: {
            p: 1.5
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "h6",
                gutterBottom: true,
                children: [
                    "Spot Occupancy Timeline (",
                    horizonHours,
                    "h window)"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                sx: {
                    maxHeight: 600
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                    size: "small",
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                            children: showDayLabels ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                rowSpan: 2,
                                                sx: {
                                                    fontWeight: "bold",
                                                    bgcolor: "grey.100",
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 3,
                                                    minWidth: "60px"
                                                },
                                                children: "Zone"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                rowSpan: 2,
                                                sx: {
                                                    fontWeight: "bold",
                                                    bgcolor: "grey.100",
                                                    position: "sticky",
                                                    left: "60px",
                                                    zIndex: 3,
                                                    minWidth: "105px"
                                                },
                                                children: "Spot"
                                            }),
                                            (()=>{
                                                const days = Math.ceil(horizonHours / 24);
                                                return Array.from({
                                                    length: days
                                                }, (_, dayIndex)=>{
                                                    // Each day spans 96 buckets (24 hours × 4 buckets/hour)
                                                    const bucketsPerDay = 96;
                                                    const dayStartBucket = dayIndex * bucketsPerDay;
                                                    const dayEndBucket = Math.min((dayIndex + 1) * bucketsPerDay, totalSlots);
                                                    // Calculate how many DISPLAYED buckets fall within this day
                                                    // This accounts for display sampling (hourly/2-hour precision)
                                                    const displayedBucketsInDay = buckets.filter((b)=>b >= dayStartBucket && b < dayEndBucket).length;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                                        colSpan: displayedBucketsInDay,
                                                        align: "center",
                                                        sx: {
                                                            fontWeight: "bold",
                                                            bgcolor: "grey.200",
                                                            borderRight: "2px solid rgba(0, 0, 0, 0.3)",
                                                            fontSize: "0.56rem",
                                                            padding: "3px"
                                                        },
                                                        children: [
                                                            "Day ",
                                                            dayIndex + 1
                                                        ]
                                                    }, `day-${dayIndex}`);
                                                });
                                            })()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2XjE0.default), {
                                        children: buckets.map((bucket)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                align: "center",
                                                sx: {
                                                    fontWeight: "bold",
                                                    bgcolor: "grey.100",
                                                    width: "22px",
                                                    maxWidth: "22px",
                                                    minWidth: "22px",
                                                    fontSize: "0.525rem",
                                                    padding: "3px",
                                                    borderRight: bucket % 96 === 95 ? "2px solid rgba(0, 0, 0, 0.3)" : "1px solid rgba(0, 0, 0, 0.2)",
                                                    overflow: "hidden"
                                                },
                                                children: (0, $elGuA.bucketToTimeString)(bucket, startTime, false)
                                            }, bucket))
                                    })
                                ]
                            }) : // Single-day view - just one row with times
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            fontWeight: "bold",
                                            bgcolor: "grey.100",
                                            position: "sticky",
                                            left: 0,
                                            zIndex: 3,
                                            minWidth: "60px"
                                        },
                                        children: "Zone"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            fontWeight: "bold",
                                            bgcolor: "grey.100",
                                            position: "sticky",
                                            left: "60px",
                                            zIndex: 3,
                                            minWidth: "105px"
                                        },
                                        children: "Spot"
                                    }),
                                    buckets.map((bucket)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            align: "center",
                                            sx: {
                                                fontWeight: "bold",
                                                bgcolor: "grey.100",
                                                width: "22px",
                                                maxWidth: "22px",
                                                minWidth: "22px",
                                                fontSize: "0.525rem",
                                                padding: "3px",
                                                borderRight: "1px solid rgba(0, 0, 0, 0.2)",
                                                overflow: "hidden"
                                            },
                                            children: displaySamplingRate === 1 && bucket % 4 !== 0 ? "" : (0, $elGuA.bucketToTimeString)(bucket, startTime, false)
                                        }, bucket))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $QpuKB.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            colSpan: 2,
                                            component: "th",
                                            scope: "row",
                                            sx: {
                                                fontWeight: "bold",
                                                bgcolor: "white",
                                                position: "sticky",
                                                left: 0,
                                                zIndex: 1,
                                                color: "primary.main",
                                                minWidth: "165px"
                                            },
                                            children: "Utilization"
                                        }),
                                        buckets.map((bucket)=>{
                                            const { percentage: percentage } = timelineData.utilizationData[bucket];
                                            // Color based on utilization percentage
                                            let bgcolor = "transparent";
                                            let color = "text.disabled";
                                            if (percentage >= 70) {
                                                bgcolor = "success.100";
                                                color = "success.dark";
                                            } else if (percentage >= 40) {
                                                bgcolor = "warning.100";
                                                color = "warning.dark";
                                            } else if (percentage > 0) {
                                                bgcolor = "grey.100";
                                                color = "text.secondary";
                                            }
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                align: "center",
                                                sx: {
                                                    bgcolor: bgcolor,
                                                    color: color,
                                                    fontSize: "0.525rem",
                                                    fontFamily: "monospace",
                                                    fontWeight: percentage > 0 ? "bold" : "normal",
                                                    padding: "3px",
                                                    width: "22px",
                                                    maxWidth: "22px",
                                                    minWidth: "22px",
                                                    borderRight: "1px solid rgba(0, 0, 0, 0.2)",
                                                    overflow: "hidden"
                                                },
                                                children: percentage > 0 ? `${percentage}%` : "\u2014"
                                            }, bucket);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            colSpan: 2,
                                            component: "th",
                                            scope: "row",
                                            sx: {
                                                fontWeight: "bold",
                                                bgcolor: "white",
                                                position: "sticky",
                                                left: 0,
                                                zIndex: 1,
                                                color: "primary.main",
                                                minWidth: "165px"
                                            },
                                            children: "Placed"
                                        }),
                                        buckets.map((bucket)=>{
                                            const { count: count, percentage: percentage } = timelineData.utilizationData[bucket];
                                            // Color based on utilization percentage (darker than Utilization row)
                                            let bgcolor = "transparent";
                                            let color = "text.disabled";
                                            if (percentage >= 70) {
                                                bgcolor = "success.200";
                                                color = "success.dark";
                                            } else if (percentage >= 40) {
                                                bgcolor = "warning.200";
                                                color = "warning.dark";
                                            } else if (count > 0) {
                                                bgcolor = "grey.200";
                                                color = "text.primary";
                                            }
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                align: "center",
                                                sx: {
                                                    bgcolor: bgcolor,
                                                    color: color,
                                                    fontSize: "0.525rem",
                                                    fontFamily: "monospace",
                                                    fontWeight: count > 0 ? "bold" : "normal",
                                                    padding: "3px",
                                                    width: "22px",
                                                    maxWidth: "22px",
                                                    minWidth: "22px",
                                                    borderRight: "1px solid rgba(0, 0, 0, 0.2)",
                                                    overflow: "hidden"
                                                },
                                                children: count > 0 ? count : "\u2014"
                                            }, bucket);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            colSpan: 2,
                                            component: "th",
                                            scope: "row",
                                            sx: {
                                                fontWeight: "bold",
                                                bgcolor: "white",
                                                position: "sticky",
                                                left: 0,
                                                zIndex: 1,
                                                color: "error.main",
                                                minWidth: "165px"
                                            },
                                            children: "Unplaced"
                                        }),
                                        buckets.map((bucket)=>{
                                            const unplacedAircraft = timelineData.unplacedData[bucket];
                                            const count = unplacedAircraft.length;
                                            const tailNumbers = unplacedAircraft.map((ac)=>ac.tail_number).join(", ");
                                            const handleClick = ()=>{
                                                if (count > 0) {
                                                    setSelectedBucket(bucket);
                                                    setUnplacedDialogOpen(true);
                                                }
                                            };
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                align: "center",
                                                sx: {
                                                    bgcolor: count > 0 ? "error.100" : "transparent",
                                                    color: count > 0 ? "error.main" : "text.disabled",
                                                    fontSize: "0.525rem",
                                                    fontFamily: "monospace",
                                                    fontWeight: count > 0 ? "bold" : "normal",
                                                    padding: "3px",
                                                    width: "22px",
                                                    maxWidth: "22px",
                                                    minWidth: "22px",
                                                    borderRight: "1px solid rgba(0, 0, 0, 0.2)",
                                                    overflow: "hidden"
                                                },
                                                children: count > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: `${tailNumbers} (click for details)`,
                                                    arrow: true,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        onClick: handleClick,
                                                        style: {
                                                            cursor: "pointer",
                                                            userSelect: "none"
                                                        },
                                                        children: count
                                                    })
                                                }) : "\u2014"
                                            }, bucket);
                                        })
                                    ]
                                }),
                                lanes.map((lane)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                colSpan: 2,
                                                component: "th",
                                                scope: "row",
                                                sx: {
                                                    fontWeight: "bold",
                                                    bgcolor: "white",
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 1,
                                                    color: "warning.main",
                                                    minWidth: "165px"
                                                },
                                                children: lane.laneName
                                            }),
                                            buckets.map((bucket)=>{
                                                const departingAircraft = timelineData.laneData.get(`${lane.laneId}-${bucket}`) || [];
                                                const count = departingAircraft.length;
                                                const tailNumbers = departingAircraft.map((ac)=>ac.tail_number).join(", ");
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                    align: "center",
                                                    sx: {
                                                        bgcolor: count > 0 ? "warning.200" : "transparent",
                                                        color: count > 0 ? "warning.dark" : "text.disabled",
                                                        fontSize: "0.525rem",
                                                        fontFamily: "monospace",
                                                        fontWeight: count > 0 ? "bold" : "normal",
                                                        padding: "3px",
                                                        width: "22px",
                                                        maxWidth: "22px",
                                                        minWidth: "22px",
                                                        borderRight: "1px solid rgba(0, 0, 0, 0.2)",
                                                        overflow: "hidden"
                                                    },
                                                    children: count > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: `Departing: ${tailNumbers}`,
                                                        arrow: true,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                cursor: "help"
                                                            },
                                                            children: count
                                                        })
                                                    }) : "\u2014"
                                                }, bucket);
                                            })
                                        ]
                                    }, lane.laneId)),
                                sortedSpots.map((spot)=>{
                                    // Find spot's zone and check if disabled
                                    const spotZone = zones.find((z)=>z.id === spot.zoneId);
                                    const isDisabled = !(0, $6moNe.isSpotEnabled)(spot, zones);
                                    const isSpotDirectlyDisabled = spot.disabled === true;
                                    const isZoneDisabled = spotZone?.disabled === true;
                                    // Determine disabled reason for tooltip
                                    let disabledReason = "";
                                    if (isSpotDirectlyDisabled && isZoneDisabled) disabledReason = `Spot disabled AND ${spotZone?.name || "Zone"} disabled`;
                                    else if (isSpotDirectlyDisabled) disabledReason = "Spot disabled (unavailable to algorithm)";
                                    else if (isZoneDisabled) disabledReason = `${spotZone?.name || "Zone"} disabled (all spots in zone unavailable)`;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                                component: "th",
                                                scope: "row",
                                                sx: {
                                                    fontWeight: "normal",
                                                    bgcolor: "grey.50",
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 1,
                                                    minWidth: "60px",
                                                    color: isZoneDisabled ? "text.disabled" : "text.secondary",
                                                    fontSize: "0.56rem"
                                                },
                                                children: [
                                                    isZoneDisabled && "\uD83D\uDEAB ",
                                                    spotZone?.name || "\u2014"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                                component: "th",
                                                scope: "row",
                                                sx: {
                                                    fontWeight: "bold",
                                                    bgcolor: "grey.50",
                                                    position: "sticky",
                                                    left: "60px",
                                                    zIndex: 1,
                                                    minWidth: "105px",
                                                    color: isDisabled ? "text.disabled" : "inherit",
                                                    textDecoration: isDisabled ? "line-through" : "none"
                                                },
                                                children: [
                                                    isDisabled && "\uD83D\uDEAB ",
                                                    (0, $kbn5z.isSpotInStagingZone)(spot) && "\uD83D\uDD36 ",
                                                    spotIdToName?.[spot.id] || spot.id,
                                                    " ",
                                                    spot.allowedSizes.length < 5 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                        component: "span",
                                                        sx: {
                                                            fontSize: "0.49rem",
                                                            color: isDisabled ? "text.disabled" : "text.secondary",
                                                            fontWeight: "normal"
                                                        },
                                                        children: [
                                                            "(",
                                                            (0, $czco8.formatSizeCategories)(spot.allowedSizes),
                                                            ")"
                                                        ]
                                                    }),
                                                    isDisabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: disabledReason,
                                                        arrow: true,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                            component: "span",
                                                            sx: {
                                                                ml: 0.5,
                                                                color: "error.main",
                                                                fontSize: "0.49rem",
                                                                fontWeight: "bold"
                                                            },
                                                            children: "(DISABLED)"
                                                        })
                                                    })
                                                ]
                                            }),
                                            buckets.map((bucket)=>{
                                                const ac = timelineData.aircraftAtSpotMap.get(`${spot.id}-${bucket}`);
                                                // Determine if tail number should be shown (pre-computed)
                                                const blockSpan = ac ? timelineData.blockSpans.get(`${spot.id}-${ac.id}`) : null;
                                                const showTailNumber = blockSpan ? bucket === blockSpan.middle : false;
                                                // Check if this spot is blocked by another aircraft (pre-computed)
                                                const blockingInfo = !ac ? timelineData.blockingInfoMap.get(`${spot.id}-${bucket}`) : null;
                                                // Determine if this bucket is in a staging segment
                                                const stagingInfo = ac ? $8f55baf62b1fa8f3$var$getStagingSegmentInfo(spot.id, bucket, ac, placement, spots) : null;
                                                // Color-code segments: orange for staging, normal colors for permanent
                                                const backgroundColor = ac ? stagingInfo?.isStaging ? "#FF9800" // Orange for staging segments
                                                 : $8f55baf62b1fa8f3$var$getAircraftColor(ac.id, aircraft) // Normal color for permanent
                                                 : "transparent";
                                                // Add diagonal stripes pattern for blocked spots
                                                const blockedPattern = blockingInfo ? "repeating-linear-gradient(45deg, rgba(255, 152, 0, 0.3), rgba(255, 152, 0, 0.3) 2px, transparent 2px, transparent 4px)" : undefined;
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                    align: "center",
                                                    sx: {
                                                        bgcolor: backgroundColor,
                                                        backgroundImage: blockedPattern,
                                                        color: ac ? "white" : blockingInfo ? "warning.dark" : "text.disabled",
                                                        fontSize: "0.525rem",
                                                        fontFamily: "monospace",
                                                        padding: "3px",
                                                        width: "22px",
                                                        maxWidth: "22px",
                                                        minWidth: "22px",
                                                        borderRight: "1px solid rgba(0, 0, 0, 0.2)",
                                                        overflow: "hidden",
                                                        position: "relative"
                                                    },
                                                    children: ac ? showTailNumber ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                            sx: {
                                                                bgcolor: "white",
                                                                p: 1.5,
                                                                minWidth: 400
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25rQi.DecisionLogDisplay), {
                                                                aircraft: ac,
                                                                log: log,
                                                                compact: true,
                                                                spotIdToName: spotIdToName
                                                            })
                                                        }),
                                                        arrow: true,
                                                        componentsProps: {
                                                            tooltip: {
                                                                sx: {
                                                                    bgcolor: "white",
                                                                    boxShadow: 3,
                                                                    maxWidth: "none",
                                                                    "& .MuiTooltip-arrow": {
                                                                        color: "white"
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                            sx: {
                                                                cursor: "help",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                width: "100%",
                                                                height: "100%",
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0
                                                            },
                                                            children: [
                                                                ac.tail_number,
                                                                stagingInfo?.segmentType && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    component: "span",
                                                                    sx: {
                                                                        fontSize: "0.4rem",
                                                                        opacity: 0.8,
                                                                        ml: 0.2
                                                                    },
                                                                    children: stagingInfo.segmentType === "arrival" ? " (A)" : stagingInfo.segmentType === "departure" ? " (D)" : ""
                                                                })
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                        sx: {
                                                            width: "100%",
                                                            height: "100%",
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0
                                                        }
                                                    }) : blockingInfo ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: blockingInfo.reason,
                                                        arrow: true,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                cursor: "help",
                                                                fontSize: "0.45rem"
                                                            },
                                                            children: "\uD83D\uDEAB"
                                                        })
                                                    }) : "\u2014"
                                                }, bucket);
                                            })
                                        ]
                                    }, spot.id);
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $izFuk.UnplacedAircraftDialog), {
                open: unplacedDialogOpen,
                onClose: ()=>setUnplacedDialogOpen(false),
                unplacedAircraft: timelineData.unplacedData[selectedBucket] || [],
                bucket: selectedBucket,
                log: log,
                spotIdToName: spotIdToName,
                startTime: startTime
            })
        ]
    });
};

});
parcelRegister("izFuk", function(module, exports) {

$parcel$export(module.exports, "UnplacedAircraftDialog", () => $5f03455a78413635$export$dfd590345b54a4b8);
/**
 * UnplacedAircraftDialog Component
 * Displays decision logs for unplaced aircraft at a specific time bucket
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $dqlTG = parcelRequire("dqlTG");

var $03mUs = parcelRequire("03mUs");
var $6MV2p = parcelRequire("6MV2p");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $9Lykx = parcelRequire("9Lykx");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $elGuA = parcelRequire("elGuA");

var $25rQi = parcelRequire("25rQi");
const $5f03455a78413635$export$dfd590345b54a4b8 = /*#__PURE__*/ $acw62.memo(({ open: open, onClose: onClose, unplacedAircraft: unplacedAircraft, bucket: bucket, log: log, spotIdToName: spotIdToName = {}, startTime: startTime = new Date(new Date().setHours(0, 0, 0, 0)) })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "h6",
                                    component: "div",
                                    children: [
                                        "Unplaced Aircraft at ",
                                        (0, $elGuA.bucketToTimeString)(bucket, startTime)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: [
                                        unplacedAircraft.length,
                                        " aircraft could not be placed at this time"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            edge: "end",
                            color: "inherit",
                            onClick: onClose,
                            "aria-label": "close",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        maxHeight: "70vh",
                        overflow: "auto"
                    },
                    children: unplacedAircraft.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        color: "text.secondary",
                        sx: {
                            py: 2
                        },
                        children: "No unplaced aircraft at this time"
                    }) : unplacedAircraft.map((aircraft)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                mb: 3,
                                pb: 3,
                                borderBottom: "1px solid",
                                borderColor: "divider",
                                "&:last-child": {
                                    borderBottom: "none",
                                    mb: 0,
                                    pb: 0
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25rQi.DecisionLogDisplay), {
                                aircraft: aircraft,
                                log: log,
                                spotIdToName: spotIdToName
                            })
                        }, aircraft.id))
                })
            })
        ]
    });
});

});


parcelRegister("gqmpX", function(module, exports) {

$parcel$export(module.exports, "CapacityBar", () => $ef005d1f6c3008ee$export$29bce99810bf3a25);
/**
 * CapacityBar Component
 * Visual indicator of spot capacity utilization and filter breakdown
 * Inspired by Claude Code's context usage visualization
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");
const $ef005d1f6c3008ee$export$29bce99810bf3a25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ totalSpots: totalSpots, placedCount: placedCount, availableCount: availableCount, filterBreakdown: filterBreakdown })=>{
    const theme = (0, $14H9o.default)();
    // Calculate counts
    const filteredCount = totalSpots - placedCount - availableCount;
    const placedPercentage = totalSpots > 0 ? placedCount / totalSpots * 100 : 0;
    // Calculate proportions for visual bar (in percentages)
    const placedWidth = totalSpots > 0 ? placedCount / totalSpots * 100 : 0;
    const availableWidth = totalSpots > 0 ? availableCount / totalSpots * 100 : 0;
    const filteredWidth = totalSpots > 0 ? filteredCount / totalSpots * 100 : 0;
    // Color palette
    const colors = {
        placed: theme.palette.success.main,
        available: theme.palette.primary.main,
        filtered: theme.palette.grey[400],
        time: theme.palette.error.main,
        size: theme.palette.warning.main,
        duration: theme.palette.warning.light,
        disabled: theme.palette.grey[500],
        geometry: theme.palette.secondary.main
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            mb: 2,
            p: 2,
            border: 1,
            borderColor: "divider",
            borderRadius: 1,
            bgcolor: "background.paper"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        sx: {
                            fontWeight: "bold"
                        },
                        children: "Spot Capacity"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        sx: {
                            fontFamily: "monospace",
                            color: "text.secondary"
                        },
                        children: [
                            placedCount,
                            "/",
                            totalSpots,
                            " spots (",
                            placedPercentage.toFixed(0),
                            "% utilized)"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    height: "24px",
                    width: "100%",
                    borderRadius: "4px",
                    overflow: "hidden",
                    bgcolor: theme.palette.grey[200],
                    mb: 1
                },
                children: [
                    placedWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            width: `${placedWidth}%`,
                            bgcolor: colors.placed,
                            transition: "width 0.3s ease"
                        },
                        title: `${placedCount} placed`
                    }),
                    availableWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            width: `${availableWidth}%`,
                            bgcolor: colors.available,
                            transition: "width 0.3s ease"
                        },
                        title: `${availableCount} available`
                    }),
                    filteredWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            width: `${filteredWidth}%`,
                            bgcolor: colors.filtered,
                            transition: "width 0.3s ease"
                        },
                        title: `${filteredCount} filtered`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    fontSize: "0.875rem"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    width: 12,
                                    height: 12,
                                    bgcolor: colors.placed,
                                    borderRadius: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                children: [
                                    "Placed ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                        children: [
                                            "(",
                                            placedCount,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    width: 12,
                                    height: 12,
                                    bgcolor: colors.available,
                                    borderRadius: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                children: [
                                    "Available ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                        children: [
                                            "(",
                                            availableCount,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    filteredCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    width: 12,
                                    height: 12,
                                    bgcolor: colors.filtered,
                                    borderRadius: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                children: [
                                    "Filtered ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                        children: [
                                            "(",
                                            filteredCount,
                                            ")"
                                        ]
                                    }),
                                    filterBreakdown && (filterBreakdown.timeConflict > 0 || filterBreakdown.sizeIncompatible > 0 || filterBreakdown.durationExceeded > 0 || filterBreakdown.disabled > 0 || filterBreakdown.geometryCollision > 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            color: theme.palette.text.secondary
                                        },
                                        children: [
                                            ":",
                                            " ",
                                            [
                                                filterBreakdown.timeConflict > 0 && `Time (${filterBreakdown.timeConflict})`,
                                                filterBreakdown.sizeIncompatible > 0 && `Size (${filterBreakdown.sizeIncompatible})`,
                                                filterBreakdown.durationExceeded > 0 && `Duration (${filterBreakdown.durationExceeded})`,
                                                filterBreakdown.disabled > 0 && `Disabled (${filterBreakdown.disabled})`,
                                                filterBreakdown.geometryCollision > 0 && `Geometry (${filterBreakdown.geometryCollision})`
                                            ].filter(Boolean).join(" \xb7 ")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
$ef005d1f6c3008ee$export$29bce99810bf3a25.displayName = "CapacityBar";

});

parcelRegister("hfdp4", function(module, exports) {

$parcel$export(module.exports, "PlacementTableView", () => $7849f1516335c961$export$6f1acdfc0b8dc7a2);
/**
 * PlacementTableView - Compact table display for AutoPark results
 *
 * Linear/Stripe-inspired table view optimized for quick scanning and searching.
 * Shows aircraft placements in a sortable, filterable table format.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $fIZH8 = parcelRequire("fIZH8");

var $hcqd9 = parcelRequire("hcqd9");

var $7cmsE = parcelRequire("7cmsE");

var $6aDwK = parcelRequire("6aDwK");
const $7849f1516335c961$export$6f1acdfc0b8dc7a2 = ({ placement: placement, requests: requests, spots: spots, zones: zones = [], rampShapes: rampShapes, startTime: startTime, partialPlacements: partialPlacements, onScheduleChanged: onScheduleChanged, enableEditing: enableEditing = false })=>{
    // Filter/sort state
    const [filterMode, setFilterMode] = (0, $acw62.useState)("all");
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)("");
    const [sortBy, setSortBy] = (0, $acw62.useState)("status");
    const [sortOrder, setSortOrder] = (0, $acw62.useState)("asc");
    // Expanded rows state
    const [expandedRowIds, setExpandedRowIds] = (0, $acw62.useState)(new Set());
    // Create spot ID to name mapping
    const spotIdToName = (0, $acw62.useMemo)(()=>{
        const mapping = {};
        rampShapes.forEach((shape)=>{
            if (shape.type === "Spot" && shape.text) mapping[shape.id] = shape.text;
        });
        return mapping;
    }, [
        rampShapes
    ]);
    // Build table rows
    const baseRows = (0, $acw62.useMemo)(()=>(0, $fIZH8.buildTableRows)(requests, placement, startTime, partialPlacements, spotIdToName), [
        requests,
        placement,
        startTime,
        partialPlacements,
        spotIdToName
    ]);
    // Apply filters and sorting
    const filteredRows = (0, $acw62.useMemo)(()=>{
        let rows = (0, $fIZH8.filterByStatus)(baseRows, filterMode);
        rows = (0, $fIZH8.filterBySearch)(rows, searchQuery);
        rows = (0, $fIZH8.sortRows)(rows, sortBy, sortOrder);
        return rows;
    }, [
        baseRows,
        filterMode,
        searchQuery,
        sortBy,
        sortOrder
    ]);
    // Handle sort column click
    const handleSort = (column)=>{
        if (sortBy === column) // Toggle order
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        else {
            // New column - default to ascending
            setSortBy(column);
            setSortOrder("asc");
        }
    };
    // Handle row expansion
    const handleRowClick = (aircraftId)=>{
        setExpandedRowIds((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(aircraftId)) newSet.delete(aircraftId);
            else newSet.add(aircraftId);
            return newSet;
        });
    };
    // Calculate filter counts
    const filterCounts = (0, $acw62.useMemo)(()=>{
        const all = baseRows.length;
        const placed = baseRows.filter((r)=>r.status === "placed" || r.status === "partial").length;
        const unplaced = baseRows.filter((r)=>r.status === "unplaced").length;
        return {
            all: all,
            placed: placed,
            unplaced: unplaced
        };
    }, [
        baseRows
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hcqd9.PlacementTableFilters), {
                filterMode: filterMode,
                onFilterModeChange: setFilterMode,
                searchQuery: searchQuery,
                onSearchQueryChange: setSearchQuery,
                sortBy: sortBy,
                sortOrder: sortOrder,
                onSortChange: handleSort,
                filterCounts: filterCounts
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    flex: 1,
                    overflow: "auto"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: "100px 180px 1fr 130px 130px 90px",
                            gap: 2,
                            alignItems: "center",
                            height: 40,
                            px: 2,
                            py: 1,
                            bgcolor: "grey.50",
                            borderBottom: "1px solid",
                            borderColor: "grey.200",
                            position: "sticky",
                            top: 0,
                            zIndex: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                onClick: ()=>handleSort("status"),
                                sx: {
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "grey.600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer"
                                },
                                children: [
                                    "STATUS",
                                    " ",
                                    sortBy === "status" ? sortOrder === "asc" ? "\u2191" : "\u2193" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                onClick: ()=>handleSort("tail"),
                                sx: {
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "grey.600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer"
                                },
                                children: [
                                    "TAIL # ",
                                    sortBy === "tail" ? sortOrder === "asc" ? "\u2191" : "\u2193" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                onClick: ()=>handleSort("spot"),
                                sx: {
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "grey.600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer"
                                },
                                children: [
                                    "SPOT(S) ",
                                    sortBy === "spot" ? sortOrder === "asc" ? "\u2191" : "\u2193" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                onClick: ()=>handleSort("arrival"),
                                sx: {
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "grey.600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer"
                                },
                                children: [
                                    "ARRIVAL",
                                    " ",
                                    sortBy === "arrival" ? sortOrder === "asc" ? "\u2191" : "\u2193" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                onClick: ()=>handleSort("departure"),
                                sx: {
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "grey.600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer"
                                },
                                children: [
                                    "DEPARTURE",
                                    " ",
                                    sortBy === "departure" ? sortOrder === "asc" ? "\u2191" : "\u2193" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                sx: {
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "grey.600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px"
                                },
                                children: "DWELL"
                            })
                        ]
                    }),
                    filteredRows.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cmsE.PlacementTableRow), {
                            row: row,
                            isExpanded: expandedRowIds.has(row.aircraftId),
                            onRowClick: handleRowClick,
                            enableEditing: enableEditing,
                            onScheduleChanged: onScheduleChanged,
                            spots: spots,
                            zones: zones,
                            spotIdToName: spotIdToName
                        }, row.aircraftId))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6aDwK.PlacementTableSummary), {
                totalCount: baseRows.length,
                filteredCount: filteredRows.length,
                placedCount: filterCounts.placed,
                unplacedCount: filterCounts.unplaced
            })
        ]
    });
};

});
parcelRegister("fIZH8", function(module, exports) {

$parcel$export(module.exports, "buildTableRows", () => $f2c67f41e249927d$export$c044826cee7e9450);
$parcel$export(module.exports, "filterByStatus", () => $f2c67f41e249927d$export$1caf81d27b0e4d0e);
$parcel$export(module.exports, "filterBySearch", () => $f2c67f41e249927d$export$8b8e2e3e5a90c9ec);
$parcel$export(module.exports, "sortRows", () => $f2c67f41e249927d$export$bc58d7f8cf8938c3);
/**
 * Build Table Rows - Transform placement data for table display
 *
 * Converts AutoPark algorithm output into a tabular format optimized for the PlacementTableView.
 * Each row represents one aircraft with its placement status, spot assignment(s), and timing information.
 */ 
var $kCLFX = parcelRequire("kCLFX");

var $czco8 = parcelRequire("czco8");

var $h7RLZ = parcelRequire("h7RLZ");
/**
 * Convert time bucket to Date
 */ function $f2c67f41e249927d$var$bucketToDate(bucket, baseDate) {
    return (0, $kCLFX.addHours)(baseDate, bucket * 0.25); // 15-minute buckets
}
/**
 * Format spot summary for display
 * - Single spot: "M1"
 * - 2-3 spots: "M1 → F3 → M1"
 * - 4+ spots: "M1 + 3 more"
 */ function $f2c67f41e249927d$var$formatSpotSummary(spotIds) {
    if (spotIds.length === 0) return "\u2014";
    if (spotIds.length === 1) return spotIds[0];
    if (spotIds.length <= 3) return spotIds.join(" \u2192 ");
    return `${spotIds[0]} + ${spotIds.length - 1} more`;
}
function $f2c67f41e249927d$export$c044826cee7e9450(aircraft, placement, startTime, partialPlacements, spotIdToName) {
    return aircraft.map((ac)=>{
        const placed = placement[ac.id];
        const partial = partialPlacements.find((p)=>p.aircraftId === ac.id);
        // Determine status
        let status;
        if (!placed) status = "unplaced";
        else if (partial) status = "partial";
        else status = "placed";
        // Extract spot information
        let spotIds = [];
        let spotSummary;
        let moveCount = 0;
        let segments;
        if (!placed) {
            // Unplaced
            spotIds = [];
            spotSummary = "\u2014";
        } else if ("segments" in placed) {
            // Multi-segment placement
            segments = placed.segments.map((seg)=>({
                    spotId: seg.spotId,
                    startBucket: seg.startBucket,
                    endBucket: seg.endBucket
                }));
            spotIds = segments.map((s)=>s.spotId);
            moveCount = placed.moveCount;
            // Use display names if available
            const displayNames = spotIds.map((id)=>spotIdToName[id] || id);
            spotSummary = $f2c67f41e249927d$var$formatSpotSummary(displayNames);
        } else {
            // Single placement
            spotIds = [
                placed.spotId
            ];
            const displayName = spotIdToName[placed.spotId] || placed.spotId;
            spotSummary = displayName;
            // Create single segment for display
            segments = [
                {
                    spotId: placed.spotId,
                    startBucket: ac.arrivalBucket,
                    endBucket: ac.departureBucket
                }
            ];
        }
        // Calculate timing
        const arrivalTime = $f2c67f41e249927d$var$bucketToDate(ac.arrivalBucket, startTime);
        const departureTime = $f2c67f41e249927d$var$bucketToDate(ac.departureBucket, startTime);
        const dwellMinutes = (ac.departureBucket - ac.arrivalBucket) * 15;
        const dwellFormatted = (0, $h7RLZ.formatDuration)(dwellMinutes);
        // Extract aircraft information
        const aircraftMake = ac.aircraft?.make || "";
        const aircraftModel = ac.aircraft?.model || "Unknown";
        return {
            // Identity
            aircraftId: ac.id,
            tailNumber: ac.tail_number,
            aircraftModel: aircraftModel,
            aircraftMake: aircraftMake,
            sizeCategory: ac.sizeCategory,
            status: // Placement status
            status,
            spotSummary: spotSummary,
            spotIds: spotIds,
            moveCount: moveCount,
            // Timing
            arrivalBucket: ac.arrivalBucket,
            departureBucket: ac.departureBucket,
            arrivalTime: arrivalTime,
            departureTime: departureTime,
            dwellMinutes: dwellMinutes,
            dwellFormatted: dwellFormatted,
            segments: // Additional metadata
            segments,
            partialInfo: partial,
            placementSource: ac.placement_source,
            isLocked: ac.is_locked
        };
    });
}
function $f2c67f41e249927d$export$1caf81d27b0e4d0e(rows, filterMode) {
    if (filterMode === "all") return rows;
    if (filterMode === "placed") return rows.filter((r)=>r.status === "placed" || r.status === "partial");
    if (filterMode === "unplaced") return rows.filter((r)=>r.status === "unplaced");
    return rows;
}
function $f2c67f41e249927d$export$8b8e2e3e5a90c9ec(rows, query) {
    if (!query.trim()) return rows;
    const lowerQuery = query.toLowerCase();
    return rows.filter((r)=>r.tailNumber.toLowerCase().includes(lowerQuery));
}
function $f2c67f41e249927d$export$5e4cb54eb22bb463(rows, zoneFilter, spotToZone) {
    if (!zoneFilter) return rows;
    return rows.filter((r)=>{
        // Check if any of the row's spots belong to the selected zone
        return r.spotIds.some((spotId)=>spotToZone[spotId] === zoneFilter);
    });
}
function $f2c67f41e249927d$export$bc58d7f8cf8938c3(rows, sortBy, sortOrder) {
    const sorted = [
        ...rows
    ].sort((a, b)=>{
        let comparison = 0;
        switch(sortBy){
            case "status":
                // Order: unplaced → partial → placed
                const statusOrder = {
                    unplaced: 0,
                    partial: 1,
                    placed: 2
                };
                comparison = statusOrder[a.status] - statusOrder[b.status];
                break;
            case "tail":
                comparison = a.tailNumber.localeCompare(b.tailNumber);
                break;
            case "spot":
                comparison = a.spotSummary.localeCompare(b.spotSummary);
                break;
            case "arrival":
                comparison = a.arrivalBucket - b.arrivalBucket;
                break;
            case "departure":
                comparison = a.departureBucket - b.departureBucket;
                break;
        }
        return sortOrder === "asc" ? comparison : -comparison;
    });
    return sorted;
}

});

parcelRegister("hcqd9", function(module, exports) {

$parcel$export(module.exports, "PlacementTableFilters", () => $e59bff123f9b1e92$export$c32e4a96aee31c9f);
/**
 * PlacementTableFilters - Filter controls for PlacementTableView
 *
 * Sticky filter bar with status chips, search input, and sort controls.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $2P5BT = parcelRequire("2P5BT");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $hViLc = parcelRequire("hViLc");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
parcelRequire("acw62");
const $e59bff123f9b1e92$export$c32e4a96aee31c9f = ({ filterMode: filterMode, onFilterModeChange: onFilterModeChange, searchQuery: searchQuery, onSearchQueryChange: onSearchQueryChange, filterCounts: filterCounts })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            position: 'sticky',
            top: 0,
            zIndex: 10,
            bgcolor: 'background.paper',
            borderBottom: '1px solid rgba(0,0,0,0.06)',
            px: 2,
            py: 1.5
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "row",
            spacing: 1.5,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 0.75,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                            label: `All ${filterCounts.all}`,
                            onClick: ()=>onFilterModeChange('all'),
                            size: "small",
                            sx: {
                                height: 24,
                                fontSize: '11px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                bgcolor: filterMode === 'all' ? 'rgba(0,0,0,0.08)' : 'transparent',
                                border: filterMode === 'all' ? '1px solid rgba(0,0,0,0.15)' : '1px solid rgba(0,0,0,0.08)',
                                color: 'text.primary',
                                '&:hover': {
                                    bgcolor: 'rgba(0,0,0,0.06)'
                                },
                                '& .MuiChip-label': {
                                    px: 1.5
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                            label: `Placed ${filterCounts.placed}`,
                            onClick: ()=>onFilterModeChange('placed'),
                            size: "small",
                            sx: {
                                height: 24,
                                fontSize: '11px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                bgcolor: filterMode === 'placed' ? 'rgba(16, 185, 129, 0.1)' : 'transparent',
                                border: filterMode === 'placed' ? '1px solid rgba(16, 185, 129, 0.3)' : '1px solid rgba(0,0,0,0.08)',
                                color: filterMode === 'placed' ? '#10B981' : 'text.secondary',
                                '&:hover': {
                                    bgcolor: 'rgba(16, 185, 129, 0.08)'
                                },
                                '& .MuiChip-label': {
                                    px: 1.5
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                            label: `Unplaced ${filterCounts.unplaced}`,
                            onClick: ()=>onFilterModeChange('unplaced'),
                            size: "small",
                            sx: {
                                height: 24,
                                fontSize: '11px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                bgcolor: filterMode === 'unplaced' ? 'rgba(239, 68, 68, 0.1)' : 'transparent',
                                border: filterMode === 'unplaced' ? '1px solid rgba(239, 68, 68, 0.3)' : '1px solid rgba(0,0,0,0.08)',
                                color: filterMode === 'unplaced' ? '#EF4444' : 'text.secondary',
                                '&:hover': {
                                    bgcolor: 'rgba(239, 68, 68, 0.08)'
                                },
                                '& .MuiChip-label': {
                                    px: 1.5
                                }
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    placeholder: "Search tail number...",
                    value: searchQuery,
                    onChange: (e)=>onSearchQueryChange(e.target.value),
                    size: "small",
                    sx: {
                        minWidth: 220,
                        '& .MuiOutlinedInput-root': {
                            fontSize: '14px',
                            fontWeight: 500,
                            height: 40,
                            borderRadius: '8px',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'grey.300'
                            }
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'grey.200'
                        },
                        '& .MuiOutlinedInput-input::placeholder': {
                            color: 'grey.500',
                            opacity: 1
                        }
                    },
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                            position: "start",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {
                                sx: {
                                    fontSize: 18,
                                    color: 'grey.600'
                                }
                            })
                        })
                    }
                })
            ]
        })
    });
};

});

parcelRegister("7cmsE", function(module, exports) {

$parcel$export(module.exports, "PlacementTableRow", () => $8d04695c06a32d9c$export$88a28ac47cc05956);
/**
 * PlacementTableRow - Individual row in PlacementTableView
 *
 * Compact 38-42px row with expand/collapse functionality.
 * Shows status, tail number, aircraft info, spot assignment, and times.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $bnA1h = parcelRequire("bnA1h");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $9Xw8e = parcelRequire("9Xw8e");

var $hdo73 = parcelRequire("hdo73");

var $evCdK = parcelRequire("evCdK");
const $8d04695c06a32d9c$export$88a28ac47cc05956 = ({ row: row, isExpanded: isExpanded, onRowClick: onRowClick, enableEditing: enableEditing, onScheduleChanged: onScheduleChanged, spots: spots, zones: zones, spotIdToName: spotIdToName })=>{
    // Status badge styling
    const getStatusStyle = ()=>{
        switch(row.status){
            case "placed":
                return {
                    bgcolor: "rgba(46, 125, 50, 0.06)",
                    borderColor: "rgba(46, 125, 50, 0.20)",
                    color: "#2e7d32"
                };
            case "partial":
                return {
                    bgcolor: "rgba(237, 108, 2, 0.06)",
                    borderColor: "rgba(237, 108, 2, 0.20)",
                    color: "#ed6c02"
                };
            case "unplaced":
                return {
                    bgcolor: "rgba(211, 47, 47, 0.06)",
                    borderColor: "rgba(211, 47, 47, 0.20)",
                    color: "#d32f2f"
                };
        }
    };
    const statusStyle = getStatusStyle();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                onClick: ()=>onRowClick(row.aircraftId),
                sx: {
                    display: "grid",
                    gridTemplateColumns: "100px 180px 1fr 130px 130px 90px",
                    gap: 2,
                    alignItems: "center",
                    height: 48,
                    px: 2,
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                    cursor: "pointer",
                    transition: "background-color 80ms ease-in-out, box-shadow 80ms ease-in-out",
                    "&:hover": {
                        bgcolor: "rgba(0,0,0,0.05)",
                        boxShadow: "inset 0 1px 0 0 rgba(0, 0, 0, 0.03)"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                px: 1,
                                py: 0.375,
                                borderRadius: 1.5,
                                fontSize: "12px",
                                fontWeight: 600,
                                letterSpacing: "0.02em",
                                textTransform: "lowercase",
                                display: "inline-block",
                                ...statusStyle,
                                border: "1px solid"
                            },
                            children: row.status
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    mb: 0.25
                                },
                                children: [
                                    row.isLocked && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: 10
                                        },
                                        children: "\uD83D\uDD12"
                                    }),
                                    row.placementSource === "auto" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: 10
                                        },
                                        children: "\u26A1"
                                    }),
                                    row.placementSource === "manual" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: 10
                                        },
                                        children: "\u270B"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: "15px",
                                            fontWeight: 600,
                                            color: "text.primary"
                                        },
                                        children: row.tailNumber
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                sx: {
                                    fontSize: "12px",
                                    color: "text.secondary",
                                    opacity: 0.7
                                },
                                children: [
                                    row.aircraftMake,
                                    " ",
                                    row.aircraftModel
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Xw8e.EditableSpotCell), {
                            row: row,
                            spots: spots,
                            zones: zones,
                            spotIdToName: spotIdToName,
                            enableEditing: enableEditing,
                            onScheduleChanged: onScheduleChanged
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hdo73.EditableTimeCell), {
                            row: row,
                            field: "arrival",
                            enableEditing: enableEditing,
                            onScheduleChanged: onScheduleChanged
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hdo73.EditableTimeCell), {
                            row: row,
                            field: "departure",
                            enableEditing: enableEditing,
                            onScheduleChanged: onScheduleChanged
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            sx: {
                                fontSize: "13px",
                                fontWeight: 500,
                                color: "text.secondary",
                                fontFamily: "SF Mono, Consolas, monospace"
                            },
                            children: row.dwellFormatted
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnA1h.default), {
                in: isExpanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $evCdK.PlacementTableRowExpanded), {
                    row: row,
                    spotIdToName: spotIdToName
                })
            })
        ]
    });
};

});
parcelRegister("9Xw8e", function(module, exports) {

$parcel$export(module.exports, "EditableSpotCell", () => $462a978bf057fde6$export$e028b3ae93860617);
/**
 * EditableSpotCell - Inline spot assignment editor
 *
 * Click to activate dropdown showing available spots filtered by:
 * - Size compatibility
 * - Grouped by zone
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $7djgP = parcelRequire("7djgP");
var $2iAqv = parcelRequire("2iAqv");
var $cX7V2 = parcelRequire("cX7V2");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $462a978bf057fde6$export$e028b3ae93860617 = ({ row: row, spots: spots, zones: zones, spotIdToName: spotIdToName, enableEditing: enableEditing, onScheduleChanged: onScheduleChanged })=>{
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    // Handle click to enter edit mode
    const handleClick = (e)=>{
        if (!enableEditing) return;
        e.stopPropagation(); // Prevent row expansion
        setIsEditing(true);
    };
    // Handle spot selection
    const handleChange = (newSpotId)=>{
        if (!onScheduleChanged) return;
        // Emit schedule change event
        const change = {
            aircraftId: row.aircraftId,
            tailNumber: row.tailNumber,
            originalSpotId: row.spotIds[0] || undefined,
            newSpotId: newSpotId,
            originalArrivalBucket: row.arrivalBucket,
            originalDepartureBucket: row.departureBucket,
            newArrivalBucket: row.arrivalBucket,
            newDepartureBucket: row.departureBucket,
            segmentIndex: null // For now, only support single placements
        };
        onScheduleChanged([
            change
        ]);
        setIsEditing(false);
    };
    // Filter spots by size compatibility
    const compatibleSpots = spots.filter((spot)=>spot.allowedSizes.includes(row.sizeCategory));
    // Group spots by zone
    const spotsByZone = zones.reduce((acc, zone)=>{
        const zoneSpots = compatibleSpots.filter((spot)=>zone.spotIds.includes(spot.id));
        if (zoneSpots.length > 0) acc[zone.id] = {
            zone: zone,
            spots: zoneSpots
        };
        return acc;
    }, {});
    // Spots not in any zone
    const unzonedSpots = compatibleSpots.filter((spot)=>!zones.some((zone)=>zone.spotIds.includes(spot.id)));
    if (isEditing) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
        value: row.spotIds[0] || "",
        onChange: (e)=>handleChange(e.target.value),
        onClose: ()=>setIsEditing(false),
        open: true,
        size: "small",
        autoFocus: true,
        sx: {
            fontSize: "12px",
            fontFamily: "SF Mono, Consolas, monospace",
            "& .MuiSelect-select": {
                py: 0.5,
                px: 1
            }
        },
        children: [
            Object.values(spotsByZone).map(({ zone: zone, spots: zoneSpots })=>[
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7djgP.default), {
                        sx: {
                            fontSize: "10px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            color: "text.secondary",
                            lineHeight: "24px"
                        },
                        children: zone.name
                    }, `header-${zone.id}`),
                    ...zoneSpots.map((spot)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                            value: spot.id,
                            sx: {
                                fontSize: "12px",
                                fontFamily: "SF Mono, Consolas, monospace",
                                py: 0.75
                            },
                            children: spotIdToName[spot.id] || spot.id
                        }, spot.id))
                ]),
            unzonedSpots.length > 0 && [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7djgP.default), {
                    sx: {
                        fontSize: "10px",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        color: "text.secondary",
                        lineHeight: "24px"
                    },
                    children: "Other Spots"
                }, "header-unzoned"),
                ...unzonedSpots.map((spot)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                        value: spot.id,
                        sx: {
                            fontSize: "12px",
                            fontFamily: "SF Mono, Consolas, monospace",
                            py: 0.75
                        },
                        children: spotIdToName[spot.id] || spot.id
                    }, spot.id))
            ]
        ]
    });
    // Normal display mode
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        onClick: handleClick,
        sx: {
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            cursor: enableEditing ? "pointer" : "default",
            "&:hover": enableEditing ? {
                "& .edit-hint": {
                    opacity: 1
                }
            } : {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                sx: {
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "text.primary",
                    fontFamily: "SF Mono, Consolas, monospace",
                    whiteSpace: 'nowrap'
                },
                children: row.spotSummary
            }),
            row.moveCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                label: `${row.moveCount}\xd7`,
                size: "small",
                sx: {
                    height: 18,
                    fontSize: "10px",
                    fontWeight: 600,
                    bgcolor: "rgba(237, 108, 2, 0.08)",
                    color: "#ed6c02",
                    border: "1px solid rgba(237, 108, 2, 0.2)",
                    "& .MuiChip-label": {
                        px: 0.75,
                        py: 0
                    }
                }
            })
        ]
    });
};

});

parcelRegister("hdo73", function(module, exports) {

$parcel$export(module.exports, "EditableTimeCell", () => $6a261dc85cd491a6$export$bb4021b4ba993970);
/**
 * EditableTimeCell - Inline time editor
 *
 * Click to edit arrival or departure time with conflict warnings.
 * Snaps to 15-minute buckets.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $kfA3C = parcelRequire("kfA3C");

var $acw62 = parcelRequire("acw62");
const $6a261dc85cd491a6$export$bb4021b4ba993970 = ({ row: row, field: field, enableEditing: enableEditing, onScheduleChanged: onScheduleChanged })=>{
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [tempValue, setTempValue] = (0, $acw62.useState)("");
    const currentTime = field === "arrival" ? row.arrivalTime : row.departureTime;
    // Handle click to enter edit mode
    const handleClick = (e)=>{
        if (!enableEditing) return;
        e.stopPropagation(); // Prevent row expansion
        setIsEditing(true);
        // Set initial value in HH:mm format
        setTempValue((0, $kfA3C.format)(currentTime, "HH:mm"));
    };
    // Handle time change
    const handleChange = (newTimeStr)=>{
        if (!onScheduleChanged) return;
        try {
            // Parse time string (HH:mm)
            const [hours, minutes] = newTimeStr.split(":").map(Number);
            if (isNaN(hours) || isNaN(minutes)) return;
            // Snap to 15-minute intervals
            const snappedMinutes = Math.round(minutes / 15) * 15;
            const snappedHours = snappedMinutes === 60 ? hours + 1 : hours;
            const finalMinutes = snappedMinutes === 60 ? 0 : snappedMinutes;
            // Calculate bucket offset from current time
            const currentDate = field === "arrival" ? row.arrivalTime : row.departureTime;
            const newDate = new Date(currentDate);
            newDate.setHours(snappedHours, finalMinutes, 0, 0);
            // Calculate bucket from date difference
            const diffMs = newDate.getTime() - row.arrivalTime.getTime();
            const diffBuckets = Math.round(diffMs / 900000);
            const newArrivalBucket = field === "arrival" ? row.arrivalBucket + diffBuckets : row.arrivalBucket;
            const newDepartureBucket = field === "departure" ? row.departureBucket + diffBuckets : row.departureBucket;
            // Emit schedule change event
            const change = {
                aircraftId: row.aircraftId,
                tailNumber: row.tailNumber,
                originalSpotId: row.spotIds[0],
                newSpotId: row.spotIds[0],
                originalArrivalBucket: row.arrivalBucket,
                originalDepartureBucket: row.departureBucket,
                newArrivalBucket: newArrivalBucket,
                newDepartureBucket: newDepartureBucket,
                segmentIndex: null
            };
            onScheduleChanged([
                change
            ]);
            setIsEditing(false);
        } catch (error) {
            console.error("Failed to parse time:", error);
            setIsEditing(false);
        }
    };
    // Handle blur or Enter key
    const handleBlur = ()=>{
        if (tempValue) handleChange(tempValue);
        else setIsEditing(false);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") handleBlur();
        else if (e.key === "Escape") setIsEditing(false);
    };
    if (isEditing) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
        value: tempValue,
        onChange: (e)=>setTempValue(e.target.value),
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        autoFocus: true,
        placeholder: "HH:mm",
        size: "small",
        sx: {
            width: 80,
            "& .MuiOutlinedInput-root": {
                fontSize: "11px",
                fontFamily: "SF Mono, Consolas, monospace"
            },
            "& .MuiOutlinedInput-input": {
                py: 0.5,
                px: 1
            }
        }
    });
    // Normal display mode
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        onClick: handleClick,
        sx: {
            cursor: enableEditing ? "pointer" : "default",
            "&:hover": enableEditing ? {
                "& .edit-hint": {
                    opacity: 1
                }
            } : {}
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            sx: {
                fontSize: "13px",
                fontWeight: 500,
                color: "text.primary",
                fontFamily: "SF Mono, Consolas, monospace"
            },
            children: (0, $kfA3C.format)(currentTime, "MMM d, HH:mm")
        })
    });
};

});

parcelRegister("evCdK", function(module, exports) {

$parcel$export(module.exports, "PlacementTableRowExpanded", () => $b7995cde7f19eb8c$export$1f09e3375a39bac3);
/**
 * PlacementTableRowExpanded - Expanded row content showing details
 *
 * Displays additional information when a table row is expanded:
 * - Segment breakdown for multi-move placements
 * - Decision log summary
 * - Filter breakdown for unplaced aircraft
 * - Suggestions for unplaced aircraft
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $kfA3C = parcelRequire("kfA3C");
parcelRequire("acw62");
const $b7995cde7f19eb8c$export$1f09e3375a39bac3 = ({ row: row, spotIdToName: spotIdToName })=>{
    // Format time for display
    const formatTime = (date)=>{
        return (0, $kfA3C.format)(date, 'MMM d, HH:mm');
    };
    // Calculate segment duration
    const calculateSegmentDuration = (startBucket, endBucket)=>{
        const minutes = (endBucket - startBucket) * 15;
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        if (hours > 0) return `${hours}h ${mins}m`;
        return `${mins}m`;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            bgcolor: 'rgba(0,0,0,0.01)',
            borderTop: '1px solid rgba(0,0,0,0.04)',
            px: 2,
            py: 1.5
        },
        children: [
            row.status !== 'unplaced' && row.segments && row.segments.length >= 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    mb: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        sx: {
                            fontSize: '10px',
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            letterSpacing: '0.08em',
                            color: 'text.secondary',
                            mb: 1
                        },
                        children: [
                            "Segment Breakdown (",
                            row.segments.length,
                            " segment",
                            row.segments.length !== 1 ? 's' : '',
                            ", ",
                            row.moveCount,
                            " move",
                            row.moveCount !== 1 ? 's' : '',
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        spacing: 0.75,
                        children: row.segments.map((segment, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    fontSize: '11px',
                                    fontFamily: 'SF Mono, Consolas, monospace'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                        label: `${idx + 1}`,
                                        size: "small",
                                        sx: {
                                            height: 18,
                                            width: 24,
                                            fontSize: '10px',
                                            fontWeight: 600,
                                            bgcolor: 'rgba(0,0,0,0.05)',
                                            '& .MuiChip-label': {
                                                px: 0
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: '11px',
                                            fontWeight: 500,
                                            color: 'text.primary',
                                            fontFamily: 'SF Mono, Consolas, monospace',
                                            minWidth: 80
                                        },
                                        children: spotIdToName[segment.spotId] || segment.spotId
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: '11px',
                                            color: 'text.secondary',
                                            fontFamily: 'SF Mono, Consolas, monospace'
                                        },
                                        children: [
                                            formatTime(new Date(row.arrivalTime.getTime() + segment.startBucket * 900000)),
                                            " \u2192 ",
                                            formatTime(new Date(row.arrivalTime.getTime() + segment.endBucket * 900000))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: '11px',
                                            color: 'text.disabled',
                                            fontFamily: 'SF Mono, Consolas, monospace',
                                            fontStyle: 'italic'
                                        },
                                        children: [
                                            "(",
                                            calculateSegmentDuration(segment.startBucket, segment.endBucket),
                                            ")"
                                        ]
                                    })
                                ]
                            }, idx))
                    })
                ]
            }),
            row.status === 'partial' && row.partialInfo && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    mb: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        sx: {
                            fontSize: '10px',
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            letterSpacing: '0.08em',
                            color: '#F59E0B',
                            mb: 1
                        },
                        children: [
                            "Partial Placement - ",
                            row.partialInfo.gaps.length,
                            " Gap",
                            row.partialInfo.gaps.length !== 1 ? 's' : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 0.75,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    display: 'flex',
                                    gap: 3,
                                    fontSize: '11px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: '11px',
                                            color: 'text.secondary'
                                        },
                                        children: [
                                            "Placed: ",
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                style: {
                                                    color: '#10B981'
                                                },
                                                children: [
                                                    Math.round(100 - row.partialInfo.gapPercentage),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        sx: {
                                            fontSize: '11px',
                                            color: 'text.secondary'
                                        },
                                        children: [
                                            "Gap: ",
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                style: {
                                                    color: '#EF4444'
                                                },
                                                children: [
                                                    Math.round(row.partialInfo.gapPercentage),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            row.partialInfo.gaps.map((gap, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        fontSize: '11px',
                                        color: 'text.secondary',
                                        fontFamily: 'SF Mono, Consolas, monospace',
                                        pl: 1
                                    },
                                    children: [
                                        "\u2022 Gap ",
                                        idx + 1,
                                        ": ",
                                        formatTime(gap.startTime),
                                        " \u2192 ",
                                        formatTime(gap.endTime),
                                        ' ',
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            component: "span",
                                            sx: {
                                                fontSize: '11px',
                                                color: 'text.disabled',
                                                fontStyle: 'italic'
                                            },
                                            children: [
                                                "(",
                                                Math.round(gap.durationMinutes),
                                                "m)"
                                            ]
                                        })
                                    ]
                                }, idx))
                        ]
                    })
                ]
            }),
            row.status === 'unplaced' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        sx: {
                            fontSize: '11px',
                            color: '#EF4444',
                            fontWeight: 500
                        },
                        children: "No available spots found"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        sx: {
                            fontSize: '10px',
                            color: 'text.secondary',
                            mt: 0.5
                        },
                        children: "Check Decision Log tab for detailed filter breakdown"
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("6aDwK", function(module, exports) {

$parcel$export(module.exports, "PlacementTableSummary", () => $a27b8f8be206aeb5$export$bb8a5fb47ea032ce);
/**
 * PlacementTableSummary - Summary bar for PlacementTableView
 *
 * Sticky bottom bar showing filtered results and quick statistics.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $a27b8f8be206aeb5$export$bb8a5fb47ea032ce = ({ totalCount: totalCount, filteredCount: filteredCount, placedCount: placedCount, unplacedCount: unplacedCount })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            position: 'sticky',
            bottom: 0,
            zIndex: 10,
            bgcolor: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(8px)',
            borderTop: '1px solid rgba(0,0,0,0.06)',
            px: 2,
            py: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body2",
                sx: {
                    fontSize: '11px',
                    fontWeight: 500,
                    color: 'text.primary'
                },
                children: [
                    "Showing ",
                    filteredCount,
                    " of ",
                    totalCount
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                sx: {
                    fontSize: '11px',
                    color: 'text.disabled'
                },
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body2",
                sx: {
                    fontSize: '11px',
                    color: '#10B981',
                    fontWeight: 600
                },
                children: [
                    placedCount,
                    " placed"
                ]
            }),
            unplacedCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        sx: {
                            fontSize: '11px',
                            color: 'text.disabled'
                        },
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        sx: {
                            fontSize: '11px',
                            color: '#EF4444',
                            fontWeight: 600
                        },
                        children: [
                            unplacedCount,
                            " unplaced"
                        ]
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("4H2Jj", function(module, exports) {

$parcel$export(module.exports, "SpotOccupancyGantt", () => $e28c36d696191b44$export$2f19ffb71e0fa995);
/**
 * SpotOccupancyGantt Component
 *
 * Operational GANTT view of AutoPark results showing aircraft assignments to spots.
 * Designed for printing and sharing with line managers and operations teams.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $iGBB4 = parcelRequire("iGBB4");

var $ap4xJ = parcelRequire("ap4xJ");

var $6KM07 = parcelRequire("6KM07");

var $utPXC = parcelRequire("utPXC");

var $clR8m = parcelRequire("clR8m");

var $8gMkr = parcelRequire("8gMkr");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $7Frhn = parcelRequire("7Frhn");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $kCLFX = parcelRequire("kCLFX");
var $kfA3C = parcelRequire("kfA3C");
var $hvR20 = parcelRequire("hvR20");

var $acw62 = parcelRequire("acw62");

var $5vA8q = parcelRequire("5vA8q");


var $6fDLr = parcelRequire("6fDLr");

var $25rQi = parcelRequire("25rQi");

var $h7RLZ = parcelRequire("h7RLZ");


var $9RYDA = parcelRequire("9RYDA");
/**
 * Format bucket to readable date/time
 */ function $e28c36d696191b44$var$formatBucketTime(bucket, baseDate) {
    const date = (0, $kCLFX.addHours)(baseDate, bucket * 0.25); // 15-minute buckets
    return (0, $kfA3C.format)(date, "MMM d, HH:mm");
}
/**
 * Calculate dwell duration in human-readable format
 */ function $e28c36d696191b44$var$calculateDwell(startBucket, endBucket) {
    const totalMinutes = (endBucket - startBucket) * 15;
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor(totalMinutes % 1440 / 60);
    const minutes = totalMinutes % 60;
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
}
/**
 * Format size category as readable label
 */ function $e28c36d696191b44$var$formatSizeCategory(size) {
    const labels = {
        "very-small": "Very Small",
        small: "Small",
        midsize: "Midsize",
        "super-midsize": "Super-Midsize",
        large: "Large",
        enormous: "Enormous"
    };
    return labels[size] || size;
}
/**
 * Calculate utilization percentage for a time bucket
 */ function $e28c36d696191b44$var$calculateUtilization(spots, aircraft, placement, bucket) {
    let occupiedCount = 0;
    for (const spot of spots)// Check if any aircraft occupies this spot at this time
    for (const ac of aircraft){
        const placed = placement[ac.id];
        if (!placed) continue;
        if ("segments" in placed) {
            // Segmented placement
            for (const segment of placed.segments)if (segment.spotId === spot.id && bucket >= segment.startBucket && bucket < segment.endBucket) {
                occupiedCount++;
                break; // Count each spot only once
            }
        } else // Single placement
        if (placed.spotId === spot.id && bucket >= ac.arrivalBucket && bucket < ac.departureBucket) {
            occupiedCount++;
            break;
        }
    }
    return spots.length > 0 ? Math.round(occupiedCount / spots.length * 100) : 0;
}
/**
 * Convert Unix timestamp to bucket index
 * Following react-calendar-timeline coordinate transformation pattern
 */ function $e28c36d696191b44$var$timestampToBucket(timestamp, baseDate) {
    const diffMs = timestamp - (0, $hvR20.getTime)(baseDate);
    const diffHours = diffMs / 3600000;
    return Math.round(diffHours * 4); // 4 buckets per hour (15-minute intervals)
}
/**
 * Convert bucket index to Unix timestamp
 */ function $e28c36d696191b44$var$bucketToTimestamp(bucket, baseDate) {
    return (0, $hvR20.getTime)((0, $kCLFX.addHours)(baseDate, bucket * 0.25));
}
/**
 * Extract aircraft ID from timeline item ID
 * Handles both segmented ("ac123-segment-0") and single ("ac123") items
 */ function $e28c36d696191b44$var$getAircraftIdFromItemId(itemId) {
    return itemId.split("-segment-")[0];
}
/**
 * Extract segment index from timeline item ID
 * Returns null for non-segmented items
 */ function $e28c36d696191b44$var$getSegmentIndexFromItemId(itemId) {
    const parts = itemId.split("-segment-");
    return parts.length > 1 ? parseInt(parts[1], 10) : null;
}
/**
 * Find which aircraft (if any) occupies a spot at a given bucket
 * Returns aircraft ID or null
 */ function $e28c36d696191b44$var$findAircraftAtSpotBucket(spotId, bucket, placement, aircraft) {
    for (const ac of aircraft){
        const placed = placement[ac.id];
        if (!placed) continue;
        if ("segments" in placed) // Check if any segment overlaps this bucket
        for (const seg of placed.segments){
            if (seg.spotId === spotId && bucket >= seg.startBucket && bucket < seg.endBucket) return ac.id;
        }
        else {
            // Single placement
            if (placed.spotId === spotId && bucket >= ac.arrivalBucket && bucket < ac.departureBucket) return ac.id;
        }
    }
    return null;
}
const $e28c36d696191b44$export$2f19ffb71e0fa995 = ({ spots: spots, aircraft: aircraft, placement: placement, horizonHours: horizonHours, startTime: startTime, currentTimestamp: currentTimestamp, rampShapes: rampShapes = [], zones: zones, statistics: statistics, partialPlacements: partialPlacements = [], hideStatistics: hideStatistics = false, onScheduleChanged: onScheduleChanged, onViewportChange: onViewportChange, enableEditing: enableEditing = false, decisionLog: decisionLog, showDetailedView: showDetailedView = false })=>{
    // MUI theme for dark/light mode support
    const theme = (0, $14H9o.default)();
    // Snackbar for user feedback
    const snackbar = (0, $6fDLr.useSnackbar)();
    // Local state to override item positions (prevents snap-back after drag)
    const [itemOverrides, setItemOverrides] = (0, $acw62.useState)(new Map());
    // Track if last move had conflict (to suppress success notification)
    const [lastMoveHadConflict, setLastMoveHadConflict] = (0, $acw62.useState)(false);
    // Ghost highlight state
    const [hoveredAircraft, setHoveredAircraft] = (0, $acw62.useState)(null);
    const [pinnedAircraft, setPinnedAircraft] = (0, $acw62.useState)(null);
    // Ref for timeline container (needed for width calculations)
    const timelineContainerRef = (0, $acw62.useRef)(null);
    // Use start time as base date for timeline calculations
    const baseDate = startTime;
    // Handle hover for preview
    const handleChipMouseEnter = (0, $acw62.useCallback)((ac)=>{
        setHoveredAircraft(ac);
    }, []);
    const handleChipMouseLeave = (0, $acw62.useCallback)(()=>{
        setHoveredAircraft(null);
    }, []);
    // Handle click to pin/unpin
    const handleChipClick = (0, $acw62.useCallback)((ac)=>{
        setPinnedAircraft((prev)=>{
            // Toggle: if clicking the same chip, unpin it
            if (prev?.id === ac.id) return null;
            // Otherwise, pin the new chip (replaces previous)
            return ac;
        });
    }, []);
    // Create aircraft map for quick lookup
    const aircraftMap = (0, $acw62.useMemo)(()=>{
        const map = {};
        aircraft.forEach((ac)=>{
            map[ac.id] = ac;
        });
        return map;
    }, [
        aircraft
    ]);
    // Visible time range state (for scrolling/zooming)
    // Initialize based on currentTimestamp if available, otherwise use baseDate
    const [visibleTimeStart, setVisibleTimeStart] = (0, $acw62.useState)(()=>{
        if (currentTimestamp) {
            const windowSize = 86400000; // 24 hours window
            return (0, $hvR20.getTime)(currentTimestamp) - windowSize / 2;
        }
        return (0, $hvR20.getTime)(baseDate);
    });
    const [visibleTimeEnd, setVisibleTimeEnd] = (0, $acw62.useState)(()=>{
        if (currentTimestamp) {
            const windowSize = 86400000; // 24 hours window
            return (0, $hvR20.getTime)(currentTimestamp) + windowSize / 2;
        }
        return (0, $hvR20.getTime)((0, $kCLFX.addHours)(baseDate, horizonHours));
    });
    // Update visible range when horizonHours or baseDate changes
    // BUT only if currentTimestamp is not provided (respect user's viewing context)
    (0, $acw62.useEffect)(()=>{
        if (!currentTimestamp) {
            setVisibleTimeStart((0, $hvR20.getTime)(baseDate));
            setVisibleTimeEnd((0, $hvR20.getTime)((0, $kCLFX.addHours)(baseDate, horizonHours)));
        }
    }, [
        baseDate,
        horizonHours,
        currentTimestamp
    ]);
    // Track viewport range for display purposes (separate from data loading range)
    // Initialize to match visible range (handles currentTimestamp centering)
    const [viewportStart, setViewportStart] = (0, $acw62.useState)(()=>{
        if (currentTimestamp) {
            const windowSize = 86400000; // 24 hours window
            return new Date((0, $hvR20.getTime)(currentTimestamp) - windowSize / 2);
        }
        return baseDate;
    });
    const [viewportEnd, setViewportEnd] = (0, $acw62.useState)(()=>{
        if (currentTimestamp) {
            const windowSize = 86400000; // 24 hours window
            return new Date((0, $hvR20.getTime)(currentTimestamp) + windowSize / 2);
        }
        return (0, $kCLFX.addHours)(baseDate, horizonHours);
    });
    // Create spot ID to name mapping
    const spotIdToName = (0, $acw62.useMemo)(()=>{
        const mapping = {};
        rampShapes.forEach((shape)=>{
            if (shape.type === "Spot" && shape.text) mapping[shape.id] = shape.text;
        });
        return mapping;
    }, [
        rampShapes
    ]);
    // Create spot ID to zone mapping
    const spotToZone = (0, $acw62.useMemo)(()=>{
        if (!zones) return {};
        const mapping = {};
        zones.forEach((zone)=>{
            zone.spotIds.forEach((spotId)=>{
                mapping[spotId] = zone;
            });
        });
        return mapping;
    }, [
        zones
    ]);
    // Calculate ghost highlight position
    const calculateGhostPosition = (0, $acw62.useCallback)((aircraft)=>{
        if (!timelineContainerRef.current) return null;
        const arrivalTime = $e28c36d696191b44$var$bucketToTimestamp(aircraft.arrivalBucket, baseDate);
        const departureTime = $e28c36d696191b44$var$bucketToTimestamp(aircraft.departureBucket, baseDate);
        // Check if aircraft time overlaps visible timeline range
        if (departureTime < visibleTimeStart || arrivalTime > visibleTimeEnd) return null; // Outside viewport
        const totalVisibleDuration = visibleTimeEnd - visibleTimeStart;
        const leftRatio = Math.max(0, (arrivalTime - visibleTimeStart) / totalVisibleDuration);
        const rightRatio = Math.min(1, (departureTime - visibleTimeStart) / totalVisibleDuration);
        // Get timeline width (subtract sidebar width: 150px)
        const containerWidth = timelineContainerRef.current.offsetWidth;
        const timelineWidth = containerWidth - 150;
        return {
            left: 150 + leftRatio * timelineWidth,
            // 150 = sidebar offset
            width: (rightRatio - leftRatio) * timelineWidth
        };
    }, [
        baseDate,
        visibleTimeStart,
        visibleTimeEnd
    ]);
    // Transform spots into timeline groups (sorted by name)
    const groups = (0, $acw62.useMemo)(()=>{
        return spots.map((spot)=>({
                id: spot.id,
                title: spotIdToName[spot.id] || spot.id
            })).sort((a, b)=>a.title.localeCompare(b.title, undefined, {
                numeric: true
            }));
    }, [
        spots,
        spotIdToName
    ]);
    // Event Handlers following react-calendar-timeline patterns
    /**
   * moveResizeValidator - Validates moves/resizes and blocks conflicts
   * MUST return number (not void) - skill file pattern
   */ const moveResizeValidator = (0, $acw62.useCallback)((action, item, time, resizeEdge)=>{
        const aircraftId = $e28c36d696191b44$var$getAircraftIdFromItemId(item.id);
        const movingAircraft = aircraftMap[aircraftId];
        if (!movingAircraft) return time;
        const bucket = $e28c36d696191b44$var$timestampToBucket(time, baseDate);
        // Calculate time range for validation
        let startBucket;
        let endBucket;
        let spotId;
        if (action === "move") {
            const duration = movingAircraft.departureBucket - movingAircraft.arrivalBucket;
            startBucket = bucket;
            endBucket = bucket + duration;
            spotId = item.group; // Current group during drag
            console.log("[Validator] MOVE:", movingAircraft.tail_number, "to spot", spotId, "buckets", startBucket, "-", endBucket);
        } else {
            // Resize - get current position from overrides or original
            const override = itemOverrides.get(item.id);
            const currentGroup = override?.group || item.group;
            if (resizeEdge === "left") {
                startBucket = bucket;
                endBucket = override ? $e28c36d696191b44$var$timestampToBucket(override.end_time, baseDate) : movingAircraft.departureBucket;
            } else {
                startBucket = override ? $e28c36d696191b44$var$timestampToBucket(override.start_time, baseDate) : movingAircraft.arrivalBucket;
                endBucket = bucket;
            }
            spotId = currentGroup;
        }
        // Find the spot
        const spot = spots.find((s)=>s.id === spotId);
        if (!spot) {
            console.log("[Validator] Spot not found:", spotId);
            snackbar.notify({
                text: "Spot not found",
                severity: "error"
            });
            return time; // Allow anyway
        }
        console.log("[Validator] Checking spot", spotId, "occupancy length:", spot.occupancy.length);
        // Check size compatibility (only for moves, not resizes)
        let hasConflict = false;
        if (action === "move" && !spot.allowedSizes.includes(movingAircraft.sizeCategory)) {
            hasConflict = true;
            const allowedSizesStr = spot.allowedSizes.map($e28c36d696191b44$var$formatSizeCategory).join(", ");
            snackbar.notify({
                text: `Warning: Spot ${spotIdToName[spotId] || spotId} only allows ${allowedSizesStr} (${movingAircraft.tail_number} is ${$e28c36d696191b44$var$formatSizeCategory(movingAircraft.sizeCategory)})`,
                severity: "warning"
            });
        // Continue to check occupancy, might have multiple issues
        }
        // Check occupancy bitmap for conflicts
        for(let b = startBucket; b < endBucket; b++){
            const wordIndex = Math.floor(b / 64);
            const bitIndex = b % 64;
            if (wordIndex < spot.occupancy.length) {
                const occupied = !!(spot.occupancy[wordIndex] & BigInt(1) << BigInt(bitIndex));
                if (occupied) {
                    // Find which aircraft occupies this bucket
                    const occupyingAircraftId = $e28c36d696191b44$var$findAircraftAtSpotBucket(spotId, b, placement, aircraft);
                    const isSameAircraft = occupyingAircraftId === aircraftId;
                    console.log("[Validator] Bucket", b, "occupied by:", occupyingAircraftId, "moving aircraft:", aircraftId, "same?:", isSameAircraft);
                    if (occupyingAircraftId && !isSameAircraft) {
                        // Different aircraft - show warning
                        hasConflict = true;
                        const occupyingAircraft = aircraftMap[occupyingAircraftId];
                        const conflictTime = $e28c36d696191b44$var$formatBucketTime(b, baseDate);
                        console.log("[Validator] CONFLICT DETECTED at", conflictTime, "with", occupyingAircraft?.tail_number);
                        snackbar.notify({
                            text: `Warning: Spot ${spotIdToName[spotId] || spotId} occupied by ${occupyingAircraft?.tail_number || "another aircraft"} at ${conflictTime}`,
                            severity: "warning"
                        });
                        break;
                    }
                }
            }
        }
        console.log("[Validator] Final result - hasConflict:", hasConflict, "returning:", time);
        // Track conflict state to suppress success notification
        setLastMoveHadConflict(hasConflict);
        // Return new time (allow move even with conflicts)
        return time;
    }, [
        aircraftMap,
        aircraft,
        baseDate,
        spots,
        placement,
        snackbar,
        spotIdToName,
        itemOverrides
    ]);
    /**
   * onItemMove - Called on drop, apply changes immediately
   */ const handleItemMove = (0, $acw62.useCallback)((itemId, dragTime, newGroupOrder)=>{
        const group = groups[newGroupOrder];
        const newSpotId = group.id;
        const aircraftId = $e28c36d696191b44$var$getAircraftIdFromItemId(itemId);
        const segmentIndex = $e28c36d696191b44$var$getSegmentIndexFromItemId(itemId);
        const aircraft = aircraftMap[aircraftId];
        if (!aircraft) return;
        // Convert timestamp to bucket
        const newArrivalBucket = $e28c36d696191b44$var$timestampToBucket(dragTime, baseDate);
        const duration = aircraft.departureBucket - aircraft.arrivalBucket;
        const newDepartureBucket = newArrivalBucket + duration;
        // Get original spot ID (for segmented, get the specific segment's spot)
        let originalSpotId;
        if ("segments" in placement[aircraftId]) {
            const idx = segmentIndex !== null ? segmentIndex : 0;
            originalSpotId = placement[aircraftId].segments[idx].spotId;
        } else originalSpotId = placement[aircraftId].spotId;
        // Build schedule change
        const change = {
            aircraftId: aircraftId,
            tailNumber: aircraft.tail_number,
            originalArrivalBucket: aircraft.arrivalBucket,
            originalDepartureBucket: aircraft.departureBucket,
            originalSpotId: originalSpotId,
            newArrivalBucket: newArrivalBucket,
            newDepartureBucket: newDepartureBucket,
            newSpotId: newSpotId,
            segmentIndex: segmentIndex
        };
        // Update local item overrides for immediate visual update (prevents snap-back)
        setItemOverrides((prev)=>new Map(prev).set(itemId, {
                start_time: dragTime,
                end_time: dragTime + (aircraft.departureBucket - aircraft.arrivalBucket) * 900000,
                group: newSpotId
            }));
        // Call parent callback for persistence
        if (onScheduleChanged) onScheduleChanged([
            change
        ]);
        // Only show success notification if there was no conflict
        if (!lastMoveHadConflict) snackbar.notify({
            text: `Moved ${aircraft.tail_number} to ${spotIdToName[newSpotId] || newSpotId}`,
            severity: "success"
        });
    }, [
        aircraftMap,
        baseDate,
        placement,
        onScheduleChanged,
        snackbar,
        groups,
        spotIdToName,
        lastMoveHadConflict
    ]);
    /**
   * onItemResize - Called on resize complete
   */ const handleItemResize = (0, $acw62.useCallback)((itemId, time, edge)=>{
        const aircraftId = $e28c36d696191b44$var$getAircraftIdFromItemId(itemId);
        const segmentIndex = $e28c36d696191b44$var$getSegmentIndexFromItemId(itemId);
        const aircraft = aircraftMap[aircraftId];
        if (!aircraft) return;
        const bucket = $e28c36d696191b44$var$timestampToBucket(time, baseDate);
        // Get current item position (from overrides OR original placement)
        const override = itemOverrides.get(itemId);
        let originalSpotId;
        let currentStartBucket;
        let currentEndBucket;
        if (override) {
            // Use overridden values
            originalSpotId = override.group;
            currentStartBucket = $e28c36d696191b44$var$timestampToBucket(override.start_time, baseDate);
            currentEndBucket = $e28c36d696191b44$var$timestampToBucket(override.end_time, baseDate);
        } else // Use original placement values (specific segment if segmented)
        if ("segments" in placement[aircraftId]) {
            const idx = segmentIndex !== null ? segmentIndex : 0;
            const segment = placement[aircraftId].segments[idx];
            originalSpotId = segment.spotId;
            currentStartBucket = segment.startBucket;
            currentEndBucket = segment.endBucket;
        } else {
            originalSpotId = placement[aircraftId].spotId;
            currentStartBucket = aircraft.arrivalBucket;
            currentEndBucket = aircraft.departureBucket;
        }
        // Calculate new buckets based on resize edge
        const newArrivalBucket = edge === "left" ? bucket : currentStartBucket;
        const newDepartureBucket = edge === "right" ? bucket : currentEndBucket;
        // Build schedule change
        const change = {
            aircraftId: aircraftId,
            tailNumber: aircraft.tail_number,
            originalArrivalBucket: currentStartBucket,
            originalDepartureBucket: currentEndBucket,
            originalSpotId: originalSpotId,
            newArrivalBucket: newArrivalBucket,
            newDepartureBucket: newDepartureBucket,
            newSpotId: originalSpotId,
            segmentIndex: segmentIndex
        };
        // Calculate new timestamps from buckets
        const newStartTime = $e28c36d696191b44$var$bucketToTimestamp(newArrivalBucket, baseDate);
        const newEndTime = $e28c36d696191b44$var$bucketToTimestamp(newDepartureBucket, baseDate);
        // Update local item overrides for immediate visual update (prevents snap-back)
        setItemOverrides((prev)=>new Map(prev).set(itemId, {
                start_time: newStartTime,
                end_time: newEndTime,
                group: originalSpotId
            }));
        // Call parent callback for persistence
        if (onScheduleChanged) onScheduleChanged([
            change
        ]);
        // Only show success notification if there was no conflict
        if (!lastMoveHadConflict) snackbar.notify({
            text: `Adjusted ${aircraft.tail_number} schedule`,
            severity: "success"
        });
    }, [
        aircraftMap,
        baseDate,
        placement,
        onScheduleChanged,
        snackbar,
        lastMoveHadConflict,
        itemOverrides
    ]);
    // Transform placements into timeline items
    const items = (0, $acw62.useMemo)(()=>{
        const timelineItems = [];
        aircraft.forEach((ac)=>{
            const placed = placement[ac.id];
            if (!placed) return;
            // Convert time buckets to actual timestamps
            const bucketToTime = (bucket)=>{
                return (0, $hvR20.getTime)((0, $kCLFX.addHours)(baseDate, bucket * 0.25)); // 15-minute buckets
            };
            if ("segments" in placed) // Segmented placement - create item for each segment
            placed.segments.forEach((segment, idx)=>{
                const itemId = `${ac.id}-segment-${idx}`;
                // Check if adjacent segments are in staging zones
                const prevSegment = idx > 0 ? placed.segments[idx - 1] : null;
                const nextSegment = idx < placed.segments.length - 1 ? placed.segments[idx + 1] : null;
                const prevSpot = prevSegment ? spots.find((s)=>s.id === prevSegment.spotId) : null;
                const nextSpot = nextSegment ? spots.find((s)=>s.id === nextSegment.spotId) : null;
                const prevSegmentIsStaging = prevSpot?.shape?.metadata?.is_staging === true;
                const nextSegmentIsStaging = nextSpot?.shape?.metadata?.is_staging === true;
                const baseItem = {
                    id: itemId,
                    group: segment.spotId,
                    title: ac.tail_number,
                    start_time: bucketToTime(segment.startBucket),
                    end_time: bucketToTime(segment.endBucket),
                    aircraft: ac,
                    moveCount: placed.moveCount,
                    isSegmented: true,
                    segmentIndex: idx,
                    totalSegments: placed.segments.length,
                    prevSegmentIsStaging: prevSegmentIsStaging,
                    nextSegmentIsStaging: nextSegmentIsStaging
                };
                // Apply local overrides if they exist (for immediate visual update)
                const override = itemOverrides.get(itemId);
                if (override) {
                    baseItem.start_time = override.start_time;
                    baseItem.end_time = override.end_time;
                    baseItem.group = override.group;
                }
                timelineItems.push(baseItem);
            });
            else {
                // Single placement
                const itemId = ac.id;
                const baseItem = {
                    id: itemId,
                    group: placed.spotId,
                    title: ac.tail_number,
                    start_time: bucketToTime(ac.arrivalBucket),
                    end_time: bucketToTime(ac.departureBucket),
                    aircraft: ac,
                    moveCount: 0,
                    isSegmented: false
                };
                // Apply local overrides if they exist (for immediate visual update)
                const override = itemOverrides.get(itemId);
                if (override) {
                    baseItem.start_time = override.start_time;
                    baseItem.end_time = override.end_time;
                    baseItem.group = override.group;
                }
                timelineItems.push(baseItem);
            }
        });
        return timelineItems;
    }, [
        aircraft,
        placement,
        baseDate,
        itemOverrides,
        spots
    ]);
    // Calculate average utilization
    const avgUtilization = (0, $acw62.useMemo)(()=>{
        if (!spots.length || !horizonHours) return 0;
        const totalBuckets = horizonHours * 4; // 15-minute buckets
        let totalUtilization = 0;
        for(let bucket = 0; bucket < totalBuckets; bucket++)totalUtilization += $e28c36d696191b44$var$calculateUtilization(spots, aircraft, placement, bucket);
        return Math.round(totalUtilization / totalBuckets);
    }, [
        spots,
        aircraft,
        placement,
        horizonHours
    ]);
    // Custom item renderer
    const itemRenderer = ({ item: item, itemContext: itemContext, getItemProps: getItemProps })=>{
        const aircraft = item.aircraft;
        const isSegmented = item.isSegmented;
        const moveCount = item.moveCount || 0;
        // Determine if this is a staging segment
        const currentSpot = spots.find((s)=>s.id === item.group);
        const isInStagingZone = currentSpot?.shape?.metadata?.is_staging === true;
        let stagingSegmentType = null;
        if (isSegmented && isInStagingZone && item.segmentIndex !== undefined) {
            // First segment in staging zone = arrival, last = departure
            if (item.segmentIndex === 0) stagingSegmentType = "arrival";
            else if (item.segmentIndex === item.totalSegments - 1) stagingSegmentType = "departure";
        }
        // Check if this item is being dragged
        const isDragging = itemContext.dragging;
        const dragTime = itemContext.dragTime;
        const dragGroupDelta = itemContext.dragGroupDelta;
        // Calculate preview values during drag
        let previewArrivalBucket = aircraft.arrivalBucket;
        let previewDepartureBucket = aircraft.departureBucket;
        let previewSpotName = spotIdToName[item.group] || item.group;
        if (isDragging && dragTime !== null) {
            previewArrivalBucket = $e28c36d696191b44$var$timestampToBucket(dragTime, baseDate);
            const duration = aircraft.departureBucket - aircraft.arrivalBucket;
            previewDepartureBucket = previewArrivalBucket + duration;
            if (dragGroupDelta !== null && dragGroupDelta !== undefined) {
                const newGroupIndex = itemContext.dimensions.order.index + dragGroupDelta;
                const newGroup = groups[newGroupIndex];
                if (newGroup) previewSpotName = newGroup.title;
            }
        }
        // Build tooltip content
        const tooltipContent = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        mb: 1.5,
                        pb: 1.5,
                        borderBottom: 1,
                        borderColor: "divider"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            sx: {
                                mb: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    fontWeight: "bold",
                                    sx: {
                                        fontSize: "0.95rem"
                                    },
                                    children: [
                                        aircraft.is_locked ? "\uD83D\uDD12 " : aircraft.placement_source === "auto" ? "\u26A1 " : aircraft.placement_source === "manual" ? "\u270B " : "",
                                        aircraft.tail_number
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: $e28c36d696191b44$var$formatSizeCategory(aircraft.sizeCategory),
                                    size: "small",
                                    color: "primary",
                                    variant: "outlined",
                                    sx: {
                                        fontSize: "0.65rem",
                                        fontWeight: 500,
                                        height: 20
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            display: "block",
                            sx: {
                                fontSize: "0.8rem"
                            },
                            children: [
                                aircraft.aircraft?.make,
                                " ",
                                aircraft.aircraft?.model || "Unknown Type"
                            ]
                        })
                    ]
                }),
                moveCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        mb: 1.5
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                        label: `${moveCount} move${moveCount !== 1 ? "s" : ""}`,
                        size: "small",
                        color: "warning",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clR8m))), {
                            sx: {
                                fontSize: 14
                            }
                        }),
                        sx: {
                            fontSize: "0.7rem",
                            fontWeight: 500
                        }
                    })
                }),
                stagingSegmentType && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        mb: 1.5
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                        label: stagingSegmentType === "arrival" ? "Arrival Staging" : "Departure Staging",
                        size: "small",
                        color: "warning",
                        variant: "outlined",
                        sx: {
                            fontSize: "0.7rem",
                            fontWeight: 500,
                            bgcolor: "#FF9800",
                            color: "white",
                            borderColor: "#F57C00"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        mb: 1.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            sx: {
                                mb: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6KM07))), {
                                    sx: {
                                        fontSize: 16,
                                        color: isDragging ? "primary.dark" : "primary.main"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    fontWeight: 600,
                                    color: isDragging ? "primary.dark" : "inherit",
                                    children: previewSpotName
                                }),
                                isSegmented && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: `${item.segmentIndex + 1}/${item.totalSegments}`,
                                    size: "small",
                                    sx: {
                                        height: 18,
                                        fontSize: "0.65rem"
                                    }
                                })
                            ]
                        }),
                        spotToZone[item.group] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            sx: {
                                pl: 3,
                                fontSize: "0.75rem"
                            },
                            children: [
                                "Zone: ",
                                spotToZone[item.group].name
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        pt: 1.5,
                        borderTop: 1,
                        borderColor: "divider"
                    },
                    children: [
                        isSegmented && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        mb: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            sx: {
                                                mb: 0.5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    fontWeight: "bold",
                                                    sx: {
                                                        fontSize: "0.7rem",
                                                        textTransform: "uppercase",
                                                        letterSpacing: 0.5
                                                    },
                                                    children: "In This Spot"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    fontWeight: 600,
                                                    sx: {
                                                        fontSize: "0.75rem",
                                                        fontStyle: "italic"
                                                    },
                                                    children: $e28c36d696191b44$var$calculateDwell(isDragging && dragTime !== null ? $e28c36d696191b44$var$timestampToBucket(dragTime, baseDate) : $e28c36d696191b44$var$timestampToBucket(item.start_time, baseDate), isDragging && dragTime !== null ? $e28c36d696191b44$var$timestampToBucket(dragTime, baseDate) + ($e28c36d696191b44$var$timestampToBucket(item.end_time, baseDate) - $e28c36d696191b44$var$timestampToBucket(item.start_time, baseDate)) : $e28c36d696191b44$var$timestampToBucket(item.end_time, baseDate))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                                            sx: {
                                                                fontSize: 16
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                fontSize: "0.8rem"
                                                            },
                                                            color: isDragging ? "primary.dark" : "inherit",
                                                            children: isDragging && dragTime !== null ? $e28c36d696191b44$var$formatBucketTime($e28c36d696191b44$var$timestampToBucket(dragTime, baseDate), baseDate) : $e28c36d696191b44$var$formatBucketTime($e28c36d696191b44$var$timestampToBucket(item.start_time, baseDate), baseDate)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                                            sx: {
                                                                fontSize: 16
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                fontSize: "0.8rem"
                                                            },
                                                            color: isDragging ? "primary.dark" : "inherit",
                                                            children: isDragging && dragTime !== null ? $e28c36d696191b44$var$formatBucketTime($e28c36d696191b44$var$timestampToBucket(dragTime, baseDate) + ($e28c36d696191b44$var$timestampToBucket(item.end_time, baseDate) - $e28c36d696191b44$var$timestampToBucket(item.start_time, baseDate)), baseDate) : $e28c36d696191b44$var$formatBucketTime($e28c36d696191b44$var$timestampToBucket(item.end_time, baseDate), baseDate)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            sx: {
                                                mb: 0.5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    fontWeight: "bold",
                                                    sx: {
                                                        fontSize: "0.7rem",
                                                        textTransform: "uppercase",
                                                        letterSpacing: 0.5
                                                    },
                                                    children: "Overall Trip"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    fontWeight: 600,
                                                    sx: {
                                                        fontSize: "0.75rem",
                                                        fontStyle: "italic"
                                                    },
                                                    children: $e28c36d696191b44$var$calculateDwell(aircraft.arrivalBucket, aircraft.departureBucket)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                                            sx: {
                                                                fontSize: 16
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                fontSize: "0.8rem"
                                                            },
                                                            children: $e28c36d696191b44$var$formatBucketTime(aircraft.arrivalBucket, baseDate)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                                            sx: {
                                                                fontSize: 16
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                fontSize: "0.8rem"
                                                            },
                                                            children: $e28c36d696191b44$var$formatBucketTime(aircraft.departureBucket, baseDate)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isSegmented && /* Single Placement - Show only one time section */ /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                            sx: {
                                                fontSize: 16
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                fontSize: "0.8rem"
                                            },
                                            color: isDragging ? "primary.dark" : "inherit",
                                            children: $e28c36d696191b44$var$formatBucketTime(previewArrivalBucket, baseDate)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                            sx: {
                                                fontSize: 16
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                fontSize: "0.8rem"
                                            },
                                            color: isDragging ? "primary.dark" : "inherit",
                                            children: $e28c36d696191b44$var$formatBucketTime(previewDepartureBucket, baseDate)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    sx: {
                                        pl: 3,
                                        pt: 0.5,
                                        fontSize: "0.75rem",
                                        fontStyle: "italic"
                                    },
                                    children: $e28c36d696191b44$var$calculateDwell(previewArrivalBucket, previewDepartureBucket)
                                })
                            ]
                        }),
                        isDragging && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "primary.dark",
                            sx: {
                                display: "block",
                                mt: 1,
                                fontStyle: "italic"
                            },
                            children: "Moving..."
                        })
                    ]
                })
            ]
        });
        // Color based on placement source and type
        // Adjacent staging info from item
        const prevSegmentIsStaging = item.prevSegmentIsStaging;
        const nextSegmentIsStaging = item.nextSegmentIsStaging;
        // Determine if this is a staging segment (in staging zone)
        const isStagingSegment = isInStagingZone;
        // Base colors for auto/manual placements
        const autoFillColor = "#4287F5"; // Blue
        const manualFillColor = "#FB8C00"; // Orange
        const stagingFillColor = aircraft.placement_source === "manual" ? "#9C27B0" : "#8B5CF6"; // Purple variants
        const autoBorderColor = "#2563EB"; // Dark blue
        const manualBorderColor = "#E65100"; // Dark orange
        const stagingBorderColor = aircraft.placement_source === "manual" ? "#7B1FA2" : "#6D28D9"; // Purple variants
        let backgroundColor;
        let normalBorderColor;
        if (isDragging) {
            backgroundColor = "#64B5F6"; // Lighter blue during drag
            normalBorderColor = aircraft.placement_source === "manual" ? "#FF6F00" : "#1976D2";
        } else if (isStagingSegment) {
            // Staging segments: purple fill and borders
            backgroundColor = stagingFillColor;
            normalBorderColor = stagingBorderColor;
        } else if (isSegmented) {
            // Non-staging segmented: normal fill color (not purple)
            backgroundColor = aircraft.placement_source === "manual" ? manualFillColor : autoFillColor;
            normalBorderColor = aircraft.placement_source === "manual" ? manualBorderColor : autoBorderColor;
        } else {
            // Single placements: normal colors
            backgroundColor = aircraft.placement_source === "manual" ? manualFillColor : autoFillColor;
            normalBorderColor = aircraft.placement_source === "manual" ? manualBorderColor : autoBorderColor;
        }
        // Calculate individual border colors
        // For non-staging segments, borders adjacent to staging get purple color
        const topBorderColor = normalBorderColor;
        const bottomBorderColor = normalBorderColor;
        const leftBorderColor = isSegmented && !isStagingSegment && prevSegmentIsStaging ? stagingBorderColor : normalBorderColor;
        const rightBorderColor = isSegmented && !isStagingSegment && nextSegmentIsStaging ? stagingBorderColor : normalBorderColor;
        // Calculate background (solid or gradient for staging-adjacent segments)
        let background;
        if (!isStagingSegment && isSegmented && (prevSegmentIsStaging || nextSegmentIsStaging)) {
            // Non-staging segment adjacent to staging: use gradient
            const purpleColor = stagingFillColor;
            if (prevSegmentIsStaging && nextSegmentIsStaging) // Both sides adjacent to staging
            background = `linear-gradient(to right, ${purpleColor} 0%, ${backgroundColor} 15%, ${backgroundColor} 85%, ${purpleColor} 100%)`;
            else if (prevSegmentIsStaging) // Left side adjacent to staging
            background = `linear-gradient(to right, ${purpleColor} 0%, ${backgroundColor} 15%, ${backgroundColor} 100%)`;
            else // Right side adjacent to staging
            background = `linear-gradient(to left, ${purpleColor} 0%, ${backgroundColor} 15%, ${backgroundColor} 100%)`;
        } else // Solid color for all other cases
        background = backgroundColor;
        const borderWidth = isDragging ? 2 : 1;
        const itemProps = getItemProps({
            style: {
                background: background,
                borderRadius: 4,
                borderTopWidth: borderWidth,
                borderBottomWidth: borderWidth,
                borderLeftWidth: borderWidth,
                borderRightWidth: borderWidth,
                borderStyle: "solid",
                borderTopColor: topBorderColor,
                borderBottomColor: bottomBorderColor,
                borderLeftColor: leftBorderColor,
                borderRightColor: rightBorderColor,
                color: "#fff",
                fontSize: 12,
                padding: "4px 8px",
                cursor: enableEditing ? "move" : "default",
                fontWeight: 500
            }
        });
        const { key: key, title: _title, ...restProps } = itemProps;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
            title: tooltipContent,
            arrow: true,
            placement: "top",
            slotProps: {
                popper: {
                    modifiers: [
                        {
                            name: "flip",
                            enabled: true,
                            options: {
                                fallbackPlacements: [
                                    "bottom",
                                    "right",
                                    "left"
                                ],
                                padding: 100 // Large padding to trigger flip sooner (tooltip is ~300px tall)
                            }
                        },
                        {
                            name: "preventOverflow",
                            enabled: true,
                            options: {
                                padding: 8,
                                altAxis: true // Also prevent horizontal overflow
                            }
                        }
                    ]
                },
                tooltip: {
                    sx: {
                        bgcolor: "background.paper",
                        color: "text.primary",
                        boxShadow: 3,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        p: 2,
                        maxWidth: 360,
                        "& .MuiTooltip-arrow": {
                            color: "background.paper",
                            "&::before": {
                                border: "1px solid",
                                borderColor: "divider"
                            }
                        }
                    }
                }
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ...restProps,
                style: {
                    ...restProps.style,
                    height: itemContext.dimensions.height,
                    display: "flex",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        width: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    },
                    children: [
                        item.title,
                        isSegmented && ` (${item.segmentIndex + 1}/${item.totalSegments})`
                    ]
                })
            })
        }, key);
    };
    // Find rejected log entry for an aircraft
    const getRejectedLogEntry = (0, $acw62.useCallback)((aircraftId)=>{
        if (!decisionLog) return null;
        return decisionLog.find((entry)=>entry.type === "rejected" && entry.aircraftId === aircraftId) || null;
    }, [
        decisionLog
    ]);
    // Build tooltip content for unplaced aircraft
    const buildUnplacedAircraftTooltip = (0, $acw62.useCallback)((ac)=>{
        const rejectedEntry = getRejectedLogEntry(ac.id);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        mb: 1.5,
                        pb: 1.5,
                        borderBottom: 1,
                        borderColor: "divider"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            sx: {
                                mb: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    fontWeight: "bold",
                                    sx: {
                                        fontSize: "0.95rem"
                                    },
                                    children: [
                                        ac.is_locked ? "\uD83D\uDD12 " : ac.placement_source === "auto" ? "\u26A1 " : ac.placement_source === "manual" ? "\u270B " : "",
                                        ac.tail_number
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: $e28c36d696191b44$var$formatSizeCategory(ac.sizeCategory),
                                    size: "small",
                                    color: "primary",
                                    variant: "outlined",
                                    sx: {
                                        fontSize: "0.65rem",
                                        fontWeight: 500,
                                        height: 20
                                    }
                                })
                            ]
                        }),
                        ac.aircraft && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            display: "block",
                            sx: {
                                fontSize: "0.8rem"
                            },
                            children: [
                                ac.aircraft.make,
                                " ",
                                ac.aircraft.model || "Unknown Type"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        pt: 1.5,
                        borderTop: 1,
                        borderColor: "divider"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                            sx: {
                                                fontSize: 16
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                fontSize: "0.8rem"
                                            },
                                            children: $e28c36d696191b44$var$formatBucketTime(ac.arrivalBucket, baseDate)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                            sx: {
                                                fontSize: 16
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                fontSize: "0.8rem"
                                            },
                                            children: $e28c36d696191b44$var$formatBucketTime(ac.departureBucket, baseDate)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    sx: {
                                        pl: 3,
                                        pt: 0.5,
                                        fontSize: "0.75rem",
                                        fontStyle: "italic"
                                    },
                                    children: $e28c36d696191b44$var$calculateDwell(ac.arrivalBucket, ac.departureBucket)
                                })
                            ]
                        }),
                        ac.trip_id && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            sx: {
                                display: "block",
                                mt: 1.5,
                                pt: 1.5,
                                borderTop: 1,
                                borderColor: "divider",
                                fontSize: "0.75rem"
                            },
                            children: [
                                "Trip ID: ",
                                ac.trip_id
                            ]
                        })
                    ]
                }),
                showDetailedView && rejectedEntry && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        mt: 1.5,
                        pt: 1.5,
                        borderTop: 1,
                        borderColor: "divider"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            fontWeight: "bold",
                            sx: {
                                fontSize: "0.75rem",
                                textTransform: "uppercase",
                                letterSpacing: 0.5,
                                display: "block",
                                mb: 1,
                                color: "error.main"
                            },
                            children: "Why Unplaced:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25rQi.DecisionLogDisplay), {
                            aircraft: ac,
                            log: [
                                rejectedEntry
                            ],
                            spotIdToName: spotIdToName,
                            compact: true
                        })
                    ]
                })
            ]
        });
    }, [
        baseDate,
        getRejectedLogEntry,
        showDetailedView,
        spotIdToName
    ]);
    // Handle timeline scroll/zoom
    const handleTimeChange = (0, $acw62.useCallback)((newVisibleTimeStart, newVisibleTimeEnd, updateScrollCanvas)=>{
        setVisibleTimeStart(newVisibleTimeStart);
        setVisibleTimeEnd(newVisibleTimeEnd);
        updateScrollCanvas(newVisibleTimeStart, newVisibleTimeEnd);
        // Update viewport display
        setViewportStart(new Date(newVisibleTimeStart));
        setViewportEnd(new Date(newVisibleTimeEnd));
        // Notify parent to update input fields
        if (onViewportChange) onViewportChange(new Date(newVisibleTimeStart), new Date(newVisibleTimeEnd));
    }, [
        onViewportChange
    ]);
    // Handle print
    const handlePrint = ()=>{
        window.print();
    };
    // Custom label format for timeline headers
    const customLabelFormat = ([startTime], unit, labelWidth)=>{
        if (unit === "day") return labelWidth < 60 ? startTime.format("D") : startTime.format("ddd D");
        if (unit === "hour") return startTime.format("HH:00");
        if (unit === "minute") return startTime.format("HH:mm");
        if (unit === "month") return startTime.format("MMMM");
        return startTime.format("L");
    };
    // Format date range for print header
    const dateRangeString = `${(0, $kfA3C.format)(baseDate, "MMM d, yyyy")} - ${(0, $kfA3C.format)((0, $kCLFX.addHours)(baseDate, horizonHours), "MMM d, yyyy")}`;
    const printDateString = (0, $kfA3C.format)(new Date(), "MMM d, yyyy h:mm a");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        className: "spot-occupancy-gantt",
        direction: "column",
        height: "100%",
        "data-ramp-name": "Ramp" // TODO: Pass actual ramp name via props
        ,
        "data-date-range": dateRangeString,
        "data-print-date": printDateString,
        children: [
            !hideStatistics && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                elevation: 0,
                sx: {
                    p: 2,
                    mb: 2,
                    borderRadius: 2,
                    backgroundColor: "background.default",
                    border: 1,
                    borderColor: "divider"
                },
                className: "gantt-statistics",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 4,
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            display: "block",
                                            children: "Aircraft Placed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "h6",
                                            component: "div",
                                            children: [
                                                statistics?.placedAircraft || 0,
                                                " /",
                                                " ",
                                                statistics?.totalAircraft || 0
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            display: "block",
                                            children: "Avg Utilization"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "h6",
                                            component: "div",
                                            children: [
                                                avgUtilization,
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                statistics?.averageMoves !== undefined && statistics.averageMoves > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            display: "block",
                                            children: "Avg Moves"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "h6",
                                            component: "div",
                                            children: statistics.averageMoves.toFixed(1)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "outlined",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($utPXC))), {}),
                            onClick: handlePrint,
                            className: "print-button",
                            size: "small",
                            children: "Print"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    px: 2,
                    py: 1,
                    bgcolor: "background.default",
                    borderBottom: 1,
                    borderColor: "divider"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "caption",
                    color: "text.secondary",
                    children: [
                        "Currently viewing: ",
                        (0, $kfA3C.format)(viewportStart, "MMM d, yyyy HH:mm"),
                        " -",
                        " ",
                        (0, $kfA3C.format)(viewportEnd, "MMM d, yyyy HH:mm")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                ref: timelineContainerRef,
                className: "gantt-timeline-container",
                sx: {
                    flex: 1,
                    minHeight: 0,
                    position: "relative",
                    overflowY: "auto",
                    overflowX: "auto",
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 1,
                    // CSS custom properties for react-calendar-timeline dark/light mode
                    "--timeline-bg": theme.palette.background.paper,
                    "--timeline-bg-default": theme.palette.background.default,
                    "--timeline-border": theme.palette.divider,
                    "--timeline-text-primary": theme.palette.text.primary,
                    "--timeline-text-secondary": theme.palette.text.secondary,
                    "--timeline-header-bg": theme.palette.background.paper,
                    "--timeline-row-hover": theme.palette.action.hover,
                    "--timeline-grid-line": theme.palette.divider,
                    "--timeline-weekend-bg": theme.palette.action.selected
                },
                children: [
                    (()=>{
                        // Determine which aircraft to show (pinned takes priority over hover for consistency)
                        const displayAircraft = pinnedAircraft || hoveredAircraft;
                        if (!displayAircraft) return null;
                        const position = calculateGhostPosition(displayAircraft);
                        if (!position) return null;
                        const isPinned = pinnedAircraft?.id === displayAircraft.id;
                        const isDark = theme.palette.mode === "dark";
                        const primaryColor = theme.palette.primary.main;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                position: "absolute",
                                left: position.left,
                                width: position.width,
                                top: 0,
                                bottom: 0,
                                zIndex: 49,
                                // Below timeline items (z-index 50+)
                                background: `linear-gradient(to bottom, ${(0, $8gMkr.alpha)(primaryColor, isDark ? 0.15 : 0.12)}, ${(0, $8gMkr.alpha)(primaryColor, isDark ? 0.08 : 0.06)})`,
                                borderLeft: `2px dashed ${(0, $8gMkr.alpha)(primaryColor, isDark ? 0.4 : 0.35)}`,
                                borderRight: `2px dashed ${(0, $8gMkr.alpha)(primaryColor, isDark ? 0.4 : 0.35)}`,
                                borderTop: `1px solid ${(0, $8gMkr.alpha)(primaryColor, 0.25)}`,
                                pointerEvents: "none",
                                // Critical: doesn't block timeline interactions
                                transition: "opacity 200ms ease-out, width 200ms ease-out, left 200ms ease-out",
                                opacity: 1
                            },
                            children: isPinned && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    position: "absolute",
                                    top: 8,
                                    left: 8,
                                    bgcolor: (0, $8gMkr.alpha)(theme.palette.background.paper, 0.95),
                                    border: `1px solid ${(0, $8gMkr.alpha)(primaryColor, 0.3)}`,
                                    borderRadius: 1,
                                    px: 1,
                                    py: 0.5,
                                    fontSize: 11,
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    boxShadow: 1
                                },
                                children: [
                                    "\u2708 ",
                                    displayAircraft.tail_number
                                ]
                            })
                        });
                    })(),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5vA8q.default), {
                        groups: groups,
                        items: items,
                        keys: {
                            groupIdKey: "id",
                            groupTitleKey: "title",
                            groupLabelKey: "title",
                            groupRightTitleKey: "rightTitle",
                            itemIdKey: "id",
                            itemTitleKey: "title",
                            itemDivTitleKey: "divTitle",
                            // Use non-existent property to avoid native title attribute (conflicts with MUI Tooltip)
                            itemGroupKey: "group",
                            itemTimeStartKey: "start_time",
                            itemTimeEndKey: "end_time"
                        },
                        visibleTimeStart: visibleTimeStart,
                        visibleTimeEnd: visibleTimeEnd,
                        // Drag-and-drop configuration (skill file patterns)
                        canMove: enableEditing,
                        canResize: enableEditing ? "both" : false,
                        canChangeGroup: enableEditing,
                        canSelect: false,
                        dragSnap: 900000,
                        selected: enableEditing ? items.map((i)=>i.id) : [],
                        // Event handlers
                        onItemMove: enableEditing ? handleItemMove : undefined,
                        onItemResize: enableEditing ? handleItemResize : undefined,
                        onItemSelect: ()=>{},
                        moveResizeValidator: enableEditing ? moveResizeValidator : undefined,
                        onTimeChange: handleTimeChange,
                        // Enable mouse wheel zoom
                        // @ts-expect-error - mouseZoom exists in runtime but not in type definitions
                        mouseZoom: true,
                        minZoom: 43200000,
                        maxZoom: 15552000000,
                        // Display configuration
                        buffer: 1,
                        lineHeight: 40,
                        sidebarWidth: 150,
                        itemRenderer: itemRenderer,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5vA8q.TimelineHeaders), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.DateHeader), {
                                        unit: "primaryHeader"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.DateHeader), {
                                        labelFormat: customLabelFormat
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.TimelineMarkers), {
                                children: currentTimestamp && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.CustomMarker), {
                                    date: (0, $hvR20.getTime)(currentTimestamp),
                                    children: ({ styles: styles })=>{
                                        const customStyles = {
                                            ...styles,
                                            backgroundColor: theme.palette.primary.main,
                                            width: "2px",
                                            zIndex: 100
                                        };
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: customStyles,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    position: "absolute",
                                                    top: "-20px",
                                                    left: "-40px",
                                                    backgroundColor: theme.palette.primary.main,
                                                    color: theme.palette.primary.contrastText,
                                                    padding: "2px 8px",
                                                    borderRadius: "4px",
                                                    fontSize: "11px",
                                                    fontWeight: 600,
                                                    whiteSpace: "nowrap"
                                                },
                                                children: (0, $kfA3C.format)(currentTimestamp, "MMM d, HH:mm")
                                            })
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            statistics && statistics.unplacedAircraft > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    p: 1.5,
                    mt: 1,
                    borderRadius: 1,
                    backgroundColor: (0, $8gMkr.alpha)(theme.palette.error.main, 0.1),
                    border: 1,
                    borderColor: "error.main"
                },
                className: "gantt-unplaced",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "error.dark",
                        fontWeight: 600,
                        sx: {
                            mb: 1
                        },
                        children: [
                            "\u26A0 Fully Unplaced Aircraft (",
                            statistics.unplacedAircraft,
                            "):"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        flexWrap: "wrap",
                        useFlexGap: true,
                        children: aircraft.filter((ac)=>!placement[ac.id]).map((ac)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                title: buildUnplacedAircraftTooltip(ac),
                                arrow: true,
                                placement: "top",
                                slotProps: {
                                    popper: {
                                        modifiers: [
                                            {
                                                name: "flip",
                                                enabled: true,
                                                options: {
                                                    fallbackPlacements: [
                                                        "bottom",
                                                        "right",
                                                        "left"
                                                    ],
                                                    padding: 100
                                                }
                                            },
                                            {
                                                name: "preventOverflow",
                                                enabled: true,
                                                options: {
                                                    padding: 8,
                                                    altAxis: true
                                                }
                                            }
                                        ]
                                    },
                                    tooltip: {
                                        sx: {
                                            bgcolor: "background.paper",
                                            color: "text.primary",
                                            boxShadow: 3,
                                            border: "1px solid",
                                            borderColor: "divider",
                                            borderRadius: 2,
                                            p: 2,
                                            maxWidth: 500,
                                            // Increased from 360 to fit Decision Log content
                                            "& .MuiTooltip-arrow": {
                                                color: "background.paper",
                                                "&::before": {
                                                    border: "1px solid",
                                                    borderColor: "divider"
                                                }
                                            }
                                        }
                                    }
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: ac.tail_number,
                                    size: "small",
                                    color: "error",
                                    variant: "outlined",
                                    onMouseEnter: ()=>handleChipMouseEnter(ac),
                                    onMouseLeave: handleChipMouseLeave,
                                    onClick: ()=>handleChipClick(ac),
                                    sx: {
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        // Highlight if pinned
                                        ...pinnedAircraft?.id === ac.id && {
                                            bgcolor: (0, $8gMkr.alpha)(theme.palette.error.main, 0.15),
                                            borderWidth: 2
                                        }
                                    }
                                })
                            }, ac.id))
                    })
                ]
            }),
            (statistics?.partiallyPlacedAircraft ?? 0) > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    p: 1.5,
                    mt: 1,
                    borderRadius: 1,
                    backgroundColor: (0, $8gMkr.alpha)(theme.palette.warning.main, 0.1),
                    border: 1,
                    borderColor: "warning.main"
                },
                className: "gantt-partial",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "warning.dark",
                        fontWeight: 600,
                        sx: {
                            mb: 1
                        },
                        children: [
                            "\u26A0 Partially Placed Aircraft (",
                            statistics.partiallyPlacedAircraft,
                            "):"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "text.secondary",
                        sx: {
                            display: "block",
                            mb: 1.5
                        },
                        children: "These aircraft are assigned to the ramp but couldn't be placed for their entire trip duration:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        spacing: 1,
                        children: partialPlacements.map((partial)=>{
                            const gapPercent = Math.round(partial.gapPercentage);
                            const placedPercent = 100 - gapPercent;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                                    border: "1px solid rgba(0, 0, 0, 0.1)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        fontWeight: 600,
                                        color: "warning.dark",
                                        children: partial.tailNumber
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "caption",
                                        color: "text.secondary",
                                        sx: {
                                            display: "block",
                                            mt: 0.5
                                        },
                                        children: [
                                            "Placed: ",
                                            placedPercent,
                                            "% (",
                                            (0, $h7RLZ.formatDuration)(partial.placedDurationMinutes),
                                            ") | Gaps:",
                                            " ",
                                            gapPercent,
                                            "% (",
                                            (0, $h7RLZ.formatDuration)(partial.gapDurationMinutes),
                                            ")"
                                        ]
                                    }),
                                    partial.gaps.map((gap, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "error.dark",
                                            sx: {
                                                display: "block",
                                                mt: 0.5,
                                                ml: 1
                                            },
                                            children: [
                                                "\u2022 Gap ",
                                                idx + 1,
                                                ":",
                                                " ",
                                                (0, $h7RLZ.formatTimeRange)(gap.startTime, gap.endTime),
                                                " (",
                                                (0, $h7RLZ.formatDuration)(gap.durationMinutes),
                                                ")"
                                            ]
                                        }, idx))
                                ]
                            }, partial.aircraftId);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                className: "print-only-view",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RYDA.SpotSchedulePrintView), {
                    spots: spots,
                    aircraft: aircraft,
                    placement: placement,
                    horizonHours: horizonHours,
                    startTime: startTime,
                    rampShapes: rampShapes,
                    statistics: statistics,
                    dateRange: dateRangeString
                })
            })
        ]
    });
};

});
parcelRegister("6KM07", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $4eac45ec32c750b2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4eac45ec32c750b2$var$_createSvgIcon = $4eac45ec32c750b2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4eac45ec32c750b2$var$_default = module.exports.default = (0, $4eac45ec32c750b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6m.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2"
}), 'LocalParking');

});

parcelRegister("clR8m", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8fe0a98016eeb6bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fe0a98016eeb6bb$var$_createSvgIcon = $8fe0a98016eeb6bb$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8fe0a98016eeb6bb$var$_default = module.exports.default = (0, $8fe0a98016eeb6bb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6.99 11 3 15l3.99 4v-3H14v-2H6.99zM21 9l-3.99-4v3H10v2h7.01v3z"
}), 'SwapHoriz');

});

parcelRegister("hvR20", function(module, exports) {

$parcel$export(module.exports, "getTime", () => $66a187a483864bc4$export$1428f42a7de81803);

var $9Jots = parcelRequire("9Jots");
function $66a187a483864bc4$export$1428f42a7de81803(date) {
    const _date = (0, $9Jots.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}
var // Fallback for modularized imports:
$66a187a483864bc4$export$2e2bcd8739ae039 = $66a187a483864bc4$export$1428f42a7de81803;

});

parcelRegister("5vA8q", function(module, exports) {

$parcel$export(module.exports, "TimelineHeaders", () => $402be0a702aa527c$export$2ee434a1d99db2a0);
$parcel$export(module.exports, "DateHeader", () => $402be0a702aa527c$export$e8d17be7d8196f34);
$parcel$export(module.exports, "TimelineMarkers", () => $402be0a702aa527c$export$261c7e0d88c702db);
$parcel$export(module.exports, "TodayMarker", () => $402be0a702aa527c$export$d4a27226ade5fb61);
$parcel$export(module.exports, "CustomMarker", () => $402be0a702aa527c$export$2037ebd950c0fcb);
$parcel$export(module.exports, "default", () => $402be0a702aa527c$export$e6a97ba2cae5bb94);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
function $402be0a702aa527c$var$Hn(s) {
    let i = 0, a = 0, u = !0;
    for(; s;)!s.offsetParent && s.tagName === "BODY" && s.scrollLeft === 0 && s.scrollTop === 0 && (s = document.scrollingElement || s), i += s.offsetLeft - (u ? 0 : s.scrollLeft) + s.clientLeft, a += s.offsetTop - (u ? 0 : s.scrollTop) + s.clientTop, s = s.offsetParent, u = !1;
    return {
        x: i,
        y: a
    };
}
function $402be0a702aa527c$var$jt(s) {
    if (s === document.body) return {
        scrollLeft: 0,
        scrollTop: 0
    };
    {
        const i = $402be0a702aa527c$var$jt(s.parentNode);
        return {
            scrollLeft: s.scrollLeft + i.scrollLeft,
            scrollTop: s.scrollTop + i.scrollTop
        };
    }
}
function $402be0a702aa527c$var$At(s) {
    if (s === document.body || !s.offsetParent) return {
        offsetLeft: 0,
        offsetTop: 0
    };
    {
        const i = $402be0a702aa527c$var$At(s.offsetParent);
        return {
            offsetLeft: s.offsetLeft + i.offsetLeft,
            offsetTop: s.offsetTop + i.offsetTop
        };
    }
}
var $402be0a702aa527c$var$We = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $402be0a702aa527c$var$Ze(s) {
    return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var $402be0a702aa527c$var$Lt = {
    exports: {}
};
$402be0a702aa527c$var$Lt.exports;
(function(s, i) {
    (function(a, u) {
        s.exports = u();
    })($402be0a702aa527c$var$We, function() {
        function a(t1, e) {
            var r = Object.keys(t1);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t1);
                e && (n = n.filter(function(o) {
                    return Object.getOwnPropertyDescriptor(t1, o).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function u(t1) {
            for(var e = 1; e < arguments.length; e++){
                var r = arguments[e] != null ? arguments[e] : {};
                e % 2 ? a(Object(r), !0).forEach(function(n) {
                    x(t1, n, r[n]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(r)) : a(Object(r)).forEach(function(n) {
                    Object.defineProperty(t1, n, Object.getOwnPropertyDescriptor(r, n));
                });
            }
            return t1;
        }
        function f(t1) {
            return f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
                return typeof e;
            } : function(e) {
                return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, f(t1);
        }
        function v(t1, e) {
            if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function m(t1, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, C(n.key), n);
            }
        }
        function y(t1, e, r) {
            return e && m(t1.prototype, e), Object.defineProperty(t1, "prototype", {
                writable: !1
            }), t1;
        }
        function x(t1, e, r) {
            return (e = C(e)) in t1 ? Object.defineProperty(t1, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = r, t1;
        }
        function O(t1, e) {
            if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
            t1.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t1,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(t1, "prototype", {
                writable: !1
            }), e && P(t1, e);
        }
        function $(t1) {
            return $ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, $(t1);
        }
        function P(t1, e) {
            return P = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
                return r.__proto__ = n, r;
            }, P(t1, e);
        }
        function T(t1) {
            if (t1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t1;
        }
        function _(t1) {
            var e = function() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
                if (typeof Proxy == "function") return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch  {
                    return !1;
                }
            }();
            return function() {
                var r, n = $(t1);
                if (e) {
                    var o = $(this).constructor;
                    r = Reflect.construct(n, arguments, o);
                } else r = n.apply(this, arguments);
                return function(l, c) {
                    if (c && (typeof c == "object" || typeof c == "function")) return c;
                    if (c !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return T(l);
                }(this, r);
            };
        }
        function M() {
            return M = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(t1, e, r) {
                var n = function(l, c) {
                    for(; !Object.prototype.hasOwnProperty.call(l, c) && (l = $(l)) !== null;);
                    return l;
                }(t1, e);
                if (n) {
                    var o = Object.getOwnPropertyDescriptor(n, e);
                    return o.get ? o.get.call(arguments.length < 3 ? t1 : r) : o.value;
                }
            }, M.apply(this, arguments);
        }
        function C(t1) {
            var e = function(r, n) {
                if (typeof r != "object" || r === null) return r;
                var o = r[Symbol.toPrimitive];
                if (o !== void 0) {
                    var l = o.call(r, n);
                    if (typeof l != "object") return l;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(r);
            }(t1, "string");
            return typeof e == "symbol" ? e : e + "";
        }
        var z = function(t1) {
            return !(!t1 || !t1.Window) && t1 instanceof t1.Window;
        }, N = void 0, G = void 0;
        function Q(t1) {
            N = t1;
            var e = t1.document.createTextNode("");
            e.ownerDocument !== t1.document && typeof t1.wrap == "function" && t1.wrap(e) === e && (t1 = t1.wrap(t1)), G = t1;
        }
        function te(t1) {
            return z(t1) ? t1 : (t1.ownerDocument || t1).defaultView || G.window;
        }
        typeof window < "u" && window && Q(window);
        var re = function(t1) {
            return !!t1 && f(t1) === "object";
        }, ue = function(t1) {
            return typeof t1 == "function";
        }, S = {
            window: function(t1) {
                return t1 === G || z(t1);
            },
            docFrag: function(t1) {
                return re(t1) && t1.nodeType === 11;
            },
            object: re,
            func: ue,
            number: function(t1) {
                return typeof t1 == "number";
            },
            bool: function(t1) {
                return typeof t1 == "boolean";
            },
            string: function(t1) {
                return typeof t1 == "string";
            },
            element: function(t1) {
                if (!t1 || f(t1) !== "object") return !1;
                var e = te(t1) || G;
                return /object|function/.test(typeof Element > "u" ? "undefined" : f(Element)) ? t1 instanceof Element || t1 instanceof e.Element : t1.nodeType === 1 && typeof t1.nodeName == "string";
            },
            plainObject: function(t1) {
                return re(t1) && !!t1.constructor && /function Object\b/.test(t1.constructor.toString());
            },
            array: function(t1) {
                return re(t1) && t1.length !== void 0 && ue(t1.splice);
            }
        };
        function be(t1) {
            var e = t1.interaction;
            if (e.prepared.name === "drag") {
                var r = e.prepared.axis;
                r === "x" ? (e.coords.cur.page.y = e.coords.start.page.y, e.coords.cur.client.y = e.coords.start.client.y, e.coords.velocity.client.y = 0, e.coords.velocity.page.y = 0) : r === "y" && (e.coords.cur.page.x = e.coords.start.page.x, e.coords.cur.client.x = e.coords.start.client.x, e.coords.velocity.client.x = 0, e.coords.velocity.page.x = 0);
            }
        }
        function we(t1) {
            var e = t1.iEvent, r = t1.interaction;
            if (r.prepared.name === "drag") {
                var n = r.prepared.axis;
                if (n === "x" || n === "y") {
                    var o = n === "x" ? "y" : "x";
                    e.page[o] = r.coords.start.page[o], e.client[o] = r.coords.start.client[o], e.delta[o] = 0;
                }
            }
        }
        var ce = {
            id: "actions/drag",
            install: function(t1) {
                var e = t1.actions, r = t1.Interactable, n = t1.defaults;
                r.prototype.draggable = ce.draggable, e.map.drag = ce, e.methodDict.drag = "draggable", n.actions.drag = ce.defaults;
            },
            listeners: {
                "interactions:before-action-move": be,
                "interactions:action-resume": be,
                "interactions:action-move": we,
                "auto-start:check": function(t1) {
                    var e = t1.interaction, r = t1.interactable, n = t1.buttons, o = r.options.drag;
                    if (o && o.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || n & r.options.drag.mouseButtons)) return t1.action = {
                        name: "drag",
                        axis: o.lockAxis === "start" ? o.startAxis : o.lockAxis
                    }, !1;
                }
            },
            draggable: function(t1) {
                return S.object(t1) ? (this.options.drag.enabled = t1.enabled !== !1, this.setPerAction("drag", t1), this.setOnEvents("drag", t1), /^(xy|x|y|start)$/.test(t1.lockAxis) && (this.options.drag.lockAxis = t1.lockAxis), /^(xy|x|y)$/.test(t1.startAxis) && (this.options.drag.startAxis = t1.startAxis), this) : S.bool(t1) ? (this.options.drag.enabled = t1, this) : this.options.drag;
            },
            beforeMove: be,
            move: we,
            defaults: {
                startAxis: "xy",
                lockAxis: "xy"
            },
            getCursor: function() {
                return "move";
            },
            filterEventType: function(t1) {
                return t1.search("drag") === 0;
            }
        }, ne = ce, de = {
            init: function(t1) {
                var e = t1;
                de.document = e.document, de.DocumentFragment = e.DocumentFragment || Ee, de.SVGElement = e.SVGElement || Ee, de.SVGSVGElement = e.SVGSVGElement || Ee, de.SVGElementInstance = e.SVGElementInstance || Ee, de.Element = e.Element || Ee, de.HTMLElement = e.HTMLElement || de.Element, de.Event = e.Event, de.Touch = e.Touch || Ee, de.PointerEvent = e.PointerEvent || e.MSPointerEvent;
            },
            document: null,
            DocumentFragment: null,
            SVGElement: null,
            SVGSVGElement: null,
            SVGElementInstance: null,
            Element: null,
            HTMLElement: null,
            Event: null,
            Touch: null,
            PointerEvent: null
        };
        function Ee() {}
        var W = de, k = {
            init: function(t1) {
                var e = W.Element, r = t1.navigator || {};
                k.supportsTouch = "ontouchstart" in t1 || S.func(t1.DocumentTouch) && W.document instanceof t1.DocumentTouch, k.supportsPointerEvent = r.pointerEnabled !== !1 && !!W.PointerEvent, k.isIOS = /iP(hone|od|ad)/.test(r.platform), k.isIOS7 = /iP(hone|od|ad)/.test(r.platform) && /OS 7[^\d]/.test(r.appVersion), k.isIe9 = /MSIE 9/.test(r.userAgent), k.isOperaMobile = r.appName === "Opera" && k.supportsTouch && /Presto/.test(r.userAgent), k.prefixedMatchesSelector = "matches" in e.prototype ? "matches" : "webkitMatchesSelector" in e.prototype ? "webkitMatchesSelector" : "mozMatchesSelector" in e.prototype ? "mozMatchesSelector" : "oMatchesSelector" in e.prototype ? "oMatchesSelector" : "msMatchesSelector", k.pEventTypes = k.supportsPointerEvent ? W.PointerEvent === t1.MSPointerEvent ? {
                    up: "MSPointerUp",
                    down: "MSPointerDown",
                    over: "mouseover",
                    out: "mouseout",
                    move: "MSPointerMove",
                    cancel: "MSPointerCancel"
                } : {
                    up: "pointerup",
                    down: "pointerdown",
                    over: "pointerover",
                    out: "pointerout",
                    move: "pointermove",
                    cancel: "pointercancel"
                } : null, k.wheelEvent = W.document && "onmousewheel" in W.document ? "mousewheel" : "wheel";
            },
            supportsTouch: null,
            supportsPointerEvent: null,
            isIOS7: null,
            isIOS: null,
            isIe9: null,
            isOperaMobile: null,
            prefixedMatchesSelector: null,
            pEventTypes: null,
            wheelEvent: null
        }, R = k;
        function F(t1, e) {
            if (t1.contains) return t1.contains(e);
            for(; e;){
                if (e === t1) return !0;
                e = e.parentNode;
            }
            return !1;
        }
        function A(t1, e) {
            for(; S.element(t1);){
                if (X(t1, e)) return t1;
                t1 = K(t1);
            }
            return null;
        }
        function K(t1) {
            var e = t1.parentNode;
            if (S.docFrag(e)) {
                for(; (e = e.host) && S.docFrag(e););
                return e;
            }
            return e;
        }
        function X(t1, e) {
            return G !== N && (e = e.replace(/\/deep\//g, " ")), t1[R.prefixedMatchesSelector](e);
        }
        var ie = function(t1) {
            return t1.parentNode || t1.host;
        };
        function ae(t1, e) {
            for(var r, n = [], o = t1; (r = ie(o)) && o !== e && r !== o.ownerDocument;)n.unshift(o), o = r;
            return n;
        }
        function pe(t1, e, r) {
            for(; S.element(t1);){
                if (X(t1, e)) return !0;
                if ((t1 = K(t1)) === r) return X(t1, e);
            }
            return !1;
        }
        function he(t1) {
            return t1.correspondingUseElement || t1;
        }
        function ve(t1) {
            var e = t1 instanceof W.SVGElement ? t1.getBoundingClientRect() : t1.getClientRects()[0];
            return e && {
                left: e.left,
                right: e.right,
                top: e.top,
                bottom: e.bottom,
                width: e.width || e.right - e.left,
                height: e.height || e.bottom - e.top
            };
        }
        function Oe(t1) {
            var e, r = ve(t1);
            if (!R.isIOS7 && r) {
                var n = {
                    x: (e = (e = te(t1)) || G).scrollX || e.document.documentElement.scrollLeft,
                    y: e.scrollY || e.document.documentElement.scrollTop
                };
                r.left += n.x, r.right += n.x, r.top += n.y, r.bottom += n.y;
            }
            return r;
        }
        function Ce(t1) {
            for(var e = []; t1;)e.push(t1), t1 = K(t1);
            return e;
        }
        function ke(t1) {
            return !!S.string(t1) && (W.document.querySelector(t1), !0);
        }
        function H(t1, e) {
            for(var r in e)t1[r] = e[r];
            return t1;
        }
        function fe(t1, e, r) {
            return t1 === "parent" ? K(r) : t1 === "self" ? e.getRect(r) : A(r, t1);
        }
        function ye(t1, e, r, n) {
            var o = t1;
            return S.string(o) ? o = fe(o, e, r) : S.func(o) && (o = o.apply(void 0, n)), S.element(o) && (o = Oe(o)), o;
        }
        function _e(t1) {
            return t1 && {
                x: "x" in t1 ? t1.x : t1.left,
                y: "y" in t1 ? t1.y : t1.top
            };
        }
        function ze(t1) {
            return !t1 || "x" in t1 && "y" in t1 || ((t1 = H({}, t1)).x = t1.left || 0, t1.y = t1.top || 0, t1.width = t1.width || (t1.right || 0) - t1.x, t1.height = t1.height || (t1.bottom || 0) - t1.y), t1;
        }
        function mt(t1, e, r) {
            t1.left && (e.left += r.x), t1.right && (e.right += r.x), t1.top && (e.top += r.y), t1.bottom && (e.bottom += r.y), e.width = e.right - e.left, e.height = e.bottom - e.top;
        }
        function it(t1, e, r) {
            var n = r && t1.options[r];
            return _e(ye(n && n.origin || t1.options.origin, t1, e, [
                t1 && e
            ])) || {
                x: 0,
                y: 0
            };
        }
        function Ue(t1, e) {
            var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(h) {
                return !0;
            }, n = arguments.length > 3 ? arguments[3] : void 0;
            if (n = n || {}, S.string(t1) && t1.search(" ") !== -1 && (t1 = Br(t1)), S.array(t1)) return t1.forEach(function(h) {
                return Ue(h, e, r, n);
            }), n;
            if (S.object(t1) && (e = t1, t1 = ""), S.func(e) && r(t1)) n[t1] = n[t1] || [], n[t1].push(e);
            else if (S.array(e)) for(var o = 0, l = e; o < l.length; o++){
                var c = l[o];
                Ue(t1, c, r, n);
            }
            else if (S.object(e)) for(var p in e)Ue(Br(p).map(function(h) {
                return "".concat(t1).concat(h);
            }), e[p], r, n);
            return n;
        }
        function Br(t1) {
            return t1.trim().split(/ +/);
        }
        var ot = function(t1, e) {
            return Math.sqrt(t1 * t1 + e * e);
        }, ao = [
            "webkit",
            "moz"
        ];
        function bt(t1, e) {
            t1.__set || (t1.__set = {});
            var r = function(o) {
                if (ao.some(function(l) {
                    return o.indexOf(l) === 0;
                })) return 1;
                typeof t1[o] != "function" && o !== "__set" && Object.defineProperty(t1, o, {
                    get: function() {
                        return o in t1.__set ? t1.__set[o] : t1.__set[o] = e[o];
                    },
                    set: function(l) {
                        t1.__set[o] = l;
                    },
                    configurable: !0
                });
            };
            for(var n in e)r(n);
            return t1;
        }
        function yt(t1, e) {
            t1.page = t1.page || {}, t1.page.x = e.page.x, t1.page.y = e.page.y, t1.client = t1.client || {}, t1.client.x = e.client.x, t1.client.y = e.client.y, t1.timeStamp = e.timeStamp;
        }
        function Vr(t1) {
            t1.page.x = 0, t1.page.y = 0, t1.client.x = 0, t1.client.y = 0;
        }
        function qr(t1) {
            return t1 instanceof W.Event || t1 instanceof W.Touch;
        }
        function Tt(t1, e, r) {
            return t1 = t1 || "page", (r = r || {}).x = e[t1 + "X"], r.y = e[t1 + "Y"], r;
        }
        function Zr(t1, e) {
            return e = e || {
                x: 0,
                y: 0
            }, R.isOperaMobile && qr(t1) ? (Tt("screen", t1, e), e.x += window.scrollX, e.y += window.scrollY) : Tt("page", t1, e), e;
        }
        function st(t1) {
            return S.number(t1.pointerId) ? t1.pointerId : t1.identifier;
        }
        function lo(t1, e, r) {
            var n = e.length > 1 ? Jr(e) : e[0];
            Zr(n, t1.page), function(o, l) {
                l = l || {}, R.isOperaMobile && qr(o) ? Tt("screen", o, l) : Tt("client", o, l);
            }(n, t1.client), t1.timeStamp = r;
        }
        function Jt(t1) {
            var e = [];
            return S.array(t1) ? (e[0] = t1[0], e[1] = t1[1]) : t1.type === "touchend" ? t1.touches.length === 1 ? (e[0] = t1.touches[0], e[1] = t1.changedTouches[0]) : t1.touches.length === 0 && (e[0] = t1.changedTouches[0], e[1] = t1.changedTouches[1]) : (e[0] = t1.touches[0], e[1] = t1.touches[1]), e;
        }
        function Jr(t1) {
            for(var e = {
                pageX: 0,
                pageY: 0,
                clientX: 0,
                clientY: 0,
                screenX: 0,
                screenY: 0
            }, r = 0; r < t1.length; r++){
                var n = t1[r];
                for(var o in e)e[o] += n[o];
            }
            for(var l in e)e[l] /= t1.length;
            return e;
        }
        function Qt(t1) {
            if (!t1.length) return null;
            var e = Jt(t1), r = Math.min(e[0].pageX, e[1].pageX), n = Math.min(e[0].pageY, e[1].pageY), o = Math.max(e[0].pageX, e[1].pageX), l = Math.max(e[0].pageY, e[1].pageY);
            return {
                x: r,
                y: n,
                left: r,
                top: n,
                right: o,
                bottom: l,
                width: o - r,
                height: l - n
            };
        }
        function er(t1, e) {
            var r = e + "X", n = e + "Y", o = Jt(t1), l = o[0][r] - o[1][r], c = o[0][n] - o[1][n];
            return ot(l, c);
        }
        function tr(t1, e) {
            var r = e + "X", n = e + "Y", o = Jt(t1), l = o[1][r] - o[0][r], c = o[1][n] - o[0][n];
            return 180 * Math.atan2(c, l) / Math.PI;
        }
        function Qr(t1) {
            return S.string(t1.pointerType) ? t1.pointerType : S.number(t1.pointerType) ? [
                void 0,
                void 0,
                "touch",
                "pen",
                "mouse"
            ][t1.pointerType] : /touch/.test(t1.type || "") || t1 instanceof W.Touch ? "touch" : "mouse";
        }
        function en(t1) {
            var e = S.func(t1.composedPath) ? t1.composedPath() : t1.path;
            return [
                he(e ? e[0] : t1.target),
                he(t1.currentTarget)
            ];
        }
        var wt = function() {
            function t1(e) {
                v(this, t1), this.immediatePropagationStopped = !1, this.propagationStopped = !1, this._interaction = e;
            }
            return y(t1, [
                {
                    key: "preventDefault",
                    value: function() {}
                },
                {
                    key: "stopPropagation",
                    value: function() {
                        this.propagationStopped = !0;
                    }
                },
                {
                    key: "stopImmediatePropagation",
                    value: function() {
                        this.immediatePropagationStopped = this.propagationStopped = !0;
                    }
                }
            ]), t1;
        }();
        Object.defineProperty(wt.prototype, "interaction", {
            get: function() {
                return this._interaction._proxy;
            },
            set: function() {}
        });
        var tn = function(t1, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                t1.push(n);
            }
            return t1;
        }, rn = function(t1) {
            return tn([], t1);
        }, at = function(t1, e) {
            for(var r = 0; r < t1.length; r++)if (e(t1[r], r, t1)) return r;
            return -1;
        }, lt = function(t1, e) {
            return t1[at(t1, e)];
        }, Xe = function(t1) {
            O(r, t1);
            var e = _(r);
            function r(n, o, l) {
                var c;
                v(this, r), (c = e.call(this, o._interaction)).dropzone = void 0, c.dragEvent = void 0, c.relatedTarget = void 0, c.draggable = void 0, c.propagationStopped = !1, c.immediatePropagationStopped = !1;
                var p = l === "dragleave" ? n.prev : n.cur, h = p.element, g = p.dropzone;
                return c.type = l, c.target = h, c.currentTarget = h, c.dropzone = g, c.dragEvent = o, c.relatedTarget = o.target, c.draggable = o.interactable, c.timeStamp = o.timeStamp, c;
            }
            return y(r, [
                {
                    key: "reject",
                    value: function() {
                        var n = this, o = this._interaction.dropState;
                        if (this.type === "dropactivate" || this.dropzone && o.cur.dropzone === this.dropzone && o.cur.element === this.target) {
                            if (o.prev.dropzone = this.dropzone, o.prev.element = this.target, o.rejected = !0, o.events.enter = null, this.stopImmediatePropagation(), this.type === "dropactivate") {
                                var l = o.activeDrops, c = at(l, function(h) {
                                    var g = h.dropzone, d = h.element;
                                    return g === n.dropzone && d === n.target;
                                });
                                o.activeDrops.splice(c, 1);
                                var p = new r(o, this.dragEvent, "dropdeactivate");
                                p.dropzone = this.dropzone, p.target = this.target, this.dropzone.fire(p);
                            } else this.dropzone.fire(new r(o, this.dragEvent, "dragleave"));
                        }
                    }
                },
                {
                    key: "preventDefault",
                    value: function() {}
                },
                {
                    key: "stopPropagation",
                    value: function() {
                        this.propagationStopped = !0;
                    }
                },
                {
                    key: "stopImmediatePropagation",
                    value: function() {
                        this.immediatePropagationStopped = this.propagationStopped = !0;
                    }
                }
            ]), r;
        }(wt);
        function nn(t1, e) {
            for(var r = 0, n = t1.slice(); r < n.length; r++){
                var o = n[r], l = o.dropzone, c = o.element;
                e.dropzone = l, e.target = c, l.fire(e), e.propagationStopped = e.immediatePropagationStopped = !1;
            }
        }
        function rr(t1, e) {
            for(var r = function(l, c) {
                for(var p = [], h = 0, g = l.interactables.list; h < g.length; h++){
                    var d = g[h];
                    if (d.options.drop.enabled) {
                        var b = d.options.drop.accept;
                        if (!(S.element(b) && b !== c || S.string(b) && !X(c, b) || S.func(b) && !b({
                            dropzone: d,
                            draggableElement: c
                        }))) for(var w = 0, I = d.getAllElements(); w < I.length; w++){
                            var E = I[w];
                            E !== c && p.push({
                                dropzone: d,
                                element: E,
                                rect: d.getRect(E)
                            });
                        }
                    }
                }
                return p;
            }(t1, e), n = 0; n < r.length; n++){
                var o = r[n];
                o.rect = o.dropzone.getRect(o.element);
            }
            return r;
        }
        function on(t1, e, r) {
            for(var n = t1.dropState, o = t1.interactable, l = t1.element, c = [], p = 0, h = n.activeDrops; p < h.length; p++){
                var g = h[p], d = g.dropzone, b = g.element, w = g.rect, I = d.dropCheck(e, r, o, l, b, w);
                c.push(I ? b : null);
            }
            var E = function(D) {
                for(var L, j, Y, q = [], ee = 0; ee < D.length; ee++){
                    var B = D[ee], Z = D[L];
                    if (B && ee !== L) {
                        if (Z) {
                            var me = ie(B), le = ie(Z);
                            if (me !== B.ownerDocument) {
                                if (le !== B.ownerDocument) {
                                    if (me !== le) {
                                        q = q.length ? q : ae(Z);
                                        var Te = void 0;
                                        if (Z instanceof W.HTMLElement && B instanceof W.SVGElement && !(B instanceof W.SVGSVGElement)) {
                                            if (B === le) continue;
                                            Te = B.ownerSVGElement;
                                        } else Te = B;
                                        for(var Se = ae(Te, Z.ownerDocument), De = 0; Se[De] && Se[De] === q[De];)De++;
                                        var Pt = [
                                            Se[De - 1],
                                            Se[De],
                                            q[De]
                                        ];
                                        if (Pt[0]) for(var ft = Pt[0].lastChild; ft;){
                                            if (ft === Pt[1]) {
                                                L = ee, q = Se;
                                                break;
                                            }
                                            if (ft === Pt[2]) break;
                                            ft = ft.previousSibling;
                                        }
                                    } else Y = Z, (parseInt(te(j = B).getComputedStyle(j).zIndex, 10) || 0) >= (parseInt(te(Y).getComputedStyle(Y).zIndex, 10) || 0) && (L = ee);
                                } else L = ee;
                            }
                        } else L = ee;
                    }
                }
                return L;
            }(c);
            return n.activeDrops[E] || null;
        }
        function nr(t1, e, r) {
            var n = t1.dropState, o = {
                enter: null,
                leave: null,
                activate: null,
                deactivate: null,
                move: null,
                drop: null
            };
            return r.type === "dragstart" && (o.activate = new Xe(n, r, "dropactivate"), o.activate.target = null, o.activate.dropzone = null), r.type === "dragend" && (o.deactivate = new Xe(n, r, "dropdeactivate"), o.deactivate.target = null, o.deactivate.dropzone = null), n.rejected || (n.cur.element !== n.prev.element && (n.prev.dropzone && (o.leave = new Xe(n, r, "dragleave"), r.dragLeave = o.leave.target = n.prev.element, r.prevDropzone = o.leave.dropzone = n.prev.dropzone), n.cur.dropzone && (o.enter = new Xe(n, r, "dragenter"), r.dragEnter = n.cur.element, r.dropzone = n.cur.dropzone)), r.type === "dragend" && n.cur.dropzone && (o.drop = new Xe(n, r, "drop"), r.dropzone = n.cur.dropzone, r.relatedTarget = n.cur.element), r.type === "dragmove" && n.cur.dropzone && (o.move = new Xe(n, r, "dropmove"), r.dropzone = n.cur.dropzone)), o;
        }
        function ir(t1, e) {
            var r = t1.dropState, n = r.activeDrops, o = r.cur, l = r.prev;
            e.leave && l.dropzone.fire(e.leave), e.enter && o.dropzone.fire(e.enter), e.move && o.dropzone.fire(e.move), e.drop && o.dropzone.fire(e.drop), e.deactivate && nn(n, e.deactivate), r.prev.dropzone = o.dropzone, r.prev.element = o.element;
        }
        function sn(t1, e) {
            var r = t1.interaction, n = t1.iEvent, o = t1.event;
            if (n.type === "dragmove" || n.type === "dragend") {
                var l = r.dropState;
                e.dynamicDrop && (l.activeDrops = rr(e, r.element));
                var c = n, p = on(r, c, o);
                l.rejected = l.rejected && !!p && p.dropzone === l.cur.dropzone && p.element === l.cur.element, l.cur.dropzone = p && p.dropzone, l.cur.element = p && p.element, l.events = nr(r, 0, c);
            }
        }
        var an = {
            id: "actions/drop",
            install: function(t1) {
                var e = t1.actions, r = t1.interactStatic, n = t1.Interactable, o = t1.defaults;
                t1.usePlugin(ne), n.prototype.dropzone = function(l) {
                    return function(c, p) {
                        if (S.object(p)) {
                            if (c.options.drop.enabled = p.enabled !== !1, p.listeners) {
                                var h = Ue(p.listeners), g = Object.keys(h).reduce(function(b, w) {
                                    return b[/^(enter|leave)/.test(w) ? "drag".concat(w) : /^(activate|deactivate|move)/.test(w) ? "drop".concat(w) : w] = h[w], b;
                                }, {}), d = c.options.drop.listeners;
                                d && c.off(d), c.on(g), c.options.drop.listeners = g;
                            }
                            return S.func(p.ondrop) && c.on("drop", p.ondrop), S.func(p.ondropactivate) && c.on("dropactivate", p.ondropactivate), S.func(p.ondropdeactivate) && c.on("dropdeactivate", p.ondropdeactivate), S.func(p.ondragenter) && c.on("dragenter", p.ondragenter), S.func(p.ondragleave) && c.on("dragleave", p.ondragleave), S.func(p.ondropmove) && c.on("dropmove", p.ondropmove), /^(pointer|center)$/.test(p.overlap) ? c.options.drop.overlap = p.overlap : S.number(p.overlap) && (c.options.drop.overlap = Math.max(Math.min(1, p.overlap), 0)), "accept" in p && (c.options.drop.accept = p.accept), "checker" in p && (c.options.drop.checker = p.checker), c;
                        }
                        return S.bool(p) ? (c.options.drop.enabled = p, c) : c.options.drop;
                    }(this, l);
                }, n.prototype.dropCheck = function(l, c, p, h, g, d) {
                    return function(b, w, I, E, D, L, j) {
                        var Y = !1;
                        if (!(j = j || b.getRect(L))) return !!b.options.drop.checker && b.options.drop.checker(w, I, Y, b, L, E, D);
                        var q = b.options.drop.overlap;
                        if (q === "pointer") {
                            var ee = it(E, D, "drag"), B = Zr(w);
                            B.x += ee.x, B.y += ee.y;
                            var Z = B.x > j.left && B.x < j.right, me = B.y > j.top && B.y < j.bottom;
                            Y = Z && me;
                        }
                        var le = E.getRect(D);
                        if (le && q === "center") {
                            var Te = le.left + le.width / 2, Se = le.top + le.height / 2;
                            Y = Te >= j.left && Te <= j.right && Se >= j.top && Se <= j.bottom;
                        }
                        return le && S.number(q) && (Y = Math.max(0, Math.min(j.right, le.right) - Math.max(j.left, le.left)) * Math.max(0, Math.min(j.bottom, le.bottom) - Math.max(j.top, le.top)) / (le.width * le.height) >= q), b.options.drop.checker && (Y = b.options.drop.checker(w, I, Y, b, L, E, D)), Y;
                    }(this, l, c, p, h, g, d);
                }, r.dynamicDrop = function(l) {
                    return S.bool(l) ? (t1.dynamicDrop = l, r) : t1.dynamicDrop;
                }, H(e.phaselessTypes, {
                    dragenter: !0,
                    dragleave: !0,
                    dropactivate: !0,
                    dropdeactivate: !0,
                    dropmove: !0,
                    drop: !0
                }), e.methodDict.drop = "dropzone", t1.dynamicDrop = !1, o.actions.drop = an.defaults;
            },
            listeners: {
                "interactions:before-action-start": function(t1) {
                    var e = t1.interaction;
                    e.prepared.name === "drag" && (e.dropState = {
                        cur: {
                            dropzone: null,
                            element: null
                        },
                        prev: {
                            dropzone: null,
                            element: null
                        },
                        rejected: null,
                        events: null,
                        activeDrops: []
                    });
                },
                "interactions:after-action-start": function(t1, e) {
                    var r = t1.interaction, n = (t1.event, t1.iEvent);
                    if (r.prepared.name === "drag") {
                        var o = r.dropState;
                        o.activeDrops = [], o.events = {}, o.activeDrops = rr(e, r.element), o.events = nr(r, 0, n), o.events.activate && (nn(o.activeDrops, o.events.activate), e.fire("actions/drop:start", {
                            interaction: r,
                            dragEvent: n
                        }));
                    }
                },
                "interactions:action-move": sn,
                "interactions:after-action-move": function(t1, e) {
                    var r = t1.interaction, n = t1.iEvent;
                    if (r.prepared.name === "drag") {
                        var o = r.dropState;
                        ir(r, o.events), e.fire("actions/drop:move", {
                            interaction: r,
                            dragEvent: n
                        }), o.events = {};
                    }
                },
                "interactions:action-end": function(t1, e) {
                    if (t1.interaction.prepared.name === "drag") {
                        var r = t1.interaction, n = t1.iEvent;
                        sn(t1, e), ir(r, r.dropState.events), e.fire("actions/drop:end", {
                            interaction: r,
                            dragEvent: n
                        });
                    }
                },
                "interactions:stop": function(t1) {
                    var e = t1.interaction;
                    if (e.prepared.name === "drag") {
                        var r = e.dropState;
                        r && (r.activeDrops = null, r.events = null, r.cur.dropzone = null, r.cur.element = null, r.prev.dropzone = null, r.prev.element = null, r.rejected = !1);
                    }
                }
            },
            getActiveDrops: rr,
            getDrop: on,
            getDropEvents: nr,
            fireDropEvents: ir,
            filterEventType: function(t1) {
                return t1.search("drag") === 0 || t1.search("drop") === 0;
            },
            defaults: {
                enabled: !1,
                accept: null,
                overlap: "pointer"
            }
        }, co = an;
        function or(t1) {
            var e = t1.interaction, r = t1.iEvent, n = t1.phase;
            if (e.prepared.name === "gesture") {
                var o = e.pointers.map(function(g) {
                    return g.pointer;
                }), l = n === "start", c = n === "end", p = e.interactable.options.deltaSource;
                if (r.touches = [
                    o[0],
                    o[1]
                ], l) r.distance = er(o, p), r.box = Qt(o), r.scale = 1, r.ds = 0, r.angle = tr(o, p), r.da = 0, e.gesture.startDistance = r.distance, e.gesture.startAngle = r.angle;
                else if (c || e.pointers.length < 2) {
                    var h = e.prevEvent;
                    r.distance = h.distance, r.box = h.box, r.scale = h.scale, r.ds = 0, r.angle = h.angle, r.da = 0;
                } else r.distance = er(o, p), r.box = Qt(o), r.scale = r.distance / e.gesture.startDistance, r.angle = tr(o, p), r.ds = r.scale - e.gesture.scale, r.da = r.angle - e.gesture.angle;
                e.gesture.distance = r.distance, e.gesture.angle = r.angle, S.number(r.scale) && r.scale !== 1 / 0 && !isNaN(r.scale) && (e.gesture.scale = r.scale);
            }
        }
        var sr = {
            id: "actions/gesture",
            before: [
                "actions/drag",
                "actions/resize"
            ],
            install: function(t1) {
                var e = t1.actions, r = t1.Interactable, n = t1.defaults;
                r.prototype.gesturable = function(o) {
                    return S.object(o) ? (this.options.gesture.enabled = o.enabled !== !1, this.setPerAction("gesture", o), this.setOnEvents("gesture", o), this) : S.bool(o) ? (this.options.gesture.enabled = o, this) : this.options.gesture;
                }, e.map.gesture = sr, e.methodDict.gesture = "gesturable", n.actions.gesture = sr.defaults;
            },
            listeners: {
                "interactions:action-start": or,
                "interactions:action-move": or,
                "interactions:action-end": or,
                "interactions:new": function(t1) {
                    t1.interaction.gesture = {
                        angle: 0,
                        distance: 0,
                        scale: 1,
                        startAngle: 0,
                        startDistance: 0
                    };
                },
                "auto-start:check": function(t1) {
                    if (!(t1.interaction.pointers.length < 2)) {
                        var e = t1.interactable.options.gesture;
                        if (e && e.enabled) return t1.action = {
                            name: "gesture"
                        }, !1;
                    }
                }
            },
            defaults: {},
            getCursor: function() {
                return "";
            },
            filterEventType: function(t1) {
                return t1.search("gesture") === 0;
            }
        }, uo = sr;
        function po(t1, e, r, n, o, l, c) {
            if (!e) return !1;
            if (e === !0) {
                var p = S.number(l.width) ? l.width : l.right - l.left, h = S.number(l.height) ? l.height : l.bottom - l.top;
                if (c = Math.min(c, Math.abs((t1 === "left" || t1 === "right" ? p : h) / 2)), p < 0 && (t1 === "left" ? t1 = "right" : t1 === "right" && (t1 = "left")), h < 0 && (t1 === "top" ? t1 = "bottom" : t1 === "bottom" && (t1 = "top")), t1 === "left") {
                    var g = p >= 0 ? l.left : l.right;
                    return r.x < g + c;
                }
                if (t1 === "top") {
                    var d = h >= 0 ? l.top : l.bottom;
                    return r.y < d + c;
                }
                if (t1 === "right") return r.x > (p >= 0 ? l.right : l.left) - c;
                if (t1 === "bottom") return r.y > (h >= 0 ? l.bottom : l.top) - c;
            }
            return !!S.element(n) && (S.element(e) ? e === n : pe(n, e, o));
        }
        function ln(t1) {
            var e = t1.iEvent, r = t1.interaction;
            if (r.prepared.name === "resize" && r.resizeAxes) {
                var n = e;
                r.interactable.options.resize.square ? (r.resizeAxes === "y" ? n.delta.x = n.delta.y : n.delta.y = n.delta.x, n.axes = "xy") : (n.axes = r.resizeAxes, r.resizeAxes === "x" ? n.delta.y = 0 : r.resizeAxes === "y" && (n.delta.x = 0));
            }
        }
        var Ie, Ne, Pe = {
            id: "actions/resize",
            before: [
                "actions/drag"
            ],
            install: function(t1) {
                var e = t1.actions, r = t1.browser, n = t1.Interactable, o = t1.defaults;
                Pe.cursors = function(l) {
                    return l.isIe9 ? {
                        x: "e-resize",
                        y: "s-resize",
                        xy: "se-resize",
                        top: "n-resize",
                        left: "w-resize",
                        bottom: "s-resize",
                        right: "e-resize",
                        topleft: "se-resize",
                        bottomright: "se-resize",
                        topright: "ne-resize",
                        bottomleft: "ne-resize"
                    } : {
                        x: "ew-resize",
                        y: "ns-resize",
                        xy: "nwse-resize",
                        top: "ns-resize",
                        left: "ew-resize",
                        bottom: "ns-resize",
                        right: "ew-resize",
                        topleft: "nwse-resize",
                        bottomright: "nwse-resize",
                        topright: "nesw-resize",
                        bottomleft: "nesw-resize"
                    };
                }(r), Pe.defaultMargin = r.supportsTouch || r.supportsPointerEvent ? 20 : 10, n.prototype.resizable = function(l) {
                    return function(c, p, h) {
                        return S.object(p) ? (c.options.resize.enabled = p.enabled !== !1, c.setPerAction("resize", p), c.setOnEvents("resize", p), S.string(p.axis) && /^x$|^y$|^xy$/.test(p.axis) ? c.options.resize.axis = p.axis : p.axis === null && (c.options.resize.axis = h.defaults.actions.resize.axis), S.bool(p.preserveAspectRatio) ? c.options.resize.preserveAspectRatio = p.preserveAspectRatio : S.bool(p.square) && (c.options.resize.square = p.square), c) : S.bool(p) ? (c.options.resize.enabled = p, c) : c.options.resize;
                    }(this, l, t1);
                }, e.map.resize = Pe, e.methodDict.resize = "resizable", o.actions.resize = Pe.defaults;
            },
            listeners: {
                "interactions:new": function(t1) {
                    t1.interaction.resizeAxes = "xy";
                },
                "interactions:action-start": function(t1) {
                    (function(e) {
                        var r = e.iEvent, n = e.interaction;
                        if (n.prepared.name === "resize" && n.prepared.edges) {
                            var o = r, l = n.rect;
                            n._rects = {
                                start: H({}, l),
                                corrected: H({}, l),
                                previous: H({}, l),
                                delta: {
                                    left: 0,
                                    right: 0,
                                    width: 0,
                                    top: 0,
                                    bottom: 0,
                                    height: 0
                                }
                            }, o.edges = n.prepared.edges, o.rect = n._rects.corrected, o.deltaRect = n._rects.delta;
                        }
                    })(t1), ln(t1);
                },
                "interactions:action-move": function(t1) {
                    (function(e) {
                        var r = e.iEvent, n = e.interaction;
                        if (n.prepared.name === "resize" && n.prepared.edges) {
                            var o = r, l = n.interactable.options.resize.invert, c = l === "reposition" || l === "negate", p = n.rect, h = n._rects, g = h.start, d = h.corrected, b = h.delta, w = h.previous;
                            if (H(w, d), c) {
                                if (H(d, p), l === "reposition") {
                                    if (d.top > d.bottom) {
                                        var I = d.top;
                                        d.top = d.bottom, d.bottom = I;
                                    }
                                    if (d.left > d.right) {
                                        var E = d.left;
                                        d.left = d.right, d.right = E;
                                    }
                                }
                            } else d.top = Math.min(p.top, g.bottom), d.bottom = Math.max(p.bottom, g.top), d.left = Math.min(p.left, g.right), d.right = Math.max(p.right, g.left);
                            for(var D in d.width = d.right - d.left, d.height = d.bottom - d.top, d)b[D] = d[D] - w[D];
                            o.edges = n.prepared.edges, o.rect = d, o.deltaRect = b;
                        }
                    })(t1), ln(t1);
                },
                "interactions:action-end": function(t1) {
                    var e = t1.iEvent, r = t1.interaction;
                    if (r.prepared.name === "resize" && r.prepared.edges) {
                        var n = e;
                        n.edges = r.prepared.edges, n.rect = r._rects.corrected, n.deltaRect = r._rects.delta;
                    }
                },
                "auto-start:check": function(t1) {
                    var e = t1.interaction, r = t1.interactable, n = t1.element, o = t1.rect, l = t1.buttons;
                    if (o) {
                        var c = H({}, e.coords.cur.page), p = r.options.resize;
                        if (p && p.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || l & p.mouseButtons)) {
                            if (S.object(p.edges)) {
                                var h = {
                                    left: !1,
                                    right: !1,
                                    top: !1,
                                    bottom: !1
                                };
                                for(var g in h)h[g] = po(g, p.edges[g], c, e._latestPointer.eventTarget, n, o, p.margin || Pe.defaultMargin);
                                h.left = h.left && !h.right, h.top = h.top && !h.bottom, (h.left || h.right || h.top || h.bottom) && (t1.action = {
                                    name: "resize",
                                    edges: h
                                });
                            } else {
                                var d = p.axis !== "y" && c.x > o.right - Pe.defaultMargin, b = p.axis !== "x" && c.y > o.bottom - Pe.defaultMargin;
                                (d || b) && (t1.action = {
                                    name: "resize",
                                    axes: (d ? "x" : "") + (b ? "y" : "")
                                });
                            }
                            return !t1.action && void 0;
                        }
                    }
                }
            },
            defaults: {
                square: !1,
                preserveAspectRatio: !1,
                axis: "xy",
                margin: NaN,
                edges: null,
                invert: "none"
            },
            cursors: null,
            getCursor: function(t1) {
                var e = t1.edges, r = t1.axis, n = t1.name, o = Pe.cursors, l = null;
                if (r) l = o[n + r];
                else if (e) {
                    for(var c = "", p = 0, h = [
                        "top",
                        "bottom",
                        "left",
                        "right"
                    ]; p < h.length; p++){
                        var g = h[p];
                        e[g] && (c += g);
                    }
                    l = o[c];
                }
                return l;
            },
            filterEventType: function(t1) {
                return t1.search("resize") === 0;
            },
            defaultMargin: null
        }, ho = Pe, fo = {
            id: "actions",
            install: function(t1) {
                t1.usePlugin(uo), t1.usePlugin(ho), t1.usePlugin(ne), t1.usePlugin(co);
            }
        }, cn = 0, je = {
            request: function(t1) {
                return Ie(t1);
            },
            cancel: function(t1) {
                return Ne(t1);
            },
            init: function(t1) {
                if (Ie = t1.requestAnimationFrame, Ne = t1.cancelAnimationFrame, !Ie) for(var e = [
                    "ms",
                    "moz",
                    "webkit",
                    "o"
                ], r = 0; r < e.length; r++){
                    var n = e[r];
                    Ie = t1["".concat(n, "RequestAnimationFrame")], Ne = t1["".concat(n, "CancelAnimationFrame")] || t1["".concat(n, "CancelRequestAnimationFrame")];
                }
                Ie = Ie && Ie.bind(t1), Ne = Ne && Ne.bind(t1), Ie || (Ie = function(o) {
                    var l = Date.now(), c = Math.max(0, 16 - (l - cn)), p = t1.setTimeout(function() {
                        o(l + c);
                    }, c);
                    return cn = l + c, p;
                }, Ne = function(o) {
                    return clearTimeout(o);
                });
            }
        }, V = {
            defaults: {
                enabled: !1,
                margin: 60,
                container: null,
                speed: 300
            },
            now: Date.now,
            interaction: null,
            i: 0,
            x: 0,
            y: 0,
            isScrolling: !1,
            prevTime: 0,
            margin: 0,
            speed: 0,
            start: function(t1) {
                V.isScrolling = !0, je.cancel(V.i), t1.autoScroll = V, V.interaction = t1, V.prevTime = V.now(), V.i = je.request(V.scroll);
            },
            stop: function() {
                V.isScrolling = !1, V.interaction && (V.interaction.autoScroll = null), je.cancel(V.i);
            },
            scroll: function() {
                var t1 = V.interaction, e = t1.interactable, r = t1.element, n = t1.prepared.name, o = e.options[n].autoScroll, l = un(o.container, e, r), c = V.now(), p = (c - V.prevTime) / 1e3, h = o.speed * p;
                if (h >= 1) {
                    var g = {
                        x: V.x * h,
                        y: V.y * h
                    };
                    if (g.x || g.y) {
                        var d = pn(l);
                        S.window(l) ? l.scrollBy(g.x, g.y) : l && (l.scrollLeft += g.x, l.scrollTop += g.y);
                        var b = pn(l), w = {
                            x: b.x - d.x,
                            y: b.y - d.y
                        };
                        (w.x || w.y) && e.fire({
                            type: "autoscroll",
                            target: r,
                            interactable: e,
                            delta: w,
                            interaction: t1,
                            container: l
                        });
                    }
                    V.prevTime = c;
                }
                V.isScrolling && (je.cancel(V.i), V.i = je.request(V.scroll));
            },
            check: function(t1, e) {
                var r;
                return (r = t1.options[e].autoScroll) == null ? void 0 : r.enabled;
            },
            onInteractionMove: function(t1) {
                var e = t1.interaction, r = t1.pointer;
                if (e.interacting() && V.check(e.interactable, e.prepared.name)) {
                    if (e.simulation) V.x = V.y = 0;
                    else {
                        var n, o, l, c, p = e.interactable, h = e.element, g = e.prepared.name, d = p.options[g].autoScroll, b = un(d.container, p, h);
                        if (S.window(b)) c = r.clientX < V.margin, n = r.clientY < V.margin, o = r.clientX > b.innerWidth - V.margin, l = r.clientY > b.innerHeight - V.margin;
                        else {
                            var w = ve(b);
                            c = r.clientX < w.left + V.margin, n = r.clientY < w.top + V.margin, o = r.clientX > w.right - V.margin, l = r.clientY > w.bottom - V.margin;
                        }
                        V.x = o ? 1 : c ? -1 : 0, V.y = l ? 1 : n ? -1 : 0, V.isScrolling || (V.margin = d.margin, V.speed = d.speed, V.start(e));
                    }
                }
            }
        };
        function un(t1, e, r) {
            return (S.string(t1) ? fe(t1, e, r) : t1) || te(r);
        }
        function pn(t1) {
            return S.window(t1) && (t1 = window.document.body), {
                x: t1.scrollLeft,
                y: t1.scrollTop
            };
        }
        var vo = {
            id: "auto-scroll",
            install: function(t1) {
                var e = t1.defaults, r = t1.actions;
                t1.autoScroll = V, V.now = function() {
                    return t1.now();
                }, r.phaselessTypes.autoscroll = !0, e.perAction.autoScroll = V.defaults;
            },
            listeners: {
                "interactions:new": function(t1) {
                    t1.interaction.autoScroll = null;
                },
                "interactions:destroy": function(t1) {
                    t1.interaction.autoScroll = null, V.stop(), V.interaction && (V.interaction = null);
                },
                "interactions:stop": V.stop,
                "interactions:action-move": function(t1) {
                    return V.onInteractionMove(t1);
                }
            }
        }, go = vo;
        function ct(t1, e) {
            var r = !1;
            return function() {
                return r || (G.console.warn(e), r = !0), t1.apply(this, arguments);
            };
        }
        function ar(t1, e) {
            return t1.name = e.name, t1.axis = e.axis, t1.edges = e.edges, t1;
        }
        function mo(t1) {
            return S.bool(t1) ? (this.options.styleCursor = t1, this) : t1 === null ? (delete this.options.styleCursor, this) : this.options.styleCursor;
        }
        function bo(t1) {
            return S.func(t1) ? (this.options.actionChecker = t1, this) : t1 === null ? (delete this.options.actionChecker, this) : this.options.actionChecker;
        }
        var yo = {
            id: "auto-start/interactableMethods",
            install: function(t1) {
                var e = t1.Interactable;
                e.prototype.getAction = function(r, n, o, l) {
                    var c = function(p, h, g, d, b) {
                        var w = p.getRect(d), I = h.buttons || ({
                            0: 1,
                            1: 4,
                            3: 8,
                            4: 16
                        })[h.button], E = {
                            action: null,
                            interactable: p,
                            interaction: g,
                            element: d,
                            rect: w,
                            buttons: I
                        };
                        return b.fire("auto-start:check", E), E.action;
                    }(this, n, o, l, t1);
                    return this.options.actionChecker ? this.options.actionChecker(r, n, c, this, l, o) : c;
                }, e.prototype.ignoreFrom = ct(function(r) {
                    return this._backCompatOption("ignoreFrom", r);
                }, "Interactable.ignoreFrom() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue})."), e.prototype.allowFrom = ct(function(r) {
                    return this._backCompatOption("allowFrom", r);
                }, "Interactable.allowFrom() has been deprecated. Use Interactble.draggable({allowFrom: newValue})."), e.prototype.actionChecker = bo, e.prototype.styleCursor = mo;
            }
        };
        function hn(t1, e, r, n, o) {
            return e.testIgnoreAllow(e.options[t1.name], r, n) && e.options[t1.name].enabled && St(e, r, t1, o) ? t1 : null;
        }
        function To(t1, e, r, n, o, l, c) {
            for(var p = 0, h = n.length; p < h; p++){
                var g = n[p], d = o[p], b = g.getAction(e, r, t1, d);
                if (b) {
                    var w = hn(b, g, d, l, c);
                    if (w) return {
                        action: w,
                        interactable: g,
                        element: d
                    };
                }
            }
            return {
                action: null,
                interactable: null,
                element: null
            };
        }
        function dn(t1, e, r, n, o) {
            var l = [], c = [], p = n;
            function h(d) {
                l.push(d), c.push(p);
            }
            for(; S.element(p);){
                l = [], c = [], o.interactables.forEachMatch(p, h);
                var g = To(t1, e, r, l, c, n, o);
                if (g.action && !g.interactable.options[g.action.name].manualStart) return g;
                p = K(p);
            }
            return {
                action: null,
                interactable: null,
                element: null
            };
        }
        function fn(t1, e, r) {
            var n = e.action, o = e.interactable, l = e.element;
            n = n || {
                name: null
            }, t1.interactable = o, t1.element = l, ar(t1.prepared, n), t1.rect = o && n.name ? o.getRect(l) : null, gn(t1, r), r.fire("autoStart:prepared", {
                interaction: t1
            });
        }
        function St(t1, e, r, n) {
            var o = t1.options, l = o[r.name].max, c = o[r.name].maxPerElement, p = n.autoStart.maxInteractions, h = 0, g = 0, d = 0;
            if (!(l && c && p)) return !1;
            for(var b = 0, w = n.interactions.list; b < w.length; b++){
                var I = w[b], E = I.prepared.name;
                if (I.interacting() && (++h >= p || I.interactable === t1 && ((g += E === r.name ? 1 : 0) >= l || I.element === e && (d++, E === r.name && d >= c)))) return !1;
            }
            return p > 0;
        }
        function vn(t1, e) {
            return S.number(t1) ? (e.autoStart.maxInteractions = t1, this) : e.autoStart.maxInteractions;
        }
        function lr(t1, e, r) {
            var n = r.autoStart.cursorElement;
            n && n !== t1 && (n.style.cursor = ""), t1.ownerDocument.documentElement.style.cursor = e, t1.style.cursor = e, r.autoStart.cursorElement = e ? t1 : null;
        }
        function gn(t1, e) {
            var r = t1.interactable, n = t1.element, o = t1.prepared;
            if (t1.pointerType === "mouse" && r && r.options.styleCursor) {
                var l = "";
                if (o.name) {
                    var c = r.options[o.name].cursorChecker;
                    l = S.func(c) ? c(o, r, n, t1._interacting) : e.actions.map[o.name].getCursor(o);
                }
                lr(t1.element, l || "", e);
            } else e.autoStart.cursorElement && lr(e.autoStart.cursorElement, "", e);
        }
        var wo = {
            id: "auto-start/base",
            before: [
                "actions"
            ],
            install: function(t1) {
                var e = t1.interactStatic, r = t1.defaults;
                t1.usePlugin(yo), r.base.actionChecker = null, r.base.styleCursor = !0, H(r.perAction, {
                    manualStart: !1,
                    max: 1 / 0,
                    maxPerElement: 1,
                    allowFrom: null,
                    ignoreFrom: null,
                    mouseButtons: 1
                }), e.maxInteractions = function(n) {
                    return vn(n, t1);
                }, t1.autoStart = {
                    maxInteractions: 1 / 0,
                    withinInteractionLimit: St,
                    cursorElement: null
                };
            },
            listeners: {
                "interactions:down": function(t1, e) {
                    var r = t1.interaction, n = t1.pointer, o = t1.event, l = t1.eventTarget;
                    r.interacting() || fn(r, dn(r, n, o, l, e), e);
                },
                "interactions:move": function(t1, e) {
                    (function(r, n) {
                        var o = r.interaction, l = r.pointer, c = r.event, p = r.eventTarget;
                        o.pointerType !== "mouse" || o.pointerIsDown || o.interacting() || fn(o, dn(o, l, c, p, n), n);
                    })(t1, e), function(r, n) {
                        var o = r.interaction;
                        if (o.pointerIsDown && !o.interacting() && o.pointerWasMoved && o.prepared.name) {
                            n.fire("autoStart:before-start", r);
                            var l = o.interactable, c = o.prepared.name;
                            c && l && (l.options[c].manualStart || !St(l, o.element, o.prepared, n) ? o.stop() : (o.start(o.prepared, l, o.element), gn(o, n)));
                        }
                    }(t1, e);
                },
                "interactions:stop": function(t1, e) {
                    var r = t1.interaction, n = r.interactable;
                    n && n.options.styleCursor && lr(r.element, "", e);
                }
            },
            maxInteractions: vn,
            withinInteractionLimit: St,
            validateAction: hn
        }, cr = wo, So = {
            id: "auto-start/dragAxis",
            listeners: {
                "autoStart:before-start": function(t1, e) {
                    var r = t1.interaction, n = t1.eventTarget, o = t1.dx, l = t1.dy;
                    if (r.prepared.name === "drag") {
                        var c = Math.abs(o), p = Math.abs(l), h = r.interactable.options.drag, g = h.startAxis, d = c > p ? "x" : c < p ? "y" : "xy";
                        if (r.prepared.axis = h.lockAxis === "start" ? d[0] : h.lockAxis, d !== "xy" && g !== "xy" && g !== d) {
                            r.prepared.name = null;
                            for(var b = n, w = function(E) {
                                if (E !== r.interactable) {
                                    var D = r.interactable.options.drag;
                                    if (!D.manualStart && E.testIgnoreAllow(D, b, n)) {
                                        var L = E.getAction(r.downPointer, r.downEvent, r, b);
                                        if (L && L.name === "drag" && function(j, Y) {
                                            if (!Y) return !1;
                                            var q = Y.options.drag.startAxis;
                                            return j === "xy" || q === "xy" || q === j;
                                        }(d, E) && cr.validateAction(L, E, b, n, e)) return E;
                                    }
                                }
                            }; S.element(b);){
                                var I = e.interactables.forEachMatch(b, w);
                                if (I) {
                                    r.prepared.name = "drag", r.interactable = I, r.element = b;
                                    break;
                                }
                                b = K(b);
                            }
                        }
                    }
                }
            }
        };
        function ur(t1) {
            var e = t1.prepared && t1.prepared.name;
            if (!e) return null;
            var r = t1.interactable.options;
            return r[e].hold || r[e].delay;
        }
        var xo = {
            id: "auto-start/hold",
            install: function(t1) {
                var e = t1.defaults;
                t1.usePlugin(cr), e.perAction.hold = 0, e.perAction.delay = 0;
            },
            listeners: {
                "interactions:new": function(t1) {
                    t1.interaction.autoStartHoldTimer = null;
                },
                "autoStart:prepared": function(t1) {
                    var e = t1.interaction, r = ur(e);
                    r > 0 && (e.autoStartHoldTimer = setTimeout(function() {
                        e.start(e.prepared, e.interactable, e.element);
                    }, r));
                },
                "interactions:move": function(t1) {
                    var e = t1.interaction, r = t1.duplicate;
                    e.autoStartHoldTimer && e.pointerWasMoved && !r && (clearTimeout(e.autoStartHoldTimer), e.autoStartHoldTimer = null);
                },
                "autoStart:before-start": function(t1) {
                    var e = t1.interaction;
                    ur(e) > 0 && (e.prepared.name = null);
                }
            },
            getHoldDuration: ur
        }, Oo = xo, Co = {
            id: "auto-start",
            install: function(t1) {
                t1.usePlugin(cr), t1.usePlugin(Oo), t1.usePlugin(So);
            }
        }, _o = function(t1) {
            return /^(always|never|auto)$/.test(t1) ? (this.options.preventDefault = t1, this) : S.bool(t1) ? (this.options.preventDefault = t1 ? "always" : "never", this) : this.options.preventDefault;
        };
        function Mo(t1) {
            var e = t1.interaction, r = t1.event;
            e.interactable && e.interactable.checkAndPreventDefault(r);
        }
        var mn = {
            id: "core/interactablePreventDefault",
            install: function(t1) {
                var e = t1.Interactable;
                e.prototype.preventDefault = _o, e.prototype.checkAndPreventDefault = function(r) {
                    return function(n, o, l) {
                        var c = n.options.preventDefault;
                        if (c !== "never") {
                            if (c !== "always") {
                                if (o.events.supportsPassive && /^touch(start|move)$/.test(l.type)) {
                                    var p = te(l.target).document, h = o.getDocOptions(p);
                                    if (!h || !h.events || h.events.passive !== !1) return;
                                }
                                /^(mouse|pointer|touch)*(down|start)/i.test(l.type) || S.element(l.target) && X(l.target, "input,select,textarea,[contenteditable=true],[contenteditable=true] *") || l.preventDefault();
                            } else l.preventDefault();
                        }
                    }(this, t1, r);
                }, t1.interactions.docEvents.push({
                    type: "dragstart",
                    listener: function(r) {
                        for(var n = 0, o = t1.interactions.list; n < o.length; n++){
                            var l = o[n];
                            if (l.element && (l.element === r.target || F(l.element, r.target))) return void l.interactable.checkAndPreventDefault(r);
                        }
                    }
                });
            },
            listeners: [
                "down",
                "move",
                "up",
                "cancel"
            ].reduce(function(t1, e) {
                return t1["interactions:".concat(e)] = Mo, t1;
            }, {})
        };
        function xt(t1, e) {
            if (e.phaselessTypes[t1]) return !0;
            for(var r in e.map)if (t1.indexOf(r) === 0 && t1.substr(r.length) in e.phases) return !0;
            return !1;
        }
        function Be(t1) {
            var e = {};
            for(var r in t1){
                var n = t1[r];
                S.plainObject(n) ? e[r] = Be(n) : S.array(n) ? e[r] = rn(n) : e[r] = n;
            }
            return e;
        }
        var pr = function() {
            function t1(e) {
                v(this, t1), this.states = [], this.startOffset = {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }, this.startDelta = void 0, this.result = void 0, this.endResult = void 0, this.startEdges = void 0, this.edges = void 0, this.interaction = void 0, this.interaction = e, this.result = Ot(), this.edges = {
                    left: !1,
                    right: !1,
                    top: !1,
                    bottom: !1
                };
            }
            return y(t1, [
                {
                    key: "start",
                    value: function(e, r) {
                        var n, o, l = e.phase, c = this.interaction, p = function(g) {
                            var d = g.interactable.options[g.prepared.name], b = d.modifiers;
                            return b && b.length ? b : [
                                "snap",
                                "snapSize",
                                "snapEdges",
                                "restrict",
                                "restrictEdges",
                                "restrictSize"
                            ].map(function(w) {
                                var I = d[w];
                                return I && I.enabled && {
                                    options: I,
                                    methods: I._methods
                                };
                            }).filter(function(w) {
                                return !!w;
                            });
                        }(c);
                        this.prepareStates(p), this.startEdges = H({}, c.edges), this.edges = H({}, this.startEdges), this.startOffset = (n = c.rect, o = r, n ? {
                            left: o.x - n.left,
                            top: o.y - n.top,
                            right: n.right - o.x,
                            bottom: n.bottom - o.y
                        } : {
                            left: 0,
                            top: 0,
                            right: 0,
                            bottom: 0
                        }), this.startDelta = {
                            x: 0,
                            y: 0
                        };
                        var h = this.fillArg({
                            phase: l,
                            pageCoords: r,
                            preEnd: !1
                        });
                        return this.result = Ot(), this.startAll(h), this.result = this.setAll(h);
                    }
                },
                {
                    key: "fillArg",
                    value: function(e) {
                        var r = this.interaction;
                        return e.interaction = r, e.interactable = r.interactable, e.element = r.element, e.rect || (e.rect = r.rect), e.edges || (e.edges = this.startEdges), e.startOffset = this.startOffset, e;
                    }
                },
                {
                    key: "startAll",
                    value: function(e) {
                        for(var r = 0, n = this.states; r < n.length; r++){
                            var o = n[r];
                            o.methods.start && (e.state = o, o.methods.start(e));
                        }
                    }
                },
                {
                    key: "setAll",
                    value: function(e) {
                        var r = e.phase, n = e.preEnd, o = e.skipModifiers, l = e.rect, c = e.edges;
                        e.coords = H({}, e.pageCoords), e.rect = H({}, l), e.edges = H({}, c);
                        for(var p = o ? this.states.slice(o) : this.states, h = Ot(e.coords, e.rect), g = 0; g < p.length; g++){
                            var d, b = p[g], w = b.options, I = H({}, e.coords), E = null;
                            (d = b.methods) != null && d.set && this.shouldDo(w, n, r) && (e.state = b, E = b.methods.set(e), mt(e.edges, e.rect, {
                                x: e.coords.x - I.x,
                                y: e.coords.y - I.y
                            })), h.eventProps.push(E);
                        }
                        H(this.edges, e.edges), h.delta.x = e.coords.x - e.pageCoords.x, h.delta.y = e.coords.y - e.pageCoords.y, h.rectDelta.left = e.rect.left - l.left, h.rectDelta.right = e.rect.right - l.right, h.rectDelta.top = e.rect.top - l.top, h.rectDelta.bottom = e.rect.bottom - l.bottom;
                        var D = this.result.coords, L = this.result.rect;
                        if (D && L) {
                            var j = h.rect.left !== L.left || h.rect.right !== L.right || h.rect.top !== L.top || h.rect.bottom !== L.bottom;
                            h.changed = j || D.x !== h.coords.x || D.y !== h.coords.y;
                        }
                        return h;
                    }
                },
                {
                    key: "applyToInteraction",
                    value: function(e) {
                        var r = this.interaction, n = e.phase, o = r.coords.cur, l = r.coords.start, c = this.result, p = this.startDelta, h = c.delta;
                        n === "start" && H(this.startDelta, c.delta);
                        for(var g = 0, d = [
                            [
                                l,
                                p
                            ],
                            [
                                o,
                                h
                            ]
                        ]; g < d.length; g++){
                            var b = d[g], w = b[0], I = b[1];
                            w.page.x += I.x, w.page.y += I.y, w.client.x += I.x, w.client.y += I.y;
                        }
                        var E = this.result.rectDelta, D = e.rect || r.rect;
                        D.left += E.left, D.right += E.right, D.top += E.top, D.bottom += E.bottom, D.width = D.right - D.left, D.height = D.bottom - D.top;
                    }
                },
                {
                    key: "setAndApply",
                    value: function(e) {
                        var r = this.interaction, n = e.phase, o = e.preEnd, l = e.skipModifiers, c = this.setAll(this.fillArg({
                            preEnd: o,
                            phase: n,
                            pageCoords: e.modifiedCoords || r.coords.cur.page
                        }));
                        if (this.result = c, !c.changed && (!l || l < this.states.length) && r.interacting()) return !1;
                        if (e.modifiedCoords) {
                            var p = r.coords.cur.page, h = {
                                x: e.modifiedCoords.x - p.x,
                                y: e.modifiedCoords.y - p.y
                            };
                            c.coords.x += h.x, c.coords.y += h.y, c.delta.x += h.x, c.delta.y += h.y;
                        }
                        this.applyToInteraction(e);
                    }
                },
                {
                    key: "beforeEnd",
                    value: function(e) {
                        var r = e.interaction, n = e.event, o = this.states;
                        if (o && o.length) {
                            for(var l = !1, c = 0; c < o.length; c++){
                                var p = o[c];
                                e.state = p;
                                var h = p.options, g = p.methods, d = g.beforeEnd && g.beforeEnd(e);
                                if (d) return this.endResult = d, !1;
                                l = l || !l && this.shouldDo(h, !0, e.phase, !0);
                            }
                            l && r.move({
                                event: n,
                                preEnd: !0
                            });
                        }
                    }
                },
                {
                    key: "stop",
                    value: function(e) {
                        var r = e.interaction;
                        if (this.states && this.states.length) {
                            var n = H({
                                states: this.states,
                                interactable: r.interactable,
                                element: r.element,
                                rect: null
                            }, e);
                            this.fillArg(n);
                            for(var o = 0, l = this.states; o < l.length; o++){
                                var c = l[o];
                                n.state = c, c.methods.stop && c.methods.stop(n);
                            }
                            this.states = null, this.endResult = null;
                        }
                    }
                },
                {
                    key: "prepareStates",
                    value: function(e) {
                        this.states = [];
                        for(var r = 0; r < e.length; r++){
                            var n = e[r], o = n.options, l = n.methods, c = n.name;
                            this.states.push({
                                options: o,
                                methods: l,
                                index: r,
                                name: c
                            });
                        }
                        return this.states;
                    }
                },
                {
                    key: "restoreInteractionCoords",
                    value: function(e) {
                        var r = e.interaction, n = r.coords, o = r.rect, l = r.modification;
                        if (l.result) {
                            for(var c = l.startDelta, p = l.result, h = p.delta, g = p.rectDelta, d = 0, b = [
                                [
                                    n.start,
                                    c
                                ],
                                [
                                    n.cur,
                                    h
                                ]
                            ]; d < b.length; d++){
                                var w = b[d], I = w[0], E = w[1];
                                I.page.x -= E.x, I.page.y -= E.y, I.client.x -= E.x, I.client.y -= E.y;
                            }
                            o.left -= g.left, o.right -= g.right, o.top -= g.top, o.bottom -= g.bottom;
                        }
                    }
                },
                {
                    key: "shouldDo",
                    value: function(e, r, n, o) {
                        return !(!e || e.enabled === !1 || o && !e.endOnly || e.endOnly && !r || n === "start" && !e.setStart);
                    }
                },
                {
                    key: "copyFrom",
                    value: function(e) {
                        this.startOffset = e.startOffset, this.startDelta = e.startDelta, this.startEdges = e.startEdges, this.edges = e.edges, this.states = e.states.map(function(r) {
                            return Be(r);
                        }), this.result = Ot(H({}, e.result.coords), H({}, e.result.rect));
                    }
                },
                {
                    key: "destroy",
                    value: function() {
                        for(var e in this)this[e] = null;
                    }
                }
            ]), t1;
        }();
        function Ot(t1, e) {
            return {
                rect: e,
                coords: t1,
                delta: {
                    x: 0,
                    y: 0
                },
                rectDelta: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                eventProps: [],
                changed: !0
            };
        }
        function Ae(t1, e) {
            var r = t1.defaults, n = {
                start: t1.start,
                set: t1.set,
                beforeEnd: t1.beforeEnd,
                stop: t1.stop
            }, o = function(l) {
                var c = l || {};
                for(var p in c.enabled = c.enabled !== !1, r)p in c || (c[p] = r[p]);
                var h = {
                    options: c,
                    methods: n,
                    name: e,
                    enable: function() {
                        return c.enabled = !0, h;
                    },
                    disable: function() {
                        return c.enabled = !1, h;
                    }
                };
                return h;
            };
            return e && typeof e == "string" && (o._defaults = r, o._methods = n), o;
        }
        function ut(t1) {
            var e = t1.iEvent, r = t1.interaction.modification.result;
            r && (e.modifiers = r.eventProps);
        }
        var Eo = {
            id: "modifiers/base",
            before: [
                "actions"
            ],
            install: function(t1) {
                t1.defaults.perAction.modifiers = [];
            },
            listeners: {
                "interactions:new": function(t1) {
                    var e = t1.interaction;
                    e.modification = new pr(e);
                },
                "interactions:before-action-start": function(t1) {
                    var e = t1.interaction, r = t1.interaction.modification;
                    r.start(t1, e.coords.start.page), e.edges = r.edges, r.applyToInteraction(t1);
                },
                "interactions:before-action-move": function(t1) {
                    var e = t1.interaction, r = e.modification, n = r.setAndApply(t1);
                    return e.edges = r.edges, n;
                },
                "interactions:before-action-end": function(t1) {
                    var e = t1.interaction, r = e.modification, n = r.beforeEnd(t1);
                    return e.edges = r.startEdges, n;
                },
                "interactions:action-start": ut,
                "interactions:action-move": ut,
                "interactions:action-end": ut,
                "interactions:after-action-start": function(t1) {
                    return t1.interaction.modification.restoreInteractionCoords(t1);
                },
                "interactions:after-action-move": function(t1) {
                    return t1.interaction.modification.restoreInteractionCoords(t1);
                },
                "interactions:stop": function(t1) {
                    return t1.interaction.modification.stop(t1);
                }
            }
        }, bn = Eo, yn = {
            base: {
                preventDefault: "auto",
                deltaSource: "page"
            },
            perAction: {
                enabled: !1,
                origin: {
                    x: 0,
                    y: 0
                }
            },
            actions: {}
        }, hr = function(t1) {
            O(r, t1);
            var e = _(r);
            function r(n, o, l, c, p, h, g) {
                var d;
                v(this, r), (d = e.call(this, n)).relatedTarget = null, d.screenX = void 0, d.screenY = void 0, d.button = void 0, d.buttons = void 0, d.ctrlKey = void 0, d.shiftKey = void 0, d.altKey = void 0, d.metaKey = void 0, d.page = void 0, d.client = void 0, d.delta = void 0, d.rect = void 0, d.x0 = void 0, d.y0 = void 0, d.t0 = void 0, d.dt = void 0, d.duration = void 0, d.clientX0 = void 0, d.clientY0 = void 0, d.velocity = void 0, d.speed = void 0, d.swipe = void 0, d.axes = void 0, d.preEnd = void 0, p = p || n.element;
                var b = n.interactable, w = (b && b.options || yn).deltaSource, I = it(b, p, l), E = c === "start", D = c === "end", L = E ? T(d) : n.prevEvent, j = E ? n.coords.start : D ? {
                    page: L.page,
                    client: L.client,
                    timeStamp: n.coords.cur.timeStamp
                } : n.coords.cur;
                return d.page = H({}, j.page), d.client = H({}, j.client), d.rect = H({}, n.rect), d.timeStamp = j.timeStamp, D || (d.page.x -= I.x, d.page.y -= I.y, d.client.x -= I.x, d.client.y -= I.y), d.ctrlKey = o.ctrlKey, d.altKey = o.altKey, d.shiftKey = o.shiftKey, d.metaKey = o.metaKey, d.button = o.button, d.buttons = o.buttons, d.target = p, d.currentTarget = p, d.preEnd = h, d.type = g || l + (c || ""), d.interactable = b, d.t0 = E ? n.pointers[n.pointers.length - 1].downTime : L.t0, d.x0 = n.coords.start.page.x - I.x, d.y0 = n.coords.start.page.y - I.y, d.clientX0 = n.coords.start.client.x - I.x, d.clientY0 = n.coords.start.client.y - I.y, d.delta = E || D ? {
                    x: 0,
                    y: 0
                } : {
                    x: d[w].x - L[w].x,
                    y: d[w].y - L[w].y
                }, d.dt = n.coords.delta.timeStamp, d.duration = d.timeStamp - d.t0, d.velocity = H({}, n.coords.velocity[w]), d.speed = ot(d.velocity.x, d.velocity.y), d.swipe = D || c === "inertiastart" ? d.getSwipe() : null, d;
            }
            return y(r, [
                {
                    key: "getSwipe",
                    value: function() {
                        var n = this._interaction;
                        if (n.prevEvent.speed < 600 || this.timeStamp - n.prevEvent.timeStamp > 150) return null;
                        var o = 180 * Math.atan2(n.prevEvent.velocityY, n.prevEvent.velocityX) / Math.PI;
                        o < 0 && (o += 360);
                        var l = 112.5 <= o && o < 247.5, c = 202.5 <= o && o < 337.5;
                        return {
                            up: c,
                            down: !c && 22.5 <= o && o < 157.5,
                            left: l,
                            right: !l && (292.5 <= o || o < 67.5),
                            angle: o,
                            speed: n.prevEvent.speed,
                            velocity: {
                                x: n.prevEvent.velocityX,
                                y: n.prevEvent.velocityY
                            }
                        };
                    }
                },
                {
                    key: "preventDefault",
                    value: function() {}
                },
                {
                    key: "stopImmediatePropagation",
                    value: function() {
                        this.immediatePropagationStopped = this.propagationStopped = !0;
                    }
                },
                {
                    key: "stopPropagation",
                    value: function() {
                        this.propagationStopped = !0;
                    }
                }
            ]), r;
        }(wt);
        Object.defineProperties(hr.prototype, {
            pageX: {
                get: function() {
                    return this.page.x;
                },
                set: function(t1) {
                    this.page.x = t1;
                }
            },
            pageY: {
                get: function() {
                    return this.page.y;
                },
                set: function(t1) {
                    this.page.y = t1;
                }
            },
            clientX: {
                get: function() {
                    return this.client.x;
                },
                set: function(t1) {
                    this.client.x = t1;
                }
            },
            clientY: {
                get: function() {
                    return this.client.y;
                },
                set: function(t1) {
                    this.client.y = t1;
                }
            },
            dx: {
                get: function() {
                    return this.delta.x;
                },
                set: function(t1) {
                    this.delta.x = t1;
                }
            },
            dy: {
                get: function() {
                    return this.delta.y;
                },
                set: function(t1) {
                    this.delta.y = t1;
                }
            },
            velocityX: {
                get: function() {
                    return this.velocity.x;
                },
                set: function(t1) {
                    this.velocity.x = t1;
                }
            },
            velocityY: {
                get: function() {
                    return this.velocity.y;
                },
                set: function(t1) {
                    this.velocity.y = t1;
                }
            }
        });
        var Io = y(function t1(e, r, n, o, l) {
            v(this, t1), this.id = void 0, this.pointer = void 0, this.event = void 0, this.downTime = void 0, this.downTarget = void 0, this.id = e, this.pointer = r, this.event = n, this.downTime = o, this.downTarget = l;
        }), Po = function(t1) {
            return t1.interactable = "", t1.element = "", t1.prepared = "", t1.pointerIsDown = "", t1.pointerWasMoved = "", t1._proxy = "", t1;
        }({}), Tn = function(t1) {
            return t1.start = "", t1.move = "", t1.end = "", t1.stop = "", t1.interacting = "", t1;
        }({}), Do = 0, Ro = function() {
            function t1(e) {
                var r = this, n = e.pointerType, o = e.scopeFire;
                v(this, t1), this.interactable = null, this.element = null, this.rect = null, this._rects = void 0, this.edges = null, this._scopeFire = void 0, this.prepared = {
                    name: null,
                    axis: null,
                    edges: null
                }, this.pointerType = void 0, this.pointers = [], this.downEvent = null, this.downPointer = {}, this._latestPointer = {
                    pointer: null,
                    event: null,
                    eventTarget: null
                }, this.prevEvent = null, this.pointerIsDown = !1, this.pointerWasMoved = !1, this._interacting = !1, this._ending = !1, this._stopped = !0, this._proxy = void 0, this.simulation = null, this.doMove = ct(function(d) {
                    this.move(d);
                }, "The interaction.doMove() method has been renamed to interaction.move()"), this.coords = {
                    start: {
                        page: {
                            x: 0,
                            y: 0
                        },
                        client: {
                            x: 0,
                            y: 0
                        },
                        timeStamp: 0
                    },
                    prev: {
                        page: {
                            x: 0,
                            y: 0
                        },
                        client: {
                            x: 0,
                            y: 0
                        },
                        timeStamp: 0
                    },
                    cur: {
                        page: {
                            x: 0,
                            y: 0
                        },
                        client: {
                            x: 0,
                            y: 0
                        },
                        timeStamp: 0
                    },
                    delta: {
                        page: {
                            x: 0,
                            y: 0
                        },
                        client: {
                            x: 0,
                            y: 0
                        },
                        timeStamp: 0
                    },
                    velocity: {
                        page: {
                            x: 0,
                            y: 0
                        },
                        client: {
                            x: 0,
                            y: 0
                        },
                        timeStamp: 0
                    }
                }, this._id = Do++, this._scopeFire = o, this.pointerType = n;
                var l = this;
                this._proxy = {};
                var c = function(d) {
                    Object.defineProperty(r._proxy, d, {
                        get: function() {
                            return l[d];
                        }
                    });
                };
                for(var p in Po)c(p);
                var h = function(d) {
                    Object.defineProperty(r._proxy, d, {
                        value: function() {
                            return l[d].apply(l, arguments);
                        }
                    });
                };
                for(var g in Tn)h(g);
                this._scopeFire("interactions:new", {
                    interaction: this
                });
            }
            return y(t1, [
                {
                    key: "pointerMoveTolerance",
                    get: function() {
                        return 1;
                    }
                },
                {
                    key: "pointerDown",
                    value: function(e, r, n) {
                        var o = this.updatePointer(e, r, n, !0), l = this.pointers[o];
                        this._scopeFire("interactions:down", {
                            pointer: e,
                            event: r,
                            eventTarget: n,
                            pointerIndex: o,
                            pointerInfo: l,
                            type: "down",
                            interaction: this
                        });
                    }
                },
                {
                    key: "start",
                    value: function(e, r, n) {
                        return !(this.interacting() || !this.pointerIsDown || this.pointers.length < (e.name === "gesture" ? 2 : 1) || !r.options[e.name].enabled) && (ar(this.prepared, e), this.interactable = r, this.element = n, this.rect = r.getRect(n), this.edges = this.prepared.edges ? H({}, this.prepared.edges) : {
                            left: !0,
                            right: !0,
                            top: !0,
                            bottom: !0
                        }, this._stopped = !1, this._interacting = this._doPhase({
                            interaction: this,
                            event: this.downEvent,
                            phase: "start"
                        }) && !this._stopped, this._interacting);
                    }
                },
                {
                    key: "pointerMove",
                    value: function(e, r, n) {
                        this.simulation || this.modification && this.modification.endResult || this.updatePointer(e, r, n, !1);
                        var o, l, c = this.coords.cur.page.x === this.coords.prev.page.x && this.coords.cur.page.y === this.coords.prev.page.y && this.coords.cur.client.x === this.coords.prev.client.x && this.coords.cur.client.y === this.coords.prev.client.y;
                        this.pointerIsDown && !this.pointerWasMoved && (o = this.coords.cur.client.x - this.coords.start.client.x, l = this.coords.cur.client.y - this.coords.start.client.y, this.pointerWasMoved = ot(o, l) > this.pointerMoveTolerance);
                        var p, h, g, d = this.getPointerIndex(e), b = {
                            pointer: e,
                            pointerIndex: d,
                            pointerInfo: this.pointers[d],
                            event: r,
                            type: "move",
                            eventTarget: n,
                            dx: o,
                            dy: l,
                            duplicate: c,
                            interaction: this
                        };
                        c || (p = this.coords.velocity, h = this.coords.delta, g = Math.max(h.timeStamp / 1e3, 1e-3), p.page.x = h.page.x / g, p.page.y = h.page.y / g, p.client.x = h.client.x / g, p.client.y = h.client.y / g, p.timeStamp = g), this._scopeFire("interactions:move", b), c || this.simulation || (this.interacting() && (b.type = null, this.move(b)), this.pointerWasMoved && yt(this.coords.prev, this.coords.cur));
                    }
                },
                {
                    key: "move",
                    value: function(e) {
                        e && e.event || Vr(this.coords.delta), (e = H({
                            pointer: this._latestPointer.pointer,
                            event: this._latestPointer.event,
                            eventTarget: this._latestPointer.eventTarget,
                            interaction: this
                        }, e || {})).phase = "move", this._doPhase(e);
                    }
                },
                {
                    key: "pointerUp",
                    value: function(e, r, n, o) {
                        var l = this.getPointerIndex(e);
                        l === -1 && (l = this.updatePointer(e, r, n, !1));
                        var c = /cancel$/i.test(r.type) ? "cancel" : "up";
                        this._scopeFire("interactions:".concat(c), {
                            pointer: e,
                            pointerIndex: l,
                            pointerInfo: this.pointers[l],
                            event: r,
                            eventTarget: n,
                            type: c,
                            curEventTarget: o,
                            interaction: this
                        }), this.simulation || this.end(r), this.removePointer(e, r);
                    }
                },
                {
                    key: "documentBlur",
                    value: function(e) {
                        this.end(e), this._scopeFire("interactions:blur", {
                            event: e,
                            type: "blur",
                            interaction: this
                        });
                    }
                },
                {
                    key: "end",
                    value: function(e) {
                        var r;
                        this._ending = !0, e = e || this._latestPointer.event, this.interacting() && (r = this._doPhase({
                            event: e,
                            interaction: this,
                            phase: "end"
                        })), this._ending = !1, r === !0 && this.stop();
                    }
                },
                {
                    key: "currentAction",
                    value: function() {
                        return this._interacting ? this.prepared.name : null;
                    }
                },
                {
                    key: "interacting",
                    value: function() {
                        return this._interacting;
                    }
                },
                {
                    key: "stop",
                    value: function() {
                        this._scopeFire("interactions:stop", {
                            interaction: this
                        }), this.interactable = this.element = null, this._interacting = !1, this._stopped = !0, this.prepared.name = this.prevEvent = null;
                    }
                },
                {
                    key: "getPointerIndex",
                    value: function(e) {
                        var r = st(e);
                        return this.pointerType === "mouse" || this.pointerType === "pen" ? this.pointers.length - 1 : at(this.pointers, function(n) {
                            return n.id === r;
                        });
                    }
                },
                {
                    key: "getPointerInfo",
                    value: function(e) {
                        return this.pointers[this.getPointerIndex(e)];
                    }
                },
                {
                    key: "updatePointer",
                    value: function(e, r, n, o) {
                        var l, c, p, h = st(e), g = this.getPointerIndex(e), d = this.pointers[g];
                        return o = o !== !1 && (o || /(down|start)$/i.test(r.type)), d ? d.pointer = e : (d = new Io(h, e, r, null, null), g = this.pointers.length, this.pointers.push(d)), lo(this.coords.cur, this.pointers.map(function(b) {
                            return b.pointer;
                        }), this._now()), l = this.coords.delta, c = this.coords.prev, p = this.coords.cur, l.page.x = p.page.x - c.page.x, l.page.y = p.page.y - c.page.y, l.client.x = p.client.x - c.client.x, l.client.y = p.client.y - c.client.y, l.timeStamp = p.timeStamp - c.timeStamp, o && (this.pointerIsDown = !0, d.downTime = this.coords.cur.timeStamp, d.downTarget = n, bt(this.downPointer, e), this.interacting() || (yt(this.coords.start, this.coords.cur), yt(this.coords.prev, this.coords.cur), this.downEvent = r, this.pointerWasMoved = !1)), this._updateLatestPointer(e, r, n), this._scopeFire("interactions:update-pointer", {
                            pointer: e,
                            event: r,
                            eventTarget: n,
                            down: o,
                            pointerInfo: d,
                            pointerIndex: g,
                            interaction: this
                        }), g;
                    }
                },
                {
                    key: "removePointer",
                    value: function(e, r) {
                        var n = this.getPointerIndex(e);
                        if (n !== -1) {
                            var o = this.pointers[n];
                            this._scopeFire("interactions:remove-pointer", {
                                pointer: e,
                                event: r,
                                eventTarget: null,
                                pointerIndex: n,
                                pointerInfo: o,
                                interaction: this
                            }), this.pointers.splice(n, 1), this.pointerIsDown = !1;
                        }
                    }
                },
                {
                    key: "_updateLatestPointer",
                    value: function(e, r, n) {
                        this._latestPointer.pointer = e, this._latestPointer.event = r, this._latestPointer.eventTarget = n;
                    }
                },
                {
                    key: "destroy",
                    value: function() {
                        this._latestPointer.pointer = null, this._latestPointer.event = null, this._latestPointer.eventTarget = null;
                    }
                },
                {
                    key: "_createPreparedEvent",
                    value: function(e, r, n, o) {
                        return new hr(this, e, this.prepared.name, r, this.element, n, o);
                    }
                },
                {
                    key: "_fireEvent",
                    value: function(e) {
                        var r;
                        (r = this.interactable) == null || r.fire(e), (!this.prevEvent || e.timeStamp >= this.prevEvent.timeStamp) && (this.prevEvent = e);
                    }
                },
                {
                    key: "_doPhase",
                    value: function(e) {
                        var r = e.event, n = e.phase, o = e.preEnd, l = e.type, c = this.rect;
                        if (c && n === "move" && (mt(this.edges, c, this.coords.delta[this.interactable.options.deltaSource]), c.width = c.right - c.left, c.height = c.bottom - c.top), this._scopeFire("interactions:before-action-".concat(n), e) === !1) return !1;
                        var p = e.iEvent = this._createPreparedEvent(r, n, o, l);
                        return this._scopeFire("interactions:action-".concat(n), e), n === "start" && (this.prevEvent = p), this._fireEvent(p), this._scopeFire("interactions:after-action-".concat(n), e), !0;
                    }
                },
                {
                    key: "_now",
                    value: function() {
                        return Date.now();
                    }
                }
            ]), t1;
        }();
        function wn(t1) {
            Sn(t1.interaction);
        }
        function Sn(t1) {
            if (!function(r) {
                return !(!r.offset.pending.x && !r.offset.pending.y);
            }(t1)) return !1;
            var e = t1.offset.pending;
            return dr(t1.coords.cur, e), dr(t1.coords.delta, e), mt(t1.edges, t1.rect, e), e.x = 0, e.y = 0, !0;
        }
        function $o(t1) {
            var e = t1.x, r = t1.y;
            this.offset.pending.x += e, this.offset.pending.y += r, this.offset.total.x += e, this.offset.total.y += r;
        }
        function dr(t1, e) {
            var r = t1.page, n = t1.client, o = e.x, l = e.y;
            r.x += o, r.y += l, n.x += o, n.y += l;
        }
        Tn.offsetBy = "";
        var ko = {
            id: "offset",
            before: [
                "modifiers",
                "pointer-events",
                "actions",
                "inertia"
            ],
            install: function(t1) {
                t1.Interaction.prototype.offsetBy = $o;
            },
            listeners: {
                "interactions:new": function(t1) {
                    t1.interaction.offset = {
                        total: {
                            x: 0,
                            y: 0
                        },
                        pending: {
                            x: 0,
                            y: 0
                        }
                    };
                },
                "interactions:update-pointer": function(t1) {
                    return function(e) {
                        e.pointerIsDown && (dr(e.coords.cur, e.offset.total), e.offset.pending.x = 0, e.offset.pending.y = 0);
                    }(t1.interaction);
                },
                "interactions:before-action-start": wn,
                "interactions:before-action-move": wn,
                "interactions:before-action-end": function(t1) {
                    var e = t1.interaction;
                    if (Sn(e)) return e.move({
                        offset: !0
                    }), e.end(), !1;
                },
                "interactions:stop": function(t1) {
                    var e = t1.interaction;
                    e.offset.total.x = 0, e.offset.total.y = 0, e.offset.pending.x = 0, e.offset.pending.y = 0;
                }
            }
        }, xn = ko, zo = function() {
            function t1(e) {
                v(this, t1), this.active = !1, this.isModified = !1, this.smoothEnd = !1, this.allowResume = !1, this.modification = void 0, this.modifierCount = 0, this.modifierArg = void 0, this.startCoords = void 0, this.t0 = 0, this.v0 = 0, this.te = 0, this.targetOffset = void 0, this.modifiedOffset = void 0, this.currentOffset = void 0, this.lambda_v0 = 0, this.one_ve_v0 = 0, this.timeout = void 0, this.interaction = void 0, this.interaction = e;
            }
            return y(t1, [
                {
                    key: "start",
                    value: function(e) {
                        var r = this.interaction, n = Ct(r);
                        if (!n || !n.enabled) return !1;
                        var o = r.coords.velocity.client, l = ot(o.x, o.y), c = this.modification || (this.modification = new pr(r));
                        if (c.copyFrom(r.modification), this.t0 = r._now(), this.allowResume = n.allowResume, this.v0 = l, this.currentOffset = {
                            x: 0,
                            y: 0
                        }, this.startCoords = r.coords.cur.page, this.modifierArg = c.fillArg({
                            pageCoords: this.startCoords,
                            preEnd: !0,
                            phase: "inertiastart"
                        }), this.t0 - r.coords.cur.timeStamp < 50 && l > n.minSpeed && l > n.endSpeed) this.startInertia();
                        else {
                            if (c.result = c.setAll(this.modifierArg), !c.result.changed) return !1;
                            this.startSmoothEnd();
                        }
                        return r.modification.result.rect = null, r.offsetBy(this.targetOffset), r._doPhase({
                            interaction: r,
                            event: e,
                            phase: "inertiastart"
                        }), r.offsetBy({
                            x: -this.targetOffset.x,
                            y: -this.targetOffset.y
                        }), r.modification.result.rect = null, this.active = !0, r.simulation = this, !0;
                    }
                },
                {
                    key: "startInertia",
                    value: function() {
                        var e = this, r = this.interaction.coords.velocity.client, n = Ct(this.interaction), o = n.resistance, l = -Math.log(n.endSpeed / this.v0) / o;
                        this.targetOffset = {
                            x: (r.x - l) / o,
                            y: (r.y - l) / o
                        }, this.te = l, this.lambda_v0 = o / this.v0, this.one_ve_v0 = 1 - n.endSpeed / this.v0;
                        var c = this.modification, p = this.modifierArg;
                        p.pageCoords = {
                            x: this.startCoords.x + this.targetOffset.x,
                            y: this.startCoords.y + this.targetOffset.y
                        }, c.result = c.setAll(p), c.result.changed && (this.isModified = !0, this.modifiedOffset = {
                            x: this.targetOffset.x + c.result.delta.x,
                            y: this.targetOffset.y + c.result.delta.y
                        }), this.onNextFrame(function() {
                            return e.inertiaTick();
                        });
                    }
                },
                {
                    key: "startSmoothEnd",
                    value: function() {
                        var e = this;
                        this.smoothEnd = !0, this.isModified = !0, this.targetOffset = {
                            x: this.modification.result.delta.x,
                            y: this.modification.result.delta.y
                        }, this.onNextFrame(function() {
                            return e.smoothEndTick();
                        });
                    }
                },
                {
                    key: "onNextFrame",
                    value: function(e) {
                        var r = this;
                        this.timeout = je.request(function() {
                            r.active && e();
                        });
                    }
                },
                {
                    key: "inertiaTick",
                    value: function() {
                        var e, r, n, o, l, c, p, h = this, g = this.interaction, d = Ct(g).resistance, b = (g._now() - this.t0) / 1e3;
                        if (b < this.te) {
                            var w, I = 1 - (Math.exp(-d * b) - this.lambda_v0) / this.one_ve_v0;
                            this.isModified ? (e = 0, r = 0, n = this.targetOffset.x, o = this.targetOffset.y, l = this.modifiedOffset.x, c = this.modifiedOffset.y, w = {
                                x: On(p = I, e, n, l),
                                y: On(p, r, o, c)
                            }) : w = {
                                x: this.targetOffset.x * I,
                                y: this.targetOffset.y * I
                            };
                            var E = {
                                x: w.x - this.currentOffset.x,
                                y: w.y - this.currentOffset.y
                            };
                            this.currentOffset.x += E.x, this.currentOffset.y += E.y, g.offsetBy(E), g.move(), this.onNextFrame(function() {
                                return h.inertiaTick();
                            });
                        } else g.offsetBy({
                            x: this.modifiedOffset.x - this.currentOffset.x,
                            y: this.modifiedOffset.y - this.currentOffset.y
                        }), this.end();
                    }
                },
                {
                    key: "smoothEndTick",
                    value: function() {
                        var e = this, r = this.interaction, n = r._now() - this.t0, o = Ct(r).smoothEndDuration;
                        if (n < o) {
                            var l = {
                                x: Cn(n, 0, this.targetOffset.x, o),
                                y: Cn(n, 0, this.targetOffset.y, o)
                            }, c = {
                                x: l.x - this.currentOffset.x,
                                y: l.y - this.currentOffset.y
                            };
                            this.currentOffset.x += c.x, this.currentOffset.y += c.y, r.offsetBy(c), r.move({
                                skipModifiers: this.modifierCount
                            }), this.onNextFrame(function() {
                                return e.smoothEndTick();
                            });
                        } else r.offsetBy({
                            x: this.targetOffset.x - this.currentOffset.x,
                            y: this.targetOffset.y - this.currentOffset.y
                        }), this.end();
                    }
                },
                {
                    key: "resume",
                    value: function(e) {
                        var r = e.pointer, n = e.event, o = e.eventTarget, l = this.interaction;
                        l.offsetBy({
                            x: -this.currentOffset.x,
                            y: -this.currentOffset.y
                        }), l.updatePointer(r, n, o, !0), l._doPhase({
                            interaction: l,
                            event: n,
                            phase: "resume"
                        }), yt(l.coords.prev, l.coords.cur), this.stop();
                    }
                },
                {
                    key: "end",
                    value: function() {
                        this.interaction.move(), this.interaction.end(), this.stop();
                    }
                },
                {
                    key: "stop",
                    value: function() {
                        this.active = this.smoothEnd = !1, this.interaction.simulation = null, je.cancel(this.timeout);
                    }
                }
            ]), t1;
        }();
        function Ct(t1) {
            var e = t1.interactable, r = t1.prepared;
            return e && e.options && r.name && e.options[r.name].inertia;
        }
        var jo = {
            id: "inertia",
            before: [
                "modifiers",
                "actions"
            ],
            install: function(t1) {
                var e = t1.defaults;
                t1.usePlugin(xn), t1.usePlugin(bn), t1.actions.phases.inertiastart = !0, t1.actions.phases.resume = !0, e.perAction.inertia = {
                    enabled: !1,
                    resistance: 10,
                    minSpeed: 100,
                    endSpeed: 10,
                    allowResume: !0,
                    smoothEndDuration: 300
                };
            },
            listeners: {
                "interactions:new": function(t1) {
                    var e = t1.interaction;
                    e.inertia = new zo(e);
                },
                "interactions:before-action-end": function(t1) {
                    var e = t1.interaction, r = t1.event;
                    return (!e._interacting || e.simulation || !e.inertia.start(r)) && null;
                },
                "interactions:down": function(t1) {
                    var e = t1.interaction, r = t1.eventTarget, n = e.inertia;
                    if (n.active) for(var o = r; S.element(o);){
                        if (o === e.element) {
                            n.resume(t1);
                            break;
                        }
                        o = K(o);
                    }
                },
                "interactions:stop": function(t1) {
                    var e = t1.interaction.inertia;
                    e.active && e.stop();
                },
                "interactions:before-action-resume": function(t1) {
                    var e = t1.interaction.modification;
                    e.stop(t1), e.start(t1, t1.interaction.coords.cur.page), e.applyToInteraction(t1);
                },
                "interactions:before-action-inertiastart": function(t1) {
                    return t1.interaction.modification.setAndApply(t1);
                },
                "interactions:action-resume": ut,
                "interactions:action-inertiastart": ut,
                "interactions:after-action-inertiastart": function(t1) {
                    return t1.interaction.modification.restoreInteractionCoords(t1);
                },
                "interactions:after-action-resume": function(t1) {
                    return t1.interaction.modification.restoreInteractionCoords(t1);
                }
            }
        };
        function On(t1, e, r, n) {
            var o = 1 - t1;
            return o * o * e + 2 * o * t1 * r + t1 * t1 * n;
        }
        function Cn(t1, e, r, n) {
            return -r * (t1 /= n) * (t1 - 2) + e;
        }
        var Ao = jo;
        function _n(t1, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                if (t1.immediatePropagationStopped) break;
                n(t1);
            }
        }
        var Mn = function() {
            function t1(e) {
                v(this, t1), this.options = void 0, this.types = {}, this.propagationStopped = !1, this.immediatePropagationStopped = !1, this.global = void 0, this.options = H({}, e || {});
            }
            return y(t1, [
                {
                    key: "fire",
                    value: function(e) {
                        var r, n = this.global;
                        (r = this.types[e.type]) && _n(e, r), !e.propagationStopped && n && (r = n[e.type]) && _n(e, r);
                    }
                },
                {
                    key: "on",
                    value: function(e, r) {
                        var n = Ue(e, r);
                        for(e in n)this.types[e] = tn(this.types[e] || [], n[e]);
                    }
                },
                {
                    key: "off",
                    value: function(e, r) {
                        var n = Ue(e, r);
                        for(e in n){
                            var o = this.types[e];
                            if (o && o.length) for(var l = 0, c = n[e]; l < c.length; l++){
                                var p = c[l], h = o.indexOf(p);
                                h !== -1 && o.splice(h, 1);
                            }
                        }
                    }
                },
                {
                    key: "getRect",
                    value: function(e) {
                        return null;
                    }
                }
            ]), t1;
        }(), Lo = function() {
            function t1(e) {
                v(this, t1), this.currentTarget = void 0, this.originalEvent = void 0, this.type = void 0, this.originalEvent = e, bt(this, e);
            }
            return y(t1, [
                {
                    key: "preventOriginalDefault",
                    value: function() {
                        this.originalEvent.preventDefault();
                    }
                },
                {
                    key: "stopPropagation",
                    value: function() {
                        this.originalEvent.stopPropagation();
                    }
                },
                {
                    key: "stopImmediatePropagation",
                    value: function() {
                        this.originalEvent.stopImmediatePropagation();
                    }
                }
            ]), t1;
        }();
        function pt(t1) {
            return S.object(t1) ? {
                capture: !!t1.capture,
                passive: !!t1.passive
            } : {
                capture: !!t1,
                passive: !1
            };
        }
        function _t(t1, e) {
            return t1 === e || (typeof t1 == "boolean" ? !!e.capture === t1 && !e.passive : !!t1.capture == !!e.capture && !!t1.passive == !!e.passive);
        }
        var Ho = {
            id: "events",
            install: function(t1) {
                var e, r = [], n = {}, o = [], l = {
                    add: c,
                    remove: p,
                    addDelegate: function(d, b, w, I, E) {
                        var D = pt(E);
                        if (!n[w]) {
                            n[w] = [];
                            for(var L = 0; L < o.length; L++){
                                var j = o[L];
                                c(j, w, h), c(j, w, g, !0);
                            }
                        }
                        var Y = n[w], q = lt(Y, function(ee) {
                            return ee.selector === d && ee.context === b;
                        });
                        q || (q = {
                            selector: d,
                            context: b,
                            listeners: []
                        }, Y.push(q)), q.listeners.push({
                            func: I,
                            options: D
                        });
                    },
                    removeDelegate: function(d, b, w, I, E) {
                        var D, L = pt(E), j = n[w], Y = !1;
                        if (j) for(D = j.length - 1; D >= 0; D--){
                            var q = j[D];
                            if (q.selector === d && q.context === b) {
                                for(var ee = q.listeners, B = ee.length - 1; B >= 0; B--){
                                    var Z = ee[B];
                                    if (Z.func === I && _t(Z.options, L)) {
                                        ee.splice(B, 1), ee.length || (j.splice(D, 1), p(b, w, h), p(b, w, g, !0)), Y = !0;
                                        break;
                                    }
                                }
                                if (Y) break;
                            }
                        }
                    },
                    delegateListener: h,
                    delegateUseCapture: g,
                    delegatedEvents: n,
                    documents: o,
                    targets: r,
                    supportsOptions: !1,
                    supportsPassive: !1
                };
                function c(d, b, w, I) {
                    if (d.addEventListener) {
                        var E = pt(I), D = lt(r, function(L) {
                            return L.eventTarget === d;
                        });
                        D || (D = {
                            eventTarget: d,
                            events: {}
                        }, r.push(D)), D.events[b] || (D.events[b] = []), lt(D.events[b], function(L) {
                            return L.func === w && _t(L.options, E);
                        }) || (d.addEventListener(b, w, l.supportsOptions ? E : E.capture), D.events[b].push({
                            func: w,
                            options: E
                        }));
                    }
                }
                function p(d, b, w, I) {
                    if (d.addEventListener && d.removeEventListener) {
                        var E = at(r, function(me) {
                            return me.eventTarget === d;
                        }), D = r[E];
                        if (D && D.events) {
                            if (b !== "all") {
                                var L = !1, j = D.events[b];
                                if (j) {
                                    if (w === "all") {
                                        for(var Y = j.length - 1; Y >= 0; Y--){
                                            var q = j[Y];
                                            p(d, b, q.func, q.options);
                                        }
                                        return;
                                    }
                                    for(var ee = pt(I), B = 0; B < j.length; B++){
                                        var Z = j[B];
                                        if (Z.func === w && _t(Z.options, ee)) {
                                            d.removeEventListener(b, w, l.supportsOptions ? ee : ee.capture), j.splice(B, 1), j.length === 0 && (delete D.events[b], L = !0);
                                            break;
                                        }
                                    }
                                }
                                L && !Object.keys(D.events).length && r.splice(E, 1);
                            } else for(b in D.events)D.events.hasOwnProperty(b) && p(d, b, "all");
                        }
                    }
                }
                function h(d, b) {
                    for(var w = pt(b), I = new Lo(d), E = n[d.type], D = en(d)[0], L = D; S.element(L);){
                        for(var j = 0; j < E.length; j++){
                            var Y = E[j], q = Y.selector, ee = Y.context;
                            if (X(L, q) && F(ee, D) && F(ee, L)) {
                                var B = Y.listeners;
                                I.currentTarget = L;
                                for(var Z = 0; Z < B.length; Z++){
                                    var me = B[Z];
                                    _t(me.options, w) && me.func(I);
                                }
                            }
                        }
                        L = K(L);
                    }
                }
                function g(d) {
                    return h(d, !0);
                }
                return (e = t1.document) == null || e.createElement("div").addEventListener("test", null, {
                    get capture () {
                        return l.supportsOptions = !0;
                    },
                    get passive () {
                        return l.supportsPassive = !0;
                    }
                }), t1.events = l, l;
            }
        }, fr = {
            methodOrder: [
                "simulationResume",
                "mouseOrPen",
                "hasPointer",
                "idle"
            ],
            search: function(t1) {
                for(var e = 0, r = fr.methodOrder; e < r.length; e++){
                    var n = r[e], o = fr[n](t1);
                    if (o) return o;
                }
                return null;
            },
            simulationResume: function(t1) {
                var e = t1.pointerType, r = t1.eventType, n = t1.eventTarget, o = t1.scope;
                if (!/down|start/i.test(r)) return null;
                for(var l = 0, c = o.interactions.list; l < c.length; l++){
                    var p = c[l], h = n;
                    if (p.simulation && p.simulation.allowResume && p.pointerType === e) for(; h;){
                        if (h === p.element) return p;
                        h = K(h);
                    }
                }
                return null;
            },
            mouseOrPen: function(t1) {
                var e, r = t1.pointerId, n = t1.pointerType, o = t1.eventType, l = t1.scope;
                if (n !== "mouse" && n !== "pen") return null;
                for(var c = 0, p = l.interactions.list; c < p.length; c++){
                    var h = p[c];
                    if (h.pointerType === n) {
                        if (h.simulation && !En(h, r)) continue;
                        if (h.interacting()) return h;
                        e || (e = h);
                    }
                }
                if (e) return e;
                for(var g = 0, d = l.interactions.list; g < d.length; g++){
                    var b = d[g];
                    if (!(b.pointerType !== n || /down/i.test(o) && b.simulation)) return b;
                }
                return null;
            },
            hasPointer: function(t1) {
                for(var e = t1.pointerId, r = 0, n = t1.scope.interactions.list; r < n.length; r++){
                    var o = n[r];
                    if (En(o, e)) return o;
                }
                return null;
            },
            idle: function(t1) {
                for(var e = t1.pointerType, r = 0, n = t1.scope.interactions.list; r < n.length; r++){
                    var o = n[r];
                    if (o.pointers.length === 1) {
                        var l = o.interactable;
                        if (l && (!l.options.gesture || !l.options.gesture.enabled)) continue;
                    } else if (o.pointers.length >= 2) continue;
                    if (!o.interacting() && e === o.pointerType) return o;
                }
                return null;
            }
        };
        function En(t1, e) {
            return t1.pointers.some(function(r) {
                return r.id === e;
            });
        }
        var Wo = fr, vr = [
            "pointerDown",
            "pointerMove",
            "pointerUp",
            "updatePointer",
            "removePointer",
            "windowBlur"
        ];
        function In(t1, e) {
            return function(r) {
                var n = e.interactions.list, o = Qr(r), l = en(r), c = l[0], p = l[1], h = [];
                if (/^touch/.test(r.type)) {
                    e.prevTouchTime = e.now();
                    for(var g = 0, d = r.changedTouches; g < d.length; g++){
                        var b = d[g], w = {
                            pointer: b,
                            pointerId: st(b),
                            pointerType: o,
                            eventType: r.type,
                            eventTarget: c,
                            curEventTarget: p,
                            scope: e
                        }, I = Pn(w);
                        h.push([
                            w.pointer,
                            w.eventTarget,
                            w.curEventTarget,
                            I
                        ]);
                    }
                } else {
                    var E = !1;
                    if (!R.supportsPointerEvent && /mouse/.test(r.type)) {
                        for(var D = 0; D < n.length && !E; D++)E = n[D].pointerType !== "mouse" && n[D].pointerIsDown;
                        E = E || e.now() - e.prevTouchTime < 500 || r.timeStamp === 0;
                    }
                    if (!E) {
                        var L = {
                            pointer: r,
                            pointerId: st(r),
                            pointerType: o,
                            eventType: r.type,
                            curEventTarget: p,
                            eventTarget: c,
                            scope: e
                        }, j = Pn(L);
                        h.push([
                            L.pointer,
                            L.eventTarget,
                            L.curEventTarget,
                            j
                        ]);
                    }
                }
                for(var Y = 0; Y < h.length; Y++){
                    var q = h[Y], ee = q[0], B = q[1], Z = q[2];
                    q[3][t1](ee, r, B, Z);
                }
            };
        }
        function Pn(t1) {
            var e = t1.pointerType, r = t1.scope, n = {
                interaction: Wo.search(t1),
                searchDetails: t1
            };
            return r.fire("interactions:find", n), n.interaction || r.interactions.new({
                pointerType: e
            });
        }
        function gr(t1, e) {
            var r = t1.doc, n = t1.scope, o = t1.options, l = n.interactions.docEvents, c = n.events, p = c[e];
            for(var h in n.browser.isIOS && !o.events && (o.events = {
                passive: !1
            }), c.delegatedEvents)p(r, h, c.delegateListener), p(r, h, c.delegateUseCapture, !0);
            for(var g = o && o.events, d = 0; d < l.length; d++){
                var b = l[d];
                p(r, b.type, b.listener, g);
            }
        }
        var Fo = {
            id: "core/interactions",
            install: function(t1) {
                for(var e = {}, r = 0; r < vr.length; r++){
                    var n = vr[r];
                    e[n] = In(n, t1);
                }
                var o, l = R.pEventTypes;
                function c() {
                    for(var p = 0, h = t1.interactions.list; p < h.length; p++){
                        var g = h[p];
                        if (g.pointerIsDown && g.pointerType === "touch" && !g._interacting) for(var d = function() {
                            var I = w[b];
                            t1.documents.some(function(E) {
                                return F(E.doc, I.downTarget);
                            }) || g.removePointer(I.pointer, I.event);
                        }, b = 0, w = g.pointers; b < w.length; b++)d();
                    }
                }
                (o = W.PointerEvent ? [
                    {
                        type: l.down,
                        listener: c
                    },
                    {
                        type: l.down,
                        listener: e.pointerDown
                    },
                    {
                        type: l.move,
                        listener: e.pointerMove
                    },
                    {
                        type: l.up,
                        listener: e.pointerUp
                    },
                    {
                        type: l.cancel,
                        listener: e.pointerUp
                    }
                ] : [
                    {
                        type: "mousedown",
                        listener: e.pointerDown
                    },
                    {
                        type: "mousemove",
                        listener: e.pointerMove
                    },
                    {
                        type: "mouseup",
                        listener: e.pointerUp
                    },
                    {
                        type: "touchstart",
                        listener: c
                    },
                    {
                        type: "touchstart",
                        listener: e.pointerDown
                    },
                    {
                        type: "touchmove",
                        listener: e.pointerMove
                    },
                    {
                        type: "touchend",
                        listener: e.pointerUp
                    },
                    {
                        type: "touchcancel",
                        listener: e.pointerUp
                    }
                ]).push({
                    type: "blur",
                    listener: function(p) {
                        for(var h = 0, g = t1.interactions.list; h < g.length; h++)g[h].documentBlur(p);
                    }
                }), t1.prevTouchTime = 0, t1.Interaction = function(p) {
                    O(g, p);
                    var h = _(g);
                    function g() {
                        return v(this, g), h.apply(this, arguments);
                    }
                    return y(g, [
                        {
                            key: "pointerMoveTolerance",
                            get: function() {
                                return t1.interactions.pointerMoveTolerance;
                            },
                            set: function(d) {
                                t1.interactions.pointerMoveTolerance = d;
                            }
                        },
                        {
                            key: "_now",
                            value: function() {
                                return t1.now();
                            }
                        }
                    ]), g;
                }(Ro), t1.interactions = {
                    list: [],
                    new: function(p) {
                        p.scopeFire = function(g, d) {
                            return t1.fire(g, d);
                        };
                        var h = new t1.Interaction(p);
                        return t1.interactions.list.push(h), h;
                    },
                    listeners: e,
                    docEvents: o,
                    pointerMoveTolerance: 1
                }, t1.usePlugin(mn);
            },
            listeners: {
                "scope:add-document": function(t1) {
                    return gr(t1, "add");
                },
                "scope:remove-document": function(t1) {
                    return gr(t1, "remove");
                },
                "interactable:unset": function(t1, e) {
                    for(var r = t1.interactable, n = e.interactions.list.length - 1; n >= 0; n--){
                        var o = e.interactions.list[n];
                        o.interactable === r && (o.stop(), e.fire("interactions:destroy", {
                            interaction: o
                        }), o.destroy(), e.interactions.list.length > 2 && e.interactions.list.splice(n, 1));
                    }
                }
            },
            onDocSignal: gr,
            doOnInteractions: In,
            methodNames: vr
        }, Uo = Fo, Le = function(t1) {
            return t1[t1.On = 0] = "On", t1[t1.Off = 1] = "Off", t1;
        }(Le || {}), No = function() {
            function t1(e, r, n, o) {
                v(this, t1), this.target = void 0, this.options = void 0, this._actions = void 0, this.events = new Mn(), this._context = void 0, this._win = void 0, this._doc = void 0, this._scopeEvents = void 0, this._actions = r.actions, this.target = e, this._context = r.context || n, this._win = te(ke(e) ? this._context : e), this._doc = this._win.document, this._scopeEvents = o, this.set(r);
            }
            return y(t1, [
                {
                    key: "_defaults",
                    get: function() {
                        return {
                            base: {},
                            perAction: {},
                            actions: {}
                        };
                    }
                },
                {
                    key: "setOnEvents",
                    value: function(e, r) {
                        return S.func(r.onstart) && this.on("".concat(e, "start"), r.onstart), S.func(r.onmove) && this.on("".concat(e, "move"), r.onmove), S.func(r.onend) && this.on("".concat(e, "end"), r.onend), S.func(r.oninertiastart) && this.on("".concat(e, "inertiastart"), r.oninertiastart), this;
                    }
                },
                {
                    key: "updatePerActionListeners",
                    value: function(e, r, n) {
                        var o, l = this, c = (o = this._actions.map[e]) == null ? void 0 : o.filterEventType, p = function(h) {
                            return (c == null || c(h)) && xt(h, l._actions);
                        };
                        (S.array(r) || S.object(r)) && this._onOff(Le.Off, e, r, void 0, p), (S.array(n) || S.object(n)) && this._onOff(Le.On, e, n, void 0, p);
                    }
                },
                {
                    key: "setPerAction",
                    value: function(e, r) {
                        var n = this._defaults;
                        for(var o in r){
                            var l = o, c = this.options[e], p = r[l];
                            l === "listeners" && this.updatePerActionListeners(e, c.listeners, p), S.array(p) ? c[l] = rn(p) : S.plainObject(p) ? (c[l] = H(c[l] || {}, Be(p)), S.object(n.perAction[l]) && "enabled" in n.perAction[l] && (c[l].enabled = p.enabled !== !1)) : S.bool(p) && S.object(n.perAction[l]) ? c[l].enabled = p : c[l] = p;
                        }
                    }
                },
                {
                    key: "getRect",
                    value: function(e) {
                        return e = e || (S.element(this.target) ? this.target : null), S.string(this.target) && (e = e || this._context.querySelector(this.target)), Oe(e);
                    }
                },
                {
                    key: "rectChecker",
                    value: function(e) {
                        var r = this;
                        return S.func(e) ? (this.getRect = function(n) {
                            var o = H({}, e.apply(r, n));
                            return "width" in o || (o.width = o.right - o.left, o.height = o.bottom - o.top), o;
                        }, this) : e === null ? (delete this.getRect, this) : this.getRect;
                    }
                },
                {
                    key: "_backCompatOption",
                    value: function(e, r) {
                        if (ke(r) || S.object(r)) {
                            for(var n in this.options[e] = r, this._actions.map)this.options[n][e] = r;
                            return this;
                        }
                        return this.options[e];
                    }
                },
                {
                    key: "origin",
                    value: function(e) {
                        return this._backCompatOption("origin", e);
                    }
                },
                {
                    key: "deltaSource",
                    value: function(e) {
                        return e === "page" || e === "client" ? (this.options.deltaSource = e, this) : this.options.deltaSource;
                    }
                },
                {
                    key: "getAllElements",
                    value: function() {
                        var e = this.target;
                        return S.string(e) ? Array.from(this._context.querySelectorAll(e)) : S.func(e) && e.getAllElements ? e.getAllElements() : S.element(e) ? [
                            e
                        ] : [];
                    }
                },
                {
                    key: "context",
                    value: function() {
                        return this._context;
                    }
                },
                {
                    key: "inContext",
                    value: function(e) {
                        return this._context === e.ownerDocument || F(this._context, e);
                    }
                },
                {
                    key: "testIgnoreAllow",
                    value: function(e, r, n) {
                        return !this.testIgnore(e.ignoreFrom, r, n) && this.testAllow(e.allowFrom, r, n);
                    }
                },
                {
                    key: "testAllow",
                    value: function(e, r, n) {
                        return !e || !!S.element(n) && (S.string(e) ? pe(n, e, r) : !!S.element(e) && F(e, n));
                    }
                },
                {
                    key: "testIgnore",
                    value: function(e, r, n) {
                        return !(!e || !S.element(n)) && (S.string(e) ? pe(n, e, r) : !!S.element(e) && F(e, n));
                    }
                },
                {
                    key: "fire",
                    value: function(e) {
                        return this.events.fire(e), this;
                    }
                },
                {
                    key: "_onOff",
                    value: function(e, r, n, o, l) {
                        S.object(r) && !S.array(r) && (o = n, n = null);
                        var c = Ue(r, n, l);
                        for(var p in c){
                            p === "wheel" && (p = R.wheelEvent);
                            for(var h = 0, g = c[p]; h < g.length; h++){
                                var d = g[h];
                                xt(p, this._actions) ? this.events[e === Le.On ? "on" : "off"](p, d) : S.string(this.target) ? this._scopeEvents[e === Le.On ? "addDelegate" : "removeDelegate"](this.target, this._context, p, d, o) : this._scopeEvents[e === Le.On ? "add" : "remove"](this.target, p, d, o);
                            }
                        }
                        return this;
                    }
                },
                {
                    key: "on",
                    value: function(e, r, n) {
                        return this._onOff(Le.On, e, r, n);
                    }
                },
                {
                    key: "off",
                    value: function(e, r, n) {
                        return this._onOff(Le.Off, e, r, n);
                    }
                },
                {
                    key: "set",
                    value: function(e) {
                        var r = this._defaults;
                        for(var n in S.object(e) || (e = {}), this.options = Be(r.base), this._actions.methodDict){
                            var o = n, l = this._actions.methodDict[o];
                            this.options[o] = {}, this.setPerAction(o, H(H({}, r.perAction), r.actions[o])), this[l](e[o]);
                        }
                        for(var c in e)c !== "getRect" ? S.func(this[c]) && this[c](e[c]) : this.rectChecker(e.getRect);
                        return this;
                    }
                },
                {
                    key: "unset",
                    value: function() {
                        if (S.string(this.target)) for(var e in this._scopeEvents.delegatedEvents)for(var r = this._scopeEvents.delegatedEvents[e], n = r.length - 1; n >= 0; n--){
                            var o = r[n], l = o.selector, c = o.context, p = o.listeners;
                            l === this.target && c === this._context && r.splice(n, 1);
                            for(var h = p.length - 1; h >= 0; h--)this._scopeEvents.removeDelegate(this.target, this._context, e, p[h][0], p[h][1]);
                        }
                        else this._scopeEvents.remove(this.target, "all");
                    }
                }
            ]), t1;
        }(), Yo = function() {
            function t1(e) {
                var r = this;
                v(this, t1), this.list = [], this.selectorMap = {}, this.scope = void 0, this.scope = e, e.addListeners({
                    "interactable:unset": function(n) {
                        var o = n.interactable, l = o.target, c = S.string(l) ? r.selectorMap[l] : l[r.scope.id], p = at(c, function(h) {
                            return h === o;
                        });
                        c.splice(p, 1);
                    }
                });
            }
            return y(t1, [
                {
                    key: "new",
                    value: function(e, r) {
                        r = H(r || {}, {
                            actions: this.scope.actions
                        });
                        var n = new this.scope.Interactable(e, r, this.scope.document, this.scope.events);
                        return this.scope.addDocument(n._doc), this.list.push(n), S.string(e) ? (this.selectorMap[e] || (this.selectorMap[e] = []), this.selectorMap[e].push(n)) : (n.target[this.scope.id] || Object.defineProperty(e, this.scope.id, {
                            value: [],
                            configurable: !0
                        }), e[this.scope.id].push(n)), this.scope.fire("interactable:new", {
                            target: e,
                            options: r,
                            interactable: n,
                            win: this.scope._win
                        }), n;
                    }
                },
                {
                    key: "getExisting",
                    value: function(e, r) {
                        var n = r && r.context || this.scope.document, o = S.string(e), l = o ? this.selectorMap[e] : e[this.scope.id];
                        if (l) return lt(l, function(c) {
                            return c._context === n && (o || c.inContext(e));
                        });
                    }
                },
                {
                    key: "forEachMatch",
                    value: function(e, r) {
                        for(var n = 0, o = this.list; n < o.length; n++){
                            var l = o[n], c = void 0;
                            if ((S.string(l.target) ? S.element(e) && X(e, l.target) : e === l.target) && l.inContext(e) && (c = r(l)), c !== void 0) return c;
                        }
                    }
                }
            ]), t1;
        }(), Go = function() {
            function t1() {
                var e = this;
                v(this, t1), this.id = "__interact_scope_".concat(Math.floor(100 * Math.random())), this.isInitialized = !1, this.listenerMaps = [], this.browser = R, this.defaults = Be(yn), this.Eventable = Mn, this.actions = {
                    map: {},
                    phases: {
                        start: !0,
                        move: !0,
                        end: !0
                    },
                    methodDict: {},
                    phaselessTypes: {}
                }, this.interactStatic = function(n) {
                    var o = function l(c, p) {
                        var h = n.interactables.getExisting(c, p);
                        return h || ((h = n.interactables.new(c, p)).events.global = l.globalEvents), h;
                    };
                    return o.getPointerAverage = Jr, o.getTouchBBox = Qt, o.getTouchDistance = er, o.getTouchAngle = tr, o.getElementRect = Oe, o.getElementClientRect = ve, o.matchesSelector = X, o.closest = A, o.globalEvents = {}, o.version = "1.10.27", o.scope = n, o.use = function(l, c) {
                        return this.scope.usePlugin(l, c), this;
                    }, o.isSet = function(l, c) {
                        return !!this.scope.interactables.get(l, c && c.context);
                    }, o.on = ct(function(l, c, p) {
                        if (S.string(l) && l.search(" ") !== -1 && (l = l.trim().split(/ +/)), S.array(l)) {
                            for(var h = 0, g = l; h < g.length; h++){
                                var d = g[h];
                                this.on(d, c, p);
                            }
                            return this;
                        }
                        if (S.object(l)) {
                            for(var b in l)this.on(b, l[b], c);
                            return this;
                        }
                        return xt(l, this.scope.actions) ? this.globalEvents[l] ? this.globalEvents[l].push(c) : this.globalEvents[l] = [
                            c
                        ] : this.scope.events.add(this.scope.document, l, c, {
                            options: p
                        }), this;
                    }, "The interact.on() method is being deprecated"), o.off = ct(function(l, c, p) {
                        if (S.string(l) && l.search(" ") !== -1 && (l = l.trim().split(/ +/)), S.array(l)) {
                            for(var h = 0, g = l; h < g.length; h++){
                                var d = g[h];
                                this.off(d, c, p);
                            }
                            return this;
                        }
                        if (S.object(l)) {
                            for(var b in l)this.off(b, l[b], c);
                            return this;
                        }
                        var w;
                        return xt(l, this.scope.actions) ? l in this.globalEvents && (w = this.globalEvents[l].indexOf(c)) !== -1 && this.globalEvents[l].splice(w, 1) : this.scope.events.remove(this.scope.document, l, c, p), this;
                    }, "The interact.off() method is being deprecated"), o.debug = function() {
                        return this.scope;
                    }, o.supportsTouch = function() {
                        return R.supportsTouch;
                    }, o.supportsPointerEvent = function() {
                        return R.supportsPointerEvent;
                    }, o.stop = function() {
                        for(var l = 0, c = this.scope.interactions.list; l < c.length; l++)c[l].stop();
                        return this;
                    }, o.pointerMoveTolerance = function(l) {
                        return S.number(l) ? (this.scope.interactions.pointerMoveTolerance = l, this) : this.scope.interactions.pointerMoveTolerance;
                    }, o.addDocument = function(l, c) {
                        this.scope.addDocument(l, c);
                    }, o.removeDocument = function(l) {
                        this.scope.removeDocument(l);
                    }, o;
                }(this), this.InteractEvent = hr, this.Interactable = void 0, this.interactables = new Yo(this), this._win = void 0, this.document = void 0, this.window = void 0, this.documents = [], this._plugins = {
                    list: [],
                    map: {}
                }, this.onWindowUnload = function(n) {
                    return e.removeDocument(n.target);
                };
                var r = this;
                this.Interactable = function(n) {
                    O(l, n);
                    var o = _(l);
                    function l() {
                        return v(this, l), o.apply(this, arguments);
                    }
                    return y(l, [
                        {
                            key: "_defaults",
                            get: function() {
                                return r.defaults;
                            }
                        },
                        {
                            key: "set",
                            value: function(c) {
                                return M($(l.prototype), "set", this).call(this, c), r.fire("interactable:set", {
                                    options: c,
                                    interactable: this
                                }), this;
                            }
                        },
                        {
                            key: "unset",
                            value: function() {
                                M($(l.prototype), "unset", this).call(this);
                                var c = r.interactables.list.indexOf(this);
                                c < 0 || (r.interactables.list.splice(c, 1), r.fire("interactable:unset", {
                                    interactable: this
                                }));
                            }
                        }
                    ]), l;
                }(No);
            }
            return y(t1, [
                {
                    key: "addListeners",
                    value: function(e, r) {
                        this.listenerMaps.push({
                            id: r,
                            map: e
                        });
                    }
                },
                {
                    key: "fire",
                    value: function(e, r) {
                        for(var n = 0, o = this.listenerMaps; n < o.length; n++){
                            var l = o[n].map[e];
                            if (l && l(r, this, e) === !1) return !1;
                        }
                    }
                },
                {
                    key: "init",
                    value: function(e) {
                        return this.isInitialized ? this : function(r, n) {
                            return r.isInitialized = !0, S.window(n) && Q(n), W.init(n), R.init(n), je.init(n), r.window = n, r.document = n.document, r.usePlugin(Uo), r.usePlugin(Ho), r;
                        }(this, e);
                    }
                },
                {
                    key: "pluginIsInstalled",
                    value: function(e) {
                        var r = e.id;
                        return r ? !!this._plugins.map[r] : this._plugins.list.indexOf(e) !== -1;
                    }
                },
                {
                    key: "usePlugin",
                    value: function(e, r) {
                        if (!this.isInitialized) return this;
                        if (this.pluginIsInstalled(e)) return this;
                        if (e.id && (this._plugins.map[e.id] = e), this._plugins.list.push(e), e.install && e.install(this, r), e.listeners && e.before) {
                            for(var n = 0, o = this.listenerMaps.length, l = e.before.reduce(function(p, h) {
                                return p[h] = !0, p[Dn(h)] = !0, p;
                            }, {}); n < o; n++){
                                var c = this.listenerMaps[n].id;
                                if (c && (l[c] || l[Dn(c)])) break;
                            }
                            this.listenerMaps.splice(n, 0, {
                                id: e.id,
                                map: e.listeners
                            });
                        } else e.listeners && this.listenerMaps.push({
                            id: e.id,
                            map: e.listeners
                        });
                        return this;
                    }
                },
                {
                    key: "addDocument",
                    value: function(e, r) {
                        if (this.getDocIndex(e) !== -1) return !1;
                        var n = te(e);
                        r = r ? H({}, r) : {}, this.documents.push({
                            doc: e,
                            options: r
                        }), this.events.documents.push(e), e !== this.document && this.events.add(n, "unload", this.onWindowUnload), this.fire("scope:add-document", {
                            doc: e,
                            window: n,
                            scope: this,
                            options: r
                        });
                    }
                },
                {
                    key: "removeDocument",
                    value: function(e) {
                        var r = this.getDocIndex(e), n = te(e), o = this.documents[r].options;
                        this.events.remove(n, "unload", this.onWindowUnload), this.documents.splice(r, 1), this.events.documents.splice(r, 1), this.fire("scope:remove-document", {
                            doc: e,
                            window: n,
                            scope: this,
                            options: o
                        });
                    }
                },
                {
                    key: "getDocIndex",
                    value: function(e) {
                        for(var r = 0; r < this.documents.length; r++)if (this.documents[r].doc === e) return r;
                        return -1;
                    }
                },
                {
                    key: "getDocOptions",
                    value: function(e) {
                        var r = this.getDocIndex(e);
                        return r === -1 ? null : this.documents[r].options;
                    }
                },
                {
                    key: "now",
                    value: function() {
                        return (this.window.Date || Date).now();
                    }
                }
            ]), t1;
        }();
        function Dn(t1) {
            return t1 && t1.replace(/\/.*$/, "");
        }
        var Rn = new Go(), ge = Rn.interactStatic, Ko = typeof globalThis < "u" ? globalThis : window;
        Rn.init(Ko);
        var Xo = Object.freeze({
            __proto__: null,
            edgeTarget: function() {},
            elements: function() {},
            grid: function(t1) {
                var e = [
                    [
                        "x",
                        "y"
                    ],
                    [
                        "left",
                        "top"
                    ],
                    [
                        "right",
                        "bottom"
                    ],
                    [
                        "width",
                        "height"
                    ]
                ].filter(function(n) {
                    var o = n[0], l = n[1];
                    return o in t1 || l in t1;
                }), r = function(n, o) {
                    for(var l = t1.range, c = t1.limits, p = c === void 0 ? {
                        left: -1 / 0,
                        right: 1 / 0,
                        top: -1 / 0,
                        bottom: 1 / 0
                    } : c, h = t1.offset, g = h === void 0 ? {
                        x: 0,
                        y: 0
                    } : h, d = {
                        range: l,
                        grid: t1,
                        x: null,
                        y: null
                    }, b = 0; b < e.length; b++){
                        var w = e[b], I = w[0], E = w[1], D = Math.round((n - g.x) / t1[I]), L = Math.round((o - g.y) / t1[E]);
                        d[I] = Math.max(p.left, Math.min(p.right, D * t1[I] + g.x)), d[E] = Math.max(p.top, Math.min(p.bottom, L * t1[E] + g.y));
                    }
                    return d;
                };
                return r.grid = t1, r.coordFields = e, r;
            }
        }), Bo = {
            id: "snappers",
            install: function(t1) {
                var e = t1.interactStatic;
                e.snappers = H(e.snappers || {}, Xo), e.createSnapGrid = e.snappers.grid;
            }
        }, Vo = Bo, qo = {
            start: function(t1) {
                var e = t1.state, r = t1.rect, n = t1.edges, o = t1.pageCoords, l = e.options, c = l.ratio, p = l.enabled, h = e.options, g = h.equalDelta, d = h.modifiers;
                c === "preserve" && (c = r.width / r.height), e.startCoords = H({}, o), e.startRect = H({}, r), e.ratio = c, e.equalDelta = g;
                var b = e.linkedEdges = {
                    top: n.top || n.left && !n.bottom,
                    left: n.left || n.top && !n.right,
                    bottom: n.bottom || n.right && !n.top,
                    right: n.right || n.bottom && !n.left
                };
                if (e.xIsPrimaryAxis = !(!n.left && !n.right), e.equalDelta) {
                    var w = (b.left ? 1 : -1) * (b.top ? 1 : -1);
                    e.edgeSign = {
                        x: w,
                        y: w
                    };
                } else e.edgeSign = {
                    x: b.left ? -1 : 1,
                    y: b.top ? -1 : 1
                };
                if (p !== !1 && H(n, b), d != null && d.length) {
                    var I = new pr(t1.interaction);
                    I.copyFrom(t1.interaction.modification), I.prepareStates(d), e.subModification = I, I.startAll(u({}, t1));
                }
            },
            set: function(t1) {
                var e = t1.state, r = t1.rect, n = t1.coords, o = e.linkedEdges, l = H({}, n), c = e.equalDelta ? Zo : Jo;
                if (H(t1.edges, o), c(e, e.xIsPrimaryAxis, n, r), !e.subModification) return null;
                var p = H({}, r);
                mt(o, p, {
                    x: n.x - l.x,
                    y: n.y - l.y
                });
                var h = e.subModification.setAll(u(u({}, t1), {}, {
                    rect: p,
                    edges: o,
                    pageCoords: n,
                    prevCoords: n,
                    prevRect: p
                })), g = h.delta;
                return h.changed && (c(e, Math.abs(g.x) > Math.abs(g.y), h.coords, h.rect), H(n, h.coords)), h.eventProps;
            },
            defaults: {
                ratio: "preserve",
                equalDelta: !1,
                modifiers: [],
                enabled: !1
            }
        };
        function Zo(t1, e, r) {
            var n = t1.startCoords, o = t1.edgeSign;
            e ? r.y = n.y + (r.x - n.x) * o.y : r.x = n.x + (r.y - n.y) * o.x;
        }
        function Jo(t1, e, r, n) {
            var o = t1.startRect, l = t1.startCoords, c = t1.ratio, p = t1.edgeSign;
            if (e) {
                var h = n.width / c;
                r.y = l.y + (h - o.height) * p.y;
            } else {
                var g = n.height * c;
                r.x = l.x + (g - o.width) * p.x;
            }
        }
        var Qo = Ae(qo, "aspectRatio"), $n = function() {};
        $n._defaults = {};
        var Mt = $n;
        function Ye(t1, e, r) {
            return S.func(t1) ? ye(t1, e.interactable, e.element, [
                r.x,
                r.y,
                e
            ]) : ye(t1, e.interactable, e.element);
        }
        var Et = {
            start: function(t1) {
                var e = t1.rect, r = t1.startOffset, n = t1.state, o = t1.interaction, l = t1.pageCoords, c = n.options, p = c.elementRect, h = H({
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                }, c.offset || {});
                if (e && p) {
                    var g = Ye(c.restriction, o, l);
                    if (g) {
                        var d = g.right - g.left - e.width, b = g.bottom - g.top - e.height;
                        d < 0 && (h.left += d, h.right += d), b < 0 && (h.top += b, h.bottom += b);
                    }
                    h.left += r.left - e.width * p.left, h.top += r.top - e.height * p.top, h.right += r.right - e.width * (1 - p.right), h.bottom += r.bottom - e.height * (1 - p.bottom);
                }
                n.offset = h;
            },
            set: function(t1) {
                var e = t1.coords, r = t1.interaction, n = t1.state, o = n.options, l = n.offset, c = Ye(o.restriction, r, e);
                if (c) {
                    var p = function(h) {
                        return !h || "left" in h && "top" in h || ((h = H({}, h)).left = h.x || 0, h.top = h.y || 0, h.right = h.right || h.left + h.width, h.bottom = h.bottom || h.top + h.height), h;
                    }(c);
                    e.x = Math.max(Math.min(p.right - l.right, e.x), p.left + l.left), e.y = Math.max(Math.min(p.bottom - l.bottom, e.y), p.top + l.top);
                }
            },
            defaults: {
                restriction: null,
                elementRect: null,
                offset: null,
                endOnly: !1,
                enabled: !1
            }
        }, es = Ae(Et, "restrict"), kn = {
            top: 1 / 0,
            left: 1 / 0,
            bottom: -1 / 0,
            right: -1 / 0
        }, zn = {
            top: -1 / 0,
            left: -1 / 0,
            bottom: 1 / 0,
            right: 1 / 0
        };
        function jn(t1, e) {
            for(var r = 0, n = [
                "top",
                "left",
                "bottom",
                "right"
            ]; r < n.length; r++){
                var o = n[r];
                o in t1 || (t1[o] = e[o]);
            }
            return t1;
        }
        var ht = {
            noInner: kn,
            noOuter: zn,
            start: function(t1) {
                var e, r = t1.interaction, n = t1.startOffset, o = t1.state, l = o.options;
                l && (e = _e(Ye(l.offset, r, r.coords.start.page))), e = e || {
                    x: 0,
                    y: 0
                }, o.offset = {
                    top: e.y + n.top,
                    left: e.x + n.left,
                    bottom: e.y - n.bottom,
                    right: e.x - n.right
                };
            },
            set: function(t1) {
                var e = t1.coords, r = t1.edges, n = t1.interaction, o = t1.state, l = o.offset, c = o.options;
                if (r) {
                    var p = H({}, e), h = Ye(c.inner, n, p) || {}, g = Ye(c.outer, n, p) || {};
                    jn(h, kn), jn(g, zn), r.top ? e.y = Math.min(Math.max(g.top + l.top, p.y), h.top + l.top) : r.bottom && (e.y = Math.max(Math.min(g.bottom + l.bottom, p.y), h.bottom + l.bottom)), r.left ? e.x = Math.min(Math.max(g.left + l.left, p.x), h.left + l.left) : r.right && (e.x = Math.max(Math.min(g.right + l.right, p.x), h.right + l.right));
                }
            },
            defaults: {
                inner: null,
                outer: null,
                offset: null,
                endOnly: !1,
                enabled: !1
            }
        }, ts = Ae(ht, "restrictEdges"), rs = H({
            get elementRect () {
                return {
                    top: 0,
                    left: 0,
                    bottom: 1,
                    right: 1
                };
            },
            set elementRect (t){}
        }, Et.defaults), ns = Ae({
            start: Et.start,
            set: Et.set,
            defaults: rs
        }, "restrictRect"), is = {
            width: -1 / 0,
            height: -1 / 0
        }, os = {
            width: 1 / 0,
            height: 1 / 0
        }, ss = Ae({
            start: function(t1) {
                return ht.start(t1);
            },
            set: function(t1) {
                var e = t1.interaction, r = t1.state, n = t1.rect, o = t1.edges, l = r.options;
                if (o) {
                    var c = ze(Ye(l.min, e, t1.coords)) || is, p = ze(Ye(l.max, e, t1.coords)) || os;
                    r.options = {
                        endOnly: l.endOnly,
                        inner: H({}, ht.noInner),
                        outer: H({}, ht.noOuter)
                    }, o.top ? (r.options.inner.top = n.bottom - c.height, r.options.outer.top = n.bottom - p.height) : o.bottom && (r.options.inner.bottom = n.top + c.height, r.options.outer.bottom = n.top + p.height), o.left ? (r.options.inner.left = n.right - c.width, r.options.outer.left = n.right - p.width) : o.right && (r.options.inner.right = n.left + c.width, r.options.outer.right = n.left + p.width), ht.set(t1), r.options = l;
                }
            },
            defaults: {
                min: null,
                max: null,
                endOnly: !1,
                enabled: !1
            }
        }, "restrictSize"), mr = {
            start: function(t1) {
                var e, r = t1.interaction, n = t1.interactable, o = t1.element, l = t1.rect, c = t1.state, p = t1.startOffset, h = c.options, g = h.offsetWithOrigin ? function(w) {
                    var I = w.interaction.element, E = _e(ye(w.state.options.origin, null, null, [
                        I
                    ])), D = E || it(w.interactable, I, w.interaction.prepared.name);
                    return D;
                }(t1) : {
                    x: 0,
                    y: 0
                };
                if (h.offset === "startCoords") e = {
                    x: r.coords.start.page.x,
                    y: r.coords.start.page.y
                };
                else {
                    var d = ye(h.offset, n, o, [
                        r
                    ]);
                    (e = _e(d) || {
                        x: 0,
                        y: 0
                    }).x += g.x, e.y += g.y;
                }
                var b = h.relativePoints;
                c.offsets = l && b && b.length ? b.map(function(w, I) {
                    return {
                        index: I,
                        relativePoint: w,
                        x: p.left - l.width * w.x + e.x,
                        y: p.top - l.height * w.y + e.y
                    };
                }) : [
                    {
                        index: 0,
                        relativePoint: null,
                        x: e.x,
                        y: e.y
                    }
                ];
            },
            set: function(t1) {
                var e = t1.interaction, r = t1.coords, n = t1.state, o = n.options, l = n.offsets, c = it(e.interactable, e.element, e.prepared.name), p = H({}, r), h = [];
                o.offsetWithOrigin || (p.x -= c.x, p.y -= c.y);
                for(var g = 0, d = l; g < d.length; g++)for(var b = d[g], w = p.x - b.x, I = p.y - b.y, E = 0, D = o.targets.length; E < D; E++){
                    var L = o.targets[E], j = void 0;
                    (j = S.func(L) ? L(w, I, e._proxy, b, E) : L) && h.push({
                        x: (S.number(j.x) ? j.x : w) + b.x,
                        y: (S.number(j.y) ? j.y : I) + b.y,
                        range: S.number(j.range) ? j.range : o.range,
                        source: L,
                        index: E,
                        offset: b
                    });
                }
                for(var Y = {
                    target: null,
                    inRange: !1,
                    distance: 0,
                    range: 0,
                    delta: {
                        x: 0,
                        y: 0
                    }
                }, q = 0; q < h.length; q++){
                    var ee = h[q], B = ee.range, Z = ee.x - p.x, me = ee.y - p.y, le = ot(Z, me), Te = le <= B;
                    B === 1 / 0 && Y.inRange && Y.range !== 1 / 0 && (Te = !1), Y.target && !(Te ? Y.inRange && B !== 1 / 0 ? le / B < Y.distance / Y.range : B === 1 / 0 && Y.range !== 1 / 0 || le < Y.distance : !Y.inRange && le < Y.distance) || (Y.target = ee, Y.distance = le, Y.range = B, Y.inRange = Te, Y.delta.x = Z, Y.delta.y = me);
                }
                return Y.inRange && (r.x = Y.target.x, r.y = Y.target.y), n.closest = Y, Y;
            },
            defaults: {
                range: 1 / 0,
                targets: null,
                offset: null,
                offsetWithOrigin: !0,
                origin: null,
                relativePoints: null,
                endOnly: !1,
                enabled: !1
            }
        }, as = Ae(mr, "snap"), It = {
            start: function(t1) {
                var e = t1.state, r = t1.edges, n = e.options;
                if (!r) return null;
                t1.state = {
                    options: {
                        targets: null,
                        relativePoints: [
                            {
                                x: r.left ? 0 : 1,
                                y: r.top ? 0 : 1
                            }
                        ],
                        offset: n.offset || "self",
                        origin: {
                            x: 0,
                            y: 0
                        },
                        range: n.range
                    }
                }, e.targetFields = e.targetFields || [
                    [
                        "width",
                        "height"
                    ],
                    [
                        "x",
                        "y"
                    ]
                ], mr.start(t1), e.offsets = t1.state.offsets, t1.state = e;
            },
            set: function(t1) {
                var e = t1.interaction, r = t1.state, n = t1.coords, o = r.options, l = r.offsets, c = {
                    x: n.x - l[0].x,
                    y: n.y - l[0].y
                };
                r.options = H({}, o), r.options.targets = [];
                for(var p = 0, h = o.targets || []; p < h.length; p++){
                    var g = h[p], d = void 0;
                    if (d = S.func(g) ? g(c.x, c.y, e) : g) {
                        for(var b = 0, w = r.targetFields; b < w.length; b++){
                            var I = w[b], E = I[0], D = I[1];
                            if (E in d || D in d) {
                                d.x = d[E], d.y = d[D];
                                break;
                            }
                        }
                        r.options.targets.push(d);
                    }
                }
                var L = mr.set(t1);
                return r.options = o, L;
            },
            defaults: {
                range: 1 / 0,
                targets: null,
                offset: null,
                endOnly: !1,
                enabled: !1
            }
        }, ls = Ae(It, "snapSize"), br = {
            aspectRatio: Qo,
            restrictEdges: ts,
            restrict: es,
            restrictRect: ns,
            restrictSize: ss,
            snapEdges: Ae({
                start: function(t1) {
                    var e = t1.edges;
                    return e ? (t1.state.targetFields = t1.state.targetFields || [
                        [
                            e.left ? "left" : "right",
                            e.top ? "top" : "bottom"
                        ]
                    ], It.start(t1)) : null;
                },
                set: It.set,
                defaults: H(Be(It.defaults), {
                    targets: void 0,
                    range: void 0,
                    offset: {
                        x: 0,
                        y: 0
                    }
                })
            }, "snapEdges"),
            snap: as,
            snapSize: ls,
            spring: Mt,
            avoid: Mt,
            transform: Mt,
            rubberband: Mt
        }, cs = {
            id: "modifiers",
            install: function(t1) {
                var e = t1.interactStatic;
                for(var r in t1.usePlugin(bn), t1.usePlugin(Vo), e.modifiers = br, br){
                    var n = br[r], o = n._defaults, l = n._methods;
                    o._methods = l, t1.defaults.perAction[r] = o;
                }
            }
        }, us = cs, An = function(t1) {
            O(r, t1);
            var e = _(r);
            function r(n, o, l, c, p, h) {
                var g;
                if (v(this, r), bt(T(g = e.call(this, p)), l), l !== o && bt(T(g), o), g.timeStamp = h, g.originalEvent = l, g.type = n, g.pointerId = st(o), g.pointerType = Qr(o), g.target = c, g.currentTarget = null, n === "tap") {
                    var d = p.getPointerIndex(o);
                    g.dt = g.timeStamp - p.pointers[d].downTime;
                    var b = g.timeStamp - p.tapTime;
                    g.double = !!p.prevTap && p.prevTap.type !== "doubletap" && p.prevTap.target === g.target && b < 500;
                } else n === "doubletap" && (g.dt = o.timeStamp - p.tapTime, g.double = !0);
                return g;
            }
            return y(r, [
                {
                    key: "_subtractOrigin",
                    value: function(n) {
                        var o = n.x, l = n.y;
                        return this.pageX -= o, this.pageY -= l, this.clientX -= o, this.clientY -= l, this;
                    }
                },
                {
                    key: "_addOrigin",
                    value: function(n) {
                        var o = n.x, l = n.y;
                        return this.pageX += o, this.pageY += l, this.clientX += o, this.clientY += l, this;
                    }
                },
                {
                    key: "preventDefault",
                    value: function() {
                        this.originalEvent.preventDefault();
                    }
                }
            ]), r;
        }(wt), dt = {
            id: "pointer-events/base",
            before: [
                "inertia",
                "modifiers",
                "auto-start",
                "actions"
            ],
            install: function(t1) {
                t1.pointerEvents = dt, t1.defaults.actions.pointerEvents = dt.defaults, H(t1.actions.phaselessTypes, dt.types);
            },
            listeners: {
                "interactions:new": function(t1) {
                    var e = t1.interaction;
                    e.prevTap = null, e.tapTime = 0;
                },
                "interactions:update-pointer": function(t1) {
                    var e = t1.down, r = t1.pointerInfo;
                    !e && r.hold || (r.hold = {
                        duration: 1 / 0,
                        timeout: null
                    });
                },
                "interactions:move": function(t1, e) {
                    var r = t1.interaction, n = t1.pointer, o = t1.event, l = t1.eventTarget;
                    t1.duplicate || r.pointerIsDown && !r.pointerWasMoved || (r.pointerIsDown && yr(t1), He({
                        interaction: r,
                        pointer: n,
                        event: o,
                        eventTarget: l,
                        type: "move"
                    }, e));
                },
                "interactions:down": function(t1, e) {
                    (function(r, n) {
                        for(var o = r.interaction, l = r.pointer, c = r.event, p = r.eventTarget, h = r.pointerIndex, g = o.pointers[h].hold, d = Ce(p), b = {
                            interaction: o,
                            pointer: l,
                            event: c,
                            eventTarget: p,
                            type: "hold",
                            targets: [],
                            path: d,
                            node: null
                        }, w = 0; w < d.length; w++){
                            var I = d[w];
                            b.node = I, n.fire("pointerEvents:collect-targets", b);
                        }
                        if (b.targets.length) {
                            for(var E = 1 / 0, D = 0, L = b.targets; D < L.length; D++){
                                var j = L[D].eventable.options.holdDuration;
                                j < E && (E = j);
                            }
                            g.duration = E, g.timeout = setTimeout(function() {
                                He({
                                    interaction: o,
                                    eventTarget: p,
                                    pointer: l,
                                    event: c,
                                    type: "hold"
                                }, n);
                            }, E);
                        }
                    })(t1, e), He(t1, e);
                },
                "interactions:up": function(t1, e) {
                    yr(t1), He(t1, e), function(r, n) {
                        var o = r.interaction, l = r.pointer, c = r.event, p = r.eventTarget;
                        o.pointerWasMoved || He({
                            interaction: o,
                            eventTarget: p,
                            pointer: l,
                            event: c,
                            type: "tap"
                        }, n);
                    }(t1, e);
                },
                "interactions:cancel": function(t1, e) {
                    yr(t1), He(t1, e);
                }
            },
            PointerEvent: An,
            fire: He,
            collectEventTargets: Ln,
            defaults: {
                holdDuration: 600,
                ignoreFrom: null,
                allowFrom: null,
                origin: {
                    x: 0,
                    y: 0
                }
            },
            types: {
                down: !0,
                move: !0,
                up: !0,
                cancel: !0,
                tap: !0,
                doubletap: !0,
                hold: !0
            }
        };
        function He(t1, e) {
            var r = t1.interaction, n = t1.pointer, o = t1.event, l = t1.eventTarget, c = t1.type, p = t1.targets, h = p === void 0 ? Ln(t1, e) : p, g = new An(c, n, o, l, r, e.now());
            e.fire("pointerEvents:new", {
                pointerEvent: g
            });
            for(var d = {
                interaction: r,
                pointer: n,
                event: o,
                eventTarget: l,
                targets: h,
                type: c,
                pointerEvent: g
            }, b = 0; b < h.length; b++){
                var w = h[b];
                for(var I in w.props || {})g[I] = w.props[I];
                var E = it(w.eventable, w.node);
                if (g._subtractOrigin(E), g.eventable = w.eventable, g.currentTarget = w.node, w.eventable.fire(g), g._addOrigin(E), g.immediatePropagationStopped || g.propagationStopped && b + 1 < h.length && h[b + 1].node !== g.currentTarget) break;
            }
            if (e.fire("pointerEvents:fired", d), c === "tap") {
                var D = g.double ? He({
                    interaction: r,
                    pointer: n,
                    event: o,
                    eventTarget: l,
                    type: "doubletap"
                }, e) : g;
                r.prevTap = D, r.tapTime = D.timeStamp;
            }
            return g;
        }
        function Ln(t1, e) {
            var r = t1.interaction, n = t1.pointer, o = t1.event, l = t1.eventTarget, c = t1.type, p = r.getPointerIndex(n), h = r.pointers[p];
            if (c === "tap" && (r.pointerWasMoved || !h || h.downTarget !== l)) return [];
            for(var g = Ce(l), d = {
                interaction: r,
                pointer: n,
                event: o,
                eventTarget: l,
                type: c,
                path: g,
                targets: [],
                node: null
            }, b = 0; b < g.length; b++){
                var w = g[b];
                d.node = w, e.fire("pointerEvents:collect-targets", d);
            }
            return c === "hold" && (d.targets = d.targets.filter(function(I) {
                var E, D;
                return I.eventable.options.holdDuration === ((E = r.pointers[p]) == null || (D = E.hold) == null ? void 0 : D.duration);
            })), d.targets;
        }
        function yr(t1) {
            var e = t1.interaction, r = t1.pointerIndex, n = e.pointers[r].hold;
            n && n.timeout && (clearTimeout(n.timeout), n.timeout = null);
        }
        var ps = Object.freeze({
            __proto__: null,
            default: dt
        });
        function hs(t1) {
            var e = t1.interaction;
            e.holdIntervalHandle && (clearInterval(e.holdIntervalHandle), e.holdIntervalHandle = null);
        }
        var ds = {
            id: "pointer-events/holdRepeat",
            install: function(t1) {
                t1.usePlugin(dt);
                var e = t1.pointerEvents;
                e.defaults.holdRepeatInterval = 0, e.types.holdrepeat = t1.actions.phaselessTypes.holdrepeat = !0;
            },
            listeners: [
                "move",
                "up",
                "cancel",
                "endall"
            ].reduce(function(t1, e) {
                return t1["pointerEvents:".concat(e)] = hs, t1;
            }, {
                "pointerEvents:new": function(t1) {
                    var e = t1.pointerEvent;
                    e.type === "hold" && (e.count = (e.count || 0) + 1);
                },
                "pointerEvents:fired": function(t1, e) {
                    var r = t1.interaction, n = t1.pointerEvent, o = t1.eventTarget, l = t1.targets;
                    if (n.type === "hold" && l.length) {
                        var c = l[0].eventable.options.holdRepeatInterval;
                        c <= 0 || (r.holdIntervalHandle = setTimeout(function() {
                            e.pointerEvents.fire({
                                interaction: r,
                                eventTarget: o,
                                type: "hold",
                                pointer: n,
                                event: n
                            }, e);
                        }, c));
                    }
                }
            })
        }, fs = ds, vs = {
            id: "pointer-events/interactableTargets",
            install: function(t1) {
                var e = t1.Interactable;
                e.prototype.pointerEvents = function(n) {
                    return H(this.events.options, n), this;
                };
                var r = e.prototype._backCompatOption;
                e.prototype._backCompatOption = function(n, o) {
                    var l = r.call(this, n, o);
                    return l === this && (this.events.options[n] = o), l;
                };
            },
            listeners: {
                "pointerEvents:collect-targets": function(t1, e) {
                    var r = t1.targets, n = t1.node, o = t1.type, l = t1.eventTarget;
                    e.interactables.forEachMatch(n, function(c) {
                        var p = c.events, h = p.options;
                        p.types[o] && p.types[o].length && c.testIgnoreAllow(h, n, l) && r.push({
                            node: n,
                            eventable: p,
                            props: {
                                interactable: c
                            }
                        });
                    });
                },
                "interactable:new": function(t1) {
                    var e = t1.interactable;
                    e.events.getRect = function(r) {
                        return e.getRect(r);
                    };
                },
                "interactable:set": function(t1, e) {
                    var r = t1.interactable, n = t1.options;
                    H(r.events.options, e.pointerEvents.defaults), H(r.events.options, n.pointerEvents || {});
                }
            }
        }, gs = vs, ms = {
            id: "pointer-events",
            install: function(t1) {
                t1.usePlugin(ps), t1.usePlugin(fs), t1.usePlugin(gs);
            }
        }, bs = ms, ys = {
            id: "reflow",
            install: function(t1) {
                var e = t1.Interactable;
                t1.actions.phases.reflow = !0, e.prototype.reflow = function(r) {
                    return function(n, o, l) {
                        for(var c = n.getAllElements(), p = l.window.Promise, h = p ? [] : null, g = function() {
                            var b = c[d], w = n.getRect(b);
                            if (!w) return 1;
                            var I, E = lt(l.interactions.list, function(j) {
                                return j.interacting() && j.interactable === n && j.element === b && j.prepared.name === o.name;
                            });
                            if (E) E.move(), h && (I = E._reflowPromise || new p(function(j) {
                                E._reflowResolve = j;
                            }));
                            else {
                                var D = ze(w), L = /* @__PURE__ */ function(j) {
                                    return {
                                        coords: j,
                                        get page () {
                                            return this.coords.page;
                                        },
                                        get client () {
                                            return this.coords.client;
                                        },
                                        get timeStamp () {
                                            return this.coords.timeStamp;
                                        },
                                        get pageX () {
                                            return this.coords.page.x;
                                        },
                                        get pageY () {
                                            return this.coords.page.y;
                                        },
                                        get clientX () {
                                            return this.coords.client.x;
                                        },
                                        get clientY () {
                                            return this.coords.client.y;
                                        },
                                        get pointerId () {
                                            return this.coords.pointerId;
                                        },
                                        get target () {
                                            return this.coords.target;
                                        },
                                        get type () {
                                            return this.coords.type;
                                        },
                                        get pointerType () {
                                            return this.coords.pointerType;
                                        },
                                        get buttons () {
                                            return this.coords.buttons;
                                        },
                                        preventDefault: function() {}
                                    };
                                }({
                                    page: {
                                        x: D.x,
                                        y: D.y
                                    },
                                    client: {
                                        x: D.x,
                                        y: D.y
                                    },
                                    timeStamp: l.now()
                                });
                                I = function(j, Y, q, ee, B) {
                                    var Z = j.interactions.new({
                                        pointerType: "reflow"
                                    }), me = {
                                        interaction: Z,
                                        event: B,
                                        pointer: B,
                                        eventTarget: q,
                                        phase: "reflow"
                                    };
                                    Z.interactable = Y, Z.element = q, Z.prevEvent = B, Z.updatePointer(B, B, q, !0), Vr(Z.coords.delta), ar(Z.prepared, ee), Z._doPhase(me);
                                    var le = j.window, Te = le.Promise, Se = Te ? new Te(function(De) {
                                        Z._reflowResolve = De;
                                    }) : void 0;
                                    return Z._reflowPromise = Se, Z.start(ee, Y, q), Z._interacting ? (Z.move(me), Z.end(B)) : (Z.stop(), Z._reflowResolve()), Z.removePointer(B, B), Se;
                                }(l, n, b, o, L);
                            }
                            h && h.push(I);
                        }, d = 0; d < c.length && !g(); d++);
                        return h && p.all(h).then(function() {
                            return n;
                        });
                    }(this, r, t1);
                };
            },
            listeners: {
                "interactions:stop": function(t1, e) {
                    var r = t1.interaction;
                    r.pointerType === "reflow" && (r._reflowResolve && r._reflowResolve(), function(n, o) {
                        n.splice(n.indexOf(o), 1);
                    }(e.interactions.list, r));
                }
            }
        }, Ts = ys;
        if (ge.use(mn), ge.use(xn), ge.use(bs), ge.use(Ao), ge.use(us), ge.use(Co), ge.use(fo), ge.use(go), ge.use(Ts), ge.default = ge, f(s) === "object" && s) try {
            s.exports = ge;
        } catch  {}
        return ge.default = ge, ge;
    });
})($402be0a702aa527c$var$Lt, $402be0a702aa527c$var$Lt.exports);
var $402be0a702aa527c$var$Ss = $402be0a702aa527c$var$Lt.exports;
const $402be0a702aa527c$var$Tr = /* @__PURE__ */ $402be0a702aa527c$var$Ze($402be0a702aa527c$var$Ss);
var $402be0a702aa527c$var$xi = {
    exports: {}
};
(function(s, i) {
    (function(a, u) {
        s.exports = u();
    })($402be0a702aa527c$var$We, function() {
        var a = 1e3, u = 6e4, f = 36e5, v = "millisecond", m = "second", y = "minute", x = "hour", O = "day", $ = "week", P = "month", T = "quarter", _ = "year", M = "date", C = "Invalid Date", z = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, N = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, G = {
            name: "en",
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            ordinal: function(W) {
                var k = [
                    "th",
                    "st",
                    "nd",
                    "rd"
                ], R = W % 100;
                return "[" + W + (k[(R - 20) % 10] || k[R] || k[0]) + "]";
            }
        }, Q = function(W, k, R) {
            var F = String(W);
            return !F || F.length >= k ? W : "" + Array(k + 1 - F.length).join(R) + W;
        }, te = {
            s: Q,
            z: function(W) {
                var k = -W.utcOffset(), R = Math.abs(k), F = Math.floor(R / 60), A = R % 60;
                return (k <= 0 ? "+" : "-") + Q(F, 2, "0") + ":" + Q(A, 2, "0");
            },
            m: function W(k, R) {
                if (k.date() < R.date()) return -W(R, k);
                var F = 12 * (R.year() - k.year()) + (R.month() - k.month()), A = k.clone().add(F, P), K = R - A < 0, X = k.clone().add(F + (K ? -1 : 1), P);
                return +(-(F + (R - A) / (K ? A - X : X - A)) || 0);
            },
            a: function(W) {
                return W < 0 ? Math.ceil(W) || 0 : Math.floor(W);
            },
            p: function(W) {
                return ({
                    M: P,
                    y: _,
                    w: $,
                    d: O,
                    D: M,
                    h: x,
                    m: y,
                    s: m,
                    ms: v,
                    Q: T
                })[W] || String(W || "").toLowerCase().replace(/s$/, "");
            },
            u: function(W) {
                return W === void 0;
            }
        }, re = "en", ue = {};
        ue[re] = G;
        var S = "$isDayjsObject", be = function(W) {
            return W instanceof de || !(!W || !W[S]);
        }, we = function W(k, R, F) {
            var A;
            if (!k) return re;
            if (typeof k == "string") {
                var K = k.toLowerCase();
                ue[K] && (A = K), R && (ue[K] = R, A = K);
                var X = k.split("-");
                if (!A && X.length > 1) return W(X[0]);
            } else {
                var ie = k.name;
                ue[ie] = k, A = ie;
            }
            return !F && A && (re = A), A || !F && re;
        }, ce = function(W, k) {
            if (be(W)) return W.clone();
            var R = typeof k == "object" ? k : {};
            return R.date = W, R.args = arguments, new de(R);
        }, ne = te;
        ne.l = we, ne.i = be, ne.w = function(W, k) {
            return ce(W, {
                locale: k.$L,
                utc: k.$u,
                x: k.$x,
                $offset: k.$offset
            });
        };
        var de = function() {
            function W(R) {
                this.$L = we(R.locale, null, !0), this.parse(R), this.$x = this.$x || R.x || {}, this[S] = !0;
            }
            var k = W.prototype;
            return k.parse = function(R) {
                this.$d = function(F) {
                    var A = F.date, K = F.utc;
                    if (A === null) return /* @__PURE__ */ new Date(NaN);
                    if (ne.u(A)) return /* @__PURE__ */ new Date();
                    if (A instanceof Date) return new Date(A);
                    if (typeof A == "string" && !/Z$/i.test(A)) {
                        var X = A.match(z);
                        if (X) {
                            var ie = X[2] - 1 || 0, ae = (X[7] || "0").substring(0, 3);
                            return K ? new Date(Date.UTC(X[1], ie, X[3] || 1, X[4] || 0, X[5] || 0, X[6] || 0, ae)) : new Date(X[1], ie, X[3] || 1, X[4] || 0, X[5] || 0, X[6] || 0, ae);
                        }
                    }
                    return new Date(A);
                }(R), this.init();
            }, k.init = function() {
                var R = this.$d;
                this.$y = R.getFullYear(), this.$M = R.getMonth(), this.$D = R.getDate(), this.$W = R.getDay(), this.$H = R.getHours(), this.$m = R.getMinutes(), this.$s = R.getSeconds(), this.$ms = R.getMilliseconds();
            }, k.$utils = function() {
                return ne;
            }, k.isValid = function() {
                return this.$d.toString() !== C;
            }, k.isSame = function(R, F) {
                var A = ce(R);
                return this.startOf(F) <= A && A <= this.endOf(F);
            }, k.isAfter = function(R, F) {
                return ce(R) < this.startOf(F);
            }, k.isBefore = function(R, F) {
                return this.endOf(F) < ce(R);
            }, k.$g = function(R, F, A) {
                return ne.u(R) ? this[F] : this.set(A, R);
            }, k.unix = function() {
                return Math.floor(this.valueOf() / 1e3);
            }, k.valueOf = function() {
                return this.$d.getTime();
            }, k.startOf = function(R, F) {
                var A = this, K = !!ne.u(F) || F, X = ne.p(R), ie = function(H, fe) {
                    var ye = ne.w(A.$u ? Date.UTC(A.$y, fe, H) : new Date(A.$y, fe, H), A);
                    return K ? ye : ye.endOf(O);
                }, ae = function(H, fe) {
                    return ne.w(A.toDate()[H].apply(A.toDate("s"), (K ? [
                        0,
                        0,
                        0,
                        0
                    ] : [
                        23,
                        59,
                        59,
                        999
                    ]).slice(fe)), A);
                }, pe = this.$W, he = this.$M, ve = this.$D, Oe = "set" + (this.$u ? "UTC" : "");
                switch(X){
                    case _:
                        return K ? ie(1, 0) : ie(31, 11);
                    case P:
                        return K ? ie(1, he) : ie(0, he + 1);
                    case $:
                        var Ce = this.$locale().weekStart || 0, ke = (pe < Ce ? pe + 7 : pe) - Ce;
                        return ie(K ? ve - ke : ve + (6 - ke), he);
                    case O:
                    case M:
                        return ae(Oe + "Hours", 0);
                    case x:
                        return ae(Oe + "Minutes", 1);
                    case y:
                        return ae(Oe + "Seconds", 2);
                    case m:
                        return ae(Oe + "Milliseconds", 3);
                    default:
                        return this.clone();
                }
            }, k.endOf = function(R) {
                return this.startOf(R, !1);
            }, k.$set = function(R, F) {
                var A, K = ne.p(R), X = "set" + (this.$u ? "UTC" : ""), ie = (A = {}, A[O] = X + "Date", A[M] = X + "Date", A[P] = X + "Month", A[_] = X + "FullYear", A[x] = X + "Hours", A[y] = X + "Minutes", A[m] = X + "Seconds", A[v] = X + "Milliseconds", A)[K], ae = K === O ? this.$D + (F - this.$W) : F;
                if (K === P || K === _) {
                    var pe = this.clone().set(M, 1);
                    pe.$d[ie](ae), pe.init(), this.$d = pe.set(M, Math.min(this.$D, pe.daysInMonth())).$d;
                } else ie && this.$d[ie](ae);
                return this.init(), this;
            }, k.set = function(R, F) {
                return this.clone().$set(R, F);
            }, k.get = function(R) {
                return this[ne.p(R)]();
            }, k.add = function(R, F) {
                var A, K = this;
                R = Number(R);
                var X = ne.p(F), ie = function(he) {
                    var ve = ce(K);
                    return ne.w(ve.date(ve.date() + Math.round(he * R)), K);
                };
                if (X === P) return this.set(P, this.$M + R);
                if (X === _) return this.set(_, this.$y + R);
                if (X === O) return ie(1);
                if (X === $) return ie(7);
                var ae = (A = {}, A[y] = u, A[x] = f, A[m] = a, A)[X] || 1, pe = this.$d.getTime() + R * ae;
                return ne.w(pe, this);
            }, k.subtract = function(R, F) {
                return this.add(-1 * R, F);
            }, k.format = function(R) {
                var F = this, A = this.$locale();
                if (!this.isValid()) return A.invalidDate || C;
                var K = R || "YYYY-MM-DDTHH:mm:ssZ", X = ne.z(this), ie = this.$H, ae = this.$m, pe = this.$M, he = A.weekdays, ve = A.months, Oe = A.meridiem, Ce = function(fe, ye, _e, ze) {
                    return fe && (fe[ye] || fe(F, K)) || _e[ye].slice(0, ze);
                }, ke = function(fe) {
                    return ne.s(ie % 12 || 12, fe, "0");
                }, H = Oe || function(fe, ye, _e) {
                    var ze = fe < 12 ? "AM" : "PM";
                    return _e ? ze.toLowerCase() : ze;
                };
                return K.replace(N, function(fe, ye) {
                    return ye || function(_e) {
                        switch(_e){
                            case "YY":
                                return String(F.$y).slice(-2);
                            case "YYYY":
                                return ne.s(F.$y, 4, "0");
                            case "M":
                                return pe + 1;
                            case "MM":
                                return ne.s(pe + 1, 2, "0");
                            case "MMM":
                                return Ce(A.monthsShort, pe, ve, 3);
                            case "MMMM":
                                return Ce(ve, pe);
                            case "D":
                                return F.$D;
                            case "DD":
                                return ne.s(F.$D, 2, "0");
                            case "d":
                                return String(F.$W);
                            case "dd":
                                return Ce(A.weekdaysMin, F.$W, he, 2);
                            case "ddd":
                                return Ce(A.weekdaysShort, F.$W, he, 3);
                            case "dddd":
                                return he[F.$W];
                            case "H":
                                return String(ie);
                            case "HH":
                                return ne.s(ie, 2, "0");
                            case "h":
                                return ke(1);
                            case "hh":
                                return ke(2);
                            case "a":
                                return H(ie, ae, !0);
                            case "A":
                                return H(ie, ae, !1);
                            case "m":
                                return String(ae);
                            case "mm":
                                return ne.s(ae, 2, "0");
                            case "s":
                                return String(F.$s);
                            case "ss":
                                return ne.s(F.$s, 2, "0");
                            case "SSS":
                                return ne.s(F.$ms, 3, "0");
                            case "Z":
                                return X;
                        }
                        return null;
                    }(fe) || X.replace(":", "");
                });
            }, k.utcOffset = function() {
                return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
            }, k.diff = function(R, F, A) {
                var K, X = this, ie = ne.p(F), ae = ce(R), pe = (ae.utcOffset() - this.utcOffset()) * u, he = this - ae, ve = function() {
                    return ne.m(X, ae);
                };
                switch(ie){
                    case _:
                        K = ve() / 12;
                        break;
                    case P:
                        K = ve();
                        break;
                    case T:
                        K = ve() / 3;
                        break;
                    case $:
                        K = (he - pe) / 6048e5;
                        break;
                    case O:
                        K = (he - pe) / 864e5;
                        break;
                    case x:
                        K = he / f;
                        break;
                    case y:
                        K = he / u;
                        break;
                    case m:
                        K = he / a;
                        break;
                    default:
                        K = he;
                }
                return A ? K : ne.a(K);
            }, k.daysInMonth = function() {
                return this.endOf(P).$D;
            }, k.$locale = function() {
                return ue[this.$L];
            }, k.locale = function(R, F) {
                if (!R) return this.$L;
                var A = this.clone(), K = we(R, F, !0);
                return K && (A.$L = K), A;
            }, k.clone = function() {
                return ne.w(this.$d, this);
            }, k.toDate = function() {
                return new Date(this.valueOf());
            }, k.toJSON = function() {
                return this.isValid() ? this.toISOString() : null;
            }, k.toISOString = function() {
                return this.$d.toISOString();
            }, k.toString = function() {
                return this.$d.toUTCString();
            }, W;
        }(), Ee = de.prototype;
        return ce.prototype = Ee, [
            [
                "$ms",
                v
            ],
            [
                "$s",
                m
            ],
            [
                "$m",
                y
            ],
            [
                "$H",
                x
            ],
            [
                "$W",
                O
            ],
            [
                "$M",
                P
            ],
            [
                "$y",
                _
            ],
            [
                "$D",
                M
            ]
        ].forEach(function(W) {
            Ee[W[1]] = function(k) {
                return this.$g(k, W[0], W[1]);
            };
        }), ce.extend = function(W, k) {
            return W.$i || (W(k, de, ce), W.$i = !0), ce;
        }, ce.locale = we, ce.isDayjs = be, ce.unix = function(W) {
            return ce(1e3 * W);
        }, ce.en = ue[re], ce.Ls = ue, ce.p = {}, ce;
    });
})($402be0a702aa527c$var$xi);
var $402be0a702aa527c$var$xs = $402be0a702aa527c$var$xi.exports;
const $402be0a702aa527c$var$Me = /* @__PURE__ */ $402be0a702aa527c$var$Ze($402be0a702aa527c$var$xs);
var $402be0a702aa527c$var$Oi = {
    exports: {}
};
(function(s, i) {
    (function(a, u) {
        s.exports = u();
    })($402be0a702aa527c$var$We, function() {
        var a = "minute", u = /[+-]\d\d(?::?\d\d)?/g, f = /([+-]|\d\d)/g;
        return function(v, m, y) {
            var x = m.prototype;
            y.utc = function(C) {
                var z = {
                    date: C,
                    utc: !0,
                    args: arguments
                };
                return new m(z);
            }, x.utc = function(C) {
                var z = y(this.toDate(), {
                    locale: this.$L,
                    utc: !0
                });
                return C ? z.add(this.utcOffset(), a) : z;
            }, x.local = function() {
                return y(this.toDate(), {
                    locale: this.$L,
                    utc: !1
                });
            };
            var O = x.parse;
            x.parse = function(C) {
                C.utc && (this.$u = !0), this.$utils().u(C.$offset) || (this.$offset = C.$offset), O.call(this, C);
            };
            var $ = x.init;
            x.init = function() {
                if (this.$u) {
                    var C = this.$d;
                    this.$y = C.getUTCFullYear(), this.$M = C.getUTCMonth(), this.$D = C.getUTCDate(), this.$W = C.getUTCDay(), this.$H = C.getUTCHours(), this.$m = C.getUTCMinutes(), this.$s = C.getUTCSeconds(), this.$ms = C.getUTCMilliseconds();
                } else $.call(this);
            };
            var P = x.utcOffset;
            x.utcOffset = function(C, z) {
                var N = this.$utils().u;
                if (N(C)) return this.$u ? 0 : N(this.$offset) ? P.call(this) : this.$offset;
                if (typeof C == "string" && (C = function(re) {
                    re === void 0 && (re = "");
                    var ue = re.match(u);
                    if (!ue) return null;
                    var S = ("" + ue[0]).match(f) || [
                        "-",
                        0,
                        0
                    ], be = S[0], we = 60 * +S[1] + +S[2];
                    return we === 0 ? 0 : be === "+" ? we : -we;
                }(C), C === null)) return this;
                var G = Math.abs(C) <= 16 ? 60 * C : C, Q = this;
                if (z) return Q.$offset = G, Q.$u = C === 0, Q;
                if (C !== 0) {
                    var te = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                    (Q = this.local().add(G + te, a)).$offset = G, Q.$x.$localOffset = te;
                } else Q = this.utc();
                return Q;
            };
            var T = x.format;
            x.format = function(C) {
                var z = C || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
                return T.call(this, z);
            }, x.valueOf = function() {
                var C = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
                return this.$d.valueOf() - 6e4 * C;
            }, x.isUTC = function() {
                return !!this.$u;
            }, x.toISOString = function() {
                return this.toDate().toISOString();
            }, x.toString = function() {
                return this.toDate().toUTCString();
            };
            var _ = x.toDate;
            x.toDate = function(C) {
                return C === "s" && this.$offset ? y(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : _.call(this);
            };
            var M = x.diff;
            x.diff = function(C, z, N) {
                if (C && this.$u === C.$u) return M.call(this, C, z, N);
                var G = this.local(), Q = y(C).local();
                return M.call(G, Q, z, N);
            };
        };
    });
})($402be0a702aa527c$var$Oi);
var $402be0a702aa527c$var$Os = $402be0a702aa527c$var$Oi.exports;
const $402be0a702aa527c$var$Cs = /* @__PURE__ */ $402be0a702aa527c$var$Ze($402be0a702aa527c$var$Os);
function $402be0a702aa527c$var$_s() {
    this.__data__ = [], this.size = 0;
}
var $402be0a702aa527c$var$Ms = $402be0a702aa527c$var$_s;
function $402be0a702aa527c$var$Es(s, i) {
    return s === i || s !== s && i !== i;
}
var $402be0a702aa527c$var$Ci = $402be0a702aa527c$var$Es, $402be0a702aa527c$var$Is = $402be0a702aa527c$var$Ci;
function $402be0a702aa527c$var$Ps(s, i) {
    for(var a = s.length; a--;)if ($402be0a702aa527c$var$Is(s[a][0], i)) return a;
    return -1;
}
var $402be0a702aa527c$var$Yt = $402be0a702aa527c$var$Ps, $402be0a702aa527c$var$Ds = $402be0a702aa527c$var$Yt, $402be0a702aa527c$var$Rs = Array.prototype, $402be0a702aa527c$var$$s = $402be0a702aa527c$var$Rs.splice;
function $402be0a702aa527c$var$ks(s) {
    var i = this.__data__, a = $402be0a702aa527c$var$Ds(i, s);
    if (a < 0) return !1;
    var u = i.length - 1;
    return a == u ? i.pop() : $402be0a702aa527c$var$$s.call(i, a, 1), --this.size, !0;
}
var $402be0a702aa527c$var$zs = $402be0a702aa527c$var$ks, $402be0a702aa527c$var$js = $402be0a702aa527c$var$Yt;
function $402be0a702aa527c$var$As(s) {
    var i = this.__data__, a = $402be0a702aa527c$var$js(i, s);
    return a < 0 ? void 0 : i[a][1];
}
var $402be0a702aa527c$var$Ls = $402be0a702aa527c$var$As, $402be0a702aa527c$var$Hs = $402be0a702aa527c$var$Yt;
function $402be0a702aa527c$var$Ws(s) {
    return $402be0a702aa527c$var$Hs(this.__data__, s) > -1;
}
var $402be0a702aa527c$var$Fs = $402be0a702aa527c$var$Ws, $402be0a702aa527c$var$Us = $402be0a702aa527c$var$Yt;
function $402be0a702aa527c$var$Ns(s, i) {
    var a = this.__data__, u = $402be0a702aa527c$var$Us(a, s);
    return u < 0 ? (++this.size, a.push([
        s,
        i
    ])) : a[u][1] = i, this;
}
var $402be0a702aa527c$var$Ys = $402be0a702aa527c$var$Ns, $402be0a702aa527c$var$Gs = $402be0a702aa527c$var$Ms, $402be0a702aa527c$var$Ks = $402be0a702aa527c$var$zs, $402be0a702aa527c$var$Xs = $402be0a702aa527c$var$Ls, $402be0a702aa527c$var$Bs = $402be0a702aa527c$var$Fs, $402be0a702aa527c$var$Vs = $402be0a702aa527c$var$Ys;
function $402be0a702aa527c$var$Je(s) {
    var i = -1, a = s == null ? 0 : s.length;
    for(this.clear(); ++i < a;){
        var u = s[i];
        this.set(u[0], u[1]);
    }
}
$402be0a702aa527c$var$Je.prototype.clear = $402be0a702aa527c$var$Gs;
$402be0a702aa527c$var$Je.prototype.delete = $402be0a702aa527c$var$Ks;
$402be0a702aa527c$var$Je.prototype.get = $402be0a702aa527c$var$Xs;
$402be0a702aa527c$var$Je.prototype.has = $402be0a702aa527c$var$Bs;
$402be0a702aa527c$var$Je.prototype.set = $402be0a702aa527c$var$Vs;
var $402be0a702aa527c$var$Gt = $402be0a702aa527c$var$Je, $402be0a702aa527c$var$qs = $402be0a702aa527c$var$Gt;
function $402be0a702aa527c$var$Zs() {
    this.__data__ = new $402be0a702aa527c$var$qs(), this.size = 0;
}
var $402be0a702aa527c$var$Js = $402be0a702aa527c$var$Zs;
function $402be0a702aa527c$var$Qs(s) {
    var i = this.__data__, a = i.delete(s);
    return this.size = i.size, a;
}
var $402be0a702aa527c$var$ea = $402be0a702aa527c$var$Qs;
function $402be0a702aa527c$var$ta(s) {
    return this.__data__.get(s);
}
var $402be0a702aa527c$var$ra = $402be0a702aa527c$var$ta;
function $402be0a702aa527c$var$na(s) {
    return this.__data__.has(s);
}
var $402be0a702aa527c$var$ia = $402be0a702aa527c$var$na, $402be0a702aa527c$var$oa = typeof $402be0a702aa527c$var$We == "object" && $402be0a702aa527c$var$We && $402be0a702aa527c$var$We.Object === Object && $402be0a702aa527c$var$We, $402be0a702aa527c$var$_i = $402be0a702aa527c$var$oa, $402be0a702aa527c$var$sa = $402be0a702aa527c$var$_i, $402be0a702aa527c$var$aa = typeof self == "object" && self && self.Object === Object && self, $402be0a702aa527c$var$la = $402be0a702aa527c$var$sa || $402be0a702aa527c$var$aa || Function("return this")(), $402be0a702aa527c$var$$e = $402be0a702aa527c$var$la, $402be0a702aa527c$var$ca = $402be0a702aa527c$var$$e, $402be0a702aa527c$var$ua = $402be0a702aa527c$var$ca.Symbol, $402be0a702aa527c$var$kr = $402be0a702aa527c$var$ua, $402be0a702aa527c$var$Wn = $402be0a702aa527c$var$kr, $402be0a702aa527c$var$Mi = Object.prototype, $402be0a702aa527c$var$pa = $402be0a702aa527c$var$Mi.hasOwnProperty, $402be0a702aa527c$var$ha = $402be0a702aa527c$var$Mi.toString, $402be0a702aa527c$var$vt = $402be0a702aa527c$var$Wn ? $402be0a702aa527c$var$Wn.toStringTag : void 0;
function $402be0a702aa527c$var$da(s) {
    var i = $402be0a702aa527c$var$pa.call(s, $402be0a702aa527c$var$vt), a = s[$402be0a702aa527c$var$vt];
    try {
        s[$402be0a702aa527c$var$vt] = void 0;
        var u = !0;
    } catch  {}
    var f = $402be0a702aa527c$var$ha.call(s);
    return u && (i ? s[$402be0a702aa527c$var$vt] = a : delete s[$402be0a702aa527c$var$vt]), f;
}
var $402be0a702aa527c$var$fa = $402be0a702aa527c$var$da, $402be0a702aa527c$var$va = Object.prototype, $402be0a702aa527c$var$ga = $402be0a702aa527c$var$va.toString;
function $402be0a702aa527c$var$ma(s) {
    return $402be0a702aa527c$var$ga.call(s);
}
var $402be0a702aa527c$var$ba = $402be0a702aa527c$var$ma, $402be0a702aa527c$var$Fn = $402be0a702aa527c$var$kr, $402be0a702aa527c$var$ya = $402be0a702aa527c$var$fa, $402be0a702aa527c$var$Ta = $402be0a702aa527c$var$ba, $402be0a702aa527c$var$wa = "[object Null]", $402be0a702aa527c$var$Sa = "[object Undefined]", $402be0a702aa527c$var$Un = $402be0a702aa527c$var$Fn ? $402be0a702aa527c$var$Fn.toStringTag : void 0;
function $402be0a702aa527c$var$xa(s) {
    return s == null ? s === void 0 ? $402be0a702aa527c$var$Sa : $402be0a702aa527c$var$wa : $402be0a702aa527c$var$Un && $402be0a702aa527c$var$Un in Object(s) ? $402be0a702aa527c$var$ya(s) : $402be0a702aa527c$var$Ta(s);
}
var $402be0a702aa527c$var$Kt = $402be0a702aa527c$var$xa;
function $402be0a702aa527c$var$Oa(s) {
    var i = typeof s;
    return s != null && (i == "object" || i == "function");
}
var $402be0a702aa527c$var$Ei = $402be0a702aa527c$var$Oa, $402be0a702aa527c$var$Ca = $402be0a702aa527c$var$Kt, $402be0a702aa527c$var$_a = $402be0a702aa527c$var$Ei, $402be0a702aa527c$var$Ma = "[object AsyncFunction]", $402be0a702aa527c$var$Ea = "[object Function]", $402be0a702aa527c$var$Ia = "[object GeneratorFunction]", $402be0a702aa527c$var$Pa = "[object Proxy]";
function $402be0a702aa527c$var$Da(s) {
    if (!$402be0a702aa527c$var$_a(s)) return !1;
    var i = $402be0a702aa527c$var$Ca(s);
    return i == $402be0a702aa527c$var$Ea || i == $402be0a702aa527c$var$Ia || i == $402be0a702aa527c$var$Ma || i == $402be0a702aa527c$var$Pa;
}
var $402be0a702aa527c$var$Ii = $402be0a702aa527c$var$Da, $402be0a702aa527c$var$Ra = $402be0a702aa527c$var$$e, $402be0a702aa527c$var$$a = $402be0a702aa527c$var$Ra["__core-js_shared__"], $402be0a702aa527c$var$ka = $402be0a702aa527c$var$$a, $402be0a702aa527c$var$wr = $402be0a702aa527c$var$ka, $402be0a702aa527c$var$Nn = function() {
    var s = /[^.]+$/.exec($402be0a702aa527c$var$wr && $402be0a702aa527c$var$wr.keys && $402be0a702aa527c$var$wr.keys.IE_PROTO || "");
    return s ? "Symbol(src)_1." + s : "";
}();
function $402be0a702aa527c$var$za(s) {
    return !!$402be0a702aa527c$var$Nn && $402be0a702aa527c$var$Nn in s;
}
var $402be0a702aa527c$var$ja = $402be0a702aa527c$var$za, $402be0a702aa527c$var$Aa = Function.prototype, $402be0a702aa527c$var$La = $402be0a702aa527c$var$Aa.toString;
function $402be0a702aa527c$var$Ha(s) {
    if (s != null) {
        try {
            return $402be0a702aa527c$var$La.call(s);
        } catch  {}
        try {
            return s + "";
        } catch  {}
    }
    return "";
}
var $402be0a702aa527c$var$Pi = $402be0a702aa527c$var$Ha, $402be0a702aa527c$var$Wa = $402be0a702aa527c$var$Ii, $402be0a702aa527c$var$Fa = $402be0a702aa527c$var$ja, $402be0a702aa527c$var$Ua = $402be0a702aa527c$var$Ei, $402be0a702aa527c$var$Na = $402be0a702aa527c$var$Pi, $402be0a702aa527c$var$Ya = /[\\^$.*+?()[\]{}|]/g, $402be0a702aa527c$var$Ga = /^\[object .+?Constructor\]$/, $402be0a702aa527c$var$Ka = Function.prototype, $402be0a702aa527c$var$Xa = Object.prototype, $402be0a702aa527c$var$Ba = $402be0a702aa527c$var$Ka.toString, $402be0a702aa527c$var$Va = $402be0a702aa527c$var$Xa.hasOwnProperty, $402be0a702aa527c$var$qa = RegExp("^" + $402be0a702aa527c$var$Ba.call($402be0a702aa527c$var$Va).replace($402be0a702aa527c$var$Ya, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function $402be0a702aa527c$var$Za(s) {
    if (!$402be0a702aa527c$var$Ua(s) || $402be0a702aa527c$var$Fa(s)) return !1;
    var i = $402be0a702aa527c$var$Wa(s) ? $402be0a702aa527c$var$qa : $402be0a702aa527c$var$Ga;
    return i.test($402be0a702aa527c$var$Na(s));
}
var $402be0a702aa527c$var$Ja = $402be0a702aa527c$var$Za;
function $402be0a702aa527c$var$Qa(s, i) {
    return s == null ? void 0 : s[i];
}
var $402be0a702aa527c$var$el = $402be0a702aa527c$var$Qa, $402be0a702aa527c$var$tl = $402be0a702aa527c$var$Ja, $402be0a702aa527c$var$rl = $402be0a702aa527c$var$el;
function $402be0a702aa527c$var$nl(s, i) {
    var a = $402be0a702aa527c$var$rl(s, i);
    return $402be0a702aa527c$var$tl(a) ? a : void 0;
}
var $402be0a702aa527c$var$Qe = $402be0a702aa527c$var$nl, $402be0a702aa527c$var$il = $402be0a702aa527c$var$Qe, $402be0a702aa527c$var$ol = $402be0a702aa527c$var$$e, $402be0a702aa527c$var$sl = $402be0a702aa527c$var$il($402be0a702aa527c$var$ol, "Map"), $402be0a702aa527c$var$zr = $402be0a702aa527c$var$sl, $402be0a702aa527c$var$al = $402be0a702aa527c$var$Qe, $402be0a702aa527c$var$ll = $402be0a702aa527c$var$al(Object, "create"), $402be0a702aa527c$var$Xt = $402be0a702aa527c$var$ll, $402be0a702aa527c$var$Yn = $402be0a702aa527c$var$Xt;
function $402be0a702aa527c$var$cl() {
    this.__data__ = $402be0a702aa527c$var$Yn ? $402be0a702aa527c$var$Yn(null) : {}, this.size = 0;
}
var $402be0a702aa527c$var$ul = $402be0a702aa527c$var$cl;
function $402be0a702aa527c$var$pl(s) {
    var i = this.has(s) && delete this.__data__[s];
    return this.size -= i ? 1 : 0, i;
}
var $402be0a702aa527c$var$hl = $402be0a702aa527c$var$pl, $402be0a702aa527c$var$dl = $402be0a702aa527c$var$Xt, $402be0a702aa527c$var$fl = "__lodash_hash_undefined__", $402be0a702aa527c$var$vl = Object.prototype, $402be0a702aa527c$var$gl = $402be0a702aa527c$var$vl.hasOwnProperty;
function $402be0a702aa527c$var$ml(s) {
    var i = this.__data__;
    if ($402be0a702aa527c$var$dl) {
        var a = i[s];
        return a === $402be0a702aa527c$var$fl ? void 0 : a;
    }
    return $402be0a702aa527c$var$gl.call(i, s) ? i[s] : void 0;
}
var $402be0a702aa527c$var$bl = $402be0a702aa527c$var$ml, $402be0a702aa527c$var$yl = $402be0a702aa527c$var$Xt, $402be0a702aa527c$var$Tl = Object.prototype, $402be0a702aa527c$var$wl = $402be0a702aa527c$var$Tl.hasOwnProperty;
function $402be0a702aa527c$var$Sl(s) {
    var i = this.__data__;
    return $402be0a702aa527c$var$yl ? i[s] !== void 0 : $402be0a702aa527c$var$wl.call(i, s);
}
var $402be0a702aa527c$var$xl = $402be0a702aa527c$var$Sl, $402be0a702aa527c$var$Ol = $402be0a702aa527c$var$Xt, $402be0a702aa527c$var$Cl = "__lodash_hash_undefined__";
function $402be0a702aa527c$var$_l(s, i) {
    var a = this.__data__;
    return this.size += this.has(s) ? 0 : 1, a[s] = $402be0a702aa527c$var$Ol && i === void 0 ? $402be0a702aa527c$var$Cl : i, this;
}
var $402be0a702aa527c$var$Ml = $402be0a702aa527c$var$_l, $402be0a702aa527c$var$El = $402be0a702aa527c$var$ul, $402be0a702aa527c$var$Il = $402be0a702aa527c$var$hl, $402be0a702aa527c$var$Pl = $402be0a702aa527c$var$bl, $402be0a702aa527c$var$Dl = $402be0a702aa527c$var$xl, $402be0a702aa527c$var$Rl = $402be0a702aa527c$var$Ml;
function $402be0a702aa527c$var$et(s) {
    var i = -1, a = s == null ? 0 : s.length;
    for(this.clear(); ++i < a;){
        var u = s[i];
        this.set(u[0], u[1]);
    }
}
$402be0a702aa527c$var$et.prototype.clear = $402be0a702aa527c$var$El;
$402be0a702aa527c$var$et.prototype.delete = $402be0a702aa527c$var$Il;
$402be0a702aa527c$var$et.prototype.get = $402be0a702aa527c$var$Pl;
$402be0a702aa527c$var$et.prototype.has = $402be0a702aa527c$var$Dl;
$402be0a702aa527c$var$et.prototype.set = $402be0a702aa527c$var$Rl;
var $402be0a702aa527c$var$$l = $402be0a702aa527c$var$et, $402be0a702aa527c$var$Gn = $402be0a702aa527c$var$$l, $402be0a702aa527c$var$kl = $402be0a702aa527c$var$Gt, $402be0a702aa527c$var$zl = $402be0a702aa527c$var$zr;
function $402be0a702aa527c$var$jl() {
    this.size = 0, this.__data__ = {
        hash: new $402be0a702aa527c$var$Gn(),
        map: new ($402be0a702aa527c$var$zl || $402be0a702aa527c$var$kl)(),
        string: new $402be0a702aa527c$var$Gn()
    };
}
var $402be0a702aa527c$var$Al = $402be0a702aa527c$var$jl;
function $402be0a702aa527c$var$Ll(s) {
    var i = typeof s;
    return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? s !== "__proto__" : s === null;
}
var $402be0a702aa527c$var$Hl = $402be0a702aa527c$var$Ll, $402be0a702aa527c$var$Wl = $402be0a702aa527c$var$Hl;
function $402be0a702aa527c$var$Fl(s, i) {
    var a = s.__data__;
    return $402be0a702aa527c$var$Wl(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
}
var $402be0a702aa527c$var$Bt = $402be0a702aa527c$var$Fl, $402be0a702aa527c$var$Ul = $402be0a702aa527c$var$Bt;
function $402be0a702aa527c$var$Nl(s) {
    var i = $402be0a702aa527c$var$Ul(this, s).delete(s);
    return this.size -= i ? 1 : 0, i;
}
var $402be0a702aa527c$var$Yl = $402be0a702aa527c$var$Nl, $402be0a702aa527c$var$Gl = $402be0a702aa527c$var$Bt;
function $402be0a702aa527c$var$Kl(s) {
    return $402be0a702aa527c$var$Gl(this, s).get(s);
}
var $402be0a702aa527c$var$Xl = $402be0a702aa527c$var$Kl, $402be0a702aa527c$var$Bl = $402be0a702aa527c$var$Bt;
function $402be0a702aa527c$var$Vl(s) {
    return $402be0a702aa527c$var$Bl(this, s).has(s);
}
var $402be0a702aa527c$var$ql = $402be0a702aa527c$var$Vl, $402be0a702aa527c$var$Zl = $402be0a702aa527c$var$Bt;
function $402be0a702aa527c$var$Jl(s, i) {
    var a = $402be0a702aa527c$var$Zl(this, s), u = a.size;
    return a.set(s, i), this.size += a.size == u ? 0 : 1, this;
}
var $402be0a702aa527c$var$Ql = $402be0a702aa527c$var$Jl, $402be0a702aa527c$var$ec = $402be0a702aa527c$var$Al, $402be0a702aa527c$var$tc = $402be0a702aa527c$var$Yl, $402be0a702aa527c$var$rc = $402be0a702aa527c$var$Xl, $402be0a702aa527c$var$nc = $402be0a702aa527c$var$ql, $402be0a702aa527c$var$ic = $402be0a702aa527c$var$Ql;
function $402be0a702aa527c$var$tt(s) {
    var i = -1, a = s == null ? 0 : s.length;
    for(this.clear(); ++i < a;){
        var u = s[i];
        this.set(u[0], u[1]);
    }
}
$402be0a702aa527c$var$tt.prototype.clear = $402be0a702aa527c$var$ec;
$402be0a702aa527c$var$tt.prototype.delete = $402be0a702aa527c$var$tc;
$402be0a702aa527c$var$tt.prototype.get = $402be0a702aa527c$var$rc;
$402be0a702aa527c$var$tt.prototype.has = $402be0a702aa527c$var$nc;
$402be0a702aa527c$var$tt.prototype.set = $402be0a702aa527c$var$ic;
var $402be0a702aa527c$var$Di = $402be0a702aa527c$var$tt, $402be0a702aa527c$var$oc = $402be0a702aa527c$var$Gt, $402be0a702aa527c$var$sc = $402be0a702aa527c$var$zr, $402be0a702aa527c$var$ac = $402be0a702aa527c$var$Di, $402be0a702aa527c$var$lc = 200;
function $402be0a702aa527c$var$cc(s, i) {
    var a = this.__data__;
    if (a instanceof $402be0a702aa527c$var$oc) {
        var u = a.__data__;
        if (!$402be0a702aa527c$var$sc || u.length < $402be0a702aa527c$var$lc - 1) return u.push([
            s,
            i
        ]), this.size = ++a.size, this;
        a = this.__data__ = new $402be0a702aa527c$var$ac(u);
    }
    return a.set(s, i), this.size = a.size, this;
}
var $402be0a702aa527c$var$uc = $402be0a702aa527c$var$cc, $402be0a702aa527c$var$pc = $402be0a702aa527c$var$Gt, $402be0a702aa527c$var$hc = $402be0a702aa527c$var$Js, $402be0a702aa527c$var$dc = $402be0a702aa527c$var$ea, $402be0a702aa527c$var$fc = $402be0a702aa527c$var$ra, $402be0a702aa527c$var$vc = $402be0a702aa527c$var$ia, $402be0a702aa527c$var$gc = $402be0a702aa527c$var$uc;
function $402be0a702aa527c$var$rt(s) {
    var i = this.__data__ = new $402be0a702aa527c$var$pc(s);
    this.size = i.size;
}
$402be0a702aa527c$var$rt.prototype.clear = $402be0a702aa527c$var$hc;
$402be0a702aa527c$var$rt.prototype.delete = $402be0a702aa527c$var$dc;
$402be0a702aa527c$var$rt.prototype.get = $402be0a702aa527c$var$fc;
$402be0a702aa527c$var$rt.prototype.has = $402be0a702aa527c$var$vc;
$402be0a702aa527c$var$rt.prototype.set = $402be0a702aa527c$var$gc;
var $402be0a702aa527c$var$mc = $402be0a702aa527c$var$rt, $402be0a702aa527c$var$bc = "__lodash_hash_undefined__";
function $402be0a702aa527c$var$yc(s) {
    return this.__data__.set(s, $402be0a702aa527c$var$bc), this;
}
var $402be0a702aa527c$var$Tc = $402be0a702aa527c$var$yc;
function $402be0a702aa527c$var$wc(s) {
    return this.__data__.has(s);
}
var $402be0a702aa527c$var$Sc = $402be0a702aa527c$var$wc, $402be0a702aa527c$var$xc = $402be0a702aa527c$var$Di, $402be0a702aa527c$var$Oc = $402be0a702aa527c$var$Tc, $402be0a702aa527c$var$Cc = $402be0a702aa527c$var$Sc;
function $402be0a702aa527c$var$Ht(s) {
    var i = -1, a = s == null ? 0 : s.length;
    for(this.__data__ = new $402be0a702aa527c$var$xc(); ++i < a;)this.add(s[i]);
}
$402be0a702aa527c$var$Ht.prototype.add = $402be0a702aa527c$var$Ht.prototype.push = $402be0a702aa527c$var$Oc;
$402be0a702aa527c$var$Ht.prototype.has = $402be0a702aa527c$var$Cc;
var $402be0a702aa527c$var$_c = $402be0a702aa527c$var$Ht;
function $402be0a702aa527c$var$Mc(s, i) {
    for(var a = -1, u = s == null ? 0 : s.length; ++a < u;)if (i(s[a], a, s)) return !0;
    return !1;
}
var $402be0a702aa527c$var$Ec = $402be0a702aa527c$var$Mc;
function $402be0a702aa527c$var$Ic(s, i) {
    return s.has(i);
}
var $402be0a702aa527c$var$Pc = $402be0a702aa527c$var$Ic, $402be0a702aa527c$var$Dc = $402be0a702aa527c$var$_c, $402be0a702aa527c$var$Rc = $402be0a702aa527c$var$Ec, $402be0a702aa527c$var$$c = $402be0a702aa527c$var$Pc, $402be0a702aa527c$var$kc = 1, $402be0a702aa527c$var$zc = 2;
function $402be0a702aa527c$var$jc(s, i, a, u, f, v) {
    var m = a & $402be0a702aa527c$var$kc, y = s.length, x = i.length;
    if (y != x && !(m && x > y)) return !1;
    var O = v.get(s), $ = v.get(i);
    if (O && $) return O == i && $ == s;
    var P = -1, T = !0, _ = a & $402be0a702aa527c$var$zc ? new $402be0a702aa527c$var$Dc() : void 0;
    for(v.set(s, i), v.set(i, s); ++P < y;){
        var M = s[P], C = i[P];
        if (u) var z = m ? u(C, M, P, i, s, v) : u(M, C, P, s, i, v);
        if (z !== void 0) {
            if (z) continue;
            T = !1;
            break;
        }
        if (_) {
            if (!$402be0a702aa527c$var$Rc(i, function(N, G) {
                if (!$402be0a702aa527c$var$$c(_, G) && (M === N || f(M, N, a, u, v))) return _.push(G);
            })) {
                T = !1;
                break;
            }
        } else if (!(M === C || f(M, C, a, u, v))) {
            T = !1;
            break;
        }
    }
    return v.delete(s), v.delete(i), T;
}
var $402be0a702aa527c$var$Ri = $402be0a702aa527c$var$jc, $402be0a702aa527c$var$Ac = $402be0a702aa527c$var$$e, $402be0a702aa527c$var$Lc = $402be0a702aa527c$var$Ac.Uint8Array, $402be0a702aa527c$var$Hc = $402be0a702aa527c$var$Lc;
function $402be0a702aa527c$var$Wc(s) {
    var i = -1, a = Array(s.size);
    return s.forEach(function(u, f) {
        a[++i] = [
            f,
            u
        ];
    }), a;
}
var $402be0a702aa527c$var$Fc = $402be0a702aa527c$var$Wc;
function $402be0a702aa527c$var$Uc(s) {
    var i = -1, a = Array(s.size);
    return s.forEach(function(u) {
        a[++i] = u;
    }), a;
}
var $402be0a702aa527c$var$Nc = $402be0a702aa527c$var$Uc, $402be0a702aa527c$var$Kn = $402be0a702aa527c$var$kr, $402be0a702aa527c$var$Xn = $402be0a702aa527c$var$Hc, $402be0a702aa527c$var$Yc = $402be0a702aa527c$var$Ci, $402be0a702aa527c$var$Gc = $402be0a702aa527c$var$Ri, $402be0a702aa527c$var$Kc = $402be0a702aa527c$var$Fc, $402be0a702aa527c$var$Xc = $402be0a702aa527c$var$Nc, $402be0a702aa527c$var$Bc = 1, $402be0a702aa527c$var$Vc = 2, $402be0a702aa527c$var$qc = "[object Boolean]", $402be0a702aa527c$var$Zc = "[object Date]", $402be0a702aa527c$var$Jc = "[object Error]", $402be0a702aa527c$var$Qc = "[object Map]", $402be0a702aa527c$var$eu = "[object Number]", $402be0a702aa527c$var$tu = "[object RegExp]", $402be0a702aa527c$var$ru = "[object Set]", $402be0a702aa527c$var$nu = "[object String]", $402be0a702aa527c$var$iu = "[object Symbol]", $402be0a702aa527c$var$ou = "[object ArrayBuffer]", $402be0a702aa527c$var$su = "[object DataView]", $402be0a702aa527c$var$Bn = $402be0a702aa527c$var$Kn ? $402be0a702aa527c$var$Kn.prototype : void 0, $402be0a702aa527c$var$Sr = $402be0a702aa527c$var$Bn ? $402be0a702aa527c$var$Bn.valueOf : void 0;
function $402be0a702aa527c$var$au(s, i, a, u, f, v, m) {
    switch(a){
        case $402be0a702aa527c$var$su:
            if (s.byteLength != i.byteLength || s.byteOffset != i.byteOffset) return !1;
            s = s.buffer, i = i.buffer;
        case $402be0a702aa527c$var$ou:
            return !(s.byteLength != i.byteLength || !v(new $402be0a702aa527c$var$Xn(s), new $402be0a702aa527c$var$Xn(i)));
        case $402be0a702aa527c$var$qc:
        case $402be0a702aa527c$var$Zc:
        case $402be0a702aa527c$var$eu:
            return $402be0a702aa527c$var$Yc(+s, +i);
        case $402be0a702aa527c$var$Jc:
            return s.name == i.name && s.message == i.message;
        case $402be0a702aa527c$var$tu:
        case $402be0a702aa527c$var$nu:
            return s == i + "";
        case $402be0a702aa527c$var$Qc:
            var y = $402be0a702aa527c$var$Kc;
        case $402be0a702aa527c$var$ru:
            var x = u & $402be0a702aa527c$var$Bc;
            if (y || (y = $402be0a702aa527c$var$Xc), s.size != i.size && !x) return !1;
            var O = m.get(s);
            if (O) return O == i;
            u |= $402be0a702aa527c$var$Vc, m.set(s, i);
            var $ = $402be0a702aa527c$var$Gc(y(s), y(i), u, f, v, m);
            return m.delete(s), $;
        case $402be0a702aa527c$var$iu:
            if ($402be0a702aa527c$var$Sr) return $402be0a702aa527c$var$Sr.call(s) == $402be0a702aa527c$var$Sr.call(i);
    }
    return !1;
}
var $402be0a702aa527c$var$lu = $402be0a702aa527c$var$au;
function $402be0a702aa527c$var$cu(s, i) {
    for(var a = -1, u = i.length, f = s.length; ++a < u;)s[f + a] = i[a];
    return s;
}
var $402be0a702aa527c$var$uu = $402be0a702aa527c$var$cu, $402be0a702aa527c$var$pu = Array.isArray, $402be0a702aa527c$var$jr = $402be0a702aa527c$var$pu, $402be0a702aa527c$var$hu = $402be0a702aa527c$var$uu, $402be0a702aa527c$var$du = $402be0a702aa527c$var$jr;
function $402be0a702aa527c$var$fu(s, i, a) {
    var u = i(s);
    return $402be0a702aa527c$var$du(s) ? u : $402be0a702aa527c$var$hu(u, a(s));
}
var $402be0a702aa527c$var$vu = $402be0a702aa527c$var$fu;
function $402be0a702aa527c$var$gu(s, i) {
    for(var a = -1, u = s == null ? 0 : s.length, f = 0, v = []; ++a < u;){
        var m = s[a];
        i(m, a, s) && (v[f++] = m);
    }
    return v;
}
var $402be0a702aa527c$var$mu = $402be0a702aa527c$var$gu;
function $402be0a702aa527c$var$bu() {
    return [];
}
var $402be0a702aa527c$var$yu = $402be0a702aa527c$var$bu, $402be0a702aa527c$var$Tu = $402be0a702aa527c$var$mu, $402be0a702aa527c$var$wu = $402be0a702aa527c$var$yu, $402be0a702aa527c$var$Su = Object.prototype, $402be0a702aa527c$var$xu = $402be0a702aa527c$var$Su.propertyIsEnumerable, $402be0a702aa527c$var$Vn = Object.getOwnPropertySymbols, $402be0a702aa527c$var$Ou = $402be0a702aa527c$var$Vn ? function(s) {
    return s == null ? [] : (s = Object(s), $402be0a702aa527c$var$Tu($402be0a702aa527c$var$Vn(s), function(i) {
        return $402be0a702aa527c$var$xu.call(s, i);
    }));
} : $402be0a702aa527c$var$wu, $402be0a702aa527c$var$Cu = $402be0a702aa527c$var$Ou;
function $402be0a702aa527c$var$_u(s, i) {
    for(var a = -1, u = Array(s); ++a < s;)u[a] = i(a);
    return u;
}
var $402be0a702aa527c$var$Mu = $402be0a702aa527c$var$_u;
function $402be0a702aa527c$var$Eu(s) {
    return s != null && typeof s == "object";
}
var $402be0a702aa527c$var$Vt = $402be0a702aa527c$var$Eu, $402be0a702aa527c$var$Iu = $402be0a702aa527c$var$Kt, $402be0a702aa527c$var$Pu = $402be0a702aa527c$var$Vt, $402be0a702aa527c$var$Du = "[object Arguments]";
function $402be0a702aa527c$var$Ru(s) {
    return $402be0a702aa527c$var$Pu(s) && $402be0a702aa527c$var$Iu(s) == $402be0a702aa527c$var$Du;
}
var $402be0a702aa527c$var$$u = $402be0a702aa527c$var$Ru, $402be0a702aa527c$var$qn = $402be0a702aa527c$var$$u, $402be0a702aa527c$var$ku = $402be0a702aa527c$var$Vt, $402be0a702aa527c$var$$i = Object.prototype, $402be0a702aa527c$var$zu = $402be0a702aa527c$var$$i.hasOwnProperty, $402be0a702aa527c$var$ju = $402be0a702aa527c$var$$i.propertyIsEnumerable, $402be0a702aa527c$var$Au = $402be0a702aa527c$var$qn(/* @__PURE__ */ function() {
    return arguments;
}()) ? $402be0a702aa527c$var$qn : function(s) {
    return $402be0a702aa527c$var$ku(s) && $402be0a702aa527c$var$zu.call(s, "callee") && !$402be0a702aa527c$var$ju.call(s, "callee");
}, $402be0a702aa527c$var$Lu = $402be0a702aa527c$var$Au, $402be0a702aa527c$var$Wt = {
    exports: {}
};
function $402be0a702aa527c$var$Hu() {
    return !1;
}
var $402be0a702aa527c$var$Wu = $402be0a702aa527c$var$Hu;
$402be0a702aa527c$var$Wt.exports;
(function(s, i) {
    var a = $402be0a702aa527c$var$$e, u = $402be0a702aa527c$var$Wu, f = i && !i.nodeType && i, v = f && !0 && s && !s.nodeType && s, m = v && v.exports === f, y = m ? a.Buffer : void 0, x = y ? y.isBuffer : void 0, O = x || u;
    s.exports = O;
})($402be0a702aa527c$var$Wt, $402be0a702aa527c$var$Wt.exports);
var $402be0a702aa527c$var$ki = $402be0a702aa527c$var$Wt.exports, $402be0a702aa527c$var$Fu = 9007199254740991, $402be0a702aa527c$var$Uu = /^(?:0|[1-9]\d*)$/;
function $402be0a702aa527c$var$Nu(s, i) {
    var a = typeof s;
    return i = i ?? $402be0a702aa527c$var$Fu, !!i && (a == "number" || a != "symbol" && $402be0a702aa527c$var$Uu.test(s)) && s > -1 && s % 1 == 0 && s < i;
}
var $402be0a702aa527c$var$Yu = $402be0a702aa527c$var$Nu, $402be0a702aa527c$var$Gu = 9007199254740991;
function $402be0a702aa527c$var$Ku(s) {
    return typeof s == "number" && s > -1 && s % 1 == 0 && s <= $402be0a702aa527c$var$Gu;
}
var $402be0a702aa527c$var$zi = $402be0a702aa527c$var$Ku, $402be0a702aa527c$var$Xu = $402be0a702aa527c$var$Kt, $402be0a702aa527c$var$Bu = $402be0a702aa527c$var$zi, $402be0a702aa527c$var$Vu = $402be0a702aa527c$var$Vt, $402be0a702aa527c$var$qu = "[object Arguments]", $402be0a702aa527c$var$Zu = "[object Array]", $402be0a702aa527c$var$Ju = "[object Boolean]", $402be0a702aa527c$var$Qu = "[object Date]", $402be0a702aa527c$var$ep = "[object Error]", $402be0a702aa527c$var$tp = "[object Function]", $402be0a702aa527c$var$rp = "[object Map]", $402be0a702aa527c$var$np = "[object Number]", $402be0a702aa527c$var$ip = "[object Object]", $402be0a702aa527c$var$op = "[object RegExp]", $402be0a702aa527c$var$sp = "[object Set]", $402be0a702aa527c$var$ap = "[object String]", $402be0a702aa527c$var$lp = "[object WeakMap]", $402be0a702aa527c$var$cp = "[object ArrayBuffer]", $402be0a702aa527c$var$up = "[object DataView]", $402be0a702aa527c$var$pp = "[object Float32Array]", $402be0a702aa527c$var$hp = "[object Float64Array]", $402be0a702aa527c$var$dp = "[object Int8Array]", $402be0a702aa527c$var$fp = "[object Int16Array]", $402be0a702aa527c$var$vp = "[object Int32Array]", $402be0a702aa527c$var$gp = "[object Uint8Array]", $402be0a702aa527c$var$mp = "[object Uint8ClampedArray]", $402be0a702aa527c$var$bp = "[object Uint16Array]", $402be0a702aa527c$var$yp = "[object Uint32Array]", $402be0a702aa527c$var$oe = {};
$402be0a702aa527c$var$oe[$402be0a702aa527c$var$pp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$hp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$dp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$fp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$vp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$gp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$mp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$bp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$yp] = !0;
$402be0a702aa527c$var$oe[$402be0a702aa527c$var$qu] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$Zu] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$cp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$Ju] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$up] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$Qu] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$ep] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$tp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$rp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$np] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$ip] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$op] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$sp] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$ap] = $402be0a702aa527c$var$oe[$402be0a702aa527c$var$lp] = !1;
function $402be0a702aa527c$var$Tp(s) {
    return $402be0a702aa527c$var$Vu(s) && $402be0a702aa527c$var$Bu(s.length) && !!$402be0a702aa527c$var$oe[$402be0a702aa527c$var$Xu(s)];
}
var $402be0a702aa527c$var$wp = $402be0a702aa527c$var$Tp;
function $402be0a702aa527c$var$Sp(s) {
    return function(i) {
        return s(i);
    };
}
var $402be0a702aa527c$var$xp = $402be0a702aa527c$var$Sp, $402be0a702aa527c$var$Ft = {
    exports: {}
};
$402be0a702aa527c$var$Ft.exports;
(function(s, i) {
    var a = $402be0a702aa527c$var$_i, u = i && !i.nodeType && i, f = u && !0 && s && !s.nodeType && s, v = f && f.exports === u, m = v && a.process, y = function() {
        try {
            var x = f && f.require && f.require("util").types;
            return x || m && m.binding && m.binding("util");
        } catch  {}
    }();
    s.exports = y;
})($402be0a702aa527c$var$Ft, $402be0a702aa527c$var$Ft.exports);
var $402be0a702aa527c$var$Op = $402be0a702aa527c$var$Ft.exports, $402be0a702aa527c$var$Cp = $402be0a702aa527c$var$wp, $402be0a702aa527c$var$_p = $402be0a702aa527c$var$xp, $402be0a702aa527c$var$Zn = $402be0a702aa527c$var$Op, $402be0a702aa527c$var$Jn = $402be0a702aa527c$var$Zn && $402be0a702aa527c$var$Zn.isTypedArray, $402be0a702aa527c$var$Mp = $402be0a702aa527c$var$Jn ? $402be0a702aa527c$var$_p($402be0a702aa527c$var$Jn) : $402be0a702aa527c$var$Cp, $402be0a702aa527c$var$ji = $402be0a702aa527c$var$Mp, $402be0a702aa527c$var$Ep = $402be0a702aa527c$var$Mu, $402be0a702aa527c$var$Ip = $402be0a702aa527c$var$Lu, $402be0a702aa527c$var$Pp = $402be0a702aa527c$var$jr, $402be0a702aa527c$var$Dp = $402be0a702aa527c$var$ki, $402be0a702aa527c$var$Rp = $402be0a702aa527c$var$Yu, $402be0a702aa527c$var$$p = $402be0a702aa527c$var$ji, $402be0a702aa527c$var$kp = Object.prototype, $402be0a702aa527c$var$zp = $402be0a702aa527c$var$kp.hasOwnProperty;
function $402be0a702aa527c$var$jp(s, i) {
    var a = $402be0a702aa527c$var$Pp(s), u = !a && $402be0a702aa527c$var$Ip(s), f = !a && !u && $402be0a702aa527c$var$Dp(s), v = !a && !u && !f && $402be0a702aa527c$var$$p(s), m = a || u || f || v, y = m ? $402be0a702aa527c$var$Ep(s.length, String) : [], x = y.length;
    for(var O in s)(i || $402be0a702aa527c$var$zp.call(s, O)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
    (O == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    f && (O == "offset" || O == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    v && (O == "buffer" || O == "byteLength" || O == "byteOffset") || // Skip index properties.
    $402be0a702aa527c$var$Rp(O, x))) && y.push(O);
    return y;
}
var $402be0a702aa527c$var$Ap = $402be0a702aa527c$var$jp, $402be0a702aa527c$var$Lp = Object.prototype;
function $402be0a702aa527c$var$Hp(s) {
    var i = s && s.constructor, a = typeof i == "function" && i.prototype || $402be0a702aa527c$var$Lp;
    return s === a;
}
var $402be0a702aa527c$var$Wp = $402be0a702aa527c$var$Hp;
function $402be0a702aa527c$var$Fp(s, i) {
    return function(a) {
        return s(i(a));
    };
}
var $402be0a702aa527c$var$Up = $402be0a702aa527c$var$Fp, $402be0a702aa527c$var$Np = $402be0a702aa527c$var$Up, $402be0a702aa527c$var$Yp = $402be0a702aa527c$var$Np(Object.keys, Object), $402be0a702aa527c$var$Gp = $402be0a702aa527c$var$Yp, $402be0a702aa527c$var$Kp = $402be0a702aa527c$var$Wp, $402be0a702aa527c$var$Xp = $402be0a702aa527c$var$Gp, $402be0a702aa527c$var$Bp = Object.prototype, $402be0a702aa527c$var$Vp = $402be0a702aa527c$var$Bp.hasOwnProperty;
function $402be0a702aa527c$var$qp(s) {
    if (!$402be0a702aa527c$var$Kp(s)) return $402be0a702aa527c$var$Xp(s);
    var i = [];
    for(var a in Object(s))$402be0a702aa527c$var$Vp.call(s, a) && a != "constructor" && i.push(a);
    return i;
}
var $402be0a702aa527c$var$Zp = $402be0a702aa527c$var$qp, $402be0a702aa527c$var$Jp = $402be0a702aa527c$var$Ii, $402be0a702aa527c$var$Qp = $402be0a702aa527c$var$zi;
function $402be0a702aa527c$var$eh(s) {
    return s != null && $402be0a702aa527c$var$Qp(s.length) && !$402be0a702aa527c$var$Jp(s);
}
var $402be0a702aa527c$var$th = $402be0a702aa527c$var$eh, $402be0a702aa527c$var$rh = $402be0a702aa527c$var$Ap, $402be0a702aa527c$var$nh = $402be0a702aa527c$var$Zp, $402be0a702aa527c$var$ih = $402be0a702aa527c$var$th;
function $402be0a702aa527c$var$oh(s) {
    return $402be0a702aa527c$var$ih(s) ? $402be0a702aa527c$var$rh(s) : $402be0a702aa527c$var$nh(s);
}
var $402be0a702aa527c$var$sh = $402be0a702aa527c$var$oh, $402be0a702aa527c$var$ah = $402be0a702aa527c$var$vu, $402be0a702aa527c$var$lh = $402be0a702aa527c$var$Cu, $402be0a702aa527c$var$ch = $402be0a702aa527c$var$sh;
function $402be0a702aa527c$var$uh(s) {
    return $402be0a702aa527c$var$ah(s, $402be0a702aa527c$var$ch, $402be0a702aa527c$var$lh);
}
var $402be0a702aa527c$var$ph = $402be0a702aa527c$var$uh, $402be0a702aa527c$var$Qn = $402be0a702aa527c$var$ph, $402be0a702aa527c$var$hh = 1, $402be0a702aa527c$var$dh = Object.prototype, $402be0a702aa527c$var$fh = $402be0a702aa527c$var$dh.hasOwnProperty;
function $402be0a702aa527c$var$vh(s, i, a, u, f, v) {
    var m = a & $402be0a702aa527c$var$hh, y = $402be0a702aa527c$var$Qn(s), x = y.length, O = $402be0a702aa527c$var$Qn(i), $ = O.length;
    if (x != $ && !m) return !1;
    for(var P = x; P--;){
        var T = y[P];
        if (!(m ? T in i : $402be0a702aa527c$var$fh.call(i, T))) return !1;
    }
    var _ = v.get(s), M = v.get(i);
    if (_ && M) return _ == i && M == s;
    var C = !0;
    v.set(s, i), v.set(i, s);
    for(var z = m; ++P < x;){
        T = y[P];
        var N = s[T], G = i[T];
        if (u) var Q = m ? u(G, N, T, i, s, v) : u(N, G, T, s, i, v);
        if (!(Q === void 0 ? N === G || f(N, G, a, u, v) : Q)) {
            C = !1;
            break;
        }
        z || (z = T == "constructor");
    }
    if (C && !z) {
        var te = s.constructor, re = i.constructor;
        te != re && "constructor" in s && "constructor" in i && !(typeof te == "function" && te instanceof te && typeof re == "function" && re instanceof re) && (C = !1);
    }
    return v.delete(s), v.delete(i), C;
}
var $402be0a702aa527c$var$gh = $402be0a702aa527c$var$vh, $402be0a702aa527c$var$mh = $402be0a702aa527c$var$Qe, $402be0a702aa527c$var$bh = $402be0a702aa527c$var$$e, $402be0a702aa527c$var$yh = $402be0a702aa527c$var$mh($402be0a702aa527c$var$bh, "DataView"), $402be0a702aa527c$var$Th = $402be0a702aa527c$var$yh, $402be0a702aa527c$var$wh = $402be0a702aa527c$var$Qe, $402be0a702aa527c$var$Sh = $402be0a702aa527c$var$$e, $402be0a702aa527c$var$xh = $402be0a702aa527c$var$wh($402be0a702aa527c$var$Sh, "Promise"), $402be0a702aa527c$var$Oh = $402be0a702aa527c$var$xh, $402be0a702aa527c$var$Ch = $402be0a702aa527c$var$Qe, $402be0a702aa527c$var$_h = $402be0a702aa527c$var$$e, $402be0a702aa527c$var$Mh = $402be0a702aa527c$var$Ch($402be0a702aa527c$var$_h, "Set"), $402be0a702aa527c$var$Eh = $402be0a702aa527c$var$Mh, $402be0a702aa527c$var$Ih = $402be0a702aa527c$var$Qe, $402be0a702aa527c$var$Ph = $402be0a702aa527c$var$$e, $402be0a702aa527c$var$Dh = $402be0a702aa527c$var$Ih($402be0a702aa527c$var$Ph, "WeakMap"), $402be0a702aa527c$var$Rh = $402be0a702aa527c$var$Dh, $402be0a702aa527c$var$Or = $402be0a702aa527c$var$Th, $402be0a702aa527c$var$Cr = $402be0a702aa527c$var$zr, $402be0a702aa527c$var$_r = $402be0a702aa527c$var$Oh, $402be0a702aa527c$var$Mr = $402be0a702aa527c$var$Eh, $402be0a702aa527c$var$Er = $402be0a702aa527c$var$Rh, $402be0a702aa527c$var$Ai = $402be0a702aa527c$var$Kt, $402be0a702aa527c$var$nt = $402be0a702aa527c$var$Pi, $402be0a702aa527c$var$ei = "[object Map]", $402be0a702aa527c$var$$h = "[object Object]", $402be0a702aa527c$var$ti = "[object Promise]", $402be0a702aa527c$var$ri = "[object Set]", $402be0a702aa527c$var$ni = "[object WeakMap]", $402be0a702aa527c$var$ii = "[object DataView]", $402be0a702aa527c$var$kh = $402be0a702aa527c$var$nt($402be0a702aa527c$var$Or), $402be0a702aa527c$var$zh = $402be0a702aa527c$var$nt($402be0a702aa527c$var$Cr), $402be0a702aa527c$var$jh = $402be0a702aa527c$var$nt($402be0a702aa527c$var$_r), $402be0a702aa527c$var$Ah = $402be0a702aa527c$var$nt($402be0a702aa527c$var$Mr), $402be0a702aa527c$var$Lh = $402be0a702aa527c$var$nt($402be0a702aa527c$var$Er), $402be0a702aa527c$var$Ge = $402be0a702aa527c$var$Ai;
($402be0a702aa527c$var$Or && $402be0a702aa527c$var$Ge(new $402be0a702aa527c$var$Or(new ArrayBuffer(1))) != $402be0a702aa527c$var$ii || $402be0a702aa527c$var$Cr && $402be0a702aa527c$var$Ge(new $402be0a702aa527c$var$Cr()) != $402be0a702aa527c$var$ei || $402be0a702aa527c$var$_r && $402be0a702aa527c$var$Ge($402be0a702aa527c$var$_r.resolve()) != $402be0a702aa527c$var$ti || $402be0a702aa527c$var$Mr && $402be0a702aa527c$var$Ge(new $402be0a702aa527c$var$Mr()) != $402be0a702aa527c$var$ri || $402be0a702aa527c$var$Er && $402be0a702aa527c$var$Ge(new $402be0a702aa527c$var$Er()) != $402be0a702aa527c$var$ni) && ($402be0a702aa527c$var$Ge = function(s) {
    var i = $402be0a702aa527c$var$Ai(s), a = i == $402be0a702aa527c$var$$h ? s.constructor : void 0, u = a ? $402be0a702aa527c$var$nt(a) : "";
    if (u) switch(u){
        case $402be0a702aa527c$var$kh:
            return $402be0a702aa527c$var$ii;
        case $402be0a702aa527c$var$zh:
            return $402be0a702aa527c$var$ei;
        case $402be0a702aa527c$var$jh:
            return $402be0a702aa527c$var$ti;
        case $402be0a702aa527c$var$Ah:
            return $402be0a702aa527c$var$ri;
        case $402be0a702aa527c$var$Lh:
            return $402be0a702aa527c$var$ni;
    }
    return i;
});
var $402be0a702aa527c$var$Hh = $402be0a702aa527c$var$Ge, $402be0a702aa527c$var$xr = $402be0a702aa527c$var$mc, $402be0a702aa527c$var$Wh = $402be0a702aa527c$var$Ri, $402be0a702aa527c$var$Fh = $402be0a702aa527c$var$lu, $402be0a702aa527c$var$Uh = $402be0a702aa527c$var$gh, $402be0a702aa527c$var$oi = $402be0a702aa527c$var$Hh, $402be0a702aa527c$var$si = $402be0a702aa527c$var$jr, $402be0a702aa527c$var$ai = $402be0a702aa527c$var$ki, $402be0a702aa527c$var$Nh = $402be0a702aa527c$var$ji, $402be0a702aa527c$var$Yh = 1, $402be0a702aa527c$var$li = "[object Arguments]", $402be0a702aa527c$var$ci = "[object Array]", $402be0a702aa527c$var$Dt = "[object Object]", $402be0a702aa527c$var$Gh = Object.prototype, $402be0a702aa527c$var$ui = $402be0a702aa527c$var$Gh.hasOwnProperty;
function $402be0a702aa527c$var$Kh(s, i, a, u, f, v) {
    var m = $402be0a702aa527c$var$si(s), y = $402be0a702aa527c$var$si(i), x = m ? $402be0a702aa527c$var$ci : $402be0a702aa527c$var$oi(s), O = y ? $402be0a702aa527c$var$ci : $402be0a702aa527c$var$oi(i);
    x = x == $402be0a702aa527c$var$li ? $402be0a702aa527c$var$Dt : x, O = O == $402be0a702aa527c$var$li ? $402be0a702aa527c$var$Dt : O;
    var $ = x == $402be0a702aa527c$var$Dt, P = O == $402be0a702aa527c$var$Dt, T = x == O;
    if (T && $402be0a702aa527c$var$ai(s)) {
        if (!$402be0a702aa527c$var$ai(i)) return !1;
        m = !0, $ = !1;
    }
    if (T && !$) return v || (v = new $402be0a702aa527c$var$xr()), m || $402be0a702aa527c$var$Nh(s) ? $402be0a702aa527c$var$Wh(s, i, a, u, f, v) : $402be0a702aa527c$var$Fh(s, i, x, a, u, f, v);
    if (!(a & $402be0a702aa527c$var$Yh)) {
        var _ = $ && $402be0a702aa527c$var$ui.call(s, "__wrapped__"), M = P && $402be0a702aa527c$var$ui.call(i, "__wrapped__");
        if (_ || M) {
            var C = _ ? s.value() : s, z = M ? i.value() : i;
            return v || (v = new $402be0a702aa527c$var$xr()), f(C, z, a, u, v);
        }
    }
    return T ? (v || (v = new $402be0a702aa527c$var$xr()), $402be0a702aa527c$var$Uh(s, i, a, u, f, v)) : !1;
}
var $402be0a702aa527c$var$Xh = $402be0a702aa527c$var$Kh, $402be0a702aa527c$var$Bh = $402be0a702aa527c$var$Xh, $402be0a702aa527c$var$pi = $402be0a702aa527c$var$Vt;
function $402be0a702aa527c$var$Li(s, i, a, u, f) {
    return s === i ? !0 : s == null || i == null || !$402be0a702aa527c$var$pi(s) && !$402be0a702aa527c$var$pi(i) ? s !== s && i !== i : $402be0a702aa527c$var$Bh(s, i, a, u, $402be0a702aa527c$var$Li, f);
}
var $402be0a702aa527c$var$Vh = $402be0a702aa527c$var$Li, $402be0a702aa527c$var$qh = $402be0a702aa527c$var$Vh;
function $402be0a702aa527c$var$Zh(s, i) {
    return $402be0a702aa527c$var$qh(s, i);
}
var $402be0a702aa527c$var$Jh = $402be0a702aa527c$var$Zh;
const $402be0a702aa527c$var$Ir = /* @__PURE__ */ $402be0a702aa527c$var$Ze($402be0a702aa527c$var$Jh);
function $402be0a702aa527c$var$J(s, i) {
    return typeof s.get == "function" ? s.get(i) : s[i];
}
function $402be0a702aa527c$var$hi(s) {
    return typeof s.count == "function" ? s.count() : s.length;
}
function $402be0a702aa527c$var$gt(s, i) {
    return $402be0a702aa527c$var$hi(s) === $402be0a702aa527c$var$hi(i) && s.every((a, u)=>a === $402be0a702aa527c$var$J(i, u.toString()));
}
function $402be0a702aa527c$var$Qh(s, i) {
    const a = {};
    return s.forEach((u)=>{
        a[u[i]] = u;
    }), a;
}
function $402be0a702aa527c$var$$t() {}
function $402be0a702aa527c$var$Ke(...s) {
    return (i, ...a)=>{
        i.preventDefault(), s.forEach((u)=>u && u(i, ...a));
    };
}
function $402be0a702aa527c$var$Hi({ item: s, itemContext: i, getItemProps: a, getResizeProps: u }) {
    const { left: f, right: v } = u(), { key: m, ref: y, ...x } = a(s.itemProps ?? {}), { useResizeHandle: O } = i;
    return (0, $acw62.createElement)("div", {
        ...x,
        ref: y,
        key: `${m}-outer`
    }, O ? (0, $acw62.createElement)("div", {
        ...f,
        key: `${m}-lr`
    }) : null, (0, $ayMG0.jsx)("div", {
        className: "rct-item-content",
        style: {
            maxHeight: `${i.dimensions.height}`
        },
        children: i.title
    }, `${m}-content`), O ? (0, $acw62.createElement)("div", {
        ...v,
        key: `${m}-rr`
    }) : null);
}
function $402be0a702aa527c$var$Ut(s, i, a) {
    return (i - s) / a;
}
function $402be0a702aa527c$var$Nt(s, i, a, u) {
    const f = a / (i - s);
    return (u - s) * f;
}
function $402be0a702aa527c$var$Ar(s, i, a, u) {
    return (i - s) / a * u + s;
}
function $402be0a702aa527c$var$Lr(s, i, a, u, f) {
    let v = $402be0a702aa527c$var$Me(s).startOf(a);
    if (u[a] && u[a] > 1) {
        const m = v.get(a);
        v = v.set(a, m - m % u[a]);
    }
    for(; v.valueOf() < i;){
        const m = $402be0a702aa527c$var$Me(v).add(u[a] || 1, a).startOf(a);
        f(v, m), v = m;
    }
}
const $402be0a702aa527c$var$Pr = 17;
function $402be0a702aa527c$var$kt(s, i, a) {
    const u = {
        second: 1e3,
        minute: 60,
        hour: 60,
        day: 24,
        month: 30,
        year: 12
    };
    let f = "year", v = s;
    return Object.keys(u).some((m)=>{
        const y = m;
        v = v / u[y];
        const x = v / a[y], O = a[y] && a[y] > 1 ? 3 * $402be0a702aa527c$var$Pr : $402be0a702aa527c$var$Pr, $ = i / O;
        if (x < $) return f = m, !0;
    }), f;
}
const $402be0a702aa527c$var$Dr = {
    second: "minute",
    minute: "hour",
    hour: "day",
    day: "month",
    month: "year",
    year: "year"
};
function $402be0a702aa527c$var$Hr(s) {
    if (!$402be0a702aa527c$var$Dr[s]) throw new Error(`unit ${s} is not acceptable`);
    return $402be0a702aa527c$var$Dr[s];
}
function $402be0a702aa527c$var$Wi({ itemTimeStart: s, itemTimeEnd: i, dragTime: a, isDragging: u, isResizing: f, resizingEdge: v, resizeTime: m }) {
    const y = i - s;
    return [
        u && a ? a : f && v === "left" && m ? m : s,
        u && a ? a + y : f && v === "right" && m ? m : i
    ];
}
function $402be0a702aa527c$var$Fi({ itemTimeStart: s, itemTimeEnd: i, canvasTimeStart: a, canvasTimeEnd: u, canvasWidth: f }) {
    const v = i - s, m = Math.max(s, a), y = Math.min(i, u), x = $402be0a702aa527c$var$Nt(a, u, f, m), $ = $402be0a702aa527c$var$Nt(a, u, f, y) - x;
    return {
        left: x,
        width: Math.max($, 3),
        collisionLeft: s,
        collisionWidth: v
    };
}
function $402be0a702aa527c$var$Wr(s, i) {
    const { groupIdKey: a } = i, u = {};
    for(let f = 0; f < s.length; f++)u[$402be0a702aa527c$var$J(s[f], a)] = {
        index: f,
        group: s[f]
    };
    return u;
}
function $402be0a702aa527c$var$Ui(s, i) {
    var f, v;
    const a = {}, u = Object.keys(i);
    for(let m = 0; m < u.length; m++){
        const y = i[u[m]];
        a[m] = {
            index: y.index,
            group: y.group,
            items: []
        };
    }
    for(let m = 0; m < s.length; m++)if (s[m].dimensions !== void 0 && ((f = s[m].dimensions) == null ? void 0 : f.order) !== void 0) {
        const y = a[((v = s[m].dimensions) == null ? void 0 : v.order.index) ?? 0];
        y && y.items.push(s[m]);
    }
    return a;
}
function $402be0a702aa527c$var$Fr(s, i, a, u) {
    const { itemTimeStartKey: f, itemTimeEndKey: v } = u;
    return s.filter((m)=>{
        const y = $402be0a702aa527c$var$Me($402be0a702aa527c$var$J(m, f)).valueOf() <= a, x = $402be0a702aa527c$var$Me($402be0a702aa527c$var$J(m, v)).valueOf() >= i;
        return y && x;
    });
}
const $402be0a702aa527c$var$ed = 1e-3;
function $402be0a702aa527c$var$Ni(s, i, a = $402be0a702aa527c$var$ed) {
    return s.collisionLeft + a < i.collisionLeft + i.collisionWidth && s.collisionLeft + s.collisionWidth - a > i.collisionLeft && s.top - 0 + a < i.top + i.height && s.top + s.height + 0 - a > i.top;
}
function $402be0a702aa527c$var$Yi(s, i, a, u, f, v) {
    let m = u;
    const y = (s - i.dimensions.height) / 2;
    if (i.dimensions.stack && i.dimensions.top === null) {
        i.dimensions.top = f + y, m = Math.max(m, s);
        do {
            var x = null;
            for(let O = v - 1, $ = 0; O >= $; O--){
                const P = a[O];
                if (P.dimensions.top !== null && P.dimensions.stack && $402be0a702aa527c$var$Ni(i.dimensions, P.dimensions)) {
                    x = P;
                    break;
                }
            }
            x != null && (i.dimensions.top = x.dimensions.top + s, m = Math.max(m, i.dimensions.top + i.dimensions.height + y - f));
        }while (x);
    }
    return {
        groupHeight: m,
        verticalMargin: y,
        itemTop: i.dimensions.top
    };
}
function $402be0a702aa527c$var$Gi(s, i, a, u) {
    var v, m;
    const f = (s - (((v = i.dimensions) == null ? void 0 : v.height) ?? 1)) / 2;
    return i.dimensions && i.dimensions.top === null && (i.dimensions.top = u + f, a = Math.max(a, s)), {
        groupHeight: a,
        verticalMargin: 0,
        itemTop: ((m = i.dimensions) == null ? void 0 : m.top) ?? 0
    };
}
function $402be0a702aa527c$var$di(s = []) {
    return s.reduce((i, a)=>i + a, 0);
}
function $402be0a702aa527c$var$Ki(s, i, a, u) {
    const f = [], v = [], m = $402be0a702aa527c$var$Ui(s, i);
    for(const y in m){
        const x = m[y], { items: O, group: $ } = x, P = $402be0a702aa527c$var$di(f), T = $.stackItems !== void 0 ? $.stackItems : u, { groupHeight: _ } = $402be0a702aa527c$var$Xi(O, T, a, P);
        v.push(P), $.height ? f.push($.height) : f.push(Math.max(_, a));
    }
    return {
        height: $402be0a702aa527c$var$di(f),
        groupHeights: f,
        groupTops: v
    };
}
function $402be0a702aa527c$var$Xi(s, i, a, u) {
    let f = 0, v = 0;
    for(let m = 0; m < s.length; m++){
        const y = i ? $402be0a702aa527c$var$Yi(a, s[m], s, f, u, m) : $402be0a702aa527c$var$Gi(a, s[m], f, u);
        f = y.groupHeight, v = y.verticalMargin;
    }
    return {
        groupHeight: f,
        verticalMargin: v
    };
}
function $402be0a702aa527c$var$qe(s, i, a, u, f, v, m, y, x, O, $, P, T, _, M) {
    const z = $402be0a702aa527c$var$Fr(s, u, f, v).map((ue)=>$402be0a702aa527c$var$Vi({
            item: ue,
            keys: v,
            draggingItem: O,
            resizingItem: $,
            dragTime: P,
            resizingEdge: T,
            resizeTime: _,
            groups: i,
            newGroupOrder: M
        }));
    if (i.length === 0) return {
        dimensionItems: [],
        height: 0,
        groupHeights: [],
        groupTops: []
    };
    const N = $402be0a702aa527c$var$Wr(i, v), G = z.map((ue)=>$402be0a702aa527c$var$Bi({
            item: ue,
            keys: v,
            canvasTimeStart: u,
            canvasTimeEnd: f,
            canvasWidth: a,
            groupOrders: N,
            lineHeight: m,
            itemHeightRatio: y
        })).filter((ue)=>!!ue), { height: Q, groupHeights: te, groupTops: re } = $402be0a702aa527c$var$Ki(G, N, m, x);
    return {
        dimensionItems: G,
        height: Q,
        groupHeights: te,
        groupTops: re
    };
}
function $402be0a702aa527c$var$Re(s, i) {
    return s * i;
}
function $402be0a702aa527c$var$Bi({ item: s, keys: i, canvasTimeStart: a, canvasTimeEnd: u, canvasWidth: f, groupOrders: v, lineHeight: m, itemHeightRatio: y }) {
    const x = $402be0a702aa527c$var$J(s, i.itemIdKey), O = $402be0a702aa527c$var$Fi({
        itemTimeStart: $402be0a702aa527c$var$J(s, i.itemTimeStartKey),
        itemTimeEnd: $402be0a702aa527c$var$J(s, i.itemTimeEndKey),
        canvasTimeStart: a,
        canvasTimeEnd: u,
        canvasWidth: f
    });
    if (O) return O.top = null, O.order = v[$402be0a702aa527c$var$J(s, i.itemGroupKey)], O.stack = !s.isOverlay, O.height = m * y, {
        id: x,
        dimensions: O
    };
}
function $402be0a702aa527c$var$Vi({ item: s, keys: i, draggingItem: a, resizingItem: u, dragTime: f, resizingEdge: v, resizeTime: m, groups: y, newGroupOrder: x }) {
    if (!u && !a) return s;
    const O = $402be0a702aa527c$var$J(s, i.itemIdKey), $ = O === a, P = O === u, [T, _] = $402be0a702aa527c$var$Wi({
        itemTimeStart: $402be0a702aa527c$var$J(s, i.itemTimeStartKey),
        itemTimeEnd: $402be0a702aa527c$var$J(s, i.itemTimeEndKey),
        isDragging: $,
        isResizing: P,
        dragTime: f,
        resizingEdge: v,
        resizeTime: m
    });
    return {
        ...s,
        [i.itemTimeStartKey]: T,
        [i.itemTimeEndKey]: _,
        [i.itemGroupKey]: $ ? $402be0a702aa527c$var$J(y[x], i.groupIdKey) : $402be0a702aa527c$var$J(s, i.itemGroupKey)
    };
}
function $402be0a702aa527c$var$Ur(s, i, a) {
    const u = i - s, f = s - u * (a - 1) / 2, v = f + u * a;
    return [
        f,
        v
    ];
}
function $402be0a702aa527c$var$Rr(s, i, a, u, f, v, m) {
    const y = v.buffer, x = m.canvasTimeStart, O = m.canvasTimeEnd, $ = m.visibleTimeEnd - m.visibleTimeStart, P = i - s, T = {
        ...m,
        visibleTimeStart: s,
        visibleTimeEnd: i
    }, _ = $ * (y - 1) * 0.25;
    if (P !== $ || s <= x + _ || i >= O - _ || a) {
        const [C, z] = $402be0a702aa527c$var$Ur(s, i, y);
        T.canvasTimeStart = C, T.canvasTimeEnd = z;
        const N = {
            ...m,
            ...T
        }, G = $402be0a702aa527c$var$Re(N.width, v.buffer);
        Object.assign(T, $402be0a702aa527c$var$qe(u, f, G, N.canvasTimeStart, N.canvasTimeEnd, v.keys, v.lineHeight, v.itemHeightRatio, v.stackItems, N.draggingItem, N.resizingItem, N.dragTime, N.resizingEdge, N.resizeTime, N.newGroupOrder));
    }
    return T;
}
const $402be0a702aa527c$export$802a8b44e12d82a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    NEXT_UNITS: $402be0a702aa527c$var$Dr,
    calculateDimensions: $402be0a702aa527c$var$Fi,
    calculateInteractionNewTimes: $402be0a702aa527c$var$Wi,
    calculateScrollCanvas: $402be0a702aa527c$var$Rr,
    calculateTimeForXPosition: $402be0a702aa527c$var$Ar,
    calculateXPositionForTime: $402be0a702aa527c$var$Nt,
    collision: $402be0a702aa527c$var$Ni,
    coordinateToTimeRatio: $402be0a702aa527c$var$Ut,
    getCanvasBoundariesFromVisibleTime: $402be0a702aa527c$var$Ur,
    getCanvasWidth: $402be0a702aa527c$var$Re,
    getGroupOrders: $402be0a702aa527c$var$Wr,
    getGroupedItems: $402be0a702aa527c$var$Ui,
    getItemDimensions: $402be0a702aa527c$var$Bi,
    getItemWithInteractions: $402be0a702aa527c$var$Vi,
    getMinUnit: $402be0a702aa527c$var$kt,
    getNextUnit: $402be0a702aa527c$var$Hr,
    getVisibleItems: $402be0a702aa527c$var$Fr,
    groupNoStack: $402be0a702aa527c$var$Gi,
    groupStack: $402be0a702aa527c$var$Yi,
    iterateTimes: $402be0a702aa527c$var$Lr,
    minCellWidth: $402be0a702aa527c$var$Pr,
    stackAll: $402be0a702aa527c$var$Ki,
    stackGroup: $402be0a702aa527c$var$Xi,
    stackTimelineItems: $402be0a702aa527c$var$qe
}, Symbol.toStringTag, {
    value: "Module"
})), $402be0a702aa527c$var$td = {
    fontSize: 12,
    color: "white",
    cursor: "pointer",
    background: "#2196f3",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderColor: "#1a6fb3",
    zIndex: 80
}, $402be0a702aa527c$var$rd = {
    background: "#ffc107",
    borderTopWidth: "1px",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderBottomWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ff9800",
    zIndex: 82
}, $402be0a702aa527c$var$nd = {
    willChange: "left, top, width",
    cursor: "move"
}, $402be0a702aa527c$var$id = {
    borderLeftWidth: 3
}, $402be0a702aa527c$var$od = {
    cursor: "w-resize"
}, $402be0a702aa527c$var$sd = {
    borderRightWidth: "3px"
}, $402be0a702aa527c$var$ad = {
    cursor: "e-resize"
}, $402be0a702aa527c$var$ld = {
    position: "absolute",
    width: 24,
    maxWidth: "20%",
    minWidth: 2,
    height: "100%",
    top: 0,
    left: 0,
    cursor: "pointer",
    zIndex: 88
}, $402be0a702aa527c$var$cd = {
    position: "absolute",
    width: 24,
    maxWidth: "20%",
    minWidth: 2,
    height: "100%",
    top: 0,
    right: 0,
    cursor: "pointer",
    zIndex: 88
}, $402be0a702aa527c$var$ud = {
    getTimelineState: ()=>(console.warn('"getTimelineState" default func is being used'), {}),
    getLeftOffsetFromDate: ()=>(console.warn('"getLeftOffsetFromDate" default func is being used'), 0),
    getDateFromLeftOffsetPosition: ()=>(console.warn('"getDateFromLeftOffsetPosition" default func is being used'), 0),
    showPeriod: ()=>{
        console.warn('"showPeriod" default func is being used');
    }
}, $402be0a702aa527c$var$Nr = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($402be0a702aa527c$var$ud), { Consumer: $402be0a702aa527c$var$pd, Provider: $402be0a702aa527c$var$hd } = $402be0a702aa527c$var$Nr;
class $402be0a702aa527c$var$dd extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(i){
        super(i), Object.defineProperty(this, "getTimelineState", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                const { visibleTimeStart: a, visibleTimeEnd: u, canvasTimeStart: f, canvasTimeEnd: v, canvasWidth: m, timelineUnit: y, timelineWidth: x } = this.props;
                return {
                    visibleTimeStart: a,
                    visibleTimeEnd: u,
                    canvasTimeStart: f,
                    canvasTimeEnd: v,
                    canvasWidth: m,
                    timelineUnit: y,
                    timelineWidth: x
                };
            }
        }), Object.defineProperty(this, "getLeftOffsetFromDate", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                const { canvasTimeStart: u, canvasTimeEnd: f, canvasWidth: v } = this.props;
                return $402be0a702aa527c$var$Nt(u, f, v, a);
            }
        }), Object.defineProperty(this, "getDateFromLeftOffsetPosition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                const { canvasTimeStart: u, canvasTimeEnd: f, canvasWidth: v } = this.props;
                return $402be0a702aa527c$var$Ar(u, f, v, a);
            }
        }), this.state = {
            timelineContext: {
                getTimelineState: this.getTimelineState,
                getLeftOffsetFromDate: this.getLeftOffsetFromDate,
                getDateFromLeftOffsetPosition: this.getDateFromLeftOffsetPosition,
                showPeriod: this.props.showPeriod
            }
        };
    }
    render() {
        return (0, $ayMG0.jsx)($402be0a702aa527c$var$hd, {
            value: this.state.timelineContext,
            children: this.props.children
        });
    }
}
const $402be0a702aa527c$var$qt = $402be0a702aa527c$var$pd, $402be0a702aa527c$var$fd = ()=>(0, $acw62.useContext)($402be0a702aa527c$var$Nr);
$402be0a702aa527c$var$Me.extend($402be0a702aa527c$var$Cs);
class $402be0a702aa527c$var$Yr extends (0, $acw62.Component) {
    constructor(i){
        super(i), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                interactMounted: !1,
                dragging: !1,
                dragStart: null,
                preDragPosition: null,
                dragTime: null,
                dragGroupDelta: null,
                resizing: !1,
                resizeEdge: null,
                resizeStart: null,
                resizeTime: null
            }
        }), Object.defineProperty(this, "itemId", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "itemTitle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "itemDivTitle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "itemTimeStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "itemTimeEnd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "itemRef", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, $acw62.createRef)()
        }), Object.defineProperty(this, "dragLeft", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "dragRight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startedClicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedTouching", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "dragInProgress", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "fireInteractEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                var u;
                if (this.itemRef && this.itemRef.current) {
                    const f = new CustomEvent("itemInteraction", {
                        bubbles: !0,
                        detail: {
                            itemInteraction: a
                        }
                    });
                    (u = this.itemRef.current) == null || u.dispatchEvent(f);
                }
            }
        }), Object.defineProperty(this, "onMouseDown", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                this.state.interactMounted || (a.preventDefault(), this.startedClicking = !0);
            }
        }), Object.defineProperty(this, "onMouseUp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                !this.state.interactMounted && this.startedClicking && (this.startedClicking = !1, this.actualClick(a, "click"));
            }
        }), Object.defineProperty(this, "onTouchStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                this.state.interactMounted || (a.preventDefault(), this.startedTouching = !0);
            }
        }), Object.defineProperty(this, "onTouchEnd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                !this.state.interactMounted && this.startedTouching && (this.startedTouching = !1, this.actualClick(a, "touch"));
            }
        }), Object.defineProperty(this, "handleDoubleClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                a.stopPropagation(), this.props.onItemDoubleClick && this.props.onItemDoubleClick(this.itemId, a);
            }
        }), Object.defineProperty(this, "handleContextMenu", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                this.props.onContextMenu && (a.preventDefault(), a.stopPropagation(), this.props.onContextMenu(this.itemId, a));
            }
        }), Object.defineProperty(this, "getDragLeftRef", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>this.dragLeft = a
        }), Object.defineProperty(this, "getDragRightRef", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>this.dragRight = a
        }), Object.defineProperty(this, "getItemProps", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a = {})=>{
                const u = "rct-item" + (this.props.item.className ? ` ${this.props.item.className}` : "");
                return {
                    key: this.itemId,
                    ref: this.itemRef,
                    title: this.itemDivTitle,
                    className: u + ` ${a.className ? a.className : ""}`,
                    onMouseDown: $402be0a702aa527c$var$Ke(this.onMouseDown, a.onMouseDown),
                    onMouseUp: $402be0a702aa527c$var$Ke(this.onMouseUp, a.onMouseUp),
                    onTouchStart: $402be0a702aa527c$var$Ke(this.onTouchStart, a.onTouchStart),
                    onTouchEnd: $402be0a702aa527c$var$Ke(this.onTouchEnd, a.onTouchEnd),
                    onDoubleClick: $402be0a702aa527c$var$Ke(this.handleDoubleClick, a.onDoubleClick),
                    onContextMenu: $402be0a702aa527c$var$Ke(this.handleContextMenu, a.onContextMenu),
                    style: Object.assign({}, this.getItemStyle(a))
                };
            }
        }), Object.defineProperty(this, "getResizeProps", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a = {})=>{
                let u = "rct-item-handler rct-item-handler-left rct-item-handler-resize-left";
                a.leftClassName && (u += ` ${a.leftClassName}`);
                let f = "rct-item-handler rct-item-handler-right rct-item-handler-resize-right";
                return a.rightClassName && (f += ` ${a.rightClassName}`), {
                    left: {
                        ref: this.getDragLeftRef,
                        className: u,
                        style: Object.assign({}, $402be0a702aa527c$var$ld, a.leftStyle)
                    },
                    right: {
                        ref: this.getDragRightRef,
                        className: f,
                        style: Object.assign({}, $402be0a702aa527c$var$cd, a.rightStyle)
                    }
                };
            }
        }), this.cacheDataFromProps(i);
    }
    shouldComponentUpdate(i, a) {
        return !$402be0a702aa527c$var$Ir(this.props, i) || !$402be0a702aa527c$var$Ir(this.state, a);
    }
    cacheDataFromProps(i) {
        this.itemId = $402be0a702aa527c$var$J(i.item, i.keys.itemIdKey), this.itemTitle = $402be0a702aa527c$var$J(i.item, i.keys.itemTitleKey), this.itemDivTitle = i.keys.itemDivTitleKey ? $402be0a702aa527c$var$J(i.item, i.keys.itemDivTitleKey) : this.itemTitle, this.itemTimeStart = $402be0a702aa527c$var$J(i.item, i.keys.itemTimeStartKey), this.itemTimeEnd = $402be0a702aa527c$var$J(i.item, i.keys.itemTimeEndKey);
    }
    getTimeRatio() {
        const { canvasTimeStart: i, canvasTimeEnd: a, canvasWidth: u } = this.props;
        return $402be0a702aa527c$var$Ut(i, a, u);
    }
    dragTimeSnap(i, a) {
        const { dragSnap: u } = this.props;
        if (u) {
            const f = a ? $402be0a702aa527c$var$Me().utcOffset() * 60000 : 0;
            return Math.round(i / u) * u - f % u;
        } else return i;
    }
    resizeTimeSnap(i) {
        const { dragSnap: a } = this.props;
        if (a) {
            const u = this.itemTimeEnd % a;
            return Math.round((i - u) / a) * a + u;
        } else return i;
    }
    dragTime(i) {
        const a = $402be0a702aa527c$var$Me(this.itemTimeStart);
        return this.state.dragging ? this.dragTimeSnap(this.timeFor(i) + this.state.dragStart.offset, !0) : a.valueOf();
    }
    timeFor(i) {
        const a = $402be0a702aa527c$var$Ut(this.props.canvasTimeStart, this.props.canvasTimeEnd, this.props.canvasWidth), u = $402be0a702aa527c$var$At(this.props.scrollRef).offsetLeft, f = $402be0a702aa527c$var$jt(this.props.scrollRef);
        return (i.pageX - u + f.scrollLeft) * a + this.props.canvasTimeStart;
    }
    dragGroupDelta(i) {
        const { groupTops: a, order: u } = this.props;
        if (this.state.dragging) {
            if (!this.props.canChangeGroup) return 0;
            let f = 0;
            const v = $402be0a702aa527c$var$At(this.props.scrollRef).offsetTop, m = $402be0a702aa527c$var$jt(this.props.scrollRef);
            for (const y of Object.keys(a)){
                const x = a[y];
                if (i.pageY - v + m.scrollTop > x) f = parseInt(y, 10) - u.index;
                else break;
            }
            return this.props.order.index + f < 0 ? 0 - this.props.order.index : f;
        } else return 0;
    }
    resizeTimeDelta(i, a) {
        const u = this.itemTimeEnd - this.itemTimeStart, f = this.dragTimeSnap((i.pageX - this.state.resizeStart) * this.getTimeRatio());
        return u + (a === "left" ? -f : f) < (this.props.dragSnap || 1e3) ? a === "left" ? u - (this.props.dragSnap || 1e3) : (this.props.dragSnap || 1e3) - u : f;
    }
    mountInteract() {
        const i = this.props.useResizeHandle ? ".rct-item-handler-resize-left" : !0, a = this.props.useResizeHandle ? ".rct-item-handler-resize-right" : !0;
        $402be0a702aa527c$var$Tr(this.itemRef.current).resizable({
            edges: {
                left: this.canResizeLeft() && i,
                right: this.canResizeRight() && a,
                top: !1,
                bottom: !1
            },
            enabled: this.props.selected && (this.canResizeLeft() || this.canResizeRight())
        }).draggable({
            enabled: this.props.selected && this.canMove()
        }).styleCursor(!1).on("dragstart", (u)=>{
            if (this.props.selected) {
                this.dragInProgress = !0, this.fireInteractEvent(!0);
                const f = this.timeFor(u);
                this.setState({
                    dragging: !0,
                    dragStart: {
                        x: u.pageX,
                        y: u.pageY,
                        offset: this.itemTimeStart - f
                    },
                    preDragPosition: {
                        x: u.target.offsetLeft,
                        y: u.target.offsetTop
                    },
                    dragTime: this.itemTimeStart,
                    dragGroupDelta: 0
                });
            } else return !1;
        }).on("dragmove", (u)=>{
            this.state.dragging && this.setState((f)=>{
                if (!this.dragInProgress) return {
                    ...f
                };
                let v = this.dragTime(u);
                const m = this.dragGroupDelta(u);
                return this.props.moveResizeValidator && (v = this.props.moveResizeValidator("move", this.props.item, v)), this.props.onDrag && this.props.onDrag(this.itemId, v, this.props.order.index + m), {
                    dragTime: v,
                    dragGroupDelta: m
                };
            });
        }).on("dragend", (u)=>{
            if (this.state.dragging) {
                if (this.props.onDrop) {
                    this.dragInProgress = !1, this.fireInteractEvent(!1);
                    let f = this.dragTime(u);
                    this.props.moveResizeValidator && (f = this.props.moveResizeValidator("move", this.props.item, f)), this.props.onDrop(this.itemId, f, this.props.order.index + this.dragGroupDelta(u));
                }
                this.setState({
                    dragging: !1,
                    dragStart: null,
                    preDragPosition: null,
                    dragTime: null,
                    dragGroupDelta: null
                });
            }
        }).on("resizestart", (u)=>{
            if (this.props.selected) this.fireInteractEvent(!0), this.setState({
                resizing: !0,
                resizeEdge: null,
                // we don't know yet
                resizeStart: u.pageX,
                resizeTime: 0
            });
            else return !1;
        }).on("resizemove", (u)=>{
            if (this.state.resizing) {
                let f = this.state.resizeEdge;
                f || (f = u.deltaRect.left !== 0 ? "left" : "right", this.setState({
                    resizeEdge: f
                }));
                let v = this.resizeTimeSnap(this.timeFor(u));
                this.props.moveResizeValidator && (v = this.props.moveResizeValidator("resize", this.props.item, v, f)), this.props.onResizing && this.props.onResizing(this.itemId, v, f), this.setState({
                    resizeTime: v
                });
            }
        }).on("resizeend", (u)=>{
            if (this.state.resizing) {
                this.fireInteractEvent(!1);
                const { resizeEdge: f } = this.state;
                let v = this.resizeTimeSnap(this.timeFor(u));
                this.props.moveResizeValidator && (v = this.props.moveResizeValidator("resize", this.props.item, v, f)), this.props.onResized && this.props.onResized(this.itemId, v, f, this.resizeTimeDelta(u, f)), this.setState({
                    resizing: !1,
                    resizeStart: null,
                    resizeEdge: null,
                    resizeTime: null
                });
            }
        }).on("tap", (u)=>{
            this.actualClick(u, u.pointerType === "mouse" ? "click" : "touch");
        }), this.setState({
            interactMounted: !0
        });
    }
    canResizeLeft(i = this.props) {
        var u;
        return !i.canResizeLeft || i.minResizeWidth === void 0 ? !1 : parseInt((u = i.dimensions.width) == null ? void 0 : u.toString(), 10) >= i.minResizeWidth;
    }
    canResizeRight(i = this.props) {
        var u;
        return !i.canResizeRight || i.minResizeWidth === void 0 ? !1 : parseInt((u = i.dimensions.width) == null ? void 0 : u.toString(), 10) >= i.minResizeWidth;
    }
    canMove(i = this.props) {
        return !!i.canMove;
    }
    componentDidUpdate(i) {
        this.cacheDataFromProps(this.props);
        let { interactMounted: a } = this.state;
        const u = i.selected && this.canMove(i), f = i.selected && this.canResizeLeft(i), v = i.selected && this.canResizeRight(i), m = this.props.selected && this.canMove(this.props), y = this.props.selected && this.canResizeLeft(this.props), x = this.props.selected && this.canResizeRight(this.props);
        if (this.itemRef && this.itemRef.current) {
            if (this.props.selected && !a && (this.mountInteract(), a = !0), a && (f !== y || v !== x)) {
                const O = this.props.useResizeHandle ? this.dragLeft : !0, $ = this.props.useResizeHandle ? this.dragRight : !0;
                $402be0a702aa527c$var$Tr(this.itemRef.current).resizable({
                    enabled: y || x,
                    edges: {
                        top: !1,
                        bottom: !1,
                        left: y && O,
                        right: x && $
                    }
                });
            }
            a && u !== m && $402be0a702aa527c$var$Tr(this.itemRef.current).draggable({
                enabled: m
            });
        } else a = !1;
        a !== this.state.interactMounted && this.setState({
            interactMounted: a
        });
    }
    actualClick(i, a) {
        this.props.canSelect && this.props.onSelect && this.props.onSelect(this.itemId, a, i);
    }
    getItemStyle(i) {
        const a = this.props.dimensions, u = {
            position: "absolute",
            boxSizing: "border-box",
            left: `${a.left}px`,
            top: `${a.top}px`,
            width: `${a.width}px`,
            height: `${a.height}px`,
            lineHeight: `${a.height}px`
        };
        return Object.assign({}, $402be0a702aa527c$var$td, this.props.selected ? $402be0a702aa527c$var$rd : {}, this.props.selected && this.canMove(this.props) ? $402be0a702aa527c$var$nd : {}, this.props.selected && this.canResizeLeft(this.props) ? $402be0a702aa527c$var$id : {}, this.props.selected && this.canResizeLeft(this.props) && this.state.dragging ? $402be0a702aa527c$var$od : {}, this.props.selected && this.canResizeRight(this.props) ? $402be0a702aa527c$var$sd : {}, this.props.selected && this.canResizeRight(this.props) && this.state.dragging ? $402be0a702aa527c$var$ad : {}, i.style, u);
    }
    render() {
        if (typeof this.props.order > "u" || this.props.order === null) return null;
        const i = this.context, a = {
            dimensions: this.props.dimensions,
            useResizeHandle: !!this.props.useResizeHandle,
            title: this.itemTitle,
            canMove: this.canMove(this.props),
            canResizeLeft: this.canResizeLeft(this.props),
            canResizeRight: this.canResizeRight(this.props),
            selected: this.props.selected,
            dragging: this.state.dragging,
            dragStart: this.state.dragStart,
            dragTime: this.state.dragTime,
            dragGroupDelta: this.state.dragGroupDelta,
            resizing: this.state.resizing,
            resizeEdge: this.state.resizeEdge,
            resizeStart: this.state.resizeStart,
            resizeTime: this.state.resizeTime
        };
        return this.props.itemRenderer ? this.props.itemRenderer({
            item: this.props.item,
            timelineContext: i,
            itemContext: a,
            getItemProps: this.getItemProps,
            getResizeProps: this.getResizeProps
        }) : $402be0a702aa527c$var$Hi({
            item: this.props.item,
            itemContext: a,
            getItemProps: this.getItemProps,
            getResizeProps: this.getResizeProps
        });
    }
}
Object.defineProperty($402be0a702aa527c$var$Yr, "defaultProps", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        selected: !1,
        itemRenderer: $402be0a702aa527c$var$Hi
    }
});
Object.defineProperty($402be0a702aa527c$var$Yr, "contextType", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $402be0a702aa527c$var$Nr
});
function $402be0a702aa527c$var$vd(s, i) {
    const a = $402be0a702aa527c$var$J(s, "canResize") !== void 0 ? $402be0a702aa527c$var$J(s, "canResize") : i;
    return a === "left" || a === "both";
}
function $402be0a702aa527c$var$gd(s, i) {
    const a = $402be0a702aa527c$var$J(s, "canResize") !== void 0 ? $402be0a702aa527c$var$J(s, "canResize") : i;
    return a === "right" || a === "both" || a === !0;
}
class $402be0a702aa527c$export$11b05e9638ecc4d4 extends (0, $acw62.Component) {
    shouldComponentUpdate(i) {
        return !($402be0a702aa527c$var$gt(i.groups, this.props.groups) && $402be0a702aa527c$var$gt(i.items, this.props.items) && $402be0a702aa527c$var$gt(i.dimensionItems, this.props.dimensionItems) && i.keys === this.props.keys && i.canvasTimeStart === this.props.canvasTimeStart && i.canvasTimeEnd === this.props.canvasTimeEnd && i.canvasWidth === this.props.canvasWidth && i.selectedItem === this.props.selectedItem && i.selected === this.props.selected && i.dragSnap === this.props.dragSnap && i.minResizeWidth === this.props.minResizeWidth && i.canChangeGroup === this.props.canChangeGroup && i.canMove === this.props.canMove && i.canResize === this.props.canResize && i.canSelect === this.props.canSelect);
    }
    isSelected(i, a) {
        if (this.props.selected) {
            const u = $402be0a702aa527c$var$J(i, a);
            return this.props.selected.includes(u);
        } else return this.props.selectedItem === $402be0a702aa527c$var$J(i, a);
    }
    getVisibleItems(i, a) {
        const { keys: u, items: f } = this.props;
        return $402be0a702aa527c$var$Fr(f, i, a, u);
    }
    render() {
        const { canvasTimeStart: i, canvasTimeEnd: a, dimensionItems: u, keys: f, groups: v } = this.props, { itemIdKey: m, itemGroupKey: y } = f, x = $402be0a702aa527c$var$Wr(v, f), O = this.getVisibleItems(i, a), $ = $402be0a702aa527c$var$Qh(u, "id");
        return (0, $ayMG0.jsx)("div", {
            className: "rct-items",
            children: O.filter((P)=>$[$402be0a702aa527c$var$J(P, m)]).map((P)=>(0, $ayMG0.jsx)($402be0a702aa527c$var$Yr, {
                    itemProps: P.itemProps,
                    item: P,
                    keys: this.props.keys,
                    order: x[$402be0a702aa527c$var$J(P, y)],
                    dimensions: $[$402be0a702aa527c$var$J(P, m)].dimensions,
                    selected: this.isSelected(P, m),
                    canChangeGroup: $402be0a702aa527c$var$J(P, "canChangeGroup") !== void 0 ? $402be0a702aa527c$var$J(P, "canChangeGroup") : this.props.canChangeGroup,
                    canMove: $402be0a702aa527c$var$J(P, "canMove") !== void 0 ? $402be0a702aa527c$var$J(P, "canMove") : this.props.canMove,
                    canResizeLeft: $402be0a702aa527c$var$vd(P, this.props.canResize),
                    canResizeRight: $402be0a702aa527c$var$gd(P, this.props.canResize),
                    canSelect: $402be0a702aa527c$var$J(P, "canSelect") !== void 0 ? $402be0a702aa527c$var$J(P, "canSelect") : this.props.canSelect,
                    useResizeHandle: this.props.useResizeHandle,
                    groupTops: this.props.groupTops,
                    canvasTimeStart: this.props.canvasTimeStart,
                    canvasTimeEnd: this.props.canvasTimeEnd,
                    canvasWidth: this.props.canvasWidth,
                    dragSnap: this.props.dragSnap,
                    minResizeWidth: this.props.minResizeWidth,
                    onResizing: this.props.itemResizing,
                    onResized: this.props.itemResized,
                    moveResizeValidator: this.props.moveResizeValidator,
                    onDrag: this.props.itemDrag,
                    onDrop: this.props.itemDrop,
                    onItemDoubleClick: this.props.onItemDoubleClick,
                    onContextMenu: this.props.onItemContextMenu,
                    onSelect: this.props.itemSelect,
                    itemRenderer: this.props.itemRenderer,
                    scrollRef: this.props.scrollRef
                }, $402be0a702aa527c$var$J(P, m)))
        });
    }
}
class $402be0a702aa527c$var$fi extends (0, $acw62.Component) {
    shouldComponentUpdate(i) {
        return !(i.keys === this.props.keys && i.width === this.props.width && i.height === this.props.height && $402be0a702aa527c$var$gt(i.groups, this.props.groups) && $402be0a702aa527c$var$gt(i.groupHeights, this.props.groupHeights));
    }
    renderGroupContent(i, a = !1, u, f) {
        return this.props.groupRenderer ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(this.props.groupRenderer, {
            group: i,
            isRightSidebar: a
        }) : $402be0a702aa527c$var$J(i, a ? f : u);
    }
    render() {
        const { width: i, groupHeights: a, height: u, isRightSidebar: f } = this.props, { groupIdKey: v, groupTitleKey: m, groupRightTitleKey: y } = this.props.keys, x = {
            width: `${i}px`,
            height: `${u}px`
        }, O = {
            width: `${i}px`
        }, $ = this.props.groups.map((P, T)=>{
            const _ = {
                height: `${a[T]}px`,
                lineHeight: `${a[T]}px`
            };
            return (0, $ayMG0.jsx)("div", {
                className: "rct-sidebar-row rct-sidebar-row-" + (T % 2 === 0 ? "even" : "odd"),
                style: _,
                children: this.renderGroupContent(P, f, m, y)
            }, $402be0a702aa527c$var$J(P, v));
        });
        return (0, $ayMG0.jsx)("div", {
            className: "rct-sidebar" + (f ? " rct-sidebar-right" : ""),
            style: x,
            children: (0, $ayMG0.jsx)("div", {
                style: O,
                children: $
            })
        });
    }
}
class $402be0a702aa527c$var$bd extends (0, $acw62.Component) {
    shouldComponentUpdate(i) {
        return !(i.canvasTimeStart === this.props.canvasTimeStart && i.canvasTimeEnd === this.props.canvasTimeEnd && i.canvasWidth === this.props.canvasWidth && i.lineCount === this.props.lineCount && i.minUnit === this.props.minUnit && i.timeSteps === this.props.timeSteps && i.height === this.props.height && i.verticalLineClassNamesForTime === this.props.verticalLineClassNamesForTime);
    }
    render() {
        const { canvasTimeStart: i, canvasTimeEnd: a, // canvasWidth,
        minUnit: u, timeSteps: f, height: v, verticalLineClassNamesForTime: m, getLeftOffsetFromDate: y } = this.props, x = [];
        return $402be0a702aa527c$var$Lr(i, a, u, f, (O, $)=>{
            const T = O.get(u === "day" ? "date" : u) === (u === "day" ? 1 : 0);
            let _ = [];
            m && (_ = m(O.unix() * 1e3, // turn into ms, which is what verticalLineClassNamesForTime expects
            $.unix() * 1e3 - 1));
            const M = "rct-vl" + (T ? " rct-vl-first" : "") + (u === "day" || u === "hour" || u === "minute" ? ` rct-day-${O.day()} ` : " ") + _.join(" "), C = y(O.valueOf()), z = y($.valueOf());
            x.push((0, $ayMG0.jsx)("div", {
                className: M,
                style: {
                    pointerEvents: "none",
                    top: "0px",
                    left: `${C}px`,
                    width: `${z - C}px`,
                    height: `${v}px`
                }
            }, `line-${O.valueOf()}`));
        }), (0, $ayMG0.jsx)("div", {
            className: "rct-vertical-lines",
            children: x
        });
    }
}
const $402be0a702aa527c$var$yd = ({ ...s })=>(0, $ayMG0.jsx)($402be0a702aa527c$var$qt, {
        children: ({ getLeftOffsetFromDate: i })=>(0, $ayMG0.jsx)($402be0a702aa527c$var$bd, {
                getLeftOffsetFromDate: i,
                ...s
            })
    });
class $402be0a702aa527c$var$Td extends (0, $acw62.Component) {
    constructor(){
        super(...arguments), Object.defineProperty(this, "handleMouseDown", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i)=>{
                this.originClickX = i.clientX;
            }
        }), Object.defineProperty(this, "handleMouseUp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i)=>{
                this.props.clickTolerance !== void 0 && Math.abs(this.originClickX - i.clientX) > this.props.clickTolerance && (this.cancelClick = !0);
            }
        }), Object.defineProperty(this, "handleClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i)=>{
                this.cancelClick || this.props.onClick(i), this.cancelClick = !1, this.originClickX = null;
            }
        }), Object.defineProperty(this, "originClickX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "cancelClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    render() {
        const i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(this.props.children);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(i, {
            onMouseDown: this.handleMouseDown,
            onMouseUp: this.handleMouseUp,
            onClick: this.handleClick
        });
    }
}
class $402be0a702aa527c$export$84aac6ac2cec7eed extends (0, $acw62.Component) {
    render() {
        const { onContextMenu: i, onDoubleClick: a, isEvenRow: u, style: f, onClick: v, clickTolerance: m, horizontalLineClassNamesForGroup: y, group: x } = this.props;
        let O = [];
        return y && (O = y(x)), (0, $ayMG0.jsx)($402be0a702aa527c$var$Td, {
            clickTolerance: m,
            onClick: v,
            children: (0, $ayMG0.jsx)("div", {
                onContextMenu: i,
                onDoubleClick: a,
                className: (u ? "rct-hl-even " : "rct-hl-odd ") + (O ? O.join(" ") : ""),
                style: f
            })
        });
    }
}
class $402be0a702aa527c$var$Sd extends (0, $acw62.Component) {
    shouldComponentUpdate(i) {
        return !(i.canvasWidth === this.props.canvasWidth && i.lineCount === this.props.lineCount && i.groupHeights === this.props.groupHeights && i.groups === this.props.groups);
    }
    render() {
        const { canvasWidth: i, lineCount: a, groupHeights: u, onRowClick: f, onRowDoubleClick: v, clickTolerance: m, groups: y, horizontalLineClassNamesForGroup: x, onRowContextClick: O } = this.props, $ = [];
        for(let P = 0; P < a; P++)$.push((0, $ayMG0.jsx)($402be0a702aa527c$export$84aac6ac2cec7eed, {
            clickTolerance: m,
            onContextMenu: (T)=>O(T, P),
            onClick: (T)=>f(T, P),
            onDoubleClick: (T)=>v(T, P),
            isEvenRow: P % 2 === 0,
            group: y[P],
            horizontalLineClassNamesForGroup: x,
            style: {
                width: `${i}px`,
                height: `${u[P]}px`
            }
        }, `horizontal-line-${P}`));
        return (0, $ayMG0.jsx)("div", {
            className: "rct-horizontal-lines",
            children: $
        });
    }
}
class $402be0a702aa527c$var$xd extends (0, $acw62.Component) {
    constructor(i){
        super(i), Object.defineProperty(this, "scrollComponentRef", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, $acw62.createRef)()
        }), Object.defineProperty(this, "dragLastPosition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastTouchDistance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "singleTouchStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastSingleTouch", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isItemInteraction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "handleScroll", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                const a = this.scrollComponentRef.current.scrollLeft;
                this.props.onScroll(a);
            }
        }), Object.defineProperty(this, "handleWheel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                if (a.ctrlKey || a.metaKey || a.altKey) {
                    a.preventDefault();
                    const u = $402be0a702aa527c$var$Hn(a.currentTarget), f = a.clientX - u.x, v = a.ctrlKey ? 10 : a.metaKey ? 3 : 1;
                    this.props.onWheelZoom(v, f, a.deltaY);
                } else a.shiftKey && (a.preventDefault(), this.props.onScroll(this.scrollComponentRef.current.scrollLeft + (a.deltaY || a.deltaX)));
            }
        }), Object.defineProperty(this, "handleMouseDown", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                a.button === 0 && (this.dragLastPosition = a.pageX, this.setState({
                    isDragging: !0
                }));
            }
        }), Object.defineProperty(this, "handleMouseMove", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                this.state.isDragging && !this.isItemInteraction && (this.props.onScroll(this.scrollComponentRef.current.scrollLeft + this.dragLastPosition - a.pageX), this.dragLastPosition = a.pageX);
            }
        }), Object.defineProperty(this, "handleMouseUp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                this.dragLastPosition = null, this.setState({
                    isDragging: !1
                });
            }
        }), Object.defineProperty(this, "handleMouseLeave", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                this.dragLastPosition = null, this.setState({
                    isDragging: !1
                });
            }
        }), Object.defineProperty(this, "handleTouchStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                if (a.touches.length === 2) a.preventDefault(), this.lastTouchDistance = Math.abs(a.touches[0].screenX - a.touches[1].screenX), this.singleTouchStart = null, this.lastSingleTouch = null;
                else if (a.touches.length === 1) {
                    a.preventDefault();
                    const u = a.touches[0].clientX, f = a.touches[0].clientY;
                    this.lastTouchDistance = null, this.singleTouchStart = {
                        x: u,
                        y: f,
                        screenY: window.pageYOffset
                    }, this.lastSingleTouch = {
                        x: u,
                        y: f,
                        screenY: window.pageYOffset
                    };
                }
            }
        }), Object.defineProperty(this, "handleTouchMove", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                const { width: u, onZoom: f } = this.props;
                if (this.isItemInteraction) {
                    a.preventDefault();
                    return;
                }
                if (this.lastTouchDistance && a.touches.length === 2) {
                    a.preventDefault();
                    const v = Math.abs(a.touches[0].screenX - a.touches[1].screenX), m = $402be0a702aa527c$var$Hn(a.currentTarget), y = (a.touches[0].screenX + a.touches[1].screenX) / 2 - m.x;
                    v !== 0 && this.lastTouchDistance !== 0 && (f(this.lastTouchDistance / v, y / u), this.lastTouchDistance = v);
                } else if (this.lastSingleTouch && a.touches.length === 1) {
                    a.preventDefault();
                    const v = a.touches[0].clientX, m = a.touches[0].clientY, y = v - this.lastSingleTouch.x, x = v - this.singleTouchStart.x, O = m - this.singleTouchStart.y;
                    this.lastSingleTouch = {
                        x: v,
                        y: m,
                        screenY: window.pageYOffset
                    };
                    const $ = Math.abs(x) * 3 > Math.abs(O), P = Math.abs(O) * 3 > Math.abs(x);
                    y !== 0 && $ && this.props.onScroll(this.scrollComponentRef.current.scrollLeft - y), P && window.scrollTo(window.scrollX, this.singleTouchStart.screenY - O);
                }
            }
        }), Object.defineProperty(this, "handleTouchEnd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                this.lastTouchDistance && (this.lastTouchDistance = null), this.lastSingleTouch && (this.lastSingleTouch = null, this.singleTouchStart = null);
            }
        }), Object.defineProperty(this, "handleItemInteract", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                this.isItemInteraction = a.detail.itemInteraction;
            }
        }), this.state = {
            isDragging: !1
        };
    }
    componentDidMount() {
        this.scrollComponentRef.current && (this.props.scrollRef(this.scrollComponentRef.current), this.scrollComponentRef.current.addEventListener("wheel", this.handleWheel, {
            passive: !1
        }), this.scrollComponentRef.current.addEventListener("itemInteraction", this.handleItemInteract), this.scrollComponentRef.current.addEventListener("touchstart", this.handleTouchStart, {
            passive: !1
        }), this.scrollComponentRef.current.addEventListener("touchmove", this.handleTouchMove, {
            passive: !1
        }));
    }
    componentWillUnmount() {
        this.scrollComponentRef.current && (this.scrollComponentRef.current.removeEventListener("wheel", this.handleWheel), this.scrollComponentRef.current.removeEventListener("itemInteraction", this.handleItemInteract), this.scrollComponentRef.current.removeEventListener("touchstart", this.handleTouchStart), this.scrollComponentRef.current.removeEventListener("touchmove", this.handleTouchMove));
    }
    render() {
        const { width: i, height: a, children: u } = this.props, { isDragging: f } = this.state, v = {
            width: `${i}px`,
            height: `${a + 20}px`,
            //20px to push the scroll element down off screen...?
            cursor: f ? "move" : "default",
            position: "relative"
        };
        return (0, $ayMG0.jsx)("div", {
            ref: this.scrollComponentRef,
            "data-testid": "scroll-element",
            className: "rct-scroll",
            style: v,
            onMouseDown: this.handleMouseDown,
            onMouseMove: this.handleMouseMove,
            onMouseUp: this.handleMouseUp,
            onMouseLeave: this.handleMouseLeave,
            //        onTouchStart={this.handleTouchStart}
            //         onTouchMove={this.handleTouchMove}
            onTouchEnd: this.handleTouchEnd,
            onScroll: this.handleScroll,
            children: u
        });
    }
}
const $402be0a702aa527c$var$Od = {
    subscribeToMouseOver: ()=>(console.warn('"subscribeToMouseOver" default func is being used'), ()=>{})
}, { Consumer: $402be0a702aa527c$var$Cd, Provider: $402be0a702aa527c$var$_d } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($402be0a702aa527c$var$Od), $402be0a702aa527c$var$Md = $402be0a702aa527c$var$_d, $402be0a702aa527c$var$Ed = $402be0a702aa527c$var$Cd, $402be0a702aa527c$var$Id = {
    markers: [],
    subscribeMarker: ()=>(console.warn("default subscribe marker used"), {
            unsubscribe: $402be0a702aa527c$var$$t,
            getMarker: $402be0a702aa527c$var$$t
        }),
    updateMarker: ()=>(console.warn("default subscribe marker used"), $402be0a702aa527c$var$$t)
}, { Consumer: $402be0a702aa527c$var$Pd, Provider: $402be0a702aa527c$var$Dd } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($402be0a702aa527c$var$Id);
let $402be0a702aa527c$var$vi = 0;
const $402be0a702aa527c$var$Rd = ()=>($402be0a702aa527c$var$vi += 1, $402be0a702aa527c$var$vi + 1);
class $402be0a702aa527c$var$$d extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(i){
        super(i), Object.defineProperty(this, "handleSubscribeToMarker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>(a = {
                    ...a,
                    // REVIEW: in the event that we accept id to be passed to the Marker components, this line would override those
                    id: $402be0a702aa527c$var$Rd()
                }, this.setState((u)=>({
                        markers: [
                            ...u.markers,
                            a
                        ]
                    })), {
                    unsubscribe: ()=>{
                        this.setState((u)=>({
                                markers: u.markers.filter((f)=>f.id !== a.id)
                            }));
                    },
                    getMarker: ()=>a
                })
        }), Object.defineProperty(this, "handleUpdateMarker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (a)=>{
                const u = this.state.markers.findIndex((f)=>f.id === a.id);
                u < 0 || this.setState((f)=>({
                        markers: [
                            ...f.markers.slice(0, u),
                            a,
                            ...f.markers.slice(u + 1)
                        ]
                    }));
            }
        }), this.state = {
            markers: [],
            subscribeMarker: this.handleSubscribeToMarker,
            updateMarker: this.handleUpdateMarker
        };
    }
    render() {
        return (0, $ayMG0.jsx)($402be0a702aa527c$var$Dd, {
            value: this.state,
            children: this.props.children
        });
    }
}
const $402be0a702aa527c$var$Zt = $402be0a702aa527c$var$Pd;
var $402be0a702aa527c$var$Fe;
(function(s) {
    s.Today = "Today", s.Custom = "Custom", s.Cursor = "Cursor";
})($402be0a702aa527c$var$Fe || ($402be0a702aa527c$var$Fe = {}));
const $402be0a702aa527c$var$kd = {
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "2px",
    backgroundColor: "black",
    // by default, pointer events (specifically click) will
    // "pass through".  This is added so that CursorMarker
    // will not get in the way of canvas click
    pointerEvents: "none"
}, $402be0a702aa527c$var$Gr = (s)=>({
        ...$402be0a702aa527c$var$kd,
        left: s
    }), $402be0a702aa527c$var$Kr = (s)=>function({ styles: a }) {
        return (0, $ayMG0.jsx)("div", {
            style: a,
            "data-testid": s
        });
    }, $402be0a702aa527c$var$zd = $402be0a702aa527c$var$Kr("default-today-line");
let $402be0a702aa527c$var$qi = class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                date: Date.now()
            }
        }), Object.defineProperty(this, "intervalToken", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        });
    }
    componentDidMount() {
        this.intervalToken = this.createIntervalUpdater(this.props.interval);
    }
    componentDidUpdate(i) {
        i.interval !== this.props.interval && (clearInterval(this.intervalToken), this.intervalToken = this.createIntervalUpdater(this.props.interval));
    }
    createIntervalUpdater(i) {
        return setInterval(()=>{
            this.setState({
                date: Date.now()
            });
        }, i);
    }
    componentWillUnmount() {
        clearInterval(this.intervalToken);
    }
    render() {
        const { date: i } = this.state, a = this.props.getLeftOffsetFromDate(i), u = $402be0a702aa527c$var$Gr(a);
        return this.props.renderer({
            styles: u,
            date: i
        });
    }
};
Object.defineProperty($402be0a702aa527c$var$qi, "defaultProps", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        renderer: $402be0a702aa527c$var$zd
    }
});
const $402be0a702aa527c$var$jd = $402be0a702aa527c$var$Kr("default-customer-marker-id");
let $402be0a702aa527c$var$Zi = class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        const { date: i } = this.props, a = this.props.getLeftOffsetFromDate(i), u = $402be0a702aa527c$var$Gr(a);
        return this.props.renderer({
            styles: u,
            date: i
        });
    }
};
Object.defineProperty($402be0a702aa527c$var$Zi, "defaultProps", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        renderer: $402be0a702aa527c$var$jd
    }
});
const $402be0a702aa527c$var$Ad = $402be0a702aa527c$var$Kr("default-cursor-marker");
let $402be0a702aa527c$var$Ji = class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(i){
        super(i), Object.defineProperty(this, "handleCanvasMouseOver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ({ leftOffset: a, date: u, isCursorOverCanvas: f })=>{
                this.setState({
                    leftOffset: a,
                    date: u,
                    isShowingCursor: f
                });
            }
        }), Object.defineProperty(this, "unsubscribe", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.state = {
            leftOffset: 0,
            date: 0,
            isShowingCursor: !1
        };
    }
    componentDidMount() {
        this.unsubscribe = this.props.subscribeToCanvasMouseOver(this.handleCanvasMouseOver);
    }
    componentWillUnmount() {
        this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
    }
    render() {
        const { isShowingCursor: i, leftOffset: a, date: u } = this.state;
        if (!i) return null;
        const f = $402be0a702aa527c$var$Gr(a);
        return this.props.renderer ? this.props.renderer({
            styles: f,
            date: u
        }) : null;
    }
};
Object.defineProperty($402be0a702aa527c$var$Ji, "defaultProps", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        renderer: $402be0a702aa527c$var$Ad
    }
});
const $402be0a702aa527c$var$Qi = (s)=>(0, $ayMG0.jsx)($402be0a702aa527c$var$Ed, {
        children: ({ subscribeToMouseOver: i })=>(0, $ayMG0.jsx)($402be0a702aa527c$var$Ji, {
                subscribeToCanvasMouseOver: i,
                ...s
            })
    });
$402be0a702aa527c$var$Qi.displayName = "CursorMarkerWrapper";
const $402be0a702aa527c$var$Ld = ()=>(0, $ayMG0.jsx)($402be0a702aa527c$var$qt, {
        children: ({ getLeftOffsetFromDate: s, getTimelineState: i })=>(0, $ayMG0.jsx)($402be0a702aa527c$var$Zt, {
                children: ({ markers: a })=>{
                    const u = i();
                    return a.map((f)=>{
                        switch(f.type){
                            case $402be0a702aa527c$var$Fe.Today:
                                return /* @__PURE__ */ new Date().valueOf() >= u.canvasTimeStart && /* @__PURE__ */ new Date().valueOf() <= u.canvasTimeEnd ? (0, $ayMG0.jsx)($402be0a702aa527c$var$qi, {
                                    getLeftOffsetFromDate: s,
                                    renderer: f.renderer,
                                    interval: f.interval
                                }, f.id) : null;
                            case $402be0a702aa527c$var$Fe.Custom:
                                return f.date >= u.canvasTimeStart && f.date <= u.canvasTimeEnd ? (0, $ayMG0.jsx)($402be0a702aa527c$var$Zi, {
                                    renderer: f.renderer,
                                    date: f.date,
                                    getLeftOffsetFromDate: s
                                }, f.id) : null;
                            case $402be0a702aa527c$var$Fe.Cursor:
                                return (0, $ayMG0.jsx)($402be0a702aa527c$var$Qi, {
                                    renderer: f.renderer,
                                    getLeftOffsetFromDate: s
                                }, f.id);
                            default:
                                return null;
                        }
                    });
                }
            })
    }), $402be0a702aa527c$var$Hd = {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
class $402be0a702aa527c$var$Wd extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(){
        super(...arguments), Object.defineProperty(this, "handleMouseMove", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i)=>{
                var a;
                if (this.subscription !== null) {
                    const { pageX: u } = i, { left: f } = ((a = this.containerEl.current) == null ? void 0 : a.getBoundingClientRect()) ?? {
                        left: 0
                    }, v = u - f, m = this.props.getDateFromLeftOffsetPosition(v);
                    this.subscription({
                        leftOffset: v,
                        date: m,
                        isCursorOverCanvas: !0
                    });
                }
            }
        }), Object.defineProperty(this, "handleMouseLeave", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                this.subscription !== null && this.subscription({
                    leftOffset: 0,
                    date: 0,
                    isCursorOverCanvas: !1
                });
            }
        }), Object.defineProperty(this, "handleMouseMoveSubscribe", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i)=>(this.subscription = i, ()=>{
                    this.subscription = null;
                })
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                subscribeToMouseOver: this.handleMouseMoveSubscribe
            }
        }), Object.defineProperty(this, "containerEl", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef()
        }), Object.defineProperty(this, "subscription", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    render() {
        return (0, $ayMG0.jsx)($402be0a702aa527c$var$Md, {
            value: this.state,
            children: (0, $ayMG0.jsxs)("div", {
                style: $402be0a702aa527c$var$Hd,
                onMouseMove: this.handleMouseMove,
                onMouseLeave: this.handleMouseLeave,
                ref: this.containerEl,
                children: [
                    (0, $ayMG0.jsx)($402be0a702aa527c$var$Ld, {}),
                    this.props.children
                ]
            })
        });
    }
}
const $402be0a702aa527c$var$Fd = (s)=>(0, $ayMG0.jsx)($402be0a702aa527c$var$qt, {
        children: ({ getDateFromLeftOffsetPosition: i })=>(0, $ayMG0.jsx)($402be0a702aa527c$var$Wd, {
                getDateFromLeftOffsetPosition: i,
                ...s
            })
    });
function $402be0a702aa527c$var$Ud(s) {
    s._resizeEventListener = ()=>s.resize(), window.addEventListener("resize", s._resizeEventListener);
}
function $402be0a702aa527c$var$Nd(s) {
    window.removeEventListener("resize", s._resizeEventListener);
}
const $402be0a702aa527c$var$gi = {
    addListener: $402be0a702aa527c$var$Ud,
    removeListener: $402be0a702aa527c$var$Nd
}, $402be0a702aa527c$var$Yd = {
    groupIdKey: "id",
    groupTitleKey: "title",
    groupRightTitleKey: "rightTitle",
    groupLabelKey: "title",
    itemIdKey: "id",
    itemTitleKey: "title",
    itemDivTitleKey: "title",
    itemGroupKey: "group",
    itemTimeStartKey: "start_time",
    itemTimeEndKey: "end_time"
}, $402be0a702aa527c$var$Gd = {
    second: 1,
    minute: 1,
    hour: 1,
    day: 1,
    month: 1,
    year: 1
}, $402be0a702aa527c$var$Kd = {
    year: {
        long: "YYYY",
        mediumLong: "YYYY",
        medium: "YYYY",
        short: "YY"
    },
    month: {
        long: "MMMM YYYY",
        mediumLong: "MMMM",
        medium: "MMMM",
        short: "MM/YY"
    },
    week: {
        long: "w",
        mediumLong: "w",
        medium: "w",
        short: "w"
    },
    day: {
        long: "dddd, LL",
        mediumLong: "dddd, LL",
        medium: "dd D",
        short: "D"
    },
    hour: {
        long: "dddd, LL, HH:00",
        mediumLong: "L, HH:00",
        medium: "HH:00",
        short: "HH"
    },
    minute: {
        long: "HH:mm",
        mediumLong: "HH:mm",
        medium: "HH:mm",
        short: "mm"
    },
    second: {
        long: "mm:ss",
        mediumLong: "mm:ss",
        medium: "mm:ss",
        short: "ss"
    }
}, $402be0a702aa527c$var$Xd = {
    registerScroll: ()=>(console.warn("default registerScroll header used"), $402be0a702aa527c$var$$t),
    rightSidebarWidth: 0,
    leftSidebarWidth: 150,
    timeSteps: {}
}, $402be0a702aa527c$var$eo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($402be0a702aa527c$var$Xd);
class $402be0a702aa527c$var$Bd extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        const i = {
            rightSidebarWidth: this.props.rightSidebarWidth,
            leftSidebarWidth: this.props.leftSidebarWidth,
            timeSteps: this.props.timeSteps,
            registerScroll: this.props.registerScroll
        };
        return (0, $ayMG0.jsx)($402be0a702aa527c$var$eo.Provider, {
            value: i,
            children: this.props.children
        });
    }
}
const $402be0a702aa527c$var$Vd = $402be0a702aa527c$var$eo, $402be0a702aa527c$var$Xr = ()=>(0, $acw62.useContext)($402be0a702aa527c$var$Vd);
var $402be0a702aa527c$var$to = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ (function(s) {
    (function() {
        var i = {}.hasOwnProperty;
        function a() {
            for(var v = "", m = 0; m < arguments.length; m++){
                var y = arguments[m];
                y && (v = f(v, u(y)));
            }
            return v;
        }
        function u(v) {
            if (typeof v == "string" || typeof v == "number") return v;
            if (typeof v != "object") return "";
            if (Array.isArray(v)) return a.apply(null, v);
            if (v.toString !== Object.prototype.toString && !v.toString.toString().includes("[native code]")) return v.toString();
            var m = "";
            for(var y in v)i.call(v, y) && v[y] && (m = f(m, y));
            return m;
        }
        function f(v, m) {
            return m ? v ? v + " " + m : v + m : v;
        }
        s.exports ? (a.default = a, s.exports = a) : window.classNames = a;
    })();
})($402be0a702aa527c$var$to);
var $402be0a702aa527c$var$qd = $402be0a702aa527c$var$to.exports;
const $402be0a702aa527c$var$mi = /* @__PURE__ */ $402be0a702aa527c$var$Ze($402be0a702aa527c$var$qd), $402be0a702aa527c$var$Zd = "left", $402be0a702aa527c$var$ro = "right";
class $402be0a702aa527c$var$Jd extends (0, $acw62.PureComponent) {
    constructor(){
        super(...arguments), Object.defineProperty(this, "getRootProps", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i = {})=>{
                const { style: a } = i, u = this.props.variant === $402be0a702aa527c$var$ro ? this.props.rightSidebarWidth : this.props.leftSidebarWidth;
                return {
                    style: {
                        color: (a == null ? void 0 : a.color) ?? "#fff",
                        ...a,
                        width: u
                    }
                };
            }
        }), Object.defineProperty(this, "getStateAndHelpers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>({
                    getRootProps: this.getRootProps,
                    data: this.props.headerData
                })
        });
    }
    render() {
        const i = this.getStateAndHelpers();
        return this.props.children(i);
    }
}
const $402be0a702aa527c$var$Qd = ({ getRootProps: s })=>(0, $ayMG0.jsx)("div", {
        "data-testid": "sidebarHeader",
        ...s()
    }), $402be0a702aa527c$export$e575a964a1fe8b0 = (s)=>{
    const { children: i, variant: a = $402be0a702aa527c$var$Zd, headerData: u } = s, { leftSidebarWidth: f, rightSidebarWidth: v } = $402be0a702aa527c$var$Xr();
    return (0, $ayMG0.jsx)($402be0a702aa527c$var$Jd, {
        leftSidebarWidth: f,
        rightSidebarWidth: v,
        variant: a,
        headerData: u,
        children: i || $402be0a702aa527c$var$Qd
    });
};
$402be0a702aa527c$export$e575a964a1fe8b0.secretKey = "SidebarHeader";
class $402be0a702aa527c$var$ef extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(){
        super(...arguments), Object.defineProperty(this, "getRootStyle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>({
                    ...this.props.style,
                    display: "flex",
                    width: "100%"
                })
        }), Object.defineProperty(this, "getCalendarHeaderStyle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                const { leftSidebarWidth: i, rightSidebarWidth: a, calendarHeaderStyle: u } = this.props;
                return {
                    ...u,
                    overflow: "hidden",
                    width: `calc(100% - ${i + a}px)`
                };
            }
        }), Object.defineProperty(this, "isSidebarHeader", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i)=>i.type === void 0 ? !1 : i.type.secretKey === $402be0a702aa527c$export$e575a964a1fe8b0.secretKey
        });
    }
    render() {
        let i, a;
        const u = [], f = Array.isArray(this.props.children) ? this.props.children.filter((v)=>v) : [
            this.props.children
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(f, (v)=>{
            var m;
            this.isSidebarHeader(v) ? ((m = v == null ? void 0 : v.props) == null ? void 0 : m.variant) === $402be0a702aa527c$var$ro ? i = v : a = v : u.push(v);
        }), a || (a = (0, $ayMG0.jsx)($402be0a702aa527c$export$e575a964a1fe8b0, {})), !i && this.props.rightSidebarWidth && (i = (0, $ayMG0.jsx)($402be0a702aa527c$export$e575a964a1fe8b0, {
            variant: "right"
        })), (0, $ayMG0.jsxs)("div", {
            "data-testid": "headerRootDiv",
            style: this.getRootStyle(),
            className: $402be0a702aa527c$var$mi("rct-header-root", this.props.className),
            children: [
                a,
                (0, $ayMG0.jsx)("div", {
                    ref: this.props.registerScroll,
                    style: this.getCalendarHeaderStyle(),
                    className: $402be0a702aa527c$var$mi("rct-calendar-header", this.props.calendarHeaderClassName),
                    "data-testid": "headerContainer",
                    children: u
                }),
                i
            ]
        });
    }
}
const $402be0a702aa527c$export$2ee434a1d99db2a0 = ({ children: s, style: i, className: a, calendarHeaderStyle: u, calendarHeaderClassName: f })=>{
    const { leftSidebarWidth: v, rightSidebarWidth: m, registerScroll: y } = $402be0a702aa527c$var$Xr();
    return (0, $ayMG0.jsx)($402be0a702aa527c$var$ef, {
        leftSidebarWidth: v,
        rightSidebarWidth: m,
        registerScroll: y,
        style: i,
        className: a,
        calendarHeaderStyle: u,
        calendarHeaderClassName: f,
        children: s
    });
};
$402be0a702aa527c$export$2ee434a1d99db2a0.secretKey = "TimelineHeaders";
class $402be0a702aa527c$var$no extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(i){
        super(i), Object.defineProperty(this, "getHeaderIntervals", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ({ canvasTimeStart: x, canvasTimeEnd: O, unit: $, timeSteps: P, getLeftOffsetFromDate: T })=>{
                const _ = [];
                return $402be0a702aa527c$var$Lr(x, O, $, P, (M, C)=>{
                    const z = T(M.valueOf()), G = T(C.valueOf()) - z;
                    _.push({
                        startTime: M,
                        endTime: C,
                        labelWidth: G,
                        left: z
                    });
                }), _;
            }
        }), Object.defineProperty(this, "getRootProps", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (x = {})=>{
                const { style: O } = x;
                return {
                    style: Object.assign({}, O || {}, {
                        position: "relative",
                        width: this.props.canvasWidth,
                        height: this.props.height
                    })
                };
            }
        }), Object.defineProperty(this, "getIntervalProps", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (x = {})=>{
                const { interval: O, style: $ } = x;
                if (!O) throw new Error("you should provide interval to the prop getter");
                const { startTime: P, labelWidth: T, left: _ } = O;
                return {
                    style: {
                        ...$,
                        left: _,
                        width: T,
                        position: "absolute"
                    },
                    key: `label-${P.valueOf()}`
                };
            }
        }), Object.defineProperty(this, "getStateAndHelpers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                const { /*canvasTimeStart,
          canvasTimeEnd,
          timelineWidth,
          visibleTimeStart,
          visibleTimeEnd,*/ unit: x, showPeriod: O, headerData: $ } = this.props;
                return {
                    /*timelineContext: {
            timelineWidth,
            visibleTimeStart,
            visibleTimeEnd,
            canvasTimeStart,
            canvasTimeEnd,
          },*/ headerContext: {
                        unit: x,
                        intervals: this.state.intervals
                    },
                    getRootProps: this.getRootProps,
                    getIntervalProps: this.getIntervalProps,
                    showPeriod: O,
                    data: $
                };
            }
        });
        const { canvasTimeStart: a, canvasTimeEnd: u, unit: f, timeSteps: v, getLeftOffsetFromDate: m } = i, y = this.getHeaderIntervals({
            canvasTimeStart: a,
            canvasTimeEnd: u,
            unit: f,
            timeSteps: v,
            getLeftOffsetFromDate: m
        });
        this.state = {
            intervals: y
        };
    }
    /*shouldComponentUpdate(nextProps: CustomHeaderProps<Data>) {
    if (
      nextProps.canvasTimeStart !== this.props.canvasTimeStart ||
      nextProps.canvasTimeEnd !== this.props.canvasTimeEnd ||
      nextProps.canvasWidth !== this.props.canvasWidth ||
      nextProps.unit !== this.props.unit ||
      nextProps.timeSteps !== this.props.timeSteps ||
      nextProps.showPeriod !== this.props.showPeriod ||
      nextProps.children !== this.props.children ||
      nextProps.headerData !== this.props.headerData
    ) {
      return true
    }
    return false
  }*/ componentDidUpdate(i) {
        if (!$402be0a702aa527c$var$Ir(i, this.props)) {
            const { canvasTimeStart: a, canvasTimeEnd: u, unit: f, timeSteps: v, getLeftOffsetFromDate: m } = this.props, y = this.getHeaderIntervals({
                canvasTimeStart: a,
                canvasTimeEnd: u,
                unit: f,
                timeSteps: v,
                getLeftOffsetFromDate: m
            });
            this.setState({
                intervals: y
            });
        }
    }
    render() {
        const i = this.getStateAndHelpers();
        return this.props.children(i);
    }
}
Object.defineProperty($402be0a702aa527c$var$no, "defaultProps", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        height: 30
    }
});
function $402be0a702aa527c$export$a231a61d189ef09a({ children: s, unit: i, headerData: a, height: u }) {
    const { getTimelineState: f, showPeriod: v, getLeftOffsetFromDate: m } = $402be0a702aa527c$var$fd(), y = f(), { timeSteps: x } = $402be0a702aa527c$var$Xr();
    return (0, $ayMG0.jsx)($402be0a702aa527c$var$no, {
        children: s,
        timeSteps: x,
        showPeriod: v,
        unit: i || y.timelineUnit,
        ...y,
        headerData: a,
        getLeftOffsetFromDate: m,
        height: u
    });
}
var $402be0a702aa527c$var$bi = Number.isNaN || function(i) {
    return typeof i == "number" && i !== i;
};
function $402be0a702aa527c$var$rf(s, i) {
    return !!(s === i || $402be0a702aa527c$var$bi(s) && $402be0a702aa527c$var$bi(i));
}
function $402be0a702aa527c$var$nf(s, i) {
    if (s.length !== i.length) return !1;
    for(var a = 0; a < s.length; a++)if (!$402be0a702aa527c$var$rf(s[a], i[a])) return !1;
    return !0;
}
function $402be0a702aa527c$var$yi(s, i) {
    i === void 0 && (i = $402be0a702aa527c$var$nf);
    var a = null;
    function u() {
        for(var f = [], v = 0; v < arguments.length; v++)f[v] = arguments[v];
        if (a && a.lastThis === this && i(f, a.lastArgs)) return a.lastResult;
        var m = s.apply(this, f);
        return a = {
            lastResult: m,
            lastArgs: f,
            lastThis: this
        }, m;
    }
    return u.clear = function() {
        a = null;
    }, u;
}
class $402be0a702aa527c$var$of extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent {
    constructor(){
        super(...arguments), Object.defineProperty(this, "onIntervalClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                const { primaryHeader: i, interval: a, unit: u, showPeriod: f } = this.props;
                if (i) {
                    const v = $402be0a702aa527c$var$Hr(u), m = a.startTime.clone().startOf(v), y = a.startTime.clone().endOf(v);
                    f(m, y);
                } else f(a.startTime, a.endTime);
            }
        }), Object.defineProperty(this, "getIntervalProps", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i = {})=>({
                    ...this.props.getIntervalProps({
                        interval: this.props.interval,
                        ...i
                    }),
                    onClick: $402be0a702aa527c$var$Ke(this.onIntervalClick, i.onClick)
                })
        });
    }
    render() {
        const { intervalText: i, interval: a, intervalRenderer: u, headerData: f } = this.props, v = u;
        if (v) return v({
            getIntervalProps: this.getIntervalProps,
            intervalContext: {
                interval: a,
                intervalText: i
            },
            data: f
        });
        const { key: m, ...y } = this.getIntervalProps();
        return (0, $acw62.createElement)("div", {
            "data-testid": "dateHeaderInterval",
            ...y,
            key: m,
            className: `rct-dateHeader ${this.props.primaryHeader ? "rct-dateHeader-primary" : ""}`
        }, (0, $ayMG0.jsx)("span", {
            children: i
        }));
    }
}
function $402be0a702aa527c$var$sf({ headerContext: { intervals: s, unit: i }, getRootProps: a, getIntervalProps: u, showPeriod: f, data: { style: v, intervalRenderer: m, className: y, getLabelFormat: x, unitProp: O, headerData: $ } }) {
    return (0, $ayMG0.jsx)("div", {
        "data-testid": "dateHeader",
        className: y,
        ...a({
            style: v
        }),
        children: s.map((P)=>{
            const T = x([
                P.startTime,
                P.endTime
            ], i, P.labelWidth);
            return (0, $ayMG0.jsx)($402be0a702aa527c$var$of, {
                unit: i,
                interval: P,
                showPeriod: f,
                intervalText: T,
                primaryHeader: O === "primaryHeader",
                getIntervalProps: u,
                intervalRenderer: m,
                headerData: $
            }, `label-${P.startTime.valueOf()}`);
        })
    });
}
class $402be0a702aa527c$var$af extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(){
        super(...arguments), Object.defineProperty(this, "getHeaderUnit", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>this.props.unit === "primaryHeader" ? $402be0a702aa527c$var$Hr(this.props.timelineUnit) : this.props.unit ? this.props.unit : this.props.timelineUnit
        }), Object.defineProperty(this, "getRootStyle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $402be0a702aa527c$var$yi((i)=>({
                    height: 30,
                    ...i
                }))
        }), Object.defineProperty(this, "getLabelFormat", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (i, a, u)=>{
                const { labelFormat: f } = this.props;
                if (typeof f == "string") return i[0].format(f);
                if (typeof f == "function") return f(i, a, u);
                throw new Error("labelFormat should be function or string");
            }
        }), Object.defineProperty(this, "getHeaderData", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $402be0a702aa527c$var$yi((i, a, u, f, v, m)=>({
                    intervalRenderer: i,
                    style: a,
                    className: u,
                    getLabelFormat: f,
                    unitProp: v,
                    headerData: m
                }))
        });
    }
    render() {
        const i = this.getHeaderUnit(), { height: a } = this.props;
        return (0, $ayMG0.jsx)($402be0a702aa527c$export$a231a61d189ef09a, {
            children: $402be0a702aa527c$var$sf,
            unit: i,
            height: a,
            headerData: this.getHeaderData(this.props.intervalRenderer, this.getRootStyle(this.props.style), this.props.className, this.getLabelFormat, this.props.unit, this.props.headerData)
        });
    }
}
function $402be0a702aa527c$export$e8d17be7d8196f34({ labelFormat: s, unit: i, style: a, className: u, intervalRenderer: f, headerData: v, height: m }) {
    return (0, $ayMG0.jsx)($402be0a702aa527c$var$qt, {
        children: ({ getTimelineState: y })=>{
            const x = y();
            return (0, $ayMG0.jsx)($402be0a702aa527c$var$af, {
                timelineUnit: x.timelineUnit,
                unit: i,
                labelFormat: s || $402be0a702aa527c$var$lf,
                style: a,
                className: u,
                intervalRenderer: f,
                headerData: v,
                height: m
            });
        }
    });
}
const $402be0a702aa527c$var$lf = ([s], i, a = 150, u = $402be0a702aa527c$var$Kd)=>{
    let f;
    return a >= 150 ? f = u[i].long : a >= 100 ? f = u[i].mediumLong : a >= 50 ? f = u[i].medium : f = u[i].short, s.format(f);
};
var $402be0a702aa527c$var$io = {
    exports: {}
};
(function(s, i) {
    (function(a, u) {
        s.exports = u();
    })($402be0a702aa527c$var$We, function() {
        var a = {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
        };
        return function(u, f, v) {
            var m = f.prototype, y = m.format;
            v.en.formats = a, m.format = function(x) {
                x === void 0 && (x = "YYYY-MM-DDTHH:mm:ssZ");
                var O = this.$locale().formats, $ = function(P, T) {
                    return P.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(_, M, C) {
                        var z = C && C.toUpperCase();
                        return M || T[C] || a[C] || T[z].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(N, G, Q) {
                            return G || Q.slice(1);
                        });
                    });
                }(x, O === void 0 ? {} : O);
                return y.call(this, $);
            };
        };
    });
})($402be0a702aa527c$var$io);
var $402be0a702aa527c$var$cf = $402be0a702aa527c$var$io.exports;
const $402be0a702aa527c$var$uf = /* @__PURE__ */ $402be0a702aa527c$var$Ze($402be0a702aa527c$var$cf);
$402be0a702aa527c$var$Me.extend($402be0a702aa527c$var$uf);
class $402be0a702aa527c$export$e6a97ba2cae5bb94 extends (0, $acw62.Component) {
    constructor(i){
        super(i), Object.defineProperty(this, "getTimelineContext", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                const { width: T, visibleTimeStart: _, visibleTimeEnd: M, canvasTimeStart: C, canvasTimeEnd: z } = this.state, N = M - _, G = $402be0a702aa527c$var$Re(T, this.props.buffer), Q = $402be0a702aa527c$var$kt(N, T, this.props.timeSteps);
                return {
                    canvasWidth: G,
                    timelineUnit: Q,
                    timelineWidth: T,
                    visibleTimeStart: _,
                    visibleTimeEnd: M,
                    canvasTimeStart: C,
                    canvasTimeEnd: z
                };
            }
        }), Object.defineProperty(this, "getTimelineUnit", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                const { width: T, visibleTimeStart: _, visibleTimeEnd: M } = this.state, { timeSteps: C } = this.props, z = M - _;
                return $402be0a702aa527c$var$kt(z, T, C);
            }
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "scrollComponent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "scrollHeaderRef", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resize", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T = this.props)=>{
                var re;
                const { width: _ } = ((re = this.container.current) == null ? void 0 : re.getBoundingClientRect()) ?? {
                    width: 0
                }, M = _ - T.sidebarWidth - T.rightSidebarWidth, C = $402be0a702aa527c$var$Re(M, T.buffer), { dimensionItems: z, height: N, groupHeights: G, groupTops: Q } = $402be0a702aa527c$var$qe(T.items, T.groups, C, this.state.canvasTimeStart, this.state.canvasTimeEnd, T.keys, T.lineHeight, T.itemHeightRatio, T.stackItems, this.state.draggingItem, this.state.resizingItem, this.state.dragTime, this.state.resizingEdge, this.state.resizeTime, this.state.newGroupOrder);
                this.setState({
                    width: M,
                    dimensionItems: z,
                    height: N,
                    groupHeights: G,
                    groupTops: Q
                });
                const te = M * ((T.buffer - 1) / 2);
                this.scrollComponent && (this.scrollComponent.scrollLeft = te), this.scrollHeaderRef && (this.scrollHeaderRef.scrollLeft = te);
            }
        }), Object.defineProperty(this, "onScroll", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T)=>{
                var N, G;
                const _ = this.state.width, M = this.state.canvasTimeStart, C = this.state.visibleTimeEnd - this.state.visibleTimeStart, z = M + C * T / _;
                (this.state.visibleTimeStart !== z || this.state.visibleTimeEnd !== z + C) && ((G = (N = this.props).onTimeChange) == null || G.call(N, z, z + C, this.updateScrollCanvas, this.getTimelineUnit()));
            }
        }), Object.defineProperty(this, "updateScrollCanvas", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _, M = !1, C = this.props.items, z = this.props.groups)=>{
                this.setState($402be0a702aa527c$var$Rr(T, _, M, C, z, this.props, this.state));
            }
        }), Object.defineProperty(this, "handleWheelZoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _, M)=>{
                this.changeZoom(1 + T * M / 500, _ / this.state.width);
            }
        }), Object.defineProperty(this, "changeZoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _ = 0.5)=>{
                const { minZoom: M, maxZoom: C } = this.props, z = this.state.visibleTimeEnd - this.state.visibleTimeStart, N = Math.min(Math.max(Math.round(z * T), M), C), G = Math.round(this.state.visibleTimeStart + (z - N) * _);
                this.props.onTimeChange && this.props.onTimeChange(G, G + N, this.updateScrollCanvas, this.getTimelineUnit());
            }
        }), Object.defineProperty(this, "showPeriod", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _)=>{
                var N, G;
                const M = T.valueOf(), z = _.valueOf() - M;
                z < this.props.minZoom || (G = (N = this.props).onTimeChange) == null || G.call(N, M, M + z, this.updateScrollCanvas, this.getTimelineUnit());
            }
        }), Object.defineProperty(this, "selectItem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _, M)=>{
                if (this.isItemSelected(T) || this.props.itemTouchSendsClick && _ === "touch") {
                    if (T && this.props.onItemClick) {
                        const C = this.timeFromItemEvent(M);
                        this.props.onItemClick(T, M, C);
                    }
                } else if (this.setState({
                    selectedItem: T
                }), T && this.props.onItemSelect) {
                    const C = this.timeFromItemEvent(M);
                    this.props.onItemSelect(T, M, C);
                } else T === null && this.props.onItemDeselect && this.props.onItemDeselect(M);
            }
        }), Object.defineProperty(this, "doubleClickItem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _)=>{
                if (this.props.onItemDoubleClick) {
                    const M = this.timeFromItemEvent(_);
                    this.props.onItemDoubleClick(T, _, M);
                }
            }
        }), Object.defineProperty(this, "contextMenuClickItem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _)=>{
                if (this.props.onItemContextMenu) {
                    const M = this.timeFromItemEvent(_);
                    this.props.onItemContextMenu(T, _, M);
                }
            }
        }), Object.defineProperty(this, "getTimeFromRowClickEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T)=>{
                const { dragSnap: _, buffer: M } = this.props, { width: C, canvasTimeStart: z, canvasTimeEnd: N } = this.state, { offsetX: G } = T.nativeEvent;
                let Q = $402be0a702aa527c$var$Ar(z, N, $402be0a702aa527c$var$Re(C, M), G);
                return Q = Math.floor(Q / _) * _, Q;
            }
        }), Object.defineProperty(this, "timeFromItemEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T)=>{
                const { width: _, visibleTimeStart: M, visibleTimeEnd: C } = this.state, z = this.props.dragSnap, N = this.scrollComponent, { left: G } = N.getBoundingClientRect(), te = (T.clientX - G) / _, re = C - M, ue = te * re;
                let S = Math.round(M + ue);
                return S = Math.floor(S / z) * z, S;
            }
        }), Object.defineProperty(this, "dragItem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _, M)=>{
                const C = this.props.groups[M], z = this.props.keys;
                this.setState({
                    draggingItem: T,
                    dragTime: _,
                    newGroupOrder: M,
                    dragGroupTitle: C ? $402be0a702aa527c$var$J(C, z.groupLabelKey) : ""
                }), this.updatingItem({
                    eventType: "move",
                    itemId: T,
                    time: _,
                    newGroupOrder: M
                });
            }
        }), Object.defineProperty(this, "dropItem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _, M)=>{
                this.setState({
                    draggingItem: null,
                    dragTime: null,
                    dragGroupTitle: null
                }), this.props.onItemMove && this.props.onItemMove(T, _, M);
            }
        }), Object.defineProperty(this, "resizingItem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _, M)=>{
                this.setState({
                    resizingItem: T,
                    resizingEdge: M,
                    resizeTime: _
                }), this.updatingItem({
                    eventType: "resize",
                    itemId: T,
                    time: _,
                    edge: M || void 0
                });
            }
        }), Object.defineProperty(this, "resizedItem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _, M, C)=>{
                this.setState({
                    resizingItem: null,
                    resizingEdge: null,
                    resizeTime: null
                }), this.props.onItemResize && C !== 0 && this.props.onItemResize(T, _, M);
            }
        }), Object.defineProperty(this, "updatingItem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ({ eventType: T, itemId: _, time: M, edge: C, newGroupOrder: z })=>{
                this.props.onItemDrag && (T === "move" ? this.props.onItemDrag({
                    eventType: T,
                    itemId: _,
                    time: M,
                    newGroupOrder: z
                }) : this.props.onItemDrag({
                    eventType: T,
                    itemId: _,
                    time: M,
                    edge: C
                }));
            }
        }), Object.defineProperty(this, "handleRowClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _)=>{
                if (this.hasSelectedItem() && this.selectItem(null, "click", T), this.props.onCanvasClick == null) return;
                const M = this.getTimeFromRowClickEvent(T), C = $402be0a702aa527c$var$J(this.props.groups[_], this.props.keys.groupIdKey);
                this.props.onCanvasClick(C, M, T);
            }
        }), Object.defineProperty(this, "handleRowDoubleClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _)=>{
                if (this.props.onCanvasDoubleClick == null) return;
                const M = this.getTimeFromRowClickEvent(T), C = $402be0a702aa527c$var$J(this.props.groups[_], this.props.keys.groupIdKey);
                this.props.onCanvasDoubleClick(C, M, T);
            }
        }), Object.defineProperty(this, "handleScrollContextMenu", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _)=>{
                if (this.props.onCanvasContextMenu == null) return;
                const M = this.getTimeFromRowClickEvent(T), C = $402be0a702aa527c$var$J(this.props.groups[_], this.props.keys.groupIdKey);
                this.props.onCanvasContextMenu && (T.preventDefault(), this.props.onCanvasContextMenu(C, M, T));
            }
        }), Object.defineProperty(this, "handleHeaderRef", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T)=>{
                this.scrollHeaderRef = T, this.props.headerRef && this.props.headerRef(T);
            }
        }), Object.defineProperty(this, "isTimelineHeader", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T)=>T.type === void 0 ? !1 : T.type.secretKey === $402be0a702aa527c$export$2ee434a1d99db2a0.secretKey
        }), Object.defineProperty(this, "renderHeaders", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>{
                if (this.props.children) {
                    let T;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(this.props.children, (_)=>{
                        this.isTimelineHeader(_) && (T = _);
                    }), T) return T;
                }
                return (0, $ayMG0.jsxs)($402be0a702aa527c$export$2ee434a1d99db2a0, {
                    children: [
                        (0, $ayMG0.jsx)($402be0a702aa527c$export$e8d17be7d8196f34, {
                            unit: "primaryHeader"
                        }),
                        (0, $ayMG0.jsx)($402be0a702aa527c$export$e8d17be7d8196f34, {})
                    ]
                });
            }
        }), Object.defineProperty(this, "getScrollElementRef", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T)=>{
                this.props.scrollRef && this.props.scrollRef(T), this.scrollComponent = T;
            }
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef()
        }), Object.defineProperty(this, "getBoundingClientRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ()=>this.scrollComponent.getBoundingClientRect()
        }), Object.defineProperty(this, "calculateDropCoordinatesToTimeAndGroup", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (T, _)=>{
                const M = $402be0a702aa527c$var$Re(this.state.width, this.props.buffer), C = $402be0a702aa527c$var$Ut(this.state.canvasTimeStart, this.state.canvasTimeEnd, M), z = $402be0a702aa527c$var$At(this.scrollComponent).offsetLeft, N = $402be0a702aa527c$var$jt(this.scrollComponent), G = (T - z + N.scrollLeft) * C + this.state.canvasTimeStart;
                let Q = 0;
                for (const re of this.state.groupTops)if (_ > Number(re)) Q = this.state.groupTops.indexOf(re);
                else break;
                if (!this.props.dragSnap) return {
                    time: G,
                    groupIndex: Q
                };
                const te = $402be0a702aa527c$var$Me().utcOffset() * 60000;
                return {
                    time: Math.round(G / this.props.dragSnap) * this.props.dragSnap - te % this.props.dragSnap,
                    groupIndex: Q
                };
            }
        }), this.getSelected = this.getSelected.bind(this), this.hasSelectedItem = this.hasSelectedItem.bind(this), this.isItemSelected = this.isItemSelected.bind(this);
        let a = null, u = null;
        if (this.props.defaultTimeStart && this.props.defaultTimeEnd) a = this.props.defaultTimeStart, u = this.props.defaultTimeEnd;
        else if (this.props.visibleTimeStart && this.props.visibleTimeEnd) a = this.props.visibleTimeStart, u = this.props.visibleTimeEnd;
        else throw new Error('You must provide either "defaultTimeStart" and "defaultTimeEnd" or "visibleTimeStart" and "visibleTimeEnd" to initialize the Timeline');
        const [f, v] = $402be0a702aa527c$var$Ur(a, u, i.buffer), m = {
            width: 1e3,
            visibleTimeStart: a,
            visibleTimeEnd: u,
            canvasTimeStart: f,
            canvasTimeEnd: v,
            selectedItem: null,
            dragTime: null,
            dragGroupTitle: null,
            resizeTime: null,
            resizingItem: null,
            resizingEdge: null,
            newGroupOrder: 0
        }, y = $402be0a702aa527c$var$Re(m.width, i.buffer), { dimensionItems: x, height: O, groupHeights: $, groupTops: P } = $402be0a702aa527c$var$qe(i.items, i.groups, y, m.canvasTimeStart, m.canvasTimeEnd, i.keys, i.lineHeight, i.itemHeightRatio, i.stackItems, m.draggingItem, m.resizingItem, m.dragTime, m.resizingEdge, m.resizeTime, m.newGroupOrder);
        m.dimensionItems = x, m.height = O, m.groupHeights = $, m.groupTops = P, this.state = m;
    }
    componentDidMount() {
        this.resize(this.props), this.props.resizeDetector && this.props.resizeDetector.addListener && this.props.resizeDetector.addListener(this), $402be0a702aa527c$var$gi.addListener(this);
    }
    componentWillUnmount() {
        this.props.resizeDetector && this.props.resizeDetector.addListener && this.props.resizeDetector.removeListener(this), $402be0a702aa527c$var$gi.removeListener(this);
    }
    static getDerivedStateFromProps(i, a) {
        const { visibleTimeStart: u, visibleTimeEnd: f, items: v, groups: m } = i, y = {
            items: v,
            groups: m
        }, x = v !== a.items || m !== a.groups;
        if (u && f) Object.assign(y, $402be0a702aa527c$var$Rr(u, f, x, v, m, i, a));
        else if (x) {
            const O = $402be0a702aa527c$var$Re(a.width, i.buffer);
            Object.assign(y, $402be0a702aa527c$var$qe(v, m, O, a.canvasTimeStart, a.canvasTimeEnd, i.keys, i.lineHeight, i.itemHeightRatio, i.stackItems, a.draggingItem, a.resizingItem, a.dragTime, a.resizingEdge, a.resizeTime, a.newGroupOrder));
        }
        return y;
    }
    componentDidUpdate(i, a) {
        const u = this.state.visibleTimeEnd - this.state.visibleTimeStart, f = a.visibleTimeEnd - a.visibleTimeStart;
        this.props.onZoom && u !== f && this.props.onZoom(this.getTimelineContext(), this.getTimelineUnit()), this.props.onBoundsChange && this.state.canvasTimeStart !== a.canvasTimeStart && this.props.onBoundsChange(this.state.canvasTimeStart, this.state.canvasTimeStart + u * 3);
        const v = Math.round(this.state.width * (this.state.visibleTimeStart - this.state.canvasTimeStart) / u);
        (Math.round(a.width * (a.visibleTimeStart - a.canvasTimeStart) / f) !== v || this.scrollComponent.scrollLeft !== v) && (this.scrollComponent.scrollLeft = v, this.scrollHeaderRef.scrollLeft = v);
    }
    columns(i, a, u, f, v, m) {
        var y;
        return (0, $ayMG0.jsx)($402be0a702aa527c$var$yd, {
            canvasTimeStart: i,
            canvasTimeEnd: a,
            canvasWidth: u,
            lineCount: ((y = this.props.groups) == null ? void 0 : y.length) || 0,
            minUnit: f,
            timeSteps: v,
            height: m,
            verticalLineClassNamesForTime: this.props.verticalLineClassNamesForTime
        });
    }
    rows(i, a, u) {
        var f;
        return (0, $ayMG0.jsx)($402be0a702aa527c$var$Sd, {
            groups: u,
            canvasWidth: i,
            lineCount: ((f = this.props.groups) == null ? void 0 : f.length) || 0,
            groupHeights: a,
            clickTolerance: this.props.clickTolerance,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            horizontalLineClassNamesForGroup: this.props.horizontalLineClassNamesForGroup,
            onRowContextClick: this.handleScrollContextMenu
        });
    }
    items({ canvasTimeStart: i, canvasTimeEnd: a, canvasWidth: u, dimensionItems: f, groupTops: v }) {
        return (0, $ayMG0.jsx)($402be0a702aa527c$export$11b05e9638ecc4d4, {
            canvasTimeStart: i,
            canvasTimeEnd: a,
            canvasWidth: u,
            dimensionItems: f,
            groupTops: v,
            items: this.props.items,
            groups: this.props.groups,
            keys: this.props.keys,
            selectedItem: this.state.selectedItem || void 0,
            dragSnap: this.props.dragSnap,
            minResizeWidth: this.props.minResizeWidth,
            canChangeGroup: this.props.canChangeGroup,
            canMove: this.props.canMove,
            canResize: this.props.canResize,
            useResizeHandle: this.props.useResizeHandle,
            canSelect: this.props.canSelect,
            moveResizeValidator: this.props.moveResizeValidator,
            itemSelect: this.selectItem,
            itemDrag: this.dragItem,
            itemDrop: this.dropItem,
            onItemDoubleClick: this.doubleClickItem,
            onItemContextMenu: this.props.onItemContextMenu ? this.contextMenuClickItem : void 0,
            itemResizing: this.resizingItem,
            itemResized: this.resizedItem,
            itemRenderer: this.props.itemRenderer,
            selected: this.props.selected,
            scrollRef: this.scrollComponent
        });
    }
    sidebar(i, a) {
        const { sidebarWidth: u } = this.props;
        return u && (0, $ayMG0.jsx)($402be0a702aa527c$var$fi, {
            groups: this.props.groups,
            groupRenderer: this.props.groupRenderer,
            keys: this.props.keys,
            width: u,
            groupHeights: a,
            height: i
        });
    }
    rightSidebar(i, a) {
        const { rightSidebarWidth: u } = this.props;
        return u && (0, $ayMG0.jsx)($402be0a702aa527c$var$fi, {
            groups: this.props.groups,
            keys: this.props.keys,
            groupRenderer: this.props.groupRenderer,
            isRightSidebar: !0,
            width: u,
            groupHeights: a,
            height: i
        });
    }
    childrenWithProps(i, a, u, f, v, m, y, x, O, $, P) {
        if (!this.props.children) return null;
        const T = Array.isArray(this.props.children) ? this.props.children.filter((M)=>M) : [
            this.props.children
        ], _ = {
            canvasTimeStart: i,
            canvasTimeEnd: a,
            canvasWidth: u,
            visibleTimeStart: x,
            visibleTimeEnd: O,
            dimensionItems: f,
            items: this.props.items,
            groups: this.props.groups,
            keys: this.props.keys,
            groupHeights: v,
            groupTops: m,
            selected: this.getSelected(),
            height: y,
            minUnit: $,
            timeSteps: P
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(T, (M)=>this.isTimelineHeader(M) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(M, _));
    }
    getSelected() {
        return this.state.selectedItem && !this.props.selected ? [
            this.state.selectedItem
        ] : this.props.selected || [];
    }
    hasSelectedItem() {
        return Array.isArray(this.props.selected) ? this.props.selected.length > 0 : !!this.state.selectedItem;
    }
    isItemSelected(i) {
        return this.getSelected().some((u)=>u === i);
    }
    render() {
        const { items: i, groups: a, sidebarWidth: u, rightSidebarWidth: f, timeSteps: v, traditionalZoom: m, buffer: y } = this.props, { draggingItem: x, resizingItem: O, width: $, visibleTimeStart: P, visibleTimeEnd: T, canvasTimeStart: _, canvasTimeEnd: M } = this.state;
        let { dimensionItems: C, height: z, groupHeights: N, groupTops: G } = this.state;
        const Q = T - P, te = $402be0a702aa527c$var$Re($, y), re = $402be0a702aa527c$var$kt(Q, $, v);
        if (!!x || !!O) {
            const be = $402be0a702aa527c$var$qe(i, a, te, this.state.canvasTimeStart, this.state.canvasTimeEnd, this.props.keys, this.props.lineHeight, this.props.itemHeightRatio, this.props.stackItems, this.state.draggingItem, this.state.resizingItem, this.state.dragTime, this.state.resizingEdge, this.state.resizeTime, this.state.newGroupOrder);
            C = be.dimensionItems, z = be.height, N = be.groupHeights, G = be.groupTops;
        }
        const S = {
            height: `${z}px`
        };
        return (0, $ayMG0.jsx)($402be0a702aa527c$var$dd, {
            visibleTimeStart: P,
            visibleTimeEnd: T,
            canvasTimeStart: _,
            canvasTimeEnd: M,
            canvasWidth: te,
            showPeriod: this.showPeriod,
            timelineUnit: re,
            timelineWidth: this.state.width,
            children: (0, $ayMG0.jsx)($402be0a702aa527c$var$$d, {
                children: (0, $ayMG0.jsx)($402be0a702aa527c$var$Bd, {
                    registerScroll: this.handleHeaderRef,
                    timeSteps: v,
                    leftSidebarWidth: this.props.sidebarWidth,
                    rightSidebarWidth: this.props.rightSidebarWidth,
                    children: (0, $ayMG0.jsxs)("div", {
                        style: this.props.style,
                        ref: this.container,
                        className: `react-calendar-timeline ${this.props.className}`,
                        children: [
                            this.renderHeaders(),
                            (0, $ayMG0.jsxs)("div", {
                                style: S,
                                className: "rct-outer",
                                children: [
                                    u > 0 ? this.sidebar(z, N) : null,
                                    (0, $ayMG0.jsx)($402be0a702aa527c$var$xd, {
                                        scrollRef: this.getScrollElementRef,
                                        width: $,
                                        height: z,
                                        onZoom: this.changeZoom,
                                        onWheelZoom: this.handleWheelZoom,
                                        traditionalZoom: !!m,
                                        onScroll: this.onScroll,
                                        children: (0, $ayMG0.jsxs)($402be0a702aa527c$var$Fd, {
                                            children: [
                                                this.columns(_, M, te, re, v, z),
                                                this.rows(te, N, a),
                                                this.items({
                                                    canvasTimeStart: _,
                                                    canvasTimeEnd: M,
                                                    canvasWidth: te,
                                                    dimensionItems: C,
                                                    groupTops: G
                                                }),
                                                this.childrenWithProps(_, M, te, C, N, G, z, P, T, re, v)
                                            ]
                                        })
                                    }),
                                    f > 0 ? this.rightSidebar(z, N) : null
                                ]
                            })
                        ]
                    })
                })
            })
        });
    }
}
Object.defineProperty($402be0a702aa527c$export$e6a97ba2cae5bb94, "setDayjsLocale", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $402be0a702aa527c$var$Me.locale
});
Object.defineProperty($402be0a702aa527c$export$e6a97ba2cae5bb94, "defaultProps", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        sidebarWidth: 150,
        rightSidebarWidth: 0,
        dragSnap: 900000,
        // 15min
        minResizeWidth: 20,
        lineHeight: 30,
        itemHeightRatio: 0.65,
        buffer: 3,
        minZoom: 3600000,
        // 1 hour
        maxZoom: 157783680000,
        // 5 years
        clickTolerance: 3,
        // how many pixels can we drag for it to be still considered a click?
        canChangeGroup: !0,
        canMove: !0,
        canResize: "right",
        useResizeHandle: !1,
        canSelect: !0,
        stackItems: !1,
        traditionalZoom: !1,
        horizontalLineClassNamesForGroup: null,
        onItemMove: null,
        onItemResize: null,
        onItemClick: null,
        onItemSelect: null,
        onItemDeselect: null,
        onItemDrag: null,
        onCanvasClick: null,
        onItemDoubleClick: null,
        onItemContextMenu: null,
        onZoom: null,
        verticalLineClassNamesForTime: null,
        moveResizeValidator: null,
        dayBackground: null,
        defaultTimeStart: null,
        defaultTimeEnd: null,
        itemTouchSendsClick: !1,
        style: {},
        className: "",
        keys: $402be0a702aa527c$var$Yd,
        timeSteps: $402be0a702aa527c$var$Gd,
        headerRef: ()=>{},
        scrollRef: ()=>{},
        // if you pass in visibleTimeStart and visibleTimeEnd, you must also pass onTimeChange(visibleTimeStart, visibleTimeEnd),
        // which needs to update the props visibleTimeStart and visibleTimeEnd to the ones passed
        visibleTimeStart: null,
        visibleTimeEnd: null,
        onTimeChange: function(s, i, a) {
            a(s, i);
        },
        // called when the canvas area of the calendar changes
        onBoundsChange: null,
        children: null,
        selected: null
    }
});
const $402be0a702aa527c$export$261c7e0d88c702db = (s)=>s.children || null;
class $402be0a702aa527c$var$so extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(){
        super(...arguments), Object.defineProperty(this, "unsubscribe", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "getMarker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    componentDidMount() {
        const { unsubscribe: i, getMarker: a } = this.props.subscribeMarker({
            type: $402be0a702aa527c$var$Fe.Today,
            renderer: this.props.children,
            interval: this.props.interval
        });
        this.unsubscribe = i, this.getMarker = a;
    }
    componentWillUnmount() {
        this.unsubscribe != null && (this.unsubscribe(), this.unsubscribe = null);
    }
    componentDidUpdate(i) {
        if (i.interval !== this.props.interval && this.getMarker) {
            const a = this.getMarker();
            this.props.updateMarker({
                ...a,
                interval: this.props.interval
            });
        }
    }
    render() {
        return null;
    }
}
Object.defineProperty($402be0a702aa527c$var$so, "defaultProps", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        interval: 10000
    }
});
const $402be0a702aa527c$export$d4a27226ade5fb61 = (s)=>(0, $ayMG0.jsx)($402be0a702aa527c$var$Zt, {
        children: ({ subscribeMarker: i, updateMarker: a })=>(0, $ayMG0.jsx)($402be0a702aa527c$var$so, {
                subscribeMarker: i,
                updateMarker: a,
                ...s
            })
    });
$402be0a702aa527c$export$d4a27226ade5fb61.displayName = "TodayMarkerWrapper";
class $402be0a702aa527c$var$hf extends (0, $acw62.Component) {
    constructor(){
        super(...arguments), Object.defineProperty(this, "unsubscribe", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "getMarker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    componentDidUpdate(i) {
        if (i.date !== this.props.date && this.getMarker) {
            const a = this.getMarker();
            this.props.updateMarker({
                ...a,
                date: this.props.date
            });
        }
    }
    componentDidMount() {
        const { unsubscribe: i, getMarker: a } = this.props.subscribeMarker({
            type: $402be0a702aa527c$var$Fe.Custom,
            renderer: this.props.children,
            date: this.props.date
        });
        this.unsubscribe = i, this.getMarker = a;
    }
    componentWillUnmount() {
        this.unsubscribe != null && (this.unsubscribe(), this.unsubscribe = null);
    }
    render() {
        return null;
    }
}
const $402be0a702aa527c$export$2037ebd950c0fcb = (s)=>(0, $ayMG0.jsx)($402be0a702aa527c$var$Zt, {
        children: ({ subscribeMarker: i, updateMarker: a })=>(0, $ayMG0.jsx)($402be0a702aa527c$var$hf, {
                subscribeMarker: i,
                updateMarker: a,
                ...s
            })
    });
$402be0a702aa527c$export$2037ebd950c0fcb.displayName = "CustomMarkerWrapper";
class $402be0a702aa527c$var$ff extends (0, $acw62.Component) {
    constructor(){
        super(...arguments), Object.defineProperty(this, "unsubscribe", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    componentDidMount() {
        const { unsubscribe: i } = this.props.subscribeMarker({
            type: $402be0a702aa527c$var$Fe.Cursor,
            renderer: this.props.children
        });
        this.unsubscribe = i;
    }
    componentWillUnmount() {
        this.unsubscribe != null && (this.unsubscribe(), this.unsubscribe = null);
    }
    render() {
        return null;
    }
}
const $402be0a702aa527c$export$2747f3ef11cc49c9 = (s)=>(0, $ayMG0.jsx)($402be0a702aa527c$var$Zt, {
        children: ({ subscribeMarker: i })=>(0, $ayMG0.jsx)($402be0a702aa527c$var$ff, {
                subscribeMarker: i,
                ...s
            })
    });
$402be0a702aa527c$export$2747f3ef11cc49c9.displayName = "CursorMarkerWrapper";

});

parcelRegister("9RYDA", function(module, exports) {

$parcel$export(module.exports, "SpotSchedulePrintView", () => $524401630daf15f8$export$553651c5c73a7475);
/**
 * SpotSchedulePrintView Component
 *
 * Print-optimized list view of aircraft parking schedule.
 * Displays spot-by-spot schedule in table format for operational use.
 * Hidden on screen, only visible when printing.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $3bYfT = parcelRequire("3bYfT");

var $kCLFX = parcelRequire("kCLFX");
var $kfA3C = parcelRequire("kfA3C");

var $acw62 = parcelRequire("acw62");
/**
 * Calculate dwell duration in human-readable format
 */ function $524401630daf15f8$var$calculateDwell(startBucket, endBucket) {
    const totalMinutes = (endBucket - startBucket) * 15;
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor(totalMinutes % 1440 / 60);
    const minutes = totalMinutes % 60;
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
}
/**
 * Format bucket to readable date/time in 24-hour format
 */ function $524401630daf15f8$var$formatBucketTime(bucket, baseDate) {
    const date = (0, $kCLFX.addHours)(baseDate, bucket * 0.25); // 15-minute buckets
    return (0, $kfA3C.format)(date, "MMM d, HH:mm");
}
const $524401630daf15f8$export$553651c5c73a7475 = ({ spots: spots, aircraft: aircraft, placement: placement, horizonHours: horizonHours, startTime: startTime, rampShapes: rampShapes = [], statistics: statistics, rampName: rampName = "Ramp", dateRange: dateRange })=>{
    // Use start time as base date for timeline calculations
    const baseDate = startTime;
    // Create spot ID to name mapping
    const spotIdToName = (0, $acw62.useMemo)(()=>{
        const mapping = {};
        rampShapes.forEach((shape)=>{
            if (shape.type === "Spot" && shape.text) mapping[shape.id] = shape.text;
        });
        return mapping;
    }, [
        rampShapes
    ]);
    // Build spot assignments
    const spotAssignments = (0, $acw62.useMemo)(()=>{
        const assignments = {};
        // Initialize all spots
        spots.forEach((spot)=>{
            assignments[spot.id] = [];
        });
        // Populate assignments from placement
        aircraft.forEach((ac)=>{
            const placed = placement[ac.id];
            if (!placed) return;
            const aircraftType = ac.aircraft?.make && ac.aircraft?.model ? `${ac.aircraft.make} ${ac.aircraft.model}` : "Unknown Type";
            if ("segments" in placed) // Segmented placement - add each segment
            placed.segments.forEach((segment, idx)=>{
                const assignment = {
                    tailNumber: ac.tail_number,
                    aircraftType: aircraftType,
                    arrival: $524401630daf15f8$var$formatBucketTime(segment.startBucket, baseDate),
                    departure: $524401630daf15f8$var$formatBucketTime(segment.endBucket, baseDate),
                    duration: $524401630daf15f8$var$calculateDwell(segment.startBucket, segment.endBucket),
                    notes: `Segment ${idx + 1}/${placed.segments.length} (${placed.moveCount} moves)`
                };
                if (!assignments[segment.spotId]) assignments[segment.spotId] = [];
                assignments[segment.spotId].push(assignment);
            });
            else {
                // Single placement
                const assignment = {
                    tailNumber: ac.tail_number,
                    aircraftType: aircraftType,
                    arrival: $524401630daf15f8$var$formatBucketTime(ac.arrivalBucket, baseDate),
                    departure: $524401630daf15f8$var$formatBucketTime(ac.departureBucket, baseDate),
                    duration: $524401630daf15f8$var$calculateDwell(ac.arrivalBucket, ac.departureBucket),
                    notes: ""
                };
                if (!assignments[placed.spotId]) assignments[placed.spotId] = [];
                assignments[placed.spotId].push(assignment);
            }
        });
        // Sort assignments within each spot by arrival time
        Object.keys(assignments).forEach((spotId)=>{
            assignments[spotId].sort((a, b)=>a.arrival.localeCompare(b.arrival));
        });
        return assignments;
    }, [
        spots,
        aircraft,
        placement,
        baseDate
    ]);
    // Deduplicate and sort spots by name
    const sortedSpots = (0, $acw62.useMemo)(()=>{
        // First deduplicate by ID
        const uniqueById = new Map();
        spots.forEach((spot)=>{
            uniqueById.set(spot.id, spot);
        });
        // Then deduplicate by display name (in case same name, different IDs)
        const uniqueByName = new Map();
        Array.from(uniqueById.values()).forEach((spot)=>{
            const spotName = spotIdToName[spot.id] || spot.id;
            // Keep first occurrence of each name
            if (!uniqueByName.has(spotName)) uniqueByName.set(spotName, spot);
        });
        // Convert to array and sort by name
        return Array.from(uniqueByName.values()).sort((a, b)=>{
            const nameA = spotIdToName[a.id] || a.id;
            const nameB = spotIdToName[b.id] || b.id;
            return nameA.localeCompare(nameB, undefined, {
                numeric: true
            });
        });
    }, [
        spots,
        spotIdToName
    ]);
    // Calculate date range if not provided
    const displayDateRange = dateRange || `${(0, $kfA3C.format)(baseDate, "MMM d, yyyy")} - ${(0, $kfA3C.format)((0, $kCLFX.addHours)(baseDate, horizonHours), "MMM d, yyyy")}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        className: "print-view-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                className: "print-view-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "h5",
                        component: "h1",
                        fontWeight: "bold",
                        gutterBottom: true,
                        children: [
                            "AutoPark Results - ",
                            rampName,
                            " - ",
                            displayDateRange
                        ]
                    }),
                    statistics && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        className: "print-view-stats",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                className: "print-view-stat-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "caption",
                                        display: "block",
                                        children: "Aircraft Placed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "h6",
                                        component: "div",
                                        children: [
                                            statistics.placedAircraft,
                                            " / ",
                                            statistics.totalAircraft
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                className: "print-view-stat-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "caption",
                                        display: "block",
                                        children: "Success Rate"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "h6",
                                        component: "div",
                                        children: [
                                            Math.round(statistics.placedAircraft / statistics.totalAircraft * 100),
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            statistics.averageMoves !== undefined && statistics.averageMoves > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                className: "print-view-stat-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "caption",
                                        display: "block",
                                        children: "Average Moves"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h6",
                                        component: "div",
                                        children: statistics.averageMoves.toFixed(1)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            sortedSpots.map((spot)=>{
                const spotName = spotIdToName[spot.id] || spot.id;
                const assignments = spotAssignments[spot.id] || [];
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    className: "print-view-spot-section",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            className: "print-view-spot-header",
                            children: spotName
                        }),
                        assignments.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "print-view-table",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Tail Number"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Aircraft Type"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Arrival"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Departure"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Duration"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Notes"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: assignments.map((assignment, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: assignment.tailNumber
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    children: assignment.aircraftType
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    children: assignment.arrival
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    children: assignment.departure
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    children: assignment.duration
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    children: assignment.notes
                                                })
                                            ]
                                        }, idx))
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            className: "print-view-empty",
                            children: "(No aircraft scheduled)"
                        })
                    ]
                }, spot.id);
            }),
            statistics && statistics.unplacedAircraft > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                className: "gantt-unplaced",
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        fontWeight: "bold",
                        gutterBottom: true,
                        children: [
                            "Unplaced Aircraft (",
                            statistics.unplacedAircraft,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        children: aircraft.filter((ac)=>!placement[ac.id]).map((ac)=>ac.tail_number).join(", ")
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("bnXem", function(module, exports) {

$parcel$export(module.exports, "ParkNextButton", () => $6abb2ad73ebb13b5$export$c267918f30749063);

var $ayMG0 = parcelRequire("ayMG0");

var $2eUTP = parcelRequire("2eUTP");

var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $cVXaD = parcelRequire("cVXaD");
parcelRequire("acw62");
const $6abb2ad73ebb13b5$export$c267918f30749063 = ({ onClick: onClick, disabled: disabled, disabledMessage: disabledMessage = "No unplaced aircraft available.", compact: compact = false, fullWidth: fullWidth = false })=>{
    const button = compact ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
        color: "primary",
        onClick: onClick,
        disabled: disabled,
        size: "small",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2eUTP))), {})
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
        variant: "outlined",
        color: "primary",
        onClick: onClick,
        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2eUTP))), {}),
        fullWidth: fullWidth,
        disabled: disabled,
        size: "small",
        children: "Park Next"
    });
    const tooltipTitle = compact ? "Park Next" : disabled ? disabledMessage : "";
    if (disabled || compact) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: tooltipTitle || disabledMessage,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: button
        })
    });
    return button;
};

});
parcelRegister("2eUTP", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1a19069bf77ec147$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a19069bf77ec147$var$_createSvgIcon = $1a19069bf77ec147$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1a19069bf77ec147$var$_default = module.exports.default = (0, $1a19069bf77ec147$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m6 18 8.5-6L6 6zM16 6v12h2V6z"
}), 'SkipNext');

});



parcelRegister("8vHzJ", function(module, exports) {

$parcel$export(module.exports, "MicroMetric", () => $07dd48ca2dca15d7$export$365ed52811c86ee5);
$parcel$export(module.exports, "calculateGeometryArea", () => $07dd48ca2dca15d7$export$9b5751392bc3c564);
$parcel$export(module.exports, "RampInfoCard", () => $07dd48ca2dca15d7$export$972fab16a844e18e);

var $ayMG0 = parcelRequire("ayMG0");

var $le4Y6 = parcelRequire("le4Y6");

var $hbZ6O = parcelRequire("hbZ6O");

var $ex6lH = parcelRequire("ex6lH");

var $1QUqu = parcelRequire("1QUqu");

var $8Sfdl = parcelRequire("8Sfdl");

var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $aQbYS = parcelRequire("aQbYS");

var $ioYla = parcelRequire("ioYla");

var $9Pb0P = parcelRequire("9Pb0P");
parcelRequire("9vNAe");
var $g2BFU = parcelRequire("g2BFU");
var $dfdxy = parcelRequire("dfdxy");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $64iGd = parcelRequire("64iGd");

var $3gD4P = parcelRequire("3gD4P");

var $kZKuk = parcelRequire("kZKuk");

var $5KGQl = parcelRequire("5KGQl");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $d7VTV = parcelRequire("d7VTV");

var $3dLiv = parcelRequire("3dLiv");

var $gQSh1 = parcelRequire("gQSh1");
parcelRequire("5tyjr");
var $cfcMM = parcelRequire("cfcMM");
const $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES = {
    aircraftOnRamp: "Aircraft parked within ramp outline / All aircraft shown on screen.",
    parkableArea: "Outlined ramp areas, excluding those marked as not parkable (eg taxiways, obstacles).",
    utilization: "Aircraft parked within ramp outline / All aircraft shown on screen.  (Note aircraft counts as parked when main wheels are within the overall ramp outline)",
    grossDimensions: "Basic length and width of ramp outline"
};
const $07dd48ca2dca15d7$export$365ed52811c86ee5 = ({ icon: icon, value: value, tooltip: tooltip })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: tooltip,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "row",
            spacing: 1,
            alignItems: "center",
            justifyContent: "flex-start",
            children: [
                icon,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "caption",
                    textAlign: "center",
                    color: "info.dark",
                    children: value
                })
            ]
        })
    });
};
const $07dd48ca2dca15d7$export$9b5751392bc3c564 = (geom)=>{
    if (geom.type === "Polygon") {
        const areas = geom.coordinates.map((coords)=>$07dd48ca2dca15d7$var$calculatePolygonArea(coords));
        return (0, $cLNZr.sum)(areas);
    }
    if (geom.type === "MultiPolygon") {
        const areas = geom.coordinates.flatMap((coordSet)=>coordSet.flatMap((coords)=>$07dd48ca2dca15d7$var$calculatePolygonArea(coords)));
        return (0, $cLNZr.sum)(areas);
    }
    return null;
};
const $07dd48ca2dca15d7$var$calculatePolygonArea = (coordinates)=>{
    let n = coordinates.length;
    let area = 0;
    for(let i = 0; i < n - 1; i++){
        const [x1, y1] = coordinates[i];
        const [x2, y2] = coordinates[i + 1];
        // Shoelace formula summation
        area += x1 * y2 - y1 * x2;
    }
    // Finalize the calculation (absolute value)
    return Math.abs(area) / 2;
};
const $07dd48ca2dca15d7$export$f4adc071ee7f743 = (polygons)=>{
    if (!polygons.length) return null;
    if (polygons.length === 1) return polygons[0];
    return (0, $9Pb0P.default)((0, $ioYla.featureCollection)(polygons));
};
const $07dd48ca2dca15d7$export$a80ed51d61482ba0 = (shape)=>{
    return (0, $ioYla.polygon)([
        [
            ...shape.points.map((point)=>[
                    point.x,
                    point.y
                ]),
            [
                shape.points[0].x,
                shape.points[0].y
            ]
        ]
    ]);
};
const $07dd48ca2dca15d7$export$d65933df5f5a23f8 = (ramp, ignoreObstructions = false)=>{
    const parkablePolygons = ramp.shapes.filter((s)=>s.tags.includes("parkable") && s.type === "Area")// this is actually covering up for a bug in the editor. not sure what's
    // causing it
    .filter((s)=>s.points.length > 2).map((shape)=>$07dd48ca2dca15d7$export$a80ed51d61482ba0(shape));
    if (!parkablePolygons.length) return null;
    if (ignoreObstructions) return $07dd48ca2dca15d7$export$f4adc071ee7f743(parkablePolygons);
    const isObstruction = (s)=>{
        if (s.tags.includes("obstruction") && s.type === "Area") return true;
        if (s.hangar_id) return true;
        return false;
    };
    const obstructionPolygons = ramp.shapes.filter(isObstruction)// this is actually covering up for a bug in the editor. not sure what's
    // causing it
    .filter((s)=>s.points.length > 2).map($07dd48ca2dca15d7$export$a80ed51d61482ba0);
    if (obstructionPolygons.length === 0) return $07dd48ca2dca15d7$export$f4adc071ee7f743(parkablePolygons);
    const combinedGeometry = $07dd48ca2dca15d7$export$f4adc071ee7f743(parkablePolygons);
    const obstructionGeometry = $07dd48ca2dca15d7$export$f4adc071ee7f743(obstructionPolygons);
    // remove obstruction from parkable area
    const parkableGeometry = (0, $aQbYS.default)((0, $ioYla.featureCollection)([
        combinedGeometry,
        obstructionGeometry
    ]));
    return parkableGeometry;
};
const $07dd48ca2dca15d7$export$62492e5091d9258 = (ramp)=>{
    try {
        const parkableGeometry = $07dd48ca2dca15d7$export$d65933df5f5a23f8(ramp);
        if (!parkableGeometry || !parkableGeometry.geometry) return 0;
        const parkableArea = $07dd48ca2dca15d7$export$9b5751392bc3c564(parkableGeometry.geometry);
        const obstructionArea = (0, $cLNZr.sum)(parkableGeometry.geometry.coordinates.slice(1).map((c)=>$07dd48ca2dca15d7$var$calculatePolygonArea(c)));
        return parkableArea - obstructionArea;
    } catch (e) {
        console.error(e);
        return 0;
    }
};
const $07dd48ca2dca15d7$export$f51625fff77161f6 = (ramp, entityPolygons, parkableArea)=>{
    if (!parkableArea || !parkableArea.geometry) return [];
    const parkableAreaPolygon = parkableArea.geometry.coordinates.flat()// inverted coordinates on the shapes
    .map((xy)=>[
            xy[0],
            ramp.depth - xy[1]
        ]);
    const tenantIdsFullyOnRamp = entityPolygons.filter((entityPolygon)=>{
        const { polygon: polygon } = entityPolygon;
        const isCompletedlyInside = (0, $dfdxy.polygonInPolygon)(polygon.coordinates[0], parkableAreaPolygon);
        if (isCompletedlyInside) return true;
        const bounds = entityPolygon.bounds;
        // check if the center of the entity is inside the parkable area
        const center = [
            (bounds[0][0] + bounds[1][0]) / 2,
            (bounds[0][1] + bounds[1][1]) / 2
        ];
        if ((0, $g2BFU.pointInPolygon)(center, parkableAreaPolygon)) return true;
    }).map(({ entity_id: entity_id })=>entity_id);
    const tenantsOnRamp = ramp.stack.tenants.filter((tenant)=>{
        return tenantIdsFullyOnRamp.indexOf(tenant.entity_id) > -1;
    });
    return tenantsOnRamp;
};
const $07dd48ca2dca15d7$export$cc573a7b400f64c4 = (ramp, rampParkableAreaPolygon, mustBeOnRamp = true, totalArea)=>{
    const area = totalArea || $07dd48ca2dca15d7$export$62492e5091d9258(ramp);
    // limit to aircraft that are within the parkable area
    const polygons = (0, $5KGQl.getStackPolygons)(ramp.stack, -1, 1);
    const tenants = mustBeOnRamp ? $07dd48ca2dca15d7$export$f51625fff77161f6(ramp, polygons, rampParkableAreaPolygon) : ramp.stack.tenants;
    const totalUtilizatedSqft = (0, $cLNZr.sum)(tenants.map((t)=>t.aircraft.length * t.aircraft.wingspan));
    const utilization = totalUtilizatedSqft / area;
    if (area === 0) return {
        nFullyOnRamp: tenants.length,
        utilizationFormatted: "0%"
    };
    const formatted = (0, $lNEp2.formatPercentage)(utilization, 0);
    if (formatted === "0%" && totalUtilizatedSqft > 0) return {
        nFullyOnRamp: tenants.length,
        utilizationFormatted: "<1%"
    };
    return {
        nFullyOnRamp: tenants.length,
        utilizationFormatted: formatted
    };
};
const $07dd48ca2dca15d7$export$972fab16a844e18e = ({ isDrawerOpen: isDrawerOpen, ramp: ramp, isScheduledView: isScheduledView = false, timeRange: timeRange, allPlacements: allPlacements = [] })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const rampLocation = (0, $3gD4P.useRampLocation)(ramp);
    // Fetch wind data for this ramp's location
    const { loading: windLoading, windData: windData, error: windError } = (0, $kZKuk.useWindData)(rampLocation?.latitude, rampLocation?.longitude);
    const useMetric = activeFBO?.settings?.useMetricSystem ?? false;
    // Create dynamic wind tooltip
    const windTooltip = $acw62.useMemo(()=>{
        if (windError) return `Unable to fetch wind data: ${windError}`;
        if (!windData) return "Current wind conditions from nearby weather station (updated every 5 minutes)";
        const lastUpdated = windData.timestamp ? new Date(windData.timestamp).toLocaleTimeString("en-US", {
            hour12: false
        }) : "Unknown";
        const stationInfo = windData.stationName ? `${windData.stationId} (${windData.stationName})` : windData.stationId;
        // Check if wind values are null (missing data from station)
        if (windData.speedMps === null && windData.directionDegrees === null) return `Wind data not available from ${stationInfo}\nLast checked: ${lastUpdated}\nRefreshes every 5 minutes`;
        return `Current wind conditions from ${stationInfo}\nLast updated: ${lastUpdated}\nRefreshes every 5 minutes`;
    }, [
        windError,
        windData
    ]);
    const rampParkableAreaPolygon = (0, $64iGd.useDebouncedValue)(()=>{
        if (ramp?.version === "v2") return $07dd48ca2dca15d7$export$d65933df5f5a23f8(ramp, true);
        return null;
    }, 50, [
        ramp.shapes
    ]);
    // this is really expensive to calculate. so do it as little as possible.
    const { nFullyOnRamp: nFullyOnRamp, utilizationFormatted: utilizationFormatted } = (0, $64iGd.useDebouncedValue)(()=>{
        if (ramp?.version === "v2") return $07dd48ca2dca15d7$export$cc573a7b400f64c4(ramp, rampParkableAreaPolygon, true);
        return {
            nFullyOnRamp: 0,
            utilizationFormatted: "0%"
        };
    }, 50, [
        ramp.stack.tenants,
        rampParkableAreaPolygon
    ]);
    const { utilizationFormatted: totalPossibleUtilizationFormatted } = (0, $64iGd.useDebouncedValue)(()=>{
        if (ramp?.version === "v2") return $07dd48ca2dca15d7$export$cc573a7b400f64c4(ramp, rampParkableAreaPolygon, false);
        return {
            utilizationFormatted: "0%"
        };
    }, 50, [
        ramp.stack.tenants,
        rampParkableAreaPolygon
    ]);
    const shapeUtilizations = (0, $64iGd.useDebouncedValue)(()=>{
        const shapesToCalculate = ramp.shapes.filter((s)=>s.tags.includes("utilization"));
        return shapesToCalculate.map((shape)=>{
            const shapePolygon = $07dd48ca2dca15d7$export$a80ed51d61482ba0(shape);
            const shapeArea = $07dd48ca2dca15d7$export$9b5751392bc3c564(shapePolygon.geometry);
            const shapeUtilization = $07dd48ca2dca15d7$export$cc573a7b400f64c4(ramp, shapePolygon, true, shapeArea);
            return {
                name: shape.text || "---",
                utilization: shapeUtilization.utilizationFormatted
            };
        }).sort((a, b)=>a.name.localeCompare(b.name));
    }, 50, [
        ramp.stack.tenants,
        ramp.shapes
    ]);
    const [isUtilizationsExpanded, setUtilizationsExpanded] = $acw62.useState(false);
    const handleUtilizationsChange = $acw62.useCallback(()=>{
        setUtilizationsExpanded((prev)=>!prev);
    }, []);
    // New metrics for scheduled view
    const currentTime = timeRange ? new Date((timeRange.start.getTime() + timeRange.end.getTime()) / 2) : new Date();
    const activeTrips = (0, $64iGd.useDebouncedValue)(()=>{
        if (!isScheduledView || !allPlacements) return 0;
        return (0, $3dLiv.calculateActiveAircraft)(allPlacements, currentTime, ramp.id, "ramp");
    }, 100, [
        isScheduledView,
        allPlacements,
        allPlacements?.length,
        currentTime,
        ramp.id
    ]);
    const futureTrips = (0, $64iGd.useDebouncedValue)(()=>{
        if (!isScheduledView || !allPlacements) return 0;
        return (0, $3dLiv.calculateAssignedAircraft)(allPlacements, currentTime, ramp.id, "ramp");
    }, 100, [
        isScheduledView,
        allPlacements,
        allPlacements?.length,
        currentTime,
        ramp.id
    ]);
    const dimensions = activeFBO?.settings?.useMetricSystem ? `${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(ramp.depth), 0)}L x ${(0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(ramp.width), 0)}W` : `${(0, $cLNZr.round)(ramp.depth, 0)}L x ${(0, $cLNZr.round)(ramp.width)}W`;
    const parkableAreaDisplay = activeFBO?.settings?.useMetricSystem ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: `${(0, $lNEp2.formatNumber)((0, $d7VTV.squareFeetToSquareMeters)($07dd48ca2dca15d7$export$62492e5091d9258(ramp)), 0)} m\xb2`
    }) : isDrawerOpen ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            `${(0, $lNEp2.formatNumber)($07dd48ca2dca15d7$export$62492e5091d9258(ramp) / 1000, 0)}K ft\xb2`,
            " (",
            `${(0, $lNEp2.formatNumber)($07dd48ca2dca15d7$export$62492e5091d9258(ramp) / 43560, 2)} acres`,
            ")"
        ]
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: `${(0, $lNEp2.formatNumber)($07dd48ca2dca15d7$export$62492e5091d9258(ramp) / 1000, 0)}K ft\xb2`
    });
    /**
  // TODO: this is a work in progress. we need to calculate the hangar
  React.useEffect(() => {
    const polygons = getStackPolygons(ramp.stack, -1, 1);
    for (const polygon of polygons) {
      for (const hangar of ramp.shapes.filter((s) => Boolean(s.hangar_id))) {
        if (
          polygonInPolygon(
            polygon.polygon.coordinates[0],
            hangar.points.map((p) => [p.x, ramp.depth - p.y])
          )
        ) {
          const tenant = ramp.stack.tenants.find(
            (t) => t.entity_id === polygon.entity_id
          );
          console.log(`${tenant?.tail_number} 'is inside' ${hangar.hangar_id}`);
          // it might not be 100% true, but the hangar is rectangular in some form or fashion
          // we need to calculate the angle of the bottom-left arc of the hangar relative to
          // true up/down. with that angle, we will translate the position (x, y, angle) of the
          // aircraft so that it's relative to the hangar.
          //
          // invoke setHangars
        }
      }
    }
  }, [ramp.stack.tenants, rampParkableAreaPolygon]);
   */ if (!isDrawerOpen) {
        if (ramp?.version === "v2") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
            direction: "column",
            alignItems: "center",
            height: 150,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                spacing: 1,
                sx: {
                    p: 2,
                    maxHeight: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($07dd48ca2dca15d7$export$365ed52811c86ee5, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($le4Y6))), {}),
                        value: `${(0, $lNEp2.formatNumber)(nFullyOnRamp, 0)} / ${(0, $lNEp2.formatNumber)(ramp.stack?.tenants?.length ?? 0, 0)}`,
                        tooltip: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.aircraftOnRamp
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($07dd48ca2dca15d7$export$365ed52811c86ee5, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1QUqu))), {}),
                        value: `${utilizationFormatted} / ${totalPossibleUtilizationFormatted}`,
                        tooltip: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.utilization
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($07dd48ca2dca15d7$export$365ed52811c86ee5, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Sfdl))), {}),
                        value: parkableAreaDisplay,
                        tooltip: "Total square footage of parkable space on the ramp"
                    }),
                    rampLocation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfcMM.WindDisplay), {
                        loading: windLoading,
                        windData: windData,
                        error: windError,
                        useMetric: useMetric,
                        compact: true
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
            direction: "column",
            alignItems: "center",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                spacing: 1,
                sx: {
                    p: 2,
                    maxHeight: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($07dd48ca2dca15d7$export$365ed52811c86ee5, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($le4Y6))), {}),
                        value: `${(0, $lNEp2.formatNumber)(ramp.stack?.tenants?.length ?? 0, 0)}`,
                        tooltip: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.parkableArea
                    }),
                    rampLocation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfcMM.WindDisplay), {
                        loading: windLoading,
                        windData: windData,
                        error: windError,
                        useMetric: useMetric,
                        compact: true
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        sx: {
            p: 2,
            maxHeight: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        textAlign: "center",
                                        children: "Aircraft"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.aircraftOnRamp,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                            sx: {
                                                color: "info.dark"
                                            },
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                textAlign: "center",
                                color: "info.dark",
                                children: `${(0, $lNEp2.formatNumber)(nFullyOnRamp, 0)} / ${(0, $lNEp2.formatNumber)(ramp.stack?.tenants?.length ?? 0, 0)}`
                            })
                        ]
                    }),
                    ramp?.version === "v2" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                orientation: "vertical",
                                variant: "middle",
                                flexItem: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                sx: {
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                textAlign: "center",
                                                children: "Utilization"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                title: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.utilization,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                    sx: {
                                                        color: "info.dark"
                                                    },
                                                    fontSize: "small"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        spacing: 0,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                textAlign: "center",
                                                color: "info.dark",
                                                align: "center",
                                                component: "div",
                                                sx: {
                                                    fontWeight: "medium",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                },
                                                onClick: handleUtilizationsChange,
                                                children: [
                                                    `${utilizationFormatted} / ${totalPossibleUtilizationFormatted}`,
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {
                                                        fontSize: "small",
                                                        sx: {
                                                            transform: isUtilizationsExpanded ? "rotate(180deg)" : "rotate(0)",
                                                            transition: "transform 150ms ease"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                                sx: {
                                                    height: isUtilizationsExpanded ? "auto" : 0,
                                                    overflow: "hidden",
                                                    transition: "height 150ms cubic-bezier(0.4, 0, 0.2, 1)",
                                                    visibility: isUtilizationsExpanded ? "visible" : "hidden"
                                                },
                                                children: shapeUtilizations.map((shapeUtilization, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        textAlign: "center",
                                                        color: "info.dark",
                                                        children: [
                                                            shapeUtilization.name,
                                                            ": ",
                                                            shapeUtilization.utilization
                                                        ]
                                                    }, `shape-utilization-${idx}`))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            rampLocation && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                        orientation: "vertical",
                                        variant: "middle",
                                        flexItem: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        textAlign: "center",
                                                        children: "Wind"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: windTooltip,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                            sx: {
                                                                color: "info.dark"
                                                            },
                                                            fontSize: "small"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                textAlign: "center",
                                                color: "info.dark",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfcMM.WindDisplay), {
                                                    loading: windLoading,
                                                    windData: windData,
                                                    error: windError,
                                                    useMetric: useMetric
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                orientation: "vertical",
                                flexItem: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                direction: "column",
                                sx: {
                                    width: "100%"
                                },
                                children: isScheduledView ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    textAlign: "center",
                                                    children: "Trips"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: "Active trips / Future trips assigned to this ramp",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                        sx: {
                                                            color: "info.dark"
                                                        },
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    style: {
                                                        color: "inherit"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                            value: activeTrips,
                                                            text: activeTrips
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                "/ ",
                                                futureTrips
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    textAlign: "center",
                                                    children: "Gross Dimensions"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.grossDimensions,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                        sx: {
                                                            color: "info.dark"
                                                        },
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: dimensions
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            ramp?.version === "v2" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        children: isScheduledView ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    textAlign: "center",
                                                    children: "Trips"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: "Active trips / Future trips assigned to this ramp",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                        sx: {
                                                            color: "info.dark"
                                                        },
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    style: {
                                                        color: "inherit"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                            value: activeTrips,
                                                            text: activeTrips
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                "/ ",
                                                futureTrips
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                    orientation: "vertical",
                                    variant: "middle",
                                    flexItem: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    textAlign: "center",
                                                    children: "Parkable Area"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.parkableArea,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                        sx: {
                                                            color: "info.dark"
                                                        },
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: parkableAreaDisplay
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    textAlign: "center",
                                                    children: "Parkable Area"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.parkableArea,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                        sx: {
                                                            color: "info.dark"
                                                        },
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: parkableAreaDisplay
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                    orientation: "vertical",
                                    variant: "middle",
                                    flexItem: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    textAlign: "center",
                                                    children: "Gross Dimensions"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: $07dd48ca2dca15d7$var$TOOLTIP_MESSAGES.grossDimensions,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                        sx: {
                                                            color: "info.dark"
                                                        },
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: dimensions
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("aQbYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e480dda420629f4$export$2e2bcd8739ae039);
// index.ts

var $kxJOP = parcelRequire("kxJOP");

var $ioYla = parcelRequire("ioYla");

var $25Xct = parcelRequire("25Xct");
function $7e480dda420629f4$export$acaf96a27438246b(features) {
    const geoms = [];
    (0, $25Xct.geomEach)(features, (geom)=>{
        geoms.push(geom.coordinates);
    });
    if (geoms.length < 2) throw new Error("Must have at least two features");
    const properties = features.features[0].properties || {};
    const differenced = $kxJOP.difference(geoms[0], ...geoms.slice(1));
    if (differenced.length === 0) return null;
    if (differenced.length === 1) return (0, $ioYla.polygon)(differenced[0], properties);
    return (0, $ioYla.multiPolygon)(differenced, properties);
}
var $7e480dda420629f4$export$2e2bcd8739ae039 = $7e480dda420629f4$export$acaf96a27438246b;

});

parcelRegister("9Pb0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $72716b4a4f588c0c$export$2e2bcd8739ae039);
// index.ts

var $kxJOP = parcelRequire("kxJOP");

var $ioYla = parcelRequire("ioYla");

var $25Xct = parcelRequire("25Xct");
function $72716b4a4f588c0c$export$971dd5b0dfd021b6(features, options = {}) {
    const geoms = [];
    (0, $25Xct.geomEach)(features, (geom)=>{
        geoms.push(geom.coordinates);
    });
    if (geoms.length < 2) throw new Error("Must have at least 2 geometries");
    const unioned = $kxJOP.union(geoms[0], ...geoms.slice(1));
    if (unioned.length === 0) return null;
    if (unioned.length === 1) return (0, $ioYla.polygon)(unioned[0], options.properties);
    else return (0, $ioYla.multiPolygon)(unioned, options.properties);
}
var $72716b4a4f588c0c$export$2e2bcd8739ae039 = $72716b4a4f588c0c$export$971dd5b0dfd021b6;

});

parcelRegister("3gD4P", function(module, exports) {

$parcel$export(module.exports, "useRampLocation", () => $a39e3253085b0429$export$45933e8ccae5646a);

var $acw62 = parcelRequire("acw62");
const $a39e3253085b0429$export$45933e8ccae5646a = (ramp)=>{
    return $acw62.useMemo(()=>{
        if (!ramp?.calibration_points || ramp.calibration_points.length === 0) return null;
        const points = ramp.calibration_points;
        const sumLat = points.reduce((sum, point)=>sum + point.latitude, 0);
        const sumLng = points.reduce((sum, point)=>sum + point.longitude, 0);
        return {
            latitude: sumLat / points.length,
            longitude: sumLng / points.length
        };
    }, [
        ramp?.calibration_points
    ]);
};

});

parcelRegister("kZKuk", function(module, exports) {

$parcel$export(module.exports, "useWindData", () => $566d95316465845b$export$1cceba5547858250);

var $acw62 = parcelRequire("acw62");

var $8NlK4 = parcelRequire("8NlK4");
const $566d95316465845b$var$REFRESH_INTERVAL_MS = 300000; // 5 minutes
const $566d95316465845b$export$1cceba5547858250 = (latitude, longitude)=>{
    const [loading, setLoading] = $acw62.useState(false);
    const [windData, setWindData] = $acw62.useState(null);
    const [error, setError] = $acw62.useState(null);
    const weatherService = $acw62.useMemo(()=>new (0, $8NlK4.WeatherService)(), []);
    const fetchWindData = $acw62.useCallback(async ()=>{
        if (latitude === null || latitude === undefined || longitude === null || longitude === undefined) {
            setWindData(null);
            setError(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const data = await weatherService.getWindData(latitude, longitude);
            if (data) {
                setWindData(data);
                setError(null);
            } else {
                setWindData(null);
                setError("Unable to fetch wind data");
            }
        } catch (err) {
            console.error("[useWindData] Error fetching wind data:", err);
            setWindData(null);
            setError("Error fetching wind data");
        } finally{
            setLoading(false);
        }
    }, [
        latitude,
        longitude,
        weatherService
    ]);
    // Initial fetch
    $acw62.useEffect(()=>{
        fetchWindData();
    }, [
        fetchWindData
    ]);
    // Auto-refresh interval
    $acw62.useEffect(()=>{
        if (latitude === null || latitude === undefined || longitude === null || longitude === undefined) return;
        const intervalId = setInterval(fetchWindData, $566d95316465845b$var$REFRESH_INTERVAL_MS);
        return ()=>{
            clearInterval(intervalId);
        };
    }, [
        fetchWindData,
        latitude,
        longitude
    ]);
    return {
        loading: loading,
        windData: windData,
        error: error
    };
};

});
parcelRegister("8NlK4", function(module, exports) {

$parcel$export(module.exports, "WeatherService", () => $226a68957aeb3d50$export$adb6ebac5e4f9ae4);
/**
 * WeatherService - Handles interactions with the weather.gov API
 * API Documentation: https://www.weather.gov/documentation/services-web-api
 */ const $226a68957aeb3d50$var$BASE_URL = "https://api.weather.gov";
const $226a68957aeb3d50$var$CACHE_DURATION_MS = 300000; // 5 minutes
// Simple in-memory cache
const $226a68957aeb3d50$var$cache = new Map();
class $226a68957aeb3d50$export$adb6ebac5e4f9ae4 {
    constructor(baseUrl = $226a68957aeb3d50$var$BASE_URL){
        this.baseUrl = baseUrl;
    }
    /**
   * Get wind data for a specific location
   * @param latitude - Location latitude
   * @param longitude - Location longitude
   * @returns Wind data or null if unavailable
   */ async getWindData(latitude, longitude) {
        // Check cache first
        const cacheKey = `${latitude.toFixed(4)},${longitude.toFixed(4)}`;
        const cached = $226a68957aeb3d50$var$cache.get(cacheKey);
        if (cached && Date.now() < cached.expiresAt) return cached.data;
        try {
            // Step 1: Get grid coordinates for this location
            const pointMeta = await this.getPointMetadata(latitude, longitude);
            if (!pointMeta) {
                console.warn(`[WeatherService] No point metadata for ${cacheKey}`);
                return null;
            }
            // Step 2: Get nearby weather stations
            const stations = await this.getNearbyStations(pointMeta.gridId, pointMeta.gridX, pointMeta.gridY);
            if (!stations || stations.length === 0) {
                console.warn(`[WeatherService] No weather stations found`);
                return null;
            }
            // Step 3: Try to get observation from available stations
            // Skip stations that return null values - try next station
            for (const station of stations){
                const observation = await this.getLatestObservation(station.stationId, station.name);
                if (observation) {
                    // Only accept observations with at least one valid wind value
                    if (observation.speedMps !== null || observation.directionDegrees !== null) {
                        // Cache the result
                        $226a68957aeb3d50$var$cache.set(cacheKey, {
                            data: observation,
                            expiresAt: Date.now() + $226a68957aeb3d50$var$CACHE_DURATION_MS
                        });
                        return observation;
                    } else console.warn(`[WeatherService] Station ${station.stationId} returned null wind values, trying next station`);
                }
            }
            console.warn(`[WeatherService] No valid observations from any of ${stations.length} stations`);
            return null;
        } catch (error) {
            console.error("[WeatherService] Error fetching wind data:", error);
            return null;
        }
    }
    /**
   * Get point metadata (grid coordinates) for a lat/lng location
   */ async getPointMetadata(latitude, longitude) {
        try {
            const url = `${this.baseUrl}/points/${latitude.toFixed(4)},${longitude.toFixed(4)}`;
            const response = await fetch(url, {
                headers: {
                    "User-Agent": "AirPlx (contact@airplx.com)"
                }
            });
            if (!response.ok) {
                console.warn(`Point metadata request failed: ${response.status}`);
                return null;
            }
            const data = await response.json();
            if (!data?.properties?.gridId || !data?.properties?.gridX || !data?.properties?.gridY) return null;
            return {
                gridId: data.properties.gridId,
                gridX: data.properties.gridX,
                gridY: data.properties.gridY
            };
        } catch (error) {
            console.error("Error fetching point metadata:", error);
            return null;
        }
    }
    /**
   * Get nearby weather stations for a grid location
   */ async getNearbyStations(gridId, gridX, gridY) {
        try {
            const url = `${this.baseUrl}/gridpoints/${gridId}/${gridX},${gridY}/stations`;
            const response = await fetch(url, {
                headers: {
                    "User-Agent": "AirPlx (contact@airplx.com)"
                }
            });
            if (!response.ok) {
                console.warn(`Stations request failed: ${response.status}`);
                return [];
            }
            const data = await response.json();
            if (!data?.features || !Array.isArray(data.features)) return [];
            return data.features.map((feature)=>({
                    stationId: feature.properties?.stationIdentifier,
                    name: feature.properties?.name
                })).filter((station)=>station.stationId);
        } catch (error) {
            console.error("Error fetching stations:", error);
            return [];
        }
    }
    /**
   * Get latest observation from a specific weather station
   */ async getLatestObservation(stationId, stationName) {
        try {
            const url = `${this.baseUrl}/stations/${stationId}/observations/latest`;
            const response = await fetch(url, {
                headers: {
                    "User-Agent": "AirPlx (contact@airplx.com)"
                }
            });
            if (!response.ok) {
                console.warn(`Observation request failed for ${stationId}: ${response.status}`);
                return null;
            }
            const data = await response.json();
            if (!data?.properties) return null;
            const props = data.properties;
            // Extract wind speed and convert to m/s
            let speedMps = null;
            if (props.windSpeed?.value !== null && props.windSpeed?.value !== undefined) {
                const rawValue = props.windSpeed.value;
                const unitCode = props.windSpeed.unitCode;
                // Convert to m/s based on unit code
                if (unitCode === "wmoUnit:km_h-1") // Convert km/h to m/s
                speedMps = rawValue / 3.6;
                else if (unitCode === "wmoUnit:m_s-1" || !unitCode) {
                    // Already in m/s or no unit specified (assume m/s)
                    speedMps = rawValue;
                    if (!unitCode) console.warn(`[WeatherService] No unitCode for windSpeed, assuming m/s`);
                } else {
                    console.warn(`[WeatherService] Unknown windSpeed unitCode: ${unitCode}, assuming m/s`);
                    speedMps = rawValue;
                }
            }
            // Extract wind direction (in degrees)
            let directionDegrees = null;
            if (props.windDirection?.value !== null && props.windDirection?.value !== undefined) directionDegrees = props.windDirection.value;
            // Extract timestamp
            const timestamp = props.timestamp ? new Date(props.timestamp) : new Date();
            return {
                speedMps: speedMps,
                directionDegrees: directionDegrees,
                timestamp: timestamp,
                stationId: stationId,
                stationName: stationName
            };
        } catch (error) {
            console.error(`Error fetching observation for ${stationId}:`, error);
            return null;
        }
    }
    /**
   * Clear the cache (useful for testing)
   */ static clearCache() {
        $226a68957aeb3d50$var$cache.clear();
    }
}

});


parcelRegister("5tyjr", function(module, exports) {

$parcel$export(module.exports, "WindDisplay", () => (parcelRequire("cfcMM")).WindDisplay);

var $cfcMM = parcelRequire("cfcMM");

});
parcelRegister("cfcMM", function(module, exports) {

$parcel$export(module.exports, "WindDisplay", () => $9ec725646cc0e74a$export$63a1c2a14b680cf7);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $5RIww = parcelRequire("5RIww");
var $3bYfT = parcelRequire("3bYfT");

var $9dUJu = parcelRequire("9dUJu");

var $isPIL = parcelRequire("isPIL");
const $9ec725646cc0e74a$export$63a1c2a14b680cf7 = ({ loading: loading, windData: windData, error: error, useMetric: useMetric, compact: compact = false })=>{
    // Format wind information
    const windText = $acw62.useMemo(()=>{
        if (loading) return "Loading...";
        if (error || !windData) return "--";
        const formatted = (0, $isPIL.formatWindInfo)(windData.speedMps, windData.directionDegrees, useMetric);
        return formatted;
    }, [
        loading,
        error,
        windData,
        useMetric
    ]);
    // Calculate rotation angle: wind blows TO (directionDegrees + 180)
    const rotationAngle = windData?.directionDegrees !== undefined ? (windData.directionDegrees + 180) % 360 : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        children: [
            !loading && !error && windData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dUJu))), {
                sx: {
                    fontSize: 14,
                    color: "info.dark",
                    transform: `rotate(${rotationAngle}deg)`,
                    transition: "transform 0.3s ease"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "caption",
                textAlign: "center",
                color: "info.dark",
                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                    variant: "text",
                    width: compact ? 60 : 80,
                    height: compact ? 16 : 20,
                    sx: {
                        display: "inline-block"
                    }
                }) : windText
            })
        ]
    });
};

});
parcelRegister("isPIL", function(module, exports) {

$parcel$export(module.exports, "formatWindInfo", () => $b7f66e367f0b3e5c$export$59460333ce6a4f7a);
/**
 * Wind-related utility functions for converting and formatting wind data
 */ /**
 * Converts wind direction in degrees to cardinal direction
 * @param degrees - Wind direction in degrees (0-360)
 * @returns Cardinal direction (N, NE, E, SE, S, SW, W, NW)
 */ const $b7f66e367f0b3e5c$export$5358b79e5268516 = (degrees)=>{
    if (degrees === null || degrees === undefined || isNaN(degrees)) return "";
    // Normalize degrees to 0-360 range
    const normalized = (degrees % 360 + 360) % 360;
    const directions = [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
    ];
    const index = Math.round(normalized / 45) % 8;
    return directions[index];
};
const $b7f66e367f0b3e5c$export$55876fc9c6dfae72 = (mps)=>{
    if (mps === null || mps === undefined || isNaN(mps)) return null;
    return mps * 2.23694;
};
const $b7f66e367f0b3e5c$export$4f14aa71d6a0e5a8 = (mps)=>{
    if (mps === null || mps === undefined || isNaN(mps)) return null;
    return mps * 3.6;
};
const $b7f66e367f0b3e5c$export$22293dea41dc62df = (mps, useMetric = false)=>{
    if (mps === null || mps === undefined || isNaN(mps)) return "--";
    if (useMetric) {
        const kmh = $b7f66e367f0b3e5c$export$4f14aa71d6a0e5a8(mps);
        if (kmh === null) return "--";
        const rounded = Math.round(kmh);
        return rounded === 0 ? "< 2 km/h" : `${rounded} km/h`;
    } else {
        const mph = $b7f66e367f0b3e5c$export$55876fc9c6dfae72(mps);
        if (mph === null) return "--";
        const rounded = Math.round(mph);
        return rounded === 0 ? "< 1 mph" : `${rounded} mph`;
    }
};
const $b7f66e367f0b3e5c$export$9049faba82d22c3 = (degrees)=>{
    if (degrees === null || degrees === undefined || isNaN(degrees)) return "--";
    const cardinal = $b7f66e367f0b3e5c$export$5358b79e5268516(degrees);
    const normalized = Math.round((degrees % 360 + 360) % 360);
    return `${normalized}\xb0 ${cardinal}`;
};
const $b7f66e367f0b3e5c$export$59460333ce6a4f7a = (speedMps, directionDegrees, useMetric = false)=>{
    const speed = $b7f66e367f0b3e5c$export$22293dea41dc62df(speedMps, useMetric);
    const direction = $b7f66e367f0b3e5c$export$9049faba82d22c3(directionDegrees);
    // If both are missing, show N/A instead of --
    if (speed === "--" && direction === "--") return "N/A";
    if (speed === "--") return direction;
    if (direction === "--") return speed;
    return `${speed} ${direction}`;
};

});





parcelRegister("7y2Rw", function(module, exports) {

$parcel$export(module.exports, "SimpleBulkUpload", () => $b54570542b6b1cbf$export$c75398abb0b5724c);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $4bqcK = parcelRequire("4bqcK");

var $a7gZr = parcelRequire("a7gZr");

var $lQ8IB = parcelRequire("lQ8IB");

var $keHtM = parcelRequire("keHtM");

var $gYLUy = parcelRequire("gYLUy");

var $FF8G7 = parcelRequire("FF8G7");
const $b54570542b6b1cbf$export$c75398abb0b5724c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ open: open, onClose: onClose, onComplete: onComplete, autoAssignLocationId: autoAssignLocationId, autoAssignLocationType: autoAssignLocationType, autoAssignLocationName: autoAssignLocationName, embedded: embedded = false, onStateChange: onStateChange }, ref)=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [trips, setTrips] = (0, $acw62.useState)([
        {
            id: 1,
            tail_number: "",
            arrival_date: "",
            departure_date: ""
        }
    ]);
    const [pasteData, setPasteData] = (0, $acw62.useState)("");
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [uploadProgress, setUploadProgress] = (0, $acw62.useState)({
        current: 0,
        total: 0,
        currentItem: ""
    });
    const [isImporting, setIsImporting] = (0, $acw62.useState)(false);
    // Initialize TripService and PlacementService
    const tripService = (0, $acw62.useMemo)(()=>new (0, $lQ8IB.TripService)(postgrest), [
        postgrest
    ]);
    const placementService = (0, $acw62.useMemo)(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    // Generate example dates for placeholder
    const getExampleDates = (0, $acw62.useMemo)(()=>{
        const today = new Date();
        const formatDate = (date)=>{
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? "PM" : "AM";
            const displayHours = hours % 12 || 12;
            return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${displayHours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
        };
        const example1Arrival = new Date(today);
        example1Arrival.setDate(today.getDate() + 3);
        example1Arrival.setHours(10, 11, 0, 0);
        const example1Departure = new Date(example1Arrival);
        example1Departure.setDate(example1Arrival.getDate() + 5);
        example1Departure.setHours(16, 25, 0, 0);
        const example2Arrival = new Date(today);
        example2Arrival.setDate(today.getDate() + 10);
        example2Arrival.setHours(18, 0, 0, 0);
        const example2Departure = new Date(example2Arrival);
        example2Departure.setDate(example2Arrival.getDate() + 4);
        example2Departure.setHours(22, 0, 0, 0);
        const example3Arrival = new Date(today);
        example3Arrival.setDate(today.getDate() + 15);
        example3Arrival.setHours(14, 30, 0, 0);
        const example3Departure = new Date(example3Arrival);
        example3Departure.setDate(example3Arrival.getDate() + 3);
        example3Departure.setHours(16, 45, 0, 0);
        return {
            example1: `N123AB\t${formatDate(example1Arrival)}\t${formatDate(example1Departure)}`,
            example2: `N456CD\t${formatDate(example2Arrival)}\t${formatDate(example2Departure)}`,
            example3: `N789EF\t${formatDate(example3Arrival)}\t${formatDate(example3Departure)}`,
            example4: `N101GH\t${formatDate(example3Arrival)}\tno departure`
        };
    }, []);
    // Convert Excel date/datetime formats to HTML datetime-local format (YYYY-MM-DDTHH:MM)
    const convertDateFormat = (dateStr)=>{
        const trimmed = dateStr.trim();
        // Handle infinity/base tenant formats (empty, "no departure", "infinity", "base tenant")
        if (!trimmed || trimmed.toLowerCase() === "no departure" || trimmed.toLowerCase() === "infinity" || trimmed.toLowerCase() === "base tenant") return "infinity";
        // Check if already in datetime-local format (YYYY-MM-DDTHH:MM)
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(trimmed)) return trimmed;
        // Try datetime formats with AM/PM: M/D/YYYY H:MM AM/PM
        let match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        if (match) {
            const [, month, day, year, hours, minutes, ampm] = match;
            let hour24 = parseInt(hours, 10);
            if (ampm.toUpperCase() === "PM" && hour24 !== 12) hour24 += 12;
            else if (ampm.toUpperCase() === "AM" && hour24 === 12) hour24 = 0;
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${hour24.toString().padStart(2, "0")}:${minutes}`;
        }
        // Try datetime formats with 24-hour time: M/D/YYYY H:MM or M/D/YYYY HH:MM
        match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})$/);
        if (match) {
            const [, month, day, year, hours, minutes] = match;
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${hours.padStart(2, "0")}:${minutes}`;
        }
        // Try datetime formats with dash separator: M-D-YYYY H:MM AM/PM
        match = trimmed.match(/^(\d{1,2})-(\d{1,2})-(\d{4})\s+(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        if (match) {
            const [, month, day, year, hours, minutes, ampm] = match;
            let hour24 = parseInt(hours, 10);
            if (ampm.toUpperCase() === "PM" && hour24 !== 12) hour24 += 12;
            else if (ampm.toUpperCase() === "AM" && hour24 === 12) hour24 = 0;
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${hour24.toString().padStart(2, "0")}:${minutes}`;
        }
        // Try datetime formats with dash separator: M-D-YYYY H:MM or M-D-YYYY HH:MM
        match = trimmed.match(/^(\d{1,2})-(\d{1,2})-(\d{4})\s+(\d{1,2}):(\d{2})$/);
        if (match) {
            const [, month, day, year, hours, minutes] = match;
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${hours.padStart(2, "0")}:${minutes}`;
        }
        // Try date-only formats (backward compatibility) - default to midnight
        // MM/DD/YYYY or M/D/YYYY
        match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (match) {
            const [, month, day, year] = match;
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T00:00`;
        }
        // MM-DD-YYYY or M-D-YYYY
        match = trimmed.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
        if (match) {
            const [, month, day, year] = match;
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T00:00`;
        }
        // YYYY-MM-DD (add default time)
        match = trimmed.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
        if (match) {
            const [, year, month, day] = match;
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T00:00`;
        }
        // If no format matches, return as is
        return trimmed;
    };
    // Parse TSV data into trip objects
    const parseTSVData = (data)=>{
        const lines = data.trim().split("\n");
        const trips = [];
        lines.forEach((line, index)=>{
            const columns = line.split("\t");
            if (columns.length >= 3) {
                const [tailNumber, arrivalDate, departureDate] = columns;
                // Skip empty rows
                if (!tailNumber.trim() && !arrivalDate.trim() && !departureDate.trim()) return;
                // Skip header row if detected (check if it contains common header words)
                // NOTE: Must check for exact header patterns, not substrings, to avoid filtering "no departure" as a header
                const lowerTail = tailNumber.toLowerCase();
                const lowerArrival = arrivalDate.toLowerCase();
                // Check if this looks like a header row (all three columns have header-like text)
                const isTailHeader = lowerTail.includes("tail") || lowerTail.includes("number") || lowerTail === "n#";
                const isArrivalHeader = lowerArrival.includes("arrival") || lowerArrival.includes("date") || lowerArrival === "eta";
                // Only skip if it looks like a full header row (tail AND arrival headers present)
                // Don't filter based on departure alone - "no departure" is valid data, not a header
                if (isTailHeader && isArrivalHeader) return;
                trips.push({
                    id: Date.now() + index,
                    tail_number: tailNumber.trim(),
                    arrival_date: convertDateFormat(arrivalDate),
                    departure_date: convertDateFormat(departureDate)
                });
            }
        });
        return trips;
    };
    const handleImportData = async ()=>{
        if (!pasteData.trim() || !postgrest || !activeFBO) return;
        setIsImporting(true);
        try {
            const parsedTrips = parseTSVData(pasteData);
            if (parsedTrips.length === 0) return;
            // Look up aircraft data for each trip
            const tripsWithAircraft = await Promise.all(parsedTrips.map(async (trip)=>{
                const aircraft = await (0, $4bqcK.lookupAircraftByTailNumber)(postgrest, trip.tail_number, activeFBO);
                if (aircraft) return {
                    ...trip,
                    aircraft_id: aircraft.id,
                    make: aircraft.make,
                    model: aircraft.model,
                    wingspan: aircraft.wingspan,
                    length: aircraft.length
                };
                // No aircraft found, return trip without aircraft data
                return trip;
            }));
            setTrips(tripsWithAircraft);
            setPasteData(""); // Clear the text area after import
        } finally{
            setIsImporting(false);
        }
    };
    const downloadSampleFile = ()=>{
        // Generate dates relative to today
        const today = new Date();
        const formatDate = (date)=>{
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? "PM" : "AM";
            const displayHours = hours % 12 || 12;
            return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${displayHours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
        };
        // Create sample trips with dates in the near future
        const trip1Arrival = new Date(today);
        trip1Arrival.setDate(today.getDate() + 3);
        trip1Arrival.setHours(10, 11, 0, 0);
        const trip1Departure = new Date(trip1Arrival);
        trip1Departure.setDate(trip1Arrival.getDate() + 5);
        trip1Departure.setHours(16, 25, 0, 0);
        const trip2Arrival = new Date(today);
        trip2Arrival.setDate(today.getDate() + 10);
        trip2Arrival.setHours(18, 0, 0, 0);
        const trip2Departure = new Date(trip2Arrival);
        trip2Departure.setDate(trip2Arrival.getDate() + 4);
        trip2Departure.setHours(22, 0, 0, 0);
        const trip3Arrival = new Date(today);
        trip3Arrival.setDate(today.getDate() + 20);
        trip3Arrival.setHours(9, 30, 0, 0);
        const trip3Departure = new Date(trip3Arrival);
        trip3Departure.setDate(trip3Arrival.getDate() + 3);
        trip3Departure.setHours(14, 45, 0, 0);
        const trip4Arrival = new Date(today);
        trip4Arrival.setDate(today.getDate() + 30);
        trip4Arrival.setHours(7, 0, 0, 0);
        const trip4Departure = new Date(trip4Arrival);
        trip4Departure.setDate(trip4Arrival.getDate() + 2);
        trip4Departure.setHours(19, 15, 0, 0);
        const sampleData = [
            "Tail Number\tArrival Date\tDeparture Date",
            // Header row
            `N123AB\t${formatDate(trip1Arrival)}\t${formatDate(trip1Departure)}`,
            `N456CD\t${formatDate(trip2Arrival)}\t${formatDate(trip2Departure)}`,
            `N789EF\t${formatDate(trip3Arrival)}\t${formatDate(trip3Departure)}`,
            `N111GH\t${formatDate(trip4Arrival)}\t${formatDate(trip4Departure)}`
        ].join("\n");
        const blob = new Blob([
            sampleData
        ], {
            type: "text/tab-separated-values"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "sample_trips.tsv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    // Helper function to check if a trip has validation errors
    const getTripValidationError = (trip)=>{
        // Check for missing required fields
        if (!trip.tail_number || !trip.arrival_date || !trip.departure_date) return true;
        // Check for invalid dates (arrival >= departure) - skip if departure is infinity
        if (!(0, $gYLUy.isInfinityDate)(trip.departure_date)) {
            if (new Date(trip.arrival_date) >= new Date(trip.departure_date)) return true;
        }
        // Check for missing aircraft
        if (!trip.aircraft_id) return true;
        return false;
    };
    // Auto-sort trips with errors to the top
    // Create a stable reference that only changes when trip content changes (not order)
    const tripsContentKey = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return trips.map((t)=>`${t.id}-${t.tail_number}-${t.arrival_date}-${t.departure_date}-${t.aircraft_id}`).sort().join("|");
    }, [
        trips
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setTrips((prev)=>{
            const tripsWithErrors = [];
            const tripsWithoutErrors = [];
            prev.forEach((trip)=>{
                if (getTripValidationError(trip)) tripsWithErrors.push(trip);
                else tripsWithoutErrors.push(trip);
            });
            // Only update if the order actually changed
            const newOrder = [
                ...tripsWithErrors,
                ...tripsWithoutErrors
            ];
            const orderChanged = prev.some((trip, index)=>trip.id !== newOrder[index]?.id);
            return orderChanged ? newOrder : prev;
        });
    }, [
        tripsContentKey
    ]);
    const addRow = ()=>{
        setTrips((prev)=>[
                ...prev,
                {
                    id: Date.now(),
                    tail_number: "",
                    arrival_date: "",
                    departure_date: ""
                }
            ]);
    };
    const removeRow = (id)=>{
        setTrips((prev)=>prev.filter((trip)=>trip.id !== id));
    };
    const updateTrip = (id, field, value)=>{
        setTrips((prev)=>prev.map((trip)=>trip.id === id ? {
                    ...trip,
                    [field]: value
                } : trip));
    };
    // Update trip with aircraft selection from autocomplete
    const updateTripAircraft = (id, aircraft)=>{
        setTrips((prev)=>prev.map((trip)=>trip.id === id ? {
                    ...trip,
                    aircraft_id: aircraft?.id,
                    make: aircraft?.make,
                    model: aircraft?.model,
                    wingspan: aircraft?.wingspan,
                    length: aircraft?.length
                } : trip));
    };
    const handleSave = async ()=>{
        // Filter out trips with missing data or invalid dates (arrival >= departure)
        const validTrips = trips.filter((t)=>{
            if (!t.tail_number || !t.arrival_date || !t.departure_date) return false;
            // Check that arrival is before departure - skip validation if departure is infinity
            if ((0, $gYLUy.isInfinityDate)(t.departure_date)) return true; // Infinity is always valid
            return new Date(t.arrival_date) < new Date(t.departure_date);
        });
        if (!activeFBO?.id) {
            setError("No active FBO selected");
            return;
        }
        if (validTrips.length === 0) {
            setError("No valid trips to save");
            return;
        }
        // Check for trips without aircraft_id - CRITICAL: don't allow upload
        const tripsWithoutAircraft = validTrips.filter((t)=>!t.aircraft_id);
        if (tripsWithoutAircraft.length > 0) {
            const tailNumbers = tripsWithoutAircraft.map((t)=>t.tail_number).join(", ");
            setError(`Cannot upload trips without aircraft data. Please select aircraft for: ${tailNumbers}`);
            return;
        }
        setLoading(true);
        setError(null);
        setUploadProgress({
            current: 0,
            total: validTrips.length,
            currentItem: ""
        });
        try {
            let successCount = 0;
            const errors = [];
            const failedTripIds = new Set(); // Track which trip IDs failed
            // Process trips in batches of 5 for parallel execution
            const BATCH_SIZE = 5;
            const batches = [];
            for(let i = 0; i < validTrips.length; i += BATCH_SIZE)batches.push(validTrips.slice(i, i + BATCH_SIZE));
            // Process each batch in parallel
            for (const batch of batches){
                const batchResults = await Promise.all(batch.map(async (trip)=>{
                    try {
                        // 1. Find or create tenant for this tail number
                        let tenantId;
                        // Check if tenant already exists
                        const { data: existingTenants, error: tenantSearchError } = await postgrest.from("tenant").select("id, aircraft_id").eq("fbo_id", activeFBO.id).eq("tail_number", trip.tail_number.trim()).limit(1);
                        if (tenantSearchError) throw new Error(`Failed to search for tenant: ${tenantSearchError.message}`);
                        if (existingTenants && existingTenants.length > 0) {
                            // Use existing tenant and ALWAYS update aircraft_id
                            // This fixes bug where NULL aircraft_id tenants were reused without update
                            const existingTenant = existingTenants[0];
                            tenantId = existingTenant.id;
                            // Validate we have aircraft_id (should be caught by validation earlier)
                            if (!trip.aircraft_id) throw new Error(`Internal error: trip missing aircraft_id for ${trip.tail_number} - should be caught by validation`);
                            // Always update aircraft_id to ensure it's set (fixes NULL aircraft_id bug)
                            await postgrest.from("tenant").update({
                                aircraft_id: trip.aircraft_id
                            }).eq("id", tenantId);
                        } else {
                            // Create new tenant with aircraft_id
                            const { data: newTenant, error: tenantError } = await postgrest.from("tenant").insert({
                                fbo_id: activeFBO.id,
                                tail_number: trip.tail_number.trim(),
                                aircraft_id: trip.aircraft_id,
                                // Include aircraft_id
                                type: (0, $keHtM.TenantType).TRANSIENT // Default to transient
                            }).select().single();
                            if (tenantError) throw new Error(`Failed to create tenant: ${tenantError.message}`);
                            tenantId = newTenant.id;
                        }
                        // 2. Create the trip
                        const tripData = {
                            tenant_id: tenantId,
                            fbo_id: activeFBO.id,
                            arrival_date: new Date(trip.arrival_date).toISOString(),
                            // Handle infinity departure (base tenants)
                            departure_date: (0, $gYLUy.isInfinityDate)(trip.departure_date) ? trip.departure_date : new Date(trip.departure_date).toISOString(),
                            status: "scheduled"
                        };
                        const createdTrip = await tripService.createTrip(tripData);
                        // 3. If auto-assignment is enabled, assign trip to location
                        if (autoAssignLocationId && autoAssignLocationType && createdTrip.id) try {
                            await placementService.assignToLocationWithGapFilling(createdTrip.id, autoAssignLocationId, autoAssignLocationType, new Date(trip.arrival_date).toISOString(), // Handle infinity departure (base tenants)
                            (0, $gYLUy.isInfinityDate)(trip.departure_date) ? trip.departure_date : new Date(trip.departure_date).toISOString(), true, // excludeConflicts
                            {
                                x: null,
                                y: null,
                                angle: null
                            } // No specific position initially
                            );
                        } catch (assignmentError) {
                            // Trip created but assignment failed - still count as partial success
                            console.error(`Failed to assign trip for ${trip.tail_number}:`, assignmentError);
                            return {
                                success: true,
                                partialSuccess: true,
                                trip: trip,
                                error: `${trip.tail_number}: Trip created but assignment failed - ${assignmentError.message || "Unknown error"}`
                            };
                        }
                        return {
                            success: true,
                            trip: trip
                        };
                    } catch (tripError) {
                        console.error(`Failed to create trip for ${trip.tail_number}:`, tripError);
                        return {
                            success: false,
                            trip: trip,
                            error: `${trip.tail_number}: ${tripError.message || "Unknown error"}`
                        };
                    }
                }));
                // Process batch results
                for (const result of batchResults)if (result.success) {
                    successCount++;
                    if (result.partialSuccess && result.error) errors.push(result.error);
                } else {
                    failedTripIds.add(result.trip.id);
                    errors.push(result.error);
                }
                // Update progress after each batch
                setUploadProgress({
                    current: successCount + errors.length,
                    total: validTrips.length,
                    currentItem: batch[batch.length - 1].tail_number
                });
            }
            // Remove successful trips, keep only failed ones and trips with validation errors
            if (successCount > 0) setTrips((prev)=>{
                const remainingTrips = prev.filter((t)=>// Keep trips that failed during save
                    failedTripIds.has(t.id) || // Keep trips that weren't included in validTrips (have validation errors)
                    !validTrips.some((vt)=>vt.id === t.id));
                // If all trips succeeded, reset to one empty row
                if (remainingTrips.length === 0) return [
                    {
                        id: Date.now(),
                        tail_number: "",
                        arrival_date: "",
                        departure_date: ""
                    }
                ];
                return remainingTrips;
            });
            // Show results - DO NOT close dialog, keep it open to show results
            const locationMessage = autoAssignLocationName ? ` to ${autoAssignLocationName}` : "";
            if (successCount === validTrips.length) {
                // All succeeded
                setError(null);
                onComplete(successCount);
                // Set success message (we'll add this to the UI)
                setError(`\u{2713} Successfully added ${successCount} trip${successCount > 1 ? "s" : ""}${locationMessage}`);
            } else if (successCount > 0) {
                // Some succeeded, some failed
                setError(`\u{2713} Successfully added ${successCount} out of ${validTrips.length} trips${locationMessage}.

\u{2717} Failed ${errors.length}:\n${errors.join("\n")}`);
                onComplete(successCount);
            } else // All failed
            setError(`\u{2717} Failed to add any trips:
${errors.join("\n")}`);
        } catch (err) {
            console.error("Bulk upload failed:", err);
            setError(err.message || "Failed to save trips. Please try again.");
        } finally{
            setLoading(false);
        }
    };
    const handleClose = ()=>{
        setTrips([
            {
                id: 1,
                tail_number: "",
                arrival_date: "",
                departure_date: ""
            }
        ]);
        setPasteData("");
        setError(null);
        setLoading(false);
        onClose();
    };
    // Count valid trips (has required fields AND arrival < departure)
    const validCount = trips.filter((t)=>{
        if (!t.tail_number || !t.arrival_date || !t.departure_date) return false;
        // Allow infinity dates
        if ((0, $gYLUy.isInfinityDate)(t.departure_date)) return true;
        return new Date(t.arrival_date) < new Date(t.departure_date);
    }).length;
    // Calculate form validity - all trips must have aircraft_id AND valid dates
    const isFormValid = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const validTrips = trips.filter((t)=>{
            if (!t.tail_number || !t.arrival_date || !t.departure_date) return false;
            // Check that arrival is before departure - skip validation if departure is infinity
            if ((0, $gYLUy.isInfinityDate)(t.departure_date)) return true;
            return new Date(t.arrival_date) < new Date(t.departure_date);
        });
        if (validTrips.length === 0) return false;
        return validTrips.every((t)=>t.aircraft_id);
    }, [
        trips
    ]);
    // Store onStateChange in a ref to avoid recreating the effect
    const onStateChangeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onStateChange);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onStateChangeRef.current = onStateChange;
    }, [
        onStateChange
    ]);
    // Notify parent of state changes
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onStateChangeRef.current?.(isFormValid, loading);
    }, [
        isFormValid,
        loading
    ]);
    // Expose save function via ref
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            isFormValid: isFormValid,
            loading: loading,
            save: handleSave
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $FF8G7.SimpleBulkUploadPresenter), {
        open: open,
        onClose: onClose,
        trips: trips,
        pasteData: pasteData,
        setPasteData: setPasteData,
        loading: loading,
        isImporting: isImporting,
        error: error,
        setError: setError,
        validCount: validCount,
        exampleDates: getExampleDates,
        handleImportData: handleImportData,
        downloadSampleFile: downloadSampleFile,
        addRow: addRow,
        removeRow: removeRow,
        updateTrip: updateTrip,
        updateTripAircraft: updateTripAircraft,
        handleSave: handleSave,
        handleClose: handleClose,
        activeFBOId: activeFBO?.id || "",
        autoAssignLocationName: autoAssignLocationName,
        embedded: embedded,
        uploadProgress: uploadProgress
    });
});

});
parcelRegister("FF8G7", function(module, exports) {

$parcel$export(module.exports, "SimpleBulkUploadPresenter", () => $1208482314f66b8c$export$bf1065362bf07da8);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $hmTQO = parcelRequire("hmTQO");

var $1MdOk = parcelRequire("1MdOk");

var $5y9fX = parcelRequire("5y9fX");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $6GL0S = parcelRequire("6GL0S");

var $hTRQz = parcelRequire("hTRQz");
const $1208482314f66b8c$export$bf1065362bf07da8 = ({ open: open, trips: trips, pasteData: pasteData, setPasteData: setPasteData, loading: loading, isImporting: isImporting = false, error: error, setError: setError, validCount: validCount, exampleDates: exampleDates, handleImportData: handleImportData, downloadSampleFile: downloadSampleFile, addRow: addRow, removeRow: removeRow, updateTrip: updateTrip, updateTripAircraft: updateTripAircraft, handleSave: handleSave, handleClose: handleClose, autoAssignLocationName: autoAssignLocationName, embedded: embedded = false, uploadProgress: uploadProgress })=>{
    // Determine if error is actually a success message
    const isSuccessMessage = error?.startsWith("\u2713");
    const isPartialSuccess = error?.includes("\u2713") && error?.includes("\u2717");
    // Helper function to check if dates are valid (arrival < departure)
    const hasInvalidDates = (trip)=>{
        if (!trip.arrival_date || !trip.departure_date) return false;
        return new Date(trip.arrival_date) >= new Date(trip.departure_date);
    };
    const content = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            autoAssignLocationName && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                severity: "info",
                sx: {
                    mb: 2
                },
                children: [
                    "Trips will be automatically assigned to",
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        children: autoAssignLocationName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    mb: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        sx: {
                            mb: 1
                        },
                        children: "Paste from Excel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            mb: 2
                        },
                        children: 'Copy trip data from Excel (Tail Number, Arrival Date, Departure Date) and paste below. For base tenants, leave the departure column blank or use "no departure". Headers are optional and will be automatically detected and skipped.'
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        multiline: true,
                        rows: 4,
                        fullWidth: true,
                        value: pasteData,
                        onChange: (e)=>setPasteData(e.target.value),
                        placeholder: `${exampleDates.example1}\n${exampleDates.example2}\n${exampleDates.example3}\n${exampleDates.example4}`,
                        disabled: isImporting,
                        sx: {
                            mb: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "outlined",
                        onClick: handleImportData,
                        disabled: !pasteData.trim() || isImporting,
                        startIcon: isImporting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                            size: 16
                        }) : undefined,
                        sx: {
                            mr: 2
                        },
                        children: isImporting ? "Importing..." : "Import Data"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "text",
                        onClick: downloadSampleFile,
                        sx: {
                            mr: 2
                        },
                        children: "Sample File"
                    }),
                    pasteData.trim() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "text.secondary",
                        children: [
                            pasteData.trim().split("\n").length,
                            " rows ready to import"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                sx: {
                    mb: 2
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                sx: {
                    mb: 1
                },
                children: "Edit Trips"
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: isSuccessMessage && !isPartialSuccess ? "success" : isPartialSuccess ? "warning" : "error",
                sx: {
                    mb: 2
                },
                onClose: ()=>setError(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                    style: {
                        margin: 0,
                        whiteSpace: "pre-wrap"
                    },
                    children: error
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Tail Number"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Aircraft"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Arrival Date"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Departure Date"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        onClick: addRow,
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                        children: "Add"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                        children: trips.map((trip)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            py: 2
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            size: "small",
                                            value: trip.tail_number,
                                            onChange: (e)=>updateTrip(trip.id, "tail_number", e.target.value),
                                            placeholder: "N123AB",
                                            sx: {
                                                width: 120
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            py: 2
                                        },
                                        children: trip.aircraft_id ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1.5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmTQO))), {
                                                    color: "success",
                                                    fontSize: "small"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            sx: {
                                                                fontWeight: 500
                                                            },
                                                            children: trip.make
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            color: "text.secondary",
                                                            children: trip.model
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1.5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5y9fX))), {
                                                    color: "warning",
                                                    fontSize: "small",
                                                    sx: {
                                                        flexShrink: 0
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                    sx: {
                                                        flexGrow: 1
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                                                        label: "Select Aircraft",
                                                        onSelect: (aircraft)=>updateTripAircraft(trip.id, aircraft),
                                                        defaultSelected: null
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            py: 2
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            type: "datetime-local",
                                            size: "small",
                                            value: trip.arrival_date,
                                            onChange: (e)=>updateTrip(trip.id, "arrival_date", e.target.value),
                                            InputLabelProps: {
                                                shrink: true
                                            },
                                            error: hasInvalidDates(trip),
                                            helperText: hasInvalidDates(trip) ? "Arrival must be before departure" : "",
                                            sx: {
                                                width: 200
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            py: 2
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            type: "datetime-local",
                                            size: "small",
                                            value: trip.departure_date,
                                            onChange: (e)=>updateTrip(trip.id, "departure_date", e.target.value),
                                            InputLabelProps: {
                                                shrink: true
                                            },
                                            error: hasInvalidDates(trip),
                                            helperText: hasInvalidDates(trip) ? "Departure must be after arrival" : "",
                                            sx: {
                                                width: 200
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "center",
                                        sx: {
                                            py: 2
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                            size: "small",
                                            onClick: ()=>removeRow(trip.id),
                                            disabled: trips.length === 1,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {})
                                        })
                                    })
                                ]
                            }, trip.id))
                    })
                ]
            })
        ]
    });
    // If embedded, just return the content without Dialog wrapper
    if (embedded) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            content,
            loading && uploadProgress && uploadProgress.total > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6GL0S.ProgressDialog), {
                open: loading,
                title: "Uploading Trips",
                message: "Creating trips and assigning to location. Please wait...",
                current: uploadProgress.current,
                total: uploadProgress.total,
                itemName: "trip",
                currentItem: uploadProgress.currentItem
            })
        ]
    });
    // Otherwise, wrap in Dialog (standalone mode)
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: handleClose,
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Bulk Upload Trips"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: content
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "text.secondary",
                                children: [
                                    validCount,
                                    " valid trips"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleClose,
                                disabled: loading,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                onClick: handleSave,
                                disabled: validCount === 0 || loading,
                                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 24
                                }) : `Save ${validCount} Trips`
                            })
                        ]
                    })
                ]
            }),
            loading && uploadProgress && uploadProgress.total > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6GL0S.ProgressDialog), {
                open: loading,
                title: "Uploading Trips",
                message: "Creating trips and assigning to location. Please wait...",
                current: uploadProgress.current,
                total: uploadProgress.total,
                itemName: "trip",
                currentItem: uploadProgress.currentItem
            })
        ]
    });
};

});


parcelRegister("iTQAE", function(module, exports) {

$parcel$export(module.exports, "AddSelectedTenant", () => $6e5e7c1023135c27$export$1d93e54ce0378a15);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $6rxM8 = parcelRequire("6rxM8");

var $gZQV9 = parcelRequire("gZQV9");

var $74Lxs = parcelRequire("74Lxs");

var $5kwJN = parcelRequire("5kwJN");
parcelRequire("briyn");
var $1gbL9 = parcelRequire("1gbL9");

var $5U03M = parcelRequire("5U03M");
const $6e5e7c1023135c27$export$1d93e54ce0378a15 = ({ selectedTenant: selectedTenant, onAdd: onAdd, isReference: isReference, location: location })=>{
    const { findTenantLocation: findTenantLocation } = (0, $6rxM8.useLocationsState)();
    const { hangar: hangar } = (0, $gZQV9.useThisHangar)();
    const { entries: holdingAreaEntries } = (0, $74Lxs.useHoldingArea)();
    const tenantLocation = findTenantLocation(isReference, selectedTenant);
    const isInThisHangar = tenantLocation?.location_id === location?.location_id && hangar?.stack?.tenants?.some((t)=>t.id === selectedTenant.id);
    const currentTenantLocation = findTenantLocation(false, selectedTenant);
    // Check if tenant is in the holding area using the entries from useHoldingArea
    const isInHoldingArea = holdingAreaEntries.some((entry)=>entry.tenant_id === selectedTenant.id);
    // For holding area: check if aircraft is in a different location (any hangar)
    const isHoldingArea = location.id === (0, $5U03M.HOLDING_AREA_ID);
    const isInDifferentLocation = currentTenantLocation && currentTenantLocation.id !== location.id;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
        size: "small",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: "Tail #"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: "Model"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: "Current Location"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: "Last Hangared"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: "Type"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: selectedTenant.tail_number
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: selectedTenant.aircraft.model
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1gbL9.LocationTextField), {
                                selectedLocationId: currentTenantLocation?.location_id,
                                readOnly: true,
                                unassignedText: "Not Hangared"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: (0, $5kwJN.lastHangaredText)(selectedTenant.last_hangared, Boolean(currentTenantLocation))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: selectedTenant.type
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                            children: isInHoldingArea ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                children: "In Holding Area"
                            }) : isInThisHangar ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                children: "In This Hangar"
                            }) : isHoldingArea && isInDifferentLocation ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                children: [
                                    "In ",
                                    currentTenantLocation.name
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                onClick: ()=>{
                                    onAdd({
                                        ...selectedTenant
                                    });
                                },
                                children: "Add"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("74Lxs", function(module, exports) {

$parcel$export(module.exports, "useHoldingArea", () => $baec6c7ebcbf0a38$export$77baec229a9b4a59);

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $ZD2ym = parcelRequire("ZD2ym");

var $dZ8EH = parcelRequire("dZ8EH");
const $baec6c7ebcbf0a38$export$77baec229a9b4a59 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [entries, setEntries] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const service = new (0, $dZ8EH.HoldingAreaService)(postgrest);
    /**
   * Fetch active holding area entries
   */ const refresh = (0, $acw62.useCallback)(async ()=>{
        if (!activeFBO?.id) {
            setEntries([]);
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            setError(null);
            const data = await service.getActiveEntries(activeFBO.id);
            setEntries(data);
        } catch (err) {
            setError(err);
            console.error("Failed to fetch holding area entries:", err);
        } finally{
            setLoading(false);
        }
    }, [
        activeFBO?.id,
        postgrest
    ]);
    /**
   * Add a tenant to the holding area
   */ const addTenant = (0, $acw62.useCallback)(async (tenant)=>{
        if (!activeFBO?.id) throw new Error("No active FBO");
        const tenants = Array.isArray(tenant) ? tenant : [
            tenant
        ];
        try {
            setError(null);
            // Add each tenant to the holding area
            await Promise.all(tenants.map((t)=>service.addToHoldingArea(t.id, activeFBO.id)));
            // Refresh the list
            await refresh();
        } catch (err) {
            setError(err);
            throw err;
        }
    }, [
        activeFBO?.id,
        refresh
    ]);
    /**
   * Remove a tenant from the holding area
   */ const removeTenant = (0, $acw62.useCallback)(async (tenantId)=>{
        try {
            setError(null);
            await service.removeFromHoldingArea(tenantId);
            // Refresh the list
            await refresh();
        } catch (err) {
            setError(err);
            throw err;
        }
    }, [
        refresh
    ]);
    /**
   * Assign a tenant from the holding area to a hangar
   */ const assignTenant = (0, $acw62.useCallback)(async (tenantId)=>{
        try {
            setError(null);
            await service.assignFromHoldingArea(tenantId);
            // Refresh the list
            await refresh();
        } catch (err) {
            setError(err);
            throw err;
        }
    }, [
        refresh
    ]);
    /**
   * Check if a tenant is in the holding area
   */ const isInHoldingArea = (0, $acw62.useCallback)(async (tenantId)=>{
        try {
            return await service.isInHoldingArea(tenantId);
        } catch (err) {
            console.error("Failed to check holding area status:", err);
            return false;
        }
    }, []);
    // Load initial data
    (0, $acw62.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    return {
        entries: entries,
        loading: loading,
        error: error,
        addTenant: addTenant,
        removeTenant: removeTenant,
        assignTenant: assignTenant,
        isInHoldingArea: isInHoldingArea,
        refresh: refresh
    };
};

});
parcelRegister("dZ8EH", function(module, exports) {

$parcel$export(module.exports, "HoldingAreaService", () => $4d17176f03be30d7$export$bd2ca9cd7704dd3a);
class $4d17176f03be30d7$export$bd2ca9cd7704dd3a {
    constructor(postgrest){
        this.postgrest = postgrest;
    }
    /**
   * Add a tenant to the holding area
   * Creates a new entry with status='active'
   */ async addToHoldingArea(tenantId, fboId) {
        const { data: data, error: error } = await this.postgrest.from("holding_area_entry").insert({
            tenant_id: tenantId,
            fbo_id: fboId,
            status: "active"
        }).select().single();
        if (error) throw new Error(`Failed to add to holding area: ${error.message}`);
        return data;
    }
    /**
   * Remove a tenant from the holding area
   * Updates status to 'removed'
   */ async removeFromHoldingArea(tenantId) {
        // Find the active entry for this tenant
        const { data: entry, error: findError } = await this.postgrest.from("holding_area_entry").select().eq("tenant_id", tenantId).eq("status", "active").single();
        if (findError) throw new Error(`Failed to find holding area entry: ${findError.message}`);
        if (!entry) throw new Error(`No active holding area entry found for tenant ${tenantId}`);
        const { data: data, error: error } = await this.postgrest.from("holding_area_entry").update({
            status: "removed"
        }).eq("id", entry.id).select().single();
        if (error) throw new Error(`Failed to remove from holding area: ${error.message}`);
        return data;
    }
    /**
   * Assign a tenant from the holding area to a hangar
   * Updates status to 'assigned'
   */ async assignFromHoldingArea(tenantId) {
        // Find the active entry for this tenant
        const { data: entry, error: findError } = await this.postgrest.from("holding_area_entry").select().eq("tenant_id", tenantId).eq("status", "active").single();
        if (findError) throw new Error(`Failed to find holding area entry: ${findError.message}`);
        if (!entry) throw new Error(`No active holding area entry found for tenant ${tenantId}`);
        const { data: data, error: error } = await this.postgrest.from("holding_area_entry").update({
            status: "assigned"
        }).eq("id", entry.id).select().single();
        if (error) throw new Error(`Failed to assign from holding area: ${error.message}`);
        return data;
    }
    /**
   * Get all active holding area entries for an FBO
   * Returns entries with full tenant data
   */ async getActiveEntries(fboId) {
        const { data: data, error: error } = await this.postgrest.from("holding_area_entry").select(`
        *,
        tenant:tenant_id (
          *,
          aircraft:aircraft_id (*),
          position:entity_id!inner(*)
        )
      `).eq("fbo_id", fboId).eq("status", "active").order("added_at", {
            ascending: false
        });
        if (error) throw new Error(`Failed to get holding area entries: ${error.message}`);
        return data || [];
    }
    /**
   * Get all holding area entries (including historical) for an FBO
   * Useful for audit trail
   */ async getAllEntries(fboId) {
        const { data: data, error: error } = await this.postgrest.from("holding_area_entry").select(`
        *,
        tenant:tenant_id (
          *,
          aircraft:aircraft_id (*),
          position:entity_id!inner(*)
        )
      `).eq("fbo_id", fboId).order("added_at", {
            ascending: false
        });
        if (error) throw new Error(`Failed to get holding area history: ${error.message}`);
        return data || [];
    }
    /**
   * Get a specific holding area entry by tenant ID
   * Returns the active entry for the tenant if it exists
   */ async getEntryByTenantId(tenantId) {
        const { data: data, error: error } = await this.postgrest.from("holding_area_entry").select(`
        *,
        tenant:tenant_id (
          *,
          aircraft:aircraft_id (*),
          position:entity_id!inner(*)
        )
      `).eq("tenant_id", tenantId).eq("status", "active").maybeSingle();
        if (error) throw new Error(`Failed to get holding area entry: ${error.message}`);
        return data;
    }
    /**
   * Check if a tenant is currently in the holding area
   */ async isInHoldingArea(tenantId) {
        const { data: data, error: error } = await this.postgrest.from("holding_area_entry").select("id").eq("tenant_id", tenantId).eq("status", "active").maybeSingle();
        if (error) throw new Error(`Failed to check holding area status: ${error.message}`);
        return Boolean(data);
    }
}

});



parcelRegister("bX2ze", function(module, exports) {

$parcel$export(module.exports, "AddTripTab", () => $57ef1353edf1bb97$export$8a4fbf610a80dad5);

var $ayMG0 = parcelRequire("ayMG0");

var $iGBB4 = parcelRequire("iGBB4");

var $ap4xJ = parcelRequire("ap4xJ");

var $iwiZ3 = parcelRequire("iwiZ3");
var $1Aijw = parcelRequire("1Aijw");
var $2esSG = parcelRequire("2esSG");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
var $18tt9 = parcelRequire("18tt9");
var $14H9o = parcelRequire("14H9o");

var $78ow6 = parcelRequire("78ow6");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $7S0ew = parcelRequire("7S0ew");

var $acw62 = parcelRequire("acw62");

var $2FHMK = parcelRequire("2FHMK");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");

var $aKUfR = parcelRequire("aKUfR");

var $lQ8IB = parcelRequire("lQ8IB");

var $keHtM = parcelRequire("keHtM");

var $e6g4k = parcelRequire("e6g4k");

var $gYLUy = parcelRequire("gYLUy");
parcelRequire("bPruZ");
var $gDfVd = parcelRequire("gDfVd");

var $hTRQz = parcelRequire("hTRQz");
const $57ef1353edf1bb97$export$8a4fbf610a80dad5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ location: location, currentTime: currentTime, tenants: tenants, onAddTrip: onAddTrip, onClose: onClose, onStateChange: onStateChange }, ref)=>{
    const theme = (0, $14H9o.default)();
    const isTablet = (0, $18tt9.default)(theme.breakpoints.down("lg"));
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    // Initialize shared hook with initial form data
    const initialFormData = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            arrivalDate: currentTime || new Date(),
            departureDate: currentTime ? (0, $7S0ew.addDays)(currentTime, 2) : (0, $7S0ew.addDays)(new Date(), 2)
        }), [
        currentTime
    ]);
    const { formData: formData, setFormData: setFormData, loading: loading, error: error, validationErrors: validationErrors, createTrip: createTrip, validateForm: validateForm, setError: setError, checkForOverlaps: checkForOverlaps, isFormValid: isFormValid } = (0, $aKUfR.useCreateTrip)(initialFormData);
    // Services for trip retrieval
    const tripService = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new (0, $lQ8IB.TripService)(postgrest), [
        postgrest
    ]);
    // Existing trips state
    const [existingTrips, setExistingTrips] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // Trip creation handlers
    const handleTripTailNumberChange = (value)=>{
        setFormData({
            tailNumber: value
        });
    };
    const handleTripTenantChange = (tenant)=>{
        if (tenant) {
            setFormData({
                selectedTenant: tenant,
                tailNumber: tenant.tail_number || "",
                ownerManager: tenant.owner_manager || "",
                tenantType: tenant.type || (0, $keHtM.TenantType).TRANSIENT,
                selectedAircraft: tenant.aircraft || null
            });
            // Fetch existing trips for this tenant
            fetchExistingTrips(tenant.tail_number);
        } else {
            setFormData({
                selectedTenant: null
            });
            setExistingTrips([]);
        }
    };
    // Fetch existing trips for tail number
    const fetchExistingTrips = async (tailNumber)=>{
        if (!activeFBO?.id || !tailNumber.trim()) {
            setExistingTrips([]);
            return;
        }
        try {
            const trips = await tripService.getTripsByTailNumber(activeFBO.id, tailNumber);
            setExistingTrips(trips);
        } catch (error) {
            console.error("Failed to fetch existing trips:", error);
            setExistingTrips([]);
        }
    };
    // Handle trip creation
    const handleCreateTrip = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        try {
            const trip = await createTrip({
                locationId: location?.id,
                locationType: location?.type,
                useGapFilling: true // Use gap filling for AddTripTab
            });
            // Call success callback
            if (onAddTrip) onAddTrip(trip);
            // Reset form and close dialog
            onClose();
            snackbar.notify({
                text: `Trip created for ${formData.tailNumber}`,
                severity: "success"
            });
        } catch (err) {
            console.error("Failed to create trip:", err);
            // Check if error is due to overlapping trips (database constraint)
            if (err.message && err.message.toLowerCase().includes("overlap")) {
                setError("Another overlapping trip exists. Please refresh and select different dates.");
                // Refresh existing trips to show the latest data
                if (formData.selectedTenant) fetchExistingTrips(formData.selectedTenant.tail_number);
            }
        // Error is already set by the shared hook for other cases
        }
    }, [
        createTrip,
        location?.id,
        location?.type,
        onAddTrip,
        onClose,
        snackbar,
        formData.tailNumber,
        formData.selectedTenant,
        setError,
        fetchExistingTrips
    ]);
    // Check for overlaps when dates change
    const hasOverlap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!formData.arrivalDate || !formData.departureDate || !existingTrips.length) return false;
        return checkForOverlaps(formData.arrivalDate, formData.departureDate, existingTrips) !== null;
    }, [
        formData.arrivalDate,
        formData.departureDate,
        existingTrips,
        checkForOverlaps
    ]);
    // Update validation with existing trips
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (formData.arrivalDate && formData.departureDate) validateForm(existingTrips);
    }, [
        formData.arrivalDate,
        formData.departureDate,
        existingTrips,
        validateForm
    ]);
    // Calculate if form is valid including overlap check
    const isFormValidWithOverlapCheck = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return isFormValid && !hasOverlap;
    }, [
        isFormValid,
        hasOverlap
    ]);
    // Expose form state via ref
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            isFormValid: isFormValidWithOverlapCheck,
            loading: loading,
            createTrip: handleCreateTrip
        }));
    // Track "No departure" checkbox state
    const [noScheduledDeparture, setNoScheduledDeparture] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Sync checkbox state with formData.departureDate
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setNoScheduledDeparture((0, $gYLUy.isInfinityDate)(formData.departureDate));
    }, [
        formData.departureDate
    ]);
    // Notify parent of state changes for DialogActions
    const onStateChangeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onStateChange);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onStateChangeRef.current = onStateChange;
    }, [
        onStateChange
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onStateChangeRef.current?.(isFormValidWithOverlapCheck, loading);
    }, [
        isFormValidWithOverlapCheck,
        loading
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
        dateAdapter: (0, $78ow6.AdapterDateFns),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: isTablet ? 1.25 : 2,
            sx: {
                height: "100%",
                overflowY: "visible",
                pt: isTablet ? 0.5 : 1,
                minHeight: 0
            },
            children: [
                error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                    severity: "error",
                    onClose: ()=>setError(null),
                    children: error
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gDfVd.SelectTailNumber), {
                    disableAutocomplete: false,
                    defaultValue: "",
                    tenants: tenants,
                    onInputChange: handleTripTailNumberChange,
                    onChange: handleTripTenantChange,
                    warning: validationErrors.tailNumber
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            label: "Owner/Manager",
                            value: formData.ownerManager,
                            onChange: (e)=>setFormData({
                                    ownerManager: e.target.value
                                }),
                            fullWidth: true,
                            size: "small",
                            placeholder: "e.g., John Smith"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                            select: true,
                            label: "Type",
                            value: formData.tenantType,
                            onChange: (e)=>setFormData({
                                    tenantType: e.target.value
                                }),
                            size: "small",
                            sx: {
                                minWidth: 120
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: (0, $keHtM.TenantType).TRANSIENT,
                                    children: "Transient"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: (0, $keHtM.TenantType).BASE,
                                    children: "Base"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                            label: "Search by make and model",
                            onSelect: (aircraft)=>setFormData({
                                    selectedAircraft: aircraft
                                }),
                            defaultSelected: formData.selectedAircraft || undefined
                        }),
                        validationErrors.aircraft && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "error",
                            children: validationErrors.aircraft
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "body2",
                            color: "text.secondary",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                    fontSize: "small",
                                    sx: {
                                        verticalAlign: "middle",
                                        mr: 0.5
                                    },
                                    color: "action"
                                }),
                                "Arrival Date & Time ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        color: "red"
                                    },
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                            label: "",
                            value: formData.arrivalDate,
                            onChange: (newValue)=>setFormData({
                                    arrivalDate: newValue
                                }),
                            minDate: (0, $e6g4k.SCHEDULE_MIN_DATE),
                            ampm: false,
                            minutesStep: 15,
                            slotProps: {
                                textField: {
                                    fullWidth: true,
                                    size: "small",
                                    error: !!validationErrors.arrivalDate,
                                    helperText: validationErrors.arrivalDate
                                }
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                            fontSize: "small",
                                            sx: {
                                                verticalAlign: "middle",
                                                mr: 0.5
                                            },
                                            color: "action"
                                        }),
                                        "Departure Date & Time",
                                        " ",
                                        !noScheduledDeparture && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                color: "red"
                                            },
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                        checked: noScheduledDeparture,
                                        onChange: (e)=>{
                                            const checked = e.target.checked;
                                            setNoScheduledDeparture(checked);
                                            if (checked) // Set departure to infinity
                                            setFormData({
                                                departureDate: (0, $gYLUy.INFINITY_DATE_STRING)
                                            });
                                            else {
                                                // Reset to default (2 days from arrival)
                                                const defaultDeparture = formData.arrivalDate ? (0, $7S0ew.addDays)(formData.arrivalDate, 2) : (0, $7S0ew.addDays)(new Date(), 2);
                                                setFormData({
                                                    departureDate: defaultDeparture
                                                });
                                            }
                                        },
                                        disabled: loading
                                    }),
                                    label: "No departure"
                                })
                            ]
                        }),
                        !noScheduledDeparture ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                            label: "",
                            value: typeof formData.departureDate === "string" ? null : formData.departureDate,
                            onChange: (newValue)=>setFormData({
                                    departureDate: newValue
                                }),
                            minDate: formData.arrivalDate && formData.arrivalDate > (0, $e6g4k.SCHEDULE_MIN_DATE) ? formData.arrivalDate : (0, $e6g4k.SCHEDULE_MIN_DATE),
                            ampm: false,
                            minutesStep: 15,
                            minDateTime: formData.arrivalDate || undefined,
                            slotProps: {
                                textField: {
                                    fullWidth: true,
                                    size: "small",
                                    error: !!validationErrors.departureDate,
                                    helperText: validationErrors.departureDate
                                }
                            }
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                            severity: "info",
                            sx: {
                                mt: 1
                            },
                            children: "This aircraft will remain at the FBO indefinitely with no scheduled departure."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    label: "Notes",
                    value: formData.notes,
                    onChange: (e)=>setFormData({
                            notes: e.target.value
                        }),
                    multiline: true,
                    rows: isTablet ? 2 : 3,
                    size: "small",
                    placeholder: "Optional notes about this trip...",
                    fullWidth: true
                }),
                formData.selectedTenant && existingTrips.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                    severity: hasOverlap ? "error" : "warning",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "body2",
                            gutterBottom: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                children: [
                                    "Existing trips for ",
                                    formData.selectedTenant.tail_number,
                                    ":"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2FHMK.TripListDisplay), {
                            trips: existingTrips,
                            compact: true
                        }),
                        hasOverlap && validationErrors.overlap && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "body2",
                            color: "error",
                            sx: {
                                mt: 1,
                                fontWeight: 500
                            },
                            children: [
                                "\u26A0\uFE0F ",
                                validationErrors.overlap
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            sx: {
                                mt: 1,
                                display: "block",
                                fontStyle: "italic"
                            },
                            children: hasOverlap ? "Please select different dates to avoid overlap" : "Check dates to avoid overlaps - we won't allow overlapping trips"
                        })
                    ]
                }),
                location && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                    severity: "info",
                    children: [
                        "This trip will be automatically assigned to the current",
                        " ",
                        location.type,
                        "."
                    ]
                })
            ]
        })
    });
});
$57ef1353edf1bb97$export$8a4fbf610a80dad5.displayName = "AddTripTab";

});
parcelRegister("2FHMK", function(module, exports) {

$parcel$export(module.exports, "TripListDisplay", () => $74773d892c822119$export$e0fa48040dc132c3);

var $ayMG0 = parcelRequire("ayMG0");

var $iGBB4 = parcelRequire("iGBB4");

var $ap4xJ = parcelRequire("ap4xJ");

var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $kfA3C = parcelRequire("kfA3C");
var $7761d = parcelRequire("7761d");
parcelRequire("acw62");

var $gYLUy = parcelRequire("gYLUy");
const $74773d892c822119$export$e0fa48040dc132c3 = ({ trips: trips, showTailNumber: showTailNumber = false, compact: compact = false })=>{
    if (trips.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
        variant: "caption",
        color: "text.secondary",
        children: "No trips found"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        spacing: compact ? 0.5 : 1,
        children: trips.map((trip)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                spacing: 0.25,
                children: [
                    showTailNumber && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "caption",
                        fontWeight: 500,
                        children: [
                            trip.tail_number,
                            " - ",
                            trip.owner_manager || "No owner"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                sx: {
                                    fontSize: 12,
                                    color: "text.secondary"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                children: (0, $kfA3C.format)((0, $7761d.parseISO)(trip.arrival_date), "MMM d, h:mm a")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "text.secondary",
                                children: "-"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                sx: {
                                    fontSize: 12,
                                    color: "text.secondary"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                children: (0, $gYLUy.formatDepartureDate)(trip.departure_date)
                            })
                        ]
                    })
                ]
            }, trip.trip_id))
    });
};

});


parcelRegister("jPO9z", function(module, exports) {

$parcel$export(module.exports, "AllTripsTab", () => $a00e932270cea69f$export$ab1106bf899ac402);

var $ayMG0 = parcelRequire("ayMG0");

var $dqlTG = parcelRequire("dqlTG");

var $iGBB4 = parcelRequire("iGBB4");

var $ap4xJ = parcelRequire("ap4xJ");

var $2P5BT = parcelRequire("2P5BT");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $9Lykx = parcelRequire("9Lykx");
var $hViLc = parcelRequire("hViLc");
var $2iAqv = parcelRequire("2iAqv");
var $cX7V2 = parcelRequire("cX7V2");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $78ow6 = parcelRequire("78ow6");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $4HKwc = parcelRequire("4HKwc");
var $lGkA3 = parcelRequire("lGkA3");
var $3WoNO = parcelRequire("3WoNO");
var $kfA3C = parcelRequire("kfA3C");
var $l5LF9 = parcelRequire("l5LF9");
var $hnYfM = parcelRequire("hnYfM");
var $1sdKP = parcelRequire("1sdKP");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $6fDLr = parcelRequire("6fDLr");

var $kWYrU = parcelRequire("kWYrU");

var $a7gZr = parcelRequire("a7gZr");

var $lQ8IB = parcelRequire("lQ8IB");

var $aHqXU = parcelRequire("aHqXU");
parcelRequire("LjLd0");
var $97ydF = parcelRequire("97ydF");

var $f4Dj1 = parcelRequire("f4Dj1");

var $35bYL = parcelRequire("35bYL");

var $adZJa = parcelRequire("adZJa");

var $6SKo7 = parcelRequire("6SKo7");

var $gwxbx = parcelRequire("gwxbx");
const $a00e932270cea69f$export$ab1106bf899ac402 = ({ locationId: locationId, locationType: locationType, currentTime: currentTime, onAssignmentComplete: onAssignmentComplete })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hangars: hangars } = (0, $7FzhI.useHangarsState)();
    const { ramps: ramps } = (0, $3AGzj.useRampsState)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const [loading, setLoading] = $acw62.useState(true);
    const [initialTrips, setInitialTrips] = $acw62.useState([]);
    const [filterText, setFilterText] = $acw62.useState("");
    const [locationFilterId, setLocationFilterId] = $acw62.useState("");
    const [showPastTrips, setShowPastTrips] = $acw62.useState(true);
    const [startDate, setStartDate] = $acw62.useState(null);
    const [endDate, setEndDate] = $acw62.useState(null);
    const [createTripDialogOpen, setCreateTripDialogOpen] = $acw62.useState(false);
    const [selectedTailNumberForNewTrip, setSelectedTailNumberForNewTrip] = $acw62.useState(null);
    const [rowSelectionModel, setRowSelectionModel] = $acw62.useState([]);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = $acw62.useState(false);
    const tripService = $acw62.useMemo(()=>new (0, $lQ8IB.TripService)(postgrest), [
        postgrest
    ]);
    const placementService = $acw62.useMemo(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    // Use optimistic trips hook
    const { trips: trips, loadingTripIds: loadingTripIds, bulkAssignTrips: bulkAssignTrips, bulkUnassignTrips: bulkUnassignTrips, bulkCancelTrips: bulkCancelTrips, bulkDeleteTrips: bulkDeleteTrips, refreshTrips: refreshTrips } = (0, $6SKo7.useOptimisticTrips)({
        initialTrips: initialTrips
    });
    // Transform to table data
    const tableData = (0, $gwxbx.useTripsTableData)({
        trips: trips,
        filterText: filterText,
        locationFilterId: locationFilterId,
        showPastTrips: showPastTrips,
        currentTime: currentTime,
        startDate: startDate,
        endDate: endDate
    });
    // Fetch all trips on mount
    $acw62.useEffect(()=>{
        const fetchTrips = async ()=>{
            if (!activeFBO) return;
            try {
                setLoading(true);
                const allTrips = await tripService.listTripsWithTenantAndPlacement(activeFBO.id);
                const sortedTrips = allTrips.sort((a, b)=>{
                    const aDate = a.arrival_date ? new Date(a.arrival_date).getTime() : 0;
                    const bDate = b.arrival_date ? new Date(b.arrival_date).getTime() : 0;
                    return aDate - bDate;
                });
                setInitialTrips(sortedTrips);
                refreshTrips(sortedTrips);
            } catch (error) {
                console.error("Failed to fetch trips:", error);
                snackbar.notify({
                    text: "Failed to load trips",
                    severity: "error"
                });
            } finally{
                setLoading(false);
            }
        };
        fetchTrips();
    }, [
        activeFBO,
        tripService,
        snackbar,
        refreshTrips
    ]);
    const getTripStatus = (trip)=>{
        if (!trip.arrival_date || !trip.departure_date) return "upcoming";
        const start = new Date(trip.arrival_date);
        const end = new Date(trip.departure_date);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) return "upcoming";
        if (currentTime < start) return "upcoming";
        if (currentTime > end) return "past";
        return "active";
    };
    const formatTripDuration = (startTime, endTime)=>{
        if (!startTime || !endTime) return "--";
        const start = new Date(startTime);
        const end = new Date(endTime);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) return "--";
        const days = (0, $4HKwc.differenceInDays)(end, start);
        const hours = (0, $lGkA3.differenceInHours)(end, start) % 24;
        const minutes = (0, $3WoNO.differenceInMinutes)(end, start) % 60;
        if (days > 0) return `${days}d ${hours}h`;
        else if (hours > 0) return `${hours}h ${minutes}m`;
        else return `${minutes}m`;
    };
    const isAssignedToThisLocation = (trip)=>{
        if (locationType === "hangar") return trip.hangar_id === locationId;
        else if (locationType === "ramp") return trip.ramp_id === locationId;
        return false;
    };
    const getStatusLabel = (status, trip)=>{
        if (trip.status === "cancelled") return "Cancelled";
        if (status === "past") return "Past";
        if (status === "active") return "Active";
        if (!trip.arrival_date) return "Future";
        const arrivalDate = new Date(trip.arrival_date);
        const daysDiff = (0, $4HKwc.differenceInDays)(arrivalDate, currentTime);
        if ((0, $hnYfM.isToday)(arrivalDate)) return "Today";
        if ((0, $1sdKP.isTomorrow)(arrivalDate)) return "Tomorrow";
        if (daysDiff <= 7) return "This Week";
        if (daysDiff <= 14) return "Next Week";
        if ((0, $l5LF9.isThisMonth)(arrivalDate)) return "This Month";
        return "Future";
    };
    // Handle bulk operations
    const handleBulkAssign = async ()=>{
        // Validate that a location is selected in the filter
        if (!locationFilterId) {
            snackbar.notify({
                text: "Please select a location from the filter dropdown before assigning trips",
                severity: "error"
            });
            return;
        }
        const tripIds = rowSelectionModel;
        const targetLocation = allLocations.find((loc)=>loc.id === locationFilterId);
        if (!targetLocation) {
            snackbar.notify({
                text: "Selected location not found",
                severity: "error"
            });
            return;
        }
        try {
            await bulkAssignTrips(tripIds, targetLocation.id, targetLocation.type, targetLocation.name, async (tripId)=>{
                const trip = trips.find((t)=>t.trip_id === tripId);
                if (!trip) return;
                await placementService.assignToLocationWithGapFilling(tripId, targetLocation.id, targetLocation.type, trip.arrival_date || "", trip.departure_date || "", true, {
                    x: null,
                    y: null,
                    angle: null
                });
            });
            snackbar.notify({
                text: `Assigned ${tripIds.length} trip${tripIds.length !== 1 ? "s" : ""} to ${targetLocation.name}`,
                severity: "success"
            });
            setRowSelectionModel([]);
            if (onAssignmentComplete) onAssignmentComplete();
        } catch (error) {
            snackbar.notify({
                text: error.message || "Failed to assign trips",
                severity: "error"
            });
        }
    };
    const handleBulkUnassign = async ()=>{
        const tripIds = rowSelectionModel;
        try {
            await bulkUnassignTrips(tripIds, async (tripId)=>{
                await placementService.rebuildTripCoverage(tripId, []);
            });
            snackbar.notify({
                text: `Unassigned ${tripIds.length} trip${tripIds.length !== 1 ? "s" : ""}`,
                severity: "success"
            });
            setRowSelectionModel([]);
            if (onAssignmentComplete) onAssignmentComplete();
        } catch (error) {
            snackbar.notify({
                text: error.message || "Failed to unassign trips",
                severity: "error"
            });
        }
    };
    const handleBulkCancel = async ()=>{
        const tripIds = rowSelectionModel;
        try {
            await bulkCancelTrips(tripIds, async (tripId)=>{
                await tripService.cancelTrip(tripId);
            });
            snackbar.notify({
                text: `Cancelled ${tripIds.length} trip${tripIds.length !== 1 ? "s" : ""}`,
                severity: "success"
            });
            setRowSelectionModel([]);
            if (onAssignmentComplete) onAssignmentComplete();
        } catch (error) {
            snackbar.notify({
                text: error.message || "Failed to cancel trips",
                severity: "error"
            });
        }
    };
    const handleBulkDelete = async ()=>{
        setShowDeleteConfirmation(true);
    };
    const handleConfirmDelete = async ()=>{
        const tripIds = rowSelectionModel;
        try {
            await bulkDeleteTrips(tripIds, async (tripId)=>{
                await tripService.deleteTrip(tripId);
            });
            snackbar.notify({
                text: `Deleted ${tripIds.length} trip${tripIds.length !== 1 ? "s" : ""}`,
                severity: "success"
            });
            setRowSelectionModel([]);
            if (onAssignmentComplete) onAssignmentComplete();
        } catch (error) {
            snackbar.notify({
                text: error.message || "Failed to delete trips",
                severity: "error"
            });
        }
    };
    // Column definitions
    const columns = $acw62.useMemo(()=>[
            {
                field: "tail_number",
                headerName: "Tail Number",
                width: 110,
                renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        children: params.row.tail_number || "--"
                    })
            },
            {
                field: "arrival_date",
                headerName: "Arrival",
                width: 130,
                renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        alignItems: "center",
                        spacing: 0.5,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                sx: {
                                    fontSize: 14
                                },
                                color: "action"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                children: params.row.arrival_date ? (0, $kfA3C.format)(new Date(params.row.arrival_date), "MMM d HH:mm") : "--"
                            })
                        ]
                    })
            },
            {
                field: "departure_date",
                headerName: "Departure",
                width: 130,
                renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        alignItems: "center",
                        spacing: 0.5,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                sx: {
                                    fontSize: 14
                                },
                                color: "action"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                children: params.row.departure_date ? (0, $kfA3C.format)(new Date(params.row.departure_date), "MMM d HH:mm") : "--"
                            })
                        ]
                    })
            },
            {
                field: "duration",
                headerName: "Duration",
                width: 70,
                align: "right",
                headerAlign: "right",
                renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "text.secondary",
                        children: formatTripDuration(params.row.arrival_date, params.row.departure_date)
                    })
            },
            {
                field: "status",
                headerName: "Status",
                width: 85,
                align: "center",
                headerAlign: "center",
                renderCell: (params)=>{
                    const status = getTripStatus(params.row);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                        label: getStatusLabel(status, params.row),
                        size: "small",
                        color: params.row.status === "cancelled" ? "error" : status === "active" ? "success" : status === "upcoming" ? "primary" : "default",
                        variant: "outlined",
                        sx: {
                            height: 20,
                            fontSize: "0.65rem"
                        }
                    });
                }
            },
            {
                field: "location_name",
                headerName: "Location",
                width: 150,
                renderCell: (params)=>{
                    const isAssigned = isAssignedToThisLocation(params.row);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                        label: params.row.location_name || "Unassigned",
                        size: "small",
                        variant: "filled",
                        sx: {
                            height: 20,
                            fontSize: "0.65rem",
                            backgroundColor: isAssigned ? "#e3f2fd" : params.row.location_name ? "#fff3e0" : "#f5f5f5",
                            color: isAssigned ? "#1565c0" : params.row.location_name ? "#e65100" : "#666666"
                        }
                    });
                }
            },
            {
                field: "actions",
                headerName: "Actions",
                width: 110,
                sortable: false,
                align: "center",
                headerAlign: "center",
                renderCell: (params)=>{
                    const status = getTripStatus(params.row);
                    const isAssigned = isAssignedToThisLocation(params.row);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97ydF.AssignTripButton), {
                        trip: params.row,
                        currentLocationId: locationId,
                        currentLocationType: locationType,
                        isAssigned: isAssigned,
                        disabled: status === "past" || params.row.status === "cancelled",
                        size: "small",
                        iconOnly: true,
                        onAssignmentComplete: onAssignmentComplete
                    });
                }
            }
        ], [
        currentTime,
        locationId,
        locationType,
        onAssignmentComplete
    ]);
    // Locations for bulk action toolbar
    const allLocations = $acw62.useMemo(()=>{
        const locations = [];
        hangars.forEach((hangar)=>{
            locations.push({
                id: hangar.id,
                name: hangar.name,
                type: "hangar"
            });
        });
        ramps.forEach((ramp)=>{
            locations.push({
                id: ramp.id,
                name: ramp.name,
                type: "ramp"
            });
        });
        return locations;
    }, [
        hangars,
        ramps
    ]);
    // Get selected trip count
    const selectedTripCount = rowSelectionModel.length;
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 2,
        sx: {
            minHeight: 400,
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                variant: "text",
                height: 40
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                variant: "rectangular",
                height: 100
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                variant: "rectangular",
                height: 100
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                variant: "rectangular",
                height: 100
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 1,
        sx: {
            minHeight: 300,
            maxHeight: 600,
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
                dateAdapter: (0, $78ow6.AdapterDateFns),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            placeholder: "Filter tail or owner",
                            value: filterText,
                            onChange: (e)=>setFilterText(e.target.value),
                            InputProps: {
                                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                    position: "start",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {
                                        fontSize: "small"
                                    })
                                })
                            },
                            size: "small",
                            sx: {
                                width: 200
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                            size: "small",
                            value: locationFilterId,
                            onChange: (e)=>setLocationFilterId(e.target.value),
                            displayEmpty: true,
                            sx: {
                                width: 180,
                                bgcolor: "background.paper"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: "",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                        children: "All Locations"
                                    })
                                }),
                                allLocations.map((location)=>{
                                    const isCurrentRamp = location.type === "ramp" && location.id === locationId;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                        value: location.id,
                                        children: [
                                            isCurrentRamp && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                component: "span",
                                                sx: {
                                                    display: "inline-block",
                                                    width: 6,
                                                    height: 6,
                                                    borderRadius: "50%",
                                                    bgcolor: "primary.main",
                                                    mr: 1
                                                }
                                            }),
                                            location.name,
                                            " (",
                                            location.type,
                                            ")"
                                        ]
                                    }, location.id);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                            label: "Start Date",
                            value: startDate,
                            onChange: setStartDate,
                            ampm: false,
                            slotProps: {
                                textField: {
                                    size: "small",
                                    sx: {
                                        width: 180
                                    },
                                    InputProps: {
                                        endAdornment: startDate ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                            position: "end",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                size: "small",
                                                onClick: ()=>setStartDate(null),
                                                edge: "end",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        }) : null
                                    }
                                },
                                actionBar: {
                                    actions: [
                                        "accept"
                                    ]
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                            label: "End Date",
                            value: endDate,
                            onChange: setEndDate,
                            ampm: false,
                            slotProps: {
                                textField: {
                                    size: "small",
                                    sx: {
                                        width: 180
                                    },
                                    InputProps: {
                                        endAdornment: endDate ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                            position: "end",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                size: "small",
                                                onClick: ()=>setEndDate(null),
                                                edge: "end",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        }) : null
                                    }
                                },
                                actionBar: {
                                    actions: [
                                        "accept"
                                    ]
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: showPastTrips ? "contained" : "outlined",
                            size: "small",
                            onClick: ()=>setShowPastTrips(!showPastTrips),
                            sx: {
                                height: 32
                            },
                            children: showPastTrips ? "Hide Past" : "Show Past"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            sx: {
                                whiteSpace: "nowrap"
                            },
                            children: [
                                tableData.length,
                                " trips"
                            ]
                        })
                    ]
                })
            }),
            selectedTripCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adZJa.BulkActionToolbar), {
                selectedCount: selectedTripCount,
                onBulkAssign: handleBulkAssign,
                onBulkUnassign: handleBulkUnassign,
                onBulkCancel: handleBulkCancel,
                onBulkDelete: handleBulkDelete,
                onClearSelection: ()=>setRowSelectionModel([]),
                canDelete: hasPermission((0, $aHqXU.Permission).DELETE_TRIPS)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    flex: 1,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                    rows: tableData,
                    columns: columns,
                    getRowId: (row)=>row.trip_id,
                    checkboxSelection: true,
                    disableRowSelectionOnClick: true,
                    rowSelectionModel: rowSelectionModel,
                    onRowSelectionModelChange: setRowSelectionModel,
                    density: "compact",
                    sx: {
                        "& .MuiDataGrid-row": {
                            minHeight: "32px !important",
                            "&:nth-of-type(even)": {
                                backgroundColor: "#fafbfc"
                            }
                        },
                        "& .MuiDataGrid-cell": {
                            display: "flex",
                            alignItems: "center",
                            py: 0.5
                        }
                    },
                    pageSizeOptions: [
                        25,
                        50,
                        100
                    ],
                    initialState: {
                        pagination: {
                            paginationModel: {
                                pageSize: 50
                            }
                        }
                    },
                    loading: loadingTripIds.size > 0
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35bYL.CreateTripDialog), {
                open: createTripDialogOpen,
                onClose: ()=>{
                    setCreateTripDialogOpen(false);
                    setSelectedTailNumberForNewTrip(null);
                },
                onSuccess: async ()=>{
                    setCreateTripDialogOpen(false);
                    setSelectedTailNumberForNewTrip(null);
                    // Refresh trips list
                    if (activeFBO) {
                        const allTrips = await tripService.listTripsWithTenantAndPlacement(activeFBO.id);
                        const sortedTrips = allTrips.sort((a, b)=>{
                            const aDate = a.arrival_date ? new Date(a.arrival_date).getTime() : 0;
                            const bDate = b.arrival_date ? new Date(b.arrival_date).getTime() : 0;
                            return aDate - bDate;
                        });
                        setInitialTrips(sortedTrips);
                        refreshTrips(sortedTrips);
                    }
                },
                simpleMode: !!selectedTailNumberForNewTrip,
                existingTenant: selectedTailNumberForNewTrip || undefined
            }),
            showDeleteConfirmation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Delete Trips?",
                text: `Are you sure you want to permanently delete ${rowSelectionModel.length} trip${rowSelectionModel.length !== 1 ? "s" : ""}? This action cannot be undone.`,
                okText: "Delete",
                okButtonColor: "error",
                onCancel: ()=>setShowDeleteConfirmation(false),
                onOk: handleConfirmDelete,
                onClose: ()=>setShowDeleteConfirmation(false)
            })
        ]
    });
};

});
parcelRegister("l5LF9", function(module, exports) {

$parcel$export(module.exports, "isThisMonth", () => $4c040efe6be2217a$export$173f1e1d92847276);

var $c50C8 = parcelRequire("c50C8");

var $8ubaZ = parcelRequire("8ubaZ");
function $4c040efe6be2217a$export$173f1e1d92847276(date) {
    return (0, $8ubaZ.isSameMonth)(date, (0, $c50C8.constructNow)(date));
}
var // Fallback for modularized imports:
$4c040efe6be2217a$export$2e2bcd8739ae039 = $4c040efe6be2217a$export$173f1e1d92847276;

});
parcelRegister("c50C8", function(module, exports) {

$parcel$export(module.exports, "constructNow", () => $a146c3e31d4b204d$export$18c3c6510fb97afc);

var $bXANJ = parcelRequire("bXANJ");
function $a146c3e31d4b204d$export$18c3c6510fb97afc(date) {
    return (0, $bXANJ.constructFrom)(date, Date.now());
}
var // Fallback for modularized imports:
$a146c3e31d4b204d$export$2e2bcd8739ae039 = $a146c3e31d4b204d$export$18c3c6510fb97afc;

});

parcelRegister("8ubaZ", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", () => $0b324b26c46cd5d7$export$a18c89cbd24170ff);

var $9Jots = parcelRequire("9Jots");
function $0b324b26c46cd5d7$export$a18c89cbd24170ff(dateLeft, dateRight) {
    const _dateLeft = (0, $9Jots.toDate)(dateLeft);
    const _dateRight = (0, $9Jots.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}
var // Fallback for modularized imports:
$0b324b26c46cd5d7$export$2e2bcd8739ae039 = $0b324b26c46cd5d7$export$a18c89cbd24170ff;

});


parcelRegister("hnYfM", function(module, exports) {

$parcel$export(module.exports, "isToday", () => $36d0fca4a40aa9b2$export$629b0a497aa65267);

var $c50C8 = parcelRequire("c50C8");

var $8AHLd = parcelRequire("8AHLd");
function $36d0fca4a40aa9b2$export$629b0a497aa65267(date) {
    return (0, $8AHLd.isSameDay)(date, (0, $c50C8.constructNow)(date));
}
var // Fallback for modularized imports:
$36d0fca4a40aa9b2$export$2e2bcd8739ae039 = $36d0fca4a40aa9b2$export$629b0a497aa65267;

});
parcelRegister("8AHLd", function(module, exports) {

$parcel$export(module.exports, "isSameDay", () => $fc0b49ce51db4bd5$export$ea39ec197993aef0);

var $g04kv = parcelRequire("g04kv");
function $fc0b49ce51db4bd5$export$ea39ec197993aef0(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $g04kv.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $g04kv.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}
var // Fallback for modularized imports:
$fc0b49ce51db4bd5$export$2e2bcd8739ae039 = $fc0b49ce51db4bd5$export$ea39ec197993aef0;

});


parcelRegister("1sdKP", function(module, exports) {

$parcel$export(module.exports, "isTomorrow", () => $5ba1ab3e828ef398$export$d6365ba92f0647f1);

var $7S0ew = parcelRequire("7S0ew");

var $c50C8 = parcelRequire("c50C8");

var $8AHLd = parcelRequire("8AHLd");
function $5ba1ab3e828ef398$export$d6365ba92f0647f1(date) {
    return (0, $8AHLd.isSameDay)(date, (0, $7S0ew.addDays)((0, $c50C8.constructNow)(date), 1));
}
var // Fallback for modularized imports:
$5ba1ab3e828ef398$export$2e2bcd8739ae039 = $5ba1ab3e828ef398$export$d6365ba92f0647f1;

});

parcelRegister("LjLd0", function(module, exports) {

$parcel$export(module.exports, "AssignTripButton", () => (parcelRequire("97ydF")).AssignTripButton);

var $97ydF = parcelRequire("97ydF");

});
parcelRegister("97ydF", function(module, exports) {

$parcel$export(module.exports, "AssignTripButton", () => $9d5301c0330c1b96$export$2c0320f114962771);

var $ayMG0 = parcelRequire("ayMG0");

var $hmTQO = parcelRequire("hmTQO");

var $8kUPg = parcelRequire("8kUPg");

var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");
var $cVXaD = parcelRequire("cVXaD");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $6fDLr = parcelRequire("6fDLr");

var $a7gZr = parcelRequire("a7gZr");

var $c9nMz = parcelRequire("c9nMz");
const $9d5301c0330c1b96$export$2c0320f114962771 = ({ trip: trip, currentLocationId: currentLocationId, currentLocationType: currentLocationType, isAssigned: isAssigned = false, disabled: disabled = false, size: size = "small", iconOnly: iconOnly = false, onAssignmentComplete: onAssignmentComplete })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { hangars: hangars } = (0, $7FzhI.useHangarsState)();
    const { ramps: ramps } = (0, $3AGzj.useRampsState)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const [assigning, setAssigning] = $acw62.useState(false);
    const [menuAnchorEl, setMenuAnchorEl] = $acw62.useState(null);
    const placementService = $acw62.useMemo(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    // Handle assignment to any location
    const handleAssignToLocation = async (locationId, locationType, locationName)=>{
        try {
            setAssigning(true);
            await placementService.assignToLocationWithGapFilling(trip.trip_id, locationId, locationType, trip.arrival_date || "", trip.departure_date || "", true, // excludeConflicts
            {
                x: null,
                y: null,
                angle: null
            } // Let the system determine position
            );
            snackbar.notify({
                text: `Assigned ${trip.tail_number} to ${locationName}`,
                severity: "success"
            });
            if (onAssignmentComplete) onAssignmentComplete();
        } catch (error) {
            console.error("Failed to assign trip:", error);
            snackbar.notify({
                text: error.message || "Failed to assign trip",
                severity: "error"
            });
        } finally{
            setAssigning(false);
        }
    };
    // Build options for the split button
    const options = $acw62.useMemo(()=>{
        const allOptions = [];
        // First option: current location (default)
        const currentLocationName = currentLocationType === "hangar" ? hangars.find((h)=>h.id === currentLocationId)?.name || "This Hangar" : ramps.find((r)=>r.id === currentLocationId)?.name || "This Ramp";
        allOptions.push({
            label: isAssigned ? "Assigned" : `Assign to ${currentLocationName}`,
            disabled: isAssigned || disabled,
            onClick: ()=>handleAssignToLocation(currentLocationId, currentLocationType, currentLocationName)
        });
        // Add separator label if there are other locations
        if (hangars.length > 1 || ramps.length > 0) {
            // Add all other hangars
            const otherHangars = hangars.filter((hangar)=>hangar.id !== currentLocationId || currentLocationType !== "hangar");
            if (otherHangars.length > 0) otherHangars.forEach((hangar)=>{
                const isAssignedToThis = trip.hangar_id === hangar.id;
                allOptions.push({
                    label: isAssignedToThis ? `\u{2713} ${hangar.name}` : hangar.name,
                    disabled: isAssignedToThis || disabled,
                    onClick: ()=>handleAssignToLocation(hangar.id, "hangar", hangar.name)
                });
            });
            // Add all ramps
            const otherRamps = ramps.filter((ramp)=>ramp.id !== currentLocationId || currentLocationType !== "ramp");
            if (otherRamps.length > 0) otherRamps.forEach((ramp)=>{
                const isAssignedToThis = trip.ramp_id === ramp.id;
                allOptions.push({
                    label: isAssignedToThis ? `\u{2713} ${ramp.name}` : ramp.name,
                    disabled: isAssignedToThis || disabled,
                    onClick: ()=>handleAssignToLocation(ramp.id, "ramp", ramp.name)
                });
            });
        }
        return allOptions;
    }, [
        hangars,
        ramps,
        currentLocationId,
        currentLocationType,
        isAssigned,
        disabled,
        trip.hangar_id,
        trip.ramp_id,
        trip.tail_number,
        trip.trip_id,
        trip.arrival_date,
        trip.departure_date
    ]);
    // Show loading spinner if assigning
    if (assigning) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
        size: size === "small" ? 12 : 20
    });
    // Get current location name for tooltip
    const currentLocationName = currentLocationType === "hangar" ? hangars.find((h)=>h.id === currentLocationId)?.name || "This Hangar" : ramps.find((r)=>r.id === currentLocationId)?.name || "This Ramp";
    // Icon-only mode: show button with icon and text, dropdown menu on click
    if (iconOnly) {
        const handleButtonClick = (event)=>{
            if (!disabled && !isAssigned) setMenuAnchorEl(event.currentTarget);
        };
        const handleMenuClose = ()=>{
            setMenuAnchorEl(null);
        };
        const tooltipTitle = isAssigned ? `Assigned to ${currentLocationName}` : `Assign to ${currentLocationName}`;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: tooltipTitle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            startIcon: isAssigned ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmTQO))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8kUPg))), {}),
                            onClick: handleButtonClick,
                            disabled: disabled,
                            size: size,
                            variant: isAssigned ? "text" : "outlined",
                            color: isAssigned ? "success" : "primary",
                            sx: {
                                minHeight: 0,
                                py: 0.25,
                                px: 1
                            },
                            children: isAssigned ? "Assigned" : "Assign"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
                    anchorEl: menuAnchorEl,
                    open: Boolean(menuAnchorEl),
                    onClose: handleMenuClose,
                    children: options.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                            disabled: option.disabled,
                            onClick: ()=>{
                                if (!option.disabled && option.onClick) option.onClick();
                                handleMenuClose();
                            },
                            children: option.label
                        }, index))
                })
            ]
        });
    }
    // Standard mode: show split button
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9nMz.SplitButton), {
        options: options,
        disabled: disabled || assigning,
        color: isAssigned ? "inherit" : "primary",
        size: size
    });
};

});
parcelRegister("8kUPg", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $611c456ff945bdca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $611c456ff945bdca$var$_createSvgIcon = $611c456ff945bdca$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $611c456ff945bdca$var$_default = module.exports.default = (0, $611c456ff945bdca$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 1v3h3v2h-3v3h-2V6h-3V4h3V1zm-8 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m2-9.75V7h3v3h2.92c.05.39.08.79.08 1.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 6.22 7.8 3 12 3c.68 0 1.35.08 2 .25"
}), 'AddLocationAlt');

});



parcelRegister("adZJa", function(module, exports) {

$parcel$export(module.exports, "BulkActionToolbar", () => $e92ee39fd27202c4$export$522b8308f1751ff5);

var $ayMG0 = parcelRequire("ayMG0");

var $jO6ya = parcelRequire("jO6ya");

var $1MdOk = parcelRequire("1MdOk");

var $fKDaI = parcelRequire("fKDaI");

var $lCWOH = parcelRequire("lCWOH");

var $iQIBI = parcelRequire("iQIBI");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $e92ee39fd27202c4$export$522b8308f1751ff5 = ({ selectedCount: selectedCount, onBulkAssign: onBulkAssign, onBulkUnassign: onBulkUnassign, onBulkCancel: onBulkCancel, onBulkDelete: onBulkDelete, onClearSelection: onClearSelection, disabled: disabled = false, canDelete: canDelete = false })=>{
    const [loading, setLoading] = $acw62.useState(false);
    const handleBulkAssign = async ()=>{
        setLoading(true);
        try {
            await onBulkAssign();
        } catch (error) {
            console.error("Bulk assign failed:", error);
        } finally{
            setLoading(false);
        }
    };
    const handleBulkUnassign = async ()=>{
        setLoading(true);
        try {
            await onBulkUnassign();
        } catch (error) {
            console.error("Bulk unassign failed:", error);
        } finally{
            setLoading(false);
        }
    };
    const handleBulkCancel = async ()=>{
        setLoading(true);
        try {
            await onBulkCancel();
        } catch (error) {
            console.error("Bulk cancel failed:", error);
        } finally{
            setLoading(false);
        }
    };
    const handleBulkDelete = async ()=>{
        if (!onBulkDelete) return;
        setLoading(true);
        try {
            await onBulkDelete();
        } catch (error) {
            console.error("Bulk delete failed:", error);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 1.5,
            borderRadius: 1,
            mb: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "row",
            spacing: 1.5,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "body2",
                    fontWeight: 600,
                    color: "primary.main",
                    children: [
                        selectedCount,
                        " trip",
                        selectedCount !== 1 ? "s" : "",
                        " selected"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "contained",
                    size: "small",
                    startIcon: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                        size: 16
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iQIBI))), {}),
                    onClick: handleBulkAssign,
                    disabled: disabled || loading,
                    children: "Assign"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "outlined",
                    size: "small",
                    startIcon: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                        size: 16
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lCWOH))), {}),
                    onClick: handleBulkUnassign,
                    disabled: disabled || loading,
                    children: "Unassign"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "outlined",
                    size: "small",
                    color: "error",
                    startIcon: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                        size: 16
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {}),
                    onClick: handleBulkCancel,
                    disabled: disabled || loading,
                    children: "Cancel"
                }),
                canDelete && onBulkDelete && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "outlined",
                    size: "small",
                    color: "error",
                    startIcon: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                        size: 16
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fKDaI))), {}),
                    onClick: handleBulkDelete,
                    disabled: disabled || loading,
                    children: "Delete"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        flex: 1
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "text",
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jO6ya))), {}),
                    onClick: onClearSelection,
                    disabled: disabled || loading,
                    children: "Clear"
                })
            ]
        })
    });
};

});
parcelRegister("fKDaI", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $b7798996678e060e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7798996678e060e$var$_createSvgIcon = $b7798996678e060e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b7798996678e060e$var$_default = module.exports.default = (0, $b7798996678e060e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zm2.46-7.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteForever');

});


parcelRegister("6SKo7", function(module, exports) {

$parcel$export(module.exports, "useOptimisticTrips", () => $6fd578bc35bdcd05$export$e976de08f37bc121);

var $acw62 = parcelRequire("acw62");
const $6fd578bc35bdcd05$export$e976de08f37bc121 = ({ initialTrips: initialTrips })=>{
    const [trips, setTrips] = $acw62.useState(initialTrips);
    const [loadingTripIds, setLoadingTripIds] = $acw62.useState(new Set());
    // Update trips when initial data changes
    $acw62.useEffect(()=>{
        setTrips(initialTrips);
    }, [
        initialTrips
    ]);
    /**
   * Optimistically assign trip to location
   */ const assignTrip = $acw62.useCallback(async (tripId, locationId, locationType, locationName, performUpdate)=>{
        // Save previous state for rollback
        const previousTrips = trips;
        // Mark trip as loading
        setLoadingTripIds((prev)=>new Set(prev).add(tripId));
        // Optimistic update
        setTrips((prev)=>prev.map((trip)=>{
                if (trip.trip_id !== tripId) return trip;
                // Update location fields based on type
                if (locationType === "hangar") return {
                    ...trip,
                    hangar_id: locationId,
                    hangar_name: locationName,
                    ramp_id: null,
                    ramp_name: null,
                    location_name: locationName,
                    location_type: "hangar"
                };
                else return {
                    ...trip,
                    ramp_id: locationId,
                    ramp_name: locationName,
                    hangar_id: null,
                    hangar_name: null,
                    location_name: locationName,
                    location_type: "ramp"
                };
            }));
        try {
            // Perform actual update
            await performUpdate();
        } catch (error) {
            // Rollback on error
            setTrips(previousTrips);
            throw error;
        } finally{
            // Remove loading state
            setLoadingTripIds((prev)=>{
                const next = new Set(prev);
                next.delete(tripId);
                return next;
            });
        }
    }, [
        trips
    ]);
    /**
   * Optimistically unassign trip from location
   */ const unassignTrip = $acw62.useCallback(async (tripId, performUpdate)=>{
        const previousTrips = trips;
        setLoadingTripIds((prev)=>new Set(prev).add(tripId));
        // Optimistic update
        setTrips((prev)=>prev.map((trip)=>{
                if (trip.trip_id !== tripId) return trip;
                return {
                    ...trip,
                    hangar_id: null,
                    hangar_name: null,
                    ramp_id: null,
                    ramp_name: null,
                    location_name: null,
                    location_type: null
                };
            }));
        try {
            await performUpdate();
        } catch (error) {
            setTrips(previousTrips);
            throw error;
        } finally{
            setLoadingTripIds((prev)=>{
                const next = new Set(prev);
                next.delete(tripId);
                return next;
            });
        }
    }, [
        trips
    ]);
    /**
   * Optimistically bulk assign trips to location
   */ const bulkAssignTrips = $acw62.useCallback(async (tripIds, locationId, locationType, locationName, performUpdate)=>{
        const previousTrips = trips;
        const tripIdsSet = new Set(tripIds);
        // Mark all trips as loading
        setLoadingTripIds((prev)=>{
            const next = new Set(prev);
            tripIds.forEach((id)=>next.add(id));
            return next;
        });
        // Optimistic update
        setTrips((prev)=>prev.map((trip)=>{
                if (!tripIdsSet.has(trip.trip_id)) return trip;
                if (locationType === "hangar") return {
                    ...trip,
                    hangar_id: locationId,
                    hangar_name: locationName,
                    ramp_id: null,
                    ramp_name: null,
                    location_name: locationName,
                    location_type: "hangar"
                };
                else return {
                    ...trip,
                    ramp_id: locationId,
                    ramp_name: locationName,
                    hangar_id: null,
                    hangar_name: null,
                    location_name: locationName,
                    location_type: "ramp"
                };
            }));
        try {
            // Perform updates in parallel
            await Promise.all(tripIds.map((tripId)=>performUpdate(tripId)));
        } catch (error) {
            // Rollback on error
            setTrips(previousTrips);
            throw error;
        } finally{
            // Remove loading states
            setLoadingTripIds((prev)=>{
                const next = new Set(prev);
                tripIds.forEach((id)=>next.delete(id));
                return next;
            });
        }
    }, [
        trips
    ]);
    /**
   * Optimistically bulk unassign trips
   */ const bulkUnassignTrips = $acw62.useCallback(async (tripIds, performUpdate)=>{
        const previousTrips = trips;
        const tripIdsSet = new Set(tripIds);
        setLoadingTripIds((prev)=>{
            const next = new Set(prev);
            tripIds.forEach((id)=>next.add(id));
            return next;
        });
        // Optimistic update
        setTrips((prev)=>prev.map((trip)=>{
                if (!tripIdsSet.has(trip.trip_id)) return trip;
                return {
                    ...trip,
                    hangar_id: null,
                    hangar_name: null,
                    ramp_id: null,
                    ramp_name: null,
                    location_name: null,
                    location_type: null
                };
            }));
        try {
            await Promise.all(tripIds.map((tripId)=>performUpdate(tripId)));
        } catch (error) {
            setTrips(previousTrips);
            throw error;
        } finally{
            setLoadingTripIds((prev)=>{
                const next = new Set(prev);
                tripIds.forEach((id)=>next.delete(id));
                return next;
            });
        }
    }, [
        trips
    ]);
    /**
   * Optimistically delete/cancel trips
   */ const bulkCancelTrips = $acw62.useCallback(async (tripIds, performUpdate)=>{
        const previousTrips = trips;
        const tripIdsSet = new Set(tripIds);
        setLoadingTripIds((prev)=>{
            const next = new Set(prev);
            tripIds.forEach((id)=>next.add(id));
            return next;
        });
        // Optimistic update - remove trips from list
        setTrips((prev)=>prev.filter((trip)=>!tripIdsSet.has(trip.trip_id)));
        try {
            await Promise.all(tripIds.map((tripId)=>performUpdate(tripId)));
        } catch (error) {
            setTrips(previousTrips);
            throw error;
        } finally{
            setLoadingTripIds((prev)=>{
                const next = new Set(prev);
                tripIds.forEach((id)=>next.delete(id));
                return next;
            });
        }
    }, [
        trips
    ]);
    /**
   * Optimistically bulk delete trips (hard delete)
   */ const bulkDeleteTrips = $acw62.useCallback(async (tripIds, performUpdate)=>{
        const previousTrips = trips;
        const tripIdsSet = new Set(tripIds);
        setLoadingTripIds((prev)=>{
            const next = new Set(prev);
            tripIds.forEach((id)=>next.add(id));
            return next;
        });
        // Optimistic update - remove trips from list
        setTrips((prev)=>prev.filter((trip)=>!tripIdsSet.has(trip.trip_id)));
        try {
            await Promise.all(tripIds.map((tripId)=>performUpdate(tripId)));
        } catch (error) {
            setTrips(previousTrips);
            throw error;
        } finally{
            setLoadingTripIds((prev)=>{
                const next = new Set(prev);
                tripIds.forEach((id)=>next.delete(id));
                return next;
            });
        }
    }, [
        trips
    ]);
    /**
   * Force refresh trips from server
   */ const refreshTrips = $acw62.useCallback((newTrips)=>{
        setTrips(newTrips);
    }, []);
    return {
        trips: trips,
        loadingTripIds: loadingTripIds,
        assignTrip: assignTrip,
        unassignTrip: unassignTrip,
        bulkAssignTrips: bulkAssignTrips,
        bulkUnassignTrips: bulkUnassignTrips,
        bulkCancelTrips: bulkCancelTrips,
        bulkDeleteTrips: bulkDeleteTrips,
        refreshTrips: refreshTrips
    };
};

});

parcelRegister("gwxbx", function(module, exports) {

$parcel$export(module.exports, "useTripsTableData", () => $d3479619b5c5c926$export$89b39d0accaf5c12);

var $acw62 = parcelRequire("acw62");
const $d3479619b5c5c926$export$89b39d0accaf5c12 = ({ trips: trips, filterText: filterText, locationFilterId: locationFilterId, showPastTrips: showPastTrips, currentTime: currentTime, startDate: startDate, endDate: endDate })=>{
    const getTripStatus = (trip)=>{
        if (!trip.arrival_date || !trip.departure_date) return "upcoming";
        const start = new Date(trip.arrival_date);
        const end = new Date(trip.departure_date);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) return "upcoming";
        if (currentTime < start) return "upcoming";
        if (currentTime > end) return "past";
        return "active";
    };
    const tableData = $acw62.useMemo(()=>{
        // Filter trips
        const filtered = trips.filter((trip)=>{
            // Filter by search text
            if (filterText) {
                const searchLower = filterText.toLowerCase();
                const matchesSearch = trip.tail_number?.toLowerCase().includes(searchLower) || trip.owner_manager?.toLowerCase().includes(searchLower);
                if (!matchesSearch) return false;
            }
            // Filter by location (show trips assigned to this location)
            if (locationFilterId) {
                const matchesLocation = trip.hangar_id === locationFilterId || trip.ramp_id === locationFilterId;
                if (!matchesLocation) return false;
            }
            // Filter by start date (trips arriving on or after start date)
            if (startDate && trip.arrival_date) {
                const arrivalDate = new Date(trip.arrival_date);
                if (!isNaN(arrivalDate.getTime()) && arrivalDate < startDate) return false;
            }
            // Filter by end date (trips departing on or before end date)
            if (endDate && trip.departure_date) {
                const departureDate = new Date(trip.departure_date);
                if (!isNaN(departureDate.getTime()) && departureDate > endDate) return false;
            }
            // Filter out past trips if needed
            if (!showPastTrips && getTripStatus(trip) === "past") return false;
            return true;
        });
        // Sort by arrival date (earliest first)
        return filtered.sort((a, b)=>{
            const aDate = a.arrival_date ? new Date(a.arrival_date).getTime() : 0;
            const bDate = b.arrival_date ? new Date(b.arrival_date).getTime() : 0;
            return aDate - bDate;
        });
    }, [
        trips,
        filterText,
        locationFilterId,
        showPastTrips,
        currentTime,
        startDate,
        endDate
    ]);
    return tableData;
};

});


parcelRegister("63ZV6", function(module, exports) {

$parcel$export(module.exports, "BulkAdd", () => $5260307fc4592ec9$export$a6f2cbeecceb330);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $jNGAr = parcelRequire("jNGAr");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $aDtBU = parcelRequire("aDtBU");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $6fDLr = parcelRequire("6fDLr");

var $8GP8k = parcelRequire("8GP8k");

var $9OZOC = parcelRequire("9OZOC");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $hTRQz = parcelRequire("hTRQz");
const $5260307fc4592ec9$var$BulkAddByTailNumber = ({ stack: stack, bulkTenantsToAdd: bulkTenantsToAdd, setBulkTenantsToAdd: setBulkTenantsToAdd })=>{
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { tenants: tenants } = (0, $9OZOC.useTenants)();
    const [tailNumbers, setTailNumbers] = $acw62.useState([]);
    const [unfoundTailNumbers, setUnfoundTailNumbers] = $acw62.useState([]);
    const [manualAircraftSelections, setManualAircraftSelections] = $acw62.useState({});
    const [hasSearched, setHasSearched] = $acw62.useState(false);
    const [hasSubmitted, setHasSubmitted] = $acw62.useState(false);
    // Clear manual selections when tail numbers change
    $acw62.useEffect(()=>{
        setManualAircraftSelections((prev)=>{
            const filtered = {};
            tailNumbers.forEach((tn)=>{
                if (prev[tn]) filtered[tn] = prev[tn];
            });
            return filtered;
        });
        setHasSearched(false); // Reset search state when tail numbers change
        setHasSubmitted(false); // Reset submission state when tail numbers change
    }, [
        tailNumbers
    ]);
    const fetchTenantsByTailNumbers = $acw62.useCallback(async ()=>{
        if (tailNumbers.length === 0) {
            setUnfoundTailNumbers([]);
            return [];
        }
        const existingTenants = tenants.filter((t)=>tailNumbers.includes(t.tail_number)).map((t)=>{
            const entity_id = t.entity_id || (0, $lNEp2.uuidv4)();
            return {
                ...t,
                position: {
                    ...t.position ?? {},
                    id: t.position?.id || (0, $lNEp2.consistentId)(entity_id, false),
                    stack_id: stack?.id ?? null,
                    entity_id: entity_id,
                    x: null,
                    y: stack ? -1 * Math.max(t.aircraft.length, t.aircraft.wingspan) : null,
                    angle: null,
                    preferences: (0, $lNEp2.defaultPreferenceForAircraft)(t.aircraft, activeFBO)
                }
            };
        });
        const newTenantTailNumbers = tailNumbers.filter((tn)=>!existingTenants.some((t)=>t.tail_number === tn));
        const { data: data, error: error } = await postgrest.from("vw_faa_tail_numbers").select().in("tail_number", newTenantTailNumbers);
        if (error) throw new Error(error.message);
        // Identify tail numbers not found in the database
        const foundTailNumbers = data.map((row)=>row.tail_number);
        const unfoundTailNumbers = newTenantTailNumbers.filter((tn)=>!foundTailNumbers.includes(tn));
        setUnfoundTailNumbers(unfoundTailNumbers);
        const doit = data.map(async ({ tail_number: tail_number, aircraft_id: aircraft_id })=>{
            const aircraft = await (0, $8GP8k.fetchAircraft)(postgrest, aircraft_id, activeFBO);
            return {
                tail_number: tail_number,
                aircraft_id: aircraft_id,
                aircraft: aircraft
            };
        });
        const newTenantInfos = await Promise.all(doit);
        const newTenants = newTenantInfos.map((newTenantInfo)=>{
            const entity_id = (0, $lNEp2.uuidv4)();
            const tenant = {
                id: (0, $lNEp2.uuidv4)(),
                placement_id: (0, $lNEp2.uuidv4)(),
                fbo_id: activeFBO.id,
                entity_id: entity_id,
                tail_number: newTenantInfo.tail_number || "",
                owner_manager: "",
                note: "",
                note_last_updated: new Date().toISOString(),
                note_last_updated_by: airplxIdentity?.email ?? "Unknown",
                type: stack?.isReference ? "base" : "transient",
                aircraft_id: newTenantInfo.aircraft.id,
                aircraft: newTenantInfo.aircraft,
                selected: false,
                position: {
                    id: (0, $lNEp2.consistentId)(entity_id, false),
                    stack_id: stack?.id ?? null,
                    entity_id: entity_id,
                    x: null,
                    y: stack ? -1 * Math.max(newTenantInfo.aircraft.length, newTenantInfo.aircraft.wingspan) : null,
                    angle: null,
                    preferences: (0, $lNEp2.defaultPreferenceForAircraft)(newTenantInfo.aircraft, activeFBO)
                }
            };
            return tenant;
        });
        return [
            ...existingTenants,
            ...newTenants
        ];
    }, [
        postgrest,
        tailNumbers,
        tenants,
        stack,
        activeFBO,
        airplxIdentity
    ]);
    const handleSubmit = async ()=>{
        if (!hasSearched) {
            // First time - just search and identify unfound tail numbers
            setHasSearched(true);
            await fetchTenantsByTailNumbers(); // This will set unfoundTailNumbers
        } else {
            // Second time - actually add the tenants
            const newTenants = await fetchTenantsByTailNumbers();
            // Create tenants for manually specified aircraft
            const manualTenants = unfoundTailNumbers.filter((tailNumber)=>manualAircraftSelections[tailNumber]).map((tailNumber)=>{
                const aircraft = manualAircraftSelections[tailNumber];
                const entity_id = (0, $lNEp2.uuidv4)();
                const tenant = {
                    id: (0, $lNEp2.uuidv4)(),
                    placement_id: (0, $lNEp2.uuidv4)(),
                    fbo_id: activeFBO.id,
                    entity_id: entity_id,
                    tail_number: tailNumber,
                    owner_manager: "",
                    note: "",
                    note_last_updated: new Date().toISOString(),
                    note_last_updated_by: airplxIdentity?.email ?? "Unknown",
                    type: stack?.isReference ? "base" : "transient",
                    aircraft_id: aircraft.id,
                    aircraft: aircraft,
                    selected: false,
                    position: {
                        id: (0, $lNEp2.consistentId)(entity_id, false),
                        stack_id: stack?.id ?? null,
                        entity_id: entity_id,
                        x: null,
                        y: stack ? -1 * Math.max(aircraft.length, aircraft.wingspan) : null,
                        angle: null,
                        preferences: (0, $lNEp2.defaultPreferenceForAircraft)(aircraft, activeFBO)
                    }
                };
                return tenant;
            });
            const newTenantsToAdd = (0, $cLNZr.uniqBy)([
                ...bulkTenantsToAdd,
                ...newTenants,
                ...manualTenants
            ], "id");
            setBulkTenantsToAdd(newTenantsToAdd);
            setHasSubmitted(true); // Mark as submitted to hide the correction panel
        }
    };
    const removeUnfoundTailNumber = (tailNumberToRemove)=>{
        setUnfoundTailNumbers((prev)=>prev.filter((tn)=>tn !== tailNumberToRemove));
        setManualAircraftSelections((prev)=>{
            const updated = {
                ...prev
            };
            delete updated[tailNumberToRemove];
            return updated;
        });
    };
    // Check if all unfound tail numbers have been handled (either selected aircraft or removed)
    const allUnfoundHandled = unfoundTailNumbers.length === 0 || unfoundTailNumbers.every((tn)=>manualAircraftSelections[tn]);
    // Show submit button only if we have searched and all unfound are handled
    const showSubmitButton = hasSearched && tailNumbers.length > 0 && allUnfoundHandled;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        width: "100%",
        children: !hasSubmitted ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    placeholder: `N12345
N54321
N67890`,
                    variant: "outlined",
                    size: "small",
                    fullWidth: true,
                    multiline: true,
                    rows: 10,
                    onChange: (e)=>{
                        const value = e.target.value.split("\n").map((t)=>t.trim()).filter((t)=>t.length);
                        setTailNumbers(value);
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "caption",
                    color: "text.secondary",
                    children: "Enter one tail number per line."
                }),
                !hasSearched && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "contained",
                    color: "primary",
                    disabled: tailNumbers.length === 0,
                    onClick: handleSubmit,
                    children: "Search"
                }),
                hasSearched && unfoundTailNumbers.length === 0 && tailNumbers.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body2",
                    color: "success.main",
                    sx: {
                        mt: 2
                    },
                    children: "\u2713 All tail numbers found in database"
                }),
                hasSearched && unfoundTailNumbers.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "subtitle2",
                            color: "warning.main",
                            sx: {
                                mt: 2
                            },
                            children: "Unknown Tail Numbers"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            children: "The following tail numbers were not found in the database. Please select the aircraft type for each or remove them:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 2,
                            sx: {
                                mt: 1
                            },
                            children: unfoundTailNumbers.map((tailNumber)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                minWidth: 80,
                                                fontWeight: "bold"
                                            },
                                            children: tailNumber
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            sx: {
                                                flexGrow: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                                                label: "Select aircraft type",
                                                onSelect: (aircraft)=>{
                                                    setManualAircraftSelections((prev)=>({
                                                            ...prev,
                                                            [tailNumber]: aircraft
                                                        }));
                                                },
                                                defaultSelected: manualAircraftSelections[tailNumber] || null
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "outlined",
                                            color: "error",
                                            size: "small",
                                            onClick: ()=>removeUnfoundTailNumber(tailNumber),
                                            children: "Remove"
                                        })
                                    ]
                                }, tailNumber))
                        })
                    ]
                }),
                showSubmitButton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "contained",
                    color: "success",
                    onClick: handleSubmit,
                    sx: {
                        mt: 2
                    },
                    children: "Add Aircraft"
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            spacing: 2,
            alignItems: "center",
            sx: {
                py: 2
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body2",
                    color: "success.main",
                    sx: {
                        textAlign: "center"
                    },
                    children: "\u2713 Aircraft have been added to the list below"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    variant: "outlined",
                    size: "small",
                    onClick: ()=>{
                        setHasSubmitted(false);
                        setHasSearched(false);
                        setTailNumbers([]);
                        setUnfoundTailNumbers([]);
                        setManualAircraftSelections({});
                    },
                    children: "Add More Tail Numbers"
                })
            ]
        })
    });
};
const $5260307fc4592ec9$export$a6f2cbeecceb330 = ({ stack: stack, bulkTenantsToAdd: bulkTenantsToAdd, setBulkTenantsToAdd: setBulkTenantsToAdd })=>{
    const [activeTab, setActiveTab] = $acw62.useState("Add by Make and Model");
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { tenants: tenants } = (0, $9OZOC.useTenants)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const [newAircraft, setNewAircraft] = $acw62.useState(null);
    const [nAircraft, setNAircraft] = $acw62.useState(1);
    const [tailNumbers, setTailNumbers] = $acw62.useState("");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                value: activeTab,
                onChange: (e, newValue)=>{
                    setBulkTenantsToAdd([]); // reset the tenants to add when switching tabs
                    setActiveTab(newValue);
                },
                variant: "fullWidth",
                sx: {
                    width: "100%",
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "Add by Make and Model",
                        label: "Add by Make and Model"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "Add by Tail Numbers",
                        label: "Add by Tail Numbers"
                    })
                ]
            }),
            activeTab === "Add by Tail Numbers" && /*#__PURE__*/ (0, $ayMG0.jsx)($5260307fc4592ec9$var$BulkAddByTailNumber, {
                stack: stack,
                bulkTenantsToAdd: bulkTenantsToAdd,
                setBulkTenantsToAdd: setBulkTenantsToAdd
            }),
            activeTab === "Add by Make and Model" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 2,
                alignItems: "flex-start",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        width: 350,
                        flexShrink: 0,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                            label: "Search by make and model",
                            onSelect: (aircraft)=>setNewAircraft(aircraft),
                            defaultSelected: newAircraft
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        label: "# Aircraft",
                        type: "number",
                        variant: "outlined",
                        size: "small",
                        inputProps: {
                            min: 1,
                            max: 20
                        },
                        onChange: (e)=>{
                            const value = parseInt(e.target.value, 10);
                            // Handle empty input or invalid number
                            if (e.target.value === "" || isNaN(value)) {
                                setNAircraft(1); // Reset to minimum valid value
                                return;
                            }
                            // Show notification if exceeds max
                            if (value > 20) snackbar.notify({
                                severity: "warning",
                                text: "Maximum number of aircraft to add is 20.",
                                duration: 5000
                            });
                            // Clamp value between 1 and 20
                            setNAircraft(Math.min(20, Math.max(1, value)));
                        },
                        value: nAircraft,
                        sx: {
                            width: 100
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        flexGrow: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                label: "Tail Numbers",
                                placeholder: "i.e. N12345, N54321, N67890",
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                onChange: (e)=>{
                                    // remove all commas or non-alphanumeric characters
                                    const value = e.target.value.replace(/[^a-zA-Z0-9,]/g, "");
                                    setTailNumbers(value);
                                },
                                value: tailNumbers
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "text.secondary",
                                children: "Optional. Separate tail numbers with commas."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        flexGrow: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            disabled: !newAircraft || nAircraft === 0,
                            variant: "contained",
                            onClick: ()=>{
                                const newTenants = Array.from({
                                    length: nAircraft
                                }, (_, i)=>{
                                    // extract tail_number from comma delimited list. if it is "" then set it to null
                                    const tail_number = tailNumbers.split(",").map((t)=>t.trim()).filter((t)=>t.length)[i];
                                    const existingTenant = tenants.find((t)=>t.tail_number === tail_number);
                                    if (tail_number?.length && existingTenant) {
                                        // if the aircraft is different, tell the user
                                        if (existingTenant.aircraft.make !== newAircraft.make || existingTenant.aircraft.model !== newAircraft.model) snackbar.notify({
                                            severity: "warning",
                                            text: `Aircraft with tail number ${tail_number} already exists. We\u{2019}ve added the existing tail number and associated aircraft model.`,
                                            duration: 5000
                                        });
                                        return {
                                            ...existingTenant,
                                            selected: false,
                                            position: {
                                                ...existingTenant.position,
                                                stack_id: stack?.id ?? null,
                                                // reset the position
                                                x: null,
                                                y: stack ? -1 * Math.max(newAircraft.length, newAircraft.wingspan) : null,
                                                angle: null,
                                                preferences: (0, $lNEp2.defaultPreferenceForAircraft)(newAircraft, activeFBO)
                                            }
                                        };
                                    }
                                    const entity_id = (0, $lNEp2.uuidv4)();
                                    const tenant = {
                                        id: (0, $lNEp2.uuidv4)(),
                                        placement_id: (0, $lNEp2.uuidv4)(),
                                        fbo_id: activeFBO.id,
                                        entity_id: entity_id,
                                        tail_number: tail_number || "",
                                        owner_manager: "",
                                        note: "",
                                        note_last_updated: new Date().toISOString(),
                                        note_last_updated_by: airplxIdentity?.email ?? "Unknown",
                                        type: stack?.isReference ? "base" : "transient",
                                        aircraft_id: newAircraft.id,
                                        aircraft: newAircraft,
                                        selected: false,
                                        position: {
                                            id: (0, $lNEp2.consistentId)(entity_id, false),
                                            stack_id: stack?.id ?? null,
                                            entity_id: entity_id,
                                            x: null,
                                            y: stack ? -1 * Math.max(newAircraft.length, newAircraft.wingspan) : null,
                                            angle: null,
                                            preferences: (0, $lNEp2.defaultPreferenceForAircraft)(newAircraft, activeFBO)
                                        }
                                    };
                                    return tenant;
                                });
                                const newTenantsToAdd = (0, $cLNZr.uniqBy)([
                                    ...bulkTenantsToAdd,
                                    ...newTenants
                                ], "id");
                                setBulkTenantsToAdd(newTenantsToAdd);
                                // reset
                                setNewAircraft(null);
                                setNAircraft(1);
                                setTailNumbers("");
                            },
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                            children: "Add"
                        })
                    })
                ]
            }),
            bulkTenantsToAdd.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                sx: {
                    maxWidth: 640
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: "Tail #"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: "Model"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                            children: bulkTenantsToAdd.map((tenant)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: tenant.tail_number ?? "N/A"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: tenant.aircraft.model
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: tenant.type
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                variant: "outlined",
                                                color: "error",
                                                size: "small",
                                                onClick: ()=>setBulkTenantsToAdd((prev)=>prev.filter((t)=>t.id !== tenant.id)),
                                                children: "Remove"
                                            })
                                        })
                                    ]
                                }, `tenant-to-add-${tenant.id}`))
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("8UGfr", function(module, exports) {

$parcel$export(module.exports, "NewAircraftForm", () => $f3ef260a01ea23fc$export$e9637bcbdccbd675);

var $ayMG0 = parcelRequire("ayMG0");

var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $18tt9 = parcelRequire("18tt9");
var $14H9o = parcelRequire("14H9o");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $6rxM8 = parcelRequire("6rxM8");

var $9OZOC = parcelRequire("9OZOC");

var $5kwJN = parcelRequire("5kwJN");
parcelRequire("briyn");
var $1gbL9 = parcelRequire("1gbL9");
parcelRequire("bPruZ");
var $gDfVd = parcelRequire("gDfVd");

var $hTRQz = parcelRequire("hTRQz");
const $f3ef260a01ea23fc$export$e9637bcbdccbd675 = ({ disableAutocomplete: disableAutocomplete = false, tailNumber: tailNumber, setTailNumber: setTailNumber, owner: owner, setOwner: setOwner, type: type, setType: setType, location: location, setShowConfirmation: setShowConfirmation, isReference: isReference, newAircraft: newAircraft, setNewAircraft: setNewAircraft, note: note, setNote: setNote, assignedLocation: assignedLocation, setAssignedLocation: setAssignedLocation, currentLocation: currentLocation, setCurrentLocation: setCurrentLocation })=>{
    const theme = (0, $14H9o.default)();
    const isTablet = (0, $18tt9.default)(theme.breakpoints.down("lg"));
    const { tenants: tenants } = (0, $9OZOC.useTenants)();
    const { locations: locations } = (0, $6rxM8.useLocationsState)();
    const [shouldFlashAircraft, setShouldFlashAircraft] = $acw62.useState(false);
    const flashTimeoutRef = $acw62.useRef(null);
    // Cleanup timeout on component unmount
    $acw62.useEffect(()=>{
        return ()=>{
            if (flashTimeoutRef.current) clearTimeout(flashTimeoutRef.current);
        };
    }, []);
    // for the time being tail numbers aren't unique. we're going to cheat a bit
    // and dedup on tail number here
    const tenantsWithTailNumber = $acw62.useMemo(()=>(0, $cLNZr.uniqBy)(tenants.filter((t)=>t.tail_number), "tail_number"), [
        tenants
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: isTablet ? 0.75 : 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gDfVd.SelectTailNumber), {
                        disableAutocomplete: disableAutocomplete,
                        defaultValue: tailNumber,
                        tenants: tenantsWithTailNumber,
                        onInputChange: (tailNumber)=>{
                            setTailNumber(tailNumber);
                        },
                        onChange: (tenant)=>{
                            // Common setter logic
                            setNewAircraft(tenant?.aircraft);
                            setType(tenant?.type ?? "");
                            setTailNumber(tenant?.tail_number ?? "");
                            setOwner(tenant?.owner_manager ?? "");
                            setNote(tenant?.note ?? "");
                            if (tenant?.aircraft) {
                                // Clear any existing timeout before setting a new one
                                if (flashTimeoutRef.current) clearTimeout(flashTimeoutRef.current);
                                // Trigger flash animation when user selects from tail number dropdown
                                setShouldFlashAircraft(true);
                                // Reset flash state after the animation completes
                                flashTimeoutRef.current = setTimeout(()=>{
                                    setShouldFlashAircraft(false);
                                    flashTimeoutRef.current = null;
                                }, 1500);
                            } else {
                                // Fallback for cases where aircraft is not available
                                setNewAircraft(tenant?.aircraft);
                                setType(tenant?.type ?? "");
                                setTailNumber(tenant?.tail_number ?? "");
                                setOwner(tenant?.owner_manager ?? "");
                                setNote(tenant?.note ?? "");
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        inputProps: {
                            testid: "owner_manager"
                        },
                        fullWidth: true,
                        size: "small",
                        label: "Owner/Manager",
                        onChange: (evt)=>setOwner(evt.target.value),
                        value: owner
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                        select: true,
                        size: "small",
                        fullWidth: true,
                        label: "Type",
                        onChange: (evt)=>{
                            if (evt.target.value === "base") {
                                const confirmationText = (0, $5kwJN.addTenantConformationText)(!location || location?.type === "hangar" ? "hangar" : "ramp");
                                setShowConfirmation(confirmationText);
                                return;
                            }
                            setType(evt.target.value);
                        },
                        value: type,
                        children: [
                            (!location || isReference) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "base",
                                children: "Base"
                            }),
                            (!location || !isReference) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                value: "transient",
                                children: "Transient"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                label: "Search by make and model",
                onSelect: (aircraft)=>setNewAircraft(aircraft),
                defaultSelected: newAircraft,
                shouldFlash: shouldFlashAircraft
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                margin: "dense",
                label: "Notes",
                type: "text",
                fullWidth: true,
                placeholder: "Departure Time: 05/24/2025 12:00 PM",
                multiline: true,
                minRows: isTablet ? 3 : 10,
                onChange: (evt)=>setNote(evt.target.value),
                value: note ?? ""
            }),
            !location && type === "base" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 2,
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1gbL9.LocationTextField), {
                        isReference: true,
                        unassignedText: type === "base" ? "Unassigned" : "N/A",
                        selectedLocationId: assignedLocation?.location_id,
                        onChange: (newLocationId)=>{
                            const newLocation = locations.find((l)=>l.location_id === newLocationId);
                            setAssignedLocation(newLocation);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1gbL9.LocationTextField), {
                        isReference: false,
                        selectedLocationId: currentLocation?.location_id,
                        unassignedText: "Not Hangared",
                        onChange: (newLocationId)=>{
                            const newLocation = locations.find((l)=>l.location_id === newLocationId);
                            setCurrentLocation(newLocation);
                        }
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("jxJ0r", function(module, exports) {

$parcel$export(module.exports, "TenantSelector", () => $c5c9e60a933e1bf8$export$db5d8fbac40d6cf7);

var $ayMG0 = parcelRequire("ayMG0");

var $2P5BT = parcelRequire("2P5BT");

var $6lXkL = parcelRequire("6lXkL");
var $hViLc = parcelRequire("hViLc");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
var $18tt9 = parcelRequire("18tt9");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $6rxM8 = parcelRequire("6rxM8");

var $6fDLr = parcelRequire("6fDLr");

var $9OZOC = parcelRequire("9OZOC");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $7R9OT = parcelRequire("7R9OT");

var $5kwJN = parcelRequire("5kwJN");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");

var $5U03M = parcelRequire("5U03M");

var $iEhC9 = parcelRequire("iEhC9");

var $4jd4A = parcelRequire("4jd4A");

var $8ORjT = parcelRequire("8ORjT");
const $c5c9e60a933e1bf8$export$db5d8fbac40d6cf7 = ({ location: location, stack: stack, setStack: setStack, tenantType: tenantType, filterBy: filterBy = ()=>true, isReference: isReference, checkAircraftHeight: checkAircraftHeight, feetToPixels: feetToPixels })=>{
    const theme = (0, $14H9o.default)();
    const isTablet = (0, $18tt9.default)(theme.breakpoints.down("lg"));
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { initialPositionOffset: initialPositionOffset } = (0, $iEhC9.useLayoutCanvasState)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [filter, setFilter] = $acw62.useState("");
    const { sendToLocation: sendToLocation, findTenantLocation: findTenantLocation } = (0, $6rxM8.useLocationsState)();
    const { tenants: tenants } = (0, $9OZOC.useTenants)();
    const tenantsToDisplay = $acw62.useMemo(()=>tenants.filter(filterBy).filter((t)=>{
            if (!Boolean(filter)) return true;
            const currentHangarName = findTenantLocation(false, t)?.name;
            const assignedHangarName = findTenantLocation(true, t)?.name;
            const queryString = `${t.tail_number} - ${t.aircraft.make} - ${t.aircraft.model} - ${currentHangarName} - ${assignedHangarName}`.toLocaleLowerCase();
            return queryString.indexOf(filter.toLocaleLowerCase()) > -1;
        }).sort((a, b)=>{
            const aAssignedHangarName = findTenantLocation(false, a)?.name;
            const bAssignedHangarName = findTenantLocation(false, b)?.name;
            if (aAssignedHangarName === bAssignedHangarName) return a.tail_number.localeCompare(b.tail_number);
            if (aAssignedHangarName === location.location_id) return -1;
            if (bAssignedHangarName === location.location_id) return 1;
            return a.tail_number.localeCompare(b.tail_number);
        }), [
        tenants,
        filter,
        filterBy
    ]);
    const additionalColumns = [];
    if (tenantType === (0, $keHtM.TenantType).TRANSIENT) additionalColumns.push({
        field: "last_hangared",
        headerName: "Last Hangared",
        width: 175,
        editable: false,
        renderCell: (params)=>(0, $5kwJN.lastHangaredText)(params.value, Boolean(findTenantLocation(false, params.row)))
    });
    additionalColumns.push({
        field: "action",
        headerName: "",
        sortable: false,
        width: 150,
        renderCell: (params)=>{
            const [tenantToAdd, setTenantToAdd] = $acw62.useState();
            const [confirmAddText, setConfirmAddText] = $acw62.useState();
            // Check if aircraft is in a different location (only for holding area in multi-hangar view)
            // Reuses pattern from AddSelectedTenant.tsx
            const currentLocation = findTenantLocation(false, params.row);
            const isInDifferentLocation = currentLocation && currentLocation.id !== location.id;
            const isHoldingArea = location.id === (0, $5U03M.HOLDING_AREA_ID);
            if (isHoldingArea && isInDifferentLocation) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "caption",
                children: [
                    "In ",
                    currentLocation.name
                ]
            });
            if (stack?.tenants?.find((t)=>t.id === params.row.id)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                size: "small",
                variant: "contained",
                color: "error",
                onClick: async ()=>{
                    await sendToLocation(null, isReference ? "reference" : "current", params.row);
                    setStack({
                        ...stack,
                        tenants: stack.tenants.filter((t)=>t.id !== params.row.id)
                    });
                },
                children: "Remove Aircraft"
            });
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "contained",
                        color: "inherit",
                        onClick: async ()=>{
                            /**
           * this gets called from:
           *  - Base Tenant 'Add Aircraft' button => make sure selectedTenant is in the hangar. make sure tenant has a position
           * in the base hangar (and current hangar?)
           *  - Current Hangar 'Add Aircraft' button => make sure selectedTenant is in the hangar. add a position for the
           * current hangar. if adding as base, make position for base also.
           *  - Tenants/Transients 'Add Aircraft' button'
           *
           **/ const selectedTenant = {
                                ...params.row
                            };
                            const tenant = {
                                ...selectedTenant,
                                placement_id: (0, $lNEp2.uuidv4)(),
                                aircraft: params.row.aircraft,
                                selected: false,
                                type: isReference ? (0, $keHtM.TenantType).BASE : tenantType,
                                position: {
                                    id: (0, $lNEp2.consistentId)(selectedTenant.entity_id, stack.isReference),
                                    stack_id: stack.id,
                                    entity_id: selectedTenant.entity_id,
                                    x: null,
                                    y: null,
                                    ...(0, $8ORjT.calculateInitialPosition)(location, params.row.aircraft, feetToPixels, initialPositionOffset.xFeet, initialPositionOffset.yFeet),
                                    angle: null,
                                    preferences: (0, $lNEp2.defaultPreferenceForAircraft)(params.row.aircraft, activeFBO)
                                }
                            };
                            if (isReference && tenantType === (0, $keHtM.TenantType).TRANSIENT) {
                                setTenantToAdd(tenant);
                                setConfirmAddText((0, $5kwJN.addTenantConformationText)(location.type === "hangar" ? "hangar" : "ramp"));
                                return;
                            }
                            (0, $7R9OT.default).track("Add Aircraft", {
                                aircraft_tenant_type: tenant.type,
                                aircraft_type: tenant.aircraft.model,
                                aircraft_tail_number: tenant.tail_number
                            });
                            await sendToLocation(location, isReference ? "reference" : "current", tenant);
                            setStack({
                                ...stack,
                                tenants: [
                                    tenant,
                                    ...stack.tenants
                                ]
                            });
                            snackbar.notify({
                                text: `${tenant.aircraft.model} added to ${location.name}`,
                                severity: "success"
                            });
                            checkAircraftHeight(params.row.aircraft);
                        },
                        children: "Add Aircraft"
                    }),
                    Boolean(confirmAddText) && Boolean(tenantToAdd) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                        title: "Please Confirm",
                        text: confirmAddText,
                        onCancel: ()=>{
                            setConfirmAddText(null);
                        },
                        onOk: ()=>{
                            setStack({
                                ...stack,
                                tenants: [
                                    tenantToAdd,
                                    ...stack.tenants
                                ]
                            });
                            checkAircraftHeight(params.row.aircraft);
                            setTenantToAdd(null);
                        },
                        onClose: ()=>{
                            setConfirmAddText(null);
                        }
                    })
                ]
            });
        }
    });
    const hideTheseColumns = [
        "owner_manager",
        "make"
    ];
    if (tenantType === (0, $keHtM.TenantType).TRANSIENT) {
        hideTheseColumns.push("type");
        hideTheseColumns.push("assigned_location");
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: isTablet ? 0.75 : 1,
        sx: {
            height: "100%",
            minHeight: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                size: "small",
                fullWidth: true,
                placeholder: "Search by tenant name or Tail #",
                inputProps: {
                    ["data-testid"]: "tenant-filter"
                },
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                        position: "start",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                    })
                },
                onChange: (evt)=>setFilter(evt.target.value)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4jd4A.TenantGrid), {
                tenants: tenantsToDisplay,
                additionalColumns: additionalColumns,
                hideTheseColumns: hideTheseColumns
            })
        ]
    });
};

});
parcelRegister("4jd4A", function(module, exports) {

$parcel$export(module.exports, "TenantGrid", () => $5ed641ccd0bf99ff$export$9250e3bca264095);

var $ayMG0 = parcelRequire("ayMG0");

var $1J2kR = parcelRequire("1J2kR");
parcelRequire("acw62");

var $6rxM8 = parcelRequire("6rxM8");
parcelRequire("briyn");
var $1gbL9 = parcelRequire("1gbL9");
const $5ed641ccd0bf99ff$export$9250e3bca264095 = ({ tenants: tenants, additionalColumns: additionalColumns, hideTheseColumns: hideTheseColumns = [] })=>{
    const { findTenantLocation: findTenantLocation } = (0, $6rxM8.useLocationsState)();
    const columns = [
        {
            field: "tail_number",
            headerName: "Tail #",
            width: 94,
            editable: false
        },
        {
            field: "owner_manager",
            headerName: "Owner/Manager",
            width: 167,
            editable: false
        },
        {
            field: "model",
            headerName: "Model",
            width: 175,
            editable: false,
            valueGetter: (_, row)=>row.aircraft.model
        },
        {
            field: "current_location",
            headerName: "Current Location",
            editable: false,
            width: 175,
            valueGetter: (_, row)=>findTenantLocation(false, row)?.name,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1gbL9.LocationTextField), {
                    selectedLocationId: findTenantLocation(false, params.row)?.location_id,
                    readOnly: true,
                    unassignedText: "Not Hangared",
                    link: true
                })
        },
        {
            field: "assigned_location",
            headerName: "Assigned Location",
            editable: false,
            width: 175,
            valueGetter: (_, row)=>findTenantLocation(true, row)?.name,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1gbL9.LocationTextField), {
                    selectedLocationId: findTenantLocation(true, params.row)?.location_id,
                    isReference: true,
                    readOnly: true,
                    link: true
                })
        },
        {
            field: "type",
            headerName: "Type",
            editable: false,
            valueGetter: (_, row)=>{
                if (row.type === "transient") return row.type;
                return findTenantLocation(true, row)?.type === "ramp" ? "tie-down" : "base";
            }
        },
        ...additionalColumns
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
        rows: tenants,
        columns: columns.filter((column)=>hideTheseColumns.indexOf(column.field) === -1),
        pageSizeOptions: [
            100
        ],
        getRowId: (row)=>row.entity_id,
        disableRowSelectionOnClick: true
    });
};

});



parcelRegister("cOIY7", function(module, exports) {

$parcel$export(module.exports, "HoldingAreaListItem", () => $ba7f3ede3f15fa74$export$3b8d4795de20d2e1);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $d8apZ = parcelRequire("d8apZ");

var $acw62 = parcelRequire("acw62");

var $f4Dj1 = parcelRequire("f4Dj1");
const $ba7f3ede3f15fa74$export$3b8d4795de20d2e1 = ({ tenant: tenant, onAssign: onAssign, onEdit: onEdit, onRemove: onRemove, disabled: disabled = false })=>{
    const [imageError, setImageError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [noteViewed, setNoteViewed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleRemoveClick = ()=>{
        setConfirmDialogOpen(true);
    };
    const handleConfirmRemove = ()=>{
        setConfirmDialogOpen(false);
        onRemove(tenant.id);
    };
    const handleCancelRemove = ()=>{
        setConfirmDialogOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            position: "relative"
        },
        children: [
            tenant.note && !noteViewed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    top: -6,
                    left: -6,
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: "#b89230",
                    border: "2px solid white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    zIndex: 10
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    p: 2,
                    borderRadius: 1,
                    border: "1px solid",
                    borderColor: "divider",
                    backgroundColor: "background.paper",
                    "&:hover": {
                        backgroundColor: "action.hover"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            width: 56,
                            height: 56,
                            borderRadius: 1,
                            backgroundColor: "grey.200",
                            flexShrink: 0,
                            mr: 2.5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: tenant.aircraft?.image && !imageError ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: tenant.aircraft.image,
                            alt: tenant.tail_number,
                            onError: ()=>setImageError(true),
                            style: {
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: 8
                            }
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            children: "N/A"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        flex: 1,
                        spacing: 0.5,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle2",
                                        fontWeight: "bold",
                                        sx: {
                                            fontSize: "0.95rem",
                                            lineHeight: 1.2
                                        },
                                        children: tenant.tail_number
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                        label: tenant.type === "transient" ? "Transient" : "Base",
                                        size: "small",
                                        color: tenant.type === "transient" ? "primary" : "secondary",
                                        variant: "outlined",
                                        sx: {
                                            fontSize: "0.65rem",
                                            fontWeight: 500,
                                            height: 20
                                        }
                                    }),
                                    tenant.note && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: tenant.note,
                                        arrow: true,
                                        placement: "top",
                                        onOpen: ()=>setNoteViewed(true),
                                        componentsProps: {
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#f2f2f2',
                                                    color: '#000000',
                                                    fontSize: '12px',
                                                    borderRadius: '5px',
                                                    padding: '8px 12px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                    maxWidth: 250,
                                                    '&::before': {
                                                        backgroundColor: '#b89230',
                                                        content: '""',
                                                        display: 'block',
                                                        height: '4px',
                                                        margin: '-8px -12px 6px -12px',
                                                        borderTopLeftRadius: '5px',
                                                        borderTopRightRadius: '5px'
                                                    }
                                                }
                                            },
                                            arrow: {
                                                sx: {
                                                    color: '#f2f2f2'
                                                }
                                            }
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8apZ))), {
                                            sx: {
                                                fontSize: 16,
                                                color: 'warning.main',
                                                cursor: 'help'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "text.secondary",
                                sx: {
                                    fontSize: "0.8rem",
                                    lineHeight: 1.2
                                },
                                children: tenant.aircraft?.model || "Unknown Model"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 0.5,
                        sx: {
                            minWidth: 70
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                size: "small",
                                onClick: ()=>onAssign(tenant.id),
                                disabled: disabled,
                                sx: {
                                    py: 0.25,
                                    fontSize: "0.7rem",
                                    minHeight: 24
                                },
                                children: "Assign"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "outlined",
                                size: "small",
                                onClick: ()=>onEdit(tenant),
                                disabled: disabled,
                                sx: {
                                    py: 0.25,
                                    fontSize: "0.7rem",
                                    minHeight: 24
                                },
                                children: "Edit"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "outlined",
                                size: "small",
                                color: "error",
                                onClick: handleRemoveClick,
                                disabled: disabled,
                                sx: {
                                    py: 0.25,
                                    fontSize: "0.7rem",
                                    minHeight: 24
                                },
                                children: "Remove"
                            })
                        ]
                    })
                ]
            }),
            confirmDialogOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Remove Aircraft from Holding Area?",
                text: `Are you sure you want to remove ${tenant.tail_number || tenant.aircraft?.model || "this aircraft"} from the holding area?`,
                okText: "Remove",
                cancelText: "Cancel",
                okButtonColor: "error",
                onOk: handleConfirmRemove,
                onCancel: handleCancelRemove,
                onClose: handleCancelRemove
            })
        ]
    });
};

});


parcelRegister("7UdqG", function(module, exports) {

$parcel$export(module.exports, "HoldingAreaPresenter", () => $3a55b9b3dfd75703$export$9551011d0e82ce9c);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $4yCYl = parcelRequire("4yCYl");

var $ZD2ym = parcelRequire("ZD2ym");

var $6rxM8 = parcelRequire("6rxM8");

var $7p8YN = parcelRequire("7p8YN");

var $6AlVH = parcelRequire("6AlVH");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");

var $32ESd = parcelRequire("32ESd");

var $8ORjT = parcelRequire("8ORjT");

var $5U03M = parcelRequire("5U03M");
const $3a55b9b3dfd75703$export$9551011d0e82ce9c = ({ active: active, feetToPixels: feetToPixels, multiHangarDepth: multiHangarDepth, customPlacementOptions: customPlacementOptions })=>{
    const theme = (0, $14H9o.default)();
    const { sendToLocation: sendToLocation } = (0, $6rxM8.useLocationsState)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { hangars: hangars, setHangars: setHangars } = (0, $7p8YN.useMultiHangarState)();
    const { towingEquipments: allTowingEquipments } = (0, $6AlVH.useTowingEquipmentState)();
    const defaultTowingEquipmentId = allTowingEquipments.find((t)=>t.in_use && t.is_default)?.towing_equipment_id;
    const refAddAircraft = $acw62.useRef(null);
    const { getHangar: getHangar, setHangar: setHangar } = (0, $7p8YN.useMultiHangarState)();
    const hangar = getHangar((0, $5U03M.HOLDING_AREA_ID));
    // we hardcode to 250 b/c it doesn't really matter. arbitrary but works in most situations.
    const width = 250 / feetToPixels;
    // this is the same as 100% of the total height of the multi-layout container. we then need to offset
    // by the height of the 'Add Aircraft' button
    const buttonHeightOffsetPixels = refAddAircraft?.current?.clientHeight + parseFloat(theme.spacing(3)) || 0;
    // bottom of the bottom hangar has theme(2) of padding
    const bottomMarginOffset = parseFloat(theme.spacing(2));
    const depth = (multiHangarDepth - buttonHeightOffsetPixels - bottomMarginOffset) / feetToPixels;
    const previousDepth = (0, $4yCYl.default)(depth);
    const syntheticLocation = {
        type: "hangar",
        ...hangar,
        width: width,
        depth: depth
    };
    const setStack = $acw62.useCallback((stack)=>{
        setHangar({
            ...hangar,
            stack: {
                ...hangar.stack,
                ...stack
            }
        });
    }, [
        hangar,
        setHangar
    ]);
    const onAddAircraft = $acw62.useCallback((tenant)=>{
        if (Array.isArray(tenant)) {
            setStack({
                ...hangar?.stack,
                tenants: [
                    ...tenant.map((t)=>({
                            ...t,
                            position: {
                                ...t.position,
                                x: null,
                                y: null,
                                angle: null
                            }
                        })),
                    ...hangar?.stack?.tenants
                ]
            });
            return;
        }
        const tenantWithPosition = {
            ...tenant,
            position: {
                ...tenant.position,
                x: null,
                y: null,
                angle: null
            }
        };
        setStack({
            ...hangar?.stack,
            tenants: [
                tenantWithPosition,
                ...hangar?.stack?.tenants
            ]
        });
    }, [
        hangar?.stack,
        setStack
    ]);
    const autocomplete = (0, $32ESd.useHangarAutocomplete)({
        hangar: hangar,
        defaultTowingEquipmentId: defaultTowingEquipmentId,
        width: width,
        customPlacementOptions: customPlacementOptions
    }, [
        hangar,
        customPlacementOptions,
        defaultTowingEquipmentId
    ]);
    // watch for when the dimensions of the holding area change and then update the locations
    // of the aircraft so they remain in the same location
    $acw62.useEffect(()=>{
        const depthAdjustment = depth - previousDepth;
        setStack({
            ...hangar.stack,
            tenants: hangar.stack.tenants.map((t)=>({
                    ...t,
                    position: {
                        ...t.position,
                        y: t.position.y + depthAdjustment
                    }
                })),
            movableObstacles: hangar.stack.movableObstacles.map((o)=>({
                    ...o,
                    position: {
                        ...o.position,
                        y: o.position.y + depthAdjustment
                    }
                }))
        });
    }, [
        depth
    ]);
    if (!hangar || !hangar?.stack) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        alignItems: "center",
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                ref: refAddAircraft,
                sx: {
                    p: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    alignItems: "center",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: "Holding Area"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ORjT.AddTenantButton), {
                            sendToLocation: sendToLocation,
                            location: {
                                type: "hangar",
                                ...hangar
                            },
                            stack: hangar?.stack,
                            setStack: (stack)=>{
                                setHangar({
                                    ...hangar,
                                    stack: {
                                        ...hangar.stack,
                                        ...stack
                                    }
                                });
                            },
                            onAdd: onAddAircraft
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                onMouseDown: ()=>{
                    setHangars(hangars.map((h)=>({
                            ...h,
                            stack: {
                                ...h.stack,
                                tenants: h.stack.tenants.map((t)=>({
                                        ...t,
                                        selected: h.id !== (0, $5U03M.HOLDING_AREA_ID) ? false : t.selected
                                    })),
                                movableObstacles: h.stack.movableObstacles.map((mo)=>({
                                        ...mo,
                                        selected: h.id !== (0, $5U03M.HOLDING_AREA_ID) ? false : mo.selected
                                    }))
                            }
                        })));
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                    width: 250,
                    location: syntheticLocation,
                    stack: hangar?.stack,
                    setStack: setStack,
                    autocomplete: autocomplete,
                    options: {
                        hideUnplaced: false,
                        readOnly: false,
                        frozen: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                        printable: false,
                        selectable: false,
                        disableDragProtection: true,
                        backgroundColor: active ? "#d3d3d3" : "#b3b3b3",
                        borderColor: active ? "black" : null,
                        dashColor: "black",
                        disableGrabScroll: true
                    }
                })
            })
        ]
    });
};

});
parcelRegister("32ESd", function(module, exports) {

$parcel$export(module.exports, "useHangarAutocomplete", () => $f92c1b8f1bbe53d7$export$759c3049cab00b1);

var $acw62 = parcelRequire("acw62");

var $g7var = parcelRequire("g7var");

var $eYWyk = parcelRequire("eYWyk");

var $5KGQl = parcelRequire("5KGQl");

var $5U03M = parcelRequire("5U03M");
parcelRequire("9vNAe");
var $dfdxy = parcelRequire("dfdxy");

var $8G8wE = parcelRequire("8G8wE");

var $gqehT = parcelRequire("gqehT");

var $7p8YN = parcelRequire("7p8YN");

var $keHtM = parcelRequire("keHtM");
const $f92c1b8f1bbe53d7$var$convertOrientation = (orientation)=>{
    switch(orientation){
        case (0, $keHtM.Preference).TAIL_WHEEL_NOSE_IN:
            return (0, $keHtM.Preference).NOSE_IN;
        case (0, $keHtM.Preference).TAIL_WHEEL_TAIL_IN:
            return (0, $keHtM.Preference).TAIL_IN;
        default:
            return orientation;
    }
};
const $f92c1b8f1bbe53d7$export$759c3049cab00b1 = (props, deps = [])=>{
    const { isMultiHangar: isMultiHangar, hangars: allHangars } = (0, $7p8YN.useMultiHangarState)();
    const hangars = allHangars.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID));
    const { airplxToken: airplxToken } = (0, $gqehT.useIdentity)();
    const { hangar: hangar, width: width, defaultTowingEquipmentId: defaultTowingEquipmentId, customPlacementOptions: customPlacementOptions } = props;
    const runAutocompleteForHangar = $acw62.useCallback(async (hangar, tenant)=>{
        const polygons = (0, $5KGQl.getStackPolygons)(hangar.stack, width, 1, isMultiHangar, hangar.id === (0, $5U03M.HOLDING_AREA_ID));
        console.log(`running autocomplete on ${tenant.aircraft.id}`);
        const orientation = (0, $g7var.getOrientation)(tenant);
        const options = isMultiHangar ? {
            ...customPlacementOptions,
            ...hangar.stack.options,
            towing_equipment_id: defaultTowingEquipmentId,
            sample_size: 1000
        } : {
            ...hangar.stack.options,
            ...customPlacementOptions,
            towing_equipment_id: defaultTowingEquipmentId,
            sample_size: 1000
        };
        const baseParamSetForAutocomplete = {
            run_id: null,
            label: "autocomplete",
            // slim down the hangar for the API call
            hangar: {
                id: hangar.id,
                width: hangar.width,
                depth: hangar.depth,
                left_door: hangar.left_door,
                right_door: hangar.right_door,
                garage_doors: hangar.garageDoors ?? [],
                bays: hangar.bays ?? []
            },
            // slim down the tenant so it's just what we need to do the placement
            aircrafts_to_place: [
                {
                    id: tenant.aircraft.id,
                    placement_id: tenant.placement_id,
                    angles_to_try: [],
                    sectors_to_try: [],
                    preferences: [
                        $f92c1b8f1bbe53d7$var$convertOrientation(orientation)
                    ]
                }
            ],
            locked_aircrafts: hangar.stack.tenants.filter((t)=>t.id != tenant.id).filter((t)=>{
                const { polygon: polygon } = polygons.find((p)=>p.entity_id === t.entity_id);
                const layoutPolygon = [
                    [
                        0,
                        0
                    ],
                    [
                        hangar.width,
                        0
                    ],
                    [
                        hangar.width,
                        hangar.depth
                    ],
                    [
                        0,
                        hangar.depth
                    ],
                    [
                        0,
                        0
                    ]
                ];
                // Convert GeoJSON.Polygon to geometric.Polygon by extracting coordinates
                const geometricPolygon = polygon.coordinates[0];
                return (0, $dfdxy.polygonInPolygon)(geometricPolygon, layoutPolygon);
            }).map((tenant)=>({
                    id: tenant.aircraft.id,
                    placement_id: tenant.placement_id,
                    x: tenant.position.x,
                    y: tenant.position.y,
                    angle: tenant.position.angle
                })),
            obstacles: (0, $g7var.formatObstacles)(hangar),
            options: options
        };
        const aircrafts = hangar.stack.tenants.map((t)=>t.aircraft);
        const isTenantInHangar = hangar.stack.tenants.find((t)=>t.id === tenant.id);
        if (!isTenantInHangar) aircrafts.push(tenant.aircraft);
        const paramSetsForAutocomplete = (0, $eYWyk.generateAutocompleteParamSets)(baseParamSetForAutocomplete, aircrafts);
        console.log(`[paramSetsForAutocomplete][${paramSetsForAutocomplete.length}]`, paramSetsForAutocomplete);
        const hangarForAutocomplete = {
            ...hangar,
            stack: {
                ...hangar.stack,
                tenants: isTenantInHangar ? hangar.stack.tenants : [
                    ...hangar.stack.tenants,
                    tenant
                ]
            }
        };
        return await (0, $8G8wE.runAutocomplete)(hangarForAutocomplete, paramSetsForAutocomplete, airplxToken);
    }, deps);
    return $acw62.useCallback(async (tenant)=>{
        if (isMultiHangar) {
            const doit = await Promise.all(hangars.map((hangar)=>runAutocompleteForHangar(hangar, tenant)));
            return doit.flat();
        }
        return runAutocompleteForHangar(hangar, tenant);
    }, [
        deps
    ]);
};

});
parcelRegister("eYWyk", function(module, exports) {

$parcel$export(module.exports, "generateDevParamSets", () => $935b6e5ffeb2b47a$export$1319dec062b23539);
$parcel$export(module.exports, "generateAutocompleteParamSets", () => $935b6e5ffeb2b47a$export$694f03378fb53893);
$parcel$export(module.exports, "StackStrategy", () => $935b6e5ffeb2b47a$export$b817980e9115ae3c);
$parcel$export(module.exports, "makeParamSetForType", () => $935b6e5ffeb2b47a$export$7db1b6df574af2b9);
parcelRequire("9vNAe");
var $dfdxy = parcelRequire("dfdxy");
var $d2xzW = parcelRequire("d2xzW");

var $lLxKB = parcelRequire("lLxKB");

var $5sKyw = parcelRequire("5sKyw");

var $5KGQl = parcelRequire("5KGQl");

var $keHtM = parcelRequire("keHtM");

var $cLNZr = parcelRequire("cLNZr");
const $935b6e5ffeb2b47a$export$e7fd70891e3f79cf = (aircrafts_to_place, aircrafts)=>{
    return [
        ...aircrafts_to_place
    ].sort((a, b)=>{
        if (a.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return 1;
        if (b.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return -1;
        if (a.preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1 || a.preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1) return -1;
        if (b.preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1 || b.preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1) return 1;
        if (b.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return -1;
        if (a.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return 1;
        const aircraftA = aircrafts.find(({ id: id })=>id === a.id);
        const aircraftB = aircrafts.find(({ id: id })=>id === b.id);
        return aircraftB.wingspan * aircraftB.length - aircraftA.wingspan * aircraftA.length;
    });
};
const $935b6e5ffeb2b47a$var$sortDoubleSwap = (aircrafts_to_place, aircrafts)=>{
    const aircraftOrderedBiggestToSmallest = $935b6e5ffeb2b47a$export$e7fd70891e3f79cf(aircrafts_to_place, aircrafts);
    const aircraftOrdereDoubleSwap = [];
    for(let i = 0; i < aircraftOrderedBiggestToSmallest.length; i += 2){
        if (aircraftOrderedBiggestToSmallest[i + 1]) aircraftOrdereDoubleSwap.push(aircraftOrderedBiggestToSmallest[i + 1]);
        aircraftOrdereDoubleSwap.push(aircraftOrderedBiggestToSmallest[i]);
    }
    return aircraftOrdereDoubleSwap;
};
const $935b6e5ffeb2b47a$var$sortTripleSwap = (aircrafts_to_place, aircrafts)=>{
    const aircraftOrderedBiggestToSmallest = $935b6e5ffeb2b47a$export$e7fd70891e3f79cf(aircrafts_to_place, aircrafts);
    const aircraftOrdereTripleSwap = [];
    for(let i = 0; i < aircraftOrderedBiggestToSmallest.length; i += 3){
        if (aircraftOrderedBiggestToSmallest[i + 2]) aircraftOrdereTripleSwap.push(aircraftOrderedBiggestToSmallest[i + 2]);
        if (aircraftOrderedBiggestToSmallest[i + 1]) aircraftOrdereTripleSwap.push(aircraftOrderedBiggestToSmallest[i + 1]);
        aircraftOrdereTripleSwap.push(aircraftOrderedBiggestToSmallest[i]);
    }
    return aircraftOrdereTripleSwap;
};
const $935b6e5ffeb2b47a$export$e2aa793f036c8ae6 = (params, utilization, aircrafts)=>{
    let paramSets = [];
    if (utilization < 0.8) paramSets = $935b6e5ffeb2b47a$export$7fdf6b5703cbb386(params, aircrafts);
    else if (params.options.overlap === true) paramSets = $935b6e5ffeb2b47a$export$8ad0a960b29b0069(params, aircrafts);
    else paramSets = $935b6e5ffeb2b47a$export$6ed08c1567af60f9(params, aircrafts);
    // for certain edge cases, it's possible to have duplicates
    return (0, $cLNZr.uniqBy)(paramSets, (paramSet)=>(0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify(paramSet)));
};
const $935b6e5ffeb2b47a$export$1319dec062b23539 = (params, aircrafts, customPlacementOptions)=>{
    const paramSets = [];
    const xyWeightsToTry = [
        customPlacementOptions?.xy_weights ?? [
            1,
            2
        ],
        [
            1.5,
            1
        ]
    ];
    const cornerStrategiesToTry = customPlacementOptions?.corner_strategies ?? (0, $keHtM.CornerStrategies);
    for (const xy_weights of xyWeightsToTry)for (const corner_strategy of cornerStrategiesToTry){
        paramSets.push({
            run_id: (0, $5sKyw.default)(),
            ...params,
            options: {
                ...params.options,
                corner_strategy: corner_strategy,
                xy_weights: xy_weights
            },
            label: `Biggest to Smallest, [${xy_weights}] [${corner_strategy.join(",")}], Spacing: ${params.options.horizontal_spacing} ft`,
            aircrafts_to_place: $935b6e5ffeb2b47a$export$e7fd70891e3f79cf(params.aircrafts_to_place, aircrafts)
        });
        paramSets.push({
            run_id: (0, $5sKyw.default)(),
            ...params,
            options: {
                ...params.options,
                corner_strategy: corner_strategy,
                xy_weights: xy_weights
            },
            label: `Double Swap, [${xy_weights}] [${corner_strategy.join(",")}], Spacing: ${params.options.horizontal_spacing} ft`,
            aircrafts_to_place: $935b6e5ffeb2b47a$var$sortDoubleSwap(params.aircrafts_to_place, aircrafts)
        });
        paramSets.push({
            run_id: (0, $5sKyw.default)(),
            ...params,
            options: {
                ...params.options,
                corner_strategy: corner_strategy,
                xy_weights: xy_weights
            },
            label: `Triple Swap, [${xy_weights}] [${corner_strategy.join(",")}], Spacing: ${params.options.horizontal_spacing} ft`,
            aircrafts_to_place: $935b6e5ffeb2b47a$var$sortTripleSwap(params.aircrafts_to_place, aircrafts)
        });
    }
    return paramSets;
};
const $935b6e5ffeb2b47a$export$52ec49048724fdf1 = (params, aircrafts)=>{
    const polygons = (0, $5KGQl.getStackPolygons)({
        id: null,
        isReference: null,
        movableObstacles: [],
        options: params.options,
        tenants: params.locked_aircrafts.map((aircraft)=>({
                id: (0, $5sKyw.default)(),
                entity_id: (0, $5sKyw.default)(),
                aircraft_id: aircraft.id,
                fbo_id: null,
                is_reference: null,
                owner_manager: null,
                placement_id: null,
                selected: null,
                tail_number: null,
                type: null,
                aircraft: aircrafts.find((a)=>a.id === aircraft.id),
                position: {
                    // doesn't matter as these are throwaway
                    id: (0, $5sKyw.default)(),
                    stack_id: (0, $5sKyw.default)(),
                    entity_id: (0, $5sKyw.default)(),
                    x: aircraft.x,
                    y: aircraft.y,
                    angle: aircraft.angle,
                    is_reference: false,
                    preferences: []
                }
            }))
    }, params.hangar.width, 1);
    const aircraftBeingPlaced = aircrafts.find((a)=>a.id === params.aircrafts_to_place[0].id);
    const span = Math.max(aircraftBeingPlaced.wingspan, aircraftBeingPlaced.length);
    let leftCornerOpen = true;
    let rightCornerOpen = true;
    for (const polygon of polygons){
        const leftCorner = [
            [
                0,
                params.hangar.depth
            ],
            [
                span,
                params.hangar.depth
            ],
            [
                span,
                params.hangar.depth - span
            ],
            [
                0,
                params.hangar.depth - span
            ]
        ];
        const rightCorner = [
            [
                params.hangar.width,
                params.hangar.depth
            ],
            [
                params.hangar.width - span,
                params.hangar.depth
            ],
            [
                params.hangar.width - span,
                params.hangar.depth - span
            ],
            [
                params.hangar.width,
                params.hangar.depth - span
            ]
        ];
        const polygonCoords = polygon.polygon.coordinates[0].map(([x, y])=>[
                x,
                y
            ]);
        if ((0, $dfdxy.polygonInPolygon)(leftCorner, polygonCoords) || (0, $dfdxy.polygonInPolygon)(polygonCoords, leftCorner) || (0, $d2xzW.polygonIntersectsPolygon)(leftCorner, polygonCoords)) leftCornerOpen = false;
        if ((0, $dfdxy.polygonInPolygon)(rightCorner, polygonCoords) || (0, $dfdxy.polygonInPolygon)(polygonCoords, rightCorner) || (0, $d2xzW.polygonIntersectsPolygon)(rightCorner, polygonCoords)) rightCornerOpen = false;
    }
    return leftCornerOpen || rightCornerOpen;
};
const $935b6e5ffeb2b47a$export$694f03378fb53893 = (params, aircrafts)=>{
    const paramSets = [];
    if ($935b6e5ffeb2b47a$export$52ec49048724fdf1(params, aircrafts)) {
        const xy_weights = [
            1,
            2
        ];
        for (const corner_strategy of [
            [
                (0, $keHtM.CornerStrategy).ANGLE_SHALLOW,
                (0, $keHtM.CornerStrategy).ANGLE_SHALLOW
            ]
        ]){
            const prefsToTry = [
                [
                    (0, $keHtM.Preference).PREFER_LEFT
                ],
                [
                    (0, $keHtM.Preference).PREFER_RIGHT
                ]
            ];
            for (const prefToTry of prefsToTry)paramSets.push({
                run_id: (0, $5sKyw.default)(),
                ...params,
                options: {
                    ...params.options,
                    corner_strategy: corner_strategy,
                    xy_weights: xy_weights
                },
                label: `Autocomplete, [${xy_weights}] [${corner_strategy}], Spacing: ${params.options.horizontal_spacing} ft`,
                aircrafts_to_place: [
                    {
                        ...params.aircrafts_to_place[0],
                        preferences: [
                            ...params.aircrafts_to_place[0].preferences,
                            ...prefToTry
                        ]
                    }
                ]
            });
        }
        return paramSets;
    }
    const prefsToTry = [
        // [Preference.PREFER_LEFT, Preference.PREFER_BACK],
        // [Preference.PREFER_LEFT, Preference.PREFER_FRONT],
        // [Preference.PREFER_RIGHT, Preference.PREFER_BACK],
        // [Preference.PREFER_RIGHT, Preference.PREFER_FRONT],
        [
            (0, $keHtM.Preference).PREFER_LEFT_THIRD
        ],
        [
            (0, $keHtM.Preference).PREFER_MIDDLE_THIRD
        ],
        [
            (0, $keHtM.Preference).PREFER_RIGHT_THIRD
        ]
    ];
    for (const prefToTry of prefsToTry)for (const xy_weights of [
        [
            1,
            2
        ]
    ])paramSets.push({
        run_id: (0, $5sKyw.default)(),
        ...params,
        options: {
            ...params.options,
            corner_strategy: (0, $keHtM.CornerStrategies)[0],
            xy_weights: xy_weights
        },
        label: `Autocomplete, [${xy_weights}] [${prefToTry}] [${(0, $keHtM.CornerStrategies)[0]}], Spacing: ${params.options.horizontal_spacing} ft`,
        aircrafts_to_place: [
            {
                ...params.aircrafts_to_place[0],
                preferences: [
                    ...params.aircrafts_to_place[0].preferences,
                    ...prefToTry
                ]
            }
        ]
    });
    return paramSets;
};
const $935b6e5ffeb2b47a$export$a360cdb8e7f665dd = (params, aircrafts, customPlacementOptions)=>{
    const paramSets = [];
    for (const corner_strategy of customPlacementOptions.corner_strategies)paramSets.push({
        run_id: (0, $5sKyw.default)(),
        ...params,
        options: {
            ...params.options,
            corner_strategy: corner_strategy
        },
        label: `TreeStack [${corner_strategy.join(",")}], Spacing: ${params.options.horizontal_spacing} ft`,
        aircrafts_to_place: $935b6e5ffeb2b47a$export$e7fd70891e3f79cf(params.aircrafts_to_place, aircrafts)
    });
    return paramSets;
};
const $935b6e5ffeb2b47a$export$6ed08c1567af60f9 = (params, aircrafts)=>{
    const error_types = [
        "error_hybrid_magnetic_lines_50_typewriter_50",
        "error_hybrid_magnetic_lines_25_typewriter_75",
        "error_hybrid_magnetic_lines_10_typewriter_90",
        "error_hybrid_magnetic_lines_50_reverse_typewriter_50",
        "error_hybrid_magnetic_lines_25_reverse_typewriter_75",
        "error_hybrid_magnetic_lines_10_reverse_typewriter_90"
    ];
    const aircraftOrderedBiggestToSmallest = [
        ...params.aircrafts_to_place
    ].sort((a, b)=>{
        if (a.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return 1;
        if (b.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return -1;
        if (a.preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1 || a.preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1) return -1;
        if (b.preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1 || b.preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1) return 1;
        if (b.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return -1;
        if (a.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return 1;
        const aircraftA = aircrafts.find(({ id: id })=>id === a.id);
        const aircraftB = aircrafts.find(({ id: id })=>id === b.id);
        return aircraftB.wingspan * aircraftB.length - aircraftA.wingspan * aircraftA.length;
    });
    const aircraftOrdereDoubleSwap = [];
    for(let i = 0; i < aircraftOrderedBiggestToSmallest.length; i += 2){
        if (aircraftOrderedBiggestToSmallest[i + 1]) aircraftOrdereDoubleSwap.push(aircraftOrderedBiggestToSmallest[i + 1]);
        aircraftOrdereDoubleSwap.push(aircraftOrderedBiggestToSmallest[i]);
    }
    const aircraftsToPlaceOrders = [
        // biggest to smallest
        aircraftOrderedBiggestToSmallest,
        // double swap
        aircraftOrdereDoubleSwap
    ];
    const labels = [
        "Big to Small, 50/50, Typewriter",
        "Big to Small, 25/75, Typewriter",
        "Big to Small, 10/90, Typewriter",
        "Big to Small, 50/50, Reverse Typewriter",
        "Big to Small, 25/75, Reverse Typewriter",
        "Big to Small, 10/90, Reverse Typewriter",
        "Double Swap, 50/50, Typewriter",
        "Double Swap, 25/75, Typewriter",
        "Double Swap, 10/90, Typewriter",
        "Double Swap, 50/50, Reverse Typewriter",
        "Double Swap, 25/75, Reverse Typewriter",
        "Double Swap, 10/90, Reverse Typewriter"
    ];
    const paramsSets = [];
    for (let error_type of error_types)for (let orderedAircraftsToPlace of aircraftsToPlaceOrders){
        const label = `${labels[paramsSets.length]}, ${params.options.overlap ? "3D" : "2D"}`;
        paramsSets.push({
            ...params,
            label: label,
            aircrafts_to_place: orderedAircraftsToPlace,
            options: {
                ...params.options,
                error_type: error_type
            }
        });
    }
    return paramsSets;
};
const $935b6e5ffeb2b47a$export$7fdf6b5703cbb386 = (params, aircrafts)=>{
    const error_types = [
        "error_hybrid_magnetic_lines_50_typewriter_50",
        "error_hybrid_magnetic_lines_25_typewriter_75",
        "error_hybrid_magnetic_lines_10_typewriter_90"
    ];
    const aircraftOrderedBiggestToSmallest = [
        ...params.aircrafts_to_place
    ].sort((a, b)=>{
        if (a.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return 1;
        if (b.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return -1;
        if (a.preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1 || a.preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1) return -1;
        if (b.preferences.indexOf((0, $keHtM.Preference).PREFER_FRONT_ROW) > -1 || b.preferences.indexOf((0, $keHtM.Preference).PREFER_BACK_ROW) > -1) return 1;
        if (b.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return -1;
        if (a.preferences.indexOf((0, $keHtM.Preference).OK_TO_LEAVE_OUT) > -1) return 1;
        const aircraftA = aircrafts.find(({ id: id })=>id === a.id);
        const aircraftB = aircrafts.find(({ id: id })=>id === b.id);
        return aircraftB.wingspan * aircraftB.length - aircraftA.wingspan * aircraftA.length;
    });
    const aircraftsToPlaceOrders = [
        aircraftOrderedBiggestToSmallest
    ];
    const labels = [
        "Big to Small, 50/50, Typewriter, 1ft spacing",
        "Big to Small, 50/50, Typewriter, 2ft spacing",
        "Big to Small, 50/50, Typewriter, 3ft spacing",
        "Big to Small, 50/50, Typewriter, 4ft spacing",
        "Big to Small, 50/50, Typewriter, 5ft spacing",
        "Big to Small, 25/75, Typewriter, 1 ft spacing",
        "Big to Small, 25/75, Typewriter, 2 ft spacing",
        "Big to Small, 25/75, Typewriter, 3 ft spacing",
        "Big to Small, 25/75, Typewriter, 4 ft spacing",
        "Big to Small, 25/75, Typewriter, 5 ft spacing",
        "Big to Small, 10/90, Typewriter, 1 ft spacing",
        "Big to Small, 10/90, Typewriter, 2 ft spacing",
        "Big to Small, 10/90, Typewriter, 3 ft spacing",
        "Big to Small, 10/90, Typewriter, 4 ft spacing",
        "Big to Small, 10/90, Typewriter, 5 ft spacing"
    ];
    const spacings = [
        1,
        2,
        3,
        4,
        5
    ];
    const paramsSets = [];
    for (let orderedAircraftsToPlace of aircraftsToPlaceOrders){
        for (let error_type of error_types)for (let spacing of spacings)paramsSets.push({
            ...params,
            label: labels[paramsSets.length],
            aircrafts_to_place: orderedAircraftsToPlace,
            options: {
                ...params.options,
                error_type: error_type,
                horizontal_spacing: spacing
            }
        });
    }
    return paramsSets;
};
const $935b6e5ffeb2b47a$export$8ad0a960b29b0069 = (params, aircrafts)=>{
    // - Do same 12 presets (as in 2D) with full 3D
    // - Do same 12 presets without overlap
    const nonOverlappingParamSets = $935b6e5ffeb2b47a$export$6ed08c1567af60f9({
        ...params,
        options: {
            ...params.options,
            overlap: false
        }
    }, aircrafts);
    const overlappingParamSets = $935b6e5ffeb2b47a$export$6ed08c1567af60f9(params, aircrafts);
    const paramSets = [
        ...nonOverlappingParamSets,
        ...overlappingParamSets
    ];
    return paramSets;
};
var $935b6e5ffeb2b47a$export$b817980e9115ae3c = /*#__PURE__*/ function(StackStrategy) {
    StackStrategy["normal"] = "NORMAL";
    StackStrategy["tight"] = "TIGHT";
    StackStrategy["loose"] = "LOOSE";
    StackStrategy["custom"] = "CUSTOM";
    StackStrategy["dev"] = "DEV";
    return StackStrategy;
}({});
const $935b6e5ffeb2b47a$export$7db1b6df574af2b9 = (strategy, paramSet, customPlacementOptions, fbo)=>{
    if (strategy === "DEV") return $935b6e5ffeb2b47a$export$c692edb86ded4bb2(paramSet, customPlacementOptions);
    if (strategy === "CUSTOM") return $935b6e5ffeb2b47a$export$c692edb86ded4bb2(paramSet, customPlacementOptions);
    if (strategy === "NORMAL") return $935b6e5ffeb2b47a$export$616171285a310bde(paramSet);
    if (strategy === "LOOSE") return $935b6e5ffeb2b47a$export$add41a8342ffea54(paramSet, fbo);
    if (strategy === "TIGHT") return $935b6e5ffeb2b47a$export$ad441ca3571b1bd4(paramSet, fbo);
};
const $935b6e5ffeb2b47a$export$ad441ca3571b1bd4 = (paramSet, fbo)=>{
    return {
        ...paramSet,
        // aircrafts_to_place: paramSet.aircrafts_to_place.map((a) => ({
        //   ...a,
        //   // nuke the preferences
        //   preferences: [],
        // })),
        options: {
            ...paramSet.options,
            xy_weights: [
                1,
                2
            ],
            cloud_position_prioritization: true,
            sample_size: 1000,
            vertical_spacing: fbo.sop_vertical_spacing_tight ?? Math.max(0, fbo.sop_vertical_spacing - 1),
            horizontal_spacing: fbo.sop_horizontal_spacing_tight ?? Math.max(0, fbo.sop_horizontal_spacing - 1),
            overlap: true,
            wall_spacing_back: paramSet.options.wall_spacing_back,
            wall_spacing_left: paramSet.options.wall_spacing_left,
            wall_spacing_right: paramSet.options.wall_spacing_right
        }
    };
};
const $935b6e5ffeb2b47a$export$616171285a310bde = (paramSet)=>{
    return {
        ...paramSet,
        options: {
            ...paramSet.options,
            xy_weights: [
                1,
                2
            ],
            cloud_position_prioritization: true,
            sample_size: 1000,
            overlap: paramSet.options.overlap ?? true
        }
    };
};
const $935b6e5ffeb2b47a$export$add41a8342ffea54 = (paramSet, fbo)=>{
    return {
        ...paramSet,
        options: {
            ...paramSet.options,
            xy_weights: [
                1,
                2
            ],
            cloud_position_prioritization: true,
            sample_size: 1000,
            overlap: false,
            vertical_spacing: fbo.sop_vertical_spacing_loose ?? paramSet.options.vertical_spacing + 1,
            horizontal_spacing: fbo.sop_horizontal_spacing_loose ?? paramSet.options.horizontal_spacing + 1,
            wall_spacing_back: paramSet.options.wall_spacing_back + 1,
            wall_spacing_left: paramSet.options.wall_spacing_left + 1,
            wall_spacing_right: paramSet.options.wall_spacing_right + 1
        }
    };
};
const $935b6e5ffeb2b47a$export$c692edb86ded4bb2 = (paramSet, customPlacementOptions)=>{
    return {
        ...paramSet,
        aircrafts_to_place: paramSet.aircrafts_to_place.map((a)=>({
                ...a,
                // nuke the preferences
                preferences: a.preferences.filter((pref)=>{
                    if ((pref === (0, $keHtM.Preference).NOSE_IN || pref === (0, $keHtM.Preference).TAIL_IN) && customPlacementOptions.ignore_nose_in_out) return false;
                    if ((pref === (0, $keHtM.Preference).PREFER_BACK_ROW || pref === (0, $keHtM.Preference).PREFER_FRONT_ROW) && customPlacementOptions.ignore_front_back) return false;
                    if (pref === (0, $keHtM.Preference).OK_TO_LEAVE_OUT && customPlacementOptions.ignore_outside_hangar) return false;
                    return true;
                })
            })),
        options: {
            ...paramSet.options,
            towing_equipment_id: customPlacementOptions.towing_equipment_id ?? paramSet.options.towing_equipment_id,
            overlap: customPlacementOptions.overlap,
            horizontal_spacing: customPlacementOptions.horizontal_spacing,
            vertical_spacing: customPlacementOptions.vertical_spacing,
            cloud_position_prioritization: customPlacementOptions.cloud_position_prioritization,
            sample_size: customPlacementOptions.sample_size,
            corner_strategy: customPlacementOptions.corner_strategies?.[0],
            xy_weights: customPlacementOptions.xy_weights,
            wall_spacing_back: customPlacementOptions.wall_spacing_back,
            wall_spacing_left: customPlacementOptions.wall_spacing_left,
            wall_spacing_right: customPlacementOptions.wall_spacing_right
        }
    };
};

});

parcelRegister("8G8wE", function(module, exports) {

$parcel$export(module.exports, "runAutocomplete", () => $92905270c4eddf7f$export$46eb1aea871aee5c);
$parcel$export(module.exports, "runAllParamSets", () => $92905270c4eddf7f$export$5394415ecb133413);
parcelRequire("9vNAe");
var $d2xzW = parcelRequire("d2xzW");

var $lLxKB = parcelRequire("lLxKB");

var $d199i = parcelRequire("d199i");

var $5KGQl = parcelRequire("5KGQl");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $hdCOT = parcelRequire("hdCOT");
const $92905270c4eddf7f$export$9f17032d917177de = (a, b)=>{
    return Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);
};
const $92905270c4eddf7f$export$571f7998b5f60e84 = (positions)=>{
    if (positions.length <= 3) return positions;
    const positionsByError = (0, $cLNZr.orderBy)(positions, [
        "error"
    ], [
        "desc"
    ]);
    const bestPosition = positionsByError[0];
    let furthestPositions = [];
    let maxDistance = 0;
    for (const position1 of positions.slice(1)){
        if (position1.id === bestPosition.id) continue;
        for (const position2 of positions.slice(1)){
            if (position1.id === position2.id) continue;
            if (position2.id === bestPosition.id) continue;
            const totalDistance = $92905270c4eddf7f$export$9f17032d917177de(bestPosition, position1) + $92905270c4eddf7f$export$9f17032d917177de(bestPosition, position2);
            if (totalDistance > maxDistance) {
                maxDistance = totalDistance;
                furthestPositions = [
                    bestPosition,
                    position1,
                    position2
                ];
            }
        }
    }
    return furthestPositions;
};
const $92905270c4eddf7f$var$makeAutocompleteHash = (params)=>{
    const { label: _label, ...paramsWithoutLabel } = params;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify(paramsWithoutLabel));
};
const $92905270c4eddf7f$var$autocompleteCache = new Map();
const $92905270c4eddf7f$export$46eb1aea871aee5c = async (hangar, paramSets, airplxToken)=>{
    window.globalThis.airplxKillSwitch = 0;
    const N_WORKER_THREADS = Math.min(paramSets.length, 10);
    const limit = (0, (/*@__PURE__*/$parcel$interopDefault($d199i)))(N_WORKER_THREADS);
    const doit = paramSets.map(async (paramsWithLabel)=>{
        return limit(async ()=>{
            const { label: _label, ...paramsWithoutLabel } = paramsWithLabel;
            const hash = $92905270c4eddf7f$var$makeAutocompleteHash(paramsWithLabel);
            if ($92905270c4eddf7f$var$autocompleteCache.has(hash)) return $92905270c4eddf7f$var$autocompleteCache.get(hash);
            // this is for testing
            window.location.hostname.indexOf("localhost");
            const result = await (0, $hdCOT.oneShotAutocomplete)(paramsWithoutLabel, airplxToken);
            $92905270c4eddf7f$var$autocompleteCache.set(hash, result);
            return result;
        });
    });
    const t0 = +new Date();
    const results = await Promise.all(doit);
    console.log(`autocomplete took ${+new Date() - t0}ms`);
    const suggestions = results.map((stackMembers)=>{
        return stackMembers.filter((sm)=>sm.placement_id === paramSets[0].aircrafts_to_place[0].placement_id).map((sm)=>({
                id: (0, $lNEp2.uuidv4)(),
                hangar_id: hangar.id,
                x: sm.x,
                y: sm.y,
                angle: sm.angle,
                error: sm.error
            }));
    }).flat().filter((suggestion)=>{
        return suggestion.x !== null && suggestion.x !== undefined;
    });
    const dedupedSuggestions = (0, $cLNZr.uniqBy)(suggestions, (s)=>`${s.x}-${s.y}-${s.angle}`);
    const orderedSuggestions = (0, $cLNZr.orderBy)(dedupedSuggestions, [
        "error"
    ], [
        "asc"
    ]);
    const suggestedPolygons = (0, $5KGQl.getStackPolygons)({
        ...hangar.stack,
        tenants: orderedSuggestions.map((position)=>({
                ...hangar.stack.tenants.find((t)=>t.selected),
                position: {
                    ...hangar.stack.tenants.find((t)=>t.selected).position,
                    ...position
                }
            })),
        movableObstacles: []
    }, hangar.width, 1);
    const nonOverlappingSuggestions = [];
    const nonOverlappingPolygons = [];
    for(let i = 0; i < suggestedPolygons.length; i++){
        // check to see if the ith suggestedPolygon overlaps with any of the nonOverlappingSuggestions
        let overlaps = false;
        const ithPolygon = suggestedPolygons[i];
        for (const suggestedPolygon of nonOverlappingPolygons)if ((0, $d2xzW.polygonIntersectsPolygon)(ithPolygon.polygon.coordinates[0], suggestedPolygon.polygon.coordinates[0])) {
            overlaps = true;
            break;
        }
        if (!overlaps) {
            nonOverlappingSuggestions.push(orderedSuggestions[i]);
            nonOverlappingPolygons.push(ithPolygon);
        }
    }
    return orderedSuggestions.slice(0, 4);
// return findFurthestApart(orderedSuggestions);
};
const $92905270c4eddf7f$export$5394415ecb133413 = async (hangar, paramsSets, onNewStacks, onProgress, airplxIdentity, airplxToken)=>{
    /**
   * Limit to 4 trials running simultaneously. This defacto also limits to 4
   * simultaneous requests because each trial runs each step sequentially.
   */ const N_WORKER_THREADS = 10;
    const limit = (0, (/*@__PURE__*/$parcel$interopDefault($d199i)))(N_WORKER_THREADS);
    const currentLayoutOptions = paramsSets.map((paramSet)=>({
            paramSet: paramSet,
            stackMembers: []
        }));
    const progress = paramsSets.map(()=>0);
    onNewStacks(currentLayoutOptions);
    const doit = paramsSets.map(async (paramsWithLabel, idx)=>{
        return limit(async ()=>{
            const { label: _label, ...paramsWithoutLabel } = paramsWithLabel;
            let cntr = 0;
            /**
       * We get incremental updates as airplanes are being put into the hangar. So let's
       * show them to the user! TECHNOLOGY!
       */ for await (let stackMembers of (0, $hdCOT.placeIncrementally)(paramsWithoutLabel, hangar.stack.tenants, airplxIdentity, airplxToken)){
                currentLayoutOptions[idx] = {
                    ...currentLayoutOptions[idx],
                    stackMembers: stackMembers
                };
                cntr++;
                // somewhat surprisingly, this stuff still works even though we're now
                // in a function. not exactly sure why...
                progress[idx] = cntr / paramsSets[0].aircrafts_to_place.length;
                onNewStacks([
                    ...currentLayoutOptions
                ]);
                onProgress(progress);
            }
            progress[idx] = 1;
            onProgress(progress);
        });
    });
    await Promise.all(doit);
};

});
parcelRegister("hdCOT", function(module, exports) {

$parcel$export(module.exports, "placeIncrementally", () => $6be480fa88188402$export$976ce578d9ad01c1);
$parcel$export(module.exports, "oneShotAutocomplete", () => $6be480fa88188402$export$d37f8f6be8d30981);
parcelRequire("hLOAf");
var $bjuzH = parcelRequire("bjuzH");

var $lNEp2 = parcelRequire("lNEp2");
const $6be480fa88188402$var$postgrest = new (0, $bjuzH.default)((0, $lNEp2.getPostgrestUrl)());
async function $6be480fa88188402$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
const $6be480fa88188402$export$1765177311736717 = async (postgrest, queueId)=>{
    for(let i = 0; i < 240; i++){
        if (window.globalThis.airplxKillSwitch) return;
        const response = await postgrest.from("queue_result").select("result").eq("qid", queueId);
        if (response.data?.length > 0) return response.data[0].result;
        await $6be480fa88188402$export$e772c8ff12451969(100);
    }
};
const $6be480fa88188402$export$de27182ff8187d6c = async (postgrest, paramSet)=>{
    const response = await postgrest.rpc("setup", {
        ...paramSet
    }).single();
    const queueId = response.data;
    try {
        const setupResult = (await $6be480fa88188402$export$1765177311736717(postgrest, queueId)).setup;
        return setupResult;
    } catch (err) {
        console.error(err);
        console.log(`could not fetch queueId: ${queueId}`);
    }
};
const $6be480fa88188402$export$7f1b872c50694171 = async (postgrest, payload)=>{
    const response = await postgrest.rpc("place_aircraft", {
        ...payload
    }).single();
    // it will take at least 250ms, so wait until we start polling
    await $6be480fa88188402$export$e772c8ff12451969(100);
    const queueId = response.data;
    for(let retry = 1; retry <= 3; retry++)try {
        const placement = (await $6be480fa88188402$export$1765177311736717(postgrest, queueId)).placement;
        if (retry > 1) console.log(`retry success for ${queueId}`);
        return placement;
    } catch (err) {
        if (retry === 3) {
            console.error(err);
            console.log(`could not fetch queueId: ${queueId} -- ${payload.aircraft.id}`);
            continue;
        }
        console.log(`could not fetch queueId: ${queueId} -- ${payload.aircraft.id}. retrying ${retry} of 3`);
    }
};
async function* $6be480fa88188402$export$976ce578d9ad01c1(placementParams, tenants, airplxIdentity, airplxToken) {
    $6be480fa88188402$var$postgrest.schema = "web";
    $6be480fa88188402$var$postgrest.auth(airplxToken);
    const { run_id: run_id } = placementParams;
    const setupResult = await $6be480fa88188402$export$de27182ff8187d6c($6be480fa88188402$var$postgrest, placementParams);
    if (!setupResult || !setupResult.hangar) {
        console.log("invalid setup");
        return;
    }
    const { aircrafts_to_place: aircrafts_to_place, stack_members: stack_members, hangar: hangar, options: options } = setupResult;
    let smallestPlacedArea = 9999999999999999;
    for (let aircraft_to_place of aircrafts_to_place){
        if (window.globalThis.airplxKillSwitch) {
            const unstackedTenants = tenants.filter((tenant)=>!Boolean(stack_members.find(({ placement_id: placement_id })=>placement_id === tenant.placement_id))).map((tenant)=>{
                return {
                    aircraft_id: tenant.aircraft.id,
                    placement_id: tenant.placement_id,
                    x: null,
                    y: null,
                    angle: null,
                    geom: null,
                    geomz: null,
                    error: 0,
                    area: tenant.aircraft.wingspan * tenant.aircraft.length
                };
            });
            yield stack_members.filter(({ aircraft_id: aircraft_id })=>!aircraft_id.startsWith("00000000-0000-0000-0000-00000000000")).concat(unstackedTenants);
            return;
        }
        const { aircraft: aircraft } = tenants.find((tenant)=>tenant.placement_id === aircraft_to_place.placement_id);
        const area = aircraft.wingspan * aircraft.length;
        if (area >= smallestPlacedArea) continue;
        const parameters = {
            run_id: run_id,
            aircraft: aircraft_to_place,
            stack_members_web: stack_members,
            hangar: hangar,
            options: options,
            bays: hangar.bays ?? []
        };
        let placement;
        try {
            placement = await $6be480fa88188402$export$7f1b872c50694171($6be480fa88188402$var$postgrest, parameters);
        } catch (err) {
            console.error(err);
            continue;
        }
        if (!placement) {
            console.error("no placement returned");
            continue;
        }
        // for 2D we will only continue placing aircraft that are smaller than ones we've tried
        if (!placement?.point) {
            smallestPlacedArea = area;
            continue;
        }
        const new_stack_member = {
            aircraft_id: aircraft_to_place.id,
            placement_id: aircraft_to_place.placement_id,
            x: placement.point.coordinates[0],
            y: placement.point.coordinates[1],
            angle: placement.angle,
            geom: placement.geom,
            geomz: placement.geomz,
            error: placement.error,
            area: area
        };
        stack_members.push(new_stack_member);
        yield stack_members.filter(({ aircraft_id: aircraft_id })=>!aircraft_id.startsWith("00000000-0000-0000-0000-00000000000"));
    }
    const unstackedTenants = tenants.filter((tenant)=>!Boolean(stack_members.find(({ placement_id: placement_id })=>placement_id === tenant.placement_id))).map((tenant)=>{
        return {
            aircraft_id: tenant.aircraft.id,
            placement_id: tenant.placement_id,
            x: null,
            y: null,
            angle: null,
            geom: null,
            geomz: null,
            error: 0,
            area: tenant.aircraft.wingspan * tenant.aircraft.length
        };
    });
    yield stack_members.filter(({ aircraft_id: aircraft_id })=>!aircraft_id.startsWith("00000000-0000-0000-0000-00000000000")).concat(unstackedTenants);
}
const $6be480fa88188402$export$75fafd44a6a51c5b = async (postgrest, paramSet)=>{
    const response = await postgrest.rpc("autocomplete", {
        ...paramSet
    }).single();
    const queueId = response.data;
    if (!queueId) {
        console.error("no queueId returned", response);
        return;
    }
    try {
        const result = (await $6be480fa88188402$export$1765177311736717(postgrest, queueId)).placement;
        return result;
    } catch (err) {
        console.error(err);
        console.log(`could not fetch queueId: ${queueId}`);
    }
};
const $6be480fa88188402$export$d37f8f6be8d30981 = async (paramSet, airplxToken)=>{
    $6be480fa88188402$var$postgrest.schema = "web";
    $6be480fa88188402$var$postgrest.auth(airplxToken);
    const aircraft = paramSet.aircrafts_to_place[0];
    const autocompleteParamSet = {
        run_id: paramSet.run_id,
        aircraft: aircraft,
        stack_members_web: [],
        hangar: paramSet.hangar,
        locked_aircrafts: paramSet.locked_aircrafts,
        obstacles: paramSet.obstacles,
        options: paramSet.options,
        bays: paramSet.hangar.bays ?? []
    };
    const placement = await $6be480fa88188402$export$75fafd44a6a51c5b($6be480fa88188402$var$postgrest, autocompleteParamSet);
    if (!placement) return [];
    return [
        {
            aircraft_id: aircraft.id,
            placement_id: aircraft.placement_id,
            x: placement.point?.coordinates?.[0],
            y: placement.point?.coordinates?.[1],
            angle: placement.angle,
            geom: placement.geom,
            geomz: placement.geomz,
            error: placement.error,
            area: null
        }
    ];
};

});




parcelRegister("he3Hz", function(module, exports) {

$parcel$export(module.exports, "LayoutToolbarWrapper", () => $99a6fe53ed711d13$export$bf38685a49448127);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
parcelRequire("acw62");

var $7p8YN = parcelRequire("7p8YN");
parcelRequire("6qWGE");
var $c0zpU = parcelRequire("c0zpU");

var $5ShSi = parcelRequire("5ShSi");
const $99a6fe53ed711d13$export$bf38685a49448127 = ({ hangarId: hangarId, setStacks: setStacks })=>{
    const { getHangar: getHangar, setHangar: setHangar, history: history } = (0, $7p8YN.useMultiHangarState)();
    const hangar = getHangar(hangarId);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        bgcolor: "white",
        mb: 1,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0zpU.LayoutToolbar), {
            location: {
                type: "hangar",
                ...hangar
            },
            setLocation: ({ type: _type, ...location })=>setHangar({
                    ...hangar,
                    ...location
                }),
            stack: hangar.stack,
            setStack: (stack)=>{
                setHangar({
                    ...hangar,
                    stack: {
                        ...hangar.stack,
                        ...stack
                    }
                });
            },
            setStacks: setStacks,
            onClickUndo: ()=>{
                history && history.undo();
            },
            renderOnPrint: (idsToPrint)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ShSi.MultiHangarPrintLayout), {
                    idsToPrint: idsToPrint
                })
        })
    });
};

});
parcelRegister("5ShSi", function(module, exports) {

$parcel$export(module.exports, "MultiHangarPrintLayout", () => $edd88339acb73cd1$export$35b524213ba95d90);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $7p8YN = parcelRequire("7p8YN");

var $lNEp2 = parcelRequire("lNEp2");

var $e8RbV = parcelRequire("e8RbV");

var $ki5be = parcelRequire("ki5be");

var $kinWj = parcelRequire("kinWj");
const $edd88339acb73cd1$export$35b524213ba95d90 = ({ idsToPrint: idsToPrint })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hangarIds: hangarIds, hangars: allHangars } = (0, $7p8YN.useMultiHangarState)();
    const hangars = allHangars.filter((h)=>hangarIds.indexOf(h.id) > -1).filter((h)=>idsToPrint.indexOf(h.id) > -1);
    const { nAircraftInHangar: nAircraftInHangar, totalSqftAvailable: totalSqftAvailable, totalUtilization: totalUtilization } = (0, $kinWj.calculateMultiHangarStats)(activeFBO, hangars);
    const maxDim = (0, $e8RbV.getMaxDimension)(hangars);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                    type: "text/css",
                    media: "print",
                    children: `@page { size: landscape; }`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    "data-id": "multi-hangar-layout",
                    sx: {
                        display: "flex",
                        flexWrap: "wrap"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    direction: "column",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                children: [
                                                    hangars.length,
                                                    " Hangars"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                orientation: "vertical",
                                                sx: {
                                                    height: 20
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                children: [
                                                    (0, $lNEp2.formatNumber)(totalSqftAvailable, 0),
                                                    " ft\xb2"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "flex-end",
                                    spacing: 1,
                                    sx: {
                                        width: 500,
                                        height: 50
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "subtitle1",
                                                    children: "Aircraft"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    textAlign: "center",
                                                    color: "info.dark",
                                                    children: nAircraftInHangar
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                            orientation: "vertical"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "subtitle1",
                                                    children: "Utilization"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    textAlign: "center",
                                                    color: "info.dark",
                                                    children: [
                                                        totalUtilization,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        hangars.map((hangar)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ki5be.LayoutWrapper), {
                                    width: 350 * hangar.width / maxDim,
                                    print: true,
                                    customPlacementOptions: null,
                                    hangars: hangars,
                                    hangarId: hangar.id
                                })
                            }, `print-multihangar-${hangar.id}`);
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("e8RbV", function(module, exports) {

$parcel$export(module.exports, "getMaxDimension", () => $fc4eb8ea36d62df2$export$4ee9b233297e67a9);
$parcel$export(module.exports, "getFeetToPixels", () => $fc4eb8ea36d62df2$export$18aa3ecf4d1cb0a3);
$parcel$export(module.exports, "HangarViewWrapper", () => $fc4eb8ea36d62df2$export$55c23f1eaaf55553);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ZD2ym = parcelRequire("ZD2ym");

var $7p8YN = parcelRequire("7p8YN");

var $78CAK = parcelRequire("78CAK");

var $eYWyk = parcelRequire("eYWyk");

var $3JLDK = parcelRequire("3JLDK");

var $ctu9I = parcelRequire("ctu9I");

var $5U03M = parcelRequire("5U03M");

var $he3Hz = parcelRequire("he3Hz");

var $ki5be = parcelRequire("ki5be");

var $kinWj = parcelRequire("kinWj");
const $fc4eb8ea36d62df2$export$cd2d95db06fbcd33 = 1.25;
const $fc4eb8ea36d62df2$export$2ab2de410bb962bd = 500;
const $fc4eb8ea36d62df2$export$cef59c987cffaef5 = 500;
const $fc4eb8ea36d62df2$export$305ed5866edcee44 = (hangar, zoom, expanded)=>{
    // const aspectRatios = hangars.map((h) => h.width / h.depth);
    if (expanded) return {
        width: 900,
        height: 900 * hangar.depth / hangar.width
    };
    const aspectRatio = hangar.width / hangar.depth;
    if (aspectRatio > 1.75) return {
        width: $fc4eb8ea36d62df2$export$2ab2de410bb962bd * zoom * 1.75,
        height: $fc4eb8ea36d62df2$export$cef59c987cffaef5 * zoom * 1.75
    };
    return {
        width: $fc4eb8ea36d62df2$export$2ab2de410bb962bd * zoom,
        height: $fc4eb8ea36d62df2$export$cef59c987cffaef5 * zoom
    };
};
const $fc4eb8ea36d62df2$export$4ee9b233297e67a9 = (hangars)=>{
    const maxWidth = Math.max(...hangars.map((h)=>h.width));
    const mathDepth = Math.max(...hangars.map((h)=>h.depth));
    const maxDim = Math.max(maxWidth, mathDepth);
    return maxDim;
};
const $fc4eb8ea36d62df2$export$18aa3ecf4d1cb0a3 = (hangars, zoom, focus)=>{
    if (Boolean(focus)) return 600 * zoom / hangars.find((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID) && h.id === focus).width;
    const maxDim = $fc4eb8ea36d62df2$export$4ee9b233297e67a9(hangars.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID)));
    const benchmarkDim = maxDim * $fc4eb8ea36d62df2$export$cd2d95db06fbcd33;
    const feetToPixels = $fc4eb8ea36d62df2$export$2ab2de410bb962bd / benchmarkDim * zoom;
    return feetToPixels;
};
const $fc4eb8ea36d62df2$export$be14c70873dfcfa2 = (hangar, zoom, expanded, feetToPixels)=>{
    if (expanded) return 600 * zoom;
    return hangar.width * feetToPixels;
};
const $fc4eb8ea36d62df2$export$55c23f1eaaf55553 = ({ feetToPixels: feetToPixels, hangarId: hangarId })=>{
    const { zoom: zoom, activeLocationId: activeLocationId, setActiveLocationId: setActiveLocationId, focus: focus, hangars: hangars, getHangar: getHangar } = (0, $7p8YN.useMultiHangarState)();
    const navigate = (0, $aphAM.useNavigate)();
    const hangar = getHangar(hangarId);
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [stackStrategy, setStackStrategy] = $acw62.useState((0, $eYWyk.StackStrategy).normal);
    const [stacks, setStacks] = $acw62.useState([]);
    // TODO: this won't work
    const [customPlacementOptions, setCustomPlacementOptions] = $acw62.useState((0, $78CAK.defaultCustomPlacementOptions)(activeFBO, null));
    // to make things simpler, we're going to pre-scale the width and height of the hangar
    // so that each hangar has the same aspect ratio
    // default that 200ft will equal 450px
    const boxWidth = $fc4eb8ea36d62df2$export$be14c70873dfcfa2(hangar, zoom, focus === hangar.id, feetToPixels);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    zIndex: 1000,
                    top: 0,
                    left: 72,
                    display: activeLocationId === hangar.id ? "block" : "none",
                    bgcolor: "white",
                    height: "100vh"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "row",
                    sx: {
                        height: "100%"
                    },
                    children: activeLocationId === hangar.id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3JLDK.CollapsibleRampActionCard), {
                        hideTitle: true,
                        location: {
                            type: "hangar",
                            ...hangar
                        },
                        onClickBack: ()=>navigate("/hangars"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            display: "flex",
                            flex: 1,
                            spacing: 1,
                            height: "100%",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kinWj.MultiHangarInfoCard), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctu9I.HangarLeftPanelWrapper), {
                                    hangarId: hangar.id,
                                    width: !isDrawerOpen ? 125 : 400,
                                    stacks: stacks,
                                    setStacks: setStacks,
                                    stackStrategy: stackStrategy,
                                    setStackStrategy: setStackStrategy,
                                    customPlacementOptions: customPlacementOptions,
                                    setCustomPlacementOptions: setCustomPlacementOptions,
                                    viewableHangars: hangars,
                                    activeHangarId: activeLocationId,
                                    setActiveHangarId: setActiveLocationId
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    zIndex: 5249,
                    top: 0,
                    left: !isDrawerOpen ? 225 : 475,
                    width: !isDrawerOpen ? "calc(100vw - 225px)" : "calc(100vw - 475px)",
                    display: activeLocationId === hangar.id ? "block" : "none"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $he3Hz.LayoutToolbarWrapper), {
                    hangarId: hangar.id,
                    setStacks: setStacks
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                m: 0,
                p: 0,
                onMouseOver: ()=>{
                    const hangarWithEntitySelected = hangars.find((h)=>{
                        if (h.stack.tenants.find((t)=>t.selected)) return true;
                        if (h.stack.movableObstacles.find((mo)=>mo.selected)) return true;
                        return false;
                    });
                    if (!hangarWithEntitySelected) return;
                    if (activeLocationId === hangarWithEntitySelected.id) return;
                // TODO
                },
                onMouseLeave: ()=>{
                // TODO
                },
                onMouseDown: ()=>{
                    setActiveLocationId(hangar.id);
                    // here we are looking to handle the case when multiple airplanes can theoretically be
                    // selected in a multihangar setting. the problem is that this messes with the click event
                    // inside of the layout––but only when clicking on a Ghost Aircraft in a different hangar than
                    // the airplane is currently in
                    return;
                },
                onMouseUp: ()=>{
                // TODO
                },
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ki5be.LayoutWrapper), {
                        hangarId: hangar.id,
                        width: boxWidth,
                        customPlacementOptions: customPlacementOptions,
                        hangars: hangars
                    })
                })
            })
        ]
    });
};

});
parcelRegister("ctu9I", function(module, exports) {

$parcel$export(module.exports, "HangarLeftPanelWrapper", () => $1fae00eff993ea1b$export$2a856a3591235d9c);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $7p8YN = parcelRequire("7p8YN");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");

var $g7var = parcelRequire("g7var");

var $dnRrW = parcelRequire("dnRrW");

var $3JLDK = parcelRequire("3JLDK");
const $1fae00eff993ea1b$export$2a856a3591235d9c = ({ hangarId: hangarId, stacks: stacks, setStacks: setStacks, stackStrategy: stackStrategy, setStackStrategy: setStackStrategy, customPlacementOptions: customPlacementOptions, setCustomPlacementOptions: setCustomPlacementOptions, viewableHangars: viewableHangars, activeHangarId: activeHangarId, setActiveHangarId: setActiveHangarId })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { getHangar: getHangar, setHangar: setHangar } = (0, $7p8YN.useMultiHangarState)();
    const hangar = getHangar(hangarId);
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const paramSet = {
        run_id: null,
        label: "base case",
        // slim down the hangar for the API call
        hangar: {
            id: hangar.id,
            width: hangar.width,
            depth: hangar.depth,
            left_door: hangar.left_door,
            right_door: hangar.right_door,
            garage_doors: hangar.garageDoors ?? []
        },
        // slim down the tenant so it's just what we need to do the placement
        aircrafts_to_place: hangar.stack.tenants.filter((t)=>t.position.preferences?.indexOf((0, $keHtM.Preference).LOCKED) === -1).map((tenant)=>({
                id: tenant.aircraft.id,
                placement_id: tenant.placement_id,
                angles_to_try: [],
                sectors_to_try: null,
                preferences: (0, $lNEp2.convertAircraftPreferencesToAlgorithmPreferences)(tenant.position.preferences)
            })),
        locked_aircrafts: hangar.stack.tenants.filter((t)=>t.position.preferences?.indexOf((0, $keHtM.Preference).LOCKED) > -1).map((tenant)=>({
                id: tenant.aircraft.id,
                placement_id: tenant.placement_id,
                x: tenant.position.x,
                y: tenant.position.y,
                angle: tenant.position.angle
            })),
        obstacles: (0, $g7var.formatObstacles)(hangar),
        options: {
            ...hangar.stack.options,
            ...customPlacementOptions
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dnRrW.HangarLeftPanel), {
        readOnly: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
        multiHangar: true,
        hangar: hangar,
        setHangar: setHangar,
        stacks: stacks,
        setStacks: setStacks,
        stackStrategy: stackStrategy,
        setStackStrategy: setStackStrategy,
        paramSet: paramSet,
        customPlacementOptions: customPlacementOptions,
        setCustomPlacementOptions: setCustomPlacementOptions,
        isReference: false,
        isAlgorithmTesting: false,
        width: isDrawerOpen ? 400 : 125,
        activeHangarId: activeHangarId,
        setActiveHangarId: setActiveHangarId,
        viewableHangars: viewableHangars
    });
};

});
parcelRegister("dnRrW", function(module, exports) {

$parcel$export(module.exports, "HangarLeftPanel", () => $3cd43e951e2ac3e9$export$ee9a89e24c2907a3);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $eXGdF = parcelRequire("eXGdF");

var $6wfYj = parcelRequire("6wfYj");

var $5U03M = parcelRequire("5U03M");

var $kPMZ3 = parcelRequire("kPMZ3");
parcelRequire("48Vdb");
var $jmWH8 = parcelRequire("jmWH8");

var $aWoxc = parcelRequire("aWoxc");
const $3cd43e951e2ac3e9$export$ee9a89e24c2907a3 = ({ hangar: hangar, setHangar: setHangar, stacks: stacks, setStacks: setStacks, stackStrategy: stackStrategy, setStackStrategy: setStackStrategy, paramSet: paramSet, customPlacementOptions: customPlacementOptions, setCustomPlacementOptions: setCustomPlacementOptions, isReference: isReference = false, isAlgorithmTesting: isAlgorithmTesting = false, multiHangar: multiHangar = false, width: width = 400, viewableHangars: viewableHangars, activeHangarId: activeHangarId, setActiveHangarId: setActiveHangarId, readOnly: readOnly = false, disableAutoOpen: disableAutoOpen = false, isScheduledView: isScheduledView = false, onAddTrip: onAddTrip, currentTime: currentTime, timeRange: timeRange, allPlacements: allPlacements, onRemoveAircraft: onRemoveAircraft, onRefresh: onRefresh, onTimeChange: onTimeChange, onNavigateToLocation: onNavigateToLocation })=>{
    const navigate = (0, $aphAM.useNavigate)();
    const { rangeStart: rangeStart, rangeEnd: rangeEnd } = (0, $aWoxc.useScheduleTimeRange)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        sx: {
            height: "100%",
            display: "flex",
            flex: 1,
            width: width ?? 400,
            overflow: "auto"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPMZ3.HangarInfoCard), {
                customPlacementOptions: customPlacementOptions,
                setCustomPlacementOptions: setCustomPlacementOptions,
                isAlgorithmTesting: isAlgorithmTesting,
                hangar: hangar,
                onClickBack: ()=>navigate("/hangars"),
                isReference: isReference,
                multiHangar: multiHangar,
                activeHangarId: activeHangarId,
                setActiveHangarId: setActiveHangarId,
                hangars: viewableHangars,
                isScheduledView: isScheduledView,
                timeRange: timeRange,
                allPlacements: allPlacements
            }),
            hangar.id !== (0, $5U03M.HOLDING_AREA_ID) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jmWH8.RunStack), {
                        disabled: readOnly,
                        hangar: hangar,
                        isAlgorithmTesting: isAlgorithmTesting,
                        customPlacementOptions: customPlacementOptions,
                        paramSet: paramSet,
                        stacks: stacks,
                        setStacks: setStacks,
                        stackStrategy: stackStrategy,
                        setStackStrategy: setStackStrategy,
                        isScheduledView: isScheduledView
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    height: 8,
                    width: "100%",
                    backgroundColor: "#EEEEEE"
                }
            }),
            isScheduledView && allPlacements ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6wfYj.TimelineAircraftList), {
                readOnly: readOnly,
                width: width,
                location: {
                    type: "hangar",
                    ...hangar
                },
                stack: hangar.stack,
                setStack: (stack)=>{
                    setHangar({
                        ...hangar,
                        stack: {
                            ...hangar.stack,
                            ...stack
                        }
                    });
                },
                disableAutoOpen: disableAutoOpen,
                isScheduledView: isScheduledView,
                onAddTrip: onAddTrip,
                currentTime: currentTime || new Date(),
                onRemoveAircraft: onRemoveAircraft,
                rangeStart: rangeStart,
                rangeEnd: rangeEnd,
                placementsInRange: allPlacements.filter((p)=>{
                    const start = new Date(p.start_time).getTime();
                    const end = new Date(p.end_time).getTime();
                    const rangeStartTime = rangeStart.getTime();
                    const rangeEndTime = rangeEnd.getTime();
                    return start >= rangeStartTime && start <= rangeEndTime || end >= rangeStartTime && end <= rangeEndTime || start <= rangeStartTime && end >= rangeEndTime;
                }),
                allPlacementsFromNow: allPlacements,
                onRefresh: onRefresh,
                onTimeChange: onTimeChange,
                onNavigateToLocation: onNavigateToLocation
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eXGdF.CurrentAircraft), {
                readOnly: readOnly,
                width: width,
                location: {
                    type: "hangar",
                    ...hangar
                },
                stack: hangar.stack,
                setStack: (stack)=>{
                    setHangar({
                        ...hangar,
                        stack: {
                            ...hangar.stack,
                            ...stack
                        }
                    });
                },
                disableAutoOpen: disableAutoOpen,
                isScheduledView: isScheduledView,
                onAddTrip: onAddTrip,
                currentTime: currentTime,
                onRemoveAircraft: onRemoveAircraft
            })
        ]
    });
};

});
parcelRegister("6wfYj", function(module, exports) {

$parcel$export(module.exports, "TimelineAircraftList", () => $d118f0c966764588$export$e831e45c6a944680);

var $ayMG0 = parcelRequire("ayMG0");

var $jO6ya = parcelRequire("jO6ya");

var $2P5BT = parcelRequire("2P5BT");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $hViLc = parcelRequire("hViLc");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $6rxM8 = parcelRequire("6rxM8");

var $3JLDK = parcelRequire("3JLDK");

var $35bYL = parcelRequire("35bYL");

var $8ORjT = parcelRequire("8ORjT");

var $lNEp2 = parcelRequire("lNEp2");

var $jYWTx = parcelRequire("jYWTx");

var $eGvtx = parcelRequire("eGvtx");
// Wrapper component to properly handle prefilled tail number
const $d118f0c966764588$var$CreateTripDialogWrapper = (props)=>{
    // This wrapper ensures the dialog gets the prefilled tail as initial data
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35bYL.CreateTripDialog), {
        ...props
    });
};
const $d118f0c966764588$export$e831e45c6a944680 = ({ location: location, stack: stack, setStack: setStack, width: width, feetToPixels: feetToPixels, readOnly: readOnly = false, disableAutoOpen: disableAutoOpen = false, isScheduledView: isScheduledView = false, onAddTrip: onAddTrip, currentTime: currentTime = new Date(), onRemoveAircraft: _onRemoveAircraft, rangeStart: // Unused but part of interface
rangeStart, rangeEnd: rangeEnd, placementsInRange: placementsInRange, allPlacementsFromNow: allPlacementsFromNow, onRefresh: onRefresh, onTimeChange: onTimeChange, onNavigateToLocation: onNavigateToLocation, rampShapes: rampShapes, rampDepth: rampDepth })=>{
    const theme = (0, $14H9o.default)();
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const { sendToLocation: sendToLocation } = (0, $6rxM8.useLocationsState)();
    const [filterText, setFilterText] = $acw62.useState("");
    const [showCreateTrip, setShowCreateTrip] = $acw62.useState(false);
    const [prefilledTailNumber, setPrefilledTailNumber] = $acw62.useState("");
    const [createTripKey, setCreateTripKey] = $acw62.useState(0); // Force remount of dialog
    // Process placements to get unique aircraft with trip info
    const aircraftWithTrips = $acw62.useMemo(()=>{
        const aircraftMap = new Map();
        // Use ALL placements when searching, otherwise just active
        const placementsToProcess = filterText ? allPlacementsFromNow : placementsInRange;
        // Process all placements
        placementsToProcess.forEach((placement)=>{
            // Skip cancelled placements when not searching
            if (placement.status === "cancelled" && !filterText) return;
            // Get tail number from placement data - it's directly on the placement
            const tailNumber = placement.tail_number;
            if (!tailNumber) return;
            if (!aircraftMap.has(tailNumber)) aircraftMap.set(tailNumber, {
                tailNumber: tailNumber,
                tenantId: placement.tenant_id,
                aircraftModel: placement.aircraft_type,
                // Using aircraft_type field
                aircraftMake: placement.aircraft_make,
                // Add make from placement
                trips: [],
                isCurrentlyHere: false,
                tenant: undefined
            });
            const aircraft = aircraftMap.get(tailNumber);
            // Check if we already have this trip (by trip_id)
            const existingTripIndex = aircraft.trips.findIndex((t)=>t.tripId === placement.trip_id);
            if (existingTripIndex >= 0) {
                // Update existing trip with broader time range
                const existingTrip = aircraft.trips[existingTripIndex];
                const placementStart = new Date(placement.start_time);
                const placementEnd = new Date(placement.end_time);
                // Expand the time range to include this placement
                if (placementStart < existingTrip.start) existingTrip.start = placementStart;
                if (placementEnd > existingTrip.end) existingTrip.end = placementEnd;
                // Update location if this placement is more relevant (e.g., matches current time)
                const now = currentTime.getTime();
                const placementStartTime = placementStart.getTime();
                const placementEndTime = placementEnd.getTime();
                if (placementStartTime <= now && placementEndTime >= now) {
                    // This placement is current, use its location
                    existingTrip.locationId = placement.hangar_id || placement.ramp_id || "";
                    existingTrip.locationType = placement.hangar_id ? "hangar" : "ramp";
                    existingTrip.locationName = placement.location_name;
                }
                // Always update status from the placement
                if (placement.status) existingTrip.status = placement.status;
            } else // Add as new trip
            aircraft.trips.push({
                tripId: placement.trip_id,
                start: new Date(placement.start_time),
                end: new Date(placement.end_time),
                locationId: placement.hangar_id || placement.ramp_id || "",
                locationType: placement.hangar_id ? "hangar" : "ramp",
                locationName: placement.location_name,
                status: placement.status
            });
            // Check if currently at this location (exclude cancelled trips)
            const now = currentTime.getTime();
            const startTime = new Date(placement.start_time).getTime();
            const endTime = new Date(placement.end_time).getTime();
            if (startTime <= now && endTime >= now && placement.status !== "cancelled") {
                const isAtThisLocation = location.type === "hangar" && placement.hangar_id === location.id || location.type === "ramp" && placement.ramp_id === location.id;
                if (isAtThisLocation) {
                    aircraft.isCurrentlyHere = true;
                    // Find the matching tenant from the stack
                    aircraft.tenant = stack.tenants.find((t)=>t.tail_number === tailNumber);
                }
            }
        });
        // Filter based on search mode
        const allAircraft = Array.from(aircraftMap.values());
        let filteredByView = allAircraft;
        // When not searching, show only active aircraft at this location
        if (!filterText) filteredByView = allAircraft.filter((a)=>a.isCurrentlyHere);
        // When searching, show ALL aircraft (already using allPlacementsFromNow)
        // Sort alphabetically by: (1) tail number, (2) make, (3) model
        return filteredByView.sort((a, b)=>{
            // 1. Compare tail numbers (case-insensitive)
            const tailCompare = a.tailNumber.localeCompare(b.tailNumber, undefined, {
                sensitivity: "base"
            });
            if (tailCompare !== 0) return tailCompare;
            // 2. Compare makes if both exist
            if (a.aircraftMake && b.aircraftMake) {
                const makeCompare = a.aircraftMake.localeCompare(b.aircraftMake, undefined, {
                    sensitivity: "base"
                });
                if (makeCompare !== 0) return makeCompare;
            } else if (a.aircraftMake) return -1;
            else if (b.aircraftMake) return 1;
            // 3. Compare models if both exist
            if (a.aircraftModel && b.aircraftModel) return a.aircraftModel.localeCompare(b.aircraftModel, undefined, {
                sensitivity: "base"
            });
            else if (a.aircraftModel) return -1;
            else if (b.aircraftModel) return 1;
            return 0;
        });
    }, [
        placementsInRange,
        allPlacementsFromNow,
        currentTime,
        location,
        stack.tenants,
        filterText
    ]);
    // Filter aircraft based on search text and check if tail exists
    const { filteredAircraft: filteredAircraft, tailNumberExists: tailNumberExists } = $acw62.useMemo(()=>{
        if (!filterText) return {
            filteredAircraft: aircraftWithTrips,
            tailNumberExists: true
        };
        const searchText = filterText.toLowerCase().trim();
        const filtered = aircraftWithTrips.filter((aircraft)=>aircraft.tailNumber.toLowerCase().includes(searchText));
        // Check for exact match to determine if tail number exists
        const exactMatch = aircraftWithTrips.some((aircraft)=>aircraft.tailNumber.toLowerCase() === searchText || aircraft.tailNumber.toLowerCase() === "n" + searchText);
        return {
            filteredAircraft: filtered,
            tailNumberExists: exactMatch || filtered.length > 0
        };
    }, [
        aircraftWithTrips,
        filterText
    ]);
    const onAddAircraft = $acw62.useCallback((tenant)=>{
        if (Array.isArray(tenant)) {
            setStack({
                ...stack,
                tenants: [
                    ...tenant,
                    ...stack.tenants
                ]
            });
            return;
        }
        setStack({
            ...stack,
            tenants: [
                tenant,
                ...stack.tenants
            ]
        });
    }, [
        stack,
        setStack
    ]);
    const setTenant = $acw62.useCallback((tenant)=>{
        setStack({
            ...stack,
            tenants: stack.tenants.map((t)=>t.id === tenant.id ? tenant : t)
        });
    }, [
        stack,
        setStack
    ]);
    const onDeleteAircraft = $acw62.useCallback((tenant)=>{
        setStack({
            ...stack,
            tenants: stack.tenants.filter((t)=>t.placement_id !== tenant.placement_id)
        });
    }, [
        stack,
        setStack
    ]);
    const onSelectAircraft = $acw62.useCallback((tenant)=>{
        setStack({
            ...stack,
            tenants: stack.tenants.map((t)=>({
                    ...t,
                    selected: t.placement_id === tenant.placement_id ? !t.selected : false
                }))
        });
    }, [
        stack,
        setStack
    ]);
    // Calculate total aircraft count
    const totalAircraft = aircraftWithTrips.length;
    const currentlyHereCount = aircraftWithTrips.filter((a)=>a.isCurrentlyHere).length;
    const filteredHereCount = filteredAircraft.filter((a)=>a.isCurrentlyHere).length;
    // Handle create trip for non-existent tail number
    const handleCreateTripClick = $acw62.useCallback(()=>{
        // Normalize the tail number (add 'N' prefix if not present)
        const normalizedTail = filterText.toUpperCase().startsWith("N") ? filterText.toUpperCase() : "N" + filterText.toUpperCase();
        setPrefilledTailNumber(normalizedTail);
        setCreateTripKey((prev)=>prev + 1); // Force dialog remount
        setShowCreateTrip(true);
    }, [
        filterText
    ]);
    const handleTripCreated = $acw62.useCallback(()=>{
        // Refresh the view after trip creation
        if (onRefresh) onRefresh();
        setShowCreateTrip(false);
        setFilterText("");
    }, [
        onRefresh
    ]);
    // Calculate spot for a tenant based on current position
    const calculateSpotForTenant = $acw62.useCallback((tenant)=>{
        if (!rampShapes || !rampDepth || !tenant.position) return undefined;
        // Filter for spot shapes only
        const spotShapes = rampShapes.filter((shape)=>shape.type === "Spot");
        if (spotShapes.length === 0) return undefined;
        // Build a map of legacy spots to their shape IDs
        const shapeIdMap = new Map();
        // Convert spot shapes to LegacySpot format
        const legacySpots = spotShapes.filter((shape)=>shape.reference_points && shape.reference_points.length > 0).map((shape)=>{
            const legacySpot = {
                points: shape.points,
                referencePoints: shape.reference_points
            };
            shapeIdMap.set(legacySpot, shape.id);
            return legacySpot;
        });
        if (legacySpots.length === 0) return undefined;
        // In ScheduledRampView, tenant positions come from database placements
        // which use Y-flipped coordinates (origin at top-left)
        // Spot shapes use non-flipped coordinates (origin at bottom-left)
        // Apply Y-flip transformation to match coordinate systems
        const position = {
            x: tenant.position.x,
            y: rampDepth - tenant.position.y,
            angle: tenant.position.angle
        };
        // Call getSpotForPositionLegacy
        try {
            const result = (0, $jYWTx.getSpotForPositionLegacy)(tenant, position, legacySpots);
            if (!result) return undefined;
            // Get the shape ID from the map
            const shapeId = shapeIdMap.get(result.spot);
            if (!shapeId) return undefined;
            // Find and return the matching shape
            return spotShapes.find((shape)=>shape.id === shapeId);
        } catch (error) {
            console.error("Error detecting spot for tenant:", error);
            return undefined;
        }
    }, [
        rampShapes,
        rampDepth
    ]);
    if (!isDrawerOpen) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        spacing: 2,
        sx: {
            width: "100%",
            height: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ORjT.AddTenantButton), {
                iconButton: true,
                disabled: readOnly,
                onAdd: onAddAircraft,
                location: location,
                sendToLocation: sendToLocation,
                stack: stack,
                setStack: setStack,
                feetToPixels: feetToPixels,
                disableAutoOpen: disableAutoOpen,
                isScheduledView: isScheduledView,
                onAddTrip: onAddTrip,
                currentTime: currentTime
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "caption",
                sx: {
                    color: theme.palette.primary.main
                },
                children: filterText ? `${filteredAircraft.length} of ${totalAircraft}` : `${totalAircraft} aircraft`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                size: "small",
                placeholder: "Filter...",
                value: filterText,
                onChange: (e)=>setFilterText(e.target.value),
                sx: {
                    width: "90%",
                    "& .MuiInputBase-input": {
                        fontSize: "0.75rem",
                        py: 0.5
                    }
                },
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                        position: "start",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {
                            sx: {
                                fontSize: "1rem"
                            }
                        })
                    }),
                    endAdornment: filterText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                        position: "end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            size: "small",
                            onClick: ()=>setFilterText(""),
                            sx: {
                                p: 0
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jO6ya))), {
                                sx: {
                                    fontSize: "1rem"
                                }
                            })
                        })
                    })
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                flexItem: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                alignItems: "center",
                sx: {
                    overflowY: "scroll",
                    overflowX: "hidden",
                    width: "100%",
                    ...(0, $lNEp2.scrollSx)
                },
                children: filteredAircraft.map((aircraft, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            width: "100%",
                            p: 0.5,
                            cursor: "pointer",
                            bgcolor: aircraft.tenant?.selected ? `${theme.palette.success.main}15` : aircraft.isCurrentlyHere ? `${theme.palette.primary.main}08` : "transparent",
                            "&:hover": {
                                backgroundColor: `${theme.palette.success.main}15`
                            }
                        },
                        onClick: ()=>aircraft.tenant && onSelectAircraft(aircraft.tenant),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                noWrap: true,
                                sx: {
                                    fontWeight: aircraft.isCurrentlyHere ? 600 : 400,
                                    color: aircraft.isCurrentlyHere ? theme.palette.primary.main : "inherit"
                                },
                                children: aircraft.tailNumber.substring(0, 6)
                            }),
                            aircraft.trips.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                sx: {
                                    ml: 0.5,
                                    fontSize: "0.65rem",
                                    color: theme.palette.text.secondary
                                },
                                children: [
                                    "(",
                                    aircraft.trips.length,
                                    ")"
                                ]
                            })
                        ]
                    }, `timeline-aircraft-${aircraft.tailNumber}-${idx}`))
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 2,
                sx: {
                    minWidth: width ?? 400,
                    height: "100%",
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        sx: {
                            px: 1.5,
                            py: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: "Timeline Aircraft"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "caption",
                                        sx: {
                                            color: theme.palette.text.secondary
                                        },
                                        children: filterText ? `(${filteredAircraft.length} of ${totalAircraft} \u{2022} ${filteredHereCount} here)` : `(${totalAircraft} total \u{2022} ${currentlyHereCount} here)`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ORjT.AddTenantButton), {
                                disabled: readOnly,
                                onAdd: onAddAircraft,
                                location: location,
                                sendToLocation: sendToLocation,
                                stack: stack,
                                setStack: setStack,
                                feetToPixels: feetToPixels,
                                isScheduledView: isScheduledView,
                                onAddTrip: onAddTrip,
                                currentTime: currentTime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            px: 1.5,
                            pb: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            fullWidth: true,
                            size: "small",
                            placeholder: "Search tail number across all trips...",
                            value: filterText,
                            onChange: (e)=>setFilterText(e.target.value),
                            InputProps: {
                                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                    position: "start",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                                }),
                                endAdornment: filterText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                    position: "end",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        size: "small",
                                        onClick: ()=>setFilterText(""),
                                        edge: "end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jO6ya))), {})
                                    })
                                })
                            }
                        })
                    }),
                    filterText && !tailNumberExists && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            px: 1.5,
                            pb: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            alignItems: "center",
                            spacing: 1,
                            sx: {
                                p: 2,
                                bgcolor: theme.palette.action.hover,
                                borderRadius: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    sx: {
                                        color: theme.palette.text.secondary
                                    },
                                    children: [
                                        'No aircraft found with tail number "',
                                        filterText.toUpperCase(),
                                        '"'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    size: "small",
                                    variant: "contained",
                                    color: "primary",
                                    onClick: handleCreateTripClick,
                                    children: "Create New Trip"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            flex: 1,
                            height: "100%",
                            width: "100%",
                            overflowY: "scroll",
                            overflowX: "hidden",
                            ...(0, $lNEp2.scrollSx)
                        },
                        children: filteredAircraft.map((aircraft, idx)=>{
                            // Find current placement for this aircraft (if HERE NOW)
                            const currentPlacement = aircraft.isCurrentlyHere ? placementsInRange.find((p)=>p.tail_number === aircraft.tailNumber && new Date(p.start_time).getTime() <= currentTime.getTime() && new Date(p.end_time).getTime() >= currentTime.getTime() && (location.type === "ramp" && p.ramp_id === location.id || location.type === "hangar" && p.hangar_id === location.id)) : undefined;
                            // Calculate spot from current tenant position
                            const calculatedSpot = aircraft.tenant ? calculateSpotForTenant(aircraft.tenant) : undefined;
                            // Merge calculated spot into placement (override database spot with live calculation)
                            const enhancedPlacement = currentPlacement ? {
                                ...currentPlacement,
                                spot: calculatedSpot
                            } : undefined;
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eGvtx.TimelineAircraftListItem), {
                                    aircraft: aircraft,
                                    tenant: aircraft.tenant,
                                    stack: stack,
                                    setStack: setStack,
                                    setTenant: setTenant,
                                    onSelectAircraft: onSelectAircraft,
                                    onDeleteAircraft: onDeleteAircraft,
                                    showBottomBorder: idx + 1 === filteredAircraft.length,
                                    rangeStart: rangeStart,
                                    rangeEnd: rangeEnd,
                                    currentTime: currentTime,
                                    location: location,
                                    onRefresh: onRefresh,
                                    onTimeChange: onTimeChange,
                                    onNavigateToLocation: onNavigateToLocation,
                                    currentPlacement: enhancedPlacement
                                })
                            }, `timeline-aircraft-${aircraft.tailNumber}-${idx}`);
                        })
                    })
                ]
            }),
            showCreateTrip && /*#__PURE__*/ (0, $ayMG0.jsx)($d118f0c966764588$var$CreateTripDialogWrapper, {
                open: showCreateTrip,
                onClose: ()=>{
                    setShowCreateTrip(false);
                    setPrefilledTailNumber("");
                },
                onSuccess: handleTripCreated,
                initialArrivalDate: currentTime,
                currentLocationId: location.id,
                currentLocationType: location.type,
                prefilledTailNumber: prefilledTailNumber
            }, createTripKey)
        ]
    });
};

});
parcelRegister("eGvtx", function(module, exports) {

$parcel$export(module.exports, "TimelineAircraftListItem", () => $256c1447aa1a4ee5$export$c38d960444ef20a5);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $cSDx2 = parcelRequire("cSDx2");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $auxXs = parcelRequire("auxXs");

var $16TXW = parcelRequire("16TXW");

var $dVik7 = parcelRequire("dVik7");
const $256c1447aa1a4ee5$export$c38d960444ef20a5 = ({ aircraft: aircraft, tenant: tenant, stack: stack, setStack: setStack, setTenant: setTenant, onSelectAircraft: onSelectAircraft, onDeleteAircraft: onDeleteAircraft, showBottomBorder: showBottomBorder, rangeStart: rangeStart, rangeEnd: rangeEnd, currentTime: currentTime, location: location, onAircraftClick: onAircraftClick, onRefresh: onRefresh, onTimeChange: onTimeChange, onNavigateToLocation: onNavigateToLocation, currentPlacement: currentPlacement })=>{
    const theme = (0, $14H9o.default)();
    const [expanded, setExpanded] = $acw62.useState(false);
    // Dialog state for navigation
    const [navigationDialog, setNavigationDialog] = $acw62.useState({
        open: false,
        targetLocation: {
            id: '',
            name: '',
            type: 'unassigned'
        },
        tripInfo: {
            tailNumber: '',
            startTime: new Date(),
            endTime: new Date()
        }
    });
    // Check if any trip is cancelled
    const hasCancelledTrip = aircraft.trips.some((trip)=>trip.status === 'cancelled');
    // Determine display color based on state
    const displayColor = hasCancelledTrip ? '#F44336' // Red for cancelled
     : aircraft.isCurrentlyHere ? theme.palette.primary.main : theme.palette.text.secondary;
    // Get current location info with enhanced status
    const locationStatus = $acw62.useMemo(()=>{
        const now = currentTime.getTime();
        const currentTrip = aircraft.trips.find((trip)=>{
            const start = trip.start.getTime();
            const end = trip.end.getTime();
            return start <= now && end >= now;
        });
        if (currentTrip) {
            // Check if cancelled first
            if (currentTrip.status === 'cancelled') return {
                text: 'CANCELLED',
                color: 'error',
                variant: 'filled'
            };
            if (currentTrip.locationId === location.id) return {
                text: 'HERE',
                color: 'success',
                variant: 'filled'
            };
            else if (currentTrip.locationName) {
                // Handle "Unassigned" location name from database
                if (currentTrip.locationName === "Unassigned" || !currentTrip.locationId) return {
                    text: 'UNASSIGNED',
                    color: 'warning',
                    variant: 'outlined'
                };
                return {
                    text: `AT ${currentTrip.locationName.toUpperCase()}`,
                    color: 'default',
                    variant: 'outlined'
                };
            } else if (!currentTrip.locationId) // No location ID means unassigned
            return {
                text: 'UNASSIGNED',
                color: 'warning',
                variant: 'outlined'
            };
        }
        // Find next arrival
        const nextTrip = aircraft.trips.filter((trip)=>trip.start.getTime() > now).sort((a, b)=>a.start.getTime() - b.start.getTime())[0];
        if (nextTrip) {
            const hoursUntil = Math.floor((nextTrip.start.getTime() - now) / 3600000);
            if (hoursUntil < 24) return {
                text: `ARRIVES IN ${hoursUntil}H`,
                color: 'info',
                variant: 'outlined'
            };
            else {
                const daysUntil = Math.floor(hoursUntil / 24);
                return {
                    text: `ARRIVES IN ${daysUntil}D`,
                    color: 'default',
                    variant: 'outlined'
                };
            }
        }
        return null;
    }, [
        aircraft.trips,
        currentTime,
        location.id
    ]);
    // Format aircraft info
    const aircraftInfo = $acw62.useMemo(()=>{
        if (aircraft.aircraftModel) return aircraft.aircraftModel;
        if (aircraft.aircraftMake) return aircraft.aircraftMake;
        return "Unknown Aircraft";
    }, [
        aircraft.aircraftModel,
        aircraft.aircraftMake
    ]);
    // Get smart trip summary
    const tripSummary = $acw62.useMemo(()=>{
        if (aircraft.trips.length === 0) return null;
        const sortedTrips = [
            ...aircraft.trips
        ].sort((a, b)=>a.start.getTime() - b.start.getTime());
        const formatDateCompact = (date)=>{
            return date.toLocaleDateString(undefined, {
                month: 'short',
                day: 'numeric'
            });
        };
        const formatDateRange = (start, end)=>{
            const startStr = formatDateCompact(start);
            const endStr = formatDateCompact(end);
            if (startStr === endStr) return startStr;
            const startMonth = start.toLocaleDateString(undefined, {
                month: 'short'
            });
            const endMonth = end.toLocaleDateString(undefined, {
                month: 'short'
            });
            if (startMonth === endMonth) return `${startMonth} ${start.getDate()}-${end.getDate()}`;
            return `${startStr}-${endStr}`;
        };
        // Get unique locations
        const uniqueLocations = new Set(sortedTrips.map((t)=>t.locationName || `${t.locationType} ${t.locationId}`));
        // Get overall date range
        const firstTrip = sortedTrips[0];
        const lastTrip = sortedTrips[sortedTrips.length - 1];
        const overallDateRange = formatDateRange(firstTrip.start, lastTrip.end);
        // Determine location text
        let locationText = '';
        if (uniqueLocations.size === 1) locationText = Array.from(uniqueLocations)[0];
        else locationText = `${uniqueLocations.size} locations`;
        // For 1-2 trips, return individual trips for inline display
        if (sortedTrips.length <= 2) return {
            type: 'inline',
            trips: sortedTrips.map((trip)=>({
                    trip: trip,
                    text: `${formatDateRange(trip.start, trip.end)} @ ${trip.locationName || `${trip.locationType} ${trip.locationId}`}`,
                    isHere: trip.locationId === location.id,
                    isCancelled: trip.status === 'cancelled'
                }))
        };
        // For 3+ trips, return summary
        return {
            type: 'summary',
            summaryText: `${sortedTrips.length} trips: ${overallDateRange} @ ${locationText}`,
            trips: sortedTrips.map((trip)=>({
                    trip: trip,
                    text: `${formatDateRange(trip.start, trip.end)} @ ${trip.locationName || `${trip.locationType} ${trip.locationId}`}`,
                    isHere: trip.locationId === location.id,
                    isCancelled: trip.status === 'cancelled'
                })),
            firstTrip: sortedTrips[0],
            isAnyHere: sortedTrips.some((t)=>t.locationId === location.id)
        };
    }, [
        aircraft.trips,
        location.id
    ]);
    // Get spot name from placement data (calculated at data source)
    const currentSpotName = currentPlacement?.spot?.text;
    const isSelectable = !!tenant;
    const isSelected = tenant?.selected || false;
    // Handle trip click with location check
    const handleTripClick = $acw62.useCallback((trip, e)=>{
        e.stopPropagation();
        // Check if trip is at a different location than current view
        const isDifferentLocation = trip.locationId !== location.id;
        const isUnassigned = !trip.locationId || trip.locationType === 'unassigned';
        if (isDifferentLocation || isUnassigned) // Show navigation dialog
        setNavigationDialog({
            open: true,
            targetLocation: {
                id: trip.locationId || '',
                name: trip.locationName || 'Unassigned',
                type: isUnassigned ? 'unassigned' : trip.locationType
            },
            tripInfo: {
                tailNumber: aircraft.tailNumber,
                startTime: trip.start,
                endTime: trip.end
            }
        });
        else // Same location, just jump to time
        onTimeChange?.(trip.start);
    }, [
        location.id,
        aircraft.tailNumber,
        onTimeChange
    ]);
    // Add state for menu anchor to programmatically open menu
    const menuButtonRef = $acw62.useRef(null);
    const handleClick = ()=>{
        // If aircraft is currently here and has a tenant, toggle selection
        if (isSelectable && tenant) onSelectAircraft(tenant);
        else // For aircraft not currently here, trigger the action menu click
        // This makes the entire row interactive
        menuButtonRef.current?.click();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            borderBottom: !showBottomBorder ? 1 : 0,
            borderColor: "divider",
            bgcolor: isSelected ? `${theme.palette.success.main}15` : aircraft.isCurrentlyHere ? `${theme.palette.primary.main}05` : "transparent",
            "&:hover": {
                backgroundColor: isSelected ? `${theme.palette.success.main}20` : `${theme.palette.action.hover}`
            },
            transition: "background-color 0.2s",
            display: "flex",
            alignItems: "stretch"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cSDx2.default), {
                onClick: handleClick,
                sx: {
                    flex: 1,
                    p: 0,
                    "&:hover": {
                        backgroundColor: "transparent" // Handled by parent Box
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 0.25,
                    sx: {
                        flex: 1,
                        p: 1,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            sx: {
                                width: '100%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 1,
                                    sx: {
                                        flex: 1,
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                fontWeight: aircraft.isCurrentlyHere ? 600 : 500,
                                                color: displayColor
                                            },
                                            children: aircraft.tailNumber
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                color: theme.palette.text.secondary
                                            },
                                            noWrap: true,
                                            children: aircraftInfo
                                        })
                                    ]
                                }),
                                locationStatus && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: locationStatus.text === 'HERE' ? 'HERE NOW' : locationStatus.text,
                                    color: locationStatus.color,
                                    variant: locationStatus.variant,
                                    size: "small",
                                    sx: {
                                        height: 20,
                                        fontSize: '0.7rem',
                                        fontWeight: 600,
                                        '& .MuiChip-label': {
                                            px: 0.75
                                        }
                                    }
                                }),
                                locationStatus?.text === 'HERE' && currentSpotName && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: currentSpotName,
                                    variant: "outlined",
                                    size: "small",
                                    sx: {
                                        height: 20,
                                        fontSize: '0.7rem',
                                        fontWeight: 500,
                                        borderColor: theme.palette.primary.main,
                                        color: theme.palette.primary.main,
                                        '& .MuiChip-label': {
                                            px: 0.75
                                        }
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16TXW.TripIndicator), {
                            trips: aircraft.trips,
                            rangeStart: rangeStart,
                            rangeEnd: rangeEnd,
                            currentTime: currentTime,
                            currentLocationId: location.id,
                            onTimeChange: (time)=>{
                                // For now, TripIndicator just jumps to time
                                // Could be enhanced to also check location
                                onTimeChange?.(time);
                            }
                        }),
                        tripSummary && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: tripSummary.type === 'inline' ? // For 1-2 trips, show inline
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                direction: "row",
                                alignItems: "center",
                                spacing: 0.5,
                                flexWrap: "wrap",
                                children: tripSummary.trips.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                onClick: (e)=>handleTripClick(item.trip, e),
                                                sx: {
                                                    fontSize: '0.75rem',
                                                    color: item.isCancelled ? 'error.main' : item.isHere ? 'text.primary' : 'text.secondary',
                                                    textDecoration: item.isCancelled ? 'line-through' : 'none',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        textDecoration: 'underline'
                                                    }
                                                },
                                                children: item.text
                                            }),
                                            idx < tripSummary.trips.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                sx: {
                                                    fontSize: '0.75rem',
                                                    color: 'text.secondary'
                                                },
                                                children: ","
                                            })
                                        ]
                                    }, `inline-${aircraft.tailNumber}-${idx}`))
                            }) : // For 3+ trips, show summary with expansion
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 0.25,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        alignItems: "center",
                                        spacing: 0.5,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                sx: {
                                                    fontSize: '0.75rem',
                                                    color: tripSummary.isAnyHere ? 'text.primary' : 'text.secondary'
                                                },
                                                children: tripSummary.summaryText
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    setExpanded(!expanded);
                                                },
                                                sx: {
                                                    fontSize: '0.7rem',
                                                    color: 'primary.main',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        textDecoration: 'underline'
                                                    }
                                                },
                                                children: expanded ? 'show less' : 'show all'
                                            })
                                        ]
                                    }),
                                    expanded && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                        spacing: 0,
                                        sx: {
                                            pl: 1
                                        },
                                        children: tripSummary.trips.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                onClick: (e)=>handleTripClick(item.trip, e),
                                                sx: {
                                                    fontSize: '0.7rem',
                                                    color: item.isCancelled ? 'error.main' : item.isHere ? 'success.main' : 'text.secondary',
                                                    textDecoration: item.isCancelled ? 'line-through' : 'none',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        textDecoration: 'underline'
                                                    }
                                                },
                                                children: [
                                                    "\u2022 ",
                                                    item.text
                                                ]
                                            }, `expanded-${aircraft.tailNumber}-${idx}`))
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    pr: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $auxXs.AircraftActionMenu), {
                    aircraft: aircraft,
                    currentLocation: location,
                    currentTime: currentTime,
                    onRefresh: onRefresh || (()=>{}),
                    onTimeChange: onTimeChange || (()=>{})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dVik7.TripLocationNavigationDialog), {
                open: navigationDialog.open,
                onClose: ()=>setNavigationDialog({
                        ...navigationDialog,
                        open: false
                    }),
                currentLocation: {
                    id: location.id,
                    name: location.name || 'Unknown',
                    type: location.type
                },
                targetLocation: navigationDialog.targetLocation,
                tripInfo: navigationDialog.tripInfo,
                onNavigateToLocation: onNavigateToLocation || (()=>{}),
                onStayCurrentLocation: (time)=>{
                    onTimeChange?.(time);
                    setNavigationDialog({
                        ...navigationDialog,
                        open: false
                    });
                }
            })
        ]
    });
};

});
parcelRegister("auxXs", function(module, exports) {

$parcel$export(module.exports, "AircraftActionMenu", () => $02b9d66648d9b32e$export$a30dd8ddc704b880);

var $ayMG0 = parcelRequire("ayMG0");

var $ltk0t = parcelRequire("ltk0t");

var $kT7QH = parcelRequire("kT7QH");

var $ap4xJ = parcelRequire("ap4xJ");

var $4D8ul = parcelRequire("4D8ul");

var $63MTG = parcelRequire("63MTG");

var $2cPwN = parcelRequire("2cPwN");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $bjZRT = parcelRequire("bjZRT");
var $19ocJ = parcelRequire("19ocJ");
var $4F5tJ = parcelRequire("4F5tJ");
var $2iAqv = parcelRequire("2iAqv");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");

var $a7gZr = parcelRequire("a7gZr");

var $lQ8IB = parcelRequire("lQ8IB");

var $6RcbS = parcelRequire("6RcbS");

var $55RUj = parcelRequire("55RUj");

var $ZD2ym = parcelRequire("ZD2ym");
const $02b9d66648d9b32e$export$a30dd8ddc704b880 = /*#__PURE__*/ $acw62.forwardRef(({ aircraft: aircraft, currentLocation: currentLocation, currentTime: currentTime, onRefresh: onRefresh, onTimeChange: onTimeChange }, ref)=>{
    const navigate = (0, $aphAM.useNavigate)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [jumpToMenuAnchor, setJumpToMenuAnchor] = $acw62.useState(null);
    const [isMoving, setIsMoving] = $acw62.useState(false);
    const [viewTripsOpen, setViewTripsOpen] = $acw62.useState(false);
    const [aircraftTrips, setAircraftTrips] = $acw62.useState([]);
    const [selectedTrip, setSelectedTrip] = $acw62.useState(null);
    const [tripsLoading, setTripsLoading] = $acw62.useState(false);
    const open = Boolean(anchorEl);
    const jumpToMenuOpen = Boolean(jumpToMenuAnchor);
    const handleClick = (event)=>{
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
        setJumpToMenuAnchor(null);
    };
    // Get trips at current location
    const tripsAtCurrentLocation = $acw62.useMemo(()=>{
        return aircraft.trips.filter((trip)=>trip.locationId === currentLocation.id).sort((a, b)=>a.start.getTime() - b.start.getTime());
    }, [
        aircraft.trips,
        currentLocation.id
    ]);
    // Get trips at other locations
    const tripsAtOtherLocations = $acw62.useMemo(()=>{
        const locationMap = new Map();
        aircraft.trips.filter((trip)=>{
            // Include unassigned trips (empty locationId) as "other locations"
            // Also include trips at locations other than current
            return !trip.locationId || trip.locationId !== currentLocation.id;
        }).forEach((trip)=>{
            // Use a special key for unassigned trips
            const key = trip.locationId ? `${trip.locationType}-${trip.locationId}` : 'unassigned';
            if (!locationMap.has(key)) locationMap.set(key, []);
            locationMap.get(key).push(trip);
        });
        return Array.from(locationMap.entries()).map(([key, trips])=>({
                locationKey: key,
                locationId: trips[0].locationId,
                locationType: trips[0].locationType,
                locationName: !trips[0].locationId || trips[0].locationName === "Unassigned" ? "Unassigned" : trips[0].locationName || "Unknown Location",
                trips: trips.sort((a, b)=>a.start.getTime() - b.start.getTime())
            }));
    }, [
        aircraft.trips,
        currentLocation.id
    ]);
    // Get current or next upcoming trip
    const currentOrNextTrip = $acw62.useMemo(()=>{
        const now = currentTime.getTime();
        // First check for current trip
        const currentTrip = aircraft.trips.find((trip)=>trip.start.getTime() <= now && trip.end.getTime() > now);
        if (currentTrip) return {
            trip: currentTrip,
            isCurrent: true
        };
        // If no current trip, find the next upcoming one
        const futureTrips = aircraft.trips.filter((trip)=>trip.start.getTime() > now).sort((a, b)=>a.start.getTime() - b.start.getTime());
        if (futureTrips.length > 0) return {
            trip: futureTrips[0],
            isCurrent: false
        };
        return null;
    }, [
        aircraft.trips,
        currentTime
    ]);
    const formatTime = (date)=>{
        const now = new Date();
        const diff = date.getTime() - now.getTime();
        const hours = Math.floor(Math.abs(diff) / 3600000);
        const days = Math.floor(hours / 24);
        // Format time
        const timeStr = date.toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit"
        });
        // Add relative time
        if (days === 0 && date.toDateString() === now.toDateString()) return `Today at ${timeStr}`;
        else if (days === 1) return `Tomorrow at ${timeStr}`;
        else if (days === -1) return `Yesterday at ${timeStr}`;
        else if (days > 1 && days < 7) return `In ${days} days at ${timeStr}`;
        else return date.toLocaleDateString(undefined, {
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };
    const handleJumpToTime = (trip)=>{
        // Pass the exact trip start time - the URL hook will handle proper snapping
        onTimeChange(trip.start);
        handleClose();
    };
    const handleNavigateToLocation = (locationId, locationType, time)=>{
        const path = locationType === "hangar" ? `/hangars/${locationId}/schedule` : `/ramps/${locationId}/schedule`;
        // Pass the exact time - the destination route will handle proper snapping
        const timeParam = time.toISOString();
        navigate(`${path}?t=${timeParam}`);
        handleClose();
    };
    const handleAssignEntireTrip = async ()=>{
        if (!currentOrNextTrip || !postgrest || !activeFBO?.id) {
            snackbar.notify({
                text: "No active or upcoming trip found for this aircraft",
                severity: "warning"
            });
            return;
        }
        setIsMoving(true);
        try {
            const { trip: trip } = currentOrNextTrip;
            // First, get the full trip data to get actual arrival/departure dates
            const tripService = new (0, $lQ8IB.TripService)(postgrest);
            const trips = await tripService.getTripsByTailNumber(activeFBO.id, aircraft.tailNumber);
            const fullTrip = trips.find((t)=>t.trip_id === trip.tripId);
            if (!fullTrip) throw new Error("Could not find trip details");
            // Use rebuildTripCoverage to assign the entire trip to this location
            const placementService = new (0, $a7gZr.PlacementService)(postgrest);
            await placementService.rebuildTripCoverage(trip.tripId, [
                {
                    start_time: fullTrip.arrival_date,
                    end_time: fullTrip.departure_date,
                    hangar_id: currentLocation.type === 'hangar' ? currentLocation.id : null,
                    ramp_id: currentLocation.type === 'ramp' ? currentLocation.id : null,
                    x: null,
                    y: null,
                    angle: null
                }
            ]);
            snackbar.notify({
                text: `${aircraft.tailNumber} assigned to ${currentLocation.name} for entire trip`,
                severity: "success"
            });
            // Trigger refresh with delay to ensure DB has updated
            setTimeout(()=>{
                onRefresh();
            }, 500);
            handleClose();
        } catch (error) {
            console.error("Failed to assign entire trip:", error);
            snackbar.notify({
                text: error.message || "Failed to assign entire trip",
                severity: "error"
            });
        } finally{
            setIsMoving(false);
        }
    };
    const handleAssignHere = async ()=>{
        if (!currentOrNextTrip || !postgrest) {
            snackbar.notify({
                text: "No active or upcoming trip found for this aircraft",
                severity: "warning"
            });
            return;
        }
        setIsMoving(true);
        try {
            const placementService = new (0, $a7gZr.PlacementService)(postgrest);
            const { trip: trip, isCurrent: isCurrent } = currentOrNextTrip;
            // If it's a future trip, assign from its start time
            // If it's current, assign from current time
            // Always floor to quarter hour for proper alignment
            const assignFromTime = isCurrent ? (0, $55RUj.floorToQuarterHour)(currentTime) : (0, $55RUj.floorToQuarterHour)(trip.start);
            await placementService.assignToLocationWithGapFilling(trip.tripId, currentLocation.id, currentLocation.type, assignFromTime.toISOString(), undefined, // to trip end
            true, // exclude conflicts
            {
                x: null,
                y: null,
                angle: null
            } // clear position
            );
            snackbar.notify({
                text: `${aircraft.tailNumber} assigned to ${currentLocation.name}`,
                severity: "success"
            });
            // Trigger refresh with delay to ensure DB has updated
            setTimeout(()=>{
                onRefresh();
            }, 500);
            handleClose();
        } catch (error) {
            console.error("Failed to move aircraft:", error);
            snackbar.notify({
                text: error.message || "Failed to assign aircraft",
                severity: "error"
            });
        } finally{
            setIsMoving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                ref: ref,
                size: "small",
                onClick: handleClick,
                disabled: isMoving,
                sx: {
                    "&:hover": {
                        backgroundColor: "action.hover",
                        "& .MuiSvgIcon-root": {
                            transform: "rotate(90deg)",
                            transition: "transform 0.2s"
                        }
                    }
                },
                children: isMoving ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                    size: 16
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4D8ul))), {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4F5tJ.default), {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                children: [
                    (tripsAtCurrentLocation.length > 0 || tripsAtOtherLocations.length > 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                onClick: (e)=>setJumpToMenuAnchor(e.currentTarget),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ltk0t))), {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                        children: "Jump to..."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kT7QH))), {
                                        fontSize: "small"
                                    })
                                ]
                            }),
                            !aircraft.isCurrentlyHere && currentOrNextTrip && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
                        ]
                    }),
                    !aircraft.isCurrentlyHere && currentOrNextTrip && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                onClick: handleAssignHere,
                                disabled: isMoving,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($63MTG))), {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                        children: "Assign Here"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                onClick: handleAssignEntireTrip,
                                disabled: isMoving,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($63MTG))), {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                        children: "Assign Here (Entire Trip)"
                                    })
                                ]
                            })
                        ]
                    }),
                    (tripsAtCurrentLocation.length > 0 || tripsAtOtherLocations.length > 0 || !aircraft.isCurrentlyHere && currentOrNextTrip) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                        onClick: async ()=>{
                            if (!activeFBO?.id || !aircraft.tailNumber) return;
                            setTripsLoading(true);
                            try {
                                const tripService = new (0, $lQ8IB.TripService)(postgrest);
                                const trips = await tripService.getTripsByTailNumber(activeFBO.id, aircraft.tailNumber);
                                setAircraftTrips(trips);
                                // Find the current trip if any
                                const now = currentTime.getTime();
                                const currentTripData = trips.find((t)=>{
                                    const start = new Date(t.arrival_date).getTime();
                                    const end = new Date(t.departure_date).getTime();
                                    return start <= now && end >= now;
                                });
                                if (currentTripData) setSelectedTrip(currentTripData);
                                else if (trips.length > 0) setSelectedTrip(trips[0]);
                                handleClose();
                                setViewTripsOpen(true);
                            } catch (error) {
                                console.error('Failed to fetch trips:', error);
                                snackbar.notify({
                                    text: 'Failed to load trips for this aircraft',
                                    severity: 'error'
                                });
                            } finally{
                                setTripsLoading(false);
                            }
                        },
                        disabled: tripsLoading,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                    fontSize: "small"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                children: tripsLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 14
                                }) : "View Trips"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4F5tJ.default), {
                anchorEl: jumpToMenuAnchor,
                open: jumpToMenuOpen,
                onClose: ()=>setJumpToMenuAnchor(null),
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                children: [
                    tripsAtCurrentLocation.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                disabled: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: [
                                        "\u2014 Here at ",
                                        currentLocation.name,
                                        " \u2014"
                                    ]
                                })
                            }),
                            tripsAtCurrentLocation.map((trip, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    onClick: ()=>handleJumpToTime(trip),
                                    sx: {
                                        pl: 4
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19ocJ.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                children: formatTime(trip.start)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: [
                                                    Math.round((trip.end.getTime() - trip.start.getTime()) / 3600000),
                                                    "h stay"
                                                ]
                                            })
                                        ]
                                    })
                                }, `current-${trip.tripId}-${index}`))
                        ]
                    }),
                    tripsAtCurrentLocation.length > 0 && tripsAtOtherLocations.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    tripsAtOtherLocations.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                disabled: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: "\u2014 Other Locations \u2014"
                                })
                            }),
                            tripsAtOtherLocations.map((location)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                                    children: [
                                        location.trips.slice(0, 3).map((trip, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                onClick: ()=>{
                                                    // For unassigned trips, just jump to the time
                                                    if (!trip.locationId) handleJumpToTime(trip);
                                                    else handleNavigateToLocation(trip.locationId, trip.locationType, trip.start);
                                                },
                                                sx: {
                                                    pl: 4
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        children: [
                                                            location.locationName,
                                                            ": ",
                                                            formatTime(trip.start)
                                                        ]
                                                    })
                                                })
                                            }, `other-${trip.tripId}-${index}`)),
                                        location.trips.length > 3 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                            disabled: true,
                                            sx: {
                                                pl: 4
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: [
                                                    "...and ",
                                                    location.trips.length - 3,
                                                    " more at ",
                                                    location.locationName
                                                ]
                                            })
                                        })
                                    ]
                                }, location.locationKey))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6RcbS.TripDetailsModal), {
                open: viewTripsOpen,
                trip: selectedTrip,
                trips: aircraftTrips,
                onClose: ()=>{
                    setViewTripsOpen(false);
                    setSelectedTrip(null);
                },
                onNavigate: (newTripId)=>{
                    const newTrip = aircraftTrips.find((t)=>t.trip_id === newTripId);
                    if (newTrip) setSelectedTrip(newTrip);
                },
                onTripChanged: async ()=>{
                    // Refresh trips after changes
                    if (!activeFBO?.id || !aircraft.tailNumber) return;
                    try {
                        const tripService = new (0, $lQ8IB.TripService)(postgrest);
                        const trips = await tripService.getTripsByTailNumber(activeFBO.id, aircraft.tailNumber);
                        setAircraftTrips(trips);
                    } catch (error) {
                        console.error('Failed to refresh trips:', error);
                    }
                    // Also refresh the main view
                    onRefresh();
                },
                currentTimestamp: currentTime
            })
        ]
    });
});
$02b9d66648d9b32e$export$a30dd8ddc704b880.displayName = 'AircraftActionMenu';

});
parcelRegister("63MTG", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $4698f3dc72c917f3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4698f3dc72c917f3$var$_createSvgIcon = $4698f3dc72c917f3$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4698f3dc72c917f3$var$_default = module.exports.default = (0, $4698f3dc72c917f3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 13c0-2.45 1.76-4.47 4.08-4.91l-1.49 1.5L7 11l4-4.01L7 3 5.59 4.41l1.58 1.58v.06C3.7 6.46 1 9.42 1 13c0 3.87 3.13 7 7 7h3v-2H8c-2.76 0-5-2.24-5-5m10 0v7h9v-7zm7 5h-5v-3h5zM13 4h9v7h-9z"
}), 'MoveUp');

});


parcelRegister("16TXW", function(module, exports) {

$parcel$export(module.exports, "TripIndicator", () => $e2fae9d82e42c0b8$export$51077b646fccc1a6);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");
const $e2fae9d82e42c0b8$export$51077b646fccc1a6 = ({ trips: trips, rangeStart: rangeStart, rangeEnd: rangeEnd, currentTime: currentTime, currentLocationId: currentLocationId, onTimeChange: onTimeChange })=>{
    const theme = (0, $14H9o.default)();
    // Calculate timeline segments
    const segments = $acw62.useMemo(()=>{
        const rangeStartTime = rangeStart.getTime();
        const rangeEndTime = rangeEnd.getTime();
        const rangeDuration = rangeEndTime - rangeStartTime;
        const currentTimeMs = currentTime.getTime();
        return trips.map((trip)=>{
            const tripStart = trip.start.getTime();
            const tripEnd = trip.end.getTime();
            // Skip trips completely outside the range
            if (tripEnd < rangeStartTime || tripStart > rangeEndTime) return null;
            // Calculate position and width as percentages
            const startPos = Math.max(0, (tripStart - rangeStartTime) / rangeDuration * 100);
            const endPos = Math.min(100, (tripEnd - rangeStartTime) / rangeDuration * 100);
            const width = endPos - startPos;
            // Determine color based on location and time
            const isAtThisLocation = trip.locationId === currentLocationId;
            const isCurrentlyActive = tripStart <= currentTimeMs && tripEnd >= currentTimeMs;
            const isCancelled = trip.status === 'cancelled';
            let color;
            if (isCancelled) color = 'rgba(244, 67, 54, 0.7)'; // Red for cancelled
            else if (isCurrentlyActive && isAtThisLocation) color = theme.palette.success.main; // Green for currently here
            else if (isAtThisLocation) color = theme.palette.primary.main; // Blue for scheduled here
            else color = theme.palette.grey[400]; // Gray for other locations
            return {
                tripId: trip.tripId,
                left: `${startPos}%`,
                width: `${width}%`,
                color: color,
                isActive: isCurrentlyActive,
                locationName: trip.locationName || `${trip.locationType} ${trip.locationId}`,
                start: trip.start,
                end: trip.end
            };
        }).filter((segment)=>segment !== null);
    }, [
        trips,
        rangeStart,
        rangeEnd,
        currentTime,
        currentLocationId,
        theme
    ]);
    // Calculate current time marker position
    const currentTimePosition = $acw62.useMemo(()=>{
        const rangeStartTime = rangeStart.getTime();
        const rangeEndTime = rangeEnd.getTime();
        const currentTimeMs = currentTime.getTime();
        if (currentTimeMs < rangeStartTime || currentTimeMs > rangeEndTime) return null;
        const position = (currentTimeMs - rangeStartTime) / (rangeEndTime - rangeStartTime) * 100;
        return `${position}%`;
    }, [
        rangeStart,
        rangeEnd,
        currentTime
    ]);
    // Format dates for tooltip
    const formatDate = (date)=>{
        return date.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            position: 'relative',
            width: '100%',
            height: 20,
            bgcolor: theme.palette.grey[100],
            borderRadius: 0.5,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: 'absolute',
                    top: '50%',
                    left: 0,
                    right: 0,
                    height: 4,
                    bgcolor: theme.palette.grey[200],
                    transform: 'translateY(-50%)'
                }
            }),
            segments.map((segment, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 0.5,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                sx: {
                                    fontWeight: 500
                                },
                                children: segment.locationName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                children: [
                                    formatDate(segment.start),
                                    " - ",
                                    formatDate(segment.end)
                                ]
                            })
                        ]
                    }),
                    placement: "top",
                    arrow: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        onClick: ()=>onTimeChange?.(segment.start),
                        sx: {
                            position: 'absolute',
                            top: '50%',
                            left: segment.left,
                            width: segment.width,
                            height: segment.isActive ? 10 : 8,
                            bgcolor: segment.color,
                            transform: 'translateY(-50%)',
                            borderRadius: 0.25,
                            transition: 'all 0.2s',
                            cursor: 'pointer',
                            '&:hover': {
                                height: 12,
                                zIndex: 10,
                                boxShadow: 1
                            },
                            ...segment.isActive && {
                                animation: 'pulse 2s infinite',
                                '@keyframes pulse': {
                                    '0%': {
                                        opacity: 1
                                    },
                                    '50%': {
                                        opacity: 0.7
                                    },
                                    '100%': {
                                        opacity: 1
                                    }
                                }
                            }
                        }
                    })
                }, `${segment.tripId}-${index}`)),
            currentTimePosition && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    position: 'absolute',
                    left: currentTimePosition,
                    top: 0,
                    bottom: 0,
                    width: 2,
                    bgcolor: theme.palette.error.main,
                    zIndex: 20,
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        bgcolor: theme.palette.error.main,
                        transform: 'translate(-50%, -50%)'
                    }
                }
            })
        ]
    });
};

});

parcelRegister("dVik7", function(module, exports) {

$parcel$export(module.exports, "TripLocationNavigationDialog", () => $cc5db525b3d6df44$export$af7013498c3daf23);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $haMqN = parcelRequire("haMqN");
const $cc5db525b3d6df44$export$af7013498c3daf23 = ({ open: open, onClose: onClose, currentLocation: currentLocation, targetLocation: targetLocation, tripInfo: tripInfo, onNavigateToLocation: onNavigateToLocation, onStayCurrentLocation: onStayCurrentLocation })=>{
    // Handle navigation to target location
    const handleNavigateToTarget = ()=>{
        if (targetLocation.type !== 'unassigned') onNavigateToLocation(targetLocation.id, targetLocation.type, tripInfo.startTime);
        onClose();
    };
    // Handle staying in current location but jumping to time
    const handleStayInCurrent = ()=>{
        onStayCurrentLocation(tripInfo.startTime);
        onClose();
    };
    // Handle cancel
    const handleCancel = ()=>{
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $haMqN.TripLocationNavigationDialogPresenter), {
        open: open,
        onClose: onClose,
        currentLocation: currentLocation,
        targetLocation: targetLocation,
        tripInfo: tripInfo,
        onNavigateToTarget: handleNavigateToTarget,
        onStayInCurrent: handleStayInCurrent,
        onCancel: handleCancel
    });
};

});
parcelRegister("haMqN", function(module, exports) {

$parcel$export(module.exports, "TripLocationNavigationDialogPresenter", () => $d9c1208e4f219a95$export$2f0559f0e82fa15a);

var $ayMG0 = parcelRequire("ayMG0");

var $aF8PJ = parcelRequire("aF8PJ");

var $dTjVb = parcelRequire("dTjVb");

var $ap4xJ = parcelRequire("ap4xJ");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $kfA3C = parcelRequire("kfA3C");
parcelRequire("acw62");

var $gtiLb = parcelRequire("gtiLb");

var $apzof = parcelRequire("apzof");
const $d9c1208e4f219a95$export$2f0559f0e82fa15a = ({ open: open, onClose: onClose, currentLocation: currentLocation, targetLocation: targetLocation, tripInfo: tripInfo, onNavigateToTarget: onNavigateToTarget, onStayInCurrent: onStayInCurrent, onCancel: onCancel })=>{
    // Format the date range for display
    const formatDateRange = ()=>{
        const start = (0, $kfA3C.format)(tripInfo.startTime, "MMM d");
        const end = (0, $kfA3C.format)(tripInfo.endTime, "MMM d");
        return start === end ? start : `${start} - ${end}`;
    };
    // Get appropriate icon for location type
    const getLocationIcon = (type)=>{
        switch(type){
            case 'hangar':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtiLb.HangarIcon), {
                    sx: {
                        fontSize: 20
                    }
                });
            case 'ramp':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $apzof.RampIcon), {
                    sx: {
                        fontSize: 20
                    }
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aF8PJ))), {
                    sx: {
                        fontSize: 20
                    }
                });
        }
    };
    // Check if target is unassigned
    const isUnassigned = targetLocation.type === 'unassigned';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        "aria-labelledby": "trip-location-navigation-dialog",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                id: "trip-location-navigation-dialog",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    alignItems: "center",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "h6",
                            children: "Trip at Different Location"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                sx: {
                                    mb: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body1",
                                        fontWeight: 500,
                                        children: tripInfo.tailNumber
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTjVb))), {
                                            sx: {
                                                fontSize: 16
                                            }
                                        }),
                                        label: formatDateRange(),
                                        size: "small",
                                        variant: "outlined"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                bgcolor: 'background.paper',
                                borderRadius: 1,
                                p: 2
                            },
                            children: isUnassigned ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body1",
                                        color: "warning.main",
                                        children: "This trip hasn't been assigned to a specific location yet."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: "You can view the time period when this trip is scheduled, but it doesn't have a hangar or ramp assignment."
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    mb: 0.5
                                                },
                                                children: "TRIP LOCATION"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    getLocationIcon(targetLocation.type),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body1",
                                                        fontWeight: 500,
                                                        children: targetLocation.name
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    mb: 0.5
                                                },
                                                children: "YOU'RE VIEWING"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    getLocationIcon(currentLocation.type),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body1",
                                                        children: currentLocation.name
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "body2",
                            color: "text.secondary",
                            children: isUnassigned ? "Choose whether to jump to this time period in your current view." : "Choose whether to navigate to the trip's location or stay in your current view."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                sx: {
                    px: 3,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: onCancel,
                        color: "inherit",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                        onClick: onStayInCurrent,
                        variant: "outlined",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTjVb))), {}),
                        children: [
                            "Stay in ",
                            currentLocation.name
                        ]
                    }),
                    !isUnassigned && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                        onClick: onNavigateToTarget,
                        variant: "contained",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aF8PJ))), {}),
                        autoFocus: true,
                        children: [
                            "Go to ",
                            targetLocation.name
                        ]
                    })
                ]
            })
        ]
    });
};

});




parcelRegister("48Vdb", function(module, exports) {
$parcel$export(module.exports, "RunStack", () => (parcelRequire("jmWH8")).RunStack);
parcelRequire("jmWH8");

});
parcelRegister("jmWH8", function(module, exports) {

$parcel$export(module.exports, "RunStack", () => $ba728f7af41e06b2$export$d8642658704001ac);

var $ayMG0 = parcelRequire("ayMG0");

var $78dTG = parcelRequire("78dTG");

var $ewtCw = parcelRequire("ewtCw");

var $dJDFZ = parcelRequire("dJDFZ");

var $iwiZ3 = parcelRequire("iwiZ3");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $gqehT = parcelRequire("gqehT");

var $6AlVH = parcelRequire("6AlVH");

var $fC0pb = parcelRequire("fC0pb");

var $7R9OT = parcelRequire("7R9OT");

var $b5wBz = parcelRequire("b5wBz");

var $5U03M = parcelRequire("5U03M");

var $3JLDK = parcelRequire("3JLDK");

var $78CAK = parcelRequire("78CAK");
parcelRequire("f1x1q");
var $iJtNT = parcelRequire("iJtNT");

var $eYWyk = parcelRequire("eYWyk");

var $elDPN = parcelRequire("elDPN");

var $j1m4k = parcelRequire("j1m4k");

var $8G8wE = parcelRequire("8G8wE");
const $ba728f7af41e06b2$var$ButtonAutoStack = ({ disabled: disabled, onClick: onClick, icon: icon })=>{
    const handleClick = $acw62.useCallback((e)=>{
        e.stopPropagation();
        onClick();
    }, [
        onClick
    ]);
    if (icon) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: "AutoStack",
        arrow: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
            disabled: disabled,
            onClick: handleClick,
            color: "success",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dJDFZ))), {})
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
        disabled: disabled,
        fullWidth: true,
        variant: "contained",
        color: "success",
        endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dJDFZ))), {}),
        onClick: handleClick,
        children: "AutoStack"
    });
};
const $ba728f7af41e06b2$var$ButtonResults = ({ disabled: disabled, onClick: onClick, icon: icon })=>{
    const handleClick = $acw62.useCallback((e)=>{
        e.stopPropagation();
        onClick();
    }, [
        onClick
    ]);
    if (icon) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: "Results",
        arrow: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
            disabled: disabled,
            onClick: handleClick,
            color: "primary",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78dTG))), {})
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
        fullWidth: true,
        disabled: disabled,
        variant: "contained",
        color: "primary",
        endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78dTG))), {}),
        onClick: handleClick,
        children: "Results"
    });
};
var $ba728f7af41e06b2$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["IN_PROGRESS"] = "in progress";
    Status["COMPLETE"] = "complete";
    return Status;
}({});
const $ba728f7af41e06b2$export$d8642658704001ac = ({ hangar: hangar, stacks: stacks, setStacks: setStacks, paramSet: paramSet, customPlacementOptions: customPlacementOptions, isAlgorithmTesting: isAlgorithmTesting = false, stackStrategy: stackStrategy, setStackStrategy: setStackStrategy, disabled: disabled = false, isScheduledView: isScheduledView = false })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { preferences: preferences, setPreferences: setPreferences } = (0, $fC0pb.useUserPreferences)();
    const { towingEquipments: allTowingEquipments } = (0, $6AlVH.useTowingEquipmentState)();
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const { airplxIdentity: airplxIdentity, airplxToken: airplxToken } = (0, $gqehT.useIdentity)();
    const [open, setOpen] = $acw62.useState(false);
    const [status, setStatus] = $acw62.useState();
    const [ignoreTowingEquipment, setIgnoreTowingEquipment] = $acw62.useState(false);
    const towingEquipments = allTowingEquipments.filter((t)=>t.in_use);
    const [stacksProgress, setStacksProgress] = $acw62.useState([]);
    const isOpeningRef = $acw62.useRef(false);
    const [selectedTowingEquipment, setSelectedTowingEquipment] = $acw62.useState(()=>(0, $b5wBz.getDefaultTugForLocation)(hangar.towing_equipment_id, towingEquipments));
    const [showCustomDialog, setShowCustomDialog] = $acw62.useState(false);
    const handleOpenDialog = $acw62.useCallback(()=>{
        if (isOpeningRef.current || open) return;
        isOpeningRef.current = true;
        // Set default towing equipment when dialog opens
        const defaultTug = (0, $b5wBz.getDefaultTugForLocation)(hangar.towing_equipment_id, towingEquipments);
        setSelectedTowingEquipment(defaultTug);
        setOpen(true);
        // Reset the ref after a short delay
        setTimeout(()=>{
            isOpeningRef.current = false;
        }, 100);
    }, [
        open,
        hangar.towing_equipment_id,
        towingEquipments
    ]);
    const onClickRunStack = $acw62.useCallback(async (customPlacementOptions)=>{
        (0, $7R9OT.default).track("Clicked Autostack", {
            location_name: hangar.name,
            location_type: "hangar",
            stack_strategy: stackStrategy.toString()
        });
        window.globalThis.airplxKillSwitch = 0;
        window.globalThis.airplxAborter = new AbortController();
        setStacksProgress([]);
        setStatus("in progress");
        const baseParamSet = {
            ...paramSet,
            options: {
                ...paramSet.options,
                towing_equipment_id: ignoreTowingEquipment ? null : selectedTowingEquipment?.towing_equipment_id
            }
        };
        const paramSetForType = (0, $eYWyk.makeParamSetForType)(isAlgorithmTesting ? (0, $eYWyk.StackStrategy).dev : stackStrategy, baseParamSet, customPlacementOptions, activeFBO);
        const paramsSets = (0, $eYWyk.generateDevParamSets)(paramSetForType, hangar.stack.tenants.map(({ aircraft: aircraft })=>aircraft), customPlacementOptions);
        await (0, $8G8wE.runAllParamSets)(hangar, paramsSets, (stacks)=>setStacks(stacks), (progress)=>setStacksProgress(progress), airplxIdentity, airplxToken);
        if (!window.globalThis.airplxKillSwitch || window.globalThis.airplxKillSwitch < 2) setStatus("complete");
    }, [
        open,
        setStacks,
        paramSet,
        selectedTowingEquipment,
        ignoreTowingEquipment,
        customPlacementOptions
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iJtNT.EvaluatingStackDialog), {
                open: Boolean(status),
                hangarId: hangar.id,
                isAlgorithmTesting: isAlgorithmTesting,
                status: status,
                stacks: stacks,
                progress: stacksProgress,
                onClose: ()=>setStatus(null)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                justifyContent: isDrawerOpen ? "space-between" : "space-around",
                sx: {
                    m: 0,
                    pl: 1,
                    pr: 1
                },
                children: [
                    isAlgorithmTesting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            fullWidth: true,
                            variant: "contained",
                            color: "success",
                            endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dJDFZ))), {}),
                            onClick: ()=>{
                                setOpen(false);
                                onClickRunStack(customPlacementOptions);
                            },
                            children: "AutoStack++"
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($ba728f7af41e06b2$var$ButtonAutoStack, {
                        disabled: hangar.autostacking_enabled === false || activeFBO.subscription === "standard" || hangar.id === (0, $5U03M.HOLDING_AREA_ID) || disabled || isScheduledView,
                        onClick: handleOpenDialog,
                        icon: !isDrawerOpen
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ba728f7af41e06b2$var$ButtonResults, {
                        disabled: !stacks.length,
                        onClick: ()=>setStatus("complete"),
                        icon: !isDrawerOpen
                    })
                ]
            }),
            showCustomDialog && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $78CAK.CustomStackDialog), {
                onClickRunStack: (customPlacementOptions)=>{
                    setOpen(false);
                    onClickRunStack(customPlacementOptions);
                    setShowCustomDialog(false);
                },
                onClose: ()=>{
                    setOpen(true);
                    setShowCustomDialog(false);
                    setStatus(null);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: ()=>{
                    setOpen(false);
                    setStatus(null);
                },
                maxWidth: "sm",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Select a type of Stack"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 2,
                            children: [
                                preferences.hideLockReminderAlert ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                    severity: "warning",
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ewtCw))), {
                                        fontSize: "inherit"
                                    }),
                                    onClose: ()=>{
                                        setPreferences({
                                            ...preferences,
                                            hideLockReminderAlert: true
                                        });
                                    },
                                    children: "Did you lock aircraft that you don\u2019t want to move? (eg dedicated location, already hangared)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elDPN.SelectStackStrategy), {
                                    paramSet: paramSet,
                                    stackStrategy: stackStrategy,
                                    setStackStrategy: setStackStrategy
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j1m4k.SelectTowingEquipment), {
                                    ignoreTowingEquipment: ignoreTowingEquipment,
                                    setIgnoreTowingEquipment: setIgnoreTowingEquipment,
                                    selectedTowingEquipment: selectedTowingEquipment,
                                    setSelectedTowingEquipment: setSelectedTowingEquipment,
                                    towingEquipments: towingEquipments
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setOpen(false),
                                children: "Cancel"
                            }),
                            stackStrategy === (0, $eYWyk.StackStrategy).custom ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                onClick: ()=>{
                                    setOpen(false);
                                    setShowCustomDialog(true);
                                },
                                children: "Customize Stack"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                onClick: ()=>{
                                    setOpen(false);
                                    onClickRunStack();
                                },
                                children: "Run Stack"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("b5wBz", function(module, exports) {

$parcel$export(module.exports, "getDefaultTugForLocation", () => $0feea57d4f0d4a3a$export$b497a7612e98b3f6);
function $0feea57d4f0d4a3a$export$b497a7612e98b3f6(locationTowingEquipmentId, availableTugs) {
    // Try location-specific tug first
    if (locationTowingEquipmentId) {
        const locationTug = availableTugs.find((t)=>t.towing_equipment_id === locationTowingEquipmentId);
        if (locationTug) return locationTug;
    }
    // Fall back to FBO default
    return availableTugs.find((t)=>t.is_default);
}

});

parcelRegister("f1x1q", function(module, exports) {
$parcel$export(module.exports, "EvaluatingStackDialog", () => (parcelRequire("iJtNT")).EvaluatingStackDialog);
parcelRequire("iJtNT");

});
parcelRegister("iJtNT", function(module, exports) {

$parcel$export(module.exports, "EvaluatingStackDialog", () => $d16d150300b0f4ed$export$58e7b4b5695bd28e);

var $ayMG0 = parcelRequire("ayMG0");

var $dqlTG = parcelRequire("dqlTG");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $cJu23 = parcelRequire("cJu23");
var $9Lykx = parcelRequire("9Lykx");
var $1lfQl = parcelRequire("1lfQl");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $5Jffw = parcelRequire("5Jffw");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $ggtZr = parcelRequire("ggtZr");

var $7p8YN = parcelRequire("7p8YN");

var $gZQV9 = parcelRequire("gZQV9");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $b9BFS = parcelRequire("b9BFS");

var $brzp3 = parcelRequire("brzp3");
// helper function for calculating the dimensions of one of the hangar stacks
// based on the dimensions of the hangar and the dimensions of the screen
const $d16d150300b0f4ed$var$calculateStackResultHeight = (containerDimensions, hangar)=>{
    const { width: width, height: height } = containerDimensions;
    const cellWidth = width / 2;
    const cellHeight = height / 2;
    const hangarAspectRatio = hangar.width / hangar.depth;
    if (hangar.width > hangar.depth) return Math.min(cellHeight / hangarAspectRatio, cellWidth);
    return cellHeight;
};
// helper function to check if a movable obstacle is within hangar bounds
const $d16d150300b0f4ed$var$isMovableObstacleWithinHangarBounds = (obstacle, hangar)=>{
    // Check if obstacle has valid position
    if (!obstacle.position || obstacle.position.x === null || obstacle.position.y === null) return false;
    // Check if obstacle position is within hangar dimensions
    return obstacle.position.x >= 0 && obstacle.position.x <= hangar.width && obstacle.position.y >= 0 && obstacle.position.y <= hangar.depth;
};
const $d16d150300b0f4ed$export$58e7b4b5695bd28e = (props)=>{
    const [ref, { width: containerWidth }] = (0, $5Jffw.default)();
    const { open: open, status: status, stacks: stacks, progress: progress, onClose: onClose, isAlgorithmTesting: isAlgorithmTesting = false } = props;
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const hangarState = (0, $ggtZr.useOptionalHangarState)();
    const isReference = hangarState?.isReference ?? false;
    const { isMultiHangar: isMultiHangar } = (0, $7p8YN.useMultiHangarState)();
    const { hangar: stateHangar, getHangar: getHangar, setHangar: setHangar } = (0, $gZQV9.useThisHangar)();
    const hangar = props.hangar ?? isMultiHangar ? getHangar(props.hangarId) : stateHangar;
    const [startTime, setStartTime] = $acw62.useState();
    const [endTime, setEndTime] = $acw62.useState();
    const handleClose = ()=>{
        onClose();
    };
    const stacksToDisplay = $acw62.useMemo(()=>{
        const sortedHangarStacks = (0, $lNEp2.sortLayoutOptions)(hangar, stacks, false).slice(0, Math.min(isAlgorithmTesting ? stacks.length : 4, stacks.length));
        return sortedHangarStacks.map((scoredHangarStack)=>{
            const stackId = (0, $lNEp2.uuidv4)();
            const stack = {
                id: stackId,
                options: scoredHangarStack.stack.paramSet.options,
                tenants: scoredHangarStack.stack.stackMembers.map((stackMember)=>({
                        ...hangar.stack.tenants.find((t)=>t.placement_id === stackMember.placement_id),
                        selected: false,
                        // overwrite or keep?
                        position: {
                            ...hangar.stack.tenants.find((t)=>t.placement_id === stackMember.placement_id).position,
                            x: stackMember.x,
                            y: stackMember.y,
                            angle: stackMember.angle,
                            stack_id: stackId
                        }
                    })),
                movableObstacles: hangar.stack.movableObstacles.filter((obstacle)=>$d16d150300b0f4ed$var$isMovableObstacleWithinHangarBounds(obstacle, hangar)),
                isReference: hangar.stack.isReference
            };
            return {
                label: `${scoredHangarStack.stack.paramSet.label} - ${(0, $cLNZr.round)(scoredHangarStack.score, 2)}`,
                stack: stack
            };
        });
    }, [
        props.hangar,
        stacks
    ]);
    $acw62.useEffect(()=>{
        if (status === "in progress") setStartTime(+new Date());
        if (status === "complete") setEndTime(+new Date());
    }, [
        status
    ]);
    const timeElapsed = Boolean(startTime) && Boolean(endTime) && (0, $cLNZr.round)((endTime - startTime) / 1000, 1);
    const percentOf200x200 = hangar?.width * hangar?.depth / 40000;
    const totalPositionsToEvaluate = (0, $cLNZr.sum)(hangar?.stack?.tenants?.map((t)=>percentOf200x200 * 16 * // avg number of angles per position
        ($b9BFS.find((p)=>p.aircraft_id === t.aircraft_id)?.count ?? 10000)));
    const totalScenariosEvaluated = (0, $cLNZr.mean)(progress) * progress.length * totalPositionsToEvaluate || 0;
    const totalScenarios = progress.length * totalPositionsToEvaluate;
    const scenariosProgress = totalScenarios === 0 ? `Preparing for takeoff...` : `${(0, $lNEp2.formatNumber)(totalScenariosEvaluated, 0)} scenarios evaluated`;
    const stackResultHeight = $d16d150300b0f4ed$var$calculateStackResultHeight({
        width: containerWidth,
        height: window.innerHeight - 325
    }, hangar);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        ref: ref,
        open: open,
        onClose: ()=>{
        // nothing
        },
        maxWidth: "lg",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: status === "complete" ? "Select a Stack" : "Evaluating Stack"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: ()=>{
                                // user clicks on area outside of of modal window. kill!
                                window.globalThis.airplxKillSwitch = 2;
                                window.globalThis.airplxAborter?.abort();
                                handleClose();
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                sx: {
                    p: 0,
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        sx: {
                            minWidth: 800
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                                container: true,
                                justifyContent: "center",
                                alignItems: "center",
                                alignContent: "center",
                                children: stacksToDisplay.map(({ label: label, stack: stack })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cJu23.default), {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        justifyContent: "center",
                                        alignItems: "center",
                                        alignContent: "center",
                                        children: [
                                            isAlgorithmTesting && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                sx: {
                                                    width: "100%"
                                                },
                                                align: "center",
                                                variant: "caption",
                                                component: "div",
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brzp3.StackResult), {
                                                height: stackResultHeight,
                                                status: status,
                                                isReference: isReference,
                                                stack: stack,
                                                hangar: hangar,
                                                setHangar: setHangar,
                                                onClose: onClose,
                                                onFlagResult: async (id, isFlagged)=>{
                                                    if (!isFlagged) {
                                                        // delete matching records in flagged_stack
                                                        await postgrest.from("flagged_stack").delete().eq("id", id);
                                                        return;
                                                    }
                                                    // add to flagged_stack
                                                    const flaggedStack = stacksToDisplay.find((s)=>id === s.stack.id).stack;
                                                    const alternate_stacks = stacksToDisplay.filter((s)=>s.stack.id !== id).map(({ stack: stack })=>stack);
                                                    await postgrest.from("flagged_stack").insert({
                                                        id: id,
                                                        fbo_id: activeFBO.id,
                                                        hangar_id: hangar.id,
                                                        stack: flaggedStack,
                                                        alternate_stacks: alternate_stacks
                                                    });
                                                }
                                            })
                                        ]
                                    }, `stack-result-${stack.id}`))
                            }),
                            status === "complete" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {
                                        color: "success",
                                        variant: "determinate",
                                        sx: {
                                            height: 10,
                                            width: "100%"
                                        },
                                        value: 100 * (0, $cLNZr.mean)(progress)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        sx: {
                                            p: 1
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            children: scenariosProgress
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    status == "complete" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "body2",
                            component: "div",
                            children: [
                                "Stacking finished in ",
                                timeElapsed,
                                "s. Not happy with your stack?",
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    component: "span",
                                    color: "success.main",
                                    onClick: handleClose,
                                    sx: {
                                        "&:hover": {
                                            textDecoration: "underline",
                                            cursor: "pointer"
                                        }
                                    },
                                    children: "Try modifying your requirements."
                                })
                            ]
                        })
                    })
                ]
            }),
            status === "complete" ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                sx: {
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        disabled: window.globalThis.airplxKillSwitch > 0,
                        color: "error",
                        onClick: ()=>{
                            window.globalThis.airplxKillSwitch = 2;
                            window.globalThis.airplxAborter.abort();
                            handleClose();
                        },
                        children: "Cancel Stack"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            flex: "1 0 0"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        disabled: window.globalThis.airplxKillSwitch === 1,
                        variant: "contained",
                        color: "success",
                        onClick: ()=>{
                            window.globalThis.airplxKillSwitch = 1;
                            window.globalThis.airplxAborter.abort();
                        },
                        children: "End Stacking Early"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("5Jffw", function(module, exports) {

$parcel$export(module.exports, "default", () => $42bcfbe6cabdd2e0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dwVAB = parcelRequire("dwVAB");

var $iG64q = parcelRequire("iG64q");
var $42bcfbe6cabdd2e0$var$defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
function $42bcfbe6cabdd2e0$var$useMeasure() {
    var _a = (0, $acw62.useState)(null), element = _a[0], ref = _a[1];
    var _b = (0, $acw62.useState)($42bcfbe6cabdd2e0$var$defaultState), rect = _b[0], setRect = _b[1];
    var observer = (0, $acw62.useMemo)(function() {
        return new window.ResizeObserver(function(entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top_1,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        });
    }, []);
    (0, $dwVAB.default)(function() {
        if (!element) return;
        observer.observe(element);
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    return [
        ref,
        rect
    ];
}
var $42bcfbe6cabdd2e0$export$2e2bcd8739ae039 = (0, $iG64q.isBrowser) && typeof window.ResizeObserver !== 'undefined' ? $42bcfbe6cabdd2e0$var$useMeasure : function() {
    return [
        (0, $iG64q.noop),
        $42bcfbe6cabdd2e0$var$defaultState
    ];
};

});
parcelRegister("dwVAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9aef90db4aa20a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $iG64q = parcelRequire("iG64q");
var $9d9aef90db4aa20a$var$useIsomorphicLayoutEffect = (0, $iG64q.isBrowser) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $9d9aef90db4aa20a$export$2e2bcd8739ae039 = $9d9aef90db4aa20a$var$useIsomorphicLayoutEffect;

});


parcelRegister("b9BFS", function(module, exports) {
module.exports = JSON.parse("[{\"aircraft_id\":\"01649b18-177c-47cc-b162-a273a1ad4acc\",\"count\":70225},{\"aircraft_id\":\"031f82cc-1e24-41c6-be62-f67040fbd3f0\",\"count\":60025},{\"aircraft_id\":\"036e6050-9af1-483a-9406-9424a38d7214\",\"count\":59536},{\"aircraft_id\":\"0453caf3-203c-4461-a920-0f43a16efcee\",\"count\":60025},{\"aircraft_id\":\"0458638e-f9e2-4fb1-bab9-bc24ec5e5dc3\",\"count\":58564},{\"aircraft_id\":\"0625bc0c-7f73-4cee-836c-31f434824781\",\"count\":51984},{\"aircraft_id\":\"066615ff-108b-450e-82b0-5abf726cfdf7\",\"count\":59536},{\"aircraft_id\":\"06fe7134-97b1-4143-b7a5-5c4c6a67485f\",\"count\":51984},{\"aircraft_id\":\"072610c0-6f66-4763-9de1-db97fe829b72\",\"count\":50625},{\"aircraft_id\":\"08f76ed1-2394-4610-bbd0-3398d353e8a6\",\"count\":51529},{\"aircraft_id\":\"090247c4-633b-404e-bed9-bf7de06e19db\",\"count\":61009},{\"aircraft_id\":\"0996279e-d90e-4f24-a99b-2fa4c15ad60d\",\"count\":50625},{\"aircraft_id\":\"0c2dd127-fcd3-4860-b8b3-e5285b144645\",\"count\":51984},{\"aircraft_id\":\"0c3a395e-1441-46a2-8ec9-a9533503941a\",\"count\":64516},{\"aircraft_id\":\"0d4e36ae-7841-47cb-9725-7a8c994d7bca\",\"count\":63001},{\"aircraft_id\":\"0df9d0e6-91ff-434f-adb8-d718976ef101\",\"count\":50625},{\"aircraft_id\":\"0e38f34f-121a-4f90-aa6d-64aea620e4db\",\"count\":55696},{\"aircraft_id\":\"0e952c28-c43f-49ed-be9b-7e811cb2710d\",\"count\":60025},{\"aircraft_id\":\"0fa8bf52-cd44-4078-a045-234af0860a6f\",\"count\":58564},{\"aircraft_id\":\"105b8979-e2b9-4555-b69b-7ace775eed53\",\"count\":51984},{\"aircraft_id\":\"10dec469-f512-473e-88cf-0bea09afbb3f\",\"count\":59536},{\"aircraft_id\":\"117682b6-8fb5-4152-af50-748eb1ab4cc8\",\"count\":50176},{\"aircraft_id\":\"14854cfe-8757-4fcd-801c-1d9de910541c\",\"count\":72361},{\"aircraft_id\":\"14f31748-b6a8-4659-b36e-62d82a38921f\",\"count\":51984},{\"aircraft_id\":\"150c45a7-8203-4fe5-84ad-dcb341441587\",\"count\":52441},{\"aircraft_id\":\"15f3593c-f5d2-422c-ad7b-1ea6f72bfe1d\",\"count\":50625},{\"aircraft_id\":\"17834433-1f02-4f5b-a95f-81638148be73\",\"count\":55696},{\"aircraft_id\":\"17fb31e1-fb19-47e1-845c-83dd949a9374\",\"count\":56169},{\"aircraft_id\":\"1cb72af9-3229-4d31-a380-e903ca675ce8\",\"count\":57600},{\"aircraft_id\":\"1f5985e9-c24b-4ba6-afc1-39e6e6cbf5e8\",\"count\":59536},{\"aircraft_id\":\"202f607f-f02d-4aea-b881-544f4e7567e2\",\"count\":61009},{\"aircraft_id\":\"2050eccf-02b6-4409-a7e9-3e40df0ee788\",\"count\":87025},{\"aircraft_id\":\"20b5d43d-356d-4872-a23f-101169ba97e1\",\"count\":50625},{\"aircraft_id\":\"20f3ff21-b711-406c-a550-63157a3b9988\",\"count\":61504},{\"aircraft_id\":\"219e5891-19bb-42fa-981d-09523abcfa6f\",\"count\":51984},{\"aircraft_id\":\"223b6b88-b94c-4ba4-8ed3-5c8f88c5989f\",\"count\":55696},{\"aircraft_id\":\"238cdc2b-0535-46c5-b7cb-60a0b24cfd45\",\"count\":51529},{\"aircraft_id\":\"2453d752-669f-4cf5-80e5-834f96f8e79c\",\"count\":51076},{\"aircraft_id\":\"24c500d4-0f9d-4b2f-a7c2-06ee5ab2d800\",\"count\":90601},{\"aircraft_id\":\"250c4de6-c7c4-447c-b9b8-10d472ebc299\",\"count\":51076},{\"aircraft_id\":\"25dac745-be7b-4b91-a888-02de54d81afd\",\"count\":54756},{\"aircraft_id\":\"2649611e-62e6-4c5d-93a7-206f16bfe7d2\",\"count\":51076},{\"aircraft_id\":\"2915c571-a0ab-410e-8ef9-0fa24a139501\",\"count\":51984},{\"aircraft_id\":\"2a296bbf-4ed3-4a41-bf10-475010072d17\",\"count\":56169},{\"aircraft_id\":\"2ad811aa-06d4-4990-9894-90f28e727681\",\"count\":51984},{\"aircraft_id\":\"2b818953-bf35-43b3-be41-867c434d2d3a\",\"count\":50176},{\"aircraft_id\":\"2c98383c-c690-49a4-86cd-f6dffcf1ec81\",\"count\":52900},{\"aircraft_id\":\"2e754d74-adbc-4306-afa6-b362d2ef51d2\",\"count\":50176},{\"aircraft_id\":\"306d0c30-8c0d-4e5f-bc57-8bcfa9e26a01\",\"count\":52441},{\"aircraft_id\":\"309bd15a-0747-42c2-b9cd-43277467620a\",\"count\":70225},{\"aircraft_id\":\"30d7864f-5597-429e-bf0c-1bee18056c30\",\"count\":51984},{\"aircraft_id\":\"319fb7ce-ea49-4518-8bc9-9ad626a91873\",\"count\":59536},{\"aircraft_id\":\"32c2ddc6-ae7a-4beb-83ae-919b4eb7610f\",\"count\":53824},{\"aircraft_id\":\"3385b4db-e41d-47d6-a078-20d75dc5bb7a\",\"count\":51076},{\"aircraft_id\":\"34a9120e-018d-450b-8523-f3806d9fe6a8\",\"count\":49729},{\"aircraft_id\":\"361c7b92-e305-4c25-be37-1b0571d2ee57\",\"count\":87025},{\"aircraft_id\":\"365749cf-8851-44f3-a125-e62b34492660\",\"count\":59536},{\"aircraft_id\":\"36fe3fd8-ac79-47ad-a3a4-cf54e11a54e4\",\"count\":50625},{\"aircraft_id\":\"370c4aed-b63d-4fba-8a5d-673df531f4fa\",\"count\":70225},{\"aircraft_id\":\"3729432b-90ee-45ca-b696-914c9111bd37\",\"count\":90601},{\"aircraft_id\":\"3846a66c-fbed-48f1-824d-d4bab2056374\",\"count\":50625},{\"aircraft_id\":\"38bce97f-13e4-4e63-b0a4-ae4b8ad00d39\",\"count\":68121},{\"aircraft_id\":\"38f43cd8-8831-40a6-9376-c56dd629926e\",\"count\":63504},{\"aircraft_id\":\"39fd2605-b5d0-4ce7-af7f-27ec1fe5e4ce\",\"count\":50625},{\"aircraft_id\":\"3aa5155e-404f-4714-9892-cdf6b42b6cbc\",\"count\":55225},{\"aircraft_id\":\"3abc2e30-245a-4520-898f-027e12317cae\",\"count\":69169},{\"aircraft_id\":\"3ac052b7-f108-4463-bac0-dcc07a7b2a37\",\"count\":59536},{\"aircraft_id\":\"3af87609-6518-4016-8dbd-a3edbaf07d6e\",\"count\":48841},{\"aircraft_id\":\"3bda19aa-d700-4d73-973b-345e43226e3d\",\"count\":55696},{\"aircraft_id\":\"3ef55d15-566b-4a40-b6f7-8442546f80b1\",\"count\":52900},{\"aircraft_id\":\"3f0e9057-bc2d-4543-8b18-13e7f683c62d\",\"count\":61504},{\"aircraft_id\":\"3fd089ac-060a-4162-96d1-3af3904328be\",\"count\":52441},{\"aircraft_id\":\"3ff7dba3-857e-4d87-8658-5364c241d1a4\",\"count\":59536},{\"aircraft_id\":\"42f80e46-695b-4cb4-b4d7-5cd9a2027488\",\"count\":54289},{\"aircraft_id\":\"447f13b4-0d42-4457-a78a-4eefab522cc8\",\"count\":72361},{\"aircraft_id\":\"44f386b6-bdb4-4116-92a2-16c1cb812e2a\",\"count\":60025},{\"aircraft_id\":\"45003eee-f39a-42b3-98a0-2e1f7522083a\",\"count\":59049},{\"aircraft_id\":\"450da9ed-b52a-462d-983f-449be300365a\",\"count\":57121},{\"aircraft_id\":\"453fdfc2-a79b-458e-aa0f-df454a1cbc6e\",\"count\":61504},{\"aircraft_id\":\"459d565a-f0b0-4f09-ac22-dc230a31d076\",\"count\":53361},{\"aircraft_id\":\"45d3e0d3-e842-4495-be9a-1bcfa2a607a3\",\"count\":51984},{\"aircraft_id\":\"46baa078-5110-4b2d-a2c3-8dfe685a76e6\",\"count\":50625},{\"aircraft_id\":\"491781a8-8101-4e81-aa71-53b5b3a3d8ab\",\"count\":55696},{\"aircraft_id\":\"492af825-45af-498a-bb2b-b93c6e2edb86\",\"count\":53361},{\"aircraft_id\":\"496c8d4e-9d75-4898-8ead-e8f22369c76f\",\"count\":54756},{\"aircraft_id\":\"49c086b5-1398-4699-a806-60104f34fc0a\",\"count\":55696},{\"aircraft_id\":\"4bd6960a-9391-413b-a441-c8003aebcd96\",\"count\":64516},{\"aircraft_id\":\"4c9621b6-c6ed-4ebd-82a3-7eb03375d7b0\",\"count\":65025},{\"aircraft_id\":\"4cb6cd7a-6a18-4074-845f-3212730b0ab5\",\"count\":52441},{\"aircraft_id\":\"4d78018f-6747-43df-bca8-23d08446aa10\",\"count\":77284},{\"aircraft_id\":\"4d913ce5-8bd3-4b1d-b58b-bddf9e42d73d\",\"count\":70756},{\"aircraft_id\":\"4dc85875-da40-4414-b370-d6c8bfef260a\",\"count\":72361},{\"aircraft_id\":\"4e49c227-0f11-4f13-966d-1f7847339ba1\",\"count\":61009},{\"aircraft_id\":\"4e5d2123-7b24-422c-8c9d-c620223caff8\",\"count\":51984},{\"aircraft_id\":\"4ebd43f5-3c79-4e48-8d71-cddee8bd53b6\",\"count\":72900},{\"aircraft_id\":\"5020f97e-23ca-4e58-aacc-d4c0a520620b\",\"count\":76729},{\"aircraft_id\":\"53264e27-3c3c-415e-80d7-9cc1a274a2d8\",\"count\":57600},{\"aircraft_id\":\"5344e2f3-3051-49e5-af40-a16e8d992949\",\"count\":50176},{\"aircraft_id\":\"54bef36c-5322-43dc-87c2-4a1bcb54d210\",\"count\":51076},{\"aircraft_id\":\"54cd260a-12b4-4744-86bf-dfcca559da94\",\"count\":70756},{\"aircraft_id\":\"55b59322-cac2-4400-b457-0943ccd857a9\",\"count\":55225},{\"aircraft_id\":\"56a2c098-67e1-44bc-af87-47dd383d5bb7\",\"count\":47961},{\"aircraft_id\":\"5744450a-0578-405f-8e12-8baee530131a\",\"count\":63504},{\"aircraft_id\":\"5794419c-3c26-481f-8ce7-3a454e2358ec\",\"count\":63504},{\"aircraft_id\":\"5954fcad-369b-4352-93d4-772e32725239\",\"count\":58081},{\"aircraft_id\":\"599a491b-4dc5-4b03-b4e9-ce7f10a638c1\",\"count\":54289},{\"aircraft_id\":\"5be6d8f1-60ed-47f2-8c86-f2b7102d2575\",\"count\":53824},{\"aircraft_id\":\"5c20225d-bf42-4aa3-8a54-8a4aa6612a0a\",\"count\":61504},{\"aircraft_id\":\"5c405c26-68bf-48c9-a8f6-6559a2dd6b7e\",\"count\":55696},{\"aircraft_id\":\"5d3cefa7-781e-4547-9386-de5495dd5765\",\"count\":69696},{\"aircraft_id\":\"5ee9026f-a77b-4863-b482-784bffa14ded\",\"count\":51984},{\"aircraft_id\":\"5f4ef5cf-65e8-4669-8ef2-b9812649f1e8\",\"count\":68644},{\"aircraft_id\":\"60511826-267a-4769-9861-1b2f26b7f221\",\"count\":50625},{\"aircraft_id\":\"61f9628d-b615-4cce-a7e0-09a1bf20e35d\",\"count\":87025},{\"aircraft_id\":\"631d9e33-7246-4bd5-beaf-61d3bfcf6934\",\"count\":59049},{\"aircraft_id\":\"63b600e1-a52e-4d86-9b6d-db747c6485cb\",\"count\":63504},{\"aircraft_id\":\"6464e763-7f1c-4e20-9537-181723120c5c\",\"count\":78961},{\"aircraft_id\":\"67f0c702-834a-4bda-8763-91eb9c52187b\",\"count\":49729},{\"aircraft_id\":\"69775337-6d29-473f-a541-ef7e757c2b43\",\"count\":90601},{\"aircraft_id\":\"6afe3528-b3a1-46b6-a792-d37dca797f29\",\"count\":49729},{\"aircraft_id\":\"6b2e2c3d-a2b4-453f-8640-224934918366\",\"count\":55225},{\"aircraft_id\":\"6c034d22-dd68-4e31-8618-94a09519058c\",\"count\":63504},{\"aircraft_id\":\"6c136d15-53f0-4057-bb81-0261a359db4d\",\"count\":59536},{\"aircraft_id\":\"6c25df3b-ff7c-44c1-a3d3-b2e6e49e0c01\",\"count\":51076},{\"aircraft_id\":\"6c4851c2-2357-4b57-8623-96c936603e12\",\"count\":49729},{\"aircraft_id\":\"6ca980ca-2dc9-47f3-94d6-ac63d08dcd0e\",\"count\":50625},{\"aircraft_id\":\"6cd002ed-cd7c-46f0-acb1-5a1f139ffc2c\",\"count\":65536},{\"aircraft_id\":\"6d80b076-4a44-4901-b026-701f50596e85\",\"count\":59049},{\"aircraft_id\":\"6e1b0368-d95b-417d-815d-c4dc99ca7fcb\",\"count\":49729},{\"aircraft_id\":\"6e253bb2-d1c8-4c82-a3b5-ad8794115dc5\",\"count\":57600},{\"aircraft_id\":\"6eec0f5f-2bab-4da9-b0b8-8f70dd948942\",\"count\":52441},{\"aircraft_id\":\"6f1f2c3b-66de-4568-8f87-868b699ebba3\",\"count\":49284},{\"aircraft_id\":\"6f24288d-3c48-4bad-bf19-b5ee6ee179d1\",\"count\":51529},{\"aircraft_id\":\"6fccce55-34d0-4b5c-b816-a7c133cc9f1c\",\"count\":48841},{\"aircraft_id\":\"6fe23d61-1367-4df9-b0ee-9faa8b5e18da\",\"count\":51984},{\"aircraft_id\":\"6fe731f2-86c1-4c94-bec2-2370a613ff3b\",\"count\":51984},{\"aircraft_id\":\"700b358c-b65e-436d-8ce5-4f2410a127a5\",\"count\":65025},{\"aircraft_id\":\"709ef6f9-0e8c-4540-8c41-3f827589b5e1\",\"count\":54289},{\"aircraft_id\":\"711fd2ff-cffe-4834-b811-850834897c8b\",\"count\":55225},{\"aircraft_id\":\"72a49887-db6f-45d4-81d8-9316c9d66936\",\"count\":87025},{\"aircraft_id\":\"72c759c6-ec50-49a5-8352-9afd649ab2c6\",\"count\":52441},{\"aircraft_id\":\"76658409-8fff-4d22-a344-7b00d3ef189c\",\"count\":51076},{\"aircraft_id\":\"772850a4-0c17-4ac0-a1c0-c0f6042cfbfc\",\"count\":55696},{\"aircraft_id\":\"776a03ac-4a12-4dff-972b-8cf1665fe7b7\",\"count\":56169},{\"aircraft_id\":\"779f31c3-ae43-4a1a-93c3-1f51faaf345b\",\"count\":70225},{\"aircraft_id\":\"78342823-7db8-43f7-8887-e58e9074ee10\",\"count\":51076},{\"aircraft_id\":\"791e86c9-2d71-40cc-b382-d0094670a16c\",\"count\":51529},{\"aircraft_id\":\"7929fcc0-cc46-4f83-8858-31e852bd5602\",\"count\":72900},{\"aircraft_id\":\"7a5f5203-9377-4754-a02f-dc0ccf6bc3be\",\"count\":77284},{\"aircraft_id\":\"7be78379-38d5-4285-9af1-a5d5c40d2165\",\"count\":56169},{\"aircraft_id\":\"7d2ee735-e1aa-4a68-ad18-321ab293191a\",\"count\":65025},{\"aircraft_id\":\"7d975ecb-6287-4138-88a3-f90169df4dd6\",\"count\":63001},{\"aircraft_id\":\"7e95d386-985f-4ae4-add2-78fcf9465ad2\",\"count\":50176},{\"aircraft_id\":\"7ea21055-1677-4b53-ad70-d241421c5387\",\"count\":43264},{\"aircraft_id\":\"7fbb172b-b770-490c-a188-b8842ba3b88a\",\"count\":51984},{\"aircraft_id\":\"800404a8-0aed-4d99-b25b-5269011f8a52\",\"count\":77284},{\"aircraft_id\":\"805f48d4-f267-458a-9ee1-0a0769d05e17\",\"count\":64516},{\"aircraft_id\":\"80ea3d07-6f8b-4900-9ee0-6aee29ad3158\",\"count\":57121},{\"aircraft_id\":\"80fa4b2b-68b6-4f6b-a4b1-cb09bdb01490\",\"count\":52441},{\"aircraft_id\":\"80fc1aae-22c4-4422-b2fa-df98453e17f4\",\"count\":50176},{\"aircraft_id\":\"81624059-eee6-46dd-908f-da1d5f979719\",\"count\":65536},{\"aircraft_id\":\"81be48a2-d52a-4bfd-a2ef-632b0f86327d\",\"count\":55225},{\"aircraft_id\":\"8257dd9c-a533-4289-aedf-f7947495120f\",\"count\":77284},{\"aircraft_id\":\"8341a5d9-bd32-4b9c-804c-09446666bd10\",\"count\":66564},{\"aircraft_id\":\"83f9918a-ef41-4545-b671-b69b9260e420\",\"count\":51529},{\"aircraft_id\":\"841f4d13-8a38-4120-912b-60f236759d59\",\"count\":57600},{\"aircraft_id\":\"849c2ffe-050f-43d5-b2b8-c789c7c41314\",\"count\":55696},{\"aircraft_id\":\"84afec76-6fb6-48f5-a546-dc883f133a22\",\"count\":50625},{\"aircraft_id\":\"850d7f7b-acf7-4edf-b3b5-46bf4b822b5e\",\"count\":77284},{\"aircraft_id\":\"856d4c72-7115-49d6-b157-1785a2221bb9\",\"count\":51076},{\"aircraft_id\":\"88505ec9-85bb-46ce-a0c4-320637740403\",\"count\":69696},{\"aircraft_id\":\"89639c8b-50fb-4e15-b4ca-35e994360b39\",\"count\":69696},{\"aircraft_id\":\"89a7aa2f-9822-4353-8c15-07c8f0fc7ed5\",\"count\":52900},{\"aircraft_id\":\"8ba456a0-3058-4be1-993c-337a654cb2dd\",\"count\":57600},{\"aircraft_id\":\"8c5f781d-ceae-4cb5-9e85-dfdb83190953\",\"count\":51984},{\"aircraft_id\":\"8cd777ac-14ad-419a-aa33-f70b05a9bcd1\",\"count\":49284},{\"aircraft_id\":\"8cec5b73-c898-4641-982a-585f0756c94a\",\"count\":54289},{\"aircraft_id\":\"8d4abc40-c29d-4588-864e-07e4f4c6242e\",\"count\":51076},{\"aircraft_id\":\"8d4e5c3a-2c3e-435c-bdf1-619b6b84a61b\",\"count\":51076},{\"aircraft_id\":\"8d53d129-63a3-4fec-882e-dc255247aa68\",\"count\":86436},{\"aircraft_id\":\"8e0183ae-35b8-4ce1-8358-675b321228e3\",\"count\":51529},{\"aircraft_id\":\"8e1f0f2f-6213-40db-992e-1a30e82825ba\",\"count\":53824},{\"aircraft_id\":\"8ee4c266-a2df-4608-a0d3-4c3a71f8b615\",\"count\":59536},{\"aircraft_id\":\"8f89648a-af3f-4a19-9018-31f01e0ce5b6\",\"count\":51076},{\"aircraft_id\":\"8f95d990-4cdd-4947-86c2-15f6d043a4fd\",\"count\":55696},{\"aircraft_id\":\"8fdc7915-7f39-4eb8-86d1-48b4ecca3023\",\"count\":50176},{\"aircraft_id\":\"90d3ab9c-f0e3-4ec0-87a6-1ac70d66c725\",\"count\":51984},{\"aircraft_id\":\"9230794f-3ebc-4c84-84ae-ed0daae9d86f\",\"count\":63001},{\"aircraft_id\":\"92892a51-e413-4735-8f4e-9b3e2a1c33c6\",\"count\":90000},{\"aircraft_id\":\"92d26139-ff7c-44d2-98b0-6b282bbf84d9\",\"count\":55225},{\"aircraft_id\":\"92fea6c9-ed7e-4e16-9e7b-38247f65bb96\",\"count\":50625},{\"aircraft_id\":\"93051cf9-9ce3-4ced-9726-731ca130debc\",\"count\":87025},{\"aircraft_id\":\"930be7d3-ea98-4eee-9f72-1cc155090f1a\",\"count\":59536},{\"aircraft_id\":\"9485d7b9-3eb3-49d7-90de-8b42fbb67f2e\",\"count\":50176},{\"aircraft_id\":\"94d2c94c-f976-42d4-b74a-bc3a7a3558ed\",\"count\":71289},{\"aircraft_id\":\"959d3100-a75d-4476-ae84-368b5ac97e8f\",\"count\":50625},{\"aircraft_id\":\"96bca297-d888-4f60-adab-9757fa0b7966\",\"count\":49729},{\"aircraft_id\":\"96f2403a-70d1-4c20-8022-93ae5106d25c\",\"count\":58081},{\"aircraft_id\":\"97044e19-aaa1-479a-8fa2-da07880e91ab\",\"count\":54289},{\"aircraft_id\":\"970be9a5-300f-4088-8dff-133791e388b9\",\"count\":55225},{\"aircraft_id\":\"98203742-cb8b-49ca-a884-5840afd8c390\",\"count\":52441},{\"aircraft_id\":\"9a5a3567-9bc6-44c7-8c52-bf14c001163a\",\"count\":50625},{\"aircraft_id\":\"9a9804ac-99d3-41bb-9040-1615933a78f6\",\"count\":59536},{\"aircraft_id\":\"9ac7ac7b-c8a8-402b-832f-8fa7a0f67a70\",\"count\":56169},{\"aircraft_id\":\"9b68e9e4-ae25-4a8f-9061-493dba335c6c\",\"count\":52900},{\"aircraft_id\":\"9c324784-53cc-4fa3-bbab-b7a49c5a0ce6\",\"count\":51984},{\"aircraft_id\":\"9d78caad-6f55-4e4b-8f8f-496c65f9d380\",\"count\":50625},{\"aircraft_id\":\"9d8c825f-bf86-4cd4-bc18-3348d3e90854\",\"count\":56169},{\"aircraft_id\":\"9dfc4690-05a1-462a-968a-c6383629f304\",\"count\":53361},{\"aircraft_id\":\"9e1fc90b-4a97-429f-9169-4f0c4830d156\",\"count\":61504},{\"aircraft_id\":\"9ef1a202-15a5-473e-8479-2b37a77948d3\",\"count\":49729},{\"aircraft_id\":\"9fa9ec6f-8f26-479e-b0da-0f90936c2176\",\"count\":87025},{\"aircraft_id\":\"9fc355c7-6652-48cf-bec6-2b2956af07a4\",\"count\":56169},{\"aircraft_id\":\"a002ba9b-8f84-428e-b97c-a4f4ffab1286\",\"count\":55225},{\"aircraft_id\":\"a0a49b54-3dd7-4876-8c01-b2f768e771b0\",\"count\":77284},{\"aircraft_id\":\"a1a3478e-b017-437a-a754-8b6e7c34a9d3\",\"count\":69696},{\"aircraft_id\":\"a279da59-f2b7-4962-a00d-94169c1fa5ad\",\"count\":52441},{\"aircraft_id\":\"a318d93c-9b01-4875-9505-b9ac74bac148\",\"count\":64009},{\"aircraft_id\":\"a4f08d21-1410-4c4c-b495-8dabbe178dac\",\"count\":52441},{\"aircraft_id\":\"a500ac24-8e55-46b3-9614-4890da85839a\",\"count\":49284},{\"aircraft_id\":\"a66282db-b6a9-47b6-92dc-4aca01b7f5cc\",\"count\":50625},{\"aircraft_id\":\"a66530e5-6525-4d27-8604-77721dcba26d\",\"count\":50625},{\"aircraft_id\":\"a76f5ef2-beb2-4d89-9984-428538bad60e\",\"count\":51529},{\"aircraft_id\":\"a7a563a5-8ce0-42ab-886e-ff9fd15ef76a\",\"count\":52441},{\"aircraft_id\":\"a86bc346-2f64-4f9d-911e-5bd22d1e3c0e\",\"count\":82369},{\"aircraft_id\":\"a881f195-07da-41d8-80ad-abe78ce7431d\",\"count\":65025},{\"aircraft_id\":\"a8c79801-a3fa-4aa1-936f-ef1292c2c3d3\",\"count\":55696},{\"aircraft_id\":\"a92da450-4d72-4940-b9a1-6ff1d7c720f7\",\"count\":61009},{\"aircraft_id\":\"aa0a2a14-1c71-483f-a541-4c8ed4af8ef9\",\"count\":60025},{\"aircraft_id\":\"aa0ab598-f41f-4602-9a79-1739d83721b5\",\"count\":50176},{\"aircraft_id\":\"ab130036-5e4d-424a-aadb-7aa199f4387c\",\"count\":54756},{\"aircraft_id\":\"aba3b4b1-2bdc-414d-990d-7e447e5532a4\",\"count\":70225},{\"aircraft_id\":\"abd1366f-879f-4405-ad0b-30fe2e3ca56a\",\"count\":51984},{\"aircraft_id\":\"abdfc7c9-1cbd-446f-8697-4ed8bfd3811c\",\"count\":63001},{\"aircraft_id\":\"abe908c1-cb6d-4dde-8bb5-1e9c77e2e70f\",\"count\":52900},{\"aircraft_id\":\"ad57073e-901d-41b3-b21e-0e2ab06c43e1\",\"count\":54756},{\"aircraft_id\":\"adf4075f-a14c-45e3-88a4-fdb272103450\",\"count\":49284},{\"aircraft_id\":\"aed4d605-d11f-47d6-80de-061b05fed180\",\"count\":52441},{\"aircraft_id\":\"b02527fb-1f12-4dfe-a523-6432346088db\",\"count\":50625},{\"aircraft_id\":\"b2cd0c3d-4dee-44bf-971a-e1595d796c8c\",\"count\":51984},{\"aircraft_id\":\"b2e05e2b-5a5b-49f0-a418-70258a65430b\",\"count\":51076},{\"aircraft_id\":\"b31e1a07-b6e1-4d9a-8158-187d91e5b839\",\"count\":69696},{\"aircraft_id\":\"b35aa43d-5461-4aa4-85a5-8c5e5038ef03\",\"count\":82369},{\"aircraft_id\":\"b384e0bd-7dd1-4c70-b6b1-e902420eb402\",\"count\":50176},{\"aircraft_id\":\"b3859b31-eafd-4cf8-8eb6-0f53d19e03bc\",\"count\":51984},{\"aircraft_id\":\"b3b07b4b-dca3-4032-b86a-d17b97247d14\",\"count\":50625},{\"aircraft_id\":\"b3c44513-2578-4991-8682-2f8f26fa3aa1\",\"count\":72361},{\"aircraft_id\":\"b3eff267-b1b5-47a5-ab95-64e92068f586\",\"count\":49729},{\"aircraft_id\":\"b4caa9b8-088f-4011-87b7-3408ebe606be\",\"count\":62001},{\"aircraft_id\":\"b5b5d633-9ebb-45d6-900d-70eac1ae67cf\",\"count\":64009},{\"aircraft_id\":\"b624231b-eeb9-4f6c-a217-75415703c1e5\",\"count\":61009},{\"aircraft_id\":\"b63e7b52-e619-44b5-b4d6-d47004d72fcf\",\"count\":54289},{\"aircraft_id\":\"b850c4fa-8b01-4951-ae89-b8eda85617aa\",\"count\":54289},{\"aircraft_id\":\"b88c03e5-9c49-453e-8cce-40247298ed45\",\"count\":55696},{\"aircraft_id\":\"b8cde0a5-7725-49f0-aef4-2179edcf93fb\",\"count\":51984},{\"aircraft_id\":\"b97e80d3-e310-486d-ad51-824f89aa0a5b\",\"count\":52441},{\"aircraft_id\":\"b9b6fdba-d66d-4f2d-aae4-bf5094618d1d\",\"count\":51984},{\"aircraft_id\":\"bc54f069-59e4-42e5-82ca-e43c24b98814\",\"count\":59049},{\"aircraft_id\":\"bce730af-1ba1-45f1-bf1c-2d5737d96a31\",\"count\":61504},{\"aircraft_id\":\"bdd2a2fa-0473-4886-8a6b-f7876d221c95\",\"count\":59049},{\"aircraft_id\":\"be05d674-26e6-474c-8f53-53c158de2e53\",\"count\":65536},{\"aircraft_id\":\"be1defcf-6ea3-42e2-9193-c64472f1c612\",\"count\":65025},{\"aircraft_id\":\"be3000d9-5b61-441c-9483-3d528a87e9e9\",\"count\":58081},{\"aircraft_id\":\"be6f5407-e0c0-4fe5-b83d-2a61f9fd8698\",\"count\":50176},{\"aircraft_id\":\"beadc09f-0994-4292-9392-ba0b0d55930f\",\"count\":49729},{\"aircraft_id\":\"bed3b163-d8eb-4133-bc5e-3d3ca0c52c88\",\"count\":50625},{\"aircraft_id\":\"bfea67ef-1ec9-468a-9825-2561c92a4f16\",\"count\":59049},{\"aircraft_id\":\"c07e4dbe-7022-4f43-a937-79ca40d977ef\",\"count\":90601},{\"aircraft_id\":\"c0c606af-e736-4c98-ba1d-dcb067241580\",\"count\":59049},{\"aircraft_id\":\"c13e3a43-7524-4462-9a14-0e020cc546f4\",\"count\":50176},{\"aircraft_id\":\"c1d60079-9f9a-4367-b2c7-4dd470e554b4\",\"count\":86436},{\"aircraft_id\":\"c2ddcb88-9dbd-4c53-a2d2-db57c04a4552\",\"count\":66564},{\"aircraft_id\":\"c3d7ddf2-23ec-42e0-b22c-47a32e8b19fd\",\"count\":58081},{\"aircraft_id\":\"c4526310-0ec6-45c8-b539-7a34f14b90b8\",\"count\":59536},{\"aircraft_id\":\"c463641b-f21e-42b4-bdc7-f744f2264f77\",\"count\":55225},{\"aircraft_id\":\"c487fb9a-1769-43cc-a138-eee977db0bec\",\"count\":56169},{\"aircraft_id\":\"c798146b-7aeb-4403-bc82-9810b062ab56\",\"count\":81225},{\"aircraft_id\":\"c90846ca-07ac-4167-9269-52becf95b86c\",\"count\":51984},{\"aircraft_id\":\"c9544942-851d-44d8-b03f-ddb575ce7872\",\"count\":54289},{\"aircraft_id\":\"c9726303-75df-4748-81d7-54386e9ebd00\",\"count\":71289},{\"aircraft_id\":\"cb63c0ec-249d-4a95-9553-c5831a94c00c\",\"count\":52441},{\"aircraft_id\":\"cbbfdf04-260c-4598-8566-e45aabb95f3a\",\"count\":57600},{\"aircraft_id\":\"cbc6f2c0-712e-4be5-9fd1-a349bfc4aa3b\",\"count\":51984},{\"aircraft_id\":\"cca143ae-6243-4f56-8c5e-c0fea98a0c72\",\"count\":51984},{\"aircraft_id\":\"ccedfe1d-0be9-4e72-a909-db245865a502\",\"count\":56169},{\"aircraft_id\":\"ccf8243f-5540-48c3-9204-e011ff1992e0\",\"count\":52441},{\"aircraft_id\":\"ce1fd647-c43f-42c1-aa0e-66010e5a6f0c\",\"count\":49284},{\"aircraft_id\":\"ce23fd7f-2d32-4bf1-86c6-bc57d97d1ef5\",\"count\":49729},{\"aircraft_id\":\"ce5d59b8-9486-4881-a75b-f222f5b9794f\",\"count\":51984},{\"aircraft_id\":\"ced5f5cf-2441-4f86-8efb-6dc05926e070\",\"count\":50625},{\"aircraft_id\":\"cf515db4-f575-4529-a721-2095e30493f3\",\"count\":51984},{\"aircraft_id\":\"d1fafb27-18c9-4094-9d26-ccd702ab5089\",\"count\":69696},{\"aircraft_id\":\"d3e69994-9ef9-41e5-af97-395c3275aa29\",\"count\":59536},{\"aircraft_id\":\"d4ba2506-383c-47b6-8873-2ec0727e716f\",\"count\":51984},{\"aircraft_id\":\"d5d79a52-e86d-43e7-b077-29441fd56f0c\",\"count\":50176},{\"aircraft_id\":\"d84ff575-f949-47bb-a840-ade846b048b5\",\"count\":50625},{\"aircraft_id\":\"d92908dc-7196-428a-a47b-b88f5248d927\",\"count\":50625},{\"aircraft_id\":\"d93a4a6b-1c9f-4833-bb4f-f0bcef1eddb6\",\"count\":49284},{\"aircraft_id\":\"d94166a7-9513-4df1-b305-e0fd76ac6391\",\"count\":69696},{\"aircraft_id\":\"d94d7bb6-a4ea-4a68-aab9-5f2b0a984d80\",\"count\":53361},{\"aircraft_id\":\"d968e01d-d36b-4397-976c-ed6108b48ba6\",\"count\":54756},{\"aircraft_id\":\"da9b04b8-910d-4710-8af0-0871c0c0151d\",\"count\":58081},{\"aircraft_id\":\"daeed3e3-507f-4f37-aafd-cfe547b45bdb\",\"count\":51984},{\"aircraft_id\":\"daf6d557-a414-472d-b304-726ed9f06c4c\",\"count\":60025},{\"aircraft_id\":\"dbb1e18f-5e6b-449b-ab99-937475bfbe0e\",\"count\":48841},{\"aircraft_id\":\"dbc6a417-b15e-4587-93f5-e02580c03085\",\"count\":54756},{\"aircraft_id\":\"dcbd7da4-125c-4fa2-9d68-2a8edda7f98f\",\"count\":50625},{\"aircraft_id\":\"de4411db-5b3e-4e4c-a16a-c3df5e1dcc5a\",\"count\":50176},{\"aircraft_id\":\"decc03ac-4eee-4574-a9ea-9194953e4284\",\"count\":55696},{\"aircraft_id\":\"df7df0f4-fe61-4312-8aed-799b4e20c50f\",\"count\":51076},{\"aircraft_id\":\"e035cd93-7344-469a-b3cb-aa0ce28a94d9\",\"count\":67081},{\"aircraft_id\":\"e09d7055-6b4d-476d-bc8e-f9c09b75263e\",\"count\":55225},{\"aircraft_id\":\"e1f779e8-a7c9-4af3-8d3a-cfbef81410fc\",\"count\":42849},{\"aircraft_id\":\"e213f72b-1bd7-465d-98b9-06e9210b10e8\",\"count\":51076},{\"aircraft_id\":\"e246fe58-2ec4-415d-81bc-985371db3fe9\",\"count\":61009},{\"aircraft_id\":\"e3295b26-810a-427d-ba00-6e1fdeef9dc2\",\"count\":55696},{\"aircraft_id\":\"e3607a43-0077-4fc8-8d43-8aba011577de\",\"count\":56169},{\"aircraft_id\":\"e3a52329-7b05-4278-91e8-1a109200fb9a\",\"count\":55696},{\"aircraft_id\":\"e440cb80-a043-46ec-9704-8c9715cef50b\",\"count\":54756},{\"aircraft_id\":\"e45b7e9c-4e82-4c72-85e9-6e17d4531002\",\"count\":52900},{\"aircraft_id\":\"e510949d-63d4-44a8-9b89-2725956eb42a\",\"count\":61504},{\"aircraft_id\":\"e5b50efa-325e-4f3e-9371-57bd762164d4\",\"count\":52900},{\"aircraft_id\":\"e637fab5-111b-4049-91f2-642bae8cdb5e\",\"count\":51529},{\"aircraft_id\":\"e7f5f4ec-d9e3-4227-94f6-1a102b7a44a3\",\"count\":53824},{\"aircraft_id\":\"e97dc27d-de22-415b-ba74-8be5210e4d17\",\"count\":55696},{\"aircraft_id\":\"ea9582f1-31c1-4878-b933-3c03b467b542\",\"count\":52900},{\"aircraft_id\":\"eab35a1d-29dd-4bc7-98ea-6d67c9c2bccc\",\"count\":61504},{\"aircraft_id\":\"eb48871b-fb37-4f2d-9442-27f83c523822\",\"count\":51076},{\"aircraft_id\":\"ebc39fa4-d828-4eaa-ba3a-cf1eb8ad0e7d\",\"count\":67081},{\"aircraft_id\":\"ec9b6164-89ad-4e05-9548-7c0beca29e8d\",\"count\":64516},{\"aircraft_id\":\"ed59f5ae-5305-4efc-a33e-09137c40b130\",\"count\":69696},{\"aircraft_id\":\"ed73b06c-80f4-4c07-b8c8-493ef6ddfe37\",\"count\":51076},{\"aircraft_id\":\"edd82e36-533a-4fa0-b188-2cfb5c002a62\",\"count\":77284},{\"aircraft_id\":\"ee64353c-dcee-44be-8e37-a2ca6708ba5a\",\"count\":55225},{\"aircraft_id\":\"eee90118-8379-45c5-8f6d-eb8d3b296d34\",\"count\":50625},{\"aircraft_id\":\"eefbdda4-2a28-4da6-9286-8ef7d8a19526\",\"count\":56169},{\"aircraft_id\":\"ef00fe4c-efd4-4989-b82a-00df25d5cb2e\",\"count\":72361},{\"aircraft_id\":\"ef912d2d-daa6-406b-874a-5da9791c287a\",\"count\":59536},{\"aircraft_id\":\"f039325b-d052-4602-aae1-5d076f663d17\",\"count\":68121},{\"aircraft_id\":\"f03b9f2d-5475-4af7-856e-2d47e3634c1d\",\"count\":81796},{\"aircraft_id\":\"f23f0595-4343-47bc-9446-5b3bd5249eea\",\"count\":56644},{\"aircraft_id\":\"f28cc9e9-294a-4607-9615-62d645695ec7\",\"count\":48400},{\"aircraft_id\":\"f3b8f550-2016-4934-b93f-9de21f78d9de\",\"count\":50176},{\"aircraft_id\":\"f44268eb-f205-4f15-943c-c01aa3cae4c8\",\"count\":68644},{\"aircraft_id\":\"f50a013d-b7bb-4f12-a99b-07083132f982\",\"count\":62001},{\"aircraft_id\":\"f59aa479-0607-4eb7-8b8b-ce0755d5dc58\",\"count\":71289},{\"aircraft_id\":\"f6018117-7c63-4f55-b6c0-1252ed664d41\",\"count\":57600},{\"aircraft_id\":\"f797ff51-3dcc-422e-a753-c0957032df35\",\"count\":51984},{\"aircraft_id\":\"fad1c892-d0bf-4e65-abc0-5086365df628\",\"count\":90000},{\"aircraft_id\":\"faea06e9-6ac6-4bf6-9320-4bb0ac051208\",\"count\":55696},{\"aircraft_id\":\"fbbb5071-40f2-437f-8aca-5f4d95409c6d\",\"count\":59536},{\"aircraft_id\":\"fc49cdfe-c03b-457f-8c46-e8bcb27d4298\",\"count\":69696},{\"aircraft_id\":\"fd052a6e-8e82-43d3-b55e-1eca7ee985ae\",\"count\":50176},{\"aircraft_id\":\"fd3ae1de-1454-496c-8735-b910449c25a5\",\"count\":48400},{\"aircraft_id\":\"fd62d0c2-0aa6-49d4-873e-a310cd359853\",\"count\":56169},{\"aircraft_id\":\"fd749e09-d172-494a-81a7-d08f98e39056\",\"count\":70225},{\"aircraft_id\":\"feb32ce2-c196-478b-804e-f8392e06345d\",\"count\":74529},{\"aircraft_id\":\"ffba55ac-0637-42ac-84cf-70bb807e9852\",\"count\":52900},{\"aircraft_id\":\"fff8aab0-98ae-4a88-8277-48246273ab21\",\"count\":69696}]");

});

parcelRegister("brzp3", function(module, exports) {

$parcel$export(module.exports, "StackResult", () => $f25e8fe270f8aea6$export$f14254ebf9170a58);

var $ayMG0 = parcelRequire("ayMG0");

var $1BegY = parcelRequire("1BegY");

var $ex6lH = parcelRequire("ex6lH");

var $7mYdE = parcelRequire("7mYdE");

var $6lXkL = parcelRequire("6lXkL");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $5KGQl = parcelRequire("5KGQl");
parcelRequire("86FOL");
var $9UCpe = parcelRequire("9UCpe");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");

var $kPMZ3 = parcelRequire("kPMZ3");
parcelRequire("gvs0W");
var $b4zZe = parcelRequire("b4zZe");
const $f25e8fe270f8aea6$var$TooltipInfoAircraft = ({ tenants: tenants })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9UCpe.HtmlTooltip), {
        title: tenants.length === 0 ? "" : /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            style: {
                margin: 0,
                padding: 0,
                paddingInlineStart: 20,
                fontSize: 18
            },
            children: tenants.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: t.aircraft.model
                }, `info-aircraft-${t.placement_id}`))
        }),
        placement: "right",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
            sx: {
                fontSize: 11
            }
        })
    });
};
const $f25e8fe270f8aea6$export$f14254ebf9170a58 = ({ status: status, flagged: flagged = false, readOnly: readOnly = false, hangar: hangar, setHangar: setHangar, stack: stack, onClose: onClose, onFlagResult: onFlagResult, isReference: isReference = false, height: height })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [isPoor, setIsPoor] = $acw62.useState(false);
    const entityPolygons = (0, $5KGQl.getStackPolygons)(stack, hangar.width, 1);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                stack: stack,
                setStack: ()=>{
                // not needed
                },
                location: {
                    ...hangar,
                    type: "hangar"
                },
                height: height ?? (hangar.width / hangar.depth > 1.75 ? 200 : 250),
                options: {
                    hideUnplaced: true,
                    readOnly: true,
                    selectable: false,
                    printable: false,
                    hideTailNumbers: true,
                    hideNotes: true,
                    dashColor: isReference ? "#FFFFFF" : null,
                    backgroundColor: (0, $b4zZe.HANGAR_BACKGROUND_COLORS)[isReference ? "reference" : null]
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "space-around",
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                children: [
                                    (0, $kPMZ3.calculateUtilization)(hangar, entityPolygons, true, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "info.dark",
                                fontSize: 12,
                                children: "Utilization"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        orientation: "vertical",
                        variant: "middle",
                        flexItem: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                spacing: 0.5,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: stack.tenants.filter(({ position: position })=>position.x != null).length
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($f25e8fe270f8aea6$var$TooltipInfoAircraft, {
                                        tenants: stack.tenants.filter(({ position: position })=>position.x !== null)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "info.dark",
                                fontSize: 12,
                                children: "Inside"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        orientation: "vertical",
                        variant: "middle",
                        flexItem: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                spacing: 0.5,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: hangar.stack.tenants.length - stack.tenants.filter(({ position: position })=>position.x != null).length
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($f25e8fe270f8aea6$var$TooltipInfoAircraft, {
                                        tenants: stack.tenants.filter(({ position: position })=>position.x === null)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "info.dark",
                                fontSize: 12,
                                children: "Outside"
                            })
                        ]
                    }),
                    flagged && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                orientation: "vertical",
                                variant: "middle",
                                flexItem: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                direction: "column",
                                alignItems: "center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BegY))), {
                                    sx: {
                                        color: "#ff2244"
                                    }
                                })
                            })
                        ]
                    }),
                    status === "complete" && readOnly === false && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                size: "small",
                                onClick: ()=>{
                                    setHangar({
                                        ...hangar,
                                        stack: {
                                            ...hangar.stack,
                                            ...stack,
                                            tenants: stack.tenants.map((t)=>({
                                                    ...t,
                                                    position: {
                                                        ...t.position,
                                                        stack_id: hangar.stack.id
                                                    }
                                                })),
                                            movableObstacles: stack.movableObstacles.map((mo)=>({
                                                    ...mo,
                                                    position: {
                                                        ...mo.position,
                                                        stack_id: hangar.stack.id
                                                    }
                                                })),
                                            id: hangar.stack.id
                                        }
                                    });
                                    onClose();
                                },
                                sx: {
                                    mb: 0.75,
                                    mt: 0.75
                                },
                                children: "Select Stack"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                title: "Flag poor layout",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    size: "small",
                                    onClick: async ()=>{
                                        setIsPoor(!isPoor);
                                        await onFlagResult(stack.id, !isPoor);
                                    },
                                    children: isPoor ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BegY))), {
                                        sx: {
                                            color: "#ff2244"
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7mYdE))), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("gvs0W", function(module, exports) {

$parcel$export(module.exports, "HangarPresenter", () => $409028f0b4f82291$export$6b0a9334f6972d68);
$parcel$export(module.exports, "HANGAR_BACKGROUND_COLORS", () => (parcelRequire("b4zZe")).HANGAR_BACKGROUND_COLORS);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gZQV9 = parcelRequire("gZQV9");

var $b4zZe = parcelRequire("b4zZe");
const $409028f0b4f82291$export$6b0a9334f6972d68 = ({ id: id, stacks: stacks, setStacks: setStacks, isReference: isReference, isAlgorithmTesting: isAlgorithmTesting = false })=>{
    const { hangar: hangar, setHangar: setHangar, history: history } = (0, $gZQV9.useThisHangar)();
    if (!hangar) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4zZe.HangarPresenterBase), {
        id: id,
        stacks: stacks,
        setStacks: setStacks,
        isReference: isReference,
        isAlgorithmTesting: isAlgorithmTesting,
        hangar: hangar,
        setHangar: setHangar,
        history: history
    });
};

});
parcelRegister("b4zZe", function(module, exports) {

$parcel$export(module.exports, "HANGAR_BACKGROUND_COLORS", () => $c0c9fc31d7ab3f31$export$32f5b8ab45fa2334);
$parcel$export(module.exports, "HangarPresenterBase", () => $c0c9fc31d7ab3f31$export$d33e103360ba1428);

var $ayMG0 = parcelRequire("ayMG0");

var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");

var $fifzc = parcelRequire("fifzc");

var $ZD2ym = parcelRequire("ZD2ym");

var $ciKN1 = parcelRequire("ciKN1");

var $7p8YN = parcelRequire("7p8YN");

var $6AlVH = parcelRequire("6AlVH");

var $5KGQl = parcelRequire("5KGQl");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");
parcelRequire("6qWGE");
var $c0zpU = parcelRequire("c0zpU");
parcelRequire("baghD");
var $drjQE = parcelRequire("drjQE");

var $5U03M = parcelRequire("5U03M");

var $eYWyk = parcelRequire("eYWyk");

var $g7var = parcelRequire("g7var");

var $dnRrW = parcelRequire("dnRrW");

var $64aJt = parcelRequire("64aJt");

var $32ESd = parcelRequire("32ESd");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $3JLDK = parcelRequire("3JLDK");

var $78CAK = parcelRequire("78CAK");
const $c0c9fc31d7ab3f31$export$32f5b8ab45fa2334 = {
    reference: "#F4D2CD",
    testing: "#23967F"
};
const $c0c9fc31d7ab3f31$export$d33e103360ba1428 = ({ id: id, stacks: stacks, setStacks: setStacks, isReference: isReference, isAlgorithmTesting: isAlgorithmTesting = false, hangar: hangar, setHangar: setHangar, history: history, onScheduledUpdate: onScheduledUpdate, isScheduledView: isScheduledView = false, onUndo: onUndo, scheduledViewProps: scheduledViewProps })=>{
    const navigate = (0, $aphAM.useNavigate)();
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { isMultiHangar: isMultiHangar } = (0, $7p8YN.useMultiHangarState)();
    const [stackStrategy, setStackStrategy] = $acw62.useState((0, $eYWyk.StackStrategy).normal);
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { towingEquipments: allTowingEquipments } = (0, $6AlVH.useTowingEquipmentState)();
    const defaultTowingEquipmentId = allTowingEquipments.find((t)=>t.in_use && t.is_default)?.towing_equipment_id;
    // Hangar data now comes from props instead of useThisHangar hook
    const [width, setWidth] = $acw62.useState(700);
    const [customPlacementOptions, setCustomPlacementOptions] = $acw62.useState((0, $78CAK.defaultCustomPlacementOptions)(activeFBO, hangar));
    $acw62.useEffect(()=>{
        setCustomPlacementOptions((0, $78CAK.defaultCustomPlacementOptions)(activeFBO, hangar));
    }, [
        stackStrategy
    ]);
    const div = $acw62.useCallback((node)=>{
        if (node?.offsetWidth && node?.offsetHeight) {
            let maxUnplacedAircraftLength = hangar.stack.tenants.filter((t)=>t.position.x === null).map((t)=>t.aircraft.length + 20).reduce((a, b)=>Math.max(a, b), 0);
            maxUnplacedAircraftLength = Math.max(maxUnplacedAircraftLength, 70);
            const feetToPixels = node?.offsetHeight / (hangar.depth + maxUnplacedAircraftLength);
            const height = node.offsetHeight - maxUnplacedAircraftLength * feetToPixels;
            setWidth(hangar.width * height / hangar.depth);
        }
    }, [
        isDrawerOpen
    ]);
    const polygons = $acw62.useMemo(()=>(0, $5KGQl.getStackPolygons)(hangar?.stack, width, 1, isMultiHangar, id === (0, $5U03M.HOLDING_AREA_ID)), [
        width,
        hangar?.stack?.tenants,
        hangar?.stack?.movableObstacles
    ]);
    const setStack = $acw62.useCallback((stack)=>{
        setHangar({
            ...hangar,
            stack: {
                ...hangar.stack,
                ...stack
            }
        });
    }, [
        hangar,
        setHangar
    ]);
    const paramSet = $acw62.useMemo(()=>{
        if (!hangar) return null;
        return {
            run_id: null,
            label: "base case",
            // slim down the hangar for the API call
            hangar: {
                id: hangar.id,
                width: hangar.width,
                depth: hangar.depth,
                left_door: hangar.left_door,
                right_door: hangar.right_door,
                garage_doors: hangar.garageDoors ?? [],
                bays: hangar.bays ?? []
            },
            // slim down the tenant so it's just what we need to do the placement
            aircrafts_to_place: hangar.stack.tenants.filter((t)=>t.position.preferences?.indexOf((0, $keHtM.Preference).LOCKED) === -1).map((tenant)=>({
                    id: tenant.aircraft.id,
                    placement_id: tenant.placement_id,
                    angles_to_try: [],
                    sectors_to_try: null,
                    preferences: (0, $lNEp2.convertAircraftPreferencesToAlgorithmPreferences)(tenant.position.preferences)
                })),
            locked_aircrafts: hangar.stack.tenants.filter((t)=>t.position.preferences?.indexOf((0, $keHtM.Preference).LOCKED) > -1).map((tenant)=>({
                    id: tenant.aircraft.id,
                    placement_id: tenant.placement_id,
                    x: tenant.position.x,
                    y: tenant.position.y,
                    angle: tenant.position.angle
                })),
            obstacles: (0, $g7var.formatObstacles)(hangar),
            options: {
                ...hangar.stack.options,
                ...customPlacementOptions
            }
        };
    }, [
        hangar
    ]);
    const autocomplete = (0, $32ESd.useHangarAutocomplete)({
        hangar: hangar,
        defaultTowingEquipmentId: defaultTowingEquipmentId,
        width: width,
        customPlacementOptions: customPlacementOptions
    }, [
        hangar,
        polygons,
        customPlacementOptions,
        defaultTowingEquipmentId
    ]);
    const positions = hangar?.stack?.tenants.map((t)=>`${t.position.x},${t.position.y},${t.position.angle}`).join("");
    (0, $fifzc.default)(()=>{
        setHangar({
            ...hangar,
            last_stacked: new Date().toISOString()
        });
    }, [
        positions
    ]);
    if (!hangar) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciKN1.AutocompleteResultsContainer), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "row",
            sx: {
                width: "100%",
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3JLDK.CollapsibleRampActionCard), {
                    location: {
                        type: "hangar",
                        ...hangar
                    },
                    onClickBack: ()=>navigate("/hangars"),
                    hideNavigation: isScheduledView,
                    extendBorderUp: isScheduledView,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dnRrW.HangarLeftPanel), {
                        width: isDrawerOpen ? 400 : 125,
                        hangar: hangar,
                        setHangar: setHangar,
                        stacks: stacks,
                        setStacks: setStacks,
                        stackStrategy: stackStrategy,
                        setStackStrategy: setStackStrategy,
                        paramSet: paramSet,
                        customPlacementOptions: customPlacementOptions,
                        setCustomPlacementOptions: setCustomPlacementOptions,
                        isReference: isReference,
                        isAlgorithmTesting: isAlgorithmTesting,
                        readOnly: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                        disableAutoOpen: !!onScheduledUpdate,
                        isScheduledView: isScheduledView,
                        onAddTrip: scheduledViewProps?.onScheduledUpdate ? ()=>{
                            // For scheduled views, trigger refresh after trip creation
                            scheduledViewProps.onScheduledUpdate();
                        } : undefined,
                        currentTime: scheduledViewProps?.currentTime,
                        timeRange: scheduledViewProps?.timeRange,
                        allPlacements: scheduledViewProps?.allPlacements,
                        onRemoveAircraft: scheduledViewProps?.onRemoveAircraft,
                        onRefresh: scheduledViewProps?.onScheduledUpdate,
                        onTimeChange: scheduledViewProps?.onTimeChange
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    sx: {
                        flex: 1,
                        height: "100%",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0zpU.LayoutToolbar), {
                            location: {
                                type: "hangar",
                                ...hangar
                            },
                            setLocation: ({ type: _type, ...location })=>{
                                setHangar({
                                    ...hangar,
                                    ...location
                                });
                            },
                            stack: hangar.stack,
                            setStack: setStack,
                            setStacks: setStacks,
                            isScheduledView: isScheduledView,
                            scheduledViewProps: scheduledViewProps,
                            onClickUndo: ()=>{
                                if (isScheduledView && onUndo) onUndo();
                                else history && history.undo();
                            },
                            renderOnPrint: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $64aJt.HangarPrintLayout), {
                                    hangar: hangar,
                                    stack: hangar.stack
                                })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: div,
                            style: {
                                flex: 1,
                                // This stops the aircraft being dragged outside of this section
                                // overflow: "scroll",
                                position: "relative",
                                height: "100%",
                                margin: "20px"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                                width: width,
                                location: {
                                    type: "hangar",
                                    ...hangar
                                },
                                stack: hangar?.stack,
                                setStack: setStack,
                                autocomplete: autocomplete,
                                onScheduledUpdate: onScheduledUpdate,
                                scheduledViewProps: scheduledViewProps,
                                options: {
                                    hideUnplaced: false,
                                    readOnly: false,
                                    frozen: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                                    printable: false,
                                    selectable: false,
                                    disableGrabScroll: isMultiHangar
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drjQE.ZoomControl), {
                    currentZoom: width,
                    increment: 0.1,
                    onClickPlus: ()=>setWidth(width * 1.1),
                    onClickMinus: ()=>setWidth(width * 0.9)
                })
            ]
        })
    });
};

});
parcelRegister("fifzc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2249cae2acd5252$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dSoFf = parcelRequire("dSoFf");
var $b2249cae2acd5252$var$useUpdateEffect = function(effect, deps) {
    var isFirstMount = (0, $dSoFf.useFirstMountState)();
    (0, $acw62.useEffect)(function() {
        if (!isFirstMount) return effect();
    }, deps);
};
var $b2249cae2acd5252$export$2e2bcd8739ae039 = $b2249cae2acd5252$var$useUpdateEffect;

});
parcelRegister("dSoFf", function(module, exports) {

$parcel$export(module.exports, "useFirstMountState", () => $a1a3735398fd84b3$export$ddbfea47304c9e3);

var $acw62 = parcelRequire("acw62");
function $a1a3735398fd84b3$export$ddbfea47304c9e3() {
    var isFirst = (0, $acw62.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

});







parcelRegister("elDPN", function(module, exports) {

$parcel$export(module.exports, "SelectStackStrategy", () => $fc698d5b4afe172a$export$d2207dbe9996c6a5);

var $ayMG0 = parcelRequire("ayMG0");

var $fP0Mq = parcelRequire("fP0Mq");

var $hBILp = parcelRequire("hBILp");

var $3th7A = parcelRequire("3th7A");

var $2wozg = parcelRequire("2wozg");

var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");

var $eYWyk = parcelRequire("eYWyk");
const $fc698d5b4afe172a$export$d2207dbe9996c6a5 = ({ paramSet: paramSet, stackStrategy: stackStrategy, setStackStrategy: setStackStrategy })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    // Helper function to format distance values with proper units
    const formatDistance = (valueInFeet)=>{
        if (valueInFeet == null) return "N/A";
        const useMetric = activeFBO?.settings?.useMetricSystem || false;
        if (useMetric) {
            const valueInMeters = (0, $d7VTV.feetToMeters)(valueInFeet);
            return `${(0, $lNEp2.formatNumber)(valueInMeters, 1)} m`;
        }
        return `${(0, $lNEp2.formatNumber)(valueInFeet, 0)} ft`;
    };
    // Helper function to format vertical spacing display
    const formatVerticalSpacing = (overlap, spacing)=>{
        if (!overlap) return "No Overlap";
        if (spacing == null) return "N/A";
        return formatDistance(spacing);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                        elevation: 0,
                        variant: "outlined",
                        onClick: ()=>setStackStrategy((0, $eYWyk.StackStrategy).normal),
                        sx: {
                            width: "100%",
                            borderColor: stackStrategy === (0, $eYWyk.StackStrategy).normal && "success.main",
                            borderWidth: stackStrategy === (0, $eYWyk.StackStrategy).normal && 2,
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3th7A))), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    children: "Normal"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    children: [
                                        "Day-to-day operations using SOPs.",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "\u2022 Horizontal spacing: ",
                                        formatDistance(paramSet.options.horizontal_spacing),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "\u2022 Overlap min: ",
                                        formatVerticalSpacing(activeFBO?.sop_overlap || false, activeFBO?.sop_vertical_spacing)
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                        elevation: 0,
                        variant: "outlined",
                        onClick: ()=>setStackStrategy((0, $eYWyk.StackStrategy).tight),
                        sx: {
                            width: "100%",
                            borderColor: stackStrategy === (0, $eYWyk.StackStrategy).tight && "success.main",
                            borderWidth: stackStrategy === (0, $eYWyk.StackStrategy).tight && 2,
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    direction: "row",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBILp))), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    children: "Tight"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    children: [
                                        "Optimized for maximum utilization.",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "\u2022 Horizontal spacing: ",
                                        formatDistance(activeFBO?.sop_horizontal_spacing_tight ?? paramSet.options.horizontal_spacing),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "\u2022 Overlap min: ",
                                        formatVerticalSpacing(activeFBO?.sop_overlap_tight || false, activeFBO?.sop_vertical_spacing_tight)
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                        elevation: 0,
                        variant: "outlined",
                        onClick: ()=>setStackStrategy((0, $eYWyk.StackStrategy).loose),
                        sx: {
                            width: "100%",
                            borderColor: stackStrategy === (0, $eYWyk.StackStrategy).loose && "success.main",
                            borderWidth: stackStrategy === (0, $eYWyk.StackStrategy).loose && 2,
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fP0Mq))), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    children: "Loose"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    children: [
                                        "Optimized for easy towing, at the expense of utilization.",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "\u2022 Horizontal spacing: ",
                                        formatDistance(activeFBO?.sop_horizontal_spacing_loose),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "\u2022 Overlap min: ",
                                        formatVerticalSpacing(activeFBO?.sop_overlap_loose || false, activeFBO?.sop_vertical_spacing_loose)
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                        elevation: 0,
                        variant: "outlined",
                        onClick: ()=>setStackStrategy((0, $eYWyk.StackStrategy).custom),
                        sx: {
                            width: "100%",
                            borderColor: stackStrategy === (0, $eYWyk.StackStrategy).custom && "success.main",
                            borderWidth: stackStrategy === (0, $eYWyk.StackStrategy).custom && 2,
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2wozg))), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    children: "Custom"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    children: "Completely customize your stack preferences."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("j1m4k", function(module, exports) {

$parcel$export(module.exports, "SelectTowingEquipment", () => $5eb080067577a8b1$export$cb877e376e15c2d7);

var $ayMG0 = parcelRequire("ayMG0");

var $2esSG = parcelRequire("2esSG");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $iAtns = parcelRequire("iAtns");
parcelRequire("acw62");
const $5eb080067577a8b1$export$cb877e376e15c2d7 = ({ ignoreTowingEquipment: ignoreTowingEquipment, setIgnoreTowingEquipment: setIgnoreTowingEquipment, selectedTowingEquipment: selectedTowingEquipment, setSelectedTowingEquipment: setSelectedTowingEquipment, towingEquipments: towingEquipments })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                size: "small",
                disabled: ignoreTowingEquipment,
                select: true,
                fullWidth: true,
                label: "Towing Equipment For Stack",
                value: selectedTowingEquipment?.towing_equipment_id || "",
                onChange: (evt)=>{
                    setSelectedTowingEquipment(towingEquipments.find((t)=>t.towing_equipment_id === evt.target.value));
                },
                children: towingEquipments?.map((towingEquipment)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                        value: towingEquipment.towing_equipment_id,
                        children: towingEquipment.name
                    }, `towing-equipment-select-${towingEquipment.towing_equipment_id}`))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                    checked: ignoreTowingEquipment
                }),
                onChange: ()=>{
                    setIgnoreTowingEquipment(!ignoreTowingEquipment);
                    setSelectedTowingEquipment(null);
                },
                label: "Ignore?"
            })
        ]
    });

});



parcelRegister("aWoxc", function(module, exports) {

$parcel$export(module.exports, "useScheduleTimeRange", () => $3597698995b64281$export$c7521e3700e04688);

var $f4OIt = parcelRequire("f4OIt");

var $88tPr = parcelRequire("88tPr");
const $3597698995b64281$export$c7521e3700e04688 = (0, $f4OIt.create)((0, $88tPr.persist)((set)=>({
        // Default to a week range centered on current time
        rangeStart: (()=>{
            const start = new Date();
            start.setDate(start.getDate() - 3);
            start.setHours(0, 0, 0, 0);
            return start;
        })(),
        rangeEnd: (()=>{
            const end = new Date();
            end.setDate(end.getDate() + 4);
            end.setHours(23, 59, 59, 999);
            return end;
        })(),
        setTimeRange: (start, end)=>{
            set({
                rangeStart: start,
                rangeEnd: end
            });
        },
        getDefaultWeekRange: (centerTime)=>{
            const start = new Date(centerTime);
            start.setDate(start.getDate() - 3);
            start.setHours(0, 0, 0, 0);
            const end = new Date(centerTime);
            end.setDate(end.getDate() + 4);
            end.setHours(23, 59, 59, 999);
            return {
                start: start,
                end: end
            };
        }
    }), {
    name: "schedule-time-range-storage",
    // Custom serialization to handle Date objects
    storage: {
        getItem: (name)=>{
            const str = localStorage.getItem(name);
            if (!str) return null;
            const data = JSON.parse(str);
            return {
                ...data,
                state: {
                    ...data.state,
                    rangeStart: new Date(data.state.rangeStart),
                    rangeEnd: new Date(data.state.rangeEnd)
                }
            };
        },
        setItem: (name, value)=>{
            localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name)=>{
            localStorage.removeItem(name);
        }
    }
}));

});



parcelRegister("ki5be", function(module, exports) {

$parcel$export(module.exports, "LayoutWrapper", () => $e70c8a1e7979aa90$export$f6b907d7616eb8b2);

var $ayMG0 = parcelRequire("ayMG0");

var $146vq = parcelRequire("146vq");

var $erdLd = parcelRequire("erdLd");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $7p8YN = parcelRequire("7p8YN");

var $6AlVH = parcelRequire("6AlVH");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");

var $d1mLJ = parcelRequire("d1mLJ");

var $gQSh1 = parcelRequire("gQSh1");

var $32ESd = parcelRequire("32ESd");
const $e70c8a1e7979aa90$export$f6b907d7616eb8b2 = ({ hangarId: hangarId, width: width, customPlacementOptions: customPlacementOptions, print: print = false })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { activeLocationId: activeLocationId, setActiveLocationId: setActiveLocationId, focus: focus, setFocus: setFocus, getHangar: getHangar, setHangar: setHangar } = (0, $7p8YN.useMultiHangarState)();
    const hangar = getHangar(hangarId);
    const { towingEquipments: allTowingEquipments } = (0, $6AlVH.useTowingEquipmentState)();
    const defaultTowingEquipmentId = allTowingEquipments.find((t)=>t.in_use && t.is_default)?.towing_equipment_id;
    const active = !print && (focus || activeLocationId === hangar.id);
    const { feetToPixels: feetToPixels } = (0, $d1mLJ.useDimensions)({
        location: {
            type: "hangar",
            ...hangar
        },
        width: width
    });
    const setStack = $acw62.useCallback((stack)=>{
        setHangar({
            ...hangar,
            stack: {
                ...hangar.stack,
                ...stack
            }
        });
    }, [
        hangar,
        setHangar
    ]);
    const autocomplete = (0, $32ESd.useHangarAutocomplete)({
        hangar: hangar,
        defaultTowingEquipmentId: defaultTowingEquipmentId,
        width: width,
        customPlacementOptions: customPlacementOptions
    }, [
        hangar,
        customPlacementOptions,
        defaultTowingEquipmentId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        justifyContent: "space-between",
        spacing: 1,
        pb: `${feetToPixels * 75}px`,
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                sx: {
                    ml: 2,
                    width: width
                },
                children: [
                    active ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                        value: hangar.stack.tenants.length,
                        text: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                            color: "primary",
                            label: hangar.name,
                            sx: {
                                fontSize: 16
                            }
                        }),
                        bidirectional: true
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                        value: hangar.stack.tenants.length,
                        text: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: hangar.name
                        }),
                        bidirectional: true
                    }),
                    print ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        // i think it looks better when the icon (not the button outline) is pulled flush
                        sx: {
                            mr: -1
                        },
                        onClick: ()=>{
                            setActiveLocationId(hangar.id);
                            setFocus(Boolean(focus) ? null : hangar.id);
                        },
                        children: focus ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($146vq))), {
                            fontSize: "small"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($erdLd))), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                    width: width,
                    location: {
                        type: "hangar",
                        ...hangar
                    },
                    stack: hangar?.stack,
                    setStack: setStack,
                    autocomplete: autocomplete,
                    options: {
                        hideUnplaced: false,
                        readOnly: false,
                        frozen: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                        printable: print ? true : false,
                        selectable: false,
                        disableDragProtection: true,
                        borderColor: active && !focus ? "black" : null,
                        disableGrabScroll: true
                    }
                })
            })
        ]
    });
};

});

parcelRegister("kinWj", function(module, exports) {

$parcel$export(module.exports, "calculateMultiHangarStats", () => $fede6b6b51cdedc2$export$d3b9f7b09347ddf1);
$parcel$export(module.exports, "MultiHangarInfoCard", () => $fede6b6b51cdedc2$export$77c46c683e3d255f);

var $ayMG0 = parcelRequire("ayMG0");

var $le4Y6 = parcelRequire("le4Y6");

var $ex6lH = parcelRequire("ex6lH");

var $1QUqu = parcelRequire("1QUqu");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $7p8YN = parcelRequire("7p8YN");

var $64iGd = parcelRequire("64iGd");

var $5KGQl = parcelRequire("5KGQl");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $d7VTV = parcelRequire("d7VTV");

var $aHqXU = parcelRequire("aHqXU");

var $gtiLb = parcelRequire("gtiLb");

var $gQSh1 = parcelRequire("gQSh1");

var $kPMZ3 = parcelRequire("kPMZ3");

var $97sqG = parcelRequire("97sqG");

var $jbTvW = parcelRequire("jbTvW");

var $3JLDK = parcelRequire("3JLDK");

var $8vHzJ = parcelRequire("8vHzJ");

var $5U03M = parcelRequire("5U03M");
const $fede6b6b51cdedc2$export$d3b9f7b09347ddf1 = (activeFBO, allHangars)=>{
    const hangars = allHangars.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID));
    const polygons = hangars.map((hangar)=>(0, $5KGQl.getStackPolygons)(hangar.stack, hangar.width, 1, true));
    const nAircraftInHangar = (0, $cLNZr.sum)(hangars.map((hangar, idx)=>{
        const entityPolygons = polygons[idx];
        return (0, $kPMZ3.findTenantsFullyInHangar)(hangar, entityPolygons).length;
    }));
    const nAircraft = (0, $cLNZr.sum)(hangars.map((hangar)=>hangar.stack.tenants.length));
    const totalSqftAvailable = (0, $cLNZr.sum)(hangars.map((hangar)=>(0, $kPMZ3.calculateTotalArea)(hangar, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false)));
    const totalSqftUsed = (0, $cLNZr.sum)(hangars.map((hangar, idx)=>{
        const entityPolygons = polygons[idx];
        return (0, $kPMZ3.calculateUtilization)(hangar, entityPolygons, true, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false, true);
    }));
    const totalSqftDesired = (0, $cLNZr.sum)(hangars.map((hangar, idx)=>{
        const entityPolygons = polygons[idx];
        return (0, $kPMZ3.calculateUtilization)(hangar, entityPolygons, null, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false, true);
    }));
    const totalUtilization = Math.round(totalSqftUsed / totalSqftAvailable * 100);
    const totalUtilizationDesired = Math.round(totalSqftDesired / totalSqftAvailable * 100);
    const estValue = (0, $cLNZr.sum)(hangars.map((hangar, idx)=>{
        const entityPolygons = polygons[idx];
        return (0, $5KGQl.removeNonNumericAndParse)((0, $97sqG.estimateValue)(activeFBO, hangar, entityPolygons, activeFBO?.settings?.ignoreDeadSpaceForUtilization ?? false));
    }));
    const towTime = (0, $cLNZr.sum)(hangars.map((hangar, idx)=>{
        const entityPolygons = polygons[idx];
        return (0, $5KGQl.removeNonNumericAndParse)((0, $97sqG.calcEstimateTowTime)(hangar, entityPolygons));
    }));
    return {
        nAircraftInHangar: nAircraftInHangar,
        nAircraft: nAircraft,
        totalSqftAvailable: totalSqftAvailable,
        totalSqftUsed: totalSqftUsed,
        totalSqftDesired: totalSqftDesired,
        totalUtilization: totalUtilization,
        totalUtilizationDesired: totalUtilizationDesired,
        estValue: estValue,
        towTime: towTime
    };
};
const $fede6b6b51cdedc2$export$77c46c683e3d255f = ()=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const displayEstimatedValue = (0, $aHqXU.getRoleSetting)(activeFBO, 'displayEstimatedValue', true);
    const { hangars: hangars, setHangars: setHangars, setActiveLocationId: setActiveLocationId } = (0, $7p8YN.useMultiHangarState)();
    const { nAircraftInHangar: nAircraftInHangar, nAircraft: nAircraft, totalSqftAvailable: totalSqftAvailable, totalSqftUsed: totalSqftUsed, totalUtilization: totalUtilization, totalUtilizationDesired: totalUtilizationDesired, estValue: estValue, towTime: towTime } = (0, $64iGd.useDebouncedValue)(()=>$fede6b6b51cdedc2$export$d3b9f7b09347ddf1(activeFBO, hangars), 100, [
        [
            hangars.map((h)=>h.stack)
        ]
    ]);
    const totalAreaAvailable = activeFBO?.settings?.useMetricSystem ? (0, $d7VTV.squareFeetToSquareMeters)(totalSqftAvailable) : totalSqftAvailable;
    const totalAreaUsed = activeFBO?.settings?.useMetricSystem ? (0, $d7VTV.squareFeetToSquareMeters)(totalSqftUsed) : totalSqftUsed;
    const allTenants = $acw62.useMemo(()=>hangars.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID)).flatMap((hangar)=>hangar.stack.tenants), [
        hangars.map((h)=>h.stack.tenants)
    ]);
    if (!isDrawerOpen) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        children: "All Hangars"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        justifyContent: "center",
                        spacing: 1,
                        sx: {
                            p: 1,
                            pt: 0,
                            maxHeight: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vHzJ.MicroMetric), {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtiLb.HangarIcon), {}),
                                value: `${hangars.filter((h)=>h.id !== (0, $5U03M.HOLDING_AREA_ID)).length} `,
                                tooltip: "Number of hangars"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vHzJ.MicroMetric), {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($le4Y6))), {}),
                                value: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                color: "inherit"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                    value: nAircraftInHangar,
                                                    text: nAircraftInHangar
                                                }),
                                                " "
                                            ]
                                        }),
                                        "/ ",
                                        nAircraft
                                    ]
                                }),
                                tooltip: "# aircraft inside all hangars / # aircraft wanted inside all hangars"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vHzJ.MicroMetric), {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1QUqu))), {}),
                                value: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                color: "inherit"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                    value: totalUtilization,
                                                    text: `${totalUtilization}%`
                                                }),
                                                " "
                                            ]
                                        }),
                                        "/ ",
                                        totalUtilizationDesired,
                                        "%"
                                    ]
                                }),
                                tooltip: "Stacked aircraft utl. / All aircraft on screen utl. You can adjust how utilization is calculated in Settings > Configuration."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jbTvW.AircraftFinder), {
                mini: !isDrawerOpen,
                tenants: allTenants ?? [],
                onSelect: (tenant)=>{
                    const selectedTenantHangar = hangars.find((hangar)=>hangar.stack.tenants.find((t)=>t.id === tenant.id));
                    setActiveLocationId(selectedTenantHangar.id);
                    setHangars(hangars.map((hangar)=>({
                            ...hangar,
                            stack: {
                                ...hangar.stack,
                                tenants: hangar.stack.tenants.map((t)=>{
                                    if (t.id === tenant.id) return {
                                        ...tenant,
                                        selected: true
                                    };
                                    return {
                                        ...t,
                                        selected: false
                                    };
                                })
                            }
                        })));
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 1,
            borderBottomColor: "info.main",
            borderBottomWidth: 2,
            borderBottomStyle: "solid",
            borderLeft: "1px solid lightgrey",
            borderRight: "1px solid lightgrey"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    children: "All Hangars"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            textAlign: "center",
                                            children: "Aircraft"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "# aircraft inside all hangars / # aircraft wanted inside all hangars",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "info.dark"
                                                },
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    textAlign: "center",
                                    color: "info.dark",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                color: "inherit"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                    value: nAircraftInHangar,
                                                    text: nAircraftInHangar
                                                }),
                                                " "
                                            ]
                                        }),
                                        "/ ",
                                        nAircraft
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                            orientation: "vertical",
                            variant: "middle",
                            flexItem: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            textAlign: "center",
                                            children: "Utilization"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "Stacked aircraft utl. / All aircraft on screen utl. You can adjust how utilization is calculated in Settings > Configuration.",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "info.dark"
                                                },
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    textAlign: "center",
                                    color: "info.dark",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                color: "inherit"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                    value: totalUtilization,
                                                    text: `${totalUtilization}%`
                                                }),
                                                " "
                                            ]
                                        }),
                                        "/ ",
                                        totalUtilizationDesired,
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            textAlign: "center",
                                            children: "Total Sqft"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "Square footage of all hangars",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "info.dark"
                                                },
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    textAlign: "center",
                                    color: "info.dark",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                            value: totalAreaAvailable,
                                            text: (0, $lNEp2.formatNumber)(totalAreaAvailable, 0)
                                        }),
                                        activeFBO?.settings?.useMetricSystem ? " m\xb2" : " ft\xb2"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                            orientation: "vertical",
                            variant: "middle",
                            flexItem: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            textAlign: "center",
                                            children: "Total Utilized"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "Utilized square footage across all hangars",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "info.dark"
                                                },
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    textAlign: "center",
                                    color: "info.dark",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                        value: totalAreaUsed,
                                        text: `${(0, $lNEp2.formatNumber)(totalAreaUsed, 0)} ${activeFBO?.settings?.useMetricSystem ? " m\xb2" : " ft\xb2"}`
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    children: [
                        displayEstimatedValue && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    textAlign: "center",
                                                    children: "Est. Value"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: "Estimated value of all hangars. This includes all base tenants and any transients you're able to fit in the hangars.",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                        sx: {
                                                            color: "info.dark"
                                                        },
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            textAlign: "center",
                                            color: "info.dark",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                                value: estValue,
                                                text: `$${estValue} / day`
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                    orientation: "vertical",
                                    variant: "middle",
                                    flexItem: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            textAlign: "center",
                                            children: "Est. Tow Time"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "Estimated time it would take to tow every aircraft out of the hangars.",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                                                sx: {
                                                    color: "info.dark"
                                                },
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    textAlign: "center",
                                    color: "info.dark",
                                    children: `${towTime} min`
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jbTvW.AircraftFinder), {
                    mini: !isDrawerOpen,
                    tenants: allTenants ?? [],
                    onSelect: (tenant)=>{
                        const selectedTenantHangar = hangars.find((hangar)=>hangar.stack.tenants.find((t)=>t.id === tenant.id));
                        setActiveLocationId(selectedTenantHangar.id);
                        setHangars(hangars.map((hangar)=>({
                                ...hangar,
                                stack: {
                                    ...hangar.stack,
                                    tenants: hangar.stack.tenants.map((t)=>{
                                        if (t.id === tenant.id) return {
                                            ...tenant,
                                            selected: true
                                        };
                                        return {
                                            ...t,
                                            selected: false
                                        };
                                    })
                                }
                            })));
                    }
                })
            ]
        })
    });
};

});




parcelRegister("gJrqw", function(module, exports) {

$parcel$export(module.exports, "AssignAircraftDialog", () => $a10a660c74df4ab5$export$c8c9af4c5768b5dc);

var $ayMG0 = parcelRequire("ayMG0");

var $3LBtW = parcelRequire("3LBtW");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $gd5y7 = parcelRequire("gd5y7");
var $2esSG = parcelRequire("2esSG");
var $hrMZe = parcelRequire("hrMZe");
var $8IWga = parcelRequire("8IWga");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $a10a660c74df4ab5$export$c8c9af4c5768b5dc = ({ open: open, onClose: onClose, aircraftTail: aircraftTail, aircraftModel: aircraftModel, aircraftWingspan: aircraftWingspan, aircraftLength: aircraftLength, availableHangars: availableHangars, onAssign: onAssign, isAssigning: isAssigning = false })=>{
    const [selectedHangarId, setSelectedHangarId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    // Reset selection when dialog opens
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setSelectedHangarId("");
    }, [
        open
    ]);
    const handleAssign = ()=>{
        onAssign(selectedHangarId);
    };
    // Helper to check if aircraft is too large for hangar (width or length)
    const isTooLarge = (hangar)=>{
        if (!aircraftWingspan && !aircraftLength) return false;
        // Check wingspan vs usable width
        const widthIssue = aircraftWingspan && hangar.width ? aircraftWingspan > hangar.width - (hangar.left_door || 0) - (hangar.right_door || 0) : false;
        // Check aircraft length vs hangar depth
        const depthIssue = aircraftLength && hangar.depth ? aircraftLength > hangar.depth : false;
        return widthIssue || depthIssue;
    };
    // Group hangars and ramps with memoization
    const { hangars: hangars, ramps: ramps } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return availableHangars.reduce((acc, h)=>{
            if (h.id.includes("ramp")) acc.ramps.push(h);
            else acc.hangars.push(h);
            return acc;
        }, {
            hangars: [],
            ramps: []
        });
    }, [
        availableHangars
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ejcfT.default), {
                children: [
                    "Assign Aircraft to Location",
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        children: [
                            aircraftTail,
                            " \u2022 ",
                            aircraftModel
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                    component: "fieldset",
                    fullWidth: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8IWga.default), {
                        value: selectedHangarId,
                        onChange: (e)=>setSelectedHangarId(e.target.value),
                        children: [
                            hangars.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle2",
                                        color: "text.secondary",
                                        sx: {
                                            ml: 1,
                                            mb: 0.5
                                        },
                                        children: "Hangars"
                                    }),
                                    hangars.map((hangar)=>{
                                        const tooLarge = isTooLarge(hangar);
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                            value: hangar.id,
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {}),
                                            label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        children: hangar.name
                                                    }),
                                                    tooLarge && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                        direction: "row",
                                                        spacing: 0.5,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3LBtW))), {
                                                                sx: {
                                                                    fontSize: 16,
                                                                    color: "warning.main"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "caption",
                                                                color: "warning.main",
                                                                children: "May be too small"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, hangar.id);
                                    })
                                ]
                            }),
                            ramps.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                        sx: {
                                            my: 1.5
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle2",
                                        color: "text.secondary",
                                        sx: {
                                            ml: 1,
                                            mb: 0.5
                                        },
                                        children: "Ramps"
                                    }),
                                    ramps.map((ramp)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                            value: ramp.id,
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {}),
                                            label: ramp.name
                                        }, ramp.id))
                                ]
                            }),
                            hangars.length === 0 && ramps.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "text.secondary",
                                sx: {
                                    textAlign: "center",
                                    py: 3
                                },
                                children: "No hangars or ramps available"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: onClose,
                        disabled: isAssigning,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleAssign,
                        variant: "contained",
                        disabled: !selectedHangarId || isAssigning,
                        children: isAssigning ? "Assigning..." : "Assign"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("3LBtW", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2be2d5fda6f09cee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2be2d5fda6f09cee$var$_createSvgIcon = $2be2d5fda6f09cee$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2be2d5fda6f09cee$var$_default = module.exports.default = (0, $2be2d5fda6f09cee$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], 'WarningAmber');

});




parcelRegister("2sRWk", function(module, exports) {

$parcel$export(module.exports, "HangarSkeleton", () => $cf6127258aa30d81$export$4a889442e59c94a1);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $lkxXU = parcelRequire("lkxXU");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $cf6127258aa30d81$export$4a889442e59c94a1 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            height: "100%",
            width: "100%",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: {
                        p: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                variant: "text",
                                width: 250,
                                height: 40
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rounded",
                                    width: 120,
                                    height: 40,
                                    sx: {
                                        animation: "pulse 1.5s ease-in-out 0.5s infinite"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rounded",
                                    width: 120,
                                    height: 40,
                                    sx: {
                                        animation: "pulse 1.5s ease-in-out 0.6s infinite"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rounded",
                                    width: 120,
                                    height: 40,
                                    sx: {
                                        animation: "pulse 1.5s ease-in-out 0.7s infinite"
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    sx: {
                        height: "calc(100% - 64px)",
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 2,
                            sx: {
                                width: 300,
                                p: 2,
                                borderRight: "1px solid rgba(0, 0, 0, 0.12)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                    variant: "outlined",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "h6",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                        width: 150
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 80
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 60
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 80
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 60
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 80
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 60
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 120
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 40
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 120
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 40
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                width: 120
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                width: 60
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle1",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                        width: 150
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    spacing: 1,
                                    children: [
                                        ...Array(5)
                                    ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                            variant: "outlined",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                                                sx: {
                                                    py: 1,
                                                    "&:last-child": {
                                                        pb: 1
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                            variant: "rectangular",
                                                            width: 40,
                                                            height: 40,
                                                            sx: {
                                                                borderRadius: 1,
                                                                animation: `pulse 1.5s ease-in-out ${0.5 + index * 0.1}s infinite`
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "body2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 120
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "caption",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        width: 80
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                            sx: {
                                                                ml: "auto"
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                variant: "circular",
                                                                width: 24,
                                                                height: 24,
                                                                sx: {
                                                                    animation: `pulse 1.5s ease-in-out ${0.6 + index * 0.1}s infinite`
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }, `aircraft-skeleton-${index}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                flex: 1,
                                position: "relative",
                                backgroundColor: "#f5f5f5",
                                overflow: "hidden"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: "100%",
                                    sx: {
                                        position: "absolute",
                                        animation: "pulse 1.5s ease-in-out 0.3s infinite",
                                        opacity: 0.7
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "80%",
                                    height: 8,
                                    sx: {
                                        position: "absolute",
                                        top: "2%",
                                        left: "10%",
                                        animation: "pulse 1.5s ease-in-out 0.4s infinite",
                                        opacity: 0.8
                                    }
                                }),
                                [
                                    ...Array(4)
                                ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                        variant: "rounded",
                                        width: 120 + index % 2 * 40,
                                        height: 60 + index % 3 * 20,
                                        sx: {
                                            position: "absolute",
                                            top: `${15 + index % 3 * 25}%`,
                                            left: `${20 + index % 2 * 30}%`,
                                            animation: `pulse 1.5s ease-in-out ${0.5 + index * 0.2}s infinite`,
                                            opacity: 0.6,
                                            transform: `rotate(${index * 45}deg)`
                                        }
                                    }, `aircraft-shape-${index}`)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rounded",
                                    width: 80,
                                    height: 80,
                                    sx: {
                                        position: "absolute",
                                        top: "70%",
                                        left: "70%",
                                        animation: "pulse 1.5s ease-in-out 0.8s infinite",
                                        opacity: 0.5
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    spacing: 1,
                                    sx: {
                                        position: "absolute",
                                        bottom: 16,
                                        right: 16
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            variant: "circular",
                                            width: 40,
                                            height: 40,
                                            sx: {
                                                animation: "pulse 1.5s ease-in-out 0.9s infinite"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            variant: "circular",
                                            width: 40,
                                            height: 40,
                                            sx: {
                                                animation: "pulse 1.5s ease-in-out 1.0s infinite"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});



parcelRegister("aYEL3", function(module, exports) {
$parcel$export(module.exports, "BorderedBox", () => (parcelRequire("1nUr4")).BorderedBox);
parcelRequire("1nUr4");

});
parcelRegister("1nUr4", function(module, exports) {

$parcel$export(module.exports, "BorderedBox", () => $c4962f1a06447107$export$663fc9cd9987d3de);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
const $c4962f1a06447107$export$663fc9cd9987d3de = ({ sx: sx, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            border: 1,
            borderColor: "divider",
            p: 1,
            ...sx
        },
        children: children
    });

});



parcelRegister("7UqNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c228c234852d575$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $bnA1h = parcelRequire("bnA1h");

var $7Frhn = parcelRequire("7Frhn");

var $7Snug = parcelRequire("7Snug");

var $3yddg = parcelRequire("3yddg");

var $6lpak = parcelRequire("6lpak");

var $jliMD = parcelRequire("jliMD");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        heading: [
            'heading'
        ],
        region: [
            'region'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jliMD.getAccordionUtilityClass), classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $jliMD.default).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $jliMD.default).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $jliMD.default).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}), (0, $aeD7H.default)(({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $jliMD.default).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    })));
const $5c228c234852d575$var$AccordionHeading = (0, $d8seH.default)('h3', {
    name: 'MuiAccordion',
    slot: 'Heading',
    overridesResolver: (props, styles)=>styles.heading
})({
    all: 'unset'
});
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $acw62.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, ...other } = props;
    const [expanded, setExpandedState] = (0, $3yddg.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $acw62.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $acw62.Children.toArray(childrenProp);
    const contextValue = $acw62.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = {
        ...props,
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    };
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $5c228c234852d575$var$AccordionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        className: (0, $9QePP.default)(classes.root, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        additionalProps: {
            square: square
        }
    });
    const [AccordionHeadingSlot, accordionProps] = (0, $6lpak.default)('heading', {
        elementType: $5c228c234852d575$var$AccordionHeading,
        externalForwardedProps: externalForwardedProps,
        className: classes.heading,
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $bnA1h.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(AccordionHeadingSlot, {
                ...accordionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Snug.default).Provider, {
                    value: contextValue,
                    children: summary
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                in: expanded,
                timeout: "auto",
                ...transitionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            })
        ]
    });
});
var $5c228c234852d575$export$2e2bcd8739ae039 = $5c228c234852d575$var$Accordion;

});
parcelRegister("7Snug", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bbfcb95732dc207$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $acw62.createContext({});
var $5bbfcb95732dc207$export$2e2bcd8739ae039 = $5bbfcb95732dc207$var$AccordionContext;

});

parcelRegister("jliMD", function(module, exports) {

$parcel$export(module.exports, "getAccordionUtilityClass", () => $e14e8c767477d992$export$80fb6a2cb3f13b8b);
$parcel$export(module.exports, "default", () => $e14e8c767477d992$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e14e8c767477d992$export$80fb6a2cb3f13b8b(slot) {
    return (0, $4Cod0.default)('MuiAccordion', slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $beCSm.default)('MuiAccordion', [
    'root',
    'heading',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $e14e8c767477d992$export$2e2bcd8739ae039 = $e14e8c767477d992$var$accordionClasses;

});


parcelRegister("2mdyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b78273c1c27a2e1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $9t5XO = parcelRequire("9t5XO");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9t5XO.getAccordionDetailsUtilityClass), classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $d8seH.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $aeD7H.default)(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    })));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $acw62.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $1b78273c1c27a2e1$export$2e2bcd8739ae039 = $1b78273c1c27a2e1$var$AccordionDetails;

});
parcelRegister("9t5XO", function(module, exports) {

$parcel$export(module.exports, "getAccordionDetailsUtilityClass", () => $6e4b72c3145e33d8$export$a6afb527becfac26);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e4b72c3145e33d8$export$a6afb527becfac26(slot) {
    return (0, $4Cod0.default)('MuiAccordionDetails', slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $beCSm.default)('MuiAccordionDetails', [
    'root'
]);
var $6e4b72c3145e33d8$export$2e2bcd8739ae039 = $6e4b72c3145e33d8$var$accordionDetailsClasses;

});


parcelRegister("2gURC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a792f5a0c37e2ab$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $7Snug = parcelRequire("7Snug");

var $ijHn9 = parcelRequire("ijHn9");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ijHn9.getAccordionSummaryUtilityClass), classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $aeD7H.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $ijHn9.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $ijHn9.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $ijHn9.default).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $ijHn9.default).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
}));
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $d8seH.default)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $ijHn9.default).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    })));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $d8seH.default)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $ijHn9.default).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    })));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $acw62.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick, slots: slots, slotProps: slotProps, ...other } = props;
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $acw62.useContext((0, $7Snug.default));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = {
        ...props,
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    };
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled: disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [ContentSlot, contentSlotProps] = (0, $6lpak.default)('content', {
        className: classes.content,
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = (0, $6lpak.default)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(ContentSlot, {
                ...contentSlotProps,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)(ExpandIconWrapperSlot, {
                ...expandIconWrapperSlotProps,
                children: expandIcon
            })
        ]
    });
});
var $1a792f5a0c37e2ab$export$2e2bcd8739ae039 = $1a792f5a0c37e2ab$var$AccordionSummary;

});
parcelRegister("ijHn9", function(module, exports) {

$parcel$export(module.exports, "getAccordionSummaryUtilityClass", () => $d55ba52db43b55df$export$282216ad123d6580);
$parcel$export(module.exports, "default", () => $d55ba52db43b55df$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d55ba52db43b55df$export$282216ad123d6580(slot) {
    return (0, $4Cod0.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $beCSm.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$export$2e2bcd8739ae039 = $d55ba52db43b55df$var$accordionSummaryClasses;

});



parcelRegister("hKDIt", function(module, exports) {

$parcel$export(module.exports, "HangarRow", () => $b6ed8cf86999f796$export$af5d4292ceaa4bd6);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $kfA3C = parcelRequire("kfA3C");
parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $7R9OT = parcelRequire("7R9OT");

var $5YoAr = parcelRequire("5YoAr");
const $b6ed8cf86999f796$export$af5d4292ceaa4bd6 = ({ hangar: hangar, aircraftInside: aircraftInside, aircraftTotal: aircraftTotal, utilizationStacked: utilizationStacked, utilizationAll: utilizationAll, estimatedValue: estimatedValue, estimatedTowTime: estimatedTowTime, lastStacked: lastStacked, displayEditTenants: displayEditTenants, enableScheduling: enableScheduling, isTablet: isTablet, displayEstimatedValue: displayEstimatedValue })=>{
    const navigate = (0, $aphAM.useNavigate)();
    const gridColumns = isTablet ? "200px 160px 180px 120px 1fr" : displayEstimatedValue ? "200px 160px 180px 120px 140px 120px 1fr" : "200px 160px 180px 140px 120px 1fr";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            display: "grid",
            gridTemplateColumns: gridColumns,
            alignItems: "center",
            gap: 2,
            px: 2.5,
            py: 1.5,
            borderBottom: "1px solid",
            borderColor: "grey.200",
            transition: "background-color 0.15s ease",
            "&:hover": {
                bgcolor: "action.hover"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                sx: {
                    fontWeight: 600
                },
                children: hangar.name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    textAlign: "right"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "body2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            component: "span",
                            sx: {
                                fontWeight: 500
                            },
                            children: aircraftInside
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            component: "span",
                            color: "text.secondary",
                            sx: {
                                mx: 0.5
                            },
                            children: "of"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            component: "span",
                            sx: {
                                fontWeight: 500
                            },
                            children: aircraftTotal
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            component: "span",
                            color: "text.secondary",
                            sx: {
                                ml: 0.5
                            },
                            children: "aircraft"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5YoAr.UtilizationDisplay), {
                stackedUtilization: utilizationStacked,
                allUtilization: utilizationAll
            }),
            !isTablet && displayEstimatedValue && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    textAlign: "right"
                },
                children: estimatedValue
            }),
            !isTablet && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    textAlign: "right"
                },
                children: estimatedTowTime
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: lastStacked ? lastStacked.toISOString() : "Never stacked",
                arrow: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body2",
                    color: "text.secondary",
                    sx: {
                        fontWeight: 400,
                        textAlign: "right"
                    },
                    children: lastStacked ? (0, $kfA3C.format)(lastStacked, "MMM d") : "Never"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                justifyContent: "flex-end",
                sx: {
                    flexWrap: "nowrap"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "contained",
                        color: "success",
                        onClick: ()=>{
                            (0, $7R9OT.default).track("Clicked Hangar", {
                                location_name: hangar.name,
                                location_type: "hangar"
                            });
                            navigate(`/hangars/${hangar.id}`);
                        },
                        sx: {
                            whiteSpace: "nowrap",
                            minWidth: "fit-content",
                            px: 1.5,
                            py: 0.4,
                            fontSize: "0.75rem",
                            borderRadius: "14px"
                        },
                        children: "Current Hangar"
                    }),
                    enableScheduling && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "contained",
                        color: "secondary",
                        onClick: ()=>{
                            (0, $7R9OT.default).track("Clicked Hangar Schedule", {
                                location_name: hangar.name,
                                location_type: "hangar"
                            });
                            navigate(`/hangars/${hangar.id}/schedule`);
                        },
                        sx: {
                            whiteSpace: "nowrap",
                            minWidth: "fit-content",
                            px: 1.5,
                            py: 0.4,
                            fontSize: "0.75rem",
                            borderRadius: "14px"
                        },
                        children: "Hangar Schedule"
                    }),
                    displayEditTenants && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "outlined",
                        sx: {
                            color: "text.primary",
                            borderColor: "grey.300",
                            whiteSpace: "nowrap",
                            minWidth: "fit-content",
                            px: 1.5,
                            py: 0.4,
                            fontSize: "0.75rem",
                            borderRadius: "14px",
                            "&:hover": {
                                borderColor: "grey.400",
                                bgcolor: "grey.50"
                            }
                        },
                        onClick: ()=>{
                            navigate(`/reference-hangars/${hangar.id}`);
                        },
                        children: "Edit Tenants"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("5YoAr", function(module, exports) {

$parcel$export(module.exports, "UtilizationDisplay", () => $6b7b39b0cede4d54$export$614521fafc44558d);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");
const $6b7b39b0cede4d54$export$614521fafc44558d = ({ stackedUtilization: stackedUtilization, allUtilization: allUtilization })=>{
    const theme = (0, $14H9o.default)();
    // Color based on baseline (100%): green if above, blue if below
    const primaryColor = stackedUtilization >= 100 ? theme.palette.success.main : theme.palette.primary.main;
    const fillPercentage = Math.min(stackedUtilization, 200); // Cap at 200% for display
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 0.5,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                alignItems: "baseline",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body1",
                        sx: {
                            fontWeight: 700,
                            color: primaryColor
                        },
                        children: [
                            Math.round(stackedUtilization),
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "text.secondary",
                        children: "stacked"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    position: "relative",
                    width: "100px",
                    height: 5,
                    mt: 0.5
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            position: "absolute",
                            top: "50%",
                            transform: "translateY(-50%)",
                            left: 0,
                            width: "100%",
                            height: 1,
                            bgcolor: "divider"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: `${Math.min(fillPercentage / 200 * 100, 50)}%`,
                            height: "100%",
                            bgcolor: "primary.main",
                            borderRadius: stackedUtilization >= 100 ? "100px 0 0 100px" : "100px",
                            transition: "width 0.3s ease-in-out"
                        }
                    }),
                    stackedUtilization > 100 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            position: "absolute",
                            top: 0,
                            left: "50%",
                            width: `${Math.min((fillPercentage - 100) / 200 * 100, 50)}%`,
                            height: "100%",
                            bgcolor: "success.main",
                            borderRadius: "0 100px 100px 0",
                            transition: "width 0.3s ease-in-out"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            position: "absolute",
                            top: -1,
                            left: "50%",
                            width: 2,
                            height: 7,
                            bgcolor: theme.palette.grey[500]
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "caption",
                color: "text.secondary",
                sx: {
                    lineHeight: 1.2
                },
                children: [
                    Math.round(allUtilization),
                    "% at full tenant load"
                ]
            })
        ]
    });
};

});


parcelRegister("44Pku", function(module, exports) {

$parcel$export(module.exports, "HangarsSkeleton", () => $84079684c4c4d762$export$d0b3c3a1e851eb92);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
const $84079684c4c4d762$export$d0b3c3a1e851eb92 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            ml: 2,
            mr: 2,
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    sx: {
                        mt: 2,
                        mb: 2
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                        variant: "text",
                        width: 300,
                        height: 40
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 2,
                    sx: {
                        mb: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            justifyContent: "space-between",
                            sx: {
                                minWidth: 500
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                    variant: "outlined",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle1",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                    width: 120
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "h5",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                    width: 40
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                    variant: "outlined",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle1",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                    width: 180
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "h5",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                    width: 40
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            direction: "column",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                            sx: {
                                width: 200,
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                variant: "rounded",
                                width: 180,
                                height: 40
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                    variant: "rectangular",
                    height: "calc(100vh - 200px)",
                    width: "100%",
                    sx: {
                        minHeight: 400,
                        animation: "pulse 1.5s ease-in-out 0.5s infinite"
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        display: "none"
                    },
                    children: [
                        ...Array(5)
                    ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            sx: {
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 200,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 150,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 175,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 115,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 140,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 125,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 250,
                                    height: 30
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};

});

parcelRegister("3Zybu", function(module, exports) {

$parcel$export(module.exports, "MultiHangarButton", () => $3c6959c6cde36412$export$dc24bea652073fb1);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $gd5y7 = parcelRequire("gd5y7");
var $OEVqP = parcelRequire("OEVqP");
var $19ocJ = parcelRequire("19ocJ");
var $2iAqv = parcelRequire("2iAqv");
var $imehR = parcelRequire("imehR");
var $cX7V2 = parcelRequire("cX7V2");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ZD2ym = parcelRequire("ZD2ym");

var $97sqG = parcelRequire("97sqG");
const $3c6959c6cde36412$var$CustomCheckbox = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: 2,
            borderColor: "grey.500",
            borderRadius: 0.5,
            height: 20,
            width: 20
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            alignSelf: "center",
            alignContent: "center",
            alignItems: "center",
            textAlign: "center",
            variant: "inherit",
            children: children
        })
    });
const $3c6959c6cde36412$var$ITEM_HEIGHT = 48;
const $3c6959c6cde36412$var$ITEM_PADDING_TOP = 8;
const $3c6959c6cde36412$var$MenuProps = {
    PaperProps: {
        style: {
            maxHeight: $3c6959c6cde36412$var$ITEM_HEIGHT * 15 + $3c6959c6cde36412$var$ITEM_PADDING_TOP,
            width: 250
        }
    }
};
const $3c6959c6cde36412$export$dc24bea652073fb1 = ({ hangars: hangars })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const navigate = (0, $aphAM.useNavigate)();
    const [selectedHangarIds, setSelectedHangarIds] = $acw62.useState([]);
    const hangarsSorted = [
        ...hangars
    ].sort((a, b)=>(0, $97sqG.sortHangars)(a, b, activeFBO?.settings?.hangarDisplayOrder));
    const handleChange = (event)=>{
        const { target: { value: value } } = event;
        if (value.includes("all")) {
            if (selectedHangarIds.length === hangars.length) {
                setSelectedHangarIds([]);
                return;
            }
            setSelectedHangarIds(hangars.map((h)=>h.id));
            return;
        }
        setSelectedHangarIds(typeof value === "string" ? value.split(",") : value);
    };
    const handleGo = ()=>{
        const urlIds = selectedHangarIds.map((id)=>hangars.find((h)=>h.id === id)).map((h)=>h?.id).filter(Boolean).join("|");
        const goURL = `/multi-hangar/${urlIds}`;
        navigate(goURL);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                sx: {
                    width: 240
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                        size: "small",
                        children: "Multi-Hangar"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                        multiple: true,
                        value: selectedHangarIds,
                        onChange: handleChange,
                        input: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $imehR.default), {
                            size: "small",
                            label: "Multi-Hangar"
                        }),
                        renderValue: (selected)=>selected.map((s)=>hangarsSorted.find((h)=>h.id === s)?.name).filter(Boolean).join(", "),
                        MenuProps: $3c6959c6cde36412$var$MenuProps,
                        children: [
                            hangars.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                disabled: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                    primary: "No hangars available",
                                    secondary: "Create hangars in Settings",
                                    primaryTypographyProps: {
                                        fontSize: "14px",
                                        fontStyle: "italic"
                                    },
                                    secondaryTypographyProps: {
                                        fontSize: "12px"
                                    }
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                value: "all",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                        checked: Boolean(selectedHangarIds.length === hangars.length),
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3c6959c6cde36412$var$CustomCheckbox, {
                                            children: ""
                                        }),
                                        checkedIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($3c6959c6cde36412$var$CustomCheckbox, {
                                            children: "\u2713"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                        primary: "Select All"
                                    })
                                ]
                            }, `option-multihangar-all`),
                            hangarsSorted.map((hangar)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                    value: hangar.id,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                            checked: Boolean(selectedHangarIds.indexOf(hangar.id) > -1),
                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3c6959c6cde36412$var$CustomCheckbox, {
                                                children: ""
                                            }),
                                            checkedIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($3c6959c6cde36412$var$CustomCheckbox, {
                                                children: selectedHangarIds.indexOf(hangar.id) + 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                            primary: hangar.name
                                        })
                                    ]
                                }, `option-multihangar-${hangar.id}`))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                size: "small",
                variant: "contained",
                color: "success",
                disabled: selectedHangarIds.length === 0,
                onClick: handleGo,
                children: "Go"
            })
        ]
    });
};

});




parcelRegister("7zk06", function(module, exports) {
$parcel$export(module.exports, "Hangar", () => (parcelRequire("9TSbO")).Hangar);
parcelRequire("9TSbO");

});
parcelRegister("9TSbO", function(module, exports) {

$parcel$export(module.exports, "Hangar", () => $36038551eb26a771$export$a38c2c143dd4cd6b);

var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $ggtZr = parcelRequire("ggtZr");

var $7FzhI = parcelRequire("7FzhI");

var $jRWDn = parcelRequire("jRWDn");

var $3AGzj = parcelRequire("3AGzj");

var $6AlVH = parcelRequire("6AlVH");

var $gvs0W = parcelRequire("gvs0W");
const $36038551eb26a771$export$a38c2c143dd4cd6b = ({ hangarId: hangarId, isReference: isReference, ..._props })=>{
    const { id: hangarIdFromRoute } = (0, $aphAM.useParams)();
    const [stacks, setStacks] = $acw62.useState([]);
    return(// RampsStateContainer and HangarsStateContainer might seem weird. it's for the selection menus
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
        isReference: isReference ?? false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
            isReference: isReference ?? false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggtZr.HangarStateContainer), {
                initialState: {
                    hangar_id: hangarId ?? hangarIdFromRoute,
                    isReference: isReference ?? false
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRWDn.PredefinedObstaclesContainer), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6AlVH.TowingEquipmentContainer), {
                        children: [
                            isReference && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                severity: "warning",
                                children: "This is your Base Tenant Reference Hangar. It only shows your base tenants and is distinct from your active Current Hangar."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gvs0W.HangarPresenter), {
                                id: hangarIdFromRoute,
                                stacks: stacks,
                                setStacks: setStacks,
                                isReference: isReference
                            })
                        ]
                    })
                })
            })
        })
    }));
};

});
parcelRegister("jRWDn", function(module, exports) {

$parcel$export(module.exports, "PredefinedObstaclesContainer", () => $ac361ba209bd36c6$export$489ff607f2df6f1e);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $ac361ba209bd36c6$var$PredefinedObstaclesContainerState = /*#__PURE__*/ $acw62.createContext({
    loading: false,
    predefinedObstacles: [],
    setPredefinedObstacles: function() {}
});
const $ac361ba209bd36c6$export$489ff607f2df6f1e = ({ children: children })=>{
    const data = $ac361ba209bd36c6$export$8c65094e5bd7c5a6();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ac361ba209bd36c6$var$PredefinedObstaclesContainerState.Provider, {
        value: data,
        children: children
    });
};
const $ac361ba209bd36c6$export$8c65094e5bd7c5a6 = ()=>$acw62.useContext($ac361ba209bd36c6$var$PredefinedObstaclesContainerState);

});



parcelRegister("iFplc", function(module, exports) {

$parcel$export(module.exports, "HangarDimensionsForm", () => $28af8030da83eaa4$export$4fa49f09abb7db4c);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $ipR47 = parcelRequire("ipR47");

var $3zG2N = parcelRequire("3zG2N");

var $03mUs = parcelRequire("03mUs");
var $2esSG = parcelRequire("2esSG");
var $9Lykx = parcelRequire("9Lykx");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $6lXkL = parcelRequire("6lXkL");

var $ioYla = parcelRequire("ioYla");

var $9Pb0P = parcelRequire("9Pb0P");

var $acw62 = parcelRequire("acw62");

var $5sKyw = parcelRequire("5sKyw");

var $lTOh0 = parcelRequire("lTOh0");

var $ZD2ym = parcelRequire("ZD2ym");

var $lNEp2 = parcelRequire("lNEp2");

var $kzQHY = parcelRequire("kzQHY");

var $8vHzJ = parcelRequire("8vHzJ");

var $fbENC = parcelRequire("fbENC");

var $aVGl3 = parcelRequire("aVGl3");
const $28af8030da83eaa4$export$4fa49f09abb7db4c = ({ localHangar: localHangar, setLocalHangar: setLocalHangar, hideGarageDoors: hideGarageDoors = false, setIGarageDoor: setIGarageDoor, activeTab: activeTab, bayDefinitions: externalBayDefinitions, bayOrientation: externalBayOrientation, useBayHeights: externalUseBayHeights, onBayConfigChange: onBayConfigChange })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const unit = activeFBO?.settings?.useMetricSystem ? "m" : "ft";
    const step = activeFBO?.settings?.useMetricSystem ? 0.1 : 0.5;
    // Bay configuration - fully controlled by parent
    const useBayHeights = externalUseBayHeights ?? false;
    const bayDefinitions = externalBayDefinitions ?? [];
    const bayOrientation = externalBayOrientation ?? "lateral";
    // Don't create wrapper setters - just call onBayConfigChange directly in the JSX
    // This avoids stale closure issues
    const usableSquareFootage = $acw62.useMemo(()=>{
        if (!localHangar) return 0;
        const grossSquareFootage = localHangar?.width * localHangar?.depth;
        if (!activeFBO?.settings?.ignoreDeadSpaceForUtilization) return grossSquareFootage;
        try {
            const obstaclePolygons = localHangar?.obstacles?.map((obstacle)=>{
                const p = (0, $ioYla.polygon)([
                    [
                        [
                            obstacle.x,
                            obstacle.y
                        ],
                        [
                            obstacle.x,
                            obstacle.y + obstacle.depth
                        ],
                        [
                            obstacle.x + obstacle.width,
                            obstacle.y + obstacle.depth
                        ],
                        [
                            obstacle.x + obstacle.width,
                            obstacle.y
                        ],
                        [
                            obstacle.x,
                            obstacle.y
                        ]
                    ]
                ]);
                return p;
            });
            const spacingPolygons = [
                (0, $ioYla.polygon)([
                    [
                        [
                            0,
                            0
                        ],
                        [
                            0,
                            localHangar?.depth || 0
                        ],
                        [
                            localHangar?.wall_spacing_left || 0,
                            localHangar?.depth || 0
                        ],
                        [
                            localHangar?.wall_spacing_left || 0,
                            0
                        ],
                        [
                            0,
                            0
                        ]
                    ]
                ]),
                (0, $ioYla.polygon)([
                    [
                        [
                            localHangar?.width || 0,
                            0
                        ],
                        [
                            localHangar?.width || 0,
                            localHangar?.depth || 0
                        ],
                        [
                            (localHangar?.width || 0) - (localHangar?.wall_spacing_right || 0),
                            localHangar?.depth || 0
                        ],
                        [
                            (localHangar?.width || 0) - (localHangar?.wall_spacing_right || 0),
                            0
                        ],
                        [
                            localHangar?.width || 0,
                            0
                        ]
                    ]
                ]),
                (0, $ioYla.polygon)([
                    [
                        [
                            0,
                            localHangar?.depth || 0
                        ],
                        [
                            localHangar?.width || 0,
                            localHangar?.depth || 0
                        ],
                        [
                            localHangar?.width || 0,
                            (localHangar?.depth || 0) - (localHangar?.wall_spacing_back || 0)
                        ],
                        [
                            0,
                            (localHangar?.depth || 0) - (localHangar?.wall_spacing_back || 0)
                        ],
                        [
                            0,
                            localHangar?.depth || 0
                        ]
                    ]
                ])
            ].filter((_)=>false);
            const polygonsToUnion = [
                ...obstaclePolygons,
                ...spacingPolygons
            ];
            const unionPolygon = polygonsToUnion.length <= 1 ? polygonsToUnion[0] : (0, $9Pb0P.default)((0, $ioYla.featureCollection)(polygonsToUnion));
            if (!unionPolygon) {
                console.info("No union polygon");
                return grossSquareFootage;
            }
            const obstacleSquareFootage = (0, $8vHzJ.calculateGeometryArea)(unionPolygon.geometry);
            return grossSquareFootage - obstacleSquareFootage;
        } catch (e) {
            console.error(e);
            // if all else fails just return the gross square footage
            return grossSquareFootage;
        }
    }, [
        localHangar
    ]);
    if (!localHangar) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                value: activeTab,
                index: 0,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 2,
                    sx: {
                        width: "100%",
                        maxWidth: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        fullWidth: true,
                        size: "small",
                        label: "Hangar Name",
                        onChange: (evt)=>setLocalHangar({
                                ...localHangar,
                                name: evt.target.value
                            }),
                        value: localHangar?.name ?? ""
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                value: activeTab,
                index: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 2,
                    sx: {
                        width: "100%",
                        maxWidth: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                    disabled: activeFBO?.subscription === "standard",
                                    type: "number",
                                    fullWidth: true,
                                    InputProps: {
                                        inputProps: {
                                            min: 50,
                                            max: 600
                                        }
                                    },
                                    size: "small",
                                    label: `Width (${unit})`,
                                    onChange: (value)=>setLocalHangar({
                                            ...localHangar,
                                            width: Math.min(600, value)
                                        }),
                                    value: localHangar?.width
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                    unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                    disabled: activeFBO?.subscription === "standard",
                                    type: "number",
                                    fullWidth: true,
                                    InputProps: {
                                        inputProps: {
                                            min: 50,
                                            max: 600
                                        }
                                    },
                                    size: "small",
                                    label: `Depth (${unit})`,
                                    onChange: (value)=>setLocalHangar({
                                            ...localHangar,
                                            depth: Math.min(600, value)
                                        }),
                                    value: localHangar?.depth
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            justifyContent: "space-around",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            children: "Gross Square Footage"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            children: (0, $lNEp2.formatUnit)(localHangar?.width * localHangar?.depth, true, activeFBO?.settings?.useMetricSystem)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            children: "Usable Square Footage"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            children: (0, $lNEp2.formatUnit)(usableSquareFootage, true, activeFBO?.settings?.useMetricSystem)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Door Pockets"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                            unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                            disabled: activeFBO?.subscription === "standard",
                                            type: "number",
                                            fullWidth: true,
                                            InputProps: {
                                                inputProps: {
                                                    min: 0,
                                                    max: 200
                                                }
                                            },
                                            size: "small",
                                            label: `Left Door Length (${unit})`,
                                            onChange: (value)=>setLocalHangar({
                                                    ...localHangar,
                                                    left_door: value
                                                }),
                                            value: localHangar?.left_door
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                            unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                            disabled: activeFBO?.subscription === "standard",
                                            type: "number",
                                            fullWidth: true,
                                            InputProps: {
                                                inputProps: {
                                                    min: 0,
                                                    max: 200
                                                }
                                            },
                                            size: "small",
                                            label: `Right Door Length (${unit})`,
                                            onChange: (value)=>setLocalHangar({
                                                    ...localHangar,
                                                    right_door: value
                                                }),
                                            value: localHangar?.right_door
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Door Dimensions"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                        unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                        disabled: true,
                                        type: "number",
                                        fullWidth: true,
                                        InputProps: {
                                            inputProps: {
                                                min: 1,
                                                max: 200
                                            }
                                        },
                                        size: "small",
                                        label: `Width (${unit})`,
                                        value: localHangar?.width - (localHangar?.left_door + localHangar?.right_door),
                                        onChange: ()=>{}
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                value: activeTab,
                index: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 2,
                    sx: {
                        width: "100%",
                        maxWidth: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                children: "Height Configuration"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                            checked: useBayHeights,
                                            onChange: (e)=>onBayConfigChange?.({
                                                    useBayHeights: e.target.checked,
                                                    bayDefinitions: bayDefinitions,
                                                    bayOrientation: bayOrientation
                                                })
                                        }),
                                        label: "Use bay-specific heights"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: "Enable for stepped-eave hangars with different height zones. Each bay can have its own eave and clear height.",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            fontSize: "small",
                                            color: "action"
                                        })
                                    })
                                ]
                            }),
                            !useBayHeights ? // Single height field for uniform hangars
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                        unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                        disabled: activeFBO?.subscription === "standard",
                                        type: "number",
                                        fullWidth: true,
                                        InputProps: {
                                            inputProps: {
                                                min: 1,
                                                max: 200
                                            }
                                        },
                                        size: "small",
                                        label: `Height (${unit})`,
                                        onChange: (value)=>setLocalHangar({
                                                ...localHangar,
                                                height: value
                                            }),
                                        value: localHangar?.height
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: "Eave height for uniform hangars. This is the vertical clearance from floor to the lowest point of the roof structure.",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            fontSize: "small",
                                            color: "action",
                                            sx: {
                                                mt: 1
                                            }
                                        })
                                    })
                                ]
                            }) : // Bay editor for stepped-eave hangars
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    maxWidth: 600
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fbENC.HangarBayEditor), {
                                    hangarWidth: localHangar?.width || 0,
                                    hangarDepth: localHangar?.depth || 0,
                                    bayDefinitions: bayDefinitions,
                                    bayOrientation: bayOrientation,
                                    onChange: (bays, orientation)=>{
                                        onBayConfigChange?.({
                                            useBayHeights: useBayHeights,
                                            bayDefinitions: bays,
                                            bayOrientation: orientation
                                        });
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lTOh0.TabPanel), {
                value: activeTab,
                index: 3,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 2,
                    sx: {
                        width: "100%",
                        maxWidth: "100%"
                    },
                    children: [
                        hideGarageDoors ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            children: "Garage Doors"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            disabled: activeFBO?.subscription === "standard",
                                            size: "small",
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                            onClick: ()=>{
                                                setLocalHangar({
                                                    ...localHangar,
                                                    garageDoors: localHangar?.garageDoors?.concat([
                                                        {
                                                            id: (0, $5sKyw.default)(),
                                                            fbo_id: activeFBO.id,
                                                            hangar_id: localHangar?.id,
                                                            wall: "left",
                                                            x: 0,
                                                            y: 0,
                                                            width: 10
                                                        }
                                                    ])
                                                });
                                            },
                                            children: "Add"
                                        })
                                    ]
                                }),
                                (localHangar?.garageDoors?.length || 0) === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: {
                                        py: 2,
                                        textAlign: "center"
                                    },
                                    children: "No garage doors. Click Add to create one."
                                }) : localHangar?.garageDoors?.map((garageDoor, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                                disabled: activeFBO?.subscription === "standard",
                                                select: true,
                                                size: "small",
                                                label: "Wall",
                                                fullWidth: true,
                                                onChange: (evt)=>{
                                                    const wall = evt.target.value;
                                                    const x = wall === "back" ? garageDoor.x : wall === "right" ? localHangar?.width : 0;
                                                    const y = wall !== "back" ? garageDoor.y : localHangar?.depth;
                                                    setIGarageDoor(idx, {
                                                        ...garageDoor,
                                                        wall: wall,
                                                        x: x,
                                                        y: y
                                                    });
                                                },
                                                value: garageDoor.wall,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "left",
                                                        children: "Left"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "back",
                                                        children: "Back"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "right",
                                                        children: "Right"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                                unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                                disabled: activeFBO?.subscription === "standard",
                                                type: "number",
                                                fullWidth: true,
                                                inputProps: {
                                                    min: 0,
                                                    max: garageDoor.wall === "back" ? localHangar?.width || 0 : localHangar?.depth || 0,
                                                    step: step
                                                },
                                                size: "small",
                                                onChange: (width)=>{
                                                    setIGarageDoor(idx, {
                                                        ...garageDoor,
                                                        width: width
                                                    });
                                                },
                                                value: garageDoor.width,
                                                label: "Width"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                disabled: activeFBO?.subscription === "standard",
                                                color: "error",
                                                onClick: ()=>setLocalHangar({
                                                        ...localHangar,
                                                        garageDoors: localHangar?.garageDoors?.filter((x, i)=>i !== idx)
                                                    }),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3zG2N))), {})
                                            })
                                        ]
                                    }, `garage-door-${idx}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Obstacles"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVGl3.ObstacleToolbar), {
                                    hangar: localHangar,
                                    onAdd: (obstacle)=>setLocalHangar({
                                            ...localHangar,
                                            obstacles: [
                                                ...localHangar.obstacles || [],
                                                obstacle
                                            ]
                                        })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "Wall Spacing"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                            unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                            type: "number",
                                            fullWidth: true,
                                            inputProps: {
                                                min: 0,
                                                max: 15,
                                                step: step
                                            },
                                            size: "small",
                                            label: `Left Wall (${unit})`,
                                            onChange: (value)=>setLocalHangar({
                                                    ...localHangar,
                                                    wall_spacing_left: value
                                                }),
                                            value: localHangar?.wall_spacing_left
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                            unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                            type: "number",
                                            fullWidth: true,
                                            inputProps: {
                                                min: 0,
                                                max: 15,
                                                step: step
                                            },
                                            size: "small",
                                            label: `Back Wall (${unit})`,
                                            onChange: (value)=>setLocalHangar({
                                                    ...localHangar,
                                                    wall_spacing_back: value
                                                }),
                                            value: localHangar?.wall_spacing_back
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                            unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                            type: "number",
                                            fullWidth: true,
                                            inputProps: {
                                                min: 0,
                                                max: 15,
                                                step: step
                                            },
                                            size: "small",
                                            label: `Right Wall (${unit})`,
                                            onChange: (value)=>setLocalHangar({
                                                    ...localHangar,
                                                    wall_spacing_right: value
                                                }),
                                            value: localHangar?.wall_spacing_right
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("fbENC", function(module, exports) {

$parcel$export(module.exports, "HangarBayEditor", () => $939012a97a234902$export$ee906f99ed11c0f6);

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $kPlrn = parcelRequire("kPlrn");

var $1MdOk = parcelRequire("1MdOk");

var $ipR47 = parcelRequire("ipR47");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $gd5y7 = parcelRequire("gd5y7");
var $2esSG = parcelRequire("2esSG");
var $9Lykx = parcelRequire("9Lykx");
var $hrMZe = parcelRequire("hrMZe");
var $8IWga = parcelRequire("8IWga");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $939012a97a234902$export$ee906f99ed11c0f6 = ({ hangarWidth: hangarWidth, hangarDepth: hangarDepth, bayDefinitions: bayDefinitions = [], bayOrientation: // Default to empty array
bayOrientation = "lateral", onChange: // Default to lateral
onChange })=>{
    // Use props directly (controlled component - no internal state)
    const bays = bayDefinitions.length > 0 ? bayDefinitions : [
        {
            width: hangarWidth,
            eave_height: 30,
            clear_height: 28
        }
    ];
    const orientation = bayOrientation;
    // Calculate totals
    const totalWidth = bays.reduce((sum, bay)=>sum + (bay.width || 0), 0);
    const totalDepth = bays.reduce((sum, bay)=>sum + (bay.depth || 0), 0);
    const isLateral = orientation === "lateral";
    const totalDimension = isLateral ? totalWidth : totalDepth;
    const hangarDimension = isLateral ? hangarWidth : hangarDepth;
    // Calculate coverage metrics
    const coverageGap = hangarDimension - totalDimension;
    const isComplete = Math.abs(coverageGap) < 0.1; // Exact match (±0.1ft tolerance)
    const isOverflow = coverageGap < -0.1; // Exceeds hangar
    const isUndercovered = coverageGap > 0.1; // Gap exists
    const coveragePercent = totalDimension / hangarDimension * 100;
    const handleOrientationChange = (newOrientation)=>{
        // Reset bays with appropriate dimension
        const newBays = [
            {
                [newOrientation === "lateral" ? "width" : "depth"]: newOrientation === "lateral" ? hangarWidth : hangarDepth,
                eave_height: 30,
                clear_height: 28
            }
        ];
        onChange(newBays, newOrientation);
    };
    const handleBayChange = (index, field, value)=>{
        const newBays = [
            ...bays
        ];
        newBays[index] = {
            ...newBays[index],
            [field]: value
        };
        onChange(newBays, orientation);
    };
    const handleAddBay = ()=>{
        // Calculate remaining dimension to suggest smart default
        const remaining = hangarDimension - totalDimension;
        const suggestedDimension = remaining > 0.1 ? remaining : isLateral ? 50 : 40;
        const newBay = {
            [isLateral ? "width" : "depth"]: suggestedDimension,
            eave_height: bays.length > 0 ? bays[bays.length - 1].eave_height : 30,
            clear_height: bays.length > 0 ? bays[bays.length - 1].clear_height : 28
        };
        const newBays = [
            ...bays,
            newBay
        ];
        onChange(newBays, orientation);
    };
    const handleFillRemainder = ()=>{
        const remaining = hangarDimension - totalDimension;
        if (remaining <= 0.1 || bays.length === 0) return;
        const lastBay = bays[bays.length - 1];
        const currentDimension = isLateral ? lastBay.width || 0 : lastBay.depth || 0;
        const newDimension = currentDimension + remaining;
        handleBayChange(bays.length - 1, isLateral ? "width" : "depth", newDimension);
    };
    const handleRemoveBay = (index)=>{
        if (bays.length === 1) return; // Keep at least one bay
        const newBays = bays.filter((_, i)=>i !== index);
        onChange(newBays, orientation);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                component: "fieldset",
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8IWga.default), {
                    value: orientation,
                    onChange: (e)=>handleOrientationChange(e.target.value),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 0.5,
                            alignItems: "center",
                            sx: {
                                mb: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    value: "lateral",
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {}),
                                    label: "Lateral (Side-by-Side)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            fontFamily: "monospace",
                                            fontSize: "0.75rem",
                                            whiteSpace: "pre"
                                        },
                                        children: `\u{250C}\u{2500}\u{2500}\u{252C}\u{2500}\u{2500}\u{2500}\u{252C}\u{2500}\u{2500}\u{2510}
\u{2502}A \u{2502} B \u{2502}C \u{2502}
\u{2502}  \u{2502}   \u{2502}  \u{2502}
\u{2514}\u{2500}\u{2500}\u{2534}\u{2500}\u{2500}\u{2500}\u{2534}\u{2500}\u{2500}\u{2518}
Bays divide left\u{2192}right
Example: 3 bays of 80ft, 100ft, 80ft`
                                    }),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                        fontSize: "small",
                                        color: "action"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 0.5,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    value: "longitudinal",
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hrMZe.default), {}),
                                    label: "Longitudinal (Front-to-Back)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            fontFamily: "monospace",
                                            fontSize: "0.75rem",
                                            whiteSpace: "pre"
                                        },
                                        children: `\u{250C}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2510}
\u{2502}    A    \u{2502}
\u{251C}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2524}
\u{2502}    B    \u{2502}
\u{2514}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2518}
Bays divide front\u{2192}back
Example: 2 bays of 60ft, 60ft`
                                    }),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                        fontSize: "small",
                                        color: "action"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                spacing: 1,
                children: bays.map((bay, index)=>{
                    // Calculate cumulative range for this bay
                    const dimension = isLateral ? bay.width || 0 : bay.depth || 0;
                    const rangeStart = bays.slice(0, index).reduce((sum, b)=>sum + (isLateral ? b.width || 0 : b.depth || 0), 0);
                    const rangeEnd = rangeStart + dimension;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                title: `Bay covers ${rangeStart.toFixed(1)}ft - ${rangeEnd.toFixed(1)}ft`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 80,
                                        fontFamily: "monospace",
                                        color: "text.secondary",
                                        fontSize: "0.75rem"
                                    },
                                    children: [
                                        rangeStart.toFixed(0),
                                        "-",
                                        rangeEnd.toFixed(0),
                                        "ft"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                type: "number",
                                size: "small",
                                label: isLateral ? "Width (ft)" : "Depth (ft)",
                                value: isLateral ? bay.width || "" : bay.depth || "",
                                onChange: (e)=>handleBayChange(index, isLateral ? "width" : "depth", parseFloat(e.target.value) || 0),
                                inputProps: {
                                    min: 0,
                                    step: 1
                                },
                                sx: {
                                    width: 120
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                type: "number",
                                size: "small",
                                label: "Eave Ht (ft)",
                                value: bay.eave_height,
                                onChange: (e)=>handleBayChange(index, "eave_height", parseFloat(e.target.value) || 0),
                                inputProps: {
                                    min: 0,
                                    step: 0.5
                                },
                                sx: {
                                    width: 100
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                type: "number",
                                size: "small",
                                label: "Clear Ht (ft)",
                                value: bay.clear_height,
                                onChange: (e)=>handleBayChange(index, "clear_height", parseFloat(e.target.value) || 0),
                                inputProps: {
                                    min: 0,
                                    step: 0.5
                                },
                                error: bay.clear_height > bay.eave_height,
                                sx: {
                                    width: 100
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                size: "small",
                                onClick: ()=>handleRemoveBay(index),
                                disabled: bays.length === 1,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {
                                    fontSize: "small"
                                })
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            height: 24,
                            border: "1px solid",
                            borderColor: isComplete ? "success.main" : isOverflow ? "error.main" : "warning.main",
                            borderRadius: 1,
                            overflow: "hidden",
                            display: "flex",
                            mb: 1,
                            bgcolor: "#f5f5f5"
                        },
                        children: [
                            bays.map((bay, index)=>{
                                const dimension = isLateral ? bay.width || 0 : bay.depth || 0;
                                const bayPercent = dimension / hangarDimension * 100;
                                const rangeStart = bays.slice(0, index).reduce((sum, b)=>sum + (isLateral ? b.width || 0 : b.depth || 0), 0);
                                const rangeEnd = rangeStart + dimension;
                                // Color palette for bays (cycling through shades)
                                const colors = [
                                    "#1976d2",
                                    "#42a5f5",
                                    "#64b5f6",
                                    "#90caf9",
                                    "#bbdefb"
                                ];
                                const bgColor = colors[index % colors.length];
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: `Bay ${index + 1}: ${rangeStart.toFixed(0)}-${rangeEnd.toFixed(0)}ft (${bayPercent.toFixed(1)}%)`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            width: `${Math.min(bayPercent, 100)}%`,
                                            bgcolor: bgColor,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "white",
                                            fontSize: "0.7rem",
                                            fontWeight: "bold",
                                            fontFamily: "Lexend Deca, sans-serif",
                                            cursor: "help",
                                            transition: "all 0.3s ease",
                                            "&:hover": {
                                                filter: "brightness(1.1)"
                                            }
                                        },
                                        children: bayPercent > 10 && `${bayPercent.toFixed(0)}%`
                                    })
                                }, index);
                            }),
                            isOverflow && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    width: `${Math.min(Math.abs(coverageGap / hangarDimension) * 100, 20)}%`,
                                    bgcolor: "error.main",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "white",
                                    fontSize: "0.65rem",
                                    fontWeight: "bold",
                                    fontFamily: "Lexend Deca, sans-serif"
                                },
                                children: [
                                    "+",
                                    Math.abs(coverageGap).toFixed(0),
                                    "ft"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "text.secondary",
                                children: [
                                    "Total: ",
                                    totalDimension.toFixed(1),
                                    " ft / ",
                                    hangarDimension.toFixed(1),
                                    " ",
                                    "ft (",
                                    coveragePercent.toFixed(0),
                                    "%)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: isComplete ? "success.main" : isOverflow ? "error.main" : "warning.main",
                                sx: {
                                    fontWeight: "bold"
                                },
                                children: isComplete ? "\u2713 Complete coverage" : isOverflow ? `\u{26A0}\u{FE0F} Exceeds by ${Math.abs(coverageGap).toFixed(1)}ft` : `\u{26A0}\u{FE0F} Missing ${coverageGap.toFixed(1)}ft`
                            })
                        ]
                    }),
                    isUndercovered && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "warning.main",
                        sx: {
                            display: "block",
                            mt: 0.5,
                            fontStyle: "italic"
                        },
                        children: [
                            "Uncovered ",
                            isLateral ? "width" : "depth",
                            ":",
                            " ",
                            totalDimension.toFixed(1),
                            "ft - ",
                            hangarDimension.toFixed(1),
                            "ft"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                        onClick: handleAddBay,
                        variant: "outlined",
                        children: "Add Bay"
                    }),
                    isUndercovered && bays.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kPlrn))), {}),
                        onClick: handleFillRemainder,
                        variant: "contained",
                        color: "success",
                        size: "small",
                        children: [
                            "Fill Remainder (",
                            coverageGap.toFixed(1),
                            "ft)"
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("kPlrn", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $f29933bb0902f394$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f29933bb0902f394$var$_createSvgIcon = $f29933bb0902f394$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $f29933bb0902f394$var$_default = module.exports.default = (0, $f29933bb0902f394$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.996.996 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12z"
}), 'AutoFixHigh');

});



parcelRegister("7SR5F", function(module, exports) {

var $4QOjN = parcelRequire("4QOjN");
module.exports = function(jwt, options) {
    options = options || {};
    var decoded = $4QOjN.decode(jwt, options);
    if (!decoded) return null;
    var payload = decoded.payload;
    //try parse the payload
    if (typeof payload === 'string') try {
        var obj = JSON.parse(payload);
        if (obj !== null && typeof obj === 'object') payload = obj;
    } catch (e) {}
    //return header if `complete` option is enabled.  header includes claims
    //such as `kid` and `alg` used to select the key within a JWKS needed to
    //verify the signature
    if (options.complete === true) return {
        header: decoded.header,
        payload: payload,
        signature: decoded.signature
    };
    return payload;
};

});
parcelRegister("4QOjN", function(module, exports) {

$parcel$export(module.exports, "sign", () => $38830cf000cd4d7c$export$c5552dfdbc7cec71, (v) => $38830cf000cd4d7c$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "verify", () => $38830cf000cd4d7c$export$532244b5b8b0b4b6, (v) => $38830cf000cd4d7c$export$532244b5b8b0b4b6 = v);
$parcel$export(module.exports, "decode", () => $38830cf000cd4d7c$export$2f872c0f2117be69, (v) => $38830cf000cd4d7c$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "createSign", () => $38830cf000cd4d7c$export$45df7cae684751af, (v) => $38830cf000cd4d7c$export$45df7cae684751af = v);
/*global exports*/ var $38830cf000cd4d7c$export$6f6fa4628974a579;
var $38830cf000cd4d7c$export$c5552dfdbc7cec71;
var $38830cf000cd4d7c$export$532244b5b8b0b4b6;
var $38830cf000cd4d7c$export$2f872c0f2117be69;
var $38830cf000cd4d7c$export$1ea939691cdc45b8;
var $38830cf000cd4d7c$export$45df7cae684751af;
var $38830cf000cd4d7c$export$6f65485f87568e37;

var $1KBFA = parcelRequire("1KBFA");

var $jVVQU = parcelRequire("jVVQU");
var $38830cf000cd4d7c$var$ALGORITHMS = [
    'HS256',
    'HS384',
    'HS512',
    'RS256',
    'RS384',
    'RS512',
    'PS256',
    'PS384',
    'PS512',
    'ES256',
    'ES384',
    'ES512'
];
$38830cf000cd4d7c$export$6f6fa4628974a579 = $38830cf000cd4d7c$var$ALGORITHMS;
$38830cf000cd4d7c$export$c5552dfdbc7cec71 = $1KBFA.sign;
$38830cf000cd4d7c$export$532244b5b8b0b4b6 = $jVVQU.verify;
$38830cf000cd4d7c$export$2f872c0f2117be69 = $jVVQU.decode;
$38830cf000cd4d7c$export$1ea939691cdc45b8 = $jVVQU.isValid;
$38830cf000cd4d7c$export$45df7cae684751af = function createSign(opts) {
    return new $1KBFA(opts);
};
$38830cf000cd4d7c$export$6f65485f87568e37 = function createVerify(opts) {
    return new $jVVQU(opts);
};

});
parcelRegister("1KBFA", function(module, exports) {
/*global module*/ 
var $1U9GM = parcelRequire("1U9GM");
var $14674ebf784babdc$require$Buffer = $1U9GM.Buffer;

var $8prZJ = parcelRequire("8prZJ");

var $f2m41 = parcelRequire("f2m41");

var $ioRHp = parcelRequire("ioRHp");

var $1vKm0 = parcelRequire("1vKm0");

var $N7Lcz = parcelRequire("N7Lcz");
function $14674ebf784babdc$var$base64url(string, encoding) {
    return $14674ebf784babdc$require$Buffer.from(string, encoding).toString('base64').replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $14674ebf784babdc$var$jwsSecuredInput(header, payload, encoding) {
    encoding = encoding || 'utf8';
    var encodedHeader = $14674ebf784babdc$var$base64url($1vKm0(header), 'binary');
    var encodedPayload = $14674ebf784babdc$var$base64url($1vKm0(payload), encoding);
    return $N7Lcz.format('%s.%s', encodedHeader, encodedPayload);
}
function $14674ebf784babdc$var$jwsSign(opts) {
    var header = opts.header;
    var payload = opts.payload;
    var secretOrKey = opts.secret || opts.privateKey;
    var encoding = opts.encoding;
    var algo = $f2m41(header.alg);
    var securedInput = $14674ebf784babdc$var$jwsSecuredInput(header, payload, encoding);
    var signature = algo.sign(securedInput, secretOrKey);
    return $N7Lcz.format('%s.%s', securedInput, signature);
}
function $14674ebf784babdc$var$SignStream(opts) {
    var secret = opts.secret || opts.privateKey || opts.key;
    var secretStream = new $8prZJ(secret);
    this.readable = true;
    this.header = opts.header;
    this.encoding = opts.encoding;
    this.secret = this.privateKey = this.key = secretStream;
    this.payload = new $8prZJ(opts.payload);
    this.secret.once('close', (function() {
        if (!this.payload.writable && this.readable) this.sign();
    }).bind(this));
    this.payload.once('close', (function() {
        if (!this.secret.writable && this.readable) this.sign();
    }).bind(this));
}
$N7Lcz.inherits($14674ebf784babdc$var$SignStream, $ioRHp);
$14674ebf784babdc$var$SignStream.prototype.sign = function sign() {
    try {
        var signature = $14674ebf784babdc$var$jwsSign({
            header: this.header,
            payload: this.payload.buffer,
            secret: this.secret.buffer,
            encoding: this.encoding
        });
        this.emit('done', signature);
        this.emit('data', signature);
        this.emit('end');
        this.readable = false;
        return signature;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$14674ebf784babdc$var$SignStream.sign = $14674ebf784babdc$var$jwsSign;
module.exports = $14674ebf784babdc$var$SignStream;

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("8prZJ", function(module, exports) {
/*global module, process*/ 
var $hPtJY = parcelRequire("hPtJY");

var $1U9GM = parcelRequire("1U9GM");
var $61f65fb5a1a8c380$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");

var $N7Lcz = parcelRequire("N7Lcz");
function $61f65fb5a1a8c380$var$DataStream(data) {
    this.buffer = null;
    this.writable = true;
    this.readable = true;
    // No input
    if (!data) {
        this.buffer = $61f65fb5a1a8c380$require$Buffer.alloc(0);
        return this;
    }
    // Stream
    if (typeof data.pipe === 'function') {
        this.buffer = $61f65fb5a1a8c380$require$Buffer.alloc(0);
        data.pipe(this);
        return this;
    }
    // Buffer or String
    // or Object (assumedly a passworded key)
    if (data.length || typeof data === 'object') {
        this.buffer = data;
        this.writable = false;
        $hPtJY.nextTick((function() {
            this.emit('end', data);
            this.readable = false;
            this.emit('close');
        }).bind(this));
        return this;
    }
    throw new TypeError('Unexpected data type (' + typeof data + ')');
}
$N7Lcz.inherits($61f65fb5a1a8c380$var$DataStream, $ioRHp);
$61f65fb5a1a8c380$var$DataStream.prototype.write = function write(data) {
    this.buffer = $61f65fb5a1a8c380$require$Buffer.concat([
        this.buffer,
        $61f65fb5a1a8c380$require$Buffer.from(data)
    ]);
    this.emit('data', data);
};
$61f65fb5a1a8c380$var$DataStream.prototype.end = function end(data) {
    if (data) this.write(data);
    this.emit('end', data);
    this.emit('close');
    this.writable = false;
    this.readable = false;
};
module.exports = $61f65fb5a1a8c380$var$DataStream;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $7b84d2ca8f0d8afd$var$debug;
if ($kjyEk && $kjyEk.debuglog) $7b84d2ca8f0d8afd$var$debug = $kjyEk.debuglog('stream');
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug('ondata');
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, 'error') === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug('on readable', state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self1) {
    $7b84d2ca8f0d8afd$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $7b84d2ca8f0d8afd$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $7b84d2ca8f0d8afd$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("6aKSQ", function(module, exports) {
'use strict';
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $47e80b5d1f4ca857$var$ownKeys(Object(source), !0).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    key = $47e80b5d1f4ca857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $47e80b5d1f4ca857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $47e80b5d1f4ca857$var$_toPropertyKey(arg) {
    var key = $47e80b5d1f4ca857$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e80b5d1f4ca857$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $47e80b5d1f4ca857$var$inspect = $kjyEk.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || 'inspect';
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread($47e80b5d1f4ca857$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRegister("5yyyA", function(module, exports) {
'use strict';

var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("967Aq")).codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRegister("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
'use strict';
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $69fa8f23fe6fc7e7$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, 'type'));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$69fa8f23fe6fc7e7$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRegister("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, 'buffer', {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jJj7p.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config('throwDeprecation')) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    key = $25a99ede456543b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25a99ede456543b7$var$_toPropertyKey(arg) {
    var key = $25a99ede456543b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $25a99ede456543b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol('lastResolve');
var $25a99ede456543b7$var$kLastReject = Symbol('lastReject');
var $25a99ede456543b7$var$kError = Symbol('error');
var $25a99ede456543b7$var$kEnded = Symbol('ended');
var $25a99ede456543b7$var$kLastPromise = Symbol('lastPromise');
var $25a99ede456543b7$var$kHandlePromise = Symbol('handlePromise');
var $25a99ede456543b7$var$kStream = Symbol('stream');
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$25a99ede456543b7$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on('readable', $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRegister("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("967Aq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRegister("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});


parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = ' ' + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== 'undefined';
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== 'undefined';
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === 'Uint8Array';
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === 'Uint16Array';
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === 'Uint32Array';
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === 'Int8Array';
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === 'Int16Array';
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === 'Int32Array';
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === 'Float32Array';
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === 'Float64Array';
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map]';
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== 'undefined' && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set]';
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== 'undefined' && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakMap]';
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakSet]';
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object DataView]';
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === 'undefined') $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
'use strict';

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $eW390 = parcelRequire("eW390");
var $af991f1d6c80f097$var$$toString = $eW390('Object.prototype.toString');
/** @type {import('.')} */ var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== '[object Array]' && 'callee' in value && $af991f1d6c80f097$var$$toString(value.callee) === '[object Function]';
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
'use strict';

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eW390", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $jyxCz = parcelRequire("jyxCz");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $jyxCz([
    $1zENl('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $jyxCz(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;

var $90JBs = parcelRequire("90JBs");

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");

var $bdePV = parcelRequire("bdePV");

var $dK8VM = parcelRequire("dK8VM");

var $7F9c3 = parcelRequire("7F9c3");

var $4l7TM = parcelRequire("4l7TM");

var $brYbP = parcelRequire("brYbP");

var $1rWQg = parcelRequire("1rWQg");

var $4J7z9 = parcelRequire("4J7z9");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $dYOee = parcelRequire("dYOee");

var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $dYOee ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $dYOee(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $3ERI6 = parcelRequire("3ERI6");

var $eim86 = parcelRequire("eim86");

var $TxOUG = parcelRequire("TxOUG");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$3ERI6 ? undefined : $3ERI6(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5A49f,
    '%eval%': eval,
    '%EvalError%': $hDtVy,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6($3ERI6([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $90JBs,
    '%Object.getOwnPropertyDescriptor%': $dYOee,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9RC8m,
    '%ReferenceError%': $2BaZq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5Ox6r,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $eEkyn,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hFSMY,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9pzbV,
    '%Function.prototype.apply%': $xMvSJ,
    '%Object.defineProperty%': $jAy3M,
    '%Object.getPrototypeOf%': $eim86,
    '%Math.abs%': $bdePV,
    '%Math.floor%': $dK8VM,
    '%Math.max%': $7F9c3,
    '%Math.min%': $4l7TM,
    '%Math.pow%': $brYbP,
    '%Math.round%': $1rWQg,
    '%Math.sign%': $4J7z9,
    '%Reflect.getPrototypeOf%': $TxOUG
};
if ($3ERI6) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $3ERI6($3ERI6(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3ERI6) value = $3ERI6(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call($9pzbV, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call($xMvSJ, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call($9pzbV, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call($9pzbV, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call($9pzbV, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eEkyn('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eEkyn('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5Ox6r('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($dYOee && i + 1 >= parts.length) {
                var desc = $dYOee(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("90JBs", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5A49f", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bdePV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("dK8VM", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("7F9c3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4l7TM", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("brYbP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1rWQg", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4J7z9", function(module, exports) {
'use strict';

var $4oiz9 = parcelRequire("4oiz9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4oiz9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4oiz9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("dYOee", function(module, exports) {
'use strict';

var $d4L75 = parcelRequire("d4L75");
var $a2d7d74e83f6c3ed$require$$gOPD = $d4L75;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$require$$gOPD;

});
parcelRegister("d4L75", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});

parcelRegister("3ERI6", function(module, exports) {
'use strict';

var $TxOUG = parcelRequire("TxOUG");

var $eim86 = parcelRequire("eim86");

var $7kfw3 = parcelRequire("7kfw3");
/** @type {import('.')} */ module.exports = $TxOUG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TxOUG(O);
} : $eim86 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eim86(O);
} : $7kfw3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7kfw3(O);
} : null;

});
parcelRegister("TxOUG", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eim86", function(module, exports) {
'use strict';

var $90JBs = parcelRequire("90JBs");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $90JBs.getPrototypeOf || null;

});

parcelRegister("7kfw3", function(module, exports) {
'use strict';

var $jyxCz = parcelRequire("jyxCz");

var $dYOee = parcelRequire("dYOee");
var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $dYOee && $dYOee(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $jyxCz([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;

});
parcelRegister("jyxCz", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $eEkyn = parcelRequire("eEkyn");

var $9pzbV = parcelRequire("9pzbV");

var $3YvJT = parcelRequire("3YvJT");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eEkyn('a function is required');
    return $3YvJT($gvair, $9pzbV, args);
};

});
parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pzbV", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3YvJT", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");

var $8qWPV = parcelRequire("8qWPV");
/** @type {import('./actualApply')} */ module.exports = $8qWPV || $gvair.call($9pzbV, $xMvSJ);

});
parcelRegister("xMvSJ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("8qWPV", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("4c4Ky", function(module, exports) {
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});




parcelRegister("5WnCa", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $2xf7f = parcelRequire("2xf7f");
var $4534afe844d627e4$var$isFnRegex = $2xf7f(/^\s*(?:function)?\*/);

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $3ERI6 = parcelRequire("3ERI6");
var $4534afe844d627e4$var$toStr = $eW390('Object.prototype.toString');
var $4534afe844d627e4$var$fnToStr = $eW390('Function.prototype.toString');
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
/** @type {undefined | false | null | GeneratorFunctionConstructor} */ var $4534afe844d627e4$var$GeneratorFunction;
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($4534afe844d627e4$var$isFnRegex($4534afe844d627e4$var$fnToStr(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$3ERI6) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? /** @type {GeneratorFunctionConstructor} */ $3ERI6(generatorFunc) : false;
    }
    return $3ERI6(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});
parcelRegister("2xf7f", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $l37Ky = parcelRequire("l37Ky");
var $1d8a638ce4bfc95c$var$$exec = $eW390('RegExp.prototype.exec');

var $eEkyn = parcelRequire("eEkyn");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$l37Ky(regex)) throw new $eEkyn('`regex` must be a RegExp');
    return function test(s) {
        return $1d8a638ce4bfc95c$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("l37Ky", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $f52fe3bd41a86f17$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $4c4Ky = parcelRequire("4c4Ky");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ var $f52fe3bd41a86f17$var$fn;
if ($f52fe3bd41a86f17$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $f52fe3bd41a86f17$var$$exec = $eW390('RegExp.prototype.exec');
    /** @type {object} */ var $f52fe3bd41a86f17$var$isRegexMarker = {};
    var $f52fe3bd41a86f17$var$throwRegexMarker = function() {
        throw $f52fe3bd41a86f17$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $f52fe3bd41a86f17$var$badStringifier = {
        toString: $f52fe3bd41a86f17$var$throwRegexMarker,
        valueOf: $f52fe3bd41a86f17$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $f52fe3bd41a86f17$var$badStringifier[Symbol.toPrimitive] = $f52fe3bd41a86f17$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $dYOee(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $4c4Ky(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $f52fe3bd41a86f17$var$$exec(value, /** @type {unknown} */ $f52fe3bd41a86f17$var$badStringifier);
        } catch (e) {
            return e === $f52fe3bd41a86f17$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $f52fe3bd41a86f17$var$$toString = $eW390('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $f52fe3bd41a86f17$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $f52fe3bd41a86f17$var$$toString(value) === $f52fe3bd41a86f17$var$regexClass;
    };
}
module.exports = $f52fe3bd41a86f17$var$fn;

});



parcelRegister("gJrpv", function(module, exports) {
'use strict';

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $eW390 = parcelRequire("eW390");

var $dYOee = parcelRequire("dYOee");

var $3ERI6 = parcelRequire("3ERI6");
var $c2e61c703a2c9ae0$var$$toString = $eW390('Object.prototype.toString');

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $eW390('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $eW390('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $3ERI6) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3ERI6) {
        var proto = $3ERI6(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3ERI6(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c2e61c703a2c9ae0$var$cache['$' + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $cOB0F(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        /** @type {string} */ var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
'use strict';

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c21e1d005400ef2a$var$isArray(x) {
    return $c21e1d005400ef2a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$isArray(list)) $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("63RD0", function(module, exports) {
'use strict';
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = '[object Object]';
var $469c9f4bd3a650de$var$fnClass = '[object Function]';
var $469c9f4bd3a650de$var$genClass = '[object GeneratorFunction]';
var $469c9f4bd3a650de$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = '[object HTML document.all class]';
var $469c9f4bd3a650de$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
'use strict';

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === 'function') // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("cOB0F", function(module, exports) {
'use strict';

var $BPe9e = parcelRequire("BPe9e");

var $jAy3M = parcelRequire("jAy3M");

var $jyxCz = parcelRequire("jyxCz");

var $1uOip = parcelRequire("1uOip");
module.exports = function callBind(originalFunction) {
    var func = $jyxCz(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $BPe9e(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($jAy3M) $jAy3M(module.exports, 'apply', {
    value: $1uOip
});
else module.exports.apply = $1uOip;

});
parcelRegister("BPe9e", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eEkyn('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $dYOee) {
        var desc = $dYOee(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eEkyn('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eEkyn('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eEkyn('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eEkyn('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eEkyn('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eEkyn('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("i16wS", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRegister("1uOip", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $3YvJT = parcelRequire("3YvJT");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $3YvJT($gvair, $xMvSJ, arguments);
};

});



parcelRegister("hN833", function(module, exports) {
'use strict';

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("f2m41", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $af2828556be4bfdb$require$Buffer = $1U9GM.Buffer;

var $5UUfm = parcelRequire("5UUfm");

var $bpzVP = parcelRequire("bpzVP");

var $N7Lcz = parcelRequire("N7Lcz");
var $af2828556be4bfdb$var$MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".';
var $af2828556be4bfdb$var$MSG_INVALID_SECRET = 'secret must be a string or buffer';
var $af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var $af2828556be4bfdb$var$MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
var $af2828556be4bfdb$var$supportsKeyObjects = typeof $5UUfm.createPublicKey === 'function';
if ($af2828556be4bfdb$var$supportsKeyObjects) {
    $af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
    $af2828556be4bfdb$var$MSG_INVALID_SECRET += 'or a KeyObject';
}
function $af2828556be4bfdb$var$checkIsPublicKey(key) {
    if ($af2828556be4bfdb$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (!$af2828556be4bfdb$var$supportsKeyObjects) throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key !== 'object') throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.type !== 'string') throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.asymmetricKeyType !== 'string') throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.export !== 'function') throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
}
function $af2828556be4bfdb$var$checkIsPrivateKey(key) {
    if ($af2828556be4bfdb$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (typeof key === 'object') return;
    throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SIGNER_KEY);
}
function $af2828556be4bfdb$var$checkIsSecretKey(key) {
    if ($af2828556be4bfdb$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return key;
    if (!$af2828556be4bfdb$var$supportsKeyObjects) throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SECRET);
    if (typeof key !== 'object') throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SECRET);
    if (key.type !== 'secret') throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SECRET);
    if (typeof key.export !== 'function') throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SECRET);
}
function $af2828556be4bfdb$var$fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $af2828556be4bfdb$var$toBase64(base64url) {
    base64url = base64url.toString();
    var padding = 4 - base64url.length % 4;
    if (padding !== 4) for(var i = 0; i < padding; ++i)base64url += '=';
    return base64url.replace(/\-/g, '+').replace(/_/g, '/');
}
function $af2828556be4bfdb$var$typeError(template) {
    var args = [].slice.call(arguments, 1);
    var errMsg = $N7Lcz.format.bind($N7Lcz, template).apply(null, args);
    return new TypeError(errMsg);
}
function $af2828556be4bfdb$var$bufferOrString(obj) {
    return $af2828556be4bfdb$require$Buffer.isBuffer(obj) || typeof obj === 'string';
}
function $af2828556be4bfdb$var$normalizeInput(thing) {
    if (!$af2828556be4bfdb$var$bufferOrString(thing)) thing = JSON.stringify(thing);
    return thing;
}
function $af2828556be4bfdb$var$createHmacSigner(bits) {
    return function sign(thing, secret) {
        $af2828556be4bfdb$var$checkIsSecretKey(secret);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        var hmac = $5UUfm.createHmac('sha' + bits, secret);
        var sig = (hmac.update(thing), hmac.digest('base64'));
        return $af2828556be4bfdb$var$fromBase64(sig);
    };
}
var $af2828556be4bfdb$var$bufferEqual;

var $af2828556be4bfdb$var$timingSafeEqual = 'timingSafeEqual' in $5UUfm ? function timingSafeEqual(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $5UUfm.timingSafeEqual(a, b);
} : function timingSafeEqual(a, b) {
    if (!$af2828556be4bfdb$var$bufferEqual) $af2828556be4bfdb$var$bufferEqual = (parcelRequire("2wwUJ"));
    return $af2828556be4bfdb$var$bufferEqual(a, b);
};
function $af2828556be4bfdb$var$createHmacVerifier(bits) {
    return function verify(thing, signature, secret) {
        var computedSig = $af2828556be4bfdb$var$createHmacSigner(bits)(thing, secret);
        return $af2828556be4bfdb$var$timingSafeEqual($af2828556be4bfdb$require$Buffer.from(signature), $af2828556be4bfdb$require$Buffer.from(computedSig));
    };
}
function $af2828556be4bfdb$var$createKeySigner(bits) {
    return function sign(thing, privateKey) {
        $af2828556be4bfdb$var$checkIsPrivateKey(privateKey);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        // Even though we are specifying "RSA" here, this works with ECDSA
        // keys as well.
        var signer = $5UUfm.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
        return $af2828556be4bfdb$var$fromBase64(sig);
    };
}
function $af2828556be4bfdb$var$createKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $af2828556be4bfdb$var$checkIsPublicKey(publicKey);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        signature = $af2828556be4bfdb$var$toBase64(signature);
        var verifier = $5UUfm.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify(publicKey, signature, 'base64');
    };
}
function $af2828556be4bfdb$var$createPSSKeySigner(bits) {
    return function sign(thing, privateKey) {
        $af2828556be4bfdb$var$checkIsPrivateKey(privateKey);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        var signer = $5UUfm.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign({
            key: privateKey,
            padding: $5UUfm.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $5UUfm.constants.RSA_PSS_SALTLEN_DIGEST
        }, 'base64'));
        return $af2828556be4bfdb$var$fromBase64(sig);
    };
}
function $af2828556be4bfdb$var$createPSSKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $af2828556be4bfdb$var$checkIsPublicKey(publicKey);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        signature = $af2828556be4bfdb$var$toBase64(signature);
        var verifier = $5UUfm.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify({
            key: publicKey,
            padding: $5UUfm.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $5UUfm.constants.RSA_PSS_SALTLEN_DIGEST
        }, signature, 'base64');
    };
}
function $af2828556be4bfdb$var$createECDSASigner(bits) {
    var inner = $af2828556be4bfdb$var$createKeySigner(bits);
    return function sign() {
        var signature = inner.apply(null, arguments);
        signature = $bpzVP.derToJose(signature, 'ES' + bits);
        return signature;
    };
}
function $af2828556be4bfdb$var$createECDSAVerifer(bits) {
    var inner = $af2828556be4bfdb$var$createKeyVerifier(bits);
    return function verify(thing, signature, publicKey) {
        signature = $bpzVP.joseToDer(signature, 'ES' + bits).toString('base64');
        var result = inner(thing, signature, publicKey);
        return result;
    };
}
function $af2828556be4bfdb$var$createNoneSigner() {
    return function sign() {
        return '';
    };
}
function $af2828556be4bfdb$var$createNoneVerifier() {
    return function verify(thing, signature) {
        return signature === '';
    };
}
module.exports = function jwa(algorithm) {
    var signerFactories = {
        hs: $af2828556be4bfdb$var$createHmacSigner,
        rs: $af2828556be4bfdb$var$createKeySigner,
        ps: $af2828556be4bfdb$var$createPSSKeySigner,
        es: $af2828556be4bfdb$var$createECDSASigner,
        none: $af2828556be4bfdb$var$createNoneSigner
    };
    var verifierFactories = {
        hs: $af2828556be4bfdb$var$createHmacVerifier,
        rs: $af2828556be4bfdb$var$createKeyVerifier,
        ps: $af2828556be4bfdb$var$createPSSKeyVerifier,
        es: $af2828556be4bfdb$var$createECDSAVerifer,
        none: $af2828556be4bfdb$var$createNoneVerifier
    };
    var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
    if (!match) throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_ALGORITHM, algorithm);
    var algo = (match[1] || match[3]).toLowerCase();
    var bits = match[2];
    return {
        sign: signerFactories[algo](bits),
        verify: verifierFactories[algo](bits)
    };
};

});
parcelRegister("5UUfm", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $44edd02a6be448cd$export$5f828d93ff035aa8, (v) => $44edd02a6be448cd$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $44edd02a6be448cd$export$cd94982b18c6332c, (v) => $44edd02a6be448cd$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $44edd02a6be448cd$export$1d518568e4f529b0, (v) => $44edd02a6be448cd$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $44edd02a6be448cd$export$5285b6d41c912b41, (v) => $44edd02a6be448cd$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $44edd02a6be448cd$export$2fb37efbf6ae0c0e, (v) => $44edd02a6be448cd$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $44edd02a6be448cd$export$ab85ecd77ce6a5cd, (v) => $44edd02a6be448cd$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $44edd02a6be448cd$export$da39cf97e1eb7c91, (v) => $44edd02a6be448cd$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $44edd02a6be448cd$export$52a9039d7177394f, (v) => $44edd02a6be448cd$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $44edd02a6be448cd$export$f7201db400317331, (v) => $44edd02a6be448cd$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $44edd02a6be448cd$export$448fa22aedc9dbca, (v) => $44edd02a6be448cd$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $44edd02a6be448cd$export$b80c7ba289c8fa56, (v) => $44edd02a6be448cd$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $44edd02a6be448cd$export$26e5786e8ac8e530, (v) => $44edd02a6be448cd$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $44edd02a6be448cd$export$bdd223f16383713e, (v) => $44edd02a6be448cd$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $44edd02a6be448cd$export$20533d26f07f1ee0, (v) => $44edd02a6be448cd$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $44edd02a6be448cd$export$2f64596b8cbf08b4, (v) => $44edd02a6be448cd$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a, (v) => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $44edd02a6be448cd$export$12ada9414fbc594c, (v) => $44edd02a6be448cd$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $44edd02a6be448cd$export$f5e7e39d57cd9700, (v) => $44edd02a6be448cd$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $44edd02a6be448cd$export$36b6d6ef312eab39, (v) => $44edd02a6be448cd$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $44edd02a6be448cd$export$58a258485f1e49f6, (v) => $44edd02a6be448cd$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $44edd02a6be448cd$export$dedd8dc3dc62b370, (v) => $44edd02a6be448cd$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $44edd02a6be448cd$export$971862a2fcb1bb40, (v) => $44edd02a6be448cd$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $44edd02a6be448cd$export$c6ff6a88acbeaf40, (v) => $44edd02a6be448cd$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $44edd02a6be448cd$export$fdc27893e98845cc, (v) => $44edd02a6be448cd$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $44edd02a6be448cd$export$6671fb9a1323bed, (v) => $44edd02a6be448cd$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $44edd02a6be448cd$export$d74daf141a551db, (v) => $44edd02a6be448cd$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $44edd02a6be448cd$export$45df7cae684751af, (v) => $44edd02a6be448cd$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $44edd02a6be448cd$export$1db683ad541682f6, (v) => $44edd02a6be448cd$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $44edd02a6be448cd$export$6f65485f87568e37, (v) => $44edd02a6be448cd$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $44edd02a6be448cd$export$91a8e56769aeb334, (v) => $44edd02a6be448cd$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $44edd02a6be448cd$export$2d4117e99c2179e4, (v) => $44edd02a6be448cd$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $44edd02a6be448cd$export$512823e338ddb1b7, (v) => $44edd02a6be448cd$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3, (v) => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $44edd02a6be448cd$export$b9d55ff329113abd, (v) => $44edd02a6be448cd$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $44edd02a6be448cd$export$7efb24e2fddf99b9, (v) => $44edd02a6be448cd$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $44edd02a6be448cd$export$bb1abf2ce84fc7e8, (v) => $44edd02a6be448cd$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $44edd02a6be448cd$export$2f7171e78e524d5e, (v) => $44edd02a6be448cd$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $44edd02a6be448cd$export$e1d879b482f37d98, (v) => $44edd02a6be448cd$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $44edd02a6be448cd$export$1a988e7317c65621, (v) => $44edd02a6be448cd$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
'use strict';

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));

var $eFSIF = parcelRequire("eFSIF");
var $44edd02a6be448cd$var$algoKeys = Object.keys($eFSIF);
var $44edd02a6be448cd$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;

var $eyeBm = parcelRequire("eyeBm");
$44edd02a6be448cd$export$26e5786e8ac8e530 = $eyeBm.Cipher;
$44edd02a6be448cd$export$bdd223f16383713e = $eyeBm.createCipher;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $eyeBm.Cipheriv;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $eyeBm.createCipheriv;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $eyeBm.Decipher;
$44edd02a6be448cd$export$12ada9414fbc594c = $eyeBm.createDecipher;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $eyeBm.Decipheriv;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $eyeBm.createDecipheriv;
$44edd02a6be448cd$export$58a258485f1e49f6 = $eyeBm.getCiphers;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $eyeBm.listCiphers;

var $5NszM = parcelRequire("5NszM");
$44edd02a6be448cd$export$971862a2fcb1bb40 = $5NszM.DiffieHellmanGroup;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $5NszM.createDiffieHellmanGroup;
$44edd02a6be448cd$export$fdc27893e98845cc = $5NszM.getDiffieHellman;
$44edd02a6be448cd$export$6671fb9a1323bed = $5NszM.createDiffieHellman;
$44edd02a6be448cd$export$d74daf141a551db = $5NszM.DiffieHellman;

var $4zMFU = parcelRequire("4zMFU");
$44edd02a6be448cd$export$45df7cae684751af = $4zMFU.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $4zMFU.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $4zMFU.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $4zMFU.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));

var $fMM6j = parcelRequire("fMM6j");
$44edd02a6be448cd$export$512823e338ddb1b7 = $fMM6j.publicEncrypt;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $fMM6j.privateEncrypt;
$44edd02a6be448cd$export$b9d55ff329113abd = $fMM6j.publicDecrypt;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $fMM6j.privateDecrypt;

var $c34vB = parcelRequire("c34vB");
$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $c34vB.randomFill;
$44edd02a6be448cd$export$2f7171e78e524d5e = $c34vB.randomFillSync;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("1R2J7", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, 'digest');
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $loYLU();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("loYLU", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $abf00c68ae11d39d$require$Transform = $ioRHp.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $abf00c68ae11d39d$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $abf00c68ae11d39d$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($abf00c68ae11d39d$require$Buffer.prototype instanceof Uint8Array || $abf00c68ae11d39d$require$Buffer.TYPED_ARRAY_SUPPORT);
function $abf00c68ae11d39d$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $abf00c68ae11d39d$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($abf00c68ae11d39d$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $abf00c68ae11d39d$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $abf00c68ae11d39d$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($abf00c68ae11d39d$var$useUint8Array && data instanceof Uint8Array) return $abf00c68ae11d39d$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($abf00c68ae11d39d$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $abf00c68ae11d39d$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $abf00c68ae11d39d$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});


parcelRegister("a8qBR", function(module, exports) {
'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("dECyV"));

module.exports.sha1 = (parcelRequire("dVcFO"));

module.exports.sha224 = (parcelRequire("3wNjm"));

module.exports.sha256 = (parcelRequire("3BFQx"));

module.exports.sha384 = (parcelRequire("5qHaZ"));

module.exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + w[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $5KQLs(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $0968fae43eb53960$var$Hash;

});
parcelRegister("5KQLs", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $430a2d85d7cad11c$require$Buffer = $1U9GM.Buffer;

var $5RgoW = parcelRequire("5RgoW");

var $aErU4 = parcelRequire("aErU4");
var $430a2d85d7cad11c$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $aErU4(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $430a2d85d7cad11c$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $430a2d85d7cad11c$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $430a2d85d7cad11c$var$useFromArrayBuffer = $430a2d85d7cad11c$var$useArrayBuffer && ($430a2d85d7cad11c$require$Buffer.prototype instanceof Uint8Array || $430a2d85d7cad11c$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $430a2d85d7cad11c$require$Buffer) return data;
    if (typeof data === 'string') return $430a2d85d7cad11c$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($430a2d85d7cad11c$var$useArrayBuffer && $430a2d85d7cad11c$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $430a2d85d7cad11c$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($430a2d85d7cad11c$var$useFromArrayBuffer) {
            var res = $430a2d85d7cad11c$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $430a2d85d7cad11c$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($430a2d85d7cad11c$var$useUint8Array && data instanceof Uint8Array) return $430a2d85d7cad11c$require$Buffer.from(data);
    var isArr = $5RgoW(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $430a2d85d7cad11c$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $430a2d85d7cad11c$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("5RgoW", function(module, exports) {
var $443e9fef32a42cac$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $443e9fef32a42cac$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("aErU4", function(module, exports) {
'use strict';

var $eEkyn = parcelRequire("eEkyn");

var $eW390 = parcelRequire("eW390");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $7c1348d7c62af12b$var$$typedArrayBuffer = $eW390('TypedArray.prototype.buffer', true);

var $hN833 = parcelRequire("hN833");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $7c1348d7c62af12b$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$hN833(x)) throw new $eEkyn('Not a Typed Array');
    return x.buffer;
};

});




parcelRegister("dVcFO", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $a22a6de6a357c37a$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + w[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W; // new Array(64)
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W; // new Array(64)
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $2a05499bef58a0cf$var$gamma1(w[i - 2]) + w[i - 7] + $2a05499bef58a0cf$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + w[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
var $187e9d8dfda3dbba$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $187e9d8dfda3dbba$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($187e9d8dfda3dbba$require$Buffer.prototype instanceof Uint8Array || $187e9d8dfda3dbba$require$Buffer.TYPED_ARRAY_SUPPORT);
function $187e9d8dfda3dbba$var$toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $187e9d8dfda3dbba$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $187e9d8dfda3dbba$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($187e9d8dfda3dbba$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $187e9d8dfda3dbba$require$Buffer.alloc(0);
        var res = $187e9d8dfda3dbba$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        /*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */ if (res.byteLength === data.byteLength) return res;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($187e9d8dfda3dbba$var$useUint8Array && data instanceof Uint8Array) return $187e9d8dfda3dbba$require$Buffer.from(data);
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if ($187e9d8dfda3dbba$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $187e9d8dfda3dbba$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $187e9d8dfda3dbba$var$toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});


parcelRegister("1iL1D", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $0f2bf322914b61b2$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("eFSIF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6swAi"));

});
parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;
'use strict';

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});
parcelRegister("5dQ72", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $3cd697166017b735$var$checks = [];
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
'use strict';
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split('.')[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $5130da986dd86f24$var$defaultEncoding = 'utf-8';
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {
'use strict';

var $87pxb = parcelRequire("87pxb");

var $3vzY0 = parcelRequire("3vzY0");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $16722fe28cdbf3c2$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $16722fe28cdbf3c2$var$rmd160Func(data) {
    return new $3vzY0().update(data).digest();
}
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $16722fe28cdbf3c2$var$rmd160Func;
    if (alg === 'md5') return $87pxb;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $16722fe28cdbf3c2$var$mapping[lowerDigest] || lowerDigest;
    var size = $16722fe28cdbf3c2$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $16722fe28cdbf3c2$var$Hmac(mappedDigest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("87pxb", function(module, exports) {
'use strict';

var $bR68C = parcelRequire("bR68C");
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */ function $5e92c8c3c1f2cd01$var$core_md5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = $5e92c8c3c1f2cd01$var$md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = $5e92c8c3c1f2cd01$var$md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $5e92c8c3c1f2cd01$var$md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $5e92c8c3c1f2cd01$var$md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $5e92c8c3c1f2cd01$var$md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $5e92c8c3c1f2cd01$var$md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $5e92c8c3c1f2cd01$var$md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $5e92c8c3c1f2cd01$var$md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $5e92c8c3c1f2cd01$var$md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $5e92c8c3c1f2cd01$var$md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $5e92c8c3c1f2cd01$var$md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $5e92c8c3c1f2cd01$var$md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $5e92c8c3c1f2cd01$var$md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $5e92c8c3c1f2cd01$var$md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $5e92c8c3c1f2cd01$var$md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $5e92c8c3c1f2cd01$var$md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $5e92c8c3c1f2cd01$var$md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $5e92c8c3c1f2cd01$var$md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $5e92c8c3c1f2cd01$var$md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $5e92c8c3c1f2cd01$var$md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = $5e92c8c3c1f2cd01$var$md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $5e92c8c3c1f2cd01$var$md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $5e92c8c3c1f2cd01$var$md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $5e92c8c3c1f2cd01$var$md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $5e92c8c3c1f2cd01$var$md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $5e92c8c3c1f2cd01$var$md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $5e92c8c3c1f2cd01$var$md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $5e92c8c3c1f2cd01$var$md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $5e92c8c3c1f2cd01$var$md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $5e92c8c3c1f2cd01$var$md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $5e92c8c3c1f2cd01$var$md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $5e92c8c3c1f2cd01$var$md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $5e92c8c3c1f2cd01$var$md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $5e92c8c3c1f2cd01$var$md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $5e92c8c3c1f2cd01$var$md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $5e92c8c3c1f2cd01$var$md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $5e92c8c3c1f2cd01$var$md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $5e92c8c3c1f2cd01$var$md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $5e92c8c3c1f2cd01$var$md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $5e92c8c3c1f2cd01$var$md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $5e92c8c3c1f2cd01$var$md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $5e92c8c3c1f2cd01$var$md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = $5e92c8c3c1f2cd01$var$md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $5e92c8c3c1f2cd01$var$md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $5e92c8c3c1f2cd01$var$md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $5e92c8c3c1f2cd01$var$md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $5e92c8c3c1f2cd01$var$md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $5e92c8c3c1f2cd01$var$md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $5e92c8c3c1f2cd01$var$md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = $5e92c8c3c1f2cd01$var$md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $5e92c8c3c1f2cd01$var$md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $5e92c8c3c1f2cd01$var$md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $5e92c8c3c1f2cd01$var$md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $5e92c8c3c1f2cd01$var$md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $5e92c8c3c1f2cd01$var$md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $5e92c8c3c1f2cd01$var$md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $5e92c8c3c1f2cd01$var$md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $5e92c8c3c1f2cd01$var$md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $5e92c8c3c1f2cd01$var$md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $5e92c8c3c1f2cd01$var$md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $5e92c8c3c1f2cd01$var$md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $5e92c8c3c1f2cd01$var$md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $5e92c8c3c1f2cd01$var$md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $5e92c8c3c1f2cd01$var$md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $5e92c8c3c1f2cd01$var$safe_add(a, olda);
        b = $5e92c8c3c1f2cd01$var$safe_add(b, oldb);
        c = $5e92c8c3c1f2cd01$var$safe_add(c, oldc);
        d = $5e92c8c3c1f2cd01$var$safe_add(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $5e92c8c3c1f2cd01$var$md5_cmn(q, a, b, x, s, t) {
    return $5e92c8c3c1f2cd01$var$safe_add($5e92c8c3c1f2cd01$var$bit_rol($5e92c8c3c1f2cd01$var$safe_add($5e92c8c3c1f2cd01$var$safe_add(a, q), $5e92c8c3c1f2cd01$var$safe_add(x, t)), s), b);
}
function $5e92c8c3c1f2cd01$var$md5_ff(a, b, c, d, x, s, t) {
    return $5e92c8c3c1f2cd01$var$md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function $5e92c8c3c1f2cd01$var$md5_gg(a, b, c, d, x, s, t) {
    return $5e92c8c3c1f2cd01$var$md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function $5e92c8c3c1f2cd01$var$md5_hh(a, b, c, d, x, s, t) {
    return $5e92c8c3c1f2cd01$var$md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function $5e92c8c3c1f2cd01$var$md5_ii(a, b, c, d, x, s, t) {
    return $5e92c8c3c1f2cd01$var$md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $5e92c8c3c1f2cd01$var$safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $5e92c8c3c1f2cd01$var$bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
module.exports = function md5(buf) {
    return $bR68C(buf, $5e92c8c3c1f2cd01$var$core_md5);
};

});
parcelRegister("bR68C", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8a1967d13b803f87$require$Buffer = $6ZWSX.Buffer;
'use strict';
var $8a1967d13b803f87$var$intSize = 4;
var $8a1967d13b803f87$var$zeroBuffer = new $8a1967d13b803f87$require$Buffer($8a1967d13b803f87$var$intSize);
$8a1967d13b803f87$var$zeroBuffer.fill(0);
var $8a1967d13b803f87$var$charSize = 8;
var $8a1967d13b803f87$var$hashSize = 16;
function $8a1967d13b803f87$var$toArray(buf) {
    if (buf.length % $8a1967d13b803f87$var$intSize !== 0) {
        var len = buf.length + ($8a1967d13b803f87$var$intSize - buf.length % $8a1967d13b803f87$var$intSize);
        buf = $8a1967d13b803f87$require$Buffer.concat([
            buf,
            $8a1967d13b803f87$var$zeroBuffer
        ], len);
    }
    var arr = new Array(buf.length >>> 2);
    for(var i = 0, j = 0; i < buf.length; i += $8a1967d13b803f87$var$intSize, j++)arr[j] = buf.readInt32LE(i);
    return arr;
}
module.exports = function hash(buf, fn) {
    var arr = fn($8a1967d13b803f87$var$toArray(buf), buf.length * $8a1967d13b803f87$var$charSize);
    buf = new $8a1967d13b803f87$require$Buffer($8a1967d13b803f87$var$hashSize);
    for(var i = 0; i < arr.length; i++)buf.writeInt32LE(arr[i], i << 2, true);
    return buf;
};

});


parcelRegister("3vzY0", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $28e02aa07b933bee$require$Buffer = $6ZWSX.Buffer;
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $7G2iN = parcelRequire("7G2iN");
function $28e02aa07b933bee$var$RIPEMD160() {
    $7G2iN.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($28e02aa07b933bee$var$RIPEMD160, $7G2iN);
$28e02aa07b933bee$var$RIPEMD160.prototype._update = function() {
    var m = new Array(16);
    for(var i = 0; i < 16; ++i)m[i] = this._block.readInt32LE(i * 4);
    var al = this._a;
    var bl = this._b;
    var cl = this._c;
    var dl = this._d;
    var el = this._e;
    // Mj = 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
    // K = 0x00000000
    // Sj = 11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8
    al = $28e02aa07b933bee$var$fn1(al, bl, cl, dl, el, m[0], 0x00000000, 11);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn1(el, al, bl, cl, dl, m[1], 0x00000000, 14);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn1(dl, el, al, bl, cl, m[2], 0x00000000, 15);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn1(cl, dl, el, al, bl, m[3], 0x00000000, 12);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn1(bl, cl, dl, el, al, m[4], 0x00000000, 5);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn1(al, bl, cl, dl, el, m[5], 0x00000000, 8);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn1(el, al, bl, cl, dl, m[6], 0x00000000, 7);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn1(dl, el, al, bl, cl, m[7], 0x00000000, 9);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn1(cl, dl, el, al, bl, m[8], 0x00000000, 11);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn1(bl, cl, dl, el, al, m[9], 0x00000000, 13);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn1(al, bl, cl, dl, el, m[10], 0x00000000, 14);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn1(el, al, bl, cl, dl, m[11], 0x00000000, 15);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn1(dl, el, al, bl, cl, m[12], 0x00000000, 6);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn1(cl, dl, el, al, bl, m[13], 0x00000000, 7);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn1(bl, cl, dl, el, al, m[14], 0x00000000, 9);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn1(al, bl, cl, dl, el, m[15], 0x00000000, 8);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    // Mj = 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8
    // K = 0x5a827999
    // Sj = 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12
    el = $28e02aa07b933bee$var$fn2(el, al, bl, cl, dl, m[7], 0x5a827999, 7);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn2(dl, el, al, bl, cl, m[4], 0x5a827999, 6);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn2(cl, dl, el, al, bl, m[13], 0x5a827999, 8);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn2(bl, cl, dl, el, al, m[1], 0x5a827999, 13);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn2(al, bl, cl, dl, el, m[10], 0x5a827999, 11);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn2(el, al, bl, cl, dl, m[6], 0x5a827999, 9);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn2(dl, el, al, bl, cl, m[15], 0x5a827999, 7);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn2(cl, dl, el, al, bl, m[3], 0x5a827999, 15);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn2(bl, cl, dl, el, al, m[12], 0x5a827999, 7);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn2(al, bl, cl, dl, el, m[0], 0x5a827999, 12);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn2(el, al, bl, cl, dl, m[9], 0x5a827999, 15);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn2(dl, el, al, bl, cl, m[5], 0x5a827999, 9);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn2(cl, dl, el, al, bl, m[2], 0x5a827999, 11);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn2(bl, cl, dl, el, al, m[14], 0x5a827999, 7);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn2(al, bl, cl, dl, el, m[11], 0x5a827999, 13);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn2(el, al, bl, cl, dl, m[8], 0x5a827999, 12);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    // Mj = 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12
    // K = 0x6ed9eba1
    // Sj = 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5
    dl = $28e02aa07b933bee$var$fn3(dl, el, al, bl, cl, m[3], 0x6ed9eba1, 11);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn3(cl, dl, el, al, bl, m[10], 0x6ed9eba1, 13);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn3(bl, cl, dl, el, al, m[14], 0x6ed9eba1, 6);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn3(al, bl, cl, dl, el, m[4], 0x6ed9eba1, 7);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn3(el, al, bl, cl, dl, m[9], 0x6ed9eba1, 14);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn3(dl, el, al, bl, cl, m[15], 0x6ed9eba1, 9);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn3(cl, dl, el, al, bl, m[8], 0x6ed9eba1, 13);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn3(bl, cl, dl, el, al, m[1], 0x6ed9eba1, 15);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn3(al, bl, cl, dl, el, m[2], 0x6ed9eba1, 14);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn3(el, al, bl, cl, dl, m[7], 0x6ed9eba1, 8);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn3(dl, el, al, bl, cl, m[0], 0x6ed9eba1, 13);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn3(cl, dl, el, al, bl, m[6], 0x6ed9eba1, 6);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn3(bl, cl, dl, el, al, m[13], 0x6ed9eba1, 5);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn3(al, bl, cl, dl, el, m[11], 0x6ed9eba1, 12);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn3(el, al, bl, cl, dl, m[5], 0x6ed9eba1, 7);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn3(dl, el, al, bl, cl, m[12], 0x6ed9eba1, 5);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    // Mj = 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2
    // K = 0x8f1bbcdc
    // Sj = 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12
    cl = $28e02aa07b933bee$var$fn4(cl, dl, el, al, bl, m[1], 0x8f1bbcdc, 11);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn4(bl, cl, dl, el, al, m[9], 0x8f1bbcdc, 12);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn4(al, bl, cl, dl, el, m[11], 0x8f1bbcdc, 14);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn4(el, al, bl, cl, dl, m[10], 0x8f1bbcdc, 15);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn4(dl, el, al, bl, cl, m[0], 0x8f1bbcdc, 14);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn4(cl, dl, el, al, bl, m[8], 0x8f1bbcdc, 15);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn4(bl, cl, dl, el, al, m[12], 0x8f1bbcdc, 9);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn4(al, bl, cl, dl, el, m[4], 0x8f1bbcdc, 8);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn4(el, al, bl, cl, dl, m[13], 0x8f1bbcdc, 9);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn4(dl, el, al, bl, cl, m[3], 0x8f1bbcdc, 14);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn4(cl, dl, el, al, bl, m[7], 0x8f1bbcdc, 5);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn4(bl, cl, dl, el, al, m[15], 0x8f1bbcdc, 6);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn4(al, bl, cl, dl, el, m[14], 0x8f1bbcdc, 8);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn4(el, al, bl, cl, dl, m[5], 0x8f1bbcdc, 6);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn4(dl, el, al, bl, cl, m[6], 0x8f1bbcdc, 5);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn4(cl, dl, el, al, bl, m[2], 0x8f1bbcdc, 12);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    // Mj = 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    // K = 0xa953fd4e
    // Sj = 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    bl = $28e02aa07b933bee$var$fn5(bl, cl, dl, el, al, m[4], 0xa953fd4e, 9);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn5(al, bl, cl, dl, el, m[0], 0xa953fd4e, 15);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn5(el, al, bl, cl, dl, m[5], 0xa953fd4e, 5);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn5(dl, el, al, bl, cl, m[9], 0xa953fd4e, 11);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn5(cl, dl, el, al, bl, m[7], 0xa953fd4e, 6);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn5(bl, cl, dl, el, al, m[12], 0xa953fd4e, 8);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn5(al, bl, cl, dl, el, m[2], 0xa953fd4e, 13);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn5(el, al, bl, cl, dl, m[10], 0xa953fd4e, 12);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn5(dl, el, al, bl, cl, m[14], 0xa953fd4e, 5);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn5(cl, dl, el, al, bl, m[1], 0xa953fd4e, 12);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn5(bl, cl, dl, el, al, m[3], 0xa953fd4e, 13);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    al = $28e02aa07b933bee$var$fn5(al, bl, cl, dl, el, m[8], 0xa953fd4e, 14);
    cl = $28e02aa07b933bee$var$rotl(cl, 10);
    el = $28e02aa07b933bee$var$fn5(el, al, bl, cl, dl, m[11], 0xa953fd4e, 11);
    bl = $28e02aa07b933bee$var$rotl(bl, 10);
    dl = $28e02aa07b933bee$var$fn5(dl, el, al, bl, cl, m[6], 0xa953fd4e, 8);
    al = $28e02aa07b933bee$var$rotl(al, 10);
    cl = $28e02aa07b933bee$var$fn5(cl, dl, el, al, bl, m[15], 0xa953fd4e, 5);
    el = $28e02aa07b933bee$var$rotl(el, 10);
    bl = $28e02aa07b933bee$var$fn5(bl, cl, dl, el, al, m[13], 0xa953fd4e, 6);
    dl = $28e02aa07b933bee$var$rotl(dl, 10);
    var ar = this._a;
    var br = this._b;
    var cr = this._c;
    var dr = this._d;
    var er = this._e;
    // M'j = 5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12
    // K' = 0x50a28be6
    // S'j = 8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6
    ar = $28e02aa07b933bee$var$fn5(ar, br, cr, dr, er, m[5], 0x50a28be6, 8);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn5(er, ar, br, cr, dr, m[14], 0x50a28be6, 9);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn5(dr, er, ar, br, cr, m[7], 0x50a28be6, 9);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn5(cr, dr, er, ar, br, m[0], 0x50a28be6, 11);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn5(br, cr, dr, er, ar, m[9], 0x50a28be6, 13);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn5(ar, br, cr, dr, er, m[2], 0x50a28be6, 15);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn5(er, ar, br, cr, dr, m[11], 0x50a28be6, 15);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn5(dr, er, ar, br, cr, m[4], 0x50a28be6, 5);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn5(cr, dr, er, ar, br, m[13], 0x50a28be6, 7);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn5(br, cr, dr, er, ar, m[6], 0x50a28be6, 7);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn5(ar, br, cr, dr, er, m[15], 0x50a28be6, 8);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn5(er, ar, br, cr, dr, m[8], 0x50a28be6, 11);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn5(dr, er, ar, br, cr, m[1], 0x50a28be6, 14);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn5(cr, dr, er, ar, br, m[10], 0x50a28be6, 14);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn5(br, cr, dr, er, ar, m[3], 0x50a28be6, 12);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn5(ar, br, cr, dr, er, m[12], 0x50a28be6, 6);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    // M'j = 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2
    // K' = 0x5c4dd124
    // S'j = 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11
    er = $28e02aa07b933bee$var$fn4(er, ar, br, cr, dr, m[6], 0x5c4dd124, 9);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn4(dr, er, ar, br, cr, m[11], 0x5c4dd124, 13);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn4(cr, dr, er, ar, br, m[3], 0x5c4dd124, 15);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn4(br, cr, dr, er, ar, m[7], 0x5c4dd124, 7);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn4(ar, br, cr, dr, er, m[0], 0x5c4dd124, 12);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn4(er, ar, br, cr, dr, m[13], 0x5c4dd124, 8);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn4(dr, er, ar, br, cr, m[5], 0x5c4dd124, 9);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn4(cr, dr, er, ar, br, m[10], 0x5c4dd124, 11);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn4(br, cr, dr, er, ar, m[14], 0x5c4dd124, 7);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn4(ar, br, cr, dr, er, m[15], 0x5c4dd124, 7);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn4(er, ar, br, cr, dr, m[8], 0x5c4dd124, 12);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn4(dr, er, ar, br, cr, m[12], 0x5c4dd124, 7);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn4(cr, dr, er, ar, br, m[4], 0x5c4dd124, 6);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn4(br, cr, dr, er, ar, m[9], 0x5c4dd124, 15);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn4(ar, br, cr, dr, er, m[1], 0x5c4dd124, 13);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn4(er, ar, br, cr, dr, m[2], 0x5c4dd124, 11);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    // M'j = 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13
    // K' = 0x6d703ef3
    // S'j = 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5
    dr = $28e02aa07b933bee$var$fn3(dr, er, ar, br, cr, m[15], 0x6d703ef3, 9);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn3(cr, dr, er, ar, br, m[5], 0x6d703ef3, 7);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn3(br, cr, dr, er, ar, m[1], 0x6d703ef3, 15);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn3(ar, br, cr, dr, er, m[3], 0x6d703ef3, 11);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn3(er, ar, br, cr, dr, m[7], 0x6d703ef3, 8);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn3(dr, er, ar, br, cr, m[14], 0x6d703ef3, 6);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn3(cr, dr, er, ar, br, m[6], 0x6d703ef3, 6);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn3(br, cr, dr, er, ar, m[9], 0x6d703ef3, 14);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn3(ar, br, cr, dr, er, m[11], 0x6d703ef3, 12);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn3(er, ar, br, cr, dr, m[8], 0x6d703ef3, 13);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn3(dr, er, ar, br, cr, m[12], 0x6d703ef3, 5);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn3(cr, dr, er, ar, br, m[2], 0x6d703ef3, 14);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn3(br, cr, dr, er, ar, m[10], 0x6d703ef3, 13);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn3(ar, br, cr, dr, er, m[0], 0x6d703ef3, 13);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn3(er, ar, br, cr, dr, m[4], 0x6d703ef3, 7);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn3(dr, er, ar, br, cr, m[13], 0x6d703ef3, 5);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    // M'j = 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14
    // K' = 0x7a6d76e9
    // S'j = 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8
    cr = $28e02aa07b933bee$var$fn2(cr, dr, er, ar, br, m[8], 0x7a6d76e9, 15);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn2(br, cr, dr, er, ar, m[6], 0x7a6d76e9, 5);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn2(ar, br, cr, dr, er, m[4], 0x7a6d76e9, 8);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn2(er, ar, br, cr, dr, m[1], 0x7a6d76e9, 11);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn2(dr, er, ar, br, cr, m[3], 0x7a6d76e9, 14);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn2(cr, dr, er, ar, br, m[11], 0x7a6d76e9, 14);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn2(br, cr, dr, er, ar, m[15], 0x7a6d76e9, 6);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn2(ar, br, cr, dr, er, m[0], 0x7a6d76e9, 14);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn2(er, ar, br, cr, dr, m[5], 0x7a6d76e9, 6);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn2(dr, er, ar, br, cr, m[12], 0x7a6d76e9, 9);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn2(cr, dr, er, ar, br, m[2], 0x7a6d76e9, 12);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn2(br, cr, dr, er, ar, m[13], 0x7a6d76e9, 9);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn2(ar, br, cr, dr, er, m[9], 0x7a6d76e9, 12);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn2(er, ar, br, cr, dr, m[7], 0x7a6d76e9, 5);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn2(dr, er, ar, br, cr, m[10], 0x7a6d76e9, 15);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn2(cr, dr, er, ar, br, m[14], 0x7a6d76e9, 8);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    // M'j = 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    // K' = 0x00000000
    // S'j = 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    br = $28e02aa07b933bee$var$fn1(br, cr, dr, er, ar, m[12], 0x00000000, 8);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn1(ar, br, cr, dr, er, m[15], 0x00000000, 5);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn1(er, ar, br, cr, dr, m[10], 0x00000000, 12);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn1(dr, er, ar, br, cr, m[4], 0x00000000, 9);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn1(cr, dr, er, ar, br, m[1], 0x00000000, 12);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn1(br, cr, dr, er, ar, m[5], 0x00000000, 5);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn1(ar, br, cr, dr, er, m[8], 0x00000000, 14);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn1(er, ar, br, cr, dr, m[7], 0x00000000, 6);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn1(dr, er, ar, br, cr, m[6], 0x00000000, 8);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn1(cr, dr, er, ar, br, m[2], 0x00000000, 13);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn1(br, cr, dr, er, ar, m[13], 0x00000000, 6);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    ar = $28e02aa07b933bee$var$fn1(ar, br, cr, dr, er, m[14], 0x00000000, 5);
    cr = $28e02aa07b933bee$var$rotl(cr, 10);
    er = $28e02aa07b933bee$var$fn1(er, ar, br, cr, dr, m[0], 0x00000000, 15);
    br = $28e02aa07b933bee$var$rotl(br, 10);
    dr = $28e02aa07b933bee$var$fn1(dr, er, ar, br, cr, m[3], 0x00000000, 13);
    ar = $28e02aa07b933bee$var$rotl(ar, 10);
    cr = $28e02aa07b933bee$var$fn1(cr, dr, er, ar, br, m[9], 0x00000000, 11);
    er = $28e02aa07b933bee$var$rotl(er, 10);
    br = $28e02aa07b933bee$var$fn1(br, cr, dr, er, ar, m[11], 0x00000000, 11);
    dr = $28e02aa07b933bee$var$rotl(dr, 10);
    // change state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$28e02aa07b933bee$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $28e02aa07b933bee$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $28e02aa07b933bee$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $28e02aa07b933bee$var$fn1(a, b, c, d, e, m, k, s) {
    return $28e02aa07b933bee$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $28e02aa07b933bee$var$fn2(a, b, c, d, e, m, k, s) {
    return $28e02aa07b933bee$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $28e02aa07b933bee$var$fn3(a, b, c, d, e, m, k, s) {
    return $28e02aa07b933bee$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $28e02aa07b933bee$var$fn4(a, b, c, d, e, m, k, s) {
    return $28e02aa07b933bee$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $28e02aa07b933bee$var$fn5(a, b, c, d, e, m, k, s) {
    return $28e02aa07b933bee$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $28e02aa07b933bee$var$RIPEMD160;

});
parcelRegister("7G2iN", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $596e3dca14460d73$require$Buffer = $6ZWSX.Buffer;
'use strict';

var $ioRHp = parcelRequire("ioRHp");
var $596e3dca14460d73$require$Transform = $ioRHp.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $596e3dca14460d73$var$HashBase(blockSize) {
    $596e3dca14460d73$require$Transform.call(this);
    this._block = new $596e3dca14460d73$require$Buffer(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($596e3dca14460d73$var$HashBase, $596e3dca14460d73$require$Transform);
$596e3dca14460d73$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        if (encoding !== 'buffer') chunk = new $596e3dca14460d73$require$Buffer(chunk, encoding);
        this.update(chunk);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$596e3dca14460d73$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this._digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$596e3dca14460d73$var$HashBase.prototype.update = function(data, encoding) {
    if (!$596e3dca14460d73$require$Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
    if (this._finalized) throw new Error('Digest already called');
    if (!$596e3dca14460d73$require$Buffer.isBuffer(data)) data = new $596e3dca14460d73$require$Buffer(data, encoding || 'binary');
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$596e3dca14460d73$var$HashBase.prototype._update = function(data) {
    throw new Error('_update is not implemented');
};
$596e3dca14460d73$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    return digest;
};
$596e3dca14460d73$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $596e3dca14460d73$var$HashBase;

});


parcelRegister("kiaDM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
var $ec5dbe1d2de061b3$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $ec5dbe1d2de061b3$var$useArrayBuffer = $ec5dbe1d2de061b3$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $ec5dbe1d2de061b3$var$isView = $ec5dbe1d2de061b3$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $ec5dbe1d2de061b3$require$Buffer.isBuffer(thing) || $ec5dbe1d2de061b3$var$useUint8Array && thing instanceof Uint8Array || $ec5dbe1d2de061b3$var$isView && $ec5dbe1d2de061b3$var$isView(thing)) return $5KQLs(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("eyeBm", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $a97f913e2ff95e3b$export$bdd223f16383713e, (v) => $a97f913e2ff95e3b$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $a97f913e2ff95e3b$export$26e5786e8ac8e530, (v) => $a97f913e2ff95e3b$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $a97f913e2ff95e3b$export$2f64596b8cbf08b4, (v) => $a97f913e2ff95e3b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $a97f913e2ff95e3b$export$20533d26f07f1ee0, (v) => $a97f913e2ff95e3b$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $a97f913e2ff95e3b$export$12ada9414fbc594c, (v) => $a97f913e2ff95e3b$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a, (v) => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $a97f913e2ff95e3b$export$36b6d6ef312eab39, (v) => $a97f913e2ff95e3b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $a97f913e2ff95e3b$export$f5e7e39d57cd9700, (v) => $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $a97f913e2ff95e3b$export$dedd8dc3dc62b370, (v) => $a97f913e2ff95e3b$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $a97f913e2ff95e3b$export$58a258485f1e49f6, (v) => $a97f913e2ff95e3b$export$58a258485f1e49f6 = v);
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;

var $ljOtR = parcelRequire("ljOtR");

var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");

var $xsYYh = parcelRequire("xsYYh");

var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($xsYYh).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;

});
parcelRegister("ljOtR", function(module, exports) {

var $26nOC = parcelRequire("26nOC");

var $8SeDJ = parcelRequire("8SeDJ");

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    'des-ede3-cbc': $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    'des-ede3': $8SeDJ.EDE,
    'des-ede-cbc': $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    'des-ede': $8SeDJ.EDE,
    'des-cbc': $8SeDJ.CBC.instantiate($8SeDJ.DES),
    'des-ecb': $8SeDJ.DES
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes['des-cbc'];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes['des-ede3-cbc'];
module.exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};

});
parcelRegister("8SeDJ", function(module, exports) {

$parcel$export(module.exports, "DES", () => $675eb908dbde2e68$export$cc8859615686b300, (v) => $675eb908dbde2e68$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $675eb908dbde2e68$export$8ad3f227af08fcc5, (v) => $675eb908dbde2e68$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $675eb908dbde2e68$export$947646e34766044f, (v) => $675eb908dbde2e68$export$947646e34766044f = v);
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
'use strict';

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));

});
parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
'use strict';
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("enfpo", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $dB8Kv.create({
            type: 'encrypt',
            key: k1
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: 'decrypt',
            key: k3
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});



parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});

parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv, true);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});


parcelRegister("xsYYh", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("5NszM", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $4387b1fafb8a1868$export$971862a2fcb1bb40, (v) => $4387b1fafb8a1868$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $4387b1fafb8a1868$export$c6ff6a88acbeaf40, (v) => $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $4387b1fafb8a1868$export$fdc27893e98845cc, (v) => $4387b1fafb8a1868$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $4387b1fafb8a1868$export$6671fb9a1323bed, (v) => $4387b1fafb8a1868$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $4387b1fafb8a1868$export$d74daf141a551db, (v) => $4387b1fafb8a1868$export$d74daf141a551db = v);
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;

var $aV75E = parcelRequire("aV75E");

var $kGErQ = parcelRequire("kGErQ");

var $bLCm8 = parcelRequire("bLCm8");
function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].prime, 'hex');
    var gen = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].gen, 'hex');
    return new $bLCm8(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $bLCm8($aV75E(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $bLCm8(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;

});
parcelRegister("aV75E", function(module, exports) {

var $hkN9y = parcelRequire("hkN9y");
module.exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);

var $g2bJL = parcelRequire("g2bJL");
var $7f34ba2fa9025258$var$millerRabin = new $g2bJL();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("g2bJL", function(module, exports) {

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
module.exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("kGErQ", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff\"}}");

});

parcelRegister("bLCm8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $g2bJL = parcelRequire("g2bJL");
var $8911d62d5514749e$var$millerRabin = new $g2bJL();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);

var $aV75E = parcelRequire("aV75E");

var $hkN9y = parcelRequire("hkN9y");
module.exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$aV75E.simpleSieve || !$aV75E.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("4zMFU", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");

var $6E9kG = parcelRequire("6E9kG");

var $fQdau = parcelRequire("fQdau");

var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, 'hex');
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $6E9kG(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $fQdau(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
module.exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};

});
parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $9845726cca5dc7eb$var$Readable;

var $767Wy = parcelRequire("767Wy");
/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $9845726cca5dc7eb$require$Buffer = $h3oXE.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$util = Object.create((parcelRequire("dH2Jp")));

$9845726cca5dc7eb$var$util.inherits = (parcelRequire("dlqwk"));

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug = void 0;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog('stream');
else $9845726cca5dc7eb$var$debug = function() {};

var $185iR = parcelRequire("185iR");

var $fMCbt = parcelRequire("fMCbt");
var $9845726cca5dc7eb$var$StringDecoder;
$9845726cca5dc7eb$var$util.inherits($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($767Wy(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $185iR();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $9845726cca5dc7eb$var$needMoreData(state);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $9845726cca5dc7eb$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
    this._readableState.decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $9845726cca5dc7eb$var$MAX_HWM = 0x800000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $9845726cca5dc7eb$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $9845726cca5dc7eb$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $bUlqC.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
        else $9845726cca5dc7eb$var$emitReadable_(stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    $9845726cca5dc7eb$var$debug('emit readable');
    stream.emit('readable');
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $9845726cca5dc7eb$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $bUlqC.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $bUlqC.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
            else if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('resume');
        state.flowing = true;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    if (!state.reading) {
        $9845726cca5dc7eb$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $9845726cca5dc7eb$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $9845726cca5dc7eb$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $9845726cca5dc7eb$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $9845726cca5dc7eb$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $9845726cca5dc7eb$var$copyFromBufferString(n, list) : $9845726cca5dc7eb$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBuffer(n, list) {
    var ret = $9845726cca5dc7eb$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bUlqC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = {
    nextTick: $8ab58be9444f732a$var$nextTick
};
function $8ab58be9444f732a$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $hPtJY.nextTick(fn);
        case 2:
            return $hPtJY.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $hPtJY.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $hPtJY.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $hPtJY.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("h3oXE", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c6a6143e40fe9703$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $c6a6143e40fe9703$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c6a6143e40fe9703$var$Buffer.from && $c6a6143e40fe9703$var$Buffer.alloc && $c6a6143e40fe9703$var$Buffer.allocUnsafe && $c6a6143e40fe9703$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $c6a6143e40fe9703$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $c6a6143e40fe9703$var$SafeBuffer;
}
function $c6a6143e40fe9703$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$c6a6143e40fe9703$var$copyProps($c6a6143e40fe9703$var$Buffer, $c6a6143e40fe9703$var$SafeBuffer);
$c6a6143e40fe9703$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
};
$c6a6143e40fe9703$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $c6a6143e40fe9703$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $c6a6143e40fe9703$var$Buffer(size);
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});

parcelRegister("dH2Jp", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $9f8168ed52eee242$export$43bee75e5e14138e, (v) => $9f8168ed52eee242$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $9f8168ed52eee242$export$f9ce7b637dfbe238, (v) => $9f8168ed52eee242$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $9f8168ed52eee242$export$630801d484da15df, (v) => $9f8168ed52eee242$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $9f8168ed52eee242$export$bedb7023a7733221, (v) => $9f8168ed52eee242$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $9f8168ed52eee242$export$7e4aa119212bc614, (v) => $9f8168ed52eee242$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $9f8168ed52eee242$export$844ec244b1367d54, (v) => $9f8168ed52eee242$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $9f8168ed52eee242$export$a244864fd9645c7f, (v) => $9f8168ed52eee242$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $9f8168ed52eee242$export$fce6876652108ab, (v) => $9f8168ed52eee242$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $9f8168ed52eee242$export$49841c62b9eff15, (v) => $9f8168ed52eee242$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $9f8168ed52eee242$export$a6cdc56e425d0d0a, (v) => $9f8168ed52eee242$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $9f8168ed52eee242$export$871608497c498473, (v) => $9f8168ed52eee242$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $9f8168ed52eee242$export$e6127cc7fe7395c3, (v) => $9f8168ed52eee242$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $9f8168ed52eee242$export$f6e2535fb5126e54, (v) => $9f8168ed52eee242$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $9f8168ed52eee242$export$c3825b437cbdea5c, (v) => $9f8168ed52eee242$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $9f8168ed52eee242$export$a7884ebc965f8f54, (v) => $9f8168ed52eee242$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $9f8168ed52eee242$export$43bee75e5e14138e;
var $9f8168ed52eee242$export$f9ce7b637dfbe238;
var $9f8168ed52eee242$export$630801d484da15df;
var $9f8168ed52eee242$export$bedb7023a7733221;
var $9f8168ed52eee242$export$7e4aa119212bc614;
var $9f8168ed52eee242$export$844ec244b1367d54;
var $9f8168ed52eee242$export$a244864fd9645c7f;
var $9f8168ed52eee242$export$fce6876652108ab;
var $9f8168ed52eee242$export$49841c62b9eff15;
var $9f8168ed52eee242$export$a6cdc56e425d0d0a;
var $9f8168ed52eee242$export$871608497c498473;
var $9f8168ed52eee242$export$e6127cc7fe7395c3;
var $9f8168ed52eee242$export$f6e2535fb5126e54;
var $9f8168ed52eee242$export$c3825b437cbdea5c;
var $9f8168ed52eee242$export$a7884ebc965f8f54;
function $9f8168ed52eee242$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $9f8168ed52eee242$var$objectToString(arg) === '[object Array]';
}
$9f8168ed52eee242$export$43bee75e5e14138e = $9f8168ed52eee242$var$isArray;
function $9f8168ed52eee242$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$9f8168ed52eee242$export$f9ce7b637dfbe238 = $9f8168ed52eee242$var$isBoolean;
function $9f8168ed52eee242$var$isNull(arg) {
    return arg === null;
}
$9f8168ed52eee242$export$630801d484da15df = $9f8168ed52eee242$var$isNull;
function $9f8168ed52eee242$var$isNullOrUndefined(arg) {
    return arg == null;
}
$9f8168ed52eee242$export$bedb7023a7733221 = $9f8168ed52eee242$var$isNullOrUndefined;
function $9f8168ed52eee242$var$isNumber(arg) {
    return typeof arg === 'number';
}
$9f8168ed52eee242$export$7e4aa119212bc614 = $9f8168ed52eee242$var$isNumber;
function $9f8168ed52eee242$var$isString(arg) {
    return typeof arg === 'string';
}
$9f8168ed52eee242$export$844ec244b1367d54 = $9f8168ed52eee242$var$isString;
function $9f8168ed52eee242$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$9f8168ed52eee242$export$a244864fd9645c7f = $9f8168ed52eee242$var$isSymbol;
function $9f8168ed52eee242$var$isUndefined(arg) {
    return arg === void 0;
}
$9f8168ed52eee242$export$fce6876652108ab = $9f8168ed52eee242$var$isUndefined;
function $9f8168ed52eee242$var$isRegExp(re) {
    return $9f8168ed52eee242$var$objectToString(re) === '[object RegExp]';
}
$9f8168ed52eee242$export$49841c62b9eff15 = $9f8168ed52eee242$var$isRegExp;
function $9f8168ed52eee242$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$9f8168ed52eee242$export$a6cdc56e425d0d0a = $9f8168ed52eee242$var$isObject;
function $9f8168ed52eee242$var$isDate(d) {
    return $9f8168ed52eee242$var$objectToString(d) === '[object Date]';
}
$9f8168ed52eee242$export$871608497c498473 = $9f8168ed52eee242$var$isDate;
function $9f8168ed52eee242$var$isError(e) {
    return $9f8168ed52eee242$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$9f8168ed52eee242$export$e6127cc7fe7395c3 = $9f8168ed52eee242$var$isError;
function $9f8168ed52eee242$var$isFunction(arg) {
    return typeof arg === 'function';
}
$9f8168ed52eee242$export$f6e2535fb5126e54 = $9f8168ed52eee242$var$isFunction;
function $9f8168ed52eee242$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$9f8168ed52eee242$export$c3825b437cbdea5c = $9f8168ed52eee242$var$isPrimitive;

$9f8168ed52eee242$export$a7884ebc965f8f54 = (parcelRequire("6ZWSX")).Buffer.isBuffer;
function $9f8168ed52eee242$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("185iR", function(module, exports) {
'use strict';
function $0d2aa6ea56b3e1e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $h3oXE = parcelRequire("h3oXE");
var $0d2aa6ea56b3e1e2$require$Buffer = $h3oXE.Buffer;

var $kjyEk = parcelRequire("kjyEk");
function $0d2aa6ea56b3e1e2$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $0d2aa6ea56b3e1e2$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $0d2aa6ea56b3e1e2$require$Buffer.alloc(0);
        var ret = $0d2aa6ea56b3e1e2$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $0d2aa6ea56b3e1e2$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($kjyEk && $kjyEk.inspect && $kjyEk.inspect.custom) module.exports.prototype[$kjyEk.inspect.custom] = function() {
    var obj = $kjyEk.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("fMCbt", function(module, exports) {
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy
};

});

parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ /*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

/*<replacement>*/ var $076d08b0309449dc$var$util = Object.create((parcelRequire("dH2Jp")));

$076d08b0309449dc$var$util.inherits = (parcelRequire("dlqwk"));

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");
$076d08b0309449dc$var$util.inherits($076d08b0309449dc$var$Duplex, $d4xg3);
// avoid scope creep, the keys array can then be collected
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $076d08b0309449dc$var$onend);
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $bUlqC.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$076d08b0309449dc$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $bUlqC.nextTick(cb, err);
};

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$asyncWrite = (0, $bUlqC.nextTick);
/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$util = Object.create((parcelRequire("dH2Jp")));

$2bdf55c2c4f390d3$var$util.inherits = (parcelRequire("dlqwk"));

/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $2bdf55c2c4f390d3$require$Buffer = $h3oXE.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");
$2bdf55c2c4f390d3$var$util.inherits($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, 'buffer', {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this) && !(this instanceof $2bdf55c2c4f390d3$var$Duplex)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $bUlqC.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $bUlqC.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ended) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $bUlqC.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $bUlqC.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $2bdf55c2c4f390d3$var$asyncWrite($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
};
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $bUlqC.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $bUlqC.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("imDDS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $d5e9082788fdd47b$export$63a7aa211a91ed69, (v) => $d5e9082788fdd47b$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d5e9082788fdd47b$export$63a7aa211a91ed69;
'use strict';

var $h3oXE = parcelRequire("h3oXE");
var $d5e9082788fdd47b$require$Buffer = $h3oXE.Buffer;
/*</replacement>*/ var $d5e9082788fdd47b$var$isEncoding = $d5e9082788fdd47b$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d5e9082788fdd47b$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d5e9082788fdd47b$var$normalizeEncoding(enc) {
    var nenc = $d5e9082788fdd47b$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d5e9082788fdd47b$require$Buffer.isEncoding === $d5e9082788fdd47b$var$isEncoding || !$d5e9082788fdd47b$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d5e9082788fdd47b$export$63a7aa211a91ed69 = $d5e9082788fdd47b$var$StringDecoder;
function $d5e9082788fdd47b$var$StringDecoder(encoding) {
    this.encoding = $d5e9082788fdd47b$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d5e9082788fdd47b$var$utf16Text;
            this.end = $d5e9082788fdd47b$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d5e9082788fdd47b$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d5e9082788fdd47b$var$base64Text;
            this.end = $d5e9082788fdd47b$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d5e9082788fdd47b$var$simpleWrite;
            this.end = $d5e9082788fdd47b$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d5e9082788fdd47b$require$Buffer.allocUnsafe(nb);
}
$d5e9082788fdd47b$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d5e9082788fdd47b$var$StringDecoder.prototype.end = $d5e9082788fdd47b$var$utf8End;
// Returns only complete characters in a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.text = $d5e9082788fdd47b$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d5e9082788fdd47b$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d5e9082788fdd47b$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d5e9082788fdd47b$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d5e9082788fdd47b$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d5e9082788fdd47b$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d5e9082788fdd47b$var$utf8Text(buf, i) {
    var total = $d5e9082788fdd47b$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d5e9082788fdd47b$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d5e9082788fdd47b$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d5e9082788fdd47b$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d5e9082788fdd47b$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d5e9082788fdd47b$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d5e9082788fdd47b$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d5e9082788fdd47b$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $8180203f7f0d3074$var$Transform;

var $DwJuQ = parcelRequire("DwJuQ");

/*<replacement>*/ var $8180203f7f0d3074$var$util = Object.create((parcelRequire("dH2Jp")));

$8180203f7f0d3074$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $8180203f7f0d3074$var$util.inherits($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

/*<replacement>*/ var $34c74be520d619f2$var$util = Object.create((parcelRequire("dH2Jp")));

$34c74be520d619f2$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $34c74be520d619f2$var$util.inherits($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("6E9kG", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $aYksR[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $4d6db7c28d99f640$var$sign;
module.exports.getKey = $4d6db7c28d99f640$var$getKey;
module.exports.makeKey = $4d6db7c28d99f640$var$makeKey;

});
parcelRegister("3Sg1O", function(module, exports) {
'use strict';

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");

var $1U9GM = parcelRequire("1U9GM");
var $2d22d91c93a13ae5$require$Buffer = $1U9GM.Buffer;
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, 'be', len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});
parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("1zUcV", function(module, exports) {
'use strict';
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});
parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("gEVtY", function(module, exports) {
'use strict';
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $c20cf89948514165$var$utils.toArray(bytes, 'hex') : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, 'hex', 'le');
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lC4vN", function(module, exports) {
'use strict';
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
'use strict';
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, 'short', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, 'mont', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, 'edwards', conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
'use strict';
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $cP1GP.short(options);
    else if (options.type === 'edwards') this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), 'Invalid curve');
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$b0f2b206068f1378$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$b0f2b206068f1378$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$b0f2b206068f1378$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$b0f2b206068f1378$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
'use strict';

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
'use strict';

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 7), 'big');
    else return $btcbI.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("a9EzX", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});


parcelRegister("7j4cV", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 12), 'big');
    else return $btcbI.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("lMBCM", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'little');
    else return $btcbI.split32(this.h, 'little');
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), 'Unknown curve ' + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($jX0xT.isBN(msg) || typeof msg === 'number') {
        msg = new $jX0xT(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $jX0xT(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $jX0xT(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$jX0xT.isBN(msg)) {
        $17ac898fe5b06379$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $17ac898fe5b06379$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$17ac898fe5b06379$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $17ac898fe5b06379$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $17ac898fe5b06379$var$assert(new $jX0xT(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("kKonu", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $lC4vN.toArray(options.pers, options.persEnc || 'hex');
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $fe42f8d68750188b$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $fe42f8d68750188b$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("i46nc", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair is public only');
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $5ca7e26f93e1a560$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});



parcelRegister("aNeDF", function(module, exports) {
'use strict';

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $fC6a8.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $fC6a8.EncryptedPrivateKey.decode(data, 'der');
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $fC6a8.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $fC6a8.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $fC6a8.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $fC6a8.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $fC6a8.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
module.exports = $7db9d5f82e4113aa$var$parseKeys;

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
'use strict';

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define('DSAparam', function() {
    this['int']();
});
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("10gXo", function(module, exports) {
var $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {

var $10gXo = parcelRequire("10gXo");

var $dlqwk = parcelRequire("dlqwk");
var $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("aeJDW")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dlqwk(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($10gXo.decoders[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($10gXo.encoders[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("aeJDW", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("5JhaY", function(module, exports) {
var $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;

var $dlqwk = parcelRequire("dlqwk");

var $5JhaY = parcelRequire("5JhaY");
var $2397844df508f52e$require$Reporter = $5JhaY.Reporter;

var $6ZWSX = parcelRequire("6ZWSX");
var $2397844df508f52e$require$Buffer = $6ZWSX.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $2397844df508f52e$var$EncoderBuffer)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $2397844df508f52e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("h4y6g", function(module, exports) {

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$Reporter = $5JhaY.Reporter;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$EncoderBuffer = $5JhaY.EncoderBuffer;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$DecoderBuffer = $5JhaY.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
var $c6dd42f3395d566f$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $c6dd42f3395d566f$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
var $c6dd42f3395d566f$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $c6dd42f3395d566f$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
var $c6dd42f3395d566f$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, 'Root node can have only one child');
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    var state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $koC21(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $koC21(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("3TcQc", function(module, exports) {
var $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});
parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;

var $3TcQc = parcelRequire("3TcQc");
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$138ac3909863432c$export$f18596ef8d632e49 = $3TcQc._reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$138ac3909863432c$export$f17df38a421ab9e3 = $3TcQc._reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("89TTw", function(module, exports) {
var $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $10gXo = parcelRequire("10gXo");
var $b28be291c8d179e1$var$base = $10gXo.base;
var $b28be291c8d179e1$var$bignum = $10gXo.bignum;
// Import DER constants
var $b28be291c8d179e1$var$der = $10gXo.constants.der;
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b28be291c8d179e1$var$base.DecoderBuffer)) data = new $b28be291c8d179e1$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $b28be291c8d179e1$var$base.Node.call(this, 'der', parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $b28be291c8d179e1$var$base.Node);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b28be291c8d179e1$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b28be291c8d179e1$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b28be291c8d179e1$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $6ef8062b6cdbe0f4$require$Buffer = $6ZWSX.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $6ef8062b6cdbe0f4$require$Buffer(base64, 'base64');
    return $fkoHA.prototype.decode.call(this, input, options);
};

});


parcelRegister("ljw8S", function(module, exports) {
var $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $1ae2666fc718ae87$require$Buffer = $6ZWSX.Buffer;

var $10gXo = parcelRequire("10gXo");
var $1ae2666fc718ae87$var$base = $10gXo.base;
// Import DER constants
var $1ae2666fc718ae87$var$der = $10gXo.constants.der;
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $1ae2666fc718ae87$var$base.Node.call(this, 'der', parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $1ae2666fc718ae87$var$base.Node);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $1ae2666fc718ae87$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $1ae2666fc718ae87$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $1ae2666fc718ae87$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $1ae2666fc718ae87$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $1ae2666fc718ae87$var$two(date.getFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $1ae2666fc718ae87$var$two(date.getFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $1ae2666fc718ae87$require$Buffer(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $1ae2666fc718ae87$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $1ae2666fc718ae87$require$Buffer(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($1ae2666fc718ae87$var$der.tagByName.hasOwnProperty(tag)) res = $1ae2666fc718ae87$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $1ae2666fc718ae87$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("bPffB", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $2j6ve.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define('RelativeDistinguishedName', function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define('RDNSequence', function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define('Name', function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($877bcccea3fc6be5$var$Time), this.key('notAfter').use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('issuer').use($877bcccea3fc6be5$var$Name), this.key('validity').use($877bcccea3fc6be5$var$Validity), this.key('subject').use($877bcccea3fc6be5$var$Name), this.key('subjectPublicKeyInfo').use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($877bcccea3fc6be5$var$TBSCertificate), this.key('signatureAlgorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});


parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("3ILSx", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], 'hex');
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("aYksR", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("fQdau", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $aYksR[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $b885ed4272d45f84$var$verify;

});


parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("fMM6j", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $b7e0a6843ffae451$export$512823e338ddb1b7, (v) => $b7e0a6843ffae451$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $b7e0a6843ffae451$export$7efb24e2fddf99b9, (v) => $b7e0a6843ffae451$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3, (v) => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $b7e0a6843ffae451$export$b9d55ff329113abd, (v) => $b7e0a6843ffae451$export$b9d55ff329113abd = v);
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7('sha1').update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7('sha1').update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("c34vB", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $8c5943302864e9a5$export$bb1abf2ce84fc7e8, (v) => $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $8c5943302864e9a5$export$2f7171e78e524d5e, (v) => $8c5943302864e9a5$export$2f7171e78e524d5e = v);
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}

});


parcelRegister("bpzVP", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $84ede6cc3bc00614$require$Buffer = $1U9GM.Buffer;

var $1Awji = parcelRequire("1Awji");
var $84ede6cc3bc00614$var$MAX_OCTET = 0x80, $84ede6cc3bc00614$var$CLASS_UNIVERSAL = 0, $84ede6cc3bc00614$var$PRIMITIVE_BIT = 0x20, $84ede6cc3bc00614$var$TAG_SEQ = 0x10, $84ede6cc3bc00614$var$TAG_INT = 0x02, $84ede6cc3bc00614$var$ENCODED_TAG_SEQ = $84ede6cc3bc00614$var$TAG_SEQ | $84ede6cc3bc00614$var$PRIMITIVE_BIT | $84ede6cc3bc00614$var$CLASS_UNIVERSAL << 6, $84ede6cc3bc00614$var$ENCODED_TAG_INT = $84ede6cc3bc00614$var$TAG_INT | $84ede6cc3bc00614$var$CLASS_UNIVERSAL << 6;
function $84ede6cc3bc00614$var$base64Url(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $84ede6cc3bc00614$var$signatureAsBuffer(signature) {
    if ($84ede6cc3bc00614$require$Buffer.isBuffer(signature)) return signature;
    else if ('string' === typeof signature) return $84ede6cc3bc00614$require$Buffer.from(signature, 'base64');
    throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}
function $84ede6cc3bc00614$var$derToJose(signature, alg) {
    signature = $84ede6cc3bc00614$var$signatureAsBuffer(signature);
    var paramBytes = $1Awji(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    var maxEncodedParamLength = paramBytes + 1;
    var inputLength = signature.length;
    var offset = 0;
    if (signature[offset++] !== $84ede6cc3bc00614$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    var seqLength = signature[offset++];
    if (seqLength === ($84ede6cc3bc00614$var$MAX_OCTET | 1)) seqLength = signature[offset++];
    if (inputLength - offset < seqLength) throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
    if (signature[offset++] !== $84ede6cc3bc00614$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    var rLength = signature[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
    if (maxEncodedParamLength < rLength) throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== $84ede6cc3bc00614$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    var sLength = signature[offset++];
    if (inputLength - offset !== sLength) throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
    if (maxEncodedParamLength < sLength) throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
    var rPadding = paramBytes - rLength, sPadding = paramBytes - sLength;
    var dst = $84ede6cc3bc00614$require$Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
    offset = paramBytes;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
    dst = dst.toString('base64');
    dst = $84ede6cc3bc00614$var$base64Url(dst);
    return dst;
}
function $84ede6cc3bc00614$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= $84ede6cc3bc00614$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $84ede6cc3bc00614$var$joseToDer(signature, alg) {
    signature = $84ede6cc3bc00614$var$signatureAsBuffer(signature);
    var paramBytes = $1Awji(alg);
    var signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
    var rPadding = $84ede6cc3bc00614$var$countPadding(signature, 0, paramBytes);
    var sPadding = $84ede6cc3bc00614$var$countPadding(signature, paramBytes, signature.length);
    var rLength = paramBytes - rPadding;
    var sLength = paramBytes - sPadding;
    var rsBytes = 2 + rLength + 1 + 1 + sLength;
    var shortLength = rsBytes < $84ede6cc3bc00614$var$MAX_OCTET;
    var dst = $84ede6cc3bc00614$require$Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = $84ede6cc3bc00614$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $84ede6cc3bc00614$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $84ede6cc3bc00614$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, paramBytes);
    } else offset += signature.copy(dst, offset, rPadding, paramBytes);
    dst[offset++] = $84ede6cc3bc00614$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, paramBytes);
    } else signature.copy(dst, offset, paramBytes + sPadding);
    return dst;
}
module.exports = {
    derToJose: $84ede6cc3bc00614$var$derToJose,
    joseToDer: $84ede6cc3bc00614$var$joseToDer
};

});
parcelRegister("1Awji", function(module, exports) {
'use strict';
function $12823763f46b367f$var$getParamSize(keySize) {
    var result = (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
    return result;
}
var $12823763f46b367f$var$paramBytesForAlg = {
    ES256: $12823763f46b367f$var$getParamSize(256),
    ES384: $12823763f46b367f$var$getParamSize(384),
    ES512: $12823763f46b367f$var$getParamSize(521)
};
function $12823763f46b367f$var$getParamBytesForAlg(alg) {
    var paramBytes = $12823763f46b367f$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error('Unknown algorithm "' + alg + '"');
}
module.exports = $12823763f46b367f$var$getParamBytesForAlg;

});


parcelRegister("2wwUJ", function(module, exports) {
/*jshint node:true */ 'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $1d6819fc5f26d2dd$require$Buffer = $6ZWSX.Buffer;

var $6ZWSX = parcelRequire("6ZWSX");
var $1d6819fc5f26d2dd$require$SlowBuffer = $6ZWSX.SlowBuffer;
module.exports = $1d6819fc5f26d2dd$var$bufferEq;
function $1d6819fc5f26d2dd$var$bufferEq(a, b) {
    // shortcutting on type is necessary for correctness
    if (!$1d6819fc5f26d2dd$require$Buffer.isBuffer(a) || !$1d6819fc5f26d2dd$require$Buffer.isBuffer(b)) return false;
    // buffer sizes should be well-known information, so despite this
    // shortcutting, it doesn't leak any information about the *contents* of the
    // buffers.
    if (a.length !== b.length) return false;
    var c = 0;
    for(var i = 0; i < a.length; i++)/*jshint bitwise:false */ c |= a[i] ^ b[i]; // XOR
    return c === 0;
}
$1d6819fc5f26d2dd$var$bufferEq.install = function() {
    $1d6819fc5f26d2dd$require$Buffer.prototype.equal = $1d6819fc5f26d2dd$require$SlowBuffer.prototype.equal = function equal(that) {
        return $1d6819fc5f26d2dd$var$bufferEq(this, that);
    };
};
var $1d6819fc5f26d2dd$var$origBufEqual = $1d6819fc5f26d2dd$require$Buffer.prototype.equal;
var $1d6819fc5f26d2dd$var$origSlowBufEqual = $1d6819fc5f26d2dd$require$SlowBuffer.prototype.equal;
$1d6819fc5f26d2dd$var$bufferEq.restore = function() {
    $1d6819fc5f26d2dd$require$Buffer.prototype.equal = $1d6819fc5f26d2dd$var$origBufEqual;
    $1d6819fc5f26d2dd$require$SlowBuffer.prototype.equal = $1d6819fc5f26d2dd$var$origSlowBufEqual;
};

});


parcelRegister("1vKm0", function(module, exports) {
/*global module*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $119ca4998a9d6e3f$require$Buffer = $6ZWSX.Buffer;
module.exports = function toString(obj) {
    if (typeof obj === 'string') return obj;
    if (typeof obj === 'number' || $119ca4998a9d6e3f$require$Buffer.isBuffer(obj)) return obj.toString();
    return JSON.stringify(obj);
};

});


parcelRegister("jVVQU", function(module, exports) {
/*global module*/ 
var $1U9GM = parcelRequire("1U9GM");
var $03beb692814012e4$require$Buffer = $1U9GM.Buffer;

var $8prZJ = parcelRequire("8prZJ");

var $f2m41 = parcelRequire("f2m41");

var $ioRHp = parcelRequire("ioRHp");

var $1vKm0 = parcelRequire("1vKm0");

var $N7Lcz = parcelRequire("N7Lcz");
var $03beb692814012e4$var$JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
function $03beb692814012e4$var$isObject(thing) {
    return Object.prototype.toString.call(thing) === '[object Object]';
}
function $03beb692814012e4$var$safeJsonParse(thing) {
    if ($03beb692814012e4$var$isObject(thing)) return thing;
    try {
        return JSON.parse(thing);
    } catch (e) {
        return undefined;
    }
}
function $03beb692814012e4$var$headerFromJWS(jwsSig) {
    var encodedHeader = jwsSig.split('.', 1)[0];
    return $03beb692814012e4$var$safeJsonParse($03beb692814012e4$require$Buffer.from(encodedHeader, 'base64').toString('binary'));
}
function $03beb692814012e4$var$securedInputFromJWS(jwsSig) {
    return jwsSig.split('.', 2).join('.');
}
function $03beb692814012e4$var$signatureFromJWS(jwsSig) {
    return jwsSig.split('.')[2];
}
function $03beb692814012e4$var$payloadFromJWS(jwsSig, encoding) {
    encoding = encoding || 'utf8';
    var payload = jwsSig.split('.')[1];
    return $03beb692814012e4$require$Buffer.from(payload, 'base64').toString(encoding);
}
function $03beb692814012e4$var$isValidJws(string) {
    return $03beb692814012e4$var$JWS_REGEX.test(string) && !!$03beb692814012e4$var$headerFromJWS(string);
}
function $03beb692814012e4$var$jwsVerify(jwsSig, algorithm, secretOrKey) {
    if (!algorithm) {
        var err = new Error("Missing algorithm parameter for jws.verify");
        err.code = "MISSING_ALGORITHM";
        throw err;
    }
    jwsSig = $1vKm0(jwsSig);
    var signature = $03beb692814012e4$var$signatureFromJWS(jwsSig);
    var securedInput = $03beb692814012e4$var$securedInputFromJWS(jwsSig);
    var algo = $f2m41(algorithm);
    return algo.verify(securedInput, signature, secretOrKey);
}
function $03beb692814012e4$var$jwsDecode(jwsSig, opts) {
    opts = opts || {};
    jwsSig = $1vKm0(jwsSig);
    if (!$03beb692814012e4$var$isValidJws(jwsSig)) return null;
    var header = $03beb692814012e4$var$headerFromJWS(jwsSig);
    if (!header) return null;
    var payload = $03beb692814012e4$var$payloadFromJWS(jwsSig);
    if (header.typ === 'JWT' || opts.json) payload = JSON.parse(payload, opts.encoding);
    return {
        header: header,
        payload: payload,
        signature: $03beb692814012e4$var$signatureFromJWS(jwsSig)
    };
}
function $03beb692814012e4$var$VerifyStream(opts) {
    opts = opts || {};
    var secretOrKey = opts.secret || opts.publicKey || opts.key;
    var secretStream = new $8prZJ(secretOrKey);
    this.readable = true;
    this.algorithm = opts.algorithm;
    this.encoding = opts.encoding;
    this.secret = this.publicKey = this.key = secretStream;
    this.signature = new $8prZJ(opts.signature);
    this.secret.once('close', (function() {
        if (!this.signature.writable && this.readable) this.verify();
    }).bind(this));
    this.signature.once('close', (function() {
        if (!this.secret.writable && this.readable) this.verify();
    }).bind(this));
}
$N7Lcz.inherits($03beb692814012e4$var$VerifyStream, $ioRHp);
$03beb692814012e4$var$VerifyStream.prototype.verify = function verify() {
    try {
        var valid = $03beb692814012e4$var$jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
        var obj = $03beb692814012e4$var$jwsDecode(this.signature.buffer, this.encoding);
        this.emit('done', valid, obj);
        this.emit('data', valid);
        this.emit('end');
        this.readable = false;
        return valid;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$03beb692814012e4$var$VerifyStream.decode = $03beb692814012e4$var$jwsDecode;
$03beb692814012e4$var$VerifyStream.isValid = $03beb692814012e4$var$isValidJws;
$03beb692814012e4$var$VerifyStream.verify = $03beb692814012e4$var$jwsVerify;
module.exports = $03beb692814012e4$var$VerifyStream;

});



parcelRegister("1PSJS", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $156503e0affac391$require$Buffer = $6ZWSX.Buffer;

var $4r9pO = parcelRequire("4r9pO");

var $fUN9R = parcelRequire("fUN9R");

var $agX5Y = parcelRequire("agX5Y");

var $7SR5F = parcelRequire("7SR5F");

var $bkFw0 = parcelRequire("bkFw0");

var $1RGDU = parcelRequire("1RGDU");

var $jaMrC = parcelRequire("jaMrC");

var $4QOjN = parcelRequire("4QOjN");

var $5UUfm = parcelRequire("5UUfm");
var $156503e0affac391$require$KeyObject = $5UUfm.KeyObject;
var $156503e0affac391$require$createSecretKey = $5UUfm.createSecretKey;
var $156503e0affac391$require$createPublicKey = $5UUfm.createPublicKey;
const $156503e0affac391$var$PUB_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
const $156503e0affac391$var$EC_KEY_ALGS = [
    'ES256',
    'ES384',
    'ES512'
];
const $156503e0affac391$var$RSA_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
const $156503e0affac391$var$HS_ALGS = [
    'HS256',
    'HS384',
    'HS512'
];
if ($jaMrC) {
    $156503e0affac391$var$PUB_KEY_ALGS.splice($156503e0affac391$var$PUB_KEY_ALGS.length, 0, 'PS256', 'PS384', 'PS512');
    $156503e0affac391$var$RSA_KEY_ALGS.splice($156503e0affac391$var$RSA_KEY_ALGS.length, 0, 'PS256', 'PS384', 'PS512');
}
module.exports = function(jwtString, secretOrPublicKey, options, callback) {
    if (typeof options === 'function' && !callback) {
        callback = options;
        options = {};
    }
    if (!options) options = {};
    //clone this object since we are going to mutate it.
    options = Object.assign({}, options);
    let done;
    if (callback) done = callback;
    else done = function(err, data) {
        if (err) throw err;
        return data;
    };
    if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') return done(new $4r9pO('clockTimestamp must be a number'));
    if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) return done(new $4r9pO('nonce must be a non-empty string'));
    if (options.allowInvalidAsymmetricKeyTypes !== undefined && typeof options.allowInvalidAsymmetricKeyTypes !== 'boolean') return done(new $4r9pO('allowInvalidAsymmetricKeyTypes must be a boolean'));
    const clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
    if (!jwtString) return done(new $4r9pO('jwt must be provided'));
    if (typeof jwtString !== 'string') return done(new $4r9pO('jwt must be a string'));
    const parts = jwtString.split('.');
    if (parts.length !== 3) return done(new $4r9pO('jwt malformed'));
    let decodedToken;
    try {
        decodedToken = $7SR5F(jwtString, {
            complete: true
        });
    } catch (err) {
        return done(err);
    }
    if (!decodedToken) return done(new $4r9pO('invalid token'));
    const header = decodedToken.header;
    let getSecret;
    if (typeof secretOrPublicKey === 'function') {
        if (!callback) return done(new $4r9pO('verify must be called asynchronous if secret or public key is provided as a callback'));
        getSecret = secretOrPublicKey;
    } else getSecret = function(header, secretCallback) {
        return secretCallback(null, secretOrPublicKey);
    };
    return getSecret(header, function(err, secretOrPublicKey) {
        if (err) return done(new $4r9pO('error in secret or public key callback: ' + err.message));
        const hasSignature = parts[2].trim() !== '';
        if (!hasSignature && secretOrPublicKey) return done(new $4r9pO('jwt signature is required'));
        if (hasSignature && !secretOrPublicKey) return done(new $4r9pO('secret or public key must be provided'));
        if (!hasSignature && !options.algorithms) return done(new $4r9pO('please specify "none" in "algorithms" to verify unsigned tokens'));
        if (secretOrPublicKey != null && !(secretOrPublicKey instanceof $156503e0affac391$require$KeyObject)) try {
            secretOrPublicKey = $156503e0affac391$require$createPublicKey(secretOrPublicKey);
        } catch (_) {
            try {
                secretOrPublicKey = $156503e0affac391$require$createSecretKey(typeof secretOrPublicKey === 'string' ? $156503e0affac391$require$Buffer.from(secretOrPublicKey) : secretOrPublicKey);
            } catch (_) {
                return done(new $4r9pO('secretOrPublicKey is not valid key material'));
            }
        }
        if (!options.algorithms) {
            if (secretOrPublicKey.type === 'secret') options.algorithms = $156503e0affac391$var$HS_ALGS;
            else if ([
                'rsa',
                'rsa-pss'
            ].includes(secretOrPublicKey.asymmetricKeyType)) options.algorithms = $156503e0affac391$var$RSA_KEY_ALGS;
            else if (secretOrPublicKey.asymmetricKeyType === 'ec') options.algorithms = $156503e0affac391$var$EC_KEY_ALGS;
            else options.algorithms = $156503e0affac391$var$PUB_KEY_ALGS;
        }
        if (options.algorithms.indexOf(decodedToken.header.alg) === -1) return done(new $4r9pO('invalid algorithm'));
        if (header.alg.startsWith('HS') && secretOrPublicKey.type !== 'secret') return done(new $4r9pO(`secretOrPublicKey must be a symmetric key when using ${header.alg}`));
        else if (/^(?:RS|PS|ES)/.test(header.alg) && secretOrPublicKey.type !== 'public') return done(new $4r9pO(`secretOrPublicKey must be an asymmetric key when using ${header.alg}`));
        if (!options.allowInvalidAsymmetricKeyTypes) try {
            $1RGDU(header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        let valid;
        try {
            valid = $4QOjN.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        if (!valid) return done(new $4r9pO('invalid signature'));
        const payload = decodedToken.payload;
        if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
            if (typeof payload.nbf !== 'number') return done(new $4r9pO('invalid nbf value'));
            if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) return done(new $fUN9R('jwt not active', new Date(payload.nbf * 1000)));
        }
        if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
            if (typeof payload.exp !== 'number') return done(new $4r9pO('invalid exp value'));
            if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) return done(new $agX5Y('jwt expired', new Date(payload.exp * 1000)));
        }
        if (options.audience) {
            const audiences = Array.isArray(options.audience) ? options.audience : [
                options.audience
            ];
            const target = Array.isArray(payload.aud) ? payload.aud : [
                payload.aud
            ];
            const match = target.some(function(targetAudience) {
                return audiences.some(function(audience) {
                    return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
                });
            });
            if (!match) return done(new $4r9pO('jwt audience invalid. expected: ' + audiences.join(' or ')));
        }
        if (options.issuer) {
            const invalid_issuer = typeof options.issuer === 'string' && payload.iss !== options.issuer || Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1;
            if (invalid_issuer) return done(new $4r9pO('jwt issuer invalid. expected: ' + options.issuer));
        }
        if (options.subject) {
            if (payload.sub !== options.subject) return done(new $4r9pO('jwt subject invalid. expected: ' + options.subject));
        }
        if (options.jwtid) {
            if (payload.jti !== options.jwtid) return done(new $4r9pO('jwt jwtid invalid. expected: ' + options.jwtid));
        }
        if (options.nonce) {
            if (payload.nonce !== options.nonce) return done(new $4r9pO('jwt nonce invalid. expected: ' + options.nonce));
        }
        if (options.maxAge) {
            if (typeof payload.iat !== 'number') return done(new $4r9pO('iat required when maxAge is specified'));
            const maxAgeTimestamp = $bkFw0(options.maxAge, payload.iat);
            if (typeof maxAgeTimestamp === 'undefined') return done(new $4r9pO('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
            if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) return done(new $agX5Y('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
        }
        if (options.complete === true) {
            const signature = decodedToken.signature;
            return done(null, {
                header: header,
                payload: payload,
                signature: signature
            });
        }
        return done(null, payload);
    });
};

});
parcelRegister("4r9pO", function(module, exports) {
var $33b0fcc0293d21a5$var$JsonWebTokenError = function(message, error) {
    Error.call(this, message);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    this.name = 'JsonWebTokenError';
    this.message = message;
    if (error) this.inner = error;
};
$33b0fcc0293d21a5$var$JsonWebTokenError.prototype = Object.create(Error.prototype);
$33b0fcc0293d21a5$var$JsonWebTokenError.prototype.constructor = $33b0fcc0293d21a5$var$JsonWebTokenError;
module.exports = $33b0fcc0293d21a5$var$JsonWebTokenError;

});

parcelRegister("fUN9R", function(module, exports) {

var $4r9pO = parcelRequire("4r9pO");
var $b96237c40ca813ad$var$NotBeforeError = function(message, date) {
    $4r9pO.call(this, message);
    this.name = 'NotBeforeError';
    this.date = date;
};
$b96237c40ca813ad$var$NotBeforeError.prototype = Object.create($4r9pO.prototype);
$b96237c40ca813ad$var$NotBeforeError.prototype.constructor = $b96237c40ca813ad$var$NotBeforeError;
module.exports = $b96237c40ca813ad$var$NotBeforeError;

});

parcelRegister("agX5Y", function(module, exports) {

var $4r9pO = parcelRequire("4r9pO");
var $77a93d1635b1e624$var$TokenExpiredError = function(message, expiredAt) {
    $4r9pO.call(this, message);
    this.name = 'TokenExpiredError';
    this.expiredAt = expiredAt;
};
$77a93d1635b1e624$var$TokenExpiredError.prototype = Object.create($4r9pO.prototype);
$77a93d1635b1e624$var$TokenExpiredError.prototype.constructor = $77a93d1635b1e624$var$TokenExpiredError;
module.exports = $77a93d1635b1e624$var$TokenExpiredError;

});

parcelRegister("bkFw0", function(module, exports) {

var $3pRq5 = parcelRequire("3pRq5");
module.exports = function(time, iat) {
    var timestamp = iat || Math.floor(Date.now() / 1000);
    if (typeof time === 'string') {
        var milliseconds = $3pRq5(time);
        if (typeof milliseconds === 'undefined') return;
        return Math.floor(timestamp + milliseconds / 1000);
    } else if (typeof time === 'number') return timestamp + time;
    else return;
};

});
parcelRegister("3pRq5", function(module, exports) {
/**
 * Helpers.
 */ var $27cd24efd2f930b8$var$s = 1000;
var $27cd24efd2f930b8$var$m = $27cd24efd2f930b8$var$s * 60;
var $27cd24efd2f930b8$var$h = $27cd24efd2f930b8$var$m * 60;
var $27cd24efd2f930b8$var$d = $27cd24efd2f930b8$var$h * 24;
var $27cd24efd2f930b8$var$w = $27cd24efd2f930b8$var$d * 7;
var $27cd24efd2f930b8$var$y = $27cd24efd2f930b8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $27cd24efd2f930b8$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $27cd24efd2f930b8$var$fmtLong(val) : $27cd24efd2f930b8$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $27cd24efd2f930b8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $27cd24efd2f930b8$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $27cd24efd2f930b8$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $27cd24efd2f930b8$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $27cd24efd2f930b8$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $27cd24efd2f930b8$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $27cd24efd2f930b8$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return Math.round(ms / $27cd24efd2f930b8$var$d) + 'd';
    if (msAbs >= $27cd24efd2f930b8$var$h) return Math.round(ms / $27cd24efd2f930b8$var$h) + 'h';
    if (msAbs >= $27cd24efd2f930b8$var$m) return Math.round(ms / $27cd24efd2f930b8$var$m) + 'm';
    if (msAbs >= $27cd24efd2f930b8$var$s) return Math.round(ms / $27cd24efd2f930b8$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$d, 'day');
    if (msAbs >= $27cd24efd2f930b8$var$h) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$h, 'hour');
    if (msAbs >= $27cd24efd2f930b8$var$m) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$m, 'minute');
    if (msAbs >= $27cd24efd2f930b8$var$s) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $27cd24efd2f930b8$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});


parcelRegister("1RGDU", function(module, exports) {

var $kg3aI = parcelRequire("kg3aI");

var $fG6UR = parcelRequire("fG6UR");
const $15bbd1a0f4ef1c9f$var$allowedAlgorithmsForKeys = {
    'ec': [
        'ES256',
        'ES384',
        'ES512'
    ],
    'rsa': [
        'RS256',
        'PS256',
        'RS384',
        'PS384',
        'RS512',
        'PS512'
    ],
    'rsa-pss': [
        'PS256',
        'PS384',
        'PS512'
    ]
};
const $15bbd1a0f4ef1c9f$var$allowedCurves = {
    ES256: 'prime256v1',
    ES384: 'secp384r1',
    ES512: 'secp521r1'
};
module.exports = function(algorithm, key) {
    if (!algorithm || !key) return;
    const keyType = key.asymmetricKeyType;
    if (!keyType) return;
    const allowedAlgorithms = $15bbd1a0f4ef1c9f$var$allowedAlgorithmsForKeys[keyType];
    if (!allowedAlgorithms) throw new Error(`Unknown key type "${keyType}".`);
    if (!allowedAlgorithms.includes(algorithm)) throw new Error(`"alg" parameter for "${keyType}" key type must be one of: ${allowedAlgorithms.join(', ')}.`);
    /*
   * Ignore the next block from test coverage because it gets executed
   * conditionally depending on the Node version. Not ignoring it would
   * prevent us from reaching the target % of coverage for versions of
   * Node under 15.7.0.
   */ /* istanbul ignore next */ if ($kg3aI) switch(keyType){
        case 'ec':
            const keyCurve = key.asymmetricKeyDetails.namedCurve;
            const allowedCurve = $15bbd1a0f4ef1c9f$var$allowedCurves[algorithm];
            if (keyCurve !== allowedCurve) throw new Error(`"alg" parameter "${algorithm}" requires curve "${allowedCurve}".`);
            break;
        case 'rsa-pss':
            if ($fG6UR) {
                const length = parseInt(algorithm.slice(-3), 10);
                const { hashAlgorithm: hashAlgorithm, mgf1HashAlgorithm: mgf1HashAlgorithm, saltLength: saltLength } = key.asymmetricKeyDetails;
                if (hashAlgorithm !== `sha${length}` || mgf1HashAlgorithm !== hashAlgorithm) throw new Error(`Invalid key for this operation, its RSA-PSS parameters do not meet the requirements of "alg" ${algorithm}.`);
                if (saltLength !== undefined && saltLength > length >> 3) throw new Error(`Invalid key for this operation, its RSA-PSS parameter saltLength does not meet the requirements of "alg" ${algorithm}.`);
            }
            break;
    }
};

});
parcelRegister("kg3aI", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $iRB8M = parcelRequire("iRB8M");
module.exports = $iRB8M.satisfies($hPtJY.version, '>=15.7.0');

});
parcelRegister("iRB8M", function(module, exports) {
'use strict';

var $kGRcS = parcelRequire("kGRcS");

var $fJ45P = parcelRequire("fJ45P");

var $jc2hE = parcelRequire("jc2hE");

var $knvD1 = parcelRequire("knvD1");

var $7044y = parcelRequire("7044y");

var $h0sfq = parcelRequire("h0sfq");

var $bJ0RQ = parcelRequire("bJ0RQ");

var $ieYcB = parcelRequire("ieYcB");

var $eGp6O = parcelRequire("eGp6O");

var $5cyvG = parcelRequire("5cyvG");

var $9uxfK = parcelRequire("9uxfK");

var $6xp5n = parcelRequire("6xp5n");

var $cFVW5 = parcelRequire("cFVW5");

var $b7QMB = parcelRequire("b7QMB");

var $6EDzK = parcelRequire("6EDzK");

var $79aP4 = parcelRequire("79aP4");

var $2OL5Q = parcelRequire("2OL5Q");

var $6ku4B = parcelRequire("6ku4B");

var $59O2c = parcelRequire("59O2c");

var $1oAel = parcelRequire("1oAel");

var $lbYuD = parcelRequire("lbYuD");

var $86id8 = parcelRequire("86id8");

var $4oysg = parcelRequire("4oysg");

var $h5qJB = parcelRequire("h5qJB");

var $eFVx2 = parcelRequire("eFVx2");

var $2XmCu = parcelRequire("2XmCu");

var $2Jjdf = parcelRequire("2Jjdf");

var $5fzkR = parcelRequire("5fzkR");

var $4F7Xz = parcelRequire("4F7Xz");

var $5R6Au = parcelRequire("5R6Au");

var $9gGuZ = parcelRequire("9gGuZ");

var $3HMbn = parcelRequire("3HMbn");

var $avwTw = parcelRequire("avwTw");

var $9V0t0 = parcelRequire("9V0t0");

var $1TYcj = parcelRequire("1TYcj");

var $7feqK = parcelRequire("7feqK");

var $9tQ1X = parcelRequire("9tQ1X");

var $17FfA = parcelRequire("17FfA");

var $lTAGj = parcelRequire("lTAGj");

var $9QGcz = parcelRequire("9QGcz");

var $6nO3Y = parcelRequire("6nO3Y");
module.exports = {
    parse: $7044y,
    valid: $h0sfq,
    clean: $bJ0RQ,
    inc: $ieYcB,
    diff: $eGp6O,
    major: $5cyvG,
    minor: $9uxfK,
    patch: $6xp5n,
    prerelease: $cFVW5,
    compare: $b7QMB,
    rcompare: $6EDzK,
    compareLoose: $79aP4,
    compareBuild: $2OL5Q,
    sort: $6ku4B,
    rsort: $59O2c,
    gt: $1oAel,
    lt: $lbYuD,
    eq: $86id8,
    neq: $4oysg,
    gte: $h5qJB,
    lte: $eFVx2,
    cmp: $2XmCu,
    coerce: $2Jjdf,
    Comparator: $5fzkR,
    Range: $4F7Xz,
    satisfies: $5R6Au,
    toComparators: $9gGuZ,
    maxSatisfying: $3HMbn,
    minSatisfying: $avwTw,
    minVersion: $9V0t0,
    validRange: $1TYcj,
    outside: $7feqK,
    gtr: $9tQ1X,
    ltr: $17FfA,
    intersects: $lTAGj,
    simplifyRange: $9QGcz,
    subset: $6nO3Y,
    SemVer: $jc2hE,
    re: $kGRcS.re,
    src: $kGRcS.src,
    tokens: $kGRcS.t,
    SEMVER_SPEC_VERSION: $fJ45P.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $fJ45P.RELEASE_TYPES,
    compareIdentifiers: $knvD1.compareIdentifiers,
    rcompareIdentifiers: $knvD1.rcompareIdentifiers
};

});
parcelRegister("kGRcS", function(module, exports) {
'use strict';

var $fJ45P = parcelRequire("fJ45P");
var $f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH = $fJ45P.MAX_SAFE_COMPONENT_LENGTH;
var $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH = $fJ45P.MAX_SAFE_BUILD_LENGTH;
var $f101009ed9c0563c$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;

var $i9RZm = parcelRequire("i9RZm");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const safeSrc = exports.safeSrc = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        $f101009ed9c0563c$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $i9RZm(name, index, value);
    t[name] = index;
    src[index] = value;
    safeSrc[index] = safe;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
// Non-numberic identifiers include numberic identifiers but can be longer.
// Therefore non-numberic identifiers must go first.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
createToken('COERCERTLFULL', src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

});
parcelRegister("fJ45P", function(module, exports) {
'use strict';
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION = '2.0.0';
const $b72e3bc5fa8d2c21$var$MAX_LENGTH = 256;
const $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH = $b72e3bc5fa8d2c21$var$MAX_LENGTH - 6;
const $b72e3bc5fa8d2c21$var$RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH: $b72e3bc5fa8d2c21$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $b72e3bc5fa8d2c21$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("i9RZm", function(module, exports) {
'use strict';
const $d382f2433df5837c$var$debug = ()=>{};
module.exports = $d382f2433df5837c$var$debug;

});


parcelRegister("jc2hE", function(module, exports) {
'use strict';

var $i9RZm = parcelRequire("i9RZm");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;
var $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER = $fJ45P.MAX_SAFE_INTEGER;

var $kGRcS = parcelRequire("kGRcS");
var $df90e8d1cf1cf055$require$re = $kGRcS.safeRe;
var $df90e8d1cf1cf055$require$t = $kGRcS.t;

var $1nuyy = parcelRequire("1nuyy");

var $knvD1 = parcelRequire("knvD1");
var $df90e8d1cf1cf055$require$compareIdentifiers = $knvD1.compareIdentifiers;
class $df90e8d1cf1cf055$var$SemVer {
    constructor(version, options){
        options = $1nuyy(options);
        if (version instanceof $df90e8d1cf1cf055$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $df90e8d1cf1cf055$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$df90e8d1cf1cf055$require$MAX_LENGTH} characters`);
        $i9RZm('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.LOOSE] : $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $i9RZm('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        return $df90e8d1cf1cf055$require$compareIdentifiers(this.major, other.major) || $df90e8d1cf1cf055$require$compareIdentifiers(this.minor, other.minor) || $df90e8d1cf1cf055$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $i9RZm('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $i9RZm('build compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        if (release.startsWith('pre')) {
            if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
            // Avoid an invalid semver results
            if (identifier) {
                const match = `-${identifier}`.match(this.options.loose ? $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.PRERELEASELOOSE] : $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.PRERELEASE]);
                if (!match || match[1] !== identifier) throw new Error(`invalid identifier: ${identifier}`);
            }
        }
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'release':
                if (this.prerelease.length === 0) throw new Error(`version ${this.raw} is not a prerelease`);
                this.prerelease.length = 0;
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($df90e8d1cf1cf055$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
module.exports = $df90e8d1cf1cf055$var$SemVer;

});
parcelRegister("1nuyy", function(module, exports) {
'use strict';
// parse out just the options we care about
const $100fa442ed30ac34$var$looseOption = Object.freeze({
    loose: true
});
const $100fa442ed30ac34$var$emptyOpts = Object.freeze({});
const $100fa442ed30ac34$var$parseOptions = (options)=>{
    if (!options) return $100fa442ed30ac34$var$emptyOpts;
    if (typeof options !== 'object') return $100fa442ed30ac34$var$looseOption;
    return options;
};
module.exports = $100fa442ed30ac34$var$parseOptions;

});

parcelRegister("knvD1", function(module, exports) {
'use strict';
const $ed5e7d6476f836e9$var$numeric = /^[0-9]+$/;
const $ed5e7d6476f836e9$var$compareIdentifiers = (a, b)=>{
    const anum = $ed5e7d6476f836e9$var$numeric.test(a);
    const bnum = $ed5e7d6476f836e9$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $ed5e7d6476f836e9$var$rcompareIdentifiers = (a, b)=>$ed5e7d6476f836e9$var$compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers: $ed5e7d6476f836e9$var$compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$var$rcompareIdentifiers
};

});


parcelRegister("7044y", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");
const $518bb137cbdf72c3$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $jc2hE) return version;
    try {
        return new $jc2hE(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = $518bb137cbdf72c3$var$parse;

});

parcelRegister("h0sfq", function(module, exports) {
'use strict';

var $7044y = parcelRequire("7044y");
const $c618592c32f826bd$var$valid = (version, options)=>{
    const v = $7044y(version, options);
    return v ? v.version : null;
};
module.exports = $c618592c32f826bd$var$valid;

});

parcelRegister("bJ0RQ", function(module, exports) {
'use strict';

var $7044y = parcelRequire("7044y");
const $889491f0ea5a6118$var$clean = (version, options)=>{
    const s = $7044y(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
module.exports = $889491f0ea5a6118$var$clean;

});

parcelRegister("ieYcB", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");
const $d4783bb52460fa90$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $jc2hE(version instanceof $jc2hE ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = $d4783bb52460fa90$var$inc;

});

parcelRegister("eGp6O", function(module, exports) {
'use strict';

var $7044y = parcelRequire("7044y");
const $ab0877022a91d748$var$diff = (version1, version2)=>{
    const v1 = $7044y(version1, null, true);
    const v2 = $7044y(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // If the main part has no difference
        if (lowVersion.compareMain(highVersion) === 0) {
            if (lowVersion.minor && !lowVersion.patch) return 'minor';
            return 'patch';
        }
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are preleases
    return 'prerelease';
};
module.exports = $ab0877022a91d748$var$diff;

});

parcelRegister("5cyvG", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");
const $3c98d7b64d202a78$var$major = (a, loose)=>new $jc2hE(a, loose).major;
module.exports = $3c98d7b64d202a78$var$major;

});

parcelRegister("9uxfK", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");
const $6e90b5c2fe90feeb$var$minor = (a, loose)=>new $jc2hE(a, loose).minor;
module.exports = $6e90b5c2fe90feeb$var$minor;

});

parcelRegister("6xp5n", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");
const $4c2948a32081632b$var$patch = (a, loose)=>new $jc2hE(a, loose).patch;
module.exports = $4c2948a32081632b$var$patch;

});

parcelRegister("cFVW5", function(module, exports) {
'use strict';

var $7044y = parcelRequire("7044y");
const $93a6413aa1f64654$var$prerelease = (version, options)=>{
    const parsed = $7044y(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = $93a6413aa1f64654$var$prerelease;

});

parcelRegister("b7QMB", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");
const $81994ac4c012d104$var$compare = (a, b, loose)=>new $jc2hE(a, loose).compare(new $jc2hE(b, loose));
module.exports = $81994ac4c012d104$var$compare;

});

parcelRegister("6EDzK", function(module, exports) {
'use strict';

var $b7QMB = parcelRequire("b7QMB");
const $4d852d6325ac3f0a$var$rcompare = (a, b, loose)=>$b7QMB(b, a, loose);
module.exports = $4d852d6325ac3f0a$var$rcompare;

});

parcelRegister("79aP4", function(module, exports) {
'use strict';

var $b7QMB = parcelRequire("b7QMB");
const $5341c4d7c3ddc057$var$compareLoose = (a, b)=>$b7QMB(a, b, true);
module.exports = $5341c4d7c3ddc057$var$compareLoose;

});

parcelRegister("2OL5Q", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");
const $20d4c8016361ffad$var$compareBuild = (a, b, loose)=>{
    const versionA = new $jc2hE(a, loose);
    const versionB = new $jc2hE(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = $20d4c8016361ffad$var$compareBuild;

});

parcelRegister("6ku4B", function(module, exports) {
'use strict';

var $2OL5Q = parcelRequire("2OL5Q");
const $49bbf04266a7f106$var$sort = (list, loose)=>list.sort((a, b)=>$2OL5Q(a, b, loose));
module.exports = $49bbf04266a7f106$var$sort;

});

parcelRegister("59O2c", function(module, exports) {
'use strict';

var $2OL5Q = parcelRequire("2OL5Q");
const $3c149acde0254244$var$rsort = (list, loose)=>list.sort((a, b)=>$2OL5Q(b, a, loose));
module.exports = $3c149acde0254244$var$rsort;

});

parcelRegister("1oAel", function(module, exports) {
'use strict';

var $b7QMB = parcelRequire("b7QMB");
const $104422eefe356e5b$var$gt = (a, b, loose)=>$b7QMB(a, b, loose) > 0;
module.exports = $104422eefe356e5b$var$gt;

});

parcelRegister("lbYuD", function(module, exports) {
'use strict';

var $b7QMB = parcelRequire("b7QMB");
const $f6d98cb923c33015$var$lt = (a, b, loose)=>$b7QMB(a, b, loose) < 0;
module.exports = $f6d98cb923c33015$var$lt;

});

parcelRegister("86id8", function(module, exports) {
'use strict';

var $b7QMB = parcelRequire("b7QMB");
const $5e5d028df14dc03a$var$eq = (a, b, loose)=>$b7QMB(a, b, loose) === 0;
module.exports = $5e5d028df14dc03a$var$eq;

});

parcelRegister("4oysg", function(module, exports) {
'use strict';

var $b7QMB = parcelRequire("b7QMB");
const $3334214f1b360179$var$neq = (a, b, loose)=>$b7QMB(a, b, loose) !== 0;
module.exports = $3334214f1b360179$var$neq;

});

parcelRegister("h5qJB", function(module, exports) {
'use strict';

var $b7QMB = parcelRequire("b7QMB");
const $c707a43d6c3b801a$var$gte = (a, b, loose)=>$b7QMB(a, b, loose) >= 0;
module.exports = $c707a43d6c3b801a$var$gte;

});

parcelRegister("eFVx2", function(module, exports) {
'use strict';

var $b7QMB = parcelRequire("b7QMB");
const $aaf185a79a690d76$var$lte = (a, b, loose)=>$b7QMB(a, b, loose) <= 0;
module.exports = $aaf185a79a690d76$var$lte;

});

parcelRegister("2XmCu", function(module, exports) {
'use strict';

var $86id8 = parcelRequire("86id8");

var $4oysg = parcelRequire("4oysg");

var $1oAel = parcelRequire("1oAel");

var $h5qJB = parcelRequire("h5qJB");

var $lbYuD = parcelRequire("lbYuD");

var $eFVx2 = parcelRequire("eFVx2");
const $2272a34159523aa5$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return $86id8(a, b, loose);
        case '!=':
            return $4oysg(a, b, loose);
        case '>':
            return $1oAel(a, b, loose);
        case '>=':
            return $h5qJB(a, b, loose);
        case '<':
            return $lbYuD(a, b, loose);
        case '<=':
            return $eFVx2(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = $2272a34159523aa5$var$cmp;

});

parcelRegister("2Jjdf", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");

var $7044y = parcelRequire("7044y");

var $kGRcS = parcelRequire("kGRcS");
var $1fceaff8ff23f299$require$re = $kGRcS.safeRe;
var $1fceaff8ff23f299$require$t = $kGRcS.t;
const $1fceaff8ff23f299$var$coerce = (version, options)=>{
    if (version instanceof $jc2hE) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCEFULL] : $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTLFULL] : $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || '0';
    const patch = match[4] || '0';
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : '';
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : '';
    return $7044y(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
module.exports = $1fceaff8ff23f299$var$coerce;

});

parcelRegister("5fzkR", function(module, exports) {
'use strict';
const $3d29c357640e9d06$var$ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class $3d29c357640e9d06$var$Comparator {
    static get ANY() {
        return $3d29c357640e9d06$var$ANY;
    }
    constructor(comp, options){
        options = $1nuyy(options);
        if (comp instanceof $3d29c357640e9d06$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        $i9RZm('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $3d29c357640e9d06$var$ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        $i9RZm('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATORLOOSE] : $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $3d29c357640e9d06$var$ANY;
        else this.semver = new $jc2hE(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $i9RZm('Comparator.test', version, this.options.loose);
        if (this.semver === $3d29c357640e9d06$var$ANY || version === $3d29c357640e9d06$var$ANY) return true;
        if (typeof version === 'string') try {
            version = new $jc2hE(version, this.options);
        } catch (er) {
            return false;
        }
        return $2XmCu(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $3d29c357640e9d06$var$Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new $4F7Xz(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new $4F7Xz(this.value, options).test(comp.semver);
        }
        options = $1nuyy(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if ($2XmCu(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if ($2XmCu(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
module.exports = $3d29c357640e9d06$var$Comparator;

var $1nuyy = parcelRequire("1nuyy");

var $kGRcS = parcelRequire("kGRcS");
var $3d29c357640e9d06$require$re = $kGRcS.safeRe;
var $3d29c357640e9d06$require$t = $kGRcS.t;

var $2XmCu = parcelRequire("2XmCu");

var $i9RZm = parcelRequire("i9RZm");

var $jc2hE = parcelRequire("jc2hE");

var $4F7Xz = parcelRequire("4F7Xz");

});
parcelRegister("4F7Xz", function(module, exports) {
'use strict';
const $36512a6be0346a51$var$SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class $36512a6be0346a51$var$Range {
    constructor(range, options){
        options = $1nuyy(options);
        if (range instanceof $36512a6be0346a51$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $36512a6be0346a51$var$Range(range.raw, options);
        }
        if (range instanceof $5fzkR) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace($36512a6be0346a51$var$SPACE_CHARACTERS, ' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$36512a6be0346a51$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $36512a6be0346a51$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = '';
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += '||';
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += ' ';
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $36512a6be0346a51$require$FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = $36512a6be0346a51$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGE];
        range = range.replace(hr, $36512a6be0346a51$var$hyphenReplace(this.options.includePrerelease));
        $i9RZm('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORTRIM], $36512a6be0346a51$require$comparatorTrimReplace);
        $i9RZm('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDETRIM], $36512a6be0346a51$require$tildeTrimReplace);
        $i9RZm('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETTRIM], $36512a6be0346a51$require$caretTrimReplace);
        $i9RZm('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>$36512a6be0346a51$var$parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$36512a6be0346a51$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $i9RZm('loose invalid filter', comp, this.options);
            return !!comp.match($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORLOOSE]);
        });
        $i9RZm('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $5fzkR(comp, this.options));
        for (const comp of comparators){
            if ($36512a6be0346a51$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        $36512a6be0346a51$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $36512a6be0346a51$var$Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return $36512a6be0346a51$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $36512a6be0346a51$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new $jc2hE(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($36512a6be0346a51$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = $36512a6be0346a51$var$Range;

var $8dQzv = parcelRequire("8dQzv");
const $36512a6be0346a51$var$cache = new $8dQzv();

var $1nuyy = parcelRequire("1nuyy");

var $5fzkR = parcelRequire("5fzkR");

var $i9RZm = parcelRequire("i9RZm");

var $jc2hE = parcelRequire("jc2hE");

var $kGRcS = parcelRequire("kGRcS");
var $36512a6be0346a51$require$re = $kGRcS.safeRe;
var $36512a6be0346a51$require$t = $kGRcS.t;
var $36512a6be0346a51$require$comparatorTrimReplace = $kGRcS.comparatorTrimReplace;
var $36512a6be0346a51$require$tildeTrimReplace = $kGRcS.tildeTrimReplace;
var $36512a6be0346a51$require$caretTrimReplace = $kGRcS.caretTrimReplace;

var $fJ45P = parcelRequire("fJ45P");
var $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE = $fJ45P.FLAG_INCLUDE_PRERELEASE;
var $36512a6be0346a51$require$FLAG_LOOSE = $fJ45P.FLAG_LOOSE;
const $36512a6be0346a51$var$isNullSet = (c)=>c.value === '<0.0.0-0';
const $36512a6be0346a51$var$isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $36512a6be0346a51$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $36512a6be0346a51$var$parseComparator = (comp, options)=>{
    $i9RZm('comp', comp, options);
    comp = $36512a6be0346a51$var$replaceCarets(comp, options);
    $i9RZm('caret', comp);
    comp = $36512a6be0346a51$var$replaceTildes(comp, options);
    $i9RZm('tildes', comp);
    comp = $36512a6be0346a51$var$replaceXRanges(comp, options);
    $i9RZm('xrange', comp);
    comp = $36512a6be0346a51$var$replaceStars(comp, options);
    $i9RZm('stars', comp);
    return comp;
};
const $36512a6be0346a51$var$isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $36512a6be0346a51$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceTilde(c, options)).join(' ');
};
const $36512a6be0346a51$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm('tilde', comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = '';
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $i9RZm('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $i9RZm('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $36512a6be0346a51$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceCaret(c, options)).join(' ');
};
const $36512a6be0346a51$var$replaceCaret = (comp, options)=>{
    $i9RZm('caret', comp, options);
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETLOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm('caret', comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = '';
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $i9RZm('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $i9RZm('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $i9RZm('caret return', ret);
        return ret;
    });
};
const $36512a6be0346a51$var$replaceXRanges = (comp, options)=>{
    $i9RZm('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceXRange(c, options)).join(' ');
};
const $36512a6be0346a51$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $i9RZm('xRange', comp, ret, gtlt, M, m, p, pr);
        const xM = $36512a6be0346a51$var$isX(M);
        const xm = xM || $36512a6be0346a51$var$isX(m);
        const xp = xm || $36512a6be0346a51$var$isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $i9RZm('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $36512a6be0346a51$var$replaceStars = (comp, options)=>{
    $i9RZm('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.STAR], '');
};
const $36512a6be0346a51$var$replaceGTE0 = (comp, options)=>{
    $i9RZm('replaceGTE0', comp, options);
    return comp.trim().replace($36512a6be0346a51$require$re[options.includePrerelease ? $36512a6be0346a51$require$t.GTE0PRE : $36512a6be0346a51$require$t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const $36512a6be0346a51$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if ($36512a6be0346a51$var$isX(fM)) from = '';
        else if ($36512a6be0346a51$var$isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if ($36512a6be0346a51$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if ($36512a6be0346a51$var$isX(tM)) to = '';
        else if ($36512a6be0346a51$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $36512a6be0346a51$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $i9RZm(set[i].semver);
            if (set[i].semver === $5fzkR.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

});
parcelRegister("8dQzv", function(module, exports) {
'use strict';
class $5fc8514051072a37$var$LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
module.exports = $5fc8514051072a37$var$LRUCache;

});



parcelRegister("5R6Au", function(module, exports) {
'use strict';

var $4F7Xz = parcelRequire("4F7Xz");
const $44370327d4e393bf$var$satisfies = (version, range, options)=>{
    try {
        range = new $4F7Xz(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = $44370327d4e393bf$var$satisfies;

});

parcelRegister("9gGuZ", function(module, exports) {
'use strict';

var $4F7Xz = parcelRequire("4F7Xz");
// Mostly just for testing and legacy API reasons
const $6bf6930ad20f8979$var$toComparators = (range, options)=>new $4F7Xz(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
module.exports = $6bf6930ad20f8979$var$toComparators;

});

parcelRegister("3HMbn", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");

var $4F7Xz = parcelRequire("4F7Xz");
const $2b2ac348dee0803e$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $4F7Xz(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $jc2hE(max, options);
            }
        }
    });
    return max;
};
module.exports = $2b2ac348dee0803e$var$maxSatisfying;

});

parcelRegister("avwTw", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");

var $4F7Xz = parcelRequire("4F7Xz");
const $7a6650c8d62ec668$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $4F7Xz(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $jc2hE(min, options);
            }
        }
    });
    return min;
};
module.exports = $7a6650c8d62ec668$var$minSatisfying;

});

parcelRegister("9V0t0", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");

var $4F7Xz = parcelRequire("4F7Xz");

var $1oAel = parcelRequire("1oAel");
const $7389cc9c1db09b0d$var$minVersion = (range, loose)=>{
    range = new $4F7Xz(range, loose);
    let minver = new $jc2hE('0.0.0');
    if (range.test(minver)) return minver;
    minver = new $jc2hE('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $jc2hE(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || $1oAel(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $1oAel(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = $7389cc9c1db09b0d$var$minVersion;

});

parcelRegister("1TYcj", function(module, exports) {
'use strict';

var $4F7Xz = parcelRequire("4F7Xz");
const $16299f7793385cf3$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $4F7Xz(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
module.exports = $16299f7793385cf3$var$validRange;

});

parcelRegister("7feqK", function(module, exports) {
'use strict';

var $jc2hE = parcelRequire("jc2hE");

var $5fzkR = parcelRequire("5fzkR");
const { ANY: $546520af951b9b5a$var$ANY } = $5fzkR;

var $4F7Xz = parcelRequire("4F7Xz");

var $5R6Au = parcelRequire("5R6Au");

var $1oAel = parcelRequire("1oAel");

var $lbYuD = parcelRequire("lbYuD");

var $eFVx2 = parcelRequire("eFVx2");

var $h5qJB = parcelRequire("h5qJB");
const $546520af951b9b5a$var$outside = (version, range, hilo, options)=>{
    version = new $jc2hE(version, options);
    range = new $4F7Xz(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = $1oAel;
            ltefn = $eFVx2;
            ltfn = $lbYuD;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = $lbYuD;
            ltefn = $h5qJB;
            ltfn = $1oAel;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($5R6Au(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $546520af951b9b5a$var$ANY) comparator = new $5fzkR('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = $546520af951b9b5a$var$outside;

});

parcelRegister("9tQ1X", function(module, exports) {
'use strict';

var $7feqK = parcelRequire("7feqK");
const $6e6f2ea8eb78962a$var$gtr = (version, range, options)=>$7feqK(version, range, '>', options);
module.exports = $6e6f2ea8eb78962a$var$gtr;

});

parcelRegister("17FfA", function(module, exports) {
'use strict';

var $7feqK = parcelRequire("7feqK");
// Determine if version is less than all the versions possible in the range
const $0d167156795b8123$var$ltr = (version, range, options)=>$7feqK(version, range, '<', options);
module.exports = $0d167156795b8123$var$ltr;

});

parcelRegister("lTAGj", function(module, exports) {
'use strict';

var $4F7Xz = parcelRequire("4F7Xz");
const $ff0b302dd979be82$var$intersects = (r1, r2, options)=>{
    r1 = new $4F7Xz(r1, options);
    r2 = new $4F7Xz(r2, options);
    return r1.intersects(r2, options);
};
module.exports = $ff0b302dd979be82$var$intersects;

});

parcelRegister("9QGcz", function(module, exports) {
'use strict';

var $5R6Au = parcelRequire("5R6Au");

var $b7QMB = parcelRequire("b7QMB");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$b7QMB(a, b, options));
    for (const version of v){
        const included = $5R6Au(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

});

parcelRegister("6nO3Y", function(module, exports) {
'use strict';

var $4F7Xz = parcelRequire("4F7Xz");

var $5fzkR = parcelRequire("5fzkR");
const { ANY: $4a5bb988105271bd$var$ANY } = $5fzkR;

var $5R6Au = parcelRequire("5R6Au");

var $b7QMB = parcelRequire("b7QMB");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $4a5bb988105271bd$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $4F7Xz(sub, options);
    dom = new $4F7Xz(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $4a5bb988105271bd$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $4a5bb988105271bd$var$minimumVersionWithPreRelease = [
    new $5fzkR('>=0.0.0-0')
];
const $4a5bb988105271bd$var$minimumVersion = [
    new $5fzkR('>=0.0.0')
];
const $4a5bb988105271bd$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $4a5bb988105271bd$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) return true;
        else if (options.includePrerelease) sub = $4a5bb988105271bd$var$minimumVersionWithPreRelease;
        else sub = $4a5bb988105271bd$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $4a5bb988105271bd$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = $4a5bb988105271bd$var$higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = $4a5bb988105271bd$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $b7QMB(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$5R6Au(eq, String(gt), options)) return null;
        if (lt && !$5R6Au(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$5R6Au(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = $4a5bb988105271bd$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !$5R6Au(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = $4a5bb988105271bd$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !$5R6Au(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $4a5bb988105271bd$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $b7QMB(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $4a5bb988105271bd$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $b7QMB(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
module.exports = $4a5bb988105271bd$var$subset;

});



parcelRegister("fG6UR", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $iRB8M = parcelRequire("iRB8M");
module.exports = $iRB8M.satisfies($hPtJY.version, '>=16.9.0');

});


parcelRegister("jaMrC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $iRB8M = parcelRequire("iRB8M");
module.exports = $iRB8M.satisfies($hPtJY.version, '^6.12.0 || >=8.0.0');

});


parcelRegister("8fWg9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $602cea95edb240cd$require$Buffer = $6ZWSX.Buffer;

var $bkFw0 = parcelRequire("bkFw0");

var $jaMrC = parcelRequire("jaMrC");

var $1RGDU = parcelRequire("1RGDU");

var $4QOjN = parcelRequire("4QOjN");

var $i96bT = parcelRequire("i96bT");

var $a0Xiz = parcelRequire("a0Xiz");

var $8fuXr = parcelRequire("8fuXr");

var $hzFRX = parcelRequire("hzFRX");

var $1hRv1 = parcelRequire("1hRv1");

var $eyfSd = parcelRequire("eyfSd");

var $eHmQe = parcelRequire("eHmQe");

var $5UUfm = parcelRequire("5UUfm");
var $602cea95edb240cd$require$KeyObject = $5UUfm.KeyObject;
var $602cea95edb240cd$require$createSecretKey = $5UUfm.createSecretKey;
var $602cea95edb240cd$require$createPrivateKey = $5UUfm.createPrivateKey;
const $602cea95edb240cd$var$SUPPORTED_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512',
    'HS256',
    'HS384',
    'HS512',
    'none'
];
if ($jaMrC) $602cea95edb240cd$var$SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
const $602cea95edb240cd$var$sign_options_schema = {
    expiresIn: {
        isValid: function(value) {
            return $8fuXr(value) || $eyfSd(value) && value;
        },
        message: '"expiresIn" should be a number of seconds or string representing a timespan'
    },
    notBefore: {
        isValid: function(value) {
            return $8fuXr(value) || $eyfSd(value) && value;
        },
        message: '"notBefore" should be a number of seconds or string representing a timespan'
    },
    audience: {
        isValid: function(value) {
            return $eyfSd(value) || Array.isArray(value);
        },
        message: '"audience" must be a string or array'
    },
    algorithm: {
        isValid: $i96bT.bind(null, $602cea95edb240cd$var$SUPPORTED_ALGS),
        message: '"algorithm" must be a valid string enum value'
    },
    header: {
        isValid: $1hRv1,
        message: '"header" must be an object'
    },
    encoding: {
        isValid: $eyfSd,
        message: '"encoding" must be a string'
    },
    issuer: {
        isValid: $eyfSd,
        message: '"issuer" must be a string'
    },
    subject: {
        isValid: $eyfSd,
        message: '"subject" must be a string'
    },
    jwtid: {
        isValid: $eyfSd,
        message: '"jwtid" must be a string'
    },
    noTimestamp: {
        isValid: $a0Xiz,
        message: '"noTimestamp" must be a boolean'
    },
    keyid: {
        isValid: $eyfSd,
        message: '"keyid" must be a string'
    },
    mutatePayload: {
        isValid: $a0Xiz,
        message: '"mutatePayload" must be a boolean'
    },
    allowInsecureKeySizes: {
        isValid: $a0Xiz,
        message: '"allowInsecureKeySizes" must be a boolean'
    },
    allowInvalidAsymmetricKeyTypes: {
        isValid: $a0Xiz,
        message: '"allowInvalidAsymmetricKeyTypes" must be a boolean'
    }
};
const $602cea95edb240cd$var$registered_claims_schema = {
    iat: {
        isValid: $hzFRX,
        message: '"iat" should be a number of seconds'
    },
    exp: {
        isValid: $hzFRX,
        message: '"exp" should be a number of seconds'
    },
    nbf: {
        isValid: $hzFRX,
        message: '"nbf" should be a number of seconds'
    }
};
function $602cea95edb240cd$var$validate(schema, allowUnknown, object, parameterName) {
    if (!$1hRv1(object)) throw new Error('Expected "' + parameterName + '" to be a plain object.');
    Object.keys(object).forEach(function(key) {
        const validator = schema[key];
        if (!validator) {
            if (!allowUnknown) throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
            return;
        }
        if (!validator.isValid(object[key])) throw new Error(validator.message);
    });
}
function $602cea95edb240cd$var$validateOptions(options) {
    return $602cea95edb240cd$var$validate($602cea95edb240cd$var$sign_options_schema, false, options, 'options');
}
function $602cea95edb240cd$var$validatePayload(payload) {
    return $602cea95edb240cd$var$validate($602cea95edb240cd$var$registered_claims_schema, true, payload, 'payload');
}
const $602cea95edb240cd$var$options_to_payload = {
    'audience': 'aud',
    'issuer': 'iss',
    'subject': 'sub',
    'jwtid': 'jti'
};
const $602cea95edb240cd$var$options_for_objects = [
    'expiresIn',
    'notBefore',
    'noTimestamp',
    'audience',
    'issuer',
    'subject',
    'jwtid'
];
module.exports = function(payload, secretOrPrivateKey, options, callback) {
    if (typeof options === 'function') {
        callback = options;
        options = {};
    } else options = options || {};
    const isObjectPayload = typeof payload === 'object' && !$602cea95edb240cd$require$Buffer.isBuffer(payload);
    const header = Object.assign({
        alg: options.algorithm || 'HS256',
        typ: isObjectPayload ? 'JWT' : undefined,
        kid: options.keyid
    }, options.header);
    function failure(err) {
        if (callback) return callback(err);
        throw err;
    }
    if (!secretOrPrivateKey && options.algorithm !== 'none') return failure(new Error('secretOrPrivateKey must have a value'));
    if (secretOrPrivateKey != null && !(secretOrPrivateKey instanceof $602cea95edb240cd$require$KeyObject)) try {
        secretOrPrivateKey = $602cea95edb240cd$require$createPrivateKey(secretOrPrivateKey);
    } catch (_) {
        try {
            secretOrPrivateKey = $602cea95edb240cd$require$createSecretKey(typeof secretOrPrivateKey === 'string' ? $602cea95edb240cd$require$Buffer.from(secretOrPrivateKey) : secretOrPrivateKey);
        } catch (_) {
            return failure(new Error('secretOrPrivateKey is not valid key material'));
        }
    }
    if (header.alg.startsWith('HS') && secretOrPrivateKey.type !== 'secret') return failure(new Error(`secretOrPrivateKey must be a symmetric key when using ${header.alg}`));
    else if (/^(?:RS|PS|ES)/.test(header.alg)) {
        if (secretOrPrivateKey.type !== 'private') return failure(new Error(`secretOrPrivateKey must be an asymmetric key when using ${header.alg}`));
        if (!options.allowInsecureKeySizes && !header.alg.startsWith('ES') && secretOrPrivateKey.asymmetricKeyDetails !== undefined && //KeyObject.asymmetricKeyDetails is supported in Node 15+
        secretOrPrivateKey.asymmetricKeyDetails.modulusLength < 2048) return failure(new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`));
    }
    if (typeof payload === 'undefined') return failure(new Error('payload is required'));
    else if (isObjectPayload) {
        try {
            $602cea95edb240cd$var$validatePayload(payload);
        } catch (error) {
            return failure(error);
        }
        if (!options.mutatePayload) payload = Object.assign({}, payload);
    } else {
        const invalid_options = $602cea95edb240cd$var$options_for_objects.filter(function(opt) {
            return typeof options[opt] !== 'undefined';
        });
        if (invalid_options.length > 0) return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + typeof payload + ' payload'));
    }
    if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
    if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
    try {
        $602cea95edb240cd$var$validateOptions(options);
    } catch (error) {
        return failure(error);
    }
    if (!options.allowInvalidAsymmetricKeyTypes) try {
        $1RGDU(header.alg, secretOrPrivateKey);
    } catch (error) {
        return failure(error);
    }
    const timestamp = payload.iat || Math.floor(Date.now() / 1000);
    if (options.noTimestamp) delete payload.iat;
    else if (isObjectPayload) payload.iat = timestamp;
    if (typeof options.notBefore !== 'undefined') {
        try {
            payload.nbf = $bkFw0(options.notBefore, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.nbf === 'undefined') return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
        try {
            payload.exp = $bkFw0(options.expiresIn, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.exp === 'undefined') return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    Object.keys($602cea95edb240cd$var$options_to_payload).forEach(function(key) {
        const claim = $602cea95edb240cd$var$options_to_payload[key];
        if (typeof options[key] !== 'undefined') {
            if (typeof payload[claim] !== 'undefined') return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
            payload[claim] = options[key];
        }
    });
    const encoding = options.encoding || 'utf8';
    if (typeof callback === 'function') {
        callback = callback && $eHmQe(callback);
        $4QOjN.createSign({
            header: header,
            privateKey: secretOrPrivateKey,
            payload: payload,
            encoding: encoding
        }).once('error', callback).once('done', function(signature) {
            // TODO: Remove in favor of the modulus length check before signing once node 15+ is the minimum supported version
            if (!options.allowInsecureKeySizes && /^(?:RS|PS)/.test(header.alg) && signature.length < 256) return callback(new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`));
            callback(null, signature);
        });
    } else {
        let signature = $4QOjN.sign({
            header: header,
            payload: payload,
            secret: secretOrPrivateKey,
            encoding: encoding
        });
        // TODO: Remove in favor of the modulus length check before signing once node 15+ is the minimum supported version
        if (!options.allowInsecureKeySizes && /^(?:RS|PS)/.test(header.alg) && signature.length < 256) throw new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`);
        return signature;
    }
};

});
parcelRegister("i96bT", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $d35ddea255759560$var$INFINITY = 1 / 0, $d35ddea255759560$var$MAX_SAFE_INTEGER = 9007199254740991, $d35ddea255759560$var$MAX_INTEGER = 1.7976931348623157e+308, $d35ddea255759560$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $d35ddea255759560$var$argsTag = '[object Arguments]', $d35ddea255759560$var$funcTag = '[object Function]', $d35ddea255759560$var$genTag = '[object GeneratorFunction]', $d35ddea255759560$var$stringTag = '[object String]', $d35ddea255759560$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $d35ddea255759560$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $d35ddea255759560$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $d35ddea255759560$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $d35ddea255759560$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $d35ddea255759560$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $d35ddea255759560$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d35ddea255759560$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d35ddea255759560$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d35ddea255759560$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $d35ddea255759560$var$baseFindIndex(array, $d35ddea255759560$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $d35ddea255759560$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $d35ddea255759560$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $d35ddea255759560$var$baseValues(object, props) {
    return $d35ddea255759560$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $d35ddea255759560$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $d35ddea255759560$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d35ddea255759560$var$hasOwnProperty = $d35ddea255759560$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d35ddea255759560$var$objectToString = $d35ddea255759560$var$objectProto.toString;
/** Built-in value references. */ var $d35ddea255759560$var$propertyIsEnumerable = $d35ddea255759560$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d35ddea255759560$var$nativeKeys = $d35ddea255759560$var$overArg(Object.keys, Object), $d35ddea255759560$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $d35ddea255759560$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $d35ddea255759560$var$isArray(value) || $d35ddea255759560$var$isArguments(value) ? $d35ddea255759560$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $d35ddea255759560$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $d35ddea255759560$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d35ddea255759560$var$baseKeys(object) {
    if (!$d35ddea255759560$var$isPrototype(object)) return $d35ddea255759560$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($d35ddea255759560$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d35ddea255759560$var$isIndex(value, length) {
    length = length == null ? $d35ddea255759560$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $d35ddea255759560$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $d35ddea255759560$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $d35ddea255759560$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $d35ddea255759560$var$includes(collection, value, fromIndex, guard) {
    collection = $d35ddea255759560$var$isArrayLike(collection) ? collection : $d35ddea255759560$var$values(collection);
    fromIndex = fromIndex && !guard ? $d35ddea255759560$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $d35ddea255759560$var$nativeMax(length + fromIndex, 0);
    return $d35ddea255759560$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $d35ddea255759560$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $d35ddea255759560$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $d35ddea255759560$var$isArrayLikeObject(value) && $d35ddea255759560$var$hasOwnProperty.call(value, 'callee') && (!$d35ddea255759560$var$propertyIsEnumerable.call(value, 'callee') || $d35ddea255759560$var$objectToString.call(value) == $d35ddea255759560$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d35ddea255759560$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $d35ddea255759560$var$isArrayLike(value) {
    return value != null && $d35ddea255759560$var$isLength(value.length) && !$d35ddea255759560$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $d35ddea255759560$var$isArrayLikeObject(value) {
    return $d35ddea255759560$var$isObjectLike(value) && $d35ddea255759560$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d35ddea255759560$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $d35ddea255759560$var$isObject(value) ? $d35ddea255759560$var$objectToString.call(value) : '';
    return tag == $d35ddea255759560$var$funcTag || tag == $d35ddea255759560$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d35ddea255759560$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $d35ddea255759560$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d35ddea255759560$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $d35ddea255759560$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $d35ddea255759560$var$isString(value) {
    return typeof value == 'string' || !$d35ddea255759560$var$isArray(value) && $d35ddea255759560$var$isObjectLike(value) && $d35ddea255759560$var$objectToString.call(value) == $d35ddea255759560$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $d35ddea255759560$var$isSymbol(value) {
    return typeof value == 'symbol' || $d35ddea255759560$var$isObjectLike(value) && $d35ddea255759560$var$objectToString.call(value) == $d35ddea255759560$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $d35ddea255759560$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $d35ddea255759560$var$toNumber(value);
    if (value === $d35ddea255759560$var$INFINITY || value === -$d35ddea255759560$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $d35ddea255759560$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $d35ddea255759560$var$toInteger(value) {
    var result = $d35ddea255759560$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $d35ddea255759560$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($d35ddea255759560$var$isSymbol(value)) return $d35ddea255759560$var$NAN;
    if ($d35ddea255759560$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $d35ddea255759560$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($d35ddea255759560$var$reTrim, '');
    var isBinary = $d35ddea255759560$var$reIsBinary.test(value);
    return isBinary || $d35ddea255759560$var$reIsOctal.test(value) ? $d35ddea255759560$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $d35ddea255759560$var$reIsBadHex.test(value) ? $d35ddea255759560$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $d35ddea255759560$var$keys(object) {
    return $d35ddea255759560$var$isArrayLike(object) ? $d35ddea255759560$var$arrayLikeKeys(object) : $d35ddea255759560$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $d35ddea255759560$var$values(object) {
    return object ? $d35ddea255759560$var$baseValues(object, $d35ddea255759560$var$keys(object)) : [];
}
module.exports = $d35ddea255759560$var$includes;

});

parcelRegister("a0Xiz", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $74a7e6ed75c44e55$var$boolTag = '[object Boolean]';
/** Used for built-in method references. */ var $74a7e6ed75c44e55$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $74a7e6ed75c44e55$var$objectToString = $74a7e6ed75c44e55$var$objectProto.toString;
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $74a7e6ed75c44e55$var$isBoolean(value) {
    return value === true || value === false || $74a7e6ed75c44e55$var$isObjectLike(value) && $74a7e6ed75c44e55$var$objectToString.call(value) == $74a7e6ed75c44e55$var$boolTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $74a7e6ed75c44e55$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = $74a7e6ed75c44e55$var$isBoolean;

});

parcelRegister("8fuXr", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $6017bd06bc3b7cba$var$INFINITY = 1 / 0, $6017bd06bc3b7cba$var$MAX_INTEGER = 1.7976931348623157e+308, $6017bd06bc3b7cba$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $6017bd06bc3b7cba$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $6017bd06bc3b7cba$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $6017bd06bc3b7cba$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6017bd06bc3b7cba$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6017bd06bc3b7cba$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6017bd06bc3b7cba$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $6017bd06bc3b7cba$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6017bd06bc3b7cba$var$objectToString = $6017bd06bc3b7cba$var$objectProto.toString;
/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $6017bd06bc3b7cba$var$isInteger(value) {
    return typeof value == 'number' && value == $6017bd06bc3b7cba$var$toInteger(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6017bd06bc3b7cba$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6017bd06bc3b7cba$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6017bd06bc3b7cba$var$isSymbol(value) {
    return typeof value == 'symbol' || $6017bd06bc3b7cba$var$isObjectLike(value) && $6017bd06bc3b7cba$var$objectToString.call(value) == $6017bd06bc3b7cba$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6017bd06bc3b7cba$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $6017bd06bc3b7cba$var$toNumber(value);
    if (value === $6017bd06bc3b7cba$var$INFINITY || value === -$6017bd06bc3b7cba$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6017bd06bc3b7cba$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $6017bd06bc3b7cba$var$toInteger(value) {
    var result = $6017bd06bc3b7cba$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6017bd06bc3b7cba$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6017bd06bc3b7cba$var$isSymbol(value)) return $6017bd06bc3b7cba$var$NAN;
    if ($6017bd06bc3b7cba$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $6017bd06bc3b7cba$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($6017bd06bc3b7cba$var$reTrim, '');
    var isBinary = $6017bd06bc3b7cba$var$reIsBinary.test(value);
    return isBinary || $6017bd06bc3b7cba$var$reIsOctal.test(value) ? $6017bd06bc3b7cba$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6017bd06bc3b7cba$var$reIsBadHex.test(value) ? $6017bd06bc3b7cba$var$NAN : +value;
}
module.exports = $6017bd06bc3b7cba$var$isInteger;

});

parcelRegister("hzFRX", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $ccb62ee8c326ddba$var$numberTag = '[object Number]';
/** Used for built-in method references. */ var $ccb62ee8c326ddba$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ccb62ee8c326ddba$var$objectToString = $ccb62ee8c326ddba$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ccb62ee8c326ddba$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $ccb62ee8c326ddba$var$isNumber(value) {
    return typeof value == 'number' || $ccb62ee8c326ddba$var$isObjectLike(value) && $ccb62ee8c326ddba$var$objectToString.call(value) == $ccb62ee8c326ddba$var$numberTag;
}
module.exports = $ccb62ee8c326ddba$var$isNumber;

});

parcelRegister("1hRv1", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $0f00e0d907a420b6$var$objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $0f00e0d907a420b6$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0f00e0d907a420b6$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $0f00e0d907a420b6$var$funcProto = Function.prototype, $0f00e0d907a420b6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0f00e0d907a420b6$var$funcToString = $0f00e0d907a420b6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0f00e0d907a420b6$var$hasOwnProperty = $0f00e0d907a420b6$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0f00e0d907a420b6$var$objectCtorString = $0f00e0d907a420b6$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0f00e0d907a420b6$var$objectToString = $0f00e0d907a420b6$var$objectProto.toString;
/** Built-in value references. */ var $0f00e0d907a420b6$var$getPrototype = $0f00e0d907a420b6$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0f00e0d907a420b6$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0f00e0d907a420b6$var$isPlainObject(value) {
    if (!$0f00e0d907a420b6$var$isObjectLike(value) || $0f00e0d907a420b6$var$objectToString.call(value) != $0f00e0d907a420b6$var$objectTag || $0f00e0d907a420b6$var$isHostObject(value)) return false;
    var proto = $0f00e0d907a420b6$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $0f00e0d907a420b6$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0f00e0d907a420b6$var$funcToString.call(Ctor) == $0f00e0d907a420b6$var$objectCtorString;
}
module.exports = $0f00e0d907a420b6$var$isPlainObject;

});

parcelRegister("eyfSd", function(module, exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $a9808dcc3ae59235$var$stringTag = '[object String]';
/** Used for built-in method references. */ var $a9808dcc3ae59235$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a9808dcc3ae59235$var$objectToString = $a9808dcc3ae59235$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $a9808dcc3ae59235$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a9808dcc3ae59235$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $a9808dcc3ae59235$var$isString(value) {
    return typeof value == 'string' || !$a9808dcc3ae59235$var$isArray(value) && $a9808dcc3ae59235$var$isObjectLike(value) && $a9808dcc3ae59235$var$objectToString.call(value) == $a9808dcc3ae59235$var$stringTag;
}
module.exports = $a9808dcc3ae59235$var$isString;

});

parcelRegister("eHmQe", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $ab36ccae1adcb107$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $ab36ccae1adcb107$var$INFINITY = 1 / 0, $ab36ccae1adcb107$var$MAX_INTEGER = 1.7976931348623157e+308, $ab36ccae1adcb107$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ab36ccae1adcb107$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $ab36ccae1adcb107$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ab36ccae1adcb107$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ab36ccae1adcb107$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ab36ccae1adcb107$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ab36ccae1adcb107$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $ab36ccae1adcb107$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ab36ccae1adcb107$var$objectToString = $ab36ccae1adcb107$var$objectProto.toString;
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $ab36ccae1adcb107$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($ab36ccae1adcb107$var$FUNC_ERROR_TEXT);
    n = $ab36ccae1adcb107$var$toInteger(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $ab36ccae1adcb107$var$once(func) {
    return $ab36ccae1adcb107$var$before(2, func);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ab36ccae1adcb107$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ab36ccae1adcb107$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ab36ccae1adcb107$var$isSymbol(value) {
    return typeof value == 'symbol' || $ab36ccae1adcb107$var$isObjectLike(value) && $ab36ccae1adcb107$var$objectToString.call(value) == $ab36ccae1adcb107$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $ab36ccae1adcb107$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $ab36ccae1adcb107$var$toNumber(value);
    if (value === $ab36ccae1adcb107$var$INFINITY || value === -$ab36ccae1adcb107$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $ab36ccae1adcb107$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $ab36ccae1adcb107$var$toInteger(value) {
    var result = $ab36ccae1adcb107$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ab36ccae1adcb107$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($ab36ccae1adcb107$var$isSymbol(value)) return $ab36ccae1adcb107$var$NAN;
    if ($ab36ccae1adcb107$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $ab36ccae1adcb107$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($ab36ccae1adcb107$var$reTrim, '');
    var isBinary = $ab36ccae1adcb107$var$reIsBinary.test(value);
    return isBinary || $ab36ccae1adcb107$var$reIsOctal.test(value) ? $ab36ccae1adcb107$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ab36ccae1adcb107$var$reIsBadHex.test(value) ? $ab36ccae1adcb107$var$NAN : +value;
}
module.exports = $ab36ccae1adcb107$var$once;

});


parcelRegister("e5CQE", function(module, exports) {

$parcel$export(module.exports, "useInvitations", () => $18a5c9142f88c926$export$4a97ef64c1ca00ea);
$parcel$export(module.exports, "usePendingInvites", () => $18a5c9142f88c926$export$4f91741bc0821987);

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $4yCYl = parcelRequire("4yCYl");
const $18a5c9142f88c926$export$4a97ef64c1ca00ea = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [invitations, setInvitations] = $acw62.useState();
    const previousInvitations = (0, $4yCYl.default)(invitations);
    const fetchInvitations = async ()=>{
        const { data: invitations } = await postgrest.from("invitations").select().eq("fbo_id", activeFBO.id).eq("claimed", false);
        setInvitations(invitations ?? []);
    };
    // grab the hangar to start
    $acw62.useEffect(()=>{
        fetchInvitations();
    }, []);
    const makeInvite = $acw62.useCallback(async (invite)=>{
        const { data: inviteId } = await postgrest.rpc("make_invite", invite);
        await fetchInvitations();
        return `${window.location.origin}/#/claim-invite/${inviteId}`;
    }, []);
    $acw62.useEffect(()=>{
        (async ()=>{
            if (!invitations || !previousInvitations) return;
            if (invitations.length < previousInvitations.length) {
                const invitationsToDelete = previousInvitations.filter((p)=>!invitations.find((i)=>i.id === p.id));
                await postgrest.from("invitations").delete().in("id", invitationsToDelete.map(({ id: id })=>id));
            }
        })();
    });
    return {
        ready: Boolean(invitations),
        invitations: invitations ?? [],
        setInvitations: setInvitations,
        makeInvite: makeInvite
    };
};
const $18a5c9142f88c926$export$4f91741bc0821987 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [pendingInvites, setPendingInvites] = $acw62.useState([]);
    const [loading, setLoading] = $acw62.useState(false);
    const checkPendingInvites = $acw62.useCallback(async ()=>{
        setLoading(true);
        try {
            // Use secure stored procedure that gets invites for the current authenticated user
            const { data: data } = await postgrest.rpc("get_user_pending_invites");
            // Transform data to match expected format for backward compatibility
            const transformedData = (data ?? []).map((invite)=>({
                    id: invite.id,
                    email: invite.email,
                    claimed: invite.claimed,
                    created_at: invite.created_at,
                    is_expired: invite.is_expired,
                    fbo: {
                        id: invite.fbo_id,
                        name: invite.fbo_name
                    }
                }));
            setPendingInvites(transformedData);
        } catch (error) {
            console.error("Error fetching pending invites:", error);
            setPendingInvites([]);
        } finally{
            setLoading(false);
        }
    }, [
        postgrest
    ]);
    $acw62.useEffect(()=>{
        checkPendingInvites();
    }, [
        checkPendingInvites
    ]);
    return {
        pendingInvites: pendingInvites,
        loading: loading,
        refetch: checkPendingInvites
    };
};

});

parcelRegister("hldFD", function(module, exports) {
$parcel$export(module.exports, "RampEditor", () => (parcelRequire("lCpGu")).RampEditor);
$parcel$export(module.exports, "RampEditorWrapper", () => (parcelRequire("lCpGu")).RampEditorWrapper);
parcelRequire("lCpGu");

});
parcelRegister("lCpGu", function(module, exports) {

$parcel$export(module.exports, "RampEditor", () => $20d5b7102dc849b2$export$84a8c91f0e607f8a);
$parcel$export(module.exports, "RampEditorWrapper", () => $20d5b7102dc849b2$export$105d30ec552f9b6b);

var $ayMG0 = parcelRequire("ayMG0");

var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $1KiAb = parcelRequire("1KiAb");

var $ceJla = parcelRequire("ceJla");
const $20d5b7102dc849b2$export$84a8c91f0e607f8a = ({ ramp_id: ramp_id, ...props })=>{
    $acw62.useEffect(()=>{
        // Cleanup function to reset state when component unmounts or ramp_id changes
        return ()=>{
            (0, $ceJla.useLocalRampState).getState().reset();
        };
    }, [
        ramp_id
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
            isReference: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1KiAb.RampStateContainer), {
                initialState: {
                    ramp_id: ramp_id,
                    isReference: false,
                    includeReferenceImage: true
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ceJla.RampEditorPresenter), {
                    ...props
                })
            })
        })
    });
};
const $20d5b7102dc849b2$export$105d30ec552f9b6b = ()=>{
    const navigate = (0, $aphAM.useNavigate)();
    const { id: id } = (0, $aphAM.useParams)(); // Extract the :id from the URL
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        height: "100%",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($20d5b7102dc849b2$export$84a8c91f0e607f8a, {
            ramp_id: id,
            onClose: ()=>navigate(`/settings?tab=Ramps`)
        })
    });
};

});


parcelRegister("evsWN", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a8fa6a444a800fa7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8fa6a444a800fa7$var$_createSvgIcon = $a8fa6a444a800fa7$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a8fa6a444a800fa7$var$_default = module.exports.default = (0, $a8fa6a444a800fa7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'OpenInNew');

});

parcelRegister("2vNG8", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1d45032c62bcad96$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d45032c62bcad96$var$_createSvgIcon = $1d45032c62bcad96$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1d45032c62bcad96$var$_default = module.exports.default = (0, $1d45032c62bcad96$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m21.41 11.58-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7"
}), 'LocalOffer');

});

parcelRegister("lJX3N", function(module, exports) {
$parcel$export(module.exports, "ConvertSVG", () => (parcelRequire("a7YqU")).ConvertSVG);
parcelRequire("a7YqU");

});
parcelRegister("a7YqU", function(module, exports) {

$parcel$export(module.exports, "ConvertSVG", () => $c2b420904adbccad$export$56c63bf20f59e377);

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $dVEPf = parcelRequire("dVEPf");
const $c2b420904adbccad$export$56c63bf20f59e377 = ()=>{
    const [loading, setLoading] = $acw62.useState(false);
    const theme = (0, $14H9o.default)();
    const onDrop = $acw62.useCallback((acceptedFiles)=>{
        acceptedFiles.forEach((file)=>{
            const reader = new FileReader();
            reader.onabort = ()=>console.log("file reading was aborted");
            reader.onerror = ()=>console.log("file reading has failed");
            reader.onload = async ()=>{
                setLoading(true);
                const svg = reader.result;
                const payload = {
                    svg: svg
                };
                const url = window.location.hostname.indexOf("localhost") > 1 ? "http://localhost:8008/image" : "https://format-svg.airplx.com/image";
                await fetch(url, {
                    method: "POST",
                    mode: "cors",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }).then((response)=>response.blob()).then((blob)=>{
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = file.name.replace(".svg", ".png");
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.remove(); //afterwards we remove the element again
                });
                setLoading(false);
            };
            reader.readAsText(file);
        });
    }, []);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $dVEPf.useDropzone)({
        accept: {
            "image/svg+xml": []
        },
        onDrop: onDrop
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ...getRootProps(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    width: "40%",
                    margin: "auto",
                    marginTop: 20,
                    p: 10,
                    textAlign: "center",
                    border: `4px solid ${isDragActive ? theme.palette.success.main : theme.palette.primary.main}`
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    children: loading ? "Processing file..." : "Drag your SVG here."
                })
            })
        ]
    });
};

});
parcelRegister("dVEPf", function(module, exports) {

$parcel$export(module.exports, "useDropzone", () => $a24044586ed82795$export$cd49c0ecc5be9f36);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("cTZhp");
var $7YOG8 = parcelRequire("7YOG8");

var $eEukq = parcelRequire("eEukq");
var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $7YOG8.fromEvent),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $acw62.useMemo)(function() {
        return (0, $eEukq.acceptPropAsAcceptAttr)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $acw62.useMemo)(function() {
        return (0, $eEukq.pickerOptionsFromAccept)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $eEukq.canUseFileSystemAccessAPI)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $eEukq.onDocumentDragOver), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $eEukq.onDocumentDragOver));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $acw62.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $acw62.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $eEukq.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $eEukq.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $eEukq.allFilesAccepted)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $eEukq.isEvtWithFiles)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $eEukq.isEvtWithFiles)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $eEukq.fileAccepted)(file, acceptAttr), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $eEukq.fileMatchSize)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $eEukq.TOO_MANY_FILES_REJECTION)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $eEukq.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $eEukq.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $eEukq.isAbort)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $eEukq.isSecurityError)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $eEukq.isIeOrEdge)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $eEukq.composeEventHandlers)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $eEukq.composeEventHandlers)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, $eEukq.composeEventHandlers)(onChange, onDropCb)),
                onClick: composeHandler((0, $eEukq.composeEventHandlers)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}

});
parcelRegister("cTZhp", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => (parcelRequire("7YOG8")).fromEvent);

var $7YOG8 = parcelRequire("7YOG8");

});
parcelRegister("7YOG8", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $5cf572b3062ef12c$export$a36e16046ae8f1bb);

var $7WQrb = parcelRequire("7WQrb");

var $13eIt = parcelRequire("13eIt");
const $5cf572b3062ef12c$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $5cf572b3062ef12c$export$a36e16046ae8f1bb(evt) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
        if ($5cf572b3062ef12c$var$isObject(evt) && $5cf572b3062ef12c$var$isDataTransfer(evt.dataTransfer)) return $5cf572b3062ef12c$var$getDataTransferFiles(evt.dataTransfer, evt.type);
        else if ($5cf572b3062ef12c$var$isChangeEvt(evt)) return $5cf572b3062ef12c$var$getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>'getFile' in item && typeof item.getFile === 'function')) return $5cf572b3062ef12c$var$getFsHandleFiles(evt);
        return [];
    });
}
function $5cf572b3062ef12c$var$isDataTransfer(value) {
    return $5cf572b3062ef12c$var$isObject(value);
}
function $5cf572b3062ef12c$var$isChangeEvt(value) {
    return $5cf572b3062ef12c$var$isObject(value) && $5cf572b3062ef12c$var$isObject(value.target);
}
function $5cf572b3062ef12c$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $5cf572b3062ef12c$var$getInputFiles(evt) {
    return $5cf572b3062ef12c$var$fromList(evt.target.files).map((file)=>(0, $13eIt.toFileWithPath)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $5cf572b3062ef12c$var$getFsHandleFiles(handles) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, $13eIt.toFileWithPath)(file));
    });
}
function $5cf572b3062ef12c$var$getDataTransferFiles(dt, type) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = $5cf572b3062ef12c$var$fromList(dt.items).filter((item)=>item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') return items;
            const files = yield Promise.all(items.map($5cf572b3062ef12c$var$toFilePromises));
            return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$flatten(files));
        }
        return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$fromList(dt.files).map((file)=>(0, $13eIt.toFileWithPath)(file)));
    });
}
function $5cf572b3062ef12c$var$noIgnoredFiles(files) {
    return files.filter((file)=>$5cf572b3062ef12c$var$FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $5cf572b3062ef12c$var$fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $5cf572b3062ef12c$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $5cf572b3062ef12c$var$fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $5cf572b3062ef12c$var$fromDirEntry(entry);
    return $5cf572b3062ef12c$var$fromDataTransferItem(item, entry);
}
function $5cf572b3062ef12c$var$flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? $5cf572b3062ef12c$var$flatten(files) : [
                files
            ]
        ], []);
}
function $5cf572b3062ef12c$var$fromDataTransferItem(item, entry) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) throw new Error(`${item} is not a File`);
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return (0, $13eIt.toFileWithPath)(file);
            }
        }
        const file = item.getAsFile();
        if (!file) throw new Error(`${item} is not a File`);
        const fwp = (0, $13eIt.toFileWithPath)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $5cf572b3062ef12c$var$fromEntry(entry) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
        return entry.isDirectory ? $5cf572b3062ef12c$var$fromDirEntry(entry) : $5cf572b3062ef12c$var$fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $5cf572b3062ef12c$var$fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map($5cf572b3062ef12c$var$fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $5cf572b3062ef12c$var$fromFileEntry(entry) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, $13eIt.toFileWithPath)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}

});
parcelRegister("13eIt", function(module, exports) {

$parcel$export(module.exports, "toFileWithPath", () => $0c417c97818a47bb$export$8cc09085015f0dc7);
const $0c417c97818a47bb$export$db0345794bfc14ed = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        '1km',
        'application/vnd.1000minds.decision-model+xml'
    ],
    [
        '3dml',
        'text/vnd.in3d.3dml'
    ],
    [
        '3ds',
        'image/x-3ds'
    ],
    [
        '3g2',
        'video/3gpp2'
    ],
    [
        '3gp',
        'video/3gp'
    ],
    [
        '3gpp',
        'video/3gpp'
    ],
    [
        '3mf',
        'model/3mf'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        '7zip',
        'application/x-7z-compressed'
    ],
    [
        '123',
        'application/vnd.lotus-1-2-3'
    ],
    [
        'aab',
        'application/x-authorware-bin'
    ],
    [
        'aac',
        'audio/x-acc'
    ],
    [
        'aam',
        'application/x-authorware-map'
    ],
    [
        'aas',
        'application/x-authorware-seg'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'ac',
        'application/vnd.nokia.n-gage.ac+xml'
    ],
    [
        'ac3',
        'audio/ac3'
    ],
    [
        'acc',
        'application/vnd.americandynamics.acc'
    ],
    [
        'ace',
        'application/x-ace-compressed'
    ],
    [
        'acu',
        'application/vnd.acucobol'
    ],
    [
        'acutc',
        'application/vnd.acucorp'
    ],
    [
        'adp',
        'audio/adpcm'
    ],
    [
        'aep',
        'application/vnd.audiograph'
    ],
    [
        'afm',
        'application/x-font-type1'
    ],
    [
        'afp',
        'application/vnd.ibm.modcap'
    ],
    [
        'ahead',
        'application/vnd.ahead.space'
    ],
    [
        'ai',
        'application/pdf'
    ],
    [
        'aif',
        'audio/x-aiff'
    ],
    [
        'aifc',
        'audio/x-aiff'
    ],
    [
        'aiff',
        'audio/x-aiff'
    ],
    [
        'air',
        'application/vnd.adobe.air-application-installer-package+zip'
    ],
    [
        'ait',
        'application/vnd.dvb.ait'
    ],
    [
        'ami',
        'application/vnd.amiga.ami'
    ],
    [
        'amr',
        'audio/amr'
    ],
    [
        'apk',
        'application/vnd.android.package-archive'
    ],
    [
        'apng',
        'image/apng'
    ],
    [
        'appcache',
        'text/cache-manifest'
    ],
    [
        'application',
        'application/x-ms-application'
    ],
    [
        'apr',
        'application/vnd.lotus-approach'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'arj',
        'application/x-arj'
    ],
    [
        'asc',
        'application/pgp-signature'
    ],
    [
        'asf',
        'video/x-ms-asf'
    ],
    [
        'asm',
        'text/x-asm'
    ],
    [
        'aso',
        'application/vnd.accpac.simply.aso'
    ],
    [
        'asx',
        'video/x-ms-asf'
    ],
    [
        'atc',
        'application/vnd.acucorp'
    ],
    [
        'atom',
        'application/atom+xml'
    ],
    [
        'atomcat',
        'application/atomcat+xml'
    ],
    [
        'atomdeleted',
        'application/atomdeleted+xml'
    ],
    [
        'atomsvc',
        'application/atomsvc+xml'
    ],
    [
        'atx',
        'application/vnd.antix.game-component'
    ],
    [
        'au',
        'audio/x-au'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'aw',
        'application/applixware'
    ],
    [
        'azf',
        'application/vnd.airzip.filesecure.azf'
    ],
    [
        'azs',
        'application/vnd.airzip.filesecure.azs'
    ],
    [
        'azv',
        'image/vnd.airzip.accelerator.azv'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'b16',
        'image/vnd.pco.b16'
    ],
    [
        'bat',
        'application/x-msdownload'
    ],
    [
        'bcpio',
        'application/x-bcpio'
    ],
    [
        'bdf',
        'application/x-font-bdf'
    ],
    [
        'bdm',
        'application/vnd.syncml.dm+wbxml'
    ],
    [
        'bdoc',
        'application/x-bdoc'
    ],
    [
        'bed',
        'application/vnd.realvnc.bed'
    ],
    [
        'bh2',
        'application/vnd.fujitsu.oasysprs'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'blb',
        'application/x-blorb'
    ],
    [
        'blorb',
        'application/x-blorb'
    ],
    [
        'bmi',
        'application/vnd.bmi'
    ],
    [
        'bmml',
        'application/vnd.balsamiq.bmml+xml'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'book',
        'application/vnd.framemaker'
    ],
    [
        'box',
        'application/vnd.previewsystems.box'
    ],
    [
        'boz',
        'application/x-bzip2'
    ],
    [
        'bpk',
        'application/octet-stream'
    ],
    [
        'bpmn',
        'application/octet-stream'
    ],
    [
        'bsp',
        'model/vnd.valve.source.compiled-map'
    ],
    [
        'btif',
        'image/prs.btif'
    ],
    [
        'buffer',
        'application/octet-stream'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'c',
        'text/x-c'
    ],
    [
        'c4d',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4f',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4g',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4p',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4u',
        'application/vnd.clonk.c4group'
    ],
    [
        'c11amc',
        'application/vnd.cluetrust.cartomobile-config'
    ],
    [
        'c11amz',
        'application/vnd.cluetrust.cartomobile-config-pkg'
    ],
    [
        'cab',
        'application/vnd.ms-cab-compressed'
    ],
    [
        'caf',
        'audio/x-caf'
    ],
    [
        'cap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'car',
        'application/vnd.curl.car'
    ],
    [
        'cat',
        'application/vnd.ms-pki.seccat'
    ],
    [
        'cb7',
        'application/x-cbr'
    ],
    [
        'cba',
        'application/x-cbr'
    ],
    [
        'cbr',
        'application/x-cbr'
    ],
    [
        'cbt',
        'application/x-cbr'
    ],
    [
        'cbz',
        'application/x-cbr'
    ],
    [
        'cc',
        'text/x-c'
    ],
    [
        'cco',
        'application/x-cocoa'
    ],
    [
        'cct',
        'application/x-director'
    ],
    [
        'ccxml',
        'application/ccxml+xml'
    ],
    [
        'cdbcmsg',
        'application/vnd.contact.cmsg'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'cdf',
        'application/x-netcdf'
    ],
    [
        'cdfx',
        'application/cdfx+xml'
    ],
    [
        'cdkey',
        'application/vnd.mediastation.cdkey'
    ],
    [
        'cdmia',
        'application/cdmi-capability'
    ],
    [
        'cdmic',
        'application/cdmi-container'
    ],
    [
        'cdmid',
        'application/cdmi-domain'
    ],
    [
        'cdmio',
        'application/cdmi-object'
    ],
    [
        'cdmiq',
        'application/cdmi-queue'
    ],
    [
        'cdr',
        'application/cdr'
    ],
    [
        'cdx',
        'chemical/x-cdx'
    ],
    [
        'cdxml',
        'application/vnd.chemdraw+xml'
    ],
    [
        'cdy',
        'application/vnd.cinderella'
    ],
    [
        'cer',
        'application/pkix-cert'
    ],
    [
        'cfs',
        'application/x-cfs-compressed'
    ],
    [
        'cgm',
        'image/cgm'
    ],
    [
        'chat',
        'application/x-chat'
    ],
    [
        'chm',
        'application/vnd.ms-htmlhelp'
    ],
    [
        'chrt',
        'application/vnd.kde.kchart'
    ],
    [
        'cif',
        'chemical/x-cif'
    ],
    [
        'cii',
        'application/vnd.anser-web-certificate-issue-initiation'
    ],
    [
        'cil',
        'application/vnd.ms-artgalry'
    ],
    [
        'cjs',
        'application/node'
    ],
    [
        'cla',
        'application/vnd.claymore'
    ],
    [
        'class',
        'application/octet-stream'
    ],
    [
        'clkk',
        'application/vnd.crick.clicker.keyboard'
    ],
    [
        'clkp',
        'application/vnd.crick.clicker.palette'
    ],
    [
        'clkt',
        'application/vnd.crick.clicker.template'
    ],
    [
        'clkw',
        'application/vnd.crick.clicker.wordbank'
    ],
    [
        'clkx',
        'application/vnd.crick.clicker'
    ],
    [
        'clp',
        'application/x-msclip'
    ],
    [
        'cmc',
        'application/vnd.cosmocaller'
    ],
    [
        'cmdf',
        'chemical/x-cmdf'
    ],
    [
        'cml',
        'chemical/x-cml'
    ],
    [
        'cmp',
        'application/vnd.yellowriver-custom-menu'
    ],
    [
        'cmx',
        'image/x-cmx'
    ],
    [
        'cod',
        'application/vnd.rim.cod'
    ],
    [
        'coffee',
        'text/coffeescript'
    ],
    [
        'com',
        'application/x-msdownload'
    ],
    [
        'conf',
        'text/plain'
    ],
    [
        'cpio',
        'application/x-cpio'
    ],
    [
        'cpp',
        'text/x-c'
    ],
    [
        'cpt',
        'application/mac-compactpro'
    ],
    [
        'crd',
        'application/x-mscardfile'
    ],
    [
        'crl',
        'application/pkix-crl'
    ],
    [
        'crt',
        'application/x-x509-ca-cert'
    ],
    [
        'crx',
        'application/x-chrome-extension'
    ],
    [
        'cryptonote',
        'application/vnd.rig.cryptonote'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'csl',
        'application/vnd.citationstyles.style+xml'
    ],
    [
        'csml',
        'chemical/x-csml'
    ],
    [
        'csp',
        'application/vnd.commonspace'
    ],
    [
        'csr',
        'application/octet-stream'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'cst',
        'application/x-director'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'cu',
        'application/cu-seeme'
    ],
    [
        'curl',
        'text/vnd.curl'
    ],
    [
        'cww',
        'application/prs.cww'
    ],
    [
        'cxt',
        'application/x-director'
    ],
    [
        'cxx',
        'text/x-c'
    ],
    [
        'dae',
        'model/vnd.collada+xml'
    ],
    [
        'daf',
        'application/vnd.mobius.daf'
    ],
    [
        'dart',
        'application/vnd.dart'
    ],
    [
        'dataless',
        'application/vnd.fdsn.seed'
    ],
    [
        'davmount',
        'application/davmount+xml'
    ],
    [
        'dbf',
        'application/vnd.dbf'
    ],
    [
        'dbk',
        'application/docbook+xml'
    ],
    [
        'dcr',
        'application/x-director'
    ],
    [
        'dcurl',
        'text/vnd.curl.dcurl'
    ],
    [
        'dd2',
        'application/vnd.oma.dd2+xml'
    ],
    [
        'ddd',
        'application/vnd.fujixerox.ddd'
    ],
    [
        'ddf',
        'application/vnd.syncml.dmddf+xml'
    ],
    [
        'dds',
        'image/vnd.ms-dds'
    ],
    [
        'deb',
        'application/x-debian-package'
    ],
    [
        'def',
        'text/plain'
    ],
    [
        'deploy',
        'application/octet-stream'
    ],
    [
        'der',
        'application/x-x509-ca-cert'
    ],
    [
        'dfac',
        'application/vnd.dreamfactory'
    ],
    [
        'dgc',
        'application/x-dgc-compressed'
    ],
    [
        'dic',
        'text/x-c'
    ],
    [
        'dir',
        'application/x-director'
    ],
    [
        'dis',
        'application/vnd.mobius.dis'
    ],
    [
        'disposition-notification',
        'message/disposition-notification'
    ],
    [
        'dist',
        'application/octet-stream'
    ],
    [
        'distz',
        'application/octet-stream'
    ],
    [
        'djv',
        'image/vnd.djvu'
    ],
    [
        'djvu',
        'image/vnd.djvu'
    ],
    [
        'dll',
        'application/octet-stream'
    ],
    [
        'dmg',
        'application/x-apple-diskimage'
    ],
    [
        'dmn',
        'application/octet-stream'
    ],
    [
        'dmp',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'dms',
        'application/octet-stream'
    ],
    [
        'dna',
        'application/vnd.dna'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'dot',
        'application/msword'
    ],
    [
        'dotm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'dotx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    ],
    [
        'dp',
        'application/vnd.osgi.dp'
    ],
    [
        'dpg',
        'application/vnd.dpgraph'
    ],
    [
        'dra',
        'audio/vnd.dra'
    ],
    [
        'drle',
        'image/dicom-rle'
    ],
    [
        'dsc',
        'text/prs.lines.tag'
    ],
    [
        'dssc',
        'application/dssc+der'
    ],
    [
        'dtb',
        'application/x-dtbook+xml'
    ],
    [
        'dtd',
        'application/xml-dtd'
    ],
    [
        'dts',
        'audio/vnd.dts'
    ],
    [
        'dtshd',
        'audio/vnd.dts.hd'
    ],
    [
        'dump',
        'application/octet-stream'
    ],
    [
        'dvb',
        'video/vnd.dvb.file'
    ],
    [
        'dvi',
        'application/x-dvi'
    ],
    [
        'dwd',
        'application/atsc-dwd+xml'
    ],
    [
        'dwf',
        'model/vnd.dwf'
    ],
    [
        'dwg',
        'image/vnd.dwg'
    ],
    [
        'dxf',
        'image/vnd.dxf'
    ],
    [
        'dxp',
        'application/vnd.spotfire.dxp'
    ],
    [
        'dxr',
        'application/x-director'
    ],
    [
        'ear',
        'application/java-archive'
    ],
    [
        'ecelp4800',
        'audio/vnd.nuera.ecelp4800'
    ],
    [
        'ecelp7470',
        'audio/vnd.nuera.ecelp7470'
    ],
    [
        'ecelp9600',
        'audio/vnd.nuera.ecelp9600'
    ],
    [
        'ecma',
        'application/ecmascript'
    ],
    [
        'edm',
        'application/vnd.novadigm.edm'
    ],
    [
        'edx',
        'application/vnd.novadigm.edx'
    ],
    [
        'efif',
        'application/vnd.picsel'
    ],
    [
        'ei6',
        'application/vnd.pg.osasli'
    ],
    [
        'elc',
        'application/octet-stream'
    ],
    [
        'emf',
        'image/emf'
    ],
    [
        'eml',
        'message/rfc822'
    ],
    [
        'emma',
        'application/emma+xml'
    ],
    [
        'emotionml',
        'application/emotionml+xml'
    ],
    [
        'emz',
        'application/x-msmetafile'
    ],
    [
        'eol',
        'audio/vnd.digital-winds'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'eps',
        'application/postscript'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'es',
        'application/ecmascript'
    ],
    [
        'es3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'esa',
        'application/vnd.osgi.subsystem'
    ],
    [
        'esf',
        'application/vnd.epson.esf'
    ],
    [
        'et3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'etx',
        'text/x-setext'
    ],
    [
        'eva',
        'application/x-eva'
    ],
    [
        'evy',
        'application/x-envoy'
    ],
    [
        'exe',
        'application/octet-stream'
    ],
    [
        'exi',
        'application/exi'
    ],
    [
        'exp',
        'application/express'
    ],
    [
        'exr',
        'image/aces'
    ],
    [
        'ext',
        'application/vnd.novadigm.ext'
    ],
    [
        'ez',
        'application/andrew-inset'
    ],
    [
        'ez2',
        'application/vnd.ezpix-album'
    ],
    [
        'ez3',
        'application/vnd.ezpix-package'
    ],
    [
        'f',
        'text/x-fortran'
    ],
    [
        'f4v',
        'video/mp4'
    ],
    [
        'f77',
        'text/x-fortran'
    ],
    [
        'f90',
        'text/x-fortran'
    ],
    [
        'fbs',
        'image/vnd.fastbidsheet'
    ],
    [
        'fcdt',
        'application/vnd.adobe.formscentral.fcdt'
    ],
    [
        'fcs',
        'application/vnd.isac.fcs'
    ],
    [
        'fdf',
        'application/vnd.fdf'
    ],
    [
        'fdt',
        'application/fdt+xml'
    ],
    [
        'fe_launch',
        'application/vnd.denovo.fcselayout-link'
    ],
    [
        'fg5',
        'application/vnd.fujitsu.oasysgp'
    ],
    [
        'fgd',
        'application/x-director'
    ],
    [
        'fh',
        'image/x-freehand'
    ],
    [
        'fh4',
        'image/x-freehand'
    ],
    [
        'fh5',
        'image/x-freehand'
    ],
    [
        'fh7',
        'image/x-freehand'
    ],
    [
        'fhc',
        'image/x-freehand'
    ],
    [
        'fig',
        'application/x-xfig'
    ],
    [
        'fits',
        'image/fits'
    ],
    [
        'flac',
        'audio/x-flac'
    ],
    [
        'fli',
        'video/x-fli'
    ],
    [
        'flo',
        'application/vnd.micrografx.flo'
    ],
    [
        'flv',
        'video/x-flv'
    ],
    [
        'flw',
        'application/vnd.kde.kivio'
    ],
    [
        'flx',
        'text/vnd.fmi.flexstor'
    ],
    [
        'fly',
        'text/vnd.fly'
    ],
    [
        'fm',
        'application/vnd.framemaker'
    ],
    [
        'fnc',
        'application/vnd.frogans.fnc'
    ],
    [
        'fo',
        'application/vnd.software602.filler.form+xml'
    ],
    [
        'for',
        'text/x-fortran'
    ],
    [
        'fpx',
        'image/vnd.fpx'
    ],
    [
        'frame',
        'application/vnd.framemaker'
    ],
    [
        'fsc',
        'application/vnd.fsc.weblaunch'
    ],
    [
        'fst',
        'image/vnd.fst'
    ],
    [
        'ftc',
        'application/vnd.fluxtime.clip'
    ],
    [
        'fti',
        'application/vnd.anser-web-funds-transfer-initiation'
    ],
    [
        'fvt',
        'video/vnd.fvt'
    ],
    [
        'fxp',
        'application/vnd.adobe.fxp'
    ],
    [
        'fxpl',
        'application/vnd.adobe.fxp'
    ],
    [
        'fzs',
        'application/vnd.fuzzysheet'
    ],
    [
        'g2w',
        'application/vnd.geoplan'
    ],
    [
        'g3',
        'image/g3fax'
    ],
    [
        'g3w',
        'application/vnd.geospace'
    ],
    [
        'gac',
        'application/vnd.groove-account'
    ],
    [
        'gam',
        'application/x-tads'
    ],
    [
        'gbr',
        'application/rpki-ghostbusters'
    ],
    [
        'gca',
        'application/x-gca-compressed'
    ],
    [
        'gdl',
        'model/vnd.gdl'
    ],
    [
        'gdoc',
        'application/vnd.google-apps.document'
    ],
    [
        'geo',
        'application/vnd.dynageo'
    ],
    [
        'geojson',
        'application/geo+json'
    ],
    [
        'gex',
        'application/vnd.geometry-explorer'
    ],
    [
        'ggb',
        'application/vnd.geogebra.file'
    ],
    [
        'ggt',
        'application/vnd.geogebra.tool'
    ],
    [
        'ghf',
        'application/vnd.groove-help'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'gim',
        'application/vnd.groove-identity-message'
    ],
    [
        'glb',
        'model/gltf-binary'
    ],
    [
        'gltf',
        'model/gltf+json'
    ],
    [
        'gml',
        'application/gml+xml'
    ],
    [
        'gmx',
        'application/vnd.gmx'
    ],
    [
        'gnumeric',
        'application/x-gnumeric'
    ],
    [
        'gpg',
        'application/gpg-keys'
    ],
    [
        'gph',
        'application/vnd.flographit'
    ],
    [
        'gpx',
        'application/gpx+xml'
    ],
    [
        'gqf',
        'application/vnd.grafeq'
    ],
    [
        'gqs',
        'application/vnd.grafeq'
    ],
    [
        'gram',
        'application/srgs'
    ],
    [
        'gramps',
        'application/x-gramps-xml'
    ],
    [
        'gre',
        'application/vnd.geometry-explorer'
    ],
    [
        'grv',
        'application/vnd.groove-injector'
    ],
    [
        'grxml',
        'application/srgs+xml'
    ],
    [
        'gsf',
        'application/x-font-ghostscript'
    ],
    [
        'gsheet',
        'application/vnd.google-apps.spreadsheet'
    ],
    [
        'gslides',
        'application/vnd.google-apps.presentation'
    ],
    [
        'gtar',
        'application/x-gtar'
    ],
    [
        'gtm',
        'application/vnd.groove-tool-message'
    ],
    [
        'gtw',
        'model/vnd.gtw'
    ],
    [
        'gv',
        'text/vnd.graphviz'
    ],
    [
        'gxf',
        'application/gxf'
    ],
    [
        'gxt',
        'application/vnd.geonext'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gzip',
        'application/gzip'
    ],
    [
        'h',
        'text/x-c'
    ],
    [
        'h261',
        'video/h261'
    ],
    [
        'h263',
        'video/h263'
    ],
    [
        'h264',
        'video/h264'
    ],
    [
        'hal',
        'application/vnd.hal+xml'
    ],
    [
        'hbci',
        'application/vnd.hbci'
    ],
    [
        'hbs',
        'text/x-handlebars-template'
    ],
    [
        'hdd',
        'application/x-virtualbox-hdd'
    ],
    [
        'hdf',
        'application/x-hdf'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heics',
        'image/heic-sequence'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'heifs',
        'image/heif-sequence'
    ],
    [
        'hej2',
        'image/hej2k'
    ],
    [
        'held',
        'application/atsc-held+xml'
    ],
    [
        'hh',
        'text/x-c'
    ],
    [
        'hjson',
        'application/hjson'
    ],
    [
        'hlp',
        'application/winhlp'
    ],
    [
        'hpgl',
        'application/vnd.hp-hpgl'
    ],
    [
        'hpid',
        'application/vnd.hp-hpid'
    ],
    [
        'hps',
        'application/vnd.hp-hps'
    ],
    [
        'hqx',
        'application/mac-binhex40'
    ],
    [
        'hsj2',
        'image/hsj2'
    ],
    [
        'htc',
        'text/x-component'
    ],
    [
        'htke',
        'application/vnd.kenameaapp'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'hvd',
        'application/vnd.yamaha.hv-dic'
    ],
    [
        'hvp',
        'application/vnd.yamaha.hv-voice'
    ],
    [
        'hvs',
        'application/vnd.yamaha.hv-script'
    ],
    [
        'i2g',
        'application/vnd.intergeo'
    ],
    [
        'icc',
        'application/vnd.iccprofile'
    ],
    [
        'ice',
        'x-conference/x-cooltalk'
    ],
    [
        'icm',
        'application/vnd.iccprofile'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'ief',
        'image/ief'
    ],
    [
        'ifb',
        'text/calendar'
    ],
    [
        'ifm',
        'application/vnd.shana.informed.formdata'
    ],
    [
        'iges',
        'model/iges'
    ],
    [
        'igl',
        'application/vnd.igloader'
    ],
    [
        'igm',
        'application/vnd.insors.igm'
    ],
    [
        'igs',
        'model/iges'
    ],
    [
        'igx',
        'application/vnd.micrografx.igx'
    ],
    [
        'iif',
        'application/vnd.shana.informed.interchange'
    ],
    [
        'img',
        'application/octet-stream'
    ],
    [
        'imp',
        'application/vnd.accpac.simply.imp'
    ],
    [
        'ims',
        'application/vnd.ms-ims'
    ],
    [
        'in',
        'text/plain'
    ],
    [
        'ini',
        'text/plain'
    ],
    [
        'ink',
        'application/inkml+xml'
    ],
    [
        'inkml',
        'application/inkml+xml'
    ],
    [
        'install',
        'application/x-install-instructions'
    ],
    [
        'iota',
        'application/vnd.astraea-software.iota'
    ],
    [
        'ipfix',
        'application/ipfix'
    ],
    [
        'ipk',
        'application/vnd.shana.informed.package'
    ],
    [
        'irm',
        'application/vnd.ibm.rights-management'
    ],
    [
        'irp',
        'application/vnd.irepository.package+xml'
    ],
    [
        'iso',
        'application/x-iso9660-image'
    ],
    [
        'itp',
        'application/vnd.shana.informed.formtemplate'
    ],
    [
        'its',
        'application/its+xml'
    ],
    [
        'ivp',
        'application/vnd.immervision-ivp'
    ],
    [
        'ivu',
        'application/vnd.immervision-ivu'
    ],
    [
        'jad',
        'text/vnd.sun.j2me.app-descriptor'
    ],
    [
        'jade',
        'text/jade'
    ],
    [
        'jam',
        'application/vnd.jam'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jardiff',
        'application/x-java-archive-diff'
    ],
    [
        'java',
        'text/x-java-source'
    ],
    [
        'jhc',
        'image/jphc'
    ],
    [
        'jisp',
        'application/vnd.jisp'
    ],
    [
        'jls',
        'image/jls'
    ],
    [
        'jlt',
        'application/vnd.hp-jlyt'
    ],
    [
        'jng',
        'image/x-jng'
    ],
    [
        'jnlp',
        'application/x-java-jnlp-file'
    ],
    [
        'joda',
        'application/vnd.joost.joda-archive'
    ],
    [
        'jp2',
        'image/jp2'
    ],
    [
        'jpe',
        'image/jpeg'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpf',
        'image/jpx'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'jpg2',
        'image/jp2'
    ],
    [
        'jpgm',
        'video/jpm'
    ],
    [
        'jpgv',
        'video/jpeg'
    ],
    [
        'jph',
        'image/jph'
    ],
    [
        'jpm',
        'video/jpm'
    ],
    [
        'jpx',
        'image/jpx'
    ],
    [
        'js',
        'application/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'json5',
        'application/json5'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    // https://jsonlines.org/
    [
        'jsonl',
        'application/jsonl'
    ],
    [
        'jsonml',
        'application/jsonml+json'
    ],
    [
        'jsx',
        'text/jsx'
    ],
    [
        'jxr',
        'image/jxr'
    ],
    [
        'jxra',
        'image/jxra'
    ],
    [
        'jxrs',
        'image/jxrs'
    ],
    [
        'jxs',
        'image/jxs'
    ],
    [
        'jxsc',
        'image/jxsc'
    ],
    [
        'jxsi',
        'image/jxsi'
    ],
    [
        'jxss',
        'image/jxss'
    ],
    [
        'kar',
        'audio/midi'
    ],
    [
        'karbon',
        'application/vnd.kde.karbon'
    ],
    [
        'kdb',
        'application/octet-stream'
    ],
    [
        'kdbx',
        'application/x-keepass2'
    ],
    [
        'key',
        'application/x-iwork-keynote-sffkey'
    ],
    [
        'kfo',
        'application/vnd.kde.kformula'
    ],
    [
        'kia',
        'application/vnd.kidspiration'
    ],
    [
        'kml',
        'application/vnd.google-earth.kml+xml'
    ],
    [
        'kmz',
        'application/vnd.google-earth.kmz'
    ],
    [
        'kne',
        'application/vnd.kinar'
    ],
    [
        'knp',
        'application/vnd.kinar'
    ],
    [
        'kon',
        'application/vnd.kde.kontour'
    ],
    [
        'kpr',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpt',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpxx',
        'application/vnd.ds-keypoint'
    ],
    [
        'ksp',
        'application/vnd.kde.kspread'
    ],
    [
        'ktr',
        'application/vnd.kahootz'
    ],
    [
        'ktx',
        'image/ktx'
    ],
    [
        'ktx2',
        'image/ktx2'
    ],
    [
        'ktz',
        'application/vnd.kahootz'
    ],
    [
        'kwd',
        'application/vnd.kde.kword'
    ],
    [
        'kwt',
        'application/vnd.kde.kword'
    ],
    [
        'lasxml',
        'application/vnd.las.las+xml'
    ],
    [
        'latex',
        'application/x-latex'
    ],
    [
        'lbd',
        'application/vnd.llamagraphics.life-balance.desktop'
    ],
    [
        'lbe',
        'application/vnd.llamagraphics.life-balance.exchange+xml'
    ],
    [
        'les',
        'application/vnd.hhe.lesson-player'
    ],
    [
        'less',
        'text/less'
    ],
    [
        'lgr',
        'application/lgr+xml'
    ],
    [
        'lha',
        'application/octet-stream'
    ],
    [
        'link66',
        'application/vnd.route66.link66+xml'
    ],
    [
        'list',
        'text/plain'
    ],
    [
        'list3820',
        'application/vnd.ibm.modcap'
    ],
    [
        'listafp',
        'application/vnd.ibm.modcap'
    ],
    [
        'litcoffee',
        'text/coffeescript'
    ],
    [
        'lnk',
        'application/x-ms-shortcut'
    ],
    [
        'log',
        'text/plain'
    ],
    [
        'lostxml',
        'application/lost+xml'
    ],
    [
        'lrf',
        'application/octet-stream'
    ],
    [
        'lrm',
        'application/vnd.ms-lrm'
    ],
    [
        'ltf',
        'application/vnd.frogans.ltf'
    ],
    [
        'lua',
        'text/x-lua'
    ],
    [
        'luac',
        'application/x-lua-bytecode'
    ],
    [
        'lvp',
        'audio/vnd.lucent.voice'
    ],
    [
        'lwp',
        'application/vnd.lotus-wordpro'
    ],
    [
        'lzh',
        'application/octet-stream'
    ],
    [
        'm1v',
        'video/mpeg'
    ],
    [
        'm2a',
        'audio/mpeg'
    ],
    [
        'm2v',
        'video/mpeg'
    ],
    [
        'm3a',
        'audio/mpeg'
    ],
    [
        'm3u',
        'text/plain'
    ],
    [
        'm3u8',
        'application/vnd.apple.mpegurl'
    ],
    [
        'm4a',
        'audio/x-m4a'
    ],
    [
        'm4p',
        'application/mp4'
    ],
    [
        'm4s',
        'video/iso.segment'
    ],
    [
        'm4u',
        'application/vnd.mpegurl'
    ],
    [
        'm4v',
        'video/x-m4v'
    ],
    [
        'm13',
        'application/x-msmediaview'
    ],
    [
        'm14',
        'application/x-msmediaview'
    ],
    [
        'm21',
        'application/mp21'
    ],
    [
        'ma',
        'application/mathematica'
    ],
    [
        'mads',
        'application/mads+xml'
    ],
    [
        'maei',
        'application/mmt-aei+xml'
    ],
    [
        'mag',
        'application/vnd.ecowin.chart'
    ],
    [
        'maker',
        'application/vnd.framemaker'
    ],
    [
        'man',
        'text/troff'
    ],
    [
        'manifest',
        'text/cache-manifest'
    ],
    [
        'map',
        'application/json'
    ],
    [
        'mar',
        'application/octet-stream'
    ],
    [
        'markdown',
        'text/markdown'
    ],
    [
        'mathml',
        'application/mathml+xml'
    ],
    [
        'mb',
        'application/mathematica'
    ],
    [
        'mbk',
        'application/vnd.mobius.mbk'
    ],
    [
        'mbox',
        'application/mbox'
    ],
    [
        'mc1',
        'application/vnd.medcalcdata'
    ],
    [
        'mcd',
        'application/vnd.mcd'
    ],
    [
        'mcurl',
        'text/vnd.curl.mcurl'
    ],
    [
        'md',
        'text/markdown'
    ],
    [
        'mdb',
        'application/x-msaccess'
    ],
    [
        'mdi',
        'image/vnd.ms-modi'
    ],
    [
        'mdx',
        'text/mdx'
    ],
    [
        'me',
        'text/troff'
    ],
    [
        'mesh',
        'model/mesh'
    ],
    [
        'meta4',
        'application/metalink4+xml'
    ],
    [
        'metalink',
        'application/metalink+xml'
    ],
    [
        'mets',
        'application/mets+xml'
    ],
    [
        'mfm',
        'application/vnd.mfmp'
    ],
    [
        'mft',
        'application/rpki-manifest'
    ],
    [
        'mgp',
        'application/vnd.osgeo.mapguide.package'
    ],
    [
        'mgz',
        'application/vnd.proteus.magazine'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mie',
        'application/x-mie'
    ],
    [
        'mif',
        'application/vnd.mif'
    ],
    [
        'mime',
        'message/rfc822'
    ],
    [
        'mj2',
        'video/mj2'
    ],
    [
        'mjp2',
        'video/mj2'
    ],
    [
        'mjs',
        'application/javascript'
    ],
    [
        'mk3d',
        'video/x-matroska'
    ],
    [
        'mka',
        'audio/x-matroska'
    ],
    [
        'mkd',
        'text/x-markdown'
    ],
    [
        'mks',
        'video/x-matroska'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mlp',
        'application/vnd.dolby.mlp'
    ],
    [
        'mmd',
        'application/vnd.chipnuts.karaoke-mmd'
    ],
    [
        'mmf',
        'application/vnd.smaf'
    ],
    [
        'mml',
        'text/mathml'
    ],
    [
        'mmr',
        'image/vnd.fujixerox.edmics-mmr'
    ],
    [
        'mng',
        'video/x-mng'
    ],
    [
        'mny',
        'application/x-msmoney'
    ],
    [
        'mobi',
        'application/x-mobipocket-ebook'
    ],
    [
        'mods',
        'application/mods+xml'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'movie',
        'video/x-sgi-movie'
    ],
    [
        'mp2',
        'audio/mpeg'
    ],
    [
        'mp2a',
        'audio/mpeg'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mp4a',
        'audio/mp4'
    ],
    [
        'mp4s',
        'application/mp4'
    ],
    [
        'mp4v',
        'video/mp4'
    ],
    [
        'mp21',
        'application/mp21'
    ],
    [
        'mpc',
        'application/vnd.mophun.certificate'
    ],
    [
        'mpd',
        'application/dash+xml'
    ],
    [
        'mpe',
        'video/mpeg'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpg',
        'video/mpeg'
    ],
    [
        'mpg4',
        'video/mp4'
    ],
    [
        'mpga',
        'audio/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'mpm',
        'application/vnd.blueice.multipass'
    ],
    [
        'mpn',
        'application/vnd.mophun.application'
    ],
    [
        'mpp',
        'application/vnd.ms-project'
    ],
    [
        'mpt',
        'application/vnd.ms-project'
    ],
    [
        'mpy',
        'application/vnd.ibm.minipay'
    ],
    [
        'mqy',
        'application/vnd.mobius.mqy'
    ],
    [
        'mrc',
        'application/marc'
    ],
    [
        'mrcx',
        'application/marcxml+xml'
    ],
    [
        'ms',
        'text/troff'
    ],
    [
        'mscml',
        'application/mediaservercontrol+xml'
    ],
    [
        'mseed',
        'application/vnd.fdsn.mseed'
    ],
    [
        'mseq',
        'application/vnd.mseq'
    ],
    [
        'msf',
        'application/vnd.epson.msf'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ],
    [
        'msh',
        'model/mesh'
    ],
    [
        'msi',
        'application/x-msdownload'
    ],
    [
        'msl',
        'application/vnd.mobius.msl'
    ],
    [
        'msm',
        'application/octet-stream'
    ],
    [
        'msp',
        'application/octet-stream'
    ],
    [
        'msty',
        'application/vnd.muvee.style'
    ],
    [
        'mtl',
        'model/mtl'
    ],
    [
        'mts',
        'model/vnd.mts'
    ],
    [
        'mus',
        'application/vnd.musician'
    ],
    [
        'musd',
        'application/mmt-usd+xml'
    ],
    [
        'musicxml',
        'application/vnd.recordare.musicxml+xml'
    ],
    [
        'mvb',
        'application/x-msmediaview'
    ],
    [
        'mvt',
        'application/vnd.mapbox-vector-tile'
    ],
    [
        'mwf',
        'application/vnd.mfer'
    ],
    [
        'mxf',
        'application/mxf'
    ],
    [
        'mxl',
        'application/vnd.recordare.musicxml'
    ],
    [
        'mxmf',
        'audio/mobile-xmf'
    ],
    [
        'mxml',
        'application/xv+xml'
    ],
    [
        'mxs',
        'application/vnd.triscape.mxs'
    ],
    [
        'mxu',
        'video/vnd.mpegurl'
    ],
    [
        'n-gage',
        'application/vnd.nokia.n-gage.symbian.install'
    ],
    [
        'n3',
        'text/n3'
    ],
    [
        'nb',
        'application/mathematica'
    ],
    [
        'nbp',
        'application/vnd.wolfram.player'
    ],
    [
        'nc',
        'application/x-netcdf'
    ],
    [
        'ncx',
        'application/x-dtbncx+xml'
    ],
    [
        'nfo',
        'text/x-nfo'
    ],
    [
        'ngdat',
        'application/vnd.nokia.n-gage.data'
    ],
    [
        'nitf',
        'application/vnd.nitf'
    ],
    [
        'nlu',
        'application/vnd.neurolanguage.nlu'
    ],
    [
        'nml',
        'application/vnd.enliven'
    ],
    [
        'nnd',
        'application/vnd.noblenet-directory'
    ],
    [
        'nns',
        'application/vnd.noblenet-sealer'
    ],
    [
        'nnw',
        'application/vnd.noblenet-web'
    ],
    [
        'npx',
        'image/vnd.net-fpx'
    ],
    [
        'nq',
        'application/n-quads'
    ],
    [
        'nsc',
        'application/x-conference'
    ],
    [
        'nsf',
        'application/vnd.lotus-notes'
    ],
    [
        'nt',
        'application/n-triples'
    ],
    [
        'ntf',
        'application/vnd.nitf'
    ],
    [
        'numbers',
        'application/x-iwork-numbers-sffnumbers'
    ],
    [
        'nzb',
        'application/x-nzb'
    ],
    [
        'oa2',
        'application/vnd.fujitsu.oasys2'
    ],
    [
        'oa3',
        'application/vnd.fujitsu.oasys3'
    ],
    [
        'oas',
        'application/vnd.fujitsu.oasys'
    ],
    [
        'obd',
        'application/x-msbinder'
    ],
    [
        'obgx',
        'application/vnd.openblox.game+xml'
    ],
    [
        'obj',
        'model/obj'
    ],
    [
        'oda',
        'application/oda'
    ],
    [
        'odb',
        'application/vnd.oasis.opendocument.database'
    ],
    [
        'odc',
        'application/vnd.oasis.opendocument.chart'
    ],
    [
        'odf',
        'application/vnd.oasis.opendocument.formula'
    ],
    [
        'odft',
        'application/vnd.oasis.opendocument.formula-template'
    ],
    [
        'odg',
        'application/vnd.oasis.opendocument.graphics'
    ],
    [
        'odi',
        'application/vnd.oasis.opendocument.image'
    ],
    [
        'odm',
        'application/vnd.oasis.opendocument.text-master'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogex',
        'model/vnd.opengex'
    ],
    [
        'ogg',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'omdoc',
        'application/omdoc+xml'
    ],
    [
        'onepkg',
        'application/onenote'
    ],
    [
        'onetmp',
        'application/onenote'
    ],
    [
        'onetoc',
        'application/onenote'
    ],
    [
        'onetoc2',
        'application/onenote'
    ],
    [
        'opf',
        'application/oebps-package+xml'
    ],
    [
        'opml',
        'text/x-opml'
    ],
    [
        'oprc',
        'application/vnd.palm'
    ],
    [
        'opus',
        'audio/ogg'
    ],
    [
        'org',
        'text/x-org'
    ],
    [
        'osf',
        'application/vnd.yamaha.openscoreformat'
    ],
    [
        'osfpvg',
        'application/vnd.yamaha.openscoreformat.osfpvg+xml'
    ],
    [
        'osm',
        'application/vnd.openstreetmap.data+xml'
    ],
    [
        'otc',
        'application/vnd.oasis.opendocument.chart-template'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'otg',
        'application/vnd.oasis.opendocument.graphics-template'
    ],
    [
        'oth',
        'application/vnd.oasis.opendocument.text-web'
    ],
    [
        'oti',
        'application/vnd.oasis.opendocument.image-template'
    ],
    [
        'otp',
        'application/vnd.oasis.opendocument.presentation-template'
    ],
    [
        'ots',
        'application/vnd.oasis.opendocument.spreadsheet-template'
    ],
    [
        'ott',
        'application/vnd.oasis.opendocument.text-template'
    ],
    [
        'ova',
        'application/x-virtualbox-ova'
    ],
    [
        'ovf',
        'application/x-virtualbox-ovf'
    ],
    [
        'owl',
        'application/rdf+xml'
    ],
    [
        'oxps',
        'application/oxps'
    ],
    [
        'oxt',
        'application/vnd.openofficeorg.extension'
    ],
    [
        'p',
        'text/x-pascal'
    ],
    [
        'p7a',
        'application/x-pkcs7-signature'
    ],
    [
        'p7b',
        'application/x-pkcs7-certificates'
    ],
    [
        'p7c',
        'application/pkcs7-mime'
    ],
    [
        'p7m',
        'application/pkcs7-mime'
    ],
    [
        'p7r',
        'application/x-pkcs7-certreqresp'
    ],
    [
        'p7s',
        'application/pkcs7-signature'
    ],
    [
        'p8',
        'application/pkcs8'
    ],
    [
        'p10',
        'application/x-pkcs10'
    ],
    [
        'p12',
        'application/x-pkcs12'
    ],
    [
        'pac',
        'application/x-ns-proxy-autoconfig'
    ],
    [
        'pages',
        'application/x-iwork-pages-sffpages'
    ],
    [
        'pas',
        'text/x-pascal'
    ],
    [
        'paw',
        'application/vnd.pawaafile'
    ],
    [
        'pbd',
        'application/vnd.powerbuilder6'
    ],
    [
        'pbm',
        'image/x-portable-bitmap'
    ],
    [
        'pcap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'pcf',
        'application/x-font-pcf'
    ],
    [
        'pcl',
        'application/vnd.hp-pcl'
    ],
    [
        'pclxl',
        'application/vnd.hp-pclxl'
    ],
    [
        'pct',
        'image/x-pict'
    ],
    [
        'pcurl',
        'application/vnd.curl.pcurl'
    ],
    [
        'pcx',
        'image/x-pcx'
    ],
    [
        'pdb',
        'application/x-pilot'
    ],
    [
        'pde',
        'text/x-processing'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'pem',
        'application/x-x509-user-cert'
    ],
    [
        'pfa',
        'application/x-font-type1'
    ],
    [
        'pfb',
        'application/x-font-type1'
    ],
    [
        'pfm',
        'application/x-font-type1'
    ],
    [
        'pfr',
        'application/font-tdpfr'
    ],
    [
        'pfx',
        'application/x-pkcs12'
    ],
    [
        'pgm',
        'image/x-portable-graymap'
    ],
    [
        'pgn',
        'application/x-chess-pgn'
    ],
    [
        'pgp',
        'application/pgp'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'php3',
        'application/x-httpd-php'
    ],
    [
        'php4',
        'application/x-httpd-php'
    ],
    [
        'phps',
        'application/x-httpd-php-source'
    ],
    [
        'phtml',
        'application/x-httpd-php'
    ],
    [
        'pic',
        'image/x-pict'
    ],
    [
        'pkg',
        'application/octet-stream'
    ],
    [
        'pki',
        'application/pkixcmp'
    ],
    [
        'pkipath',
        'application/pkix-pkipath'
    ],
    [
        'pkpass',
        'application/vnd.apple.pkpass'
    ],
    [
        'pl',
        'application/x-perl'
    ],
    [
        'plb',
        'application/vnd.3gpp.pic-bw-large'
    ],
    [
        'plc',
        'application/vnd.mobius.plc'
    ],
    [
        'plf',
        'application/vnd.pocketlearn'
    ],
    [
        'pls',
        'application/pls+xml'
    ],
    [
        'pm',
        'application/x-perl'
    ],
    [
        'pml',
        'application/vnd.ctc-posml'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pnm',
        'image/x-portable-anymap'
    ],
    [
        'portpkg',
        'application/vnd.macports.portpkg'
    ],
    [
        'pot',
        'application/vnd.ms-powerpoint'
    ],
    [
        'potm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.template'
    ],
    [
        'ppa',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppam',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    ],
    [
        'ppd',
        'application/vnd.cups-ppd'
    ],
    [
        'ppm',
        'image/x-portable-pixmap'
    ],
    [
        'pps',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppsm',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    [
        'ppsx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    ],
    [
        'ppt',
        'application/powerpoint'
    ],
    [
        'pptm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'pqa',
        'application/vnd.palm'
    ],
    [
        'prc',
        'application/x-pilot'
    ],
    [
        'pre',
        'application/vnd.lotus-freelance'
    ],
    [
        'prf',
        'application/pics-rules'
    ],
    [
        'provx',
        'application/provenance+xml'
    ],
    [
        'ps',
        'application/postscript'
    ],
    [
        'psb',
        'application/vnd.3gpp.pic-bw-small'
    ],
    [
        'psd',
        'application/x-photoshop'
    ],
    [
        'psf',
        'application/x-font-linux-psf'
    ],
    [
        'pskcxml',
        'application/pskc+xml'
    ],
    [
        'pti',
        'image/prs.pti'
    ],
    [
        'ptid',
        'application/vnd.pvi.ptid1'
    ],
    [
        'pub',
        'application/x-mspublisher'
    ],
    [
        'pvb',
        'application/vnd.3gpp.pic-bw-var'
    ],
    [
        'pwn',
        'application/vnd.3m.post-it-notes'
    ],
    [
        'pya',
        'audio/vnd.ms-playready.media.pya'
    ],
    [
        'pyv',
        'video/vnd.ms-playready.media.pyv'
    ],
    [
        'qam',
        'application/vnd.epson.quickanime'
    ],
    [
        'qbo',
        'application/vnd.intu.qbo'
    ],
    [
        'qfx',
        'application/vnd.intu.qfx'
    ],
    [
        'qps',
        'application/vnd.publishare-delta-tree'
    ],
    [
        'qt',
        'video/quicktime'
    ],
    [
        'qwd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qwt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxb',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxl',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'ra',
        'audio/x-realaudio'
    ],
    [
        'ram',
        'audio/x-pn-realaudio'
    ],
    [
        'raml',
        'application/raml+yaml'
    ],
    [
        'rapd',
        'application/route-apd+xml'
    ],
    [
        'rar',
        'application/x-rar'
    ],
    [
        'ras',
        'image/x-cmu-raster'
    ],
    [
        'rcprofile',
        'application/vnd.ipunplugged.rcprofile'
    ],
    [
        'rdf',
        'application/rdf+xml'
    ],
    [
        'rdz',
        'application/vnd.data-vision.rdz'
    ],
    [
        'relo',
        'application/p2p-overlay+xml'
    ],
    [
        'rep',
        'application/vnd.businessobjects'
    ],
    [
        'res',
        'application/x-dtbresource+xml'
    ],
    [
        'rgb',
        'image/x-rgb'
    ],
    [
        'rif',
        'application/reginfo+xml'
    ],
    [
        'rip',
        'audio/vnd.rip'
    ],
    [
        'ris',
        'application/x-research-info-systems'
    ],
    [
        'rl',
        'application/resource-lists+xml'
    ],
    [
        'rlc',
        'image/vnd.fujixerox.edmics-rlc'
    ],
    [
        'rld',
        'application/resource-lists-diff+xml'
    ],
    [
        'rm',
        'audio/x-pn-realaudio'
    ],
    [
        'rmi',
        'audio/midi'
    ],
    [
        'rmp',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rms',
        'application/vnd.jcp.javame.midlet-rms'
    ],
    [
        'rmvb',
        'application/vnd.rn-realmedia-vbr'
    ],
    [
        'rnc',
        'application/relax-ng-compact-syntax'
    ],
    [
        'rng',
        'application/xml'
    ],
    [
        'roa',
        'application/rpki-roa'
    ],
    [
        'roff',
        'text/troff'
    ],
    [
        'rp9',
        'application/vnd.cloanto.rp9'
    ],
    [
        'rpm',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rpss',
        'application/vnd.nokia.radio-presets'
    ],
    [
        'rpst',
        'application/vnd.nokia.radio-preset'
    ],
    [
        'rq',
        'application/sparql-query'
    ],
    [
        'rs',
        'application/rls-services+xml'
    ],
    [
        'rsa',
        'application/x-pkcs7'
    ],
    [
        'rsat',
        'application/atsc-rsat+xml'
    ],
    [
        'rsd',
        'application/rsd+xml'
    ],
    [
        'rsheet',
        'application/urc-ressheet+xml'
    ],
    [
        'rss',
        'application/rss+xml'
    ],
    [
        'rtf',
        'text/rtf'
    ],
    [
        'rtx',
        'text/richtext'
    ],
    [
        'run',
        'application/x-makeself'
    ],
    [
        'rusd',
        'application/route-usd+xml'
    ],
    [
        'rv',
        'video/vnd.rn-realvideo'
    ],
    [
        's',
        'text/x-asm'
    ],
    [
        's3m',
        'audio/s3m'
    ],
    [
        'saf',
        'application/vnd.yamaha.smaf-audio'
    ],
    [
        'sass',
        'text/x-sass'
    ],
    [
        'sbml',
        'application/sbml+xml'
    ],
    [
        'sc',
        'application/vnd.ibm.secure-container'
    ],
    [
        'scd',
        'application/x-msschedule'
    ],
    [
        'scm',
        'application/vnd.lotus-screencam'
    ],
    [
        'scq',
        'application/scvp-cv-request'
    ],
    [
        'scs',
        'application/scvp-cv-response'
    ],
    [
        'scss',
        'text/x-scss'
    ],
    [
        'scurl',
        'text/vnd.curl.scurl'
    ],
    [
        'sda',
        'application/vnd.stardivision.draw'
    ],
    [
        'sdc',
        'application/vnd.stardivision.calc'
    ],
    [
        'sdd',
        'application/vnd.stardivision.impress'
    ],
    [
        'sdkd',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdkm',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdp',
        'application/sdp'
    ],
    [
        'sdw',
        'application/vnd.stardivision.writer'
    ],
    [
        'sea',
        'application/octet-stream'
    ],
    [
        'see',
        'application/vnd.seemail'
    ],
    [
        'seed',
        'application/vnd.fdsn.seed'
    ],
    [
        'sema',
        'application/vnd.sema'
    ],
    [
        'semd',
        'application/vnd.semd'
    ],
    [
        'semf',
        'application/vnd.semf'
    ],
    [
        'senmlx',
        'application/senml+xml'
    ],
    [
        'sensmlx',
        'application/sensml+xml'
    ],
    [
        'ser',
        'application/java-serialized-object'
    ],
    [
        'setpay',
        'application/set-payment-initiation'
    ],
    [
        'setreg',
        'application/set-registration-initiation'
    ],
    [
        'sfd-hdstx',
        'application/vnd.hydrostatix.sof-data'
    ],
    [
        'sfs',
        'application/vnd.spotfire.sfs'
    ],
    [
        'sfv',
        'text/x-sfv'
    ],
    [
        'sgi',
        'image/sgi'
    ],
    [
        'sgl',
        'application/vnd.stardivision.writer-global'
    ],
    [
        'sgm',
        'text/sgml'
    ],
    [
        'sgml',
        'text/sgml'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'shar',
        'application/x-shar'
    ],
    [
        'shex',
        'text/shex'
    ],
    [
        'shf',
        'application/shf+xml'
    ],
    [
        'shtml',
        'text/html'
    ],
    [
        'sid',
        'image/x-mrsid-image'
    ],
    [
        'sieve',
        'application/sieve'
    ],
    [
        'sig',
        'application/pgp-signature'
    ],
    [
        'sil',
        'audio/silk'
    ],
    [
        'silo',
        'model/mesh'
    ],
    [
        'sis',
        'application/vnd.symbian.install'
    ],
    [
        'sisx',
        'application/vnd.symbian.install'
    ],
    [
        'sit',
        'application/x-stuffit'
    ],
    [
        'sitx',
        'application/x-stuffitx'
    ],
    [
        'siv',
        'application/sieve'
    ],
    [
        'skd',
        'application/vnd.koan'
    ],
    [
        'skm',
        'application/vnd.koan'
    ],
    [
        'skp',
        'application/vnd.koan'
    ],
    [
        'skt',
        'application/vnd.koan'
    ],
    [
        'sldm',
        'application/vnd.ms-powerpoint.slide.macroenabled.12'
    ],
    [
        'sldx',
        'application/vnd.openxmlformats-officedocument.presentationml.slide'
    ],
    [
        'slim',
        'text/slim'
    ],
    [
        'slm',
        'text/slim'
    ],
    [
        'sls',
        'application/route-s-tsid+xml'
    ],
    [
        'slt',
        'application/vnd.epson.salt'
    ],
    [
        'sm',
        'application/vnd.stepmania.stepchart'
    ],
    [
        'smf',
        'application/vnd.stardivision.math'
    ],
    [
        'smi',
        'application/smil'
    ],
    [
        'smil',
        'application/smil'
    ],
    [
        'smv',
        'video/x-smv'
    ],
    [
        'smzip',
        'application/vnd.stepmania.package'
    ],
    [
        'snd',
        'audio/basic'
    ],
    [
        'snf',
        'application/x-font-snf'
    ],
    [
        'so',
        'application/octet-stream'
    ],
    [
        'spc',
        'application/x-pkcs7-certificates'
    ],
    [
        'spdx',
        'text/spdx'
    ],
    [
        'spf',
        'application/vnd.yamaha.smaf-phrase'
    ],
    [
        'spl',
        'application/x-futuresplash'
    ],
    [
        'spot',
        'text/vnd.in3d.spot'
    ],
    [
        'spp',
        'application/scvp-vp-response'
    ],
    [
        'spq',
        'application/scvp-vp-request'
    ],
    [
        'spx',
        'audio/ogg'
    ],
    [
        'sql',
        'application/x-sql'
    ],
    [
        'src',
        'application/x-wais-source'
    ],
    [
        'srt',
        'application/x-subrip'
    ],
    [
        'sru',
        'application/sru+xml'
    ],
    [
        'srx',
        'application/sparql-results+xml'
    ],
    [
        'ssdl',
        'application/ssdl+xml'
    ],
    [
        'sse',
        'application/vnd.kodak-descriptor'
    ],
    [
        'ssf',
        'application/vnd.epson.ssf'
    ],
    [
        'ssml',
        'application/ssml+xml'
    ],
    [
        'sst',
        'application/octet-stream'
    ],
    [
        'st',
        'application/vnd.sailingtracker.track'
    ],
    [
        'stc',
        'application/vnd.sun.xml.calc.template'
    ],
    [
        'std',
        'application/vnd.sun.xml.draw.template'
    ],
    [
        'stf',
        'application/vnd.wt.stf'
    ],
    [
        'sti',
        'application/vnd.sun.xml.impress.template'
    ],
    [
        'stk',
        'application/hyperstudio'
    ],
    [
        'stl',
        'model/stl'
    ],
    [
        'stpx',
        'model/step+xml'
    ],
    [
        'stpxz',
        'model/step-xml+zip'
    ],
    [
        'stpz',
        'model/step+zip'
    ],
    [
        'str',
        'application/vnd.pg.format'
    ],
    [
        'stw',
        'application/vnd.sun.xml.writer.template'
    ],
    [
        'styl',
        'text/stylus'
    ],
    [
        'stylus',
        'text/stylus'
    ],
    [
        'sub',
        'text/vnd.dvb.subtitle'
    ],
    [
        'sus',
        'application/vnd.sus-calendar'
    ],
    [
        'susp',
        'application/vnd.sus-calendar'
    ],
    [
        'sv4cpio',
        'application/x-sv4cpio'
    ],
    [
        'sv4crc',
        'application/x-sv4crc'
    ],
    [
        'svc',
        'application/vnd.dvb.service'
    ],
    [
        'svd',
        'application/vnd.svd'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'svgz',
        'image/svg+xml'
    ],
    [
        'swa',
        'application/x-director'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'swi',
        'application/vnd.aristanetworks.swi'
    ],
    [
        'swidtag',
        'application/swid+xml'
    ],
    [
        'sxc',
        'application/vnd.sun.xml.calc'
    ],
    [
        'sxd',
        'application/vnd.sun.xml.draw'
    ],
    [
        'sxg',
        'application/vnd.sun.xml.writer.global'
    ],
    [
        'sxi',
        'application/vnd.sun.xml.impress'
    ],
    [
        'sxm',
        'application/vnd.sun.xml.math'
    ],
    [
        'sxw',
        'application/vnd.sun.xml.writer'
    ],
    [
        't',
        'text/troff'
    ],
    [
        't3',
        'application/x-t3vm-image'
    ],
    [
        't38',
        'image/t38'
    ],
    [
        'taglet',
        'application/vnd.mynfc'
    ],
    [
        'tao',
        'application/vnd.tao.intent-module-archive'
    ],
    [
        'tap',
        'image/vnd.tencent.tap'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tcap',
        'application/vnd.3gpp2.tcap'
    ],
    [
        'tcl',
        'application/x-tcl'
    ],
    [
        'td',
        'application/urc-targetdesc+xml'
    ],
    [
        'teacher',
        'application/vnd.smart.teacher'
    ],
    [
        'tei',
        'application/tei+xml'
    ],
    [
        'teicorpus',
        'application/tei+xml'
    ],
    [
        'tex',
        'application/x-tex'
    ],
    [
        'texi',
        'application/x-texinfo'
    ],
    [
        'texinfo',
        'application/x-texinfo'
    ],
    [
        'text',
        'text/plain'
    ],
    [
        'tfi',
        'application/thraud+xml'
    ],
    [
        'tfm',
        'application/x-tex-tfm'
    ],
    [
        'tfx',
        'image/tiff-fx'
    ],
    [
        'tga',
        'image/x-tga'
    ],
    [
        'tgz',
        'application/x-tar'
    ],
    [
        'thmx',
        'application/vnd.ms-officetheme'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'tk',
        'application/x-tcl'
    ],
    [
        'tmo',
        'application/vnd.tmobile-livetv'
    ],
    [
        'toml',
        'application/toml'
    ],
    [
        'torrent',
        'application/x-bittorrent'
    ],
    [
        'tpl',
        'application/vnd.groove-tool-template'
    ],
    [
        'tpt',
        'application/vnd.trid.tpt'
    ],
    [
        'tr',
        'text/troff'
    ],
    [
        'tra',
        'application/vnd.trueapp'
    ],
    [
        'trig',
        'application/trig'
    ],
    [
        'trm',
        'application/x-msterminal'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'tsd',
        'application/timestamped-data'
    ],
    [
        'tsv',
        'text/tab-separated-values'
    ],
    [
        'ttc',
        'font/collection'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'ttl',
        'text/turtle'
    ],
    [
        'ttml',
        'application/ttml+xml'
    ],
    [
        'twd',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'twds',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'txd',
        'application/vnd.genomatix.tuxedo'
    ],
    [
        'txf',
        'application/vnd.mobius.txf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'u8dsn',
        'message/global-delivery-status'
    ],
    [
        'u8hdr',
        'message/global-headers'
    ],
    [
        'u8mdn',
        'message/global-disposition-notification'
    ],
    [
        'u8msg',
        'message/global'
    ],
    [
        'u32',
        'application/x-authorware-bin'
    ],
    [
        'ubj',
        'application/ubjson'
    ],
    [
        'udeb',
        'application/x-debian-package'
    ],
    [
        'ufd',
        'application/vnd.ufdl'
    ],
    [
        'ufdl',
        'application/vnd.ufdl'
    ],
    [
        'ulx',
        'application/x-glulx'
    ],
    [
        'umj',
        'application/vnd.umajin'
    ],
    [
        'unityweb',
        'application/vnd.unity'
    ],
    [
        'uoml',
        'application/vnd.uoml+xml'
    ],
    [
        'uri',
        'text/uri-list'
    ],
    [
        'uris',
        'text/uri-list'
    ],
    [
        'urls',
        'text/uri-list'
    ],
    [
        'usdz',
        'model/vnd.usdz+zip'
    ],
    [
        'ustar',
        'application/x-ustar'
    ],
    [
        'utz',
        'application/vnd.uiq.theme'
    ],
    [
        'uu',
        'text/x-uuencode'
    ],
    [
        'uva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvd',
        'application/vnd.dece.data'
    ],
    [
        'uvf',
        'application/vnd.dece.data'
    ],
    [
        'uvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvv',
        'video/vnd.dece.video'
    ],
    [
        'uvva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvvd',
        'application/vnd.dece.data'
    ],
    [
        'uvvf',
        'application/vnd.dece.data'
    ],
    [
        'uvvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvvv',
        'video/vnd.dece.video'
    ],
    [
        'uvvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvvz',
        'application/vnd.dece.zip'
    ],
    [
        'uvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvz',
        'application/vnd.dece.zip'
    ],
    [
        'vbox',
        'application/x-virtualbox-vbox'
    ],
    [
        'vbox-extpack',
        'application/x-virtualbox-vbox-extpack'
    ],
    [
        'vcard',
        'text/vcard'
    ],
    [
        'vcd',
        'application/x-cdlink'
    ],
    [
        'vcf',
        'text/x-vcard'
    ],
    [
        'vcg',
        'application/vnd.groove-vcard'
    ],
    [
        'vcs',
        'text/x-vcalendar'
    ],
    [
        'vcx',
        'application/vnd.vcx'
    ],
    [
        'vdi',
        'application/x-virtualbox-vdi'
    ],
    [
        'vds',
        'model/vnd.sap.vds'
    ],
    [
        'vhd',
        'application/x-virtualbox-vhd'
    ],
    [
        'vis',
        'application/vnd.visionary'
    ],
    [
        'viv',
        'video/vnd.vivo'
    ],
    [
        'vlc',
        'application/videolan'
    ],
    [
        'vmdk',
        'application/x-virtualbox-vmdk'
    ],
    [
        'vob',
        'video/x-ms-vob'
    ],
    [
        'vor',
        'application/vnd.stardivision.writer'
    ],
    [
        'vox',
        'application/x-authorware-bin'
    ],
    [
        'vrml',
        'model/vrml'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'vsf',
        'application/vnd.vsf'
    ],
    [
        'vss',
        'application/vnd.visio'
    ],
    [
        'vst',
        'application/vnd.visio'
    ],
    [
        'vsw',
        'application/vnd.visio'
    ],
    [
        'vtf',
        'image/vnd.valve.source.texture'
    ],
    [
        'vtt',
        'text/vtt'
    ],
    [
        'vtu',
        'model/vnd.vtu'
    ],
    [
        'vxml',
        'application/voicexml+xml'
    ],
    [
        'w3d',
        'application/x-director'
    ],
    [
        'wad',
        'application/x-doom'
    ],
    [
        'wadl',
        'application/vnd.sun.wadl+xml'
    ],
    [
        'war',
        'application/java-archive'
    ],
    [
        'wasm',
        'application/wasm'
    ],
    [
        'wav',
        'audio/x-wav'
    ],
    [
        'wax',
        'audio/x-ms-wax'
    ],
    [
        'wbmp',
        'image/vnd.wap.wbmp'
    ],
    [
        'wbs',
        'application/vnd.criticaltools.wbs+xml'
    ],
    [
        'wbxml',
        'application/wbxml'
    ],
    [
        'wcm',
        'application/vnd.ms-works'
    ],
    [
        'wdb',
        'application/vnd.ms-works'
    ],
    [
        'wdp',
        'image/vnd.ms-photo'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webapp',
        'application/x-web-app-manifest+json'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webmanifest',
        'application/manifest+json'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'wg',
        'application/vnd.pmi.widget'
    ],
    [
        'wgt',
        'application/widget'
    ],
    [
        'wks',
        'application/vnd.ms-works'
    ],
    [
        'wm',
        'video/x-ms-wm'
    ],
    [
        'wma',
        'audio/x-ms-wma'
    ],
    [
        'wmd',
        'application/x-ms-wmd'
    ],
    [
        'wmf',
        'image/wmf'
    ],
    [
        'wml',
        'text/vnd.wap.wml'
    ],
    [
        'wmlc',
        'application/wmlc'
    ],
    [
        'wmls',
        'text/vnd.wap.wmlscript'
    ],
    [
        'wmlsc',
        'application/vnd.wap.wmlscriptc'
    ],
    [
        'wmv',
        'video/x-ms-wmv'
    ],
    [
        'wmx',
        'video/x-ms-wmx'
    ],
    [
        'wmz',
        'application/x-msmetafile'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'word',
        'application/msword'
    ],
    [
        'wpd',
        'application/vnd.wordperfect'
    ],
    [
        'wpl',
        'application/vnd.ms-wpl'
    ],
    [
        'wps',
        'application/vnd.ms-works'
    ],
    [
        'wqd',
        'application/vnd.wqd'
    ],
    [
        'wri',
        'application/x-mswrite'
    ],
    [
        'wrl',
        'model/vrml'
    ],
    [
        'wsc',
        'message/vnd.wfa.wsc'
    ],
    [
        'wsdl',
        'application/wsdl+xml'
    ],
    [
        'wspolicy',
        'application/wspolicy+xml'
    ],
    [
        'wtb',
        'application/vnd.webturbo'
    ],
    [
        'wvx',
        'video/x-ms-wvx'
    ],
    [
        'x3d',
        'model/x3d+xml'
    ],
    [
        'x3db',
        'model/x3d+fastinfoset'
    ],
    [
        'x3dbz',
        'model/x3d+binary'
    ],
    [
        'x3dv',
        'model/x3d-vrml'
    ],
    [
        'x3dvz',
        'model/x3d+vrml'
    ],
    [
        'x3dz',
        'model/x3d+xml'
    ],
    [
        'x32',
        'application/x-authorware-bin'
    ],
    [
        'x_b',
        'model/vnd.parasolid.transmit.binary'
    ],
    [
        'x_t',
        'model/vnd.parasolid.transmit.text'
    ],
    [
        'xaml',
        'application/xaml+xml'
    ],
    [
        'xap',
        'application/x-silverlight-app'
    ],
    [
        'xar',
        'application/vnd.xara'
    ],
    [
        'xav',
        'application/xcap-att+xml'
    ],
    [
        'xbap',
        'application/x-ms-xbap'
    ],
    [
        'xbd',
        'application/vnd.fujixerox.docuworks.binder'
    ],
    [
        'xbm',
        'image/x-xbitmap'
    ],
    [
        'xca',
        'application/xcap-caps+xml'
    ],
    [
        'xcs',
        'application/calendar+xml'
    ],
    [
        'xdf',
        'application/xcap-diff+xml'
    ],
    [
        'xdm',
        'application/vnd.syncml.dm+xml'
    ],
    [
        'xdp',
        'application/vnd.adobe.xdp+xml'
    ],
    [
        'xdssc',
        'application/dssc+xml'
    ],
    [
        'xdw',
        'application/vnd.fujixerox.docuworks'
    ],
    [
        'xel',
        'application/xcap-el+xml'
    ],
    [
        'xenc',
        'application/xenc+xml'
    ],
    [
        'xer',
        'application/patch-ops-error+xml'
    ],
    [
        'xfdf',
        'application/vnd.adobe.xfdf'
    ],
    [
        'xfdl',
        'application/vnd.xfdl'
    ],
    [
        'xht',
        'application/xhtml+xml'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xhvml',
        'application/xv+xml'
    ],
    [
        'xif',
        'image/vnd.xiff'
    ],
    [
        'xl',
        'application/excel'
    ],
    [
        'xla',
        'application/vnd.ms-excel'
    ],
    [
        'xlam',
        'application/vnd.ms-excel.addin.macroEnabled.12'
    ],
    [
        'xlc',
        'application/vnd.ms-excel'
    ],
    [
        'xlf',
        'application/xliff+xml'
    ],
    [
        'xlm',
        'application/vnd.ms-excel'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsb',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    [
        'xlsm',
        'application/vnd.ms-excel.sheet.macroEnabled.12'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xlt',
        'application/vnd.ms-excel'
    ],
    [
        'xltm',
        'application/vnd.ms-excel.template.macroEnabled.12'
    ],
    [
        'xltx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    ],
    [
        'xlw',
        'application/vnd.ms-excel'
    ],
    [
        'xm',
        'audio/xm'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xns',
        'application/xcap-ns+xml'
    ],
    [
        'xo',
        'application/vnd.olpc-sugar'
    ],
    [
        'xop',
        'application/xop+xml'
    ],
    [
        'xpi',
        'application/x-xpinstall'
    ],
    [
        'xpl',
        'application/xproc+xml'
    ],
    [
        'xpm',
        'image/x-xpixmap'
    ],
    [
        'xpr',
        'application/vnd.is-xpr'
    ],
    [
        'xps',
        'application/vnd.ms-xpsdocument'
    ],
    [
        'xpw',
        'application/vnd.intercon.formnet'
    ],
    [
        'xpx',
        'application/vnd.intercon.formnet'
    ],
    [
        'xsd',
        'application/xml'
    ],
    [
        'xsl',
        'application/xml'
    ],
    [
        'xslt',
        'application/xslt+xml'
    ],
    [
        'xsm',
        'application/vnd.syncml+xml'
    ],
    [
        'xspf',
        'application/xspf+xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'xvm',
        'application/xv+xml'
    ],
    [
        'xvml',
        'application/xv+xml'
    ],
    [
        'xwd',
        'image/x-xwindowdump'
    ],
    [
        'xyz',
        'chemical/x-xyz'
    ],
    [
        'xz',
        'application/x-xz'
    ],
    [
        'yaml',
        'text/yaml'
    ],
    [
        'yang',
        'application/yang'
    ],
    [
        'yin',
        'application/yin+xml'
    ],
    [
        'yml',
        'text/yaml'
    ],
    [
        'ymp',
        'text/x-suse-ymp'
    ],
    [
        'z',
        'application/x-compress'
    ],
    [
        'z1',
        'application/x-zmachine'
    ],
    [
        'z2',
        'application/x-zmachine'
    ],
    [
        'z3',
        'application/x-zmachine'
    ],
    [
        'z4',
        'application/x-zmachine'
    ],
    [
        'z5',
        'application/x-zmachine'
    ],
    [
        'z6',
        'application/x-zmachine'
    ],
    [
        'z7',
        'application/x-zmachine'
    ],
    [
        'z8',
        'application/x-zmachine'
    ],
    [
        'zaz',
        'application/vnd.zzazz.deck+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'zir',
        'application/vnd.zul'
    ],
    [
        'zirz',
        'application/vnd.zul'
    ],
    [
        'zmm',
        'application/vnd.handheld-entertainment+xml'
    ],
    [
        'zsh',
        'text/x-scriptzsh'
    ]
]);
function $0c417c97818a47bb$export$8cc09085015f0dc7(file, path, h) {
    const f = $0c417c97818a47bb$var$withMimeType(file);
    const { webkitRelativePath: webkitRelativePath } = file;
    const p = typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== 'string') $0c417c97818a47bb$var$setObjProp(f, 'path', p);
    if (h !== undefined) Object.defineProperty(f, 'handle', {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    $0c417c97818a47bb$var$setObjProp(f, 'relativePath', p);
    return f;
}
function $0c417c97818a47bb$var$withMimeType(file) {
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.').pop().toLowerCase();
        const type = $0c417c97818a47bb$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function $0c417c97818a47bb$var$setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value: value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}

});



parcelRegister("eEukq", function(module, exports) {

$parcel$export(module.exports, "TOO_MANY_FILES_REJECTION", () => $aaac53b849ab07d4$export$1e1e1b6120329fe);
$parcel$export(module.exports, "fileAccepted", () => $aaac53b849ab07d4$export$b511db3632effe58);
$parcel$export(module.exports, "fileMatchSize", () => $aaac53b849ab07d4$export$860631d45ba43fd9);
$parcel$export(module.exports, "allFilesAccepted", () => $aaac53b849ab07d4$export$6a0bb4322c81a197);
$parcel$export(module.exports, "isPropagationStopped", () => $aaac53b849ab07d4$export$8d6d6472146de265);
$parcel$export(module.exports, "isEvtWithFiles", () => $aaac53b849ab07d4$export$52f1fc875a1e5986);
$parcel$export(module.exports, "onDocumentDragOver", () => $aaac53b849ab07d4$export$2ead263d6635cecc);
$parcel$export(module.exports, "isIeOrEdge", () => $aaac53b849ab07d4$export$d3498e653911f962);
$parcel$export(module.exports, "composeEventHandlers", () => $aaac53b849ab07d4$export$b9ecd428b558ff10);
$parcel$export(module.exports, "canUseFileSystemAccessAPI", () => $aaac53b849ab07d4$export$858af2af50e1eaf8);
$parcel$export(module.exports, "pickerOptionsFromAccept", () => $aaac53b849ab07d4$export$8ce4bd13c494743e);
$parcel$export(module.exports, "acceptPropAsAcceptAttr", () => $aaac53b849ab07d4$export$1278288bcefb97b9);
$parcel$export(module.exports, "isAbort", () => $aaac53b849ab07d4$export$72580c77a176a18f);
$parcel$export(module.exports, "isSecurityError", () => $aaac53b849ab07d4$export$c4f82d4432e209a9);

var $0dzo3 = parcelRequire("0dzo3");
function $aaac53b849ab07d4$var$_toConsumableArray(arr) {
    return $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) || $aaac53b849ab07d4$var$_iterableToArray(arr) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr) || $aaac53b849ab07d4$var$_nonIterableSpread();
}
function $aaac53b849ab07d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aaac53b849ab07d4$var$_arrayLikeToArray(arr);
}
function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$var$accepts = typeof (0, $0dzo3.default) === "function" ? (0, $0dzo3.default) : (0, $0dzo3.default).default; // Error codes
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
};
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(msg)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
};
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || $aaac53b849ab07d4$var$accepts(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$8ce4bd13c494743e(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $aaac53b849ab07d4$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$aaac53b849ab07d4$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($aaac53b849ab07d4$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $aaac53b849ab07d4$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, agg), {}, $aaac53b849ab07d4$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $aaac53b849ab07d4$export$1278288bcefb97b9(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $aaac53b849ab07d4$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($aaac53b849ab07d4$var$_toConsumableArray(a), [
            mimeType
        ], $aaac53b849ab07d4$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) || $aaac53b849ab07d4$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $aaac53b849ab07d4$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 

});
parcelRegister("0dzo3", function(module, exports) {

$parcel$export(module.exports, "default", () => $000a86df99a95c54$export$2e2bcd8739ae039, (v) => $000a86df99a95c54$export$2e2bcd8739ae039 = v);
var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};

});





parcelRegister("3Tv1e", function(module, exports) {

$parcel$export(module.exports, "ButtonUploadImage", () => $9ee6d33a30e4e9c8$export$60b5b6598a8d44be);

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");

var $acw62 = parcelRequire("acw62");

var $YOQGa = parcelRequire("YOQGa");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");
const $9ee6d33a30e4e9c8$export$60b5b6598a8d44be = ({ label: label, onLoad: onLoad })=>{
    const [loading, setLoading] = $acw62.useState(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
            size: "small",
            variant: "contained",
            component: "label",
            children: [
                label,
                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    type: "file",
                    hidden: true,
                    accept: "image/*",
                    onChange: async (evt)=>{
                        setLoading(true);
                        const file = evt.target.files[0];
                        if (file) try {
                            const compressedDataUri = await (0, $YOQGa.compressImageWithFallback)(file);
                            setLoading(false);
                            onLoad(compressedDataUri);
                        } catch (error) {
                            console.error("Image compression failed:", error);
                            setLoading(false);
                        }
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MV2p.default), {
                    open: loading,
                    onClose: ()=>setLoading(false),
                    fullScreen: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {
                        message: "Compressing image. This will take a few seconds."
                    })
                })
            ]
        })
    });
};

});

parcelRegister("jk25Q", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e111824352d45a40$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e111824352d45a40$var$_createSvgIcon = $e111824352d45a40$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e111824352d45a40$var$_default = module.exports.default = (0, $e111824352d45a40$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6m6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26"
}), 'Autorenew');

});

parcelRegister("2xNsq", function(module, exports) {
module.exports = Promise.all([
    import("k1JeB"),
    import("Rt9Vu"),
    import("9AiJE"),
    import("ctROh"),
    import("5DuyH")
]).then(()=>parcelRequire('2xsb1'));

});

parcelRegister("g7iKU", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("jPru3")),
    import("ioJXq"),
    import("a9547"),
    import("2n7e5"),
    import("lQcGU"),
    import("bcI4Q")
]).then(()=>parcelRequire('kQTz7'));

});
parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("jqPLh", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("7OiKz")),
    import("ioJXq"),
    import("a9547"),
    import("2n7e5"),
    import("lQcGU"),
    import("91zGq")
]).then(()=>parcelRequire('kY55G'));

});


var $ayMG0 = parcelRequire("ayMG0");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $8b320f2fc2c0171c$export$2e2bcd8739ae039(s) {
    console.warn('[react-ga]', s);
}


function $d2aa88a99758251b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d2aa88a99758251b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d2aa88a99758251b$var$_typeof(obj);
}
var $d2aa88a99758251b$var$_excluded = [
    "to",
    "target"
];
function $d2aa88a99758251b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d2aa88a99758251b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d2aa88a99758251b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d2aa88a99758251b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d2aa88a99758251b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d2aa88a99758251b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d2aa88a99758251b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d2aa88a99758251b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d2aa88a99758251b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d2aa88a99758251b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d2aa88a99758251b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d2aa88a99758251b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d2aa88a99758251b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d2aa88a99758251b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d2aa88a99758251b$var$_setPrototypeOf(subClass, superClass);
}
function $d2aa88a99758251b$var$_setPrototypeOf(o, p) {
    $d2aa88a99758251b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d2aa88a99758251b$var$_setPrototypeOf(o, p);
}
function $d2aa88a99758251b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d2aa88a99758251b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d2aa88a99758251b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d2aa88a99758251b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d2aa88a99758251b$var$_possibleConstructorReturn(this, result);
    };
}
function $d2aa88a99758251b$var$_possibleConstructorReturn(self, call) {
    if (call && ($d2aa88a99758251b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d2aa88a99758251b$var$_assertThisInitialized(self);
}
function $d2aa88a99758251b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d2aa88a99758251b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d2aa88a99758251b$var$_getPrototypeOf(o) {
    $d2aa88a99758251b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d2aa88a99758251b$var$_getPrototypeOf(o);
}
function $d2aa88a99758251b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d2aa88a99758251b$var$NEWTAB = '_blank';
var $d2aa88a99758251b$var$MIDDLECLICK = 1;
var $d2aa88a99758251b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    $d2aa88a99758251b$var$_inherits(OutboundLink, _Component);
    var _super = $d2aa88a99758251b$var$_createSuper(OutboundLink);
    function OutboundLink() {
        var _this;
        $d2aa88a99758251b$var$_classCallCheck(this, OutboundLink);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d2aa88a99758251b$var$_defineProperty($d2aa88a99758251b$var$_assertThisInitialized(_this), "handleClick", function(event) {
            var _this$props = _this.props, target = _this$props.target, eventLabel = _this$props.eventLabel, to = _this$props.to, onClick = _this$props.onClick, trackerNames = _this$props.trackerNames;
            var eventMeta = {
                label: eventLabel
            };
            var sameTarget = target !== $d2aa88a99758251b$var$NEWTAB;
            var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === $d2aa88a99758251b$var$MIDDLECLICK);
            if (sameTarget && normalClick) {
                event.preventDefault();
                OutboundLink.trackLink(eventMeta, function() {
                    window.location.href = to;
                }, trackerNames);
            } else OutboundLink.trackLink(eventMeta, function() {}, trackerNames);
            if (onClick) onClick(event);
        });
        return _this;
    }
    $d2aa88a99758251b$var$_createClass(OutboundLink, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, href = _this$props2.to, target = _this$props2.target, oldProps = $d2aa88a99758251b$var$_objectWithoutProperties(_this$props2, $d2aa88a99758251b$var$_excluded);
                var props = $d2aa88a99758251b$var$_objectSpread($d2aa88a99758251b$var$_objectSpread({}, oldProps), {}, {
                    target: target,
                    href: href,
                    onClick: this.handleClick
                });
                if (target === $d2aa88a99758251b$var$NEWTAB) props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
                delete props.eventLabel;
                delete props.trackerNames;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('a', props);
            }
        }
    ]);
    return OutboundLink;
}((0, $acw62.Component));
$d2aa88a99758251b$var$_defineProperty($d2aa88a99758251b$export$2e2bcd8739ae039, "trackLink", function() {
    (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('ga tracking not enabled');
});
$d2aa88a99758251b$export$2e2bcd8739ae039.propTypes = {
    eventLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    trackerNames: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
};
$d2aa88a99758251b$export$2e2bcd8739ae039.defaultProps = {
    target: null,
    to: null,
    onClick: null,
    trackerNames: null
};


var $aa0c8b5cb706df9d$exports = {};

$parcel$defineInteropFlag($aa0c8b5cb706df9d$exports);

$parcel$export($aa0c8b5cb706df9d$exports, "addTrackers", () => $aa0c8b5cb706df9d$export$f6195261cffd8234);
$parcel$export($aa0c8b5cb706df9d$exports, "initialize", () => $aa0c8b5cb706df9d$export$2a47f398eeff8b01);
$parcel$export($aa0c8b5cb706df9d$exports, "ga", () => $aa0c8b5cb706df9d$export$298dfd455d823e81);
$parcel$export($aa0c8b5cb706df9d$exports, "set", () => $aa0c8b5cb706df9d$export$adaa4cf7ef1b65be);
$parcel$export($aa0c8b5cb706df9d$exports, "send", () => $aa0c8b5cb706df9d$export$89db4734f6c919c4);
$parcel$export($aa0c8b5cb706df9d$exports, "pageview", () => $aa0c8b5cb706df9d$export$b81f1580747d8b3a);
$parcel$export($aa0c8b5cb706df9d$exports, "modalview", () => $aa0c8b5cb706df9d$export$7d8fb59896ec60b6);
$parcel$export($aa0c8b5cb706df9d$exports, "timing", () => $aa0c8b5cb706df9d$export$edfe6c349c815521);
$parcel$export($aa0c8b5cb706df9d$exports, "event", () => $aa0c8b5cb706df9d$export$6cd530ed55e06764);
$parcel$export($aa0c8b5cb706df9d$exports, "exception", () => $aa0c8b5cb706df9d$export$788a307bb494601);
$parcel$export($aa0c8b5cb706df9d$exports, "plugin", () => $aa0c8b5cb706df9d$export$ca524d3785e2543);
$parcel$export($aa0c8b5cb706df9d$exports, "outboundLink", () => $aa0c8b5cb706df9d$export$db5a0739dc2fd70d);
$parcel$export($aa0c8b5cb706df9d$exports, "testModeAPI", () => $aa0c8b5cb706df9d$export$5ce97d6af069b36);
$parcel$export($aa0c8b5cb706df9d$exports, "default", () => $aa0c8b5cb706df9d$export$2e2bcd8739ae039);

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $b774be3b8f19021c$export$2e2bcd8739ae039(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === 'string' && s.indexOf('@') !== -1;
}


var $cc3d8e52e34cac96$var$redacted = 'REDACTED (Potential Email Address)';
function $cc3d8e52e34cac96$export$2e2bcd8739ae039(string) {
    if ((0, $b774be3b8f19021c$export$2e2bcd8739ae039)(string)) {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('This arg looks like an email address, redacting.');
        return $cc3d8e52e34cac96$var$redacted;
    }
    return string;
}


/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */ // GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function $4188b31481f56268$export$2e2bcd8739ae039(s) {
    return s && s.toString().replace(/^\s+|\s+$/g, '');
}


var $1ef92d9ef5a92fc0$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test
function $1ef92d9ef5a92fc0$export$2e2bcd8739ae039(string) {
    return (0, $4188b31481f56268$export$2e2bcd8739ae039)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($1ef92d9ef5a92fc0$var$smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}


function $8f9082d1ac386b85$export$2e2bcd8739ae039() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || '';
    if (titleCase) _str = (0, $1ef92d9ef5a92fc0$export$2e2bcd8739ae039)(s);
    if (redactingEmail) _str = (0, $cc3d8e52e34cac96$export$2e2bcd8739ae039)(_str);
    return _str;
}


function $730a9736f63ea36d$export$2e2bcd8739ae039(string) {
    if (string.substring(0, 1) === '/') return string.substring(1);
    return string;
}



var $298ce0a2c767a039$var$isLoaded = false;
function $298ce0a2c767a039$export$2e2bcd8739ae039(options) {
    if ($298ce0a2c767a039$var$isLoaded) return;
    $298ce0a2c767a039$var$isLoaded = true;
    var gaAddress = 'https://www.google-analytics.com/analytics.js';
    if (options && options.gaAddress) gaAddress = options.gaAddress;
    else if (options && options.debug) gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
    var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/
    /* eslint-disable */ (function(i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function() {
            (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        a.onerror = onerror;
        m.parentNode.insertBefore(a, m);
    })(window, document, 'script', gaAddress, 'ga');
/* eslint-enable */ }



function $d4a26e689cfb7518$export$2e2bcd8739ae039(s) {
    console.info('[react-ga]', s);
}


var $d62aa03ea723b5ac$export$9b5f317161046a80 = [];
var $d62aa03ea723b5ac$export$2e2bcd8739ae039 = {
    calls: $d62aa03ea723b5ac$export$9b5f317161046a80,
    ga: function ga() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        $d62aa03ea723b5ac$export$9b5f317161046a80.push([].concat(args));
    },
    resetCalls: function resetCalls() {
        $d62aa03ea723b5ac$export$9b5f317161046a80.length = 0;
    }
};


var $aa0c8b5cb706df9d$var$_excluded = [
    "category",
    "action",
    "label",
    "value",
    "nonInteraction",
    "transport"
];
function $aa0c8b5cb706df9d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $aa0c8b5cb706df9d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $aa0c8b5cb706df9d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $aa0c8b5cb706df9d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa0c8b5cb706df9d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aa0c8b5cb706df9d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aa0c8b5cb706df9d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aa0c8b5cb706df9d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aa0c8b5cb706df9d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aa0c8b5cb706df9d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aa0c8b5cb706df9d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aa0c8b5cb706df9d$var$_typeof(obj);
}
function $aa0c8b5cb706df9d$var$_toConsumableArray(arr) {
    return $aa0c8b5cb706df9d$var$_arrayWithoutHoles(arr) || $aa0c8b5cb706df9d$var$_iterableToArray(arr) || $aa0c8b5cb706df9d$var$_unsupportedIterableToArray(arr) || $aa0c8b5cb706df9d$var$_nonIterableSpread();
}
function $aa0c8b5cb706df9d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aa0c8b5cb706df9d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aa0c8b5cb706df9d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aa0c8b5cb706df9d$var$_arrayLikeToArray(o, minLen);
}
function $aa0c8b5cb706df9d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aa0c8b5cb706df9d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aa0c8b5cb706df9d$var$_arrayLikeToArray(arr);
}
function $aa0c8b5cb706df9d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $aa0c8b5cb706df9d$var$_isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
var $aa0c8b5cb706df9d$var$_debug = false;
var $aa0c8b5cb706df9d$var$_titleCase = true;
var $aa0c8b5cb706df9d$var$_testMode = false;
var $aa0c8b5cb706df9d$var$_alwaysSendToDefaultTracker = true;
var $aa0c8b5cb706df9d$var$_redactEmail = true;
var $aa0c8b5cb706df9d$var$internalGa = function internalGa() {
    var _window;
    if ($aa0c8b5cb706df9d$var$_testMode) return (0, $d62aa03ea723b5ac$export$2e2bcd8739ae039).ga.apply((0, $d62aa03ea723b5ac$export$2e2bcd8739ae039), arguments);
    if ($aa0c8b5cb706df9d$var$_isNotBrowser) return false;
    if (!window.ga) return (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
    return (_window = window).ga.apply(_window, arguments);
};
function $aa0c8b5cb706df9d$var$_format(s) {
    return (0, $8f9082d1ac386b85$export$2e2bcd8739ae039)(s, $aa0c8b5cb706df9d$var$_titleCase, $aa0c8b5cb706df9d$var$_redactEmail);
}
function $aa0c8b5cb706df9d$var$_gaCommand(trackerNames) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var command = args[0];
    if (typeof $aa0c8b5cb706df9d$var$internalGa === 'function') {
        if (typeof command !== 'string') {
            (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('ga command must be a string');
            return;
        }
        if ($aa0c8b5cb706df9d$var$_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) $aa0c8b5cb706df9d$var$internalGa.apply(void 0, args);
        if (Array.isArray(trackerNames)) trackerNames.forEach(function(name) {
            $aa0c8b5cb706df9d$var$internalGa.apply(void 0, $aa0c8b5cb706df9d$var$_toConsumableArray([
                "".concat(name, ".").concat(command)
            ].concat(args.slice(1))));
        });
    }
}
function $aa0c8b5cb706df9d$var$_initialize(gaTrackingID, options) {
    if (!gaTrackingID) {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('gaTrackingID is required in initialize()');
        return;
    }
    if (options) {
        if (options.debug && options.debug === true) $aa0c8b5cb706df9d$var$_debug = true;
        if (options.titleCase === false) $aa0c8b5cb706df9d$var$_titleCase = false;
        if (options.redactEmail === false) $aa0c8b5cb706df9d$var$_redactEmail = false;
        if (options.useExistingGa) return;
    }
    if (options && options.gaOptions) $aa0c8b5cb706df9d$var$internalGa('create', gaTrackingID, options.gaOptions);
    else $aa0c8b5cb706df9d$var$internalGa('create', gaTrackingID, 'auto');
}
function $aa0c8b5cb706df9d$export$f6195261cffd8234(configsOrTrackingId, options) {
    if (Array.isArray(configsOrTrackingId)) configsOrTrackingId.forEach(function(config) {
        if ($aa0c8b5cb706df9d$var$_typeof(config) !== 'object') {
            (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('All configs must be an object');
            return;
        }
        $aa0c8b5cb706df9d$var$_initialize(config.trackingId, config);
    });
    else $aa0c8b5cb706df9d$var$_initialize(configsOrTrackingId, options);
    return true;
}
function $aa0c8b5cb706df9d$export$2a47f398eeff8b01(configsOrTrackingId, options) {
    if (options && options.testMode === true) $aa0c8b5cb706df9d$var$_testMode = true;
    else {
        if ($aa0c8b5cb706df9d$var$_isNotBrowser) return;
        if (!options || options.standardImplementation !== true) (0, $298ce0a2c767a039$export$2e2bcd8739ae039)(options);
    }
    $aa0c8b5cb706df9d$var$_alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
    $aa0c8b5cb706df9d$export$f6195261cffd8234(configsOrTrackingId, options);
}
function $aa0c8b5cb706df9d$export$298dfd455d823e81() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (args.length > 0) {
        $aa0c8b5cb706df9d$var$internalGa.apply(void 0, args);
        if ($aa0c8b5cb706df9d$var$_debug) {
            (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('arguments');");
            (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("with arguments: ".concat(JSON.stringify(args)));
        }
    }
    return window.ga;
}
function $aa0c8b5cb706df9d$export$adaa4cf7ef1b65be(fieldsObject, trackerNames) {
    if (!fieldsObject) {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('`fieldsObject` is required in .set()');
        return;
    }
    if ($aa0c8b5cb706df9d$var$_typeof(fieldsObject) !== 'object') {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('Expected `fieldsObject` arg to be an Object');
        return;
    }
    if (Object.keys(fieldsObject).length === 0) (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('empty `fieldsObject` given to .set()');
    $aa0c8b5cb706df9d$var$_gaCommand(trackerNames, 'set', fieldsObject);
    if ($aa0c8b5cb706df9d$var$_debug) {
        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('set', fieldsObject);");
        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
    }
}
function $aa0c8b5cb706df9d$export$89db4734f6c919c4(fieldObject, trackerNames) {
    $aa0c8b5cb706df9d$var$_gaCommand(trackerNames, 'send', fieldObject);
    if ($aa0c8b5cb706df9d$var$_debug) {
        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('send', fieldObject);");
        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("with fieldObject: ".concat(JSON.stringify(fieldObject)));
        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("with trackers: ".concat(JSON.stringify(trackerNames)));
    }
}
function $aa0c8b5cb706df9d$export$b81f1580747d8b3a(rawPath, trackerNames, title) {
    if (!rawPath) {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('path is required in .pageview()');
        return;
    }
    var path = (0, $4188b31481f56268$export$2e2bcd8739ae039)(rawPath);
    if (path === '') {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('path cannot be an empty string in .pageview()');
        return;
    }
    var extraFields = {};
    if (title) extraFields.title = title;
    if (typeof $aa0c8b5cb706df9d$export$298dfd455d823e81 === 'function') {
        $aa0c8b5cb706df9d$var$_gaCommand(trackerNames, 'send', $aa0c8b5cb706df9d$var$_objectSpread({
            hitType: 'pageview',
            page: path
        }, extraFields));
        if ($aa0c8b5cb706df9d$var$_debug) {
            (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('send', 'pageview', path);");
            var extraLog = '';
            if (title) extraLog = " and title: ".concat(title);
            (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("with path: ".concat(path).concat(extraLog));
        }
    }
}
function $aa0c8b5cb706df9d$export$7d8fb59896ec60b6(rawModalName, trackerNames) {
    if (!rawModalName) {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('modalName is required in .modalview(modalName)');
        return;
    }
    var modalName = (0, $730a9736f63ea36d$export$2e2bcd8739ae039)((0, $4188b31481f56268$export$2e2bcd8739ae039)(rawModalName));
    if (modalName === '') {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('modalName cannot be an empty string or a single / in .modalview()');
        return;
    }
    if (typeof $aa0c8b5cb706df9d$export$298dfd455d823e81 === 'function') {
        var path = "/modal/".concat(modalName);
        $aa0c8b5cb706df9d$var$_gaCommand(trackerNames, 'send', 'pageview', path);
        if ($aa0c8b5cb706df9d$var$_debug) {
            (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('send', 'pageview', path);");
            (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("with path: ".concat(path));
        }
    }
}
function $aa0c8b5cb706df9d$export$edfe6c349c815521() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, category = _ref.category, variable = _ref.variable, value = _ref.value, label = _ref.label;
    var trackerNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (typeof $aa0c8b5cb706df9d$export$298dfd455d823e81 === 'function') {
        if (!category || !variable || typeof value !== 'number') {
            (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)("args.category, args.variable AND args.value are required in timing() AND args.value has to be a number");
            return;
        } // Required Fields
        var fieldObject = {
            hitType: 'timing',
            timingCategory: $aa0c8b5cb706df9d$var$_format(category),
            timingVar: $aa0c8b5cb706df9d$var$_format(variable),
            timingValue: value
        };
        if (label) fieldObject.timingLabel = $aa0c8b5cb706df9d$var$_format(label);
        $aa0c8b5cb706df9d$export$89db4734f6c919c4(fieldObject, trackerNames);
    }
}
function $aa0c8b5cb706df9d$export$6cd530ed55e06764() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, category = _ref2.category, action = _ref2.action, label = _ref2.label, value = _ref2.value, nonInteraction = _ref2.nonInteraction, transport = _ref2.transport, args = $aa0c8b5cb706df9d$var$_objectWithoutProperties(_ref2, $aa0c8b5cb706df9d$var$_excluded);
    var trackerNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (typeof $aa0c8b5cb706df9d$export$298dfd455d823e81 === 'function') {
        // Simple Validation
        if (!category || !action) {
            (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('args.category AND args.action are required in event()');
            return;
        } // Required Fields
        var fieldObject = {
            hitType: 'event',
            eventCategory: $aa0c8b5cb706df9d$var$_format(category),
            eventAction: $aa0c8b5cb706df9d$var$_format(action)
        }; // Optional Fields
        if (label) fieldObject.eventLabel = $aa0c8b5cb706df9d$var$_format(label);
        if (typeof value !== 'undefined') {
            if (typeof value !== 'number') (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('Expected `args.value` arg to be a Number.');
            else fieldObject.eventValue = value;
        }
        if (typeof nonInteraction !== 'undefined') {
            if (typeof nonInteraction !== 'boolean') (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('`args.nonInteraction` must be a boolean.');
            else fieldObject.nonInteraction = nonInteraction;
        }
        if (typeof transport !== 'undefined') {
            if (typeof transport !== 'string') (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('`args.transport` must be a string.');
            else {
                if ([
                    'beacon',
                    'xhr',
                    'image'
                ].indexOf(transport) === -1) (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
                fieldObject.transport = transport;
            }
        }
        Object.keys(args).filter(function(key) {
            return key.substr(0, 9) === 'dimension';
        }).forEach(function(key) {
            fieldObject[key] = args[key];
        });
        Object.keys(args).filter(function(key) {
            return key.substr(0, 6) === 'metric';
        }).forEach(function(key) {
            fieldObject[key] = args[key];
        }); // Send to GA
        $aa0c8b5cb706df9d$export$89db4734f6c919c4(fieldObject, trackerNames);
    }
}
function $aa0c8b5cb706df9d$export$788a307bb494601(_ref3, trackerNames) {
    var description = _ref3.description, fatal = _ref3.fatal;
    if (typeof $aa0c8b5cb706df9d$export$298dfd455d823e81 === 'function') {
        // Required Fields
        var fieldObject = {
            hitType: 'exception'
        }; // Optional Fields
        if (description) fieldObject.exDescription = $aa0c8b5cb706df9d$var$_format(description);
        if (typeof fatal !== 'undefined') {
            if (typeof fatal !== 'boolean') (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('`args.fatal` must be a boolean.');
            else fieldObject.exFatal = fatal;
        } // Send to GA
        $aa0c8b5cb706df9d$export$89db4734f6c919c4(fieldObject, trackerNames);
    }
}
var $aa0c8b5cb706df9d$export$ca524d3785e2543 = {
    /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */ require: function require(rawName, options, trackerName) {
        if (typeof $aa0c8b5cb706df9d$export$298dfd455d823e81 === 'function') {
            // Required Fields
            if (!rawName) {
                (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('`name` is required in .require()');
                return;
            }
            var name = (0, $4188b31481f56268$export$2e2bcd8739ae039)(rawName);
            if (name === '') {
                (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('`name` cannot be an empty string in .require()');
                return;
            }
            var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
            if (options) {
                if ($aa0c8b5cb706df9d$var$_typeof(options) !== 'object') {
                    (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('Expected `options` arg to be an Object');
                    return;
                }
                if (Object.keys(options).length === 0) (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('Empty `options` given to .require()');
                $aa0c8b5cb706df9d$export$298dfd455d823e81(requireString, name, options);
                if ($aa0c8b5cb706df9d$var$_debug) (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
            } else {
                $aa0c8b5cb706df9d$export$298dfd455d823e81(requireString, name);
                if ($aa0c8b5cb706df9d$var$_debug) (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('require', '".concat(name, "');"));
            }
        }
    },
    /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */ execute: function execute(pluginName, action) {
        var payload;
        var actionType;
        for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
        if (args.length === 1) payload = args[0];
        else {
            actionType = args[0];
            payload = args[1];
        }
        if (typeof $aa0c8b5cb706df9d$export$298dfd455d823e81 === 'function') {
            if (typeof pluginName !== 'string') (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('Expected `pluginName` arg to be a String.');
            else if (typeof action !== 'string') (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('Expected `action` arg to be a String.');
            else {
                var command = "".concat(pluginName, ":").concat(action);
                payload = payload || null;
                if (actionType && payload) {
                    $aa0c8b5cb706df9d$export$298dfd455d823e81(command, actionType, payload);
                    if ($aa0c8b5cb706df9d$var$_debug) {
                        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('".concat(command, "');"));
                        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
                    }
                } else if (payload) {
                    $aa0c8b5cb706df9d$export$298dfd455d823e81(command, payload);
                    if ($aa0c8b5cb706df9d$var$_debug) {
                        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('".concat(command, "');"));
                        (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("with payload: ".concat(JSON.stringify(payload)));
                    }
                } else {
                    $aa0c8b5cb706df9d$export$298dfd455d823e81(command);
                    if ($aa0c8b5cb706df9d$var$_debug) (0, $d4a26e689cfb7518$export$2e2bcd8739ae039)("called ga('".concat(command, "');"));
                }
            }
        }
    }
};
function $aa0c8b5cb706df9d$export$db5a0739dc2fd70d(args, hitCallback, trackerNames) {
    if (typeof hitCallback !== 'function') {
        (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('hitCallback function is required');
        return;
    }
    if (typeof $aa0c8b5cb706df9d$export$298dfd455d823e81 === 'function') {
        // Simple Validation
        if (!args || !args.label) {
            (0, $8b320f2fc2c0171c$export$2e2bcd8739ae039)('args.label is required in outboundLink()');
            return;
        } // Required Fields
        var fieldObject = {
            hitType: 'event',
            eventCategory: 'Outbound',
            eventAction: 'Click',
            eventLabel: $aa0c8b5cb706df9d$var$_format(args.label)
        };
        var safetyCallbackCalled = false;
        var safetyCallback = function safetyCallback() {
            // This prevents a delayed response from GA
            // causing hitCallback from being fired twice
            safetyCallbackCalled = true;
            hitCallback();
        }; // Using a timeout to ensure the execution of critical application code
        // in the case when the GA server might be down
        // or an ad blocker prevents sending the data
        // register safety net timeout:
        var t = setTimeout(safetyCallback, 250);
        var clearableCallbackForGA = function clearableCallbackForGA() {
            clearTimeout(t);
            if (!safetyCallbackCalled) hitCallback();
        };
        fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
        $aa0c8b5cb706df9d$export$89db4734f6c919c4(fieldObject, trackerNames);
    } else // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
}
var $aa0c8b5cb706df9d$export$5ce97d6af069b36 = (0, $d62aa03ea723b5ac$export$2e2bcd8739ae039);
var $aa0c8b5cb706df9d$export$2e2bcd8739ae039 = {
    initialize: $aa0c8b5cb706df9d$export$2a47f398eeff8b01,
    ga: $aa0c8b5cb706df9d$export$298dfd455d823e81,
    set: $aa0c8b5cb706df9d$export$adaa4cf7ef1b65be,
    send: $aa0c8b5cb706df9d$export$89db4734f6c919c4,
    pageview: $aa0c8b5cb706df9d$export$b81f1580747d8b3a,
    modalview: $aa0c8b5cb706df9d$export$7d8fb59896ec60b6,
    timing: $aa0c8b5cb706df9d$export$edfe6c349c815521,
    event: $aa0c8b5cb706df9d$export$6cd530ed55e06764,
    exception: $aa0c8b5cb706df9d$export$788a307bb494601,
    plugin: $aa0c8b5cb706df9d$export$ca524d3785e2543,
    outboundLink: $aa0c8b5cb706df9d$export$db5a0739dc2fd70d,
    testModeAPI: (0, $d62aa03ea723b5ac$export$2e2bcd8739ae039)
};


function $748332cc4d70356f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $748332cc4d70356f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $748332cc4d70356f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $748332cc4d70356f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $748332cc4d70356f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $748332cc4d70356f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $748332cc4d70356f$export$2a47f398eeff8b01 = $aa0c8b5cb706df9d$exports.initialize;
var $748332cc4d70356f$export$f6195261cffd8234 = $aa0c8b5cb706df9d$exports.addTrackers;
var $748332cc4d70356f$export$298dfd455d823e81 = $aa0c8b5cb706df9d$exports.ga;
var $748332cc4d70356f$export$adaa4cf7ef1b65be = $aa0c8b5cb706df9d$exports.set;
var $748332cc4d70356f$export$89db4734f6c919c4 = $aa0c8b5cb706df9d$exports.send;
var $748332cc4d70356f$export$b81f1580747d8b3a = $aa0c8b5cb706df9d$exports.pageview;
var $748332cc4d70356f$export$7d8fb59896ec60b6 = $aa0c8b5cb706df9d$exports.modalview;
var $748332cc4d70356f$export$edfe6c349c815521 = $aa0c8b5cb706df9d$exports.timing;
var $748332cc4d70356f$export$6cd530ed55e06764 = $aa0c8b5cb706df9d$exports.event;
var $748332cc4d70356f$export$788a307bb494601 = $aa0c8b5cb706df9d$exports.exception;
var $748332cc4d70356f$export$ca524d3785e2543 = $aa0c8b5cb706df9d$exports.plugin;
var $748332cc4d70356f$export$db5a0739dc2fd70d = $aa0c8b5cb706df9d$exports.outboundLink;
var $748332cc4d70356f$export$5ce97d6af069b36 = $aa0c8b5cb706df9d$exports.testModeAPI;
(0, $d2aa88a99758251b$export$2e2bcd8739ae039).origTrackLink = (0, $d2aa88a99758251b$export$2e2bcd8739ae039).trackLink;
(0, $d2aa88a99758251b$export$2e2bcd8739ae039).trackLink = $aa0c8b5cb706df9d$exports.outboundLink;
var $748332cc4d70356f$export$8d333529301affdf = (0, $d2aa88a99758251b$export$2e2bcd8739ae039);
var $748332cc4d70356f$export$2e2bcd8739ae039 = $748332cc4d70356f$var$_objectSpread($748332cc4d70356f$var$_objectSpread({}, $aa0c8b5cb706df9d$exports), {}, {
    OutboundLink: $748332cc4d70356f$export$8d333529301affdf
});



var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");
parcelRequire("7R9OT");
var $gKzpB = parcelRequire("gKzpB");
const $a24a5d3e9cf90620$export$39e6b45630afbd62 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    // Setup Mixpanel session tracking when FBO or user changes
    $acw62.useEffect(()=>{
        if (activeFBO?.id && airplxIdentity?.userid && postgrest) (0, $gKzpB.setupSessionTracking)(postgrest, airplxIdentity.userid, activeFBO.id);
    }, [
        activeFBO?.id,
        airplxIdentity?.userid,
        postgrest
    ]);
};


const $2cc8a8b916a220b3$export$f1e582dddb502dd6 = ({ children: children })=>{
    // Enable session tracking
    (0, $a24a5d3e9cf90620$export$39e6b45630afbd62)();
    // This component doesn't render anything visible, just enables tracking
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
};



var $ZD2ym = parcelRequire("ZD2ym");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $1bIpT = parcelRequire("1bIpT");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $0dd289201de31a3a$var$SafeIframe = ({ iframeHtml: iframeHtml })=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(iframeHtml, 'text/html');
    const iframe = doc.querySelector('iframe');
    if (!iframe) return null;
    const src = iframe.getAttribute('src');
    if (!src || !src.includes('youtube.com/embed/')) return null;
    // Safely extract title attribute
    const title = iframe.getAttribute('title') || 'YouTube video player';
    return /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
        src: src,
        width: "100%",
        height: "400",
        frameBorder: "0",
        allowFullScreen: true,
        sandbox: "allow-scripts allow-same-origin",
        title: title
    });
};
var $0dd289201de31a3a$export$2e2bcd8739ae039 = $0dd289201de31a3a$var$SafeIframe;


const $f13dd908c366a257$var$AnnouncementContent = ({ announcement: announcement })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                children: announcement.body
            }),
            announcement.action_link && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                variant: "contained",
                href: announcement.action_link,
                target: "_blank",
                rel: "noopener noreferrer",
                fullWidth: true,
                sx: {
                    backgroundColor: '#1976d2',
                    '&:hover': {
                        backgroundColor: '#1565c0'
                    },
                    animation: 'pulse 2s ease-in-out infinite',
                    '@keyframes pulse': {
                        '0%, 100%': {
                            transform: 'scale(1)',
                            boxShadow: '0 0 0 0 rgba(25, 118, 210, 0.7)'
                        },
                        '50%': {
                            transform: 'scale(1.02)',
                            boxShadow: '0 0 20px 0 rgba(25, 118, 210, 0.4)'
                        }
                    }
                },
                children: announcement.action_link_text || 'Learn More'
            }),
            announcement.video_url && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0dd289201de31a3a$export$2e2bcd8739ae039), {
                iframeHtml: announcement.video_url
            }),
            announcement.image_url && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    my: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: announcement.image_url,
                    alt: announcement.title,
                    style: {
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                        borderRadius: '8px'
                    }
                })
            })
        ]
    });
const $f13dd908c366a257$export$c89dc6aba6e9473c = ({ enabled: enabled = true, children: children })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { isLoggedIn: isLoggedIn } = (0, $gqehT.useIdentity)();
    const [activeAnnouncement, setActiveAnnouncement] = $acw62.useState(null);
    const [seenAnnouncements, setSeenAnnouncements] = (0, $1bIpT.default)("airplx/seen-announcements", {}, {
        raw: false,
        serializer: (value)=>JSON.stringify(value),
        deserializer: (value)=>JSON.parse(value)
    });
    $acw62.useEffect(()=>{
        if (!enabled || !isLoggedIn || !postgrest) return;
        const fetchAnnouncements = async ()=>{
            try {
                const { data: data, error: error } = await postgrest.rpc("get_active_announcements");
                if (error) {
                    // Don't log authentication errors or 404s as they're expected during initial load
                    if (error.code !== 'PGRST301' && !error.message?.includes('JWT')) console.warn("Announcements API error:", error.message || error);
                    return;
                }
                // Since we now only get the most recent active announcement
                const activeAnn = data && data.length > 0 ? data[0] : null;
                // Show the active announcement if it hasn't been seen
                if (activeAnn && !seenAnnouncements[activeAnn.id]) setActiveAnnouncement(activeAnn);
            } catch (error) {
                // Only log unexpected errors
                if (error instanceof Error && !error.message?.includes('JWT') && !error.message?.includes('401')) console.warn("Unexpected error fetching announcements:", error.message);
            }
        };
        fetchAnnouncements();
    }, [
        enabled,
        isLoggedIn,
        postgrest
    ]);
    const handleClose = ()=>{
        if (activeAnnouncement) {
            setSeenAnnouncements({
                ...seenAnnouncements,
                [activeAnnouncement.id]: true
            });
            setActiveAnnouncement(null);
        }
    };
    if (!enabled || !activeAnnouncement) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: !!activeAnnouncement,
                onClose: handleClose,
                maxWidth: "sm",
                fullWidth: true,
                PaperProps: {
                    sx: {
                        maxHeight: '85vh'
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: activeAnnouncement.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($f13dd908c366a257$var$AnnouncementContent, {
                            announcement: activeAnnouncement
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            onClick: handleClose,
                            children: "Got it!"
                        })
                    })
                ]
            })
        ]
    });
};



var $2LXej = parcelRequire("2LXej");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ay9Yf = parcelRequire("ay9Yf");
const $ed5cb7861d4e005d$var$useDraggableAircraftContainerState = ()=>{
    const [placementIdBeingDragged, setPlacementIdBeingDragged] = $acw62.useState("");
    return {
        isTugging: (id)=>id === placementIdBeingDragged,
        setIsTugging: (id)=>setPlacementIdBeingDragged(id)
    };
};
const $ed5cb7861d4e005d$var$DraggableAircraftContainerState = (0, $ay9Yf.createContainer)($ed5cb7861d4e005d$var$useDraggableAircraftContainerState);
const $ed5cb7861d4e005d$export$ff2f3c5abb77cb90 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ed5cb7861d4e005d$var$DraggableAircraftContainerState.Provider, {
        children: children
    });
};
const $ed5cb7861d4e005d$export$24adf6947a0a1573 = $ed5cb7861d4e005d$var$DraggableAircraftContainerState.useContainer;



var $4o1tI = parcelRequire("4o1tI");

var $4ckAs = parcelRequire("4ckAs");

var $gqehT = parcelRequire("gqehT");

var $89b86 = parcelRequire("89b86");

var $js9Xf = parcelRequire("js9Xf");

var $6fDLr = parcelRequire("6fDLr");

var $g5N8Q = parcelRequire("g5N8Q");

var $fC0pb = parcelRequire("fC0pb");
/**
 * Redirect Manager
 *
 * Manages redirect URLs for post-authentication flows.
 * Used to remember where users intended to go before being redirected to login/verification.
 */ const $2a8b7cbac056e639$var$REDIRECT_KEY = 'airplx/redirect_after_auth';
function $2a8b7cbac056e639$export$7d08b3bdc73d1dd3(url) {
    if (url && url !== '#/login' && url !== '#/signup' && url !== '#/verify-email') localStorage.setItem($2a8b7cbac056e639$var$REDIRECT_KEY, url);
}
function $2a8b7cbac056e639$export$3776b0afb4f2473f() {
    const url = localStorage.getItem($2a8b7cbac056e639$var$REDIRECT_KEY);
    if (url) {
        localStorage.removeItem($2a8b7cbac056e639$var$REDIRECT_KEY);
        return url;
    }
    return null;
}
function $2a8b7cbac056e639$export$93832c3affb240d3(defaultUrl = '/') {
    const storedUrl = $2a8b7cbac056e639$export$3776b0afb4f2473f();
    if (storedUrl) // Remove leading hash if present (React Router will add it)
    return storedUrl.startsWith('#') ? storedUrl.substring(1) : storedUrl;
    return defaultUrl;
}
function $2a8b7cbac056e639$export$c91fe789cc037634() {
    localStorage.removeItem($2a8b7cbac056e639$var$REDIRECT_KEY);
}




var $ayMG0 = parcelRequire("ayMG0");

var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $ayMG0 = parcelRequire("ayMG0");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $lNEp2 = parcelRequire("lNEp2");

var $d7VTV = parcelRequire("d7VTV");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
parcelRequire("acw62");
const $35fe38f43861017f$export$96094fb98cfeffc8 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        p: 4,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                variant: "text",
                width: 200,
                height: 40
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                justifyContent: "space-around",
                alignItems: "flex-start",
                maxWidth: "100%",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        p: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                variant: "text",
                                width: 100,
                                height: 32
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                width: 600,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "column",
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "column",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                            variant: "text",
                                                            width: 120,
                                                            height: 24
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                            variant: "circular",
                                                            width: 20,
                                                            height: 20
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                            variant: "rectangular",
                                                            width: 375,
                                                            height: 56,
                                                            sx: {
                                                                borderRadius: 1,
                                                                animation: "pulse 1.5s ease-in-out 0.5s infinite"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "column",
                                                            alignItems: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "text",
                                                                    width: 100,
                                                                    height: 24
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "text",
                                                                    width: 80,
                                                                    height: 24
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "column",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                            variant: "text",
                                                            width: 80,
                                                            height: 24
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                            variant: "circular",
                                                            width: 20,
                                                            height: 20
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                    variant: "rectangular",
                                                    width: 125,
                                                    height: 56,
                                                    sx: {
                                                        borderRadius: 1,
                                                        animation: "pulse 1.5s ease-in-out 0.6s infinite"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "column",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 2,
                                                    alignItems: "flex-end",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "column",
                                                            spacing: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                    direction: "row",
                                                                    spacing: 1,
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                            variant: "text",
                                                                            width: 140,
                                                                            height: 24
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                            variant: "circular",
                                                                            width: 20,
                                                                            height: 20
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "rectangular",
                                                                    width: 200,
                                                                    height: 56,
                                                                    sx: {
                                                                        borderRadius: 1,
                                                                        animation: "pulse 1.5s ease-in-out 0.7s infinite"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "column",
                                                            spacing: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                    direction: "row",
                                                                    spacing: 1,
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                            variant: "text",
                                                                            width: 120,
                                                                            height: 24
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                            variant: "circular",
                                                                            width: 20,
                                                                            height: 20
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "rectangular",
                                                                    width: 200,
                                                                    height: 56,
                                                                    sx: {
                                                                        borderRadius: 1,
                                                                        animation: "pulse 1.5s ease-in-out 0.8s infinite"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "column",
                                                            spacing: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                    direction: "row",
                                                                    spacing: 1,
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                            variant: "text",
                                                                            width: 80,
                                                                            height: 24
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                            variant: "circular",
                                                                            width: 20,
                                                                            height: 20
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "rectangular",
                                                                    width: 225,
                                                                    height: 56,
                                                                    sx: {
                                                                        borderRadius: 1,
                                                                        animation: "pulse 1.5s ease-in-out 0.9s infinite"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "column",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            spacing: 1,
                                                            alignItems: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "text",
                                                                    width: 220,
                                                                    height: 24
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "circular",
                                                                    width: 20,
                                                                    height: 20
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                            direction: "row",
                                                            spacing: 2,
                                                            alignItems: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "rectangular",
                                                                    width: 120,
                                                                    height: 56,
                                                                    sx: {
                                                                        borderRadius: 1,
                                                                        animation: "pulse 1.5s ease-in-out 1.0s infinite"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "text",
                                                                    width: 30,
                                                                    height: 24
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "rectangular",
                                                                    width: 140,
                                                                    height: 56,
                                                                    sx: {
                                                                        borderRadius: 1,
                                                                        animation: "pulse 1.5s ease-in-out 1.1s infinite"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        orientation: "vertical",
                        flexItem: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        width: 600,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            p: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 120,
                                    height: 32
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            variant: "rectangular",
                                            width: 180,
                                            height: 48,
                                            sx: {
                                                borderRadius: 1,
                                                animation: "pulse 1.5s ease-in-out 0.5s infinite"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            variant: "rectangular",
                                            width: 120,
                                            height: 48,
                                            sx: {
                                                borderRadius: 1,
                                                animation: "pulse 1.5s ease-in-out 0.6s infinite"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        mt: 2
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                spacing: 1,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        variant: "text",
                                                                        width: 150,
                                                                        height: 24
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        variant: "circular",
                                                                        width: 20,
                                                                        height: 20
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                spacing: 1,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        variant: "text",
                                                                        width: 150,
                                                                        height: 24
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        variant: "circular",
                                                                        width: 20,
                                                                        height: 20
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                variant: "text",
                                                                width: 80,
                                                                height: 24
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                variant: "text",
                                                                width: 80,
                                                                height: 24
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        mt: 4
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                variant: "text",
                                                                width: 40,
                                                                height: 24
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                variant: "text",
                                                                width: 100,
                                                                height: 24
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                variant: "text",
                                                                width: 80,
                                                                height: 24
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                variant: "text",
                                                                width: 120,
                                                                height: 24,
                                                                sx: {
                                                                    animation: "pulse 1.5s ease-in-out 0.7s infinite"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                                children: [
                                                    ...Array(2)
                                                ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "text",
                                                                    width: 120,
                                                                    height: 24
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "text",
                                                                    width: 80,
                                                                    height: 24
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "text",
                                                                    width: 80,
                                                                    height: 24
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                    variant: "text",
                                                                    width: 100,
                                                                    height: 24,
                                                                    sx: {
                                                                        animation: "pulse 1.5s ease-in-out 0.8s infinite"
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }, `fee-row-${index}`))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



var $eScwB = parcelRequire("eScwB");
const $5a6af46e412e838f$export$be48ee98142e31c2 = ({ defaultMonthlyRate: defaultMonthlyRate, defaultDailyRate: defaultDailyRate })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO, setFBO: setFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [aircraft, setAircaft] = $acw62.useState(null);
    const [bufferRaw, setBuffer] = $acw62.useState(activeFBO?.settings?.defaultBuffer || 0);
    const buffer = bufferRaw || 0;
    const [monthlyRate, setMonthlyRate] = $acw62.useState((0, $cLNZr.round)(defaultMonthlyRate ?? 0, 3));
    const [dailyRate, setDailyRate] = $acw62.useState((0, $cLNZr.round)(defaultDailyRate ?? 0, 3));
    const [cam, setCam] = $acw62.useState(activeFBO?.settings?.defaultCAM || 0);
    const [camPerSqft, setCamPerSqft] = $acw62.useState(activeFBO?.settings?.defaultCAMPerSqft || 0);
    const { loading: loading, value: availableRates } = (0, $2NPdf.default)(async ()=>{
        const { data: alternativeRates } = await postgrest.from("rates").select("*");
        const rates = [];
        rates.push({
            id: "default",
            fbo_id: activeFBO.id,
            label: "Default",
            monthly_rate: activeFBO.nightly_base_rate * 30,
            nightly_rate: activeFBO.nightly_transient_rate,
            created_at: new Date().toISOString()
        });
        rates.push(...alternativeRates);
        return rates;
    }, []);
    const formatUnit = (value, squared)=>{
        if (activeFBO?.settings?.useMetricSystem) {
            if (squared) return `${(0, $lNEp2.formatNumber)((0, $d7VTV.squareFeetToSquareMeters)(value), 2)} m\xb2`;
            return (0, $lNEp2.formatNumber)((0, $d7VTV.feetToMeters)(value), 2);
        }
        if (squared) return `${(0, $lNEp2.formatNumber)(value, 0)} ft\xb2`;
        return (0, $lNEp2.formatNumber)(value, 0);
    };
    const aircraftSqftValue = aircraft ? aircraft.length * aircraft.wingspan : 0;
    const aircraftSqft = aircraft ? formatUnit(aircraftSqftValue, true) : "---";
    const aircraftSqftWithBufferValue = aircraft ? (2 * buffer + aircraft.length) * (2 * buffer + aircraft.wingspan) : 0;
    const aircraftSqftWithBuffer = aircraft ? formatUnit(aircraftSqftWithBufferValue, true) : "---";
    const baseDailyTenantDisplayValue = !aircraft || !dailyRate ? "---" : (0, $lNEp2.formatCurrency)(dailyRate * aircraft.length * aircraft.wingspan, 2);
    const dailyTenantDisplayValue = !aircraft || !dailyRate ? "---" : (0, $lNEp2.formatCurrency)(dailyRate * (2 * buffer + aircraft.length) * (2 * buffer + aircraft.wingspan), 2);
    const baseMonthlyTenantValue = monthlyRate * aircraft?.length * aircraft?.wingspan;
    const baseMonthlyTenantDisplayValue = !aircraft || !monthlyRate ? "---" : (0, $lNEp2.formatCurrency)(baseMonthlyTenantValue, 2);
    const monthlyTenantValue = monthlyRate * (2 * buffer + aircraft?.length) * (2 * buffer + aircraft?.wingspan);
    let monthlyTenantValueWithCAM = monthlyRate * (2 * buffer + aircraft?.length) * (2 * buffer + aircraft?.wingspan);
    if (cam) monthlyTenantValueWithCAM += monthlyTenantValue * (cam / 100);
    else if (camPerSqft) monthlyTenantValueWithCAM += camPerSqft * ((2 * buffer + aircraft?.length) * (2 * buffer + aircraft?.wingspan));
    let dailyCamFees = 0;
    let monthlyCamFees = 0;
    if (cam) {
        dailyCamFees = dailyRate * (2 * buffer + aircraft?.length) * (2 * buffer + aircraft?.wingspan) * cam / 100;
        monthlyCamFees = monthlyRate * (2 * buffer + aircraft?.length) * (2 * buffer + aircraft?.wingspan) * (cam / 100);
    } else {
        dailyCamFees = dailyRate * (2 * buffer + aircraft?.length) * (2 * buffer + aircraft?.wingspan) * camPerSqft;
        monthlyCamFees = camPerSqft * ((2 * buffer + aircraft?.length) * (2 * buffer + aircraft?.wingspan));
    }
    const monthlyTenantDisplayValue = !aircraft || !monthlyRate ? "---" : (0, $lNEp2.formatCurrency)(monthlyTenantValue, 2);
    const monthlyTenantDisplayValueWithCAM = !aircraft || !monthlyRate ? "---" : (0, $lNEp2.formatCurrency)(monthlyTenantValueWithCAM, 2);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35fe38f43861017f$export$96094fb98cfeffc8), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eScwB.FeeCalculator2Presenter), {
        aircraft: aircraft,
        buffer: bufferRaw,
        setBuffer: setBuffer,
        aircraftSqft: aircraftSqft,
        aircraftSqftWithBuffer: aircraftSqftWithBuffer,
        setAircaft: setAircaft,
        monthlyTenantValue: monthlyTenantValue,
        baseMonthlyTenantValue: baseMonthlyTenantValue,
        monthlyTenantValueWithCAM: monthlyTenantValueWithCAM,
        baseMonthlyTenantDisplayValue: baseMonthlyTenantDisplayValue,
        monthlyTenantDisplayValue: monthlyTenantDisplayValue,
        monthlyTenantDisplayValueWithCAM: monthlyTenantDisplayValueWithCAM,
        baseDailyTenantDisplayValue: baseDailyTenantDisplayValue,
        dailyTenantDisplayValue: dailyTenantDisplayValue,
        dailyCamFees: dailyCamFees,
        monthlyCamFees: monthlyCamFees,
        activeFBO: activeFBO,
        setFBO: setFBO,
        nightlyRate: dailyRate,
        cam: cam,
        setCam: setCam,
        camPerSqft: camPerSqft,
        setCamPerSqft: setCamPerSqft,
        dailyRate: dailyRate,
        setDailyRate: setDailyRate,
        monthlyRate: monthlyRate,
        setMonthlyRate: setMonthlyRate,
        availableRates: availableRates
    });
};


const $971f42d42303f2e4$export$5ad0adb7a28f3807 = ()=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        p: 4,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                children: "Fee Calculator"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a6af46e412e838f$export$be48ee98142e31c2), {
                defaultMonthlyRate: (activeFBO?.nightly_base_rate ?? 0) * 30,
                defaultDailyRate: activeFBO?.nightly_transient_rate || 0
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $7FzhI = parcelRequire("7FzhI");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $6Q1H5 = parcelRequire("6Q1H5");
var $lkxXU = parcelRequire("lkxXU");
var $cJu23 = parcelRequire("cJu23");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $kfA3C = parcelRequire("kfA3C");

var $acw62 = parcelRequire("acw62");

var $ggtZr = parcelRequire("ggtZr");

var $gZQV9 = parcelRequire("gZQV9");

var $brzp3 = parcelRequire("brzp3");
const $09ddeef7e25b36d6$var$StackResultsGridDialog = ({ stacks: stacks, onClose: onClose })=>{
    const { hangar: hangar } = (0, $gZQV9.useThisHangar)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MV2p.default), {
        open: true,
        maxWidth: "xl",
        onClose: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                container: true,
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
                children: stacks.map((stack, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                        item: true,
                        xs: 12,
                        md: 6,
                        justifyContent: "center",
                        alignItems: "center",
                        alignContent: "center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brzp3.StackResult), {
                            readOnly: true,
                            flagged: idx === 0,
                            status: "complete",
                            hangar: hangar,
                            stack: stack,
                            setHangar: ()=>null,
                            onClose: onClose,
                            onFlagResult: async ()=>{
                            // noop
                            }
                        })
                    }, `flagged-stack-result-${stack.id}`))
            })
        })
    });
};
const $09ddeef7e25b36d6$var$FlaggedStacksGrid = ({ flaggedStacks: flaggedStacks })=>{
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 300
        },
        {
            field: "hangar_name",
            headerName: "Hangar",
            width: 200,
            valueGetter: (value, row)=>row.hangar.name
        },
        {
            field: "created_at",
            headerName: "Date",
            width: 225,
            renderCell: (params)=>(0, $kfA3C.format)(new Date(params.row.created_at), "yyyy-MM-dd hh:mm:ss a z")
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 200,
            renderCell: (params)=>{
                const [open, setOpen] = $acw62.useState(false);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            size: "small",
                            variant: "contained",
                            color: "success",
                            onClick: ()=>setOpen(true),
                            children: "View"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggtZr.HangarStateContainer), {
                            initialState: {
                                hangar_id: params.row.hangar_id,
                                isReference: false
                            },
                            children: open && /*#__PURE__*/ (0, $ayMG0.jsx)($09ddeef7e25b36d6$var$StackResultsGridDialog, {
                                stacks: [
                                    params.row.stack
                                ].concat(params.row.alternate_stacks),
                                onClose: ()=>setOpen(false)
                            })
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            height: "100%",
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
            getRowId: (row)=>row.id,
            rows: flaggedStacks,
            disableRowSelectionOnClick: true,
            columns: columns
        })
    });
};
const $09ddeef7e25b36d6$export$a0f814565b29b34b = ({ flaggedStacks: flaggedStacks })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            ml: 2,
            mr: 2,
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    sx: {
                        mt: 2,
                        mb: 2
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        children: "Flagged Stacks"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)($09ddeef7e25b36d6$var$FlaggedStacksGrid, {
                    flaggedStacks: flaggedStacks
                })
            ]
        })
    });
};


const $d5455f29f5a853f8$export$bdc747a154a2c5d9 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [flaggedStacks, setFlaggedStacks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        (async ()=>{
            const { data: data } = await postgrest.from("flagged_stack").select("*,hangar(*)").order("created_at", {
                ascending: false
            });
            setFlaggedStacks(data);
        })();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09ddeef7e25b36d6$export$a0f814565b29b34b), {
            flaggedStacks: flaggedStacks
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $iscuz = parcelRequire("iscuz");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $3kyM0 = parcelRequire("3kyM0");
const $8ee939fb44325409$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $8ee939fb44325409$export$b597ee422a3143dc = ()=>{
    const { url: tokenMakerURL } = (0, $3kyM0.useTokenMaker)();
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const [email, setEmail] = $acw62.useState(location.state?.email || "");
    const [sent, setSent] = $acw62.useState(false);
    const [loading, setLoading] = $acw62.useState(false);
    const [error, setError] = $acw62.useState("");
    const handleSendReset = async ()=>{
        if (!email) {
            setError("Please enter your email address");
            return;
        }
        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError("Please enter a valid email address");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const response = await fetch(`${tokenMakerURL}/send-password-reset`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email
                })
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            setSent(true);
        } catch (err) {
            setError("Failed to send reset email. Please try again.");
            console.error("Error sending password reset:", err);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "60vh",
                width: "100vw",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    width: 450,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iscuz.default), {
                            in: !sent,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 3,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "h5",
                                                children: "Reset Your Password"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body1",
                                                color: "text.secondary",
                                                align: "center",
                                                children: "Enter your email to receive a reset link"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        fullWidth: true,
                                        label: "Email",
                                        variant: "outlined",
                                        type: "email",
                                        onChange: (e)=>setEmail(e.target.value),
                                        onKeyPress: (e)=>e.key === "Enter" && handleSendReset(),
                                        value: email,
                                        error: Boolean(error),
                                        helperText: error,
                                        disabled: loading,
                                        autoFocus: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        disabled: !email || loading,
                                        variant: "contained",
                                        color: "primary",
                                        onClick: handleSendReset,
                                        fullWidth: true,
                                        sx: {
                                            borderRadius: 1
                                        },
                                        children: loading ? "Sending..." : "Send Reset Link"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        onClick: ()=>navigate("/login"),
                                        children: "Back to login"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iscuz.default), {
                            in: sent,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 2,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        children: "Check Your Email"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body1",
                                        color: "text.secondary",
                                        align: "center",
                                        children: [
                                            "We sent a password reset link to",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: email
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        align: "center",
                                        children: "The link will expire in 1 hour"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "outlined",
                                        onClick: ()=>navigate("/login"),
                                        sx: {
                                            mt: 2
                                        },
                                        children: "Back to login"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: $8ee939fb44325409$var$logo,
                style: {
                    position: "fixed",
                    bottom: 15,
                    right: 15,
                    width: 50
                }
            })
        ]
    });
};




parcelRequire("7zk06");
var $9TSbO = parcelRequire("9TSbO");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $ggtZr = parcelRequire("ggtZr");

var $7FzhI = parcelRequire("7FzhI");

var $jRWDn = parcelRequire("jRWDn");

var $3AGzj = parcelRequire("3AGzj");

var $6AlVH = parcelRequire("6AlVH");

var $ayMG0 = parcelRequire("ayMG0");

var $lLxKB = parcelRequire("lLxKB");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");

var $8GP8k = parcelRequire("8GP8k");

var $abvRu = parcelRequire("abvRu");

var $6TVXD = parcelRequire("6TVXD");

var $koS2J = parcelRequire("koS2J");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $dlEXA = parcelRequire("dlEXA");

var $55RUj = parcelRequire("55RUj");
const $ec443de9378d8cc1$export$3c41ae73890a1609 = (options = {})=>{
    const { defaultDate: defaultDate = new Date(), updateUrlOnMount: updateUrlOnMount = true } = options;
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const [isFromUrl, setIsFromUrl] = (0, $acw62.useState)(false);
    // Initialize state from URL parameter or default
    const [currentTime, setCurrentTimeState] = (0, $acw62.useState)(()=>{
        const dateParam = searchParams.get('date');
        const urlDate = (0, $dlEXA.decodeTimeFromUrl)(dateParam);
        if (urlDate) {
            setIsFromUrl(true);
            return urlDate;
        }
        // Use provided default or current time, snapped to quarter hour
        return (0, $55RUj.snapToQuarterHour)(defaultDate);
    });
    // Update URL when component mounts if no date parameter exists and updateUrlOnMount is true
    (0, $acw62.useEffect)(()=>{
        const dateParam = searchParams.get('date');
        if (!dateParam && updateUrlOnMount) {
            // Add current time to URL without creating a new history entry
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.set('date', (0, $dlEXA.encodeTimeToUrl)(currentTime));
            setSearchParams(newSearchParams, {
                replace: true
            });
        }
    }, []); // Empty dependency array - only run on mount
    // Function to update current time and URL
    const setCurrentTime = (0, $acw62.useCallback)((date)=>{
        // Smart snapping: If the date is already on a quarter hour, use it as-is.
        // Otherwise, check if snapping would go before the desired time and use ceil instead
        const minutes = date.getMinutes();
        const isOnQuarterHour = minutes % 15 === 0;
        let snappedDate;
        if (isOnQuarterHour) {
            // Already on a quarter hour boundary
            snappedDate = new Date(date);
            snappedDate.setSeconds(0, 0);
        } else {
            // Check if normal snapping would go backwards
            const normalSnap = (0, $55RUj.snapToQuarterHour)(date);
            if (normalSnap.getTime() < date.getTime()) // Normal snap goes backwards, use ceil to ensure we don't go before the trip
            snappedDate = (0, $55RUj.ceilToQuarterHour)(date);
            else // Normal snap goes forward or stays the same, use it
            snappedDate = normalSnap;
        }
        setCurrentTimeState(snappedDate);
        // Update URL with new date
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('date', (0, $dlEXA.encodeTimeToUrl)(snappedDate));
        // Use replace: true to avoid creating excessive browser history entries
        // This allows users to share the URL at any time without navigation issues
        setSearchParams(newSearchParams, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    // Get shareable URL for current time
    const getShareableUrl = (0, $acw62.useCallback)(()=>{
        const url = new URL(window.location.href);
        url.searchParams.set('date', (0, $dlEXA.encodeTimeToUrl)(currentTime));
        return url.toString();
    }, [
        currentTime
    ]);
    return {
        currentTime: currentTime,
        setCurrentTime: setCurrentTime,
        isFromUrl: isFromUrl,
        getShareableUrl: getShareableUrl
    };
};



var $a7gZr = parcelRequire("a7gZr");

var $aWoxc = parcelRequire("aWoxc");

var $lNEp2 = parcelRequire("lNEp2");

var $3dLiv = parcelRequire("3dLiv");

var $55RUj = parcelRequire("55RUj");

var $3JLDK = parcelRequire("3JLDK");

var $ayMG0 = parcelRequire("ayMG0");

var $9uy2D = parcelRequire("9uy2D");

var $6lMlz = parcelRequire("6lMlz");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $9Lykx = parcelRequire("9Lykx");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
parcelRequire("acw62");

var $fBVnr = parcelRequire("fBVnr");

var $gGfi1 = parcelRequire("gGfi1");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $4F5tJ = parcelRequire("4F5tJ");
var $30UGG = parcelRequire("30UGG");

var $78ow6 = parcelRequire("78ow6");

var $uaXRK = parcelRequire("uaXRK");
var $e04218bd8a4dbb99$exports = {};
"use strict";
Object.defineProperty($e04218bd8a4dbb99$exports, "__esModule", {
    value: true
});
Object.defineProperty($e04218bd8a4dbb99$exports, "StaticDatePicker", {
    enumerable: true,
    get: function() {
        return $ca189b504425f183$exports.StaticDatePicker;
    }
});
var $ca189b504425f183$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ca189b504425f183$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ca189b504425f183$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ca189b504425f183$exports, "__esModule", {
    value: true
});
$ca189b504425f183$exports.StaticDatePicker = void 0;

var $ca189b504425f183$var$_extends2 = $ca189b504425f183$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ca189b504425f183$var$React = $ca189b504425f183$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ca189b504425f183$var$_propTypes = $ca189b504425f183$require$_interopRequireDefault((parcelRequire("c9Z8w")));
var $cff128f6b922ac60$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cff128f6b922ac60$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cff128f6b922ac60$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($cff128f6b922ac60$exports, "__esModule", {
    value: true
});
$cff128f6b922ac60$exports.useDatePickerDefaultizedProps = $cff128f6b922ac60$var$useDatePickerDefaultizedProps;

var $cff128f6b922ac60$var$_extends2 = $cff128f6b922ac60$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $cff128f6b922ac60$var$React = $cff128f6b922ac60$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6g9fa = parcelRequire("6g9fa");

var $kqIjR = parcelRequire("kqIjR");
var $ab147feda772f70e$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ab147feda772f70e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ab147feda772f70e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($ab147feda772f70e$exports, "__esModule", {
    value: true
});
$ab147feda772f70e$exports.DatePickerToolbar = void 0;

var $ab147feda772f70e$var$_extends2 = $ab147feda772f70e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ab147feda772f70e$var$_objectWithoutPropertiesLoose2 = $ab147feda772f70e$require$_interopRequireDefault((parcelRequire("c05no")));

var $ab147feda772f70e$var$React = $ab147feda772f70e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ab147feda772f70e$var$_clsx = $ab147feda772f70e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ab147feda772f70e$var$_propTypes = $ab147feda772f70e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ab147feda772f70e$var$_Typography = $ab147feda772f70e$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $ab147feda772f70e$var$_composeClasses = $ab147feda772f70e$require$_interopRequireDefault((parcelRequire("1gqgQ")));

var $1YoVy = parcelRequire("1YoVy");

var $BKARN = parcelRequire("BKARN");
var $12fed230fa62a38e$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $12fed230fa62a38e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($12fed230fa62a38e$exports, "__esModule", {
    value: true
});
$12fed230fa62a38e$exports.datePickerToolbarClasses = void 0;
$12fed230fa62a38e$exports.getDatePickerToolbarUtilityClass = $12fed230fa62a38e$var$getDatePickerToolbarUtilityClass;

var $12fed230fa62a38e$var$_generateUtilityClass = $12fed230fa62a38e$require$_interopRequireDefault((parcelRequire("l9FHx")));

var $12fed230fa62a38e$var$_generateUtilityClasses = $12fed230fa62a38e$require$_interopRequireDefault((parcelRequire("fXRFb")));
function $12fed230fa62a38e$var$getDatePickerToolbarUtilityClass(slot) {
    return (0, $12fed230fa62a38e$var$_generateUtilityClass.default)('MuiDatePickerToolbar', slot);
}
const $12fed230fa62a38e$var$datePickerToolbarClasses = $12fed230fa62a38e$exports.datePickerToolbarClasses = (0, $12fed230fa62a38e$var$_generateUtilityClasses.default)('MuiDatePickerToolbar', [
    'root',
    'title'
]);



var $NRNex = parcelRequire("NRNex");

var $1IRkN = parcelRequire("1IRkN");

var $ayMG0 = parcelRequire("ayMG0");
const $ab147feda772f70e$var$_excluded = [
    "toolbarFormat",
    "toolbarPlaceholder",
    "className",
    "classes"
];
const $ab147feda772f70e$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $ab147feda772f70e$var$_composeClasses.default)(slots, $12fed230fa62a38e$exports.getDatePickerToolbarUtilityClass, classes);
};
const $ab147feda772f70e$var$DatePickerToolbarRoot = (0, $d8seH.default)($1YoVy.PickersToolbar, {
    name: 'MuiDatePickerToolbar',
    slot: 'Root'
})({});
const $ab147feda772f70e$var$DatePickerToolbarTitle = (0, $d8seH.default)($ab147feda772f70e$var$_Typography.default, {
    name: 'MuiDatePickerToolbar',
    slot: 'Title'
})({
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DatePickerToolbar API](https://mui.com/x/api/date-pickers/date-picker-toolbar/)
 */ const $ab147feda772f70e$var$DatePickerToolbar = $ab147feda772f70e$exports.DatePickerToolbar = /*#__PURE__*/ $ab147feda772f70e$var$React.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", className: className, classes: classesProp } = props, other = (0, $ab147feda772f70e$var$_objectWithoutPropertiesLoose2.default)(props, $ab147feda772f70e$var$_excluded);
    const adapter = (0, $BKARN.usePickerAdapter)();
    const { value: value, views: views, orientation: orientation } = (0, $BKARN.usePickerContext)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const ownerState = (0, $1IRkN.useToolbarOwnerState)();
    const classes = $ab147feda772f70e$var$useUtilityClasses(classesProp);
    const dateText = $ab147feda772f70e$var$React.useMemo(()=>{
        if (!adapter.isValid(value)) return toolbarPlaceholder;
        const formatFromViews = (0, $NRNex.resolveDateFormat)(adapter, {
            format: toolbarFormat,
            views: views
        }, true);
        return adapter.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        adapter,
        views
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab147feda772f70e$var$DatePickerToolbarRoot, (0, $ab147feda772f70e$var$_extends2.default)({
        ref: ref,
        toolbarTitle: translations.datePickerToolbarTitle,
        className: (0, $ab147feda772f70e$var$_clsx.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ab147feda772f70e$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: orientation === 'landscape' ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});



var $1aSwN = parcelRequire("1aSwN");
function $cff128f6b922ac60$var$useDatePickerDefaultizedProps(props, name) {
    const themeProps = (0, $6g9fa.default)({
        props: props,
        name: name
    });
    const validationProps = (0, $1aSwN.useApplyDefaultValuesToDateValidationProps)(themeProps);
    const localeText = $cff128f6b922ac60$var$React.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $cff128f6b922ac60$var$_extends2.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $cff128f6b922ac60$var$_extends2.default)({}, themeProps, validationProps, {
        localeText: localeText
    }, (0, $kqIjR.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        slots: (0, $cff128f6b922ac60$var$_extends2.default)({
            toolbar: $ab147feda772f70e$exports.DatePickerToolbar
        }, themeProps.slots)
    });
}



var $5TrXg = parcelRequire("5TrXg");
var $935a66ecd28e9da6$exports = {};
"use strict";
Object.defineProperty($935a66ecd28e9da6$exports, "__esModule", {
    value: true
});
Object.defineProperty($935a66ecd28e9da6$exports, "useStaticPicker", {
    enumerable: true,
    get: function() {
        return $50dbdc231be4d263$exports.useStaticPicker;
    }
});
var $50dbdc231be4d263$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $50dbdc231be4d263$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $50dbdc231be4d263$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($50dbdc231be4d263$exports, "__esModule", {
    value: true
});
$50dbdc231be4d263$exports.useStaticPicker = void 0;

var $50dbdc231be4d263$var$_extends2 = $50dbdc231be4d263$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $50dbdc231be4d263$var$_objectWithoutPropertiesLoose2 = $50dbdc231be4d263$require$_interopRequireDefault((parcelRequire("c05no")));

var $50dbdc231be4d263$var$React = $50dbdc231be4d263$require$_interopRequireWildcard((parcelRequire("acw62")));

var $50dbdc231be4d263$var$_clsx = $50dbdc231be4d263$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d8seH = parcelRequire("d8seH");

var $hz59J = parcelRequire("hz59J");

var $jk6Bf = parcelRequire("jk6Bf");

var $g0CIC = parcelRequire("g0CIC");

var $99eO4 = parcelRequire("99eO4");

var $l16rr = parcelRequire("l16rr");

var $a2Tw3 = parcelRequire("a2Tw3");

var $ayMG0 = parcelRequire("ayMG0");
const $50dbdc231be4d263$var$_excluded = [
    "props",
    "steps"
];
const $50dbdc231be4d263$var$PickerStaticLayout = (0, $d8seH.default)($g0CIC.PickersLayout)(({ theme: theme })=>({
        overflow: 'hidden',
        minWidth: $99eO4.DIALOG_WIDTH,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
/**
 * Hook managing all the single-date static pickers:
 * - StaticDatePicker
 * - StaticDateTimePicker
 * - StaticTimePicker
 */ const $50dbdc231be4d263$var$useStaticPicker = (_ref)=>{
    let { props: props, steps: steps } = _ref, pickerParams = (0, $50dbdc231be4d263$var$_objectWithoutPropertiesLoose2.default)(_ref, $50dbdc231be4d263$var$_excluded);
    const { localeText: localeText, slots: slots, slotProps: slotProps, displayStaticWrapperAs: displayStaticWrapperAs, autoFocus: autoFocus } = props;
    const getStepNavigation = (0, $a2Tw3.createNonRangePickerStepNavigation)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView } = (0, $hz59J.usePicker)((0, $50dbdc231be4d263$var$_extends2.default)({}, pickerParams, {
        props: props,
        variant: displayStaticWrapperAs,
        autoFocusView: autoFocus ?? false,
        viewContainerRole: null,
        localeText: localeText,
        getStepNavigation: getStepNavigation
    }));
    const Layout = slots?.layout ?? $50dbdc231be4d263$var$PickerStaticLayout;
    const renderPicker = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($jk6Bf.PickerProvider, (0, $50dbdc231be4d263$var$_extends2.default)({}, providerProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Layout, (0, $50dbdc231be4d263$var$_extends2.default)({}, slotProps?.layout, {
                slots: slots,
                slotProps: slotProps,
                sx: (0, $l16rr.mergeSx)(providerProps.contextValue.rootSx, slotProps?.layout?.sx),
                className: (0, $50dbdc231be4d263$var$_clsx.default)(providerProps.contextValue.rootClassName, slotProps?.layout?.className),
                ref: providerProps.contextValue.rootRef,
                children: renderCurrentView()
            }))
        }));
    return {
        renderPicker: renderPicker
    };
};
$50dbdc231be4d263$exports.useStaticPicker = $50dbdc231be4d263$var$useStaticPicker;





var $5UoGz = parcelRequire("5UoGz");

var $1M3bL = parcelRequire("1M3bL");
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [StaticDatePicker API](https://mui.com/x/api/date-pickers/static-date-picker/)
 */ const $ca189b504425f183$var$StaticDatePicker = $ca189b504425f183$exports.StaticDatePicker = /*#__PURE__*/ $ca189b504425f183$var$React.forwardRef(function StaticDatePicker(inProps, ref) {
    const defaultizedProps = (0, $cff128f6b922ac60$exports.useDatePickerDefaultizedProps)(inProps, 'MuiStaticDatePicker');
    const displayStaticWrapperAs = defaultizedProps.displayStaticWrapperAs ?? 'mobile';
    const viewRenderers = (0, $ca189b504425f183$var$_extends2.default)({
        day: $5TrXg.renderDateViewCalendar,
        month: $5TrXg.renderDateViewCalendar,
        year: $5TrXg.renderDateViewCalendar
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the static variant
    const props = (0, $ca189b504425f183$var$_extends2.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        displayStaticWrapperAs: displayStaticWrapperAs,
        yearsPerRow: defaultizedProps.yearsPerRow ?? (displayStaticWrapperAs === 'mobile' ? 3 : 4),
        slotProps: (0, $ca189b504425f183$var$_extends2.default)({}, defaultizedProps.slotProps, {
            toolbar: (0, $ca189b504425f183$var$_extends2.default)({
                hidden: displayStaticWrapperAs === 'desktop'
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $935a66ecd28e9da6$exports.useStaticPicker)({
        ref: ref,
        props: props,
        valueManager: $1M3bL.singleItemValueManager,
        valueType: 'date',
        validator: $5UoGz.validateDate,
        steps: null
    });
    return renderPicker();
});
$ca189b504425f183$var$StaticDatePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: $ca189b504425f183$var$_propTypes.default.bool,
    className: $ca189b504425f183$var$_propTypes.default.string,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: $ca189b504425f183$var$_propTypes.default.object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * Force static wrapper inner components to be rendered in mobile or desktop mode.
   * @default "mobile"
   */ displayStaticWrapperAs: $ca189b504425f183$var$_propTypes.default.oneOf([
        'desktop',
        'mobile'
    ]),
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: $ca189b504425f183$var$_propTypes.default.number,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: $ca189b504425f183$var$_propTypes.default.object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: $ca189b504425f183$var$_propTypes.default.object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: $ca189b504425f183$var$_propTypes.default.object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: $ca189b504425f183$var$_propTypes.default.oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Callback fired when component requests to be closed.
   * Can be fired when selecting (by default on `desktop` mode) or clearing a value.
   * @deprecated Please avoid using as it will be removed in next major version.
   */ onClose: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: $ca189b504425f183$var$_propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: $ca189b504425f183$var$_propTypes.default.oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: $ca189b504425f183$var$_propTypes.default.object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: $ca189b504425f183$var$_propTypes.default.func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: $ca189b504425f183$var$_propTypes.default.bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: $ca189b504425f183$var$_propTypes.default.object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: $ca189b504425f183$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $ca189b504425f183$var$_propTypes.default.oneOfType([
        $ca189b504425f183$var$_propTypes.default.arrayOf($ca189b504425f183$var$_propTypes.default.oneOfType([
            $ca189b504425f183$var$_propTypes.default.func,
            $ca189b504425f183$var$_propTypes.default.object,
            $ca189b504425f183$var$_propTypes.default.bool
        ])),
        $ca189b504425f183$var$_propTypes.default.func,
        $ca189b504425f183$var$_propTypes.default.object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: $ca189b504425f183$var$_propTypes.default.string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: $ca189b504425f183$var$_propTypes.default.object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: $ca189b504425f183$var$_propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: $ca189b504425f183$var$_propTypes.default.shape({
        day: $ca189b504425f183$var$_propTypes.default.func,
        month: $ca189b504425f183$var$_propTypes.default.func,
        year: $ca189b504425f183$var$_propTypes.default.func
    }),
    /**
   * Available views.
   */ views: $ca189b504425f183$var$_propTypes.default.arrayOf($ca189b504425f183$var$_propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: $ca189b504425f183$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default `4` when `displayStaticWrapperAs === 'desktop'`, `3` otherwise.
   */ yearsPerRow: $ca189b504425f183$var$_propTypes.default.oneOf([
        3,
        4
    ])
};





var $acw62 = parcelRequire("acw62");

var $aWoxc = parcelRequire("aWoxc");

var $55RUj = parcelRequire("55RUj");

var $ayMG0 = parcelRequire("ayMG0");
var $89bc6a2c1ad4197b$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $89bc6a2c1ad4197b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($89bc6a2c1ad4197b$exports, "__esModule", {
    value: true
});
$89bc6a2c1ad4197b$exports.default = void 0;

var $89bc6a2c1ad4197b$var$_createSvgIcon = $89bc6a2c1ad4197b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $89bc6a2c1ad4197b$var$_default = $89bc6a2c1ad4197b$exports.default = (0, $89bc6a2c1ad4197b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M8 11H4V6h4zm6 0h-4V6h4zm6 0h-4V6h4zM8 18H4v-5h4zm6 0h-4v-5h4zm6 0h-4v-5h4z"
}), 'CalendarViewMonth');



var $iGBB4 = parcelRequire("iGBB4");

var $ap4xJ = parcelRequire("ap4xJ");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2p5OG = parcelRequire("2p5OG");
var $jU0bc = parcelRequire("jU0bc");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");

var $78ow6 = parcelRequire("78ow6");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $kfA3C = parcelRequire("kfA3C");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $cVXaD = parcelRequire("cVXaD");

var $5XNc8 = parcelRequire("5XNc8");
parcelRequire("acw62");
const $14103f231151e779$export$d5f45dc5ee859403 = (props)=>{
    const { day: day, tripCountsByDate: tripCountsByDate, ...other } = props;
    // Get trip count for this date
    const dateKey = day.toISOString().split("T")[0]; // YYYY-MM-DD format
    const tripCount = tripCountsByDate?.get(dateKey) || 0;
    // Calculate dot styling based on trip count
    const getDotStyle = (count)=>{
        if (count === 0) return null; // No dot
        else if (count <= 2) return {
            size: 4,
            opacity: 0.6
        }; // Small, subtle
        else if (count <= 5) return {
            size: 6,
            opacity: 0.8
        }; // Medium
        else return {
            size: 8,
            opacity: 1.0
        }; // Large, prominent
    };
    const dotStyle = getDotStyle(tripCount);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: tripCount > 0 ? `${tripCount} trip${tripCount > 1 ? "s" : ""}` : "",
        arrow: true,
        placement: "top",
        disableInteractive: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            sx: {
                position: "relative",
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5XNc8.PickersDay), {
                    day: day,
                    ...other
                }),
                dotStyle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        position: "absolute",
                        bottom: 2,
                        width: dotStyle.size,
                        height: dotStyle.size,
                        borderRadius: "50%",
                        backgroundColor: "primary.main",
                        opacity: dotStyle.opacity,
                        transition: "all 0.2s ease-in-out",
                        // Add subtle shadow for depth on larger dots
                        ...dotStyle.size >= 6 && {
                            boxShadow: "0 1px 2px rgba(0,0,0,0.2)"
                        }
                    }
                })
            ]
        })
    });
};



var $e6g4k = parcelRequire("e6g4k");

var $55RUj = parcelRequire("55RUj");

var $gQSh1 = parcelRequire("gQSh1");
const $f31e41b03b6202b3$export$77093a460b457117 = ({ currentTime: currentTime, rangeStart: rangeStart, rangeEnd: rangeEnd, onTimeChange: onTimeChange, onRangeChange: onRangeChange, tripCountsByDate: tripCountsByDate, showDateTimePicker: showDateTimePicker = false, showNowButton: showNowButton = false, selectedTripStart: selectedTripStart, selectedTripEnd: selectedTripEnd, showTripDuration: showTripDuration = false, selectedTailNumber: selectedTailNumber, onJumpToNextTrip: onJumpToNextTrip, onJumpToPreviousTrip: onJumpToPreviousTrip, showTripJumpButtons: showTripJumpButtons = false, hasNextTrip: hasNextTrip = false, hasPreviousTrip: hasPreviousTrip = false, onViewSchedule: onViewSchedule, showViewScheduleButton: showViewScheduleButton = false, viewScheduleDisabled: viewScheduleDisabled = false, compact: compact = false })=>{
    // State to track which range button is selected
    const [selectedRange, setSelectedRange] = $acw62.useState("1W");
    // Convert time to slider value (0-100 representing position within range)
    const timeToSliderValue = (time)=>{
        const totalRange = rangeEnd.getTime() - rangeStart.getTime();
        const currentPosition = time.getTime() - rangeStart.getTime();
        return Math.max(0, Math.min(100, currentPosition / totalRange * 100));
    };
    // Convert slider value back to time
    const sliderValueToTime = (value)=>{
        const totalRange = rangeEnd.getTime() - rangeStart.getTime();
        const timeOffset = value / 100 * totalRange;
        return new Date(rangeStart.getTime() + timeOffset);
    };
    const currentSliderValue = timeToSliderValue(currentTime);
    // Counter for reliable flashing on range changes
    const [rangeChangeCounter, setRangeChangeCounter] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        setRangeChangeCounter((prev)=>prev + 1);
    }, [
        rangeStart,
        rangeEnd
    ]);
    // Calculate trip duration bar position and width
    const tripDurationBar = $acw62.useMemo(()=>{
        if (!showTripDuration || !selectedTripStart || !selectedTripEnd) return null;
        const startValue = timeToSliderValue(selectedTripStart);
        const endValue = timeToSliderValue(selectedTripEnd);
        // Calculate visible portion of the trip
        const visibleStartValue = Math.max(0, Math.min(100, startValue));
        const visibleEndValue = Math.max(0, Math.min(100, endValue));
        const visibleWidth = visibleEndValue - visibleStartValue;
        // Only show if trip has visible portion
        if (visibleWidth <= 0) return null;
        const result = {
            left: visibleStartValue,
            width: visibleWidth
        };
        return result;
    }, [
        showTripDuration,
        selectedTripStart,
        selectedTripEnd,
        rangeStart,
        rangeEnd
    ]);
    const handleSliderChange = (_, value)=>{
        if (typeof value === "number") {
            const newTime = sliderValueToTime(value);
            // Snap to 15-minute intervals when clicking/dragging
            const snappedTime = new Date(newTime);
            const minutes = Math.round(snappedTime.getMinutes() / 15) * 15;
            snappedTime.setMinutes(minutes, 0, 0);
            onTimeChange(snappedTime);
        }
    };
    // Handle keyboard navigation (arrow keys for 15-minute increments)
    const handleKeyDown = (event)=>{
        const fifteenMinutes = 900000;
        let newTime = null;
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                newTime = new Date(currentTime.getTime() - fifteenMinutes);
                break;
            case "ArrowRight":
                event.preventDefault();
                newTime = new Date(currentTime.getTime() + fifteenMinutes);
                break;
            case "Home":
                event.preventDefault();
                newTime = new Date(rangeStart);
                break;
            case "End":
                event.preventDefault();
                newTime = new Date(rangeEnd);
                break;
        }
        if (newTime && newTime >= rangeStart && newTime <= rangeEnd) onTimeChange(newTime);
    };
    // Range control functions
    const setWeekRange = ()=>{
        setSelectedRange("1W");
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - 3);
        start.setHours(0, 0, 0, 0);
        const end = new Date(now);
        end.setDate(end.getDate() + 4);
        end.setHours(23, 59, 59, 999);
        onRangeChange(start, end);
    };
    const setTwoWeekRange = ()=>{
        setSelectedRange("2W");
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - 7);
        start.setHours(0, 0, 0, 0);
        const end = new Date(now);
        end.setDate(end.getDate() + 7);
        end.setHours(23, 59, 59, 999);
        onRangeChange(start, end);
    };
    const setMonthRange = ()=>{
        setSelectedRange("1M");
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - 15);
        start.setHours(0, 0, 0, 0);
        const end = new Date(now);
        end.setDate(end.getDate() + 15);
        end.setHours(23, 59, 59, 999);
        onRangeChange(start, end);
    };
    // Jump to now function for inline Now button
    const jumpToNow = ()=>{
        const now = new Date();
        onTimeChange((0, $55RUj.floorToQuarterHour)(now));
    };
    const shiftTime = (minutes)=>{
        const time = minutes * 60000;
        const newTime = new Date(currentTime.getTime() + time);
        onTimeChange(newTime);
    };
    // Main layout - vertical stacking with controls on top, slider on bottom
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 0,
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                alignItems: "center",
                justifyContent: "flex-end",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2p5OG.default), {
                        size: compact ? "small" : "small",
                        variant: "outlined",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: setWeekRange,
                                variant: selectedRange === "1W" ? "contained" : "outlined",
                                sx: {
                                    minWidth: "40px",
                                    fontSize: "0.7rem",
                                    px: 1
                                },
                                children: "1W"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: setTwoWeekRange,
                                variant: selectedRange === "2W" ? "contained" : "outlined",
                                sx: {
                                    minWidth: "40px",
                                    fontSize: "0.7rem",
                                    px: 1
                                },
                                children: "2W"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: setMonthRange,
                                variant: selectedRange === "1M" ? "contained" : "outlined",
                                sx: {
                                    minWidth: "40px",
                                    fontSize: "0.7rem",
                                    px: 1
                                },
                                children: "1M"
                            })
                        ]
                    }),
                    showDateTimePicker && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
                        dateAdapter: (0, $78ow6.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                            value: currentTime,
                            onChange: (newDate)=>{
                                if (newDate) onTimeChange((0, $55RUj.snapToQuarterHour)(newDate));
                            },
                            minDate: (0, $e6g4k.SCHEDULE_MIN_DATE),
                            ampm: false,
                            minutesStep: 15,
                            slots: {
                                day: (0, $14103f231151e779$export$d5f45dc5ee859403)
                            },
                            slotProps: {
                                day: {
                                    tripCountsByDate: tripCountsByDate
                                },
                                textField: {
                                    size: "small",
                                    sx: {
                                        width: 210,
                                        height: "27px !important",
                                        minHeight: "unset !important",
                                        boxSizing: "border-box",
                                        "& .MuiPickersTextField-root": {
                                            height: "27px !important"
                                        },
                                        "& .MuiInputBase-root": {
                                            height: "27px !important",
                                            minHeight: "unset !important",
                                            fontSize: "0.75rem",
                                            paddingTop: "0 !important",
                                            paddingBottom: "0 !important"
                                        },
                                        "& .MuiPickersInputBase-root": {
                                            height: "27px !important",
                                            minHeight: "unset !important"
                                        },
                                        "& .MuiPickersOutlinedInput-root": {
                                            height: "27px !important",
                                            minHeight: "unset !important"
                                        },
                                        "& .MuiInputBase-input": {
                                            fontSize: "0.75rem",
                                            padding: "3px 8px !important",
                                            lineHeight: "1.2 !important",
                                            height: "auto !important"
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            top: "0 !important"
                                        },
                                        "& .MuiInputLabel-root": {
                                            fontSize: "0.75rem",
                                            transform: "translate(8px, 6px) scale(1)",
                                            "&.Mui-focused, &.MuiFormLabel-filled": {
                                                transform: "translate(8px, -8px) scale(0.75)"
                                            }
                                        },
                                        "& .MuiInputAdornment-root": {
                                            height: "27px !important",
                                            "& .MuiIconButton-root": {
                                                padding: "2px !important",
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: "1rem !important"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        })
                    }),
                    (showNowButton || showTripJumpButtons) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2p5OG.default), {
                        variant: "outlined",
                        size: "small",
                        children: [
                            showTripJumpButtons && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                title: !hasPreviousTrip ? selectedTailNumber ? `No earlier trips for ${selectedTailNumber}` : "No earlier trips" : selectedTailNumber ? `Jump to previous trip for ${selectedTailNumber}` : "Jump to previous trip",
                                arrow: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: onJumpToPreviousTrip,
                                        disabled: !hasPreviousTrip || !onJumpToPreviousTrip,
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                            sx: {
                                                fontSize: 18
                                            }
                                        }),
                                        sx: {
                                            fontSize: "0.75rem",
                                            px: {
                                                xs: 0.75,
                                                sm: 1.25
                                            },
                                            minWidth: {
                                                xs: 40,
                                                sm: "auto"
                                            },
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            "& .MuiButton-startIcon": {
                                                mr: {
                                                    xs: 0,
                                                    sm: 0.5
                                                },
                                                ml: 0,
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            component: "span",
                                            sx: {
                                                display: {
                                                    xs: "none",
                                                    sm: "inline"
                                                }
                                            },
                                            children: "Prev Trip"
                                        })
                                    })
                                })
                            }),
                            showNowButton && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>shiftTime(-10080),
                                        sx: {
                                            fontSize: "0.75rem",
                                            px: 1,
                                            minWidth: "45px",
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: "-1w"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>shiftTime(-15),
                                        sx: {
                                            fontSize: "0.75rem",
                                            px: 1,
                                            minWidth: "45px",
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: "-15m"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        disabled: currentTime.getTime() === (0, $55RUj.floorToQuarterHour)(new Date()).getTime(),
                                        variant: "contained",
                                        onClick: jumpToNow,
                                        sx: {
                                            fontSize: "0.75rem",
                                            px: 1.5,
                                            fontWeight: 600,
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: "Now"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>shiftTime(15),
                                        sx: {
                                            fontSize: "0.75rem",
                                            px: 1,
                                            minWidth: "45px",
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: "+15m"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>shiftTime(10080),
                                        sx: {
                                            fontSize: "0.75rem",
                                            px: 1,
                                            minWidth: "45px",
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: "+1w"
                                    })
                                ]
                            }),
                            showTripJumpButtons && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                title: !hasNextTrip ? selectedTailNumber ? `No future trips for ${selectedTailNumber}` : "No future trips" : selectedTailNumber ? `Jump to next trip for ${selectedTailNumber}` : "Jump to next trip",
                                arrow: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: onJumpToNextTrip,
                                        disabled: !hasNextTrip || !onJumpToNextTrip,
                                        endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                            sx: {
                                                fontSize: 18
                                            }
                                        }),
                                        sx: {
                                            fontSize: "0.75rem",
                                            px: {
                                                xs: 0.75,
                                                sm: 1.25
                                            },
                                            minWidth: {
                                                xs: 40,
                                                sm: "auto"
                                            },
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            "& .MuiButton-endIcon": {
                                                ml: {
                                                    xs: 0,
                                                    sm: 0.5
                                                },
                                                mr: 0,
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            component: "span",
                                            sx: {
                                                display: {
                                                    xs: "none",
                                                    sm: "inline"
                                                }
                                            },
                                            children: "Next Trip"
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    showViewScheduleButton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "outlined",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($89bc6a2c1ad4197b$exports))), {}),
                        onClick: onViewSchedule,
                        disabled: viewScheduleDisabled,
                        size: "small",
                        sx: {
                            fontSize: "0.75rem",
                            px: 1.5
                        },
                        children: "View Schedule"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    width: "100%",
                    pt: 1.25,
                    // Add padding-top to make room for trip duration bar (~10px)
                    overflow: "visible",
                    // Allow bar to show above
                    position: "relative"
                },
                children: [
                    tripDurationBar && (()=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    position: "absolute",
                                    top: 15,
                                    left: `calc(${tripDurationBar.left}%)`,
                                    width: `${tripDurationBar.width}%`,
                                    height: 6,
                                    backgroundColor: "success.main",
                                    zIndex: 0
                                },
                                title: "Selected aircraft trip duration"
                            })
                        });
                    })(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jU0bc.default), {
                        value: currentSliderValue,
                        onChange: handleSliderChange,
                        onKeyDown: handleKeyDown,
                        min: 0,
                        max: 100,
                        step: 0.1,
                        marks: (()=>{
                            const marks = [];
                            const rangeInDays = (rangeEnd.getTime() - rangeStart.getTime()) / 86400000;
                            // Determine step size based on range
                            let dayStep = 1;
                            if (rangeInDays > 14) dayStep = Math.ceil(rangeInDays / 7); // Show ~7 markers for longer ranges
                            else if (rangeInDays > 7) dayStep = 2; // Every other day for 2 week range
                            // Always include the start
                            marks.push({
                                value: 0,
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                    value: rangeChangeCounter,
                                    text: rangeStart.toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "numeric"
                                    }),
                                    bidirectional: true
                                })
                            });
                            // Add day boundary markers
                            const currentDate = new Date(rangeStart);
                            currentDate.setHours(0, 0, 0, 0);
                            currentDate.setDate(currentDate.getDate() + dayStep);
                            while(currentDate < rangeEnd){
                                const sliderValue = timeToSliderValue(currentDate);
                                // Only add if not too close to start or end
                                if (sliderValue > 5 && sliderValue < 95) marks.push({
                                    value: sliderValue,
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                        value: rangeChangeCounter,
                                        text: currentDate.toLocaleDateString("en-US", {
                                            month: "short",
                                            day: "numeric"
                                        }),
                                        bidirectional: true
                                    })
                                });
                                currentDate.setDate(currentDate.getDate() + dayStep);
                            }
                            // Always include the end
                            marks.push({
                                value: 100,
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQSh1.SexyText), {
                                    value: rangeChangeCounter,
                                    text: rangeEnd.toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "numeric"
                                    }),
                                    bidirectional: true
                                })
                            });
                            return marks;
                        })(),
                        valueLabelDisplay: "auto",
                        valueLabelFormat: (value)=>{
                            const date = sliderValueToTime(value);
                            return (0, $kfA3C.format)(date, "MMM d, HH:mm");
                        },
                        getAriaValueText: (value)=>{
                            const date = sliderValueToTime(value);
                            return (0, $kfA3C.format)(date, "MMM d, HH:mm");
                        },
                        "aria-label": "Time selection slider",
                        sx: {
                            height: 6,
                            "& .MuiSlider-track": {
                                backgroundColor: "primary.main",
                                border: "none"
                            },
                            "& .MuiSlider-rail": {
                                backgroundColor: "primary.main",
                                borderRadius: 0,
                                opacity: 0.38
                            },
                            "& .MuiSlider-mark": {
                                backgroundColor: "text.primary",
                                height: 8,
                                width: 2,
                                opacity: 1
                            },
                            "& .MuiSlider-markLabel": {
                                fontSize: "0.7rem",
                                transform: "translateX(-50%)",
                                top: 24,
                                color: "text.secondary"
                            },
                            "& .MuiSlider-thumb": {
                                width: 20,
                                height: 20,
                                backgroundColor: "primary.main",
                                border: "3px solid",
                                borderColor: "background.paper",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                cursor: "grab",
                                zIndex: 1,
                                "&:hover": {
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.25)"
                                },
                                "&:focus, &.Mui-focusVisible": {
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.25)"
                                },
                                "&.Mui-active": {
                                    cursor: "grabbing !important",
                                    boxShadow: "0 3px 8px rgba(0,0,0,0.3) !important"
                                }
                            },
                            ".MuiSlider-rail": {
                                opacity: 1
                            }
                        }
                    })
                ]
            })
        ]
    });
};


const $ca7bd34565630016$export$af6201c40255f12e = ({ currentTime: currentTime, onTimeChange: onTimeChange, tripCountsByDate: tripCountsByDate, selectedTripStart: selectedTripStart, selectedTripEnd: selectedTripEnd, showTripDuration: showTripDuration = false, selectedTailNumber: selectedTailNumber, onJumpToNextTrip: onJumpToNextTrip, onJumpToPreviousTrip: onJumpToPreviousTrip, showTripJumpButtons: showTripJumpButtons = false, hasNextTrip: hasNextTrip = false, hasPreviousTrip: hasPreviousTrip = false, onViewSchedule: onViewSchedule, showViewScheduleButton: showViewScheduleButton = false, viewScheduleDisabled: viewScheduleDisabled = false })=>{
    // Use Zustand store for time range
    const { rangeStart: rangeStart, rangeEnd: rangeEnd, setTimeRange: setTimeRange, getDefaultWeekRange: getDefaultWeekRange } = (0, $aWoxc.useScheduleTimeRange)();
    // Update range when current time changes significantly (e.g., jumped to a different day)
    $acw62.useEffect(()=>{
        // Only update range if current time is truly outside the range
        // Allow currentTime to be exactly at the boundaries without triggering a range update
        const isCurrentTimeOutsideRange = currentTime.getTime() < rangeStart.getTime() - 1000 || currentTime.getTime() > rangeEnd.getTime() + 1000;
        if (isCurrentTimeOutsideRange) {
            const newRange = getDefaultWeekRange(currentTime);
            // Only update if the range would actually change
            if (newRange.start.getTime() !== rangeStart.getTime() || newRange.end.getTime() !== rangeEnd.getTime()) setTimeRange(newRange.start, newRange.end);
        }
    }, [
        currentTime,
        rangeStart,
        rangeEnd,
        setTimeRange,
        getDefaultWeekRange
    ]);
    const handleRangeChange = (start, end)=>{
        setTimeRange(start, end);
    };
    // Calendar menu state
    const [calendarAnchor, setCalendarAnchor] = $acw62.useState(null);
    const calendarOpen = Boolean(calendarAnchor);
    const handleCalendarClose = ()=>{
        setCalendarAnchor(null);
    };
    const handleDateSelect = (date)=>{
        if (date) {
            onTimeChange((0, $55RUj.snapToQuarterHour)(date));
            handleCalendarClose();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 0,
        sx: {
            ml: 4,
            mr: 6,
            maxHeight: "80px",
            // Prevent excessive height expansion
            overflow: "visible" // Allow dropdowns to overflow
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: {
                    xs: 1,
                    sm: 2
                },
                alignItems: "center",
                sx: {
                    padding: {
                        xs: 0.5,
                        sm: 1
                    },
                    flexWrap: {
                        xs: "wrap",
                        md: "nowrap"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f31e41b03b6202b3$export$77093a460b457117), {
                currentTime: currentTime,
                rangeStart: rangeStart,
                rangeEnd: rangeEnd,
                onTimeChange: onTimeChange,
                onRangeChange: handleRangeChange,
                tripCountsByDate: tripCountsByDate,
                showDateTimePicker: true,
                showNowButton: true,
                selectedTripStart: selectedTripStart,
                selectedTripEnd: selectedTripEnd,
                showTripDuration: showTripDuration,
                selectedTailNumber: selectedTailNumber,
                onJumpToNextTrip: onJumpToNextTrip,
                onJumpToPreviousTrip: onJumpToPreviousTrip,
                showTripJumpButtons: showTripJumpButtons,
                hasNextTrip: hasNextTrip,
                hasPreviousTrip: hasPreviousTrip,
                onViewSchedule: onViewSchedule,
                showViewScheduleButton: showViewScheduleButton,
                viewScheduleDisabled: viewScheduleDisabled
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
                anchorEl: calendarAnchor,
                open: calendarOpen,
                onClose: handleCalendarClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                PaperProps: {
                    sx: {
                        mt: 1,
                        "& .MuiPickersCalendarHeader-root": {
                            paddingLeft: 2,
                            paddingRight: 2
                        }
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
                    dateAdapter: (0, $78ow6.AdapterDateFns),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04218bd8a4dbb99$exports.StaticDatePicker), {
                        displayStaticWrapperAs: "desktop",
                        value: currentTime,
                        onChange: handleDateSelect,
                        slotProps: {
                            actionBar: {
                                actions: [
                                    "today"
                                ]
                            }
                        }
                    })
                })
            })
        ]
    });
};



var $kgjm7 = parcelRequire("kgjm7");

var $b4zZe = parcelRequire("b4zZe");
const $a5c1781b0223e0ab$export$9da61ba0edbfb550 = ({ id: id, stacks: stacks, setStacks: setStacks, isReference: isReference, isAlgorithmTesting: isAlgorithmTesting, baseHangar: baseHangar, scheduledHangar: scheduledHangar, currentTimestamp: currentTimestamp, initialLoading: initialLoading, isUpdating: isUpdating, isPending: isPending, hasLoadedOnce: hasLoadedOnce, hasNextTrip: hasNextTrip, hasPreviousTrip: hasPreviousTrip, showAddObstacleDialog: showAddObstacleDialog, isSchedulingEnabled: isSchedulingEnabled, isDrawerOpen: isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen, tenantTripMap: tenantTripMap, placementsInRange: placementsInRange, tripCountsByDate: tripCountsByDate, predefinedObstacles: predefinedObstacles, originalStackId: originalStackId, addedObstacles: addedObstacles, timeRange: timeRange, selectedTripInfo: selectedTripInfo, handleTimeChange: handleTimeChange, handleJumpToNextTrip: handleJumpToNextTrip, handleJumpToPreviousTrip: handleJumpToPreviousTrip, handleHangarChange: handleHangarChange, handleUndo: handleUndo, handleAircraftRemoval: handleAircraftRemoval, setShowAddObstacleDialog: setShowAddObstacleDialog, setRefreshKey: setRefreshKey, setAddedObstaclesWithLogging: setAddedObstaclesWithLogging, placementService: placementService })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        sx: {
            height: "100vh"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            width: isDrawerOpen ? "400px" : "125px",
                            // Match sidebar width
                            minWidth: isDrawerOpen ? "400px" : "125px",
                            // Prevent flex shrinking
                            flexShrink: 0,
                            // Disable flexbox shrinking
                            borderRight: 1,
                            borderColor: "divider",
                            p: isDrawerOpen ? 2 : 1 // Less padding when collapsed
                        },
                        children: isDrawerOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gGfi1.LocationNavigationHeader), {
                            locationName: baseHangar?.name || "",
                            locationId: id,
                            locationType: "hangar",
                            isSchedulingEnabled: isSchedulingEnabled,
                            rightActions: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                onClick: ()=>setIsDrawerOpen(false),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9uy2D))), {})
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                onClick: ()=>setIsDrawerOpen(true),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6lMlz))), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            flexGrow: 1,
                            pt: 2,
                            pb: 3
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ca7bd34565630016$export$af6201c40255f12e), {
                            currentTime: currentTimestamp,
                            onTimeChange: handleTimeChange,
                            tripCountsByDate: tripCountsByDate,
                            selectedTripStart: selectedTripInfo?.start,
                            selectedTripEnd: selectedTripInfo?.end,
                            showTripDuration: !!selectedTripInfo,
                            selectedTailNumber: selectedTripInfo?.tailNumber,
                            onJumpToNextTrip: handleJumpToNextTrip,
                            onJumpToPreviousTrip: handleJumpToPreviousTrip,
                            showTripJumpButtons: true,
                            hasNextTrip: hasNextTrip,
                            hasPreviousTrip: hasPreviousTrip
                        })
                    })
                ]
            }),
            isUpdating && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    position: "absolute",
                    top: 16,
                    right: 16,
                    zIndex: 1200,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    backgroundColor: "background.paper",
                    borderRadius: 1,
                    px: 1.5,
                    py: 0.5,
                    boxShadow: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                        size: 16
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            fontSize: "0.75rem",
                            color: "text.secondary"
                        },
                        children: "Updating..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                sx: {
                    flex: 1,
                    overflow: "hidden",
                    transition: "opacity 0.2s ease-in-out",
                    opacity: isPending ? 0.8 : 1
                },
                children: initialLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        p: 4
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            variant: "text",
                            width: "60%",
                            height: 40,
                            sx: {
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            variant: "rectangular",
                            width: "90%",
                            height: 400,
                            sx: {
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            width: "90%",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "30%",
                                    height: 100
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "30%",
                                    height: 100
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "30%",
                                    height: 100
                                })
                            ]
                        })
                    ]
                }) : scheduledHangar ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4zZe.HangarPresenterBase), {
                    id: id,
                    stacks: stacks,
                    setStacks: setStacks,
                    isReference: isReference,
                    isAlgorithmTesting: isAlgorithmTesting,
                    hangar: scheduledHangar,
                    setHangar: handleHangarChange,
                    history: {
                        undo: ()=>{}
                    },
                    isScheduledView: true,
                    onUndo: handleUndo,
                    scheduledViewProps: {
                        tenantTripMap: tenantTripMap,
                        placementService: placementService,
                        currentTime: currentTimestamp,
                        onScheduledUpdate: ()=>{
                            // Trigger a refresh after a short delay to ensure DB has updated
                            setTimeout(()=>{
                                setRefreshKey((prev)=>prev + 1);
                            }, 300);
                        },
                        timeRange: timeRange,
                        allPlacements: placementsInRange,
                        onRemoveAircraft: handleAircraftRemoval,
                        onTimeChange: handleTimeChange
                    },
                    onScheduledUpdate: ()=>{
                        // Trigger a refresh after a short delay to ensure DB has updated
                        setTimeout(()=>{
                            setRefreshKey((prev)=>prev + 1);
                        }, 300);
                    }
                }) : hasLoadedOnce ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fBVnr.EmptyState), {
                    title: "No Hangar Data Available",
                    description: "Unable to load hangar information for this time period. Try refreshing the page or selecting a different time.",
                    actionLabel: "Refresh",
                    onAction: ()=>setRefreshKey((prev)=>prev + 1)
                }) : null
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: showAddObstacleDialog,
                onClose: ()=>setShowAddObstacleDialog(false),
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Add Movable Obstacle"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        sx: {
                            width: 900,
                            height: 600
                        },
                        children: baseHangar && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kgjm7.MovableObstacleGrid), {
                            location: baseHangar,
                            movableObstacles: predefinedObstacles,
                            stack: {
                                ...baseHangar.stack,
                                id: originalStackId
                            },
                            setStack: (newStack)=>{
                                const baseObstacles = baseHangar.stack.movableObstacles || [];
                                const currentAdded = addedObstacles;
                                // Handle additions (removals are handled in handleHangarChange)
                                const updatedAdded = [];
                                const newlyAdded = [];
                                for (const obstacle of newStack.movableObstacles){
                                    const isFromBase = baseObstacles.find((base)=>base.id === obstacle.id);
                                    const isFromAdded = currentAdded.find((added)=>added.id === obstacle.id);
                                    if (isFromBase) continue;
                                    else if (isFromAdded) // Existing added obstacle - update position
                                    updatedAdded.push(obstacle);
                                    else // Truly new obstacle
                                    newlyAdded.push(obstacle);
                                }
                                // Update addedObstacles with position changes + new obstacles
                                const finalObstacles = [
                                    ...updatedAdded,
                                    ...newlyAdded
                                ];
                                setAddedObstaclesWithLogging(finalObstacles);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setShowAddObstacleDialog(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                onClick: ()=>{
                                    setShowAddObstacleDialog(false);
                                    // Don't clear addedObstacles - they should persist in scheduled view
                                    // The obstacles are saved to database but should remain visible
                                    // Trigger refresh to reload from database
                                    setRefreshKey((prev)=>prev + 1);
                                },
                                children: "Done"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const { useTransition: $04e95467c56025f2$var$useTransition } = $acw62;
// Predicate function to determine if a scheduled state change is meaningful for undo
const $04e95467c56025f2$var$isScheduledStateChangeMeaningful = (oldState, newState)=>{
    // If either state is null, it's meaningful
    if (!oldState?.scheduledHangar || !newState?.scheduledHangar) return true;
    // If timestamp changed, it's meaningful
    if (oldState.timestamp.getTime() !== newState.timestamp.getTime()) return true;
    // Check if hangar positions changed using existing logic
    const oldStateHash = (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify((0, $abvRu.extractImportantLocationState)(oldState.scheduledHangar)));
    const newStateHash = (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify((0, $abvRu.extractImportantLocationState)(newState.scheduledHangar)));
    return oldStateHash !== newStateHash;
};
const $04e95467c56025f2$export$9fd0d0f7bd5a185d = /*#__PURE__*/ $acw62.memo(({ id: id, stacks: stacks, setStacks: setStacks, isReference: isReference, isAlgorithmTesting: isAlgorithmTesting })=>{
    // URL-driven timestamp management with current time as default
    const { currentTime: currentTimestamp, setCurrentTime: setCurrentTimestamp } = (0, $ec443de9378d8cc1$export$3c41ae73890a1609)({
        defaultDate: new Date(),
        updateUrlOnMount: true
    });
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { predefinedObstacles: predefinedObstacles } = (0, $koS2J.usePredefinedObstacle)();
    const { isDrawerOpen: isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen } = (0, $3JLDK.useLayout)();
    const { rangeStart: rangeStart, rangeEnd: rangeEnd, setTimeRange: setTimeRange, getDefaultWeekRange: getDefaultWeekRange } = (0, $aWoxc.useScheduleTimeRange)();
    // Memoize PlacementService instance to avoid recreating on every render
    const placementService = $acw62.useMemo(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    // State for the base hangar structure and scheduled data
    const [baseHangar, setBaseHangar] = $acw62.useState(null);
    // Composite state for undo functionality (combines hangar state + timestamp)
    const [viewState, setViewState, undoViewState] = (0, $6TVXD.useStateHistory)({
        scheduledHangar: null,
        timestamp: currentTimestamp
    }, $04e95467c56025f2$var$isScheduledStateChangeMeaningful);
    // Extract current values for easier access
    const scheduledHangar = viewState?.scheduledHangar;
    const setScheduledHangar = $acw62.useCallback((newHangar)=>{
        setViewState({
            scheduledHangar: newHangar,
            timestamp: currentTimestamp
        });
    }, [
        setViewState,
        currentTimestamp
    ]);
    // Preserve original stack ID before it gets corrupted by synthetic scheduled stack
    const [originalStackId, setOriginalStackId] = $acw62.useState(null);
    // React 18 concurrent features for smooth date transitions
    const [isPending, startTransition] = $04e95467c56025f2$var$useTransition();
    const [initialLoading, setInitialLoading] = $acw62.useState(true);
    const [isUpdating, setIsUpdating] = $acw62.useState(false);
    const [hasLoadedOnce, setHasLoadedOnce] = $acw62.useState(false);
    // State to trigger refresh
    const [refreshKey, setRefreshKey] = $acw62.useState(0);
    // Track tenant ID -> trip ID mapping
    const [tenantTripMap, setTenantTripMap] = $acw62.useState(new Map());
    // State for placement data (needed for trip duration display)
    const [allPlacements, setAllPlacements] = $acw62.useState([]);
    // State for ALL placements in time range across all locations (for Timeline Aircraft)
    const [allPlacementsInTimeRange, setAllPlacementsInTimeRange] = $acw62.useState([]);
    // State for trip counts by date (used for calendar date picker indicators)
    // Efficiently loaded from database aggregation instead of client-side computation
    const [tripCountsByDate, setTripCountsByDate] = $acw62.useState(new Map());
    // State for next/previous trip availability
    const [hasNextTrip, setHasNextTrip] = $acw62.useState(false);
    const [hasPreviousTrip, setHasPreviousTrip] = $acw62.useState(false);
    // Aircraft-specific trip availability
    const [hasNextTripForAircraft, setHasNextTripForAircraft] = $acw62.useState(false);
    const [hasPreviousTripForAircraft, setHasPreviousTripForAircraft] = $acw62.useState(false);
    // Use global snackbar
    const snackbar = (0, $6fDLr.useSnackbar)();
    // State for Add Obstacle Dialog
    const [showAddObstacleDialog, setShowAddObstacleDialog] = $acw62.useState(false);
    // State for user-added obstacles (separate from baseHangar to avoid circular dependency)
    const [addedObstacles, setAddedObstacles] = $acw62.useState([]);
    // Add logging wrapper for setAddedObstacles
    const setAddedObstaclesWithLogging = $acw62.useCallback((newObstaclesOrUpdater)=>{
        if (typeof newObstaclesOrUpdater === "function") setAddedObstacles((prev)=>{
            const newValue = newObstaclesOrUpdater(prev);
            return newValue;
        });
        else setAddedObstacles(newObstaclesOrUpdater);
    }, []); // Empty dependencies to prevent infinite loops
    // Database functions handle placement changes atomically - no separate handler needed
    // Load base hangar structure (dimensions, obstacles, etc.)
    $acw62.useEffect(()=>{
        if (!postgrest || !activeFBO || !id) return;
        const loadBaseHangar = async ()=>{
            try {
                const hangar = await (0, $8GP8k.fetchHangar)(postgrest, activeFBO, id, isReference || false);
                setBaseHangar(hangar);
                // Capture the original real stack ID before it gets corrupted
                setOriginalStackId(hangar.stack.id);
            } catch (error) {
                console.error("Failed to load base hangar:", error);
                snackbar.notify({
                    text: "Failed to load hangar structure",
                    severity: "error"
                });
            }
        };
        loadBaseHangar();
    }, [
        postgrest,
        activeFBO,
        id,
        isReference
    ]);
    // Load all placements in the visible time range (for Active Trips metric)
    $acw62.useEffect(()=>{
        if (!postgrest || !id || !rangeStart || !rangeEnd) return;
        const fetchPlacementsInRange = async ()=>{
            try {
                // Fetch ALL trips (including unassigned) for search capability (1 year range)
                // Uses the comprehensive view that includes trips without placement assignments
                // HangarLeftPanel will filter this down to rangeStart/rangeEnd for timeline view
                const searchEndDate = new Date();
                searchEndDate.setFullYear(searchEndDate.getFullYear() + 1); // 1 year ahead
                const allPlacements = await placementService.getAllTripsWithPlacementStatus(rangeStart, // from timeline range start (includes currently active trips)
                searchEndDate // to 1 year from now
                );
                setAllPlacementsInTimeRange(allPlacements);
            } catch (error) {
                console.error("Failed to fetch placements in time range:", error);
            }
        };
        fetchPlacementsInRange();
    }, [
        postgrest,
        id,
        placementService,
        rangeStart,
        rangeEnd,
        refreshKey
    ]);
    // Load trip counts by date for calendar indicators (1 year range)
    $acw62.useEffect(()=>{
        if (!postgrest || !id) return;
        const fetchTripCounts = async ()=>{
            try {
                const startDate = rangeStart || new Date();
                const endDate = new Date(startDate);
                endDate.setFullYear(endDate.getFullYear() + 1); // 1 year ahead for calendar
                const counts = await placementService.getTripCountsByDate(startDate, endDate, id, "hangar");
                setTripCountsByDate(counts);
            } catch (error) {
                // Silent failure - calendar indicators are non-critical
                console.warn("Failed to load trip counts for calendar:", error);
            }
        };
        fetchTripCounts();
    }, [
        postgrest,
        id,
        placementService,
        rangeStart,
        refreshKey
    ]);
    // Compute selected trip info BEFORE using it in useEffect below
    const selectedTripInfo = $acw62.useMemo(()=>{
        if (!scheduledHangar?.stack?.tenants) return null;
        const selectedTenant = scheduledHangar.stack.tenants.find((tenant)=>tenant.selected);
        if (!selectedTenant) return null;
        const tripId = tenantTripMap.get(selectedTenant.id);
        if (!tripId) return null;
        // Find the trip placement to get the trip data
        // Note: allPlacements only has one placement per trip (deduplicated)
        // TODO: To support multi-segment trips in HangarView, need to use a different data source
        const tripPlacement = allPlacements.find((placement)=>placement.trip_id === tripId);
        if (!tripPlacement) return null;
        // Use the full trip dates from the placement data - try different property names
        const startDate = tripPlacement.arrival_date || tripPlacement.start_time;
        const endDate = tripPlacement.departure_date || tripPlacement.end_time;
        return {
            start: new Date(startDate),
            end: new Date(endDate),
            tailNumber: selectedTenant.tail_number
        };
    }, [
        scheduledHangar?.stack?.tenants,
        tenantTripMap,
        allPlacements
    ]);
    // Check for next/previous trips availability
    $acw62.useEffect(()=>{
        if (!placementService || !id || !currentTimestamp) return;
        const checkTripAvailability = async ()=>{
            try {
                // Always check location-wide trips
                const [nextTrip, previousTrip] = await Promise.all([
                    placementService.getNextTripTime(id, "hangar", currentTimestamp),
                    placementService.getPreviousTripTime(id, "hangar", currentTimestamp)
                ]);
                setHasNextTrip(!!nextTrip);
                setHasPreviousTrip(!!previousTrip);
                // If aircraft selected, also check aircraft-specific trips
                if (selectedTripInfo?.tailNumber) {
                    const [nextAircraftTrip, previousAircraftTrip] = await Promise.all([
                        placementService.getNextTripTimeForAircraft(selectedTripInfo.tailNumber, currentTimestamp, id, "hangar"),
                        placementService.getPreviousTripTimeForAircraft(selectedTripInfo.tailNumber, currentTimestamp, id, "hangar")
                    ]);
                    setHasNextTripForAircraft(!!nextAircraftTrip);
                    setHasPreviousTripForAircraft(!!previousAircraftTrip);
                } else {
                    // No aircraft selected, clear aircraft-specific state
                    setHasNextTripForAircraft(false);
                    setHasPreviousTripForAircraft(false);
                }
            } catch (error) {
                console.error("Failed to check trip availability:", error);
            }
        };
        checkTripAvailability();
    }, [
        placementService,
        id,
        currentTimestamp,
        selectedTripInfo,
        refreshKey
    ]);
    // Load scheduled placement data when timestamp changes
    $acw62.useEffect(()=>{
        if (!postgrest || !activeFBO || !baseHangar || !currentTimestamp) // Don't set loading false here - let the data fetch complete first
        return;
        const loadScheduledData = async ()=>{
            // Only show loading on initial load, keep previous data visible during date changes
            if (!scheduledHangar) setInitialLoading(true);
            // Don't set isUpdating during date changes - keep previous content visible
            try {
                // 1. Fetch placements at the current timestamp
                const allPlacements = await placementService.getPlacementsAtTime(currentTimestamp);
                // 2. Filter placements for this hangar
                const hangarPlacements = allPlacements.filter((p)=>p.hangar_id === id);
                // 2.1 Deduplicate placements by trip_id (keep most recent)
                const placementMap = new Map();
                hangarPlacements.forEach((placement)=>{
                    const existing = placementMap.get(placement.trip_id);
                    if (!existing || new Date(placement.created_at) > new Date(existing.created_at)) placementMap.set(placement.trip_id, placement);
                });
                const deduplicatedPlacements = Array.from(placementMap.values());
                // Log if duplicates were found
                deduplicatedPlacements.length, hangarPlacements.length;
                // Store placement data in state for trip duration display (use deduplicated)
                setAllPlacements(deduplicatedPlacements);
                // 3. Extract unique aircraft IDs and fetch aircraft data
                const aircraftIds = deduplicatedPlacements.map((p)=>p.aircraft_id).filter((id)=>id != null);
                const aircrafts = aircraftIds.length > 0 ? await (0, $8GP8k.fetchAircraftWithCache)(postgrest, aircraftIds, activeFBO) : [];
                // 4. Create aircraft lookup map
                const aircraftMap = new Map();
                aircrafts.forEach((aircraft)=>{
                    aircraftMap.set(aircraft.id, aircraft);
                });
                // 5. Create scheduled stack ID - use stable ID to prevent remounting
                const scheduledStackId = baseHangar.stack.id;
                // Build trip ID map
                const tripMap = new Map();
                // Find currently selected tenant's tail number to preserve selection across time changes
                const currentlySelectedTailNumber = scheduledHangar?.stack?.tenants?.find((t)=>t.selected)?.tail_number;
                // Transform placements to tenants format
                const scheduledTenants = deduplicatedPlacements.map((placement)=>{
                    const aircraft = placement.aircraft_id ? aircraftMap.get(placement.aircraft_id) : undefined;
                    // Fail fast if aircraft data is missing
                    if (!aircraft) throw new Error(`Missing aircraft data for placement ${placement.id} (aircraft_id: ${placement.aircraft_id}, tail_number: ${placement.tail_number}). ` + `This indicates a data integrity issue - aircraft records should exist for all scheduled placements.`);
                    const tenantId = `scheduled-trip-${placement.trip_id}`;
                    // Store the mapping
                    tripMap.set(tenantId, placement.trip_id);
                    return {
                        id: tenantId,
                        fbo_id: baseHangar.fbo_id,
                        entity_id: placement.entity_id || `entity-${placement.trip_id}`,
                        placement_id: placement.id,
                        aircraft_id: placement.aircraft_id || "",
                        type: placement.aircraft_type || "transient",
                        tail_number: placement.tail_number || "Unknown",
                        owner_manager: placement.owner_manager || "",
                        trip_id: placement.trip_id,
                        aircraft: aircraft,
                        created_at: placement.start_time,
                        // Preserve selection state for the same aircraft across time changes
                        selected: currentlySelectedTailNumber === placement.tail_number,
                        position: {
                            id: `position-${placement.id}`,
                            stack_id: scheduledStackId,
                            // Use the scheduled stack ID, not the base hangar stack ID
                            entity_id: placement.entity_id || `entity-${placement.trip_id}`,
                            x: placement.x,
                            y: placement.y,
                            angle: placement.angle,
                            preferences: aircraft ? (0, $lNEp2.defaultPreferenceForAircraft)(aircraft, activeFBO) : [],
                            timestamp: placement.start_time ? new Date(placement.start_time).getTime() : Date.now() // Use placement start time (changes when position changes)
                        },
                        suggestedPositions: [],
                        note: `Trip: ${placement.trip_id}`,
                        note_last_updated_by: "scheduling",
                        note_last_updated: new Date().toISOString()
                    };
                });
                // Log any remaining duplicates for monitoring
                (0, $3dLiv.detectAndLogDuplicates)(scheduledTenants, `ScheduledHangarView-${id}`);
                // 6. Create scheduled stack
                // Merge base obstacles (from database) with user-added obstacles
                const allObstacles = [
                    ...baseHangar.stack.movableObstacles || [],
                    ...addedObstacles
                ];
                const scheduledMovableObstacles = allObstacles.map((obstacle)=>{
                    return {
                        ...obstacle,
                        position: {
                            ...obstacle.position,
                            stack_id: scheduledStackId // Update to match scheduled stack ID
                        }
                    };
                });
                const scheduledStack = {
                    id: scheduledStackId,
                    name: `Scheduled View - ${currentTimestamp.toLocaleString()}`,
                    location_id: baseHangar.id,
                    isReference: false,
                    tenants: scheduledTenants,
                    movableObstacles: scheduledMovableObstacles,
                    options: baseHangar.stack.options
                };
                // 7. Create complete scheduled hangar object
                const scheduledHangarData = {
                    ...baseHangar,
                    stack: scheduledStack,
                    stacks: [
                        scheduledStack
                    ] // Replace stacks with just the scheduled one
                };
                // Wrap state updates in startTransition to prevent remounting
                startTransition(()=>{
                    setScheduledHangar(scheduledHangarData);
                    setTenantTripMap(tripMap);
                    setHasLoadedOnce(true);
                });
            } catch (error) {
                console.error("Failed to load scheduled data:", error);
                snackbar.notify({
                    text: "Failed to load scheduled placement data",
                    severity: "error"
                });
                setHasLoadedOnce(true);
            } finally{
                setInitialLoading(false);
                setIsUpdating(false);
            }
        };
        loadScheduledData();
    }, [
        postgrest,
        activeFBO,
        baseHangar,
        currentTimestamp,
        id,
        refreshKey,
        addedObstacles
    ]);
    // Note: baseHangar back in dependencies so effect runs when base data loads
    // Handler for time changes - now managed by URL hook which handles snapping
    const handleTimeChange = $acw62.useCallback((newTime)=>{
        setCurrentTimestamp(newTime); // URL hook handles snapping internally
        // Update the viewState to track time changes for undo
        if (scheduledHangar) setViewState({
            scheduledHangar: scheduledHangar,
            timestamp: newTime
        });
    }, [
        setCurrentTimestamp,
        scheduledHangar,
        setViewState
    ]);
    // Handler for jumping to next trip
    const handleJumpToNextTrip = $acw62.useCallback(async ()=>{
        if (!placementService || !id) return;
        try {
            // Simple: if aircraft selected, search for that aircraft. Otherwise, any aircraft.
            const nextTripTime = selectedTripInfo?.tailNumber ? await placementService.getNextTripTimeForAircraft(selectedTripInfo.tailNumber, currentTimestamp, id, "hangar") : await placementService.getNextTripTime(id, "hangar", currentTimestamp);
            if (nextTripTime) {
                // Navigate to the next trip
                const snappedTime = (0, $55RUj.ceilToQuarterHour)(nextTripTime);
                setCurrentTimestamp(snappedTime);
                // Update time range
                const { start: newStart, end: newEnd } = getDefaultWeekRange(snappedTime);
                setTimeRange(newStart, newEnd);
            }
        } catch (error) {
            console.error("Failed to jump to next trip:", error);
            snackbar.notify({
                text: "Failed to jump to next trip",
                severity: "error"
            });
        }
    }, [
        placementService,
        id,
        currentTimestamp,
        setCurrentTimestamp,
        getDefaultWeekRange,
        setTimeRange,
        selectedTripInfo
    ]);
    // Handler for jumping to previous trip
    const handleJumpToPreviousTrip = $acw62.useCallback(async ()=>{
        if (!placementService || !id) return;
        try {
            // Simple: if aircraft selected, search for that aircraft. Otherwise, any aircraft.
            const previousTripTime = selectedTripInfo?.tailNumber ? await placementService.getPreviousTripTimeForAircraft(selectedTripInfo.tailNumber, currentTimestamp, id, "hangar") : await placementService.getPreviousTripTime(id, "hangar", currentTimestamp);
            if (previousTripTime) {
                // Navigate to the previous trip
                const snappedTime = (0, $55RUj.floorToQuarterHour)(previousTripTime);
                setCurrentTimestamp(snappedTime);
                // Update time range
                const { start: newStart, end: newEnd } = getDefaultWeekRange(snappedTime);
                setTimeRange(newStart, newEnd);
            }
        } catch (error) {
            console.error("Failed to jump to previous trip:", error);
            snackbar.notify({
                text: "Failed to jump to previous trip",
                severity: "error"
            });
        }
    }, [
        placementService,
        id,
        currentTimestamp,
        setCurrentTimestamp,
        getDefaultWeekRange,
        setTimeRange,
        selectedTripInfo
    ]);
    // Handler for undo - restores both hangar state and timestamp
    const handleUndo = $acw62.useCallback(()=>{
        const previousState = undoViewState();
        if (previousState) {
            // Restore the timestamp first
            setCurrentTimestamp(previousState.timestamp);
            // The hangar state is already restored by undoViewState
            // Trigger a refresh to ensure UI is consistent
            setRefreshKey((prev)=>prev + 1);
        }
    }, [
        undoViewState,
        setCurrentTimestamp,
        setRefreshKey
    ]);
    // Handler for hangar changes (when user drags aircraft in scheduled view)
    const handleHangarChange = $acw62.useCallback(async (updatedHangar)=>{
        // Update the scheduled hangar immediately for UI feedback
        setScheduledHangar(updatedHangar);
        if (!scheduledHangar || !postgrest) return;
        try {
            // Get current placements for comparison
            const oldTenants = scheduledHangar.stack.tenants;
            const newTenants = updatedHangar.stack.tenants;
            const oldObstacles = scheduledHangar.stack.movableObstacles;
            const newObstacles = updatedHangar.stack.movableObstacles;
            // Handle aircraft/tenant removals first
            for (const oldTenant of oldTenants){
                const stillExists = newTenants.find((t)=>t.id === oldTenant.id);
                if (!stillExists) {
                    // Tenant was removed
                    const tripId = tenantTripMap.get(oldTenant.id);
                    if (tripId) {
                        // Remove from location using the placement service
                        const startTimeISO = currentTimestamp.toISOString();
                        await placementService.assignToLocationWithGapFilling(tripId, null, // null location means unassigned
                        null, startTimeISO, undefined, true, // excludeConflicts
                        {
                            x: null,
                            y: null,
                            angle: null
                        });
                    }
                }
            }
            // Handle aircraft/tenant position changes
            for (const newTenant of newTenants){
                const oldTenant = oldTenants.find((t)=>t.id === newTenant.id);
                if (!oldTenant) continue; // Skip new tenants (shouldn't happen in scheduled view)
                const oldPos = oldTenant.position;
                const newPos = newTenant.position;
                // Check if position changed (x, y, angle)
                const positionChanged = oldPos.x !== newPos.x || oldPos.y !== newPos.y || oldPos.angle !== newPos.angle;
                if (positionChanged) {
                    // Get trip ID from our map
                    const tripId = tenantTripMap.get(newTenant.id);
                    if (!tripId) {
                        console.error("No trip ID found for tenant:", newTenant.id);
                        continue;
                    }
                    // Use database function to handle the placement change atomically
                    // This ensures the aircraft stays in the new position until explicitly moved again
                    await placementService.moveAircraftAtTime(tripId, id, // hangar id
                    "hangar", currentTimestamp, // When the move happens
                    {
                        x: newPos.x,
                        y: newPos.y,
                        angle: newPos.angle
                    });
                }
            }
            // Handle movable obstacle position changes
            for (const newObstacle of newObstacles){
                const oldObstacle = oldObstacles.find((o)=>o.id === newObstacle.id);
                if (!oldObstacle) continue; // Skip new obstacles (shouldn't happen in scheduled view)
                const oldPos = oldObstacle.position;
                const newPos = newObstacle.position;
                // Check if obstacle position changed (x, y, angle)
                const obstaclePositionChanged = oldPos.x !== newPos.x || oldPos.y !== newPos.y || oldPos.angle !== newPos.angle;
                if (obstaclePositionChanged) {
                    // Check if this obstacle is from base or added obstacles
                    const isFromBase = baseHangar?.stack.movableObstacles.find((mo)=>mo.id === newObstacle.id);
                    const isFromAdded = addedObstacles.find((mo)=>mo.id === newObstacle.id);
                    if (isFromBase && baseHangar) {
                        // Update the base hangar's movable obstacle position
                        const updatedBaseHangar = {
                            ...baseHangar,
                            stack: {
                                ...baseHangar.stack,
                                movableObstacles: baseHangar.stack.movableObstacles.map((mo)=>mo.id === newObstacle.id ? newObstacle : mo)
                            }
                        };
                        setBaseHangar(updatedBaseHangar);
                    } else if (isFromAdded) // Update the added obstacles state
                    setAddedObstaclesWithLogging(addedObstacles.map((mo)=>mo.id === newObstacle.id ? newObstacle : mo));
                    // Save obstacle position change to database immediately
                    try {
                        await postgrest.from("position").upsert({
                            id: newObstacle.position.id,
                            stack_id: baseHangar?.stack.id,
                            // Use base stack ID for persistence
                            entity_id: newObstacle.entity_id,
                            x: newObstacle.position.x,
                            y: newObstacle.position.y,
                            angle: newObstacle.position.angle,
                            preferences: newObstacle.position.preferences || []
                        });
                    } catch (error) {
                        console.error("Failed to save obstacle position:", error);
                        snackbar.notify({
                            text: "Failed to save obstacle position",
                            severity: "error"
                        });
                    }
                }
            }
            // Handle movable obstacle removals
            const currentObstacleCount = scheduledHangar.stack.movableObstacles.length;
            const newObstacleCount = updatedHangar.stack.movableObstacles.length;
            if (newObstacleCount < currentObstacleCount) {
                // Find removed obstacles
                const removedObstacles = scheduledHangar.stack.movableObstacles.filter((oldObstacle)=>!updatedHangar.stack.movableObstacles.find((newObs)=>newObs.id === oldObstacle.id));
                for (const removed of removedObstacles){
                    // Check if it's from base or added obstacles
                    const isFromBase = baseHangar?.stack.movableObstacles.find((base)=>base.id === removed.id);
                    const isFromAdded = addedObstacles.find((added)=>added.id === removed.id);
                    if (isFromBase && baseHangar) {
                        // Delete from database and update base hangar
                        await postgrest.from("position").delete().eq("id", removed.position.id);
                        await postgrest.from("movable_obstacle").delete().eq("id", removed.id);
                        const updatedBaseHangar = {
                            ...baseHangar,
                            stack: {
                                ...baseHangar.stack,
                                movableObstacles: baseHangar.stack.movableObstacles.filter((obs)=>obs.id !== removed.id)
                            }
                        };
                        setBaseHangar(updatedBaseHangar);
                    } else if (isFromAdded) // Remove from added obstacles state
                    setAddedObstacles((prev)=>prev.filter((obs)=>obs.id !== removed.id));
                }
            }
        } catch (error) {
            console.error("Failed to save hangar changes:", error);
            // Error handling via snackbar if needed
            snackbar.notify({
                text: error.message || "Failed to save changes",
                severity: "error"
            });
        }
    }, [
        scheduledHangar,
        baseHangar,
        setBaseHangar,
        addedObstacles,
        postgrest,
        currentTimestamp,
        id,
        tenantTripMap,
        snackbar
    ]);
    // Handler for aircraft removal - only updates local state
    // The database update happens through handleHangarChange
    const handleAircraftRemoval = $acw62.useCallback((tenantId)=>{
        if (!scheduledHangar) return;
        // Update the local state (this will be captured for undo)
        const updatedHangar = {
            ...scheduledHangar,
            stack: {
                ...scheduledHangar.stack,
                tenants: scheduledHangar.stack.tenants.filter((t)=>t.id !== tenantId)
            }
        };
        // Update through handleHangarChange which will:
        // 1. Update local state (for immediate UI feedback)
        // 2. Trigger database sync (handleHangarChange handles this)
        // 3. Enable proper undo (state is tracked before change)
        handleHangarChange(updatedHangar);
    }, [
        scheduledHangar,
        handleHangarChange
    ]);
    // Navigation options for the location dropdown
    const isSchedulingEnabled = activeFBO?.settings?.enableScheduling ?? false;
    // Use the actual time range from the store for metrics
    const timeRange = $acw62.useMemo(()=>({
            start: rangeStart,
            end: rangeEnd
        }), [
        rangeStart,
        rangeEnd
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c1781b0223e0ab$export$9da61ba0edbfb550), {
        id: id,
        stacks: stacks,
        setStacks: setStacks,
        isReference: isReference,
        isAlgorithmTesting: isAlgorithmTesting,
        baseHangar: baseHangar,
        scheduledHangar: scheduledHangar,
        currentTimestamp: currentTimestamp,
        initialLoading: initialLoading,
        isUpdating: isUpdating,
        isPending: isPending,
        hasLoadedOnce: hasLoadedOnce,
        hasNextTrip: selectedTripInfo?.tailNumber ? hasNextTripForAircraft : hasNextTrip,
        hasPreviousTrip: selectedTripInfo?.tailNumber ? hasPreviousTripForAircraft : hasPreviousTrip,
        showAddObstacleDialog: showAddObstacleDialog,
        isSchedulingEnabled: isSchedulingEnabled,
        isDrawerOpen: isDrawerOpen,
        setIsDrawerOpen: setIsDrawerOpen,
        tenantTripMap: tenantTripMap,
        placementsInRange: allPlacementsInTimeRange,
        tripCountsByDate: tripCountsByDate,
        predefinedObstacles: predefinedObstacles,
        originalStackId: originalStackId,
        addedObstacles: addedObstacles,
        timeRange: timeRange,
        selectedTripInfo: selectedTripInfo,
        handleTimeChange: handleTimeChange,
        handleJumpToNextTrip: handleJumpToNextTrip,
        handleJumpToPreviousTrip: handleJumpToPreviousTrip,
        handleHangarChange: handleHangarChange,
        handleUndo: handleUndo,
        handleAircraftRemoval: handleAircraftRemoval,
        setShowAddObstacleDialog: setShowAddObstacleDialog,
        setRefreshKey: setRefreshKey,
        setAddedObstaclesWithLogging: setAddedObstaclesWithLogging,
        placementService: placementService
    });
});


const $7d34f26ec0edecbf$export$d6bb8b8b30f49857 = ({ hangarId: hangarId })=>{
    const { id: hangarIdFromRoute } = (0, $aphAM.useParams)();
    const [stacks, setStacks] = $acw62.useState([]);
    return(// Same container structure as regular Hangar component
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
            isReference: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggtZr.HangarStateContainer), {
                initialState: {
                    hangar_id: hangarId ?? hangarIdFromRoute,
                    isReference: false
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRWDn.PredefinedObstaclesContainer), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6AlVH.TowingEquipmentContainer), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04e95467c56025f2$export$9fd0d0f7bd5a185d), {
                            id: hangarIdFromRoute,
                            stacks: stacks,
                            setStacks: setStacks,
                            isReference: false,
                            isAlgorithmTesting: false
                        })
                    })
                })
            })
        })
    }));
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $ggtZr = parcelRequire("ggtZr");

var $6AlVH = parcelRequire("6AlVH");

var $gvs0W = parcelRequire("gvs0W");
const $6cad12db4323dccc$export$b65f3ee0bce9c66c = ({ hangarId: hangarId, isReference: isReference })=>{
    const { id: hangarIdFromRoute } = (0, $aphAM.useParams)();
    const [stacks, setStacks] = $acw62.useState([]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggtZr.HangarStateContainer), {
        initialState: {
            hangar_id: hangarId ?? hangarIdFromRoute,
            isReference: isReference ?? false
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6AlVH.TowingEquipmentContainer), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gvs0W.HangarPresenter), {
                id: hangarId ?? hangarIdFromRoute,
                isAlgorithmTesting: true,
                stacks: stacks,
                setStacks: setStacks,
                isReference: isReference
            })
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7FzhI = parcelRequire("7FzhI");

var $jRWDn = parcelRequire("jRWDn");

var $3AGzj = parcelRequire("3AGzj");

var $6AlVH = parcelRequire("6AlVH");

var $ayMG0 = parcelRequire("ayMG0");

var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $gqehT = parcelRequire("gqehT");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $eYWyk = parcelRequire("eYWyk");

var $d199i = parcelRequire("d199i");

var $hdCOT = parcelRequire("hdCOT");
const $d977a2d2296ce41c$export$658fb009ff801842 = async (hangar, paramSets, airplxIdentity, airplxToken, onUpdate)=>{
    const N_WORKER_THREADS = 18;
    const limit = (0, (/*@__PURE__*/$parcel$interopDefault($d199i)))(N_WORKER_THREADS);
    const currentLayoutOptions = paramSets.map((paramSet)=>({
            paramSet: paramSet,
            stackMembers: []
        }));
    const progress = paramSets.map(()=>0);
    const doit = paramSets.map(async (paramsWithLabel, idx)=>{
        return limit(async ()=>{
            const { label: _label, ...paramsWithoutLabel } = paramsWithLabel;
            let cntr = 0;
            /**
       * We get incremental updates as airplanes are being put into the hangar. So let's
       * show them to the user! TECHNOLOGY!
       */ for await (let stackMembers of (0, $hdCOT.placeIncrementally)(paramsWithoutLabel, hangar.stack.tenants, airplxIdentity, airplxToken)){
                currentLayoutOptions[idx] = {
                    ...currentLayoutOptions[idx],
                    stackMembers: stackMembers
                };
                cntr++;
                // somewhat surprisingly, this stuff still works even though we're now
                // in a function. not exactly sure why...
                progress[idx] = cntr / paramsWithLabel.aircrafts_to_place.length;
                onUpdate([
                    ...currentLayoutOptions
                ], progress);
            }
            progress[idx] = 1;
            onUpdate([
                ...currentLayoutOptions
            ], progress);
        });
    });
    await Promise.all(doit);
    onUpdate([
        ...currentLayoutOptions
    ], progress);
};



var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $keHtM = parcelRequire("keHtM");

var $ayMG0 = parcelRequire("ayMG0");

var $dqlTG = parcelRequire("dqlTG");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $6Q1H5 = parcelRequire("6Q1H5");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4NpFa = parcelRequire("4NpFa");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $bPDWy = parcelRequire("bPDWy");

var $7qEX0 = parcelRequire("7qEX0");

var $iPcdL = parcelRequire("iPcdL");

var $6hiu6 = parcelRequire("6hiu6");

var $8NnpI = parcelRequire("8NnpI");
const $744fbb4a819a6eab$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $744fbb4a819a6eab$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $744fbb4a819a6eab$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $c00d6b0248767160$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $c00d6b0248767160$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $c00d6b0248767160$var$selfColumnsVar = '--Grid-columns';
const $c00d6b0248767160$var$parentColumnsVar = '--Grid-parent-columns';
const $c00d6b0248767160$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $744fbb4a819a6eab$export$e04173f1577f18b7)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$c00d6b0248767160$var$parentColumnsVar}) - (var(${$c00d6b0248767160$var$parentColumnsVar}) - ${value}) * (var(${$c00d6b0248767160$var$getParentSpacingVar('column')}) / var(${$c00d6b0248767160$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $c00d6b0248767160$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $744fbb4a819a6eab$export$e04173f1577f18b7)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$c00d6b0248767160$var$parentColumnsVar}) + var(${$c00d6b0248767160$var$getParentSpacingVar('column')}) * ${value} / var(${$c00d6b0248767160$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $c00d6b0248767160$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$c00d6b0248767160$var$selfColumnsVar]: 12
    };
    (0, $744fbb4a819a6eab$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$c00d6b0248767160$var$selfColumnsVar]: columns,
            '> *': {
                [$c00d6b0248767160$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $c00d6b0248767160$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $744fbb4a819a6eab$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$c00d6b0248767160$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$c00d6b0248767160$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $c00d6b0248767160$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $744fbb4a819a6eab$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$c00d6b0248767160$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$c00d6b0248767160$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $c00d6b0248767160$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $744fbb4a819a6eab$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $c00d6b0248767160$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$c00d6b0248767160$var$getSelfSpacingVar('row')}) var(${$c00d6b0248767160$var$getSelfSpacingVar('column')})`
        }
    };
};
const $c00d6b0248767160$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $c00d6b0248767160$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $c00d6b0248767160$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};


const $53f6674693b584fd$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://v6.mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $53f6674693b584fd$var$warnedAboutProps = [];
function $53f6674693b584fd$export$2e2bcd8739ae039(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}



var $ayMG0 = parcelRequire("ayMG0");
const $f43dbe240d50ecec$var$defaultTheme = (0, $8NnpI.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $f43dbe240d50ecec$var$defaultCreateStyledComponent = (0, $bPDWy.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $f43dbe240d50ecec$var$useThemePropsDefault(props) {
    return (0, $7qEX0.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $f43dbe240d50ecec$var$defaultTheme
    });
}
function $f43dbe240d50ecec$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $f43dbe240d50ecec$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $f43dbe240d50ecec$var$useThemePropsDefault, useTheme: useTheme = (0, $iPcdL.default), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $c00d6b0248767160$export$a7c8efbe2b138a60)(direction),
                ...(0, $c00d6b0248767160$export$e2d1175061442d38)(size),
                ...container ? (0, $c00d6b0248767160$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $c00d6b0248767160$export$ccc4d4a4923f1b06), (0, $c00d6b0248767160$export$a89c28919b8e3bb5), (0, $c00d6b0248767160$export$68c4dad72dd49c74), (0, $c00d6b0248767160$export$84053369756c53db), (0, $c00d6b0248767160$export$2a0a3c01032b3f4), (0, $c00d6b0248767160$export$810b8c3ab5d46bf), (0, $c00d6b0248767160$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $6hiu6.default)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $53f6674693b584fd$export$2e2bcd8739ae039)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            children: $acw62.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $acw62.isValidElement(child) && (0, $4NpFa.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $acw62.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $14H9o = parcelRequire("14H9o");
'use client';
/**
 *
 * Demos:
 *
 * - [Grid version 2](https://v6.mui.com/material-ui/react-grid2/)
 *
 * API:
 *
 * - [Grid2 API](https://v6.mui.com/material-ui/api/grid-2/)
 */ const $e427cceb5e1ecc90$var$Grid2 = (0, $f43dbe240d50ecec$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiGrid2',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid2',
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid2'
        }),
    useTheme: $14H9o.default
});
var $e427cceb5e1ecc90$export$2e2bcd8739ae039 = $e427cceb5e1ecc90$var$Grid2;


var $9Lykx = parcelRequire("9Lykx");
var $1lfQl = parcelRequire("1lfQl");
var $30UGG = parcelRequire("30UGG");
var $elyLx = parcelRequire("elyLx");
var $2XjE0 = parcelRequire("2XjE0");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ciKN1 = parcelRequire("ciKN1");

var $5KGQl = parcelRequire("5KGQl");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $brzp3 = parcelRequire("brzp3");

var $kPMZ3 = parcelRequire("kPMZ3");
const $80382670c874bc6e$export$54fd5f9a981bd35 = ({ result: result })=>{
    const [showStacks, setShowStacks] = $acw62.useState(false);
    const resultStacks = $acw62.useMemo(()=>{
        return result.layoutOptions.map((layout)=>{
            const id = (0, $lNEp2.uuidv4)();
            const stack = {
                id: id,
                options: layout.paramSet.options,
                tenants: layout.stackMembers.map((stackMember)=>({
                        ...result.hangar.stack.tenants.find((t)=>t.placement_id === stackMember.placement_id),
                        selected: false,
                        // overwrite or keep?
                        position: {
                            ...result.hangar.stack.tenants.find((t)=>t.placement_id === stackMember.placement_id).position,
                            x: stackMember.x,
                            y: stackMember.y,
                            angle: stackMember.angle,
                            stack_id: id
                        }
                    })),
                movableObstacles: result.hangar.stack.movableObstacles,
                isReference: result.hangar.stack.isReference
            };
            const polygons = (0, $5KGQl.getStackPolygons)(stack, result.hangar.width, 1);
            return {
                stack: stack,
                polygons: polygons,
                utilization: (0, $kPMZ3.calculateUtilization)(result.hangar, polygons, true)
            };
        });
    }, [
        result.layoutOptions
    ]);
    const formatNumberInHangar = (value)=>{
        if (isNaN(value) || value === Infinity || value === -Infinity) return "---";
        return (0, $lNEp2.formatNumber)(value, 0);
    };
    const worstInHangar = formatNumberInHangar(Math.min(...resultStacks.map(({ stack: stack })=>stack.tenants.filter(({ position: position })=>position.x != null).length)));
    const bestInHangar = formatNumberInHangar(Math.max(...resultStacks.map(({ stack: stack })=>stack.tenants.filter(({ position: position })=>position.x != null).length)));
    const averageInHangar = formatNumberInHangar((0, $cLNZr.sum)(resultStacks.map(({ stack: stack })=>stack.tenants.filter(({ position: position })=>position.x != null).length)) / resultStacks.length);
    const formatUtilization = (value)=>{
        if (isNaN(value) || value === Infinity || value === -Infinity) return "---";
        return (0, $lNEp2.formatPercentage)(value / 100, 0);
    };
    const worstUtilization = formatUtilization(Math.min(...resultStacks.map((stack)=>stack.utilization)));
    const bestUtilization = formatUtilization(Math.max(...resultStacks.map((stack)=>stack.utilization)));
    const averageUtilization = formatUtilization((0, $cLNZr.sum)(resultStacks.map((stack)=>stack.utilization)) / resultStacks.length);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: result.hangar.name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                children: [
                    "[",
                    result.hangar.left_door,
                    ", ",
                    result.hangar.right_door,
                    "]"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {
                    variant: "determinate",
                    color: "success",
                    value: (0, $cLNZr.sum)(result.progress) / result.progress.length * 100,
                    sx: {
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: worstInHangar
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: bestInHangar
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: averageInHangar
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: worstUtilization
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: bestUtilization
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: averageUtilization
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            color: "primary",
                            size: "small",
                            onClick: ()=>setShowStacks(true),
                            children: "View"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MV2p.default), {
                            open: showStacks,
                            maxWidth: "lg",
                            fullWidth: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "h6",
                                                children: result.hangar.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                onClick: ()=>setShowStacks(false),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 2,
                                        children: resultStacks.map(({ stack: stack })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
                                                size: {
                                                    xs: 6
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciKN1.AutocompleteResultsContainer), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brzp3.StackResult), {
                                                        readOnly: true,
                                                        status: "complete",
                                                        hangar: result.hangar,
                                                        setHangar: ()=>{},
                                                        stack: stack,
                                                        onClose: ()=>setShowStacks(false),
                                                        onFlagResult: async ()=>{}
                                                    })
                                                })
                                            }, stack.id))
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }, result.id);
};


const $035142c70be0be84$export$6749cfaea4d6423b = ({ aircrafts: aircrafts, results: results, onClickRun: onClickRun })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                spacing: 8,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        fullWidth: true,
                        variant: "contained",
                        color: "error",
                        onClick: ()=>{
                            window.globalThis.airplxKillSwitch = 1;
                            window.globalThis?.airplxAborter?.abort();
                        },
                        children: "Stop"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        fullWidth: true,
                        variant: "contained",
                        disabled: aircrafts.length === 0,
                        onClick: ()=>onClickRun({
                                wall_spacing_left: 2,
                                wall_spacing_back: 2,
                                wall_spacing_right: 2,
                                horizontal_spacing: 2,
                                vertical_spacing: 2,
                                overlap: false,
                                ignore_nose_in_out: false,
                                ignore_front_back: false,
                                ignore_outside_hangar: false,
                                tug_spacing: 2,
                                density_threshold: 0.8,
                                corner_strategies: [
                                    [
                                        (0, $keHtM.CornerStrategy).ANGLE_45,
                                        (0, $keHtM.CornerStrategy).ANGLE_45
                                    ]
                                ],
                                cloud_position_prioritization: false,
                                xy_weights: [
                                    1,
                                    1
                                ],
                                towing_equipment_id: null
                            }),
                        children: "Run"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                size: "small",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Hangar"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Doors"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: "Progress"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "inherit",
                                                children: "# in Hangar"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "Worst"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "Best"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "Average"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "column",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "inherit",
                                                children: "Utilization"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "Worst"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "Best"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "inherit",
                                                        children: "Average"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                        children: results.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $80382670c874bc6e$export$54fd5f9a981bd35), {
                                result: r
                            }, r.id))
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $1MdOk = parcelRequire("1MdOk");

var $03mUs = parcelRequire("03mUs");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $kzQHY = parcelRequire("kzQHY");

var $hTRQz = parcelRequire("hTRQz");

var $iFplc = parcelRequire("iFplc");
const $d44b7578f4c7831b$export$e4b1ff5a512e8603 = ({ localHangar: localHangar, setLocalHangar: setLocalHangar, depthIncrement: depthIncrement, setDepthIncrement: setDepthIncrement, widthIncrement: widthIncrement, setWidthIncrement: setWidthIncrement, selectedAircraft: selectedAircraft, setSelectedAircraft: setSelectedAircraft, nAircraft: nAircraft, setNAircraft: setNAircraft, aircrafts: aircrafts, setAircrafts: setAircrafts, setIGarageDoor: setIGarageDoor })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const unit = activeFBO?.settings?.useMetricSystem ? "m" : "ft";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: "Initial Dimensions"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iFplc.HangarDimensionsForm), {
                        localHangar: localHangar,
                        setLocalHangar: setLocalHangar,
                        hideGarageDoors: true,
                        setIGarageDoor: setIGarageDoor,
                        activeTab: 0
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: "Variations"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 2,
                        width: 375,
                        p: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                disabled: activeFBO.subscription === "standard",
                                type: "number",
                                fullWidth: true,
                                InputProps: {
                                    inputProps: {
                                        min: 50,
                                        max: 400
                                    }
                                },
                                size: "small",
                                label: `+/- width (${unit})`,
                                onChange: setWidthIncrement,
                                value: widthIncrement
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzQHY.MetricAwareTextField), {
                                unit: activeFBO?.settings?.useMetricSystem ? "meters" : "feet",
                                disabled: activeFBO.subscription === "standard",
                                type: "number",
                                fullWidth: true,
                                InputProps: {
                                    inputProps: {
                                        min: 50,
                                        max: 400
                                    }
                                },
                                size: "small",
                                label: `+/- depth (${unit})`,
                                onChange: setDepthIncrement,
                                value: depthIncrement
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                width: 600,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        children: "Aircraft Mix"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 2,
                        p: 2,
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                width: 300,
                                flexShrink: 0,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                                    label: "Search by make and model",
                                    onSelect: setSelectedAircraft
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                label: "# Aircraft",
                                type: "number",
                                variant: "outlined",
                                size: "small",
                                inputProps: {
                                    min: 1,
                                    max: 20
                                },
                                onChange: (e)=>{
                                    setNAircraft(parseInt(e.target.value));
                                },
                                sx: {
                                    width: 110
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                color: "primary",
                                onClick: ()=>{
                                    if (selectedAircraft && nAircraft > 0) {
                                        const newAircrafts = [
                                            ...aircrafts
                                        ];
                                        for(let i = 0; i < nAircraft; i++)newAircrafts.push(selectedAircraft);
                                        setAircrafts(newAircrafts);
                                    }
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: "Make"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: "Model"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                            children: [
                                                "Wingspan (",
                                                unit,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                            children: [
                                                "Length (",
                                                unit,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                            children: [
                                                "Tail Height (",
                                                unit,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                children: aircrafts.map((aircraft, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                children: aircraft.make
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                children: aircraft.model
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                children: aircraft.wingspan
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                children: aircraft.length
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                children: aircraft.tail_height
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                    onClick: ()=>{
                                                        const newAircrafts = [
                                                            ...aircrafts
                                                        ];
                                                        newAircrafts.splice(index, 1);
                                                        setAircrafts(newAircrafts);
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {})
                                                })
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $f94ed2c887d342f4$export$c479437b4e95daad = ()=>{
    const { airplxIdentity: airplxIdentity, airplxToken: airplxToken } = (0, $gqehT.useIdentity)();
    const [localHangar, setLocalHangar] = $acw62.useState({
        id: (0, $lNEp2.uuidv4)(),
        location_id: (0, $lNEp2.uuidv4)(),
        fbo_id: "",
        name: "",
        width: 150,
        depth: 150,
        height: 50,
        left_door: 0,
        right_door: 0,
        wall_spacing_left: 2,
        wall_spacing_back: 2,
        wall_spacing_right: 2,
        garageDoors: [],
        obstacles: [],
        stack: {
            id: (0, $lNEp2.uuidv4)(),
            name: "Test Stack",
            location_id: (0, $lNEp2.uuidv4)(),
            isReference: false,
            tenants: [],
            movableObstacles: [],
            options: {
                wall_spacing_left: 2,
                wall_spacing_back: 2,
                wall_spacing_right: 2,
                horizontal_spacing: 2,
                vertical_spacing: 2,
                overlap: false,
                tug_spacing: 2,
                density_threshold: 0.8,
                corner_strategy: [
                    (0, $keHtM.CornerStrategy).ANGLE_45,
                    (0, $keHtM.CornerStrategy).ANGLE_45
                ],
                xy_weights: [
                    1,
                    1
                ],
                towing_equipment_id: null
            }
        },
        stacks: [],
        last_stacked: new Date().toISOString(),
        created_at: new Date().toISOString()
    });
    const [widthIncrement, setWidthIncrement] = $acw62.useState(20);
    const [depthIncrement, setDepthIncrement] = $acw62.useState(20);
    const [selectedAircraft, setSelectedAircraft] = $acw62.useState(null);
    const [nAircraft, setNAircraft] = $acw62.useState(0);
    const [aircrafts, setAircrafts] = $acw62.useState([]);
    const [results, setResults] = $acw62.useState([]);
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const hangars = $acw62.useMemo(()=>{
        const hangarsToTrial = [];
        const widths = (0, $cLNZr.range)(localHangar.width - widthIncrement, localHangar.width + widthIncrement, widthIncrement / 2);
        const depths = (0, $cLNZr.range)(localHangar.depth - depthIncrement, localHangar.depth + depthIncrement, depthIncrement / 2);
        for (const w of widths)for (const d of depths)hangarsToTrial.push({
            id: (0, $lNEp2.uuidv4)(),
            location_id: (0, $lNEp2.uuidv4)(),
            fbo_id: activeFBO.id,
            name: `${w}x${d}`,
            width: w,
            depth: d,
            height: 50,
            // option?
            left_door: 0,
            // option?
            right_door: 0,
            // option?
            wall_spacing_left: 2,
            // option?
            wall_spacing_back: 2,
            // option?
            wall_spacing_right: 2,
            // option?
            garageDoors: [],
            // option?
            obstacles: [],
            // option?
            stack: {
                id: (0, $lNEp2.uuidv4)(),
                name: "Test Stack",
                location_id: (0, $lNEp2.uuidv4)(),
                isReference: false,
                tenants: aircrafts.map((aircraft)=>{
                    return {
                        id: (0, $lNEp2.uuidv4)(),
                        fbo_id: activeFBO.id,
                        entity_id: (0, $lNEp2.uuidv4)(),
                        placement_id: (0, $lNEp2.uuidv4)(),
                        aircraft_id: aircraft.id,
                        type: "transient",
                        tail_number: "",
                        owner_manager: "",
                        created_at: new Date().toISOString(),
                        selected: false,
                        last_hangared: new Date().toISOString(),
                        note: "",
                        note_last_updated_by: "",
                        note_last_updated: new Date().toISOString(),
                        aircraft: aircraft,
                        position: {
                            x: 0,
                            y: 0,
                            angle: 0,
                            preferences: []
                        }
                    };
                }),
                movableObstacles: [],
                // option?
                options: {
                    wall_spacing_left: 2,
                    wall_spacing_back: 2,
                    wall_spacing_right: 2,
                    horizontal_spacing: 2,
                    vertical_spacing: 2,
                    overlap: false,
                    tug_spacing: 2,
                    density_threshold: 0.8,
                    corner_strategy: [
                        (0, $keHtM.CornerStrategy).ANGLE_45,
                        (0, $keHtM.CornerStrategy).ANGLE_45
                    ],
                    xy_weights: [
                        1,
                        1
                    ],
                    towing_equipment_id: null
                }
            },
            stacks: [],
            last_stacked: new Date().toISOString(),
            created_at: new Date().toISOString()
        });
        return hangarsToTrial;
    }, [
        localHangar,
        widthIncrement,
        depthIncrement,
        aircrafts
    ]);
    const onClickRun = $acw62.useCallback(async (customPlacementOptions)=>{
        const currentResults = hangars.map((hangar)=>({
                id: (0, $lNEp2.uuidv4)(),
                hangar: hangar,
                layoutOptions: [],
                progress: [
                    0
                ],
                time: 0
            }));
        for (const hangar of hangars){
            const startTime = +new Date();
            console.log(`running hangar: ${hangar.name}`);
            const paramSet = {
                run_id: (0, $lNEp2.uuidv4)(),
                label: "base case",
                // slim down the hangar for the API call
                hangar: {
                    id: hangar.id,
                    width: hangar.width,
                    depth: hangar.depth,
                    left_door: hangar.left_door,
                    right_door: hangar.right_door,
                    garage_doors: hangar.garageDoors ?? []
                },
                // slim down the tenant so it's just what we need to do the placement
                aircrafts_to_place: hangar.stack.tenants.filter((t)=>t.position.preferences?.indexOf((0, $keHtM.Preference).LOCKED) === -1).map((tenant)=>({
                        id: tenant.aircraft.id,
                        placement_id: tenant.placement_id,
                        angles_to_try: [],
                        sectors_to_try: null,
                        preferences: tenant.position.preferences
                    })),
                locked_aircrafts: [],
                obstacles: hangar.obstacles ?? [],
                options: {
                    ...customPlacementOptions,
                    corner_strategy: [
                        (0, $keHtM.CornerStrategy).ANGLE_45,
                        (0, $keHtM.CornerStrategy).ANGLE_45
                    ],
                    tug_spacing: 0,
                    // obselete
                    error_type: null,
                    // obselete
                    density_threshold: 0.8 // obselete
                }
            };
            const paramSets = (0, $eYWyk.generateDevParamSets)(paramSet, hangar.stack.tenants.map((t)=>t.aircraft), customPlacementOptions);
            window.globalThis.airplxKillSwitch = 0;
            await (0, $d977a2d2296ce41c$export$658fb009ff801842)(hangar, paramSets, airplxIdentity, airplxToken, (layoutOptions, progress)=>{
                const idx = currentResults.findIndex((r)=>r.hangar.id === hangar.id);
                currentResults[idx] = {
                    ...currentResults[idx],
                    layoutOptions: layoutOptions,
                    progress: progress,
                    time: +new Date() - startTime
                };
                setResults([
                    ...currentResults
                ]);
            });
        }
    }, [
        hangars
    ]);
    const setIGarageDoor = $acw62.useCallback((i, g)=>{
        const newGarageDoors = localHangar.garageDoors.map((garageDoor, idx)=>{
            if (i === idx) return g;
            return garageDoor;
        });
        setLocalHangar({
            ...localHangar,
            garageDoors: newGarageDoors
        });
    }, [
        localHangar
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        spacing: 12,
        justifyContent: "space-between",
        p: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d44b7578f4c7831b$export$e4b1ff5a512e8603), {
                localHangar: localHangar,
                setLocalHangar: setLocalHangar,
                depthIncrement: depthIncrement,
                setDepthIncrement: setDepthIncrement,
                widthIncrement: widthIncrement,
                setWidthIncrement: setWidthIncrement,
                selectedAircraft: selectedAircraft,
                setSelectedAircraft: setSelectedAircraft,
                nAircraft: nAircraft,
                setNAircraft: setNAircraft,
                aircrafts: aircrafts,
                setAircrafts: setAircrafts,
                setIGarageDoor: setIGarageDoor
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $035142c70be0be84$export$6749cfaea4d6423b), {
                aircrafts: aircrafts,
                results: results,
                onClickRun: onClickRun
            })
        ]
    });
};


const $87d1b6b2efef707a$export$e0fdcf77fb4d441c = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
            isReference: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRWDn.PredefinedObstaclesContainer), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6AlVH.TowingEquipmentContainer), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f94ed2c887d342f4$export$c479437b4e95daad), {})
                })
            })
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7FzhI = parcelRequire("7FzhI");

var $97sqG = parcelRequire("97sqG");
const $2ca8206f04a5e3c6$export$b2d30dec8cfd42d6 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97sqG.HangarsPresenter), {})
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $cFBau = parcelRequire("cFBau");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $2esSG = parcelRequire("2esSG");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $iAtns = parcelRequire("iAtns");
parcelRequire("hLOAf");
var $bjuzH = parcelRequire("bjuzH");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $2NPdf = parcelRequire("2NPdf");

var $gqehT = parcelRequire("gqehT");

var $6fDLr = parcelRequire("6fDLr");

var $kWYrU = parcelRequire("kWYrU");

var $3kyM0 = parcelRequire("3kyM0");

var $aHqXU = parcelRequire("aHqXU");

var $lNEp2 = parcelRequire("lNEp2");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $cJu23 = parcelRequire("cJu23");
var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");

var $cLNZr = parcelRequire("cLNZr");

var $ga8GY = parcelRequire("ga8GY");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $dVEPf = parcelRequire("dVEPf");
const $35a2b27b76e3cab2$export$1fc3164dc49838d9 = ({ label: label, onUploadImage: onUploadImage, displayPreview: displayPreview = true, mimeType: mimeType = "image/*", style: style = {} })=>{
    const [previewURL, setPreviewURL] = $acw62.useState("");
    const theme = (0, $14H9o.default)();
    const onDrop = $acw62.useCallback((acceptedFiles)=>{
        acceptedFiles.forEach((file)=>{
            const reader = new FileReader();
            reader.onabort = ()=>console.log("file reading was aborted");
            reader.onerror = ()=>console.log("file reading has failed");
            reader.onload = ()=>{
                const base64Image = reader.result;
                setPreviewURL(base64Image);
                onUploadImage(base64Image);
            };
            reader.readAsDataURL(file);
        });
    }, [
        onUploadImage
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $dVEPf.useDropzone)({
        accept: {
            [mimeType]: []
        },
        onDrop: onDrop,
        onDropRejected: ()=>alert("Incorrect file extension")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ...getRootProps(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    width: "calc(100% - 8px)",
                    textAlign: "center",
                    border: `4px solid ${isDragActive ? theme.palette.success.main : theme.palette.primary.main}`,
                    ...style
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    sx: {
                        p: 4
                    },
                    children: [
                        "Drag your",
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                children: label
                            })
                        }),
                        " ",
                        "image here."
                    ]
                })
            }),
            displayPreview && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: previewURL,
                style: {
                    maxWidth: "100%"
                }
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $cFBau = parcelRequire("cFBau");
var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $2esSG = parcelRequire("2esSG");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $cLNZr = parcelRequire("cLNZr");
const $285bab7047928a62$var$SmallTextArea = ({ isBeingSelected: isBeingSelected = false, ...props })=>{
    const extraProps = {
        ...props
    };
    if (!props.value && props.value !== 0 && props.required) {
        extraProps.color = "error";
        extraProps.focused = true;
        extraProps.required = null;
    }
    if (isBeingSelected) {
        extraProps.color = "success";
        extraProps.focused = true;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
        size: "small",
        ...extraProps,
        sx: {
            ...props.sx || {}
        },
        InputLabelProps: {
            sx: {
                fontSize: 12
            }
        },
        inputProps: {
            sx: {
                fontSize: 12
            },
            ...props.inputProps
        }
    });
};
const $285bab7047928a62$export$a36d98764fa4ed07 = (props)=>{
    const { aircrafts: aircrafts, aircraft: aircraft, setAircraft: setAircraft, setAircraftValue: setAircraftValue, onClickAutoOutline: onClickAutoOutline, contourNumber: contourNumber, setContourNumber: setContourNumber, setShapes: setShapes, setGeomBeingSelected: setGeomBeingSelected, select: select, setSelect: setSelect, taggableArea: taggableArea, onChangeTaggableArea: onChangeTaggableArea } = props;
    const [linkedAircraft, setLinkedAircraft] = $acw62.useState();
    const [noPropeller, setNoPropeller] = $acw62.useState(false);
    const needsPropellerSelection = !Boolean(aircraft.propeller_geom) && !noPropeller;
    $acw62.useEffect(()=>{
        setLinkedAircraft(aircrafts.find((a)=>a.id === aircraft.linked_to));
    }, [
        aircraft.linked_to
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        sx: {
            mt: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                        disabled: true,
                        label: "ID",
                        value: (0, $cLNZr.defaultTo)(aircraft.id, "")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                        required: true,
                        label: "Make",
                        onChange: (evt)=>setAircraftValue("make", evt.target.value),
                        value: (0, $cLNZr.defaultTo)(aircraft.make, "")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                        required: true,
                        label: "Model",
                        onChange: (evt)=>setAircraftValue("model", evt.target.value),
                        value: (0, $cLNZr.defaultTo)(aircraft.model, "")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                disablePortal: true,
                                sx: {
                                    width: 500
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        ...params,
                                        label: "Link this aircraft to",
                                        size: "small"
                                    }),
                                getOptionLabel: (option)=>`${option.make} ${option.model}`,
                                options: aircrafts,
                                onChange: (event, newValue)=>{
                                    setLinkedAircraft(newValue);
                                },
                                value: linkedAircraft || null
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                disabled: !Boolean(aircraft.linked_to),
                                size: "small",
                                onClick: ()=>{
                                    setAircraft({
                                        ...aircraft,
                                        linked_to: null
                                    });
                                    setLinkedAircraft(null);
                                },
                                children: "Remove"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                disabled: !Boolean(linkedAircraft),
                                size: "small",
                                onClick: ()=>{
                                    setAircraft({
                                        ...aircraft,
                                        linked_to: linkedAircraft.id
                                    });
                                },
                                children: "Save"
                            })
                        ]
                    })
                ]
            }),
            Boolean(aircraft.linked_to) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle1",
                        children: "Reference Points"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        isBeingSelected: taggableArea === "reference_point_wing_bottom",
                                        required: true,
                                        label: "Wing Bottom",
                                        inputProps: {
                                            onFocus: ()=>{
                                                onChangeTaggableArea("reference_point_wing_bottom");
                                            }
                                        },
                                        onChange: (evt)=>{
                                            setAircraftValue("reference_point_wing_bottom", evt.target.value);
                                            onChangeTaggableArea("reference_point_wing_top");
                                        },
                                        value: (0, $cLNZr.defaultTo)(aircraft.reference_point_wing_bottom, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        isBeingSelected: taggableArea === "reference_point_wing_top",
                                        required: true,
                                        label: "Wing Top",
                                        inputProps: {
                                            onFocus: ()=>{
                                                onChangeTaggableArea("reference_point_wing_top");
                                            }
                                        },
                                        onChange: (evt)=>setAircraftValue("reference_point_wing_top", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.reference_point_wing_top, 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        isBeingSelected: taggableArea === "reference_point_tail_bottom",
                                        required: true,
                                        label: "Horizontal Tail Bottom \u2014",
                                        inputProps: {
                                            onFocus: ()=>{
                                                onChangeTaggableArea("reference_point_tail_bottom");
                                            }
                                        },
                                        onChange: (evt)=>{
                                            setAircraftValue("reference_point_tail_bottom", evt.target.value);
                                        },
                                        value: (0, $cLNZr.defaultTo)(aircraft.reference_point_tail_bottom, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        isBeingSelected: taggableArea === "reference_point_tail_top",
                                        required: true,
                                        label: "Horizontal Tail Top \u2014",
                                        inputProps: {
                                            onFocus: ()=>{
                                                onChangeTaggableArea("reference_point_tail_top");
                                            }
                                        },
                                        onChange: (evt)=>{
                                            setAircraftValue("reference_point_tail_top", evt.target.value);
                                        },
                                        value: (0, $cLNZr.defaultTo)(aircraft.reference_point_tail_top, 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        isBeingSelected: taggableArea === "reference_point_vertical_tail_fin_bottom",
                                        required: true,
                                        type: "number",
                                        label: "Vertical Tail Bottom |",
                                        inputProps: {
                                            onFocus: ()=>{
                                                onChangeTaggableArea("reference_point_vertical_tail_fin_bottom");
                                            }
                                        },
                                        onChange: (evt)=>{
                                            setAircraftValue("reference_point_vertical_tail_fin_bottom", evt.target.value);
                                            setAircraftValue("reference_point_cabin_bottom", evt.target.value);
                                        },
                                        value: (0, $cLNZr.defaultTo)(aircraft.reference_point_vertical_tail_fin_bottom, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        isBeingSelected: taggableArea === "reference_point_vertical_tail_fin_top",
                                        required: true,
                                        label: "Vertical Tail Top |",
                                        inputProps: {
                                            onFocus: ()=>{
                                                onChangeTaggableArea("reference_point_vertical_tail_fin_top");
                                            }
                                        },
                                        onChange: (evt)=>{
                                            setAircraftValue("reference_point_vertical_tail_fin_top", evt.target.value);
                                        },
                                        value: (0, $cLNZr.defaultTo)(aircraft.reference_point_vertical_tail_fin_top, 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        isBeingSelected: taggableArea === "reference_point_cabin_bottom",
                                        required: true,
                                        type: "number",
                                        label: "Cabin Bottom",
                                        inputProps: {
                                            onFocus: ()=>{
                                                onChangeTaggableArea("reference_point_cabin_bottom");
                                            }
                                        },
                                        onChange: (evt)=>{
                                            setAircraftValue("reference_point_cabin_bottom", evt.target.value);
                                        },
                                        value: (0, $cLNZr.defaultTo)(aircraft.reference_point_cabin_bottom, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        isBeingSelected: taggableArea === "reference_point_cabin_top",
                                        required: true,
                                        label: "Cabin Top",
                                        inputProps: {
                                            onFocus: ()=>{
                                                onChangeTaggableArea("reference_point_cabin_top");
                                            }
                                        },
                                        onChange: (evt)=>{
                                            setAircraftValue("reference_point_cabin_top", evt.target.value);
                                        },
                                        value: (0, $cLNZr.defaultTo)(aircraft.reference_point_cabin_top, 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle1",
                                children: "Orientation"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                            required: true,
                                            fullWidth: true,
                                            label: "Nose",
                                            inputProps: {
                                                onFocus: ()=>{
                                                    setGeomBeingSelected("nose");
                                                }
                                            },
                                            onChange: (evt)=>setAircraftValue("nose", evt.target.value),
                                            value: (0, $cLNZr.defaultTo)(JSON.stringify(aircraft.nose?.coordinates), "")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                            required: true,
                                            fullWidth: true,
                                            type: "number",
                                            inputProps: {
                                                onFocus: ()=>{
                                                    setGeomBeingSelected("midline");
                                                }
                                            },
                                            label: "Midline",
                                            onChange: (evt)=>setAircraftValue("midline", evt.target.value),
                                            value: (0, $cLNZr.defaultTo)(aircraft.midline, 0)
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle1",
                                children: "Propellers"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        variant: noPropeller ? "contained" : "outlined",
                                        color: needsPropellerSelection ? "error" : "primary",
                                        onClick: ()=>{
                                            // something?
                                            setNoPropeller(!noPropeller);
                                        },
                                        children: "no propeller"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        variant: "outlined",
                                        color: needsPropellerSelection ? "error" : "primary",
                                        onClick: ()=>{
                                            setShapes([]);
                                            setGeomBeingSelected("propeller_geom");
                                            setNoPropeller(false);
                                            setSelect(!select);
                                        },
                                        children: "select"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        color: "warning",
                                        disabled: !Boolean(aircraft.propeller_geom),
                                        onClick: ()=>{
                                            setAircraftValue("propeller_geom", null);
                                        },
                                        children: "clear"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                        checked: Boolean(aircraft.propeller_geom)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle1",
                                children: "Dimensions"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        type: "number",
                                        label: "Length",
                                        onChange: (evt)=>setAircraftValue("length", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.length, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        type: "number",
                                        label: "Wingspan",
                                        onChange: (evt)=>setAircraftValue("wingspan", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.wingspan, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        type: "number",
                                        label: "Tail Height",
                                        onChange: (evt)=>setAircraftValue("tail_height", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.tail_height, 0)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle1",
                                children: "Outline"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        onClick: onClickAutoOutline,
                                        variant: "outlined",
                                        color: aircraft.geom ? "primary" : "error",
                                        children: "auto"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        type: "number",
                                        label: "Contour #",
                                        onChange: (evt)=>setContourNumber(Number(evt.target.value)),
                                        value: (0, $cLNZr.defaultTo)(contourNumber, 1)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        label: "Simplify %",
                                        type: "number",
                                        inputProps: {
                                            step: 0.005,
                                            min: 0,
                                            max: 1
                                        },
                                        onChange: (evt)=>setAircraftValue("simplify_pct", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.simplify_pct, 0)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle1",
                                children: "Overlaps"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle2",
                                children: "Wings"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        onClick: ()=>{
                                            setShapes([]);
                                            setGeomBeingSelected("wing_geom");
                                            setSelect(!select);
                                        },
                                        children: "select"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        color: "warning",
                                        disabled: !Boolean(aircraft.wing_geom),
                                        onClick: ()=>setAircraftValue("wing_geom", null),
                                        children: "clear"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                        checked: Boolean(aircraft.wing_geom)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        label: "Bottom",
                                        onChange: (evt)=>setAircraftValue("wing_bottom", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.wing_bottom, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        label: "Top",
                                        onChange: (evt)=>setAircraftValue("wing_top", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.wing_top, 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle2",
                                children: "Horizontal Tail"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        onClick: ()=>{
                                            setShapes([]);
                                            setGeomBeingSelected("tail_geom");
                                            setSelect(!select);
                                        },
                                        children: "select"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        color: "warning",
                                        disabled: !Boolean(aircraft.tail_geom),
                                        onClick: ()=>setAircraftValue("tail_geom", null),
                                        children: "clear"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                        checked: Boolean(aircraft.tail_geom)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        label: "Bottom",
                                        onChange: (evt)=>setAircraftValue("tail_bottom", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.tail_bottom, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        label: "Top",
                                        onChange: (evt)=>setAircraftValue("tail_top", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.tail_top, 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle2",
                                children: "Vertical Tail Fin"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        onClick: ()=>{
                                            setShapes([]);
                                            setGeomBeingSelected("vertical_tail_fin_geom");
                                            setSelect(!select);
                                        },
                                        children: "select"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        size: "small",
                                        color: "warning",
                                        disabled: !Boolean(aircraft.vertical_tail_fin_geom),
                                        onClick: ()=>setAircraftValue("vertical_tail_fin_geom", null),
                                        children: "clear"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                        checked: Boolean(aircraft.vertical_tail_fin_geom)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        label: "Bottom",
                                        onChange: (evt)=>setAircraftValue("vertical_tail_fin_bottom", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.vertical_tail_fin_bottom, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        label: "Top",
                                        onChange: (evt)=>setAircraftValue("vertical_tail_fin_top", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.vertical_tail_fin_top, 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle2",
                                children: "Cabin"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        type: "number",
                                        label: "Bottom",
                                        onChange: (evt)=>setAircraftValue("cabin_bottom", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.cabin_bottom, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        required: true,
                                        type: "number",
                                        label: "Top",
                                        onChange: (evt)=>setAircraftValue("cabin_top", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.cabin_top, 0)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle1",
                        children: "Towing"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                label: "Limit Degrees",
                                onChange: (evt)=>setAircraftValue("wheel_rotation_limit", evt.target.value),
                                value: (0, $cLNZr.defaultTo)(aircraft.wheel_rotation_limit, 0)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                required: true,
                                label: "Front",
                                type: "number",
                                inputProps: {
                                    onFocus: ()=>{
                                        setGeomBeingSelected("front_wheels");
                                    }
                                },
                                onChange: (evt)=>setAircraftValue("front_wheels", evt.target.value),
                                value: (0, $cLNZr.defaultTo)(aircraft.front_wheels, 0)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                required: true,
                                type: "number",
                                label: "Rear",
                                inputProps: {
                                    onFocus: ()=>{
                                        setGeomBeingSelected("rear_wheels");
                                    }
                                },
                                onChange: (evt)=>setAircraftValue("rear_wheels", evt.target.value),
                                value: (0, $cLNZr.defaultTo)(aircraft.rear_wheels, 0)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                    size: "small",
                                    onChange: (evt)=>setAircraftValue("tail_wheel", evt.target.checked),
                                    checked: Boolean(aircraft.tail_wheel)
                                }),
                                label: "Tail Wheel?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle1",
                                children: "Fuel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($285bab7047928a62$var$SmallTextArea, {
                                        label: "Fuel Capacity",
                                        type: "number",
                                        onChange: (evt)=>setAircraftValue("fuel_capacity", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.fuel_capacity, 0)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                        size: "small",
                                        fullWidth: true,
                                        label: "Fuel Type",
                                        value: aircraft.fuel_type ?? "",
                                        select: true,
                                        onChange: (evt)=>setAircraftValue("fuel_type", evt.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "Jet A",
                                                children: "Jet A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "AvGas",
                                                children: "AvGas"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "Other",
                                                children: "Other"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                sx: {
                                    mt: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        size: "small",
                                        fullWidth: true,
                                        label: "Cruise Burn (gal/hr)",
                                        type: "number",
                                        onChange: (evt)=>setAircraftValue("cruise_burn_gal_per_hour", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.cruise_burn_gal_per_hour, 0),
                                        helperText: "Typical cruise fuel burn rate in gallons per hour"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        size: "small",
                                        fullWidth: true,
                                        label: "Cruise Speed (kts)",
                                        type: "number",
                                        onChange: (evt)=>setAircraftValue("cruise_speed_kts", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.cruise_speed_kts, 0),
                                        helperText: "Typical cruise true airspeed in knots"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                sx: {
                                    mt: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        size: "small",
                                        fullWidth: true,
                                        label: "Reserves (gal)",
                                        type: "number",
                                        onChange: (evt)=>setAircraftValue("reserves_gal", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.reserves_gal, 0),
                                        helperText: "Typical fuel reserves (VFR/IFR alternate + safety)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        size: "small",
                                        fullWidth: true,
                                        label: "Cruise Altitude (ft)",
                                        type: "number",
                                        onChange: (evt)=>setAircraftValue("typical_cruise_altitude_ft", evt.target.value),
                                        value: (0, $cLNZr.defaultTo)(aircraft.typical_cruise_altitude_ft, 0),
                                        helperText: "Typical cruise altitude in feet (e.g., 41000 for FL410)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle1",
                        children: "Helicopter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                checked: aircraft.is_helicopter,
                                onChange: (evt)=>setAircraftValue("is_helicopter", evt.target.checked)
                            }),
                            label: "Is Helicopter?"
                        })
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ga8GY = parcelRequire("ga8GY");

const $6edcd9badeb2a613$var$CANVAS_WIDTH = 600;
const $6edcd9badeb2a613$var$CANVAS_HEIGHT = 600;
const $6edcd9badeb2a613$export$3439dc245e1bb884 = ({ img: img, aircraft: aircraft, onClick: onClick })=>{
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const draw = (ctx)=>{
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        (0, $e2171ec99804ba65$export$21a059be5bfd5fb)(ctx, img);
        aircraft.reference_point_vertical_tail_fin_bottom && (0, $e2171ec99804ba65$export$d30895ab3bff3c11)(ctx, aircraft.reference_point_vertical_tail_fin_bottom, 0, $6edcd9badeb2a613$var$CANVAS_WIDTH, {
            color: "red",
            width: 0.75
        });
        aircraft.reference_point_vertical_tail_fin_top && (0, $e2171ec99804ba65$export$d30895ab3bff3c11)(ctx, aircraft.reference_point_vertical_tail_fin_top, 0, $6edcd9badeb2a613$var$CANVAS_WIDTH, {
            color: "red",
            width: 1
        });
        aircraft.reference_point_cabin_bottom && (0, $e2171ec99804ba65$export$d30895ab3bff3c11)(ctx, aircraft.reference_point_cabin_bottom, 0, $6edcd9badeb2a613$var$CANVAS_WIDTH, {
            color: "blue",
            width: 1
        });
        aircraft.reference_point_cabin_top && (0, $e2171ec99804ba65$export$d30895ab3bff3c11)(ctx, aircraft.reference_point_cabin_top, 0, $6edcd9badeb2a613$var$CANVAS_WIDTH, {
            color: "blue",
            width: 1
        });
        aircraft.reference_point_wing_bottom && (0, $e2171ec99804ba65$export$d30895ab3bff3c11)(ctx, aircraft.reference_point_wing_bottom, 0, $6edcd9badeb2a613$var$CANVAS_WIDTH, {
            color: "purple",
            width: 0.75
        });
        aircraft.reference_point_wing_top && (0, $e2171ec99804ba65$export$d30895ab3bff3c11)(ctx, aircraft.reference_point_wing_top, 0, $6edcd9badeb2a613$var$CANVAS_WIDTH, {
            color: "purple",
            width: 0.75
        });
        aircraft.reference_point_tail_bottom && (0, $e2171ec99804ba65$export$d30895ab3bff3c11)(ctx, aircraft.reference_point_tail_bottom, 0, $6edcd9badeb2a613$var$CANVAS_WIDTH, {
            color: "orange",
            width: 0.75
        });
        aircraft.reference_point_tail_top && (0, $e2171ec99804ba65$export$d30895ab3bff3c11)(ctx, aircraft.reference_point_tail_top, 0, $6edcd9badeb2a613$var$CANVAS_WIDTH, {
            color: "orange",
            width: 0.75
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ga8GY.default), {
        ref: canvasRef,
        width: $6edcd9badeb2a613$var$CANVAS_WIDTH,
        height: $6edcd9badeb2a613$var$CANVAS_HEIGHT,
        draw: draw,
        onClick: (evt)=>{
            const canvas = evt.target;
            const rect = canvas.getBoundingClientRect();
            // const x = Math.round(evt.clientX - rect.left);
            const y = Math.round(evt.clientY - rect.top);
            onClick(y);
        },
        style: {
            border: "2px solid black",
            cursor: "crosshair"
        }
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("hLOAf");
var $bjuzH = parcelRequire("bjuzH");

var $acw62 = parcelRequire("acw62");

var $lNEp2 = parcelRequire("lNEp2");

var $ga8GY = parcelRequire("ga8GY");

const $1be5cc1e7018e161$var$postgrest = new (0, $bjuzH.default)((0, $lNEp2.getPostgrestUrl)());
const $1be5cc1e7018e161$var$CANVAS_WIDTH = 600;
const $1be5cc1e7018e161$var$CANVAS_HEIGHT = 600;
const $1be5cc1e7018e161$export$4e8644473798a35e = ({ geom: geom, simplify_pct: simplify_pct })=>{
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const [simplifiedGeom, setSimplifiedGeom] = $acw62.useState();
    const simplifyTo = async (geom, percent_missing)=>{
        return $1be5cc1e7018e161$var$postgrest.rpc("simplify_to", {
            geomjson: geom,
            percent_missing: percent_missing
        }).single();
    };
    $acw62.useEffect(()=>{
        (async ()=>{
            const { data: data } = await simplifyTo(geom, simplify_pct);
            setSimplifiedGeom(data?.geom);
        })();
    }, [
        geom,
        simplify_pct
    ]);
    const draw = (ctx)=>{
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        (0, $e2171ec99804ba65$export$acf1aed9b8518fca)(ctx, simplifiedGeom, {
            outline: {
                color: "#FF4136"
            },
            point: {
                color: "transparent"
            }
        });
    };
    if (!simplifiedGeom || !simplify_pct) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ga8GY.default), {
        ref: canvasRef,
        width: $1be5cc1e7018e161$var$CANVAS_WIDTH,
        height: $1be5cc1e7018e161$var$CANVAS_HEIGHT,
        draw: draw,
        style: {
            border: "2px solid black"
        }
    });
};


function $24461355656d8852$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

function $5c80433537c7ad93$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}


function $6d386446084ca1a9$export$2e2bcd8739ae039(values) {
    return Math.max(1, Math.ceil(Math.log((0, $5c80433537c7ad93$export$2e2bcd8739ae039)(values)) / Math.LN2) + 1);
}

const $7c028b8201e48c5a$var$e10 = Math.sqrt(50), $7c028b8201e48c5a$var$e5 = Math.sqrt(10), $7c028b8201e48c5a$var$e2 = Math.sqrt(2);
function $7c028b8201e48c5a$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $7c028b8201e48c5a$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $7c028b8201e48c5a$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $7c028b8201e48c5a$var$tickSpec(stop, start, count) : $7c028b8201e48c5a$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $7c028b8201e48c5a$var$tickSpec(start, stop, count)[2];
}
function $7c028b8201e48c5a$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $7c028b8201e48c5a$export$bc64d00cc98e7e95(stop, start, count) : $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


var $6e529a4d7c5318cb$var$array = Array.prototype;
var $6e529a4d7c5318cb$export$58adb3bec8346d0f = $6e529a4d7c5318cb$var$array.slice;


function $8cf317e8294c08d4$export$2e2bcd8739ae039(a, b) {
    return a - b;
}


function $3e63541b38411916$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}


var $2c54087e0cd22b13$export$2e2bcd8739ae039 = (x)=>()=>x;


function $dab7974168a117cc$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $dab7974168a117cc$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $dab7974168a117cc$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($dab7974168a117cc$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $dab7974168a117cc$var$segmentContains(a, b, c) {
    var i;
    return $dab7974168a117cc$var$collinear(a, b, c) && $dab7974168a117cc$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $dab7974168a117cc$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $dab7974168a117cc$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}


function $a2ef71a294399755$export$2e2bcd8739ae039() {}


var $bedfe0973872bedd$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $bedfe0973872bedd$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $6d386446084ca1a9$export$2e2bcd8739ae039), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            const e = (0, $24461355656d8852$export$2e2bcd8739ae039)(values), ts = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(e[0], e[1], tz);
            tz = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(Math.floor(e[0] / ts) * ts, Math.floor(e[1] / ts - 1) * ts, tz);
        } else tz = tz.slice().sort((0, $8cf317e8294c08d4$export$2e2bcd8739ae039));
        return tz.map((value)=>contour(values, value));
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        var polygons = [], holes = [];
        isorings(values, value, function(ring) {
            smooth(ring, values, value);
            if ((0, $3e63541b38411916$export$2e2bcd8739ae039)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $dab7974168a117cc$export$2e2bcd8739ae039)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = values[0] >= value;
        $bedfe0973872bedd$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = values[x + 1] >= value;
            $bedfe0973872bedd$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $bedfe0973872bedd$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = values[y * dx + dx] >= value;
            t2 = values[y * dx] >= value;
            $bedfe0973872bedd$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                $bedfe0973872bedd$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $bedfe0973872bedd$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $bedfe0973872bedd$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = values[y * dx + x + 1] >= value;
            $bedfe0973872bedd$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $bedfe0973872bedd$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
            if (x > 0 && x < dx && xt === x) {
                v0 = values[yt * dx + xt - 1];
                point[0] = x + (value - v0) / (v1 - v0) - 0.5;
            }
            if (y > 0 && y < dy && yt === y) {
                v0 = values[(yt - 1) * dx + xt];
                point[1] = y + (value - v0) / (v1 - v0) - 0.5;
            }
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)((0, $6e529a4d7c5318cb$export$58adb3bec8346d0f).call(_)) : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $a2ef71a294399755$export$2e2bcd8739ae039), contours) : smooth === smoothLinear;
    };
    return contours;
}


var $1c64d3e0c6f02944$exports = {};
/*
 (c) 2017, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/ (function() {
    'use strict';
    // to suit your point format, run search/replace for '.x' and '.y';
    // for 3D version, see 3d branch (configurability would draw significant performance overhead)
    // square distance between 2 points
    function getSqDist(p1, p2) {
        var dx = p1.x - p2.x, dy = p1.y - p2.y;
        return dx * dx + dy * dy;
    }
    // square distance from a point to a segment
    function getSqSegDist(p, p1, p2) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y;
        if (dx !== 0 || dy !== 0) {
            var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return dx * dx + dy * dy;
    }
    // rest of the code doesn't care about point format
    // basic distance-based simplification
    function simplifyRadialDist(points, sqTolerance) {
        var prevPoint = points[0], newPoints = [
            prevPoint
        ], point;
        for(var i = 1, len = points.length; i < len; i++){
            point = points[i];
            if (getSqDist(point, prevPoint) > sqTolerance) {
                newPoints.push(point);
                prevPoint = point;
            }
        }
        if (prevPoint !== point) newPoints.push(point);
        return newPoints;
    }
    function simplifyDPStep(points, first, last, sqTolerance, simplified) {
        var maxSqDist = sqTolerance, index;
        for(var i = first + 1; i < last; i++){
            var sqDist = getSqSegDist(points[i], points[first], points[last]);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
            simplified.push(points[index]);
            if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
        }
    }
    // simplification using Ramer-Douglas-Peucker algorithm
    function simplifyDouglasPeucker(points, sqTolerance) {
        var last = points.length - 1;
        var simplified = [
            points[0]
        ];
        simplifyDPStep(points, 0, last, sqTolerance, simplified);
        simplified.push(points[last]);
        return simplified;
    }
    // both algorithms combined for awesome performance
    function simplify(points, tolerance, highestQuality) {
        if (points.length <= 2) return points;
        var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;
        points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
        points = simplifyDouglasPeucker(points, sqTolerance);
        return points;
    }
    // export as AMD module / Node module / browser or worker variable
    if (typeof define === 'function' && define.amd) define(function() {
        return simplify;
    });
    else {
        $1c64d3e0c6f02944$exports = simplify;
        $1c64d3e0c6f02944$exports.default = simplify;
    }
})();


function $182e9d371a282184$export$616a6fe8c009ec37(imageData) {
    const data = imageData.data; // => [r,g,b,a,...]
    const pixels = [];
    for(let i = 0; i < data.length; i += 4)pixels.push({
        red: data[i],
        green: data[i + 1],
        blue: data[i + 2],
        alpha: data[i + 3] / 255
    });
    return pixels;
}
function $182e9d371a282184$export$f93b785f8754feb(imageData, width, height) {
    const pixels = $182e9d371a282184$export$616a6fe8c009ec37(imageData);
    const monochromePixels = pixels.map((p)=>p.alpha === 0 ? -1 : (p.red + p.green + p.blue) / 3);
    const contours = (0, $bedfe0973872bedd$export$2e2bcd8739ae039)().size([
        width,
        height
    ])(monochromePixels);
    return contours;
}
function $182e9d371a282184$export$9e2d70d8cb92ff85(contour, shouldSimplify, tolerance) {
    // simplify points
    if (shouldSimplify) {
        const xyPoints = contour.coordinates[0][0].map((coord)=>({
                x: coord[0],
                y: coord[1]
            }));
        const simplifiedPoints = $1c64d3e0c6f02944$exports(xyPoints, tolerance);
        contour = {
            ...contour,
            coordinates: [
                [
                    simplifiedPoints.map((point)=>[
                            point.x,
                            point.y
                        ])
                ]
            ]
        };
    }
    return contour;
}
const $182e9d371a282184$export$699be5b27c3837a5 = (imageData, contourNumber = 1, dimensions)=>{
    const contours = $182e9d371a282184$export$f93b785f8754feb(imageData, dimensions.width, dimensions.height);
    console.log(contours);
    const coordinates = contours[contourNumber].coordinates[0][0];
    const points = coordinates.map((coord)=>({
            x: coord[0],
            y: coord[1]
        }));
    return $1c64d3e0c6f02944$exports(points, 1).map(({ x: x, y: y })=>[
            x,
            y
        ]);
};


const $e2171ec99804ba65$var$average = (numbers)=>{
    return (0, $cLNZr.sum)(numbers) / numbers.length;
};
const $e2171ec99804ba65$var$makeRectangle = (points)=>{
    const point1 = points[0];
    const point2 = points[1];
    return [
        [
            ...point1
        ],
        [
            point1[0],
            point2[1]
        ],
        [
            ...point2
        ],
        [
            point2[0],
            point1[1]
        ],
        [
            ...point1
        ]
    ];
};
const $e2171ec99804ba65$export$21a059be5bfd5fb = (ctx, img)=>{
    const xScale = ctx.canvas.width / img.width;
    const yScale = ctx.canvas.height / img.height;
    const scale = Math.min(xScale, yScale);
    let offsetY = 0;
    if (xScale < yScale) offsetY = (img.height * yScale - img.height * xScale) / 2;
    // put the image on the canvas
    ctx.drawImage(img, 0, 0 + offsetY, img.width * scale, img.height * scale);
};
const $e2171ec99804ba65$var$drawVerticalLine = (ctx, x, options = {})=>{
    ctx.beginPath();
    ctx.setLineDash([]);
    ctx.lineWidth = options.width || 4;
    ctx.strokeStyle = options.color || "red";
    ctx.moveTo(x - ctx.lineWidth / 2, 0);
    ctx.lineTo(x - ctx.lineWidth / 2, ctx.canvas.height);
    ctx.stroke();
    ctx.closePath();
};
const $e2171ec99804ba65$export$d30895ab3bff3c11 = (ctx, y, xStart = 0, xEnd = 600, options = {})=>{
    ctx.beginPath();
    ctx.setLineDash([]);
    ctx.lineWidth = options.width || 2;
    ctx.strokeStyle = options.color || "hotpink";
    ctx.moveTo(xStart || 0, y);
    ctx.lineTo(xEnd || ctx.canvas.width, y);
    ctx.stroke();
    ctx.closePath();
};
const $e2171ec99804ba65$var$drawCircle = (ctx, geom)=>{
    if (!geom) return;
    const { coordinates: coordinates } = geom;
    ctx.lineWidth = 4;
    ctx.strokeStyle = "black";
    ctx.fillStyle = "black";
    ctx.moveTo(coordinates[0] - 2, coordinates[1] - 2);
    ctx.arc(coordinates[0] - 2, coordinates[1] - 2, 5, 0, 2 * Math.PI);
    ctx.stroke();
    ctx.fill();
    ctx.closePath();
};
const $e2171ec99804ba65$var$iterCoordinates = (geom)=>{
    if (geom.type === "Polygon") return [
        ...geom.coordinates
    ];
    if (geom.type === "MultiPolygon") return [
        ...geom.coordinates.flat()
    ];
    if (geom.type === "GeometryCollection") return [
        ...geom.geometries.map($e2171ec99804ba65$var$iterCoordinates).flat()
    ];
    return [
        ...geom.coordinates
    ];
};
const $e2171ec99804ba65$export$b11bd9a0808bdc9 = (ctx, geom, geomtext, _aircraft)=>{
    if (!geom || !geomtext) return;
    const labels = [];
    if (geom.type.toUpperCase() === "MULTIPOLYGON" || geom.type.toUpperCase() === "MULTIPOLYGON ZM") {
        const cs = geomtext.slice(17, -1).split("),(").map((x)=>x.replaceAll("(", "").replaceAll(")", "").split(",")).map((cs)=>cs.map((i)=>i.split(" ").map(parseFloat)));
        for (let c of cs){
            const zm = c[0].slice(2).map((v)=>(0, $cLNZr.round)(v, 2));
            labels.push(zm);
        }
    }
    if (!labels.length) return;
    let i = 0;
    for (let coordinates of $e2171ec99804ba65$var$iterCoordinates(geom)){
        ctx.font = "bold 3px Arial";
        ctx.fillStyle = "black";
        ctx.textAlign = "center";
        const textX = $e2171ec99804ba65$var$average(coordinates.filter(([x, _])=>x > 0).map(([x, _])=>x));
        const textY = $e2171ec99804ba65$var$average(coordinates.filter((_, y)=>y > 0).map(([_, y])=>y));
        const text = `${labels[i][0]}-${labels[i][1]}`;
        ctx.fillText(text, textX, textY);
        i++;
    }
};
const $e2171ec99804ba65$export$acf1aed9b8518fca = (ctx, geom, options = {})=>{
    if (!geom) return;
    for (let coordinates of $e2171ec99804ba65$var$iterCoordinates(geom)){
        for(let i = 0; i < coordinates.length; i++){
            const [x1, y1] = coordinates[i];
            // draws a point on the image
            ctx.fillStyle = options.point?.color || "#ff0000";
            ctx.fillRect(x1 - 4, y1 - 4, 8, 8);
            if (i > coordinates.length - 2) continue;
            // connect the points with a blue line
            const [x2, y2] = coordinates[i + 1];
            ctx.beginPath();
            ctx.setLineDash([]);
            ctx.lineWidth = options.outline?.lineWidth || 2;
            ctx.strokeStyle = options.outline?.color || "steelblue";
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.closePath();
        }
        if (!options.fillStyle) continue;
        ctx.fillStyle = options.fillStyle;
        ctx.beginPath();
        ctx.moveTo(coordinates[0][0], coordinates[0][1]);
        for(let i = 0; i < coordinates.length; i++){
            if (i > coordinates.length - 2) continue;
            // connect the points with a blue line
            const [x2, y2] = coordinates[i + 1];
            ctx.lineTo(x2, y2);
        }
        ctx.fill();
    }
};
const $e2171ec99804ba65$var$CANVAS_WIDTH = 600;
const $e2171ec99804ba65$var$CANVAS_HEIGHT = 600;
const $e2171ec99804ba65$export$ebcb430fea391dc = ({ img: img, imgSide: imgSide, aircrafts: aircrafts, aircraft: aircraft, setAircraft: setAircraft, gisIntersection: gisIntersection })=>{
    const [select, setSelect] = $acw62.useState(false);
    const [shapes, setShapes] = $acw62.useState([]);
    const [taggableArea, setTaggableArea] = $acw62.useState("");
    const [contourNumber, setContourNumber] = $acw62.useState(1);
    const [geomBeingSelected, setGeomBeingSelected] = $acw62.useState("");
    const canvasRef = /*#__PURE__*/ $acw62.createRef();
    const setAircraftValue = (key, value)=>{
        setAircraft({
            ...aircraft,
            [key]: value
        });
    };
    const draw = (ctx)=>{
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        $e2171ec99804ba65$export$21a059be5bfd5fb(ctx, img);
        $e2171ec99804ba65$var$drawCircle(ctx, aircraft.nose);
        $e2171ec99804ba65$var$drawVerticalLine(ctx, aircraft.midline, {
            color: "limegreen",
            width: 1
        });
        $e2171ec99804ba65$export$d30895ab3bff3c11(ctx, aircraft.front_wheels, ctx.canvas.width * 0.3, ctx.canvas.width * 0.7);
        $e2171ec99804ba65$export$d30895ab3bff3c11(ctx, aircraft.rear_wheels, ctx.canvas.width * 0.3, ctx.canvas.width * 0.7);
        $e2171ec99804ba65$export$acf1aed9b8518fca(ctx, aircraft.geom);
        const heightAreaOptions = {
            fillStyle: "#3D997040",
            point: {
                color: "#3D9970"
            },
            outline: {
                color: "#3D9970"
            }
        };
        $e2171ec99804ba65$export$acf1aed9b8518fca(ctx, aircraft.wing_geom, heightAreaOptions);
        $e2171ec99804ba65$export$acf1aed9b8518fca(ctx, aircraft.tail_geom, heightAreaOptions);
        $e2171ec99804ba65$export$acf1aed9b8518fca(ctx, aircraft.vertical_tail_fin_geom, heightAreaOptions);
        $e2171ec99804ba65$export$acf1aed9b8518fca(ctx, aircraft.propeller_geom, {
            fillStyle: null,
            point: {
                color: "transparent"
            },
            outline: {
                color: "black"
            }
        });
        if (shapes.length) for (let shape of shapes){
            if (shape.length < 2) continue;
            $e2171ec99804ba65$export$acf1aed9b8518fca(ctx, {
                coordinates: [
                    shape
                ]
            }, {
                fillStyle: "#ff7f5040",
                point: {
                    color: "coral"
                },
                outline: {
                    color: "coral"
                }
            });
        }
    };
    const onClickAutoOutline = ()=>{
        if (!img) return;
        // we have an in memory canvas so we don't use anything we've marked up
        // on the user displayed canvas in the contour calculation.
        const inMemoryCanvas = document.createElement("canvas");
        inMemoryCanvas.width = $e2171ec99804ba65$var$CANVAS_WIDTH;
        inMemoryCanvas.height = $e2171ec99804ba65$var$CANVAS_HEIGHT;
        const inMemoryContext = inMemoryCanvas.getContext("2d");
        $e2171ec99804ba65$export$21a059be5bfd5fb(inMemoryContext, img);
        if (aircraft.propeller_geom) $e2171ec99804ba65$export$acf1aed9b8518fca(inMemoryContext, aircraft.propeller_geom, {
            fillStyle: "transparent",
            point: {
                color: "transparent"
            },
            outline: {
                color: "black"
            }
        });
        const imageData = inMemoryContext.getImageData(0, 0, $e2171ec99804ba65$var$CANVAS_WIDTH, $e2171ec99804ba65$var$CANVAS_HEIGHT);
        const outline = (0, $182e9d371a282184$export$699be5b27c3837a5)(imageData, contourNumber, {
            width: $e2171ec99804ba65$var$CANVAS_WIDTH,
            height: $e2171ec99804ba65$var$CANVAS_HEIGHT
        });
        const geom = {
            type: "Polygon",
            coordinates: [
                outline
            ]
        };
        setAircraftValue("geom", geom);
    };
    const onClickNose = ()=>{
        setGeomBeingSelected("nose");
    };
    const handleMouseDown = (evt)=>{
        if (!select) return;
        const canvas = evt.currentTarget;
        const rect = canvas.getBoundingClientRect();
        const x = Math.round(evt.clientX - rect.left);
        const y = Math.round(evt.clientY - rect.top);
        // starts as just a point
        setShapes([
            $e2171ec99804ba65$var$makeRectangle([
                [
                    x,
                    y
                ],
                [
                    x,
                    y
                ]
            ])
        ]);
    };
    const handleMouseMove = (evt)=>{
        if (!select || !shapes.length || shapes[0].length === 0) return;
        const canvas = evt.currentTarget;
        const rect = canvas.getBoundingClientRect();
        const x = Math.round(evt.clientX - rect.left);
        const y = Math.round(evt.clientY - rect.top);
        setShapes([
            $e2171ec99804ba65$var$makeRectangle([
                shapes[0][0],
                [
                    x,
                    y
                ]
            ])
        ]);
    };
    const handleMouseExit = async (evt)=>{
        if (!select || !shapes.length || shapes[0].length === 0) return;
        const canvas = evt.currentTarget;
        const rect = canvas.getBoundingClientRect();
        const x = Math.round(evt.clientX - rect.left);
        const y = Math.round(evt.clientY - rect.top);
        const selectedRectangle = shapes[0];
        const selectedGeometry = {
            type: "GeometryCollection",
            geometries: [
                {
                    type: "Polygon",
                    coordinates: [
                        selectedRectangle
                    ]
                }
            ]
        };
        if (geomBeingSelected !== "vertical_tail_fin_geom") {
            const mirroredRegion = [
                [
                    canvas.width - x,
                    y
                ],
                [
                    canvas.width - selectedRectangle[0][0],
                    selectedRectangle[0][1]
                ]
            ];
            selectedGeometry.geometries.push({
                type: "Polygon",
                coordinates: [
                    $e2171ec99804ba65$var$makeRectangle(mirroredRegion)
                ]
            });
        }
        let intersection;
        if (geomBeingSelected === "propeller_geom") intersection = selectedGeometry;
        else {
            const { data: data } = await gisIntersection(aircraft.geom, selectedGeometry);
            intersection = data;
        }
        setAircraftValue(geomBeingSelected, intersection);
        setShapes([]);
        setSelect(false);
    };
    const onClickCalculateFromReferencePoints = ()=>{
    //
    };
    $acw62.useEffect(()=>{
        if (aircraft.reference_point_vertical_tail_fin_top && aircraft.reference_point_cabin_bottom) {
            const fields = [
                "reference_point_wing_bottom",
                "reference_point_wing_top",
                "reference_point_tail_bottom",
                "reference_point_tail_top",
                "reference_point_vertical_tail_fin_bottom",
                "reference_point_vertical_tail_fin_top",
                "reference_point_cabin_bottom",
                "reference_point_cabin_top"
            ];
            const newValues = {};
            for (let field of fields){
                if (aircraft[field]) {
                    const h = Math.abs(aircraft.reference_point_vertical_tail_fin_top - aircraft.reference_point_cabin_bottom);
                    const computedValue = aircraft.tail_height / h * Math.abs(aircraft[field] - aircraft.reference_point_cabin_bottom);
                    const actualField = field.replace("reference_point_", "");
                    newValues[actualField] = computedValue;
                }
                // newValues.cabin_bottom = 0;
                // newValues.cabin_top = aircraft.tail_height;
                // newValues.vertical_tail_fin_bottom = newValues.cabin_bottom;
                setAircraft({
                    ...aircraft,
                    ...newValues
                });
            }
        }
    }, [
        aircraft?.reference_point_wing_bottom,
        aircraft?.reference_point_wing_top,
        aircraft?.reference_point_tail_bottom,
        aircraft?.reference_point_tail_top,
        aircraft?.reference_point_vertical_tail_fin_bottom,
        aircraft?.reference_point_vertical_tail_fin_top,
        aircraft?.reference_point_cabin_bottom,
        aircraft?.reference_point_cabin_top
    ]);
    const onUploadSideImage = (base64Image)=>{
        setAircraftValue("side_image", base64Image);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cJu23.default), {
        container: true,
        spacing: 3,
        sx: {
            p: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                item: true,
                md: 3,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $285bab7047928a62$export$a36d98764fa4ed07), {
                    aircrafts: aircrafts,
                    aircraft: aircraft,
                    setAircraft: setAircraft,
                    setAircraftValue: setAircraftValue,
                    onClickAutoOutline: onClickAutoOutline,
                    onClickNose: onClickNose,
                    contourNumber: contourNumber,
                    setContourNumber: setContourNumber,
                    select: select,
                    setSelect: setSelect,
                    setShapes: setShapes,
                    geomBeingSelected: geomBeingSelected,
                    setGeomBeingSelected: setGeomBeingSelected,
                    taggableArea: taggableArea,
                    onChangeTaggableArea: setTaggableArea,
                    onClickCalculateFromReferencePoints: onClickCalculateFromReferencePoints
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                item: true,
                md: 9,
                children: Boolean(aircraft.linked_to) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            sx: {
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                justifyContent: "space-around",
                                alignItems: "center",
                                spacing: 2,
                                sx: {
                                    width: "100%"
                                },
                                children: [
                                    Boolean(aircraft.image) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ga8GY.default), {
                                                ref: canvasRef,
                                                width: $e2171ec99804ba65$var$CANVAS_WIDTH,
                                                height: $e2171ec99804ba65$var$CANVAS_HEIGHT,
                                                draw: draw,
                                                style: {
                                                    border: "2px solid black",
                                                    backgroundColor: "#c8cfde"
                                                },
                                                onMouseDown: handleMouseDown,
                                                onMouseMove: handleMouseMove,
                                                onMouseUp: handleMouseExit,
                                                onMouseLeave: handleMouseExit,
                                                onClick: (evt)=>{
                                                    const canvas = evt.currentTarget;
                                                    const rect = canvas.getBoundingClientRect();
                                                    const x = Math.round(evt.clientX - rect.left);
                                                    const y = Math.round(evt.clientY - rect.top);
                                                    if (geomBeingSelected === "nose") {
                                                        setAircraftValue("nose", {
                                                            type: "point",
                                                            coordinates: [
                                                                x,
                                                                y
                                                            ]
                                                        });
                                                        setGeomBeingSelected(null);
                                                    }
                                                    if (geomBeingSelected === "midline") {
                                                        setAircraftValue("midline", x);
                                                        setGeomBeingSelected(null);
                                                    }
                                                    if (geomBeingSelected === "front_wheels") {
                                                        setAircraftValue("front_wheels", y);
                                                        setGeomBeingSelected(null);
                                                    }
                                                    if (geomBeingSelected === "rear_wheels") {
                                                        setAircraftValue("rear_wheels", y);
                                                        setGeomBeingSelected(null);
                                                    }
                                                    setSelect(false);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                size: "small",
                                                onClick: ()=>setAircraftValue("image", ""),
                                                children: "remove image"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35a2b27b76e3cab2$export$1fc3164dc49838d9), {
                                        label: "Top View",
                                        mimeType: "image/png",
                                        onUploadImage: (base64Image)=>setAircraftValue("image", base64Image)
                                    }),
                                    Boolean(aircraft.side_image) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6edcd9badeb2a613$export$3439dc245e1bb884), {
                                                img: imgSide,
                                                aircraft: aircraft,
                                                onClick: (y)=>{
                                                    setAircraftValue(taggableArea, y);
                                                    const nextTaggableArea = {
                                                        reference_point_wing_bottom: "reference_point_wing_top",
                                                        reference_point_wing_top: "reference_point_tail_bottom",
                                                        reference_point_tail_bottom: "reference_point_tail_top",
                                                        reference_point_tail_top: "reference_point_vertical_tail_fin_bottom",
                                                        reference_point_vertical_tail_fin_bottom: "reference_point_vertical_tail_fin_top",
                                                        reference_point_vertical_tail_fin_top: "reference_point_cabin_bottom",
                                                        reference_point_cabin_bottom: "reference_point_cabin_top",
                                                        reference_point_cabin_top: "reference_point_wing_top"
                                                    };
                                                    setTaggableArea(nextTaggableArea[taggableArea]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                size: "small",
                                                onClick: ()=>setAircraftValue("side_image", ""),
                                                children: "remove image"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35a2b27b76e3cab2$export$1fc3164dc49838d9), {
                                        label: "Side View",
                                        onUploadImage: onUploadSideImage
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                width: 600
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be5cc1e7018e161$export$4e8644473798a35e), {
                                geom: aircraft.geom,
                                simplify_pct: aircraft.simplify_pct
                            })
                        })
                    ]
                })
            })
        ]
    });
};


const $c458e7c8b36cf0e5$var$postgrest = new (0, $bjuzH.default)((0, $lNEp2.getPostgrestUrl)());
const $c458e7c8b36cf0e5$export$23fc689adf68113e = ()=>{
    const { aircraftId: aircraftId } = (0, $aphAM.useParams)();
    const [confirmDeploy, setConfirmDeploy] = $acw62.useState(false);
    const { url: webURL } = (0, $3kyM0.useTokenMaker)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const navigate = (0, $aphAM.useNavigate)();
    (0, $gqehT.useIdentity)(); // Keep for auth
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    // const [aircrafts, setAircrafts] = React.useState<Aircraft[]>([]);
    const [limitToCompleted, setLimitToCompleted] = $acw62.useState(false);
    const [completedAircraft, setCompletedAircraft] = $acw62.useState({});
    const [limitToNotCompleted, setLimitToNotCompleted] = $acw62.useState(false);
    const [selectedAircraft, setSelectedAircraft] = $acw62.useState();
    const [img, setImg] = $acw62.useState(new Image());
    const [imgSide, setImgSide] = $acw62.useState(new Image());
    const { loading: loading, value: selectableAircrafts } = (0, $2NPdf.default)(async ()=>{
        const { data: data } = await $c458e7c8b36cf0e5$var$postgrest.rpc("aircraft_raw", {
            anything: "anything"
        }).select("id, make, model, locked").order("make").order("model");
        const aircrafts = data;
        const defaultAircraft = aircrafts.find((a)=>a.id === aircraftId) || aircrafts[0];
        setSelectedAircraft(await fetchAircraft(defaultAircraft.id));
        fetchCompletedAircraft(aircrafts);
        return aircrafts;
    }, []);
    const fetchCompletedAircraft = async (aircrafts)=>{
        const completedAircraft = {};
        const { data: completedAircraftResults } = await $c458e7c8b36cf0e5$var$postgrest.rpc("is_aircraft_complete", {
            aircraft_ids: aircrafts.map((a)=>a.id)
        }).select();
        for (const aircraft of completedAircraftResults)completedAircraft[aircraft.aircraft_id] = aircraft.is_complete;
        setCompletedAircraft(completedAircraft);
    };
    // fetch image from the server. use loaded/setLoaded in the even that we're
    // changing airplanes
    async function fetchImage(imageURL, setIt) {
        let newImage = new Image();
        newImage.setAttribute("crossOrigin", "");
        newImage.crossOrigin = "Anonymous";
        newImage.src = imageURL.replace("public", "");
        newImage.onload = ()=>{
            setIt(newImage);
        };
    }
    const gisIntersection = async (geom1, geom2)=>{
        $c458e7c8b36cf0e5$var$postgrest.schema = "web";
        return $c458e7c8b36cf0e5$var$postgrest.rpc("gis_intersection", {
            geom1: geom1,
            geom2: geom2
        });
    };
    $acw62.useEffect(()=>{
        if (window.location.host.indexOf("staging.airplx.com") > -1) snackbar.notify({
            text: "FYI - You are on staging",
            severity: "warning"
        });
    }, []);
    const fetchAircraft = async (id)=>{
        const { data: aircrafts } = await $c458e7c8b36cf0e5$var$postgrest.rpc("aircraft_raw", {
            anything: "anything"
        }).select().eq("id", id);
        return aircrafts[0];
    };
    (0, $2NPdf.default)(async ()=>{
        if (!selectedAircraft) return;
        const { id: id, geomz_text: _geomz_text, ...data } = selectedAircraft;
        await $c458e7c8b36cf0e5$var$postgrest.rpc("upsert_aircraft", {
            an_aircraft: {
                id: id,
                ...data
            }
        });
        await fetchCompletedAircraft(selectableAircrafts);
    }, [
        selectedAircraft
    ]);
    $acw62.useEffect(()=>{
        if (!selectedAircraft) return;
        if (selectedAircraft.image) fetchImage(selectedAircraft.image, setImg);
        if (selectedAircraft.side_image) fetchImage(selectedAircraft.side_image, setImgSide);
    }, [
        selectedAircraft
    ]);
    if (loading || !selectedAircraft || !img) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {});
    const isComplete = (a)=>{
        if (!a) return false;
        if (a.linked_to) return true;
        return completedAircraft[a.id] ?? false;
    };
    const getEmojiForAircraft = (aircraft)=>{
        if (aircraft.locked) return "\uD83D\uDD12";
        if (isComplete(aircraft)) return "\u2705";
        return "";
    };
    const isPeter = hasPermission((0, $aHqXU.Permission).ACCESS_SUPER_ADMIN);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            p: 1,
            overflow: "scroll",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                        disablePortal: true,
                        sx: {
                            width: 500
                        },
                        options: selectableAircrafts.filter((a)=>limitToCompleted ? isComplete(a) : true).filter((a)=>limitToNotCompleted ? !isComplete(a) : true),
                        getOptionLabel: (option)=>`${getEmojiForAircraft(option)} ${option.make} ${option.model}`,
                        onChange: async (event, newValue)=>{
                            if (!newValue?.id) return;
                            const aircraft = await fetchAircraft(newValue.id);
                            setSelectedAircraft(aircraft);
                            if (aircraft) window.location.hash = "#/labeling-tool/" + aircraft.id;
                            if (isComplete(aircraft)) snackbar.notify({
                                text: "You are editing a completed aircraft.",
                                severity: "warning"
                            });
                        },
                        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                ...params,
                                label: "Aircraft",
                                size: "small"
                            }),
                        value: selectedAircraft
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                            checked: limitToCompleted,
                            onChange: ()=>{
                                setLimitToNotCompleted(false);
                                setLimitToCompleted(!limitToCompleted);
                            }
                        }),
                        label: "Limit to Completed"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                            checked: limitToNotCompleted,
                            onChange: ()=>{
                                setLimitToCompleted(false);
                                setLimitToNotCompleted(!limitToNotCompleted);
                            }
                        }),
                        label: "Limit to Not Completed"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        color: "success",
                        variant: "contained",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                        onClick: async ()=>{
                            const { data: new_aircraft_id } = await $c458e7c8b36cf0e5$var$postgrest.rpc("new_aircraft", {
                                anything: "hi"
                            });
                            navigate(`/labeling-tool/${new_aircraft_id}`);
                        },
                        children: "New"
                    }),
                    isPeter && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    checked: selectedAircraft.locked
                                }),
                                onChange: async (evt)=>{
                                    const confirmed = confirm("You sure big man?");
                                    if (!confirmed) return;
                                    setSelectedAircraft({
                                        ...selectedAircraft,
                                        locked: evt.target.checked
                                    });
                                    await $c458e7c8b36cf0e5$var$postgrest.rpc("toggle_locked", {
                                        aircraft_id: selectedAircraft.id,
                                        new_value: evt.target.checked
                                    });
                                },
                                label: "Locked?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    checked: selectedAircraft.is_hidden
                                }),
                                onChange: async (evt)=>{
                                    const confirmed = confirm("You sure big man?");
                                    if (!confirmed) return;
                                    setSelectedAircraft({
                                        ...selectedAircraft,
                                        is_hidden: evt.target.checked
                                    });
                                    await $c458e7c8b36cf0e5$var$postgrest.rpc("toggle_is_hidden", {
                                        aircraft_id: selectedAircraft.id,
                                        new_value: evt.target.checked
                                    });
                                },
                                label: "Is Hidden?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setConfirmDeploy(true),
                                variant: "contained",
                                color: "primary",
                                children: "Deploy"
                            }),
                            confirmDeploy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                                title: "Confirm deploy",
                                text: "Are you sure you want to deploy?",
                                onCancel: ()=>setConfirmDeploy(false),
                                onClose: ()=>setConfirmDeploy(false),
                                onOk: async ()=>{
                                    try {
                                        const response = await fetch(`${webURL}/jobs/update-aircraft`);
                                        if (!response.ok) throw new Error("Failed to deploy aircraft data");
                                        snackbar.notify({
                                            text: "Aircraft data deployment started. Track progress on Super Admin > System Status tab.",
                                            severity: "success"
                                        });
                                    } catch (err) {
                                        const errorMsg = err instanceof Error ? err.message : "Deployment failed";
                                        snackbar.notify({
                                            text: errorMsg,
                                            severity: "error"
                                        });
                                    } finally{
                                        setConfirmDeploy(false);
                                    }
                                },
                                okText: "Go baby go!"
                            })
                        ]
                    })
                ]
            }),
            selectedAircraft.locked && !isPeter ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2171ec99804ba65$export$ebcb430fea391dc), {
                img: img,
                imgSide: imgSide,
                aircrafts: selectableAircrafts,
                aircraft: selectedAircraft,
                setAircraft: ()=>{
                // noop
                },
                gisIntersection: gisIntersection
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2171ec99804ba65$export$ebcb430fea391dc), {
                img: img,
                imgSide: imgSide,
                aircrafts: selectableAircrafts,
                aircraft: selectedAircraft,
                setAircraft: setSelectedAircraft,
                gisIntersection: gisIntersection
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $8qjhV = parcelRequire("8qjhV");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $hY1XM = parcelRequire("hY1XM");
var $54c991629ee0a8ce$exports = {};






$54c991629ee0a8ce$exports = {
    decode: (parcelRequire("7SR5F")),
    verify: (parcelRequire("1PSJS")),
    sign: (parcelRequire("8fWg9")),
    JsonWebTokenError: (parcelRequire("4r9pO")),
    NotBeforeError: (parcelRequire("fUN9R")),
    TokenExpiredError: (parcelRequire("agX5Y"))
};



var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $gqehT = parcelRequire("gqehT");


var $l5ED9 = parcelRequire("l5ED9");
// import logo from "../../../airplx-logo-transparent-square-no-text.png";
const $600f7fa9fdef2746$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $600f7fa9fdef2746$export$b3b2dca8d8638ba0 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: `Magic Link Login allows user to securely login without a password. A link will be sent to the email address associated with your account.`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
            component: (0, $lzNIT.Link),
            to: "/login/link",
            variant: "outlined",
            fullWidth: true,
            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8qjhV))), {}),
            sx: {
                borderRadius: 1,
                borderColor: "divider",
                "&:hover": {
                    borderColor: "text.primary",
                    backgroundColor: "action.hover"
                }
            },
            children: "Login with Magic Link"
        })
    });
};
const $600f7fa9fdef2746$export$21a94553ffa41578 = ()=>{
    const { isLoggedIn: isLoggedIn, loginWithMicrosoft: loginWithMicrosoft, loginWithGoogle: loginWithGoogle, loginWithPassword: loginWithPassword, hasPassword: hasPassword } = (0, $gqehT.useIdentity)();
    // Use unauthenticated client for whitelist check (user not logged in yet)
    const postgrest = $acw62.useMemo(()=>(0, $l5ED9.createUnauthenticatedPostgrest)(), []);
    const [email, setEmail] = $acw62.useState("");
    const [password, setPassword] = $acw62.useState("");
    const [step, setStep] = $acw62.useState("email");
    const [loading, setLoading] = $acw62.useState(false);
    const [error, setError] = $acw62.useState("");
    const [showEmailLogin, setShowEmailLogin] = $acw62.useState(false);
    if (isLoggedIn) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/",
        replace: true
    });
    const handleEmailSubmit = async ()=>{
        if (!email) {
            setError("Please enter your email address");
            return;
        }
        setLoading(true);
        setError("");
        try {
            // First check if whitelisted for password auth
            const isWhitelisted = await postgrest.rpc("is_password_auth_whitelisted", {
                p_email: email
            });
            if (!isWhitelisted.data) {
                // Not whitelisted - show helpful error
                setError("Password authentication is not available for your account. Please use Microsoft or Google to sign in.");
                setLoading(false);
                return;
            }
            // Whitelisted - check if they have a password set
            const emailHasPassword = await hasPassword(email);
            if (emailHasPassword) setStep("password");
            else // Whitelisted but no password set - prompt to set up password
            setStep("setup-password");
        } catch (err) {
            setError("An error occurred. Please try again.");
            console.error("Error checking email:", err);
        } finally{
            setLoading(false);
        }
    };
    const handlePasswordLogin = async ()=>{
        if (!password) {
            setError("Please enter your password");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const success = await loginWithPassword(email, password);
            if (success) {
                // Redirect to stored URL or default to home page
                // Use window.location to force full page reload so identity re-initializes
                const redirectUrl = (0, $2a8b7cbac056e639$export$93832c3affb240d3)("/");
                window.location.href = `/#${redirectUrl}`;
            } else setError("Invalid email or password");
        } catch (err) {
            setError("An error occurred. Please try again.");
            console.error("Error logging in:", err);
        } finally{
            setLoading(false);
        }
    };
    const handleBackToEmail = ()=>{
        setStep("email");
        setPassword("");
        setError("");
        setShowEmailLogin(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                sx: {
                    height: "100%",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        width: 368,
                        margin: "auto",
                        border: 2,
                        borderColor: "divider",
                        p: 3,
                        mt: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    align: "center",
                                    variant: "h4",
                                    children: "Welcome Back"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    align: "center",
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: [
                                        step === "email" && "Sign in to your account",
                                        step === "password" && "Enter your password",
                                        step === "magic-link" && "We'll send you a login link",
                                        step === "setup-password" && "Set up your password"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 2,
                            children: [
                                step === "email" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "outlined",
                                            fullWidth: true,
                                            sx: {
                                                borderRadius: 1,
                                                borderColor: "divider"
                                            },
                                            onClick: async ()=>{
                                                await loginWithMicrosoft();
                                                // Redirect to stored URL or default to home page
                                                // Use window.location to force full page reload so identity re-initializes
                                                const redirectUrl = (0, $2a8b7cbac056e639$export$93832c3affb240d3)("/");
                                                window.location.href = `/#${redirectUrl}`;
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                spacing: 1,
                                                sx: {
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: "https://img.icons8.com/color/48/000000/microsoft.png",
                                                        style: {
                                                            width: 25
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        sx: {
                                                            color: "text.primary"
                                                        },
                                                        children: "Login with Microsoft"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hY1XM.GoogleLogin), {
                                            width: "320px",
                                            onSuccess: async (credentialResponse)=>{
                                                const token = credentialResponse.credential;
                                                const identity = $54c991629ee0a8ce$exports.decode(token);
                                                await loginWithGoogle(token, identity);
                                                // Redirect to stored URL or default to home page
                                                // Use window.location to force full page reload so identity re-initializes
                                                const redirectUrl = (0, $2a8b7cbac056e639$export$93832c3affb240d3)("/");
                                                window.location.href = `/#${redirectUrl}`;
                                            },
                                            onError: ()=>{
                                                console.log("Login Failed");
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            align: "center",
                                            sx: {
                                                mt: 2,
                                                cursor: "pointer",
                                                color: "text.secondary",
                                                "&:hover": {
                                                    textDecoration: "underline"
                                                }
                                            },
                                            onClick: ()=>setShowEmailLogin(true),
                                            children: "Use password instead (for special cases only)"
                                        }),
                                        showEmailLogin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                    sx: {
                                                        my: 2
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    color: "text.secondary",
                                                    sx: {
                                                        mb: 1,
                                                        display: "block"
                                                    },
                                                    children: "Password authentication is restricted per your organization's policy. Most users should use Microsoft or Google login above."
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                    label: "Email",
                                                    type: "email",
                                                    value: email,
                                                    onChange: (e)=>setEmail(e.target.value),
                                                    onKeyPress: (e)=>e.key === "Enter" && handleEmailSubmit(),
                                                    fullWidth: true,
                                                    error: Boolean(error),
                                                    helperText: error,
                                                    disabled: loading,
                                                    size: "small"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    variant: "outlined",
                                                    onClick: handleEmailSubmit,
                                                    fullWidth: true,
                                                    disabled: loading || !email,
                                                    size: "small",
                                                    sx: {
                                                        borderRadius: 1,
                                                        borderColor: "divider"
                                                    },
                                                    children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                                        size: 20
                                                    }) : "Continue"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    size: "small",
                                                    onClick: ()=>{
                                                        setShowEmailLogin(false);
                                                        setEmail("");
                                                        setError("");
                                                    },
                                                    sx: {
                                                        textTransform: "none"
                                                    },
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                step === "password" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "Email",
                                            type: "email",
                                            value: email,
                                            fullWidth: true,
                                            disabled: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "Password",
                                            type: "password",
                                            value: password,
                                            onChange: (e)=>setPassword(e.target.value),
                                            onKeyPress: (e)=>e.key === "Enter" && handlePasswordLogin(),
                                            fullWidth: true,
                                            autoFocus: true,
                                            error: Boolean(error),
                                            helperText: error,
                                            disabled: loading
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "contained",
                                            onClick: handlePasswordLogin,
                                            fullWidth: true,
                                            disabled: loading || !password,
                                            sx: {
                                                borderRadius: 1
                                            },
                                            children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                                size: 24
                                            }) : "Login"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    size: "small",
                                                    onClick: handleBackToEmail,
                                                    children: "Change email"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    size: "small",
                                                    component: (0, $lzNIT.Link),
                                                    to: "/forgot-password",
                                                    state: {
                                                        email: email
                                                    },
                                                    children: "Forgot password?"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                step === "setup-password" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "Email",
                                            type: "email",
                                            value: email,
                                            fullWidth: true,
                                            disabled: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                py: 1
                                            },
                                            children: "Your account is approved for password authentication. Please set up a password to continue."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "contained",
                                            component: (0, $lzNIT.Link),
                                            to: "/signup",
                                            state: {
                                                email: email
                                            },
                                            fullWidth: true,
                                            sx: {
                                                borderRadius: 1
                                            },
                                            children: "Set Up Password"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            size: "small",
                                            onClick: handleBackToEmail,
                                            fullWidth: true,
                                            children: "Change email"
                                        })
                                    ]
                                }),
                                step === "magic-link" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "Email",
                                            type: "email",
                                            value: email,
                                            fullWidth: true,
                                            disabled: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                py: 1
                                            },
                                            children: "No password set for this account. You can log in using a magic link sent to your email, or contact your administrator to set up password authentication."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "contained",
                                            component: (0, $lzNIT.Link),
                                            to: "/login/link",
                                            state: {
                                                email: email
                                            },
                                            fullWidth: true,
                                            sx: {
                                                borderRadius: 1
                                            },
                                            children: "Send login link"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            size: "small",
                                            onClick: handleBackToEmail,
                                            fullWidth: true,
                                            children: "Change email"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: $600f7fa9fdef2746$var$logo,
                style: {
                    position: "fixed",
                    bottom: 15,
                    right: 15,
                    width: 50
                }
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $iscuz = parcelRequire("iscuz");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $3kyM0 = parcelRequire("3kyM0");
// import logo from "../../../airplx-logo-transparent-square-no-text.png";
const $1e8c12e4e30b0f18$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $1e8c12e4e30b0f18$export$5c788018c6392017 = ()=>{
    const { url: tokenMakerURL } = (0, $3kyM0.useTokenMaker)();
    const [email, setEmail] = $acw62.useState("");
    const [sent, setSent] = $acw62.useState(false);
    const onClickSend = async ()=>{
        await fetch(`${tokenMakerURL}/login/link`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email
            })
        });
        setSent(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "60vh",
                width: "100vw",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    width: 450,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iscuz.default), {
                            in: !sent,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h6",
                                        children: "Login with a Magic Link"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "textSecondary",
                                        children: "Enter your email address below to receive a magic link to login."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                size: "small",
                                                fullWidth: true,
                                                label: "Email",
                                                variant: "outlined",
                                                onChange: (e)=>setEmail(e.target.value),
                                                value: email
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                disabled: // disabled if email does not match @airplx.com or @amway.com
                                                !email.match(/@(gmail|hotmail|airplx|amway)\.com$/) || email.length === 0,
                                                variant: "contained",
                                                color: "primary",
                                                onClick: onClickSend,
                                                children: "Send"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iscuz.default), {
                            in: sent,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h6",
                                        children: "Check your email"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "textSecondary",
                                        align: "center",
                                        children: [
                                            "An email with subject ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                children: "Login to AirPlx"
                                            }),
                                            " has been sent to",
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                children: email
                                            }),
                                            " with a magic link has been sent to your email address. Click the link to login."
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: $1e8c12e4e30b0f18$var$logo,
                style: {
                    position: "fixed",
                    bottom: 15,
                    right: 15,
                    width: 50
                }
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $2NPdf = parcelRequire("2NPdf");

var $gqehT = parcelRequire("gqehT");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");

const $b098f644182b1a7e$export$ad9ddc5bf7a9f508 = ()=>{
    const { airplxIdentity: airplxIdentity, loginWithMagicLink: loginWithMagicLink } = (0, $gqehT.useIdentity)();
    const navigate = (0, $aphAM.useNavigate)();
    const { code: code } = (0, $aphAM.useParams)();
    const { loading: loading } = (0, $2NPdf.default)(async ()=>{
        // convert code to token and login
        if (!code) return;
        await loginWithMagicLink(code);
    }, [
        code
    ]);
    $acw62.useEffect(()=>{
        if (airplxIdentity?.email) navigate("/");
    }, [
        airplxIdentity
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {});
    if (airplxIdentity?.email) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        width: "100%",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
            variant: "h4",
            children: [
                "Welcome to AirPlx ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                    children: airplxIdentity?.email
                }),
                "!"
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        width: "100%",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            spacing: 1,
            width: 500,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h4",
                    children: "We weren't able to log you in."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body1",
                    color: "textSecondary",
                    children: "Click the button below to try again. If this issue persists, please contact support@airplx.com."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $600f7fa9fdef2746$export$b3b2dca8d8638ba0), {})
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $4ckAs = parcelRequire("4ckAs");
// import logo from "../../../airplx-logo-transparent-square-no-text.png";
const $90fefde97640a06d$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $90fefde97640a06d$export$9d2f79ff058e7ac4 = ()=>{
    const { maintenanceEndTime: maintenanceEndTime } = (0, $4ckAs.useFeatureFlags)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        alignItems: "center",
        sx: {
            maxWidth: 600,
            margin: "auto",
            border: "8px solid black",
            borderRadius: 3,
            p: 3,
            mt: "10%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "row",
            alignItems: "center",
            justifyContent: "center",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "center",
                    alignContent: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: $90fefde97640a06d$var$logo,
                            style: {
                                width: 50
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            align: "center",
                            variant: "h4",
                            children: "AirPlx"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "subtitle2",
                    children: [
                        "We are currently undergoing scheduled maintenance. AirPlx is scheduled to be back online at",
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: maintenanceEndTime
                            })
                        }),
                        "."
                    ]
                })
            ]
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $ciKN1 = parcelRequire("ciKN1");

var $7FzhI = parcelRequire("7FzhI");

var $7p8YN = parcelRequire("7p8YN");

var $3AGzj = parcelRequire("3AGzj");

var $6AlVH = parcelRequire("6AlVH");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");

var $5Jffw = parcelRequire("5Jffw");

var $4o1tI = parcelRequire("4o1tI");

var $7p8YN = parcelRequire("7p8YN");

var $6fDLr = parcelRequire("6fDLr");

var $lNEp2 = parcelRequire("lNEp2");

var $b4ldQ = parcelRequire("b4ldQ");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");
parcelRequire("baghD");
var $drjQE = parcelRequire("drjQE");

var $3JLDK = parcelRequire("3JLDK");

var $acw62 = parcelRequire("acw62");
const $ba371427e8c26968$export$99369abfa4f5630e = (entity, position)=>{
    return 'aircraft' in entity ? {
        x: position.x + entity.aircraft.wingspan / 2,
        y: position.y + entity.aircraft.length / 2
    } : {
        x: position.x + entity.obstacle.width / 2,
        y: position.y + entity.obstacle.length / 2
    };
};
const $ba371427e8c26968$export$82e3997fd3fcb6e = (previousHCP, hangars, layoutPolygons, entity, position)=>{
    const center = $ba371427e8c26968$export$99369abfa4f5630e(entity, position);
    // first check to see if the aircraft is inside of a hangar container. if it's not then pick
    // the hangar that is closest to the point.
    // TODO: turn this into a function and implement the second part
    const found = layoutPolygons.find((hcp)=>{
        const [x, y] = hcp.polygon[0];
        const [x2, y2] = hcp.polygon[2];
        const isInHangar = center.x >= x && center.x <= x2 && center.y >= y && center.y <= y2;
        if (isInHangar) return isInHangar;
        return false;
    });
    if (found) return hangars.find((h)=>h.id === found.id);
    // otherwise, find the nearest hangar
    const distanceFromHangarPolygon = (hcp)=>{
        const x = hcp.x + hcp.width / 2;
        const y = hcp.y + hcp.depth / 2;
        return Math.sqrt((center.x - x) ** 2 + (center.y - y) ** 2);
    };
    const nearest = layoutPolygons.sort((a, b)=>distanceFromHangarPolygon(a) - distanceFromHangarPolygon(b))[0];
    return hangars.find((h)=>h.id === nearest.id);
};
const $ba371427e8c26968$export$305a94c6aeddb798 = ()=>{
    return $acw62.useCallback(()=>{
    // const { entity, locationId: previousLocationId } = payload.data;
    // DO SOME SCHTUFF
    }, []);
};



var $e8RbV = parcelRequire("e8RbV");

var $5U03M = parcelRequire("5U03M");

var $acw62 = parcelRequire("acw62");

var $5U03M = parcelRequire("5U03M");
const $8f66fb21f2f1b5fd$export$13492d43d9329f56 = (holdingAreaRef, hangarRefs, feetToPixels)=>{
    const leftmostX = Math.min(...hangarRefs.map((hangarRef)=>{
        const hangarRect = hangarRef.current.getBoundingClientRect();
        return hangarRect.left;
    }));
    const bottommostY = Math.max(...hangarRefs.map((hangarRef)=>{
        const hangarRect = hangarRef.current.getBoundingClientRect();
        return hangarRect.bottom;
    }));
    const holdingAreaRect = holdingAreaRef.current.getBoundingClientRect();
    const holdingAreaRectRelativeToBottomLeft = {
        x: holdingAreaRect.x - leftmostX,
        y: bottommostY - holdingAreaRect.bottom,
        width: holdingAreaRect.width,
        height: holdingAreaRect.height
    };
    const holdingAreaPolygonPixels = [
        [
            holdingAreaRectRelativeToBottomLeft.x,
            holdingAreaRectRelativeToBottomLeft.y
        ],
        [
            holdingAreaRectRelativeToBottomLeft.x,
            holdingAreaRectRelativeToBottomLeft.y + holdingAreaRectRelativeToBottomLeft.height
        ],
        [
            holdingAreaRectRelativeToBottomLeft.x + holdingAreaRectRelativeToBottomLeft.width,
            holdingAreaRectRelativeToBottomLeft.y + holdingAreaRectRelativeToBottomLeft.height
        ],
        [
            holdingAreaRectRelativeToBottomLeft.x + holdingAreaRectRelativeToBottomLeft.width,
            holdingAreaRectRelativeToBottomLeft.y
        ],
        [
            holdingAreaRectRelativeToBottomLeft.x,
            holdingAreaRectRelativeToBottomLeft.y
        ]
    ];
    const holdingAreaPolygonFeet = holdingAreaPolygonPixels.map((p)=>p.map((i)=>i / feetToPixels));
    const canvasRect = holdingAreaRef.current.querySelector("canvas").getBoundingClientRect();
    const widthOffsetPixels = canvasRect.left - holdingAreaRect.left;
    const depthOffsetPixels = holdingAreaRect.bottom - canvasRect.bottom;
    return {
        id: (0, $5U03M.HOLDING_AREA_ID),
        polygon: holdingAreaPolygonFeet,
        x: holdingAreaRectRelativeToBottomLeft.x / feetToPixels,
        y: holdingAreaRectRelativeToBottomLeft.y / feetToPixels,
        // distance from the bottom of the hangar container to the bottom of the hangar canvas
        widthOffset: widthOffsetPixels / feetToPixels,
        depthOffset: depthOffsetPixels / feetToPixels,
        width: holdingAreaRectRelativeToBottomLeft.width / feetToPixels,
        depth: holdingAreaRectRelativeToBottomLeft.height / feetToPixels,
        pixels: holdingAreaPolygonPixels,
        feet: holdingAreaPolygonFeet,
        depthOffsetPixels: depthOffsetPixels
    };
};
const $8f66fb21f2f1b5fd$export$fcb4fc3e4badf49f = (props, deps)=>{
    const [layoutPolygons, setLayoutPolygons] = $acw62.useState([]);
    const { hangarRefs: allHangarRefs, holdingAreaRef: holdingAreaRef, multiHangarLayoutHeight: multiHangarLayoutHeight, feetToPixels: feetToPixels } = props;
    $acw62.useEffect(()=>{
        // limit to refs currently in the DOM
        const hangarRefs = allHangarRefs.filter((x)=>x.current);
        const rects = hangarRefs.map((ref)=>ref.current.getBoundingClientRect());
        const minX = Math.min(...rects.map((r)=>r.x));
        const minY = Math.min(...rects.map((r)=>r.y));
        const polygons = hangarRefs.map((ref)=>{
            const rect = ref.current.getBoundingClientRect();
            const canvasRect = ref.current.querySelector("canvas").getBoundingClientRect();
            const widthOffsetPixels = canvasRect.left - rect.left;
            const depthOffsetPixels = rect.bottom - canvasRect.bottom;
            // we're going to invert the y axis so that the origin is in the bottom left
            const rectRelativeToBottomLeft = {
                x: rect.x - minX,
                y: multiHangarLayoutHeight - rect.y - rect.height + minY,
                width: rect.width,
                height: rect.height
            };
            const polygonPixels = [
                [
                    rectRelativeToBottomLeft.x,
                    rectRelativeToBottomLeft.y
                ],
                [
                    rectRelativeToBottomLeft.x,
                    rectRelativeToBottomLeft.y + rectRelativeToBottomLeft.height
                ],
                [
                    rectRelativeToBottomLeft.x + rectRelativeToBottomLeft.width,
                    rectRelativeToBottomLeft.y + rectRelativeToBottomLeft.height
                ],
                [
                    rectRelativeToBottomLeft.x + rectRelativeToBottomLeft.width,
                    rectRelativeToBottomLeft.y
                ],
                [
                    rectRelativeToBottomLeft.x,
                    rectRelativeToBottomLeft.y
                ]
            ];
            const polygonFeet = polygonPixels.map((p)=>p.map((i)=>i / feetToPixels));
            return {
                id: ref.current.getAttribute("data-id"),
                polygon: polygonFeet,
                x: rectRelativeToBottomLeft.x / feetToPixels,
                y: rectRelativeToBottomLeft.y / feetToPixels,
                // distance from the corner of the hangar container to the bottom of the hangar canvas
                widthOffset: widthOffsetPixels / feetToPixels,
                depthOffset: depthOffsetPixels / feetToPixels,
                width: rectRelativeToBottomLeft.width / feetToPixels,
                depth: rectRelativeToBottomLeft.height / feetToPixels,
                // extras
                pixels: polygonPixels,
                feet: polygonFeet,
                depthOffsetPixels: depthOffsetPixels
            };
        });
        if (holdingAreaRef.current && holdingAreaRef.current.querySelector("canvas")) polygons.push($8f66fb21f2f1b5fd$export$13492d43d9329f56(holdingAreaRef, hangarRefs, feetToPixels));
        setLayoutPolygons(polygons);
    }, [
        multiHangarLayoutHeight,
        feetToPixels,
        ...deps
    ]);
    return layoutPolygons;
};


const $aa3f6e90678f61bc$export$f7452e218803201a = ({ hangarIds: hangarIds })=>{
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const theme = (0, $14H9o.default)();
    const { ready: ready, zoom: zoom, setZoom: setZoom, activeLocationId: activeLocationId, focus: focus, hangars: allHangars, setHangars: setHangars, setActiveLocationId: setActiveLocationId } = (0, $7p8YN.useMultiHangarState)();
    const hangars = allHangars.filter((h)=>hangarIds.indexOf(h.id) > -1);
    const hangarRefs = hangars.map(()=>/*#__PURE__*/ $acw62.createRef());
    // it's easier it we treat the holding area as its own speical place. technically it's a hangar
    // but it's not *actually* a hangar.
    const holdingAreaRef = /*#__PURE__*/ $acw62.createRef();
    // this is the container for all of the the actual drawings of all of the hangars
    // we need this to account for when an airplane gets dropped into a different hangar so
    // that we can update the position of the airplane relative to the new hangar.
    const [refMultiHangarLayout, { height: multiHangarLayoutHeight }] = (0, $5Jffw.default)();
    const moveEvent = (0, $4o1tI.useEventContainer)();
    const feetToPixels = (0, $e8RbV.getFeetToPixels)(hangars.filter((h)=>focus ? h.id === focus : true), zoom, focus);
    // for the multi-hangar layout, we need to account for the "whitespace" between the canvas of each hangar.
    // this is stuff such as padding, the title, etc. we need to account for this so that the global coordinates
    // of each hangar are correct.
    const layoutPolygons = (0, $8f66fb21f2f1b5fd$export$fcb4fc3e4badf49f)({
        hangars: hangars,
        hangarRefs: hangarRefs,
        holdingAreaRef: holdingAreaRef,
        multiHangarLayoutHeight: multiHangarLayoutHeight,
        feetToPixels: feetToPixels
    }, [
        activeLocationId,
        focus
    ]);
    /**
   * I need a way to check if a plane goes into another hangar. If that happens,
   * then we need to move the plane out of its original hangar and into the new one.
   */ const handleOnMoveEntity = $acw62.useCallback((payload)=>{
        const { entity: entity, locationId: previousLocationId } = payload.data;
        // convert coordinates to the 'global' coordinate system
        // this is the entire component (including the padding, title, etc.) not just the
        // hangar canvas.
        // determine where the tenant is now located
        const previousHangarIdx = allHangars.findIndex((h)=>h.id === previousLocationId);
        if (previousHangarIdx === -1) return;
        if (layoutPolygons.length === 0 || !layoutPolygons?.[0]?.depth) return;
        // need to account for the vertical padding from the hangar, as well as the distance offset
        // from the origin of the hangar
        // remove a few things and then it's the largest hangar's depth as baseline - this hangar's depth.
        // then adjusted for the offset from the origin
        const previousHCP = layoutPolygons.find((hcp)=>hcp.id === previousLocationId);
        const globalPosition = {
            ...entity.position,
            x: entity.position.x + previousHCP.x + previousHCP.widthOffset,
            y: entity.position.y + previousHCP.y + previousHCP.depthOffset
        };
        const newHangar = (0, $ba371427e8c26968$export$82e3997fd3fcb6e)(previousHCP, allHangars, layoutPolygons, entity, globalPosition);
        // now we need to convert the global coordinates of the aircraft to the local
        // coordinates of the hangar. to do this, we'll remove the padding we applied
        // to the global coordinates.
        const newHangarPolygon = layoutPolygons.find((hcp)=>hcp.id === newHangar.id);
        const newPosition = {
            ...entity.position,
            id: (0, $lNEp2.uuidv4)(),
            stack_id: newHangar.stack.id,
            x: globalPosition.x - newHangarPolygon.x - newHangarPolygon.widthOffset,
            y: globalPosition.y - newHangarPolygon.y - newHangarPolygon.depthOffset,
            angle: entity.position.angle
        };
        if (!newHangar) return;
        if (newHangar.id === previousLocationId) return;
        let newTenant;
        if (entity.entity_type === "tenant") {
            newTenant = {
                ...entity,
                position: newPosition
            };
            if (newHangar.id !== (0, $5U03M.HOLDING_AREA_ID)) {
                // checking for things like if the airplane is too tall for the hangar
                const warnings = (0, $b4ldQ.checkForAircraftWarnings)(newTenant.aircraft, {
                    type: "hangar",
                    ...newHangar
                });
                // if a warning triggers, throw it back up to the global warning snackbar.
                for (const warning of warnings)snackbar.notify({
                    text: warning,
                    severity: "error"
                });
            }
        }
        let movableObstacle;
        if (entity.entity_type === "movableObstacle") movableObstacle = {
            ...entity,
            position: newPosition
        };
        setHangars((hangars)=>hangars.map((h)=>{
                if (h.id === newHangar.id) {
                    const tenants = Boolean(newTenant) ? [
                        ...h.stack.tenants,
                        newTenant
                    ] : h.stack.tenants;
                    const movableObstacles = Boolean(movableObstacle) ? [
                        ...h.stack.movableObstacles,
                        movableObstacle
                    ] : h.stack.movableObstacles;
                    return {
                        ...h,
                        stack: {
                            ...h.stack,
                            tenants: tenants,
                            movableObstacles: movableObstacles
                        }
                    };
                } else return {
                    ...h,
                    stack: {
                        ...h.stack,
                        tenants: h.stack.tenants.filter((t)=>t.id !== newTenant?.id),
                        movableObstacles: h.stack.movableObstacles.filter((mo)=>mo.id !== movableObstacle?.id)
                    }
                };
            }));
        setActiveLocationId(newHangar.id);
    }, [
        layoutPolygons,
        hangars,
        setHangars,
        zoom,
        theme
    ]);
    $acw62.useEffect(()=>{
        moveEvent.addEventListener("moveEntity", handleOnMoveEntity);
        return ()=>{
            moveEvent.removeEventListener("moveEntity", handleOnMoveEntity);
        };
    }, [
        handleOnMoveEntity,
        moveEvent.addEventListener,
        moveEvent.removeEventListener
    ]);
    /**
   * it's easiest to let the multihangar select multiple tenants simultaneously
   * and then remove the `selected: true` flat on tenants where it should not be
   * selected. this happens when the user is changing active hangars. the reason it's
   * being done here is because if we try to do this in the onMouseDown event within the
   * HangarViewWrapper, it will cause the click event to not fire.
   */ const selectedTenants = hangars.map((hangar)=>hangar.stack.tenants.filter((t)=>t.selected)).flat();
    $acw62.useEffect(()=>{
        if (selectedTenants.length === 0) return;
        // find tenant that is also in the hangar that is currently selected
        setHangars((hangars)=>hangars.map((h)=>({
                    ...h,
                    stack: {
                        ...h.stack,
                        tenants: h.stack.tenants.map((t)=>{
                            if (t.selected && h.id === activeLocationId) return {
                                ...t,
                                selected: true
                            };
                            return {
                                ...t,
                                selected: false
                            };
                        })
                    }
                })));
    }, [
        JSON.stringify(selectedTenants.map((t)=>t.id))
    ]);
    if (!ready) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        sx: {
            width: "100%",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                ref: refMultiHangarLayout,
                "data-id": "multi-hangar-layout",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-start" // Align items at the start of the flex container (top of each row)
                ,
                justifyContent: "flex-start" // Justify items at the start of the flex container (left)
                ,
                sx: {
                    placeSelf: "flex-start",
                    marginLeft: !isDrawerOpen ? "150px" : "400px",
                    marginTop: `50px`,
                    p: 2,
                    // height: "100%", // causes planes to "hop" when moving to/from holding area
                    overflowY: "scroll"
                },
                children: hangars.filter((h)=>{
                    if (focus) return h.id === focus || h.id === activeLocationId;
                    if (h.id === (0, $5U03M.HOLDING_AREA_ID)) return false;
                    return true;
                }).map((hangar, idx)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        ref: hangarRefs[idx],
                        "data-id": hangar.id,
                        height: "100%",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8RbV.HangarViewWrapper), {
                            hangarId: hangar.id,
                            feetToPixels: feetToPixels
                        })
                    }, `multihangar-${hangar.id}`);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                ref: holdingAreaRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5U03M.HoldingArea), {
                    feetToPixels: feetToPixels,
                    multiHangarLayoutHeight: multiHangarLayoutHeight
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drjQE.ZoomControl), {
                currentZoom: zoom,
                increment: 0.1,
                onClickPlus: ()=>setZoom(zoom * 1.1),
                onClickMinus: ()=>setZoom(zoom * 0.9)
            })
        ]
    });
};


const $662710c37101de9c$export$36344c50020c7a7e = ()=>{
    const params = (0, $aphAM.useParams)();
    const ids = params.ids.split("|");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7p8YN.MultiHangarStateContainer), {
        initialState: {
            hangarIds: ids,
            activeHangarId: ids[0]
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciKN1.AutocompleteResultsContainer), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
                isReference: false,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
                    isReference: false,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6AlVH.TowingEquipmentContainer), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa3f6e90678f61bc$export$f7452e218803201a), {
                            hangarIds: ids
                        })
                    })
                })
            })
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $6ami2 = parcelRequire("6ami2");
var $2cPwN = parcelRequire("2cPwN");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");

var $7qEX0 = parcelRequire("7qEX0");

var $bPDWy = parcelRequire("bPDWy");

var $8NnpI = parcelRequire("8NnpI");

var $ayMG0 = parcelRequire("ayMG0");
const $26f3a9e890bcae2b$var$defaultTheme = (0, $8NnpI.default)();
const $26f3a9e890bcae2b$var$defaultCreateStyledComponent = (0, $bPDWy.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $gxvzd.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $26f3a9e890bcae2b$var$useThemePropsDefault = (inProps)=>(0, $7qEX0.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $26f3a9e890bcae2b$var$defaultTheme
    });
const $26f3a9e890bcae2b$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $4Cod0.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $gxvzd.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, getContainerUtilityClass, classes);
};
function $26f3a9e890bcae2b$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $26f3a9e890bcae2b$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $26f3a9e890bcae2b$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $26f3a9e890bcae2b$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}



var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $2291beb327d500f8$var$Container = (0, $26f3a9e890bcae2b$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $2291beb327d500f8$export$2e2bcd8739ae039 = $2291beb327d500f8$var$Container;


var $5RIww = parcelRequire("5RIww");
var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");
var $lHOu3 = parcelRequire("lHOu3");

var $f56pe = parcelRequire("f56pe");
'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $2d16bff1157c299f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $lHOu3.default)();
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                if (nativeEvent.key === 'Escape') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose?.(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $13KXh.default)((event, reason)=>{
        onClose?.(event, reason);
    });
    const setAutoHideTimer = (0, $13KXh.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose?.(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback?.(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback?.(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback?.(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback?.(event);
            handleResume();
        };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = {
            ...(0, $f56pe.default)(parameters),
            ...(0, $f56pe.default)(externalProps)
        };
        return {
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation',
            ...externalProps,
            ...externalEventHandlers,
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        };
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $2d16bff1157c299f$export$2e2bcd8739ae039 = $2d16bff1157c299f$var$useSnackbar;



var $kGwBF = parcelRequire("kGwBF");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $iscuz = parcelRequire("iscuz");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8gMkr = parcelRequire("8gMkr");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $7Frhn = parcelRequire("7Frhn");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4d2fdf4430378182$export$def81488db1a3216(slot) {
    return (0, $4Cod0.default)('MuiSnackbarContent', slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $beCSm.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $4d2fdf4430378182$export$2e2bcd8739ae039 = $4d2fdf4430378182$var$snackbarContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4d2fdf4430378182$export$def81488db1a3216), classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $aeD7H.default)(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $8gMkr.emphasize)(theme.palette.background.default, emphasis);
    return {
        ...theme.typography.body2,
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    };
}));
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert', ...other } = props;
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, {
        role: role,
        square: true,
        elevation: 6,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    });
});
var $dbe322effc7340b4$export$2e2bcd8739ae039 = $dbe322effc7340b4$var$SnackbarContent;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3bdc4d25b715a88$export$6cb096457f5926f4(slot) {
    return (0, $4Cod0.default)('MuiSnackbar', slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $beCSm.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $f3bdc4d25b715a88$export$2e2bcd8739ae039 = $f3bdc4d25b715a88$var$snackbarClasses;



var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3bdc4d25b715a88$export$6cb096457f5926f4), classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top',
                style: {
                    top: 8,
                    [theme.breakpoints.up('sm')]: {
                        top: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical !== 'top',
                style: {
                    bottom: 8,
                    [theme.breakpoints.up('sm')]: {
                        bottom: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'left',
                style: {
                    justifyContent: 'flex-start',
                    [theme.breakpoints.up('sm')]: {
                        left: 24,
                        right: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'right',
                style: {
                    justifyContent: 'flex-end',
                    [theme.breakpoints.up('sm')]: {
                        right: 24,
                        left: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'center',
                style: {
                    [theme.breakpoints.up('sm')]: {
                        left: '50%',
                        right: 'auto',
                        transform: 'translateX(-50%)'
                    }
                }
            }
        ]
    })));
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $14H9o.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerPropsProp, ContentProps: ContentPropsProp, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited, ...TransitionPropsProp } = {}, ...other } = props;
    const ownerState = {
        ...props,
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponentProp,
        transitionDuration: transitionDuration
    };
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $2d16bff1157c299f$export$2e2bcd8739ae039)({
        ...ownerState
    });
    const [exited, setExited] = $acw62.useState(true);
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponentProp,
            ...slots
        },
        slotProps: {
            content: ContentPropsProp,
            clickAwayListener: ClickAwayListenerPropsProp,
            transition: TransitionPropsProp,
            ...slotProps
        }
    };
    const [Root, rootProps] = (0, $6lpak.default)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $ef601776ba11bb1e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState
    });
    const [ClickAwaySlot, { ownerState: clickAwayOwnerStateProp, ...clickAwayListenerProps }] = (0, $6lpak.default)('clickAwayListener', {
        elementType: (0, $kGwBF.ClickAwayListener),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onClickAway: (...params)=>{
                    handlers.onClickAway?.(...params);
                    onClickAway(...params);
                }
            }),
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $6lpak.default)('content', {
        elementType: (0, $dbe322effc7340b4$export$2e2bcd8739ae039),
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            message: message,
            action: action
        },
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $iscuz.default),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onEnter: (...params)=>{
                    handlers.onEnter?.(...params);
                    handleEnter(...params);
                },
                onExited: (...params)=>{
                    handlers.onExited?.(...params);
                    handleExited(...params);
                }
            }),
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            direction: vertical === 'top' ? 'down' : 'up'
        },
        ownerState: ownerState
    });
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(ClickAwaySlot, {
        ...clickAwayListenerProps,
        ...slots.clickAwayListener && {
            ownerState: clickAwayOwnerStateProp
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
            ...rootProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                ...transitionProps,
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)(ContentSlot, {
                    ...contentSlotProps
                })
            })
        })
    });
});
var $ef601776ba11bb1e$export$2e2bcd8739ae039 = $ef601776ba11bb1e$var$Snackbar;


var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $3kyM0 = parcelRequire("3kyM0");

var $e5CQE = parcelRequire("e5CQE");
// import logo from "../../../airplx-logo-transparent-square-no-text.png";
const $989bebeace70f0e5$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $989bebeace70f0e5$export$4b37b77b314e9ac4 = ()=>{
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { pendingInvites: pendingInvites, loading: loading } = (0, $e5CQE.usePendingInvites)();
    const navigate = (0, $aphAM.useNavigate)();
    const theme = (0, $14H9o.default)();
    const { url: tokenMakerURL } = (0, $3kyM0.useTokenMaker)();
    const { activeFBO: activeFBO, fbos: fbos, ready: ready, setActiveFBOId: setActiveFBOId } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { inviteId: inviteId } = (0, $aphAM.useParams)();
    // Determine user's FBO context
    const hasFBOs = fbos && fbos.length > 0;
    // State for tracking which invites are being claimed
    const [claimingInvites, setClaimingInvites] = $acw62.useState(new Set());
    // State for tracking errors on specific invites
    const [errorInvites, setErrorInvites] = $acw62.useState(new Map());
    // State for user feedback snackbar
    const [snackbar, setSnackbar] = $acw62.useState({
        open: false,
        message: "",
        severity: "success"
    });
    // State for direct-link invite (from URL parameter)
    const [directLinkInvite, setDirectLinkInvite] = $acw62.useState(null);
    const [directLinkLoading, setDirectLinkLoading] = $acw62.useState(false);
    // Validation function that mirrors ClaimInvite.tsx
    const validateInvite = async (inviteId)=>{
        const { data: data } = await postgrest.rpc("is_invite_valid", {
            invite_id: inviteId,
            email: airplxIdentity?.email
        }).single();
        return data;
    };
    // Comprehensive claim function with validation and error handling
    const handleClaimInvite = async (inviteId)=>{
        // Clear any previous error for this invite
        setErrorInvites((prev)=>{
            const newMap = new Map(prev);
            newMap.delete(inviteId);
            return newMap;
        });
        // Guard clauses - check required dependencies
        if (!airplxIdentity?.userid) {
            setErrorInvites((prev)=>new Map(prev).set(inviteId, "User authentication required"));
            setSnackbar({
                open: true,
                message: "Please log in again to accept invitations",
                severity: "error"
            });
            return;
        }
        if (!tokenMakerURL) {
            setErrorInvites((prev)=>new Map(prev).set(inviteId, "Service unavailable"));
            setSnackbar({
                open: true,
                message: "Service temporarily unavailable. Please try again.",
                severity: "error"
            });
            return;
        }
        if (!airplxIdentity?.email) {
            setErrorInvites((prev)=>new Map(prev).set(inviteId, "Email required"));
            setSnackbar({
                open: true,
                message: "User email is required to validate invitation",
                severity: "error"
            });
            return;
        }
        // Add to claiming set for loading state
        setClaimingInvites((prev)=>new Set([
                ...prev,
                inviteId
            ]));
        try {
            // Step 1: Validate invite first (mirrors ClaimInvite.tsx)
            const validation = await validateInvite(inviteId);
            if (!validation?.is_valid) throw new Error("Invite is no longer valid or has already been claimed");
            // Use FBO ID from validation (not from pending invites data)
            const validatedFboId = validation.fbo_id;
            if (!validatedFboId) throw new Error("Invalid FBO information in invitation");
            // Step 2: Claim the invite via tokenMaker API
            const response = await fetch(`${tokenMakerURL}/claim/invite/${inviteId}/${airplxIdentity.userid}`);
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to claim invite: ${errorText}`);
            }
            const result = await response.json();
            if (!result.did_claim) throw new Error("Invite could not be claimed");
            // Step 3: Set active FBO using validated FBO ID
            // No need to refresh token - JWT doesn't include FBO memberships anymore.
            // The page reload will fetch updated FBO memberships from the database.
            setActiveFBOId(validatedFboId);
            // Step 5: Show success feedback
            setSnackbar({
                open: true,
                message: `Successfully joined ${validation.name}!`,
                severity: "success"
            });
            // Step 6: Navigate home (same as ClaimInvite.tsx)
            navigate("/");
            window.location.reload();
        } catch (error) {
            console.error("Error claiming invite:", error);
            const errorMessage = error instanceof Error ? error.message : "Failed to accept invitation";
            setErrorInvites((prev)=>new Map(prev).set(inviteId, errorMessage));
            setSnackbar({
                open: true,
                message: errorMessage,
                severity: "error"
            });
            // Remove from claiming set on error
            setClaimingInvites((prev)=>{
                const newSet = new Set(prev);
                newSet.delete(inviteId);
                return newSet;
            });
        }
    };
    // Fetch direct-link invite when inviteId is present in URL
    $acw62.useEffect(()=>{
        const fetchDirectLinkInvite = async ()=>{
            if (!inviteId || !postgrest) return;
            setDirectLinkLoading(true);
            try {
                const validation = await validateInvite(inviteId);
                if (validation?.is_valid) setDirectLinkInvite({
                    id: inviteId,
                    fbo_id: validation.fbo_id,
                    fbo_name: validation.name,
                    is_valid: true
                });
                else // Invalid invite - show error
                setSnackbar({
                    open: true,
                    message: "This invitation link is invalid or has already been claimed",
                    severity: "error"
                });
            } catch (error) {
                console.error("Error fetching direct-link invite:", error);
                setSnackbar({
                    open: true,
                    message: "Failed to load invitation. Please try again.",
                    severity: "error"
                });
            } finally{
                setDirectLinkLoading(false);
            }
        };
        fetchDirectLinkInvite();
    }, [
        inviteId,
        postgrest
    ]);
    // Helper functions for invite status and styling
    const getInviteCardSx = (invite)=>({
            transition: "all 0.2s ease-in-out",
            "&:hover": invite.is_expired ? {} : {
                elevation: 4,
                transform: "translateY(-2px)",
                boxShadow: theme.shadows[8]
            },
            borderRadius: 2,
            overflow: "hidden",
            opacity: invite.is_expired ? 0.7 : 1,
            border: invite.is_expired ? `1px solid ${theme.palette.error.light}` : "none"
        });
    const getStatusChip = (invite)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
            label: invite.is_expired ? "Expired" : "Pending",
            size: "small",
            color: invite.is_expired ? "error" : "warning",
            variant: "outlined",
            sx: invite.is_expired ? {
                backgroundColor: theme.palette.error.light,
                color: theme.palette.error.contrastText
            } : {
                backgroundColor: theme.palette.warning.light,
                color: theme.palette.warning.contrastText
            }
        });
    const getActionButton = (invite)=>{
        if (invite.is_expired) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
            variant: "outlined",
            size: "large",
            disabled: true,
            sx: {
                minWidth: 120,
                fontWeight: "medium",
                color: theme.palette.error.main,
                borderColor: theme.palette.error.main
            },
            children: "Expired"
        });
        // For valid invites, use existing button logic
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
            variant: "contained",
            size: "large",
            onClick: ()=>handleClaimInvite(invite.id),
            disabled: claimingInvites.has(invite.id),
            sx: {
                minWidth: 120,
                fontWeight: "medium",
                ...getButtonColor(invite.id)
            },
            children: getButtonContent(invite.id)
        });
    };
    // Helper functions for button state management (for valid invites only)
    const getButtonState = (inviteId)=>{
        if (claimingInvites.has(inviteId)) return "claiming";
        if (errorInvites.has(inviteId)) return "error";
        return "default";
    };
    const getButtonContent = (inviteId)=>{
        const state = getButtonState(inviteId);
        switch(state){
            case "claiming":
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                            size: 16,
                            sx: {
                                mr: 1,
                                color: "white"
                            }
                        }),
                        "Accepting..."
                    ]
                });
            case "error":
                return "Try Again";
            default:
                return "Accept";
        }
    };
    const getButtonColor = (inviteId)=>{
        const state = getButtonState(inviteId);
        switch(state){
            case "error":
                return {
                    backgroundColor: theme.palette.error.main,
                    "&:hover": {
                        backgroundColor: theme.palette.error.dark
                    }
                };
            default:
                return {
                    backgroundColor: theme.palette.primary.main,
                    "&:hover": {
                        backgroundColor: theme.palette.primary.dark
                    }
                };
        }
    };
    // Navigation helpers for existing FBO users
    const handleReturnToDashboard = ()=>{
        const targetFBO = activeFBO || fbos?.[0];
        if (targetFBO && targetFBO.id !== activeFBO?.id) setActiveFBOId(targetFBO.id);
        navigate("/hangars");
    };
    const handleSwitchFBO = ()=>{
        navigate("/settings");
    };
    // Context-aware messaging functions
    const getHeaderMessage = ()=>{
        if (!ready) return null; // Still loading FBO data
        if (!hasFBOs) {
            // No FBOs - show invite-specific messages
            if (loading) return null;
            const validInvites = pendingInvites.filter((invite)=>!invite.is_expired);
            const expiredInvites = pendingInvites.filter((invite)=>invite.is_expired);
            if (validInvites.length > 0 && expiredInvites.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "h5",
                sx: {
                    color: theme.palette.warning.main,
                    fontWeight: "medium",
                    textAlign: "center",
                    mb: 3
                },
                children: [
                    "\uD83D\uDCCB You have ",
                    validInvites.length,
                    " active and ",
                    expiredInvites.length,
                    " ",
                    "expired invitation",
                    expiredInvites.length > 1 ? "s" : ""
                ]
            });
            else if (validInvites.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h5",
                sx: {
                    color: theme.palette.success.main,
                    fontWeight: "medium",
                    textAlign: "center",
                    mb: 3
                },
                children: "\uD83C\uDF89 You have pending invitations!"
            });
            else if (expiredInvites.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "h5",
                sx: {
                    color: theme.palette.error.main,
                    fontWeight: "medium",
                    textAlign: "center",
                    mb: 3
                },
                children: [
                    "\u23F0 Your invitation",
                    expiredInvites.length > 1 ? "s have" : " has",
                    " ",
                    "expired"
                ]
            });
        } else {
            // Has FBOs - show additional invite context
            if (loading) return null;
            if (pendingInvites.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h5",
                sx: {
                    color: theme.palette.info.main,
                    fontWeight: "medium",
                    textAlign: "center",
                    mb: 3
                },
                children: "\uD83C\uDFE2 Additional FBO Invitations"
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h5",
                sx: {
                    color: theme.palette.primary.main,
                    fontWeight: "medium",
                    textAlign: "center",
                    mb: 3
                },
                children: "\uD83D\uDC4B Welcome back!"
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        maxWidth: "md",
        sx: {
            mt: 4,
            mb: 4
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minHeight: "60vh",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        sx: {
                            mb: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                component: "img",
                                src: $989bebeace70f0e5$var$logo,
                                alt: "AirPlx Logo",
                                sx: {
                                    width: 56,
                                    height: 56,
                                    border: "2px solid",
                                    borderColor: theme.palette.primary.main,
                                    borderRadius: "50%"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "h3",
                                color: "primary",
                                fontWeight: "bold",
                                children: "AirPlx"
                            })
                        ]
                    }),
                    loading || !ready || directLinkLoading ? // Loading State (includes both invite loading and FBO loading)
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            width: "100%",
                            maxWidth: 600
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                variant: "text",
                                width: 300,
                                height: 40,
                                sx: {
                                    mb: 3,
                                    mx: "auto"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                spacing: 3,
                                children: [
                                    1,
                                    2
                                ].map((index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                        elevation: 2,
                                        sx: {
                                            borderRadius: 2
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                                            sx: {
                                                p: 3
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                spacing: 3,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                        flex: 1,
                                                        spacing: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                alignItems: "center",
                                                                spacing: 2,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        variant: "text",
                                                                        width: 120,
                                                                        height: 32
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                        variant: "rectangular",
                                                                        width: 60,
                                                                        height: 24,
                                                                        sx: {
                                                                            borderRadius: 1
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                                variant: "text",
                                                                width: 100,
                                                                height: 20
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                                        variant: "rectangular",
                                                        width: 120,
                                                        height: 40,
                                                        sx: {
                                                            borderRadius: 1
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    }, index))
                            })
                        ]
                    }) : directLinkInvite || pendingInvites.length > 0 ? // Has pending invites (for users with or without existing FBOs)
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            width: "100%",
                            maxWidth: 600
                        },
                        children: [
                            getHeaderMessage(),
                            hasFBOs && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                variant: "outlined",
                                sx: {
                                    mb: 3,
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                    sx: {
                                        py: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            children: [
                                                "Currently active: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: activeFBO?.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            spacing: 2,
                                            justifyContent: "center",
                                            sx: {
                                                mt: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    size: "small",
                                                    variant: "contained",
                                                    onClick: handleReturnToDashboard,
                                                    sx: {
                                                        fontSize: "0.75rem"
                                                    },
                                                    children: "Return to Dashboard"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    size: "small",
                                                    onClick: handleSwitchFBO,
                                                    sx: {
                                                        fontSize: "0.75rem"
                                                    },
                                                    children: "Switch FBO"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            directLinkInvite && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle1",
                                        sx: {
                                            color: theme.palette.info.main,
                                            fontWeight: "medium",
                                            mb: 2
                                        },
                                        children: "\uD83D\uDCE7 Invitation from Email Link"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                        elevation: 3,
                                        sx: {
                                            borderRadius: 2,
                                            overflow: "hidden",
                                            border: `2px solid ${theme.palette.primary.main}`,
                                            mb: 3
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                                            sx: {
                                                p: 3
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                spacing: 3,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                        flex: 1,
                                                        spacing: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                alignItems: "center",
                                                                spacing: 2,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "h6",
                                                                        fontWeight: "medium",
                                                                        children: directLinkInvite.fbo_name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                        label: "Pending",
                                                                        size: "small",
                                                                        color: "primary",
                                                                        variant: "outlined",
                                                                        sx: {
                                                                            backgroundColor: theme.palette.primary.light,
                                                                            color: theme.palette.primary.contrastText
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "body2",
                                                                color: "text.secondary",
                                                                children: "Click Accept to join this FBO"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                        variant: "contained",
                                                        size: "large",
                                                        onClick: ()=>handleClaimInvite(directLinkInvite.id),
                                                        disabled: claimingInvites.has(directLinkInvite.id),
                                                        sx: {
                                                            minWidth: 120,
                                                            fontWeight: "medium",
                                                            ...getButtonColor(directLinkInvite.id)
                                                        },
                                                        children: getButtonContent(directLinkInvite.id)
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                spacing: 3,
                                children: pendingInvites.filter((invite)=>invite.id !== directLinkInvite?.id).map((invite)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                        elevation: 2,
                                        sx: getInviteCardSx(invite),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                                            sx: {
                                                p: 3
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                direction: "row",
                                                spacing: 3,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                        flex: 1,
                                                        spacing: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                alignItems: "center",
                                                                spacing: 2,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "h6",
                                                                        fontWeight: "medium",
                                                                        sx: {
                                                                            color: invite.is_expired ? theme.palette.text.secondary : "inherit"
                                                                        },
                                                                        children: invite.fbo?.name || "Unknown FBO"
                                                                    }),
                                                                    getStatusChip(invite)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                variant: "body2",
                                                                color: "text.secondary",
                                                                children: [
                                                                    "Invited",
                                                                    " ",
                                                                    new Date(invite.created_at).toLocaleDateString("en-US", {
                                                                        month: "short",
                                                                        day: "numeric",
                                                                        year: "numeric"
                                                                    })
                                                                ]
                                                            }),
                                                            invite.is_expired && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: "body2",
                                                                sx: {
                                                                    color: theme.palette.error.main,
                                                                    fontStyle: "italic",
                                                                    mt: 0.5
                                                                },
                                                                children: "This invitation has expired. Please contact your FBO administrator for a new invitation."
                                                            })
                                                        ]
                                                    }),
                                                    getActionButton(invite)
                                                ]
                                            })
                                        })
                                    }, invite.id))
                            })
                        ]
                    }) : // No pending invites - different messages based on FBO context
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            width: "100%",
                            maxWidth: 500
                        },
                        children: [
                            getHeaderMessage(),
                            hasFBOs ? // User has FBOs but no pending invites
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                sx: {
                                    textAlign: "center",
                                    borderRadius: 3,
                                    boxShadow: 3
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                    sx: {
                                        p: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "body1",
                                            color: "text.secondary",
                                            sx: {
                                                mb: 3
                                            },
                                            children: [
                                                "You're currently a member of",
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: activeFBO?.name
                                                }),
                                                fbos && fbos.length > 1 && ` and ${fbos.length - 1} other FBO${fbos.length > 2 ? "s" : ""}`,
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                mb: 3
                                            },
                                            children: "Looking for access to another FBO? Contact their administrator for an invitation."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            direction: "row",
                                            spacing: 2,
                                            justifyContent: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    variant: "contained",
                                                    onClick: handleReturnToDashboard,
                                                    sx: {
                                                        fontWeight: "medium"
                                                    },
                                                    children: "Return to Dashboard"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                    variant: "outlined",
                                                    onClick: handleSwitchFBO,
                                                    children: "Manage FBOs"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : // User has no FBOs and no pending invites
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                sx: {
                                    textAlign: "center",
                                    borderRadius: 3,
                                    boxShadow: 3
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                    sx: {
                                        p: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "h5",
                                            fontWeight: "medium",
                                            sx: {
                                                mb: 2
                                            },
                                            children: "No FBO Access"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "body1",
                                            color: "text.secondary",
                                            sx: {
                                                mb: 3
                                            },
                                            children: [
                                                "You're logged in as ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: airplxIdentity?.email
                                                }),
                                                ", but don't have access to any FBOs yet."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                                            variant: "outlined",
                                            sx: {
                                                textAlign: "left",
                                                mb: 3
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                                sx: {
                                                    p: 3
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "subtitle1",
                                                        fontWeight: "medium",
                                                        sx: {
                                                            mb: 2
                                                        },
                                                        children: "What to do next:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                        spacing: 2,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                spacing: 2,
                                                                alignItems: "flex-start",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        color: "primary",
                                                                        sx: {
                                                                            mt: 0.5
                                                                        },
                                                                        children: "\uD83D\uDCEC"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        children: [
                                                                            "Check your email for an invitation with the subject",
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: '"Claim AirPlx Invite"'
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                spacing: 2,
                                                                alignItems: "flex-start",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        color: "primary",
                                                                        sx: {
                                                                            mt: 0.5
                                                                        },
                                                                        children: "\uD83D\uDC65"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        children: "Ask your FBO administrator to send you an invitation"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                                direction: "row",
                                                                spacing: 2,
                                                                alignItems: "flex-start",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                        color: "primary",
                                                                        sx: {
                                                                            mt: 0.5
                                                                        },
                                                                        children: "\uD83D\uDCAC"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                        variant: "body2",
                                                                        children: [
                                                                            "Contact ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "support@airplx.com"
                                                                            }),
                                                                            " if you believe this is an error"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            sx: {
                                                fontStyle: "italic"
                                            },
                                            children: "Invitations are sent to the email address you used to log in."
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                open: snackbar.open,
                autoHideDuration: 6000,
                onClose: ()=>setSnackbar((prev)=>({
                            ...prev,
                            open: false
                        })),
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                    onClose: ()=>setSnackbar((prev)=>({
                                ...prev,
                                open: false
                            })),
                    severity: snackbar.severity,
                    sx: {
                        width: "100%"
                    },
                    children: snackbar.message
                })
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");
parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $1KiAb = parcelRequire("1KiAb");

var $6AlVH = parcelRequire("6AlVH");

var $iEhC9 = parcelRequire("iEhC9");
const $1e9bcd04b71bedac$export$d5f885e7bd4f2167 = ({ rampId: rampId, isReference: isReference })=>{
    const { id: rampIdFromRoute } = (0, $aphAM.useParams)();
    return(// RampsStateContainer and HangarsStateContainer might seem weird. it's for the selection menus
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
        isReference: isReference ?? false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
            isReference: isReference ?? false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1KiAb.RampStateContainer), {
                initialState: {
                    ramp_id: rampId ?? rampIdFromRoute,
                    isReference: isReference ?? false
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6AlVH.TowingEquipmentContainer), {
                    children: [
                        isReference && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                            severity: "warning",
                            children: "This is your Tie Town Tenant Reference ramp. It only shows your tie down tenants and is distinct from your active Current Ramp."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEhC9.RampsPresenter), {})
                    ]
                })
            })
        })
    }));
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $1KiAb = parcelRequire("1KiAb");

var $6AlVH = parcelRequire("6AlVH");

var $ayMG0 = parcelRequire("ayMG0");

var $lLxKB = parcelRequire("lLxKB");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");

var $fC0pb = parcelRequire("fC0pb");

var $8GP8k = parcelRequire("8GP8k");

var $abvRu = parcelRequire("abvRu");

var $6TVXD = parcelRequire("6TVXD");

var $koS2J = parcelRequire("koS2J");


var $a7gZr = parcelRequire("a7gZr");

var $aWoxc = parcelRequire("aWoxc");

var $lNEp2 = parcelRequire("lNEp2");

var $3dLiv = parcelRequire("3dLiv");

var $jYWTx = parcelRequire("jYWTx");

var $55RUj = parcelRequire("55RUj");

var $3JLDK = parcelRequire("3JLDK");

var $6zwbt = parcelRequire("6zwbt");

var $ayMG0 = parcelRequire("ayMG0");

var $9uy2D = parcelRequire("9uy2D");

var $6lMlz = parcelRequire("6lMlz");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $1lfQl = parcelRequire("1lfQl");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");

var $fBVnr = parcelRequire("fBVnr");

var $gGfi1 = parcelRequire("gGfi1");


var $ZD2ym = parcelRequire("ZD2ym");

var $kgjm7 = parcelRequire("kgjm7");
/**
 * ScheduleGanttDialog Component
 *
 * Dialog for viewing and editing existing placements in Gantt format.
 * Shows all trips in the selected time range with drag-and-drop editing.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $dqlTG = parcelRequire("dqlTG");

var $utPXC = parcelRequire("utPXC");

var $9wvX1 = parcelRequire("9wvX1");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $7Frhn = parcelRequire("7Frhn");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
/**
 * TimeRangePicker Component
 *
 * Allows users to select a time range with start/end times and quick duration buttons.
 * Used in ScheduleGanttDialog for adjusting the visible time range.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $ltk0t = parcelRequire("ltk0t");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2p5OG = parcelRequire("2p5OG");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $78ow6 = parcelRequire("78ow6");

var $7S0ew = parcelRequire("7S0ew");
var $4HKwc = parcelRequire("4HKwc");
var $lGkA3 = parcelRequire("lGkA3");
var $3WoNO = parcelRequire("3WoNO");

var $acw62 = parcelRequire("acw62");

var $e6g4k = parcelRequire("e6g4k");
/**
 * Format duration in human-readable format
 */ function $8d0380fc533e4496$var$formatDuration(start, end) {
    const days = (0, $4HKwc.differenceInDays)(end, start);
    const hours = (0, $lGkA3.differenceInHours)(end, start) % 24;
    const minutes = (0, $3WoNO.differenceInMinutes)(end, start) % 60;
    if (days > 0) return `${days}d ${hours}h ${minutes}m`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
}
const $8d0380fc533e4496$export$1cb5f10c96d32256 = ({ startTime: startTime, endTime: endTime, onChange: onChange })=>{
    // Calculate duration
    const duration = (0, $acw62.useMemo)(()=>$8d0380fc533e4496$var$formatDuration(startTime, endTime), [
        startTime,
        endTime
    ]);
    // Handle start time change
    const handleStartChange = (newValue)=>{
        if (newValue) onChange(newValue, endTime);
    };
    // Handle end time change
    const handleEndChange = (newValue)=>{
        if (newValue) onChange(startTime, newValue);
    };
    // Quick duration buttons
    const handleQuickDuration = (days)=>{
        const newEnd = (0, $7S0ew.addDays)(startTime, days);
        onChange(startTime, newEnd);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
        dateAdapter: (0, $78ow6.AdapterDateFns),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "row",
            spacing: 2,
            alignItems: "center",
            flexWrap: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                    label: "Start Time",
                    value: startTime,
                    onChange: handleStartChange,
                    minDate: (0, $e6g4k.SCHEDULE_MIN_DATE),
                    maxDate: endTime || (0, $e6g4k.SCHEDULE_MAX_DATE),
                    ampm: false,
                    minutesStep: 15,
                    slotProps: {
                        textField: {
                            size: "small",
                            sx: {
                                width: 220
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                    label: "End Time",
                    value: endTime,
                    onChange: handleEndChange,
                    minDate: startTime || (0, $e6g4k.SCHEDULE_MIN_DATE),
                    maxDate: (0, $e6g4k.SCHEDULE_MAX_DATE),
                    ampm: false,
                    minutesStep: 15,
                    slotProps: {
                        textField: {
                            size: "small",
                            sx: {
                                width: 220
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ltk0t))), {
                            sx: {
                                fontSize: 18,
                                color: "text.secondary"
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "body2",
                            sx: {
                                fontWeight: 600,
                                minWidth: 80
                            },
                            children: duration
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2p5OG.default), {
                    size: "small",
                    variant: "outlined",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>handleQuickDuration(1),
                            children: "1 Day"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>handleQuickDuration(3),
                            children: "3 Days"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>handleQuickDuration(7),
                            children: "7 Days"
                        })
                    ]
                })
            ]
        })
    });
};



var $4H2Jj = parcelRequire("4H2Jj");
/**
 * Hook for managing Schedule Gantt View editing
 *
 * Handles:
 * - Loading trip data for time range
 * - Converting to temporal format
 * - Tracking schedule changes
 * - Applying changes to database
 * - Error handling and user feedback
 */ 
var $acw62 = parcelRequire("acw62");

var $6fDLr = parcelRequire("6fDLr");
/**
 * Data Conversion Utilities for Schedule Gantt View
 *
 * Converts between database trip/coverage format and temporal algorithm format.
 * Enables viewing and editing existing placements in the Gantt chart.
 */ 
var $77E3s = parcelRequire("77E3s");

var $8a5rg = parcelRequire("8a5rg");
/**
 * Check if a point is inside a polygon using ray casting algorithm
 */ function $d68d6e62f0606117$var$isPointInPolygon(point, polygon) {
    if (!polygon || polygon.length < 3) return false;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > point.y !== yj > point.y && point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
/**
 * Calculate distance between two points
 */ function $d68d6e62f0606117$var$distance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
/**
 * Calculate centroid of a polygon
 */ function $d68d6e62f0606117$var$calculateCentroid(points) {
    if (points.length === 0) return {
        x: 0,
        y: 0
    };
    const sum = points.reduce((acc, p)=>({
            x: acc.x + p.x,
            y: acc.y + p.y
        }), {
        x: 0,
        y: 0
    });
    return {
        x: sum.x / points.length,
        y: sum.y / points.length
    };
}
function $d68d6e62f0606117$export$d146a30c7f5a340(position, shapes, rampDepth, options = {}) {
    const spotShapes = shapes.filter((s)=>s.type === "Spot");
    // First, try exact point-in-polygon test
    for (const shape of spotShapes){
        if (!shape.points || shape.points.length === 0) continue;
        // Y-flip shape points to match database coordinate system (bottom-left origin)
        const flippedPoints = shape.points.map((p)=>({
                x: p.x,
                y: rampDepth - p.y
            }));
        if ($d68d6e62f0606117$var$isPointInPolygon(position, flippedPoints)) return shape.id;
    }
    // If no exact match and fallback is enabled, find nearest spot
    if (options.fallbackNearest) {
        let nearestSpotId = null;
        let nearestDistance = Infinity;
        for (const shape of spotShapes){
            if (!shape.points || shape.points.length === 0) continue;
            // Calculate centroid in database coordinates
            const flippedPoints = shape.points.map((p)=>({
                    x: p.x,
                    y: rampDepth - p.y
                }));
            const centroid = $d68d6e62f0606117$var$calculateCentroid(flippedPoints);
            const dist = $d68d6e62f0606117$var$distance(position, centroid);
            if (dist < nearestDistance) {
                nearestDistance = dist;
                nearestSpotId = shape.id;
            }
        }
        if (nearestSpotId) {
            console.warn(`[findSpotForPosition] Position (${position.x}, ${position.y}) outside all spots, using nearest: ${nearestSpotId} (distance: ${nearestDistance.toFixed(1)})`);
            return nearestSpotId;
        }
    }
    return null;
}
function $d68d6e62f0606117$export$acb114a8701c4956(trips, shapes, rampDepth, startTime, rampId) {
    const aircraft = [];
    const placement = {};
    const tripMap = new Map();
    for (const trip of trips){
        // Use tenant_id as unique request identifier (aircraft identity)
        // This allows placement map to use aircraft_id as key for tracking where each aircraft is
        const requestId = trip.tenant_id;
        // Calculate arrival/departure buckets from trip times
        const arrivalBucket = (0, $8a5rg.dateToTimeBucket)(trip.arrival_date, startTime);
        const departureBucket = (0, $8a5rg.dateToTimeBucket)(trip.departure_date, startTime);
        // Build ParkingRequest
        const parkingRequest = {
            id: requestId,
            tail_number: trip.tail_number || "Unknown",
            arrivalBucket: arrivalBucket,
            departureBucket: departureBucket,
            sizeCategory: (0, $8a5rg.aircraftToSizeCategory)({
                wingspan: trip.wingspan || 0,
                length: trip.aircraft_length || 0
            }),
            trip_id: trip.trip_id,
            aircraft: trip.aircraft_type ? {
                id: trip.tenant_id,
                // Aircraft identity uses tenant_id
                make: trip.aircraft_manufacturer || "",
                model: trip.aircraft_model || "",
                wingspan: trip.wingspan || 0,
                length: trip.aircraft_length || 0
            } : undefined
        };
        aircraft.push(parkingRequest);
        tripMap.set(requestId, trip.trip_id);
        // Process coverage segments
        if (!trip.coverage || trip.coverage.length === 0) continue;
        // Filter coverage to only include segments on this ramp
        const rampCoverage = trip.coverage.filter((seg)=>seg.ramp_id === rampId);
        if (rampCoverage.length === 0) continue;
        // Convert coverage segments to placement format
        const segments = rampCoverage.map((seg)=>{
            // Skip segments without position data
            if (seg.x === null || seg.x === undefined || seg.y === null || seg.y === undefined) return null;
            // Find spot ID for this position
            const spotId = $d68d6e62f0606117$export$d146a30c7f5a340({
                x: seg.x,
                y: seg.y
            }, shapes, rampDepth, {
                fallbackNearest: true
            });
            if (!spotId) {
                console.warn(`[convertTripsToTemporalFormat] Could not find spot for position (${seg.x}, ${seg.y}) for aircraft ${trip.tail_number}`);
                return null;
            }
            // Convert timestamps to buckets
            const startBucket = (0, $8a5rg.dateToTimeBucket)(seg.start_time, startTime);
            const endBucket = (0, $8a5rg.dateToTimeBucket)(seg.end_time, startTime);
            return {
                spotId: spotId,
                startBucket: startBucket,
                endBucket: endBucket
            };
        }).filter((seg)=>seg !== null);
        if (segments.length === 0) continue;
        // Build placement entry
        if (segments.length === 1) // Single placement
        placement[requestId] = {
            spotId: segments[0].spotId,
            orientationId: "center" // Default orientation
        };
        else // Segmented placement (aircraft moved between spots)
        placement[requestId] = {
            segments: segments.map((seg)=>({
                    ...seg,
                    orientationId: "center" // Default orientation
                })),
            moveCount: segments.length - 1
        };
    }
    return {
        aircraft: aircraft,
        placement: placement,
        tripMap: tripMap
    };
}
function $d68d6e62f0606117$export$dffce92ad2a91bf1(changes, shapes, rampDepth, rampId, startTime) {
    const result = new Map();
    // Group changes by trip ID
    const changesByTrip = new Map();
    for (const change of changes){
        if (!change.tripId) {
            console.warn(`[convertScheduleChangesToDB] Change for ${change.tailNumber} missing trip_id, skipping`);
            continue;
        }
        const existing = changesByTrip.get(change.tripId) || [];
        existing.push(change);
        changesByTrip.set(change.tripId, existing);
    }
    // Convert each trip's changes to coverage segments
    for (const tripEntry of Array.from(changesByTrip.entries())){
        const [tripId, tripChanges] = tripEntry;
        const segments = [];
        for (const change of tripChanges){
            // Get new spot ID
            const newSpotId = change.newSpotId;
            if (!newSpotId) {
                console.warn(`[convertScheduleChangesToDB] Change for ${change.tailNumber} missing new spot ID, skipping`);
                continue;
            }
            // Find spot shape
            const spotShape = shapes.find((s)=>s.id === newSpotId && s.type === "Spot");
            if (!spotShape || !spotShape.reference_points || spotShape.reference_points.length === 0) {
                console.error(`[convertScheduleChangesToDB] Spot ${newSpotId} not found or has no reference points`);
                continue;
            }
            // Calculate spot center position from shape geometry
            const centroid = (0, $77E3s.getCentroid)(spotShape.points);
            // Y-flip coordinates to database system (bottom-left origin)
            const dbY = rampDepth - centroid.y;
            // Use center orientation (0 degrees) since we don't have placement-specific angle
            const angle = 0;
            // Convert buckets to timestamps
            const start_time = (0, $8a5rg.timeBucketToDate)(change.newArrivalBucket || 0, startTime).toISOString();
            const end_time = (0, $8a5rg.timeBucketToDate)(change.newDepartureBucket || 0, startTime).toISOString();
            segments.push({
                start_time: start_time,
                end_time: end_time,
                x: centroid.x,
                y: dbY,
                angle: angle,
                ramp_id: rampId
            });
        }
        if (segments.length > 0) result.set(tripId, segments);
    }
    return result;
}


function $e6496e58e6727f0e$export$1b8a47272cacfa75(options) {
    const { rampId: rampId, rampShapes: rampShapes, rampDepth: rampDepth, zones: zones, placementService: placementService, onApplied: onApplied } = options;
    const snackbar = (0, $6fDLr.useSnackbar)();
    // State
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [isApplying, setIsApplying] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)(null);
    const [pendingChanges, setPendingChanges] = (0, $acw62.useState)([]);
    const [error, setError] = (0, $acw62.useState)(null);
    /**
   * Load trip data for the given time range
   */ const loadData = (0, $acw62.useCallback)(async (startTime, endTime)=>{
        setIsLoading(true);
        setError(null);
        try {
            // Fetch placements for time range (filtered by ramp)
            const placements = await placementService.getPlacementsInTimeRange(startTime, endTime, rampId, "ramp");
            // Build TripWithCoverage data from placements
            // Group placements by trip_id to build coverage arrays
            const tripMap = new Map();
            for (const placement of placements){
                // Placements are already filtered by rampId in the query
                const tripId = placement.trip_id;
                // Get or create trip entry
                let trip = tripMap.get(tripId);
                if (!trip) {
                    trip = {
                        trip_id: tripId,
                        tenant_id: placement.tenant_id || tripId,
                        tail_number: placement.tail_number || "Unknown",
                        aircraft_manufacturer: placement.aircraft_make,
                        aircraft_model: placement.aircraft_model,
                        wingspan: placement.wingspan,
                        aircraft_length: placement.length,
                        arrival_date: placement.start_time,
                        departure_date: placement.end_time,
                        fbo_id: "",
                        status: "active",
                        created_at: placement.created_at || new Date().toISOString(),
                        updated_at: placement.updated_at || new Date().toISOString(),
                        version: 1,
                        coverage: []
                    };
                    tripMap.set(tripId, trip);
                }
                // Add coverage segment
                trip.coverage.push({
                    start_time: placement.start_time,
                    end_time: placement.end_time,
                    x: placement.x || null,
                    y: placement.y || null,
                    angle: placement.angle || null,
                    ramp_id: placement.ramp_id,
                    hangar_id: placement.hangar_id
                });
            }
            // Convert to temporal format
            const trips = Array.from(tripMap.values());
            const temporal = (0, $d68d6e62f0606117$export$acb114a8701c4956)(trips, rampShapes, rampDepth, startTime, rampId);
            // Calculate horizon hours
            const horizonMs = endTime.getTime() - startTime.getTime();
            const horizonHours = Math.ceil(horizonMs / 3600000);
            // Build result
            setData({
                aircraft: temporal.aircraft,
                placement: temporal.placement,
                zones: zones || [],
                startTime: startTime,
                horizonHours: horizonHours,
                tripMap: temporal.tripMap
            });
            setIsLoading(false);
        } catch (err) {
            console.error("[useScheduleGanttEdit] Failed to load data:", err);
            setError(err instanceof Error ? err.message : "Failed to load data");
            setIsLoading(false);
        }
    }, [
        rampId,
        rampShapes,
        rampDepth,
        zones,
        placementService
    ]);
    /**
   * Track schedule changes from Gantt
   */ const handleScheduleChanged = (0, $acw62.useCallback)((changes)=>{
        setPendingChanges(changes);
    }, []);
    /**
   * Apply pending changes to database
   */ const applyChanges = (0, $acw62.useCallback)(async ()=>{
        if (!data || pendingChanges.length === 0) {
            snackbar.notify({
                text: "No changes to apply",
                severity: "info"
            });
            return;
        }
        setIsApplying(true);
        try {
            // Enhance changes with trip IDs
            const changesWithTrips = pendingChanges.map((change)=>({
                    ...change,
                    tripId: data.tripMap.get(change.aircraftId)
                }));
            // Convert changes to database format
            const segmentsByTrip = (0, $d68d6e62f0606117$export$dffce92ad2a91bf1)(changesWithTrips, rampShapes, rampDepth, rampId, data.startTime);
            // Apply each trip's changes
            let successCount = 0;
            let errorCount = 0;
            const errors = [];
            for (const tripEntry of Array.from(segmentsByTrip.entries())){
                const [tripId, segments] = tripEntry;
                try {
                    await placementService.rebuildTripCoverage(tripId, segments);
                    successCount++;
                } catch (err) {
                    console.error(`[useScheduleGanttEdit] Failed to apply changes for trip ${tripId}:`, err);
                    errorCount++;
                    errors.push(tripId);
                }
            }
            // Show results
            if (errorCount === 0) snackbar.notify({
                text: `Successfully applied changes for ${successCount} trip${successCount !== 1 ? "s" : ""}`,
                severity: "success"
            });
            else if (successCount > 0) snackbar.notify({
                text: `Applied ${successCount}/${successCount + errorCount} changes (${errorCount} errors)`,
                severity: "warning"
            });
            else snackbar.notify({
                text: "Failed to apply changes",
                severity: "error"
            });
            // Clear pending changes
            setPendingChanges([]);
            setIsApplying(false);
            // Callback to refresh parent view
            if (onApplied) onApplied();
        } catch (err) {
            console.error("[useScheduleGanttEdit] Failed to apply changes:", err);
            snackbar.notify({
                text: `Failed to apply changes: ${err instanceof Error ? err.message : "Unknown error"}`,
                severity: "error"
            });
            setIsApplying(false);
        }
    }, [
        data,
        pendingChanges,
        rampShapes,
        rampDepth,
        rampId,
        placementService,
        snackbar,
        onApplied
    ]);
    /**
   * Reset pending changes
   */ const resetChanges = (0, $acw62.useCallback)(()=>{
        setPendingChanges([]);
    }, []);
    return {
        isLoading: // State
        isLoading,
        isApplying: isApplying,
        data: data,
        pendingChanges: pendingChanges,
        error: error,
        loadData: // Actions
        loadData,
        handleScheduleChanged: handleScheduleChanged,
        applyChanges: applyChanges,
        resetChanges: resetChanges
    };
}


/**
 * Round a date to the nearest 15-minute increment
 */ function $5f72dba5709d1e5d$var$roundToQuarterHour(date) {
    const rounded = new Date(date);
    const minutes = rounded.getMinutes();
    const remainder = minutes % 15;
    if (remainder === 0) return rounded; // Already aligned
    // Round to nearest 15-minute mark
    const roundedMinutes = remainder < 7.5 ? minutes - remainder : minutes + (15 - remainder);
    rounded.setMinutes(roundedMinutes, 0, 0); // Also clear seconds and milliseconds
    return rounded;
}
const $5f72dba5709d1e5d$export$22c4a271103992a1 = ({ open: open, onClose: onClose, initialStartTime: initialStartTime, initialEndTime: initialEndTime, currentTimestamp: currentTimestamp, rampId: rampId, rampName: rampName, rampShapes: rampShapes, rampDepth: rampDepth, zones: zones, placementService: placementService, onApplied: onApplied, onTimeRangeChange: onTimeRangeChange })=>{
    // Time range state - round to 15-minute increments
    const [startTime, setStartTime] = (0, $acw62.useState)(()=>$5f72dba5709d1e5d$var$roundToQuarterHour(initialStartTime));
    const [endTime, setEndTime] = (0, $acw62.useState)(()=>$5f72dba5709d1e5d$var$roundToQuarterHour(initialEndTime));
    // Use schedule gantt edit hook
    const { isLoading: isLoading, isApplying: isApplying, data: data, pendingChanges: pendingChanges, error: error, loadData: loadData, handleScheduleChanged: handleScheduleChanged, applyChanges: applyChanges, resetChanges: resetChanges } = (0, $e6496e58e6727f0e$export$1b8a47272cacfa75)({
        rampId: rampId,
        rampShapes: rampShapes,
        rampDepth: rampDepth,
        zones: zones,
        placementService: placementService,
        onApplied: ()=>{
            if (onApplied) onApplied();
            onClose();
        }
    });
    // Load data only when dialog first opens (not on time range changes from drag/zoom)
    (0, $acw62.useEffect)(()=>{
        if (open) loadData(initialStartTime, initialEndTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]); // Only depend on 'open', not on startTime/endTime
    // Reset pending changes when dialog closes
    (0, $acw62.useEffect)(()=>{
        if (!open) resetChanges();
    }, [
        open,
        resetChanges
    ]);
    // Handle time range change
    const handleTimeRangeChange = (newStart, newEnd)=>{
        setStartTime(newStart);
        setEndTime(newEnd);
        // Notify parent component of time range change
        if (onTimeRangeChange) onTimeRangeChange(newStart, newEnd);
    };
    // Handle close
    const handleClose = ()=>{
        if (pendingChanges.length > 0) {
            const confirmed = window.confirm("You have unsaved changes. Are you sure you want to close?");
            if (!confirmed) return;
        }
        onClose();
    };
    // Handle viewport changes from timeline (drag/zoom)
    const handleViewportChange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((viewportStart, viewportEnd)=>{
        // Just update the input fields, don't reload data
        setStartTime($5f72dba5709d1e5d$var$roundToQuarterHour(viewportStart));
        setEndTime($5f72dba5709d1e5d$var$roundToQuarterHour(viewportEnd));
    }, []);
    // Calculate statistics
    const statistics = data ? {
        totalAircraft: data.aircraft.length,
        placedAircraft: Object.keys(data.placement).length,
        unplacedAircraft: data.aircraft.length - Object.keys(data.placement).length
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: handleClose,
        fullScreen: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ejcfT.default), {
                sx: {
                    pb: 1.5,
                    position: "relative",
                    pr: 7
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        onClick: handleClose,
                        "aria-label": "close",
                        sx: {
                            position: "absolute",
                            right: 8,
                            top: 8
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 1.5,
                        children: [
                            rampName && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "h6",
                                fontWeight: 600,
                                children: [
                                    rampName,
                                    " Schedule"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 2,
                                alignItems: "center",
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d0380fc533e4496$export$1cb5f10c96d32256), {
                                        startTime: startTime,
                                        endTime: endTime,
                                        onChange: handleTimeRangeChange
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                        orientation: "vertical",
                                        flexItem: true,
                                        sx: {
                                            mx: 1
                                        }
                                    }),
                                    statistics && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    minWidth: 120
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        display: "block",
                                                        children: "Aircraft Placed"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "body1",
                                                        fontWeight: 600,
                                                        children: [
                                                            statistics.placedAircraft,
                                                            " / ",
                                                            statistics.totalAircraft
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    minWidth: 100
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        display: "block",
                                                        children: "Avg Utilization"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "body1",
                                                        fontWeight: 600,
                                                        children: [
                                                            Math.round(statistics.placedAircraft / (statistics.totalAircraft || 1) * 100),
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            ml: "auto"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "outlined",
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($utPXC))), {}),
                                            onClick: ()=>window.print(),
                                            size: "small",
                                            children: "Print"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                dividers: true,
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 2,
                    height: "100%",
                    children: [
                        isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {})
                        }),
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                            elevation: 0,
                            sx: {
                                p: 2,
                                backgroundColor: "#ffebee",
                                border: "1px solid #ef5350",
                                borderRadius: 2
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                color: "error",
                                children: error
                            })
                        }),
                        !isLoading && !error && data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            flex: 1,
                            minHeight: 0,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4H2Jj.SpotOccupancyGantt), {
                                spots: rampShapes.filter((s)=>s.type === "Spot").map((s)=>{
                                    const spotMetadata = s.metadata;
                                    return {
                                        id: s.id,
                                        zoneId: spotMetadata?.zoneId || "default",
                                        allowedSizes: spotMetadata?.allowedSizes || [],
                                        occupancy: new BigUint64Array(),
                                        // Empty occupancy (will be calculated from placements)
                                        orientations: [
                                            {
                                                id: "center"
                                            }
                                        ],
                                        shape: s
                                    };
                                }),
                                aircraft: data.aircraft,
                                placement: data.placement,
                                horizonHours: data.horizonHours,
                                startTime: data.startTime,
                                currentTimestamp: currentTimestamp,
                                rampShapes: rampShapes,
                                zones: data.zones,
                                statistics: statistics,
                                hideStatistics: true,
                                onScheduleChanged: handleScheduleChanged,
                                onViewportChange: handleViewportChange,
                                enableEditing: true
                            })
                        }),
                        pendingChanges.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                            elevation: 0,
                            sx: {
                                p: 1.5,
                                backgroundColor: "#fff3e0",
                                border: "1px solid #ffb74d",
                                borderRadius: 2
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "warning.dark",
                                children: [
                                    pendingChanges.length,
                                    " unsaved change",
                                    pendingChanges.length !== 1 ? "s" : ""
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                sx: {
                    px: 3,
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleClose,
                        disabled: isApplying,
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        startIcon: isApplying ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                            size: 20
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9wvX1))), {}),
                        onClick: applyChanges,
                        disabled: isApplying || pendingChanges.length === 0,
                        children: isApplying ? "Applying..." : "Apply to Database"
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $fifzc = parcelRequire("fifzc");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $ciKN1 = parcelRequire("ciKN1");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");

var $eXGdF = parcelRequire("eXGdF");
parcelRequire("lFMxC");
var $bXDUV = parcelRequire("bXDUV");

var $d1mLJ = parcelRequire("d1mLJ");
parcelRequire("6qWGE");
var $c0zpU = parcelRequire("c0zpU");

var $6wfYj = parcelRequire("6wfYj");
parcelRequire("baghD");
var $drjQE = parcelRequire("drjQE");

var $jbTvW = parcelRequire("jbTvW");

var $14j5W = parcelRequire("14j5W");

var $3JLDK = parcelRequire("3JLDK");

var $8vHzJ = parcelRequire("8vHzJ");

var $lFx3G = parcelRequire("lFx3G");
const $1774625a478f9093$export$e1f99d255e2289f = {
    reference: "#F4D2CD",
    testing: "#23967F"
};
const $1774625a478f9093$export$7b435ba7a1f9f7f1 = ({ ramp: ramp, setRamp: setRamp, history: history, onScheduledUpdate: onScheduledUpdate, isScheduledView: isScheduledView = false, onUndo: onUndo, scheduledViewProps: scheduledViewProps })=>{
    const navigate = (0, $aphAM.useNavigate)();
    const { isDrawerOpen: isDrawerOpen } = (0, $3JLDK.useLayout)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    // Ramp data now comes from props instead of useRampState hook
    const [width, setWidth] = $acw62.useState(700);
    const [zoomLevel, setZoomLevel] = $acw62.useState(1);
    const div = $acw62.useCallback((node)=>{
        const heightOffsetForRamp = 150;
        if (node?.offsetWidth && node?.offsetHeight) {
            const widthBasedOnAvaiableWidth = node.offsetWidth;
            const widthBasedOnAvailableHeight = node.offsetHeight * ramp.width / ramp.depth - heightOffsetForRamp;
            setWidth(Math.min(widthBasedOnAvaiableWidth, widthBasedOnAvailableHeight));
        }
    }, [
        isDrawerOpen,
        ramp.width,
        ramp.depth
    ]);
    const zoomedWith = width * zoomLevel;
    const { feetToPixels: feetToPixels } = (0, $d1mLJ.useDimensions)({
        location: {
            type: "ramp",
            ...ramp
        },
        width: zoomedWith,
        height: zoomedWith * ramp.depth / ramp.width
    });
    const setStack = $acw62.useCallback((stack)=>{
        setRamp({
            ...ramp,
            stack: {
                ...ramp.stack,
                ...stack
            }
        });
    }, [
        ramp,
        setRamp
    ]);
    const positions = ramp?.stack?.tenants.map((t)=>`${t.position.x},${t.position.y},${t.position.angle}`).join("");
    (0, $fifzc.default)(()=>{
        setRamp({
            ...ramp,
            last_stacked: new Date().toISOString()
        });
    }, [
        positions
    ]);
    // Memoize placementsInRange to prevent creating new arrays on every render
    const placementsInRange = $acw62.useMemo(()=>{
        if (!scheduledViewProps?.allPlacements) return [];
        return scheduledViewProps.allPlacements.filter((p)=>{
            const start = new Date(p.start_time).getTime();
            const end = new Date(p.end_time).getTime();
            const rangeStartTime = (scheduledViewProps?.timeRange?.start || new Date()).getTime();
            const rangeEndTime = (scheduledViewProps?.timeRange?.end || new Date()).getTime();
            return start >= rangeStartTime && start <= rangeEndTime || end >= rangeStartTime && end <= rangeEndTime || start <= rangeStartTime && end >= rangeEndTime;
        });
    }, [
        scheduledViewProps?.allPlacements,
        scheduledViewProps?.timeRange?.start,
        scheduledViewProps?.timeRange?.end
    ]);
    if (!ramp) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciKN1.AutocompleteResultsContainer), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "row",
            sx: {
                width: "100%",
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3JLDK.CollapsibleRampActionCard), {
                    location: {
                        type: "ramp",
                        ...ramp
                    },
                    onClickBack: ()=>navigate("/ramps"),
                    hideNavigation: isScheduledView,
                    extendBorderUp: false,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        sx: {
                            maxHeight: "100%",
                            width: isDrawerOpen ? 400 : 125
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8vHzJ.RampInfoCard), {
                                isDrawerOpen: isDrawerOpen,
                                ramp: ramp,
                                isScheduledView: isScheduledView,
                                timeRange: scheduledViewProps?.timeRange,
                                allPlacements: scheduledViewProps?.allPlacements
                            }),
                            ramp.autoparking_enabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $14j5W.AutoPark), {
                                ramp: ramp,
                                stack: ramp.stack,
                                setStack: setStack,
                                isScheduledView: isScheduledView,
                                placementService: scheduledViewProps?.placementService,
                                currentTime: scheduledViewProps?.currentTime,
                                postgrest: postgrest,
                                fbo: activeFBO,
                                onScheduledUpdate: scheduledViewProps?.onScheduledUpdate,
                                isDrawerOpen: isDrawerOpen
                            }),
                            !isScheduledView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jbTvW.AircraftFinder), {
                                mini: !isDrawerOpen,
                                tenants: ramp.stack.tenants ?? [],
                                onSelect: (tenant)=>{
                                    setStack({
                                        ...ramp.stack,
                                        tenants: ramp.stack.tenants.map((t)=>({
                                                ...t,
                                                selected: t.id === tenant.id
                                            }))
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                            isScheduledView && scheduledViewProps?.allPlacements ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6wfYj.TimelineAircraftList), {
                                feetToPixels: feetToPixels,
                                readOnly: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                                location: {
                                    type: "ramp",
                                    ...ramp
                                },
                                stack: ramp.stack,
                                setStack: (stack)=>{
                                    setRamp({
                                        ...ramp,
                                        stack: {
                                            ...ramp.stack,
                                            ...stack
                                        }
                                    });
                                },
                                disableAutoOpen: !!onScheduledUpdate,
                                isScheduledView: isScheduledView,
                                onAddTrip: scheduledViewProps?.onScheduledUpdate ? ()=>{
                                    // For scheduled views, trigger refresh after trip creation
                                    scheduledViewProps.onScheduledUpdate();
                                } : undefined,
                                currentTime: scheduledViewProps?.currentTime,
                                onRemoveAircraft: scheduledViewProps?.onRemoveAircraft,
                                rangeStart: scheduledViewProps?.timeRange?.start || new Date(),
                                rangeEnd: scheduledViewProps?.timeRange?.end || new Date(),
                                placementsInRange: placementsInRange,
                                allPlacementsFromNow: scheduledViewProps.allPlacementsForSearch || scheduledViewProps.allPlacements,
                                onRefresh: scheduledViewProps?.onScheduledUpdate,
                                onTimeChange: scheduledViewProps?.onTimeChange,
                                onNavigateToLocation: scheduledViewProps?.onNavigateToLocation,
                                rampShapes: ramp.shapes,
                                rampDepth: ramp.depth
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eXGdF.CurrentAircraft), {
                                feetToPixels: feetToPixels,
                                readOnly: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                                location: {
                                    type: "ramp",
                                    ...ramp
                                },
                                stack: ramp.stack,
                                setStack: (stack)=>{
                                    setRamp({
                                        ...ramp,
                                        stack: {
                                            ...ramp.stack,
                                            ...stack
                                        }
                                    });
                                },
                                disableAutoOpen: !!onScheduledUpdate,
                                isScheduledView: isScheduledView,
                                onAddTrip: scheduledViewProps?.onScheduledUpdate ? ()=>{
                                    // For scheduled views, trigger refresh after trip creation
                                    scheduledViewProps.onScheduledUpdate();
                                } : undefined,
                                currentTime: scheduledViewProps?.currentTime,
                                onRemoveAircraft: scheduledViewProps?.onRemoveAircraft
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    sx: {
                        flex: 1,
                        height: "100%",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0zpU.LayoutToolbar), {
                            location: {
                                type: "ramp",
                                ...ramp
                            },
                            setLocation: ({ type: _type, ...location })=>{
                                setRamp({
                                    ...ramp,
                                    ...location
                                });
                            },
                            stack: ramp.stack,
                            setStack: setStack,
                            setStacks: ()=>{
                            // Ramps don't have multiple stacks like hangars
                            },
                            isScheduledView: isScheduledView,
                            scheduledViewProps: scheduledViewProps,
                            onClickUndo: ()=>{
                                if (isScheduledView && onUndo) onUndo();
                                else history && history.undo();
                            },
                            renderOnPrint: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lFx3G.RampPrintLayout), {
                                    ramp: ramp,
                                    stack: ramp.stack
                                })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: div,
                            style: {
                                flex: 1,
                                position: "relative",
                                height: "100%",
                                margin: "20px"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXDUV.Layout), {
                                width: zoomedWith,
                                location: {
                                    type: "ramp",
                                    ...ramp
                                },
                                stack: ramp?.stack,
                                setStack: setStack,
                                onScheduledUpdate: onScheduledUpdate,
                                scheduledViewProps: scheduledViewProps,
                                options: {
                                    hideUnplaced: false,
                                    readOnly: false,
                                    frozen: !hasPermission((0, $aHqXU.Permission).MODIFY_LAYOUT),
                                    printable: false,
                                    selectable: false
                                },
                                zoomLevel: zoomLevel
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drjQE.ZoomControl), {
                    currentZoom: zoomedWith,
                    increment: 0.1,
                    onClickPlus: (newZoomLevel)=>setZoomLevel(newZoomLevel),
                    onClickMinus: (newZoomLevel)=>setZoomLevel(newZoomLevel)
                })
            ]
        })
    });
};


const $d3657bc75c8922c6$export$1b7a3aa9749b1d74 = ({ id: id, isReference: isReference, isAlgorithmTesting: isAlgorithmTesting, baseRamp: baseRamp, scheduledRamp: scheduledRamp, currentTimestamp: currentTimestamp, rangeStart: rangeStart, rangeEnd: rangeEnd, setTimeRange: setTimeRange, initialLoading: initialLoading, isUpdating: isUpdating, isPending: isPending, hasLoadedOnce: hasLoadedOnce, isDrawerOpen: isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen, isSchedulingEnabled: isSchedulingEnabled, hasNextTrip: hasNextTrip, hasPreviousTrip: hasPreviousTrip, selectedTripInfo: selectedTripInfo, tenantTripMap: tenantTripMap, placementsInRange: placementsInRange, tripCountsByDate: tripCountsByDate, allPlacementsForSearch: allPlacementsForSearch, heatmapPlacements: heatmapPlacements, showAddObstacleDialog: showAddObstacleDialog, setShowAddObstacleDialog: setShowAddObstacleDialog, addedObstacles: addedObstacles, predefinedObstacles: predefinedObstacles, handleTimeChange: handleTimeChange, handleJumpToNextTrip: handleJumpToNextTrip, handleJumpToPreviousTrip: handleJumpToPreviousTrip, handleUndo: handleUndo, handleRampChange: handleRampChange, handleAircraftRemoval: handleAircraftRemoval, handleNavigateToLocation: handleNavigateToLocation, setAddedObstaclesWithLogging: setAddedObstaclesWithLogging, placementService: placementService, setRefreshKey: setRefreshKey })=>{
    // Check if auto parking is enabled (required for View Schedule button)
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const isAutoParkEnabled = activeFBO?.settings?.enableAutoParking ?? false;
    // Schedule Gantt dialog state
    const [scheduleGanttOpen, setScheduleGanttOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Handle time range change from Gantt view
    const handleTimeRangeChange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((newStart, newEnd)=>{
        setTimeRange(newStart, newEnd);
    }, [
        setTimeRange
    ]);
    // Use the actual time range from props for metrics
    const timeRange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            start: rangeStart || new Date(),
            end: rangeEnd || new Date()
        }), [
        rangeStart,
        rangeEnd
    ]);
    // Handle schedule gantt dialog applied changes
    const handleScheduleGanttApplied = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        // Trigger refresh by incrementing refreshKey
        setRefreshKey((prev)=>prev + 1);
    }, [
        setRefreshKey
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        sx: {
            height: "100vh"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            width: isDrawerOpen ? "400px" : "125px",
                            // Match sidebar width
                            minWidth: isDrawerOpen ? "400px" : "125px",
                            // Prevent flex shrinking
                            flexShrink: 0,
                            // Disable flexbox shrinking
                            p: isDrawerOpen ? 2 : 1,
                            // Less padding when collapsed
                            borderRight: 1,
                            borderColor: "divider"
                        },
                        children: [
                            isDrawerOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gGfi1.LocationNavigationHeader), {
                                locationName: baseRamp?.name || "",
                                locationId: id,
                                locationType: "ramp",
                                isSchedulingEnabled: isSchedulingEnabled,
                                rightActions: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>setIsDrawerOpen(false),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9uy2D))), {})
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>setIsDrawerOpen(true),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6lMlz))), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    height: 8
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            flexGrow: 1,
                            pt: 2,
                            pb: 3
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ca7bd34565630016$export$af6201c40255f12e), {
                            currentTime: currentTimestamp,
                            onTimeChange: handleTimeChange,
                            tripCountsByDate: tripCountsByDate,
                            selectedTripStart: selectedTripInfo?.start,
                            selectedTripEnd: selectedTripInfo?.end,
                            showTripDuration: !!selectedTripInfo,
                            selectedTailNumber: selectedTripInfo?.tailNumber,
                            onJumpToNextTrip: handleJumpToNextTrip,
                            onJumpToPreviousTrip: handleJumpToPreviousTrip,
                            showTripJumpButtons: true,
                            hasNextTrip: hasNextTrip,
                            hasPreviousTrip: hasPreviousTrip,
                            showViewScheduleButton: isAutoParkEnabled,
                            onViewSchedule: ()=>setScheduleGanttOpen(true),
                            viewScheduleDisabled: !baseRamp
                        })
                    })
                ]
            }),
            isUpdating && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {
                sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1200
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                sx: {
                    flex: 1,
                    transition: "opacity 0.2s ease-in-out",
                    opacity: isPending ? 0.8 : 1
                },
                children: initialLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        p: 4
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            variant: "text",
                            width: "60%",
                            height: 40,
                            sx: {
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            variant: "rectangular",
                            width: "90%",
                            height: 400,
                            sx: {
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            width: "90%",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "30%",
                                    height: 100
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "30%",
                                    height: 100
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "rectangular",
                                    width: "30%",
                                    height: 100
                                })
                            ]
                        })
                    ]
                }) : scheduledRamp ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1774625a478f9093$export$7b435ba7a1f9f7f1), {
                    id: id,
                    isReference: isReference,
                    isAlgorithmTesting: isAlgorithmTesting,
                    ramp: scheduledRamp,
                    setRamp: handleRampChange,
                    history: {
                        undo: ()=>{}
                    },
                    isScheduledView: true,
                    onUndo: handleUndo,
                    scheduledViewProps: {
                        tenantTripMap: tenantTripMap,
                        placementService: placementService,
                        currentTime: currentTimestamp,
                        onScheduledUpdate: ()=>{
                            // Trigger a refresh after a short delay to ensure DB has updated
                            setTimeout(()=>{
                                setRefreshKey((prev)=>prev + 1);
                            }, 300);
                        },
                        timeRange: timeRange,
                        // Use the actual calculated time range
                        allPlacements: placementsInRange,
                        // Ramp-specific placements for default display
                        allPlacementsForSearch: allPlacementsForSearch,
                        heatmapPlacements: // All-location placements for search
                        heatmapPlacements,
                        // Placements for 72h heatmap window
                        onRemoveAircraft: handleAircraftRemoval,
                        onTimeChange: handleTimeChange,
                        onNavigateToLocation: handleNavigateToLocation
                    },
                    onScheduledUpdate: ()=>{
                        // Trigger a refresh after a short delay to ensure DB has updated
                        setTimeout(()=>{
                            setRefreshKey((prev)=>prev + 1);
                        }, 300);
                    }
                }) : hasLoadedOnce ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fBVnr.EmptyState), {
                    title: "No Ramp Data Available",
                    description: "Unable to load ramp information for this time period. Try refreshing the page or selecting a different time.",
                    actionLabel: "Refresh",
                    onAction: ()=>setRefreshKey((prev)=>prev + 1)
                }) : null
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: showAddObstacleDialog,
                onClose: ()=>setShowAddObstacleDialog(false),
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Add Movable Obstacle"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        sx: {
                            width: 900,
                            height: 600
                        },
                        children: baseRamp && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kgjm7.MovableObstacleGrid), {
                            location: baseRamp,
                            movableObstacles: predefinedObstacles,
                            stack: baseRamp.stack,
                            setStack: (newStack)=>{
                                const baseObstacles = baseRamp.stack.movableObstacles || [];
                                const currentAdded = addedObstacles;
                                // Separate new obstacles from position updates
                                const updatedAdded = [];
                                const newlyAdded = [];
                                for (const obstacle of newStack.movableObstacles){
                                    const isFromBase = baseObstacles.find((base)=>base.id === obstacle.id);
                                    const isFromAdded = currentAdded.find((added)=>added.id === obstacle.id);
                                    if (isFromBase && baseRamp) continue;
                                    else if (isFromAdded) // Existing added obstacle - update position
                                    updatedAdded.push(obstacle);
                                    else // Truly new obstacle
                                    newlyAdded.push(obstacle);
                                }
                                // Update addedObstacles with position changes + new obstacles
                                const finalObstacles = [
                                    ...updatedAdded,
                                    ...newlyAdded
                                ];
                                setAddedObstaclesWithLogging(finalObstacles);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setShowAddObstacleDialog(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                onClick: ()=>{
                                    setShowAddObstacleDialog(false);
                                    // Clear added obstacles since they're now saved to database
                                    setAddedObstaclesWithLogging([]);
                                    // Trigger refresh to reload from database
                                    setRefreshKey((prev)=>prev + 1);
                                },
                                children: "Done"
                            })
                        ]
                    })
                ]
            }),
            baseRamp && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f72dba5709d1e5d$export$22c4a271103992a1), {
                open: scheduleGanttOpen,
                onClose: ()=>setScheduleGanttOpen(false),
                initialStartTime: rangeStart || new Date(),
                initialEndTime: rangeEnd || new Date(),
                currentTimestamp: currentTimestamp,
                rampId: id,
                rampName: baseRamp.name,
                rampShapes: baseRamp.shapes,
                rampDepth: baseRamp.depth,
                onTimeRangeChange: handleTimeRangeChange,
                zones: baseRamp.shapes.filter((s)=>s.type === "Zone").map((s)=>({
                        id: s.id,
                        name: s.text || s.id,
                        spotIds: [],
                        // Will be populated from spot metadata
                        priority: s.priority || 5
                    })),
                placementService: placementService,
                onApplied: handleScheduleGanttApplied
            })
        ]
    });
};


const { useTransition: $b40dd1754d99f7ff$var$useTransition } = $acw62;
/**
 * Calculate which spot an aircraft is in based on its position
 * Returns the full Shape object for the spot, or undefined if not in any spot
 */ const $b40dd1754d99f7ff$var$calculateSpotForPlacement = (placement, aircraftMap, rampShapes, rampDepth)=>{
    // Check if we have valid position data
    if (placement.x == null || placement.y == null || placement.angle == null || !placement.aircraft_id) return undefined;
    // Get aircraft data
    const aircraft = aircraftMap.get(placement.aircraft_id);
    if (!aircraft) return undefined;
    // Filter for spot shapes only
    const spotShapes = rampShapes.filter((shape)=>shape.type === "Spot");
    if (spotShapes.length === 0) return undefined;
    // Build a map of legacy spots to their shape IDs
    const shapeIdMap = new Map();
    // Convert spot shapes to LegacySpot format
    const legacySpots = spotShapes.filter((shape)=>shape.reference_points && shape.reference_points.length > 0).map((shape)=>{
        const legacySpot = {
            points: shape.points,
            referencePoints: shape.reference_points
        };
        shapeIdMap.set(legacySpot, shape.id);
        return legacySpot;
    });
    if (legacySpots.length === 0) return undefined;
    // Apply Y-flip transformation to placement coordinates
    // Database placements use Y-flipped coordinates (origin at top-left)
    // Spot shapes use non-flipped coordinates (origin at bottom-left)
    const transformedPosition = {
        x: placement.x,
        y: rampDepth - placement.y,
        angle: placement.angle
    };
    // Create minimal tenant for spot detection
    const tenant = {
        aircraft: aircraft,
        id: "",
        fbo_id: "",
        entity_id: "",
        tail_number: "" // Not available from Aircraft type
    };
    // Call getSpotForPositionLegacy with transformed coordinates
    try {
        const result = (0, $jYWTx.getSpotForPositionLegacy)(tenant, transformedPosition, legacySpots);
        if (!result) return undefined;
        // Get the shape ID from the map
        const shapeId = shapeIdMap.get(result.spot);
        if (!shapeId) return undefined;
        // Find and return the matching shape
        return spotShapes.find((shape)=>shape.id === shapeId);
    } catch (error) {
        console.error("Error detecting spot for placement:", error);
        return undefined;
    }
};
const $b40dd1754d99f7ff$export$b70f93cbcdedd9de = /*#__PURE__*/ $acw62.memo(({ id: id, isReference: isReference, isAlgorithmTesting: isAlgorithmTesting })=>{
    // Predicate function to determine if a scheduled state change is meaningful for undo
    // Memoized to prevent infinite re-renders caused by changing function reference
    const isScheduledRampStateChangeMeaningful = $acw62.useCallback((oldState, newState)=>{
        // If either state is null, it's meaningful
        if (!oldState?.scheduledRamp || !newState?.scheduledRamp) return true;
        // If timestamp changed, it's meaningful
        if (oldState.timestamp.getTime() !== newState.timestamp.getTime()) return true;
        // Check if ramp positions changed using existing logic
        const oldStateHash = (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify((0, $abvRu.extractImportantLocationState)(oldState.scheduledRamp)));
        const newStateHash = (0, (/*@__PURE__*/$parcel$interopDefault($lLxKB)))(JSON.stringify((0, $abvRu.extractImportantLocationState)(newState.scheduledRamp)));
        return oldStateHash !== newStateHash;
    }, [] // Empty deps - function has no external dependencies
    );
    // URL-driven timestamp management with current time as default
    const { currentTime: currentTimestamp, setCurrentTime: setCurrentTimestamp } = (0, $ec443de9378d8cc1$export$3c41ae73890a1609)({
        defaultDate: new Date(),
        updateUrlOnMount: true
    });
    const navigate = (0, $aphAM.useNavigate)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const activeFBOId = activeFBO?.id; // Extract stable ID for dependency arrays
    const { predefinedObstacles: predefinedObstacles } = (0, $koS2J.usePredefinedObstacle)();
    const { isDrawerOpen: isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen } = (0, $3JLDK.useLayout)();
    const { rangeStart: rangeStart, rangeEnd: rangeEnd, setTimeRange: setTimeRange, getDefaultWeekRange: getDefaultWeekRange } = (0, $aWoxc.useScheduleTimeRange)();
    const { preferences: preferences } = (0, $fC0pb.useUserPreferences)();
    // Memoize PlacementService instance to avoid recreating on every render
    const placementService = $acw62.useMemo(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    // State for the base ramp structure and scheduled data
    const [baseRamp, setBaseRamp] = $acw62.useState(null);
    // Track selected aircraft tail number separately (UI state, not persisted)
    // Using ref to avoid re-render loops and useEffect dependency issues
    const selectedTailNumberRef = $acw62.useRef(undefined);
    // Composite state for undo functionality (combines ramp state + timestamp)
    const [viewState, setViewState, undoViewState] = (0, $6TVXD.useStateHistory)({
        scheduledRamp: null,
        timestamp: currentTimestamp
    }, isScheduledRampStateChangeMeaningful);
    // Use ref to keep track of currentTimestamp without causing re-renders
    const currentTimestampRef = $acw62.useRef(currentTimestamp);
    $acw62.useEffect(()=>{
        currentTimestampRef.current = currentTimestamp;
    }, [
        currentTimestamp
    ]);
    // Extract current values for easier access
    const scheduledRamp = viewState?.scheduledRamp;
    const setScheduledRamp = $acw62.useCallback((newRamp)=>{
        setViewState({
            scheduledRamp: newRamp,
            timestamp: currentTimestampRef.current
        });
    }, [
        setViewState
    ]);
    // React 18 concurrent features for smooth date transitions
    const [isPending, startTransition] = $b40dd1754d99f7ff$var$useTransition();
    const [initialLoading, setInitialLoading] = $acw62.useState(true);
    const [isUpdating, setIsUpdating] = $acw62.useState(false);
    const [hasLoadedOnce, setHasLoadedOnce] = $acw62.useState(false);
    // State to trigger refresh
    const [refreshKey, setRefreshKey] = $acw62.useState(0);
    // Track tenant ID -> trip ID mapping
    const [tenantTripMap, setTenantTripMap] = $acw62.useState(new Map());
    // State for all placements in the visible time range (for Active Trips metric)
    // This stores the raw placements from the database (without spot enrichment)
    const [rawPlacementsInRange, setRawPlacementsInRange] = $acw62.useState([]);
    // State for ALL placements in time range across all locations (for Timeline Aircraft)
    const [allPlacementsInTimeRange, setAllPlacementsInTimeRange] = $acw62.useState([]);
    // State for heatmap placements (72h window from current timestamp)
    const [heatmapPlacements, setHeatmapPlacements] = $acw62.useState([]);
    // State for trip counts by date (used for calendar date picker indicators)
    // Efficiently loaded from database aggregation instead of client-side computation
    const [tripCountsByDate, setTripCountsByDate] = $acw62.useState(new Map());
    // State for next/previous trip availability
    const [hasNextTrip, setHasNextTrip] = $acw62.useState(false);
    const [hasPreviousTrip, setHasPreviousTrip] = $acw62.useState(false);
    // Aircraft-specific trip availability
    const [hasNextTripForAircraft, setHasNextTripForAircraft] = $acw62.useState(false);
    const [hasPreviousTripForAircraft, setHasPreviousTripForAircraft] = $acw62.useState(false);
    // Use global snackbar
    const snackbar = (0, $6fDLr.useSnackbar)();
    // State for Add Obstacle Dialog
    const [showAddObstacleDialog, setShowAddObstacleDialog] = $acw62.useState(false);
    // State for user-added obstacles (separate from baseRamp to avoid circular dependency)
    const [addedObstacles, setAddedObstacles] = $acw62.useState([]);
    // Add logging wrapper for setAddedObstacles
    const setAddedObstaclesWithLogging = $acw62.useCallback((newObstaclesOrUpdater)=>{
        if (typeof newObstaclesOrUpdater === "function") setAddedObstacles((prev)=>{
            const newValue = newObstaclesOrUpdater(prev);
            return newValue;
        });
        else setAddedObstacles(newObstaclesOrUpdater);
    }, []); // Empty dependencies to prevent infinite loops
    // Load base ramp structure (dimensions, obstacles, etc.)
    $acw62.useEffect(()=>{
        if (!postgrest || !activeFBO || !id) return;
        const loadBaseRamp = async ()=>{
            try {
                const ramp = await (0, $8GP8k.fetchRamp)(postgrest, activeFBO, id, isReference || false);
                setBaseRamp(ramp);
            } catch (error) {
                snackbar.notify({
                    text: "Failed to load ramp structure",
                    severity: "error"
                });
            }
        };
        loadBaseRamp();
    }, [
        postgrest,
        activeFBOId,
        id,
        isReference
    ]); // Use activeFBOId instead of activeFBO to avoid infinite loops. snackbar intentionally omitted - only used in catch block
    // Load all placements in the visible time range (for Active Trips metric)
    $acw62.useEffect(()=>{
        if (!postgrest || !id || !rangeStart || !rangeEnd) return;
        const fetchPlacementsInRange = async ()=>{
            try {
                // Fetch placements for this specific ramp (for metrics)
                const placementsForThisRamp = await placementService.getPlacementsInTimeRange(rangeStart, rangeEnd, id, "ramp");
                // Fetch ALL trips (including unassigned) for search capability (1 year range)
                // Uses the comprehensive view that includes trips without placement assignments
                // RampLeftPanel will filter this down to rangeStart/rangeEnd for timeline view
                // Use timeline's rangeEnd (not actual current date) to support viewing future dates
                const searchEndDate = new Date(rangeEnd);
                searchEndDate.setFullYear(searchEndDate.getFullYear() + 1); // 1 year ahead from timeline
                const allPlacements = await placementService.getAllTripsWithPlacementStatus(rangeStart, // from timeline range start (includes currently active trips)
                searchEndDate // to 1 year from now
                );
                // Fetch aircraft data for all placements in time range
                const aircraftIds = Array.from(new Set(placementsForThisRamp.map((p)=>p.aircraft_id).filter((id)=>id != null)));
                const aircrafts = await (0, $8GP8k.fetchAircraftWithCache)(postgrest, aircraftIds, activeFBO);
                const aircraftMap = new Map();
                aircrafts.forEach((aircraft)=>{
                    aircraftMap.set(aircraft.id, aircraft);
                });
                // Enrich placements with aircraft data immediately
                const enrichedPlacements = placementsForThisRamp.map((p)=>{
                    const aircraft = p.aircraft_id ? aircraftMap.get(p.aircraft_id) : undefined;
                    return {
                        ...p,
                        aircraft_make: aircraft?.make,
                        aircraft_model: aircraft?.model
                    };
                });
                setRawPlacementsInRange(enrichedPlacements);
                setAllPlacementsInTimeRange(allPlacements);
            } catch (error) {
            // Silent failure - non-critical for main functionality
            }
        };
        fetchPlacementsInRange();
    }, [
        postgrest,
        id,
        placementService,
        rangeStart,
        rangeEnd,
        refreshKey,
        activeFBO
    ]);
    // Enrich placementsInRange with spot data and aircraft details (memoized to avoid recalculation)
    const placementsInRange = $acw62.useMemo(()=>{
        if (!baseRamp || !rawPlacementsInRange.length || !scheduledRamp) return rawPlacementsInRange;
        // Build aircraft map from scheduledRamp tenants (already loaded with aircraft)
        const aircraftMap = new Map();
        scheduledRamp.stack.tenants.forEach((t)=>{
            if (t.aircraft && t.aircraft_id) aircraftMap.set(t.aircraft_id, t.aircraft);
        });
        // Enrich placements with spot detection ONLY (aircraft data already enriched in useEffect)
        return rawPlacementsInRange.map((p)=>({
                ...p,
                spot: $b40dd1754d99f7ff$var$calculateSpotForPlacement(p, aircraftMap, baseRamp.shapes, baseRamp.depth)
            }));
    }, [
        baseRamp,
        rawPlacementsInRange,
        scheduledRamp
    ]);
    // Load placements for heatmap (72h window from current timestamp)
    $acw62.useEffect(()=>{
        if (!postgrest || !id) return;
        const fetchHeatmapPlacements = async ()=>{
            try {
                const horizonHours = preferences?.heatmapHorizonHours || (0, $6zwbt.HEATMAP_HORIZON_HOURS);
                const heatmapStart = currentTimestamp;
                const heatmapEnd = new Date(currentTimestamp.getTime() + horizonHours * 3600000);
                const placements = await placementService.getPlacementsInTimeRange(heatmapStart, heatmapEnd, id, "ramp");
                setHeatmapPlacements(placements);
            } catch (error) {
                // Silent failure - heatmap is non-critical
                console.warn("Failed to load heatmap placements:", error);
            }
        };
        fetchHeatmapPlacements();
    }, [
        postgrest,
        id,
        placementService,
        currentTimestamp,
        refreshKey,
        preferences?.heatmapHorizonHours
    ]);
    // Load trip counts by date for calendar indicators (1 year range)
    $acw62.useEffect(()=>{
        if (!postgrest || !id) return;
        const fetchTripCounts = async ()=>{
            try {
                const startDate = rangeStart || new Date();
                const endDate = new Date(startDate);
                endDate.setFullYear(endDate.getFullYear() + 1); // 1 year ahead for calendar
                const counts = await placementService.getTripCountsByDate(startDate, endDate, id, "ramp");
                setTripCountsByDate(counts);
            } catch (error) {
                // Silent failure - calendar indicators are non-critical
                console.warn("Failed to load trip counts for calendar:", error);
            }
        };
        fetchTripCounts();
    }, [
        postgrest,
        id,
        placementService,
        rangeStart,
        refreshKey
    ]);
    // Compute selected trip info BEFORE using it in useEffect below
    const selectedTripInfo = $acw62.useMemo(()=>{
        if (!scheduledRamp?.stack?.tenants) return null;
        // Find the selected tenant
        const selectedTenant = scheduledRamp.stack.tenants.find((tenant)=>tenant.selected);
        if (!selectedTenant) return null;
        // Get the trip ID for this tenant
        const tripId = tenantTripMap.get(selectedTenant.id);
        if (!tripId) return null;
        // Get ALL placements for this trip (may have multiple segments)
        // Use placementsInRange which contains all segments in the visible time range
        const tripPlacements = placementsInRange.filter((placement)=>placement.trip_id === tripId);
        if (tripPlacements.length === 0) return null;
        // Calculate earliest start and latest end across all segments
        const start = tripPlacements.reduce((earliest, p)=>{
            const pStart = new Date(p.start_time);
            return pStart < earliest ? pStart : earliest;
        }, new Date(tripPlacements[0].start_time));
        const end = tripPlacements.reduce((latest, p)=>{
            const pEnd = new Date(p.end_time);
            return pEnd > latest ? pEnd : latest;
        }, new Date(tripPlacements[0].end_time));
        return {
            start: start,
            end: end,
            tailNumber: selectedTenant.tail_number
        };
    }, [
        scheduledRamp?.stack?.tenants,
        tenantTripMap,
        placementsInRange
    ]);
    // Check for next/previous trips availability
    $acw62.useEffect(()=>{
        if (!placementService || !id || !currentTimestamp) return;
        const checkTripAvailability = async ()=>{
            try {
                // Always check location-wide trips
                const [nextTrip, previousTrip] = await Promise.all([
                    placementService.getNextTripTime(id, "ramp", currentTimestamp),
                    placementService.getPreviousTripTime(id, "ramp", currentTimestamp)
                ]);
                setHasNextTrip(!!nextTrip);
                setHasPreviousTrip(!!previousTrip);
                // If aircraft selected, also check aircraft-specific trips
                if (selectedTripInfo?.tailNumber) {
                    const [nextAircraftTrip, previousAircraftTrip] = await Promise.all([
                        placementService.getNextTripTimeForAircraft(selectedTripInfo.tailNumber, currentTimestamp, id, "ramp"),
                        placementService.getPreviousTripTimeForAircraft(selectedTripInfo.tailNumber, currentTimestamp, id, "ramp")
                    ]);
                    setHasNextTripForAircraft(!!nextAircraftTrip);
                    setHasPreviousTripForAircraft(!!previousAircraftTrip);
                } else {
                    // No aircraft selected, clear aircraft-specific state
                    setHasNextTripForAircraft(false);
                    setHasPreviousTripForAircraft(false);
                }
            } catch (error) {
            // Silent failure - non-critical for main functionality
            }
        };
        checkTripAvailability();
    }, [
        placementService,
        id,
        currentTimestamp,
        selectedTripInfo,
        refreshKey
    ]);
    // Load scheduled placement data when timestamp changes
    $acw62.useEffect(()=>{
        if (!postgrest || !activeFBO || !baseRamp || !currentTimestamp) // Don't set loading false here - let the data fetch complete first
        return;
        const loadScheduledData = async ()=>{
            // Only show loading on initial load, keep previous data visible during date changes
            if (!scheduledRamp) setInitialLoading(true);
            // Don't set isUpdating during date changes - keep previous content visible
            try {
                // 1. Fetch placements at the current timestamp
                const allPlacements = await placementService.getPlacementsAtTime(currentTimestamp);
                // 2. Filter placements for this ramp
                // NOTE: We do NOT filter out placements with null x/y here!
                // Placements can exist without positions (they just haven't been parked yet)
                const rampPlacements = allPlacements.filter((p)=>p.ramp_id === id);
                // 2.1 Deduplicate placements by placement.id first (detect AutoPark bugs)
                // This catches the case where the same placement_id appears for multiple trips
                const placementIdMap = new Map();
                const placementIdDuplicates = [];
                rampPlacements.forEach((placement)=>{
                    if (placementIdMap.has(placement.id)) {
                        const existing = placementIdMap.get(placement.id);
                        console.error(`\u{26A0}\u{FE0F}  DUPLICATE PLACEMENT_ID DETECTED: placement_id="${placement.id}" appears in multiple trips:\n` + `  - Trip ${existing.trip_id} (tail: ${existing.tail_number})\n` + `  - Trip ${placement.trip_id} (tail: ${placement.tail_number})\n` + `This indicates an AutoPark bug where the same position was assigned to multiple aircraft.`);
                        placementIdDuplicates.push({
                            existing: existing,
                            duplicate: placement
                        });
                    } else placementIdMap.set(placement.id, placement);
                });
                // Use placement_id-deduplicated list for further processing
                const placementIdDeduplicated = Array.from(placementIdMap.values());
                // 2.2 Then deduplicate by trip_id (keep most recent placement per trip)
                const placementMap = new Map();
                placementIdDeduplicated.forEach((placement)=>{
                    const existing = placementMap.get(placement.trip_id);
                    if (!existing || new Date(placement.created_at) > new Date(existing.created_at)) placementMap.set(placement.trip_id, placement);
                });
                const deduplicatedPlacements = Array.from(placementMap.values());
                // Log deduplication summary
                if (placementIdDuplicates.length > 0) console.error(`[ScheduledRampView] Removed ${placementIdDuplicates.length} placement_id duplicates (AutoPark bug)`);
                // 3. Extract unique aircraft IDs and fetch aircraft data
                const aircraftIds = deduplicatedPlacements.map((p)=>p.aircraft_id).filter((id)=>id != null);
                const aircrafts = aircraftIds.length > 0 ? await (0, $8GP8k.fetchAircraftWithCache)(postgrest, aircraftIds, activeFBO) : [];
                // 4. Create aircraft lookup map
                const aircraftMap = new Map();
                aircrafts.forEach((aircraft)=>{
                    aircraftMap.set(aircraft.id, aircraft);
                });
                // 6. Create scheduled stack ID - use stable ID to prevent remounting
                const scheduledStackId = `scheduled-${baseRamp.id}`;
                // Build trip ID map
                const tripMap = new Map();
                // Use the separately tracked selected tail number (persists across data refreshes)
                const currentlySelectedTailNumber = selectedTailNumberRef.current;
                // Filter out placements with NULL aircraft_id (data integrity issue)
                // Show warning instead of crashing to allow UI to remain functional
                const validPlacements = deduplicatedPlacements.filter((p)=>{
                    if (!p.aircraft_id) {
                        console.warn("Filtering out placement with NULL aircraft_id:", {
                            placementId: p.id,
                            tailNumber: p.tail_number,
                            tripId: p.trip_id
                        });
                        return false;
                    }
                    return true;
                });
                // Track how many placements were filtered for warning display
                const hiddenPlacementCount = deduplicatedPlacements.length - validPlacements.length;
                // Transform placements to tenants format
                const scheduledTenants = validPlacements.map((placement)=>{
                    const aircraft = placement.aircraft_id ? aircraftMap.get(placement.aircraft_id) : undefined;
                    // At this point aircraft_id is guaranteed to be non-NULL due to filter above
                    if (!placement.aircraft_id) // This should never happen due to filter, but TypeScript doesn't know that
                    throw new Error(`Internal error: NULL aircraft_id passed filter (placement ${placement.id})`);
                    if (!aircraft) {
                        console.error("Missing aircraft for placement with aircraft_id:", {
                            placementId: placement.id,
                            aircraftId: placement.aircraft_id,
                            tailNumber: placement.tail_number,
                            tripId: placement.trip_id,
                            requestedIds: aircraftIds,
                            returnedIds: aircrafts.map((a)=>a.id),
                            aircraftMapKeys: Array.from(aircraftMap.keys())
                        });
                        throw new Error(`Missing aircraft data for placement ${placement.id} (aircraft_id: ${placement.aircraft_id}, tail_number: ${placement.tail_number}). ` + `This indicates a data integrity issue - aircraft records should exist for all scheduled placements.`);
                    }
                    const tenantId = `scheduled-trip-${placement.trip_id}`;
                    // Store the mapping
                    tripMap.set(tenantId, placement.trip_id);
                    return {
                        id: tenantId,
                        fbo_id: baseRamp.fbo_id,
                        entity_id: placement.entity_id || `entity-${placement.trip_id}`,
                        placement_id: placement.id,
                        aircraft_id: aircraft.id,
                        type: placement.aircraft_type || "transient",
                        tail_number: placement.tail_number || "Unknown",
                        owner_manager: placement.owner_manager || "",
                        trip_id: placement.trip_id,
                        aircraft: aircraft,
                        created_at: placement.start_time,
                        // Preserve selection state for the same aircraft across time changes
                        selected: currentlySelectedTailNumber === placement.tail_number,
                        position: {
                            id: `position-${placement.id}`,
                            stack_id: scheduledStackId,
                            // Use the scheduled stack ID, not the base ramp stack ID
                            entity_id: placement.entity_id || `entity-${placement.trip_id}`,
                            x: placement.x,
                            y: placement.y,
                            angle: placement.angle || 0,
                            preferences: aircraft ? (0, $lNEp2.defaultPreferenceForAircraft)(aircraft, activeFBO) : [],
                            timestamp: placement.start_time ? new Date(placement.start_time).getTime() : Date.now() // Use placement start time (changes when position changes)
                        },
                        suggestedPositions: [],
                        note: `Trip: ${placement.trip_id}`,
                        note_last_updated_by: "scheduling",
                        note_last_updated: new Date().toISOString(),
                        placement_source: placement.placement_source,
                        is_locked: placement.is_locked
                    };
                });
                // Log any remaining duplicates for monitoring
                (0, $3dLiv.detectAndLogDuplicates)(scheduledTenants, `ScheduledRampView-${id}`);
                // 6. Create scheduled stack
                // Merge base obstacles (from database) with user-added obstacles
                const allObstacles = [
                    ...baseRamp.stack.movableObstacles || [],
                    ...addedObstacles
                ];
                const scheduledMovableObstacles = allObstacles.map((obstacle)=>{
                    return {
                        ...obstacle,
                        position: {
                            ...obstacle.position,
                            stack_id: scheduledStackId // Update to match scheduled stack ID
                        }
                    };
                });
                const scheduledStack = {
                    id: scheduledStackId,
                    name: `Scheduled View - ${currentTimestamp.toLocaleString()}`,
                    location_id: baseRamp.id,
                    isReference: false,
                    tenants: scheduledTenants,
                    movableObstacles: scheduledMovableObstacles,
                    options: baseRamp.stack.options
                };
                // 7. Create complete scheduled ramp object
                const scheduledRampData = {
                    ...baseRamp,
                    stack: scheduledStack
                };
                // Wrap state updates in startTransition to prevent remounting
                startTransition(()=>{
                    setScheduledRamp(scheduledRampData);
                    setTenantTripMap(tripMap);
                    setHasLoadedOnce(true);
                });
            } catch (error) {
                console.error("Error loading scheduled placement data:", error);
                snackbar.notify({
                    text: "Failed to load scheduled placement data",
                    severity: "error"
                });
                setHasLoadedOnce(true);
            } finally{
                setInitialLoading(false);
                setIsUpdating(false);
            }
        };
        loadScheduledData();
    }, [
        postgrest,
        activeFBOId,
        // Use activeFBOId instead of activeFBO to avoid infinite loops while still triggering on FBO changes
        baseRamp,
        currentTimestamp,
        id,
        refreshKey,
        addedObstacles,
        placementService,
        // selectedTailNumberRef - Intentionally omitted, refs don't need to be in dependencies
        // snackbar, // Intentionally omitted - only used in async catch blocks, safe to omit. Including it causes infinite re-renders since snackbar object is recreated on every render.
        // setScheduledRamp, // Intentionally omitted to prevent infinite re-renders. This function is behaviorally stable and only uses stable refs, so it's safe to exclude from dependencies.
        startTransition
    ]);
    // Handler for time changes - now managed by URL hook which handles snapping
    const handleTimeChange = $acw62.useCallback((newTime)=>{
        setCurrentTimestamp(newTime); // URL hook handles snapping internally
        // Update the viewState to track time changes for undo
        if (scheduledRamp) setViewState({
            scheduledRamp: scheduledRamp,
            timestamp: newTime
        });
    }, [
        setCurrentTimestamp,
        scheduledRamp,
        setViewState
    ]);
    // Handler for navigating to a different location
    const handleNavigateToLocation = $acw62.useCallback((locationId, locationType, time)=>{
        const path = locationType === "hangar" ? `/hangars/${locationId}/schedule` : `/ramps/${locationId}/schedule`;
        // Pass the exact time - the destination route will handle proper snapping
        const timeParam = time.toISOString();
        navigate(`${path}?t=${timeParam}`);
    }, [
        navigate
    ]);
    // Handler for jumping to next trip
    const handleJumpToNextTrip = $acw62.useCallback(async ()=>{
        if (!placementService || !id) return;
        // Use selectedTripInfo which is already computed and has the tail number
        const selectedTailNumber = selectedTripInfo?.tailNumber;
        try {
            let nextTripTime = null;
            if (selectedTailNumber) // If an aircraft is selected, jump to its next trip
            nextTripTime = await placementService.getNextTripTimeForAircraft(selectedTailNumber, currentTimestamp, id, "ramp");
            else // Otherwise, jump to the next trip at this location
            nextTripTime = await placementService.getNextTripTime(id, "ramp", currentTimestamp);
            if (nextTripTime) {
                // Update the time to jump to the next trip, snapped to 15-minute grid
                // Use ceil for next trips to ensure we're at a time when the trip is active
                const snappedTime = (0, $55RUj.ceilToQuarterHour)(nextTripTime);
                setCurrentTimestamp(snappedTime);
                // Recalibrate the time range to center around the new time
                const { start: newStart, end: newEnd } = getDefaultWeekRange(snappedTime);
                setTimeRange(newStart, newEnd);
            }
        } catch (error) {
            console.error("Failed to jump to next trip:", error);
            snackbar.notify({
                text: "Failed to jump to next trip",
                severity: "error"
            });
        }
    }, [
        placementService,
        id,
        currentTimestamp,
        setCurrentTimestamp,
        getDefaultWeekRange,
        setTimeRange,
        // snackbar, // Intentionally omitted - only used in error catch block
        selectedTripInfo
    ]);
    // Handler for jumping to previous trip
    const handleJumpToPreviousTrip = $acw62.useCallback(async ()=>{
        if (!placementService || !id) return;
        // Use selectedTripInfo which is already computed and has the tail number
        const selectedTailNumber = selectedTripInfo?.tailNumber;
        try {
            let previousTripTime = null;
            if (selectedTailNumber) // If an aircraft is selected, jump to its previous trip
            previousTripTime = await placementService.getPreviousTripTimeForAircraft(selectedTailNumber, currentTimestamp, id, "ramp");
            else // Otherwise, jump to the previous trip at this location
            previousTripTime = await placementService.getPreviousTripTime(id, "ramp", currentTimestamp);
            if (previousTripTime) {
                // Update the time to jump to the previous trip - URL hook handles snapping
                setCurrentTimestamp(previousTripTime);
                // Recalibrate the time range to center around the new time
                const { start: newStart, end: newEnd } = getDefaultWeekRange(previousTripTime);
                setTimeRange(newStart, newEnd);
            }
        } catch (error) {
            console.error("Failed to jump to previous trip:", error);
            snackbar.notify({
                text: "Failed to jump to previous trip",
                severity: "error"
            });
        }
    }, [
        placementService,
        id,
        currentTimestamp,
        setCurrentTimestamp,
        getDefaultWeekRange,
        setTimeRange,
        // snackbar, // Intentionally omitted - only used in error catch block
        selectedTripInfo
    ]);
    // Handler for undo - restores both ramp state and timestamp
    const handleUndo = $acw62.useCallback(()=>{
        const previousState = undoViewState();
        if (previousState) {
            // Restore the timestamp first
            setCurrentTimestamp(previousState.timestamp);
            // The ramp state is already restored by undoViewState
            // Trigger a refresh to ensure UI is consistent
            setRefreshKey((prev)=>prev + 1);
        }
    }, [
        undoViewState,
        setCurrentTimestamp,
        setRefreshKey
    ]);
    // Handler for ramp changes (when user drags aircraft in scheduled view)
    const handleRampChange = $acw62.useCallback(async (updatedRamp)=>{
        // Check if any tenant is selected in the updated ramp
        const selectedInUpdate = updatedRamp?.stack?.tenants?.find((t)=>t.selected);
        // Update selection ref (only when explicitly changed, not from data refresh)
        const newSelection = selectedInUpdate?.tail_number;
        // Update ref based on selection state
        if (selectedInUpdate) selectedTailNumberRef.current = newSelection;
        else // Clear ref when no selection (handles deselection via useUnselect hook)
        selectedTailNumberRef.current = undefined;
        // ALWAYS apply the ref value when updating scheduledRamp (preserves selection across refreshes)
        const currentSelection = selectedTailNumberRef.current;
        setScheduledRamp({
            ...updatedRamp,
            stack: {
                ...updatedRamp.stack,
                tenants: updatedRamp.stack.tenants.map((t)=>{
                    // Just apply selection, preserve everything else from incoming data
                    return {
                        ...t,
                        selected: currentSelection ? t.tail_number === currentSelection : false
                    };
                })
            }
        });
        if (!scheduledRamp || !postgrest) return;
        try {
            // Get current placements for comparison
            const oldTenants = scheduledRamp.stack.tenants;
            const newTenants = updatedRamp.stack.tenants;
            const oldObstacles = scheduledRamp.stack.movableObstacles;
            const newObstacles = updatedRamp.stack.movableObstacles;
            // Handle aircraft/tenant removals first
            for (const oldTenant of oldTenants){
                const stillExists = newTenants.find((t)=>t.id === oldTenant.id);
                if (!stillExists) {
                    // Tenant was removed
                    const tripId = tenantTripMap.get(oldTenant.id);
                    if (tripId) {
                        // Remove from location using the placement service
                        const startTimeISO = currentTimestamp.toISOString();
                        await placementService.assignToLocationWithGapFilling(tripId, null, // null location means unassigned
                        null, startTimeISO, undefined, true, // excludeConflicts
                        {
                            x: null,
                            y: null,
                            angle: null
                        });
                    }
                }
            }
            // Handle aircraft/tenant position changes
            for (const newTenant of newTenants){
                const oldTenant = oldTenants.find((t)=>t.id === newTenant.id);
                if (!oldTenant) continue; // Skip new tenants (shouldn't happen in scheduled view)
                const oldPos = oldTenant.position;
                const newPos = newTenant.position;
                // Check if position changed (x, y, angle)
                const positionChanged = oldPos.x !== newPos.x || oldPos.y !== newPos.y || oldPos.angle !== newPos.angle;
                if (positionChanged) {
                    // Get trip ID from our map
                    const tripId = tenantTripMap.get(newTenant.id);
                    if (!tripId) continue;
                    // Use database function to handle the placement change atomically
                    // This ensures the aircraft stays in the new position until explicitly moved again
                    await placementService.moveAircraftAtTime(tripId, id, // ramp id
                    "ramp", currentTimestamp, // When the move happens
                    {
                        x: newPos.x,
                        y: newPos.y,
                        angle: newPos.angle
                    }, newTenant.is_locked ?? true // Only lock if in spot/zone
                    );
                }
            }
            // Handle movable obstacle position changes
            for (const newObstacle of newObstacles){
                const oldObstacle = oldObstacles.find((o)=>o.id === newObstacle.id);
                if (!oldObstacle) continue; // Skip new obstacles (shouldn't happen in scheduled view)
                const oldPos = oldObstacle.position;
                const newPos = newObstacle.position;
                // Check if obstacle position changed (x, y, angle)
                const obstaclePositionChanged = oldPos.x !== newPos.x || oldPos.y !== newPos.y || oldPos.angle !== newPos.angle;
                if (obstaclePositionChanged) {
                    // Check if this obstacle is from base or added obstacles
                    const isFromBase = baseRamp?.stack.movableObstacles.find((mo)=>mo.id === newObstacle.id);
                    const isFromAdded = addedObstacles.find((mo)=>mo.id === newObstacle.id);
                    if (isFromBase && baseRamp) {
                        // Update the base ramp's movable obstacle position
                        const updatedBaseRamp = {
                            ...baseRamp,
                            stack: {
                                ...baseRamp.stack,
                                movableObstacles: baseRamp.stack.movableObstacles.map((mo)=>mo.id === newObstacle.id ? newObstacle : mo)
                            }
                        };
                        setBaseRamp(updatedBaseRamp);
                    } else if (isFromAdded) // Update the added obstacles state
                    setAddedObstaclesWithLogging(addedObstacles.map((mo)=>mo.id === newObstacle.id ? newObstacle : mo));
                    // Save obstacle position change to database immediately
                    try {
                        await postgrest.from("position").upsert({
                            id: newObstacle.position.id,
                            stack_id: baseRamp?.stack.id,
                            // Use base stack ID for persistence
                            entity_id: newObstacle.entity_id,
                            x: newObstacle.position.x,
                            y: newObstacle.position.y,
                            angle: newObstacle.position.angle,
                            preferences: newObstacle.position.preferences || []
                        });
                    } catch (error) {
                        snackbar.notify({
                            text: "Failed to save obstacle position",
                            severity: "error"
                        });
                    }
                }
                // Handle movable obstacle removals
                const currentObstacleCount = scheduledRamp.stack.movableObstacles.length;
                const newObstacleCount = updatedRamp.stack.movableObstacles.length;
                if (newObstacleCount < currentObstacleCount) {
                    const removedObstacles = scheduledRamp.stack.movableObstacles.filter((oldObstacle)=>!updatedRamp.stack.movableObstacles.find((newObs)=>newObs.id === oldObstacle.id));
                    for (const removed of removedObstacles){
                        const isFromBase = baseRamp?.stack.movableObstacles.find((base)=>base.id === removed.id);
                        if (isFromBase && baseRamp) {
                            await postgrest.from("position").delete().eq("id", removed.position.id);
                            await postgrest.from("movable_obstacle").delete().eq("id", removed.id);
                            const updatedBaseRamp = {
                                ...baseRamp,
                                stack: {
                                    ...baseRamp.stack,
                                    movableObstacles: baseRamp.stack.movableObstacles.filter((obs)=>obs.id !== removed.id)
                                }
                            };
                            setBaseRamp(updatedBaseRamp);
                        }
                    }
                }
            }
        } catch (error) {
            // Error handling via snackbar if needed
            snackbar.notify({
                text: error.message || "Failed to save changes",
                severity: "error"
            });
        }
    }, [
        scheduledRamp,
        baseRamp,
        setBaseRamp,
        postgrest,
        currentTimestamp,
        id,
        tenantTripMap,
        // snackbar, // Intentionally omitted - only used in error catch blocks
        placementService,
        setScheduledRamp,
        addedObstacles,
        setAddedObstaclesWithLogging
    ]);
    // Handler for aircraft removal - only updates local state
    // The database update happens through handleRampChange
    const handleAircraftRemoval = $acw62.useCallback((tenantId)=>{
        if (!scheduledRamp) return;
        // Update the local state (this will be captured for undo)
        const updatedRamp = {
            ...scheduledRamp,
            stack: {
                ...scheduledRamp.stack,
                tenants: scheduledRamp.stack.tenants.filter((t)=>t.id !== tenantId)
            }
        };
        // Update through handleRampChange which will:
        // 1. Update local state (for immediate UI feedback)
        // 2. Trigger database sync (handleRampChange handles this)
        // 3. Enable proper undo (state is tracked before change)
        handleRampChange(updatedRamp);
    }, [
        scheduledRamp,
        handleRampChange
    ]);
    // Navigation options for the location dropdown
    const isSchedulingEnabled = activeFBO?.settings?.enableScheduling ?? false;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3657bc75c8922c6$export$1b7a3aa9749b1d74), {
        id: id,
        isReference: isReference,
        isAlgorithmTesting: isAlgorithmTesting,
        baseRamp: baseRamp,
        scheduledRamp: scheduledRamp,
        currentTimestamp: currentTimestamp,
        rangeStart: rangeStart,
        rangeEnd: rangeEnd,
        setTimeRange: setTimeRange,
        initialLoading: initialLoading,
        isUpdating: isUpdating,
        isPending: isPending,
        hasLoadedOnce: hasLoadedOnce,
        isDrawerOpen: isDrawerOpen,
        setIsDrawerOpen: setIsDrawerOpen,
        isSchedulingEnabled: isSchedulingEnabled,
        hasNextTrip: selectedTripInfo?.tailNumber ? hasNextTripForAircraft : hasNextTrip,
        hasPreviousTrip: selectedTripInfo?.tailNumber ? hasPreviousTripForAircraft : hasPreviousTrip,
        selectedTripInfo: selectedTripInfo,
        tenantTripMap: tenantTripMap,
        placementsInRange: placementsInRange,
        tripCountsByDate: tripCountsByDate,
        allPlacementsForSearch: allPlacementsInTimeRange,
        heatmapPlacements: heatmapPlacements,
        showAddObstacleDialog: showAddObstacleDialog,
        setShowAddObstacleDialog: setShowAddObstacleDialog,
        addedObstacles: addedObstacles,
        predefinedObstacles: predefinedObstacles,
        handleTimeChange: handleTimeChange,
        handleJumpToNextTrip: handleJumpToNextTrip,
        handleJumpToPreviousTrip: handleJumpToPreviousTrip,
        handleUndo: handleUndo,
        handleRampChange: handleRampChange,
        handleAircraftRemoval: handleAircraftRemoval,
        handleNavigateToLocation: handleNavigateToLocation,
        setAddedObstaclesWithLogging: setAddedObstaclesWithLogging,
        placementService: placementService,
        refreshKey: refreshKey,
        setRefreshKey: setRefreshKey
    });
});


const $24b92612ec4d9b68$export$f8c4c61fc79c6924 = ({ rampId: rampId })=>{
    const { id: rampIdFromRoute } = (0, $aphAM.useParams)();
    return(// Same container structure as regular Ramp component
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
            isReference: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1KiAb.RampStateContainer), {
                initialState: {
                    ramp_id: rampId ?? rampIdFromRoute,
                    isReference: false
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6AlVH.TowingEquipmentContainer), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b40dd1754d99f7ff$export$b70f93cbcdedd9de), {
                        id: rampIdFromRoute || ""
                    })
                })
            })
        })
    }));
};


/**
 * Temporal Parking Test Page
 * Standalone page for testing temporal parking algorithm with visual feedback
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $hmTQO = parcelRequire("hmTQO");

var $euRCv = parcelRequire("euRCv");

var $5y9fX = parcelRequire("5y9fX");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $gd5y7 = parcelRequire("gd5y7");
var $OEVqP = parcelRequire("OEVqP");
var $2iAqv = parcelRequire("2iAqv");
var $7Frhn = parcelRequire("7Frhn");
var $cX7V2 = parcelRequire("cX7V2");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $25rQi = parcelRequire("25rQi");

var $3tkEe = parcelRequire("3tkEe");
/**
 * PlacementList Component
 * Shows text list of parking assignments
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $ewtCw = parcelRequire("ewtCw");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $cJu23 = parcelRequire("cJu23");
var $7Frhn = parcelRequire("7Frhn");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $elGuA = parcelRequire("elGuA");

var $7O8dW = parcelRequire("7O8dW");

var $czco8 = parcelRequire("czco8");
/**
 * Format size category as short label (uses shared formatter for consistency)
 * WHY: Show aircraft size at a glance in compact UI
 * EXAMPLES: "very-small" → "VS", "small" → "S", "large" → "L"
 */ const $07cb3cb81c1595aa$var$formatSizeLabel = (0, $czco8.formatSizeCategory);
/**
 * Format size category for tooltip (full name)
 * WHY: Provide clear explanation of abbreviation on hover
 */ const $07cb3cb81c1595aa$var$formatSizeTooltip = (size)=>{
    const tooltips = {
        "very-small": "Very Small (e.g., Cessna 172)",
        small: "Small (e.g., Citation, Phenom 300)",
        midsize: "Midsize (e.g., Challenger 604)",
        "super-midsize": "Super-Midsize (e.g., Gulfstream G650)",
        large: "Large (e.g., Global 7500, BBJ)",
        enormous: "Enormous (e.g., Commercial airliners)"
    };
    return tooltips[size];
};
const $07cb3cb81c1595aa$export$b655ca18f52b2d = ({ placement: placement, aircraft: aircraft, spots: spots, zones: zones })=>{
    // Get zone name for a spot
    const getZoneName = (spotId)=>{
        const spot = spots.find((s)=>s.id === spotId);
        if (!spot) return "?";
        const zone = zones.find((z)=>z.id === spot.zoneId);
        return zone?.name || spot.zoneId;
    };
    /**
   * Generate human-readable description of which aircraft are trapped
   *
   * WHY: Users need to understand the consequences of a trapping placement
   * SHOWS: "Blocks N822QS (departs 09:00)" or "Blocks 3 aircraft: N822QS, N697QS, N478QS"
   * USE CASE: Helps operator decide if trap is acceptable (e.g., "worth it for VIP aircraft")
   */ const getTrapWarningText = (request, spot, trapCount)=>{
        // Find specifically which aircraft are trapped (not just count)
        // WHY: Knowing "N822QS is trapped" is more actionable than "1 aircraft trapped"
        const trappedAircraft = (0, $7O8dW.findTrappedAircraft)(request, spot, placement, aircraft, spots);
        // Single aircraft trap - show detailed info with departure time
        // WHY: Departure time tells operator how long the blockage lasts
        // EXAMPLE: If trapped aircraft departs in 30min, it's a minor issue
        if (trappedAircraft.length === 1) {
            const trapped = trappedAircraft[0];
            return `Blocks ${trapped.tail_number} (departs ${(0, $elGuA.bucketToTimeString)(trapped.departureBucket)})`;
        }
        // Multiple aircraft - show list
        // WHY: Operator needs to see full impact (blocking 5 aircraft is serious)
        return `Blocks ${trapCount} aircraft: ${trappedAircraft.map((a)=>a.tail_number).join(", ")}`;
    };
    // Sort aircraft by arrival time
    const sortedAircraft = [
        ...aircraft
    ].sort((a, b)=>a.arrivalBucket - b.arrivalBucket);
    const placedAircraft = sortedAircraft.filter((ac)=>placement[ac.id]);
    const unplacedAircraft = sortedAircraft.filter((ac)=>!placement[ac.id]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7Frhn.default), {
        "data-testid": "placement-list",
        elevation: 1,
        sx: {
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                gutterBottom: true,
                children: "Parking Assignments"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cJu23.default), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                        item: true,
                        xs: 12,
                        md: placedAircraft.length > 0 && unplacedAircraft.length > 0 ? 7 : 12,
                        children: placedAircraft.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    color: "success.main",
                                    gutterBottom: true,
                                    children: [
                                        "Placed (",
                                        placedAircraft.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                        size: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            sx: {
                                                                fontWeight: "bold",
                                                                fontSize: "0.75rem"
                                                            },
                                                            children: "Tail"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            sx: {
                                                                fontWeight: "bold",
                                                                fontSize: "0.75rem"
                                                            },
                                                            children: "Spot"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            sx: {
                                                                fontWeight: "bold",
                                                                fontSize: "0.75rem"
                                                            },
                                                            children: "Zone"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            sx: {
                                                                fontWeight: "bold",
                                                                fontSize: "0.75rem"
                                                            },
                                                            children: "Time"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                                children: placedAircraft.map((ac)=>{
                                                    const p = placement[ac.id];
                                                    const requestedArrival = (0, $elGuA.bucketToTimeString)(ac.arrivalBucket);
                                                    const requestedDeparture = (0, $elGuA.bucketToTimeString)(ac.departureBucket);
                                                    // Check if this is a segmented placement
                                                    const isSegmented = "segments" in p;
                                                    // Calculate actual placement times
                                                    let actualStart;
                                                    let actualEnd;
                                                    let spotDisplay;
                                                    let zoneDisplay;
                                                    if (isSegmented) {
                                                        // Segmented placement - show chain with move indicators
                                                        const segments = p.segments;
                                                        // Trim to actual aircraft dwell (segments may include buffer)
                                                        actualStart = Math.max(segments[0].startBucket, ac.arrivalBucket);
                                                        actualEnd = Math.min(segments[segments.length - 1].endBucket, ac.departureBucket);
                                                        spotDisplay = segments.map((s)=>s.spotId).join(" \u2192 ");
                                                        // Use stored moveCount (actual spot changes) instead of recalculating
                                                        const moves = "moveCount" in p ? p.moveCount : segments.length - 1;
                                                        const firstMoveTime = moves > 0 ? (0, $elGuA.bucketToTimeString)(segments[1].startBucket) : null;
                                                        zoneDisplay = `${moves} move${moves !== 1 ? "s" : ""}${firstMoveTime ? ` @ ${firstMoveTime}` : ""}`;
                                                    } else {
                                                        // Single spot placement - assume full dwell
                                                        actualStart = ac.arrivalBucket;
                                                        actualEnd = ac.departureBucket;
                                                        const { spotId: spotId } = p;
                                                        spotDisplay = spotId;
                                                        zoneDisplay = getZoneName(spotId);
                                                    }
                                                    // Check if placement covers full dwell
                                                    const coveragePct = Math.round((actualEnd - actualStart) / (ac.departureBucket - ac.arrivalBucket) * 100);
                                                    const isPartial = coveragePct < 100;
                                                    const actualArrival = (0, $elGuA.bucketToTimeString)(actualStart);
                                                    const actualDeparture = (0, $elGuA.bucketToTimeString)(actualEnd);
                                                    // Calculate how many other aircraft this placement would trap
                                                    // WHY: Users need to see which placements create egress conflicts
                                                    // WHEN: Shows as warning icon in the placement list
                                                    let trapCount = 0;
                                                    if (!isSegmented) {
                                                        const spot = spots.find((s)=>s.id === spotDisplay);
                                                        if (spot) trapCount = (0, $7O8dW.countTrappedAircraft)(ac, spot, placement, aircraft, spots);
                                                    }
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                        "data-testid": "placement-item",
                                                        sx: {
                                                            "&:hover": {
                                                                bgcolor: trapCount > 0 ? "warning.100" : "success.50"
                                                            },
                                                            bgcolor: isPartial ? "warning.50" : trapCount > 0 ? "warning.50" : "transparent"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                sx: {
                                                                    fontFamily: "monospace",
                                                                    fontSize: "0.85rem"
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                    sx: {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 0.5
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                            children: ac.tail_number
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                            title: $07cb3cb81c1595aa$var$formatSizeTooltip(ac.sizeCategory),
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                                label: $07cb3cb81c1595aa$var$formatSizeLabel(ac.sizeCategory),
                                                                                size: "small",
                                                                                sx: {
                                                                                    height: "16px",
                                                                                    fontSize: "0.65rem",
                                                                                    fontWeight: "bold",
                                                                                    bgcolor: "grey.200",
                                                                                    "& .MuiChip-label": {
                                                                                        px: 0.5
                                                                                    }
                                                                                }
                                                                            })
                                                                        }),
                                                                        ac.locks && ac.locks.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                            title: `${ac.locks.length} spot lock${ac.locks.length !== 1 ? "s" : ""}: ${ac.locks.map((l)=>`${l.spotId}${l.reason ? ` (${l.reason})` : ""}`).join(", ")}`,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ewtCw))), {
                                                                                sx: {
                                                                                    fontSize: "0.9rem",
                                                                                    color: "#FF6F00"
                                                                                }
                                                                            })
                                                                        }),
                                                                        isPartial && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                                            component: "span",
                                                                            sx: {
                                                                                ml: 0.5,
                                                                                fontSize: "0.7rem",
                                                                                color: "warning.dark"
                                                                            },
                                                                            children: "\u26A0\uFE0F"
                                                                        }),
                                                                        trapCount > 0 && !isSegmented && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                            title: getTrapWarningText(ac, spots.find((s)=>s.id === spotDisplay), trapCount),
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                                                component: "span",
                                                                                sx: {
                                                                                    ml: 0.5,
                                                                                    fontSize: "0.7rem",
                                                                                    color: "warning.dark"
                                                                                },
                                                                                children: "\u26A0\uFE0F"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                                                sx: {
                                                                    fontFamily: "monospace",
                                                                    fontSize: "0.85rem"
                                                                },
                                                                children: [
                                                                    spotDisplay,
                                                                    !isSegmented && (()=>{
                                                                        const spot = spots.find((s)=>s.id === spotDisplay);
                                                                        if (spot && spot.allowedSizes.length < 5) {
                                                                            const sizeLabels = spot.allowedSizes.map($07cb3cb81c1595aa$var$formatSizeLabel).join(", ");
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                                component: "div",
                                                                                sx: {
                                                                                    fontSize: "0.65rem",
                                                                                    color: "text.secondary"
                                                                                },
                                                                                children: [
                                                                                    "allows: ",
                                                                                    sizeLabels
                                                                                ]
                                                                            });
                                                                        }
                                                                        return null;
                                                                    })()
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                                                sx: {
                                                                    fontSize: "0.85rem"
                                                                },
                                                                children: [
                                                                    zoneDisplay,
                                                                    isPartial && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                        component: "div",
                                                                        sx: {
                                                                            fontSize: "0.7rem",
                                                                            color: "warning.dark"
                                                                        },
                                                                        children: [
                                                                            coveragePct,
                                                                            "% coverage"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                sx: {
                                                                    fontFamily: "monospace",
                                                                    fontSize: "0.75rem",
                                                                    whiteSpace: "nowrap"
                                                                },
                                                                children: isPartial ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                            component: "div",
                                                                            children: [
                                                                                actualArrival,
                                                                                "\u2013",
                                                                                actualDeparture
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                            component: "div",
                                                                            sx: {
                                                                                fontSize: "0.65rem",
                                                                                color: "text.secondary"
                                                                            },
                                                                            children: [
                                                                                "(req: ",
                                                                                requestedArrival,
                                                                                "\u2013",
                                                                                requestedDeparture,
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }) : `${actualArrival}\u{2013}${actualDeparture}`
                                                            })
                                                        ]
                                                    }, ac.id);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    unplacedAircraft.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                        item: true,
                        xs: 12,
                        md: placedAircraft.length > 0 ? 5 : 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "subtitle2",
                                    color: "error",
                                    gutterBottom: true,
                                    children: [
                                        "Unplaced (",
                                        unplacedAircraft.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                                        size: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            sx: {
                                                                fontWeight: "bold",
                                                                fontSize: "0.75rem"
                                                            },
                                                            children: "Tail"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                            sx: {
                                                                fontWeight: "bold",
                                                                fontSize: "0.75rem"
                                                            },
                                                            children: "Time"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                                children: unplacedAircraft.map((ac)=>{
                                                    const arrivalTime = (0, $elGuA.bucketToTimeString)(ac.arrivalBucket);
                                                    const departureTime = (0, $elGuA.bucketToTimeString)(ac.departureBucket);
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                                        sx: {
                                                            "&:hover": {
                                                                bgcolor: "error.100"
                                                            },
                                                            bgcolor: "error.50"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                                sx: {
                                                                    fontFamily: "monospace",
                                                                    fontSize: "0.85rem"
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                    sx: {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 0.5
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                            children: ac.tail_number
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                            title: $07cb3cb81c1595aa$var$formatSizeTooltip(ac.sizeCategory),
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                                label: $07cb3cb81c1595aa$var$formatSizeLabel(ac.sizeCategory),
                                                                                size: "small",
                                                                                sx: {
                                                                                    height: "16px",
                                                                                    fontSize: "0.65rem",
                                                                                    fontWeight: "bold",
                                                                                    bgcolor: "grey.200",
                                                                                    "& .MuiChip-label": {
                                                                                        px: 0.5
                                                                                    }
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                                                                sx: {
                                                                    fontFamily: "monospace",
                                                                    fontSize: "0.75rem",
                                                                    whiteSpace: "nowrap"
                                                                },
                                                                children: [
                                                                    arrivalTime,
                                                                    "\u2013",
                                                                    departureTime
                                                                ]
                                                            })
                                                        ]
                                                    }, ac.id);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



var $bXsOq = parcelRequire("bXsOq");

var $7O8dW = parcelRequire("7O8dW");

var $ad1qL = parcelRequire("ad1qL");

var $aDzfS = parcelRequire("aDzfS");

var $ixuXj = parcelRequire("ixuXj");
/**
 * Test Data for Temporal Parking
 * Multiple test scenarios for validating algorithm behavior
 */ 
var $elGuA = parcelRequire("elGuA");
/**
 * Create minimal test Shape for a spot
 * Used to provide required shape field for test data
 */ function $514609d279b59bb0$var$createMinimalShape(id) {
    return {
        id: id,
        fbo_id: "test-fbo",
        ramp_id: "test-ramp",
        tags: [],
        points: [
            {
                x: 0,
                y: 0
            },
            {
                x: 100,
                y: 0
            },
            {
                x: 100,
                y: 100
            },
            {
                x: 0,
                y: 100
            }
        ],
        type: "Spot",
        locked: false,
        reference_points: [
            {
                name: "center",
                validOrientations: [
                    "nose_to_line"
                ]
            }
        ]
    };
}
const $514609d279b59bb0$export$d91ea7bf94524911 = {
    id: "nose_in",
    label: "Nose In"
};
// MINIMAL: 2 spots (for testing forced splits with absolute minimum capacity)
const $514609d279b59bb0$var$LAYOUT_MINIMAL = {
    zones: [
        {
            id: "A",
            name: "Row A",
            spotIds: [
                "A01",
                "A02"
            ]
        }
    ],
    spots: [
        {
            id: "A01",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A02"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A01")
        },
        {
            id: "A02",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "small",
                "midsize"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A02")
        }
    ]
};
// SMALL: 5 spots (for basic capacity testing)
const $514609d279b59bb0$var$LAYOUT_SMALL = {
    zones: [
        {
            id: "A",
            name: "Row A",
            spotIds: [
                "A01",
                "A02",
                "A03"
            ]
        },
        {
            id: "B",
            name: "Row B",
            spotIds: [
                "B01",
                "B02"
            ]
        }
    ],
    spots: [
        {
            id: "A01",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A02",
                        "A03"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A01")
        },
        {
            id: "A02",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A03"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A02")
        },
        {
            id: "A03",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A03")
        },
        {
            id: "B01",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "B02"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B01")
        },
        {
            id: "B02",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B02")
        }
    ]
};
// SIZE_CONSTRAINED: 5 spots with heterogeneous size restrictions (for testing Local Repair with size categories)
const $514609d279b59bb0$var$LAYOUT_SIZE_CONSTRAINED = {
    zones: [
        {
            id: "A",
            name: "Row A",
            spotIds: [
                "A01",
                "A02",
                "A03"
            ]
        },
        {
            id: "B",
            name: "Row B",
            spotIds: [
                "B01",
                "B02"
            ]
        }
    ],
    spots: [
        {
            id: "A01",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "small",
                "midsize"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A02",
                        "A03"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A01")
        },
        {
            id: "A02",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "small",
                "midsize"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A03"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A02")
        },
        {
            id: "A03",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A03")
        },
        {
            id: "B01",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "B02"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B01")
        },
        {
            id: "B02",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B02")
        }
    ]
};
// MEDIUM: 7 spots (for moderate complexity scenarios)
const $514609d279b59bb0$var$LAYOUT_MEDIUM = {
    zones: [
        {
            id: "A",
            name: "Row A",
            spotIds: [
                "A01",
                "A02",
                "A03",
                "A04"
            ]
        },
        {
            id: "B",
            name: "Row B",
            spotIds: [
                "B01",
                "B02",
                "B03"
            ]
        }
    ],
    spots: [
        {
            id: "A01",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A02",
                        "A03",
                        "A04"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A01")
        },
        {
            id: "A02",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A03",
                        "A04"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A02")
        },
        {
            id: "A03",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A04"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A03")
        },
        {
            id: "A04",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A04")
        },
        {
            id: "B01",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "B02",
                        "B03"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B01")
        },
        {
            id: "B02",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "B03"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B02")
        },
        {
            id: "B03",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B03")
        }
    ]
};
// TEB: 24 spots (realistic large FBO layout)
const $514609d279b59bb0$var$LAYOUT_TEB = {
    zones: [
        {
            id: "A",
            name: "North Row",
            spotIds: [
                "A01",
                "A02",
                "A03",
                "A04",
                "A05",
                "A06"
            ]
        },
        {
            id: "B",
            name: "Middle-North Row",
            spotIds: [
                "B01",
                "B02",
                "B03",
                "B04",
                "B05",
                "B06"
            ]
        },
        {
            id: "C",
            name: "Middle-South Row",
            spotIds: [
                "C01",
                "C02",
                "C03",
                "C04",
                "C05",
                "C06"
            ]
        },
        {
            id: "D",
            name: "South Row",
            spotIds: [
                "D01",
                "D02",
                "D03",
                "D04",
                "D05",
                "D06"
            ]
        }
    ],
    spots: [
        // North Row (A) - Uses Lane 1 - A01 blocks A02-A06, A02 blocks A03-A06, etc.
        {
            id: "A01",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A02",
                        "A03",
                        "A04",
                        "A05",
                        "A06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A01")
        },
        {
            id: "A02",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A03",
                        "A04",
                        "A05",
                        "A06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A02")
        },
        {
            id: "A03",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A04",
                        "A05",
                        "A06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A03")
        },
        {
            id: "A04",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A05",
                        "A06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A04")
        },
        {
            id: "A05",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "A06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A05")
        },
        {
            id: "A06",
            zoneId: "A",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("A06")
        },
        // Middle-North Row (B) - Uses Lane 1 or Lane 2
        {
            id: "B01",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "B02",
                        "B03",
                        "B04",
                        "B05",
                        "B06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B01")
        },
        {
            id: "B02",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "B03",
                        "B04",
                        "B05",
                        "B06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B02")
        },
        {
            id: "B03",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: [
                        "B04",
                        "B05",
                        "B06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B03")
        },
        {
            id: "B04",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "B05",
                        "B06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B04")
        },
        {
            id: "B05",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "B06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B05")
        },
        {
            id: "B06",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B06")
        },
        // Middle-South Row (C) - Uses Lane 2
        {
            id: "C01",
            zoneId: "C",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "C02",
                        "C03",
                        "C04",
                        "C05",
                        "C06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("C01")
        },
        {
            id: "C02",
            zoneId: "C",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "C03",
                        "C04",
                        "C05",
                        "C06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("C02")
        },
        {
            id: "C03",
            zoneId: "C",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "C04",
                        "C05",
                        "C06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("C03")
        },
        {
            id: "C04",
            zoneId: "C",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "C05",
                        "C06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("C04")
        },
        {
            id: "C05",
            zoneId: "C",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: [
                        "C06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("C05")
        },
        {
            id: "C06",
            zoneId: "C",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_2",
                    laneName: "Lane 2",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("C06")
        },
        // South Row (D) - Uses Lane 3
        {
            id: "D01",
            zoneId: "D",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_3",
                    laneName: "Lane 3",
                    blocksSpotIds: [
                        "D02",
                        "D03",
                        "D04",
                        "D05",
                        "D06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("D01")
        },
        {
            id: "D02",
            zoneId: "D",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_3",
                    laneName: "Lane 3",
                    blocksSpotIds: [
                        "D03",
                        "D04",
                        "D05",
                        "D06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("D02")
        },
        {
            id: "D03",
            zoneId: "D",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_3",
                    laneName: "Lane 3",
                    blocksSpotIds: [
                        "D04",
                        "D05",
                        "D06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("D03")
        },
        {
            id: "D04",
            zoneId: "D",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_3",
                    laneName: "Lane 3",
                    blocksSpotIds: [
                        "D05",
                        "D06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("D04")
        },
        {
            id: "D05",
            zoneId: "D",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_3",
                    laneName: "Lane 3",
                    blocksSpotIds: [
                        "D06"
                    ]
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("D05")
        },
        {
            id: "D06",
            zoneId: "D",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small",
                "midsize",
                "super-midsize",
                "large"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_3",
                    laneName: "Lane 3",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("D06")
        }
    ]
};
// GAP_DEMO: 3 spots demonstrating gap spot behavior
// B01 and B02 are large spots side-by-side
// B06 is a small gap spot between them (Phase 2a - just the flag, no dependencies yet)
const $514609d279b59bb0$var$LAYOUT_GAP_DEMO = {
    zones: [
        {
            id: "B",
            name: "Row B",
            spotIds: [
                "B01",
                "B02",
                "B06"
            ]
        }
    ],
    spots: [
        // Regular large spots (side by side)
        {
            id: "B01",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "large",
                "super-midsize"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B01")
        },
        {
            id: "B02",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "large",
                "super-midsize"
            ],
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: []
                }
            ],
            shape: $514609d279b59bb0$var$createMinimalShape("B02")
        },
        // Gap spot - Phase 2c/2d: with requiresOccupiedSpots
        // Small aircraft can fit in the space between two large aircraft
        // Only available when BOTH B01 and B02 are occupied
        {
            id: "B06",
            zoneId: "B",
            orientations: [
                $514609d279b59bb0$export$d91ea7bf94524911
            ],
            allowedSizes: [
                "very-small",
                "small"
            ],
            // Only small aircraft fit
            occupancy: (0, $elGuA.makeEmptyMask)(),
            egressOptions: [
                {
                    laneId: "lane_1",
                    laneName: "Lane 1",
                    blocksSpotIds: []
                }
            ],
            isGapSpot: true,
            // Gap spot flag (Phase 2a)
            requiresOccupiedSpots: [
                "B01",
                "B02"
            ],
            // Required spots (Phase 2c/2d)
            shape: $514609d279b59bb0$var$createMinimalShape("B06")
        }
    ]
};
const $514609d279b59bb0$var$LAYOUTS = {
    minimal: $514609d279b59bb0$var$LAYOUT_MINIMAL,
    small: $514609d279b59bb0$var$LAYOUT_SMALL,
    "size-constrained": $514609d279b59bb0$var$LAYOUT_SIZE_CONSTRAINED,
    medium: $514609d279b59bb0$var$LAYOUT_MEDIUM,
    teb: $514609d279b59bb0$var$LAYOUT_TEB,
    "gap-demo": $514609d279b59bb0$var$LAYOUT_GAP_DEMO
};
// ==== Test Scenarios ====
// Defined with human-readable time strings, converted to buckets at runtime
const $514609d279b59bb0$var$TEST_SCENARIO_DEFINITIONS = [
    {
        id: "basic",
        name: "Basic - Balanced Load",
        description: "5 aircraft, 5 spots. All should fit comfortably with good distribution.",
        rampLayout: "small",
        aircraft: [
            {
                id: "ac1",
                tailNumber: "N650GL",
                sizeCategory: "small",
                arrival: "00:00",
                departure: "04:40"
            },
            {
                id: "ac2",
                tailNumber: "N88GX",
                sizeCategory: "small",
                arrival: "00:20",
                departure: "09:55"
            },
            {
                id: "ac3",
                tailNumber: "N7XXF",
                sizeCategory: "small",
                arrival: "00:30",
                departure: "16:00"
            },
            {
                id: "ac4",
                tailNumber: "N345QS",
                sizeCategory: "small",
                arrival: "00:45",
                departure: "02:25"
            },
            {
                id: "ac5",
                tailNumber: "N23PC",
                sizeCategory: "small",
                arrival: "01:10",
                departure: "07:00"
            }
        ],
        expectedPlaced: 5,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "oversubscribed",
        name: "Oversubscribed - Capacity Exceeded",
        description: "8 aircraft, 5 spots with overlapping times. Tests unplaced aircraft handling.",
        rampLayout: "small",
        aircraft: [
            {
                id: "ac1",
                tailNumber: "N101",
                sizeCategory: "small",
                arrival: "00:00",
                departure: "09:00"
            },
            {
                id: "ac2",
                tailNumber: "N102",
                sizeCategory: "small",
                arrival: "00:15",
                departure: "08:45"
            },
            {
                id: "ac3",
                tailNumber: "N103",
                sizeCategory: "small",
                arrival: "00:30",
                departure: "08:30"
            },
            {
                id: "ac4",
                tailNumber: "N104",
                sizeCategory: "small",
                arrival: "00:45",
                departure: "08:15"
            },
            {
                id: "ac5",
                tailNumber: "N105",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "08:00"
            },
            {
                id: "ac6",
                tailNumber: "N106",
                sizeCategory: "small",
                arrival: "01:15",
                departure: "07:45"
            },
            {
                id: "ac7",
                tailNumber: "N107",
                sizeCategory: "small",
                arrival: "01:30",
                departure: "07:30"
            },
            {
                id: "ac8",
                tailNumber: "N108",
                sizeCategory: "small",
                arrival: "01:45",
                departure: "07:15"
            }
        ],
        expectedPlaced: 5,
        expectedUnplaced: 3,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "size-constrained",
        name: "Size-Constrained Shuffle",
        description: "6 aircraft (2 large + 1 super-midsize) competing for 2 B-row spots (B01=large-only, B02=flex). Shows importance of sorting strategy. Capacity constraint: impossible to place all 6 (3 aircraft need 2 spots).",
        rampLayout: "size-constrained",
        aircraft: [
            {
                id: "ac1",
                tailNumber: "N100",
                sizeCategory: "large",
                arrival: "08:00",
                departure: "16:00"
            },
            {
                id: "ac2",
                tailNumber: "N200",
                sizeCategory: "small",
                arrival: "08:15",
                departure: "12:00"
            },
            {
                id: "ac3",
                tailNumber: "N300",
                sizeCategory: "midsize",
                arrival: "08:30",
                departure: "14:00"
            },
            {
                id: "ac4",
                tailNumber: "N400",
                sizeCategory: "super-midsize",
                arrival: "09:00",
                departure: "17:00"
            },
            {
                id: "ac5",
                tailNumber: "N500",
                sizeCategory: "small",
                arrival: "10:00",
                departure: "15:00"
            },
            {
                id: "ac6",
                tailNumber: "N600",
                sizeCategory: "large",
                arrival: "11:00",
                departure: "18:00"
            }
        ],
        expectedPlaced: 5,
        // Maximum possible: N100+N400 need B01/B02, but 3 aircraft (N100, N400, N600) compete for 2 spots
        expectedUnplaced: 1,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "waste-demo",
        name: "Waste Demo - Size Mismatch",
        description: "Demonstrates waste scoring with mixed sizes competing for limited spots. With waste disabled, small aircraft may grab premium large spots early, leaving large aircraft stranded. With waste high/very high, small aircraft avoid oversized spots, saving capacity for aircraft that need it.",
        rampLayout: "size-constrained",
        aircraft: [
            // Large aircraft arrives first - NEEDS B01 or B02 (only spots that fit large)
            {
                id: "ac1",
                tailNumber: "N700L",
                sizeCategory: "large",
                arrival: "08:00",
                departure: "16:00"
            },
            // Small aircraft arrive early - CAN fit B01/B02 but waste space (waste=3)
            {
                id: "ac2",
                tailNumber: "N701S",
                sizeCategory: "small",
                arrival: "08:05",
                departure: "12:00"
            },
            {
                id: "ac3",
                tailNumber: "N702S",
                sizeCategory: "small",
                arrival: "08:10",
                departure: "13:00"
            },
            // Very-small arrives - best fit is A03 (waste=0), okay fit A01/A02 (waste=1)
            {
                id: "ac4",
                tailNumber: "N703VS",
                sizeCategory: "very-small",
                arrival: "08:15",
                departure: "11:00"
            },
            // Midsize arrives - fits A01/A02 (waste=0), or B02 (waste=1)
            {
                id: "ac5",
                tailNumber: "N704M",
                sizeCategory: "midsize",
                arrival: "08:20",
                departure: "14:00"
            }
        ],
        expectedPlaced: 5,
        // All should fit with smart placement
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "longterm",
        name: "Long-term Parkers - Overnight Mix",
        description: "7 aircraft on 7 spots. 3 long parkers + 4 quick turns. Tests gap filling between long dwells.",
        rampLayout: "medium",
        aircraft: [
            // Long-term parkers
            {
                id: "ac1",
                tailNumber: "N401L",
                sizeCategory: "small",
                arrival: "00:00",
                departure: "14:00"
            },
            {
                id: "ac2",
                tailNumber: "N402L",
                sizeCategory: "small",
                arrival: "00:30",
                departure: "14:30"
            },
            {
                id: "ac3",
                tailNumber: "N403L",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "15:00"
            },
            // Quick turns
            {
                id: "ac4",
                tailNumber: "N404Q",
                sizeCategory: "small",
                arrival: "02:00",
                departure: "03:30"
            },
            {
                id: "ac5",
                tailNumber: "N405Q",
                sizeCategory: "small",
                arrival: "04:00",
                departure: "05:30"
            },
            {
                id: "ac6",
                tailNumber: "N406Q",
                sizeCategory: "small",
                arrival: "07:00",
                departure: "08:30"
            },
            {
                id: "ac7",
                tailNumber: "N407Q",
                sizeCategory: "small",
                arrival: "10:00",
                departure: "11:30"
            }
        ],
        expectedPlaced: 7,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "buffer-sequential",
        name: "Sequential Reuse - Buffer Gap Test",
        description: "6 aircraft on 7 spots with 2-hour dwells and exact handoffs. With 0 buffer all share 1 spot; with 15min buffer they overlap and need multiple spots. Watch the timeline for gaps!",
        rampLayout: "medium",
        aircraft: [
            // Perfect 2-hour sequential blocks - no buffer = perfect reuse
            {
                id: "ac1",
                tailNumber: "N601",
                sizeCategory: "small",
                arrival: "00:00",
                departure: "02:00"
            },
            {
                id: "ac2",
                tailNumber: "N602",
                sizeCategory: "small",
                arrival: "02:00",
                departure: "04:00"
            },
            {
                id: "ac3",
                tailNumber: "N603",
                sizeCategory: "small",
                arrival: "04:00",
                departure: "06:00"
            },
            {
                id: "ac4",
                tailNumber: "N604",
                sizeCategory: "small",
                arrival: "06:00",
                departure: "08:00"
            },
            {
                id: "ac5",
                tailNumber: "N605",
                sizeCategory: "small",
                arrival: "08:00",
                departure: "10:00"
            },
            {
                id: "ac6",
                tailNumber: "N606",
                sizeCategory: "small",
                arrival: "10:00",
                departure: "12:00"
            }
        ],
        // With 0 buffer: all 6 fit in 1 spot (perfect sequential reuse)
        // With 15min buffer: buffer creates overlaps, need 2-3 spots
        expectedPlaced: 6,
        // all fit, but spread across multiple spots with buffer
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "buffer-capacity",
        name: "Capacity Reduction - Buffer Test",
        description: "8 aircraft on 5 spots arriving in 1-hour rush, all leaving 9 hours later. Buffer reduces effective capacity. Watch unplaced count increase with buffer!",
        rampLayout: "small",
        aircraft: [
            // All arrive 00:00-01:00, all depart 09:00-10:00
            // With 0 buffer: arrival times don't overlap much, 5 fit
            // With 15min+ buffer: arrival buffers overlap heavily, fewer fit
            {
                id: "ac1",
                tailNumber: "N611",
                sizeCategory: "small",
                arrival: "00:00",
                departure: "09:00"
            },
            {
                id: "ac2",
                tailNumber: "N612",
                sizeCategory: "small",
                arrival: "00:10",
                departure: "09:10"
            },
            {
                id: "ac3",
                tailNumber: "N613",
                sizeCategory: "small",
                arrival: "00:20",
                departure: "09:20"
            },
            {
                id: "ac4",
                tailNumber: "N614",
                sizeCategory: "small",
                arrival: "00:30",
                departure: "09:30"
            },
            {
                id: "ac5",
                tailNumber: "N615",
                sizeCategory: "small",
                arrival: "00:40",
                departure: "09:40"
            },
            {
                id: "ac6",
                tailNumber: "N616",
                sizeCategory: "small",
                arrival: "00:50",
                departure: "09:50"
            },
            {
                id: "ac7",
                tailNumber: "N617",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "10:00"
            },
            {
                id: "ac8",
                tailNumber: "N618",
                sizeCategory: "small",
                arrival: "01:10",
                departure: "10:10"
            }
        ],
        // With 0 buffer: 5 placed (fills all spots)
        // With 15min buffer: 5 placed (but arrival window overlaps more)
        expectedPlaced: 5,
        expectedUnplaced: 3,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "split-required",
        name: "Skip-Ahead Demonstration",
        description: "6 aircraft on 5 spots. Last aircraft arrives at 02:00 when all spots occupied, algorithm skips ahead to 04:00 (delayed placement). **Use 0 buffer, Allow 1 Move**.",
        rampLayout: "small",
        aircraft: [
            // First 3: 01:00-07:00 (occupy 3 spots fully)
            {
                id: "ac1",
                tailNumber: "N701",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "07:00"
            },
            {
                id: "ac2",
                tailNumber: "N702",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "07:00"
            },
            {
                id: "ac3",
                tailNumber: "N703",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "07:00"
            },
            // 4th: 01:00-04:00 (occupies spot for morning only)
            {
                id: "ac4",
                tailNumber: "N704",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "04:00"
            },
            // 5th: 01:00-04:00 (occupies last spot for morning)
            {
                id: "ac5",
                tailNumber: "N705",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "04:00"
            },
            // 6th: 02:00-07:00 - arrives when all spots occupied, demonstrates skip-ahead
            {
                id: "ac6",
                tailNumber: "N706",
                sizeCategory: "small",
                arrival: "02:00",
                departure: "07:00"
            }
        ],
        expectedPlaced: 6,
        // With plannedMoveCap >= 0, N706 gets delayed placement
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "multi-spot-split",
        name: "Multi-Spot Attempt",
        description: "7 aircraft on 7 spots. Attempts to force multi-spot split. Greedy algorithm may still find single-spot placement. **Use 15min buffer, Allow 1 Move**.",
        rampLayout: "medium",
        aircraft: [
            // Fill A01/A02/A03 all day
            {
                id: "ac1",
                tailNumber: "N801",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "09:00"
            },
            {
                id: "ac2",
                tailNumber: "N802",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "09:00"
            },
            {
                id: "ac3",
                tailNumber: "N803",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "09:00"
            },
            // B01: Morning until 06:00
            {
                id: "ac4",
                tailNumber: "N804",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "06:00"
            },
            // B02: Morning until 04:00
            {
                id: "ac5",
                tailNumber: "N805",
                sizeCategory: "small",
                arrival: "01:00",
                departure: "04:00"
            },
            // B02: Afternoon from 06:30 (leaves gap with buffer)
            {
                id: "ac6",
                tailNumber: "N806",
                sizeCategory: "small",
                arrival: "06:30",
                departure: "09:00"
            },
            // Last: 04:00-09:00, may split or find single spot
            {
                id: "ac7",
                tailNumber: "N807",
                sizeCategory: "small",
                arrival: "04:00",
                departure: "09:00"
            }
        ],
        expectedPlaced: 7,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "minimal-split",
        name: "Minimal 2-Spot Split Attempt",
        description: "3 aircraft on 2 spots. Attempts to force multi-spot split with absolute minimum capacity. **Use 0 buffer, Allow 1 Move**. Note: Greedy algorithm may still find single-spot solutions depending on placement order.",
        rampLayout: "minimal",
        aircraft: [
            // Design intent: Create complementary gaps in A01 and A02 that force N903 to split
            // A01 blocked late (03:00-06:00), A02 blocked early (00:00-02:00)
            // N903 needs 00:00-06:00, theoretically requiring A01(00-03) → A02(03-06)
            // Block A01 from 03:00-06:00
            {
                id: "ac1",
                tailNumber: "N901",
                sizeCategory: "small",
                arrival: "03:00",
                departure: "06:00"
            },
            // Block A02 from 00:00-02:00
            {
                id: "ac2",
                tailNumber: "N902",
                sizeCategory: "small",
                arrival: "00:00",
                departure: "02:00"
            },
            // Target: needs 00:00-06:00
            // Theory: Must split across A01(00-03) → A02(03-06) with 1 move at 03:00
            // Reality: Greedy placement order may allow single-spot placement if N903 claims
            //          a spot before the blocking aircraft reserve their windows
            {
                id: "ac3",
                tailNumber: "N903",
                sizeCategory: "small",
                arrival: "00:00",
                departure: "06:00"
            }
        ],
        expectedPlaced: 3,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "busy-friday",
        name: "Busy Friday - Large Scale",
        description: "Realistic busy Friday scenario with 15 aircraft on 7 spots. Mix of long-dwell heavies and quick transient turns. **Use 15min buffer, Allow 1 Move**.",
        rampLayout: "medium",
        aircraft: [
            // Morning rush - Long dwells (heavies staying most of day)
            {
                id: "ac1",
                tailNumber: "N650GL",
                sizeCategory: "small",
                arrival: "07:50",
                departure: "12:30"
            },
            {
                id: "ac2",
                tailNumber: "N88GX",
                sizeCategory: "small",
                arrival: "08:10",
                departure: "17:45"
            },
            {
                id: "ac3",
                tailNumber: "N7XXF",
                sizeCategory: "small",
                arrival: "08:30",
                departure: "16:00"
            },
            // Mid-morning - Quick turns
            {
                id: "ac4",
                tailNumber: "N345QS",
                sizeCategory: "small",
                arrival: "09:45",
                departure: "11:25"
            },
            {
                id: "ac5",
                tailNumber: "N23PC",
                sizeCategory: "small",
                arrival: "10:10",
                departure: "14:00"
            },
            // Lunch rush - More long dwells
            {
                id: "ac6",
                tailNumber: "N501ZR",
                sizeCategory: "small",
                arrival: "11:30",
                departure: "19:15"
            },
            {
                id: "ac7",
                tailNumber: "N678PH",
                sizeCategory: "small",
                arrival: "12:00",
                departure: "18:30"
            },
            // Afternoon - Mixed
            {
                id: "ac8",
                tailNumber: "N42TF",
                sizeCategory: "small",
                arrival: "13:15",
                departure: "15:45"
            },
            {
                id: "ac9",
                tailNumber: "N890LX",
                sizeCategory: "small",
                arrival: "14:20",
                departure: "20:00"
            },
            {
                id: "ac10",
                tailNumber: "N111SK",
                sizeCategory: "small",
                arrival: "15:00",
                departure: "17:30"
            },
            // Evening rush - Overnight parkers
            {
                id: "ac11",
                tailNumber: "N222FJ",
                sizeCategory: "small",
                arrival: "16:45",
                departure: "23:00"
            },
            {
                id: "ac12",
                tailNumber: "N333GT",
                sizeCategory: "small",
                arrival: "17:30",
                departure: "22:15"
            },
            {
                id: "ac13",
                tailNumber: "N444BR",
                sizeCategory: "small",
                arrival: "18:00",
                departure: "21:45"
            },
            // Late evening
            {
                id: "ac14",
                tailNumber: "N555CX",
                sizeCategory: "small",
                arrival: "19:30",
                departure: "23:45"
            },
            {
                id: "ac15",
                tailNumber: "N666MV",
                sizeCategory: "small",
                arrival: "20:15",
                departure: "23:30"
            }
        ],
        // With 15min buffer and 24 spots, all aircraft should easily fit
        expectedPlaced: 15,
        expectedUnplaced: 0,
        startTime: "06:00",
        horizonHours: 18
    },
    {
        id: "teb-schedule",
        name: "TEB Schedule - Real Data (36 Aircraft)",
        description: "Real-world schedule from Teterboro (TEB) on 09/24/2025, 06:00-22:00. ALL 36 aircraft with actual arrival/departure times on 24 spots (4 rows \xd7 6). **Use 15min buffer, Allow 1 Move**.",
        rampLayout: "teb",
        aircraft: [
            // Data source: plans/schedule-teb.txt
            // Time window: 09/24/2025 06:00 - 22:00 (16 hour operational window)
            // Times relative to 06:00 start
            {
                id: "ac1",
                tailNumber: "N132QS",
                sizeCategory: "small",
                arrival: "06:48",
                departure: "11:00"
            },
            {
                id: "ac2",
                tailNumber: "N822QS",
                sizeCategory: "small",
                arrival: "07:06",
                departure: "09:00"
            },
            {
                id: "ac3",
                tailNumber: "N682QS",
                sizeCategory: "small",
                arrival: "07:33",
                departure: "10:48"
            },
            {
                id: "ac4",
                tailNumber: "N697QS",
                sizeCategory: "small",
                arrival: "09:24",
                departure: "10:30"
            },
            {
                id: "ac5",
                tailNumber: "N478QS",
                sizeCategory: "small",
                arrival: "09:33",
                departure: "16:00"
            },
            {
                id: "ac6",
                tailNumber: "N523QS",
                sizeCategory: "small",
                arrival: "09:48",
                departure: "11:00"
            },
            {
                id: "ac7",
                tailNumber: "N839QS",
                sizeCategory: "small",
                arrival: "10:09",
                departure: "15:09"
            },
            {
                id: "ac8",
                tailNumber: "N791QS",
                sizeCategory: "small",
                arrival: "10:18",
                departure: "11:18"
            },
            {
                id: "ac9",
                tailNumber: "N336QS",
                sizeCategory: "small",
                arrival: "11:09",
                departure: "17:09"
            },
            {
                id: "ac10",
                tailNumber: "N866QS",
                sizeCategory: "small",
                arrival: "11:18",
                departure: "16:00"
            },
            {
                id: "ac11",
                tailNumber: "N313QS",
                sizeCategory: "small",
                arrival: "11:30",
                departure: "12:30"
            },
            {
                id: "ac12",
                tailNumber: "N957QS",
                sizeCategory: "small",
                arrival: "11:30",
                departure: "13:09"
            },
            {
                id: "ac13",
                tailNumber: "N525QS",
                sizeCategory: "small",
                arrival: "11:48",
                departure: "15:45"
            },
            {
                id: "ac14",
                tailNumber: "N881QS",
                sizeCategory: "small",
                arrival: "12:48",
                departure: "13:48"
            },
            {
                id: "ac15",
                tailNumber: "N91GV",
                sizeCategory: "small",
                arrival: "13:00",
                departure: "14:00"
            },
            {
                id: "ac16",
                tailNumber: "N922QS",
                sizeCategory: "small",
                arrival: "13:06",
                departure: "15:30"
            },
            {
                id: "ac17",
                tailNumber: "N835QS",
                sizeCategory: "small",
                arrival: "13:33",
                departure: "15:00"
            },
            {
                id: "ac18",
                tailNumber: "N972QS",
                sizeCategory: "small",
                arrival: "13:54",
                departure: "14:54"
            },
            {
                id: "ac19",
                tailNumber: "N856QS",
                sizeCategory: "small",
                arrival: "14:36",
                departure: "18:00"
            },
            {
                id: "ac20",
                tailNumber: "N791QS",
                sizeCategory: "small",
                arrival: "14:48",
                departure: "17:00"
            },
            {
                id: "ac21",
                tailNumber: "N677QS",
                sizeCategory: "small",
                arrival: "15:09",
                departure: "17:00"
            },
            {
                id: "ac22",
                tailNumber: "N731QS",
                sizeCategory: "small",
                arrival: "15:54",
                departure: "19:30"
            },
            {
                id: "ac23",
                tailNumber: "N604QS",
                sizeCategory: "small",
                arrival: "15:57",
                departure: "21:09"
            },
            {
                id: "ac24",
                tailNumber: "N410LG",
                sizeCategory: "small",
                arrival: "16:03",
                departure: "17:03"
            },
            {
                id: "ac25",
                tailNumber: "N189QS",
                sizeCategory: "small",
                arrival: "16:21",
                departure: "19:00"
            },
            {
                id: "ac26",
                tailNumber: "N348QS",
                sizeCategory: "small",
                arrival: "16:24",
                departure: "20:09"
            },
            {
                id: "ac27",
                tailNumber: "N755QS",
                sizeCategory: "small",
                arrival: "16:42",
                departure: "17:00"
            },
            {
                id: "ac28",
                tailNumber: "N750QS",
                sizeCategory: "small",
                arrival: "17:09",
                departure: "18:17"
            },
            {
                id: "ac29",
                tailNumber: "N905QS",
                sizeCategory: "small",
                arrival: "17:18",
                departure: "18:18"
            },
            {
                id: "ac30",
                tailNumber: "N635QS",
                sizeCategory: "small",
                arrival: "17:36",
                departure: "19:00"
            },
            {
                id: "ac31",
                tailNumber: "N871QS",
                sizeCategory: "small",
                arrival: "18:12",
                departure: "21:40"
            },
            {
                id: "ac32",
                tailNumber: "N570QS",
                sizeCategory: "small",
                arrival: "18:18",
                departure: "18:48"
            },
            {
                id: "ac33",
                tailNumber: "N512QS",
                sizeCategory: "small",
                arrival: "18:18",
                departure: "19:18"
            },
            {
                id: "ac34",
                tailNumber: "N373QS",
                sizeCategory: "small",
                arrival: "18:54",
                departure: "21:00"
            },
            {
                id: "ac35",
                tailNumber: "N514QS",
                sizeCategory: "small",
                arrival: "19:18",
                departure: "22:00"
            },
            {
                id: "ac36",
                tailNumber: "N160QS",
                sizeCategory: "small",
                arrival: "20:15",
                departure: "21:15"
            }
        ],
        // With 24 spots (TEB-realistic layout) and 36 aircraft with overlapping dwells, expect most to fit
        // Peak periods may still have 12-15 aircraft on ground simultaneously
        expectedPlaced: 32,
        expectedUnplaced: 4,
        startTime: "06:00",
        horizonHours: 16
    },
    {
        id: "teb-2x",
        name: "TEB 2x - Stress Test (72 Aircraft)",
        description: "Extreme stress test: TEB schedule duplicated with slight offsets. 72 aircraft competing for 24 spots. Expect heavy segmentation and unplaced aircraft. **Use 15min buffer, Allow 1-2 Moves**.",
        rampLayout: "teb",
        aircraft: [
            // Original TEB schedule (36 aircraft)
            {
                id: "ac1",
                tailNumber: "N132QS",
                sizeCategory: "small",
                arrival: "06:48",
                departure: "11:00"
            },
            {
                id: "ac2",
                tailNumber: "N822QS",
                sizeCategory: "small",
                arrival: "07:06",
                departure: "09:00"
            },
            {
                id: "ac3",
                tailNumber: "N682QS",
                sizeCategory: "small",
                arrival: "07:33",
                departure: "10:48"
            },
            {
                id: "ac4",
                tailNumber: "N697QS",
                sizeCategory: "small",
                arrival: "09:24",
                departure: "10:30"
            },
            {
                id: "ac5",
                tailNumber: "N478QS",
                sizeCategory: "small",
                arrival: "09:33",
                departure: "16:00"
            },
            {
                id: "ac6",
                tailNumber: "N523QS",
                sizeCategory: "small",
                arrival: "09:48",
                departure: "11:00"
            },
            {
                id: "ac7",
                tailNumber: "N839QS",
                sizeCategory: "small",
                arrival: "10:09",
                departure: "15:09"
            },
            {
                id: "ac8",
                tailNumber: "N791QS",
                sizeCategory: "small",
                arrival: "10:18",
                departure: "11:18"
            },
            {
                id: "ac9",
                tailNumber: "N336QS",
                sizeCategory: "small",
                arrival: "11:09",
                departure: "17:09"
            },
            {
                id: "ac10",
                tailNumber: "N866QS",
                sizeCategory: "small",
                arrival: "11:18",
                departure: "16:00"
            },
            {
                id: "ac11",
                tailNumber: "N313QS",
                sizeCategory: "small",
                arrival: "11:30",
                departure: "12:30"
            },
            {
                id: "ac12",
                tailNumber: "N957QS",
                sizeCategory: "small",
                arrival: "11:30",
                departure: "13:09"
            },
            {
                id: "ac13",
                tailNumber: "N525QS",
                sizeCategory: "small",
                arrival: "11:48",
                departure: "15:45"
            },
            {
                id: "ac14",
                tailNumber: "N881QS",
                sizeCategory: "small",
                arrival: "12:48",
                departure: "13:48"
            },
            {
                id: "ac15",
                tailNumber: "N91GV",
                sizeCategory: "small",
                arrival: "13:00",
                departure: "14:00"
            },
            {
                id: "ac16",
                tailNumber: "N922QS",
                sizeCategory: "small",
                arrival: "13:06",
                departure: "15:30"
            },
            {
                id: "ac17",
                tailNumber: "N835QS",
                sizeCategory: "small",
                arrival: "13:33",
                departure: "15:00"
            },
            {
                id: "ac18",
                tailNumber: "N972QS",
                sizeCategory: "small",
                arrival: "13:54",
                departure: "14:54"
            },
            {
                id: "ac19",
                tailNumber: "N856QS",
                sizeCategory: "small",
                arrival: "14:36",
                departure: "18:00"
            },
            {
                id: "ac20",
                tailNumber: "N791QS",
                sizeCategory: "small",
                arrival: "14:48",
                departure: "17:00"
            },
            {
                id: "ac21",
                tailNumber: "N677QS",
                sizeCategory: "small",
                arrival: "15:09",
                departure: "17:00"
            },
            {
                id: "ac22",
                tailNumber: "N731QS",
                sizeCategory: "small",
                arrival: "15:54",
                departure: "19:30"
            },
            {
                id: "ac23",
                tailNumber: "N604QS",
                sizeCategory: "small",
                arrival: "15:57",
                departure: "21:09"
            },
            {
                id: "ac24",
                tailNumber: "N410LG",
                sizeCategory: "small",
                arrival: "16:03",
                departure: "17:03"
            },
            {
                id: "ac25",
                tailNumber: "N189QS",
                sizeCategory: "small",
                arrival: "16:21",
                departure: "19:00"
            },
            {
                id: "ac26",
                tailNumber: "N348QS",
                sizeCategory: "small",
                arrival: "16:24",
                departure: "20:09"
            },
            {
                id: "ac27",
                tailNumber: "N755QS",
                sizeCategory: "small",
                arrival: "16:42",
                departure: "17:00"
            },
            {
                id: "ac28",
                tailNumber: "N750QS",
                sizeCategory: "small",
                arrival: "17:09",
                departure: "18:17"
            },
            {
                id: "ac29",
                tailNumber: "N905QS",
                sizeCategory: "small",
                arrival: "17:18",
                departure: "18:18"
            },
            {
                id: "ac30",
                tailNumber: "N635QS",
                sizeCategory: "small",
                arrival: "17:36",
                departure: "19:00"
            },
            {
                id: "ac31",
                tailNumber: "N871QS",
                sizeCategory: "small",
                arrival: "18:12",
                departure: "21:40"
            },
            {
                id: "ac32",
                tailNumber: "N570QS",
                sizeCategory: "small",
                arrival: "18:18",
                departure: "18:48"
            },
            {
                id: "ac33",
                tailNumber: "N512QS",
                sizeCategory: "small",
                arrival: "18:18",
                departure: "19:18"
            },
            {
                id: "ac34",
                tailNumber: "N373QS",
                sizeCategory: "small",
                arrival: "18:54",
                departure: "21:00"
            },
            {
                id: "ac35",
                tailNumber: "N514QS",
                sizeCategory: "small",
                arrival: "19:18",
                departure: "22:00"
            },
            {
                id: "ac36",
                tailNumber: "N160QS",
                sizeCategory: "small",
                arrival: "20:15",
                departure: "21:15"
            },
            // Duplicate wave with slight offsets (+5-10 minutes, different tail numbers)
            {
                id: "ac37",
                tailNumber: "N132MX",
                sizeCategory: "small",
                arrival: "06:53",
                departure: "11:05"
            },
            {
                id: "ac38",
                tailNumber: "N822MX",
                sizeCategory: "small",
                arrival: "07:11",
                departure: "09:05"
            },
            {
                id: "ac39",
                tailNumber: "N682MX",
                sizeCategory: "small",
                arrival: "07:38",
                departure: "10:53"
            },
            {
                id: "ac40",
                tailNumber: "N697MX",
                sizeCategory: "small",
                arrival: "09:29",
                departure: "10:35"
            },
            {
                id: "ac41",
                tailNumber: "N478MX",
                sizeCategory: "small",
                arrival: "09:38",
                departure: "16:05"
            },
            {
                id: "ac42",
                tailNumber: "N523MX",
                sizeCategory: "small",
                arrival: "09:53",
                departure: "11:05"
            },
            {
                id: "ac43",
                tailNumber: "N839MX",
                sizeCategory: "small",
                arrival: "10:14",
                departure: "15:14"
            },
            {
                id: "ac44",
                tailNumber: "N791MX",
                sizeCategory: "small",
                arrival: "10:23",
                departure: "11:23"
            },
            {
                id: "ac45",
                tailNumber: "N336MX",
                sizeCategory: "small",
                arrival: "11:14",
                departure: "17:14"
            },
            {
                id: "ac46",
                tailNumber: "N866MX",
                sizeCategory: "small",
                arrival: "11:23",
                departure: "16:05"
            },
            {
                id: "ac47",
                tailNumber: "N313MX",
                sizeCategory: "small",
                arrival: "11:35",
                departure: "12:35"
            },
            {
                id: "ac48",
                tailNumber: "N957MX",
                sizeCategory: "small",
                arrival: "11:35",
                departure: "13:14"
            },
            {
                id: "ac49",
                tailNumber: "N525MX",
                sizeCategory: "small",
                arrival: "11:53",
                departure: "15:50"
            },
            {
                id: "ac50",
                tailNumber: "N881MX",
                sizeCategory: "small",
                arrival: "12:53",
                departure: "13:53"
            },
            {
                id: "ac51",
                tailNumber: "N91MX",
                sizeCategory: "small",
                arrival: "13:05",
                departure: "14:05"
            },
            {
                id: "ac52",
                tailNumber: "N922MX",
                sizeCategory: "small",
                arrival: "13:11",
                departure: "15:35"
            },
            {
                id: "ac53",
                tailNumber: "N835MX",
                sizeCategory: "small",
                arrival: "13:38",
                departure: "15:05"
            },
            {
                id: "ac54",
                tailNumber: "N972MX",
                sizeCategory: "small",
                arrival: "13:59",
                departure: "14:59"
            },
            {
                id: "ac55",
                tailNumber: "N856MX",
                sizeCategory: "small",
                arrival: "14:41",
                departure: "18:05"
            },
            {
                id: "ac56",
                tailNumber: "N791MX",
                sizeCategory: "small",
                arrival: "14:53",
                departure: "17:05"
            },
            {
                id: "ac57",
                tailNumber: "N677MX",
                sizeCategory: "small",
                arrival: "15:14",
                departure: "17:05"
            },
            {
                id: "ac58",
                tailNumber: "N731MX",
                sizeCategory: "small",
                arrival: "15:59",
                departure: "19:35"
            },
            {
                id: "ac59",
                tailNumber: "N604MX",
                sizeCategory: "small",
                arrival: "16:02",
                departure: "21:14"
            },
            {
                id: "ac60",
                tailNumber: "N410MX",
                sizeCategory: "small",
                arrival: "16:08",
                departure: "17:08"
            },
            {
                id: "ac61",
                tailNumber: "N189MX",
                sizeCategory: "small",
                arrival: "16:26",
                departure: "19:05"
            },
            {
                id: "ac62",
                tailNumber: "N348MX",
                sizeCategory: "small",
                arrival: "16:29",
                departure: "20:14"
            },
            {
                id: "ac63",
                tailNumber: "N755MX",
                sizeCategory: "small",
                arrival: "16:47",
                departure: "17:05"
            },
            {
                id: "ac64",
                tailNumber: "N750MX",
                sizeCategory: "small",
                arrival: "17:14",
                departure: "18:22"
            },
            {
                id: "ac65",
                tailNumber: "N905MX",
                sizeCategory: "small",
                arrival: "17:23",
                departure: "18:23"
            },
            {
                id: "ac66",
                tailNumber: "N635MX",
                sizeCategory: "small",
                arrival: "17:41",
                departure: "19:05"
            },
            {
                id: "ac67",
                tailNumber: "N871MX",
                sizeCategory: "small",
                arrival: "18:17",
                departure: "21:45"
            },
            {
                id: "ac68",
                tailNumber: "N570MX",
                sizeCategory: "small",
                arrival: "18:23",
                departure: "18:53"
            },
            {
                id: "ac69",
                tailNumber: "N512MX",
                sizeCategory: "small",
                arrival: "18:23",
                departure: "19:23"
            },
            {
                id: "ac70",
                tailNumber: "N373MX",
                sizeCategory: "small",
                arrival: "18:59",
                departure: "21:05"
            },
            {
                id: "ac71",
                tailNumber: "N514MX",
                sizeCategory: "small",
                arrival: "19:23",
                departure: "22:05"
            },
            {
                id: "ac72",
                tailNumber: "N160MX",
                sizeCategory: "small",
                arrival: "20:20",
                departure: "21:20"
            }
        ],
        // With 72 aircraft on 24 spots, expect significant oversubscription
        // Peak periods (afternoon) may have 30-35 aircraft wanting spots simultaneously
        expectedPlaced: 50,
        expectedUnplaced: 22,
        startTime: "06:00",
        horizonHours: 16
    },
    {
        id: "egress-trap-basic",
        name: "Egress Trap - Basic (Long Blocks Short)",
        description: "Tests egress blocking detection. Long-dwell aircraft arrives early and would trap short-turn aircraft deeper in row. Algorithm should avoid placing long-dwell at front spots. **6 spots (A01-A06), Use 0 buffer**.",
        rampLayout: "teb",
        // Uses 6-spot row from TEB layout
        aircraft: [
            // Long-dwell aircraft (08:00-20:00, 12 hour dwell)
            {
                id: "ac1",
                tailNumber: "N650GL",
                sizeCategory: "small",
                arrival: "08:00",
                departure: "20:00"
            },
            // Short-turn aircraft deeper in row (all depart before long-dwell)
            {
                id: "ac2",
                tailNumber: "N822QS",
                sizeCategory: "small",
                arrival: "08:30",
                departure: "10:00"
            },
            // A02
            {
                id: "ac3",
                tailNumber: "N697QS",
                sizeCategory: "small",
                arrival: "09:00",
                departure: "11:00"
            },
            // A03
            {
                id: "ac4",
                tailNumber: "N478QS",
                sizeCategory: "small",
                arrival: "09:30",
                departure: "12:00"
            },
            // A04
            {
                id: "ac5",
                tailNumber: "N523QS",
                sizeCategory: "small",
                arrival: "10:00",
                departure: "13:00"
            },
            // A05
            {
                id: "ac6",
                tailNumber: "N839QS",
                sizeCategory: "small",
                arrival: "10:30",
                departure: "14:00"
            } // A06
        ],
        // With egress blocking: long-dwell should be placed at A06 (back of row)
        // Without egress blocking: might place at A01 (front), trapping all others
        expectedPlaced: 6,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "egress-trap-resolved",
        name: "Egress Trap - Resolved (Short Front, Long Back)",
        description: "No egress conflicts when short-turn aircraft are in front and long-dwell aircraft are in back. All placements should succeed with no traps. **6 spots (A01-A06), Use 0 buffer**.",
        rampLayout: "teb",
        aircraft: [
            // Short-turn aircraft (arrive first, placed at front)
            {
                id: "ac1",
                tailNumber: "N822QS",
                sizeCategory: "small",
                arrival: "08:00",
                departure: "10:00"
            },
            // A01
            {
                id: "ac2",
                tailNumber: "N697QS",
                sizeCategory: "small",
                arrival: "08:30",
                departure: "11:00"
            },
            // A02
            {
                id: "ac3",
                tailNumber: "N478QS",
                sizeCategory: "small",
                arrival: "09:00",
                departure: "12:00"
            },
            // A03
            // Long-dwell aircraft (arrive later, placed at back)
            {
                id: "ac4",
                tailNumber: "N650GL",
                sizeCategory: "small",
                arrival: "09:30",
                departure: "20:00"
            },
            // A04
            {
                id: "ac5",
                tailNumber: "N88GX",
                sizeCategory: "small",
                arrival: "10:00",
                departure: "21:00"
            },
            // A05
            {
                id: "ac6",
                tailNumber: "N7XXF",
                sizeCategory: "small",
                arrival: "10:30",
                departure: "22:00"
            } // A06
        ],
        // All should place successfully - short-turns depart before long-dwells
        expectedPlaced: 6,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "egress-unavoidable",
        name: "Egress Unavoidable - Forced Trap",
        description: "All spots occupied except front spot. New aircraft arrives and only available placement would trap others. Tests allowTrapping=true vs false. **Use 0 buffer**.",
        rampLayout: "small",
        // 5 spots: A01-A03, B01-B02
        aircraft: [
            // Pre-fill spots A02, A03, B01, B02 with short-turns
            {
                id: "ac1",
                tailNumber: "N822QS",
                sizeCategory: "small",
                arrival: "08:00",
                departure: "10:00"
            },
            // A02
            {
                id: "ac2",
                tailNumber: "N697QS",
                sizeCategory: "small",
                arrival: "08:10",
                departure: "10:30"
            },
            // A03
            {
                id: "ac3",
                tailNumber: "N478QS",
                sizeCategory: "small",
                arrival: "08:20",
                departure: "11:00"
            },
            // B01
            {
                id: "ac4",
                tailNumber: "N523QS",
                sizeCategory: "small",
                arrival: "08:30",
                departure: "11:30"
            },
            // B02
            // Late-arriving long-dwell - only A01 available, but traps A02 and A03
            {
                id: "ac5",
                tailNumber: "N650GL",
                sizeCategory: "small",
                arrival: "09:00",
                departure: "20:00"
            }
        ],
        // With allowTrapping=true: 5 placed (accepts trap)
        // With allowTrapping=false: 4 placed, 1 unplaced (rejects trap)
        expectedPlaced: 5,
        // Default: allowTrapping=true
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "overnight-48h",
        name: "Overnight 48-Hour - Multi-Day Planning",
        description: "48-hour planning window with aircraft spanning midnight boundaries. Tests day-wrap-around logic and multi-day dwells. **5 spots, Use 15min buffer**.",
        rampLayout: "small",
        aircraft: [
            // Day 1 morning arrivals
            {
                id: "ac1",
                tailNumber: "N101",
                sizeCategory: "small",
                arrival: "08:00",
                departure: "16:00"
            },
            // Same day
            {
                id: "ac2",
                tailNumber: "N102",
                sizeCategory: "small",
                arrival: "10:00",
                departure: "18:00"
            },
            // Same day
            // Day 1 evening arrivals that stay overnight
            {
                id: "ac3",
                tailNumber: "N103",
                sizeCategory: "small",
                arrival: "18:00",
                departure: "08:00"
            },
            // Next morning (14h dwell)
            {
                id: "ac4",
                tailNumber: "N104",
                sizeCategory: "small",
                arrival: "20:00",
                departure: "10:00"
            },
            // Next morning (14h dwell)
            // Day 2 morning arrivals
            {
                id: "ac5",
                tailNumber: "N105",
                sizeCategory: "small",
                arrival: "08:00",
                departure: "14:00"
            },
            // Day 2 afternoon
            {
                id: "ac6",
                tailNumber: "N106",
                sizeCategory: "small",
                arrival: "12:00",
                departure: "20:00"
            },
            // Day 2 evening
            // Long-term parker spanning both days
            {
                id: "ac7",
                tailNumber: "N107",
                sizeCategory: "small",
                arrival: "06:00",
                departure: "06:00"
            } // Full 24h (Day 1 06:00 -> Day 2 06:00)
        ],
        expectedPlaced: 7,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 48
    },
    {
        id: "night-shift",
        name: "Night Shift - Wrap-Around Schedule",
        description: "12-hour night shift (18:00-06:00) with wrap-around to next day. Tests time conversion for schedules crossing midnight. **5 spots, Use 0 buffer**.",
        rampLayout: "small",
        aircraft: [
            // Evening arrivals
            {
                id: "ac1",
                tailNumber: "N201",
                sizeCategory: "small",
                arrival: "18:00",
                departure: "22:00"
            },
            {
                id: "ac2",
                tailNumber: "N202",
                sizeCategory: "small",
                arrival: "19:00",
                departure: "23:00"
            },
            {
                id: "ac3",
                tailNumber: "N203",
                sizeCategory: "small",
                arrival: "20:00",
                departure: "00:00"
            },
            // Departs at midnight
            // Late night arrivals (after midnight)
            {
                id: "ac4",
                tailNumber: "N204",
                sizeCategory: "small",
                arrival: "00:00",
                departure: "04:00"
            },
            {
                id: "ac5",
                tailNumber: "N205",
                sizeCategory: "small",
                arrival: "02:00",
                departure: "06:00"
            },
            // All-nighter
            {
                id: "ac6",
                tailNumber: "N206",
                sizeCategory: "small",
                arrival: "18:00",
                departure: "06:00"
            } // Full 12h shift
        ],
        expectedPlaced: 6,
        expectedUnplaced: 0,
        startTime: "18:00",
        horizonHours: 12
    },
    {
        id: "weekend-72h",
        name: "Weekend 72-Hour - Extended Planning",
        description: "3-day planning window (Friday-Sunday) with varied patterns. Tests timeline rendering with multiple days and long-term parkers. **7 spots, Use 15min buffer**.",
        rampLayout: "medium",
        aircraft: [
            // Friday arrivals - short visits (buckets: 4 per hour, 96 per day)
            {
                id: "ac1",
                tailNumber: "N301",
                sizeCategory: "small",
                arrival: 32,
                departure: 64
            },
            // Fri 08:00-16:00
            {
                id: "ac2",
                tailNumber: "N302",
                sizeCategory: "small",
                arrival: 48,
                departure: 80
            },
            // Fri 12:00-20:00
            // Friday evening -> Saturday morning (overnight)
            {
                id: "ac3",
                tailNumber: "N303",
                sizeCategory: "small",
                arrival: 72,
                departure: 128
            },
            // Fri 18:00 -> Sat 08:00
            {
                id: "ac4",
                tailNumber: "N304",
                sizeCategory: "small",
                arrival: 80,
                departure: 136
            },
            // Fri 20:00 -> Sat 10:00
            // Weekend warriors (Fri -> Sat, Fri -> Sun)
            {
                id: "ac5",
                tailNumber: "N305",
                sizeCategory: "small",
                arrival: 56,
                departure: 152
            },
            // Fri 14:00 -> Sat 14:00 (24h)
            {
                id: "ac6",
                tailNumber: "N306",
                sizeCategory: "small",
                arrival: 64,
                departure: 256
            },
            // Fri 16:00 -> Sun 16:00 (48h)
            // Saturday activity
            {
                id: "ac7",
                tailNumber: "N307",
                sizeCategory: "small",
                arrival: 128,
                departure: 160
            },
            // Sat 08:00-16:00
            {
                id: "ac8",
                tailNumber: "N308",
                sizeCategory: "small",
                arrival: 144,
                departure: 176
            },
            // Sat 12:00-20:00
            // Sunday arrivals
            {
                id: "ac9",
                tailNumber: "N309",
                sizeCategory: "small",
                arrival: 224,
                departure: 256
            },
            // Sun 08:00-16:00
            {
                id: "ac10",
                tailNumber: "N310",
                sizeCategory: "small",
                arrival: 240,
                departure: 272
            },
            // Sun 12:00-20:00
            // Full weekend parker
            {
                id: "ac11",
                tailNumber: "N311",
                sizeCategory: "small",
                arrival: 24,
                departure: 280
            } // Fri 06:00 -> Sun 22:00 (64h)
        ],
        expectedPlaced: 11,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 72
    },
    {
        id: "gap-demo",
        name: "Gap Spot Demo - Phase 2d",
        description: "Demonstrates gap spot dependency checking. B01 and B02 are large spots, B06 is a small gap spot that requires BOTH B01 and B02 to be occupied. Phase 2d: B06 only available when dependencies are met. 2 large aircraft occupy B01/B02 (08:00-18:00), during this time the small aircraft (10:00-15:00) should be placed in B06. When only 1 large aircraft present, B06 should NOT be available.",
        rampLayout: "gap-demo",
        aircraft: [
            // Large aircraft occupy B01 and B02 (full day)
            {
                id: "ac1",
                tailNumber: "N700L",
                sizeCategory: "large",
                arrival: "08:00",
                departure: "18:00"
            },
            {
                id: "ac2",
                tailNumber: "N701L",
                sizeCategory: "super-midsize",
                arrival: "09:00",
                departure: "17:00"
            },
            // Small aircraft should fit in gap spot B06 when B01 and B02 are both occupied
            {
                id: "ac3",
                tailNumber: "N702S",
                sizeCategory: "small",
                arrival: "10:00",
                departure: "12:00"
            },
            {
                id: "ac4",
                tailNumber: "N703S",
                sizeCategory: "very-small",
                arrival: "13:00",
                departure: "15:00"
            }
        ],
        expectedPlaced: 4,
        // Phase 2d: All 4 should place (dependencies met when both large aircraft present)
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "lock-vip-maintenance",
        name: "VIP Aircraft - Maintenance Lock",
        description: "VIP Gulfstream G650 requires maintenance in hangar spot A01 from 12:00-14:00. Aircraft arrives 08:00, locked to A01 for maintenance, then moves to regular spot after. Tests mid-dwell lock with 3 segments (requires move cap \u2265 2).",
        rampLayout: "medium",
        aircraft: [
            {
                id: "vip1",
                tailNumber: "N650VIP",
                sizeCategory: "super-midsize",
                arrival: "08:00",
                departure: "18:00",
                locks: [
                    {
                        spotId: "A01",
                        startBucket: 48,
                        endBucket: 56,
                        reason: "maintenance"
                    }
                ]
            },
            // Add some background traffic to make it interesting
            {
                id: "ac2",
                tailNumber: "N201",
                sizeCategory: "small",
                arrival: "09:00",
                departure: "11:00"
            },
            {
                id: "ac3",
                tailNumber: "N202",
                sizeCategory: "small",
                arrival: "13:00",
                departure: "15:00"
            },
            {
                id: "ac4",
                tailNumber: "N203",
                sizeCategory: "midsize",
                arrival: "16:00",
                departure: "20:00"
            }
        ],
        expectedPlaced: 4,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "lock-conflict-demo",
        name: "Lock Conflict - Spot Unavailable",
        description: "Two aircraft both want spot A01, but first arrives earlier and takes it. Second aircraft has a lock to A01 from 10:00-12:00, but A01 is occupied by first aircraft. Tests lock validation failure (spot occupied during lock period). Works with any move cap.",
        rampLayout: "medium",
        aircraft: [
            // First aircraft takes A01 from 08:00-14:00 (no lock)
            {
                id: "ac1",
                tailNumber: "N101",
                sizeCategory: "midsize",
                arrival: "08:00",
                departure: "14:00"
            },
            // Second aircraft wants A01 locked from 10:00-12:00, but it's occupied!
            {
                id: "ac2",
                tailNumber: "N102",
                sizeCategory: "midsize",
                arrival: "09:00",
                departure: "13:00",
                locks: [
                    {
                        spotId: "A01",
                        startBucket: 40,
                        endBucket: 48,
                        reason: "vip"
                    }
                ]
            },
            // Third aircraft should place fine (background traffic)
            {
                id: "ac3",
                tailNumber: "N103",
                sizeCategory: "small",
                arrival: "15:00",
                departure: "17:00"
            }
        ],
        expectedPlaced: 2,
        // ac1 and ac3 succeed, ac2 fails due to lock conflict
        expectedUnplaced: 1,
        startTime: "00:00",
        horizonHours: 24
    },
    {
        id: "lock-multiple-moves",
        name: "Multiple Locks - Fueling + Boarding",
        description: "Heavy jet requires both fueling (A01: 10:00-11:00) and passenger boarding (B01: 14:00-15:00). Tests multiple non-overlapping locks creating 5 segments and 4 moves. Demonstrates complex multi-lock scenario. Requires move cap \u2265 4.",
        rampLayout: "medium",
        aircraft: [
            {
                id: "heavy1",
                tailNumber: "N777HA",
                sizeCategory: "large",
                arrival: "08:00",
                departure: "18:00",
                locks: [
                    {
                        spotId: "A01",
                        startBucket: 40,
                        endBucket: 44,
                        reason: "fueling"
                    },
                    {
                        spotId: "B01",
                        startBucket: 56,
                        endBucket: 60,
                        reason: "boarding"
                    }
                ]
            },
            // Background traffic
            {
                id: "ac2",
                tailNumber: "N301",
                sizeCategory: "small",
                arrival: "09:00",
                departure: "12:00"
            },
            {
                id: "ac3",
                tailNumber: "N302",
                sizeCategory: "small",
                arrival: "13:00",
                departure: "16:00"
            }
        ],
        expectedPlaced: 3,
        expectedUnplaced: 0,
        startTime: "00:00",
        horizonHours: 24
    }
];
/**
 * Convert TestAircraft (time strings or buckets) to Aircraft (buckets)
 * @param testAircraft - Aircraft with time strings or bucket numbers
 * @param startTime - Planning window start time for bucket conversion
 */ function $514609d279b59bb0$var$convertTestAircraftToAircraft(testAircraft, startTime) {
    return {
        id: testAircraft.id,
        tail_number: testAircraft.tailNumber,
        sizeCategory: testAircraft.sizeCategory,
        arrivalBucket: typeof testAircraft.arrival === "number" ? testAircraft.arrival : (0, $elGuA.timeStringToBucket)(testAircraft.arrival, startTime),
        departureBucket: typeof testAircraft.departure === "number" ? testAircraft.departure : (0, $elGuA.timeStringToBucket)(testAircraft.departure, startTime),
        locks: testAircraft.locks
    };
}
/**
 * Convert test scenario definitions (time strings) to runtime scenarios (buckets)
 */ function $514609d279b59bb0$var$convertScenarioDefinitions() {
    return $514609d279b59bb0$var$TEST_SCENARIO_DEFINITIONS.map((def)=>({
            ...def,
            aircraft: def.aircraft.map((ac)=>$514609d279b59bb0$var$convertTestAircraftToAircraft(ac, def.startTime))
        }));
}
const $514609d279b59bb0$export$6c85bda9f33a3d24 = $514609d279b59bb0$var$convertScenarioDefinitions();
function $514609d279b59bb0$export$f2bc56107b39dfc5(scenarioId = "basic") {
    const scenario = $514609d279b59bb0$export$6c85bda9f33a3d24.find((s)=>s.id === scenarioId) || $514609d279b59bb0$export$6c85bda9f33a3d24[0];
    const layout = $514609d279b59bb0$var$LAYOUTS[scenario.rampLayout];
    return {
        zones: [
            ...layout.zones
        ],
        spots: layout.spots.map((spot)=>({
                ...spot,
                occupancy: (0, $elGuA.makeEmptyMask)(scenario.horizonHours)
            })),
        aircraft: [
            ...scenario.aircraft
        ],
        scenario: scenario,
        horizonHours: scenario.horizonHours,
        startTime: scenario.startTime
    };
}


const $5e3106e503f2fba7$export$c2e0aa8ab70bb54c = ()=>{
    const [result, setResult] = $acw62.useState(null);
    const [selectedScenario, setSelectedScenario] = $acw62.useState("basic");
    const [bufferMinutes, setBufferMinutes] = $acw62.useState(15);
    const [plannedMoveCap, setPlannedMoveCap] = $acw62.useState(0);
    const [isRunning, setIsRunning] = $acw62.useState(false);
    // Use shared parking config hook
    const parkingConfig = (0, $aDzfS.useParkingConfig)({
        bufferMinutes: bufferMinutes,
        plannedMoveCap: plannedMoveCap,
        allowTrapping: true,
        egressWeight: 1.0,
        wasteWeight: 1.0,
        structuralWeight: 0.1,
        sortingStrategy: "arrival",
        zonePriorityWeight: 1.0,
        min_dwell_weight: 2.0,
        arrivalStagingDwellMinutes: 45,
        departureStagingDwellMinutes: 45,
        quickTurnThresholdMinutes: 90
    });
    const currentScenario = (0, $514609d279b59bb0$export$6c85bda9f33a3d24).find((s)=>s.id === selectedScenario) || (0, $514609d279b59bb0$export$6c85bda9f33a3d24)[0];
    // Reset results when parameters change
    $acw62.useEffect(()=>{
        setResult(null);
    }, [
        selectedScenario,
        bufferMinutes,
        plannedMoveCap,
        parkingConfig.config
    ]);
    const handleRunPlanner = ()=>{
        setIsRunning(true);
        // Get fresh test data (resets bitmaps)
        const { aircraft: aircraft, spots: spots, zones: zones, horizonHours: horizonHours, startTime: startTime } = (0, $514609d279b59bb0$export$f2bc56107b39dfc5)(selectedScenario);
        // Run the planner with current settings
        const planningResult = (0, $ixuXj.planParkingAssignments)(aircraft, spots, bufferMinutes, plannedMoveCap, parkingConfig.config.allowTrapping, parkingConfig.config.egressWeight, parkingConfig.config.wasteWeight, parkingConfig.config.structuralWeight, parkingConfig.config.sortingStrategy, horizonHours, true, // useMaskOptimization - Phase 9 fast path
        false, // validateMasks - validation not needed (proven correct). TODO: remove validation parameter entirely in future
        parkingConfig.config.zonePriorityWeight, zones, parkingConfig.config.min_dwell_weight);
        // Precompute egress masks for visualization and analysis
        // WHY: Allows fast egress blocking checks and powers the blocked spot visualization on timeline
        // WHEN: After placement complete, before rendering results
        (0, $ad1qL.precomputeAllEgressMasks)(spots, planningResult.placement, aircraft, bufferMinutes);
        // Calculate trap statistics for display in stats panel
        // WHY: Users need high-level overview of how many egress conflicts exist
        // USE CASE: "3 aircraft are blocking 8 others" tells operator there's a problem
        let trappingCount = 0; // How many aircraft are creating traps
        let totalTrappedAircraft = 0; // How many aircraft are trapped (sum)
        for(const aircraftId in planningResult.placement){
            const ac = aircraft.find((a)=>a.id === aircraftId);
            const placementInfo = planningResult.placement[aircraftId];
            // Skip segmented placements for now
            // WHY: Trap detection for segments needs special handling (future enhancement)
            if (!ac || !("spotId" in placementInfo)) continue;
            const spot = spots.find((s)=>s.id === placementInfo.spotId);
            if (!spot) continue;
            // Check how many aircraft this placement traps
            // WHY: Some placements trap 0, some trap many - we need to count each
            const trapCount = (0, $7O8dW.countTrappedAircraft)(ac, // Aircraft we placed
            spot, // Where we placed it
            planningResult.placement, // All placements
            aircraft, // All aircraft (for look-ahead)
            spots // All spots (for blocking)
            );
            // If this aircraft traps at least one other, count it
            // WHY: trappingCount = "problematic placements", totalTrappedAircraft = "total impact"
            if (trapCount > 0) {
                trappingCount++; // One more problematic placement
                totalTrappedAircraft += trapCount; // Add to total impact
            }
        }
        // Store everything together in state with trap statistics
        setResult({
            ...planningResult,
            stats: {
                ...planningResult.stats,
                trappingCount: trappingCount,
                totalTrappedAircraft: totalTrappedAircraft
            },
            aircraft: aircraft,
            spots: spots,
            zones: zones,
            horizonHours: horizonHours,
            startTime: startTime
        });
        setIsRunning(false);
    };
    // Check if results match expectations
    const resultsMatch = result && result.stats.placed === currentScenario.expectedPlaced && result.stats.unplaced === currentScenario.expectedUnplaced;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        maxWidth: "xl",
        sx: {
            py: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h5",
                gutterBottom: true,
                children: "Temporal Parking Test"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                spacing: 1.5,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                                sx: {
                                    minWidth: 300
                                },
                                size: "small",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                                        children: "Test Scenario"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cX7V2.default), {
                                        value: selectedScenario,
                                        onChange: (e)=>setSelectedScenario(e.target.value),
                                        label: "Test Scenario",
                                        children: (0, $514609d279b59bb0$export$6c85bda9f33a3d24).map((scenario)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: scenario.id,
                                                children: scenario.name
                                            }, scenario.id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3tkEe.ParkingConfigForm), {
                                ...parkingConfig.config,
                                onBufferMinutesChange: (value)=>{
                                    setBufferMinutes(value);
                                    parkingConfig.setBufferMinutes(value);
                                },
                                onPlannedMoveCapChange: (value)=>{
                                    setPlannedMoveCap(value);
                                    parkingConfig.setPlannedMoveCap(value);
                                },
                                onAllowTrappingChange: parkingConfig.setAllowTrapping,
                                onEgressWeightChange: parkingConfig.setEgressWeight,
                                onWasteWeightChange: parkingConfig.setWasteWeight,
                                onStructuralWeightChange: parkingConfig.setStructuralWeight,
                                onZonePriorityWeightChange: parkingConfig.setZonePriorityWeight,
                                onMinDwellWeightChange: parkingConfig.setMinDwellWeight,
                                onSortingStrategyChange: parkingConfig.setSortingStrategy,
                                onArrivalStagingDwellMinutesChange: parkingConfig.setArrivalStagingDwellMinutes,
                                onDepartureStagingDwellMinutesChange: parkingConfig.setDepartureStagingDwellMinutes,
                                onQuickTurnThresholdMinutesChange: parkingConfig.setQuickTurnThresholdMinutes,
                                size: "small",
                                layout: "row"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                "data-testid": "run-planner-button",
                                variant: "contained",
                                color: "primary",
                                onClick: handleRunPlanner,
                                disabled: isRunning,
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euRCv))), {}),
                                children: isRunning ? "Running..." : "Run Planner"
                            })
                        ]
                    }),
                    result && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                        "data-testid": "stats",
                        elevation: 1,
                        sx: {
                            p: 1,
                            bgcolor: resultsMatch ? "success.50" : "warning.50",
                            borderColor: resultsMatch ? "success.200" : "warning.200",
                            display: "inline-flex"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            flexWrap: "wrap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 0.5,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "subtitle2",
                                            children: "Planning Statistics"
                                        }),
                                        resultsMatch ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmTQO))), {
                                            color: "success",
                                            fontSize: "small"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5y9fX))), {
                                            color: "warning",
                                            fontSize: "small"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Total Aircraft:"
                                        }),
                                        " ",
                                        result.stats.totalAircraft
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "success.main",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Placed:"
                                        }),
                                        " ",
                                        result.stats.placed
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "error.main",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Unplaced:"
                                        }),
                                        " ",
                                        result.stats.unplaced
                                    ]
                                }),
                                result.stats.plannedMoves > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "info.main",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Planned Moves:"
                                        }),
                                        " ",
                                        result.stats.plannedMoves
                                    ]
                                }),
                                result.stats.trappingCount !== undefined && result.stats.trappingCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "warning.main",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Traps:"
                                        }),
                                        " ",
                                        result.stats.trappingCount,
                                        " ",
                                        "aircraft blocking ",
                                        result.stats.totalTrappedAircraft,
                                        " others"
                                    ]
                                }),
                                result.stats.trappingCount === 0 && result.stats.placed > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "success.main",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Traps:"
                                        }),
                                        " None \u2713"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: resultsMatch ? "success.dark" : "warning.dark",
                                    children: [
                                        "Expected: ",
                                        currentScenario.expectedPlaced,
                                        " placed /",
                                        " ",
                                        currentScenario.expectedUnplaced,
                                        " unplaced",
                                        resultsMatch ? " \u2713" : " (mismatch)"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "text.secondary",
                        children: currentScenario.description
                    }),
                    !result && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        sx: {
                            textAlign: "center",
                            color: "text.secondary",
                            my: 1
                        },
                        children: 'Select a scenario and click "Run Planner" to generate parking assignments'
                    }),
                    !result && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7Frhn.default), {
                        sx: {
                            p: 2,
                            bgcolor: "grey.50",
                            border: 1,
                            borderColor: "grey.300"
                        },
                        elevation: 0,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                gutterBottom: true,
                                sx: {
                                    mb: 2
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Parameter Guide"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600,
                                                    mb: 0.5
                                                },
                                                children: "Buffer"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    mb: 0.5
                                                },
                                                children: "Extra time (minutes) added before arrival and after departure to prevent tight spacing conflicts."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    fontStyle: "italic",
                                                    pl: 1,
                                                    borderLeft: "2px solid",
                                                    borderColor: "grey.400"
                                                },
                                                children: "Example: Aircraft A departs at 10:00. With 15min buffer, spot becomes available at 10:15, preventing rushed turnarounds."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600,
                                                    mb: 0.5
                                                },
                                                children: "Planned Moves"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    mb: 0.5
                                                },
                                                children: "Maximum number of times an aircraft can be relocated during its dwell. 0 = no moves (aircraft stays in one spot)."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    fontStyle: "italic",
                                                    pl: 1,
                                                    borderLeft: "2px solid",
                                                    borderColor: "grey.400"
                                                },
                                                children: "Example: Aircraft arrives 8:00, departs 16:00. With 1 move allowed, it could park at Spot A (8:00-12:00) then move to Spot B (12:00-16:00) if no single spot is available for the full 8 hours."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600,
                                                    mb: 0.5
                                                },
                                                children: "Allow Trapping"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    mb: 0.5
                                                },
                                                children: "When checked, allows placing aircraft in spots that block others' departure paths. When unchecked, only places aircraft in spots that don't trap others (may leave aircraft unplaced)."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    fontStyle: "italic",
                                                    pl: 1,
                                                    borderLeft: "2px solid",
                                                    borderColor: "grey.400"
                                                },
                                                children: "Example: Row has spots A (front) and B (back). Aircraft at B departs at 14:00, aircraft at A departs at 16:00. With trapping disallowed, B cannot be used (would be blocked). With trapping allowed, both spots can be used."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600,
                                                    mb: 0.5
                                                },
                                                children: "Egress Weight"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    mb: 0.5
                                                },
                                                children: "Controls how strongly the algorithm avoids placements that trap other aircraft."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 0.5,
                                                sx: {
                                                    pl: 1,
                                                    mb: 0.5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Low (1x):"
                                                            }),
                                                            " Minimal penalty - prefers spots without traps but accepts trapping when needed"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Medium (2x):"
                                                            }),
                                                            " Moderate penalty - works harder to avoid traps, may leave aircraft unplaced"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "High (5x):"
                                                            }),
                                                            " Strong penalty - heavily prioritizes zero-trap placements over placement count"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    fontStyle: "italic",
                                                    pl: 1,
                                                    borderLeft: "2px solid",
                                                    borderColor: "grey.400"
                                                },
                                                children: "Example: Spot A traps 2 aircraft (score = 2 \xd7 weight), Spot B traps 0 (score = 0). With High weight (5x), Spot A scores 10 vs Spot B scores 0, making Spot B strongly preferred."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600,
                                                    mb: 0.5
                                                },
                                                children: "Waste Weight"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    mb: 0.5
                                                },
                                                children: "Controls how strongly the algorithm avoids placing small aircraft in oversized spots. Helps reserve premium large spots for large aircraft that actually need them."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 0.5,
                                                sx: {
                                                    pl: 1,
                                                    mb: 0.5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Disabled (0x):"
                                                            }),
                                                            " No penalty - ignores spot size mismatch, algorithm places freely"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Low (0.5x):"
                                                            }),
                                                            " Gentle nudge - slight preference for right-sized spots"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Medium (1x):"
                                                            }),
                                                            " Balanced penalty - comparable to egress weight"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "High (2x):"
                                                            }),
                                                            " Strong preference - works hard to avoid oversized spots"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Very High (3x):"
                                                            }),
                                                            " Extreme penalty - aggressively reserves large spots for large aircraft"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    fontStyle: "italic",
                                                    pl: 1,
                                                    borderLeft: "2px solid",
                                                    borderColor: "grey.400"
                                                },
                                                children: "Example: Citation (small) considering large-capable spot has waste=3. With Medium weight (1x), waste penalty=3. With High weight (2x), penalty=6. If a right-sized small-only spot has score=0 and large spot has egress penalty=2, then: Medium makes scores 0 vs 5 (prefer small), High makes scores 0 vs 8 (strongly prefer small)."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600,
                                                    mb: 0.5
                                                },
                                                children: "Sorting Strategy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    mb: 0.5
                                                },
                                                children: "Controls the order in which aircraft are processed by the greedy placement algorithm. Different orderings can dramatically affect placement rates."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 0.5,
                                                sx: {
                                                    pl: 1,
                                                    mb: 0.5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Arrival Order:"
                                                            }),
                                                            " Process by arrival time (earliest first). Realistic but may waste flexible spots."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Size-Constrained First:"
                                                            }),
                                                            " Place aircraft with fewer compatible spots first. Prevents wasting flexible spots on flexible aircraft."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Longest Dwell First:"
                                                            }),
                                                            " Place longest-staying aircraft first. Ensures long dwells get priority."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Latest Departure First:"
                                                            }),
                                                            " Place latest-departing aircraft first. Optimizes overnight parking."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Hybrid:"
                                                            }),
                                                            " Combines size-constrained and longest-dwell (most constrained + longest first)."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    fontStyle: "italic",
                                                    pl: 1,
                                                    borderLeft: "2px solid",
                                                    borderColor: "grey.400"
                                                },
                                                children: "Example: 2 spots (A=Small-only, B=Flex). Small aircraft arrives first, greedy places it at B (wastes flexibility). Large aircraft arrives, rejected (only B works, now occupied). With size-constrained ordering: Large placed first at B, small takes A \u2192 both placed!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600,
                                                    mb: 0.5
                                                },
                                                children: "Size Categories"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    mb: 0.5
                                                },
                                                children: "Aircraft are assigned size categories based on wingspan. Spots have policies that restrict which aircraft sizes they accept, enabling flexible parking rules."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 0.5,
                                                sx: {
                                                    pl: 1,
                                                    mb: 0.5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "VS (Very Small):"
                                                            }),
                                                            " ~35-40ft wingspan (Cessna 172, Piper PA-28, Cirrus SR22)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "S (Small):"
                                                            }),
                                                            " ~50-60ft wingspan (Citations, Phenom 300, King Air 350, Learjet 45)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "M (Midsize):"
                                                            }),
                                                            " ~60-70ft wingspan (Challenger 604/605, Falcon 900, Gulfstream G280)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "SM (Super-Midsize):"
                                                            }),
                                                            " ~75-100ft wingspan (Falcon 7X, Gulfstream G500/G650)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "L (Large):"
                                                            }),
                                                            " ~100-120ft wingspan (Global 6000/7500, Gulfstream G700, BBJ)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    mb: 0.5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: "Spot Policies:"
                                                    }),
                                                    " Each spot has an allowed sizes list that determines which aircraft can park there."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                spacing: 0.5,
                                                sx: {
                                                    pl: 1,
                                                    mb: 0.5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Universal:"
                                                            }),
                                                            " [VS, S, M, SM, L] - accepts all aircraft sizes"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Large-only:"
                                                            }),
                                                            " [L] - reserves spot for large aircraft (prevents waste)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        color: "text.secondary",
                                                        children: [
                                                            "\u2022 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "Common jets:"
                                                            }),
                                                            " [S, M] - blocks very-small and large aircraft"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    display: "block",
                                                    fontStyle: "italic",
                                                    pl: 1,
                                                    borderLeft: "2px solid",
                                                    borderColor: "grey.400"
                                                },
                                                children: "Example: Spot A01 allows [S, M] (small and midsize only). A large aircraft (L) arrives but cannot use A01 due to size restrictions. It must find a spot that allows large aircraft."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    result && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $07cb3cb81c1595aa$export$b655ca18f52b2d), {
                                placement: result.placement,
                                aircraft: result.aircraft,
                                spots: result.spots,
                                zones: result.zones
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bXsOq.TimelineView), {
                                spots: result.spots,
                                aircraft: result.aircraft,
                                placement: result.placement,
                                log: result.log,
                                horizonHours: result.horizonHours,
                                startTime: new Date(result.startTime)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7Frhn.default), {
                                sx: {
                                    p: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "h6",
                                        gutterBottom: true,
                                        children: [
                                            "Decision Log (",
                                            result.log.length,
                                            " events)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            maxHeight: 400,
                                            overflow: "auto"
                                        },
                                        children: result.aircraft.map((ac)=>{
                                            const acLogs = result.log.filter((e)=>e.aircraftId === ac.id);
                                            if (acLogs.length === 0) return null;
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                sx: {
                                                    mb: 2
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25rQi.DecisionLogDisplay), {
                                                    aircraft: ac,
                                                    log: result.log
                                                })
                                            }, ac.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");
parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $1KiAb = parcelRequire("1KiAb");

var $6AlVH = parcelRequire("6AlVH");
const $cc8552e1cb17cbf9$export$94cdc8ffefbad5ab = ({ rampId: rampId, isReference: isReference })=>{
    const { id: rampIdFromRoute } = (0, $aphAM.useParams)();
    const TEST_RAMP_ID = "3540d501-1237-4364-9e45-475e849b8b67";
    return(// RampsStateContainer and HangarsStateContainer might seem weird. it's for the selection menus
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
        isReference: isReference ?? false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
            isReference: isReference ?? false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1KiAb.RampStateContainer), {
                initialState: {
                    ramp_id: rampId ?? rampIdFromRoute ?? TEST_RAMP_ID,
                    isReference: isReference ?? false
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6AlVH.TowingEquipmentContainer), {
                    children: [
                        isReference && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                            severity: "warning",
                            children: "This is your Tie Town Tenant Reference ramp. It only shows your tie down tenants and is distinct from your active Current Ramp."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: "Ramp Optimization Component (TestRamp disabled to reduce bundle size)"
                        })
                    ]
                })
            })
        })
    }));
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3AGzj = parcelRequire("3AGzj");

var $5HLUx = parcelRequire("5HLUx");
const $2188062c3d068362$export$d085537b834e7da5 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5HLUx.RampsPresenter), {})
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $l5ED9 = parcelRequire("l5ED9");

var $gqehT = parcelRequire("gqehT");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");
const $85658fb2dfdaeb3d$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $85658fb2dfdaeb3d$export$a4c3d56613a57187 = ()=>{
    const { code: code } = (0, $aphAM.useParams)();
    const navigate = (0, $aphAM.useNavigate)();
    const [newPassword, setNewPassword] = $acw62.useState("");
    const [confirmPassword, setConfirmPassword] = $acw62.useState("");
    const [loading, setLoading] = $acw62.useState(false);
    const [error, setError] = $acw62.useState("");
    // Create unauthenticated postgrest client for public endpoint
    const postgrest = $acw62.useMemo(()=>{
        return (0, $l5ED9.createUnauthenticatedPostgrest)();
    }, []);
    const validatePassword = ()=>{
        if (newPassword.length < 8) {
            setError("Password must be at least 8 characters");
            return false;
        }
        if (!/[A-Z]/.test(newPassword)) {
            setError("Password must contain at least one uppercase letter");
            return false;
        }
        if (!/[a-z]/.test(newPassword)) {
            setError("Password must contain at least one lowercase letter");
            return false;
        }
        if (!/[0-9]/.test(newPassword)) {
            setError("Password must contain at least one number");
            return false;
        }
        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return false;
        }
        return true;
    };
    const handleResetPassword = async ()=>{
        setError("");
        if (!validatePassword()) return;
        setLoading(true);
        try {
            const { data: token } = await postgrest.rpc("reset_password_with_code", {
                p_code: code,
                p_new_password: newPassword
            });
            if (!token || token.length === 0) {
                setError("Invalid or expired reset link. Please request a new one.");
                setLoading(false);
                return;
            }
            // Store token and reload (auto-login)
            // Use reload instead of navigate to ensure React state reinitializes
            localStorage.setItem((0, $gqehT.AIRPLX_TOKEN), token[0]);
            window.location.reload();
        } catch (err) {
            setError(err.message || "An error occurred. Please try again.");
            console.error("Error resetting password:", err);
            setLoading(false);
        }
    };
    const getPasswordStrength = ()=>{
        if (!newPassword) return "";
        if (newPassword.length < 8) return "Too short";
        let strength = 0;
        if (/[A-Z]/.test(newPassword)) strength++;
        if (/[a-z]/.test(newPassword)) strength++;
        if (/[0-9]/.test(newPassword)) strength++;
        if (/[^A-Za-z0-9]/.test(newPassword)) strength++;
        if (strength === 4 && newPassword.length >= 12) return "Strong";
        if (strength >= 3) return "Good";
        if (strength >= 2) return "Fair";
        return "Weak";
    };
    const passwordStrength = getPasswordStrength();
    if (!code) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h5",
                children: "Invalid reset link"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                variant: "contained",
                onClick: ()=>navigate("/login"),
                sx: {
                    mt: 2
                },
                children: "Back to login"
            })
        ]
    });
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "60vh",
                width: "100vw",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    width: 450,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "h5",
                                    children: "Reset Your Password"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body1",
                                    color: "text.secondary",
                                    align: "center",
                                    children: "Choose a strong password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            fullWidth: true,
                            label: "New Password",
                            variant: "outlined",
                            type: "password",
                            onChange: (e)=>setNewPassword(e.target.value),
                            onKeyPress: (e)=>e.key === "Enter" && handleResetPassword(),
                            value: newPassword,
                            autoFocus: true
                        }),
                        newPassword && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "body2",
                            sx: {
                                mt: -1
                            },
                            color: passwordStrength === "Strong" ? "success.main" : passwordStrength === "Good" ? "primary.main" : passwordStrength === "Fair" ? "warning.main" : "error.main",
                            children: [
                                "Strength: ",
                                passwordStrength
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            fullWidth: true,
                            label: "Confirm Password",
                            variant: "outlined",
                            type: "password",
                            onChange: (e)=>setConfirmPassword(e.target.value),
                            onKeyPress: (e)=>e.key === "Enter" && handleResetPassword(),
                            value: confirmPassword,
                            error: Boolean(error),
                            helperText: error,
                            sx: {
                                mt: newPassword ? 0 : 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            align: "center",
                            children: "Must be 8+ characters with uppercase, lowercase, and numbers"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            disabled: !newPassword || !confirmPassword || loading,
                            variant: "contained",
                            color: "primary",
                            onClick: handleResetPassword,
                            fullWidth: true,
                            sx: {
                                borderRadius: 1
                            },
                            children: loading ? "Resetting..." : "Reset Password"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            size: "small",
                            onClick: ()=>navigate("/login"),
                            children: "Back to login"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: $85658fb2dfdaeb3d$var$logo,
                style: {
                    position: "fixed",
                    bottom: 15,
                    right: 15,
                    width: 50
                }
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $ayMG0 = parcelRequire("ayMG0");

var $7S0ew = parcelRequire("7S0ew");
var $2CcMD = parcelRequire("2CcMD");
var $g04kv = parcelRequire("g04kv");

var $acw62 = parcelRequire("acw62");

var $cLNZr = parcelRequire("cLNZr");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $7FzhI = parcelRequire("7FzhI");

var $3AGzj = parcelRequire("3AGzj");

var $lQ8IB = parcelRequire("lQ8IB");

var $gYLUy = parcelRequire("gYLUy");

var $55RUj = parcelRequire("55RUj");

var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $2cPwN = parcelRequire("2cPwN");
var $gd5y7 = parcelRequire("gd5y7");
var $OEVqP = parcelRequire("OEVqP");
var $2iAqv = parcelRequire("2iAqv");
var $7Frhn = parcelRequire("7Frhn");
var $cX7V2 = parcelRequire("cX7V2");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $eJ0JC = parcelRequire("eJ0JC");
var $9ZYXn = parcelRequire("9ZYXn");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
// Map MUI SVG icon names to Material Icons font names
const $93f8f77d121d719e$var$iconNameMap = {
    // Core navigation and actions
    AccessTimeIcon: 'access_time',
    AddIcon: 'add',
    AddRoadIcon: 'add_road',
    AirplanemodeActiveIcon: 'flight',
    ArrowBackIcon: 'arrow_back',
    ArrowDownwardIcon: 'keyboard_arrow_down',
    ArrowDropDownIcon: 'arrow_drop_down',
    ArrowUpwardIcon: 'keyboard_arrow_up',
    BeachAccessIcon: 'beach_access',
    BoltIcon: 'bolt',
    CheckIcon: 'check',
    ChevronRightIcon: 'chevron_right',
    ChevronLeftIcon: 'chevron_left',
    CleaningServicesIcon: 'cleaning_services',
    ClearIcon: 'clear',
    CloseIcon: 'close',
    CloseFullscreenIcon: 'fullscreen_exit',
    CloudUploadIcon: 'cloud_upload',
    CompassIcon: 'navigation',
    ConnectingAirportsIcon: 'connecting_airports',
    ContentCopyIcon: 'content_copy',
    CopyAllIcon: 'copy_all',
    DeleteIcon: 'delete',
    DoneIcon: 'done',
    DownloadIcon: 'download',
    EditIcon: 'edit',
    EditNoteIcon: 'edit_note',
    ExpandLessIcon: 'expand_less',
    ExpandMoreIcon: 'expand_more',
    FilledFlagIcon: 'flag',
    FlightIcon: 'flight',
    FlightLandIcon: 'flight_land',
    FlightTakeoffIcon: 'flight_takeoff',
    GpsFixedIcon: 'gps_fixed',
    GridViewIcon: 'grid_view',
    GroupIcon: 'group',
    HelpIcon: 'help',
    HelpCenterIcon: 'help_center',
    HelpOutlineIcon: 'help_outline',
    ImageAspectRatioIcon: 'aspect_ratio',
    InfoIcon: 'info',
    KeyboardDoubleArrowLeftIcon: 'keyboard_double_arrow_left',
    KeyboardDoubleArrowRightIcon: 'keyboard_double_arrow_right',
    LabelIcon: 'label',
    LinearScaleIcon: 'linear_scale',
    LinkIcon: 'link',
    LocalFireDepartmentIcon: 'local_fire_department',
    LockIcon: 'lock',
    LockOpenIcon: 'lock_open',
    LogoutIcon: 'logout',
    MailOutlineIcon: 'mail_outline',
    MapIcon: 'map',
    MoreHorizIcon: 'more_horiz',
    MoreVertIcon: 'more_vert',
    MyLocationIcon: 'my_location',
    NextIcon: 'navigate_next',
    NearMeIcon: 'near_me',
    OpenInFullIcon: 'open_in_full',
    OutlinedFlagIcon: 'outlined_flag',
    PictureInPictureIcon: 'picture_in_picture',
    PlayIcon: 'play_arrow',
    PrintIcon: 'print',
    RadioButtonUncheckedIcon: 'radio_button_unchecked',
    RefreshIcon: 'refresh',
    RemoveIcon: 'remove',
    ReplayIcon: 'replay',
    RocketLaunchIcon: 'rocket_launch',
    SaveIcon: 'save',
    ScatterPlotIcon: 'scatter_plot',
    SearchIcon: 'search',
    SettingsIcon: 'settings',
    SpeedIcon: 'speed',
    SquareFootIcon: 'square_foot',
    StopIcon: 'stop',
    StraightenIcon: 'straighten',
    SwitchAccountIcon: 'switch_account',
    SwitchLeftIcon: 'switch_left_alt',
    TextFieldsIcon: 'text_fields',
    TextureIcon: 'texture',
    ThumbUpIcon: 'thumb_up',
    TitleIcon: 'title',
    TuneIcon: 'tune',
    UnfoldLessIcon: 'unfold_less',
    WarningIcon: 'warning',
    WidgetsIcon: 'widgets',
    CalculateIcon: 'calculate',
    MonetizationOnIcon: 'monetization_on',
    SupportIcon: 'support',
    // Additional icons
    CameraAltIcon: 'camera_alt',
    ExpandCircleDownIcon: 'expand_circle_down',
    FilterListIcon: 'filter_list',
    GetAppIcon: 'get_app',
    LaunchIcon: 'launch',
    MinimizeIcon: 'minimize',
    NotificationImportantIcon: 'notification_important',
    PauseCircleIcon: 'pause_circle',
    PhoneIcon: 'phone',
    PhotoCameraIcon: 'photo_camera',
    PlaceIcon: 'place',
    PublicIcon: 'public',
    QuestionMarkIcon: 'help',
    ScheduleIcon: 'schedule',
    SmartToyIcon: 'smart_toy',
    SyncAltIcon: 'sync_alt',
    TimelineIcon: 'timeline',
    TransformIcon: 'transform',
    VisibilityIcon: 'visibility',
    VisibilityOffIcon: 'visibility_off',
    ZoomInIcon: 'zoom_in',
    ZoomOutIcon: 'zoom_out',
    StarIcon: 'star',
    StarBorderIcon: 'star_border',
    ViewModuleIcon: 'view_module',
    ViewComfyIcon: 'view_comfy',
    AnalyticsIcon: 'analytics',
    InsightsIcon: 'insights',
    PersonIcon: 'person',
    BugReportIcon: 'bug_report',
    BuildIcon: 'build',
    CalendarMonthIcon: 'calendar_month',
    NavigateNextIcon: 'navigate_next',
    ShareIcon: 'share',
    TableViewIcon: 'table_view',
    TodayIcon: 'today',
    EventBusyIcon: 'event_busy'
};
const $93f8f77d121d719e$export$60cd750a357cc92 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ name: name, fontSize: fontSize = 'medium', color: color = 'inherit', className: className, style: style, ...props }, ref)=>{
    const fontIconName = $93f8f77d121d719e$var$iconNameMap[name];
    if (!fontIconName) {
        console.warn(`CdnIcon: Unknown icon "${name}"`);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            ref: ref,
            className: `material-icons ${className || ''}`,
            style: style,
            children: "help"
        });
    }
    // Convert MUI fontSize to CSS size
    const getFontSize = (size)=>{
        if (typeof size === 'number') return `${size}px`;
        switch(size){
            case 'small':
                return '20px';
            case 'medium':
                return '24px';
            case 'large':
                return '36px';
            case 'inherit':
                return 'inherit';
            default:
                return size;
        }
    };
    // Convert MUI color to CSS color
    const getColor = (colorProp)=>{
        switch(colorProp){
            case 'inherit':
                return 'inherit';
            case 'primary':
                return 'var(--mui-palette-primary-main, #1976d2)';
            case 'secondary':
                return 'var(--mui-palette-secondary-main, #dc004e)';
            case 'error':
                return 'var(--mui-palette-error-main, #d32f2f)';
            case 'warning':
                return 'var(--mui-palette-warning-main, #ed6c02)';
            case 'info':
                return 'var(--mui-palette-info-main, #0288d1)';
            case 'success':
                return 'var(--mui-palette-success-main, #2e7d32)';
            case 'action':
                return 'var(--mui-palette-action-active, rgba(0, 0, 0, 0.54))';
            case 'disabled':
                return 'var(--mui-palette-action-disabled, rgba(0, 0, 0, 0.26))';
            default:
                return colorProp;
        }
    };
    const combinedStyle = {
        fontSize: getFontSize(fontSize),
        color: getColor(color),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        lineHeight: 1,
        ...style
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        ref: ref,
        className: `material-icons ${className || ''}`,
        style: combinedStyle,
        ...props,
        children: fontIconName
    });
});
$93f8f77d121d719e$export$60cd750a357cc92.displayName = 'CdnIcon';
var $93f8f77d121d719e$export$2e2bcd8739ae039 = $93f8f77d121d719e$export$60cd750a357cc92;


class $164d2a3175b4615c$export$e926676385687eaf extends (0, $acw62.Component) {
    constructor(props){
        super(props), this.handleReset = ()=>{
            this.setState({
                hasError: false,
                error: null,
                errorInfo: null
            });
        }, this.handleRefresh = ()=>{
            window.location.reload();
        };
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return {
            hasError: true,
            error: error,
            errorInfo: null
        };
    }
    componentDidCatch(error, errorInfo) {
        // Call optional error handler
        if (this.props.onError) this.props.onError(error, errorInfo);
        // Update state with error info
        this.setState({
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.hasError) {
            const { fallbackTitle: fallbackTitle = "Something went wrong", fallbackDescription: fallbackDescription = "An unexpected error occurred. Please try refreshing the page." } = this.props;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: 400,
                    p: 4,
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93f8f77d121d719e$export$60cd750a357cc92), {
                        name: "BugIcon",
                        fontSize: 64,
                        color: "error",
                        style: {
                            opacity: 0.5,
                            marginBottom: 16
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h5",
                        gutterBottom: true,
                        sx: {
                            fontWeight: 500
                        },
                        children: fallbackTitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            mb: 3,
                            maxWidth: 600
                        },
                        children: fallbackDescription
                    }),
                    false,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "primary",
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93f8f77d121d719e$export$60cd750a357cc92), {
                                    name: "RefreshIcon"
                                }),
                                onClick: this.handleRefresh,
                                children: "Refresh Page"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "outlined",
                                onClick: this.handleReset,
                                children: "Try Again"
                            })
                        ]
                    })
                ]
            });
        }
        return this.props.children;
    }
}



var $fu9Og = parcelRequire("fu9Og");

var $c9nMz = parcelRequire("c9nMz");

var $35bYL = parcelRequire("35bYL");

var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $78ow6 = parcelRequire("78ow6");

var $dNxct = parcelRequire("dNxct");

var $uaXRK = parcelRequire("uaXRK");

var $kfA3C = parcelRequire("kfA3C");

var $acw62 = parcelRequire("acw62");

var $55RUj = parcelRequire("55RUj");
const $0e2c32697d5f2458$export$8dd6e5a51d2bd2e8 = ({ currentTime: currentTime, startDate: startDate, endDate: endDate, onTimeChange: onTimeChange, onNowClick: onNowClick, isScrolledAway: isScrolledAway = false })=>{
    // Check if current time is already at "now" (within 15-minute interval)
    const isAtNow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const now = (0, $55RUj.floorToQuarterHour)(new Date());
        const currentFloored = (0, $55RUj.floorToQuarterHour)(currentTime);
        // Compare times (within 1 second tolerance for floating point)
        return Math.abs(now.getTime() - currentFloored.getTime()) < 1000;
    }, [
        currentTime
    ]);
    // Button is disabled only when we're at "now" AND not scrolled away
    const isNowButtonDisabled = isAtNow && !isScrolledAway;
    // Jump to now
    const handleJumpToNow = ()=>{
        if (onNowClick) onNowClick();
        else onTimeChange((0, $55RUj.floorToQuarterHour)(new Date()));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $uaXRK.LocalizationProvider), {
        dateAdapter: (0, $78ow6.AdapterDateFns),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: 1,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNxct.DateTimePicker), {
                            label: "Current Time",
                            value: currentTime,
                            onChange: (newValue)=>{
                                if (newValue) onTimeChange(newValue);
                            },
                            ampm: false,
                            minutesStep: 15,
                            slotProps: {
                                textField: {
                                    size: "small",
                                    sx: {
                                        minWidth: 200
                                    }
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            size: "small",
                            onClick: handleJumpToNow,
                            disabled: isNowButtonDisabled,
                            sx: {
                                minWidth: 60
                            },
                            children: "Now"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "caption",
                    color: "text.secondary",
                    sx: {
                        ml: 0.5
                    },
                    children: [
                        "Viewing: ",
                        (0, $kfA3C.format)(startDate, "MMM d, yyyy"),
                        " -",
                        " ",
                        (0, $kfA3C.format)(endDate, "MMM d, yyyy")
                    ]
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $cFBau = parcelRequire("cFBau");
var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $19ocJ = parcelRequire("19ocJ");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $be544fa411c3beeb$export$c6e326473c442588 = ({ locations: locations, selectedLocationIds: selectedLocationIds, onChange: onChange, disabled: disabled = false })=>{
    // Flatten locations for autocomplete
    const allLocations = $acw62.useMemo(()=>{
        return locations.map((loc)=>({
                ...loc,
                label: `${loc.name}${loc.tripCount ? ` (${loc.tripCount})` : ""}`,
                group: loc.type === "hangar" ? "Hangars" : "Ramps"
            }));
    }, [
        locations
    ]);
    // Get selected location objects
    const selectedLocations = $acw62.useMemo(()=>{
        return allLocations.filter((loc)=>selectedLocationIds.includes(loc.id));
    }, [
        allLocations,
        selectedLocationIds
    ]);
    const handleChange = (_event, newValue)=>{
        onChange(newValue.map((loc)=>loc.id));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
        multiple: true,
        disableCloseOnSelect: true,
        disabled: disabled,
        options: allLocations,
        groupBy: (option)=>option.group,
        value: selectedLocations,
        onChange: handleChange,
        size: "small",
        sx: {
            minWidth: 250,
            maxWidth: 400,
            "& .MuiAutocomplete-tag": {
                maxWidth: "120px"
            }
        },
        ListboxProps: {
            style: {
                maxHeight: "none"
            }
        },
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                ...params,
                variant: "outlined",
                label: "Filter by Location",
                placeholder: selectedLocationIds.length === 0 ? "All locations" : ""
            }),
        renderOption: (props, option)=>{
            const { key: key, ...restProps } = props;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                component: "li",
                ...restProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                    primary: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                children: option.name
                            }),
                            option.tripCount !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "text.secondary",
                                children: option.tripCount
                            })
                        ]
                    })
                })
            }, key);
        },
        renderTags: (value, getTagProps)=>value.map((option, index)=>{
                const { key: key, ...restProps } = getTagProps({
                    index: index
                });
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                    ...restProps,
                    label: option.name,
                    size: "small",
                    color: option.type === "hangar" ? "primary" : "secondary",
                    variant: "outlined"
                }, key);
            }),
        ChipProps: {
            size: "small",
            variant: "outlined"
        }
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $kfA3C = parcelRequire("kfA3C");
var $7761d = parcelRequire("7761d");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $a7gZr = parcelRequire("a7gZr");

var $gYLUy = parcelRequire("gYLUy");

var $ayMG0 = parcelRequire("ayMG0");

var $c3r8Q = parcelRequire("c3r8Q");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $gd5y7 = parcelRequire("gd5y7");
var $9Lykx = parcelRequire("9Lykx");
var $OEVqP = parcelRequire("OEVqP");
var $2iAqv = parcelRequire("2iAqv");
var $7Frhn = parcelRequire("7Frhn");
var $cX7V2 = parcelRequire("cX7V2");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $kfA3C = parcelRequire("kfA3C");
var $7761d = parcelRequire("7761d");
parcelRequire("acw62");

var $gYLUy = parcelRequire("gYLUy");
const $d343b219e5639229$export$239eda83abbe39fc = ({ filteredTrips: filteredTrips, trips: trips, statusFilter: statusFilter, setStatusFilter: setStatusFilter, tailNumberFilter: tailNumberFilter, setTailNumberFilter: setTailNumberFilter, showFilters: showFilters = true, loading: loading = false, startDate: startDate, endDate: endDate, onTripEdit: onTripEdit, formatDate: formatDate, getStatusColor: getStatusColor, getTripType: getTripType, getTripAssignments: getTripAssignments })=>{
    // DataGrid column definitions
    const columns = [
        {
            field: "tail_number",
            headerName: "Tail Number",
            width: 150,
            align: "left",
            filterable: true,
            sortable: true,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        fontWeight: "medium",
                        children: params.value || "\u2014"
                    })
                })
        },
        {
            field: "aircraft_model",
            headerName: "Aircraft Model",
            width: 200,
            align: "left",
            filterable: true,
            sortable: true,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        children: params.value || "\u2014"
                    })
                })
        },
        {
            field: "type",
            headerName: "Type",
            width: 120,
            align: "left",
            filterable: true,
            sortable: true,
            valueGetter: (_, row)=>getTripType(row),
            renderCell: (params)=>{
                const tripType = getTripType(params.row);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                    label: tripType,
                    size: "small",
                    color: tripType === "Base Tenant" ? "secondary" : "default",
                    variant: "outlined"
                });
            }
        },
        {
            field: "arrival_date",
            headerName: "Arrival",
            width: 180,
            type: "dateTime",
            filterable: true,
            sortable: true,
            valueGetter: (_, row)=>(0, $7761d.parseISO)(row.arrival_date),
            renderCell: (params)=>formatDate(params.row.arrival_date)
        },
        {
            field: "departure_date",
            headerName: "Departure",
            width: 180,
            type: "dateTime",
            filterable: true,
            sortable: true,
            valueGetter: (_, row)=>{
                // Handle infinity dates for sorting (sort to end)
                if ((0, $gYLUy.isInfinityDate)(row.departure_date)) return new Date("2099-12-31T23:59:59Z");
                return (0, $7761d.parseISO)(row.departure_date);
            },
            renderCell: (params)=>formatDate(params.row.departure_date)
        },
        {
            field: "status",
            headerName: "Status",
            width: 130,
            filterable: true,
            sortable: true,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                    label: params.value,
                    size: "small",
                    color: getStatusColor(params.value),
                    variant: "outlined"
                })
        },
        {
            field: "notes",
            headerName: "Notes",
            width: 200,
            align: "left",
            filterable: true,
            sortable: true,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        height: "100%"
                    },
                    children: params.value ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: params.value,
                        arrow: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "body2",
                            noWrap: true,
                            sx: {
                                maxWidth: 180,
                                cursor: "help"
                            },
                            children: params.value
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        children: "\u2014"
                    })
                })
        },
        {
            field: "owner_manager",
            headerName: "Owner/Manager",
            width: 180,
            align: "left",
            filterable: true,
            sortable: true,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        children: params.value || "\u2014"
                    })
                })
        },
        {
            field: "assignment",
            headerName: "Assignment",
            width: 180,
            align: "left",
            filterable: true,
            sortable: true,
            valueGetter: (_, row)=>getTripAssignments(row)
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 100,
            filterable: false,
            sortable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    size: "small",
                    onClick: ()=>onTripEdit?.(params.row),
                    title: "Edit Trip",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3r8Q))), {})
                })
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            width: "100%"
        },
        children: [
            startDate && endDate && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    mb: 1
                },
                children: [
                    "Showing trips from ",
                    (0, $kfA3C.format)(startDate, "MMM d, yyyy"),
                    " to",
                    " ",
                    (0, $kfA3C.format)(endDate, "MMM d, yyyy")
                ]
            }),
            showFilters && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 2,
                sx: {
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        label: "Filter by Tail Number",
                        variant: "outlined",
                        size: "small",
                        value: tailNumberFilter,
                        onChange: (e)=>setTailNumberFilter(e.target.value),
                        sx: {
                            minWidth: 200
                        },
                        placeholder: "e.g. N123AB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                        size: "small",
                        sx: {
                            minWidth: 120
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                                value: statusFilter,
                                label: "Status",
                                onChange: (e)=>setStatusFilter(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        value: "all",
                                        children: "All Status"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        value: "scheduled",
                                        children: "Scheduled"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        value: "active",
                                        children: "Active"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        value: "completed",
                                        children: "Completed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                        value: "cancelled",
                                        children: "Cancelled"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            alignSelf: "center"
                        },
                        children: [
                            "Showing ",
                            filteredTrips.length,
                            " of ",
                            trips.length,
                            " trips"
                        ]
                    })
                ]
            }),
            !showFilters && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    mb: 1,
                    textAlign: "right"
                },
                children: [
                    "Showing ",
                    filteredTrips.length,
                    " of ",
                    trips.length,
                    " trips"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                sx: {
                    height: 600,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                    rows: filteredTrips,
                    columns: columns,
                    getRowId: (row)=>row.trip_id,
                    // Enable sorting & filtering
                    sortingOrder: [
                        "asc",
                        "desc"
                    ],
                    filterMode: "client",
                    // Pagination
                    pageSizeOptions: [
                        25,
                        50,
                        100
                    ],
                    initialState: {
                        pagination: {
                            paginationModel: {
                                pageSize: 50
                            }
                        }
                    },
                    // UI Configuration
                    disableRowSelectionOnClick: true,
                    // Loading state
                    loading: loading,
                    // No rows overlay
                    slots: {
                        noRowsOverlay: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    children: "No trips found"
                                })
                            })
                    }
                })
            })
        ]
    });
};


const $4f2bb41b06b8c886$export$3ffcf01f528c086f = ({ trips: trips, onTripEdit: onTripEdit, loading: loading = false, startDate: startDate, endDate: endDate, statusFilter: externalStatusFilter, tailNumberFilter: externalTailNumberFilter })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const placementService = (0, $acw62.useMemo)(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    // Use external filters if provided, otherwise manage locally (for backward compatibility)
    const [localStatusFilter, setLocalStatusFilter] = (0, $acw62.useState)("all");
    const [localTailNumberFilter, setLocalTailNumberFilter] = (0, $acw62.useState)("");
    const statusFilter = externalStatusFilter !== undefined ? externalStatusFilter : localStatusFilter;
    const tailNumberFilter = externalTailNumberFilter !== undefined ? externalTailNumberFilter : localTailNumberFilter;
    const setStatusFilter = externalStatusFilter !== undefined ? ()=>{} : setLocalStatusFilter;
    const setTailNumberFilter = externalTailNumberFilter !== undefined ? ()=>{} : setLocalTailNumberFilter;
    const [tripPlacements, setTripPlacements] = (0, $acw62.useState)({});
    // Filter trips
    const filteredTrips = (0, $acw62.useMemo)(()=>{
        return trips.filter((trip)=>{
            const matchesStatus = statusFilter === "all" || trip.status === statusFilter;
            const matchesTailNumber = !tailNumberFilter || trip.tail_number && trip.tail_number.toLowerCase().includes(tailNumberFilter.toLowerCase());
            return matchesStatus && matchesTailNumber;
        });
    }, [
        trips,
        statusFilter,
        tailNumberFilter
    ]);
    // Format date for display
    const formatDate = (dateString)=>{
        if ((0, $gYLUy.isInfinityDate)(dateString)) return "No scheduled departure";
        return (0, $kfA3C.format)((0, $7761d.parseISO)(dateString), "MMM d, yyyy h:mm a");
    };
    // Get status chip color
    const getStatusColor = (status)=>{
        switch(status){
            case "scheduled":
                return "primary";
            case "active":
                return "success";
            case "completed":
                return "default";
            case "cancelled":
                return "error";
            default:
                return "default";
        }
    };
    // Load placement data for all trips
    (0, $acw62.useEffect)(()=>{
        const loadTripPlacements = async ()=>{
            if (!filteredTrips.length) return;
            const placementPromises = filteredTrips.map(async (trip)=>{
                try {
                    const placements = await placementService.getPlacementsWithLocation(trip.trip_id);
                    const locationNames = placements.map((p)=>p.location_name).filter((name)=>name && name !== "Unassigned");
                    return {
                        tripId: trip.trip_id,
                        assignment: locationNames.length > 0 ? locationNames.join(", ") : "Unassigned"
                    };
                } catch (error) {
                    return {
                        tripId: trip.trip_id,
                        assignment: "Unassigned"
                    };
                }
            });
            const results = await Promise.all(placementPromises);
            const placementMap = results.reduce((acc, { tripId: tripId, assignment: assignment })=>{
                acc[tripId] = assignment;
                return acc;
            }, {});
            setTripPlacements(placementMap);
        };
        loadTripPlacements();
    }, [
        filteredTrips,
        placementService
    ]);
    // Get trip type (determine if trip is for base tenant or transient)
    const getTripType = (trip)=>{
        // Base tenants have infinite departure dates
        return (0, $gYLUy.isInfinityDate)(trip.departure_date) ? "Base Tenant" : "Transient";
    };
    // Get trip location assignments from cached placement data
    const getTripAssignments = (trip)=>{
        return tripPlacements[trip.trip_id] || "Loading...";
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d343b219e5639229$export$239eda83abbe39fc), {
        filteredTrips: filteredTrips,
        trips: trips,
        tripPlacements: tripPlacements,
        statusFilter: statusFilter,
        setStatusFilter: setStatusFilter,
        tailNumberFilter: tailNumberFilter,
        setTailNumberFilter: setTailNumberFilter,
        showFilters: externalStatusFilter === undefined && externalTailNumberFilter === undefined,
        loading: loading,
        startDate: startDate,
        endDate: endDate,
        onTripEdit: onTripEdit,
        formatDate: formatDate,
        getStatusColor: getStatusColor,
        getTripType: getTripType,
        getTripAssignments: getTripAssignments
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $hvR20 = parcelRequire("hvR20");
var $7761d = parcelRequire("7761d");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");

var $a7gZr = parcelRequire("a7gZr");

var $lQ8IB = parcelRequire("lQ8IB");

var $gYLUy = parcelRequire("gYLUy");

var $ayMG0 = parcelRequire("ayMG0");

var $iGBB4 = parcelRequire("iGBB4");

var $ap4xJ = parcelRequire("ap4xJ");

var $dLCr5 = parcelRequire("dLCr5");

var $6KM07 = parcelRequire("6KM07");

var $03mUs = parcelRequire("03mUs");
var $1lfQl = parcelRequire("1lfQl");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $kfA3C = parcelRequire("kfA3C");
var $hvR20 = parcelRequire("hvR20");
var $7761d = parcelRequire("7761d");

var $acw62 = parcelRequire("acw62");

var $5vA8q = parcelRequire("5vA8q");


var $gYLUy = parcelRequire("gYLUy");

var $f4Dj1 = parcelRequire("f4Dj1");

var $gtiLb = parcelRequire("gtiLb");

var $apzof = parcelRequire("apzof");

var $drjQE = parcelRequire("drjQE");

var $6RcbS = parcelRequire("6RcbS");

var $ayMG0 = parcelRequire("ayMG0");

var $jO6ya = parcelRequire("jO6ya");

var $1MdOk = parcelRequire("1MdOk");

var $6lXkL = parcelRequire("6lXkL");
var $2p5OG = parcelRequire("2p5OG");
var $86f4a = parcelRequire("86f4a");
var $7Frhn = parcelRequire("7Frhn");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $fa19498f9d4ef8c5$export$522b8308f1751ff5 = ({ selectedCount: selectedCount, onDelete: onDelete, onClearSelection: onClearSelection, disabled: disabled = false })=>{
    if (selectedCount === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86f4a.default), {
        in: selectedCount > 0,
        timeout: 200,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7Frhn.default), {
            elevation: 2,
            sx: {
                position: "absolute",
                top: -50,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 100,
                px: 2,
                py: 1,
                display: "flex",
                alignItems: "center",
                gap: 2,
                backgroundColor: "background.paper",
                border: 1,
                borderColor: "divider"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "body2",
                    sx: {
                        fontWeight: 500
                    },
                    children: [
                        selectedCount,
                        " trip",
                        selectedCount > 1 ? "s" : "",
                        " selected"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2p5OG.default), {
                    variant: "outlined",
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: onDelete,
                            disabled: disabled,
                            color: "error",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {
                                sx: {
                                    fontSize: 18
                                }
                            }),
                            sx: {
                                minWidth: 80,
                                fontSize: "0.75rem"
                            },
                            children: "Delete"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: onClearSelection,
                            disabled: disabled,
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jO6ya))), {
                                sx: {
                                    fontSize: 18
                                }
                            }),
                            sx: {
                                minWidth: 80,
                                fontSize: "0.75rem"
                            },
                            children: "Clear"
                        })
                    ]
                })
            ]
        })
    });
};



// Label format function for timeline headers - using simplified approach
const $4f36741c7c303977$var$customLabelFormat = ([startTime], unit, labelWidth)=>{
    // For day units - always use "ddd D" format (e.g., "Mon 15")
    if (unit === "day") {
        if (labelWidth < 60) return startTime.format("D");
        else return startTime.format("ddd D");
    }
    // For hour units - always use 24-hour format (e.g., "14:00")
    if (unit === "hour") {
        labelWidth;
        return startTime.format("HH:00");
    }
    // For minute units
    if (unit === "minute") return startTime.format("HH:mm");
    // For month units
    if (unit === "month") return startTime.format("MMMM");
    // For year units
    if (unit === "year") return startTime.format("YYYY");
    // For week units
    if (unit === "week") return startTime.format("[W]w");
    // Default fallback
    return startTime.format("L");
};
const $4f36741c7c303977$export$916dfb5c1f8daeeb = ({ trips: trips, groups: groups, items: items, keys: keys, selectedTrip: selectedTrip, modalOpen: modalOpen, placementsLoading: placementsLoading, startDate: startDate, endDate: endDate, viewTimestamp: viewTimestamp, timelineContainerRef: timelineContainerRef, timelineRef: timelineRef, handleItemClick: handleItemClick, handleModalClose: handleModalClose, handleNavigate: handleNavigate, handleTripChanged: handleTripChanged, handleTimeChange: handleTimeChange, getTripLocation: getTripLocation, getBorderColor: getBorderColor, getBorderWidth: getBorderWidth, inlineMode: inlineMode = false, visibleTimeStart: // Zoom props
visibleTimeStart, visibleTimeEnd: visibleTimeEnd, currentZoomLevel: currentZoomLevel = 1, handleZoomIn: handleZoomIn, handleZoomOut: handleZoomOut, handleZoomReset: handleZoomReset, selectedTripIds: // Multi-select props
selectedTripIds = new Set(), enableMultiSelect: enableMultiSelect = true, showDeleteConfirmation: showDeleteConfirmation = false, handleBulkDelete: handleBulkDelete, handleBulkDeleteClick: handleBulkDeleteClick, handleCancelDelete: handleCancelDelete, handleClearSelection: handleClearSelection })=>{
    const theme = (0, $14H9o.default)();
    // Use controlled visible time or default to date range
    const defaultTimelineStart = visibleTimeStart || (0, $hvR20.getTime)(startDate);
    const defaultTimelineEnd = visibleTimeEnd || (0, $hvR20.getTime)(endDate);
    // Custom item renderer for better trip display
    const itemRenderer = ({ item: item, itemContext: itemContext, getItemProps: getItemProps, getResizeProps: getResizeProps })=>{
        const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
        const trip = trips.find((t)=>t.trip_id === item.id);
        const location = trip ? getTripLocation(trip.trip_id) : null;
        // Check if this trip is selected
        const isSelected = selectedTripIds.has(item.id);
        // Determine background color based on status and assignment
        let backgroundColor = "#949494"; // Default gray
        // Check if aircraft has departed (departure date is in the past)
        // Infinity trips never depart
        const isDeparted = trip && !(0, $gYLUy.isInfinityDate)(trip.departure_date) && (0, $7761d.parseISO)(trip.departure_date) < new Date();
        if (isDeparted) // Departed aircraft are amber
        backgroundColor = "#FF9800";
        else if (trip?.status === "completed") // Completed but not yet departed trips are red
        backgroundColor = "#ED666D";
        else if (trip?.status === "scheduled") {
            // Check if trip has a hangar or ramp assignment
            if (location && location.name !== "Unassigned" && location.type !== "transient") // Assigned trips are blue
            backgroundColor = "#4287F5";
            else // Unassigned trips are gray
            backgroundColor = "#949494";
        } else if (trip?.status === "active") // Keep active trips with their original color
        backgroundColor = "#1565C0";
        else if (trip?.status === "cancelled") // Keep cancelled trips with their original color
        backgroundColor = "#C62828";
        // Apply selection styling
        if (isSelected) // Light blue background for selected items
        backgroundColor = "#E3F2FD";
        // For departed aircraft, use amber border to match the fill
        let borderColor = isDeparted ? "#FF9800" // Same amber as background
         : trip ? getBorderColor(trip, item.id) : "rgba(0,0,0,0.1)";
        let borderWidth = trip ? getBorderWidth(trip, item.id) : 1;
        // Override border for selected items
        if (isSelected) {
            borderColor = "#1976D2";
            borderWidth = 2;
        }
        // Get item props and extract key to avoid React warning
        const itemProps = getItemProps({
            style: {
                backgroundColor: backgroundColor,
                borderTopWidth: borderWidth,
                borderRightWidth: borderWidth,
                borderBottomWidth: borderWidth,
                borderLeftWidth: borderWidth,
                borderStyle: "solid",
                borderColor: borderColor,
                borderRadius: 4,
                color: isSelected ? theme.palette.primary.main : theme.palette.text.primary,
                fontSize: 12,
                padding: "2px 4px",
                cursor: "pointer",
                // Show it's clickable, not draggable
                boxShadow: isSelected ? `0 2px 4px ${theme.palette.primary.main}4D` : undefined
            }
        });
        const { key: key, ...restProps } = itemProps;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ...restProps,
            children: [
                itemContext.useResizeHandle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ...leftResizeProps
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                display: "block",
                                children: [
                                    trip?.tail_number,
                                    " - ",
                                    trip?.owner_manager
                                ]
                            }),
                            location && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                display: "block",
                                children: [
                                    location.type === "hangar" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dLCr5))), {
                                        sx: {
                                            fontSize: 12,
                                            mr: 0.5
                                        }
                                    }) : location.type === "ramp" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6KM07))), {
                                        sx: {
                                            fontSize: 12,
                                            mr: 0.5
                                        }
                                    }) : null,
                                    "Location: ",
                                    location.name
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                display: "block",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGBB4))), {
                                        sx: {
                                            fontSize: 12,
                                            mr: 0.5
                                        }
                                    }),
                                    (0, $kfA3C.format)((0, $7761d.parseISO)(trip?.arrival_date), "MMM d, h:mm a")
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                display: "block",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ap4xJ))), {
                                        sx: {
                                            fontSize: 12,
                                            mr: 0.5
                                        }
                                    }),
                                    (0, $gYLUy.formatDepartureDate)(trip?.departure_date)
                                ]
                            }),
                            trip?.notes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                display: "block",
                                sx: {
                                    mt: 0.5
                                },
                                children: trip.notes
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            height: itemContext.dimensions.height,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            paddingLeft: "4px",
                            fontSize: 11,
                            fontWeight: trip?.status === "active" ? 600 : 400
                        },
                        children: [
                            trip?.status === "active" && "\u25CF ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: itemContext.title
                            }),
                            location && location.type !== "transient" && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    fontSize: "10px",
                                    fontWeight: 500,
                                    marginLeft: "4px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        component: "span",
                                        sx: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            "& .MuiIcon-root": {
                                                fontSize: "14px",
                                                marginRight: "2px"
                                            }
                                        },
                                        children: location.type === "hangar" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtiLb.HangarIcon), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $apzof.RampIcon), {})
                                    }),
                                    location.name
                                ]
                            })
                        ]
                    })
                }),
                itemContext.useResizeHandle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ...rightResizeProps
                }) : null
            ]
        }, key);
    };
    // Fix z-index layering after timeline renders
    (0, $acw62.useEffect)(()=>{
        const fixZIndex = ()=>{
            // Set trip items above grid lines
            const items = document.querySelectorAll(".rct-item");
            items.forEach((item)=>{
                item.style.zIndex = "50";
            });
            // Set grid lines below trip items
            const verticalLines = document.querySelectorAll(".rct-vl");
            verticalLines.forEach((line)=>{
                line.style.zIndex = "1";
            });
            const horizontalLines = document.querySelectorAll(".rct-hl-even, .rct-hl-odd");
            horizontalLines.forEach((line)=>{
                line.style.zIndex = "1";
            });
        };
        // Fix z-index with multiple attempts to catch timeline renders
        const timers = [
            setTimeout(fixZIndex, 100),
            setTimeout(fixZIndex, 300),
            setTimeout(fixZIndex, 500),
            setTimeout(fixZIndex, 1000)
        ];
        // Also observe for dynamic changes to the timeline
        const observer = new MutationObserver(()=>{
            fixZIndex();
        });
        const timelineContainer = document.querySelector(".react-calendar-timeline");
        if (timelineContainer) observer.observe(timelineContainer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                "style"
            ]
        });
        return ()=>{
            timers.forEach((timer)=>clearTimeout(timer));
            observer.disconnect();
        };
    }, [
        trips,
        items
    ]); // Re-run when trips or items change
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            placementsLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {
                sx: {
                    mb: 1,
                    height: 2
                },
                color: "primary"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                ref: timelineContainerRef,
                className: "schedule-timeline-container",
                sx: {
                    position: "relative",
                    // CSS custom properties for timeline dark mode support
                    "--timeline-bg": theme.palette.background.paper,
                    "--timeline-bg-default": theme.palette.background.default,
                    "--timeline-border": theme.palette.divider,
                    "--timeline-text-primary": theme.palette.text.primary,
                    "--timeline-text-secondary": theme.palette.text.secondary,
                    "--timeline-header-bg": theme.palette.background.paper,
                    "--timeline-row-hover": theme.palette.action.hover,
                    "--timeline-grid-line": theme.palette.divider,
                    "--timeline-weekend-bg": theme.palette.action.selected
                },
                children: [
                    enableMultiSelect && handleClearSelection && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa19498f9d4ef8c5$export$522b8308f1751ff5), {
                        selectedCount: selectedTripIds.size,
                        onDelete: ()=>handleBulkDeleteClick?.(),
                        onClearSelection: handleClearSelection
                    }),
                    handleZoomIn && handleZoomOut && handleZoomReset && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drjQE.ZoomControl), {
                        currentZoom: currentZoomLevel,
                        increment: 0.5,
                        onClickPlus: ()=>handleZoomIn(),
                        onClickMinus: ()=>handleZoomOut(),
                        onClickReset: handleZoomReset,
                        showResetButton: true,
                        position: "absolute",
                        bottom: 16,
                        right: 16
                    }),
                    trips.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        className: "timeline-empty-state",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "h6",
                                color: "text.secondary",
                                gutterBottom: true,
                                children: "No trips in this date range"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "text.secondary",
                                children: "Scroll or zoom the timeline to find trips in other time periods"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5vA8q.default), {
                        ref: timelineRef,
                        groups: groups,
                        items: items,
                        keys: keys,
                        visibleTimeStart: defaultTimelineStart,
                        visibleTimeEnd: defaultTimelineEnd,
                        canMove: false,
                        canResize: false,
                        onItemSelect: handleItemClick,
                        selected: [],
                        buffer: 1,
                        lineHeight: 50,
                        sidebarWidth: 150,
                        itemTouchSendsClick: true,
                        itemRenderer: itemRenderer,
                        onTimeChange: handleTimeChange,
                        // Enable mouse wheel zoom
                        // @ts-expect-error - mouseZoom exists in runtime but not in type definitions
                        mouseZoom: true,
                        // Set zoom limits: 12 hours to 180 days
                        minZoom: 43200000,
                        maxZoom: 15552000000,
                        // Enable drag to scroll
                        dragSnap: 1,
                        timeSteps: {
                            second: 1,
                            minute: 1,
                            hour: 1,
                            day: 1,
                            month: 1,
                            year: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5vA8q.TimelineHeaders), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.DateHeader), {
                                        unit: "primaryHeader"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.DateHeader), {
                                        labelFormat: $4f36741c7c303977$var$customLabelFormat
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.TimelineMarkers), {
                                children: viewTimestamp ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.CustomMarker), {
                                    date: (0, $hvR20.getTime)(viewTimestamp),
                                    children: ({ styles: styles })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                ...styles,
                                                backgroundColor: "rgba(229, 62, 62, 0.7)",
                                                width: "2px",
                                                zIndex: 10
                                            }
                                        })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5vA8q.TodayMarker), {
                                    children: ({ styles: styles })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                ...styles,
                                                backgroundColor: "rgba(229, 62, 62, 0.7)",
                                                width: "2px",
                                                zIndex: 10
                                            }
                                        })
                                })
                            })
                        ]
                    })
                ]
            }),
            !inlineMode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6RcbS.TripDetailsModal), {
                open: modalOpen,
                trip: selectedTrip,
                trips: trips,
                onClose: handleModalClose,
                onUpdate: undefined,
                onNavigate: handleNavigate,
                onTripChanged: handleTripChanged,
                currentTimestamp: viewTimestamp || new Date()
            }),
            showDeleteConfirmation && handleBulkDelete && handleCancelDelete && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Delete Selected Trips",
                text: `Are you sure you want to delete ${selectedTripIds.size} selected trip${selectedTripIds.size > 1 ? "s" : ""}? This action cannot be undone.`,
                onOk: handleBulkDelete,
                onCancel: handleCancelDelete,
                onClose: handleCancelDelete,
                okText: "Delete",
                cancelText: "Cancel",
                okButtonColor: "error"
            })
        ]
    });
};


const $719c0ad99a16cdec$export$c24148711d4fc771 = ({ trips: trips, onTripsChanged: onTripsChanged, startDate: startDate, endDate: endDate, viewTimestamp: viewTimestamp, onTimeRangeChange: onTimeRangeChange, inlineMode: inlineMode = false, onTripSelect: onTripSelect, enableMultiSelect: enableMultiSelect = true, onSelectionChange: onSelectionChange, shouldResetScroll: shouldResetScroll = false, onScrollReset: onScrollReset, onScrollChange: onScrollChange })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    // Modal state
    const [selectedTripId, setSelectedTripId] = (0, $acw62.useState)(null);
    const [modalOpen, setModalOpen] = (0, $acw62.useState)(false);
    // Multi-select state
    const [selectedTripIds, setSelectedTripIds] = (0, $acw62.useState)(new Set());
    const [isShiftPressed, setIsShiftPressed] = (0, $acw62.useState)(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = (0, $acw62.useState)(false);
    // Placement state
    const [tripPlacements, setTripPlacements] = (0, $acw62.useState)({});
    const [placementsLoading, setPlacementsLoading] = (0, $acw62.useState)(false);
    const timelineContainerRef = (0, $acw62.useRef)(null);
    const timelineRef = (0, $acw62.useRef)(null); // Reference to the timeline component
    // Cache and debouncing refs
    const placementCacheRef = (0, $acw62.useRef)({});
    const debounceTimerRef = (0, $acw62.useRef)(null);
    const lastFetchedTripsRef = (0, $acw62.useRef)([]);
    // Zoom state - default to 30 day view
    const [currentZoomLevel, setCurrentZoomLevel] = (0, $acw62.useState)(1);
    const [visibleTimeStart, setVisibleTimeStart] = (0, $acw62.useState)((0, $hvR20.getTime)(startDate));
    const [visibleTimeEnd, setVisibleTimeEnd] = (0, $acw62.useState)((0, $hvR20.getTime)(endDate));
    // Track the initial/default time range for scroll detection
    const initialTimeStartRef = (0, $acw62.useRef)((0, $hvR20.getTime)(startDate));
    const initialTimeEndRef = (0, $acw62.useRef)((0, $hvR20.getTime)(endDate));
    // Initialize services
    const placementService = (0, $acw62.useMemo)(()=>new (0, $a7gZr.PlacementService)(postgrest), [
        postgrest
    ]);
    const tripService = (0, $acw62.useMemo)(()=>new (0, $lQ8IB.TripService)(postgrest), [
        postgrest
    ]);
    const selectedTrip = (0, $acw62.useMemo)(()=>trips.find((t)=>t.trip_id === selectedTripId) || null, [
        trips,
        selectedTripId
    ]);
    // Track shift key press and zoom shortcuts
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Shift") setIsShiftPressed(true);
            // Handle ESC to clear selection
            if (e.key === "Escape" && selectedTripIds.size > 0) {
                setSelectedTripIds(new Set());
                if (onSelectionChange) onSelectionChange([]);
            }
            // Handle Delete key for bulk delete
            if (e.key === "Delete" && selectedTripIds.size > 0 && enableMultiSelect) setShowDeleteConfirmation(true);
            // Handle zoom shortcuts
            if (e.key === "+" || e.key === "=") {
                e.preventDefault();
                handleZoomIn();
            }
            if (e.key === "-" || e.key === "_") {
                e.preventDefault();
                handleZoomOut();
            }
            // Reset zoom with Home key
            if (e.key === "Home") {
                e.preventDefault();
                handleZoomReset();
            }
        };
        const handleKeyUp = (e)=>{
            if (e.key === "Shift") setIsShiftPressed(false);
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, [
        selectedTripIds,
        enableMultiSelect,
        onSelectionChange,
        visibleTimeStart,
        visibleTimeEnd
    ]);
    // Notify parent of selection changes
    (0, $acw62.useEffect)(()=>{
        if (onSelectionChange) onSelectionChange(Array.from(selectedTripIds));
    }, [
        selectedTripIds,
        onSelectionChange
    ]);
    // Reset scroll when requested
    (0, $acw62.useEffect)(()=>{
        if (shouldResetScroll) {
            // Reset to initial time range
            const newStart = (0, $hvR20.getTime)(startDate);
            const newEnd = (0, $hvR20.getTime)(endDate);
            setVisibleTimeStart(newStart);
            setVisibleTimeEnd(newEnd);
            setCurrentZoomLevel(1);
            // Update refs
            initialTimeStartRef.current = newStart;
            initialTimeEndRef.current = newEnd;
            // Notify parent that reset is complete
            if (onScrollReset) onScrollReset();
        }
    }, [
        shouldResetScroll,
        startDate,
        endDate,
        onScrollReset
    ]);
    // Update initial refs when date range changes
    (0, $acw62.useEffect)(()=>{
        initialTimeStartRef.current = (0, $hvR20.getTime)(startDate);
        initialTimeEndRef.current = (0, $hvR20.getTime)(endDate);
    }, [
        startDate,
        endDate
    ]);
    // Debounced placement fetcher
    const debouncedFetchPlacements = (0, $acw62.useCallback)((tripsToFetch)=>{
        // Clear existing debounce timer
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        // Set new debounce timer
        debounceTimerRef.current = setTimeout(async ()=>{
            const tripIds = tripsToFetch.map((t)=>t.trip_id).sort();
            const lastFetchedIds = lastFetchedTripsRef.current.sort();
            // Only fetch if trip IDs actually changed
            if (JSON.stringify(tripIds) === JSON.stringify(lastFetchedIds)) return;
            setPlacementsLoading(true);
            const placementsMap = {
                ...placementCacheRef.current
            };
            // Only fetch placements for trips not in cache
            const tripsToFetchFromAPI = tripsToFetch.filter((trip)=>!placementCacheRef.current[trip.trip_id]);
            if (tripsToFetchFromAPI.length > 0) try {
                await Promise.all(tripsToFetchFromAPI.map(async (trip)=>{
                    try {
                        const placements = await placementService.getPlacementsWithLocation(trip.trip_id);
                        placementsMap[trip.trip_id] = placements;
                        placementCacheRef.current[trip.trip_id] = placements;
                    } catch (error) {
                        console.error(`Failed to fetch placements for trip ${trip.trip_id}:`, error);
                        placementsMap[trip.trip_id] = [];
                        placementCacheRef.current[trip.trip_id] = [];
                    }
                }));
            } catch (error) {
                console.error("Error fetching placements:", error);
            }
            // Update state with all placements for current trips
            const currentTripPlacements = {};
            tripsToFetch.forEach((trip)=>{
                currentTripPlacements[trip.trip_id] = placementsMap[trip.trip_id] || [];
            });
            setTripPlacements(currentTripPlacements);
            lastFetchedTripsRef.current = tripIds;
            setPlacementsLoading(false);
        }, 100); // Reduced to 100ms for faster initial load
    }, [
        placementService
    ]);
    // Fetch placements for all trips with debouncing
    (0, $acw62.useEffect)(()=>{
        if (trips.length > 0) debouncedFetchPlacements(trips);
        else {
            setTripPlacements({});
            setPlacementsLoading(false);
        }
        // Cleanup on unmount
        return ()=>{
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        };
    }, [
        trips,
        debouncedFetchPlacements
    ]);
    // Helper function to get current location for a trip
    const getTripLocation = (0, $acw62.useCallback)((tripId)=>{
        const placements = tripPlacements[tripId];
        if (!placements || placements.length === 0) return {
            name: "Unassigned",
            type: "transient"
        };
        // Get the first placement (assuming it's the current one)
        const currentPlacement = placements[0];
        return {
            name: currentPlacement.location_name || "Unassigned",
            type: currentPlacement.location_type || "transient"
        };
    }, [
        tripPlacements
    ]);
    // Helper function to determine if trip is fully assigned
    const isFullyAssigned = (0, $acw62.useCallback)((tripId)=>{
        const placements = tripPlacements[tripId];
        if (!placements || placements.length === 0) return false;
        // Check if any placement has actual hangar/ramp assignment
        return placements.some((placement)=>placement.location_name && placement.location_name !== "Unassigned" && (placement.hangar_id || placement.ramp_id));
    }, [
        tripPlacements
    ]);
    // Convert trips to timeline format
    const { groups: groups, items: items, keys: keys } = (0, $acw62.useMemo)(()=>{
        // Always create at least one empty group to maintain timeline structure
        if (trips.length === 0) return {
            groups: [
                {
                    id: "empty",
                    title: "No trips in this date range"
                }
            ],
            items: [],
            keys: {
                groupIdKey: "id",
                groupTitleKey: "title",
                itemIdKey: "id",
                itemTitleKey: "title",
                itemDivTitleKey: "title",
                itemGroupKey: "group",
                itemTimeStartKey: "start",
                itemTimeEndKey: "end"
            }
        };
        // Get unique tail numbers to create groups (rows)
        const tailNumberMap = new Map();
        trips.forEach((trip)=>{
            const tailNumber = trip.tail_number || "Unknown";
            if (!tailNumberMap.has(tailNumber)) tailNumberMap.set(tailNumber, tailNumber);
        });
        // Create groups (one per tail number)
        const groups = Array.from(tailNumberMap.keys()).map((tailNumber)=>({
                id: tailNumber,
                title: tailNumber,
                height: 50
            }));
        // Create items (all trips)
        const items = trips.map((trip)=>{
            // Initial background color (will be properly set in itemRenderer)
            let backgroundColor = "#949494"; // Default gray
            return {
                id: trip.trip_id,
                group: trip.tail_number || "Unknown",
                title: trip.notes || `[${trip.status.toUpperCase()}]`,
                start: (0, $hvR20.getTime)((0, $7761d.parseISO)(trip.arrival_date)),
                // Handle infinity departure (base tenants) - extend to right edge of timeline
                end: (0, $gYLUy.isInfinityDate)(trip.departure_date) ? visibleTimeEnd : (0, $hvR20.getTime)((0, $7761d.parseISO)(trip.departure_date)),
                // Removed className to prevent CSS conflicts - colors are handled by inline styles
                itemProps: {
                    "data-trip-id": trip.trip_id,
                    "data-status": trip.status,
                    style: {
                        background: backgroundColor,
                        borderTopWidth: trip.status === "active" ? 2 : 1,
                        borderRightWidth: trip.status === "active" ? 2 : 1,
                        borderBottomWidth: trip.status === "active" ? 2 : 1,
                        borderLeftWidth: trip.status === "active" ? 2 : 1,
                        borderStyle: "solid",
                        borderColor: trip.status === "active" ? "#1976d2" : "rgba(0,0,0,0.1)",
                        color: "#000",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                        zIndex: "auto",
                        cursor: "pointer" // Show it's clickable, not draggable
                    }
                },
                canMove: false,
                // Disable drag to move
                canResize: false,
                // Disable drag to resize
                canChangeGroup: false // Don't allow moving between aircraft
            };
        });
        const keys = {
            groupIdKey: "id",
            groupTitleKey: "title",
            groupLabelKey: "title",
            groupRightTitleKey: "rightTitle",
            itemIdKey: "id",
            itemTitleKey: "title",
            itemDivTitleKey: "title",
            itemGroupKey: "group",
            itemTimeStartKey: "start",
            itemTimeEndKey: "end"
        };
        return {
            groups: groups,
            items: items,
            keys: keys
        };
    }, [
        trips,
        tripPlacements
    ]); // Added tripPlacements to trigger re-render when placements load
    // Get border color based on status and assignment
    const getBorderColor = (0, $acw62.useCallback)((trip, tripId)=>{
        if (trip.status === "active") return "#1976d2"; // Blue border for active
        if (trip.status === "scheduled" && isFullyAssigned(tripId)) return "#1976d2"; // Blue border for assigned scheduled trips
        if (trip.status === "scheduled" && !isFullyAssigned(tripId)) return "rgba(0,0,0,0.1)"; // Light gray border for unassigned scheduled trips
        return "rgba(0,0,0,0.1)"; // Light gray for completed/cancelled/other
    }, [
        isFullyAssigned
    ]);
    // Get border width based on status and assignment
    const getBorderWidth = (0, $acw62.useCallback)((trip, tripId)=>{
        if (trip.status === "active") return 2; // Thick border for active
        if (trip.status === "scheduled" && isFullyAssigned(tripId)) return 2; // Thick blue border for assigned scheduled trips
        if (trip.status === "scheduled" && !isFullyAssigned(tripId)) return 1; // Thin border for unassigned scheduled trips
        return 1; // Thin border for completed/cancelled/others
    }, [
        isFullyAssigned
    ]);
    // Handle item click
    const handleItemClick = (0, $acw62.useCallback)((itemId, e)=>{
        // Check if this is a shift+click for multi-select
        if (enableMultiSelect && (isShiftPressed || e?.shiftKey)) // Toggle selection
        setSelectedTripIds((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(itemId)) newSet.delete(itemId);
            else newSet.add(itemId);
            return newSet;
        });
        else if (inlineMode && onTripSelect) // In inline mode, just call the callback
        onTripSelect(itemId);
        else // In normal mode, open the modal
        if (selectedTripId === itemId && !modalOpen) setModalOpen(true);
        else {
            setSelectedTripId(itemId);
            setModalOpen(true);
        }
    }, [
        selectedTripId,
        modalOpen,
        inlineMode,
        onTripSelect,
        isShiftPressed,
        enableMultiSelect
    ]);
    // Handle navigation to different trip
    const handleNavigate = (0, $acw62.useCallback)((tripId)=>{
        setSelectedTripId(tripId);
    }, []);
    // Handle modal close
    const handleModalClose = (0, $acw62.useCallback)(()=>{
        setModalOpen(false);
    // Don't clear selectedTripId here to maintain the selection for re-clicking
    }, []);
    // Handle trip changes (refresh placements when trip is updated)
    const handleTripChanged = (0, $acw62.useCallback)(async ()=>{
        // Clear cache for affected trips and refetch
        placementCacheRef.current = {};
        lastFetchedTripsRef.current = [];
        // Trigger parent to reload trip data
        if (onTripsChanged) await onTripsChanged();
        // After trip data is refreshed, refetch placements for new trip list
        if (trips.length > 0) debouncedFetchPlacements(trips);
    }, [
        trips,
        debouncedFetchPlacements,
        onTripsChanged
    ]);
    // Handle timeline viewport changes (drag, zoom, etc.)
    const handleTimeChange = (0, $acw62.useCallback)((visibleTimeStart, visibleTimeEnd, updateScrollCanvas)=>{
        // Update visible time state
        setVisibleTimeStart(visibleTimeStart);
        setVisibleTimeEnd(visibleTimeEnd);
        // Check if we've scrolled away from initial position
        if (onScrollChange) {
            const hasScrolled = Math.abs(visibleTimeStart - initialTimeStartRef.current) > 60000 || // More than 1 minute difference
            Math.abs(visibleTimeEnd - initialTimeEndRef.current) > 60000;
            onScrollChange(hasScrolled);
        }
        // Convert milliseconds to Date objects
        const newStartDate = new Date(visibleTimeStart);
        const newEndDate = new Date(visibleTimeEnd);
        // Notify parent component of the time range change
        if (onTimeRangeChange) onTimeRangeChange(newStartDate, newEndDate);
        // Call the updateScrollCanvas function to update the timeline
        updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
    }, [
        onTimeRangeChange,
        onScrollChange
    ]);
    // Zoom handler functions
    const handleZoomIn = (0, $acw62.useCallback)(()=>{
        const zoom = 1.5;
        const centerTime = (visibleTimeStart + visibleTimeEnd) / 2;
        const newHalfDuration = (visibleTimeEnd - visibleTimeStart) / 2 / zoom;
        // Check against minimum zoom (12 hours)
        const minZoom = 43200000;
        if (newHalfDuration * 2 < minZoom) return;
        const newStart = centerTime - newHalfDuration;
        const newEnd = centerTime + newHalfDuration;
        setVisibleTimeStart(newStart);
        setVisibleTimeEnd(newEnd);
        setCurrentZoomLevel(currentZoomLevel * zoom);
        // Notify parent about scroll state change after zooming
        if (onScrollChange) {
            const hasScrolled = Math.abs(newStart - initialTimeStartRef.current) > 60000 || // More than 1 minute difference
            Math.abs(newEnd - initialTimeEndRef.current) > 60000;
            onScrollChange(hasScrolled);
        }
    }, [
        visibleTimeStart,
        visibleTimeEnd,
        currentZoomLevel,
        onScrollChange
    ]);
    const handleZoomOut = (0, $acw62.useCallback)(()=>{
        const zoom = 0.75;
        const centerTime = (visibleTimeStart + visibleTimeEnd) / 2;
        const newHalfDuration = (visibleTimeEnd - visibleTimeStart) / 2 / zoom;
        // Check against maximum zoom (180 days)
        const maxZoom = 15552000000;
        if (newHalfDuration * 2 > maxZoom) return;
        const newStart = centerTime - newHalfDuration;
        const newEnd = centerTime + newHalfDuration;
        setVisibleTimeStart(newStart);
        setVisibleTimeEnd(newEnd);
        setCurrentZoomLevel(currentZoomLevel * zoom);
        // Notify parent about scroll state change after zooming
        if (onScrollChange) {
            const hasScrolled = Math.abs(newStart - initialTimeStartRef.current) > 60000 || // More than 1 minute difference
            Math.abs(newEnd - initialTimeEndRef.current) > 60000;
            onScrollChange(hasScrolled);
        }
    }, [
        visibleTimeStart,
        visibleTimeEnd,
        currentZoomLevel,
        onScrollChange
    ]);
    const handleZoomReset = (0, $acw62.useCallback)(()=>{
        setVisibleTimeStart((0, $hvR20.getTime)(startDate));
        setVisibleTimeEnd((0, $hvR20.getTime)(endDate));
        setCurrentZoomLevel(1);
    }, [
        startDate,
        endDate
    ]);
    // Sync visible time range with startDate/endDate props when they change
    (0, $acw62.useEffect)(()=>{
        setVisibleTimeStart((0, $hvR20.getTime)(startDate));
        setVisibleTimeEnd((0, $hvR20.getTime)(endDate));
        setCurrentZoomLevel(1); // Reset zoom level when date range changes
    }, [
        startDate,
        endDate
    ]);
    // Handle bulk delete button click (shows confirmation)
    const handleBulkDeleteClick = (0, $acw62.useCallback)(()=>{
        if (selectedTripIds.size > 0) setShowDeleteConfirmation(true);
    }, [
        selectedTripIds
    ]);
    // Handle bulk delete (actual deletion)
    const handleBulkDelete = (0, $acw62.useCallback)(async ()=>{
        if (selectedTripIds.size === 0) return;
        try {
            const tripIdsArray = Array.from(selectedTripIds);
            // Delete each trip
            await Promise.all(tripIdsArray.map((tripId)=>tripService.deleteTrip(tripId)));
            // Clear selection
            setSelectedTripIds(new Set());
            setShowDeleteConfirmation(false);
            // Show success message
            snackbar.notify({
                text: `Successfully deleted ${tripIdsArray.length} trip${tripIdsArray.length > 1 ? "s" : ""}`,
                severity: "success"
            });
            // Refresh trips
            if (onTripsChanged) await onTripsChanged();
        } catch (error) {
            console.error("Failed to delete trips:", error);
            snackbar.notify({
                text: "Failed to delete some trips. Please try again.",
                severity: "error"
            });
        }
    }, [
        selectedTripIds,
        tripService,
        snackbar,
        onTripsChanged
    ]);
    // Handle cancel deletion
    const handleCancelDelete = (0, $acw62.useCallback)(()=>{
        setShowDeleteConfirmation(false);
    }, []);
    // Clear selection handler for toolbar
    const handleClearSelection = (0, $acw62.useCallback)(()=>{
        setSelectedTripIds(new Set());
        if (onSelectionChange) onSelectionChange([]);
    }, [
        onSelectionChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f36741c7c303977$export$916dfb5c1f8daeeb), {
        trips: trips,
        groups: groups,
        items: items,
        keys: keys,
        selectedTrip: selectedTrip,
        modalOpen: modalOpen,
        placementsLoading: placementsLoading,
        startDate: startDate,
        endDate: endDate,
        viewTimestamp: viewTimestamp,
        timelineContainerRef: timelineContainerRef,
        timelineRef: timelineRef,
        handleItemClick: handleItemClick,
        handleModalClose: handleModalClose,
        handleNavigate: handleNavigate,
        handleTripChanged: handleTripChanged,
        handleTimeChange: handleTimeChange,
        getTripLocation: getTripLocation,
        getBorderColor: getBorderColor,
        getBorderWidth: getBorderWidth,
        inlineMode: inlineMode,
        // Zoom props
        visibleTimeStart: visibleTimeStart,
        visibleTimeEnd: visibleTimeEnd,
        currentZoomLevel: currentZoomLevel,
        handleZoomIn: handleZoomIn,
        handleZoomOut: handleZoomOut,
        handleZoomReset: handleZoomReset,
        // Multi-select props
        selectedTripIds: selectedTripIds,
        enableMultiSelect: enableMultiSelect,
        showDeleteConfirmation: showDeleteConfirmation,
        handleBulkDelete: handleBulkDelete,
        handleBulkDeleteClick: handleBulkDeleteClick,
        handleCancelDelete: handleCancelDelete,
        handleClearSelection: handleClearSelection
    });
};



var $7y2Rw = parcelRequire("7y2Rw");

var $6RcbS = parcelRequire("6RcbS");
const $41dc4aa0c8c58a28$export$cc58e68b1f877ead = ({ activeFBO: activeFBO, currentTime: currentTime, handleTimeChange: handleTimeChange, handleNowClick: handleNowClick, isTimelineScrolledAway: isTimelineScrolledAway, startDate: startDate, endDate: endDate, trips: trips, filteredTrips: filteredTrips, loading: loading, error: error, createDialogOpen: createDialogOpen, setCreateDialogOpen: setCreateDialogOpen, bulkUploadOpen: bulkUploadOpen, setBulkUploadOpen: setBulkUploadOpen, tripDetailsOpen: tripDetailsOpen, selectedTrip: selectedTrip, viewMode: viewMode, handleViewModeChange: handleViewModeChange, loadTrips: loadTrips, handleTripCreated: handleTripCreated, handleTripEdit: handleTripEdit, handleTripDetailsClose: handleTripDetailsClose, handleBulkUploadComplete: handleBulkUploadComplete, handleTimeRangeChange: handleTimeRangeChange, shouldResetScroll: shouldResetScroll, handleScrollReset: handleScrollReset, handleTimelineScrollChange: handleTimelineScrollChange, locations: locations, selectedLocationIds: selectedLocationIds, setSelectedLocationIds: setSelectedLocationIds, statusFilter: statusFilter, setStatusFilter: setStatusFilter, tailNumberFilter: tailNumberFilter, setTailNumberFilter: setTailNumberFilter })=>{
    if (!activeFBO) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
            severity: "warning",
            children: "Please select an FBO to view the schedule."
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            height: "100%",
            py: 3,
            px: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: 3,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "h4",
                                    children: "Trip Schedule"
                                }),
                                selectedLocationIds.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: `Filtered: ${selectedLocationIds.length} location${selectedLocationIds.length > 1 ? 's' : ''}`,
                                    size: "small",
                                    color: "primary",
                                    variant: "outlined",
                                    onDelete: ()=>setSelectedLocationIds([])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ZYXn.default), {
                                    value: viewMode,
                                    exclusive: true,
                                    onChange: handleViewModeChange,
                                    size: "small",
                                    sx: {
                                        "& .MuiToggleButton-root": {
                                            px: 2,
                                            py: 1,
                                            border: "1px solid",
                                            borderColor: "divider",
                                            "&.Mui-selected": {
                                                backgroundColor: "primary.main",
                                                color: "primary.contrastText",
                                                "&:hover": {
                                                    backgroundColor: "primary.dark"
                                                }
                                            },
                                            "&:hover": {
                                                backgroundColor: "action.hover"
                                            }
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "View trips in a visual timeline/GANTT chart",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJ0JC.default), {
                                                value: "timeline",
                                                "aria-label": "timeline view",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                                                        name: "TimelineIcon",
                                                        sx: {
                                                            mr: 0.5
                                                        }
                                                    }),
                                                    "Timeline"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "View trips in a detailed data table",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJ0JC.default), {
                                                value: "table",
                                                "aria-label": "table view",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                                                        name: "TableViewIcon",
                                                        sx: {
                                                            mr: 0.5
                                                        }
                                                    }),
                                                    "Table"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9nMz.SplitButton), {
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fu9Og.LazyIcon), {
                                        name: "AddIcon"
                                    }),
                                    options: [
                                        {
                                            label: "Create Trip",
                                            onClick: ()=>setCreateDialogOpen(true)
                                        },
                                        {
                                            label: "Bulk Import",
                                            onClick: ()=>setBulkUploadOpen(true)
                                        }
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                    elevation: 1,
                    sx: {
                        p: 2,
                        mb: 2,
                        backgroundColor: "background.paper"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e2c32697d5f2458$export$8dd6e5a51d2bd2e8), {
                                currentTime: currentTime,
                                startDate: startDate,
                                endDate: endDate,
                                onTimeChange: handleTimeChange,
                                onNowClick: handleNowClick,
                                isScrolledAway: isTimelineScrolledAway
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                                        size: "small",
                                        sx: {
                                            minWidth: 120
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                                                value: statusFilter,
                                                label: "Status",
                                                onChange: (e)=>setStatusFilter(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "all",
                                                        children: "All Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "scheduled",
                                                        children: "Scheduled"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "active",
                                                        children: "Active"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "completed",
                                                        children: "Completed"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "cancelled",
                                                        children: "Cancelled"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        label: "Filter by Tail Number",
                                        variant: "outlined",
                                        size: "small",
                                        value: tailNumberFilter,
                                        onChange: (e)=>setTailNumberFilter(e.target.value),
                                        sx: {
                                            minWidth: 200
                                        },
                                        placeholder: "N123AB"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be544fa411c3beeb$export$c6e326473c442588), {
                                        locations: locations,
                                        selectedLocationIds: selectedLocationIds,
                                        onChange: setSelectedLocationIds,
                                        disabled: loading
                                    })
                                ]
                            })
                        ]
                    })
                }),
                loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    display: "flex",
                    justifyContent: "center",
                    py: 4,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {})
                }) : error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                    severity: "error",
                    children: error
                }) : viewMode === "timeline" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $164d2a3175b4615c$export$e926676385687eaf), {
                        fallbackTitle: "Timeline Error",
                        fallbackDescription: "There was an error loading the timeline view. Please try refreshing or switching to table view.",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $719c0ad99a16cdec$export$c24148711d4fc771), {
                            trips: filteredTrips,
                            onTripsChanged: loadTrips,
                            startDate: startDate,
                            endDate: endDate,
                            viewTimestamp: currentTime,
                            onTimeRangeChange: handleTimeRangeChange,
                            shouldResetScroll: shouldResetScroll,
                            onScrollReset: handleScrollReset,
                            onScrollChange: handleTimelineScrollChange
                        })
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: filteredTrips.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                        elevation: 1,
                        sx: {
                            p: 4,
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: "No trips scheduled for the selected date range"
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f2bb41b06b8c886$export$3ffcf01f528c086f), {
                        trips: filteredTrips,
                        loading: loading,
                        onTripsUpdated: loadTrips,
                        onTripEdit: handleTripEdit,
                        startDate: startDate,
                        endDate: endDate,
                        statusFilter: statusFilter,
                        tailNumberFilter: tailNumberFilter
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35bYL.CreateTripDialog), {
                    open: createDialogOpen,
                    onClose: ()=>setCreateDialogOpen(false),
                    onSuccess: handleTripCreated
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6RcbS.TripDetailsModal), {
                    open: tripDetailsOpen,
                    trip: selectedTrip,
                    trips: trips,
                    onClose: handleTripDetailsClose,
                    onUpdate: undefined,
                    onTripChanged: loadTrips
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7y2Rw.SimpleBulkUpload), {
                    open: bulkUploadOpen,
                    onClose: ()=>setBulkUploadOpen(false),
                    onComplete: handleBulkUploadComplete
                })
            ]
        })
    });
};


const $cb8f6db42767ecd7$export$5d14f38e6b79c033 = ()=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { hangars: hangars } = (0, $7FzhI.useHangarsState)();
    const { ramps: ramps } = (0, $3AGzj.useRampsState)();
    // Current time state
    const [currentTime, setCurrentTime] = (0, $acw62.useState)(()=>(0, $55RUj.floorToQuarterHour)(new Date()));
    // Visible date range state - default to current date -7 days to +30 days
    const [visibleStartDate, setVisibleStartDate] = (0, $acw62.useState)(()=>(0, $g04kv.startOfDay)((0, $7S0ew.addDays)(new Date(), -7)));
    const [visibleEndDate, setVisibleEndDate] = (0, $acw62.useState)(()=>(0, $2CcMD.endOfDay)((0, $7S0ew.addDays)(new Date(), 30)));
    const [trips, setTrips] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [createDialogOpen, setCreateDialogOpen] = (0, $acw62.useState)(false);
    const [bulkUploadOpen, setBulkUploadOpen] = (0, $acw62.useState)(false);
    const [selectedTrip, setSelectedTrip] = (0, $acw62.useState)(null);
    const [tripDetailsOpen, setTripDetailsOpen] = (0, $acw62.useState)(false);
    const [viewMode, setViewMode] = (0, $acw62.useState)(()=>{
        const saved = localStorage.getItem("scheduleViewMode");
        return saved === "table" || saved === "timeline" ? saved : "timeline";
    });
    // Track if timeline is scrolled away from initial position
    const [isTimelineScrolledAway, setIsTimelineScrolledAway] = (0, $acw62.useState)(false);
    const [shouldResetScroll, setShouldResetScroll] = (0, $acw62.useState)(false);
    // Initialize services
    const tripService = (0, $acw62.useMemo)(()=>new (0, $lQ8IB.TripService)(postgrest), [
        postgrest
    ]);
    // Filter states
    const [selectedLocationIds, setSelectedLocationIds] = (0, $acw62.useState)([]);
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)("all");
    const [tailNumberFilter, setTailNumberFilter] = (0, $acw62.useState)("");
    // Load trips for the current FBO
    const loadTrips = async ()=>{
        if (!activeFBO?.id) return;
        setLoading(true);
        setError(null);
        try {
            // Load trips with tenant and placement info
            const allTrips = await tripService.listTripsWithTenantAndPlacement(activeFBO.id);
            // Rename trip_id to id for consistency
            const tripsWithId = allTrips.map((trip)=>({
                    ...trip,
                    id: trip.trip_id
                }));
            setTrips(tripsWithId);
        } catch (err) {
            console.error("Failed to load trips:", err);
            setError("Failed to load trips. Please try again.");
        } finally{
            setLoading(false);
        }
    };
    // Handle current time changes
    const handleTimeChange = (0, $acw62.useCallback)((newTime)=>{
        setCurrentTime(newTime);
    }, []);
    // Handle Now button click - reset time and scroll
    const handleNowClick = (0, $acw62.useCallback)(()=>{
        const now = (0, $55RUj.floorToQuarterHour)(new Date());
        setCurrentTime(now);
        // Update visible date range to center on "now"
        setVisibleStartDate((0, $g04kv.startOfDay)((0, $7S0ew.addDays)(now, -7)));
        setVisibleEndDate((0, $2CcMD.endOfDay)((0, $7S0ew.addDays)(now, 30)));
        setShouldResetScroll(true);
        setIsTimelineScrolledAway(false);
    }, []);
    // Handle timeline scroll changes
    const handleTimelineScrollChange = (0, $acw62.useCallback)((scrolledAway)=>{
        setIsTimelineScrolledAway(scrolledAway);
    }, []);
    // Handle scroll reset acknowledgment from timeline
    const handleScrollReset = (0, $acw62.useCallback)(()=>{
        setShouldResetScroll(false);
    }, []);
    // Create debounced update function for visible date range
    const debouncedTimeRangeUpdate = (0, $acw62.useMemo)(()=>(0, $cLNZr.debounce)((start, end)=>{
            setVisibleStartDate(start);
            setVisibleEndDate(end);
        }, 100), // 100ms debounce to prevent excessive updates during dragging
    []);
    // Handle timeline viewport changes
    const handleTimeRangeChange = (0, $acw62.useCallback)((newStartDate, newEndDate)=>{
        debouncedTimeRangeUpdate(newStartDate, newEndDate);
    }, [
        debouncedTimeRangeUpdate
    ]);
    (0, $acw62.useEffect)(()=>{
        loadTrips();
    }, [
        activeFBO?.id
    ]);
    // Adjust visible date range when location filter changes
    (0, $acw62.useEffect)(()=>{
        if (selectedLocationIds.length === 0) {
            // Reset to default range when no filter is applied
            const now = new Date();
            setVisibleStartDate((0, $g04kv.startOfDay)((0, $7S0ew.addDays)(now, -7)));
            setVisibleEndDate((0, $2CcMD.endOfDay)((0, $7S0ew.addDays)(now, 30)));
            return;
        }
        // Filter trips by selected locations
        const locationFilteredTrips = trips.filter((trip)=>selectedLocationIds.some((locationId)=>trip.hangar_id === locationId || trip.ramp_id === locationId));
        if (locationFilteredTrips.length === 0) // No trips found in selected locations, keep current range
        return;
        // Find the date range of filtered trips
        let earliestDate = null;
        let latestDate = null;
        locationFilteredTrips.forEach((trip)=>{
            const arrivalDate = new Date(trip.arrival_date);
            const departureDate = new Date(trip.departure_date);
            if (!earliestDate || arrivalDate < earliestDate) earliestDate = arrivalDate;
            if (!latestDate || departureDate > latestDate) latestDate = departureDate;
        });
        if (earliestDate && latestDate) {
            // Add padding: 3 days before earliest and 3 days after latest
            const paddedStart = (0, $g04kv.startOfDay)((0, $7S0ew.addDays)(earliestDate, -3));
            const paddedEnd = (0, $2CcMD.endOfDay)((0, $7S0ew.addDays)(latestDate, 3));
            setVisibleStartDate(paddedStart);
            setVisibleEndDate(paddedEnd);
        }
    }, [
        selectedLocationIds,
        trips
    ]);
    // Combine hangars and ramps into location list with trip counts
    const locations = (0, $acw62.useMemo)(()=>{
        const locationMap = new Map();
        // Add hangars
        if (hangars) hangars.forEach((hangar)=>{
            locationMap.set(hangar.id, {
                id: hangar.id,
                name: hangar.name,
                type: "hangar",
                tripCount: 0
            });
        });
        // Add ramps
        if (ramps) ramps.forEach((ramp)=>{
            locationMap.set(ramp.id, {
                id: ramp.id,
                name: ramp.name,
                type: "ramp",
                tripCount: 0
            });
        });
        // Count trips per location based on their placement data
        trips.forEach((trip)=>{
            if (trip.hangar_id) {
                const location = locationMap.get(trip.hangar_id);
                if (location) location.tripCount++;
            }
            if (trip.ramp_id) {
                const location = locationMap.get(trip.ramp_id);
                if (location) location.tripCount++;
            }
        });
        return Array.from(locationMap.values());
    }, [
        hangars,
        ramps,
        trips
    ]);
    // Filter trips by visible date range, selected locations, status, and tail number
    const filteredTrips = (0, $acw62.useMemo)(()=>{
        return trips.filter((trip)=>{
            // Filter by date range - include trips that overlap with the visible range
            const tripStart = new Date(trip.arrival_date);
            // Handle infinity departure (base tenants never end)
            const tripEnd = (0, $gYLUy.isInfinityDate)(trip.departure_date) ? new Date('2099-12-31') // Far future for comparison
             : new Date(trip.departure_date);
            const dateMatch = tripStart <= visibleEndDate && tripEnd >= visibleStartDate;
            if (!dateMatch) return false;
            // Filter by location if any are selected
            if (selectedLocationIds.length > 0) {
                const locationMatch = selectedLocationIds.some((locationId)=>trip.hangar_id === locationId || trip.ramp_id === locationId);
                if (!locationMatch) return false;
            }
            // Filter by status
            if (statusFilter !== "all" && trip.status !== statusFilter) return false;
            // Filter by tail number
            if (tailNumberFilter && trip.tail_number) {
                const matchesTailNumber = trip.tail_number.toLowerCase().includes(tailNumberFilter.toLowerCase());
                if (!matchesTailNumber) return false;
            }
            return true;
        });
    }, [
        trips,
        visibleStartDate,
        visibleEndDate,
        selectedLocationIds,
        statusFilter,
        tailNumberFilter
    ]);
    // Handle trip creation success
    const handleTripCreated = ()=>{
        setCreateDialogOpen(false);
        loadTrips();
    };
    // Handle trip edit
    const handleTripEdit = (0, $acw62.useCallback)((trip)=>{
        setSelectedTrip(trip);
        setTripDetailsOpen(true);
    }, []);
    // Handle trip details close
    const handleTripDetailsClose = (0, $acw62.useCallback)(()=>{
        setTripDetailsOpen(false);
        setSelectedTrip(null);
    }, []);
    // Handle bulk upload completion
    const handleBulkUploadComplete = (0, $acw62.useCallback)((_)=>{
        setBulkUploadOpen(false);
        loadTrips(); // Reload trips after bulk upload
    }, []);
    // Handle view mode change
    const handleViewModeChange = (_, newMode)=>{
        if (newMode !== null) {
            setViewMode(newMode);
            localStorage.setItem("scheduleViewMode", newMode);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41dc4aa0c8c58a28$export$cc58e68b1f877ead), {
        activeFBO: activeFBO,
        currentTime: currentTime,
        handleTimeChange: handleTimeChange,
        handleNowClick: handleNowClick,
        isTimelineScrolledAway: isTimelineScrolledAway,
        startDate: visibleStartDate,
        endDate: visibleEndDate,
        trips: trips,
        filteredTrips: filteredTrips,
        loading: loading,
        error: error,
        createDialogOpen: createDialogOpen,
        setCreateDialogOpen: setCreateDialogOpen,
        bulkUploadOpen: bulkUploadOpen,
        setBulkUploadOpen: setBulkUploadOpen,
        tripDetailsOpen: tripDetailsOpen,
        selectedTrip: selectedTrip,
        viewMode: viewMode,
        handleViewModeChange: handleViewModeChange,
        loadTrips: loadTrips,
        handleTripCreated: handleTripCreated,
        handleTripEdit: handleTripEdit,
        handleTripDetailsClose: handleTripDetailsClose,
        handleBulkUploadComplete: handleBulkUploadComplete,
        handleTimeRangeChange: handleTimeRangeChange,
        shouldResetScroll: shouldResetScroll,
        handleScrollReset: handleScrollReset,
        handleTimelineScrollChange: handleTimelineScrollChange,
        locations: locations,
        selectedLocationIds: selectedLocationIds,
        setSelectedLocationIds: setSelectedLocationIds,
        statusFilter: statusFilter,
        setStatusFilter: setStatusFilter,
        tailNumberFilter: tailNumberFilter,
        setTailNumberFilter: setTailNumberFilter
    });
};


const $8f38d70b2b37b143$export$5d14f38e6b79c033 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
            isReference: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb8f6db42767ecd7$export$5d14f38e6b79c033), {})
        })
    });
};


parcelRequire("hldFD");
var $lCpGu = parcelRequire("lCpGu");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $gqehT = parcelRequire("gqehT");

var $l5ED9 = parcelRequire("l5ED9");

var $3kyM0 = parcelRequire("3kyM0");
const $2f6414e3914b3f0c$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $2f6414e3914b3f0c$export$89200835fb4edfb9 = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $gqehT.useIdentity)();
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const { url: tokenMakerURL } = (0, $3kyM0.useTokenMaker)();
    const [email, setEmail] = $acw62.useState(location.state?.email || "");
    const [password, setPassword] = $acw62.useState("");
    const [confirmPassword, setConfirmPassword] = $acw62.useState("");
    const [loading, setLoading] = $acw62.useState(false);
    const [error, setError] = $acw62.useState("");
    const postgrest = $acw62.useMemo(()=>{
        return (0, $l5ED9.createUnauthenticatedPostgrest)();
    }, []);
    if (isLoggedIn) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/",
        replace: true
    });
    const validateEmail = ()=>{
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError("Please enter a valid email address");
            return false;
        }
        return true;
    };
    const validatePassword = ()=>{
        if (password.length < 8) {
            setError("Password must be at least 8 characters");
            return false;
        }
        if (!/[A-Z]/.test(password)) {
            setError("Password must contain at least one uppercase letter");
            return false;
        }
        if (!/[a-z]/.test(password)) {
            setError("Password must contain at least one lowercase letter");
            return false;
        }
        if (!/[0-9]/.test(password)) {
            setError("Password must contain at least one number");
            return false;
        }
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return false;
        }
        return true;
    };
    const handleSignup = async ()=>{
        setError("");
        if (!validateEmail() || !validatePassword()) return;
        setLoading(true);
        try {
            // Register user (creates unverified user, returns email)
            const { data: registeredEmail, error: rpcError } = await postgrest.rpc("register_with_password", {
                p_email: email,
                p_password: password
            });
            if (rpcError) {
                setError(rpcError.message || "Failed to create account");
                setLoading(false);
                return;
            }
            if (!registeredEmail) {
                setError("Failed to create account. Please try again.");
                setLoading(false);
                return;
            }
            // Send verification email
            await fetch(`${tokenMakerURL}/send-verification-email`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email
                })
            });
            // Redirect to verification page
            navigate("/verify-email", {
                state: {
                    email: email
                }
            });
        } catch (err) {
            setError(err.message || "An error occurred. Please try again.");
            console.error("Error signing up:", err);
            setLoading(false);
        }
    };
    const getPasswordStrength = ()=>{
        if (!password) return "";
        if (password.length < 8) return "Too short";
        let strength = 0;
        if (/[A-Z]/.test(password)) strength++;
        if (/[a-z]/.test(password)) strength++;
        if (/[0-9]/.test(password)) strength++;
        if (/[^A-Za-z0-9]/.test(password)) strength++;
        if (strength === 4 && password.length >= 12) return "Strong";
        if (strength >= 3) return "Good";
        if (strength >= 2) return "Fair";
        return "Weak";
    };
    const passwordStrength = getPasswordStrength();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                sx: {
                    height: "100%",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        width: 368,
                        margin: "auto",
                        border: "2px solid #E2E2E2",
                        p: 3,
                        mt: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    align: "center",
                                    variant: "h4",
                                    children: "Create Account"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    align: "center",
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: "Sign up to get started"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Email",
                                    type: "email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    fullWidth: true,
                                    autoFocus: true,
                                    disabled: loading
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Password",
                                    type: "password",
                                    value: password,
                                    onChange: (e)=>setPassword(e.target.value),
                                    fullWidth: true,
                                    disabled: loading
                                }),
                                password && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    sx: {
                                        mt: -1
                                    },
                                    color: passwordStrength === "Strong" ? "success.main" : passwordStrength === "Good" ? "primary.main" : passwordStrength === "Fair" ? "warning.main" : "error.main",
                                    children: [
                                        "Strength: ",
                                        passwordStrength
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Confirm Password",
                                    type: "password",
                                    value: confirmPassword,
                                    onChange: (e)=>setConfirmPassword(e.target.value),
                                    onKeyPress: (e)=>e.key === "Enter" && handleSignup(),
                                    fullWidth: true,
                                    error: Boolean(error),
                                    helperText: error,
                                    disabled: loading
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: "Must be 8+ characters with uppercase, lowercase, and numbers"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    onClick: handleSignup,
                                    fullWidth: true,
                                    disabled: loading || !email || !password || !confirmPassword,
                                    sx: {
                                        borderRadius: 1
                                    },
                                    children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                        size: 24
                                    }) : "Sign Up"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    align: "center",
                                    color: "text.secondary",
                                    children: [
                                        "Already have an account?",
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                            to: "/login",
                                            style: {
                                                textDecoration: "none",
                                                color: "#0066cc"
                                            },
                                            children: "Log in"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: $2f6414e3914b3f0c$var$logo,
                style: {
                    position: "fixed",
                    bottom: 15,
                    right: 15,
                    width: 50
                }
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7FzhI = parcelRequire("7FzhI");

var $ayMG0 = parcelRequire("ayMG0");

var $2WBL0 = parcelRequire("2WBL0");

var $4VwvT = parcelRequire("4VwvT");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $5sKyw = parcelRequire("5sKyw");

var $ggtZr = parcelRequire("ggtZr");

var $7FzhI = parcelRequire("7FzhI");

var $gqehT = parcelRequire("gqehT");

var $3kyM0 = parcelRequire("3kyM0");

var $keHtM = parcelRequire("keHtM");

var $lNEp2 = parcelRequire("lNEp2");

var $cLNZr = parcelRequire("cLNZr");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");

var $1lfQl = parcelRequire("1lfQl");

var $3bYfT = parcelRequire("3bYfT");
const $c7ae214ca7ee945f$export$3ced3c1b5b85482c = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            width: "100%",
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    width: "100%",
                    mr: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {
                    variant: "determinate",
                    ...props
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    minWidth: 35
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body2",
                    color: "text.secondary",
                    children: `${Math.round(props.value)}%`
                })
            })
        ]
    });
};





var $78CAK = parcelRequire("78CAK");
parcelRequire("f1x1q");
var $iJtNT = parcelRequire("iJtNT");

var $eYWyk = parcelRequire("eYWyk");

const $52cd12c2ac5b9257$var$calculateStackedAirplanes = (result)=>{
    return result.layoutOptions.map((layoutOption)=>{
        return layoutOption.stackMembers.filter((s)=>s.x !== null).length;
    });
};
const $52cd12c2ac5b9257$var$calculateStackUtilizations = (result)=>{
    return result.layoutOptions.map((layoutOption)=>{
        return (0, $lNEp2.calcStackUtilization)(result.hangar, {
            id: (0, $5sKyw.default)(),
            options: layoutOption.paramSet.options,
            tenants: layoutOption.stackMembers.map((stackMember)=>({
                    ...result.hangar.stack.tenants.find((t)=>t.placement_id === stackMember.placement_id),
                    selected: false,
                    // overwrite or keep?
                    position: {
                        ...result.hangar.stack.tenants.find((t)=>t.placement_id === stackMember.placement_id).position,
                        x: stackMember.x,
                        y: stackMember.y,
                        angle: stackMember.angle
                    }
                })),
            isReference: false,
            movableObstacles: []
        });
    });
};
const $52cd12c2ac5b9257$var$convertLayoutToHangarStacks = (result)=>{
    return result.layoutOptions.map((layoutOption)=>{
        return {
            ...layoutOption
        };
    });
};
const $52cd12c2ac5b9257$var$PLACEMENT_OPTIONS_KEYS = [
    "wall_spacing_left",
    "wall_spacing_back",
    "wall_spacing_right",
    "horizontal_spacing",
    "vertical_spacing",
    "overlap",
    "ignore_nose_in_out",
    "ignore_front_back",
    "ignore_outside_hangar",
    "density_threshold",
    "tug_spacing",
    "sample_size",
    "corner_strategies",
    "cloud_position_prioritization"
];
const $52cd12c2ac5b9257$var$ResultGrid = ({ id: id, results: results })=>{
    const customPlacementColumns = $52cd12c2ac5b9257$var$PLACEMENT_OPTIONS_KEYS.map((option)=>({
            field: option,
            headerName: `option_${option}`,
            width: 80,
            valueGetter: (_, row)=>{
                return row?.layoutOptions?.[0]?.paramSet?.options?.[option];
            }
        }));
    const columns = [
        {
            field: "id",
            headerName: "",
            width: 40,
            renderCell: (params)=>{
                const totalProgress = params.row.layoutOptions.length ? (0, $cLNZr.sum)(params.row.progress) / params.row.layoutOptions.length : 0;
                if (totalProgress === 1) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4VwvT))), {});
                return "";
            }
        },
        {
            field: "hangar_name",
            headerName: "Hangar",
            width: 200,
            valueGetter: (_, row)=>row?.hangar?.name
        },
        {
            field: "progress",
            headerName: "Progress",
            width: 200,
            valueGetter: (_, row)=>100 * (0, $cLNZr.sum)(row?.progress),
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $c7ae214ca7ee945f$export$3ced3c1b5b85482c), {
                    value: params.row.layoutOptions.length ? 100 * (0, $cLNZr.sum)(params.row.progress) / params.row.layoutOptions.length : 0,
                    sx: {
                        width: "100%"
                    }
                })
        },
        {
            field: "n_variations",
            headerName: "# Variants",
            width: 150,
            valueGetter: (_, row)=>row.layoutOptions.length
        },
        {
            field: "n_placed",
            headerName: "# Placed",
            width: 150,
            valueGetter: (_, row)=>row.layoutOptions.length ? `${Math.max(...$52cd12c2ac5b9257$var$calculateStackedAirplanes(row))}` : "---"
        },
        {
            field: "time",
            headerName: "Duration",
            width: 150,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "inherit",
                    children: params.row.time > 0 ? `${(0, $cLNZr.round)(params.row.time / 1000, 1)}s` : "---"
                })
        },
        {
            field: "util",
            headerName: "Utilization",
            width: 150,
            valueGetter: (_, row)=>row.layoutOptions.length ? Math.max(...$52cd12c2ac5b9257$var$calculateStackUtilizations(row)) : "---",
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "inherit",
                    children: params.row.layoutOptions.length ? `${Math.max(...$52cd12c2ac5b9257$var$calculateStackUtilizations(params.row))}%` : "---"
                })
        },
        {
            field: "utils",
            headerName: "Top 4 Utilizations",
            width: 200,
            valueGetter: (_, row)=>row.layoutOptions.length ? $52cd12c2ac5b9257$var$calculateStackUtilizations(row).sort((a, b)=>b - a).slice(0, 4).join(", ") : "---"
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 200,
            valueGetter: ()=>`${window.location.origin}/#/stackmaster/${id}`,
            renderCell: (params)=>{
                const [open, setOpen] = $acw62.useState(false);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            size: "small",
                            variant: "contained",
                            color: "success",
                            onClick: ()=>setOpen(true),
                            children: "View Results"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggtZr.HangarStateContainer), {
                            initialState: {
                                hangar_id: params.row.hangar.id,
                                isReference: false
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iJtNT.EvaluatingStackDialog), {
                                isAlgorithmTesting: true,
                                open: open,
                                status: "complete",
                                stacks: $52cd12c2ac5b9257$var$convertLayoutToHangarStacks(params.row),
                                progress: params.row.progress,
                                onClose: ()=>setOpen(false),
                                hangar: params.row.hangar,
                                hangarId: ""
                            })
                        })
                    ]
                });
            }
        },
        ...customPlacementColumns
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            height: "100%",
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
            getRowId: (row)=>row.hangar.id,
            rows: results,
            columns: columns,
            pageSizeOptions: [
                20
            ],
            disableRowSelectionOnClick: true
        })
    });
};
const $52cd12c2ac5b9257$export$dbf83699f01cb2f9 = ()=>{
    const { id: idFromRoute } = (0, $aphAM.useParams)();
    const id = idFromRoute ?? (0, $5sKyw.default)();
    const { airplxIdentity: airplxIdentity, airplxToken: airplxToken } = (0, $gqehT.useIdentity)();
    const postgres = (0, $3kyM0.usePostgrest)();
    const [results, setResults] = $acw62.useState([]);
    const { hangars: allHangars } = (0, $7FzhI.useHangarsState)();
    const [openCustomStackDialog, setOpenCustomStackDialog] = $acw62.useState(false);
    const hangars = $acw62.useMemo(()=>{
        return allHangars.filter((hangar)=>hangar.name.startsWith("Speed"));
    }, [
        allHangars
    ]);
    /**
   * 1. Select hangars to run. Or just run all of them
   * 2. Click button for parameters prompt
   * 3. Run 1 hangar at a time.
   * 4. Save results to a table of some kind.
   */ $acw62.useEffect(()=>{
        (async ()=>{
            if (idFromRoute) {
                const res = await postgres.from("algorithm_test_result").select().eq("id", id).single();
                setResults(res.data.result);
                return;
            }
            setResults(hangars.map((hangar)=>({
                    id: (0, $5sKyw.default)(),
                    hangar: hangar,
                    layoutOptions: [],
                    progress: [
                        0
                    ],
                    time: 0
                })));
        })();
    }, [
        hangars
    ]);
    const onClickRun = $acw62.useCallback(async (customPlacementOptions)=>{
        const currentResults = hangars.map((hangar)=>({
                id: (0, $5sKyw.default)(),
                hangar: hangar,
                layoutOptions: [],
                progress: [
                    0
                ],
                time: 0
            }));
        for (const hangar of hangars){
            const startTime = +new Date();
            console.log(`running hangar: ${hangar.name}`);
            const paramSet = {
                run_id: (0, $5sKyw.default)(),
                label: "base case",
                // slim down the hangar for the API call
                hangar: {
                    id: hangar.id,
                    width: hangar.width,
                    depth: hangar.depth,
                    left_door: hangar.left_door,
                    right_door: hangar.right_door,
                    garage_doors: hangar.garageDoors ?? []
                },
                // slim down the tenant so it's just what we need to do the placement
                aircrafts_to_place: hangar.stack.tenants.filter((t)=>t.position.preferences?.indexOf((0, $keHtM.Preference).LOCKED) === -1).map((tenant)=>({
                        id: tenant.aircraft.id,
                        placement_id: tenant.placement_id,
                        angles_to_try: [],
                        sectors_to_try: null,
                        preferences: tenant.position.preferences
                    })),
                locked_aircrafts: hangar.stack.tenants.filter((t)=>t.position.preferences?.indexOf((0, $keHtM.Preference).LOCKED) > -1).map((tenant)=>({
                        id: tenant.aircraft.id,
                        placement_id: tenant.placement_id,
                        x: tenant.position.x,
                        // hangar.depth - y
                        // y: tenant.position.y - hangar.depth,
                        y: tenant.position.y,
                        angle: tenant.position.angle
                    })),
                obstacles: hangar.obstacles ?? [],
                options: {
                    ...customPlacementOptions,
                    corner_strategy: [
                        (0, $keHtM.CornerStrategy).ANGLE_45,
                        (0, $keHtM.CornerStrategy).ANGLE_45
                    ],
                    tug_spacing: 0,
                    // obselete
                    error_type: null,
                    // obselete
                    density_threshold: 0.8 // obselete
                }
            };
            const paramSets = (0, $eYWyk.generateDevParamSets)(paramSet, hangar.stack.tenants.map((t)=>t.aircraft), customPlacementOptions);
            await (0, $d977a2d2296ce41c$export$658fb009ff801842)(hangar, paramSets, airplxIdentity, airplxToken, (layoutOptions, progress)=>{
                const idx = currentResults.findIndex((r)=>r.hangar.id === hangar.id);
                currentResults[idx] = {
                    ...currentResults[idx],
                    layoutOptions: layoutOptions,
                    progress: progress,
                    time: +new Date() - startTime
                };
                setResults([
                    ...currentResults
                ]);
            });
        }
        // all done, save this bad boy to the db
        await postgres.from("algorithm_test_result").insert({
            id: // bring out the id for ease of lookup
            id,
            // everything we stuff into the result so we can bring it back
            // out to load the page if need be
            result: currentResults
        });
    }, [
        hangars
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            ml: 2,
            mr: 2,
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            mt: 2,
                            mb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "h6",
                                children: "Benchmarking Hangars"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2WBL0))), {}),
                                variant: "contained",
                                onClick: ()=>setOpenCustomStackDialog(true),
                                children: "Stack"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($52cd12c2ac5b9257$var$ResultGrid, {
                        id: id,
                        results: results
                    })
                ]
            }),
            openCustomStackDialog && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $78CAK.CustomStackDialog), {
                isDev: true,
                onClickRunStack: (customPlacementOptions)=>{
                    onClickRun(customPlacementOptions);
                    setOpenCustomStackDialog(false);
                },
                onClose: ()=>{
                    setOpenCustomStackDialog(false);
                }
            })
        ]
    });
};


const $02aa5f9760e33e8c$export$ad512fb4726ebbf = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52cd12c2ac5b9257$export$dbf83699f01cb2f9), {})
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $03mUs = parcelRequire("03mUs");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");

var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $jLQQD = parcelRequire("jLQQD");

var $f4OIt = parcelRequire("f4OIt");

var $88tPr = parcelRequire("88tPr");
const $71adbde76e2065d6$export$7b4a8be4a3db7382 = (0, $f4OIt.create)()((0, $88tPr.persist)((set, get)=>({
        fixes: {},
        startFix: (filePath, processId)=>set((state)=>({
                    fixes: {
                        ...state.fixes,
                        [filePath]: {
                            processId: processId,
                            filePath: filePath,
                            status: 'running',
                            output: '',
                            startTime: Date.now()
                        }
                    }
                })),
        appendOutput: (filePath, chunk)=>set((state)=>{
                const fix = state.fixes[filePath];
                if (!fix) return state;
                return {
                    fixes: {
                        ...state.fixes,
                        [filePath]: {
                            ...fix,
                            output: fix.output + chunk
                        }
                    }
                };
            }),
        setStatus: (filePath, status)=>set((state)=>{
                const fix = state.fixes[filePath];
                if (!fix) return state;
                return {
                    fixes: {
                        ...state.fixes,
                        [filePath]: {
                            ...fix,
                            status: status,
                            endTime: Date.now()
                        }
                    }
                };
            }),
        setGitDiff: (filePath, diff)=>set((state)=>{
                const fix = state.fixes[filePath];
                if (!fix) return state;
                return {
                    fixes: {
                        ...state.fixes,
                        [filePath]: {
                            ...fix,
                            gitDiff: diff
                        }
                    }
                };
            }),
        getFix: (filePath)=>get().fixes[filePath],
        removeFix: (filePath)=>set((state)=>{
                const { [filePath]: _removed, ...rest } = state.fixes;
                return {
                    fixes: rest
                };
            }),
        clearCompleted: ()=>set((state)=>{
                const runningFixes = {};
                Object.entries(state.fixes).forEach(([path, fix])=>{
                    if (fix.status === 'running') runningFixes[path] = fix;
                });
                return {
                    fixes: runningFixes
                };
            })
    }), {
    name: 'active-fixes-storage'
}));



var $acw62 = parcelRequire("acw62");

// Global map of active SSE connections
const $bcfb9fb7923a5d52$var$activeConnections = new Map();
function $bcfb9fb7923a5d52$export$9696ecd12e42547c(filePath, prompt, autoStart) {
    const store = (0, $71adbde76e2065d6$export$7b4a8be4a3db7382)();
    (0, $acw62.useEffect)(()=>{
        if (!autoStart) return;
        // Check if already running
        if ($bcfb9fb7923a5d52$var$activeConnections.has(filePath)) {
            console.log('[useFixConnection] Connection already exists for', filePath);
            return;
        }
        // Also check store - don't start if already running
        const existingFix = store.getFix(filePath);
        if (existingFix && existingFix.status === 'running') {
            console.log('[useFixConnection] Fix already running in store for', filePath);
            return;
        }
        console.log('[useFixConnection] Starting fix for', filePath);
        // Start new SSE connection
        const es = new EventSource(`http://localhost:9999/api/fix-with-claude?prompt=${encodeURIComponent(prompt)}`);
        $bcfb9fb7923a5d52$var$activeConnections.set(filePath, es);
        es.onmessage = (event)=>{
            const msg = JSON.parse(event.data);
            console.log('[useFixConnection] SSE message:', msg.type, 'for', filePath);
            if (msg.type === 'started') store.startFix(filePath, msg.processId);
            else if (msg.type === 'output') store.appendOutput(filePath, msg.data);
            else if (msg.type === 'complete') {
                store.setStatus(filePath, 'success');
                // Fetch git diff
                fetch(`http://localhost:9999/api/git-diff/${encodeURIComponent(filePath)}`).then((res)=>res.json()).then((data)=>store.setGitDiff(filePath, data.diff)).catch((err)=>console.error('Failed to fetch git diff:', err));
                es.close();
                $bcfb9fb7923a5d52$var$activeConnections.delete(filePath);
            } else if (msg.type === 'error') {
                store.appendOutput(filePath, `\n\nError: ${msg.error}`);
                store.setStatus(filePath, 'error');
                es.close();
                $bcfb9fb7923a5d52$var$activeConnections.delete(filePath);
            }
        };
        es.onerror = (error)=>{
            console.error('[useFixConnection] SSE error for', filePath, error);
            es.close();
            $bcfb9fb7923a5d52$var$activeConnections.delete(filePath);
            // If we have output, consider it success (process completed)
            const fix = store.getFix(filePath);
            if (fix && fix.output.length > 0 && fix.status === 'running') store.setStatus(filePath, 'success');
        };
        return ()=>{
            // Don't close connection on unmount - keep running in background
            console.log('[useFixConnection] Component unmounting, but connection stays open for', filePath);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filePath,
        autoStart
    ]); // Exclude prompt and store to avoid infinite loops
    return {
        isConnected: $bcfb9fb7923a5d52$var$activeConnections.has(filePath)
    };
}
function $bcfb9fb7923a5d52$export$88f33643b2a4c42b(filePath, processId) {
    const es = $bcfb9fb7923a5d52$var$activeConnections.get(filePath);
    if (es) {
        es.close();
        $bcfb9fb7923a5d52$var$activeConnections.delete(filePath);
    }
    // Kill the process
    fetch(`http://localhost:9999/api/cancel-fix/${processId}`, {
        method: 'POST'
    }).catch((err)=>console.error('Failed to cancel process:', err));
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7UqNi = parcelRequire("7UqNi");
var $2mdyF = parcelRequire("2mdyF");
var $2gURC = parcelRequire("2gURC");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $3bYfT = parcelRequire("3bYfT");

var $hbZ6O = parcelRequire("hbZ6O");


const $c03efcf2a83da13a$export$3b3200de8168f792 = ({ open: open, onClose: onClose, filePath: filePath, onSuccess: onSuccess })=>{
    const outputRef = (0, $acw62.useRef)(null);
    // Subscribe to store for this file's fix status
    const fix = (0, $71adbde76e2065d6$export$7b4a8be4a3db7382)((state)=>state.getFix(filePath));
    const removeFix = (0, $71adbde76e2065d6$export$7b4a8be4a3db7382)((state)=>state.removeFix);
    // Auto-scroll on output changes
    (0, $acw62.useEffect)(()=>{
        if (fix?.output) setTimeout(()=>{
            outputRef.current?.scrollTo({
                top: outputRef.current.scrollHeight
            });
        }, 0);
    }, [
        fix?.output
    ]);
    // Trigger onSuccess when fix completes successfully
    (0, $acw62.useEffect)(()=>{
        if (fix?.status === 'success' && fix.endTime) onSuccess?.();
    }, [
        fix?.status,
        fix?.endTime,
        onSuccess
    ]);
    const handleCancel = async ()=>{
        if (!fix?.processId) return;
        (0, $bcfb9fb7923a5d52$export$88f33643b2a4c42b)(filePath, fix.processId);
        (0, $71adbde76e2065d6$export$7b4a8be4a3db7382).getState().setStatus(filePath, 'cancelled');
    };
    const handleClear = ()=>{
        removeFix(filePath);
        onClose();
    };
    // If no fix data, don't render
    if (!fix) return null;
    const isRunning = fix.status === 'running';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ejcfT.default), {
                children: [
                    "Fix with Claude - ",
                    filePath.split('/').pop(),
                    isRunning && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "text.secondary",
                        display: "block",
                        children: "Running in background (dialog can be closed)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        ref: outputRef,
                        sx: {
                            bgcolor: '#000',
                            color: '#0f0',
                            p: 2,
                            borderRadius: 1,
                            fontFamily: 'monospace',
                            fontSize: '0.875rem',
                            maxHeight: '400px',
                            overflowY: 'auto',
                            whiteSpace: 'pre-wrap'
                        },
                        children: fix.output || 'Starting Claude...'
                    }),
                    fix.gitDiff && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UqNi.default), {
                        sx: {
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gURC.default), {
                                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {}),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    children: "File Changes (git diff)"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2mdyF.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    component: "pre",
                                    sx: {
                                        bgcolor: '#f5f5f5',
                                        p: 2,
                                        borderRadius: 1,
                                        overflow: 'auto',
                                        fontSize: '0.75rem',
                                        fontFamily: 'monospace'
                                    },
                                    children: fix.gitDiff || 'No changes detected'
                                })
                            })
                        ]
                    }),
                    fix.status === 'success' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        color: "success.main",
                        mt: 2,
                        children: "\u2705 Fix completed successfully!"
                    }),
                    fix.status === 'cancelled' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        color: "warning.main",
                        mt: 2,
                        children: "\u26A0\uFE0F Fix cancelled"
                    }),
                    fix.status === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        color: "error.main",
                        mt: 2,
                        children: "\u274C Fix failed (see output above)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                children: isRunning ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    onClick: handleCancel,
                    color: "error",
                    children: "Cancel"
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: handleClear,
                            children: "Clear"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: onClose,
                            variant: "contained",
                            children: "Close"
                        })
                    ]
                })
            })
        ]
    });
};


const $cab0c297ecebbdd4$export$593fd10f7e6c6505 = ({ file: file, onViewFile: onViewFile, onCopy: onCopy, generatePrompt: generatePrompt, onErrorsRefresh: onErrorsRefresh })=>{
    const [dialogOpen, setDialogOpen] = (0, $acw62.useState)(false);
    const [startFix, setStartFix] = (0, $acw62.useState)(false);
    const fixStatus = (0, $71adbde76e2065d6$export$7b4a8be4a3db7382)((state)=>state.getFix(file.filePath));
    // Start SSE connection when startFix is true
    (0, $bcfb9fb7923a5d52$export$9696ecd12e42547c)(file.filePath, generatePrompt(file), startFix);
    const handleFixClick = ()=>{
        const currentFix = (0, $71adbde76e2065d6$export$7b4a8be4a3db7382).getState().getFix(file.filePath);
        if (!currentFix || currentFix.status !== 'running') {
            // Start new fix
            setStartFix(true);
            setDialogOpen(true);
        } else // View existing fix
        setDialogOpen(true);
    };
    const buttonColor = !fixStatus ? 'primary' : fixStatus.status === 'running' ? 'info' : fixStatus.status === 'success' ? 'success' : 'error';
    const buttonText = !fixStatus ? 'Fix All with Claude' : fixStatus.status === 'running' ? 'View Progress...' : fixStatus.status === 'success' ? "Fixed \u2713" : "Fix Failed \u2717";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "subtitle1",
                            gutterBottom: true,
                            children: file.filePath
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "body2",
                            color: "text.secondary",
                            gutterBottom: true,
                            children: [
                                file.eslintCount > 0 && `${file.eslintCount} ESLint`,
                                file.eslintCount > 0 && file.typescriptCount > 0 && ", ",
                                file.typescriptCount > 0 && `${file.typescriptCount} TypeScript`,
                                " (",
                                file.totalCount,
                                " total)"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            mt: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "outlined",
                                    size: "small",
                                    onClick: ()=>onViewFile(file.filePath),
                                    children: "View Errors"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    color: "info",
                                    size: "small",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jLQQD))), {}),
                                    onClick: ()=>onCopy(file),
                                    children: "Copy All for Claude"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    color: buttonColor,
                                    size: "small",
                                    onClick: handleFixClick,
                                    children: buttonText
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c03efcf2a83da13a$export$3b3200de8168f792), {
                open: dialogOpen,
                onClose: ()=>setDialogOpen(false),
                filePath: file.filePath,
                onSuccess: ()=>{
                    onErrorsRefresh?.();
                }
            })
        ]
    });
};


const $6161f03bd7f688a0$export$543e5412eeccf242 = ({ files: files, onViewFile: onViewFile, onErrorsRefresh: onErrorsRefresh })=>{
    const [snackbarOpen, setSnackbarOpen] = (0, $acw62.useState)(false);
    const [copiedFile, setCopiedFile] = (0, $acw62.useState)("");
    const generateFilePrompt = (file)=>{
        const errorList = file.errors.map((e, idx)=>{
            const errorCode = e.errorCode || e.ruleId;
            return `${idx + 1}. Line ${e.line} - ${errorCode}: ${e.message}`;
        }).join("\n");
        return `You are an expert TypeScript developer fixing type errors in a React/TypeScript codebase.

FILE TO FIX: ${file.filePath}

ERRORS TO FIX (${file.totalCount} total):
${errorList}

INSTRUCTIONS:

1. READ THE FILE FIRST
   - Use the Read tool to read the entire file: ${file.filePath}
   - Understand what this file does and its role in the codebase
   - Identify any patterns or conventions used

2. FIX ERRORS METHODICALLY
   - Fix errors one at a time, starting from the top of the file
   - For each error:
     a) Understand the root cause (not just the symptom)
     b) Choose the most type-safe fix (avoid 'any', 'as any', or type assertions unless absolutely necessary)
     c) Prefer proper type definitions over quick fixes
     d) Make minimal changes - don't refactor unrelated code

3. COMMON FIX STRATEGIES
   - Missing properties: Add them to the interface/type definition
   - Type mismatches: Check if the types are correct, fix the source if needed
   - 'any' types: Replace with proper types from the codebase
   - Wrong arguments: Check function signature, pass correct parameters
   - Unsafe conversions: Use proper type guards or restructure the code

4. VERIFICATION (CRITICAL)
   After making fixes:
   - Run: npm run typecheck (must pass with 0 errors in this file)
   - Run: npm run test (if tests exist for this file)
   - Check: No new errors introduced in related files
   - Verify: The actual functionality is unchanged (behavior-preserving fixes only)

5. REPORT YOUR WORK
   When done, report:
   - Total errors fixed: X/${file.totalCount}
   - Any errors you couldn't fix (with explanation)
   - Typecheck status: PASS/FAIL
   - Test status: PASS/FAIL/SKIPPED

IMPORTANT CONSTRAINTS:
- Do NOT use 'as any' or '@ts-ignore' unless absolutely necessary
- Do NOT change functionality - only fix type errors
- Do NOT refactor code beyond what's needed for the fix
- DO maintain existing code style and conventions
- DO read the file first before making any changes

Start by reading ${file.filePath} to understand the code.`;
    };
    const copyFilePrompt = (file)=>{
        navigator.clipboard.writeText(generateFilePrompt(file));
        setCopiedFile(file.filePath.split("/").pop() || file.filePath);
        setSnackbarOpen(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "h6",
                gutterBottom: true,
                children: [
                    "Files with Errors (",
                    files.length,
                    " files)"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                gutterBottom: true,
                mb: 2,
                children: "Files sorted by error count (most errors first)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                spacing: 2,
                children: files.map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cab0c297ecebbdd4$export$593fd10f7e6c6505), {
                        file: file,
                        onViewFile: onViewFile,
                        onCopy: copyFilePrompt,
                        generatePrompt: generateFilePrompt,
                        onErrorsRefresh: onErrorsRefresh
                    }, file.filePath))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                open: snackbarOpen,
                autoHideDuration: 2000,
                onClose: ()=>setSnackbarOpen(false),
                message: `Copied all errors from ${copiedFile}`
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $6ami2 = parcelRequire("6ami2");
var $9SK5h = parcelRequire("9SK5h");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $1YLXO = parcelRequire("1YLXO");

var $jLQQD = parcelRequire("jLQQD");

var $evsWN = parcelRequire("evsWN");
const $a728abc15a757a91$export$92398b3d663e20bc = ({ filePath: filePath, errors: errors, onBack: onBack })=>{
    const [snackbarOpen, setSnackbarOpen] = (0, $acw62.useState)(false);
    const [snackbarMessage, setSnackbarMessage] = (0, $acw62.useState)("");
    const eslintCount = errors.filter((e)=>e.source === "eslint").length;
    const typescriptCount = errors.filter((e)=>e.source === "typescript").length;
    const generateFilePrompt = ()=>{
        const errorList = errors.map((e, idx)=>{
            const errorCode = e.errorCode || e.ruleId;
            return `${idx + 1}. Line ${e.line} - ${errorCode}: ${e.message}`;
        }).join("\n");
        return `You are an expert TypeScript developer fixing type errors in a React/TypeScript codebase.

FILE TO FIX: ${filePath}

ERRORS TO FIX (${errors.length} total):
${errorList}

INSTRUCTIONS:

1. READ THE FILE FIRST
   - Use the Read tool to read the entire file: ${filePath}
   - Understand what this file does and its role in the codebase
   - Identify any patterns or conventions used

2. FIX ERRORS METHODICALLY
   - Fix errors one at a time, starting from the top of the file
   - For each error:
     a) Understand the root cause (not just the symptom)
     b) Choose the most type-safe fix (avoid 'any', 'as any', or type assertions unless absolutely necessary)
     c) Prefer proper type definitions over quick fixes
     d) Make minimal changes - don't refactor unrelated code

3. COMMON FIX STRATEGIES
   - Missing properties: Add them to the interface/type definition
   - Type mismatches: Check if the types are correct, fix the source if needed
   - 'any' types: Replace with proper types from the codebase
   - Wrong arguments: Check function signature, pass correct parameters
   - Unsafe conversions: Use proper type guards or restructure the code

4. VERIFICATION (CRITICAL)
   After making fixes:
   - Run: npm run typecheck (must pass with 0 errors in this file)
   - Run: npm run test (if tests exist for this file)
   - Check: No new errors introduced in related files
   - Verify: The actual functionality is unchanged (behavior-preserving fixes only)

5. REPORT YOUR WORK
   When done, report:
   - Total errors fixed: X/${errors.length}
   - Any errors you couldn't fix (with explanation)
   - Typecheck status: PASS/FAIL
   - Test status: PASS/FAIL/SKIPPED

IMPORTANT CONSTRAINTS:
- Do NOT use 'as any' or '@ts-ignore' unless absolutely necessary
- Do NOT change functionality - only fix type errors
- Do NOT refactor code beyond what's needed for the fix
- DO maintain existing code style and conventions
- DO read the file first before making any changes

Start by reading ${filePath} to understand the code.`;
    };
    const copyAllPrompt = ()=>{
        navigator.clipboard.writeText(generateFilePrompt());
        setSnackbarMessage(`Copied all ${errors.length} errors for Claude!`);
        setSnackbarOpen(true);
    };
    const copyIndividualPrompt = (error)=>{
        const errorCode = error.errorCode || error.ruleId;
        const prompt = `You are an expert TypeScript developer fixing a ${error.source || "code quality"} error.

FILE: ${error.relativeFilePath}
LINE: ${error.line}
ERROR: ${errorCode}
MESSAGE: ${error.message}

CODE CONTEXT:
\`\`\`typescript
${error.codeSnippet}
\`\`\`

INSTRUCTIONS:

1. READ THE FILE FIRST
   - Read ${error.relativeFilePath} to understand the full context
   - Don't just fix the line - understand why the error exists

2. APPLY TYPE-SAFE FIX
   - Avoid 'any' or type assertions unless absolutely necessary
   - Prefer fixing the root cause over suppressing the error
   - Make minimal changes - don't refactor unrelated code

3. VERIFY YOUR FIX
   - Run: npm run typecheck
   - Run: npm run test (if applicable)
   - Ensure no new errors introduced

Start by reading the file to understand the context.`;
        navigator.clipboard.writeText(prompt);
        setSnackbarMessage(`Copied error from line ${error.line}`);
        setSnackbarOpen(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YLXO))), {}),
                onClick: onBack,
                sx: {
                    mb: 2
                },
                variant: "outlined",
                children: "Back to Files"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                gutterBottom: true,
                children: filePath
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                gutterBottom: true,
                mb: 2,
                children: [
                    eslintCount > 0 && `${eslintCount} ESLint`,
                    eslintCount > 0 && typescriptCount > 0 && ", ",
                    typescriptCount > 0 && `${typescriptCount} TypeScript`,
                    " (",
                    errors.length,
                    " total)"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                variant: "contained",
                color: "info",
                size: "large",
                fullWidth: true,
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jLQQD))), {}),
                onClick: copyAllPrompt,
                sx: {
                    mb: 3
                },
                children: [
                    "Copy All ",
                    errors.length,
                    " Errors"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                spacing: 2,
                children: errors.map((error, _idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                        variant: "outlined",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 1,
                                    mb: 1,
                                    children: [
                                        error.source && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: error.source.toUpperCase(),
                                            size: "small",
                                            color: error.source === "eslint" ? "primary" : "secondary"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: error.errorCode || error.ruleId,
                                            size: "small",
                                            variant: "outlined"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `Line ${error.line}`,
                                            size: "small"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    gutterBottom: true,
                                    children: error.message
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 1,
                                    mt: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9SK5h.default), {
                                            href: `vscode://file${error.filePath}:${error.line}:${error.column}`,
                                            variant: "body2",
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                textDecoration: "none",
                                                "&:hover": {
                                                    textDecoration: "underline"
                                                }
                                            },
                                            children: [
                                                "Open in VSCode",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($evsWN))), {
                                                    sx: {
                                                        fontSize: 14
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            children: "\u2022"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            size: "small",
                                            onClick: ()=>copyIndividualPrompt(error),
                                            sx: {
                                                minWidth: 0,
                                                p: 0,
                                                textTransform: "none"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                children: "Copy Individual"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, error.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                open: snackbarOpen,
                autoHideDuration: 2000,
                onClose: ()=>setSnackbarOpen(false),
                message: snackbarMessage
            })
        ]
    });
};


const $1c55ffb179de49ee$export$d2f1f8a9f24159f8 = ()=>{
    const [errors, setErrors] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [selectedFile, setSelectedFile] = (0, $acw62.useState)(null);
    const loadErrors = async ()=>{
        setIsLoading(true);
        setError(null);
        try {
            const res = await fetch("http://localhost:9999/api/errors");
            if (!res.ok) throw new Error(`Failed to load errors: ${res.statusText}`);
            const data = await res.json();
            setErrors(data.errors);
        } catch (err) {
            setError(err.message);
        } finally{
            setIsLoading(false);
        }
    };
    // Group errors by file
    const errorsByFile = (0, $acw62.useMemo)(()=>{
        const grouped = new Map();
        errors.forEach((error)=>{
            const existing = grouped.get(error.relativeFilePath) || [];
            grouped.set(error.relativeFilePath, [
                ...existing,
                error
            ]);
        });
        // Convert to array and sort by error count (descending)
        return Array.from(grouped.entries()).map(([filePath, fileErrors])=>({
                filePath: filePath,
                errors: fileErrors,
                eslintCount: fileErrors.filter((e)=>e.source === "eslint").length,
                typescriptCount: fileErrors.filter((e)=>e.source === "typescript").length,
                totalCount: fileErrors.length
            })).sort((a, b)=>b.totalCount - a.totalCount);
    }, [
        errors
    ]);
    // Load errors on mount
    (0, $acw62.useEffect)(()=>{
        loadErrors();
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        p: 3,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: "h6",
            gutterBottom: true,
            children: "Loading errors..."
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
        severity: "error",
        sx: {
            m: 3
        },
        action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
            color: "inherit",
            size: "small",
            onClick: loadErrors,
            children: "Retry"
        }),
        children: [
            error,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                mt: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "caption",
                    children: "Make sure the devtools server is running: cd devtools && npm run dev"
                })
            })
        ]
    });
    if (errors.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        p: 3,
        textAlign: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h5",
                gutterBottom: true,
                children: "No errors found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body1",
                color: "text.secondary",
                children: "All linter checks passed!"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        p: 3,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h4",
                gutterBottom: true,
                children: "Linter Issues"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                gutterBottom: true,
                children: [
                    errors.filter((e)=>e.source === "eslint").length,
                    " ESLint errors,",
                    " ",
                    errors.filter((e)=>e.source === "typescript").length,
                    " TypeScript errors"
                ]
            }),
            selectedFile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a728abc15a757a91$export$92398b3d663e20bc), {
                filePath: selectedFile,
                errors: errors.filter((e)=>e.relativeFilePath === selectedFile),
                onBack: ()=>setSelectedFile(null),
                onErrorsRefresh: ()=>{
                    setTimeout(()=>loadErrors(), 1000);
                }
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6161f03bd7f688a0$export$543e5412eeccf242), {
                files: errorsByFile,
                onViewFile: setSelectedFile,
                onErrorsRefresh: ()=>{
                    setTimeout(()=>loadErrors(), 1000);
                }
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $1lfQl = parcelRequire("1lfQl");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");


const $b89bc374518c1ca5$export$dd5c4cb95b11992e = ()=>{
    const [errors, setErrors] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [selectedFile, setSelectedFile] = (0, $acw62.useState)(null);
    const loadErrors = async ()=>{
        setIsLoading(true);
        setError(null);
        try {
            const res = await fetch("http://localhost:9999/api/test-errors");
            if (!res.ok) throw new Error(`Failed to load test errors: ${res.statusText}`);
            const data = await res.json();
            setErrors(data.errors);
        } catch (err) {
            setError(err.message);
        } finally{
            setIsLoading(false);
        }
    };
    // Load errors on mount
    (0, $acw62.useEffect)(()=>{
        loadErrors();
    }, []);
    // Group errors by file
    const errorsByFile = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const grouped = new Map();
        errors.forEach((testError)=>{
            const existing = grouped.get(testError.relativeFilePath) || [];
            grouped.set(testError.relativeFilePath, [
                ...existing,
                testError
            ]);
        });
        // Convert to array and sort by error count (descending)
        return Array.from(grouped.entries()).map(([filePath, fileErrors])=>({
                filePath: filePath,
                errors: fileErrors,
                eslintCount: 0,
                typescriptCount: 0,
                totalCount: fileErrors.length
            })).sort((a, b)=>b.totalCount - a.totalCount);
    }, [
        errors
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        p: 3,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                gutterBottom: true,
                children: "Running tests and collecting failures..."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                gutterBottom: true,
                children: "This may take 30-60 seconds depending on your test suite size"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {})
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
        severity: "error",
        sx: {
            m: 3
        },
        action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
            color: "inherit",
            size: "small",
            onClick: loadErrors,
            children: "Retry"
        }),
        children: [
            error,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                mt: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "caption",
                    children: "Make sure the devtools server is running: cd devtools && npm run dev"
                })
            })
        ]
    });
    if (errors.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        p: 3,
        textAlign: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h5",
                gutterBottom: true,
                children: "All Tests Passing! \uD83C\uDF89"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body1",
                color: "text.secondary",
                gutterBottom: true,
                children: "No test failures found. Great job!"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                variant: "outlined",
                sx: {
                    mt: 2
                },
                onClick: loadErrors,
                children: "Refresh"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        p: 3,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h4",
                gutterBottom: true,
                children: "Test Failures"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                gutterBottom: true,
                children: [
                    errors.length,
                    " failing test",
                    errors.length !== 1 ? "s" : "",
                    " across",
                    " ",
                    errorsByFile.length,
                    " file",
                    errorsByFile.length !== 1 ? "s" : ""
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                severity: "info",
                sx: {
                    mb: 2,
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        fontWeight: "bold",
                        gutterBottom: true,
                        children: "Workflow:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        component: "div",
                        children: [
                            "1. Click on a file to view all test failures",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "2. Review the test name, error message, and stack trace",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "3. Click ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "Copy Claude Prompt"
                            }),
                            " to get a fix request",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "4. Paste in terminal:",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                style: {
                                    background: "#f5f5f5",
                                    padding: "2px 4px",
                                    borderRadius: "3px"
                                },
                                children: 'claude "Fix this test..."'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "5. After fixing, ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "refresh this page"
                            }),
                            " to re-run tests"
                        ]
                    })
                ]
            }),
            selectedFile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a728abc15a757a91$export$92398b3d663e20bc), {
                filePath: selectedFile,
                errors: errors.filter((e)=>e.relativeFilePath === selectedFile),
                onBack: ()=>setSelectedFile(null),
                onErrorsRefresh: ()=>{
                    setTimeout(()=>loadErrors(), 1000);
                }
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6161f03bd7f688a0$export$543e5412eeccf242), {
                files: errorsByFile,
                onViewFile: setSelectedFile,
                onErrorsRefresh: ()=>{
                    setTimeout(()=>loadErrors(), 1000);
                }
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $1lfQl = parcelRequire("1lfQl");
var $3bYfT = parcelRequire("3bYfT");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7UqNi = parcelRequire("7UqNi");
var $2mdyF = parcelRequire("2mdyF");
var $2gURC = parcelRequire("2gURC");
var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $cSDx2 = parcelRequire("cSDx2");
var $19ocJ = parcelRequire("19ocJ");
var $3bYfT = parcelRequire("3bYfT");

var $hbZ6O = parcelRequire("hbZ6O");

var $hmTQO = parcelRequire("hmTQO");

var $at4qK = parcelRequire("at4qK");
var $befc967ff9b5a223$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $befc967ff9b5a223$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($befc967ff9b5a223$exports, "__esModule", {
    value: true
});
$befc967ff9b5a223$exports.default = void 0;

var $befc967ff9b5a223$var$_createSvgIcon = $befc967ff9b5a223$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $befc967ff9b5a223$var$_default = $befc967ff9b5a223$exports.default = (0, $befc967ff9b5a223$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 11v2h10v-2zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'RemoveCircleOutline');


var $ce97b2bfee2919ec$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ce97b2bfee2919ec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ce97b2bfee2919ec$exports, "__esModule", {
    value: true
});
$ce97b2bfee2919ec$exports.default = void 0;

var $ce97b2bfee2919ec$var$_createSvgIcon = $ce97b2bfee2919ec$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ce97b2bfee2919ec$var$_default = $ce97b2bfee2919ec$exports.default = (0, $ce97b2bfee2919ec$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'CircleOutlined');



var $33PpE = parcelRequire("33PpE");

var $2vNG8 = parcelRequire("2vNG8");
const $8b24182ce835ade5$var$StatusIcon = ({ status: status })=>{
    const iconStyle = {
        fontSize: 18,
        mr: 1
    };
    switch(status){
        case 'passed':
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmTQO))), {
                sx: {
                    ...iconStyle,
                    color: 'success.main'
                }
            });
        case 'failed':
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($at4qK))), {
                sx: {
                    ...iconStyle,
                    color: 'error.main'
                }
            });
        case 'skipped':
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($befc967ff9b5a223$exports))), {
                sx: {
                    ...iconStyle,
                    color: 'warning.main'
                }
            });
        case 'not-run':
        default:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ce97b2bfee2919ec$exports))), {
                sx: {
                    ...iconStyle,
                    color: 'grey.500'
                }
            });
    }
};
const $8b24182ce835ade5$var$getStatusColor = (status)=>{
    switch(status){
        case 'passed':
            return 'success';
        case 'failed':
            return 'error';
        case 'skipped':
            return 'warning';
        default:
            return 'default';
    }
};
const $8b24182ce835ade5$export$c1c58d06f783ec80 = ({ testGroups: testGroups, onSelectTest: onSelectTest })=>{
    const [expandedRoles, setExpandedRoles] = (0, $acw62.useState)(new Set());
    const [expandedTags, setExpandedTags] = (0, $acw62.useState)(new Set());
    const handleRoleToggle = (role)=>{
        const newExpanded = new Set(expandedRoles);
        if (newExpanded.has(role)) newExpanded.delete(role);
        else newExpanded.add(role);
        setExpandedRoles(newExpanded);
    };
    const handleTagToggle = (roleTag)=>{
        const newExpanded = new Set(expandedTags);
        if (newExpanded.has(roleTag)) newExpanded.delete(roleTag);
        else newExpanded.add(roleTag);
        setExpandedTags(newExpanded);
    };
    const getTestCount = (group)=>{
        return Object.values(group.tags).reduce((sum, tests)=>sum + tests.length, 0);
    };
    const getStatusCounts = (tests)=>{
        const counts = {
            passed: 0,
            failed: 0,
            skipped: 0,
            notRun: 0
        };
        tests.forEach((test)=>{
            if (test.status === 'passed') counts.passed++;
            else if (test.status === 'failed') counts.failed++;
            else if (test.status === 'skipped') counts.skipped++;
            else counts.notRun++;
        });
        return counts;
    };
    if (testGroups.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        p: 3,
        textAlign: "center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            color: "text.secondary",
            children: "No test results available. Run the tests to see results here."
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        children: testGroups.map((group)=>{
            const testCount = getTestCount(group);
            if (testCount === 0) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UqNi.default), {
                expanded: expandedRoles.has(group.role),
                onChange: ()=>handleRoleToggle(group.role),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gURC.default), {
                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {}),
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($33PpE))), {
                                    fontSize: "small"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle1",
                                    fontWeight: "bold",
                                    children: group.role
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: `${testCount} tests`,
                                    size: "small"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2mdyF.default), {
                        sx: {
                            p: 0
                        },
                        children: Object.entries(group.tags).map(([tag, tests])=>{
                            const roleTagKey = `${group.role}:${tag}`;
                            const counts = getStatusCounts(tests);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UqNi.default), {
                                expanded: expandedTags.has(roleTagKey),
                                onChange: ()=>handleTagToggle(roleTagKey),
                                sx: {
                                    boxShadow: 'none',
                                    '&:before': {
                                        display: 'none'
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gURC.default), {
                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {}),
                                        sx: {
                                            pl: 4,
                                            bgcolor: 'action.hover'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2vNG8))), {
                                                    fontSize: "small"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "body1",
                                                    children: [
                                                        "@",
                                                        tag
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                    label: `${tests.length}`,
                                                    size: "small",
                                                    variant: "outlined"
                                                }),
                                                counts.passed > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                    label: `\u{2713} ${counts.passed}`,
                                                    size: "small",
                                                    color: "success",
                                                    variant: "outlined"
                                                }),
                                                counts.failed > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                    label: `\u{2717} ${counts.failed}`,
                                                    size: "small",
                                                    color: "error",
                                                    variant: "outlined"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2mdyF.default), {
                                        sx: {
                                            p: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
                                            sx: {
                                                pl: 2
                                            },
                                            children: tests.map((test)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                                                    disablePadding: true,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cSDx2.default), {
                                                        onClick: ()=>onSelectTest(test),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($8b24182ce835ade5$var$StatusIcon, {
                                                                status: test.status
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                                                primary: test.name,
                                                                secondary: test.file,
                                                                primaryTypographyProps: {
                                                                    variant: 'body2',
                                                                    fontWeight: test.status === 'failed' ? 'bold' : 'normal'
                                                                },
                                                                secondaryTypographyProps: {
                                                                    variant: 'caption'
                                                                }
                                                            }),
                                                            test.duration !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                label: `${Math.round(test.duration)}ms`,
                                                                size: "small",
                                                                variant: "outlined",
                                                                sx: {
                                                                    ml: 1
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                                label: test.status,
                                                                size: "small",
                                                                color: $8b24182ce835ade5$var$getStatusColor(test.status),
                                                                sx: {
                                                                    ml: 1
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }, test.id))
                                        })
                                    })
                                ]
                            }, roleTagKey);
                        })
                    })
                ]
            }, group.role);
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $5WjaY = parcelRequire("5WjaY");
var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4c5dd21dca115198$export$2a5c27c211442e3c(slot) {
    return (0, $4Cod0.default)('MuiCardActions', slot);
}
const $4c5dd21dca115198$var$cardActionsClasses = (0, $beCSm.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $4c5dd21dca115198$export$2e2bcd8739ae039 = $4c5dd21dca115198$var$cardActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b46a5bcac23a5f99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4c5dd21dca115198$export$2a5c27c211442e3c), classes);
};
const $b46a5bcac23a5f99$var$CardActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    variants: [
        {
            props: {
                disableSpacing: false
            },
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $b46a5bcac23a5f99$var$CardActions = /*#__PURE__*/ $acw62.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $b46a5bcac23a5f99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46a5bcac23a5f99$var$CardActionsRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $b46a5bcac23a5f99$export$2e2bcd8739ae039 = $b46a5bcac23a5f99$var$CardActions;


var $3ulHf = parcelRequire("3ulHf");
var $6ami2 = parcelRequire("6ami2");
var $3bYfT = parcelRequire("3bYfT");

var $1YLXO = parcelRequire("1YLXO");
var $d812595be82c5518$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d812595be82c5518$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d812595be82c5518$exports, "__esModule", {
    value: true
});
$d812595be82c5518$exports.default = void 0;

var $d812595be82c5518$var$_createSvgIcon = $d812595be82c5518$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d812595be82c5518$var$_default = $d812595be82c5518$exports.default = (0, $d812595be82c5518$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), 'Image');


var $1892dbb6dceffbba$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1892dbb6dceffbba$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1892dbb6dceffbba$exports, "__esModule", {
    value: true
});
$1892dbb6dceffbba$exports.default = void 0;

var $1892dbb6dceffbba$var$_createSvgIcon = $1892dbb6dceffbba$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1892dbb6dceffbba$var$_default = $1892dbb6dceffbba$exports.default = (0, $1892dbb6dceffbba$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8 12.5v-9l6 4.5z"
}), 'VideoLibrary');


var $abf2e6573b7dedd2$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $abf2e6573b7dedd2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($abf2e6573b7dedd2$exports, "__esModule", {
    value: true
});
$abf2e6573b7dedd2$exports.default = void 0;

var $abf2e6573b7dedd2$var$_createSvgIcon = $abf2e6573b7dedd2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $abf2e6573b7dedd2$var$_default = $abf2e6573b7dedd2$exports.default = (0, $abf2e6573b7dedd2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8z"
}), 'Update');



var $kPlrn = parcelRequire("kPlrn");
const $a5c36d2142115643$var$getStatusColor = (status)=>{
    switch(status){
        case 'passed':
            return 'success';
        case 'failed':
            return 'error';
        case 'skipped':
            return 'warning';
        default:
            return 'default';
    }
};
const $a5c36d2142115643$var$isSnapshotFailure = (error)=>{
    if (!error) return false;
    return error.includes('snapshot') || error.includes('toMatchSnapshot') || error.includes('Screenshot comparison');
};
const $a5c36d2142115643$export$99e616ae8e2e9f4e = ({ test: test, onBack: onBack, onRefresh: onRefresh })=>{
    const [isUpdatingSnapshots, setIsUpdatingSnapshots] = (0, $acw62.useState)(false);
    const [snackbarMessage, setSnackbarMessage] = (0, $acw62.useState)(null);
    const handleUpdateSnapshots = async ()=>{
        setIsUpdatingSnapshots(true);
        try {
            const res = await fetch('http://localhost:9999/api/playwright-update-snapshots', {
                method: 'POST'
            });
            const result = await res.json();
            if (result.success) {
                setSnackbarMessage('Snapshots updated successfully!');
                setTimeout(()=>onRefresh(), 2000);
            } else {
                setSnackbarMessage('Failed to update snapshots. Check console for details.');
                console.error('Snapshot update output:', result.output);
            }
        } catch (error) {
            setSnackbarMessage(`Error: ${error.message}`);
        } finally{
            setIsUpdatingSnapshots(false);
        }
    };
    const handleFixWithClaude = ()=>{
        // TODO: Integrate with FixWithClaudeDialog component
        const prompt = `Fix this failing Playwright test:

Test: ${test.name}
File: ${test.file}
Role: ${test.role}
Tags: ${test.tags.join(', ')}

Error:
${test.error}

Please analyze the error and suggest a fix for this E2E test.`;
        console.log('Claude fix prompt:', prompt);
        setSnackbarMessage('Claude fix integration coming soon!');
    };
    const hasArtifacts = test.artifacts && (test.artifacts.screenshots.length > 0 || test.artifacts.videos.length > 0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                onClick: onBack,
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YLXO))), {}),
                sx: {
                    mb: 2
                },
                children: "Back to Tests"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5WjaY.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "h5",
                                gutterBottom: true,
                                children: test.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "text.secondary",
                                gutterBottom: true,
                                children: test.file
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                mt: 2,
                                display: "flex",
                                gap: 1,
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                        label: test.status.toUpperCase(),
                                        color: $a5c36d2142115643$var$getStatusColor(test.status)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                        label: test.role,
                                        variant: "outlined"
                                    }),
                                    test.tags.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: `@${tag}`,
                                            variant: "outlined",
                                            size: "small"
                                        }, tag)),
                                    test.duration !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                        label: `${Math.round(test.duration)}ms`,
                                        variant: "outlined",
                                        size: "small"
                                    })
                                ]
                            }),
                            test.error && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                                severity: "error",
                                sx: {
                                    mt: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle2",
                                        gutterBottom: true,
                                        children: "Error Message:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        component: "pre",
                                        sx: {
                                            mt: 1,
                                            p: 2,
                                            bgcolor: '#1e1e1e',
                                            color: '#d4d4d4',
                                            borderRadius: 1,
                                            overflow: 'auto',
                                            fontSize: '12px',
                                            fontFamily: 'monospace',
                                            maxHeight: 400
                                        },
                                        children: test.error
                                    })
                                ]
                            }),
                            test.status === 'passed' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                severity: "success",
                                sx: {
                                    mt: 3
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: "This test passed successfully!"
                                })
                            })
                        ]
                    }),
                    test.status === 'failed' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b46a5bcac23a5f99$export$2e2bcd8739ae039), {
                        sx: {
                            p: 2,
                            pt: 0,
                            gap: 1
                        },
                        children: [
                            hasArtifacts && test.artifacts.screenshots.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d812595be82c5518$exports))), {}),
                                variant: "outlined",
                                size: "small",
                                disabled: true,
                                children: [
                                    "View Screenshots (",
                                    test.artifacts.screenshots.length,
                                    ")"
                                ]
                            }),
                            hasArtifacts && test.artifacts.videos.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1892dbb6dceffbba$exports))), {}),
                                variant: "outlined",
                                size: "small",
                                disabled: true,
                                children: [
                                    "View Videos (",
                                    test.artifacts.videos.length,
                                    ")"
                                ]
                            }),
                            $a5c36d2142115643$var$isSnapshotFailure(test.error) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($abf2e6573b7dedd2$exports))), {}),
                                variant: "outlined",
                                color: "warning",
                                size: "small",
                                onClick: handleUpdateSnapshots,
                                disabled: isUpdatingSnapshots,
                                children: isUpdatingSnapshots ? 'Updating...' : 'Update Snapshots'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kPlrn))), {}),
                                variant: "contained",
                                color: "primary",
                                size: "small",
                                onClick: handleFixWithClaude,
                                children: "Fix with Claude"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                open: !!snackbarMessage,
                autoHideDuration: 6000,
                onClose: ()=>setSnackbarMessage(null),
                message: snackbarMessage
            })
        ]
    });
};


const $4287604e495d0485$export$5989d753cf257e84 = ()=>{
    const [testGroups, setTestGroups] = (0, $acw62.useState)([]);
    const [selectedTest, setSelectedTest] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [isRunning, setIsRunning] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [runOutput, setRunOutput] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        loadTests();
    }, []);
    const loadTests = async ()=>{
        setIsLoading(true);
        setError(null);
        try {
            const res = await fetch('http://localhost:9999/api/playwright-tests');
            if (!res.ok) throw new Error(`Failed to load tests: ${res.statusText}`);
            const data = await res.json();
            setTestGroups(data.results || []);
        } catch (err) {
            setError(err.message);
        } finally{
            setIsLoading(false);
        }
    };
    const handleRunTests = async ()=>{
        setIsRunning(true);
        setRunOutput([]);
        setError(null);
        try {
            const response = await fetch('http://localhost:9999/api/playwright-run', {
                method: 'POST'
            });
            const reader = response.body?.getReader();
            const decoder = new TextDecoder();
            if (!reader) throw new Error('Failed to start test execution');
            while(true){
                const { done: done, value: value } = await reader.read();
                if (done) break;
                const text = decoder.decode(value);
                const lines = text.split('\n').filter((line)=>line.trim().startsWith('data:'));
                lines.forEach((line)=>{
                    const data = line.substring(5).trim(); // Remove 'data:' prefix
                    try {
                        const event = JSON.parse(data);
                        switch(event.type){
                            case 'started':
                                setRunOutput((prev)=>[
                                        ...prev,
                                        `Test execution started (${event.processId})`
                                    ]);
                                break;
                            case 'output':
                                setRunOutput((prev)=>[
                                        ...prev,
                                        event.data
                                    ]);
                                break;
                            case 'complete':
                                setRunOutput((prev)=>[
                                        ...prev,
                                        `\nTest execution completed with code ${event.code}`
                                    ]);
                                setIsRunning(false);
                                // Reload test results after completion
                                setTimeout(()=>loadTests(), 1000);
                                break;
                            case 'error':
                                setError(event.error);
                                setIsRunning(false);
                                break;
                        }
                    } catch (e) {
                    // Ignore parse errors from incomplete JSON
                    }
                });
            }
        } catch (err) {
            setError(err.message);
            setIsRunning(false);
        }
    };
    const getTotalTestCount = ()=>{
        return testGroups.reduce((sum, group)=>{
            return sum + Object.values(group.tags).reduce((tagSum, tests)=>tagSum + tests.length, 0);
        }, 0);
    };
    const getAverageDuration = ()=>{
        let totalDuration = 0;
        let testsWithDuration = 0;
        testGroups.forEach((group)=>{
            Object.values(group.tags).forEach((tests)=>{
                tests.forEach((test)=>{
                    if (test.duration !== undefined) {
                        totalDuration += test.duration;
                        testsWithDuration++;
                    }
                });
            });
        });
        return testsWithDuration > 0 ? totalDuration / testsWithDuration : 0;
    };
    const getEstimatedDuration = ()=>{
        const totalTests = getTotalTestCount();
        const avgDuration = getAverageDuration();
        // If we have historical data, use it
        if (avgDuration > 0) return avgDuration * totalTests;
        // Otherwise, estimate based on typical Playwright test duration
        // Smoke tests: ~2s, Workflow tests: ~5s
        // Assume average of 3.5s per test
        const estimatedAvg = 3500; // 3.5 seconds in ms
        return estimatedAvg * totalTests;
    };
    const formatDuration = (ms)=>{
        const seconds = Math.floor(ms / 1000);
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        if (minutes > 0) return `~${minutes}m ${remainingSeconds}s`;
        return `~${seconds}s`;
    };
    const hasAnyTests = getTotalTestCount() > 0;
    const estimatedDuration = getEstimatedDuration();
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        p: 3,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                gutterBottom: true,
                children: "Loading Playwright tests..."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {})
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        p: 3,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
            severity: "error",
            sx: {
                mb: 2
            },
            action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                color: "inherit",
                size: "small",
                onClick: loadTests,
                children: "Retry"
            }),
            children: error
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        p: 3,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "h4",
                                children: "Playwright Tests"
                            }),
                            hasAnyTests && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "text.secondary",
                                children: [
                                    getTotalTestCount(),
                                    " tests \xb7 Est. ",
                                    formatDuration(estimatedDuration)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        onClick: handleRunTests,
                        disabled: isRunning,
                        color: "primary",
                        children: isRunning ? 'Running Tests...' : 'Run All Tests'
                    })
                ]
            }),
            !hasAnyTests && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "info",
                sx: {
                    mb: 2
                },
                children: 'No Playwright test results found. Click "Run All Tests" to execute the test suite.'
            }),
            isRunning && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                        severity: "info",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "body2",
                            gutterBottom: true,
                            children: "Running Playwright tests... This may take a few minutes."
                        })
                    }),
                    runOutput.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            mt: 2,
                            p: 2,
                            bgcolor: '#1e1e1e',
                            color: '#d4d4d4',
                            borderRadius: 1,
                            maxHeight: 400,
                            overflow: 'auto',
                            fontFamily: 'monospace',
                            fontSize: '12px'
                        },
                        children: runOutput.map((line, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: line
                            }, idx))
                    })
                ]
            }),
            selectedTest ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c36d2142115643$export$99e616ae8e2e9f4e), {
                test: selectedTest,
                onBack: ()=>setSelectedTest(null),
                onRefresh: loadTests
            }) : hasAnyTests && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b24182ce835ade5$export$c1c58d06f783ec80), {
                testGroups: testGroups,
                onSelectTest: setSelectedTest
            })
        ]
    });
};


const $00a803aeca10f61d$var$TAB_NAMES = [
    'lint-triage',
    'test-failures',
    'playwright-tests'
];
const $00a803aeca10f61d$export$d4d8c31640dc9976 = ()=>{
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    // Get initial tab from URL hash parameter
    const getInitialTab = ()=>{
        const hash = location.hash;
        const params = new URLSearchParams(hash.split('?')[1] || '');
        const tabParam = params.get('tab');
        const tabIndex = $00a803aeca10f61d$var$TAB_NAMES.indexOf(tabParam || '');
        return tabIndex >= 0 ? tabIndex : 0;
    };
    const [tab, setTab] = (0, $acw62.useState)(getInitialTab);
    // Update tab when URL changes
    (0, $acw62.useEffect)(()=>{
        const newTab = getInitialTab();
        if (newTab !== tab) setTab(newTab);
    }, [
        location.hash
    ]);
    const handleTabChange = (_, newValue)=>{
        setTab(newValue);
        // Update URL hash with tab parameter
        const hash = location.hash.split('?')[0];
        navigate(`${hash}?tab=${$00a803aeca10f61d$var$TAB_NAMES[newValue]}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                value: tab,
                onChange: handleTabChange,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        label: "Lint Triage"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        label: "Test Failures"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        label: "Playwright Tests"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    mt: 2
                },
                children: [
                    tab === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c55ffb179de49ee$export$d2f1f8a9f24159f8), {}),
                    tab === 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b89bc374518c1ca5$export$dd5c4cb95b11992e), {}),
                    tab === 2 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4287604e495d0485$export$5989d753cf257e84), {})
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
parcelRequire("lJX3N");
var $a7YqU = parcelRequire("a7YqU");

var $ayMG0 = parcelRequire("ayMG0");

var $30UGG = parcelRequire("30UGG");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $c23f457d2a179863$var$useInterval = function(callback, delay) {
    var savedCallback = (0, $acw62.useRef)(function() {});
    (0, $acw62.useEffect)(function() {
        savedCallback.current = callback;
    });
    (0, $acw62.useEffect)(function() {
        if (delay !== null) {
            var interval_1 = setInterval(function() {
                return savedCallback.current();
            }, delay || 0);
            return function() {
                return clearInterval(interval_1);
            };
        }
        return undefined;
    }, [
        delay
    ]);
};
var $c23f457d2a179863$export$2e2bcd8739ae039 = $c23f457d2a179863$var$useInterval;



var $2LXej = parcelRequire("2LXej");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $kfA3C = parcelRequire("kfA3C");
var $fqtQp = parcelRequire("fqtQp");
parcelRequire("acw62");
const $f29ac18636ec0146$export$4d4628463ce30b0c = ({ exportChecksums: exportChecksums })=>{
    const columns = [
        {
            field: "table_name",
            headerName: "Table Name",
            width: 200,
            editable: false,
            sortable: false
        },
        {
            field: "checksum",
            headerName: "Checksum",
            width: 300,
            editable: false,
            sortable: false
        },
        {
            field: "last_updated",
            headerName: "Last Updated",
            width: 250,
            editable: false,
            sortable: false,
            valueGetter: (_, row)=>{
                if (!row.last_updated) return "N/A";
                return (0, $kfA3C.format)(new Date(row.last_updated), "yyyy-MM-dd hh:mm:ss a z");
            }
        },
        {
            field: "last_updated_relative",
            headerName: "",
            width: 200,
            editable: false,
            sortable: false,
            valueGetter: (_, row)=>{
                if (!row.last_updated) return "N/A";
                return (0, $fqtQp.formatDistance)(new Date(row.last_updated), new Date(), {
                    addSuffix: true
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        sx: {
            height: "250px",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        children: "Aircraft Last Updated"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "textSecondary",
                        children: `The last time when the aircraft data (labels, images, sizes, etc.) were updated on this instance.`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                disableColumnFilter: true,
                disableColumnMenu: true,
                disableColumnSelector: true,
                disableRowSelectionOnClick: true,
                hideFooterPagination: true,
                getRowId: (row)=>row.table_name,
                rows: exportChecksums,
                columns: columns
            })
        ]
    });
};


const $f24ea69507aa2f55$export$68fd2147e58fe0b4 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [exportChecksums, setExportChecksums] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        (async ()=>{
            const result = await postgrest.rpc("export_checksum");
            console.log("result", result);
            setExportChecksums(result.data);
        })();
    }, []);
    (0, $c23f457d2a179863$export$2e2bcd8739ae039)(async ()=>{
        const result = await postgrest.rpc("export_checksum");
        setExportChecksums(result.data);
    }, 10000);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f29ac18636ec0146$export$4d4628463ce30b0c), {
        exportChecksums: exportChecksums
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");


var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $kfA3C = parcelRequire("kfA3C");
var $fqtQp = parcelRequire("fqtQp");
parcelRequire("acw62");
const $45f956b6ef63d0e6$export$a096138980f63164 = ({ integrations: integrations })=>{
    const columns = [
        {
            field: "fbo_name",
            headerName: "FBO",
            width: 200,
            editable: false,
            sortable: false
        },
        {
            field: "external_company_id",
            headerName: "Company ID",
            width: 150,
            editable: false,
            sortable: false
        },
        {
            field: "sync_status",
            headerName: "Status",
            width: 125,
            editable: false,
            sortable: false,
            renderCell: (params)=>{
                const status = params.row.sync_status || 'pending';
                let color = "default";
                if (status === "success") color = "success";
                else if (status === "error") color = "error";
                else if (status === "pending") color = "warning";
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                    size: "small",
                    label: status.toUpperCase(),
                    color: color
                });
            }
        },
        {
            field: "last_sync_at",
            headerName: "Last Sync",
            width: 250,
            editable: false,
            sortable: false,
            valueGetter: (_, row)=>{
                if (!row.last_sync_at) return "Never";
                return (0, $kfA3C.format)(new Date(row.last_sync_at), "yyyy-MM-dd hh:mm:ss a z");
            }
        },
        {
            field: "last_sync_at_relative",
            headerName: "",
            width: 200,
            editable: false,
            sortable: false,
            valueGetter: (_, row)=>{
                if (!row.last_sync_at) return "";
                return (0, $fqtQp.formatDistance)(new Date(row.last_sync_at), new Date(), {
                    addSuffix: true
                });
            }
        },
        {
            field: "sync_error",
            headerName: "Error",
            width: 300,
            editable: false,
            sortable: false,
            valueGetter: (_, row)=>{
                return row.sync_error || "";
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        sx: {
            height: "250px",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        children: "FlightBridge Integrations"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "textSecondary",
                        children: "FlightBridge syncs trip schedules and concierge reservations from external flight operations systems. Each FBO integration syncs incrementally based on webhooks and scheduled updates."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                disableColumnFilter: true,
                disableColumnMenu: true,
                disableColumnSelector: true,
                disableRowSelectionOnClick: true,
                hideFooterPagination: true,
                hideFooter: true,
                rows: integrations,
                columns: columns,
                getRowId: (row)=>row.fbo_id
            })
        ]
    });
};


const $2f6f9109153d4e5f$export$6f5031c4dd0f28dd = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [integrations, setIntegrations] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        (async ()=>{
            const result = await postgrest.from("fbo_integration").select("fbo_id, external_company_id, airport_codes, sync_status, last_sync_at, sync_error, fbo:fbo_id(name)").eq("provider", "flightbridge").eq("enabled", true);
            if (result.data) {
                // Flatten PostgREST join result
                const mapped = result.data.map((row)=>({
                        fbo_id: row.fbo_id,
                        fbo_name: row.fbo?.name || 'Unknown FBO',
                        external_company_id: row.external_company_id,
                        airport_codes: row.airport_codes,
                        sync_status: row.sync_status || 'pending',
                        last_sync_at: row.last_sync_at,
                        sync_error: row.sync_error
                    }));
                setIntegrations(mapped);
            }
        })();
    }, [
        postgrest
    ]);
    // Auto-refresh every 10 seconds (like WorkerStatus)
    (0, $c23f457d2a179863$export$2e2bcd8739ae039)(async ()=>{
        const result = await postgrest.from("fbo_integration").select("fbo_id, external_company_id, airport_codes, sync_status, last_sync_at, sync_error, fbo:fbo_id(name)").eq("provider", "flightbridge").eq("enabled", true);
        if (result.data) {
            const mapped = result.data.map((row)=>({
                    fbo_id: row.fbo_id,
                    fbo_name: row.fbo?.name || 'Unknown FBO',
                    external_company_id: row.external_company_id,
                    airport_codes: row.airport_codes,
                    sync_status: row.sync_status || 'pending',
                    last_sync_at: row.last_sync_at,
                    sync_error: row.sync_error
                }));
            setIntegrations(mapped);
        }
    }, 10000);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45f956b6ef63d0e6$export$a096138980f63164), {
        integrations: integrations
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $6fDLr = parcelRequire("6fDLr");

var $3kyM0 = parcelRequire("3kyM0");

var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
function $d23d5afe806e3c05$export$d5ae1d7d149f50ef(data) {
    if (!data || typeof data !== 'object') return false;
    // Check that each component is either null or an object with expected keys
    const validateComponent = (comp)=>{
        if (comp === null) return true;
        if (typeof comp !== 'object') return false;
        return 'prod' in comp && 'worker1' in comp && 'worker2' in comp;
    };
    return validateComponent(data.aircraft) && validateComponent(data.obstacles) && validateComponent(data.towing);
}
const $d23d5afe806e3c05$var$StatusCell = ({ status: status })=>{
    let symbol = "\u2014";
    let color = "text.disabled";
    if (status === "success") {
        symbol = "\u2713";
        color = "success.main";
    } else if (status === "skipped") {
        symbol = "\u25CB";
        color = "info.main";
    } else if (status === "error") {
        symbol = "\u2717";
        color = "error.main";
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            color: color,
            fontWeight: "bold",
            fontSize: "1rem"
        },
        children: symbol
    });
};
const $d23d5afe806e3c05$export$4802cc3850db4f0b = ({ summary: summary })=>{
    if (!summary) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 2
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: "body2",
            color: "text.secondary",
            children: "No execution details available"
        })
    });
    const components = [
        {
            key: "aircraft",
            label: "Aircraft",
            data: summary.aircraft
        },
        {
            key: "obstacles",
            label: "Obstacles",
            data: summary.obstacles
        },
        {
            key: "towing",
            label: "Towing Equip",
            data: summary.towing
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            p: 2,
            backgroundColor: "grey.50"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "subtitle2",
                gutterBottom: true,
                children: "Execution Details"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                size: "small",
                sx: {
                    maxWidth: 400
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    sx: {
                                        fontWeight: "bold"
                                    },
                                    children: "Component"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    sx: {
                                        fontWeight: "bold",
                                        textAlign: "center"
                                    },
                                    children: "Prod"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    sx: {
                                        fontWeight: "bold",
                                        textAlign: "center"
                                    },
                                    children: "Worker 1"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    sx: {
                                        fontWeight: "bold",
                                        textAlign: "center"
                                    },
                                    children: "Worker 2"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                        children: components.map(({ key: key, label: label, data: data })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d23d5afe806e3c05$var$StatusCell, {
                                            status: data?.prod || null
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d23d5afe806e3c05$var$StatusCell, {
                                            status: data?.worker1 || null
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        sx: {
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d23d5afe806e3c05$var$StatusCell, {
                                            status: data?.worker2 || null
                                        })
                                    })
                                ]
                            }, key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    mt: 1,
                    display: "flex",
                    gap: 2,
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "caption",
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                component: "span",
                                sx: {
                                    color: "success.main",
                                    fontWeight: "bold"
                                },
                                children: "\u2713"
                            }),
                            "Success"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "caption",
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                component: "span",
                                sx: {
                                    color: "info.main",
                                    fontWeight: "bold"
                                },
                                children: "\u25CB"
                            }),
                            "Skipped"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "caption",
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                component: "span",
                                sx: {
                                    color: "error.main",
                                    fontWeight: "bold"
                                },
                                children: "\u2717"
                            }),
                            "Error"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "caption",
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "text.disabled"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                component: "span",
                                sx: {
                                    fontWeight: "bold"
                                },
                                children: "\u2014"
                            }),
                            "N/A"
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $ipR47 = parcelRequire("ipR47");

var $evsWN = parcelRequire("evsWN");

var $euRCv = parcelRequire("euRCv");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $2cPwN = parcelRequire("2cPwN");
var $9SK5h = parcelRequire("9SK5h");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $kfA3C = parcelRequire("kfA3C");
var $fqtQp = parcelRequire("fqtQp");

var $acw62 = parcelRequire("acw62");

const $84892b34d6394465$export$bf59a0ff4d98c83a = ({ jobs: jobs, loading: loading, error: error, jobSummaries: jobSummaries, onForceRun: onForceRun, isForceRunning: isForceRunning, isRefreshing: isRefreshing })=>{
    const [expandedJobId, setExpandedJobId] = $acw62.useState(null);
    if (loading && jobs.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "subtitle2",
                children: "Render Job History"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                size: 24
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "subtitle2",
                children: "Render Job History"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "error",
                children: error
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "subtitle2",
                                        children: "Render Job History"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: "Force Run resets the checksum and runs the job even if data hasn't changed. Useful for testing or ensuring all databases are synchronized.",
                                        placement: "top",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                            fontSize: "small",
                                            sx: {
                                                color: "text.secondary",
                                                cursor: "help"
                                            }
                                        })
                                    }),
                                    isRefreshing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: "Refreshing job list...",
                                        placement: "top",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                            size: 16,
                                            color: "primary",
                                            sx: {
                                                ml: 0.5
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "textSecondary",
                                children: "Recent jobs from Render (update-aircraft, movable obstacles, towing equipment). Auto-refreshes every 10 seconds."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        color: "primary",
                        size: "small",
                        startIcon: isForceRunning ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                            size: 16,
                            color: "inherit"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euRCv))), {}),
                        onClick: onForceRun,
                        disabled: isForceRunning,
                        sx: {
                            minWidth: "140px"
                        },
                        children: isForceRunning ? "Running..." : "Force Run"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 1,
                    maxHeight: "600px",
                    overflowY: "auto"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: "180px 120px 180px 100px 110px",
                            p: 1,
                            backgroundColor: "grey.100",
                            borderBottom: "2px solid",
                            borderColor: "divider",
                            fontWeight: "bold",
                            fontSize: "0.875rem",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                children: "Job Type"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                children: "Created"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                children: "Duration"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                children: "Dashboard"
                            })
                        ]
                    }),
                    jobs.map((job)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                mb: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    onClick: ()=>setExpandedJobId(expandedJobId === job.id ? null : job.id),
                                    sx: {
                                        display: "grid",
                                        gridTemplateColumns: "180px 120px 180px 100px 110px",
                                        p: 1,
                                        borderBottom: "1px solid",
                                        borderColor: "divider",
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "action.hover"
                                        },
                                        backgroundColor: expandedJobId === job.id ? "action.selected" : "transparent"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            children: job.startCommand.includes("load_aircraft") ? "Update Aircraft" : job.startCommand.includes("load_movable_obstacles") ? "Update Movable Obstacles" : "Update Towing Equipment"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                size: "small",
                                                label: job.status.toUpperCase(),
                                                color: job.status === "succeeded" ? "success" : job.status === "failed" ? "error" : job.status === "pending" ? "warning" : job.status === "running" ? "info" : "default"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: (0, $kfA3C.format)(new Date(job.createdAt), "yyyy-MM-dd hh:mm:ss a"),
                                            placement: "top",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                sx: {
                                                    cursor: "help"
                                                },
                                                children: (0, $fqtQp.formatDistance)(new Date(job.createdAt), new Date(), {
                                                    addSuffix: true
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            children: job.duration_seconds ? (()=>{
                                                const totalSeconds = Math.floor(job.duration_seconds);
                                                const minutes = Math.floor(totalSeconds / 60);
                                                const seconds = totalSeconds % 60;
                                                return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
                                            })() : ""
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9SK5h.default), {
                                                href: job.dashboard_url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                onClick: (e)=>e.stopPropagation(),
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5
                                                },
                                                children: [
                                                    "View",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($evsWN))), {
                                                        fontSize: "small"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                expandedJobId === job.id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        borderBottom: "1px solid",
                                        borderColor: "divider",
                                        backgroundColor: "grey.50"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23d5afe806e3c05$export$4802cc3850db4f0b), {
                                        summary: jobSummaries.get(job.id) || null
                                    })
                                })
                            ]
                        }, job.id))
                ]
            })
        ]
    });
};


const $eb88e1f2631d5f51$export$35dde12516dc6859 = ()=>{
    const { url: webURL } = (0, $3kyM0.useTokenMaker)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const [jobs, setJobs] = $acw62.useState([]);
    const [loading, setLoading] = $acw62.useState(true);
    const [error, setError] = $acw62.useState(null);
    const [jobSummaries, setJobSummaries] = $acw62.useState(new Map());
    const [isForceRunning, setIsForceRunning] = $acw62.useState(false);
    const [isRefreshing, setIsRefreshing] = $acw62.useState(false);
    // Track already-fetched job IDs to prevent re-fetching on every jobs change
    const fetchedJobIdsRef = $acw62.useRef(new Set());
    const fetchJobs = $acw62.useCallback(async ()=>{
        // Set refreshing state (but only if we have jobs already)
        const hasJobs = jobs.length > 0;
        if (hasJobs) setIsRefreshing(true);
        try {
            const response = await fetch(`${webURL}/jobs/render/list`);
            if (!response.ok) throw new Error(`Failed to fetch jobs: ${response.statusText}`);
            const data = await response.json();
            // Transform Render API response to our format
            // Render API returns array of {cursor, job} objects
            // Filter out jobs without IDs (API sometimes returns incomplete data)
            const mapped = data.filter((item)=>item.job && item.job.id).map((item)=>{
                const job = item.job;
                return {
                    id: job.id,
                    startCommand: job.startCommand,
                    status: job.status,
                    createdAt: job.createdAt,
                    startedAt: job.startedAt || null,
                    finishedAt: job.finishedAt || null,
                    exitCode: job.exitCode ?? null,
                    dashboard_url: `https://dashboard.render.com/jobs/${job.id}`,
                    duration_seconds: job.startedAt && job.finishedAt ? (new Date(job.finishedAt).getTime() - new Date(job.startedAt).getTime()) / 1000 : null
                };
            });
            setJobs(mapped);
            setError(null);
        } catch (err) {
            console.error("Failed to fetch Render jobs:", err);
            setError(err instanceof Error ? err.message : "Unknown error");
        } finally{
            setLoading(false);
            setIsRefreshing(false);
        }
    }, [
        webURL,
        jobs.length
    ]);
    $acw62.useEffect(()=>{
        fetchJobs();
    }, [
        fetchJobs
    ]);
    // Fetch job summaries (execution details from database)
    // Only fetches summaries for NEW jobs (not already fetched) to avoid race conditions
    const fetchJobSummaries = $acw62.useCallback(async (jobs)=>{
        const completedJobs = jobs.filter((j)=>(j.status === 'succeeded' || j.status === 'failed') && !fetchedJobIdsRef.current.has(j.id) // ONLY fetch NEW jobs
        );
        if (completedJobs.length === 0) return; // No new jobs to fetch
        const summaryPromises = completedJobs.map(async (job)=>{
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), 10000); // 10s timeout
            try {
                const response = await fetch(`${webURL}/jobs/render/${job.id}/summary`, {
                    signal: controller.signal
                });
                const data = await response.json();
                // Validate data structure at runtime
                if (!(0, $d23d5afe806e3c05$export$d5ae1d7d149f50ef)(data)) {
                    console.warn(`Invalid summary data for ${job.id}`, data);
                    return {
                        jobId: job.id,
                        summary: null,
                        error: 'Invalid data format'
                    };
                }
                fetchedJobIdsRef.current.add(job.id); // Mark as fetched
                return {
                    jobId: job.id,
                    summary: data,
                    error: null
                };
            } catch (err) {
                if (err.name === 'AbortError') console.warn(`Summary fetch timeout for ${job.id}`);
                else console.error(`Failed to fetch summary for ${job.id}:`, err);
                return {
                    jobId: job.id,
                    summary: null,
                    error: err.message
                };
            } finally{
                clearTimeout(timeoutId);
            }
        });
        const results = await Promise.all(summaryPromises);
        setJobSummaries((prev)=>{
            const updated = new Map(prev);
            results.forEach(({ jobId: jobId, summary: summary })=>{
                if (summary) updated.set(jobId, summary);
            });
            return updated;
        });
    }, [
        webURL
    ]);
    $acw62.useEffect(()=>{
        if (jobs.length > 0) fetchJobSummaries(jobs);
    }, [
        jobs,
        fetchJobSummaries
    ]);
    // Force run handler
    const handleForceRun = $acw62.useCallback(async ()=>{
        setIsForceRunning(true);
        try {
            const response = await fetch(`${webURL}/jobs/force-update-aircraft`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || "Failed to force run job");
            }
            snackbar.notify({
                text: "Force run triggered - aircraft update will run regardless of checksum",
                severity: "success"
            });
            // Refresh job list immediately
            setTimeout(()=>fetchJobs(), 1000);
        } catch (err) {
            console.error("Force run failed:", err);
            snackbar.notify({
                text: `Failed to force run: ${err instanceof Error ? err.message : "Unknown error"}`,
                severity: "error"
            });
        } finally{
            setIsForceRunning(false);
        }
    }, [
        webURL,
        fetchJobs,
        snackbar
    ]);
    // Auto-refresh every 10 seconds (matches FlightBridgeStatus pattern)
    (0, $c23f457d2a179863$export$2e2bcd8739ae039)(fetchJobs, 10000);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84892b34d6394465$export$bf59a0ff4d98c83a), {
        jobs: jobs,
        loading: loading,
        error: error,
        jobSummaries: jobSummaries,
        onForceRun: handleForceRun,
        isForceRunning: isForceRunning,
        isRefreshing: isRefreshing
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");


var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $kfA3C = parcelRequire("kfA3C");
var $fqtQp = parcelRequire("fqtQp");
parcelRequire("acw62");
const $5e28f87ed6e0b9de$var$formatDate = (0, $kfA3C.format);
const $5e28f87ed6e0b9de$export$972f989d72b589a = ({ healthchecks: healthchecks })=>{
    const columns = [
        {
            field: "name",
            headerName: "Worker",
            width: 200,
            editable: false,
            sortable: false
        },
        {
            field: "status",
            headerName: "Status",
            width: 125,
            editable: false,
            sortable: false,
            renderCell: (params)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                    size: "small",
                    label: params.row.status,
                    color: params.row.status === "OK" ? "success" : "error"
                });
            }
        },
        {
            field: "last_updated",
            headerName: "Last Checked",
            width: 250,
            editable: false,
            sortable: false,
            valueGetter: (_, row)=>{
                if (!row.last_updated) return "N/A";
                return $5e28f87ed6e0b9de$var$formatDate(new Date(row.last_updated), "yyyy-MM-dd hh:mm:ss a z");
            }
        },
        {
            field: "last_updated_relative",
            headerName: "",
            width: 200,
            editable: false,
            sortable: false,
            valueGetter: (_, row)=>{
                if (!row.last_updated) return "N/A";
                return (0, $fqtQp.formatDistance)(new Date(row.last_updated), new Date(), {
                    addSuffix: true
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        sx: {
            height: "250px",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        children: "Workers"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "textSecondary",
                        children: `Each worker reports home every minute to let us know how it's doing. Every time we checks-in, the worker runs a very small version of the AutoStacking algorithm. This should run in <50ms. It's the best way to determine if something is wrong.`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                disableColumnFilter: true,
                disableColumnMenu: true,
                disableColumnSelector: true,
                disableRowSelectionOnClick: true,
                hideFooterPagination: true,
                hideFooter: true,
                rows: healthchecks,
                columns: columns,
                getRowId: (row)=>row.name
            })
        ]
    });
};


const $91e38bba84bf912c$export$f44b31b408c0abf1 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [healthchecks, setHealthChecks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        (async ()=>{
            const result = await postgrest.from("healthcheck").select();
            setHealthChecks(result.data);
        })();
    }, []);
    (0, $c23f457d2a179863$export$2e2bcd8739ae039)(async ()=>{
        const result = await postgrest.from("healthcheck").select();
        setHealthChecks(result.data);
    }, 10000);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e28f87ed6e0b9de$export$972f989d72b589a), {
        healthchecks: healthchecks
    });
};




const $916ab46e0adccdf5$export$9c2acc1ae06565bb = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 4,
        maxWidth: 1000,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91e38bba84bf912c$export$f44b31b408c0abf1), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6f9109153d4e5f$export$6f5031c4dd0f28dd), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $164d2a3175b4615c$export$e926676385687eaf), {
                fallbackTitle: "Job History Error",
                fallbackDescription: "Unable to load render job history. Please refresh the page.",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb88e1f2631d5f51$export$35dde12516dc6859), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f24ea69507aa2f55$export$68fd2147e58fe0b4), {})
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $dqlTG = parcelRequire("dqlTG");

var $7fruN = parcelRequire("7fruN");

var $2s2i8 = parcelRequire("2s2i8");

var $1KzZ6 = parcelRequire("1KzZ6");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $ZD2ym = parcelRequire("ZD2ym");

var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $ex6lH = parcelRequire("ex6lH");

var $cFBau = parcelRequire("cFBau");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");
const $950bf8d0cf7ae392$export$8ed650531a6535a7 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const api = postgrest;
    const [testFBOs, setTestFBOs] = $acw62.useState([]);
    const [employees, setEmployees] = $acw62.useState([]);
    const [allFBOs, setAllFBOs] = $acw62.useState([]);
    const [addFBODialog, setAddFBODialog] = $acw62.useState(false);
    const [addEmployeeDialog, setAddEmployeeDialog] = $acw62.useState(false);
    const [selectedFBO, setSelectedFBO] = $acw62.useState(null);
    const [reason, setReason] = $acw62.useState("");
    const [email, setEmail] = $acw62.useState("");
    const testFBOColumns = [
        {
            field: "fbo_name",
            headerName: "FBO Name",
            width: 300,
            editable: false
        },
        {
            field: "reason",
            headerName: "Reason",
            width: 400,
            editable: false,
            valueGetter: (_, row)=>row.reason || "-"
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 100,
            editable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    height: "100%",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "outlined",
                        color: "error",
                        size: "small",
                        onClick: ()=>handleRemoveTestFBO(params.row.fbo_id),
                        children: "Delete"
                    })
                })
        }
    ];
    const loadData = async ()=>{
        try {
            // Load test FBOs
            const testFBOsRes = await postgrest.from("test_fbos").select("*, fbo:fbo_id(id, name)");
            if (testFBOsRes.data) setTestFBOs(testFBOsRes.data.map((tf)=>({
                    fbo_id: tf.fbo_id,
                    fbo_name: tf.fbo?.name || "Unknown",
                    reason: tf.reason
                })));
            // Load AirPlx employees
            const employeesRes = await postgrest.from("airplx_employees").select("email");
            if (employeesRes.data) setEmployees(employeesRes.data);
            // Load all FBOs for autocomplete
            const fbosRes = await postgrest.from("fbo").select("id, name").order("name");
            if (fbosRes.data) setAllFBOs(fbosRes.data);
        } catch (err) {
            console.error("Error loading filter data:", err);
        }
    };
    $acw62.useEffect(()=>{
        loadData();
    }, []);
    const handleAddTestFBO = async ()=>{
        if (!selectedFBO) return;
        try {
            const res = await api.rpc("api_manage_test_fbo", {
                p_fbo_id: selectedFBO.id,
                p_is_test: true,
                p_reason: reason || null
            });
            const result = res.data;
            if (result?.success) {
                await loadData();
                setAddFBODialog(false);
                setSelectedFBO(null);
                setReason("");
            }
        } catch (err) {
            console.error("Error adding test FBO:", err);
        }
    };
    const handleRemoveTestFBO = async (fbo_id)=>{
        try {
            const res = await api.rpc("api_manage_test_fbo", {
                p_fbo_id: fbo_id,
                p_is_test: false
            });
            const result = res.data;
            if (result?.success) await loadData();
        } catch (err) {
            console.error("Error removing test FBO:", err);
        }
    };
    const handleAddEmployee = async ()=>{
        if (!email) return;
        try {
            const res = await api.rpc("api_manage_airplx_employee", {
                p_email: email,
                p_is_employee: true
            });
            const result = res.data;
            if (result?.success) {
                await loadData();
                setAddEmployeeDialog(false);
                setEmail("");
            }
        } catch (err) {
            console.error("Error adding employee:", err);
        }
    };
    const handleRemoveEmployee = async (email)=>{
        try {
            const res = await api.rpc("api_manage_airplx_employee", {
                p_email: email,
                p_is_employee: false
            });
            const result = res.data;
            if (result?.success) await loadData();
        } catch (err) {
            console.error("Error removing employee:", err);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 3,
        sx: {
            width: "100%",
            maxWidth: 800,
            mx: "auto",
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        children: "Activity Tracking Filters"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "These filters exclude FBOs and users from activity reports and metrics.",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ex6lH))), {
                            sx: {
                                color: "info.dark"
                            },
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 2,
                sx: {
                    width: "100%",
                    minWidth: 700,
                    p: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body1",
                                sx: {
                                    fontWeight: 600
                                },
                                children: "Test/Demo FBOs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                onClick: ()=>setAddFBODialog(true),
                                children: "Add Test FBO"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            height: 300,
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                            rows: testFBOs.map((fbo)=>({
                                    ...fbo,
                                    id: fbo.fbo_id
                                })),
                            columns: testFBOColumns,
                            pageSizeOptions: [
                                20
                            ],
                            disableRowSelectionOnClick: true,
                            disableColumnMenu: true,
                            disableColumnFilter: true,
                            disableColumnSelector: true,
                            getRowId: (row)=>row.fbo_id
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 2,
                sx: {
                    width: "100%",
                    minWidth: 700,
                    p: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body1",
                                sx: {
                                    fontWeight: 600
                                },
                                children: "AirPlx Employees"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                onClick: ()=>setAddEmployeeDialog(true),
                                children: "Add Employee"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                label: "*@airplx.com (auto-excluded)",
                                color: "primary",
                                variant: "outlined"
                            }),
                            employees.map((emp)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: emp.email,
                                    onDelete: ()=>handleRemoveEmployee(emp.email)
                                }, emp.email)),
                            employees.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                color: "text.secondary",
                                variant: "body2",
                                children: "No additional employees configured (all @airplx.com emails are automatically excluded)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: addFBODialog,
                onClose: ()=>setAddFBODialog(false),
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Add Test/Demo FBO"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 2,
                            sx: {
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                    options: allFBOs,
                                    getOptionLabel: (option)=>option.name,
                                    value: selectedFBO,
                                    onChange: (_, value)=>setSelectedFBO(value),
                                    renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            ...params,
                                            label: "Select FBO",
                                            required: true
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Reason (optional)",
                                    value: reason,
                                    onChange: (e)=>setReason(e.target.value),
                                    placeholder: "e.g., Internal testing account",
                                    multiline: true,
                                    rows: 2
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setAddFBODialog(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleAddTestFBO,
                                variant: "contained",
                                disabled: !selectedFBO,
                                children: "Add"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: addEmployeeDialog,
                onClose: ()=>setAddEmployeeDialog(false),
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Add AirPlx Employee"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                            fullWidth: true,
                            label: "Email Address",
                            value: email,
                            onChange: (e)=>setEmail(e.target.value),
                            placeholder: "user@example.com",
                            sx: {
                                mt: 1
                            },
                            type: "email"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>setAddEmployeeDialog(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleAddEmployee,
                                variant: "contained",
                                disabled: !email,
                                children: "Add"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $lkxXU = parcelRequire("lkxXU");
var $cJu23 = parcelRequire("cJu23");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $fZSPM = parcelRequire("fZSPM");

var $dqlTG = parcelRequire("dqlTG");

var $7fruN = parcelRequire("7fruN");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2esSG = parcelRequire("2esSG");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
/**
 * Utility functions for Activity tracking components
 */ /**
 * Month name to number mapping for date parsing
 */ const $5aa3de2d83dbc4e2$var$MONTH_MAP = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11
};
const $5aa3de2d83dbc4e2$export$26bb176c15f719fe = (week)=>{
    if (typeof week === "string") return week; // Test format
    return week.label || week; // Real format
};
const $5aa3de2d83dbc4e2$export$63d9785fd2262be1 = (dateStr)=>{
    if (dateStr.includes("/")) {
        // Test format: "01/01-01/07"
        const [startDate] = dateStr.split("-");
        const [month, day] = startDate.split("/");
        const currentYear = new Date().getFullYear();
        return new Date(currentYear, parseInt(month) - 1, parseInt(day));
    } else {
        // Real format: "06-Jan-25"
        const [day, month, year] = dateStr.split("-");
        const yearNum = parseInt(year);
        // Handle 2-digit years by determining the century
        const currentYear = new Date().getFullYear();
        const currentCentury = Math.floor(currentYear / 100) * 100;
        const fullYear = yearNum < 100 ? currentCentury + yearNum : yearNum;
        return new Date(fullYear, $5aa3de2d83dbc4e2$var$MONTH_MAP[month], parseInt(day));
    }
};
const $5aa3de2d83dbc4e2$export$9154c2debcb5a609 = (weeks)=>{
    return [
        ...weeks
    ].sort((a, b)=>{
        const labelA = $5aa3de2d83dbc4e2$export$26bb176c15f719fe(a);
        const labelB = $5aa3de2d83dbc4e2$export$26bb176c15f719fe(b);
        const dateA = $5aa3de2d83dbc4e2$export$63d9785fd2262be1(labelA);
        const dateB = $5aa3de2d83dbc4e2$export$63d9785fd2262be1(labelB);
        return dateA.getTime() - dateB.getTime();
    });
};
const $5aa3de2d83dbc4e2$export$a69763144b393319 = (weeklyGrid, showTestFBOs, containerRef, metricRowsCount, rowHeight)=>{
    if (!containerRef || !weeklyGrid) return 0;
    const fboRowsCount = weeklyGrid.fbos?.filter((fbo)=>showTestFBOs || !fbo.is_test).length || 0;
    const totalRows = metricRowsCount + fboRowsCount;
    const totalHeight = totalRows * rowHeight;
    const visibleHeight = containerRef.clientHeight;
    return Math.max(0, totalHeight - visibleHeight);
};
const $5aa3de2d83dbc4e2$export$10298d0350e6529c = (activity, index)=>{
    // Prefer existing ID, then timestamp, then fall back to index
    if (activity.id) return activity.id;
    if (activity.timestamp) return activity.timestamp;
    if (activity.user_email && activity.fbo_name && activity.timestamp) // Create composite ID from unique fields
    return `${activity.user_email}-${activity.fbo_name}-${activity.timestamp}`;
    return `activity-${index}`;
};


// Constants
const $4141b4de708156c7$var$DAYS_PER_WEEK = 7;
// Constants for layout calculations
const $4141b4de708156c7$var$HEADER_HEIGHT = 39;
const $4141b4de708156c7$var$FBO_COLUMN_WIDTH = 200; // Increased to prevent text cutoff
const $4141b4de708156c7$var$WEEK_COLUMN_WIDTH = 90; // Slightly increased for date labels
const $4141b4de708156c7$export$e693c1550588d43 = ({ weeklyGrid: weeklyGrid, showTestFBOs: showTestFBOs, onShowTestFBOsChange: onShowTestFBOsChange })=>{
    if (!weeklyGrid) return null;
    // Add error handling for edge cases
    const sortedWeeks = (0, $5aa3de2d83dbc4e2$export$9154c2debcb5a609)(weeklyGrid.weeks || []);
    const filteredFbos = weeklyGrid.fbos?.filter((fbo)=>(showTestFBOs || !fbo.is_test) && fbo.fbo_name !== "FBO").sort((a, b)=>a.fbo_name.localeCompare(b.fbo_name)) || [];
    // Handle empty data
    if (!sortedWeeks.length || !filteredFbos.length) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 2,
        sx: {
            width: "100%",
            p: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                children: "Weekly Activity"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                color: "text.secondary",
                children: "No activity data available for the selected period."
            })
        ]
    });
    // Helper function to get the Sunday of a given date's week
    const getWeekStart = (date)=>{
        const weekStart = new Date(date);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay());
        return weekStart;
    };
    // Helper function to download TSV file
    const downloadTSV = (content, filename)=>{
        const blob = new Blob([
            content
        ], {
            type: "text/tab-separated-values;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        // Delay cleanup to ensure download completes in all browsers
        setTimeout(()=>URL.revokeObjectURL(url), 100);
    };
    const exportWeeklyActivityTSV = ()=>{
        if (!weeklyGrid?.fbos || !weeklyGrid?.weeks) return;
        // Prepare and sort FBOs alphabetically
        const sortedFbos = weeklyGrid.fbos.filter((fbo)=>showTestFBOs || !fbo.is_test).sort((a, b)=>a.fbo_name.localeCompare(b.fbo_name));
        // Configuration
        const START_DATE = new Date("2025-01-06");
        const END_DATE = new Date();
        const HEADERS = [
            "Date",
            "Metric",
            "FBO",
            "Activity"
        ];
        // Build activity lookup map for performance
        // Map structure: weekStartDate -> Set of FBO names with activity
        const activityMap = new Map();
        sortedFbos.forEach((fbo)=>{
            Object.entries(fbo.weeks).forEach(([weekLabel, hasActivity])=>{
                if (hasActivity) {
                    const weekDate = (0, $5aa3de2d83dbc4e2$export$63d9785fd2262be1)(weekLabel);
                    const weekKey = weekDate.toISOString().split("T")[0];
                    if (!activityMap.has(weekKey)) activityMap.set(weekKey, new Set());
                    activityMap.get(weekKey)?.add(fbo.fbo_name);
                }
            });
        });
        const rows = [];
        let currentWeekStart = getWeekStart(START_DATE);
        // Process each week
        while(currentWeekStart <= END_DATE){
            // Process each day of the week
            for(let dayOffset = 0; dayOffset < $4141b4de708156c7$var$DAYS_PER_WEEK; dayOffset++){
                const currentDay = new Date(currentWeekStart);
                currentDay.setDate(currentDay.getDate() + dayOffset);
                // Check boundaries
                if (currentDay < START_DATE || currentDay > END_DATE) continue;
                const dateStr = currentDay.toISOString().split("T")[0];
                const weekStartStr = currentWeekStart.toISOString().split("T")[0];
                // Add row for each FBO (already sorted alphabetically)
                sortedFbos.forEach((fbo)=>{
                    // Use pre-built activity map for O(1) lookup instead of O(n) search
                    const hasActivity = activityMap.get(weekStartStr)?.has(fbo.fbo_name) || false;
                    rows.push([
                        dateStr,
                        "Activity",
                        fbo.fbo_name,
                        hasActivity ? "1" : "0"
                    ]);
                });
            }
            // Move to next week (next Sunday)
            currentWeekStart.setDate(currentWeekStart.getDate() + $4141b4de708156c7$var$DAYS_PER_WEEK);
        }
        // Generate TSV content and download
        const tsvContent = [
            HEADERS.join("\t"),
            ...rows.map((row)=>row.join("\t"))
        ].join("\n");
        const filename = `weekly-activity-${new Date().toISOString().split("T")[0]}.tsv`;
        downloadTSV(tsvContent, filename);
    };
    // Common cell styles
    const cellStyle = {
        padding: "6px 12px",
        minHeight: 39,
        display: "flex",
        alignItems: "center",
        borderRight: "1px solid",
        borderRightColor: "divider",
        borderBottom: "1px solid",
        borderBottomColor: "divider"
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 2,
        sx: {
            width: "100%",
            p: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        children: "Weekly Activity"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "outlined",
                                size: "small",
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fruN))), {}),
                                onClick: exportWeeklyActivityTSV,
                                children: "Export TSV"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                                    checked: showTestFBOs,
                                    onChange: (e)=>onShowTestFBOsChange(e.target.checked)
                                }),
                                label: "Show Test FBOs"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                role: "table",
                "aria-label": "Weekly activity table with FBO rows and date columns",
                sx: {
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 1,
                    overflow: "auto",
                    maxHeight: 600,
                    position: "relative",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        display: "inline-block",
                        minWidth: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            role: "row",
                            sx: {
                                display: "flex",
                                position: "sticky",
                                top: 0,
                                zIndex: 30,
                                backgroundColor: "action.selected"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    role: "columnheader",
                                    "aria-label": "FBO column header",
                                    sx: {
                                        ...cellStyle,
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 31,
                                        minWidth: $4141b4de708156c7$var$FBO_COLUMN_WIDTH,
                                        backgroundColor: "action.selected",
                                        borderRight: "2px solid",
                                        borderRightColor: "divider",
                                        // Ensure visibility
                                        boxShadow: "2px 0 4px rgba(0,0,0,0.1)"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        sx: {
                                            fontWeight: "bold"
                                        },
                                        children: "FBO"
                                    })
                                }),
                                sortedWeeks.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        role: "columnheader",
                                        "aria-label": `Week of ${(0, $5aa3de2d83dbc4e2$export$26bb176c15f719fe)(week)}`,
                                        sx: {
                                            ...cellStyle,
                                            minWidth: $4141b4de708156c7$var$WEEK_COLUMN_WIDTH,
                                            justifyContent: "center",
                                            backgroundColor: "action.selected"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                fontSize: "0.95em"
                                            },
                                            children: (0, $5aa3de2d83dbc4e2$export$26bb176c15f719fe)(week)
                                        })
                                    }, `header-${index}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                display: "flex",
                                position: "sticky",
                                top: $4141b4de708156c7$var$HEADER_HEIGHT,
                                zIndex: 20,
                                backgroundColor: "action.hover",
                                height: 39
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        ...cellStyle,
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 21,
                                        minWidth: $4141b4de708156c7$var$FBO_COLUMN_WIDTH,
                                        backgroundColor: "action.hover",
                                        borderRight: "2px solid",
                                        borderRightColor: "divider",
                                        boxShadow: "2px 0 4px rgba(0,0,0,0.1)"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        children: "Total Customers"
                                    })
                                }),
                                sortedWeeks.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            ...cellStyle,
                                            minWidth: $4141b4de708156c7$var$WEEK_COLUMN_WIDTH,
                                            justifyContent: "center",
                                            backgroundColor: "action.hover",
                                            flexShrink: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                fontWeight: "bold"
                                            },
                                            children: week.total_customers || 0
                                        })
                                    }, `total-${index}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                display: "flex",
                                position: "sticky",
                                top: 78,
                                zIndex: 20,
                                backgroundColor: "action.hover",
                                height: 39
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        ...cellStyle,
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 21,
                                        minWidth: $4141b4de708156c7$var$FBO_COLUMN_WIDTH,
                                        backgroundColor: "action.hover",
                                        borderRight: "2px solid",
                                        borderRightColor: "divider",
                                        boxShadow: "2px 0 4px rgba(0,0,0,0.1)"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        children: "Weekly Active"
                                    })
                                }),
                                sortedWeeks.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            ...cellStyle,
                                            minWidth: $4141b4de708156c7$var$WEEK_COLUMN_WIDTH,
                                            justifyContent: "center",
                                            backgroundColor: "action.hover",
                                            flexShrink: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                fontWeight: "bold",
                                                color: "primary.main"
                                            },
                                            children: week.weekly_active || 0
                                        })
                                    }, `weekly-${index}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                display: "flex",
                                position: "sticky",
                                top: 117,
                                zIndex: 20,
                                backgroundColor: "action.hover",
                                height: 39
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        ...cellStyle,
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 21,
                                        minWidth: $4141b4de708156c7$var$FBO_COLUMN_WIDTH,
                                        backgroundColor: "action.hover",
                                        borderRight: "2px solid",
                                        borderRightColor: "divider",
                                        boxShadow: "2px 0 4px rgba(0,0,0,0.1)"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body2",
                                        children: "Monthly Active"
                                    })
                                }),
                                sortedWeeks.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            ...cellStyle,
                                            minWidth: $4141b4de708156c7$var$WEEK_COLUMN_WIDTH,
                                            justifyContent: "center",
                                            backgroundColor: "action.hover",
                                            flexShrink: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                fontWeight: "bold",
                                                color: "secondary.main"
                                            },
                                            children: week.monthly_active || 0
                                        })
                                    }, `monthly-${index}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                display: "flex",
                                marginRight: "-1px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 10,
                                        minWidth: $4141b4de708156c7$var$FBO_COLUMN_WIDTH,
                                        height: 8,
                                        backgroundColor: "divider",
                                        flexShrink: 0,
                                        borderRight: "2px solid",
                                        borderRightColor: "divider"
                                    }
                                }),
                                sortedWeeks.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            minWidth: $4141b4de708156c7$var$WEEK_COLUMN_WIDTH,
                                            height: 8,
                                            backgroundColor: "divider",
                                            flexShrink: 0
                                        }
                                    }, `separator-${index}`))
                            ]
                        }),
                        filteredFbos?.map((fbo)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                role: "row",
                                "aria-label": `Activity for ${fbo.fbo_name}`,
                                sx: {
                                    display: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        role: "rowheader",
                                        "aria-label": `FBO ${fbo.fbo_name}`,
                                        sx: {
                                            ...cellStyle,
                                            position: "sticky",
                                            left: 0,
                                            zIndex: 10,
                                            minWidth: $4141b4de708156c7$var$FBO_COLUMN_WIDTH,
                                            backgroundColor: "background.default",
                                            borderRight: "2px solid",
                                            borderRightColor: "divider",
                                            // Removed pseudo-element for better performance
                                            boxShadow: "2px 0 4px rgba(0,0,0,0.1)"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                width: "100%"
                                            },
                                            title: fbo.fbo_name,
                                            children: fbo.fbo_name
                                        })
                                    }),
                                    sortedWeeks.map((week, index)=>{
                                        const label = (0, $5aa3de2d83dbc4e2$export$26bb176c15f719fe)(week);
                                        const hasActivity = fbo.weeks?.[label];
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            role: "cell",
                                            "aria-label": `${fbo.fbo_name} activity for week of ${label}: ${hasActivity ? "Active" : "Inactive"}`,
                                            sx: {
                                                ...cellStyle,
                                                minWidth: $4141b4de708156c7$var$WEEK_COLUMN_WIDTH,
                                                justifyContent: "center",
                                                flexShrink: 0
                                            },
                                            children: hasActivity ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fZSPM))), {
                                                fontSize: "small",
                                                color: "success"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                                                fontSize: "small",
                                                color: "error"
                                            })
                                        }, `${fbo.fbo_id}-week-${index}`);
                                    })
                                ]
                            }, fbo.fbo_id))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "body2",
                    children: [
                        "Total FBOs: ",
                        filteredFbos?.length || 0
                    ]
                })
            })
        ]
    });
};


const $9bfde48683d09d80$export$2280a99e8d7149d7 = ({ metrics: metrics, weeklyGrid: weeklyGrid, showTestFBOs: showTestFBOs, onShowTestFBOsChange: onShowTestFBOsChange })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            metrics && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cJu23.default), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                            variant: "outlined",
                            sx: {
                                height: "100%",
                                borderRadius: 2,
                                boxShadow: "none",
                                "&:hover": {
                                    boxShadow: 1
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body1",
                                        color: "text.primary",
                                        gutterBottom: true,
                                        children: "Total Customers"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h2",
                                        sx: {
                                            fontSize: "3rem",
                                            fontWeight: 600
                                        },
                                        children: metrics.total_customers
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: metrics.total_customers_change > 5 ? "success.main" : "text.secondary",
                                        children: [
                                            metrics.total_customers_change > 0 ? "+" : "",
                                            metrics.total_customers_change || 0,
                                            " this month"
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                            variant: "outlined",
                            sx: {
                                height: "100%",
                                borderRadius: 2,
                                boxShadow: "none",
                                "&:hover": {
                                    boxShadow: 1
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body1",
                                        color: "text.primary",
                                        gutterBottom: true,
                                        children: "Weekly Active"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h2",
                                        sx: {
                                            fontSize: "3rem",
                                            fontWeight: 600
                                        },
                                        children: metrics.weekly_active
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: [
                                            metrics.weekly_active_percent,
                                            "% of total customers"
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                            variant: "outlined",
                            sx: {
                                height: "100%",
                                borderRadius: 2,
                                boxShadow: "none",
                                "&:hover": {
                                    boxShadow: 1
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3ulHf.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body1",
                                        color: "text.primary",
                                        gutterBottom: true,
                                        children: "Monthly Active"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h2",
                                        sx: {
                                            fontSize: "3rem",
                                            fontWeight: 600
                                        },
                                        children: metrics.monthly_active
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: [
                                            metrics.monthly_active_percent,
                                            "% of total customers"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    width: "100%",
                    // Remove overflow here as it's handled in the table component
                    pb: 2,
                    boxSizing: "border-box"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4141b4de708156c7$export$e693c1550588d43), {
                    weeklyGrid: weeklyGrid,
                    showTestFBOs: showTestFBOs,
                    onShowTestFBOsChange: onShowTestFBOsChange
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");
parcelRequire("acw62");

/**
 * Constants for Activity tracking components
 */ // Scroll synchronization
const $db5e3212e23a4517$export$60c5cebfe4d59260 = 10; // milliseconds
const $db5e3212e23a4517$export$258441c8a79bb589 = 52; // pixels
const $db5e3212e23a4517$export$cdb7fd9d999c7168 = 56; // pixels
const $db5e3212e23a4517$export$4f0e26d59544a572 = 4; // Total Customers, Weekly Active, Monthly Active, Separator
const $db5e3212e23a4517$export$9bfa11eca50c8734 = 200; // pixels
const $db5e3212e23a4517$export$f2bf5907bd3cbb5c = 140; // pixels
const $db5e3212e23a4517$export$61c763b8b48b5dc = 600; // pixels
const $db5e3212e23a4517$export$abfe9e5a2ed0cb04 = 400; // pixels
const $db5e3212e23a4517$export$9a6bb2acef5e644a = 14; // pixels
const $db5e3212e23a4517$export$316d4fd794a88351 = 14; // pixels
const $db5e3212e23a4517$export$5716e8bcb003888d = 100;
const $db5e3212e23a4517$export$a6e06e7d29ab728f = [
    25,
    50,
    100
];
const $db5e3212e23a4517$export$b257755979f3ea09 = 20;


const $67c3d66deea546d7$export$8d9137fcb112aeab = ({ recentActivity: recentActivity })=>{
    const recentActivityColumns = [
        {
            field: "user",
            headerName: "User",
            width: 300,
            editable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        py: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "body2",
                            sx: {
                                fontWeight: 500,
                                lineHeight: 1.2
                            },
                            children: params.row.user_name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            color: "text.secondary",
                            sx: {
                                lineHeight: 1.2
                            },
                            children: params.row.user_email
                        })
                    ]
                })
        },
        {
            field: "fbo_name",
            headerName: "FBO",
            width: 250,
            editable: false
        },
        {
            field: "timestamp",
            headerName: "Timestamp",
            width: 250,
            editable: false,
            valueGetter: (_, row)=>new Date(row.timestamp).toLocaleString()
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        sx: {
            width: "100%",
            minWidth: 700,
            p: 1
        },
        children: recentActivity.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
            sx: {
                textAlign: "center",
                py: 4
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                color: "text.secondary",
                children: "No recent activity"
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
            sx: {
                height: "calc(100vh - 300px)",
                // Full height minus headers
                width: "100%",
                overflow: "auto",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
                "&::-webkit-scrollbar": {
                    width: "14px",
                    height: "14px",
                    display: "block !important"
                },
                "&::-webkit-scrollbar-track": {
                    background: (theme)=>theme.palette.action.hover,
                    borderRadius: "7px"
                },
                "&::-webkit-scrollbar-thumb": {
                    background: (theme)=>theme.palette.text.secondary,
                    borderRadius: "7px",
                    border: (theme)=>`2px solid ${theme.palette.action.hover}`,
                    "&:hover": {
                        background: (theme)=>theme.palette.text.primary
                    }
                },
                "&::-webkit-scrollbar-corner": {
                    background: (theme)=>theme.palette.action.hover
                }
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    minWidth: "fit-content"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                    autoHeight: true,
                    rows: recentActivity.map((activity, idx)=>({
                            ...activity,
                            id: (0, $5aa3de2d83dbc4e2$export$10298d0350e6529c)(activity, idx)
                        })),
                    columns: recentActivityColumns,
                    pageSizeOptions: [
                        (0, $db5e3212e23a4517$export$b257755979f3ea09)
                    ],
                    disableRowSelectionOnClick: true,
                    disableColumnMenu: true,
                    disableColumnFilter: true,
                    disableColumnSelector: true,
                    getRowHeight: ()=>"auto",
                    sx: {
                        "& .MuiDataGrid-cell": {
                            alignItems: "center",
                            display: "flex"
                        },
                        "& .MuiDataGrid-pinnedColumns": {
                            boxShadow: "2px 0 5px -2px rgba(0, 0, 0, 0.1)",
                            backgroundColor: "background.paper"
                        },
                        "& .MuiDataGrid-pinnedColumns .MuiDataGrid-cell": {
                            backgroundColor: "background.paper"
                        }
                    }
                })
            })
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $cJu23 = parcelRequire("cJu23");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $8949095c694a9dc7$export$450ef49911c0760 = ({ fbos: fbos })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        spacing: 3,
        sx: {
            width: "100%",
            p: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                children: "FBO Activity Tracker"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 1,
                    p: 3,
                    backgroundColor: "background.paper"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        color: "text.secondary",
                        gutterBottom: true,
                        align: "center",
                        children: "Coming Soon"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "body2",
                        color: "text.secondary",
                        align: "center",
                        sx: {
                            mb: 3
                        },
                        children: "This feature will display activity tracking for each FBO account."
                    }),
                    fbos && fbos.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                        sx: {
                            maxHeight: 400,
                            overflow: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "subtitle2",
                                gutterBottom: true,
                                children: [
                                    "FBO Accounts (",
                                    fbos.length,
                                    "):"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                                container: true,
                                spacing: 1,
                                children: fbos.map((fbo)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        md: 4,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                p: 1.5,
                                                border: "1px solid",
                                                borderColor: "divider",
                                                borderRadius: 1,
                                                backgroundColor: "background.default"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    children: fbo.name
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    color: "text.secondary",
                                                    children: "Activity data coming soon"
                                                })
                                            ]
                                        })
                                    }, fbo.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $b80781a1032cdd95$export$9c16c1426311996d = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [loading, setLoading] = $acw62.useState(true);
    const [error, setError] = $acw62.useState(null);
    const [metrics, setMetrics] = $acw62.useState(null);
    const [recentActivity, setRecentActivity] = $acw62.useState([]);
    const [weeklyGrid, setWeeklyGrid] = $acw62.useState(null);
    const [showTestFBOs, setShowTestFBOs] = $acw62.useState(false);
    const [filtersDialog, setFiltersDialog] = $acw62.useState(false);
    const [activeTab, setActiveTab] = $acw62.useState(0); // 0: Weekly, 1: Recent, 2: FBO
    const loadData = async ()=>{
        setLoading(true);
        setError(null);
        try {
            // Load all data in parallel
            const [metricsRes, activityRes, gridRes] = await Promise.all([
                postgrest.rpc("api_get_activity_metrics"),
                postgrest.rpc("api_get_recent_activity", {
                    p_limit: 50
                }),
                postgrest.rpc("api_get_weekly_activity_grid", {
                    p_weeks: 52
                })
            ]);
            if (metricsRes.data?.success) setMetrics(metricsRes.data.metrics);
            if (activityRes.data?.success) setRecentActivity(activityRes.data.activity || []);
            if (gridRes.data?.success) setWeeklyGrid(gridRes.data.data);
        } catch (err) {
            setError("Failed to load activity data");
            console.error("Error loading activity data:", err);
        } finally{
            setLoading(false);
        }
    };
    $acw62.useEffect(()=>{
        loadData();
    }, []);
    const handleTabChange = (event, newValue)=>{
        setActiveTab(newValue);
    };
    // For FBO Activity tab - use the useActiveFBOs hook
    const { fbos: fbos } = (0, $ZD2ym.useActiveFBOs)();
    const exportReport = async ()=>{
        try {
            const res = await postgrest.rpc("api_export_activity_report");
            if (res.data?.success) {
                // Convert to CSV or download JSON
                const blob = new Blob([
                    JSON.stringify(res.data.report, null, 2)
                ], {
                    type: "application/json"
                });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `activity-report-${new Date().toISOString().split("T")[0]}.json`;
                a.click();
                URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error("Error exporting report:", err);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        display: "flex",
        justifyContent: "center",
        p: 4,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {})
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        p: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
            severity: "error",
            children: error
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            width: "100%",
            height: "100vh",
            overflowY: "auto",
            // Remove overflowX: hidden to allow horizontal scrolling within child components
            "&::-webkit-scrollbar": {
                width: "14px",
                height: "14px"
            },
            "&::-webkit-scrollbar-track": {
                background: (theme)=>theme.palette.action.hover,
                borderRadius: "7px"
            },
            "&::-webkit-scrollbar-thumb": {
                background: (theme)=>theme.palette.text.secondary,
                borderRadius: "7px",
                border: (theme)=>`2px solid ${theme.palette.action.hover}`,
                "&:hover": {
                    background: (theme)=>theme.palette.text.primary
                }
            },
            "&::-webkit-scrollbar-corner": {
                background: (theme)=>theme.palette.action.hover
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: 3,
            sx: {
                width: "100%",
                maxWidth: 1400,
                mx: "auto",
                p: 2,
                pb: 15 // Add substantial bottom padding to ensure full visibility
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "h5",
                            children: "Activity Tracking"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            display: "flex",
                            gap: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "outlined",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1KzZ6))), {}),
                                    onClick: ()=>setFiltersDialog(true),
                                    children: "Manage Filters"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "outlined",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2s2i8))), {}),
                                    onClick: loadData,
                                    children: "Refresh"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fruN))), {}),
                                    onClick: exportReport,
                                    children: "Export Report"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        borderBottom: 1,
                        borderColor: 'divider'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                        value: activeTab,
                        onChange: handleTabChange,
                        "aria-label": "activity tabs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                label: "Weekly Activity"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                label: "Recent Activity"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                label: "FBO Activity"
                            })
                        ]
                    })
                }),
                activeTab === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfde48683d09d80$export$2280a99e8d7149d7), {
                    metrics: metrics,
                    weeklyGrid: weeklyGrid,
                    showTestFBOs: showTestFBOs,
                    onShowTestFBOsChange: setShowTestFBOs
                }),
                activeTab === 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67c3d66deea546d7$export$8d9137fcb112aeab), {
                    recentActivity: recentActivity
                }),
                activeTab === 2 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8949095c694a9dc7$export$450ef49911c0760), {
                    fbos: fbos
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                    open: filtersDialog,
                    onClose: ()=>setFiltersDialog(false),
                    maxWidth: "md",
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h6",
                                        children: "Manage Activity Filters"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        onClick: ()=>setFiltersDialog(false),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                            dividers: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $950bf8d0cf7ae392$export$8ed650531a6535a7), {})
                        })
                    ]
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $7fruN = parcelRequire("7fruN");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");
const $3382779820f90fb0$export$3523f37fd7d0411b = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [aircraft, setAircraft] = (0, $acw62.useState)([]);
    const [completionStatus, setCompletionStatus] = (0, $acw62.useState)({});
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        fetchAircraft();
    }, []);
    const fetchAircraft = async ()=>{
        try {
            setLoading(true);
            // Set schema to web
            postgrest.schema = "web";
            // For admin panel, let's try direct table access instead of RPC
            // The aircraft_raw RPC has inverted logic that returns empty for admins
            const { data: aircraftData, error: aircraftError } = await postgrest.from("aircraft").select("*").order("make").order("model");
            if (aircraftError) {
                console.error("Aircraft fetch error:", aircraftError);
                throw aircraftError;
            }
            console.log("Aircraft data loaded:", aircraftData?.length || 0, "records");
            const aircraftList = aircraftData || [];
            setAircraft(aircraftList);
            // Only fetch completion status if we have aircraft
            if (aircraftList.length > 0) {
                // Fetch completion status for all aircraft
                const { data: completionData, error: completionError } = await postgrest.rpc("is_aircraft_complete", {
                    aircraft_ids: aircraftList.map((a)=>a.id)
                }).select();
                if (completionError) throw completionError;
                // Create a map of aircraft ID to completion status
                const statusMap = {};
                for (const item of completionData || [])statusMap[item.aircraft_id] = item.is_complete;
                setCompletionStatus(statusMap);
            }
        } catch (err) {
            setError(err.message || "Failed to fetch aircraft");
            console.error("Error fetching aircraft:", err);
        } finally{
            setLoading(false);
        }
    };
    return {
        loading: loading,
        aircraft: aircraft,
        completionStatus: completionStatus,
        error: error,
        refetch: fetchAircraft
    };
};



var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $7Frhn = parcelRequire("7Frhn");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

var $6n0Ko = parcelRequire("6n0Ko");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $3ceb567076b478bc$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');



var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $72164616b8f12725$export$645d356c89a51794(slot) {
    return (0, $4Cod0.default)('MuiTableSortLabel', slot);
}
const $72164616b8f12725$var$tableSortLabelClasses = (0, $beCSm.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc',
    'directionDesc',
    'directionAsc'
]);
var $72164616b8f12725$export$2e2bcd8739ae039 = $72164616b8f12725$var$tableSortLabelClasses;



var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $be01c206ebbcc5af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            `direction${(0, $jTnBY.default)(direction)}`
        ],
        icon: [
            'icon',
            `iconDirection${(0, $jTnBY.default)(direction)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $72164616b8f12725$export$645d356c89a51794), classes);
};
const $be01c206ebbcc5af$var$TableSortLabelRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $72164616b8f12725$export$2e2bcd8739ae039).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $72164616b8f12725$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $72164616b8f12725$export$2e2bcd8739ae039).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    })));
const $be01c206ebbcc5af$var$TableSortLabelIcon = (0, $d8seH.default)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $jTnBY.default)(ownerState.direction)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none',
        variants: [
            {
                props: {
                    direction: 'desc'
                },
                style: {
                    transform: 'rotate(0deg)'
                }
            },
            {
                props: {
                    direction: 'asc'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $be01c206ebbcc5af$var$TableSortLabel = /*#__PURE__*/ $acw62.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $3ceb567076b478bc$export$2e2bcd8739ae039), slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    };
    const classes = $be01c206ebbcc5af$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $be01c206ebbcc5af$var$TableSortLabelRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    });
    const [IconSlot, iconProps] = (0, $6lpak.default)('icon', {
        elementType: $be01c206ebbcc5af$var$TableSortLabelIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.icon
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        disableRipple: true,
        component: "span",
        ...rootProps,
        ...other,
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
                as: IconComponent,
                ...iconProps
            })
        ]
    });
});
var $be01c206ebbcc5af$export$2e2bcd8739ae039 = $be01c206ebbcc5af$var$TableSortLabel;


var $iAtns = parcelRequire("iAtns");

var $acw62 = parcelRequire("acw62");
const $28e2bd07f97fd99d$export$1bbc69491da977be = ({ aircraft: aircraft, completionStatus: completionStatus, selectedAircraft: selectedAircraft, onSelectAircraft: onSelectAircraft, tableRef: tableRef })=>{
    const [searchTerm, setSearchTerm] = $acw62.useState("");
    const [orderBy, setOrderBy] = $acw62.useState("make");
    const [orderDirection, setOrderDirection] = $acw62.useState("asc");
    const handleRequestSort = (property)=>{
        const isAsc = orderBy === property && orderDirection === "asc";
        setOrderDirection(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const getStatus = (aircraft)=>{
        if (aircraft.linked_to) return "locked";
        if (completionStatus[aircraft.id]) return "deployed";
        return "labeling";
    };
    const filteredAndSortedAircraft = $acw62.useMemo(()=>{
        let filtered = aircraft.filter((a)=>{
            const searchLower = searchTerm.toLowerCase();
            return a.make?.toLowerCase().includes(searchLower) || a.model?.toLowerCase().includes(searchLower) || a.id.toLowerCase().includes(searchLower);
        });
        // Sort the filtered results
        filtered.sort((a, b)=>{
            let aValue;
            let bValue;
            switch(orderBy){
                case "status":
                    const statusOrder = {
                        deployed: 0,
                        locked: 1,
                        labeling: 2
                    };
                    aValue = statusOrder[getStatus(a)];
                    bValue = statusOrder[getStatus(b)];
                    break;
                default:
                    aValue = a[orderBy] || "";
                    bValue = b[orderBy] || "";
            }
            if (aValue < bValue) return orderDirection === "asc" ? -1 : 1;
            if (aValue > bValue) return orderDirection === "asc" ? 1 : -1;
            return 0;
        });
        return filtered;
    }, [
        aircraft,
        completionStatus,
        searchTerm,
        orderBy,
        orderDirection
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            display: "flex",
            flexDirection: "column",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                fullWidth: true,
                variant: "outlined",
                size: "small",
                placeholder: "Search by make, model, or ID...",
                value: searchTerm,
                onChange: (e)=>setSearchTerm(e.target.value),
                sx: {
                    mb: 2
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                component: (0, $7Frhn.default),
                sx: {
                    flex: 1,
                    overflow: "auto"
                },
                ref: tableRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                    stickyHeader: true,
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                sx: {
                                    backgroundColor: (theme)=>theme.palette.grey[300],
                                    "& .MuiTableCell-head": {
                                        fontWeight: 600,
                                        fontSize: "0.875rem",
                                        lineHeight: 1.2,
                                        padding: "8px 16px",
                                        whiteSpace: "nowrap",
                                        backgroundColor: (theme)=>theme.palette.grey[300]
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be01c206ebbcc5af$export$2e2bcd8739ae039), {
                                            active: orderBy === "make",
                                            direction: orderBy === "make" ? orderDirection : "asc",
                                            onClick: ()=>handleRequestSort("make"),
                                            children: "Make"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be01c206ebbcc5af$export$2e2bcd8739ae039), {
                                            active: orderBy === "model",
                                            direction: orderBy === "model" ? orderDirection : "asc",
                                            onClick: ()=>handleRequestSort("model"),
                                            children: "Model"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be01c206ebbcc5af$export$2e2bcd8739ae039), {
                                            active: orderBy === "length",
                                            direction: orderBy === "length" ? orderDirection : "asc",
                                            onClick: ()=>handleRequestSort("length"),
                                            children: "Length"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be01c206ebbcc5af$export$2e2bcd8739ae039), {
                                            active: orderBy === "wingspan",
                                            direction: orderBy === "wingspan" ? orderDirection : "asc",
                                            onClick: ()=>handleRequestSort("wingspan"),
                                            children: "Wingspan"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be01c206ebbcc5af$export$2e2bcd8739ae039), {
                                            active: orderBy === "tail_height",
                                            direction: orderBy === "tail_height" ? orderDirection : "asc",
                                            onClick: ()=>handleRequestSort("tail_height"),
                                            children: "Tail Height"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be01c206ebbcc5af$export$2e2bcd8739ae039), {
                                            active: orderBy === "status",
                                            direction: orderBy === "status" ? orderDirection : "asc",
                                            onClick: ()=>handleRequestSort("status"),
                                            children: "Status"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                            children: filteredAndSortedAircraft.map((aircraft, index)=>{
                                const status = getStatus(aircraft);
                                const isSelected = selectedAircraft?.id === aircraft.id;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    hover: true,
                                    selected: isSelected,
                                    onClick: ()=>onSelectAircraft(aircraft, index),
                                    sx: {
                                        cursor: "pointer"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: aircraft.make || "-"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: aircraft.model || "-"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            align: "right",
                                            children: aircraft.length ? aircraft.length.toFixed(1) : "-"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            align: "right",
                                            children: aircraft.wingspan ? aircraft.wingspan.toFixed(1) : "-"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            align: "right",
                                            children: aircraft.tail_height ? aircraft.tail_height.toFixed(1) : "-"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                label: status === "deployed" ? "Deployed" : status === "locked" ? "Locked" : "Labeling",
                                                color: status === "deployed" ? "success" : status === "locked" ? "warning" : "error",
                                                size: "small",
                                                sx: {
                                                    minWidth: 80,
                                                    width: 80
                                                }
                                            })
                                        })
                                    ]
                                }, aircraft.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $7Frhn = parcelRequire("7Frhn");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $c3r8Q = parcelRequire("c3r8Q");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
const $1b100b66a5ae6ae7$export$f0ea934cb07b042a = (aircraftId)=>{
    if (!aircraftId) return "";
    // Always use the CDN URL for consistent image loading
    return `https://static.airplx.com/${aircraftId}.png`;
};


const $de95d3353f1a45f4$export$3839e74577f733c4 = ({ selectedAircraft: selectedAircraft, imageError: imageError, onImageError: onImageError, aircraftMap: aircraftMap })=>{
    const [localImageError, setLocalImageError] = $acw62.useState(false);
    const navigate = (0, $aphAM.useNavigate)();
    $acw62.useEffect(()=>{
        setLocalImageError(false);
    }, [
        selectedAircraft
    ]);
    if (!selectedAircraft) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
        sx: {
            width: "100%",
            p: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            color: "textSecondary",
            children: "Select an aircraft to preview"
        })
    });
    const hasError = imageError || localImageError;
    const imageUrl = (0, $1b100b66a5ae6ae7$export$f0ea934cb07b042a)(selectedAircraft.id);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
        sx: {
            width: "100%",
            p: 3,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: 2,
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            variant: "h6",
                            children: [
                                selectedAircraft.make,
                                " ",
                                selectedAircraft.model
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            size: "medium",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3r8Q))), {}),
                            onClick: ()=>navigate(`/labeling-tool/${selectedAircraft.id}`, {
                                    state: {
                                        from: '/super-admin',
                                        selectedAircraftId: selectedAircraft.id,
                                        activeTab: 10 // Aircraft tab index
                                    }
                                }),
                            sx: {
                                mr: 1
                            },
                            children: "Edit"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        flex: "1 1 60%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "grey.100",
                        borderRadius: 1,
                        position: "relative",
                        overflow: "hidden"
                    },
                    children: hasError ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        color: "textSecondary",
                        children: "No image available"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: imageUrl,
                        alt: `${selectedAircraft.make} ${selectedAircraft.model}`,
                        style: {
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain"
                        },
                        onError: ()=>{
                            setLocalImageError(true);
                            onImageError();
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        flex: "0 0 auto",
                        overflow: "auto"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "ID:"
                                    }),
                                    " ",
                                    selectedAircraft.id
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Length:"
                                    }),
                                    " ",
                                    selectedAircraft.length?.toFixed(1) || "-",
                                    " ft"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Wingspan:"
                                    }),
                                    " ",
                                    selectedAircraft.wingspan?.toFixed(1) || "-",
                                    " ft"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Tail Height:"
                                    }),
                                    " ",
                                    selectedAircraft.tail_height?.toFixed(1) || "-",
                                    " ft"
                                ]
                            }),
                            selectedAircraft.linked_to && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Linked To:"
                                    }),
                                    " ",
                                    aircraftMap[selectedAircraft.linked_to] || selectedAircraft.linked_to
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};


const $2e367a6eed987259$export$8f4262e2cbb7dc96 = ()=>{
    const { loading: loading, aircraft: aircraft, completionStatus: completionStatus, error: error } = (0, $3382779820f90fb0$export$3523f37fd7d0411b)();
    const location = (0, $aphAM.useLocation)();
    const [selectedAircraft, setSelectedAircraft] = (0, $acw62.useState)(null);
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(null);
    const [imageError, setImageError] = (0, $acw62.useState)(false);
    const tableRef = (0, $acw62.useRef)(null);
    const containerRef = (0, $acw62.useRef)(null);
    // Create a map of aircraft ID to make/model for linked aircraft display
    const aircraftMap = $acw62.useMemo(()=>{
        const map = {};
        aircraft.forEach((a)=>{
            map[a.id] = `${a.make} ${a.model}`;
        });
        return map;
    }, [
        aircraft
    ]);
    // Helper function to scroll to aircraft row
    const scrollToAircraft = (index)=>{
        setTimeout(()=>{
            if (tableRef.current) {
                const row = tableRef.current.querySelector(`tbody tr:nth-child(${index + 1})`);
                row?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        }, 100);
    };
    // Helper function to find and select aircraft by ID
    const selectAircraftById = (aircraftId)=>{
        const index = aircraft.findIndex((a)=>a.id === aircraftId);
        if (index !== -1) {
            setSelectedAircraft(aircraft[index]);
            setSelectedIndex(index);
            scrollToAircraft(index);
            return true;
        }
        return false;
    };
    // Helper function to select first aircraft
    const selectFirstAircraft = ()=>{
        if (aircraft.length > 0 && !selectedAircraft) {
            setSelectedAircraft(aircraft[0]);
            setSelectedIndex(0);
        }
    };
    // Focus container on mount
    (0, $acw62.useEffect)(()=>{
        containerRef.current?.focus();
    }, []);
    // Handle aircraft selection and restoration from navigation state
    (0, $acw62.useEffect)(()=>{
        if (!aircraft || aircraft.length === 0) return;
        // Try to restore from navigation state
        const state = location.state;
        const selectedId = state?.selectedAircraftId;
        if (selectedId && selectAircraftById(selectedId)) return;
        // Default to first aircraft
        selectFirstAircraft();
    }, [
        aircraft,
        location.state
    ]);
    // Helper function for keyboard navigation
    const handleArrowKeyNavigation = (direction)=>{
        if (!aircraft || aircraft.length === 0) return;
        let newIndex = selectedIndex ?? 0;
        if (direction === 'down') newIndex = Math.min(newIndex + 1, aircraft.length - 1);
        else newIndex = Math.max(newIndex - 1, 0);
        setSelectedIndex(newIndex);
        setSelectedAircraft(aircraft[newIndex]);
        setImageError(false);
        // Scroll into view
        if (tableRef.current) {
            const row = tableRef.current.querySelector(`tbody tr:nth-child(${newIndex + 1})`);
            row?.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
    };
    // Keyboard navigation
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            // Skip if typing in input
            const target = e.target;
            if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") return;
            if (e.key === "ArrowDown") {
                e.preventDefault();
                handleArrowKeyNavigation('down');
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                handleArrowKeyNavigation('up');
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        aircraft,
        selectedIndex
    ]);
    const handleSelectAircraft = (aircraft, index)=>{
        setSelectedAircraft(aircraft);
        setSelectedIndex(index);
        setImageError(false);
    };
    // Helper to get aircraft status
    const getAircraftStatus = (aircraft)=>{
        if (aircraft.linked_to) return 'Locked';
        if (completionStatus[aircraft.id]) return 'Deployed';
        return 'Labeling';
    };
    // Helper to prepare aircraft data for export
    const prepareAircraftExportData = ()=>{
        const headers = [
            "Make",
            "Model",
            "Length",
            "Wingspan",
            "Tail Height",
            "Status",
            "ID"
        ];
        const rows = aircraft.map((a)=>[
                a.make || "",
                a.model || "",
                a.length?.toFixed(1) || "",
                a.wingspan?.toFixed(1) || "",
                a.tail_height?.toFixed(1) || "",
                getAircraftStatus(a),
                a.id
            ]);
        return {
            headers: headers,
            rows: rows
        };
    };
    // Helper to download file
    const downloadFile = (content, filename, mimeType)=>{
        const blob = new Blob([
            content
        ], {
            type: mimeType
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const handleExportCSV = ()=>{
        const { headers: headers, rows: rows } = prepareAircraftExportData();
        // Convert to TSV format
        const tsvContent = [
            headers.join("\t"),
            ...rows.map((row)=>row.join("\t"))
        ].join("\n");
        const filename = `aircraft_list_${new Date().toISOString().split('T')[0]}.tsv`;
        downloadFile(tsvContent, filename, "text/tab-separated-values;charset=utf-8;");
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            children: "Loading aircraft data..."
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
            severity: "error",
            children: error
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        ref: containerRef,
        tabIndex: 0,
        sx: {
            p: 2,
            height: 'calc(100vh - 250px)',
            display: 'flex',
            flexDirection: 'column',
            outline: 'none'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: 3,
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h5",
                    children: "Aircraft Database"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: {
                        xs: 'column',
                        md: 'row'
                    },
                    spacing: 3,
                    sx: {
                        flex: 1,
                        minHeight: 0,
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                flex: 1,
                                minWidth: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                minHeight: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28e2bd07f97fd99d$export$1bbc69491da977be), {
                                    aircraft: aircraft,
                                    completionStatus: completionStatus,
                                    selectedAircraft: selectedAircraft,
                                    onSelectAircraft: handleSelectAircraft,
                                    tableRef: tableRef,
                                    aircraftMap: aircraftMap
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            sx: {
                                                px: 2,
                                                py: 1,
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                borderRadius: 1,
                                                backgroundColor: 'background.paper'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "body2",
                                                color: "black",
                                                children: [
                                                    "Aircraft Deployed: ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: Object.values(completionStatus).filter(Boolean).length
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "outlined",
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fruN))), {}),
                                            onClick: handleExportCSV,
                                            disabled: aircraft.length === 0,
                                            children: "Export Aircraft List"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                flex: 1,
                                minWidth: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                minHeight: 0
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de95d3353f1a45f4$export$3839e74577f733c4), {
                                selectedAircraft: selectedAircraft,
                                imageError: imageError,
                                onImageError: ()=>setImageError(true),
                                aircraftMap: aircraftMap
                            })
                        })
                    ]
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");


var $8qjhV = parcelRequire("8qjhV");


var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $gd5y7 = parcelRequire("gd5y7");
var $i32L9 = parcelRequire("i32L9");
var $djhCy = parcelRequire("djhCy");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $eJ0JC = parcelRequire("eJ0JC");
var $9ZYXn = parcelRequire("9ZYXn");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $acw62 = parcelRequire("acw62");


var $2LXej = parcelRequire("2LXej");
const $797d47240b10fce7$export$c6758002b7139c = (iframeHtml)=>{
    if (!iframeHtml.trim()) return false;
    // Check for reasonable length to prevent DoS
    if (iframeHtml.length > 10000) return false;
    // Parse the HTML to check if it's a valid iframe
    const parser = new DOMParser();
    const doc = parser.parseFromString(iframeHtml, "text/html");
    // Check for parsing errors
    const errorNode = doc.querySelector("parsererror");
    if (errorNode) return false;
    // Get the iframe element
    const iframe = doc.querySelector("iframe");
    if (!iframe) return false;
    // Check for dangerous attributes that shouldn't be present
    const dangerousAttrs = [
        "onload",
        "onerror",
        "onmessage",
        "srcdoc"
    ];
    for (const attr of dangerousAttrs){
        if (iframe.hasAttribute(attr)) return false;
    }
    // Check that it has a src attribute with a YouTube embed URL
    const src = iframe.getAttribute("src");
    if (!src) return false;
    // Validate that the src is a YouTube embed URL with stricter pattern
    const youtubeEmbedPattern = /^https:\/\/(www\.)?youtube\.com\/embed\/[\w-]+(\?[\w=&%-]*)?$/;
    return youtubeEmbedPattern.test(src);
};



var $3Tv1e = parcelRequire("3Tv1e");



// Lazy load date picker field wrapper
const $c49efcbeaf14fdff$var$DatePickerField = /*#__PURE__*/ $acw62.lazy(()=>Promise.all([
        Promise.resolve((parcelRequire("dNxct"))),
        Promise.resolve((parcelRequire("uaXRK"))),
        Promise.resolve((parcelRequire("78ow6")))
    ]).then(([dateTimePicker, localizationProvider, adapterDateFns])=>({
            default: ({ label: label, value: value, onChange: onChange, error: error, helperText: helperText })=>/*#__PURE__*/ (0, $ayMG0.jsx)(localizationProvider.LocalizationProvider, {
                    dateAdapter: adapterDateFns.AdapterDateFns,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(dateTimePicker.DateTimePicker, {
                        label: label,
                        value: value,
                        onChange: onChange,
                        slotProps: {
                            textField: {
                                error: error,
                                helperText: helperText,
                                fullWidth: true
                            }
                        }
                    })
                })
        })));
const $c49efcbeaf14fdff$var$initialFormData = {
    title: "",
    body: "",
    media_type: "none",
    video_url: "",
    image_url: "",
    action_link: "",
    action_link_text: "",
    expiration_date: null
};
const $c49efcbeaf14fdff$export$e0c30b5422904bf8 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [announcements, setAnnouncements] = $acw62.useState([]);
    const [loading, setLoading] = $acw62.useState(true);
    const [open, setOpen] = $acw62.useState(false);
    const [editingId, setEditingId] = $acw62.useState(null);
    const [formData, setFormData] = $acw62.useState($c49efcbeaf14fdff$var$initialFormData);
    const [errors, setErrors] = $acw62.useState({});
    const [previewAnnouncement, setPreviewAnnouncement] = $acw62.useState(null);
    const [imagePreview, setImagePreview] = $acw62.useState(null);
    const [uploading, setUploading] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        fetchAnnouncements();
    }, []);
    const fetchAnnouncements = async ()=>{
        try {
            setLoading(true);
            const { data: data, error: error } = await postgrest.from("announcements").select("*").order("created_at", {
                ascending: false
            });
            if (error) throw error;
            // Add is_active computed field
            const announcementsWithStatus = (data || []).map((announcement)=>({
                    ...announcement,
                    is_active: new Date(announcement.expiration_date) > new Date()
                }));
            setAnnouncements(announcementsWithStatus);
        } catch (error) {
            console.error("Failed to fetch announcements:", error);
        } finally{
            setLoading(false);
        }
    };
    const validateForm = ()=>{
        const newErrors = {};
        if (!formData.title.trim()) newErrors.title = "Title is required";
        if (!formData.body.trim()) newErrors.body = "Body is required";
        if (!formData.expiration_date) newErrors.expiration_date = "Expiration date is required";
        // Validate media based on type
        if (formData.media_type === "video" && formData.video_url && !(0, $797d47240b10fce7$export$c6758002b7139c)(formData.video_url)) newErrors.video_url = "Please enter a valid YouTube iframe embed code";
        if (formData.media_type === "video" && !formData.video_url.trim()) newErrors.video_url = "Video URL is required when video is selected";
        if (formData.media_type === "image" && !formData.image_url) newErrors.image_url = "Please upload an image";
        // Validate action link URL format if provided
        if (formData.action_link && formData.action_link.trim()) try {
            new URL(formData.action_link);
        } catch  {
            newErrors.action_link = "Please enter a valid URL (e.g., https://example.com)";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async ()=>{
        if (!validateForm()) return;
        try {
            setUploading(true);
            const announcementData = {
                title: formData.title,
                body: formData.body,
                video_url: formData.media_type === "video" ? formData.video_url : null,
                image_url: formData.media_type === "image" ? formData.image_url : null,
                action_link: formData.action_link || null,
                action_link_text: formData.action_link_text || null,
                expiration_date: formData.expiration_date?.toISOString()
            };
            if (editingId) {
                const { error: error } = await postgrest.from("announcements").update(announcementData).eq("id", editingId);
                if (error) throw error;
            } else {
                const { error: error } = await postgrest.from("announcements").insert(announcementData);
                if (error) throw error;
            }
            handleClose();
            fetchAnnouncements();
        } catch (error) {
            console.error("Failed to save announcement:", error);
            alert("Failed to save announcement. Please try again.");
        } finally{
            setUploading(false);
        }
    };
    const handleEdit = (announcement)=>{
        // Determine media type based on what's present
        let mediaType = "none";
        if (announcement.video_url) mediaType = "video";
        else if (announcement.image_url) mediaType = "image";
        setFormData({
            title: announcement.title,
            body: announcement.body,
            media_type: mediaType,
            video_url: announcement.video_url || "",
            image_url: announcement.image_url || "",
            action_link: announcement.action_link || "",
            action_link_text: announcement.action_link_text || "",
            expiration_date: new Date(announcement.expiration_date)
        });
        // Set image preview if editing announcement with image
        if (announcement.image_url) setImagePreview(announcement.image_url);
        else setImagePreview(null);
        setEditingId(announcement.id);
        setOpen(true);
    };
    const handleDelete = async (id)=>{
        if (!window.confirm("Are you sure you want to delete this announcement?")) return;
        try {
            const { error: error } = await postgrest.from("announcements").delete().eq("id", id);
            if (error) throw error;
            fetchAnnouncements();
        } catch (error) {
            console.error("Failed to delete announcement:", error);
        }
    };
    const handleClose = ()=>{
        setOpen(false);
        setEditingId(null);
        setFormData($c49efcbeaf14fdff$var$initialFormData);
        setErrors({});
        setImagePreview(null);
    };
    const handleImageUpload = (base64Image)=>{
        setFormData({
            ...formData,
            image_url: base64Image
        });
        setImagePreview(base64Image);
        // Clear any previous errors
        const newErrors = {
            ...errors
        };
        delete newErrors.image_url;
        setErrors(newErrors);
    };
    const handlePreview = (announcement)=>{
        setPreviewAnnouncement(announcement);
    };
    const columns = [
        {
            field: "title",
            headerName: "Title",
            flex: 1,
            minWidth: 150,
            headerAlign: "left",
            align: "left"
        },
        {
            field: "body",
            headerName: "Body",
            flex: 2,
            minWidth: 250,
            headerAlign: "left",
            align: "left",
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    sx: {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    },
                    children: params.value
                })
        },
        {
            field: "media",
            headerName: "Media",
            width: 100,
            headerAlign: "center",
            align: "center",
            renderCell: (params)=>{
                if (params.row.video_url) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1892dbb6dceffbba$exports))), {
                    color: "primary",
                    titleAccess: "Video"
                });
                else if (params.row.image_url) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d812595be82c5518$exports))), {
                    color: "primary",
                    titleAccess: "Image"
                });
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "caption",
                    color: "text.secondary",
                    children: "None"
                });
            }
        },
        {
            field: "has_link",
            headerName: "Link",
            width: 80,
            headerAlign: "center",
            align: "center",
            renderCell: (params)=>{
                if (params.row.action_link) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8qjhV))), {
                    color: "primary",
                    titleAccess: params.row.action_link
                });
                return null;
            }
        },
        {
            field: "is_active",
            headerName: "Status",
            width: 120,
            headerAlign: "center",
            align: "center",
            renderCell: (params)=>{
                const expirationDate = new Date(params.row.expiration_date);
                const now = new Date();
                const isActive = expirationDate > now;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                    label: isActive ? "Active" : "Expired",
                    color: isActive ? "success" : "default",
                    size: "small"
                });
            }
        },
        {
            field: "expiration_date",
            headerName: "Expires",
            width: 180,
            headerAlign: "left",
            align: "left",
            renderCell: (params)=>new Date(params.value).toLocaleString()
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 280,
            sortable: false,
            headerAlign: "center",
            align: "center",
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            size: "small",
                            onClick: ()=>handlePreview(params.row),
                            children: "Preview"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            size: "small",
                            onClick: ()=>handleEdit(params.row),
                            children: "Edit"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            size: "small",
                            color: "error",
                            onClick: ()=>handleDelete(params.row.id),
                            children: "Delete"
                        })
                    ]
                })
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            height: "100%",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                            onClick: ()=>setOpen(true),
                            children: "Add Announcement"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            height: 600
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                            rows: announcements,
                            columns: columns,
                            loading: loading,
                            disableRowSelectionOnClick: true,
                            pageSizeOptions: [
                                10,
                                25,
                                50
                            ],
                            initialState: {
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            },
                            sx: {
                                "& .MuiDataGrid-cell": {
                                    display: "flex",
                                    alignItems: "center"
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: handleClose,
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: editingId ? "Edit Announcement" : "New Announcement"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 3,
                            sx: {
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Title",
                                    value: formData.title,
                                    onChange: (e)=>setFormData({
                                            ...formData,
                                            title: e.target.value
                                        }),
                                    error: !!errors.title,
                                    helperText: errors.title,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Body",
                                    value: formData.body,
                                    onChange: (e)=>setFormData({
                                            ...formData,
                                            body: e.target.value
                                        }),
                                    error: !!errors.body,
                                    helperText: errors.body,
                                    multiline: true,
                                    rows: 6,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $djhCy.default), {
                                            children: "Media Type"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ZYXn.default), {
                                            value: formData.media_type,
                                            exclusive: true,
                                            onChange: (_, value)=>{
                                                if (value !== null) {
                                                    setFormData({
                                                        ...formData,
                                                        media_type: value,
                                                        // Clear opposite media when switching
                                                        video_url: value === "video" ? formData.video_url : "",
                                                        image_url: value === "image" ? formData.image_url : ""
                                                    });
                                                    if (value !== "image") setImagePreview(null);
                                                }
                                            },
                                            fullWidth: true,
                                            sx: {
                                                mt: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJ0JC.default), {
                                                    value: "none",
                                                    children: "None"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJ0JC.default), {
                                                    value: "video",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1892dbb6dceffbba$exports))), {
                                                            sx: {
                                                                mr: 1
                                                            }
                                                        }),
                                                        "Video"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJ0JC.default), {
                                                    value: "image",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d812595be82c5518$exports))), {
                                                            sx: {
                                                                mr: 1
                                                            }
                                                        }),
                                                        "Image"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                formData.media_type === "video" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "YouTube Embed Code",
                                    value: formData.video_url,
                                    onChange: (e)=>setFormData({
                                            ...formData,
                                            video_url: e.target.value
                                        }),
                                    error: !!errors.video_url,
                                    helperText: errors.video_url || "Paste the iframe embed code from YouTube",
                                    multiline: true,
                                    rows: 3,
                                    fullWidth: true
                                }),
                                formData.media_type === "image" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        !imagePreview ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Tv1e.ButtonUploadImage), {
                                            label: "Upload Image",
                                            onLoad: handleImageUpload
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                    sx: {
                                                        textAlign: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: imagePreview,
                                                        alt: "Preview",
                                                        style: {
                                                            maxWidth: "100%",
                                                            maxHeight: "300px",
                                                            objectFit: "contain"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Tv1e.ButtonUploadImage), {
                                                    label: "Change Image",
                                                    onLoad: handleImageUpload
                                                })
                                            ]
                                        }),
                                        errors.image_url && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                                            error: true,
                                            children: errors.image_url
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Action Link (optional)",
                                    value: formData.action_link,
                                    onChange: (e)=>setFormData({
                                            ...formData,
                                            action_link: e.target.value
                                        }),
                                    error: !!errors.action_link,
                                    helperText: errors.action_link || "Enter a URL to add a clickable link to the announcement",
                                    placeholder: "https://example.com",
                                    fullWidth: true
                                }),
                                formData.action_link && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Link Button Text (optional)",
                                    value: formData.action_link_text,
                                    onChange: (e)=>setFormData({
                                            ...formData,
                                            action_link_text: e.target.value
                                        }),
                                    helperText: "Default: 'Learn More'",
                                    placeholder: "Learn More",
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center",
                                            p: 2
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {})
                                    }),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($c49efcbeaf14fdff$var$DatePickerField, {
                                        label: "Expiration Date",
                                        value: formData.expiration_date,
                                        onChange: (newValue)=>setFormData({
                                                ...formData,
                                                expiration_date: newValue
                                            }),
                                        error: !!errors.expiration_date,
                                        helperText: errors.expiration_date
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleClose,
                                disabled: uploading,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleSubmit,
                                variant: "contained",
                                disabled: uploading,
                                startIcon: uploading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 20
                                }) : null,
                                children: uploading ? "Uploading..." : editingId ? "Update" : "Create"
                            })
                        ]
                    })
                ]
            }),
            previewAnnouncement && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: !!previewAnnouncement,
                onClose: ()=>setPreviewAnnouncement(null),
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: previewAnnouncement.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    children: previewAnnouncement.body
                                }),
                                previewAnnouncement.action_link && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    href: previewAnnouncement.action_link,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    fullWidth: true,
                                    sx: {
                                        backgroundColor: "#1976d2",
                                        "&:hover": {
                                            backgroundColor: "#1565c0"
                                        },
                                        animation: "pulse 2s ease-in-out infinite",
                                        "@keyframes pulse": {
                                            "0%, 100%": {
                                                transform: "scale(1)",
                                                boxShadow: "0 0 0 0 rgba(25, 118, 210, 0.7)"
                                            },
                                            "50%": {
                                                transform: "scale(1.02)",
                                                boxShadow: "0 0 20px 0 rgba(25, 118, 210, 0.4)"
                                            }
                                        }
                                    },
                                    children: previewAnnouncement.action_link_text || "Learn More"
                                }),
                                previewAnnouncement.video_url && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0dd289201de31a3a$export$2e2bcd8739ae039), {
                                    iframeHtml: previewAnnouncement.video_url
                                }),
                                previewAnnouncement.image_url && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        my: 1
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: previewAnnouncement.image_url,
                                        alt: previewAnnouncement.title,
                                        style: {
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain",
                                            borderRadius: "8px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: [
                                        "Expires:",
                                        " ",
                                        new Date(previewAnnouncement.expiration_date).toLocaleString()
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>setPreviewAnnouncement(null),
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $fZSPM = parcelRequire("fZSPM");

var $dqlTG = parcelRequire("dqlTG");

var $1MdOk = parcelRequire("1MdOk");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $19ocJ = parcelRequire("19ocJ");
var $7djgP = parcelRequire("7djgP");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $lNEp2 = parcelRequire("lNEp2");
const $0bfdb14bee91b161$export$f17f1ad215aeafd0 = ()=>{
    const [testEmail, setTestEmail] = $acw62.useState("");
    const [testResult, setTestResult] = $acw62.useState();
    const [emailOrDomain, setEmailOrDomain] = $acw62.useState("");
    const [authorizedAccounts, setAuthorizedAccounts] = $acw62.useState([]);
    // Password whitelist state
    const [whitelistEmail, setWhitelistEmail] = $acw62.useState("");
    const [whitelistTestEmail, setWhitelistTestEmail] = $acw62.useState("");
    const [whitelistTestResult, setWhitelistTestResult] = $acw62.useState();
    const [passwordWhitelist, setPasswordWhitelist] = $acw62.useState([]);
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const fetchAuthorizedAccounts = async ()=>{
        const result = await postgrest.from("authorized_account").select("*");
        return result.data;
    };
    const fetchPasswordWhitelist = async ()=>{
        const result = await postgrest.from("password_auth_whitelist").select("*").order("created_at", {
            ascending: false
        });
        return result.data;
    };
    $acw62.useEffect(()=>{
        fetchAuthorizedAccounts().then(setAuthorizedAccounts);
        fetchPasswordWhitelist().then(setPasswordWhitelist);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 1,
        sx: {
            width: 400
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
                subheader: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7djgP.default), {
                            component: "div",
                            id: "nested-list-subheader",
                            children: "Valid Emails/Domains"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        maxHeight: 500,
                        overflow: "auto",
                        ...(0, $lNEp2.scrollSx)
                    },
                    children: authorizedAccounts.map((authorizedAccount)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                            secondaryAction: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                onClick: async ()=>{
                                    await postgrest.from("authorized_account").delete().eq("email_or_domain", authorizedAccount.email_or_domain);
                                    fetchAuthorizedAccounts().then(setAuthorizedAccounts);
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {})
                            }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                primary: authorizedAccount.email_or_domain
                            })
                        }, authorizedAccount.email_or_domain))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        fullWidth: true,
                        placeholder: "New Email/Domain",
                        size: "small",
                        onChange: (e)=>setEmailOrDomain(e.target.value),
                        value: emailOrDomain
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        size: "small",
                        onClick: async ()=>{
                            // don't let someone input a very liberal regex
                            if (emailOrDomain.length < 3) return;
                            await postgrest.from("authorized_account").insert({
                                email_or_domain: emailOrDomain
                            });
                            fetchAuthorizedAccounts().then(setAuthorizedAccounts);
                            setEmailOrDomain("");
                        },
                        children: "Add"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                fullWidth: true,
                                size: "small",
                                placeholder: "Email to test",
                                onChange: (e)=>{
                                    setTestResult(null);
                                    setTestEmail(e.target.value);
                                },
                                value: testEmail
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                size: "small",
                                onClick: async ()=>{
                                    setTestResult(null);
                                    const result = await postgrest.rpc("is_authorized", {
                                        email: testEmail
                                    });
                                    setTestResult(result.data);
                                },
                                children: "Test"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        children: [
                            testResult === true && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fZSPM))), {
                                sx: {
                                    color: "green"
                                }
                            }),
                            testResult === false && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                                sx: {
                                    color: "red"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                children: [
                                    testResult === true && "Passed. This email will be allowed access.",
                                    testResult === false && "Failed. This email will not be allowed access."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                sx: {
                    width: 400,
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
                        subheader: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7djgP.default), {
                                    component: "div",
                                    id: "password-whitelist-subheader",
                                    children: "Password Authentication Whitelist"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {})
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                maxHeight: 500,
                                overflow: "auto",
                                ...(0, $lNEp2.scrollSx)
                            },
                            children: passwordWhitelist.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                                    secondaryAction: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        onClick: async ()=>{
                                            await postgrest.from("password_auth_whitelist").delete().eq("email", item.email);
                                            fetchPasswordWhitelist().then(setPasswordWhitelist);
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {})
                                    }),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                        primary: item.email,
                                        secondary: item.reason
                                    })
                                }, item.email))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                fullWidth: true,
                                placeholder: "New Email",
                                size: "small",
                                onChange: (e)=>setWhitelistEmail(e.target.value),
                                value: whitelistEmail
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                size: "small",
                                onClick: async ()=>{
                                    if (whitelistEmail.length < 3) return;
                                    await postgrest.from("password_auth_whitelist").insert({
                                        email: whitelistEmail,
                                        reason: "Added via admin UI"
                                    });
                                    fetchPasswordWhitelist().then(setPasswordWhitelist);
                                    setWhitelistEmail("");
                                },
                                children: "Add"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        fullWidth: true,
                                        size: "small",
                                        placeholder: "Email to test",
                                        onChange: (e)=>{
                                            setWhitelistTestResult(null);
                                            setWhitelistTestEmail(e.target.value);
                                        },
                                        value: whitelistTestEmail
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "contained",
                                        size: "small",
                                        onClick: async ()=>{
                                            setWhitelistTestResult(null);
                                            const result = await postgrest.rpc("is_password_auth_whitelisted", {
                                                p_email: whitelistTestEmail
                                            });
                                            setWhitelistTestResult(result.data);
                                        },
                                        children: "Test"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    whitelistTestResult === true && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fZSPM))), {
                                        sx: {
                                            color: "green"
                                        }
                                    }),
                                    whitelistTestResult === false && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                                        sx: {
                                            color: "red"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        children: [
                                            whitelistTestResult === true && "Passed. This email can use password authentication.",
                                            whitelistTestResult === false && "Failed. This email must use Microsoft/Google login."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
const $6efbb3e7879ab111$export$2ecffa85439d004b = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        p: 4,
        justifyContent: "center",
        alignItems: "center",
        width: 400,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h5",
                children: "Enter the dojo \uD83E\uDD77"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                component: (0, $lzNIT.Link),
                to: "/labeling-tool",
                size: "large",
                color: "success",
                variant: "contained",
                children: "Let's Start Labeling \uD83D\uDE80"
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $2KvQo = parcelRequire("2KvQo");

var $ipR47 = parcelRequire("ipR47");

var $cFBau = parcelRequire("cFBau");
var $fagfG = parcelRequire("fagfG");
var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $2esSG = parcelRequire("2esSG");
var $9Lykx = parcelRequire("9Lykx");
var $1lfQl = parcelRequire("1lfQl");
var $30UGG = parcelRequire("30UGG");
var $7s24a = parcelRequire("7s24a");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $6fDLr = parcelRequire("6fDLr");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");
/**
 * Confidence thresholds for hybrid CSV + fuzzy approach:
 * - High (0-20): CSV verified matches and strong fuzzy matches (exact, prefix)
 * - Medium (21-50): Good fuzzy matches (word boundary, substring, multi-token)
 * - Low/No suggestion (51+): Weak fuzzy matches, not shown
 */ const $0b7d8c3925d2de62$var$CONFIDENCE_THRESHOLDS = {
    HIGH: 20,
    MEDIUM: 50
};
/**
 * Get the confidence level for a given score.
 */ const $0b7d8c3925d2de62$var$getConfidenceLevel = (score)=>{
    if (score <= $0b7d8c3925d2de62$var$CONFIDENCE_THRESHOLDS.HIGH) return "high";
    if (score <= $0b7d8c3925d2de62$var$CONFIDENCE_THRESHOLDS.MEDIUM) return "medium";
    return null;
};
/**
 * Generate human-readable reason for why an alternative match is shown.
 */ const $0b7d8c3925d2de62$var$getAlternativeReason = (breakdown)=>{
    if (breakdown.method === "historical") return "Previously mapped similar FAA string";
    if (breakdown.manufacturerScore >= 0.9 && breakdown.modelScore < 5) return "Same manufacturer, similar model";
    if (breakdown.manufacturerScore >= 0.9) return "Same manufacturer";
    if (breakdown.modelScore < 10) return "Similar model number";
    return "Fuzzy match";
};
const $0b7d8c3925d2de62$export$15c516ff8a9e5edc = (faaManufacturer, faaModel, allAircraft, csvMatcher)=>{
    // STAGE 0: Try CSV exact match first (highest confidence, verified data)
    if (csvMatcher && faaManufacturer && faaModel) {
        const csvMatch = csvMatcher.suggestMatch(faaManufacturer, faaModel);
        if (csvMatch) {
            // Find the aircraft in allAircraft list
            const aircraft = allAircraft.find((a)=>a.make === csvMatch.airplx_make && a.model === csvMatch.airplx_model);
            if (aircraft) {
                // CRITICAL VALIDATION: Even for CSV matches, verify model numbers actually match
                // This prevents bad database data like "AT-802A" → "AT-502" from being trusted
                const modelSimilarity = $0b7d8c3925d2de62$var$compareModels(faaModel, aircraft.model);
                // Require very high similarity (0.9+) even for CSV matches
                // AT-802A (802) vs AT-502 (502) will score 0.0, failing this check
                if (modelSimilarity >= 0.9) return {
                    suggestedAircraft: aircraft,
                    score: 0,
                    confidence: "high",
                    breakdown: {
                        manufacturerScore: 1.0,
                        modelScore: 1.0,
                        historicalScore: 0,
                        matchedHistoricalString: `${faaManufacturer} / ${faaModel}`,
                        manufacturerPenalty: 0,
                        method: "csv-verified"
                    }
                };
            // If model validation fails, fall through to fuzzy matching
            // (don't trust the bad CSV data)
            }
        }
    }
    // No CSV match - fall back to fuzzy matching algorithm
    // Build search string from FAA data
    const searchParts = [];
    if (faaManufacturer) searchParts.push(faaManufacturer.trim());
    if (faaModel) searchParts.push(faaModel.trim());
    const searchString = searchParts.join(" ");
    // No search string means no suggestion
    if (!searchString) return {
        suggestedAircraft: null,
        score: Infinity,
        confidence: null
    };
    // STAGE 1: Filter aircraft by manufacturer to reduce search space
    // This prevents cross-manufacturer matches (e.g., Eurocopter → ERCO)
    const candidatesByManufacturer = $0b7d8c3925d2de62$var$filterByManufacturer(faaManufacturer, allAircraft);
    // STAGE 2: Score models within filtered manufacturer list
    // Use only the model portion for scoring since manufacturer is already filtered
    const modelOnlySearchString = faaModel ? faaModel.trim() : searchString;
    const scoredAircraft = [];
    for (const aircraft of candidatesByManufacturer){
        // Calculate manufacturer match quality (0.0-1.0, higher is better)
        const manufacturerScore = $0b7d8c3925d2de62$var$matchManufacturer(faaManufacturer || "", aircraft.make || "");
        // Calculate traditional score (comparing model only, manufacturer already filtered)
        const traditionalScore = $0b7d8c3925d2de62$var$calculateScore(aircraft, modelOnlySearchString);
        // Calculate historical score (comparing to previously-mapped FAA strings)
        const historicalResult = $0b7d8c3925d2de62$var$calculateHistoricalScore(aircraft, faaManufacturer, faaModel);
        let historicalScore = historicalResult.score;
        const matchedHistoricalString = historicalResult.matchedString;
        // CRITICAL: Verify the FAA model also matches the AIRCRAFT model
        // This prevents historical "305B" → aircraft "337" nonsense
        // Check specifically that the core NUMBERS match (not just overall similarity)
        if (historicalScore < Infinity && faaModel && aircraft.model) {
            // Extract numeric cores from both models
            const faaComponents = $0b7d8c3925d2de62$var$extractComponents($0b7d8c3925d2de62$var$normalizeModel(faaModel));
            const aircraftComponents = $0b7d8c3925d2de62$var$extractComponents($0b7d8c3925d2de62$var$normalizeModel(aircraft.model));
            // Check if the core numbers match (the critical part)
            const numbersMatch = $0b7d8c3925d2de62$var$compareNumberArrays(faaComponents.numbers, aircraftComponents.numbers);
            // Require core numbers to match (1.0 = perfect match, 0.5 = subset match)
            // This allows "DHC-2 MK. I" to match "DHC-2 Beaver" (same numbers)
            // but prevents "305B" from matching "337" (different numbers)
            if (numbersMatch < 0.5) historicalScore = Infinity;
        }
        // Use the best (lowest) score from both methods
        let baseScore = Math.min(traditionalScore, historicalScore);
        const method = historicalScore < traditionalScore ? "historical" : traditionalScore < historicalScore ? "traditional" : "combined";
        // Adjust score based on manufacturer match quality
        // Better manufacturer match = lower (better) final score
        // Convert manufacturer score (0.0-1.0) to penalty (0-5)
        const manufacturerPenalty = (1.0 - manufacturerScore) * 5;
        const finalScore = baseScore + manufacturerPenalty;
        // QUALITY GATE: For fuzzy matches (non-CSV), require reasonable match quality
        // This prevents weak matches from being suggested
        // Only apply quality gate for scores > 25 (weaker matches)
        const isFuzzyMatch = baseScore > 0; // CSV has score 0, fuzzy has score > 0
        let passesQualityGate = true;
        if (isFuzzyMatch && baseScore > 25) {
            // Calculate model similarity for quality check
            const modelSimilarity = faaModel && aircraft.model ? $0b7d8c3925d2de62$var$compareModels(faaModel, aircraft.model) : 0.0;
            // Quality gate rules for weaker matches (score > 25):
            // 1. If manufacturer provided: require manufacturer ≥ 0.6
            // 2. If model provided: require model ≥ 0.6
            // 3. If manufacturer is null: only check model similarity
            const manufacturerOk = !faaManufacturer || manufacturerScore >= 0.6;
            const modelOk = !faaModel || modelSimilarity >= 0.6;
            if (!manufacturerOk || !modelOk) passesQualityGate = false;
        }
        if (finalScore !== Infinity && passesQualityGate) scoredAircraft.push({
            aircraft: aircraft,
            score: finalScore,
            breakdown: {
                manufacturerScore: manufacturerScore,
                modelScore: traditionalScore,
                historicalScore: historicalScore,
                matchedHistoricalString: matchedHistoricalString,
                manufacturerPenalty: manufacturerPenalty,
                method: method
            }
        });
    }
    // If no matches found, return null suggestion
    if (scoredAircraft.length === 0) return {
        suggestedAircraft: null,
        score: Infinity,
        confidence: null
    };
    // Sort by score (ascending - lower is better)
    scoredAircraft.sort((a, b)=>a.score - b.score);
    // Get the best match
    const bestMatch = scoredAircraft[0];
    const confidence = $0b7d8c3925d2de62$var$getConfidenceLevel(bestMatch.score);
    // Only return suggestion if confidence is high or medium
    if (confidence === null) return {
        suggestedAircraft: null,
        score: bestMatch.score,
        confidence: null,
        breakdown: bestMatch.breakdown
    };
    // Collect alternative matches (top 2-3 after the best match)
    const alternatives = scoredAircraft.slice(1, 4) // Next 3 matches
    .filter((m)=>$0b7d8c3925d2de62$var$getConfidenceLevel(m.score) !== null) // Only show decent matches
    .map((match)=>({
            aircraft: match.aircraft,
            score: match.score,
            confidence: $0b7d8c3925d2de62$var$getConfidenceLevel(match.score) || "medium",
            reason: $0b7d8c3925d2de62$var$getAlternativeReason(match.breakdown)
        }));
    return {
        suggestedAircraft: bestMatch.aircraft,
        score: bestMatch.score,
        confidence: confidence,
        breakdown: bestMatch.breakdown,
        alternatives: alternatives.length > 0 ? alternatives : undefined
    };
};
/**
 * Calculate score for a single aircraft against search string.
 * This mirrors the logic in aircraftFilterUtils.ts scoreAircraft function.
 */ const $0b7d8c3925d2de62$var$calculateScore = (aircraft, searchString)=>{
    const make = aircraft.make || "";
    const model = aircraft.model || "";
    const fullName = `${make} ${model}`;
    const input = searchString.toLowerCase().trim();
    const inputTokens = input.split(/\s+/).filter((t)=>t.length > 0);
    if (inputTokens.length === 0) return Infinity;
    // Score each token independently
    const tokenScores = inputTokens.map((token)=>{
        const makeScore = $0b7d8c3925d2de62$var$scoreToken(token, make, true);
        const modelScore = $0b7d8c3925d2de62$var$scoreToken(token, model, false);
        const fullNameScore = $0b7d8c3925d2de62$var$scoreToken(token, fullName, false);
        return Math.min(makeScore, modelScore, fullNameScore);
    });
    // Sum all token scores
    const totalScore = tokenScores.reduce((sum, score)=>sum + score, 0);
    return totalScore;
};
/**
 * Check if a token contains any numeric characters.
 * Numeric tokens require exact matching (no fuzzy matching).
 */ const $0b7d8c3925d2de62$var$isNumericToken = (token)=>{
    return /\d/.test(token);
};
/**
 * Score a single token against a target string.
 * Mirrors the logic from aircraftFilterUtils.ts scoreToken function.
 *
 * IMPORTANT: Tokens containing numbers (e.g., "222", "PA-34", "A320") require
 * EXACT matching only. No fuzzy/substring matching for numeric tokens to prevent
 * matching "222" with "212" or "PA-34-220T" with "PA-34-200T".
 */ const $0b7d8c3925d2de62$var$scoreToken = (token, target, isMakeField)=>{
    const lowerTarget = target.toLowerCase();
    const lowerToken = token.toLowerCase();
    // STRICT NUMERIC MATCHING: If token contains numbers,
    // only allow exact match, prefix match, or word boundary match
    // (no substring/fuzzy matching to prevent "222" matching "212")
    // Note: We only check the token, not the target, to allow text tokens
    // like "Cherokee" to fuzzy match against "PA-28-140 Cherokee Cruiser"
    const hasNumbers = $0b7d8c3925d2de62$var$isNumericToken(token);
    // Exact match
    if (lowerTarget === lowerToken) return isMakeField ? 0 : 1;
    // Prefix match (allowed for numeric tokens)
    if (lowerTarget.startsWith(lowerToken)) return isMakeField ? 10 : 11;
    // Word boundary match (allowed for numeric tokens like "58" in "Baron 58")
    const escapedToken = lowerToken.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const wordBoundaryRegex = new RegExp(`\\b${escapedToken}\\b`, "i");
    if (wordBoundaryRegex.test(lowerTarget)) {
        const matchIndex = lowerTarget.search(wordBoundaryRegex);
        const score = isMakeField ? 20 + matchIndex : 21 + matchIndex;
        // For numeric tokens, return this score - no further fuzzy matching
        if (hasNumbers) return score;
        // For non-numeric, continue to allow better matches below
        return score;
    }
    // For numeric tokens, STOP HERE - no substring/fuzzy matching allowed
    if (hasNumbers) return Infinity;
    // Substring match (only for non-numeric tokens)
    const substringIndex = lowerTarget.indexOf(lowerToken);
    if (substringIndex !== -1) return isMakeField ? 30 + substringIndex : 31 + substringIndex;
    // Fuzzy match (Levenshtein distance) - only for tokens of 4+ characters
    if (lowerToken.length >= 4) {
        const distance = $0b7d8c3925d2de62$var$levenshtein(lowerToken, lowerTarget);
        const threshold = lowerToken.length <= 5 ? 2 : 4;
        if (distance <= threshold) return isMakeField ? 40 + distance : 41 + distance;
    }
    // No match
    return Infinity;
};
/**
 * Calculate Levenshtein distance between two strings.
 * Copied from hooks/utils.ts to avoid circular dependencies.
 */ const $0b7d8c3925d2de62$var$levenshtein = (a, b)=>{
    const an = a.length;
    const bn = b.length;
    const matrix = [];
    if (an === 0) return bn;
    if (bn === 0) return an;
    for(let i = 0; i <= bn; i++)matrix[i] = [
        i
    ];
    for(let j = 0; j <= an; j++)matrix[0][j] = j;
    for(let i = 1; i <= bn; i++){
        for(let j = 1; j <= an; j++)if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
        else matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1);
    }
    return matrix[bn][an];
};
/**
 * Corporate suffixes to strip during normalization
 */ const $0b7d8c3925d2de62$var$CORPORATE_SUFFIXES = [
    "INC",
    "CORP",
    "LLC",
    "CO",
    "LTD",
    "S A S",
    "ACFT OF CANADA LTD",
    "AIRCRAFT",
    "AVIATION",
    "INDUSTRIES",
    "INDUSTRIE",
    "FLUGZEUGWERKE",
    // German aircraft works
    "SPA",
    // Italian company suffix
    "AG" // German company suffix
];
/**
 * Manufacturer alias map - maps normalized manufacturer names to their common variations.
 * This allows "CESSNA AIRCRAFT CO" to match "Cessna", "Reims/cessna" to match "Cessna", etc.
 */ const $0b7d8c3925d2de62$var$MANUFACTURER_ALIASES = {
    cessna: [
        "cessna",
        "reims",
        "reims cessna",
        "textron aviation"
    ],
    beechcraft: [
        "beech",
        "beechcraft",
        "hawker beechcraft",
        "raytheon"
    ],
    piper: [
        "piper",
        "new piper",
        "piper aircraft"
    ],
    boeing: [
        "boeing",
        "boeing co",
        "mcdonnell douglas"
    ],
    airbus: [
        "airbus",
        "airbus industrie",
        "airbus s a s"
    ],
    bombardier: [
        "bombardier",
        "learjet",
        "gates learjet",
        "canadair"
    ],
    eurocopter: [
        "eurocopter",
        "aerospatiale",
        "american eurocopter"
    ],
    "bell helicopter": [
        "bell",
        "bell helicopter",
        "bell helicopter textron"
    ],
    cirrus: [
        "cirrus",
        "cirrus design",
        "cirrus aircraft"
    ],
    mooney: [
        "mooney",
        "mooney aircraft"
    ],
    diamond: [
        "diamond",
        "diamond aircraft"
    ],
    "de havilland": [
        "de havilland",
        "dehavilland",
        "de havilland canada"
    ],
    "american aviation": [
        "american aviation",
        "grumman american"
    ],
    erco: [
        "erco",
        "engineering and research"
    ],
    luscombe: [
        "luscombe",
        "silvaire"
    ],
    champion: [
        "champion",
        "american champion"
    ],
    "aero commander": [
        "aero commander",
        "commander",
        "rockwell"
    ],
    "aviat aircraft": [
        "aviat",
        "aviat aircraft"
    ],
    maule: [
        "maule",
        "maule aircraft"
    ],
    "air tractor": [
        "air tractor"
    ],
    pilatus: [
        "pilatus",
        "pilatus aircraft",
        "pilatus flugzeugwerke"
    ],
    "md helicopters": [
        "md helicopters",
        "mcdonnell douglas helicopters"
    ],
    agusta: [
        "agusta",
        "agustawestland",
        "leonardo"
    ],
    "british aerospace": [
        "british aerospace",
        "bae",
        "hawker siddeley"
    ]
};
/**
 * Normalize a manufacturer name for matching.
 * Similar to normalizeFaaString but more aggressive for manufacturer-specific comparisons.
 */ const $0b7d8c3925d2de62$var$normalizeManufacturer = (manufacturer)=>{
    if (!manufacturer) return "";
    let normalized = manufacturer.toLowerCase().trim();
    // Remove corporate suffixes
    for (const suffix of $0b7d8c3925d2de62$var$CORPORATE_SUFFIXES){
        const lowerSuffix = suffix.toLowerCase();
        // Try with space prefix
        if (normalized.endsWith(` ${lowerSuffix}`)) normalized = normalized.slice(0, -(lowerSuffix.length + 1));
        // Try without space (handles cases like "CESSNAAIRCRAFT")
        if (normalized.endsWith(lowerSuffix)) normalized = normalized.slice(0, -lowerSuffix.length);
    }
    // Normalize punctuation
    normalized = normalized.replace(/\./g, "") // Remove periods
    .replace(/\//g, " ") // Convert slashes to spaces (handles "Reims/cessna")
    .replace(/-/g, " ") // Convert hyphens to spaces
    .replace(/\s+/g, " ") // Collapse multiple spaces
    .trim();
    return normalized;
};
/**
 * Match a manufacturer name against known aliases and fuzzy matching.
 * Returns a score between 0.0 (no match) and 1.0 (perfect match).
 *
 * Scoring:
 * - Exact match: 1.0
 * - Alias match: 0.9
 * - Fuzzy match (≥80% similarity): 0.8-0.99
 * - Fuzzy match (≥70% similarity): 0.7-0.79
 * - No match: 0.0
 */ const $0b7d8c3925d2de62$var$matchManufacturer = (faaManufacturer, aircraftMake)=>{
    if (!faaManufacturer || !aircraftMake) return 0.0;
    const normalizedFaa = $0b7d8c3925d2de62$var$normalizeManufacturer(faaManufacturer);
    const normalizedAircraft = $0b7d8c3925d2de62$var$normalizeManufacturer(aircraftMake);
    // Exact match after normalization
    if (normalizedFaa === normalizedAircraft) return 1.0;
    // Check if either contains the other (handles single word vs multi-word)
    if (normalizedFaa.includes(normalizedAircraft) || normalizedAircraft.includes(normalizedFaa)) return 0.95;
    // Token-based partial matching (handles "Hawker Beechcraft" vs "Beechcraft")
    const faaTokens = normalizedFaa.split(/\s+/).filter((t)=>t.length > 2);
    const aircraftTokens = normalizedAircraft.split(/\s+/).filter((t)=>t.length > 2);
    // Check if any significant tokens match
    const hasMatchingToken = faaTokens.some((ft)=>aircraftTokens.some((at)=>ft === at || ft.includes(at) || at.includes(ft)));
    if (hasMatchingToken) return 0.85;
    // Check alias map
    for (const [_, aliases] of Object.entries($0b7d8c3925d2de62$var$MANUFACTURER_ALIASES)){
        const faaInAliases = aliases.some((alias)=>normalizedFaa.includes(alias) || alias.includes(normalizedFaa));
        const aircraftInAliases = aliases.some((alias)=>normalizedAircraft.includes(alias) || alias.includes(normalizedAircraft));
        if (faaInAliases && aircraftInAliases) return 0.9;
    }
    // Fuzzy matching using Levenshtein distance
    const distance = $0b7d8c3925d2de62$var$levenshtein(normalizedFaa, normalizedAircraft);
    const maxLength = Math.max(normalizedFaa.length, normalizedAircraft.length);
    const similarity = 1 - distance / maxLength;
    // Map similarity to score range (slightly relaxed thresholds)
    if (similarity >= 0.75) return 0.75 + (similarity - 0.75) * 1.0; // 0.75-1.0
    else if (similarity >= 0.65) return 0.65 + (similarity - 0.65) * 0.9; // 0.65-0.74
    else if (similarity >= 0.5) return 0.5 + (similarity - 0.5) * 0.8; // 0.5-0.64
    return 0.0;
};
/**
 * Filter aircraft list to only those with matching manufacturers.
 * Returns filtered list if matches found, otherwise returns full list (safety net).
 */ const $0b7d8c3925d2de62$var$filterByManufacturer = (faaManufacturer, allAircraft)=>{
    // No manufacturer provided - return all
    if (!faaManufacturer) return allAircraft;
    // Score each aircraft's manufacturer
    const scoredAircraft = allAircraft.map((aircraft)=>({
            aircraft: aircraft,
            manufacturerScore: $0b7d8c3925d2de62$var$matchManufacturer(faaManufacturer, aircraft.make || "")
        }));
    // Filter to matches with score ≥ 0.70 (70% threshold)
    // Quality gate in main algorithm ensures strong matches
    const matches = scoredAircraft.filter((s)=>s.manufacturerScore >= 0.7).map((s)=>s.aircraft);
    // NO FALLBACK: If manufacturer doesn't match, return empty list
    // This prevents nonsense matches like DJI → Piper
    return matches;
};
/**
 * Extract components from a model string.
 * Separates numeric sequences from text for independent comparison.
 *
 * Examples:
 * - "172M" → numbers:[172], letters:["M"]
 * - "PA-34-220T" → numbers:[34,220], letters:["PA","T"]
 * - "EC120B Colibri" → numbers:[120], letters:["EC","B","Colibri"]
 * - "Baron 58" → numbers:[58], letters:["Baron"]
 */ const $0b7d8c3925d2de62$var$extractComponents = (model)=>{
    const normalized = $0b7d8c3925d2de62$var$normalizeModel(model);
    // Extract all number sequences
    const numberMatches = normalized.match(/\d+/g);
    const numbers = numberMatches ? numberMatches.map((n)=>parseInt(n, 10)) : [];
    // Extract all letter sequences
    const letterMatches = normalized.match(/[a-z]+/g);
    const letters = letterMatches || [];
    return {
        numbers: numbers,
        letters: letters
    };
};
/**
 * Compare two number arrays with strict exact matching.
 * ALL numbers from arr1 (search) must appear in arr2 (target).
 * This prevents "305" from matching "337" or "212" from matching "412",
 * but allows "36" to match "Bonanza 36, A36, G36" (which has [36, 36, 36]).
 *
 * Returns score 0.0-1.0 (higher is better).
 */ const $0b7d8c3925d2de62$var$compareNumberArrays = (arr1, arr2)=>{
    // Both empty = perfect match
    if (arr1.length === 0 && arr2.length === 0) return 1.0;
    // One empty = no match
    if (arr1.length === 0 || arr2.length === 0) return 0.0;
    // Check if arr1 is a subset of arr2 (all numbers in arr1 appear in arr2)
    // Use sets to handle duplicates (e.g., [36] matches [36, 36, 36])
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    // ALL unique numbers from search must be in target
    for (const num of set1){
        if (!set2.has(num)) return 0.0; // Missing number = no match
    }
    // If arr1 has MORE unique numbers than arr2, it's not a match
    // (prevents "PA-34-220" from matching "PA-34")
    if (set1.size > set2.size) return 0.5; // Partial match
    // Perfect match: all numbers from search are in target
    return 1.0;
};
/**
 * Compare letter components with fuzzy matching.
 * Returns score 0.0-1.0 (higher is better).
 */ const $0b7d8c3925d2de62$var$compareLetters = (arr1, arr2)=>{
    // Both empty = perfect match
    if (arr1.length === 0 && arr2.length === 0) return 1.0;
    // One empty = partial score (numbers matched, no letters to compare)
    if (arr1.length === 0 || arr2.length === 0) return 0.7;
    // Check if all letters from arr1 are present in arr2 (subset match)
    // e.g., ["cherokee"] is subset of ["pa", "cherokee", "cruiser"]
    const set1 = new Set(arr1.map((s)=>s.toLowerCase()));
    const set2 = new Set(arr2.map((s)=>s.toLowerCase()));
    const allPresent = Array.from(set1).every((letter)=>set2.has(letter));
    if (allPresent && set1.size <= set2.size) // Perfect match if arr1 is subset of arr2
    return 1.0;
    // Join into strings and compare
    const str1 = arr1.join(" ");
    const str2 = arr2.join(" ");
    if (str1 === str2) return 1.0;
    // Fuzzy comparison
    const distance = $0b7d8c3925d2de62$var$levenshtein(str1, str2);
    const maxLength = Math.max(str1.length, str2.length);
    const similarity = 1 - distance / maxLength;
    return Math.max(0, similarity);
};
/**
 * Compare two model strings using component-based matching.
 * Combines numeric position-weighted comparison with letter fuzzy matching.
 *
 * Returns a score 0.0-1.0 (higher is better).
 * - 1.0 = Perfect match
 * - 0.9+ = Same numbers, minor letter differences (HIGH confidence)
 * - 0.7-0.89 = Major numbers match, some digit differences (MEDIUM confidence)
 * - 0.5-0.69 = Partial match (LOW confidence)
 * - <0.5 = Too different (NO MATCH)
 */ const $0b7d8c3925d2de62$var$compareModels = (model1, model2)=>{
    const norm1 = $0b7d8c3925d2de62$var$normalizeModel(model1);
    const norm2 = $0b7d8c3925d2de62$var$normalizeModel(model2);
    // Exact match
    if (norm1 === norm2) return 1.0;
    // Extract components
    const comp1 = $0b7d8c3925d2de62$var$extractComponents(norm1);
    const comp2 = $0b7d8c3925d2de62$var$extractComponents(norm2);
    // For text-only models (no numbers), use simple fuzzy matching
    if (comp1.numbers.length === 0 && comp2.numbers.length === 0) {
        const distance = $0b7d8c3925d2de62$var$levenshtein(norm1, norm2);
        const maxLength = Math.max(norm1.length, norm2.length);
        return Math.max(0, 1 - distance / maxLength);
    }
    // Compare numeric components
    const numericScore = $0b7d8c3925d2de62$var$compareNumberArrays(comp1.numbers, comp2.numbers);
    // Compare letter components
    const letterScore = $0b7d8c3925d2de62$var$compareLetters(comp1.letters, comp2.letters);
    // Adaptive weighting based on whether search has numbers
    // If search has no numbers (e.g., "Cherokee"), letters matter more
    // If search has numbers (e.g., "PA-28-140"), numbers matter more
    if (comp1.numbers.length === 0 && comp2.numbers.length > 0) // Search is text-only, target has numbers
    // Weight letters heavily (letters are what we're searching for)
    return letterScore * 0.9 + numericScore * 0.1;
    else // Both have numbers, or target has no numbers
    // Weight numbers heavily (traditional behavior)
    return numericScore * 0.8 + letterScore * 0.2;
};
/**
 * Normalize a model string for comparison.
 * Less aggressive than normalizeFaaString - preserves model structure.
 */ const $0b7d8c3925d2de62$var$normalizeModel = (model)=>{
    return model.toLowerCase().trim().replace(/\([^)]*\)/g, "") // Remove parentheses and contents (variant designations like "(L20A)")
    .replace(/\./g, "") // Remove periods
    .replace(/\s+/g, " ") // Collapse whitespace
    .trim();
};
/**
 * Calculate similarity between two FAA strings.
 * Returns a distance score between 0 (identical) and Infinity (no match).
 *
 * CRITICAL FIX: Compares ONLY the model portions (after " / "), not full strings.
 * This prevents "CESSNA / 162" from matching "CESSNA / 182" just because
 * the manufacturer portions are identical.
 *
 * Uses component-based matching with strict numeric requirements.
 */ const $0b7d8c3925d2de62$var$compareFaaStrings = (str1, str2)=>{
    // Extract model portions (everything after " / ")
    // "CESSNA AIRCRAFT CO / 162" → "162"
    const model1 = str1.includes(" / ") ? str1.split(" / ")[1] : str1;
    const model2 = str2.includes(" / ") ? str2.split(" / ")[1] : str2;
    // Compare models using component-based matching (returns 0.0-1.0, higher is better)
    const similarity = $0b7d8c3925d2de62$var$compareModels(model1, model2);
    // Convert similarity score (0.0-1.0) to distance score (0-Infinity, lower is better)
    // 1.0 similarity → 0 distance (perfect match)
    // 0.9 similarity → 1 distance (excellent match)
    // 0.5 similarity → 10 distance (weak match)
    // 0.0 similarity → Infinity (no match)
    if (similarity >= 0.9) return (1.0 - similarity) * 10; // 0-1 range
    else if (similarity >= 0.5) return (1.0 - similarity) * 20; // 1-10 range
    else return Infinity; // Too weak
};
/**
 * Calculate score based on historical FAA string matches.
 * Compares the incoming FAA string against all previously-mapped FAA strings
 * for this aircraft, returning the best (lowest) score and the matched string.
 */ const $0b7d8c3925d2de62$var$calculateHistoricalScore = (aircraft, faaManufacturer, faaModel)=>{
    // No historical data available
    if (!aircraft.alreadyMatched || aircraft.alreadyMatched.length === 0) return {
        score: Infinity
    };
    // Build incoming FAA string
    const incomingParts = [];
    if (faaManufacturer) incomingParts.push(faaManufacturer.trim());
    if (faaModel) incomingParts.push(faaModel.trim());
    const incomingFaaString = incomingParts.join(" / ");
    if (!incomingFaaString) return {
        score: Infinity
    };
    // Compare against each historical FAA string
    let bestScore = Infinity;
    let bestMatchedString;
    for (const historicalFaaString of aircraft.alreadyMatched){
        const score = $0b7d8c3925d2de62$var$compareFaaStrings(incomingFaaString, historicalFaaString);
        if (score < bestScore) {
            bestScore = score;
            bestMatchedString = historicalFaaString;
        }
    }
    return {
        score: bestScore,
        matchedString: bestMatchedString
    };
};


/**
 * Country to flag emoji mapping for aircraft registration countries
 * Based on ICAO aircraft registration prefixes
 */ const $86dca4a6955b79de$export$4bd78a5eda910a5e = {
    // North America
    "United States": "\uD83C\uDDFA\uD83C\uDDF8",
    "Canada": "\uD83C\uDDE8\uD83C\uDDE6",
    "Mexico": "\uD83C\uDDF2\uD83C\uDDFD",
    // South America
    "Brazil": "\uD83C\uDDE7\uD83C\uDDF7",
    "Argentina": "\uD83C\uDDE6\uD83C\uDDF7",
    "Chile": "\uD83C\uDDE8\uD83C\uDDF1",
    "Colombia": "\uD83C\uDDE8\uD83C\uDDF4",
    "Ecuador": "\uD83C\uDDEA\uD83C\uDDE8",
    "Peru": "\uD83C\uDDF5\uD83C\uDDEA",
    "Venezuela": "\uD83C\uDDFB\uD83C\uDDEA",
    // Central America & Caribbean
    "Panama": "\uD83C\uDDF5\uD83C\uDDE6",
    "El Salvador": "\uD83C\uDDF8\uD83C\uDDFB",
    "Guatemala": "\uD83C\uDDEC\uD83C\uDDF9",
    "Honduras": "\uD83C\uDDED\uD83C\uDDF3",
    "Costa Rica": "\uD83C\uDDE8\uD83C\uDDF7",
    "Nicaragua": "\uD83C\uDDF3\uD83C\uDDEE",
    "Jamaica": "\uD83C\uDDEF\uD83C\uDDF2",
    "Dominican Republic": "\uD83C\uDDE9\uD83C\uDDF4",
    // Europe
    "United Kingdom": "\uD83C\uDDEC\uD83C\uDDE7",
    "Germany": "\uD83C\uDDE9\uD83C\uDDEA",
    "France": "\uD83C\uDDEB\uD83C\uDDF7",
    "Italy": "\uD83C\uDDEE\uD83C\uDDF9",
    "Spain": "\uD83C\uDDEA\uD83C\uDDF8",
    "Portugal": "\uD83C\uDDF5\uD83C\uDDF9",
    "Netherlands": "\uD83C\uDDF3\uD83C\uDDF1",
    "Belgium": "\uD83C\uDDE7\uD83C\uDDEA",
    "Switzerland": "\uD83C\uDDE8\uD83C\uDDED",
    "Austria": "\uD83C\uDDE6\uD83C\uDDF9",
    "Sweden": "\uD83C\uDDF8\uD83C\uDDEA",
    "Norway": "\uD83C\uDDF3\uD83C\uDDF4",
    "Denmark": "\uD83C\uDDE9\uD83C\uDDF0",
    "Finland": "\uD83C\uDDEB\uD83C\uDDEE",
    "Ireland": "\uD83C\uDDEE\uD83C\uDDEA",
    "Poland": "\uD83C\uDDF5\uD83C\uDDF1",
    "Czech Republic": "\uD83C\uDDE8\uD83C\uDDFF",
    "Hungary": "\uD83C\uDDED\uD83C\uDDFA",
    "Russia": "\uD83C\uDDF7\uD83C\uDDFA",
    "Ukraine": "\uD83C\uDDFA\uD83C\uDDE6",
    "Bulgaria": "\uD83C\uDDE7\uD83C\uDDEC",
    "Romania": "\uD83C\uDDF7\uD83C\uDDF4",
    "Greece": "\uD83C\uDDEC\uD83C\uDDF7",
    "Malta": "\uD83C\uDDF2\uD83C\uDDF9",
    // Asia Pacific
    "Australia": "\uD83C\uDDE6\uD83C\uDDFA",
    "New Zealand": "\uD83C\uDDF3\uD83C\uDDFF",
    "Japan": "\uD83C\uDDEF\uD83C\uDDF5",
    "South Korea": "\uD83C\uDDF0\uD83C\uDDF7",
    "China": "\uD83C\uDDE8\uD83C\uDDF3",
    "India": "\uD83C\uDDEE\uD83C\uDDF3",
    "Malaysia": "\uD83C\uDDF2\uD83C\uDDFE",
    "Singapore": "\uD83C\uDDF8\uD83C\uDDEC",
    "Thailand": "\uD83C\uDDF9\uD83C\uDDED",
    "Indonesia": "\uD83C\uDDEE\uD83C\uDDE9",
    "Philippines": "\uD83C\uDDF5\uD83C\uDDED",
    "Vietnam": "\uD83C\uDDFB\uD83C\uDDF3",
    // Middle East
    "United Arab Emirates": "\uD83C\uDDE6\uD83C\uDDEA",
    "Saudi Arabia": "\uD83C\uDDF8\uD83C\uDDE6",
    "Iran": "\uD83C\uDDEE\uD83C\uDDF7",
    "Turkey": "\uD83C\uDDF9\uD83C\uDDF7",
    "Israel": "\uD83C\uDDEE\uD83C\uDDF1",
    "Jordan": "\uD83C\uDDEF\uD83C\uDDF4",
    "Oman": "\uD83C\uDDF4\uD83C\uDDF2",
    "Qatar": "\uD83C\uDDF6\uD83C\uDDE6",
    "Bahrain": "\uD83C\uDDE7\uD83C\uDDED",
    // Africa
    "South Africa": "\uD83C\uDDFF\uD83C\uDDE6",
    "Kenya": "\uD83C\uDDF0\uD83C\uDDEA",
    "Ethiopia": "\uD83C\uDDEA\uD83C\uDDF9",
    "Egypt": "\uD83C\uDDEA\uD83C\uDDEC",
    "Morocco": "\uD83C\uDDF2\uD83C\uDDE6",
    "Ivory Coast": "\uD83C\uDDE8\uD83C\uDDEE",
    "Nigeria": "\uD83C\uDDF3\uD83C\uDDEC"
};
const $86dca4a6955b79de$export$fd5d2cd02be3d52a = (country)=>{
    return $86dca4a6955b79de$export$4bd78a5eda910a5e[country] || "\uD83C\uDFF3\uFE0F";
};
const $86dca4a6955b79de$export$a977daf163a2da79 = (country, prefix)=>{
    return `${$86dca4a6955b79de$export$fd5d2cd02be3d52a(country)} ${country} (${prefix})`;
};



var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $2LXej = parcelRequire("2LXej");
/**
 * Conservative CSV-based matcher for FAA aircraft types.
 * Only suggests matches that appear in verified training data with no ambiguity.
 *
 * Approach:
 * 1. Normalize FAA manufacturer + model
 * 2. Look up in pre-built index of verified mappings
 * 3. Only suggest if exact match exists and is unambiguous
 * 4. Confidence always high (from verified data)
 */ // Minimum examples before we auto-trust a pattern
const $c2e6aaae14840b5d$var$MIN_SAFE_COUNT = 1;
/**
 * Normalize manufacturer name for matching.
 * Aggressive normalization to catch corporate name variations.
 */ function $c2e6aaae14840b5d$var$normalizeMake(raw) {
    let normalized = (raw || "").toUpperCase().trim();
    // Strip common corporate suffixes
    const suffixes = [
        "AIRCRAFT COMPANY",
        "AIRCRAFT CO",
        "AIRCRAFT INC",
        "AIRCRAFT",
        "CORPORATION",
        "CORP",
        "COMPANY",
        "CO",
        "INC",
        "LLC",
        "LTD",
        "LIMITED",
        "INDUSTRIES",
        "AVIATION",
        "HELICOPTER",
        "HELICOPTERS",
        "FLUGZEUGWERKE",
        "SPA",
        "AG",
        "S A S"
    ];
    for (const suffix of suffixes){
        // Try with space prefix
        const withSpace = new RegExp(`\\s+${suffix}$`, "i");
        normalized = normalized.replace(withSpace, "");
        // Try without space (handles "CESSNAAIRCRAFT")
        const withoutSpace = new RegExp(`${suffix}$`, "i");
        normalized = normalized.replace(withoutSpace, "");
    }
    // Normalize all punctuation to spaces
    normalized = normalized.replace(/[,.\/\-&()]/g, " ").replace(/\s+/g, " ").trim();
    return normalized;
}
/**
 * Normalize model string for matching.
 * Very aggressive - strips ALL punctuation and whitespace.
 * "PA-28-140" → "PA28140", "172-M" → "172M", "King Air B350" → "KINGAIRB350"
 */ function $c2e6aaae14840b5d$var$normalizeModel(raw) {
    let normalized = (raw || "").toUpperCase().trim();
    // Remove parenthetical content: "172M (Special)" → "172M"
    normalized = normalized.replace(/\([^)]*\)/g, "");
    // Strip ALL punctuation and whitespace - collapse to letters+numbers only
    // This ensures "172-M", "172 M", "172M" all become "172M"
    normalized = normalized.replace(/[-,./\s]+/g, "");
    return normalized;
}
class $c2e6aaae14840b5d$export$cd9d7304cd237617 {
    constructor(safeMap, stats){
        this.safeMap = new Map();
        this.safeMap = safeMap;
        this.stats = stats;
    }
    /**
   * Build matcher from array of CSV rows (training data)
   */ static fromRows(rows) {
        const canonRows = rows.map((r)=>({
                make_norm: $c2e6aaae14840b5d$var$normalizeMake(r.faa_manufacturer),
                model_norm: $c2e6aaae14840b5d$var$normalizeModel(r.faa_model),
                airplx_make: r.airplx_make,
                airplx_model: r.airplx_model
            }));
        const totalRows = canonRows.length;
        // Count by (make_norm, model_norm, airplx_make, airplx_model)
        const comboCounts = new Map();
        canonRows.forEach((r)=>{
            const key = `${r.make_norm}||${r.model_norm}||${r.airplx_make}||${r.airplx_model}`;
            comboCounts.set(key, (comboCounts.get(key) ?? 0) + 1);
        });
        const perPair = new Map();
        comboCounts.forEach((count, comboKey)=>{
            const [make_norm, model_norm, airplx_make, airplx_model] = comboKey.split("||");
            const pairKey = `${make_norm}||${model_norm}`;
            const existing = perPair.get(pairKey) ?? {
                totalExamples: 0,
                targets: new Set()
            };
            existing.totalExamples += count;
            existing.targets.add(`${airplx_make}||${airplx_model}`);
            perPair.set(pairKey, existing);
        });
        const uniquePairs = perPair.size;
        // Build safeMap: only pairs that:
        // - map to exactly one AirPlx (no ambiguity)
        // - have at least MIN_SAFE_COUNT examples
        const safeMap = new Map();
        perPair.forEach((info, pairKey)=>{
            if (info.targets.size !== 1) return; // Ambiguous - skip
            if (info.totalExamples < $c2e6aaae14840b5d$var$MIN_SAFE_COUNT) return; // Not enough examples - skip
            const [target] = Array.from(info.targets);
            const [airplx_make, airplx_model] = target.split("||");
            safeMap.set(pairKey, {
                airplx_make: airplx_make,
                airplx_model: airplx_model,
                confidence: 0.999,
                auto: true
            });
        });
        const stats = {
            totalRows: totalRows,
            uniquePairs: uniquePairs,
            safePairs: safeMap.size
        };
        return new $c2e6aaae14840b5d$export$cd9d7304cd237617(safeMap, stats);
    }
    /**
   * Suggest a match for given FAA manufacturer/model
   * Returns null if no safe match found in CSV
   */ suggestMatch(faa_make, faa_model) {
        const make_norm = $c2e6aaae14840b5d$var$normalizeMake(faa_make);
        const model_norm = $c2e6aaae14840b5d$var$normalizeModel(faa_model);
        const key = `${make_norm}||${model_norm}`;
        return this.safeMap.get(key) ?? null;
    }
}


const $b4695ffadadf5fb9$export$f71ad16b7a15ca64 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    // Fetch existing FAA mappings (the "training data" for suggestions)
    const { value: existingMappings, loading: loadingMappings } = (0, $2NPdf.default)(async ()=>{
        const { data: data, error: error } = await postgrest.rpc("get_faa_mappings");
        if (error) {
            console.error("Failed to fetch FAA mappings:", error);
            return [];
        }
        return data || [];
    }, [
        postgrest
    ]);
    // Fetch all aircraft for suggestions
    const { value: allAircraft, loading: loadingAircraft } = (0, $2NPdf.default)(async ()=>{
        const result = await postgrest.from("aircraft").select("id,make,model,geom,linked_to").order("make").order("model");
        return result.body?.filter((row)=>row.geom || row.linked_to) || [];
    }, [
        postgrest
    ]);
    // Build AircraftWithHistory by enriching aircraft with historical FAA mappings
    const aircraftWithHistory = $acw62.useMemo(()=>{
        if (!allAircraft || !existingMappings) return [];
        // Group FAA strings by matched_aircraft_id
        // Map<aircraft_id, string[]> where strings are "MANUFACTURER / MODEL"
        const historyMap = new Map();
        existingMappings.forEach((mapping)=>{
            if (!mapping.matched_aircraft_id) return;
            const faaString = `${mapping.faa_manufacturer} / ${mapping.faa_model}`;
            const existing = historyMap.get(mapping.matched_aircraft_id) || [];
            // Avoid duplicates
            if (!existing.includes(faaString)) {
                existing.push(faaString);
                historyMap.set(mapping.matched_aircraft_id, existing);
            }
        });
        // Enrich each aircraft with its historical mappings
        return allAircraft.map((aircraft)=>({
                ...aircraft,
                alreadyMatched: historyMap.get(aircraft.id) || []
            }));
    }, [
        allAircraft,
        existingMappings
    ]);
    // Build CSV matcher from existing mappings for verified exact matches
    const csvMatcher = $acw62.useMemo(()=>{
        if (!existingMappings || existingMappings.length === 0) return null;
        return (0, $c2e6aaae14840b5d$export$cd9d7304cd237617).fromRows(existingMappings);
    }, [
        existingMappings
    ]);
    return {
        aircraftWithHistory: aircraftWithHistory,
        csvMatcher: csvMatcher,
        loading: loadingMappings || loadingAircraft
    };
};



var $ayMG0 = parcelRequire("ayMG0");

var $jk25Q = parcelRequire("jk25Q");

var $1MdOk = parcelRequire("1MdOk");

var $hbZ6O = parcelRequire("hbZ6O");
var $347bb668b18a16a4$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $347bb668b18a16a4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($347bb668b18a16a4$exports, "__esModule", {
    value: true
});
$347bb668b18a16a4$exports.default = void 0;

var $347bb668b18a16a4$var$_createSvgIcon = $347bb668b18a16a4$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $347bb668b18a16a4$var$_default = $347bb668b18a16a4$exports.default = (0, $347bb668b18a16a4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m2 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m6-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m6 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-.02 6c-.74 0-1.37.4-1.72 1h-2.54c-.34-.6-.98-1-1.72-1s-1.37.4-1.72 1H8.41l3.07-3.07c.17.04.34.07.52.07 1.1 0 2-.9 2-2 0-.18-.03-.35-.07-.51l3.56-3.56c.16.04.33.07.51.07 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .18.03.35.07.51l-3.56 3.56c-.16-.04-.33-.07-.51-.07-1.1 0-2 .9-2 2 0 .18.03.35.07.51l-3.56 3.56C6.35 16.03 6.18 16 6 16c-1.1 0-2 .9-2 2s.9 2 2 2c.74 0 1.37-.4 1.72-1h2.57c.34.6.98 1 1.72 1s1.37-.4 1.72-1h2.55c.34.6.98 1 1.72 1 1.1 0 2-.9 2-2-.02-1.1-.92-2-2.02-2"
}), 'Pattern');



var $7UqNi = parcelRequire("7UqNi");
var $2mdyF = parcelRequire("2mdyF");
var $2gURC = parcelRequire("2gURC");
var $6lXkL = parcelRequire("6lXkL");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $6ami2 = parcelRequire("6ami2");
var $cJu23 = parcelRequire("cJu23");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $294f423e61f44b59$export$40e5ba8bd6a5d06e = ({ patterns: patterns, loading: loading, onReApply: onReApply, onDelete: onDelete })=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const formatDate = (dateStr)=>{
        if (!dateStr) return "Never";
        const date = new Date(dateStr);
        return date.toLocaleDateString(undefined, {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    };
    const formatAircraftName = (pattern)=>{
        if (!pattern.aircraft) return "Unknown Aircraft";
        return `${pattern.aircraft.make} ${pattern.aircraft.model}`;
    };
    if (loading || patterns.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UqNi.default), {
        expanded: expanded,
        onChange: ()=>setExpanded(!expanded),
        sx: {
            backgroundColor: "background.paper"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gURC.default), {
                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {}),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($347bb668b18a16a4$exports))), {
                            color: "primary"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "h6",
                            children: "Saved Patterns"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                            label: patterns.length,
                            size: "small",
                            color: "primary",
                            variant: "outlined"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2mdyF.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                    container: true,
                    spacing: 2,
                    children: patterns.map((pattern)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cJu23.default), {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 4,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5WjaY.default), {
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                    variant: "body2",
                                                    color: "text.secondary",
                                                    sx: {
                                                        fontStyle: "italic"
                                                    },
                                                    children: [
                                                        '"',
                                                        pattern.search_query,
                                                        '"'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "subtitle2",
                                                    sx: {
                                                        fontWeight: 600
                                                    },
                                                    children: formatAircraftName(pattern)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                                            label: `${pattern.applied_count} applied`,
                                                            size: "small",
                                                            variant: "outlined"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            color: "text.secondary",
                                                            children: [
                                                                "Last: ",
                                                                formatDate(pattern.last_applied_at)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b46a5bcac23a5f99$export$2e2bcd8739ae039), {
                                        sx: {
                                            justifyContent: "space-between",
                                            pt: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                size: "small",
                                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jk25Q))), {}),
                                                onClick: ()=>onReApply(pattern),
                                                children: "Re-apply"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                size: "small",
                                                onClick: ()=>onDelete(pattern.id),
                                                color: "error",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, pattern.id))
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $hmTQO = parcelRequire("hmTQO");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $hTRQz = parcelRequire("hTRQz");

var $ayMG0 = parcelRequire("ayMG0");

var $hmTQO = parcelRequire("hmTQO");

var $dqlTG = parcelRequire("dqlTG");

var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $7Frhn = parcelRequire("7Frhn");
var $6FKde = parcelRequire("6FKde");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");
parcelRequire("acw62");
const $9e66727a1201d661$export$30e52911d7f982b0 = ({ aircraftName: aircraftName, matchCount: matchCount, onApply: onApply, onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6FKde.default), {
        direction: "down",
        in: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
            elevation: 3,
            sx: {
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                mt: 0.5,
                p: 1.5,
                zIndex: 1000,
                backgroundColor: "background.paper",
                borderLeft: 3,
                borderColor: "primary.main"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1.5,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmTQO))), {
                        fontSize: "small",
                        color: "primary"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: "body2",
                        sx: {
                            flex: 1
                        },
                        children: [
                            "Apply ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: aircraftName
                            }),
                            " to all ",
                            matchCount,
                            " visible rows?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        size: "small",
                        variant: "contained",
                        color: "primary",
                        onClick: onApply,
                        children: "Apply"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        size: "small",
                        onClick: onDismiss,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                            fontSize: "small"
                        })
                    })
                ]
            })
        })
    });
};


const $012ccf33f2b0276f$export$f2b59a177e463cba = ({ suggestion: suggestion, currentMapping: currentMapping, faaManufacturer: faaManufacturer, faaModel: faaModel, onApprove: onApprove, onManualChange: onManualChange, onBulkApplyRequest: onBulkApplyRequest, bulkApplyContext: bulkApplyContext })=>{
    const [isApproving, setIsApproving] = $acw62.useState(false);
    const [flashSuggestion, setFlashSuggestion] = $acw62.useState(false);
    // Track which aircraft ID we've flashed to avoid re-flashing on filter changes
    const flashedAircraftId = $acw62.useRef(null);
    // Memoize defaultSelected to prevent new object references on every render
    // This prevents AutocompleteAircraft from thinking the value changed
    const defaultSelected = $acw62.useMemo(()=>{
        return currentMapping || suggestion?.suggestedAircraft || undefined;
    }, [
        currentMapping?.id,
        suggestion?.suggestedAircraft?.id
    ]);
    // Show suggestion as flashing when it's a new suggestion (not already mapped)
    const shouldFlash = !currentMapping && suggestion?.confidence !== null && flashSuggestion;
    // Flash only when we get a NEW aircraft suggestion (different ID than previously flashed)
    $acw62.useEffect(()=>{
        const hasSuggestion = !currentMapping && suggestion?.confidence !== null && suggestion?.suggestedAircraft?.id;
        if (hasSuggestion) {
            const currentAircraftId = suggestion.suggestedAircraft.id;
            // Only flash if this is a different aircraft than we've already flashed
            if (flashedAircraftId.current !== currentAircraftId) {
                flashedAircraftId.current = currentAircraftId;
                setFlashSuggestion(true);
                const timer = setTimeout(()=>setFlashSuggestion(false), 1500);
                return ()=>clearTimeout(timer);
            }
        } else if (currentMapping?.id) // Reset the flashed ID when suggestion disappears (e.g., row gets mapped)
        flashedAircraftId.current = null;
    }, [
        suggestion?.suggestedAircraft?.id,
        suggestion?.confidence,
        currentMapping?.id
    ]);
    const handleApprove = async ()=>{
        if (!suggestion?.suggestedAircraft) return;
        setIsApproving(true);
        try {
            await onApprove(suggestion.suggestedAircraft);
        } catch (error) {
            console.error("Failed to approve suggestion:", error);
        } finally{
            setIsApproving(false);
        }
    };
    const handleManualChange = async (aircraft)=>{
        if (!aircraft) return;
        await onManualChange(aircraft);
        // Trigger bulk apply request when aircraft is selected
        if (onBulkApplyRequest) onBulkApplyRequest(aircraft);
    };
    // Determine checkmark color based on confidence
    const getCheckmarkColor = ()=>{
        if (suggestion?.confidence === "high") return "success";
        if (suggestion?.confidence === "medium") return "warning";
        return "success"; // fallback
    };
    const calculateModelDiff = (faaModel, aircraftModel)=>{
        if (!faaModel || !aircraftModel) return [];
        const segments = [];
        const maxLen = Math.max(faaModel.length, aircraftModel.length);
        for(let i = 0; i < maxLen; i++){
            const faaChar = faaModel[i] || "";
            const aircraftChar = aircraftModel[i] || "";
            if (faaChar === aircraftChar) segments.push({
                text: faaChar,
                type: "match"
            });
            else if (faaChar.toUpperCase() === aircraftChar.toUpperCase()) segments.push({
                text: aircraftChar,
                type: "case-diff"
            });
            else segments.push({
                text: aircraftChar,
                type: "different"
            });
        }
        return segments;
    };
    const getDiffColor = (type)=>{
        switch(type){
            case "match":
                return "inherit";
            case "case-diff":
                return "warning.main";
            case "different":
                return "error.main";
        }
    };
    // Get human-readable match confidence reason
    const getMatchReason = (breakdown)=>{
        if (!breakdown) return "";
        switch(breakdown.method){
            case "csv-verified":
                return breakdown.matchedHistoricalString ? `This FAA string "${breakdown.matchedHistoricalString}" was previously mapped to this aircraft` : "Found in verified database mappings";
            case "historical":
                return breakdown.matchedHistoricalString ? `Similar to previously mapped: "${breakdown.matchedHistoricalString}"` : "Based on historical mapping patterns";
            case "combined":
                return "Match found using both database history and fuzzy text matching";
            case "traditional":
                return "Match found using fuzzy text matching of manufacturer and model";
            default:
                return "Unknown match method";
        }
    };
    // Determine detailed tooltip content with score breakdown
    const getTooltipContent = ()=>{
        if (!suggestion || suggestion.confidence === null) return "";
        const { score: score, confidence: confidence, breakdown: breakdown, suggestedAircraft: suggestedAircraft } = suggestion;
        const confidenceLabel = confidence === "high" ? "High" : "Medium";
        const borderColor = confidence === "high" ? "success.main" : "warning.main";
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            sx: {
                p: 1.5,
                maxWidth: 500
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 2,
                    alignItems: "flex-start",
                    sx: {
                        mb: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            component: "img",
                            src: `/${suggestedAircraft?.id}.png`,
                            alt: `${suggestedAircraft?.make} ${suggestedAircraft?.model}`,
                            sx: {
                                width: 80,
                                height: 80,
                                border: 2,
                                borderColor: borderColor,
                                bgcolor: "background.default",
                                borderRadius: 1,
                                objectFit: "cover"
                            },
                            onError: (e)=>{
                                e.currentTarget.style.display = "none";
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            sx: {
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "h6",
                                    sx: {
                                        fontWeight: 700,
                                        lineHeight: 1.2,
                                        mb: 0.5
                                    },
                                    children: [
                                        suggestedAircraft?.make,
                                        " ",
                                        suggestedAircraft?.model
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: `${confidenceLabel} confidence`,
                                    size: "small",
                                    color: confidence === "high" ? "success" : "warning",
                                    sx: {
                                        fontWeight: 600
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "caption",
                                    display: "block",
                                    sx: {
                                        mt: 0.5,
                                        color: "text.secondary"
                                    },
                                    children: [
                                        "Score: ",
                                        score.toFixed(1)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    sx: {
                        my: 1.5
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        bgcolor: "action.hover",
                        p: 1.5,
                        borderRadius: 1,
                        mb: 1.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            sx: {
                                fontWeight: 600,
                                display: "block",
                                mb: 1,
                                color: "text.secondary"
                            },
                            children: "Match Details"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 1.5,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                color: "text.secondary",
                                                display: "block",
                                                fontSize: "0.7rem"
                                            },
                                            children: "FAA Input (what you're mapping):"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                fontWeight: 600,
                                                fontFamily: "monospace",
                                                fontSize: "0.875rem"
                                            },
                                            children: [
                                                faaManufacturer || "\u2014",
                                                " / ",
                                                faaModel || "\u2014"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                color: "text.secondary",
                                                display: "block",
                                                fontSize: "0.7rem"
                                            },
                                            children: "Suggested Aircraft:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                fontWeight: 700,
                                                color: "success.main",
                                                fontSize: "0.875rem"
                                            },
                                            children: [
                                                suggestedAircraft?.make,
                                                " ",
                                                suggestedAircraft?.model
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                color: "text.secondary",
                                                fontSize: "0.7rem"
                                            },
                                            children: [
                                                "Score: ",
                                                score.toFixed(1),
                                                " (",
                                                confidenceLabel,
                                                " confidence)"
                                            ]
                                        }),
                                        faaModel && suggestedAircraft?.model && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            sx: {
                                                mt: 1,
                                                p: 1,
                                                bgcolor: "background.default",
                                                borderRadius: 1,
                                                border: 1,
                                                borderColor: "divider"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: "caption",
                                                    sx: {
                                                        color: "text.secondary",
                                                        display: "block",
                                                        fontSize: "0.65rem",
                                                        mb: 0.5
                                                    },
                                                    children: "Model Comparison:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    alignItems: "baseline",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                color: "text.secondary",
                                                                fontSize: "0.7rem",
                                                                minWidth: 50
                                                            },
                                                            children: "FAA:"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            sx: {
                                                                fontFamily: "monospace",
                                                                fontSize: "0.75rem"
                                                            },
                                                            children: faaModel
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    alignItems: "baseline",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                color: "text.secondary",
                                                                fontSize: "0.7rem",
                                                                minWidth: 50
                                                            },
                                                            children: "AirPlx:"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "body2",
                                                            sx: {
                                                                fontFamily: "monospace",
                                                                fontSize: "0.75rem"
                                                            },
                                                            children: calculateModelDiff(faaModel, suggestedAircraft.model).map((seg, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                                    component: "span",
                                                                    sx: {
                                                                        color: getDiffColor(seg.type),
                                                                        fontWeight: seg.type === "different" ? 700 : 400,
                                                                        textDecoration: seg.type === "different" ? "underline" : "none"
                                                                    },
                                                                    children: seg.text
                                                                }, idx))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    sx: {
                                                        mt: 0.5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                fontSize: "0.6rem",
                                                                color: "success.main"
                                                            },
                                                            children: "\u2713 match"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                fontSize: "0.6rem",
                                                                color: "warning.main"
                                                            },
                                                            children: "~ case"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                fontSize: "0.6rem",
                                                                color: "error.main"
                                                            },
                                                            children: "\u2717 different"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                breakdown && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        pt: 1,
                                        borderTop: 1,
                                        borderColor: "divider"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "caption",
                                            sx: {
                                                color: "text.secondary",
                                                display: "block",
                                                fontSize: "0.7rem",
                                                mb: 0.5
                                            },
                                            children: "Why this match?"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                fontSize: "0.75rem",
                                                fontStyle: "italic"
                                            },
                                            children: getMatchReason(breakdown)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    sx: {
                        my: 1.5
                    }
                }),
                breakdown && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            sx: {
                                mb: 0.5,
                                color: "text.secondary",
                                display: "block",
                                fontSize: "0.7rem"
                            },
                            children: "Match Quality Details:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            component: "ul",
                            sx: {
                                pl: 2,
                                my: 0.5,
                                fontSize: "0.7rem",
                                "& li": {
                                    mb: 0.25
                                }
                            },
                            children: [
                                breakdown.method === "csv-verified" && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "caption",
                                        sx: {
                                            color: "success.dark",
                                            fontWeight: 600,
                                            fontSize: "0.7rem"
                                        },
                                        children: "\u2713 Verified exact match"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    children: [
                                        "Manufacturer:",
                                        " ",
                                        breakdown.manufacturerScore >= 0.9 ? `${(breakdown.manufacturerScore * 100).toFixed(0)}% match \u{2713}` : breakdown.manufacturerScore >= 0.7 ? `${(breakdown.manufacturerScore * 100).toFixed(0)}% match ~` : "no match \u2717"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    children: [
                                        "Model:",
                                        " ",
                                        breakdown.modelScore === Infinity ? "no direct match" : `score ${breakdown.modelScore.toFixed(1)}`
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                suggestion.alternatives && suggestion.alternatives.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                            sx: {
                                my: 1.5
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            sx: {
                                mb: 1,
                                color: "text.secondary",
                                display: "block",
                                fontWeight: 600,
                                fontSize: "0.7rem"
                            },
                            children: "Other Possible Matches:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                            spacing: 0.75,
                            children: suggestion.alternatives.map((alt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        p: 1,
                                        bgcolor: "action.hover",
                                        borderRadius: 1,
                                        border: 1,
                                        borderColor: "divider",
                                        cursor: "pointer",
                                        "&:hover": {
                                            bgcolor: "action.selected",
                                            borderColor: "primary.main"
                                        }
                                    },
                                    onClick: ()=>onManualChange(alt.aircraft),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                component: "img",
                                                src: `/${alt.aircraft.id}.png`,
                                                sx: {
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 0.5,
                                                    objectFit: "cover"
                                                },
                                                onError: (e)=>{
                                                    e.currentTarget.style.display = "none";
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    flex: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        sx: {
                                                            fontWeight: 600,
                                                            fontSize: "0.75rem"
                                                        },
                                                        children: [
                                                            alt.aircraft.make,
                                                            " ",
                                                            alt.aircraft.model
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                        variant: "caption",
                                                        sx: {
                                                            color: "text.secondary",
                                                            fontSize: "0.65rem"
                                                        },
                                                        children: [
                                                            "Score: ",
                                                            alt.score.toFixed(1),
                                                            " \u2022 ",
                                                            alt.reason
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, alt.aircraft.id))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "caption",
                            sx: {
                                mt: 0.5,
                                display: "block",
                                fontSize: "0.6rem",
                                color: "text.secondary",
                                fontStyle: "italic"
                            },
                            children: "Click an alternative to select it"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    sx: {
                        my: 1.5
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "body2",
                    sx: {
                        fontStyle: "italic",
                        color: "text.secondary",
                        fontSize: "0.75rem"
                    },
                    children: "Click checkmark to approve, or manually select if incorrect"
                })
            ]
        });
    };
    // Show checkmark button only if there's a suggestion and no current mapping
    const showCheckmark = !currentMapping && suggestion?.confidence !== null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    flex: 1,
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTRQz.AutocompleteAircraft), {
                    label: "",
                    defaultSelected: defaultSelected,
                    shouldFlash: shouldFlash,
                    onSelect: handleManualChange
                })
            }),
            showCheckmark && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: getTooltipContent(),
                placement: "left",
                componentsProps: {
                    tooltip: {
                        sx: {
                            maxWidth: 500,
                            bgcolor: "background.paper",
                            color: "text.primary",
                            border: 1,
                            borderColor: "divider",
                            boxShadow: 3
                        }
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    size: "small",
                    color: getCheckmarkColor(),
                    onClick: handleApprove,
                    disabled: isApproving,
                    sx: {
                        flexShrink: 0,
                        "&:hover": {
                            transform: "scale(1.1)"
                        },
                        transition: "transform 0.2s"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmTQO))), {})
                })
            }),
            bulkApplyContext && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9e66727a1201d661$export$30e52911d7f982b0), {
                aircraftName: `${bulkApplyContext.aircraft.make} ${bulkApplyContext.aircraft.model}`,
                matchCount: bulkApplyContext.matchCount,
                onApply: bulkApplyContext.onApply,
                onDismiss: bulkApplyContext.onDismiss
            })
        ]
    });
};


const $27295743dd770d31$export$f4ea20e1570c61c3 = ()=>{
    const [query, setQuery] = $acw62.useState("");
    const [showOnlyUnmatched, setShowOnlyUnmatched] = $acw62.useState(false);
    const [showOnlyWithSuggestions, setShowOnlyWithSuggestions] = $acw62.useState(false);
    const [selectedCountry, setSelectedCountry] = $acw62.useState({
        country: "All Countries",
        prefix: ""
    });
    const [selectedManufacturer, setSelectedManufacturer] = $acw62.useState("All Manufacturers");
    const [approvedMappings, setApprovedMappings] = $acw62.useState(new Map());
    const [blacklistedRows, setBlacklistedRows] = $acw62.useState(new Set());
    // Bulk apply state
    const [bulkApplyAircraft, setBulkApplyAircraft] = $acw62.useState(null);
    const [bulkApplyRowKey, setBulkApplyRowKey] = $acw62.useState(null);
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    // Debounce timer for search input
    const debounceTimerRef = $acw62.useRef(null);
    // Debounced search handler (75ms delay)
    const handleSearchChange = $acw62.useCallback((value)=>{
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = setTimeout(()=>{
            // Normalize whitespace: trim and collapse multiple spaces to single space
            const normalized = value.replace(/\s+/g, " ").trim();
            setQuery(normalized);
        }, 75);
    }, []);
    // Cleanup debounce timer on unmount
    $acw62.useEffect(()=>{
        return ()=>{
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        };
    }, []);
    // Persistent cache for suggestion calculations (survives across filter changes)
    const suggestionCacheRef = $acw62.useRef(new Map());
    // Fetch aircraft with historical FAA mappings for intelligent suggestions
    const { aircraftWithHistory: aircraftWithHistory, csvMatcher: csvMatcher, loading: loadingAircraft } = (0, $b4695ffadadf5fb9$export$f71ad16b7a15ca64)();
    // Clear cache when aircraft data or matcher changes (ensures fresh suggestions)
    $acw62.useEffect(()=>{
        suggestionCacheRef.current.clear();
    }, [
        aircraftWithHistory,
        csvMatcher
    ]);
    // Fetch list of countries from registration prefixes
    const { value: countries } = (0, $2NPdf.default)(async ()=>{
        const { data: data } = await postgrest.from("aircraft_registration_prefixes").select("country, prefix").order("country");
        if (!data) return [];
        // Deduplicate by country (some countries have multiple prefixes)
        const uniqueCountries = Array.from(new Map(data.map((item)=>[
                item.country,
                item
            ])).values());
        return uniqueCountries;
    }, [
        postgrest
    ]);
    const [rowsRefreshKey, setRowsRefreshKey] = $acw62.useState(0);
    const { loading: loading, value: rows } = (0, $2NPdf.default)(async ()=>{
        const { data: data } = await postgrest.from("vw_faa_mapping").select();
        return data || [];
    }, [
        postgrest,
        rowsRefreshKey
    ]);
    // Fetch saved patterns
    const [patternsRefreshKey, setPatternsRefreshKey] = $acw62.useState(0);
    const { loading: loadingPatterns, value: patterns = [] } = (0, $2NPdf.default)(async ()=>{
        const { data: data } = await postgrest.from("vw_faa_mapping_patterns").select("*").order("created_at", {
            ascending: false
        }).limit(10);
        return data || [];
    }, [
        postgrest,
        patternsRefreshKey
    ]);
    // Helper function to format frequency display
    const formatFrequency = (row, selectedCountry)=>{
        const overall = row.freq || 0;
        // When "All Countries" is selected, just show overall
        if (selectedCountry.country === "All Countries") return overall.toString();
        // When country is selected, show: "countryCount (overall)"
        const countryCounts = row.country_counts;
        const countrySpecific = countryCounts?.[selectedCountry.country] || 0;
        return `${countrySpecific} (${overall})`;
    };
    const rowsToDisplay = $acw62.useMemo(()=>{
        if (!rows) return [];
        let filtered = rows.filter((row)=>{
            // Manufacturer filter
            if (selectedManufacturer !== "All Manufacturers") {
                if (row.faa_manufacturer !== selectedManufacturer) return false;
            }
            // Country filter
            if (selectedCountry.country !== "All Countries") {
                // Check if selected country is in the countries array
                const rowCountries = row.countries;
                if (!rowCountries || !rowCountries.includes(selectedCountry.country)) return false;
            }
            // Text search filter (client-side, combined search across manufacturer + model)
            if (query.trim() !== "") {
                const searchLower = query.toLowerCase();
                const manufacturerLower = row.faa_manufacturer.toLowerCase();
                const modelLower = row.faa_model.toLowerCase();
                const combined = `${manufacturerLower} ${modelLower}`;
                // Match if query appears in combined text (handles "Gulfstream Aerospace" matching both fields)
                const matchesCombined = combined.includes(searchLower);
                if (!matchesCombined) return false;
            }
            // Unmatched filter
            if (showOnlyUnmatched && row.aircraft_id) return false;
            return true;
        });
        // Sort by country-specific count when country filter is active
        if (selectedCountry.country !== "All Countries") filtered = [
            ...filtered
        ].sort((a, b)=>{
            const aCount = a.country_counts?.[selectedCountry.country] || 0;
            const bCount = b.country_counts?.[selectedCountry.country] || 0;
            return bCount - aCount; // Descending - highest country-specific count first
        });
        // else: keep default sort from view (by overall freq DESC)
        // Filter out locally blacklisted rows (optimistic UI)
        filtered = filtered.filter((row)=>{
            const key = `${row.faa_manufacturer}|${row.faa_model}`;
            return !blacklistedRows.has(key);
        });
        return filtered.slice(0, 100);
    }, [
        rows,
        query,
        showOnlyUnmatched,
        selectedCountry,
        selectedManufacturer,
        blacklistedRows
    ]);
    // Calculate suggestions for visible rows using persistent cache
    // Only calculates new suggestions that aren't already cached
    const suggestions = $acw62.useMemo(()=>{
        if (!aircraftWithHistory || !rowsToDisplay) return new Map();
        const cache = suggestionCacheRef.current;
        const map = new Map();
        rowsToDisplay.forEach((row)=>{
            const key = `${row.faa_manufacturer}|${row.faa_model}`;
            // Check cache first
            if (cache.has(key)) map.set(key, cache.get(key));
            else {
                // Calculate and cache new suggestion
                const suggestion = (0, $0b7d8c3925d2de62$export$15c516ff8a9e5edc)(row.faa_manufacturer, row.faa_model, aircraftWithHistory, csvMatcher);
                cache.set(key, suggestion);
                map.set(key, suggestion);
            }
        });
        return map;
    }, [
        rowsToDisplay,
        aircraftWithHistory,
        csvMatcher
    ]);
    // Apply suggestions filter if enabled (must happen after suggestions are calculated)
    const filteredRowsToDisplay = $acw62.useMemo(()=>{
        if (!showOnlyWithSuggestions) return rowsToDisplay;
        return rowsToDisplay.filter((row)=>{
            const key = `${row.faa_manufacturer}|${row.faa_model}`;
            const suggestion = suggestions.get(key);
            // Only show rows that have a valid suggestion (confidence is not null)
            return suggestion?.confidence !== null;
        });
    }, [
        rowsToDisplay,
        suggestions,
        showOnlyWithSuggestions
    ]);
    // Count of suggestions available (excluding already mapped/approved)
    const suggestionCount = $acw62.useMemo(()=>{
        let count = 0;
        filteredRowsToDisplay.forEach((row)=>{
            const key = `${row.faa_manufacturer}|${row.faa_model}`;
            const suggestion = suggestions.get(key);
            const hasExistingMapping = row.aircraft_id || approvedMappings.has(key);
            if (suggestion?.confidence !== null && !hasExistingMapping) count++;
        });
        return count;
    }, [
        suggestions,
        filteredRowsToDisplay,
        approvedMappings
    ]);
    // Calculate confidence level breakdown for suggestions
    const confidenceBreakdown = $acw62.useMemo(()=>{
        let high = 0;
        let medium = 0;
        filteredRowsToDisplay.forEach((row)=>{
            const key = `${row.faa_manufacturer}|${row.faa_model}`;
            const suggestion = suggestions.get(key);
            const hasExistingMapping = row.aircraft_id || approvedMappings.has(key);
            if (!hasExistingMapping && suggestion?.confidence) {
                if (suggestion.confidence === "high") high++;
                else if (suggestion.confidence === "medium") medium++;
            }
        });
        return {
            high: high,
            medium: medium
        };
    }, [
        suggestions,
        filteredRowsToDisplay,
        approvedMappings
    ]);
    // Calculate tail number coverage based on current filters
    const coverageStats = $acw62.useMemo(()=>{
        if (!rows) return null;
        // Apply same filters as rowsToDisplay (without 100-row limit)
        const filtered = rows.filter((row)=>{
            // Manufacturer filter
            if (selectedManufacturer !== "All Manufacturers") {
                if (row.faa_manufacturer !== selectedManufacturer) return false;
            }
            // Country filter
            if (selectedCountry.country !== "All Countries") {
                const rowCountries = row.countries;
                if (!rowCountries || !rowCountries.includes(selectedCountry.country)) return false;
            }
            // Text search filter (client-side, combined search across manufacturer + model)
            if (query.trim() !== "") {
                const searchLower = query.toLowerCase();
                const manufacturerLower = row.faa_manufacturer.toLowerCase();
                const modelLower = row.faa_model.toLowerCase();
                const combined = `${manufacturerLower} ${modelLower}`;
                // Match if query appears in combined text (handles "Gulfstream Aerospace" matching both fields)
                const matchesCombined = combined.includes(searchLower);
                if (!matchesCombined) return false;
            }
            // Unmatched filter
            if (showOnlyUnmatched && row.aircraft_id) return false;
            // Exclude blacklisted rows from statistics
            const key = `${row.faa_manufacturer}|${row.faa_model}`;
            if (blacklistedRows.has(key)) return false;
            return true;
        });
        const totalTails = filtered.reduce((sum, r)=>sum + (r.freq || 0), 0);
        const mappedTails = filtered.filter((r)=>{
            const key = `${r.faa_manufacturer}|${r.faa_model}`;
            // Count BOTH database mappings AND local approved mappings
            return r.aircraft_id || approvedMappings.has(key);
        }).reduce((sum, r)=>sum + (r.freq || 0), 0);
        const percentage = totalTails > 0 ? (mappedTails / totalTails * 100).toFixed(1) : "0.0";
        return {
            totalTails: totalTails,
            mappedTails: mappedTails,
            percentage: percentage
        };
    }, [
        rows,
        query,
        showOnlyUnmatched,
        selectedCountry,
        selectedManufacturer,
        approvedMappings,
        blacklistedRows
    ]);
    // Blacklist handler - optimistic UI update (no page reload)
    const handleBlacklist = async (row)=>{
        const key = `${row.faa_manufacturer}|${row.faa_model}`;
        // Optimistic update - hide row immediately
        setBlacklistedRows((prev)=>new Set(prev).add(key));
        try {
            await postgrest.from("faa_to_airplx").upsert({
                faa_manufacturer: row.faa_manufacturer,
                faa_model: row.faa_model,
                blacklisted: true
            }, {
                onConflict: "faa_manufacturer,faa_model"
            });
            snackbar.notify({
                text: `Blacklisted "${row.faa_manufacturer} ${row.faa_model}"`,
                severity: "warning"
            });
        } catch (error) {
            // Rollback on error - show row again
            setBlacklistedRows((prev)=>{
                const next = new Set(prev);
                next.delete(key);
                return next;
            });
            console.error("Failed to blacklist:", error);
            snackbar.notify({
                text: "Failed to blacklist. Please try again.",
                severity: "error"
            });
        }
    };
    // Bulk apply handlers
    const handleBulkApplyRequest = (aircraft, rowKey)=>{
        if (!query.trim()) return; // Only allow bulk apply when searching
        setBulkApplyAircraft(aircraft);
        setBulkApplyRowKey(rowKey);
    };
    const handleBulkApply = async ()=>{
        if (!bulkApplyAircraft || !airplxIdentity?.userid) return;
        try {
            const { data: data, error: error } = await postgrest.rpc("bulk_apply_faa_pattern", {
                p_search_query: query,
                p_aircraft_id: bulkApplyAircraft.id,
                p_user_id: airplxIdentity.userid
            });
            if (error) throw error;
            const result = data[0];
            snackbar.notify({
                text: `Applied ${result.applied_count} mappings (${result.skipped_count} skipped)`,
                severity: "success"
            });
            // Refresh patterns list
            setPatternsRefreshKey((k)=>k + 1);
            // Clear bulk apply state
            setBulkApplyAircraft(null);
            setBulkApplyRowKey(null);
            // Refresh rows to show updated mappings (preserves search/filter state)
            setRowsRefreshKey((k)=>k + 1);
        } catch (error) {
            console.error("Bulk apply failed:", error);
            snackbar.notify({
                text: `Bulk apply failed: ${error.message}`,
                severity: "error"
            });
        }
    };
    const handleBulkApplyDismiss = ()=>{
        setBulkApplyAircraft(null);
        setBulkApplyRowKey(null);
    };
    const handleReApplyPattern = async (pattern)=>{
        if (!airplxIdentity?.userid || !pattern.aircraft) return;
        try {
            const { data: data, error: error } = await postgrest.rpc("bulk_apply_faa_pattern", {
                p_search_query: pattern.search_query,
                p_aircraft_id: pattern.matched_aircraft_id,
                p_user_id: airplxIdentity.userid
            });
            if (error) throw error;
            const result = data[0];
            snackbar.notify({
                text: `Re-applied pattern "${pattern.search_query}": ${result.applied_count} mappings (${result.skipped_count} skipped)`,
                severity: "success"
            });
            // Refresh patterns list
            setPatternsRefreshKey((k)=>k + 1);
            // Refresh rows (preserves search/filter state)
            setRowsRefreshKey((k)=>k + 1);
        } catch (error) {
            console.error("Re-apply pattern failed:", error);
            snackbar.notify({
                text: `Re-apply failed: ${error.message}`,
                severity: "error"
            });
        }
    };
    const handleDeletePattern = async (patternId)=>{
        try {
            const { error: error } = await postgrest.from("faa_mapping_patterns").delete().eq("id", patternId);
            if (error) throw error;
            snackbar.notify({
                text: "Pattern deleted",
                severity: "success"
            });
            // Refresh patterns list
            setPatternsRefreshKey((k)=>k + 1);
        } catch (error) {
            console.error("Delete pattern failed:", error);
            snackbar.notify({
                text: `Delete failed: ${error.message}`,
                severity: "error"
            });
        }
    };
    // Function to render Aircraft cell with suggestions
    const renderAircraftCell = (row)=>{
        const key = `${row.faa_manufacturer}|${row.faa_model}`;
        // Check for existing mapping from database OR local approval state
        const currentMapping = row.aircraft_id ? {
            make: row.make,
            model: row.model,
            id: row.aircraft_id,
            linked_to: "",
            // Not included in view
            geom: null // Not included in view (not needed for mapping)
        } : approvedMappings.get(key) || null;
        const suggestion = suggestions.get(key) || null;
        const handleApprove = async (aircraft)=>{
            if (!aircraft || !aircraft.id) return;
            // Update database
            await postgrest.from("faa_to_airplx").update({
                matched_aircraft_id: aircraft.id
            }).eq("faa_model", row.faa_model).eq("faa_manufacturer", row.faa_manufacturer);
            // Update local state - this makes the checkmark disappear immediately
            setApprovedMappings((prev)=>{
                const next = new Map(prev);
                next.set(key, aircraft);
                return next;
            });
        };
        const handleManualChange = async (aircraft)=>{
            if (!aircraft || !aircraft.id) return;
            // Update database
            await postgrest.from("faa_to_airplx").update({
                matched_aircraft_id: aircraft.id
            }).eq("faa_model", row.faa_model).eq("faa_manufacturer", row.faa_manufacturer);
            // Update local state
            setApprovedMappings((prev)=>{
                const next = new Map(prev);
                next.set(key, aircraft);
                return next;
            });
        };
        // Calculate bulk apply context if applicable
        const bulkApplyContext = bulkApplyAircraft && bulkApplyRowKey === key && query.trim() ? {
            aircraft: bulkApplyAircraft,
            matchCount: filteredRowsToDisplay.filter((r)=>!r.aircraft_id && !approvedMappings.has(`${r.faa_manufacturer}|${r.faa_model}`)).length,
            onApply: handleBulkApply,
            onDismiss: handleBulkApplyDismiss
        } : null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $012ccf33f2b0276f$export$f2b59a177e463cba), {
            suggestion: suggestion,
            currentMapping: currentMapping,
            faaManufacturer: row.faa_manufacturer,
            faaModel: row.faa_model,
            onApprove: handleApprove,
            onManualChange: handleManualChange,
            onBulkApplyRequest: (aircraft)=>handleBulkApplyRequest(aircraft, key),
            bulkApplyContext: bulkApplyContext
        }, key);
    };
    // Extract unique manufacturers from rows for the filter dropdown
    // Must be called before early returns to follow Rules of Hooks
    const manufacturers = $acw62.useMemo(()=>{
        if (!rows) return [];
        const uniqueManufacturers = new Set();
        rows.forEach((row)=>{
            if (row.faa_manufacturer) uniqueManufacturers.add(row.faa_manufacturer);
        });
        return Array.from(uniqueManufacturers).sort();
    }, [
        rows
    ]);
    // Only show full-page loading on initial load (when no data exists yet)
    if (loading && !rows || loadingAircraft) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {})
    });
    const countryOptions = [
        {
            country: "All Countries",
            prefix: ""
        },
        ...countries || []
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 2,
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $294f423e61f44b59$export$40e5ba8bd6a5d06e), {
                patterns: patterns,
                loading: loadingPatterns,
                onReApply: handleReApplyPattern,
                onDelete: handleDeletePattern
            }),
            coverageStats && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: "body2",
                    color: "text.secondary",
                    sx: {
                        fontWeight: 500
                    },
                    children: [
                        "Coverage: ",
                        coverageStats.percentage,
                        "% (",
                        coverageStats.mappedTails.toLocaleString(),
                        " /",
                        " ",
                        coverageStats.totalTails.toLocaleString(),
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        size: "small",
                        label: "Search by FAA Manufacturer or Model",
                        onChange: (evt)=>handleSearchChange(evt.target.value),
                        variant: "outlined",
                        sx: {
                            width: 400
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                        size: "small",
                        options: [
                            "All Manufacturers",
                            ...manufacturers
                        ],
                        value: selectedManufacturer,
                        onChange: (_, value)=>setSelectedManufacturer(value || "All Manufacturers"),
                        getOptionLabel: (option)=>option,
                        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                ...params,
                                label: "Manufacturer"
                            }),
                        ListboxProps: {
                            style: {
                                maxHeight: "40vh"
                            }
                        },
                        sx: {
                            width: 250
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                        size: "small",
                        options: countryOptions,
                        value: selectedCountry,
                        onChange: (_, value)=>{
                            if (value) setSelectedCountry(value);
                        },
                        getOptionLabel: (option)=>option.country === "All Countries" ? "All" : `${(0, $86dca4a6955b79de$export$fd5d2cd02be3d52a)(option.country)} ${option.country.substring(0, 15)}`,
                        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                ...params,
                                label: "Country"
                            }),
                        isOptionEqualToValue: (option, value)=>option.country === value.country,
                        sx: {
                            width: 250
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                            checked: showOnlyUnmatched,
                            onChange: (e)=>setShowOnlyUnmatched(e.target.checked)
                        }),
                        label: "Unmatched",
                        sx: {
                            width: 140
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s24a.default), {
                            checked: showOnlyWithSuggestions,
                            onChange: (e)=>setShowOnlyWithSuggestions(e.target.checked)
                        }),
                        label: "With Suggestions",
                        sx: {
                            width: 180,
                            whiteSpace: "nowrap"
                        }
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                sx: {
                    maxHeight: 750
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                    size: "small",
                    stickyHeader: true,
                    "aria-label": "FAA aircraft mapping table",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        width: 150,
                                        sx: {
                                            backgroundColor: "background.paper",
                                            zIndex: 100,
                                            borderBottom: 2,
                                            borderColor: "divider"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.5,
                                            children: [
                                                "Frequency",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: selectedCountry.country === "All Countries" ? "Total number of registered tail numbers for this aircraft type" : `Format: "countryCount (totalCount)" - Showing ${selectedCountry.country} registrations with worldwide total in parentheses. Sorted by ${selectedCountry.country} count.`,
                                                    arrow: true,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                        size: "small",
                                                        sx: {
                                                            padding: 0
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                                            fontSize: "small",
                                                            sx: {
                                                                fontSize: 16
                                                            }
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        width: 200,
                                        sx: {
                                            backgroundColor: "background.paper",
                                            zIndex: 100,
                                            borderBottom: 2,
                                            borderColor: "divider"
                                        },
                                        children: "FAA Manufacturer"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        width: 200,
                                        sx: {
                                            backgroundColor: "background.paper",
                                            zIndex: 100,
                                            borderBottom: 2,
                                            borderColor: "divider"
                                        },
                                        children: "FAA Model"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        width: 300,
                                        sx: {
                                            backgroundColor: "background.paper",
                                            zIndex: 100,
                                            borderBottom: 2,
                                            borderColor: "divider"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            children: [
                                                "AirPlx Aircraft",
                                                suggestionCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                                                    badgeContent: suggestionCount,
                                                    color: "success",
                                                    sx: {
                                                        "& .MuiBadge-badge": {
                                                            fontSize: "0.7rem",
                                                            height: "18px",
                                                            minWidth: "18px"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                            sx: {
                                                                p: 1,
                                                                minWidth: 240
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        fontWeight: 600,
                                                                        mb: 1
                                                                    },
                                                                    children: [
                                                                        "Intelligent Suggestions (",
                                                                        suggestionCount,
                                                                        ")"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                                    sx: {
                                                                        mb: 1
                                                                    }
                                                                }),
                                                                confidenceBreakdown.high > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                    sx: {
                                                                        mb: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                            sx: {
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                mb: 0.25
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                                                    sx: {
                                                                                        width: 8,
                                                                                        height: 8,
                                                                                        borderRadius: "50%",
                                                                                        bgcolor: "success.main",
                                                                                        mr: 1
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                    variant: "body2",
                                                                                    sx: {
                                                                                        flex: 1
                                                                                    },
                                                                                    children: "High Confidence"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                    variant: "body2",
                                                                                    sx: {
                                                                                        fontWeight: 600
                                                                                    },
                                                                                    children: confidenceBreakdown.high
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                            variant: "caption",
                                                                            sx: {
                                                                                color: "text.secondary",
                                                                                pl: 2.5,
                                                                                display: "block"
                                                                            },
                                                                            children: "CSV verified exact matches"
                                                                        })
                                                                    ]
                                                                }),
                                                                confidenceBreakdown.medium > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                    sx: {
                                                                        mb: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                                            sx: {
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                mb: 0.25
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                                                    sx: {
                                                                                        width: 8,
                                                                                        height: 8,
                                                                                        borderRadius: "50%",
                                                                                        bgcolor: "warning.main",
                                                                                        mr: 1
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                    variant: "body2",
                                                                                    sx: {
                                                                                        flex: 1
                                                                                    },
                                                                                    children: "Medium Confidence"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                                    variant: "body2",
                                                                                    sx: {
                                                                                        fontWeight: 600
                                                                                    },
                                                                                    children: confidenceBreakdown.medium
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                            variant: "caption",
                                                                            sx: {
                                                                                color: "text.secondary",
                                                                                pl: 2.5,
                                                                                display: "block"
                                                                            },
                                                                            children: "Fuzzy matches - review carefully"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                                    sx: {
                                                                        my: 1
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: "caption",
                                                                    sx: {
                                                                        color: "text.secondary",
                                                                        fontStyle: "italic"
                                                                    },
                                                                    children: "Click checkmarks to review and apply"
                                                                })
                                                            ]
                                                        }),
                                                        arrow: true,
                                                        placement: "bottom",
                                                        componentsProps: {
                                                            tooltip: {
                                                                sx: {
                                                                    bgcolor: "background.paper",
                                                                    color: "text.primary",
                                                                    border: 1,
                                                                    borderColor: "divider",
                                                                    boxShadow: 3
                                                                }
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                            size: "small",
                                                            sx: {
                                                                padding: 0
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                                                fontSize: "small",
                                                                sx: {
                                                                    fontSize: 16
                                                                }
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                        align: "center",
                                        width: 60,
                                        sx: {
                                            backgroundColor: "background.paper",
                                            zIndex: 100,
                                            borderBottom: 2,
                                            borderColor: "divider"
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                            children: filteredRowsToDisplay.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: formatFrequency(row, selectedCountry)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: row.faa_manufacturer
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: row.faa_model
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            children: renderAircraftCell(row)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            align: "center",
                                            children: !row.aircraft_id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                title: "Blacklist this FAA type (drones, balloons, etc.)",
                                                placement: "left",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                    size: "small",
                                                    onClick: ()=>handleBlacklist(row),
                                                    sx: {
                                                        opacity: 0.5,
                                                        "&:hover": {
                                                            opacity: 1,
                                                            color: "error.main"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2KvQo))), {
                                                        fontSize: "small"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }, row.faa_model + row.faa_manufacturer))
                        })
                    ]
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $1MdOk = parcelRequire("1MdOk");

var $03mUs = parcelRequire("03mUs");
var $9Lykx = parcelRequire("9Lykx");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");
/**
 * Blacklist tab - shows FAA types that have been ignored (drones, balloons, etc.)
 * Allows restoring blacklisted records back to the main mapping view.
 */ // Common styling for sticky table headers
const $7426fb90b10aaca4$var$headerCellSx = {
    backgroundColor: "background.paper",
    fontWeight: 600,
    borderBottom: 2,
    borderColor: "divider"
};
const $7426fb90b10aaca4$export$44744f4b08aba423 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { loading: loading, value: blacklisted } = (0, $2NPdf.default)(async ()=>{
        const { data: data, error: error } = await postgrest.from("faa_to_airplx").select("faa_manufacturer,faa_model").eq("blacklisted", true).order("faa_manufacturer").order("faa_model");
        if (error) {
            console.error("Failed to fetch blacklisted records:", error);
            return [];
        }
        return data || [];
    }, [
        postgrest
    ]);
    const [restoredRows, setRestoredRows] = $acw62.useState(new Set());
    const handleRestore = async (item)=>{
        const key = `${item.faa_manufacturer}|${item.faa_model}`;
        // Optimistic update - hide row immediately
        setRestoredRows((prev)=>new Set(prev).add(key));
        try {
            await postgrest.from("faa_to_airplx").update({
                blacklisted: false
            }).eq("faa_manufacturer", item.faa_manufacturer).eq("faa_model", item.faa_model);
            snackbar.notify({
                text: `Restored "${item.faa_manufacturer} ${item.faa_model}"`,
                severity: "success"
            });
        } catch (error) {
            // Rollback on error - show row again
            setRestoredRows((prev)=>{
                const next = new Set(prev);
                next.delete(key);
                return next;
            });
            console.error("Failed to restore:", error);
            snackbar.notify({
                text: "Failed to restore. Please try again.",
                severity: "error"
            });
        }
    };
    // Filter out restored rows for optimistic UI
    const displayedBlacklist = $acw62.useMemo(()=>{
        if (!blacklisted) return [];
        return blacklisted.filter((item)=>{
            const key = `${item.faa_manufacturer}|${item.faa_model}`;
            return !restoredRows.has(key);
        });
    }, [
        blacklisted,
        restoredRows
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {})
    });
    if (!displayedBlacklist || displayedBlacklist.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: "body1",
            color: "text.secondary",
            children: 'No blacklisted FAA types. Use the "Ignore" button on the Aircraft Mapping tab to blacklist irrelevant aircraft types (drones, balloons, etc.)'
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
        sx: {
            maxHeight: "calc(100vh - 250px)"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
            stickyHeader: true,
            size: "small",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                sx: $7426fb90b10aaca4$var$headerCellSx,
                                children: "FAA Manufacturer"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                sx: $7426fb90b10aaca4$var$headerCellSx,
                                children: "FAA Model"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "center",
                                width: 100,
                                sx: $7426fb90b10aaca4$var$headerCellSx,
                                children: "Restore"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                    children: displayedBlacklist.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                            sx: {
                                "&:hover": {
                                    backgroundColor: "action.hover"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: item.faa_manufacturer
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: item.faa_model
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: "Restore this FAA type to Aircraft Mapping tab",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                            size: "small",
                                            onClick: ()=>handleRestore(item),
                                            color: "primary",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {
                                                fontSize: "small"
                                            })
                                        })
                                    })
                                })
                            ]
                        }, `${item.faa_manufacturer}|${item.faa_model}`))
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $1MdOk = parcelRequire("1MdOk");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $5WjaY = parcelRequire("5WjaY");
var $3ulHf = parcelRequire("3ulHf");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $eFqab = parcelRequire("eFqab");
var $ejcfT = parcelRequire("ejcfT");
var $9Lykx = parcelRequire("9Lykx");
var $7Frhn = parcelRequire("7Frhn");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $gqehT = parcelRequire("gqehT");

var $6fDLr = parcelRequire("6fDLr");
const $37011361996a2ccc$export$b07073aab83e6395 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { identity: identity, airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    // Form state
    const [formData, setFormData] = $acw62.useState({
        tailNumber: "",
        manufacturer: "",
        model: ""
    });
    const [errors, setErrors] = $acw62.useState({});
    const [isSubmitting, setIsSubmitting] = $acw62.useState(false);
    const [recentlyAdded, setRecentlyAdded] = $acw62.useState([]);
    // Delete confirmation dialog state
    const [deleteDialogOpen, setDeleteDialogOpen] = $acw62.useState(false);
    const [deleteConfirmText, setDeleteConfirmText] = $acw62.useState("");
    const [tailNumberToDelete, setTailNumberToDelete] = $acw62.useState(null);
    const [isDeleting, setIsDeleting] = $acw62.useState(false);
    // Validation function
    const validateForm = ()=>{
        const newErrors = {};
        // Tail number validation
        const tailNumber = formData.tailNumber.trim().toUpperCase();
        if (!tailNumber) newErrors.tailNumber = "Tail number is required";
        else if (!/^[A-Z0-9\-]+$/.test(tailNumber)) newErrors.tailNumber = "Tail number must contain only letters, numbers, and hyphens";
        else if (tailNumber.length < 2 || tailNumber.length > 10) newErrors.tailNumber = "Tail number must be between 2 and 10 characters";
        // Manufacturer validation
        const manufacturer = formData.manufacturer.trim();
        if (!manufacturer) newErrors.manufacturer = "Manufacturer is required";
        else if (manufacturer.length < 2 || manufacturer.length > 100) newErrors.manufacturer = "Manufacturer must be between 2 and 100 characters";
        // Model validation
        const model = formData.model.trim();
        if (!model) newErrors.model = "Model is required";
        else if (model.length < 1 || model.length > 100) newErrors.model = "Model must be between 1 and 100 characters";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // Handle form field changes
    const handleFieldChange = (field)=>(event)=>{
            setFormData((prev)=>({
                    ...prev,
                    [field]: event.target.value
                }));
            // Clear error for this field when user types
            setErrors((prev)=>({
                    ...prev,
                    [field]: undefined
                }));
        };
    // Handle form submission
    const handleSubmit = async (event)=>{
        event.preventDefault();
        // Validate form
        if (!validateForm()) return;
        setIsSubmitting(true);
        try {
            const tailNumber = formData.tailNumber.trim().toUpperCase();
            const manufacturer = formData.manufacturer.trim().toUpperCase();
            const model = formData.model.trim().toUpperCase();
            // Check if tail number already exists
            const { data: existingData, error: checkError } = await postgrest.from("faa_tail_numbers").select("tail_number").eq("tail_number", tailNumber).single();
            if (existingData && !checkError) {
                snackbar.notify({
                    text: `Tail number ${tailNumber} already exists in the database`,
                    severity: "error"
                });
                setIsSubmitting(false);
                return;
            }
            // Insert new tail number with current user ID
            const { data: insertData, error: insertError } = await postgrest.from("faa_tail_numbers").insert({
                tail_number: tailNumber,
                manufacturer: manufacturer,
                model: model,
                added_by_user_id: airplxIdentity.userid || null // Set current user's ID
            }).select("*, users!faa_tail_numbers_added_by_user_id_fkey(email)").single();
            if (insertError) {
                // Handle specific error cases
                if (insertError.code === "23505") // Unique constraint violation
                snackbar.notify({
                    text: `Tail number ${tailNumber} already exists`,
                    severity: "error"
                });
                else if (insertError.code === "42501") // Permission denied
                snackbar.notify({
                    text: "You don't have permission to add tail numbers",
                    severity: "error"
                });
                else snackbar.notify({
                    text: `Failed to add tail number: ${insertError.message}`,
                    severity: "error"
                });
            } else {
                // Success
                snackbar.notify({
                    text: `Successfully added tail number ${tailNumber}`,
                    severity: "success"
                });
                // Add to recently added list with user information
                setRecentlyAdded((prev)=>[
                        {
                            tail_number: tailNumber,
                            manufacturer: manufacturer,
                            model: model,
                            created_at: new Date().toISOString(),
                            added_by_user_id: insertData?.added_by_user_id || null,
                            users: insertData?.users || null
                        },
                        ...prev.slice(0, 9) // Keep only last 10 entries
                    ]);
                // Clear form
                setFormData({
                    tailNumber: "",
                    manufacturer: "",
                    model: ""
                });
            }
        } catch (error) {
            console.error("Error adding tail number:", error);
            snackbar.notify({
                text: error instanceof Error ? `Error: ${error.message}` : "An unexpected error occurred",
                severity: "error"
            });
        } finally{
            setIsSubmitting(false);
        }
    };
    // Handle delete button click
    const handleDeleteClick = (tailNumber)=>{
        setTailNumberToDelete(tailNumber);
        setDeleteDialogOpen(true);
        setDeleteConfirmText("");
    };
    // Handle delete confirmation
    const handleDeleteConfirm = async ()=>{
        if (!tailNumberToDelete || deleteConfirmText.toLowerCase() !== "delete") return;
        setIsDeleting(true);
        try {
            const { error: error } = await postgrest.from("faa_tail_numbers").delete().eq("tail_number", tailNumberToDelete);
            if (error) snackbar.notify({
                text: `Failed to delete tail number: ${error.message}`,
                severity: "error"
            });
            else {
                snackbar.notify({
                    text: `Successfully deleted tail number ${tailNumberToDelete}`,
                    severity: "success"
                });
                // Remove from recently added list
                setRecentlyAdded((prev)=>prev.filter((entry)=>entry.tail_number !== tailNumberToDelete));
            }
        } catch (error) {
            console.error("Error deleting tail number:", error);
            snackbar.notify({
                text: error instanceof Error ? `Error: ${error.message}` : "An unexpected error occurred while deleting",
                severity: "error"
            });
        } finally{
            setIsDeleting(false);
            setDeleteDialogOpen(false);
            setTailNumberToDelete(null);
            setDeleteConfirmText("");
        }
    };
    // Handle delete dialog close
    const handleDeleteCancel = ()=>{
        setDeleteDialogOpen(false);
        setTailNumberToDelete(null);
        setDeleteConfirmText("");
    };
    // Load recently added tail numbers on mount
    $acw62.useEffect(()=>{
        const loadRecentEntries = async ()=>{
            try {
                const { data: data, error: error } = await postgrest.from("faa_tail_numbers").select("tail_number, manufacturer, model, created_at, added_by_user_id, users!faa_tail_numbers_added_by_user_id_fkey(email)").order("created_at", {
                    ascending: false
                }).limit(10);
                if (data && !error) setRecentlyAdded(data);
            } catch (error) {
                console.error("Error loading recent entries:", error);
            }
        };
        loadRecentEntries();
    }, [
        postgrest
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 3,
        sx: {
            p: 2,
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h6",
                color: "text.primary",
                children: "Manually Add FAA Tail Number"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
                elevation: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ulHf.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: "Add a new tail number to the FAA database. This is useful for aircraft not yet in the FAA registry."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "Tail Number",
                                            placeholder: "N12345",
                                            value: formData.tailNumber,
                                            onChange: handleFieldChange("tailNumber"),
                                            error: !!errors.tailNumber,
                                            helperText: errors.tailNumber,
                                            size: "small",
                                            sx: {
                                                width: 200
                                            },
                                            disabled: isSubmitting,
                                            inputProps: {
                                                maxLength: 10,
                                                style: {
                                                    textTransform: "uppercase"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "Manufacturer",
                                            placeholder: "CESSNA",
                                            value: formData.manufacturer,
                                            onChange: handleFieldChange("manufacturer"),
                                            error: !!errors.manufacturer,
                                            helperText: errors.manufacturer,
                                            size: "small",
                                            sx: {
                                                width: 250
                                            },
                                            disabled: isSubmitting,
                                            inputProps: {
                                                maxLength: 100,
                                                style: {
                                                    textTransform: "uppercase"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "Model",
                                            placeholder: "172S",
                                            value: formData.model,
                                            onChange: handleFieldChange("model"),
                                            error: !!errors.model,
                                            helperText: errors.model,
                                            size: "small",
                                            sx: {
                                                width: 250
                                            },
                                            disabled: isSubmitting,
                                            inputProps: {
                                                maxLength: 100,
                                                style: {
                                                    textTransform: "uppercase"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            type: "submit",
                                            variant: "contained",
                                            startIcon: isSubmitting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                                size: 20
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                            disabled: isSubmitting,
                                            sx: {
                                                height: 40,
                                                mt: 0.5
                                            },
                                            children: isSubmitting ? "Adding..." : "Add Tail Number"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7Frhn.default), {
                elevation: 1,
                sx: {
                    flexGrow: 1,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            p: 2,
                            borderBottom: 1,
                            borderColor: "divider"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "subtitle1",
                            fontWeight: "medium",
                            children: "Recently Added Tail Numbers"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
                        sx: {
                            flexGrow: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                            size: "small",
                            stickyHeader: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                sx: {
                                                    backgroundColor: "background.paper",
                                                    fontWeight: "bold"
                                                },
                                                children: "Tail Number"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                sx: {
                                                    backgroundColor: "background.paper",
                                                    fontWeight: "bold"
                                                },
                                                children: "Manufacturer"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                sx: {
                                                    backgroundColor: "background.paper",
                                                    fontWeight: "bold"
                                                },
                                                children: "Model"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                sx: {
                                                    backgroundColor: "background.paper",
                                                    fontWeight: "bold"
                                                },
                                                children: "Source"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                sx: {
                                                    backgroundColor: "background.paper",
                                                    fontWeight: "bold"
                                                },
                                                children: "Added"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                sx: {
                                                    backgroundColor: "background.paper",
                                                    fontWeight: "bold",
                                                    width: 80
                                                },
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                    children: recentlyAdded.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2XjE0.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                            colSpan: 6,
                                            align: "center",
                                            sx: {
                                                py: 4
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                children: "No recently added tail numbers"
                                            })
                                        })
                                    }) : recentlyAdded.map((entry)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        fontWeight: "medium",
                                                        children: entry.tail_number
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                    children: entry.manufacturer
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                    children: entry.model
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                    children: entry.added_by_user_id && entry.users?.email ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        color: "text.primary",
                                                        children: entry.users.email
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: "body2",
                                                        color: "text.secondary",
                                                        sx: {
                                                            fontStyle: "italic"
                                                        },
                                                        children: "FAA Import"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                    children: entry.created_at ? new Date(entry.created_at).toLocaleString("en-US", {
                                                        dateStyle: "short",
                                                        timeStyle: "short"
                                                    }) : "Just now"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                        size: "small",
                                                        onClick: ()=>handleDeleteClick(entry.tail_number),
                                                        sx: {
                                                            color: "error.main"
                                                        },
                                                        title: `Delete tail number ${entry.tail_number}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {
                                                            fontSize: "small"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, entry.tail_number))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: deleteDialogOpen,
                onClose: handleDeleteCancel,
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Delete Tail Number"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eFqab.default), {
                                sx: {
                                    mb: 2
                                },
                                children: [
                                    "Are you sure you want to delete tail number",
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: tailNumberToDelete
                                    }),
                                    "? This action cannot be undone."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eFqab.default), {
                                sx: {
                                    mb: 2
                                },
                                children: [
                                    "To confirm deletion, please type ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: '"delete"'
                                    }),
                                    " in the field below:"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                fullWidth: true,
                                placeholder: "Type 'delete' to confirm",
                                value: deleteConfirmText,
                                onChange: (e)=>setDeleteConfirmText(e.target.value),
                                size: "small",
                                error: deleteConfirmText !== "" && deleteConfirmText.toLowerCase() !== "delete",
                                helperText: deleteConfirmText !== "" && deleteConfirmText.toLowerCase() !== "delete" ? "Please type 'delete' exactly" : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleDeleteCancel,
                                disabled: isDeleting,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleDeleteConfirm,
                                color: "error",
                                variant: "contained",
                                disabled: isDeleting || deleteConfirmText.toLowerCase() !== "delete",
                                startIcon: isDeleting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 16
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {}),
                                children: isDeleting ? "Deleting..." : "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $1MdOk = parcelRequire("1MdOk");

var $03mUs = parcelRequire("03mUs");
var $9Lykx = parcelRequire("9Lykx");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $2LXej = parcelRequire("2LXej");

var $6fDLr = parcelRequire("6fDLr");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");

var $c50C8 = parcelRequire("c50C8");

var $fqtQp = parcelRequire("fqtQp");
function $e960d8d8a5def06b$export$d130c20a256f8817(date, options) {
    return (0, $fqtQp.formatDistance)(date, (0, $c50C8.constructNow)(date), options);
}
var // Fallback for modularized imports:
$e960d8d8a5def06b$export$2e2bcd8739ae039 = $e960d8d8a5def06b$export$d130c20a256f8817;


/**
 * Tail Requests tab - shows pending tail number requests from users
 * Allows dismissing requests that have been handled or are not relevant.
 */ // Common styling for sticky table headers
const $a8d67170a4e8e046$var$headerCellSx = {
    backgroundColor: "background.paper",
    fontWeight: 600,
    borderBottom: 2,
    borderColor: "divider"
};
const $a8d67170a4e8e046$export$3206efbac41a4ae0 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const snackbar = (0, $6fDLr.useSnackbar)();
    const { loading: loading, value: requests } = (0, $2NPdf.default)(async ()=>{
        const { data: data, error: error } = await postgrest.from("tail_number_requests").select("id,tail_number,requested_at,fbo(name),users(email)").eq("status", "pending").order("requested_at", {
            ascending: false
        });
        if (error) {
            console.error("Failed to fetch tail number requests:", error);
            return [];
        }
        return data || [];
    }, [
        postgrest
    ]);
    const [dismissedIds, setDismissedIds] = $acw62.useState(new Set());
    const handleDismiss = async (request)=>{
        // Optimistic update - hide row immediately
        setDismissedIds((prev)=>new Set(prev).add(request.id));
        try {
            const { error: error } = await postgrest.from("tail_number_requests").update({
                status: "dismissed"
            }).eq("id", request.id);
            if (error) throw error;
            snackbar.notify({
                text: `Dismissed request for "${request.tail_number}"`,
                severity: "success"
            });
        } catch (error) {
            // Rollback on error - show row again
            setDismissedIds((prev)=>{
                const next = new Set(prev);
                next.delete(request.id);
                return next;
            });
            console.error("Failed to dismiss request:", error);
            snackbar.notify({
                text: "Failed to dismiss request. Please try again.",
                severity: "error"
            });
        }
    };
    // Filter out dismissed requests for optimistic UI
    const displayedRequests = $acw62.useMemo(()=>{
        if (!requests) return [];
        return requests.filter((request)=>!dismissedIds.has(request.id));
    }, [
        requests,
        dismissedIds
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {})
    });
    if (!displayedRequests || displayedRequests.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: "body1",
            color: "text.secondary",
            children: "No pending tail number requests"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
        sx: {
            maxHeight: "calc(100vh - 250px)"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
            stickyHeader: true,
            size: "small",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                sx: $a8d67170a4e8e046$var$headerCellSx,
                                children: "Tail Number"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                sx: $a8d67170a4e8e046$var$headerCellSx,
                                children: "FBO Name"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                sx: $a8d67170a4e8e046$var$headerCellSx,
                                children: "Requested By"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                sx: $a8d67170a4e8e046$var$headerCellSx,
                                children: "Requested At"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "center",
                                width: 100,
                                sx: $a8d67170a4e8e046$var$headerCellSx,
                                children: "Actions"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                    children: displayedRequests.map((request)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                            sx: {
                                "&:hover": {
                                    backgroundColor: "action.hover"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: request.tail_number
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: request.fbo?.name || "Unknown"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: request.users?.email || "Unknown"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: (0, $e960d8d8a5def06b$export$d130c20a256f8817)(new Date(request.requested_at), {
                                        addSuffix: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: "Dismiss this request",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                            size: "small",
                                            onClick: ()=>handleDismiss(request),
                                            color: "error",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {
                                                fontSize: "small"
                                            })
                                        })
                                    })
                                })
                            ]
                        }, request.id))
                })
            ]
        })
    });
};


function $70af75c933722976$var$CustomTabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `faa-mapping-tabpanel-${index}`,
        "aria-labelledby": `faa-mapping-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
            sx: {
                pt: 2
            },
            children: children
        })
    });
}
function $70af75c933722976$var$a11yProps(index) {
    return {
        id: `faa-mapping-tab-${index}`,
        'aria-controls': `faa-mapping-tabpanel-${index}`
    };
}
const $70af75c933722976$export$c2d31d5d5b22613a = ()=>{
    const [activeTab, setActiveTab] = $acw62.useState(0);
    const handleTabChange = (event, newValue)=>{
        setActiveTab(newValue);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 0,
        width: "100%",
        sx: {
            height: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    borderBottom: 1,
                    borderColor: 'divider',
                    px: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                    value: activeTab,
                    onChange: handleTabChange,
                    "aria-label": "FAA mapping tabs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                            label: "Aircraft Mapping",
                            ...$70af75c933722976$var$a11yProps(0),
                            sx: {
                                textTransform: 'none',
                                fontWeight: 'medium'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                            label: "Tail Manual Add",
                            ...$70af75c933722976$var$a11yProps(1),
                            sx: {
                                textTransform: 'none',
                                fontWeight: 'medium'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                            label: "Blacklist",
                            ...$70af75c933722976$var$a11yProps(2),
                            sx: {
                                textTransform: 'none',
                                fontWeight: 'medium'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                            label: "Tail Requests",
                            ...$70af75c933722976$var$a11yProps(3),
                            sx: {
                                textTransform: 'none',
                                fontWeight: 'medium'
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    flexGrow: 1,
                    overflow: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($70af75c933722976$var$CustomTabPanel, {
                        value: activeTab,
                        index: 0,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $27295743dd770d31$export$f4ea20e1570c61c3), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($70af75c933722976$var$CustomTabPanel, {
                        value: activeTab,
                        index: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37011361996a2ccc$export$b07073aab83e6395), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($70af75c933722976$var$CustomTabPanel, {
                        value: activeTab,
                        index: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7426fb90b10aaca4$export$44744f4b08aba423), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($70af75c933722976$var$CustomTabPanel, {
                        value: activeTab,
                        index: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8d67170a4e8e046$export$3206efbac41a4ae0), {})
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $lkxXU = parcelRequire("lkxXU");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $cLNZr = parcelRequire("cLNZr");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $lNEp2 = parcelRequire("lNEp2");

var $ayMG0 = parcelRequire("ayMG0");

var $eBnBM = parcelRequire("eBnBM");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $eFqab = parcelRequire("eFqab");
var $ejcfT = parcelRequire("ejcfT");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $btULL = parcelRequire("btULL");
const $4bc148abb05f558b$export$21f0333ea0618bd2 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [open, setOpen] = $acw62.useState(false);
    const [email, setEmail] = $acw62.useState("");
    const [name, setName] = $acw62.useState("");
    const [inviteURL, setInviteURL] = $acw62.useState("");
    $acw62.useEffect(()=>{
        setName("");
        setEmail("");
        setInviteURL("");
    }, [
        open
    ]);
    const onClickAdd = async ()=>{
        if (!name || !email) return;
        const { data: newFbo } = await postgrest.from("fbo").insert({
            name: name,
            // Default FBO Settings - Complete permission set for all roles
            settings: {
                // View-only mode (all roles default to false = can edit)
                viewOnlyForFBOAdmin: false,
                viewOnlyForManager: false,
                viewOnlyForOperator: false,
                viewOnlyForCSR: false,
                // Display estimated value (FBOAdmin/Manager see, Operator/CSR don't)
                displayEstimatedValueForFBOAdmin: true,
                displayEstimatedValueForManager: true,
                displayEstimatedValueForOperator: false,
                displayEstimatedValueForCSR: false,
                // Team management (FBOAdmin/Manager can, Operator/CSR cannot)
                addTeamMembersForFBOAdmin: true,
                addTeamMembersForManager: true,
                addTeamMembersForOperator: false,
                addTeamMembersForCSR: false,
                // Tenant modification (FBOAdmin/Manager/Operator can, CSR cannot)
                modifyTenantsForFBOAdmin: true,
                modifyTenantsForManager: true,
                modifyTenantsForOperator: true,
                modifyTenantsForCSR: false,
                // Layout modification (all roles can modify)
                modifyLayoutForFBOAdmin: true,
                modifyLayoutForManager: true,
                modifyLayoutForOperator: true,
                modifyLayoutForCSR: true,
                // Trip creation (all roles can create)
                createTripsForFBOAdmin: true,
                createTripsForManager: true,
                createTripsForOperator: true,
                createTripsForCSR: true,
                // Trip deletion (all roles can delete)
                deleteTripsForFBOAdmin: true,
                deleteTripsForManager: true,
                deleteTripsForOperator: true,
                deleteTripsForCSR: true,
                // Favorites (all roles can use)
                useFavoritesForFBOAdmin: true,
                useFavoritesForManager: true,
                useFavoritesForOperator: true,
                useFavoritesForCSR: true,
                // Global settings (not role-specific)
                ignoreDeadSpaceForUtilization: false,
                forceDisplayNotes: false,
                useMetricSystem: false,
                enableScheduling: true,
                displayDetailedDecisionLog: false,
                useListHoldingArea: false,
                enableAutoParking: true,
                enableOpsCenter: false,
                defaultBuffer: 0,
                defaultCAM: 0,
                defaultCAMPerSqft: 0,
                hangarDisplayOrder: [],
                rampDisplayOrder: []
            }
        }).single();
        const { data: inviteId } = await postgrest.rpc("make_invite", {
            fbo_id: newFbo.id,
            email: email,
            default_role: "manager"
        });
        setInviteURL(`${window.location.origin}/#/claim-invite/${inviteId}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $btULL.SideIconButton), {
                onClickRoute: ()=>setOpen(!open),
                label: "Add FBO",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eBnBM))), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: ()=>setOpen(false),
                maxWidth: "md",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Add a New FBO"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                                children: Boolean(inviteURL) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        "An email has been sent to",
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            style: {
                                                color: "#3c6ce9"
                                            },
                                            children: email
                                        }),
                                        " with an invite to",
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            style: {
                                                color: "#3c6ce9"
                                            },
                                            children: name
                                        }),
                                        ". You can also use the link below."
                                    ]
                                }) : "Create a new FBO and invite the first user."
                            }),
                            Boolean(inviteURL) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle1",
                                children: inviteURL
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "column",
                                spacing: 1,
                                sx: {
                                    p: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        size: "small",
                                        autoFocus: true,
                                        required: true,
                                        label: "Name",
                                        type: "text",
                                        fullWidth: true,
                                        onChange: (evt)=>setName(evt.target.value),
                                        value: name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        size: "small",
                                        required: true,
                                        label: "Email Address",
                                        type: "email",
                                        fullWidth: true,
                                        onChange: (evt)=>setEmail(evt.target.value),
                                        value: email
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                        children: Boolean(inviteURL) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            onClick: ()=>setOpen(false),
                            children: "OK"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    color: "error",
                                    onClick: ()=>setOpen(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    color: "success",
                                    variant: "contained",
                                    onClick: onClickAdd,
                                    children: "Add"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $1MdOk = parcelRequire("1MdOk");

var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $eFqab = parcelRequire("eFqab");
var $ejcfT = parcelRequire("ejcfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");
const $cd35251cfc6f4c1a$export$1930a24c331462bf = ()=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const handleOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const handleRemoveFBO = (0, $acw62.useCallback)(async ()=>{
        try {
            setLoading(true);
            // Async call to remove the FBO (replace with your actual API call)
            await postgrest.from("fbo").delete().eq("id", activeFBO.id);
            // Handle success response
            console.log("FBO removed successfully");
            setOpen(false);
        } catch (error) {
            // Handle error
            console.error("Error removing FBO:", error);
        } finally{
            setLoading(false);
        }
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                size: "small",
                variant: "contained",
                color: "error",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {}),
                onClick: handleOpen,
                children: "Remove FBO"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: "Confirm FBO Removal"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                            children: "Are you sure you want to remove this FBO? This action cannot be undone."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleClose,
                                color: "primary",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleRemoveFBO,
                                color: "error",
                                variant: "contained",
                                disabled: loading,
                                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                    size: 24
                                }) : "Confirm"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $c3r8Q = parcelRequire("c3r8Q");

var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $9Lykx = parcelRequire("9Lykx");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
const $10795c7395d2b74f$export$a532b65c6fcfddbf = ({ name: name, onChange: onChange })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [newName, setNewName] = (0, $acw62.useState)(name);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "row",
                spacing: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        width: 150,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        onClick: ()=>setOpen(true),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3r8Q))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: open,
                onClose: ()=>setOpen(false),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        sx: {
                            p: 2
                        },
                        children: "Edit FBO Name"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 2,
                        sx: {
                            p: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                label: "Name",
                                value: newName,
                                onChange: (evt)=>setNewName(evt.target.value)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                justifyContent: "flex-end",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>setOpen(false),
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "contained",
                                        color: "success",
                                        onClick: ()=>{
                                            setOpen(false);
                                            onChange(newName);
                                        },
                                        children: "Save"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $ef1fcc004f67cf01$export$be2b17db69ae28a0 = ()=>{
    const { fbos: fbos, setFBO: setFBO } = (0, $ZD2ym.useActiveFBOs)();
    const sortedFBOs = $acw62.useMemo(()=>{
        return (0, $cLNZr.orderBy)(fbos, [
            "name"
        ], [
            "asc"
        ]);
    }, [
        fbos
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "column",
        spacing: 4,
        sx: {
            width: 400,
            p: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                children: "Serious Business"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "textSecondary",
                                children: "For serious people who do serious business, there are these buttons. Use them wisely."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                children: "Add a new FBO"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4bc148abb05f558b$export$21f0333ea0618bd2), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                children: [
                                    "Delete ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                        children: "this"
                                    }),
                                    " FBO"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd35251cfc6f4c1a$export$1930a24c331462bf), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                children: "Current FBOs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "textSecondary",
                                children: "Modify the text input to change the FBO Name. Change their subscription (gated feature access) by selecting from the dropdown."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "column",
                        spacing: 1,
                        maxHeight: 450,
                        overflow: "auto",
                        p: 1,
                        sx: {
                            ...(0, $lNEp2.scrollSx)
                        },
                        children: sortedFBOs.map((fbo)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10795c7395d2b74f$export$a532b65c6fcfddbf), {
                                        name: fbo?.name,
                                        onChange: (name)=>{
                                            setFBO({
                                                ...fbo,
                                                name: name
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                        size: "small",
                                        select: true,
                                        fullWidth: true,
                                        label: "Subscription",
                                        value: fbo.subscription,
                                        onChange: (evt)=>{
                                            setFBO({
                                                ...fbo,
                                                subscription: evt.target.value
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "standard",
                                                children: "Standard"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "autostacking",
                                                children: "Autostacking"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "autostacking_with_edit",
                                                children: "Autostacking with Hangar/Ramp Edit"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "autostacking_with_edit_and_copy",
                                                children: "Autostacking with Hangar/Ramp Edit & Copy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            }, `fbo-${fbo.id}`))
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $7fruN = parcelRequire("7fruN");

var $h23xD = parcelRequire("h23xD");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $3kyM0 = parcelRequire("3kyM0");

var $koS2J = parcelRequire("koS2J");

var $lNEp2 = parcelRequire("lNEp2");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $79E6C = parcelRequire("79E6C");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
const $7abdfce98d6dce0d$export$5cf1212673c1b442 = ({ label: label, currentValue: currentValue, value: value, onChange: onChange, placeholder: placeholder, required: required = false })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        spacing: 2,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                sx: {
                    width: '80px'
                },
                children: [
                    label,
                    ":"
                ]
            }),
            currentValue !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                sx: {
                    width: '100px'
                },
                children: [
                    currentValue.toFixed(2),
                    " ft"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                size: "small",
                placeholder: placeholder || (currentValue !== undefined ? `Current: ${currentValue.toFixed(2)}` : placeholder),
                type: "number",
                value: value,
                onChange: (e)=>onChange(e.target.value),
                error: value !== "" && (isNaN(parseFloat(value)) || parseFloat(value) <= 0),
                helperText: value !== "" && (isNaN(parseFloat(value)) || parseFloat(value) <= 0) ? "Must be > 0" : "",
                sx: {
                    flex: 1
                },
                inputProps: {
                    min: 0,
                    step: 0.01
                },
                required: required
            })
        ]
    });
};


const $f295b75114d04032$export$84b33e034bea51ef = ({ open: open, obstacle: obstacle, isCreating: isCreating, onClose: onClose, onSave: onSave })=>{
    const [formData, setFormData] = $acw62.useState({
        name: "",
        width: "",
        length: "",
        height: "",
        image: undefined
    });
    const [imagePreview, setImagePreview] = $acw62.useState(null);
    const [imageError, setImageError] = $acw62.useState(null);
    const fileInputRef = $acw62.useRef(null);
    // Reset form when obstacle changes or creating new
    $acw62.useEffect(()=>{
        if (isCreating) {
            setFormData({
                name: "",
                width: "",
                length: "",
                height: "",
                image: undefined
            });
            setImagePreview(null);
            setImageError(null);
        } else if (obstacle) {
            setFormData({
                name: obstacle.name,
                width: "",
                length: "",
                height: "",
                image: undefined
            });
            setImagePreview(null);
            setImageError(null);
        }
    }, [
        obstacle,
        isCreating
    ]);
    const handleChange = (field, value)=>{
        setFormData((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const handleImageChange = (event)=>{
        const file = event.target.files?.[0];
        if (file) {
            // Clear previous error
            setImageError(null);
            // Validate file size (max 10MB)
            if (file.size > 10485760) {
                setImageError("File size must be under 10MB");
                event.target.value = ''; // Clear the input
                return;
            }
            // Validate file type (images only)
            const allowedTypes = [
                'image/jpeg',
                'image/jpg',
                'image/png',
                'image/gif',
                'image/svg+xml'
            ];
            if (!allowedTypes.includes(file.type)) {
                setImageError("Only image files are allowed (JPG, PNG, GIF, SVG)");
                event.target.value = ''; // Clear the input
                return;
            }
            setFormData((prev)=>({
                    ...prev,
                    image: file
                }));
            // Create preview
            const reader = new FileReader();
            reader.onloadend = ()=>{
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleSave = async ()=>{
        await onSave(formData);
    // Don't close here - let parent close on success
    };
    const handleClose = ()=>{
        setFormData({
            name: "",
            width: "",
            length: "",
            height: "",
            image: undefined
        });
        setImagePreview(null);
        setImageError(null);
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: handleClose,
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: isCreating ? "Add New Obstacle" : "Edit Obstacle"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 3,
                        sx: {
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                fullWidth: true,
                                label: "Name",
                                value: formData.name,
                                onChange: (e)=>handleChange('name', e.target.value),
                                placeholder: obstacle?.name || "Obstacle name",
                                autoFocus: true,
                                required: isCreating
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                            (obstacle || isCreating) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7abdfce98d6dce0d$export$5cf1212673c1b442), {
                                        label: "Width",
                                        currentValue: obstacle?.width,
                                        value: formData.width,
                                        onChange: (value)=>handleChange('width', value),
                                        placeholder: isCreating ? "Width in feet" : "New width",
                                        required: isCreating
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7abdfce98d6dce0d$export$5cf1212673c1b442), {
                                        label: "Length",
                                        currentValue: obstacle?.length,
                                        value: formData.length,
                                        onChange: (value)=>handleChange('length', value),
                                        placeholder: isCreating ? "Length in feet" : "New length",
                                        required: isCreating
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7abdfce98d6dce0d$export$5cf1212673c1b442), {
                                        label: "Height",
                                        currentValue: obstacle?.height,
                                        value: formData.height,
                                        onChange: (value)=>handleChange('height', value),
                                        placeholder: isCreating ? "Height in feet" : "New height",
                                        required: isCreating
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle2",
                                                gutterBottom: true,
                                                children: "Obstacle Image"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                ref: fileInputRef,
                                                type: "file",
                                                accept: "image/*",
                                                onChange: handleImageChange,
                                                style: {
                                                    display: 'none'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                variant: "outlined",
                                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($79E6C))), {}),
                                                onClick: ()=>fileInputRef.current?.click(),
                                                fullWidth: true,
                                                color: imageError ? "error" : "primary",
                                                children: formData.image ? 'Change Image' : 'Upload Image'
                                            }),
                                            imageError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "error",
                                                sx: {
                                                    mt: 1,
                                                    display: 'block'
                                                },
                                                children: imageError
                                            }),
                                            formData.image && !imageError && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                variant: "caption",
                                                color: "textSecondary",
                                                sx: {
                                                    mt: 1,
                                                    display: 'block'
                                                },
                                                children: [
                                                    "Selected: ",
                                                    formData.image.name
                                                ]
                                            }),
                                            imagePreview && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                sx: {
                                                    mt: 2,
                                                    textAlign: 'center'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: imagePreview,
                                                    alt: "Preview",
                                                    style: {
                                                        maxWidth: '100%',
                                                        maxHeight: '200px',
                                                        objectFit: 'contain'
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !isCreating && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "textSecondary",
                        sx: {
                            mt: 2,
                            display: 'block'
                        },
                        children: "* Leave dimension fields empty to keep current values"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleSave,
                        variant: "contained",
                        children: isCreating ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $lkxXU = parcelRequire("lkxXU");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $54aSv = parcelRequire("54aSv");
const $05d1fa088ff5ce23$export$8baa46f7a5ed6295 = ({ selectedObstacle: selectedObstacle, imageError: imageError, onImageError: onImageError })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            width: {
                xs: '100%',
                md: '400px',
                lg: '500px',
                xl: '562px'
            },
            flexShrink: 0,
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: 2,
            sx: {
                height: '100%'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h6",
                    children: "Preview"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                selectedObstacle ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    spacing: 2,
                    sx: {
                        flex: 1,
                        overflowY: 'auto',
                        pr: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "subtitle1",
                            children: selectedObstacle.name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                width: 'calc(100% - 8px)',
                                aspectRatio: '1',
                                maxHeight: '300px',
                                border: '2px dashed',
                                borderColor: 'divider',
                                borderRadius: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'background.default',
                                flexShrink: 0,
                                boxSizing: 'border-box',
                                mr: 1,
                                overflow: 'hidden'
                            },
                            children: !imageError ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: `${(0, $54aSv.getObstacleImageUrl)(selectedObstacle.id, selectedObstacle.image)}?t=${Date.now()}`,
                                alt: selectedObstacle.name,
                                style: {
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain'
                                },
                                onError: onImageError
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                color: "textSecondary",
                                children: "No image available"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Dimensions:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: [
                                        "Width: ",
                                        selectedObstacle.width.toFixed(2),
                                        " ft"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: [
                                        "Length: ",
                                        selectedObstacle.length.toFixed(2),
                                        " ft"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: "body2",
                                    children: [
                                        "Height: ",
                                        selectedObstacle.height.toFixed(2),
                                        " ft"
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    color: "textSecondary",
                    sx: {
                        textAlign: 'center',
                        mt: 4
                    },
                    children: "Select an obstacle to view details"
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");
var $7Frhn = parcelRequire("7Frhn");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");

var $c3r8Q = parcelRequire("c3r8Q");

var $1MdOk = parcelRequire("1MdOk");

var $lNEp2 = parcelRequire("lNEp2");
const $79d0dca3c1b5b45c$export$3a045bb52d29139c = ({ obstacles: obstacles, selectedObstacle: selectedObstacle, onSelectObstacle: onSelectObstacle, onEditClick: onEditClick, onDeleteClick: onDeleteClick, tableRef: tableRef })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
        ref: tableRef,
        component: (0, $7Frhn.default),
        sx: {
            flex: 1,
            overflow: 'auto',
            maxHeight: '100%',
            ...(0, $lNEp2.scrollSx)
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
            stickyHeader: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                sx: {
                                    width: '15%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "right",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Width (ft)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "right",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Length (ft)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "right",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Height (ft)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "center",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Actions"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                    children: obstacles.map((obstacle, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                            hover: true,
                            selected: selectedObstacle?.id === obstacle.id,
                            onClick: ()=>onSelectObstacle(obstacle, index),
                            sx: {
                                cursor: 'pointer',
                                height: '48px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: obstacle.name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "right",
                                    children: obstacle.width.toFixed(2)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "right",
                                    children: obstacle.length.toFixed(2)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "right",
                                    children: obstacle.height.toFixed(2)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 1,
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                size: "small",
                                                variant: "outlined",
                                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3r8Q))), {}),
                                                onClick: (e)=>onEditClick(obstacle, e),
                                                sx: {
                                                    minWidth: 'auto'
                                                },
                                                children: "Edit"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                size: "small",
                                                variant: "outlined",
                                                color: "error",
                                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {}),
                                                onClick: (e)=>onDeleteClick(obstacle, e),
                                                sx: {
                                                    minWidth: 'auto'
                                                },
                                                children: "Delete"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, obstacle.id))
                })
            ]
        })
    });
};


const $71827cade1dc8e6f$export$a4d0709e003e4f7e = ()=>{
    const { loading: loading, error: hookError, predefinedObstacles: predefinedObstacles, createPredefinedObstacle: createPredefinedObstacle, updatePredefinedObstacle: updatePredefinedObstacle, deletePredefinedObstacle: deletePredefinedObstacle, refreshObstacles: refreshObstacles } = (0, $koS2J.usePredefinedObstacle)();
    const tokenMakerURL = (0, $lNEp2.getTokenMakerUrl)();
    const { url: webURL } = (0, $3kyM0.useTokenMaker)();
    // Check if we're on production
    const isProduction = window.location.hostname === 'app.airplx.com';
    const [selectedObstacle, setSelectedObstacle] = (0, $acw62.useState)(null);
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(null);
    const [editingObstacle, setEditingObstacle] = (0, $acw62.useState)(null);
    const [isCreating, setIsCreating] = (0, $acw62.useState)(false);
    const [imageError, setImageError] = (0, $acw62.useState)(false);
    const [componentError, setComponentError] = (0, $acw62.useState)(null);
    const [confirmDeploy, setConfirmDeploy] = (0, $acw62.useState)(false);
    const [newObstacleId, setNewObstacleId] = (0, $acw62.useState)(null);
    const tableRef = (0, $acw62.useRef)(null);
    const containerRef = (0, $acw62.useRef)(null);
    // Combine errors
    const error = componentError || hookError;
    // Focus container on mount and select first obstacle
    (0, $acw62.useEffect)(()=>{
        containerRef.current?.focus();
        // If we have a new obstacle ID to select after refresh
        if (newObstacleId && predefinedObstacles) {
            const index = predefinedObstacles.findIndex((o)=>o.id === newObstacleId);
            if (index !== -1) {
                setSelectedObstacle(predefinedObstacles[index]);
                setSelectedIndex(index);
                setNewObstacleId(null); // Clear after selection
                return;
            }
        }
        // Default behavior: select first obstacle if none selected
        if (predefinedObstacles && predefinedObstacles.length > 0 && !selectedObstacle) {
            setSelectedObstacle(predefinedObstacles[0]);
            setSelectedIndex(0);
        }
    }, [
        predefinedObstacles,
        newObstacleId
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            // Don't handle keyboard events when dialog is open
            if (editingObstacle || isCreating) return;
            if (!predefinedObstacles || predefinedObstacles.length === 0) return;
            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                e.preventDefault();
                let newIndex = selectedIndex;
                if (newIndex === null) newIndex = 0;
                else if (e.key === "ArrowDown") newIndex = Math.min(newIndex + 1, predefinedObstacles.length - 1);
                else newIndex = Math.max(newIndex - 1, 0);
                setSelectedIndex(newIndex);
                setSelectedObstacle(predefinedObstacles[newIndex]);
                setImageError(false);
                // Scroll into view
                if (tableRef.current) {
                    const row = tableRef.current.querySelector(`tbody tr:nth-child(${newIndex + 1})`);
                    row?.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                    });
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        predefinedObstacles,
        selectedIndex,
        editingObstacle,
        isCreating
    ]);
    const handleSelectObstacle = (obstacle, index)=>{
        setSelectedObstacle(obstacle);
        setSelectedIndex(index);
        setImageError(false);
    };
    const handleEditClick = (obstacle, event)=>{
        event.stopPropagation();
        setEditingObstacle(obstacle);
        setIsCreating(false);
    };
    const handleAddClick = ()=>{
        setEditingObstacle(null);
        setIsCreating(true);
    };
    const handleDeleteClick = async (obstacle, event)=>{
        event.stopPropagation();
        if (window.confirm(`Are you sure you want to delete "${obstacle.name}"?`)) try {
            await deletePredefinedObstacle(obstacle.id);
            if (selectedObstacle?.id === obstacle.id) {
                setSelectedObstacle(null);
                setSelectedIndex(null);
            }
        } catch (err) {
            setComponentError(`Failed to delete obstacle: ${err}`);
        }
    };
    // Helper function for dimension validation
    const validateDimension = (value)=>{
        if (!value) return null;
        const num = parseFloat(value);
        return !isNaN(num) && num > 0 && num <= 1000 ? num : null;
    };
    const handleSaveEdit = async (formData)=>{
        try {
            if (isCreating) {
                // Create new obstacle
                const width = validateDimension(formData.width);
                const length = validateDimension(formData.length);
                const height = validateDimension(formData.height);
                if (!formData.name || !width || !length || !height) {
                    setComponentError("Please provide valid values for all fields. Dimensions must be positive numbers up to 1000 feet.");
                    return;
                }
                const newObstacle = await createPredefinedObstacle({
                    name: formData.name,
                    width: width,
                    length: length,
                    height: height
                });
                // Check if creation was successful
                if (!newObstacle) {
                    setComponentError("Failed to create obstacle. Please try again.");
                    return;
                }
                // Set the new obstacle ID for selection after refresh
                setNewObstacleId(newObstacle.id);
                // Upload image if provided
                if (formData.image) {
                    await uploadObstacleImage(newObstacle.id, formData.image);
                    // Refresh to get the updated image
                    await refreshObstacles();
                // The new obstacle will be selected via useEffect
                } else // If no image, still refresh to get the new obstacle in the list
                await refreshObstacles();
            } else if (editingObstacle) {
                // Update existing obstacle
                const width = validateDimension(formData.width);
                const length = validateDimension(formData.length);
                const height = validateDimension(formData.height);
                // Check if any provided dimensions are invalid
                if (formData.width && !width) {
                    setComponentError("Width must be a positive number up to 1000 feet.");
                    return;
                }
                if (formData.length && !length) {
                    setComponentError("Length must be a positive number up to 1000 feet.");
                    return;
                }
                if (formData.height && !height) {
                    setComponentError("Height must be a positive number up to 1000 feet.");
                    return;
                }
                const updatedObstacle = {
                    ...editingObstacle,
                    name: formData.name || editingObstacle.name,
                    width: width ?? editingObstacle.width,
                    length: length ?? editingObstacle.length,
                    height: height ?? editingObstacle.height
                };
                await updatePredefinedObstacle(updatedObstacle);
                // Upload image if provided
                if (formData.image) {
                    await uploadObstacleImage(editingObstacle.id, formData.image);
                    // Refresh to get the updated image
                    await refreshObstacles();
                }
                // Update selected obstacle if it was edited
                const updated = predefinedObstacles.find((o)=>o.id === editingObstacle.id);
                if (updated && selectedObstacle?.id === editingObstacle.id) setSelectedObstacle(updated);
            }
            setEditingObstacle(null);
            setIsCreating(false);
            setComponentError(null);
        } catch (err) {
            setComponentError(`Failed to save obstacle: ${err}`);
        }
    };
    const uploadObstacleImage = async (obstacleId, file)=>{
        const formData = new FormData();
        formData.append("image", file);
        const response = await fetch(`${tokenMakerURL}/movable_obstacles/${obstacleId}/image`, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Failed to upload image");
    };
    // Helper to prepare obstacle data for export
    const prepareObstacleExportData = ()=>{
        const headers = [
            "Name",
            "Width",
            "Length",
            "Height",
            "ID"
        ];
        const rows = predefinedObstacles.map((o)=>[
                o.name || "",
                o.width?.toFixed(1) || "",
                o.length?.toFixed(1) || "",
                o.height?.toFixed(1) || "",
                o.id
            ]);
        return {
            headers: headers,
            rows: rows
        };
    };
    // Helper to download file
    const downloadFile = (content, filename, mimeType)=>{
        const blob = new Blob([
            content
        ], {
            type: mimeType
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const handleExportCSV = ()=>{
        const { headers: headers, rows: rows } = prepareObstacleExportData();
        // Convert to TSV format
        const tsvContent = [
            headers.join("\t"),
            ...rows.map((row)=>row.join("\t"))
        ].join("\n");
        const filename = `movable_obstacles_${new Date().toISOString().split("T")[0]}.tsv`;
        downloadFile(tsvContent, filename, "text/tab-separated-values;charset=utf-8;");
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            children: "Loading obstacles..."
        })
    });
    if (error && !loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
            severity: "error",
            onClose: ()=>setComponentError(null),
            children: error
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        ref: containerRef,
        tabIndex: 0,
        sx: {
            p: 2,
            height: "calc(100vh - 120px)",
            display: "flex",
            flexDirection: "column",
            outline: "none"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                spacing: 3,
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                    onClick: handleAddClick,
                                    color: "primary",
                                    children: "Add Obstacle"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fruN))), {}),
                                    onClick: handleExportCSV,
                                    disabled: predefinedObstacles.length === 0,
                                    color: "primary",
                                    children: "Export Obstacle List"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: !isProduction ? "Deploy is only available on production (app.airplx.com)" : "",
                                    arrow: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            onClick: ()=>setConfirmDeploy(true),
                                            variant: "contained",
                                            color: "primary",
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h23xD))), {}),
                                            disabled: !isProduction,
                                            children: "Deploy"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: {
                            xs: "column",
                            md: "row"
                        },
                        spacing: 2,
                        sx: {
                            flex: 1,
                            minHeight: 0,
                            pr: {
                                xs: 0,
                                md: "13px"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    flex: 1,
                                    minWidth: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    minHeight: 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $79d0dca3c1b5b45c$export$3a045bb52d29139c), {
                                    obstacles: predefinedObstacles,
                                    selectedObstacle: selectedObstacle,
                                    onSelectObstacle: handleSelectObstacle,
                                    onEditClick: handleEditClick,
                                    onDeleteClick: handleDeleteClick,
                                    tableRef: tableRef
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05d1fa088ff5ce23$export$8baa46f7a5ed6295), {
                                selectedObstacle: selectedObstacle,
                                imageError: imageError,
                                onImageError: ()=>setImageError(true)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f295b75114d04032$export$84b33e034bea51ef), {
                open: !!editingObstacle || isCreating,
                obstacle: editingObstacle,
                isCreating: isCreating,
                onClose: ()=>{
                    setEditingObstacle(null);
                    setIsCreating(false);
                },
                onSave: handleSaveEdit
            }),
            confirmDeploy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Confirm deploy",
                text: "Are you sure you want to deploy?",
                onCancel: ()=>setConfirmDeploy(false),
                onClose: ()=>setConfirmDeploy(false),
                onOk: async ()=>{
                    await fetch(`${webURL}/jobs/update-movable-obstacles`);
                    setConfirmDeploy(false);
                },
                okText: "Go baby go!"
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $2P5BT = parcelRequire("2P5BT");

var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $hViLc = parcelRequire("hViLc");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $acw62 = parcelRequire("acw62");

var $2NPdf = parcelRequire("2NPdf");

var $ZD2ym = parcelRequire("ZD2ym");

var $2LXej = parcelRequire("2LXej");

var $aHqXU = parcelRequire("aHqXU");
const $8d26d3e61cd4a876$export$dee3e08bb2289aea = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [loading, setLoading] = $acw62.useState(false);
    const [editingUser, setEditingUser] = $acw62.useState(null);
    const [users, setUsers] = $acw62.useState([]);
    const { fbos: fbos } = (0, $ZD2ym.useActiveFBOs)();
    const [actionsOnSave, setActionsOnSave] = $acw62.useState([]);
    const [fboFilter, setFBOFilter] = $acw62.useState("");
    const [userFilter, setUserFilter] = $acw62.useState("");
    const { loading: loadingUsers } = (0, $2NPdf.default)(async ()=>{
        const results = await postgrest.rpc("get_users_with_fbos").select("*");
        setUsers(results.body);
    }, []);
    const onSave = $acw62.useCallback(async ()=>{
        for (const action of actionsOnSave)await action();
        setActionsOnSave([]);
    }, [
        actionsOnSave
    ]);
    $acw62.useEffect(()=>{
        setFBOFilter("");
    }, [
        editingUser
    ]);
    const onChangeRole = $acw62.useCallback(async (user_id, user_display_name, fbo_id, _role)=>{
        if (_role === "none") await postgrest.from("fbo_employees").delete().eq("user_id", user_id).eq("fbo_id", fbo_id);
        else // super annoying but postgres doesn't do upserts on non-primary keys
        await postgrest.rpc("modify_role", {
            _user_id: user_id,
            _fbo_id: fbo_id,
            __role: _role,
            _user_display_name: user_display_name
        });
        const results = await postgrest.rpc("get_users_with_fbos").select("*");
        setUsers(results.body);
    }, []);
    const sortedFbos = $acw62.useMemo(()=>{
        return [
            ...fbos
        ].sort((a, b)=>{
            const nameA = a.name.toLocaleLowerCase();
            const nameB = b.name.toLocaleLowerCase();
            if (nameA.indexOf(fboFilter.toLocaleLowerCase()) > -1) return -1;
            if (nameB.indexOf(fboFilter.toLocaleLowerCase()) > -1) return 1;
            return nameA.localeCompare(nameB);
        });
    }, [
        fbos,
        fboFilter
    ]);
    if (loadingUsers) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    const columns = [
        {
            field: "id",
            headerName: "User ID",
            width: 100,
            editable: false,
            valueGetter: (_, row)=>row.id.slice(0, 7) || "---"
        },
        {
            field: "name",
            headerName: "Name",
            width: 175,
            editable: false,
            valueGetter: (_, row)=>row.name || "---"
        },
        {
            field: "email",
            headerName: "Email",
            width: 250,
            editable: false,
            valueGetter: (_, row)=>row.email || "---"
        },
        {
            field: "fbos",
            headerName: "FBO",
            width: 400,
            editable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    height: "100%",
                    children: [
                        params.row.fbos.sort((a, b)=>a.name.localeCompare(b.name)).slice(0, 5).map((fbo)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                size: "small",
                                variant: "outlined",
                                label: fbo.name
                            }, fbo.id)),
                        params.row.fbos.length > 5 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                            size: "small",
                            variant: "outlined",
                            label: `+ ${params.row.fbos.length - 5} more`
                        })
                    ]
                })
        },
        {
            field: "action",
            headerName: "Action",
            width: 200,
            editable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    height: "100%",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        color: "info",
                        size: "small",
                        onClick: ()=>{
                            setEditingUser(params.row.id);
                            setActionsOnSave([]);
                        },
                        children: "Edit"
                    })
                })
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 2,
                sx: {
                    width: "100%",
                    minWidth: 700,
                    p: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        fullWidth: true,
                        size: "small",
                        placeholder: "Search for user",
                        inputProps: {
                            ["data-testid"]: "input_filter_team_member"
                        },
                        InputProps: {
                            startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                position: "start",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                            })
                        },
                        onChange: (evt)=>setUserFilter(evt.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            height: 500,
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                            rows: users.filter((u)=>`${u.email} ${u.name}`.toLocaleLowerCase().indexOf(userFilter.toLocaleLowerCase()) > -1),
                            columns: columns,
                            pageSizeOptions: [
                                20
                            ],
                            disableRowSelectionOnClick: true,
                            disableColumnMenu: true,
                            disableColumnFilter: true,
                            disableColumnSelector: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
                open: !!editingUser,
                onClose: ()=>{
                    setEditingUser(null);
                    setActionsOnSave([]);
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "inherit",
                            children: "Edit User"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "column",
                            spacing: 1,
                            height: 500,
                            width: 500,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    fullWidth: true,
                                    size: "small",
                                    placeholder: "Search for FBO",
                                    inputProps: {
                                        ["data-testid"]: "input_filter_team_member"
                                    },
                                    InputProps: {
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                            position: "start",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                                        })
                                    },
                                    onChange: (evt)=>setFBOFilter(evt.target.value)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                                    rows: sortedFbos,
                                    columns: [
                                        {
                                            field: "name",
                                            headerName: "Name",
                                            width: 200
                                        },
                                        {
                                            field: "permissions",
                                            headerName: "Permissions",
                                            width: 200,
                                            renderCell: (params)=>{
                                                const user = users.find((u)=>u.id === editingUser);
                                                const userRole = user?.fbo_employees.find((e)=>e.fbo_id === params.row.id)?._role || "none";
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                                    direction: "column",
                                                    height: "100%",
                                                    justifyContent: "center",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                                        select: true,
                                                        fullWidth: true,
                                                        size: "small",
                                                        value: userRole,
                                                        onChange: async (evt)=>{
                                                            const newRole = evt.target.value;
                                                            // Optimistically update local state immediately
                                                            setUsers((prevUsers)=>prevUsers.map((u)=>{
                                                                    if (u.id !== editingUser) return u;
                                                                    const existingEmployee = u.fbo_employees.find((e)=>e.fbo_id === params.row.id);
                                                                    if (newRole === "none") // Remove the employee entry
                                                                    return {
                                                                        ...u,
                                                                        fbo_employees: u.fbo_employees.filter((e)=>e.fbo_id !== params.row.id)
                                                                    };
                                                                    else if (existingEmployee) // Update existing role
                                                                    return {
                                                                        ...u,
                                                                        fbo_employees: u.fbo_employees.map((e)=>e.fbo_id === params.row.id ? {
                                                                                ...e,
                                                                                _role: newRole
                                                                            } : e)
                                                                    };
                                                                    else // Add new employee entry
                                                                    return {
                                                                        ...u,
                                                                        fbo_employees: [
                                                                            ...u.fbo_employees,
                                                                            {
                                                                                fbo_id: params.row.id,
                                                                                _role: newRole
                                                                            }
                                                                        ]
                                                                    };
                                                                }));
                                                            // Queue the action for server persistence
                                                            setActionsOnSave([
                                                                ...actionsOnSave,
                                                                async ()=>await onChangeRole(user.id, user.email, params.row.id, newRole)
                                                            ]);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                value: "none",
                                                                children: "None"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                value: "fbo_admin",
                                                                children: (0, $aHqXU.ROLE_DISPLAY_NAMES).fbo_admin
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                value: "manager",
                                                                children: (0, $aHqXU.ROLE_DISPLAY_NAMES).manager
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                value: "operator",
                                                                children: (0, $aHqXU.ROLE_DISPLAY_NAMES).operator
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                value: "csr",
                                                                children: (0, $aHqXU.ROLE_DISPLAY_NAMES).csr
                                                            })
                                                        ]
                                                    }, `${editingUser}-${params.row.id}`)
                                                });
                                            }
                                        }
                                    ],
                                    pageSizeOptions: [
                                        1000
                                    ],
                                    disableVirtualization: true,
                                    disableRowSelectionOnClick: true,
                                    disableColumnMenu: true,
                                    disableColumnFilter: true,
                                    disableColumnSelector: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: ()=>{
                                    setEditingUser(null);
                                    setActionsOnSave([]);
                                },
                                children: "Close"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "success",
                                onClick: async ()=>{
                                    setLoading(true);
                                    await onSave();
                                    setLoading(false);
                                    setEditingUser(null);
                                },
                                disabled: loading,
                                children: loading ? "Saving..." : "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $7tqxO = parcelRequire("7tqxO");

var $7fruN = parcelRequire("7fruN");

var $h23xD = parcelRequire("h23xD");

var $iwiZ3 = parcelRequire("iwiZ3");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $3kyM0 = parcelRequire("3kyM0");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $lNEp2 = parcelRequire("lNEp2");
const $76a0871e2896f6a2$export$8778e43524c9ecd3 = ()=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const [loading, setLoading] = $acw62.useState(true);
    const [error, setError] = $acw62.useState(null);
    const [towingEquipment, setTowingEquipment] = $acw62.useState([]);
    const fetchTowingEquipment = $acw62.useCallback(async ()=>{
        try {
            setError(null);
            const { data: data, error: fetchError } = await postgrest.from("towing_equipment").select().order("name");
            if (fetchError) throw fetchError;
            setTowingEquipment(data || []);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching towing equipment:", err);
            setError(err?.message || "Failed to fetch towing equipment");
            setLoading(false);
        }
    }, [
        postgrest
    ]);
    $acw62.useEffect(()=>{
        fetchTowingEquipment();
    }, [
        fetchTowingEquipment
    ]);
    const upsertTowingEquipment = $acw62.useCallback(async (equipment)=>{
        try {
            setError(null);
            // Call the admin upsert function
            const { data: data, error: rpcError } = await postgrest.rpc("admin_upsert_towing_equipment", {
                p_id: equipment.id,
                p_name: equipment.name,
                p_width: equipment.width,
                p_length: equipment.length,
                p_height: equipment.height,
                p_tow_bar_length: equipment.tow_bar_length,
                p_no_footprint: equipment.no_footprint || false
            });
            if (rpcError) throw rpcError;
            // Refresh the list
            await fetchTowingEquipment();
            return data;
        } catch (err) {
            console.error("Error upserting towing equipment:", err);
            setError(err?.message || "Failed to save towing equipment");
            throw err;
        }
    }, [
        postgrest,
        fetchTowingEquipment
    ]);
    const createTowingEquipment = $acw62.useCallback(async (equipment)=>{
        const newEquipment = {
            ...equipment,
            id: (0, $lNEp2.uuidv4)(),
            created_at: new Date().toISOString()
        };
        const id = await upsertTowingEquipment(newEquipment);
        return {
            ...newEquipment,
            id: id || newEquipment.id
        };
    }, [
        upsertTowingEquipment
    ]);
    const deleteTowingEquipment = $acw62.useCallback(async (id)=>{
        try {
            setError(null);
            // Call the admin delete function
            const { data: data, error: rpcError } = await postgrest.rpc("admin_delete_towing_equipment", {
                p_id: id
            });
            if (rpcError) throw rpcError;
            // Refresh the list
            await fetchTowingEquipment();
            return data;
        } catch (err) {
            console.error("Error deleting towing equipment:", err);
            setError(err?.message || "Failed to delete towing equipment");
            throw err;
        }
    }, [
        postgrest,
        fetchTowingEquipment
    ]);
    const updateTowingEquipment = $acw62.useCallback(async (equipment)=>{
        return upsertTowingEquipment(equipment);
    }, [
        upsertTowingEquipment
    ]);
    return {
        loading: loading,
        error: error,
        towingEquipment: towingEquipment,
        createTowingEquipment: createTowingEquipment,
        updateTowingEquipment: updateTowingEquipment,
        deleteTowingEquipment: deleteTowingEquipment,
        refreshTowingEquipment: fetchTowingEquipment
    };
};


parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");
var $1Aijw = parcelRequire("1Aijw");
var $6MV2p = parcelRequire("6MV2p");
var $2MUlQ = parcelRequire("2MUlQ");
var $6Q1H5 = parcelRequire("6Q1H5");
var $ejcfT = parcelRequire("ejcfT");
var $lkxXU = parcelRequire("lkxXU");
var $2esSG = parcelRequire("2esSG");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

const $95d240f09353b5ca$export$6d80b19cdd25c931 = ({ open: open, equipment: equipment, isCreating: isCreating, onClose: onClose, onSave: onSave })=>{
    const [formData, setFormData] = $acw62.useState({
        name: "",
        width: "",
        length: "",
        height: "",
        tow_bar_length: "",
        no_footprint: false
    });
    // Reset form when equipment changes or creating new
    $acw62.useEffect(()=>{
        if (isCreating) setFormData({
            name: "",
            width: "",
            length: "",
            height: "",
            tow_bar_length: "",
            no_footprint: false
        });
        else if (equipment) setFormData({
            name: equipment.name,
            width: "",
            length: "",
            height: "",
            tow_bar_length: "",
            no_footprint: equipment.no_footprint ?? false
        });
    }, [
        equipment,
        isCreating
    ]);
    const handleChange = (field, value)=>{
        setFormData((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const handleSave = async ()=>{
        await onSave(formData);
    // Don't close here - let parent close on success
    };
    const handleClose = ()=>{
        setFormData({
            name: "",
            width: "",
            length: "",
            height: "",
            tow_bar_length: "",
            no_footprint: false
        });
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: open,
        onClose: handleClose,
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                children: isCreating ? "Add New Towing Equipment" : "Edit Towing Equipment"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        spacing: 3,
                        sx: {
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                fullWidth: true,
                                label: "Name",
                                value: formData.name,
                                onChange: (e)=>handleChange('name', e.target.value),
                                placeholder: equipment?.name || "Equipment name",
                                autoFocus: true,
                                required: isCreating
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                            (equipment || isCreating) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7abdfce98d6dce0d$export$5cf1212673c1b442), {
                                        label: "Width",
                                        currentValue: equipment?.width,
                                        value: formData.width,
                                        onChange: (value)=>handleChange('width', value),
                                        placeholder: isCreating ? "Width in feet" : "New width",
                                        required: isCreating
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7abdfce98d6dce0d$export$5cf1212673c1b442), {
                                        label: "Length",
                                        currentValue: equipment?.length,
                                        value: formData.length,
                                        onChange: (value)=>handleChange('length', value),
                                        placeholder: isCreating ? "Length in feet" : "New length",
                                        required: isCreating
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7abdfce98d6dce0d$export$5cf1212673c1b442), {
                                        label: "Height",
                                        currentValue: equipment?.height,
                                        value: formData.height,
                                        onChange: (value)=>handleChange('height', value),
                                        placeholder: isCreating ? "Height in feet" : "New height",
                                        required: isCreating
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
                                    checked: formData.no_footprint,
                                    onChange: (e)=>handleChange('no_footprint', e.target.checked)
                                }),
                                label: "No Footprint (Robotic)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "textSecondary",
                                children: "Check if equipment has no physical footprint (affects collision detection only)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7abdfce98d6dce0d$export$5cf1212673c1b442), {
                                label: "Tow Bar",
                                currentValue: equipment?.tow_bar_length ?? undefined,
                                value: formData.tow_bar_length,
                                onChange: (value)=>handleChange('tow_bar_length', value),
                                placeholder: isCreating ? "Tow bar length (optional)" : "New tow bar length",
                                required: false
                            })
                        ]
                    }),
                    !isCreating && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "textSecondary",
                        sx: {
                            mt: 2,
                            display: 'block'
                        },
                        children: "* Leave fields empty to keep current values"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleSave,
                        variant: "contained",
                        disabled: isCreating && (!formData.name || !formData.width || !formData.length || !formData.height),
                        children: isCreating ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");
var $7Frhn = parcelRequire("7Frhn");
var $30UGG = parcelRequire("30UGG");
var $30hyv = parcelRequire("30hyv");
var $QpuKB = parcelRequire("QpuKB");
var $elyLx = parcelRequire("elyLx");
var $81yMd = parcelRequire("81yMd");
var $hjXJ8 = parcelRequire("hjXJ8");
var $2XjE0 = parcelRequire("2XjE0");

var $c3r8Q = parcelRequire("c3r8Q");

var $1MdOk = parcelRequire("1MdOk");

var $lNEp2 = parcelRequire("lNEp2");
const $4db381867263501b$export$a7c288a0285b6042 = ({ equipment: equipment, selectedEquipment: selectedEquipment, onSelectEquipment: onSelectEquipment, onEditClick: onEditClick, onDeleteClick: onDeleteClick, tableRef: tableRef })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81yMd.default), {
        ref: tableRef,
        component: (0, $7Frhn.default),
        sx: {
            flex: 1,
            overflow: 'auto',
            maxHeight: '100%',
            ...(0, $lNEp2.scrollSx)
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
            stickyHeader: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                sx: {
                                    width: '15%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "right",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Width (ft)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "right",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Length (ft)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "right",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Height (ft)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "right",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Tow Bar (ft)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                align: "center",
                                sx: {
                                    width: '10%',
                                    backgroundColor: 'background.default'
                                },
                                children: "Actions"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                    children: equipment.map((equip, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
                            hover: true,
                            selected: selectedEquipment?.id === equip.id,
                            onClick: ()=>onSelectEquipment(equip, index),
                            sx: {
                                cursor: 'pointer',
                                height: '48px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    children: equip.name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "right",
                                    children: equip.width.toFixed(2)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "right",
                                    children: equip.length.toFixed(2)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "right",
                                    children: equip.height.toFixed(2)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "right",
                                    children: equip.tow_bar_length !== null && equip.tow_bar_length !== undefined ? equip.tow_bar_length.toFixed(2) : "\u2014"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        spacing: 1,
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                size: "small",
                                                variant: "outlined",
                                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3r8Q))), {}),
                                                onClick: (e)=>onEditClick(equip, e),
                                                sx: {
                                                    minWidth: 'auto'
                                                },
                                                children: "Edit"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                size: "small",
                                                variant: "outlined",
                                                color: "error",
                                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {}),
                                                onClick: (e)=>onDeleteClick(equip, e),
                                                sx: {
                                                    minWidth: 'auto'
                                                },
                                                children: "Delete"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, equip.id))
                })
            ]
        })
    });
};


const $20ad2ea09c0e6252$export$8f2b8082d10087ae = ()=>{
    const { loading: loading, error: hookError, towingEquipment: towingEquipment, createTowingEquipment: createTowingEquipment, updateTowingEquipment: updateTowingEquipment, deleteTowingEquipment: deleteTowingEquipment, refreshTowingEquipment: refreshTowingEquipment } = (0, $76a0871e2896f6a2$export$8778e43524c9ecd3)();
    const { url: webURL } = (0, $3kyM0.useTokenMaker)();
    // Check if we're on production
    const isProduction = window.location.hostname === "app.airplx.com";
    const [selectedEquipment, setSelectedEquipment] = (0, $acw62.useState)(null);
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(null);
    const [editingEquipment, setEditingEquipment] = (0, $acw62.useState)(null);
    const [isCreating, setIsCreating] = (0, $acw62.useState)(false);
    const [componentError, setComponentError] = (0, $acw62.useState)(null);
    const [confirmDeploy, setConfirmDeploy] = (0, $acw62.useState)(false);
    const [newEquipmentId, setNewEquipmentId] = (0, $acw62.useState)(null);
    const tableRef = (0, $acw62.useRef)(null);
    const containerRef = (0, $acw62.useRef)(null);
    // Combine errors
    const error = componentError || hookError;
    // Focus container on mount and select first equipment
    (0, $acw62.useEffect)(()=>{
        containerRef.current?.focus();
        // If we have a new equipment ID to select after refresh
        if (newEquipmentId && towingEquipment) {
            const index = towingEquipment.findIndex((e)=>e.id === newEquipmentId);
            if (index !== -1) {
                setSelectedEquipment(towingEquipment[index]);
                setSelectedIndex(index);
                setNewEquipmentId(null); // Clear after selection
                return;
            }
        }
        // Default behavior: select first equipment if none selected
        if (towingEquipment && towingEquipment.length > 0 && !selectedEquipment) {
            setSelectedEquipment(towingEquipment[0]);
            setSelectedIndex(0);
        }
    }, [
        towingEquipment,
        newEquipmentId
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            // Don't handle keyboard events when dialog is open
            if (editingEquipment || isCreating) return;
            if (!towingEquipment || towingEquipment.length === 0) return;
            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                e.preventDefault();
                let newIndex = selectedIndex;
                if (newIndex === null) newIndex = 0;
                else if (e.key === "ArrowDown") newIndex = Math.min(newIndex + 1, towingEquipment.length - 1);
                else newIndex = Math.max(newIndex - 1, 0);
                setSelectedIndex(newIndex);
                setSelectedEquipment(towingEquipment[newIndex]);
                // Scroll into view
                if (tableRef.current) {
                    const row = tableRef.current.querySelector(`tbody tr:nth-child(${newIndex + 1})`);
                    row?.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                    });
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        towingEquipment,
        selectedIndex,
        editingEquipment,
        isCreating
    ]);
    const handleSelectEquipment = (equipment, index)=>{
        setSelectedEquipment(equipment);
        setSelectedIndex(index);
    };
    const handleEditClick = (equipment, event)=>{
        event.stopPropagation();
        setEditingEquipment(equipment);
        setIsCreating(false);
    };
    const handleAddClick = ()=>{
        setEditingEquipment(null);
        setIsCreating(true);
    };
    const handleDeleteClick = async (equipment, event)=>{
        event.stopPropagation();
        if (window.confirm(`Are you sure you want to delete "${equipment.name}"?`)) try {
            await deleteTowingEquipment(equipment.id);
            if (selectedEquipment?.id === equipment.id) {
                setSelectedEquipment(null);
                setSelectedIndex(null);
            }
        } catch (err) {
            setComponentError(`Failed to delete equipment: ${err}`);
        }
    };
    // Helper function for dimension validation
    const validateDimension = (value, allowZero = false)=>{
        if (!value) return null;
        const num = parseFloat(value);
        const isValid = !isNaN(num) && (allowZero ? num >= 0 : num > 0) && num <= 1000;
        return isValid ? num : null;
    };
    const handleSaveEdit = async (formData)=>{
        try {
            if (isCreating) {
                // Create new equipment
                const width = validateDimension(formData.width);
                const length = validateDimension(formData.length);
                const height = validateDimension(formData.height);
                const towBarLength = formData.tow_bar_length ? validateDimension(formData.tow_bar_length, true) : null;
                if (!formData.name) {
                    setComponentError("Please provide a name for the equipment.");
                    return;
                }
                if (!width || !length || !height) {
                    setComponentError("Please provide valid values for all dimension fields. Dimensions must be positive numbers up to 1000 feet.");
                    return;
                }
                const newEquipment = await createTowingEquipment({
                    name: formData.name,
                    width: width || 0,
                    length: length || 0,
                    height: height || 0,
                    tow_bar_length: towBarLength,
                    no_footprint: formData.no_footprint
                });
                // Check if creation was successful
                if (!newEquipment) {
                    setComponentError("Failed to create equipment. Please try again.");
                    return;
                }
                // Set the new equipment ID for selection after refresh
                if (typeof newEquipment.id === "string") setNewEquipmentId(newEquipment.id);
                await refreshTowingEquipment();
            } else if (editingEquipment) {
                // Update existing equipment
                const width = formData.width ? validateDimension(formData.width) : null;
                const length = formData.length ? validateDimension(formData.length) : null;
                const height = formData.height ? validateDimension(formData.height) : null;
                const towBarLength = formData.tow_bar_length ? validateDimension(formData.tow_bar_length, true) : undefined;
                // Check if any provided dimensions are invalid
                if (formData.width && !width) {
                    setComponentError("Width must be a positive number up to 1000 feet.");
                    return;
                }
                if (formData.length && !length) {
                    setComponentError("Length must be a positive number up to 1000 feet.");
                    return;
                }
                if (formData.height && !height) {
                    setComponentError("Height must be a positive number up to 1000 feet.");
                    return;
                }
                const updatedEquipment = {
                    ...editingEquipment,
                    name: formData.name || editingEquipment.name,
                    width: width ?? editingEquipment.width,
                    length: length ?? editingEquipment.length,
                    height: height ?? editingEquipment.height,
                    tow_bar_length: towBarLength !== undefined ? towBarLength : editingEquipment.tow_bar_length,
                    no_footprint: formData.no_footprint
                };
                await updateTowingEquipment(updatedEquipment);
                // Update selected equipment if it was edited
                const updated = towingEquipment.find((e)=>e.id === editingEquipment.id);
                if (updated && selectedEquipment?.id === editingEquipment.id) setSelectedEquipment(updated);
            }
            setEditingEquipment(null);
            setIsCreating(false);
            setComponentError(null);
        } catch (err) {
            setComponentError(`Failed to save equipment: ${err}`);
        }
    };
    // Helper to prepare equipment data for export
    const prepareEquipmentExportData = ()=>{
        const headers = [
            "Name",
            "Width",
            "Length",
            "Height",
            "Tow Bar Length",
            "ID"
        ];
        const rows = towingEquipment.map((e)=>[
                e.name || "",
                e.width?.toFixed(1) || "",
                e.length?.toFixed(1) || "",
                e.height?.toFixed(1) || "",
                e.tow_bar_length?.toFixed(1) || "",
                e.id
            ]);
        return {
            headers: headers,
            rows: rows
        };
    };
    // Helper to download file
    const downloadFile = (content, filename, mimeType)=>{
        const blob = new Blob([
            content
        ], {
            type: mimeType
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const handleExportCSV = ()=>{
        const { headers: headers, rows: rows } = prepareEquipmentExportData();
        // Convert to TSV format
        const tsvContent = [
            headers.join("\t"),
            ...rows.map((row)=>row.join("\t"))
        ].join("\n");
        const filename = `towing_equipment_${new Date().toISOString().split("T")[0]}.tsv`;
        downloadFile(tsvContent, filename, "text/tab-separated-values;charset=utf-8;");
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            children: "Loading towing equipment..."
        })
    });
    if (error && !loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
            severity: "error",
            onClose: ()=>setComponentError(null),
            children: error
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        ref: containerRef,
        tabIndex: 0,
        sx: {
            p: 2,
            height: "calc(100vh - 120px)",
            display: "flex",
            flexDirection: "column",
            outline: "none"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                spacing: 3,
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7tqxO))), {}),
                                    onClick: handleAddClick,
                                    color: "primary",
                                    children: "Add Equipment"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: "contained",
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fruN))), {}),
                                    onClick: handleExportCSV,
                                    disabled: towingEquipment.length === 0,
                                    color: "primary",
                                    children: "Export Equipment List"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: !isProduction ? "Deploy is only available on production (app.airplx.com)" : "",
                                    arrow: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            onClick: ()=>setConfirmDeploy(true),
                                            variant: "contained",
                                            color: "primary",
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h23xD))), {}),
                                            disabled: !isProduction,
                                            children: "Deploy"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                        sx: {
                            flex: 1,
                            minHeight: 0,
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4db381867263501b$export$a7c288a0285b6042), {
                            equipment: towingEquipment,
                            selectedEquipment: selectedEquipment,
                            onSelectEquipment: handleSelectEquipment,
                            onEditClick: handleEditClick,
                            onDeleteClick: handleDeleteClick,
                            tableRef: tableRef
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95d240f09353b5ca$export$6d80b19cdd25c931), {
                open: !!editingEquipment || isCreating,
                equipment: editingEquipment,
                isCreating: isCreating,
                onClose: ()=>{
                    setEditingEquipment(null);
                    setIsCreating(false);
                },
                onSave: handleSaveEdit
            }),
            confirmDeploy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: "Confirm deploy",
                text: "Are you sure you want to deploy towing equipment updates?",
                onCancel: ()=>setConfirmDeploy(false),
                onClose: ()=>setConfirmDeploy(false),
                onOk: async ()=>{
                    await fetch(`${webURL}/jobs/update-towing-equipment`);
                    setConfirmDeploy(false);
                },
                okText: "Go baby go!"
            })
        ]
    });
};


const $645ea21c5284e70d$export$27f9d797b6f3e617 = ()=>{
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    // Get initial tab from URL, default to "authorized-accounts"
    const [activeTab, setActiveTab] = $acw62.useState(searchParams.get("tab") || "authorized-accounts");
    // Update URL when tab changes
    const handleTabChange = (event, newValue)=>{
        setActiveTab(newValue);
        setSearchParams({
            tab: newValue
        }, {
            replace: true
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                value: activeTab,
                onChange: handleTabChange,
                variant: "scrollable",
                scrollButtons: "auto",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "authorized-accounts",
                        label: "Authorized Accounts"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "fbos",
                        label: "FBOs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "users",
                        label: "Users"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "faa-mapping",
                        label: "FAA Mapping"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "announcements",
                        label: "Announcements"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "activity",
                        label: "Activity"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "movable-obstacles",
                        label: "Movable Obstacles"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "towing-equipment",
                        label: "Towing Equipment"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "aircraft",
                        label: "Aircraft"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "labeling",
                        label: "Labeling"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "convert-svgs",
                        label: "Convert SVGs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        value: "system-status",
                        label: "System Status"
                    })
                ]
            }),
            activeTab === "authorized-accounts" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bfdb14bee91b161$export$f17f1ad215aeafd0), {}),
            activeTab === "fbos" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef1fcc004f67cf01$export$be2b17db69ae28a0), {}),
            activeTab === "users" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d26d3e61cd4a876$export$dee3e08bb2289aea), {}),
            activeTab === "faa-mapping" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $70af75c933722976$export$c2d31d5d5b22613a), {}),
            activeTab === "announcements" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c49efcbeaf14fdff$export$e0c30b5422904bf8), {}),
            activeTab === "activity" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b80781a1032cdd95$export$9c16c1426311996d), {}),
            activeTab === "movable-obstacles" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71827cade1dc8e6f$export$a4d0709e003e4f7e), {}),
            activeTab === "towing-equipment" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20ad2ea09c0e6252$export$8f2b8082d10087ae), {}),
            activeTab === "aircraft" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e367a6eed987259$export$8f4262e2cbb7dc96), {}),
            activeTab === "labeling" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6efbb3e7879ab111$export$2ecffa85439d004b), {}),
            activeTab === "convert-svgs" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7YqU.ConvertSVG), {}),
            activeTab === "system-status" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $916ab46e0adccdf5$export$9c2acc1ae06565bb), {})
        ]
    });
};







var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2LXej = parcelRequire("2LXej");

var $7FzhI = parcelRequire("7FzhI");

var $6rxM8 = parcelRequire("6rxM8");

var $3AGzj = parcelRequire("3AGzj");

var $9OZOC = parcelRequire("9OZOC");

var $ayMG0 = parcelRequire("ayMG0");

var $jO6ya = parcelRequire("jO6ya");

var $1MdOk = parcelRequire("1MdOk");

var $2P5BT = parcelRequire("2P5BT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $7FzhI = parcelRequire("7FzhI");

var $6rxM8 = parcelRequire("6rxM8");

var $3AGzj = parcelRequire("3AGzj");

var $kWYrU = parcelRequire("kWYrU");

var $aHqXU = parcelRequire("aHqXU");

var $5kwJN = parcelRequire("5kwJN");
parcelRequire("5nfKz");
var $f4Dj1 = parcelRequire("f4Dj1");
parcelRequire("7o8I0");
var $3XtNi = parcelRequire("3XtNi");

var $8ORjT = parcelRequire("8ORjT");

var $4jd4A = parcelRequire("4jd4A");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $hViLc = parcelRequire("hViLc");
var $2iAqv = parcelRequire("2iAqv");
var $30UGG = parcelRequire("30UGG");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $j3VXW = parcelRequire("j3VXW");
const $e8720665dd27b217$export$1f7c4e342f05ba6d = ({ filter: filter = "", tenants: tenants, setTenant: setTenant, setFilter: setFilter, deleteTenant: deleteTenant, editTenantId: editTenantId, setEditTenantId: setEditTenantId })=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { hasPermission: hasPermission } = (0, $kWYrU.usePermissions)();
    const { ramps: ramps } = (0, $3AGzj.useRampsState)();
    const { hangars: hangars } = (0, $7FzhI.useHangarsState)();
    const { sendToLocation: sendToLocation, locationOverides: locationOverides, findTenantLocation: findTenantLocation } = (0, $6rxM8.useLocationsState)();
    const [tenantToDelete, setTenantToDelete] = $acw62.useState();
    const [limitToAssignedLocationId, setLimitToAssignedLocationId] = $acw62.useState("");
    const [limitToCurrentLocationId, setLimitToCurrentLocationId] = $acw62.useState("");
    const viewOnly = !hasPermission((0, $aHqXU.Permission).MODIFY_TENANTS);
    const tenantsToDisplay = $acw62.useMemo(()=>{
        return tenants.filter((t)=>{
            if (!Boolean(filter) && !Boolean(limitToAssignedLocationId) && !Boolean(limitToCurrentLocationId)) return true;
            const currentLocation = findTenantLocation(false, t);
            const referenceLocation = findTenantLocation(true, t);
            const currentLocationName = currentLocation?.name ?? "";
            const referenceLocationName = referenceLocation?.name ?? "";
            const queryString = `${t.type} - ${t.tail_number} - ${t.owner_manager} - ${t.aircraft.make} - ${t.aircraft.model} - ${t.note} - ${currentLocationName} - ${referenceLocationName}`.toLocaleLowerCase();
            const matchesQuerystring = Boolean(filter) ? queryString.indexOf(filter.toLocaleLowerCase()) > -1 : true;
            if (limitToAssignedLocationId) {
                if (limitToAssignedLocationId === "ALL" && t.type === "base") return matchesQuerystring;
                if (limitToAssignedLocationId === "Unassigned" && !referenceLocation && t.type === "base") return matchesQuerystring;
                if (referenceLocation?.location_id === limitToAssignedLocationId) return matchesQuerystring;
                return false;
            }
            if (limitToCurrentLocationId) {
                if (limitToCurrentLocationId === "ALL") return matchesQuerystring;
                if (currentLocation?.location_id === limitToCurrentLocationId) return matchesQuerystring;
                return false;
            }
            return matchesQuerystring;
        });
    }, [
        tenants,
        filter,
        limitToAssignedLocationId,
        limitToCurrentLocationId,
        locationOverides
    ]);
    const additionalColumns = [
        {
            field: "last_hangared",
            headerName: "Last Hangared",
            width: 175,
            editable: false,
            renderCell: (params)=>{
                return (0, $5kwJN.lastHangaredText)(params.value, Boolean(findTenantLocation(false, params.row)));
            }
        },
        {
            field: "note",
            headerName: "Note",
            width: 150,
            editable: false,
            renderCell: (params)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: params.row.note,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "inherit",
                        noWrap: true,
                        children: params.row.note
                    })
                });
            }
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 250,
            renderCell: (params)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j3VXW.ButtonNotes), {
                            disabled: viewOnly,
                            variant: "contained",
                            tenant: tenants.find((t)=>t.id === params.row.id),
                            setTenant: (tenant)=>{
                                setTenant(tenant);
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            disabled: viewOnly,
                            size: "small",
                            variant: "contained",
                            color: "inherit",
                            onClick: ()=>setEditTenantId(params.row.id),
                            children: "Edit"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            disabled: viewOnly,
                            "data-testid": "delete",
                            onClick: ()=>setTenantToDelete(params.row),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1MdOk))), {})
                        })
                    ]
                });
            }
        }
    ];
    const selectedTenant = tenants.find((tenant)=>tenant.id === editTenantId);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: {
            p: 1,
            ml: 2,
            mr: 2,
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                direction: "column",
                spacing: 2,
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "h6",
                                children: [
                                    "Transient & Tenant Aircraft \u2013 ",
                                    activeFBO?.name
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ORjT.AddTenantButton), {
                                    location: null,
                                    sendToLocation: sendToLocation,
                                    onAdd: (tenant)=>{
                                        if (Array.isArray(tenant)) // Bulk add: add all tenants individually
                                        tenant.forEach((t)=>setTenant(t));
                                        else // Single add
                                        setTenant(tenant);
                                    },
                                    stack: null,
                                    setStack: ()=>null,
                                    hideAddMovableObstacle: true,
                                    bulk: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                fullWidth: true,
                                placeholder: "Search by Tail #, Owner, or Model",
                                InputProps: {
                                    startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                        position: "start",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2P5BT))), {})
                                    })
                                },
                                onChange: (evt)=>setFilter(evt.target.value),
                                inputProps: {
                                    testid: "search"
                                },
                                value: filter
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                direction: "row",
                                spacing: 1,
                                justifyContent: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iAtns.default), {
                                                select: true,
                                                fullWidth: true,
                                                label: "Show Tenants",
                                                value: limitToAssignedLocationId,
                                                onChange: (evt)=>{
                                                    setLimitToCurrentLocationId("");
                                                    setLimitToAssignedLocationId(evt.target.value);
                                                },
                                                sx: {
                                                    minWidth: 240
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "ALL",
                                                        children: "Show All Tenants"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: "Unassigned",
                                                        children: "Show Unassigned"
                                                    }),
                                                    [
                                                        ...hangars,
                                                        ...ramps
                                                    ].map((location)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                                                            value: location.location_id,
                                                            children: [
                                                                "Assigned to ",
                                                                location.name
                                                            ]
                                                        }, `location-tenant-menu-${location.location_id}`))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                onClick: ()=>setLimitToAssignedLocationId(""),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jO6ya))), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                        direction: "row",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                select: true,
                                                fullWidth: true,
                                                label: "Show by Current Location",
                                                value: limitToCurrentLocationId,
                                                onChange: (evt)=>{
                                                    setLimitToAssignedLocationId("");
                                                    setLimitToCurrentLocationId(evt.target.value);
                                                },
                                                sx: {
                                                    minWidth: 240
                                                },
                                                children: [
                                                    ...hangars,
                                                    ...ramps
                                                ].map((location)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                        value: location.location_id,
                                                        children: location.name
                                                    }, `location-transient-menu-${location.location_id}`))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                onClick: ()=>setLimitToCurrentLocationId(""),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jO6ya))), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4jd4A.TenantGrid), {
                        tenants: tenantsToDisplay,
                        additionalColumns: additionalColumns
                    })
                ]
            }),
            Boolean(editTenantId) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3XtNi.EditTenant), {
                displayTypeAndLocation: true,
                stack: null,
                setStack: null,
                tenant: selectedTenant,
                setTenant: setTenant,
                onClose: ()=>setEditTenantId(null)
            }),
            Boolean(tenantToDelete) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4Dj1.ConfirmationDialog), {
                title: `Are you sure you want to delete ${tenantToDelete.tail_number || tenantToDelete.aircraft.model}?`,
                text: "This aircraft will be permanently deleted.",
                okText: "Yes",
                onCancel: ()=>{
                    setTenantToDelete(null);
                },
                onOk: ()=>{
                    deleteTenant(tenantToDelete);
                    setTenantToDelete(null);
                },
                onClose: ()=>{
                    setTenantToDelete(null);
                }
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $5RIww = parcelRequire("5RIww");
var $30UGG = parcelRequire("30UGG");
parcelRequire("acw62");
const $596d0d1de233b82e$export$3cbffdec9db04f7b = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
        sx: {
            p: 1,
            ml: 2,
            mr: 2,
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            direction: "column",
            spacing: 2,
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    sx: {
                        mt: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            variant: "text",
                            width: 400,
                            height: 40
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            variant: "rounded",
                            width: 150,
                            height: 40
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "row",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            variant: "rectangular",
                            width: "100%",
                            height: 56,
                            sx: {
                                borderRadius: 1
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 1,
                            justifyContent: "flex-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            variant: "rectangular",
                                            width: 240,
                                            height: 56,
                                            sx: {
                                                borderRadius: 1
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            variant: "circular",
                                            width: 40,
                                            height: 40
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            variant: "rectangular",
                                            width: 240,
                                            height: 56,
                                            sx: {
                                                borderRadius: 1
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                            variant: "circular",
                                            width: 40,
                                            height: 40
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                    variant: "rectangular",
                    height: "calc(100vh - 200px)",
                    width: "100%",
                    sx: {
                        minHeight: 400,
                        animation: "pulse 1.5s ease-in-out 0.5s infinite",
                        borderRadius: 1
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        display: "none"
                    },
                    children: [
                        ...Array(5)
                    ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                            direction: "row",
                            spacing: 2,
                            sx: {
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 120,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 150,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 180,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 120,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 150,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 175,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "text",
                                    width: 250,
                                    height: 30
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};


// Inner component that uses the state hooks after providers are rendered
const $8a0726b0ba977db9$var$TenantsContent = ({ filter: filter, setFilter: setFilter, editTenantId: editTenantId, setEditTenantId: setEditTenantId })=>{
    const { postgrest: postgrest } = (0, $2LXej.useApi)();
    const { tenants: tenants, setTenant: setTenant, setTenants: setTenants, ready: tenantsReady } = (0, $9OZOC.useTenants)();
    // Now we can safely use these hooks because their providers are already rendered
    const { ready: hangarsReady } = (0, $7FzhI.useHangarsState)();
    const { ready: rampsReady } = (0, $3AGzj.useRampsState)();
    // All data is ready when hangars, ramps, and tenants are all loaded
    const allDataReady = hangarsReady && rampsReady && tenantsReady;
    const deleteTenant = $acw62.useCallback(async (tenant)=>{
        await postgrest.from("tenant").delete().eq("entity_id", tenant.entity_id);
        setTenants(tenants.filter((t)=>t.entity_id !== tenant.entity_id));
    }, [
        tenants
    ]);
    // Show skeleton while data is loading
    if (!allDataReady) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $596d0d1de233b82e$export$3cbffdec9db04f7b), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8720665dd27b217$export$1f7c4e342f05ba6d), {
        filter: filter,
        tenants: tenants,
        setTenant: setTenant,
        deleteTenant: deleteTenant,
        setFilter: setFilter,
        editTenantId: editTenantId,
        setEditTenantId: setEditTenantId
    });
};
const $8a0726b0ba977db9$export$3f4dd2b277bee89f = ()=>{
    const [filter, setFilter] = $acw62.useState("");
    const [editTenantId, setEditTenantId] = $acw62.useState("");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3AGzj.RampsStateContainer), {
        isReference: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7FzhI.HangarsStateContainer), {
            isReference: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6rxM8.LocationsContainer), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($8a0726b0ba977db9$var$TenantsContent, {
                    filter: filter,
                    setFilter: setFilter,
                    editTenantId: editTenantId,
                    setEditTenantId: setEditTenantId
                })
            })
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $30UGG = parcelRequire("30UGG");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $gqehT = parcelRequire("gqehT");

var $3kyM0 = parcelRequire("3kyM0");


var $l5ED9 = parcelRequire("l5ED9");
parcelRequire("7pCBl");
var $6G9QQ = parcelRequire("6G9QQ");
const $6a19464f21456889$var$logo = "/airplx-logo-transparent-square-no-text.png";
const $6a19464f21456889$export$3d3197b723615cc = ()=>{
    const { code: code } = (0, $aphAM.useParams)();
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const { url: tokenMakerURL } = (0, $3kyM0.useTokenMaker)();
    const [loading, setLoading] = $acw62.useState(Boolean(code));
    const [error, setError] = $acw62.useState("");
    const [email] = $acw62.useState(location.state?.email || "");
    const [resending, setResending] = $acw62.useState(false);
    const postgrest = $acw62.useMemo(()=>{
        return (0, $l5ED9.createUnauthenticatedPostgrest)();
    }, []);
    // Auto-verify if code is in URL
    $acw62.useEffect(()=>{
        if (code) handleVerify(code);
    }, [
        code
    ]);
    const handleVerify = async (verificationCode)=>{
        setLoading(true);
        setError("");
        try {
            const { data: token } = await postgrest.rpc("verify_email_with_code", {
                p_code: verificationCode
            });
            if (!token) {
                setError("Invalid or expired verification link. Please request a new one.");
                setLoading(false);
                return;
            }
            // Store token (auto-login)
            localStorage.setItem((0, $gqehT.AIRPLX_TOKEN), token);
            // Redirect to the stored URL or default to home page
            // Set hash then force reload (browser optimizes same-origin hash changes without reload)
            const redirectUrl = (0, $2a8b7cbac056e639$export$93832c3affb240d3)("/");
            window.location.href = `/#${redirectUrl}`;
            window.location.reload();
        } catch (err) {
            setError(err.message || "An error occurred. Please try again.");
            console.error("Error verifying email:", err);
            setLoading(false);
        }
    };
    const handleResend = async ()=>{
        if (!email) {
            setError("No email address available. Please sign up again.");
            return;
        }
        setResending(true);
        setError("");
        try {
            await fetch(`${tokenMakerURL}/send-verification-email`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email
                })
            });
            // Show success message (could add a success state)
            setError(""); // Clear any previous errors
        } catch (err) {
            setError("Failed to resend verification email. Please try again.");
            console.error("Error resending verification:", err);
        } finally{
            setResending(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6G9QQ.Loading), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "60vh",
                width: "100vw",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30UGG.default), {
                    direction: "column",
                    width: 450,
                    spacing: 3,
                    children: error ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        children: "Verification Failed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "body1",
                                        color: "error",
                                        align: "center",
                                        children: error
                                    })
                                ]
                            }),
                            email && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                onClick: handleResend,
                                disabled: resending,
                                fullWidth: true,
                                sx: {
                                    borderRadius: 1
                                },
                                children: resending ? "Sending..." : "Resend Verification Email"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "outlined",
                                onClick: ()=>navigate("/login"),
                                children: "Back to login"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        children: "Check Your Email"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        variant: "body1",
                                        color: "text.secondary",
                                        align: "center",
                                        children: [
                                            "We sent a verification link to",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body2",
                                color: "text.secondary",
                                align: "center",
                                children: "Click the link in the email to verify your account and complete signup."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "caption",
                                color: "text.secondary",
                                align: "center",
                                children: "The link will expire in 1 hour"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "outlined",
                                onClick: handleResend,
                                disabled: resending,
                                fullWidth: true,
                                children: resending ? "Sending..." : "Resend Verification Email"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                size: "small",
                                onClick: ()=>navigate("/login"),
                                children: "Back to login"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: $6a19464f21456889$var$logo,
                style: {
                    position: "fixed",
                    bottom: 15,
                    right: 15,
                    width: 50
                }
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lNEp2 = parcelRequire("lNEp2");

var $gqehT = parcelRequire("gqehT");
// Track if we're currently sending to prevent recursive calls
let $a4cae99f7938bb3f$var$isSending = false;
// Track failed attempts to avoid spamming logs
let $a4cae99f7938bb3f$var$failedAttempts = 0;
const $a4cae99f7938bb3f$var$MAX_FAILED_ATTEMPTS = 3;
const $a4cae99f7938bb3f$var$sendToBackend = async (level, message, token)=>{
    // Skip sending logs if there's no valid token, we're already sending, or too many failures
    if (!token || $a4cae99f7938bb3f$var$isSending || $a4cae99f7938bb3f$var$failedAttempts >= $a4cae99f7938bb3f$var$MAX_FAILED_ATTEMPTS) return;
    const url = (0, $lNEp2.getTokenMakerUrl)();
    // Create an AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), 5000); // 5 second timeout
    try {
        $a4cae99f7938bb3f$var$isSending = true;
        const response = await fetch(`${url}/logs`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                level: level,
                message: message.map((m)=>{
                    try {
                        return typeof m === "object" ? JSON.stringify(m) : m;
                    } catch  {
                        return "[Circular or unserializable object]";
                    }
                }),
                timestamp: new Date().toISOString()
            }),
            signal: controller.signal
        });
        // Check if the response is ok
        if (!response.ok) {
            $a4cae99f7938bb3f$var$failedAttempts++;
            // Log locally but don't try to send to backend again
            if ($a4cae99f7938bb3f$var$failedAttempts === 1) $a4cae99f7938bb3f$var$originalConsole.warn(`Log backend returned ${response.status}`);
        } else // Reset failed attempts on success
        $a4cae99f7938bb3f$var$failedAttempts = 0;
    } catch (err) {
        $a4cae99f7938bb3f$var$failedAttempts++;
        // Only log the first failure to avoid spam
        if ($a4cae99f7938bb3f$var$failedAttempts === 1) {
            if (err.name === 'AbortError') $a4cae99f7938bb3f$var$originalConsole.warn("Log backend request timed out");
            else $a4cae99f7938bb3f$var$originalConsole.warn("Failed to send log to backend:", err.message || err);
        }
    } finally{
        clearTimeout(timeoutId);
        $a4cae99f7938bb3f$var$isSending = false;
    }
};
// Save a reference to the original console methods
const $a4cae99f7938bb3f$var$originalConsole = {
    ...console
};
const $a4cae99f7938bb3f$export$885e921454ab5512 = (token)=>{
    [
        "log",
        "error",
        "warn",
        "info",
        "debug"
    ].forEach((level)=>{
        console[level] = (...args)=>{
            // 1. Log to the original front-end console
            $a4cae99f7938bb3f$var$originalConsole[level](...args);
            // 2. Send the logs to the backend only if there's a valid token
            // Don't send logs that originate from the logging system itself
            const isLoggingError = args.some((arg)=>typeof arg === 'string' && (arg.includes('Failed to send log to backend') || arg.includes('Log backend returned')));
            if (token && !isLoggingError) $a4cae99f7938bb3f$var$sendToBackend(level, args, token);
        };
    });
};
const $a4cae99f7938bb3f$export$c20e622dc3e14cea = ({ children: children })=>{
    const { airplxToken: airplxToken } = (0, $gqehT.useIdentity)();
    (0, $acw62.useEffect)(()=>{
        $a4cae99f7938bb3f$export$885e921454ab5512(airplxToken);
    }, [
        airplxToken
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $1lfQl = parcelRequire("1lfQl");
parcelRequire("acw62");

var $89b86 = parcelRequire("89b86");
const $8242b7e40a572aac$export$db6450169f27f69d = ({})=>{
    const { show: show } = (0, $89b86.useLoadingProgress)();
    if (!show) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1lfQl.default), {
        color: "success",
        sx: {
            position: "fixed",
            bottom: 0,
            height: 20,
            width: "100vw",
            zIndex: 99999
        }
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $03mUs = parcelRequire("03mUs");
var $30UGG = parcelRequire("30UGG");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $gqehT = parcelRequire("gqehT");

var $lNEp2 = parcelRequire("lNEp2");

var $btULL = parcelRequire("btULL");
const $0368638632abb792$export$39140c7d8b0ba7b3 = ({ children: children })=>{
    const { isLoggedIn: isLoggedIn, airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const [open, setOpen] = $acw62.useState(false);
    const navigate = (0, $aphAM.useNavigate)();
    const location = (0, $aphAM.useLocation)();
    const isMultiHangar = location.pathname.includes("/multi-hangar/");
    const isTVMode = location.pathname.includes("/tv"); // Detect TV mode
    const handleClickRoute = (pathname)=>{
        navigate(pathname);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
        direction: "row",
        display: "flex",
        height: "100%",
        sx: {
            overflow: "hidden"
        },
        children: [
            !isTVMode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    height: "100%",
                    maxWidth: "100%"
                },
                children: isLoggedIn ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $btULL.SideDrawer), {
                    open: open,
                    setOpen: setOpen,
                    onClickRoute: handleClickRoute,
                    showAdmin: airplxIdentity?.isadmin || false
                }) : null
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                component: "main",
                sx: {
                    height: "100%",
                    width: "100%",
                    overflow: isMultiHangar ? "scroll" : "auto",
                    ...isMultiHangar ? (0, $lNEp2.scrollSx) : {}
                },
                children: children
            })
        ]
    });
};




/**
 * Role Testing Floating Action Button (FAB)
 *
 * Appears when admin role testing is active. Provides quick access to switch roles.
 * Uses standard MUI components and theme colors.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
var $72fe16ee15ba6af3$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $72fe16ee15ba6af3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($72fe16ee15ba6af3$exports, "__esModule", {
    value: true
});
$72fe16ee15ba6af3$exports.default = void 0;

var $72fe16ee15ba6af3$var$_createSvgIcon = $72fe16ee15ba6af3$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $72fe16ee15ba6af3$var$_default = $72fe16ee15ba6af3$exports.default = (0, $72fe16ee15ba6af3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2M9 12c.83 0 1.5.67 1.5 1.5S9.83 15 9 15s-1.5-.67-1.5-1.5S8.17 12 9 12m3 6H6v-.75c0-1 2-1.5 3-1.5s3 .5 3 1.5zm1-9h-2V4h2zm5 7.5h-4V15h4zm0-3h-4V12h4z"
}), 'Badge');



var $dqlTG = parcelRequire("dqlTG");

var $6lXkL = parcelRequire("6lXkL");
var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a206933548dacbdf$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $4Cod0.default)('MuiFab', slot);
}
const $a206933548dacbdf$var$fabClasses = (0, $beCSm.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $a206933548dacbdf$export$2e2bcd8739ae039 = $a206933548dacbdf$var$fabClasses;



var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2426d7556721cbb6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $jTnBY.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $a206933548dacbdf$export$e2cfa0ca4bce1fc2), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $2426d7556721cbb6$var$FabRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $jTnBY.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $a206933548dacbdf$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $aeD7H.default)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $aeD7H.default)(({ theme: theme })=>({
        [`&.${(0, $a206933548dacbdf$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $2426d7556721cbb6$var$Fab = /*#__PURE__*/ $acw62.forwardRef(function Fab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $2426d7556721cbb6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2426d7556721cbb6$var$FabRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: classes,
        children: children
    });
});
var $2426d7556721cbb6$export$2e2bcd8739ae039 = $2426d7556721cbb6$var$Fab;


var $gd5y7 = parcelRequire("gd5y7");
var $OEVqP = parcelRequire("OEVqP");
var $2iAqv = parcelRequire("2iAqv");
var $7Frhn = parcelRequire("7Frhn");
var $cX7V2 = parcelRequire("cX7V2");
var $30UGG = parcelRequire("30UGG");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $acw62 = parcelRequire("acw62");

var $ZD2ym = parcelRequire("ZD2ym");

var $bfCc1 = parcelRequire("bfCc1");

var $aHqXU = parcelRequire("aHqXU");
const $af421bff7d3da11a$export$ed20f4cab46f9716 = ()=>{
    const { activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    const { isActive: isActive, overriddenRole: overriddenRole, startRoleOverride: startRoleOverride, stopRoleOverride: stopRoleOverride } = (0, $bfCc1.useRoleOverride)();
    const [expanded, setExpanded] = $acw62.useState(false);
    const [selectedRole, setSelectedRole] = $acw62.useState(overriddenRole);
    // Sync selectedRole with store
    $acw62.useEffect(()=>{
        if (overriddenRole) setSelectedRole(overriddenRole);
    }, [
        overriddenRole
    ]);
    // Don't render if override is not active
    if (!isActive) return null;
    const handleRoleChange = (newRole)=>{
        setSelectedRole(newRole);
        if (activeFBO?.id) startRoleOverride(newRole, activeFBO.id);
    };
    const handleExit = ()=>{
        stopRoleOverride();
        setExpanded(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            expanded && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                elevation: 8,
                sx: {
                    position: "fixed",
                    bottom: (theme)=>theme.spacing(10),
                    right: (theme)=>theme.spacing(2),
                    p: 2,
                    zIndex: 1300,
                    minWidth: 280
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                    direction: "column",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: "subtitle1",
                            fontWeight: "bold",
                            children: "Role Testing"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                            fullWidth: true,
                            size: "small",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                                    children: "Testing as"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cX7V2.default), {
                                    value: selectedRole,
                                    onChange: (e)=>handleRoleChange(e.target.value),
                                    label: "Testing as",
                                    children: (0, $aHqXU.ROLE_OPTIONS).map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                            value: option.value,
                                            children: option.label
                                        }, option.value))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            variant: "contained",
                            color: "secondary",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {}),
                            onClick: handleExit,
                            fullWidth: true,
                            children: "Exit Role Testing"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: expanded ? "Close" : `Testing as ${(0, $aHqXU.formatRoleName)(overriddenRole)} - Click to change`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2426d7556721cbb6$export$2e2bcd8739ae039), {
                    color: "secondary",
                    onClick: ()=>setExpanded(!expanded),
                    sx: {
                        position: "fixed",
                        bottom: (theme)=>theme.spacing(2),
                        right: (theme)=>theme.spacing(2)
                    },
                    children: expanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($72fe16ee15ba6af3$exports))), {})
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $iwiZ3 = parcelRequire("iwiZ3");

var $acw62 = parcelRequire("acw62");

var $6fDLr = parcelRequire("6fDLr");
const $1a0272eda2ccbc54$export$9689b5d1b3e00abd = ()=>{
    const { notifications: notifications, setNotifications: setNotifications } = (0, $6fDLr.useSnackbar)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: notifications.map(({ id: id, open: open, text: text, severity: severity, duration: duration = 3000 })=>/*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                    open: open,
                    autoHideDuration: duration,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "center"
                    },
                    onClose: ()=>setNotifications(notifications.filter((n)=>n.id !== id)),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                        onClose: ()=>setNotifications(notifications.filter((n)=>n.id !== id)),
                        severity: severity,
                        sx: {
                            width: "100%"
                        },
                        children: text
                    })
                })
            }, `snackbar-${id}`))
    });
};





// Lazy load heavy screens to reduce initial bundle size
const $c5b6574cf2a8f4d0$var$Settings = /*#__PURE__*/ $acw62.lazy(()=>(parcelRequire("2xNsq")).then((module)=>({
            default: module.Settings
        })));

// Lazy load OpsCenter to defer Leaflet library (3.8 MB)
const $c5b6574cf2a8f4d0$var$OpsCenter = /*#__PURE__*/ $acw62.lazy(()=>(parcelRequire("g7iKU")).then((module)=>({
            default: module.OpsCenter
        })));

const $c5b6574cf2a8f4d0$var$OpsCenterTV = /*#__PURE__*/ $acw62.lazy(()=>(parcelRequire("jqPLh")).then((module)=>({
            default: module.OpsCenterTV
        })));

// Lazy load ConvertSVG utility screen
const $c5b6574cf2a8f4d0$var$ConvertSVG = /*#__PURE__*/ $acw62.lazy(()=>Promise.resolve((parcelRequire("lJX3N"))).then((module)=>({
            default: module.ConvertSVG
        })));
const $c5b6574cf2a8f4d0$var$TRACKING_ID = "G-80LQDPGBHS";
$748332cc4d70356f$export$2a47f398eeff8b01($c5b6574cf2a8f4d0$var$TRACKING_ID);
const $c5b6574cf2a8f4d0$var$ProtectedRoute = ({ mustBelongtoFBO: mustBelongtoFBO = false, isAdmin: isAdmin = false, requiresScheduling: requiresScheduling = false })=>{
    const { isLoggedIn: isLoggedIn, airplxIdentity: airplxIdentity } = (0, $gqehT.useIdentity)();
    const { ready: ready, activeFBO: activeFBO } = (0, $ZD2ym.useActiveFBOs)();
    if (!isLoggedIn) {
        // Store where the user was trying to go before redirecting to login
        (0, $2a8b7cbac056e639$export$7d08b3bdc73d1dd3)(window.location.hash);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
            to: "/login",
            replace: true,
            state: {
                from: window.location.hash
            }
        });
    }
    if (mustBelongtoFBO) {
        // async so need to wait until it's pulled data
        if (!ready) return null;
        if (!activeFBO) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $989bebeace70f0e5$export$4b37b77b314e9ac4), {});
    }
    if (isAdmin && !airplxIdentity?.isadmin) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/",
        replace: true
    });
    if (requiresScheduling && !activeFBO?.settings?.enableScheduling) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/hangars",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {});
};
const $c5b6574cf2a8f4d0$export$d653589df987fd93 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ckAs.FeatureFlagsContainer), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4o1tI.EventContainerProvider), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6fDLr.SnackbarContainer), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89b86.LoadingProgressContainer), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gqehT.IdentityContainer), {
                        ...props,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2LXej.ApiContainer), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4cae99f7938bb3f$export$c20e622dc3e14cea), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $js9Xf.SchemaContainer), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fC0pb.UserPreferencesContainer), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g5N8Q.ThemeContainer), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ZD2ym.ActiveFBOContainer), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed5cb7861d4e005d$export$ff2f3c5abb77cb90), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f13dd908c366a257$export$c89dc6aba6e9473c), {
                                                        enabled: true,
                                                        children: children
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
const $c5b6574cf2a8f4d0$export$861edd1ccea2f746 = ({ ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$export$d653589df987fd93, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$export$86fbec116b87613f, {
            ...props
        })
    });
};
const $c5b6574cf2a8f4d0$export$86fbec116b87613f = ({})=>{
    if (Boolean((0, $4ckAs.useFeatureFlags)().isMaintenance)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90fefde97640a06d$export$9d2f79ff058e7ac4), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cc8a8b916a220b3$export$f1e582dddb502dd6), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.HashRouter), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0368638632abb792$export$39140c7d8b0ba7b3), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/login",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $600f7fa9fdef2746$export$21a94553ffa41578), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/signup",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6414e3914b3f0c$export$89200835fb4edfb9), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/verify-email",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a19464f21456889$export$3d3197b723615cc), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/verify-email/:code",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a19464f21456889$export$3d3197b723615cc), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/login/magic-link",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $600f7fa9fdef2746$export$21a94553ffa41578), {
                                    magicLink: true
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/login/link",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e8c12e4e30b0f18$export$5c788018c6392017), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/login/link/:code",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b098f644182b1a7e$export$ad9ddc5bf7a9f508), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/forgot-password",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ee939fb44325409$export$b597ee422a3143dc), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/reset-password/:code",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85658fb2dfdaeb3d$export$a4c3d56613a57187), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$var$ProtectedRoute, {}),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "/claim-invite/:inviteId",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $989bebeace70f0e5$export$4b37b77b314e9ac4), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$var$ProtectedRoute, {
                                    mustBelongtoFBO: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                            to: "/hangars",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/hangars",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ca8206f04a5e3c6$export$b2d30dec8cfd42d6), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/hangars/:id",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TSbO.Hangar), {}, "current")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/multi-hangar/:ids",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $662710c37101de9c$export$36344c50020c7a7e), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/reference-hangars/:id",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TSbO.Hangar), {
                                            isReference: true
                                        }, "reference")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/algorithm-evaluation/:id",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cad12db4323dccc$export$b65f3ee0bce9c66c), {
                                            isReference: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/tenants",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a0726b0ba977db9$export$3f4dd2b277bee89f), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/ramps",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2188062c3d068362$export$d085537b834e7da5), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/ramps/:id",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e9bcd04b71bedac$export$d5f885e7bd4f2167), {}, "current")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/ramps/optimization",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc8552e1cb17cbf9$export$94cdc8ffefbad5ab), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/reference-ramps/:id",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e9bcd04b71bedac$export$d5f885e7bd4f2167), {
                                            isReference: true
                                        }, "reference")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/ops-center",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Suspense, {
                                            fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8242b7e40a572aac$export$db6450169f27f69d), {}),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$var$OpsCenter, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/ops-center/tv",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Suspense, {
                                            fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8242b7e40a572aac$export$db6450169f27f69d), {}),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$var$OpsCenterTV, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/fee-calculator",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $971f42d42303f2e4$export$5ad0adb7a28f3807), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/hangar-builder-optimizer",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87d1b6b2efef707a$export$e0fdcf77fb4d441c), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/settings",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Suspense, {
                                            fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8242b7e40a572aac$export$db6450169f27f69d), {}),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$var$Settings, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/settings/ramp/:id/edit",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCpGu.RampEditorWrapper), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/flagged-stacks",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5455f29f5a853f8$export$bdc747a154a2c5d9), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/stackmaster",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02aa5f9760e33e8c$export$ad512fb4726ebbf), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/stackmaster/:id",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02aa5f9760e33e8c$export$ad512fb4726ebbf), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/dev/temporal-parking",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e3106e503f2fba7$export$c2e0aa8ab70bb54c), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/dev-tools",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a803aeca10f61d$export$d4d8c31640dc9976), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$var$ProtectedRoute, {
                                    mustBelongtoFBO: true,
                                    requiresScheduling: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/hangars/:id/schedule",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d34f26ec0edecbf$export$d6bb8b8b30f49857), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/ramps/:id/schedule",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24b92612ec4d9b68$export$f8c4c61fc79c6924), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/schedule",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f38d70b2b37b143$export$5d14f38e6b79c033), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$var$ProtectedRoute, {
                                    isAdmin: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/labeling-tool",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c458e7c8b36cf0e5$export$23fc689adf68113e), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/labeling-tool/:aircraftId",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c458e7c8b36cf0e5$export$23fc689adf68113e), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/convert-svg",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Suspense, {
                                            fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8242b7e40a572aac$export$db6450169f27f69d), {}),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($c5b6574cf2a8f4d0$var$ConvertSVG, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/super-admin",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $645ea21c5284e70d$export$27f9d797b6f3e617), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a0272eda2ccbc54$export$9689b5d1b3e00abd), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8242b7e40a572aac$export$db6450169f27f69d), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af421bff7d3da11a$export$ed20f4cab46f9716), {})
                ]
            })
        })
    });
};


var $70fc9a727fa662ae$var$event;
// Set favicon based on domain
const $70fc9a727fa662ae$var$setFavicon = ()=>{
    const link = document.querySelector("link[rel*='icon']");
    if (link && window.location.hostname === "staging.airplx.com") // Use the staging favicon directly
    link.href = "./favicon-staging.png";
};
// Set favicon on load
$70fc9a727fa662ae$var$setFavicon();
const $70fc9a727fa662ae$var$app = document.getElementById("app");
if ($70fc9a727fa662ae$var$app) {
    const root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($70fc9a727fa662ae$var$app);
    root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $c5b6574cf2a8f4d0$export$861edd1ccea2f746), {}));
}


//# sourceMappingURL=app.711a571e.js.map
